import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type AiTutor = {
  __typename?: 'AITutor';
  activityState?: Maybe<ActivityState>;
  assessment: Array<Assessment>;
  assessmentAggregate?: Maybe<AiTutorAssessmentAssessmentAggregationSelection>;
  assessmentConnection: AiTutorAssessmentConnection;
  chats?: Maybe<Array<Maybe<Chat>>>;
  context?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documents: Array<Document>;
  documentsAggregate?: Maybe<AiTutorDocumentDocumentsAggregationSelection>;
  documentsConnection: AiTutorDocumentsConnection;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  files: Array<File>;
  filesAggregate?: Maybe<AiTutorFileFilesAggregationSelection>;
  filesConnection: AiTutorFilesConnection;
  hasChapterPrerequisites: Array<Chapter>;
  hasChapterPrerequisitesAggregate?: Maybe<AiTutorChapterHasChapterPrerequisitesAggregationSelection>;
  hasChapterPrerequisitesConnection: AiTutorHasChapterPrerequisitesConnection;
  hasChapterSkills: Array<Chapter>;
  hasChapterSkillsAggregate?: Maybe<AiTutorChapterHasChapterSkillsAggregationSelection>;
  hasChapterSkillsConnection: AiTutorHasChapterSkillsConnection;
  hasChatChats: Array<Chat>;
  hasChatChatsAggregate?: Maybe<AiTutorChatHasChatChatsAggregationSelection>;
  hasChatChatsConnection: AiTutorHasChatChatsConnection;
  hasReview?: Maybe<Review>;
  hasReviewAggregate?: Maybe<AiTutorReviewHasReviewAggregationSelection>;
  hasReviewConnection: AiTutorHasReviewConnection;
  hasSubchapterPrerequisites: Array<Subchapter>;
  hasSubchapterPrerequisitesAggregate?: Maybe<AiTutorSubchapterHasSubchapterPrerequisitesAggregationSelection>;
  hasSubchapterPrerequisitesConnection: AiTutorHasSubchapterPrerequisitesConnection;
  hasSubchapterSkills: Array<Subchapter>;
  hasSubchapterSkillsAggregate?: Maybe<AiTutorSubchapterHasSubchapterSkillsAggregationSelection>;
  hasSubchapterSkillsConnection: AiTutorHasSubchapterSkillsConnection;
  id: Scalars['ID']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  mcqQuestions: Array<McqQuestion>;
  mcqQuestionsAggregate?: Maybe<AiTutorMcqQuestionMcqQuestionsAggregationSelection>;
  mcqQuestionsConnection: AiTutorMcqQuestionsConnection;
  moduleHasAiTutors: Array<Module>;
  moduleHasAiTutorsAggregate?: Maybe<AiTutorModuleModuleHasAiTutorsAggregationSelection>;
  moduleHasAiTutorsConnection: AiTutorModuleHasAiTutorsConnection;
  nudgesAboutThis: Array<Nudge>;
  nudgesAboutThisAggregate?: Maybe<AiTutorNudgeNudgesAboutThisAggregationSelection>;
  nudgesAboutThisConnection: AiTutorNudgesAboutThisConnection;
  objectives: Array<Objective>;
  objectivesAggregate?: Maybe<AiTutorObjectiveObjectivesAggregationSelection>;
  objectivesConnection: AiTutorObjectivesConnection;
  questionGenerationStatus?: Maybe<QuestionGenerationStatus>;
  questions: Array<Question>;
  questionsAggregate?: Maybe<AiTutorQuestionQuestionsAggregationSelection>;
  questionsConnection: AiTutorQuestionsConnection;
  reviewForUser?: Maybe<User>;
  reviewForUserAggregate?: Maybe<AiTutorUserReviewForUserAggregationSelection>;
  reviewForUserConnection: AiTutorReviewForUserConnection;
  scheduledDate?: Maybe<Scalars['DateTime']['output']>;
  targetAudience?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  visualization?: Maybe<Visualization>;
  visualizationAggregate?: Maybe<AiTutorVisualizationVisualizationAggregationSelection>;
  visualizationConnection: AiTutorVisualizationConnection;
};


export type AiTutorAssessmentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AssessmentOptions>;
  where?: InputMaybe<AssessmentWhere>;
};


export type AiTutorAssessmentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssessmentWhere>;
};


export type AiTutorAssessmentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AiTutorAssessmentConnectionSort>>;
  where?: InputMaybe<AiTutorAssessmentConnectionWhere>;
};


export type AiTutorDocumentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DocumentOptions>;
  where?: InputMaybe<DocumentWhere>;
};


export type AiTutorDocumentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DocumentWhere>;
};


export type AiTutorDocumentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AiTutorDocumentsConnectionSort>>;
  where?: InputMaybe<AiTutorDocumentsConnectionWhere>;
};


export type AiTutorFilesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FileOptions>;
  where?: InputMaybe<FileWhere>;
};


export type AiTutorFilesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FileWhere>;
};


export type AiTutorFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AiTutorFilesConnectionSort>>;
  where?: InputMaybe<AiTutorFilesConnectionWhere>;
};


export type AiTutorHasChapterPrerequisitesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ChapterOptions>;
  where?: InputMaybe<ChapterWhere>;
};


export type AiTutorHasChapterPrerequisitesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ChapterWhere>;
};


export type AiTutorHasChapterPrerequisitesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AiTutorHasChapterPrerequisitesConnectionSort>>;
  where?: InputMaybe<AiTutorHasChapterPrerequisitesConnectionWhere>;
};


export type AiTutorHasChapterSkillsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ChapterOptions>;
  where?: InputMaybe<ChapterWhere>;
};


export type AiTutorHasChapterSkillsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ChapterWhere>;
};


export type AiTutorHasChapterSkillsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AiTutorHasChapterSkillsConnectionSort>>;
  where?: InputMaybe<AiTutorHasChapterSkillsConnectionWhere>;
};


export type AiTutorHasChatChatsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ChatOptions>;
  where?: InputMaybe<ChatWhere>;
};


export type AiTutorHasChatChatsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ChatWhere>;
};


export type AiTutorHasChatChatsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AiTutorHasChatChatsConnectionSort>>;
  where?: InputMaybe<AiTutorHasChatChatsConnectionWhere>;
};


export type AiTutorHasReviewArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ReviewOptions>;
  where?: InputMaybe<ReviewWhere>;
};


export type AiTutorHasReviewAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ReviewWhere>;
};


export type AiTutorHasReviewConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AiTutorHasReviewConnectionSort>>;
  where?: InputMaybe<AiTutorHasReviewConnectionWhere>;
};


export type AiTutorHasSubchapterPrerequisitesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SubchapterOptions>;
  where?: InputMaybe<SubchapterWhere>;
};


export type AiTutorHasSubchapterPrerequisitesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SubchapterWhere>;
};


export type AiTutorHasSubchapterPrerequisitesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AiTutorHasSubchapterPrerequisitesConnectionSort>>;
  where?: InputMaybe<AiTutorHasSubchapterPrerequisitesConnectionWhere>;
};


export type AiTutorHasSubchapterSkillsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SubchapterOptions>;
  where?: InputMaybe<SubchapterWhere>;
};


export type AiTutorHasSubchapterSkillsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SubchapterWhere>;
};


export type AiTutorHasSubchapterSkillsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AiTutorHasSubchapterSkillsConnectionSort>>;
  where?: InputMaybe<AiTutorHasSubchapterSkillsConnectionWhere>;
};


export type AiTutorMcqQuestionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<McqQuestionOptions>;
  where?: InputMaybe<McqQuestionWhere>;
};


export type AiTutorMcqQuestionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<McqQuestionWhere>;
};


export type AiTutorMcqQuestionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AiTutorMcqQuestionsConnectionSort>>;
  where?: InputMaybe<AiTutorMcqQuestionsConnectionWhere>;
};


export type AiTutorModuleHasAiTutorsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ModuleOptions>;
  where?: InputMaybe<ModuleWhere>;
};


export type AiTutorModuleHasAiTutorsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ModuleWhere>;
};


export type AiTutorModuleHasAiTutorsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AiTutorModuleHasAiTutorsConnectionSort>>;
  where?: InputMaybe<AiTutorModuleHasAiTutorsConnectionWhere>;
};


export type AiTutorNudgesAboutThisArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<NudgeOptions>;
  where?: InputMaybe<NudgeWhere>;
};


export type AiTutorNudgesAboutThisAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NudgeWhere>;
};


export type AiTutorNudgesAboutThisConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AiTutorNudgesAboutThisConnectionSort>>;
  where?: InputMaybe<AiTutorNudgesAboutThisConnectionWhere>;
};


export type AiTutorObjectivesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ObjectiveOptions>;
  where?: InputMaybe<ObjectiveWhere>;
};


export type AiTutorObjectivesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ObjectiveWhere>;
};


export type AiTutorObjectivesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AiTutorObjectivesConnectionSort>>;
  where?: InputMaybe<AiTutorObjectivesConnectionWhere>;
};


export type AiTutorQuestionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QuestionOptions>;
  where?: InputMaybe<QuestionWhere>;
};


export type AiTutorQuestionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QuestionWhere>;
};


export type AiTutorQuestionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AiTutorQuestionsConnectionSort>>;
  where?: InputMaybe<AiTutorQuestionsConnectionWhere>;
};


export type AiTutorReviewForUserArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type AiTutorReviewForUserAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type AiTutorReviewForUserConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AiTutorReviewForUserConnectionSort>>;
  where?: InputMaybe<AiTutorReviewForUserConnectionWhere>;
};


export type AiTutorVisualizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<VisualizationOptions>;
  where?: InputMaybe<VisualizationWhere>;
};


export type AiTutorVisualizationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VisualizationWhere>;
};


export type AiTutorVisualizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AiTutorVisualizationConnectionSort>>;
  where?: InputMaybe<AiTutorVisualizationConnectionWhere>;
};

export type AiTutorAnalytics = {
  __typename?: 'AITutorAnalytics';
  averageEngagementTime?: Maybe<Scalars['Float']['output']>;
  completionRate?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  totalSessions?: Maybe<Scalars['Int']['output']>;
};

export type AiTutorAnalyticsResponse = {
  __typename?: 'AITutorAnalyticsResponse';
  data?: Maybe<AiTutorAnalytics>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiTutorAssessmentAggregateInput = {
  AND?: InputMaybe<Array<AiTutorAssessmentAggregateInput>>;
  NOT?: InputMaybe<AiTutorAssessmentAggregateInput>;
  OR?: InputMaybe<Array<AiTutorAssessmentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AiTutorAssessmentNodeAggregationWhereInput>;
};

export type AiTutorAssessmentAssessmentAggregationSelection = {
  __typename?: 'AITutorAssessmentAssessmentAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AiTutorAssessmentAssessmentNodeAggregateSelection>;
};

export type AiTutorAssessmentAssessmentNodeAggregateSelection = {
  __typename?: 'AITutorAssessmentAssessmentNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  numberOfQuestions: IntAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  timeLimit: IntAggregateSelection;
};

export type AiTutorAssessmentConnectFieldInput = {
  connect?: InputMaybe<Array<AssessmentConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AssessmentConnectWhere>;
};

export type AiTutorAssessmentConnectOrCreateFieldInput = {
  onCreate: AiTutorAssessmentConnectOrCreateFieldInputOnCreate;
  where: AssessmentConnectOrCreateWhere;
};

export type AiTutorAssessmentConnectOrCreateFieldInputOnCreate = {
  node: AssessmentOnCreateInput;
};

export type AiTutorAssessmentConnection = {
  __typename?: 'AITutorAssessmentConnection';
  edges: Array<AiTutorAssessmentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AiTutorAssessmentConnectionSort = {
  node?: InputMaybe<AssessmentSort>;
};

export type AiTutorAssessmentConnectionWhere = {
  AND?: InputMaybe<Array<AiTutorAssessmentConnectionWhere>>;
  NOT?: InputMaybe<AiTutorAssessmentConnectionWhere>;
  OR?: InputMaybe<Array<AiTutorAssessmentConnectionWhere>>;
  node?: InputMaybe<AssessmentWhere>;
};

export type AiTutorAssessmentCreateFieldInput = {
  node: AssessmentCreateInput;
};

export type AiTutorAssessmentDeleteFieldInput = {
  delete?: InputMaybe<AssessmentDeleteInput>;
  where?: InputMaybe<AiTutorAssessmentConnectionWhere>;
};

export type AiTutorAssessmentDisconnectFieldInput = {
  disconnect?: InputMaybe<AssessmentDisconnectInput>;
  where?: InputMaybe<AiTutorAssessmentConnectionWhere>;
};

export type AiTutorAssessmentFieldInput = {
  connect?: InputMaybe<Array<AiTutorAssessmentConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AiTutorAssessmentConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AiTutorAssessmentCreateFieldInput>>;
};

export type AiTutorAssessmentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AiTutorAssessmentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AiTutorAssessmentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AiTutorAssessmentNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfQuestions_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  timeLimit_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AiTutorAssessmentRelationship = {
  __typename?: 'AITutorAssessmentRelationship';
  cursor: Scalars['String']['output'];
  node: Assessment;
};

export type AiTutorAssessmentUpdateConnectionInput = {
  node?: InputMaybe<AssessmentUpdateInput>;
};

export type AiTutorAssessmentUpdateFieldInput = {
  connect?: InputMaybe<Array<AiTutorAssessmentConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AiTutorAssessmentConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AiTutorAssessmentCreateFieldInput>>;
  delete?: InputMaybe<Array<AiTutorAssessmentDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AiTutorAssessmentDisconnectFieldInput>>;
  update?: InputMaybe<AiTutorAssessmentUpdateConnectionInput>;
  where?: InputMaybe<AiTutorAssessmentConnectionWhere>;
};

export type AiTutorChapterHasChapterPrerequisitesAggregationSelection = {
  __typename?: 'AITutorChapterHasChapterPrerequisitesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AiTutorChapterHasChapterPrerequisitesNodeAggregateSelection>;
};

export type AiTutorChapterHasChapterPrerequisitesNodeAggregateSelection = {
  __typename?: 'AITutorChapterHasChapterPrerequisitesNodeAggregateSelection';
  name: StringAggregateSelection;
};

export type AiTutorChapterHasChapterSkillsAggregationSelection = {
  __typename?: 'AITutorChapterHasChapterSkillsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AiTutorChapterHasChapterSkillsNodeAggregateSelection>;
};

export type AiTutorChapterHasChapterSkillsNodeAggregateSelection = {
  __typename?: 'AITutorChapterHasChapterSkillsNodeAggregateSelection';
  name: StringAggregateSelection;
};

export type AiTutorChatHasChatChatsAggregationSelection = {
  __typename?: 'AITutorChatHasChatChatsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<AiTutorChatHasChatChatsEdgeAggregateSelection>;
  node?: Maybe<AiTutorChatHasChatChatsNodeAggregateSelection>;
};

export type AiTutorChatHasChatChatsEdgeAggregateSelection = {
  __typename?: 'AITutorChatHasChatChatsEdgeAggregateSelection';
  ai_messages_count: IntAggregateSelection;
  average_ai_response_time: FloatAggregateSelection;
  average_student_response_time: FloatAggregateSelection;
  created: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  num_messages: IntAggregateSelection;
  questions_asked: IntAggregateSelection;
  student_messages_count: IntAggregateSelection;
  summary: StringAggregateSelection;
  total_time_taken: FloatAggregateSelection;
};

export type AiTutorChatHasChatChatsNodeAggregateSelection = {
  __typename?: 'AITutorChatHasChatChatsNodeAggregateSelection';
  context: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  date: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  name: StringAggregateSelection;
  objectId: IdAggregateSelection;
  schemaVersion: IntAggregateSelection;
  timezone: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type AiTutorConnectInput = {
  assessment?: InputMaybe<Array<AiTutorAssessmentConnectFieldInput>>;
  documents?: InputMaybe<Array<AiTutorDocumentsConnectFieldInput>>;
  files?: InputMaybe<Array<AiTutorFilesConnectFieldInput>>;
  hasChapterPrerequisites?: InputMaybe<Array<AiTutorHasChapterPrerequisitesConnectFieldInput>>;
  hasChapterSkills?: InputMaybe<Array<AiTutorHasChapterSkillsConnectFieldInput>>;
  hasChatChats?: InputMaybe<Array<AiTutorHasChatChatsConnectFieldInput>>;
  hasReview?: InputMaybe<AiTutorHasReviewConnectFieldInput>;
  hasSubchapterPrerequisites?: InputMaybe<Array<AiTutorHasSubchapterPrerequisitesConnectFieldInput>>;
  hasSubchapterSkills?: InputMaybe<Array<AiTutorHasSubchapterSkillsConnectFieldInput>>;
  mcqQuestions?: InputMaybe<Array<AiTutorMcqQuestionsConnectFieldInput>>;
  moduleHasAiTutors?: InputMaybe<Array<AiTutorModuleHasAiTutorsConnectFieldInput>>;
  nudgesAboutThis?: InputMaybe<Array<AiTutorNudgesAboutThisConnectFieldInput>>;
  objectives?: InputMaybe<Array<AiTutorObjectivesConnectFieldInput>>;
  questions?: InputMaybe<Array<AiTutorQuestionsConnectFieldInput>>;
  reviewForUser?: InputMaybe<AiTutorReviewForUserConnectFieldInput>;
  visualization?: InputMaybe<AiTutorVisualizationConnectFieldInput>;
};

export type AiTutorConnectOrCreateWhere = {
  node: AiTutorUniqueWhere;
};

export type AiTutorConnectWhere = {
  node: AiTutorWhere;
};

export type AiTutorCreateInput = {
  activityState?: InputMaybe<ActivityState>;
  assessment?: InputMaybe<AiTutorAssessmentFieldInput>;
  context?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<AiTutorDocumentsFieldInput>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  files?: InputMaybe<AiTutorFilesFieldInput>;
  hasChapterPrerequisites?: InputMaybe<AiTutorHasChapterPrerequisitesFieldInput>;
  hasChapterSkills?: InputMaybe<AiTutorHasChapterSkillsFieldInput>;
  hasChatChats?: InputMaybe<AiTutorHasChatChatsFieldInput>;
  hasReview?: InputMaybe<AiTutorHasReviewFieldInput>;
  hasSubchapterPrerequisites?: InputMaybe<AiTutorHasSubchapterPrerequisitesFieldInput>;
  hasSubchapterSkills?: InputMaybe<AiTutorHasSubchapterSkillsFieldInput>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  mcqQuestions?: InputMaybe<AiTutorMcqQuestionsFieldInput>;
  moduleHasAiTutors?: InputMaybe<AiTutorModuleHasAiTutorsFieldInput>;
  nudgesAboutThis?: InputMaybe<AiTutorNudgesAboutThisFieldInput>;
  objectives?: InputMaybe<AiTutorObjectivesFieldInput>;
  questionGenerationStatus?: InputMaybe<QuestionGenerationStatus>;
  questions?: InputMaybe<AiTutorQuestionsFieldInput>;
  reviewForUser?: InputMaybe<AiTutorReviewForUserFieldInput>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  targetAudience?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  visualization?: InputMaybe<AiTutorVisualizationFieldInput>;
};

export type AiTutorDeleteInput = {
  assessment?: InputMaybe<Array<AiTutorAssessmentDeleteFieldInput>>;
  documents?: InputMaybe<Array<AiTutorDocumentsDeleteFieldInput>>;
  files?: InputMaybe<Array<AiTutorFilesDeleteFieldInput>>;
  hasChapterPrerequisites?: InputMaybe<Array<AiTutorHasChapterPrerequisitesDeleteFieldInput>>;
  hasChapterSkills?: InputMaybe<Array<AiTutorHasChapterSkillsDeleteFieldInput>>;
  hasChatChats?: InputMaybe<Array<AiTutorHasChatChatsDeleteFieldInput>>;
  hasReview?: InputMaybe<AiTutorHasReviewDeleteFieldInput>;
  hasSubchapterPrerequisites?: InputMaybe<Array<AiTutorHasSubchapterPrerequisitesDeleteFieldInput>>;
  hasSubchapterSkills?: InputMaybe<Array<AiTutorHasSubchapterSkillsDeleteFieldInput>>;
  mcqQuestions?: InputMaybe<Array<AiTutorMcqQuestionsDeleteFieldInput>>;
  moduleHasAiTutors?: InputMaybe<Array<AiTutorModuleHasAiTutorsDeleteFieldInput>>;
  nudgesAboutThis?: InputMaybe<Array<AiTutorNudgesAboutThisDeleteFieldInput>>;
  objectives?: InputMaybe<Array<AiTutorObjectivesDeleteFieldInput>>;
  questions?: InputMaybe<Array<AiTutorQuestionsDeleteFieldInput>>;
  reviewForUser?: InputMaybe<AiTutorReviewForUserDeleteFieldInput>;
  visualization?: InputMaybe<AiTutorVisualizationDeleteFieldInput>;
};

export type AiTutorDisconnectInput = {
  assessment?: InputMaybe<Array<AiTutorAssessmentDisconnectFieldInput>>;
  documents?: InputMaybe<Array<AiTutorDocumentsDisconnectFieldInput>>;
  files?: InputMaybe<Array<AiTutorFilesDisconnectFieldInput>>;
  hasChapterPrerequisites?: InputMaybe<Array<AiTutorHasChapterPrerequisitesDisconnectFieldInput>>;
  hasChapterSkills?: InputMaybe<Array<AiTutorHasChapterSkillsDisconnectFieldInput>>;
  hasChatChats?: InputMaybe<Array<AiTutorHasChatChatsDisconnectFieldInput>>;
  hasReview?: InputMaybe<AiTutorHasReviewDisconnectFieldInput>;
  hasSubchapterPrerequisites?: InputMaybe<Array<AiTutorHasSubchapterPrerequisitesDisconnectFieldInput>>;
  hasSubchapterSkills?: InputMaybe<Array<AiTutorHasSubchapterSkillsDisconnectFieldInput>>;
  mcqQuestions?: InputMaybe<Array<AiTutorMcqQuestionsDisconnectFieldInput>>;
  moduleHasAiTutors?: InputMaybe<Array<AiTutorModuleHasAiTutorsDisconnectFieldInput>>;
  nudgesAboutThis?: InputMaybe<Array<AiTutorNudgesAboutThisDisconnectFieldInput>>;
  objectives?: InputMaybe<Array<AiTutorObjectivesDisconnectFieldInput>>;
  questions?: InputMaybe<Array<AiTutorQuestionsDisconnectFieldInput>>;
  reviewForUser?: InputMaybe<AiTutorReviewForUserDisconnectFieldInput>;
  visualization?: InputMaybe<AiTutorVisualizationDisconnectFieldInput>;
};

export type AiTutorDocumentDocumentsAggregationSelection = {
  __typename?: 'AITutorDocumentDocumentsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AiTutorDocumentDocumentsNodeAggregateSelection>;
};

export type AiTutorDocumentDocumentsNodeAggregateSelection = {
  __typename?: 'AITutorDocumentDocumentsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  summary: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type AiTutorDocumentsAggregateInput = {
  AND?: InputMaybe<Array<AiTutorDocumentsAggregateInput>>;
  NOT?: InputMaybe<AiTutorDocumentsAggregateInput>;
  OR?: InputMaybe<Array<AiTutorDocumentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AiTutorDocumentsNodeAggregationWhereInput>;
};

export type AiTutorDocumentsConnectFieldInput = {
  connect?: InputMaybe<Array<DocumentConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DocumentConnectWhere>;
};

export type AiTutorDocumentsConnection = {
  __typename?: 'AITutorDocumentsConnection';
  edges: Array<AiTutorDocumentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AiTutorDocumentsConnectionSort = {
  node?: InputMaybe<DocumentSort>;
};

export type AiTutorDocumentsConnectionWhere = {
  AND?: InputMaybe<Array<AiTutorDocumentsConnectionWhere>>;
  NOT?: InputMaybe<AiTutorDocumentsConnectionWhere>;
  OR?: InputMaybe<Array<AiTutorDocumentsConnectionWhere>>;
  node?: InputMaybe<DocumentWhere>;
};

export type AiTutorDocumentsCreateFieldInput = {
  node: DocumentCreateInput;
};

export type AiTutorDocumentsDeleteFieldInput = {
  delete?: InputMaybe<DocumentDeleteInput>;
  where?: InputMaybe<AiTutorDocumentsConnectionWhere>;
};

export type AiTutorDocumentsDisconnectFieldInput = {
  disconnect?: InputMaybe<DocumentDisconnectInput>;
  where?: InputMaybe<AiTutorDocumentsConnectionWhere>;
};

export type AiTutorDocumentsFieldInput = {
  connect?: InputMaybe<Array<AiTutorDocumentsConnectFieldInput>>;
  create?: InputMaybe<Array<AiTutorDocumentsCreateFieldInput>>;
};

export type AiTutorDocumentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AiTutorDocumentsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AiTutorDocumentsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AiTutorDocumentsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  summary_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  summary_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AiTutorDocumentsRelationship = {
  __typename?: 'AITutorDocumentsRelationship';
  cursor: Scalars['String']['output'];
  node: Document;
};

export type AiTutorDocumentsUpdateConnectionInput = {
  node?: InputMaybe<DocumentUpdateInput>;
};

export type AiTutorDocumentsUpdateFieldInput = {
  connect?: InputMaybe<Array<AiTutorDocumentsConnectFieldInput>>;
  create?: InputMaybe<Array<AiTutorDocumentsCreateFieldInput>>;
  delete?: InputMaybe<Array<AiTutorDocumentsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AiTutorDocumentsDisconnectFieldInput>>;
  update?: InputMaybe<AiTutorDocumentsUpdateConnectionInput>;
  where?: InputMaybe<AiTutorDocumentsConnectionWhere>;
};

export type AiTutorEvalCriteriaResponse = {
  __typename?: 'AITutorEvalCriteriaResponse';
  data?: Maybe<Array<Maybe<FormattedObjective>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiTutorFileFilesAggregationSelection = {
  __typename?: 'AITutorFileFilesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AiTutorFileFilesNodeAggregateSelection>;
};

export type AiTutorFileFilesNodeAggregateSelection = {
  __typename?: 'AITutorFileFilesNodeAggregateSelection';
  bucketName: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  fileName: StringAggregateSelection;
  filePath: StringAggregateSelection;
  fileURL: StringAggregateSelection;
  id: IdAggregateSelection;
};

export type AiTutorFilesAggregateInput = {
  AND?: InputMaybe<Array<AiTutorFilesAggregateInput>>;
  NOT?: InputMaybe<AiTutorFilesAggregateInput>;
  OR?: InputMaybe<Array<AiTutorFilesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AiTutorFilesNodeAggregationWhereInput>;
};

export type AiTutorFilesConnectFieldInput = {
  connect?: InputMaybe<Array<FileConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FileConnectWhere>;
};

export type AiTutorFilesConnectOrCreateFieldInput = {
  onCreate: AiTutorFilesConnectOrCreateFieldInputOnCreate;
  where: FileConnectOrCreateWhere;
};

export type AiTutorFilesConnectOrCreateFieldInputOnCreate = {
  node: FileOnCreateInput;
};

export type AiTutorFilesConnection = {
  __typename?: 'AITutorFilesConnection';
  edges: Array<AiTutorFilesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AiTutorFilesConnectionSort = {
  node?: InputMaybe<FileSort>;
};

export type AiTutorFilesConnectionWhere = {
  AND?: InputMaybe<Array<AiTutorFilesConnectionWhere>>;
  NOT?: InputMaybe<AiTutorFilesConnectionWhere>;
  OR?: InputMaybe<Array<AiTutorFilesConnectionWhere>>;
  node?: InputMaybe<FileWhere>;
};

export type AiTutorFilesCreateFieldInput = {
  node: FileCreateInput;
};

export type AiTutorFilesDeleteFieldInput = {
  delete?: InputMaybe<FileDeleteInput>;
  where?: InputMaybe<AiTutorFilesConnectionWhere>;
};

export type AiTutorFilesDisconnectFieldInput = {
  disconnect?: InputMaybe<FileDisconnectInput>;
  where?: InputMaybe<AiTutorFilesConnectionWhere>;
};

export type AiTutorFilesFieldInput = {
  connect?: InputMaybe<Array<AiTutorFilesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AiTutorFilesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AiTutorFilesCreateFieldInput>>;
};

export type AiTutorFilesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AiTutorFilesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AiTutorFilesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AiTutorFilesNodeAggregationWhereInput>>;
  bucketName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  bucketName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  fileName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileURL_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AiTutorFilesRelationship = {
  __typename?: 'AITutorFilesRelationship';
  cursor: Scalars['String']['output'];
  node: File;
};

export type AiTutorFilesUpdateConnectionInput = {
  node?: InputMaybe<FileUpdateInput>;
};

export type AiTutorFilesUpdateFieldInput = {
  connect?: InputMaybe<Array<AiTutorFilesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AiTutorFilesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AiTutorFilesCreateFieldInput>>;
  delete?: InputMaybe<Array<AiTutorFilesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AiTutorFilesDisconnectFieldInput>>;
  update?: InputMaybe<AiTutorFilesUpdateConnectionInput>;
  where?: InputMaybe<AiTutorFilesConnectionWhere>;
};

export type AiTutorGeneratedResponse = {
  __typename?: 'AITutorGeneratedResponse';
  data?: Maybe<GeneratedAiTutor>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiTutorHasChapterPrerequisitesAggregateInput = {
  AND?: InputMaybe<Array<AiTutorHasChapterPrerequisitesAggregateInput>>;
  NOT?: InputMaybe<AiTutorHasChapterPrerequisitesAggregateInput>;
  OR?: InputMaybe<Array<AiTutorHasChapterPrerequisitesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AiTutorHasChapterPrerequisitesNodeAggregationWhereInput>;
};

export type AiTutorHasChapterPrerequisitesConnectFieldInput = {
  connect?: InputMaybe<Array<ChapterConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ChapterConnectWhere>;
};

export type AiTutorHasChapterPrerequisitesConnection = {
  __typename?: 'AITutorHasChapterPrerequisitesConnection';
  edges: Array<AiTutorHasChapterPrerequisitesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AiTutorHasChapterPrerequisitesConnectionSort = {
  node?: InputMaybe<ChapterSort>;
};

export type AiTutorHasChapterPrerequisitesConnectionWhere = {
  AND?: InputMaybe<Array<AiTutorHasChapterPrerequisitesConnectionWhere>>;
  NOT?: InputMaybe<AiTutorHasChapterPrerequisitesConnectionWhere>;
  OR?: InputMaybe<Array<AiTutorHasChapterPrerequisitesConnectionWhere>>;
  node?: InputMaybe<ChapterWhere>;
};

export type AiTutorHasChapterPrerequisitesCreateFieldInput = {
  node: ChapterCreateInput;
};

export type AiTutorHasChapterPrerequisitesDeleteFieldInput = {
  delete?: InputMaybe<ChapterDeleteInput>;
  where?: InputMaybe<AiTutorHasChapterPrerequisitesConnectionWhere>;
};

export type AiTutorHasChapterPrerequisitesDisconnectFieldInput = {
  disconnect?: InputMaybe<ChapterDisconnectInput>;
  where?: InputMaybe<AiTutorHasChapterPrerequisitesConnectionWhere>;
};

export type AiTutorHasChapterPrerequisitesFieldInput = {
  connect?: InputMaybe<Array<AiTutorHasChapterPrerequisitesConnectFieldInput>>;
  create?: InputMaybe<Array<AiTutorHasChapterPrerequisitesCreateFieldInput>>;
};

export type AiTutorHasChapterPrerequisitesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AiTutorHasChapterPrerequisitesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AiTutorHasChapterPrerequisitesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AiTutorHasChapterPrerequisitesNodeAggregationWhereInput>>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AiTutorHasChapterPrerequisitesRelationship = {
  __typename?: 'AITutorHasChapterPrerequisitesRelationship';
  cursor: Scalars['String']['output'];
  node: Chapter;
};

export type AiTutorHasChapterPrerequisitesUpdateConnectionInput = {
  node?: InputMaybe<ChapterUpdateInput>;
};

export type AiTutorHasChapterPrerequisitesUpdateFieldInput = {
  connect?: InputMaybe<Array<AiTutorHasChapterPrerequisitesConnectFieldInput>>;
  create?: InputMaybe<Array<AiTutorHasChapterPrerequisitesCreateFieldInput>>;
  delete?: InputMaybe<Array<AiTutorHasChapterPrerequisitesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AiTutorHasChapterPrerequisitesDisconnectFieldInput>>;
  update?: InputMaybe<AiTutorHasChapterPrerequisitesUpdateConnectionInput>;
  where?: InputMaybe<AiTutorHasChapterPrerequisitesConnectionWhere>;
};

export type AiTutorHasChapterSkillsAggregateInput = {
  AND?: InputMaybe<Array<AiTutorHasChapterSkillsAggregateInput>>;
  NOT?: InputMaybe<AiTutorHasChapterSkillsAggregateInput>;
  OR?: InputMaybe<Array<AiTutorHasChapterSkillsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AiTutorHasChapterSkillsNodeAggregationWhereInput>;
};

export type AiTutorHasChapterSkillsConnectFieldInput = {
  connect?: InputMaybe<Array<ChapterConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ChapterConnectWhere>;
};

export type AiTutorHasChapterSkillsConnection = {
  __typename?: 'AITutorHasChapterSkillsConnection';
  edges: Array<AiTutorHasChapterSkillsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AiTutorHasChapterSkillsConnectionSort = {
  node?: InputMaybe<ChapterSort>;
};

export type AiTutorHasChapterSkillsConnectionWhere = {
  AND?: InputMaybe<Array<AiTutorHasChapterSkillsConnectionWhere>>;
  NOT?: InputMaybe<AiTutorHasChapterSkillsConnectionWhere>;
  OR?: InputMaybe<Array<AiTutorHasChapterSkillsConnectionWhere>>;
  node?: InputMaybe<ChapterWhere>;
};

export type AiTutorHasChapterSkillsCreateFieldInput = {
  node: ChapterCreateInput;
};

export type AiTutorHasChapterSkillsDeleteFieldInput = {
  delete?: InputMaybe<ChapterDeleteInput>;
  where?: InputMaybe<AiTutorHasChapterSkillsConnectionWhere>;
};

export type AiTutorHasChapterSkillsDisconnectFieldInput = {
  disconnect?: InputMaybe<ChapterDisconnectInput>;
  where?: InputMaybe<AiTutorHasChapterSkillsConnectionWhere>;
};

export type AiTutorHasChapterSkillsFieldInput = {
  connect?: InputMaybe<Array<AiTutorHasChapterSkillsConnectFieldInput>>;
  create?: InputMaybe<Array<AiTutorHasChapterSkillsCreateFieldInput>>;
};

export type AiTutorHasChapterSkillsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AiTutorHasChapterSkillsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AiTutorHasChapterSkillsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AiTutorHasChapterSkillsNodeAggregationWhereInput>>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AiTutorHasChapterSkillsRelationship = {
  __typename?: 'AITutorHasChapterSkillsRelationship';
  cursor: Scalars['String']['output'];
  node: Chapter;
};

export type AiTutorHasChapterSkillsUpdateConnectionInput = {
  node?: InputMaybe<ChapterUpdateInput>;
};

export type AiTutorHasChapterSkillsUpdateFieldInput = {
  connect?: InputMaybe<Array<AiTutorHasChapterSkillsConnectFieldInput>>;
  create?: InputMaybe<Array<AiTutorHasChapterSkillsCreateFieldInput>>;
  delete?: InputMaybe<Array<AiTutorHasChapterSkillsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AiTutorHasChapterSkillsDisconnectFieldInput>>;
  update?: InputMaybe<AiTutorHasChapterSkillsUpdateConnectionInput>;
  where?: InputMaybe<AiTutorHasChapterSkillsConnectionWhere>;
};

export type AiTutorHasChatChatsAggregateInput = {
  AND?: InputMaybe<Array<AiTutorHasChatChatsAggregateInput>>;
  NOT?: InputMaybe<AiTutorHasChatChatsAggregateInput>;
  OR?: InputMaybe<Array<AiTutorHasChatChatsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasChatPropertiesAggregationWhereInput>;
  node?: InputMaybe<AiTutorHasChatChatsNodeAggregationWhereInput>;
};

export type AiTutorHasChatChatsConnectFieldInput = {
  connect?: InputMaybe<Array<ChatConnectInput>>;
  edge?: InputMaybe<HasChatPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ChatConnectWhere>;
};

export type AiTutorHasChatChatsConnectOrCreateFieldInput = {
  onCreate: AiTutorHasChatChatsConnectOrCreateFieldInputOnCreate;
  where: ChatConnectOrCreateWhere;
};

export type AiTutorHasChatChatsConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<HasChatPropertiesCreateInput>;
  node: ChatOnCreateInput;
};

export type AiTutorHasChatChatsConnection = {
  __typename?: 'AITutorHasChatChatsConnection';
  edges: Array<AiTutorHasChatChatsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AiTutorHasChatChatsConnectionSort = {
  edge?: InputMaybe<HasChatPropertiesSort>;
  node?: InputMaybe<ChatSort>;
};

export type AiTutorHasChatChatsConnectionWhere = {
  AND?: InputMaybe<Array<AiTutorHasChatChatsConnectionWhere>>;
  NOT?: InputMaybe<AiTutorHasChatChatsConnectionWhere>;
  OR?: InputMaybe<Array<AiTutorHasChatChatsConnectionWhere>>;
  edge?: InputMaybe<HasChatPropertiesWhere>;
  node?: InputMaybe<ChatWhere>;
};

export type AiTutorHasChatChatsCreateFieldInput = {
  edge?: InputMaybe<HasChatPropertiesCreateInput>;
  node: ChatCreateInput;
};

export type AiTutorHasChatChatsDeleteFieldInput = {
  delete?: InputMaybe<ChatDeleteInput>;
  where?: InputMaybe<AiTutorHasChatChatsConnectionWhere>;
};

export type AiTutorHasChatChatsDisconnectFieldInput = {
  disconnect?: InputMaybe<ChatDisconnectInput>;
  where?: InputMaybe<AiTutorHasChatChatsConnectionWhere>;
};

export type AiTutorHasChatChatsFieldInput = {
  connect?: InputMaybe<Array<AiTutorHasChatChatsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AiTutorHasChatChatsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AiTutorHasChatChatsCreateFieldInput>>;
};

export type AiTutorHasChatChatsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AiTutorHasChatChatsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AiTutorHasChatChatsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AiTutorHasChatChatsNodeAggregationWhereInput>>;
  context_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  context_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  schemaVersion_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  schemaVersion_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  schemaVersion_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  schemaVersion_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  schemaVersion_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AiTutorHasChatChatsRelationship = {
  __typename?: 'AITutorHasChatChatsRelationship';
  cursor: Scalars['String']['output'];
  node: Chat;
  properties: HasChatProperties;
};

export type AiTutorHasChatChatsUpdateConnectionInput = {
  edge?: InputMaybe<HasChatPropertiesUpdateInput>;
  node?: InputMaybe<ChatUpdateInput>;
};

export type AiTutorHasChatChatsUpdateFieldInput = {
  connect?: InputMaybe<Array<AiTutorHasChatChatsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AiTutorHasChatChatsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AiTutorHasChatChatsCreateFieldInput>>;
  delete?: InputMaybe<Array<AiTutorHasChatChatsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AiTutorHasChatChatsDisconnectFieldInput>>;
  update?: InputMaybe<AiTutorHasChatChatsUpdateConnectionInput>;
  where?: InputMaybe<AiTutorHasChatChatsConnectionWhere>;
};

export type AiTutorHasReviewAggregateInput = {
  AND?: InputMaybe<Array<AiTutorHasReviewAggregateInput>>;
  NOT?: InputMaybe<AiTutorHasReviewAggregateInput>;
  OR?: InputMaybe<Array<AiTutorHasReviewAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AiTutorHasReviewNodeAggregationWhereInput>;
};

export type AiTutorHasReviewConnectFieldInput = {
  connect?: InputMaybe<ReviewConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ReviewConnectWhere>;
};

export type AiTutorHasReviewConnectOrCreateFieldInput = {
  onCreate: AiTutorHasReviewConnectOrCreateFieldInputOnCreate;
  where: ReviewConnectOrCreateWhere;
};

export type AiTutorHasReviewConnectOrCreateFieldInputOnCreate = {
  node: ReviewOnCreateInput;
};

export type AiTutorHasReviewConnection = {
  __typename?: 'AITutorHasReviewConnection';
  edges: Array<AiTutorHasReviewRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AiTutorHasReviewConnectionSort = {
  node?: InputMaybe<ReviewSort>;
};

export type AiTutorHasReviewConnectionWhere = {
  AND?: InputMaybe<Array<AiTutorHasReviewConnectionWhere>>;
  NOT?: InputMaybe<AiTutorHasReviewConnectionWhere>;
  OR?: InputMaybe<Array<AiTutorHasReviewConnectionWhere>>;
  node?: InputMaybe<ReviewWhere>;
};

export type AiTutorHasReviewCreateFieldInput = {
  node: ReviewCreateInput;
};

export type AiTutorHasReviewDeleteFieldInput = {
  delete?: InputMaybe<ReviewDeleteInput>;
  where?: InputMaybe<AiTutorHasReviewConnectionWhere>;
};

export type AiTutorHasReviewDisconnectFieldInput = {
  disconnect?: InputMaybe<ReviewDisconnectInput>;
  where?: InputMaybe<AiTutorHasReviewConnectionWhere>;
};

export type AiTutorHasReviewFieldInput = {
  connect?: InputMaybe<AiTutorHasReviewConnectFieldInput>;
  connectOrCreate?: InputMaybe<AiTutorHasReviewConnectOrCreateFieldInput>;
  create?: InputMaybe<AiTutorHasReviewCreateFieldInput>;
};

export type AiTutorHasReviewNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AiTutorHasReviewNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AiTutorHasReviewNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AiTutorHasReviewNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AiTutorHasReviewRelationship = {
  __typename?: 'AITutorHasReviewRelationship';
  cursor: Scalars['String']['output'];
  node: Review;
};

export type AiTutorHasReviewUpdateConnectionInput = {
  node?: InputMaybe<ReviewUpdateInput>;
};

export type AiTutorHasReviewUpdateFieldInput = {
  connect?: InputMaybe<AiTutorHasReviewConnectFieldInput>;
  connectOrCreate?: InputMaybe<AiTutorHasReviewConnectOrCreateFieldInput>;
  create?: InputMaybe<AiTutorHasReviewCreateFieldInput>;
  delete?: InputMaybe<AiTutorHasReviewDeleteFieldInput>;
  disconnect?: InputMaybe<AiTutorHasReviewDisconnectFieldInput>;
  update?: InputMaybe<AiTutorHasReviewUpdateConnectionInput>;
  where?: InputMaybe<AiTutorHasReviewConnectionWhere>;
};

export type AiTutorHasSubchapterPrerequisitesAggregateInput = {
  AND?: InputMaybe<Array<AiTutorHasSubchapterPrerequisitesAggregateInput>>;
  NOT?: InputMaybe<AiTutorHasSubchapterPrerequisitesAggregateInput>;
  OR?: InputMaybe<Array<AiTutorHasSubchapterPrerequisitesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AiTutorHasSubchapterPrerequisitesNodeAggregationWhereInput>;
};

export type AiTutorHasSubchapterPrerequisitesConnectFieldInput = {
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SubchapterConnectWhere>;
};

export type AiTutorHasSubchapterPrerequisitesConnection = {
  __typename?: 'AITutorHasSubchapterPrerequisitesConnection';
  edges: Array<AiTutorHasSubchapterPrerequisitesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AiTutorHasSubchapterPrerequisitesConnectionSort = {
  node?: InputMaybe<SubchapterSort>;
};

export type AiTutorHasSubchapterPrerequisitesConnectionWhere = {
  AND?: InputMaybe<Array<AiTutorHasSubchapterPrerequisitesConnectionWhere>>;
  NOT?: InputMaybe<AiTutorHasSubchapterPrerequisitesConnectionWhere>;
  OR?: InputMaybe<Array<AiTutorHasSubchapterPrerequisitesConnectionWhere>>;
  node?: InputMaybe<SubchapterWhere>;
};

export type AiTutorHasSubchapterPrerequisitesCreateFieldInput = {
  node: SubchapterCreateInput;
};

export type AiTutorHasSubchapterPrerequisitesDeleteFieldInput = {
  where?: InputMaybe<AiTutorHasSubchapterPrerequisitesConnectionWhere>;
};

export type AiTutorHasSubchapterPrerequisitesDisconnectFieldInput = {
  where?: InputMaybe<AiTutorHasSubchapterPrerequisitesConnectionWhere>;
};

export type AiTutorHasSubchapterPrerequisitesFieldInput = {
  connect?: InputMaybe<Array<AiTutorHasSubchapterPrerequisitesConnectFieldInput>>;
  create?: InputMaybe<Array<AiTutorHasSubchapterPrerequisitesCreateFieldInput>>;
};

export type AiTutorHasSubchapterPrerequisitesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AiTutorHasSubchapterPrerequisitesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AiTutorHasSubchapterPrerequisitesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AiTutorHasSubchapterPrerequisitesNodeAggregationWhereInput>>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AiTutorHasSubchapterPrerequisitesRelationship = {
  __typename?: 'AITutorHasSubchapterPrerequisitesRelationship';
  cursor: Scalars['String']['output'];
  node: Subchapter;
};

export type AiTutorHasSubchapterPrerequisitesUpdateConnectionInput = {
  node?: InputMaybe<SubchapterUpdateInput>;
};

export type AiTutorHasSubchapterPrerequisitesUpdateFieldInput = {
  connect?: InputMaybe<Array<AiTutorHasSubchapterPrerequisitesConnectFieldInput>>;
  create?: InputMaybe<Array<AiTutorHasSubchapterPrerequisitesCreateFieldInput>>;
  delete?: InputMaybe<Array<AiTutorHasSubchapterPrerequisitesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AiTutorHasSubchapterPrerequisitesDisconnectFieldInput>>;
  update?: InputMaybe<AiTutorHasSubchapterPrerequisitesUpdateConnectionInput>;
  where?: InputMaybe<AiTutorHasSubchapterPrerequisitesConnectionWhere>;
};

export type AiTutorHasSubchapterSkillsAggregateInput = {
  AND?: InputMaybe<Array<AiTutorHasSubchapterSkillsAggregateInput>>;
  NOT?: InputMaybe<AiTutorHasSubchapterSkillsAggregateInput>;
  OR?: InputMaybe<Array<AiTutorHasSubchapterSkillsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AiTutorHasSubchapterSkillsNodeAggregationWhereInput>;
};

export type AiTutorHasSubchapterSkillsConnectFieldInput = {
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SubchapterConnectWhere>;
};

export type AiTutorHasSubchapterSkillsConnection = {
  __typename?: 'AITutorHasSubchapterSkillsConnection';
  edges: Array<AiTutorHasSubchapterSkillsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AiTutorHasSubchapterSkillsConnectionSort = {
  node?: InputMaybe<SubchapterSort>;
};

export type AiTutorHasSubchapterSkillsConnectionWhere = {
  AND?: InputMaybe<Array<AiTutorHasSubchapterSkillsConnectionWhere>>;
  NOT?: InputMaybe<AiTutorHasSubchapterSkillsConnectionWhere>;
  OR?: InputMaybe<Array<AiTutorHasSubchapterSkillsConnectionWhere>>;
  node?: InputMaybe<SubchapterWhere>;
};

export type AiTutorHasSubchapterSkillsCreateFieldInput = {
  node: SubchapterCreateInput;
};

export type AiTutorHasSubchapterSkillsDeleteFieldInput = {
  where?: InputMaybe<AiTutorHasSubchapterSkillsConnectionWhere>;
};

export type AiTutorHasSubchapterSkillsDisconnectFieldInput = {
  where?: InputMaybe<AiTutorHasSubchapterSkillsConnectionWhere>;
};

export type AiTutorHasSubchapterSkillsFieldInput = {
  connect?: InputMaybe<Array<AiTutorHasSubchapterSkillsConnectFieldInput>>;
  create?: InputMaybe<Array<AiTutorHasSubchapterSkillsCreateFieldInput>>;
};

export type AiTutorHasSubchapterSkillsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AiTutorHasSubchapterSkillsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AiTutorHasSubchapterSkillsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AiTutorHasSubchapterSkillsNodeAggregationWhereInput>>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AiTutorHasSubchapterSkillsRelationship = {
  __typename?: 'AITutorHasSubchapterSkillsRelationship';
  cursor: Scalars['String']['output'];
  node: Subchapter;
};

export type AiTutorHasSubchapterSkillsUpdateConnectionInput = {
  node?: InputMaybe<SubchapterUpdateInput>;
};

export type AiTutorHasSubchapterSkillsUpdateFieldInput = {
  connect?: InputMaybe<Array<AiTutorHasSubchapterSkillsConnectFieldInput>>;
  create?: InputMaybe<Array<AiTutorHasSubchapterSkillsCreateFieldInput>>;
  delete?: InputMaybe<Array<AiTutorHasSubchapterSkillsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AiTutorHasSubchapterSkillsDisconnectFieldInput>>;
  update?: InputMaybe<AiTutorHasSubchapterSkillsUpdateConnectionInput>;
  where?: InputMaybe<AiTutorHasSubchapterSkillsConnectionWhere>;
};

export type AiTutorMcqQuestionMcqQuestionsAggregationSelection = {
  __typename?: 'AITutorMcqQuestionMcqQuestionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AiTutorMcqQuestionMcqQuestionsNodeAggregateSelection>;
};

export type AiTutorMcqQuestionMcqQuestionsNodeAggregateSelection = {
  __typename?: 'AITutorMcqQuestionMcqQuestionsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  explanation: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  order: IntAggregateSelection;
  question: StringAggregateSelection;
  totalScore: FloatAggregateSelection;
};

export type AiTutorMcqQuestionsAggregateInput = {
  AND?: InputMaybe<Array<AiTutorMcqQuestionsAggregateInput>>;
  NOT?: InputMaybe<AiTutorMcqQuestionsAggregateInput>;
  OR?: InputMaybe<Array<AiTutorMcqQuestionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AiTutorMcqQuestionsNodeAggregationWhereInput>;
};

export type AiTutorMcqQuestionsConnectFieldInput = {
  connect?: InputMaybe<Array<McqQuestionConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<McqQuestionConnectWhere>;
};

export type AiTutorMcqQuestionsConnectOrCreateFieldInput = {
  onCreate: AiTutorMcqQuestionsConnectOrCreateFieldInputOnCreate;
  where: McqQuestionConnectOrCreateWhere;
};

export type AiTutorMcqQuestionsConnectOrCreateFieldInputOnCreate = {
  node: McqQuestionOnCreateInput;
};

export type AiTutorMcqQuestionsConnection = {
  __typename?: 'AITutorMcqQuestionsConnection';
  edges: Array<AiTutorMcqQuestionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AiTutorMcqQuestionsConnectionSort = {
  node?: InputMaybe<McqQuestionSort>;
};

export type AiTutorMcqQuestionsConnectionWhere = {
  AND?: InputMaybe<Array<AiTutorMcqQuestionsConnectionWhere>>;
  NOT?: InputMaybe<AiTutorMcqQuestionsConnectionWhere>;
  OR?: InputMaybe<Array<AiTutorMcqQuestionsConnectionWhere>>;
  node?: InputMaybe<McqQuestionWhere>;
};

export type AiTutorMcqQuestionsCreateFieldInput = {
  node: McqQuestionCreateInput;
};

export type AiTutorMcqQuestionsDeleteFieldInput = {
  delete?: InputMaybe<McqQuestionDeleteInput>;
  where?: InputMaybe<AiTutorMcqQuestionsConnectionWhere>;
};

export type AiTutorMcqQuestionsDisconnectFieldInput = {
  disconnect?: InputMaybe<McqQuestionDisconnectInput>;
  where?: InputMaybe<AiTutorMcqQuestionsConnectionWhere>;
};

export type AiTutorMcqQuestionsFieldInput = {
  connect?: InputMaybe<Array<AiTutorMcqQuestionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AiTutorMcqQuestionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AiTutorMcqQuestionsCreateFieldInput>>;
};

export type AiTutorMcqQuestionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AiTutorMcqQuestionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AiTutorMcqQuestionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AiTutorMcqQuestionsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  explanation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  explanation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  explanation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  explanation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  explanation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  explanation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  explanation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  explanation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  explanation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  explanation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  explanation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  explanation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  explanation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  explanation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  explanation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  question_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  question_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalScore_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type AiTutorMcqQuestionsRelationship = {
  __typename?: 'AITutorMcqQuestionsRelationship';
  cursor: Scalars['String']['output'];
  node: McqQuestion;
};

export type AiTutorMcqQuestionsUpdateConnectionInput = {
  node?: InputMaybe<McqQuestionUpdateInput>;
};

export type AiTutorMcqQuestionsUpdateFieldInput = {
  connect?: InputMaybe<Array<AiTutorMcqQuestionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AiTutorMcqQuestionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AiTutorMcqQuestionsCreateFieldInput>>;
  delete?: InputMaybe<Array<AiTutorMcqQuestionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AiTutorMcqQuestionsDisconnectFieldInput>>;
  update?: InputMaybe<AiTutorMcqQuestionsUpdateConnectionInput>;
  where?: InputMaybe<AiTutorMcqQuestionsConnectionWhere>;
};

export type AiTutorModuleHasAiTutorsAggregateInput = {
  AND?: InputMaybe<Array<AiTutorModuleHasAiTutorsAggregateInput>>;
  NOT?: InputMaybe<AiTutorModuleHasAiTutorsAggregateInput>;
  OR?: InputMaybe<Array<AiTutorModuleHasAiTutorsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AiTutorModuleHasAiTutorsNodeAggregationWhereInput>;
};

export type AiTutorModuleHasAiTutorsConnectFieldInput = {
  connect?: InputMaybe<Array<ModuleConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ModuleConnectWhere>;
};

export type AiTutorModuleHasAiTutorsConnectOrCreateFieldInput = {
  onCreate: AiTutorModuleHasAiTutorsConnectOrCreateFieldInputOnCreate;
  where: ModuleConnectOrCreateWhere;
};

export type AiTutorModuleHasAiTutorsConnectOrCreateFieldInputOnCreate = {
  node: ModuleOnCreateInput;
};

export type AiTutorModuleHasAiTutorsConnection = {
  __typename?: 'AITutorModuleHasAiTutorsConnection';
  edges: Array<AiTutorModuleHasAiTutorsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AiTutorModuleHasAiTutorsConnectionSort = {
  node?: InputMaybe<ModuleSort>;
};

export type AiTutorModuleHasAiTutorsConnectionWhere = {
  AND?: InputMaybe<Array<AiTutorModuleHasAiTutorsConnectionWhere>>;
  NOT?: InputMaybe<AiTutorModuleHasAiTutorsConnectionWhere>;
  OR?: InputMaybe<Array<AiTutorModuleHasAiTutorsConnectionWhere>>;
  node?: InputMaybe<ModuleWhere>;
};

export type AiTutorModuleHasAiTutorsCreateFieldInput = {
  node: ModuleCreateInput;
};

export type AiTutorModuleHasAiTutorsDeleteFieldInput = {
  delete?: InputMaybe<ModuleDeleteInput>;
  where?: InputMaybe<AiTutorModuleHasAiTutorsConnectionWhere>;
};

export type AiTutorModuleHasAiTutorsDisconnectFieldInput = {
  disconnect?: InputMaybe<ModuleDisconnectInput>;
  where?: InputMaybe<AiTutorModuleHasAiTutorsConnectionWhere>;
};

export type AiTutorModuleHasAiTutorsFieldInput = {
  connect?: InputMaybe<Array<AiTutorModuleHasAiTutorsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AiTutorModuleHasAiTutorsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AiTutorModuleHasAiTutorsCreateFieldInput>>;
};

export type AiTutorModuleHasAiTutorsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AiTutorModuleHasAiTutorsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AiTutorModuleHasAiTutorsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AiTutorModuleHasAiTutorsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  module_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  module_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AiTutorModuleHasAiTutorsRelationship = {
  __typename?: 'AITutorModuleHasAiTutorsRelationship';
  cursor: Scalars['String']['output'];
  node: Module;
};

export type AiTutorModuleHasAiTutorsUpdateConnectionInput = {
  node?: InputMaybe<ModuleUpdateInput>;
};

export type AiTutorModuleHasAiTutorsUpdateFieldInput = {
  connect?: InputMaybe<Array<AiTutorModuleHasAiTutorsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AiTutorModuleHasAiTutorsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AiTutorModuleHasAiTutorsCreateFieldInput>>;
  delete?: InputMaybe<Array<AiTutorModuleHasAiTutorsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AiTutorModuleHasAiTutorsDisconnectFieldInput>>;
  update?: InputMaybe<AiTutorModuleHasAiTutorsUpdateConnectionInput>;
  where?: InputMaybe<AiTutorModuleHasAiTutorsConnectionWhere>;
};

export type AiTutorModuleModuleHasAiTutorsAggregationSelection = {
  __typename?: 'AITutorModuleModuleHasAiTutorsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AiTutorModuleModuleHasAiTutorsNodeAggregateSelection>;
};

export type AiTutorModuleModuleHasAiTutorsNodeAggregateSelection = {
  __typename?: 'AITutorModuleModuleHasAiTutorsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  module_name: StringAggregateSelection;
  thumbnail: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type AiTutorNudgeNudgesAboutThisAggregationSelection = {
  __typename?: 'AITutorNudgeNudgesAboutThisAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AiTutorNudgeNudgesAboutThisNodeAggregateSelection>;
};

export type AiTutorNudgeNudgesAboutThisNodeAggregateSelection = {
  __typename?: 'AITutorNudgeNudgesAboutThisNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  idempotencyKey: StringAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  priorityScore: FloatAggregateSelection;
  scheduledFor: DateTimeAggregateSelection;
  snoozedUntil: DateTimeAggregateSelection;
  taskCompletedAt: DateTimeAggregateSelection;
};

export type AiTutorNudgesAboutThisAggregateInput = {
  AND?: InputMaybe<Array<AiTutorNudgesAboutThisAggregateInput>>;
  NOT?: InputMaybe<AiTutorNudgesAboutThisAggregateInput>;
  OR?: InputMaybe<Array<AiTutorNudgesAboutThisAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AiTutorNudgesAboutThisNodeAggregationWhereInput>;
};

export type AiTutorNudgesAboutThisConnectFieldInput = {
  connect?: InputMaybe<Array<NudgeConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<NudgeConnectWhere>;
};

export type AiTutorNudgesAboutThisConnectOrCreateFieldInput = {
  onCreate: AiTutorNudgesAboutThisConnectOrCreateFieldInputOnCreate;
  where: NudgeConnectOrCreateWhere;
};

export type AiTutorNudgesAboutThisConnectOrCreateFieldInputOnCreate = {
  node: NudgeOnCreateInput;
};

export type AiTutorNudgesAboutThisConnection = {
  __typename?: 'AITutorNudgesAboutThisConnection';
  edges: Array<AiTutorNudgesAboutThisRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AiTutorNudgesAboutThisConnectionSort = {
  node?: InputMaybe<NudgeSort>;
};

export type AiTutorNudgesAboutThisConnectionWhere = {
  AND?: InputMaybe<Array<AiTutorNudgesAboutThisConnectionWhere>>;
  NOT?: InputMaybe<AiTutorNudgesAboutThisConnectionWhere>;
  OR?: InputMaybe<Array<AiTutorNudgesAboutThisConnectionWhere>>;
  node?: InputMaybe<NudgeWhere>;
};

export type AiTutorNudgesAboutThisCreateFieldInput = {
  node: NudgeCreateInput;
};

export type AiTutorNudgesAboutThisDeleteFieldInput = {
  delete?: InputMaybe<NudgeDeleteInput>;
  where?: InputMaybe<AiTutorNudgesAboutThisConnectionWhere>;
};

export type AiTutorNudgesAboutThisDisconnectFieldInput = {
  disconnect?: InputMaybe<NudgeDisconnectInput>;
  where?: InputMaybe<AiTutorNudgesAboutThisConnectionWhere>;
};

export type AiTutorNudgesAboutThisFieldInput = {
  connect?: InputMaybe<Array<AiTutorNudgesAboutThisConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AiTutorNudgesAboutThisConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AiTutorNudgesAboutThisCreateFieldInput>>;
};

export type AiTutorNudgesAboutThisNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AiTutorNudgesAboutThisNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AiTutorNudgesAboutThisNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AiTutorNudgesAboutThisNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  idempotencyKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  priorityScore_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  scheduledFor_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AiTutorNudgesAboutThisRelationship = {
  __typename?: 'AITutorNudgesAboutThisRelationship';
  cursor: Scalars['String']['output'];
  node: Nudge;
};

export type AiTutorNudgesAboutThisUpdateConnectionInput = {
  node?: InputMaybe<NudgeUpdateInput>;
};

export type AiTutorNudgesAboutThisUpdateFieldInput = {
  connect?: InputMaybe<Array<AiTutorNudgesAboutThisConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AiTutorNudgesAboutThisConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AiTutorNudgesAboutThisCreateFieldInput>>;
  delete?: InputMaybe<Array<AiTutorNudgesAboutThisDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AiTutorNudgesAboutThisDisconnectFieldInput>>;
  update?: InputMaybe<AiTutorNudgesAboutThisUpdateConnectionInput>;
  where?: InputMaybe<AiTutorNudgesAboutThisConnectionWhere>;
};

export type AiTutorObjectiveObjectivesAggregationSelection = {
  __typename?: 'AITutorObjectiveObjectivesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AiTutorObjectiveObjectivesNodeAggregateSelection>;
};

export type AiTutorObjectiveObjectivesNodeAggregateSelection = {
  __typename?: 'AITutorObjectiveObjectivesNodeAggregateSelection';
  id: IdAggregateSelection;
  objective: StringAggregateSelection;
  sequence: FloatAggregateSelection;
  teachingPlan: StringAggregateSelection;
};

export type AiTutorObjectivesAggregateInput = {
  AND?: InputMaybe<Array<AiTutorObjectivesAggregateInput>>;
  NOT?: InputMaybe<AiTutorObjectivesAggregateInput>;
  OR?: InputMaybe<Array<AiTutorObjectivesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AiTutorObjectivesNodeAggregationWhereInput>;
};

export type AiTutorObjectivesConnectFieldInput = {
  connect?: InputMaybe<Array<ObjectiveConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ObjectiveConnectWhere>;
};

export type AiTutorObjectivesConnectOrCreateFieldInput = {
  onCreate: AiTutorObjectivesConnectOrCreateFieldInputOnCreate;
  where: ObjectiveConnectOrCreateWhere;
};

export type AiTutorObjectivesConnectOrCreateFieldInputOnCreate = {
  node: ObjectiveOnCreateInput;
};

export type AiTutorObjectivesConnection = {
  __typename?: 'AITutorObjectivesConnection';
  edges: Array<AiTutorObjectivesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AiTutorObjectivesConnectionSort = {
  node?: InputMaybe<ObjectiveSort>;
};

export type AiTutorObjectivesConnectionWhere = {
  AND?: InputMaybe<Array<AiTutorObjectivesConnectionWhere>>;
  NOT?: InputMaybe<AiTutorObjectivesConnectionWhere>;
  OR?: InputMaybe<Array<AiTutorObjectivesConnectionWhere>>;
  node?: InputMaybe<ObjectiveWhere>;
};

export type AiTutorObjectivesCreateFieldInput = {
  node: ObjectiveCreateInput;
};

export type AiTutorObjectivesDeleteFieldInput = {
  delete?: InputMaybe<ObjectiveDeleteInput>;
  where?: InputMaybe<AiTutorObjectivesConnectionWhere>;
};

export type AiTutorObjectivesDisconnectFieldInput = {
  disconnect?: InputMaybe<ObjectiveDisconnectInput>;
  where?: InputMaybe<AiTutorObjectivesConnectionWhere>;
};

export type AiTutorObjectivesFieldInput = {
  connect?: InputMaybe<Array<AiTutorObjectivesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AiTutorObjectivesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AiTutorObjectivesCreateFieldInput>>;
};

export type AiTutorObjectivesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AiTutorObjectivesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AiTutorObjectivesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AiTutorObjectivesNodeAggregationWhereInput>>;
  objective_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  objective_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  objective_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  objective_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  objective_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  objective_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  objective_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  objective_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  objective_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  objective_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  objective_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  objective_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  objective_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  objective_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  objective_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sequence_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sequence_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sequence_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sequence_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sequence_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sequence_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sequence_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sequence_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sequence_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sequence_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sequence_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sequence_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sequence_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sequence_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sequence_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sequence_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sequence_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sequence_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sequence_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sequence_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  teachingPlan_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  teachingPlan_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  teachingPlan_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  teachingPlan_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  teachingPlan_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  teachingPlan_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  teachingPlan_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  teachingPlan_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  teachingPlan_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  teachingPlan_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  teachingPlan_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  teachingPlan_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  teachingPlan_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  teachingPlan_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  teachingPlan_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AiTutorObjectivesRelationship = {
  __typename?: 'AITutorObjectivesRelationship';
  cursor: Scalars['String']['output'];
  node: Objective;
};

export type AiTutorObjectivesUpdateConnectionInput = {
  node?: InputMaybe<ObjectiveUpdateInput>;
};

export type AiTutorObjectivesUpdateFieldInput = {
  connect?: InputMaybe<Array<AiTutorObjectivesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AiTutorObjectivesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AiTutorObjectivesCreateFieldInput>>;
  delete?: InputMaybe<Array<AiTutorObjectivesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AiTutorObjectivesDisconnectFieldInput>>;
  update?: InputMaybe<AiTutorObjectivesUpdateConnectionInput>;
  where?: InputMaybe<AiTutorObjectivesConnectionWhere>;
};

export type AiTutorOnCreateInput = {
  activityState?: InputMaybe<ActivityState>;
  context?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  questionGenerationStatus?: InputMaybe<QuestionGenerationStatus>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  targetAudience?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type AiTutorOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AITutorSort objects to sort AiTutors by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AiTutorSort>>;
};

export type AiTutorProgressAnalytics = {
  __typename?: 'AITutorProgressAnalytics';
  active_interaction_count: Scalars['Int']['output'];
  chatAnalytics?: Maybe<Array<Maybe<ChatAnalytics>>>;
  completion_percentage?: Maybe<Scalars['Float']['output']>;
  confusion_points: Scalars['Int']['output'];
  details: AiTutorProgressDetails;
  distractions: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  questions_asked: Scalars['Int']['output'];
  sentiment: Scalars['String']['output'];
  success_points: Scalars['Int']['output'];
  total_time_taken?: Maybe<Scalars['Float']['output']>;
};

export type AiTutorProgressDetails = {
  __typename?: 'AITutorProgressDetails';
  objectives: Array<ObjectiveProgressAnalytics>;
};

export type AiTutorQuestionQuestionsAggregationSelection = {
  __typename?: 'AITutorQuestionQuestionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AiTutorQuestionQuestionsNodeAggregateSelection>;
};

export type AiTutorQuestionQuestionsNodeAggregateSelection = {
  __typename?: 'AITutorQuestionQuestionsNodeAggregateSelection';
  id: IdAggregateSelection;
  question: StringAggregateSelection;
  totalScore: FloatAggregateSelection;
};

export type AiTutorQuestionsAggregateInput = {
  AND?: InputMaybe<Array<AiTutorQuestionsAggregateInput>>;
  NOT?: InputMaybe<AiTutorQuestionsAggregateInput>;
  OR?: InputMaybe<Array<AiTutorQuestionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AiTutorQuestionsNodeAggregationWhereInput>;
};

export type AiTutorQuestionsConnectFieldInput = {
  connect?: InputMaybe<Array<QuestionConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<QuestionConnectWhere>;
};

export type AiTutorQuestionsConnectOrCreateFieldInput = {
  onCreate: AiTutorQuestionsConnectOrCreateFieldInputOnCreate;
  where: QuestionConnectOrCreateWhere;
};

export type AiTutorQuestionsConnectOrCreateFieldInputOnCreate = {
  node: QuestionOnCreateInput;
};

export type AiTutorQuestionsConnection = {
  __typename?: 'AITutorQuestionsConnection';
  edges: Array<AiTutorQuestionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AiTutorQuestionsConnectionSort = {
  node?: InputMaybe<QuestionSort>;
};

export type AiTutorQuestionsConnectionWhere = {
  AND?: InputMaybe<Array<AiTutorQuestionsConnectionWhere>>;
  NOT?: InputMaybe<AiTutorQuestionsConnectionWhere>;
  OR?: InputMaybe<Array<AiTutorQuestionsConnectionWhere>>;
  node?: InputMaybe<QuestionWhere>;
};

export type AiTutorQuestionsCreateFieldInput = {
  node: QuestionCreateInput;
};

export type AiTutorQuestionsDeleteFieldInput = {
  delete?: InputMaybe<QuestionDeleteInput>;
  where?: InputMaybe<AiTutorQuestionsConnectionWhere>;
};

export type AiTutorQuestionsDisconnectFieldInput = {
  disconnect?: InputMaybe<QuestionDisconnectInput>;
  where?: InputMaybe<AiTutorQuestionsConnectionWhere>;
};

export type AiTutorQuestionsFieldInput = {
  connect?: InputMaybe<Array<AiTutorQuestionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AiTutorQuestionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AiTutorQuestionsCreateFieldInput>>;
};

export type AiTutorQuestionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AiTutorQuestionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AiTutorQuestionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AiTutorQuestionsNodeAggregationWhereInput>>;
  question_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  question_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalScore_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type AiTutorQuestionsRelationship = {
  __typename?: 'AITutorQuestionsRelationship';
  cursor: Scalars['String']['output'];
  node: Question;
};

export type AiTutorQuestionsUpdateConnectionInput = {
  node?: InputMaybe<QuestionUpdateInput>;
};

export type AiTutorQuestionsUpdateFieldInput = {
  connect?: InputMaybe<Array<AiTutorQuestionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AiTutorQuestionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AiTutorQuestionsCreateFieldInput>>;
  delete?: InputMaybe<Array<AiTutorQuestionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AiTutorQuestionsDisconnectFieldInput>>;
  update?: InputMaybe<AiTutorQuestionsUpdateConnectionInput>;
  where?: InputMaybe<AiTutorQuestionsConnectionWhere>;
};

export type AiTutorResponse = {
  __typename?: 'AITutorResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<FormattedAiTutor>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiTutorReviewForUserAggregateInput = {
  AND?: InputMaybe<Array<AiTutorReviewForUserAggregateInput>>;
  NOT?: InputMaybe<AiTutorReviewForUserAggregateInput>;
  OR?: InputMaybe<Array<AiTutorReviewForUserAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AiTutorReviewForUserNodeAggregationWhereInput>;
};

export type AiTutorReviewForUserConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type AiTutorReviewForUserConnectOrCreateFieldInput = {
  onCreate: AiTutorReviewForUserConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type AiTutorReviewForUserConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type AiTutorReviewForUserConnection = {
  __typename?: 'AITutorReviewForUserConnection';
  edges: Array<AiTutorReviewForUserRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AiTutorReviewForUserConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type AiTutorReviewForUserConnectionWhere = {
  AND?: InputMaybe<Array<AiTutorReviewForUserConnectionWhere>>;
  NOT?: InputMaybe<AiTutorReviewForUserConnectionWhere>;
  OR?: InputMaybe<Array<AiTutorReviewForUserConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type AiTutorReviewForUserCreateFieldInput = {
  node: UserCreateInput;
};

export type AiTutorReviewForUserDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<AiTutorReviewForUserConnectionWhere>;
};

export type AiTutorReviewForUserDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<AiTutorReviewForUserConnectionWhere>;
};

export type AiTutorReviewForUserFieldInput = {
  connect?: InputMaybe<AiTutorReviewForUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<AiTutorReviewForUserConnectOrCreateFieldInput>;
  create?: InputMaybe<AiTutorReviewForUserCreateFieldInput>;
};

export type AiTutorReviewForUserNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AiTutorReviewForUserNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AiTutorReviewForUserNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AiTutorReviewForUserNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AiTutorReviewForUserRelationship = {
  __typename?: 'AITutorReviewForUserRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type AiTutorReviewForUserUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type AiTutorReviewForUserUpdateFieldInput = {
  connect?: InputMaybe<AiTutorReviewForUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<AiTutorReviewForUserConnectOrCreateFieldInput>;
  create?: InputMaybe<AiTutorReviewForUserCreateFieldInput>;
  delete?: InputMaybe<AiTutorReviewForUserDeleteFieldInput>;
  disconnect?: InputMaybe<AiTutorReviewForUserDisconnectFieldInput>;
  update?: InputMaybe<AiTutorReviewForUserUpdateConnectionInput>;
  where?: InputMaybe<AiTutorReviewForUserConnectionWhere>;
};

export type AiTutorReviewHasReviewAggregationSelection = {
  __typename?: 'AITutorReviewHasReviewAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AiTutorReviewHasReviewNodeAggregateSelection>;
};

export type AiTutorReviewHasReviewNodeAggregateSelection = {
  __typename?: 'AITutorReviewHasReviewNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
};

/** Fields to sort AiTutors by. The order in which sorts are applied is not guaranteed when specifying many fields in one AITutorSort object. */
export type AiTutorSort = {
  activityState?: InputMaybe<SortDirection>;
  context?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  dueDate?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastModified?: InputMaybe<SortDirection>;
  questionGenerationStatus?: InputMaybe<SortDirection>;
  scheduledDate?: InputMaybe<SortDirection>;
  targetAudience?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
};

export type AiTutorSubchapterHasSubchapterPrerequisitesAggregationSelection = {
  __typename?: 'AITutorSubchapterHasSubchapterPrerequisitesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AiTutorSubchapterHasSubchapterPrerequisitesNodeAggregateSelection>;
};

export type AiTutorSubchapterHasSubchapterPrerequisitesNodeAggregateSelection = {
  __typename?: 'AITutorSubchapterHasSubchapterPrerequisitesNodeAggregateSelection';
  name: StringAggregateSelection;
};

export type AiTutorSubchapterHasSubchapterSkillsAggregationSelection = {
  __typename?: 'AITutorSubchapterHasSubchapterSkillsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AiTutorSubchapterHasSubchapterSkillsNodeAggregateSelection>;
};

export type AiTutorSubchapterHasSubchapterSkillsNodeAggregateSelection = {
  __typename?: 'AITutorSubchapterHasSubchapterSkillsNodeAggregateSelection';
  name: StringAggregateSelection;
};

export type AiTutorUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type AiTutorUpdateInput = {
  activityState?: InputMaybe<ActivityState>;
  assessment?: InputMaybe<Array<AiTutorAssessmentUpdateFieldInput>>;
  context?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Array<AiTutorDocumentsUpdateFieldInput>>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  files?: InputMaybe<Array<AiTutorFilesUpdateFieldInput>>;
  hasChapterPrerequisites?: InputMaybe<Array<AiTutorHasChapterPrerequisitesUpdateFieldInput>>;
  hasChapterSkills?: InputMaybe<Array<AiTutorHasChapterSkillsUpdateFieldInput>>;
  hasChatChats?: InputMaybe<Array<AiTutorHasChatChatsUpdateFieldInput>>;
  hasReview?: InputMaybe<AiTutorHasReviewUpdateFieldInput>;
  hasSubchapterPrerequisites?: InputMaybe<Array<AiTutorHasSubchapterPrerequisitesUpdateFieldInput>>;
  hasSubchapterSkills?: InputMaybe<Array<AiTutorHasSubchapterSkillsUpdateFieldInput>>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  mcqQuestions?: InputMaybe<Array<AiTutorMcqQuestionsUpdateFieldInput>>;
  moduleHasAiTutors?: InputMaybe<Array<AiTutorModuleHasAiTutorsUpdateFieldInput>>;
  nudgesAboutThis?: InputMaybe<Array<AiTutorNudgesAboutThisUpdateFieldInput>>;
  objectives?: InputMaybe<Array<AiTutorObjectivesUpdateFieldInput>>;
  questionGenerationStatus?: InputMaybe<QuestionGenerationStatus>;
  questions?: InputMaybe<Array<AiTutorQuestionsUpdateFieldInput>>;
  reviewForUser?: InputMaybe<AiTutorReviewForUserUpdateFieldInput>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  targetAudience?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  visualization?: InputMaybe<AiTutorVisualizationUpdateFieldInput>;
};

export type AiTutorUserReviewForUserAggregationSelection = {
  __typename?: 'AITutorUserReviewForUserAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AiTutorUserReviewForUserNodeAggregateSelection>;
};

export type AiTutorUserReviewForUserNodeAggregateSelection = {
  __typename?: 'AITutorUserReviewForUserNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type AiTutorVideosResponse = {
  __typename?: 'AITutorVideosResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<Video>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AiTutorVisualizationAggregateInput = {
  AND?: InputMaybe<Array<AiTutorVisualizationAggregateInput>>;
  NOT?: InputMaybe<AiTutorVisualizationAggregateInput>;
  OR?: InputMaybe<Array<AiTutorVisualizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AiTutorVisualizationNodeAggregationWhereInput>;
};

export type AiTutorVisualizationConnectFieldInput = {
  connect?: InputMaybe<VisualizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<VisualizationConnectWhere>;
};

export type AiTutorVisualizationConnectOrCreateFieldInput = {
  onCreate: AiTutorVisualizationConnectOrCreateFieldInputOnCreate;
  where: VisualizationConnectOrCreateWhere;
};

export type AiTutorVisualizationConnectOrCreateFieldInputOnCreate = {
  node: VisualizationOnCreateInput;
};

export type AiTutorVisualizationConnection = {
  __typename?: 'AITutorVisualizationConnection';
  edges: Array<AiTutorVisualizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AiTutorVisualizationConnectionSort = {
  node?: InputMaybe<VisualizationSort>;
};

export type AiTutorVisualizationConnectionWhere = {
  AND?: InputMaybe<Array<AiTutorVisualizationConnectionWhere>>;
  NOT?: InputMaybe<AiTutorVisualizationConnectionWhere>;
  OR?: InputMaybe<Array<AiTutorVisualizationConnectionWhere>>;
  node?: InputMaybe<VisualizationWhere>;
};

export type AiTutorVisualizationCreateFieldInput = {
  node: VisualizationCreateInput;
};

export type AiTutorVisualizationDeleteFieldInput = {
  delete?: InputMaybe<VisualizationDeleteInput>;
  where?: InputMaybe<AiTutorVisualizationConnectionWhere>;
};

export type AiTutorVisualizationDisconnectFieldInput = {
  disconnect?: InputMaybe<VisualizationDisconnectInput>;
  where?: InputMaybe<AiTutorVisualizationConnectionWhere>;
};

export type AiTutorVisualizationFieldInput = {
  connect?: InputMaybe<AiTutorVisualizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<AiTutorVisualizationConnectOrCreateFieldInput>;
  create?: InputMaybe<AiTutorVisualizationCreateFieldInput>;
};

export type AiTutorVisualizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AiTutorVisualizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AiTutorVisualizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AiTutorVisualizationNodeAggregationWhereInput>>;
  code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  visualizationDescription_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  visualizationDescription_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  visualizationDescription_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  visualizationDescription_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  visualizationDescription_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  visualizationDescription_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  visualizationDescription_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  visualizationDescription_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  visualizationDescription_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  visualizationDescription_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  visualizationDescription_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  visualizationDescription_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  visualizationDescription_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  visualizationDescription_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  visualizationDescription_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  visualizationType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  visualizationType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  visualizationType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  visualizationType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  visualizationType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  visualizationType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  visualizationType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  visualizationType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  visualizationType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  visualizationType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  visualizationType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  visualizationType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  visualizationType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  visualizationType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  visualizationType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AiTutorVisualizationRelationship = {
  __typename?: 'AITutorVisualizationRelationship';
  cursor: Scalars['String']['output'];
  node: Visualization;
};

export type AiTutorVisualizationUpdateConnectionInput = {
  node?: InputMaybe<VisualizationUpdateInput>;
};

export type AiTutorVisualizationUpdateFieldInput = {
  connect?: InputMaybe<AiTutorVisualizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<AiTutorVisualizationConnectOrCreateFieldInput>;
  create?: InputMaybe<AiTutorVisualizationCreateFieldInput>;
  delete?: InputMaybe<AiTutorVisualizationDeleteFieldInput>;
  disconnect?: InputMaybe<AiTutorVisualizationDisconnectFieldInput>;
  update?: InputMaybe<AiTutorVisualizationUpdateConnectionInput>;
  where?: InputMaybe<AiTutorVisualizationConnectionWhere>;
};

export type AiTutorVisualizationVisualizationAggregationSelection = {
  __typename?: 'AITutorVisualizationVisualizationAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AiTutorVisualizationVisualizationNodeAggregateSelection>;
};

export type AiTutorVisualizationVisualizationNodeAggregateSelection = {
  __typename?: 'AITutorVisualizationVisualizationNodeAggregateSelection';
  code: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  visualizationDescription: StringAggregateSelection;
  visualizationType: StringAggregateSelection;
};

export type AiTutorWhere = {
  AND?: InputMaybe<Array<AiTutorWhere>>;
  NOT?: InputMaybe<AiTutorWhere>;
  OR?: InputMaybe<Array<AiTutorWhere>>;
  activityState?: InputMaybe<ActivityState>;
  activityState_IN?: InputMaybe<Array<InputMaybe<ActivityState>>>;
  assessmentAggregate?: InputMaybe<AiTutorAssessmentAggregateInput>;
  /** Return AITutors where all of the related AITutorAssessmentConnections match this filter */
  assessmentConnection_ALL?: InputMaybe<AiTutorAssessmentConnectionWhere>;
  /** Return AITutors where none of the related AITutorAssessmentConnections match this filter */
  assessmentConnection_NONE?: InputMaybe<AiTutorAssessmentConnectionWhere>;
  /** Return AITutors where one of the related AITutorAssessmentConnections match this filter */
  assessmentConnection_SINGLE?: InputMaybe<AiTutorAssessmentConnectionWhere>;
  /** Return AITutors where some of the related AITutorAssessmentConnections match this filter */
  assessmentConnection_SOME?: InputMaybe<AiTutorAssessmentConnectionWhere>;
  /** Return AITutors where all of the related Assessments match this filter */
  assessment_ALL?: InputMaybe<AssessmentWhere>;
  /** Return AITutors where none of the related Assessments match this filter */
  assessment_NONE?: InputMaybe<AssessmentWhere>;
  /** Return AITutors where one of the related Assessments match this filter */
  assessment_SINGLE?: InputMaybe<AssessmentWhere>;
  /** Return AITutors where some of the related Assessments match this filter */
  assessment_SOME?: InputMaybe<AssessmentWhere>;
  context?: InputMaybe<Scalars['String']['input']>;
  context_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  context_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  context_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  context_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentsAggregate?: InputMaybe<AiTutorDocumentsAggregateInput>;
  /** Return AITutors where all of the related AITutorDocumentsConnections match this filter */
  documentsConnection_ALL?: InputMaybe<AiTutorDocumentsConnectionWhere>;
  /** Return AITutors where none of the related AITutorDocumentsConnections match this filter */
  documentsConnection_NONE?: InputMaybe<AiTutorDocumentsConnectionWhere>;
  /** Return AITutors where one of the related AITutorDocumentsConnections match this filter */
  documentsConnection_SINGLE?: InputMaybe<AiTutorDocumentsConnectionWhere>;
  /** Return AITutors where some of the related AITutorDocumentsConnections match this filter */
  documentsConnection_SOME?: InputMaybe<AiTutorDocumentsConnectionWhere>;
  /** Return AITutors where all of the related Documents match this filter */
  documents_ALL?: InputMaybe<DocumentWhere>;
  /** Return AITutors where none of the related Documents match this filter */
  documents_NONE?: InputMaybe<DocumentWhere>;
  /** Return AITutors where one of the related Documents match this filter */
  documents_SINGLE?: InputMaybe<DocumentWhere>;
  /** Return AITutors where some of the related Documents match this filter */
  documents_SOME?: InputMaybe<DocumentWhere>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  dueDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  filesAggregate?: InputMaybe<AiTutorFilesAggregateInput>;
  /** Return AITutors where all of the related AITutorFilesConnections match this filter */
  filesConnection_ALL?: InputMaybe<AiTutorFilesConnectionWhere>;
  /** Return AITutors where none of the related AITutorFilesConnections match this filter */
  filesConnection_NONE?: InputMaybe<AiTutorFilesConnectionWhere>;
  /** Return AITutors where one of the related AITutorFilesConnections match this filter */
  filesConnection_SINGLE?: InputMaybe<AiTutorFilesConnectionWhere>;
  /** Return AITutors where some of the related AITutorFilesConnections match this filter */
  filesConnection_SOME?: InputMaybe<AiTutorFilesConnectionWhere>;
  /** Return AITutors where all of the related Files match this filter */
  files_ALL?: InputMaybe<FileWhere>;
  /** Return AITutors where none of the related Files match this filter */
  files_NONE?: InputMaybe<FileWhere>;
  /** Return AITutors where one of the related Files match this filter */
  files_SINGLE?: InputMaybe<FileWhere>;
  /** Return AITutors where some of the related Files match this filter */
  files_SOME?: InputMaybe<FileWhere>;
  hasChapterPrerequisitesAggregate?: InputMaybe<AiTutorHasChapterPrerequisitesAggregateInput>;
  /** Return AITutors where all of the related AITutorHasChapterPrerequisitesConnections match this filter */
  hasChapterPrerequisitesConnection_ALL?: InputMaybe<AiTutorHasChapterPrerequisitesConnectionWhere>;
  /** Return AITutors where none of the related AITutorHasChapterPrerequisitesConnections match this filter */
  hasChapterPrerequisitesConnection_NONE?: InputMaybe<AiTutorHasChapterPrerequisitesConnectionWhere>;
  /** Return AITutors where one of the related AITutorHasChapterPrerequisitesConnections match this filter */
  hasChapterPrerequisitesConnection_SINGLE?: InputMaybe<AiTutorHasChapterPrerequisitesConnectionWhere>;
  /** Return AITutors where some of the related AITutorHasChapterPrerequisitesConnections match this filter */
  hasChapterPrerequisitesConnection_SOME?: InputMaybe<AiTutorHasChapterPrerequisitesConnectionWhere>;
  /** Return AITutors where all of the related Chapters match this filter */
  hasChapterPrerequisites_ALL?: InputMaybe<ChapterWhere>;
  /** Return AITutors where none of the related Chapters match this filter */
  hasChapterPrerequisites_NONE?: InputMaybe<ChapterWhere>;
  /** Return AITutors where one of the related Chapters match this filter */
  hasChapterPrerequisites_SINGLE?: InputMaybe<ChapterWhere>;
  /** Return AITutors where some of the related Chapters match this filter */
  hasChapterPrerequisites_SOME?: InputMaybe<ChapterWhere>;
  hasChapterSkillsAggregate?: InputMaybe<AiTutorHasChapterSkillsAggregateInput>;
  /** Return AITutors where all of the related AITutorHasChapterSkillsConnections match this filter */
  hasChapterSkillsConnection_ALL?: InputMaybe<AiTutorHasChapterSkillsConnectionWhere>;
  /** Return AITutors where none of the related AITutorHasChapterSkillsConnections match this filter */
  hasChapterSkillsConnection_NONE?: InputMaybe<AiTutorHasChapterSkillsConnectionWhere>;
  /** Return AITutors where one of the related AITutorHasChapterSkillsConnections match this filter */
  hasChapterSkillsConnection_SINGLE?: InputMaybe<AiTutorHasChapterSkillsConnectionWhere>;
  /** Return AITutors where some of the related AITutorHasChapterSkillsConnections match this filter */
  hasChapterSkillsConnection_SOME?: InputMaybe<AiTutorHasChapterSkillsConnectionWhere>;
  /** Return AITutors where all of the related Chapters match this filter */
  hasChapterSkills_ALL?: InputMaybe<ChapterWhere>;
  /** Return AITutors where none of the related Chapters match this filter */
  hasChapterSkills_NONE?: InputMaybe<ChapterWhere>;
  /** Return AITutors where one of the related Chapters match this filter */
  hasChapterSkills_SINGLE?: InputMaybe<ChapterWhere>;
  /** Return AITutors where some of the related Chapters match this filter */
  hasChapterSkills_SOME?: InputMaybe<ChapterWhere>;
  hasChatChatsAggregate?: InputMaybe<AiTutorHasChatChatsAggregateInput>;
  /** Return AITutors where all of the related AITutorHasChatChatsConnections match this filter */
  hasChatChatsConnection_ALL?: InputMaybe<AiTutorHasChatChatsConnectionWhere>;
  /** Return AITutors where none of the related AITutorHasChatChatsConnections match this filter */
  hasChatChatsConnection_NONE?: InputMaybe<AiTutorHasChatChatsConnectionWhere>;
  /** Return AITutors where one of the related AITutorHasChatChatsConnections match this filter */
  hasChatChatsConnection_SINGLE?: InputMaybe<AiTutorHasChatChatsConnectionWhere>;
  /** Return AITutors where some of the related AITutorHasChatChatsConnections match this filter */
  hasChatChatsConnection_SOME?: InputMaybe<AiTutorHasChatChatsConnectionWhere>;
  /** Return AITutors where all of the related Chats match this filter */
  hasChatChats_ALL?: InputMaybe<ChatWhere>;
  /** Return AITutors where none of the related Chats match this filter */
  hasChatChats_NONE?: InputMaybe<ChatWhere>;
  /** Return AITutors where one of the related Chats match this filter */
  hasChatChats_SINGLE?: InputMaybe<ChatWhere>;
  /** Return AITutors where some of the related Chats match this filter */
  hasChatChats_SOME?: InputMaybe<ChatWhere>;
  hasReview?: InputMaybe<ReviewWhere>;
  hasReviewAggregate?: InputMaybe<AiTutorHasReviewAggregateInput>;
  hasReviewConnection?: InputMaybe<AiTutorHasReviewConnectionWhere>;
  hasReviewConnection_NOT?: InputMaybe<AiTutorHasReviewConnectionWhere>;
  hasReview_NOT?: InputMaybe<ReviewWhere>;
  hasSubchapterPrerequisitesAggregate?: InputMaybe<AiTutorHasSubchapterPrerequisitesAggregateInput>;
  /** Return AITutors where all of the related AITutorHasSubchapterPrerequisitesConnections match this filter */
  hasSubchapterPrerequisitesConnection_ALL?: InputMaybe<AiTutorHasSubchapterPrerequisitesConnectionWhere>;
  /** Return AITutors where none of the related AITutorHasSubchapterPrerequisitesConnections match this filter */
  hasSubchapterPrerequisitesConnection_NONE?: InputMaybe<AiTutorHasSubchapterPrerequisitesConnectionWhere>;
  /** Return AITutors where one of the related AITutorHasSubchapterPrerequisitesConnections match this filter */
  hasSubchapterPrerequisitesConnection_SINGLE?: InputMaybe<AiTutorHasSubchapterPrerequisitesConnectionWhere>;
  /** Return AITutors where some of the related AITutorHasSubchapterPrerequisitesConnections match this filter */
  hasSubchapterPrerequisitesConnection_SOME?: InputMaybe<AiTutorHasSubchapterPrerequisitesConnectionWhere>;
  /** Return AITutors where all of the related Subchapters match this filter */
  hasSubchapterPrerequisites_ALL?: InputMaybe<SubchapterWhere>;
  /** Return AITutors where none of the related Subchapters match this filter */
  hasSubchapterPrerequisites_NONE?: InputMaybe<SubchapterWhere>;
  /** Return AITutors where one of the related Subchapters match this filter */
  hasSubchapterPrerequisites_SINGLE?: InputMaybe<SubchapterWhere>;
  /** Return AITutors where some of the related Subchapters match this filter */
  hasSubchapterPrerequisites_SOME?: InputMaybe<SubchapterWhere>;
  hasSubchapterSkillsAggregate?: InputMaybe<AiTutorHasSubchapterSkillsAggregateInput>;
  /** Return AITutors where all of the related AITutorHasSubchapterSkillsConnections match this filter */
  hasSubchapterSkillsConnection_ALL?: InputMaybe<AiTutorHasSubchapterSkillsConnectionWhere>;
  /** Return AITutors where none of the related AITutorHasSubchapterSkillsConnections match this filter */
  hasSubchapterSkillsConnection_NONE?: InputMaybe<AiTutorHasSubchapterSkillsConnectionWhere>;
  /** Return AITutors where one of the related AITutorHasSubchapterSkillsConnections match this filter */
  hasSubchapterSkillsConnection_SINGLE?: InputMaybe<AiTutorHasSubchapterSkillsConnectionWhere>;
  /** Return AITutors where some of the related AITutorHasSubchapterSkillsConnections match this filter */
  hasSubchapterSkillsConnection_SOME?: InputMaybe<AiTutorHasSubchapterSkillsConnectionWhere>;
  /** Return AITutors where all of the related Subchapters match this filter */
  hasSubchapterSkills_ALL?: InputMaybe<SubchapterWhere>;
  /** Return AITutors where none of the related Subchapters match this filter */
  hasSubchapterSkills_NONE?: InputMaybe<SubchapterWhere>;
  /** Return AITutors where one of the related Subchapters match this filter */
  hasSubchapterSkills_SINGLE?: InputMaybe<SubchapterWhere>;
  /** Return AITutors where some of the related Subchapters match this filter */
  hasSubchapterSkills_SOME?: InputMaybe<SubchapterWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastModified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  mcqQuestionsAggregate?: InputMaybe<AiTutorMcqQuestionsAggregateInput>;
  /** Return AITutors where all of the related AITutorMcqQuestionsConnections match this filter */
  mcqQuestionsConnection_ALL?: InputMaybe<AiTutorMcqQuestionsConnectionWhere>;
  /** Return AITutors where none of the related AITutorMcqQuestionsConnections match this filter */
  mcqQuestionsConnection_NONE?: InputMaybe<AiTutorMcqQuestionsConnectionWhere>;
  /** Return AITutors where one of the related AITutorMcqQuestionsConnections match this filter */
  mcqQuestionsConnection_SINGLE?: InputMaybe<AiTutorMcqQuestionsConnectionWhere>;
  /** Return AITutors where some of the related AITutorMcqQuestionsConnections match this filter */
  mcqQuestionsConnection_SOME?: InputMaybe<AiTutorMcqQuestionsConnectionWhere>;
  /** Return AITutors where all of the related McqQuestions match this filter */
  mcqQuestions_ALL?: InputMaybe<McqQuestionWhere>;
  /** Return AITutors where none of the related McqQuestions match this filter */
  mcqQuestions_NONE?: InputMaybe<McqQuestionWhere>;
  /** Return AITutors where one of the related McqQuestions match this filter */
  mcqQuestions_SINGLE?: InputMaybe<McqQuestionWhere>;
  /** Return AITutors where some of the related McqQuestions match this filter */
  mcqQuestions_SOME?: InputMaybe<McqQuestionWhere>;
  moduleHasAiTutorsAggregate?: InputMaybe<AiTutorModuleHasAiTutorsAggregateInput>;
  /** Return AITutors where all of the related AITutorModuleHasAiTutorsConnections match this filter */
  moduleHasAiTutorsConnection_ALL?: InputMaybe<AiTutorModuleHasAiTutorsConnectionWhere>;
  /** Return AITutors where none of the related AITutorModuleHasAiTutorsConnections match this filter */
  moduleHasAiTutorsConnection_NONE?: InputMaybe<AiTutorModuleHasAiTutorsConnectionWhere>;
  /** Return AITutors where one of the related AITutorModuleHasAiTutorsConnections match this filter */
  moduleHasAiTutorsConnection_SINGLE?: InputMaybe<AiTutorModuleHasAiTutorsConnectionWhere>;
  /** Return AITutors where some of the related AITutorModuleHasAiTutorsConnections match this filter */
  moduleHasAiTutorsConnection_SOME?: InputMaybe<AiTutorModuleHasAiTutorsConnectionWhere>;
  /** Return AITutors where all of the related Modules match this filter */
  moduleHasAiTutors_ALL?: InputMaybe<ModuleWhere>;
  /** Return AITutors where none of the related Modules match this filter */
  moduleHasAiTutors_NONE?: InputMaybe<ModuleWhere>;
  /** Return AITutors where one of the related Modules match this filter */
  moduleHasAiTutors_SINGLE?: InputMaybe<ModuleWhere>;
  /** Return AITutors where some of the related Modules match this filter */
  moduleHasAiTutors_SOME?: InputMaybe<ModuleWhere>;
  nudgesAboutThisAggregate?: InputMaybe<AiTutorNudgesAboutThisAggregateInput>;
  /** Return AITutors where all of the related AITutorNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_ALL?: InputMaybe<AiTutorNudgesAboutThisConnectionWhere>;
  /** Return AITutors where none of the related AITutorNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_NONE?: InputMaybe<AiTutorNudgesAboutThisConnectionWhere>;
  /** Return AITutors where one of the related AITutorNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_SINGLE?: InputMaybe<AiTutorNudgesAboutThisConnectionWhere>;
  /** Return AITutors where some of the related AITutorNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_SOME?: InputMaybe<AiTutorNudgesAboutThisConnectionWhere>;
  /** Return AITutors where all of the related Nudges match this filter */
  nudgesAboutThis_ALL?: InputMaybe<NudgeWhere>;
  /** Return AITutors where none of the related Nudges match this filter */
  nudgesAboutThis_NONE?: InputMaybe<NudgeWhere>;
  /** Return AITutors where one of the related Nudges match this filter */
  nudgesAboutThis_SINGLE?: InputMaybe<NudgeWhere>;
  /** Return AITutors where some of the related Nudges match this filter */
  nudgesAboutThis_SOME?: InputMaybe<NudgeWhere>;
  objectivesAggregate?: InputMaybe<AiTutorObjectivesAggregateInput>;
  /** Return AITutors where all of the related AITutorObjectivesConnections match this filter */
  objectivesConnection_ALL?: InputMaybe<AiTutorObjectivesConnectionWhere>;
  /** Return AITutors where none of the related AITutorObjectivesConnections match this filter */
  objectivesConnection_NONE?: InputMaybe<AiTutorObjectivesConnectionWhere>;
  /** Return AITutors where one of the related AITutorObjectivesConnections match this filter */
  objectivesConnection_SINGLE?: InputMaybe<AiTutorObjectivesConnectionWhere>;
  /** Return AITutors where some of the related AITutorObjectivesConnections match this filter */
  objectivesConnection_SOME?: InputMaybe<AiTutorObjectivesConnectionWhere>;
  /** Return AITutors where all of the related Objectives match this filter */
  objectives_ALL?: InputMaybe<ObjectiveWhere>;
  /** Return AITutors where none of the related Objectives match this filter */
  objectives_NONE?: InputMaybe<ObjectiveWhere>;
  /** Return AITutors where one of the related Objectives match this filter */
  objectives_SINGLE?: InputMaybe<ObjectiveWhere>;
  /** Return AITutors where some of the related Objectives match this filter */
  objectives_SOME?: InputMaybe<ObjectiveWhere>;
  questionGenerationStatus?: InputMaybe<QuestionGenerationStatus>;
  questionGenerationStatus_IN?: InputMaybe<Array<InputMaybe<QuestionGenerationStatus>>>;
  questionsAggregate?: InputMaybe<AiTutorQuestionsAggregateInput>;
  /** Return AITutors where all of the related AITutorQuestionsConnections match this filter */
  questionsConnection_ALL?: InputMaybe<AiTutorQuestionsConnectionWhere>;
  /** Return AITutors where none of the related AITutorQuestionsConnections match this filter */
  questionsConnection_NONE?: InputMaybe<AiTutorQuestionsConnectionWhere>;
  /** Return AITutors where one of the related AITutorQuestionsConnections match this filter */
  questionsConnection_SINGLE?: InputMaybe<AiTutorQuestionsConnectionWhere>;
  /** Return AITutors where some of the related AITutorQuestionsConnections match this filter */
  questionsConnection_SOME?: InputMaybe<AiTutorQuestionsConnectionWhere>;
  /** Return AITutors where all of the related Questions match this filter */
  questions_ALL?: InputMaybe<QuestionWhere>;
  /** Return AITutors where none of the related Questions match this filter */
  questions_NONE?: InputMaybe<QuestionWhere>;
  /** Return AITutors where one of the related Questions match this filter */
  questions_SINGLE?: InputMaybe<QuestionWhere>;
  /** Return AITutors where some of the related Questions match this filter */
  questions_SOME?: InputMaybe<QuestionWhere>;
  reviewForUser?: InputMaybe<UserWhere>;
  reviewForUserAggregate?: InputMaybe<AiTutorReviewForUserAggregateInput>;
  reviewForUserConnection?: InputMaybe<AiTutorReviewForUserConnectionWhere>;
  reviewForUserConnection_NOT?: InputMaybe<AiTutorReviewForUserConnectionWhere>;
  reviewForUser_NOT?: InputMaybe<UserWhere>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  scheduledDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  targetAudience?: InputMaybe<Scalars['String']['input']>;
  targetAudience_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  targetAudience_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  targetAudience_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  targetAudience_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  visualization?: InputMaybe<VisualizationWhere>;
  visualizationAggregate?: InputMaybe<AiTutorVisualizationAggregateInput>;
  visualizationConnection?: InputMaybe<AiTutorVisualizationConnectionWhere>;
  visualizationConnection_NOT?: InputMaybe<AiTutorVisualizationConnectionWhere>;
  visualization_NOT?: InputMaybe<VisualizationWhere>;
};

export type Achievements = {
  __typename?: 'Achievements';
  attributes: Array<Attribute>;
  attributesAggregate?: Maybe<AchievementsAttributeAttributesAggregationSelection>;
  attributesConnection: AchievementsAttributesConnection;
  created: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  last_modified: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  users: Array<User>;
  usersAggregate?: Maybe<AchievementsUserUsersAggregationSelection>;
  usersConnection: AchievementsUsersConnection;
};


export type AchievementsAttributesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AttributeOptions>;
  where?: InputMaybe<AttributeWhere>;
};


export type AchievementsAttributesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AttributeWhere>;
};


export type AchievementsAttributesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AchievementsAttributesConnectionSort>>;
  where?: InputMaybe<AchievementsAttributesConnectionWhere>;
};


export type AchievementsUsersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type AchievementsUsersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type AchievementsUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AchievementsUsersConnectionSort>>;
  where?: InputMaybe<AchievementsUsersConnectionWhere>;
};

export type AchievementsAttributeAttributesAggregationSelection = {
  __typename?: 'AchievementsAttributeAttributesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AchievementsAttributeAttributesNodeAggregateSelection>;
};

export type AchievementsAttributeAttributesNodeAggregateSelection = {
  __typename?: 'AchievementsAttributeAttributesNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: StringAggregateSelection;
  text: StringAggregateSelection;
};

export type AchievementsAttributesAggregateInput = {
  AND?: InputMaybe<Array<AchievementsAttributesAggregateInput>>;
  NOT?: InputMaybe<AchievementsAttributesAggregateInput>;
  OR?: InputMaybe<Array<AchievementsAttributesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AchievementsAttributesNodeAggregationWhereInput>;
};

export type AchievementsAttributesConnectFieldInput = {
  connect?: InputMaybe<Array<AttributeConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AttributeConnectWhere>;
};

export type AchievementsAttributesConnection = {
  __typename?: 'AchievementsAttributesConnection';
  edges: Array<AchievementsAttributesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AchievementsAttributesConnectionSort = {
  node?: InputMaybe<AttributeSort>;
};

export type AchievementsAttributesConnectionWhere = {
  AND?: InputMaybe<Array<AchievementsAttributesConnectionWhere>>;
  NOT?: InputMaybe<AchievementsAttributesConnectionWhere>;
  OR?: InputMaybe<Array<AchievementsAttributesConnectionWhere>>;
  node?: InputMaybe<AttributeWhere>;
};

export type AchievementsAttributesCreateFieldInput = {
  node: AttributeCreateInput;
};

export type AchievementsAttributesDeleteFieldInput = {
  delete?: InputMaybe<AttributeDeleteInput>;
  where?: InputMaybe<AchievementsAttributesConnectionWhere>;
};

export type AchievementsAttributesDisconnectFieldInput = {
  disconnect?: InputMaybe<AttributeDisconnectInput>;
  where?: InputMaybe<AchievementsAttributesConnectionWhere>;
};

export type AchievementsAttributesFieldInput = {
  connect?: InputMaybe<Array<AchievementsAttributesConnectFieldInput>>;
  create?: InputMaybe<Array<AchievementsAttributesCreateFieldInput>>;
};

export type AchievementsAttributesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AchievementsAttributesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AchievementsAttributesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AchievementsAttributesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  text_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  text_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AchievementsAttributesRelationship = {
  __typename?: 'AchievementsAttributesRelationship';
  cursor: Scalars['String']['output'];
  node: Attribute;
};

export type AchievementsAttributesUpdateConnectionInput = {
  node?: InputMaybe<AttributeUpdateInput>;
};

export type AchievementsAttributesUpdateFieldInput = {
  connect?: InputMaybe<Array<AchievementsAttributesConnectFieldInput>>;
  create?: InputMaybe<Array<AchievementsAttributesCreateFieldInput>>;
  delete?: InputMaybe<Array<AchievementsAttributesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AchievementsAttributesDisconnectFieldInput>>;
  update?: InputMaybe<AchievementsAttributesUpdateConnectionInput>;
  where?: InputMaybe<AchievementsAttributesConnectionWhere>;
};

export type AchievementsConnectInput = {
  attributes?: InputMaybe<Array<AchievementsAttributesConnectFieldInput>>;
  users?: InputMaybe<Array<AchievementsUsersConnectFieldInput>>;
};

export type AchievementsConnectWhere = {
  node: AchievementsWhere;
};

export type AchievementsCreateInput = {
  attributes?: InputMaybe<AchievementsAttributesFieldInput>;
  created: Scalars['DateTime']['input'];
  id: Scalars['String']['input'];
  last_modified: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  users?: InputMaybe<AchievementsUsersFieldInput>;
};

export type AchievementsDeleteInput = {
  attributes?: InputMaybe<Array<AchievementsAttributesDeleteFieldInput>>;
  users?: InputMaybe<Array<AchievementsUsersDeleteFieldInput>>;
};

export type AchievementsDisconnectInput = {
  attributes?: InputMaybe<Array<AchievementsAttributesDisconnectFieldInput>>;
  users?: InputMaybe<Array<AchievementsUsersDisconnectFieldInput>>;
};

export type AchievementsOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AchievementsSort objects to sort Achievements by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AchievementsSort>>;
};

/** Fields to sort Achievements by. The order in which sorts are applied is not guaranteed when specifying many fields in one AchievementsSort object. */
export type AchievementsSort = {
  created?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  last_modified?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type AchievementsUpdateInput = {
  attributes?: InputMaybe<Array<AchievementsAttributesUpdateFieldInput>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<AchievementsUsersUpdateFieldInput>>;
};

export type AchievementsUserUsersAggregationSelection = {
  __typename?: 'AchievementsUserUsersAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AchievementsUserUsersNodeAggregateSelection>;
};

export type AchievementsUserUsersNodeAggregateSelection = {
  __typename?: 'AchievementsUserUsersNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type AchievementsUsersAggregateInput = {
  AND?: InputMaybe<Array<AchievementsUsersAggregateInput>>;
  NOT?: InputMaybe<AchievementsUsersAggregateInput>;
  OR?: InputMaybe<Array<AchievementsUsersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AchievementsUsersNodeAggregationWhereInput>;
};

export type AchievementsUsersConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type AchievementsUsersConnectOrCreateFieldInput = {
  onCreate: AchievementsUsersConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type AchievementsUsersConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type AchievementsUsersConnection = {
  __typename?: 'AchievementsUsersConnection';
  edges: Array<AchievementsUsersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AchievementsUsersConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type AchievementsUsersConnectionWhere = {
  AND?: InputMaybe<Array<AchievementsUsersConnectionWhere>>;
  NOT?: InputMaybe<AchievementsUsersConnectionWhere>;
  OR?: InputMaybe<Array<AchievementsUsersConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type AchievementsUsersCreateFieldInput = {
  node: UserCreateInput;
};

export type AchievementsUsersDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<AchievementsUsersConnectionWhere>;
};

export type AchievementsUsersDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<AchievementsUsersConnectionWhere>;
};

export type AchievementsUsersFieldInput = {
  connect?: InputMaybe<Array<AchievementsUsersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AchievementsUsersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AchievementsUsersCreateFieldInput>>;
};

export type AchievementsUsersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AchievementsUsersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AchievementsUsersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AchievementsUsersNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AchievementsUsersRelationship = {
  __typename?: 'AchievementsUsersRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type AchievementsUsersUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type AchievementsUsersUpdateFieldInput = {
  connect?: InputMaybe<Array<AchievementsUsersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AchievementsUsersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AchievementsUsersCreateFieldInput>>;
  delete?: InputMaybe<Array<AchievementsUsersDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AchievementsUsersDisconnectFieldInput>>;
  update?: InputMaybe<AchievementsUsersUpdateConnectionInput>;
  where?: InputMaybe<AchievementsUsersConnectionWhere>;
};

export type AchievementsWhere = {
  AND?: InputMaybe<Array<AchievementsWhere>>;
  NOT?: InputMaybe<AchievementsWhere>;
  OR?: InputMaybe<Array<AchievementsWhere>>;
  attributesAggregate?: InputMaybe<AchievementsAttributesAggregateInput>;
  /** Return Achievements where all of the related AchievementsAttributesConnections match this filter */
  attributesConnection_ALL?: InputMaybe<AchievementsAttributesConnectionWhere>;
  /** Return Achievements where none of the related AchievementsAttributesConnections match this filter */
  attributesConnection_NONE?: InputMaybe<AchievementsAttributesConnectionWhere>;
  /** Return Achievements where one of the related AchievementsAttributesConnections match this filter */
  attributesConnection_SINGLE?: InputMaybe<AchievementsAttributesConnectionWhere>;
  /** Return Achievements where some of the related AchievementsAttributesConnections match this filter */
  attributesConnection_SOME?: InputMaybe<AchievementsAttributesConnectionWhere>;
  /** Return Achievements where all of the related Attributes match this filter */
  attributes_ALL?: InputMaybe<AttributeWhere>;
  /** Return Achievements where none of the related Attributes match this filter */
  attributes_NONE?: InputMaybe<AttributeWhere>;
  /** Return Achievements where one of the related Attributes match this filter */
  attributes_SINGLE?: InputMaybe<AttributeWhere>;
  /** Return Achievements where some of the related Attributes match this filter */
  attributes_SOME?: InputMaybe<AttributeWhere>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  id_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  last_modified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  usersAggregate?: InputMaybe<AchievementsUsersAggregateInput>;
  /** Return Achievements where all of the related AchievementsUsersConnections match this filter */
  usersConnection_ALL?: InputMaybe<AchievementsUsersConnectionWhere>;
  /** Return Achievements where none of the related AchievementsUsersConnections match this filter */
  usersConnection_NONE?: InputMaybe<AchievementsUsersConnectionWhere>;
  /** Return Achievements where one of the related AchievementsUsersConnections match this filter */
  usersConnection_SINGLE?: InputMaybe<AchievementsUsersConnectionWhere>;
  /** Return Achievements where some of the related AchievementsUsersConnections match this filter */
  usersConnection_SOME?: InputMaybe<AchievementsUsersConnectionWhere>;
  /** Return Achievements where all of the related Users match this filter */
  users_ALL?: InputMaybe<UserWhere>;
  /** Return Achievements where none of the related Users match this filter */
  users_NONE?: InputMaybe<UserWhere>;
  /** Return Achievements where one of the related Users match this filter */
  users_SINGLE?: InputMaybe<UserWhere>;
  /** Return Achievements where some of the related Users match this filter */
  users_SOME?: InputMaybe<UserWhere>;
};

export type ActiveTrack = {
  __typename?: 'ActiveTrack';
  completedUnits?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['DateTime']['output']>;
  mastery?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  parentSubfield?: Maybe<Scalars['String']['output']>;
  totalUnits?: Maybe<Scalars['Int']['output']>;
};

export type ActivityAnalytics = {
  __typename?: 'ActivityAnalytics';
  active_interaction_count: Scalars['Int']['output'];
  average_time_taken?: Maybe<Scalars['Float']['output']>;
  confusion_points: Scalars['Int']['output'];
  confusion_points_details?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  details: ActivityAnalyticsDetails;
  distractions: Scalars['Int']['output'];
  distractions_details?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  enrollment: Scalars['Int']['output'];
  further_recommendations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  questions_asked: Scalars['Int']['output'];
  sentiment: Scalars['String']['output'];
  success_points: Scalars['Int']['output'];
  success_points_details?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  summaries?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ActivityAnalyticsDetails = {
  __typename?: 'ActivityAnalyticsDetails';
  objectives: Array<ObjectiveAnalytics>;
};

export type ActivityAnalyticsResponse = {
  __typename?: 'ActivityAnalyticsResponse';
  count: Scalars['Int']['output'];
  data: Array<ActivityAnalytics>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ActivityCompletionDetails = {
  __typename?: 'ActivityCompletionDetails';
  completionStats: CompletionStats;
  details: ActivityCompletionDetailsData;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type ActivityCompletionDetailsData = {
  __typename?: 'ActivityCompletionDetailsData';
  objectives: Array<ObjectiveCompletionDetails>;
};

export type ActivityCompletionDetailsFull = {
  __typename?: 'ActivityCompletionDetailsFull';
  completionStats: CompletionStats;
  course_id?: Maybe<Scalars['ID']['output']>;
  course_name?: Maybe<Scalars['String']['output']>;
  details: ActivityCompletionDetailsObjectives;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  module_id?: Maybe<Scalars['ID']['output']>;
  module_name?: Maybe<Scalars['String']['output']>;
};

export type ActivityCompletionDetailsObjectives = {
  __typename?: 'ActivityCompletionDetailsObjectives';
  objectives: Array<ObjectiveCompletionDetails>;
};

export type ActivityCompletionDetailsResponse = {
  __typename?: 'ActivityCompletionDetailsResponse';
  count: Scalars['Int']['output'];
  data: Array<ActivityCompletionDetailsFull>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ActivityInsights = {
  __typename?: 'ActivityInsights';
  average_time_taken: Scalars['Float']['output'];
  completion_rate: Scalars['Float']['output'];
  confusion_points_details: Array<Scalars['String']['output']>;
  further_recommendations: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  overall_sentiment: Scalars['String']['output'];
  student_engagement: Scalars['String']['output'];
  success_points_details: Array<Scalars['String']['output']>;
};

export type ActivityInsightsResponse = {
  __typename?: 'ActivityInsightsResponse';
  count: Scalars['Int']['output'];
  data: Array<ActivityInsights>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ActivityProgressAnalytics = {
  __typename?: 'ActivityProgressAnalytics';
  active_interaction_count: Scalars['Int']['output'];
  chatAnalytics?: Maybe<Array<Maybe<ChatAnalytics>>>;
  completion_percentage?: Maybe<Scalars['Float']['output']>;
  confusion_points: Scalars['Int']['output'];
  details: ActivityProgressDetails;
  distractions: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  questions_asked: Scalars['Int']['output'];
  sentiment: Scalars['String']['output'];
  success_points: Scalars['Int']['output'];
  total_time_taken?: Maybe<Scalars['Float']['output']>;
};

export type ActivityProgressDetails = {
  __typename?: 'ActivityProgressDetails';
  objectives: Array<ObjectiveProgressAnalytics>;
};

export enum ActivityState {
  Draft = 'draft',
  Published = 'published',
  Scheduled = 'scheduled'
}

export enum ActivityType {
  Aitutor = 'AITUTOR',
  Assessment = 'ASSESSMENT',
  Assignment = 'ASSIGNMENT',
  AxioResource = 'AXIO_RESOURCE',
  Page = 'PAGE',
  Project = 'PROJECT',
  Review = 'REVIEW'
}

export type AddAssignmentResponse = {
  __typename?: 'AddAssignmentResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AddContentModuleResponse = {
  __typename?: 'AddContentModuleResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AddCoursesToDegreeInput = {
  courseIds: Array<Scalars['ID']['input']>;
  degreeId: Scalars['ID']['input'];
};

export type AddTodoInput = {
  aiSummary?: InputMaybe<Scalars['String']['input']>;
  completed_date?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['String']['input']>;
  recurringDaily?: InputMaybe<Scalars['Boolean']['input']>;
  recurringDayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek?: InputMaybe<Scalars['String']['input']>;
  recurringFrequency?: InputMaybe<Scalars['String']['input']>;
  recurringTime?: InputMaybe<Scalars['String']['input']>;
  timeOfDay?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminDashboardMetrics = {
  __typename?: 'AdminDashboardMetrics';
  activeCourses: Scalars['Int']['output'];
  totalStudents: Scalars['Int']['output'];
};

export type AdminDashboardResponse = {
  __typename?: 'AdminDashboardResponse';
  data: AdminDashboardMetrics;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AdminDocumentAnalytics = {
  __typename?: 'AdminDocumentAnalytics';
  document: Document;
  referenceCount: Scalars['Int']['output'];
};

export type AdminDocumentAnalyticsResponse = {
  __typename?: 'AdminDocumentAnalyticsResponse';
  count: Scalars['Int']['output'];
  data: Array<AdminDocumentAnalytics>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AdminDocumentsResponse = {
  __typename?: 'AdminDocumentsResponse';
  count: Scalars['Int']['output'];
  data: Array<Document>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AllowedUploadSpecifications = {
  __typename?: 'AllowedUploadSpecifications';
  allowedMimeTypes: Array<Scalars['String']['output']>;
  maxFileSize: Scalars['Int']['output'];
};

export type AllowedUploadSpecificationsResponse = {
  __typename?: 'AllowedUploadSpecificationsResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<AllowedUploadSpecifications>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AnalyticsCourse = {
  __typename?: 'AnalyticsCourse';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Announcement = {
  __typename?: 'Announcement';
  audienceType: AudienceType;
  author: User;
  authorAggregate?: Maybe<AnnouncementUserAuthorAggregationSelection>;
  authorConnection: AnnouncementAuthorConnection;
  courses: Array<Course>;
  coursesAggregate?: Maybe<AnnouncementCourseCoursesAggregationSelection>;
  coursesConnection: AnnouncementCoursesConnection;
  created: Scalars['DateTime']['output'];
  degrees: Array<Degree>;
  degreesAggregate?: Maybe<AnnouncementDegreeDegreesAggregationSelection>;
  degreesConnection: AnnouncementDegreesConnection;
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  lastModified: Scalars['DateTime']['output'];
  message: Scalars['String']['output'];
  notificationEvents: Array<NotificationEvent>;
  notificationEventsAggregate?: Maybe<AnnouncementNotificationEventNotificationEventsAggregationSelection>;
  notificationEventsConnection: AnnouncementNotificationEventsConnection;
  nudgesAboutThis: Array<Nudge>;
  nudgesAboutThisAggregate?: Maybe<AnnouncementNudgeNudgesAboutThisAggregationSelection>;
  nudgesAboutThisConnection: AnnouncementNudgesAboutThisConnection;
  school?: Maybe<School>;
  schoolAggregate?: Maybe<AnnouncementSchoolSchoolAggregationSelection>;
  schoolConnection: AnnouncementSchoolConnection;
  scope: AnnouncementScope;
  title: Scalars['String']['output'];
  viewedBy: Array<User>;
  viewedByAggregate?: Maybe<AnnouncementUserViewedByAggregationSelection>;
  viewedByConnection: AnnouncementViewedByConnection;
};


export type AnnouncementAuthorArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type AnnouncementAuthorAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type AnnouncementAuthorConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AnnouncementAuthorConnectionSort>>;
  where?: InputMaybe<AnnouncementAuthorConnectionWhere>;
};


export type AnnouncementCoursesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CourseOptions>;
  where?: InputMaybe<CourseWhere>;
};


export type AnnouncementCoursesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CourseWhere>;
};


export type AnnouncementCoursesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AnnouncementCoursesConnectionSort>>;
  where?: InputMaybe<AnnouncementCoursesConnectionWhere>;
};


export type AnnouncementDegreesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DegreeOptions>;
  where?: InputMaybe<DegreeWhere>;
};


export type AnnouncementDegreesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DegreeWhere>;
};


export type AnnouncementDegreesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AnnouncementDegreesConnectionSort>>;
  where?: InputMaybe<AnnouncementDegreesConnectionWhere>;
};


export type AnnouncementNotificationEventsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<NotificationEventOptions>;
  where?: InputMaybe<NotificationEventWhere>;
};


export type AnnouncementNotificationEventsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NotificationEventWhere>;
};


export type AnnouncementNotificationEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AnnouncementNotificationEventsConnectionSort>>;
  where?: InputMaybe<AnnouncementNotificationEventsConnectionWhere>;
};


export type AnnouncementNudgesAboutThisArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<NudgeOptions>;
  where?: InputMaybe<NudgeWhere>;
};


export type AnnouncementNudgesAboutThisAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NudgeWhere>;
};


export type AnnouncementNudgesAboutThisConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AnnouncementNudgesAboutThisConnectionSort>>;
  where?: InputMaybe<AnnouncementNudgesAboutThisConnectionWhere>;
};


export type AnnouncementSchoolArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SchoolOptions>;
  where?: InputMaybe<SchoolWhere>;
};


export type AnnouncementSchoolAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SchoolWhere>;
};


export type AnnouncementSchoolConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AnnouncementSchoolConnectionSort>>;
  where?: InputMaybe<AnnouncementSchoolConnectionWhere>;
};


export type AnnouncementViewedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type AnnouncementViewedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type AnnouncementViewedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AnnouncementViewedByConnectionSort>>;
  where?: InputMaybe<AnnouncementViewedByConnectionWhere>;
};

export type AnnouncementAuthorAggregateInput = {
  AND?: InputMaybe<Array<AnnouncementAuthorAggregateInput>>;
  NOT?: InputMaybe<AnnouncementAuthorAggregateInput>;
  OR?: InputMaybe<Array<AnnouncementAuthorAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AnnouncementAuthorNodeAggregationWhereInput>;
};

export type AnnouncementAuthorConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type AnnouncementAuthorConnectOrCreateFieldInput = {
  onCreate: AnnouncementAuthorConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type AnnouncementAuthorConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type AnnouncementAuthorConnection = {
  __typename?: 'AnnouncementAuthorConnection';
  edges: Array<AnnouncementAuthorRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AnnouncementAuthorConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type AnnouncementAuthorConnectionWhere = {
  AND?: InputMaybe<Array<AnnouncementAuthorConnectionWhere>>;
  NOT?: InputMaybe<AnnouncementAuthorConnectionWhere>;
  OR?: InputMaybe<Array<AnnouncementAuthorConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type AnnouncementAuthorCreateFieldInput = {
  node: UserCreateInput;
};

export type AnnouncementAuthorDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<AnnouncementAuthorConnectionWhere>;
};

export type AnnouncementAuthorDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<AnnouncementAuthorConnectionWhere>;
};

export type AnnouncementAuthorFieldInput = {
  connect?: InputMaybe<AnnouncementAuthorConnectFieldInput>;
  connectOrCreate?: InputMaybe<AnnouncementAuthorConnectOrCreateFieldInput>;
  create?: InputMaybe<AnnouncementAuthorCreateFieldInput>;
};

export type AnnouncementAuthorNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AnnouncementAuthorNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AnnouncementAuthorNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AnnouncementAuthorNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AnnouncementAuthorRelationship = {
  __typename?: 'AnnouncementAuthorRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type AnnouncementAuthorUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type AnnouncementAuthorUpdateFieldInput = {
  connect?: InputMaybe<AnnouncementAuthorConnectFieldInput>;
  connectOrCreate?: InputMaybe<AnnouncementAuthorConnectOrCreateFieldInput>;
  create?: InputMaybe<AnnouncementAuthorCreateFieldInput>;
  delete?: InputMaybe<AnnouncementAuthorDeleteFieldInput>;
  disconnect?: InputMaybe<AnnouncementAuthorDisconnectFieldInput>;
  update?: InputMaybe<AnnouncementAuthorUpdateConnectionInput>;
  where?: InputMaybe<AnnouncementAuthorConnectionWhere>;
};

export type AnnouncementConnectInput = {
  author?: InputMaybe<AnnouncementAuthorConnectFieldInput>;
  courses?: InputMaybe<Array<AnnouncementCoursesConnectFieldInput>>;
  degrees?: InputMaybe<Array<AnnouncementDegreesConnectFieldInput>>;
  notificationEvents?: InputMaybe<Array<AnnouncementNotificationEventsConnectFieldInput>>;
  nudgesAboutThis?: InputMaybe<Array<AnnouncementNudgesAboutThisConnectFieldInput>>;
  school?: InputMaybe<AnnouncementSchoolConnectFieldInput>;
  viewedBy?: InputMaybe<Array<AnnouncementViewedByConnectFieldInput>>;
};

export type AnnouncementConnectOrCreateWhere = {
  node: AnnouncementUniqueWhere;
};

export type AnnouncementConnectWhere = {
  node: AnnouncementWhere;
};

export type AnnouncementCourseCoursesAggregationSelection = {
  __typename?: 'AnnouncementCourseCoursesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AnnouncementCourseCoursesNodeAggregateSelection>;
};

export type AnnouncementCourseCoursesNodeAggregateSelection = {
  __typename?: 'AnnouncementCourseCoursesNodeAggregateSelection';
  account_id: FloatAggregateSelection;
  calendar_ics: StringAggregateSelection;
  cost: FloatAggregateSelection;
  courseId: StringAggregateSelection;
  course_code: StringAggregateSelection;
  course_id: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  default_view: StringAggregateSelection;
  description: StringAggregateSelection;
  dueDateEndDate: DateTimeAggregateSelection;
  dueDateStartDate: DateTimeAggregateSelection;
  endDate: DateTimeAggregateSelection;
  end_at: StringAggregateSelection;
  enrollment_term_id: FloatAggregateSelection;
  grading_standard_id: FloatAggregateSelection;
  id: IdAggregateSelection;
  integration_id: StringAggregateSelection;
  label: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  learningStandards: StringAggregateSelection;
  lengthInWeeks: FloatAggregateSelection;
  license: StringAggregateSelection;
  lti_id: StringAggregateSelection;
  name: StringAggregateSelection;
  original_name: StringAggregateSelection;
  root_account_id: FloatAggregateSelection;
  sis_course_id: StringAggregateSelection;
  sis_import_id: FloatAggregateSelection;
  startDate: DateTimeAggregateSelection;
  start_at: StringAggregateSelection;
  state: StringAggregateSelection;
  storage_quota_mb: FloatAggregateSelection;
  stripePriceId: StringAggregateSelection;
  stripeProductId: StringAggregateSelection;
  targetAudience: StringAggregateSelection;
  thumbnail: StringAggregateSelection;
  time_zone: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  uuid: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export type AnnouncementCoursesAggregateInput = {
  AND?: InputMaybe<Array<AnnouncementCoursesAggregateInput>>;
  NOT?: InputMaybe<AnnouncementCoursesAggregateInput>;
  OR?: InputMaybe<Array<AnnouncementCoursesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AnnouncementCoursesNodeAggregationWhereInput>;
};

export type AnnouncementCoursesConnectFieldInput = {
  connect?: InputMaybe<Array<CourseConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CourseConnectWhere>;
};

export type AnnouncementCoursesConnectOrCreateFieldInput = {
  onCreate: AnnouncementCoursesConnectOrCreateFieldInputOnCreate;
  where: CourseConnectOrCreateWhere;
};

export type AnnouncementCoursesConnectOrCreateFieldInputOnCreate = {
  node: CourseOnCreateInput;
};

export type AnnouncementCoursesConnection = {
  __typename?: 'AnnouncementCoursesConnection';
  edges: Array<AnnouncementCoursesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AnnouncementCoursesConnectionSort = {
  node?: InputMaybe<CourseSort>;
};

export type AnnouncementCoursesConnectionWhere = {
  AND?: InputMaybe<Array<AnnouncementCoursesConnectionWhere>>;
  NOT?: InputMaybe<AnnouncementCoursesConnectionWhere>;
  OR?: InputMaybe<Array<AnnouncementCoursesConnectionWhere>>;
  node?: InputMaybe<CourseWhere>;
};

export type AnnouncementCoursesCreateFieldInput = {
  node: CourseCreateInput;
};

export type AnnouncementCoursesDeleteFieldInput = {
  delete?: InputMaybe<CourseDeleteInput>;
  where?: InputMaybe<AnnouncementCoursesConnectionWhere>;
};

export type AnnouncementCoursesDisconnectFieldInput = {
  disconnect?: InputMaybe<CourseDisconnectInput>;
  where?: InputMaybe<AnnouncementCoursesConnectionWhere>;
};

export type AnnouncementCoursesFieldInput = {
  connect?: InputMaybe<Array<AnnouncementCoursesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AnnouncementCoursesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AnnouncementCoursesCreateFieldInput>>;
};

export type AnnouncementCoursesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AnnouncementCoursesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AnnouncementCoursesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AnnouncementCoursesNodeAggregationWhereInput>>;
  account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  cost_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDateEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  enrollment_term_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  label_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningStandards_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthInWeeks_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  root_account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_import_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  startDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  storage_quota_mb_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AnnouncementCoursesRelationship = {
  __typename?: 'AnnouncementCoursesRelationship';
  cursor: Scalars['String']['output'];
  node: Course;
};

export type AnnouncementCoursesUpdateConnectionInput = {
  node?: InputMaybe<CourseUpdateInput>;
};

export type AnnouncementCoursesUpdateFieldInput = {
  connect?: InputMaybe<Array<AnnouncementCoursesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AnnouncementCoursesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AnnouncementCoursesCreateFieldInput>>;
  delete?: InputMaybe<Array<AnnouncementCoursesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AnnouncementCoursesDisconnectFieldInput>>;
  update?: InputMaybe<AnnouncementCoursesUpdateConnectionInput>;
  where?: InputMaybe<AnnouncementCoursesConnectionWhere>;
};

export type AnnouncementCreateInput = {
  audienceType: AudienceType;
  author?: InputMaybe<AnnouncementAuthorFieldInput>;
  courses?: InputMaybe<AnnouncementCoursesFieldInput>;
  created: Scalars['DateTime']['input'];
  degrees?: InputMaybe<AnnouncementDegreesFieldInput>;
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified: Scalars['DateTime']['input'];
  message: Scalars['String']['input'];
  notificationEvents?: InputMaybe<AnnouncementNotificationEventsFieldInput>;
  nudgesAboutThis?: InputMaybe<AnnouncementNudgesAboutThisFieldInput>;
  school?: InputMaybe<AnnouncementSchoolFieldInput>;
  scope: AnnouncementScope;
  title: Scalars['String']['input'];
  viewedBy?: InputMaybe<AnnouncementViewedByFieldInput>;
};

export type AnnouncementDegreeDegreesAggregationSelection = {
  __typename?: 'AnnouncementDegreeDegreesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AnnouncementDegreeDegreesNodeAggregateSelection>;
};

export type AnnouncementDegreeDegreesNodeAggregateSelection = {
  __typename?: 'AnnouncementDegreeDegreesNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  id: IdAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  name: StringAggregateSelection;
};

export type AnnouncementDegreesAggregateInput = {
  AND?: InputMaybe<Array<AnnouncementDegreesAggregateInput>>;
  NOT?: InputMaybe<AnnouncementDegreesAggregateInput>;
  OR?: InputMaybe<Array<AnnouncementDegreesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AnnouncementDegreesNodeAggregationWhereInput>;
};

export type AnnouncementDegreesConnectFieldInput = {
  connect?: InputMaybe<Array<DegreeConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DegreeConnectWhere>;
};

export type AnnouncementDegreesConnectOrCreateFieldInput = {
  onCreate: AnnouncementDegreesConnectOrCreateFieldInputOnCreate;
  where: DegreeConnectOrCreateWhere;
};

export type AnnouncementDegreesConnectOrCreateFieldInputOnCreate = {
  node: DegreeOnCreateInput;
};

export type AnnouncementDegreesConnection = {
  __typename?: 'AnnouncementDegreesConnection';
  edges: Array<AnnouncementDegreesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AnnouncementDegreesConnectionSort = {
  node?: InputMaybe<DegreeSort>;
};

export type AnnouncementDegreesConnectionWhere = {
  AND?: InputMaybe<Array<AnnouncementDegreesConnectionWhere>>;
  NOT?: InputMaybe<AnnouncementDegreesConnectionWhere>;
  OR?: InputMaybe<Array<AnnouncementDegreesConnectionWhere>>;
  node?: InputMaybe<DegreeWhere>;
};

export type AnnouncementDegreesCreateFieldInput = {
  node: DegreeCreateInput;
};

export type AnnouncementDegreesDeleteFieldInput = {
  delete?: InputMaybe<DegreeDeleteInput>;
  where?: InputMaybe<AnnouncementDegreesConnectionWhere>;
};

export type AnnouncementDegreesDisconnectFieldInput = {
  disconnect?: InputMaybe<DegreeDisconnectInput>;
  where?: InputMaybe<AnnouncementDegreesConnectionWhere>;
};

export type AnnouncementDegreesFieldInput = {
  connect?: InputMaybe<Array<AnnouncementDegreesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AnnouncementDegreesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AnnouncementDegreesCreateFieldInput>>;
};

export type AnnouncementDegreesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AnnouncementDegreesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AnnouncementDegreesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AnnouncementDegreesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AnnouncementDegreesRelationship = {
  __typename?: 'AnnouncementDegreesRelationship';
  cursor: Scalars['String']['output'];
  node: Degree;
};

export type AnnouncementDegreesUpdateConnectionInput = {
  node?: InputMaybe<DegreeUpdateInput>;
};

export type AnnouncementDegreesUpdateFieldInput = {
  connect?: InputMaybe<Array<AnnouncementDegreesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AnnouncementDegreesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AnnouncementDegreesCreateFieldInput>>;
  delete?: InputMaybe<Array<AnnouncementDegreesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AnnouncementDegreesDisconnectFieldInput>>;
  update?: InputMaybe<AnnouncementDegreesUpdateConnectionInput>;
  where?: InputMaybe<AnnouncementDegreesConnectionWhere>;
};

export type AnnouncementDeleteInput = {
  author?: InputMaybe<AnnouncementAuthorDeleteFieldInput>;
  courses?: InputMaybe<Array<AnnouncementCoursesDeleteFieldInput>>;
  degrees?: InputMaybe<Array<AnnouncementDegreesDeleteFieldInput>>;
  notificationEvents?: InputMaybe<Array<AnnouncementNotificationEventsDeleteFieldInput>>;
  nudgesAboutThis?: InputMaybe<Array<AnnouncementNudgesAboutThisDeleteFieldInput>>;
  school?: InputMaybe<AnnouncementSchoolDeleteFieldInput>;
  viewedBy?: InputMaybe<Array<AnnouncementViewedByDeleteFieldInput>>;
};

export type AnnouncementDisconnectInput = {
  author?: InputMaybe<AnnouncementAuthorDisconnectFieldInput>;
  courses?: InputMaybe<Array<AnnouncementCoursesDisconnectFieldInput>>;
  degrees?: InputMaybe<Array<AnnouncementDegreesDisconnectFieldInput>>;
  notificationEvents?: InputMaybe<Array<AnnouncementNotificationEventsDisconnectFieldInput>>;
  nudgesAboutThis?: InputMaybe<Array<AnnouncementNudgesAboutThisDisconnectFieldInput>>;
  school?: InputMaybe<AnnouncementSchoolDisconnectFieldInput>;
  viewedBy?: InputMaybe<Array<AnnouncementViewedByDisconnectFieldInput>>;
};

export type AnnouncementListResponse = {
  __typename?: 'AnnouncementListResponse';
  count: Scalars['Int']['output'];
  data: Array<AnnouncementWithStatus>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AnnouncementNotificationEventNotificationEventsAggregationSelection = {
  __typename?: 'AnnouncementNotificationEventNotificationEventsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AnnouncementNotificationEventNotificationEventsNodeAggregateSelection>;
};

export type AnnouncementNotificationEventNotificationEventsNodeAggregateSelection = {
  __typename?: 'AnnouncementNotificationEventNotificationEventsNodeAggregateSelection';
  actorId: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  expirationDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  idempotencyKey: StringAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  message: StringAggregateSelection;
  schoolId: IdAggregateSelection;
  title: StringAggregateSelection;
};

export type AnnouncementNotificationEventsAggregateInput = {
  AND?: InputMaybe<Array<AnnouncementNotificationEventsAggregateInput>>;
  NOT?: InputMaybe<AnnouncementNotificationEventsAggregateInput>;
  OR?: InputMaybe<Array<AnnouncementNotificationEventsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AnnouncementNotificationEventsNodeAggregationWhereInput>;
};

export type AnnouncementNotificationEventsConnectFieldInput = {
  connect?: InputMaybe<Array<NotificationEventConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<NotificationEventConnectWhere>;
};

export type AnnouncementNotificationEventsConnectOrCreateFieldInput = {
  onCreate: AnnouncementNotificationEventsConnectOrCreateFieldInputOnCreate;
  where: NotificationEventConnectOrCreateWhere;
};

export type AnnouncementNotificationEventsConnectOrCreateFieldInputOnCreate = {
  node: NotificationEventOnCreateInput;
};

export type AnnouncementNotificationEventsConnection = {
  __typename?: 'AnnouncementNotificationEventsConnection';
  edges: Array<AnnouncementNotificationEventsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AnnouncementNotificationEventsConnectionSort = {
  node?: InputMaybe<NotificationEventSort>;
};

export type AnnouncementNotificationEventsConnectionWhere = {
  AND?: InputMaybe<Array<AnnouncementNotificationEventsConnectionWhere>>;
  NOT?: InputMaybe<AnnouncementNotificationEventsConnectionWhere>;
  OR?: InputMaybe<Array<AnnouncementNotificationEventsConnectionWhere>>;
  node?: InputMaybe<NotificationEventWhere>;
};

export type AnnouncementNotificationEventsCreateFieldInput = {
  node: NotificationEventCreateInput;
};

export type AnnouncementNotificationEventsDeleteFieldInput = {
  delete?: InputMaybe<NotificationEventDeleteInput>;
  where?: InputMaybe<AnnouncementNotificationEventsConnectionWhere>;
};

export type AnnouncementNotificationEventsDisconnectFieldInput = {
  disconnect?: InputMaybe<NotificationEventDisconnectInput>;
  where?: InputMaybe<AnnouncementNotificationEventsConnectionWhere>;
};

export type AnnouncementNotificationEventsFieldInput = {
  connect?: InputMaybe<Array<AnnouncementNotificationEventsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AnnouncementNotificationEventsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AnnouncementNotificationEventsCreateFieldInput>>;
};

export type AnnouncementNotificationEventsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AnnouncementNotificationEventsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AnnouncementNotificationEventsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AnnouncementNotificationEventsNodeAggregationWhereInput>>;
  actorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  actorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  actorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  actorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  actorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  actorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  actorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  idempotencyKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  message_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  message_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AnnouncementNotificationEventsRelationship = {
  __typename?: 'AnnouncementNotificationEventsRelationship';
  cursor: Scalars['String']['output'];
  node: NotificationEvent;
};

export type AnnouncementNotificationEventsUpdateConnectionInput = {
  node?: InputMaybe<NotificationEventUpdateInput>;
};

export type AnnouncementNotificationEventsUpdateFieldInput = {
  connect?: InputMaybe<Array<AnnouncementNotificationEventsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AnnouncementNotificationEventsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AnnouncementNotificationEventsCreateFieldInput>>;
  delete?: InputMaybe<Array<AnnouncementNotificationEventsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AnnouncementNotificationEventsDisconnectFieldInput>>;
  update?: InputMaybe<AnnouncementNotificationEventsUpdateConnectionInput>;
  where?: InputMaybe<AnnouncementNotificationEventsConnectionWhere>;
};

export type AnnouncementNudgeNudgesAboutThisAggregationSelection = {
  __typename?: 'AnnouncementNudgeNudgesAboutThisAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AnnouncementNudgeNudgesAboutThisNodeAggregateSelection>;
};

export type AnnouncementNudgeNudgesAboutThisNodeAggregateSelection = {
  __typename?: 'AnnouncementNudgeNudgesAboutThisNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  idempotencyKey: StringAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  priorityScore: FloatAggregateSelection;
  scheduledFor: DateTimeAggregateSelection;
  snoozedUntil: DateTimeAggregateSelection;
  taskCompletedAt: DateTimeAggregateSelection;
};

export type AnnouncementNudgesAboutThisAggregateInput = {
  AND?: InputMaybe<Array<AnnouncementNudgesAboutThisAggregateInput>>;
  NOT?: InputMaybe<AnnouncementNudgesAboutThisAggregateInput>;
  OR?: InputMaybe<Array<AnnouncementNudgesAboutThisAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AnnouncementNudgesAboutThisNodeAggregationWhereInput>;
};

export type AnnouncementNudgesAboutThisConnectFieldInput = {
  connect?: InputMaybe<Array<NudgeConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<NudgeConnectWhere>;
};

export type AnnouncementNudgesAboutThisConnectOrCreateFieldInput = {
  onCreate: AnnouncementNudgesAboutThisConnectOrCreateFieldInputOnCreate;
  where: NudgeConnectOrCreateWhere;
};

export type AnnouncementNudgesAboutThisConnectOrCreateFieldInputOnCreate = {
  node: NudgeOnCreateInput;
};

export type AnnouncementNudgesAboutThisConnection = {
  __typename?: 'AnnouncementNudgesAboutThisConnection';
  edges: Array<AnnouncementNudgesAboutThisRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AnnouncementNudgesAboutThisConnectionSort = {
  node?: InputMaybe<NudgeSort>;
};

export type AnnouncementNudgesAboutThisConnectionWhere = {
  AND?: InputMaybe<Array<AnnouncementNudgesAboutThisConnectionWhere>>;
  NOT?: InputMaybe<AnnouncementNudgesAboutThisConnectionWhere>;
  OR?: InputMaybe<Array<AnnouncementNudgesAboutThisConnectionWhere>>;
  node?: InputMaybe<NudgeWhere>;
};

export type AnnouncementNudgesAboutThisCreateFieldInput = {
  node: NudgeCreateInput;
};

export type AnnouncementNudgesAboutThisDeleteFieldInput = {
  delete?: InputMaybe<NudgeDeleteInput>;
  where?: InputMaybe<AnnouncementNudgesAboutThisConnectionWhere>;
};

export type AnnouncementNudgesAboutThisDisconnectFieldInput = {
  disconnect?: InputMaybe<NudgeDisconnectInput>;
  where?: InputMaybe<AnnouncementNudgesAboutThisConnectionWhere>;
};

export type AnnouncementNudgesAboutThisFieldInput = {
  connect?: InputMaybe<Array<AnnouncementNudgesAboutThisConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AnnouncementNudgesAboutThisConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AnnouncementNudgesAboutThisCreateFieldInput>>;
};

export type AnnouncementNudgesAboutThisNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AnnouncementNudgesAboutThisNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AnnouncementNudgesAboutThisNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AnnouncementNudgesAboutThisNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  idempotencyKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  priorityScore_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  scheduledFor_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnnouncementNudgesAboutThisRelationship = {
  __typename?: 'AnnouncementNudgesAboutThisRelationship';
  cursor: Scalars['String']['output'];
  node: Nudge;
};

export type AnnouncementNudgesAboutThisUpdateConnectionInput = {
  node?: InputMaybe<NudgeUpdateInput>;
};

export type AnnouncementNudgesAboutThisUpdateFieldInput = {
  connect?: InputMaybe<Array<AnnouncementNudgesAboutThisConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AnnouncementNudgesAboutThisConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AnnouncementNudgesAboutThisCreateFieldInput>>;
  delete?: InputMaybe<Array<AnnouncementNudgesAboutThisDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AnnouncementNudgesAboutThisDisconnectFieldInput>>;
  update?: InputMaybe<AnnouncementNudgesAboutThisUpdateConnectionInput>;
  where?: InputMaybe<AnnouncementNudgesAboutThisConnectionWhere>;
};

export type AnnouncementOnCreateInput = {
  audienceType: AudienceType;
  created: Scalars['DateTime']['input'];
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified: Scalars['DateTime']['input'];
  message: Scalars['String']['input'];
  scope: AnnouncementScope;
  title: Scalars['String']['input'];
};

export type AnnouncementOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AnnouncementSort objects to sort Announcements by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AnnouncementSort>>;
};

export type AnnouncementResponse = {
  __typename?: 'AnnouncementResponse';
  count: Scalars['Int']['output'];
  data?: Maybe<Announcement>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AnnouncementSchoolAggregateInput = {
  AND?: InputMaybe<Array<AnnouncementSchoolAggregateInput>>;
  NOT?: InputMaybe<AnnouncementSchoolAggregateInput>;
  OR?: InputMaybe<Array<AnnouncementSchoolAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AnnouncementSchoolNodeAggregationWhereInput>;
};

export type AnnouncementSchoolConnectFieldInput = {
  connect?: InputMaybe<SchoolConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SchoolConnectWhere>;
};

export type AnnouncementSchoolConnectOrCreateFieldInput = {
  onCreate: AnnouncementSchoolConnectOrCreateFieldInputOnCreate;
  where: SchoolConnectOrCreateWhere;
};

export type AnnouncementSchoolConnectOrCreateFieldInputOnCreate = {
  node: SchoolOnCreateInput;
};

export type AnnouncementSchoolConnection = {
  __typename?: 'AnnouncementSchoolConnection';
  edges: Array<AnnouncementSchoolRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AnnouncementSchoolConnectionSort = {
  node?: InputMaybe<SchoolSort>;
};

export type AnnouncementSchoolConnectionWhere = {
  AND?: InputMaybe<Array<AnnouncementSchoolConnectionWhere>>;
  NOT?: InputMaybe<AnnouncementSchoolConnectionWhere>;
  OR?: InputMaybe<Array<AnnouncementSchoolConnectionWhere>>;
  node?: InputMaybe<SchoolWhere>;
};

export type AnnouncementSchoolCreateFieldInput = {
  node: SchoolCreateInput;
};

export type AnnouncementSchoolDeleteFieldInput = {
  delete?: InputMaybe<SchoolDeleteInput>;
  where?: InputMaybe<AnnouncementSchoolConnectionWhere>;
};

export type AnnouncementSchoolDisconnectFieldInput = {
  disconnect?: InputMaybe<SchoolDisconnectInput>;
  where?: InputMaybe<AnnouncementSchoolConnectionWhere>;
};

export type AnnouncementSchoolFieldInput = {
  connect?: InputMaybe<AnnouncementSchoolConnectFieldInput>;
  connectOrCreate?: InputMaybe<AnnouncementSchoolConnectOrCreateFieldInput>;
  create?: InputMaybe<AnnouncementSchoolCreateFieldInput>;
};

export type AnnouncementSchoolNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AnnouncementSchoolNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AnnouncementSchoolNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AnnouncementSchoolNodeAggregationWhereInput>>;
  brightspace_api_client_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_secret_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_secret_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_secret_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_secret_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_secret_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  domain_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domain_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  provider_icon_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  provider_icon_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  provider_icon_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  provider_icon_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  provider_icon_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  provider_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  provider_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  provider_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  provider_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  provider_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  provider_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  provider_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  provider_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  provider_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  provider_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  provider_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  provider_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  provider_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  provider_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  provider_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  team_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  team_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  team_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  team_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  team_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  team_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  team_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  team_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  team_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  team_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  team_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  team_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  team_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  team_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  team_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnnouncementSchoolRelationship = {
  __typename?: 'AnnouncementSchoolRelationship';
  cursor: Scalars['String']['output'];
  node: School;
};

export type AnnouncementSchoolSchoolAggregationSelection = {
  __typename?: 'AnnouncementSchoolSchoolAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AnnouncementSchoolSchoolNodeAggregateSelection>;
};

export type AnnouncementSchoolSchoolNodeAggregateSelection = {
  __typename?: 'AnnouncementSchoolSchoolNodeAggregateSelection';
  brightspace_api_client_id: StringAggregateSelection;
  brightspace_api_client_secret: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  domain: StringAggregateSelection;
  id: IdAggregateSelection;
  provider_icon_url: StringAggregateSelection;
  provider_name: StringAggregateSelection;
  team_name: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
};

export type AnnouncementSchoolUpdateConnectionInput = {
  node?: InputMaybe<SchoolUpdateInput>;
};

export type AnnouncementSchoolUpdateFieldInput = {
  connect?: InputMaybe<AnnouncementSchoolConnectFieldInput>;
  connectOrCreate?: InputMaybe<AnnouncementSchoolConnectOrCreateFieldInput>;
  create?: InputMaybe<AnnouncementSchoolCreateFieldInput>;
  delete?: InputMaybe<AnnouncementSchoolDeleteFieldInput>;
  disconnect?: InputMaybe<AnnouncementSchoolDisconnectFieldInput>;
  update?: InputMaybe<AnnouncementSchoolUpdateConnectionInput>;
  where?: InputMaybe<AnnouncementSchoolConnectionWhere>;
};

export enum AnnouncementScope {
  School = 'SCHOOL',
  SpecificGroups = 'SPECIFIC_GROUPS'
}

/** Fields to sort Announcements by. The order in which sorts are applied is not guaranteed when specifying many fields in one AnnouncementSort object. */
export type AnnouncementSort = {
  audienceType?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  expirationDate?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastModified?: InputMaybe<SortDirection>;
  message?: InputMaybe<SortDirection>;
  scope?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
};

export type AnnouncementUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type AnnouncementUpdateInput = {
  audienceType?: InputMaybe<AudienceType>;
  author?: InputMaybe<AnnouncementAuthorUpdateFieldInput>;
  courses?: InputMaybe<Array<AnnouncementCoursesUpdateFieldInput>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  degrees?: InputMaybe<Array<AnnouncementDegreesUpdateFieldInput>>;
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  notificationEvents?: InputMaybe<Array<AnnouncementNotificationEventsUpdateFieldInput>>;
  nudgesAboutThis?: InputMaybe<Array<AnnouncementNudgesAboutThisUpdateFieldInput>>;
  school?: InputMaybe<AnnouncementSchoolUpdateFieldInput>;
  scope?: InputMaybe<AnnouncementScope>;
  title?: InputMaybe<Scalars['String']['input']>;
  viewedBy?: InputMaybe<Array<AnnouncementViewedByUpdateFieldInput>>;
};

export type AnnouncementUserAuthorAggregationSelection = {
  __typename?: 'AnnouncementUserAuthorAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AnnouncementUserAuthorNodeAggregateSelection>;
};

export type AnnouncementUserAuthorNodeAggregateSelection = {
  __typename?: 'AnnouncementUserAuthorNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type AnnouncementUserViewedByAggregationSelection = {
  __typename?: 'AnnouncementUserViewedByAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AnnouncementUserViewedByNodeAggregateSelection>;
};

export type AnnouncementUserViewedByNodeAggregateSelection = {
  __typename?: 'AnnouncementUserViewedByNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type AnnouncementViewedByAggregateInput = {
  AND?: InputMaybe<Array<AnnouncementViewedByAggregateInput>>;
  NOT?: InputMaybe<AnnouncementViewedByAggregateInput>;
  OR?: InputMaybe<Array<AnnouncementViewedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AnnouncementViewedByNodeAggregationWhereInput>;
};

export type AnnouncementViewedByConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type AnnouncementViewedByConnectOrCreateFieldInput = {
  onCreate: AnnouncementViewedByConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type AnnouncementViewedByConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type AnnouncementViewedByConnection = {
  __typename?: 'AnnouncementViewedByConnection';
  edges: Array<AnnouncementViewedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AnnouncementViewedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type AnnouncementViewedByConnectionWhere = {
  AND?: InputMaybe<Array<AnnouncementViewedByConnectionWhere>>;
  NOT?: InputMaybe<AnnouncementViewedByConnectionWhere>;
  OR?: InputMaybe<Array<AnnouncementViewedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type AnnouncementViewedByCreateFieldInput = {
  node: UserCreateInput;
};

export type AnnouncementViewedByDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<AnnouncementViewedByConnectionWhere>;
};

export type AnnouncementViewedByDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<AnnouncementViewedByConnectionWhere>;
};

export type AnnouncementViewedByFieldInput = {
  connect?: InputMaybe<Array<AnnouncementViewedByConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AnnouncementViewedByConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AnnouncementViewedByCreateFieldInput>>;
};

export type AnnouncementViewedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AnnouncementViewedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AnnouncementViewedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AnnouncementViewedByNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AnnouncementViewedByRelationship = {
  __typename?: 'AnnouncementViewedByRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type AnnouncementViewedByUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type AnnouncementViewedByUpdateFieldInput = {
  connect?: InputMaybe<Array<AnnouncementViewedByConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AnnouncementViewedByConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AnnouncementViewedByCreateFieldInput>>;
  delete?: InputMaybe<Array<AnnouncementViewedByDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AnnouncementViewedByDisconnectFieldInput>>;
  update?: InputMaybe<AnnouncementViewedByUpdateConnectionInput>;
  where?: InputMaybe<AnnouncementViewedByConnectionWhere>;
};

export type AnnouncementWhere = {
  AND?: InputMaybe<Array<AnnouncementWhere>>;
  NOT?: InputMaybe<AnnouncementWhere>;
  OR?: InputMaybe<Array<AnnouncementWhere>>;
  audienceType?: InputMaybe<AudienceType>;
  audienceType_IN?: InputMaybe<Array<AudienceType>>;
  author?: InputMaybe<UserWhere>;
  authorAggregate?: InputMaybe<AnnouncementAuthorAggregateInput>;
  authorConnection?: InputMaybe<AnnouncementAuthorConnectionWhere>;
  authorConnection_NOT?: InputMaybe<AnnouncementAuthorConnectionWhere>;
  author_NOT?: InputMaybe<UserWhere>;
  coursesAggregate?: InputMaybe<AnnouncementCoursesAggregateInput>;
  /** Return Announcements where all of the related AnnouncementCoursesConnections match this filter */
  coursesConnection_ALL?: InputMaybe<AnnouncementCoursesConnectionWhere>;
  /** Return Announcements where none of the related AnnouncementCoursesConnections match this filter */
  coursesConnection_NONE?: InputMaybe<AnnouncementCoursesConnectionWhere>;
  /** Return Announcements where one of the related AnnouncementCoursesConnections match this filter */
  coursesConnection_SINGLE?: InputMaybe<AnnouncementCoursesConnectionWhere>;
  /** Return Announcements where some of the related AnnouncementCoursesConnections match this filter */
  coursesConnection_SOME?: InputMaybe<AnnouncementCoursesConnectionWhere>;
  /** Return Announcements where all of the related Courses match this filter */
  courses_ALL?: InputMaybe<CourseWhere>;
  /** Return Announcements where none of the related Courses match this filter */
  courses_NONE?: InputMaybe<CourseWhere>;
  /** Return Announcements where one of the related Courses match this filter */
  courses_SINGLE?: InputMaybe<CourseWhere>;
  /** Return Announcements where some of the related Courses match this filter */
  courses_SOME?: InputMaybe<CourseWhere>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  degreesAggregate?: InputMaybe<AnnouncementDegreesAggregateInput>;
  /** Return Announcements where all of the related AnnouncementDegreesConnections match this filter */
  degreesConnection_ALL?: InputMaybe<AnnouncementDegreesConnectionWhere>;
  /** Return Announcements where none of the related AnnouncementDegreesConnections match this filter */
  degreesConnection_NONE?: InputMaybe<AnnouncementDegreesConnectionWhere>;
  /** Return Announcements where one of the related AnnouncementDegreesConnections match this filter */
  degreesConnection_SINGLE?: InputMaybe<AnnouncementDegreesConnectionWhere>;
  /** Return Announcements where some of the related AnnouncementDegreesConnections match this filter */
  degreesConnection_SOME?: InputMaybe<AnnouncementDegreesConnectionWhere>;
  /** Return Announcements where all of the related Degrees match this filter */
  degrees_ALL?: InputMaybe<DegreeWhere>;
  /** Return Announcements where none of the related Degrees match this filter */
  degrees_NONE?: InputMaybe<DegreeWhere>;
  /** Return Announcements where one of the related Degrees match this filter */
  degrees_SINGLE?: InputMaybe<DegreeWhere>;
  /** Return Announcements where some of the related Degrees match this filter */
  degrees_SOME?: InputMaybe<DegreeWhere>;
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  expirationDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lastModified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  message_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  message_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  message_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  message_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  notificationEventsAggregate?: InputMaybe<AnnouncementNotificationEventsAggregateInput>;
  /** Return Announcements where all of the related AnnouncementNotificationEventsConnections match this filter */
  notificationEventsConnection_ALL?: InputMaybe<AnnouncementNotificationEventsConnectionWhere>;
  /** Return Announcements where none of the related AnnouncementNotificationEventsConnections match this filter */
  notificationEventsConnection_NONE?: InputMaybe<AnnouncementNotificationEventsConnectionWhere>;
  /** Return Announcements where one of the related AnnouncementNotificationEventsConnections match this filter */
  notificationEventsConnection_SINGLE?: InputMaybe<AnnouncementNotificationEventsConnectionWhere>;
  /** Return Announcements where some of the related AnnouncementNotificationEventsConnections match this filter */
  notificationEventsConnection_SOME?: InputMaybe<AnnouncementNotificationEventsConnectionWhere>;
  /** Return Announcements where all of the related NotificationEvents match this filter */
  notificationEvents_ALL?: InputMaybe<NotificationEventWhere>;
  /** Return Announcements where none of the related NotificationEvents match this filter */
  notificationEvents_NONE?: InputMaybe<NotificationEventWhere>;
  /** Return Announcements where one of the related NotificationEvents match this filter */
  notificationEvents_SINGLE?: InputMaybe<NotificationEventWhere>;
  /** Return Announcements where some of the related NotificationEvents match this filter */
  notificationEvents_SOME?: InputMaybe<NotificationEventWhere>;
  nudgesAboutThisAggregate?: InputMaybe<AnnouncementNudgesAboutThisAggregateInput>;
  /** Return Announcements where all of the related AnnouncementNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_ALL?: InputMaybe<AnnouncementNudgesAboutThisConnectionWhere>;
  /** Return Announcements where none of the related AnnouncementNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_NONE?: InputMaybe<AnnouncementNudgesAboutThisConnectionWhere>;
  /** Return Announcements where one of the related AnnouncementNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_SINGLE?: InputMaybe<AnnouncementNudgesAboutThisConnectionWhere>;
  /** Return Announcements where some of the related AnnouncementNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_SOME?: InputMaybe<AnnouncementNudgesAboutThisConnectionWhere>;
  /** Return Announcements where all of the related Nudges match this filter */
  nudgesAboutThis_ALL?: InputMaybe<NudgeWhere>;
  /** Return Announcements where none of the related Nudges match this filter */
  nudgesAboutThis_NONE?: InputMaybe<NudgeWhere>;
  /** Return Announcements where one of the related Nudges match this filter */
  nudgesAboutThis_SINGLE?: InputMaybe<NudgeWhere>;
  /** Return Announcements where some of the related Nudges match this filter */
  nudgesAboutThis_SOME?: InputMaybe<NudgeWhere>;
  school?: InputMaybe<SchoolWhere>;
  schoolAggregate?: InputMaybe<AnnouncementSchoolAggregateInput>;
  schoolConnection?: InputMaybe<AnnouncementSchoolConnectionWhere>;
  schoolConnection_NOT?: InputMaybe<AnnouncementSchoolConnectionWhere>;
  school_NOT?: InputMaybe<SchoolWhere>;
  scope?: InputMaybe<AnnouncementScope>;
  scope_IN?: InputMaybe<Array<AnnouncementScope>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewedByAggregate?: InputMaybe<AnnouncementViewedByAggregateInput>;
  /** Return Announcements where all of the related AnnouncementViewedByConnections match this filter */
  viewedByConnection_ALL?: InputMaybe<AnnouncementViewedByConnectionWhere>;
  /** Return Announcements where none of the related AnnouncementViewedByConnections match this filter */
  viewedByConnection_NONE?: InputMaybe<AnnouncementViewedByConnectionWhere>;
  /** Return Announcements where one of the related AnnouncementViewedByConnections match this filter */
  viewedByConnection_SINGLE?: InputMaybe<AnnouncementViewedByConnectionWhere>;
  /** Return Announcements where some of the related AnnouncementViewedByConnections match this filter */
  viewedByConnection_SOME?: InputMaybe<AnnouncementViewedByConnectionWhere>;
  /** Return Announcements where all of the related Users match this filter */
  viewedBy_ALL?: InputMaybe<UserWhere>;
  /** Return Announcements where none of the related Users match this filter */
  viewedBy_NONE?: InputMaybe<UserWhere>;
  /** Return Announcements where one of the related Users match this filter */
  viewedBy_SINGLE?: InputMaybe<UserWhere>;
  /** Return Announcements where some of the related Users match this filter */
  viewedBy_SOME?: InputMaybe<UserWhere>;
};

export type AnnouncementWithStatus = {
  __typename?: 'AnnouncementWithStatus';
  audienceType: AudienceType;
  author: User;
  courses: Array<Course>;
  created: Scalars['DateTime']['output'];
  degrees: Array<Degree>;
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isNew?: Maybe<Scalars['Boolean']['output']>;
  lastModified: Scalars['DateTime']['output'];
  message: Scalars['String']['output'];
  school?: Maybe<School>;
  title: Scalars['String']['output'];
};

export type ArtifactBlock = {
  __typename?: 'ArtifactBlock';
  assignment?: Maybe<Assignment>;
  assignmentAggregate?: Maybe<ArtifactBlockAssignmentAssignmentAggregationSelection>;
  assignmentConnection: ArtifactBlockAssignmentConnection;
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  message: Message;
  messageAggregate?: Maybe<ArtifactBlockMessageMessageAggregationSelection>;
  messageConnection: ArtifactBlockMessageConnection;
  todo?: Maybe<Todo>;
  todoAggregate?: Maybe<ArtifactBlockTodoTodoAggregationSelection>;
  todoConnection: ArtifactBlockTodoConnection;
  type: BlockType;
};


export type ArtifactBlockAssignmentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AssignmentOptions>;
  where?: InputMaybe<AssignmentWhere>;
};


export type ArtifactBlockAssignmentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssignmentWhere>;
};


export type ArtifactBlockAssignmentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ArtifactBlockAssignmentConnectionSort>>;
  where?: InputMaybe<ArtifactBlockAssignmentConnectionWhere>;
};


export type ArtifactBlockMessageArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<MessageOptions>;
  where?: InputMaybe<MessageWhere>;
};


export type ArtifactBlockMessageAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MessageWhere>;
};


export type ArtifactBlockMessageConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ArtifactBlockMessageConnectionSort>>;
  where?: InputMaybe<ArtifactBlockMessageConnectionWhere>;
};


export type ArtifactBlockTodoArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TodoOptions>;
  where?: InputMaybe<TodoWhere>;
};


export type ArtifactBlockTodoAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TodoWhere>;
};


export type ArtifactBlockTodoConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ArtifactBlockTodoConnectionSort>>;
  where?: InputMaybe<ArtifactBlockTodoConnectionWhere>;
};

export type ArtifactBlockAssignmentAggregateInput = {
  AND?: InputMaybe<Array<ArtifactBlockAssignmentAggregateInput>>;
  NOT?: InputMaybe<ArtifactBlockAssignmentAggregateInput>;
  OR?: InputMaybe<Array<ArtifactBlockAssignmentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ArtifactBlockAssignmentNodeAggregationWhereInput>;
};

export type ArtifactBlockAssignmentAssignmentAggregationSelection = {
  __typename?: 'ArtifactBlockAssignmentAssignmentAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ArtifactBlockAssignmentAssignmentNodeAggregateSelection>;
};

export type ArtifactBlockAssignmentAssignmentNodeAggregateSelection = {
  __typename?: 'ArtifactBlockAssignmentAssignmentNodeAggregateSelection';
  _empty: StringAggregateSelection;
  allowed_attempts: FloatAggregateSelection;
  assignee_mode: StringAggregateSelection;
  assignment_group_id: FloatAggregateSelection;
  assignment_name: StringAggregateSelection;
  body: StringAggregateSelection;
  category_id: StringAggregateSelection;
  course_id: FloatAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  description: StringAggregateSelection;
  description_plaintext: StringAggregateSelection;
  discussion_topic_assignment_id: FloatAggregateSelection;
  discussion_topic_author_anonymous_id: StringAggregateSelection;
  discussion_topic_author_avatar_image_url: StringAggregateSelection;
  discussion_topic_author_display_name: StringAggregateSelection;
  discussion_topic_author_html_url: StringAggregateSelection;
  discussion_topic_author_id: FloatAggregateSelection;
  discussion_topic_created_at: StringAggregateSelection;
  discussion_topic_discussion_subentry_count: FloatAggregateSelection;
  discussion_topic_discussion_type: StringAggregateSelection;
  discussion_topic_html_url: StringAggregateSelection;
  discussion_topic_id: FloatAggregateSelection;
  discussion_topic_last_reply_at: StringAggregateSelection;
  discussion_topic_message: StringAggregateSelection;
  discussion_topic_posted_at: StringAggregateSelection;
  discussion_topic_read_state: StringAggregateSelection;
  discussion_topic_title: StringAggregateSelection;
  discussion_topic_unread_count: FloatAggregateSelection;
  discussion_topic_url: StringAggregateSelection;
  discussion_topic_user_name: StringAggregateSelection;
  display_date: StringAggregateSelection;
  due_at: StringAggregateSelection;
  due_date: DateTimeAggregateSelection;
  end_date: StringAggregateSelection;
  external_tool_tag_attributes_content_id: FloatAggregateSelection;
  external_tool_tag_attributes_content_type: StringAggregateSelection;
  external_tool_tag_attributes_external_data: StringAggregateSelection;
  external_tool_tag_attributes_resource_link_id: StringAggregateSelection;
  external_tool_tag_attributes_url: StringAggregateSelection;
  grade_points: FloatAggregateSelection;
  grader_count: FloatAggregateSelection;
  grading_type: StringAggregateSelection;
  html: StringAggregateSelection;
  html_url: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  lti_context_id: StringAggregateSelection;
  max_attempts: FloatAggregateSelection;
  max_name_length: FloatAggregateSelection;
  name: StringAggregateSelection;
  needs_grading_count: FloatAggregateSelection;
  objectives: StringAggregateSelection;
  points_possible: FloatAggregateSelection;
  position: FloatAggregateSelection;
  resource_metadata: StringAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  secure_params: StringAggregateSelection;
  session_id: StringAggregateSelection;
  start_date: StringAggregateSelection;
  state: StringAggregateSelection;
  submissions_download_url: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_at: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  url: StringAggregateSelection;
  videoUrl: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export type ArtifactBlockAssignmentConnectFieldInput = {
  connect?: InputMaybe<AssignmentConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AssignmentConnectWhere>;
};

export type ArtifactBlockAssignmentConnectOrCreateFieldInput = {
  onCreate: ArtifactBlockAssignmentConnectOrCreateFieldInputOnCreate;
  where: AssignmentConnectOrCreateWhere;
};

export type ArtifactBlockAssignmentConnectOrCreateFieldInputOnCreate = {
  node: AssignmentOnCreateInput;
};

export type ArtifactBlockAssignmentConnection = {
  __typename?: 'ArtifactBlockAssignmentConnection';
  edges: Array<ArtifactBlockAssignmentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ArtifactBlockAssignmentConnectionSort = {
  node?: InputMaybe<AssignmentSort>;
};

export type ArtifactBlockAssignmentConnectionWhere = {
  AND?: InputMaybe<Array<ArtifactBlockAssignmentConnectionWhere>>;
  NOT?: InputMaybe<ArtifactBlockAssignmentConnectionWhere>;
  OR?: InputMaybe<Array<ArtifactBlockAssignmentConnectionWhere>>;
  node?: InputMaybe<AssignmentWhere>;
};

export type ArtifactBlockAssignmentCreateFieldInput = {
  node: AssignmentCreateInput;
};

export type ArtifactBlockAssignmentDeleteFieldInput = {
  delete?: InputMaybe<AssignmentDeleteInput>;
  where?: InputMaybe<ArtifactBlockAssignmentConnectionWhere>;
};

export type ArtifactBlockAssignmentDisconnectFieldInput = {
  disconnect?: InputMaybe<AssignmentDisconnectInput>;
  where?: InputMaybe<ArtifactBlockAssignmentConnectionWhere>;
};

export type ArtifactBlockAssignmentFieldInput = {
  connect?: InputMaybe<ArtifactBlockAssignmentConnectFieldInput>;
  connectOrCreate?: InputMaybe<ArtifactBlockAssignmentConnectOrCreateFieldInput>;
  create?: InputMaybe<ArtifactBlockAssignmentCreateFieldInput>;
};

export type ArtifactBlockAssignmentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ArtifactBlockAssignmentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ArtifactBlockAssignmentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ArtifactBlockAssignmentNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  allowed_attempts_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_group_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  body_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  category_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_assignment_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_unread_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  display_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  due_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_date_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_points_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  html_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lti_context_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  max_attempts_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  needs_grading_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  points_possible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  secure_params_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  secure_params_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  session_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ArtifactBlockAssignmentRelationship = {
  __typename?: 'ArtifactBlockAssignmentRelationship';
  cursor: Scalars['String']['output'];
  node: Assignment;
};

export type ArtifactBlockAssignmentUpdateConnectionInput = {
  node?: InputMaybe<AssignmentUpdateInput>;
};

export type ArtifactBlockAssignmentUpdateFieldInput = {
  connect?: InputMaybe<ArtifactBlockAssignmentConnectFieldInput>;
  connectOrCreate?: InputMaybe<ArtifactBlockAssignmentConnectOrCreateFieldInput>;
  create?: InputMaybe<ArtifactBlockAssignmentCreateFieldInput>;
  delete?: InputMaybe<ArtifactBlockAssignmentDeleteFieldInput>;
  disconnect?: InputMaybe<ArtifactBlockAssignmentDisconnectFieldInput>;
  update?: InputMaybe<ArtifactBlockAssignmentUpdateConnectionInput>;
  where?: InputMaybe<ArtifactBlockAssignmentConnectionWhere>;
};

export type ArtifactBlockConnectInput = {
  assignment?: InputMaybe<ArtifactBlockAssignmentConnectFieldInput>;
  message?: InputMaybe<ArtifactBlockMessageConnectFieldInput>;
  todo?: InputMaybe<ArtifactBlockTodoConnectFieldInput>;
};

export type ArtifactBlockConnectOrCreateWhere = {
  node: ArtifactBlockUniqueWhere;
};

export type ArtifactBlockConnectWhere = {
  node: ArtifactBlockWhere;
};

export type ArtifactBlockCreateInput = {
  assignment?: InputMaybe<ArtifactBlockAssignmentFieldInput>;
  created: Scalars['DateTime']['input'];
  message?: InputMaybe<ArtifactBlockMessageFieldInput>;
  todo?: InputMaybe<ArtifactBlockTodoFieldInput>;
  type: BlockType;
};

export type ArtifactBlockDeleteInput = {
  assignment?: InputMaybe<ArtifactBlockAssignmentDeleteFieldInput>;
  message?: InputMaybe<ArtifactBlockMessageDeleteFieldInput>;
  todo?: InputMaybe<ArtifactBlockTodoDeleteFieldInput>;
};

export type ArtifactBlockDisconnectInput = {
  assignment?: InputMaybe<ArtifactBlockAssignmentDisconnectFieldInput>;
  message?: InputMaybe<ArtifactBlockMessageDisconnectFieldInput>;
  todo?: InputMaybe<ArtifactBlockTodoDisconnectFieldInput>;
};

export type ArtifactBlockMessageAggregateInput = {
  AND?: InputMaybe<Array<ArtifactBlockMessageAggregateInput>>;
  NOT?: InputMaybe<ArtifactBlockMessageAggregateInput>;
  OR?: InputMaybe<Array<ArtifactBlockMessageAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasBlockPropertiesAggregationWhereInput>;
  node?: InputMaybe<ArtifactBlockMessageNodeAggregationWhereInput>;
};

export type ArtifactBlockMessageConnectFieldInput = {
  connect?: InputMaybe<MessageConnectInput>;
  edge: HasBlockPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<MessageConnectWhere>;
};

export type ArtifactBlockMessageConnectOrCreateFieldInput = {
  onCreate: ArtifactBlockMessageConnectOrCreateFieldInputOnCreate;
  where: MessageConnectOrCreateWhere;
};

export type ArtifactBlockMessageConnectOrCreateFieldInputOnCreate = {
  edge: HasBlockPropertiesCreateInput;
  node: MessageOnCreateInput;
};

export type ArtifactBlockMessageConnection = {
  __typename?: 'ArtifactBlockMessageConnection';
  edges: Array<ArtifactBlockMessageRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ArtifactBlockMessageConnectionSort = {
  edge?: InputMaybe<HasBlockPropertiesSort>;
  node?: InputMaybe<MessageSort>;
};

export type ArtifactBlockMessageConnectionWhere = {
  AND?: InputMaybe<Array<ArtifactBlockMessageConnectionWhere>>;
  NOT?: InputMaybe<ArtifactBlockMessageConnectionWhere>;
  OR?: InputMaybe<Array<ArtifactBlockMessageConnectionWhere>>;
  edge?: InputMaybe<HasBlockPropertiesWhere>;
  node?: InputMaybe<MessageWhere>;
};

export type ArtifactBlockMessageCreateFieldInput = {
  edge: HasBlockPropertiesCreateInput;
  node: MessageCreateInput;
};

export type ArtifactBlockMessageDeleteFieldInput = {
  delete?: InputMaybe<MessageDeleteInput>;
  where?: InputMaybe<ArtifactBlockMessageConnectionWhere>;
};

export type ArtifactBlockMessageDisconnectFieldInput = {
  disconnect?: InputMaybe<MessageDisconnectInput>;
  where?: InputMaybe<ArtifactBlockMessageConnectionWhere>;
};

export type ArtifactBlockMessageFieldInput = {
  connect?: InputMaybe<ArtifactBlockMessageConnectFieldInput>;
  connectOrCreate?: InputMaybe<ArtifactBlockMessageConnectOrCreateFieldInput>;
  create?: InputMaybe<ArtifactBlockMessageCreateFieldInput>;
};

export type ArtifactBlockMessageMessageAggregationSelection = {
  __typename?: 'ArtifactBlockMessageMessageAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<ArtifactBlockMessageMessageEdgeAggregateSelection>;
  node?: Maybe<ArtifactBlockMessageMessageNodeAggregateSelection>;
};

export type ArtifactBlockMessageMessageEdgeAggregateSelection = {
  __typename?: 'ArtifactBlockMessageMessageEdgeAggregateSelection';
  created: DateTimeAggregateSelection;
  index: IntAggregateSelection;
};

export type ArtifactBlockMessageMessageNodeAggregateSelection = {
  __typename?: 'ArtifactBlockMessageMessageNodeAggregateSelection';
  aspectDetails: StringAggregateSelection;
  content: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  emotion: StringAggregateSelection;
  id: IdAggregateSelection;
  index: IntAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  nodeId: StringAggregateSelection;
  parameters: StringAggregateSelection;
  sender: StringAggregateSelection;
  snackType: StringAggregateSelection;
  type: StringAggregateSelection;
};

export type ArtifactBlockMessageNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ArtifactBlockMessageNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ArtifactBlockMessageNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ArtifactBlockMessageNodeAggregationWhereInput>>;
  aspectDetails_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  content_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  content_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  emotion_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emotion_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emotion_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emotion_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emotion_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emotion_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emotion_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emotion_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emotion_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emotion_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  index_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  index_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  nodeId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nodeId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  nodeId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  nodeId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  nodeId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  nodeId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nodeId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nodeId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nodeId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nodeId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  parameters_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  parameters_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  parameters_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  parameters_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  parameters_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  parameters_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  parameters_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  parameters_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  parameters_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  parameters_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  snackType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  snackType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  snackType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  snackType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  snackType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  snackType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  snackType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  snackType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  snackType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  snackType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ArtifactBlockMessageRelationship = {
  __typename?: 'ArtifactBlockMessageRelationship';
  cursor: Scalars['String']['output'];
  node: Message;
  properties: HasBlockProperties;
};

export type ArtifactBlockMessageUpdateConnectionInput = {
  edge?: InputMaybe<HasBlockPropertiesUpdateInput>;
  node?: InputMaybe<MessageUpdateInput>;
};

export type ArtifactBlockMessageUpdateFieldInput = {
  connect?: InputMaybe<ArtifactBlockMessageConnectFieldInput>;
  connectOrCreate?: InputMaybe<ArtifactBlockMessageConnectOrCreateFieldInput>;
  create?: InputMaybe<ArtifactBlockMessageCreateFieldInput>;
  delete?: InputMaybe<ArtifactBlockMessageDeleteFieldInput>;
  disconnect?: InputMaybe<ArtifactBlockMessageDisconnectFieldInput>;
  update?: InputMaybe<ArtifactBlockMessageUpdateConnectionInput>;
  where?: InputMaybe<ArtifactBlockMessageConnectionWhere>;
};

export type ArtifactBlockOnCreateInput = {
  created: Scalars['DateTime']['input'];
  type: BlockType;
};

export type ArtifactBlockOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ArtifactBlockSort objects to sort ArtifactBlocks by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ArtifactBlockSort>>;
};

/** Fields to sort ArtifactBlocks by. The order in which sorts are applied is not guaranteed when specifying many fields in one ArtifactBlockSort object. */
export type ArtifactBlockSort = {
  created?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export type ArtifactBlockTodoAggregateInput = {
  AND?: InputMaybe<Array<ArtifactBlockTodoAggregateInput>>;
  NOT?: InputMaybe<ArtifactBlockTodoAggregateInput>;
  OR?: InputMaybe<Array<ArtifactBlockTodoAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ArtifactBlockTodoNodeAggregationWhereInput>;
};

export type ArtifactBlockTodoConnectFieldInput = {
  connect?: InputMaybe<TodoConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TodoConnectWhere>;
};

export type ArtifactBlockTodoConnectOrCreateFieldInput = {
  onCreate: ArtifactBlockTodoConnectOrCreateFieldInputOnCreate;
  where: TodoConnectOrCreateWhere;
};

export type ArtifactBlockTodoConnectOrCreateFieldInputOnCreate = {
  node: TodoOnCreateInput;
};

export type ArtifactBlockTodoConnection = {
  __typename?: 'ArtifactBlockTodoConnection';
  edges: Array<ArtifactBlockTodoRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ArtifactBlockTodoConnectionSort = {
  node?: InputMaybe<TodoSort>;
};

export type ArtifactBlockTodoConnectionWhere = {
  AND?: InputMaybe<Array<ArtifactBlockTodoConnectionWhere>>;
  NOT?: InputMaybe<ArtifactBlockTodoConnectionWhere>;
  OR?: InputMaybe<Array<ArtifactBlockTodoConnectionWhere>>;
  node?: InputMaybe<TodoWhere>;
};

export type ArtifactBlockTodoCreateFieldInput = {
  node: TodoCreateInput;
};

export type ArtifactBlockTodoDeleteFieldInput = {
  delete?: InputMaybe<TodoDeleteInput>;
  where?: InputMaybe<ArtifactBlockTodoConnectionWhere>;
};

export type ArtifactBlockTodoDisconnectFieldInput = {
  disconnect?: InputMaybe<TodoDisconnectInput>;
  where?: InputMaybe<ArtifactBlockTodoConnectionWhere>;
};

export type ArtifactBlockTodoFieldInput = {
  connect?: InputMaybe<ArtifactBlockTodoConnectFieldInput>;
  connectOrCreate?: InputMaybe<ArtifactBlockTodoConnectOrCreateFieldInput>;
  create?: InputMaybe<ArtifactBlockTodoCreateFieldInput>;
};

export type ArtifactBlockTodoNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ArtifactBlockTodoNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ArtifactBlockTodoNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ArtifactBlockTodoNodeAggregationWhereInput>>;
  aiSummary_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiSummary_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aiSummary_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiSummary_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aiSummary_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aiSummary_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aiSummary_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aiSummary_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aiSummary_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aiSummary_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aiSummary_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aiSummary_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aiSummary_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aiSummary_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aiSummary_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  completed_date_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completed_date_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completed_date_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completed_date_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completed_date_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  completed_date_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completed_date_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completed_date_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completed_date_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completed_date_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsReceived_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsReceived_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsReceived_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsReceived_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsReceived_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  priority_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priority_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  priority_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  priority_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  priority_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  priority_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  priority_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  priority_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  priority_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  priority_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  priority_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  priority_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  priority_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  priority_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  priority_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  recurringDayOfMonth_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  recurringDayOfMonth_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  recurringDayOfMonth_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  recurringDayOfMonth_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  recurringDayOfMonth_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  recurringDayOfWeek_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  recurringDayOfWeek_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  recurringDayOfWeek_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  recurringDayOfWeek_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  recurringDayOfWeek_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  recurringFrequency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  recurringFrequency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  recurringFrequency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  recurringFrequency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  recurringFrequency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  recurringFrequency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recurringFrequency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  recurringFrequency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  recurringFrequency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  recurringFrequency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  recurringFrequency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recurringFrequency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  recurringFrequency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  recurringFrequency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  recurringFrequency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  recurringTime_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  recurringTime_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  recurringTime_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  recurringTime_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  recurringTime_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  recurringTime_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recurringTime_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  recurringTime_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  recurringTime_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  recurringTime_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  recurringTime_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recurringTime_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  recurringTime_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  recurringTime_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  recurringTime_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeOfDay_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timeOfDay_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeOfDay_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timeOfDay_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeOfDay_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ArtifactBlockTodoRelationship = {
  __typename?: 'ArtifactBlockTodoRelationship';
  cursor: Scalars['String']['output'];
  node: Todo;
};

export type ArtifactBlockTodoTodoAggregationSelection = {
  __typename?: 'ArtifactBlockTodoTodoAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ArtifactBlockTodoTodoNodeAggregateSelection>;
};

export type ArtifactBlockTodoTodoNodeAggregateSelection = {
  __typename?: 'ArtifactBlockTodoTodoNodeAggregateSelection';
  aiSummary: StringAggregateSelection;
  completed_date: DateTimeAggregateSelection;
  created: DateTimeAggregateSelection;
  date: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  id: IdAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  name: StringAggregateSelection;
  pointsReceived: IntAggregateSelection;
  priority: StringAggregateSelection;
  recurringDayOfMonth: IntAggregateSelection;
  recurringDayOfWeek: StringAggregateSelection;
  recurringFrequency: StringAggregateSelection;
  recurringTime: StringAggregateSelection;
  timeOfDay: StringAggregateSelection;
  timezone: StringAggregateSelection;
};

export type ArtifactBlockTodoUpdateConnectionInput = {
  node?: InputMaybe<TodoUpdateInput>;
};

export type ArtifactBlockTodoUpdateFieldInput = {
  connect?: InputMaybe<ArtifactBlockTodoConnectFieldInput>;
  connectOrCreate?: InputMaybe<ArtifactBlockTodoConnectOrCreateFieldInput>;
  create?: InputMaybe<ArtifactBlockTodoCreateFieldInput>;
  delete?: InputMaybe<ArtifactBlockTodoDeleteFieldInput>;
  disconnect?: InputMaybe<ArtifactBlockTodoDisconnectFieldInput>;
  update?: InputMaybe<ArtifactBlockTodoUpdateConnectionInput>;
  where?: InputMaybe<ArtifactBlockTodoConnectionWhere>;
};

export type ArtifactBlockUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ArtifactBlockUpdateInput = {
  assignment?: InputMaybe<ArtifactBlockAssignmentUpdateFieldInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  message?: InputMaybe<ArtifactBlockMessageUpdateFieldInput>;
  todo?: InputMaybe<ArtifactBlockTodoUpdateFieldInput>;
  type?: InputMaybe<BlockType>;
};

export type ArtifactBlockWhere = {
  AND?: InputMaybe<Array<ArtifactBlockWhere>>;
  NOT?: InputMaybe<ArtifactBlockWhere>;
  OR?: InputMaybe<Array<ArtifactBlockWhere>>;
  assignment?: InputMaybe<AssignmentWhere>;
  assignmentAggregate?: InputMaybe<ArtifactBlockAssignmentAggregateInput>;
  assignmentConnection?: InputMaybe<ArtifactBlockAssignmentConnectionWhere>;
  assignmentConnection_NOT?: InputMaybe<ArtifactBlockAssignmentConnectionWhere>;
  assignment_NOT?: InputMaybe<AssignmentWhere>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  message?: InputMaybe<MessageWhere>;
  messageAggregate?: InputMaybe<ArtifactBlockMessageAggregateInput>;
  messageConnection?: InputMaybe<ArtifactBlockMessageConnectionWhere>;
  messageConnection_NOT?: InputMaybe<ArtifactBlockMessageConnectionWhere>;
  message_NOT?: InputMaybe<MessageWhere>;
  todo?: InputMaybe<TodoWhere>;
  todoAggregate?: InputMaybe<ArtifactBlockTodoAggregateInput>;
  todoConnection?: InputMaybe<ArtifactBlockTodoConnectionWhere>;
  todoConnection_NOT?: InputMaybe<ArtifactBlockTodoConnectionWhere>;
  todo_NOT?: InputMaybe<TodoWhere>;
  type?: InputMaybe<BlockType>;
  type_IN?: InputMaybe<Array<BlockType>>;
};

export type AspectDetailsType = {
  __typename?: 'AspectDetailsType';
  calories?: Maybe<Scalars['Float']['output']>;
  carbohydrates_grams?: Maybe<Scalars['Float']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  communicationChannel?: Maybe<Scalars['String']['output']>;
  completionStatus?: Maybe<Scalars['String']['output']>;
  connectionStrength?: Maybe<Scalars['Int']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  context?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  deadline?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  fat_grams?: Maybe<Scalars['Float']['output']>;
  fiber_grams?: Maybe<Scalars['Float']['output']>;
  frequencyOfInteraction?: Maybe<Scalars['String']['output']>;
  friendId?: Maybe<Scalars['Int']['output']>;
  friendPersonalityTraits?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['Int']['output']>;
  importance?: Maybe<Scalars['Int']['output']>;
  intensity?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lastInteractionDate?: Maybe<Scalars['DateTime']['output']>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  learningDuration?: Maybe<Scalars['Int']['output']>;
  learningStyle?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notificationPreferences?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  protein_grams?: Maybe<Scalars['Float']['output']>;
  relationshipType?: Maybe<Scalars['String']['output']>;
  sentiment?: Maybe<Scalars['String']['output']>;
  serving_size?: Maybe<Scalars['String']['output']>;
  sharedEventsAttended?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sharedGoals?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sharedInterests?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sodium_mg?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  sugars_grams?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  timeOfDay?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  totalCalories?: Maybe<Scalars['Float']['output']>;
  totalCaloriesBurned?: Maybe<Scalars['Float']['output']>;
  totalCarbs?: Maybe<Scalars['Float']['output']>;
  totalDurationMinutes?: Maybe<Scalars['Float']['output']>;
  totalFats?: Maybe<Scalars['Float']['output']>;
  totalProteins?: Maybe<Scalars['Float']['output']>;
  totalWorkouts?: Maybe<Scalars['Float']['output']>;
  trigger?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
  water_intake_oz?: Maybe<Scalars['Float']['output']>;
};

export type Assessment = {
  __typename?: 'Assessment';
  activityState?: Maybe<ActivityState>;
  aiTutors: Array<AiTutor>;
  aiTutorsAggregate?: Maybe<AssessmentAiTutorAiTutorsAggregationSelection>;
  aiTutorsConnection: AssessmentAiTutorsConnection;
  assessmentType?: Maybe<AssessmentType>;
  created?: Maybe<Scalars['DateTime']['output']>;
  documents: Array<Document>;
  documentsAggregate?: Maybe<AssessmentDocumentDocumentsAggregationSelection>;
  documentsConnection: AssessmentDocumentsConnection;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  hasReviews: Array<Review>;
  hasReviewsAggregate?: Maybe<AssessmentReviewHasReviewsAggregationSelection>;
  hasReviewsConnection: AssessmentHasReviewsConnection;
  id: Scalars['ID']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  mcqQuestions: Array<McqQuestion>;
  mcqQuestionsAggregate?: Maybe<AssessmentMcqQuestionMcqQuestionsAggregationSelection>;
  mcqQuestionsConnection: AssessmentMcqQuestionsConnection;
  moduleHasAssessment: Module;
  moduleHasAssessmentAggregate?: Maybe<AssessmentModuleModuleHasAssessmentAggregationSelection>;
  moduleHasAssessmentConnection: AssessmentModuleHasAssessmentConnection;
  nudgesAboutThis: Array<Nudge>;
  nudgesAboutThisAggregate?: Maybe<AssessmentNudgeNudgesAboutThisAggregationSelection>;
  nudgesAboutThisConnection: AssessmentNudgesAboutThisConnection;
  numberOfQuestions?: Maybe<Scalars['Int']['output']>;
  scheduledDate?: Maybe<Scalars['DateTime']['output']>;
  socraticQuestions: Array<Question>;
  socraticQuestionsAggregate?: Maybe<AssessmentQuestionSocraticQuestionsAggregationSelection>;
  socraticQuestionsConnection: AssessmentSocraticQuestionsConnection;
  submissions: Array<AssessmentSubmission>;
  submissionsAggregate?: Maybe<AssessmentAssessmentSubmissionSubmissionsAggregationSelection>;
  submissionsConnection: AssessmentSubmissionsConnection;
  timeLimit?: Maybe<Scalars['Int']['output']>;
};


export type AssessmentAiTutorsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AiTutorOptions>;
  where?: InputMaybe<AiTutorWhere>;
};


export type AssessmentAiTutorsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AiTutorWhere>;
};


export type AssessmentAiTutorsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AssessmentAiTutorsConnectionSort>>;
  where?: InputMaybe<AssessmentAiTutorsConnectionWhere>;
};


export type AssessmentDocumentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DocumentOptions>;
  where?: InputMaybe<DocumentWhere>;
};


export type AssessmentDocumentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DocumentWhere>;
};


export type AssessmentDocumentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AssessmentDocumentsConnectionSort>>;
  where?: InputMaybe<AssessmentDocumentsConnectionWhere>;
};


export type AssessmentHasReviewsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ReviewOptions>;
  where?: InputMaybe<ReviewWhere>;
};


export type AssessmentHasReviewsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ReviewWhere>;
};


export type AssessmentHasReviewsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AssessmentHasReviewsConnectionSort>>;
  where?: InputMaybe<AssessmentHasReviewsConnectionWhere>;
};


export type AssessmentMcqQuestionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<McqQuestionOptions>;
  where?: InputMaybe<McqQuestionWhere>;
};


export type AssessmentMcqQuestionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<McqQuestionWhere>;
};


export type AssessmentMcqQuestionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AssessmentMcqQuestionsConnectionSort>>;
  where?: InputMaybe<AssessmentMcqQuestionsConnectionWhere>;
};


export type AssessmentModuleHasAssessmentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ModuleOptions>;
  where?: InputMaybe<ModuleWhere>;
};


export type AssessmentModuleHasAssessmentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ModuleWhere>;
};


export type AssessmentModuleHasAssessmentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AssessmentModuleHasAssessmentConnectionSort>>;
  where?: InputMaybe<AssessmentModuleHasAssessmentConnectionWhere>;
};


export type AssessmentNudgesAboutThisArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<NudgeOptions>;
  where?: InputMaybe<NudgeWhere>;
};


export type AssessmentNudgesAboutThisAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NudgeWhere>;
};


export type AssessmentNudgesAboutThisConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AssessmentNudgesAboutThisConnectionSort>>;
  where?: InputMaybe<AssessmentNudgesAboutThisConnectionWhere>;
};


export type AssessmentSocraticQuestionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QuestionOptions>;
  where?: InputMaybe<QuestionWhere>;
};


export type AssessmentSocraticQuestionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QuestionWhere>;
};


export type AssessmentSocraticQuestionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AssessmentSocraticQuestionsConnectionSort>>;
  where?: InputMaybe<AssessmentSocraticQuestionsConnectionWhere>;
};


export type AssessmentSubmissionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AssessmentSubmissionOptions>;
  where?: InputMaybe<AssessmentSubmissionWhere>;
};


export type AssessmentSubmissionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssessmentSubmissionWhere>;
};


export type AssessmentSubmissionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AssessmentSubmissionsConnectionSort>>;
  where?: InputMaybe<AssessmentSubmissionsConnectionWhere>;
};

export type AssessmentAiTutorAiTutorsAggregationSelection = {
  __typename?: 'AssessmentAITutorAiTutorsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AssessmentAiTutorAiTutorsNodeAggregateSelection>;
};

export type AssessmentAiTutorAiTutorsNodeAggregateSelection = {
  __typename?: 'AssessmentAITutorAiTutorsNodeAggregateSelection';
  context: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  targetAudience: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type AssessmentAiTutors = {
  __typename?: 'AssessmentAiTutors';
  currentModuleAiTutors?: Maybe<ModuleAiTutors>;
  futureModulesAiTutors?: Maybe<Array<Maybe<ModuleAiTutors>>>;
  pastModulesAiTutors?: Maybe<Array<Maybe<ModuleAiTutors>>>;
};

export type AssessmentAiTutorsAggregateInput = {
  AND?: InputMaybe<Array<AssessmentAiTutorsAggregateInput>>;
  NOT?: InputMaybe<AssessmentAiTutorsAggregateInput>;
  OR?: InputMaybe<Array<AssessmentAiTutorsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AssessmentAiTutorsNodeAggregationWhereInput>;
};

export type AssessmentAiTutorsConnectFieldInput = {
  connect?: InputMaybe<Array<AiTutorConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AiTutorConnectWhere>;
};

export type AssessmentAiTutorsConnectOrCreateFieldInput = {
  onCreate: AssessmentAiTutorsConnectOrCreateFieldInputOnCreate;
  where: AiTutorConnectOrCreateWhere;
};

export type AssessmentAiTutorsConnectOrCreateFieldInputOnCreate = {
  node: AiTutorOnCreateInput;
};

export type AssessmentAiTutorsConnection = {
  __typename?: 'AssessmentAiTutorsConnection';
  edges: Array<AssessmentAiTutorsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssessmentAiTutorsConnectionSort = {
  node?: InputMaybe<AiTutorSort>;
};

export type AssessmentAiTutorsConnectionWhere = {
  AND?: InputMaybe<Array<AssessmentAiTutorsConnectionWhere>>;
  NOT?: InputMaybe<AssessmentAiTutorsConnectionWhere>;
  OR?: InputMaybe<Array<AssessmentAiTutorsConnectionWhere>>;
  node?: InputMaybe<AiTutorWhere>;
};

export type AssessmentAiTutorsCreateFieldInput = {
  node: AiTutorCreateInput;
};

export type AssessmentAiTutorsDeleteFieldInput = {
  delete?: InputMaybe<AiTutorDeleteInput>;
  where?: InputMaybe<AssessmentAiTutorsConnectionWhere>;
};

export type AssessmentAiTutorsDisconnectFieldInput = {
  disconnect?: InputMaybe<AiTutorDisconnectInput>;
  where?: InputMaybe<AssessmentAiTutorsConnectionWhere>;
};

export type AssessmentAiTutorsFieldInput = {
  connect?: InputMaybe<Array<AssessmentAiTutorsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssessmentAiTutorsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssessmentAiTutorsCreateFieldInput>>;
};

export type AssessmentAiTutorsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AssessmentAiTutorsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AssessmentAiTutorsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AssessmentAiTutorsNodeAggregationWhereInput>>;
  context_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  context_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AssessmentAiTutorsRelationship = {
  __typename?: 'AssessmentAiTutorsRelationship';
  cursor: Scalars['String']['output'];
  node: AiTutor;
};

export type AssessmentAiTutorsResponse = {
  __typename?: 'AssessmentAiTutorsResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<AssessmentAiTutors>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AssessmentAiTutorsUpdateConnectionInput = {
  node?: InputMaybe<AiTutorUpdateInput>;
};

export type AssessmentAiTutorsUpdateFieldInput = {
  connect?: InputMaybe<Array<AssessmentAiTutorsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssessmentAiTutorsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssessmentAiTutorsCreateFieldInput>>;
  delete?: InputMaybe<Array<AssessmentAiTutorsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AssessmentAiTutorsDisconnectFieldInput>>;
  update?: InputMaybe<AssessmentAiTutorsUpdateConnectionInput>;
  where?: InputMaybe<AssessmentAiTutorsConnectionWhere>;
};

export type AssessmentAssessmentSubmissionSubmissionsAggregationSelection = {
  __typename?: 'AssessmentAssessmentSubmissionSubmissionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AssessmentAssessmentSubmissionSubmissionsNodeAggregateSelection>;
};

export type AssessmentAssessmentSubmissionSubmissionsNodeAggregateSelection = {
  __typename?: 'AssessmentAssessmentSubmissionSubmissionsNodeAggregateSelection';
  aiTotalPoints: FloatAggregateSelection;
  completedAt: DateTimeAggregateSelection;
  created: DateTimeAggregateSelection;
  feedback: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  maximumPoints: FloatAggregateSelection;
  startedAt: DateTimeAggregateSelection;
  timeLimit: IntAggregateSelection;
  totalPoints: FloatAggregateSelection;
};

export type AssessmentConnectInput = {
  aiTutors?: InputMaybe<Array<AssessmentAiTutorsConnectFieldInput>>;
  documents?: InputMaybe<Array<AssessmentDocumentsConnectFieldInput>>;
  hasReviews?: InputMaybe<Array<AssessmentHasReviewsConnectFieldInput>>;
  mcqQuestions?: InputMaybe<Array<AssessmentMcqQuestionsConnectFieldInput>>;
  moduleHasAssessment?: InputMaybe<AssessmentModuleHasAssessmentConnectFieldInput>;
  nudgesAboutThis?: InputMaybe<Array<AssessmentNudgesAboutThisConnectFieldInput>>;
  socraticQuestions?: InputMaybe<Array<AssessmentSocraticQuestionsConnectFieldInput>>;
  submissions?: InputMaybe<Array<AssessmentSubmissionsConnectFieldInput>>;
};

export type AssessmentConnectOrCreateWhere = {
  node: AssessmentUniqueWhere;
};

export type AssessmentConnectWhere = {
  node: AssessmentWhere;
};

export type AssessmentCreateInput = {
  activityState?: InputMaybe<ActivityState>;
  aiTutors?: InputMaybe<AssessmentAiTutorsFieldInput>;
  assessmentType?: InputMaybe<AssessmentType>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  documents?: InputMaybe<AssessmentDocumentsFieldInput>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  hasReviews?: InputMaybe<AssessmentHasReviewsFieldInput>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  mcqQuestions?: InputMaybe<AssessmentMcqQuestionsFieldInput>;
  moduleHasAssessment?: InputMaybe<AssessmentModuleHasAssessmentFieldInput>;
  nudgesAboutThis?: InputMaybe<AssessmentNudgesAboutThisFieldInput>;
  numberOfQuestions?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  socraticQuestions?: InputMaybe<AssessmentSocraticQuestionsFieldInput>;
  submissions?: InputMaybe<AssessmentSubmissionsFieldInput>;
  timeLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type AssessmentDeleteInput = {
  aiTutors?: InputMaybe<Array<AssessmentAiTutorsDeleteFieldInput>>;
  documents?: InputMaybe<Array<AssessmentDocumentsDeleteFieldInput>>;
  hasReviews?: InputMaybe<Array<AssessmentHasReviewsDeleteFieldInput>>;
  mcqQuestions?: InputMaybe<Array<AssessmentMcqQuestionsDeleteFieldInput>>;
  moduleHasAssessment?: InputMaybe<AssessmentModuleHasAssessmentDeleteFieldInput>;
  nudgesAboutThis?: InputMaybe<Array<AssessmentNudgesAboutThisDeleteFieldInput>>;
  socraticQuestions?: InputMaybe<Array<AssessmentSocraticQuestionsDeleteFieldInput>>;
  submissions?: InputMaybe<Array<AssessmentSubmissionsDeleteFieldInput>>;
};

export type AssessmentDisconnectInput = {
  aiTutors?: InputMaybe<Array<AssessmentAiTutorsDisconnectFieldInput>>;
  documents?: InputMaybe<Array<AssessmentDocumentsDisconnectFieldInput>>;
  hasReviews?: InputMaybe<Array<AssessmentHasReviewsDisconnectFieldInput>>;
  mcqQuestions?: InputMaybe<Array<AssessmentMcqQuestionsDisconnectFieldInput>>;
  moduleHasAssessment?: InputMaybe<AssessmentModuleHasAssessmentDisconnectFieldInput>;
  nudgesAboutThis?: InputMaybe<Array<AssessmentNudgesAboutThisDisconnectFieldInput>>;
  socraticQuestions?: InputMaybe<Array<AssessmentSocraticQuestionsDisconnectFieldInput>>;
  submissions?: InputMaybe<Array<AssessmentSubmissionsDisconnectFieldInput>>;
};

export type AssessmentDocumentDocumentsAggregationSelection = {
  __typename?: 'AssessmentDocumentDocumentsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AssessmentDocumentDocumentsNodeAggregateSelection>;
};

export type AssessmentDocumentDocumentsNodeAggregateSelection = {
  __typename?: 'AssessmentDocumentDocumentsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  summary: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type AssessmentDocumentsAggregateInput = {
  AND?: InputMaybe<Array<AssessmentDocumentsAggregateInput>>;
  NOT?: InputMaybe<AssessmentDocumentsAggregateInput>;
  OR?: InputMaybe<Array<AssessmentDocumentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AssessmentDocumentsNodeAggregationWhereInput>;
};

export type AssessmentDocumentsConnectFieldInput = {
  connect?: InputMaybe<Array<DocumentConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DocumentConnectWhere>;
};

export type AssessmentDocumentsConnection = {
  __typename?: 'AssessmentDocumentsConnection';
  edges: Array<AssessmentDocumentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssessmentDocumentsConnectionSort = {
  node?: InputMaybe<DocumentSort>;
};

export type AssessmentDocumentsConnectionWhere = {
  AND?: InputMaybe<Array<AssessmentDocumentsConnectionWhere>>;
  NOT?: InputMaybe<AssessmentDocumentsConnectionWhere>;
  OR?: InputMaybe<Array<AssessmentDocumentsConnectionWhere>>;
  node?: InputMaybe<DocumentWhere>;
};

export type AssessmentDocumentsCreateFieldInput = {
  node: DocumentCreateInput;
};

export type AssessmentDocumentsDeleteFieldInput = {
  delete?: InputMaybe<DocumentDeleteInput>;
  where?: InputMaybe<AssessmentDocumentsConnectionWhere>;
};

export type AssessmentDocumentsDisconnectFieldInput = {
  disconnect?: InputMaybe<DocumentDisconnectInput>;
  where?: InputMaybe<AssessmentDocumentsConnectionWhere>;
};

export type AssessmentDocumentsFieldInput = {
  connect?: InputMaybe<Array<AssessmentDocumentsConnectFieldInput>>;
  create?: InputMaybe<Array<AssessmentDocumentsCreateFieldInput>>;
};

export type AssessmentDocumentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AssessmentDocumentsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AssessmentDocumentsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AssessmentDocumentsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  summary_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  summary_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AssessmentDocumentsRelationship = {
  __typename?: 'AssessmentDocumentsRelationship';
  cursor: Scalars['String']['output'];
  node: Document;
};

export type AssessmentDocumentsUpdateConnectionInput = {
  node?: InputMaybe<DocumentUpdateInput>;
};

export type AssessmentDocumentsUpdateFieldInput = {
  connect?: InputMaybe<Array<AssessmentDocumentsConnectFieldInput>>;
  create?: InputMaybe<Array<AssessmentDocumentsCreateFieldInput>>;
  delete?: InputMaybe<Array<AssessmentDocumentsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AssessmentDocumentsDisconnectFieldInput>>;
  update?: InputMaybe<AssessmentDocumentsUpdateConnectionInput>;
  where?: InputMaybe<AssessmentDocumentsConnectionWhere>;
};

export type AssessmentHasReviewsAggregateInput = {
  AND?: InputMaybe<Array<AssessmentHasReviewsAggregateInput>>;
  NOT?: InputMaybe<AssessmentHasReviewsAggregateInput>;
  OR?: InputMaybe<Array<AssessmentHasReviewsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AssessmentHasReviewsNodeAggregationWhereInput>;
};

export type AssessmentHasReviewsConnectFieldInput = {
  connect?: InputMaybe<Array<ReviewConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ReviewConnectWhere>;
};

export type AssessmentHasReviewsConnectOrCreateFieldInput = {
  onCreate: AssessmentHasReviewsConnectOrCreateFieldInputOnCreate;
  where: ReviewConnectOrCreateWhere;
};

export type AssessmentHasReviewsConnectOrCreateFieldInputOnCreate = {
  node: ReviewOnCreateInput;
};

export type AssessmentHasReviewsConnection = {
  __typename?: 'AssessmentHasReviewsConnection';
  edges: Array<AssessmentHasReviewsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssessmentHasReviewsConnectionSort = {
  node?: InputMaybe<ReviewSort>;
};

export type AssessmentHasReviewsConnectionWhere = {
  AND?: InputMaybe<Array<AssessmentHasReviewsConnectionWhere>>;
  NOT?: InputMaybe<AssessmentHasReviewsConnectionWhere>;
  OR?: InputMaybe<Array<AssessmentHasReviewsConnectionWhere>>;
  node?: InputMaybe<ReviewWhere>;
};

export type AssessmentHasReviewsCreateFieldInput = {
  node: ReviewCreateInput;
};

export type AssessmentHasReviewsDeleteFieldInput = {
  delete?: InputMaybe<ReviewDeleteInput>;
  where?: InputMaybe<AssessmentHasReviewsConnectionWhere>;
};

export type AssessmentHasReviewsDisconnectFieldInput = {
  disconnect?: InputMaybe<ReviewDisconnectInput>;
  where?: InputMaybe<AssessmentHasReviewsConnectionWhere>;
};

export type AssessmentHasReviewsFieldInput = {
  connect?: InputMaybe<Array<AssessmentHasReviewsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssessmentHasReviewsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssessmentHasReviewsCreateFieldInput>>;
};

export type AssessmentHasReviewsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AssessmentHasReviewsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AssessmentHasReviewsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AssessmentHasReviewsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AssessmentHasReviewsRelationship = {
  __typename?: 'AssessmentHasReviewsRelationship';
  cursor: Scalars['String']['output'];
  node: Review;
};

export type AssessmentHasReviewsUpdateConnectionInput = {
  node?: InputMaybe<ReviewUpdateInput>;
};

export type AssessmentHasReviewsUpdateFieldInput = {
  connect?: InputMaybe<Array<AssessmentHasReviewsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssessmentHasReviewsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssessmentHasReviewsCreateFieldInput>>;
  delete?: InputMaybe<Array<AssessmentHasReviewsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AssessmentHasReviewsDisconnectFieldInput>>;
  update?: InputMaybe<AssessmentHasReviewsUpdateConnectionInput>;
  where?: InputMaybe<AssessmentHasReviewsConnectionWhere>;
};

export type AssessmentMcqQuestionMcqQuestionsAggregationSelection = {
  __typename?: 'AssessmentMcqQuestionMcqQuestionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AssessmentMcqQuestionMcqQuestionsNodeAggregateSelection>;
};

export type AssessmentMcqQuestionMcqQuestionsNodeAggregateSelection = {
  __typename?: 'AssessmentMcqQuestionMcqQuestionsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  explanation: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  order: IntAggregateSelection;
  question: StringAggregateSelection;
  totalScore: FloatAggregateSelection;
};

export type AssessmentMcqQuestionsAggregateInput = {
  AND?: InputMaybe<Array<AssessmentMcqQuestionsAggregateInput>>;
  NOT?: InputMaybe<AssessmentMcqQuestionsAggregateInput>;
  OR?: InputMaybe<Array<AssessmentMcqQuestionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AssessmentMcqQuestionsNodeAggregationWhereInput>;
};

export type AssessmentMcqQuestionsConnectFieldInput = {
  connect?: InputMaybe<Array<McqQuestionConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<McqQuestionConnectWhere>;
};

export type AssessmentMcqQuestionsConnectOrCreateFieldInput = {
  onCreate: AssessmentMcqQuestionsConnectOrCreateFieldInputOnCreate;
  where: McqQuestionConnectOrCreateWhere;
};

export type AssessmentMcqQuestionsConnectOrCreateFieldInputOnCreate = {
  node: McqQuestionOnCreateInput;
};

export type AssessmentMcqQuestionsConnection = {
  __typename?: 'AssessmentMcqQuestionsConnection';
  edges: Array<AssessmentMcqQuestionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssessmentMcqQuestionsConnectionSort = {
  node?: InputMaybe<McqQuestionSort>;
};

export type AssessmentMcqQuestionsConnectionWhere = {
  AND?: InputMaybe<Array<AssessmentMcqQuestionsConnectionWhere>>;
  NOT?: InputMaybe<AssessmentMcqQuestionsConnectionWhere>;
  OR?: InputMaybe<Array<AssessmentMcqQuestionsConnectionWhere>>;
  node?: InputMaybe<McqQuestionWhere>;
};

export type AssessmentMcqQuestionsCreateFieldInput = {
  node: McqQuestionCreateInput;
};

export type AssessmentMcqQuestionsDeleteFieldInput = {
  delete?: InputMaybe<McqQuestionDeleteInput>;
  where?: InputMaybe<AssessmentMcqQuestionsConnectionWhere>;
};

export type AssessmentMcqQuestionsDisconnectFieldInput = {
  disconnect?: InputMaybe<McqQuestionDisconnectInput>;
  where?: InputMaybe<AssessmentMcqQuestionsConnectionWhere>;
};

export type AssessmentMcqQuestionsFieldInput = {
  connect?: InputMaybe<Array<AssessmentMcqQuestionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssessmentMcqQuestionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssessmentMcqQuestionsCreateFieldInput>>;
};

export type AssessmentMcqQuestionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AssessmentMcqQuestionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AssessmentMcqQuestionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AssessmentMcqQuestionsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  explanation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  explanation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  explanation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  explanation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  explanation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  explanation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  explanation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  explanation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  explanation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  explanation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  explanation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  explanation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  explanation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  explanation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  explanation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  question_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  question_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalScore_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type AssessmentMcqQuestionsRelationship = {
  __typename?: 'AssessmentMcqQuestionsRelationship';
  cursor: Scalars['String']['output'];
  node: McqQuestion;
};

export type AssessmentMcqQuestionsUpdateConnectionInput = {
  node?: InputMaybe<McqQuestionUpdateInput>;
};

export type AssessmentMcqQuestionsUpdateFieldInput = {
  connect?: InputMaybe<Array<AssessmentMcqQuestionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssessmentMcqQuestionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssessmentMcqQuestionsCreateFieldInput>>;
  delete?: InputMaybe<Array<AssessmentMcqQuestionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AssessmentMcqQuestionsDisconnectFieldInput>>;
  update?: InputMaybe<AssessmentMcqQuestionsUpdateConnectionInput>;
  where?: InputMaybe<AssessmentMcqQuestionsConnectionWhere>;
};

export type AssessmentModuleHasAssessmentAggregateInput = {
  AND?: InputMaybe<Array<AssessmentModuleHasAssessmentAggregateInput>>;
  NOT?: InputMaybe<AssessmentModuleHasAssessmentAggregateInput>;
  OR?: InputMaybe<Array<AssessmentModuleHasAssessmentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AssessmentModuleHasAssessmentNodeAggregationWhereInput>;
};

export type AssessmentModuleHasAssessmentConnectFieldInput = {
  connect?: InputMaybe<ModuleConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ModuleConnectWhere>;
};

export type AssessmentModuleHasAssessmentConnectOrCreateFieldInput = {
  onCreate: AssessmentModuleHasAssessmentConnectOrCreateFieldInputOnCreate;
  where: ModuleConnectOrCreateWhere;
};

export type AssessmentModuleHasAssessmentConnectOrCreateFieldInputOnCreate = {
  node: ModuleOnCreateInput;
};

export type AssessmentModuleHasAssessmentConnection = {
  __typename?: 'AssessmentModuleHasAssessmentConnection';
  edges: Array<AssessmentModuleHasAssessmentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssessmentModuleHasAssessmentConnectionSort = {
  node?: InputMaybe<ModuleSort>;
};

export type AssessmentModuleHasAssessmentConnectionWhere = {
  AND?: InputMaybe<Array<AssessmentModuleHasAssessmentConnectionWhere>>;
  NOT?: InputMaybe<AssessmentModuleHasAssessmentConnectionWhere>;
  OR?: InputMaybe<Array<AssessmentModuleHasAssessmentConnectionWhere>>;
  node?: InputMaybe<ModuleWhere>;
};

export type AssessmentModuleHasAssessmentCreateFieldInput = {
  node: ModuleCreateInput;
};

export type AssessmentModuleHasAssessmentDeleteFieldInput = {
  delete?: InputMaybe<ModuleDeleteInput>;
  where?: InputMaybe<AssessmentModuleHasAssessmentConnectionWhere>;
};

export type AssessmentModuleHasAssessmentDisconnectFieldInput = {
  disconnect?: InputMaybe<ModuleDisconnectInput>;
  where?: InputMaybe<AssessmentModuleHasAssessmentConnectionWhere>;
};

export type AssessmentModuleHasAssessmentFieldInput = {
  connect?: InputMaybe<AssessmentModuleHasAssessmentConnectFieldInput>;
  connectOrCreate?: InputMaybe<AssessmentModuleHasAssessmentConnectOrCreateFieldInput>;
  create?: InputMaybe<AssessmentModuleHasAssessmentCreateFieldInput>;
};

export type AssessmentModuleHasAssessmentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AssessmentModuleHasAssessmentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AssessmentModuleHasAssessmentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AssessmentModuleHasAssessmentNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  module_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  module_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AssessmentModuleHasAssessmentRelationship = {
  __typename?: 'AssessmentModuleHasAssessmentRelationship';
  cursor: Scalars['String']['output'];
  node: Module;
};

export type AssessmentModuleHasAssessmentUpdateConnectionInput = {
  node?: InputMaybe<ModuleUpdateInput>;
};

export type AssessmentModuleHasAssessmentUpdateFieldInput = {
  connect?: InputMaybe<AssessmentModuleHasAssessmentConnectFieldInput>;
  connectOrCreate?: InputMaybe<AssessmentModuleHasAssessmentConnectOrCreateFieldInput>;
  create?: InputMaybe<AssessmentModuleHasAssessmentCreateFieldInput>;
  delete?: InputMaybe<AssessmentModuleHasAssessmentDeleteFieldInput>;
  disconnect?: InputMaybe<AssessmentModuleHasAssessmentDisconnectFieldInput>;
  update?: InputMaybe<AssessmentModuleHasAssessmentUpdateConnectionInput>;
  where?: InputMaybe<AssessmentModuleHasAssessmentConnectionWhere>;
};

export type AssessmentModuleModuleHasAssessmentAggregationSelection = {
  __typename?: 'AssessmentModuleModuleHasAssessmentAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AssessmentModuleModuleHasAssessmentNodeAggregateSelection>;
};

export type AssessmentModuleModuleHasAssessmentNodeAggregateSelection = {
  __typename?: 'AssessmentModuleModuleHasAssessmentNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  module_name: StringAggregateSelection;
  thumbnail: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type AssessmentNudgeNudgesAboutThisAggregationSelection = {
  __typename?: 'AssessmentNudgeNudgesAboutThisAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AssessmentNudgeNudgesAboutThisNodeAggregateSelection>;
};

export type AssessmentNudgeNudgesAboutThisNodeAggregateSelection = {
  __typename?: 'AssessmentNudgeNudgesAboutThisNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  idempotencyKey: StringAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  priorityScore: FloatAggregateSelection;
  scheduledFor: DateTimeAggregateSelection;
  snoozedUntil: DateTimeAggregateSelection;
  taskCompletedAt: DateTimeAggregateSelection;
};

export type AssessmentNudgesAboutThisAggregateInput = {
  AND?: InputMaybe<Array<AssessmentNudgesAboutThisAggregateInput>>;
  NOT?: InputMaybe<AssessmentNudgesAboutThisAggregateInput>;
  OR?: InputMaybe<Array<AssessmentNudgesAboutThisAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AssessmentNudgesAboutThisNodeAggregationWhereInput>;
};

export type AssessmentNudgesAboutThisConnectFieldInput = {
  connect?: InputMaybe<Array<NudgeConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<NudgeConnectWhere>;
};

export type AssessmentNudgesAboutThisConnectOrCreateFieldInput = {
  onCreate: AssessmentNudgesAboutThisConnectOrCreateFieldInputOnCreate;
  where: NudgeConnectOrCreateWhere;
};

export type AssessmentNudgesAboutThisConnectOrCreateFieldInputOnCreate = {
  node: NudgeOnCreateInput;
};

export type AssessmentNudgesAboutThisConnection = {
  __typename?: 'AssessmentNudgesAboutThisConnection';
  edges: Array<AssessmentNudgesAboutThisRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssessmentNudgesAboutThisConnectionSort = {
  node?: InputMaybe<NudgeSort>;
};

export type AssessmentNudgesAboutThisConnectionWhere = {
  AND?: InputMaybe<Array<AssessmentNudgesAboutThisConnectionWhere>>;
  NOT?: InputMaybe<AssessmentNudgesAboutThisConnectionWhere>;
  OR?: InputMaybe<Array<AssessmentNudgesAboutThisConnectionWhere>>;
  node?: InputMaybe<NudgeWhere>;
};

export type AssessmentNudgesAboutThisCreateFieldInput = {
  node: NudgeCreateInput;
};

export type AssessmentNudgesAboutThisDeleteFieldInput = {
  delete?: InputMaybe<NudgeDeleteInput>;
  where?: InputMaybe<AssessmentNudgesAboutThisConnectionWhere>;
};

export type AssessmentNudgesAboutThisDisconnectFieldInput = {
  disconnect?: InputMaybe<NudgeDisconnectInput>;
  where?: InputMaybe<AssessmentNudgesAboutThisConnectionWhere>;
};

export type AssessmentNudgesAboutThisFieldInput = {
  connect?: InputMaybe<Array<AssessmentNudgesAboutThisConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssessmentNudgesAboutThisConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssessmentNudgesAboutThisCreateFieldInput>>;
};

export type AssessmentNudgesAboutThisNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AssessmentNudgesAboutThisNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AssessmentNudgesAboutThisNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AssessmentNudgesAboutThisNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  idempotencyKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  priorityScore_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  scheduledFor_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AssessmentNudgesAboutThisRelationship = {
  __typename?: 'AssessmentNudgesAboutThisRelationship';
  cursor: Scalars['String']['output'];
  node: Nudge;
};

export type AssessmentNudgesAboutThisUpdateConnectionInput = {
  node?: InputMaybe<NudgeUpdateInput>;
};

export type AssessmentNudgesAboutThisUpdateFieldInput = {
  connect?: InputMaybe<Array<AssessmentNudgesAboutThisConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssessmentNudgesAboutThisConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssessmentNudgesAboutThisCreateFieldInput>>;
  delete?: InputMaybe<Array<AssessmentNudgesAboutThisDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AssessmentNudgesAboutThisDisconnectFieldInput>>;
  update?: InputMaybe<AssessmentNudgesAboutThisUpdateConnectionInput>;
  where?: InputMaybe<AssessmentNudgesAboutThisConnectionWhere>;
};

export type AssessmentOnCreateInput = {
  activityState?: InputMaybe<ActivityState>;
  assessmentType?: InputMaybe<AssessmentType>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfQuestions?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  timeLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type AssessmentOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AssessmentSort objects to sort Assessments by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AssessmentSort>>;
};

export type AssessmentQuestionBankPaginationInput = {
  mcqLimit?: InputMaybe<Scalars['Int']['input']>;
  mcqOffset?: InputMaybe<Scalars['Int']['input']>;
  socraticLimit?: InputMaybe<Scalars['Int']['input']>;
  socraticOffset?: InputMaybe<Scalars['Int']['input']>;
};

export type AssessmentQuestionSocraticQuestionsAggregationSelection = {
  __typename?: 'AssessmentQuestionSocraticQuestionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AssessmentQuestionSocraticQuestionsNodeAggregateSelection>;
};

export type AssessmentQuestionSocraticQuestionsNodeAggregateSelection = {
  __typename?: 'AssessmentQuestionSocraticQuestionsNodeAggregateSelection';
  id: IdAggregateSelection;
  question: StringAggregateSelection;
  totalScore: FloatAggregateSelection;
};

export type AssessmentQuestionsPreviewResponse = {
  __typename?: 'AssessmentQuestionsPreviewResponse';
  count?: Maybe<Scalars['Int']['output']>;
  mcqQuestions: Array<PreviewMcqQuestion>;
  message?: Maybe<Scalars['String']['output']>;
  socraticQuestions: Array<PreviewSocraticQuestion>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AssessmentResponse = {
  __typename?: 'AssessmentResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Assessment>;
  mcqTotalCount?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  socraticTotalCount?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AssessmentReviewHasReviewsAggregationSelection = {
  __typename?: 'AssessmentReviewHasReviewsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AssessmentReviewHasReviewsNodeAggregateSelection>;
};

export type AssessmentReviewHasReviewsNodeAggregateSelection = {
  __typename?: 'AssessmentReviewHasReviewsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
};

export type AssessmentSocraticQuestionsAggregateInput = {
  AND?: InputMaybe<Array<AssessmentSocraticQuestionsAggregateInput>>;
  NOT?: InputMaybe<AssessmentSocraticQuestionsAggregateInput>;
  OR?: InputMaybe<Array<AssessmentSocraticQuestionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AssessmentSocraticQuestionsNodeAggregationWhereInput>;
};

export type AssessmentSocraticQuestionsConnectFieldInput = {
  connect?: InputMaybe<Array<QuestionConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<QuestionConnectWhere>;
};

export type AssessmentSocraticQuestionsConnectOrCreateFieldInput = {
  onCreate: AssessmentSocraticQuestionsConnectOrCreateFieldInputOnCreate;
  where: QuestionConnectOrCreateWhere;
};

export type AssessmentSocraticQuestionsConnectOrCreateFieldInputOnCreate = {
  node: QuestionOnCreateInput;
};

export type AssessmentSocraticQuestionsConnection = {
  __typename?: 'AssessmentSocraticQuestionsConnection';
  edges: Array<AssessmentSocraticQuestionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssessmentSocraticQuestionsConnectionSort = {
  node?: InputMaybe<QuestionSort>;
};

export type AssessmentSocraticQuestionsConnectionWhere = {
  AND?: InputMaybe<Array<AssessmentSocraticQuestionsConnectionWhere>>;
  NOT?: InputMaybe<AssessmentSocraticQuestionsConnectionWhere>;
  OR?: InputMaybe<Array<AssessmentSocraticQuestionsConnectionWhere>>;
  node?: InputMaybe<QuestionWhere>;
};

export type AssessmentSocraticQuestionsCreateFieldInput = {
  node: QuestionCreateInput;
};

export type AssessmentSocraticQuestionsDeleteFieldInput = {
  delete?: InputMaybe<QuestionDeleteInput>;
  where?: InputMaybe<AssessmentSocraticQuestionsConnectionWhere>;
};

export type AssessmentSocraticQuestionsDisconnectFieldInput = {
  disconnect?: InputMaybe<QuestionDisconnectInput>;
  where?: InputMaybe<AssessmentSocraticQuestionsConnectionWhere>;
};

export type AssessmentSocraticQuestionsFieldInput = {
  connect?: InputMaybe<Array<AssessmentSocraticQuestionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssessmentSocraticQuestionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssessmentSocraticQuestionsCreateFieldInput>>;
};

export type AssessmentSocraticQuestionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AssessmentSocraticQuestionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AssessmentSocraticQuestionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AssessmentSocraticQuestionsNodeAggregationWhereInput>>;
  question_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  question_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalScore_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type AssessmentSocraticQuestionsRelationship = {
  __typename?: 'AssessmentSocraticQuestionsRelationship';
  cursor: Scalars['String']['output'];
  node: Question;
};

export type AssessmentSocraticQuestionsUpdateConnectionInput = {
  node?: InputMaybe<QuestionUpdateInput>;
};

export type AssessmentSocraticQuestionsUpdateFieldInput = {
  connect?: InputMaybe<Array<AssessmentSocraticQuestionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssessmentSocraticQuestionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssessmentSocraticQuestionsCreateFieldInput>>;
  delete?: InputMaybe<Array<AssessmentSocraticQuestionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AssessmentSocraticQuestionsDisconnectFieldInput>>;
  update?: InputMaybe<AssessmentSocraticQuestionsUpdateConnectionInput>;
  where?: InputMaybe<AssessmentSocraticQuestionsConnectionWhere>;
};

/** Fields to sort Assessments by. The order in which sorts are applied is not guaranteed when specifying many fields in one AssessmentSort object. */
export type AssessmentSort = {
  activityState?: InputMaybe<SortDirection>;
  assessmentType?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  dueDate?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastModified?: InputMaybe<SortDirection>;
  numberOfQuestions?: InputMaybe<SortDirection>;
  scheduledDate?: InputMaybe<SortDirection>;
  timeLimit?: InputMaybe<SortDirection>;
};

export type AssessmentSubmission = {
  __typename?: 'AssessmentSubmission';
  aiTotalPoints?: Maybe<Scalars['Float']['output']>;
  assessment: Assessment;
  assessmentAggregate?: Maybe<AssessmentSubmissionAssessmentAssessmentAggregationSelection>;
  assessmentConnection: AssessmentSubmissionAssessmentConnection;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  hasTeacherAdjustedGrade?: Maybe<Scalars['Boolean']['output']>;
  hasTeacherGraded?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isEvaluationPending?: Maybe<Scalars['Boolean']['output']>;
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  maximumPoints?: Maybe<Scalars['Float']['output']>;
  mcqAnswers: Array<McqQuestion>;
  mcqAnswersAggregate?: Maybe<AssessmentSubmissionMcqQuestionMcqAnswersAggregationSelection>;
  mcqAnswersConnection: AssessmentSubmissionMcqAnswersConnection;
  questions: Array<Question>;
  questionsAggregate?: Maybe<AssessmentSubmissionQuestionQuestionsAggregationSelection>;
  questionsConnection: AssessmentSubmissionQuestionsConnection;
  rubrics: Array<Rubric>;
  rubricsAggregate?: Maybe<AssessmentSubmissionRubricRubricsAggregationSelection>;
  rubricsConnection: AssessmentSubmissionRubricsConnection;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<AssessmentSubmissionStatus>;
  timeLimit?: Maybe<Scalars['Int']['output']>;
  totalPoints?: Maybe<Scalars['Float']['output']>;
  user: User;
  userAggregate?: Maybe<AssessmentSubmissionUserUserAggregationSelection>;
  userConnection: AssessmentSubmissionUserConnection;
};


export type AssessmentSubmissionAssessmentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AssessmentOptions>;
  where?: InputMaybe<AssessmentWhere>;
};


export type AssessmentSubmissionAssessmentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssessmentWhere>;
};


export type AssessmentSubmissionAssessmentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AssessmentSubmissionAssessmentConnectionSort>>;
  where?: InputMaybe<AssessmentSubmissionAssessmentConnectionWhere>;
};


export type AssessmentSubmissionMcqAnswersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<McqQuestionOptions>;
  where?: InputMaybe<McqQuestionWhere>;
};


export type AssessmentSubmissionMcqAnswersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<McqQuestionWhere>;
};


export type AssessmentSubmissionMcqAnswersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AssessmentSubmissionMcqAnswersConnectionSort>>;
  where?: InputMaybe<AssessmentSubmissionMcqAnswersConnectionWhere>;
};


export type AssessmentSubmissionQuestionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QuestionOptions>;
  where?: InputMaybe<QuestionWhere>;
};


export type AssessmentSubmissionQuestionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QuestionWhere>;
};


export type AssessmentSubmissionQuestionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AssessmentSubmissionQuestionsConnectionSort>>;
  where?: InputMaybe<AssessmentSubmissionQuestionsConnectionWhere>;
};


export type AssessmentSubmissionRubricsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RubricOptions>;
  where?: InputMaybe<RubricWhere>;
};


export type AssessmentSubmissionRubricsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RubricWhere>;
};


export type AssessmentSubmissionRubricsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AssessmentSubmissionRubricsConnectionSort>>;
  where?: InputMaybe<AssessmentSubmissionRubricsConnectionWhere>;
};


export type AssessmentSubmissionUserArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type AssessmentSubmissionUserAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type AssessmentSubmissionUserConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AssessmentSubmissionUserConnectionSort>>;
  where?: InputMaybe<AssessmentSubmissionUserConnectionWhere>;
};

export type AssessmentSubmissionAssessmentAggregateInput = {
  AND?: InputMaybe<Array<AssessmentSubmissionAssessmentAggregateInput>>;
  NOT?: InputMaybe<AssessmentSubmissionAssessmentAggregateInput>;
  OR?: InputMaybe<Array<AssessmentSubmissionAssessmentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AssessmentSubmissionAssessmentNodeAggregationWhereInput>;
};

export type AssessmentSubmissionAssessmentAssessmentAggregationSelection = {
  __typename?: 'AssessmentSubmissionAssessmentAssessmentAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AssessmentSubmissionAssessmentAssessmentNodeAggregateSelection>;
};

export type AssessmentSubmissionAssessmentAssessmentNodeAggregateSelection = {
  __typename?: 'AssessmentSubmissionAssessmentAssessmentNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  numberOfQuestions: IntAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  timeLimit: IntAggregateSelection;
};

export type AssessmentSubmissionAssessmentConnectFieldInput = {
  connect?: InputMaybe<AssessmentConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AssessmentConnectWhere>;
};

export type AssessmentSubmissionAssessmentConnectOrCreateFieldInput = {
  onCreate: AssessmentSubmissionAssessmentConnectOrCreateFieldInputOnCreate;
  where: AssessmentConnectOrCreateWhere;
};

export type AssessmentSubmissionAssessmentConnectOrCreateFieldInputOnCreate = {
  node: AssessmentOnCreateInput;
};

export type AssessmentSubmissionAssessmentConnection = {
  __typename?: 'AssessmentSubmissionAssessmentConnection';
  edges: Array<AssessmentSubmissionAssessmentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssessmentSubmissionAssessmentConnectionSort = {
  node?: InputMaybe<AssessmentSort>;
};

export type AssessmentSubmissionAssessmentConnectionWhere = {
  AND?: InputMaybe<Array<AssessmentSubmissionAssessmentConnectionWhere>>;
  NOT?: InputMaybe<AssessmentSubmissionAssessmentConnectionWhere>;
  OR?: InputMaybe<Array<AssessmentSubmissionAssessmentConnectionWhere>>;
  node?: InputMaybe<AssessmentWhere>;
};

export type AssessmentSubmissionAssessmentCreateFieldInput = {
  node: AssessmentCreateInput;
};

export type AssessmentSubmissionAssessmentDeleteFieldInput = {
  delete?: InputMaybe<AssessmentDeleteInput>;
  where?: InputMaybe<AssessmentSubmissionAssessmentConnectionWhere>;
};

export type AssessmentSubmissionAssessmentDisconnectFieldInput = {
  disconnect?: InputMaybe<AssessmentDisconnectInput>;
  where?: InputMaybe<AssessmentSubmissionAssessmentConnectionWhere>;
};

export type AssessmentSubmissionAssessmentFieldInput = {
  connect?: InputMaybe<AssessmentSubmissionAssessmentConnectFieldInput>;
  connectOrCreate?: InputMaybe<AssessmentSubmissionAssessmentConnectOrCreateFieldInput>;
  create?: InputMaybe<AssessmentSubmissionAssessmentCreateFieldInput>;
};

export type AssessmentSubmissionAssessmentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AssessmentSubmissionAssessmentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AssessmentSubmissionAssessmentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AssessmentSubmissionAssessmentNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfQuestions_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  timeLimit_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AssessmentSubmissionAssessmentRelationship = {
  __typename?: 'AssessmentSubmissionAssessmentRelationship';
  cursor: Scalars['String']['output'];
  node: Assessment;
};

export type AssessmentSubmissionAssessmentUpdateConnectionInput = {
  node?: InputMaybe<AssessmentUpdateInput>;
};

export type AssessmentSubmissionAssessmentUpdateFieldInput = {
  connect?: InputMaybe<AssessmentSubmissionAssessmentConnectFieldInput>;
  connectOrCreate?: InputMaybe<AssessmentSubmissionAssessmentConnectOrCreateFieldInput>;
  create?: InputMaybe<AssessmentSubmissionAssessmentCreateFieldInput>;
  delete?: InputMaybe<AssessmentSubmissionAssessmentDeleteFieldInput>;
  disconnect?: InputMaybe<AssessmentSubmissionAssessmentDisconnectFieldInput>;
  update?: InputMaybe<AssessmentSubmissionAssessmentUpdateConnectionInput>;
  where?: InputMaybe<AssessmentSubmissionAssessmentConnectionWhere>;
};

export type AssessmentSubmissionConnectInput = {
  assessment?: InputMaybe<AssessmentSubmissionAssessmentConnectFieldInput>;
  mcqAnswers?: InputMaybe<Array<AssessmentSubmissionMcqAnswersConnectFieldInput>>;
  questions?: InputMaybe<Array<AssessmentSubmissionQuestionsConnectFieldInput>>;
  rubrics?: InputMaybe<Array<AssessmentSubmissionRubricsConnectFieldInput>>;
  user?: InputMaybe<AssessmentSubmissionUserConnectFieldInput>;
};

export type AssessmentSubmissionConnectOrCreateWhere = {
  node: AssessmentSubmissionUniqueWhere;
};

export type AssessmentSubmissionConnectWhere = {
  node: AssessmentSubmissionWhere;
};

export type AssessmentSubmissionCreateInput = {
  aiTotalPoints?: InputMaybe<Scalars['Float']['input']>;
  assessment?: InputMaybe<AssessmentSubmissionAssessmentFieldInput>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  hasTeacherAdjustedGrade?: InputMaybe<Scalars['Boolean']['input']>;
  hasTeacherGraded?: InputMaybe<Scalars['Boolean']['input']>;
  isEvaluationPending?: InputMaybe<Scalars['Boolean']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  maximumPoints?: InputMaybe<Scalars['Float']['input']>;
  mcqAnswers?: InputMaybe<AssessmentSubmissionMcqAnswersFieldInput>;
  questions?: InputMaybe<AssessmentSubmissionQuestionsFieldInput>;
  rubrics?: InputMaybe<AssessmentSubmissionRubricsFieldInput>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<AssessmentSubmissionStatus>;
  timeLimit?: InputMaybe<Scalars['Int']['input']>;
  totalPoints?: InputMaybe<Scalars['Float']['input']>;
  user?: InputMaybe<AssessmentSubmissionUserFieldInput>;
};

export type AssessmentSubmissionData = {
  __typename?: 'AssessmentSubmissionData';
  assessmentSubmissions?: Maybe<Array<Maybe<AssessmentSubmission>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AssessmentSubmissionDeleteInput = {
  assessment?: InputMaybe<AssessmentSubmissionAssessmentDeleteFieldInput>;
  mcqAnswers?: InputMaybe<Array<AssessmentSubmissionMcqAnswersDeleteFieldInput>>;
  questions?: InputMaybe<Array<AssessmentSubmissionQuestionsDeleteFieldInput>>;
  rubrics?: InputMaybe<Array<AssessmentSubmissionRubricsDeleteFieldInput>>;
  user?: InputMaybe<AssessmentSubmissionUserDeleteFieldInput>;
};

export type AssessmentSubmissionDetails = {
  __typename?: 'AssessmentSubmissionDetails';
  aiTotalPoints?: Maybe<Scalars['Float']['output']>;
  assessmentId?: Maybe<Scalars['String']['output']>;
  assessmentType?: Maybe<AssessmentType>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  courseName?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  hasTeacherAdjustedGrade?: Maybe<Scalars['Boolean']['output']>;
  hasTeacherGraded?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  maximumPoints?: Maybe<Scalars['Float']['output']>;
  mcqAnswers?: Maybe<Array<Maybe<McqAnswerDetail>>>;
  moduleName?: Maybe<Scalars['String']['output']>;
  questions?: Maybe<Array<Maybe<AssessmentSubmissionQuestion>>>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<AssessmentSubmissionStatus>;
  timeLimit?: Maybe<Scalars['Int']['output']>;
  totalPoints?: Maybe<Scalars['Float']['output']>;
  userEmail?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type AssessmentSubmissionDetailsResponse = {
  __typename?: 'AssessmentSubmissionDetailsResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<AssessmentSubmissionDetails>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AssessmentSubmissionDisconnectInput = {
  assessment?: InputMaybe<AssessmentSubmissionAssessmentDisconnectFieldInput>;
  mcqAnswers?: InputMaybe<Array<AssessmentSubmissionMcqAnswersDisconnectFieldInput>>;
  questions?: InputMaybe<Array<AssessmentSubmissionQuestionsDisconnectFieldInput>>;
  rubrics?: InputMaybe<Array<AssessmentSubmissionRubricsDisconnectFieldInput>>;
  user?: InputMaybe<AssessmentSubmissionUserDisconnectFieldInput>;
};

export type AssessmentSubmissionListResponse = {
  __typename?: 'AssessmentSubmissionListResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<AssessmentSubmissionData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AssessmentSubmissionMcqAnswersAggregateInput = {
  AND?: InputMaybe<Array<AssessmentSubmissionMcqAnswersAggregateInput>>;
  NOT?: InputMaybe<AssessmentSubmissionMcqAnswersAggregateInput>;
  OR?: InputMaybe<Array<AssessmentSubmissionMcqAnswersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasMcqAnswerPropertiesAggregationWhereInput>;
  node?: InputMaybe<AssessmentSubmissionMcqAnswersNodeAggregationWhereInput>;
};

export type AssessmentSubmissionMcqAnswersConnectFieldInput = {
  connect?: InputMaybe<Array<McqQuestionConnectInput>>;
  edge: HasMcqAnswerPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<McqQuestionConnectWhere>;
};

export type AssessmentSubmissionMcqAnswersConnectOrCreateFieldInput = {
  onCreate: AssessmentSubmissionMcqAnswersConnectOrCreateFieldInputOnCreate;
  where: McqQuestionConnectOrCreateWhere;
};

export type AssessmentSubmissionMcqAnswersConnectOrCreateFieldInputOnCreate = {
  edge: HasMcqAnswerPropertiesCreateInput;
  node: McqQuestionOnCreateInput;
};

export type AssessmentSubmissionMcqAnswersConnection = {
  __typename?: 'AssessmentSubmissionMcqAnswersConnection';
  edges: Array<AssessmentSubmissionMcqAnswersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssessmentSubmissionMcqAnswersConnectionSort = {
  edge?: InputMaybe<HasMcqAnswerPropertiesSort>;
  node?: InputMaybe<McqQuestionSort>;
};

export type AssessmentSubmissionMcqAnswersConnectionWhere = {
  AND?: InputMaybe<Array<AssessmentSubmissionMcqAnswersConnectionWhere>>;
  NOT?: InputMaybe<AssessmentSubmissionMcqAnswersConnectionWhere>;
  OR?: InputMaybe<Array<AssessmentSubmissionMcqAnswersConnectionWhere>>;
  edge?: InputMaybe<HasMcqAnswerPropertiesWhere>;
  node?: InputMaybe<McqQuestionWhere>;
};

export type AssessmentSubmissionMcqAnswersCreateFieldInput = {
  edge: HasMcqAnswerPropertiesCreateInput;
  node: McqQuestionCreateInput;
};

export type AssessmentSubmissionMcqAnswersDeleteFieldInput = {
  delete?: InputMaybe<McqQuestionDeleteInput>;
  where?: InputMaybe<AssessmentSubmissionMcqAnswersConnectionWhere>;
};

export type AssessmentSubmissionMcqAnswersDisconnectFieldInput = {
  disconnect?: InputMaybe<McqQuestionDisconnectInput>;
  where?: InputMaybe<AssessmentSubmissionMcqAnswersConnectionWhere>;
};

export type AssessmentSubmissionMcqAnswersFieldInput = {
  connect?: InputMaybe<Array<AssessmentSubmissionMcqAnswersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssessmentSubmissionMcqAnswersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssessmentSubmissionMcqAnswersCreateFieldInput>>;
};

export type AssessmentSubmissionMcqAnswersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AssessmentSubmissionMcqAnswersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AssessmentSubmissionMcqAnswersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AssessmentSubmissionMcqAnswersNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  explanation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  explanation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  explanation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  explanation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  explanation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  explanation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  explanation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  explanation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  explanation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  explanation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  explanation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  explanation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  explanation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  explanation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  explanation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  question_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  question_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalScore_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type AssessmentSubmissionMcqAnswersRelationship = {
  __typename?: 'AssessmentSubmissionMcqAnswersRelationship';
  cursor: Scalars['String']['output'];
  node: McqQuestion;
  properties: HasMcqAnswerProperties;
};

export type AssessmentSubmissionMcqAnswersUpdateConnectionInput = {
  edge?: InputMaybe<HasMcqAnswerPropertiesUpdateInput>;
  node?: InputMaybe<McqQuestionUpdateInput>;
};

export type AssessmentSubmissionMcqAnswersUpdateFieldInput = {
  connect?: InputMaybe<Array<AssessmentSubmissionMcqAnswersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssessmentSubmissionMcqAnswersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssessmentSubmissionMcqAnswersCreateFieldInput>>;
  delete?: InputMaybe<Array<AssessmentSubmissionMcqAnswersDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AssessmentSubmissionMcqAnswersDisconnectFieldInput>>;
  update?: InputMaybe<AssessmentSubmissionMcqAnswersUpdateConnectionInput>;
  where?: InputMaybe<AssessmentSubmissionMcqAnswersConnectionWhere>;
};

export type AssessmentSubmissionMcqQuestionMcqAnswersAggregationSelection = {
  __typename?: 'AssessmentSubmissionMcqQuestionMcqAnswersAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<AssessmentSubmissionMcqQuestionMcqAnswersEdgeAggregateSelection>;
  node?: Maybe<AssessmentSubmissionMcqQuestionMcqAnswersNodeAggregateSelection>;
};

export type AssessmentSubmissionMcqQuestionMcqAnswersEdgeAggregateSelection = {
  __typename?: 'AssessmentSubmissionMcqQuestionMcqAnswersEdgeAggregateSelection';
  answeredAt: DateTimeAggregateSelection;
  pointsAwarded: FloatAggregateSelection;
};

export type AssessmentSubmissionMcqQuestionMcqAnswersNodeAggregateSelection = {
  __typename?: 'AssessmentSubmissionMcqQuestionMcqAnswersNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  explanation: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  order: IntAggregateSelection;
  question: StringAggregateSelection;
  totalScore: FloatAggregateSelection;
};

export type AssessmentSubmissionOnCreateInput = {
  aiTotalPoints?: InputMaybe<Scalars['Float']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  hasTeacherAdjustedGrade?: InputMaybe<Scalars['Boolean']['input']>;
  hasTeacherGraded?: InputMaybe<Scalars['Boolean']['input']>;
  isEvaluationPending?: InputMaybe<Scalars['Boolean']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  maximumPoints?: InputMaybe<Scalars['Float']['input']>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<AssessmentSubmissionStatus>;
  timeLimit?: InputMaybe<Scalars['Int']['input']>;
  totalPoints?: InputMaybe<Scalars['Float']['input']>;
};

export type AssessmentSubmissionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AssessmentSubmissionSort objects to sort AssessmentSubmissions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AssessmentSubmissionSort>>;
};

export type AssessmentSubmissionQuestion = {
  __typename?: 'AssessmentSubmissionQuestion';
  id: Scalars['ID']['output'];
  question?: Maybe<Scalars['String']['output']>;
  rubrics?: Maybe<Array<Maybe<AssessmentSubmissionRubric>>>;
  totalScore?: Maybe<Scalars['Float']['output']>;
  userAnswer?: Maybe<AssessmentSubmissionUserAnswer>;
};

export type AssessmentSubmissionQuestionQuestionsAggregationSelection = {
  __typename?: 'AssessmentSubmissionQuestionQuestionsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<AssessmentSubmissionQuestionQuestionsEdgeAggregateSelection>;
  node?: Maybe<AssessmentSubmissionQuestionQuestionsNodeAggregateSelection>;
};

export type AssessmentSubmissionQuestionQuestionsEdgeAggregateSelection = {
  __typename?: 'AssessmentSubmissionQuestionQuestionsEdgeAggregateSelection';
  aiTotalPoints: FloatAggregateSelection;
  answer: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  maximumPoints: FloatAggregateSelection;
  totalPoints: FloatAggregateSelection;
};

export type AssessmentSubmissionQuestionQuestionsNodeAggregateSelection = {
  __typename?: 'AssessmentSubmissionQuestionQuestionsNodeAggregateSelection';
  id: IdAggregateSelection;
  question: StringAggregateSelection;
  totalScore: FloatAggregateSelection;
};

export type AssessmentSubmissionQuestionsAggregateInput = {
  AND?: InputMaybe<Array<AssessmentSubmissionQuestionsAggregateInput>>;
  NOT?: InputMaybe<AssessmentSubmissionQuestionsAggregateInput>;
  OR?: InputMaybe<Array<AssessmentSubmissionQuestionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasAnswerPropertiesAggregationWhereInput>;
  node?: InputMaybe<AssessmentSubmissionQuestionsNodeAggregationWhereInput>;
};

export type AssessmentSubmissionQuestionsConnectFieldInput = {
  connect?: InputMaybe<Array<QuestionConnectInput>>;
  edge?: InputMaybe<HasAnswerPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<QuestionConnectWhere>;
};

export type AssessmentSubmissionQuestionsConnectOrCreateFieldInput = {
  onCreate: AssessmentSubmissionQuestionsConnectOrCreateFieldInputOnCreate;
  where: QuestionConnectOrCreateWhere;
};

export type AssessmentSubmissionQuestionsConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<HasAnswerPropertiesCreateInput>;
  node: QuestionOnCreateInput;
};

export type AssessmentSubmissionQuestionsConnection = {
  __typename?: 'AssessmentSubmissionQuestionsConnection';
  edges: Array<AssessmentSubmissionQuestionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssessmentSubmissionQuestionsConnectionSort = {
  edge?: InputMaybe<HasAnswerPropertiesSort>;
  node?: InputMaybe<QuestionSort>;
};

export type AssessmentSubmissionQuestionsConnectionWhere = {
  AND?: InputMaybe<Array<AssessmentSubmissionQuestionsConnectionWhere>>;
  NOT?: InputMaybe<AssessmentSubmissionQuestionsConnectionWhere>;
  OR?: InputMaybe<Array<AssessmentSubmissionQuestionsConnectionWhere>>;
  edge?: InputMaybe<HasAnswerPropertiesWhere>;
  node?: InputMaybe<QuestionWhere>;
};

export type AssessmentSubmissionQuestionsCreateFieldInput = {
  edge?: InputMaybe<HasAnswerPropertiesCreateInput>;
  node: QuestionCreateInput;
};

export type AssessmentSubmissionQuestionsDeleteFieldInput = {
  delete?: InputMaybe<QuestionDeleteInput>;
  where?: InputMaybe<AssessmentSubmissionQuestionsConnectionWhere>;
};

export type AssessmentSubmissionQuestionsDisconnectFieldInput = {
  disconnect?: InputMaybe<QuestionDisconnectInput>;
  where?: InputMaybe<AssessmentSubmissionQuestionsConnectionWhere>;
};

export type AssessmentSubmissionQuestionsFieldInput = {
  connect?: InputMaybe<Array<AssessmentSubmissionQuestionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssessmentSubmissionQuestionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssessmentSubmissionQuestionsCreateFieldInput>>;
};

export type AssessmentSubmissionQuestionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AssessmentSubmissionQuestionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AssessmentSubmissionQuestionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AssessmentSubmissionQuestionsNodeAggregationWhereInput>>;
  question_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  question_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalScore_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type AssessmentSubmissionQuestionsRelationship = {
  __typename?: 'AssessmentSubmissionQuestionsRelationship';
  cursor: Scalars['String']['output'];
  node: Question;
  properties: HasAnswerProperties;
};

export type AssessmentSubmissionQuestionsUpdateConnectionInput = {
  edge?: InputMaybe<HasAnswerPropertiesUpdateInput>;
  node?: InputMaybe<QuestionUpdateInput>;
};

export type AssessmentSubmissionQuestionsUpdateFieldInput = {
  connect?: InputMaybe<Array<AssessmentSubmissionQuestionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssessmentSubmissionQuestionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssessmentSubmissionQuestionsCreateFieldInput>>;
  delete?: InputMaybe<Array<AssessmentSubmissionQuestionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AssessmentSubmissionQuestionsDisconnectFieldInput>>;
  update?: InputMaybe<AssessmentSubmissionQuestionsUpdateConnectionInput>;
  where?: InputMaybe<AssessmentSubmissionQuestionsConnectionWhere>;
};

export type AssessmentSubmissionResponse = {
  __typename?: 'AssessmentSubmissionResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<AssessmentSubmission>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AssessmentSubmissionRubric = {
  __typename?: 'AssessmentSubmissionRubric';
  aiPointsAwarded?: Maybe<Scalars['Float']['output']>;
  component?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  maxPoints?: Maybe<Scalars['Float']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  pointsAwarded?: Maybe<Scalars['Float']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
};

export type AssessmentSubmissionRubricRubricsAggregationSelection = {
  __typename?: 'AssessmentSubmissionRubricRubricsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<AssessmentSubmissionRubricRubricsEdgeAggregateSelection>;
  node?: Maybe<AssessmentSubmissionRubricRubricsNodeAggregateSelection>;
};

export type AssessmentSubmissionRubricRubricsEdgeAggregateSelection = {
  __typename?: 'AssessmentSubmissionRubricRubricsEdgeAggregateSelection';
  aiPointsAwarded: FloatAggregateSelection;
  maxPoints: FloatAggregateSelection;
  pointsAwarded: FloatAggregateSelection;
  remarks: StringAggregateSelection;
};

export type AssessmentSubmissionRubricRubricsNodeAggregateSelection = {
  __typename?: 'AssessmentSubmissionRubricRubricsNodeAggregateSelection';
  component: StringAggregateSelection;
  id: IdAggregateSelection;
  points: FloatAggregateSelection;
};

export type AssessmentSubmissionRubricsAggregateInput = {
  AND?: InputMaybe<Array<AssessmentSubmissionRubricsAggregateInput>>;
  NOT?: InputMaybe<AssessmentSubmissionRubricsAggregateInput>;
  OR?: InputMaybe<Array<AssessmentSubmissionRubricsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasRubricPropertiesAggregationWhereInput>;
  node?: InputMaybe<AssessmentSubmissionRubricsNodeAggregationWhereInput>;
};

export type AssessmentSubmissionRubricsConnectFieldInput = {
  connect?: InputMaybe<Array<RubricConnectInput>>;
  edge?: InputMaybe<HasRubricPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<RubricConnectWhere>;
};

export type AssessmentSubmissionRubricsConnectOrCreateFieldInput = {
  onCreate: AssessmentSubmissionRubricsConnectOrCreateFieldInputOnCreate;
  where: RubricConnectOrCreateWhere;
};

export type AssessmentSubmissionRubricsConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<HasRubricPropertiesCreateInput>;
  node: RubricOnCreateInput;
};

export type AssessmentSubmissionRubricsConnection = {
  __typename?: 'AssessmentSubmissionRubricsConnection';
  edges: Array<AssessmentSubmissionRubricsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssessmentSubmissionRubricsConnectionSort = {
  edge?: InputMaybe<HasRubricPropertiesSort>;
  node?: InputMaybe<RubricSort>;
};

export type AssessmentSubmissionRubricsConnectionWhere = {
  AND?: InputMaybe<Array<AssessmentSubmissionRubricsConnectionWhere>>;
  NOT?: InputMaybe<AssessmentSubmissionRubricsConnectionWhere>;
  OR?: InputMaybe<Array<AssessmentSubmissionRubricsConnectionWhere>>;
  edge?: InputMaybe<HasRubricPropertiesWhere>;
  node?: InputMaybe<RubricWhere>;
};

export type AssessmentSubmissionRubricsCreateFieldInput = {
  edge?: InputMaybe<HasRubricPropertiesCreateInput>;
  node: RubricCreateInput;
};

export type AssessmentSubmissionRubricsDeleteFieldInput = {
  delete?: InputMaybe<RubricDeleteInput>;
  where?: InputMaybe<AssessmentSubmissionRubricsConnectionWhere>;
};

export type AssessmentSubmissionRubricsDisconnectFieldInput = {
  disconnect?: InputMaybe<RubricDisconnectInput>;
  where?: InputMaybe<AssessmentSubmissionRubricsConnectionWhere>;
};

export type AssessmentSubmissionRubricsFieldInput = {
  connect?: InputMaybe<Array<AssessmentSubmissionRubricsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssessmentSubmissionRubricsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssessmentSubmissionRubricsCreateFieldInput>>;
};

export type AssessmentSubmissionRubricsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AssessmentSubmissionRubricsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AssessmentSubmissionRubricsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AssessmentSubmissionRubricsNodeAggregationWhereInput>>;
  component_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  component_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  component_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  component_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  component_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  component_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  component_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  component_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  component_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  component_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  component_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  component_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  component_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  component_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  component_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  points_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  points_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  points_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  points_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  points_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  points_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  points_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  points_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  points_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type AssessmentSubmissionRubricsRelationship = {
  __typename?: 'AssessmentSubmissionRubricsRelationship';
  cursor: Scalars['String']['output'];
  node: Rubric;
  properties: HasRubricProperties;
};

export type AssessmentSubmissionRubricsUpdateConnectionInput = {
  edge?: InputMaybe<HasRubricPropertiesUpdateInput>;
  node?: InputMaybe<RubricUpdateInput>;
};

export type AssessmentSubmissionRubricsUpdateFieldInput = {
  connect?: InputMaybe<Array<AssessmentSubmissionRubricsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssessmentSubmissionRubricsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssessmentSubmissionRubricsCreateFieldInput>>;
  delete?: InputMaybe<Array<AssessmentSubmissionRubricsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AssessmentSubmissionRubricsDisconnectFieldInput>>;
  update?: InputMaybe<AssessmentSubmissionRubricsUpdateConnectionInput>;
  where?: InputMaybe<AssessmentSubmissionRubricsConnectionWhere>;
};

/** Fields to sort AssessmentSubmissions by. The order in which sorts are applied is not guaranteed when specifying many fields in one AssessmentSubmissionSort object. */
export type AssessmentSubmissionSort = {
  aiTotalPoints?: InputMaybe<SortDirection>;
  completedAt?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  feedback?: InputMaybe<SortDirection>;
  hasTeacherAdjustedGrade?: InputMaybe<SortDirection>;
  hasTeacherGraded?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isEvaluationPending?: InputMaybe<SortDirection>;
  lastModified?: InputMaybe<SortDirection>;
  maximumPoints?: InputMaybe<SortDirection>;
  startedAt?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  timeLimit?: InputMaybe<SortDirection>;
  totalPoints?: InputMaybe<SortDirection>;
};

export enum AssessmentSubmissionStatus {
  Completed = 'COMPLETED',
  Running = 'RUNNING'
}

export type AssessmentSubmissionUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type AssessmentSubmissionUpdateInput = {
  aiTotalPoints?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_ADD?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  assessment?: InputMaybe<AssessmentSubmissionAssessmentUpdateFieldInput>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  hasTeacherAdjustedGrade?: InputMaybe<Scalars['Boolean']['input']>;
  hasTeacherGraded?: InputMaybe<Scalars['Boolean']['input']>;
  isEvaluationPending?: InputMaybe<Scalars['Boolean']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  maximumPoints?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_ADD?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  mcqAnswers?: InputMaybe<Array<AssessmentSubmissionMcqAnswersUpdateFieldInput>>;
  questions?: InputMaybe<Array<AssessmentSubmissionQuestionsUpdateFieldInput>>;
  rubrics?: InputMaybe<Array<AssessmentSubmissionRubricsUpdateFieldInput>>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<AssessmentSubmissionStatus>;
  timeLimit?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  totalPoints?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_ADD?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  user?: InputMaybe<AssessmentSubmissionUserUpdateFieldInput>;
};

export type AssessmentSubmissionUserAggregateInput = {
  AND?: InputMaybe<Array<AssessmentSubmissionUserAggregateInput>>;
  NOT?: InputMaybe<AssessmentSubmissionUserAggregateInput>;
  OR?: InputMaybe<Array<AssessmentSubmissionUserAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AssessmentSubmissionUserNodeAggregationWhereInput>;
};

export type AssessmentSubmissionUserAnswer = {
  __typename?: 'AssessmentSubmissionUserAnswer';
  aiTotalPoints?: Maybe<Scalars['Float']['output']>;
  answer?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  maximumPoints?: Maybe<Scalars['Float']['output']>;
  totalPoints?: Maybe<Scalars['Float']['output']>;
};

export type AssessmentSubmissionUserConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type AssessmentSubmissionUserConnectOrCreateFieldInput = {
  onCreate: AssessmentSubmissionUserConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type AssessmentSubmissionUserConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type AssessmentSubmissionUserConnection = {
  __typename?: 'AssessmentSubmissionUserConnection';
  edges: Array<AssessmentSubmissionUserRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssessmentSubmissionUserConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type AssessmentSubmissionUserConnectionWhere = {
  AND?: InputMaybe<Array<AssessmentSubmissionUserConnectionWhere>>;
  NOT?: InputMaybe<AssessmentSubmissionUserConnectionWhere>;
  OR?: InputMaybe<Array<AssessmentSubmissionUserConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type AssessmentSubmissionUserCreateFieldInput = {
  node: UserCreateInput;
};

export type AssessmentSubmissionUserDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<AssessmentSubmissionUserConnectionWhere>;
};

export type AssessmentSubmissionUserDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<AssessmentSubmissionUserConnectionWhere>;
};

export type AssessmentSubmissionUserFieldInput = {
  connect?: InputMaybe<AssessmentSubmissionUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<AssessmentSubmissionUserConnectOrCreateFieldInput>;
  create?: InputMaybe<AssessmentSubmissionUserCreateFieldInput>;
};

export type AssessmentSubmissionUserNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AssessmentSubmissionUserNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AssessmentSubmissionUserNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AssessmentSubmissionUserNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AssessmentSubmissionUserRelationship = {
  __typename?: 'AssessmentSubmissionUserRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type AssessmentSubmissionUserUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type AssessmentSubmissionUserUpdateFieldInput = {
  connect?: InputMaybe<AssessmentSubmissionUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<AssessmentSubmissionUserConnectOrCreateFieldInput>;
  create?: InputMaybe<AssessmentSubmissionUserCreateFieldInput>;
  delete?: InputMaybe<AssessmentSubmissionUserDeleteFieldInput>;
  disconnect?: InputMaybe<AssessmentSubmissionUserDisconnectFieldInput>;
  update?: InputMaybe<AssessmentSubmissionUserUpdateConnectionInput>;
  where?: InputMaybe<AssessmentSubmissionUserConnectionWhere>;
};

export type AssessmentSubmissionUserUserAggregationSelection = {
  __typename?: 'AssessmentSubmissionUserUserAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AssessmentSubmissionUserUserNodeAggregateSelection>;
};

export type AssessmentSubmissionUserUserNodeAggregateSelection = {
  __typename?: 'AssessmentSubmissionUserUserNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type AssessmentSubmissionWhere = {
  AND?: InputMaybe<Array<AssessmentSubmissionWhere>>;
  NOT?: InputMaybe<AssessmentSubmissionWhere>;
  OR?: InputMaybe<Array<AssessmentSubmissionWhere>>;
  aiTotalPoints?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_GT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  aiTotalPoints_LT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_LTE?: InputMaybe<Scalars['Float']['input']>;
  assessment?: InputMaybe<AssessmentWhere>;
  assessmentAggregate?: InputMaybe<AssessmentSubmissionAssessmentAggregateInput>;
  assessmentConnection?: InputMaybe<AssessmentSubmissionAssessmentConnectionWhere>;
  assessmentConnection_NOT?: InputMaybe<AssessmentSubmissionAssessmentConnectionWhere>;
  assessment_NOT?: InputMaybe<AssessmentWhere>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  completedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  feedback_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  feedback_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  feedback_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  feedback_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  hasTeacherAdjustedGrade?: InputMaybe<Scalars['Boolean']['input']>;
  hasTeacherGraded?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isEvaluationPending?: InputMaybe<Scalars['Boolean']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastModified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  maximumPoints?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_GT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_GTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  maximumPoints_LT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_LTE?: InputMaybe<Scalars['Float']['input']>;
  mcqAnswersAggregate?: InputMaybe<AssessmentSubmissionMcqAnswersAggregateInput>;
  /** Return AssessmentSubmissions where all of the related AssessmentSubmissionMcqAnswersConnections match this filter */
  mcqAnswersConnection_ALL?: InputMaybe<AssessmentSubmissionMcqAnswersConnectionWhere>;
  /** Return AssessmentSubmissions where none of the related AssessmentSubmissionMcqAnswersConnections match this filter */
  mcqAnswersConnection_NONE?: InputMaybe<AssessmentSubmissionMcqAnswersConnectionWhere>;
  /** Return AssessmentSubmissions where one of the related AssessmentSubmissionMcqAnswersConnections match this filter */
  mcqAnswersConnection_SINGLE?: InputMaybe<AssessmentSubmissionMcqAnswersConnectionWhere>;
  /** Return AssessmentSubmissions where some of the related AssessmentSubmissionMcqAnswersConnections match this filter */
  mcqAnswersConnection_SOME?: InputMaybe<AssessmentSubmissionMcqAnswersConnectionWhere>;
  /** Return AssessmentSubmissions where all of the related McqQuestions match this filter */
  mcqAnswers_ALL?: InputMaybe<McqQuestionWhere>;
  /** Return AssessmentSubmissions where none of the related McqQuestions match this filter */
  mcqAnswers_NONE?: InputMaybe<McqQuestionWhere>;
  /** Return AssessmentSubmissions where one of the related McqQuestions match this filter */
  mcqAnswers_SINGLE?: InputMaybe<McqQuestionWhere>;
  /** Return AssessmentSubmissions where some of the related McqQuestions match this filter */
  mcqAnswers_SOME?: InputMaybe<McqQuestionWhere>;
  questionsAggregate?: InputMaybe<AssessmentSubmissionQuestionsAggregateInput>;
  /** Return AssessmentSubmissions where all of the related AssessmentSubmissionQuestionsConnections match this filter */
  questionsConnection_ALL?: InputMaybe<AssessmentSubmissionQuestionsConnectionWhere>;
  /** Return AssessmentSubmissions where none of the related AssessmentSubmissionQuestionsConnections match this filter */
  questionsConnection_NONE?: InputMaybe<AssessmentSubmissionQuestionsConnectionWhere>;
  /** Return AssessmentSubmissions where one of the related AssessmentSubmissionQuestionsConnections match this filter */
  questionsConnection_SINGLE?: InputMaybe<AssessmentSubmissionQuestionsConnectionWhere>;
  /** Return AssessmentSubmissions where some of the related AssessmentSubmissionQuestionsConnections match this filter */
  questionsConnection_SOME?: InputMaybe<AssessmentSubmissionQuestionsConnectionWhere>;
  /** Return AssessmentSubmissions where all of the related Questions match this filter */
  questions_ALL?: InputMaybe<QuestionWhere>;
  /** Return AssessmentSubmissions where none of the related Questions match this filter */
  questions_NONE?: InputMaybe<QuestionWhere>;
  /** Return AssessmentSubmissions where one of the related Questions match this filter */
  questions_SINGLE?: InputMaybe<QuestionWhere>;
  /** Return AssessmentSubmissions where some of the related Questions match this filter */
  questions_SOME?: InputMaybe<QuestionWhere>;
  rubricsAggregate?: InputMaybe<AssessmentSubmissionRubricsAggregateInput>;
  /** Return AssessmentSubmissions where all of the related AssessmentSubmissionRubricsConnections match this filter */
  rubricsConnection_ALL?: InputMaybe<AssessmentSubmissionRubricsConnectionWhere>;
  /** Return AssessmentSubmissions where none of the related AssessmentSubmissionRubricsConnections match this filter */
  rubricsConnection_NONE?: InputMaybe<AssessmentSubmissionRubricsConnectionWhere>;
  /** Return AssessmentSubmissions where one of the related AssessmentSubmissionRubricsConnections match this filter */
  rubricsConnection_SINGLE?: InputMaybe<AssessmentSubmissionRubricsConnectionWhere>;
  /** Return AssessmentSubmissions where some of the related AssessmentSubmissionRubricsConnections match this filter */
  rubricsConnection_SOME?: InputMaybe<AssessmentSubmissionRubricsConnectionWhere>;
  /** Return AssessmentSubmissions where all of the related Rubrics match this filter */
  rubrics_ALL?: InputMaybe<RubricWhere>;
  /** Return AssessmentSubmissions where none of the related Rubrics match this filter */
  rubrics_NONE?: InputMaybe<RubricWhere>;
  /** Return AssessmentSubmissions where one of the related Rubrics match this filter */
  rubrics_SINGLE?: InputMaybe<RubricWhere>;
  /** Return AssessmentSubmissions where some of the related Rubrics match this filter */
  rubrics_SOME?: InputMaybe<RubricWhere>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  startedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<AssessmentSubmissionStatus>;
  status_IN?: InputMaybe<Array<InputMaybe<AssessmentSubmissionStatus>>>;
  timeLimit?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timeLimit_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalPoints?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_GT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  totalPoints_LT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_LTE?: InputMaybe<Scalars['Float']['input']>;
  user?: InputMaybe<UserWhere>;
  userAggregate?: InputMaybe<AssessmentSubmissionUserAggregateInput>;
  userConnection?: InputMaybe<AssessmentSubmissionUserConnectionWhere>;
  userConnection_NOT?: InputMaybe<AssessmentSubmissionUserConnectionWhere>;
  user_NOT?: InputMaybe<UserWhere>;
};

export type AssessmentSubmissionsAggregateInput = {
  AND?: InputMaybe<Array<AssessmentSubmissionsAggregateInput>>;
  NOT?: InputMaybe<AssessmentSubmissionsAggregateInput>;
  OR?: InputMaybe<Array<AssessmentSubmissionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AssessmentSubmissionsNodeAggregationWhereInput>;
};

export type AssessmentSubmissionsConnectFieldInput = {
  connect?: InputMaybe<Array<AssessmentSubmissionConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AssessmentSubmissionConnectWhere>;
};

export type AssessmentSubmissionsConnectOrCreateFieldInput = {
  onCreate: AssessmentSubmissionsConnectOrCreateFieldInputOnCreate;
  where: AssessmentSubmissionConnectOrCreateWhere;
};

export type AssessmentSubmissionsConnectOrCreateFieldInputOnCreate = {
  node: AssessmentSubmissionOnCreateInput;
};

export type AssessmentSubmissionsConnection = {
  __typename?: 'AssessmentSubmissionsConnection';
  edges: Array<AssessmentSubmissionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssessmentSubmissionsConnectionSort = {
  node?: InputMaybe<AssessmentSubmissionSort>;
};

export type AssessmentSubmissionsConnectionWhere = {
  AND?: InputMaybe<Array<AssessmentSubmissionsConnectionWhere>>;
  NOT?: InputMaybe<AssessmentSubmissionsConnectionWhere>;
  OR?: InputMaybe<Array<AssessmentSubmissionsConnectionWhere>>;
  node?: InputMaybe<AssessmentSubmissionWhere>;
};

export type AssessmentSubmissionsCreateFieldInput = {
  node: AssessmentSubmissionCreateInput;
};

export type AssessmentSubmissionsDeleteFieldInput = {
  delete?: InputMaybe<AssessmentSubmissionDeleteInput>;
  where?: InputMaybe<AssessmentSubmissionsConnectionWhere>;
};

export type AssessmentSubmissionsDisconnectFieldInput = {
  disconnect?: InputMaybe<AssessmentSubmissionDisconnectInput>;
  where?: InputMaybe<AssessmentSubmissionsConnectionWhere>;
};

export type AssessmentSubmissionsFieldInput = {
  connect?: InputMaybe<Array<AssessmentSubmissionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssessmentSubmissionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssessmentSubmissionsCreateFieldInput>>;
};

export type AssessmentSubmissionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AssessmentSubmissionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AssessmentSubmissionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AssessmentSubmissionsNodeAggregationWhereInput>>;
  aiTotalPoints_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  completedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  feedback_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  feedback_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  maximumPoints_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  startedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  timeLimit_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalPoints_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type AssessmentSubmissionsRelationship = {
  __typename?: 'AssessmentSubmissionsRelationship';
  cursor: Scalars['String']['output'];
  node: AssessmentSubmission;
};

export type AssessmentSubmissionsUpdateConnectionInput = {
  node?: InputMaybe<AssessmentSubmissionUpdateInput>;
};

export type AssessmentSubmissionsUpdateFieldInput = {
  connect?: InputMaybe<Array<AssessmentSubmissionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssessmentSubmissionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssessmentSubmissionsCreateFieldInput>>;
  delete?: InputMaybe<Array<AssessmentSubmissionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AssessmentSubmissionsDisconnectFieldInput>>;
  update?: InputMaybe<AssessmentSubmissionsUpdateConnectionInput>;
  where?: InputMaybe<AssessmentSubmissionsConnectionWhere>;
};

export enum AssessmentType {
  Mcq = 'MCQ',
  SocraticDialog = 'SOCRATIC_DIALOG'
}

export type AssessmentUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type AssessmentUpdateInput = {
  activityState?: InputMaybe<ActivityState>;
  aiTutors?: InputMaybe<Array<AssessmentAiTutorsUpdateFieldInput>>;
  assessmentType?: InputMaybe<AssessmentType>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  documents?: InputMaybe<Array<AssessmentDocumentsUpdateFieldInput>>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  hasReviews?: InputMaybe<Array<AssessmentHasReviewsUpdateFieldInput>>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  mcqQuestions?: InputMaybe<Array<AssessmentMcqQuestionsUpdateFieldInput>>;
  moduleHasAssessment?: InputMaybe<AssessmentModuleHasAssessmentUpdateFieldInput>;
  nudgesAboutThis?: InputMaybe<Array<AssessmentNudgesAboutThisUpdateFieldInput>>;
  numberOfQuestions?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  socraticQuestions?: InputMaybe<Array<AssessmentSocraticQuestionsUpdateFieldInput>>;
  submissions?: InputMaybe<Array<AssessmentSubmissionsUpdateFieldInput>>;
  timeLimit?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
};

export type AssessmentWhere = {
  AND?: InputMaybe<Array<AssessmentWhere>>;
  NOT?: InputMaybe<AssessmentWhere>;
  OR?: InputMaybe<Array<AssessmentWhere>>;
  activityState?: InputMaybe<ActivityState>;
  activityState_IN?: InputMaybe<Array<InputMaybe<ActivityState>>>;
  aiTutorsAggregate?: InputMaybe<AssessmentAiTutorsAggregateInput>;
  /** Return Assessments where all of the related AssessmentAiTutorsConnections match this filter */
  aiTutorsConnection_ALL?: InputMaybe<AssessmentAiTutorsConnectionWhere>;
  /** Return Assessments where none of the related AssessmentAiTutorsConnections match this filter */
  aiTutorsConnection_NONE?: InputMaybe<AssessmentAiTutorsConnectionWhere>;
  /** Return Assessments where one of the related AssessmentAiTutorsConnections match this filter */
  aiTutorsConnection_SINGLE?: InputMaybe<AssessmentAiTutorsConnectionWhere>;
  /** Return Assessments where some of the related AssessmentAiTutorsConnections match this filter */
  aiTutorsConnection_SOME?: InputMaybe<AssessmentAiTutorsConnectionWhere>;
  /** Return Assessments where all of the related AITutors match this filter */
  aiTutors_ALL?: InputMaybe<AiTutorWhere>;
  /** Return Assessments where none of the related AITutors match this filter */
  aiTutors_NONE?: InputMaybe<AiTutorWhere>;
  /** Return Assessments where one of the related AITutors match this filter */
  aiTutors_SINGLE?: InputMaybe<AiTutorWhere>;
  /** Return Assessments where some of the related AITutors match this filter */
  aiTutors_SOME?: InputMaybe<AiTutorWhere>;
  assessmentType?: InputMaybe<AssessmentType>;
  assessmentType_IN?: InputMaybe<Array<InputMaybe<AssessmentType>>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  documentsAggregate?: InputMaybe<AssessmentDocumentsAggregateInput>;
  /** Return Assessments where all of the related AssessmentDocumentsConnections match this filter */
  documentsConnection_ALL?: InputMaybe<AssessmentDocumentsConnectionWhere>;
  /** Return Assessments where none of the related AssessmentDocumentsConnections match this filter */
  documentsConnection_NONE?: InputMaybe<AssessmentDocumentsConnectionWhere>;
  /** Return Assessments where one of the related AssessmentDocumentsConnections match this filter */
  documentsConnection_SINGLE?: InputMaybe<AssessmentDocumentsConnectionWhere>;
  /** Return Assessments where some of the related AssessmentDocumentsConnections match this filter */
  documentsConnection_SOME?: InputMaybe<AssessmentDocumentsConnectionWhere>;
  /** Return Assessments where all of the related Documents match this filter */
  documents_ALL?: InputMaybe<DocumentWhere>;
  /** Return Assessments where none of the related Documents match this filter */
  documents_NONE?: InputMaybe<DocumentWhere>;
  /** Return Assessments where one of the related Documents match this filter */
  documents_SINGLE?: InputMaybe<DocumentWhere>;
  /** Return Assessments where some of the related Documents match this filter */
  documents_SOME?: InputMaybe<DocumentWhere>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  dueDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  hasReviewsAggregate?: InputMaybe<AssessmentHasReviewsAggregateInput>;
  /** Return Assessments where all of the related AssessmentHasReviewsConnections match this filter */
  hasReviewsConnection_ALL?: InputMaybe<AssessmentHasReviewsConnectionWhere>;
  /** Return Assessments where none of the related AssessmentHasReviewsConnections match this filter */
  hasReviewsConnection_NONE?: InputMaybe<AssessmentHasReviewsConnectionWhere>;
  /** Return Assessments where one of the related AssessmentHasReviewsConnections match this filter */
  hasReviewsConnection_SINGLE?: InputMaybe<AssessmentHasReviewsConnectionWhere>;
  /** Return Assessments where some of the related AssessmentHasReviewsConnections match this filter */
  hasReviewsConnection_SOME?: InputMaybe<AssessmentHasReviewsConnectionWhere>;
  /** Return Assessments where all of the related Reviews match this filter */
  hasReviews_ALL?: InputMaybe<ReviewWhere>;
  /** Return Assessments where none of the related Reviews match this filter */
  hasReviews_NONE?: InputMaybe<ReviewWhere>;
  /** Return Assessments where one of the related Reviews match this filter */
  hasReviews_SINGLE?: InputMaybe<ReviewWhere>;
  /** Return Assessments where some of the related Reviews match this filter */
  hasReviews_SOME?: InputMaybe<ReviewWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastModified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  mcqQuestionsAggregate?: InputMaybe<AssessmentMcqQuestionsAggregateInput>;
  /** Return Assessments where all of the related AssessmentMcqQuestionsConnections match this filter */
  mcqQuestionsConnection_ALL?: InputMaybe<AssessmentMcqQuestionsConnectionWhere>;
  /** Return Assessments where none of the related AssessmentMcqQuestionsConnections match this filter */
  mcqQuestionsConnection_NONE?: InputMaybe<AssessmentMcqQuestionsConnectionWhere>;
  /** Return Assessments where one of the related AssessmentMcqQuestionsConnections match this filter */
  mcqQuestionsConnection_SINGLE?: InputMaybe<AssessmentMcqQuestionsConnectionWhere>;
  /** Return Assessments where some of the related AssessmentMcqQuestionsConnections match this filter */
  mcqQuestionsConnection_SOME?: InputMaybe<AssessmentMcqQuestionsConnectionWhere>;
  /** Return Assessments where all of the related McqQuestions match this filter */
  mcqQuestions_ALL?: InputMaybe<McqQuestionWhere>;
  /** Return Assessments where none of the related McqQuestions match this filter */
  mcqQuestions_NONE?: InputMaybe<McqQuestionWhere>;
  /** Return Assessments where one of the related McqQuestions match this filter */
  mcqQuestions_SINGLE?: InputMaybe<McqQuestionWhere>;
  /** Return Assessments where some of the related McqQuestions match this filter */
  mcqQuestions_SOME?: InputMaybe<McqQuestionWhere>;
  moduleHasAssessment?: InputMaybe<ModuleWhere>;
  moduleHasAssessmentAggregate?: InputMaybe<AssessmentModuleHasAssessmentAggregateInput>;
  moduleHasAssessmentConnection?: InputMaybe<AssessmentModuleHasAssessmentConnectionWhere>;
  moduleHasAssessmentConnection_NOT?: InputMaybe<AssessmentModuleHasAssessmentConnectionWhere>;
  moduleHasAssessment_NOT?: InputMaybe<ModuleWhere>;
  nudgesAboutThisAggregate?: InputMaybe<AssessmentNudgesAboutThisAggregateInput>;
  /** Return Assessments where all of the related AssessmentNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_ALL?: InputMaybe<AssessmentNudgesAboutThisConnectionWhere>;
  /** Return Assessments where none of the related AssessmentNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_NONE?: InputMaybe<AssessmentNudgesAboutThisConnectionWhere>;
  /** Return Assessments where one of the related AssessmentNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_SINGLE?: InputMaybe<AssessmentNudgesAboutThisConnectionWhere>;
  /** Return Assessments where some of the related AssessmentNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_SOME?: InputMaybe<AssessmentNudgesAboutThisConnectionWhere>;
  /** Return Assessments where all of the related Nudges match this filter */
  nudgesAboutThis_ALL?: InputMaybe<NudgeWhere>;
  /** Return Assessments where none of the related Nudges match this filter */
  nudgesAboutThis_NONE?: InputMaybe<NudgeWhere>;
  /** Return Assessments where one of the related Nudges match this filter */
  nudgesAboutThis_SINGLE?: InputMaybe<NudgeWhere>;
  /** Return Assessments where some of the related Nudges match this filter */
  nudgesAboutThis_SOME?: InputMaybe<NudgeWhere>;
  numberOfQuestions?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  numberOfQuestions_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  scheduledDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  socraticQuestionsAggregate?: InputMaybe<AssessmentSocraticQuestionsAggregateInput>;
  /** Return Assessments where all of the related AssessmentSocraticQuestionsConnections match this filter */
  socraticQuestionsConnection_ALL?: InputMaybe<AssessmentSocraticQuestionsConnectionWhere>;
  /** Return Assessments where none of the related AssessmentSocraticQuestionsConnections match this filter */
  socraticQuestionsConnection_NONE?: InputMaybe<AssessmentSocraticQuestionsConnectionWhere>;
  /** Return Assessments where one of the related AssessmentSocraticQuestionsConnections match this filter */
  socraticQuestionsConnection_SINGLE?: InputMaybe<AssessmentSocraticQuestionsConnectionWhere>;
  /** Return Assessments where some of the related AssessmentSocraticQuestionsConnections match this filter */
  socraticQuestionsConnection_SOME?: InputMaybe<AssessmentSocraticQuestionsConnectionWhere>;
  /** Return Assessments where all of the related Questions match this filter */
  socraticQuestions_ALL?: InputMaybe<QuestionWhere>;
  /** Return Assessments where none of the related Questions match this filter */
  socraticQuestions_NONE?: InputMaybe<QuestionWhere>;
  /** Return Assessments where one of the related Questions match this filter */
  socraticQuestions_SINGLE?: InputMaybe<QuestionWhere>;
  /** Return Assessments where some of the related Questions match this filter */
  socraticQuestions_SOME?: InputMaybe<QuestionWhere>;
  submissionsAggregate?: InputMaybe<AssessmentSubmissionsAggregateInput>;
  /** Return Assessments where all of the related AssessmentSubmissionsConnections match this filter */
  submissionsConnection_ALL?: InputMaybe<AssessmentSubmissionsConnectionWhere>;
  /** Return Assessments where none of the related AssessmentSubmissionsConnections match this filter */
  submissionsConnection_NONE?: InputMaybe<AssessmentSubmissionsConnectionWhere>;
  /** Return Assessments where one of the related AssessmentSubmissionsConnections match this filter */
  submissionsConnection_SINGLE?: InputMaybe<AssessmentSubmissionsConnectionWhere>;
  /** Return Assessments where some of the related AssessmentSubmissionsConnections match this filter */
  submissionsConnection_SOME?: InputMaybe<AssessmentSubmissionsConnectionWhere>;
  /** Return Assessments where all of the related AssessmentSubmissions match this filter */
  submissions_ALL?: InputMaybe<AssessmentSubmissionWhere>;
  /** Return Assessments where none of the related AssessmentSubmissions match this filter */
  submissions_NONE?: InputMaybe<AssessmentSubmissionWhere>;
  /** Return Assessments where one of the related AssessmentSubmissions match this filter */
  submissions_SINGLE?: InputMaybe<AssessmentSubmissionWhere>;
  /** Return Assessments where some of the related AssessmentSubmissions match this filter */
  submissions_SOME?: InputMaybe<AssessmentSubmissionWhere>;
  timeLimit?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timeLimit_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AssignedQuest = {
  __typename?: 'AssignedQuest';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isComplete: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type Assignment = {
  __typename?: 'Assignment';
  _empty?: Maybe<Scalars['String']['output']>;
  activityState?: Maybe<ActivityState>;
  allowed_attempts?: Maybe<Scalars['Float']['output']>;
  anonymize_students?: Maybe<Scalars['Boolean']['output']>;
  anonymous_grading?: Maybe<Scalars['Boolean']['output']>;
  anonymous_instructor_annotations?: Maybe<Scalars['Boolean']['output']>;
  anonymous_peer_reviews?: Maybe<Scalars['Boolean']['output']>;
  assignee_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  assignee_mode?: Maybe<Scalars['String']['output']>;
  assignment_group_id?: Maybe<Scalars['Float']['output']>;
  assignment_name?: Maybe<Scalars['String']['output']>;
  automatic_peer_reviews?: Maybe<Scalars['Boolean']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  can_duplicate?: Maybe<Scalars['Boolean']['output']>;
  category_id?: Maybe<Scalars['String']['output']>;
  courseCategoriesHasAssignment: Array<CourseCategory>;
  courseCategoriesHasAssignmentAggregate?: Maybe<AssignmentCourseCategoryCourseCategoriesHasAssignmentAggregationSelection>;
  courseCategoriesHasAssignmentConnection: AssignmentCourseCategoriesHasAssignmentConnection;
  course_id?: Maybe<Scalars['Float']['output']>;
  coursesHasAssignment: Array<Course>;
  coursesHasAssignmentAggregate?: Maybe<AssignmentCourseCoursesHasAssignmentAggregationSelection>;
  coursesHasAssignmentConnection: AssignmentCoursesHasAssignmentConnection;
  created?: Maybe<Scalars['DateTime']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  description_plaintext?: Maybe<Scalars['String']['output']>;
  discussion_topic_allow_rating?: Maybe<Scalars['Boolean']['output']>;
  discussion_topic_assignment_id?: Maybe<Scalars['Float']['output']>;
  discussion_topic_attachments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  discussion_topic_author_anonymous_id?: Maybe<Scalars['String']['output']>;
  discussion_topic_author_avatar_image_url?: Maybe<Scalars['String']['output']>;
  discussion_topic_author_display_name?: Maybe<Scalars['String']['output']>;
  discussion_topic_author_html_url?: Maybe<Scalars['String']['output']>;
  discussion_topic_author_id?: Maybe<Scalars['Float']['output']>;
  discussion_topic_can_group?: Maybe<Scalars['Boolean']['output']>;
  discussion_topic_can_lock?: Maybe<Scalars['Boolean']['output']>;
  discussion_topic_can_unpublish?: Maybe<Scalars['Boolean']['output']>;
  discussion_topic_comments_disabled?: Maybe<Scalars['Boolean']['output']>;
  discussion_topic_created_at?: Maybe<Scalars['String']['output']>;
  discussion_topic_discussion_subentry_count?: Maybe<Scalars['Float']['output']>;
  discussion_topic_discussion_type?: Maybe<Scalars['String']['output']>;
  discussion_topic_group_topic_children?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  discussion_topic_html_url?: Maybe<Scalars['String']['output']>;
  discussion_topic_id?: Maybe<Scalars['Float']['output']>;
  discussion_topic_is_announcement?: Maybe<Scalars['Boolean']['output']>;
  discussion_topic_is_section_specific?: Maybe<Scalars['Boolean']['output']>;
  discussion_topic_last_reply_at?: Maybe<Scalars['String']['output']>;
  discussion_topic_locked?: Maybe<Scalars['Boolean']['output']>;
  discussion_topic_locked_for_user?: Maybe<Scalars['Boolean']['output']>;
  discussion_topic_message?: Maybe<Scalars['String']['output']>;
  discussion_topic_only_graders_can_rate?: Maybe<Scalars['Boolean']['output']>;
  discussion_topic_permissions_attach?: Maybe<Scalars['Boolean']['output']>;
  discussion_topic_permissions_delete?: Maybe<Scalars['Boolean']['output']>;
  discussion_topic_permissions_manage_assign_to?: Maybe<Scalars['Boolean']['output']>;
  discussion_topic_permissions_reply?: Maybe<Scalars['Boolean']['output']>;
  discussion_topic_permissions_update?: Maybe<Scalars['Boolean']['output']>;
  discussion_topic_pinned?: Maybe<Scalars['Boolean']['output']>;
  discussion_topic_podcast_has_student_posts?: Maybe<Scalars['Boolean']['output']>;
  discussion_topic_posted_at?: Maybe<Scalars['String']['output']>;
  discussion_topic_published?: Maybe<Scalars['Boolean']['output']>;
  discussion_topic_read_state?: Maybe<Scalars['String']['output']>;
  discussion_topic_sort_by_rating?: Maybe<Scalars['Boolean']['output']>;
  discussion_topic_subscribed?: Maybe<Scalars['Boolean']['output']>;
  discussion_topic_summary_enabled?: Maybe<Scalars['Boolean']['output']>;
  discussion_topic_title?: Maybe<Scalars['String']['output']>;
  discussion_topic_topic_children?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  discussion_topic_unread_count?: Maybe<Scalars['Float']['output']>;
  discussion_topic_url?: Maybe<Scalars['String']['output']>;
  discussion_topic_user_can_see_posts?: Maybe<Scalars['Boolean']['output']>;
  discussion_topic_user_name?: Maybe<Scalars['String']['output']>;
  display_date?: Maybe<Scalars['String']['output']>;
  documents: Array<Document>;
  documentsAggregate?: Maybe<AssignmentDocumentDocumentsAggregationSelection>;
  documentsConnection: AssignmentDocumentsConnection;
  due_at?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['DateTime']['output']>;
  due_date_required?: Maybe<Scalars['Boolean']['output']>;
  enableStudentFileUpload?: Maybe<Scalars['Boolean']['output']>;
  end_date?: Maybe<Scalars['String']['output']>;
  external_tool_tag_attributes_content_id?: Maybe<Scalars['Float']['output']>;
  external_tool_tag_attributes_content_type?: Maybe<Scalars['String']['output']>;
  external_tool_tag_attributes_external_data?: Maybe<Scalars['String']['output']>;
  external_tool_tag_attributes_new_tab?: Maybe<Scalars['Boolean']['output']>;
  external_tool_tag_attributes_resource_link_id?: Maybe<Scalars['String']['output']>;
  external_tool_tag_attributes_url?: Maybe<Scalars['String']['output']>;
  files: Array<File>;
  filesAggregate?: Maybe<AssignmentFileFilesAggregationSelection>;
  filesConnection: AssignmentFilesConnection;
  frozen_attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  grade_group_students_individually?: Maybe<Scalars['Boolean']['output']>;
  grade_points?: Maybe<Scalars['Float']['output']>;
  graded_submissions_exist?: Maybe<Scalars['Boolean']['output']>;
  grader_comments_visible_to_graders?: Maybe<Scalars['Boolean']['output']>;
  grader_count?: Maybe<Scalars['Float']['output']>;
  grader_names_visible_to_final_grader?: Maybe<Scalars['Boolean']['output']>;
  graders_anonymous_to_graders?: Maybe<Scalars['Boolean']['output']>;
  grading_type?: Maybe<Scalars['String']['output']>;
  hasChatChats: Array<Chat>;
  hasChatChatsAggregate?: Maybe<AssignmentChatHasChatChatsAggregationSelection>;
  hasChatChatsConnection: AssignmentHasChatChatsConnection;
  hasObjectiveObjective: Array<Objective>;
  hasObjectiveObjectiveAggregate?: Maybe<AssignmentObjectiveHasObjectiveObjectiveAggregationSelection>;
  hasObjectiveObjectiveConnection: AssignmentHasObjectiveObjectiveConnection;
  has_overrides?: Maybe<Scalars['Boolean']['output']>;
  has_submitted_submissions?: Maybe<Scalars['Boolean']['output']>;
  hide_in_gradebook?: Maybe<Scalars['Boolean']['output']>;
  html?: Maybe<Scalars['String']['output']>;
  html_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  important_dates?: Maybe<Scalars['Boolean']['output']>;
  in_closed_grading_period?: Maybe<Scalars['Boolean']['output']>;
  intra_group_peer_reviews?: Maybe<Scalars['Boolean']['output']>;
  is_quiz_assignment?: Maybe<Scalars['Boolean']['output']>;
  is_quiz_lti_assignment?: Maybe<Scalars['Boolean']['output']>;
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  locked_for_user?: Maybe<Scalars['Boolean']['output']>;
  lti_context_id?: Maybe<Scalars['String']['output']>;
  max_attempts?: Maybe<Scalars['Float']['output']>;
  max_name_length?: Maybe<Scalars['Float']['output']>;
  moderated_grading?: Maybe<Scalars['Boolean']['output']>;
  moduleHasAssignments: Array<Module>;
  moduleHasAssignmentsAggregate?: Maybe<AssignmentModuleModuleHasAssignmentsAggregationSelection>;
  moduleHasAssignmentsConnection: AssignmentModuleHasAssignmentsConnection;
  muted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  needs_grading_count?: Maybe<Scalars['Float']['output']>;
  nudgesAboutThis: Array<Nudge>;
  nudgesAboutThisAggregate?: Maybe<AssignmentNudgeNudgesAboutThisAggregationSelection>;
  nudgesAboutThisConnection: AssignmentNudgesAboutThisConnection;
  objectives?: Maybe<Scalars['String']['output']>;
  omit_from_final_grade?: Maybe<Scalars['Boolean']['output']>;
  only_visible_to_overrides?: Maybe<Scalars['Boolean']['output']>;
  peer_reviews?: Maybe<Scalars['Boolean']['output']>;
  points_possible?: Maybe<Scalars['Float']['output']>;
  position?: Maybe<Scalars['Float']['output']>;
  post_manually?: Maybe<Scalars['Boolean']['output']>;
  post_to_sis?: Maybe<Scalars['Boolean']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  require_lockdown_browser?: Maybe<Scalars['Boolean']['output']>;
  resource_metadata?: Maybe<Scalars['String']['output']>;
  restrict_quantitative_data?: Maybe<Scalars['Boolean']['output']>;
  scheduledDate?: Maybe<Scalars['DateTime']['output']>;
  section_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  secure_params?: Maybe<Scalars['String']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  submissions: Array<Submission>;
  submissionsAggregate?: Maybe<AssignmentSubmissionSubmissionsAggregationSelection>;
  submissionsConnection: AssignmentSubmissionsConnection;
  submissions_download_url?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  unpublishable?: Maybe<Scalars['Boolean']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  updated_date?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usersHasSchoolAssignment: Array<User>;
  usersHasSchoolAssignmentAggregate?: Maybe<AssignmentUserUsersHasSchoolAssignmentAggregationSelection>;
  usersHasSchoolAssignmentConnection: AssignmentUsersHasSchoolAssignmentConnection;
  videoUrl?: Maybe<Scalars['String']['output']>;
  visible_to_everyone?: Maybe<Scalars['Boolean']['output']>;
  workflow_state?: Maybe<Scalars['String']['output']>;
  worksheet?: Maybe<Worksheet>;
  worksheetAggregate?: Maybe<AssignmentWorksheetWorksheetAggregationSelection>;
  worksheetConnection: AssignmentWorksheetConnection;
};


export type AssignmentCourseCategoriesHasAssignmentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CourseCategoryOptions>;
  where?: InputMaybe<CourseCategoryWhere>;
};


export type AssignmentCourseCategoriesHasAssignmentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CourseCategoryWhere>;
};


export type AssignmentCourseCategoriesHasAssignmentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AssignmentCourseCategoriesHasAssignmentConnectionSort>>;
  where?: InputMaybe<AssignmentCourseCategoriesHasAssignmentConnectionWhere>;
};


export type AssignmentCoursesHasAssignmentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CourseOptions>;
  where?: InputMaybe<CourseWhere>;
};


export type AssignmentCoursesHasAssignmentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CourseWhere>;
};


export type AssignmentCoursesHasAssignmentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AssignmentCoursesHasAssignmentConnectionSort>>;
  where?: InputMaybe<AssignmentCoursesHasAssignmentConnectionWhere>;
};


export type AssignmentDocumentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DocumentOptions>;
  where?: InputMaybe<DocumentWhere>;
};


export type AssignmentDocumentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DocumentWhere>;
};


export type AssignmentDocumentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AssignmentDocumentsConnectionSort>>;
  where?: InputMaybe<AssignmentDocumentsConnectionWhere>;
};


export type AssignmentFilesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FileOptions>;
  where?: InputMaybe<FileWhere>;
};


export type AssignmentFilesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FileWhere>;
};


export type AssignmentFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AssignmentFilesConnectionSort>>;
  where?: InputMaybe<AssignmentFilesConnectionWhere>;
};


export type AssignmentHasChatChatsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ChatOptions>;
  where?: InputMaybe<ChatWhere>;
};


export type AssignmentHasChatChatsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ChatWhere>;
};


export type AssignmentHasChatChatsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AssignmentHasChatChatsConnectionSort>>;
  where?: InputMaybe<AssignmentHasChatChatsConnectionWhere>;
};


export type AssignmentHasObjectiveObjectiveArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ObjectiveOptions>;
  where?: InputMaybe<ObjectiveWhere>;
};


export type AssignmentHasObjectiveObjectiveAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ObjectiveWhere>;
};


export type AssignmentHasObjectiveObjectiveConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AssignmentHasObjectiveObjectiveConnectionSort>>;
  where?: InputMaybe<AssignmentHasObjectiveObjectiveConnectionWhere>;
};


export type AssignmentModuleHasAssignmentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ModuleOptions>;
  where?: InputMaybe<ModuleWhere>;
};


export type AssignmentModuleHasAssignmentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ModuleWhere>;
};


export type AssignmentModuleHasAssignmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AssignmentModuleHasAssignmentsConnectionSort>>;
  where?: InputMaybe<AssignmentModuleHasAssignmentsConnectionWhere>;
};


export type AssignmentNudgesAboutThisArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<NudgeOptions>;
  where?: InputMaybe<NudgeWhere>;
};


export type AssignmentNudgesAboutThisAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NudgeWhere>;
};


export type AssignmentNudgesAboutThisConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AssignmentNudgesAboutThisConnectionSort>>;
  where?: InputMaybe<AssignmentNudgesAboutThisConnectionWhere>;
};


export type AssignmentSubmissionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SubmissionOptions>;
  where?: InputMaybe<SubmissionWhere>;
};


export type AssignmentSubmissionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SubmissionWhere>;
};


export type AssignmentSubmissionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AssignmentSubmissionsConnectionSort>>;
  where?: InputMaybe<AssignmentSubmissionsConnectionWhere>;
};


export type AssignmentUsersHasSchoolAssignmentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type AssignmentUsersHasSchoolAssignmentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type AssignmentUsersHasSchoolAssignmentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AssignmentUsersHasSchoolAssignmentConnectionSort>>;
  where?: InputMaybe<AssignmentUsersHasSchoolAssignmentConnectionWhere>;
};


export type AssignmentWorksheetArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<WorksheetOptions>;
  where?: InputMaybe<WorksheetWhere>;
};


export type AssignmentWorksheetAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WorksheetWhere>;
};


export type AssignmentWorksheetConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AssignmentWorksheetConnectionSort>>;
  where?: InputMaybe<AssignmentWorksheetConnectionWhere>;
};

export type AssignmentAndSubmission = {
  __typename?: 'AssignmentAndSubmission';
  assignment?: Maybe<Assignment>;
  submission?: Maybe<Submission>;
};

export type AssignmentAndSubmissionResponse = {
  __typename?: 'AssignmentAndSubmissionResponse';
  data?: Maybe<Array<Maybe<AssignmentAndSubmission>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AssignmentChatHasChatChatsAggregationSelection = {
  __typename?: 'AssignmentChatHasChatChatsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<AssignmentChatHasChatChatsEdgeAggregateSelection>;
  node?: Maybe<AssignmentChatHasChatChatsNodeAggregateSelection>;
};

export type AssignmentChatHasChatChatsEdgeAggregateSelection = {
  __typename?: 'AssignmentChatHasChatChatsEdgeAggregateSelection';
  ai_messages_count: IntAggregateSelection;
  average_ai_response_time: FloatAggregateSelection;
  average_student_response_time: FloatAggregateSelection;
  created: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  num_messages: IntAggregateSelection;
  questions_asked: IntAggregateSelection;
  student_messages_count: IntAggregateSelection;
  summary: StringAggregateSelection;
  total_time_taken: FloatAggregateSelection;
};

export type AssignmentChatHasChatChatsNodeAggregateSelection = {
  __typename?: 'AssignmentChatHasChatChatsNodeAggregateSelection';
  context: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  date: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  name: StringAggregateSelection;
  objectId: IdAggregateSelection;
  schemaVersion: IntAggregateSelection;
  timezone: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type AssignmentConnectInput = {
  courseCategoriesHasAssignment?: InputMaybe<Array<AssignmentCourseCategoriesHasAssignmentConnectFieldInput>>;
  coursesHasAssignment?: InputMaybe<Array<AssignmentCoursesHasAssignmentConnectFieldInput>>;
  documents?: InputMaybe<Array<AssignmentDocumentsConnectFieldInput>>;
  files?: InputMaybe<Array<AssignmentFilesConnectFieldInput>>;
  hasChatChats?: InputMaybe<Array<AssignmentHasChatChatsConnectFieldInput>>;
  hasObjectiveObjective?: InputMaybe<Array<AssignmentHasObjectiveObjectiveConnectFieldInput>>;
  moduleHasAssignments?: InputMaybe<Array<AssignmentModuleHasAssignmentsConnectFieldInput>>;
  nudgesAboutThis?: InputMaybe<Array<AssignmentNudgesAboutThisConnectFieldInput>>;
  submissions?: InputMaybe<Array<AssignmentSubmissionsConnectFieldInput>>;
  usersHasSchoolAssignment?: InputMaybe<Array<AssignmentUsersHasSchoolAssignmentConnectFieldInput>>;
  worksheet?: InputMaybe<AssignmentWorksheetConnectFieldInput>;
};

export type AssignmentConnectOrCreateWhere = {
  node: AssignmentUniqueWhere;
};

export type AssignmentConnectWhere = {
  node: AssignmentWhere;
};

export type AssignmentCourseCategoriesHasAssignmentAggregateInput = {
  AND?: InputMaybe<Array<AssignmentCourseCategoriesHasAssignmentAggregateInput>>;
  NOT?: InputMaybe<AssignmentCourseCategoriesHasAssignmentAggregateInput>;
  OR?: InputMaybe<Array<AssignmentCourseCategoriesHasAssignmentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AssignmentCourseCategoriesHasAssignmentNodeAggregationWhereInput>;
};

export type AssignmentCourseCategoriesHasAssignmentConnectFieldInput = {
  connect?: InputMaybe<Array<CourseCategoryConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CourseCategoryConnectWhere>;
};

export type AssignmentCourseCategoriesHasAssignmentConnection = {
  __typename?: 'AssignmentCourseCategoriesHasAssignmentConnection';
  edges: Array<AssignmentCourseCategoriesHasAssignmentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssignmentCourseCategoriesHasAssignmentConnectionSort = {
  node?: InputMaybe<CourseCategorySort>;
};

export type AssignmentCourseCategoriesHasAssignmentConnectionWhere = {
  AND?: InputMaybe<Array<AssignmentCourseCategoriesHasAssignmentConnectionWhere>>;
  NOT?: InputMaybe<AssignmentCourseCategoriesHasAssignmentConnectionWhere>;
  OR?: InputMaybe<Array<AssignmentCourseCategoriesHasAssignmentConnectionWhere>>;
  node?: InputMaybe<CourseCategoryWhere>;
};

export type AssignmentCourseCategoriesHasAssignmentCreateFieldInput = {
  node: CourseCategoryCreateInput;
};

export type AssignmentCourseCategoriesHasAssignmentDeleteFieldInput = {
  delete?: InputMaybe<CourseCategoryDeleteInput>;
  where?: InputMaybe<AssignmentCourseCategoriesHasAssignmentConnectionWhere>;
};

export type AssignmentCourseCategoriesHasAssignmentDisconnectFieldInput = {
  disconnect?: InputMaybe<CourseCategoryDisconnectInput>;
  where?: InputMaybe<AssignmentCourseCategoriesHasAssignmentConnectionWhere>;
};

export type AssignmentCourseCategoriesHasAssignmentFieldInput = {
  connect?: InputMaybe<Array<AssignmentCourseCategoriesHasAssignmentConnectFieldInput>>;
  create?: InputMaybe<Array<AssignmentCourseCategoriesHasAssignmentCreateFieldInput>>;
};

export type AssignmentCourseCategoriesHasAssignmentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AssignmentCourseCategoriesHasAssignmentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AssignmentCourseCategoriesHasAssignmentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AssignmentCourseCategoriesHasAssignmentNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AssignmentCourseCategoriesHasAssignmentRelationship = {
  __typename?: 'AssignmentCourseCategoriesHasAssignmentRelationship';
  cursor: Scalars['String']['output'];
  node: CourseCategory;
};

export type AssignmentCourseCategoriesHasAssignmentUpdateConnectionInput = {
  node?: InputMaybe<CourseCategoryUpdateInput>;
};

export type AssignmentCourseCategoriesHasAssignmentUpdateFieldInput = {
  connect?: InputMaybe<Array<AssignmentCourseCategoriesHasAssignmentConnectFieldInput>>;
  create?: InputMaybe<Array<AssignmentCourseCategoriesHasAssignmentCreateFieldInput>>;
  delete?: InputMaybe<Array<AssignmentCourseCategoriesHasAssignmentDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AssignmentCourseCategoriesHasAssignmentDisconnectFieldInput>>;
  update?: InputMaybe<AssignmentCourseCategoriesHasAssignmentUpdateConnectionInput>;
  where?: InputMaybe<AssignmentCourseCategoriesHasAssignmentConnectionWhere>;
};

export type AssignmentCourseCategoryCourseCategoriesHasAssignmentAggregationSelection = {
  __typename?: 'AssignmentCourseCategoryCourseCategoriesHasAssignmentAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AssignmentCourseCategoryCourseCategoriesHasAssignmentNodeAggregateSelection>;
};

export type AssignmentCourseCategoryCourseCategoriesHasAssignmentNodeAggregateSelection = {
  __typename?: 'AssignmentCourseCategoryCourseCategoriesHasAssignmentNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  title: StringAggregateSelection;
};

export type AssignmentCourseCoursesHasAssignmentAggregationSelection = {
  __typename?: 'AssignmentCourseCoursesHasAssignmentAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AssignmentCourseCoursesHasAssignmentNodeAggregateSelection>;
};

export type AssignmentCourseCoursesHasAssignmentNodeAggregateSelection = {
  __typename?: 'AssignmentCourseCoursesHasAssignmentNodeAggregateSelection';
  account_id: FloatAggregateSelection;
  calendar_ics: StringAggregateSelection;
  cost: FloatAggregateSelection;
  courseId: StringAggregateSelection;
  course_code: StringAggregateSelection;
  course_id: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  default_view: StringAggregateSelection;
  description: StringAggregateSelection;
  dueDateEndDate: DateTimeAggregateSelection;
  dueDateStartDate: DateTimeAggregateSelection;
  endDate: DateTimeAggregateSelection;
  end_at: StringAggregateSelection;
  enrollment_term_id: FloatAggregateSelection;
  grading_standard_id: FloatAggregateSelection;
  id: IdAggregateSelection;
  integration_id: StringAggregateSelection;
  label: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  learningStandards: StringAggregateSelection;
  lengthInWeeks: FloatAggregateSelection;
  license: StringAggregateSelection;
  lti_id: StringAggregateSelection;
  name: StringAggregateSelection;
  original_name: StringAggregateSelection;
  root_account_id: FloatAggregateSelection;
  sis_course_id: StringAggregateSelection;
  sis_import_id: FloatAggregateSelection;
  startDate: DateTimeAggregateSelection;
  start_at: StringAggregateSelection;
  state: StringAggregateSelection;
  storage_quota_mb: FloatAggregateSelection;
  stripePriceId: StringAggregateSelection;
  stripeProductId: StringAggregateSelection;
  targetAudience: StringAggregateSelection;
  thumbnail: StringAggregateSelection;
  time_zone: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  uuid: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export type AssignmentCoursesHasAssignmentAggregateInput = {
  AND?: InputMaybe<Array<AssignmentCoursesHasAssignmentAggregateInput>>;
  NOT?: InputMaybe<AssignmentCoursesHasAssignmentAggregateInput>;
  OR?: InputMaybe<Array<AssignmentCoursesHasAssignmentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AssignmentCoursesHasAssignmentNodeAggregationWhereInput>;
};

export type AssignmentCoursesHasAssignmentConnectFieldInput = {
  connect?: InputMaybe<Array<CourseConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CourseConnectWhere>;
};

export type AssignmentCoursesHasAssignmentConnectOrCreateFieldInput = {
  onCreate: AssignmentCoursesHasAssignmentConnectOrCreateFieldInputOnCreate;
  where: CourseConnectOrCreateWhere;
};

export type AssignmentCoursesHasAssignmentConnectOrCreateFieldInputOnCreate = {
  node: CourseOnCreateInput;
};

export type AssignmentCoursesHasAssignmentConnection = {
  __typename?: 'AssignmentCoursesHasAssignmentConnection';
  edges: Array<AssignmentCoursesHasAssignmentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssignmentCoursesHasAssignmentConnectionSort = {
  node?: InputMaybe<CourseSort>;
};

export type AssignmentCoursesHasAssignmentConnectionWhere = {
  AND?: InputMaybe<Array<AssignmentCoursesHasAssignmentConnectionWhere>>;
  NOT?: InputMaybe<AssignmentCoursesHasAssignmentConnectionWhere>;
  OR?: InputMaybe<Array<AssignmentCoursesHasAssignmentConnectionWhere>>;
  node?: InputMaybe<CourseWhere>;
};

export type AssignmentCoursesHasAssignmentCreateFieldInput = {
  node: CourseCreateInput;
};

export type AssignmentCoursesHasAssignmentDeleteFieldInput = {
  delete?: InputMaybe<CourseDeleteInput>;
  where?: InputMaybe<AssignmentCoursesHasAssignmentConnectionWhere>;
};

export type AssignmentCoursesHasAssignmentDisconnectFieldInput = {
  disconnect?: InputMaybe<CourseDisconnectInput>;
  where?: InputMaybe<AssignmentCoursesHasAssignmentConnectionWhere>;
};

export type AssignmentCoursesHasAssignmentFieldInput = {
  connect?: InputMaybe<Array<AssignmentCoursesHasAssignmentConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssignmentCoursesHasAssignmentConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssignmentCoursesHasAssignmentCreateFieldInput>>;
};

export type AssignmentCoursesHasAssignmentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AssignmentCoursesHasAssignmentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AssignmentCoursesHasAssignmentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AssignmentCoursesHasAssignmentNodeAggregationWhereInput>>;
  account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  cost_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDateEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  enrollment_term_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  label_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningStandards_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthInWeeks_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  root_account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_import_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  startDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  storage_quota_mb_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AssignmentCoursesHasAssignmentRelationship = {
  __typename?: 'AssignmentCoursesHasAssignmentRelationship';
  cursor: Scalars['String']['output'];
  node: Course;
};

export type AssignmentCoursesHasAssignmentUpdateConnectionInput = {
  node?: InputMaybe<CourseUpdateInput>;
};

export type AssignmentCoursesHasAssignmentUpdateFieldInput = {
  connect?: InputMaybe<Array<AssignmentCoursesHasAssignmentConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssignmentCoursesHasAssignmentConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssignmentCoursesHasAssignmentCreateFieldInput>>;
  delete?: InputMaybe<Array<AssignmentCoursesHasAssignmentDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AssignmentCoursesHasAssignmentDisconnectFieldInput>>;
  update?: InputMaybe<AssignmentCoursesHasAssignmentUpdateConnectionInput>;
  where?: InputMaybe<AssignmentCoursesHasAssignmentConnectionWhere>;
};

export type AssignmentCreateInput = {
  _empty?: InputMaybe<Scalars['String']['input']>;
  activityState?: InputMaybe<ActivityState>;
  allowed_attempts?: InputMaybe<Scalars['Float']['input']>;
  anonymize_students?: InputMaybe<Scalars['Boolean']['input']>;
  anonymous_grading?: InputMaybe<Scalars['Boolean']['input']>;
  anonymous_instructor_annotations?: InputMaybe<Scalars['Boolean']['input']>;
  anonymous_peer_reviews?: InputMaybe<Scalars['Boolean']['input']>;
  assignee_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assignee_mode?: InputMaybe<Scalars['String']['input']>;
  assignment_group_id?: InputMaybe<Scalars['Float']['input']>;
  assignment_name?: InputMaybe<Scalars['String']['input']>;
  automatic_peer_reviews?: InputMaybe<Scalars['Boolean']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  can_duplicate?: InputMaybe<Scalars['Boolean']['input']>;
  category_id?: InputMaybe<Scalars['String']['input']>;
  courseCategoriesHasAssignment?: InputMaybe<AssignmentCourseCategoriesHasAssignmentFieldInput>;
  course_id?: InputMaybe<Scalars['Float']['input']>;
  coursesHasAssignment?: InputMaybe<AssignmentCoursesHasAssignmentFieldInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_at?: InputMaybe<Scalars['String']['input']>;
  created_date?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_plaintext?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_allow_rating?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_assignment_id?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_attachments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discussion_topic_author_anonymous_id?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_author_avatar_image_url?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_author_display_name?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_author_html_url?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_author_id?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_can_group?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_can_lock?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_can_unpublish?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_comments_disabled?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_created_at?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_discussion_subentry_count?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_group_topic_children?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discussion_topic_html_url?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_id?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_is_announcement?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_is_section_specific?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_last_reply_at?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_locked?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_locked_for_user?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_message?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_only_graders_can_rate?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_permissions_attach?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_permissions_delete?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_permissions_manage_assign_to?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_permissions_reply?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_permissions_update?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_pinned?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_podcast_has_student_posts?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_posted_at?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_published?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_read_state?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_sort_by_rating?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_subscribed?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_summary_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_title?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_topic_children?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discussion_topic_unread_count?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_user_can_see_posts?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_user_name?: InputMaybe<Scalars['String']['input']>;
  display_date?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<AssignmentDocumentsFieldInput>;
  due_at?: InputMaybe<Scalars['String']['input']>;
  due_date?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_required?: InputMaybe<Scalars['Boolean']['input']>;
  enableStudentFileUpload?: InputMaybe<Scalars['Boolean']['input']>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  external_tool_tag_attributes_content_id?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type?: InputMaybe<Scalars['String']['input']>;
  external_tool_tag_attributes_external_data?: InputMaybe<Scalars['String']['input']>;
  external_tool_tag_attributes_new_tab?: InputMaybe<Scalars['Boolean']['input']>;
  external_tool_tag_attributes_resource_link_id?: InputMaybe<Scalars['String']['input']>;
  external_tool_tag_attributes_url?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<AssignmentFilesFieldInput>;
  frozen_attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grade_group_students_individually?: InputMaybe<Scalars['Boolean']['input']>;
  grade_points?: InputMaybe<Scalars['Float']['input']>;
  graded_submissions_exist?: InputMaybe<Scalars['Boolean']['input']>;
  grader_comments_visible_to_graders?: InputMaybe<Scalars['Boolean']['input']>;
  grader_count?: InputMaybe<Scalars['Float']['input']>;
  grader_names_visible_to_final_grader?: InputMaybe<Scalars['Boolean']['input']>;
  graders_anonymous_to_graders?: InputMaybe<Scalars['Boolean']['input']>;
  grading_type?: InputMaybe<Scalars['String']['input']>;
  hasChatChats?: InputMaybe<AssignmentHasChatChatsFieldInput>;
  hasObjectiveObjective?: InputMaybe<AssignmentHasObjectiveObjectiveFieldInput>;
  has_overrides?: InputMaybe<Scalars['Boolean']['input']>;
  has_submitted_submissions?: InputMaybe<Scalars['Boolean']['input']>;
  hide_in_gradebook?: InputMaybe<Scalars['Boolean']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  html_url?: InputMaybe<Scalars['String']['input']>;
  important_dates?: InputMaybe<Scalars['Boolean']['input']>;
  in_closed_grading_period?: InputMaybe<Scalars['Boolean']['input']>;
  intra_group_peer_reviews?: InputMaybe<Scalars['Boolean']['input']>;
  is_quiz_assignment?: InputMaybe<Scalars['Boolean']['input']>;
  is_quiz_lti_assignment?: InputMaybe<Scalars['Boolean']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  locked_for_user?: InputMaybe<Scalars['Boolean']['input']>;
  lti_context_id?: InputMaybe<Scalars['String']['input']>;
  max_attempts?: InputMaybe<Scalars['Float']['input']>;
  max_name_length?: InputMaybe<Scalars['Float']['input']>;
  moderated_grading?: InputMaybe<Scalars['Boolean']['input']>;
  moduleHasAssignments?: InputMaybe<AssignmentModuleHasAssignmentsFieldInput>;
  muted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  needs_grading_count?: InputMaybe<Scalars['Float']['input']>;
  nudgesAboutThis?: InputMaybe<AssignmentNudgesAboutThisFieldInput>;
  objectives?: InputMaybe<Scalars['String']['input']>;
  omit_from_final_grade?: InputMaybe<Scalars['Boolean']['input']>;
  only_visible_to_overrides?: InputMaybe<Scalars['Boolean']['input']>;
  peer_reviews?: InputMaybe<Scalars['Boolean']['input']>;
  points_possible?: InputMaybe<Scalars['Float']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  post_manually?: InputMaybe<Scalars['Boolean']['input']>;
  post_to_sis?: InputMaybe<Scalars['Boolean']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  require_lockdown_browser?: InputMaybe<Scalars['Boolean']['input']>;
  resource_metadata?: InputMaybe<Scalars['String']['input']>;
  restrict_quantitative_data?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  section_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  secure_params?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  submissions?: InputMaybe<AssignmentSubmissionsFieldInput>;
  submissions_download_url?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unpublishable?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  usersHasSchoolAssignment?: InputMaybe<AssignmentUsersHasSchoolAssignmentFieldInput>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visible_to_everyone?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_state?: InputMaybe<Scalars['String']['input']>;
  worksheet?: InputMaybe<AssignmentWorksheetFieldInput>;
};

export type AssignmentDeleteInput = {
  courseCategoriesHasAssignment?: InputMaybe<Array<AssignmentCourseCategoriesHasAssignmentDeleteFieldInput>>;
  coursesHasAssignment?: InputMaybe<Array<AssignmentCoursesHasAssignmentDeleteFieldInput>>;
  documents?: InputMaybe<Array<AssignmentDocumentsDeleteFieldInput>>;
  files?: InputMaybe<Array<AssignmentFilesDeleteFieldInput>>;
  hasChatChats?: InputMaybe<Array<AssignmentHasChatChatsDeleteFieldInput>>;
  hasObjectiveObjective?: InputMaybe<Array<AssignmentHasObjectiveObjectiveDeleteFieldInput>>;
  moduleHasAssignments?: InputMaybe<Array<AssignmentModuleHasAssignmentsDeleteFieldInput>>;
  nudgesAboutThis?: InputMaybe<Array<AssignmentNudgesAboutThisDeleteFieldInput>>;
  submissions?: InputMaybe<Array<AssignmentSubmissionsDeleteFieldInput>>;
  usersHasSchoolAssignment?: InputMaybe<Array<AssignmentUsersHasSchoolAssignmentDeleteFieldInput>>;
  worksheet?: InputMaybe<AssignmentWorksheetDeleteFieldInput>;
};

export type AssignmentDisconnectInput = {
  courseCategoriesHasAssignment?: InputMaybe<Array<AssignmentCourseCategoriesHasAssignmentDisconnectFieldInput>>;
  coursesHasAssignment?: InputMaybe<Array<AssignmentCoursesHasAssignmentDisconnectFieldInput>>;
  documents?: InputMaybe<Array<AssignmentDocumentsDisconnectFieldInput>>;
  files?: InputMaybe<Array<AssignmentFilesDisconnectFieldInput>>;
  hasChatChats?: InputMaybe<Array<AssignmentHasChatChatsDisconnectFieldInput>>;
  hasObjectiveObjective?: InputMaybe<Array<AssignmentHasObjectiveObjectiveDisconnectFieldInput>>;
  moduleHasAssignments?: InputMaybe<Array<AssignmentModuleHasAssignmentsDisconnectFieldInput>>;
  nudgesAboutThis?: InputMaybe<Array<AssignmentNudgesAboutThisDisconnectFieldInput>>;
  submissions?: InputMaybe<Array<AssignmentSubmissionsDisconnectFieldInput>>;
  usersHasSchoolAssignment?: InputMaybe<Array<AssignmentUsersHasSchoolAssignmentDisconnectFieldInput>>;
  worksheet?: InputMaybe<AssignmentWorksheetDisconnectFieldInput>;
};

export type AssignmentDocumentDocumentsAggregationSelection = {
  __typename?: 'AssignmentDocumentDocumentsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AssignmentDocumentDocumentsNodeAggregateSelection>;
};

export type AssignmentDocumentDocumentsNodeAggregateSelection = {
  __typename?: 'AssignmentDocumentDocumentsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  summary: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type AssignmentDocumentsAggregateInput = {
  AND?: InputMaybe<Array<AssignmentDocumentsAggregateInput>>;
  NOT?: InputMaybe<AssignmentDocumentsAggregateInput>;
  OR?: InputMaybe<Array<AssignmentDocumentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AssignmentDocumentsNodeAggregationWhereInput>;
};

export type AssignmentDocumentsConnectFieldInput = {
  connect?: InputMaybe<Array<DocumentConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DocumentConnectWhere>;
};

export type AssignmentDocumentsConnection = {
  __typename?: 'AssignmentDocumentsConnection';
  edges: Array<AssignmentDocumentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssignmentDocumentsConnectionSort = {
  node?: InputMaybe<DocumentSort>;
};

export type AssignmentDocumentsConnectionWhere = {
  AND?: InputMaybe<Array<AssignmentDocumentsConnectionWhere>>;
  NOT?: InputMaybe<AssignmentDocumentsConnectionWhere>;
  OR?: InputMaybe<Array<AssignmentDocumentsConnectionWhere>>;
  node?: InputMaybe<DocumentWhere>;
};

export type AssignmentDocumentsCreateFieldInput = {
  node: DocumentCreateInput;
};

export type AssignmentDocumentsDeleteFieldInput = {
  delete?: InputMaybe<DocumentDeleteInput>;
  where?: InputMaybe<AssignmentDocumentsConnectionWhere>;
};

export type AssignmentDocumentsDisconnectFieldInput = {
  disconnect?: InputMaybe<DocumentDisconnectInput>;
  where?: InputMaybe<AssignmentDocumentsConnectionWhere>;
};

export type AssignmentDocumentsFieldInput = {
  connect?: InputMaybe<Array<AssignmentDocumentsConnectFieldInput>>;
  create?: InputMaybe<Array<AssignmentDocumentsCreateFieldInput>>;
};

export type AssignmentDocumentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AssignmentDocumentsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AssignmentDocumentsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AssignmentDocumentsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  summary_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  summary_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AssignmentDocumentsRelationship = {
  __typename?: 'AssignmentDocumentsRelationship';
  cursor: Scalars['String']['output'];
  node: Document;
};

export type AssignmentDocumentsUpdateConnectionInput = {
  node?: InputMaybe<DocumentUpdateInput>;
};

export type AssignmentDocumentsUpdateFieldInput = {
  connect?: InputMaybe<Array<AssignmentDocumentsConnectFieldInput>>;
  create?: InputMaybe<Array<AssignmentDocumentsCreateFieldInput>>;
  delete?: InputMaybe<Array<AssignmentDocumentsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AssignmentDocumentsDisconnectFieldInput>>;
  update?: InputMaybe<AssignmentDocumentsUpdateConnectionInput>;
  where?: InputMaybe<AssignmentDocumentsConnectionWhere>;
};

export type AssignmentFileFilesAggregationSelection = {
  __typename?: 'AssignmentFileFilesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AssignmentFileFilesNodeAggregateSelection>;
};

export type AssignmentFileFilesNodeAggregateSelection = {
  __typename?: 'AssignmentFileFilesNodeAggregateSelection';
  bucketName: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  fileName: StringAggregateSelection;
  filePath: StringAggregateSelection;
  fileURL: StringAggregateSelection;
  id: IdAggregateSelection;
};

export type AssignmentFilesAggregateInput = {
  AND?: InputMaybe<Array<AssignmentFilesAggregateInput>>;
  NOT?: InputMaybe<AssignmentFilesAggregateInput>;
  OR?: InputMaybe<Array<AssignmentFilesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AssignmentFilesNodeAggregationWhereInput>;
};

export type AssignmentFilesConnectFieldInput = {
  connect?: InputMaybe<Array<FileConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FileConnectWhere>;
};

export type AssignmentFilesConnectOrCreateFieldInput = {
  onCreate: AssignmentFilesConnectOrCreateFieldInputOnCreate;
  where: FileConnectOrCreateWhere;
};

export type AssignmentFilesConnectOrCreateFieldInputOnCreate = {
  node: FileOnCreateInput;
};

export type AssignmentFilesConnection = {
  __typename?: 'AssignmentFilesConnection';
  edges: Array<AssignmentFilesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssignmentFilesConnectionSort = {
  node?: InputMaybe<FileSort>;
};

export type AssignmentFilesConnectionWhere = {
  AND?: InputMaybe<Array<AssignmentFilesConnectionWhere>>;
  NOT?: InputMaybe<AssignmentFilesConnectionWhere>;
  OR?: InputMaybe<Array<AssignmentFilesConnectionWhere>>;
  node?: InputMaybe<FileWhere>;
};

export type AssignmentFilesCreateFieldInput = {
  node: FileCreateInput;
};

export type AssignmentFilesDeleteFieldInput = {
  delete?: InputMaybe<FileDeleteInput>;
  where?: InputMaybe<AssignmentFilesConnectionWhere>;
};

export type AssignmentFilesDisconnectFieldInput = {
  disconnect?: InputMaybe<FileDisconnectInput>;
  where?: InputMaybe<AssignmentFilesConnectionWhere>;
};

export type AssignmentFilesFieldInput = {
  connect?: InputMaybe<Array<AssignmentFilesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssignmentFilesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssignmentFilesCreateFieldInput>>;
};

export type AssignmentFilesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AssignmentFilesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AssignmentFilesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AssignmentFilesNodeAggregationWhereInput>>;
  bucketName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  bucketName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  fileName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileURL_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AssignmentFilesRelationship = {
  __typename?: 'AssignmentFilesRelationship';
  cursor: Scalars['String']['output'];
  node: File;
};

export type AssignmentFilesUpdateConnectionInput = {
  node?: InputMaybe<FileUpdateInput>;
};

export type AssignmentFilesUpdateFieldInput = {
  connect?: InputMaybe<Array<AssignmentFilesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssignmentFilesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssignmentFilesCreateFieldInput>>;
  delete?: InputMaybe<Array<AssignmentFilesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AssignmentFilesDisconnectFieldInput>>;
  update?: InputMaybe<AssignmentFilesUpdateConnectionInput>;
  where?: InputMaybe<AssignmentFilesConnectionWhere>;
};

export type AssignmentHasChatChatsAggregateInput = {
  AND?: InputMaybe<Array<AssignmentHasChatChatsAggregateInput>>;
  NOT?: InputMaybe<AssignmentHasChatChatsAggregateInput>;
  OR?: InputMaybe<Array<AssignmentHasChatChatsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasChatPropertiesAggregationWhereInput>;
  node?: InputMaybe<AssignmentHasChatChatsNodeAggregationWhereInput>;
};

export type AssignmentHasChatChatsConnectFieldInput = {
  connect?: InputMaybe<Array<ChatConnectInput>>;
  edge?: InputMaybe<HasChatPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ChatConnectWhere>;
};

export type AssignmentHasChatChatsConnectOrCreateFieldInput = {
  onCreate: AssignmentHasChatChatsConnectOrCreateFieldInputOnCreate;
  where: ChatConnectOrCreateWhere;
};

export type AssignmentHasChatChatsConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<HasChatPropertiesCreateInput>;
  node: ChatOnCreateInput;
};

export type AssignmentHasChatChatsConnection = {
  __typename?: 'AssignmentHasChatChatsConnection';
  edges: Array<AssignmentHasChatChatsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssignmentHasChatChatsConnectionSort = {
  edge?: InputMaybe<HasChatPropertiesSort>;
  node?: InputMaybe<ChatSort>;
};

export type AssignmentHasChatChatsConnectionWhere = {
  AND?: InputMaybe<Array<AssignmentHasChatChatsConnectionWhere>>;
  NOT?: InputMaybe<AssignmentHasChatChatsConnectionWhere>;
  OR?: InputMaybe<Array<AssignmentHasChatChatsConnectionWhere>>;
  edge?: InputMaybe<HasChatPropertiesWhere>;
  node?: InputMaybe<ChatWhere>;
};

export type AssignmentHasChatChatsCreateFieldInput = {
  edge?: InputMaybe<HasChatPropertiesCreateInput>;
  node: ChatCreateInput;
};

export type AssignmentHasChatChatsDeleteFieldInput = {
  delete?: InputMaybe<ChatDeleteInput>;
  where?: InputMaybe<AssignmentHasChatChatsConnectionWhere>;
};

export type AssignmentHasChatChatsDisconnectFieldInput = {
  disconnect?: InputMaybe<ChatDisconnectInput>;
  where?: InputMaybe<AssignmentHasChatChatsConnectionWhere>;
};

export type AssignmentHasChatChatsFieldInput = {
  connect?: InputMaybe<Array<AssignmentHasChatChatsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssignmentHasChatChatsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssignmentHasChatChatsCreateFieldInput>>;
};

export type AssignmentHasChatChatsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AssignmentHasChatChatsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AssignmentHasChatChatsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AssignmentHasChatChatsNodeAggregationWhereInput>>;
  context_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  context_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  schemaVersion_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  schemaVersion_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  schemaVersion_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  schemaVersion_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  schemaVersion_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AssignmentHasChatChatsRelationship = {
  __typename?: 'AssignmentHasChatChatsRelationship';
  cursor: Scalars['String']['output'];
  node: Chat;
  properties: HasChatProperties;
};

export type AssignmentHasChatChatsUpdateConnectionInput = {
  edge?: InputMaybe<HasChatPropertiesUpdateInput>;
  node?: InputMaybe<ChatUpdateInput>;
};

export type AssignmentHasChatChatsUpdateFieldInput = {
  connect?: InputMaybe<Array<AssignmentHasChatChatsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssignmentHasChatChatsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssignmentHasChatChatsCreateFieldInput>>;
  delete?: InputMaybe<Array<AssignmentHasChatChatsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AssignmentHasChatChatsDisconnectFieldInput>>;
  update?: InputMaybe<AssignmentHasChatChatsUpdateConnectionInput>;
  where?: InputMaybe<AssignmentHasChatChatsConnectionWhere>;
};

export type AssignmentHasObjectiveObjectiveAggregateInput = {
  AND?: InputMaybe<Array<AssignmentHasObjectiveObjectiveAggregateInput>>;
  NOT?: InputMaybe<AssignmentHasObjectiveObjectiveAggregateInput>;
  OR?: InputMaybe<Array<AssignmentHasObjectiveObjectiveAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AssignmentHasObjectiveObjectiveNodeAggregationWhereInput>;
};

export type AssignmentHasObjectiveObjectiveConnectFieldInput = {
  connect?: InputMaybe<Array<ObjectiveConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ObjectiveConnectWhere>;
};

export type AssignmentHasObjectiveObjectiveConnectOrCreateFieldInput = {
  onCreate: AssignmentHasObjectiveObjectiveConnectOrCreateFieldInputOnCreate;
  where: ObjectiveConnectOrCreateWhere;
};

export type AssignmentHasObjectiveObjectiveConnectOrCreateFieldInputOnCreate = {
  node: ObjectiveOnCreateInput;
};

export type AssignmentHasObjectiveObjectiveConnection = {
  __typename?: 'AssignmentHasObjectiveObjectiveConnection';
  edges: Array<AssignmentHasObjectiveObjectiveRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssignmentHasObjectiveObjectiveConnectionSort = {
  node?: InputMaybe<ObjectiveSort>;
};

export type AssignmentHasObjectiveObjectiveConnectionWhere = {
  AND?: InputMaybe<Array<AssignmentHasObjectiveObjectiveConnectionWhere>>;
  NOT?: InputMaybe<AssignmentHasObjectiveObjectiveConnectionWhere>;
  OR?: InputMaybe<Array<AssignmentHasObjectiveObjectiveConnectionWhere>>;
  node?: InputMaybe<ObjectiveWhere>;
};

export type AssignmentHasObjectiveObjectiveCreateFieldInput = {
  node: ObjectiveCreateInput;
};

export type AssignmentHasObjectiveObjectiveDeleteFieldInput = {
  delete?: InputMaybe<ObjectiveDeleteInput>;
  where?: InputMaybe<AssignmentHasObjectiveObjectiveConnectionWhere>;
};

export type AssignmentHasObjectiveObjectiveDisconnectFieldInput = {
  disconnect?: InputMaybe<ObjectiveDisconnectInput>;
  where?: InputMaybe<AssignmentHasObjectiveObjectiveConnectionWhere>;
};

export type AssignmentHasObjectiveObjectiveFieldInput = {
  connect?: InputMaybe<Array<AssignmentHasObjectiveObjectiveConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssignmentHasObjectiveObjectiveConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssignmentHasObjectiveObjectiveCreateFieldInput>>;
};

export type AssignmentHasObjectiveObjectiveNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AssignmentHasObjectiveObjectiveNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AssignmentHasObjectiveObjectiveNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AssignmentHasObjectiveObjectiveNodeAggregationWhereInput>>;
  objective_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  objective_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  objective_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  objective_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  objective_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  objective_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  objective_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  objective_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  objective_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  objective_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  objective_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  objective_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  objective_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  objective_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  objective_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sequence_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sequence_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sequence_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sequence_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sequence_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sequence_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sequence_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sequence_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sequence_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sequence_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sequence_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sequence_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sequence_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sequence_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sequence_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sequence_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sequence_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sequence_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sequence_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sequence_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  teachingPlan_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  teachingPlan_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  teachingPlan_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  teachingPlan_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  teachingPlan_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  teachingPlan_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  teachingPlan_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  teachingPlan_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  teachingPlan_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  teachingPlan_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  teachingPlan_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  teachingPlan_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  teachingPlan_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  teachingPlan_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  teachingPlan_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AssignmentHasObjectiveObjectiveRelationship = {
  __typename?: 'AssignmentHasObjectiveObjectiveRelationship';
  cursor: Scalars['String']['output'];
  node: Objective;
};

export type AssignmentHasObjectiveObjectiveUpdateConnectionInput = {
  node?: InputMaybe<ObjectiveUpdateInput>;
};

export type AssignmentHasObjectiveObjectiveUpdateFieldInput = {
  connect?: InputMaybe<Array<AssignmentHasObjectiveObjectiveConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssignmentHasObjectiveObjectiveConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssignmentHasObjectiveObjectiveCreateFieldInput>>;
  delete?: InputMaybe<Array<AssignmentHasObjectiveObjectiveDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AssignmentHasObjectiveObjectiveDisconnectFieldInput>>;
  update?: InputMaybe<AssignmentHasObjectiveObjectiveUpdateConnectionInput>;
  where?: InputMaybe<AssignmentHasObjectiveObjectiveConnectionWhere>;
};

export type AssignmentModuleHasAssignmentsAggregateInput = {
  AND?: InputMaybe<Array<AssignmentModuleHasAssignmentsAggregateInput>>;
  NOT?: InputMaybe<AssignmentModuleHasAssignmentsAggregateInput>;
  OR?: InputMaybe<Array<AssignmentModuleHasAssignmentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AssignmentModuleHasAssignmentsNodeAggregationWhereInput>;
};

export type AssignmentModuleHasAssignmentsConnectFieldInput = {
  connect?: InputMaybe<Array<ModuleConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ModuleConnectWhere>;
};

export type AssignmentModuleHasAssignmentsConnectOrCreateFieldInput = {
  onCreate: AssignmentModuleHasAssignmentsConnectOrCreateFieldInputOnCreate;
  where: ModuleConnectOrCreateWhere;
};

export type AssignmentModuleHasAssignmentsConnectOrCreateFieldInputOnCreate = {
  node: ModuleOnCreateInput;
};

export type AssignmentModuleHasAssignmentsConnection = {
  __typename?: 'AssignmentModuleHasAssignmentsConnection';
  edges: Array<AssignmentModuleHasAssignmentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssignmentModuleHasAssignmentsConnectionSort = {
  node?: InputMaybe<ModuleSort>;
};

export type AssignmentModuleHasAssignmentsConnectionWhere = {
  AND?: InputMaybe<Array<AssignmentModuleHasAssignmentsConnectionWhere>>;
  NOT?: InputMaybe<AssignmentModuleHasAssignmentsConnectionWhere>;
  OR?: InputMaybe<Array<AssignmentModuleHasAssignmentsConnectionWhere>>;
  node?: InputMaybe<ModuleWhere>;
};

export type AssignmentModuleHasAssignmentsCreateFieldInput = {
  node: ModuleCreateInput;
};

export type AssignmentModuleHasAssignmentsDeleteFieldInput = {
  delete?: InputMaybe<ModuleDeleteInput>;
  where?: InputMaybe<AssignmentModuleHasAssignmentsConnectionWhere>;
};

export type AssignmentModuleHasAssignmentsDisconnectFieldInput = {
  disconnect?: InputMaybe<ModuleDisconnectInput>;
  where?: InputMaybe<AssignmentModuleHasAssignmentsConnectionWhere>;
};

export type AssignmentModuleHasAssignmentsFieldInput = {
  connect?: InputMaybe<Array<AssignmentModuleHasAssignmentsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssignmentModuleHasAssignmentsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssignmentModuleHasAssignmentsCreateFieldInput>>;
};

export type AssignmentModuleHasAssignmentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AssignmentModuleHasAssignmentsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AssignmentModuleHasAssignmentsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AssignmentModuleHasAssignmentsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  module_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  module_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AssignmentModuleHasAssignmentsRelationship = {
  __typename?: 'AssignmentModuleHasAssignmentsRelationship';
  cursor: Scalars['String']['output'];
  node: Module;
};

export type AssignmentModuleHasAssignmentsUpdateConnectionInput = {
  node?: InputMaybe<ModuleUpdateInput>;
};

export type AssignmentModuleHasAssignmentsUpdateFieldInput = {
  connect?: InputMaybe<Array<AssignmentModuleHasAssignmentsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssignmentModuleHasAssignmentsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssignmentModuleHasAssignmentsCreateFieldInput>>;
  delete?: InputMaybe<Array<AssignmentModuleHasAssignmentsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AssignmentModuleHasAssignmentsDisconnectFieldInput>>;
  update?: InputMaybe<AssignmentModuleHasAssignmentsUpdateConnectionInput>;
  where?: InputMaybe<AssignmentModuleHasAssignmentsConnectionWhere>;
};

export type AssignmentModuleModuleHasAssignmentsAggregationSelection = {
  __typename?: 'AssignmentModuleModuleHasAssignmentsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AssignmentModuleModuleHasAssignmentsNodeAggregateSelection>;
};

export type AssignmentModuleModuleHasAssignmentsNodeAggregateSelection = {
  __typename?: 'AssignmentModuleModuleHasAssignmentsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  module_name: StringAggregateSelection;
  thumbnail: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type AssignmentNudgeNudgesAboutThisAggregationSelection = {
  __typename?: 'AssignmentNudgeNudgesAboutThisAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AssignmentNudgeNudgesAboutThisNodeAggregateSelection>;
};

export type AssignmentNudgeNudgesAboutThisNodeAggregateSelection = {
  __typename?: 'AssignmentNudgeNudgesAboutThisNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  idempotencyKey: StringAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  priorityScore: FloatAggregateSelection;
  scheduledFor: DateTimeAggregateSelection;
  snoozedUntil: DateTimeAggregateSelection;
  taskCompletedAt: DateTimeAggregateSelection;
};

export type AssignmentNudgesAboutThisAggregateInput = {
  AND?: InputMaybe<Array<AssignmentNudgesAboutThisAggregateInput>>;
  NOT?: InputMaybe<AssignmentNudgesAboutThisAggregateInput>;
  OR?: InputMaybe<Array<AssignmentNudgesAboutThisAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AssignmentNudgesAboutThisNodeAggregationWhereInput>;
};

export type AssignmentNudgesAboutThisConnectFieldInput = {
  connect?: InputMaybe<Array<NudgeConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<NudgeConnectWhere>;
};

export type AssignmentNudgesAboutThisConnectOrCreateFieldInput = {
  onCreate: AssignmentNudgesAboutThisConnectOrCreateFieldInputOnCreate;
  where: NudgeConnectOrCreateWhere;
};

export type AssignmentNudgesAboutThisConnectOrCreateFieldInputOnCreate = {
  node: NudgeOnCreateInput;
};

export type AssignmentNudgesAboutThisConnection = {
  __typename?: 'AssignmentNudgesAboutThisConnection';
  edges: Array<AssignmentNudgesAboutThisRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssignmentNudgesAboutThisConnectionSort = {
  node?: InputMaybe<NudgeSort>;
};

export type AssignmentNudgesAboutThisConnectionWhere = {
  AND?: InputMaybe<Array<AssignmentNudgesAboutThisConnectionWhere>>;
  NOT?: InputMaybe<AssignmentNudgesAboutThisConnectionWhere>;
  OR?: InputMaybe<Array<AssignmentNudgesAboutThisConnectionWhere>>;
  node?: InputMaybe<NudgeWhere>;
};

export type AssignmentNudgesAboutThisCreateFieldInput = {
  node: NudgeCreateInput;
};

export type AssignmentNudgesAboutThisDeleteFieldInput = {
  delete?: InputMaybe<NudgeDeleteInput>;
  where?: InputMaybe<AssignmentNudgesAboutThisConnectionWhere>;
};

export type AssignmentNudgesAboutThisDisconnectFieldInput = {
  disconnect?: InputMaybe<NudgeDisconnectInput>;
  where?: InputMaybe<AssignmentNudgesAboutThisConnectionWhere>;
};

export type AssignmentNudgesAboutThisFieldInput = {
  connect?: InputMaybe<Array<AssignmentNudgesAboutThisConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssignmentNudgesAboutThisConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssignmentNudgesAboutThisCreateFieldInput>>;
};

export type AssignmentNudgesAboutThisNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AssignmentNudgesAboutThisNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AssignmentNudgesAboutThisNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AssignmentNudgesAboutThisNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  idempotencyKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  priorityScore_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  scheduledFor_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AssignmentNudgesAboutThisRelationship = {
  __typename?: 'AssignmentNudgesAboutThisRelationship';
  cursor: Scalars['String']['output'];
  node: Nudge;
};

export type AssignmentNudgesAboutThisUpdateConnectionInput = {
  node?: InputMaybe<NudgeUpdateInput>;
};

export type AssignmentNudgesAboutThisUpdateFieldInput = {
  connect?: InputMaybe<Array<AssignmentNudgesAboutThisConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssignmentNudgesAboutThisConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssignmentNudgesAboutThisCreateFieldInput>>;
  delete?: InputMaybe<Array<AssignmentNudgesAboutThisDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AssignmentNudgesAboutThisDisconnectFieldInput>>;
  update?: InputMaybe<AssignmentNudgesAboutThisUpdateConnectionInput>;
  where?: InputMaybe<AssignmentNudgesAboutThisConnectionWhere>;
};

export type AssignmentObjectiveHasObjectiveObjectiveAggregationSelection = {
  __typename?: 'AssignmentObjectiveHasObjectiveObjectiveAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AssignmentObjectiveHasObjectiveObjectiveNodeAggregateSelection>;
};

export type AssignmentObjectiveHasObjectiveObjectiveNodeAggregateSelection = {
  __typename?: 'AssignmentObjectiveHasObjectiveObjectiveNodeAggregateSelection';
  id: IdAggregateSelection;
  objective: StringAggregateSelection;
  sequence: FloatAggregateSelection;
  teachingPlan: StringAggregateSelection;
};

export type AssignmentOnCreateInput = {
  _empty?: InputMaybe<Scalars['String']['input']>;
  activityState?: InputMaybe<ActivityState>;
  allowed_attempts?: InputMaybe<Scalars['Float']['input']>;
  anonymize_students?: InputMaybe<Scalars['Boolean']['input']>;
  anonymous_grading?: InputMaybe<Scalars['Boolean']['input']>;
  anonymous_instructor_annotations?: InputMaybe<Scalars['Boolean']['input']>;
  anonymous_peer_reviews?: InputMaybe<Scalars['Boolean']['input']>;
  assignee_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assignee_mode?: InputMaybe<Scalars['String']['input']>;
  assignment_group_id?: InputMaybe<Scalars['Float']['input']>;
  assignment_name?: InputMaybe<Scalars['String']['input']>;
  automatic_peer_reviews?: InputMaybe<Scalars['Boolean']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  can_duplicate?: InputMaybe<Scalars['Boolean']['input']>;
  category_id?: InputMaybe<Scalars['String']['input']>;
  course_id?: InputMaybe<Scalars['Float']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_at?: InputMaybe<Scalars['String']['input']>;
  created_date?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_plaintext?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_allow_rating?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_assignment_id?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_attachments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discussion_topic_author_anonymous_id?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_author_avatar_image_url?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_author_display_name?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_author_html_url?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_author_id?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_can_group?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_can_lock?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_can_unpublish?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_comments_disabled?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_created_at?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_discussion_subentry_count?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_group_topic_children?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discussion_topic_html_url?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_id?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_is_announcement?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_is_section_specific?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_last_reply_at?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_locked?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_locked_for_user?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_message?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_only_graders_can_rate?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_permissions_attach?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_permissions_delete?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_permissions_manage_assign_to?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_permissions_reply?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_permissions_update?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_pinned?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_podcast_has_student_posts?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_posted_at?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_published?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_read_state?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_sort_by_rating?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_subscribed?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_summary_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_title?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_topic_children?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discussion_topic_unread_count?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_user_can_see_posts?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_user_name?: InputMaybe<Scalars['String']['input']>;
  display_date?: InputMaybe<Scalars['String']['input']>;
  due_at?: InputMaybe<Scalars['String']['input']>;
  due_date?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_required?: InputMaybe<Scalars['Boolean']['input']>;
  enableStudentFileUpload?: InputMaybe<Scalars['Boolean']['input']>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  external_tool_tag_attributes_content_id?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type?: InputMaybe<Scalars['String']['input']>;
  external_tool_tag_attributes_external_data?: InputMaybe<Scalars['String']['input']>;
  external_tool_tag_attributes_new_tab?: InputMaybe<Scalars['Boolean']['input']>;
  external_tool_tag_attributes_resource_link_id?: InputMaybe<Scalars['String']['input']>;
  external_tool_tag_attributes_url?: InputMaybe<Scalars['String']['input']>;
  frozen_attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grade_group_students_individually?: InputMaybe<Scalars['Boolean']['input']>;
  grade_points?: InputMaybe<Scalars['Float']['input']>;
  graded_submissions_exist?: InputMaybe<Scalars['Boolean']['input']>;
  grader_comments_visible_to_graders?: InputMaybe<Scalars['Boolean']['input']>;
  grader_count?: InputMaybe<Scalars['Float']['input']>;
  grader_names_visible_to_final_grader?: InputMaybe<Scalars['Boolean']['input']>;
  graders_anonymous_to_graders?: InputMaybe<Scalars['Boolean']['input']>;
  grading_type?: InputMaybe<Scalars['String']['input']>;
  has_overrides?: InputMaybe<Scalars['Boolean']['input']>;
  has_submitted_submissions?: InputMaybe<Scalars['Boolean']['input']>;
  hide_in_gradebook?: InputMaybe<Scalars['Boolean']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  html_url?: InputMaybe<Scalars['String']['input']>;
  important_dates?: InputMaybe<Scalars['Boolean']['input']>;
  in_closed_grading_period?: InputMaybe<Scalars['Boolean']['input']>;
  intra_group_peer_reviews?: InputMaybe<Scalars['Boolean']['input']>;
  is_quiz_assignment?: InputMaybe<Scalars['Boolean']['input']>;
  is_quiz_lti_assignment?: InputMaybe<Scalars['Boolean']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  locked_for_user?: InputMaybe<Scalars['Boolean']['input']>;
  lti_context_id?: InputMaybe<Scalars['String']['input']>;
  max_attempts?: InputMaybe<Scalars['Float']['input']>;
  max_name_length?: InputMaybe<Scalars['Float']['input']>;
  moderated_grading?: InputMaybe<Scalars['Boolean']['input']>;
  muted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  needs_grading_count?: InputMaybe<Scalars['Float']['input']>;
  objectives?: InputMaybe<Scalars['String']['input']>;
  omit_from_final_grade?: InputMaybe<Scalars['Boolean']['input']>;
  only_visible_to_overrides?: InputMaybe<Scalars['Boolean']['input']>;
  peer_reviews?: InputMaybe<Scalars['Boolean']['input']>;
  points_possible?: InputMaybe<Scalars['Float']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  post_manually?: InputMaybe<Scalars['Boolean']['input']>;
  post_to_sis?: InputMaybe<Scalars['Boolean']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  require_lockdown_browser?: InputMaybe<Scalars['Boolean']['input']>;
  resource_metadata?: InputMaybe<Scalars['String']['input']>;
  restrict_quantitative_data?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  section_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  secure_params?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  submissions_download_url?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unpublishable?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visible_to_everyone?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_state?: InputMaybe<Scalars['String']['input']>;
};

export type AssignmentOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AssignmentSort objects to sort Assignments by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AssignmentSort>>;
};

export type AssignmentResponse = {
  __typename?: 'AssignmentResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<Assignment>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Fields to sort Assignments by. The order in which sorts are applied is not guaranteed when specifying many fields in one AssignmentSort object. */
export type AssignmentSort = {
  _empty?: InputMaybe<SortDirection>;
  activityState?: InputMaybe<SortDirection>;
  allowed_attempts?: InputMaybe<SortDirection>;
  anonymize_students?: InputMaybe<SortDirection>;
  anonymous_grading?: InputMaybe<SortDirection>;
  anonymous_instructor_annotations?: InputMaybe<SortDirection>;
  anonymous_peer_reviews?: InputMaybe<SortDirection>;
  assignee_mode?: InputMaybe<SortDirection>;
  assignment_group_id?: InputMaybe<SortDirection>;
  assignment_name?: InputMaybe<SortDirection>;
  automatic_peer_reviews?: InputMaybe<SortDirection>;
  body?: InputMaybe<SortDirection>;
  can_duplicate?: InputMaybe<SortDirection>;
  category_id?: InputMaybe<SortDirection>;
  course_id?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  created_at?: InputMaybe<SortDirection>;
  created_date?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  description_plaintext?: InputMaybe<SortDirection>;
  discussion_topic_allow_rating?: InputMaybe<SortDirection>;
  discussion_topic_assignment_id?: InputMaybe<SortDirection>;
  discussion_topic_author_anonymous_id?: InputMaybe<SortDirection>;
  discussion_topic_author_avatar_image_url?: InputMaybe<SortDirection>;
  discussion_topic_author_display_name?: InputMaybe<SortDirection>;
  discussion_topic_author_html_url?: InputMaybe<SortDirection>;
  discussion_topic_author_id?: InputMaybe<SortDirection>;
  discussion_topic_can_group?: InputMaybe<SortDirection>;
  discussion_topic_can_lock?: InputMaybe<SortDirection>;
  discussion_topic_can_unpublish?: InputMaybe<SortDirection>;
  discussion_topic_comments_disabled?: InputMaybe<SortDirection>;
  discussion_topic_created_at?: InputMaybe<SortDirection>;
  discussion_topic_discussion_subentry_count?: InputMaybe<SortDirection>;
  discussion_topic_discussion_type?: InputMaybe<SortDirection>;
  discussion_topic_html_url?: InputMaybe<SortDirection>;
  discussion_topic_id?: InputMaybe<SortDirection>;
  discussion_topic_is_announcement?: InputMaybe<SortDirection>;
  discussion_topic_is_section_specific?: InputMaybe<SortDirection>;
  discussion_topic_last_reply_at?: InputMaybe<SortDirection>;
  discussion_topic_locked?: InputMaybe<SortDirection>;
  discussion_topic_locked_for_user?: InputMaybe<SortDirection>;
  discussion_topic_message?: InputMaybe<SortDirection>;
  discussion_topic_only_graders_can_rate?: InputMaybe<SortDirection>;
  discussion_topic_permissions_attach?: InputMaybe<SortDirection>;
  discussion_topic_permissions_delete?: InputMaybe<SortDirection>;
  discussion_topic_permissions_manage_assign_to?: InputMaybe<SortDirection>;
  discussion_topic_permissions_reply?: InputMaybe<SortDirection>;
  discussion_topic_permissions_update?: InputMaybe<SortDirection>;
  discussion_topic_pinned?: InputMaybe<SortDirection>;
  discussion_topic_podcast_has_student_posts?: InputMaybe<SortDirection>;
  discussion_topic_posted_at?: InputMaybe<SortDirection>;
  discussion_topic_published?: InputMaybe<SortDirection>;
  discussion_topic_read_state?: InputMaybe<SortDirection>;
  discussion_topic_sort_by_rating?: InputMaybe<SortDirection>;
  discussion_topic_subscribed?: InputMaybe<SortDirection>;
  discussion_topic_summary_enabled?: InputMaybe<SortDirection>;
  discussion_topic_title?: InputMaybe<SortDirection>;
  discussion_topic_unread_count?: InputMaybe<SortDirection>;
  discussion_topic_url?: InputMaybe<SortDirection>;
  discussion_topic_user_can_see_posts?: InputMaybe<SortDirection>;
  discussion_topic_user_name?: InputMaybe<SortDirection>;
  display_date?: InputMaybe<SortDirection>;
  due_at?: InputMaybe<SortDirection>;
  due_date?: InputMaybe<SortDirection>;
  due_date_required?: InputMaybe<SortDirection>;
  enableStudentFileUpload?: InputMaybe<SortDirection>;
  end_date?: InputMaybe<SortDirection>;
  external_tool_tag_attributes_content_id?: InputMaybe<SortDirection>;
  external_tool_tag_attributes_content_type?: InputMaybe<SortDirection>;
  external_tool_tag_attributes_external_data?: InputMaybe<SortDirection>;
  external_tool_tag_attributes_new_tab?: InputMaybe<SortDirection>;
  external_tool_tag_attributes_resource_link_id?: InputMaybe<SortDirection>;
  external_tool_tag_attributes_url?: InputMaybe<SortDirection>;
  grade_group_students_individually?: InputMaybe<SortDirection>;
  grade_points?: InputMaybe<SortDirection>;
  graded_submissions_exist?: InputMaybe<SortDirection>;
  grader_comments_visible_to_graders?: InputMaybe<SortDirection>;
  grader_count?: InputMaybe<SortDirection>;
  grader_names_visible_to_final_grader?: InputMaybe<SortDirection>;
  graders_anonymous_to_graders?: InputMaybe<SortDirection>;
  grading_type?: InputMaybe<SortDirection>;
  has_overrides?: InputMaybe<SortDirection>;
  has_submitted_submissions?: InputMaybe<SortDirection>;
  hide_in_gradebook?: InputMaybe<SortDirection>;
  html?: InputMaybe<SortDirection>;
  html_url?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  important_dates?: InputMaybe<SortDirection>;
  in_closed_grading_period?: InputMaybe<SortDirection>;
  intra_group_peer_reviews?: InputMaybe<SortDirection>;
  is_quiz_assignment?: InputMaybe<SortDirection>;
  is_quiz_lti_assignment?: InputMaybe<SortDirection>;
  lastModified?: InputMaybe<SortDirection>;
  locked_for_user?: InputMaybe<SortDirection>;
  lti_context_id?: InputMaybe<SortDirection>;
  max_attempts?: InputMaybe<SortDirection>;
  max_name_length?: InputMaybe<SortDirection>;
  moderated_grading?: InputMaybe<SortDirection>;
  muted?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  needs_grading_count?: InputMaybe<SortDirection>;
  objectives?: InputMaybe<SortDirection>;
  omit_from_final_grade?: InputMaybe<SortDirection>;
  only_visible_to_overrides?: InputMaybe<SortDirection>;
  peer_reviews?: InputMaybe<SortDirection>;
  points_possible?: InputMaybe<SortDirection>;
  position?: InputMaybe<SortDirection>;
  post_manually?: InputMaybe<SortDirection>;
  post_to_sis?: InputMaybe<SortDirection>;
  published?: InputMaybe<SortDirection>;
  require_lockdown_browser?: InputMaybe<SortDirection>;
  resource_metadata?: InputMaybe<SortDirection>;
  restrict_quantitative_data?: InputMaybe<SortDirection>;
  scheduledDate?: InputMaybe<SortDirection>;
  secure_params?: InputMaybe<SortDirection>;
  session_id?: InputMaybe<SortDirection>;
  start_date?: InputMaybe<SortDirection>;
  state?: InputMaybe<SortDirection>;
  submissions_download_url?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  unpublishable?: InputMaybe<SortDirection>;
  updated_at?: InputMaybe<SortDirection>;
  updated_date?: InputMaybe<SortDirection>;
  url?: InputMaybe<SortDirection>;
  videoUrl?: InputMaybe<SortDirection>;
  visible_to_everyone?: InputMaybe<SortDirection>;
  workflow_state?: InputMaybe<SortDirection>;
};

export type AssignmentSubmissionData = {
  __typename?: 'AssignmentSubmissionData';
  submissions?: Maybe<Array<Maybe<Submission>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AssignmentSubmissionListResponse = {
  __typename?: 'AssignmentSubmissionListResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<AssignmentSubmissionData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AssignmentSubmissionSubmissionsAggregationSelection = {
  __typename?: 'AssignmentSubmissionSubmissionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AssignmentSubmissionSubmissionsNodeAggregateSelection>;
};

export type AssignmentSubmissionSubmissionsNodeAggregateSelection = {
  __typename?: 'AssignmentSubmissionSubmissionsNodeAggregateSelection';
  completedAt: DateTimeAggregateSelection;
  created: DateTimeAggregateSelection;
  feedback: StringAggregateSelection;
  grade: FloatAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
};

export type AssignmentSubmissionsAggregateInput = {
  AND?: InputMaybe<Array<AssignmentSubmissionsAggregateInput>>;
  NOT?: InputMaybe<AssignmentSubmissionsAggregateInput>;
  OR?: InputMaybe<Array<AssignmentSubmissionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AssignmentSubmissionsNodeAggregationWhereInput>;
};

export type AssignmentSubmissionsConnectFieldInput = {
  connect?: InputMaybe<Array<SubmissionConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SubmissionConnectWhere>;
};

export type AssignmentSubmissionsConnectOrCreateFieldInput = {
  onCreate: AssignmentSubmissionsConnectOrCreateFieldInputOnCreate;
  where: SubmissionConnectOrCreateWhere;
};

export type AssignmentSubmissionsConnectOrCreateFieldInputOnCreate = {
  node: SubmissionOnCreateInput;
};

export type AssignmentSubmissionsConnection = {
  __typename?: 'AssignmentSubmissionsConnection';
  edges: Array<AssignmentSubmissionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssignmentSubmissionsConnectionSort = {
  node?: InputMaybe<SubmissionSort>;
};

export type AssignmentSubmissionsConnectionWhere = {
  AND?: InputMaybe<Array<AssignmentSubmissionsConnectionWhere>>;
  NOT?: InputMaybe<AssignmentSubmissionsConnectionWhere>;
  OR?: InputMaybe<Array<AssignmentSubmissionsConnectionWhere>>;
  node?: InputMaybe<SubmissionWhere>;
};

export type AssignmentSubmissionsCreateFieldInput = {
  node: SubmissionCreateInput;
};

export type AssignmentSubmissionsDeleteFieldInput = {
  delete?: InputMaybe<SubmissionDeleteInput>;
  where?: InputMaybe<AssignmentSubmissionsConnectionWhere>;
};

export type AssignmentSubmissionsDisconnectFieldInput = {
  disconnect?: InputMaybe<SubmissionDisconnectInput>;
  where?: InputMaybe<AssignmentSubmissionsConnectionWhere>;
};

export type AssignmentSubmissionsFieldInput = {
  connect?: InputMaybe<Array<AssignmentSubmissionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssignmentSubmissionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssignmentSubmissionsCreateFieldInput>>;
};

export type AssignmentSubmissionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AssignmentSubmissionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AssignmentSubmissionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AssignmentSubmissionsNodeAggregationWhereInput>>;
  completedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  feedback_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  feedback_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AssignmentSubmissionsRelationship = {
  __typename?: 'AssignmentSubmissionsRelationship';
  cursor: Scalars['String']['output'];
  node: Submission;
};

export type AssignmentSubmissionsUpdateConnectionInput = {
  node?: InputMaybe<SubmissionUpdateInput>;
};

export type AssignmentSubmissionsUpdateFieldInput = {
  connect?: InputMaybe<Array<AssignmentSubmissionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssignmentSubmissionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssignmentSubmissionsCreateFieldInput>>;
  delete?: InputMaybe<Array<AssignmentSubmissionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AssignmentSubmissionsDisconnectFieldInput>>;
  update?: InputMaybe<AssignmentSubmissionsUpdateConnectionInput>;
  where?: InputMaybe<AssignmentSubmissionsConnectionWhere>;
};

export type AssignmentUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type AssignmentUpdateInput = {
  _empty?: InputMaybe<Scalars['String']['input']>;
  activityState?: InputMaybe<ActivityState>;
  allowed_attempts?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_ADD?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  anonymize_students?: InputMaybe<Scalars['Boolean']['input']>;
  anonymous_grading?: InputMaybe<Scalars['Boolean']['input']>;
  anonymous_instructor_annotations?: InputMaybe<Scalars['Boolean']['input']>;
  anonymous_peer_reviews?: InputMaybe<Scalars['Boolean']['input']>;
  assignee_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assignee_ids_POP?: InputMaybe<Scalars['Int']['input']>;
  assignee_ids_PUSH?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assignee_mode?: InputMaybe<Scalars['String']['input']>;
  assignment_group_id?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_ADD?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  assignment_name?: InputMaybe<Scalars['String']['input']>;
  automatic_peer_reviews?: InputMaybe<Scalars['Boolean']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  can_duplicate?: InputMaybe<Scalars['Boolean']['input']>;
  category_id?: InputMaybe<Scalars['String']['input']>;
  courseCategoriesHasAssignment?: InputMaybe<Array<AssignmentCourseCategoriesHasAssignmentUpdateFieldInput>>;
  course_id?: InputMaybe<Scalars['Float']['input']>;
  course_id_ADD?: InputMaybe<Scalars['Float']['input']>;
  course_id_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  coursesHasAssignment?: InputMaybe<Array<AssignmentCoursesHasAssignmentUpdateFieldInput>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_at?: InputMaybe<Scalars['String']['input']>;
  created_date?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_plaintext?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_allow_rating?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_assignment_id?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_ADD?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_attachments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discussion_topic_attachments_POP?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_attachments_PUSH?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discussion_topic_author_anonymous_id?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_author_avatar_image_url?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_author_display_name?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_author_html_url?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_author_id?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_ADD?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_can_group?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_can_lock?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_can_unpublish?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_comments_disabled?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_created_at?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_discussion_subentry_count?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_ADD?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_group_topic_children?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discussion_topic_group_topic_children_POP?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_group_topic_children_PUSH?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discussion_topic_html_url?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_id?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_ADD?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_is_announcement?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_is_section_specific?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_last_reply_at?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_locked?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_locked_for_user?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_message?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_only_graders_can_rate?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_permissions_attach?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_permissions_delete?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_permissions_manage_assign_to?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_permissions_reply?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_permissions_update?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_pinned?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_podcast_has_student_posts?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_posted_at?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_published?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_read_state?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_sort_by_rating?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_subscribed?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_summary_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_title?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_topic_children?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discussion_topic_topic_children_POP?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_topic_children_PUSH?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discussion_topic_unread_count?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_ADD?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_user_can_see_posts?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_user_name?: InputMaybe<Scalars['String']['input']>;
  display_date?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Array<AssignmentDocumentsUpdateFieldInput>>;
  due_at?: InputMaybe<Scalars['String']['input']>;
  due_date?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_required?: InputMaybe<Scalars['Boolean']['input']>;
  enableStudentFileUpload?: InputMaybe<Scalars['Boolean']['input']>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  external_tool_tag_attributes_content_id?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_ADD?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type?: InputMaybe<Scalars['String']['input']>;
  external_tool_tag_attributes_external_data?: InputMaybe<Scalars['String']['input']>;
  external_tool_tag_attributes_new_tab?: InputMaybe<Scalars['Boolean']['input']>;
  external_tool_tag_attributes_resource_link_id?: InputMaybe<Scalars['String']['input']>;
  external_tool_tag_attributes_url?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<AssignmentFilesUpdateFieldInput>>;
  frozen_attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  frozen_attributes_POP?: InputMaybe<Scalars['Int']['input']>;
  frozen_attributes_PUSH?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grade_group_students_individually?: InputMaybe<Scalars['Boolean']['input']>;
  grade_points?: InputMaybe<Scalars['Float']['input']>;
  grade_points_ADD?: InputMaybe<Scalars['Float']['input']>;
  grade_points_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  graded_submissions_exist?: InputMaybe<Scalars['Boolean']['input']>;
  grader_comments_visible_to_graders?: InputMaybe<Scalars['Boolean']['input']>;
  grader_count?: InputMaybe<Scalars['Float']['input']>;
  grader_count_ADD?: InputMaybe<Scalars['Float']['input']>;
  grader_count_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  grader_names_visible_to_final_grader?: InputMaybe<Scalars['Boolean']['input']>;
  graders_anonymous_to_graders?: InputMaybe<Scalars['Boolean']['input']>;
  grading_type?: InputMaybe<Scalars['String']['input']>;
  hasChatChats?: InputMaybe<Array<AssignmentHasChatChatsUpdateFieldInput>>;
  hasObjectiveObjective?: InputMaybe<Array<AssignmentHasObjectiveObjectiveUpdateFieldInput>>;
  has_overrides?: InputMaybe<Scalars['Boolean']['input']>;
  has_submitted_submissions?: InputMaybe<Scalars['Boolean']['input']>;
  hide_in_gradebook?: InputMaybe<Scalars['Boolean']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  html_url?: InputMaybe<Scalars['String']['input']>;
  important_dates?: InputMaybe<Scalars['Boolean']['input']>;
  in_closed_grading_period?: InputMaybe<Scalars['Boolean']['input']>;
  intra_group_peer_reviews?: InputMaybe<Scalars['Boolean']['input']>;
  is_quiz_assignment?: InputMaybe<Scalars['Boolean']['input']>;
  is_quiz_lti_assignment?: InputMaybe<Scalars['Boolean']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  locked_for_user?: InputMaybe<Scalars['Boolean']['input']>;
  lti_context_id?: InputMaybe<Scalars['String']['input']>;
  max_attempts?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_ADD?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_ADD?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  moderated_grading?: InputMaybe<Scalars['Boolean']['input']>;
  moduleHasAssignments?: InputMaybe<Array<AssignmentModuleHasAssignmentsUpdateFieldInput>>;
  muted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  needs_grading_count?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_ADD?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  nudgesAboutThis?: InputMaybe<Array<AssignmentNudgesAboutThisUpdateFieldInput>>;
  objectives?: InputMaybe<Scalars['String']['input']>;
  omit_from_final_grade?: InputMaybe<Scalars['Boolean']['input']>;
  only_visible_to_overrides?: InputMaybe<Scalars['Boolean']['input']>;
  peer_reviews?: InputMaybe<Scalars['Boolean']['input']>;
  points_possible?: InputMaybe<Scalars['Float']['input']>;
  points_possible_ADD?: InputMaybe<Scalars['Float']['input']>;
  points_possible_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  position_ADD?: InputMaybe<Scalars['Float']['input']>;
  position_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  position_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  position_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  post_manually?: InputMaybe<Scalars['Boolean']['input']>;
  post_to_sis?: InputMaybe<Scalars['Boolean']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  require_lockdown_browser?: InputMaybe<Scalars['Boolean']['input']>;
  resource_metadata?: InputMaybe<Scalars['String']['input']>;
  restrict_quantitative_data?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  section_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  section_ids_POP?: InputMaybe<Scalars['Int']['input']>;
  section_ids_PUSH?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  secure_params?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  submissions?: InputMaybe<Array<AssignmentSubmissionsUpdateFieldInput>>;
  submissions_download_url?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unpublishable?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  usersHasSchoolAssignment?: InputMaybe<Array<AssignmentUsersHasSchoolAssignmentUpdateFieldInput>>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visible_to_everyone?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_state?: InputMaybe<Scalars['String']['input']>;
  worksheet?: InputMaybe<AssignmentWorksheetUpdateFieldInput>;
};

export type AssignmentUserUsersHasSchoolAssignmentAggregationSelection = {
  __typename?: 'AssignmentUserUsersHasSchoolAssignmentAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<AssignmentUserUsersHasSchoolAssignmentEdgeAggregateSelection>;
  node?: Maybe<AssignmentUserUsersHasSchoolAssignmentNodeAggregateSelection>;
};

export type AssignmentUserUsersHasSchoolAssignmentEdgeAggregateSelection = {
  __typename?: 'AssignmentUserUsersHasSchoolAssignmentEdgeAggregateSelection';
  retakeDeadline: DateTimeAggregateSelection;
};

export type AssignmentUserUsersHasSchoolAssignmentNodeAggregateSelection = {
  __typename?: 'AssignmentUserUsersHasSchoolAssignmentNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type AssignmentUsersHasSchoolAssignmentAggregateInput = {
  AND?: InputMaybe<Array<AssignmentUsersHasSchoolAssignmentAggregateInput>>;
  NOT?: InputMaybe<AssignmentUsersHasSchoolAssignmentAggregateInput>;
  OR?: InputMaybe<Array<AssignmentUsersHasSchoolAssignmentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasSchoolAssignmentPropertiesAggregationWhereInput>;
  node?: InputMaybe<AssignmentUsersHasSchoolAssignmentNodeAggregationWhereInput>;
};

export type AssignmentUsersHasSchoolAssignmentConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  edge?: InputMaybe<HasSchoolAssignmentPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type AssignmentUsersHasSchoolAssignmentConnectOrCreateFieldInput = {
  onCreate: AssignmentUsersHasSchoolAssignmentConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type AssignmentUsersHasSchoolAssignmentConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<HasSchoolAssignmentPropertiesCreateInput>;
  node: UserOnCreateInput;
};

export type AssignmentUsersHasSchoolAssignmentConnection = {
  __typename?: 'AssignmentUsersHasSchoolAssignmentConnection';
  edges: Array<AssignmentUsersHasSchoolAssignmentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssignmentUsersHasSchoolAssignmentConnectionSort = {
  edge?: InputMaybe<HasSchoolAssignmentPropertiesSort>;
  node?: InputMaybe<UserSort>;
};

export type AssignmentUsersHasSchoolAssignmentConnectionWhere = {
  AND?: InputMaybe<Array<AssignmentUsersHasSchoolAssignmentConnectionWhere>>;
  NOT?: InputMaybe<AssignmentUsersHasSchoolAssignmentConnectionWhere>;
  OR?: InputMaybe<Array<AssignmentUsersHasSchoolAssignmentConnectionWhere>>;
  edge?: InputMaybe<HasSchoolAssignmentPropertiesWhere>;
  node?: InputMaybe<UserWhere>;
};

export type AssignmentUsersHasSchoolAssignmentCreateFieldInput = {
  edge?: InputMaybe<HasSchoolAssignmentPropertiesCreateInput>;
  node: UserCreateInput;
};

export type AssignmentUsersHasSchoolAssignmentDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<AssignmentUsersHasSchoolAssignmentConnectionWhere>;
};

export type AssignmentUsersHasSchoolAssignmentDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<AssignmentUsersHasSchoolAssignmentConnectionWhere>;
};

export type AssignmentUsersHasSchoolAssignmentFieldInput = {
  connect?: InputMaybe<Array<AssignmentUsersHasSchoolAssignmentConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssignmentUsersHasSchoolAssignmentConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssignmentUsersHasSchoolAssignmentCreateFieldInput>>;
};

export type AssignmentUsersHasSchoolAssignmentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AssignmentUsersHasSchoolAssignmentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AssignmentUsersHasSchoolAssignmentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AssignmentUsersHasSchoolAssignmentNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AssignmentUsersHasSchoolAssignmentRelationship = {
  __typename?: 'AssignmentUsersHasSchoolAssignmentRelationship';
  cursor: Scalars['String']['output'];
  node: User;
  properties: HasSchoolAssignmentProperties;
};

export type AssignmentUsersHasSchoolAssignmentUpdateConnectionInput = {
  edge?: InputMaybe<HasSchoolAssignmentPropertiesUpdateInput>;
  node?: InputMaybe<UserUpdateInput>;
};

export type AssignmentUsersHasSchoolAssignmentUpdateFieldInput = {
  connect?: InputMaybe<Array<AssignmentUsersHasSchoolAssignmentConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AssignmentUsersHasSchoolAssignmentConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AssignmentUsersHasSchoolAssignmentCreateFieldInput>>;
  delete?: InputMaybe<Array<AssignmentUsersHasSchoolAssignmentDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AssignmentUsersHasSchoolAssignmentDisconnectFieldInput>>;
  update?: InputMaybe<AssignmentUsersHasSchoolAssignmentUpdateConnectionInput>;
  where?: InputMaybe<AssignmentUsersHasSchoolAssignmentConnectionWhere>;
};

export type AssignmentWhere = {
  AND?: InputMaybe<Array<AssignmentWhere>>;
  NOT?: InputMaybe<AssignmentWhere>;
  OR?: InputMaybe<Array<AssignmentWhere>>;
  _empty?: InputMaybe<Scalars['String']['input']>;
  _empty_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  _empty_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  _empty_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  _empty_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  activityState?: InputMaybe<ActivityState>;
  activityState_IN?: InputMaybe<Array<InputMaybe<ActivityState>>>;
  allowed_attempts?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  allowed_attempts_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_LTE?: InputMaybe<Scalars['Float']['input']>;
  anonymize_students?: InputMaybe<Scalars['Boolean']['input']>;
  anonymous_grading?: InputMaybe<Scalars['Boolean']['input']>;
  anonymous_instructor_annotations?: InputMaybe<Scalars['Boolean']['input']>;
  anonymous_peer_reviews?: InputMaybe<Scalars['Boolean']['input']>;
  assignee_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assignee_ids_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  assignee_mode?: InputMaybe<Scalars['String']['input']>;
  assignee_mode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  assignee_mode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  assignee_mode_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assignee_mode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  assignment_group_id?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  assignment_group_id_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name?: InputMaybe<Scalars['String']['input']>;
  assignment_name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  assignment_name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  assignment_name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assignment_name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  automatic_peer_reviews?: InputMaybe<Scalars['Boolean']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  body_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  body_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  body_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  can_duplicate?: InputMaybe<Scalars['Boolean']['input']>;
  category_id?: InputMaybe<Scalars['String']['input']>;
  category_id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  category_id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  category_id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category_id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  courseCategoriesHasAssignmentAggregate?: InputMaybe<AssignmentCourseCategoriesHasAssignmentAggregateInput>;
  /** Return Assignments where all of the related AssignmentCourseCategoriesHasAssignmentConnections match this filter */
  courseCategoriesHasAssignmentConnection_ALL?: InputMaybe<AssignmentCourseCategoriesHasAssignmentConnectionWhere>;
  /** Return Assignments where none of the related AssignmentCourseCategoriesHasAssignmentConnections match this filter */
  courseCategoriesHasAssignmentConnection_NONE?: InputMaybe<AssignmentCourseCategoriesHasAssignmentConnectionWhere>;
  /** Return Assignments where one of the related AssignmentCourseCategoriesHasAssignmentConnections match this filter */
  courseCategoriesHasAssignmentConnection_SINGLE?: InputMaybe<AssignmentCourseCategoriesHasAssignmentConnectionWhere>;
  /** Return Assignments where some of the related AssignmentCourseCategoriesHasAssignmentConnections match this filter */
  courseCategoriesHasAssignmentConnection_SOME?: InputMaybe<AssignmentCourseCategoriesHasAssignmentConnectionWhere>;
  /** Return Assignments where all of the related CourseCategories match this filter */
  courseCategoriesHasAssignment_ALL?: InputMaybe<CourseCategoryWhere>;
  /** Return Assignments where none of the related CourseCategories match this filter */
  courseCategoriesHasAssignment_NONE?: InputMaybe<CourseCategoryWhere>;
  /** Return Assignments where one of the related CourseCategories match this filter */
  courseCategoriesHasAssignment_SINGLE?: InputMaybe<CourseCategoryWhere>;
  /** Return Assignments where some of the related CourseCategories match this filter */
  courseCategoriesHasAssignment_SOME?: InputMaybe<CourseCategoryWhere>;
  course_id?: InputMaybe<Scalars['Float']['input']>;
  course_id_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  course_id_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_LTE?: InputMaybe<Scalars['Float']['input']>;
  coursesHasAssignmentAggregate?: InputMaybe<AssignmentCoursesHasAssignmentAggregateInput>;
  /** Return Assignments where all of the related AssignmentCoursesHasAssignmentConnections match this filter */
  coursesHasAssignmentConnection_ALL?: InputMaybe<AssignmentCoursesHasAssignmentConnectionWhere>;
  /** Return Assignments where none of the related AssignmentCoursesHasAssignmentConnections match this filter */
  coursesHasAssignmentConnection_NONE?: InputMaybe<AssignmentCoursesHasAssignmentConnectionWhere>;
  /** Return Assignments where one of the related AssignmentCoursesHasAssignmentConnections match this filter */
  coursesHasAssignmentConnection_SINGLE?: InputMaybe<AssignmentCoursesHasAssignmentConnectionWhere>;
  /** Return Assignments where some of the related AssignmentCoursesHasAssignmentConnections match this filter */
  coursesHasAssignmentConnection_SOME?: InputMaybe<AssignmentCoursesHasAssignmentConnectionWhere>;
  /** Return Assignments where all of the related Courses match this filter */
  coursesHasAssignment_ALL?: InputMaybe<CourseWhere>;
  /** Return Assignments where none of the related Courses match this filter */
  coursesHasAssignment_NONE?: InputMaybe<CourseWhere>;
  /** Return Assignments where one of the related Courses match this filter */
  coursesHasAssignment_SINGLE?: InputMaybe<CourseWhere>;
  /** Return Assignments where some of the related Courses match this filter */
  coursesHasAssignment_SOME?: InputMaybe<CourseWhere>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at?: InputMaybe<Scalars['String']['input']>;
  created_at_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  created_at_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  created_at_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  created_at_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  created_date?: InputMaybe<Scalars['String']['input']>;
  created_date_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  created_date_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  created_date_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  created_date_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_plaintext?: InputMaybe<Scalars['String']['input']>;
  description_plaintext_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_plaintext_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_plaintext_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_plaintext_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_allow_rating?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_assignment_id?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  discussion_topic_assignment_id_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_attachments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discussion_topic_attachments_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_author_anonymous_id?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_author_anonymous_id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_author_anonymous_id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_author_anonymous_id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discussion_topic_author_anonymous_id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_author_avatar_image_url?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_author_avatar_image_url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_author_avatar_image_url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_author_avatar_image_url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discussion_topic_author_avatar_image_url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_author_display_name?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_author_display_name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_author_display_name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_author_display_name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discussion_topic_author_display_name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_author_html_url?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_author_html_url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_author_html_url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_author_html_url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discussion_topic_author_html_url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_author_id?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  discussion_topic_author_id_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_can_group?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_can_lock?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_can_unpublish?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_comments_disabled?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_created_at?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_created_at_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_created_at_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_created_at_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discussion_topic_created_at_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_discussion_subentry_count?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  discussion_topic_discussion_subentry_count_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_discussion_type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_discussion_type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_discussion_type_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discussion_topic_discussion_type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_group_topic_children?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discussion_topic_group_topic_children_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_html_url?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_html_url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_html_url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_html_url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discussion_topic_html_url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_id?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  discussion_topic_id_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_is_announcement?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_is_section_specific?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_last_reply_at?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_last_reply_at_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_last_reply_at_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_last_reply_at_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discussion_topic_last_reply_at_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_locked?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_locked_for_user?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_message?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_message_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_message_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_message_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discussion_topic_message_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_only_graders_can_rate?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_permissions_attach?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_permissions_delete?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_permissions_manage_assign_to?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_permissions_reply?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_permissions_update?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_pinned?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_podcast_has_student_posts?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_posted_at?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_posted_at_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_posted_at_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_posted_at_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discussion_topic_posted_at_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_published?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_read_state?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_read_state_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_read_state_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_read_state_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discussion_topic_read_state_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_sort_by_rating?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_subscribed?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_summary_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_title?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_title_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discussion_topic_title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_topic_children?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discussion_topic_topic_children_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_unread_count?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  discussion_topic_unread_count_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discussion_topic_url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_user_can_see_posts?: InputMaybe<Scalars['Boolean']['input']>;
  discussion_topic_user_name?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_user_name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_user_name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  discussion_topic_user_name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discussion_topic_user_name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  display_date?: InputMaybe<Scalars['String']['input']>;
  display_date_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  display_date_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  display_date_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  display_date_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentsAggregate?: InputMaybe<AssignmentDocumentsAggregateInput>;
  /** Return Assignments where all of the related AssignmentDocumentsConnections match this filter */
  documentsConnection_ALL?: InputMaybe<AssignmentDocumentsConnectionWhere>;
  /** Return Assignments where none of the related AssignmentDocumentsConnections match this filter */
  documentsConnection_NONE?: InputMaybe<AssignmentDocumentsConnectionWhere>;
  /** Return Assignments where one of the related AssignmentDocumentsConnections match this filter */
  documentsConnection_SINGLE?: InputMaybe<AssignmentDocumentsConnectionWhere>;
  /** Return Assignments where some of the related AssignmentDocumentsConnections match this filter */
  documentsConnection_SOME?: InputMaybe<AssignmentDocumentsConnectionWhere>;
  /** Return Assignments where all of the related Documents match this filter */
  documents_ALL?: InputMaybe<DocumentWhere>;
  /** Return Assignments where none of the related Documents match this filter */
  documents_NONE?: InputMaybe<DocumentWhere>;
  /** Return Assignments where one of the related Documents match this filter */
  documents_SINGLE?: InputMaybe<DocumentWhere>;
  /** Return Assignments where some of the related Documents match this filter */
  documents_SOME?: InputMaybe<DocumentWhere>;
  due_at?: InputMaybe<Scalars['String']['input']>;
  due_at_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  due_at_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  due_at_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  due_at_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  due_date?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_GT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  due_date_LT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_required?: InputMaybe<Scalars['Boolean']['input']>;
  enableStudentFileUpload?: InputMaybe<Scalars['Boolean']['input']>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  end_date_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  end_date_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  end_date_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  end_date_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  external_tool_tag_attributes_content_id?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  external_tool_tag_attributes_content_id_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type?: InputMaybe<Scalars['String']['input']>;
  external_tool_tag_attributes_content_type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  external_tool_tag_attributes_content_type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  external_tool_tag_attributes_content_type_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  external_tool_tag_attributes_content_type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  external_tool_tag_attributes_external_data?: InputMaybe<Scalars['String']['input']>;
  external_tool_tag_attributes_external_data_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  external_tool_tag_attributes_external_data_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  external_tool_tag_attributes_external_data_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  external_tool_tag_attributes_external_data_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  external_tool_tag_attributes_new_tab?: InputMaybe<Scalars['Boolean']['input']>;
  external_tool_tag_attributes_resource_link_id?: InputMaybe<Scalars['String']['input']>;
  external_tool_tag_attributes_resource_link_id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  external_tool_tag_attributes_resource_link_id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  external_tool_tag_attributes_resource_link_id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  external_tool_tag_attributes_resource_link_id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  external_tool_tag_attributes_url?: InputMaybe<Scalars['String']['input']>;
  external_tool_tag_attributes_url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  external_tool_tag_attributes_url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  external_tool_tag_attributes_url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  external_tool_tag_attributes_url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  filesAggregate?: InputMaybe<AssignmentFilesAggregateInput>;
  /** Return Assignments where all of the related AssignmentFilesConnections match this filter */
  filesConnection_ALL?: InputMaybe<AssignmentFilesConnectionWhere>;
  /** Return Assignments where none of the related AssignmentFilesConnections match this filter */
  filesConnection_NONE?: InputMaybe<AssignmentFilesConnectionWhere>;
  /** Return Assignments where one of the related AssignmentFilesConnections match this filter */
  filesConnection_SINGLE?: InputMaybe<AssignmentFilesConnectionWhere>;
  /** Return Assignments where some of the related AssignmentFilesConnections match this filter */
  filesConnection_SOME?: InputMaybe<AssignmentFilesConnectionWhere>;
  /** Return Assignments where all of the related Files match this filter */
  files_ALL?: InputMaybe<FileWhere>;
  /** Return Assignments where none of the related Files match this filter */
  files_NONE?: InputMaybe<FileWhere>;
  /** Return Assignments where one of the related Files match this filter */
  files_SINGLE?: InputMaybe<FileWhere>;
  /** Return Assignments where some of the related Files match this filter */
  files_SOME?: InputMaybe<FileWhere>;
  frozen_attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  frozen_attributes_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  grade_group_students_individually?: InputMaybe<Scalars['Boolean']['input']>;
  grade_points?: InputMaybe<Scalars['Float']['input']>;
  grade_points_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  grade_points_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_LTE?: InputMaybe<Scalars['Float']['input']>;
  graded_submissions_exist?: InputMaybe<Scalars['Boolean']['input']>;
  grader_comments_visible_to_graders?: InputMaybe<Scalars['Boolean']['input']>;
  grader_count?: InputMaybe<Scalars['Float']['input']>;
  grader_count_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  grader_count_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_names_visible_to_final_grader?: InputMaybe<Scalars['Boolean']['input']>;
  graders_anonymous_to_graders?: InputMaybe<Scalars['Boolean']['input']>;
  grading_type?: InputMaybe<Scalars['String']['input']>;
  grading_type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  grading_type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  grading_type_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grading_type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  hasChatChatsAggregate?: InputMaybe<AssignmentHasChatChatsAggregateInput>;
  /** Return Assignments where all of the related AssignmentHasChatChatsConnections match this filter */
  hasChatChatsConnection_ALL?: InputMaybe<AssignmentHasChatChatsConnectionWhere>;
  /** Return Assignments where none of the related AssignmentHasChatChatsConnections match this filter */
  hasChatChatsConnection_NONE?: InputMaybe<AssignmentHasChatChatsConnectionWhere>;
  /** Return Assignments where one of the related AssignmentHasChatChatsConnections match this filter */
  hasChatChatsConnection_SINGLE?: InputMaybe<AssignmentHasChatChatsConnectionWhere>;
  /** Return Assignments where some of the related AssignmentHasChatChatsConnections match this filter */
  hasChatChatsConnection_SOME?: InputMaybe<AssignmentHasChatChatsConnectionWhere>;
  /** Return Assignments where all of the related Chats match this filter */
  hasChatChats_ALL?: InputMaybe<ChatWhere>;
  /** Return Assignments where none of the related Chats match this filter */
  hasChatChats_NONE?: InputMaybe<ChatWhere>;
  /** Return Assignments where one of the related Chats match this filter */
  hasChatChats_SINGLE?: InputMaybe<ChatWhere>;
  /** Return Assignments where some of the related Chats match this filter */
  hasChatChats_SOME?: InputMaybe<ChatWhere>;
  hasObjectiveObjectiveAggregate?: InputMaybe<AssignmentHasObjectiveObjectiveAggregateInput>;
  /** Return Assignments where all of the related AssignmentHasObjectiveObjectiveConnections match this filter */
  hasObjectiveObjectiveConnection_ALL?: InputMaybe<AssignmentHasObjectiveObjectiveConnectionWhere>;
  /** Return Assignments where none of the related AssignmentHasObjectiveObjectiveConnections match this filter */
  hasObjectiveObjectiveConnection_NONE?: InputMaybe<AssignmentHasObjectiveObjectiveConnectionWhere>;
  /** Return Assignments where one of the related AssignmentHasObjectiveObjectiveConnections match this filter */
  hasObjectiveObjectiveConnection_SINGLE?: InputMaybe<AssignmentHasObjectiveObjectiveConnectionWhere>;
  /** Return Assignments where some of the related AssignmentHasObjectiveObjectiveConnections match this filter */
  hasObjectiveObjectiveConnection_SOME?: InputMaybe<AssignmentHasObjectiveObjectiveConnectionWhere>;
  /** Return Assignments where all of the related Objectives match this filter */
  hasObjectiveObjective_ALL?: InputMaybe<ObjectiveWhere>;
  /** Return Assignments where none of the related Objectives match this filter */
  hasObjectiveObjective_NONE?: InputMaybe<ObjectiveWhere>;
  /** Return Assignments where one of the related Objectives match this filter */
  hasObjectiveObjective_SINGLE?: InputMaybe<ObjectiveWhere>;
  /** Return Assignments where some of the related Objectives match this filter */
  hasObjectiveObjective_SOME?: InputMaybe<ObjectiveWhere>;
  has_overrides?: InputMaybe<Scalars['Boolean']['input']>;
  has_submitted_submissions?: InputMaybe<Scalars['Boolean']['input']>;
  hide_in_gradebook?: InputMaybe<Scalars['Boolean']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  html_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  html_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  html_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  html_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  html_url?: InputMaybe<Scalars['String']['input']>;
  html_url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  html_url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  html_url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  html_url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  important_dates?: InputMaybe<Scalars['Boolean']['input']>;
  in_closed_grading_period?: InputMaybe<Scalars['Boolean']['input']>;
  intra_group_peer_reviews?: InputMaybe<Scalars['Boolean']['input']>;
  is_quiz_assignment?: InputMaybe<Scalars['Boolean']['input']>;
  is_quiz_lti_assignment?: InputMaybe<Scalars['Boolean']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastModified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  locked_for_user?: InputMaybe<Scalars['Boolean']['input']>;
  lti_context_id?: InputMaybe<Scalars['String']['input']>;
  lti_context_id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lti_context_id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lti_context_id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lti_context_id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  max_attempts?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  max_attempts_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  max_name_length_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_LTE?: InputMaybe<Scalars['Float']['input']>;
  moderated_grading?: InputMaybe<Scalars['Boolean']['input']>;
  moduleHasAssignmentsAggregate?: InputMaybe<AssignmentModuleHasAssignmentsAggregateInput>;
  /** Return Assignments where all of the related AssignmentModuleHasAssignmentsConnections match this filter */
  moduleHasAssignmentsConnection_ALL?: InputMaybe<AssignmentModuleHasAssignmentsConnectionWhere>;
  /** Return Assignments where none of the related AssignmentModuleHasAssignmentsConnections match this filter */
  moduleHasAssignmentsConnection_NONE?: InputMaybe<AssignmentModuleHasAssignmentsConnectionWhere>;
  /** Return Assignments where one of the related AssignmentModuleHasAssignmentsConnections match this filter */
  moduleHasAssignmentsConnection_SINGLE?: InputMaybe<AssignmentModuleHasAssignmentsConnectionWhere>;
  /** Return Assignments where some of the related AssignmentModuleHasAssignmentsConnections match this filter */
  moduleHasAssignmentsConnection_SOME?: InputMaybe<AssignmentModuleHasAssignmentsConnectionWhere>;
  /** Return Assignments where all of the related Modules match this filter */
  moduleHasAssignments_ALL?: InputMaybe<ModuleWhere>;
  /** Return Assignments where none of the related Modules match this filter */
  moduleHasAssignments_NONE?: InputMaybe<ModuleWhere>;
  /** Return Assignments where one of the related Modules match this filter */
  moduleHasAssignments_SINGLE?: InputMaybe<ModuleWhere>;
  /** Return Assignments where some of the related Modules match this filter */
  moduleHasAssignments_SOME?: InputMaybe<ModuleWhere>;
  muted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  needs_grading_count?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  needs_grading_count_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_LTE?: InputMaybe<Scalars['Float']['input']>;
  nudgesAboutThisAggregate?: InputMaybe<AssignmentNudgesAboutThisAggregateInput>;
  /** Return Assignments where all of the related AssignmentNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_ALL?: InputMaybe<AssignmentNudgesAboutThisConnectionWhere>;
  /** Return Assignments where none of the related AssignmentNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_NONE?: InputMaybe<AssignmentNudgesAboutThisConnectionWhere>;
  /** Return Assignments where one of the related AssignmentNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_SINGLE?: InputMaybe<AssignmentNudgesAboutThisConnectionWhere>;
  /** Return Assignments where some of the related AssignmentNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_SOME?: InputMaybe<AssignmentNudgesAboutThisConnectionWhere>;
  /** Return Assignments where all of the related Nudges match this filter */
  nudgesAboutThis_ALL?: InputMaybe<NudgeWhere>;
  /** Return Assignments where none of the related Nudges match this filter */
  nudgesAboutThis_NONE?: InputMaybe<NudgeWhere>;
  /** Return Assignments where one of the related Nudges match this filter */
  nudgesAboutThis_SINGLE?: InputMaybe<NudgeWhere>;
  /** Return Assignments where some of the related Nudges match this filter */
  nudgesAboutThis_SOME?: InputMaybe<NudgeWhere>;
  objectives?: InputMaybe<Scalars['String']['input']>;
  objectives_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  objectives_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  objectives_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  objectives_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  omit_from_final_grade?: InputMaybe<Scalars['Boolean']['input']>;
  only_visible_to_overrides?: InputMaybe<Scalars['Boolean']['input']>;
  peer_reviews?: InputMaybe<Scalars['Boolean']['input']>;
  points_possible?: InputMaybe<Scalars['Float']['input']>;
  points_possible_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  points_possible_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_LTE?: InputMaybe<Scalars['Float']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  position_GT?: InputMaybe<Scalars['Float']['input']>;
  position_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  position_LT?: InputMaybe<Scalars['Float']['input']>;
  position_LTE?: InputMaybe<Scalars['Float']['input']>;
  post_manually?: InputMaybe<Scalars['Boolean']['input']>;
  post_to_sis?: InputMaybe<Scalars['Boolean']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  require_lockdown_browser?: InputMaybe<Scalars['Boolean']['input']>;
  resource_metadata?: InputMaybe<Scalars['String']['input']>;
  resource_metadata_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  resource_metadata_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  resource_metadata_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  resource_metadata_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  restrict_quantitative_data?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  scheduledDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  section_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  section_ids_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  secure_params?: InputMaybe<Scalars['String']['input']>;
  secure_params_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  secure_params_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  secure_params_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  secure_params_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  session_id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  session_id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  session_id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  session_id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  start_date_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  start_date_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  start_date_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  start_date_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  state_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  state_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  state_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  submissionsAggregate?: InputMaybe<AssignmentSubmissionsAggregateInput>;
  /** Return Assignments where all of the related AssignmentSubmissionsConnections match this filter */
  submissionsConnection_ALL?: InputMaybe<AssignmentSubmissionsConnectionWhere>;
  /** Return Assignments where none of the related AssignmentSubmissionsConnections match this filter */
  submissionsConnection_NONE?: InputMaybe<AssignmentSubmissionsConnectionWhere>;
  /** Return Assignments where one of the related AssignmentSubmissionsConnections match this filter */
  submissionsConnection_SINGLE?: InputMaybe<AssignmentSubmissionsConnectionWhere>;
  /** Return Assignments where some of the related AssignmentSubmissionsConnections match this filter */
  submissionsConnection_SOME?: InputMaybe<AssignmentSubmissionsConnectionWhere>;
  /** Return Assignments where all of the related Submissions match this filter */
  submissions_ALL?: InputMaybe<SubmissionWhere>;
  /** Return Assignments where none of the related Submissions match this filter */
  submissions_NONE?: InputMaybe<SubmissionWhere>;
  /** Return Assignments where one of the related Submissions match this filter */
  submissions_SINGLE?: InputMaybe<SubmissionWhere>;
  /** Return Assignments where some of the related Submissions match this filter */
  submissions_SOME?: InputMaybe<SubmissionWhere>;
  submissions_download_url?: InputMaybe<Scalars['String']['input']>;
  submissions_download_url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  submissions_download_url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  submissions_download_url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submissions_download_url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  unpublishable?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['String']['input']>;
  updated_at_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  updated_at_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  updated_at_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updated_at_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['String']['input']>;
  updated_date_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  updated_date_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  updated_date_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updated_date_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  usersHasSchoolAssignmentAggregate?: InputMaybe<AssignmentUsersHasSchoolAssignmentAggregateInput>;
  /** Return Assignments where all of the related AssignmentUsersHasSchoolAssignmentConnections match this filter */
  usersHasSchoolAssignmentConnection_ALL?: InputMaybe<AssignmentUsersHasSchoolAssignmentConnectionWhere>;
  /** Return Assignments where none of the related AssignmentUsersHasSchoolAssignmentConnections match this filter */
  usersHasSchoolAssignmentConnection_NONE?: InputMaybe<AssignmentUsersHasSchoolAssignmentConnectionWhere>;
  /** Return Assignments where one of the related AssignmentUsersHasSchoolAssignmentConnections match this filter */
  usersHasSchoolAssignmentConnection_SINGLE?: InputMaybe<AssignmentUsersHasSchoolAssignmentConnectionWhere>;
  /** Return Assignments where some of the related AssignmentUsersHasSchoolAssignmentConnections match this filter */
  usersHasSchoolAssignmentConnection_SOME?: InputMaybe<AssignmentUsersHasSchoolAssignmentConnectionWhere>;
  /** Return Assignments where all of the related Users match this filter */
  usersHasSchoolAssignment_ALL?: InputMaybe<UserWhere>;
  /** Return Assignments where none of the related Users match this filter */
  usersHasSchoolAssignment_NONE?: InputMaybe<UserWhere>;
  /** Return Assignments where one of the related Users match this filter */
  usersHasSchoolAssignment_SINGLE?: InputMaybe<UserWhere>;
  /** Return Assignments where some of the related Users match this filter */
  usersHasSchoolAssignment_SOME?: InputMaybe<UserWhere>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  videoUrl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  videoUrl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  videoUrl_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoUrl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  visible_to_everyone?: InputMaybe<Scalars['Boolean']['input']>;
  workflow_state?: InputMaybe<Scalars['String']['input']>;
  workflow_state_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  workflow_state_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  workflow_state_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workflow_state_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  worksheet?: InputMaybe<WorksheetWhere>;
  worksheetAggregate?: InputMaybe<AssignmentWorksheetAggregateInput>;
  worksheetConnection?: InputMaybe<AssignmentWorksheetConnectionWhere>;
  worksheetConnection_NOT?: InputMaybe<AssignmentWorksheetConnectionWhere>;
  worksheet_NOT?: InputMaybe<WorksheetWhere>;
};

export type AssignmentWithCourse = {
  __typename?: 'AssignmentWithCourse';
  courseCode?: Maybe<Scalars['String']['output']>;
  courseId?: Maybe<Scalars['ID']['output']>;
  courseName?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  points_possible?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AssignmentWorksheetAggregateInput = {
  AND?: InputMaybe<Array<AssignmentWorksheetAggregateInput>>;
  NOT?: InputMaybe<AssignmentWorksheetAggregateInput>;
  OR?: InputMaybe<Array<AssignmentWorksheetAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AssignmentWorksheetNodeAggregationWhereInput>;
};

export type AssignmentWorksheetConnectFieldInput = {
  connect?: InputMaybe<WorksheetConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<WorksheetConnectWhere>;
};

export type AssignmentWorksheetConnectOrCreateFieldInput = {
  onCreate: AssignmentWorksheetConnectOrCreateFieldInputOnCreate;
  where: WorksheetConnectOrCreateWhere;
};

export type AssignmentWorksheetConnectOrCreateFieldInputOnCreate = {
  node: WorksheetOnCreateInput;
};

export type AssignmentWorksheetConnection = {
  __typename?: 'AssignmentWorksheetConnection';
  edges: Array<AssignmentWorksheetRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssignmentWorksheetConnectionSort = {
  node?: InputMaybe<WorksheetSort>;
};

export type AssignmentWorksheetConnectionWhere = {
  AND?: InputMaybe<Array<AssignmentWorksheetConnectionWhere>>;
  NOT?: InputMaybe<AssignmentWorksheetConnectionWhere>;
  OR?: InputMaybe<Array<AssignmentWorksheetConnectionWhere>>;
  node?: InputMaybe<WorksheetWhere>;
};

export type AssignmentWorksheetCreateFieldInput = {
  node: WorksheetCreateInput;
};

export type AssignmentWorksheetDeleteFieldInput = {
  delete?: InputMaybe<WorksheetDeleteInput>;
  where?: InputMaybe<AssignmentWorksheetConnectionWhere>;
};

export type AssignmentWorksheetDisconnectFieldInput = {
  disconnect?: InputMaybe<WorksheetDisconnectInput>;
  where?: InputMaybe<AssignmentWorksheetConnectionWhere>;
};

export type AssignmentWorksheetFieldInput = {
  connect?: InputMaybe<AssignmentWorksheetConnectFieldInput>;
  connectOrCreate?: InputMaybe<AssignmentWorksheetConnectOrCreateFieldInput>;
  create?: InputMaybe<AssignmentWorksheetCreateFieldInput>;
};

export type AssignmentWorksheetNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AssignmentWorksheetNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AssignmentWorksheetNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AssignmentWorksheetNodeAggregationWhereInput>>;
  coverage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coverage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  coverage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  coverage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  coverage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  coverage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coverage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  coverage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  coverage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  coverage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coverage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coverage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  coverage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  coverage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  coverage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  instructions_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  instructions_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  instructions_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  instructions_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  instructions_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  instructions_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  instructions_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  instructions_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  instructions_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  instructions_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  instructions_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  instructions_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  instructions_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  instructions_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  instructions_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  numQuestions_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  numQuestions_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  numQuestions_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  numQuestions_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  numQuestions_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  numQuestions_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numQuestions_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  numQuestions_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  numQuestions_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  numQuestions_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  numQuestions_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numQuestions_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  numQuestions_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  numQuestions_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  numQuestions_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  numQuestions_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numQuestions_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  numQuestions_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  numQuestions_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  numQuestions_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AssignmentWorksheetRelationship = {
  __typename?: 'AssignmentWorksheetRelationship';
  cursor: Scalars['String']['output'];
  node: Worksheet;
};

export type AssignmentWorksheetUpdateConnectionInput = {
  node?: InputMaybe<WorksheetUpdateInput>;
};

export type AssignmentWorksheetUpdateFieldInput = {
  connect?: InputMaybe<AssignmentWorksheetConnectFieldInput>;
  connectOrCreate?: InputMaybe<AssignmentWorksheetConnectOrCreateFieldInput>;
  create?: InputMaybe<AssignmentWorksheetCreateFieldInput>;
  delete?: InputMaybe<AssignmentWorksheetDeleteFieldInput>;
  disconnect?: InputMaybe<AssignmentWorksheetDisconnectFieldInput>;
  update?: InputMaybe<AssignmentWorksheetUpdateConnectionInput>;
  where?: InputMaybe<AssignmentWorksheetConnectionWhere>;
};

export type AssignmentWorksheetWorksheetAggregationSelection = {
  __typename?: 'AssignmentWorksheetWorksheetAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AssignmentWorksheetWorksheetNodeAggregateSelection>;
};

export type AssignmentWorksheetWorksheetNodeAggregateSelection = {
  __typename?: 'AssignmentWorksheetWorksheetNodeAggregateSelection';
  coverage: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  instructions: StringAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  numQuestions: IntAggregateSelection;
  title: StringAggregateSelection;
};

export type AssignmentsWithCourseResponse = {
  __typename?: 'AssignmentsWithCourseResponse';
  count: Scalars['Int']['output'];
  data: Array<AssignmentWithCourse>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AttachmentInput = {
  fileId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  type: AttachmentType;
};

export type AttachmentProcessData = {
  __typename?: 'AttachmentProcessData';
  documentId: Scalars['ID']['output'];
  fileId: Scalars['ID']['output'];
  fileName: Scalars['String']['output'];
};

export enum AttachmentType {
  Assignment = 'assignment',
  Document = 'document',
  Todo = 'todo'
}

export type Attribute = {
  __typename?: 'Attribute';
  achievements: Array<Achievements>;
  achievementsAggregate?: Maybe<AttributeAchievementsAchievementsAggregationSelection>;
  achievementsConnection: AttributeAchievementsConnection;
  created: Scalars['DateTime']['output'];
  embedding: Array<Maybe<Scalars['Float']['output']>>;
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
  users: Array<User>;
  usersAggregate?: Maybe<AttributeUserUsersAggregationSelection>;
  usersConnection: AttributeUsersConnection;
};


export type AttributeAchievementsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AchievementsOptions>;
  where?: InputMaybe<AchievementsWhere>;
};


export type AttributeAchievementsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AchievementsWhere>;
};


export type AttributeAchievementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AttributeAchievementsConnectionSort>>;
  where?: InputMaybe<AttributeAchievementsConnectionWhere>;
};


export type AttributeUsersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type AttributeUsersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type AttributeUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AttributeUsersConnectionSort>>;
  where?: InputMaybe<AttributeUsersConnectionWhere>;
};

export type AttributeAchievementsAchievementsAggregationSelection = {
  __typename?: 'AttributeAchievementsAchievementsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AttributeAchievementsAchievementsNodeAggregateSelection>;
};

export type AttributeAchievementsAchievementsNodeAggregateSelection = {
  __typename?: 'AttributeAchievementsAchievementsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  name: StringAggregateSelection;
};

export type AttributeAchievementsAggregateInput = {
  AND?: InputMaybe<Array<AttributeAchievementsAggregateInput>>;
  NOT?: InputMaybe<AttributeAchievementsAggregateInput>;
  OR?: InputMaybe<Array<AttributeAchievementsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AttributeAchievementsNodeAggregationWhereInput>;
};

export type AttributeAchievementsConnectFieldInput = {
  connect?: InputMaybe<Array<AchievementsConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AchievementsConnectWhere>;
};

export type AttributeAchievementsConnection = {
  __typename?: 'AttributeAchievementsConnection';
  edges: Array<AttributeAchievementsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AttributeAchievementsConnectionSort = {
  node?: InputMaybe<AchievementsSort>;
};

export type AttributeAchievementsConnectionWhere = {
  AND?: InputMaybe<Array<AttributeAchievementsConnectionWhere>>;
  NOT?: InputMaybe<AttributeAchievementsConnectionWhere>;
  OR?: InputMaybe<Array<AttributeAchievementsConnectionWhere>>;
  node?: InputMaybe<AchievementsWhere>;
};

export type AttributeAchievementsCreateFieldInput = {
  node: AchievementsCreateInput;
};

export type AttributeAchievementsDeleteFieldInput = {
  delete?: InputMaybe<AchievementsDeleteInput>;
  where?: InputMaybe<AttributeAchievementsConnectionWhere>;
};

export type AttributeAchievementsDisconnectFieldInput = {
  disconnect?: InputMaybe<AchievementsDisconnectInput>;
  where?: InputMaybe<AttributeAchievementsConnectionWhere>;
};

export type AttributeAchievementsFieldInput = {
  connect?: InputMaybe<Array<AttributeAchievementsConnectFieldInput>>;
  create?: InputMaybe<Array<AttributeAchievementsCreateFieldInput>>;
};

export type AttributeAchievementsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AttributeAchievementsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AttributeAchievementsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AttributeAchievementsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AttributeAchievementsRelationship = {
  __typename?: 'AttributeAchievementsRelationship';
  cursor: Scalars['String']['output'];
  node: Achievements;
};

export type AttributeAchievementsUpdateConnectionInput = {
  node?: InputMaybe<AchievementsUpdateInput>;
};

export type AttributeAchievementsUpdateFieldInput = {
  connect?: InputMaybe<Array<AttributeAchievementsConnectFieldInput>>;
  create?: InputMaybe<Array<AttributeAchievementsCreateFieldInput>>;
  delete?: InputMaybe<Array<AttributeAchievementsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AttributeAchievementsDisconnectFieldInput>>;
  update?: InputMaybe<AttributeAchievementsUpdateConnectionInput>;
  where?: InputMaybe<AttributeAchievementsConnectionWhere>;
};

export type AttributeConnectInput = {
  achievements?: InputMaybe<Array<AttributeAchievementsConnectFieldInput>>;
  users?: InputMaybe<Array<AttributeUsersConnectFieldInput>>;
};

export type AttributeConnectWhere = {
  node: AttributeWhere;
};

export type AttributeCreateInput = {
  achievements?: InputMaybe<AttributeAchievementsFieldInput>;
  created: Scalars['DateTime']['input'];
  embedding: Array<InputMaybe<Scalars['Float']['input']>>;
  id: Scalars['String']['input'];
  text: Scalars['String']['input'];
  users?: InputMaybe<AttributeUsersFieldInput>;
};

export type AttributeDeleteInput = {
  achievements?: InputMaybe<Array<AttributeAchievementsDeleteFieldInput>>;
  users?: InputMaybe<Array<AttributeUsersDeleteFieldInput>>;
};

export type AttributeDisconnectInput = {
  achievements?: InputMaybe<Array<AttributeAchievementsDisconnectFieldInput>>;
  users?: InputMaybe<Array<AttributeUsersDisconnectFieldInput>>;
};

export type AttributeOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AttributeSort objects to sort Attributes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AttributeSort>>;
};

/** Fields to sort Attributes by. The order in which sorts are applied is not guaranteed when specifying many fields in one AttributeSort object. */
export type AttributeSort = {
  created?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  text?: InputMaybe<SortDirection>;
};

export type AttributeUpdateInput = {
  achievements?: InputMaybe<Array<AttributeAchievementsUpdateFieldInput>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  embedding?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  embedding_POP?: InputMaybe<Scalars['Int']['input']>;
  embedding_PUSH?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<AttributeUsersUpdateFieldInput>>;
};

export type AttributeUserUsersAggregationSelection = {
  __typename?: 'AttributeUserUsersAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AttributeUserUsersNodeAggregateSelection>;
};

export type AttributeUserUsersNodeAggregateSelection = {
  __typename?: 'AttributeUserUsersNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type AttributeUsersAggregateInput = {
  AND?: InputMaybe<Array<AttributeUsersAggregateInput>>;
  NOT?: InputMaybe<AttributeUsersAggregateInput>;
  OR?: InputMaybe<Array<AttributeUsersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AttributeUsersNodeAggregationWhereInput>;
};

export type AttributeUsersConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type AttributeUsersConnectOrCreateFieldInput = {
  onCreate: AttributeUsersConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type AttributeUsersConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type AttributeUsersConnection = {
  __typename?: 'AttributeUsersConnection';
  edges: Array<AttributeUsersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AttributeUsersConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type AttributeUsersConnectionWhere = {
  AND?: InputMaybe<Array<AttributeUsersConnectionWhere>>;
  NOT?: InputMaybe<AttributeUsersConnectionWhere>;
  OR?: InputMaybe<Array<AttributeUsersConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type AttributeUsersCreateFieldInput = {
  node: UserCreateInput;
};

export type AttributeUsersDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<AttributeUsersConnectionWhere>;
};

export type AttributeUsersDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<AttributeUsersConnectionWhere>;
};

export type AttributeUsersFieldInput = {
  connect?: InputMaybe<Array<AttributeUsersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AttributeUsersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AttributeUsersCreateFieldInput>>;
};

export type AttributeUsersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AttributeUsersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AttributeUsersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AttributeUsersNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AttributeUsersRelationship = {
  __typename?: 'AttributeUsersRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type AttributeUsersUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type AttributeUsersUpdateFieldInput = {
  connect?: InputMaybe<Array<AttributeUsersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AttributeUsersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AttributeUsersCreateFieldInput>>;
  delete?: InputMaybe<Array<AttributeUsersDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AttributeUsersDisconnectFieldInput>>;
  update?: InputMaybe<AttributeUsersUpdateConnectionInput>;
  where?: InputMaybe<AttributeUsersConnectionWhere>;
};

export type AttributeWhere = {
  AND?: InputMaybe<Array<AttributeWhere>>;
  NOT?: InputMaybe<AttributeWhere>;
  OR?: InputMaybe<Array<AttributeWhere>>;
  achievementsAggregate?: InputMaybe<AttributeAchievementsAggregateInput>;
  /** Return Attributes where all of the related AttributeAchievementsConnections match this filter */
  achievementsConnection_ALL?: InputMaybe<AttributeAchievementsConnectionWhere>;
  /** Return Attributes where none of the related AttributeAchievementsConnections match this filter */
  achievementsConnection_NONE?: InputMaybe<AttributeAchievementsConnectionWhere>;
  /** Return Attributes where one of the related AttributeAchievementsConnections match this filter */
  achievementsConnection_SINGLE?: InputMaybe<AttributeAchievementsConnectionWhere>;
  /** Return Attributes where some of the related AttributeAchievementsConnections match this filter */
  achievementsConnection_SOME?: InputMaybe<AttributeAchievementsConnectionWhere>;
  /** Return Attributes where all of the related Achievements match this filter */
  achievements_ALL?: InputMaybe<AchievementsWhere>;
  /** Return Attributes where none of the related Achievements match this filter */
  achievements_NONE?: InputMaybe<AchievementsWhere>;
  /** Return Attributes where one of the related Achievements match this filter */
  achievements_SINGLE?: InputMaybe<AchievementsWhere>;
  /** Return Attributes where some of the related Achievements match this filter */
  achievements_SOME?: InputMaybe<AchievementsWhere>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  embedding?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  embedding_INCLUDES?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  id_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  text_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  text_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  text_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  usersAggregate?: InputMaybe<AttributeUsersAggregateInput>;
  /** Return Attributes where all of the related AttributeUsersConnections match this filter */
  usersConnection_ALL?: InputMaybe<AttributeUsersConnectionWhere>;
  /** Return Attributes where none of the related AttributeUsersConnections match this filter */
  usersConnection_NONE?: InputMaybe<AttributeUsersConnectionWhere>;
  /** Return Attributes where one of the related AttributeUsersConnections match this filter */
  usersConnection_SINGLE?: InputMaybe<AttributeUsersConnectionWhere>;
  /** Return Attributes where some of the related AttributeUsersConnections match this filter */
  usersConnection_SOME?: InputMaybe<AttributeUsersConnectionWhere>;
  /** Return Attributes where all of the related Users match this filter */
  users_ALL?: InputMaybe<UserWhere>;
  /** Return Attributes where none of the related Users match this filter */
  users_NONE?: InputMaybe<UserWhere>;
  /** Return Attributes where one of the related Users match this filter */
  users_SINGLE?: InputMaybe<UserWhere>;
  /** Return Attributes where some of the related Users match this filter */
  users_SOME?: InputMaybe<UserWhere>;
};

export enum AudienceType {
  Faculty = 'FACULTY',
  School = 'SCHOOL',
  SpecificGroups = 'SPECIFIC_GROUPS',
  Students = 'STUDENTS'
}

export type AudioToggleUserResponse = {
  __typename?: 'AudioToggleUserResponse';
  audioOn?: Maybe<Scalars['Boolean']['output']>;
};

export type AuditEvent = {
  __typename?: 'AuditEvent';
  actor?: Maybe<User>;
  actorAggregate?: Maybe<AuditEventUserActorAggregationSelection>;
  actorConnection: AuditEventActorConnection;
  actorId: Scalars['ID']['output'];
  diffAfter: Array<Scalars['String']['output']>;
  diffBefore: Array<Scalars['String']['output']>;
  diffKeys: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  occurredAt: Scalars['DateTime']['output'];
  relatedUserId?: Maybe<Scalars['ID']['output']>;
  subjectCourse?: Maybe<Course>;
  subjectCourseAggregate?: Maybe<AuditEventCourseSubjectCourseAggregationSelection>;
  subjectCourseConnection: AuditEventSubjectCourseConnection;
  subjectDegree?: Maybe<Degree>;
  subjectDegreeAggregate?: Maybe<AuditEventDegreeSubjectDegreeAggregationSelection>;
  subjectDegreeConnection: AuditEventSubjectDegreeConnection;
  subjectId: Scalars['ID']['output'];
  subjectType: Scalars['String']['output'];
  subjectUser?: Maybe<User>;
  subjectUserAggregate?: Maybe<AuditEventUserSubjectUserAggregationSelection>;
  subjectUserConnection: AuditEventSubjectUserConnection;
  tenant: Tenant;
  tenantAggregate?: Maybe<AuditEventTenantTenantAggregationSelection>;
  tenantConnection: AuditEventTenantConnection;
  tenantId: Scalars['ID']['output'];
  type: AuditEventType;
};


export type AuditEventActorArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type AuditEventActorAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type AuditEventActorConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AuditEventActorConnectionSort>>;
  where?: InputMaybe<AuditEventActorConnectionWhere>;
};


export type AuditEventSubjectCourseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CourseOptions>;
  where?: InputMaybe<CourseWhere>;
};


export type AuditEventSubjectCourseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CourseWhere>;
};


export type AuditEventSubjectCourseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AuditEventSubjectCourseConnectionSort>>;
  where?: InputMaybe<AuditEventSubjectCourseConnectionWhere>;
};


export type AuditEventSubjectDegreeArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DegreeOptions>;
  where?: InputMaybe<DegreeWhere>;
};


export type AuditEventSubjectDegreeAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DegreeWhere>;
};


export type AuditEventSubjectDegreeConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AuditEventSubjectDegreeConnectionSort>>;
  where?: InputMaybe<AuditEventSubjectDegreeConnectionWhere>;
};


export type AuditEventSubjectUserArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type AuditEventSubjectUserAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type AuditEventSubjectUserConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AuditEventSubjectUserConnectionSort>>;
  where?: InputMaybe<AuditEventSubjectUserConnectionWhere>;
};


export type AuditEventTenantArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TenantOptions>;
  where?: InputMaybe<TenantWhere>;
};


export type AuditEventTenantAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TenantWhere>;
};


export type AuditEventTenantConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AuditEventTenantConnectionSort>>;
  where?: InputMaybe<AuditEventTenantConnectionWhere>;
};

export type AuditEventActorAggregateInput = {
  AND?: InputMaybe<Array<AuditEventActorAggregateInput>>;
  NOT?: InputMaybe<AuditEventActorAggregateInput>;
  OR?: InputMaybe<Array<AuditEventActorAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AuditEventActorNodeAggregationWhereInput>;
};

export type AuditEventActorConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type AuditEventActorConnectOrCreateFieldInput = {
  onCreate: AuditEventActorConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type AuditEventActorConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type AuditEventActorConnection = {
  __typename?: 'AuditEventActorConnection';
  edges: Array<AuditEventActorRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AuditEventActorConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type AuditEventActorConnectionWhere = {
  AND?: InputMaybe<Array<AuditEventActorConnectionWhere>>;
  NOT?: InputMaybe<AuditEventActorConnectionWhere>;
  OR?: InputMaybe<Array<AuditEventActorConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type AuditEventActorCreateFieldInput = {
  node: UserCreateInput;
};

export type AuditEventActorDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<AuditEventActorConnectionWhere>;
};

export type AuditEventActorDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<AuditEventActorConnectionWhere>;
};

export type AuditEventActorFieldInput = {
  connect?: InputMaybe<AuditEventActorConnectFieldInput>;
  connectOrCreate?: InputMaybe<AuditEventActorConnectOrCreateFieldInput>;
  create?: InputMaybe<AuditEventActorCreateFieldInput>;
};

export type AuditEventActorNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AuditEventActorNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AuditEventActorNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AuditEventActorNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AuditEventActorRelationship = {
  __typename?: 'AuditEventActorRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type AuditEventActorUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type AuditEventActorUpdateFieldInput = {
  connect?: InputMaybe<AuditEventActorConnectFieldInput>;
  connectOrCreate?: InputMaybe<AuditEventActorConnectOrCreateFieldInput>;
  create?: InputMaybe<AuditEventActorCreateFieldInput>;
  delete?: InputMaybe<AuditEventActorDeleteFieldInput>;
  disconnect?: InputMaybe<AuditEventActorDisconnectFieldInput>;
  update?: InputMaybe<AuditEventActorUpdateConnectionInput>;
  where?: InputMaybe<AuditEventActorConnectionWhere>;
};

export type AuditEventConnectInput = {
  actor?: InputMaybe<AuditEventActorConnectFieldInput>;
  subjectCourse?: InputMaybe<AuditEventSubjectCourseConnectFieldInput>;
  subjectDegree?: InputMaybe<AuditEventSubjectDegreeConnectFieldInput>;
  subjectUser?: InputMaybe<AuditEventSubjectUserConnectFieldInput>;
  tenant?: InputMaybe<AuditEventTenantConnectFieldInput>;
};

export type AuditEventConnectOrCreateWhere = {
  node: AuditEventUniqueWhere;
};

export type AuditEventConnectWhere = {
  node: AuditEventWhere;
};

export type AuditEventCourseSubjectCourseAggregationSelection = {
  __typename?: 'AuditEventCourseSubjectCourseAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AuditEventCourseSubjectCourseNodeAggregateSelection>;
};

export type AuditEventCourseSubjectCourseNodeAggregateSelection = {
  __typename?: 'AuditEventCourseSubjectCourseNodeAggregateSelection';
  account_id: FloatAggregateSelection;
  calendar_ics: StringAggregateSelection;
  cost: FloatAggregateSelection;
  courseId: StringAggregateSelection;
  course_code: StringAggregateSelection;
  course_id: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  default_view: StringAggregateSelection;
  description: StringAggregateSelection;
  dueDateEndDate: DateTimeAggregateSelection;
  dueDateStartDate: DateTimeAggregateSelection;
  endDate: DateTimeAggregateSelection;
  end_at: StringAggregateSelection;
  enrollment_term_id: FloatAggregateSelection;
  grading_standard_id: FloatAggregateSelection;
  id: IdAggregateSelection;
  integration_id: StringAggregateSelection;
  label: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  learningStandards: StringAggregateSelection;
  lengthInWeeks: FloatAggregateSelection;
  license: StringAggregateSelection;
  lti_id: StringAggregateSelection;
  name: StringAggregateSelection;
  original_name: StringAggregateSelection;
  root_account_id: FloatAggregateSelection;
  sis_course_id: StringAggregateSelection;
  sis_import_id: FloatAggregateSelection;
  startDate: DateTimeAggregateSelection;
  start_at: StringAggregateSelection;
  state: StringAggregateSelection;
  storage_quota_mb: FloatAggregateSelection;
  stripePriceId: StringAggregateSelection;
  stripeProductId: StringAggregateSelection;
  targetAudience: StringAggregateSelection;
  thumbnail: StringAggregateSelection;
  time_zone: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  uuid: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export type AuditEventCreateInput = {
  actor?: InputMaybe<AuditEventActorFieldInput>;
  actorId: Scalars['ID']['input'];
  diffAfter: Array<Scalars['String']['input']>;
  diffBefore: Array<Scalars['String']['input']>;
  diffKeys: Array<Scalars['String']['input']>;
  occurredAt: Scalars['DateTime']['input'];
  relatedUserId?: InputMaybe<Scalars['ID']['input']>;
  subjectCourse?: InputMaybe<AuditEventSubjectCourseFieldInput>;
  subjectDegree?: InputMaybe<AuditEventSubjectDegreeFieldInput>;
  subjectId: Scalars['ID']['input'];
  subjectType: Scalars['String']['input'];
  subjectUser?: InputMaybe<AuditEventSubjectUserFieldInput>;
  tenant?: InputMaybe<AuditEventTenantFieldInput>;
  tenantId: Scalars['ID']['input'];
  type: AuditEventType;
};

export type AuditEventDegreeSubjectDegreeAggregationSelection = {
  __typename?: 'AuditEventDegreeSubjectDegreeAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AuditEventDegreeSubjectDegreeNodeAggregateSelection>;
};

export type AuditEventDegreeSubjectDegreeNodeAggregateSelection = {
  __typename?: 'AuditEventDegreeSubjectDegreeNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  id: IdAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  name: StringAggregateSelection;
};

export type AuditEventDeleteInput = {
  actor?: InputMaybe<AuditEventActorDeleteFieldInput>;
  subjectCourse?: InputMaybe<AuditEventSubjectCourseDeleteFieldInput>;
  subjectDegree?: InputMaybe<AuditEventSubjectDegreeDeleteFieldInput>;
  subjectUser?: InputMaybe<AuditEventSubjectUserDeleteFieldInput>;
  tenant?: InputMaybe<AuditEventTenantDeleteFieldInput>;
};

export type AuditEventDisconnectInput = {
  actor?: InputMaybe<AuditEventActorDisconnectFieldInput>;
  subjectCourse?: InputMaybe<AuditEventSubjectCourseDisconnectFieldInput>;
  subjectDegree?: InputMaybe<AuditEventSubjectDegreeDisconnectFieldInput>;
  subjectUser?: InputMaybe<AuditEventSubjectUserDisconnectFieldInput>;
  tenant?: InputMaybe<AuditEventTenantDisconnectFieldInput>;
};

export type AuditEventOnCreateInput = {
  actorId: Scalars['ID']['input'];
  diffAfter: Array<Scalars['String']['input']>;
  diffBefore: Array<Scalars['String']['input']>;
  diffKeys: Array<Scalars['String']['input']>;
  occurredAt: Scalars['DateTime']['input'];
  relatedUserId?: InputMaybe<Scalars['ID']['input']>;
  subjectId: Scalars['ID']['input'];
  subjectType: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
  type: AuditEventType;
};

export type AuditEventOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AuditEventSort objects to sort AuditEvents by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AuditEventSort>>;
};

export type AuditEventServiceResult = {
  __typename?: 'AuditEventServiceResult';
  count: Scalars['Int']['output'];
  data: Array<AuditEvent>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Fields to sort AuditEvents by. The order in which sorts are applied is not guaranteed when specifying many fields in one AuditEventSort object. */
export type AuditEventSort = {
  actorId?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  occurredAt?: InputMaybe<SortDirection>;
  relatedUserId?: InputMaybe<SortDirection>;
  subjectId?: InputMaybe<SortDirection>;
  subjectType?: InputMaybe<SortDirection>;
  tenantId?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export type AuditEventSubjectCourseAggregateInput = {
  AND?: InputMaybe<Array<AuditEventSubjectCourseAggregateInput>>;
  NOT?: InputMaybe<AuditEventSubjectCourseAggregateInput>;
  OR?: InputMaybe<Array<AuditEventSubjectCourseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AuditEventSubjectCourseNodeAggregationWhereInput>;
};

export type AuditEventSubjectCourseConnectFieldInput = {
  connect?: InputMaybe<CourseConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CourseConnectWhere>;
};

export type AuditEventSubjectCourseConnectOrCreateFieldInput = {
  onCreate: AuditEventSubjectCourseConnectOrCreateFieldInputOnCreate;
  where: CourseConnectOrCreateWhere;
};

export type AuditEventSubjectCourseConnectOrCreateFieldInputOnCreate = {
  node: CourseOnCreateInput;
};

export type AuditEventSubjectCourseConnection = {
  __typename?: 'AuditEventSubjectCourseConnection';
  edges: Array<AuditEventSubjectCourseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AuditEventSubjectCourseConnectionSort = {
  node?: InputMaybe<CourseSort>;
};

export type AuditEventSubjectCourseConnectionWhere = {
  AND?: InputMaybe<Array<AuditEventSubjectCourseConnectionWhere>>;
  NOT?: InputMaybe<AuditEventSubjectCourseConnectionWhere>;
  OR?: InputMaybe<Array<AuditEventSubjectCourseConnectionWhere>>;
  node?: InputMaybe<CourseWhere>;
};

export type AuditEventSubjectCourseCreateFieldInput = {
  node: CourseCreateInput;
};

export type AuditEventSubjectCourseDeleteFieldInput = {
  delete?: InputMaybe<CourseDeleteInput>;
  where?: InputMaybe<AuditEventSubjectCourseConnectionWhere>;
};

export type AuditEventSubjectCourseDisconnectFieldInput = {
  disconnect?: InputMaybe<CourseDisconnectInput>;
  where?: InputMaybe<AuditEventSubjectCourseConnectionWhere>;
};

export type AuditEventSubjectCourseFieldInput = {
  connect?: InputMaybe<AuditEventSubjectCourseConnectFieldInput>;
  connectOrCreate?: InputMaybe<AuditEventSubjectCourseConnectOrCreateFieldInput>;
  create?: InputMaybe<AuditEventSubjectCourseCreateFieldInput>;
};

export type AuditEventSubjectCourseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AuditEventSubjectCourseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AuditEventSubjectCourseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AuditEventSubjectCourseNodeAggregationWhereInput>>;
  account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  cost_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDateEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  enrollment_term_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  label_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningStandards_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthInWeeks_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  root_account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_import_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  startDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  storage_quota_mb_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AuditEventSubjectCourseRelationship = {
  __typename?: 'AuditEventSubjectCourseRelationship';
  cursor: Scalars['String']['output'];
  node: Course;
};

export type AuditEventSubjectCourseUpdateConnectionInput = {
  node?: InputMaybe<CourseUpdateInput>;
};

export type AuditEventSubjectCourseUpdateFieldInput = {
  connect?: InputMaybe<AuditEventSubjectCourseConnectFieldInput>;
  connectOrCreate?: InputMaybe<AuditEventSubjectCourseConnectOrCreateFieldInput>;
  create?: InputMaybe<AuditEventSubjectCourseCreateFieldInput>;
  delete?: InputMaybe<AuditEventSubjectCourseDeleteFieldInput>;
  disconnect?: InputMaybe<AuditEventSubjectCourseDisconnectFieldInput>;
  update?: InputMaybe<AuditEventSubjectCourseUpdateConnectionInput>;
  where?: InputMaybe<AuditEventSubjectCourseConnectionWhere>;
};

export type AuditEventSubjectDegreeAggregateInput = {
  AND?: InputMaybe<Array<AuditEventSubjectDegreeAggregateInput>>;
  NOT?: InputMaybe<AuditEventSubjectDegreeAggregateInput>;
  OR?: InputMaybe<Array<AuditEventSubjectDegreeAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AuditEventSubjectDegreeNodeAggregationWhereInput>;
};

export type AuditEventSubjectDegreeConnectFieldInput = {
  connect?: InputMaybe<DegreeConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DegreeConnectWhere>;
};

export type AuditEventSubjectDegreeConnectOrCreateFieldInput = {
  onCreate: AuditEventSubjectDegreeConnectOrCreateFieldInputOnCreate;
  where: DegreeConnectOrCreateWhere;
};

export type AuditEventSubjectDegreeConnectOrCreateFieldInputOnCreate = {
  node: DegreeOnCreateInput;
};

export type AuditEventSubjectDegreeConnection = {
  __typename?: 'AuditEventSubjectDegreeConnection';
  edges: Array<AuditEventSubjectDegreeRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AuditEventSubjectDegreeConnectionSort = {
  node?: InputMaybe<DegreeSort>;
};

export type AuditEventSubjectDegreeConnectionWhere = {
  AND?: InputMaybe<Array<AuditEventSubjectDegreeConnectionWhere>>;
  NOT?: InputMaybe<AuditEventSubjectDegreeConnectionWhere>;
  OR?: InputMaybe<Array<AuditEventSubjectDegreeConnectionWhere>>;
  node?: InputMaybe<DegreeWhere>;
};

export type AuditEventSubjectDegreeCreateFieldInput = {
  node: DegreeCreateInput;
};

export type AuditEventSubjectDegreeDeleteFieldInput = {
  delete?: InputMaybe<DegreeDeleteInput>;
  where?: InputMaybe<AuditEventSubjectDegreeConnectionWhere>;
};

export type AuditEventSubjectDegreeDisconnectFieldInput = {
  disconnect?: InputMaybe<DegreeDisconnectInput>;
  where?: InputMaybe<AuditEventSubjectDegreeConnectionWhere>;
};

export type AuditEventSubjectDegreeFieldInput = {
  connect?: InputMaybe<AuditEventSubjectDegreeConnectFieldInput>;
  connectOrCreate?: InputMaybe<AuditEventSubjectDegreeConnectOrCreateFieldInput>;
  create?: InputMaybe<AuditEventSubjectDegreeCreateFieldInput>;
};

export type AuditEventSubjectDegreeNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AuditEventSubjectDegreeNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AuditEventSubjectDegreeNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AuditEventSubjectDegreeNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AuditEventSubjectDegreeRelationship = {
  __typename?: 'AuditEventSubjectDegreeRelationship';
  cursor: Scalars['String']['output'];
  node: Degree;
};

export type AuditEventSubjectDegreeUpdateConnectionInput = {
  node?: InputMaybe<DegreeUpdateInput>;
};

export type AuditEventSubjectDegreeUpdateFieldInput = {
  connect?: InputMaybe<AuditEventSubjectDegreeConnectFieldInput>;
  connectOrCreate?: InputMaybe<AuditEventSubjectDegreeConnectOrCreateFieldInput>;
  create?: InputMaybe<AuditEventSubjectDegreeCreateFieldInput>;
  delete?: InputMaybe<AuditEventSubjectDegreeDeleteFieldInput>;
  disconnect?: InputMaybe<AuditEventSubjectDegreeDisconnectFieldInput>;
  update?: InputMaybe<AuditEventSubjectDegreeUpdateConnectionInput>;
  where?: InputMaybe<AuditEventSubjectDegreeConnectionWhere>;
};

export type AuditEventSubjectUserAggregateInput = {
  AND?: InputMaybe<Array<AuditEventSubjectUserAggregateInput>>;
  NOT?: InputMaybe<AuditEventSubjectUserAggregateInput>;
  OR?: InputMaybe<Array<AuditEventSubjectUserAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AuditEventSubjectUserNodeAggregationWhereInput>;
};

export type AuditEventSubjectUserConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type AuditEventSubjectUserConnectOrCreateFieldInput = {
  onCreate: AuditEventSubjectUserConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type AuditEventSubjectUserConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type AuditEventSubjectUserConnection = {
  __typename?: 'AuditEventSubjectUserConnection';
  edges: Array<AuditEventSubjectUserRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AuditEventSubjectUserConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type AuditEventSubjectUserConnectionWhere = {
  AND?: InputMaybe<Array<AuditEventSubjectUserConnectionWhere>>;
  NOT?: InputMaybe<AuditEventSubjectUserConnectionWhere>;
  OR?: InputMaybe<Array<AuditEventSubjectUserConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type AuditEventSubjectUserCreateFieldInput = {
  node: UserCreateInput;
};

export type AuditEventSubjectUserDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<AuditEventSubjectUserConnectionWhere>;
};

export type AuditEventSubjectUserDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<AuditEventSubjectUserConnectionWhere>;
};

export type AuditEventSubjectUserFieldInput = {
  connect?: InputMaybe<AuditEventSubjectUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<AuditEventSubjectUserConnectOrCreateFieldInput>;
  create?: InputMaybe<AuditEventSubjectUserCreateFieldInput>;
};

export type AuditEventSubjectUserNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AuditEventSubjectUserNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AuditEventSubjectUserNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AuditEventSubjectUserNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AuditEventSubjectUserRelationship = {
  __typename?: 'AuditEventSubjectUserRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type AuditEventSubjectUserUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type AuditEventSubjectUserUpdateFieldInput = {
  connect?: InputMaybe<AuditEventSubjectUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<AuditEventSubjectUserConnectOrCreateFieldInput>;
  create?: InputMaybe<AuditEventSubjectUserCreateFieldInput>;
  delete?: InputMaybe<AuditEventSubjectUserDeleteFieldInput>;
  disconnect?: InputMaybe<AuditEventSubjectUserDisconnectFieldInput>;
  update?: InputMaybe<AuditEventSubjectUserUpdateConnectionInput>;
  where?: InputMaybe<AuditEventSubjectUserConnectionWhere>;
};

export type AuditEventTenantAggregateInput = {
  AND?: InputMaybe<Array<AuditEventTenantAggregateInput>>;
  NOT?: InputMaybe<AuditEventTenantAggregateInput>;
  OR?: InputMaybe<Array<AuditEventTenantAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AuditEventTenantNodeAggregationWhereInput>;
};

export type AuditEventTenantConnectFieldInput = {
  connect?: InputMaybe<TenantConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TenantConnectWhere>;
};

export type AuditEventTenantConnectOrCreateFieldInput = {
  onCreate: AuditEventTenantConnectOrCreateFieldInputOnCreate;
  where: TenantConnectOrCreateWhere;
};

export type AuditEventTenantConnectOrCreateFieldInputOnCreate = {
  node: TenantOnCreateInput;
};

export type AuditEventTenantConnection = {
  __typename?: 'AuditEventTenantConnection';
  edges: Array<AuditEventTenantRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AuditEventTenantConnectionSort = {
  node?: InputMaybe<TenantSort>;
};

export type AuditEventTenantConnectionWhere = {
  AND?: InputMaybe<Array<AuditEventTenantConnectionWhere>>;
  NOT?: InputMaybe<AuditEventTenantConnectionWhere>;
  OR?: InputMaybe<Array<AuditEventTenantConnectionWhere>>;
  node?: InputMaybe<TenantWhere>;
};

export type AuditEventTenantCreateFieldInput = {
  node: TenantCreateInput;
};

export type AuditEventTenantDeleteFieldInput = {
  delete?: InputMaybe<TenantDeleteInput>;
  where?: InputMaybe<AuditEventTenantConnectionWhere>;
};

export type AuditEventTenantDisconnectFieldInput = {
  disconnect?: InputMaybe<TenantDisconnectInput>;
  where?: InputMaybe<AuditEventTenantConnectionWhere>;
};

export type AuditEventTenantFieldInput = {
  connect?: InputMaybe<AuditEventTenantConnectFieldInput>;
  connectOrCreate?: InputMaybe<AuditEventTenantConnectOrCreateFieldInput>;
  create?: InputMaybe<AuditEventTenantCreateFieldInput>;
};

export type AuditEventTenantNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AuditEventTenantNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AuditEventTenantNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AuditEventTenantNodeAggregationWhereInput>>;
  companionName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  companionName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  key_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  key_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogImage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  proLogo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AuditEventTenantRelationship = {
  __typename?: 'AuditEventTenantRelationship';
  cursor: Scalars['String']['output'];
  node: Tenant;
};

export type AuditEventTenantTenantAggregationSelection = {
  __typename?: 'AuditEventTenantTenantAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AuditEventTenantTenantNodeAggregateSelection>;
};

export type AuditEventTenantTenantNodeAggregateSelection = {
  __typename?: 'AuditEventTenantTenantNodeAggregateSelection';
  companionName: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  emailBackgroundColor: StringAggregateSelection;
  emailFooterColor: StringAggregateSelection;
  emulationStatement: StringAggregateSelection;
  externalSendGridDailyEmailTemplateId: StringAggregateSelection;
  externalSendGridFromEmail: StringAggregateSelection;
  externalSendGridFromName: StringAggregateSelection;
  externalSendGridTwilioServiceSID: StringAggregateSelection;
  favicon16Url: StringAggregateSelection;
  favicon32Url: StringAggregateSelection;
  favicon48Url: StringAggregateSelection;
  favicon180Url: StringAggregateSelection;
  favicon192Url: StringAggregateSelection;
  favicon512Url: StringAggregateSelection;
  faviconIcoUrl: StringAggregateSelection;
  financialInformationUrl: StringAggregateSelection;
  gameMenuBg: StringAggregateSelection;
  gameMenuCardBg: StringAggregateSelection;
  gameMenuProgress: StringAggregateSelection;
  gameMenuTrack: StringAggregateSelection;
  generalPrompt: StringAggregateSelection;
  helpCenterUrl: StringAggregateSelection;
  id: IdAggregateSelection;
  key: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  learningEmulationStatement: StringAggregateSelection;
  logo: StringAggregateSelection;
  ltiLaunchUrl: StringAggregateSelection;
  miniLogo: StringAggregateSelection;
  newsSearchTerms: StringAggregateSelection;
  officialTranscriptsUrl: StringAggregateSelection;
  ogDescription: StringAggregateSelection;
  ogImage: StringAggregateSelection;
  ogImageHeight: StringAggregateSelection;
  ogImageWidth: StringAggregateSelection;
  ogSiteName: StringAggregateSelection;
  ogTitle: StringAggregateSelection;
  ogType: StringAggregateSelection;
  onboardingPrompt: StringAggregateSelection;
  primaryColor: StringAggregateSelection;
  proLogo: StringAggregateSelection;
  reportProblemUrl: StringAggregateSelection;
  scheduleAdvisorCallUrl: StringAggregateSelection;
  schoolResourcesUrl: StringAggregateSelection;
  stripeSecretKey: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  stripeTrialDays: IntAggregateSelection;
  submitHelpTicketLink: StringAggregateSelection;
  tenantDomain: StringAggregateSelection;
  tenantName: StringAggregateSelection;
  termsOfServiceLink: StringAggregateSelection;
  upgradeModalBody: StringAggregateSelection;
};

export type AuditEventTenantUpdateConnectionInput = {
  node?: InputMaybe<TenantUpdateInput>;
};

export type AuditEventTenantUpdateFieldInput = {
  connect?: InputMaybe<AuditEventTenantConnectFieldInput>;
  connectOrCreate?: InputMaybe<AuditEventTenantConnectOrCreateFieldInput>;
  create?: InputMaybe<AuditEventTenantCreateFieldInput>;
  delete?: InputMaybe<AuditEventTenantDeleteFieldInput>;
  disconnect?: InputMaybe<AuditEventTenantDisconnectFieldInput>;
  update?: InputMaybe<AuditEventTenantUpdateConnectionInput>;
  where?: InputMaybe<AuditEventTenantConnectionWhere>;
};

export enum AuditEventType {
  CourseAssignedToFaculty = 'course_assigned_to_faculty',
  CourseCreated = 'course_created',
  CourseDeleted = 'course_deleted',
  CourseEnrollmentAdded = 'course_enrollment_added',
  CourseEnrollmentRemoved = 'course_enrollment_removed',
  CourseInvitationAdded = 'course_invitation_added',
  CoursePublished = 'course_published',
  CourseRemovedFromFaculty = 'course_removed_from_faculty',
  CourseUnpublished = 'course_unpublished',
  CourseUpdated = 'course_updated',
  DegreeCreated = 'degree_created',
  DegreeDeleted = 'degree_deleted',
  DegreeEnrollmentAdded = 'degree_enrollment_added',
  DegreeEnrollmentRemoved = 'degree_enrollment_removed',
  DegreeInvitationAdded = 'degree_invitation_added',
  DegreeUpdated = 'degree_updated',
  UserCourseAssignmentChanged = 'user_course_assignment_changed',
  UserCreated = 'user_created',
  UserEnrollmentAdded = 'user_enrollment_added',
  UserInvitationAdded = 'user_invitation_added',
  UserInvitationRemoved = 'user_invitation_removed',
  UserRolesChanged = 'user_roles_changed'
}

export type AuditEventUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type AuditEventUpdateInput = {
  actor?: InputMaybe<AuditEventActorUpdateFieldInput>;
  actorId?: InputMaybe<Scalars['ID']['input']>;
  diffAfter?: InputMaybe<Array<Scalars['String']['input']>>;
  diffAfter_POP?: InputMaybe<Scalars['Int']['input']>;
  diffAfter_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  diffBefore?: InputMaybe<Array<Scalars['String']['input']>>;
  diffBefore_POP?: InputMaybe<Scalars['Int']['input']>;
  diffBefore_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  diffKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  diffKeys_POP?: InputMaybe<Scalars['Int']['input']>;
  diffKeys_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  occurredAt?: InputMaybe<Scalars['DateTime']['input']>;
  relatedUserId?: InputMaybe<Scalars['ID']['input']>;
  subjectCourse?: InputMaybe<AuditEventSubjectCourseUpdateFieldInput>;
  subjectDegree?: InputMaybe<AuditEventSubjectDegreeUpdateFieldInput>;
  subjectId?: InputMaybe<Scalars['ID']['input']>;
  subjectType?: InputMaybe<Scalars['String']['input']>;
  subjectUser?: InputMaybe<AuditEventSubjectUserUpdateFieldInput>;
  tenant?: InputMaybe<AuditEventTenantUpdateFieldInput>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<AuditEventType>;
};

export type AuditEventUserActorAggregationSelection = {
  __typename?: 'AuditEventUserActorAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AuditEventUserActorNodeAggregateSelection>;
};

export type AuditEventUserActorNodeAggregateSelection = {
  __typename?: 'AuditEventUserActorNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type AuditEventUserSubjectUserAggregationSelection = {
  __typename?: 'AuditEventUserSubjectUserAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AuditEventUserSubjectUserNodeAggregateSelection>;
};

export type AuditEventUserSubjectUserNodeAggregateSelection = {
  __typename?: 'AuditEventUserSubjectUserNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type AuditEventWhere = {
  AND?: InputMaybe<Array<AuditEventWhere>>;
  NOT?: InputMaybe<AuditEventWhere>;
  OR?: InputMaybe<Array<AuditEventWhere>>;
  actor?: InputMaybe<UserWhere>;
  actorAggregate?: InputMaybe<AuditEventActorAggregateInput>;
  actorConnection?: InputMaybe<AuditEventActorConnectionWhere>;
  actorConnection_NOT?: InputMaybe<AuditEventActorConnectionWhere>;
  actorId?: InputMaybe<Scalars['ID']['input']>;
  actorId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  actorId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  actorId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  actorId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  actor_NOT?: InputMaybe<UserWhere>;
  diffAfter?: InputMaybe<Array<Scalars['String']['input']>>;
  diffAfter_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  diffBefore?: InputMaybe<Array<Scalars['String']['input']>>;
  diffBefore_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  diffKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  diffKeys_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  occurredAt?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  occurredAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  relatedUserId?: InputMaybe<Scalars['ID']['input']>;
  relatedUserId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  relatedUserId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  relatedUserId_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  relatedUserId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  subjectCourse?: InputMaybe<CourseWhere>;
  subjectCourseAggregate?: InputMaybe<AuditEventSubjectCourseAggregateInput>;
  subjectCourseConnection?: InputMaybe<AuditEventSubjectCourseConnectionWhere>;
  subjectCourseConnection_NOT?: InputMaybe<AuditEventSubjectCourseConnectionWhere>;
  subjectCourse_NOT?: InputMaybe<CourseWhere>;
  subjectDegree?: InputMaybe<DegreeWhere>;
  subjectDegreeAggregate?: InputMaybe<AuditEventSubjectDegreeAggregateInput>;
  subjectDegreeConnection?: InputMaybe<AuditEventSubjectDegreeConnectionWhere>;
  subjectDegreeConnection_NOT?: InputMaybe<AuditEventSubjectDegreeConnectionWhere>;
  subjectDegree_NOT?: InputMaybe<DegreeWhere>;
  subjectId?: InputMaybe<Scalars['ID']['input']>;
  subjectId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  subjectId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  subjectId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  subjectId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  subjectType?: InputMaybe<Scalars['String']['input']>;
  subjectType_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  subjectType_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  subjectType_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  subjectType_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  subjectUser?: InputMaybe<UserWhere>;
  subjectUserAggregate?: InputMaybe<AuditEventSubjectUserAggregateInput>;
  subjectUserConnection?: InputMaybe<AuditEventSubjectUserConnectionWhere>;
  subjectUserConnection_NOT?: InputMaybe<AuditEventSubjectUserConnectionWhere>;
  subjectUser_NOT?: InputMaybe<UserWhere>;
  tenant?: InputMaybe<TenantWhere>;
  tenantAggregate?: InputMaybe<AuditEventTenantAggregateInput>;
  tenantConnection?: InputMaybe<AuditEventTenantConnectionWhere>;
  tenantConnection_NOT?: InputMaybe<AuditEventTenantConnectionWhere>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  tenantId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  tenantId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  tenantId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  tenant_NOT?: InputMaybe<TenantWhere>;
  type?: InputMaybe<AuditEventType>;
  type_IN?: InputMaybe<Array<AuditEventType>>;
};

export type AuthPayloadResponse = {
  __typename?: 'AuthPayloadResponse';
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  user?: Maybe<AuthPayloadUser>;
};

export type AuthPayloadUser = {
  __typename?: 'AuthPayloadUser';
  birthday?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  dailyEmailOptIn?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fullPhoneNumber?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  googleAuthTokens?: Maybe<GoogleAuthTokens>;
  id?: Maybe<Scalars['String']['output']>;
  isEmailVerified?: Maybe<Scalars['Boolean']['output']>;
  isOnboarded?: Maybe<Scalars['Boolean']['output']>;
  isPro?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  otpPreference?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<AuthPayloadUserPreferences>;
};

export type AuthPayloadUserPreferences = {
  __typename?: 'AuthPayloadUserPreferences';
  language?: Maybe<Scalars['String']['output']>;
};

export type AxioResource = {
  __typename?: 'AxioResource';
  activityState?: Maybe<ActivityState>;
  created?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documents: Array<Document>;
  documentsAggregate?: Maybe<AxioResourceDocumentDocumentsAggregationSelection>;
  documentsConnection: AxioResourceDocumentsConnection;
  files: Array<File>;
  filesAggregate?: Maybe<AxioResourceFileFilesAggregationSelection>;
  filesConnection: AxioResourceFilesConnection;
  id: Scalars['ID']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  module: Module;
  moduleAggregate?: Maybe<AxioResourceModuleModuleAggregationSelection>;
  moduleConnection: AxioResourceModuleConnection;
  moduleId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  scheduledDate?: Maybe<Scalars['DateTime']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
};


export type AxioResourceDocumentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DocumentOptions>;
  where?: InputMaybe<DocumentWhere>;
};


export type AxioResourceDocumentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DocumentWhere>;
};


export type AxioResourceDocumentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AxioResourceDocumentsConnectionSort>>;
  where?: InputMaybe<AxioResourceDocumentsConnectionWhere>;
};


export type AxioResourceFilesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FileOptions>;
  where?: InputMaybe<FileWhere>;
};


export type AxioResourceFilesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FileWhere>;
};


export type AxioResourceFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AxioResourceFilesConnectionSort>>;
  where?: InputMaybe<AxioResourceFilesConnectionWhere>;
};


export type AxioResourceModuleArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ModuleOptions>;
  where?: InputMaybe<ModuleWhere>;
};


export type AxioResourceModuleAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ModuleWhere>;
};


export type AxioResourceModuleConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AxioResourceModuleConnectionSort>>;
  where?: InputMaybe<AxioResourceModuleConnectionWhere>;
};

export type AxioResourceConnectInput = {
  documents?: InputMaybe<Array<AxioResourceDocumentsConnectFieldInput>>;
  files?: InputMaybe<Array<AxioResourceFilesConnectFieldInput>>;
  module?: InputMaybe<AxioResourceModuleConnectFieldInput>;
};

export type AxioResourceConnectOrCreateWhere = {
  node: AxioResourceUniqueWhere;
};

export type AxioResourceConnectWhere = {
  node: AxioResourceWhere;
};

export type AxioResourceCreateInput = {
  activityState?: InputMaybe<ActivityState>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<AxioResourceDocumentsFieldInput>;
  files?: InputMaybe<AxioResourceFilesFieldInput>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  module?: InputMaybe<AxioResourceModuleFieldInput>;
  moduleId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AxioResourceDeleteInput = {
  documents?: InputMaybe<Array<AxioResourceDocumentsDeleteFieldInput>>;
  files?: InputMaybe<Array<AxioResourceFilesDeleteFieldInput>>;
  module?: InputMaybe<AxioResourceModuleDeleteFieldInput>;
};

export type AxioResourceDisconnectInput = {
  documents?: InputMaybe<Array<AxioResourceDocumentsDisconnectFieldInput>>;
  files?: InputMaybe<Array<AxioResourceFilesDisconnectFieldInput>>;
  module?: InputMaybe<AxioResourceModuleDisconnectFieldInput>;
};

export type AxioResourceDocumentDocumentsAggregationSelection = {
  __typename?: 'AxioResourceDocumentDocumentsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AxioResourceDocumentDocumentsNodeAggregateSelection>;
};

export type AxioResourceDocumentDocumentsNodeAggregateSelection = {
  __typename?: 'AxioResourceDocumentDocumentsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  summary: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type AxioResourceDocumentsAggregateInput = {
  AND?: InputMaybe<Array<AxioResourceDocumentsAggregateInput>>;
  NOT?: InputMaybe<AxioResourceDocumentsAggregateInput>;
  OR?: InputMaybe<Array<AxioResourceDocumentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AxioResourceDocumentsNodeAggregationWhereInput>;
};

export type AxioResourceDocumentsConnectFieldInput = {
  connect?: InputMaybe<Array<DocumentConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DocumentConnectWhere>;
};

export type AxioResourceDocumentsConnection = {
  __typename?: 'AxioResourceDocumentsConnection';
  edges: Array<AxioResourceDocumentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AxioResourceDocumentsConnectionSort = {
  node?: InputMaybe<DocumentSort>;
};

export type AxioResourceDocumentsConnectionWhere = {
  AND?: InputMaybe<Array<AxioResourceDocumentsConnectionWhere>>;
  NOT?: InputMaybe<AxioResourceDocumentsConnectionWhere>;
  OR?: InputMaybe<Array<AxioResourceDocumentsConnectionWhere>>;
  node?: InputMaybe<DocumentWhere>;
};

export type AxioResourceDocumentsCreateFieldInput = {
  node: DocumentCreateInput;
};

export type AxioResourceDocumentsDeleteFieldInput = {
  delete?: InputMaybe<DocumentDeleteInput>;
  where?: InputMaybe<AxioResourceDocumentsConnectionWhere>;
};

export type AxioResourceDocumentsDisconnectFieldInput = {
  disconnect?: InputMaybe<DocumentDisconnectInput>;
  where?: InputMaybe<AxioResourceDocumentsConnectionWhere>;
};

export type AxioResourceDocumentsFieldInput = {
  connect?: InputMaybe<Array<AxioResourceDocumentsConnectFieldInput>>;
  create?: InputMaybe<Array<AxioResourceDocumentsCreateFieldInput>>;
};

export type AxioResourceDocumentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AxioResourceDocumentsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AxioResourceDocumentsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AxioResourceDocumentsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  summary_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  summary_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AxioResourceDocumentsRelationship = {
  __typename?: 'AxioResourceDocumentsRelationship';
  cursor: Scalars['String']['output'];
  node: Document;
};

export type AxioResourceDocumentsUpdateConnectionInput = {
  node?: InputMaybe<DocumentUpdateInput>;
};

export type AxioResourceDocumentsUpdateFieldInput = {
  connect?: InputMaybe<Array<AxioResourceDocumentsConnectFieldInput>>;
  create?: InputMaybe<Array<AxioResourceDocumentsCreateFieldInput>>;
  delete?: InputMaybe<Array<AxioResourceDocumentsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AxioResourceDocumentsDisconnectFieldInput>>;
  update?: InputMaybe<AxioResourceDocumentsUpdateConnectionInput>;
  where?: InputMaybe<AxioResourceDocumentsConnectionWhere>;
};

export type AxioResourceFileFilesAggregationSelection = {
  __typename?: 'AxioResourceFileFilesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AxioResourceFileFilesNodeAggregateSelection>;
};

export type AxioResourceFileFilesNodeAggregateSelection = {
  __typename?: 'AxioResourceFileFilesNodeAggregateSelection';
  bucketName: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  fileName: StringAggregateSelection;
  filePath: StringAggregateSelection;
  fileURL: StringAggregateSelection;
  id: IdAggregateSelection;
};

export type AxioResourceFilesAggregateInput = {
  AND?: InputMaybe<Array<AxioResourceFilesAggregateInput>>;
  NOT?: InputMaybe<AxioResourceFilesAggregateInput>;
  OR?: InputMaybe<Array<AxioResourceFilesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AxioResourceFilesNodeAggregationWhereInput>;
};

export type AxioResourceFilesConnectFieldInput = {
  connect?: InputMaybe<Array<FileConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FileConnectWhere>;
};

export type AxioResourceFilesConnectOrCreateFieldInput = {
  onCreate: AxioResourceFilesConnectOrCreateFieldInputOnCreate;
  where: FileConnectOrCreateWhere;
};

export type AxioResourceFilesConnectOrCreateFieldInputOnCreate = {
  node: FileOnCreateInput;
};

export type AxioResourceFilesConnection = {
  __typename?: 'AxioResourceFilesConnection';
  edges: Array<AxioResourceFilesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AxioResourceFilesConnectionSort = {
  node?: InputMaybe<FileSort>;
};

export type AxioResourceFilesConnectionWhere = {
  AND?: InputMaybe<Array<AxioResourceFilesConnectionWhere>>;
  NOT?: InputMaybe<AxioResourceFilesConnectionWhere>;
  OR?: InputMaybe<Array<AxioResourceFilesConnectionWhere>>;
  node?: InputMaybe<FileWhere>;
};

export type AxioResourceFilesCreateFieldInput = {
  node: FileCreateInput;
};

export type AxioResourceFilesDeleteFieldInput = {
  delete?: InputMaybe<FileDeleteInput>;
  where?: InputMaybe<AxioResourceFilesConnectionWhere>;
};

export type AxioResourceFilesDisconnectFieldInput = {
  disconnect?: InputMaybe<FileDisconnectInput>;
  where?: InputMaybe<AxioResourceFilesConnectionWhere>;
};

export type AxioResourceFilesFieldInput = {
  connect?: InputMaybe<Array<AxioResourceFilesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AxioResourceFilesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AxioResourceFilesCreateFieldInput>>;
};

export type AxioResourceFilesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AxioResourceFilesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AxioResourceFilesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AxioResourceFilesNodeAggregationWhereInput>>;
  bucketName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  bucketName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  fileName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileURL_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AxioResourceFilesRelationship = {
  __typename?: 'AxioResourceFilesRelationship';
  cursor: Scalars['String']['output'];
  node: File;
};

export type AxioResourceFilesUpdateConnectionInput = {
  node?: InputMaybe<FileUpdateInput>;
};

export type AxioResourceFilesUpdateFieldInput = {
  connect?: InputMaybe<Array<AxioResourceFilesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<AxioResourceFilesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<AxioResourceFilesCreateFieldInput>>;
  delete?: InputMaybe<Array<AxioResourceFilesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<AxioResourceFilesDisconnectFieldInput>>;
  update?: InputMaybe<AxioResourceFilesUpdateConnectionInput>;
  where?: InputMaybe<AxioResourceFilesConnectionWhere>;
};

export type AxioResourceModuleAggregateInput = {
  AND?: InputMaybe<Array<AxioResourceModuleAggregateInput>>;
  NOT?: InputMaybe<AxioResourceModuleAggregateInput>;
  OR?: InputMaybe<Array<AxioResourceModuleAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AxioResourceModuleNodeAggregationWhereInput>;
};

export type AxioResourceModuleConnectFieldInput = {
  connect?: InputMaybe<ModuleConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ModuleConnectWhere>;
};

export type AxioResourceModuleConnectOrCreateFieldInput = {
  onCreate: AxioResourceModuleConnectOrCreateFieldInputOnCreate;
  where: ModuleConnectOrCreateWhere;
};

export type AxioResourceModuleConnectOrCreateFieldInputOnCreate = {
  node: ModuleOnCreateInput;
};

export type AxioResourceModuleConnection = {
  __typename?: 'AxioResourceModuleConnection';
  edges: Array<AxioResourceModuleRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AxioResourceModuleConnectionSort = {
  node?: InputMaybe<ModuleSort>;
};

export type AxioResourceModuleConnectionWhere = {
  AND?: InputMaybe<Array<AxioResourceModuleConnectionWhere>>;
  NOT?: InputMaybe<AxioResourceModuleConnectionWhere>;
  OR?: InputMaybe<Array<AxioResourceModuleConnectionWhere>>;
  node?: InputMaybe<ModuleWhere>;
};

export type AxioResourceModuleCreateFieldInput = {
  node: ModuleCreateInput;
};

export type AxioResourceModuleDeleteFieldInput = {
  delete?: InputMaybe<ModuleDeleteInput>;
  where?: InputMaybe<AxioResourceModuleConnectionWhere>;
};

export type AxioResourceModuleDisconnectFieldInput = {
  disconnect?: InputMaybe<ModuleDisconnectInput>;
  where?: InputMaybe<AxioResourceModuleConnectionWhere>;
};

export type AxioResourceModuleFieldInput = {
  connect?: InputMaybe<AxioResourceModuleConnectFieldInput>;
  connectOrCreate?: InputMaybe<AxioResourceModuleConnectOrCreateFieldInput>;
  create?: InputMaybe<AxioResourceModuleCreateFieldInput>;
};

export type AxioResourceModuleModuleAggregationSelection = {
  __typename?: 'AxioResourceModuleModuleAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<AxioResourceModuleModuleNodeAggregateSelection>;
};

export type AxioResourceModuleModuleNodeAggregateSelection = {
  __typename?: 'AxioResourceModuleModuleNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  module_name: StringAggregateSelection;
  thumbnail: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type AxioResourceModuleNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AxioResourceModuleNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AxioResourceModuleNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AxioResourceModuleNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  module_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  module_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AxioResourceModuleRelationship = {
  __typename?: 'AxioResourceModuleRelationship';
  cursor: Scalars['String']['output'];
  node: Module;
};

export type AxioResourceModuleUpdateConnectionInput = {
  node?: InputMaybe<ModuleUpdateInput>;
};

export type AxioResourceModuleUpdateFieldInput = {
  connect?: InputMaybe<AxioResourceModuleConnectFieldInput>;
  connectOrCreate?: InputMaybe<AxioResourceModuleConnectOrCreateFieldInput>;
  create?: InputMaybe<AxioResourceModuleCreateFieldInput>;
  delete?: InputMaybe<AxioResourceModuleDeleteFieldInput>;
  disconnect?: InputMaybe<AxioResourceModuleDisconnectFieldInput>;
  update?: InputMaybe<AxioResourceModuleUpdateConnectionInput>;
  where?: InputMaybe<AxioResourceModuleConnectionWhere>;
};

export type AxioResourceOnCreateInput = {
  activityState?: InputMaybe<ActivityState>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  moduleId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AxioResourceOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AxioResourceSort objects to sort AxioResources by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AxioResourceSort>>;
};

export type AxioResourceResponse = {
  __typename?: 'AxioResourceResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<AxioResource>>>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Fields to sort AxioResources by. The order in which sorts are applied is not guaranteed when specifying many fields in one AxioResourceSort object. */
export type AxioResourceSort = {
  activityState?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastModified?: InputMaybe<SortDirection>;
  moduleId?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
  scheduledDate?: InputMaybe<SortDirection>;
  videoUrl?: InputMaybe<SortDirection>;
};

export type AxioResourceUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type AxioResourceUpdateInput = {
  activityState?: InputMaybe<ActivityState>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Array<AxioResourceDocumentsUpdateFieldInput>>;
  files?: InputMaybe<Array<AxioResourceFilesUpdateFieldInput>>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  module?: InputMaybe<AxioResourceModuleUpdateFieldInput>;
  moduleId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  order_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AxioResourceWhere = {
  AND?: InputMaybe<Array<AxioResourceWhere>>;
  NOT?: InputMaybe<AxioResourceWhere>;
  OR?: InputMaybe<Array<AxioResourceWhere>>;
  activityState?: InputMaybe<ActivityState>;
  activityState_IN?: InputMaybe<Array<InputMaybe<ActivityState>>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentsAggregate?: InputMaybe<AxioResourceDocumentsAggregateInput>;
  /** Return AxioResources where all of the related AxioResourceDocumentsConnections match this filter */
  documentsConnection_ALL?: InputMaybe<AxioResourceDocumentsConnectionWhere>;
  /** Return AxioResources where none of the related AxioResourceDocumentsConnections match this filter */
  documentsConnection_NONE?: InputMaybe<AxioResourceDocumentsConnectionWhere>;
  /** Return AxioResources where one of the related AxioResourceDocumentsConnections match this filter */
  documentsConnection_SINGLE?: InputMaybe<AxioResourceDocumentsConnectionWhere>;
  /** Return AxioResources where some of the related AxioResourceDocumentsConnections match this filter */
  documentsConnection_SOME?: InputMaybe<AxioResourceDocumentsConnectionWhere>;
  /** Return AxioResources where all of the related Documents match this filter */
  documents_ALL?: InputMaybe<DocumentWhere>;
  /** Return AxioResources where none of the related Documents match this filter */
  documents_NONE?: InputMaybe<DocumentWhere>;
  /** Return AxioResources where one of the related Documents match this filter */
  documents_SINGLE?: InputMaybe<DocumentWhere>;
  /** Return AxioResources where some of the related Documents match this filter */
  documents_SOME?: InputMaybe<DocumentWhere>;
  filesAggregate?: InputMaybe<AxioResourceFilesAggregateInput>;
  /** Return AxioResources where all of the related AxioResourceFilesConnections match this filter */
  filesConnection_ALL?: InputMaybe<AxioResourceFilesConnectionWhere>;
  /** Return AxioResources where none of the related AxioResourceFilesConnections match this filter */
  filesConnection_NONE?: InputMaybe<AxioResourceFilesConnectionWhere>;
  /** Return AxioResources where one of the related AxioResourceFilesConnections match this filter */
  filesConnection_SINGLE?: InputMaybe<AxioResourceFilesConnectionWhere>;
  /** Return AxioResources where some of the related AxioResourceFilesConnections match this filter */
  filesConnection_SOME?: InputMaybe<AxioResourceFilesConnectionWhere>;
  /** Return AxioResources where all of the related Files match this filter */
  files_ALL?: InputMaybe<FileWhere>;
  /** Return AxioResources where none of the related Files match this filter */
  files_NONE?: InputMaybe<FileWhere>;
  /** Return AxioResources where one of the related Files match this filter */
  files_SINGLE?: InputMaybe<FileWhere>;
  /** Return AxioResources where some of the related Files match this filter */
  files_SOME?: InputMaybe<FileWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastModified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  module?: InputMaybe<ModuleWhere>;
  moduleAggregate?: InputMaybe<AxioResourceModuleAggregateInput>;
  moduleConnection?: InputMaybe<AxioResourceModuleConnectionWhere>;
  moduleConnection_NOT?: InputMaybe<AxioResourceModuleConnectionWhere>;
  moduleId?: InputMaybe<Scalars['ID']['input']>;
  moduleId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  moduleId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  moduleId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  moduleId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  module_NOT?: InputMaybe<ModuleWhere>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  scheduledDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  videoUrl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  videoUrl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  videoUrl_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoUrl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type BaseProgressEvent = {
  activityId?: Maybe<Scalars['ID']['output']>;
  activityName?: Maybe<Scalars['String']['output']>;
  activityType?: Maybe<ActivityType>;
  courseId?: Maybe<Scalars['ID']['output']>;
  moduleId?: Maybe<Scalars['ID']['output']>;
  objectiveId?: Maybe<Scalars['ID']['output']>;
  tenantId: Scalars['ID']['output'];
  timestamp: Scalars['String']['output'];
  type: ProgressEventType;
  userId: Scalars['ID']['output'];
};

export type BaseProgressEventAggregateSelection = {
  __typename?: 'BaseProgressEventAggregateSelection';
  activityId: IdAggregateSelection;
  activityName: StringAggregateSelection;
  count: Scalars['Int']['output'];
  courseId: IdAggregateSelection;
  moduleId: IdAggregateSelection;
  objectiveId: IdAggregateSelection;
  tenantId: IdAggregateSelection;
  timestamp: StringAggregateSelection;
  userId: IdAggregateSelection;
};

export type BaseProgressEventEdge = {
  __typename?: 'BaseProgressEventEdge';
  cursor: Scalars['String']['output'];
  node: BaseProgressEvent;
};

export type BaseProgressEventOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more BaseProgressEventSort objects to sort BaseProgressEvents by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<InputMaybe<BaseProgressEventSort>>>;
};

/** Fields to sort BaseProgressEvents by. The order in which sorts are applied is not guaranteed when specifying many fields in one BaseProgressEventSort object. */
export type BaseProgressEventSort = {
  activityId?: InputMaybe<SortDirection>;
  activityName?: InputMaybe<SortDirection>;
  activityType?: InputMaybe<SortDirection>;
  courseId?: InputMaybe<SortDirection>;
  moduleId?: InputMaybe<SortDirection>;
  objectiveId?: InputMaybe<SortDirection>;
  tenantId?: InputMaybe<SortDirection>;
  timestamp?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
  userId?: InputMaybe<SortDirection>;
};

export type BaseProgressEventWhere = {
  AND?: InputMaybe<Array<BaseProgressEventWhere>>;
  NOT?: InputMaybe<BaseProgressEventWhere>;
  OR?: InputMaybe<Array<BaseProgressEventWhere>>;
  activityId?: InputMaybe<Scalars['ID']['input']>;
  activityId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  activityId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  activityId_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  activityId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  activityName?: InputMaybe<Scalars['String']['input']>;
  activityName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  activityName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  activityName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  activityName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  activityType?: InputMaybe<ActivityType>;
  activityType_IN?: InputMaybe<Array<InputMaybe<ActivityType>>>;
  courseId?: InputMaybe<Scalars['ID']['input']>;
  courseId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  courseId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  courseId_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  courseId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  moduleId?: InputMaybe<Scalars['ID']['input']>;
  moduleId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  moduleId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  moduleId_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  moduleId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  objectiveId?: InputMaybe<Scalars['ID']['input']>;
  objectiveId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  objectiveId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  objectiveId_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  objectiveId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  tenantId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  tenantId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  tenantId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  timestamp?: InputMaybe<Scalars['String']['input']>;
  timestamp_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  timestamp_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  timestamp_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  timestamp_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProgressEventType>;
  type_IN?: InputMaybe<Array<ProgressEventType>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  userId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  userId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type BaseProgressEventsConnection = {
  __typename?: 'BaseProgressEventsConnection';
  edges: Array<BaseProgressEventEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BigIntAggregateSelection = {
  __typename?: 'BigIntAggregateSelection';
  average?: Maybe<Scalars['BigInt']['output']>;
  max?: Maybe<Scalars['BigInt']['output']>;
  min?: Maybe<Scalars['BigInt']['output']>;
  sum?: Maybe<Scalars['BigInt']['output']>;
};

export enum BlockType {
  Artifact = 'artifact',
  File = 'file',
  Text = 'text'
}

export type BulkAssessmentCreateInput = {
  activityState?: InputMaybe<ActivityState>;
  numberOfQuestions?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  timeLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type BulkAssessmentCreateResponse = {
  __typename?: 'BulkAssessmentCreateResponse';
  jobId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CanvasEnv = {
  __typename?: 'CanvasEnv';
  api_client_id?: Maybe<Scalars['String']['output']>;
  api_client_secret?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  deployment_id?: Maybe<Scalars['String']['output']>;
  domain: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mobile_api_client_id?: Maybe<Scalars['String']['output']>;
  mobile_api_client_secret?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CanvasEnvConnectOrCreateWhere = {
  node: CanvasEnvUniqueWhere;
};

export type CanvasEnvConnectWhere = {
  node: CanvasEnvWhere;
};

export type CanvasEnvCreateInput = {
  api_client_id?: InputMaybe<Scalars['String']['input']>;
  api_client_secret?: InputMaybe<Scalars['String']['input']>;
  deployment_id?: InputMaybe<Scalars['String']['input']>;
  domain: Scalars['String']['input'];
  mobile_api_client_id?: InputMaybe<Scalars['String']['input']>;
  mobile_api_client_secret?: InputMaybe<Scalars['String']['input']>;
  updatedAt: Scalars['DateTime']['input'];
};

export type CanvasEnvOnCreateInput = {
  api_client_id?: InputMaybe<Scalars['String']['input']>;
  api_client_secret?: InputMaybe<Scalars['String']['input']>;
  deployment_id?: InputMaybe<Scalars['String']['input']>;
  domain: Scalars['String']['input'];
  mobile_api_client_id?: InputMaybe<Scalars['String']['input']>;
  mobile_api_client_secret?: InputMaybe<Scalars['String']['input']>;
  updatedAt: Scalars['DateTime']['input'];
};

export type CanvasEnvOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CanvasEnvSort objects to sort CanvasEnvs by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CanvasEnvSort>>;
};

/** Fields to sort CanvasEnvs by. The order in which sorts are applied is not guaranteed when specifying many fields in one CanvasEnvSort object. */
export type CanvasEnvSort = {
  api_client_id?: InputMaybe<SortDirection>;
  api_client_secret?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  deployment_id?: InputMaybe<SortDirection>;
  domain?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  mobile_api_client_id?: InputMaybe<SortDirection>;
  mobile_api_client_secret?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type CanvasEnvUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CanvasEnvUpdateInput = {
  api_client_id?: InputMaybe<Scalars['String']['input']>;
  api_client_secret?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  deployment_id?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  mobile_api_client_id?: InputMaybe<Scalars['String']['input']>;
  mobile_api_client_secret?: InputMaybe<Scalars['String']['input']>;
};

export type CanvasEnvWhere = {
  AND?: InputMaybe<Array<CanvasEnvWhere>>;
  NOT?: InputMaybe<CanvasEnvWhere>;
  OR?: InputMaybe<Array<CanvasEnvWhere>>;
  api_client_id?: InputMaybe<Scalars['String']['input']>;
  api_client_id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  api_client_id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  api_client_id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  api_client_id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  api_client_secret?: InputMaybe<Scalars['String']['input']>;
  api_client_secret_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  api_client_secret_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  api_client_secret_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  api_client_secret_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deployment_id?: InputMaybe<Scalars['String']['input']>;
  deployment_id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  deployment_id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  deployment_id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deployment_id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  domain_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  domain_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  domain_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  domain_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  mobile_api_client_id?: InputMaybe<Scalars['String']['input']>;
  mobile_api_client_id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  mobile_api_client_id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  mobile_api_client_id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mobile_api_client_id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  mobile_api_client_secret?: InputMaybe<Scalars['String']['input']>;
  mobile_api_client_secret_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  mobile_api_client_secret_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  mobile_api_client_secret_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mobile_api_client_secret_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Career = {
  __typename?: 'Career';
  brief_description?: Maybe<Scalars['String']['output']>;
  cons?: Maybe<Scalars['String']['output']>;
  core_skills?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  growth?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last_modified?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  path?: Maybe<Scalars['JSON']['output']>;
  pros?: Maybe<Scalars['String']['output']>;
  salary?: Maybe<Scalars['String']['output']>;
  skills?: Maybe<Scalars['String']['output']>;
  trends?: Maybe<Scalars['JSON']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CareerHeader = {
  __typename?: 'CareerHeader';
  careerGoal?: Maybe<Scalars['String']['output']>;
  careerId?: Maybe<Scalars['String']['output']>;
  careerName?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
};

export type CareerTopicResponse = {
  __typename?: 'CareerTopicResponse';
  careerName: Scalars['String']['output'];
  relationshipIndex: Scalars['Int']['output'];
  topicName: Scalars['String']['output'];
};

export type Challenge = {
  __typename?: 'Challenge';
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type Chapter = {
  __typename?: 'Chapter';
  isRelevant?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  topicsHasChapter: Array<Topic>;
  topicsHasChapterAggregate?: Maybe<ChapterTopicTopicsHasChapterAggregationSelection>;
  topicsHasChapterConnection: ChapterTopicsHasChapterConnection;
  usersHasKnowledge: Array<User>;
  usersHasKnowledgeAggregate?: Maybe<ChapterUserUsersHasKnowledgeAggregationSelection>;
  usersHasKnowledgeConnection: ChapterUsersHasKnowledgeConnection;
};


export type ChapterTopicsHasChapterArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TopicOptions>;
  where?: InputMaybe<TopicWhere>;
};


export type ChapterTopicsHasChapterAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TopicWhere>;
};


export type ChapterTopicsHasChapterConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ChapterTopicsHasChapterConnectionSort>>;
  where?: InputMaybe<ChapterTopicsHasChapterConnectionWhere>;
};


export type ChapterUsersHasKnowledgeArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type ChapterUsersHasKnowledgeAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type ChapterUsersHasKnowledgeConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ChapterUsersHasKnowledgeConnectionSort>>;
  where?: InputMaybe<ChapterUsersHasKnowledgeConnectionWhere>;
};

export type ChapterConnectInput = {
  topicsHasChapter?: InputMaybe<Array<ChapterTopicsHasChapterConnectFieldInput>>;
  usersHasKnowledge?: InputMaybe<Array<ChapterUsersHasKnowledgeConnectFieldInput>>;
};

export type ChapterConnectWhere = {
  node: ChapterWhere;
};

export type ChapterCreateInput = {
  isRelevant?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  topicsHasChapter?: InputMaybe<ChapterTopicsHasChapterFieldInput>;
  usersHasKnowledge?: InputMaybe<ChapterUsersHasKnowledgeFieldInput>;
};

export type ChapterDeleteInput = {
  topicsHasChapter?: InputMaybe<Array<ChapterTopicsHasChapterDeleteFieldInput>>;
  usersHasKnowledge?: InputMaybe<Array<ChapterUsersHasKnowledgeDeleteFieldInput>>;
};

export type ChapterDisconnectInput = {
  topicsHasChapter?: InputMaybe<Array<ChapterTopicsHasChapterDisconnectFieldInput>>;
  usersHasKnowledge?: InputMaybe<Array<ChapterUsersHasKnowledgeDisconnectFieldInput>>;
};

export type ChapterOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ChapterSort objects to sort Chapters by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ChapterSort>>;
};

/** Fields to sort Chapters by. The order in which sorts are applied is not guaranteed when specifying many fields in one ChapterSort object. */
export type ChapterSort = {
  isRelevant?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type ChapterTopicTopicsHasChapterAggregationSelection = {
  __typename?: 'ChapterTopicTopicsHasChapterAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<ChapterTopicTopicsHasChapterEdgeAggregateSelection>;
  node?: Maybe<ChapterTopicTopicsHasChapterNodeAggregateSelection>;
};

export type ChapterTopicTopicsHasChapterEdgeAggregateSelection = {
  __typename?: 'ChapterTopicTopicsHasChapterEdgeAggregateSelection';
  created: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
};

export type ChapterTopicTopicsHasChapterNodeAggregateSelection = {
  __typename?: 'ChapterTopicTopicsHasChapterNodeAggregateSelection';
  description: StringAggregateSelection;
  imageUrl: StringAggregateSelection;
  mastery: FloatAggregateSelection;
  name: StringAggregateSelection;
};

export type ChapterTopicsHasChapterAggregateInput = {
  AND?: InputMaybe<Array<ChapterTopicsHasChapterAggregateInput>>;
  NOT?: InputMaybe<ChapterTopicsHasChapterAggregateInput>;
  OR?: InputMaybe<Array<ChapterTopicsHasChapterAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasChapterPropertiesAggregationWhereInput>;
  node?: InputMaybe<ChapterTopicsHasChapterNodeAggregationWhereInput>;
};

export type ChapterTopicsHasChapterConnectFieldInput = {
  connect?: InputMaybe<Array<TopicConnectInput>>;
  edge: HasChapterPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TopicConnectWhere>;
};

export type ChapterTopicsHasChapterConnection = {
  __typename?: 'ChapterTopicsHasChapterConnection';
  edges: Array<ChapterTopicsHasChapterRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ChapterTopicsHasChapterConnectionSort = {
  edge?: InputMaybe<HasChapterPropertiesSort>;
  node?: InputMaybe<TopicSort>;
};

export type ChapterTopicsHasChapterConnectionWhere = {
  AND?: InputMaybe<Array<ChapterTopicsHasChapterConnectionWhere>>;
  NOT?: InputMaybe<ChapterTopicsHasChapterConnectionWhere>;
  OR?: InputMaybe<Array<ChapterTopicsHasChapterConnectionWhere>>;
  edge?: InputMaybe<HasChapterPropertiesWhere>;
  node?: InputMaybe<TopicWhere>;
};

export type ChapterTopicsHasChapterCreateFieldInput = {
  edge: HasChapterPropertiesCreateInput;
  node: TopicCreateInput;
};

export type ChapterTopicsHasChapterDeleteFieldInput = {
  delete?: InputMaybe<TopicDeleteInput>;
  where?: InputMaybe<ChapterTopicsHasChapterConnectionWhere>;
};

export type ChapterTopicsHasChapterDisconnectFieldInput = {
  disconnect?: InputMaybe<TopicDisconnectInput>;
  where?: InputMaybe<ChapterTopicsHasChapterConnectionWhere>;
};

export type ChapterTopicsHasChapterFieldInput = {
  connect?: InputMaybe<Array<ChapterTopicsHasChapterConnectFieldInput>>;
  create?: InputMaybe<Array<ChapterTopicsHasChapterCreateFieldInput>>;
};

export type ChapterTopicsHasChapterNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ChapterTopicsHasChapterNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ChapterTopicsHasChapterNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ChapterTopicsHasChapterNodeAggregationWhereInput>>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  imageUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  imageUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  imageUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  imageUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  imageUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  imageUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  imageUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  imageUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  imageUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  imageUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  imageUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  imageUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  imageUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  imageUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  imageUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mastery_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mastery_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  mastery_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  mastery_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  mastery_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  mastery_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mastery_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  mastery_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  mastery_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  mastery_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  mastery_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mastery_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  mastery_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  mastery_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  mastery_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  mastery_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mastery_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  mastery_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  mastery_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  mastery_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ChapterTopicsHasChapterRelationship = {
  __typename?: 'ChapterTopicsHasChapterRelationship';
  cursor: Scalars['String']['output'];
  node: Topic;
  properties: HasChapterProperties;
};

export type ChapterTopicsHasChapterUpdateConnectionInput = {
  edge?: InputMaybe<HasChapterPropertiesUpdateInput>;
  node?: InputMaybe<TopicUpdateInput>;
};

export type ChapterTopicsHasChapterUpdateFieldInput = {
  connect?: InputMaybe<Array<ChapterTopicsHasChapterConnectFieldInput>>;
  create?: InputMaybe<Array<ChapterTopicsHasChapterCreateFieldInput>>;
  delete?: InputMaybe<Array<ChapterTopicsHasChapterDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ChapterTopicsHasChapterDisconnectFieldInput>>;
  update?: InputMaybe<ChapterTopicsHasChapterUpdateConnectionInput>;
  where?: InputMaybe<ChapterTopicsHasChapterConnectionWhere>;
};

export type ChapterUpdateInput = {
  isRelevant?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  topicsHasChapter?: InputMaybe<Array<ChapterTopicsHasChapterUpdateFieldInput>>;
  usersHasKnowledge?: InputMaybe<Array<ChapterUsersHasKnowledgeUpdateFieldInput>>;
};

export type ChapterUserUsersHasKnowledgeAggregationSelection = {
  __typename?: 'ChapterUserUsersHasKnowledgeAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<ChapterUserUsersHasKnowledgeEdgeAggregateSelection>;
  node?: Maybe<ChapterUserUsersHasKnowledgeNodeAggregateSelection>;
};

export type ChapterUserUsersHasKnowledgeEdgeAggregateSelection = {
  __typename?: 'ChapterUserUsersHasKnowledgeEdgeAggregateSelection';
  created: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  total_mastery: FloatAggregateSelection;
};

export type ChapterUserUsersHasKnowledgeNodeAggregateSelection = {
  __typename?: 'ChapterUserUsersHasKnowledgeNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type ChapterUsersHasKnowledgeAggregateInput = {
  AND?: InputMaybe<Array<ChapterUsersHasKnowledgeAggregateInput>>;
  NOT?: InputMaybe<ChapterUsersHasKnowledgeAggregateInput>;
  OR?: InputMaybe<Array<ChapterUsersHasKnowledgeAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasKnowledgePropertiesAggregationWhereInput>;
  node?: InputMaybe<ChapterUsersHasKnowledgeNodeAggregationWhereInput>;
};

export type ChapterUsersHasKnowledgeConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  edge: HasKnowledgePropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type ChapterUsersHasKnowledgeConnectOrCreateFieldInput = {
  onCreate: ChapterUsersHasKnowledgeConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type ChapterUsersHasKnowledgeConnectOrCreateFieldInputOnCreate = {
  edge: HasKnowledgePropertiesCreateInput;
  node: UserOnCreateInput;
};

export type ChapterUsersHasKnowledgeConnection = {
  __typename?: 'ChapterUsersHasKnowledgeConnection';
  edges: Array<ChapterUsersHasKnowledgeRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ChapterUsersHasKnowledgeConnectionSort = {
  edge?: InputMaybe<HasKnowledgePropertiesSort>;
  node?: InputMaybe<UserSort>;
};

export type ChapterUsersHasKnowledgeConnectionWhere = {
  AND?: InputMaybe<Array<ChapterUsersHasKnowledgeConnectionWhere>>;
  NOT?: InputMaybe<ChapterUsersHasKnowledgeConnectionWhere>;
  OR?: InputMaybe<Array<ChapterUsersHasKnowledgeConnectionWhere>>;
  edge?: InputMaybe<HasKnowledgePropertiesWhere>;
  node?: InputMaybe<UserWhere>;
};

export type ChapterUsersHasKnowledgeCreateFieldInput = {
  edge: HasKnowledgePropertiesCreateInput;
  node: UserCreateInput;
};

export type ChapterUsersHasKnowledgeDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<ChapterUsersHasKnowledgeConnectionWhere>;
};

export type ChapterUsersHasKnowledgeDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<ChapterUsersHasKnowledgeConnectionWhere>;
};

export type ChapterUsersHasKnowledgeFieldInput = {
  connect?: InputMaybe<Array<ChapterUsersHasKnowledgeConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ChapterUsersHasKnowledgeConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ChapterUsersHasKnowledgeCreateFieldInput>>;
};

export type ChapterUsersHasKnowledgeNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ChapterUsersHasKnowledgeNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ChapterUsersHasKnowledgeNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ChapterUsersHasKnowledgeNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ChapterUsersHasKnowledgeRelationship = {
  __typename?: 'ChapterUsersHasKnowledgeRelationship';
  cursor: Scalars['String']['output'];
  node: User;
  properties: HasKnowledgeProperties;
};

export type ChapterUsersHasKnowledgeUpdateConnectionInput = {
  edge?: InputMaybe<HasKnowledgePropertiesUpdateInput>;
  node?: InputMaybe<UserUpdateInput>;
};

export type ChapterUsersHasKnowledgeUpdateFieldInput = {
  connect?: InputMaybe<Array<ChapterUsersHasKnowledgeConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ChapterUsersHasKnowledgeConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ChapterUsersHasKnowledgeCreateFieldInput>>;
  delete?: InputMaybe<Array<ChapterUsersHasKnowledgeDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ChapterUsersHasKnowledgeDisconnectFieldInput>>;
  update?: InputMaybe<ChapterUsersHasKnowledgeUpdateConnectionInput>;
  where?: InputMaybe<ChapterUsersHasKnowledgeConnectionWhere>;
};

export type ChapterWhere = {
  AND?: InputMaybe<Array<ChapterWhere>>;
  NOT?: InputMaybe<ChapterWhere>;
  OR?: InputMaybe<Array<ChapterWhere>>;
  isRelevant?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  topicsHasChapterAggregate?: InputMaybe<ChapterTopicsHasChapterAggregateInput>;
  /** Return Chapters where all of the related ChapterTopicsHasChapterConnections match this filter */
  topicsHasChapterConnection_ALL?: InputMaybe<ChapterTopicsHasChapterConnectionWhere>;
  /** Return Chapters where none of the related ChapterTopicsHasChapterConnections match this filter */
  topicsHasChapterConnection_NONE?: InputMaybe<ChapterTopicsHasChapterConnectionWhere>;
  /** Return Chapters where one of the related ChapterTopicsHasChapterConnections match this filter */
  topicsHasChapterConnection_SINGLE?: InputMaybe<ChapterTopicsHasChapterConnectionWhere>;
  /** Return Chapters where some of the related ChapterTopicsHasChapterConnections match this filter */
  topicsHasChapterConnection_SOME?: InputMaybe<ChapterTopicsHasChapterConnectionWhere>;
  /** Return Chapters where all of the related Topics match this filter */
  topicsHasChapter_ALL?: InputMaybe<TopicWhere>;
  /** Return Chapters where none of the related Topics match this filter */
  topicsHasChapter_NONE?: InputMaybe<TopicWhere>;
  /** Return Chapters where one of the related Topics match this filter */
  topicsHasChapter_SINGLE?: InputMaybe<TopicWhere>;
  /** Return Chapters where some of the related Topics match this filter */
  topicsHasChapter_SOME?: InputMaybe<TopicWhere>;
  usersHasKnowledgeAggregate?: InputMaybe<ChapterUsersHasKnowledgeAggregateInput>;
  /** Return Chapters where all of the related ChapterUsersHasKnowledgeConnections match this filter */
  usersHasKnowledgeConnection_ALL?: InputMaybe<ChapterUsersHasKnowledgeConnectionWhere>;
  /** Return Chapters where none of the related ChapterUsersHasKnowledgeConnections match this filter */
  usersHasKnowledgeConnection_NONE?: InputMaybe<ChapterUsersHasKnowledgeConnectionWhere>;
  /** Return Chapters where one of the related ChapterUsersHasKnowledgeConnections match this filter */
  usersHasKnowledgeConnection_SINGLE?: InputMaybe<ChapterUsersHasKnowledgeConnectionWhere>;
  /** Return Chapters where some of the related ChapterUsersHasKnowledgeConnections match this filter */
  usersHasKnowledgeConnection_SOME?: InputMaybe<ChapterUsersHasKnowledgeConnectionWhere>;
  /** Return Chapters where all of the related Users match this filter */
  usersHasKnowledge_ALL?: InputMaybe<UserWhere>;
  /** Return Chapters where none of the related Users match this filter */
  usersHasKnowledge_NONE?: InputMaybe<UserWhere>;
  /** Return Chapters where one of the related Users match this filter */
  usersHasKnowledge_SINGLE?: InputMaybe<UserWhere>;
  /** Return Chapters where some of the related Users match this filter */
  usersHasKnowledge_SOME?: InputMaybe<UserWhere>;
};

export type Chat = {
  __typename?: 'Chat';
  aiTutorHasChat: Array<AiTutor>;
  aiTutorHasChatAggregate?: Maybe<ChatAiTutorAiTutorHasChatAggregationSelection>;
  aiTutorHasChatConnection: ChatAiTutorHasChatConnection;
  assignedQuests?: Maybe<Array<Maybe<AssignedQuest>>>;
  assignmentsHasChat: Array<Assignment>;
  assignmentsHasChatAggregate?: Maybe<ChatAssignmentAssignmentsHasChatAggregationSelection>;
  assignmentsHasChatConnection: ChatAssignmentsHasChatConnection;
  context?: Maybe<Scalars['String']['output']>;
  conversation: Array<Message>;
  created?: Maybe<Scalars['DateTime']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  hasMessageMessages: Array<Message>;
  hasMessageMessagesAggregate?: Maybe<ChatMessageHasMessageMessagesAggregationSelection>;
  hasMessageMessagesConnection: ChatHasMessageMessagesConnection;
  id: Scalars['ID']['output'];
  last_modified?: Maybe<Scalars['DateTime']['output']>;
  learningObjectivesHasChat: Array<LearningObjective>;
  learningObjectivesHasChatAggregate?: Maybe<ChatLearningObjectiveLearningObjectivesHasChatAggregationSelection>;
  learningObjectivesHasChatConnection: ChatLearningObjectivesHasChatConnection;
  name: Scalars['String']['output'];
  objectId?: Maybe<Scalars['ID']['output']>;
  params?: Maybe<Scalars['JSON']['output']>;
  schemaVersion?: Maybe<Scalars['Int']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usersHasChat: Array<User>;
  usersHasChatAggregate?: Maybe<ChatUserUsersHasChatAggregationSelection>;
  usersHasChatConnection: ChatUsersHasChatConnection;
  workspacesHasChat: Array<Workspace>;
  workspacesHasChatAggregate?: Maybe<ChatWorkspaceWorkspacesHasChatAggregationSelection>;
  workspacesHasChatConnection: ChatWorkspacesHasChatConnection;
};


export type ChatAiTutorHasChatArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AiTutorOptions>;
  where?: InputMaybe<AiTutorWhere>;
};


export type ChatAiTutorHasChatAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AiTutorWhere>;
};


export type ChatAiTutorHasChatConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ChatAiTutorHasChatConnectionSort>>;
  where?: InputMaybe<ChatAiTutorHasChatConnectionWhere>;
};


export type ChatAssignmentsHasChatArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AssignmentOptions>;
  where?: InputMaybe<AssignmentWhere>;
};


export type ChatAssignmentsHasChatAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssignmentWhere>;
};


export type ChatAssignmentsHasChatConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ChatAssignmentsHasChatConnectionSort>>;
  where?: InputMaybe<ChatAssignmentsHasChatConnectionWhere>;
};


export type ChatHasMessageMessagesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<MessageOptions>;
  where?: InputMaybe<MessageWhere>;
};


export type ChatHasMessageMessagesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MessageWhere>;
};


export type ChatHasMessageMessagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ChatHasMessageMessagesConnectionSort>>;
  where?: InputMaybe<ChatHasMessageMessagesConnectionWhere>;
};


export type ChatLearningObjectivesHasChatArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LearningObjectiveOptions>;
  where?: InputMaybe<LearningObjectiveWhere>;
};


export type ChatLearningObjectivesHasChatAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LearningObjectiveWhere>;
};


export type ChatLearningObjectivesHasChatConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ChatLearningObjectivesHasChatConnectionSort>>;
  where?: InputMaybe<ChatLearningObjectivesHasChatConnectionWhere>;
};


export type ChatUsersHasChatArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type ChatUsersHasChatAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type ChatUsersHasChatConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ChatUsersHasChatConnectionSort>>;
  where?: InputMaybe<ChatUsersHasChatConnectionWhere>;
};


export type ChatWorkspacesHasChatArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<WorkspaceOptions>;
  where?: InputMaybe<WorkspaceWhere>;
};


export type ChatWorkspacesHasChatAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WorkspaceWhere>;
};


export type ChatWorkspacesHasChatConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ChatWorkspacesHasChatConnectionSort>>;
  where?: InputMaybe<ChatWorkspacesHasChatConnectionWhere>;
};

export type ChatAiTutorAiTutorHasChatAggregationSelection = {
  __typename?: 'ChatAITutorAiTutorHasChatAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<ChatAiTutorAiTutorHasChatEdgeAggregateSelection>;
  node?: Maybe<ChatAiTutorAiTutorHasChatNodeAggregateSelection>;
};

export type ChatAiTutorAiTutorHasChatEdgeAggregateSelection = {
  __typename?: 'ChatAITutorAiTutorHasChatEdgeAggregateSelection';
  ai_messages_count: IntAggregateSelection;
  average_ai_response_time: FloatAggregateSelection;
  average_student_response_time: FloatAggregateSelection;
  created: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  num_messages: IntAggregateSelection;
  questions_asked: IntAggregateSelection;
  student_messages_count: IntAggregateSelection;
  summary: StringAggregateSelection;
  total_time_taken: FloatAggregateSelection;
};

export type ChatAiTutorAiTutorHasChatNodeAggregateSelection = {
  __typename?: 'ChatAITutorAiTutorHasChatNodeAggregateSelection';
  context: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  targetAudience: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type ChatAiTutorHasChatAggregateInput = {
  AND?: InputMaybe<Array<ChatAiTutorHasChatAggregateInput>>;
  NOT?: InputMaybe<ChatAiTutorHasChatAggregateInput>;
  OR?: InputMaybe<Array<ChatAiTutorHasChatAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasChatPropertiesAggregationWhereInput>;
  node?: InputMaybe<ChatAiTutorHasChatNodeAggregationWhereInput>;
};

export type ChatAiTutorHasChatConnectFieldInput = {
  connect?: InputMaybe<Array<AiTutorConnectInput>>;
  edge?: InputMaybe<HasChatPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AiTutorConnectWhere>;
};

export type ChatAiTutorHasChatConnectOrCreateFieldInput = {
  onCreate: ChatAiTutorHasChatConnectOrCreateFieldInputOnCreate;
  where: AiTutorConnectOrCreateWhere;
};

export type ChatAiTutorHasChatConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<HasChatPropertiesCreateInput>;
  node: AiTutorOnCreateInput;
};

export type ChatAiTutorHasChatConnection = {
  __typename?: 'ChatAiTutorHasChatConnection';
  edges: Array<ChatAiTutorHasChatRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ChatAiTutorHasChatConnectionSort = {
  edge?: InputMaybe<HasChatPropertiesSort>;
  node?: InputMaybe<AiTutorSort>;
};

export type ChatAiTutorHasChatConnectionWhere = {
  AND?: InputMaybe<Array<ChatAiTutorHasChatConnectionWhere>>;
  NOT?: InputMaybe<ChatAiTutorHasChatConnectionWhere>;
  OR?: InputMaybe<Array<ChatAiTutorHasChatConnectionWhere>>;
  edge?: InputMaybe<HasChatPropertiesWhere>;
  node?: InputMaybe<AiTutorWhere>;
};

export type ChatAiTutorHasChatCreateFieldInput = {
  edge?: InputMaybe<HasChatPropertiesCreateInput>;
  node: AiTutorCreateInput;
};

export type ChatAiTutorHasChatDeleteFieldInput = {
  delete?: InputMaybe<AiTutorDeleteInput>;
  where?: InputMaybe<ChatAiTutorHasChatConnectionWhere>;
};

export type ChatAiTutorHasChatDisconnectFieldInput = {
  disconnect?: InputMaybe<AiTutorDisconnectInput>;
  where?: InputMaybe<ChatAiTutorHasChatConnectionWhere>;
};

export type ChatAiTutorHasChatFieldInput = {
  connect?: InputMaybe<Array<ChatAiTutorHasChatConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ChatAiTutorHasChatConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ChatAiTutorHasChatCreateFieldInput>>;
};

export type ChatAiTutorHasChatNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ChatAiTutorHasChatNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ChatAiTutorHasChatNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ChatAiTutorHasChatNodeAggregationWhereInput>>;
  context_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  context_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatAiTutorHasChatRelationship = {
  __typename?: 'ChatAiTutorHasChatRelationship';
  cursor: Scalars['String']['output'];
  node: AiTutor;
  properties: HasChatProperties;
};

export type ChatAiTutorHasChatUpdateConnectionInput = {
  edge?: InputMaybe<HasChatPropertiesUpdateInput>;
  node?: InputMaybe<AiTutorUpdateInput>;
};

export type ChatAiTutorHasChatUpdateFieldInput = {
  connect?: InputMaybe<Array<ChatAiTutorHasChatConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ChatAiTutorHasChatConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ChatAiTutorHasChatCreateFieldInput>>;
  delete?: InputMaybe<Array<ChatAiTutorHasChatDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ChatAiTutorHasChatDisconnectFieldInput>>;
  update?: InputMaybe<ChatAiTutorHasChatUpdateConnectionInput>;
  where?: InputMaybe<ChatAiTutorHasChatConnectionWhere>;
};

export type ChatAnalytics = {
  __typename?: 'ChatAnalytics';
  ai_messages_count: Scalars['Int']['output'];
  average_ai_response_time: Scalars['Float']['output'];
  average_student_question_complexity?: Maybe<Scalars['Float']['output']>;
  average_student_response_time: Scalars['Float']['output'];
  confusion_points?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  distractions: Scalars['Int']['output'];
  further_recommendations: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  level?: Maybe<Scalars['String']['output']>;
  num_messages: Scalars['Int']['output'];
  originality_analysis?: Maybe<Scalars['String']['output']>;
  questions_asked: Scalars['Int']['output'];
  sentiment_analysis?: Maybe<Scalars['String']['output']>;
  student_messages_count: Scalars['Int']['output'];
  success_points?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  summary: Scalars['String']['output'];
  total_time_taken: Scalars['Float']['output'];
};

export type ChatAssignmentAssignmentsHasChatAggregationSelection = {
  __typename?: 'ChatAssignmentAssignmentsHasChatAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<ChatAssignmentAssignmentsHasChatEdgeAggregateSelection>;
  node?: Maybe<ChatAssignmentAssignmentsHasChatNodeAggregateSelection>;
};

export type ChatAssignmentAssignmentsHasChatEdgeAggregateSelection = {
  __typename?: 'ChatAssignmentAssignmentsHasChatEdgeAggregateSelection';
  ai_messages_count: IntAggregateSelection;
  average_ai_response_time: FloatAggregateSelection;
  average_student_response_time: FloatAggregateSelection;
  created: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  num_messages: IntAggregateSelection;
  questions_asked: IntAggregateSelection;
  student_messages_count: IntAggregateSelection;
  summary: StringAggregateSelection;
  total_time_taken: FloatAggregateSelection;
};

export type ChatAssignmentAssignmentsHasChatNodeAggregateSelection = {
  __typename?: 'ChatAssignmentAssignmentsHasChatNodeAggregateSelection';
  _empty: StringAggregateSelection;
  allowed_attempts: FloatAggregateSelection;
  assignee_mode: StringAggregateSelection;
  assignment_group_id: FloatAggregateSelection;
  assignment_name: StringAggregateSelection;
  body: StringAggregateSelection;
  category_id: StringAggregateSelection;
  course_id: FloatAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  description: StringAggregateSelection;
  description_plaintext: StringAggregateSelection;
  discussion_topic_assignment_id: FloatAggregateSelection;
  discussion_topic_author_anonymous_id: StringAggregateSelection;
  discussion_topic_author_avatar_image_url: StringAggregateSelection;
  discussion_topic_author_display_name: StringAggregateSelection;
  discussion_topic_author_html_url: StringAggregateSelection;
  discussion_topic_author_id: FloatAggregateSelection;
  discussion_topic_created_at: StringAggregateSelection;
  discussion_topic_discussion_subentry_count: FloatAggregateSelection;
  discussion_topic_discussion_type: StringAggregateSelection;
  discussion_topic_html_url: StringAggregateSelection;
  discussion_topic_id: FloatAggregateSelection;
  discussion_topic_last_reply_at: StringAggregateSelection;
  discussion_topic_message: StringAggregateSelection;
  discussion_topic_posted_at: StringAggregateSelection;
  discussion_topic_read_state: StringAggregateSelection;
  discussion_topic_title: StringAggregateSelection;
  discussion_topic_unread_count: FloatAggregateSelection;
  discussion_topic_url: StringAggregateSelection;
  discussion_topic_user_name: StringAggregateSelection;
  display_date: StringAggregateSelection;
  due_at: StringAggregateSelection;
  due_date: DateTimeAggregateSelection;
  end_date: StringAggregateSelection;
  external_tool_tag_attributes_content_id: FloatAggregateSelection;
  external_tool_tag_attributes_content_type: StringAggregateSelection;
  external_tool_tag_attributes_external_data: StringAggregateSelection;
  external_tool_tag_attributes_resource_link_id: StringAggregateSelection;
  external_tool_tag_attributes_url: StringAggregateSelection;
  grade_points: FloatAggregateSelection;
  grader_count: FloatAggregateSelection;
  grading_type: StringAggregateSelection;
  html: StringAggregateSelection;
  html_url: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  lti_context_id: StringAggregateSelection;
  max_attempts: FloatAggregateSelection;
  max_name_length: FloatAggregateSelection;
  name: StringAggregateSelection;
  needs_grading_count: FloatAggregateSelection;
  objectives: StringAggregateSelection;
  points_possible: FloatAggregateSelection;
  position: FloatAggregateSelection;
  resource_metadata: StringAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  secure_params: StringAggregateSelection;
  session_id: StringAggregateSelection;
  start_date: StringAggregateSelection;
  state: StringAggregateSelection;
  submissions_download_url: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_at: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  url: StringAggregateSelection;
  videoUrl: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export type ChatAssignmentsHasChatAggregateInput = {
  AND?: InputMaybe<Array<ChatAssignmentsHasChatAggregateInput>>;
  NOT?: InputMaybe<ChatAssignmentsHasChatAggregateInput>;
  OR?: InputMaybe<Array<ChatAssignmentsHasChatAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasChatPropertiesAggregationWhereInput>;
  node?: InputMaybe<ChatAssignmentsHasChatNodeAggregationWhereInput>;
};

export type ChatAssignmentsHasChatConnectFieldInput = {
  connect?: InputMaybe<Array<AssignmentConnectInput>>;
  edge?: InputMaybe<HasChatPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AssignmentConnectWhere>;
};

export type ChatAssignmentsHasChatConnectOrCreateFieldInput = {
  onCreate: ChatAssignmentsHasChatConnectOrCreateFieldInputOnCreate;
  where: AssignmentConnectOrCreateWhere;
};

export type ChatAssignmentsHasChatConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<HasChatPropertiesCreateInput>;
  node: AssignmentOnCreateInput;
};

export type ChatAssignmentsHasChatConnection = {
  __typename?: 'ChatAssignmentsHasChatConnection';
  edges: Array<ChatAssignmentsHasChatRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ChatAssignmentsHasChatConnectionSort = {
  edge?: InputMaybe<HasChatPropertiesSort>;
  node?: InputMaybe<AssignmentSort>;
};

export type ChatAssignmentsHasChatConnectionWhere = {
  AND?: InputMaybe<Array<ChatAssignmentsHasChatConnectionWhere>>;
  NOT?: InputMaybe<ChatAssignmentsHasChatConnectionWhere>;
  OR?: InputMaybe<Array<ChatAssignmentsHasChatConnectionWhere>>;
  edge?: InputMaybe<HasChatPropertiesWhere>;
  node?: InputMaybe<AssignmentWhere>;
};

export type ChatAssignmentsHasChatCreateFieldInput = {
  edge?: InputMaybe<HasChatPropertiesCreateInput>;
  node: AssignmentCreateInput;
};

export type ChatAssignmentsHasChatDeleteFieldInput = {
  delete?: InputMaybe<AssignmentDeleteInput>;
  where?: InputMaybe<ChatAssignmentsHasChatConnectionWhere>;
};

export type ChatAssignmentsHasChatDisconnectFieldInput = {
  disconnect?: InputMaybe<AssignmentDisconnectInput>;
  where?: InputMaybe<ChatAssignmentsHasChatConnectionWhere>;
};

export type ChatAssignmentsHasChatFieldInput = {
  connect?: InputMaybe<Array<ChatAssignmentsHasChatConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ChatAssignmentsHasChatConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ChatAssignmentsHasChatCreateFieldInput>>;
};

export type ChatAssignmentsHasChatNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ChatAssignmentsHasChatNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ChatAssignmentsHasChatNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ChatAssignmentsHasChatNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  allowed_attempts_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_group_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  body_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  category_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_assignment_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_unread_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  display_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  due_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_date_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_points_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  html_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lti_context_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  max_attempts_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  needs_grading_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  points_possible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  secure_params_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  secure_params_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  session_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatAssignmentsHasChatRelationship = {
  __typename?: 'ChatAssignmentsHasChatRelationship';
  cursor: Scalars['String']['output'];
  node: Assignment;
  properties: HasChatProperties;
};

export type ChatAssignmentsHasChatUpdateConnectionInput = {
  edge?: InputMaybe<HasChatPropertiesUpdateInput>;
  node?: InputMaybe<AssignmentUpdateInput>;
};

export type ChatAssignmentsHasChatUpdateFieldInput = {
  connect?: InputMaybe<Array<ChatAssignmentsHasChatConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ChatAssignmentsHasChatConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ChatAssignmentsHasChatCreateFieldInput>>;
  delete?: InputMaybe<Array<ChatAssignmentsHasChatDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ChatAssignmentsHasChatDisconnectFieldInput>>;
  update?: InputMaybe<ChatAssignmentsHasChatUpdateConnectionInput>;
  where?: InputMaybe<ChatAssignmentsHasChatConnectionWhere>;
};

export type ChatAttachmentProcessResult = {
  __typename?: 'ChatAttachmentProcessResult';
  data?: Maybe<AttachmentProcessData>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ChatAttachmentResponse = {
  __typename?: 'ChatAttachmentResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<File>>>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ChatConnectInput = {
  aiTutorHasChat?: InputMaybe<Array<ChatAiTutorHasChatConnectFieldInput>>;
  assignmentsHasChat?: InputMaybe<Array<ChatAssignmentsHasChatConnectFieldInput>>;
  hasMessageMessages?: InputMaybe<Array<ChatHasMessageMessagesConnectFieldInput>>;
  learningObjectivesHasChat?: InputMaybe<Array<ChatLearningObjectivesHasChatConnectFieldInput>>;
  usersHasChat?: InputMaybe<Array<ChatUsersHasChatConnectFieldInput>>;
  workspacesHasChat?: InputMaybe<Array<ChatWorkspacesHasChatConnectFieldInput>>;
};

export type ChatConnectOrCreateWhere = {
  node: ChatUniqueWhere;
};

export type ChatConnectWhere = {
  node: ChatWhere;
};

export type ChatCreateInput = {
  aiTutorHasChat?: InputMaybe<ChatAiTutorHasChatFieldInput>;
  assignmentsHasChat?: InputMaybe<ChatAssignmentsHasChatFieldInput>;
  context?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  hasMessageMessages?: InputMaybe<ChatHasMessageMessagesFieldInput>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  learningObjectivesHasChat?: InputMaybe<ChatLearningObjectivesHasChatFieldInput>;
  name: Scalars['String']['input'];
  objectId?: InputMaybe<Scalars['ID']['input']>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  schemaVersion?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  usersHasChat?: InputMaybe<ChatUsersHasChatFieldInput>;
  workspacesHasChat?: InputMaybe<ChatWorkspacesHasChatFieldInput>;
};

export type ChatDeleteInput = {
  aiTutorHasChat?: InputMaybe<Array<ChatAiTutorHasChatDeleteFieldInput>>;
  assignmentsHasChat?: InputMaybe<Array<ChatAssignmentsHasChatDeleteFieldInput>>;
  hasMessageMessages?: InputMaybe<Array<ChatHasMessageMessagesDeleteFieldInput>>;
  learningObjectivesHasChat?: InputMaybe<Array<ChatLearningObjectivesHasChatDeleteFieldInput>>;
  usersHasChat?: InputMaybe<Array<ChatUsersHasChatDeleteFieldInput>>;
  workspacesHasChat?: InputMaybe<Array<ChatWorkspacesHasChatDeleteFieldInput>>;
};

export type ChatDisconnectInput = {
  aiTutorHasChat?: InputMaybe<Array<ChatAiTutorHasChatDisconnectFieldInput>>;
  assignmentsHasChat?: InputMaybe<Array<ChatAssignmentsHasChatDisconnectFieldInput>>;
  hasMessageMessages?: InputMaybe<Array<ChatHasMessageMessagesDisconnectFieldInput>>;
  learningObjectivesHasChat?: InputMaybe<Array<ChatLearningObjectivesHasChatDisconnectFieldInput>>;
  usersHasChat?: InputMaybe<Array<ChatUsersHasChatDisconnectFieldInput>>;
  workspacesHasChat?: InputMaybe<Array<ChatWorkspacesHasChatDisconnectFieldInput>>;
};

export type ChatHasMessageMessagesAggregateInput = {
  AND?: InputMaybe<Array<ChatHasMessageMessagesAggregateInput>>;
  NOT?: InputMaybe<ChatHasMessageMessagesAggregateInput>;
  OR?: InputMaybe<Array<ChatHasMessageMessagesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasMessagePropertiesAggregationWhereInput>;
  node?: InputMaybe<ChatHasMessageMessagesNodeAggregationWhereInput>;
};

export type ChatHasMessageMessagesConnectFieldInput = {
  connect?: InputMaybe<Array<MessageConnectInput>>;
  edge: HasMessagePropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<MessageConnectWhere>;
};

export type ChatHasMessageMessagesConnectOrCreateFieldInput = {
  onCreate: ChatHasMessageMessagesConnectOrCreateFieldInputOnCreate;
  where: MessageConnectOrCreateWhere;
};

export type ChatHasMessageMessagesConnectOrCreateFieldInputOnCreate = {
  edge: HasMessagePropertiesCreateInput;
  node: MessageOnCreateInput;
};

export type ChatHasMessageMessagesConnection = {
  __typename?: 'ChatHasMessageMessagesConnection';
  edges: Array<ChatHasMessageMessagesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ChatHasMessageMessagesConnectionSort = {
  edge?: InputMaybe<HasMessagePropertiesSort>;
  node?: InputMaybe<MessageSort>;
};

export type ChatHasMessageMessagesConnectionWhere = {
  AND?: InputMaybe<Array<ChatHasMessageMessagesConnectionWhere>>;
  NOT?: InputMaybe<ChatHasMessageMessagesConnectionWhere>;
  OR?: InputMaybe<Array<ChatHasMessageMessagesConnectionWhere>>;
  edge?: InputMaybe<HasMessagePropertiesWhere>;
  node?: InputMaybe<MessageWhere>;
};

export type ChatHasMessageMessagesCreateFieldInput = {
  edge: HasMessagePropertiesCreateInput;
  node: MessageCreateInput;
};

export type ChatHasMessageMessagesDeleteFieldInput = {
  delete?: InputMaybe<MessageDeleteInput>;
  where?: InputMaybe<ChatHasMessageMessagesConnectionWhere>;
};

export type ChatHasMessageMessagesDisconnectFieldInput = {
  disconnect?: InputMaybe<MessageDisconnectInput>;
  where?: InputMaybe<ChatHasMessageMessagesConnectionWhere>;
};

export type ChatHasMessageMessagesFieldInput = {
  connect?: InputMaybe<Array<ChatHasMessageMessagesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ChatHasMessageMessagesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ChatHasMessageMessagesCreateFieldInput>>;
};

export type ChatHasMessageMessagesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ChatHasMessageMessagesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ChatHasMessageMessagesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ChatHasMessageMessagesNodeAggregationWhereInput>>;
  aspectDetails_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  content_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  content_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  emotion_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emotion_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emotion_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emotion_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emotion_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emotion_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emotion_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emotion_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emotion_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emotion_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  index_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  index_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  nodeId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nodeId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  nodeId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  nodeId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  nodeId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  nodeId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nodeId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nodeId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nodeId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nodeId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  parameters_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  parameters_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  parameters_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  parameters_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  parameters_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  parameters_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  parameters_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  parameters_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  parameters_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  parameters_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  snackType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  snackType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  snackType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  snackType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  snackType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  snackType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  snackType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  snackType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  snackType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  snackType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatHasMessageMessagesRelationship = {
  __typename?: 'ChatHasMessageMessagesRelationship';
  cursor: Scalars['String']['output'];
  node: Message;
  properties: HasMessageProperties;
};

export type ChatHasMessageMessagesUpdateConnectionInput = {
  edge?: InputMaybe<HasMessagePropertiesUpdateInput>;
  node?: InputMaybe<MessageUpdateInput>;
};

export type ChatHasMessageMessagesUpdateFieldInput = {
  connect?: InputMaybe<Array<ChatHasMessageMessagesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ChatHasMessageMessagesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ChatHasMessageMessagesCreateFieldInput>>;
  delete?: InputMaybe<Array<ChatHasMessageMessagesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ChatHasMessageMessagesDisconnectFieldInput>>;
  update?: InputMaybe<ChatHasMessageMessagesUpdateConnectionInput>;
  where?: InputMaybe<ChatHasMessageMessagesConnectionWhere>;
};

export type ChatLearningObjectiveLearningObjectivesHasChatAggregationSelection = {
  __typename?: 'ChatLearningObjectiveLearningObjectivesHasChatAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<ChatLearningObjectiveLearningObjectivesHasChatEdgeAggregateSelection>;
  node?: Maybe<ChatLearningObjectiveLearningObjectivesHasChatNodeAggregateSelection>;
};

export type ChatLearningObjectiveLearningObjectivesHasChatEdgeAggregateSelection = {
  __typename?: 'ChatLearningObjectiveLearningObjectivesHasChatEdgeAggregateSelection';
  ai_messages_count: IntAggregateSelection;
  average_ai_response_time: FloatAggregateSelection;
  average_student_response_time: FloatAggregateSelection;
  created: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  num_messages: IntAggregateSelection;
  questions_asked: IntAggregateSelection;
  student_messages_count: IntAggregateSelection;
  summary: StringAggregateSelection;
  total_time_taken: FloatAggregateSelection;
};

export type ChatLearningObjectiveLearningObjectivesHasChatNodeAggregateSelection = {
  __typename?: 'ChatLearningObjectiveLearningObjectivesHasChatNodeAggregateSelection';
  completed: IntAggregateSelection;
  description: StringAggregateSelection;
  id: IdAggregateSelection;
  index: IntAggregateSelection;
  title: StringAggregateSelection;
  total_mastery: IntAggregateSelection;
};

export type ChatLearningObjectivesHasChatAggregateInput = {
  AND?: InputMaybe<Array<ChatLearningObjectivesHasChatAggregateInput>>;
  NOT?: InputMaybe<ChatLearningObjectivesHasChatAggregateInput>;
  OR?: InputMaybe<Array<ChatLearningObjectivesHasChatAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasChatPropertiesAggregationWhereInput>;
  node?: InputMaybe<ChatLearningObjectivesHasChatNodeAggregationWhereInput>;
};

export type ChatLearningObjectivesHasChatConnectFieldInput = {
  connect?: InputMaybe<Array<LearningObjectiveConnectInput>>;
  edge?: InputMaybe<HasChatPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LearningObjectiveConnectWhere>;
};

export type ChatLearningObjectivesHasChatConnection = {
  __typename?: 'ChatLearningObjectivesHasChatConnection';
  edges: Array<ChatLearningObjectivesHasChatRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ChatLearningObjectivesHasChatConnectionSort = {
  edge?: InputMaybe<HasChatPropertiesSort>;
  node?: InputMaybe<LearningObjectiveSort>;
};

export type ChatLearningObjectivesHasChatConnectionWhere = {
  AND?: InputMaybe<Array<ChatLearningObjectivesHasChatConnectionWhere>>;
  NOT?: InputMaybe<ChatLearningObjectivesHasChatConnectionWhere>;
  OR?: InputMaybe<Array<ChatLearningObjectivesHasChatConnectionWhere>>;
  edge?: InputMaybe<HasChatPropertiesWhere>;
  node?: InputMaybe<LearningObjectiveWhere>;
};

export type ChatLearningObjectivesHasChatCreateFieldInput = {
  edge?: InputMaybe<HasChatPropertiesCreateInput>;
  node: LearningObjectiveCreateInput;
};

export type ChatLearningObjectivesHasChatDeleteFieldInput = {
  delete?: InputMaybe<LearningObjectiveDeleteInput>;
  where?: InputMaybe<ChatLearningObjectivesHasChatConnectionWhere>;
};

export type ChatLearningObjectivesHasChatDisconnectFieldInput = {
  disconnect?: InputMaybe<LearningObjectiveDisconnectInput>;
  where?: InputMaybe<ChatLearningObjectivesHasChatConnectionWhere>;
};

export type ChatLearningObjectivesHasChatFieldInput = {
  connect?: InputMaybe<Array<ChatLearningObjectivesHasChatConnectFieldInput>>;
  create?: InputMaybe<Array<ChatLearningObjectivesHasChatCreateFieldInput>>;
};

export type ChatLearningObjectivesHasChatNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ChatLearningObjectivesHasChatNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ChatLearningObjectivesHasChatNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ChatLearningObjectivesHasChatNodeAggregationWhereInput>>;
  completed_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  completed_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  completed_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  completed_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  completed_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  completed_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  completed_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  completed_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  completed_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  completed_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  completed_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  completed_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  completed_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  completed_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  completed_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  completed_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  completed_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  completed_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  completed_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  completed_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  index_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  index_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  total_mastery_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  total_mastery_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  total_mastery_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  total_mastery_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  total_mastery_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  total_mastery_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  total_mastery_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  total_mastery_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  total_mastery_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  total_mastery_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  total_mastery_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  total_mastery_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  total_mastery_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  total_mastery_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  total_mastery_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  total_mastery_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  total_mastery_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  total_mastery_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  total_mastery_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  total_mastery_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatLearningObjectivesHasChatRelationship = {
  __typename?: 'ChatLearningObjectivesHasChatRelationship';
  cursor: Scalars['String']['output'];
  node: LearningObjective;
  properties: HasChatProperties;
};

export type ChatLearningObjectivesHasChatUpdateConnectionInput = {
  edge?: InputMaybe<HasChatPropertiesUpdateInput>;
  node?: InputMaybe<LearningObjectiveUpdateInput>;
};

export type ChatLearningObjectivesHasChatUpdateFieldInput = {
  connect?: InputMaybe<Array<ChatLearningObjectivesHasChatConnectFieldInput>>;
  create?: InputMaybe<Array<ChatLearningObjectivesHasChatCreateFieldInput>>;
  delete?: InputMaybe<Array<ChatLearningObjectivesHasChatDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ChatLearningObjectivesHasChatDisconnectFieldInput>>;
  update?: InputMaybe<ChatLearningObjectivesHasChatUpdateConnectionInput>;
  where?: InputMaybe<ChatLearningObjectivesHasChatConnectionWhere>;
};

export type ChatMessageHasMessageMessagesAggregationSelection = {
  __typename?: 'ChatMessageHasMessageMessagesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<ChatMessageHasMessageMessagesEdgeAggregateSelection>;
  node?: Maybe<ChatMessageHasMessageMessagesNodeAggregateSelection>;
};

export type ChatMessageHasMessageMessagesEdgeAggregateSelection = {
  __typename?: 'ChatMessageHasMessageMessagesEdgeAggregateSelection';
  created: DateTimeAggregateSelection;
};

export type ChatMessageHasMessageMessagesNodeAggregateSelection = {
  __typename?: 'ChatMessageHasMessageMessagesNodeAggregateSelection';
  aspectDetails: StringAggregateSelection;
  content: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  emotion: StringAggregateSelection;
  id: IdAggregateSelection;
  index: IntAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  nodeId: StringAggregateSelection;
  parameters: StringAggregateSelection;
  sender: StringAggregateSelection;
  snackType: StringAggregateSelection;
  type: StringAggregateSelection;
};

export type ChatMutationResponse = {
  __typename?: 'ChatMutationResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Chat>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ChatOnCreateInput = {
  context?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  objectId?: InputMaybe<Scalars['ID']['input']>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  schemaVersion?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ChatOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ChatSort objects to sort Chats by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ChatSort>>;
};

export type ChatResponse = {
  __typename?: 'ChatResponse';
  assignedQuests?: Maybe<Array<Maybe<AssignedQuest>>>;
  context?: Maybe<Scalars['String']['output']>;
  conversation: Array<MessageResponse>;
  created?: Maybe<Scalars['DateTime']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last_modified?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  objectId?: Maybe<Scalars['ID']['output']>;
  params?: Maybe<Scalars['JSON']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  workspacesHasChat: Array<Workspace>;
};

/** Fields to sort Chats by. The order in which sorts are applied is not guaranteed when specifying many fields in one ChatSort object. */
export type ChatSort = {
  context?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  date?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  last_modified?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  objectId?: InputMaybe<SortDirection>;
  params?: InputMaybe<SortDirection>;
  schemaVersion?: InputMaybe<SortDirection>;
  timezone?: InputMaybe<SortDirection>;
  url?: InputMaybe<SortDirection>;
};

export type ChatUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ChatUpdateInput = {
  aiTutorHasChat?: InputMaybe<Array<ChatAiTutorHasChatUpdateFieldInput>>;
  assignmentsHasChat?: InputMaybe<Array<ChatAssignmentsHasChatUpdateFieldInput>>;
  context?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  hasMessageMessages?: InputMaybe<Array<ChatHasMessageMessagesUpdateFieldInput>>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  learningObjectivesHasChat?: InputMaybe<Array<ChatLearningObjectivesHasChatUpdateFieldInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  objectId?: InputMaybe<Scalars['ID']['input']>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  schemaVersion?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  usersHasChat?: InputMaybe<Array<ChatUsersHasChatUpdateFieldInput>>;
  workspacesHasChat?: InputMaybe<Array<ChatWorkspacesHasChatUpdateFieldInput>>;
};

export type ChatUserUsersHasChatAggregationSelection = {
  __typename?: 'ChatUserUsersHasChatAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<ChatUserUsersHasChatEdgeAggregateSelection>;
  node?: Maybe<ChatUserUsersHasChatNodeAggregateSelection>;
};

export type ChatUserUsersHasChatEdgeAggregateSelection = {
  __typename?: 'ChatUserUsersHasChatEdgeAggregateSelection';
  ai_messages_count: IntAggregateSelection;
  average_ai_response_time: FloatAggregateSelection;
  average_student_response_time: FloatAggregateSelection;
  created: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  num_messages: IntAggregateSelection;
  questions_asked: IntAggregateSelection;
  student_messages_count: IntAggregateSelection;
  summary: StringAggregateSelection;
  total_time_taken: FloatAggregateSelection;
};

export type ChatUserUsersHasChatNodeAggregateSelection = {
  __typename?: 'ChatUserUsersHasChatNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type ChatUsersHasChatAggregateInput = {
  AND?: InputMaybe<Array<ChatUsersHasChatAggregateInput>>;
  NOT?: InputMaybe<ChatUsersHasChatAggregateInput>;
  OR?: InputMaybe<Array<ChatUsersHasChatAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasChatPropertiesAggregationWhereInput>;
  node?: InputMaybe<ChatUsersHasChatNodeAggregationWhereInput>;
};

export type ChatUsersHasChatConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  edge?: InputMaybe<HasChatPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type ChatUsersHasChatConnectOrCreateFieldInput = {
  onCreate: ChatUsersHasChatConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type ChatUsersHasChatConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<HasChatPropertiesCreateInput>;
  node: UserOnCreateInput;
};

export type ChatUsersHasChatConnection = {
  __typename?: 'ChatUsersHasChatConnection';
  edges: Array<ChatUsersHasChatRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ChatUsersHasChatConnectionSort = {
  edge?: InputMaybe<HasChatPropertiesSort>;
  node?: InputMaybe<UserSort>;
};

export type ChatUsersHasChatConnectionWhere = {
  AND?: InputMaybe<Array<ChatUsersHasChatConnectionWhere>>;
  NOT?: InputMaybe<ChatUsersHasChatConnectionWhere>;
  OR?: InputMaybe<Array<ChatUsersHasChatConnectionWhere>>;
  edge?: InputMaybe<HasChatPropertiesWhere>;
  node?: InputMaybe<UserWhere>;
};

export type ChatUsersHasChatCreateFieldInput = {
  edge?: InputMaybe<HasChatPropertiesCreateInput>;
  node: UserCreateInput;
};

export type ChatUsersHasChatDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<ChatUsersHasChatConnectionWhere>;
};

export type ChatUsersHasChatDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<ChatUsersHasChatConnectionWhere>;
};

export type ChatUsersHasChatFieldInput = {
  connect?: InputMaybe<Array<ChatUsersHasChatConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ChatUsersHasChatConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ChatUsersHasChatCreateFieldInput>>;
};

export type ChatUsersHasChatNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ChatUsersHasChatNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ChatUsersHasChatNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ChatUsersHasChatNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatUsersHasChatRelationship = {
  __typename?: 'ChatUsersHasChatRelationship';
  cursor: Scalars['String']['output'];
  node: User;
  properties: HasChatProperties;
};

export type ChatUsersHasChatUpdateConnectionInput = {
  edge?: InputMaybe<HasChatPropertiesUpdateInput>;
  node?: InputMaybe<UserUpdateInput>;
};

export type ChatUsersHasChatUpdateFieldInput = {
  connect?: InputMaybe<Array<ChatUsersHasChatConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ChatUsersHasChatConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ChatUsersHasChatCreateFieldInput>>;
  delete?: InputMaybe<Array<ChatUsersHasChatDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ChatUsersHasChatDisconnectFieldInput>>;
  update?: InputMaybe<ChatUsersHasChatUpdateConnectionInput>;
  where?: InputMaybe<ChatUsersHasChatConnectionWhere>;
};

export type ChatWhere = {
  AND?: InputMaybe<Array<ChatWhere>>;
  NOT?: InputMaybe<ChatWhere>;
  OR?: InputMaybe<Array<ChatWhere>>;
  aiTutorHasChatAggregate?: InputMaybe<ChatAiTutorHasChatAggregateInput>;
  /** Return Chats where all of the related ChatAiTutorHasChatConnections match this filter */
  aiTutorHasChatConnection_ALL?: InputMaybe<ChatAiTutorHasChatConnectionWhere>;
  /** Return Chats where none of the related ChatAiTutorHasChatConnections match this filter */
  aiTutorHasChatConnection_NONE?: InputMaybe<ChatAiTutorHasChatConnectionWhere>;
  /** Return Chats where one of the related ChatAiTutorHasChatConnections match this filter */
  aiTutorHasChatConnection_SINGLE?: InputMaybe<ChatAiTutorHasChatConnectionWhere>;
  /** Return Chats where some of the related ChatAiTutorHasChatConnections match this filter */
  aiTutorHasChatConnection_SOME?: InputMaybe<ChatAiTutorHasChatConnectionWhere>;
  /** Return Chats where all of the related AITutors match this filter */
  aiTutorHasChat_ALL?: InputMaybe<AiTutorWhere>;
  /** Return Chats where none of the related AITutors match this filter */
  aiTutorHasChat_NONE?: InputMaybe<AiTutorWhere>;
  /** Return Chats where one of the related AITutors match this filter */
  aiTutorHasChat_SINGLE?: InputMaybe<AiTutorWhere>;
  /** Return Chats where some of the related AITutors match this filter */
  aiTutorHasChat_SOME?: InputMaybe<AiTutorWhere>;
  assignmentsHasChatAggregate?: InputMaybe<ChatAssignmentsHasChatAggregateInput>;
  /** Return Chats where all of the related ChatAssignmentsHasChatConnections match this filter */
  assignmentsHasChatConnection_ALL?: InputMaybe<ChatAssignmentsHasChatConnectionWhere>;
  /** Return Chats where none of the related ChatAssignmentsHasChatConnections match this filter */
  assignmentsHasChatConnection_NONE?: InputMaybe<ChatAssignmentsHasChatConnectionWhere>;
  /** Return Chats where one of the related ChatAssignmentsHasChatConnections match this filter */
  assignmentsHasChatConnection_SINGLE?: InputMaybe<ChatAssignmentsHasChatConnectionWhere>;
  /** Return Chats where some of the related ChatAssignmentsHasChatConnections match this filter */
  assignmentsHasChatConnection_SOME?: InputMaybe<ChatAssignmentsHasChatConnectionWhere>;
  /** Return Chats where all of the related Assignments match this filter */
  assignmentsHasChat_ALL?: InputMaybe<AssignmentWhere>;
  /** Return Chats where none of the related Assignments match this filter */
  assignmentsHasChat_NONE?: InputMaybe<AssignmentWhere>;
  /** Return Chats where one of the related Assignments match this filter */
  assignmentsHasChat_SINGLE?: InputMaybe<AssignmentWhere>;
  /** Return Chats where some of the related Assignments match this filter */
  assignmentsHasChat_SOME?: InputMaybe<AssignmentWhere>;
  context?: InputMaybe<Scalars['String']['input']>;
  context_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  context_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  context_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  context_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  date_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  hasMessageMessagesAggregate?: InputMaybe<ChatHasMessageMessagesAggregateInput>;
  /** Return Chats where all of the related ChatHasMessageMessagesConnections match this filter */
  hasMessageMessagesConnection_ALL?: InputMaybe<ChatHasMessageMessagesConnectionWhere>;
  /** Return Chats where none of the related ChatHasMessageMessagesConnections match this filter */
  hasMessageMessagesConnection_NONE?: InputMaybe<ChatHasMessageMessagesConnectionWhere>;
  /** Return Chats where one of the related ChatHasMessageMessagesConnections match this filter */
  hasMessageMessagesConnection_SINGLE?: InputMaybe<ChatHasMessageMessagesConnectionWhere>;
  /** Return Chats where some of the related ChatHasMessageMessagesConnections match this filter */
  hasMessageMessagesConnection_SOME?: InputMaybe<ChatHasMessageMessagesConnectionWhere>;
  /** Return Chats where all of the related Messages match this filter */
  hasMessageMessages_ALL?: InputMaybe<MessageWhere>;
  /** Return Chats where none of the related Messages match this filter */
  hasMessageMessages_NONE?: InputMaybe<MessageWhere>;
  /** Return Chats where one of the related Messages match this filter */
  hasMessageMessages_SINGLE?: InputMaybe<MessageWhere>;
  /** Return Chats where some of the related Messages match this filter */
  hasMessageMessages_SOME?: InputMaybe<MessageWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  last_modified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningObjectivesHasChatAggregate?: InputMaybe<ChatLearningObjectivesHasChatAggregateInput>;
  /** Return Chats where all of the related ChatLearningObjectivesHasChatConnections match this filter */
  learningObjectivesHasChatConnection_ALL?: InputMaybe<ChatLearningObjectivesHasChatConnectionWhere>;
  /** Return Chats where none of the related ChatLearningObjectivesHasChatConnections match this filter */
  learningObjectivesHasChatConnection_NONE?: InputMaybe<ChatLearningObjectivesHasChatConnectionWhere>;
  /** Return Chats where one of the related ChatLearningObjectivesHasChatConnections match this filter */
  learningObjectivesHasChatConnection_SINGLE?: InputMaybe<ChatLearningObjectivesHasChatConnectionWhere>;
  /** Return Chats where some of the related ChatLearningObjectivesHasChatConnections match this filter */
  learningObjectivesHasChatConnection_SOME?: InputMaybe<ChatLearningObjectivesHasChatConnectionWhere>;
  /** Return Chats where all of the related LearningObjectives match this filter */
  learningObjectivesHasChat_ALL?: InputMaybe<LearningObjectiveWhere>;
  /** Return Chats where none of the related LearningObjectives match this filter */
  learningObjectivesHasChat_NONE?: InputMaybe<LearningObjectiveWhere>;
  /** Return Chats where one of the related LearningObjectives match this filter */
  learningObjectivesHasChat_SINGLE?: InputMaybe<LearningObjectiveWhere>;
  /** Return Chats where some of the related LearningObjectives match this filter */
  learningObjectivesHasChat_SOME?: InputMaybe<LearningObjectiveWhere>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  objectId?: InputMaybe<Scalars['ID']['input']>;
  objectId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  objectId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  objectId_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  objectId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  params_IN?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  schemaVersion?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_GT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_GTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  schemaVersion_LT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  timezone_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  timezone_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  timezone_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timezone_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  usersHasChatAggregate?: InputMaybe<ChatUsersHasChatAggregateInput>;
  /** Return Chats where all of the related ChatUsersHasChatConnections match this filter */
  usersHasChatConnection_ALL?: InputMaybe<ChatUsersHasChatConnectionWhere>;
  /** Return Chats where none of the related ChatUsersHasChatConnections match this filter */
  usersHasChatConnection_NONE?: InputMaybe<ChatUsersHasChatConnectionWhere>;
  /** Return Chats where one of the related ChatUsersHasChatConnections match this filter */
  usersHasChatConnection_SINGLE?: InputMaybe<ChatUsersHasChatConnectionWhere>;
  /** Return Chats where some of the related ChatUsersHasChatConnections match this filter */
  usersHasChatConnection_SOME?: InputMaybe<ChatUsersHasChatConnectionWhere>;
  /** Return Chats where all of the related Users match this filter */
  usersHasChat_ALL?: InputMaybe<UserWhere>;
  /** Return Chats where none of the related Users match this filter */
  usersHasChat_NONE?: InputMaybe<UserWhere>;
  /** Return Chats where one of the related Users match this filter */
  usersHasChat_SINGLE?: InputMaybe<UserWhere>;
  /** Return Chats where some of the related Users match this filter */
  usersHasChat_SOME?: InputMaybe<UserWhere>;
  workspacesHasChatAggregate?: InputMaybe<ChatWorkspacesHasChatAggregateInput>;
  /** Return Chats where all of the related ChatWorkspacesHasChatConnections match this filter */
  workspacesHasChatConnection_ALL?: InputMaybe<ChatWorkspacesHasChatConnectionWhere>;
  /** Return Chats where none of the related ChatWorkspacesHasChatConnections match this filter */
  workspacesHasChatConnection_NONE?: InputMaybe<ChatWorkspacesHasChatConnectionWhere>;
  /** Return Chats where one of the related ChatWorkspacesHasChatConnections match this filter */
  workspacesHasChatConnection_SINGLE?: InputMaybe<ChatWorkspacesHasChatConnectionWhere>;
  /** Return Chats where some of the related ChatWorkspacesHasChatConnections match this filter */
  workspacesHasChatConnection_SOME?: InputMaybe<ChatWorkspacesHasChatConnectionWhere>;
  /** Return Chats where all of the related Workspaces match this filter */
  workspacesHasChat_ALL?: InputMaybe<WorkspaceWhere>;
  /** Return Chats where none of the related Workspaces match this filter */
  workspacesHasChat_NONE?: InputMaybe<WorkspaceWhere>;
  /** Return Chats where one of the related Workspaces match this filter */
  workspacesHasChat_SINGLE?: InputMaybe<WorkspaceWhere>;
  /** Return Chats where some of the related Workspaces match this filter */
  workspacesHasChat_SOME?: InputMaybe<WorkspaceWhere>;
};

export type ChatWorkspaceWorkspacesHasChatAggregationSelection = {
  __typename?: 'ChatWorkspaceWorkspacesHasChatAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ChatWorkspaceWorkspacesHasChatNodeAggregateSelection>;
};

export type ChatWorkspaceWorkspacesHasChatNodeAggregateSelection = {
  __typename?: 'ChatWorkspaceWorkspacesHasChatNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  key: StringAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  name: StringAggregateSelection;
};

export type ChatWorkspacesHasChatAggregateInput = {
  AND?: InputMaybe<Array<ChatWorkspacesHasChatAggregateInput>>;
  NOT?: InputMaybe<ChatWorkspacesHasChatAggregateInput>;
  OR?: InputMaybe<Array<ChatWorkspacesHasChatAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ChatWorkspacesHasChatNodeAggregationWhereInput>;
};

export type ChatWorkspacesHasChatConnectFieldInput = {
  connect?: InputMaybe<Array<WorkspaceConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<WorkspaceConnectWhere>;
};

export type ChatWorkspacesHasChatConnectOrCreateFieldInput = {
  onCreate: ChatWorkspacesHasChatConnectOrCreateFieldInputOnCreate;
  where: WorkspaceConnectOrCreateWhere;
};

export type ChatWorkspacesHasChatConnectOrCreateFieldInputOnCreate = {
  node: WorkspaceOnCreateInput;
};

export type ChatWorkspacesHasChatConnection = {
  __typename?: 'ChatWorkspacesHasChatConnection';
  edges: Array<ChatWorkspacesHasChatRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ChatWorkspacesHasChatConnectionSort = {
  node?: InputMaybe<WorkspaceSort>;
};

export type ChatWorkspacesHasChatConnectionWhere = {
  AND?: InputMaybe<Array<ChatWorkspacesHasChatConnectionWhere>>;
  NOT?: InputMaybe<ChatWorkspacesHasChatConnectionWhere>;
  OR?: InputMaybe<Array<ChatWorkspacesHasChatConnectionWhere>>;
  node?: InputMaybe<WorkspaceWhere>;
};

export type ChatWorkspacesHasChatCreateFieldInput = {
  node: WorkspaceCreateInput;
};

export type ChatWorkspacesHasChatDeleteFieldInput = {
  delete?: InputMaybe<WorkspaceDeleteInput>;
  where?: InputMaybe<ChatWorkspacesHasChatConnectionWhere>;
};

export type ChatWorkspacesHasChatDisconnectFieldInput = {
  disconnect?: InputMaybe<WorkspaceDisconnectInput>;
  where?: InputMaybe<ChatWorkspacesHasChatConnectionWhere>;
};

export type ChatWorkspacesHasChatFieldInput = {
  connect?: InputMaybe<Array<ChatWorkspacesHasChatConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ChatWorkspacesHasChatConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ChatWorkspacesHasChatCreateFieldInput>>;
};

export type ChatWorkspacesHasChatNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ChatWorkspacesHasChatNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ChatWorkspacesHasChatNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ChatWorkspacesHasChatNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  key_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  key_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatWorkspacesHasChatRelationship = {
  __typename?: 'ChatWorkspacesHasChatRelationship';
  cursor: Scalars['String']['output'];
  node: Workspace;
};

export type ChatWorkspacesHasChatUpdateConnectionInput = {
  node?: InputMaybe<WorkspaceUpdateInput>;
};

export type ChatWorkspacesHasChatUpdateFieldInput = {
  connect?: InputMaybe<Array<ChatWorkspacesHasChatConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ChatWorkspacesHasChatConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ChatWorkspacesHasChatCreateFieldInput>>;
  delete?: InputMaybe<Array<ChatWorkspacesHasChatDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ChatWorkspacesHasChatDisconnectFieldInput>>;
  update?: InputMaybe<ChatWorkspacesHasChatUpdateConnectionInput>;
  where?: InputMaybe<ChatWorkspacesHasChatConnectionWhere>;
};

export enum CheckInFrequency {
  Minimal = 'MINIMAL',
  Normal = 'NORMAL',
  Proactive = 'PROACTIVE'
}

export type ChildInfo = {
  __typename?: 'ChildInfo';
  completedTracks?: Maybe<Scalars['Float']['output']>;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  totalTracks?: Maybe<Scalars['Float']['output']>;
};

export type CompanionChatsForUserResponse = {
  __typename?: 'CompanionChatsForUserResponse';
  courseWorkspaces: Array<WorkspaceChatsGroup>;
  generalChats: Array<UserChatsResponse>;
  generalChatsCount: Scalars['Int']['output'];
};

export type CompanionChatsForUserResult = {
  __typename?: 'CompanionChatsForUserResult';
  count?: Maybe<Scalars['Int']['output']>;
  data: CompanionChatsForUserResponse;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CompanionOnboardingPayloadInput = {
  assignmentReminders?: InputMaybe<Scalars['Boolean']['input']>;
  careerInterests?: InputMaybe<Array<Scalars['String']['input']>>;
  checkInFrequency?: InputMaybe<CheckInFrequency>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  learningStyles?: InputMaybe<Array<Scalars['String']['input']>>;
  motivations?: InputMaybe<Array<Scalars['String']['input']>>;
  semesterGoal?: InputMaybe<Scalars['String']['input']>;
  skillsToImprove?: InputMaybe<Array<Scalars['String']['input']>>;
  studyTimePreference?: InputMaybe<StudyTime>;
  textReminders?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanionOnboardingState = {
  __typename?: 'CompanionOnboardingState';
  deferredUntil?: Maybe<Scalars['DateTime']['output']>;
  last_modified?: Maybe<Scalars['DateTime']['output']>;
  payload?: Maybe<UserLearningPreferences>;
  status: CompanionOnboardingStatus;
  step?: Maybe<Scalars['Int']['output']>;
};

export type CompanionOnboardingStateInput = {
  deferredUntil?: InputMaybe<Scalars['DateTime']['input']>;
  payload?: InputMaybe<CompanionOnboardingPayloadInput>;
  status: CompanionOnboardingStatus;
  step?: InputMaybe<Scalars['Int']['input']>;
};

export enum CompanionOnboardingStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Skipped = 'SKIPPED'
}

export type CompanionWorkspaceChatsResponse = {
  __typename?: 'CompanionWorkspaceChatsResponse';
  chats: Array<UserChatsResponse>;
  totalCount: Scalars['Int']['output'];
};

export type CompletionActivityAnalytics = {
  __typename?: 'CompletionActivityAnalytics';
  completionStats: CompletionStats;
  details: CompletionActivityDetails;
  label: Scalars['String']['output'];
};

export type CompletionActivityDetails = {
  __typename?: 'CompletionActivityDetails';
  objectives: Array<CompletionObjectiveAnalytics>;
};

export type CompletionAnalytics = {
  __typename?: 'CompletionAnalytics';
  completionStats: CompletionStats;
  details: CompletionCourseDetails;
  label: Scalars['String']['output'];
};

export type CompletionAnalyticsResponse = {
  __typename?: 'CompletionAnalyticsResponse';
  count: Scalars['Int']['output'];
  data: Array<CompletionAnalytics>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CompletionCourseDetails = {
  __typename?: 'CompletionCourseDetails';
  modules: Array<CompletionModuleAnalytics>;
};

export type CompletionModuleAnalytics = {
  __typename?: 'CompletionModuleAnalytics';
  completionStats: CompletionStats;
  details: CompletionModuleDetails;
  label: Scalars['String']['output'];
};

export type CompletionModuleDetails = {
  __typename?: 'CompletionModuleDetails';
  activities: Array<CompletionActivityAnalytics>;
};

export type CompletionObjectiveAnalytics = {
  __typename?: 'CompletionObjectiveAnalytics';
  completionStats: CompletionStats;
  label: Scalars['String']['output'];
};

export type CompletionStats = {
  __typename?: 'CompletionStats';
  completed: Scalars['Float']['output'];
  inProgress: Scalars['Float']['output'];
  notStarted: Scalars['Float']['output'];
};

export type ContentSafetySettings = {
  __typename?: 'ContentSafetySettings';
  harassment: Scalars['Boolean']['output'];
  hate: Scalars['Boolean']['output'];
  selfHarm: Scalars['Boolean']['output'];
  sexual: Scalars['Boolean']['output'];
  violence: Scalars['Boolean']['output'];
};

export type ContentSafetySettingsInput = {
  harassment: Scalars['Boolean']['input'];
  hate: Scalars['Boolean']['input'];
  selfHarm: Scalars['Boolean']['input'];
  sexual: Scalars['Boolean']['input'];
  violence: Scalars['Boolean']['input'];
};

export type ContentSafetySettingsResponse = {
  __typename?: 'ContentSafetySettingsResponse';
  count: Scalars['Int']['output'];
  data?: Maybe<Array<Maybe<ContentSafetySettings>>>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CoreValue = {
  __typename?: 'CoreValue';
  id?: Maybe<Scalars['Int']['output']>;
  importance?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Course = {
  __typename?: 'Course';
  account_id?: Maybe<Scalars['Float']['output']>;
  announcements: Array<Announcement>;
  announcementsAggregate?: Maybe<CourseAnnouncementAnnouncementsAggregationSelection>;
  announcementsConnection: CourseAnnouncementsConnection;
  apply_assignment_group_weights?: Maybe<Scalars['Boolean']['output']>;
  auditEvents: Array<AuditEvent>;
  auditEventsAggregate?: Maybe<CourseAuditEventAuditEventsAggregationSelection>;
  auditEventsConnection: CourseAuditEventsConnection;
  blueprint?: Maybe<Scalars['Boolean']['output']>;
  calendar_ics?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  courseId?: Maybe<Scalars['String']['output']>;
  course_code?: Maybe<Scalars['String']['output']>;
  course_id?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['String']['output']>;
  default_view?: Maybe<Scalars['String']['output']>;
  degreesHasCourse: Array<Degree>;
  degreesHasCourseAggregate?: Maybe<CourseDegreeDegreesHasCourseAggregationSelection>;
  degreesHasCourseConnection: CourseDegreesHasCourseConnection;
  description?: Maybe<Scalars['String']['output']>;
  documents: Array<Document>;
  documentsAggregate?: Maybe<CourseDocumentDocumentsAggregationSelection>;
  documentsConnection: CourseDocumentsConnection;
  dueDateEndDate?: Maybe<Scalars['DateTime']['output']>;
  dueDateStartDate?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  end_at?: Maybe<Scalars['String']['output']>;
  enrolledStudents: Array<User>;
  enrolledStudentsAggregate?: Maybe<CourseUserEnrolledStudentsAggregationSelection>;
  enrolledStudentsConnection: CourseEnrolledStudentsConnection;
  enrollmentLink?: Maybe<EnrollmentLink>;
  enrollmentLinkAggregate?: Maybe<CourseEnrollmentLinkEnrollmentLinkAggregationSelection>;
  enrollmentLinkConnection: CourseEnrollmentLinkConnection;
  enrollment_term_id?: Maybe<Scalars['Float']['output']>;
  evaluations: Array<CourseEvaluation>;
  evaluationsAggregate?: Maybe<CourseCourseEvaluationEvaluationsAggregationSelection>;
  evaluationsConnection: CourseEvaluationsConnection;
  externalIntegrations: Array<CourseExternalIntegration>;
  externalIntegrationsAggregate?: Maybe<CourseCourseExternalIntegrationExternalIntegrationsAggregationSelection>;
  externalIntegrationsConnection: CourseExternalIntegrationsConnection;
  forum?: Maybe<Forum>;
  forumAggregate?: Maybe<CourseForumForumAggregationSelection>;
  forumConnection: CourseForumConnection;
  generationStatus?: Maybe<CourseGenerationStatus>;
  grading_standard_id?: Maybe<Scalars['Float']['output']>;
  hasAssignmentAssignments: Array<Assignment>;
  hasAssignmentAssignmentsAggregate?: Maybe<CourseAssignmentHasAssignmentAssignmentsAggregationSelection>;
  hasAssignmentAssignmentsConnection: CourseHasAssignmentAssignmentsConnection;
  hasCourseCategoriesCourseCategories: Array<CourseCategory>;
  hasCourseCategoriesCourseCategoriesAggregate?: Maybe<CourseCourseCategoryHasCourseCategoriesCourseCategoriesAggregationSelection>;
  hasCourseCategoriesCourseCategoriesConnection: CourseHasCourseCategoriesCourseCategoriesConnection;
  hasPagePages: Array<Page>;
  hasPagePagesAggregate?: Maybe<CoursePageHasPagePagesAggregationSelection>;
  hasPagePagesConnection: CourseHasPagePagesConnection;
  hide_final_grades?: Maybe<Scalars['Boolean']['output']>;
  homeroom_course?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  integration_id?: Maybe<Scalars['String']['output']>;
  isCustomCourse?: Maybe<Scalars['Boolean']['output']>;
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  isEnrollmentAvailable?: Maybe<Scalars['Boolean']['output']>;
  is_elective?: Maybe<Scalars['Boolean']['output']>;
  is_public?: Maybe<Scalars['Boolean']['output']>;
  is_public_to_auth_users?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['DateTime']['output']>;
  learningStandards?: Maybe<Scalars['String']['output']>;
  lengthInWeeks?: Maybe<Scalars['Float']['output']>;
  license?: Maybe<Scalars['String']['output']>;
  lti_id?: Maybe<Scalars['String']['output']>;
  moduleOrder?: Maybe<Array<Scalars['String']['output']>>;
  modules: Array<Module>;
  modulesAggregate?: Maybe<CourseModuleModulesAggregationSelection>;
  modulesConnection: CourseModulesConnection;
  name?: Maybe<Scalars['String']['output']>;
  nudgesAboutThis: Array<Nudge>;
  nudgesAboutThisAggregate?: Maybe<CourseNudgeNudgesAboutThisAggregationSelection>;
  nudgesAboutThisConnection: CourseNudgesAboutThisConnection;
  objectives?: Maybe<Array<Scalars['String']['output']>>;
  original_name?: Maybe<Scalars['String']['output']>;
  period_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  periods?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  preRequisiteFor: Array<Course>;
  preRequisiteForAggregate?: Maybe<CourseCoursePreRequisiteForAggregationSelection>;
  preRequisiteForConnection: CoursePreRequisiteForConnection;
  preRequisites: Array<Course>;
  preRequisitesAggregate?: Maybe<CourseCoursePreRequisitesAggregationSelection>;
  preRequisitesConnection: CoursePreRequisitesConnection;
  public_syllabus?: Maybe<Scalars['Boolean']['output']>;
  public_syllabus_to_auth?: Maybe<Scalars['Boolean']['output']>;
  restrict_enrollments_to_course_dates?: Maybe<Scalars['Boolean']['output']>;
  root_account_id?: Maybe<Scalars['Float']['output']>;
  schoolsHasCourse: Array<School>;
  schoolsHasCourseAggregate?: Maybe<CourseSchoolSchoolsHasCourseAggregationSelection>;
  schoolsHasCourseConnection: CourseSchoolsHasCourseConnection;
  sis_course_id?: Maybe<Scalars['String']['output']>;
  sis_import_id?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  start_at?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  storage_quota_mb?: Maybe<Scalars['Float']['output']>;
  stripePriceId?: Maybe<Scalars['String']['output']>;
  stripeProductId?: Maybe<Scalars['String']['output']>;
  targetAudience?: Maybe<Scalars['String']['output']>;
  teachingFaculty: Array<User>;
  teachingFacultyAggregate?: Maybe<CourseUserTeachingFacultyAggregationSelection>;
  teachingFacultyConnection: CourseTeachingFacultyConnection;
  template?: Maybe<Scalars['Boolean']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  time_zone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_date?: Maybe<Scalars['String']['output']>;
  usersHasSchoolCourse: Array<User>;
  usersHasSchoolCourseAggregate?: Maybe<CourseUserUsersHasSchoolCourseAggregationSelection>;
  usersHasSchoolCourseConnection: CourseUsersHasSchoolCourseConnection;
  usersHaveLearningPayment: Array<LearningPayment>;
  usersHaveLearningPaymentAggregate?: Maybe<CourseLearningPaymentUsersHaveLearningPaymentAggregationSelection>;
  usersHaveLearningPaymentConnection: CourseUsersHaveLearningPaymentConnection;
  uuid?: Maybe<Scalars['String']['output']>;
  workflow_state?: Maybe<Scalars['String']['output']>;
  workspaces: Array<Workspace>;
  workspacesAggregate?: Maybe<CourseWorkspaceWorkspacesAggregationSelection>;
  workspacesConnection: CourseWorkspacesConnection;
};


export type CourseAnnouncementsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AnnouncementOptions>;
  where?: InputMaybe<AnnouncementWhere>;
};


export type CourseAnnouncementsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnnouncementWhere>;
};


export type CourseAnnouncementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CourseAnnouncementsConnectionSort>>;
  where?: InputMaybe<CourseAnnouncementsConnectionWhere>;
};


export type CourseAuditEventsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AuditEventOptions>;
  where?: InputMaybe<AuditEventWhere>;
};


export type CourseAuditEventsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AuditEventWhere>;
};


export type CourseAuditEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CourseAuditEventsConnectionSort>>;
  where?: InputMaybe<CourseAuditEventsConnectionWhere>;
};


export type CourseDegreesHasCourseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DegreeOptions>;
  where?: InputMaybe<DegreeWhere>;
};


export type CourseDegreesHasCourseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DegreeWhere>;
};


export type CourseDegreesHasCourseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CourseDegreesHasCourseConnectionSort>>;
  where?: InputMaybe<CourseDegreesHasCourseConnectionWhere>;
};


export type CourseDocumentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DocumentOptions>;
  where?: InputMaybe<DocumentWhere>;
};


export type CourseDocumentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DocumentWhere>;
};


export type CourseDocumentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CourseDocumentsConnectionSort>>;
  where?: InputMaybe<CourseDocumentsConnectionWhere>;
};


export type CourseEnrolledStudentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type CourseEnrolledStudentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type CourseEnrolledStudentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CourseEnrolledStudentsConnectionSort>>;
  where?: InputMaybe<CourseEnrolledStudentsConnectionWhere>;
};


export type CourseEnrollmentLinkArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EnrollmentLinkOptions>;
  where?: InputMaybe<EnrollmentLinkWhere>;
};


export type CourseEnrollmentLinkAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EnrollmentLinkWhere>;
};


export type CourseEnrollmentLinkConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CourseEnrollmentLinkConnectionSort>>;
  where?: InputMaybe<CourseEnrollmentLinkConnectionWhere>;
};


export type CourseEvaluationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CourseEvaluationOptions>;
  where?: InputMaybe<CourseEvaluationWhere>;
};


export type CourseEvaluationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CourseEvaluationWhere>;
};


export type CourseEvaluationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CourseEvaluationsConnectionSort>>;
  where?: InputMaybe<CourseEvaluationsConnectionWhere>;
};


export type CourseExternalIntegrationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CourseExternalIntegrationOptions>;
  where?: InputMaybe<CourseExternalIntegrationWhere>;
};


export type CourseExternalIntegrationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CourseExternalIntegrationWhere>;
};


export type CourseExternalIntegrationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CourseExternalIntegrationsConnectionSort>>;
  where?: InputMaybe<CourseExternalIntegrationsConnectionWhere>;
};


export type CourseForumArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ForumOptions>;
  where?: InputMaybe<ForumWhere>;
};


export type CourseForumAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ForumWhere>;
};


export type CourseForumConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CourseForumConnectionSort>>;
  where?: InputMaybe<CourseForumConnectionWhere>;
};


export type CourseHasAssignmentAssignmentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AssignmentOptions>;
  where?: InputMaybe<AssignmentWhere>;
};


export type CourseHasAssignmentAssignmentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssignmentWhere>;
};


export type CourseHasAssignmentAssignmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CourseHasAssignmentAssignmentsConnectionSort>>;
  where?: InputMaybe<CourseHasAssignmentAssignmentsConnectionWhere>;
};


export type CourseHasCourseCategoriesCourseCategoriesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CourseCategoryOptions>;
  where?: InputMaybe<CourseCategoryWhere>;
};


export type CourseHasCourseCategoriesCourseCategoriesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CourseCategoryWhere>;
};


export type CourseHasCourseCategoriesCourseCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CourseHasCourseCategoriesCourseCategoriesConnectionSort>>;
  where?: InputMaybe<CourseHasCourseCategoriesCourseCategoriesConnectionWhere>;
};


export type CourseHasPagePagesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PageOptions>;
  where?: InputMaybe<PageWhere>;
};


export type CourseHasPagePagesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PageWhere>;
};


export type CourseHasPagePagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CourseHasPagePagesConnectionSort>>;
  where?: InputMaybe<CourseHasPagePagesConnectionWhere>;
};


export type CourseModulesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ModuleOptions>;
  where?: InputMaybe<ModuleWhere>;
};


export type CourseModulesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ModuleWhere>;
};


export type CourseModulesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CourseModulesConnectionSort>>;
  where?: InputMaybe<CourseModulesConnectionWhere>;
};


export type CourseNudgesAboutThisArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<NudgeOptions>;
  where?: InputMaybe<NudgeWhere>;
};


export type CourseNudgesAboutThisAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NudgeWhere>;
};


export type CourseNudgesAboutThisConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CourseNudgesAboutThisConnectionSort>>;
  where?: InputMaybe<CourseNudgesAboutThisConnectionWhere>;
};


export type CoursePreRequisiteForArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CourseOptions>;
  where?: InputMaybe<CourseWhere>;
};


export type CoursePreRequisiteForAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CourseWhere>;
};


export type CoursePreRequisiteForConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CoursePreRequisiteForConnectionSort>>;
  where?: InputMaybe<CoursePreRequisiteForConnectionWhere>;
};


export type CoursePreRequisitesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CourseOptions>;
  where?: InputMaybe<CourseWhere>;
};


export type CoursePreRequisitesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CourseWhere>;
};


export type CoursePreRequisitesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CoursePreRequisitesConnectionSort>>;
  where?: InputMaybe<CoursePreRequisitesConnectionWhere>;
};


export type CourseSchoolsHasCourseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SchoolOptions>;
  where?: InputMaybe<SchoolWhere>;
};


export type CourseSchoolsHasCourseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SchoolWhere>;
};


export type CourseSchoolsHasCourseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CourseSchoolsHasCourseConnectionSort>>;
  where?: InputMaybe<CourseSchoolsHasCourseConnectionWhere>;
};


export type CourseTeachingFacultyArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type CourseTeachingFacultyAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type CourseTeachingFacultyConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CourseTeachingFacultyConnectionSort>>;
  where?: InputMaybe<CourseTeachingFacultyConnectionWhere>;
};


export type CourseUsersHasSchoolCourseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type CourseUsersHasSchoolCourseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type CourseUsersHasSchoolCourseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CourseUsersHasSchoolCourseConnectionSort>>;
  where?: InputMaybe<CourseUsersHasSchoolCourseConnectionWhere>;
};


export type CourseUsersHaveLearningPaymentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LearningPaymentOptions>;
  where?: InputMaybe<LearningPaymentWhere>;
};


export type CourseUsersHaveLearningPaymentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LearningPaymentWhere>;
};


export type CourseUsersHaveLearningPaymentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CourseUsersHaveLearningPaymentConnectionSort>>;
  where?: InputMaybe<CourseUsersHaveLearningPaymentConnectionWhere>;
};


export type CourseWorkspacesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<WorkspaceOptions>;
  where?: InputMaybe<WorkspaceWhere>;
};


export type CourseWorkspacesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WorkspaceWhere>;
};


export type CourseWorkspacesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CourseWorkspacesConnectionSort>>;
  where?: InputMaybe<CourseWorkspacesConnectionWhere>;
};

export type CourseAnalytics = {
  __typename?: 'CourseAnalytics';
  active_interaction_count: Scalars['Int']['output'];
  average_time_taken?: Maybe<Scalars['Float']['output']>;
  confusion_points: Scalars['Int']['output'];
  details: CourseAnalyticsDetails;
  distractions: Scalars['Int']['output'];
  enrollment: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  questions_asked: Scalars['Int']['output'];
  sentiment: Scalars['String']['output'];
  success_points: Scalars['Int']['output'];
};

export type CourseAnalyticsDetails = {
  __typename?: 'CourseAnalyticsDetails';
  modules: Array<ModuleAnalytics>;
};

export type CourseAnalyticsResponse = {
  __typename?: 'CourseAnalyticsResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<CourseAnalytics>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CourseAnnouncementAnnouncementsAggregationSelection = {
  __typename?: 'CourseAnnouncementAnnouncementsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CourseAnnouncementAnnouncementsNodeAggregateSelection>;
};

export type CourseAnnouncementAnnouncementsNodeAggregateSelection = {
  __typename?: 'CourseAnnouncementAnnouncementsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  expirationDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  message: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type CourseAnnouncementsAggregateInput = {
  AND?: InputMaybe<Array<CourseAnnouncementsAggregateInput>>;
  NOT?: InputMaybe<CourseAnnouncementsAggregateInput>;
  OR?: InputMaybe<Array<CourseAnnouncementsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CourseAnnouncementsNodeAggregationWhereInput>;
};

export type CourseAnnouncementsConnectFieldInput = {
  connect?: InputMaybe<Array<AnnouncementConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AnnouncementConnectWhere>;
};

export type CourseAnnouncementsConnectOrCreateFieldInput = {
  onCreate: CourseAnnouncementsConnectOrCreateFieldInputOnCreate;
  where: AnnouncementConnectOrCreateWhere;
};

export type CourseAnnouncementsConnectOrCreateFieldInputOnCreate = {
  node: AnnouncementOnCreateInput;
};

export type CourseAnnouncementsConnection = {
  __typename?: 'CourseAnnouncementsConnection';
  edges: Array<CourseAnnouncementsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CourseAnnouncementsConnectionSort = {
  node?: InputMaybe<AnnouncementSort>;
};

export type CourseAnnouncementsConnectionWhere = {
  AND?: InputMaybe<Array<CourseAnnouncementsConnectionWhere>>;
  NOT?: InputMaybe<CourseAnnouncementsConnectionWhere>;
  OR?: InputMaybe<Array<CourseAnnouncementsConnectionWhere>>;
  node?: InputMaybe<AnnouncementWhere>;
};

export type CourseAnnouncementsCreateFieldInput = {
  node: AnnouncementCreateInput;
};

export type CourseAnnouncementsDeleteFieldInput = {
  delete?: InputMaybe<AnnouncementDeleteInput>;
  where?: InputMaybe<CourseAnnouncementsConnectionWhere>;
};

export type CourseAnnouncementsDisconnectFieldInput = {
  disconnect?: InputMaybe<AnnouncementDisconnectInput>;
  where?: InputMaybe<CourseAnnouncementsConnectionWhere>;
};

export type CourseAnnouncementsFieldInput = {
  connect?: InputMaybe<Array<CourseAnnouncementsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CourseAnnouncementsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CourseAnnouncementsCreateFieldInput>>;
};

export type CourseAnnouncementsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CourseAnnouncementsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CourseAnnouncementsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CourseAnnouncementsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  message_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  message_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CourseAnnouncementsRelationship = {
  __typename?: 'CourseAnnouncementsRelationship';
  cursor: Scalars['String']['output'];
  node: Announcement;
};

export type CourseAnnouncementsUpdateConnectionInput = {
  node?: InputMaybe<AnnouncementUpdateInput>;
};

export type CourseAnnouncementsUpdateFieldInput = {
  connect?: InputMaybe<Array<CourseAnnouncementsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CourseAnnouncementsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CourseAnnouncementsCreateFieldInput>>;
  delete?: InputMaybe<Array<CourseAnnouncementsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CourseAnnouncementsDisconnectFieldInput>>;
  update?: InputMaybe<CourseAnnouncementsUpdateConnectionInput>;
  where?: InputMaybe<CourseAnnouncementsConnectionWhere>;
};

export type CourseAssignmentHasAssignmentAssignmentsAggregationSelection = {
  __typename?: 'CourseAssignmentHasAssignmentAssignmentsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CourseAssignmentHasAssignmentAssignmentsNodeAggregateSelection>;
};

export type CourseAssignmentHasAssignmentAssignmentsNodeAggregateSelection = {
  __typename?: 'CourseAssignmentHasAssignmentAssignmentsNodeAggregateSelection';
  _empty: StringAggregateSelection;
  allowed_attempts: FloatAggregateSelection;
  assignee_mode: StringAggregateSelection;
  assignment_group_id: FloatAggregateSelection;
  assignment_name: StringAggregateSelection;
  body: StringAggregateSelection;
  category_id: StringAggregateSelection;
  course_id: FloatAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  description: StringAggregateSelection;
  description_plaintext: StringAggregateSelection;
  discussion_topic_assignment_id: FloatAggregateSelection;
  discussion_topic_author_anonymous_id: StringAggregateSelection;
  discussion_topic_author_avatar_image_url: StringAggregateSelection;
  discussion_topic_author_display_name: StringAggregateSelection;
  discussion_topic_author_html_url: StringAggregateSelection;
  discussion_topic_author_id: FloatAggregateSelection;
  discussion_topic_created_at: StringAggregateSelection;
  discussion_topic_discussion_subentry_count: FloatAggregateSelection;
  discussion_topic_discussion_type: StringAggregateSelection;
  discussion_topic_html_url: StringAggregateSelection;
  discussion_topic_id: FloatAggregateSelection;
  discussion_topic_last_reply_at: StringAggregateSelection;
  discussion_topic_message: StringAggregateSelection;
  discussion_topic_posted_at: StringAggregateSelection;
  discussion_topic_read_state: StringAggregateSelection;
  discussion_topic_title: StringAggregateSelection;
  discussion_topic_unread_count: FloatAggregateSelection;
  discussion_topic_url: StringAggregateSelection;
  discussion_topic_user_name: StringAggregateSelection;
  display_date: StringAggregateSelection;
  due_at: StringAggregateSelection;
  due_date: DateTimeAggregateSelection;
  end_date: StringAggregateSelection;
  external_tool_tag_attributes_content_id: FloatAggregateSelection;
  external_tool_tag_attributes_content_type: StringAggregateSelection;
  external_tool_tag_attributes_external_data: StringAggregateSelection;
  external_tool_tag_attributes_resource_link_id: StringAggregateSelection;
  external_tool_tag_attributes_url: StringAggregateSelection;
  grade_points: FloatAggregateSelection;
  grader_count: FloatAggregateSelection;
  grading_type: StringAggregateSelection;
  html: StringAggregateSelection;
  html_url: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  lti_context_id: StringAggregateSelection;
  max_attempts: FloatAggregateSelection;
  max_name_length: FloatAggregateSelection;
  name: StringAggregateSelection;
  needs_grading_count: FloatAggregateSelection;
  objectives: StringAggregateSelection;
  points_possible: FloatAggregateSelection;
  position: FloatAggregateSelection;
  resource_metadata: StringAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  secure_params: StringAggregateSelection;
  session_id: StringAggregateSelection;
  start_date: StringAggregateSelection;
  state: StringAggregateSelection;
  submissions_download_url: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_at: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  url: StringAggregateSelection;
  videoUrl: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export type CourseAuditEventAuditEventsAggregationSelection = {
  __typename?: 'CourseAuditEventAuditEventsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CourseAuditEventAuditEventsNodeAggregateSelection>;
};

export type CourseAuditEventAuditEventsNodeAggregateSelection = {
  __typename?: 'CourseAuditEventAuditEventsNodeAggregateSelection';
  actorId: IdAggregateSelection;
  id: IdAggregateSelection;
  occurredAt: DateTimeAggregateSelection;
  relatedUserId: IdAggregateSelection;
  subjectId: IdAggregateSelection;
  subjectType: StringAggregateSelection;
  tenantId: IdAggregateSelection;
};

export type CourseAuditEventsAggregateInput = {
  AND?: InputMaybe<Array<CourseAuditEventsAggregateInput>>;
  NOT?: InputMaybe<CourseAuditEventsAggregateInput>;
  OR?: InputMaybe<Array<CourseAuditEventsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CourseAuditEventsNodeAggregationWhereInput>;
};

export type CourseAuditEventsConnectFieldInput = {
  connect?: InputMaybe<Array<AuditEventConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AuditEventConnectWhere>;
};

export type CourseAuditEventsConnectOrCreateFieldInput = {
  onCreate: CourseAuditEventsConnectOrCreateFieldInputOnCreate;
  where: AuditEventConnectOrCreateWhere;
};

export type CourseAuditEventsConnectOrCreateFieldInputOnCreate = {
  node: AuditEventOnCreateInput;
};

export type CourseAuditEventsConnection = {
  __typename?: 'CourseAuditEventsConnection';
  edges: Array<CourseAuditEventsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CourseAuditEventsConnectionSort = {
  node?: InputMaybe<AuditEventSort>;
};

export type CourseAuditEventsConnectionWhere = {
  AND?: InputMaybe<Array<CourseAuditEventsConnectionWhere>>;
  NOT?: InputMaybe<CourseAuditEventsConnectionWhere>;
  OR?: InputMaybe<Array<CourseAuditEventsConnectionWhere>>;
  node?: InputMaybe<AuditEventWhere>;
};

export type CourseAuditEventsCreateFieldInput = {
  node: AuditEventCreateInput;
};

export type CourseAuditEventsDeleteFieldInput = {
  delete?: InputMaybe<AuditEventDeleteInput>;
  where?: InputMaybe<CourseAuditEventsConnectionWhere>;
};

export type CourseAuditEventsDisconnectFieldInput = {
  disconnect?: InputMaybe<AuditEventDisconnectInput>;
  where?: InputMaybe<CourseAuditEventsConnectionWhere>;
};

export type CourseAuditEventsFieldInput = {
  connect?: InputMaybe<Array<CourseAuditEventsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CourseAuditEventsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CourseAuditEventsCreateFieldInput>>;
};

export type CourseAuditEventsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CourseAuditEventsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CourseAuditEventsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CourseAuditEventsNodeAggregationWhereInput>>;
  occurredAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  subjectType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subjectType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  subjectType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  subjectType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  subjectType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  subjectType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subjectType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subjectType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subjectType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subjectType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subjectType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subjectType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subjectType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subjectType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subjectType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CourseAuditEventsRelationship = {
  __typename?: 'CourseAuditEventsRelationship';
  cursor: Scalars['String']['output'];
  node: AuditEvent;
};

export type CourseAuditEventsUpdateConnectionInput = {
  node?: InputMaybe<AuditEventUpdateInput>;
};

export type CourseAuditEventsUpdateFieldInput = {
  connect?: InputMaybe<Array<CourseAuditEventsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CourseAuditEventsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CourseAuditEventsCreateFieldInput>>;
  delete?: InputMaybe<Array<CourseAuditEventsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CourseAuditEventsDisconnectFieldInput>>;
  update?: InputMaybe<CourseAuditEventsUpdateConnectionInput>;
  where?: InputMaybe<CourseAuditEventsConnectionWhere>;
};

export type CourseCategory = {
  __typename?: 'CourseCategory';
  coursesHasCourseCategories: Array<Course>;
  coursesHasCourseCategoriesAggregate?: Maybe<CourseCategoryCourseCoursesHasCourseCategoriesAggregationSelection>;
  coursesHasCourseCategoriesConnection: CourseCategoryCoursesHasCourseCategoriesConnection;
  created: Scalars['DateTime']['output'];
  hasAssignmentAssignments: Array<Assignment>;
  hasAssignmentAssignmentsAggregate?: Maybe<CourseCategoryAssignmentHasAssignmentAssignmentsAggregationSelection>;
  hasAssignmentAssignmentsConnection: CourseCategoryHasAssignmentAssignmentsConnection;
  id: Scalars['String']['output'];
  last_modified: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
};


export type CourseCategoryCoursesHasCourseCategoriesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CourseOptions>;
  where?: InputMaybe<CourseWhere>;
};


export type CourseCategoryCoursesHasCourseCategoriesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CourseWhere>;
};


export type CourseCategoryCoursesHasCourseCategoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CourseCategoryCoursesHasCourseCategoriesConnectionSort>>;
  where?: InputMaybe<CourseCategoryCoursesHasCourseCategoriesConnectionWhere>;
};


export type CourseCategoryHasAssignmentAssignmentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AssignmentOptions>;
  where?: InputMaybe<AssignmentWhere>;
};


export type CourseCategoryHasAssignmentAssignmentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssignmentWhere>;
};


export type CourseCategoryHasAssignmentAssignmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CourseCategoryHasAssignmentAssignmentsConnectionSort>>;
  where?: InputMaybe<CourseCategoryHasAssignmentAssignmentsConnectionWhere>;
};

export type CourseCategoryAssignmentHasAssignmentAssignmentsAggregationSelection = {
  __typename?: 'CourseCategoryAssignmentHasAssignmentAssignmentsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CourseCategoryAssignmentHasAssignmentAssignmentsNodeAggregateSelection>;
};

export type CourseCategoryAssignmentHasAssignmentAssignmentsNodeAggregateSelection = {
  __typename?: 'CourseCategoryAssignmentHasAssignmentAssignmentsNodeAggregateSelection';
  _empty: StringAggregateSelection;
  allowed_attempts: FloatAggregateSelection;
  assignee_mode: StringAggregateSelection;
  assignment_group_id: FloatAggregateSelection;
  assignment_name: StringAggregateSelection;
  body: StringAggregateSelection;
  category_id: StringAggregateSelection;
  course_id: FloatAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  description: StringAggregateSelection;
  description_plaintext: StringAggregateSelection;
  discussion_topic_assignment_id: FloatAggregateSelection;
  discussion_topic_author_anonymous_id: StringAggregateSelection;
  discussion_topic_author_avatar_image_url: StringAggregateSelection;
  discussion_topic_author_display_name: StringAggregateSelection;
  discussion_topic_author_html_url: StringAggregateSelection;
  discussion_topic_author_id: FloatAggregateSelection;
  discussion_topic_created_at: StringAggregateSelection;
  discussion_topic_discussion_subentry_count: FloatAggregateSelection;
  discussion_topic_discussion_type: StringAggregateSelection;
  discussion_topic_html_url: StringAggregateSelection;
  discussion_topic_id: FloatAggregateSelection;
  discussion_topic_last_reply_at: StringAggregateSelection;
  discussion_topic_message: StringAggregateSelection;
  discussion_topic_posted_at: StringAggregateSelection;
  discussion_topic_read_state: StringAggregateSelection;
  discussion_topic_title: StringAggregateSelection;
  discussion_topic_unread_count: FloatAggregateSelection;
  discussion_topic_url: StringAggregateSelection;
  discussion_topic_user_name: StringAggregateSelection;
  display_date: StringAggregateSelection;
  due_at: StringAggregateSelection;
  due_date: DateTimeAggregateSelection;
  end_date: StringAggregateSelection;
  external_tool_tag_attributes_content_id: FloatAggregateSelection;
  external_tool_tag_attributes_content_type: StringAggregateSelection;
  external_tool_tag_attributes_external_data: StringAggregateSelection;
  external_tool_tag_attributes_resource_link_id: StringAggregateSelection;
  external_tool_tag_attributes_url: StringAggregateSelection;
  grade_points: FloatAggregateSelection;
  grader_count: FloatAggregateSelection;
  grading_type: StringAggregateSelection;
  html: StringAggregateSelection;
  html_url: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  lti_context_id: StringAggregateSelection;
  max_attempts: FloatAggregateSelection;
  max_name_length: FloatAggregateSelection;
  name: StringAggregateSelection;
  needs_grading_count: FloatAggregateSelection;
  objectives: StringAggregateSelection;
  points_possible: FloatAggregateSelection;
  position: FloatAggregateSelection;
  resource_metadata: StringAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  secure_params: StringAggregateSelection;
  session_id: StringAggregateSelection;
  start_date: StringAggregateSelection;
  state: StringAggregateSelection;
  submissions_download_url: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_at: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  url: StringAggregateSelection;
  videoUrl: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export type CourseCategoryConnectInput = {
  coursesHasCourseCategories?: InputMaybe<Array<CourseCategoryCoursesHasCourseCategoriesConnectFieldInput>>;
  hasAssignmentAssignments?: InputMaybe<Array<CourseCategoryHasAssignmentAssignmentsConnectFieldInput>>;
};

export type CourseCategoryConnectWhere = {
  node: CourseCategoryWhere;
};

export type CourseCategoryCourseCoursesHasCourseCategoriesAggregationSelection = {
  __typename?: 'CourseCategoryCourseCoursesHasCourseCategoriesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CourseCategoryCourseCoursesHasCourseCategoriesNodeAggregateSelection>;
};

export type CourseCategoryCourseCoursesHasCourseCategoriesNodeAggregateSelection = {
  __typename?: 'CourseCategoryCourseCoursesHasCourseCategoriesNodeAggregateSelection';
  account_id: FloatAggregateSelection;
  calendar_ics: StringAggregateSelection;
  cost: FloatAggregateSelection;
  courseId: StringAggregateSelection;
  course_code: StringAggregateSelection;
  course_id: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  default_view: StringAggregateSelection;
  description: StringAggregateSelection;
  dueDateEndDate: DateTimeAggregateSelection;
  dueDateStartDate: DateTimeAggregateSelection;
  endDate: DateTimeAggregateSelection;
  end_at: StringAggregateSelection;
  enrollment_term_id: FloatAggregateSelection;
  grading_standard_id: FloatAggregateSelection;
  id: IdAggregateSelection;
  integration_id: StringAggregateSelection;
  label: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  learningStandards: StringAggregateSelection;
  lengthInWeeks: FloatAggregateSelection;
  license: StringAggregateSelection;
  lti_id: StringAggregateSelection;
  name: StringAggregateSelection;
  original_name: StringAggregateSelection;
  root_account_id: FloatAggregateSelection;
  sis_course_id: StringAggregateSelection;
  sis_import_id: FloatAggregateSelection;
  startDate: DateTimeAggregateSelection;
  start_at: StringAggregateSelection;
  state: StringAggregateSelection;
  storage_quota_mb: FloatAggregateSelection;
  stripePriceId: StringAggregateSelection;
  stripeProductId: StringAggregateSelection;
  targetAudience: StringAggregateSelection;
  thumbnail: StringAggregateSelection;
  time_zone: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  uuid: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export type CourseCategoryCoursesHasCourseCategoriesAggregateInput = {
  AND?: InputMaybe<Array<CourseCategoryCoursesHasCourseCategoriesAggregateInput>>;
  NOT?: InputMaybe<CourseCategoryCoursesHasCourseCategoriesAggregateInput>;
  OR?: InputMaybe<Array<CourseCategoryCoursesHasCourseCategoriesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CourseCategoryCoursesHasCourseCategoriesNodeAggregationWhereInput>;
};

export type CourseCategoryCoursesHasCourseCategoriesConnectFieldInput = {
  connect?: InputMaybe<Array<CourseConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CourseConnectWhere>;
};

export type CourseCategoryCoursesHasCourseCategoriesConnectOrCreateFieldInput = {
  onCreate: CourseCategoryCoursesHasCourseCategoriesConnectOrCreateFieldInputOnCreate;
  where: CourseConnectOrCreateWhere;
};

export type CourseCategoryCoursesHasCourseCategoriesConnectOrCreateFieldInputOnCreate = {
  node: CourseOnCreateInput;
};

export type CourseCategoryCoursesHasCourseCategoriesConnection = {
  __typename?: 'CourseCategoryCoursesHasCourseCategoriesConnection';
  edges: Array<CourseCategoryCoursesHasCourseCategoriesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CourseCategoryCoursesHasCourseCategoriesConnectionSort = {
  node?: InputMaybe<CourseSort>;
};

export type CourseCategoryCoursesHasCourseCategoriesConnectionWhere = {
  AND?: InputMaybe<Array<CourseCategoryCoursesHasCourseCategoriesConnectionWhere>>;
  NOT?: InputMaybe<CourseCategoryCoursesHasCourseCategoriesConnectionWhere>;
  OR?: InputMaybe<Array<CourseCategoryCoursesHasCourseCategoriesConnectionWhere>>;
  node?: InputMaybe<CourseWhere>;
};

export type CourseCategoryCoursesHasCourseCategoriesCreateFieldInput = {
  node: CourseCreateInput;
};

export type CourseCategoryCoursesHasCourseCategoriesDeleteFieldInput = {
  delete?: InputMaybe<CourseDeleteInput>;
  where?: InputMaybe<CourseCategoryCoursesHasCourseCategoriesConnectionWhere>;
};

export type CourseCategoryCoursesHasCourseCategoriesDisconnectFieldInput = {
  disconnect?: InputMaybe<CourseDisconnectInput>;
  where?: InputMaybe<CourseCategoryCoursesHasCourseCategoriesConnectionWhere>;
};

export type CourseCategoryCoursesHasCourseCategoriesFieldInput = {
  connect?: InputMaybe<Array<CourseCategoryCoursesHasCourseCategoriesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CourseCategoryCoursesHasCourseCategoriesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CourseCategoryCoursesHasCourseCategoriesCreateFieldInput>>;
};

export type CourseCategoryCoursesHasCourseCategoriesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CourseCategoryCoursesHasCourseCategoriesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CourseCategoryCoursesHasCourseCategoriesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CourseCategoryCoursesHasCourseCategoriesNodeAggregationWhereInput>>;
  account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  cost_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDateEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  enrollment_term_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  label_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningStandards_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthInWeeks_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  root_account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_import_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  startDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  storage_quota_mb_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CourseCategoryCoursesHasCourseCategoriesRelationship = {
  __typename?: 'CourseCategoryCoursesHasCourseCategoriesRelationship';
  cursor: Scalars['String']['output'];
  node: Course;
};

export type CourseCategoryCoursesHasCourseCategoriesUpdateConnectionInput = {
  node?: InputMaybe<CourseUpdateInput>;
};

export type CourseCategoryCoursesHasCourseCategoriesUpdateFieldInput = {
  connect?: InputMaybe<Array<CourseCategoryCoursesHasCourseCategoriesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CourseCategoryCoursesHasCourseCategoriesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CourseCategoryCoursesHasCourseCategoriesCreateFieldInput>>;
  delete?: InputMaybe<Array<CourseCategoryCoursesHasCourseCategoriesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CourseCategoryCoursesHasCourseCategoriesDisconnectFieldInput>>;
  update?: InputMaybe<CourseCategoryCoursesHasCourseCategoriesUpdateConnectionInput>;
  where?: InputMaybe<CourseCategoryCoursesHasCourseCategoriesConnectionWhere>;
};

export type CourseCategoryCreateInput = {
  coursesHasCourseCategories?: InputMaybe<CourseCategoryCoursesHasCourseCategoriesFieldInput>;
  created: Scalars['DateTime']['input'];
  hasAssignmentAssignments?: InputMaybe<CourseCategoryHasAssignmentAssignmentsFieldInput>;
  id: Scalars['String']['input'];
  last_modified: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
};

export type CourseCategoryDeleteInput = {
  coursesHasCourseCategories?: InputMaybe<Array<CourseCategoryCoursesHasCourseCategoriesDeleteFieldInput>>;
  hasAssignmentAssignments?: InputMaybe<Array<CourseCategoryHasAssignmentAssignmentsDeleteFieldInput>>;
};

export type CourseCategoryDisconnectInput = {
  coursesHasCourseCategories?: InputMaybe<Array<CourseCategoryCoursesHasCourseCategoriesDisconnectFieldInput>>;
  hasAssignmentAssignments?: InputMaybe<Array<CourseCategoryHasAssignmentAssignmentsDisconnectFieldInput>>;
};

export type CourseCategoryHasAssignmentAssignmentsAggregateInput = {
  AND?: InputMaybe<Array<CourseCategoryHasAssignmentAssignmentsAggregateInput>>;
  NOT?: InputMaybe<CourseCategoryHasAssignmentAssignmentsAggregateInput>;
  OR?: InputMaybe<Array<CourseCategoryHasAssignmentAssignmentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CourseCategoryHasAssignmentAssignmentsNodeAggregationWhereInput>;
};

export type CourseCategoryHasAssignmentAssignmentsConnectFieldInput = {
  connect?: InputMaybe<Array<AssignmentConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AssignmentConnectWhere>;
};

export type CourseCategoryHasAssignmentAssignmentsConnectOrCreateFieldInput = {
  onCreate: CourseCategoryHasAssignmentAssignmentsConnectOrCreateFieldInputOnCreate;
  where: AssignmentConnectOrCreateWhere;
};

export type CourseCategoryHasAssignmentAssignmentsConnectOrCreateFieldInputOnCreate = {
  node: AssignmentOnCreateInput;
};

export type CourseCategoryHasAssignmentAssignmentsConnection = {
  __typename?: 'CourseCategoryHasAssignmentAssignmentsConnection';
  edges: Array<CourseCategoryHasAssignmentAssignmentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CourseCategoryHasAssignmentAssignmentsConnectionSort = {
  node?: InputMaybe<AssignmentSort>;
};

export type CourseCategoryHasAssignmentAssignmentsConnectionWhere = {
  AND?: InputMaybe<Array<CourseCategoryHasAssignmentAssignmentsConnectionWhere>>;
  NOT?: InputMaybe<CourseCategoryHasAssignmentAssignmentsConnectionWhere>;
  OR?: InputMaybe<Array<CourseCategoryHasAssignmentAssignmentsConnectionWhere>>;
  node?: InputMaybe<AssignmentWhere>;
};

export type CourseCategoryHasAssignmentAssignmentsCreateFieldInput = {
  node: AssignmentCreateInput;
};

export type CourseCategoryHasAssignmentAssignmentsDeleteFieldInput = {
  delete?: InputMaybe<AssignmentDeleteInput>;
  where?: InputMaybe<CourseCategoryHasAssignmentAssignmentsConnectionWhere>;
};

export type CourseCategoryHasAssignmentAssignmentsDisconnectFieldInput = {
  disconnect?: InputMaybe<AssignmentDisconnectInput>;
  where?: InputMaybe<CourseCategoryHasAssignmentAssignmentsConnectionWhere>;
};

export type CourseCategoryHasAssignmentAssignmentsFieldInput = {
  connect?: InputMaybe<Array<CourseCategoryHasAssignmentAssignmentsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CourseCategoryHasAssignmentAssignmentsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CourseCategoryHasAssignmentAssignmentsCreateFieldInput>>;
};

export type CourseCategoryHasAssignmentAssignmentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CourseCategoryHasAssignmentAssignmentsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CourseCategoryHasAssignmentAssignmentsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CourseCategoryHasAssignmentAssignmentsNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  allowed_attempts_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_group_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  body_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  category_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_assignment_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_unread_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  display_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  due_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_date_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_points_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  html_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lti_context_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  max_attempts_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  needs_grading_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  points_possible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  secure_params_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  secure_params_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  session_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CourseCategoryHasAssignmentAssignmentsRelationship = {
  __typename?: 'CourseCategoryHasAssignmentAssignmentsRelationship';
  cursor: Scalars['String']['output'];
  node: Assignment;
};

export type CourseCategoryHasAssignmentAssignmentsUpdateConnectionInput = {
  node?: InputMaybe<AssignmentUpdateInput>;
};

export type CourseCategoryHasAssignmentAssignmentsUpdateFieldInput = {
  connect?: InputMaybe<Array<CourseCategoryHasAssignmentAssignmentsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CourseCategoryHasAssignmentAssignmentsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CourseCategoryHasAssignmentAssignmentsCreateFieldInput>>;
  delete?: InputMaybe<Array<CourseCategoryHasAssignmentAssignmentsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CourseCategoryHasAssignmentAssignmentsDisconnectFieldInput>>;
  update?: InputMaybe<CourseCategoryHasAssignmentAssignmentsUpdateConnectionInput>;
  where?: InputMaybe<CourseCategoryHasAssignmentAssignmentsConnectionWhere>;
};

export type CourseCategoryOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CourseCategorySort objects to sort CourseCategories by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CourseCategorySort>>;
};

/** Fields to sort CourseCategories by. The order in which sorts are applied is not guaranteed when specifying many fields in one CourseCategorySort object. */
export type CourseCategorySort = {
  created?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  last_modified?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
};

export type CourseCategoryUpdateInput = {
  coursesHasCourseCategories?: InputMaybe<Array<CourseCategoryCoursesHasCourseCategoriesUpdateFieldInput>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  hasAssignmentAssignments?: InputMaybe<Array<CourseCategoryHasAssignmentAssignmentsUpdateFieldInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CourseCategoryWhere = {
  AND?: InputMaybe<Array<CourseCategoryWhere>>;
  NOT?: InputMaybe<CourseCategoryWhere>;
  OR?: InputMaybe<Array<CourseCategoryWhere>>;
  coursesHasCourseCategoriesAggregate?: InputMaybe<CourseCategoryCoursesHasCourseCategoriesAggregateInput>;
  /** Return CourseCategories where all of the related CourseCategoryCoursesHasCourseCategoriesConnections match this filter */
  coursesHasCourseCategoriesConnection_ALL?: InputMaybe<CourseCategoryCoursesHasCourseCategoriesConnectionWhere>;
  /** Return CourseCategories where none of the related CourseCategoryCoursesHasCourseCategoriesConnections match this filter */
  coursesHasCourseCategoriesConnection_NONE?: InputMaybe<CourseCategoryCoursesHasCourseCategoriesConnectionWhere>;
  /** Return CourseCategories where one of the related CourseCategoryCoursesHasCourseCategoriesConnections match this filter */
  coursesHasCourseCategoriesConnection_SINGLE?: InputMaybe<CourseCategoryCoursesHasCourseCategoriesConnectionWhere>;
  /** Return CourseCategories where some of the related CourseCategoryCoursesHasCourseCategoriesConnections match this filter */
  coursesHasCourseCategoriesConnection_SOME?: InputMaybe<CourseCategoryCoursesHasCourseCategoriesConnectionWhere>;
  /** Return CourseCategories where all of the related Courses match this filter */
  coursesHasCourseCategories_ALL?: InputMaybe<CourseWhere>;
  /** Return CourseCategories where none of the related Courses match this filter */
  coursesHasCourseCategories_NONE?: InputMaybe<CourseWhere>;
  /** Return CourseCategories where one of the related Courses match this filter */
  coursesHasCourseCategories_SINGLE?: InputMaybe<CourseWhere>;
  /** Return CourseCategories where some of the related Courses match this filter */
  coursesHasCourseCategories_SOME?: InputMaybe<CourseWhere>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  hasAssignmentAssignmentsAggregate?: InputMaybe<CourseCategoryHasAssignmentAssignmentsAggregateInput>;
  /** Return CourseCategories where all of the related CourseCategoryHasAssignmentAssignmentsConnections match this filter */
  hasAssignmentAssignmentsConnection_ALL?: InputMaybe<CourseCategoryHasAssignmentAssignmentsConnectionWhere>;
  /** Return CourseCategories where none of the related CourseCategoryHasAssignmentAssignmentsConnections match this filter */
  hasAssignmentAssignmentsConnection_NONE?: InputMaybe<CourseCategoryHasAssignmentAssignmentsConnectionWhere>;
  /** Return CourseCategories where one of the related CourseCategoryHasAssignmentAssignmentsConnections match this filter */
  hasAssignmentAssignmentsConnection_SINGLE?: InputMaybe<CourseCategoryHasAssignmentAssignmentsConnectionWhere>;
  /** Return CourseCategories where some of the related CourseCategoryHasAssignmentAssignmentsConnections match this filter */
  hasAssignmentAssignmentsConnection_SOME?: InputMaybe<CourseCategoryHasAssignmentAssignmentsConnectionWhere>;
  /** Return CourseCategories where all of the related Assignments match this filter */
  hasAssignmentAssignments_ALL?: InputMaybe<AssignmentWhere>;
  /** Return CourseCategories where none of the related Assignments match this filter */
  hasAssignmentAssignments_NONE?: InputMaybe<AssignmentWhere>;
  /** Return CourseCategories where one of the related Assignments match this filter */
  hasAssignmentAssignments_SINGLE?: InputMaybe<AssignmentWhere>;
  /** Return CourseCategories where some of the related Assignments match this filter */
  hasAssignmentAssignments_SOME?: InputMaybe<AssignmentWhere>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  id_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  last_modified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type CourseCompletionDetails = {
  __typename?: 'CourseCompletionDetails';
  completionStats: CompletionStats;
  details: CourseCompletionDetailsData;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type CourseCompletionDetailsData = {
  __typename?: 'CourseCompletionDetailsData';
  modules: Array<ModuleCompletionDetails>;
};

export type CourseCompletionDetailsResponse = {
  __typename?: 'CourseCompletionDetailsResponse';
  count: Scalars['Int']['output'];
  data: Array<CourseCompletionDetails>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CourseCompletionSummary = {
  __typename?: 'CourseCompletionSummary';
  completionStats: CompletionStats;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type CourseCompletionSummaryResponse = {
  __typename?: 'CourseCompletionSummaryResponse';
  count: Scalars['Int']['output'];
  data: Array<CourseCompletionSummary>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CourseConnectInput = {
  announcements?: InputMaybe<Array<CourseAnnouncementsConnectFieldInput>>;
  auditEvents?: InputMaybe<Array<CourseAuditEventsConnectFieldInput>>;
  degreesHasCourse?: InputMaybe<Array<CourseDegreesHasCourseConnectFieldInput>>;
  documents?: InputMaybe<Array<CourseDocumentsConnectFieldInput>>;
  enrolledStudents?: InputMaybe<Array<CourseEnrolledStudentsConnectFieldInput>>;
  enrollmentLink?: InputMaybe<CourseEnrollmentLinkConnectFieldInput>;
  evaluations?: InputMaybe<Array<CourseEvaluationsConnectFieldInput>>;
  externalIntegrations?: InputMaybe<Array<CourseExternalIntegrationsConnectFieldInput>>;
  forum?: InputMaybe<CourseForumConnectFieldInput>;
  hasAssignmentAssignments?: InputMaybe<Array<CourseHasAssignmentAssignmentsConnectFieldInput>>;
  hasCourseCategoriesCourseCategories?: InputMaybe<Array<CourseHasCourseCategoriesCourseCategoriesConnectFieldInput>>;
  hasPagePages?: InputMaybe<Array<CourseHasPagePagesConnectFieldInput>>;
  modules?: InputMaybe<Array<CourseModulesConnectFieldInput>>;
  nudgesAboutThis?: InputMaybe<Array<CourseNudgesAboutThisConnectFieldInput>>;
  preRequisiteFor?: InputMaybe<Array<CoursePreRequisiteForConnectFieldInput>>;
  preRequisites?: InputMaybe<Array<CoursePreRequisitesConnectFieldInput>>;
  schoolsHasCourse?: InputMaybe<Array<CourseSchoolsHasCourseConnectFieldInput>>;
  teachingFaculty?: InputMaybe<Array<CourseTeachingFacultyConnectFieldInput>>;
  usersHasSchoolCourse?: InputMaybe<Array<CourseUsersHasSchoolCourseConnectFieldInput>>;
  usersHaveLearningPayment?: InputMaybe<Array<CourseUsersHaveLearningPaymentConnectFieldInput>>;
  workspaces?: InputMaybe<Array<CourseWorkspacesConnectFieldInput>>;
};

export type CourseConnectOrCreateWhere = {
  node: CourseUniqueWhere;
};

export type CourseConnectWhere = {
  node: CourseWhere;
};

export type CourseCourseCategoryHasCourseCategoriesCourseCategoriesAggregationSelection = {
  __typename?: 'CourseCourseCategoryHasCourseCategoriesCourseCategoriesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CourseCourseCategoryHasCourseCategoriesCourseCategoriesNodeAggregateSelection>;
};

export type CourseCourseCategoryHasCourseCategoriesCourseCategoriesNodeAggregateSelection = {
  __typename?: 'CourseCourseCategoryHasCourseCategoriesCourseCategoriesNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  title: StringAggregateSelection;
};

export type CourseCourseEvaluationEvaluationsAggregationSelection = {
  __typename?: 'CourseCourseEvaluationEvaluationsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CourseCourseEvaluationEvaluationsNodeAggregateSelection>;
};

export type CourseCourseEvaluationEvaluationsNodeAggregateSelection = {
  __typename?: 'CourseCourseEvaluationEvaluationsNodeAggregateSelection';
  assignmentEvaluationJson: StringAggregateSelection;
  courseId: IdAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  curriculumEvaluationJson: StringAggregateSelection;
  id: IdAggregateSelection;
  jobId: IdAggregateSelection;
  overallSummary: StringAggregateSelection;
  status: StringAggregateSelection;
};

export type CourseCourseExternalIntegrationExternalIntegrationsAggregationSelection = {
  __typename?: 'CourseCourseExternalIntegrationExternalIntegrationsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CourseCourseExternalIntegrationExternalIntegrationsNodeAggregateSelection>;
};

export type CourseCourseExternalIntegrationExternalIntegrationsNodeAggregateSelection = {
  __typename?: 'CourseCourseExternalIntegrationExternalIntegrationsNodeAggregateSelection';
  externalIntegrationId: StringAggregateSelection;
  id: IdAggregateSelection;
};

export type CourseCoursePreRequisiteForAggregationSelection = {
  __typename?: 'CourseCoursePreRequisiteForAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CourseCoursePreRequisiteForNodeAggregateSelection>;
};

export type CourseCoursePreRequisiteForNodeAggregateSelection = {
  __typename?: 'CourseCoursePreRequisiteForNodeAggregateSelection';
  account_id: FloatAggregateSelection;
  calendar_ics: StringAggregateSelection;
  cost: FloatAggregateSelection;
  courseId: StringAggregateSelection;
  course_code: StringAggregateSelection;
  course_id: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  default_view: StringAggregateSelection;
  description: StringAggregateSelection;
  dueDateEndDate: DateTimeAggregateSelection;
  dueDateStartDate: DateTimeAggregateSelection;
  endDate: DateTimeAggregateSelection;
  end_at: StringAggregateSelection;
  enrollment_term_id: FloatAggregateSelection;
  grading_standard_id: FloatAggregateSelection;
  id: IdAggregateSelection;
  integration_id: StringAggregateSelection;
  label: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  learningStandards: StringAggregateSelection;
  lengthInWeeks: FloatAggregateSelection;
  license: StringAggregateSelection;
  lti_id: StringAggregateSelection;
  name: StringAggregateSelection;
  original_name: StringAggregateSelection;
  root_account_id: FloatAggregateSelection;
  sis_course_id: StringAggregateSelection;
  sis_import_id: FloatAggregateSelection;
  startDate: DateTimeAggregateSelection;
  start_at: StringAggregateSelection;
  state: StringAggregateSelection;
  storage_quota_mb: FloatAggregateSelection;
  stripePriceId: StringAggregateSelection;
  stripeProductId: StringAggregateSelection;
  targetAudience: StringAggregateSelection;
  thumbnail: StringAggregateSelection;
  time_zone: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  uuid: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export type CourseCoursePreRequisitesAggregationSelection = {
  __typename?: 'CourseCoursePreRequisitesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CourseCoursePreRequisitesNodeAggregateSelection>;
};

export type CourseCoursePreRequisitesNodeAggregateSelection = {
  __typename?: 'CourseCoursePreRequisitesNodeAggregateSelection';
  account_id: FloatAggregateSelection;
  calendar_ics: StringAggregateSelection;
  cost: FloatAggregateSelection;
  courseId: StringAggregateSelection;
  course_code: StringAggregateSelection;
  course_id: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  default_view: StringAggregateSelection;
  description: StringAggregateSelection;
  dueDateEndDate: DateTimeAggregateSelection;
  dueDateStartDate: DateTimeAggregateSelection;
  endDate: DateTimeAggregateSelection;
  end_at: StringAggregateSelection;
  enrollment_term_id: FloatAggregateSelection;
  grading_standard_id: FloatAggregateSelection;
  id: IdAggregateSelection;
  integration_id: StringAggregateSelection;
  label: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  learningStandards: StringAggregateSelection;
  lengthInWeeks: FloatAggregateSelection;
  license: StringAggregateSelection;
  lti_id: StringAggregateSelection;
  name: StringAggregateSelection;
  original_name: StringAggregateSelection;
  root_account_id: FloatAggregateSelection;
  sis_course_id: StringAggregateSelection;
  sis_import_id: FloatAggregateSelection;
  startDate: DateTimeAggregateSelection;
  start_at: StringAggregateSelection;
  state: StringAggregateSelection;
  storage_quota_mb: FloatAggregateSelection;
  stripePriceId: StringAggregateSelection;
  stripeProductId: StringAggregateSelection;
  targetAudience: StringAggregateSelection;
  thumbnail: StringAggregateSelection;
  time_zone: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  uuid: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export type CourseCreateInput = {
  account_id?: InputMaybe<Scalars['Float']['input']>;
  announcements?: InputMaybe<CourseAnnouncementsFieldInput>;
  apply_assignment_group_weights?: InputMaybe<Scalars['Boolean']['input']>;
  auditEvents?: InputMaybe<CourseAuditEventsFieldInput>;
  blueprint?: InputMaybe<Scalars['Boolean']['input']>;
  calendar_ics?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<Scalars['Float']['input']>;
  courseId?: InputMaybe<Scalars['String']['input']>;
  course_code?: InputMaybe<Scalars['String']['input']>;
  course_id?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_at?: InputMaybe<Scalars['String']['input']>;
  created_date?: InputMaybe<Scalars['String']['input']>;
  default_view?: InputMaybe<Scalars['String']['input']>;
  degreesHasCourse?: InputMaybe<CourseDegreesHasCourseFieldInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<CourseDocumentsFieldInput>;
  dueDateEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  end_at?: InputMaybe<Scalars['String']['input']>;
  enrolledStudents?: InputMaybe<CourseEnrolledStudentsFieldInput>;
  enrollmentLink?: InputMaybe<CourseEnrollmentLinkFieldInput>;
  enrollment_term_id?: InputMaybe<Scalars['Float']['input']>;
  evaluations?: InputMaybe<CourseEvaluationsFieldInput>;
  externalIntegrations?: InputMaybe<CourseExternalIntegrationsFieldInput>;
  forum?: InputMaybe<CourseForumFieldInput>;
  generationStatus?: InputMaybe<CourseGenerationStatus>;
  grading_standard_id?: InputMaybe<Scalars['Float']['input']>;
  hasAssignmentAssignments?: InputMaybe<CourseHasAssignmentAssignmentsFieldInput>;
  hasCourseCategoriesCourseCategories?: InputMaybe<CourseHasCourseCategoriesCourseCategoriesFieldInput>;
  hasPagePages?: InputMaybe<CourseHasPagePagesFieldInput>;
  hide_final_grades?: InputMaybe<Scalars['Boolean']['input']>;
  homeroom_course?: InputMaybe<Scalars['Boolean']['input']>;
  integration_id?: InputMaybe<Scalars['String']['input']>;
  isCustomCourse?: InputMaybe<Scalars['Boolean']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isEnrollmentAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  is_elective?: InputMaybe<Scalars['Boolean']['input']>;
  is_public?: InputMaybe<Scalars['Boolean']['input']>;
  is_public_to_auth_users?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  learningStandards?: InputMaybe<Scalars['String']['input']>;
  lengthInWeeks?: InputMaybe<Scalars['Float']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  lti_id?: InputMaybe<Scalars['String']['input']>;
  moduleOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  modules?: InputMaybe<CourseModulesFieldInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  nudgesAboutThis?: InputMaybe<CourseNudgesAboutThisFieldInput>;
  objectives?: InputMaybe<Array<Scalars['String']['input']>>;
  original_name?: InputMaybe<Scalars['String']['input']>;
  period_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  periods?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preRequisiteFor?: InputMaybe<CoursePreRequisiteForFieldInput>;
  preRequisites?: InputMaybe<CoursePreRequisitesFieldInput>;
  public_syllabus?: InputMaybe<Scalars['Boolean']['input']>;
  public_syllabus_to_auth?: InputMaybe<Scalars['Boolean']['input']>;
  restrict_enrollments_to_course_dates?: InputMaybe<Scalars['Boolean']['input']>;
  root_account_id?: InputMaybe<Scalars['Float']['input']>;
  schoolsHasCourse?: InputMaybe<CourseSchoolsHasCourseFieldInput>;
  sis_course_id?: InputMaybe<Scalars['String']['input']>;
  sis_import_id?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  start_at?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  storage_quota_mb?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId?: InputMaybe<Scalars['String']['input']>;
  stripeProductId?: InputMaybe<Scalars['String']['input']>;
  targetAudience?: InputMaybe<Scalars['String']['input']>;
  teachingFaculty?: InputMaybe<CourseTeachingFacultyFieldInput>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  time_zone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['String']['input']>;
  usersHasSchoolCourse?: InputMaybe<CourseUsersHasSchoolCourseFieldInput>;
  usersHaveLearningPayment?: InputMaybe<CourseUsersHaveLearningPaymentFieldInput>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  workflow_state?: InputMaybe<Scalars['String']['input']>;
  workspaces?: InputMaybe<CourseWorkspacesFieldInput>;
};

export type CourseCreationResponse = {
  __typename?: 'CourseCreationResponse';
  data?: Maybe<Curriculum>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CourseDegreeDegreesHasCourseAggregationSelection = {
  __typename?: 'CourseDegreeDegreesHasCourseAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CourseDegreeDegreesHasCourseNodeAggregateSelection>;
};

export type CourseDegreeDegreesHasCourseNodeAggregateSelection = {
  __typename?: 'CourseDegreeDegreesHasCourseNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  id: IdAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  name: StringAggregateSelection;
};

export type CourseDegreesHasCourseAggregateInput = {
  AND?: InputMaybe<Array<CourseDegreesHasCourseAggregateInput>>;
  NOT?: InputMaybe<CourseDegreesHasCourseAggregateInput>;
  OR?: InputMaybe<Array<CourseDegreesHasCourseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CourseDegreesHasCourseNodeAggregationWhereInput>;
};

export type CourseDegreesHasCourseConnectFieldInput = {
  connect?: InputMaybe<Array<DegreeConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DegreeConnectWhere>;
};

export type CourseDegreesHasCourseConnectOrCreateFieldInput = {
  onCreate: CourseDegreesHasCourseConnectOrCreateFieldInputOnCreate;
  where: DegreeConnectOrCreateWhere;
};

export type CourseDegreesHasCourseConnectOrCreateFieldInputOnCreate = {
  node: DegreeOnCreateInput;
};

export type CourseDegreesHasCourseConnection = {
  __typename?: 'CourseDegreesHasCourseConnection';
  edges: Array<CourseDegreesHasCourseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CourseDegreesHasCourseConnectionSort = {
  node?: InputMaybe<DegreeSort>;
};

export type CourseDegreesHasCourseConnectionWhere = {
  AND?: InputMaybe<Array<CourseDegreesHasCourseConnectionWhere>>;
  NOT?: InputMaybe<CourseDegreesHasCourseConnectionWhere>;
  OR?: InputMaybe<Array<CourseDegreesHasCourseConnectionWhere>>;
  node?: InputMaybe<DegreeWhere>;
};

export type CourseDegreesHasCourseCreateFieldInput = {
  node: DegreeCreateInput;
};

export type CourseDegreesHasCourseDeleteFieldInput = {
  delete?: InputMaybe<DegreeDeleteInput>;
  where?: InputMaybe<CourseDegreesHasCourseConnectionWhere>;
};

export type CourseDegreesHasCourseDisconnectFieldInput = {
  disconnect?: InputMaybe<DegreeDisconnectInput>;
  where?: InputMaybe<CourseDegreesHasCourseConnectionWhere>;
};

export type CourseDegreesHasCourseFieldInput = {
  connect?: InputMaybe<Array<CourseDegreesHasCourseConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CourseDegreesHasCourseConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CourseDegreesHasCourseCreateFieldInput>>;
};

export type CourseDegreesHasCourseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CourseDegreesHasCourseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CourseDegreesHasCourseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CourseDegreesHasCourseNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CourseDegreesHasCourseRelationship = {
  __typename?: 'CourseDegreesHasCourseRelationship';
  cursor: Scalars['String']['output'];
  node: Degree;
};

export type CourseDegreesHasCourseUpdateConnectionInput = {
  node?: InputMaybe<DegreeUpdateInput>;
};

export type CourseDegreesHasCourseUpdateFieldInput = {
  connect?: InputMaybe<Array<CourseDegreesHasCourseConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CourseDegreesHasCourseConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CourseDegreesHasCourseCreateFieldInput>>;
  delete?: InputMaybe<Array<CourseDegreesHasCourseDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CourseDegreesHasCourseDisconnectFieldInput>>;
  update?: InputMaybe<CourseDegreesHasCourseUpdateConnectionInput>;
  where?: InputMaybe<CourseDegreesHasCourseConnectionWhere>;
};

export type CourseDeleteInput = {
  announcements?: InputMaybe<Array<CourseAnnouncementsDeleteFieldInput>>;
  auditEvents?: InputMaybe<Array<CourseAuditEventsDeleteFieldInput>>;
  degreesHasCourse?: InputMaybe<Array<CourseDegreesHasCourseDeleteFieldInput>>;
  documents?: InputMaybe<Array<CourseDocumentsDeleteFieldInput>>;
  enrolledStudents?: InputMaybe<Array<CourseEnrolledStudentsDeleteFieldInput>>;
  enrollmentLink?: InputMaybe<CourseEnrollmentLinkDeleteFieldInput>;
  evaluations?: InputMaybe<Array<CourseEvaluationsDeleteFieldInput>>;
  externalIntegrations?: InputMaybe<Array<CourseExternalIntegrationsDeleteFieldInput>>;
  forum?: InputMaybe<CourseForumDeleteFieldInput>;
  hasAssignmentAssignments?: InputMaybe<Array<CourseHasAssignmentAssignmentsDeleteFieldInput>>;
  hasCourseCategoriesCourseCategories?: InputMaybe<Array<CourseHasCourseCategoriesCourseCategoriesDeleteFieldInput>>;
  hasPagePages?: InputMaybe<Array<CourseHasPagePagesDeleteFieldInput>>;
  modules?: InputMaybe<Array<CourseModulesDeleteFieldInput>>;
  nudgesAboutThis?: InputMaybe<Array<CourseNudgesAboutThisDeleteFieldInput>>;
  preRequisiteFor?: InputMaybe<Array<CoursePreRequisiteForDeleteFieldInput>>;
  preRequisites?: InputMaybe<Array<CoursePreRequisitesDeleteFieldInput>>;
  schoolsHasCourse?: InputMaybe<Array<CourseSchoolsHasCourseDeleteFieldInput>>;
  teachingFaculty?: InputMaybe<Array<CourseTeachingFacultyDeleteFieldInput>>;
  usersHasSchoolCourse?: InputMaybe<Array<CourseUsersHasSchoolCourseDeleteFieldInput>>;
  usersHaveLearningPayment?: InputMaybe<Array<CourseUsersHaveLearningPaymentDeleteFieldInput>>;
  workspaces?: InputMaybe<Array<CourseWorkspacesDeleteFieldInput>>;
};

export type CourseDetailedAnalytics = {
  __typename?: 'CourseDetailedAnalytics';
  active_interaction_count: Scalars['Int']['output'];
  average_time_taken?: Maybe<Scalars['Float']['output']>;
  confusion_points: Scalars['Int']['output'];
  details: CourseAnalyticsDetails;
  distractions: Scalars['Int']['output'];
  enrollment: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  questions_asked: Scalars['Int']['output'];
  sentiment: Scalars['String']['output'];
  success_points: Scalars['Int']['output'];
};

export type CourseDetailedResponse = {
  __typename?: 'CourseDetailedResponse';
  count: Scalars['Int']['output'];
  data: Array<CourseDetailedAnalytics>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CourseDisconnectInput = {
  announcements?: InputMaybe<Array<CourseAnnouncementsDisconnectFieldInput>>;
  auditEvents?: InputMaybe<Array<CourseAuditEventsDisconnectFieldInput>>;
  degreesHasCourse?: InputMaybe<Array<CourseDegreesHasCourseDisconnectFieldInput>>;
  documents?: InputMaybe<Array<CourseDocumentsDisconnectFieldInput>>;
  enrolledStudents?: InputMaybe<Array<CourseEnrolledStudentsDisconnectFieldInput>>;
  enrollmentLink?: InputMaybe<CourseEnrollmentLinkDisconnectFieldInput>;
  evaluations?: InputMaybe<Array<CourseEvaluationsDisconnectFieldInput>>;
  externalIntegrations?: InputMaybe<Array<CourseExternalIntegrationsDisconnectFieldInput>>;
  forum?: InputMaybe<CourseForumDisconnectFieldInput>;
  hasAssignmentAssignments?: InputMaybe<Array<CourseHasAssignmentAssignmentsDisconnectFieldInput>>;
  hasCourseCategoriesCourseCategories?: InputMaybe<Array<CourseHasCourseCategoriesCourseCategoriesDisconnectFieldInput>>;
  hasPagePages?: InputMaybe<Array<CourseHasPagePagesDisconnectFieldInput>>;
  modules?: InputMaybe<Array<CourseModulesDisconnectFieldInput>>;
  nudgesAboutThis?: InputMaybe<Array<CourseNudgesAboutThisDisconnectFieldInput>>;
  preRequisiteFor?: InputMaybe<Array<CoursePreRequisiteForDisconnectFieldInput>>;
  preRequisites?: InputMaybe<Array<CoursePreRequisitesDisconnectFieldInput>>;
  schoolsHasCourse?: InputMaybe<Array<CourseSchoolsHasCourseDisconnectFieldInput>>;
  teachingFaculty?: InputMaybe<Array<CourseTeachingFacultyDisconnectFieldInput>>;
  usersHasSchoolCourse?: InputMaybe<Array<CourseUsersHasSchoolCourseDisconnectFieldInput>>;
  usersHaveLearningPayment?: InputMaybe<Array<CourseUsersHaveLearningPaymentDisconnectFieldInput>>;
  workspaces?: InputMaybe<Array<CourseWorkspacesDisconnectFieldInput>>;
};

export type CourseDocumentDocumentsAggregationSelection = {
  __typename?: 'CourseDocumentDocumentsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CourseDocumentDocumentsNodeAggregateSelection>;
};

export type CourseDocumentDocumentsNodeAggregateSelection = {
  __typename?: 'CourseDocumentDocumentsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  summary: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type CourseDocumentsAggregateInput = {
  AND?: InputMaybe<Array<CourseDocumentsAggregateInput>>;
  NOT?: InputMaybe<CourseDocumentsAggregateInput>;
  OR?: InputMaybe<Array<CourseDocumentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CourseDocumentsNodeAggregationWhereInput>;
};

export type CourseDocumentsConnectFieldInput = {
  connect?: InputMaybe<Array<DocumentConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DocumentConnectWhere>;
};

export type CourseDocumentsConnection = {
  __typename?: 'CourseDocumentsConnection';
  edges: Array<CourseDocumentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CourseDocumentsConnectionSort = {
  node?: InputMaybe<DocumentSort>;
};

export type CourseDocumentsConnectionWhere = {
  AND?: InputMaybe<Array<CourseDocumentsConnectionWhere>>;
  NOT?: InputMaybe<CourseDocumentsConnectionWhere>;
  OR?: InputMaybe<Array<CourseDocumentsConnectionWhere>>;
  node?: InputMaybe<DocumentWhere>;
};

export type CourseDocumentsCreateFieldInput = {
  node: DocumentCreateInput;
};

export type CourseDocumentsDeleteFieldInput = {
  delete?: InputMaybe<DocumentDeleteInput>;
  where?: InputMaybe<CourseDocumentsConnectionWhere>;
};

export type CourseDocumentsDisconnectFieldInput = {
  disconnect?: InputMaybe<DocumentDisconnectInput>;
  where?: InputMaybe<CourseDocumentsConnectionWhere>;
};

export type CourseDocumentsFieldInput = {
  connect?: InputMaybe<Array<CourseDocumentsConnectFieldInput>>;
  create?: InputMaybe<Array<CourseDocumentsCreateFieldInput>>;
};

export type CourseDocumentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CourseDocumentsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CourseDocumentsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CourseDocumentsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  summary_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  summary_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CourseDocumentsRelationship = {
  __typename?: 'CourseDocumentsRelationship';
  cursor: Scalars['String']['output'];
  node: Document;
};

export type CourseDocumentsUpdateConnectionInput = {
  node?: InputMaybe<DocumentUpdateInput>;
};

export type CourseDocumentsUpdateFieldInput = {
  connect?: InputMaybe<Array<CourseDocumentsConnectFieldInput>>;
  create?: InputMaybe<Array<CourseDocumentsCreateFieldInput>>;
  delete?: InputMaybe<Array<CourseDocumentsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CourseDocumentsDisconnectFieldInput>>;
  update?: InputMaybe<CourseDocumentsUpdateConnectionInput>;
  where?: InputMaybe<CourseDocumentsConnectionWhere>;
};

export type CourseEnrolledStudentsAggregateInput = {
  AND?: InputMaybe<Array<CourseEnrolledStudentsAggregateInput>>;
  NOT?: InputMaybe<CourseEnrolledStudentsAggregateInput>;
  OR?: InputMaybe<Array<CourseEnrolledStudentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<EnrolledInPropertiesAggregationWhereInput>;
  node?: InputMaybe<CourseEnrolledStudentsNodeAggregationWhereInput>;
};

export type CourseEnrolledStudentsConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  edge: EnrolledInPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type CourseEnrolledStudentsConnectOrCreateFieldInput = {
  onCreate: CourseEnrolledStudentsConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type CourseEnrolledStudentsConnectOrCreateFieldInputOnCreate = {
  edge: EnrolledInPropertiesCreateInput;
  node: UserOnCreateInput;
};

export type CourseEnrolledStudentsConnection = {
  __typename?: 'CourseEnrolledStudentsConnection';
  edges: Array<CourseEnrolledStudentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CourseEnrolledStudentsConnectionSort = {
  edge?: InputMaybe<EnrolledInPropertiesSort>;
  node?: InputMaybe<UserSort>;
};

export type CourseEnrolledStudentsConnectionWhere = {
  AND?: InputMaybe<Array<CourseEnrolledStudentsConnectionWhere>>;
  NOT?: InputMaybe<CourseEnrolledStudentsConnectionWhere>;
  OR?: InputMaybe<Array<CourseEnrolledStudentsConnectionWhere>>;
  edge?: InputMaybe<EnrolledInPropertiesWhere>;
  node?: InputMaybe<UserWhere>;
};

export type CourseEnrolledStudentsCreateFieldInput = {
  edge: EnrolledInPropertiesCreateInput;
  node: UserCreateInput;
};

export type CourseEnrolledStudentsDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<CourseEnrolledStudentsConnectionWhere>;
};

export type CourseEnrolledStudentsDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<CourseEnrolledStudentsConnectionWhere>;
};

export type CourseEnrolledStudentsFieldInput = {
  connect?: InputMaybe<Array<CourseEnrolledStudentsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CourseEnrolledStudentsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CourseEnrolledStudentsCreateFieldInput>>;
};

export type CourseEnrolledStudentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CourseEnrolledStudentsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CourseEnrolledStudentsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CourseEnrolledStudentsNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CourseEnrolledStudentsRelationship = {
  __typename?: 'CourseEnrolledStudentsRelationship';
  cursor: Scalars['String']['output'];
  node: User;
  properties: EnrolledInProperties;
};

export type CourseEnrolledStudentsUpdateConnectionInput = {
  edge?: InputMaybe<EnrolledInPropertiesUpdateInput>;
  node?: InputMaybe<UserUpdateInput>;
};

export type CourseEnrolledStudentsUpdateFieldInput = {
  connect?: InputMaybe<Array<CourseEnrolledStudentsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CourseEnrolledStudentsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CourseEnrolledStudentsCreateFieldInput>>;
  delete?: InputMaybe<Array<CourseEnrolledStudentsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CourseEnrolledStudentsDisconnectFieldInput>>;
  update?: InputMaybe<CourseEnrolledStudentsUpdateConnectionInput>;
  where?: InputMaybe<CourseEnrolledStudentsConnectionWhere>;
};

export type CourseEnrollmentLinkAggregateInput = {
  AND?: InputMaybe<Array<CourseEnrollmentLinkAggregateInput>>;
  NOT?: InputMaybe<CourseEnrollmentLinkAggregateInput>;
  OR?: InputMaybe<Array<CourseEnrollmentLinkAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CourseEnrollmentLinkNodeAggregationWhereInput>;
};

export type CourseEnrollmentLinkConnectFieldInput = {
  connect?: InputMaybe<EnrollmentLinkConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<EnrollmentLinkConnectWhere>;
};

export type CourseEnrollmentLinkConnectOrCreateFieldInput = {
  onCreate: CourseEnrollmentLinkConnectOrCreateFieldInputOnCreate;
  where: EnrollmentLinkConnectOrCreateWhere;
};

export type CourseEnrollmentLinkConnectOrCreateFieldInputOnCreate = {
  node: EnrollmentLinkOnCreateInput;
};

export type CourseEnrollmentLinkConnection = {
  __typename?: 'CourseEnrollmentLinkConnection';
  edges: Array<CourseEnrollmentLinkRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CourseEnrollmentLinkConnectionSort = {
  node?: InputMaybe<EnrollmentLinkSort>;
};

export type CourseEnrollmentLinkConnectionWhere = {
  AND?: InputMaybe<Array<CourseEnrollmentLinkConnectionWhere>>;
  NOT?: InputMaybe<CourseEnrollmentLinkConnectionWhere>;
  OR?: InputMaybe<Array<CourseEnrollmentLinkConnectionWhere>>;
  node?: InputMaybe<EnrollmentLinkWhere>;
};

export type CourseEnrollmentLinkCreateFieldInput = {
  node: EnrollmentLinkCreateInput;
};

export type CourseEnrollmentLinkDeleteFieldInput = {
  delete?: InputMaybe<EnrollmentLinkDeleteInput>;
  where?: InputMaybe<CourseEnrollmentLinkConnectionWhere>;
};

export type CourseEnrollmentLinkDisconnectFieldInput = {
  disconnect?: InputMaybe<EnrollmentLinkDisconnectInput>;
  where?: InputMaybe<CourseEnrollmentLinkConnectionWhere>;
};

export type CourseEnrollmentLinkEnrollmentLinkAggregationSelection = {
  __typename?: 'CourseEnrollmentLinkEnrollmentLinkAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CourseEnrollmentLinkEnrollmentLinkNodeAggregateSelection>;
};

export type CourseEnrollmentLinkEnrollmentLinkNodeAggregateSelection = {
  __typename?: 'CourseEnrollmentLinkEnrollmentLinkNodeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  currentEnrollments: IntAggregateSelection;
  expiresAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  maxEnrollments: IntAggregateSelection;
  token: StringAggregateSelection;
};

export type CourseEnrollmentLinkFieldInput = {
  connect?: InputMaybe<CourseEnrollmentLinkConnectFieldInput>;
  connectOrCreate?: InputMaybe<CourseEnrollmentLinkConnectOrCreateFieldInput>;
  create?: InputMaybe<CourseEnrollmentLinkCreateFieldInput>;
};

export type CourseEnrollmentLinkNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CourseEnrollmentLinkNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CourseEnrollmentLinkNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CourseEnrollmentLinkNodeAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currentEnrollments_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentEnrollments_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentEnrollments_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentEnrollments_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentEnrollments_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentEnrollments_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentEnrollments_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  currentEnrollments_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentEnrollments_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  currentEnrollments_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentEnrollments_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentEnrollments_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  currentEnrollments_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentEnrollments_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  currentEnrollments_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentEnrollments_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentEnrollments_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  currentEnrollments_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentEnrollments_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  currentEnrollments_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  expiresAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  maxEnrollments_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxEnrollments_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maxEnrollments_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxEnrollments_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maxEnrollments_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxEnrollments_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxEnrollments_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  maxEnrollments_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxEnrollments_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  maxEnrollments_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxEnrollments_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxEnrollments_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  maxEnrollments_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxEnrollments_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  maxEnrollments_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxEnrollments_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxEnrollments_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  maxEnrollments_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxEnrollments_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  maxEnrollments_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  token_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  token_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  token_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  token_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  token_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  token_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  token_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  token_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  token_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  token_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  token_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  token_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  token_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  token_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  token_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CourseEnrollmentLinkRelationship = {
  __typename?: 'CourseEnrollmentLinkRelationship';
  cursor: Scalars['String']['output'];
  node: EnrollmentLink;
};

export type CourseEnrollmentLinkUpdateConnectionInput = {
  node?: InputMaybe<EnrollmentLinkUpdateInput>;
};

export type CourseEnrollmentLinkUpdateFieldInput = {
  connect?: InputMaybe<CourseEnrollmentLinkConnectFieldInput>;
  connectOrCreate?: InputMaybe<CourseEnrollmentLinkConnectOrCreateFieldInput>;
  create?: InputMaybe<CourseEnrollmentLinkCreateFieldInput>;
  delete?: InputMaybe<CourseEnrollmentLinkDeleteFieldInput>;
  disconnect?: InputMaybe<CourseEnrollmentLinkDisconnectFieldInput>;
  update?: InputMaybe<CourseEnrollmentLinkUpdateConnectionInput>;
  where?: InputMaybe<CourseEnrollmentLinkConnectionWhere>;
};

export type CourseEvaluation = {
  __typename?: 'CourseEvaluation';
  assignmentEvaluationJson?: Maybe<Scalars['String']['output']>;
  courseHasEvaluation?: Maybe<Course>;
  courseHasEvaluationAggregate?: Maybe<CourseEvaluationCourseCourseHasEvaluationAggregationSelection>;
  courseHasEvaluationConnection: CourseEvaluationCourseHasEvaluationConnection;
  courseId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  curriculumEvaluationJson?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobId: Scalars['ID']['output'];
  overallSummary?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  teacherRecommendations?: Maybe<Array<Scalars['String']['output']>>;
};


export type CourseEvaluationCourseHasEvaluationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CourseOptions>;
  where?: InputMaybe<CourseWhere>;
};


export type CourseEvaluationCourseHasEvaluationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CourseWhere>;
};


export type CourseEvaluationCourseHasEvaluationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CourseEvaluationCourseHasEvaluationConnectionSort>>;
  where?: InputMaybe<CourseEvaluationCourseHasEvaluationConnectionWhere>;
};

export type CourseEvaluationConnectInput = {
  courseHasEvaluation?: InputMaybe<CourseEvaluationCourseHasEvaluationConnectFieldInput>;
};

export type CourseEvaluationConnectWhere = {
  node: CourseEvaluationWhere;
};

export type CourseEvaluationCourseCourseHasEvaluationAggregationSelection = {
  __typename?: 'CourseEvaluationCourseCourseHasEvaluationAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CourseEvaluationCourseCourseHasEvaluationNodeAggregateSelection>;
};

export type CourseEvaluationCourseCourseHasEvaluationNodeAggregateSelection = {
  __typename?: 'CourseEvaluationCourseCourseHasEvaluationNodeAggregateSelection';
  account_id: FloatAggregateSelection;
  calendar_ics: StringAggregateSelection;
  cost: FloatAggregateSelection;
  courseId: StringAggregateSelection;
  course_code: StringAggregateSelection;
  course_id: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  default_view: StringAggregateSelection;
  description: StringAggregateSelection;
  dueDateEndDate: DateTimeAggregateSelection;
  dueDateStartDate: DateTimeAggregateSelection;
  endDate: DateTimeAggregateSelection;
  end_at: StringAggregateSelection;
  enrollment_term_id: FloatAggregateSelection;
  grading_standard_id: FloatAggregateSelection;
  id: IdAggregateSelection;
  integration_id: StringAggregateSelection;
  label: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  learningStandards: StringAggregateSelection;
  lengthInWeeks: FloatAggregateSelection;
  license: StringAggregateSelection;
  lti_id: StringAggregateSelection;
  name: StringAggregateSelection;
  original_name: StringAggregateSelection;
  root_account_id: FloatAggregateSelection;
  sis_course_id: StringAggregateSelection;
  sis_import_id: FloatAggregateSelection;
  startDate: DateTimeAggregateSelection;
  start_at: StringAggregateSelection;
  state: StringAggregateSelection;
  storage_quota_mb: FloatAggregateSelection;
  stripePriceId: StringAggregateSelection;
  stripeProductId: StringAggregateSelection;
  targetAudience: StringAggregateSelection;
  thumbnail: StringAggregateSelection;
  time_zone: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  uuid: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export type CourseEvaluationCourseHasEvaluationAggregateInput = {
  AND?: InputMaybe<Array<CourseEvaluationCourseHasEvaluationAggregateInput>>;
  NOT?: InputMaybe<CourseEvaluationCourseHasEvaluationAggregateInput>;
  OR?: InputMaybe<Array<CourseEvaluationCourseHasEvaluationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CourseEvaluationCourseHasEvaluationNodeAggregationWhereInput>;
};

export type CourseEvaluationCourseHasEvaluationConnectFieldInput = {
  connect?: InputMaybe<CourseConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CourseConnectWhere>;
};

export type CourseEvaluationCourseHasEvaluationConnectOrCreateFieldInput = {
  onCreate: CourseEvaluationCourseHasEvaluationConnectOrCreateFieldInputOnCreate;
  where: CourseConnectOrCreateWhere;
};

export type CourseEvaluationCourseHasEvaluationConnectOrCreateFieldInputOnCreate = {
  node: CourseOnCreateInput;
};

export type CourseEvaluationCourseHasEvaluationConnection = {
  __typename?: 'CourseEvaluationCourseHasEvaluationConnection';
  edges: Array<CourseEvaluationCourseHasEvaluationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CourseEvaluationCourseHasEvaluationConnectionSort = {
  node?: InputMaybe<CourseSort>;
};

export type CourseEvaluationCourseHasEvaluationConnectionWhere = {
  AND?: InputMaybe<Array<CourseEvaluationCourseHasEvaluationConnectionWhere>>;
  NOT?: InputMaybe<CourseEvaluationCourseHasEvaluationConnectionWhere>;
  OR?: InputMaybe<Array<CourseEvaluationCourseHasEvaluationConnectionWhere>>;
  node?: InputMaybe<CourseWhere>;
};

export type CourseEvaluationCourseHasEvaluationCreateFieldInput = {
  node: CourseCreateInput;
};

export type CourseEvaluationCourseHasEvaluationDeleteFieldInput = {
  delete?: InputMaybe<CourseDeleteInput>;
  where?: InputMaybe<CourseEvaluationCourseHasEvaluationConnectionWhere>;
};

export type CourseEvaluationCourseHasEvaluationDisconnectFieldInput = {
  disconnect?: InputMaybe<CourseDisconnectInput>;
  where?: InputMaybe<CourseEvaluationCourseHasEvaluationConnectionWhere>;
};

export type CourseEvaluationCourseHasEvaluationFieldInput = {
  connect?: InputMaybe<CourseEvaluationCourseHasEvaluationConnectFieldInput>;
  connectOrCreate?: InputMaybe<CourseEvaluationCourseHasEvaluationConnectOrCreateFieldInput>;
  create?: InputMaybe<CourseEvaluationCourseHasEvaluationCreateFieldInput>;
};

export type CourseEvaluationCourseHasEvaluationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CourseEvaluationCourseHasEvaluationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CourseEvaluationCourseHasEvaluationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CourseEvaluationCourseHasEvaluationNodeAggregationWhereInput>>;
  account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  cost_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDateEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  enrollment_term_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  label_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningStandards_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthInWeeks_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  root_account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_import_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  startDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  storage_quota_mb_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CourseEvaluationCourseHasEvaluationRelationship = {
  __typename?: 'CourseEvaluationCourseHasEvaluationRelationship';
  cursor: Scalars['String']['output'];
  node: Course;
};

export type CourseEvaluationCourseHasEvaluationUpdateConnectionInput = {
  node?: InputMaybe<CourseUpdateInput>;
};

export type CourseEvaluationCourseHasEvaluationUpdateFieldInput = {
  connect?: InputMaybe<CourseEvaluationCourseHasEvaluationConnectFieldInput>;
  connectOrCreate?: InputMaybe<CourseEvaluationCourseHasEvaluationConnectOrCreateFieldInput>;
  create?: InputMaybe<CourseEvaluationCourseHasEvaluationCreateFieldInput>;
  delete?: InputMaybe<CourseEvaluationCourseHasEvaluationDeleteFieldInput>;
  disconnect?: InputMaybe<CourseEvaluationCourseHasEvaluationDisconnectFieldInput>;
  update?: InputMaybe<CourseEvaluationCourseHasEvaluationUpdateConnectionInput>;
  where?: InputMaybe<CourseEvaluationCourseHasEvaluationConnectionWhere>;
};

export type CourseEvaluationCreateInput = {
  assignmentEvaluationJson?: InputMaybe<Scalars['String']['input']>;
  courseHasEvaluation?: InputMaybe<CourseEvaluationCourseHasEvaluationFieldInput>;
  courseId: Scalars['ID']['input'];
  createdAt: Scalars['DateTime']['input'];
  curriculumEvaluationJson?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  jobId: Scalars['ID']['input'];
  overallSummary?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  teacherRecommendations?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CourseEvaluationDeleteInput = {
  courseHasEvaluation?: InputMaybe<CourseEvaluationCourseHasEvaluationDeleteFieldInput>;
};

export type CourseEvaluationDisconnectInput = {
  courseHasEvaluation?: InputMaybe<CourseEvaluationCourseHasEvaluationDisconnectFieldInput>;
};

export type CourseEvaluationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CourseEvaluationSort objects to sort CourseEvaluations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CourseEvaluationSort>>;
};

export type CourseEvaluationResponse = {
  __typename?: 'CourseEvaluationResponse';
  jobId?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Fields to sort CourseEvaluations by. The order in which sorts are applied is not guaranteed when specifying many fields in one CourseEvaluationSort object. */
export type CourseEvaluationSort = {
  assignmentEvaluationJson?: InputMaybe<SortDirection>;
  courseId?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  curriculumEvaluationJson?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  jobId?: InputMaybe<SortDirection>;
  overallSummary?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
};

export type CourseEvaluationUpdateInput = {
  assignmentEvaluationJson?: InputMaybe<Scalars['String']['input']>;
  courseHasEvaluation?: InputMaybe<CourseEvaluationCourseHasEvaluationUpdateFieldInput>;
  courseId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  curriculumEvaluationJson?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jobId?: InputMaybe<Scalars['ID']['input']>;
  overallSummary?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  teacherRecommendations?: InputMaybe<Array<Scalars['String']['input']>>;
  teacherRecommendations_POP?: InputMaybe<Scalars['Int']['input']>;
  teacherRecommendations_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CourseEvaluationWhere = {
  AND?: InputMaybe<Array<CourseEvaluationWhere>>;
  NOT?: InputMaybe<CourseEvaluationWhere>;
  OR?: InputMaybe<Array<CourseEvaluationWhere>>;
  assignmentEvaluationJson?: InputMaybe<Scalars['String']['input']>;
  assignmentEvaluationJson_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  assignmentEvaluationJson_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  assignmentEvaluationJson_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assignmentEvaluationJson_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  courseHasEvaluation?: InputMaybe<CourseWhere>;
  courseHasEvaluationAggregate?: InputMaybe<CourseEvaluationCourseHasEvaluationAggregateInput>;
  courseHasEvaluationConnection?: InputMaybe<CourseEvaluationCourseHasEvaluationConnectionWhere>;
  courseHasEvaluationConnection_NOT?: InputMaybe<CourseEvaluationCourseHasEvaluationConnectionWhere>;
  courseHasEvaluation_NOT?: InputMaybe<CourseWhere>;
  courseId?: InputMaybe<Scalars['ID']['input']>;
  courseId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  courseId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  courseId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  courseId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  curriculumEvaluationJson?: InputMaybe<Scalars['String']['input']>;
  curriculumEvaluationJson_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  curriculumEvaluationJson_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  curriculumEvaluationJson_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  curriculumEvaluationJson_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  jobId?: InputMaybe<Scalars['ID']['input']>;
  jobId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  jobId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  jobId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  jobId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  overallSummary?: InputMaybe<Scalars['String']['input']>;
  overallSummary_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  overallSummary_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  overallSummary_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  overallSummary_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  status_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  status_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  status_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  teacherRecommendations?: InputMaybe<Array<Scalars['String']['input']>>;
  teacherRecommendations_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type CourseEvaluationsAggregateInput = {
  AND?: InputMaybe<Array<CourseEvaluationsAggregateInput>>;
  NOT?: InputMaybe<CourseEvaluationsAggregateInput>;
  OR?: InputMaybe<Array<CourseEvaluationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CourseEvaluationsNodeAggregationWhereInput>;
};

export type CourseEvaluationsConnectFieldInput = {
  connect?: InputMaybe<Array<CourseEvaluationConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CourseEvaluationConnectWhere>;
};

export type CourseEvaluationsConnection = {
  __typename?: 'CourseEvaluationsConnection';
  edges: Array<CourseEvaluationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CourseEvaluationsConnectionSort = {
  node?: InputMaybe<CourseEvaluationSort>;
};

export type CourseEvaluationsConnectionWhere = {
  AND?: InputMaybe<Array<CourseEvaluationsConnectionWhere>>;
  NOT?: InputMaybe<CourseEvaluationsConnectionWhere>;
  OR?: InputMaybe<Array<CourseEvaluationsConnectionWhere>>;
  node?: InputMaybe<CourseEvaluationWhere>;
};

export type CourseEvaluationsCreateFieldInput = {
  node: CourseEvaluationCreateInput;
};

export type CourseEvaluationsDeleteFieldInput = {
  delete?: InputMaybe<CourseEvaluationDeleteInput>;
  where?: InputMaybe<CourseEvaluationsConnectionWhere>;
};

export type CourseEvaluationsDisconnectFieldInput = {
  disconnect?: InputMaybe<CourseEvaluationDisconnectInput>;
  where?: InputMaybe<CourseEvaluationsConnectionWhere>;
};

export type CourseEvaluationsFieldInput = {
  connect?: InputMaybe<Array<CourseEvaluationsConnectFieldInput>>;
  create?: InputMaybe<Array<CourseEvaluationsCreateFieldInput>>;
};

export type CourseEvaluationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CourseEvaluationsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CourseEvaluationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CourseEvaluationsNodeAggregationWhereInput>>;
  assignmentEvaluationJson_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignmentEvaluationJson_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  assignmentEvaluationJson_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignmentEvaluationJson_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  assignmentEvaluationJson_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignmentEvaluationJson_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignmentEvaluationJson_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignmentEvaluationJson_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignmentEvaluationJson_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignmentEvaluationJson_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignmentEvaluationJson_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignmentEvaluationJson_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignmentEvaluationJson_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignmentEvaluationJson_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignmentEvaluationJson_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  curriculumEvaluationJson_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  curriculumEvaluationJson_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  curriculumEvaluationJson_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  curriculumEvaluationJson_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  curriculumEvaluationJson_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  curriculumEvaluationJson_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  curriculumEvaluationJson_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  curriculumEvaluationJson_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  curriculumEvaluationJson_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  curriculumEvaluationJson_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  curriculumEvaluationJson_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  curriculumEvaluationJson_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  curriculumEvaluationJson_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  curriculumEvaluationJson_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  curriculumEvaluationJson_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  overallSummary_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  overallSummary_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  overallSummary_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  overallSummary_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  overallSummary_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  overallSummary_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  overallSummary_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  overallSummary_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  overallSummary_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  overallSummary_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  overallSummary_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  overallSummary_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  overallSummary_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  overallSummary_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  overallSummary_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  status_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  status_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CourseEvaluationsRelationship = {
  __typename?: 'CourseEvaluationsRelationship';
  cursor: Scalars['String']['output'];
  node: CourseEvaluation;
};

export type CourseEvaluationsUpdateConnectionInput = {
  node?: InputMaybe<CourseEvaluationUpdateInput>;
};

export type CourseEvaluationsUpdateFieldInput = {
  connect?: InputMaybe<Array<CourseEvaluationsConnectFieldInput>>;
  create?: InputMaybe<Array<CourseEvaluationsCreateFieldInput>>;
  delete?: InputMaybe<Array<CourseEvaluationsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CourseEvaluationsDisconnectFieldInput>>;
  update?: InputMaybe<CourseEvaluationsUpdateConnectionInput>;
  where?: InputMaybe<CourseEvaluationsConnectionWhere>;
};

export type CourseExternalIntegration = {
  __typename?: 'CourseExternalIntegration';
  course: Course;
  courseAggregate?: Maybe<CourseExternalIntegrationCourseCourseAggregationSelection>;
  courseConnection: CourseExternalIntegrationCourseConnection;
  externalIntegrationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  integration?: Maybe<ExternalIntegration>;
  integrationAggregate?: Maybe<CourseExternalIntegrationExternalIntegrationIntegrationAggregationSelection>;
  integrationConnection: CourseExternalIntegrationIntegrationConnection;
};


export type CourseExternalIntegrationCourseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CourseOptions>;
  where?: InputMaybe<CourseWhere>;
};


export type CourseExternalIntegrationCourseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CourseWhere>;
};


export type CourseExternalIntegrationCourseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CourseExternalIntegrationCourseConnectionSort>>;
  where?: InputMaybe<CourseExternalIntegrationCourseConnectionWhere>;
};


export type CourseExternalIntegrationIntegrationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalIntegrationOptions>;
  where?: InputMaybe<ExternalIntegrationWhere>;
};


export type CourseExternalIntegrationIntegrationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalIntegrationWhere>;
};


export type CourseExternalIntegrationIntegrationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CourseExternalIntegrationIntegrationConnectionSort>>;
  where?: InputMaybe<CourseExternalIntegrationIntegrationConnectionWhere>;
};

export type CourseExternalIntegrationConnectInput = {
  course?: InputMaybe<CourseExternalIntegrationCourseConnectFieldInput>;
  integration?: InputMaybe<CourseExternalIntegrationIntegrationConnectFieldInput>;
};

export type CourseExternalIntegrationConnectOrCreateWhere = {
  node: CourseExternalIntegrationUniqueWhere;
};

export type CourseExternalIntegrationConnectWhere = {
  node: CourseExternalIntegrationWhere;
};

export type CourseExternalIntegrationCourseAggregateInput = {
  AND?: InputMaybe<Array<CourseExternalIntegrationCourseAggregateInput>>;
  NOT?: InputMaybe<CourseExternalIntegrationCourseAggregateInput>;
  OR?: InputMaybe<Array<CourseExternalIntegrationCourseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CourseExternalIntegrationCourseNodeAggregationWhereInput>;
};

export type CourseExternalIntegrationCourseConnectFieldInput = {
  connect?: InputMaybe<CourseConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CourseConnectWhere>;
};

export type CourseExternalIntegrationCourseConnectOrCreateFieldInput = {
  onCreate: CourseExternalIntegrationCourseConnectOrCreateFieldInputOnCreate;
  where: CourseConnectOrCreateWhere;
};

export type CourseExternalIntegrationCourseConnectOrCreateFieldInputOnCreate = {
  node: CourseOnCreateInput;
};

export type CourseExternalIntegrationCourseConnection = {
  __typename?: 'CourseExternalIntegrationCourseConnection';
  edges: Array<CourseExternalIntegrationCourseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CourseExternalIntegrationCourseConnectionSort = {
  node?: InputMaybe<CourseSort>;
};

export type CourseExternalIntegrationCourseConnectionWhere = {
  AND?: InputMaybe<Array<CourseExternalIntegrationCourseConnectionWhere>>;
  NOT?: InputMaybe<CourseExternalIntegrationCourseConnectionWhere>;
  OR?: InputMaybe<Array<CourseExternalIntegrationCourseConnectionWhere>>;
  node?: InputMaybe<CourseWhere>;
};

export type CourseExternalIntegrationCourseCourseAggregationSelection = {
  __typename?: 'CourseExternalIntegrationCourseCourseAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CourseExternalIntegrationCourseCourseNodeAggregateSelection>;
};

export type CourseExternalIntegrationCourseCourseNodeAggregateSelection = {
  __typename?: 'CourseExternalIntegrationCourseCourseNodeAggregateSelection';
  account_id: FloatAggregateSelection;
  calendar_ics: StringAggregateSelection;
  cost: FloatAggregateSelection;
  courseId: StringAggregateSelection;
  course_code: StringAggregateSelection;
  course_id: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  default_view: StringAggregateSelection;
  description: StringAggregateSelection;
  dueDateEndDate: DateTimeAggregateSelection;
  dueDateStartDate: DateTimeAggregateSelection;
  endDate: DateTimeAggregateSelection;
  end_at: StringAggregateSelection;
  enrollment_term_id: FloatAggregateSelection;
  grading_standard_id: FloatAggregateSelection;
  id: IdAggregateSelection;
  integration_id: StringAggregateSelection;
  label: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  learningStandards: StringAggregateSelection;
  lengthInWeeks: FloatAggregateSelection;
  license: StringAggregateSelection;
  lti_id: StringAggregateSelection;
  name: StringAggregateSelection;
  original_name: StringAggregateSelection;
  root_account_id: FloatAggregateSelection;
  sis_course_id: StringAggregateSelection;
  sis_import_id: FloatAggregateSelection;
  startDate: DateTimeAggregateSelection;
  start_at: StringAggregateSelection;
  state: StringAggregateSelection;
  storage_quota_mb: FloatAggregateSelection;
  stripePriceId: StringAggregateSelection;
  stripeProductId: StringAggregateSelection;
  targetAudience: StringAggregateSelection;
  thumbnail: StringAggregateSelection;
  time_zone: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  uuid: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export type CourseExternalIntegrationCourseCreateFieldInput = {
  node: CourseCreateInput;
};

export type CourseExternalIntegrationCourseDeleteFieldInput = {
  delete?: InputMaybe<CourseDeleteInput>;
  where?: InputMaybe<CourseExternalIntegrationCourseConnectionWhere>;
};

export type CourseExternalIntegrationCourseDisconnectFieldInput = {
  disconnect?: InputMaybe<CourseDisconnectInput>;
  where?: InputMaybe<CourseExternalIntegrationCourseConnectionWhere>;
};

export type CourseExternalIntegrationCourseFieldInput = {
  connect?: InputMaybe<CourseExternalIntegrationCourseConnectFieldInput>;
  connectOrCreate?: InputMaybe<CourseExternalIntegrationCourseConnectOrCreateFieldInput>;
  create?: InputMaybe<CourseExternalIntegrationCourseCreateFieldInput>;
};

export type CourseExternalIntegrationCourseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CourseExternalIntegrationCourseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CourseExternalIntegrationCourseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CourseExternalIntegrationCourseNodeAggregationWhereInput>>;
  account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  cost_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDateEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  enrollment_term_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  label_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningStandards_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthInWeeks_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  root_account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_import_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  startDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  storage_quota_mb_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CourseExternalIntegrationCourseRelationship = {
  __typename?: 'CourseExternalIntegrationCourseRelationship';
  cursor: Scalars['String']['output'];
  node: Course;
};

export type CourseExternalIntegrationCourseUpdateConnectionInput = {
  node?: InputMaybe<CourseUpdateInput>;
};

export type CourseExternalIntegrationCourseUpdateFieldInput = {
  connect?: InputMaybe<CourseExternalIntegrationCourseConnectFieldInput>;
  connectOrCreate?: InputMaybe<CourseExternalIntegrationCourseConnectOrCreateFieldInput>;
  create?: InputMaybe<CourseExternalIntegrationCourseCreateFieldInput>;
  delete?: InputMaybe<CourseExternalIntegrationCourseDeleteFieldInput>;
  disconnect?: InputMaybe<CourseExternalIntegrationCourseDisconnectFieldInput>;
  update?: InputMaybe<CourseExternalIntegrationCourseUpdateConnectionInput>;
  where?: InputMaybe<CourseExternalIntegrationCourseConnectionWhere>;
};

export type CourseExternalIntegrationCreateInput = {
  course?: InputMaybe<CourseExternalIntegrationCourseFieldInput>;
  externalIntegrationId?: InputMaybe<Scalars['String']['input']>;
  integration?: InputMaybe<CourseExternalIntegrationIntegrationFieldInput>;
};

export type CourseExternalIntegrationDeleteInput = {
  course?: InputMaybe<CourseExternalIntegrationCourseDeleteFieldInput>;
  integration?: InputMaybe<CourseExternalIntegrationIntegrationDeleteFieldInput>;
};

export type CourseExternalIntegrationDisconnectInput = {
  course?: InputMaybe<CourseExternalIntegrationCourseDisconnectFieldInput>;
  integration?: InputMaybe<CourseExternalIntegrationIntegrationDisconnectFieldInput>;
};

export type CourseExternalIntegrationExternalIntegrationIntegrationAggregationSelection = {
  __typename?: 'CourseExternalIntegrationExternalIntegrationIntegrationAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CourseExternalIntegrationExternalIntegrationIntegrationNodeAggregateSelection>;
};

export type CourseExternalIntegrationExternalIntegrationIntegrationNodeAggregateSelection = {
  __typename?: 'CourseExternalIntegrationExternalIntegrationIntegrationNodeAggregateSelection';
  apiBaseUrl: StringAggregateSelection;
  apiKey: StringAggregateSelection;
  config: StringAggregateSelection;
  id: IdAggregateSelection;
  type: StringAggregateSelection;
};

export type CourseExternalIntegrationIntegrationAggregateInput = {
  AND?: InputMaybe<Array<CourseExternalIntegrationIntegrationAggregateInput>>;
  NOT?: InputMaybe<CourseExternalIntegrationIntegrationAggregateInput>;
  OR?: InputMaybe<Array<CourseExternalIntegrationIntegrationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CourseExternalIntegrationIntegrationNodeAggregationWhereInput>;
};

export type CourseExternalIntegrationIntegrationConnectFieldInput = {
  connect?: InputMaybe<ExternalIntegrationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalIntegrationConnectWhere>;
};

export type CourseExternalIntegrationIntegrationConnectOrCreateFieldInput = {
  onCreate: CourseExternalIntegrationIntegrationConnectOrCreateFieldInputOnCreate;
  where: ExternalIntegrationConnectOrCreateWhere;
};

export type CourseExternalIntegrationIntegrationConnectOrCreateFieldInputOnCreate = {
  node: ExternalIntegrationOnCreateInput;
};

export type CourseExternalIntegrationIntegrationConnection = {
  __typename?: 'CourseExternalIntegrationIntegrationConnection';
  edges: Array<CourseExternalIntegrationIntegrationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CourseExternalIntegrationIntegrationConnectionSort = {
  node?: InputMaybe<ExternalIntegrationSort>;
};

export type CourseExternalIntegrationIntegrationConnectionWhere = {
  AND?: InputMaybe<Array<CourseExternalIntegrationIntegrationConnectionWhere>>;
  NOT?: InputMaybe<CourseExternalIntegrationIntegrationConnectionWhere>;
  OR?: InputMaybe<Array<CourseExternalIntegrationIntegrationConnectionWhere>>;
  node?: InputMaybe<ExternalIntegrationWhere>;
};

export type CourseExternalIntegrationIntegrationCreateFieldInput = {
  node: ExternalIntegrationCreateInput;
};

export type CourseExternalIntegrationIntegrationDeleteFieldInput = {
  delete?: InputMaybe<ExternalIntegrationDeleteInput>;
  where?: InputMaybe<CourseExternalIntegrationIntegrationConnectionWhere>;
};

export type CourseExternalIntegrationIntegrationDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalIntegrationDisconnectInput>;
  where?: InputMaybe<CourseExternalIntegrationIntegrationConnectionWhere>;
};

export type CourseExternalIntegrationIntegrationFieldInput = {
  connect?: InputMaybe<CourseExternalIntegrationIntegrationConnectFieldInput>;
  connectOrCreate?: InputMaybe<CourseExternalIntegrationIntegrationConnectOrCreateFieldInput>;
  create?: InputMaybe<CourseExternalIntegrationIntegrationCreateFieldInput>;
};

export type CourseExternalIntegrationIntegrationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CourseExternalIntegrationIntegrationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CourseExternalIntegrationIntegrationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CourseExternalIntegrationIntegrationNodeAggregationWhereInput>>;
  apiBaseUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  apiBaseUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  apiBaseUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  apiBaseUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  apiBaseUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  apiBaseUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  apiBaseUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  apiBaseUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  apiBaseUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  apiBaseUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  apiBaseUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  apiBaseUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  apiBaseUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  apiBaseUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  apiBaseUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  apiKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  apiKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  apiKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  apiKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  apiKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  apiKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  apiKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  apiKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  apiKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  apiKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  apiKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  apiKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  apiKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  apiKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  apiKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  config_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  config_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  config_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  config_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  config_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  config_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  config_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  config_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  config_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  config_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  config_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  config_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  config_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  config_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  config_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CourseExternalIntegrationIntegrationRelationship = {
  __typename?: 'CourseExternalIntegrationIntegrationRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalIntegration;
};

export type CourseExternalIntegrationIntegrationUpdateConnectionInput = {
  node?: InputMaybe<ExternalIntegrationUpdateInput>;
};

export type CourseExternalIntegrationIntegrationUpdateFieldInput = {
  connect?: InputMaybe<CourseExternalIntegrationIntegrationConnectFieldInput>;
  connectOrCreate?: InputMaybe<CourseExternalIntegrationIntegrationConnectOrCreateFieldInput>;
  create?: InputMaybe<CourseExternalIntegrationIntegrationCreateFieldInput>;
  delete?: InputMaybe<CourseExternalIntegrationIntegrationDeleteFieldInput>;
  disconnect?: InputMaybe<CourseExternalIntegrationIntegrationDisconnectFieldInput>;
  update?: InputMaybe<CourseExternalIntegrationIntegrationUpdateConnectionInput>;
  where?: InputMaybe<CourseExternalIntegrationIntegrationConnectionWhere>;
};

export type CourseExternalIntegrationOnCreateInput = {
  externalIntegrationId?: InputMaybe<Scalars['String']['input']>;
};

export type CourseExternalIntegrationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CourseExternalIntegrationSort objects to sort CourseExternalIntegrations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CourseExternalIntegrationSort>>;
};

/** Fields to sort CourseExternalIntegrations by. The order in which sorts are applied is not guaranteed when specifying many fields in one CourseExternalIntegrationSort object. */
export type CourseExternalIntegrationSort = {
  externalIntegrationId?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
};

export type CourseExternalIntegrationUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CourseExternalIntegrationUpdateInput = {
  course?: InputMaybe<CourseExternalIntegrationCourseUpdateFieldInput>;
  externalIntegrationId?: InputMaybe<Scalars['String']['input']>;
  integration?: InputMaybe<CourseExternalIntegrationIntegrationUpdateFieldInput>;
};

export type CourseExternalIntegrationWhere = {
  AND?: InputMaybe<Array<CourseExternalIntegrationWhere>>;
  NOT?: InputMaybe<CourseExternalIntegrationWhere>;
  OR?: InputMaybe<Array<CourseExternalIntegrationWhere>>;
  course?: InputMaybe<CourseWhere>;
  courseAggregate?: InputMaybe<CourseExternalIntegrationCourseAggregateInput>;
  courseConnection?: InputMaybe<CourseExternalIntegrationCourseConnectionWhere>;
  courseConnection_NOT?: InputMaybe<CourseExternalIntegrationCourseConnectionWhere>;
  course_NOT?: InputMaybe<CourseWhere>;
  externalIntegrationId?: InputMaybe<Scalars['String']['input']>;
  externalIntegrationId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  externalIntegrationId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  externalIntegrationId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalIntegrationId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  integration?: InputMaybe<ExternalIntegrationWhere>;
  integrationAggregate?: InputMaybe<CourseExternalIntegrationIntegrationAggregateInput>;
  integrationConnection?: InputMaybe<CourseExternalIntegrationIntegrationConnectionWhere>;
  integrationConnection_NOT?: InputMaybe<CourseExternalIntegrationIntegrationConnectionWhere>;
  integration_NOT?: InputMaybe<ExternalIntegrationWhere>;
};

export type CourseExternalIntegrationsAggregateInput = {
  AND?: InputMaybe<Array<CourseExternalIntegrationsAggregateInput>>;
  NOT?: InputMaybe<CourseExternalIntegrationsAggregateInput>;
  OR?: InputMaybe<Array<CourseExternalIntegrationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CourseExternalIntegrationsNodeAggregationWhereInput>;
};

export type CourseExternalIntegrationsConnectFieldInput = {
  connect?: InputMaybe<Array<CourseExternalIntegrationConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CourseExternalIntegrationConnectWhere>;
};

export type CourseExternalIntegrationsConnectOrCreateFieldInput = {
  onCreate: CourseExternalIntegrationsConnectOrCreateFieldInputOnCreate;
  where: CourseExternalIntegrationConnectOrCreateWhere;
};

export type CourseExternalIntegrationsConnectOrCreateFieldInputOnCreate = {
  node: CourseExternalIntegrationOnCreateInput;
};

export type CourseExternalIntegrationsConnection = {
  __typename?: 'CourseExternalIntegrationsConnection';
  edges: Array<CourseExternalIntegrationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CourseExternalIntegrationsConnectionSort = {
  node?: InputMaybe<CourseExternalIntegrationSort>;
};

export type CourseExternalIntegrationsConnectionWhere = {
  AND?: InputMaybe<Array<CourseExternalIntegrationsConnectionWhere>>;
  NOT?: InputMaybe<CourseExternalIntegrationsConnectionWhere>;
  OR?: InputMaybe<Array<CourseExternalIntegrationsConnectionWhere>>;
  node?: InputMaybe<CourseExternalIntegrationWhere>;
};

export type CourseExternalIntegrationsCreateFieldInput = {
  node: CourseExternalIntegrationCreateInput;
};

export type CourseExternalIntegrationsDeleteFieldInput = {
  delete?: InputMaybe<CourseExternalIntegrationDeleteInput>;
  where?: InputMaybe<CourseExternalIntegrationsConnectionWhere>;
};

export type CourseExternalIntegrationsDisconnectFieldInput = {
  disconnect?: InputMaybe<CourseExternalIntegrationDisconnectInput>;
  where?: InputMaybe<CourseExternalIntegrationsConnectionWhere>;
};

export type CourseExternalIntegrationsFieldInput = {
  connect?: InputMaybe<Array<CourseExternalIntegrationsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CourseExternalIntegrationsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CourseExternalIntegrationsCreateFieldInput>>;
};

export type CourseExternalIntegrationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CourseExternalIntegrationsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CourseExternalIntegrationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CourseExternalIntegrationsNodeAggregationWhereInput>>;
  externalIntegrationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalIntegrationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalIntegrationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalIntegrationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalIntegrationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalIntegrationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalIntegrationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalIntegrationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalIntegrationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalIntegrationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalIntegrationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalIntegrationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalIntegrationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalIntegrationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalIntegrationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CourseExternalIntegrationsRelationship = {
  __typename?: 'CourseExternalIntegrationsRelationship';
  cursor: Scalars['String']['output'];
  node: CourseExternalIntegration;
};

export type CourseExternalIntegrationsUpdateConnectionInput = {
  node?: InputMaybe<CourseExternalIntegrationUpdateInput>;
};

export type CourseExternalIntegrationsUpdateFieldInput = {
  connect?: InputMaybe<Array<CourseExternalIntegrationsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CourseExternalIntegrationsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CourseExternalIntegrationsCreateFieldInput>>;
  delete?: InputMaybe<Array<CourseExternalIntegrationsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CourseExternalIntegrationsDisconnectFieldInput>>;
  update?: InputMaybe<CourseExternalIntegrationsUpdateConnectionInput>;
  where?: InputMaybe<CourseExternalIntegrationsConnectionWhere>;
};

export type CourseForumAggregateInput = {
  AND?: InputMaybe<Array<CourseForumAggregateInput>>;
  NOT?: InputMaybe<CourseForumAggregateInput>;
  OR?: InputMaybe<Array<CourseForumAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CourseForumNodeAggregationWhereInput>;
};

export type CourseForumConnectFieldInput = {
  connect?: InputMaybe<ForumConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ForumConnectWhere>;
};

export type CourseForumConnectOrCreateFieldInput = {
  onCreate: CourseForumConnectOrCreateFieldInputOnCreate;
  where: ForumConnectOrCreateWhere;
};

export type CourseForumConnectOrCreateFieldInputOnCreate = {
  node: ForumOnCreateInput;
};

export type CourseForumConnection = {
  __typename?: 'CourseForumConnection';
  edges: Array<CourseForumRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CourseForumConnectionSort = {
  node?: InputMaybe<ForumSort>;
};

export type CourseForumConnectionWhere = {
  AND?: InputMaybe<Array<CourseForumConnectionWhere>>;
  NOT?: InputMaybe<CourseForumConnectionWhere>;
  OR?: InputMaybe<Array<CourseForumConnectionWhere>>;
  node?: InputMaybe<ForumWhere>;
};

export type CourseForumCreateFieldInput = {
  node: ForumCreateInput;
};

export type CourseForumDeleteFieldInput = {
  delete?: InputMaybe<ForumDeleteInput>;
  where?: InputMaybe<CourseForumConnectionWhere>;
};

export type CourseForumDisconnectFieldInput = {
  disconnect?: InputMaybe<ForumDisconnectInput>;
  where?: InputMaybe<CourseForumConnectionWhere>;
};

export type CourseForumFieldInput = {
  connect?: InputMaybe<CourseForumConnectFieldInput>;
  connectOrCreate?: InputMaybe<CourseForumConnectOrCreateFieldInput>;
  create?: InputMaybe<CourseForumCreateFieldInput>;
};

export type CourseForumForumAggregationSelection = {
  __typename?: 'CourseForumForumAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CourseForumForumNodeAggregateSelection>;
};

export type CourseForumForumNodeAggregateSelection = {
  __typename?: 'CourseForumForumNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
};

export type CourseForumNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CourseForumNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CourseForumNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CourseForumNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CourseForumRelationship = {
  __typename?: 'CourseForumRelationship';
  cursor: Scalars['String']['output'];
  node: Forum;
};

export type CourseForumUpdateConnectionInput = {
  node?: InputMaybe<ForumUpdateInput>;
};

export type CourseForumUpdateFieldInput = {
  connect?: InputMaybe<CourseForumConnectFieldInput>;
  connectOrCreate?: InputMaybe<CourseForumConnectOrCreateFieldInput>;
  create?: InputMaybe<CourseForumCreateFieldInput>;
  delete?: InputMaybe<CourseForumDeleteFieldInput>;
  disconnect?: InputMaybe<CourseForumDisconnectFieldInput>;
  update?: InputMaybe<CourseForumUpdateConnectionInput>;
  where?: InputMaybe<CourseForumConnectionWhere>;
};

export enum CourseGenerationStatus {
  Completed = 'completed',
  Failed = 'failed',
  GeneratingActivities = 'generating_activities',
  GeneratingImage = 'generating_image',
  GeneratingImageCompleted = 'generating_image_completed',
  GeneratingImageFailed = 'generating_image_failed',
  GeneratingModules = 'generating_modules',
  GeneratingStructure = 'generating_structure',
  Processing = 'processing'
}

export type CourseHasAssignmentAssignmentsAggregateInput = {
  AND?: InputMaybe<Array<CourseHasAssignmentAssignmentsAggregateInput>>;
  NOT?: InputMaybe<CourseHasAssignmentAssignmentsAggregateInput>;
  OR?: InputMaybe<Array<CourseHasAssignmentAssignmentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CourseHasAssignmentAssignmentsNodeAggregationWhereInput>;
};

export type CourseHasAssignmentAssignmentsConnectFieldInput = {
  connect?: InputMaybe<Array<AssignmentConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AssignmentConnectWhere>;
};

export type CourseHasAssignmentAssignmentsConnectOrCreateFieldInput = {
  onCreate: CourseHasAssignmentAssignmentsConnectOrCreateFieldInputOnCreate;
  where: AssignmentConnectOrCreateWhere;
};

export type CourseHasAssignmentAssignmentsConnectOrCreateFieldInputOnCreate = {
  node: AssignmentOnCreateInput;
};

export type CourseHasAssignmentAssignmentsConnection = {
  __typename?: 'CourseHasAssignmentAssignmentsConnection';
  edges: Array<CourseHasAssignmentAssignmentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CourseHasAssignmentAssignmentsConnectionSort = {
  node?: InputMaybe<AssignmentSort>;
};

export type CourseHasAssignmentAssignmentsConnectionWhere = {
  AND?: InputMaybe<Array<CourseHasAssignmentAssignmentsConnectionWhere>>;
  NOT?: InputMaybe<CourseHasAssignmentAssignmentsConnectionWhere>;
  OR?: InputMaybe<Array<CourseHasAssignmentAssignmentsConnectionWhere>>;
  node?: InputMaybe<AssignmentWhere>;
};

export type CourseHasAssignmentAssignmentsCreateFieldInput = {
  node: AssignmentCreateInput;
};

export type CourseHasAssignmentAssignmentsDeleteFieldInput = {
  delete?: InputMaybe<AssignmentDeleteInput>;
  where?: InputMaybe<CourseHasAssignmentAssignmentsConnectionWhere>;
};

export type CourseHasAssignmentAssignmentsDisconnectFieldInput = {
  disconnect?: InputMaybe<AssignmentDisconnectInput>;
  where?: InputMaybe<CourseHasAssignmentAssignmentsConnectionWhere>;
};

export type CourseHasAssignmentAssignmentsFieldInput = {
  connect?: InputMaybe<Array<CourseHasAssignmentAssignmentsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CourseHasAssignmentAssignmentsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CourseHasAssignmentAssignmentsCreateFieldInput>>;
};

export type CourseHasAssignmentAssignmentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CourseHasAssignmentAssignmentsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CourseHasAssignmentAssignmentsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CourseHasAssignmentAssignmentsNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  allowed_attempts_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_group_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  body_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  category_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_assignment_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_unread_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  display_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  due_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_date_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_points_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  html_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lti_context_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  max_attempts_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  needs_grading_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  points_possible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  secure_params_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  secure_params_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  session_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CourseHasAssignmentAssignmentsRelationship = {
  __typename?: 'CourseHasAssignmentAssignmentsRelationship';
  cursor: Scalars['String']['output'];
  node: Assignment;
};

export type CourseHasAssignmentAssignmentsUpdateConnectionInput = {
  node?: InputMaybe<AssignmentUpdateInput>;
};

export type CourseHasAssignmentAssignmentsUpdateFieldInput = {
  connect?: InputMaybe<Array<CourseHasAssignmentAssignmentsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CourseHasAssignmentAssignmentsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CourseHasAssignmentAssignmentsCreateFieldInput>>;
  delete?: InputMaybe<Array<CourseHasAssignmentAssignmentsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CourseHasAssignmentAssignmentsDisconnectFieldInput>>;
  update?: InputMaybe<CourseHasAssignmentAssignmentsUpdateConnectionInput>;
  where?: InputMaybe<CourseHasAssignmentAssignmentsConnectionWhere>;
};

export type CourseHasCourseCategoriesCourseCategoriesAggregateInput = {
  AND?: InputMaybe<Array<CourseHasCourseCategoriesCourseCategoriesAggregateInput>>;
  NOT?: InputMaybe<CourseHasCourseCategoriesCourseCategoriesAggregateInput>;
  OR?: InputMaybe<Array<CourseHasCourseCategoriesCourseCategoriesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CourseHasCourseCategoriesCourseCategoriesNodeAggregationWhereInput>;
};

export type CourseHasCourseCategoriesCourseCategoriesConnectFieldInput = {
  connect?: InputMaybe<Array<CourseCategoryConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CourseCategoryConnectWhere>;
};

export type CourseHasCourseCategoriesCourseCategoriesConnection = {
  __typename?: 'CourseHasCourseCategoriesCourseCategoriesConnection';
  edges: Array<CourseHasCourseCategoriesCourseCategoriesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CourseHasCourseCategoriesCourseCategoriesConnectionSort = {
  node?: InputMaybe<CourseCategorySort>;
};

export type CourseHasCourseCategoriesCourseCategoriesConnectionWhere = {
  AND?: InputMaybe<Array<CourseHasCourseCategoriesCourseCategoriesConnectionWhere>>;
  NOT?: InputMaybe<CourseHasCourseCategoriesCourseCategoriesConnectionWhere>;
  OR?: InputMaybe<Array<CourseHasCourseCategoriesCourseCategoriesConnectionWhere>>;
  node?: InputMaybe<CourseCategoryWhere>;
};

export type CourseHasCourseCategoriesCourseCategoriesCreateFieldInput = {
  node: CourseCategoryCreateInput;
};

export type CourseHasCourseCategoriesCourseCategoriesDeleteFieldInput = {
  delete?: InputMaybe<CourseCategoryDeleteInput>;
  where?: InputMaybe<CourseHasCourseCategoriesCourseCategoriesConnectionWhere>;
};

export type CourseHasCourseCategoriesCourseCategoriesDisconnectFieldInput = {
  disconnect?: InputMaybe<CourseCategoryDisconnectInput>;
  where?: InputMaybe<CourseHasCourseCategoriesCourseCategoriesConnectionWhere>;
};

export type CourseHasCourseCategoriesCourseCategoriesFieldInput = {
  connect?: InputMaybe<Array<CourseHasCourseCategoriesCourseCategoriesConnectFieldInput>>;
  create?: InputMaybe<Array<CourseHasCourseCategoriesCourseCategoriesCreateFieldInput>>;
};

export type CourseHasCourseCategoriesCourseCategoriesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CourseHasCourseCategoriesCourseCategoriesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CourseHasCourseCategoriesCourseCategoriesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CourseHasCourseCategoriesCourseCategoriesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CourseHasCourseCategoriesCourseCategoriesRelationship = {
  __typename?: 'CourseHasCourseCategoriesCourseCategoriesRelationship';
  cursor: Scalars['String']['output'];
  node: CourseCategory;
};

export type CourseHasCourseCategoriesCourseCategoriesUpdateConnectionInput = {
  node?: InputMaybe<CourseCategoryUpdateInput>;
};

export type CourseHasCourseCategoriesCourseCategoriesUpdateFieldInput = {
  connect?: InputMaybe<Array<CourseHasCourseCategoriesCourseCategoriesConnectFieldInput>>;
  create?: InputMaybe<Array<CourseHasCourseCategoriesCourseCategoriesCreateFieldInput>>;
  delete?: InputMaybe<Array<CourseHasCourseCategoriesCourseCategoriesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CourseHasCourseCategoriesCourseCategoriesDisconnectFieldInput>>;
  update?: InputMaybe<CourseHasCourseCategoriesCourseCategoriesUpdateConnectionInput>;
  where?: InputMaybe<CourseHasCourseCategoriesCourseCategoriesConnectionWhere>;
};

export type CourseHasPagePagesAggregateInput = {
  AND?: InputMaybe<Array<CourseHasPagePagesAggregateInput>>;
  NOT?: InputMaybe<CourseHasPagePagesAggregateInput>;
  OR?: InputMaybe<Array<CourseHasPagePagesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CourseHasPagePagesNodeAggregationWhereInput>;
};

export type CourseHasPagePagesConnectFieldInput = {
  connect?: InputMaybe<Array<PageConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PageConnectWhere>;
};

export type CourseHasPagePagesConnectOrCreateFieldInput = {
  onCreate: CourseHasPagePagesConnectOrCreateFieldInputOnCreate;
  where: PageConnectOrCreateWhere;
};

export type CourseHasPagePagesConnectOrCreateFieldInputOnCreate = {
  node: PageOnCreateInput;
};

export type CourseHasPagePagesConnection = {
  __typename?: 'CourseHasPagePagesConnection';
  edges: Array<CourseHasPagePagesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CourseHasPagePagesConnectionSort = {
  node?: InputMaybe<PageSort>;
};

export type CourseHasPagePagesConnectionWhere = {
  AND?: InputMaybe<Array<CourseHasPagePagesConnectionWhere>>;
  NOT?: InputMaybe<CourseHasPagePagesConnectionWhere>;
  OR?: InputMaybe<Array<CourseHasPagePagesConnectionWhere>>;
  node?: InputMaybe<PageWhere>;
};

export type CourseHasPagePagesCreateFieldInput = {
  node: PageCreateInput;
};

export type CourseHasPagePagesDeleteFieldInput = {
  delete?: InputMaybe<PageDeleteInput>;
  where?: InputMaybe<CourseHasPagePagesConnectionWhere>;
};

export type CourseHasPagePagesDisconnectFieldInput = {
  disconnect?: InputMaybe<PageDisconnectInput>;
  where?: InputMaybe<CourseHasPagePagesConnectionWhere>;
};

export type CourseHasPagePagesFieldInput = {
  connect?: InputMaybe<Array<CourseHasPagePagesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CourseHasPagePagesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CourseHasPagePagesCreateFieldInput>>;
};

export type CourseHasPagePagesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CourseHasPagePagesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CourseHasPagePagesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CourseHasPagePagesNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  body_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  editing_roles_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  editing_roles_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  editing_roles_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  editing_roles_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  editing_roles_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  editing_roles_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  editing_roles_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  editing_roles_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  editing_roles_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  editing_roles_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  editing_roles_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  editing_roles_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  editing_roles_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  editing_roles_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  editing_roles_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_edited_by_anonymous_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_anonymous_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_anonymous_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_anonymous_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_anonymous_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_anonymous_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_anonymous_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_anonymous_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_anonymous_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_anonymous_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_anonymous_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_anonymous_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_anonymous_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_anonymous_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_anonymous_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_avatar_image_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_avatar_image_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_avatar_image_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_avatar_image_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_avatar_image_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_avatar_image_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_avatar_image_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_avatar_image_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_avatar_image_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_avatar_image_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_avatar_image_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_avatar_image_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_avatar_image_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_avatar_image_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_avatar_image_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_display_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_display_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_display_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_display_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_display_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_display_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_display_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_display_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_display_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_display_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_display_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_display_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_display_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_display_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_display_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  page_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  page_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  page_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  page_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  page_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  page_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  page_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  page_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  page_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  page_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  page_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  page_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  page_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  page_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  page_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  page_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  page_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  page_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  page_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  page_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CourseHasPagePagesRelationship = {
  __typename?: 'CourseHasPagePagesRelationship';
  cursor: Scalars['String']['output'];
  node: Page;
};

export type CourseHasPagePagesUpdateConnectionInput = {
  node?: InputMaybe<PageUpdateInput>;
};

export type CourseHasPagePagesUpdateFieldInput = {
  connect?: InputMaybe<Array<CourseHasPagePagesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CourseHasPagePagesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CourseHasPagePagesCreateFieldInput>>;
  delete?: InputMaybe<Array<CourseHasPagePagesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CourseHasPagePagesDisconnectFieldInput>>;
  update?: InputMaybe<CourseHasPagePagesUpdateConnectionInput>;
  where?: InputMaybe<CourseHasPagePagesConnectionWhere>;
};

export type CourseHierarchyResponse = {
  __typename?: 'CourseHierarchyResponse';
  count: Scalars['Int']['output'];
  data: Array<HierarchyCourse>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CourseInfo = {
  __typename?: 'CourseInfo';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CourseLearningPaymentUsersHaveLearningPaymentAggregationSelection = {
  __typename?: 'CourseLearningPaymentUsersHaveLearningPaymentAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CourseLearningPaymentUsersHaveLearningPaymentNodeAggregateSelection>;
};

export type CourseLearningPaymentUsersHaveLearningPaymentNodeAggregateSelection = {
  __typename?: 'CourseLearningPaymentUsersHaveLearningPaymentNodeAggregateSelection';
  amount: FloatAggregateSelection;
  created: DateTimeAggregateSelection;
  discountAmount: FloatAggregateSelection;
  id: IdAggregateSelection;
  promotionCode: StringAggregateSelection;
};

export type CourseModuleModulesAggregationSelection = {
  __typename?: 'CourseModuleModulesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CourseModuleModulesNodeAggregateSelection>;
};

export type CourseModuleModulesNodeAggregateSelection = {
  __typename?: 'CourseModuleModulesNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  module_name: StringAggregateSelection;
  thumbnail: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type CourseModulesAggregateInput = {
  AND?: InputMaybe<Array<CourseModulesAggregateInput>>;
  NOT?: InputMaybe<CourseModulesAggregateInput>;
  OR?: InputMaybe<Array<CourseModulesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CourseModulesNodeAggregationWhereInput>;
};

export type CourseModulesConnectFieldInput = {
  connect?: InputMaybe<Array<ModuleConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ModuleConnectWhere>;
};

export type CourseModulesConnectOrCreateFieldInput = {
  onCreate: CourseModulesConnectOrCreateFieldInputOnCreate;
  where: ModuleConnectOrCreateWhere;
};

export type CourseModulesConnectOrCreateFieldInputOnCreate = {
  node: ModuleOnCreateInput;
};

export type CourseModulesConnection = {
  __typename?: 'CourseModulesConnection';
  edges: Array<CourseModulesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CourseModulesConnectionSort = {
  node?: InputMaybe<ModuleSort>;
};

export type CourseModulesConnectionWhere = {
  AND?: InputMaybe<Array<CourseModulesConnectionWhere>>;
  NOT?: InputMaybe<CourseModulesConnectionWhere>;
  OR?: InputMaybe<Array<CourseModulesConnectionWhere>>;
  node?: InputMaybe<ModuleWhere>;
};

export type CourseModulesCreateFieldInput = {
  node: ModuleCreateInput;
};

export type CourseModulesDeleteFieldInput = {
  delete?: InputMaybe<ModuleDeleteInput>;
  where?: InputMaybe<CourseModulesConnectionWhere>;
};

export type CourseModulesDisconnectFieldInput = {
  disconnect?: InputMaybe<ModuleDisconnectInput>;
  where?: InputMaybe<CourseModulesConnectionWhere>;
};

export type CourseModulesFieldInput = {
  connect?: InputMaybe<Array<CourseModulesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CourseModulesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CourseModulesCreateFieldInput>>;
};

export type CourseModulesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CourseModulesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CourseModulesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CourseModulesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  module_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  module_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CourseModulesRelationship = {
  __typename?: 'CourseModulesRelationship';
  cursor: Scalars['String']['output'];
  node: Module;
};

export type CourseModulesUpdateConnectionInput = {
  node?: InputMaybe<ModuleUpdateInput>;
};

export type CourseModulesUpdateFieldInput = {
  connect?: InputMaybe<Array<CourseModulesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CourseModulesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CourseModulesCreateFieldInput>>;
  delete?: InputMaybe<Array<CourseModulesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CourseModulesDisconnectFieldInput>>;
  update?: InputMaybe<CourseModulesUpdateConnectionInput>;
  where?: InputMaybe<CourseModulesConnectionWhere>;
};

export type CourseNudgeNudgesAboutThisAggregationSelection = {
  __typename?: 'CourseNudgeNudgesAboutThisAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CourseNudgeNudgesAboutThisNodeAggregateSelection>;
};

export type CourseNudgeNudgesAboutThisNodeAggregateSelection = {
  __typename?: 'CourseNudgeNudgesAboutThisNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  idempotencyKey: StringAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  priorityScore: FloatAggregateSelection;
  scheduledFor: DateTimeAggregateSelection;
  snoozedUntil: DateTimeAggregateSelection;
  taskCompletedAt: DateTimeAggregateSelection;
};

export type CourseNudgesAboutThisAggregateInput = {
  AND?: InputMaybe<Array<CourseNudgesAboutThisAggregateInput>>;
  NOT?: InputMaybe<CourseNudgesAboutThisAggregateInput>;
  OR?: InputMaybe<Array<CourseNudgesAboutThisAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CourseNudgesAboutThisNodeAggregationWhereInput>;
};

export type CourseNudgesAboutThisConnectFieldInput = {
  connect?: InputMaybe<Array<NudgeConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<NudgeConnectWhere>;
};

export type CourseNudgesAboutThisConnectOrCreateFieldInput = {
  onCreate: CourseNudgesAboutThisConnectOrCreateFieldInputOnCreate;
  where: NudgeConnectOrCreateWhere;
};

export type CourseNudgesAboutThisConnectOrCreateFieldInputOnCreate = {
  node: NudgeOnCreateInput;
};

export type CourseNudgesAboutThisConnection = {
  __typename?: 'CourseNudgesAboutThisConnection';
  edges: Array<CourseNudgesAboutThisRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CourseNudgesAboutThisConnectionSort = {
  node?: InputMaybe<NudgeSort>;
};

export type CourseNudgesAboutThisConnectionWhere = {
  AND?: InputMaybe<Array<CourseNudgesAboutThisConnectionWhere>>;
  NOT?: InputMaybe<CourseNudgesAboutThisConnectionWhere>;
  OR?: InputMaybe<Array<CourseNudgesAboutThisConnectionWhere>>;
  node?: InputMaybe<NudgeWhere>;
};

export type CourseNudgesAboutThisCreateFieldInput = {
  node: NudgeCreateInput;
};

export type CourseNudgesAboutThisDeleteFieldInput = {
  delete?: InputMaybe<NudgeDeleteInput>;
  where?: InputMaybe<CourseNudgesAboutThisConnectionWhere>;
};

export type CourseNudgesAboutThisDisconnectFieldInput = {
  disconnect?: InputMaybe<NudgeDisconnectInput>;
  where?: InputMaybe<CourseNudgesAboutThisConnectionWhere>;
};

export type CourseNudgesAboutThisFieldInput = {
  connect?: InputMaybe<Array<CourseNudgesAboutThisConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CourseNudgesAboutThisConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CourseNudgesAboutThisCreateFieldInput>>;
};

export type CourseNudgesAboutThisNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CourseNudgesAboutThisNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CourseNudgesAboutThisNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CourseNudgesAboutThisNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  idempotencyKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  priorityScore_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  scheduledFor_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CourseNudgesAboutThisRelationship = {
  __typename?: 'CourseNudgesAboutThisRelationship';
  cursor: Scalars['String']['output'];
  node: Nudge;
};

export type CourseNudgesAboutThisUpdateConnectionInput = {
  node?: InputMaybe<NudgeUpdateInput>;
};

export type CourseNudgesAboutThisUpdateFieldInput = {
  connect?: InputMaybe<Array<CourseNudgesAboutThisConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CourseNudgesAboutThisConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CourseNudgesAboutThisCreateFieldInput>>;
  delete?: InputMaybe<Array<CourseNudgesAboutThisDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CourseNudgesAboutThisDisconnectFieldInput>>;
  update?: InputMaybe<CourseNudgesAboutThisUpdateConnectionInput>;
  where?: InputMaybe<CourseNudgesAboutThisConnectionWhere>;
};

export type CourseOnCreateInput = {
  account_id?: InputMaybe<Scalars['Float']['input']>;
  apply_assignment_group_weights?: InputMaybe<Scalars['Boolean']['input']>;
  blueprint?: InputMaybe<Scalars['Boolean']['input']>;
  calendar_ics?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<Scalars['Float']['input']>;
  courseId?: InputMaybe<Scalars['String']['input']>;
  course_code?: InputMaybe<Scalars['String']['input']>;
  course_id?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_at?: InputMaybe<Scalars['String']['input']>;
  created_date?: InputMaybe<Scalars['String']['input']>;
  default_view?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDateEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  end_at?: InputMaybe<Scalars['String']['input']>;
  enrollment_term_id?: InputMaybe<Scalars['Float']['input']>;
  generationStatus?: InputMaybe<CourseGenerationStatus>;
  grading_standard_id?: InputMaybe<Scalars['Float']['input']>;
  hide_final_grades?: InputMaybe<Scalars['Boolean']['input']>;
  homeroom_course?: InputMaybe<Scalars['Boolean']['input']>;
  integration_id?: InputMaybe<Scalars['String']['input']>;
  isCustomCourse?: InputMaybe<Scalars['Boolean']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isEnrollmentAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  is_elective?: InputMaybe<Scalars['Boolean']['input']>;
  is_public?: InputMaybe<Scalars['Boolean']['input']>;
  is_public_to_auth_users?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  learningStandards?: InputMaybe<Scalars['String']['input']>;
  lengthInWeeks?: InputMaybe<Scalars['Float']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  lti_id?: InputMaybe<Scalars['String']['input']>;
  moduleOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  objectives?: InputMaybe<Array<Scalars['String']['input']>>;
  original_name?: InputMaybe<Scalars['String']['input']>;
  period_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  periods?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  public_syllabus?: InputMaybe<Scalars['Boolean']['input']>;
  public_syllabus_to_auth?: InputMaybe<Scalars['Boolean']['input']>;
  restrict_enrollments_to_course_dates?: InputMaybe<Scalars['Boolean']['input']>;
  root_account_id?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id?: InputMaybe<Scalars['String']['input']>;
  sis_import_id?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  start_at?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  storage_quota_mb?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId?: InputMaybe<Scalars['String']['input']>;
  stripeProductId?: InputMaybe<Scalars['String']['input']>;
  targetAudience?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  time_zone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  workflow_state?: InputMaybe<Scalars['String']['input']>;
};

export type CourseOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CourseSort objects to sort Courses by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CourseSort>>;
};

export type CoursePageHasPagePagesAggregationSelection = {
  __typename?: 'CoursePageHasPagePagesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CoursePageHasPagePagesNodeAggregateSelection>;
};

export type CoursePageHasPagePagesNodeAggregateSelection = {
  __typename?: 'CoursePageHasPagePagesNodeAggregateSelection';
  _empty: StringAggregateSelection;
  assignee_mode: StringAggregateSelection;
  body: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  description: StringAggregateSelection;
  editing_roles: StringAggregateSelection;
  html_url: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  last_edited_by_anonymous_id: StringAggregateSelection;
  last_edited_by_avatar_image_url: StringAggregateSelection;
  last_edited_by_display_name: StringAggregateSelection;
  last_edited_by_html_url: StringAggregateSelection;
  last_edited_by_id: FloatAggregateSelection;
  page_id: FloatAggregateSelection;
  state: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_at: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type CoursePreRequisiteForAggregateInput = {
  AND?: InputMaybe<Array<CoursePreRequisiteForAggregateInput>>;
  NOT?: InputMaybe<CoursePreRequisiteForAggregateInput>;
  OR?: InputMaybe<Array<CoursePreRequisiteForAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CoursePreRequisiteForNodeAggregationWhereInput>;
};

export type CoursePreRequisiteForConnectFieldInput = {
  connect?: InputMaybe<Array<CourseConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CourseConnectWhere>;
};

export type CoursePreRequisiteForConnectOrCreateFieldInput = {
  onCreate: CoursePreRequisiteForConnectOrCreateFieldInputOnCreate;
  where: CourseConnectOrCreateWhere;
};

export type CoursePreRequisiteForConnectOrCreateFieldInputOnCreate = {
  node: CourseOnCreateInput;
};

export type CoursePreRequisiteForConnection = {
  __typename?: 'CoursePreRequisiteForConnection';
  edges: Array<CoursePreRequisiteForRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CoursePreRequisiteForConnectionSort = {
  node?: InputMaybe<CourseSort>;
};

export type CoursePreRequisiteForConnectionWhere = {
  AND?: InputMaybe<Array<CoursePreRequisiteForConnectionWhere>>;
  NOT?: InputMaybe<CoursePreRequisiteForConnectionWhere>;
  OR?: InputMaybe<Array<CoursePreRequisiteForConnectionWhere>>;
  node?: InputMaybe<CourseWhere>;
};

export type CoursePreRequisiteForCreateFieldInput = {
  node: CourseCreateInput;
};

export type CoursePreRequisiteForDeleteFieldInput = {
  delete?: InputMaybe<CourseDeleteInput>;
  where?: InputMaybe<CoursePreRequisiteForConnectionWhere>;
};

export type CoursePreRequisiteForDisconnectFieldInput = {
  disconnect?: InputMaybe<CourseDisconnectInput>;
  where?: InputMaybe<CoursePreRequisiteForConnectionWhere>;
};

export type CoursePreRequisiteForFieldInput = {
  connect?: InputMaybe<Array<CoursePreRequisiteForConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CoursePreRequisiteForConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CoursePreRequisiteForCreateFieldInput>>;
};

export type CoursePreRequisiteForNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CoursePreRequisiteForNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CoursePreRequisiteForNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CoursePreRequisiteForNodeAggregationWhereInput>>;
  account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  cost_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDateEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  enrollment_term_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  label_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningStandards_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthInWeeks_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  root_account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_import_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  startDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  storage_quota_mb_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CoursePreRequisiteForRelationship = {
  __typename?: 'CoursePreRequisiteForRelationship';
  cursor: Scalars['String']['output'];
  node: Course;
};

export type CoursePreRequisiteForUpdateConnectionInput = {
  node?: InputMaybe<CourseUpdateInput>;
};

export type CoursePreRequisiteForUpdateFieldInput = {
  connect?: InputMaybe<Array<CoursePreRequisiteForConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CoursePreRequisiteForConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CoursePreRequisiteForCreateFieldInput>>;
  delete?: InputMaybe<Array<CoursePreRequisiteForDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CoursePreRequisiteForDisconnectFieldInput>>;
  update?: InputMaybe<CoursePreRequisiteForUpdateConnectionInput>;
  where?: InputMaybe<CoursePreRequisiteForConnectionWhere>;
};

export type CoursePreRequisitesAggregateInput = {
  AND?: InputMaybe<Array<CoursePreRequisitesAggregateInput>>;
  NOT?: InputMaybe<CoursePreRequisitesAggregateInput>;
  OR?: InputMaybe<Array<CoursePreRequisitesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CoursePreRequisitesNodeAggregationWhereInput>;
};

export type CoursePreRequisitesConnectFieldInput = {
  connect?: InputMaybe<Array<CourseConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CourseConnectWhere>;
};

export type CoursePreRequisitesConnectOrCreateFieldInput = {
  onCreate: CoursePreRequisitesConnectOrCreateFieldInputOnCreate;
  where: CourseConnectOrCreateWhere;
};

export type CoursePreRequisitesConnectOrCreateFieldInputOnCreate = {
  node: CourseOnCreateInput;
};

export type CoursePreRequisitesConnection = {
  __typename?: 'CoursePreRequisitesConnection';
  edges: Array<CoursePreRequisitesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CoursePreRequisitesConnectionSort = {
  node?: InputMaybe<CourseSort>;
};

export type CoursePreRequisitesConnectionWhere = {
  AND?: InputMaybe<Array<CoursePreRequisitesConnectionWhere>>;
  NOT?: InputMaybe<CoursePreRequisitesConnectionWhere>;
  OR?: InputMaybe<Array<CoursePreRequisitesConnectionWhere>>;
  node?: InputMaybe<CourseWhere>;
};

export type CoursePreRequisitesCreateFieldInput = {
  node: CourseCreateInput;
};

export type CoursePreRequisitesDeleteFieldInput = {
  delete?: InputMaybe<CourseDeleteInput>;
  where?: InputMaybe<CoursePreRequisitesConnectionWhere>;
};

export type CoursePreRequisitesDisconnectFieldInput = {
  disconnect?: InputMaybe<CourseDisconnectInput>;
  where?: InputMaybe<CoursePreRequisitesConnectionWhere>;
};

export type CoursePreRequisitesFieldInput = {
  connect?: InputMaybe<Array<CoursePreRequisitesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CoursePreRequisitesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CoursePreRequisitesCreateFieldInput>>;
};

export type CoursePreRequisitesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CoursePreRequisitesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CoursePreRequisitesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CoursePreRequisitesNodeAggregationWhereInput>>;
  account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  cost_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDateEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  enrollment_term_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  label_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningStandards_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthInWeeks_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  root_account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_import_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  startDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  storage_quota_mb_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CoursePreRequisitesRelationship = {
  __typename?: 'CoursePreRequisitesRelationship';
  cursor: Scalars['String']['output'];
  node: Course;
};

export type CoursePreRequisitesUpdateConnectionInput = {
  node?: InputMaybe<CourseUpdateInput>;
};

export type CoursePreRequisitesUpdateFieldInput = {
  connect?: InputMaybe<Array<CoursePreRequisitesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CoursePreRequisitesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CoursePreRequisitesCreateFieldInput>>;
  delete?: InputMaybe<Array<CoursePreRequisitesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CoursePreRequisitesDisconnectFieldInput>>;
  update?: InputMaybe<CoursePreRequisitesUpdateConnectionInput>;
  where?: InputMaybe<CoursePreRequisitesConnectionWhere>;
};

export type CourseProgressAnalytics = {
  __typename?: 'CourseProgressAnalytics';
  active_interaction_count: Scalars['Int']['output'];
  completion_percentage?: Maybe<Scalars['Float']['output']>;
  confusion_points: Scalars['Int']['output'];
  details: CourseProgressDetails;
  distractions: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  questions_asked: Scalars['Int']['output'];
  sentiment: Scalars['String']['output'];
  student_id?: Maybe<Scalars['ID']['output']>;
  student_name?: Maybe<Scalars['String']['output']>;
  success_points: Scalars['Int']['output'];
  total_time_taken?: Maybe<Scalars['Float']['output']>;
};

export type CourseProgressDetails = {
  __typename?: 'CourseProgressDetails';
  modules: Array<ModuleProgressAnalytics>;
};

export type CourseProgressInformationData = {
  __typename?: 'CourseProgressInformationData';
  completedModules?: Maybe<Scalars['Int']['output']>;
  courseId: Scalars['ID']['output'];
  modules: Array<ModuleProgressInformationData>;
  progress?: Maybe<Scalars['Int']['output']>;
  totalModules?: Maybe<Scalars['Int']['output']>;
};

export type CourseProgressInformationResponse = {
  __typename?: 'CourseProgressInformationResponse';
  count: Scalars['Int']['output'];
  data?: Maybe<CourseProgressInformationData>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CourseResponse = {
  __typename?: 'CourseResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<Course>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CourseRosterData = {
  __typename?: 'CourseRosterData';
  analytics?: Maybe<UserRosterAnalytics>;
  email: Scalars['String']['output'];
  enrollmentDate: Scalars['DateTime']['output'];
  expiredInvitation?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pendingCourseEnrollmentInvite?: Maybe<Scalars['Boolean']['output']>;
  roles: Array<Scalars['String']['output']>;
};

export type CourseRosterServiceResult = {
  __typename?: 'CourseRosterServiceResult';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<CourseRosterData>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CourseSchoolSchoolsHasCourseAggregationSelection = {
  __typename?: 'CourseSchoolSchoolsHasCourseAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CourseSchoolSchoolsHasCourseNodeAggregateSelection>;
};

export type CourseSchoolSchoolsHasCourseNodeAggregateSelection = {
  __typename?: 'CourseSchoolSchoolsHasCourseNodeAggregateSelection';
  brightspace_api_client_id: StringAggregateSelection;
  brightspace_api_client_secret: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  domain: StringAggregateSelection;
  id: IdAggregateSelection;
  provider_icon_url: StringAggregateSelection;
  provider_name: StringAggregateSelection;
  team_name: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
};

export type CourseSchoolsHasCourseAggregateInput = {
  AND?: InputMaybe<Array<CourseSchoolsHasCourseAggregateInput>>;
  NOT?: InputMaybe<CourseSchoolsHasCourseAggregateInput>;
  OR?: InputMaybe<Array<CourseSchoolsHasCourseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CourseSchoolsHasCourseNodeAggregationWhereInput>;
};

export type CourseSchoolsHasCourseConnectFieldInput = {
  connect?: InputMaybe<Array<SchoolConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SchoolConnectWhere>;
};

export type CourseSchoolsHasCourseConnectOrCreateFieldInput = {
  onCreate: CourseSchoolsHasCourseConnectOrCreateFieldInputOnCreate;
  where: SchoolConnectOrCreateWhere;
};

export type CourseSchoolsHasCourseConnectOrCreateFieldInputOnCreate = {
  node: SchoolOnCreateInput;
};

export type CourseSchoolsHasCourseConnection = {
  __typename?: 'CourseSchoolsHasCourseConnection';
  edges: Array<CourseSchoolsHasCourseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CourseSchoolsHasCourseConnectionSort = {
  node?: InputMaybe<SchoolSort>;
};

export type CourseSchoolsHasCourseConnectionWhere = {
  AND?: InputMaybe<Array<CourseSchoolsHasCourseConnectionWhere>>;
  NOT?: InputMaybe<CourseSchoolsHasCourseConnectionWhere>;
  OR?: InputMaybe<Array<CourseSchoolsHasCourseConnectionWhere>>;
  node?: InputMaybe<SchoolWhere>;
};

export type CourseSchoolsHasCourseCreateFieldInput = {
  node: SchoolCreateInput;
};

export type CourseSchoolsHasCourseDeleteFieldInput = {
  delete?: InputMaybe<SchoolDeleteInput>;
  where?: InputMaybe<CourseSchoolsHasCourseConnectionWhere>;
};

export type CourseSchoolsHasCourseDisconnectFieldInput = {
  disconnect?: InputMaybe<SchoolDisconnectInput>;
  where?: InputMaybe<CourseSchoolsHasCourseConnectionWhere>;
};

export type CourseSchoolsHasCourseFieldInput = {
  connect?: InputMaybe<Array<CourseSchoolsHasCourseConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CourseSchoolsHasCourseConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CourseSchoolsHasCourseCreateFieldInput>>;
};

export type CourseSchoolsHasCourseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CourseSchoolsHasCourseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CourseSchoolsHasCourseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CourseSchoolsHasCourseNodeAggregationWhereInput>>;
  brightspace_api_client_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_secret_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_secret_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_secret_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_secret_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_secret_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  domain_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domain_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  provider_icon_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  provider_icon_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  provider_icon_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  provider_icon_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  provider_icon_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  provider_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  provider_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  provider_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  provider_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  provider_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  provider_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  provider_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  provider_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  provider_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  provider_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  provider_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  provider_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  provider_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  provider_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  provider_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  team_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  team_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  team_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  team_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  team_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  team_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  team_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  team_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  team_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  team_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  team_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  team_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  team_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  team_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  team_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CourseSchoolsHasCourseRelationship = {
  __typename?: 'CourseSchoolsHasCourseRelationship';
  cursor: Scalars['String']['output'];
  node: School;
};

export type CourseSchoolsHasCourseUpdateConnectionInput = {
  node?: InputMaybe<SchoolUpdateInput>;
};

export type CourseSchoolsHasCourseUpdateFieldInput = {
  connect?: InputMaybe<Array<CourseSchoolsHasCourseConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CourseSchoolsHasCourseConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CourseSchoolsHasCourseCreateFieldInput>>;
  delete?: InputMaybe<Array<CourseSchoolsHasCourseDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CourseSchoolsHasCourseDisconnectFieldInput>>;
  update?: InputMaybe<CourseSchoolsHasCourseUpdateConnectionInput>;
  where?: InputMaybe<CourseSchoolsHasCourseConnectionWhere>;
};

export type CourseSessionAnalyticsData = {
  __typename?: 'CourseSessionAnalyticsData';
  averageDuration?: Maybe<Scalars['Int']['output']>;
  course_code?: Maybe<Scalars['String']['output']>;
  firstActiveDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  instructor?: Maybe<Scalars['String']['output']>;
  lastActiveDate?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  students?: Maybe<Scalars['Int']['output']>;
  totalDuration?: Maybe<Scalars['Int']['output']>;
  totalSessions?: Maybe<Scalars['Int']['output']>;
};

export type CourseSessionAnalyticsInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  facultyId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type CourseSessionAnalyticsResponse = {
  __typename?: 'CourseSessionAnalyticsResponse';
  data?: Maybe<Array<Maybe<CourseSessionAnalyticsData>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  topActiveUsers?: Maybe<Array<TopActiveUser>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Fields to sort Courses by. The order in which sorts are applied is not guaranteed when specifying many fields in one CourseSort object. */
export type CourseSort = {
  account_id?: InputMaybe<SortDirection>;
  apply_assignment_group_weights?: InputMaybe<SortDirection>;
  blueprint?: InputMaybe<SortDirection>;
  calendar_ics?: InputMaybe<SortDirection>;
  cost?: InputMaybe<SortDirection>;
  courseId?: InputMaybe<SortDirection>;
  course_code?: InputMaybe<SortDirection>;
  course_id?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  created_at?: InputMaybe<SortDirection>;
  created_date?: InputMaybe<SortDirection>;
  default_view?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  dueDateEndDate?: InputMaybe<SortDirection>;
  dueDateStartDate?: InputMaybe<SortDirection>;
  endDate?: InputMaybe<SortDirection>;
  end_at?: InputMaybe<SortDirection>;
  enrollment_term_id?: InputMaybe<SortDirection>;
  generationStatus?: InputMaybe<SortDirection>;
  grading_standard_id?: InputMaybe<SortDirection>;
  hide_final_grades?: InputMaybe<SortDirection>;
  homeroom_course?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  integration_id?: InputMaybe<SortDirection>;
  isCustomCourse?: InputMaybe<SortDirection>;
  isDraft?: InputMaybe<SortDirection>;
  isEnrollmentAvailable?: InputMaybe<SortDirection>;
  is_elective?: InputMaybe<SortDirection>;
  is_public?: InputMaybe<SortDirection>;
  is_public_to_auth_users?: InputMaybe<SortDirection>;
  label?: InputMaybe<SortDirection>;
  last_modified?: InputMaybe<SortDirection>;
  learningStandards?: InputMaybe<SortDirection>;
  lengthInWeeks?: InputMaybe<SortDirection>;
  license?: InputMaybe<SortDirection>;
  lti_id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  original_name?: InputMaybe<SortDirection>;
  public_syllabus?: InputMaybe<SortDirection>;
  public_syllabus_to_auth?: InputMaybe<SortDirection>;
  restrict_enrollments_to_course_dates?: InputMaybe<SortDirection>;
  root_account_id?: InputMaybe<SortDirection>;
  sis_course_id?: InputMaybe<SortDirection>;
  sis_import_id?: InputMaybe<SortDirection>;
  startDate?: InputMaybe<SortDirection>;
  start_at?: InputMaybe<SortDirection>;
  state?: InputMaybe<SortDirection>;
  storage_quota_mb?: InputMaybe<SortDirection>;
  stripePriceId?: InputMaybe<SortDirection>;
  stripeProductId?: InputMaybe<SortDirection>;
  targetAudience?: InputMaybe<SortDirection>;
  template?: InputMaybe<SortDirection>;
  thumbnail?: InputMaybe<SortDirection>;
  time_zone?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  updated_date?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
  workflow_state?: InputMaybe<SortDirection>;
};

export type CourseTeachingFacultyAggregateInput = {
  AND?: InputMaybe<Array<CourseTeachingFacultyAggregateInput>>;
  NOT?: InputMaybe<CourseTeachingFacultyAggregateInput>;
  OR?: InputMaybe<Array<CourseTeachingFacultyAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CourseTeachingFacultyNodeAggregationWhereInput>;
};

export type CourseTeachingFacultyConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type CourseTeachingFacultyConnectOrCreateFieldInput = {
  onCreate: CourseTeachingFacultyConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type CourseTeachingFacultyConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type CourseTeachingFacultyConnection = {
  __typename?: 'CourseTeachingFacultyConnection';
  edges: Array<CourseTeachingFacultyRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CourseTeachingFacultyConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type CourseTeachingFacultyConnectionWhere = {
  AND?: InputMaybe<Array<CourseTeachingFacultyConnectionWhere>>;
  NOT?: InputMaybe<CourseTeachingFacultyConnectionWhere>;
  OR?: InputMaybe<Array<CourseTeachingFacultyConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type CourseTeachingFacultyCreateFieldInput = {
  node: UserCreateInput;
};

export type CourseTeachingFacultyDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<CourseTeachingFacultyConnectionWhere>;
};

export type CourseTeachingFacultyDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<CourseTeachingFacultyConnectionWhere>;
};

export type CourseTeachingFacultyFieldInput = {
  connect?: InputMaybe<Array<CourseTeachingFacultyConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CourseTeachingFacultyConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CourseTeachingFacultyCreateFieldInput>>;
};

export type CourseTeachingFacultyNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CourseTeachingFacultyNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CourseTeachingFacultyNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CourseTeachingFacultyNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CourseTeachingFacultyRelationship = {
  __typename?: 'CourseTeachingFacultyRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type CourseTeachingFacultyUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type CourseTeachingFacultyUpdateFieldInput = {
  connect?: InputMaybe<Array<CourseTeachingFacultyConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CourseTeachingFacultyConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CourseTeachingFacultyCreateFieldInput>>;
  delete?: InputMaybe<Array<CourseTeachingFacultyDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CourseTeachingFacultyDisconnectFieldInput>>;
  update?: InputMaybe<CourseTeachingFacultyUpdateConnectionInput>;
  where?: InputMaybe<CourseTeachingFacultyConnectionWhere>;
};

export type CourseUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CourseUpdateInput = {
  account_id?: InputMaybe<Scalars['Float']['input']>;
  account_id_ADD?: InputMaybe<Scalars['Float']['input']>;
  account_id_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  announcements?: InputMaybe<Array<CourseAnnouncementsUpdateFieldInput>>;
  apply_assignment_group_weights?: InputMaybe<Scalars['Boolean']['input']>;
  auditEvents?: InputMaybe<Array<CourseAuditEventsUpdateFieldInput>>;
  blueprint?: InputMaybe<Scalars['Boolean']['input']>;
  calendar_ics?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<Scalars['Float']['input']>;
  cost_ADD?: InputMaybe<Scalars['Float']['input']>;
  cost_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  cost_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  cost_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  courseId?: InputMaybe<Scalars['String']['input']>;
  course_code?: InputMaybe<Scalars['String']['input']>;
  course_id?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_at?: InputMaybe<Scalars['String']['input']>;
  created_date?: InputMaybe<Scalars['String']['input']>;
  default_view?: InputMaybe<Scalars['String']['input']>;
  degreesHasCourse?: InputMaybe<Array<CourseDegreesHasCourseUpdateFieldInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Array<CourseDocumentsUpdateFieldInput>>;
  dueDateEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  end_at?: InputMaybe<Scalars['String']['input']>;
  enrolledStudents?: InputMaybe<Array<CourseEnrolledStudentsUpdateFieldInput>>;
  enrollmentLink?: InputMaybe<CourseEnrollmentLinkUpdateFieldInput>;
  enrollment_term_id?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_ADD?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  evaluations?: InputMaybe<Array<CourseEvaluationsUpdateFieldInput>>;
  externalIntegrations?: InputMaybe<Array<CourseExternalIntegrationsUpdateFieldInput>>;
  forum?: InputMaybe<CourseForumUpdateFieldInput>;
  generationStatus?: InputMaybe<CourseGenerationStatus>;
  grading_standard_id?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_ADD?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  hasAssignmentAssignments?: InputMaybe<Array<CourseHasAssignmentAssignmentsUpdateFieldInput>>;
  hasCourseCategoriesCourseCategories?: InputMaybe<Array<CourseHasCourseCategoriesCourseCategoriesUpdateFieldInput>>;
  hasPagePages?: InputMaybe<Array<CourseHasPagePagesUpdateFieldInput>>;
  hide_final_grades?: InputMaybe<Scalars['Boolean']['input']>;
  homeroom_course?: InputMaybe<Scalars['Boolean']['input']>;
  integration_id?: InputMaybe<Scalars['String']['input']>;
  isCustomCourse?: InputMaybe<Scalars['Boolean']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isEnrollmentAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  is_elective?: InputMaybe<Scalars['Boolean']['input']>;
  is_public?: InputMaybe<Scalars['Boolean']['input']>;
  is_public_to_auth_users?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  learningStandards?: InputMaybe<Scalars['String']['input']>;
  lengthInWeeks?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_ADD?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  lti_id?: InputMaybe<Scalars['String']['input']>;
  moduleOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  moduleOrder_POP?: InputMaybe<Scalars['Int']['input']>;
  moduleOrder_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  modules?: InputMaybe<Array<CourseModulesUpdateFieldInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  nudgesAboutThis?: InputMaybe<Array<CourseNudgesAboutThisUpdateFieldInput>>;
  objectives?: InputMaybe<Array<Scalars['String']['input']>>;
  objectives_POP?: InputMaybe<Scalars['Int']['input']>;
  objectives_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  original_name?: InputMaybe<Scalars['String']['input']>;
  period_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  period_ids_POP?: InputMaybe<Scalars['Int']['input']>;
  period_ids_PUSH?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  periods?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  periods_POP?: InputMaybe<Scalars['Int']['input']>;
  periods_PUSH?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preRequisiteFor?: InputMaybe<Array<CoursePreRequisiteForUpdateFieldInput>>;
  preRequisites?: InputMaybe<Array<CoursePreRequisitesUpdateFieldInput>>;
  public_syllabus?: InputMaybe<Scalars['Boolean']['input']>;
  public_syllabus_to_auth?: InputMaybe<Scalars['Boolean']['input']>;
  restrict_enrollments_to_course_dates?: InputMaybe<Scalars['Boolean']['input']>;
  root_account_id?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_ADD?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  schoolsHasCourse?: InputMaybe<Array<CourseSchoolsHasCourseUpdateFieldInput>>;
  sis_course_id?: InputMaybe<Scalars['String']['input']>;
  sis_import_id?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_ADD?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  start_at?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  storage_quota_mb?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_ADD?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId?: InputMaybe<Scalars['String']['input']>;
  stripeProductId?: InputMaybe<Scalars['String']['input']>;
  targetAudience?: InputMaybe<Scalars['String']['input']>;
  teachingFaculty?: InputMaybe<Array<CourseTeachingFacultyUpdateFieldInput>>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  time_zone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['String']['input']>;
  usersHasSchoolCourse?: InputMaybe<Array<CourseUsersHasSchoolCourseUpdateFieldInput>>;
  usersHaveLearningPayment?: InputMaybe<Array<CourseUsersHaveLearningPaymentUpdateFieldInput>>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  workflow_state?: InputMaybe<Scalars['String']['input']>;
  workspaces?: InputMaybe<Array<CourseWorkspacesUpdateFieldInput>>;
};

export type CourseUserEnrolledStudentsAggregationSelection = {
  __typename?: 'CourseUserEnrolledStudentsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<CourseUserEnrolledStudentsEdgeAggregateSelection>;
  node?: Maybe<CourseUserEnrolledStudentsNodeAggregateSelection>;
};

export type CourseUserEnrolledStudentsEdgeAggregateSelection = {
  __typename?: 'CourseUserEnrolledStudentsEdgeAggregateSelection';
  created: DateTimeAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
};

export type CourseUserEnrolledStudentsNodeAggregateSelection = {
  __typename?: 'CourseUserEnrolledStudentsNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type CourseUserTeachingFacultyAggregationSelection = {
  __typename?: 'CourseUserTeachingFacultyAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CourseUserTeachingFacultyNodeAggregateSelection>;
};

export type CourseUserTeachingFacultyNodeAggregateSelection = {
  __typename?: 'CourseUserTeachingFacultyNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type CourseUserUsersHasSchoolCourseAggregationSelection = {
  __typename?: 'CourseUserUsersHasSchoolCourseAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CourseUserUsersHasSchoolCourseNodeAggregateSelection>;
};

export type CourseUserUsersHasSchoolCourseNodeAggregateSelection = {
  __typename?: 'CourseUserUsersHasSchoolCourseNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type CourseUsersHasSchoolCourseAggregateInput = {
  AND?: InputMaybe<Array<CourseUsersHasSchoolCourseAggregateInput>>;
  NOT?: InputMaybe<CourseUsersHasSchoolCourseAggregateInput>;
  OR?: InputMaybe<Array<CourseUsersHasSchoolCourseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CourseUsersHasSchoolCourseNodeAggregationWhereInput>;
};

export type CourseUsersHasSchoolCourseConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type CourseUsersHasSchoolCourseConnectOrCreateFieldInput = {
  onCreate: CourseUsersHasSchoolCourseConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type CourseUsersHasSchoolCourseConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type CourseUsersHasSchoolCourseConnection = {
  __typename?: 'CourseUsersHasSchoolCourseConnection';
  edges: Array<CourseUsersHasSchoolCourseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CourseUsersHasSchoolCourseConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type CourseUsersHasSchoolCourseConnectionWhere = {
  AND?: InputMaybe<Array<CourseUsersHasSchoolCourseConnectionWhere>>;
  NOT?: InputMaybe<CourseUsersHasSchoolCourseConnectionWhere>;
  OR?: InputMaybe<Array<CourseUsersHasSchoolCourseConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type CourseUsersHasSchoolCourseCreateFieldInput = {
  node: UserCreateInput;
};

export type CourseUsersHasSchoolCourseDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<CourseUsersHasSchoolCourseConnectionWhere>;
};

export type CourseUsersHasSchoolCourseDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<CourseUsersHasSchoolCourseConnectionWhere>;
};

export type CourseUsersHasSchoolCourseFieldInput = {
  connect?: InputMaybe<Array<CourseUsersHasSchoolCourseConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CourseUsersHasSchoolCourseConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CourseUsersHasSchoolCourseCreateFieldInput>>;
};

export type CourseUsersHasSchoolCourseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CourseUsersHasSchoolCourseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CourseUsersHasSchoolCourseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CourseUsersHasSchoolCourseNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CourseUsersHasSchoolCourseRelationship = {
  __typename?: 'CourseUsersHasSchoolCourseRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type CourseUsersHasSchoolCourseUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type CourseUsersHasSchoolCourseUpdateFieldInput = {
  connect?: InputMaybe<Array<CourseUsersHasSchoolCourseConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CourseUsersHasSchoolCourseConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CourseUsersHasSchoolCourseCreateFieldInput>>;
  delete?: InputMaybe<Array<CourseUsersHasSchoolCourseDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CourseUsersHasSchoolCourseDisconnectFieldInput>>;
  update?: InputMaybe<CourseUsersHasSchoolCourseUpdateConnectionInput>;
  where?: InputMaybe<CourseUsersHasSchoolCourseConnectionWhere>;
};

export type CourseUsersHaveLearningPaymentAggregateInput = {
  AND?: InputMaybe<Array<CourseUsersHaveLearningPaymentAggregateInput>>;
  NOT?: InputMaybe<CourseUsersHaveLearningPaymentAggregateInput>;
  OR?: InputMaybe<Array<CourseUsersHaveLearningPaymentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CourseUsersHaveLearningPaymentNodeAggregationWhereInput>;
};

export type CourseUsersHaveLearningPaymentConnectFieldInput = {
  connect?: InputMaybe<Array<LearningPaymentConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LearningPaymentConnectWhere>;
};

export type CourseUsersHaveLearningPaymentConnectOrCreateFieldInput = {
  onCreate: CourseUsersHaveLearningPaymentConnectOrCreateFieldInputOnCreate;
  where: LearningPaymentConnectOrCreateWhere;
};

export type CourseUsersHaveLearningPaymentConnectOrCreateFieldInputOnCreate = {
  node: LearningPaymentOnCreateInput;
};

export type CourseUsersHaveLearningPaymentConnection = {
  __typename?: 'CourseUsersHaveLearningPaymentConnection';
  edges: Array<CourseUsersHaveLearningPaymentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CourseUsersHaveLearningPaymentConnectionSort = {
  node?: InputMaybe<LearningPaymentSort>;
};

export type CourseUsersHaveLearningPaymentConnectionWhere = {
  AND?: InputMaybe<Array<CourseUsersHaveLearningPaymentConnectionWhere>>;
  NOT?: InputMaybe<CourseUsersHaveLearningPaymentConnectionWhere>;
  OR?: InputMaybe<Array<CourseUsersHaveLearningPaymentConnectionWhere>>;
  node?: InputMaybe<LearningPaymentWhere>;
};

export type CourseUsersHaveLearningPaymentCreateFieldInput = {
  node: LearningPaymentCreateInput;
};

export type CourseUsersHaveLearningPaymentDeleteFieldInput = {
  delete?: InputMaybe<LearningPaymentDeleteInput>;
  where?: InputMaybe<CourseUsersHaveLearningPaymentConnectionWhere>;
};

export type CourseUsersHaveLearningPaymentDisconnectFieldInput = {
  disconnect?: InputMaybe<LearningPaymentDisconnectInput>;
  where?: InputMaybe<CourseUsersHaveLearningPaymentConnectionWhere>;
};

export type CourseUsersHaveLearningPaymentFieldInput = {
  connect?: InputMaybe<Array<CourseUsersHaveLearningPaymentConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CourseUsersHaveLearningPaymentConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CourseUsersHaveLearningPaymentCreateFieldInput>>;
};

export type CourseUsersHaveLearningPaymentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CourseUsersHaveLearningPaymentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CourseUsersHaveLearningPaymentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CourseUsersHaveLearningPaymentNodeAggregationWhereInput>>;
  amount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  discountAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  promotionCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  promotionCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  promotionCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  promotionCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  promotionCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  promotionCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  promotionCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  promotionCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  promotionCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  promotionCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  promotionCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  promotionCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  promotionCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  promotionCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  promotionCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CourseUsersHaveLearningPaymentRelationship = {
  __typename?: 'CourseUsersHaveLearningPaymentRelationship';
  cursor: Scalars['String']['output'];
  node: LearningPayment;
};

export type CourseUsersHaveLearningPaymentUpdateConnectionInput = {
  node?: InputMaybe<LearningPaymentUpdateInput>;
};

export type CourseUsersHaveLearningPaymentUpdateFieldInput = {
  connect?: InputMaybe<Array<CourseUsersHaveLearningPaymentConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CourseUsersHaveLearningPaymentConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CourseUsersHaveLearningPaymentCreateFieldInput>>;
  delete?: InputMaybe<Array<CourseUsersHaveLearningPaymentDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CourseUsersHaveLearningPaymentDisconnectFieldInput>>;
  update?: InputMaybe<CourseUsersHaveLearningPaymentUpdateConnectionInput>;
  where?: InputMaybe<CourseUsersHaveLearningPaymentConnectionWhere>;
};

export type CourseWhere = {
  AND?: InputMaybe<Array<CourseWhere>>;
  NOT?: InputMaybe<CourseWhere>;
  OR?: InputMaybe<Array<CourseWhere>>;
  account_id?: InputMaybe<Scalars['Float']['input']>;
  account_id_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  account_id_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_LTE?: InputMaybe<Scalars['Float']['input']>;
  announcementsAggregate?: InputMaybe<CourseAnnouncementsAggregateInput>;
  /** Return Courses where all of the related CourseAnnouncementsConnections match this filter */
  announcementsConnection_ALL?: InputMaybe<CourseAnnouncementsConnectionWhere>;
  /** Return Courses where none of the related CourseAnnouncementsConnections match this filter */
  announcementsConnection_NONE?: InputMaybe<CourseAnnouncementsConnectionWhere>;
  /** Return Courses where one of the related CourseAnnouncementsConnections match this filter */
  announcementsConnection_SINGLE?: InputMaybe<CourseAnnouncementsConnectionWhere>;
  /** Return Courses where some of the related CourseAnnouncementsConnections match this filter */
  announcementsConnection_SOME?: InputMaybe<CourseAnnouncementsConnectionWhere>;
  /** Return Courses where all of the related Announcements match this filter */
  announcements_ALL?: InputMaybe<AnnouncementWhere>;
  /** Return Courses where none of the related Announcements match this filter */
  announcements_NONE?: InputMaybe<AnnouncementWhere>;
  /** Return Courses where one of the related Announcements match this filter */
  announcements_SINGLE?: InputMaybe<AnnouncementWhere>;
  /** Return Courses where some of the related Announcements match this filter */
  announcements_SOME?: InputMaybe<AnnouncementWhere>;
  apply_assignment_group_weights?: InputMaybe<Scalars['Boolean']['input']>;
  auditEventsAggregate?: InputMaybe<CourseAuditEventsAggregateInput>;
  /** Return Courses where all of the related CourseAuditEventsConnections match this filter */
  auditEventsConnection_ALL?: InputMaybe<CourseAuditEventsConnectionWhere>;
  /** Return Courses where none of the related CourseAuditEventsConnections match this filter */
  auditEventsConnection_NONE?: InputMaybe<CourseAuditEventsConnectionWhere>;
  /** Return Courses where one of the related CourseAuditEventsConnections match this filter */
  auditEventsConnection_SINGLE?: InputMaybe<CourseAuditEventsConnectionWhere>;
  /** Return Courses where some of the related CourseAuditEventsConnections match this filter */
  auditEventsConnection_SOME?: InputMaybe<CourseAuditEventsConnectionWhere>;
  /** Return Courses where all of the related AuditEvents match this filter */
  auditEvents_ALL?: InputMaybe<AuditEventWhere>;
  /** Return Courses where none of the related AuditEvents match this filter */
  auditEvents_NONE?: InputMaybe<AuditEventWhere>;
  /** Return Courses where one of the related AuditEvents match this filter */
  auditEvents_SINGLE?: InputMaybe<AuditEventWhere>;
  /** Return Courses where some of the related AuditEvents match this filter */
  auditEvents_SOME?: InputMaybe<AuditEventWhere>;
  blueprint?: InputMaybe<Scalars['Boolean']['input']>;
  calendar_ics?: InputMaybe<Scalars['String']['input']>;
  calendar_ics_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  calendar_ics_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  calendar_ics_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  calendar_ics_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<Scalars['Float']['input']>;
  cost_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  cost_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId?: InputMaybe<Scalars['String']['input']>;
  courseId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  courseId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  courseId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  courseId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  course_code?: InputMaybe<Scalars['String']['input']>;
  course_code_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  course_code_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  course_code_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  course_code_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  course_id?: InputMaybe<Scalars['String']['input']>;
  course_id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  course_id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  course_id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  course_id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at?: InputMaybe<Scalars['String']['input']>;
  created_at_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  created_at_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  created_at_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  created_at_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  created_date?: InputMaybe<Scalars['String']['input']>;
  created_date_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  created_date_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  created_date_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  created_date_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  default_view?: InputMaybe<Scalars['String']['input']>;
  default_view_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  default_view_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  default_view_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  default_view_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  degreesHasCourseAggregate?: InputMaybe<CourseDegreesHasCourseAggregateInput>;
  /** Return Courses where all of the related CourseDegreesHasCourseConnections match this filter */
  degreesHasCourseConnection_ALL?: InputMaybe<CourseDegreesHasCourseConnectionWhere>;
  /** Return Courses where none of the related CourseDegreesHasCourseConnections match this filter */
  degreesHasCourseConnection_NONE?: InputMaybe<CourseDegreesHasCourseConnectionWhere>;
  /** Return Courses where one of the related CourseDegreesHasCourseConnections match this filter */
  degreesHasCourseConnection_SINGLE?: InputMaybe<CourseDegreesHasCourseConnectionWhere>;
  /** Return Courses where some of the related CourseDegreesHasCourseConnections match this filter */
  degreesHasCourseConnection_SOME?: InputMaybe<CourseDegreesHasCourseConnectionWhere>;
  /** Return Courses where all of the related Degrees match this filter */
  degreesHasCourse_ALL?: InputMaybe<DegreeWhere>;
  /** Return Courses where none of the related Degrees match this filter */
  degreesHasCourse_NONE?: InputMaybe<DegreeWhere>;
  /** Return Courses where one of the related Degrees match this filter */
  degreesHasCourse_SINGLE?: InputMaybe<DegreeWhere>;
  /** Return Courses where some of the related Degrees match this filter */
  degreesHasCourse_SOME?: InputMaybe<DegreeWhere>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentsAggregate?: InputMaybe<CourseDocumentsAggregateInput>;
  /** Return Courses where all of the related CourseDocumentsConnections match this filter */
  documentsConnection_ALL?: InputMaybe<CourseDocumentsConnectionWhere>;
  /** Return Courses where none of the related CourseDocumentsConnections match this filter */
  documentsConnection_NONE?: InputMaybe<CourseDocumentsConnectionWhere>;
  /** Return Courses where one of the related CourseDocumentsConnections match this filter */
  documentsConnection_SINGLE?: InputMaybe<CourseDocumentsConnectionWhere>;
  /** Return Courses where some of the related CourseDocumentsConnections match this filter */
  documentsConnection_SOME?: InputMaybe<CourseDocumentsConnectionWhere>;
  /** Return Courses where all of the related Documents match this filter */
  documents_ALL?: InputMaybe<DocumentWhere>;
  /** Return Courses where none of the related Documents match this filter */
  documents_NONE?: InputMaybe<DocumentWhere>;
  /** Return Courses where one of the related Documents match this filter */
  documents_SINGLE?: InputMaybe<DocumentWhere>;
  /** Return Courses where some of the related Documents match this filter */
  documents_SOME?: InputMaybe<DocumentWhere>;
  dueDateEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  dueDateEndDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  dueDateStartDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  endDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_at?: InputMaybe<Scalars['String']['input']>;
  end_at_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  end_at_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  end_at_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  end_at_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  enrolledStudentsAggregate?: InputMaybe<CourseEnrolledStudentsAggregateInput>;
  /** Return Courses where all of the related CourseEnrolledStudentsConnections match this filter */
  enrolledStudentsConnection_ALL?: InputMaybe<CourseEnrolledStudentsConnectionWhere>;
  /** Return Courses where none of the related CourseEnrolledStudentsConnections match this filter */
  enrolledStudentsConnection_NONE?: InputMaybe<CourseEnrolledStudentsConnectionWhere>;
  /** Return Courses where one of the related CourseEnrolledStudentsConnections match this filter */
  enrolledStudentsConnection_SINGLE?: InputMaybe<CourseEnrolledStudentsConnectionWhere>;
  /** Return Courses where some of the related CourseEnrolledStudentsConnections match this filter */
  enrolledStudentsConnection_SOME?: InputMaybe<CourseEnrolledStudentsConnectionWhere>;
  /** Return Courses where all of the related Users match this filter */
  enrolledStudents_ALL?: InputMaybe<UserWhere>;
  /** Return Courses where none of the related Users match this filter */
  enrolledStudents_NONE?: InputMaybe<UserWhere>;
  /** Return Courses where one of the related Users match this filter */
  enrolledStudents_SINGLE?: InputMaybe<UserWhere>;
  /** Return Courses where some of the related Users match this filter */
  enrolledStudents_SOME?: InputMaybe<UserWhere>;
  enrollmentLink?: InputMaybe<EnrollmentLinkWhere>;
  enrollmentLinkAggregate?: InputMaybe<CourseEnrollmentLinkAggregateInput>;
  enrollmentLinkConnection?: InputMaybe<CourseEnrollmentLinkConnectionWhere>;
  enrollmentLinkConnection_NOT?: InputMaybe<CourseEnrollmentLinkConnectionWhere>;
  enrollmentLink_NOT?: InputMaybe<EnrollmentLinkWhere>;
  enrollment_term_id?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  enrollment_term_id_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_LTE?: InputMaybe<Scalars['Float']['input']>;
  evaluationsAggregate?: InputMaybe<CourseEvaluationsAggregateInput>;
  /** Return Courses where all of the related CourseEvaluationsConnections match this filter */
  evaluationsConnection_ALL?: InputMaybe<CourseEvaluationsConnectionWhere>;
  /** Return Courses where none of the related CourseEvaluationsConnections match this filter */
  evaluationsConnection_NONE?: InputMaybe<CourseEvaluationsConnectionWhere>;
  /** Return Courses where one of the related CourseEvaluationsConnections match this filter */
  evaluationsConnection_SINGLE?: InputMaybe<CourseEvaluationsConnectionWhere>;
  /** Return Courses where some of the related CourseEvaluationsConnections match this filter */
  evaluationsConnection_SOME?: InputMaybe<CourseEvaluationsConnectionWhere>;
  /** Return Courses where all of the related CourseEvaluations match this filter */
  evaluations_ALL?: InputMaybe<CourseEvaluationWhere>;
  /** Return Courses where none of the related CourseEvaluations match this filter */
  evaluations_NONE?: InputMaybe<CourseEvaluationWhere>;
  /** Return Courses where one of the related CourseEvaluations match this filter */
  evaluations_SINGLE?: InputMaybe<CourseEvaluationWhere>;
  /** Return Courses where some of the related CourseEvaluations match this filter */
  evaluations_SOME?: InputMaybe<CourseEvaluationWhere>;
  externalIntegrationsAggregate?: InputMaybe<CourseExternalIntegrationsAggregateInput>;
  /** Return Courses where all of the related CourseExternalIntegrationsConnections match this filter */
  externalIntegrationsConnection_ALL?: InputMaybe<CourseExternalIntegrationsConnectionWhere>;
  /** Return Courses where none of the related CourseExternalIntegrationsConnections match this filter */
  externalIntegrationsConnection_NONE?: InputMaybe<CourseExternalIntegrationsConnectionWhere>;
  /** Return Courses where one of the related CourseExternalIntegrationsConnections match this filter */
  externalIntegrationsConnection_SINGLE?: InputMaybe<CourseExternalIntegrationsConnectionWhere>;
  /** Return Courses where some of the related CourseExternalIntegrationsConnections match this filter */
  externalIntegrationsConnection_SOME?: InputMaybe<CourseExternalIntegrationsConnectionWhere>;
  /** Return Courses where all of the related CourseExternalIntegrations match this filter */
  externalIntegrations_ALL?: InputMaybe<CourseExternalIntegrationWhere>;
  /** Return Courses where none of the related CourseExternalIntegrations match this filter */
  externalIntegrations_NONE?: InputMaybe<CourseExternalIntegrationWhere>;
  /** Return Courses where one of the related CourseExternalIntegrations match this filter */
  externalIntegrations_SINGLE?: InputMaybe<CourseExternalIntegrationWhere>;
  /** Return Courses where some of the related CourseExternalIntegrations match this filter */
  externalIntegrations_SOME?: InputMaybe<CourseExternalIntegrationWhere>;
  forum?: InputMaybe<ForumWhere>;
  forumAggregate?: InputMaybe<CourseForumAggregateInput>;
  forumConnection?: InputMaybe<CourseForumConnectionWhere>;
  forumConnection_NOT?: InputMaybe<CourseForumConnectionWhere>;
  forum_NOT?: InputMaybe<ForumWhere>;
  generationStatus?: InputMaybe<CourseGenerationStatus>;
  generationStatus_IN?: InputMaybe<Array<InputMaybe<CourseGenerationStatus>>>;
  grading_standard_id?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  grading_standard_id_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_LTE?: InputMaybe<Scalars['Float']['input']>;
  hasAssignmentAssignmentsAggregate?: InputMaybe<CourseHasAssignmentAssignmentsAggregateInput>;
  /** Return Courses where all of the related CourseHasAssignmentAssignmentsConnections match this filter */
  hasAssignmentAssignmentsConnection_ALL?: InputMaybe<CourseHasAssignmentAssignmentsConnectionWhere>;
  /** Return Courses where none of the related CourseHasAssignmentAssignmentsConnections match this filter */
  hasAssignmentAssignmentsConnection_NONE?: InputMaybe<CourseHasAssignmentAssignmentsConnectionWhere>;
  /** Return Courses where one of the related CourseHasAssignmentAssignmentsConnections match this filter */
  hasAssignmentAssignmentsConnection_SINGLE?: InputMaybe<CourseHasAssignmentAssignmentsConnectionWhere>;
  /** Return Courses where some of the related CourseHasAssignmentAssignmentsConnections match this filter */
  hasAssignmentAssignmentsConnection_SOME?: InputMaybe<CourseHasAssignmentAssignmentsConnectionWhere>;
  /** Return Courses where all of the related Assignments match this filter */
  hasAssignmentAssignments_ALL?: InputMaybe<AssignmentWhere>;
  /** Return Courses where none of the related Assignments match this filter */
  hasAssignmentAssignments_NONE?: InputMaybe<AssignmentWhere>;
  /** Return Courses where one of the related Assignments match this filter */
  hasAssignmentAssignments_SINGLE?: InputMaybe<AssignmentWhere>;
  /** Return Courses where some of the related Assignments match this filter */
  hasAssignmentAssignments_SOME?: InputMaybe<AssignmentWhere>;
  hasCourseCategoriesCourseCategoriesAggregate?: InputMaybe<CourseHasCourseCategoriesCourseCategoriesAggregateInput>;
  /** Return Courses where all of the related CourseHasCourseCategoriesCourseCategoriesConnections match this filter */
  hasCourseCategoriesCourseCategoriesConnection_ALL?: InputMaybe<CourseHasCourseCategoriesCourseCategoriesConnectionWhere>;
  /** Return Courses where none of the related CourseHasCourseCategoriesCourseCategoriesConnections match this filter */
  hasCourseCategoriesCourseCategoriesConnection_NONE?: InputMaybe<CourseHasCourseCategoriesCourseCategoriesConnectionWhere>;
  /** Return Courses where one of the related CourseHasCourseCategoriesCourseCategoriesConnections match this filter */
  hasCourseCategoriesCourseCategoriesConnection_SINGLE?: InputMaybe<CourseHasCourseCategoriesCourseCategoriesConnectionWhere>;
  /** Return Courses where some of the related CourseHasCourseCategoriesCourseCategoriesConnections match this filter */
  hasCourseCategoriesCourseCategoriesConnection_SOME?: InputMaybe<CourseHasCourseCategoriesCourseCategoriesConnectionWhere>;
  /** Return Courses where all of the related CourseCategories match this filter */
  hasCourseCategoriesCourseCategories_ALL?: InputMaybe<CourseCategoryWhere>;
  /** Return Courses where none of the related CourseCategories match this filter */
  hasCourseCategoriesCourseCategories_NONE?: InputMaybe<CourseCategoryWhere>;
  /** Return Courses where one of the related CourseCategories match this filter */
  hasCourseCategoriesCourseCategories_SINGLE?: InputMaybe<CourseCategoryWhere>;
  /** Return Courses where some of the related CourseCategories match this filter */
  hasCourseCategoriesCourseCategories_SOME?: InputMaybe<CourseCategoryWhere>;
  hasPagePagesAggregate?: InputMaybe<CourseHasPagePagesAggregateInput>;
  /** Return Courses where all of the related CourseHasPagePagesConnections match this filter */
  hasPagePagesConnection_ALL?: InputMaybe<CourseHasPagePagesConnectionWhere>;
  /** Return Courses where none of the related CourseHasPagePagesConnections match this filter */
  hasPagePagesConnection_NONE?: InputMaybe<CourseHasPagePagesConnectionWhere>;
  /** Return Courses where one of the related CourseHasPagePagesConnections match this filter */
  hasPagePagesConnection_SINGLE?: InputMaybe<CourseHasPagePagesConnectionWhere>;
  /** Return Courses where some of the related CourseHasPagePagesConnections match this filter */
  hasPagePagesConnection_SOME?: InputMaybe<CourseHasPagePagesConnectionWhere>;
  /** Return Courses where all of the related Pages match this filter */
  hasPagePages_ALL?: InputMaybe<PageWhere>;
  /** Return Courses where none of the related Pages match this filter */
  hasPagePages_NONE?: InputMaybe<PageWhere>;
  /** Return Courses where one of the related Pages match this filter */
  hasPagePages_SINGLE?: InputMaybe<PageWhere>;
  /** Return Courses where some of the related Pages match this filter */
  hasPagePages_SOME?: InputMaybe<PageWhere>;
  hide_final_grades?: InputMaybe<Scalars['Boolean']['input']>;
  homeroom_course?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  integration_id?: InputMaybe<Scalars['String']['input']>;
  integration_id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  integration_id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  integration_id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  integration_id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  isCustomCourse?: InputMaybe<Scalars['Boolean']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isEnrollmentAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  is_elective?: InputMaybe<Scalars['Boolean']['input']>;
  is_public?: InputMaybe<Scalars['Boolean']['input']>;
  is_public_to_auth_users?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  label_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  label_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  last_modified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningStandards?: InputMaybe<Scalars['String']['input']>;
  learningStandards_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  learningStandards_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  learningStandards_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  learningStandards_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lengthInWeeks?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lengthInWeeks_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_LTE?: InputMaybe<Scalars['Float']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  license_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  license_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  license_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  license_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lti_id?: InputMaybe<Scalars['String']['input']>;
  lti_id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lti_id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lti_id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lti_id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  moduleOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  moduleOrder_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  modulesAggregate?: InputMaybe<CourseModulesAggregateInput>;
  /** Return Courses where all of the related CourseModulesConnections match this filter */
  modulesConnection_ALL?: InputMaybe<CourseModulesConnectionWhere>;
  /** Return Courses where none of the related CourseModulesConnections match this filter */
  modulesConnection_NONE?: InputMaybe<CourseModulesConnectionWhere>;
  /** Return Courses where one of the related CourseModulesConnections match this filter */
  modulesConnection_SINGLE?: InputMaybe<CourseModulesConnectionWhere>;
  /** Return Courses where some of the related CourseModulesConnections match this filter */
  modulesConnection_SOME?: InputMaybe<CourseModulesConnectionWhere>;
  /** Return Courses where all of the related Modules match this filter */
  modules_ALL?: InputMaybe<ModuleWhere>;
  /** Return Courses where none of the related Modules match this filter */
  modules_NONE?: InputMaybe<ModuleWhere>;
  /** Return Courses where one of the related Modules match this filter */
  modules_SINGLE?: InputMaybe<ModuleWhere>;
  /** Return Courses where some of the related Modules match this filter */
  modules_SOME?: InputMaybe<ModuleWhere>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  nudgesAboutThisAggregate?: InputMaybe<CourseNudgesAboutThisAggregateInput>;
  /** Return Courses where all of the related CourseNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_ALL?: InputMaybe<CourseNudgesAboutThisConnectionWhere>;
  /** Return Courses where none of the related CourseNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_NONE?: InputMaybe<CourseNudgesAboutThisConnectionWhere>;
  /** Return Courses where one of the related CourseNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_SINGLE?: InputMaybe<CourseNudgesAboutThisConnectionWhere>;
  /** Return Courses where some of the related CourseNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_SOME?: InputMaybe<CourseNudgesAboutThisConnectionWhere>;
  /** Return Courses where all of the related Nudges match this filter */
  nudgesAboutThis_ALL?: InputMaybe<NudgeWhere>;
  /** Return Courses where none of the related Nudges match this filter */
  nudgesAboutThis_NONE?: InputMaybe<NudgeWhere>;
  /** Return Courses where one of the related Nudges match this filter */
  nudgesAboutThis_SINGLE?: InputMaybe<NudgeWhere>;
  /** Return Courses where some of the related Nudges match this filter */
  nudgesAboutThis_SOME?: InputMaybe<NudgeWhere>;
  objectives?: InputMaybe<Array<Scalars['String']['input']>>;
  objectives_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  original_name?: InputMaybe<Scalars['String']['input']>;
  original_name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  original_name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  original_name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  original_name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  period_ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  period_ids_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  periods?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  periods_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  preRequisiteForAggregate?: InputMaybe<CoursePreRequisiteForAggregateInput>;
  /** Return Courses where all of the related CoursePreRequisiteForConnections match this filter */
  preRequisiteForConnection_ALL?: InputMaybe<CoursePreRequisiteForConnectionWhere>;
  /** Return Courses where none of the related CoursePreRequisiteForConnections match this filter */
  preRequisiteForConnection_NONE?: InputMaybe<CoursePreRequisiteForConnectionWhere>;
  /** Return Courses where one of the related CoursePreRequisiteForConnections match this filter */
  preRequisiteForConnection_SINGLE?: InputMaybe<CoursePreRequisiteForConnectionWhere>;
  /** Return Courses where some of the related CoursePreRequisiteForConnections match this filter */
  preRequisiteForConnection_SOME?: InputMaybe<CoursePreRequisiteForConnectionWhere>;
  /** Return Courses where all of the related Courses match this filter */
  preRequisiteFor_ALL?: InputMaybe<CourseWhere>;
  /** Return Courses where none of the related Courses match this filter */
  preRequisiteFor_NONE?: InputMaybe<CourseWhere>;
  /** Return Courses where one of the related Courses match this filter */
  preRequisiteFor_SINGLE?: InputMaybe<CourseWhere>;
  /** Return Courses where some of the related Courses match this filter */
  preRequisiteFor_SOME?: InputMaybe<CourseWhere>;
  preRequisitesAggregate?: InputMaybe<CoursePreRequisitesAggregateInput>;
  /** Return Courses where all of the related CoursePreRequisitesConnections match this filter */
  preRequisitesConnection_ALL?: InputMaybe<CoursePreRequisitesConnectionWhere>;
  /** Return Courses where none of the related CoursePreRequisitesConnections match this filter */
  preRequisitesConnection_NONE?: InputMaybe<CoursePreRequisitesConnectionWhere>;
  /** Return Courses where one of the related CoursePreRequisitesConnections match this filter */
  preRequisitesConnection_SINGLE?: InputMaybe<CoursePreRequisitesConnectionWhere>;
  /** Return Courses where some of the related CoursePreRequisitesConnections match this filter */
  preRequisitesConnection_SOME?: InputMaybe<CoursePreRequisitesConnectionWhere>;
  /** Return Courses where all of the related Courses match this filter */
  preRequisites_ALL?: InputMaybe<CourseWhere>;
  /** Return Courses where none of the related Courses match this filter */
  preRequisites_NONE?: InputMaybe<CourseWhere>;
  /** Return Courses where one of the related Courses match this filter */
  preRequisites_SINGLE?: InputMaybe<CourseWhere>;
  /** Return Courses where some of the related Courses match this filter */
  preRequisites_SOME?: InputMaybe<CourseWhere>;
  public_syllabus?: InputMaybe<Scalars['Boolean']['input']>;
  public_syllabus_to_auth?: InputMaybe<Scalars['Boolean']['input']>;
  restrict_enrollments_to_course_dates?: InputMaybe<Scalars['Boolean']['input']>;
  root_account_id?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  root_account_id_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_LTE?: InputMaybe<Scalars['Float']['input']>;
  schoolsHasCourseAggregate?: InputMaybe<CourseSchoolsHasCourseAggregateInput>;
  /** Return Courses where all of the related CourseSchoolsHasCourseConnections match this filter */
  schoolsHasCourseConnection_ALL?: InputMaybe<CourseSchoolsHasCourseConnectionWhere>;
  /** Return Courses where none of the related CourseSchoolsHasCourseConnections match this filter */
  schoolsHasCourseConnection_NONE?: InputMaybe<CourseSchoolsHasCourseConnectionWhere>;
  /** Return Courses where one of the related CourseSchoolsHasCourseConnections match this filter */
  schoolsHasCourseConnection_SINGLE?: InputMaybe<CourseSchoolsHasCourseConnectionWhere>;
  /** Return Courses where some of the related CourseSchoolsHasCourseConnections match this filter */
  schoolsHasCourseConnection_SOME?: InputMaybe<CourseSchoolsHasCourseConnectionWhere>;
  /** Return Courses where all of the related Schools match this filter */
  schoolsHasCourse_ALL?: InputMaybe<SchoolWhere>;
  /** Return Courses where none of the related Schools match this filter */
  schoolsHasCourse_NONE?: InputMaybe<SchoolWhere>;
  /** Return Courses where one of the related Schools match this filter */
  schoolsHasCourse_SINGLE?: InputMaybe<SchoolWhere>;
  /** Return Courses where some of the related Schools match this filter */
  schoolsHasCourse_SOME?: InputMaybe<SchoolWhere>;
  sis_course_id?: InputMaybe<Scalars['String']['input']>;
  sis_course_id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  sis_course_id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  sis_course_id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sis_course_id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sis_import_id?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sis_import_id_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_LTE?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  startDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_at?: InputMaybe<Scalars['String']['input']>;
  start_at_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  start_at_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  start_at_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  start_at_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  state_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  state_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  state_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  storage_quota_mb?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  storage_quota_mb_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId?: InputMaybe<Scalars['String']['input']>;
  stripePriceId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  stripePriceId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  stripePriceId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stripePriceId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  stripeProductId?: InputMaybe<Scalars['String']['input']>;
  stripeProductId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  stripeProductId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  stripeProductId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stripeProductId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  targetAudience?: InputMaybe<Scalars['String']['input']>;
  targetAudience_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  targetAudience_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  targetAudience_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  targetAudience_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  teachingFacultyAggregate?: InputMaybe<CourseTeachingFacultyAggregateInput>;
  /** Return Courses where all of the related CourseTeachingFacultyConnections match this filter */
  teachingFacultyConnection_ALL?: InputMaybe<CourseTeachingFacultyConnectionWhere>;
  /** Return Courses where none of the related CourseTeachingFacultyConnections match this filter */
  teachingFacultyConnection_NONE?: InputMaybe<CourseTeachingFacultyConnectionWhere>;
  /** Return Courses where one of the related CourseTeachingFacultyConnections match this filter */
  teachingFacultyConnection_SINGLE?: InputMaybe<CourseTeachingFacultyConnectionWhere>;
  /** Return Courses where some of the related CourseTeachingFacultyConnections match this filter */
  teachingFacultyConnection_SOME?: InputMaybe<CourseTeachingFacultyConnectionWhere>;
  /** Return Courses where all of the related Users match this filter */
  teachingFaculty_ALL?: InputMaybe<UserWhere>;
  /** Return Courses where none of the related Users match this filter */
  teachingFaculty_NONE?: InputMaybe<UserWhere>;
  /** Return Courses where one of the related Users match this filter */
  teachingFaculty_SINGLE?: InputMaybe<UserWhere>;
  /** Return Courses where some of the related Users match this filter */
  teachingFaculty_SOME?: InputMaybe<UserWhere>;
  template?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  thumbnail_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  thumbnail_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  thumbnail_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thumbnail_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  time_zone?: InputMaybe<Scalars['String']['input']>;
  time_zone_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  time_zone_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  time_zone_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  time_zone_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['String']['input']>;
  updated_date_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  updated_date_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  updated_date_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updated_date_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  usersHasSchoolCourseAggregate?: InputMaybe<CourseUsersHasSchoolCourseAggregateInput>;
  /** Return Courses where all of the related CourseUsersHasSchoolCourseConnections match this filter */
  usersHasSchoolCourseConnection_ALL?: InputMaybe<CourseUsersHasSchoolCourseConnectionWhere>;
  /** Return Courses where none of the related CourseUsersHasSchoolCourseConnections match this filter */
  usersHasSchoolCourseConnection_NONE?: InputMaybe<CourseUsersHasSchoolCourseConnectionWhere>;
  /** Return Courses where one of the related CourseUsersHasSchoolCourseConnections match this filter */
  usersHasSchoolCourseConnection_SINGLE?: InputMaybe<CourseUsersHasSchoolCourseConnectionWhere>;
  /** Return Courses where some of the related CourseUsersHasSchoolCourseConnections match this filter */
  usersHasSchoolCourseConnection_SOME?: InputMaybe<CourseUsersHasSchoolCourseConnectionWhere>;
  /** Return Courses where all of the related Users match this filter */
  usersHasSchoolCourse_ALL?: InputMaybe<UserWhere>;
  /** Return Courses where none of the related Users match this filter */
  usersHasSchoolCourse_NONE?: InputMaybe<UserWhere>;
  /** Return Courses where one of the related Users match this filter */
  usersHasSchoolCourse_SINGLE?: InputMaybe<UserWhere>;
  /** Return Courses where some of the related Users match this filter */
  usersHasSchoolCourse_SOME?: InputMaybe<UserWhere>;
  usersHaveLearningPaymentAggregate?: InputMaybe<CourseUsersHaveLearningPaymentAggregateInput>;
  /** Return Courses where all of the related CourseUsersHaveLearningPaymentConnections match this filter */
  usersHaveLearningPaymentConnection_ALL?: InputMaybe<CourseUsersHaveLearningPaymentConnectionWhere>;
  /** Return Courses where none of the related CourseUsersHaveLearningPaymentConnections match this filter */
  usersHaveLearningPaymentConnection_NONE?: InputMaybe<CourseUsersHaveLearningPaymentConnectionWhere>;
  /** Return Courses where one of the related CourseUsersHaveLearningPaymentConnections match this filter */
  usersHaveLearningPaymentConnection_SINGLE?: InputMaybe<CourseUsersHaveLearningPaymentConnectionWhere>;
  /** Return Courses where some of the related CourseUsersHaveLearningPaymentConnections match this filter */
  usersHaveLearningPaymentConnection_SOME?: InputMaybe<CourseUsersHaveLearningPaymentConnectionWhere>;
  /** Return Courses where all of the related LearningPayments match this filter */
  usersHaveLearningPayment_ALL?: InputMaybe<LearningPaymentWhere>;
  /** Return Courses where none of the related LearningPayments match this filter */
  usersHaveLearningPayment_NONE?: InputMaybe<LearningPaymentWhere>;
  /** Return Courses where one of the related LearningPayments match this filter */
  usersHaveLearningPayment_SINGLE?: InputMaybe<LearningPaymentWhere>;
  /** Return Courses where some of the related LearningPayments match this filter */
  usersHaveLearningPayment_SOME?: InputMaybe<LearningPaymentWhere>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  uuid_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  workflow_state?: InputMaybe<Scalars['String']['input']>;
  workflow_state_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  workflow_state_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  workflow_state_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workflow_state_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  workspacesAggregate?: InputMaybe<CourseWorkspacesAggregateInput>;
  /** Return Courses where all of the related CourseWorkspacesConnections match this filter */
  workspacesConnection_ALL?: InputMaybe<CourseWorkspacesConnectionWhere>;
  /** Return Courses where none of the related CourseWorkspacesConnections match this filter */
  workspacesConnection_NONE?: InputMaybe<CourseWorkspacesConnectionWhere>;
  /** Return Courses where one of the related CourseWorkspacesConnections match this filter */
  workspacesConnection_SINGLE?: InputMaybe<CourseWorkspacesConnectionWhere>;
  /** Return Courses where some of the related CourseWorkspacesConnections match this filter */
  workspacesConnection_SOME?: InputMaybe<CourseWorkspacesConnectionWhere>;
  /** Return Courses where all of the related Workspaces match this filter */
  workspaces_ALL?: InputMaybe<WorkspaceWhere>;
  /** Return Courses where none of the related Workspaces match this filter */
  workspaces_NONE?: InputMaybe<WorkspaceWhere>;
  /** Return Courses where one of the related Workspaces match this filter */
  workspaces_SINGLE?: InputMaybe<WorkspaceWhere>;
  /** Return Courses where some of the related Workspaces match this filter */
  workspaces_SOME?: InputMaybe<WorkspaceWhere>;
};

export type CourseWithAssignments = {
  __typename?: 'CourseWithAssignments';
  assignments: Array<Assignment>;
  course_code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type CourseWithMetadata = {
  __typename?: 'CourseWithMetadata';
  course?: Maybe<Course>;
  preRequisitesCompleted?: Maybe<Scalars['Boolean']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
};

export type CourseWorkspaceWorkspacesAggregationSelection = {
  __typename?: 'CourseWorkspaceWorkspacesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<CourseWorkspaceWorkspacesNodeAggregateSelection>;
};

export type CourseWorkspaceWorkspacesNodeAggregateSelection = {
  __typename?: 'CourseWorkspaceWorkspacesNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  key: StringAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  name: StringAggregateSelection;
};

export type CourseWorkspacesAggregateInput = {
  AND?: InputMaybe<Array<CourseWorkspacesAggregateInput>>;
  NOT?: InputMaybe<CourseWorkspacesAggregateInput>;
  OR?: InputMaybe<Array<CourseWorkspacesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CourseWorkspacesNodeAggregationWhereInput>;
};

export type CourseWorkspacesConnectFieldInput = {
  connect?: InputMaybe<Array<WorkspaceConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<WorkspaceConnectWhere>;
};

export type CourseWorkspacesConnectOrCreateFieldInput = {
  onCreate: CourseWorkspacesConnectOrCreateFieldInputOnCreate;
  where: WorkspaceConnectOrCreateWhere;
};

export type CourseWorkspacesConnectOrCreateFieldInputOnCreate = {
  node: WorkspaceOnCreateInput;
};

export type CourseWorkspacesConnection = {
  __typename?: 'CourseWorkspacesConnection';
  edges: Array<CourseWorkspacesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CourseWorkspacesConnectionSort = {
  node?: InputMaybe<WorkspaceSort>;
};

export type CourseWorkspacesConnectionWhere = {
  AND?: InputMaybe<Array<CourseWorkspacesConnectionWhere>>;
  NOT?: InputMaybe<CourseWorkspacesConnectionWhere>;
  OR?: InputMaybe<Array<CourseWorkspacesConnectionWhere>>;
  node?: InputMaybe<WorkspaceWhere>;
};

export type CourseWorkspacesCreateFieldInput = {
  node: WorkspaceCreateInput;
};

export type CourseWorkspacesDeleteFieldInput = {
  delete?: InputMaybe<WorkspaceDeleteInput>;
  where?: InputMaybe<CourseWorkspacesConnectionWhere>;
};

export type CourseWorkspacesDisconnectFieldInput = {
  disconnect?: InputMaybe<WorkspaceDisconnectInput>;
  where?: InputMaybe<CourseWorkspacesConnectionWhere>;
};

export type CourseWorkspacesFieldInput = {
  connect?: InputMaybe<Array<CourseWorkspacesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CourseWorkspacesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CourseWorkspacesCreateFieldInput>>;
};

export type CourseWorkspacesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CourseWorkspacesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CourseWorkspacesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CourseWorkspacesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  key_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  key_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CourseWorkspacesRelationship = {
  __typename?: 'CourseWorkspacesRelationship';
  cursor: Scalars['String']['output'];
  node: Workspace;
};

export type CourseWorkspacesUpdateConnectionInput = {
  node?: InputMaybe<WorkspaceUpdateInput>;
};

export type CourseWorkspacesUpdateFieldInput = {
  connect?: InputMaybe<Array<CourseWorkspacesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<CourseWorkspacesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<CourseWorkspacesCreateFieldInput>>;
  delete?: InputMaybe<Array<CourseWorkspacesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CourseWorkspacesDisconnectFieldInput>>;
  update?: InputMaybe<CourseWorkspacesUpdateConnectionInput>;
  where?: InputMaybe<CourseWorkspacesConnectionWhere>;
};

export type CoursesAndAssignmentsData = {
  __typename?: 'CoursesAndAssignmentsData';
  courses: Array<CourseWithAssignments>;
};

export type CoursesAndAssignmentsResponse = {
  __typename?: 'CoursesAndAssignmentsResponse';
  count: Scalars['Int']['output'];
  data?: Maybe<CoursesAndAssignmentsData>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CoursesByQueryData = {
  __typename?: 'CoursesByQueryData';
  courses?: Maybe<Array<Maybe<Course>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CoursesByQueryDataWithMetadata = {
  __typename?: 'CoursesByQueryDataWithMetadata';
  courses?: Maybe<Array<Maybe<CourseWithMetadata>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CoursesByQueryResponse = {
  __typename?: 'CoursesByQueryResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<CoursesByQueryData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CoursesByQueryResponseWithMetadata = {
  __typename?: 'CoursesByQueryResponseWithMetadata';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<CoursesByQueryDataWithMetadata>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateAiTutorInput = {
  activityState?: InputMaybe<ActivityState>;
  context?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  objectives?: InputMaybe<Array<InputMaybe<ObjectiveInput>>>;
  parentModuleId: Scalars['ID']['input'];
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  targetAudience?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  videoPool?: InputMaybe<Array<InputMaybe<VideoDataInput>>>;
  visualizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateAnnouncementInput = {
  audienceType: AudienceType;
  courseIds: Array<Scalars['ID']['input']>;
  degreeIds: Array<Scalars['ID']['input']>;
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  message: Scalars['String']['input'];
  schoolId?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
};

export type CreateAssignmentInput = {
  activityState?: InputMaybe<ActivityState>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate: Scalars['String']['input'];
  enableStudentFileUpload?: InputMaybe<Scalars['Boolean']['input']>;
  files?: InputMaybe<Array<FileInput>>;
  moduleId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  worksheetId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateAxioResourceInput = {
  activityState?: InputMaybe<ActivityState>;
  description: Scalars['String']['input'];
  files?: InputMaybe<Array<FileInput>>;
  moduleId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCourseInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  course_code?: InputMaybe<Scalars['String']['input']>;
  degreeId?: InputMaybe<Scalars['ID']['input']>;
  is_elective?: InputMaybe<Scalars['Boolean']['input']>;
  learningStandards?: InputMaybe<Scalars['String']['input']>;
  lengthInWeeks?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  objectives?: InputMaybe<Array<Scalars['String']['input']>>;
  parentSchoolId: Scalars['String']['input'];
};

export type CreateCoursePlaceholderInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  course_code?: InputMaybe<Scalars['String']['input']>;
  degreeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  moduleOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  objectives?: InputMaybe<Scalars['String']['input']>;
  schoolId: Scalars['ID']['input'];
  targetAudience?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDegreeInput = {
  name: Scalars['String']['input'];
  schoolId: Scalars['ID']['input'];
};

export type CreateEnrollmentLinkInput = {
  courseId: Scalars['ID']['input'];
  expiresInDays: Scalars['Int']['input'];
  maxEnrollments: Scalars['Int']['input'];
};

export type CreateMcqQuestionInput = {
  aiTutorId?: InputMaybe<Scalars['ID']['input']>;
  assessmentId: Scalars['ID']['input'];
  choices: Array<Scalars['String']['input']>;
  correctChoiceIndices: Array<Scalars['Int']['input']>;
  explanation?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  question: Scalars['String']['input'];
  totalScore?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateModuleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  parentCourseId: Scalars['ID']['input'];
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateNoteInput = {
  content: Scalars['String']['input'];
  studentId: Scalars['ID']['input'];
};

export type CreateOrUpdateAssessmentInput = {
  activityState?: InputMaybe<ActivityState>;
  aiTutorIds: Array<Scalars['ID']['input']>;
  assessmentId?: InputMaybe<Scalars['ID']['input']>;
  assessmentType?: InputMaybe<AssessmentType>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  finalizedMcqQuestions?: InputMaybe<Array<FinalizedMcqQuestionInput>>;
  finalizedSocraticQuestions?: InputMaybe<Array<FinalizedSocraticQuestionInput>>;
  moduleId?: InputMaybe<Scalars['ID']['input']>;
  numberOfQuestions: Scalars['Int']['input'];
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  timeLimit: Scalars['Int']['input'];
};

export type CreatePageInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  parentModuleId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type CreatePostInput = {
  fileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  message: Scalars['String']['input'];
  replyToPostId?: InputMaybe<Scalars['ID']['input']>;
  threadId: Scalars['ID']['input'];
};

export type CreateProjectInput = {
  activityState?: InputMaybe<ActivityState>;
  assessmentCriteria?: InputMaybe<Array<Scalars['String']['input']>>;
  deliverableTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  description: Scalars['String']['input'];
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  expectedOutcomes?: InputMaybe<Array<Scalars['String']['input']>>;
  files?: InputMaybe<Array<FileInput>>;
  moduleId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  scopeDocument?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProjectRequirementInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  dependencies?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  estimatedHours?: InputMaybe<Scalars['Int']['input']>;
  priority: Priority;
  submissionId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  type: RequirementType;
};

export type CreateProjectSubmissionInput = {
  approachMethodology?: InputMaybe<Scalars['String']['input']>;
  expectedOutcomes?: InputMaybe<Array<Scalars['String']['input']>>;
  projectId: Scalars['ID']['input'];
  proposal: Scalars['String']['input'];
  scopeJustification?: InputMaybe<Scalars['String']['input']>;
};

export type CreateReviewInput = {
  activityState?: InputMaybe<ActivityState>;
  assessmentId: Scalars['ID']['input'];
  parentModuleId: Scalars['ID']['input'];
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateSocraticQuestionInput = {
  aiTutorId: Scalars['ID']['input'];
  assessmentId?: InputMaybe<Scalars['ID']['input']>;
  question: Scalars['String']['input'];
  rubrics?: InputMaybe<Array<SocraticQuestionRubricInput>>;
  totalScore?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateThreadInput = {
  courseId: Scalars['ID']['input'];
  fileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  message: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateWorksheetInput = {
  coverage: Scalars['String']['input'];
  instructions?: InputMaybe<Scalars['String']['input']>;
  numQuestions: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type Curriculum = {
  __typename?: 'Curriculum';
  created?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  last_modified?: Maybe<Scalars['DateTime']['output']>;
  modules: Array<Module>;
  name: Scalars['String']['output'];
  objectives: Array<Scalars['String']['output']>;
  standard: Scalars['String']['output'];
  weeks: Scalars['Int']['output'];
};

export type DailyBreakdownData = {
  __typename?: 'DailyBreakdownData';
  date?: Maybe<Scalars['String']['output']>;
  day?: Maybe<Scalars['String']['output']>;
  hourly?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  sessions?: Maybe<Scalars['Int']['output']>;
};

export type DailySummary = {
  __typename?: 'DailySummary';
  created: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  isArchived: Scalars['Boolean']['output'];
  last_modified: Scalars['DateTime']['output'];
  summary: Scalars['String']['output'];
  usersHasSummary: Array<User>;
  usersHasSummaryAggregate?: Maybe<DailySummaryUserUsersHasSummaryAggregationSelection>;
  usersHasSummaryConnection: DailySummaryUsersHasSummaryConnection;
};


export type DailySummaryUsersHasSummaryArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type DailySummaryUsersHasSummaryAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type DailySummaryUsersHasSummaryConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DailySummaryUsersHasSummaryConnectionSort>>;
  where?: InputMaybe<DailySummaryUsersHasSummaryConnectionWhere>;
};

export type DailySummaryConnectInput = {
  usersHasSummary?: InputMaybe<Array<DailySummaryUsersHasSummaryConnectFieldInput>>;
};

export type DailySummaryConnectWhere = {
  node: DailySummaryWhere;
};

export type DailySummaryCreateInput = {
  created: Scalars['DateTime']['input'];
  date: Scalars['DateTime']['input'];
  isArchived: Scalars['Boolean']['input'];
  last_modified: Scalars['DateTime']['input'];
  summary: Scalars['String']['input'];
  usersHasSummary?: InputMaybe<DailySummaryUsersHasSummaryFieldInput>;
};

export type DailySummaryDeleteInput = {
  usersHasSummary?: InputMaybe<Array<DailySummaryUsersHasSummaryDeleteFieldInput>>;
};

export type DailySummaryDisconnectInput = {
  usersHasSummary?: InputMaybe<Array<DailySummaryUsersHasSummaryDisconnectFieldInput>>;
};

export type DailySummaryOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DailySummarySort objects to sort DailySummaries by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DailySummarySort>>;
};

/** Fields to sort DailySummaries by. The order in which sorts are applied is not guaranteed when specifying many fields in one DailySummarySort object. */
export type DailySummarySort = {
  created?: InputMaybe<SortDirection>;
  date?: InputMaybe<SortDirection>;
  isArchived?: InputMaybe<SortDirection>;
  last_modified?: InputMaybe<SortDirection>;
  summary?: InputMaybe<SortDirection>;
};

export type DailySummaryUpdateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  usersHasSummary?: InputMaybe<Array<DailySummaryUsersHasSummaryUpdateFieldInput>>;
};

export type DailySummaryUserUsersHasSummaryAggregationSelection = {
  __typename?: 'DailySummaryUserUsersHasSummaryAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DailySummaryUserUsersHasSummaryNodeAggregateSelection>;
};

export type DailySummaryUserUsersHasSummaryNodeAggregateSelection = {
  __typename?: 'DailySummaryUserUsersHasSummaryNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type DailySummaryUsersHasSummaryAggregateInput = {
  AND?: InputMaybe<Array<DailySummaryUsersHasSummaryAggregateInput>>;
  NOT?: InputMaybe<DailySummaryUsersHasSummaryAggregateInput>;
  OR?: InputMaybe<Array<DailySummaryUsersHasSummaryAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DailySummaryUsersHasSummaryNodeAggregationWhereInput>;
};

export type DailySummaryUsersHasSummaryConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type DailySummaryUsersHasSummaryConnectOrCreateFieldInput = {
  onCreate: DailySummaryUsersHasSummaryConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type DailySummaryUsersHasSummaryConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type DailySummaryUsersHasSummaryConnection = {
  __typename?: 'DailySummaryUsersHasSummaryConnection';
  edges: Array<DailySummaryUsersHasSummaryRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DailySummaryUsersHasSummaryConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type DailySummaryUsersHasSummaryConnectionWhere = {
  AND?: InputMaybe<Array<DailySummaryUsersHasSummaryConnectionWhere>>;
  NOT?: InputMaybe<DailySummaryUsersHasSummaryConnectionWhere>;
  OR?: InputMaybe<Array<DailySummaryUsersHasSummaryConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type DailySummaryUsersHasSummaryCreateFieldInput = {
  node: UserCreateInput;
};

export type DailySummaryUsersHasSummaryDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<DailySummaryUsersHasSummaryConnectionWhere>;
};

export type DailySummaryUsersHasSummaryDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<DailySummaryUsersHasSummaryConnectionWhere>;
};

export type DailySummaryUsersHasSummaryFieldInput = {
  connect?: InputMaybe<Array<DailySummaryUsersHasSummaryConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<DailySummaryUsersHasSummaryConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<DailySummaryUsersHasSummaryCreateFieldInput>>;
};

export type DailySummaryUsersHasSummaryNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DailySummaryUsersHasSummaryNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DailySummaryUsersHasSummaryNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DailySummaryUsersHasSummaryNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DailySummaryUsersHasSummaryRelationship = {
  __typename?: 'DailySummaryUsersHasSummaryRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type DailySummaryUsersHasSummaryUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type DailySummaryUsersHasSummaryUpdateFieldInput = {
  connect?: InputMaybe<Array<DailySummaryUsersHasSummaryConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<DailySummaryUsersHasSummaryConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<DailySummaryUsersHasSummaryCreateFieldInput>>;
  delete?: InputMaybe<Array<DailySummaryUsersHasSummaryDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<DailySummaryUsersHasSummaryDisconnectFieldInput>>;
  update?: InputMaybe<DailySummaryUsersHasSummaryUpdateConnectionInput>;
  where?: InputMaybe<DailySummaryUsersHasSummaryConnectionWhere>;
};

export type DailySummaryWhere = {
  AND?: InputMaybe<Array<DailySummaryWhere>>;
  NOT?: InputMaybe<DailySummaryWhere>;
  OR?: InputMaybe<Array<DailySummaryWhere>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  date_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  date_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  last_modified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  summary_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  summary_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  summary_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  summary_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  usersHasSummaryAggregate?: InputMaybe<DailySummaryUsersHasSummaryAggregateInput>;
  /** Return DailySummaries where all of the related DailySummaryUsersHasSummaryConnections match this filter */
  usersHasSummaryConnection_ALL?: InputMaybe<DailySummaryUsersHasSummaryConnectionWhere>;
  /** Return DailySummaries where none of the related DailySummaryUsersHasSummaryConnections match this filter */
  usersHasSummaryConnection_NONE?: InputMaybe<DailySummaryUsersHasSummaryConnectionWhere>;
  /** Return DailySummaries where one of the related DailySummaryUsersHasSummaryConnections match this filter */
  usersHasSummaryConnection_SINGLE?: InputMaybe<DailySummaryUsersHasSummaryConnectionWhere>;
  /** Return DailySummaries where some of the related DailySummaryUsersHasSummaryConnections match this filter */
  usersHasSummaryConnection_SOME?: InputMaybe<DailySummaryUsersHasSummaryConnectionWhere>;
  /** Return DailySummaries where all of the related Users match this filter */
  usersHasSummary_ALL?: InputMaybe<UserWhere>;
  /** Return DailySummaries where none of the related Users match this filter */
  usersHasSummary_NONE?: InputMaybe<UserWhere>;
  /** Return DailySummaries where one of the related Users match this filter */
  usersHasSummary_SINGLE?: InputMaybe<UserWhere>;
  /** Return DailySummaries where some of the related Users match this filter */
  usersHasSummary_SOME?: InputMaybe<UserWhere>;
};

export type DateTimeAggregateSelection = {
  __typename?: 'DateTimeAggregateSelection';
  max?: Maybe<Scalars['DateTime']['output']>;
  min?: Maybe<Scalars['DateTime']['output']>;
};

export type Degree = {
  __typename?: 'Degree';
  announcements: Array<Announcement>;
  announcementsAggregate?: Maybe<DegreeAnnouncementAnnouncementsAggregationSelection>;
  announcementsConnection: DegreeAnnouncementsConnection;
  auditEvents: Array<AuditEvent>;
  auditEventsAggregate?: Maybe<DegreeAuditEventAuditEventsAggregationSelection>;
  auditEventsConnection: DegreeAuditEventsConnection;
  coursesHasCourse: Array<Course>;
  coursesHasCourseAggregate?: Maybe<DegreeCourseCoursesHasCourseAggregationSelection>;
  coursesHasCourseConnection: DegreeCoursesHasCourseConnection;
  created?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last_modified?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  schoolsHasDegree: Array<School>;
  schoolsHasDegreeAggregate?: Maybe<DegreeSchoolSchoolsHasDegreeAggregationSelection>;
  schoolsHasDegreeConnection: DegreeSchoolsHasDegreeConnection;
  usersEnrolledIn: Array<User>;
  usersEnrolledInAggregate?: Maybe<DegreeUserUsersEnrolledInAggregationSelection>;
  usersEnrolledInConnection: DegreeUsersEnrolledInConnection;
};


export type DegreeAnnouncementsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AnnouncementOptions>;
  where?: InputMaybe<AnnouncementWhere>;
};


export type DegreeAnnouncementsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnnouncementWhere>;
};


export type DegreeAnnouncementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DegreeAnnouncementsConnectionSort>>;
  where?: InputMaybe<DegreeAnnouncementsConnectionWhere>;
};


export type DegreeAuditEventsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AuditEventOptions>;
  where?: InputMaybe<AuditEventWhere>;
};


export type DegreeAuditEventsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AuditEventWhere>;
};


export type DegreeAuditEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DegreeAuditEventsConnectionSort>>;
  where?: InputMaybe<DegreeAuditEventsConnectionWhere>;
};


export type DegreeCoursesHasCourseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CourseOptions>;
  where?: InputMaybe<CourseWhere>;
};


export type DegreeCoursesHasCourseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CourseWhere>;
};


export type DegreeCoursesHasCourseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DegreeCoursesHasCourseConnectionSort>>;
  where?: InputMaybe<DegreeCoursesHasCourseConnectionWhere>;
};


export type DegreeSchoolsHasDegreeArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SchoolOptions>;
  where?: InputMaybe<SchoolWhere>;
};


export type DegreeSchoolsHasDegreeAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SchoolWhere>;
};


export type DegreeSchoolsHasDegreeConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DegreeSchoolsHasDegreeConnectionSort>>;
  where?: InputMaybe<DegreeSchoolsHasDegreeConnectionWhere>;
};


export type DegreeUsersEnrolledInArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type DegreeUsersEnrolledInAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type DegreeUsersEnrolledInConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DegreeUsersEnrolledInConnectionSort>>;
  where?: InputMaybe<DegreeUsersEnrolledInConnectionWhere>;
};

export type DegreeAnnouncementAnnouncementsAggregationSelection = {
  __typename?: 'DegreeAnnouncementAnnouncementsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DegreeAnnouncementAnnouncementsNodeAggregateSelection>;
};

export type DegreeAnnouncementAnnouncementsNodeAggregateSelection = {
  __typename?: 'DegreeAnnouncementAnnouncementsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  expirationDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  message: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type DegreeAnnouncementsAggregateInput = {
  AND?: InputMaybe<Array<DegreeAnnouncementsAggregateInput>>;
  NOT?: InputMaybe<DegreeAnnouncementsAggregateInput>;
  OR?: InputMaybe<Array<DegreeAnnouncementsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DegreeAnnouncementsNodeAggregationWhereInput>;
};

export type DegreeAnnouncementsConnectFieldInput = {
  connect?: InputMaybe<Array<AnnouncementConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AnnouncementConnectWhere>;
};

export type DegreeAnnouncementsConnectOrCreateFieldInput = {
  onCreate: DegreeAnnouncementsConnectOrCreateFieldInputOnCreate;
  where: AnnouncementConnectOrCreateWhere;
};

export type DegreeAnnouncementsConnectOrCreateFieldInputOnCreate = {
  node: AnnouncementOnCreateInput;
};

export type DegreeAnnouncementsConnection = {
  __typename?: 'DegreeAnnouncementsConnection';
  edges: Array<DegreeAnnouncementsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DegreeAnnouncementsConnectionSort = {
  node?: InputMaybe<AnnouncementSort>;
};

export type DegreeAnnouncementsConnectionWhere = {
  AND?: InputMaybe<Array<DegreeAnnouncementsConnectionWhere>>;
  NOT?: InputMaybe<DegreeAnnouncementsConnectionWhere>;
  OR?: InputMaybe<Array<DegreeAnnouncementsConnectionWhere>>;
  node?: InputMaybe<AnnouncementWhere>;
};

export type DegreeAnnouncementsCreateFieldInput = {
  node: AnnouncementCreateInput;
};

export type DegreeAnnouncementsDeleteFieldInput = {
  delete?: InputMaybe<AnnouncementDeleteInput>;
  where?: InputMaybe<DegreeAnnouncementsConnectionWhere>;
};

export type DegreeAnnouncementsDisconnectFieldInput = {
  disconnect?: InputMaybe<AnnouncementDisconnectInput>;
  where?: InputMaybe<DegreeAnnouncementsConnectionWhere>;
};

export type DegreeAnnouncementsFieldInput = {
  connect?: InputMaybe<Array<DegreeAnnouncementsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<DegreeAnnouncementsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<DegreeAnnouncementsCreateFieldInput>>;
};

export type DegreeAnnouncementsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DegreeAnnouncementsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DegreeAnnouncementsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DegreeAnnouncementsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  message_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  message_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DegreeAnnouncementsRelationship = {
  __typename?: 'DegreeAnnouncementsRelationship';
  cursor: Scalars['String']['output'];
  node: Announcement;
};

export type DegreeAnnouncementsUpdateConnectionInput = {
  node?: InputMaybe<AnnouncementUpdateInput>;
};

export type DegreeAnnouncementsUpdateFieldInput = {
  connect?: InputMaybe<Array<DegreeAnnouncementsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<DegreeAnnouncementsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<DegreeAnnouncementsCreateFieldInput>>;
  delete?: InputMaybe<Array<DegreeAnnouncementsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<DegreeAnnouncementsDisconnectFieldInput>>;
  update?: InputMaybe<DegreeAnnouncementsUpdateConnectionInput>;
  where?: InputMaybe<DegreeAnnouncementsConnectionWhere>;
};

export type DegreeAuditEventAuditEventsAggregationSelection = {
  __typename?: 'DegreeAuditEventAuditEventsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DegreeAuditEventAuditEventsNodeAggregateSelection>;
};

export type DegreeAuditEventAuditEventsNodeAggregateSelection = {
  __typename?: 'DegreeAuditEventAuditEventsNodeAggregateSelection';
  actorId: IdAggregateSelection;
  id: IdAggregateSelection;
  occurredAt: DateTimeAggregateSelection;
  relatedUserId: IdAggregateSelection;
  subjectId: IdAggregateSelection;
  subjectType: StringAggregateSelection;
  tenantId: IdAggregateSelection;
};

export type DegreeAuditEventsAggregateInput = {
  AND?: InputMaybe<Array<DegreeAuditEventsAggregateInput>>;
  NOT?: InputMaybe<DegreeAuditEventsAggregateInput>;
  OR?: InputMaybe<Array<DegreeAuditEventsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DegreeAuditEventsNodeAggregationWhereInput>;
};

export type DegreeAuditEventsConnectFieldInput = {
  connect?: InputMaybe<Array<AuditEventConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AuditEventConnectWhere>;
};

export type DegreeAuditEventsConnectOrCreateFieldInput = {
  onCreate: DegreeAuditEventsConnectOrCreateFieldInputOnCreate;
  where: AuditEventConnectOrCreateWhere;
};

export type DegreeAuditEventsConnectOrCreateFieldInputOnCreate = {
  node: AuditEventOnCreateInput;
};

export type DegreeAuditEventsConnection = {
  __typename?: 'DegreeAuditEventsConnection';
  edges: Array<DegreeAuditEventsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DegreeAuditEventsConnectionSort = {
  node?: InputMaybe<AuditEventSort>;
};

export type DegreeAuditEventsConnectionWhere = {
  AND?: InputMaybe<Array<DegreeAuditEventsConnectionWhere>>;
  NOT?: InputMaybe<DegreeAuditEventsConnectionWhere>;
  OR?: InputMaybe<Array<DegreeAuditEventsConnectionWhere>>;
  node?: InputMaybe<AuditEventWhere>;
};

export type DegreeAuditEventsCreateFieldInput = {
  node: AuditEventCreateInput;
};

export type DegreeAuditEventsDeleteFieldInput = {
  delete?: InputMaybe<AuditEventDeleteInput>;
  where?: InputMaybe<DegreeAuditEventsConnectionWhere>;
};

export type DegreeAuditEventsDisconnectFieldInput = {
  disconnect?: InputMaybe<AuditEventDisconnectInput>;
  where?: InputMaybe<DegreeAuditEventsConnectionWhere>;
};

export type DegreeAuditEventsFieldInput = {
  connect?: InputMaybe<Array<DegreeAuditEventsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<DegreeAuditEventsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<DegreeAuditEventsCreateFieldInput>>;
};

export type DegreeAuditEventsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DegreeAuditEventsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DegreeAuditEventsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DegreeAuditEventsNodeAggregationWhereInput>>;
  occurredAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  subjectType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subjectType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  subjectType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  subjectType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  subjectType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  subjectType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subjectType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subjectType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subjectType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subjectType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subjectType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subjectType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subjectType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subjectType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subjectType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DegreeAuditEventsRelationship = {
  __typename?: 'DegreeAuditEventsRelationship';
  cursor: Scalars['String']['output'];
  node: AuditEvent;
};

export type DegreeAuditEventsUpdateConnectionInput = {
  node?: InputMaybe<AuditEventUpdateInput>;
};

export type DegreeAuditEventsUpdateFieldInput = {
  connect?: InputMaybe<Array<DegreeAuditEventsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<DegreeAuditEventsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<DegreeAuditEventsCreateFieldInput>>;
  delete?: InputMaybe<Array<DegreeAuditEventsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<DegreeAuditEventsDisconnectFieldInput>>;
  update?: InputMaybe<DegreeAuditEventsUpdateConnectionInput>;
  where?: InputMaybe<DegreeAuditEventsConnectionWhere>;
};

export type DegreeConnectInput = {
  announcements?: InputMaybe<Array<DegreeAnnouncementsConnectFieldInput>>;
  auditEvents?: InputMaybe<Array<DegreeAuditEventsConnectFieldInput>>;
  coursesHasCourse?: InputMaybe<Array<DegreeCoursesHasCourseConnectFieldInput>>;
  schoolsHasDegree?: InputMaybe<Array<DegreeSchoolsHasDegreeConnectFieldInput>>;
  usersEnrolledIn?: InputMaybe<Array<DegreeUsersEnrolledInConnectFieldInput>>;
};

export type DegreeConnectOrCreateWhere = {
  node: DegreeUniqueWhere;
};

export type DegreeConnectWhere = {
  node: DegreeWhere;
};

export type DegreeCourseCoursesHasCourseAggregationSelection = {
  __typename?: 'DegreeCourseCoursesHasCourseAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DegreeCourseCoursesHasCourseNodeAggregateSelection>;
};

export type DegreeCourseCoursesHasCourseNodeAggregateSelection = {
  __typename?: 'DegreeCourseCoursesHasCourseNodeAggregateSelection';
  account_id: FloatAggregateSelection;
  calendar_ics: StringAggregateSelection;
  cost: FloatAggregateSelection;
  courseId: StringAggregateSelection;
  course_code: StringAggregateSelection;
  course_id: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  default_view: StringAggregateSelection;
  description: StringAggregateSelection;
  dueDateEndDate: DateTimeAggregateSelection;
  dueDateStartDate: DateTimeAggregateSelection;
  endDate: DateTimeAggregateSelection;
  end_at: StringAggregateSelection;
  enrollment_term_id: FloatAggregateSelection;
  grading_standard_id: FloatAggregateSelection;
  id: IdAggregateSelection;
  integration_id: StringAggregateSelection;
  label: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  learningStandards: StringAggregateSelection;
  lengthInWeeks: FloatAggregateSelection;
  license: StringAggregateSelection;
  lti_id: StringAggregateSelection;
  name: StringAggregateSelection;
  original_name: StringAggregateSelection;
  root_account_id: FloatAggregateSelection;
  sis_course_id: StringAggregateSelection;
  sis_import_id: FloatAggregateSelection;
  startDate: DateTimeAggregateSelection;
  start_at: StringAggregateSelection;
  state: StringAggregateSelection;
  storage_quota_mb: FloatAggregateSelection;
  stripePriceId: StringAggregateSelection;
  stripeProductId: StringAggregateSelection;
  targetAudience: StringAggregateSelection;
  thumbnail: StringAggregateSelection;
  time_zone: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  uuid: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export type DegreeCoursesHasCourseAggregateInput = {
  AND?: InputMaybe<Array<DegreeCoursesHasCourseAggregateInput>>;
  NOT?: InputMaybe<DegreeCoursesHasCourseAggregateInput>;
  OR?: InputMaybe<Array<DegreeCoursesHasCourseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DegreeCoursesHasCourseNodeAggregationWhereInput>;
};

export type DegreeCoursesHasCourseConnectFieldInput = {
  connect?: InputMaybe<Array<CourseConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CourseConnectWhere>;
};

export type DegreeCoursesHasCourseConnectOrCreateFieldInput = {
  onCreate: DegreeCoursesHasCourseConnectOrCreateFieldInputOnCreate;
  where: CourseConnectOrCreateWhere;
};

export type DegreeCoursesHasCourseConnectOrCreateFieldInputOnCreate = {
  node: CourseOnCreateInput;
};

export type DegreeCoursesHasCourseConnection = {
  __typename?: 'DegreeCoursesHasCourseConnection';
  edges: Array<DegreeCoursesHasCourseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DegreeCoursesHasCourseConnectionSort = {
  node?: InputMaybe<CourseSort>;
};

export type DegreeCoursesHasCourseConnectionWhere = {
  AND?: InputMaybe<Array<DegreeCoursesHasCourseConnectionWhere>>;
  NOT?: InputMaybe<DegreeCoursesHasCourseConnectionWhere>;
  OR?: InputMaybe<Array<DegreeCoursesHasCourseConnectionWhere>>;
  node?: InputMaybe<CourseWhere>;
};

export type DegreeCoursesHasCourseCreateFieldInput = {
  node: CourseCreateInput;
};

export type DegreeCoursesHasCourseDeleteFieldInput = {
  delete?: InputMaybe<CourseDeleteInput>;
  where?: InputMaybe<DegreeCoursesHasCourseConnectionWhere>;
};

export type DegreeCoursesHasCourseDisconnectFieldInput = {
  disconnect?: InputMaybe<CourseDisconnectInput>;
  where?: InputMaybe<DegreeCoursesHasCourseConnectionWhere>;
};

export type DegreeCoursesHasCourseFieldInput = {
  connect?: InputMaybe<Array<DegreeCoursesHasCourseConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<DegreeCoursesHasCourseConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<DegreeCoursesHasCourseCreateFieldInput>>;
};

export type DegreeCoursesHasCourseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DegreeCoursesHasCourseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DegreeCoursesHasCourseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DegreeCoursesHasCourseNodeAggregationWhereInput>>;
  account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  cost_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDateEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  enrollment_term_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  label_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningStandards_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthInWeeks_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  root_account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_import_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  startDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  storage_quota_mb_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DegreeCoursesHasCourseRelationship = {
  __typename?: 'DegreeCoursesHasCourseRelationship';
  cursor: Scalars['String']['output'];
  node: Course;
};

export type DegreeCoursesHasCourseUpdateConnectionInput = {
  node?: InputMaybe<CourseUpdateInput>;
};

export type DegreeCoursesHasCourseUpdateFieldInput = {
  connect?: InputMaybe<Array<DegreeCoursesHasCourseConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<DegreeCoursesHasCourseConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<DegreeCoursesHasCourseCreateFieldInput>>;
  delete?: InputMaybe<Array<DegreeCoursesHasCourseDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<DegreeCoursesHasCourseDisconnectFieldInput>>;
  update?: InputMaybe<DegreeCoursesHasCourseUpdateConnectionInput>;
  where?: InputMaybe<DegreeCoursesHasCourseConnectionWhere>;
};

export type DegreeCreateInput = {
  announcements?: InputMaybe<DegreeAnnouncementsFieldInput>;
  auditEvents?: InputMaybe<DegreeAuditEventsFieldInput>;
  coursesHasCourse?: InputMaybe<DegreeCoursesHasCourseFieldInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  schoolsHasDegree?: InputMaybe<DegreeSchoolsHasDegreeFieldInput>;
  usersEnrolledIn?: InputMaybe<DegreeUsersEnrolledInFieldInput>;
};

export type DegreeDeleteInput = {
  announcements?: InputMaybe<Array<DegreeAnnouncementsDeleteFieldInput>>;
  auditEvents?: InputMaybe<Array<DegreeAuditEventsDeleteFieldInput>>;
  coursesHasCourse?: InputMaybe<Array<DegreeCoursesHasCourseDeleteFieldInput>>;
  schoolsHasDegree?: InputMaybe<Array<DegreeSchoolsHasDegreeDeleteFieldInput>>;
  usersEnrolledIn?: InputMaybe<Array<DegreeUsersEnrolledInDeleteFieldInput>>;
};

export type DegreeDisconnectInput = {
  announcements?: InputMaybe<Array<DegreeAnnouncementsDisconnectFieldInput>>;
  auditEvents?: InputMaybe<Array<DegreeAuditEventsDisconnectFieldInput>>;
  coursesHasCourse?: InputMaybe<Array<DegreeCoursesHasCourseDisconnectFieldInput>>;
  schoolsHasDegree?: InputMaybe<Array<DegreeSchoolsHasDegreeDisconnectFieldInput>>;
  usersEnrolledIn?: InputMaybe<Array<DegreeUsersEnrolledInDisconnectFieldInput>>;
};

export type DegreeOnCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
};

export type DegreeOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DegreeSort objects to sort Degrees by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DegreeSort>>;
};

export type DegreeResponse = {
  __typename?: 'DegreeResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<Degree>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DegreeRosterData = {
  __typename?: 'DegreeRosterData';
  email: Scalars['String']['output'];
  enrollmentDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pendingDegreeEnrollmentInvite?: Maybe<Scalars['Boolean']['output']>;
};

export type DegreeRosterServiceResult = {
  __typename?: 'DegreeRosterServiceResult';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<DegreeRosterData>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DegreeSchoolSchoolsHasDegreeAggregationSelection = {
  __typename?: 'DegreeSchoolSchoolsHasDegreeAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DegreeSchoolSchoolsHasDegreeNodeAggregateSelection>;
};

export type DegreeSchoolSchoolsHasDegreeNodeAggregateSelection = {
  __typename?: 'DegreeSchoolSchoolsHasDegreeNodeAggregateSelection';
  brightspace_api_client_id: StringAggregateSelection;
  brightspace_api_client_secret: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  domain: StringAggregateSelection;
  id: IdAggregateSelection;
  provider_icon_url: StringAggregateSelection;
  provider_name: StringAggregateSelection;
  team_name: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
};

export type DegreeSchoolsHasDegreeAggregateInput = {
  AND?: InputMaybe<Array<DegreeSchoolsHasDegreeAggregateInput>>;
  NOT?: InputMaybe<DegreeSchoolsHasDegreeAggregateInput>;
  OR?: InputMaybe<Array<DegreeSchoolsHasDegreeAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DegreeSchoolsHasDegreeNodeAggregationWhereInput>;
};

export type DegreeSchoolsHasDegreeConnectFieldInput = {
  connect?: InputMaybe<Array<SchoolConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SchoolConnectWhere>;
};

export type DegreeSchoolsHasDegreeConnectOrCreateFieldInput = {
  onCreate: DegreeSchoolsHasDegreeConnectOrCreateFieldInputOnCreate;
  where: SchoolConnectOrCreateWhere;
};

export type DegreeSchoolsHasDegreeConnectOrCreateFieldInputOnCreate = {
  node: SchoolOnCreateInput;
};

export type DegreeSchoolsHasDegreeConnection = {
  __typename?: 'DegreeSchoolsHasDegreeConnection';
  edges: Array<DegreeSchoolsHasDegreeRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DegreeSchoolsHasDegreeConnectionSort = {
  node?: InputMaybe<SchoolSort>;
};

export type DegreeSchoolsHasDegreeConnectionWhere = {
  AND?: InputMaybe<Array<DegreeSchoolsHasDegreeConnectionWhere>>;
  NOT?: InputMaybe<DegreeSchoolsHasDegreeConnectionWhere>;
  OR?: InputMaybe<Array<DegreeSchoolsHasDegreeConnectionWhere>>;
  node?: InputMaybe<SchoolWhere>;
};

export type DegreeSchoolsHasDegreeCreateFieldInput = {
  node: SchoolCreateInput;
};

export type DegreeSchoolsHasDegreeDeleteFieldInput = {
  delete?: InputMaybe<SchoolDeleteInput>;
  where?: InputMaybe<DegreeSchoolsHasDegreeConnectionWhere>;
};

export type DegreeSchoolsHasDegreeDisconnectFieldInput = {
  disconnect?: InputMaybe<SchoolDisconnectInput>;
  where?: InputMaybe<DegreeSchoolsHasDegreeConnectionWhere>;
};

export type DegreeSchoolsHasDegreeFieldInput = {
  connect?: InputMaybe<Array<DegreeSchoolsHasDegreeConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<DegreeSchoolsHasDegreeConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<DegreeSchoolsHasDegreeCreateFieldInput>>;
};

export type DegreeSchoolsHasDegreeNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DegreeSchoolsHasDegreeNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DegreeSchoolsHasDegreeNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DegreeSchoolsHasDegreeNodeAggregationWhereInput>>;
  brightspace_api_client_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_secret_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_secret_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_secret_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_secret_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_secret_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  domain_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domain_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  provider_icon_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  provider_icon_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  provider_icon_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  provider_icon_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  provider_icon_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  provider_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  provider_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  provider_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  provider_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  provider_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  provider_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  provider_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  provider_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  provider_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  provider_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  provider_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  provider_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  provider_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  provider_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  provider_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  team_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  team_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  team_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  team_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  team_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  team_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  team_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  team_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  team_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  team_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  team_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  team_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  team_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  team_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  team_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DegreeSchoolsHasDegreeRelationship = {
  __typename?: 'DegreeSchoolsHasDegreeRelationship';
  cursor: Scalars['String']['output'];
  node: School;
};

export type DegreeSchoolsHasDegreeUpdateConnectionInput = {
  node?: InputMaybe<SchoolUpdateInput>;
};

export type DegreeSchoolsHasDegreeUpdateFieldInput = {
  connect?: InputMaybe<Array<DegreeSchoolsHasDegreeConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<DegreeSchoolsHasDegreeConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<DegreeSchoolsHasDegreeCreateFieldInput>>;
  delete?: InputMaybe<Array<DegreeSchoolsHasDegreeDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<DegreeSchoolsHasDegreeDisconnectFieldInput>>;
  update?: InputMaybe<DegreeSchoolsHasDegreeUpdateConnectionInput>;
  where?: InputMaybe<DegreeSchoolsHasDegreeConnectionWhere>;
};

/** Fields to sort Degrees by. The order in which sorts are applied is not guaranteed when specifying many fields in one DegreeSort object. */
export type DegreeSort = {
  created?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  last_modified?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type DegreeUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type DegreeUpdateInput = {
  announcements?: InputMaybe<Array<DegreeAnnouncementsUpdateFieldInput>>;
  auditEvents?: InputMaybe<Array<DegreeAuditEventsUpdateFieldInput>>;
  coursesHasCourse?: InputMaybe<Array<DegreeCoursesHasCourseUpdateFieldInput>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  schoolsHasDegree?: InputMaybe<Array<DegreeSchoolsHasDegreeUpdateFieldInput>>;
  usersEnrolledIn?: InputMaybe<Array<DegreeUsersEnrolledInUpdateFieldInput>>;
};

export type DegreeUserUsersEnrolledInAggregationSelection = {
  __typename?: 'DegreeUserUsersEnrolledInAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<DegreeUserUsersEnrolledInEdgeAggregateSelection>;
  node?: Maybe<DegreeUserUsersEnrolledInNodeAggregateSelection>;
};

export type DegreeUserUsersEnrolledInEdgeAggregateSelection = {
  __typename?: 'DegreeUserUsersEnrolledInEdgeAggregateSelection';
  created: DateTimeAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
};

export type DegreeUserUsersEnrolledInNodeAggregateSelection = {
  __typename?: 'DegreeUserUsersEnrolledInNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type DegreeUsersEnrolledInAggregateInput = {
  AND?: InputMaybe<Array<DegreeUsersEnrolledInAggregateInput>>;
  NOT?: InputMaybe<DegreeUsersEnrolledInAggregateInput>;
  OR?: InputMaybe<Array<DegreeUsersEnrolledInAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<EnrolledInDegreePropertiesAggregationWhereInput>;
  node?: InputMaybe<DegreeUsersEnrolledInNodeAggregationWhereInput>;
};

export type DegreeUsersEnrolledInConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  edge: EnrolledInDegreePropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type DegreeUsersEnrolledInConnectOrCreateFieldInput = {
  onCreate: DegreeUsersEnrolledInConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type DegreeUsersEnrolledInConnectOrCreateFieldInputOnCreate = {
  edge: EnrolledInDegreePropertiesCreateInput;
  node: UserOnCreateInput;
};

export type DegreeUsersEnrolledInConnection = {
  __typename?: 'DegreeUsersEnrolledInConnection';
  edges: Array<DegreeUsersEnrolledInRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DegreeUsersEnrolledInConnectionSort = {
  edge?: InputMaybe<EnrolledInDegreePropertiesSort>;
  node?: InputMaybe<UserSort>;
};

export type DegreeUsersEnrolledInConnectionWhere = {
  AND?: InputMaybe<Array<DegreeUsersEnrolledInConnectionWhere>>;
  NOT?: InputMaybe<DegreeUsersEnrolledInConnectionWhere>;
  OR?: InputMaybe<Array<DegreeUsersEnrolledInConnectionWhere>>;
  edge?: InputMaybe<EnrolledInDegreePropertiesWhere>;
  node?: InputMaybe<UserWhere>;
};

export type DegreeUsersEnrolledInCreateFieldInput = {
  edge: EnrolledInDegreePropertiesCreateInput;
  node: UserCreateInput;
};

export type DegreeUsersEnrolledInDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<DegreeUsersEnrolledInConnectionWhere>;
};

export type DegreeUsersEnrolledInDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<DegreeUsersEnrolledInConnectionWhere>;
};

export type DegreeUsersEnrolledInFieldInput = {
  connect?: InputMaybe<Array<DegreeUsersEnrolledInConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<DegreeUsersEnrolledInConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<DegreeUsersEnrolledInCreateFieldInput>>;
};

export type DegreeUsersEnrolledInNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DegreeUsersEnrolledInNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DegreeUsersEnrolledInNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DegreeUsersEnrolledInNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DegreeUsersEnrolledInRelationship = {
  __typename?: 'DegreeUsersEnrolledInRelationship';
  cursor: Scalars['String']['output'];
  node: User;
  properties: EnrolledInDegreeProperties;
};

export type DegreeUsersEnrolledInUpdateConnectionInput = {
  edge?: InputMaybe<EnrolledInDegreePropertiesUpdateInput>;
  node?: InputMaybe<UserUpdateInput>;
};

export type DegreeUsersEnrolledInUpdateFieldInput = {
  connect?: InputMaybe<Array<DegreeUsersEnrolledInConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<DegreeUsersEnrolledInConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<DegreeUsersEnrolledInCreateFieldInput>>;
  delete?: InputMaybe<Array<DegreeUsersEnrolledInDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<DegreeUsersEnrolledInDisconnectFieldInput>>;
  update?: InputMaybe<DegreeUsersEnrolledInUpdateConnectionInput>;
  where?: InputMaybe<DegreeUsersEnrolledInConnectionWhere>;
};

export type DegreeWhere = {
  AND?: InputMaybe<Array<DegreeWhere>>;
  NOT?: InputMaybe<DegreeWhere>;
  OR?: InputMaybe<Array<DegreeWhere>>;
  announcementsAggregate?: InputMaybe<DegreeAnnouncementsAggregateInput>;
  /** Return Degrees where all of the related DegreeAnnouncementsConnections match this filter */
  announcementsConnection_ALL?: InputMaybe<DegreeAnnouncementsConnectionWhere>;
  /** Return Degrees where none of the related DegreeAnnouncementsConnections match this filter */
  announcementsConnection_NONE?: InputMaybe<DegreeAnnouncementsConnectionWhere>;
  /** Return Degrees where one of the related DegreeAnnouncementsConnections match this filter */
  announcementsConnection_SINGLE?: InputMaybe<DegreeAnnouncementsConnectionWhere>;
  /** Return Degrees where some of the related DegreeAnnouncementsConnections match this filter */
  announcementsConnection_SOME?: InputMaybe<DegreeAnnouncementsConnectionWhere>;
  /** Return Degrees where all of the related Announcements match this filter */
  announcements_ALL?: InputMaybe<AnnouncementWhere>;
  /** Return Degrees where none of the related Announcements match this filter */
  announcements_NONE?: InputMaybe<AnnouncementWhere>;
  /** Return Degrees where one of the related Announcements match this filter */
  announcements_SINGLE?: InputMaybe<AnnouncementWhere>;
  /** Return Degrees where some of the related Announcements match this filter */
  announcements_SOME?: InputMaybe<AnnouncementWhere>;
  auditEventsAggregate?: InputMaybe<DegreeAuditEventsAggregateInput>;
  /** Return Degrees where all of the related DegreeAuditEventsConnections match this filter */
  auditEventsConnection_ALL?: InputMaybe<DegreeAuditEventsConnectionWhere>;
  /** Return Degrees where none of the related DegreeAuditEventsConnections match this filter */
  auditEventsConnection_NONE?: InputMaybe<DegreeAuditEventsConnectionWhere>;
  /** Return Degrees where one of the related DegreeAuditEventsConnections match this filter */
  auditEventsConnection_SINGLE?: InputMaybe<DegreeAuditEventsConnectionWhere>;
  /** Return Degrees where some of the related DegreeAuditEventsConnections match this filter */
  auditEventsConnection_SOME?: InputMaybe<DegreeAuditEventsConnectionWhere>;
  /** Return Degrees where all of the related AuditEvents match this filter */
  auditEvents_ALL?: InputMaybe<AuditEventWhere>;
  /** Return Degrees where none of the related AuditEvents match this filter */
  auditEvents_NONE?: InputMaybe<AuditEventWhere>;
  /** Return Degrees where one of the related AuditEvents match this filter */
  auditEvents_SINGLE?: InputMaybe<AuditEventWhere>;
  /** Return Degrees where some of the related AuditEvents match this filter */
  auditEvents_SOME?: InputMaybe<AuditEventWhere>;
  coursesHasCourseAggregate?: InputMaybe<DegreeCoursesHasCourseAggregateInput>;
  /** Return Degrees where all of the related DegreeCoursesHasCourseConnections match this filter */
  coursesHasCourseConnection_ALL?: InputMaybe<DegreeCoursesHasCourseConnectionWhere>;
  /** Return Degrees where none of the related DegreeCoursesHasCourseConnections match this filter */
  coursesHasCourseConnection_NONE?: InputMaybe<DegreeCoursesHasCourseConnectionWhere>;
  /** Return Degrees where one of the related DegreeCoursesHasCourseConnections match this filter */
  coursesHasCourseConnection_SINGLE?: InputMaybe<DegreeCoursesHasCourseConnectionWhere>;
  /** Return Degrees where some of the related DegreeCoursesHasCourseConnections match this filter */
  coursesHasCourseConnection_SOME?: InputMaybe<DegreeCoursesHasCourseConnectionWhere>;
  /** Return Degrees where all of the related Courses match this filter */
  coursesHasCourse_ALL?: InputMaybe<CourseWhere>;
  /** Return Degrees where none of the related Courses match this filter */
  coursesHasCourse_NONE?: InputMaybe<CourseWhere>;
  /** Return Degrees where one of the related Courses match this filter */
  coursesHasCourse_SINGLE?: InputMaybe<CourseWhere>;
  /** Return Degrees where some of the related Courses match this filter */
  coursesHasCourse_SOME?: InputMaybe<CourseWhere>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  last_modified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  schoolsHasDegreeAggregate?: InputMaybe<DegreeSchoolsHasDegreeAggregateInput>;
  /** Return Degrees where all of the related DegreeSchoolsHasDegreeConnections match this filter */
  schoolsHasDegreeConnection_ALL?: InputMaybe<DegreeSchoolsHasDegreeConnectionWhere>;
  /** Return Degrees where none of the related DegreeSchoolsHasDegreeConnections match this filter */
  schoolsHasDegreeConnection_NONE?: InputMaybe<DegreeSchoolsHasDegreeConnectionWhere>;
  /** Return Degrees where one of the related DegreeSchoolsHasDegreeConnections match this filter */
  schoolsHasDegreeConnection_SINGLE?: InputMaybe<DegreeSchoolsHasDegreeConnectionWhere>;
  /** Return Degrees where some of the related DegreeSchoolsHasDegreeConnections match this filter */
  schoolsHasDegreeConnection_SOME?: InputMaybe<DegreeSchoolsHasDegreeConnectionWhere>;
  /** Return Degrees where all of the related Schools match this filter */
  schoolsHasDegree_ALL?: InputMaybe<SchoolWhere>;
  /** Return Degrees where none of the related Schools match this filter */
  schoolsHasDegree_NONE?: InputMaybe<SchoolWhere>;
  /** Return Degrees where one of the related Schools match this filter */
  schoolsHasDegree_SINGLE?: InputMaybe<SchoolWhere>;
  /** Return Degrees where some of the related Schools match this filter */
  schoolsHasDegree_SOME?: InputMaybe<SchoolWhere>;
  usersEnrolledInAggregate?: InputMaybe<DegreeUsersEnrolledInAggregateInput>;
  /** Return Degrees where all of the related DegreeUsersEnrolledInConnections match this filter */
  usersEnrolledInConnection_ALL?: InputMaybe<DegreeUsersEnrolledInConnectionWhere>;
  /** Return Degrees where none of the related DegreeUsersEnrolledInConnections match this filter */
  usersEnrolledInConnection_NONE?: InputMaybe<DegreeUsersEnrolledInConnectionWhere>;
  /** Return Degrees where one of the related DegreeUsersEnrolledInConnections match this filter */
  usersEnrolledInConnection_SINGLE?: InputMaybe<DegreeUsersEnrolledInConnectionWhere>;
  /** Return Degrees where some of the related DegreeUsersEnrolledInConnections match this filter */
  usersEnrolledInConnection_SOME?: InputMaybe<DegreeUsersEnrolledInConnectionWhere>;
  /** Return Degrees where all of the related Users match this filter */
  usersEnrolledIn_ALL?: InputMaybe<UserWhere>;
  /** Return Degrees where none of the related Users match this filter */
  usersEnrolledIn_NONE?: InputMaybe<UserWhere>;
  /** Return Degrees where one of the related Users match this filter */
  usersEnrolledIn_SINGLE?: InputMaybe<UserWhere>;
  /** Return Degrees where some of the related Users match this filter */
  usersEnrolledIn_SOME?: InputMaybe<UserWhere>;
};

export type DegreesBySchoolByQueryData = {
  __typename?: 'DegreesBySchoolByQueryData';
  degrees?: Maybe<Array<Maybe<Degree>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type DegreesBySchoolByQueryResponse = {
  __typename?: 'DegreesBySchoolByQueryResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<DegreesBySchoolByQueryData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteContentAssignmentResponse = {
  __typename?: 'DeleteContentAssignmentResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteContentModuleResponse = {
  __typename?: 'DeleteContentModuleResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeviceSession = {
  __typename?: 'DeviceSession';
  id: Scalars['ID']['output'];
  usersHasSession: Array<User>;
  usersHasSessionAggregate?: Maybe<DeviceSessionUserUsersHasSessionAggregationSelection>;
  usersHasSessionConnection: DeviceSessionUsersHasSessionConnection;
};


export type DeviceSessionUsersHasSessionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type DeviceSessionUsersHasSessionAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type DeviceSessionUsersHasSessionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DeviceSessionUsersHasSessionConnectionSort>>;
  where?: InputMaybe<DeviceSessionUsersHasSessionConnectionWhere>;
};

export type DeviceSessionConnectInput = {
  usersHasSession?: InputMaybe<Array<DeviceSessionUsersHasSessionConnectFieldInput>>;
};

export type DeviceSessionConnectOrCreateWhere = {
  node: DeviceSessionUniqueWhere;
};

export type DeviceSessionConnectWhere = {
  node: DeviceSessionWhere;
};

export type DeviceSessionCreateInput = {
  id: Scalars['ID']['input'];
  usersHasSession?: InputMaybe<DeviceSessionUsersHasSessionFieldInput>;
};

export type DeviceSessionDeleteInput = {
  usersHasSession?: InputMaybe<Array<DeviceSessionUsersHasSessionDeleteFieldInput>>;
};

export type DeviceSessionDisconnectInput = {
  usersHasSession?: InputMaybe<Array<DeviceSessionUsersHasSessionDisconnectFieldInput>>;
};

export type DeviceSessionOnCreateInput = {
  id: Scalars['ID']['input'];
};

export type DeviceSessionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DeviceSessionSort objects to sort DeviceSessions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DeviceSessionSort>>;
};

/** Fields to sort DeviceSessions by. The order in which sorts are applied is not guaranteed when specifying many fields in one DeviceSessionSort object. */
export type DeviceSessionSort = {
  id?: InputMaybe<SortDirection>;
};

export type DeviceSessionUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type DeviceSessionUpdateInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  usersHasSession?: InputMaybe<Array<DeviceSessionUsersHasSessionUpdateFieldInput>>;
};

export type DeviceSessionUserUsersHasSessionAggregationSelection = {
  __typename?: 'DeviceSessionUserUsersHasSessionAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<DeviceSessionUserUsersHasSessionEdgeAggregateSelection>;
  node?: Maybe<DeviceSessionUserUsersHasSessionNodeAggregateSelection>;
};

export type DeviceSessionUserUsersHasSessionEdgeAggregateSelection = {
  __typename?: 'DeviceSessionUserUsersHasSessionEdgeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  expiresAt: DateTimeAggregateSelection;
};

export type DeviceSessionUserUsersHasSessionNodeAggregateSelection = {
  __typename?: 'DeviceSessionUserUsersHasSessionNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type DeviceSessionUsersHasSessionAggregateInput = {
  AND?: InputMaybe<Array<DeviceSessionUsersHasSessionAggregateInput>>;
  NOT?: InputMaybe<DeviceSessionUsersHasSessionAggregateInput>;
  OR?: InputMaybe<Array<DeviceSessionUsersHasSessionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasSessionPropertiesAggregationWhereInput>;
  node?: InputMaybe<DeviceSessionUsersHasSessionNodeAggregationWhereInput>;
};

export type DeviceSessionUsersHasSessionConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  edge: HasSessionPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type DeviceSessionUsersHasSessionConnectOrCreateFieldInput = {
  onCreate: DeviceSessionUsersHasSessionConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type DeviceSessionUsersHasSessionConnectOrCreateFieldInputOnCreate = {
  edge: HasSessionPropertiesCreateInput;
  node: UserOnCreateInput;
};

export type DeviceSessionUsersHasSessionConnection = {
  __typename?: 'DeviceSessionUsersHasSessionConnection';
  edges: Array<DeviceSessionUsersHasSessionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DeviceSessionUsersHasSessionConnectionSort = {
  edge?: InputMaybe<HasSessionPropertiesSort>;
  node?: InputMaybe<UserSort>;
};

export type DeviceSessionUsersHasSessionConnectionWhere = {
  AND?: InputMaybe<Array<DeviceSessionUsersHasSessionConnectionWhere>>;
  NOT?: InputMaybe<DeviceSessionUsersHasSessionConnectionWhere>;
  OR?: InputMaybe<Array<DeviceSessionUsersHasSessionConnectionWhere>>;
  edge?: InputMaybe<HasSessionPropertiesWhere>;
  node?: InputMaybe<UserWhere>;
};

export type DeviceSessionUsersHasSessionCreateFieldInput = {
  edge: HasSessionPropertiesCreateInput;
  node: UserCreateInput;
};

export type DeviceSessionUsersHasSessionDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<DeviceSessionUsersHasSessionConnectionWhere>;
};

export type DeviceSessionUsersHasSessionDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<DeviceSessionUsersHasSessionConnectionWhere>;
};

export type DeviceSessionUsersHasSessionFieldInput = {
  connect?: InputMaybe<Array<DeviceSessionUsersHasSessionConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<DeviceSessionUsersHasSessionConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<DeviceSessionUsersHasSessionCreateFieldInput>>;
};

export type DeviceSessionUsersHasSessionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DeviceSessionUsersHasSessionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DeviceSessionUsersHasSessionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DeviceSessionUsersHasSessionNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DeviceSessionUsersHasSessionRelationship = {
  __typename?: 'DeviceSessionUsersHasSessionRelationship';
  cursor: Scalars['String']['output'];
  node: User;
  properties: HasSessionProperties;
};

export type DeviceSessionUsersHasSessionUpdateConnectionInput = {
  edge?: InputMaybe<HasSessionPropertiesUpdateInput>;
  node?: InputMaybe<UserUpdateInput>;
};

export type DeviceSessionUsersHasSessionUpdateFieldInput = {
  connect?: InputMaybe<Array<DeviceSessionUsersHasSessionConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<DeviceSessionUsersHasSessionConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<DeviceSessionUsersHasSessionCreateFieldInput>>;
  delete?: InputMaybe<Array<DeviceSessionUsersHasSessionDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<DeviceSessionUsersHasSessionDisconnectFieldInput>>;
  update?: InputMaybe<DeviceSessionUsersHasSessionUpdateConnectionInput>;
  where?: InputMaybe<DeviceSessionUsersHasSessionConnectionWhere>;
};

export type DeviceSessionWhere = {
  AND?: InputMaybe<Array<DeviceSessionWhere>>;
  NOT?: InputMaybe<DeviceSessionWhere>;
  OR?: InputMaybe<Array<DeviceSessionWhere>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  usersHasSessionAggregate?: InputMaybe<DeviceSessionUsersHasSessionAggregateInput>;
  /** Return DeviceSessions where all of the related DeviceSessionUsersHasSessionConnections match this filter */
  usersHasSessionConnection_ALL?: InputMaybe<DeviceSessionUsersHasSessionConnectionWhere>;
  /** Return DeviceSessions where none of the related DeviceSessionUsersHasSessionConnections match this filter */
  usersHasSessionConnection_NONE?: InputMaybe<DeviceSessionUsersHasSessionConnectionWhere>;
  /** Return DeviceSessions where one of the related DeviceSessionUsersHasSessionConnections match this filter */
  usersHasSessionConnection_SINGLE?: InputMaybe<DeviceSessionUsersHasSessionConnectionWhere>;
  /** Return DeviceSessions where some of the related DeviceSessionUsersHasSessionConnections match this filter */
  usersHasSessionConnection_SOME?: InputMaybe<DeviceSessionUsersHasSessionConnectionWhere>;
  /** Return DeviceSessions where all of the related Users match this filter */
  usersHasSession_ALL?: InputMaybe<UserWhere>;
  /** Return DeviceSessions where none of the related Users match this filter */
  usersHasSession_NONE?: InputMaybe<UserWhere>;
  /** Return DeviceSessions where one of the related Users match this filter */
  usersHasSession_SINGLE?: InputMaybe<UserWhere>;
  /** Return DeviceSessions where some of the related Users match this filter */
  usersHasSession_SOME?: InputMaybe<UserWhere>;
};

export type Document = {
  __typename?: 'Document';
  adminDoc?: Maybe<Scalars['Boolean']['output']>;
  aiTutorSource?: Maybe<AiTutor>;
  aiTutorSourceAggregate?: Maybe<DocumentAiTutorAiTutorSourceAggregationSelection>;
  aiTutorSourceConnection: DocumentAiTutorSourceConnection;
  assessmentSource?: Maybe<Assessment>;
  assessmentSourceAggregate?: Maybe<DocumentAssessmentAssessmentSourceAggregationSelection>;
  assessmentSourceConnection: DocumentAssessmentSourceConnection;
  assignmentSource?: Maybe<Assignment>;
  assignmentSourceAggregate?: Maybe<DocumentAssignmentAssignmentSourceAggregationSelection>;
  assignmentSourceConnection: DocumentAssignmentSourceConnection;
  courseSource?: Maybe<Course>;
  courseSourceAggregate?: Maybe<DocumentCourseCourseSourceAggregationSelection>;
  courseSourceConnection: DocumentCourseSourceConnection;
  created: Scalars['DateTime']['output'];
  files: Array<File>;
  filesAggregate?: Maybe<DocumentFileFilesAggregationSelection>;
  filesConnection: DocumentFilesConnection;
  id: Scalars['ID']['output'];
  last_modified: Scalars['DateTime']['output'];
  messageSource?: Maybe<Message>;
  messageSourceAggregate?: Maybe<DocumentMessageMessageSourceAggregationSelection>;
  messageSourceConnection: DocumentMessageSourceConnection;
  references: Array<DocumentReference>;
  referencesAggregate?: Maybe<DocumentDocumentReferenceReferencesAggregationSelection>;
  referencesConnection: DocumentReferencesConnection;
  resourceSource?: Maybe<AxioResource>;
  resourceSourceAggregate?: Maybe<DocumentAxioResourceResourceSourceAggregationSelection>;
  resourceSourceConnection: DocumentResourceSourceConnection;
  sourceType?: Maybe<DocumentSourceType>;
  status: DocumentStatus;
  summary?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<Tenant>;
  tenantAggregate?: Maybe<DocumentTenantTenantAggregationSelection>;
  tenantConnection: DocumentTenantConnection;
  title: Scalars['String']['output'];
};


export type DocumentAiTutorSourceArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AiTutorOptions>;
  where?: InputMaybe<AiTutorWhere>;
};


export type DocumentAiTutorSourceAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AiTutorWhere>;
};


export type DocumentAiTutorSourceConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentAiTutorSourceConnectionSort>>;
  where?: InputMaybe<DocumentAiTutorSourceConnectionWhere>;
};


export type DocumentAssessmentSourceArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AssessmentOptions>;
  where?: InputMaybe<AssessmentWhere>;
};


export type DocumentAssessmentSourceAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssessmentWhere>;
};


export type DocumentAssessmentSourceConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentAssessmentSourceConnectionSort>>;
  where?: InputMaybe<DocumentAssessmentSourceConnectionWhere>;
};


export type DocumentAssignmentSourceArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AssignmentOptions>;
  where?: InputMaybe<AssignmentWhere>;
};


export type DocumentAssignmentSourceAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssignmentWhere>;
};


export type DocumentAssignmentSourceConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentAssignmentSourceConnectionSort>>;
  where?: InputMaybe<DocumentAssignmentSourceConnectionWhere>;
};


export type DocumentCourseSourceArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CourseOptions>;
  where?: InputMaybe<CourseWhere>;
};


export type DocumentCourseSourceAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CourseWhere>;
};


export type DocumentCourseSourceConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentCourseSourceConnectionSort>>;
  where?: InputMaybe<DocumentCourseSourceConnectionWhere>;
};


export type DocumentFilesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FileOptions>;
  where?: InputMaybe<FileWhere>;
};


export type DocumentFilesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FileWhere>;
};


export type DocumentFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentFilesConnectionSort>>;
  where?: InputMaybe<DocumentFilesConnectionWhere>;
};


export type DocumentMessageSourceArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<MessageOptions>;
  where?: InputMaybe<MessageWhere>;
};


export type DocumentMessageSourceAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MessageWhere>;
};


export type DocumentMessageSourceConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentMessageSourceConnectionSort>>;
  where?: InputMaybe<DocumentMessageSourceConnectionWhere>;
};


export type DocumentReferencesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DocumentReferenceOptions>;
  where?: InputMaybe<DocumentReferenceWhere>;
};


export type DocumentReferencesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DocumentReferenceWhere>;
};


export type DocumentReferencesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentReferencesConnectionSort>>;
  where?: InputMaybe<DocumentReferencesConnectionWhere>;
};


export type DocumentResourceSourceArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AxioResourceOptions>;
  where?: InputMaybe<AxioResourceWhere>;
};


export type DocumentResourceSourceAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AxioResourceWhere>;
};


export type DocumentResourceSourceConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentResourceSourceConnectionSort>>;
  where?: InputMaybe<DocumentResourceSourceConnectionWhere>;
};


export type DocumentTenantArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TenantOptions>;
  where?: InputMaybe<TenantWhere>;
};


export type DocumentTenantAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TenantWhere>;
};


export type DocumentTenantConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentTenantConnectionSort>>;
  where?: InputMaybe<DocumentTenantConnectionWhere>;
};

export type DocumentAiTutorAiTutorSourceAggregationSelection = {
  __typename?: 'DocumentAITutorAiTutorSourceAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentAiTutorAiTutorSourceNodeAggregateSelection>;
};

export type DocumentAiTutorAiTutorSourceNodeAggregateSelection = {
  __typename?: 'DocumentAITutorAiTutorSourceNodeAggregateSelection';
  context: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  targetAudience: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type DocumentAiTutorSourceAggregateInput = {
  AND?: InputMaybe<Array<DocumentAiTutorSourceAggregateInput>>;
  NOT?: InputMaybe<DocumentAiTutorSourceAggregateInput>;
  OR?: InputMaybe<Array<DocumentAiTutorSourceAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentAiTutorSourceNodeAggregationWhereInput>;
};

export type DocumentAiTutorSourceConnectFieldInput = {
  connect?: InputMaybe<AiTutorConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AiTutorConnectWhere>;
};

export type DocumentAiTutorSourceConnectOrCreateFieldInput = {
  onCreate: DocumentAiTutorSourceConnectOrCreateFieldInputOnCreate;
  where: AiTutorConnectOrCreateWhere;
};

export type DocumentAiTutorSourceConnectOrCreateFieldInputOnCreate = {
  node: AiTutorOnCreateInput;
};

export type DocumentAiTutorSourceConnection = {
  __typename?: 'DocumentAiTutorSourceConnection';
  edges: Array<DocumentAiTutorSourceRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentAiTutorSourceConnectionSort = {
  node?: InputMaybe<AiTutorSort>;
};

export type DocumentAiTutorSourceConnectionWhere = {
  AND?: InputMaybe<Array<DocumentAiTutorSourceConnectionWhere>>;
  NOT?: InputMaybe<DocumentAiTutorSourceConnectionWhere>;
  OR?: InputMaybe<Array<DocumentAiTutorSourceConnectionWhere>>;
  node?: InputMaybe<AiTutorWhere>;
};

export type DocumentAiTutorSourceCreateFieldInput = {
  node: AiTutorCreateInput;
};

export type DocumentAiTutorSourceDeleteFieldInput = {
  delete?: InputMaybe<AiTutorDeleteInput>;
  where?: InputMaybe<DocumentAiTutorSourceConnectionWhere>;
};

export type DocumentAiTutorSourceDisconnectFieldInput = {
  disconnect?: InputMaybe<AiTutorDisconnectInput>;
  where?: InputMaybe<DocumentAiTutorSourceConnectionWhere>;
};

export type DocumentAiTutorSourceFieldInput = {
  connect?: InputMaybe<DocumentAiTutorSourceConnectFieldInput>;
  connectOrCreate?: InputMaybe<DocumentAiTutorSourceConnectOrCreateFieldInput>;
  create?: InputMaybe<DocumentAiTutorSourceCreateFieldInput>;
};

export type DocumentAiTutorSourceNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentAiTutorSourceNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentAiTutorSourceNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentAiTutorSourceNodeAggregationWhereInput>>;
  context_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  context_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentAiTutorSourceRelationship = {
  __typename?: 'DocumentAiTutorSourceRelationship';
  cursor: Scalars['String']['output'];
  node: AiTutor;
};

export type DocumentAiTutorSourceUpdateConnectionInput = {
  node?: InputMaybe<AiTutorUpdateInput>;
};

export type DocumentAiTutorSourceUpdateFieldInput = {
  connect?: InputMaybe<DocumentAiTutorSourceConnectFieldInput>;
  connectOrCreate?: InputMaybe<DocumentAiTutorSourceConnectOrCreateFieldInput>;
  create?: InputMaybe<DocumentAiTutorSourceCreateFieldInput>;
  delete?: InputMaybe<DocumentAiTutorSourceDeleteFieldInput>;
  disconnect?: InputMaybe<DocumentAiTutorSourceDisconnectFieldInput>;
  update?: InputMaybe<DocumentAiTutorSourceUpdateConnectionInput>;
  where?: InputMaybe<DocumentAiTutorSourceConnectionWhere>;
};

export type DocumentAssessmentAssessmentSourceAggregationSelection = {
  __typename?: 'DocumentAssessmentAssessmentSourceAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentAssessmentAssessmentSourceNodeAggregateSelection>;
};

export type DocumentAssessmentAssessmentSourceNodeAggregateSelection = {
  __typename?: 'DocumentAssessmentAssessmentSourceNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  numberOfQuestions: IntAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  timeLimit: IntAggregateSelection;
};

export type DocumentAssessmentSourceAggregateInput = {
  AND?: InputMaybe<Array<DocumentAssessmentSourceAggregateInput>>;
  NOT?: InputMaybe<DocumentAssessmentSourceAggregateInput>;
  OR?: InputMaybe<Array<DocumentAssessmentSourceAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentAssessmentSourceNodeAggregationWhereInput>;
};

export type DocumentAssessmentSourceConnectFieldInput = {
  connect?: InputMaybe<AssessmentConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AssessmentConnectWhere>;
};

export type DocumentAssessmentSourceConnectOrCreateFieldInput = {
  onCreate: DocumentAssessmentSourceConnectOrCreateFieldInputOnCreate;
  where: AssessmentConnectOrCreateWhere;
};

export type DocumentAssessmentSourceConnectOrCreateFieldInputOnCreate = {
  node: AssessmentOnCreateInput;
};

export type DocumentAssessmentSourceConnection = {
  __typename?: 'DocumentAssessmentSourceConnection';
  edges: Array<DocumentAssessmentSourceRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentAssessmentSourceConnectionSort = {
  node?: InputMaybe<AssessmentSort>;
};

export type DocumentAssessmentSourceConnectionWhere = {
  AND?: InputMaybe<Array<DocumentAssessmentSourceConnectionWhere>>;
  NOT?: InputMaybe<DocumentAssessmentSourceConnectionWhere>;
  OR?: InputMaybe<Array<DocumentAssessmentSourceConnectionWhere>>;
  node?: InputMaybe<AssessmentWhere>;
};

export type DocumentAssessmentSourceCreateFieldInput = {
  node: AssessmentCreateInput;
};

export type DocumentAssessmentSourceDeleteFieldInput = {
  delete?: InputMaybe<AssessmentDeleteInput>;
  where?: InputMaybe<DocumentAssessmentSourceConnectionWhere>;
};

export type DocumentAssessmentSourceDisconnectFieldInput = {
  disconnect?: InputMaybe<AssessmentDisconnectInput>;
  where?: InputMaybe<DocumentAssessmentSourceConnectionWhere>;
};

export type DocumentAssessmentSourceFieldInput = {
  connect?: InputMaybe<DocumentAssessmentSourceConnectFieldInput>;
  connectOrCreate?: InputMaybe<DocumentAssessmentSourceConnectOrCreateFieldInput>;
  create?: InputMaybe<DocumentAssessmentSourceCreateFieldInput>;
};

export type DocumentAssessmentSourceNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentAssessmentSourceNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentAssessmentSourceNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentAssessmentSourceNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfQuestions_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  timeLimit_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentAssessmentSourceRelationship = {
  __typename?: 'DocumentAssessmentSourceRelationship';
  cursor: Scalars['String']['output'];
  node: Assessment;
};

export type DocumentAssessmentSourceUpdateConnectionInput = {
  node?: InputMaybe<AssessmentUpdateInput>;
};

export type DocumentAssessmentSourceUpdateFieldInput = {
  connect?: InputMaybe<DocumentAssessmentSourceConnectFieldInput>;
  connectOrCreate?: InputMaybe<DocumentAssessmentSourceConnectOrCreateFieldInput>;
  create?: InputMaybe<DocumentAssessmentSourceCreateFieldInput>;
  delete?: InputMaybe<DocumentAssessmentSourceDeleteFieldInput>;
  disconnect?: InputMaybe<DocumentAssessmentSourceDisconnectFieldInput>;
  update?: InputMaybe<DocumentAssessmentSourceUpdateConnectionInput>;
  where?: InputMaybe<DocumentAssessmentSourceConnectionWhere>;
};

export type DocumentAssignmentAssignmentSourceAggregationSelection = {
  __typename?: 'DocumentAssignmentAssignmentSourceAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentAssignmentAssignmentSourceNodeAggregateSelection>;
};

export type DocumentAssignmentAssignmentSourceNodeAggregateSelection = {
  __typename?: 'DocumentAssignmentAssignmentSourceNodeAggregateSelection';
  _empty: StringAggregateSelection;
  allowed_attempts: FloatAggregateSelection;
  assignee_mode: StringAggregateSelection;
  assignment_group_id: FloatAggregateSelection;
  assignment_name: StringAggregateSelection;
  body: StringAggregateSelection;
  category_id: StringAggregateSelection;
  course_id: FloatAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  description: StringAggregateSelection;
  description_plaintext: StringAggregateSelection;
  discussion_topic_assignment_id: FloatAggregateSelection;
  discussion_topic_author_anonymous_id: StringAggregateSelection;
  discussion_topic_author_avatar_image_url: StringAggregateSelection;
  discussion_topic_author_display_name: StringAggregateSelection;
  discussion_topic_author_html_url: StringAggregateSelection;
  discussion_topic_author_id: FloatAggregateSelection;
  discussion_topic_created_at: StringAggregateSelection;
  discussion_topic_discussion_subentry_count: FloatAggregateSelection;
  discussion_topic_discussion_type: StringAggregateSelection;
  discussion_topic_html_url: StringAggregateSelection;
  discussion_topic_id: FloatAggregateSelection;
  discussion_topic_last_reply_at: StringAggregateSelection;
  discussion_topic_message: StringAggregateSelection;
  discussion_topic_posted_at: StringAggregateSelection;
  discussion_topic_read_state: StringAggregateSelection;
  discussion_topic_title: StringAggregateSelection;
  discussion_topic_unread_count: FloatAggregateSelection;
  discussion_topic_url: StringAggregateSelection;
  discussion_topic_user_name: StringAggregateSelection;
  display_date: StringAggregateSelection;
  due_at: StringAggregateSelection;
  due_date: DateTimeAggregateSelection;
  end_date: StringAggregateSelection;
  external_tool_tag_attributes_content_id: FloatAggregateSelection;
  external_tool_tag_attributes_content_type: StringAggregateSelection;
  external_tool_tag_attributes_external_data: StringAggregateSelection;
  external_tool_tag_attributes_resource_link_id: StringAggregateSelection;
  external_tool_tag_attributes_url: StringAggregateSelection;
  grade_points: FloatAggregateSelection;
  grader_count: FloatAggregateSelection;
  grading_type: StringAggregateSelection;
  html: StringAggregateSelection;
  html_url: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  lti_context_id: StringAggregateSelection;
  max_attempts: FloatAggregateSelection;
  max_name_length: FloatAggregateSelection;
  name: StringAggregateSelection;
  needs_grading_count: FloatAggregateSelection;
  objectives: StringAggregateSelection;
  points_possible: FloatAggregateSelection;
  position: FloatAggregateSelection;
  resource_metadata: StringAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  secure_params: StringAggregateSelection;
  session_id: StringAggregateSelection;
  start_date: StringAggregateSelection;
  state: StringAggregateSelection;
  submissions_download_url: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_at: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  url: StringAggregateSelection;
  videoUrl: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export type DocumentAssignmentSourceAggregateInput = {
  AND?: InputMaybe<Array<DocumentAssignmentSourceAggregateInput>>;
  NOT?: InputMaybe<DocumentAssignmentSourceAggregateInput>;
  OR?: InputMaybe<Array<DocumentAssignmentSourceAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentAssignmentSourceNodeAggregationWhereInput>;
};

export type DocumentAssignmentSourceConnectFieldInput = {
  connect?: InputMaybe<AssignmentConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AssignmentConnectWhere>;
};

export type DocumentAssignmentSourceConnectOrCreateFieldInput = {
  onCreate: DocumentAssignmentSourceConnectOrCreateFieldInputOnCreate;
  where: AssignmentConnectOrCreateWhere;
};

export type DocumentAssignmentSourceConnectOrCreateFieldInputOnCreate = {
  node: AssignmentOnCreateInput;
};

export type DocumentAssignmentSourceConnection = {
  __typename?: 'DocumentAssignmentSourceConnection';
  edges: Array<DocumentAssignmentSourceRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentAssignmentSourceConnectionSort = {
  node?: InputMaybe<AssignmentSort>;
};

export type DocumentAssignmentSourceConnectionWhere = {
  AND?: InputMaybe<Array<DocumentAssignmentSourceConnectionWhere>>;
  NOT?: InputMaybe<DocumentAssignmentSourceConnectionWhere>;
  OR?: InputMaybe<Array<DocumentAssignmentSourceConnectionWhere>>;
  node?: InputMaybe<AssignmentWhere>;
};

export type DocumentAssignmentSourceCreateFieldInput = {
  node: AssignmentCreateInput;
};

export type DocumentAssignmentSourceDeleteFieldInput = {
  delete?: InputMaybe<AssignmentDeleteInput>;
  where?: InputMaybe<DocumentAssignmentSourceConnectionWhere>;
};

export type DocumentAssignmentSourceDisconnectFieldInput = {
  disconnect?: InputMaybe<AssignmentDisconnectInput>;
  where?: InputMaybe<DocumentAssignmentSourceConnectionWhere>;
};

export type DocumentAssignmentSourceFieldInput = {
  connect?: InputMaybe<DocumentAssignmentSourceConnectFieldInput>;
  connectOrCreate?: InputMaybe<DocumentAssignmentSourceConnectOrCreateFieldInput>;
  create?: InputMaybe<DocumentAssignmentSourceCreateFieldInput>;
};

export type DocumentAssignmentSourceNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentAssignmentSourceNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentAssignmentSourceNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentAssignmentSourceNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  allowed_attempts_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_group_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  body_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  category_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_assignment_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_unread_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  display_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  due_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_date_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_points_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  html_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lti_context_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  max_attempts_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  needs_grading_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  points_possible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  secure_params_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  secure_params_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  session_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentAssignmentSourceRelationship = {
  __typename?: 'DocumentAssignmentSourceRelationship';
  cursor: Scalars['String']['output'];
  node: Assignment;
};

export type DocumentAssignmentSourceUpdateConnectionInput = {
  node?: InputMaybe<AssignmentUpdateInput>;
};

export type DocumentAssignmentSourceUpdateFieldInput = {
  connect?: InputMaybe<DocumentAssignmentSourceConnectFieldInput>;
  connectOrCreate?: InputMaybe<DocumentAssignmentSourceConnectOrCreateFieldInput>;
  create?: InputMaybe<DocumentAssignmentSourceCreateFieldInput>;
  delete?: InputMaybe<DocumentAssignmentSourceDeleteFieldInput>;
  disconnect?: InputMaybe<DocumentAssignmentSourceDisconnectFieldInput>;
  update?: InputMaybe<DocumentAssignmentSourceUpdateConnectionInput>;
  where?: InputMaybe<DocumentAssignmentSourceConnectionWhere>;
};

export type DocumentAxioResourceResourceSourceAggregationSelection = {
  __typename?: 'DocumentAxioResourceResourceSourceAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentAxioResourceResourceSourceNodeAggregateSelection>;
};

export type DocumentAxioResourceResourceSourceNodeAggregateSelection = {
  __typename?: 'DocumentAxioResourceResourceSourceNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  moduleId: IdAggregateSelection;
  name: StringAggregateSelection;
  order: IntAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  videoUrl: StringAggregateSelection;
};

export type DocumentConnectInput = {
  aiTutorSource?: InputMaybe<DocumentAiTutorSourceConnectFieldInput>;
  assessmentSource?: InputMaybe<DocumentAssessmentSourceConnectFieldInput>;
  assignmentSource?: InputMaybe<DocumentAssignmentSourceConnectFieldInput>;
  courseSource?: InputMaybe<DocumentCourseSourceConnectFieldInput>;
  files?: InputMaybe<Array<DocumentFilesConnectFieldInput>>;
  messageSource?: InputMaybe<DocumentMessageSourceConnectFieldInput>;
  references?: InputMaybe<Array<DocumentReferencesConnectFieldInput>>;
  resourceSource?: InputMaybe<DocumentResourceSourceConnectFieldInput>;
  tenant?: InputMaybe<DocumentTenantConnectFieldInput>;
};

export type DocumentConnectWhere = {
  node: DocumentWhere;
};

export type DocumentCourseCourseSourceAggregationSelection = {
  __typename?: 'DocumentCourseCourseSourceAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentCourseCourseSourceNodeAggregateSelection>;
};

export type DocumentCourseCourseSourceNodeAggregateSelection = {
  __typename?: 'DocumentCourseCourseSourceNodeAggregateSelection';
  account_id: FloatAggregateSelection;
  calendar_ics: StringAggregateSelection;
  cost: FloatAggregateSelection;
  courseId: StringAggregateSelection;
  course_code: StringAggregateSelection;
  course_id: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  default_view: StringAggregateSelection;
  description: StringAggregateSelection;
  dueDateEndDate: DateTimeAggregateSelection;
  dueDateStartDate: DateTimeAggregateSelection;
  endDate: DateTimeAggregateSelection;
  end_at: StringAggregateSelection;
  enrollment_term_id: FloatAggregateSelection;
  grading_standard_id: FloatAggregateSelection;
  id: IdAggregateSelection;
  integration_id: StringAggregateSelection;
  label: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  learningStandards: StringAggregateSelection;
  lengthInWeeks: FloatAggregateSelection;
  license: StringAggregateSelection;
  lti_id: StringAggregateSelection;
  name: StringAggregateSelection;
  original_name: StringAggregateSelection;
  root_account_id: FloatAggregateSelection;
  sis_course_id: StringAggregateSelection;
  sis_import_id: FloatAggregateSelection;
  startDate: DateTimeAggregateSelection;
  start_at: StringAggregateSelection;
  state: StringAggregateSelection;
  storage_quota_mb: FloatAggregateSelection;
  stripePriceId: StringAggregateSelection;
  stripeProductId: StringAggregateSelection;
  targetAudience: StringAggregateSelection;
  thumbnail: StringAggregateSelection;
  time_zone: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  uuid: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export type DocumentCourseSourceAggregateInput = {
  AND?: InputMaybe<Array<DocumentCourseSourceAggregateInput>>;
  NOT?: InputMaybe<DocumentCourseSourceAggregateInput>;
  OR?: InputMaybe<Array<DocumentCourseSourceAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentCourseSourceNodeAggregationWhereInput>;
};

export type DocumentCourseSourceConnectFieldInput = {
  connect?: InputMaybe<CourseConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CourseConnectWhere>;
};

export type DocumentCourseSourceConnectOrCreateFieldInput = {
  onCreate: DocumentCourseSourceConnectOrCreateFieldInputOnCreate;
  where: CourseConnectOrCreateWhere;
};

export type DocumentCourseSourceConnectOrCreateFieldInputOnCreate = {
  node: CourseOnCreateInput;
};

export type DocumentCourseSourceConnection = {
  __typename?: 'DocumentCourseSourceConnection';
  edges: Array<DocumentCourseSourceRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentCourseSourceConnectionSort = {
  node?: InputMaybe<CourseSort>;
};

export type DocumentCourseSourceConnectionWhere = {
  AND?: InputMaybe<Array<DocumentCourseSourceConnectionWhere>>;
  NOT?: InputMaybe<DocumentCourseSourceConnectionWhere>;
  OR?: InputMaybe<Array<DocumentCourseSourceConnectionWhere>>;
  node?: InputMaybe<CourseWhere>;
};

export type DocumentCourseSourceCreateFieldInput = {
  node: CourseCreateInput;
};

export type DocumentCourseSourceDeleteFieldInput = {
  delete?: InputMaybe<CourseDeleteInput>;
  where?: InputMaybe<DocumentCourseSourceConnectionWhere>;
};

export type DocumentCourseSourceDisconnectFieldInput = {
  disconnect?: InputMaybe<CourseDisconnectInput>;
  where?: InputMaybe<DocumentCourseSourceConnectionWhere>;
};

export type DocumentCourseSourceFieldInput = {
  connect?: InputMaybe<DocumentCourseSourceConnectFieldInput>;
  connectOrCreate?: InputMaybe<DocumentCourseSourceConnectOrCreateFieldInput>;
  create?: InputMaybe<DocumentCourseSourceCreateFieldInput>;
};

export type DocumentCourseSourceNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentCourseSourceNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentCourseSourceNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentCourseSourceNodeAggregationWhereInput>>;
  account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  cost_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDateEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  enrollment_term_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  label_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningStandards_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthInWeeks_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  root_account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_import_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  startDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  storage_quota_mb_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentCourseSourceRelationship = {
  __typename?: 'DocumentCourseSourceRelationship';
  cursor: Scalars['String']['output'];
  node: Course;
};

export type DocumentCourseSourceUpdateConnectionInput = {
  node?: InputMaybe<CourseUpdateInput>;
};

export type DocumentCourseSourceUpdateFieldInput = {
  connect?: InputMaybe<DocumentCourseSourceConnectFieldInput>;
  connectOrCreate?: InputMaybe<DocumentCourseSourceConnectOrCreateFieldInput>;
  create?: InputMaybe<DocumentCourseSourceCreateFieldInput>;
  delete?: InputMaybe<DocumentCourseSourceDeleteFieldInput>;
  disconnect?: InputMaybe<DocumentCourseSourceDisconnectFieldInput>;
  update?: InputMaybe<DocumentCourseSourceUpdateConnectionInput>;
  where?: InputMaybe<DocumentCourseSourceConnectionWhere>;
};

export type DocumentCreateInput = {
  adminDoc?: InputMaybe<Scalars['Boolean']['input']>;
  aiTutorSource?: InputMaybe<DocumentAiTutorSourceFieldInput>;
  assessmentSource?: InputMaybe<DocumentAssessmentSourceFieldInput>;
  assignmentSource?: InputMaybe<DocumentAssignmentSourceFieldInput>;
  courseSource?: InputMaybe<DocumentCourseSourceFieldInput>;
  created: Scalars['DateTime']['input'];
  files?: InputMaybe<DocumentFilesFieldInput>;
  id: Scalars['ID']['input'];
  last_modified: Scalars['DateTime']['input'];
  messageSource?: InputMaybe<DocumentMessageSourceFieldInput>;
  references?: InputMaybe<DocumentReferencesFieldInput>;
  resourceSource?: InputMaybe<DocumentResourceSourceFieldInput>;
  sourceType?: InputMaybe<DocumentSourceType>;
  status: DocumentStatus;
  summary?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<DocumentTenantFieldInput>;
  title: Scalars['String']['input'];
};

export type DocumentDeleteInput = {
  aiTutorSource?: InputMaybe<DocumentAiTutorSourceDeleteFieldInput>;
  assessmentSource?: InputMaybe<DocumentAssessmentSourceDeleteFieldInput>;
  assignmentSource?: InputMaybe<DocumentAssignmentSourceDeleteFieldInput>;
  courseSource?: InputMaybe<DocumentCourseSourceDeleteFieldInput>;
  files?: InputMaybe<Array<DocumentFilesDeleteFieldInput>>;
  messageSource?: InputMaybe<DocumentMessageSourceDeleteFieldInput>;
  references?: InputMaybe<Array<DocumentReferencesDeleteFieldInput>>;
  resourceSource?: InputMaybe<DocumentResourceSourceDeleteFieldInput>;
  tenant?: InputMaybe<DocumentTenantDeleteFieldInput>;
};

export type DocumentDisconnectInput = {
  aiTutorSource?: InputMaybe<DocumentAiTutorSourceDisconnectFieldInput>;
  assessmentSource?: InputMaybe<DocumentAssessmentSourceDisconnectFieldInput>;
  assignmentSource?: InputMaybe<DocumentAssignmentSourceDisconnectFieldInput>;
  courseSource?: InputMaybe<DocumentCourseSourceDisconnectFieldInput>;
  files?: InputMaybe<Array<DocumentFilesDisconnectFieldInput>>;
  messageSource?: InputMaybe<DocumentMessageSourceDisconnectFieldInput>;
  references?: InputMaybe<Array<DocumentReferencesDisconnectFieldInput>>;
  resourceSource?: InputMaybe<DocumentResourceSourceDisconnectFieldInput>;
  tenant?: InputMaybe<DocumentTenantDisconnectFieldInput>;
};

export type DocumentDocumentReferenceReferencesAggregationSelection = {
  __typename?: 'DocumentDocumentReferenceReferencesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentDocumentReferenceReferencesNodeAggregateSelection>;
};

export type DocumentDocumentReferenceReferencesNodeAggregateSelection = {
  __typename?: 'DocumentDocumentReferenceReferencesNodeAggregateSelection';
  chatId: IdAggregateSelection;
  documentId: IdAggregateSelection;
  id: IdAggregateSelection;
  messageId: IdAggregateSelection;
  referencedAt: DateTimeAggregateSelection;
  tenantId: IdAggregateSelection;
};

export type DocumentFileFilesAggregationSelection = {
  __typename?: 'DocumentFileFilesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentFileFilesNodeAggregateSelection>;
};

export type DocumentFileFilesNodeAggregateSelection = {
  __typename?: 'DocumentFileFilesNodeAggregateSelection';
  bucketName: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  fileName: StringAggregateSelection;
  filePath: StringAggregateSelection;
  fileURL: StringAggregateSelection;
  id: IdAggregateSelection;
};

export type DocumentFilesAggregateInput = {
  AND?: InputMaybe<Array<DocumentFilesAggregateInput>>;
  NOT?: InputMaybe<DocumentFilesAggregateInput>;
  OR?: InputMaybe<Array<DocumentFilesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentFilesNodeAggregationWhereInput>;
};

export type DocumentFilesConnectFieldInput = {
  connect?: InputMaybe<Array<FileConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FileConnectWhere>;
};

export type DocumentFilesConnectOrCreateFieldInput = {
  onCreate: DocumentFilesConnectOrCreateFieldInputOnCreate;
  where: FileConnectOrCreateWhere;
};

export type DocumentFilesConnectOrCreateFieldInputOnCreate = {
  node: FileOnCreateInput;
};

export type DocumentFilesConnection = {
  __typename?: 'DocumentFilesConnection';
  edges: Array<DocumentFilesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentFilesConnectionSort = {
  node?: InputMaybe<FileSort>;
};

export type DocumentFilesConnectionWhere = {
  AND?: InputMaybe<Array<DocumentFilesConnectionWhere>>;
  NOT?: InputMaybe<DocumentFilesConnectionWhere>;
  OR?: InputMaybe<Array<DocumentFilesConnectionWhere>>;
  node?: InputMaybe<FileWhere>;
};

export type DocumentFilesCreateFieldInput = {
  node: FileCreateInput;
};

export type DocumentFilesDeleteFieldInput = {
  delete?: InputMaybe<FileDeleteInput>;
  where?: InputMaybe<DocumentFilesConnectionWhere>;
};

export type DocumentFilesDisconnectFieldInput = {
  disconnect?: InputMaybe<FileDisconnectInput>;
  where?: InputMaybe<DocumentFilesConnectionWhere>;
};

export type DocumentFilesFieldInput = {
  connect?: InputMaybe<Array<DocumentFilesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentFilesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<DocumentFilesCreateFieldInput>>;
};

export type DocumentFilesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentFilesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentFilesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentFilesNodeAggregationWhereInput>>;
  bucketName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  bucketName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  fileName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileURL_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentFilesRelationship = {
  __typename?: 'DocumentFilesRelationship';
  cursor: Scalars['String']['output'];
  node: File;
};

export type DocumentFilesUpdateConnectionInput = {
  node?: InputMaybe<FileUpdateInput>;
};

export type DocumentFilesUpdateFieldInput = {
  connect?: InputMaybe<Array<DocumentFilesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentFilesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<DocumentFilesCreateFieldInput>>;
  delete?: InputMaybe<Array<DocumentFilesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<DocumentFilesDisconnectFieldInput>>;
  update?: InputMaybe<DocumentFilesUpdateConnectionInput>;
  where?: InputMaybe<DocumentFilesConnectionWhere>;
};

export type DocumentMessageMessageSourceAggregationSelection = {
  __typename?: 'DocumentMessageMessageSourceAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentMessageMessageSourceNodeAggregateSelection>;
};

export type DocumentMessageMessageSourceNodeAggregateSelection = {
  __typename?: 'DocumentMessageMessageSourceNodeAggregateSelection';
  aspectDetails: StringAggregateSelection;
  content: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  emotion: StringAggregateSelection;
  id: IdAggregateSelection;
  index: IntAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  nodeId: StringAggregateSelection;
  parameters: StringAggregateSelection;
  sender: StringAggregateSelection;
  snackType: StringAggregateSelection;
  type: StringAggregateSelection;
};

export type DocumentMessageSourceAggregateInput = {
  AND?: InputMaybe<Array<DocumentMessageSourceAggregateInput>>;
  NOT?: InputMaybe<DocumentMessageSourceAggregateInput>;
  OR?: InputMaybe<Array<DocumentMessageSourceAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentMessageSourceNodeAggregationWhereInput>;
};

export type DocumentMessageSourceConnectFieldInput = {
  connect?: InputMaybe<MessageConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<MessageConnectWhere>;
};

export type DocumentMessageSourceConnectOrCreateFieldInput = {
  onCreate: DocumentMessageSourceConnectOrCreateFieldInputOnCreate;
  where: MessageConnectOrCreateWhere;
};

export type DocumentMessageSourceConnectOrCreateFieldInputOnCreate = {
  node: MessageOnCreateInput;
};

export type DocumentMessageSourceConnection = {
  __typename?: 'DocumentMessageSourceConnection';
  edges: Array<DocumentMessageSourceRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentMessageSourceConnectionSort = {
  node?: InputMaybe<MessageSort>;
};

export type DocumentMessageSourceConnectionWhere = {
  AND?: InputMaybe<Array<DocumentMessageSourceConnectionWhere>>;
  NOT?: InputMaybe<DocumentMessageSourceConnectionWhere>;
  OR?: InputMaybe<Array<DocumentMessageSourceConnectionWhere>>;
  node?: InputMaybe<MessageWhere>;
};

export type DocumentMessageSourceCreateFieldInput = {
  node: MessageCreateInput;
};

export type DocumentMessageSourceDeleteFieldInput = {
  delete?: InputMaybe<MessageDeleteInput>;
  where?: InputMaybe<DocumentMessageSourceConnectionWhere>;
};

export type DocumentMessageSourceDisconnectFieldInput = {
  disconnect?: InputMaybe<MessageDisconnectInput>;
  where?: InputMaybe<DocumentMessageSourceConnectionWhere>;
};

export type DocumentMessageSourceFieldInput = {
  connect?: InputMaybe<DocumentMessageSourceConnectFieldInput>;
  connectOrCreate?: InputMaybe<DocumentMessageSourceConnectOrCreateFieldInput>;
  create?: InputMaybe<DocumentMessageSourceCreateFieldInput>;
};

export type DocumentMessageSourceNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentMessageSourceNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentMessageSourceNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentMessageSourceNodeAggregationWhereInput>>;
  aspectDetails_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  content_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  content_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  emotion_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emotion_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emotion_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emotion_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emotion_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emotion_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emotion_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emotion_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emotion_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emotion_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  index_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  index_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  nodeId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nodeId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  nodeId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  nodeId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  nodeId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  nodeId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nodeId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nodeId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nodeId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nodeId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  parameters_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  parameters_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  parameters_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  parameters_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  parameters_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  parameters_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  parameters_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  parameters_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  parameters_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  parameters_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  snackType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  snackType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  snackType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  snackType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  snackType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  snackType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  snackType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  snackType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  snackType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  snackType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentMessageSourceRelationship = {
  __typename?: 'DocumentMessageSourceRelationship';
  cursor: Scalars['String']['output'];
  node: Message;
};

export type DocumentMessageSourceUpdateConnectionInput = {
  node?: InputMaybe<MessageUpdateInput>;
};

export type DocumentMessageSourceUpdateFieldInput = {
  connect?: InputMaybe<DocumentMessageSourceConnectFieldInput>;
  connectOrCreate?: InputMaybe<DocumentMessageSourceConnectOrCreateFieldInput>;
  create?: InputMaybe<DocumentMessageSourceCreateFieldInput>;
  delete?: InputMaybe<DocumentMessageSourceDeleteFieldInput>;
  disconnect?: InputMaybe<DocumentMessageSourceDisconnectFieldInput>;
  update?: InputMaybe<DocumentMessageSourceUpdateConnectionInput>;
  where?: InputMaybe<DocumentMessageSourceConnectionWhere>;
};

export type DocumentOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DocumentSort objects to sort Documents by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DocumentSort>>;
};

export type DocumentReference = {
  __typename?: 'DocumentReference';
  chatId?: Maybe<Scalars['ID']['output']>;
  document: Document;
  documentAggregate?: Maybe<DocumentReferenceDocumentDocumentAggregationSelection>;
  documentConnection: DocumentReferenceDocumentConnection;
  documentId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  messageId?: Maybe<Scalars['ID']['output']>;
  referencedAt: Scalars['DateTime']['output'];
  tenant: Tenant;
  tenantAggregate?: Maybe<DocumentReferenceTenantTenantAggregationSelection>;
  tenantConnection: DocumentReferenceTenantConnection;
  tenantId: Scalars['ID']['output'];
};


export type DocumentReferenceDocumentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DocumentOptions>;
  where?: InputMaybe<DocumentWhere>;
};


export type DocumentReferenceDocumentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DocumentWhere>;
};


export type DocumentReferenceDocumentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentReferenceDocumentConnectionSort>>;
  where?: InputMaybe<DocumentReferenceDocumentConnectionWhere>;
};


export type DocumentReferenceTenantArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TenantOptions>;
  where?: InputMaybe<TenantWhere>;
};


export type DocumentReferenceTenantAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TenantWhere>;
};


export type DocumentReferenceTenantConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentReferenceTenantConnectionSort>>;
  where?: InputMaybe<DocumentReferenceTenantConnectionWhere>;
};

export type DocumentReferenceAnalytics = {
  __typename?: 'DocumentReferenceAnalytics';
  documentId: Scalars['ID']['output'];
  referenceCount: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type DocumentReferenceAnalyticsInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DocumentReferenceAnalyticsResponse = {
  __typename?: 'DocumentReferenceAnalyticsResponse';
  count: Scalars['Int']['output'];
  data: Array<DocumentReferenceAnalytics>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DocumentReferenceConnectInput = {
  document?: InputMaybe<DocumentReferenceDocumentConnectFieldInput>;
  tenant?: InputMaybe<DocumentReferenceTenantConnectFieldInput>;
};

export type DocumentReferenceConnectOrCreateWhere = {
  node: DocumentReferenceUniqueWhere;
};

export type DocumentReferenceConnectWhere = {
  node: DocumentReferenceWhere;
};

export type DocumentReferenceCreateInput = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  document?: InputMaybe<DocumentReferenceDocumentFieldInput>;
  documentId: Scalars['ID']['input'];
  messageId?: InputMaybe<Scalars['ID']['input']>;
  referencedAt: Scalars['DateTime']['input'];
  tenant?: InputMaybe<DocumentReferenceTenantFieldInput>;
  tenantId: Scalars['ID']['input'];
};

export type DocumentReferenceDeleteInput = {
  document?: InputMaybe<DocumentReferenceDocumentDeleteFieldInput>;
  tenant?: InputMaybe<DocumentReferenceTenantDeleteFieldInput>;
};

export type DocumentReferenceDisconnectInput = {
  document?: InputMaybe<DocumentReferenceDocumentDisconnectFieldInput>;
  tenant?: InputMaybe<DocumentReferenceTenantDisconnectFieldInput>;
};

export type DocumentReferenceDocumentAggregateInput = {
  AND?: InputMaybe<Array<DocumentReferenceDocumentAggregateInput>>;
  NOT?: InputMaybe<DocumentReferenceDocumentAggregateInput>;
  OR?: InputMaybe<Array<DocumentReferenceDocumentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentReferenceDocumentNodeAggregationWhereInput>;
};

export type DocumentReferenceDocumentConnectFieldInput = {
  connect?: InputMaybe<DocumentConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DocumentConnectWhere>;
};

export type DocumentReferenceDocumentConnection = {
  __typename?: 'DocumentReferenceDocumentConnection';
  edges: Array<DocumentReferenceDocumentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentReferenceDocumentConnectionSort = {
  node?: InputMaybe<DocumentSort>;
};

export type DocumentReferenceDocumentConnectionWhere = {
  AND?: InputMaybe<Array<DocumentReferenceDocumentConnectionWhere>>;
  NOT?: InputMaybe<DocumentReferenceDocumentConnectionWhere>;
  OR?: InputMaybe<Array<DocumentReferenceDocumentConnectionWhere>>;
  node?: InputMaybe<DocumentWhere>;
};

export type DocumentReferenceDocumentCreateFieldInput = {
  node: DocumentCreateInput;
};

export type DocumentReferenceDocumentDeleteFieldInput = {
  delete?: InputMaybe<DocumentDeleteInput>;
  where?: InputMaybe<DocumentReferenceDocumentConnectionWhere>;
};

export type DocumentReferenceDocumentDisconnectFieldInput = {
  disconnect?: InputMaybe<DocumentDisconnectInput>;
  where?: InputMaybe<DocumentReferenceDocumentConnectionWhere>;
};

export type DocumentReferenceDocumentDocumentAggregationSelection = {
  __typename?: 'DocumentReferenceDocumentDocumentAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentReferenceDocumentDocumentNodeAggregateSelection>;
};

export type DocumentReferenceDocumentDocumentNodeAggregateSelection = {
  __typename?: 'DocumentReferenceDocumentDocumentNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  summary: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type DocumentReferenceDocumentFieldInput = {
  connect?: InputMaybe<DocumentReferenceDocumentConnectFieldInput>;
  create?: InputMaybe<DocumentReferenceDocumentCreateFieldInput>;
};

export type DocumentReferenceDocumentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentReferenceDocumentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentReferenceDocumentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentReferenceDocumentNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  summary_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  summary_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentReferenceDocumentRelationship = {
  __typename?: 'DocumentReferenceDocumentRelationship';
  cursor: Scalars['String']['output'];
  node: Document;
};

export type DocumentReferenceDocumentUpdateConnectionInput = {
  node?: InputMaybe<DocumentUpdateInput>;
};

export type DocumentReferenceDocumentUpdateFieldInput = {
  connect?: InputMaybe<DocumentReferenceDocumentConnectFieldInput>;
  create?: InputMaybe<DocumentReferenceDocumentCreateFieldInput>;
  delete?: InputMaybe<DocumentReferenceDocumentDeleteFieldInput>;
  disconnect?: InputMaybe<DocumentReferenceDocumentDisconnectFieldInput>;
  update?: InputMaybe<DocumentReferenceDocumentUpdateConnectionInput>;
  where?: InputMaybe<DocumentReferenceDocumentConnectionWhere>;
};

export type DocumentReferenceOnCreateInput = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  documentId: Scalars['ID']['input'];
  messageId?: InputMaybe<Scalars['ID']['input']>;
  referencedAt: Scalars['DateTime']['input'];
  tenantId: Scalars['ID']['input'];
};

export type DocumentReferenceOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DocumentReferenceSort objects to sort DocumentReferences by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DocumentReferenceSort>>;
};

/** Fields to sort DocumentReferences by. The order in which sorts are applied is not guaranteed when specifying many fields in one DocumentReferenceSort object. */
export type DocumentReferenceSort = {
  chatId?: InputMaybe<SortDirection>;
  documentId?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  messageId?: InputMaybe<SortDirection>;
  referencedAt?: InputMaybe<SortDirection>;
  tenantId?: InputMaybe<SortDirection>;
};

export type DocumentReferenceTenantAggregateInput = {
  AND?: InputMaybe<Array<DocumentReferenceTenantAggregateInput>>;
  NOT?: InputMaybe<DocumentReferenceTenantAggregateInput>;
  OR?: InputMaybe<Array<DocumentReferenceTenantAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentReferenceTenantNodeAggregationWhereInput>;
};

export type DocumentReferenceTenantConnectFieldInput = {
  connect?: InputMaybe<TenantConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TenantConnectWhere>;
};

export type DocumentReferenceTenantConnectOrCreateFieldInput = {
  onCreate: DocumentReferenceTenantConnectOrCreateFieldInputOnCreate;
  where: TenantConnectOrCreateWhere;
};

export type DocumentReferenceTenantConnectOrCreateFieldInputOnCreate = {
  node: TenantOnCreateInput;
};

export type DocumentReferenceTenantConnection = {
  __typename?: 'DocumentReferenceTenantConnection';
  edges: Array<DocumentReferenceTenantRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentReferenceTenantConnectionSort = {
  node?: InputMaybe<TenantSort>;
};

export type DocumentReferenceTenantConnectionWhere = {
  AND?: InputMaybe<Array<DocumentReferenceTenantConnectionWhere>>;
  NOT?: InputMaybe<DocumentReferenceTenantConnectionWhere>;
  OR?: InputMaybe<Array<DocumentReferenceTenantConnectionWhere>>;
  node?: InputMaybe<TenantWhere>;
};

export type DocumentReferenceTenantCreateFieldInput = {
  node: TenantCreateInput;
};

export type DocumentReferenceTenantDeleteFieldInput = {
  delete?: InputMaybe<TenantDeleteInput>;
  where?: InputMaybe<DocumentReferenceTenantConnectionWhere>;
};

export type DocumentReferenceTenantDisconnectFieldInput = {
  disconnect?: InputMaybe<TenantDisconnectInput>;
  where?: InputMaybe<DocumentReferenceTenantConnectionWhere>;
};

export type DocumentReferenceTenantFieldInput = {
  connect?: InputMaybe<DocumentReferenceTenantConnectFieldInput>;
  connectOrCreate?: InputMaybe<DocumentReferenceTenantConnectOrCreateFieldInput>;
  create?: InputMaybe<DocumentReferenceTenantCreateFieldInput>;
};

export type DocumentReferenceTenantNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentReferenceTenantNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentReferenceTenantNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentReferenceTenantNodeAggregationWhereInput>>;
  companionName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  companionName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  key_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  key_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogImage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  proLogo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentReferenceTenantRelationship = {
  __typename?: 'DocumentReferenceTenantRelationship';
  cursor: Scalars['String']['output'];
  node: Tenant;
};

export type DocumentReferenceTenantTenantAggregationSelection = {
  __typename?: 'DocumentReferenceTenantTenantAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentReferenceTenantTenantNodeAggregateSelection>;
};

export type DocumentReferenceTenantTenantNodeAggregateSelection = {
  __typename?: 'DocumentReferenceTenantTenantNodeAggregateSelection';
  companionName: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  emailBackgroundColor: StringAggregateSelection;
  emailFooterColor: StringAggregateSelection;
  emulationStatement: StringAggregateSelection;
  externalSendGridDailyEmailTemplateId: StringAggregateSelection;
  externalSendGridFromEmail: StringAggregateSelection;
  externalSendGridFromName: StringAggregateSelection;
  externalSendGridTwilioServiceSID: StringAggregateSelection;
  favicon16Url: StringAggregateSelection;
  favicon32Url: StringAggregateSelection;
  favicon48Url: StringAggregateSelection;
  favicon180Url: StringAggregateSelection;
  favicon192Url: StringAggregateSelection;
  favicon512Url: StringAggregateSelection;
  faviconIcoUrl: StringAggregateSelection;
  financialInformationUrl: StringAggregateSelection;
  gameMenuBg: StringAggregateSelection;
  gameMenuCardBg: StringAggregateSelection;
  gameMenuProgress: StringAggregateSelection;
  gameMenuTrack: StringAggregateSelection;
  generalPrompt: StringAggregateSelection;
  helpCenterUrl: StringAggregateSelection;
  id: IdAggregateSelection;
  key: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  learningEmulationStatement: StringAggregateSelection;
  logo: StringAggregateSelection;
  ltiLaunchUrl: StringAggregateSelection;
  miniLogo: StringAggregateSelection;
  newsSearchTerms: StringAggregateSelection;
  officialTranscriptsUrl: StringAggregateSelection;
  ogDescription: StringAggregateSelection;
  ogImage: StringAggregateSelection;
  ogImageHeight: StringAggregateSelection;
  ogImageWidth: StringAggregateSelection;
  ogSiteName: StringAggregateSelection;
  ogTitle: StringAggregateSelection;
  ogType: StringAggregateSelection;
  onboardingPrompt: StringAggregateSelection;
  primaryColor: StringAggregateSelection;
  proLogo: StringAggregateSelection;
  reportProblemUrl: StringAggregateSelection;
  scheduleAdvisorCallUrl: StringAggregateSelection;
  schoolResourcesUrl: StringAggregateSelection;
  stripeSecretKey: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  stripeTrialDays: IntAggregateSelection;
  submitHelpTicketLink: StringAggregateSelection;
  tenantDomain: StringAggregateSelection;
  tenantName: StringAggregateSelection;
  termsOfServiceLink: StringAggregateSelection;
  upgradeModalBody: StringAggregateSelection;
};

export type DocumentReferenceTenantUpdateConnectionInput = {
  node?: InputMaybe<TenantUpdateInput>;
};

export type DocumentReferenceTenantUpdateFieldInput = {
  connect?: InputMaybe<DocumentReferenceTenantConnectFieldInput>;
  connectOrCreate?: InputMaybe<DocumentReferenceTenantConnectOrCreateFieldInput>;
  create?: InputMaybe<DocumentReferenceTenantCreateFieldInput>;
  delete?: InputMaybe<DocumentReferenceTenantDeleteFieldInput>;
  disconnect?: InputMaybe<DocumentReferenceTenantDisconnectFieldInput>;
  update?: InputMaybe<DocumentReferenceTenantUpdateConnectionInput>;
  where?: InputMaybe<DocumentReferenceTenantConnectionWhere>;
};

export type DocumentReferenceUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type DocumentReferenceUpdateInput = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  document?: InputMaybe<DocumentReferenceDocumentUpdateFieldInput>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
  messageId?: InputMaybe<Scalars['ID']['input']>;
  referencedAt?: InputMaybe<Scalars['DateTime']['input']>;
  tenant?: InputMaybe<DocumentReferenceTenantUpdateFieldInput>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};

export type DocumentReferenceWhere = {
  AND?: InputMaybe<Array<DocumentReferenceWhere>>;
  NOT?: InputMaybe<DocumentReferenceWhere>;
  OR?: InputMaybe<Array<DocumentReferenceWhere>>;
  chatId?: InputMaybe<Scalars['ID']['input']>;
  chatId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  chatId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  chatId_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  chatId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  document?: InputMaybe<DocumentWhere>;
  documentAggregate?: InputMaybe<DocumentReferenceDocumentAggregateInput>;
  documentConnection?: InputMaybe<DocumentReferenceDocumentConnectionWhere>;
  documentConnection_NOT?: InputMaybe<DocumentReferenceDocumentConnectionWhere>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
  documentId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  documentId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  documentId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  documentId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  document_NOT?: InputMaybe<DocumentWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  messageId?: InputMaybe<Scalars['ID']['input']>;
  messageId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  messageId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  messageId_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  messageId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  referencedAt?: InputMaybe<Scalars['DateTime']['input']>;
  referencedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  referencedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  referencedAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  referencedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  referencedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  tenant?: InputMaybe<TenantWhere>;
  tenantAggregate?: InputMaybe<DocumentReferenceTenantAggregateInput>;
  tenantConnection?: InputMaybe<DocumentReferenceTenantConnectionWhere>;
  tenantConnection_NOT?: InputMaybe<DocumentReferenceTenantConnectionWhere>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  tenantId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  tenantId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  tenantId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  tenant_NOT?: InputMaybe<TenantWhere>;
};

export type DocumentReferencesAggregateInput = {
  AND?: InputMaybe<Array<DocumentReferencesAggregateInput>>;
  NOT?: InputMaybe<DocumentReferencesAggregateInput>;
  OR?: InputMaybe<Array<DocumentReferencesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentReferencesNodeAggregationWhereInput>;
};

export type DocumentReferencesConnectFieldInput = {
  connect?: InputMaybe<Array<DocumentReferenceConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DocumentReferenceConnectWhere>;
};

export type DocumentReferencesConnectOrCreateFieldInput = {
  onCreate: DocumentReferencesConnectOrCreateFieldInputOnCreate;
  where: DocumentReferenceConnectOrCreateWhere;
};

export type DocumentReferencesConnectOrCreateFieldInputOnCreate = {
  node: DocumentReferenceOnCreateInput;
};

export type DocumentReferencesConnection = {
  __typename?: 'DocumentReferencesConnection';
  edges: Array<DocumentReferencesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentReferencesConnectionSort = {
  node?: InputMaybe<DocumentReferenceSort>;
};

export type DocumentReferencesConnectionWhere = {
  AND?: InputMaybe<Array<DocumentReferencesConnectionWhere>>;
  NOT?: InputMaybe<DocumentReferencesConnectionWhere>;
  OR?: InputMaybe<Array<DocumentReferencesConnectionWhere>>;
  node?: InputMaybe<DocumentReferenceWhere>;
};

export type DocumentReferencesCreateFieldInput = {
  node: DocumentReferenceCreateInput;
};

export type DocumentReferencesDeleteFieldInput = {
  delete?: InputMaybe<DocumentReferenceDeleteInput>;
  where?: InputMaybe<DocumentReferencesConnectionWhere>;
};

export type DocumentReferencesDisconnectFieldInput = {
  disconnect?: InputMaybe<DocumentReferenceDisconnectInput>;
  where?: InputMaybe<DocumentReferencesConnectionWhere>;
};

export type DocumentReferencesFieldInput = {
  connect?: InputMaybe<Array<DocumentReferencesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentReferencesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<DocumentReferencesCreateFieldInput>>;
};

export type DocumentReferencesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentReferencesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentReferencesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentReferencesNodeAggregationWhereInput>>;
  referencedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  referencedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  referencedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  referencedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  referencedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  referencedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  referencedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  referencedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  referencedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  referencedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DocumentReferencesRelationship = {
  __typename?: 'DocumentReferencesRelationship';
  cursor: Scalars['String']['output'];
  node: DocumentReference;
};

export type DocumentReferencesUpdateConnectionInput = {
  node?: InputMaybe<DocumentReferenceUpdateInput>;
};

export type DocumentReferencesUpdateFieldInput = {
  connect?: InputMaybe<Array<DocumentReferencesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentReferencesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<DocumentReferencesCreateFieldInput>>;
  delete?: InputMaybe<Array<DocumentReferencesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<DocumentReferencesDisconnectFieldInput>>;
  update?: InputMaybe<DocumentReferencesUpdateConnectionInput>;
  where?: InputMaybe<DocumentReferencesConnectionWhere>;
};

export type DocumentResourceSourceAggregateInput = {
  AND?: InputMaybe<Array<DocumentResourceSourceAggregateInput>>;
  NOT?: InputMaybe<DocumentResourceSourceAggregateInput>;
  OR?: InputMaybe<Array<DocumentResourceSourceAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentResourceSourceNodeAggregationWhereInput>;
};

export type DocumentResourceSourceConnectFieldInput = {
  connect?: InputMaybe<AxioResourceConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AxioResourceConnectWhere>;
};

export type DocumentResourceSourceConnectOrCreateFieldInput = {
  onCreate: DocumentResourceSourceConnectOrCreateFieldInputOnCreate;
  where: AxioResourceConnectOrCreateWhere;
};

export type DocumentResourceSourceConnectOrCreateFieldInputOnCreate = {
  node: AxioResourceOnCreateInput;
};

export type DocumentResourceSourceConnection = {
  __typename?: 'DocumentResourceSourceConnection';
  edges: Array<DocumentResourceSourceRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentResourceSourceConnectionSort = {
  node?: InputMaybe<AxioResourceSort>;
};

export type DocumentResourceSourceConnectionWhere = {
  AND?: InputMaybe<Array<DocumentResourceSourceConnectionWhere>>;
  NOT?: InputMaybe<DocumentResourceSourceConnectionWhere>;
  OR?: InputMaybe<Array<DocumentResourceSourceConnectionWhere>>;
  node?: InputMaybe<AxioResourceWhere>;
};

export type DocumentResourceSourceCreateFieldInput = {
  node: AxioResourceCreateInput;
};

export type DocumentResourceSourceDeleteFieldInput = {
  delete?: InputMaybe<AxioResourceDeleteInput>;
  where?: InputMaybe<DocumentResourceSourceConnectionWhere>;
};

export type DocumentResourceSourceDisconnectFieldInput = {
  disconnect?: InputMaybe<AxioResourceDisconnectInput>;
  where?: InputMaybe<DocumentResourceSourceConnectionWhere>;
};

export type DocumentResourceSourceFieldInput = {
  connect?: InputMaybe<DocumentResourceSourceConnectFieldInput>;
  connectOrCreate?: InputMaybe<DocumentResourceSourceConnectOrCreateFieldInput>;
  create?: InputMaybe<DocumentResourceSourceCreateFieldInput>;
};

export type DocumentResourceSourceNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentResourceSourceNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentResourceSourceNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentResourceSourceNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentResourceSourceRelationship = {
  __typename?: 'DocumentResourceSourceRelationship';
  cursor: Scalars['String']['output'];
  node: AxioResource;
};

export type DocumentResourceSourceUpdateConnectionInput = {
  node?: InputMaybe<AxioResourceUpdateInput>;
};

export type DocumentResourceSourceUpdateFieldInput = {
  connect?: InputMaybe<DocumentResourceSourceConnectFieldInput>;
  connectOrCreate?: InputMaybe<DocumentResourceSourceConnectOrCreateFieldInput>;
  create?: InputMaybe<DocumentResourceSourceCreateFieldInput>;
  delete?: InputMaybe<DocumentResourceSourceDeleteFieldInput>;
  disconnect?: InputMaybe<DocumentResourceSourceDisconnectFieldInput>;
  update?: InputMaybe<DocumentResourceSourceUpdateConnectionInput>;
  where?: InputMaybe<DocumentResourceSourceConnectionWhere>;
};

export type DocumentResponse = {
  __typename?: 'DocumentResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Document>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Fields to sort Documents by. The order in which sorts are applied is not guaranteed when specifying many fields in one DocumentSort object. */
export type DocumentSort = {
  adminDoc?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  last_modified?: InputMaybe<SortDirection>;
  sourceType?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  summary?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
};

export enum DocumentSourceType {
  Aitutor = 'aitutor',
  Assessment = 'assessment',
  Assignment = 'assignment',
  Course = 'course',
  Message = 'message',
  Resource = 'resource'
}

export enum DocumentStatus {
  Completed = 'completed',
  Failed = 'failed',
  Pending = 'pending',
  Processing = 'processing'
}

export type DocumentTenantAggregateInput = {
  AND?: InputMaybe<Array<DocumentTenantAggregateInput>>;
  NOT?: InputMaybe<DocumentTenantAggregateInput>;
  OR?: InputMaybe<Array<DocumentTenantAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentTenantNodeAggregationWhereInput>;
};

export type DocumentTenantConnectFieldInput = {
  connect?: InputMaybe<TenantConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TenantConnectWhere>;
};

export type DocumentTenantConnectOrCreateFieldInput = {
  onCreate: DocumentTenantConnectOrCreateFieldInputOnCreate;
  where: TenantConnectOrCreateWhere;
};

export type DocumentTenantConnectOrCreateFieldInputOnCreate = {
  node: TenantOnCreateInput;
};

export type DocumentTenantConnection = {
  __typename?: 'DocumentTenantConnection';
  edges: Array<DocumentTenantRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentTenantConnectionSort = {
  node?: InputMaybe<TenantSort>;
};

export type DocumentTenantConnectionWhere = {
  AND?: InputMaybe<Array<DocumentTenantConnectionWhere>>;
  NOT?: InputMaybe<DocumentTenantConnectionWhere>;
  OR?: InputMaybe<Array<DocumentTenantConnectionWhere>>;
  node?: InputMaybe<TenantWhere>;
};

export type DocumentTenantCreateFieldInput = {
  node: TenantCreateInput;
};

export type DocumentTenantDeleteFieldInput = {
  delete?: InputMaybe<TenantDeleteInput>;
  where?: InputMaybe<DocumentTenantConnectionWhere>;
};

export type DocumentTenantDisconnectFieldInput = {
  disconnect?: InputMaybe<TenantDisconnectInput>;
  where?: InputMaybe<DocumentTenantConnectionWhere>;
};

export type DocumentTenantFieldInput = {
  connect?: InputMaybe<DocumentTenantConnectFieldInput>;
  connectOrCreate?: InputMaybe<DocumentTenantConnectOrCreateFieldInput>;
  create?: InputMaybe<DocumentTenantCreateFieldInput>;
};

export type DocumentTenantNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentTenantNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentTenantNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentTenantNodeAggregationWhereInput>>;
  companionName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  companionName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  key_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  key_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogImage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  proLogo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentTenantRelationship = {
  __typename?: 'DocumentTenantRelationship';
  cursor: Scalars['String']['output'];
  node: Tenant;
};

export type DocumentTenantTenantAggregationSelection = {
  __typename?: 'DocumentTenantTenantAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentTenantTenantNodeAggregateSelection>;
};

export type DocumentTenantTenantNodeAggregateSelection = {
  __typename?: 'DocumentTenantTenantNodeAggregateSelection';
  companionName: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  emailBackgroundColor: StringAggregateSelection;
  emailFooterColor: StringAggregateSelection;
  emulationStatement: StringAggregateSelection;
  externalSendGridDailyEmailTemplateId: StringAggregateSelection;
  externalSendGridFromEmail: StringAggregateSelection;
  externalSendGridFromName: StringAggregateSelection;
  externalSendGridTwilioServiceSID: StringAggregateSelection;
  favicon16Url: StringAggregateSelection;
  favicon32Url: StringAggregateSelection;
  favicon48Url: StringAggregateSelection;
  favicon180Url: StringAggregateSelection;
  favicon192Url: StringAggregateSelection;
  favicon512Url: StringAggregateSelection;
  faviconIcoUrl: StringAggregateSelection;
  financialInformationUrl: StringAggregateSelection;
  gameMenuBg: StringAggregateSelection;
  gameMenuCardBg: StringAggregateSelection;
  gameMenuProgress: StringAggregateSelection;
  gameMenuTrack: StringAggregateSelection;
  generalPrompt: StringAggregateSelection;
  helpCenterUrl: StringAggregateSelection;
  id: IdAggregateSelection;
  key: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  learningEmulationStatement: StringAggregateSelection;
  logo: StringAggregateSelection;
  ltiLaunchUrl: StringAggregateSelection;
  miniLogo: StringAggregateSelection;
  newsSearchTerms: StringAggregateSelection;
  officialTranscriptsUrl: StringAggregateSelection;
  ogDescription: StringAggregateSelection;
  ogImage: StringAggregateSelection;
  ogImageHeight: StringAggregateSelection;
  ogImageWidth: StringAggregateSelection;
  ogSiteName: StringAggregateSelection;
  ogTitle: StringAggregateSelection;
  ogType: StringAggregateSelection;
  onboardingPrompt: StringAggregateSelection;
  primaryColor: StringAggregateSelection;
  proLogo: StringAggregateSelection;
  reportProblemUrl: StringAggregateSelection;
  scheduleAdvisorCallUrl: StringAggregateSelection;
  schoolResourcesUrl: StringAggregateSelection;
  stripeSecretKey: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  stripeTrialDays: IntAggregateSelection;
  submitHelpTicketLink: StringAggregateSelection;
  tenantDomain: StringAggregateSelection;
  tenantName: StringAggregateSelection;
  termsOfServiceLink: StringAggregateSelection;
  upgradeModalBody: StringAggregateSelection;
};

export type DocumentTenantUpdateConnectionInput = {
  node?: InputMaybe<TenantUpdateInput>;
};

export type DocumentTenantUpdateFieldInput = {
  connect?: InputMaybe<DocumentTenantConnectFieldInput>;
  connectOrCreate?: InputMaybe<DocumentTenantConnectOrCreateFieldInput>;
  create?: InputMaybe<DocumentTenantCreateFieldInput>;
  delete?: InputMaybe<DocumentTenantDeleteFieldInput>;
  disconnect?: InputMaybe<DocumentTenantDisconnectFieldInput>;
  update?: InputMaybe<DocumentTenantUpdateConnectionInput>;
  where?: InputMaybe<DocumentTenantConnectionWhere>;
};

export type DocumentUpdateInput = {
  adminDoc?: InputMaybe<Scalars['Boolean']['input']>;
  aiTutorSource?: InputMaybe<DocumentAiTutorSourceUpdateFieldInput>;
  assessmentSource?: InputMaybe<DocumentAssessmentSourceUpdateFieldInput>;
  assignmentSource?: InputMaybe<DocumentAssignmentSourceUpdateFieldInput>;
  courseSource?: InputMaybe<DocumentCourseSourceUpdateFieldInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  files?: InputMaybe<Array<DocumentFilesUpdateFieldInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  messageSource?: InputMaybe<DocumentMessageSourceUpdateFieldInput>;
  references?: InputMaybe<Array<DocumentReferencesUpdateFieldInput>>;
  resourceSource?: InputMaybe<DocumentResourceSourceUpdateFieldInput>;
  sourceType?: InputMaybe<DocumentSourceType>;
  status?: InputMaybe<DocumentStatus>;
  summary?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<DocumentTenantUpdateFieldInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentWhere = {
  AND?: InputMaybe<Array<DocumentWhere>>;
  NOT?: InputMaybe<DocumentWhere>;
  OR?: InputMaybe<Array<DocumentWhere>>;
  adminDoc?: InputMaybe<Scalars['Boolean']['input']>;
  aiTutorSource?: InputMaybe<AiTutorWhere>;
  aiTutorSourceAggregate?: InputMaybe<DocumentAiTutorSourceAggregateInput>;
  aiTutorSourceConnection?: InputMaybe<DocumentAiTutorSourceConnectionWhere>;
  aiTutorSourceConnection_NOT?: InputMaybe<DocumentAiTutorSourceConnectionWhere>;
  aiTutorSource_NOT?: InputMaybe<AiTutorWhere>;
  assessmentSource?: InputMaybe<AssessmentWhere>;
  assessmentSourceAggregate?: InputMaybe<DocumentAssessmentSourceAggregateInput>;
  assessmentSourceConnection?: InputMaybe<DocumentAssessmentSourceConnectionWhere>;
  assessmentSourceConnection_NOT?: InputMaybe<DocumentAssessmentSourceConnectionWhere>;
  assessmentSource_NOT?: InputMaybe<AssessmentWhere>;
  assignmentSource?: InputMaybe<AssignmentWhere>;
  assignmentSourceAggregate?: InputMaybe<DocumentAssignmentSourceAggregateInput>;
  assignmentSourceConnection?: InputMaybe<DocumentAssignmentSourceConnectionWhere>;
  assignmentSourceConnection_NOT?: InputMaybe<DocumentAssignmentSourceConnectionWhere>;
  assignmentSource_NOT?: InputMaybe<AssignmentWhere>;
  courseSource?: InputMaybe<CourseWhere>;
  courseSourceAggregate?: InputMaybe<DocumentCourseSourceAggregateInput>;
  courseSourceConnection?: InputMaybe<DocumentCourseSourceConnectionWhere>;
  courseSourceConnection_NOT?: InputMaybe<DocumentCourseSourceConnectionWhere>;
  courseSource_NOT?: InputMaybe<CourseWhere>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  filesAggregate?: InputMaybe<DocumentFilesAggregateInput>;
  /** Return Documents where all of the related DocumentFilesConnections match this filter */
  filesConnection_ALL?: InputMaybe<DocumentFilesConnectionWhere>;
  /** Return Documents where none of the related DocumentFilesConnections match this filter */
  filesConnection_NONE?: InputMaybe<DocumentFilesConnectionWhere>;
  /** Return Documents where one of the related DocumentFilesConnections match this filter */
  filesConnection_SINGLE?: InputMaybe<DocumentFilesConnectionWhere>;
  /** Return Documents where some of the related DocumentFilesConnections match this filter */
  filesConnection_SOME?: InputMaybe<DocumentFilesConnectionWhere>;
  /** Return Documents where all of the related Files match this filter */
  files_ALL?: InputMaybe<FileWhere>;
  /** Return Documents where none of the related Files match this filter */
  files_NONE?: InputMaybe<FileWhere>;
  /** Return Documents where one of the related Files match this filter */
  files_SINGLE?: InputMaybe<FileWhere>;
  /** Return Documents where some of the related Files match this filter */
  files_SOME?: InputMaybe<FileWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  last_modified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  messageSource?: InputMaybe<MessageWhere>;
  messageSourceAggregate?: InputMaybe<DocumentMessageSourceAggregateInput>;
  messageSourceConnection?: InputMaybe<DocumentMessageSourceConnectionWhere>;
  messageSourceConnection_NOT?: InputMaybe<DocumentMessageSourceConnectionWhere>;
  messageSource_NOT?: InputMaybe<MessageWhere>;
  referencesAggregate?: InputMaybe<DocumentReferencesAggregateInput>;
  /** Return Documents where all of the related DocumentReferencesConnections match this filter */
  referencesConnection_ALL?: InputMaybe<DocumentReferencesConnectionWhere>;
  /** Return Documents where none of the related DocumentReferencesConnections match this filter */
  referencesConnection_NONE?: InputMaybe<DocumentReferencesConnectionWhere>;
  /** Return Documents where one of the related DocumentReferencesConnections match this filter */
  referencesConnection_SINGLE?: InputMaybe<DocumentReferencesConnectionWhere>;
  /** Return Documents where some of the related DocumentReferencesConnections match this filter */
  referencesConnection_SOME?: InputMaybe<DocumentReferencesConnectionWhere>;
  /** Return Documents where all of the related DocumentReferences match this filter */
  references_ALL?: InputMaybe<DocumentReferenceWhere>;
  /** Return Documents where none of the related DocumentReferences match this filter */
  references_NONE?: InputMaybe<DocumentReferenceWhere>;
  /** Return Documents where one of the related DocumentReferences match this filter */
  references_SINGLE?: InputMaybe<DocumentReferenceWhere>;
  /** Return Documents where some of the related DocumentReferences match this filter */
  references_SOME?: InputMaybe<DocumentReferenceWhere>;
  resourceSource?: InputMaybe<AxioResourceWhere>;
  resourceSourceAggregate?: InputMaybe<DocumentResourceSourceAggregateInput>;
  resourceSourceConnection?: InputMaybe<DocumentResourceSourceConnectionWhere>;
  resourceSourceConnection_NOT?: InputMaybe<DocumentResourceSourceConnectionWhere>;
  resourceSource_NOT?: InputMaybe<AxioResourceWhere>;
  sourceType?: InputMaybe<DocumentSourceType>;
  sourceType_IN?: InputMaybe<Array<InputMaybe<DocumentSourceType>>>;
  status?: InputMaybe<DocumentStatus>;
  status_IN?: InputMaybe<Array<DocumentStatus>>;
  summary?: InputMaybe<Scalars['String']['input']>;
  summary_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  summary_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  summary_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  summary_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<TenantWhere>;
  tenantAggregate?: InputMaybe<DocumentTenantAggregateInput>;
  tenantConnection?: InputMaybe<DocumentTenantConnectionWhere>;
  tenantConnection_NOT?: InputMaybe<DocumentTenantConnectionWhere>;
  tenant_NOT?: InputMaybe<TenantWhere>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type DownloadLessonPlanResponse = {
  __typename?: 'DownloadLessonPlanResponse';
  data?: Maybe<Scalars['JSON']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type EditAssignmentInput = {
  activityState?: InputMaybe<ActivityState>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  enableStudentFileUpload?: InputMaybe<Scalars['Boolean']['input']>;
  files?: InputMaybe<Array<InputMaybe<FileInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  worksheetId?: InputMaybe<Scalars['ID']['input']>;
};

export type EditCourseInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  course_code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  learningStandards?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  objectives?: InputMaybe<Array<Scalars['String']['input']>>;
  targetAudience?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
};

export type EmotionalState = {
  __typename?: 'EmotionalState';
  id?: Maybe<Scalars['Int']['output']>;
  intensity?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  trigger?: Maybe<Scalars['String']['output']>;
};

/**
 * The edge properties for the following fields:
 * * User.enrolledDegrees
 * * Degree.usersEnrolledIn
 */
export type EnrolledInDegreeProperties = {
  __typename?: 'EnrolledInDegreeProperties';
  created: Scalars['DateTime']['output'];
  invitationToken?: Maybe<Scalars['String']['output']>;
  invitationTokenExpiry?: Maybe<Scalars['DateTime']['output']>;
  last_modified: Scalars['DateTime']['output'];
  pendingDegreeEnrollmentInvite?: Maybe<Scalars['Boolean']['output']>;
};

export type EnrolledInDegreePropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<EnrolledInDegreePropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<EnrolledInDegreePropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<EnrolledInDegreePropertiesAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EnrolledInDegreePropertiesCreateInput = {
  created: Scalars['DateTime']['input'];
  invitationToken?: InputMaybe<Scalars['String']['input']>;
  invitationTokenExpiry?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified: Scalars['DateTime']['input'];
  pendingDegreeEnrollmentInvite?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnrolledInDegreePropertiesSort = {
  created?: InputMaybe<SortDirection>;
  invitationToken?: InputMaybe<SortDirection>;
  invitationTokenExpiry?: InputMaybe<SortDirection>;
  last_modified?: InputMaybe<SortDirection>;
  pendingDegreeEnrollmentInvite?: InputMaybe<SortDirection>;
};

export type EnrolledInDegreePropertiesUpdateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken?: InputMaybe<Scalars['String']['input']>;
  invitationTokenExpiry?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  pendingDegreeEnrollmentInvite?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnrolledInDegreePropertiesWhere = {
  AND?: InputMaybe<Array<EnrolledInDegreePropertiesWhere>>;
  NOT?: InputMaybe<EnrolledInDegreePropertiesWhere>;
  OR?: InputMaybe<Array<EnrolledInDegreePropertiesWhere>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken?: InputMaybe<Scalars['String']['input']>;
  invitationTokenExpiry?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  invitationTokenExpiry_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  invitationToken_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  invitationToken_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  invitationToken_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  last_modified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pendingDegreeEnrollmentInvite?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * The edge properties for the following fields:
 * * User.enrolledInTopics
 * * User.enrolledCourses
 * * Topic.usersEnrolledIn
 * * Course.enrolledStudents
 */
export type EnrolledInProperties = {
  __typename?: 'EnrolledInProperties';
  created: Scalars['DateTime']['output'];
  invitationToken?: Maybe<Scalars['String']['output']>;
  invitationTokenExpiry?: Maybe<Scalars['DateTime']['output']>;
  last_modified: Scalars['DateTime']['output'];
  pendingCourseEnrollmentInvite?: Maybe<Scalars['Boolean']['output']>;
};

export type EnrolledInPropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<EnrolledInPropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<EnrolledInPropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<EnrolledInPropertiesAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EnrolledInPropertiesCreateInput = {
  created: Scalars['DateTime']['input'];
  invitationToken?: InputMaybe<Scalars['String']['input']>;
  invitationTokenExpiry?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified: Scalars['DateTime']['input'];
  pendingCourseEnrollmentInvite?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnrolledInPropertiesSort = {
  created?: InputMaybe<SortDirection>;
  invitationToken?: InputMaybe<SortDirection>;
  invitationTokenExpiry?: InputMaybe<SortDirection>;
  last_modified?: InputMaybe<SortDirection>;
  pendingCourseEnrollmentInvite?: InputMaybe<SortDirection>;
};

export type EnrolledInPropertiesUpdateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken?: InputMaybe<Scalars['String']['input']>;
  invitationTokenExpiry?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  pendingCourseEnrollmentInvite?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnrolledInPropertiesWhere = {
  AND?: InputMaybe<Array<EnrolledInPropertiesWhere>>;
  NOT?: InputMaybe<EnrolledInPropertiesWhere>;
  OR?: InputMaybe<Array<EnrolledInPropertiesWhere>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken?: InputMaybe<Scalars['String']['input']>;
  invitationTokenExpiry?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  invitationTokenExpiry_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  invitationToken_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  invitationToken_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  invitationToken_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  last_modified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pendingCourseEnrollmentInvite?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnrollmentLink = {
  __typename?: 'EnrollmentLink';
  course: Course;
  courseAggregate?: Maybe<EnrollmentLinkCourseCourseAggregationSelection>;
  courseConnection: EnrollmentLinkCourseConnection;
  createdAt: Scalars['DateTime']['output'];
  currentEnrollments: Scalars['Int']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastModified: Scalars['DateTime']['output'];
  maxEnrollments?: Maybe<Scalars['Int']['output']>;
  token: Scalars['String']['output'];
};


export type EnrollmentLinkCourseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CourseOptions>;
  where?: InputMaybe<CourseWhere>;
};


export type EnrollmentLinkCourseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CourseWhere>;
};


export type EnrollmentLinkCourseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EnrollmentLinkCourseConnectionSort>>;
  where?: InputMaybe<EnrollmentLinkCourseConnectionWhere>;
};

export type EnrollmentLinkConnectInput = {
  course?: InputMaybe<EnrollmentLinkCourseConnectFieldInput>;
};

export type EnrollmentLinkConnectOrCreateWhere = {
  node: EnrollmentLinkUniqueWhere;
};

export type EnrollmentLinkConnectWhere = {
  node: EnrollmentLinkWhere;
};

export type EnrollmentLinkCourseAggregateInput = {
  AND?: InputMaybe<Array<EnrollmentLinkCourseAggregateInput>>;
  NOT?: InputMaybe<EnrollmentLinkCourseAggregateInput>;
  OR?: InputMaybe<Array<EnrollmentLinkCourseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EnrollmentLinkCourseNodeAggregationWhereInput>;
};

export type EnrollmentLinkCourseConnectFieldInput = {
  connect?: InputMaybe<CourseConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CourseConnectWhere>;
};

export type EnrollmentLinkCourseConnectOrCreateFieldInput = {
  onCreate: EnrollmentLinkCourseConnectOrCreateFieldInputOnCreate;
  where: CourseConnectOrCreateWhere;
};

export type EnrollmentLinkCourseConnectOrCreateFieldInputOnCreate = {
  node: CourseOnCreateInput;
};

export type EnrollmentLinkCourseConnection = {
  __typename?: 'EnrollmentLinkCourseConnection';
  edges: Array<EnrollmentLinkCourseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EnrollmentLinkCourseConnectionSort = {
  node?: InputMaybe<CourseSort>;
};

export type EnrollmentLinkCourseConnectionWhere = {
  AND?: InputMaybe<Array<EnrollmentLinkCourseConnectionWhere>>;
  NOT?: InputMaybe<EnrollmentLinkCourseConnectionWhere>;
  OR?: InputMaybe<Array<EnrollmentLinkCourseConnectionWhere>>;
  node?: InputMaybe<CourseWhere>;
};

export type EnrollmentLinkCourseCourseAggregationSelection = {
  __typename?: 'EnrollmentLinkCourseCourseAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<EnrollmentLinkCourseCourseNodeAggregateSelection>;
};

export type EnrollmentLinkCourseCourseNodeAggregateSelection = {
  __typename?: 'EnrollmentLinkCourseCourseNodeAggregateSelection';
  account_id: FloatAggregateSelection;
  calendar_ics: StringAggregateSelection;
  cost: FloatAggregateSelection;
  courseId: StringAggregateSelection;
  course_code: StringAggregateSelection;
  course_id: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  default_view: StringAggregateSelection;
  description: StringAggregateSelection;
  dueDateEndDate: DateTimeAggregateSelection;
  dueDateStartDate: DateTimeAggregateSelection;
  endDate: DateTimeAggregateSelection;
  end_at: StringAggregateSelection;
  enrollment_term_id: FloatAggregateSelection;
  grading_standard_id: FloatAggregateSelection;
  id: IdAggregateSelection;
  integration_id: StringAggregateSelection;
  label: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  learningStandards: StringAggregateSelection;
  lengthInWeeks: FloatAggregateSelection;
  license: StringAggregateSelection;
  lti_id: StringAggregateSelection;
  name: StringAggregateSelection;
  original_name: StringAggregateSelection;
  root_account_id: FloatAggregateSelection;
  sis_course_id: StringAggregateSelection;
  sis_import_id: FloatAggregateSelection;
  startDate: DateTimeAggregateSelection;
  start_at: StringAggregateSelection;
  state: StringAggregateSelection;
  storage_quota_mb: FloatAggregateSelection;
  stripePriceId: StringAggregateSelection;
  stripeProductId: StringAggregateSelection;
  targetAudience: StringAggregateSelection;
  thumbnail: StringAggregateSelection;
  time_zone: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  uuid: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export type EnrollmentLinkCourseCreateFieldInput = {
  node: CourseCreateInput;
};

export type EnrollmentLinkCourseDeleteFieldInput = {
  delete?: InputMaybe<CourseDeleteInput>;
  where?: InputMaybe<EnrollmentLinkCourseConnectionWhere>;
};

export type EnrollmentLinkCourseDisconnectFieldInput = {
  disconnect?: InputMaybe<CourseDisconnectInput>;
  where?: InputMaybe<EnrollmentLinkCourseConnectionWhere>;
};

export type EnrollmentLinkCourseFieldInput = {
  connect?: InputMaybe<EnrollmentLinkCourseConnectFieldInput>;
  connectOrCreate?: InputMaybe<EnrollmentLinkCourseConnectOrCreateFieldInput>;
  create?: InputMaybe<EnrollmentLinkCourseCreateFieldInput>;
};

export type EnrollmentLinkCourseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EnrollmentLinkCourseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EnrollmentLinkCourseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EnrollmentLinkCourseNodeAggregationWhereInput>>;
  account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  cost_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDateEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  enrollment_term_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  label_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningStandards_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthInWeeks_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  root_account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_import_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  startDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  storage_quota_mb_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type EnrollmentLinkCourseRelationship = {
  __typename?: 'EnrollmentLinkCourseRelationship';
  cursor: Scalars['String']['output'];
  node: Course;
};

export type EnrollmentLinkCourseUpdateConnectionInput = {
  node?: InputMaybe<CourseUpdateInput>;
};

export type EnrollmentLinkCourseUpdateFieldInput = {
  connect?: InputMaybe<EnrollmentLinkCourseConnectFieldInput>;
  connectOrCreate?: InputMaybe<EnrollmentLinkCourseConnectOrCreateFieldInput>;
  create?: InputMaybe<EnrollmentLinkCourseCreateFieldInput>;
  delete?: InputMaybe<EnrollmentLinkCourseDeleteFieldInput>;
  disconnect?: InputMaybe<EnrollmentLinkCourseDisconnectFieldInput>;
  update?: InputMaybe<EnrollmentLinkCourseUpdateConnectionInput>;
  where?: InputMaybe<EnrollmentLinkCourseConnectionWhere>;
};

export type EnrollmentLinkCreateInput = {
  course?: InputMaybe<EnrollmentLinkCourseFieldInput>;
  createdAt: Scalars['DateTime']['input'];
  currentEnrollments: Scalars['Int']['input'];
  expiresAt: Scalars['DateTime']['input'];
  lastModified: Scalars['DateTime']['input'];
  maxEnrollments?: InputMaybe<Scalars['Int']['input']>;
  token: Scalars['String']['input'];
};

export type EnrollmentLinkData = {
  __typename?: 'EnrollmentLinkData';
  createdAt: Scalars['DateTime']['output'];
  currentEnrollments: Scalars['Int']['output'];
  enrollmentLink: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastModified: Scalars['DateTime']['output'];
  maxEnrollments: Scalars['Int']['output'];
};

export type EnrollmentLinkDeleteInput = {
  course?: InputMaybe<EnrollmentLinkCourseDeleteFieldInput>;
};

export type EnrollmentLinkDisconnectInput = {
  course?: InputMaybe<EnrollmentLinkCourseDisconnectFieldInput>;
};

export type EnrollmentLinkMutationDataExtendedResult = {
  __typename?: 'EnrollmentLinkMutationDataExtendedResult';
  courseId: Scalars['ID']['output'];
  courseName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastModified: Scalars['DateTime']['output'];
};

export type EnrollmentLinkMutationDataResult = {
  __typename?: 'EnrollmentLinkMutationDataResult';
  id: Scalars['ID']['output'];
  lastModified: Scalars['DateTime']['output'];
};

export type EnrollmentLinkMutationResult = {
  __typename?: 'EnrollmentLinkMutationResult';
  count: Scalars['Int']['output'];
  data?: Maybe<EnrollmentLinkMutationDataResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type EnrollmentLinkMutationResultExtended = {
  __typename?: 'EnrollmentLinkMutationResultExtended';
  count: Scalars['Int']['output'];
  data?: Maybe<EnrollmentLinkMutationDataExtendedResult>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type EnrollmentLinkOnCreateInput = {
  createdAt: Scalars['DateTime']['input'];
  currentEnrollments: Scalars['Int']['input'];
  expiresAt: Scalars['DateTime']['input'];
  lastModified: Scalars['DateTime']['input'];
  maxEnrollments?: InputMaybe<Scalars['Int']['input']>;
  token: Scalars['String']['input'];
};

export type EnrollmentLinkOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more EnrollmentLinkSort objects to sort EnrollmentLinks by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<EnrollmentLinkSort>>;
};

export type EnrollmentLinkServiceResult = {
  __typename?: 'EnrollmentLinkServiceResult';
  count: Scalars['Int']['output'];
  data?: Maybe<EnrollmentLinkData>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Fields to sort EnrollmentLinks by. The order in which sorts are applied is not guaranteed when specifying many fields in one EnrollmentLinkSort object. */
export type EnrollmentLinkSort = {
  createdAt?: InputMaybe<SortDirection>;
  currentEnrollments?: InputMaybe<SortDirection>;
  expiresAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastModified?: InputMaybe<SortDirection>;
  maxEnrollments?: InputMaybe<SortDirection>;
  token?: InputMaybe<SortDirection>;
};

export type EnrollmentLinkUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EnrollmentLinkUpdateInput = {
  course?: InputMaybe<EnrollmentLinkCourseUpdateFieldInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  currentEnrollments?: InputMaybe<Scalars['Int']['input']>;
  currentEnrollments_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  currentEnrollments_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  maxEnrollments?: InputMaybe<Scalars['Int']['input']>;
  maxEnrollments_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  maxEnrollments_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type EnrollmentLinkWhere = {
  AND?: InputMaybe<Array<EnrollmentLinkWhere>>;
  NOT?: InputMaybe<EnrollmentLinkWhere>;
  OR?: InputMaybe<Array<EnrollmentLinkWhere>>;
  course?: InputMaybe<CourseWhere>;
  courseAggregate?: InputMaybe<EnrollmentLinkCourseAggregateInput>;
  courseConnection?: InputMaybe<EnrollmentLinkCourseConnectionWhere>;
  courseConnection_NOT?: InputMaybe<EnrollmentLinkCourseConnectionWhere>;
  course_NOT?: InputMaybe<CourseWhere>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currentEnrollments?: InputMaybe<Scalars['Int']['input']>;
  currentEnrollments_GT?: InputMaybe<Scalars['Int']['input']>;
  currentEnrollments_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentEnrollments_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  currentEnrollments_LT?: InputMaybe<Scalars['Int']['input']>;
  currentEnrollments_LTE?: InputMaybe<Scalars['Int']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  expiresAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lastModified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  maxEnrollments?: InputMaybe<Scalars['Int']['input']>;
  maxEnrollments_GT?: InputMaybe<Scalars['Int']['input']>;
  maxEnrollments_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxEnrollments_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  maxEnrollments_LT?: InputMaybe<Scalars['Int']['input']>;
  maxEnrollments_LTE?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  token_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  token_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  token_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  token_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type ExportCsvResponse = {
  __typename?: 'ExportCsvResponse';
  csvData?: Maybe<Scalars['String']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  jobId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ExportDownloadResponse = {
  __typename?: 'ExportDownloadResponse';
  count: Scalars['Int']['output'];
  data?: Maybe<File>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ExternalAnnouncement = {
  __typename?: 'ExternalAnnouncement';
  bodyHtml?: Maybe<Scalars['String']['output']>;
  bodyText?: Maybe<Scalars['String']['output']>;
  course: ExternalCourse;
  courseAggregate?: Maybe<ExternalAnnouncementExternalCourseCourseAggregationSelection>;
  courseConnection: ExternalAnnouncementCourseConnection;
  files: Array<ExternalFile>;
  filesAggregate?: Maybe<ExternalAnnouncementExternalFileFilesAggregationSelection>;
  filesConnection: ExternalAnnouncementFilesConnection;
  id: Scalars['ID']['output'];
  lmsSource: LmsSource;
  nudgesAboutThis: Array<Nudge>;
  nudgesAboutThisAggregate?: Maybe<ExternalAnnouncementNudgeNudgesAboutThisAggregationSelection>;
  nudgesAboutThisConnection: ExternalAnnouncementNudgesAboutThisConnection;
  pinned?: Maybe<Scalars['Boolean']['output']>;
  postedAt?: Maybe<Scalars['DateTime']['output']>;
  providerAnnouncementId: Scalars['String']['output'];
  providerApiUrl?: Maybe<Scalars['String']['output']>;
  providerCourseId: Scalars['String']['output'];
  providerKey: Scalars['String']['output'];
  sourceMeta?: Maybe<Scalars['JSON']['output']>;
  sourcePayload?: Maybe<Scalars['JSON']['output']>;
  sourceUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  syncedAt: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
  visibility: ExternalAnnouncementVisibility;
};


export type ExternalAnnouncementCourseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalCourseOptions>;
  where?: InputMaybe<ExternalCourseWhere>;
};


export type ExternalAnnouncementCourseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalCourseWhere>;
};


export type ExternalAnnouncementCourseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalAnnouncementCourseConnectionSort>>;
  where?: InputMaybe<ExternalAnnouncementCourseConnectionWhere>;
};


export type ExternalAnnouncementFilesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalFileOptions>;
  where?: InputMaybe<ExternalFileWhere>;
};


export type ExternalAnnouncementFilesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalFileWhere>;
};


export type ExternalAnnouncementFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalAnnouncementFilesConnectionSort>>;
  where?: InputMaybe<ExternalAnnouncementFilesConnectionWhere>;
};


export type ExternalAnnouncementNudgesAboutThisArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<NudgeOptions>;
  where?: InputMaybe<NudgeWhere>;
};


export type ExternalAnnouncementNudgesAboutThisAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NudgeWhere>;
};


export type ExternalAnnouncementNudgesAboutThisConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalAnnouncementNudgesAboutThisConnectionSort>>;
  where?: InputMaybe<ExternalAnnouncementNudgesAboutThisConnectionWhere>;
};

export type ExternalAnnouncementConnectInput = {
  course?: InputMaybe<ExternalAnnouncementCourseConnectFieldInput>;
  files?: InputMaybe<Array<ExternalAnnouncementFilesConnectFieldInput>>;
  nudgesAboutThis?: InputMaybe<Array<ExternalAnnouncementNudgesAboutThisConnectFieldInput>>;
};

export type ExternalAnnouncementConnectOrCreateWhere = {
  node: ExternalAnnouncementUniqueWhere;
};

export type ExternalAnnouncementConnectWhere = {
  node: ExternalAnnouncementWhere;
};

export type ExternalAnnouncementCourseAggregateInput = {
  AND?: InputMaybe<Array<ExternalAnnouncementCourseAggregateInput>>;
  NOT?: InputMaybe<ExternalAnnouncementCourseAggregateInput>;
  OR?: InputMaybe<Array<ExternalAnnouncementCourseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalAnnouncementCourseNodeAggregationWhereInput>;
};

export type ExternalAnnouncementCourseConnectFieldInput = {
  connect?: InputMaybe<ExternalCourseConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalCourseConnectWhere>;
};

export type ExternalAnnouncementCourseConnectOrCreateFieldInput = {
  onCreate: ExternalAnnouncementCourseConnectOrCreateFieldInputOnCreate;
  where: ExternalCourseConnectOrCreateWhere;
};

export type ExternalAnnouncementCourseConnectOrCreateFieldInputOnCreate = {
  node: ExternalCourseOnCreateInput;
};

export type ExternalAnnouncementCourseConnection = {
  __typename?: 'ExternalAnnouncementCourseConnection';
  edges: Array<ExternalAnnouncementCourseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalAnnouncementCourseConnectionSort = {
  node?: InputMaybe<ExternalCourseSort>;
};

export type ExternalAnnouncementCourseConnectionWhere = {
  AND?: InputMaybe<Array<ExternalAnnouncementCourseConnectionWhere>>;
  NOT?: InputMaybe<ExternalAnnouncementCourseConnectionWhere>;
  OR?: InputMaybe<Array<ExternalAnnouncementCourseConnectionWhere>>;
  node?: InputMaybe<ExternalCourseWhere>;
};

export type ExternalAnnouncementCourseCreateFieldInput = {
  node: ExternalCourseCreateInput;
};

export type ExternalAnnouncementCourseDeleteFieldInput = {
  delete?: InputMaybe<ExternalCourseDeleteInput>;
  where?: InputMaybe<ExternalAnnouncementCourseConnectionWhere>;
};

export type ExternalAnnouncementCourseDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalCourseDisconnectInput>;
  where?: InputMaybe<ExternalAnnouncementCourseConnectionWhere>;
};

export type ExternalAnnouncementCourseFieldInput = {
  connect?: InputMaybe<ExternalAnnouncementCourseConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalAnnouncementCourseConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalAnnouncementCourseCreateFieldInput>;
};

export type ExternalAnnouncementCourseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalAnnouncementCourseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalAnnouncementCourseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalAnnouncementCourseNodeAggregationWhereInput>>;
  courseCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  courseCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  courseCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  courseCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  courseCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  endDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalAnnouncementCourseRelationship = {
  __typename?: 'ExternalAnnouncementCourseRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalCourse;
};

export type ExternalAnnouncementCourseUpdateConnectionInput = {
  node?: InputMaybe<ExternalCourseUpdateInput>;
};

export type ExternalAnnouncementCourseUpdateFieldInput = {
  connect?: InputMaybe<ExternalAnnouncementCourseConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalAnnouncementCourseConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalAnnouncementCourseCreateFieldInput>;
  delete?: InputMaybe<ExternalAnnouncementCourseDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalAnnouncementCourseDisconnectFieldInput>;
  update?: InputMaybe<ExternalAnnouncementCourseUpdateConnectionInput>;
  where?: InputMaybe<ExternalAnnouncementCourseConnectionWhere>;
};

export type ExternalAnnouncementCreateInput = {
  bodyHtml?: InputMaybe<Scalars['String']['input']>;
  bodyText?: InputMaybe<Scalars['String']['input']>;
  course?: InputMaybe<ExternalAnnouncementCourseFieldInput>;
  files?: InputMaybe<ExternalAnnouncementFilesFieldInput>;
  lmsSource: LmsSource;
  nudgesAboutThis?: InputMaybe<ExternalAnnouncementNudgesAboutThisFieldInput>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  postedAt?: InputMaybe<Scalars['DateTime']['input']>;
  providerAnnouncementId: Scalars['String']['input'];
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerCourseId: Scalars['String']['input'];
  providerKey: Scalars['String']['input'];
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  visibility: ExternalAnnouncementVisibility;
};

export type ExternalAnnouncementDeleteInput = {
  course?: InputMaybe<ExternalAnnouncementCourseDeleteFieldInput>;
  files?: InputMaybe<Array<ExternalAnnouncementFilesDeleteFieldInput>>;
  nudgesAboutThis?: InputMaybe<Array<ExternalAnnouncementNudgesAboutThisDeleteFieldInput>>;
};

export type ExternalAnnouncementDisconnectInput = {
  course?: InputMaybe<ExternalAnnouncementCourseDisconnectFieldInput>;
  files?: InputMaybe<Array<ExternalAnnouncementFilesDisconnectFieldInput>>;
  nudgesAboutThis?: InputMaybe<Array<ExternalAnnouncementNudgesAboutThisDisconnectFieldInput>>;
};

export type ExternalAnnouncementExternalCourseCourseAggregationSelection = {
  __typename?: 'ExternalAnnouncementExternalCourseCourseAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalAnnouncementExternalCourseCourseNodeAggregateSelection>;
};

export type ExternalAnnouncementExternalCourseCourseNodeAggregateSelection = {
  __typename?: 'ExternalAnnouncementExternalCourseCourseNodeAggregateSelection';
  courseCode: StringAggregateSelection;
  descriptionHtml: StringAggregateSelection;
  descriptionText: StringAggregateSelection;
  endDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  name: StringAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  startDate: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalAnnouncementExternalFileFilesAggregationSelection = {
  __typename?: 'ExternalAnnouncementExternalFileFilesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalAnnouncementExternalFileFilesNodeAggregateSelection>;
};

export type ExternalAnnouncementExternalFileFilesNodeAggregateSelection = {
  __typename?: 'ExternalAnnouncementExternalFileFilesNodeAggregateSelection';
  attachedToId: StringAggregateSelection;
  displayName: StringAggregateSelection;
  downloadUrl: StringAggregateSelection;
  fileName: StringAggregateSelection;
  fileSize: IntAggregateSelection;
  id: IdAggregateSelection;
  mimeType: StringAggregateSelection;
  modifiedAt: DateTimeAggregateSelection;
  previewUrl: StringAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerFileId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  uploadedAt: DateTimeAggregateSelection;
  uploadedBy: StringAggregateSelection;
};

export type ExternalAnnouncementFilesAggregateInput = {
  AND?: InputMaybe<Array<ExternalAnnouncementFilesAggregateInput>>;
  NOT?: InputMaybe<ExternalAnnouncementFilesAggregateInput>;
  OR?: InputMaybe<Array<ExternalAnnouncementFilesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalAnnouncementFilesNodeAggregationWhereInput>;
};

export type ExternalAnnouncementFilesConnectFieldInput = {
  connect?: InputMaybe<Array<ExternalFileConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalFileConnectWhere>;
};

export type ExternalAnnouncementFilesConnectOrCreateFieldInput = {
  onCreate: ExternalAnnouncementFilesConnectOrCreateFieldInputOnCreate;
  where: ExternalFileConnectOrCreateWhere;
};

export type ExternalAnnouncementFilesConnectOrCreateFieldInputOnCreate = {
  node: ExternalFileOnCreateInput;
};

export type ExternalAnnouncementFilesConnection = {
  __typename?: 'ExternalAnnouncementFilesConnection';
  edges: Array<ExternalAnnouncementFilesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalAnnouncementFilesConnectionSort = {
  node?: InputMaybe<ExternalFileSort>;
};

export type ExternalAnnouncementFilesConnectionWhere = {
  AND?: InputMaybe<Array<ExternalAnnouncementFilesConnectionWhere>>;
  NOT?: InputMaybe<ExternalAnnouncementFilesConnectionWhere>;
  OR?: InputMaybe<Array<ExternalAnnouncementFilesConnectionWhere>>;
  node?: InputMaybe<ExternalFileWhere>;
};

export type ExternalAnnouncementFilesCreateFieldInput = {
  node: ExternalFileCreateInput;
};

export type ExternalAnnouncementFilesDeleteFieldInput = {
  delete?: InputMaybe<ExternalFileDeleteInput>;
  where?: InputMaybe<ExternalAnnouncementFilesConnectionWhere>;
};

export type ExternalAnnouncementFilesDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalFileDisconnectInput>;
  where?: InputMaybe<ExternalAnnouncementFilesConnectionWhere>;
};

export type ExternalAnnouncementFilesFieldInput = {
  connect?: InputMaybe<Array<ExternalAnnouncementFilesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalAnnouncementFilesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalAnnouncementFilesCreateFieldInput>>;
};

export type ExternalAnnouncementFilesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalAnnouncementFilesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalAnnouncementFilesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalAnnouncementFilesNodeAggregationWhereInput>>;
  attachedToId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  attachedToId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  attachedToId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  attachedToId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  attachedToId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  attachedToId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  downloadUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  downloadUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  downloadUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  downloadUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  downloadUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileSize_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileSize_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  fileSize_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileSize_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  fileSize_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileSize_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileSize_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileSize_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileSize_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  mimeType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modifiedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  previewUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  previewUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  previewUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  previewUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  previewUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  previewUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerFileId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerFileId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerFileId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerFileId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerFileId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uploadedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uploadedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uploadedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uploadedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uploadedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalAnnouncementFilesRelationship = {
  __typename?: 'ExternalAnnouncementFilesRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalFile;
};

export type ExternalAnnouncementFilesUpdateConnectionInput = {
  node?: InputMaybe<ExternalFileUpdateInput>;
};

export type ExternalAnnouncementFilesUpdateFieldInput = {
  connect?: InputMaybe<Array<ExternalAnnouncementFilesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalAnnouncementFilesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalAnnouncementFilesCreateFieldInput>>;
  delete?: InputMaybe<Array<ExternalAnnouncementFilesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ExternalAnnouncementFilesDisconnectFieldInput>>;
  update?: InputMaybe<ExternalAnnouncementFilesUpdateConnectionInput>;
  where?: InputMaybe<ExternalAnnouncementFilesConnectionWhere>;
};

export type ExternalAnnouncementNudgeNudgesAboutThisAggregationSelection = {
  __typename?: 'ExternalAnnouncementNudgeNudgesAboutThisAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalAnnouncementNudgeNudgesAboutThisNodeAggregateSelection>;
};

export type ExternalAnnouncementNudgeNudgesAboutThisNodeAggregateSelection = {
  __typename?: 'ExternalAnnouncementNudgeNudgesAboutThisNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  idempotencyKey: StringAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  priorityScore: FloatAggregateSelection;
  scheduledFor: DateTimeAggregateSelection;
  snoozedUntil: DateTimeAggregateSelection;
  taskCompletedAt: DateTimeAggregateSelection;
};

export type ExternalAnnouncementNudgesAboutThisAggregateInput = {
  AND?: InputMaybe<Array<ExternalAnnouncementNudgesAboutThisAggregateInput>>;
  NOT?: InputMaybe<ExternalAnnouncementNudgesAboutThisAggregateInput>;
  OR?: InputMaybe<Array<ExternalAnnouncementNudgesAboutThisAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalAnnouncementNudgesAboutThisNodeAggregationWhereInput>;
};

export type ExternalAnnouncementNudgesAboutThisConnectFieldInput = {
  connect?: InputMaybe<Array<NudgeConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<NudgeConnectWhere>;
};

export type ExternalAnnouncementNudgesAboutThisConnectOrCreateFieldInput = {
  onCreate: ExternalAnnouncementNudgesAboutThisConnectOrCreateFieldInputOnCreate;
  where: NudgeConnectOrCreateWhere;
};

export type ExternalAnnouncementNudgesAboutThisConnectOrCreateFieldInputOnCreate = {
  node: NudgeOnCreateInput;
};

export type ExternalAnnouncementNudgesAboutThisConnection = {
  __typename?: 'ExternalAnnouncementNudgesAboutThisConnection';
  edges: Array<ExternalAnnouncementNudgesAboutThisRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalAnnouncementNudgesAboutThisConnectionSort = {
  node?: InputMaybe<NudgeSort>;
};

export type ExternalAnnouncementNudgesAboutThisConnectionWhere = {
  AND?: InputMaybe<Array<ExternalAnnouncementNudgesAboutThisConnectionWhere>>;
  NOT?: InputMaybe<ExternalAnnouncementNudgesAboutThisConnectionWhere>;
  OR?: InputMaybe<Array<ExternalAnnouncementNudgesAboutThisConnectionWhere>>;
  node?: InputMaybe<NudgeWhere>;
};

export type ExternalAnnouncementNudgesAboutThisCreateFieldInput = {
  node: NudgeCreateInput;
};

export type ExternalAnnouncementNudgesAboutThisDeleteFieldInput = {
  delete?: InputMaybe<NudgeDeleteInput>;
  where?: InputMaybe<ExternalAnnouncementNudgesAboutThisConnectionWhere>;
};

export type ExternalAnnouncementNudgesAboutThisDisconnectFieldInput = {
  disconnect?: InputMaybe<NudgeDisconnectInput>;
  where?: InputMaybe<ExternalAnnouncementNudgesAboutThisConnectionWhere>;
};

export type ExternalAnnouncementNudgesAboutThisFieldInput = {
  connect?: InputMaybe<Array<ExternalAnnouncementNudgesAboutThisConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalAnnouncementNudgesAboutThisConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalAnnouncementNudgesAboutThisCreateFieldInput>>;
};

export type ExternalAnnouncementNudgesAboutThisNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalAnnouncementNudgesAboutThisNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalAnnouncementNudgesAboutThisNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalAnnouncementNudgesAboutThisNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  idempotencyKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  priorityScore_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  scheduledFor_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ExternalAnnouncementNudgesAboutThisRelationship = {
  __typename?: 'ExternalAnnouncementNudgesAboutThisRelationship';
  cursor: Scalars['String']['output'];
  node: Nudge;
};

export type ExternalAnnouncementNudgesAboutThisUpdateConnectionInput = {
  node?: InputMaybe<NudgeUpdateInput>;
};

export type ExternalAnnouncementNudgesAboutThisUpdateFieldInput = {
  connect?: InputMaybe<Array<ExternalAnnouncementNudgesAboutThisConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalAnnouncementNudgesAboutThisConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalAnnouncementNudgesAboutThisCreateFieldInput>>;
  delete?: InputMaybe<Array<ExternalAnnouncementNudgesAboutThisDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ExternalAnnouncementNudgesAboutThisDisconnectFieldInput>>;
  update?: InputMaybe<ExternalAnnouncementNudgesAboutThisUpdateConnectionInput>;
  where?: InputMaybe<ExternalAnnouncementNudgesAboutThisConnectionWhere>;
};

export type ExternalAnnouncementOnCreateInput = {
  bodyHtml?: InputMaybe<Scalars['String']['input']>;
  bodyText?: InputMaybe<Scalars['String']['input']>;
  lmsSource: LmsSource;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  postedAt?: InputMaybe<Scalars['DateTime']['input']>;
  providerAnnouncementId: Scalars['String']['input'];
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerCourseId: Scalars['String']['input'];
  providerKey: Scalars['String']['input'];
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  visibility: ExternalAnnouncementVisibility;
};

export type ExternalAnnouncementOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ExternalAnnouncementSort objects to sort ExternalAnnouncements by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ExternalAnnouncementSort>>;
};

/** Fields to sort ExternalAnnouncements by. The order in which sorts are applied is not guaranteed when specifying many fields in one ExternalAnnouncementSort object. */
export type ExternalAnnouncementSort = {
  bodyHtml?: InputMaybe<SortDirection>;
  bodyText?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lmsSource?: InputMaybe<SortDirection>;
  pinned?: InputMaybe<SortDirection>;
  postedAt?: InputMaybe<SortDirection>;
  providerAnnouncementId?: InputMaybe<SortDirection>;
  providerApiUrl?: InputMaybe<SortDirection>;
  providerCourseId?: InputMaybe<SortDirection>;
  providerKey?: InputMaybe<SortDirection>;
  sourceMeta?: InputMaybe<SortDirection>;
  sourcePayload?: InputMaybe<SortDirection>;
  sourceUpdatedAt?: InputMaybe<SortDirection>;
  syncedAt?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  url?: InputMaybe<SortDirection>;
  visibility?: InputMaybe<SortDirection>;
};

export type ExternalAnnouncementUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalAnnouncementUpdateInput = {
  bodyHtml?: InputMaybe<Scalars['String']['input']>;
  bodyText?: InputMaybe<Scalars['String']['input']>;
  course?: InputMaybe<ExternalAnnouncementCourseUpdateFieldInput>;
  files?: InputMaybe<Array<ExternalAnnouncementFilesUpdateFieldInput>>;
  lmsSource?: InputMaybe<LmsSource>;
  nudgesAboutThis?: InputMaybe<Array<ExternalAnnouncementNudgesAboutThisUpdateFieldInput>>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  postedAt?: InputMaybe<Scalars['DateTime']['input']>;
  providerAnnouncementId?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerCourseId?: InputMaybe<Scalars['String']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<ExternalAnnouncementVisibility>;
};

export enum ExternalAnnouncementVisibility {
  Hidden = 'HIDDEN',
  Published = 'PUBLISHED',
  Unknown = 'UNKNOWN',
  Unpublished = 'UNPUBLISHED'
}

export type ExternalAnnouncementWhere = {
  AND?: InputMaybe<Array<ExternalAnnouncementWhere>>;
  NOT?: InputMaybe<ExternalAnnouncementWhere>;
  OR?: InputMaybe<Array<ExternalAnnouncementWhere>>;
  bodyHtml?: InputMaybe<Scalars['String']['input']>;
  bodyHtml_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  bodyHtml_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  bodyHtml_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyHtml_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  bodyText?: InputMaybe<Scalars['String']['input']>;
  bodyText_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  bodyText_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  bodyText_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyText_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  course?: InputMaybe<ExternalCourseWhere>;
  courseAggregate?: InputMaybe<ExternalAnnouncementCourseAggregateInput>;
  courseConnection?: InputMaybe<ExternalAnnouncementCourseConnectionWhere>;
  courseConnection_NOT?: InputMaybe<ExternalAnnouncementCourseConnectionWhere>;
  course_NOT?: InputMaybe<ExternalCourseWhere>;
  filesAggregate?: InputMaybe<ExternalAnnouncementFilesAggregateInput>;
  /** Return ExternalAnnouncements where all of the related ExternalAnnouncementFilesConnections match this filter */
  filesConnection_ALL?: InputMaybe<ExternalAnnouncementFilesConnectionWhere>;
  /** Return ExternalAnnouncements where none of the related ExternalAnnouncementFilesConnections match this filter */
  filesConnection_NONE?: InputMaybe<ExternalAnnouncementFilesConnectionWhere>;
  /** Return ExternalAnnouncements where one of the related ExternalAnnouncementFilesConnections match this filter */
  filesConnection_SINGLE?: InputMaybe<ExternalAnnouncementFilesConnectionWhere>;
  /** Return ExternalAnnouncements where some of the related ExternalAnnouncementFilesConnections match this filter */
  filesConnection_SOME?: InputMaybe<ExternalAnnouncementFilesConnectionWhere>;
  /** Return ExternalAnnouncements where all of the related ExternalFiles match this filter */
  files_ALL?: InputMaybe<ExternalFileWhere>;
  /** Return ExternalAnnouncements where none of the related ExternalFiles match this filter */
  files_NONE?: InputMaybe<ExternalFileWhere>;
  /** Return ExternalAnnouncements where one of the related ExternalFiles match this filter */
  files_SINGLE?: InputMaybe<ExternalFileWhere>;
  /** Return ExternalAnnouncements where some of the related ExternalFiles match this filter */
  files_SOME?: InputMaybe<ExternalFileWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lmsSource?: InputMaybe<LmsSource>;
  lmsSource_IN?: InputMaybe<Array<LmsSource>>;
  nudgesAboutThisAggregate?: InputMaybe<ExternalAnnouncementNudgesAboutThisAggregateInput>;
  /** Return ExternalAnnouncements where all of the related ExternalAnnouncementNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_ALL?: InputMaybe<ExternalAnnouncementNudgesAboutThisConnectionWhere>;
  /** Return ExternalAnnouncements where none of the related ExternalAnnouncementNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_NONE?: InputMaybe<ExternalAnnouncementNudgesAboutThisConnectionWhere>;
  /** Return ExternalAnnouncements where one of the related ExternalAnnouncementNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_SINGLE?: InputMaybe<ExternalAnnouncementNudgesAboutThisConnectionWhere>;
  /** Return ExternalAnnouncements where some of the related ExternalAnnouncementNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_SOME?: InputMaybe<ExternalAnnouncementNudgesAboutThisConnectionWhere>;
  /** Return ExternalAnnouncements where all of the related Nudges match this filter */
  nudgesAboutThis_ALL?: InputMaybe<NudgeWhere>;
  /** Return ExternalAnnouncements where none of the related Nudges match this filter */
  nudgesAboutThis_NONE?: InputMaybe<NudgeWhere>;
  /** Return ExternalAnnouncements where one of the related Nudges match this filter */
  nudgesAboutThis_SINGLE?: InputMaybe<NudgeWhere>;
  /** Return ExternalAnnouncements where some of the related Nudges match this filter */
  nudgesAboutThis_SOME?: InputMaybe<NudgeWhere>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  postedAt?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  postedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  providerAnnouncementId?: InputMaybe<Scalars['String']['input']>;
  providerAnnouncementId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerAnnouncementId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerAnnouncementId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerAnnouncementId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerApiUrl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerCourseId?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerCourseId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
  providerKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerKey_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourceMeta_IN?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload_IN?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  sourceUpdatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  syncedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<ExternalAnnouncementVisibility>;
  visibility_IN?: InputMaybe<Array<ExternalAnnouncementVisibility>>;
};

export type ExternalAssignment = {
  __typename?: 'ExternalAssignment';
  assignees: Array<User>;
  assigneesAggregate?: Maybe<ExternalAssignmentUserAssigneesAggregationSelection>;
  assigneesConnection: ExternalAssignmentAssigneesConnection;
  availableFrom?: Maybe<Scalars['DateTime']['output']>;
  availableUntil?: Maybe<Scalars['DateTime']['output']>;
  course: ExternalCourse;
  courseAggregate?: Maybe<ExternalAssignmentExternalCourseCourseAggregationSelection>;
  courseConnection: ExternalAssignmentCourseConnection;
  descriptionHtml?: Maybe<Scalars['String']['output']>;
  descriptionText?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  files: Array<ExternalFile>;
  filesAggregate?: Maybe<ExternalAssignmentExternalFileFilesAggregationSelection>;
  filesConnection: ExternalAssignmentFilesConnection;
  gradingType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lmsSource: LmsSource;
  nudgesAboutThis: Array<Nudge>;
  nudgesAboutThisAggregate?: Maybe<ExternalAssignmentNudgeNudgesAboutThisAggregationSelection>;
  nudgesAboutThisConnection: ExternalAssignmentNudgesAboutThisConnection;
  pointsPossible?: Maybe<Scalars['Float']['output']>;
  providerApiUrl?: Maybe<Scalars['String']['output']>;
  providerAssignmentId: Scalars['String']['output'];
  providerCourseId: Scalars['String']['output'];
  providerKey: Scalars['String']['output'];
  sourceMeta?: Maybe<Scalars['JSON']['output']>;
  sourcePayload?: Maybe<Scalars['JSON']['output']>;
  sourceUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  submissionKinds: Array<ExternalAssignmentSubmissionKind>;
  submissions: Array<ExternalSubmission>;
  submissionsAggregate?: Maybe<ExternalAssignmentExternalSubmissionSubmissionsAggregationSelection>;
  submissionsConnection: ExternalAssignmentSubmissionsConnection;
  syncedAt: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
  visibility: ExternalAssignmentVisibility;
};


export type ExternalAssignmentAssigneesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type ExternalAssignmentAssigneesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type ExternalAssignmentAssigneesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalAssignmentAssigneesConnectionSort>>;
  where?: InputMaybe<ExternalAssignmentAssigneesConnectionWhere>;
};


export type ExternalAssignmentCourseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalCourseOptions>;
  where?: InputMaybe<ExternalCourseWhere>;
};


export type ExternalAssignmentCourseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalCourseWhere>;
};


export type ExternalAssignmentCourseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalAssignmentCourseConnectionSort>>;
  where?: InputMaybe<ExternalAssignmentCourseConnectionWhere>;
};


export type ExternalAssignmentFilesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalFileOptions>;
  where?: InputMaybe<ExternalFileWhere>;
};


export type ExternalAssignmentFilesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalFileWhere>;
};


export type ExternalAssignmentFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalAssignmentFilesConnectionSort>>;
  where?: InputMaybe<ExternalAssignmentFilesConnectionWhere>;
};


export type ExternalAssignmentNudgesAboutThisArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<NudgeOptions>;
  where?: InputMaybe<NudgeWhere>;
};


export type ExternalAssignmentNudgesAboutThisAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NudgeWhere>;
};


export type ExternalAssignmentNudgesAboutThisConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalAssignmentNudgesAboutThisConnectionSort>>;
  where?: InputMaybe<ExternalAssignmentNudgesAboutThisConnectionWhere>;
};


export type ExternalAssignmentSubmissionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalSubmissionOptions>;
  where?: InputMaybe<ExternalSubmissionWhere>;
};


export type ExternalAssignmentSubmissionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalSubmissionWhere>;
};


export type ExternalAssignmentSubmissionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalAssignmentSubmissionsConnectionSort>>;
  where?: InputMaybe<ExternalAssignmentSubmissionsConnectionWhere>;
};

export type ExternalAssignmentAssigneesAggregateInput = {
  AND?: InputMaybe<Array<ExternalAssignmentAssigneesAggregateInput>>;
  NOT?: InputMaybe<ExternalAssignmentAssigneesAggregateInput>;
  OR?: InputMaybe<Array<ExternalAssignmentAssigneesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<UserLmsContentPropertiesAggregationWhereInput>;
  node?: InputMaybe<ExternalAssignmentAssigneesNodeAggregationWhereInput>;
};

export type ExternalAssignmentAssigneesConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  edge: UserLmsContentPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type ExternalAssignmentAssigneesConnectOrCreateFieldInput = {
  onCreate: ExternalAssignmentAssigneesConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type ExternalAssignmentAssigneesConnectOrCreateFieldInputOnCreate = {
  edge: UserLmsContentPropertiesCreateInput;
  node: UserOnCreateInput;
};

export type ExternalAssignmentAssigneesConnection = {
  __typename?: 'ExternalAssignmentAssigneesConnection';
  edges: Array<ExternalAssignmentAssigneesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalAssignmentAssigneesConnectionSort = {
  edge?: InputMaybe<UserLmsContentPropertiesSort>;
  node?: InputMaybe<UserSort>;
};

export type ExternalAssignmentAssigneesConnectionWhere = {
  AND?: InputMaybe<Array<ExternalAssignmentAssigneesConnectionWhere>>;
  NOT?: InputMaybe<ExternalAssignmentAssigneesConnectionWhere>;
  OR?: InputMaybe<Array<ExternalAssignmentAssigneesConnectionWhere>>;
  edge?: InputMaybe<UserLmsContentPropertiesWhere>;
  node?: InputMaybe<UserWhere>;
};

export type ExternalAssignmentAssigneesCreateFieldInput = {
  edge: UserLmsContentPropertiesCreateInput;
  node: UserCreateInput;
};

export type ExternalAssignmentAssigneesDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<ExternalAssignmentAssigneesConnectionWhere>;
};

export type ExternalAssignmentAssigneesDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<ExternalAssignmentAssigneesConnectionWhere>;
};

export type ExternalAssignmentAssigneesFieldInput = {
  connect?: InputMaybe<Array<ExternalAssignmentAssigneesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalAssignmentAssigneesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalAssignmentAssigneesCreateFieldInput>>;
};

export type ExternalAssignmentAssigneesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalAssignmentAssigneesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalAssignmentAssigneesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalAssignmentAssigneesNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalAssignmentAssigneesRelationship = {
  __typename?: 'ExternalAssignmentAssigneesRelationship';
  cursor: Scalars['String']['output'];
  node: User;
  properties: UserLmsContentProperties;
};

export type ExternalAssignmentAssigneesUpdateConnectionInput = {
  edge?: InputMaybe<UserLmsContentPropertiesUpdateInput>;
  node?: InputMaybe<UserUpdateInput>;
};

export type ExternalAssignmentAssigneesUpdateFieldInput = {
  connect?: InputMaybe<Array<ExternalAssignmentAssigneesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalAssignmentAssigneesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalAssignmentAssigneesCreateFieldInput>>;
  delete?: InputMaybe<Array<ExternalAssignmentAssigneesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ExternalAssignmentAssigneesDisconnectFieldInput>>;
  update?: InputMaybe<ExternalAssignmentAssigneesUpdateConnectionInput>;
  where?: InputMaybe<ExternalAssignmentAssigneesConnectionWhere>;
};

export type ExternalAssignmentConnectInput = {
  assignees?: InputMaybe<Array<ExternalAssignmentAssigneesConnectFieldInput>>;
  course?: InputMaybe<ExternalAssignmentCourseConnectFieldInput>;
  files?: InputMaybe<Array<ExternalAssignmentFilesConnectFieldInput>>;
  nudgesAboutThis?: InputMaybe<Array<ExternalAssignmentNudgesAboutThisConnectFieldInput>>;
  submissions?: InputMaybe<Array<ExternalAssignmentSubmissionsConnectFieldInput>>;
};

export type ExternalAssignmentConnectOrCreateWhere = {
  node: ExternalAssignmentUniqueWhere;
};

export type ExternalAssignmentConnectWhere = {
  node: ExternalAssignmentWhere;
};

export type ExternalAssignmentCourseAggregateInput = {
  AND?: InputMaybe<Array<ExternalAssignmentCourseAggregateInput>>;
  NOT?: InputMaybe<ExternalAssignmentCourseAggregateInput>;
  OR?: InputMaybe<Array<ExternalAssignmentCourseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalAssignmentCourseNodeAggregationWhereInput>;
};

export type ExternalAssignmentCourseConnectFieldInput = {
  connect?: InputMaybe<ExternalCourseConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalCourseConnectWhere>;
};

export type ExternalAssignmentCourseConnectOrCreateFieldInput = {
  onCreate: ExternalAssignmentCourseConnectOrCreateFieldInputOnCreate;
  where: ExternalCourseConnectOrCreateWhere;
};

export type ExternalAssignmentCourseConnectOrCreateFieldInputOnCreate = {
  node: ExternalCourseOnCreateInput;
};

export type ExternalAssignmentCourseConnection = {
  __typename?: 'ExternalAssignmentCourseConnection';
  edges: Array<ExternalAssignmentCourseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalAssignmentCourseConnectionSort = {
  node?: InputMaybe<ExternalCourseSort>;
};

export type ExternalAssignmentCourseConnectionWhere = {
  AND?: InputMaybe<Array<ExternalAssignmentCourseConnectionWhere>>;
  NOT?: InputMaybe<ExternalAssignmentCourseConnectionWhere>;
  OR?: InputMaybe<Array<ExternalAssignmentCourseConnectionWhere>>;
  node?: InputMaybe<ExternalCourseWhere>;
};

export type ExternalAssignmentCourseCreateFieldInput = {
  node: ExternalCourseCreateInput;
};

export type ExternalAssignmentCourseDeleteFieldInput = {
  delete?: InputMaybe<ExternalCourseDeleteInput>;
  where?: InputMaybe<ExternalAssignmentCourseConnectionWhere>;
};

export type ExternalAssignmentCourseDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalCourseDisconnectInput>;
  where?: InputMaybe<ExternalAssignmentCourseConnectionWhere>;
};

export type ExternalAssignmentCourseFieldInput = {
  connect?: InputMaybe<ExternalAssignmentCourseConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalAssignmentCourseConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalAssignmentCourseCreateFieldInput>;
};

export type ExternalAssignmentCourseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalAssignmentCourseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalAssignmentCourseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalAssignmentCourseNodeAggregationWhereInput>>;
  courseCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  courseCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  courseCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  courseCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  courseCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  endDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalAssignmentCourseRelationship = {
  __typename?: 'ExternalAssignmentCourseRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalCourse;
};

export type ExternalAssignmentCourseUpdateConnectionInput = {
  node?: InputMaybe<ExternalCourseUpdateInput>;
};

export type ExternalAssignmentCourseUpdateFieldInput = {
  connect?: InputMaybe<ExternalAssignmentCourseConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalAssignmentCourseConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalAssignmentCourseCreateFieldInput>;
  delete?: InputMaybe<ExternalAssignmentCourseDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalAssignmentCourseDisconnectFieldInput>;
  update?: InputMaybe<ExternalAssignmentCourseUpdateConnectionInput>;
  where?: InputMaybe<ExternalAssignmentCourseConnectionWhere>;
};

export type ExternalAssignmentCreateInput = {
  assignees?: InputMaybe<ExternalAssignmentAssigneesFieldInput>;
  availableFrom?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil?: InputMaybe<Scalars['DateTime']['input']>;
  course?: InputMaybe<ExternalAssignmentCourseFieldInput>;
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  descriptionText?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  files?: InputMaybe<ExternalAssignmentFilesFieldInput>;
  gradingType?: InputMaybe<Scalars['String']['input']>;
  lmsSource: LmsSource;
  nudgesAboutThis?: InputMaybe<ExternalAssignmentNudgesAboutThisFieldInput>;
  pointsPossible?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerAssignmentId: Scalars['String']['input'];
  providerCourseId: Scalars['String']['input'];
  providerKey: Scalars['String']['input'];
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  submissionKinds: Array<ExternalAssignmentSubmissionKind>;
  submissions?: InputMaybe<ExternalAssignmentSubmissionsFieldInput>;
  syncedAt: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  visibility: ExternalAssignmentVisibility;
};

export type ExternalAssignmentDeleteInput = {
  assignees?: InputMaybe<Array<ExternalAssignmentAssigneesDeleteFieldInput>>;
  course?: InputMaybe<ExternalAssignmentCourseDeleteFieldInput>;
  files?: InputMaybe<Array<ExternalAssignmentFilesDeleteFieldInput>>;
  nudgesAboutThis?: InputMaybe<Array<ExternalAssignmentNudgesAboutThisDeleteFieldInput>>;
  submissions?: InputMaybe<Array<ExternalAssignmentSubmissionsDeleteFieldInput>>;
};

export type ExternalAssignmentDisconnectInput = {
  assignees?: InputMaybe<Array<ExternalAssignmentAssigneesDisconnectFieldInput>>;
  course?: InputMaybe<ExternalAssignmentCourseDisconnectFieldInput>;
  files?: InputMaybe<Array<ExternalAssignmentFilesDisconnectFieldInput>>;
  nudgesAboutThis?: InputMaybe<Array<ExternalAssignmentNudgesAboutThisDisconnectFieldInput>>;
  submissions?: InputMaybe<Array<ExternalAssignmentSubmissionsDisconnectFieldInput>>;
};

export type ExternalAssignmentExternalCourseCourseAggregationSelection = {
  __typename?: 'ExternalAssignmentExternalCourseCourseAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalAssignmentExternalCourseCourseNodeAggregateSelection>;
};

export type ExternalAssignmentExternalCourseCourseNodeAggregateSelection = {
  __typename?: 'ExternalAssignmentExternalCourseCourseNodeAggregateSelection';
  courseCode: StringAggregateSelection;
  descriptionHtml: StringAggregateSelection;
  descriptionText: StringAggregateSelection;
  endDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  name: StringAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  startDate: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalAssignmentExternalFileFilesAggregationSelection = {
  __typename?: 'ExternalAssignmentExternalFileFilesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalAssignmentExternalFileFilesNodeAggregateSelection>;
};

export type ExternalAssignmentExternalFileFilesNodeAggregateSelection = {
  __typename?: 'ExternalAssignmentExternalFileFilesNodeAggregateSelection';
  attachedToId: StringAggregateSelection;
  displayName: StringAggregateSelection;
  downloadUrl: StringAggregateSelection;
  fileName: StringAggregateSelection;
  fileSize: IntAggregateSelection;
  id: IdAggregateSelection;
  mimeType: StringAggregateSelection;
  modifiedAt: DateTimeAggregateSelection;
  previewUrl: StringAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerFileId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  uploadedAt: DateTimeAggregateSelection;
  uploadedBy: StringAggregateSelection;
};

export type ExternalAssignmentExternalSubmissionSubmissionsAggregationSelection = {
  __typename?: 'ExternalAssignmentExternalSubmissionSubmissionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalAssignmentExternalSubmissionSubmissionsNodeAggregateSelection>;
};

export type ExternalAssignmentExternalSubmissionSubmissionsNodeAggregateSelection = {
  __typename?: 'ExternalAssignmentExternalSubmissionSubmissionsNodeAggregateSelection';
  gradeText: StringAggregateSelection;
  gradedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  pointsPossible: FloatAggregateSelection;
  providerContentId: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  providerUserId: StringAggregateSelection;
  score: FloatAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  submittedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
};

export type ExternalAssignmentFilesAggregateInput = {
  AND?: InputMaybe<Array<ExternalAssignmentFilesAggregateInput>>;
  NOT?: InputMaybe<ExternalAssignmentFilesAggregateInput>;
  OR?: InputMaybe<Array<ExternalAssignmentFilesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalAssignmentFilesNodeAggregationWhereInput>;
};

export type ExternalAssignmentFilesConnectFieldInput = {
  connect?: InputMaybe<Array<ExternalFileConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalFileConnectWhere>;
};

export type ExternalAssignmentFilesConnectOrCreateFieldInput = {
  onCreate: ExternalAssignmentFilesConnectOrCreateFieldInputOnCreate;
  where: ExternalFileConnectOrCreateWhere;
};

export type ExternalAssignmentFilesConnectOrCreateFieldInputOnCreate = {
  node: ExternalFileOnCreateInput;
};

export type ExternalAssignmentFilesConnection = {
  __typename?: 'ExternalAssignmentFilesConnection';
  edges: Array<ExternalAssignmentFilesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalAssignmentFilesConnectionSort = {
  node?: InputMaybe<ExternalFileSort>;
};

export type ExternalAssignmentFilesConnectionWhere = {
  AND?: InputMaybe<Array<ExternalAssignmentFilesConnectionWhere>>;
  NOT?: InputMaybe<ExternalAssignmentFilesConnectionWhere>;
  OR?: InputMaybe<Array<ExternalAssignmentFilesConnectionWhere>>;
  node?: InputMaybe<ExternalFileWhere>;
};

export type ExternalAssignmentFilesCreateFieldInput = {
  node: ExternalFileCreateInput;
};

export type ExternalAssignmentFilesDeleteFieldInput = {
  delete?: InputMaybe<ExternalFileDeleteInput>;
  where?: InputMaybe<ExternalAssignmentFilesConnectionWhere>;
};

export type ExternalAssignmentFilesDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalFileDisconnectInput>;
  where?: InputMaybe<ExternalAssignmentFilesConnectionWhere>;
};

export type ExternalAssignmentFilesFieldInput = {
  connect?: InputMaybe<Array<ExternalAssignmentFilesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalAssignmentFilesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalAssignmentFilesCreateFieldInput>>;
};

export type ExternalAssignmentFilesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalAssignmentFilesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalAssignmentFilesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalAssignmentFilesNodeAggregationWhereInput>>;
  attachedToId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  attachedToId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  attachedToId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  attachedToId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  attachedToId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  attachedToId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  downloadUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  downloadUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  downloadUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  downloadUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  downloadUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileSize_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileSize_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  fileSize_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileSize_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  fileSize_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileSize_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileSize_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileSize_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileSize_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  mimeType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modifiedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  previewUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  previewUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  previewUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  previewUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  previewUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  previewUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerFileId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerFileId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerFileId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerFileId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerFileId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uploadedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uploadedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uploadedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uploadedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uploadedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalAssignmentFilesRelationship = {
  __typename?: 'ExternalAssignmentFilesRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalFile;
};

export type ExternalAssignmentFilesUpdateConnectionInput = {
  node?: InputMaybe<ExternalFileUpdateInput>;
};

export type ExternalAssignmentFilesUpdateFieldInput = {
  connect?: InputMaybe<Array<ExternalAssignmentFilesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalAssignmentFilesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalAssignmentFilesCreateFieldInput>>;
  delete?: InputMaybe<Array<ExternalAssignmentFilesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ExternalAssignmentFilesDisconnectFieldInput>>;
  update?: InputMaybe<ExternalAssignmentFilesUpdateConnectionInput>;
  where?: InputMaybe<ExternalAssignmentFilesConnectionWhere>;
};

export type ExternalAssignmentNudgeNudgesAboutThisAggregationSelection = {
  __typename?: 'ExternalAssignmentNudgeNudgesAboutThisAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalAssignmentNudgeNudgesAboutThisNodeAggregateSelection>;
};

export type ExternalAssignmentNudgeNudgesAboutThisNodeAggregateSelection = {
  __typename?: 'ExternalAssignmentNudgeNudgesAboutThisNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  idempotencyKey: StringAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  priorityScore: FloatAggregateSelection;
  scheduledFor: DateTimeAggregateSelection;
  snoozedUntil: DateTimeAggregateSelection;
  taskCompletedAt: DateTimeAggregateSelection;
};

export type ExternalAssignmentNudgesAboutThisAggregateInput = {
  AND?: InputMaybe<Array<ExternalAssignmentNudgesAboutThisAggregateInput>>;
  NOT?: InputMaybe<ExternalAssignmentNudgesAboutThisAggregateInput>;
  OR?: InputMaybe<Array<ExternalAssignmentNudgesAboutThisAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalAssignmentNudgesAboutThisNodeAggregationWhereInput>;
};

export type ExternalAssignmentNudgesAboutThisConnectFieldInput = {
  connect?: InputMaybe<Array<NudgeConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<NudgeConnectWhere>;
};

export type ExternalAssignmentNudgesAboutThisConnectOrCreateFieldInput = {
  onCreate: ExternalAssignmentNudgesAboutThisConnectOrCreateFieldInputOnCreate;
  where: NudgeConnectOrCreateWhere;
};

export type ExternalAssignmentNudgesAboutThisConnectOrCreateFieldInputOnCreate = {
  node: NudgeOnCreateInput;
};

export type ExternalAssignmentNudgesAboutThisConnection = {
  __typename?: 'ExternalAssignmentNudgesAboutThisConnection';
  edges: Array<ExternalAssignmentNudgesAboutThisRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalAssignmentNudgesAboutThisConnectionSort = {
  node?: InputMaybe<NudgeSort>;
};

export type ExternalAssignmentNudgesAboutThisConnectionWhere = {
  AND?: InputMaybe<Array<ExternalAssignmentNudgesAboutThisConnectionWhere>>;
  NOT?: InputMaybe<ExternalAssignmentNudgesAboutThisConnectionWhere>;
  OR?: InputMaybe<Array<ExternalAssignmentNudgesAboutThisConnectionWhere>>;
  node?: InputMaybe<NudgeWhere>;
};

export type ExternalAssignmentNudgesAboutThisCreateFieldInput = {
  node: NudgeCreateInput;
};

export type ExternalAssignmentNudgesAboutThisDeleteFieldInput = {
  delete?: InputMaybe<NudgeDeleteInput>;
  where?: InputMaybe<ExternalAssignmentNudgesAboutThisConnectionWhere>;
};

export type ExternalAssignmentNudgesAboutThisDisconnectFieldInput = {
  disconnect?: InputMaybe<NudgeDisconnectInput>;
  where?: InputMaybe<ExternalAssignmentNudgesAboutThisConnectionWhere>;
};

export type ExternalAssignmentNudgesAboutThisFieldInput = {
  connect?: InputMaybe<Array<ExternalAssignmentNudgesAboutThisConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalAssignmentNudgesAboutThisConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalAssignmentNudgesAboutThisCreateFieldInput>>;
};

export type ExternalAssignmentNudgesAboutThisNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalAssignmentNudgesAboutThisNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalAssignmentNudgesAboutThisNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalAssignmentNudgesAboutThisNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  idempotencyKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  priorityScore_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  scheduledFor_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ExternalAssignmentNudgesAboutThisRelationship = {
  __typename?: 'ExternalAssignmentNudgesAboutThisRelationship';
  cursor: Scalars['String']['output'];
  node: Nudge;
};

export type ExternalAssignmentNudgesAboutThisUpdateConnectionInput = {
  node?: InputMaybe<NudgeUpdateInput>;
};

export type ExternalAssignmentNudgesAboutThisUpdateFieldInput = {
  connect?: InputMaybe<Array<ExternalAssignmentNudgesAboutThisConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalAssignmentNudgesAboutThisConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalAssignmentNudgesAboutThisCreateFieldInput>>;
  delete?: InputMaybe<Array<ExternalAssignmentNudgesAboutThisDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ExternalAssignmentNudgesAboutThisDisconnectFieldInput>>;
  update?: InputMaybe<ExternalAssignmentNudgesAboutThisUpdateConnectionInput>;
  where?: InputMaybe<ExternalAssignmentNudgesAboutThisConnectionWhere>;
};

export type ExternalAssignmentOnCreateInput = {
  availableFrom?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil?: InputMaybe<Scalars['DateTime']['input']>;
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  descriptionText?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  gradingType?: InputMaybe<Scalars['String']['input']>;
  lmsSource: LmsSource;
  pointsPossible?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerAssignmentId: Scalars['String']['input'];
  providerCourseId: Scalars['String']['input'];
  providerKey: Scalars['String']['input'];
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  submissionKinds: Array<ExternalAssignmentSubmissionKind>;
  syncedAt: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  visibility: ExternalAssignmentVisibility;
};

export type ExternalAssignmentOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ExternalAssignmentSort objects to sort ExternalAssignments by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ExternalAssignmentSort>>;
};

/** Fields to sort ExternalAssignments by. The order in which sorts are applied is not guaranteed when specifying many fields in one ExternalAssignmentSort object. */
export type ExternalAssignmentSort = {
  availableFrom?: InputMaybe<SortDirection>;
  availableUntil?: InputMaybe<SortDirection>;
  descriptionHtml?: InputMaybe<SortDirection>;
  descriptionText?: InputMaybe<SortDirection>;
  dueDate?: InputMaybe<SortDirection>;
  gradingType?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lmsSource?: InputMaybe<SortDirection>;
  pointsPossible?: InputMaybe<SortDirection>;
  providerApiUrl?: InputMaybe<SortDirection>;
  providerAssignmentId?: InputMaybe<SortDirection>;
  providerCourseId?: InputMaybe<SortDirection>;
  providerKey?: InputMaybe<SortDirection>;
  sourceMeta?: InputMaybe<SortDirection>;
  sourcePayload?: InputMaybe<SortDirection>;
  sourceUpdatedAt?: InputMaybe<SortDirection>;
  syncedAt?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  url?: InputMaybe<SortDirection>;
  visibility?: InputMaybe<SortDirection>;
};

export enum ExternalAssignmentSubmissionKind {
  ExternalTool = 'external_tool',
  FileUpload = 'file_upload',
  LinkAttachment = 'link_attachment',
  Observed = 'observed',
  OnPaper = 'on_paper',
  Other = 'other',
  TextEntry = 'text_entry'
}

export type ExternalAssignmentSubmissionsAggregateInput = {
  AND?: InputMaybe<Array<ExternalAssignmentSubmissionsAggregateInput>>;
  NOT?: InputMaybe<ExternalAssignmentSubmissionsAggregateInput>;
  OR?: InputMaybe<Array<ExternalAssignmentSubmissionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalAssignmentSubmissionsNodeAggregationWhereInput>;
};

export type ExternalAssignmentSubmissionsConnectFieldInput = {
  connect?: InputMaybe<Array<ExternalSubmissionConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalSubmissionConnectWhere>;
};

export type ExternalAssignmentSubmissionsConnectOrCreateFieldInput = {
  onCreate: ExternalAssignmentSubmissionsConnectOrCreateFieldInputOnCreate;
  where: ExternalSubmissionConnectOrCreateWhere;
};

export type ExternalAssignmentSubmissionsConnectOrCreateFieldInputOnCreate = {
  node: ExternalSubmissionOnCreateInput;
};

export type ExternalAssignmentSubmissionsConnection = {
  __typename?: 'ExternalAssignmentSubmissionsConnection';
  edges: Array<ExternalAssignmentSubmissionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalAssignmentSubmissionsConnectionSort = {
  node?: InputMaybe<ExternalSubmissionSort>;
};

export type ExternalAssignmentSubmissionsConnectionWhere = {
  AND?: InputMaybe<Array<ExternalAssignmentSubmissionsConnectionWhere>>;
  NOT?: InputMaybe<ExternalAssignmentSubmissionsConnectionWhere>;
  OR?: InputMaybe<Array<ExternalAssignmentSubmissionsConnectionWhere>>;
  node?: InputMaybe<ExternalSubmissionWhere>;
};

export type ExternalAssignmentSubmissionsCreateFieldInput = {
  node: ExternalSubmissionCreateInput;
};

export type ExternalAssignmentSubmissionsDeleteFieldInput = {
  delete?: InputMaybe<ExternalSubmissionDeleteInput>;
  where?: InputMaybe<ExternalAssignmentSubmissionsConnectionWhere>;
};

export type ExternalAssignmentSubmissionsDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalSubmissionDisconnectInput>;
  where?: InputMaybe<ExternalAssignmentSubmissionsConnectionWhere>;
};

export type ExternalAssignmentSubmissionsFieldInput = {
  connect?: InputMaybe<Array<ExternalAssignmentSubmissionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalAssignmentSubmissionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalAssignmentSubmissionsCreateFieldInput>>;
};

export type ExternalAssignmentSubmissionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalAssignmentSubmissionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalAssignmentSubmissionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalAssignmentSubmissionsNodeAggregationWhereInput>>;
  gradeText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gradeText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gradeText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gradeText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gradeText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gradeText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gradeText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gradeText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gradeText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gradeText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gradeText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gradeText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gradeText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gradeText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gradeText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gradedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pointsPossible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerContentId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerContentId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerContentId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerContentId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerContentId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerContentId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  score_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  score_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  score_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  score_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  score_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  score_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  score_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  score_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  score_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  score_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  score_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  score_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  score_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  score_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  score_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  score_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  score_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  score_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  score_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  score_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ExternalAssignmentSubmissionsRelationship = {
  __typename?: 'ExternalAssignmentSubmissionsRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalSubmission;
};

export type ExternalAssignmentSubmissionsUpdateConnectionInput = {
  node?: InputMaybe<ExternalSubmissionUpdateInput>;
};

export type ExternalAssignmentSubmissionsUpdateFieldInput = {
  connect?: InputMaybe<Array<ExternalAssignmentSubmissionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalAssignmentSubmissionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalAssignmentSubmissionsCreateFieldInput>>;
  delete?: InputMaybe<Array<ExternalAssignmentSubmissionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ExternalAssignmentSubmissionsDisconnectFieldInput>>;
  update?: InputMaybe<ExternalAssignmentSubmissionsUpdateConnectionInput>;
  where?: InputMaybe<ExternalAssignmentSubmissionsConnectionWhere>;
};

export type ExternalAssignmentUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalAssignmentUpdateInput = {
  assignees?: InputMaybe<Array<ExternalAssignmentAssigneesUpdateFieldInput>>;
  availableFrom?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil?: InputMaybe<Scalars['DateTime']['input']>;
  course?: InputMaybe<ExternalAssignmentCourseUpdateFieldInput>;
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  descriptionText?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  files?: InputMaybe<Array<ExternalAssignmentFilesUpdateFieldInput>>;
  gradingType?: InputMaybe<Scalars['String']['input']>;
  lmsSource?: InputMaybe<LmsSource>;
  nudgesAboutThis?: InputMaybe<Array<ExternalAssignmentNudgesAboutThisUpdateFieldInput>>;
  pointsPossible?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_ADD?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerAssignmentId?: InputMaybe<Scalars['String']['input']>;
  providerCourseId?: InputMaybe<Scalars['String']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  submissionKinds?: InputMaybe<Array<ExternalAssignmentSubmissionKind>>;
  submissions?: InputMaybe<Array<ExternalAssignmentSubmissionsUpdateFieldInput>>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<ExternalAssignmentVisibility>;
};

export type ExternalAssignmentUserAssigneesAggregationSelection = {
  __typename?: 'ExternalAssignmentUserAssigneesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<ExternalAssignmentUserAssigneesEdgeAggregateSelection>;
  node?: Maybe<ExternalAssignmentUserAssigneesNodeAggregateSelection>;
};

export type ExternalAssignmentUserAssigneesEdgeAggregateSelection = {
  __typename?: 'ExternalAssignmentUserAssigneesEdgeAggregateSelection';
  syncedAt: DateTimeAggregateSelection;
};

export type ExternalAssignmentUserAssigneesNodeAggregateSelection = {
  __typename?: 'ExternalAssignmentUserAssigneesNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export enum ExternalAssignmentVisibility {
  Hidden = 'HIDDEN',
  Published = 'PUBLISHED',
  Unknown = 'UNKNOWN',
  Unpublished = 'UNPUBLISHED'
}

export type ExternalAssignmentWhere = {
  AND?: InputMaybe<Array<ExternalAssignmentWhere>>;
  NOT?: InputMaybe<ExternalAssignmentWhere>;
  OR?: InputMaybe<Array<ExternalAssignmentWhere>>;
  assigneesAggregate?: InputMaybe<ExternalAssignmentAssigneesAggregateInput>;
  /** Return ExternalAssignments where all of the related ExternalAssignmentAssigneesConnections match this filter */
  assigneesConnection_ALL?: InputMaybe<ExternalAssignmentAssigneesConnectionWhere>;
  /** Return ExternalAssignments where none of the related ExternalAssignmentAssigneesConnections match this filter */
  assigneesConnection_NONE?: InputMaybe<ExternalAssignmentAssigneesConnectionWhere>;
  /** Return ExternalAssignments where one of the related ExternalAssignmentAssigneesConnections match this filter */
  assigneesConnection_SINGLE?: InputMaybe<ExternalAssignmentAssigneesConnectionWhere>;
  /** Return ExternalAssignments where some of the related ExternalAssignmentAssigneesConnections match this filter */
  assigneesConnection_SOME?: InputMaybe<ExternalAssignmentAssigneesConnectionWhere>;
  /** Return ExternalAssignments where all of the related Users match this filter */
  assignees_ALL?: InputMaybe<UserWhere>;
  /** Return ExternalAssignments where none of the related Users match this filter */
  assignees_NONE?: InputMaybe<UserWhere>;
  /** Return ExternalAssignments where one of the related Users match this filter */
  assignees_SINGLE?: InputMaybe<UserWhere>;
  /** Return ExternalAssignments where some of the related Users match this filter */
  assignees_SOME?: InputMaybe<UserWhere>;
  availableFrom?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  availableFrom_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  availableUntil_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  course?: InputMaybe<ExternalCourseWhere>;
  courseAggregate?: InputMaybe<ExternalAssignmentCourseAggregateInput>;
  courseConnection?: InputMaybe<ExternalAssignmentCourseConnectionWhere>;
  courseConnection_NOT?: InputMaybe<ExternalAssignmentCourseConnectionWhere>;
  course_NOT?: InputMaybe<ExternalCourseWhere>;
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  descriptionHtml_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  descriptionHtml_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  descriptionHtml_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descriptionHtml_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  descriptionText?: InputMaybe<Scalars['String']['input']>;
  descriptionText_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  descriptionText_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  descriptionText_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descriptionText_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  dueDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  filesAggregate?: InputMaybe<ExternalAssignmentFilesAggregateInput>;
  /** Return ExternalAssignments where all of the related ExternalAssignmentFilesConnections match this filter */
  filesConnection_ALL?: InputMaybe<ExternalAssignmentFilesConnectionWhere>;
  /** Return ExternalAssignments where none of the related ExternalAssignmentFilesConnections match this filter */
  filesConnection_NONE?: InputMaybe<ExternalAssignmentFilesConnectionWhere>;
  /** Return ExternalAssignments where one of the related ExternalAssignmentFilesConnections match this filter */
  filesConnection_SINGLE?: InputMaybe<ExternalAssignmentFilesConnectionWhere>;
  /** Return ExternalAssignments where some of the related ExternalAssignmentFilesConnections match this filter */
  filesConnection_SOME?: InputMaybe<ExternalAssignmentFilesConnectionWhere>;
  /** Return ExternalAssignments where all of the related ExternalFiles match this filter */
  files_ALL?: InputMaybe<ExternalFileWhere>;
  /** Return ExternalAssignments where none of the related ExternalFiles match this filter */
  files_NONE?: InputMaybe<ExternalFileWhere>;
  /** Return ExternalAssignments where one of the related ExternalFiles match this filter */
  files_SINGLE?: InputMaybe<ExternalFileWhere>;
  /** Return ExternalAssignments where some of the related ExternalFiles match this filter */
  files_SOME?: InputMaybe<ExternalFileWhere>;
  gradingType?: InputMaybe<Scalars['String']['input']>;
  gradingType_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  gradingType_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  gradingType_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  gradingType_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lmsSource?: InputMaybe<LmsSource>;
  lmsSource_IN?: InputMaybe<Array<LmsSource>>;
  nudgesAboutThisAggregate?: InputMaybe<ExternalAssignmentNudgesAboutThisAggregateInput>;
  /** Return ExternalAssignments where all of the related ExternalAssignmentNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_ALL?: InputMaybe<ExternalAssignmentNudgesAboutThisConnectionWhere>;
  /** Return ExternalAssignments where none of the related ExternalAssignmentNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_NONE?: InputMaybe<ExternalAssignmentNudgesAboutThisConnectionWhere>;
  /** Return ExternalAssignments where one of the related ExternalAssignmentNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_SINGLE?: InputMaybe<ExternalAssignmentNudgesAboutThisConnectionWhere>;
  /** Return ExternalAssignments where some of the related ExternalAssignmentNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_SOME?: InputMaybe<ExternalAssignmentNudgesAboutThisConnectionWhere>;
  /** Return ExternalAssignments where all of the related Nudges match this filter */
  nudgesAboutThis_ALL?: InputMaybe<NudgeWhere>;
  /** Return ExternalAssignments where none of the related Nudges match this filter */
  nudgesAboutThis_NONE?: InputMaybe<NudgeWhere>;
  /** Return ExternalAssignments where one of the related Nudges match this filter */
  nudgesAboutThis_SINGLE?: InputMaybe<NudgeWhere>;
  /** Return ExternalAssignments where some of the related Nudges match this filter */
  nudgesAboutThis_SOME?: InputMaybe<NudgeWhere>;
  pointsPossible?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  pointsPossible_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerApiUrl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerAssignmentId?: InputMaybe<Scalars['String']['input']>;
  providerAssignmentId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerAssignmentId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerAssignmentId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerAssignmentId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerCourseId?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerCourseId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
  providerKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerKey_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourceMeta_IN?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload_IN?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  sourceUpdatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionKinds?: InputMaybe<Array<ExternalAssignmentSubmissionKind>>;
  submissionKinds_INCLUDES?: InputMaybe<ExternalAssignmentSubmissionKind>;
  submissionsAggregate?: InputMaybe<ExternalAssignmentSubmissionsAggregateInput>;
  /** Return ExternalAssignments where all of the related ExternalAssignmentSubmissionsConnections match this filter */
  submissionsConnection_ALL?: InputMaybe<ExternalAssignmentSubmissionsConnectionWhere>;
  /** Return ExternalAssignments where none of the related ExternalAssignmentSubmissionsConnections match this filter */
  submissionsConnection_NONE?: InputMaybe<ExternalAssignmentSubmissionsConnectionWhere>;
  /** Return ExternalAssignments where one of the related ExternalAssignmentSubmissionsConnections match this filter */
  submissionsConnection_SINGLE?: InputMaybe<ExternalAssignmentSubmissionsConnectionWhere>;
  /** Return ExternalAssignments where some of the related ExternalAssignmentSubmissionsConnections match this filter */
  submissionsConnection_SOME?: InputMaybe<ExternalAssignmentSubmissionsConnectionWhere>;
  /** Return ExternalAssignments where all of the related ExternalSubmissions match this filter */
  submissions_ALL?: InputMaybe<ExternalSubmissionWhere>;
  /** Return ExternalAssignments where none of the related ExternalSubmissions match this filter */
  submissions_NONE?: InputMaybe<ExternalSubmissionWhere>;
  /** Return ExternalAssignments where one of the related ExternalSubmissions match this filter */
  submissions_SINGLE?: InputMaybe<ExternalSubmissionWhere>;
  /** Return ExternalAssignments where some of the related ExternalSubmissions match this filter */
  submissions_SOME?: InputMaybe<ExternalSubmissionWhere>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  syncedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<ExternalAssignmentVisibility>;
  visibility_IN?: InputMaybe<Array<ExternalAssignmentVisibility>>;
};

export type ExternalCourse = {
  __typename?: 'ExternalCourse';
  announcements: Array<ExternalAnnouncement>;
  announcementsAggregate?: Maybe<ExternalCourseExternalAnnouncementAnnouncementsAggregationSelection>;
  announcementsConnection: ExternalCourseAnnouncementsConnection;
  assignments: Array<ExternalAssignment>;
  assignmentsAggregate?: Maybe<ExternalCourseExternalAssignmentAssignmentsAggregationSelection>;
  assignmentsConnection: ExternalCourseAssignmentsConnection;
  courseCode?: Maybe<Scalars['String']['output']>;
  descriptionHtml?: Maybe<Scalars['String']['output']>;
  descriptionText?: Maybe<Scalars['String']['output']>;
  discussions: Array<ExternalDiscussionBoard>;
  discussionsAggregate?: Maybe<ExternalCourseExternalDiscussionBoardDiscussionsAggregationSelection>;
  discussionsConnection: ExternalCourseDiscussionsConnection;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  gradeItems: Array<ExternalGradeItem>;
  gradeItemsAggregate?: Maybe<ExternalCourseExternalGradeItemGradeItemsAggregationSelection>;
  gradeItemsConnection: ExternalCourseGradeItemsConnection;
  id: Scalars['ID']['output'];
  lmsSource: LmsSource;
  modules: Array<ExternalModule>;
  modulesAggregate?: Maybe<ExternalCourseExternalModuleModulesAggregationSelection>;
  modulesConnection: ExternalCourseModulesConnection;
  name: Scalars['String']['output'];
  pages: Array<ExternalPage>;
  pagesAggregate?: Maybe<ExternalCourseExternalPagePagesAggregationSelection>;
  pagesConnection: ExternalCoursePagesConnection;
  providerApiUrl?: Maybe<Scalars['String']['output']>;
  providerCourseId: Scalars['String']['output'];
  providerKey: Scalars['String']['output'];
  quizzes: Array<ExternalQuiz>;
  quizzesAggregate?: Maybe<ExternalCourseExternalQuizQuizzesAggregationSelection>;
  quizzesConnection: ExternalCourseQuizzesConnection;
  school: School;
  schoolAggregate?: Maybe<ExternalCourseSchoolSchoolAggregationSelection>;
  schoolConnection: ExternalCourseSchoolConnection;
  sourceMeta?: Maybe<Scalars['JSON']['output']>;
  sourcePayload?: Maybe<Scalars['JSON']['output']>;
  sourceUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  syncedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  users: Array<User>;
  usersAggregate?: Maybe<ExternalCourseUserUsersAggregationSelection>;
  usersConnection: ExternalCourseUsersConnection;
  visibility: ExternalCourseVisibility;
};


export type ExternalCourseAnnouncementsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalAnnouncementOptions>;
  where?: InputMaybe<ExternalAnnouncementWhere>;
};


export type ExternalCourseAnnouncementsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalAnnouncementWhere>;
};


export type ExternalCourseAnnouncementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalCourseAnnouncementsConnectionSort>>;
  where?: InputMaybe<ExternalCourseAnnouncementsConnectionWhere>;
};


export type ExternalCourseAssignmentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalAssignmentOptions>;
  where?: InputMaybe<ExternalAssignmentWhere>;
};


export type ExternalCourseAssignmentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalAssignmentWhere>;
};


export type ExternalCourseAssignmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalCourseAssignmentsConnectionSort>>;
  where?: InputMaybe<ExternalCourseAssignmentsConnectionWhere>;
};


export type ExternalCourseDiscussionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalDiscussionBoardOptions>;
  where?: InputMaybe<ExternalDiscussionBoardWhere>;
};


export type ExternalCourseDiscussionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalDiscussionBoardWhere>;
};


export type ExternalCourseDiscussionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalCourseDiscussionsConnectionSort>>;
  where?: InputMaybe<ExternalCourseDiscussionsConnectionWhere>;
};


export type ExternalCourseGradeItemsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalGradeItemOptions>;
  where?: InputMaybe<ExternalGradeItemWhere>;
};


export type ExternalCourseGradeItemsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalGradeItemWhere>;
};


export type ExternalCourseGradeItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalCourseGradeItemsConnectionSort>>;
  where?: InputMaybe<ExternalCourseGradeItemsConnectionWhere>;
};


export type ExternalCourseModulesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalModuleOptions>;
  where?: InputMaybe<ExternalModuleWhere>;
};


export type ExternalCourseModulesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalModuleWhere>;
};


export type ExternalCourseModulesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalCourseModulesConnectionSort>>;
  where?: InputMaybe<ExternalCourseModulesConnectionWhere>;
};


export type ExternalCoursePagesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalPageOptions>;
  where?: InputMaybe<ExternalPageWhere>;
};


export type ExternalCoursePagesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalPageWhere>;
};


export type ExternalCoursePagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalCoursePagesConnectionSort>>;
  where?: InputMaybe<ExternalCoursePagesConnectionWhere>;
};


export type ExternalCourseQuizzesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalQuizOptions>;
  where?: InputMaybe<ExternalQuizWhere>;
};


export type ExternalCourseQuizzesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalQuizWhere>;
};


export type ExternalCourseQuizzesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalCourseQuizzesConnectionSort>>;
  where?: InputMaybe<ExternalCourseQuizzesConnectionWhere>;
};


export type ExternalCourseSchoolArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SchoolOptions>;
  where?: InputMaybe<SchoolWhere>;
};


export type ExternalCourseSchoolAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SchoolWhere>;
};


export type ExternalCourseSchoolConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalCourseSchoolConnectionSort>>;
  where?: InputMaybe<ExternalCourseSchoolConnectionWhere>;
};


export type ExternalCourseUsersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type ExternalCourseUsersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type ExternalCourseUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalCourseUsersConnectionSort>>;
  where?: InputMaybe<ExternalCourseUsersConnectionWhere>;
};

export type ExternalCourseAnnouncementsAggregateInput = {
  AND?: InputMaybe<Array<ExternalCourseAnnouncementsAggregateInput>>;
  NOT?: InputMaybe<ExternalCourseAnnouncementsAggregateInput>;
  OR?: InputMaybe<Array<ExternalCourseAnnouncementsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalCourseAnnouncementsNodeAggregationWhereInput>;
};

export type ExternalCourseAnnouncementsConnectFieldInput = {
  connect?: InputMaybe<Array<ExternalAnnouncementConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalAnnouncementConnectWhere>;
};

export type ExternalCourseAnnouncementsConnectOrCreateFieldInput = {
  onCreate: ExternalCourseAnnouncementsConnectOrCreateFieldInputOnCreate;
  where: ExternalAnnouncementConnectOrCreateWhere;
};

export type ExternalCourseAnnouncementsConnectOrCreateFieldInputOnCreate = {
  node: ExternalAnnouncementOnCreateInput;
};

export type ExternalCourseAnnouncementsConnection = {
  __typename?: 'ExternalCourseAnnouncementsConnection';
  edges: Array<ExternalCourseAnnouncementsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalCourseAnnouncementsConnectionSort = {
  node?: InputMaybe<ExternalAnnouncementSort>;
};

export type ExternalCourseAnnouncementsConnectionWhere = {
  AND?: InputMaybe<Array<ExternalCourseAnnouncementsConnectionWhere>>;
  NOT?: InputMaybe<ExternalCourseAnnouncementsConnectionWhere>;
  OR?: InputMaybe<Array<ExternalCourseAnnouncementsConnectionWhere>>;
  node?: InputMaybe<ExternalAnnouncementWhere>;
};

export type ExternalCourseAnnouncementsCreateFieldInput = {
  node: ExternalAnnouncementCreateInput;
};

export type ExternalCourseAnnouncementsDeleteFieldInput = {
  delete?: InputMaybe<ExternalAnnouncementDeleteInput>;
  where?: InputMaybe<ExternalCourseAnnouncementsConnectionWhere>;
};

export type ExternalCourseAnnouncementsDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalAnnouncementDisconnectInput>;
  where?: InputMaybe<ExternalCourseAnnouncementsConnectionWhere>;
};

export type ExternalCourseAnnouncementsFieldInput = {
  connect?: InputMaybe<Array<ExternalCourseAnnouncementsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalCourseAnnouncementsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalCourseAnnouncementsCreateFieldInput>>;
};

export type ExternalCourseAnnouncementsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalCourseAnnouncementsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalCourseAnnouncementsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalCourseAnnouncementsNodeAggregationWhereInput>>;
  bodyHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bodyText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  bodyText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  bodyText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  bodyText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  bodyText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  bodyText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bodyText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bodyText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bodyText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bodyText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  postedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  providerAnnouncementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerAnnouncementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerAnnouncementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerAnnouncementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerAnnouncementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerAnnouncementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalCourseAnnouncementsRelationship = {
  __typename?: 'ExternalCourseAnnouncementsRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalAnnouncement;
};

export type ExternalCourseAnnouncementsUpdateConnectionInput = {
  node?: InputMaybe<ExternalAnnouncementUpdateInput>;
};

export type ExternalCourseAnnouncementsUpdateFieldInput = {
  connect?: InputMaybe<Array<ExternalCourseAnnouncementsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalCourseAnnouncementsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalCourseAnnouncementsCreateFieldInput>>;
  delete?: InputMaybe<Array<ExternalCourseAnnouncementsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ExternalCourseAnnouncementsDisconnectFieldInput>>;
  update?: InputMaybe<ExternalCourseAnnouncementsUpdateConnectionInput>;
  where?: InputMaybe<ExternalCourseAnnouncementsConnectionWhere>;
};

export type ExternalCourseAssignmentsAggregateInput = {
  AND?: InputMaybe<Array<ExternalCourseAssignmentsAggregateInput>>;
  NOT?: InputMaybe<ExternalCourseAssignmentsAggregateInput>;
  OR?: InputMaybe<Array<ExternalCourseAssignmentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalCourseAssignmentsNodeAggregationWhereInput>;
};

export type ExternalCourseAssignmentsConnectFieldInput = {
  connect?: InputMaybe<Array<ExternalAssignmentConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalAssignmentConnectWhere>;
};

export type ExternalCourseAssignmentsConnectOrCreateFieldInput = {
  onCreate: ExternalCourseAssignmentsConnectOrCreateFieldInputOnCreate;
  where: ExternalAssignmentConnectOrCreateWhere;
};

export type ExternalCourseAssignmentsConnectOrCreateFieldInputOnCreate = {
  node: ExternalAssignmentOnCreateInput;
};

export type ExternalCourseAssignmentsConnection = {
  __typename?: 'ExternalCourseAssignmentsConnection';
  edges: Array<ExternalCourseAssignmentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalCourseAssignmentsConnectionSort = {
  node?: InputMaybe<ExternalAssignmentSort>;
};

export type ExternalCourseAssignmentsConnectionWhere = {
  AND?: InputMaybe<Array<ExternalCourseAssignmentsConnectionWhere>>;
  NOT?: InputMaybe<ExternalCourseAssignmentsConnectionWhere>;
  OR?: InputMaybe<Array<ExternalCourseAssignmentsConnectionWhere>>;
  node?: InputMaybe<ExternalAssignmentWhere>;
};

export type ExternalCourseAssignmentsCreateFieldInput = {
  node: ExternalAssignmentCreateInput;
};

export type ExternalCourseAssignmentsDeleteFieldInput = {
  delete?: InputMaybe<ExternalAssignmentDeleteInput>;
  where?: InputMaybe<ExternalCourseAssignmentsConnectionWhere>;
};

export type ExternalCourseAssignmentsDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalAssignmentDisconnectInput>;
  where?: InputMaybe<ExternalCourseAssignmentsConnectionWhere>;
};

export type ExternalCourseAssignmentsFieldInput = {
  connect?: InputMaybe<Array<ExternalCourseAssignmentsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalCourseAssignmentsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalCourseAssignmentsCreateFieldInput>>;
};

export type ExternalCourseAssignmentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalCourseAssignmentsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalCourseAssignmentsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalCourseAssignmentsNodeAggregationWhereInput>>;
  availableFrom_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  descriptionHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradingType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gradingType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gradingType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gradingType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gradingType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gradingType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gradingType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gradingType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gradingType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gradingType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gradingType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gradingType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gradingType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gradingType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gradingType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pointsPossible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerAssignmentId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerAssignmentId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerAssignmentId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerAssignmentId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerAssignmentId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalCourseAssignmentsRelationship = {
  __typename?: 'ExternalCourseAssignmentsRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalAssignment;
};

export type ExternalCourseAssignmentsUpdateConnectionInput = {
  node?: InputMaybe<ExternalAssignmentUpdateInput>;
};

export type ExternalCourseAssignmentsUpdateFieldInput = {
  connect?: InputMaybe<Array<ExternalCourseAssignmentsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalCourseAssignmentsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalCourseAssignmentsCreateFieldInput>>;
  delete?: InputMaybe<Array<ExternalCourseAssignmentsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ExternalCourseAssignmentsDisconnectFieldInput>>;
  update?: InputMaybe<ExternalCourseAssignmentsUpdateConnectionInput>;
  where?: InputMaybe<ExternalCourseAssignmentsConnectionWhere>;
};

export type ExternalCourseConnectInput = {
  announcements?: InputMaybe<Array<ExternalCourseAnnouncementsConnectFieldInput>>;
  assignments?: InputMaybe<Array<ExternalCourseAssignmentsConnectFieldInput>>;
  discussions?: InputMaybe<Array<ExternalCourseDiscussionsConnectFieldInput>>;
  gradeItems?: InputMaybe<Array<ExternalCourseGradeItemsConnectFieldInput>>;
  modules?: InputMaybe<Array<ExternalCourseModulesConnectFieldInput>>;
  pages?: InputMaybe<Array<ExternalCoursePagesConnectFieldInput>>;
  quizzes?: InputMaybe<Array<ExternalCourseQuizzesConnectFieldInput>>;
  school?: InputMaybe<ExternalCourseSchoolConnectFieldInput>;
  users?: InputMaybe<Array<ExternalCourseUsersConnectFieldInput>>;
};

export type ExternalCourseConnectOrCreateWhere = {
  node: ExternalCourseUniqueWhere;
};

export type ExternalCourseConnectWhere = {
  node: ExternalCourseWhere;
};

export type ExternalCourseCreateInput = {
  announcements?: InputMaybe<ExternalCourseAnnouncementsFieldInput>;
  assignments?: InputMaybe<ExternalCourseAssignmentsFieldInput>;
  courseCode?: InputMaybe<Scalars['String']['input']>;
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  descriptionText?: InputMaybe<Scalars['String']['input']>;
  discussions?: InputMaybe<ExternalCourseDiscussionsFieldInput>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  gradeItems?: InputMaybe<ExternalCourseGradeItemsFieldInput>;
  lmsSource: LmsSource;
  modules?: InputMaybe<ExternalCourseModulesFieldInput>;
  name: Scalars['String']['input'];
  pages?: InputMaybe<ExternalCoursePagesFieldInput>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerCourseId: Scalars['String']['input'];
  providerKey: Scalars['String']['input'];
  quizzes?: InputMaybe<ExternalCourseQuizzesFieldInput>;
  school?: InputMaybe<ExternalCourseSchoolFieldInput>;
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt: Scalars['DateTime']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<ExternalCourseUsersFieldInput>;
  visibility: ExternalCourseVisibility;
};

export type ExternalCourseDeleteInput = {
  announcements?: InputMaybe<Array<ExternalCourseAnnouncementsDeleteFieldInput>>;
  assignments?: InputMaybe<Array<ExternalCourseAssignmentsDeleteFieldInput>>;
  discussions?: InputMaybe<Array<ExternalCourseDiscussionsDeleteFieldInput>>;
  gradeItems?: InputMaybe<Array<ExternalCourseGradeItemsDeleteFieldInput>>;
  modules?: InputMaybe<Array<ExternalCourseModulesDeleteFieldInput>>;
  pages?: InputMaybe<Array<ExternalCoursePagesDeleteFieldInput>>;
  quizzes?: InputMaybe<Array<ExternalCourseQuizzesDeleteFieldInput>>;
  school?: InputMaybe<ExternalCourseSchoolDeleteFieldInput>;
  users?: InputMaybe<Array<ExternalCourseUsersDeleteFieldInput>>;
};

export type ExternalCourseDisconnectInput = {
  announcements?: InputMaybe<Array<ExternalCourseAnnouncementsDisconnectFieldInput>>;
  assignments?: InputMaybe<Array<ExternalCourseAssignmentsDisconnectFieldInput>>;
  discussions?: InputMaybe<Array<ExternalCourseDiscussionsDisconnectFieldInput>>;
  gradeItems?: InputMaybe<Array<ExternalCourseGradeItemsDisconnectFieldInput>>;
  modules?: InputMaybe<Array<ExternalCourseModulesDisconnectFieldInput>>;
  pages?: InputMaybe<Array<ExternalCoursePagesDisconnectFieldInput>>;
  quizzes?: InputMaybe<Array<ExternalCourseQuizzesDisconnectFieldInput>>;
  school?: InputMaybe<ExternalCourseSchoolDisconnectFieldInput>;
  users?: InputMaybe<Array<ExternalCourseUsersDisconnectFieldInput>>;
};

export type ExternalCourseDiscussionsAggregateInput = {
  AND?: InputMaybe<Array<ExternalCourseDiscussionsAggregateInput>>;
  NOT?: InputMaybe<ExternalCourseDiscussionsAggregateInput>;
  OR?: InputMaybe<Array<ExternalCourseDiscussionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalCourseDiscussionsNodeAggregationWhereInput>;
};

export type ExternalCourseDiscussionsConnectFieldInput = {
  connect?: InputMaybe<Array<ExternalDiscussionBoardConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalDiscussionBoardConnectWhere>;
};

export type ExternalCourseDiscussionsConnectOrCreateFieldInput = {
  onCreate: ExternalCourseDiscussionsConnectOrCreateFieldInputOnCreate;
  where: ExternalDiscussionBoardConnectOrCreateWhere;
};

export type ExternalCourseDiscussionsConnectOrCreateFieldInputOnCreate = {
  node: ExternalDiscussionBoardOnCreateInput;
};

export type ExternalCourseDiscussionsConnection = {
  __typename?: 'ExternalCourseDiscussionsConnection';
  edges: Array<ExternalCourseDiscussionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalCourseDiscussionsConnectionSort = {
  node?: InputMaybe<ExternalDiscussionBoardSort>;
};

export type ExternalCourseDiscussionsConnectionWhere = {
  AND?: InputMaybe<Array<ExternalCourseDiscussionsConnectionWhere>>;
  NOT?: InputMaybe<ExternalCourseDiscussionsConnectionWhere>;
  OR?: InputMaybe<Array<ExternalCourseDiscussionsConnectionWhere>>;
  node?: InputMaybe<ExternalDiscussionBoardWhere>;
};

export type ExternalCourseDiscussionsCreateFieldInput = {
  node: ExternalDiscussionBoardCreateInput;
};

export type ExternalCourseDiscussionsDeleteFieldInput = {
  delete?: InputMaybe<ExternalDiscussionBoardDeleteInput>;
  where?: InputMaybe<ExternalCourseDiscussionsConnectionWhere>;
};

export type ExternalCourseDiscussionsDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalDiscussionBoardDisconnectInput>;
  where?: InputMaybe<ExternalCourseDiscussionsConnectionWhere>;
};

export type ExternalCourseDiscussionsFieldInput = {
  connect?: InputMaybe<Array<ExternalCourseDiscussionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalCourseDiscussionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalCourseDiscussionsCreateFieldInput>>;
};

export type ExternalCourseDiscussionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalCourseDiscussionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalCourseDiscussionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalCourseDiscussionsNodeAggregationWhereInput>>;
  availableFrom_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  messageHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  messageHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  messageHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  messageHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  messageHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  messageHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  messageText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  messageText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  messageText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  messageText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  messageText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  messageText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  messageText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  messageText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  messageText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  messageText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  messageText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  messageText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  messageText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  messageText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  messageText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pointsPossible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerDiscussionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerDiscussionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerDiscussionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerDiscussionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerDiscussionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalCourseDiscussionsRelationship = {
  __typename?: 'ExternalCourseDiscussionsRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalDiscussionBoard;
};

export type ExternalCourseDiscussionsUpdateConnectionInput = {
  node?: InputMaybe<ExternalDiscussionBoardUpdateInput>;
};

export type ExternalCourseDiscussionsUpdateFieldInput = {
  connect?: InputMaybe<Array<ExternalCourseDiscussionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalCourseDiscussionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalCourseDiscussionsCreateFieldInput>>;
  delete?: InputMaybe<Array<ExternalCourseDiscussionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ExternalCourseDiscussionsDisconnectFieldInput>>;
  update?: InputMaybe<ExternalCourseDiscussionsUpdateConnectionInput>;
  where?: InputMaybe<ExternalCourseDiscussionsConnectionWhere>;
};

export type ExternalCourseExternalAnnouncementAnnouncementsAggregationSelection = {
  __typename?: 'ExternalCourseExternalAnnouncementAnnouncementsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalCourseExternalAnnouncementAnnouncementsNodeAggregateSelection>;
};

export type ExternalCourseExternalAnnouncementAnnouncementsNodeAggregateSelection = {
  __typename?: 'ExternalCourseExternalAnnouncementAnnouncementsNodeAggregateSelection';
  bodyHtml: StringAggregateSelection;
  bodyText: StringAggregateSelection;
  id: IdAggregateSelection;
  postedAt: DateTimeAggregateSelection;
  providerAnnouncementId: StringAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  title: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalCourseExternalAssignmentAssignmentsAggregationSelection = {
  __typename?: 'ExternalCourseExternalAssignmentAssignmentsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalCourseExternalAssignmentAssignmentsNodeAggregateSelection>;
};

export type ExternalCourseExternalAssignmentAssignmentsNodeAggregateSelection = {
  __typename?: 'ExternalCourseExternalAssignmentAssignmentsNodeAggregateSelection';
  availableFrom: DateTimeAggregateSelection;
  availableUntil: DateTimeAggregateSelection;
  descriptionHtml: StringAggregateSelection;
  descriptionText: StringAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  gradingType: StringAggregateSelection;
  id: IdAggregateSelection;
  pointsPossible: FloatAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerAssignmentId: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  title: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalCourseExternalDiscussionBoardDiscussionsAggregationSelection = {
  __typename?: 'ExternalCourseExternalDiscussionBoardDiscussionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalCourseExternalDiscussionBoardDiscussionsNodeAggregateSelection>;
};

export type ExternalCourseExternalDiscussionBoardDiscussionsNodeAggregateSelection = {
  __typename?: 'ExternalCourseExternalDiscussionBoardDiscussionsNodeAggregateSelection';
  availableFrom: DateTimeAggregateSelection;
  availableUntil: DateTimeAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  messageHtml: StringAggregateSelection;
  messageText: StringAggregateSelection;
  pointsPossible: FloatAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerDiscussionId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  title: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalCourseExternalGradeItemGradeItemsAggregationSelection = {
  __typename?: 'ExternalCourseExternalGradeItemGradeItemsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalCourseExternalGradeItemGradeItemsNodeAggregateSelection>;
};

export type ExternalCourseExternalGradeItemGradeItemsNodeAggregateSelection = {
  __typename?: 'ExternalCourseExternalGradeItemGradeItemsNodeAggregateSelection';
  id: IdAggregateSelection;
  pointsPossible: FloatAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerGradeItemId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  title: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalCourseExternalModuleModulesAggregationSelection = {
  __typename?: 'ExternalCourseExternalModuleModulesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalCourseExternalModuleModulesNodeAggregateSelection>;
};

export type ExternalCourseExternalModuleModulesNodeAggregateSelection = {
  __typename?: 'ExternalCourseExternalModuleModulesNodeAggregateSelection';
  id: IdAggregateSelection;
  position: IntAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  providerModuleId: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  title: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalCourseExternalPagePagesAggregationSelection = {
  __typename?: 'ExternalCourseExternalPagePagesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalCourseExternalPagePagesNodeAggregateSelection>;
};

export type ExternalCourseExternalPagePagesNodeAggregateSelection = {
  __typename?: 'ExternalCourseExternalPagePagesNodeAggregateSelection';
  bodyHtml: StringAggregateSelection;
  bodyText: StringAggregateSelection;
  id: IdAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  providerPageId: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  title: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalCourseExternalQuizQuizzesAggregationSelection = {
  __typename?: 'ExternalCourseExternalQuizQuizzesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalCourseExternalQuizQuizzesNodeAggregateSelection>;
};

export type ExternalCourseExternalQuizQuizzesNodeAggregateSelection = {
  __typename?: 'ExternalCourseExternalQuizQuizzesNodeAggregateSelection';
  attemptsAllowed: IntAggregateSelection;
  availableFrom: DateTimeAggregateSelection;
  availableUntil: DateTimeAggregateSelection;
  descriptionHtml: StringAggregateSelection;
  descriptionText: StringAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  pointsPossible: FloatAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  providerQuizId: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  timeLimitMinutes: IntAggregateSelection;
  title: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalCourseGradeItemsAggregateInput = {
  AND?: InputMaybe<Array<ExternalCourseGradeItemsAggregateInput>>;
  NOT?: InputMaybe<ExternalCourseGradeItemsAggregateInput>;
  OR?: InputMaybe<Array<ExternalCourseGradeItemsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalCourseGradeItemsNodeAggregationWhereInput>;
};

export type ExternalCourseGradeItemsConnectFieldInput = {
  connect?: InputMaybe<Array<ExternalGradeItemConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalGradeItemConnectWhere>;
};

export type ExternalCourseGradeItemsConnectOrCreateFieldInput = {
  onCreate: ExternalCourseGradeItemsConnectOrCreateFieldInputOnCreate;
  where: ExternalGradeItemConnectOrCreateWhere;
};

export type ExternalCourseGradeItemsConnectOrCreateFieldInputOnCreate = {
  node: ExternalGradeItemOnCreateInput;
};

export type ExternalCourseGradeItemsConnection = {
  __typename?: 'ExternalCourseGradeItemsConnection';
  edges: Array<ExternalCourseGradeItemsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalCourseGradeItemsConnectionSort = {
  node?: InputMaybe<ExternalGradeItemSort>;
};

export type ExternalCourseGradeItemsConnectionWhere = {
  AND?: InputMaybe<Array<ExternalCourseGradeItemsConnectionWhere>>;
  NOT?: InputMaybe<ExternalCourseGradeItemsConnectionWhere>;
  OR?: InputMaybe<Array<ExternalCourseGradeItemsConnectionWhere>>;
  node?: InputMaybe<ExternalGradeItemWhere>;
};

export type ExternalCourseGradeItemsCreateFieldInput = {
  node: ExternalGradeItemCreateInput;
};

export type ExternalCourseGradeItemsDeleteFieldInput = {
  delete?: InputMaybe<ExternalGradeItemDeleteInput>;
  where?: InputMaybe<ExternalCourseGradeItemsConnectionWhere>;
};

export type ExternalCourseGradeItemsDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalGradeItemDisconnectInput>;
  where?: InputMaybe<ExternalCourseGradeItemsConnectionWhere>;
};

export type ExternalCourseGradeItemsFieldInput = {
  connect?: InputMaybe<Array<ExternalCourseGradeItemsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalCourseGradeItemsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalCourseGradeItemsCreateFieldInput>>;
};

export type ExternalCourseGradeItemsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalCourseGradeItemsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalCourseGradeItemsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalCourseGradeItemsNodeAggregationWhereInput>>;
  pointsPossible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerGradeItemId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerGradeItemId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerGradeItemId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerGradeItemId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerGradeItemId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerGradeItemId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerGradeItemId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerGradeItemId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerGradeItemId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerGradeItemId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerGradeItemId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerGradeItemId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerGradeItemId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerGradeItemId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerGradeItemId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalCourseGradeItemsRelationship = {
  __typename?: 'ExternalCourseGradeItemsRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalGradeItem;
};

export type ExternalCourseGradeItemsUpdateConnectionInput = {
  node?: InputMaybe<ExternalGradeItemUpdateInput>;
};

export type ExternalCourseGradeItemsUpdateFieldInput = {
  connect?: InputMaybe<Array<ExternalCourseGradeItemsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalCourseGradeItemsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalCourseGradeItemsCreateFieldInput>>;
  delete?: InputMaybe<Array<ExternalCourseGradeItemsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ExternalCourseGradeItemsDisconnectFieldInput>>;
  update?: InputMaybe<ExternalCourseGradeItemsUpdateConnectionInput>;
  where?: InputMaybe<ExternalCourseGradeItemsConnectionWhere>;
};

export type ExternalCourseModulesAggregateInput = {
  AND?: InputMaybe<Array<ExternalCourseModulesAggregateInput>>;
  NOT?: InputMaybe<ExternalCourseModulesAggregateInput>;
  OR?: InputMaybe<Array<ExternalCourseModulesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalCourseModulesNodeAggregationWhereInput>;
};

export type ExternalCourseModulesConnectFieldInput = {
  connect?: InputMaybe<Array<ExternalModuleConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalModuleConnectWhere>;
};

export type ExternalCourseModulesConnectOrCreateFieldInput = {
  onCreate: ExternalCourseModulesConnectOrCreateFieldInputOnCreate;
  where: ExternalModuleConnectOrCreateWhere;
};

export type ExternalCourseModulesConnectOrCreateFieldInputOnCreate = {
  node: ExternalModuleOnCreateInput;
};

export type ExternalCourseModulesConnection = {
  __typename?: 'ExternalCourseModulesConnection';
  edges: Array<ExternalCourseModulesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalCourseModulesConnectionSort = {
  node?: InputMaybe<ExternalModuleSort>;
};

export type ExternalCourseModulesConnectionWhere = {
  AND?: InputMaybe<Array<ExternalCourseModulesConnectionWhere>>;
  NOT?: InputMaybe<ExternalCourseModulesConnectionWhere>;
  OR?: InputMaybe<Array<ExternalCourseModulesConnectionWhere>>;
  node?: InputMaybe<ExternalModuleWhere>;
};

export type ExternalCourseModulesCreateFieldInput = {
  node: ExternalModuleCreateInput;
};

export type ExternalCourseModulesDeleteFieldInput = {
  delete?: InputMaybe<ExternalModuleDeleteInput>;
  where?: InputMaybe<ExternalCourseModulesConnectionWhere>;
};

export type ExternalCourseModulesDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalModuleDisconnectInput>;
  where?: InputMaybe<ExternalCourseModulesConnectionWhere>;
};

export type ExternalCourseModulesFieldInput = {
  connect?: InputMaybe<Array<ExternalCourseModulesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalCourseModulesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalCourseModulesCreateFieldInput>>;
};

export type ExternalCourseModulesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalCourseModulesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalCourseModulesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalCourseModulesNodeAggregationWhereInput>>;
  position_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerModuleId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerModuleId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerModuleId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerModuleId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerModuleId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalCourseModulesRelationship = {
  __typename?: 'ExternalCourseModulesRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalModule;
};

export type ExternalCourseModulesUpdateConnectionInput = {
  node?: InputMaybe<ExternalModuleUpdateInput>;
};

export type ExternalCourseModulesUpdateFieldInput = {
  connect?: InputMaybe<Array<ExternalCourseModulesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalCourseModulesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalCourseModulesCreateFieldInput>>;
  delete?: InputMaybe<Array<ExternalCourseModulesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ExternalCourseModulesDisconnectFieldInput>>;
  update?: InputMaybe<ExternalCourseModulesUpdateConnectionInput>;
  where?: InputMaybe<ExternalCourseModulesConnectionWhere>;
};

export type ExternalCourseOnCreateInput = {
  courseCode?: InputMaybe<Scalars['String']['input']>;
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  descriptionText?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  lmsSource: LmsSource;
  name: Scalars['String']['input'];
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerCourseId: Scalars['String']['input'];
  providerKey: Scalars['String']['input'];
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt: Scalars['DateTime']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  visibility: ExternalCourseVisibility;
};

export type ExternalCourseOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ExternalCourseSort objects to sort ExternalCourses by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ExternalCourseSort>>;
};

export type ExternalCoursePagesAggregateInput = {
  AND?: InputMaybe<Array<ExternalCoursePagesAggregateInput>>;
  NOT?: InputMaybe<ExternalCoursePagesAggregateInput>;
  OR?: InputMaybe<Array<ExternalCoursePagesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalCoursePagesNodeAggregationWhereInput>;
};

export type ExternalCoursePagesConnectFieldInput = {
  connect?: InputMaybe<Array<ExternalPageConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalPageConnectWhere>;
};

export type ExternalCoursePagesConnectOrCreateFieldInput = {
  onCreate: ExternalCoursePagesConnectOrCreateFieldInputOnCreate;
  where: ExternalPageConnectOrCreateWhere;
};

export type ExternalCoursePagesConnectOrCreateFieldInputOnCreate = {
  node: ExternalPageOnCreateInput;
};

export type ExternalCoursePagesConnection = {
  __typename?: 'ExternalCoursePagesConnection';
  edges: Array<ExternalCoursePagesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalCoursePagesConnectionSort = {
  node?: InputMaybe<ExternalPageSort>;
};

export type ExternalCoursePagesConnectionWhere = {
  AND?: InputMaybe<Array<ExternalCoursePagesConnectionWhere>>;
  NOT?: InputMaybe<ExternalCoursePagesConnectionWhere>;
  OR?: InputMaybe<Array<ExternalCoursePagesConnectionWhere>>;
  node?: InputMaybe<ExternalPageWhere>;
};

export type ExternalCoursePagesCreateFieldInput = {
  node: ExternalPageCreateInput;
};

export type ExternalCoursePagesDeleteFieldInput = {
  delete?: InputMaybe<ExternalPageDeleteInput>;
  where?: InputMaybe<ExternalCoursePagesConnectionWhere>;
};

export type ExternalCoursePagesDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalPageDisconnectInput>;
  where?: InputMaybe<ExternalCoursePagesConnectionWhere>;
};

export type ExternalCoursePagesFieldInput = {
  connect?: InputMaybe<Array<ExternalCoursePagesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalCoursePagesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalCoursePagesCreateFieldInput>>;
};

export type ExternalCoursePagesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalCoursePagesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalCoursePagesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalCoursePagesNodeAggregationWhereInput>>;
  bodyHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bodyText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  bodyText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  bodyText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  bodyText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  bodyText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  bodyText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bodyText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bodyText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bodyText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bodyText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerPageId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerPageId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerPageId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerPageId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerPageId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerPageId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerPageId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerPageId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerPageId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerPageId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerPageId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerPageId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerPageId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerPageId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerPageId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalCoursePagesRelationship = {
  __typename?: 'ExternalCoursePagesRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalPage;
};

export type ExternalCoursePagesUpdateConnectionInput = {
  node?: InputMaybe<ExternalPageUpdateInput>;
};

export type ExternalCoursePagesUpdateFieldInput = {
  connect?: InputMaybe<Array<ExternalCoursePagesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalCoursePagesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalCoursePagesCreateFieldInput>>;
  delete?: InputMaybe<Array<ExternalCoursePagesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ExternalCoursePagesDisconnectFieldInput>>;
  update?: InputMaybe<ExternalCoursePagesUpdateConnectionInput>;
  where?: InputMaybe<ExternalCoursePagesConnectionWhere>;
};

export type ExternalCourseQuizzesAggregateInput = {
  AND?: InputMaybe<Array<ExternalCourseQuizzesAggregateInput>>;
  NOT?: InputMaybe<ExternalCourseQuizzesAggregateInput>;
  OR?: InputMaybe<Array<ExternalCourseQuizzesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalCourseQuizzesNodeAggregationWhereInput>;
};

export type ExternalCourseQuizzesConnectFieldInput = {
  connect?: InputMaybe<Array<ExternalQuizConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalQuizConnectWhere>;
};

export type ExternalCourseQuizzesConnectOrCreateFieldInput = {
  onCreate: ExternalCourseQuizzesConnectOrCreateFieldInputOnCreate;
  where: ExternalQuizConnectOrCreateWhere;
};

export type ExternalCourseQuizzesConnectOrCreateFieldInputOnCreate = {
  node: ExternalQuizOnCreateInput;
};

export type ExternalCourseQuizzesConnection = {
  __typename?: 'ExternalCourseQuizzesConnection';
  edges: Array<ExternalCourseQuizzesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalCourseQuizzesConnectionSort = {
  node?: InputMaybe<ExternalQuizSort>;
};

export type ExternalCourseQuizzesConnectionWhere = {
  AND?: InputMaybe<Array<ExternalCourseQuizzesConnectionWhere>>;
  NOT?: InputMaybe<ExternalCourseQuizzesConnectionWhere>;
  OR?: InputMaybe<Array<ExternalCourseQuizzesConnectionWhere>>;
  node?: InputMaybe<ExternalQuizWhere>;
};

export type ExternalCourseQuizzesCreateFieldInput = {
  node: ExternalQuizCreateInput;
};

export type ExternalCourseQuizzesDeleteFieldInput = {
  delete?: InputMaybe<ExternalQuizDeleteInput>;
  where?: InputMaybe<ExternalCourseQuizzesConnectionWhere>;
};

export type ExternalCourseQuizzesDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalQuizDisconnectInput>;
  where?: InputMaybe<ExternalCourseQuizzesConnectionWhere>;
};

export type ExternalCourseQuizzesFieldInput = {
  connect?: InputMaybe<Array<ExternalCourseQuizzesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalCourseQuizzesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalCourseQuizzesCreateFieldInput>>;
};

export type ExternalCourseQuizzesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalCourseQuizzesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalCourseQuizzesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalCourseQuizzesNodeAggregationWhereInput>>;
  attemptsAllowed_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  attemptsAllowed_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  attemptsAllowed_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  attemptsAllowed_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  attemptsAllowed_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  attemptsAllowed_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  availableFrom_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  descriptionHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pointsPossible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerQuizId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerQuizId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerQuizId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerQuizId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerQuizId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  timeLimitMinutes_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeLimitMinutes_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeLimitMinutes_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimitMinutes_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeLimitMinutes_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimitMinutes_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalCourseQuizzesRelationship = {
  __typename?: 'ExternalCourseQuizzesRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalQuiz;
};

export type ExternalCourseQuizzesUpdateConnectionInput = {
  node?: InputMaybe<ExternalQuizUpdateInput>;
};

export type ExternalCourseQuizzesUpdateFieldInput = {
  connect?: InputMaybe<Array<ExternalCourseQuizzesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalCourseQuizzesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalCourseQuizzesCreateFieldInput>>;
  delete?: InputMaybe<Array<ExternalCourseQuizzesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ExternalCourseQuizzesDisconnectFieldInput>>;
  update?: InputMaybe<ExternalCourseQuizzesUpdateConnectionInput>;
  where?: InputMaybe<ExternalCourseQuizzesConnectionWhere>;
};

export type ExternalCourseSchoolAggregateInput = {
  AND?: InputMaybe<Array<ExternalCourseSchoolAggregateInput>>;
  NOT?: InputMaybe<ExternalCourseSchoolAggregateInput>;
  OR?: InputMaybe<Array<ExternalCourseSchoolAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalCourseSchoolNodeAggregationWhereInput>;
};

export type ExternalCourseSchoolConnectFieldInput = {
  connect?: InputMaybe<SchoolConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SchoolConnectWhere>;
};

export type ExternalCourseSchoolConnectOrCreateFieldInput = {
  onCreate: ExternalCourseSchoolConnectOrCreateFieldInputOnCreate;
  where: SchoolConnectOrCreateWhere;
};

export type ExternalCourseSchoolConnectOrCreateFieldInputOnCreate = {
  node: SchoolOnCreateInput;
};

export type ExternalCourseSchoolConnection = {
  __typename?: 'ExternalCourseSchoolConnection';
  edges: Array<ExternalCourseSchoolRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalCourseSchoolConnectionSort = {
  node?: InputMaybe<SchoolSort>;
};

export type ExternalCourseSchoolConnectionWhere = {
  AND?: InputMaybe<Array<ExternalCourseSchoolConnectionWhere>>;
  NOT?: InputMaybe<ExternalCourseSchoolConnectionWhere>;
  OR?: InputMaybe<Array<ExternalCourseSchoolConnectionWhere>>;
  node?: InputMaybe<SchoolWhere>;
};

export type ExternalCourseSchoolCreateFieldInput = {
  node: SchoolCreateInput;
};

export type ExternalCourseSchoolDeleteFieldInput = {
  delete?: InputMaybe<SchoolDeleteInput>;
  where?: InputMaybe<ExternalCourseSchoolConnectionWhere>;
};

export type ExternalCourseSchoolDisconnectFieldInput = {
  disconnect?: InputMaybe<SchoolDisconnectInput>;
  where?: InputMaybe<ExternalCourseSchoolConnectionWhere>;
};

export type ExternalCourseSchoolFieldInput = {
  connect?: InputMaybe<ExternalCourseSchoolConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalCourseSchoolConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalCourseSchoolCreateFieldInput>;
};

export type ExternalCourseSchoolNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalCourseSchoolNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalCourseSchoolNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalCourseSchoolNodeAggregationWhereInput>>;
  brightspace_api_client_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_secret_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_secret_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_secret_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_secret_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_secret_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  domain_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domain_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  provider_icon_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  provider_icon_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  provider_icon_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  provider_icon_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  provider_icon_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  provider_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  provider_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  provider_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  provider_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  provider_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  provider_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  provider_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  provider_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  provider_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  provider_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  provider_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  provider_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  provider_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  provider_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  provider_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  team_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  team_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  team_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  team_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  team_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  team_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  team_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  team_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  team_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  team_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  team_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  team_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  team_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  team_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  team_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ExternalCourseSchoolRelationship = {
  __typename?: 'ExternalCourseSchoolRelationship';
  cursor: Scalars['String']['output'];
  node: School;
};

export type ExternalCourseSchoolSchoolAggregationSelection = {
  __typename?: 'ExternalCourseSchoolSchoolAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalCourseSchoolSchoolNodeAggregateSelection>;
};

export type ExternalCourseSchoolSchoolNodeAggregateSelection = {
  __typename?: 'ExternalCourseSchoolSchoolNodeAggregateSelection';
  brightspace_api_client_id: StringAggregateSelection;
  brightspace_api_client_secret: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  domain: StringAggregateSelection;
  id: IdAggregateSelection;
  provider_icon_url: StringAggregateSelection;
  provider_name: StringAggregateSelection;
  team_name: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
};

export type ExternalCourseSchoolUpdateConnectionInput = {
  node?: InputMaybe<SchoolUpdateInput>;
};

export type ExternalCourseSchoolUpdateFieldInput = {
  connect?: InputMaybe<ExternalCourseSchoolConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalCourseSchoolConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalCourseSchoolCreateFieldInput>;
  delete?: InputMaybe<ExternalCourseSchoolDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalCourseSchoolDisconnectFieldInput>;
  update?: InputMaybe<ExternalCourseSchoolUpdateConnectionInput>;
  where?: InputMaybe<ExternalCourseSchoolConnectionWhere>;
};

/** Fields to sort ExternalCourses by. The order in which sorts are applied is not guaranteed when specifying many fields in one ExternalCourseSort object. */
export type ExternalCourseSort = {
  courseCode?: InputMaybe<SortDirection>;
  descriptionHtml?: InputMaybe<SortDirection>;
  descriptionText?: InputMaybe<SortDirection>;
  endDate?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lmsSource?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  providerApiUrl?: InputMaybe<SortDirection>;
  providerCourseId?: InputMaybe<SortDirection>;
  providerKey?: InputMaybe<SortDirection>;
  sourceMeta?: InputMaybe<SortDirection>;
  sourcePayload?: InputMaybe<SortDirection>;
  sourceUpdatedAt?: InputMaybe<SortDirection>;
  startDate?: InputMaybe<SortDirection>;
  syncedAt?: InputMaybe<SortDirection>;
  url?: InputMaybe<SortDirection>;
  visibility?: InputMaybe<SortDirection>;
};

export type ExternalCourseUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalCourseUpdateInput = {
  announcements?: InputMaybe<Array<ExternalCourseAnnouncementsUpdateFieldInput>>;
  assignments?: InputMaybe<Array<ExternalCourseAssignmentsUpdateFieldInput>>;
  courseCode?: InputMaybe<Scalars['String']['input']>;
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  descriptionText?: InputMaybe<Scalars['String']['input']>;
  discussions?: InputMaybe<Array<ExternalCourseDiscussionsUpdateFieldInput>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  gradeItems?: InputMaybe<Array<ExternalCourseGradeItemsUpdateFieldInput>>;
  lmsSource?: InputMaybe<LmsSource>;
  modules?: InputMaybe<Array<ExternalCourseModulesUpdateFieldInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  pages?: InputMaybe<Array<ExternalCoursePagesUpdateFieldInput>>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerCourseId?: InputMaybe<Scalars['String']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
  quizzes?: InputMaybe<Array<ExternalCourseQuizzesUpdateFieldInput>>;
  school?: InputMaybe<ExternalCourseSchoolUpdateFieldInput>;
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<ExternalCourseUsersUpdateFieldInput>>;
  visibility?: InputMaybe<ExternalCourseVisibility>;
};

export type ExternalCourseUserUsersAggregationSelection = {
  __typename?: 'ExternalCourseUserUsersAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<ExternalCourseUserUsersEdgeAggregateSelection>;
  node?: Maybe<ExternalCourseUserUsersNodeAggregateSelection>;
};

export type ExternalCourseUserUsersEdgeAggregateSelection = {
  __typename?: 'ExternalCourseUserUsersEdgeAggregateSelection';
  syncedAt: DateTimeAggregateSelection;
};

export type ExternalCourseUserUsersNodeAggregateSelection = {
  __typename?: 'ExternalCourseUserUsersNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type ExternalCourseUsersAggregateInput = {
  AND?: InputMaybe<Array<ExternalCourseUsersAggregateInput>>;
  NOT?: InputMaybe<ExternalCourseUsersAggregateInput>;
  OR?: InputMaybe<Array<ExternalCourseUsersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<UserLmsContentPropertiesAggregationWhereInput>;
  node?: InputMaybe<ExternalCourseUsersNodeAggregationWhereInput>;
};

export type ExternalCourseUsersConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  edge: UserLmsContentPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type ExternalCourseUsersConnectOrCreateFieldInput = {
  onCreate: ExternalCourseUsersConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type ExternalCourseUsersConnectOrCreateFieldInputOnCreate = {
  edge: UserLmsContentPropertiesCreateInput;
  node: UserOnCreateInput;
};

export type ExternalCourseUsersConnection = {
  __typename?: 'ExternalCourseUsersConnection';
  edges: Array<ExternalCourseUsersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalCourseUsersConnectionSort = {
  edge?: InputMaybe<UserLmsContentPropertiesSort>;
  node?: InputMaybe<UserSort>;
};

export type ExternalCourseUsersConnectionWhere = {
  AND?: InputMaybe<Array<ExternalCourseUsersConnectionWhere>>;
  NOT?: InputMaybe<ExternalCourseUsersConnectionWhere>;
  OR?: InputMaybe<Array<ExternalCourseUsersConnectionWhere>>;
  edge?: InputMaybe<UserLmsContentPropertiesWhere>;
  node?: InputMaybe<UserWhere>;
};

export type ExternalCourseUsersCreateFieldInput = {
  edge: UserLmsContentPropertiesCreateInput;
  node: UserCreateInput;
};

export type ExternalCourseUsersDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<ExternalCourseUsersConnectionWhere>;
};

export type ExternalCourseUsersDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<ExternalCourseUsersConnectionWhere>;
};

export type ExternalCourseUsersFieldInput = {
  connect?: InputMaybe<Array<ExternalCourseUsersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalCourseUsersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalCourseUsersCreateFieldInput>>;
};

export type ExternalCourseUsersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalCourseUsersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalCourseUsersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalCourseUsersNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalCourseUsersRelationship = {
  __typename?: 'ExternalCourseUsersRelationship';
  cursor: Scalars['String']['output'];
  node: User;
  properties: UserLmsContentProperties;
};

export type ExternalCourseUsersUpdateConnectionInput = {
  edge?: InputMaybe<UserLmsContentPropertiesUpdateInput>;
  node?: InputMaybe<UserUpdateInput>;
};

export type ExternalCourseUsersUpdateFieldInput = {
  connect?: InputMaybe<Array<ExternalCourseUsersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalCourseUsersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalCourseUsersCreateFieldInput>>;
  delete?: InputMaybe<Array<ExternalCourseUsersDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ExternalCourseUsersDisconnectFieldInput>>;
  update?: InputMaybe<ExternalCourseUsersUpdateConnectionInput>;
  where?: InputMaybe<ExternalCourseUsersConnectionWhere>;
};

export enum ExternalCourseVisibility {
  Hidden = 'HIDDEN',
  Published = 'PUBLISHED',
  Unknown = 'UNKNOWN',
  Unpublished = 'UNPUBLISHED'
}

export type ExternalCourseWhere = {
  AND?: InputMaybe<Array<ExternalCourseWhere>>;
  NOT?: InputMaybe<ExternalCourseWhere>;
  OR?: InputMaybe<Array<ExternalCourseWhere>>;
  announcementsAggregate?: InputMaybe<ExternalCourseAnnouncementsAggregateInput>;
  /** Return ExternalCourses where all of the related ExternalCourseAnnouncementsConnections match this filter */
  announcementsConnection_ALL?: InputMaybe<ExternalCourseAnnouncementsConnectionWhere>;
  /** Return ExternalCourses where none of the related ExternalCourseAnnouncementsConnections match this filter */
  announcementsConnection_NONE?: InputMaybe<ExternalCourseAnnouncementsConnectionWhere>;
  /** Return ExternalCourses where one of the related ExternalCourseAnnouncementsConnections match this filter */
  announcementsConnection_SINGLE?: InputMaybe<ExternalCourseAnnouncementsConnectionWhere>;
  /** Return ExternalCourses where some of the related ExternalCourseAnnouncementsConnections match this filter */
  announcementsConnection_SOME?: InputMaybe<ExternalCourseAnnouncementsConnectionWhere>;
  /** Return ExternalCourses where all of the related ExternalAnnouncements match this filter */
  announcements_ALL?: InputMaybe<ExternalAnnouncementWhere>;
  /** Return ExternalCourses where none of the related ExternalAnnouncements match this filter */
  announcements_NONE?: InputMaybe<ExternalAnnouncementWhere>;
  /** Return ExternalCourses where one of the related ExternalAnnouncements match this filter */
  announcements_SINGLE?: InputMaybe<ExternalAnnouncementWhere>;
  /** Return ExternalCourses where some of the related ExternalAnnouncements match this filter */
  announcements_SOME?: InputMaybe<ExternalAnnouncementWhere>;
  assignmentsAggregate?: InputMaybe<ExternalCourseAssignmentsAggregateInput>;
  /** Return ExternalCourses where all of the related ExternalCourseAssignmentsConnections match this filter */
  assignmentsConnection_ALL?: InputMaybe<ExternalCourseAssignmentsConnectionWhere>;
  /** Return ExternalCourses where none of the related ExternalCourseAssignmentsConnections match this filter */
  assignmentsConnection_NONE?: InputMaybe<ExternalCourseAssignmentsConnectionWhere>;
  /** Return ExternalCourses where one of the related ExternalCourseAssignmentsConnections match this filter */
  assignmentsConnection_SINGLE?: InputMaybe<ExternalCourseAssignmentsConnectionWhere>;
  /** Return ExternalCourses where some of the related ExternalCourseAssignmentsConnections match this filter */
  assignmentsConnection_SOME?: InputMaybe<ExternalCourseAssignmentsConnectionWhere>;
  /** Return ExternalCourses where all of the related ExternalAssignments match this filter */
  assignments_ALL?: InputMaybe<ExternalAssignmentWhere>;
  /** Return ExternalCourses where none of the related ExternalAssignments match this filter */
  assignments_NONE?: InputMaybe<ExternalAssignmentWhere>;
  /** Return ExternalCourses where one of the related ExternalAssignments match this filter */
  assignments_SINGLE?: InputMaybe<ExternalAssignmentWhere>;
  /** Return ExternalCourses where some of the related ExternalAssignments match this filter */
  assignments_SOME?: InputMaybe<ExternalAssignmentWhere>;
  courseCode?: InputMaybe<Scalars['String']['input']>;
  courseCode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  courseCode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  courseCode_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  courseCode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  descriptionHtml_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  descriptionHtml_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  descriptionHtml_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descriptionHtml_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  descriptionText?: InputMaybe<Scalars['String']['input']>;
  descriptionText_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  descriptionText_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  descriptionText_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descriptionText_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  discussionsAggregate?: InputMaybe<ExternalCourseDiscussionsAggregateInput>;
  /** Return ExternalCourses where all of the related ExternalCourseDiscussionsConnections match this filter */
  discussionsConnection_ALL?: InputMaybe<ExternalCourseDiscussionsConnectionWhere>;
  /** Return ExternalCourses where none of the related ExternalCourseDiscussionsConnections match this filter */
  discussionsConnection_NONE?: InputMaybe<ExternalCourseDiscussionsConnectionWhere>;
  /** Return ExternalCourses where one of the related ExternalCourseDiscussionsConnections match this filter */
  discussionsConnection_SINGLE?: InputMaybe<ExternalCourseDiscussionsConnectionWhere>;
  /** Return ExternalCourses where some of the related ExternalCourseDiscussionsConnections match this filter */
  discussionsConnection_SOME?: InputMaybe<ExternalCourseDiscussionsConnectionWhere>;
  /** Return ExternalCourses where all of the related ExternalDiscussionBoards match this filter */
  discussions_ALL?: InputMaybe<ExternalDiscussionBoardWhere>;
  /** Return ExternalCourses where none of the related ExternalDiscussionBoards match this filter */
  discussions_NONE?: InputMaybe<ExternalDiscussionBoardWhere>;
  /** Return ExternalCourses where one of the related ExternalDiscussionBoards match this filter */
  discussions_SINGLE?: InputMaybe<ExternalDiscussionBoardWhere>;
  /** Return ExternalCourses where some of the related ExternalDiscussionBoards match this filter */
  discussions_SOME?: InputMaybe<ExternalDiscussionBoardWhere>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  endDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradeItemsAggregate?: InputMaybe<ExternalCourseGradeItemsAggregateInput>;
  /** Return ExternalCourses where all of the related ExternalCourseGradeItemsConnections match this filter */
  gradeItemsConnection_ALL?: InputMaybe<ExternalCourseGradeItemsConnectionWhere>;
  /** Return ExternalCourses where none of the related ExternalCourseGradeItemsConnections match this filter */
  gradeItemsConnection_NONE?: InputMaybe<ExternalCourseGradeItemsConnectionWhere>;
  /** Return ExternalCourses where one of the related ExternalCourseGradeItemsConnections match this filter */
  gradeItemsConnection_SINGLE?: InputMaybe<ExternalCourseGradeItemsConnectionWhere>;
  /** Return ExternalCourses where some of the related ExternalCourseGradeItemsConnections match this filter */
  gradeItemsConnection_SOME?: InputMaybe<ExternalCourseGradeItemsConnectionWhere>;
  /** Return ExternalCourses where all of the related ExternalGradeItems match this filter */
  gradeItems_ALL?: InputMaybe<ExternalGradeItemWhere>;
  /** Return ExternalCourses where none of the related ExternalGradeItems match this filter */
  gradeItems_NONE?: InputMaybe<ExternalGradeItemWhere>;
  /** Return ExternalCourses where one of the related ExternalGradeItems match this filter */
  gradeItems_SINGLE?: InputMaybe<ExternalGradeItemWhere>;
  /** Return ExternalCourses where some of the related ExternalGradeItems match this filter */
  gradeItems_SOME?: InputMaybe<ExternalGradeItemWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lmsSource?: InputMaybe<LmsSource>;
  lmsSource_IN?: InputMaybe<Array<LmsSource>>;
  modulesAggregate?: InputMaybe<ExternalCourseModulesAggregateInput>;
  /** Return ExternalCourses where all of the related ExternalCourseModulesConnections match this filter */
  modulesConnection_ALL?: InputMaybe<ExternalCourseModulesConnectionWhere>;
  /** Return ExternalCourses where none of the related ExternalCourseModulesConnections match this filter */
  modulesConnection_NONE?: InputMaybe<ExternalCourseModulesConnectionWhere>;
  /** Return ExternalCourses where one of the related ExternalCourseModulesConnections match this filter */
  modulesConnection_SINGLE?: InputMaybe<ExternalCourseModulesConnectionWhere>;
  /** Return ExternalCourses where some of the related ExternalCourseModulesConnections match this filter */
  modulesConnection_SOME?: InputMaybe<ExternalCourseModulesConnectionWhere>;
  /** Return ExternalCourses where all of the related ExternalModules match this filter */
  modules_ALL?: InputMaybe<ExternalModuleWhere>;
  /** Return ExternalCourses where none of the related ExternalModules match this filter */
  modules_NONE?: InputMaybe<ExternalModuleWhere>;
  /** Return ExternalCourses where one of the related ExternalModules match this filter */
  modules_SINGLE?: InputMaybe<ExternalModuleWhere>;
  /** Return ExternalCourses where some of the related ExternalModules match this filter */
  modules_SOME?: InputMaybe<ExternalModuleWhere>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  pagesAggregate?: InputMaybe<ExternalCoursePagesAggregateInput>;
  /** Return ExternalCourses where all of the related ExternalCoursePagesConnections match this filter */
  pagesConnection_ALL?: InputMaybe<ExternalCoursePagesConnectionWhere>;
  /** Return ExternalCourses where none of the related ExternalCoursePagesConnections match this filter */
  pagesConnection_NONE?: InputMaybe<ExternalCoursePagesConnectionWhere>;
  /** Return ExternalCourses where one of the related ExternalCoursePagesConnections match this filter */
  pagesConnection_SINGLE?: InputMaybe<ExternalCoursePagesConnectionWhere>;
  /** Return ExternalCourses where some of the related ExternalCoursePagesConnections match this filter */
  pagesConnection_SOME?: InputMaybe<ExternalCoursePagesConnectionWhere>;
  /** Return ExternalCourses where all of the related ExternalPages match this filter */
  pages_ALL?: InputMaybe<ExternalPageWhere>;
  /** Return ExternalCourses where none of the related ExternalPages match this filter */
  pages_NONE?: InputMaybe<ExternalPageWhere>;
  /** Return ExternalCourses where one of the related ExternalPages match this filter */
  pages_SINGLE?: InputMaybe<ExternalPageWhere>;
  /** Return ExternalCourses where some of the related ExternalPages match this filter */
  pages_SOME?: InputMaybe<ExternalPageWhere>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerApiUrl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerCourseId?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerCourseId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
  providerKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerKey_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  quizzesAggregate?: InputMaybe<ExternalCourseQuizzesAggregateInput>;
  /** Return ExternalCourses where all of the related ExternalCourseQuizzesConnections match this filter */
  quizzesConnection_ALL?: InputMaybe<ExternalCourseQuizzesConnectionWhere>;
  /** Return ExternalCourses where none of the related ExternalCourseQuizzesConnections match this filter */
  quizzesConnection_NONE?: InputMaybe<ExternalCourseQuizzesConnectionWhere>;
  /** Return ExternalCourses where one of the related ExternalCourseQuizzesConnections match this filter */
  quizzesConnection_SINGLE?: InputMaybe<ExternalCourseQuizzesConnectionWhere>;
  /** Return ExternalCourses where some of the related ExternalCourseQuizzesConnections match this filter */
  quizzesConnection_SOME?: InputMaybe<ExternalCourseQuizzesConnectionWhere>;
  /** Return ExternalCourses where all of the related ExternalQuizs match this filter */
  quizzes_ALL?: InputMaybe<ExternalQuizWhere>;
  /** Return ExternalCourses where none of the related ExternalQuizs match this filter */
  quizzes_NONE?: InputMaybe<ExternalQuizWhere>;
  /** Return ExternalCourses where one of the related ExternalQuizs match this filter */
  quizzes_SINGLE?: InputMaybe<ExternalQuizWhere>;
  /** Return ExternalCourses where some of the related ExternalQuizs match this filter */
  quizzes_SOME?: InputMaybe<ExternalQuizWhere>;
  school?: InputMaybe<SchoolWhere>;
  schoolAggregate?: InputMaybe<ExternalCourseSchoolAggregateInput>;
  schoolConnection?: InputMaybe<ExternalCourseSchoolConnectionWhere>;
  schoolConnection_NOT?: InputMaybe<ExternalCourseSchoolConnectionWhere>;
  school_NOT?: InputMaybe<SchoolWhere>;
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourceMeta_IN?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload_IN?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  sourceUpdatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  startDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  syncedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  usersAggregate?: InputMaybe<ExternalCourseUsersAggregateInput>;
  /** Return ExternalCourses where all of the related ExternalCourseUsersConnections match this filter */
  usersConnection_ALL?: InputMaybe<ExternalCourseUsersConnectionWhere>;
  /** Return ExternalCourses where none of the related ExternalCourseUsersConnections match this filter */
  usersConnection_NONE?: InputMaybe<ExternalCourseUsersConnectionWhere>;
  /** Return ExternalCourses where one of the related ExternalCourseUsersConnections match this filter */
  usersConnection_SINGLE?: InputMaybe<ExternalCourseUsersConnectionWhere>;
  /** Return ExternalCourses where some of the related ExternalCourseUsersConnections match this filter */
  usersConnection_SOME?: InputMaybe<ExternalCourseUsersConnectionWhere>;
  /** Return ExternalCourses where all of the related Users match this filter */
  users_ALL?: InputMaybe<UserWhere>;
  /** Return ExternalCourses where none of the related Users match this filter */
  users_NONE?: InputMaybe<UserWhere>;
  /** Return ExternalCourses where one of the related Users match this filter */
  users_SINGLE?: InputMaybe<UserWhere>;
  /** Return ExternalCourses where some of the related Users match this filter */
  users_SOME?: InputMaybe<UserWhere>;
  visibility?: InputMaybe<ExternalCourseVisibility>;
  visibility_IN?: InputMaybe<Array<ExternalCourseVisibility>>;
};

export enum ExternalCredentialProvider {
  Accredible = 'ACCREDIBLE'
}

export type ExternalDiscussionBoard = {
  __typename?: 'ExternalDiscussionBoard';
  availableFrom?: Maybe<Scalars['DateTime']['output']>;
  availableUntil?: Maybe<Scalars['DateTime']['output']>;
  course: ExternalCourse;
  courseAggregate?: Maybe<ExternalDiscussionBoardExternalCourseCourseAggregationSelection>;
  courseConnection: ExternalDiscussionBoardCourseConnection;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  files: Array<ExternalFile>;
  filesAggregate?: Maybe<ExternalDiscussionBoardExternalFileFilesAggregationSelection>;
  filesConnection: ExternalDiscussionBoardFilesConnection;
  id: Scalars['ID']['output'];
  lmsSource: LmsSource;
  locked?: Maybe<Scalars['Boolean']['output']>;
  messageHtml?: Maybe<Scalars['String']['output']>;
  messageText?: Maybe<Scalars['String']['output']>;
  nudgesAboutThis: Array<Nudge>;
  nudgesAboutThisAggregate?: Maybe<ExternalDiscussionBoardNudgeNudgesAboutThisAggregationSelection>;
  nudgesAboutThisConnection: ExternalDiscussionBoardNudgesAboutThisConnection;
  pinned?: Maybe<Scalars['Boolean']['output']>;
  pointsPossible?: Maybe<Scalars['Float']['output']>;
  providerApiUrl?: Maybe<Scalars['String']['output']>;
  providerCourseId: Scalars['String']['output'];
  providerDiscussionId: Scalars['String']['output'];
  providerKey: Scalars['String']['output'];
  sourceMeta?: Maybe<Scalars['JSON']['output']>;
  sourcePayload?: Maybe<Scalars['JSON']['output']>;
  sourceUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  submissions: Array<ExternalSubmission>;
  submissionsAggregate?: Maybe<ExternalDiscussionBoardExternalSubmissionSubmissionsAggregationSelection>;
  submissionsConnection: ExternalDiscussionBoardSubmissionsConnection;
  syncedAt: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
  visibility: ExternalDiscussionVisibility;
};


export type ExternalDiscussionBoardCourseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalCourseOptions>;
  where?: InputMaybe<ExternalCourseWhere>;
};


export type ExternalDiscussionBoardCourseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalCourseWhere>;
};


export type ExternalDiscussionBoardCourseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalDiscussionBoardCourseConnectionSort>>;
  where?: InputMaybe<ExternalDiscussionBoardCourseConnectionWhere>;
};


export type ExternalDiscussionBoardFilesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalFileOptions>;
  where?: InputMaybe<ExternalFileWhere>;
};


export type ExternalDiscussionBoardFilesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalFileWhere>;
};


export type ExternalDiscussionBoardFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalDiscussionBoardFilesConnectionSort>>;
  where?: InputMaybe<ExternalDiscussionBoardFilesConnectionWhere>;
};


export type ExternalDiscussionBoardNudgesAboutThisArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<NudgeOptions>;
  where?: InputMaybe<NudgeWhere>;
};


export type ExternalDiscussionBoardNudgesAboutThisAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NudgeWhere>;
};


export type ExternalDiscussionBoardNudgesAboutThisConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalDiscussionBoardNudgesAboutThisConnectionSort>>;
  where?: InputMaybe<ExternalDiscussionBoardNudgesAboutThisConnectionWhere>;
};


export type ExternalDiscussionBoardSubmissionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalSubmissionOptions>;
  where?: InputMaybe<ExternalSubmissionWhere>;
};


export type ExternalDiscussionBoardSubmissionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalSubmissionWhere>;
};


export type ExternalDiscussionBoardSubmissionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalDiscussionBoardSubmissionsConnectionSort>>;
  where?: InputMaybe<ExternalDiscussionBoardSubmissionsConnectionWhere>;
};

export type ExternalDiscussionBoardConnectInput = {
  course?: InputMaybe<ExternalDiscussionBoardCourseConnectFieldInput>;
  files?: InputMaybe<Array<ExternalDiscussionBoardFilesConnectFieldInput>>;
  nudgesAboutThis?: InputMaybe<Array<ExternalDiscussionBoardNudgesAboutThisConnectFieldInput>>;
  submissions?: InputMaybe<Array<ExternalDiscussionBoardSubmissionsConnectFieldInput>>;
};

export type ExternalDiscussionBoardConnectOrCreateWhere = {
  node: ExternalDiscussionBoardUniqueWhere;
};

export type ExternalDiscussionBoardConnectWhere = {
  node: ExternalDiscussionBoardWhere;
};

export type ExternalDiscussionBoardCourseAggregateInput = {
  AND?: InputMaybe<Array<ExternalDiscussionBoardCourseAggregateInput>>;
  NOT?: InputMaybe<ExternalDiscussionBoardCourseAggregateInput>;
  OR?: InputMaybe<Array<ExternalDiscussionBoardCourseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalDiscussionBoardCourseNodeAggregationWhereInput>;
};

export type ExternalDiscussionBoardCourseConnectFieldInput = {
  connect?: InputMaybe<ExternalCourseConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalCourseConnectWhere>;
};

export type ExternalDiscussionBoardCourseConnectOrCreateFieldInput = {
  onCreate: ExternalDiscussionBoardCourseConnectOrCreateFieldInputOnCreate;
  where: ExternalCourseConnectOrCreateWhere;
};

export type ExternalDiscussionBoardCourseConnectOrCreateFieldInputOnCreate = {
  node: ExternalCourseOnCreateInput;
};

export type ExternalDiscussionBoardCourseConnection = {
  __typename?: 'ExternalDiscussionBoardCourseConnection';
  edges: Array<ExternalDiscussionBoardCourseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalDiscussionBoardCourseConnectionSort = {
  node?: InputMaybe<ExternalCourseSort>;
};

export type ExternalDiscussionBoardCourseConnectionWhere = {
  AND?: InputMaybe<Array<ExternalDiscussionBoardCourseConnectionWhere>>;
  NOT?: InputMaybe<ExternalDiscussionBoardCourseConnectionWhere>;
  OR?: InputMaybe<Array<ExternalDiscussionBoardCourseConnectionWhere>>;
  node?: InputMaybe<ExternalCourseWhere>;
};

export type ExternalDiscussionBoardCourseCreateFieldInput = {
  node: ExternalCourseCreateInput;
};

export type ExternalDiscussionBoardCourseDeleteFieldInput = {
  delete?: InputMaybe<ExternalCourseDeleteInput>;
  where?: InputMaybe<ExternalDiscussionBoardCourseConnectionWhere>;
};

export type ExternalDiscussionBoardCourseDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalCourseDisconnectInput>;
  where?: InputMaybe<ExternalDiscussionBoardCourseConnectionWhere>;
};

export type ExternalDiscussionBoardCourseFieldInput = {
  connect?: InputMaybe<ExternalDiscussionBoardCourseConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalDiscussionBoardCourseConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalDiscussionBoardCourseCreateFieldInput>;
};

export type ExternalDiscussionBoardCourseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalDiscussionBoardCourseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalDiscussionBoardCourseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalDiscussionBoardCourseNodeAggregationWhereInput>>;
  courseCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  courseCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  courseCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  courseCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  courseCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  endDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalDiscussionBoardCourseRelationship = {
  __typename?: 'ExternalDiscussionBoardCourseRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalCourse;
};

export type ExternalDiscussionBoardCourseUpdateConnectionInput = {
  node?: InputMaybe<ExternalCourseUpdateInput>;
};

export type ExternalDiscussionBoardCourseUpdateFieldInput = {
  connect?: InputMaybe<ExternalDiscussionBoardCourseConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalDiscussionBoardCourseConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalDiscussionBoardCourseCreateFieldInput>;
  delete?: InputMaybe<ExternalDiscussionBoardCourseDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalDiscussionBoardCourseDisconnectFieldInput>;
  update?: InputMaybe<ExternalDiscussionBoardCourseUpdateConnectionInput>;
  where?: InputMaybe<ExternalDiscussionBoardCourseConnectionWhere>;
};

export type ExternalDiscussionBoardCreateInput = {
  availableFrom?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil?: InputMaybe<Scalars['DateTime']['input']>;
  course?: InputMaybe<ExternalDiscussionBoardCourseFieldInput>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  files?: InputMaybe<ExternalDiscussionBoardFilesFieldInput>;
  lmsSource: LmsSource;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  messageHtml?: InputMaybe<Scalars['String']['input']>;
  messageText?: InputMaybe<Scalars['String']['input']>;
  nudgesAboutThis?: InputMaybe<ExternalDiscussionBoardNudgesAboutThisFieldInput>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  pointsPossible?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerCourseId: Scalars['String']['input'];
  providerDiscussionId: Scalars['String']['input'];
  providerKey: Scalars['String']['input'];
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  submissions?: InputMaybe<ExternalDiscussionBoardSubmissionsFieldInput>;
  syncedAt: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  visibility: ExternalDiscussionVisibility;
};

export type ExternalDiscussionBoardDeleteInput = {
  course?: InputMaybe<ExternalDiscussionBoardCourseDeleteFieldInput>;
  files?: InputMaybe<Array<ExternalDiscussionBoardFilesDeleteFieldInput>>;
  nudgesAboutThis?: InputMaybe<Array<ExternalDiscussionBoardNudgesAboutThisDeleteFieldInput>>;
  submissions?: InputMaybe<Array<ExternalDiscussionBoardSubmissionsDeleteFieldInput>>;
};

export type ExternalDiscussionBoardDisconnectInput = {
  course?: InputMaybe<ExternalDiscussionBoardCourseDisconnectFieldInput>;
  files?: InputMaybe<Array<ExternalDiscussionBoardFilesDisconnectFieldInput>>;
  nudgesAboutThis?: InputMaybe<Array<ExternalDiscussionBoardNudgesAboutThisDisconnectFieldInput>>;
  submissions?: InputMaybe<Array<ExternalDiscussionBoardSubmissionsDisconnectFieldInput>>;
};

export type ExternalDiscussionBoardExternalCourseCourseAggregationSelection = {
  __typename?: 'ExternalDiscussionBoardExternalCourseCourseAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalDiscussionBoardExternalCourseCourseNodeAggregateSelection>;
};

export type ExternalDiscussionBoardExternalCourseCourseNodeAggregateSelection = {
  __typename?: 'ExternalDiscussionBoardExternalCourseCourseNodeAggregateSelection';
  courseCode: StringAggregateSelection;
  descriptionHtml: StringAggregateSelection;
  descriptionText: StringAggregateSelection;
  endDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  name: StringAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  startDate: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalDiscussionBoardExternalFileFilesAggregationSelection = {
  __typename?: 'ExternalDiscussionBoardExternalFileFilesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalDiscussionBoardExternalFileFilesNodeAggregateSelection>;
};

export type ExternalDiscussionBoardExternalFileFilesNodeAggregateSelection = {
  __typename?: 'ExternalDiscussionBoardExternalFileFilesNodeAggregateSelection';
  attachedToId: StringAggregateSelection;
  displayName: StringAggregateSelection;
  downloadUrl: StringAggregateSelection;
  fileName: StringAggregateSelection;
  fileSize: IntAggregateSelection;
  id: IdAggregateSelection;
  mimeType: StringAggregateSelection;
  modifiedAt: DateTimeAggregateSelection;
  previewUrl: StringAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerFileId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  uploadedAt: DateTimeAggregateSelection;
  uploadedBy: StringAggregateSelection;
};

export type ExternalDiscussionBoardExternalSubmissionSubmissionsAggregationSelection = {
  __typename?: 'ExternalDiscussionBoardExternalSubmissionSubmissionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalDiscussionBoardExternalSubmissionSubmissionsNodeAggregateSelection>;
};

export type ExternalDiscussionBoardExternalSubmissionSubmissionsNodeAggregateSelection = {
  __typename?: 'ExternalDiscussionBoardExternalSubmissionSubmissionsNodeAggregateSelection';
  gradeText: StringAggregateSelection;
  gradedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  pointsPossible: FloatAggregateSelection;
  providerContentId: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  providerUserId: StringAggregateSelection;
  score: FloatAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  submittedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
};

export type ExternalDiscussionBoardFilesAggregateInput = {
  AND?: InputMaybe<Array<ExternalDiscussionBoardFilesAggregateInput>>;
  NOT?: InputMaybe<ExternalDiscussionBoardFilesAggregateInput>;
  OR?: InputMaybe<Array<ExternalDiscussionBoardFilesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalDiscussionBoardFilesNodeAggregationWhereInput>;
};

export type ExternalDiscussionBoardFilesConnectFieldInput = {
  connect?: InputMaybe<Array<ExternalFileConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalFileConnectWhere>;
};

export type ExternalDiscussionBoardFilesConnectOrCreateFieldInput = {
  onCreate: ExternalDiscussionBoardFilesConnectOrCreateFieldInputOnCreate;
  where: ExternalFileConnectOrCreateWhere;
};

export type ExternalDiscussionBoardFilesConnectOrCreateFieldInputOnCreate = {
  node: ExternalFileOnCreateInput;
};

export type ExternalDiscussionBoardFilesConnection = {
  __typename?: 'ExternalDiscussionBoardFilesConnection';
  edges: Array<ExternalDiscussionBoardFilesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalDiscussionBoardFilesConnectionSort = {
  node?: InputMaybe<ExternalFileSort>;
};

export type ExternalDiscussionBoardFilesConnectionWhere = {
  AND?: InputMaybe<Array<ExternalDiscussionBoardFilesConnectionWhere>>;
  NOT?: InputMaybe<ExternalDiscussionBoardFilesConnectionWhere>;
  OR?: InputMaybe<Array<ExternalDiscussionBoardFilesConnectionWhere>>;
  node?: InputMaybe<ExternalFileWhere>;
};

export type ExternalDiscussionBoardFilesCreateFieldInput = {
  node: ExternalFileCreateInput;
};

export type ExternalDiscussionBoardFilesDeleteFieldInput = {
  delete?: InputMaybe<ExternalFileDeleteInput>;
  where?: InputMaybe<ExternalDiscussionBoardFilesConnectionWhere>;
};

export type ExternalDiscussionBoardFilesDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalFileDisconnectInput>;
  where?: InputMaybe<ExternalDiscussionBoardFilesConnectionWhere>;
};

export type ExternalDiscussionBoardFilesFieldInput = {
  connect?: InputMaybe<Array<ExternalDiscussionBoardFilesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalDiscussionBoardFilesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalDiscussionBoardFilesCreateFieldInput>>;
};

export type ExternalDiscussionBoardFilesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalDiscussionBoardFilesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalDiscussionBoardFilesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalDiscussionBoardFilesNodeAggregationWhereInput>>;
  attachedToId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  attachedToId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  attachedToId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  attachedToId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  attachedToId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  attachedToId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  downloadUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  downloadUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  downloadUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  downloadUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  downloadUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileSize_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileSize_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  fileSize_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileSize_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  fileSize_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileSize_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileSize_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileSize_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileSize_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  mimeType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modifiedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  previewUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  previewUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  previewUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  previewUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  previewUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  previewUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerFileId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerFileId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerFileId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerFileId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerFileId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uploadedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uploadedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uploadedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uploadedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uploadedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalDiscussionBoardFilesRelationship = {
  __typename?: 'ExternalDiscussionBoardFilesRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalFile;
};

export type ExternalDiscussionBoardFilesUpdateConnectionInput = {
  node?: InputMaybe<ExternalFileUpdateInput>;
};

export type ExternalDiscussionBoardFilesUpdateFieldInput = {
  connect?: InputMaybe<Array<ExternalDiscussionBoardFilesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalDiscussionBoardFilesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalDiscussionBoardFilesCreateFieldInput>>;
  delete?: InputMaybe<Array<ExternalDiscussionBoardFilesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ExternalDiscussionBoardFilesDisconnectFieldInput>>;
  update?: InputMaybe<ExternalDiscussionBoardFilesUpdateConnectionInput>;
  where?: InputMaybe<ExternalDiscussionBoardFilesConnectionWhere>;
};

export type ExternalDiscussionBoardNudgeNudgesAboutThisAggregationSelection = {
  __typename?: 'ExternalDiscussionBoardNudgeNudgesAboutThisAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalDiscussionBoardNudgeNudgesAboutThisNodeAggregateSelection>;
};

export type ExternalDiscussionBoardNudgeNudgesAboutThisNodeAggregateSelection = {
  __typename?: 'ExternalDiscussionBoardNudgeNudgesAboutThisNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  idempotencyKey: StringAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  priorityScore: FloatAggregateSelection;
  scheduledFor: DateTimeAggregateSelection;
  snoozedUntil: DateTimeAggregateSelection;
  taskCompletedAt: DateTimeAggregateSelection;
};

export type ExternalDiscussionBoardNudgesAboutThisAggregateInput = {
  AND?: InputMaybe<Array<ExternalDiscussionBoardNudgesAboutThisAggregateInput>>;
  NOT?: InputMaybe<ExternalDiscussionBoardNudgesAboutThisAggregateInput>;
  OR?: InputMaybe<Array<ExternalDiscussionBoardNudgesAboutThisAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalDiscussionBoardNudgesAboutThisNodeAggregationWhereInput>;
};

export type ExternalDiscussionBoardNudgesAboutThisConnectFieldInput = {
  connect?: InputMaybe<Array<NudgeConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<NudgeConnectWhere>;
};

export type ExternalDiscussionBoardNudgesAboutThisConnectOrCreateFieldInput = {
  onCreate: ExternalDiscussionBoardNudgesAboutThisConnectOrCreateFieldInputOnCreate;
  where: NudgeConnectOrCreateWhere;
};

export type ExternalDiscussionBoardNudgesAboutThisConnectOrCreateFieldInputOnCreate = {
  node: NudgeOnCreateInput;
};

export type ExternalDiscussionBoardNudgesAboutThisConnection = {
  __typename?: 'ExternalDiscussionBoardNudgesAboutThisConnection';
  edges: Array<ExternalDiscussionBoardNudgesAboutThisRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalDiscussionBoardNudgesAboutThisConnectionSort = {
  node?: InputMaybe<NudgeSort>;
};

export type ExternalDiscussionBoardNudgesAboutThisConnectionWhere = {
  AND?: InputMaybe<Array<ExternalDiscussionBoardNudgesAboutThisConnectionWhere>>;
  NOT?: InputMaybe<ExternalDiscussionBoardNudgesAboutThisConnectionWhere>;
  OR?: InputMaybe<Array<ExternalDiscussionBoardNudgesAboutThisConnectionWhere>>;
  node?: InputMaybe<NudgeWhere>;
};

export type ExternalDiscussionBoardNudgesAboutThisCreateFieldInput = {
  node: NudgeCreateInput;
};

export type ExternalDiscussionBoardNudgesAboutThisDeleteFieldInput = {
  delete?: InputMaybe<NudgeDeleteInput>;
  where?: InputMaybe<ExternalDiscussionBoardNudgesAboutThisConnectionWhere>;
};

export type ExternalDiscussionBoardNudgesAboutThisDisconnectFieldInput = {
  disconnect?: InputMaybe<NudgeDisconnectInput>;
  where?: InputMaybe<ExternalDiscussionBoardNudgesAboutThisConnectionWhere>;
};

export type ExternalDiscussionBoardNudgesAboutThisFieldInput = {
  connect?: InputMaybe<Array<ExternalDiscussionBoardNudgesAboutThisConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalDiscussionBoardNudgesAboutThisConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalDiscussionBoardNudgesAboutThisCreateFieldInput>>;
};

export type ExternalDiscussionBoardNudgesAboutThisNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalDiscussionBoardNudgesAboutThisNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalDiscussionBoardNudgesAboutThisNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalDiscussionBoardNudgesAboutThisNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  idempotencyKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  priorityScore_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  scheduledFor_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ExternalDiscussionBoardNudgesAboutThisRelationship = {
  __typename?: 'ExternalDiscussionBoardNudgesAboutThisRelationship';
  cursor: Scalars['String']['output'];
  node: Nudge;
};

export type ExternalDiscussionBoardNudgesAboutThisUpdateConnectionInput = {
  node?: InputMaybe<NudgeUpdateInput>;
};

export type ExternalDiscussionBoardNudgesAboutThisUpdateFieldInput = {
  connect?: InputMaybe<Array<ExternalDiscussionBoardNudgesAboutThisConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalDiscussionBoardNudgesAboutThisConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalDiscussionBoardNudgesAboutThisCreateFieldInput>>;
  delete?: InputMaybe<Array<ExternalDiscussionBoardNudgesAboutThisDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ExternalDiscussionBoardNudgesAboutThisDisconnectFieldInput>>;
  update?: InputMaybe<ExternalDiscussionBoardNudgesAboutThisUpdateConnectionInput>;
  where?: InputMaybe<ExternalDiscussionBoardNudgesAboutThisConnectionWhere>;
};

export type ExternalDiscussionBoardOnCreateInput = {
  availableFrom?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  lmsSource: LmsSource;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  messageHtml?: InputMaybe<Scalars['String']['input']>;
  messageText?: InputMaybe<Scalars['String']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  pointsPossible?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerCourseId: Scalars['String']['input'];
  providerDiscussionId: Scalars['String']['input'];
  providerKey: Scalars['String']['input'];
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  visibility: ExternalDiscussionVisibility;
};

export type ExternalDiscussionBoardOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ExternalDiscussionBoardSort objects to sort ExternalDiscussionBoards by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ExternalDiscussionBoardSort>>;
};

/** Fields to sort ExternalDiscussionBoards by. The order in which sorts are applied is not guaranteed when specifying many fields in one ExternalDiscussionBoardSort object. */
export type ExternalDiscussionBoardSort = {
  availableFrom?: InputMaybe<SortDirection>;
  availableUntil?: InputMaybe<SortDirection>;
  dueDate?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lmsSource?: InputMaybe<SortDirection>;
  locked?: InputMaybe<SortDirection>;
  messageHtml?: InputMaybe<SortDirection>;
  messageText?: InputMaybe<SortDirection>;
  pinned?: InputMaybe<SortDirection>;
  pointsPossible?: InputMaybe<SortDirection>;
  providerApiUrl?: InputMaybe<SortDirection>;
  providerCourseId?: InputMaybe<SortDirection>;
  providerDiscussionId?: InputMaybe<SortDirection>;
  providerKey?: InputMaybe<SortDirection>;
  sourceMeta?: InputMaybe<SortDirection>;
  sourcePayload?: InputMaybe<SortDirection>;
  sourceUpdatedAt?: InputMaybe<SortDirection>;
  syncedAt?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  url?: InputMaybe<SortDirection>;
  visibility?: InputMaybe<SortDirection>;
};

export type ExternalDiscussionBoardSubmissionsAggregateInput = {
  AND?: InputMaybe<Array<ExternalDiscussionBoardSubmissionsAggregateInput>>;
  NOT?: InputMaybe<ExternalDiscussionBoardSubmissionsAggregateInput>;
  OR?: InputMaybe<Array<ExternalDiscussionBoardSubmissionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalDiscussionBoardSubmissionsNodeAggregationWhereInput>;
};

export type ExternalDiscussionBoardSubmissionsConnectFieldInput = {
  connect?: InputMaybe<Array<ExternalSubmissionConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalSubmissionConnectWhere>;
};

export type ExternalDiscussionBoardSubmissionsConnectOrCreateFieldInput = {
  onCreate: ExternalDiscussionBoardSubmissionsConnectOrCreateFieldInputOnCreate;
  where: ExternalSubmissionConnectOrCreateWhere;
};

export type ExternalDiscussionBoardSubmissionsConnectOrCreateFieldInputOnCreate = {
  node: ExternalSubmissionOnCreateInput;
};

export type ExternalDiscussionBoardSubmissionsConnection = {
  __typename?: 'ExternalDiscussionBoardSubmissionsConnection';
  edges: Array<ExternalDiscussionBoardSubmissionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalDiscussionBoardSubmissionsConnectionSort = {
  node?: InputMaybe<ExternalSubmissionSort>;
};

export type ExternalDiscussionBoardSubmissionsConnectionWhere = {
  AND?: InputMaybe<Array<ExternalDiscussionBoardSubmissionsConnectionWhere>>;
  NOT?: InputMaybe<ExternalDiscussionBoardSubmissionsConnectionWhere>;
  OR?: InputMaybe<Array<ExternalDiscussionBoardSubmissionsConnectionWhere>>;
  node?: InputMaybe<ExternalSubmissionWhere>;
};

export type ExternalDiscussionBoardSubmissionsCreateFieldInput = {
  node: ExternalSubmissionCreateInput;
};

export type ExternalDiscussionBoardSubmissionsDeleteFieldInput = {
  delete?: InputMaybe<ExternalSubmissionDeleteInput>;
  where?: InputMaybe<ExternalDiscussionBoardSubmissionsConnectionWhere>;
};

export type ExternalDiscussionBoardSubmissionsDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalSubmissionDisconnectInput>;
  where?: InputMaybe<ExternalDiscussionBoardSubmissionsConnectionWhere>;
};

export type ExternalDiscussionBoardSubmissionsFieldInput = {
  connect?: InputMaybe<Array<ExternalDiscussionBoardSubmissionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalDiscussionBoardSubmissionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalDiscussionBoardSubmissionsCreateFieldInput>>;
};

export type ExternalDiscussionBoardSubmissionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalDiscussionBoardSubmissionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalDiscussionBoardSubmissionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalDiscussionBoardSubmissionsNodeAggregationWhereInput>>;
  gradeText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gradeText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gradeText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gradeText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gradeText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gradeText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gradeText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gradeText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gradeText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gradeText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gradeText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gradeText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gradeText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gradeText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gradeText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gradedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pointsPossible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerContentId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerContentId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerContentId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerContentId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerContentId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerContentId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  score_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  score_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  score_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  score_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  score_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  score_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  score_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  score_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  score_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  score_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  score_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  score_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  score_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  score_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  score_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  score_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  score_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  score_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  score_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  score_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ExternalDiscussionBoardSubmissionsRelationship = {
  __typename?: 'ExternalDiscussionBoardSubmissionsRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalSubmission;
};

export type ExternalDiscussionBoardSubmissionsUpdateConnectionInput = {
  node?: InputMaybe<ExternalSubmissionUpdateInput>;
};

export type ExternalDiscussionBoardSubmissionsUpdateFieldInput = {
  connect?: InputMaybe<Array<ExternalDiscussionBoardSubmissionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalDiscussionBoardSubmissionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalDiscussionBoardSubmissionsCreateFieldInput>>;
  delete?: InputMaybe<Array<ExternalDiscussionBoardSubmissionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ExternalDiscussionBoardSubmissionsDisconnectFieldInput>>;
  update?: InputMaybe<ExternalDiscussionBoardSubmissionsUpdateConnectionInput>;
  where?: InputMaybe<ExternalDiscussionBoardSubmissionsConnectionWhere>;
};

export type ExternalDiscussionBoardUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalDiscussionBoardUpdateInput = {
  availableFrom?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil?: InputMaybe<Scalars['DateTime']['input']>;
  course?: InputMaybe<ExternalDiscussionBoardCourseUpdateFieldInput>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  files?: InputMaybe<Array<ExternalDiscussionBoardFilesUpdateFieldInput>>;
  lmsSource?: InputMaybe<LmsSource>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  messageHtml?: InputMaybe<Scalars['String']['input']>;
  messageText?: InputMaybe<Scalars['String']['input']>;
  nudgesAboutThis?: InputMaybe<Array<ExternalDiscussionBoardNudgesAboutThisUpdateFieldInput>>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  pointsPossible?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_ADD?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerCourseId?: InputMaybe<Scalars['String']['input']>;
  providerDiscussionId?: InputMaybe<Scalars['String']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  submissions?: InputMaybe<Array<ExternalDiscussionBoardSubmissionsUpdateFieldInput>>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<ExternalDiscussionVisibility>;
};

export type ExternalDiscussionBoardWhere = {
  AND?: InputMaybe<Array<ExternalDiscussionBoardWhere>>;
  NOT?: InputMaybe<ExternalDiscussionBoardWhere>;
  OR?: InputMaybe<Array<ExternalDiscussionBoardWhere>>;
  availableFrom?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  availableFrom_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  availableUntil_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  course?: InputMaybe<ExternalCourseWhere>;
  courseAggregate?: InputMaybe<ExternalDiscussionBoardCourseAggregateInput>;
  courseConnection?: InputMaybe<ExternalDiscussionBoardCourseConnectionWhere>;
  courseConnection_NOT?: InputMaybe<ExternalDiscussionBoardCourseConnectionWhere>;
  course_NOT?: InputMaybe<ExternalCourseWhere>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  dueDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  filesAggregate?: InputMaybe<ExternalDiscussionBoardFilesAggregateInput>;
  /** Return ExternalDiscussionBoards where all of the related ExternalDiscussionBoardFilesConnections match this filter */
  filesConnection_ALL?: InputMaybe<ExternalDiscussionBoardFilesConnectionWhere>;
  /** Return ExternalDiscussionBoards where none of the related ExternalDiscussionBoardFilesConnections match this filter */
  filesConnection_NONE?: InputMaybe<ExternalDiscussionBoardFilesConnectionWhere>;
  /** Return ExternalDiscussionBoards where one of the related ExternalDiscussionBoardFilesConnections match this filter */
  filesConnection_SINGLE?: InputMaybe<ExternalDiscussionBoardFilesConnectionWhere>;
  /** Return ExternalDiscussionBoards where some of the related ExternalDiscussionBoardFilesConnections match this filter */
  filesConnection_SOME?: InputMaybe<ExternalDiscussionBoardFilesConnectionWhere>;
  /** Return ExternalDiscussionBoards where all of the related ExternalFiles match this filter */
  files_ALL?: InputMaybe<ExternalFileWhere>;
  /** Return ExternalDiscussionBoards where none of the related ExternalFiles match this filter */
  files_NONE?: InputMaybe<ExternalFileWhere>;
  /** Return ExternalDiscussionBoards where one of the related ExternalFiles match this filter */
  files_SINGLE?: InputMaybe<ExternalFileWhere>;
  /** Return ExternalDiscussionBoards where some of the related ExternalFiles match this filter */
  files_SOME?: InputMaybe<ExternalFileWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lmsSource?: InputMaybe<LmsSource>;
  lmsSource_IN?: InputMaybe<Array<LmsSource>>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  messageHtml?: InputMaybe<Scalars['String']['input']>;
  messageHtml_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  messageHtml_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  messageHtml_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  messageHtml_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  messageText?: InputMaybe<Scalars['String']['input']>;
  messageText_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  messageText_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  messageText_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  messageText_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  nudgesAboutThisAggregate?: InputMaybe<ExternalDiscussionBoardNudgesAboutThisAggregateInput>;
  /** Return ExternalDiscussionBoards where all of the related ExternalDiscussionBoardNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_ALL?: InputMaybe<ExternalDiscussionBoardNudgesAboutThisConnectionWhere>;
  /** Return ExternalDiscussionBoards where none of the related ExternalDiscussionBoardNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_NONE?: InputMaybe<ExternalDiscussionBoardNudgesAboutThisConnectionWhere>;
  /** Return ExternalDiscussionBoards where one of the related ExternalDiscussionBoardNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_SINGLE?: InputMaybe<ExternalDiscussionBoardNudgesAboutThisConnectionWhere>;
  /** Return ExternalDiscussionBoards where some of the related ExternalDiscussionBoardNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_SOME?: InputMaybe<ExternalDiscussionBoardNudgesAboutThisConnectionWhere>;
  /** Return ExternalDiscussionBoards where all of the related Nudges match this filter */
  nudgesAboutThis_ALL?: InputMaybe<NudgeWhere>;
  /** Return ExternalDiscussionBoards where none of the related Nudges match this filter */
  nudgesAboutThis_NONE?: InputMaybe<NudgeWhere>;
  /** Return ExternalDiscussionBoards where one of the related Nudges match this filter */
  nudgesAboutThis_SINGLE?: InputMaybe<NudgeWhere>;
  /** Return ExternalDiscussionBoards where some of the related Nudges match this filter */
  nudgesAboutThis_SOME?: InputMaybe<NudgeWhere>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  pointsPossible?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  pointsPossible_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerApiUrl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerCourseId?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerCourseId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerDiscussionId?: InputMaybe<Scalars['String']['input']>;
  providerDiscussionId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerDiscussionId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerDiscussionId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerDiscussionId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
  providerKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerKey_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourceMeta_IN?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload_IN?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  sourceUpdatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionsAggregate?: InputMaybe<ExternalDiscussionBoardSubmissionsAggregateInput>;
  /** Return ExternalDiscussionBoards where all of the related ExternalDiscussionBoardSubmissionsConnections match this filter */
  submissionsConnection_ALL?: InputMaybe<ExternalDiscussionBoardSubmissionsConnectionWhere>;
  /** Return ExternalDiscussionBoards where none of the related ExternalDiscussionBoardSubmissionsConnections match this filter */
  submissionsConnection_NONE?: InputMaybe<ExternalDiscussionBoardSubmissionsConnectionWhere>;
  /** Return ExternalDiscussionBoards where one of the related ExternalDiscussionBoardSubmissionsConnections match this filter */
  submissionsConnection_SINGLE?: InputMaybe<ExternalDiscussionBoardSubmissionsConnectionWhere>;
  /** Return ExternalDiscussionBoards where some of the related ExternalDiscussionBoardSubmissionsConnections match this filter */
  submissionsConnection_SOME?: InputMaybe<ExternalDiscussionBoardSubmissionsConnectionWhere>;
  /** Return ExternalDiscussionBoards where all of the related ExternalSubmissions match this filter */
  submissions_ALL?: InputMaybe<ExternalSubmissionWhere>;
  /** Return ExternalDiscussionBoards where none of the related ExternalSubmissions match this filter */
  submissions_NONE?: InputMaybe<ExternalSubmissionWhere>;
  /** Return ExternalDiscussionBoards where one of the related ExternalSubmissions match this filter */
  submissions_SINGLE?: InputMaybe<ExternalSubmissionWhere>;
  /** Return ExternalDiscussionBoards where some of the related ExternalSubmissions match this filter */
  submissions_SOME?: InputMaybe<ExternalSubmissionWhere>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  syncedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<ExternalDiscussionVisibility>;
  visibility_IN?: InputMaybe<Array<ExternalDiscussionVisibility>>;
};

export enum ExternalDiscussionVisibility {
  Hidden = 'HIDDEN',
  Published = 'PUBLISHED',
  Unknown = 'UNKNOWN',
  Unpublished = 'UNPUBLISHED'
}

export type ExternalFile = {
  __typename?: 'ExternalFile';
  announcement?: Maybe<ExternalAnnouncement>;
  announcementAggregate?: Maybe<ExternalFileExternalAnnouncementAnnouncementAggregationSelection>;
  announcementConnection: ExternalFileAnnouncementConnection;
  assignment?: Maybe<ExternalAssignment>;
  assignmentAggregate?: Maybe<ExternalFileExternalAssignmentAssignmentAggregationSelection>;
  assignmentConnection: ExternalFileAssignmentConnection;
  attachedToId: Scalars['String']['output'];
  attachedToType: ExternalFileAttachedToType;
  course: ExternalCourse;
  courseAggregate?: Maybe<ExternalFileExternalCourseCourseAggregationSelection>;
  courseConnection: ExternalFileCourseConnection;
  discussion?: Maybe<ExternalDiscussionBoard>;
  discussionAggregate?: Maybe<ExternalFileExternalDiscussionBoardDiscussionAggregationSelection>;
  discussionConnection: ExternalFileDiscussionConnection;
  displayName?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Document>;
  documentAggregate?: Maybe<ExternalFileDocumentDocumentAggregationSelection>;
  documentConnection: ExternalFileDocumentConnection;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  fileSize?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  internalFile?: Maybe<File>;
  internalFileAggregate?: Maybe<ExternalFileFileInternalFileAggregationSelection>;
  internalFileConnection: ExternalFileInternalFileConnection;
  lmsSource: LmsSource;
  mimeType?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  moduleItem?: Maybe<ExternalModuleItem>;
  moduleItemAggregate?: Maybe<ExternalFileExternalModuleItemModuleItemAggregationSelection>;
  moduleItemConnection: ExternalFileModuleItemConnection;
  page?: Maybe<ExternalPage>;
  pageAggregate?: Maybe<ExternalFileExternalPagePageAggregationSelection>;
  pageConnection: ExternalFilePageConnection;
  previewUrl?: Maybe<Scalars['String']['output']>;
  providerApiUrl?: Maybe<Scalars['String']['output']>;
  providerCourseId: Scalars['String']['output'];
  providerFileId: Scalars['String']['output'];
  providerKey: Scalars['String']['output'];
  quiz?: Maybe<ExternalQuiz>;
  quizAggregate?: Maybe<ExternalFileExternalQuizQuizAggregationSelection>;
  quizConnection: ExternalFileQuizConnection;
  sourceMeta?: Maybe<Scalars['JSON']['output']>;
  sourcePayload?: Maybe<Scalars['JSON']['output']>;
  sourceUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  submission?: Maybe<ExternalSubmission>;
  submissionAggregate?: Maybe<ExternalFileExternalSubmissionSubmissionAggregationSelection>;
  submissionConnection: ExternalFileSubmissionConnection;
  syncedAt: Scalars['DateTime']['output'];
  uploadedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadedBy?: Maybe<Scalars['String']['output']>;
  uploadedByUser?: Maybe<User>;
  uploadedByUserAggregate?: Maybe<ExternalFileUserUploadedByUserAggregationSelection>;
  uploadedByUserConnection: ExternalFileUploadedByUserConnection;
  visibility: ExternalFileVisibility;
};


export type ExternalFileAnnouncementArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalAnnouncementOptions>;
  where?: InputMaybe<ExternalAnnouncementWhere>;
};


export type ExternalFileAnnouncementAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalAnnouncementWhere>;
};


export type ExternalFileAnnouncementConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalFileAnnouncementConnectionSort>>;
  where?: InputMaybe<ExternalFileAnnouncementConnectionWhere>;
};


export type ExternalFileAssignmentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalAssignmentOptions>;
  where?: InputMaybe<ExternalAssignmentWhere>;
};


export type ExternalFileAssignmentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalAssignmentWhere>;
};


export type ExternalFileAssignmentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalFileAssignmentConnectionSort>>;
  where?: InputMaybe<ExternalFileAssignmentConnectionWhere>;
};


export type ExternalFileCourseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalCourseOptions>;
  where?: InputMaybe<ExternalCourseWhere>;
};


export type ExternalFileCourseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalCourseWhere>;
};


export type ExternalFileCourseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalFileCourseConnectionSort>>;
  where?: InputMaybe<ExternalFileCourseConnectionWhere>;
};


export type ExternalFileDiscussionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalDiscussionBoardOptions>;
  where?: InputMaybe<ExternalDiscussionBoardWhere>;
};


export type ExternalFileDiscussionAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalDiscussionBoardWhere>;
};


export type ExternalFileDiscussionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalFileDiscussionConnectionSort>>;
  where?: InputMaybe<ExternalFileDiscussionConnectionWhere>;
};


export type ExternalFileDocumentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DocumentOptions>;
  where?: InputMaybe<DocumentWhere>;
};


export type ExternalFileDocumentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DocumentWhere>;
};


export type ExternalFileDocumentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalFileDocumentConnectionSort>>;
  where?: InputMaybe<ExternalFileDocumentConnectionWhere>;
};


export type ExternalFileInternalFileArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FileOptions>;
  where?: InputMaybe<FileWhere>;
};


export type ExternalFileInternalFileAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FileWhere>;
};


export type ExternalFileInternalFileConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalFileInternalFileConnectionSort>>;
  where?: InputMaybe<ExternalFileInternalFileConnectionWhere>;
};


export type ExternalFileModuleItemArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalModuleItemOptions>;
  where?: InputMaybe<ExternalModuleItemWhere>;
};


export type ExternalFileModuleItemAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalModuleItemWhere>;
};


export type ExternalFileModuleItemConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalFileModuleItemConnectionSort>>;
  where?: InputMaybe<ExternalFileModuleItemConnectionWhere>;
};


export type ExternalFilePageArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalPageOptions>;
  where?: InputMaybe<ExternalPageWhere>;
};


export type ExternalFilePageAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalPageWhere>;
};


export type ExternalFilePageConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalFilePageConnectionSort>>;
  where?: InputMaybe<ExternalFilePageConnectionWhere>;
};


export type ExternalFileQuizArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalQuizOptions>;
  where?: InputMaybe<ExternalQuizWhere>;
};


export type ExternalFileQuizAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalQuizWhere>;
};


export type ExternalFileQuizConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalFileQuizConnectionSort>>;
  where?: InputMaybe<ExternalFileQuizConnectionWhere>;
};


export type ExternalFileSubmissionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalSubmissionOptions>;
  where?: InputMaybe<ExternalSubmissionWhere>;
};


export type ExternalFileSubmissionAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalSubmissionWhere>;
};


export type ExternalFileSubmissionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalFileSubmissionConnectionSort>>;
  where?: InputMaybe<ExternalFileSubmissionConnectionWhere>;
};


export type ExternalFileUploadedByUserArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type ExternalFileUploadedByUserAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type ExternalFileUploadedByUserConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalFileUploadedByUserConnectionSort>>;
  where?: InputMaybe<ExternalFileUploadedByUserConnectionWhere>;
};

export type ExternalFileAnnouncementAggregateInput = {
  AND?: InputMaybe<Array<ExternalFileAnnouncementAggregateInput>>;
  NOT?: InputMaybe<ExternalFileAnnouncementAggregateInput>;
  OR?: InputMaybe<Array<ExternalFileAnnouncementAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalFileAnnouncementNodeAggregationWhereInput>;
};

export type ExternalFileAnnouncementConnectFieldInput = {
  connect?: InputMaybe<ExternalAnnouncementConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalAnnouncementConnectWhere>;
};

export type ExternalFileAnnouncementConnectOrCreateFieldInput = {
  onCreate: ExternalFileAnnouncementConnectOrCreateFieldInputOnCreate;
  where: ExternalAnnouncementConnectOrCreateWhere;
};

export type ExternalFileAnnouncementConnectOrCreateFieldInputOnCreate = {
  node: ExternalAnnouncementOnCreateInput;
};

export type ExternalFileAnnouncementConnection = {
  __typename?: 'ExternalFileAnnouncementConnection';
  edges: Array<ExternalFileAnnouncementRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalFileAnnouncementConnectionSort = {
  node?: InputMaybe<ExternalAnnouncementSort>;
};

export type ExternalFileAnnouncementConnectionWhere = {
  AND?: InputMaybe<Array<ExternalFileAnnouncementConnectionWhere>>;
  NOT?: InputMaybe<ExternalFileAnnouncementConnectionWhere>;
  OR?: InputMaybe<Array<ExternalFileAnnouncementConnectionWhere>>;
  node?: InputMaybe<ExternalAnnouncementWhere>;
};

export type ExternalFileAnnouncementCreateFieldInput = {
  node: ExternalAnnouncementCreateInput;
};

export type ExternalFileAnnouncementDeleteFieldInput = {
  delete?: InputMaybe<ExternalAnnouncementDeleteInput>;
  where?: InputMaybe<ExternalFileAnnouncementConnectionWhere>;
};

export type ExternalFileAnnouncementDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalAnnouncementDisconnectInput>;
  where?: InputMaybe<ExternalFileAnnouncementConnectionWhere>;
};

export type ExternalFileAnnouncementFieldInput = {
  connect?: InputMaybe<ExternalFileAnnouncementConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalFileAnnouncementConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalFileAnnouncementCreateFieldInput>;
};

export type ExternalFileAnnouncementNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalFileAnnouncementNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalFileAnnouncementNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalFileAnnouncementNodeAggregationWhereInput>>;
  bodyHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bodyText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  bodyText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  bodyText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  bodyText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  bodyText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  bodyText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bodyText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bodyText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bodyText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bodyText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  postedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  providerAnnouncementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerAnnouncementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerAnnouncementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerAnnouncementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerAnnouncementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerAnnouncementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalFileAnnouncementRelationship = {
  __typename?: 'ExternalFileAnnouncementRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalAnnouncement;
};

export type ExternalFileAnnouncementUpdateConnectionInput = {
  node?: InputMaybe<ExternalAnnouncementUpdateInput>;
};

export type ExternalFileAnnouncementUpdateFieldInput = {
  connect?: InputMaybe<ExternalFileAnnouncementConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalFileAnnouncementConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalFileAnnouncementCreateFieldInput>;
  delete?: InputMaybe<ExternalFileAnnouncementDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalFileAnnouncementDisconnectFieldInput>;
  update?: InputMaybe<ExternalFileAnnouncementUpdateConnectionInput>;
  where?: InputMaybe<ExternalFileAnnouncementConnectionWhere>;
};

export type ExternalFileAssignmentAggregateInput = {
  AND?: InputMaybe<Array<ExternalFileAssignmentAggregateInput>>;
  NOT?: InputMaybe<ExternalFileAssignmentAggregateInput>;
  OR?: InputMaybe<Array<ExternalFileAssignmentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalFileAssignmentNodeAggregationWhereInput>;
};

export type ExternalFileAssignmentConnectFieldInput = {
  connect?: InputMaybe<ExternalAssignmentConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalAssignmentConnectWhere>;
};

export type ExternalFileAssignmentConnectOrCreateFieldInput = {
  onCreate: ExternalFileAssignmentConnectOrCreateFieldInputOnCreate;
  where: ExternalAssignmentConnectOrCreateWhere;
};

export type ExternalFileAssignmentConnectOrCreateFieldInputOnCreate = {
  node: ExternalAssignmentOnCreateInput;
};

export type ExternalFileAssignmentConnection = {
  __typename?: 'ExternalFileAssignmentConnection';
  edges: Array<ExternalFileAssignmentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalFileAssignmentConnectionSort = {
  node?: InputMaybe<ExternalAssignmentSort>;
};

export type ExternalFileAssignmentConnectionWhere = {
  AND?: InputMaybe<Array<ExternalFileAssignmentConnectionWhere>>;
  NOT?: InputMaybe<ExternalFileAssignmentConnectionWhere>;
  OR?: InputMaybe<Array<ExternalFileAssignmentConnectionWhere>>;
  node?: InputMaybe<ExternalAssignmentWhere>;
};

export type ExternalFileAssignmentCreateFieldInput = {
  node: ExternalAssignmentCreateInput;
};

export type ExternalFileAssignmentDeleteFieldInput = {
  delete?: InputMaybe<ExternalAssignmentDeleteInput>;
  where?: InputMaybe<ExternalFileAssignmentConnectionWhere>;
};

export type ExternalFileAssignmentDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalAssignmentDisconnectInput>;
  where?: InputMaybe<ExternalFileAssignmentConnectionWhere>;
};

export type ExternalFileAssignmentFieldInput = {
  connect?: InputMaybe<ExternalFileAssignmentConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalFileAssignmentConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalFileAssignmentCreateFieldInput>;
};

export type ExternalFileAssignmentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalFileAssignmentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalFileAssignmentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalFileAssignmentNodeAggregationWhereInput>>;
  availableFrom_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  descriptionHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradingType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gradingType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gradingType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gradingType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gradingType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gradingType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gradingType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gradingType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gradingType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gradingType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gradingType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gradingType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gradingType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gradingType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gradingType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pointsPossible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerAssignmentId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerAssignmentId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerAssignmentId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerAssignmentId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerAssignmentId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalFileAssignmentRelationship = {
  __typename?: 'ExternalFileAssignmentRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalAssignment;
};

export type ExternalFileAssignmentUpdateConnectionInput = {
  node?: InputMaybe<ExternalAssignmentUpdateInput>;
};

export type ExternalFileAssignmentUpdateFieldInput = {
  connect?: InputMaybe<ExternalFileAssignmentConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalFileAssignmentConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalFileAssignmentCreateFieldInput>;
  delete?: InputMaybe<ExternalFileAssignmentDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalFileAssignmentDisconnectFieldInput>;
  update?: InputMaybe<ExternalFileAssignmentUpdateConnectionInput>;
  where?: InputMaybe<ExternalFileAssignmentConnectionWhere>;
};

export enum ExternalFileAttachedToType {
  Announcement = 'ANNOUNCEMENT',
  Assignment = 'ASSIGNMENT',
  Course = 'COURSE',
  Discussion = 'DISCUSSION',
  ModuleItem = 'MODULE_ITEM',
  Page = 'PAGE',
  Quiz = 'QUIZ',
  Submission = 'SUBMISSION'
}

export type ExternalFileConnectInput = {
  announcement?: InputMaybe<ExternalFileAnnouncementConnectFieldInput>;
  assignment?: InputMaybe<ExternalFileAssignmentConnectFieldInput>;
  course?: InputMaybe<ExternalFileCourseConnectFieldInput>;
  discussion?: InputMaybe<ExternalFileDiscussionConnectFieldInput>;
  document?: InputMaybe<ExternalFileDocumentConnectFieldInput>;
  internalFile?: InputMaybe<ExternalFileInternalFileConnectFieldInput>;
  moduleItem?: InputMaybe<ExternalFileModuleItemConnectFieldInput>;
  page?: InputMaybe<ExternalFilePageConnectFieldInput>;
  quiz?: InputMaybe<ExternalFileQuizConnectFieldInput>;
  submission?: InputMaybe<ExternalFileSubmissionConnectFieldInput>;
  uploadedByUser?: InputMaybe<ExternalFileUploadedByUserConnectFieldInput>;
};

export type ExternalFileConnectOrCreateWhere = {
  node: ExternalFileUniqueWhere;
};

export type ExternalFileConnectWhere = {
  node: ExternalFileWhere;
};

export type ExternalFileCourseAggregateInput = {
  AND?: InputMaybe<Array<ExternalFileCourseAggregateInput>>;
  NOT?: InputMaybe<ExternalFileCourseAggregateInput>;
  OR?: InputMaybe<Array<ExternalFileCourseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalFileCourseNodeAggregationWhereInput>;
};

export type ExternalFileCourseConnectFieldInput = {
  connect?: InputMaybe<ExternalCourseConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalCourseConnectWhere>;
};

export type ExternalFileCourseConnectOrCreateFieldInput = {
  onCreate: ExternalFileCourseConnectOrCreateFieldInputOnCreate;
  where: ExternalCourseConnectOrCreateWhere;
};

export type ExternalFileCourseConnectOrCreateFieldInputOnCreate = {
  node: ExternalCourseOnCreateInput;
};

export type ExternalFileCourseConnection = {
  __typename?: 'ExternalFileCourseConnection';
  edges: Array<ExternalFileCourseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalFileCourseConnectionSort = {
  node?: InputMaybe<ExternalCourseSort>;
};

export type ExternalFileCourseConnectionWhere = {
  AND?: InputMaybe<Array<ExternalFileCourseConnectionWhere>>;
  NOT?: InputMaybe<ExternalFileCourseConnectionWhere>;
  OR?: InputMaybe<Array<ExternalFileCourseConnectionWhere>>;
  node?: InputMaybe<ExternalCourseWhere>;
};

export type ExternalFileCourseCreateFieldInput = {
  node: ExternalCourseCreateInput;
};

export type ExternalFileCourseDeleteFieldInput = {
  delete?: InputMaybe<ExternalCourseDeleteInput>;
  where?: InputMaybe<ExternalFileCourseConnectionWhere>;
};

export type ExternalFileCourseDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalCourseDisconnectInput>;
  where?: InputMaybe<ExternalFileCourseConnectionWhere>;
};

export type ExternalFileCourseFieldInput = {
  connect?: InputMaybe<ExternalFileCourseConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalFileCourseConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalFileCourseCreateFieldInput>;
};

export type ExternalFileCourseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalFileCourseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalFileCourseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalFileCourseNodeAggregationWhereInput>>;
  courseCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  courseCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  courseCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  courseCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  courseCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  endDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalFileCourseRelationship = {
  __typename?: 'ExternalFileCourseRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalCourse;
};

export type ExternalFileCourseUpdateConnectionInput = {
  node?: InputMaybe<ExternalCourseUpdateInput>;
};

export type ExternalFileCourseUpdateFieldInput = {
  connect?: InputMaybe<ExternalFileCourseConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalFileCourseConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalFileCourseCreateFieldInput>;
  delete?: InputMaybe<ExternalFileCourseDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalFileCourseDisconnectFieldInput>;
  update?: InputMaybe<ExternalFileCourseUpdateConnectionInput>;
  where?: InputMaybe<ExternalFileCourseConnectionWhere>;
};

export type ExternalFileCreateInput = {
  announcement?: InputMaybe<ExternalFileAnnouncementFieldInput>;
  assignment?: InputMaybe<ExternalFileAssignmentFieldInput>;
  attachedToId: Scalars['String']['input'];
  attachedToType: ExternalFileAttachedToType;
  course?: InputMaybe<ExternalFileCourseFieldInput>;
  discussion?: InputMaybe<ExternalFileDiscussionFieldInput>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  document?: InputMaybe<ExternalFileDocumentFieldInput>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  internalFile?: InputMaybe<ExternalFileInternalFileFieldInput>;
  lmsSource: LmsSource;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  moduleItem?: InputMaybe<ExternalFileModuleItemFieldInput>;
  page?: InputMaybe<ExternalFilePageFieldInput>;
  previewUrl?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerCourseId: Scalars['String']['input'];
  providerFileId: Scalars['String']['input'];
  providerKey: Scalars['String']['input'];
  quiz?: InputMaybe<ExternalFileQuizFieldInput>;
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  submission?: InputMaybe<ExternalFileSubmissionFieldInput>;
  syncedAt: Scalars['DateTime']['input'];
  uploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedBy?: InputMaybe<Scalars['String']['input']>;
  uploadedByUser?: InputMaybe<ExternalFileUploadedByUserFieldInput>;
  visibility: ExternalFileVisibility;
};

export type ExternalFileDeleteInput = {
  announcement?: InputMaybe<ExternalFileAnnouncementDeleteFieldInput>;
  assignment?: InputMaybe<ExternalFileAssignmentDeleteFieldInput>;
  course?: InputMaybe<ExternalFileCourseDeleteFieldInput>;
  discussion?: InputMaybe<ExternalFileDiscussionDeleteFieldInput>;
  document?: InputMaybe<ExternalFileDocumentDeleteFieldInput>;
  internalFile?: InputMaybe<ExternalFileInternalFileDeleteFieldInput>;
  moduleItem?: InputMaybe<ExternalFileModuleItemDeleteFieldInput>;
  page?: InputMaybe<ExternalFilePageDeleteFieldInput>;
  quiz?: InputMaybe<ExternalFileQuizDeleteFieldInput>;
  submission?: InputMaybe<ExternalFileSubmissionDeleteFieldInput>;
  uploadedByUser?: InputMaybe<ExternalFileUploadedByUserDeleteFieldInput>;
};

export type ExternalFileDisconnectInput = {
  announcement?: InputMaybe<ExternalFileAnnouncementDisconnectFieldInput>;
  assignment?: InputMaybe<ExternalFileAssignmentDisconnectFieldInput>;
  course?: InputMaybe<ExternalFileCourseDisconnectFieldInput>;
  discussion?: InputMaybe<ExternalFileDiscussionDisconnectFieldInput>;
  document?: InputMaybe<ExternalFileDocumentDisconnectFieldInput>;
  internalFile?: InputMaybe<ExternalFileInternalFileDisconnectFieldInput>;
  moduleItem?: InputMaybe<ExternalFileModuleItemDisconnectFieldInput>;
  page?: InputMaybe<ExternalFilePageDisconnectFieldInput>;
  quiz?: InputMaybe<ExternalFileQuizDisconnectFieldInput>;
  submission?: InputMaybe<ExternalFileSubmissionDisconnectFieldInput>;
  uploadedByUser?: InputMaybe<ExternalFileUploadedByUserDisconnectFieldInput>;
};

export type ExternalFileDiscussionAggregateInput = {
  AND?: InputMaybe<Array<ExternalFileDiscussionAggregateInput>>;
  NOT?: InputMaybe<ExternalFileDiscussionAggregateInput>;
  OR?: InputMaybe<Array<ExternalFileDiscussionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalFileDiscussionNodeAggregationWhereInput>;
};

export type ExternalFileDiscussionConnectFieldInput = {
  connect?: InputMaybe<ExternalDiscussionBoardConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalDiscussionBoardConnectWhere>;
};

export type ExternalFileDiscussionConnectOrCreateFieldInput = {
  onCreate: ExternalFileDiscussionConnectOrCreateFieldInputOnCreate;
  where: ExternalDiscussionBoardConnectOrCreateWhere;
};

export type ExternalFileDiscussionConnectOrCreateFieldInputOnCreate = {
  node: ExternalDiscussionBoardOnCreateInput;
};

export type ExternalFileDiscussionConnection = {
  __typename?: 'ExternalFileDiscussionConnection';
  edges: Array<ExternalFileDiscussionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalFileDiscussionConnectionSort = {
  node?: InputMaybe<ExternalDiscussionBoardSort>;
};

export type ExternalFileDiscussionConnectionWhere = {
  AND?: InputMaybe<Array<ExternalFileDiscussionConnectionWhere>>;
  NOT?: InputMaybe<ExternalFileDiscussionConnectionWhere>;
  OR?: InputMaybe<Array<ExternalFileDiscussionConnectionWhere>>;
  node?: InputMaybe<ExternalDiscussionBoardWhere>;
};

export type ExternalFileDiscussionCreateFieldInput = {
  node: ExternalDiscussionBoardCreateInput;
};

export type ExternalFileDiscussionDeleteFieldInput = {
  delete?: InputMaybe<ExternalDiscussionBoardDeleteInput>;
  where?: InputMaybe<ExternalFileDiscussionConnectionWhere>;
};

export type ExternalFileDiscussionDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalDiscussionBoardDisconnectInput>;
  where?: InputMaybe<ExternalFileDiscussionConnectionWhere>;
};

export type ExternalFileDiscussionFieldInput = {
  connect?: InputMaybe<ExternalFileDiscussionConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalFileDiscussionConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalFileDiscussionCreateFieldInput>;
};

export type ExternalFileDiscussionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalFileDiscussionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalFileDiscussionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalFileDiscussionNodeAggregationWhereInput>>;
  availableFrom_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  messageHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  messageHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  messageHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  messageHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  messageHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  messageHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  messageText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  messageText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  messageText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  messageText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  messageText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  messageText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  messageText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  messageText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  messageText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  messageText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  messageText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  messageText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  messageText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  messageText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  messageText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pointsPossible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerDiscussionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerDiscussionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerDiscussionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerDiscussionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerDiscussionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalFileDiscussionRelationship = {
  __typename?: 'ExternalFileDiscussionRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalDiscussionBoard;
};

export type ExternalFileDiscussionUpdateConnectionInput = {
  node?: InputMaybe<ExternalDiscussionBoardUpdateInput>;
};

export type ExternalFileDiscussionUpdateFieldInput = {
  connect?: InputMaybe<ExternalFileDiscussionConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalFileDiscussionConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalFileDiscussionCreateFieldInput>;
  delete?: InputMaybe<ExternalFileDiscussionDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalFileDiscussionDisconnectFieldInput>;
  update?: InputMaybe<ExternalFileDiscussionUpdateConnectionInput>;
  where?: InputMaybe<ExternalFileDiscussionConnectionWhere>;
};

export type ExternalFileDocumentAggregateInput = {
  AND?: InputMaybe<Array<ExternalFileDocumentAggregateInput>>;
  NOT?: InputMaybe<ExternalFileDocumentAggregateInput>;
  OR?: InputMaybe<Array<ExternalFileDocumentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalFileDocumentNodeAggregationWhereInput>;
};

export type ExternalFileDocumentConnectFieldInput = {
  connect?: InputMaybe<DocumentConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DocumentConnectWhere>;
};

export type ExternalFileDocumentConnection = {
  __typename?: 'ExternalFileDocumentConnection';
  edges: Array<ExternalFileDocumentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalFileDocumentConnectionSort = {
  node?: InputMaybe<DocumentSort>;
};

export type ExternalFileDocumentConnectionWhere = {
  AND?: InputMaybe<Array<ExternalFileDocumentConnectionWhere>>;
  NOT?: InputMaybe<ExternalFileDocumentConnectionWhere>;
  OR?: InputMaybe<Array<ExternalFileDocumentConnectionWhere>>;
  node?: InputMaybe<DocumentWhere>;
};

export type ExternalFileDocumentCreateFieldInput = {
  node: DocumentCreateInput;
};

export type ExternalFileDocumentDeleteFieldInput = {
  delete?: InputMaybe<DocumentDeleteInput>;
  where?: InputMaybe<ExternalFileDocumentConnectionWhere>;
};

export type ExternalFileDocumentDisconnectFieldInput = {
  disconnect?: InputMaybe<DocumentDisconnectInput>;
  where?: InputMaybe<ExternalFileDocumentConnectionWhere>;
};

export type ExternalFileDocumentDocumentAggregationSelection = {
  __typename?: 'ExternalFileDocumentDocumentAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalFileDocumentDocumentNodeAggregateSelection>;
};

export type ExternalFileDocumentDocumentNodeAggregateSelection = {
  __typename?: 'ExternalFileDocumentDocumentNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  summary: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type ExternalFileDocumentFieldInput = {
  connect?: InputMaybe<ExternalFileDocumentConnectFieldInput>;
  create?: InputMaybe<ExternalFileDocumentCreateFieldInput>;
};

export type ExternalFileDocumentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalFileDocumentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalFileDocumentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalFileDocumentNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  summary_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  summary_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalFileDocumentRelationship = {
  __typename?: 'ExternalFileDocumentRelationship';
  cursor: Scalars['String']['output'];
  node: Document;
};

export type ExternalFileDocumentUpdateConnectionInput = {
  node?: InputMaybe<DocumentUpdateInput>;
};

export type ExternalFileDocumentUpdateFieldInput = {
  connect?: InputMaybe<ExternalFileDocumentConnectFieldInput>;
  create?: InputMaybe<ExternalFileDocumentCreateFieldInput>;
  delete?: InputMaybe<ExternalFileDocumentDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalFileDocumentDisconnectFieldInput>;
  update?: InputMaybe<ExternalFileDocumentUpdateConnectionInput>;
  where?: InputMaybe<ExternalFileDocumentConnectionWhere>;
};

export type ExternalFileExternalAnnouncementAnnouncementAggregationSelection = {
  __typename?: 'ExternalFileExternalAnnouncementAnnouncementAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalFileExternalAnnouncementAnnouncementNodeAggregateSelection>;
};

export type ExternalFileExternalAnnouncementAnnouncementNodeAggregateSelection = {
  __typename?: 'ExternalFileExternalAnnouncementAnnouncementNodeAggregateSelection';
  bodyHtml: StringAggregateSelection;
  bodyText: StringAggregateSelection;
  id: IdAggregateSelection;
  postedAt: DateTimeAggregateSelection;
  providerAnnouncementId: StringAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  title: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalFileExternalAssignmentAssignmentAggregationSelection = {
  __typename?: 'ExternalFileExternalAssignmentAssignmentAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalFileExternalAssignmentAssignmentNodeAggregateSelection>;
};

export type ExternalFileExternalAssignmentAssignmentNodeAggregateSelection = {
  __typename?: 'ExternalFileExternalAssignmentAssignmentNodeAggregateSelection';
  availableFrom: DateTimeAggregateSelection;
  availableUntil: DateTimeAggregateSelection;
  descriptionHtml: StringAggregateSelection;
  descriptionText: StringAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  gradingType: StringAggregateSelection;
  id: IdAggregateSelection;
  pointsPossible: FloatAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerAssignmentId: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  title: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalFileExternalCourseCourseAggregationSelection = {
  __typename?: 'ExternalFileExternalCourseCourseAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalFileExternalCourseCourseNodeAggregateSelection>;
};

export type ExternalFileExternalCourseCourseNodeAggregateSelection = {
  __typename?: 'ExternalFileExternalCourseCourseNodeAggregateSelection';
  courseCode: StringAggregateSelection;
  descriptionHtml: StringAggregateSelection;
  descriptionText: StringAggregateSelection;
  endDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  name: StringAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  startDate: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalFileExternalDiscussionBoardDiscussionAggregationSelection = {
  __typename?: 'ExternalFileExternalDiscussionBoardDiscussionAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalFileExternalDiscussionBoardDiscussionNodeAggregateSelection>;
};

export type ExternalFileExternalDiscussionBoardDiscussionNodeAggregateSelection = {
  __typename?: 'ExternalFileExternalDiscussionBoardDiscussionNodeAggregateSelection';
  availableFrom: DateTimeAggregateSelection;
  availableUntil: DateTimeAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  messageHtml: StringAggregateSelection;
  messageText: StringAggregateSelection;
  pointsPossible: FloatAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerDiscussionId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  title: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalFileExternalModuleItemModuleItemAggregationSelection = {
  __typename?: 'ExternalFileExternalModuleItemModuleItemAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalFileExternalModuleItemModuleItemNodeAggregateSelection>;
};

export type ExternalFileExternalModuleItemModuleItemNodeAggregateSelection = {
  __typename?: 'ExternalFileExternalModuleItemModuleItemNodeAggregateSelection';
  externalUrl: StringAggregateSelection;
  id: IdAggregateSelection;
  position: IntAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  providerModuleId: StringAggregateSelection;
  providerModuleItemId: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  title: StringAggregateSelection;
};

export type ExternalFileExternalPagePageAggregationSelection = {
  __typename?: 'ExternalFileExternalPagePageAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalFileExternalPagePageNodeAggregateSelection>;
};

export type ExternalFileExternalPagePageNodeAggregateSelection = {
  __typename?: 'ExternalFileExternalPagePageNodeAggregateSelection';
  bodyHtml: StringAggregateSelection;
  bodyText: StringAggregateSelection;
  id: IdAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  providerPageId: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  title: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalFileExternalQuizQuizAggregationSelection = {
  __typename?: 'ExternalFileExternalQuizQuizAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalFileExternalQuizQuizNodeAggregateSelection>;
};

export type ExternalFileExternalQuizQuizNodeAggregateSelection = {
  __typename?: 'ExternalFileExternalQuizQuizNodeAggregateSelection';
  attemptsAllowed: IntAggregateSelection;
  availableFrom: DateTimeAggregateSelection;
  availableUntil: DateTimeAggregateSelection;
  descriptionHtml: StringAggregateSelection;
  descriptionText: StringAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  pointsPossible: FloatAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  providerQuizId: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  timeLimitMinutes: IntAggregateSelection;
  title: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalFileExternalSubmissionSubmissionAggregationSelection = {
  __typename?: 'ExternalFileExternalSubmissionSubmissionAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalFileExternalSubmissionSubmissionNodeAggregateSelection>;
};

export type ExternalFileExternalSubmissionSubmissionNodeAggregateSelection = {
  __typename?: 'ExternalFileExternalSubmissionSubmissionNodeAggregateSelection';
  gradeText: StringAggregateSelection;
  gradedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  pointsPossible: FloatAggregateSelection;
  providerContentId: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  providerUserId: StringAggregateSelection;
  score: FloatAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  submittedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
};

export type ExternalFileFileInternalFileAggregationSelection = {
  __typename?: 'ExternalFileFileInternalFileAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalFileFileInternalFileNodeAggregateSelection>;
};

export type ExternalFileFileInternalFileNodeAggregateSelection = {
  __typename?: 'ExternalFileFileInternalFileNodeAggregateSelection';
  bucketName: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  fileName: StringAggregateSelection;
  filePath: StringAggregateSelection;
  fileURL: StringAggregateSelection;
  id: IdAggregateSelection;
};

export type ExternalFileInternalFileAggregateInput = {
  AND?: InputMaybe<Array<ExternalFileInternalFileAggregateInput>>;
  NOT?: InputMaybe<ExternalFileInternalFileAggregateInput>;
  OR?: InputMaybe<Array<ExternalFileInternalFileAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalFileInternalFileNodeAggregationWhereInput>;
};

export type ExternalFileInternalFileConnectFieldInput = {
  connect?: InputMaybe<FileConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FileConnectWhere>;
};

export type ExternalFileInternalFileConnectOrCreateFieldInput = {
  onCreate: ExternalFileInternalFileConnectOrCreateFieldInputOnCreate;
  where: FileConnectOrCreateWhere;
};

export type ExternalFileInternalFileConnectOrCreateFieldInputOnCreate = {
  node: FileOnCreateInput;
};

export type ExternalFileInternalFileConnection = {
  __typename?: 'ExternalFileInternalFileConnection';
  edges: Array<ExternalFileInternalFileRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalFileInternalFileConnectionSort = {
  node?: InputMaybe<FileSort>;
};

export type ExternalFileInternalFileConnectionWhere = {
  AND?: InputMaybe<Array<ExternalFileInternalFileConnectionWhere>>;
  NOT?: InputMaybe<ExternalFileInternalFileConnectionWhere>;
  OR?: InputMaybe<Array<ExternalFileInternalFileConnectionWhere>>;
  node?: InputMaybe<FileWhere>;
};

export type ExternalFileInternalFileCreateFieldInput = {
  node: FileCreateInput;
};

export type ExternalFileInternalFileDeleteFieldInput = {
  delete?: InputMaybe<FileDeleteInput>;
  where?: InputMaybe<ExternalFileInternalFileConnectionWhere>;
};

export type ExternalFileInternalFileDisconnectFieldInput = {
  disconnect?: InputMaybe<FileDisconnectInput>;
  where?: InputMaybe<ExternalFileInternalFileConnectionWhere>;
};

export type ExternalFileInternalFileFieldInput = {
  connect?: InputMaybe<ExternalFileInternalFileConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalFileInternalFileConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalFileInternalFileCreateFieldInput>;
};

export type ExternalFileInternalFileNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalFileInternalFileNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalFileInternalFileNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalFileInternalFileNodeAggregationWhereInput>>;
  bucketName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  bucketName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  fileName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileURL_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalFileInternalFileRelationship = {
  __typename?: 'ExternalFileInternalFileRelationship';
  cursor: Scalars['String']['output'];
  node: File;
};

export type ExternalFileInternalFileUpdateConnectionInput = {
  node?: InputMaybe<FileUpdateInput>;
};

export type ExternalFileInternalFileUpdateFieldInput = {
  connect?: InputMaybe<ExternalFileInternalFileConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalFileInternalFileConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalFileInternalFileCreateFieldInput>;
  delete?: InputMaybe<ExternalFileInternalFileDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalFileInternalFileDisconnectFieldInput>;
  update?: InputMaybe<ExternalFileInternalFileUpdateConnectionInput>;
  where?: InputMaybe<ExternalFileInternalFileConnectionWhere>;
};

export type ExternalFileModuleItemAggregateInput = {
  AND?: InputMaybe<Array<ExternalFileModuleItemAggregateInput>>;
  NOT?: InputMaybe<ExternalFileModuleItemAggregateInput>;
  OR?: InputMaybe<Array<ExternalFileModuleItemAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalFileModuleItemNodeAggregationWhereInput>;
};

export type ExternalFileModuleItemConnectFieldInput = {
  connect?: InputMaybe<ExternalModuleItemConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalModuleItemConnectWhere>;
};

export type ExternalFileModuleItemConnectOrCreateFieldInput = {
  onCreate: ExternalFileModuleItemConnectOrCreateFieldInputOnCreate;
  where: ExternalModuleItemConnectOrCreateWhere;
};

export type ExternalFileModuleItemConnectOrCreateFieldInputOnCreate = {
  node: ExternalModuleItemOnCreateInput;
};

export type ExternalFileModuleItemConnection = {
  __typename?: 'ExternalFileModuleItemConnection';
  edges: Array<ExternalFileModuleItemRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalFileModuleItemConnectionSort = {
  node?: InputMaybe<ExternalModuleItemSort>;
};

export type ExternalFileModuleItemConnectionWhere = {
  AND?: InputMaybe<Array<ExternalFileModuleItemConnectionWhere>>;
  NOT?: InputMaybe<ExternalFileModuleItemConnectionWhere>;
  OR?: InputMaybe<Array<ExternalFileModuleItemConnectionWhere>>;
  node?: InputMaybe<ExternalModuleItemWhere>;
};

export type ExternalFileModuleItemCreateFieldInput = {
  node: ExternalModuleItemCreateInput;
};

export type ExternalFileModuleItemDeleteFieldInput = {
  delete?: InputMaybe<ExternalModuleItemDeleteInput>;
  where?: InputMaybe<ExternalFileModuleItemConnectionWhere>;
};

export type ExternalFileModuleItemDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalModuleItemDisconnectInput>;
  where?: InputMaybe<ExternalFileModuleItemConnectionWhere>;
};

export type ExternalFileModuleItemFieldInput = {
  connect?: InputMaybe<ExternalFileModuleItemConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalFileModuleItemConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalFileModuleItemCreateFieldInput>;
};

export type ExternalFileModuleItemNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalFileModuleItemNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalFileModuleItemNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalFileModuleItemNodeAggregationWhereInput>>;
  externalUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerModuleId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerModuleId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerModuleId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerModuleId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerModuleId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerModuleItemId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerModuleItemId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerModuleItemId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerModuleItemId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerModuleItemId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerModuleItemId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerModuleItemId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerModuleItemId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerModuleItemId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerModuleItemId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerModuleItemId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerModuleItemId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerModuleItemId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerModuleItemId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerModuleItemId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalFileModuleItemRelationship = {
  __typename?: 'ExternalFileModuleItemRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalModuleItem;
};

export type ExternalFileModuleItemUpdateConnectionInput = {
  node?: InputMaybe<ExternalModuleItemUpdateInput>;
};

export type ExternalFileModuleItemUpdateFieldInput = {
  connect?: InputMaybe<ExternalFileModuleItemConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalFileModuleItemConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalFileModuleItemCreateFieldInput>;
  delete?: InputMaybe<ExternalFileModuleItemDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalFileModuleItemDisconnectFieldInput>;
  update?: InputMaybe<ExternalFileModuleItemUpdateConnectionInput>;
  where?: InputMaybe<ExternalFileModuleItemConnectionWhere>;
};

export type ExternalFileOnCreateInput = {
  attachedToId: Scalars['String']['input'];
  attachedToType: ExternalFileAttachedToType;
  displayName?: InputMaybe<Scalars['String']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  lmsSource: LmsSource;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  previewUrl?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerCourseId: Scalars['String']['input'];
  providerFileId: Scalars['String']['input'];
  providerKey: Scalars['String']['input'];
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt: Scalars['DateTime']['input'];
  uploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedBy?: InputMaybe<Scalars['String']['input']>;
  visibility: ExternalFileVisibility;
};

export type ExternalFileOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ExternalFileSort objects to sort ExternalFiles by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ExternalFileSort>>;
};

export type ExternalFilePageAggregateInput = {
  AND?: InputMaybe<Array<ExternalFilePageAggregateInput>>;
  NOT?: InputMaybe<ExternalFilePageAggregateInput>;
  OR?: InputMaybe<Array<ExternalFilePageAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalFilePageNodeAggregationWhereInput>;
};

export type ExternalFilePageConnectFieldInput = {
  connect?: InputMaybe<ExternalPageConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalPageConnectWhere>;
};

export type ExternalFilePageConnectOrCreateFieldInput = {
  onCreate: ExternalFilePageConnectOrCreateFieldInputOnCreate;
  where: ExternalPageConnectOrCreateWhere;
};

export type ExternalFilePageConnectOrCreateFieldInputOnCreate = {
  node: ExternalPageOnCreateInput;
};

export type ExternalFilePageConnection = {
  __typename?: 'ExternalFilePageConnection';
  edges: Array<ExternalFilePageRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalFilePageConnectionSort = {
  node?: InputMaybe<ExternalPageSort>;
};

export type ExternalFilePageConnectionWhere = {
  AND?: InputMaybe<Array<ExternalFilePageConnectionWhere>>;
  NOT?: InputMaybe<ExternalFilePageConnectionWhere>;
  OR?: InputMaybe<Array<ExternalFilePageConnectionWhere>>;
  node?: InputMaybe<ExternalPageWhere>;
};

export type ExternalFilePageCreateFieldInput = {
  node: ExternalPageCreateInput;
};

export type ExternalFilePageDeleteFieldInput = {
  delete?: InputMaybe<ExternalPageDeleteInput>;
  where?: InputMaybe<ExternalFilePageConnectionWhere>;
};

export type ExternalFilePageDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalPageDisconnectInput>;
  where?: InputMaybe<ExternalFilePageConnectionWhere>;
};

export type ExternalFilePageFieldInput = {
  connect?: InputMaybe<ExternalFilePageConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalFilePageConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalFilePageCreateFieldInput>;
};

export type ExternalFilePageNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalFilePageNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalFilePageNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalFilePageNodeAggregationWhereInput>>;
  bodyHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bodyText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  bodyText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  bodyText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  bodyText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  bodyText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  bodyText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bodyText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bodyText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bodyText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bodyText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerPageId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerPageId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerPageId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerPageId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerPageId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerPageId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerPageId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerPageId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerPageId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerPageId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerPageId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerPageId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerPageId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerPageId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerPageId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalFilePageRelationship = {
  __typename?: 'ExternalFilePageRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalPage;
};

export type ExternalFilePageUpdateConnectionInput = {
  node?: InputMaybe<ExternalPageUpdateInput>;
};

export type ExternalFilePageUpdateFieldInput = {
  connect?: InputMaybe<ExternalFilePageConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalFilePageConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalFilePageCreateFieldInput>;
  delete?: InputMaybe<ExternalFilePageDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalFilePageDisconnectFieldInput>;
  update?: InputMaybe<ExternalFilePageUpdateConnectionInput>;
  where?: InputMaybe<ExternalFilePageConnectionWhere>;
};

export type ExternalFileQuizAggregateInput = {
  AND?: InputMaybe<Array<ExternalFileQuizAggregateInput>>;
  NOT?: InputMaybe<ExternalFileQuizAggregateInput>;
  OR?: InputMaybe<Array<ExternalFileQuizAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalFileQuizNodeAggregationWhereInput>;
};

export type ExternalFileQuizConnectFieldInput = {
  connect?: InputMaybe<ExternalQuizConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalQuizConnectWhere>;
};

export type ExternalFileQuizConnectOrCreateFieldInput = {
  onCreate: ExternalFileQuizConnectOrCreateFieldInputOnCreate;
  where: ExternalQuizConnectOrCreateWhere;
};

export type ExternalFileQuizConnectOrCreateFieldInputOnCreate = {
  node: ExternalQuizOnCreateInput;
};

export type ExternalFileQuizConnection = {
  __typename?: 'ExternalFileQuizConnection';
  edges: Array<ExternalFileQuizRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalFileQuizConnectionSort = {
  node?: InputMaybe<ExternalQuizSort>;
};

export type ExternalFileQuizConnectionWhere = {
  AND?: InputMaybe<Array<ExternalFileQuizConnectionWhere>>;
  NOT?: InputMaybe<ExternalFileQuizConnectionWhere>;
  OR?: InputMaybe<Array<ExternalFileQuizConnectionWhere>>;
  node?: InputMaybe<ExternalQuizWhere>;
};

export type ExternalFileQuizCreateFieldInput = {
  node: ExternalQuizCreateInput;
};

export type ExternalFileQuizDeleteFieldInput = {
  delete?: InputMaybe<ExternalQuizDeleteInput>;
  where?: InputMaybe<ExternalFileQuizConnectionWhere>;
};

export type ExternalFileQuizDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalQuizDisconnectInput>;
  where?: InputMaybe<ExternalFileQuizConnectionWhere>;
};

export type ExternalFileQuizFieldInput = {
  connect?: InputMaybe<ExternalFileQuizConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalFileQuizConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalFileQuizCreateFieldInput>;
};

export type ExternalFileQuizNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalFileQuizNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalFileQuizNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalFileQuizNodeAggregationWhereInput>>;
  attemptsAllowed_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  attemptsAllowed_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  attemptsAllowed_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  attemptsAllowed_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  attemptsAllowed_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  attemptsAllowed_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  availableFrom_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  descriptionHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pointsPossible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerQuizId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerQuizId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerQuizId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerQuizId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerQuizId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  timeLimitMinutes_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeLimitMinutes_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeLimitMinutes_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimitMinutes_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeLimitMinutes_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimitMinutes_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalFileQuizRelationship = {
  __typename?: 'ExternalFileQuizRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalQuiz;
};

export type ExternalFileQuizUpdateConnectionInput = {
  node?: InputMaybe<ExternalQuizUpdateInput>;
};

export type ExternalFileQuizUpdateFieldInput = {
  connect?: InputMaybe<ExternalFileQuizConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalFileQuizConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalFileQuizCreateFieldInput>;
  delete?: InputMaybe<ExternalFileQuizDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalFileQuizDisconnectFieldInput>;
  update?: InputMaybe<ExternalFileQuizUpdateConnectionInput>;
  where?: InputMaybe<ExternalFileQuizConnectionWhere>;
};

/** Fields to sort ExternalFiles by. The order in which sorts are applied is not guaranteed when specifying many fields in one ExternalFileSort object. */
export type ExternalFileSort = {
  attachedToId?: InputMaybe<SortDirection>;
  attachedToType?: InputMaybe<SortDirection>;
  displayName?: InputMaybe<SortDirection>;
  downloadUrl?: InputMaybe<SortDirection>;
  fileName?: InputMaybe<SortDirection>;
  fileSize?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lmsSource?: InputMaybe<SortDirection>;
  mimeType?: InputMaybe<SortDirection>;
  modifiedAt?: InputMaybe<SortDirection>;
  previewUrl?: InputMaybe<SortDirection>;
  providerApiUrl?: InputMaybe<SortDirection>;
  providerCourseId?: InputMaybe<SortDirection>;
  providerFileId?: InputMaybe<SortDirection>;
  providerKey?: InputMaybe<SortDirection>;
  sourceMeta?: InputMaybe<SortDirection>;
  sourcePayload?: InputMaybe<SortDirection>;
  sourceUpdatedAt?: InputMaybe<SortDirection>;
  syncedAt?: InputMaybe<SortDirection>;
  uploadedAt?: InputMaybe<SortDirection>;
  uploadedBy?: InputMaybe<SortDirection>;
  visibility?: InputMaybe<SortDirection>;
};

export type ExternalFileSubmissionAggregateInput = {
  AND?: InputMaybe<Array<ExternalFileSubmissionAggregateInput>>;
  NOT?: InputMaybe<ExternalFileSubmissionAggregateInput>;
  OR?: InputMaybe<Array<ExternalFileSubmissionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalFileSubmissionNodeAggregationWhereInput>;
};

export type ExternalFileSubmissionConnectFieldInput = {
  connect?: InputMaybe<ExternalSubmissionConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalSubmissionConnectWhere>;
};

export type ExternalFileSubmissionConnectOrCreateFieldInput = {
  onCreate: ExternalFileSubmissionConnectOrCreateFieldInputOnCreate;
  where: ExternalSubmissionConnectOrCreateWhere;
};

export type ExternalFileSubmissionConnectOrCreateFieldInputOnCreate = {
  node: ExternalSubmissionOnCreateInput;
};

export type ExternalFileSubmissionConnection = {
  __typename?: 'ExternalFileSubmissionConnection';
  edges: Array<ExternalFileSubmissionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalFileSubmissionConnectionSort = {
  node?: InputMaybe<ExternalSubmissionSort>;
};

export type ExternalFileSubmissionConnectionWhere = {
  AND?: InputMaybe<Array<ExternalFileSubmissionConnectionWhere>>;
  NOT?: InputMaybe<ExternalFileSubmissionConnectionWhere>;
  OR?: InputMaybe<Array<ExternalFileSubmissionConnectionWhere>>;
  node?: InputMaybe<ExternalSubmissionWhere>;
};

export type ExternalFileSubmissionCreateFieldInput = {
  node: ExternalSubmissionCreateInput;
};

export type ExternalFileSubmissionDeleteFieldInput = {
  delete?: InputMaybe<ExternalSubmissionDeleteInput>;
  where?: InputMaybe<ExternalFileSubmissionConnectionWhere>;
};

export type ExternalFileSubmissionDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalSubmissionDisconnectInput>;
  where?: InputMaybe<ExternalFileSubmissionConnectionWhere>;
};

export type ExternalFileSubmissionFieldInput = {
  connect?: InputMaybe<ExternalFileSubmissionConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalFileSubmissionConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalFileSubmissionCreateFieldInput>;
};

export type ExternalFileSubmissionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalFileSubmissionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalFileSubmissionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalFileSubmissionNodeAggregationWhereInput>>;
  gradeText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gradeText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gradeText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gradeText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gradeText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gradeText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gradeText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gradeText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gradeText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gradeText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gradeText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gradeText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gradeText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gradeText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gradeText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gradedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pointsPossible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerContentId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerContentId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerContentId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerContentId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerContentId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerContentId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  score_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  score_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  score_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  score_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  score_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  score_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  score_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  score_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  score_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  score_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  score_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  score_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  score_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  score_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  score_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  score_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  score_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  score_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  score_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  score_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ExternalFileSubmissionRelationship = {
  __typename?: 'ExternalFileSubmissionRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalSubmission;
};

export type ExternalFileSubmissionUpdateConnectionInput = {
  node?: InputMaybe<ExternalSubmissionUpdateInput>;
};

export type ExternalFileSubmissionUpdateFieldInput = {
  connect?: InputMaybe<ExternalFileSubmissionConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalFileSubmissionConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalFileSubmissionCreateFieldInput>;
  delete?: InputMaybe<ExternalFileSubmissionDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalFileSubmissionDisconnectFieldInput>;
  update?: InputMaybe<ExternalFileSubmissionUpdateConnectionInput>;
  where?: InputMaybe<ExternalFileSubmissionConnectionWhere>;
};

export type ExternalFileUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalFileUpdateInput = {
  announcement?: InputMaybe<ExternalFileAnnouncementUpdateFieldInput>;
  assignment?: InputMaybe<ExternalFileAssignmentUpdateFieldInput>;
  attachedToId?: InputMaybe<Scalars['String']['input']>;
  attachedToType?: InputMaybe<ExternalFileAttachedToType>;
  course?: InputMaybe<ExternalFileCourseUpdateFieldInput>;
  discussion?: InputMaybe<ExternalFileDiscussionUpdateFieldInput>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  document?: InputMaybe<ExternalFileDocumentUpdateFieldInput>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  fileSize_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  internalFile?: InputMaybe<ExternalFileInternalFileUpdateFieldInput>;
  lmsSource?: InputMaybe<LmsSource>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  moduleItem?: InputMaybe<ExternalFileModuleItemUpdateFieldInput>;
  page?: InputMaybe<ExternalFilePageUpdateFieldInput>;
  previewUrl?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerCourseId?: InputMaybe<Scalars['String']['input']>;
  providerFileId?: InputMaybe<Scalars['String']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
  quiz?: InputMaybe<ExternalFileQuizUpdateFieldInput>;
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  submission?: InputMaybe<ExternalFileSubmissionUpdateFieldInput>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedBy?: InputMaybe<Scalars['String']['input']>;
  uploadedByUser?: InputMaybe<ExternalFileUploadedByUserUpdateFieldInput>;
  visibility?: InputMaybe<ExternalFileVisibility>;
};

export type ExternalFileUploadedByUserAggregateInput = {
  AND?: InputMaybe<Array<ExternalFileUploadedByUserAggregateInput>>;
  NOT?: InputMaybe<ExternalFileUploadedByUserAggregateInput>;
  OR?: InputMaybe<Array<ExternalFileUploadedByUserAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalFileUploadedByUserNodeAggregationWhereInput>;
};

export type ExternalFileUploadedByUserConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type ExternalFileUploadedByUserConnectOrCreateFieldInput = {
  onCreate: ExternalFileUploadedByUserConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type ExternalFileUploadedByUserConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type ExternalFileUploadedByUserConnection = {
  __typename?: 'ExternalFileUploadedByUserConnection';
  edges: Array<ExternalFileUploadedByUserRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalFileUploadedByUserConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type ExternalFileUploadedByUserConnectionWhere = {
  AND?: InputMaybe<Array<ExternalFileUploadedByUserConnectionWhere>>;
  NOT?: InputMaybe<ExternalFileUploadedByUserConnectionWhere>;
  OR?: InputMaybe<Array<ExternalFileUploadedByUserConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type ExternalFileUploadedByUserCreateFieldInput = {
  node: UserCreateInput;
};

export type ExternalFileUploadedByUserDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<ExternalFileUploadedByUserConnectionWhere>;
};

export type ExternalFileUploadedByUserDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<ExternalFileUploadedByUserConnectionWhere>;
};

export type ExternalFileUploadedByUserFieldInput = {
  connect?: InputMaybe<ExternalFileUploadedByUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalFileUploadedByUserConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalFileUploadedByUserCreateFieldInput>;
};

export type ExternalFileUploadedByUserNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalFileUploadedByUserNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalFileUploadedByUserNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalFileUploadedByUserNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalFileUploadedByUserRelationship = {
  __typename?: 'ExternalFileUploadedByUserRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type ExternalFileUploadedByUserUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type ExternalFileUploadedByUserUpdateFieldInput = {
  connect?: InputMaybe<ExternalFileUploadedByUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalFileUploadedByUserConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalFileUploadedByUserCreateFieldInput>;
  delete?: InputMaybe<ExternalFileUploadedByUserDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalFileUploadedByUserDisconnectFieldInput>;
  update?: InputMaybe<ExternalFileUploadedByUserUpdateConnectionInput>;
  where?: InputMaybe<ExternalFileUploadedByUserConnectionWhere>;
};

export type ExternalFileUserUploadedByUserAggregationSelection = {
  __typename?: 'ExternalFileUserUploadedByUserAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalFileUserUploadedByUserNodeAggregateSelection>;
};

export type ExternalFileUserUploadedByUserNodeAggregateSelection = {
  __typename?: 'ExternalFileUserUploadedByUserNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export enum ExternalFileVisibility {
  Hidden = 'HIDDEN',
  Locked = 'LOCKED',
  Published = 'PUBLISHED',
  Unknown = 'UNKNOWN',
  Unpublished = 'UNPUBLISHED'
}

export type ExternalFileWhere = {
  AND?: InputMaybe<Array<ExternalFileWhere>>;
  NOT?: InputMaybe<ExternalFileWhere>;
  OR?: InputMaybe<Array<ExternalFileWhere>>;
  announcement?: InputMaybe<ExternalAnnouncementWhere>;
  announcementAggregate?: InputMaybe<ExternalFileAnnouncementAggregateInput>;
  announcementConnection?: InputMaybe<ExternalFileAnnouncementConnectionWhere>;
  announcementConnection_NOT?: InputMaybe<ExternalFileAnnouncementConnectionWhere>;
  announcement_NOT?: InputMaybe<ExternalAnnouncementWhere>;
  assignment?: InputMaybe<ExternalAssignmentWhere>;
  assignmentAggregate?: InputMaybe<ExternalFileAssignmentAggregateInput>;
  assignmentConnection?: InputMaybe<ExternalFileAssignmentConnectionWhere>;
  assignmentConnection_NOT?: InputMaybe<ExternalFileAssignmentConnectionWhere>;
  assignment_NOT?: InputMaybe<ExternalAssignmentWhere>;
  attachedToId?: InputMaybe<Scalars['String']['input']>;
  attachedToId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  attachedToId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  attachedToId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  attachedToId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  attachedToType?: InputMaybe<ExternalFileAttachedToType>;
  attachedToType_IN?: InputMaybe<Array<ExternalFileAttachedToType>>;
  course?: InputMaybe<ExternalCourseWhere>;
  courseAggregate?: InputMaybe<ExternalFileCourseAggregateInput>;
  courseConnection?: InputMaybe<ExternalFileCourseConnectionWhere>;
  courseConnection_NOT?: InputMaybe<ExternalFileCourseConnectionWhere>;
  course_NOT?: InputMaybe<ExternalCourseWhere>;
  discussion?: InputMaybe<ExternalDiscussionBoardWhere>;
  discussionAggregate?: InputMaybe<ExternalFileDiscussionAggregateInput>;
  discussionConnection?: InputMaybe<ExternalFileDiscussionConnectionWhere>;
  discussionConnection_NOT?: InputMaybe<ExternalFileDiscussionConnectionWhere>;
  discussion_NOT?: InputMaybe<ExternalDiscussionBoardWhere>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  displayName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  displayName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  document?: InputMaybe<DocumentWhere>;
  documentAggregate?: InputMaybe<ExternalFileDocumentAggregateInput>;
  documentConnection?: InputMaybe<ExternalFileDocumentConnectionWhere>;
  documentConnection_NOT?: InputMaybe<ExternalFileDocumentConnectionWhere>;
  document_NOT?: InputMaybe<DocumentWhere>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  downloadUrl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  downloadUrl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  downloadUrl_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  downloadUrl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  fileName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  fileName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  fileName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  fileSize_GT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileSize_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  fileSize_LT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_LTE?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  internalFile?: InputMaybe<FileWhere>;
  internalFileAggregate?: InputMaybe<ExternalFileInternalFileAggregateInput>;
  internalFileConnection?: InputMaybe<ExternalFileInternalFileConnectionWhere>;
  internalFileConnection_NOT?: InputMaybe<ExternalFileInternalFileConnectionWhere>;
  internalFile_NOT?: InputMaybe<FileWhere>;
  lmsSource?: InputMaybe<LmsSource>;
  lmsSource_IN?: InputMaybe<Array<LmsSource>>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  mimeType_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  mimeType_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  mimeType_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mimeType_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  modifiedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  moduleItem?: InputMaybe<ExternalModuleItemWhere>;
  moduleItemAggregate?: InputMaybe<ExternalFileModuleItemAggregateInput>;
  moduleItemConnection?: InputMaybe<ExternalFileModuleItemConnectionWhere>;
  moduleItemConnection_NOT?: InputMaybe<ExternalFileModuleItemConnectionWhere>;
  moduleItem_NOT?: InputMaybe<ExternalModuleItemWhere>;
  page?: InputMaybe<ExternalPageWhere>;
  pageAggregate?: InputMaybe<ExternalFilePageAggregateInput>;
  pageConnection?: InputMaybe<ExternalFilePageConnectionWhere>;
  pageConnection_NOT?: InputMaybe<ExternalFilePageConnectionWhere>;
  page_NOT?: InputMaybe<ExternalPageWhere>;
  previewUrl?: InputMaybe<Scalars['String']['input']>;
  previewUrl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  previewUrl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  previewUrl_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  previewUrl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerApiUrl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerCourseId?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerCourseId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerFileId?: InputMaybe<Scalars['String']['input']>;
  providerFileId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerFileId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerFileId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerFileId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
  providerKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerKey_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  quiz?: InputMaybe<ExternalQuizWhere>;
  quizAggregate?: InputMaybe<ExternalFileQuizAggregateInput>;
  quizConnection?: InputMaybe<ExternalFileQuizConnectionWhere>;
  quizConnection_NOT?: InputMaybe<ExternalFileQuizConnectionWhere>;
  quiz_NOT?: InputMaybe<ExternalQuizWhere>;
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourceMeta_IN?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload_IN?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  sourceUpdatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submission?: InputMaybe<ExternalSubmissionWhere>;
  submissionAggregate?: InputMaybe<ExternalFileSubmissionAggregateInput>;
  submissionConnection?: InputMaybe<ExternalFileSubmissionConnectionWhere>;
  submissionConnection_NOT?: InputMaybe<ExternalFileSubmissionConnectionWhere>;
  submission_NOT?: InputMaybe<ExternalSubmissionWhere>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  syncedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  uploadedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedBy?: InputMaybe<Scalars['String']['input']>;
  uploadedByUser?: InputMaybe<UserWhere>;
  uploadedByUserAggregate?: InputMaybe<ExternalFileUploadedByUserAggregateInput>;
  uploadedByUserConnection?: InputMaybe<ExternalFileUploadedByUserConnectionWhere>;
  uploadedByUserConnection_NOT?: InputMaybe<ExternalFileUploadedByUserConnectionWhere>;
  uploadedByUser_NOT?: InputMaybe<UserWhere>;
  uploadedBy_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  uploadedBy_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  uploadedBy_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uploadedBy_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<ExternalFileVisibility>;
  visibility_IN?: InputMaybe<Array<ExternalFileVisibility>>;
};

export type ExternalGradeItem = {
  __typename?: 'ExternalGradeItem';
  assignment?: Maybe<ExternalAssignment>;
  assignmentAggregate?: Maybe<ExternalGradeItemExternalAssignmentAssignmentAggregationSelection>;
  assignmentConnection: ExternalGradeItemAssignmentConnection;
  course: ExternalCourse;
  courseAggregate?: Maybe<ExternalGradeItemExternalCourseCourseAggregationSelection>;
  courseConnection: ExternalGradeItemCourseConnection;
  discussion?: Maybe<ExternalDiscussionBoard>;
  discussionAggregate?: Maybe<ExternalGradeItemExternalDiscussionBoardDiscussionAggregationSelection>;
  discussionConnection: ExternalGradeItemDiscussionConnection;
  id: Scalars['ID']['output'];
  lmsSource: LmsSource;
  pointsPossible?: Maybe<Scalars['Float']['output']>;
  providerApiUrl?: Maybe<Scalars['String']['output']>;
  providerCourseId: Scalars['String']['output'];
  providerGradeItemId: Scalars['String']['output'];
  providerKey: Scalars['String']['output'];
  quiz?: Maybe<ExternalQuiz>;
  quizAggregate?: Maybe<ExternalGradeItemExternalQuizQuizAggregationSelection>;
  quizConnection: ExternalGradeItemQuizConnection;
  sourceMeta?: Maybe<Scalars['JSON']['output']>;
  sourcePayload?: Maybe<Scalars['JSON']['output']>;
  sourceUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  syncedAt: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
  values: Array<ExternalGradeValue>;
  valuesAggregate?: Maybe<ExternalGradeItemExternalGradeValueValuesAggregationSelection>;
  valuesConnection: ExternalGradeItemValuesConnection;
  visibility: ExternalGradeVisibility;
};


export type ExternalGradeItemAssignmentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalAssignmentOptions>;
  where?: InputMaybe<ExternalAssignmentWhere>;
};


export type ExternalGradeItemAssignmentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalAssignmentWhere>;
};


export type ExternalGradeItemAssignmentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalGradeItemAssignmentConnectionSort>>;
  where?: InputMaybe<ExternalGradeItemAssignmentConnectionWhere>;
};


export type ExternalGradeItemCourseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalCourseOptions>;
  where?: InputMaybe<ExternalCourseWhere>;
};


export type ExternalGradeItemCourseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalCourseWhere>;
};


export type ExternalGradeItemCourseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalGradeItemCourseConnectionSort>>;
  where?: InputMaybe<ExternalGradeItemCourseConnectionWhere>;
};


export type ExternalGradeItemDiscussionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalDiscussionBoardOptions>;
  where?: InputMaybe<ExternalDiscussionBoardWhere>;
};


export type ExternalGradeItemDiscussionAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalDiscussionBoardWhere>;
};


export type ExternalGradeItemDiscussionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalGradeItemDiscussionConnectionSort>>;
  where?: InputMaybe<ExternalGradeItemDiscussionConnectionWhere>;
};


export type ExternalGradeItemQuizArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalQuizOptions>;
  where?: InputMaybe<ExternalQuizWhere>;
};


export type ExternalGradeItemQuizAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalQuizWhere>;
};


export type ExternalGradeItemQuizConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalGradeItemQuizConnectionSort>>;
  where?: InputMaybe<ExternalGradeItemQuizConnectionWhere>;
};


export type ExternalGradeItemValuesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalGradeValueOptions>;
  where?: InputMaybe<ExternalGradeValueWhere>;
};


export type ExternalGradeItemValuesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalGradeValueWhere>;
};


export type ExternalGradeItemValuesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalGradeItemValuesConnectionSort>>;
  where?: InputMaybe<ExternalGradeItemValuesConnectionWhere>;
};

export type ExternalGradeItemAssignmentAggregateInput = {
  AND?: InputMaybe<Array<ExternalGradeItemAssignmentAggregateInput>>;
  NOT?: InputMaybe<ExternalGradeItemAssignmentAggregateInput>;
  OR?: InputMaybe<Array<ExternalGradeItemAssignmentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalGradeItemAssignmentNodeAggregationWhereInput>;
};

export type ExternalGradeItemAssignmentConnectFieldInput = {
  connect?: InputMaybe<ExternalAssignmentConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalAssignmentConnectWhere>;
};

export type ExternalGradeItemAssignmentConnectOrCreateFieldInput = {
  onCreate: ExternalGradeItemAssignmentConnectOrCreateFieldInputOnCreate;
  where: ExternalAssignmentConnectOrCreateWhere;
};

export type ExternalGradeItemAssignmentConnectOrCreateFieldInputOnCreate = {
  node: ExternalAssignmentOnCreateInput;
};

export type ExternalGradeItemAssignmentConnection = {
  __typename?: 'ExternalGradeItemAssignmentConnection';
  edges: Array<ExternalGradeItemAssignmentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalGradeItemAssignmentConnectionSort = {
  node?: InputMaybe<ExternalAssignmentSort>;
};

export type ExternalGradeItemAssignmentConnectionWhere = {
  AND?: InputMaybe<Array<ExternalGradeItemAssignmentConnectionWhere>>;
  NOT?: InputMaybe<ExternalGradeItemAssignmentConnectionWhere>;
  OR?: InputMaybe<Array<ExternalGradeItemAssignmentConnectionWhere>>;
  node?: InputMaybe<ExternalAssignmentWhere>;
};

export type ExternalGradeItemAssignmentCreateFieldInput = {
  node: ExternalAssignmentCreateInput;
};

export type ExternalGradeItemAssignmentDeleteFieldInput = {
  delete?: InputMaybe<ExternalAssignmentDeleteInput>;
  where?: InputMaybe<ExternalGradeItemAssignmentConnectionWhere>;
};

export type ExternalGradeItemAssignmentDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalAssignmentDisconnectInput>;
  where?: InputMaybe<ExternalGradeItemAssignmentConnectionWhere>;
};

export type ExternalGradeItemAssignmentFieldInput = {
  connect?: InputMaybe<ExternalGradeItemAssignmentConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalGradeItemAssignmentConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalGradeItemAssignmentCreateFieldInput>;
};

export type ExternalGradeItemAssignmentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalGradeItemAssignmentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalGradeItemAssignmentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalGradeItemAssignmentNodeAggregationWhereInput>>;
  availableFrom_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  descriptionHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradingType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gradingType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gradingType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gradingType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gradingType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gradingType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gradingType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gradingType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gradingType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gradingType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gradingType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gradingType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gradingType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gradingType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gradingType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pointsPossible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerAssignmentId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerAssignmentId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerAssignmentId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerAssignmentId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerAssignmentId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalGradeItemAssignmentRelationship = {
  __typename?: 'ExternalGradeItemAssignmentRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalAssignment;
};

export type ExternalGradeItemAssignmentUpdateConnectionInput = {
  node?: InputMaybe<ExternalAssignmentUpdateInput>;
};

export type ExternalGradeItemAssignmentUpdateFieldInput = {
  connect?: InputMaybe<ExternalGradeItemAssignmentConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalGradeItemAssignmentConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalGradeItemAssignmentCreateFieldInput>;
  delete?: InputMaybe<ExternalGradeItemAssignmentDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalGradeItemAssignmentDisconnectFieldInput>;
  update?: InputMaybe<ExternalGradeItemAssignmentUpdateConnectionInput>;
  where?: InputMaybe<ExternalGradeItemAssignmentConnectionWhere>;
};

export type ExternalGradeItemConnectInput = {
  assignment?: InputMaybe<ExternalGradeItemAssignmentConnectFieldInput>;
  course?: InputMaybe<ExternalGradeItemCourseConnectFieldInput>;
  discussion?: InputMaybe<ExternalGradeItemDiscussionConnectFieldInput>;
  quiz?: InputMaybe<ExternalGradeItemQuizConnectFieldInput>;
  values?: InputMaybe<Array<ExternalGradeItemValuesConnectFieldInput>>;
};

export type ExternalGradeItemConnectOrCreateWhere = {
  node: ExternalGradeItemUniqueWhere;
};

export type ExternalGradeItemConnectWhere = {
  node: ExternalGradeItemWhere;
};

export type ExternalGradeItemCourseAggregateInput = {
  AND?: InputMaybe<Array<ExternalGradeItemCourseAggregateInput>>;
  NOT?: InputMaybe<ExternalGradeItemCourseAggregateInput>;
  OR?: InputMaybe<Array<ExternalGradeItemCourseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalGradeItemCourseNodeAggregationWhereInput>;
};

export type ExternalGradeItemCourseConnectFieldInput = {
  connect?: InputMaybe<ExternalCourseConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalCourseConnectWhere>;
};

export type ExternalGradeItemCourseConnectOrCreateFieldInput = {
  onCreate: ExternalGradeItemCourseConnectOrCreateFieldInputOnCreate;
  where: ExternalCourseConnectOrCreateWhere;
};

export type ExternalGradeItemCourseConnectOrCreateFieldInputOnCreate = {
  node: ExternalCourseOnCreateInput;
};

export type ExternalGradeItemCourseConnection = {
  __typename?: 'ExternalGradeItemCourseConnection';
  edges: Array<ExternalGradeItemCourseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalGradeItemCourseConnectionSort = {
  node?: InputMaybe<ExternalCourseSort>;
};

export type ExternalGradeItemCourseConnectionWhere = {
  AND?: InputMaybe<Array<ExternalGradeItemCourseConnectionWhere>>;
  NOT?: InputMaybe<ExternalGradeItemCourseConnectionWhere>;
  OR?: InputMaybe<Array<ExternalGradeItemCourseConnectionWhere>>;
  node?: InputMaybe<ExternalCourseWhere>;
};

export type ExternalGradeItemCourseCreateFieldInput = {
  node: ExternalCourseCreateInput;
};

export type ExternalGradeItemCourseDeleteFieldInput = {
  delete?: InputMaybe<ExternalCourseDeleteInput>;
  where?: InputMaybe<ExternalGradeItemCourseConnectionWhere>;
};

export type ExternalGradeItemCourseDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalCourseDisconnectInput>;
  where?: InputMaybe<ExternalGradeItemCourseConnectionWhere>;
};

export type ExternalGradeItemCourseFieldInput = {
  connect?: InputMaybe<ExternalGradeItemCourseConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalGradeItemCourseConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalGradeItemCourseCreateFieldInput>;
};

export type ExternalGradeItemCourseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalGradeItemCourseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalGradeItemCourseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalGradeItemCourseNodeAggregationWhereInput>>;
  courseCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  courseCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  courseCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  courseCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  courseCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  endDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalGradeItemCourseRelationship = {
  __typename?: 'ExternalGradeItemCourseRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalCourse;
};

export type ExternalGradeItemCourseUpdateConnectionInput = {
  node?: InputMaybe<ExternalCourseUpdateInput>;
};

export type ExternalGradeItemCourseUpdateFieldInput = {
  connect?: InputMaybe<ExternalGradeItemCourseConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalGradeItemCourseConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalGradeItemCourseCreateFieldInput>;
  delete?: InputMaybe<ExternalGradeItemCourseDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalGradeItemCourseDisconnectFieldInput>;
  update?: InputMaybe<ExternalGradeItemCourseUpdateConnectionInput>;
  where?: InputMaybe<ExternalGradeItemCourseConnectionWhere>;
};

export type ExternalGradeItemCreateInput = {
  assignment?: InputMaybe<ExternalGradeItemAssignmentFieldInput>;
  course?: InputMaybe<ExternalGradeItemCourseFieldInput>;
  discussion?: InputMaybe<ExternalGradeItemDiscussionFieldInput>;
  lmsSource: LmsSource;
  pointsPossible?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerCourseId: Scalars['String']['input'];
  providerGradeItemId: Scalars['String']['input'];
  providerKey: Scalars['String']['input'];
  quiz?: InputMaybe<ExternalGradeItemQuizFieldInput>;
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<ExternalGradeItemValuesFieldInput>;
  visibility: ExternalGradeVisibility;
};

export type ExternalGradeItemDeleteInput = {
  assignment?: InputMaybe<ExternalGradeItemAssignmentDeleteFieldInput>;
  course?: InputMaybe<ExternalGradeItemCourseDeleteFieldInput>;
  discussion?: InputMaybe<ExternalGradeItemDiscussionDeleteFieldInput>;
  quiz?: InputMaybe<ExternalGradeItemQuizDeleteFieldInput>;
  values?: InputMaybe<Array<ExternalGradeItemValuesDeleteFieldInput>>;
};

export type ExternalGradeItemDisconnectInput = {
  assignment?: InputMaybe<ExternalGradeItemAssignmentDisconnectFieldInput>;
  course?: InputMaybe<ExternalGradeItemCourseDisconnectFieldInput>;
  discussion?: InputMaybe<ExternalGradeItemDiscussionDisconnectFieldInput>;
  quiz?: InputMaybe<ExternalGradeItemQuizDisconnectFieldInput>;
  values?: InputMaybe<Array<ExternalGradeItemValuesDisconnectFieldInput>>;
};

export type ExternalGradeItemDiscussionAggregateInput = {
  AND?: InputMaybe<Array<ExternalGradeItemDiscussionAggregateInput>>;
  NOT?: InputMaybe<ExternalGradeItemDiscussionAggregateInput>;
  OR?: InputMaybe<Array<ExternalGradeItemDiscussionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalGradeItemDiscussionNodeAggregationWhereInput>;
};

export type ExternalGradeItemDiscussionConnectFieldInput = {
  connect?: InputMaybe<ExternalDiscussionBoardConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalDiscussionBoardConnectWhere>;
};

export type ExternalGradeItemDiscussionConnectOrCreateFieldInput = {
  onCreate: ExternalGradeItemDiscussionConnectOrCreateFieldInputOnCreate;
  where: ExternalDiscussionBoardConnectOrCreateWhere;
};

export type ExternalGradeItemDiscussionConnectOrCreateFieldInputOnCreate = {
  node: ExternalDiscussionBoardOnCreateInput;
};

export type ExternalGradeItemDiscussionConnection = {
  __typename?: 'ExternalGradeItemDiscussionConnection';
  edges: Array<ExternalGradeItemDiscussionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalGradeItemDiscussionConnectionSort = {
  node?: InputMaybe<ExternalDiscussionBoardSort>;
};

export type ExternalGradeItemDiscussionConnectionWhere = {
  AND?: InputMaybe<Array<ExternalGradeItemDiscussionConnectionWhere>>;
  NOT?: InputMaybe<ExternalGradeItemDiscussionConnectionWhere>;
  OR?: InputMaybe<Array<ExternalGradeItemDiscussionConnectionWhere>>;
  node?: InputMaybe<ExternalDiscussionBoardWhere>;
};

export type ExternalGradeItemDiscussionCreateFieldInput = {
  node: ExternalDiscussionBoardCreateInput;
};

export type ExternalGradeItemDiscussionDeleteFieldInput = {
  delete?: InputMaybe<ExternalDiscussionBoardDeleteInput>;
  where?: InputMaybe<ExternalGradeItemDiscussionConnectionWhere>;
};

export type ExternalGradeItemDiscussionDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalDiscussionBoardDisconnectInput>;
  where?: InputMaybe<ExternalGradeItemDiscussionConnectionWhere>;
};

export type ExternalGradeItemDiscussionFieldInput = {
  connect?: InputMaybe<ExternalGradeItemDiscussionConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalGradeItemDiscussionConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalGradeItemDiscussionCreateFieldInput>;
};

export type ExternalGradeItemDiscussionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalGradeItemDiscussionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalGradeItemDiscussionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalGradeItemDiscussionNodeAggregationWhereInput>>;
  availableFrom_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  messageHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  messageHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  messageHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  messageHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  messageHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  messageHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  messageText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  messageText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  messageText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  messageText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  messageText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  messageText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  messageText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  messageText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  messageText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  messageText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  messageText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  messageText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  messageText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  messageText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  messageText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pointsPossible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerDiscussionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerDiscussionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerDiscussionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerDiscussionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerDiscussionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalGradeItemDiscussionRelationship = {
  __typename?: 'ExternalGradeItemDiscussionRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalDiscussionBoard;
};

export type ExternalGradeItemDiscussionUpdateConnectionInput = {
  node?: InputMaybe<ExternalDiscussionBoardUpdateInput>;
};

export type ExternalGradeItemDiscussionUpdateFieldInput = {
  connect?: InputMaybe<ExternalGradeItemDiscussionConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalGradeItemDiscussionConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalGradeItemDiscussionCreateFieldInput>;
  delete?: InputMaybe<ExternalGradeItemDiscussionDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalGradeItemDiscussionDisconnectFieldInput>;
  update?: InputMaybe<ExternalGradeItemDiscussionUpdateConnectionInput>;
  where?: InputMaybe<ExternalGradeItemDiscussionConnectionWhere>;
};

export type ExternalGradeItemExternalAssignmentAssignmentAggregationSelection = {
  __typename?: 'ExternalGradeItemExternalAssignmentAssignmentAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalGradeItemExternalAssignmentAssignmentNodeAggregateSelection>;
};

export type ExternalGradeItemExternalAssignmentAssignmentNodeAggregateSelection = {
  __typename?: 'ExternalGradeItemExternalAssignmentAssignmentNodeAggregateSelection';
  availableFrom: DateTimeAggregateSelection;
  availableUntil: DateTimeAggregateSelection;
  descriptionHtml: StringAggregateSelection;
  descriptionText: StringAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  gradingType: StringAggregateSelection;
  id: IdAggregateSelection;
  pointsPossible: FloatAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerAssignmentId: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  title: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalGradeItemExternalCourseCourseAggregationSelection = {
  __typename?: 'ExternalGradeItemExternalCourseCourseAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalGradeItemExternalCourseCourseNodeAggregateSelection>;
};

export type ExternalGradeItemExternalCourseCourseNodeAggregateSelection = {
  __typename?: 'ExternalGradeItemExternalCourseCourseNodeAggregateSelection';
  courseCode: StringAggregateSelection;
  descriptionHtml: StringAggregateSelection;
  descriptionText: StringAggregateSelection;
  endDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  name: StringAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  startDate: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalGradeItemExternalDiscussionBoardDiscussionAggregationSelection = {
  __typename?: 'ExternalGradeItemExternalDiscussionBoardDiscussionAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalGradeItemExternalDiscussionBoardDiscussionNodeAggregateSelection>;
};

export type ExternalGradeItemExternalDiscussionBoardDiscussionNodeAggregateSelection = {
  __typename?: 'ExternalGradeItemExternalDiscussionBoardDiscussionNodeAggregateSelection';
  availableFrom: DateTimeAggregateSelection;
  availableUntil: DateTimeAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  messageHtml: StringAggregateSelection;
  messageText: StringAggregateSelection;
  pointsPossible: FloatAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerDiscussionId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  title: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalGradeItemExternalGradeValueValuesAggregationSelection = {
  __typename?: 'ExternalGradeItemExternalGradeValueValuesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalGradeItemExternalGradeValueValuesNodeAggregateSelection>;
};

export type ExternalGradeItemExternalGradeValueValuesNodeAggregateSelection = {
  __typename?: 'ExternalGradeItemExternalGradeValueValuesNodeAggregateSelection';
  gradeText: StringAggregateSelection;
  gradedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  percentage: FloatAggregateSelection;
  pointsPossible: FloatAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerGradeItemId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  providerUserId: StringAggregateSelection;
  score: FloatAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
};

export type ExternalGradeItemExternalQuizQuizAggregationSelection = {
  __typename?: 'ExternalGradeItemExternalQuizQuizAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalGradeItemExternalQuizQuizNodeAggregateSelection>;
};

export type ExternalGradeItemExternalQuizQuizNodeAggregateSelection = {
  __typename?: 'ExternalGradeItemExternalQuizQuizNodeAggregateSelection';
  attemptsAllowed: IntAggregateSelection;
  availableFrom: DateTimeAggregateSelection;
  availableUntil: DateTimeAggregateSelection;
  descriptionHtml: StringAggregateSelection;
  descriptionText: StringAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  pointsPossible: FloatAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  providerQuizId: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  timeLimitMinutes: IntAggregateSelection;
  title: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalGradeItemOnCreateInput = {
  lmsSource: LmsSource;
  pointsPossible?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerCourseId: Scalars['String']['input'];
  providerGradeItemId: Scalars['String']['input'];
  providerKey: Scalars['String']['input'];
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  visibility: ExternalGradeVisibility;
};

export type ExternalGradeItemOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ExternalGradeItemSort objects to sort ExternalGradeItems by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ExternalGradeItemSort>>;
};

export type ExternalGradeItemQuizAggregateInput = {
  AND?: InputMaybe<Array<ExternalGradeItemQuizAggregateInput>>;
  NOT?: InputMaybe<ExternalGradeItemQuizAggregateInput>;
  OR?: InputMaybe<Array<ExternalGradeItemQuizAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalGradeItemQuizNodeAggregationWhereInput>;
};

export type ExternalGradeItemQuizConnectFieldInput = {
  connect?: InputMaybe<ExternalQuizConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalQuizConnectWhere>;
};

export type ExternalGradeItemQuizConnectOrCreateFieldInput = {
  onCreate: ExternalGradeItemQuizConnectOrCreateFieldInputOnCreate;
  where: ExternalQuizConnectOrCreateWhere;
};

export type ExternalGradeItemQuizConnectOrCreateFieldInputOnCreate = {
  node: ExternalQuizOnCreateInput;
};

export type ExternalGradeItemQuizConnection = {
  __typename?: 'ExternalGradeItemQuizConnection';
  edges: Array<ExternalGradeItemQuizRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalGradeItemQuizConnectionSort = {
  node?: InputMaybe<ExternalQuizSort>;
};

export type ExternalGradeItemQuizConnectionWhere = {
  AND?: InputMaybe<Array<ExternalGradeItemQuizConnectionWhere>>;
  NOT?: InputMaybe<ExternalGradeItemQuizConnectionWhere>;
  OR?: InputMaybe<Array<ExternalGradeItemQuizConnectionWhere>>;
  node?: InputMaybe<ExternalQuizWhere>;
};

export type ExternalGradeItemQuizCreateFieldInput = {
  node: ExternalQuizCreateInput;
};

export type ExternalGradeItemQuizDeleteFieldInput = {
  delete?: InputMaybe<ExternalQuizDeleteInput>;
  where?: InputMaybe<ExternalGradeItemQuizConnectionWhere>;
};

export type ExternalGradeItemQuizDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalQuizDisconnectInput>;
  where?: InputMaybe<ExternalGradeItemQuizConnectionWhere>;
};

export type ExternalGradeItemQuizFieldInput = {
  connect?: InputMaybe<ExternalGradeItemQuizConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalGradeItemQuizConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalGradeItemQuizCreateFieldInput>;
};

export type ExternalGradeItemQuizNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalGradeItemQuizNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalGradeItemQuizNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalGradeItemQuizNodeAggregationWhereInput>>;
  attemptsAllowed_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  attemptsAllowed_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  attemptsAllowed_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  attemptsAllowed_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  attemptsAllowed_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  attemptsAllowed_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  availableFrom_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  descriptionHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pointsPossible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerQuizId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerQuizId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerQuizId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerQuizId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerQuizId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  timeLimitMinutes_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeLimitMinutes_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeLimitMinutes_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimitMinutes_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeLimitMinutes_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimitMinutes_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalGradeItemQuizRelationship = {
  __typename?: 'ExternalGradeItemQuizRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalQuiz;
};

export type ExternalGradeItemQuizUpdateConnectionInput = {
  node?: InputMaybe<ExternalQuizUpdateInput>;
};

export type ExternalGradeItemQuizUpdateFieldInput = {
  connect?: InputMaybe<ExternalGradeItemQuizConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalGradeItemQuizConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalGradeItemQuizCreateFieldInput>;
  delete?: InputMaybe<ExternalGradeItemQuizDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalGradeItemQuizDisconnectFieldInput>;
  update?: InputMaybe<ExternalGradeItemQuizUpdateConnectionInput>;
  where?: InputMaybe<ExternalGradeItemQuizConnectionWhere>;
};

/** Fields to sort ExternalGradeItems by. The order in which sorts are applied is not guaranteed when specifying many fields in one ExternalGradeItemSort object. */
export type ExternalGradeItemSort = {
  id?: InputMaybe<SortDirection>;
  lmsSource?: InputMaybe<SortDirection>;
  pointsPossible?: InputMaybe<SortDirection>;
  providerApiUrl?: InputMaybe<SortDirection>;
  providerCourseId?: InputMaybe<SortDirection>;
  providerGradeItemId?: InputMaybe<SortDirection>;
  providerKey?: InputMaybe<SortDirection>;
  sourceMeta?: InputMaybe<SortDirection>;
  sourcePayload?: InputMaybe<SortDirection>;
  sourceUpdatedAt?: InputMaybe<SortDirection>;
  syncedAt?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  url?: InputMaybe<SortDirection>;
  visibility?: InputMaybe<SortDirection>;
};

export type ExternalGradeItemUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalGradeItemUpdateInput = {
  assignment?: InputMaybe<ExternalGradeItemAssignmentUpdateFieldInput>;
  course?: InputMaybe<ExternalGradeItemCourseUpdateFieldInput>;
  discussion?: InputMaybe<ExternalGradeItemDiscussionUpdateFieldInput>;
  lmsSource?: InputMaybe<LmsSource>;
  pointsPossible?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_ADD?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerCourseId?: InputMaybe<Scalars['String']['input']>;
  providerGradeItemId?: InputMaybe<Scalars['String']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
  quiz?: InputMaybe<ExternalGradeItemQuizUpdateFieldInput>;
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<ExternalGradeItemValuesUpdateFieldInput>>;
  visibility?: InputMaybe<ExternalGradeVisibility>;
};

export type ExternalGradeItemValuesAggregateInput = {
  AND?: InputMaybe<Array<ExternalGradeItemValuesAggregateInput>>;
  NOT?: InputMaybe<ExternalGradeItemValuesAggregateInput>;
  OR?: InputMaybe<Array<ExternalGradeItemValuesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalGradeItemValuesNodeAggregationWhereInput>;
};

export type ExternalGradeItemValuesConnectFieldInput = {
  connect?: InputMaybe<Array<ExternalGradeValueConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalGradeValueConnectWhere>;
};

export type ExternalGradeItemValuesConnectOrCreateFieldInput = {
  onCreate: ExternalGradeItemValuesConnectOrCreateFieldInputOnCreate;
  where: ExternalGradeValueConnectOrCreateWhere;
};

export type ExternalGradeItemValuesConnectOrCreateFieldInputOnCreate = {
  node: ExternalGradeValueOnCreateInput;
};

export type ExternalGradeItemValuesConnection = {
  __typename?: 'ExternalGradeItemValuesConnection';
  edges: Array<ExternalGradeItemValuesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalGradeItemValuesConnectionSort = {
  node?: InputMaybe<ExternalGradeValueSort>;
};

export type ExternalGradeItemValuesConnectionWhere = {
  AND?: InputMaybe<Array<ExternalGradeItemValuesConnectionWhere>>;
  NOT?: InputMaybe<ExternalGradeItemValuesConnectionWhere>;
  OR?: InputMaybe<Array<ExternalGradeItemValuesConnectionWhere>>;
  node?: InputMaybe<ExternalGradeValueWhere>;
};

export type ExternalGradeItemValuesCreateFieldInput = {
  node: ExternalGradeValueCreateInput;
};

export type ExternalGradeItemValuesDeleteFieldInput = {
  delete?: InputMaybe<ExternalGradeValueDeleteInput>;
  where?: InputMaybe<ExternalGradeItemValuesConnectionWhere>;
};

export type ExternalGradeItemValuesDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalGradeValueDisconnectInput>;
  where?: InputMaybe<ExternalGradeItemValuesConnectionWhere>;
};

export type ExternalGradeItemValuesFieldInput = {
  connect?: InputMaybe<Array<ExternalGradeItemValuesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalGradeItemValuesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalGradeItemValuesCreateFieldInput>>;
};

export type ExternalGradeItemValuesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalGradeItemValuesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalGradeItemValuesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalGradeItemValuesNodeAggregationWhereInput>>;
  gradeText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gradeText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gradeText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gradeText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gradeText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gradeText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gradeText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gradeText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gradeText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gradeText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gradeText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gradeText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gradeText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gradeText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gradeText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gradedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  percentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  percentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  percentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  percentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  percentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  percentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  percentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  percentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  percentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  percentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  percentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  percentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  percentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  percentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  percentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  percentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  percentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  percentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  percentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  percentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerGradeItemId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerGradeItemId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerGradeItemId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerGradeItemId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerGradeItemId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerGradeItemId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerGradeItemId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerGradeItemId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerGradeItemId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerGradeItemId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerGradeItemId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerGradeItemId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerGradeItemId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerGradeItemId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerGradeItemId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  score_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  score_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  score_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  score_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  score_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  score_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  score_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  score_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  score_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  score_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  score_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  score_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  score_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  score_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  score_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  score_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  score_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  score_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  score_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  score_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ExternalGradeItemValuesRelationship = {
  __typename?: 'ExternalGradeItemValuesRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalGradeValue;
};

export type ExternalGradeItemValuesUpdateConnectionInput = {
  node?: InputMaybe<ExternalGradeValueUpdateInput>;
};

export type ExternalGradeItemValuesUpdateFieldInput = {
  connect?: InputMaybe<Array<ExternalGradeItemValuesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalGradeItemValuesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalGradeItemValuesCreateFieldInput>>;
  delete?: InputMaybe<Array<ExternalGradeItemValuesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ExternalGradeItemValuesDisconnectFieldInput>>;
  update?: InputMaybe<ExternalGradeItemValuesUpdateConnectionInput>;
  where?: InputMaybe<ExternalGradeItemValuesConnectionWhere>;
};

export type ExternalGradeItemWhere = {
  AND?: InputMaybe<Array<ExternalGradeItemWhere>>;
  NOT?: InputMaybe<ExternalGradeItemWhere>;
  OR?: InputMaybe<Array<ExternalGradeItemWhere>>;
  assignment?: InputMaybe<ExternalAssignmentWhere>;
  assignmentAggregate?: InputMaybe<ExternalGradeItemAssignmentAggregateInput>;
  assignmentConnection?: InputMaybe<ExternalGradeItemAssignmentConnectionWhere>;
  assignmentConnection_NOT?: InputMaybe<ExternalGradeItemAssignmentConnectionWhere>;
  assignment_NOT?: InputMaybe<ExternalAssignmentWhere>;
  course?: InputMaybe<ExternalCourseWhere>;
  courseAggregate?: InputMaybe<ExternalGradeItemCourseAggregateInput>;
  courseConnection?: InputMaybe<ExternalGradeItemCourseConnectionWhere>;
  courseConnection_NOT?: InputMaybe<ExternalGradeItemCourseConnectionWhere>;
  course_NOT?: InputMaybe<ExternalCourseWhere>;
  discussion?: InputMaybe<ExternalDiscussionBoardWhere>;
  discussionAggregate?: InputMaybe<ExternalGradeItemDiscussionAggregateInput>;
  discussionConnection?: InputMaybe<ExternalGradeItemDiscussionConnectionWhere>;
  discussionConnection_NOT?: InputMaybe<ExternalGradeItemDiscussionConnectionWhere>;
  discussion_NOT?: InputMaybe<ExternalDiscussionBoardWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lmsSource?: InputMaybe<LmsSource>;
  lmsSource_IN?: InputMaybe<Array<LmsSource>>;
  pointsPossible?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  pointsPossible_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerApiUrl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerCourseId?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerCourseId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerGradeItemId?: InputMaybe<Scalars['String']['input']>;
  providerGradeItemId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerGradeItemId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerGradeItemId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerGradeItemId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
  providerKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerKey_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  quiz?: InputMaybe<ExternalQuizWhere>;
  quizAggregate?: InputMaybe<ExternalGradeItemQuizAggregateInput>;
  quizConnection?: InputMaybe<ExternalGradeItemQuizConnectionWhere>;
  quizConnection_NOT?: InputMaybe<ExternalGradeItemQuizConnectionWhere>;
  quiz_NOT?: InputMaybe<ExternalQuizWhere>;
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourceMeta_IN?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload_IN?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  sourceUpdatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  syncedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  valuesAggregate?: InputMaybe<ExternalGradeItemValuesAggregateInput>;
  /** Return ExternalGradeItems where all of the related ExternalGradeItemValuesConnections match this filter */
  valuesConnection_ALL?: InputMaybe<ExternalGradeItemValuesConnectionWhere>;
  /** Return ExternalGradeItems where none of the related ExternalGradeItemValuesConnections match this filter */
  valuesConnection_NONE?: InputMaybe<ExternalGradeItemValuesConnectionWhere>;
  /** Return ExternalGradeItems where one of the related ExternalGradeItemValuesConnections match this filter */
  valuesConnection_SINGLE?: InputMaybe<ExternalGradeItemValuesConnectionWhere>;
  /** Return ExternalGradeItems where some of the related ExternalGradeItemValuesConnections match this filter */
  valuesConnection_SOME?: InputMaybe<ExternalGradeItemValuesConnectionWhere>;
  /** Return ExternalGradeItems where all of the related ExternalGradeValues match this filter */
  values_ALL?: InputMaybe<ExternalGradeValueWhere>;
  /** Return ExternalGradeItems where none of the related ExternalGradeValues match this filter */
  values_NONE?: InputMaybe<ExternalGradeValueWhere>;
  /** Return ExternalGradeItems where one of the related ExternalGradeValues match this filter */
  values_SINGLE?: InputMaybe<ExternalGradeValueWhere>;
  /** Return ExternalGradeItems where some of the related ExternalGradeValues match this filter */
  values_SOME?: InputMaybe<ExternalGradeValueWhere>;
  visibility?: InputMaybe<ExternalGradeVisibility>;
  visibility_IN?: InputMaybe<Array<ExternalGradeVisibility>>;
};

export type ExternalGradeValue = {
  __typename?: 'ExternalGradeValue';
  gradeItem: ExternalGradeItem;
  gradeItemAggregate?: Maybe<ExternalGradeValueExternalGradeItemGradeItemAggregationSelection>;
  gradeItemConnection: ExternalGradeValueGradeItemConnection;
  gradeText?: Maybe<Scalars['String']['output']>;
  gradedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  lmsSource: LmsSource;
  percentage?: Maybe<Scalars['Float']['output']>;
  pointsPossible?: Maybe<Scalars['Float']['output']>;
  providerCourseId: Scalars['String']['output'];
  providerGradeItemId: Scalars['String']['output'];
  providerKey: Scalars['String']['output'];
  providerUserId: Scalars['String']['output'];
  score?: Maybe<Scalars['Float']['output']>;
  sourceMeta?: Maybe<Scalars['JSON']['output']>;
  sourcePayload?: Maybe<Scalars['JSON']['output']>;
  sourceUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  syncedAt: Scalars['DateTime']['output'];
  user: User;
  userAggregate?: Maybe<ExternalGradeValueUserUserAggregationSelection>;
  userConnection: ExternalGradeValueUserConnection;
};


export type ExternalGradeValueGradeItemArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalGradeItemOptions>;
  where?: InputMaybe<ExternalGradeItemWhere>;
};


export type ExternalGradeValueGradeItemAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalGradeItemWhere>;
};


export type ExternalGradeValueGradeItemConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalGradeValueGradeItemConnectionSort>>;
  where?: InputMaybe<ExternalGradeValueGradeItemConnectionWhere>;
};


export type ExternalGradeValueUserArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type ExternalGradeValueUserAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type ExternalGradeValueUserConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalGradeValueUserConnectionSort>>;
  where?: InputMaybe<ExternalGradeValueUserConnectionWhere>;
};

export type ExternalGradeValueConnectInput = {
  gradeItem?: InputMaybe<ExternalGradeValueGradeItemConnectFieldInput>;
  user?: InputMaybe<ExternalGradeValueUserConnectFieldInput>;
};

export type ExternalGradeValueConnectOrCreateWhere = {
  node: ExternalGradeValueUniqueWhere;
};

export type ExternalGradeValueConnectWhere = {
  node: ExternalGradeValueWhere;
};

export type ExternalGradeValueCreateInput = {
  gradeItem?: InputMaybe<ExternalGradeValueGradeItemFieldInput>;
  gradeText?: InputMaybe<Scalars['String']['input']>;
  gradedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lmsSource: LmsSource;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId: Scalars['String']['input'];
  providerGradeItemId: Scalars['String']['input'];
  providerKey: Scalars['String']['input'];
  providerUserId: Scalars['String']['input'];
  score?: InputMaybe<Scalars['Float']['input']>;
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt: Scalars['DateTime']['input'];
  user?: InputMaybe<ExternalGradeValueUserFieldInput>;
};

export type ExternalGradeValueDeleteInput = {
  gradeItem?: InputMaybe<ExternalGradeValueGradeItemDeleteFieldInput>;
  user?: InputMaybe<ExternalGradeValueUserDeleteFieldInput>;
};

export type ExternalGradeValueDisconnectInput = {
  gradeItem?: InputMaybe<ExternalGradeValueGradeItemDisconnectFieldInput>;
  user?: InputMaybe<ExternalGradeValueUserDisconnectFieldInput>;
};

export type ExternalGradeValueExternalGradeItemGradeItemAggregationSelection = {
  __typename?: 'ExternalGradeValueExternalGradeItemGradeItemAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalGradeValueExternalGradeItemGradeItemNodeAggregateSelection>;
};

export type ExternalGradeValueExternalGradeItemGradeItemNodeAggregateSelection = {
  __typename?: 'ExternalGradeValueExternalGradeItemGradeItemNodeAggregateSelection';
  id: IdAggregateSelection;
  pointsPossible: FloatAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerGradeItemId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  title: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalGradeValueGradeItemAggregateInput = {
  AND?: InputMaybe<Array<ExternalGradeValueGradeItemAggregateInput>>;
  NOT?: InputMaybe<ExternalGradeValueGradeItemAggregateInput>;
  OR?: InputMaybe<Array<ExternalGradeValueGradeItemAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalGradeValueGradeItemNodeAggregationWhereInput>;
};

export type ExternalGradeValueGradeItemConnectFieldInput = {
  connect?: InputMaybe<ExternalGradeItemConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalGradeItemConnectWhere>;
};

export type ExternalGradeValueGradeItemConnectOrCreateFieldInput = {
  onCreate: ExternalGradeValueGradeItemConnectOrCreateFieldInputOnCreate;
  where: ExternalGradeItemConnectOrCreateWhere;
};

export type ExternalGradeValueGradeItemConnectOrCreateFieldInputOnCreate = {
  node: ExternalGradeItemOnCreateInput;
};

export type ExternalGradeValueGradeItemConnection = {
  __typename?: 'ExternalGradeValueGradeItemConnection';
  edges: Array<ExternalGradeValueGradeItemRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalGradeValueGradeItemConnectionSort = {
  node?: InputMaybe<ExternalGradeItemSort>;
};

export type ExternalGradeValueGradeItemConnectionWhere = {
  AND?: InputMaybe<Array<ExternalGradeValueGradeItemConnectionWhere>>;
  NOT?: InputMaybe<ExternalGradeValueGradeItemConnectionWhere>;
  OR?: InputMaybe<Array<ExternalGradeValueGradeItemConnectionWhere>>;
  node?: InputMaybe<ExternalGradeItemWhere>;
};

export type ExternalGradeValueGradeItemCreateFieldInput = {
  node: ExternalGradeItemCreateInput;
};

export type ExternalGradeValueGradeItemDeleteFieldInput = {
  delete?: InputMaybe<ExternalGradeItemDeleteInput>;
  where?: InputMaybe<ExternalGradeValueGradeItemConnectionWhere>;
};

export type ExternalGradeValueGradeItemDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalGradeItemDisconnectInput>;
  where?: InputMaybe<ExternalGradeValueGradeItemConnectionWhere>;
};

export type ExternalGradeValueGradeItemFieldInput = {
  connect?: InputMaybe<ExternalGradeValueGradeItemConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalGradeValueGradeItemConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalGradeValueGradeItemCreateFieldInput>;
};

export type ExternalGradeValueGradeItemNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalGradeValueGradeItemNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalGradeValueGradeItemNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalGradeValueGradeItemNodeAggregationWhereInput>>;
  pointsPossible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerGradeItemId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerGradeItemId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerGradeItemId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerGradeItemId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerGradeItemId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerGradeItemId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerGradeItemId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerGradeItemId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerGradeItemId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerGradeItemId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerGradeItemId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerGradeItemId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerGradeItemId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerGradeItemId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerGradeItemId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalGradeValueGradeItemRelationship = {
  __typename?: 'ExternalGradeValueGradeItemRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalGradeItem;
};

export type ExternalGradeValueGradeItemUpdateConnectionInput = {
  node?: InputMaybe<ExternalGradeItemUpdateInput>;
};

export type ExternalGradeValueGradeItemUpdateFieldInput = {
  connect?: InputMaybe<ExternalGradeValueGradeItemConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalGradeValueGradeItemConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalGradeValueGradeItemCreateFieldInput>;
  delete?: InputMaybe<ExternalGradeValueGradeItemDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalGradeValueGradeItemDisconnectFieldInput>;
  update?: InputMaybe<ExternalGradeValueGradeItemUpdateConnectionInput>;
  where?: InputMaybe<ExternalGradeValueGradeItemConnectionWhere>;
};

export type ExternalGradeValueOnCreateInput = {
  gradeText?: InputMaybe<Scalars['String']['input']>;
  gradedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lmsSource: LmsSource;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId: Scalars['String']['input'];
  providerGradeItemId: Scalars['String']['input'];
  providerKey: Scalars['String']['input'];
  providerUserId: Scalars['String']['input'];
  score?: InputMaybe<Scalars['Float']['input']>;
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt: Scalars['DateTime']['input'];
};

export type ExternalGradeValueOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ExternalGradeValueSort objects to sort ExternalGradeValues by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ExternalGradeValueSort>>;
};

/** Fields to sort ExternalGradeValues by. The order in which sorts are applied is not guaranteed when specifying many fields in one ExternalGradeValueSort object. */
export type ExternalGradeValueSort = {
  gradeText?: InputMaybe<SortDirection>;
  gradedAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lmsSource?: InputMaybe<SortDirection>;
  percentage?: InputMaybe<SortDirection>;
  pointsPossible?: InputMaybe<SortDirection>;
  providerCourseId?: InputMaybe<SortDirection>;
  providerGradeItemId?: InputMaybe<SortDirection>;
  providerKey?: InputMaybe<SortDirection>;
  providerUserId?: InputMaybe<SortDirection>;
  score?: InputMaybe<SortDirection>;
  sourceMeta?: InputMaybe<SortDirection>;
  sourcePayload?: InputMaybe<SortDirection>;
  sourceUpdatedAt?: InputMaybe<SortDirection>;
  syncedAt?: InputMaybe<SortDirection>;
};

export type ExternalGradeValueUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalGradeValueUpdateInput = {
  gradeItem?: InputMaybe<ExternalGradeValueGradeItemUpdateFieldInput>;
  gradeText?: InputMaybe<Scalars['String']['input']>;
  gradedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lmsSource?: InputMaybe<LmsSource>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  percentage_ADD?: InputMaybe<Scalars['Float']['input']>;
  percentage_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  percentage_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  percentage_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_ADD?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId?: InputMaybe<Scalars['String']['input']>;
  providerGradeItemId?: InputMaybe<Scalars['String']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
  providerUserId?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Float']['input']>;
  score_ADD?: InputMaybe<Scalars['Float']['input']>;
  score_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  score_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  score_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<ExternalGradeValueUserUpdateFieldInput>;
};

export type ExternalGradeValueUserAggregateInput = {
  AND?: InputMaybe<Array<ExternalGradeValueUserAggregateInput>>;
  NOT?: InputMaybe<ExternalGradeValueUserAggregateInput>;
  OR?: InputMaybe<Array<ExternalGradeValueUserAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalGradeValueUserNodeAggregationWhereInput>;
};

export type ExternalGradeValueUserConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type ExternalGradeValueUserConnectOrCreateFieldInput = {
  onCreate: ExternalGradeValueUserConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type ExternalGradeValueUserConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type ExternalGradeValueUserConnection = {
  __typename?: 'ExternalGradeValueUserConnection';
  edges: Array<ExternalGradeValueUserRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalGradeValueUserConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type ExternalGradeValueUserConnectionWhere = {
  AND?: InputMaybe<Array<ExternalGradeValueUserConnectionWhere>>;
  NOT?: InputMaybe<ExternalGradeValueUserConnectionWhere>;
  OR?: InputMaybe<Array<ExternalGradeValueUserConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type ExternalGradeValueUserCreateFieldInput = {
  node: UserCreateInput;
};

export type ExternalGradeValueUserDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<ExternalGradeValueUserConnectionWhere>;
};

export type ExternalGradeValueUserDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<ExternalGradeValueUserConnectionWhere>;
};

export type ExternalGradeValueUserFieldInput = {
  connect?: InputMaybe<ExternalGradeValueUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalGradeValueUserConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalGradeValueUserCreateFieldInput>;
};

export type ExternalGradeValueUserNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalGradeValueUserNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalGradeValueUserNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalGradeValueUserNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalGradeValueUserRelationship = {
  __typename?: 'ExternalGradeValueUserRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type ExternalGradeValueUserUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type ExternalGradeValueUserUpdateFieldInput = {
  connect?: InputMaybe<ExternalGradeValueUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalGradeValueUserConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalGradeValueUserCreateFieldInput>;
  delete?: InputMaybe<ExternalGradeValueUserDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalGradeValueUserDisconnectFieldInput>;
  update?: InputMaybe<ExternalGradeValueUserUpdateConnectionInput>;
  where?: InputMaybe<ExternalGradeValueUserConnectionWhere>;
};

export type ExternalGradeValueUserUserAggregationSelection = {
  __typename?: 'ExternalGradeValueUserUserAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalGradeValueUserUserNodeAggregateSelection>;
};

export type ExternalGradeValueUserUserNodeAggregateSelection = {
  __typename?: 'ExternalGradeValueUserUserNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type ExternalGradeValueWhere = {
  AND?: InputMaybe<Array<ExternalGradeValueWhere>>;
  NOT?: InputMaybe<ExternalGradeValueWhere>;
  OR?: InputMaybe<Array<ExternalGradeValueWhere>>;
  gradeItem?: InputMaybe<ExternalGradeItemWhere>;
  gradeItemAggregate?: InputMaybe<ExternalGradeValueGradeItemAggregateInput>;
  gradeItemConnection?: InputMaybe<ExternalGradeValueGradeItemConnectionWhere>;
  gradeItemConnection_NOT?: InputMaybe<ExternalGradeValueGradeItemConnectionWhere>;
  gradeItem_NOT?: InputMaybe<ExternalGradeItemWhere>;
  gradeText?: InputMaybe<Scalars['String']['input']>;
  gradeText_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  gradeText_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  gradeText_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  gradeText_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  gradedAt?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  gradedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lmsSource?: InputMaybe<LmsSource>;
  lmsSource_IN?: InputMaybe<Array<LmsSource>>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  percentage_GT?: InputMaybe<Scalars['Float']['input']>;
  percentage_GTE?: InputMaybe<Scalars['Float']['input']>;
  percentage_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  percentage_LT?: InputMaybe<Scalars['Float']['input']>;
  percentage_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  pointsPossible_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerCourseId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerGradeItemId?: InputMaybe<Scalars['String']['input']>;
  providerGradeItemId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerGradeItemId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerGradeItemId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerGradeItemId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
  providerKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerKey_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerUserId?: InputMaybe<Scalars['String']['input']>;
  providerUserId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerUserId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerUserId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerUserId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Float']['input']>;
  score_GT?: InputMaybe<Scalars['Float']['input']>;
  score_GTE?: InputMaybe<Scalars['Float']['input']>;
  score_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  score_LT?: InputMaybe<Scalars['Float']['input']>;
  score_LTE?: InputMaybe<Scalars['Float']['input']>;
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourceMeta_IN?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload_IN?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  sourceUpdatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  syncedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserWhere>;
  userAggregate?: InputMaybe<ExternalGradeValueUserAggregateInput>;
  userConnection?: InputMaybe<ExternalGradeValueUserConnectionWhere>;
  userConnection_NOT?: InputMaybe<ExternalGradeValueUserConnectionWhere>;
  user_NOT?: InputMaybe<UserWhere>;
};

export enum ExternalGradeVisibility {
  Hidden = 'HIDDEN',
  Published = 'PUBLISHED',
  Unknown = 'UNKNOWN',
  Unpublished = 'UNPUBLISHED'
}

export type ExternalIntegration = {
  __typename?: 'ExternalIntegration';
  apiBaseUrl?: Maybe<Scalars['String']['output']>;
  apiKey?: Maybe<Scalars['String']['output']>;
  config?: Maybe<Scalars['String']['output']>;
  courses: Array<Course>;
  coursesAggregate?: Maybe<ExternalIntegrationCourseCoursesAggregationSelection>;
  coursesConnection: ExternalIntegrationCoursesConnection;
  id: Scalars['ID']['output'];
  provider: ExternalCredentialProvider;
  tenant: Tenant;
  tenantAggregate?: Maybe<ExternalIntegrationTenantTenantAggregationSelection>;
  tenantConnection: ExternalIntegrationTenantConnection;
  type: Scalars['String']['output'];
};


export type ExternalIntegrationCoursesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CourseOptions>;
  where?: InputMaybe<CourseWhere>;
};


export type ExternalIntegrationCoursesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CourseWhere>;
};


export type ExternalIntegrationCoursesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalIntegrationCoursesConnectionSort>>;
  where?: InputMaybe<ExternalIntegrationCoursesConnectionWhere>;
};


export type ExternalIntegrationTenantArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TenantOptions>;
  where?: InputMaybe<TenantWhere>;
};


export type ExternalIntegrationTenantAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TenantWhere>;
};


export type ExternalIntegrationTenantConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalIntegrationTenantConnectionSort>>;
  where?: InputMaybe<ExternalIntegrationTenantConnectionWhere>;
};

export type ExternalIntegrationConnectInput = {
  courses?: InputMaybe<Array<ExternalIntegrationCoursesConnectFieldInput>>;
  tenant?: InputMaybe<ExternalIntegrationTenantConnectFieldInput>;
};

export type ExternalIntegrationConnectOrCreateWhere = {
  node: ExternalIntegrationUniqueWhere;
};

export type ExternalIntegrationConnectWhere = {
  node: ExternalIntegrationWhere;
};

export type ExternalIntegrationCourseCoursesAggregationSelection = {
  __typename?: 'ExternalIntegrationCourseCoursesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalIntegrationCourseCoursesNodeAggregateSelection>;
};

export type ExternalIntegrationCourseCoursesNodeAggregateSelection = {
  __typename?: 'ExternalIntegrationCourseCoursesNodeAggregateSelection';
  account_id: FloatAggregateSelection;
  calendar_ics: StringAggregateSelection;
  cost: FloatAggregateSelection;
  courseId: StringAggregateSelection;
  course_code: StringAggregateSelection;
  course_id: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  default_view: StringAggregateSelection;
  description: StringAggregateSelection;
  dueDateEndDate: DateTimeAggregateSelection;
  dueDateStartDate: DateTimeAggregateSelection;
  endDate: DateTimeAggregateSelection;
  end_at: StringAggregateSelection;
  enrollment_term_id: FloatAggregateSelection;
  grading_standard_id: FloatAggregateSelection;
  id: IdAggregateSelection;
  integration_id: StringAggregateSelection;
  label: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  learningStandards: StringAggregateSelection;
  lengthInWeeks: FloatAggregateSelection;
  license: StringAggregateSelection;
  lti_id: StringAggregateSelection;
  name: StringAggregateSelection;
  original_name: StringAggregateSelection;
  root_account_id: FloatAggregateSelection;
  sis_course_id: StringAggregateSelection;
  sis_import_id: FloatAggregateSelection;
  startDate: DateTimeAggregateSelection;
  start_at: StringAggregateSelection;
  state: StringAggregateSelection;
  storage_quota_mb: FloatAggregateSelection;
  stripePriceId: StringAggregateSelection;
  stripeProductId: StringAggregateSelection;
  targetAudience: StringAggregateSelection;
  thumbnail: StringAggregateSelection;
  time_zone: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  uuid: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export type ExternalIntegrationCoursesAggregateInput = {
  AND?: InputMaybe<Array<ExternalIntegrationCoursesAggregateInput>>;
  NOT?: InputMaybe<ExternalIntegrationCoursesAggregateInput>;
  OR?: InputMaybe<Array<ExternalIntegrationCoursesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalIntegrationCoursesNodeAggregationWhereInput>;
};

export type ExternalIntegrationCoursesConnectFieldInput = {
  connect?: InputMaybe<Array<CourseConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CourseConnectWhere>;
};

export type ExternalIntegrationCoursesConnectOrCreateFieldInput = {
  onCreate: ExternalIntegrationCoursesConnectOrCreateFieldInputOnCreate;
  where: CourseConnectOrCreateWhere;
};

export type ExternalIntegrationCoursesConnectOrCreateFieldInputOnCreate = {
  node: CourseOnCreateInput;
};

export type ExternalIntegrationCoursesConnection = {
  __typename?: 'ExternalIntegrationCoursesConnection';
  edges: Array<ExternalIntegrationCoursesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalIntegrationCoursesConnectionSort = {
  node?: InputMaybe<CourseSort>;
};

export type ExternalIntegrationCoursesConnectionWhere = {
  AND?: InputMaybe<Array<ExternalIntegrationCoursesConnectionWhere>>;
  NOT?: InputMaybe<ExternalIntegrationCoursesConnectionWhere>;
  OR?: InputMaybe<Array<ExternalIntegrationCoursesConnectionWhere>>;
  node?: InputMaybe<CourseWhere>;
};

export type ExternalIntegrationCoursesCreateFieldInput = {
  node: CourseCreateInput;
};

export type ExternalIntegrationCoursesDeleteFieldInput = {
  delete?: InputMaybe<CourseDeleteInput>;
  where?: InputMaybe<ExternalIntegrationCoursesConnectionWhere>;
};

export type ExternalIntegrationCoursesDisconnectFieldInput = {
  disconnect?: InputMaybe<CourseDisconnectInput>;
  where?: InputMaybe<ExternalIntegrationCoursesConnectionWhere>;
};

export type ExternalIntegrationCoursesFieldInput = {
  connect?: InputMaybe<Array<ExternalIntegrationCoursesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalIntegrationCoursesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalIntegrationCoursesCreateFieldInput>>;
};

export type ExternalIntegrationCoursesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalIntegrationCoursesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalIntegrationCoursesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalIntegrationCoursesNodeAggregationWhereInput>>;
  account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  cost_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDateEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  enrollment_term_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  label_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningStandards_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthInWeeks_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  root_account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_import_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  startDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  storage_quota_mb_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalIntegrationCoursesRelationship = {
  __typename?: 'ExternalIntegrationCoursesRelationship';
  cursor: Scalars['String']['output'];
  node: Course;
};

export type ExternalIntegrationCoursesUpdateConnectionInput = {
  node?: InputMaybe<CourseUpdateInput>;
};

export type ExternalIntegrationCoursesUpdateFieldInput = {
  connect?: InputMaybe<Array<ExternalIntegrationCoursesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalIntegrationCoursesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalIntegrationCoursesCreateFieldInput>>;
  delete?: InputMaybe<Array<ExternalIntegrationCoursesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ExternalIntegrationCoursesDisconnectFieldInput>>;
  update?: InputMaybe<ExternalIntegrationCoursesUpdateConnectionInput>;
  where?: InputMaybe<ExternalIntegrationCoursesConnectionWhere>;
};

export type ExternalIntegrationCreateInput = {
  apiBaseUrl?: InputMaybe<Scalars['String']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['String']['input']>;
  courses?: InputMaybe<ExternalIntegrationCoursesFieldInput>;
  provider: ExternalCredentialProvider;
  tenant?: InputMaybe<ExternalIntegrationTenantFieldInput>;
  type: Scalars['String']['input'];
};

export type ExternalIntegrationDeleteInput = {
  courses?: InputMaybe<Array<ExternalIntegrationCoursesDeleteFieldInput>>;
  tenant?: InputMaybe<ExternalIntegrationTenantDeleteFieldInput>;
};

export type ExternalIntegrationDisconnectInput = {
  courses?: InputMaybe<Array<ExternalIntegrationCoursesDisconnectFieldInput>>;
  tenant?: InputMaybe<ExternalIntegrationTenantDisconnectFieldInput>;
};

export type ExternalIntegrationOnCreateInput = {
  apiBaseUrl?: InputMaybe<Scalars['String']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['String']['input']>;
  provider: ExternalCredentialProvider;
  type: Scalars['String']['input'];
};

export type ExternalIntegrationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ExternalIntegrationSort objects to sort ExternalIntegrations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ExternalIntegrationSort>>;
};

/** Fields to sort ExternalIntegrations by. The order in which sorts are applied is not guaranteed when specifying many fields in one ExternalIntegrationSort object. */
export type ExternalIntegrationSort = {
  apiBaseUrl?: InputMaybe<SortDirection>;
  apiKey?: InputMaybe<SortDirection>;
  config?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  provider?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export type ExternalIntegrationTenantAggregateInput = {
  AND?: InputMaybe<Array<ExternalIntegrationTenantAggregateInput>>;
  NOT?: InputMaybe<ExternalIntegrationTenantAggregateInput>;
  OR?: InputMaybe<Array<ExternalIntegrationTenantAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalIntegrationTenantNodeAggregationWhereInput>;
};

export type ExternalIntegrationTenantConnectFieldInput = {
  connect?: InputMaybe<TenantConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TenantConnectWhere>;
};

export type ExternalIntegrationTenantConnectOrCreateFieldInput = {
  onCreate: ExternalIntegrationTenantConnectOrCreateFieldInputOnCreate;
  where: TenantConnectOrCreateWhere;
};

export type ExternalIntegrationTenantConnectOrCreateFieldInputOnCreate = {
  node: TenantOnCreateInput;
};

export type ExternalIntegrationTenantConnection = {
  __typename?: 'ExternalIntegrationTenantConnection';
  edges: Array<ExternalIntegrationTenantRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalIntegrationTenantConnectionSort = {
  node?: InputMaybe<TenantSort>;
};

export type ExternalIntegrationTenantConnectionWhere = {
  AND?: InputMaybe<Array<ExternalIntegrationTenantConnectionWhere>>;
  NOT?: InputMaybe<ExternalIntegrationTenantConnectionWhere>;
  OR?: InputMaybe<Array<ExternalIntegrationTenantConnectionWhere>>;
  node?: InputMaybe<TenantWhere>;
};

export type ExternalIntegrationTenantCreateFieldInput = {
  node: TenantCreateInput;
};

export type ExternalIntegrationTenantDeleteFieldInput = {
  delete?: InputMaybe<TenantDeleteInput>;
  where?: InputMaybe<ExternalIntegrationTenantConnectionWhere>;
};

export type ExternalIntegrationTenantDisconnectFieldInput = {
  disconnect?: InputMaybe<TenantDisconnectInput>;
  where?: InputMaybe<ExternalIntegrationTenantConnectionWhere>;
};

export type ExternalIntegrationTenantFieldInput = {
  connect?: InputMaybe<ExternalIntegrationTenantConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalIntegrationTenantConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalIntegrationTenantCreateFieldInput>;
};

export type ExternalIntegrationTenantNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalIntegrationTenantNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalIntegrationTenantNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalIntegrationTenantNodeAggregationWhereInput>>;
  companionName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  companionName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  key_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  key_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogImage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  proLogo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalIntegrationTenantRelationship = {
  __typename?: 'ExternalIntegrationTenantRelationship';
  cursor: Scalars['String']['output'];
  node: Tenant;
};

export type ExternalIntegrationTenantTenantAggregationSelection = {
  __typename?: 'ExternalIntegrationTenantTenantAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalIntegrationTenantTenantNodeAggregateSelection>;
};

export type ExternalIntegrationTenantTenantNodeAggregateSelection = {
  __typename?: 'ExternalIntegrationTenantTenantNodeAggregateSelection';
  companionName: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  emailBackgroundColor: StringAggregateSelection;
  emailFooterColor: StringAggregateSelection;
  emulationStatement: StringAggregateSelection;
  externalSendGridDailyEmailTemplateId: StringAggregateSelection;
  externalSendGridFromEmail: StringAggregateSelection;
  externalSendGridFromName: StringAggregateSelection;
  externalSendGridTwilioServiceSID: StringAggregateSelection;
  favicon16Url: StringAggregateSelection;
  favicon32Url: StringAggregateSelection;
  favicon48Url: StringAggregateSelection;
  favicon180Url: StringAggregateSelection;
  favicon192Url: StringAggregateSelection;
  favicon512Url: StringAggregateSelection;
  faviconIcoUrl: StringAggregateSelection;
  financialInformationUrl: StringAggregateSelection;
  gameMenuBg: StringAggregateSelection;
  gameMenuCardBg: StringAggregateSelection;
  gameMenuProgress: StringAggregateSelection;
  gameMenuTrack: StringAggregateSelection;
  generalPrompt: StringAggregateSelection;
  helpCenterUrl: StringAggregateSelection;
  id: IdAggregateSelection;
  key: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  learningEmulationStatement: StringAggregateSelection;
  logo: StringAggregateSelection;
  ltiLaunchUrl: StringAggregateSelection;
  miniLogo: StringAggregateSelection;
  newsSearchTerms: StringAggregateSelection;
  officialTranscriptsUrl: StringAggregateSelection;
  ogDescription: StringAggregateSelection;
  ogImage: StringAggregateSelection;
  ogImageHeight: StringAggregateSelection;
  ogImageWidth: StringAggregateSelection;
  ogSiteName: StringAggregateSelection;
  ogTitle: StringAggregateSelection;
  ogType: StringAggregateSelection;
  onboardingPrompt: StringAggregateSelection;
  primaryColor: StringAggregateSelection;
  proLogo: StringAggregateSelection;
  reportProblemUrl: StringAggregateSelection;
  scheduleAdvisorCallUrl: StringAggregateSelection;
  schoolResourcesUrl: StringAggregateSelection;
  stripeSecretKey: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  stripeTrialDays: IntAggregateSelection;
  submitHelpTicketLink: StringAggregateSelection;
  tenantDomain: StringAggregateSelection;
  tenantName: StringAggregateSelection;
  termsOfServiceLink: StringAggregateSelection;
  upgradeModalBody: StringAggregateSelection;
};

export type ExternalIntegrationTenantUpdateConnectionInput = {
  node?: InputMaybe<TenantUpdateInput>;
};

export type ExternalIntegrationTenantUpdateFieldInput = {
  connect?: InputMaybe<ExternalIntegrationTenantConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalIntegrationTenantConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalIntegrationTenantCreateFieldInput>;
  delete?: InputMaybe<ExternalIntegrationTenantDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalIntegrationTenantDisconnectFieldInput>;
  update?: InputMaybe<ExternalIntegrationTenantUpdateConnectionInput>;
  where?: InputMaybe<ExternalIntegrationTenantConnectionWhere>;
};

export type ExternalIntegrationUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ExternalIntegrationUpdateInput = {
  apiBaseUrl?: InputMaybe<Scalars['String']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['String']['input']>;
  courses?: InputMaybe<Array<ExternalIntegrationCoursesUpdateFieldInput>>;
  provider?: InputMaybe<ExternalCredentialProvider>;
  tenant?: InputMaybe<ExternalIntegrationTenantUpdateFieldInput>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalIntegrationWhere = {
  AND?: InputMaybe<Array<ExternalIntegrationWhere>>;
  NOT?: InputMaybe<ExternalIntegrationWhere>;
  OR?: InputMaybe<Array<ExternalIntegrationWhere>>;
  apiBaseUrl?: InputMaybe<Scalars['String']['input']>;
  apiBaseUrl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  apiBaseUrl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  apiBaseUrl_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  apiBaseUrl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  apiKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  apiKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  apiKey_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  apiKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['String']['input']>;
  config_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  config_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  config_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  config_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  coursesAggregate?: InputMaybe<ExternalIntegrationCoursesAggregateInput>;
  /** Return ExternalIntegrations where all of the related ExternalIntegrationCoursesConnections match this filter */
  coursesConnection_ALL?: InputMaybe<ExternalIntegrationCoursesConnectionWhere>;
  /** Return ExternalIntegrations where none of the related ExternalIntegrationCoursesConnections match this filter */
  coursesConnection_NONE?: InputMaybe<ExternalIntegrationCoursesConnectionWhere>;
  /** Return ExternalIntegrations where one of the related ExternalIntegrationCoursesConnections match this filter */
  coursesConnection_SINGLE?: InputMaybe<ExternalIntegrationCoursesConnectionWhere>;
  /** Return ExternalIntegrations where some of the related ExternalIntegrationCoursesConnections match this filter */
  coursesConnection_SOME?: InputMaybe<ExternalIntegrationCoursesConnectionWhere>;
  /** Return ExternalIntegrations where all of the related Courses match this filter */
  courses_ALL?: InputMaybe<CourseWhere>;
  /** Return ExternalIntegrations where none of the related Courses match this filter */
  courses_NONE?: InputMaybe<CourseWhere>;
  /** Return ExternalIntegrations where one of the related Courses match this filter */
  courses_SINGLE?: InputMaybe<CourseWhere>;
  /** Return ExternalIntegrations where some of the related Courses match this filter */
  courses_SOME?: InputMaybe<CourseWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  provider?: InputMaybe<ExternalCredentialProvider>;
  provider_IN?: InputMaybe<Array<ExternalCredentialProvider>>;
  tenant?: InputMaybe<TenantWhere>;
  tenantAggregate?: InputMaybe<ExternalIntegrationTenantAggregateInput>;
  tenantConnection?: InputMaybe<ExternalIntegrationTenantConnectionWhere>;
  tenantConnection_NOT?: InputMaybe<ExternalIntegrationTenantConnectionWhere>;
  tenant_NOT?: InputMaybe<TenantWhere>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  type_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalModule = {
  __typename?: 'ExternalModule';
  course: ExternalCourse;
  courseAggregate?: Maybe<ExternalModuleExternalCourseCourseAggregationSelection>;
  courseConnection: ExternalModuleCourseConnection;
  id: Scalars['ID']['output'];
  items: Array<ExternalModuleItem>;
  itemsAggregate?: Maybe<ExternalModuleExternalModuleItemItemsAggregationSelection>;
  itemsConnection: ExternalModuleItemsConnection;
  lmsSource: LmsSource;
  position?: Maybe<Scalars['Int']['output']>;
  providerApiUrl?: Maybe<Scalars['String']['output']>;
  providerCourseId: Scalars['String']['output'];
  providerKey: Scalars['String']['output'];
  providerModuleId: Scalars['String']['output'];
  sourceMeta?: Maybe<Scalars['JSON']['output']>;
  sourcePayload?: Maybe<Scalars['JSON']['output']>;
  sourceUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  syncedAt: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
  visibility: ExternalModuleVisibility;
};


export type ExternalModuleCourseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalCourseOptions>;
  where?: InputMaybe<ExternalCourseWhere>;
};


export type ExternalModuleCourseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalCourseWhere>;
};


export type ExternalModuleCourseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalModuleCourseConnectionSort>>;
  where?: InputMaybe<ExternalModuleCourseConnectionWhere>;
};


export type ExternalModuleItemsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalModuleItemOptions>;
  where?: InputMaybe<ExternalModuleItemWhere>;
};


export type ExternalModuleItemsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalModuleItemWhere>;
};


export type ExternalModuleItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalModuleItemsConnectionSort>>;
  where?: InputMaybe<ExternalModuleItemsConnectionWhere>;
};

export type ExternalModuleConnectInput = {
  course?: InputMaybe<ExternalModuleCourseConnectFieldInput>;
  items?: InputMaybe<Array<ExternalModuleItemsConnectFieldInput>>;
};

export type ExternalModuleConnectOrCreateWhere = {
  node: ExternalModuleUniqueWhere;
};

export type ExternalModuleConnectWhere = {
  node: ExternalModuleWhere;
};

export type ExternalModuleCourseAggregateInput = {
  AND?: InputMaybe<Array<ExternalModuleCourseAggregateInput>>;
  NOT?: InputMaybe<ExternalModuleCourseAggregateInput>;
  OR?: InputMaybe<Array<ExternalModuleCourseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalModuleCourseNodeAggregationWhereInput>;
};

export type ExternalModuleCourseConnectFieldInput = {
  connect?: InputMaybe<ExternalCourseConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalCourseConnectWhere>;
};

export type ExternalModuleCourseConnectOrCreateFieldInput = {
  onCreate: ExternalModuleCourseConnectOrCreateFieldInputOnCreate;
  where: ExternalCourseConnectOrCreateWhere;
};

export type ExternalModuleCourseConnectOrCreateFieldInputOnCreate = {
  node: ExternalCourseOnCreateInput;
};

export type ExternalModuleCourseConnection = {
  __typename?: 'ExternalModuleCourseConnection';
  edges: Array<ExternalModuleCourseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalModuleCourseConnectionSort = {
  node?: InputMaybe<ExternalCourseSort>;
};

export type ExternalModuleCourseConnectionWhere = {
  AND?: InputMaybe<Array<ExternalModuleCourseConnectionWhere>>;
  NOT?: InputMaybe<ExternalModuleCourseConnectionWhere>;
  OR?: InputMaybe<Array<ExternalModuleCourseConnectionWhere>>;
  node?: InputMaybe<ExternalCourseWhere>;
};

export type ExternalModuleCourseCreateFieldInput = {
  node: ExternalCourseCreateInput;
};

export type ExternalModuleCourseDeleteFieldInput = {
  delete?: InputMaybe<ExternalCourseDeleteInput>;
  where?: InputMaybe<ExternalModuleCourseConnectionWhere>;
};

export type ExternalModuleCourseDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalCourseDisconnectInput>;
  where?: InputMaybe<ExternalModuleCourseConnectionWhere>;
};

export type ExternalModuleCourseFieldInput = {
  connect?: InputMaybe<ExternalModuleCourseConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalModuleCourseConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalModuleCourseCreateFieldInput>;
};

export type ExternalModuleCourseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalModuleCourseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalModuleCourseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalModuleCourseNodeAggregationWhereInput>>;
  courseCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  courseCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  courseCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  courseCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  courseCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  endDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalModuleCourseRelationship = {
  __typename?: 'ExternalModuleCourseRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalCourse;
};

export type ExternalModuleCourseUpdateConnectionInput = {
  node?: InputMaybe<ExternalCourseUpdateInput>;
};

export type ExternalModuleCourseUpdateFieldInput = {
  connect?: InputMaybe<ExternalModuleCourseConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalModuleCourseConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalModuleCourseCreateFieldInput>;
  delete?: InputMaybe<ExternalModuleCourseDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalModuleCourseDisconnectFieldInput>;
  update?: InputMaybe<ExternalModuleCourseUpdateConnectionInput>;
  where?: InputMaybe<ExternalModuleCourseConnectionWhere>;
};

export type ExternalModuleCreateInput = {
  course?: InputMaybe<ExternalModuleCourseFieldInput>;
  items?: InputMaybe<ExternalModuleItemsFieldInput>;
  lmsSource: LmsSource;
  position?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerCourseId: Scalars['String']['input'];
  providerKey: Scalars['String']['input'];
  providerModuleId: Scalars['String']['input'];
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  visibility: ExternalModuleVisibility;
};

export type ExternalModuleDeleteInput = {
  course?: InputMaybe<ExternalModuleCourseDeleteFieldInput>;
  items?: InputMaybe<Array<ExternalModuleItemsDeleteFieldInput>>;
};

export type ExternalModuleDisconnectInput = {
  course?: InputMaybe<ExternalModuleCourseDisconnectFieldInput>;
  items?: InputMaybe<Array<ExternalModuleItemsDisconnectFieldInput>>;
};

export type ExternalModuleExternalCourseCourseAggregationSelection = {
  __typename?: 'ExternalModuleExternalCourseCourseAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalModuleExternalCourseCourseNodeAggregateSelection>;
};

export type ExternalModuleExternalCourseCourseNodeAggregateSelection = {
  __typename?: 'ExternalModuleExternalCourseCourseNodeAggregateSelection';
  courseCode: StringAggregateSelection;
  descriptionHtml: StringAggregateSelection;
  descriptionText: StringAggregateSelection;
  endDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  name: StringAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  startDate: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalModuleExternalModuleItemItemsAggregationSelection = {
  __typename?: 'ExternalModuleExternalModuleItemItemsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalModuleExternalModuleItemItemsNodeAggregateSelection>;
};

export type ExternalModuleExternalModuleItemItemsNodeAggregateSelection = {
  __typename?: 'ExternalModuleExternalModuleItemItemsNodeAggregateSelection';
  externalUrl: StringAggregateSelection;
  id: IdAggregateSelection;
  position: IntAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  providerModuleId: StringAggregateSelection;
  providerModuleItemId: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  title: StringAggregateSelection;
};

export type ExternalModuleItem = {
  __typename?: 'ExternalModuleItem';
  announcement?: Maybe<ExternalAnnouncement>;
  announcementAggregate?: Maybe<ExternalModuleItemExternalAnnouncementAnnouncementAggregationSelection>;
  announcementConnection: ExternalModuleItemAnnouncementConnection;
  assignment?: Maybe<ExternalAssignment>;
  assignmentAggregate?: Maybe<ExternalModuleItemExternalAssignmentAssignmentAggregationSelection>;
  assignmentConnection: ExternalModuleItemAssignmentConnection;
  discussion?: Maybe<ExternalDiscussionBoard>;
  discussionAggregate?: Maybe<ExternalModuleItemExternalDiscussionBoardDiscussionAggregationSelection>;
  discussionConnection: ExternalModuleItemDiscussionConnection;
  externalUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lmsSource: LmsSource;
  module: ExternalModule;
  moduleAggregate?: Maybe<ExternalModuleItemExternalModuleModuleAggregationSelection>;
  moduleConnection: ExternalModuleItemModuleConnection;
  page?: Maybe<ExternalPage>;
  pageAggregate?: Maybe<ExternalModuleItemExternalPagePageAggregationSelection>;
  pageConnection: ExternalModuleItemPageConnection;
  position?: Maybe<Scalars['Int']['output']>;
  providerApiUrl?: Maybe<Scalars['String']['output']>;
  providerCourseId: Scalars['String']['output'];
  providerKey: Scalars['String']['output'];
  providerModuleId: Scalars['String']['output'];
  providerModuleItemId: Scalars['String']['output'];
  quiz?: Maybe<ExternalQuiz>;
  quizAggregate?: Maybe<ExternalModuleItemExternalQuizQuizAggregationSelection>;
  quizConnection: ExternalModuleItemQuizConnection;
  sourceMeta?: Maybe<Scalars['JSON']['output']>;
  sourcePayload?: Maybe<Scalars['JSON']['output']>;
  sourceUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  syncedAt: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  type: ExternalModuleItemType;
  visibility: ExternalModuleVisibility;
};


export type ExternalModuleItemAnnouncementArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalAnnouncementOptions>;
  where?: InputMaybe<ExternalAnnouncementWhere>;
};


export type ExternalModuleItemAnnouncementAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalAnnouncementWhere>;
};


export type ExternalModuleItemAnnouncementConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalModuleItemAnnouncementConnectionSort>>;
  where?: InputMaybe<ExternalModuleItemAnnouncementConnectionWhere>;
};


export type ExternalModuleItemAssignmentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalAssignmentOptions>;
  where?: InputMaybe<ExternalAssignmentWhere>;
};


export type ExternalModuleItemAssignmentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalAssignmentWhere>;
};


export type ExternalModuleItemAssignmentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalModuleItemAssignmentConnectionSort>>;
  where?: InputMaybe<ExternalModuleItemAssignmentConnectionWhere>;
};


export type ExternalModuleItemDiscussionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalDiscussionBoardOptions>;
  where?: InputMaybe<ExternalDiscussionBoardWhere>;
};


export type ExternalModuleItemDiscussionAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalDiscussionBoardWhere>;
};


export type ExternalModuleItemDiscussionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalModuleItemDiscussionConnectionSort>>;
  where?: InputMaybe<ExternalModuleItemDiscussionConnectionWhere>;
};


export type ExternalModuleItemModuleArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalModuleOptions>;
  where?: InputMaybe<ExternalModuleWhere>;
};


export type ExternalModuleItemModuleAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalModuleWhere>;
};


export type ExternalModuleItemModuleConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalModuleItemModuleConnectionSort>>;
  where?: InputMaybe<ExternalModuleItemModuleConnectionWhere>;
};


export type ExternalModuleItemPageArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalPageOptions>;
  where?: InputMaybe<ExternalPageWhere>;
};


export type ExternalModuleItemPageAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalPageWhere>;
};


export type ExternalModuleItemPageConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalModuleItemPageConnectionSort>>;
  where?: InputMaybe<ExternalModuleItemPageConnectionWhere>;
};


export type ExternalModuleItemQuizArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalQuizOptions>;
  where?: InputMaybe<ExternalQuizWhere>;
};


export type ExternalModuleItemQuizAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalQuizWhere>;
};


export type ExternalModuleItemQuizConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalModuleItemQuizConnectionSort>>;
  where?: InputMaybe<ExternalModuleItemQuizConnectionWhere>;
};

export type ExternalModuleItemAnnouncementAggregateInput = {
  AND?: InputMaybe<Array<ExternalModuleItemAnnouncementAggregateInput>>;
  NOT?: InputMaybe<ExternalModuleItemAnnouncementAggregateInput>;
  OR?: InputMaybe<Array<ExternalModuleItemAnnouncementAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalModuleItemAnnouncementNodeAggregationWhereInput>;
};

export type ExternalModuleItemAnnouncementConnectFieldInput = {
  connect?: InputMaybe<ExternalAnnouncementConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalAnnouncementConnectWhere>;
};

export type ExternalModuleItemAnnouncementConnectOrCreateFieldInput = {
  onCreate: ExternalModuleItemAnnouncementConnectOrCreateFieldInputOnCreate;
  where: ExternalAnnouncementConnectOrCreateWhere;
};

export type ExternalModuleItemAnnouncementConnectOrCreateFieldInputOnCreate = {
  node: ExternalAnnouncementOnCreateInput;
};

export type ExternalModuleItemAnnouncementConnection = {
  __typename?: 'ExternalModuleItemAnnouncementConnection';
  edges: Array<ExternalModuleItemAnnouncementRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalModuleItemAnnouncementConnectionSort = {
  node?: InputMaybe<ExternalAnnouncementSort>;
};

export type ExternalModuleItemAnnouncementConnectionWhere = {
  AND?: InputMaybe<Array<ExternalModuleItemAnnouncementConnectionWhere>>;
  NOT?: InputMaybe<ExternalModuleItemAnnouncementConnectionWhere>;
  OR?: InputMaybe<Array<ExternalModuleItemAnnouncementConnectionWhere>>;
  node?: InputMaybe<ExternalAnnouncementWhere>;
};

export type ExternalModuleItemAnnouncementCreateFieldInput = {
  node: ExternalAnnouncementCreateInput;
};

export type ExternalModuleItemAnnouncementDeleteFieldInput = {
  delete?: InputMaybe<ExternalAnnouncementDeleteInput>;
  where?: InputMaybe<ExternalModuleItemAnnouncementConnectionWhere>;
};

export type ExternalModuleItemAnnouncementDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalAnnouncementDisconnectInput>;
  where?: InputMaybe<ExternalModuleItemAnnouncementConnectionWhere>;
};

export type ExternalModuleItemAnnouncementFieldInput = {
  connect?: InputMaybe<ExternalModuleItemAnnouncementConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalModuleItemAnnouncementConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalModuleItemAnnouncementCreateFieldInput>;
};

export type ExternalModuleItemAnnouncementNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalModuleItemAnnouncementNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalModuleItemAnnouncementNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalModuleItemAnnouncementNodeAggregationWhereInput>>;
  bodyHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bodyText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  bodyText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  bodyText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  bodyText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  bodyText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  bodyText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bodyText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bodyText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bodyText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bodyText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  postedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  providerAnnouncementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerAnnouncementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerAnnouncementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerAnnouncementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerAnnouncementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerAnnouncementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalModuleItemAnnouncementRelationship = {
  __typename?: 'ExternalModuleItemAnnouncementRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalAnnouncement;
};

export type ExternalModuleItemAnnouncementUpdateConnectionInput = {
  node?: InputMaybe<ExternalAnnouncementUpdateInput>;
};

export type ExternalModuleItemAnnouncementUpdateFieldInput = {
  connect?: InputMaybe<ExternalModuleItemAnnouncementConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalModuleItemAnnouncementConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalModuleItemAnnouncementCreateFieldInput>;
  delete?: InputMaybe<ExternalModuleItemAnnouncementDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalModuleItemAnnouncementDisconnectFieldInput>;
  update?: InputMaybe<ExternalModuleItemAnnouncementUpdateConnectionInput>;
  where?: InputMaybe<ExternalModuleItemAnnouncementConnectionWhere>;
};

export type ExternalModuleItemAssignmentAggregateInput = {
  AND?: InputMaybe<Array<ExternalModuleItemAssignmentAggregateInput>>;
  NOT?: InputMaybe<ExternalModuleItemAssignmentAggregateInput>;
  OR?: InputMaybe<Array<ExternalModuleItemAssignmentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalModuleItemAssignmentNodeAggregationWhereInput>;
};

export type ExternalModuleItemAssignmentConnectFieldInput = {
  connect?: InputMaybe<ExternalAssignmentConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalAssignmentConnectWhere>;
};

export type ExternalModuleItemAssignmentConnectOrCreateFieldInput = {
  onCreate: ExternalModuleItemAssignmentConnectOrCreateFieldInputOnCreate;
  where: ExternalAssignmentConnectOrCreateWhere;
};

export type ExternalModuleItemAssignmentConnectOrCreateFieldInputOnCreate = {
  node: ExternalAssignmentOnCreateInput;
};

export type ExternalModuleItemAssignmentConnection = {
  __typename?: 'ExternalModuleItemAssignmentConnection';
  edges: Array<ExternalModuleItemAssignmentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalModuleItemAssignmentConnectionSort = {
  node?: InputMaybe<ExternalAssignmentSort>;
};

export type ExternalModuleItemAssignmentConnectionWhere = {
  AND?: InputMaybe<Array<ExternalModuleItemAssignmentConnectionWhere>>;
  NOT?: InputMaybe<ExternalModuleItemAssignmentConnectionWhere>;
  OR?: InputMaybe<Array<ExternalModuleItemAssignmentConnectionWhere>>;
  node?: InputMaybe<ExternalAssignmentWhere>;
};

export type ExternalModuleItemAssignmentCreateFieldInput = {
  node: ExternalAssignmentCreateInput;
};

export type ExternalModuleItemAssignmentDeleteFieldInput = {
  delete?: InputMaybe<ExternalAssignmentDeleteInput>;
  where?: InputMaybe<ExternalModuleItemAssignmentConnectionWhere>;
};

export type ExternalModuleItemAssignmentDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalAssignmentDisconnectInput>;
  where?: InputMaybe<ExternalModuleItemAssignmentConnectionWhere>;
};

export type ExternalModuleItemAssignmentFieldInput = {
  connect?: InputMaybe<ExternalModuleItemAssignmentConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalModuleItemAssignmentConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalModuleItemAssignmentCreateFieldInput>;
};

export type ExternalModuleItemAssignmentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalModuleItemAssignmentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalModuleItemAssignmentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalModuleItemAssignmentNodeAggregationWhereInput>>;
  availableFrom_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  descriptionHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradingType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gradingType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gradingType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gradingType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gradingType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gradingType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gradingType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gradingType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gradingType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gradingType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gradingType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gradingType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gradingType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gradingType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gradingType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pointsPossible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerAssignmentId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerAssignmentId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerAssignmentId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerAssignmentId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerAssignmentId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalModuleItemAssignmentRelationship = {
  __typename?: 'ExternalModuleItemAssignmentRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalAssignment;
};

export type ExternalModuleItemAssignmentUpdateConnectionInput = {
  node?: InputMaybe<ExternalAssignmentUpdateInput>;
};

export type ExternalModuleItemAssignmentUpdateFieldInput = {
  connect?: InputMaybe<ExternalModuleItemAssignmentConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalModuleItemAssignmentConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalModuleItemAssignmentCreateFieldInput>;
  delete?: InputMaybe<ExternalModuleItemAssignmentDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalModuleItemAssignmentDisconnectFieldInput>;
  update?: InputMaybe<ExternalModuleItemAssignmentUpdateConnectionInput>;
  where?: InputMaybe<ExternalModuleItemAssignmentConnectionWhere>;
};

export type ExternalModuleItemConnectInput = {
  announcement?: InputMaybe<ExternalModuleItemAnnouncementConnectFieldInput>;
  assignment?: InputMaybe<ExternalModuleItemAssignmentConnectFieldInput>;
  discussion?: InputMaybe<ExternalModuleItemDiscussionConnectFieldInput>;
  module?: InputMaybe<ExternalModuleItemModuleConnectFieldInput>;
  page?: InputMaybe<ExternalModuleItemPageConnectFieldInput>;
  quiz?: InputMaybe<ExternalModuleItemQuizConnectFieldInput>;
};

export type ExternalModuleItemConnectOrCreateWhere = {
  node: ExternalModuleItemUniqueWhere;
};

export type ExternalModuleItemConnectWhere = {
  node: ExternalModuleItemWhere;
};

export type ExternalModuleItemCreateInput = {
  announcement?: InputMaybe<ExternalModuleItemAnnouncementFieldInput>;
  assignment?: InputMaybe<ExternalModuleItemAssignmentFieldInput>;
  discussion?: InputMaybe<ExternalModuleItemDiscussionFieldInput>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  lmsSource: LmsSource;
  module?: InputMaybe<ExternalModuleItemModuleFieldInput>;
  page?: InputMaybe<ExternalModuleItemPageFieldInput>;
  position?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerCourseId: Scalars['String']['input'];
  providerKey: Scalars['String']['input'];
  providerModuleId: Scalars['String']['input'];
  providerModuleItemId: Scalars['String']['input'];
  quiz?: InputMaybe<ExternalModuleItemQuizFieldInput>;
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
  type: ExternalModuleItemType;
  visibility: ExternalModuleVisibility;
};

export type ExternalModuleItemDeleteInput = {
  announcement?: InputMaybe<ExternalModuleItemAnnouncementDeleteFieldInput>;
  assignment?: InputMaybe<ExternalModuleItemAssignmentDeleteFieldInput>;
  discussion?: InputMaybe<ExternalModuleItemDiscussionDeleteFieldInput>;
  module?: InputMaybe<ExternalModuleItemModuleDeleteFieldInput>;
  page?: InputMaybe<ExternalModuleItemPageDeleteFieldInput>;
  quiz?: InputMaybe<ExternalModuleItemQuizDeleteFieldInput>;
};

export type ExternalModuleItemDisconnectInput = {
  announcement?: InputMaybe<ExternalModuleItemAnnouncementDisconnectFieldInput>;
  assignment?: InputMaybe<ExternalModuleItemAssignmentDisconnectFieldInput>;
  discussion?: InputMaybe<ExternalModuleItemDiscussionDisconnectFieldInput>;
  module?: InputMaybe<ExternalModuleItemModuleDisconnectFieldInput>;
  page?: InputMaybe<ExternalModuleItemPageDisconnectFieldInput>;
  quiz?: InputMaybe<ExternalModuleItemQuizDisconnectFieldInput>;
};

export type ExternalModuleItemDiscussionAggregateInput = {
  AND?: InputMaybe<Array<ExternalModuleItemDiscussionAggregateInput>>;
  NOT?: InputMaybe<ExternalModuleItemDiscussionAggregateInput>;
  OR?: InputMaybe<Array<ExternalModuleItemDiscussionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalModuleItemDiscussionNodeAggregationWhereInput>;
};

export type ExternalModuleItemDiscussionConnectFieldInput = {
  connect?: InputMaybe<ExternalDiscussionBoardConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalDiscussionBoardConnectWhere>;
};

export type ExternalModuleItemDiscussionConnectOrCreateFieldInput = {
  onCreate: ExternalModuleItemDiscussionConnectOrCreateFieldInputOnCreate;
  where: ExternalDiscussionBoardConnectOrCreateWhere;
};

export type ExternalModuleItemDiscussionConnectOrCreateFieldInputOnCreate = {
  node: ExternalDiscussionBoardOnCreateInput;
};

export type ExternalModuleItemDiscussionConnection = {
  __typename?: 'ExternalModuleItemDiscussionConnection';
  edges: Array<ExternalModuleItemDiscussionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalModuleItemDiscussionConnectionSort = {
  node?: InputMaybe<ExternalDiscussionBoardSort>;
};

export type ExternalModuleItemDiscussionConnectionWhere = {
  AND?: InputMaybe<Array<ExternalModuleItemDiscussionConnectionWhere>>;
  NOT?: InputMaybe<ExternalModuleItemDiscussionConnectionWhere>;
  OR?: InputMaybe<Array<ExternalModuleItemDiscussionConnectionWhere>>;
  node?: InputMaybe<ExternalDiscussionBoardWhere>;
};

export type ExternalModuleItemDiscussionCreateFieldInput = {
  node: ExternalDiscussionBoardCreateInput;
};

export type ExternalModuleItemDiscussionDeleteFieldInput = {
  delete?: InputMaybe<ExternalDiscussionBoardDeleteInput>;
  where?: InputMaybe<ExternalModuleItemDiscussionConnectionWhere>;
};

export type ExternalModuleItemDiscussionDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalDiscussionBoardDisconnectInput>;
  where?: InputMaybe<ExternalModuleItemDiscussionConnectionWhere>;
};

export type ExternalModuleItemDiscussionFieldInput = {
  connect?: InputMaybe<ExternalModuleItemDiscussionConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalModuleItemDiscussionConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalModuleItemDiscussionCreateFieldInput>;
};

export type ExternalModuleItemDiscussionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalModuleItemDiscussionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalModuleItemDiscussionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalModuleItemDiscussionNodeAggregationWhereInput>>;
  availableFrom_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  messageHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  messageHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  messageHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  messageHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  messageHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  messageHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  messageText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  messageText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  messageText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  messageText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  messageText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  messageText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  messageText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  messageText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  messageText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  messageText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  messageText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  messageText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  messageText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  messageText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  messageText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pointsPossible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerDiscussionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerDiscussionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerDiscussionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerDiscussionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerDiscussionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalModuleItemDiscussionRelationship = {
  __typename?: 'ExternalModuleItemDiscussionRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalDiscussionBoard;
};

export type ExternalModuleItemDiscussionUpdateConnectionInput = {
  node?: InputMaybe<ExternalDiscussionBoardUpdateInput>;
};

export type ExternalModuleItemDiscussionUpdateFieldInput = {
  connect?: InputMaybe<ExternalModuleItemDiscussionConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalModuleItemDiscussionConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalModuleItemDiscussionCreateFieldInput>;
  delete?: InputMaybe<ExternalModuleItemDiscussionDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalModuleItemDiscussionDisconnectFieldInput>;
  update?: InputMaybe<ExternalModuleItemDiscussionUpdateConnectionInput>;
  where?: InputMaybe<ExternalModuleItemDiscussionConnectionWhere>;
};

export type ExternalModuleItemExternalAnnouncementAnnouncementAggregationSelection = {
  __typename?: 'ExternalModuleItemExternalAnnouncementAnnouncementAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalModuleItemExternalAnnouncementAnnouncementNodeAggregateSelection>;
};

export type ExternalModuleItemExternalAnnouncementAnnouncementNodeAggregateSelection = {
  __typename?: 'ExternalModuleItemExternalAnnouncementAnnouncementNodeAggregateSelection';
  bodyHtml: StringAggregateSelection;
  bodyText: StringAggregateSelection;
  id: IdAggregateSelection;
  postedAt: DateTimeAggregateSelection;
  providerAnnouncementId: StringAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  title: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalModuleItemExternalAssignmentAssignmentAggregationSelection = {
  __typename?: 'ExternalModuleItemExternalAssignmentAssignmentAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalModuleItemExternalAssignmentAssignmentNodeAggregateSelection>;
};

export type ExternalModuleItemExternalAssignmentAssignmentNodeAggregateSelection = {
  __typename?: 'ExternalModuleItemExternalAssignmentAssignmentNodeAggregateSelection';
  availableFrom: DateTimeAggregateSelection;
  availableUntil: DateTimeAggregateSelection;
  descriptionHtml: StringAggregateSelection;
  descriptionText: StringAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  gradingType: StringAggregateSelection;
  id: IdAggregateSelection;
  pointsPossible: FloatAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerAssignmentId: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  title: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalModuleItemExternalDiscussionBoardDiscussionAggregationSelection = {
  __typename?: 'ExternalModuleItemExternalDiscussionBoardDiscussionAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalModuleItemExternalDiscussionBoardDiscussionNodeAggregateSelection>;
};

export type ExternalModuleItemExternalDiscussionBoardDiscussionNodeAggregateSelection = {
  __typename?: 'ExternalModuleItemExternalDiscussionBoardDiscussionNodeAggregateSelection';
  availableFrom: DateTimeAggregateSelection;
  availableUntil: DateTimeAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  messageHtml: StringAggregateSelection;
  messageText: StringAggregateSelection;
  pointsPossible: FloatAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerDiscussionId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  title: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalModuleItemExternalModuleModuleAggregationSelection = {
  __typename?: 'ExternalModuleItemExternalModuleModuleAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalModuleItemExternalModuleModuleNodeAggregateSelection>;
};

export type ExternalModuleItemExternalModuleModuleNodeAggregateSelection = {
  __typename?: 'ExternalModuleItemExternalModuleModuleNodeAggregateSelection';
  id: IdAggregateSelection;
  position: IntAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  providerModuleId: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  title: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalModuleItemExternalPagePageAggregationSelection = {
  __typename?: 'ExternalModuleItemExternalPagePageAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalModuleItemExternalPagePageNodeAggregateSelection>;
};

export type ExternalModuleItemExternalPagePageNodeAggregateSelection = {
  __typename?: 'ExternalModuleItemExternalPagePageNodeAggregateSelection';
  bodyHtml: StringAggregateSelection;
  bodyText: StringAggregateSelection;
  id: IdAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  providerPageId: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  title: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalModuleItemExternalQuizQuizAggregationSelection = {
  __typename?: 'ExternalModuleItemExternalQuizQuizAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalModuleItemExternalQuizQuizNodeAggregateSelection>;
};

export type ExternalModuleItemExternalQuizQuizNodeAggregateSelection = {
  __typename?: 'ExternalModuleItemExternalQuizQuizNodeAggregateSelection';
  attemptsAllowed: IntAggregateSelection;
  availableFrom: DateTimeAggregateSelection;
  availableUntil: DateTimeAggregateSelection;
  descriptionHtml: StringAggregateSelection;
  descriptionText: StringAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  pointsPossible: FloatAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  providerQuizId: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  timeLimitMinutes: IntAggregateSelection;
  title: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalModuleItemModuleAggregateInput = {
  AND?: InputMaybe<Array<ExternalModuleItemModuleAggregateInput>>;
  NOT?: InputMaybe<ExternalModuleItemModuleAggregateInput>;
  OR?: InputMaybe<Array<ExternalModuleItemModuleAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalModuleItemModuleNodeAggregationWhereInput>;
};

export type ExternalModuleItemModuleConnectFieldInput = {
  connect?: InputMaybe<ExternalModuleConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalModuleConnectWhere>;
};

export type ExternalModuleItemModuleConnectOrCreateFieldInput = {
  onCreate: ExternalModuleItemModuleConnectOrCreateFieldInputOnCreate;
  where: ExternalModuleConnectOrCreateWhere;
};

export type ExternalModuleItemModuleConnectOrCreateFieldInputOnCreate = {
  node: ExternalModuleOnCreateInput;
};

export type ExternalModuleItemModuleConnection = {
  __typename?: 'ExternalModuleItemModuleConnection';
  edges: Array<ExternalModuleItemModuleRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalModuleItemModuleConnectionSort = {
  node?: InputMaybe<ExternalModuleSort>;
};

export type ExternalModuleItemModuleConnectionWhere = {
  AND?: InputMaybe<Array<ExternalModuleItemModuleConnectionWhere>>;
  NOT?: InputMaybe<ExternalModuleItemModuleConnectionWhere>;
  OR?: InputMaybe<Array<ExternalModuleItemModuleConnectionWhere>>;
  node?: InputMaybe<ExternalModuleWhere>;
};

export type ExternalModuleItemModuleCreateFieldInput = {
  node: ExternalModuleCreateInput;
};

export type ExternalModuleItemModuleDeleteFieldInput = {
  delete?: InputMaybe<ExternalModuleDeleteInput>;
  where?: InputMaybe<ExternalModuleItemModuleConnectionWhere>;
};

export type ExternalModuleItemModuleDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalModuleDisconnectInput>;
  where?: InputMaybe<ExternalModuleItemModuleConnectionWhere>;
};

export type ExternalModuleItemModuleFieldInput = {
  connect?: InputMaybe<ExternalModuleItemModuleConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalModuleItemModuleConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalModuleItemModuleCreateFieldInput>;
};

export type ExternalModuleItemModuleNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalModuleItemModuleNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalModuleItemModuleNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalModuleItemModuleNodeAggregationWhereInput>>;
  position_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerModuleId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerModuleId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerModuleId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerModuleId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerModuleId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalModuleItemModuleRelationship = {
  __typename?: 'ExternalModuleItemModuleRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalModule;
};

export type ExternalModuleItemModuleUpdateConnectionInput = {
  node?: InputMaybe<ExternalModuleUpdateInput>;
};

export type ExternalModuleItemModuleUpdateFieldInput = {
  connect?: InputMaybe<ExternalModuleItemModuleConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalModuleItemModuleConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalModuleItemModuleCreateFieldInput>;
  delete?: InputMaybe<ExternalModuleItemModuleDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalModuleItemModuleDisconnectFieldInput>;
  update?: InputMaybe<ExternalModuleItemModuleUpdateConnectionInput>;
  where?: InputMaybe<ExternalModuleItemModuleConnectionWhere>;
};

export type ExternalModuleItemOnCreateInput = {
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  lmsSource: LmsSource;
  position?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerCourseId: Scalars['String']['input'];
  providerKey: Scalars['String']['input'];
  providerModuleId: Scalars['String']['input'];
  providerModuleItemId: Scalars['String']['input'];
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
  type: ExternalModuleItemType;
  visibility: ExternalModuleVisibility;
};

export type ExternalModuleItemOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ExternalModuleItemSort objects to sort ExternalModuleItems by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ExternalModuleItemSort>>;
};

export type ExternalModuleItemPageAggregateInput = {
  AND?: InputMaybe<Array<ExternalModuleItemPageAggregateInput>>;
  NOT?: InputMaybe<ExternalModuleItemPageAggregateInput>;
  OR?: InputMaybe<Array<ExternalModuleItemPageAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalModuleItemPageNodeAggregationWhereInput>;
};

export type ExternalModuleItemPageConnectFieldInput = {
  connect?: InputMaybe<ExternalPageConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalPageConnectWhere>;
};

export type ExternalModuleItemPageConnectOrCreateFieldInput = {
  onCreate: ExternalModuleItemPageConnectOrCreateFieldInputOnCreate;
  where: ExternalPageConnectOrCreateWhere;
};

export type ExternalModuleItemPageConnectOrCreateFieldInputOnCreate = {
  node: ExternalPageOnCreateInput;
};

export type ExternalModuleItemPageConnection = {
  __typename?: 'ExternalModuleItemPageConnection';
  edges: Array<ExternalModuleItemPageRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalModuleItemPageConnectionSort = {
  node?: InputMaybe<ExternalPageSort>;
};

export type ExternalModuleItemPageConnectionWhere = {
  AND?: InputMaybe<Array<ExternalModuleItemPageConnectionWhere>>;
  NOT?: InputMaybe<ExternalModuleItemPageConnectionWhere>;
  OR?: InputMaybe<Array<ExternalModuleItemPageConnectionWhere>>;
  node?: InputMaybe<ExternalPageWhere>;
};

export type ExternalModuleItemPageCreateFieldInput = {
  node: ExternalPageCreateInput;
};

export type ExternalModuleItemPageDeleteFieldInput = {
  delete?: InputMaybe<ExternalPageDeleteInput>;
  where?: InputMaybe<ExternalModuleItemPageConnectionWhere>;
};

export type ExternalModuleItemPageDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalPageDisconnectInput>;
  where?: InputMaybe<ExternalModuleItemPageConnectionWhere>;
};

export type ExternalModuleItemPageFieldInput = {
  connect?: InputMaybe<ExternalModuleItemPageConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalModuleItemPageConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalModuleItemPageCreateFieldInput>;
};

export type ExternalModuleItemPageNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalModuleItemPageNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalModuleItemPageNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalModuleItemPageNodeAggregationWhereInput>>;
  bodyHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bodyText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  bodyText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  bodyText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  bodyText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  bodyText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  bodyText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bodyText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bodyText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bodyText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bodyText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerPageId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerPageId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerPageId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerPageId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerPageId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerPageId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerPageId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerPageId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerPageId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerPageId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerPageId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerPageId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerPageId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerPageId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerPageId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalModuleItemPageRelationship = {
  __typename?: 'ExternalModuleItemPageRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalPage;
};

export type ExternalModuleItemPageUpdateConnectionInput = {
  node?: InputMaybe<ExternalPageUpdateInput>;
};

export type ExternalModuleItemPageUpdateFieldInput = {
  connect?: InputMaybe<ExternalModuleItemPageConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalModuleItemPageConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalModuleItemPageCreateFieldInput>;
  delete?: InputMaybe<ExternalModuleItemPageDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalModuleItemPageDisconnectFieldInput>;
  update?: InputMaybe<ExternalModuleItemPageUpdateConnectionInput>;
  where?: InputMaybe<ExternalModuleItemPageConnectionWhere>;
};

export type ExternalModuleItemQuizAggregateInput = {
  AND?: InputMaybe<Array<ExternalModuleItemQuizAggregateInput>>;
  NOT?: InputMaybe<ExternalModuleItemQuizAggregateInput>;
  OR?: InputMaybe<Array<ExternalModuleItemQuizAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalModuleItemQuizNodeAggregationWhereInput>;
};

export type ExternalModuleItemQuizConnectFieldInput = {
  connect?: InputMaybe<ExternalQuizConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalQuizConnectWhere>;
};

export type ExternalModuleItemQuizConnectOrCreateFieldInput = {
  onCreate: ExternalModuleItemQuizConnectOrCreateFieldInputOnCreate;
  where: ExternalQuizConnectOrCreateWhere;
};

export type ExternalModuleItemQuizConnectOrCreateFieldInputOnCreate = {
  node: ExternalQuizOnCreateInput;
};

export type ExternalModuleItemQuizConnection = {
  __typename?: 'ExternalModuleItemQuizConnection';
  edges: Array<ExternalModuleItemQuizRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalModuleItemQuizConnectionSort = {
  node?: InputMaybe<ExternalQuizSort>;
};

export type ExternalModuleItemQuizConnectionWhere = {
  AND?: InputMaybe<Array<ExternalModuleItemQuizConnectionWhere>>;
  NOT?: InputMaybe<ExternalModuleItemQuizConnectionWhere>;
  OR?: InputMaybe<Array<ExternalModuleItemQuizConnectionWhere>>;
  node?: InputMaybe<ExternalQuizWhere>;
};

export type ExternalModuleItemQuizCreateFieldInput = {
  node: ExternalQuizCreateInput;
};

export type ExternalModuleItemQuizDeleteFieldInput = {
  delete?: InputMaybe<ExternalQuizDeleteInput>;
  where?: InputMaybe<ExternalModuleItemQuizConnectionWhere>;
};

export type ExternalModuleItemQuizDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalQuizDisconnectInput>;
  where?: InputMaybe<ExternalModuleItemQuizConnectionWhere>;
};

export type ExternalModuleItemQuizFieldInput = {
  connect?: InputMaybe<ExternalModuleItemQuizConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalModuleItemQuizConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalModuleItemQuizCreateFieldInput>;
};

export type ExternalModuleItemQuizNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalModuleItemQuizNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalModuleItemQuizNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalModuleItemQuizNodeAggregationWhereInput>>;
  attemptsAllowed_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  attemptsAllowed_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  attemptsAllowed_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  attemptsAllowed_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  attemptsAllowed_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  attemptsAllowed_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  availableFrom_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  descriptionHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pointsPossible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerQuizId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerQuizId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerQuizId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerQuizId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerQuizId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  timeLimitMinutes_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeLimitMinutes_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeLimitMinutes_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimitMinutes_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeLimitMinutes_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimitMinutes_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalModuleItemQuizRelationship = {
  __typename?: 'ExternalModuleItemQuizRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalQuiz;
};

export type ExternalModuleItemQuizUpdateConnectionInput = {
  node?: InputMaybe<ExternalQuizUpdateInput>;
};

export type ExternalModuleItemQuizUpdateFieldInput = {
  connect?: InputMaybe<ExternalModuleItemQuizConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalModuleItemQuizConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalModuleItemQuizCreateFieldInput>;
  delete?: InputMaybe<ExternalModuleItemQuizDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalModuleItemQuizDisconnectFieldInput>;
  update?: InputMaybe<ExternalModuleItemQuizUpdateConnectionInput>;
  where?: InputMaybe<ExternalModuleItemQuizConnectionWhere>;
};

/** Fields to sort ExternalModuleItems by. The order in which sorts are applied is not guaranteed when specifying many fields in one ExternalModuleItemSort object. */
export type ExternalModuleItemSort = {
  externalUrl?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lmsSource?: InputMaybe<SortDirection>;
  position?: InputMaybe<SortDirection>;
  providerApiUrl?: InputMaybe<SortDirection>;
  providerCourseId?: InputMaybe<SortDirection>;
  providerKey?: InputMaybe<SortDirection>;
  providerModuleId?: InputMaybe<SortDirection>;
  providerModuleItemId?: InputMaybe<SortDirection>;
  sourceMeta?: InputMaybe<SortDirection>;
  sourcePayload?: InputMaybe<SortDirection>;
  sourceUpdatedAt?: InputMaybe<SortDirection>;
  syncedAt?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
  visibility?: InputMaybe<SortDirection>;
};

export enum ExternalModuleItemType {
  Assignment = 'ASSIGNMENT',
  Discussion = 'DISCUSSION',
  ExternalTool = 'EXTERNAL_TOOL',
  ExternalUrl = 'EXTERNAL_URL',
  File = 'FILE',
  Page = 'PAGE',
  Quiz = 'QUIZ',
  SubHeader = 'SUB_HEADER'
}

export type ExternalModuleItemUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalModuleItemUpdateInput = {
  announcement?: InputMaybe<ExternalModuleItemAnnouncementUpdateFieldInput>;
  assignment?: InputMaybe<ExternalModuleItemAssignmentUpdateFieldInput>;
  discussion?: InputMaybe<ExternalModuleItemDiscussionUpdateFieldInput>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  lmsSource?: InputMaybe<LmsSource>;
  module?: InputMaybe<ExternalModuleItemModuleUpdateFieldInput>;
  page?: InputMaybe<ExternalModuleItemPageUpdateFieldInput>;
  position?: InputMaybe<Scalars['Int']['input']>;
  position_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  position_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerCourseId?: InputMaybe<Scalars['String']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
  providerModuleId?: InputMaybe<Scalars['String']['input']>;
  providerModuleItemId?: InputMaybe<Scalars['String']['input']>;
  quiz?: InputMaybe<ExternalModuleItemQuizUpdateFieldInput>;
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ExternalModuleItemType>;
  visibility?: InputMaybe<ExternalModuleVisibility>;
};

export type ExternalModuleItemWhere = {
  AND?: InputMaybe<Array<ExternalModuleItemWhere>>;
  NOT?: InputMaybe<ExternalModuleItemWhere>;
  OR?: InputMaybe<Array<ExternalModuleItemWhere>>;
  announcement?: InputMaybe<ExternalAnnouncementWhere>;
  announcementAggregate?: InputMaybe<ExternalModuleItemAnnouncementAggregateInput>;
  announcementConnection?: InputMaybe<ExternalModuleItemAnnouncementConnectionWhere>;
  announcementConnection_NOT?: InputMaybe<ExternalModuleItemAnnouncementConnectionWhere>;
  announcement_NOT?: InputMaybe<ExternalAnnouncementWhere>;
  assignment?: InputMaybe<ExternalAssignmentWhere>;
  assignmentAggregate?: InputMaybe<ExternalModuleItemAssignmentAggregateInput>;
  assignmentConnection?: InputMaybe<ExternalModuleItemAssignmentConnectionWhere>;
  assignmentConnection_NOT?: InputMaybe<ExternalModuleItemAssignmentConnectionWhere>;
  assignment_NOT?: InputMaybe<ExternalAssignmentWhere>;
  discussion?: InputMaybe<ExternalDiscussionBoardWhere>;
  discussionAggregate?: InputMaybe<ExternalModuleItemDiscussionAggregateInput>;
  discussionConnection?: InputMaybe<ExternalModuleItemDiscussionConnectionWhere>;
  discussionConnection_NOT?: InputMaybe<ExternalModuleItemDiscussionConnectionWhere>;
  discussion_NOT?: InputMaybe<ExternalDiscussionBoardWhere>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  externalUrl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  externalUrl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  externalUrl_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalUrl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lmsSource?: InputMaybe<LmsSource>;
  lmsSource_IN?: InputMaybe<Array<LmsSource>>;
  module?: InputMaybe<ExternalModuleWhere>;
  moduleAggregate?: InputMaybe<ExternalModuleItemModuleAggregateInput>;
  moduleConnection?: InputMaybe<ExternalModuleItemModuleConnectionWhere>;
  moduleConnection_NOT?: InputMaybe<ExternalModuleItemModuleConnectionWhere>;
  module_NOT?: InputMaybe<ExternalModuleWhere>;
  page?: InputMaybe<ExternalPageWhere>;
  pageAggregate?: InputMaybe<ExternalModuleItemPageAggregateInput>;
  pageConnection?: InputMaybe<ExternalModuleItemPageConnectionWhere>;
  pageConnection_NOT?: InputMaybe<ExternalModuleItemPageConnectionWhere>;
  page_NOT?: InputMaybe<ExternalPageWhere>;
  position?: InputMaybe<Scalars['Int']['input']>;
  position_GT?: InputMaybe<Scalars['Int']['input']>;
  position_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerApiUrl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerCourseId?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerCourseId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
  providerKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerKey_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerModuleId?: InputMaybe<Scalars['String']['input']>;
  providerModuleId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerModuleId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerModuleId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerModuleId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerModuleItemId?: InputMaybe<Scalars['String']['input']>;
  providerModuleItemId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerModuleItemId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerModuleItemId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerModuleItemId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  quiz?: InputMaybe<ExternalQuizWhere>;
  quizAggregate?: InputMaybe<ExternalModuleItemQuizAggregateInput>;
  quizConnection?: InputMaybe<ExternalModuleItemQuizConnectionWhere>;
  quizConnection_NOT?: InputMaybe<ExternalModuleItemQuizConnectionWhere>;
  quiz_NOT?: InputMaybe<ExternalQuizWhere>;
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourceMeta_IN?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload_IN?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  sourceUpdatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  syncedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ExternalModuleItemType>;
  type_IN?: InputMaybe<Array<ExternalModuleItemType>>;
  visibility?: InputMaybe<ExternalModuleVisibility>;
  visibility_IN?: InputMaybe<Array<ExternalModuleVisibility>>;
};

export type ExternalModuleItemsAggregateInput = {
  AND?: InputMaybe<Array<ExternalModuleItemsAggregateInput>>;
  NOT?: InputMaybe<ExternalModuleItemsAggregateInput>;
  OR?: InputMaybe<Array<ExternalModuleItemsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalModuleItemsNodeAggregationWhereInput>;
};

export type ExternalModuleItemsConnectFieldInput = {
  connect?: InputMaybe<Array<ExternalModuleItemConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalModuleItemConnectWhere>;
};

export type ExternalModuleItemsConnectOrCreateFieldInput = {
  onCreate: ExternalModuleItemsConnectOrCreateFieldInputOnCreate;
  where: ExternalModuleItemConnectOrCreateWhere;
};

export type ExternalModuleItemsConnectOrCreateFieldInputOnCreate = {
  node: ExternalModuleItemOnCreateInput;
};

export type ExternalModuleItemsConnection = {
  __typename?: 'ExternalModuleItemsConnection';
  edges: Array<ExternalModuleItemsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalModuleItemsConnectionSort = {
  node?: InputMaybe<ExternalModuleItemSort>;
};

export type ExternalModuleItemsConnectionWhere = {
  AND?: InputMaybe<Array<ExternalModuleItemsConnectionWhere>>;
  NOT?: InputMaybe<ExternalModuleItemsConnectionWhere>;
  OR?: InputMaybe<Array<ExternalModuleItemsConnectionWhere>>;
  node?: InputMaybe<ExternalModuleItemWhere>;
};

export type ExternalModuleItemsCreateFieldInput = {
  node: ExternalModuleItemCreateInput;
};

export type ExternalModuleItemsDeleteFieldInput = {
  delete?: InputMaybe<ExternalModuleItemDeleteInput>;
  where?: InputMaybe<ExternalModuleItemsConnectionWhere>;
};

export type ExternalModuleItemsDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalModuleItemDisconnectInput>;
  where?: InputMaybe<ExternalModuleItemsConnectionWhere>;
};

export type ExternalModuleItemsFieldInput = {
  connect?: InputMaybe<Array<ExternalModuleItemsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalModuleItemsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalModuleItemsCreateFieldInput>>;
};

export type ExternalModuleItemsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalModuleItemsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalModuleItemsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalModuleItemsNodeAggregationWhereInput>>;
  externalUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerModuleId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerModuleId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerModuleId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerModuleId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerModuleId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerModuleId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerModuleItemId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerModuleItemId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerModuleItemId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerModuleItemId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerModuleItemId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerModuleItemId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerModuleItemId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerModuleItemId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerModuleItemId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerModuleItemId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerModuleItemId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerModuleItemId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerModuleItemId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerModuleItemId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerModuleItemId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalModuleItemsRelationship = {
  __typename?: 'ExternalModuleItemsRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalModuleItem;
};

export type ExternalModuleItemsUpdateConnectionInput = {
  node?: InputMaybe<ExternalModuleItemUpdateInput>;
};

export type ExternalModuleItemsUpdateFieldInput = {
  connect?: InputMaybe<Array<ExternalModuleItemsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalModuleItemsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalModuleItemsCreateFieldInput>>;
  delete?: InputMaybe<Array<ExternalModuleItemsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ExternalModuleItemsDisconnectFieldInput>>;
  update?: InputMaybe<ExternalModuleItemsUpdateConnectionInput>;
  where?: InputMaybe<ExternalModuleItemsConnectionWhere>;
};

export type ExternalModuleOnCreateInput = {
  lmsSource: LmsSource;
  position?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerCourseId: Scalars['String']['input'];
  providerKey: Scalars['String']['input'];
  providerModuleId: Scalars['String']['input'];
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  visibility: ExternalModuleVisibility;
};

export type ExternalModuleOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ExternalModuleSort objects to sort ExternalModules by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ExternalModuleSort>>;
};

/** Fields to sort ExternalModules by. The order in which sorts are applied is not guaranteed when specifying many fields in one ExternalModuleSort object. */
export type ExternalModuleSort = {
  id?: InputMaybe<SortDirection>;
  lmsSource?: InputMaybe<SortDirection>;
  position?: InputMaybe<SortDirection>;
  providerApiUrl?: InputMaybe<SortDirection>;
  providerCourseId?: InputMaybe<SortDirection>;
  providerKey?: InputMaybe<SortDirection>;
  providerModuleId?: InputMaybe<SortDirection>;
  sourceMeta?: InputMaybe<SortDirection>;
  sourcePayload?: InputMaybe<SortDirection>;
  sourceUpdatedAt?: InputMaybe<SortDirection>;
  syncedAt?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  url?: InputMaybe<SortDirection>;
  visibility?: InputMaybe<SortDirection>;
};

export type ExternalModuleUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalModuleUpdateInput = {
  course?: InputMaybe<ExternalModuleCourseUpdateFieldInput>;
  items?: InputMaybe<Array<ExternalModuleItemsUpdateFieldInput>>;
  lmsSource?: InputMaybe<LmsSource>;
  position?: InputMaybe<Scalars['Int']['input']>;
  position_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  position_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerCourseId?: InputMaybe<Scalars['String']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
  providerModuleId?: InputMaybe<Scalars['String']['input']>;
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<ExternalModuleVisibility>;
};

export enum ExternalModuleVisibility {
  Hidden = 'HIDDEN',
  Published = 'PUBLISHED',
  Unknown = 'UNKNOWN',
  Unpublished = 'UNPUBLISHED'
}

export type ExternalModuleWhere = {
  AND?: InputMaybe<Array<ExternalModuleWhere>>;
  NOT?: InputMaybe<ExternalModuleWhere>;
  OR?: InputMaybe<Array<ExternalModuleWhere>>;
  course?: InputMaybe<ExternalCourseWhere>;
  courseAggregate?: InputMaybe<ExternalModuleCourseAggregateInput>;
  courseConnection?: InputMaybe<ExternalModuleCourseConnectionWhere>;
  courseConnection_NOT?: InputMaybe<ExternalModuleCourseConnectionWhere>;
  course_NOT?: InputMaybe<ExternalCourseWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  itemsAggregate?: InputMaybe<ExternalModuleItemsAggregateInput>;
  /** Return ExternalModules where all of the related ExternalModuleItemsConnections match this filter */
  itemsConnection_ALL?: InputMaybe<ExternalModuleItemsConnectionWhere>;
  /** Return ExternalModules where none of the related ExternalModuleItemsConnections match this filter */
  itemsConnection_NONE?: InputMaybe<ExternalModuleItemsConnectionWhere>;
  /** Return ExternalModules where one of the related ExternalModuleItemsConnections match this filter */
  itemsConnection_SINGLE?: InputMaybe<ExternalModuleItemsConnectionWhere>;
  /** Return ExternalModules where some of the related ExternalModuleItemsConnections match this filter */
  itemsConnection_SOME?: InputMaybe<ExternalModuleItemsConnectionWhere>;
  /** Return ExternalModules where all of the related ExternalModuleItems match this filter */
  items_ALL?: InputMaybe<ExternalModuleItemWhere>;
  /** Return ExternalModules where none of the related ExternalModuleItems match this filter */
  items_NONE?: InputMaybe<ExternalModuleItemWhere>;
  /** Return ExternalModules where one of the related ExternalModuleItems match this filter */
  items_SINGLE?: InputMaybe<ExternalModuleItemWhere>;
  /** Return ExternalModules where some of the related ExternalModuleItems match this filter */
  items_SOME?: InputMaybe<ExternalModuleItemWhere>;
  lmsSource?: InputMaybe<LmsSource>;
  lmsSource_IN?: InputMaybe<Array<LmsSource>>;
  position?: InputMaybe<Scalars['Int']['input']>;
  position_GT?: InputMaybe<Scalars['Int']['input']>;
  position_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerApiUrl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerCourseId?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerCourseId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
  providerKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerKey_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerModuleId?: InputMaybe<Scalars['String']['input']>;
  providerModuleId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerModuleId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerModuleId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerModuleId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourceMeta_IN?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload_IN?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  sourceUpdatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  syncedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<ExternalModuleVisibility>;
  visibility_IN?: InputMaybe<Array<ExternalModuleVisibility>>;
};

export type ExternalPage = {
  __typename?: 'ExternalPage';
  bodyHtml?: Maybe<Scalars['String']['output']>;
  bodyText?: Maybe<Scalars['String']['output']>;
  course: ExternalCourse;
  courseAggregate?: Maybe<ExternalPageExternalCourseCourseAggregationSelection>;
  courseConnection: ExternalPageCourseConnection;
  files: Array<ExternalFile>;
  filesAggregate?: Maybe<ExternalPageExternalFileFilesAggregationSelection>;
  filesConnection: ExternalPageFilesConnection;
  id: Scalars['ID']['output'];
  lmsSource: LmsSource;
  providerApiUrl?: Maybe<Scalars['String']['output']>;
  providerCourseId: Scalars['String']['output'];
  providerKey: Scalars['String']['output'];
  providerPageId: Scalars['String']['output'];
  sourceMeta?: Maybe<Scalars['JSON']['output']>;
  sourcePayload?: Maybe<Scalars['JSON']['output']>;
  sourceUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  syncedAt: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
  users: Array<User>;
  usersAggregate?: Maybe<ExternalPageUserUsersAggregationSelection>;
  usersConnection: ExternalPageUsersConnection;
  visibility: ExternalPageVisibility;
};


export type ExternalPageCourseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalCourseOptions>;
  where?: InputMaybe<ExternalCourseWhere>;
};


export type ExternalPageCourseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalCourseWhere>;
};


export type ExternalPageCourseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalPageCourseConnectionSort>>;
  where?: InputMaybe<ExternalPageCourseConnectionWhere>;
};


export type ExternalPageFilesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalFileOptions>;
  where?: InputMaybe<ExternalFileWhere>;
};


export type ExternalPageFilesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalFileWhere>;
};


export type ExternalPageFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalPageFilesConnectionSort>>;
  where?: InputMaybe<ExternalPageFilesConnectionWhere>;
};


export type ExternalPageUsersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type ExternalPageUsersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type ExternalPageUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalPageUsersConnectionSort>>;
  where?: InputMaybe<ExternalPageUsersConnectionWhere>;
};

export type ExternalPageConnectInput = {
  course?: InputMaybe<ExternalPageCourseConnectFieldInput>;
  files?: InputMaybe<Array<ExternalPageFilesConnectFieldInput>>;
  users?: InputMaybe<Array<ExternalPageUsersConnectFieldInput>>;
};

export type ExternalPageConnectOrCreateWhere = {
  node: ExternalPageUniqueWhere;
};

export type ExternalPageConnectWhere = {
  node: ExternalPageWhere;
};

export type ExternalPageCourseAggregateInput = {
  AND?: InputMaybe<Array<ExternalPageCourseAggregateInput>>;
  NOT?: InputMaybe<ExternalPageCourseAggregateInput>;
  OR?: InputMaybe<Array<ExternalPageCourseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalPageCourseNodeAggregationWhereInput>;
};

export type ExternalPageCourseConnectFieldInput = {
  connect?: InputMaybe<ExternalCourseConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalCourseConnectWhere>;
};

export type ExternalPageCourseConnectOrCreateFieldInput = {
  onCreate: ExternalPageCourseConnectOrCreateFieldInputOnCreate;
  where: ExternalCourseConnectOrCreateWhere;
};

export type ExternalPageCourseConnectOrCreateFieldInputOnCreate = {
  node: ExternalCourseOnCreateInput;
};

export type ExternalPageCourseConnection = {
  __typename?: 'ExternalPageCourseConnection';
  edges: Array<ExternalPageCourseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalPageCourseConnectionSort = {
  node?: InputMaybe<ExternalCourseSort>;
};

export type ExternalPageCourseConnectionWhere = {
  AND?: InputMaybe<Array<ExternalPageCourseConnectionWhere>>;
  NOT?: InputMaybe<ExternalPageCourseConnectionWhere>;
  OR?: InputMaybe<Array<ExternalPageCourseConnectionWhere>>;
  node?: InputMaybe<ExternalCourseWhere>;
};

export type ExternalPageCourseCreateFieldInput = {
  node: ExternalCourseCreateInput;
};

export type ExternalPageCourseDeleteFieldInput = {
  delete?: InputMaybe<ExternalCourseDeleteInput>;
  where?: InputMaybe<ExternalPageCourseConnectionWhere>;
};

export type ExternalPageCourseDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalCourseDisconnectInput>;
  where?: InputMaybe<ExternalPageCourseConnectionWhere>;
};

export type ExternalPageCourseFieldInput = {
  connect?: InputMaybe<ExternalPageCourseConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalPageCourseConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalPageCourseCreateFieldInput>;
};

export type ExternalPageCourseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalPageCourseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalPageCourseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalPageCourseNodeAggregationWhereInput>>;
  courseCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  courseCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  courseCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  courseCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  courseCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  endDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalPageCourseRelationship = {
  __typename?: 'ExternalPageCourseRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalCourse;
};

export type ExternalPageCourseUpdateConnectionInput = {
  node?: InputMaybe<ExternalCourseUpdateInput>;
};

export type ExternalPageCourseUpdateFieldInput = {
  connect?: InputMaybe<ExternalPageCourseConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalPageCourseConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalPageCourseCreateFieldInput>;
  delete?: InputMaybe<ExternalPageCourseDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalPageCourseDisconnectFieldInput>;
  update?: InputMaybe<ExternalPageCourseUpdateConnectionInput>;
  where?: InputMaybe<ExternalPageCourseConnectionWhere>;
};

export type ExternalPageCreateInput = {
  bodyHtml?: InputMaybe<Scalars['String']['input']>;
  bodyText?: InputMaybe<Scalars['String']['input']>;
  course?: InputMaybe<ExternalPageCourseFieldInput>;
  files?: InputMaybe<ExternalPageFilesFieldInput>;
  lmsSource: LmsSource;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerCourseId: Scalars['String']['input'];
  providerKey: Scalars['String']['input'];
  providerPageId: Scalars['String']['input'];
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<ExternalPageUsersFieldInput>;
  visibility: ExternalPageVisibility;
};

export type ExternalPageDeleteInput = {
  course?: InputMaybe<ExternalPageCourseDeleteFieldInput>;
  files?: InputMaybe<Array<ExternalPageFilesDeleteFieldInput>>;
  users?: InputMaybe<Array<ExternalPageUsersDeleteFieldInput>>;
};

export type ExternalPageDisconnectInput = {
  course?: InputMaybe<ExternalPageCourseDisconnectFieldInput>;
  files?: InputMaybe<Array<ExternalPageFilesDisconnectFieldInput>>;
  users?: InputMaybe<Array<ExternalPageUsersDisconnectFieldInput>>;
};

export type ExternalPageExternalCourseCourseAggregationSelection = {
  __typename?: 'ExternalPageExternalCourseCourseAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalPageExternalCourseCourseNodeAggregateSelection>;
};

export type ExternalPageExternalCourseCourseNodeAggregateSelection = {
  __typename?: 'ExternalPageExternalCourseCourseNodeAggregateSelection';
  courseCode: StringAggregateSelection;
  descriptionHtml: StringAggregateSelection;
  descriptionText: StringAggregateSelection;
  endDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  name: StringAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  startDate: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalPageExternalFileFilesAggregationSelection = {
  __typename?: 'ExternalPageExternalFileFilesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalPageExternalFileFilesNodeAggregateSelection>;
};

export type ExternalPageExternalFileFilesNodeAggregateSelection = {
  __typename?: 'ExternalPageExternalFileFilesNodeAggregateSelection';
  attachedToId: StringAggregateSelection;
  displayName: StringAggregateSelection;
  downloadUrl: StringAggregateSelection;
  fileName: StringAggregateSelection;
  fileSize: IntAggregateSelection;
  id: IdAggregateSelection;
  mimeType: StringAggregateSelection;
  modifiedAt: DateTimeAggregateSelection;
  previewUrl: StringAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerFileId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  uploadedAt: DateTimeAggregateSelection;
  uploadedBy: StringAggregateSelection;
};

export type ExternalPageFilesAggregateInput = {
  AND?: InputMaybe<Array<ExternalPageFilesAggregateInput>>;
  NOT?: InputMaybe<ExternalPageFilesAggregateInput>;
  OR?: InputMaybe<Array<ExternalPageFilesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalPageFilesNodeAggregationWhereInput>;
};

export type ExternalPageFilesConnectFieldInput = {
  connect?: InputMaybe<Array<ExternalFileConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalFileConnectWhere>;
};

export type ExternalPageFilesConnectOrCreateFieldInput = {
  onCreate: ExternalPageFilesConnectOrCreateFieldInputOnCreate;
  where: ExternalFileConnectOrCreateWhere;
};

export type ExternalPageFilesConnectOrCreateFieldInputOnCreate = {
  node: ExternalFileOnCreateInput;
};

export type ExternalPageFilesConnection = {
  __typename?: 'ExternalPageFilesConnection';
  edges: Array<ExternalPageFilesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalPageFilesConnectionSort = {
  node?: InputMaybe<ExternalFileSort>;
};

export type ExternalPageFilesConnectionWhere = {
  AND?: InputMaybe<Array<ExternalPageFilesConnectionWhere>>;
  NOT?: InputMaybe<ExternalPageFilesConnectionWhere>;
  OR?: InputMaybe<Array<ExternalPageFilesConnectionWhere>>;
  node?: InputMaybe<ExternalFileWhere>;
};

export type ExternalPageFilesCreateFieldInput = {
  node: ExternalFileCreateInput;
};

export type ExternalPageFilesDeleteFieldInput = {
  delete?: InputMaybe<ExternalFileDeleteInput>;
  where?: InputMaybe<ExternalPageFilesConnectionWhere>;
};

export type ExternalPageFilesDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalFileDisconnectInput>;
  where?: InputMaybe<ExternalPageFilesConnectionWhere>;
};

export type ExternalPageFilesFieldInput = {
  connect?: InputMaybe<Array<ExternalPageFilesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalPageFilesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalPageFilesCreateFieldInput>>;
};

export type ExternalPageFilesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalPageFilesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalPageFilesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalPageFilesNodeAggregationWhereInput>>;
  attachedToId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  attachedToId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  attachedToId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  attachedToId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  attachedToId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  attachedToId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  downloadUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  downloadUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  downloadUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  downloadUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  downloadUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileSize_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileSize_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  fileSize_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileSize_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  fileSize_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileSize_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileSize_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileSize_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileSize_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  mimeType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modifiedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  previewUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  previewUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  previewUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  previewUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  previewUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  previewUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerFileId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerFileId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerFileId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerFileId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerFileId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uploadedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uploadedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uploadedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uploadedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uploadedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalPageFilesRelationship = {
  __typename?: 'ExternalPageFilesRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalFile;
};

export type ExternalPageFilesUpdateConnectionInput = {
  node?: InputMaybe<ExternalFileUpdateInput>;
};

export type ExternalPageFilesUpdateFieldInput = {
  connect?: InputMaybe<Array<ExternalPageFilesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalPageFilesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalPageFilesCreateFieldInput>>;
  delete?: InputMaybe<Array<ExternalPageFilesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ExternalPageFilesDisconnectFieldInput>>;
  update?: InputMaybe<ExternalPageFilesUpdateConnectionInput>;
  where?: InputMaybe<ExternalPageFilesConnectionWhere>;
};

export type ExternalPageOnCreateInput = {
  bodyHtml?: InputMaybe<Scalars['String']['input']>;
  bodyText?: InputMaybe<Scalars['String']['input']>;
  lmsSource: LmsSource;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerCourseId: Scalars['String']['input'];
  providerKey: Scalars['String']['input'];
  providerPageId: Scalars['String']['input'];
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  visibility: ExternalPageVisibility;
};

export type ExternalPageOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ExternalPageSort objects to sort ExternalPages by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ExternalPageSort>>;
};

/** Fields to sort ExternalPages by. The order in which sorts are applied is not guaranteed when specifying many fields in one ExternalPageSort object. */
export type ExternalPageSort = {
  bodyHtml?: InputMaybe<SortDirection>;
  bodyText?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lmsSource?: InputMaybe<SortDirection>;
  providerApiUrl?: InputMaybe<SortDirection>;
  providerCourseId?: InputMaybe<SortDirection>;
  providerKey?: InputMaybe<SortDirection>;
  providerPageId?: InputMaybe<SortDirection>;
  sourceMeta?: InputMaybe<SortDirection>;
  sourcePayload?: InputMaybe<SortDirection>;
  sourceUpdatedAt?: InputMaybe<SortDirection>;
  syncedAt?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  url?: InputMaybe<SortDirection>;
  visibility?: InputMaybe<SortDirection>;
};

export type ExternalPageUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalPageUpdateInput = {
  bodyHtml?: InputMaybe<Scalars['String']['input']>;
  bodyText?: InputMaybe<Scalars['String']['input']>;
  course?: InputMaybe<ExternalPageCourseUpdateFieldInput>;
  files?: InputMaybe<Array<ExternalPageFilesUpdateFieldInput>>;
  lmsSource?: InputMaybe<LmsSource>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerCourseId?: InputMaybe<Scalars['String']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
  providerPageId?: InputMaybe<Scalars['String']['input']>;
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<ExternalPageUsersUpdateFieldInput>>;
  visibility?: InputMaybe<ExternalPageVisibility>;
};

export type ExternalPageUserUsersAggregationSelection = {
  __typename?: 'ExternalPageUserUsersAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<ExternalPageUserUsersEdgeAggregateSelection>;
  node?: Maybe<ExternalPageUserUsersNodeAggregateSelection>;
};

export type ExternalPageUserUsersEdgeAggregateSelection = {
  __typename?: 'ExternalPageUserUsersEdgeAggregateSelection';
  syncedAt: DateTimeAggregateSelection;
};

export type ExternalPageUserUsersNodeAggregateSelection = {
  __typename?: 'ExternalPageUserUsersNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type ExternalPageUsersAggregateInput = {
  AND?: InputMaybe<Array<ExternalPageUsersAggregateInput>>;
  NOT?: InputMaybe<ExternalPageUsersAggregateInput>;
  OR?: InputMaybe<Array<ExternalPageUsersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<UserLmsContentPropertiesAggregationWhereInput>;
  node?: InputMaybe<ExternalPageUsersNodeAggregationWhereInput>;
};

export type ExternalPageUsersConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  edge: UserLmsContentPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type ExternalPageUsersConnectOrCreateFieldInput = {
  onCreate: ExternalPageUsersConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type ExternalPageUsersConnectOrCreateFieldInputOnCreate = {
  edge: UserLmsContentPropertiesCreateInput;
  node: UserOnCreateInput;
};

export type ExternalPageUsersConnection = {
  __typename?: 'ExternalPageUsersConnection';
  edges: Array<ExternalPageUsersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalPageUsersConnectionSort = {
  edge?: InputMaybe<UserLmsContentPropertiesSort>;
  node?: InputMaybe<UserSort>;
};

export type ExternalPageUsersConnectionWhere = {
  AND?: InputMaybe<Array<ExternalPageUsersConnectionWhere>>;
  NOT?: InputMaybe<ExternalPageUsersConnectionWhere>;
  OR?: InputMaybe<Array<ExternalPageUsersConnectionWhere>>;
  edge?: InputMaybe<UserLmsContentPropertiesWhere>;
  node?: InputMaybe<UserWhere>;
};

export type ExternalPageUsersCreateFieldInput = {
  edge: UserLmsContentPropertiesCreateInput;
  node: UserCreateInput;
};

export type ExternalPageUsersDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<ExternalPageUsersConnectionWhere>;
};

export type ExternalPageUsersDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<ExternalPageUsersConnectionWhere>;
};

export type ExternalPageUsersFieldInput = {
  connect?: InputMaybe<Array<ExternalPageUsersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalPageUsersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalPageUsersCreateFieldInput>>;
};

export type ExternalPageUsersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalPageUsersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalPageUsersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalPageUsersNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalPageUsersRelationship = {
  __typename?: 'ExternalPageUsersRelationship';
  cursor: Scalars['String']['output'];
  node: User;
  properties: UserLmsContentProperties;
};

export type ExternalPageUsersUpdateConnectionInput = {
  edge?: InputMaybe<UserLmsContentPropertiesUpdateInput>;
  node?: InputMaybe<UserUpdateInput>;
};

export type ExternalPageUsersUpdateFieldInput = {
  connect?: InputMaybe<Array<ExternalPageUsersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalPageUsersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalPageUsersCreateFieldInput>>;
  delete?: InputMaybe<Array<ExternalPageUsersDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ExternalPageUsersDisconnectFieldInput>>;
  update?: InputMaybe<ExternalPageUsersUpdateConnectionInput>;
  where?: InputMaybe<ExternalPageUsersConnectionWhere>;
};

export enum ExternalPageVisibility {
  Hidden = 'HIDDEN',
  Published = 'PUBLISHED',
  Unknown = 'UNKNOWN',
  Unpublished = 'UNPUBLISHED'
}

export type ExternalPageWhere = {
  AND?: InputMaybe<Array<ExternalPageWhere>>;
  NOT?: InputMaybe<ExternalPageWhere>;
  OR?: InputMaybe<Array<ExternalPageWhere>>;
  bodyHtml?: InputMaybe<Scalars['String']['input']>;
  bodyHtml_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  bodyHtml_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  bodyHtml_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyHtml_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  bodyText?: InputMaybe<Scalars['String']['input']>;
  bodyText_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  bodyText_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  bodyText_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyText_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  course?: InputMaybe<ExternalCourseWhere>;
  courseAggregate?: InputMaybe<ExternalPageCourseAggregateInput>;
  courseConnection?: InputMaybe<ExternalPageCourseConnectionWhere>;
  courseConnection_NOT?: InputMaybe<ExternalPageCourseConnectionWhere>;
  course_NOT?: InputMaybe<ExternalCourseWhere>;
  filesAggregate?: InputMaybe<ExternalPageFilesAggregateInput>;
  /** Return ExternalPages where all of the related ExternalPageFilesConnections match this filter */
  filesConnection_ALL?: InputMaybe<ExternalPageFilesConnectionWhere>;
  /** Return ExternalPages where none of the related ExternalPageFilesConnections match this filter */
  filesConnection_NONE?: InputMaybe<ExternalPageFilesConnectionWhere>;
  /** Return ExternalPages where one of the related ExternalPageFilesConnections match this filter */
  filesConnection_SINGLE?: InputMaybe<ExternalPageFilesConnectionWhere>;
  /** Return ExternalPages where some of the related ExternalPageFilesConnections match this filter */
  filesConnection_SOME?: InputMaybe<ExternalPageFilesConnectionWhere>;
  /** Return ExternalPages where all of the related ExternalFiles match this filter */
  files_ALL?: InputMaybe<ExternalFileWhere>;
  /** Return ExternalPages where none of the related ExternalFiles match this filter */
  files_NONE?: InputMaybe<ExternalFileWhere>;
  /** Return ExternalPages where one of the related ExternalFiles match this filter */
  files_SINGLE?: InputMaybe<ExternalFileWhere>;
  /** Return ExternalPages where some of the related ExternalFiles match this filter */
  files_SOME?: InputMaybe<ExternalFileWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lmsSource?: InputMaybe<LmsSource>;
  lmsSource_IN?: InputMaybe<Array<LmsSource>>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerApiUrl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerCourseId?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerCourseId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
  providerKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerKey_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerPageId?: InputMaybe<Scalars['String']['input']>;
  providerPageId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerPageId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerPageId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerPageId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourceMeta_IN?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload_IN?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  sourceUpdatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  syncedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  usersAggregate?: InputMaybe<ExternalPageUsersAggregateInput>;
  /** Return ExternalPages where all of the related ExternalPageUsersConnections match this filter */
  usersConnection_ALL?: InputMaybe<ExternalPageUsersConnectionWhere>;
  /** Return ExternalPages where none of the related ExternalPageUsersConnections match this filter */
  usersConnection_NONE?: InputMaybe<ExternalPageUsersConnectionWhere>;
  /** Return ExternalPages where one of the related ExternalPageUsersConnections match this filter */
  usersConnection_SINGLE?: InputMaybe<ExternalPageUsersConnectionWhere>;
  /** Return ExternalPages where some of the related ExternalPageUsersConnections match this filter */
  usersConnection_SOME?: InputMaybe<ExternalPageUsersConnectionWhere>;
  /** Return ExternalPages where all of the related Users match this filter */
  users_ALL?: InputMaybe<UserWhere>;
  /** Return ExternalPages where none of the related Users match this filter */
  users_NONE?: InputMaybe<UserWhere>;
  /** Return ExternalPages where one of the related Users match this filter */
  users_SINGLE?: InputMaybe<UserWhere>;
  /** Return ExternalPages where some of the related Users match this filter */
  users_SOME?: InputMaybe<UserWhere>;
  visibility?: InputMaybe<ExternalPageVisibility>;
  visibility_IN?: InputMaybe<Array<ExternalPageVisibility>>;
};

export type ExternalQuiz = {
  __typename?: 'ExternalQuiz';
  assignees: Array<User>;
  assigneesAggregate?: Maybe<ExternalQuizUserAssigneesAggregationSelection>;
  assigneesConnection: ExternalQuizAssigneesConnection;
  attemptsAllowed?: Maybe<Scalars['Int']['output']>;
  attemptsKind: ExternalQuizAttemptKind;
  availableFrom?: Maybe<Scalars['DateTime']['output']>;
  availableUntil?: Maybe<Scalars['DateTime']['output']>;
  course: ExternalCourse;
  courseAggregate?: Maybe<ExternalQuizExternalCourseCourseAggregationSelection>;
  courseConnection: ExternalQuizCourseConnection;
  descriptionHtml?: Maybe<Scalars['String']['output']>;
  descriptionText?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  lmsSource: LmsSource;
  nudgesAboutThis: Array<Nudge>;
  nudgesAboutThisAggregate?: Maybe<ExternalQuizNudgeNudgesAboutThisAggregationSelection>;
  nudgesAboutThisConnection: ExternalQuizNudgesAboutThisConnection;
  pointsPossible?: Maybe<Scalars['Float']['output']>;
  providerApiUrl?: Maybe<Scalars['String']['output']>;
  providerCourseId: Scalars['String']['output'];
  providerKey: Scalars['String']['output'];
  providerQuizId: Scalars['String']['output'];
  sourceMeta?: Maybe<Scalars['JSON']['output']>;
  sourcePayload?: Maybe<Scalars['JSON']['output']>;
  sourceUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  submissions: Array<ExternalSubmission>;
  submissionsAggregate?: Maybe<ExternalQuizExternalSubmissionSubmissionsAggregationSelection>;
  submissionsConnection: ExternalQuizSubmissionsConnection;
  syncedAt: Scalars['DateTime']['output'];
  timeLimitMinutes?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
  visibility: ExternalQuizVisibility;
};


export type ExternalQuizAssigneesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type ExternalQuizAssigneesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type ExternalQuizAssigneesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalQuizAssigneesConnectionSort>>;
  where?: InputMaybe<ExternalQuizAssigneesConnectionWhere>;
};


export type ExternalQuizCourseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalCourseOptions>;
  where?: InputMaybe<ExternalCourseWhere>;
};


export type ExternalQuizCourseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalCourseWhere>;
};


export type ExternalQuizCourseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalQuizCourseConnectionSort>>;
  where?: InputMaybe<ExternalQuizCourseConnectionWhere>;
};


export type ExternalQuizNudgesAboutThisArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<NudgeOptions>;
  where?: InputMaybe<NudgeWhere>;
};


export type ExternalQuizNudgesAboutThisAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NudgeWhere>;
};


export type ExternalQuizNudgesAboutThisConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalQuizNudgesAboutThisConnectionSort>>;
  where?: InputMaybe<ExternalQuizNudgesAboutThisConnectionWhere>;
};


export type ExternalQuizSubmissionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalSubmissionOptions>;
  where?: InputMaybe<ExternalSubmissionWhere>;
};


export type ExternalQuizSubmissionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalSubmissionWhere>;
};


export type ExternalQuizSubmissionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalQuizSubmissionsConnectionSort>>;
  where?: InputMaybe<ExternalQuizSubmissionsConnectionWhere>;
};

export type ExternalQuizAssigneesAggregateInput = {
  AND?: InputMaybe<Array<ExternalQuizAssigneesAggregateInput>>;
  NOT?: InputMaybe<ExternalQuizAssigneesAggregateInput>;
  OR?: InputMaybe<Array<ExternalQuizAssigneesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<UserLmsContentPropertiesAggregationWhereInput>;
  node?: InputMaybe<ExternalQuizAssigneesNodeAggregationWhereInput>;
};

export type ExternalQuizAssigneesConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  edge: UserLmsContentPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type ExternalQuizAssigneesConnectOrCreateFieldInput = {
  onCreate: ExternalQuizAssigneesConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type ExternalQuizAssigneesConnectOrCreateFieldInputOnCreate = {
  edge: UserLmsContentPropertiesCreateInput;
  node: UserOnCreateInput;
};

export type ExternalQuizAssigneesConnection = {
  __typename?: 'ExternalQuizAssigneesConnection';
  edges: Array<ExternalQuizAssigneesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalQuizAssigneesConnectionSort = {
  edge?: InputMaybe<UserLmsContentPropertiesSort>;
  node?: InputMaybe<UserSort>;
};

export type ExternalQuizAssigneesConnectionWhere = {
  AND?: InputMaybe<Array<ExternalQuizAssigneesConnectionWhere>>;
  NOT?: InputMaybe<ExternalQuizAssigneesConnectionWhere>;
  OR?: InputMaybe<Array<ExternalQuizAssigneesConnectionWhere>>;
  edge?: InputMaybe<UserLmsContentPropertiesWhere>;
  node?: InputMaybe<UserWhere>;
};

export type ExternalQuizAssigneesCreateFieldInput = {
  edge: UserLmsContentPropertiesCreateInput;
  node: UserCreateInput;
};

export type ExternalQuizAssigneesDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<ExternalQuizAssigneesConnectionWhere>;
};

export type ExternalQuizAssigneesDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<ExternalQuizAssigneesConnectionWhere>;
};

export type ExternalQuizAssigneesFieldInput = {
  connect?: InputMaybe<Array<ExternalQuizAssigneesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalQuizAssigneesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalQuizAssigneesCreateFieldInput>>;
};

export type ExternalQuizAssigneesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalQuizAssigneesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalQuizAssigneesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalQuizAssigneesNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalQuizAssigneesRelationship = {
  __typename?: 'ExternalQuizAssigneesRelationship';
  cursor: Scalars['String']['output'];
  node: User;
  properties: UserLmsContentProperties;
};

export type ExternalQuizAssigneesUpdateConnectionInput = {
  edge?: InputMaybe<UserLmsContentPropertiesUpdateInput>;
  node?: InputMaybe<UserUpdateInput>;
};

export type ExternalQuizAssigneesUpdateFieldInput = {
  connect?: InputMaybe<Array<ExternalQuizAssigneesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalQuizAssigneesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalQuizAssigneesCreateFieldInput>>;
  delete?: InputMaybe<Array<ExternalQuizAssigneesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ExternalQuizAssigneesDisconnectFieldInput>>;
  update?: InputMaybe<ExternalQuizAssigneesUpdateConnectionInput>;
  where?: InputMaybe<ExternalQuizAssigneesConnectionWhere>;
};

export enum ExternalQuizAttemptKind {
  Limited = 'LIMITED',
  Unknown = 'UNKNOWN',
  Unlimited = 'UNLIMITED'
}

export type ExternalQuizConnectInput = {
  assignees?: InputMaybe<Array<ExternalQuizAssigneesConnectFieldInput>>;
  course?: InputMaybe<ExternalQuizCourseConnectFieldInput>;
  nudgesAboutThis?: InputMaybe<Array<ExternalQuizNudgesAboutThisConnectFieldInput>>;
  submissions?: InputMaybe<Array<ExternalQuizSubmissionsConnectFieldInput>>;
};

export type ExternalQuizConnectOrCreateWhere = {
  node: ExternalQuizUniqueWhere;
};

export type ExternalQuizConnectWhere = {
  node: ExternalQuizWhere;
};

export type ExternalQuizCourseAggregateInput = {
  AND?: InputMaybe<Array<ExternalQuizCourseAggregateInput>>;
  NOT?: InputMaybe<ExternalQuizCourseAggregateInput>;
  OR?: InputMaybe<Array<ExternalQuizCourseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalQuizCourseNodeAggregationWhereInput>;
};

export type ExternalQuizCourseConnectFieldInput = {
  connect?: InputMaybe<ExternalCourseConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalCourseConnectWhere>;
};

export type ExternalQuizCourseConnectOrCreateFieldInput = {
  onCreate: ExternalQuizCourseConnectOrCreateFieldInputOnCreate;
  where: ExternalCourseConnectOrCreateWhere;
};

export type ExternalQuizCourseConnectOrCreateFieldInputOnCreate = {
  node: ExternalCourseOnCreateInput;
};

export type ExternalQuizCourseConnection = {
  __typename?: 'ExternalQuizCourseConnection';
  edges: Array<ExternalQuizCourseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalQuizCourseConnectionSort = {
  node?: InputMaybe<ExternalCourseSort>;
};

export type ExternalQuizCourseConnectionWhere = {
  AND?: InputMaybe<Array<ExternalQuizCourseConnectionWhere>>;
  NOT?: InputMaybe<ExternalQuizCourseConnectionWhere>;
  OR?: InputMaybe<Array<ExternalQuizCourseConnectionWhere>>;
  node?: InputMaybe<ExternalCourseWhere>;
};

export type ExternalQuizCourseCreateFieldInput = {
  node: ExternalCourseCreateInput;
};

export type ExternalQuizCourseDeleteFieldInput = {
  delete?: InputMaybe<ExternalCourseDeleteInput>;
  where?: InputMaybe<ExternalQuizCourseConnectionWhere>;
};

export type ExternalQuizCourseDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalCourseDisconnectInput>;
  where?: InputMaybe<ExternalQuizCourseConnectionWhere>;
};

export type ExternalQuizCourseFieldInput = {
  connect?: InputMaybe<ExternalQuizCourseConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalQuizCourseConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalQuizCourseCreateFieldInput>;
};

export type ExternalQuizCourseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalQuizCourseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalQuizCourseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalQuizCourseNodeAggregationWhereInput>>;
  courseCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  courseCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  courseCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  courseCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  courseCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  endDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalQuizCourseRelationship = {
  __typename?: 'ExternalQuizCourseRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalCourse;
};

export type ExternalQuizCourseUpdateConnectionInput = {
  node?: InputMaybe<ExternalCourseUpdateInput>;
};

export type ExternalQuizCourseUpdateFieldInput = {
  connect?: InputMaybe<ExternalQuizCourseConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalQuizCourseConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalQuizCourseCreateFieldInput>;
  delete?: InputMaybe<ExternalQuizCourseDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalQuizCourseDisconnectFieldInput>;
  update?: InputMaybe<ExternalQuizCourseUpdateConnectionInput>;
  where?: InputMaybe<ExternalQuizCourseConnectionWhere>;
};

export type ExternalQuizCreateInput = {
  assignees?: InputMaybe<ExternalQuizAssigneesFieldInput>;
  attemptsAllowed?: InputMaybe<Scalars['Int']['input']>;
  attemptsKind: ExternalQuizAttemptKind;
  availableFrom?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil?: InputMaybe<Scalars['DateTime']['input']>;
  course?: InputMaybe<ExternalQuizCourseFieldInput>;
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  descriptionText?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  lmsSource: LmsSource;
  nudgesAboutThis?: InputMaybe<ExternalQuizNudgesAboutThisFieldInput>;
  pointsPossible?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerCourseId: Scalars['String']['input'];
  providerKey: Scalars['String']['input'];
  providerQuizId: Scalars['String']['input'];
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  submissions?: InputMaybe<ExternalQuizSubmissionsFieldInput>;
  syncedAt: Scalars['DateTime']['input'];
  timeLimitMinutes?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  visibility: ExternalQuizVisibility;
};

export type ExternalQuizDeleteInput = {
  assignees?: InputMaybe<Array<ExternalQuizAssigneesDeleteFieldInput>>;
  course?: InputMaybe<ExternalQuizCourseDeleteFieldInput>;
  nudgesAboutThis?: InputMaybe<Array<ExternalQuizNudgesAboutThisDeleteFieldInput>>;
  submissions?: InputMaybe<Array<ExternalQuizSubmissionsDeleteFieldInput>>;
};

export type ExternalQuizDisconnectInput = {
  assignees?: InputMaybe<Array<ExternalQuizAssigneesDisconnectFieldInput>>;
  course?: InputMaybe<ExternalQuizCourseDisconnectFieldInput>;
  nudgesAboutThis?: InputMaybe<Array<ExternalQuizNudgesAboutThisDisconnectFieldInput>>;
  submissions?: InputMaybe<Array<ExternalQuizSubmissionsDisconnectFieldInput>>;
};

export type ExternalQuizExternalCourseCourseAggregationSelection = {
  __typename?: 'ExternalQuizExternalCourseCourseAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalQuizExternalCourseCourseNodeAggregateSelection>;
};

export type ExternalQuizExternalCourseCourseNodeAggregateSelection = {
  __typename?: 'ExternalQuizExternalCourseCourseNodeAggregateSelection';
  courseCode: StringAggregateSelection;
  descriptionHtml: StringAggregateSelection;
  descriptionText: StringAggregateSelection;
  endDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  name: StringAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  startDate: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalQuizExternalSubmissionSubmissionsAggregationSelection = {
  __typename?: 'ExternalQuizExternalSubmissionSubmissionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalQuizExternalSubmissionSubmissionsNodeAggregateSelection>;
};

export type ExternalQuizExternalSubmissionSubmissionsNodeAggregateSelection = {
  __typename?: 'ExternalQuizExternalSubmissionSubmissionsNodeAggregateSelection';
  gradeText: StringAggregateSelection;
  gradedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  pointsPossible: FloatAggregateSelection;
  providerContentId: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  providerUserId: StringAggregateSelection;
  score: FloatAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  submittedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
};

export type ExternalQuizNudgeNudgesAboutThisAggregationSelection = {
  __typename?: 'ExternalQuizNudgeNudgesAboutThisAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalQuizNudgeNudgesAboutThisNodeAggregateSelection>;
};

export type ExternalQuizNudgeNudgesAboutThisNodeAggregateSelection = {
  __typename?: 'ExternalQuizNudgeNudgesAboutThisNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  idempotencyKey: StringAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  priorityScore: FloatAggregateSelection;
  scheduledFor: DateTimeAggregateSelection;
  snoozedUntil: DateTimeAggregateSelection;
  taskCompletedAt: DateTimeAggregateSelection;
};

export type ExternalQuizNudgesAboutThisAggregateInput = {
  AND?: InputMaybe<Array<ExternalQuizNudgesAboutThisAggregateInput>>;
  NOT?: InputMaybe<ExternalQuizNudgesAboutThisAggregateInput>;
  OR?: InputMaybe<Array<ExternalQuizNudgesAboutThisAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalQuizNudgesAboutThisNodeAggregationWhereInput>;
};

export type ExternalQuizNudgesAboutThisConnectFieldInput = {
  connect?: InputMaybe<Array<NudgeConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<NudgeConnectWhere>;
};

export type ExternalQuizNudgesAboutThisConnectOrCreateFieldInput = {
  onCreate: ExternalQuizNudgesAboutThisConnectOrCreateFieldInputOnCreate;
  where: NudgeConnectOrCreateWhere;
};

export type ExternalQuizNudgesAboutThisConnectOrCreateFieldInputOnCreate = {
  node: NudgeOnCreateInput;
};

export type ExternalQuizNudgesAboutThisConnection = {
  __typename?: 'ExternalQuizNudgesAboutThisConnection';
  edges: Array<ExternalQuizNudgesAboutThisRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalQuizNudgesAboutThisConnectionSort = {
  node?: InputMaybe<NudgeSort>;
};

export type ExternalQuizNudgesAboutThisConnectionWhere = {
  AND?: InputMaybe<Array<ExternalQuizNudgesAboutThisConnectionWhere>>;
  NOT?: InputMaybe<ExternalQuizNudgesAboutThisConnectionWhere>;
  OR?: InputMaybe<Array<ExternalQuizNudgesAboutThisConnectionWhere>>;
  node?: InputMaybe<NudgeWhere>;
};

export type ExternalQuizNudgesAboutThisCreateFieldInput = {
  node: NudgeCreateInput;
};

export type ExternalQuizNudgesAboutThisDeleteFieldInput = {
  delete?: InputMaybe<NudgeDeleteInput>;
  where?: InputMaybe<ExternalQuizNudgesAboutThisConnectionWhere>;
};

export type ExternalQuizNudgesAboutThisDisconnectFieldInput = {
  disconnect?: InputMaybe<NudgeDisconnectInput>;
  where?: InputMaybe<ExternalQuizNudgesAboutThisConnectionWhere>;
};

export type ExternalQuizNudgesAboutThisFieldInput = {
  connect?: InputMaybe<Array<ExternalQuizNudgesAboutThisConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalQuizNudgesAboutThisConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalQuizNudgesAboutThisCreateFieldInput>>;
};

export type ExternalQuizNudgesAboutThisNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalQuizNudgesAboutThisNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalQuizNudgesAboutThisNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalQuizNudgesAboutThisNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  idempotencyKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  priorityScore_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  scheduledFor_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ExternalQuizNudgesAboutThisRelationship = {
  __typename?: 'ExternalQuizNudgesAboutThisRelationship';
  cursor: Scalars['String']['output'];
  node: Nudge;
};

export type ExternalQuizNudgesAboutThisUpdateConnectionInput = {
  node?: InputMaybe<NudgeUpdateInput>;
};

export type ExternalQuizNudgesAboutThisUpdateFieldInput = {
  connect?: InputMaybe<Array<ExternalQuizNudgesAboutThisConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalQuizNudgesAboutThisConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalQuizNudgesAboutThisCreateFieldInput>>;
  delete?: InputMaybe<Array<ExternalQuizNudgesAboutThisDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ExternalQuizNudgesAboutThisDisconnectFieldInput>>;
  update?: InputMaybe<ExternalQuizNudgesAboutThisUpdateConnectionInput>;
  where?: InputMaybe<ExternalQuizNudgesAboutThisConnectionWhere>;
};

export type ExternalQuizOnCreateInput = {
  attemptsAllowed?: InputMaybe<Scalars['Int']['input']>;
  attemptsKind: ExternalQuizAttemptKind;
  availableFrom?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil?: InputMaybe<Scalars['DateTime']['input']>;
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  descriptionText?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  lmsSource: LmsSource;
  pointsPossible?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerCourseId: Scalars['String']['input'];
  providerKey: Scalars['String']['input'];
  providerQuizId: Scalars['String']['input'];
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt: Scalars['DateTime']['input'];
  timeLimitMinutes?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  visibility: ExternalQuizVisibility;
};

export type ExternalQuizOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ExternalQuizSort objects to sort ExternalQuizs by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ExternalQuizSort>>;
};

/** Fields to sort ExternalQuizs by. The order in which sorts are applied is not guaranteed when specifying many fields in one ExternalQuizSort object. */
export type ExternalQuizSort = {
  attemptsAllowed?: InputMaybe<SortDirection>;
  attemptsKind?: InputMaybe<SortDirection>;
  availableFrom?: InputMaybe<SortDirection>;
  availableUntil?: InputMaybe<SortDirection>;
  descriptionHtml?: InputMaybe<SortDirection>;
  descriptionText?: InputMaybe<SortDirection>;
  dueDate?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lmsSource?: InputMaybe<SortDirection>;
  pointsPossible?: InputMaybe<SortDirection>;
  providerApiUrl?: InputMaybe<SortDirection>;
  providerCourseId?: InputMaybe<SortDirection>;
  providerKey?: InputMaybe<SortDirection>;
  providerQuizId?: InputMaybe<SortDirection>;
  sourceMeta?: InputMaybe<SortDirection>;
  sourcePayload?: InputMaybe<SortDirection>;
  sourceUpdatedAt?: InputMaybe<SortDirection>;
  syncedAt?: InputMaybe<SortDirection>;
  timeLimitMinutes?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  url?: InputMaybe<SortDirection>;
  visibility?: InputMaybe<SortDirection>;
};

export type ExternalQuizSubmissionsAggregateInput = {
  AND?: InputMaybe<Array<ExternalQuizSubmissionsAggregateInput>>;
  NOT?: InputMaybe<ExternalQuizSubmissionsAggregateInput>;
  OR?: InputMaybe<Array<ExternalQuizSubmissionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalQuizSubmissionsNodeAggregationWhereInput>;
};

export type ExternalQuizSubmissionsConnectFieldInput = {
  connect?: InputMaybe<Array<ExternalSubmissionConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalSubmissionConnectWhere>;
};

export type ExternalQuizSubmissionsConnectOrCreateFieldInput = {
  onCreate: ExternalQuizSubmissionsConnectOrCreateFieldInputOnCreate;
  where: ExternalSubmissionConnectOrCreateWhere;
};

export type ExternalQuizSubmissionsConnectOrCreateFieldInputOnCreate = {
  node: ExternalSubmissionOnCreateInput;
};

export type ExternalQuizSubmissionsConnection = {
  __typename?: 'ExternalQuizSubmissionsConnection';
  edges: Array<ExternalQuizSubmissionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalQuizSubmissionsConnectionSort = {
  node?: InputMaybe<ExternalSubmissionSort>;
};

export type ExternalQuizSubmissionsConnectionWhere = {
  AND?: InputMaybe<Array<ExternalQuizSubmissionsConnectionWhere>>;
  NOT?: InputMaybe<ExternalQuizSubmissionsConnectionWhere>;
  OR?: InputMaybe<Array<ExternalQuizSubmissionsConnectionWhere>>;
  node?: InputMaybe<ExternalSubmissionWhere>;
};

export type ExternalQuizSubmissionsCreateFieldInput = {
  node: ExternalSubmissionCreateInput;
};

export type ExternalQuizSubmissionsDeleteFieldInput = {
  delete?: InputMaybe<ExternalSubmissionDeleteInput>;
  where?: InputMaybe<ExternalQuizSubmissionsConnectionWhere>;
};

export type ExternalQuizSubmissionsDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalSubmissionDisconnectInput>;
  where?: InputMaybe<ExternalQuizSubmissionsConnectionWhere>;
};

export type ExternalQuizSubmissionsFieldInput = {
  connect?: InputMaybe<Array<ExternalQuizSubmissionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalQuizSubmissionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalQuizSubmissionsCreateFieldInput>>;
};

export type ExternalQuizSubmissionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalQuizSubmissionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalQuizSubmissionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalQuizSubmissionsNodeAggregationWhereInput>>;
  gradeText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gradeText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gradeText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gradeText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gradeText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gradeText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gradeText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gradeText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gradeText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gradeText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gradeText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gradeText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gradeText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gradeText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gradeText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gradedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pointsPossible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerContentId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerContentId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerContentId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerContentId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerContentId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerContentId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerContentId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  score_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  score_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  score_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  score_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  score_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  score_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  score_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  score_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  score_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  score_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  score_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  score_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  score_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  score_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  score_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  score_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  score_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  score_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  score_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  score_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ExternalQuizSubmissionsRelationship = {
  __typename?: 'ExternalQuizSubmissionsRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalSubmission;
};

export type ExternalQuizSubmissionsUpdateConnectionInput = {
  node?: InputMaybe<ExternalSubmissionUpdateInput>;
};

export type ExternalQuizSubmissionsUpdateFieldInput = {
  connect?: InputMaybe<Array<ExternalQuizSubmissionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalQuizSubmissionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalQuizSubmissionsCreateFieldInput>>;
  delete?: InputMaybe<Array<ExternalQuizSubmissionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ExternalQuizSubmissionsDisconnectFieldInput>>;
  update?: InputMaybe<ExternalQuizSubmissionsUpdateConnectionInput>;
  where?: InputMaybe<ExternalQuizSubmissionsConnectionWhere>;
};

export type ExternalQuizUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalQuizUpdateInput = {
  assignees?: InputMaybe<Array<ExternalQuizAssigneesUpdateFieldInput>>;
  attemptsAllowed?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  attemptsKind?: InputMaybe<ExternalQuizAttemptKind>;
  availableFrom?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil?: InputMaybe<Scalars['DateTime']['input']>;
  course?: InputMaybe<ExternalQuizCourseUpdateFieldInput>;
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  descriptionText?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  lmsSource?: InputMaybe<LmsSource>;
  nudgesAboutThis?: InputMaybe<Array<ExternalQuizNudgesAboutThisUpdateFieldInput>>;
  pointsPossible?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_ADD?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerCourseId?: InputMaybe<Scalars['String']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
  providerQuizId?: InputMaybe<Scalars['String']['input']>;
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  submissions?: InputMaybe<Array<ExternalQuizSubmissionsUpdateFieldInput>>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  timeLimitMinutes?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<ExternalQuizVisibility>;
};

export type ExternalQuizUserAssigneesAggregationSelection = {
  __typename?: 'ExternalQuizUserAssigneesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<ExternalQuizUserAssigneesEdgeAggregateSelection>;
  node?: Maybe<ExternalQuizUserAssigneesNodeAggregateSelection>;
};

export type ExternalQuizUserAssigneesEdgeAggregateSelection = {
  __typename?: 'ExternalQuizUserAssigneesEdgeAggregateSelection';
  syncedAt: DateTimeAggregateSelection;
};

export type ExternalQuizUserAssigneesNodeAggregateSelection = {
  __typename?: 'ExternalQuizUserAssigneesNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export enum ExternalQuizVisibility {
  Hidden = 'HIDDEN',
  Published = 'PUBLISHED',
  Unknown = 'UNKNOWN',
  Unpublished = 'UNPUBLISHED'
}

export type ExternalQuizWhere = {
  AND?: InputMaybe<Array<ExternalQuizWhere>>;
  NOT?: InputMaybe<ExternalQuizWhere>;
  OR?: InputMaybe<Array<ExternalQuizWhere>>;
  assigneesAggregate?: InputMaybe<ExternalQuizAssigneesAggregateInput>;
  /** Return ExternalQuizs where all of the related ExternalQuizAssigneesConnections match this filter */
  assigneesConnection_ALL?: InputMaybe<ExternalQuizAssigneesConnectionWhere>;
  /** Return ExternalQuizs where none of the related ExternalQuizAssigneesConnections match this filter */
  assigneesConnection_NONE?: InputMaybe<ExternalQuizAssigneesConnectionWhere>;
  /** Return ExternalQuizs where one of the related ExternalQuizAssigneesConnections match this filter */
  assigneesConnection_SINGLE?: InputMaybe<ExternalQuizAssigneesConnectionWhere>;
  /** Return ExternalQuizs where some of the related ExternalQuizAssigneesConnections match this filter */
  assigneesConnection_SOME?: InputMaybe<ExternalQuizAssigneesConnectionWhere>;
  /** Return ExternalQuizs where all of the related Users match this filter */
  assignees_ALL?: InputMaybe<UserWhere>;
  /** Return ExternalQuizs where none of the related Users match this filter */
  assignees_NONE?: InputMaybe<UserWhere>;
  /** Return ExternalQuizs where one of the related Users match this filter */
  assignees_SINGLE?: InputMaybe<UserWhere>;
  /** Return ExternalQuizs where some of the related Users match this filter */
  assignees_SOME?: InputMaybe<UserWhere>;
  attemptsAllowed?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_GT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_GTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  attemptsAllowed_LT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_LTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsKind?: InputMaybe<ExternalQuizAttemptKind>;
  attemptsKind_IN?: InputMaybe<Array<ExternalQuizAttemptKind>>;
  availableFrom?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  availableFrom_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  availableUntil_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  course?: InputMaybe<ExternalCourseWhere>;
  courseAggregate?: InputMaybe<ExternalQuizCourseAggregateInput>;
  courseConnection?: InputMaybe<ExternalQuizCourseConnectionWhere>;
  courseConnection_NOT?: InputMaybe<ExternalQuizCourseConnectionWhere>;
  course_NOT?: InputMaybe<ExternalCourseWhere>;
  descriptionHtml?: InputMaybe<Scalars['String']['input']>;
  descriptionHtml_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  descriptionHtml_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  descriptionHtml_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descriptionHtml_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  descriptionText?: InputMaybe<Scalars['String']['input']>;
  descriptionText_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  descriptionText_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  descriptionText_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descriptionText_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  dueDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lmsSource?: InputMaybe<LmsSource>;
  lmsSource_IN?: InputMaybe<Array<LmsSource>>;
  nudgesAboutThisAggregate?: InputMaybe<ExternalQuizNudgesAboutThisAggregateInput>;
  /** Return ExternalQuizs where all of the related ExternalQuizNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_ALL?: InputMaybe<ExternalQuizNudgesAboutThisConnectionWhere>;
  /** Return ExternalQuizs where none of the related ExternalQuizNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_NONE?: InputMaybe<ExternalQuizNudgesAboutThisConnectionWhere>;
  /** Return ExternalQuizs where one of the related ExternalQuizNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_SINGLE?: InputMaybe<ExternalQuizNudgesAboutThisConnectionWhere>;
  /** Return ExternalQuizs where some of the related ExternalQuizNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_SOME?: InputMaybe<ExternalQuizNudgesAboutThisConnectionWhere>;
  /** Return ExternalQuizs where all of the related Nudges match this filter */
  nudgesAboutThis_ALL?: InputMaybe<NudgeWhere>;
  /** Return ExternalQuizs where none of the related Nudges match this filter */
  nudgesAboutThis_NONE?: InputMaybe<NudgeWhere>;
  /** Return ExternalQuizs where one of the related Nudges match this filter */
  nudgesAboutThis_SINGLE?: InputMaybe<NudgeWhere>;
  /** Return ExternalQuizs where some of the related Nudges match this filter */
  nudgesAboutThis_SOME?: InputMaybe<NudgeWhere>;
  pointsPossible?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  pointsPossible_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerApiUrl_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerApiUrl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerCourseId?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerCourseId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
  providerKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerKey_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerQuizId?: InputMaybe<Scalars['String']['input']>;
  providerQuizId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerQuizId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerQuizId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerQuizId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourceMeta_IN?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload_IN?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  sourceUpdatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionsAggregate?: InputMaybe<ExternalQuizSubmissionsAggregateInput>;
  /** Return ExternalQuizs where all of the related ExternalQuizSubmissionsConnections match this filter */
  submissionsConnection_ALL?: InputMaybe<ExternalQuizSubmissionsConnectionWhere>;
  /** Return ExternalQuizs where none of the related ExternalQuizSubmissionsConnections match this filter */
  submissionsConnection_NONE?: InputMaybe<ExternalQuizSubmissionsConnectionWhere>;
  /** Return ExternalQuizs where one of the related ExternalQuizSubmissionsConnections match this filter */
  submissionsConnection_SINGLE?: InputMaybe<ExternalQuizSubmissionsConnectionWhere>;
  /** Return ExternalQuizs where some of the related ExternalQuizSubmissionsConnections match this filter */
  submissionsConnection_SOME?: InputMaybe<ExternalQuizSubmissionsConnectionWhere>;
  /** Return ExternalQuizs where all of the related ExternalSubmissions match this filter */
  submissions_ALL?: InputMaybe<ExternalSubmissionWhere>;
  /** Return ExternalQuizs where none of the related ExternalSubmissions match this filter */
  submissions_NONE?: InputMaybe<ExternalSubmissionWhere>;
  /** Return ExternalQuizs where one of the related ExternalSubmissions match this filter */
  submissions_SINGLE?: InputMaybe<ExternalSubmissionWhere>;
  /** Return ExternalQuizs where some of the related ExternalSubmissions match this filter */
  submissions_SOME?: InputMaybe<ExternalSubmissionWhere>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  syncedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  timeLimitMinutes?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timeLimitMinutes_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_LTE?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<ExternalQuizVisibility>;
  visibility_IN?: InputMaybe<Array<ExternalQuizVisibility>>;
};

export type ExternalSubmission = {
  __typename?: 'ExternalSubmission';
  assignment?: Maybe<ExternalAssignment>;
  assignmentAggregate?: Maybe<ExternalSubmissionExternalAssignmentAssignmentAggregationSelection>;
  assignmentConnection: ExternalSubmissionAssignmentConnection;
  attempt?: Maybe<ExternalSubmissionAttempt>;
  discussion?: Maybe<ExternalDiscussionBoard>;
  discussionAggregate?: Maybe<ExternalSubmissionExternalDiscussionBoardDiscussionAggregationSelection>;
  discussionConnection: ExternalSubmissionDiscussionConnection;
  files: Array<ExternalFile>;
  filesAggregate?: Maybe<ExternalSubmissionExternalFileFilesAggregationSelection>;
  filesConnection: ExternalSubmissionFilesConnection;
  gradeText?: Maybe<Scalars['String']['output']>;
  gradedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  lmsSource: LmsSource;
  pointsPossible?: Maybe<Scalars['Float']['output']>;
  providerContentId: Scalars['String']['output'];
  providerContentType: ExternalSubmissionContentType;
  providerCourseId: Scalars['String']['output'];
  providerKey: Scalars['String']['output'];
  providerUserId: Scalars['String']['output'];
  quiz?: Maybe<ExternalQuiz>;
  quizAggregate?: Maybe<ExternalSubmissionExternalQuizQuizAggregationSelection>;
  quizConnection: ExternalSubmissionQuizConnection;
  score?: Maybe<Scalars['Float']['output']>;
  sourceMeta?: Maybe<Scalars['JSON']['output']>;
  sourcePayload?: Maybe<Scalars['JSON']['output']>;
  sourceUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  status: ExternalSubmissionStatus;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  syncedAt: Scalars['DateTime']['output'];
  user: User;
  userAggregate?: Maybe<ExternalSubmissionUserUserAggregationSelection>;
  userConnection: ExternalSubmissionUserConnection;
};


export type ExternalSubmissionAssignmentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalAssignmentOptions>;
  where?: InputMaybe<ExternalAssignmentWhere>;
};


export type ExternalSubmissionAssignmentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalAssignmentWhere>;
};


export type ExternalSubmissionAssignmentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalSubmissionAssignmentConnectionSort>>;
  where?: InputMaybe<ExternalSubmissionAssignmentConnectionWhere>;
};


export type ExternalSubmissionDiscussionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalDiscussionBoardOptions>;
  where?: InputMaybe<ExternalDiscussionBoardWhere>;
};


export type ExternalSubmissionDiscussionAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalDiscussionBoardWhere>;
};


export type ExternalSubmissionDiscussionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalSubmissionDiscussionConnectionSort>>;
  where?: InputMaybe<ExternalSubmissionDiscussionConnectionWhere>;
};


export type ExternalSubmissionFilesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalFileOptions>;
  where?: InputMaybe<ExternalFileWhere>;
};


export type ExternalSubmissionFilesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalFileWhere>;
};


export type ExternalSubmissionFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalSubmissionFilesConnectionSort>>;
  where?: InputMaybe<ExternalSubmissionFilesConnectionWhere>;
};


export type ExternalSubmissionQuizArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalQuizOptions>;
  where?: InputMaybe<ExternalQuizWhere>;
};


export type ExternalSubmissionQuizAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalQuizWhere>;
};


export type ExternalSubmissionQuizConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalSubmissionQuizConnectionSort>>;
  where?: InputMaybe<ExternalSubmissionQuizConnectionWhere>;
};


export type ExternalSubmissionUserArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type ExternalSubmissionUserAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type ExternalSubmissionUserConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ExternalSubmissionUserConnectionSort>>;
  where?: InputMaybe<ExternalSubmissionUserConnectionWhere>;
};

export type ExternalSubmissionAssignmentAggregateInput = {
  AND?: InputMaybe<Array<ExternalSubmissionAssignmentAggregateInput>>;
  NOT?: InputMaybe<ExternalSubmissionAssignmentAggregateInput>;
  OR?: InputMaybe<Array<ExternalSubmissionAssignmentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalSubmissionAssignmentNodeAggregationWhereInput>;
};

export type ExternalSubmissionAssignmentConnectFieldInput = {
  connect?: InputMaybe<ExternalAssignmentConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalAssignmentConnectWhere>;
};

export type ExternalSubmissionAssignmentConnectOrCreateFieldInput = {
  onCreate: ExternalSubmissionAssignmentConnectOrCreateFieldInputOnCreate;
  where: ExternalAssignmentConnectOrCreateWhere;
};

export type ExternalSubmissionAssignmentConnectOrCreateFieldInputOnCreate = {
  node: ExternalAssignmentOnCreateInput;
};

export type ExternalSubmissionAssignmentConnection = {
  __typename?: 'ExternalSubmissionAssignmentConnection';
  edges: Array<ExternalSubmissionAssignmentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalSubmissionAssignmentConnectionSort = {
  node?: InputMaybe<ExternalAssignmentSort>;
};

export type ExternalSubmissionAssignmentConnectionWhere = {
  AND?: InputMaybe<Array<ExternalSubmissionAssignmentConnectionWhere>>;
  NOT?: InputMaybe<ExternalSubmissionAssignmentConnectionWhere>;
  OR?: InputMaybe<Array<ExternalSubmissionAssignmentConnectionWhere>>;
  node?: InputMaybe<ExternalAssignmentWhere>;
};

export type ExternalSubmissionAssignmentCreateFieldInput = {
  node: ExternalAssignmentCreateInput;
};

export type ExternalSubmissionAssignmentDeleteFieldInput = {
  delete?: InputMaybe<ExternalAssignmentDeleteInput>;
  where?: InputMaybe<ExternalSubmissionAssignmentConnectionWhere>;
};

export type ExternalSubmissionAssignmentDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalAssignmentDisconnectInput>;
  where?: InputMaybe<ExternalSubmissionAssignmentConnectionWhere>;
};

export type ExternalSubmissionAssignmentFieldInput = {
  connect?: InputMaybe<ExternalSubmissionAssignmentConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalSubmissionAssignmentConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalSubmissionAssignmentCreateFieldInput>;
};

export type ExternalSubmissionAssignmentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalSubmissionAssignmentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalSubmissionAssignmentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalSubmissionAssignmentNodeAggregationWhereInput>>;
  availableFrom_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  descriptionHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradingType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gradingType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gradingType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gradingType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gradingType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gradingType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gradingType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gradingType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gradingType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gradingType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gradingType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gradingType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gradingType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gradingType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gradingType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pointsPossible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerAssignmentId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerAssignmentId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerAssignmentId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerAssignmentId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerAssignmentId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalSubmissionAssignmentRelationship = {
  __typename?: 'ExternalSubmissionAssignmentRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalAssignment;
};

export type ExternalSubmissionAssignmentUpdateConnectionInput = {
  node?: InputMaybe<ExternalAssignmentUpdateInput>;
};

export type ExternalSubmissionAssignmentUpdateFieldInput = {
  connect?: InputMaybe<ExternalSubmissionAssignmentConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalSubmissionAssignmentConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalSubmissionAssignmentCreateFieldInput>;
  delete?: InputMaybe<ExternalSubmissionAssignmentDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalSubmissionAssignmentDisconnectFieldInput>;
  update?: InputMaybe<ExternalSubmissionAssignmentUpdateConnectionInput>;
  where?: InputMaybe<ExternalSubmissionAssignmentConnectionWhere>;
};

export type ExternalSubmissionAttempt = {
  __typename?: 'ExternalSubmissionAttempt';
  fileName?: Maybe<Scalars['String']['output']>;
  fileSizeBytes?: Maybe<Scalars['Int']['output']>;
  kind: ExternalSubmissionAttemptKind;
  providerFileId?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum ExternalSubmissionAttemptKind {
  File = 'FILE',
  Lti = 'LTI',
  Other = 'OTHER',
  Text = 'TEXT',
  Url = 'URL'
}

export type ExternalSubmissionConnectInput = {
  assignment?: InputMaybe<ExternalSubmissionAssignmentConnectFieldInput>;
  discussion?: InputMaybe<ExternalSubmissionDiscussionConnectFieldInput>;
  files?: InputMaybe<Array<ExternalSubmissionFilesConnectFieldInput>>;
  quiz?: InputMaybe<ExternalSubmissionQuizConnectFieldInput>;
  user?: InputMaybe<ExternalSubmissionUserConnectFieldInput>;
};

export type ExternalSubmissionConnectOrCreateWhere = {
  node: ExternalSubmissionUniqueWhere;
};

export type ExternalSubmissionConnectWhere = {
  node: ExternalSubmissionWhere;
};

export enum ExternalSubmissionContentType {
  Assignment = 'ASSIGNMENT',
  Discussion = 'DISCUSSION',
  Quiz = 'QUIZ'
}

export type ExternalSubmissionCreateInput = {
  assignment?: InputMaybe<ExternalSubmissionAssignmentFieldInput>;
  discussion?: InputMaybe<ExternalSubmissionDiscussionFieldInput>;
  files?: InputMaybe<ExternalSubmissionFilesFieldInput>;
  gradeText?: InputMaybe<Scalars['String']['input']>;
  gradedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lmsSource: LmsSource;
  pointsPossible?: InputMaybe<Scalars['Float']['input']>;
  providerContentId: Scalars['String']['input'];
  providerContentType: ExternalSubmissionContentType;
  providerCourseId: Scalars['String']['input'];
  providerKey: Scalars['String']['input'];
  providerUserId: Scalars['String']['input'];
  quiz?: InputMaybe<ExternalSubmissionQuizFieldInput>;
  score?: InputMaybe<Scalars['Float']['input']>;
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: ExternalSubmissionStatus;
  submittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt: Scalars['DateTime']['input'];
  user?: InputMaybe<ExternalSubmissionUserFieldInput>;
};

export type ExternalSubmissionDeleteInput = {
  assignment?: InputMaybe<ExternalSubmissionAssignmentDeleteFieldInput>;
  discussion?: InputMaybe<ExternalSubmissionDiscussionDeleteFieldInput>;
  files?: InputMaybe<Array<ExternalSubmissionFilesDeleteFieldInput>>;
  quiz?: InputMaybe<ExternalSubmissionQuizDeleteFieldInput>;
  user?: InputMaybe<ExternalSubmissionUserDeleteFieldInput>;
};

export type ExternalSubmissionDisconnectInput = {
  assignment?: InputMaybe<ExternalSubmissionAssignmentDisconnectFieldInput>;
  discussion?: InputMaybe<ExternalSubmissionDiscussionDisconnectFieldInput>;
  files?: InputMaybe<Array<ExternalSubmissionFilesDisconnectFieldInput>>;
  quiz?: InputMaybe<ExternalSubmissionQuizDisconnectFieldInput>;
  user?: InputMaybe<ExternalSubmissionUserDisconnectFieldInput>;
};

export type ExternalSubmissionDiscussionAggregateInput = {
  AND?: InputMaybe<Array<ExternalSubmissionDiscussionAggregateInput>>;
  NOT?: InputMaybe<ExternalSubmissionDiscussionAggregateInput>;
  OR?: InputMaybe<Array<ExternalSubmissionDiscussionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalSubmissionDiscussionNodeAggregationWhereInput>;
};

export type ExternalSubmissionDiscussionConnectFieldInput = {
  connect?: InputMaybe<ExternalDiscussionBoardConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalDiscussionBoardConnectWhere>;
};

export type ExternalSubmissionDiscussionConnectOrCreateFieldInput = {
  onCreate: ExternalSubmissionDiscussionConnectOrCreateFieldInputOnCreate;
  where: ExternalDiscussionBoardConnectOrCreateWhere;
};

export type ExternalSubmissionDiscussionConnectOrCreateFieldInputOnCreate = {
  node: ExternalDiscussionBoardOnCreateInput;
};

export type ExternalSubmissionDiscussionConnection = {
  __typename?: 'ExternalSubmissionDiscussionConnection';
  edges: Array<ExternalSubmissionDiscussionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalSubmissionDiscussionConnectionSort = {
  node?: InputMaybe<ExternalDiscussionBoardSort>;
};

export type ExternalSubmissionDiscussionConnectionWhere = {
  AND?: InputMaybe<Array<ExternalSubmissionDiscussionConnectionWhere>>;
  NOT?: InputMaybe<ExternalSubmissionDiscussionConnectionWhere>;
  OR?: InputMaybe<Array<ExternalSubmissionDiscussionConnectionWhere>>;
  node?: InputMaybe<ExternalDiscussionBoardWhere>;
};

export type ExternalSubmissionDiscussionCreateFieldInput = {
  node: ExternalDiscussionBoardCreateInput;
};

export type ExternalSubmissionDiscussionDeleteFieldInput = {
  delete?: InputMaybe<ExternalDiscussionBoardDeleteInput>;
  where?: InputMaybe<ExternalSubmissionDiscussionConnectionWhere>;
};

export type ExternalSubmissionDiscussionDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalDiscussionBoardDisconnectInput>;
  where?: InputMaybe<ExternalSubmissionDiscussionConnectionWhere>;
};

export type ExternalSubmissionDiscussionFieldInput = {
  connect?: InputMaybe<ExternalSubmissionDiscussionConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalSubmissionDiscussionConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalSubmissionDiscussionCreateFieldInput>;
};

export type ExternalSubmissionDiscussionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalSubmissionDiscussionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalSubmissionDiscussionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalSubmissionDiscussionNodeAggregationWhereInput>>;
  availableFrom_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  messageHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  messageHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  messageHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  messageHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  messageHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  messageHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  messageText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  messageText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  messageText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  messageText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  messageText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  messageText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  messageText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  messageText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  messageText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  messageText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  messageText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  messageText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  messageText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  messageText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  messageText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pointsPossible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerDiscussionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerDiscussionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerDiscussionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerDiscussionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerDiscussionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalSubmissionDiscussionRelationship = {
  __typename?: 'ExternalSubmissionDiscussionRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalDiscussionBoard;
};

export type ExternalSubmissionDiscussionUpdateConnectionInput = {
  node?: InputMaybe<ExternalDiscussionBoardUpdateInput>;
};

export type ExternalSubmissionDiscussionUpdateFieldInput = {
  connect?: InputMaybe<ExternalSubmissionDiscussionConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalSubmissionDiscussionConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalSubmissionDiscussionCreateFieldInput>;
  delete?: InputMaybe<ExternalSubmissionDiscussionDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalSubmissionDiscussionDisconnectFieldInput>;
  update?: InputMaybe<ExternalSubmissionDiscussionUpdateConnectionInput>;
  where?: InputMaybe<ExternalSubmissionDiscussionConnectionWhere>;
};

export type ExternalSubmissionExternalAssignmentAssignmentAggregationSelection = {
  __typename?: 'ExternalSubmissionExternalAssignmentAssignmentAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalSubmissionExternalAssignmentAssignmentNodeAggregateSelection>;
};

export type ExternalSubmissionExternalAssignmentAssignmentNodeAggregateSelection = {
  __typename?: 'ExternalSubmissionExternalAssignmentAssignmentNodeAggregateSelection';
  availableFrom: DateTimeAggregateSelection;
  availableUntil: DateTimeAggregateSelection;
  descriptionHtml: StringAggregateSelection;
  descriptionText: StringAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  gradingType: StringAggregateSelection;
  id: IdAggregateSelection;
  pointsPossible: FloatAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerAssignmentId: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  title: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalSubmissionExternalDiscussionBoardDiscussionAggregationSelection = {
  __typename?: 'ExternalSubmissionExternalDiscussionBoardDiscussionAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalSubmissionExternalDiscussionBoardDiscussionNodeAggregateSelection>;
};

export type ExternalSubmissionExternalDiscussionBoardDiscussionNodeAggregateSelection = {
  __typename?: 'ExternalSubmissionExternalDiscussionBoardDiscussionNodeAggregateSelection';
  availableFrom: DateTimeAggregateSelection;
  availableUntil: DateTimeAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  messageHtml: StringAggregateSelection;
  messageText: StringAggregateSelection;
  pointsPossible: FloatAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerDiscussionId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  title: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalSubmissionExternalFileFilesAggregationSelection = {
  __typename?: 'ExternalSubmissionExternalFileFilesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalSubmissionExternalFileFilesNodeAggregateSelection>;
};

export type ExternalSubmissionExternalFileFilesNodeAggregateSelection = {
  __typename?: 'ExternalSubmissionExternalFileFilesNodeAggregateSelection';
  attachedToId: StringAggregateSelection;
  displayName: StringAggregateSelection;
  downloadUrl: StringAggregateSelection;
  fileName: StringAggregateSelection;
  fileSize: IntAggregateSelection;
  id: IdAggregateSelection;
  mimeType: StringAggregateSelection;
  modifiedAt: DateTimeAggregateSelection;
  previewUrl: StringAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerFileId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  uploadedAt: DateTimeAggregateSelection;
  uploadedBy: StringAggregateSelection;
};

export type ExternalSubmissionExternalQuizQuizAggregationSelection = {
  __typename?: 'ExternalSubmissionExternalQuizQuizAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalSubmissionExternalQuizQuizNodeAggregateSelection>;
};

export type ExternalSubmissionExternalQuizQuizNodeAggregateSelection = {
  __typename?: 'ExternalSubmissionExternalQuizQuizNodeAggregateSelection';
  attemptsAllowed: IntAggregateSelection;
  availableFrom: DateTimeAggregateSelection;
  availableUntil: DateTimeAggregateSelection;
  descriptionHtml: StringAggregateSelection;
  descriptionText: StringAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  pointsPossible: FloatAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  providerQuizId: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  timeLimitMinutes: IntAggregateSelection;
  title: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type ExternalSubmissionFilesAggregateInput = {
  AND?: InputMaybe<Array<ExternalSubmissionFilesAggregateInput>>;
  NOT?: InputMaybe<ExternalSubmissionFilesAggregateInput>;
  OR?: InputMaybe<Array<ExternalSubmissionFilesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalSubmissionFilesNodeAggregationWhereInput>;
};

export type ExternalSubmissionFilesConnectFieldInput = {
  connect?: InputMaybe<Array<ExternalFileConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalFileConnectWhere>;
};

export type ExternalSubmissionFilesConnectOrCreateFieldInput = {
  onCreate: ExternalSubmissionFilesConnectOrCreateFieldInputOnCreate;
  where: ExternalFileConnectOrCreateWhere;
};

export type ExternalSubmissionFilesConnectOrCreateFieldInputOnCreate = {
  node: ExternalFileOnCreateInput;
};

export type ExternalSubmissionFilesConnection = {
  __typename?: 'ExternalSubmissionFilesConnection';
  edges: Array<ExternalSubmissionFilesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalSubmissionFilesConnectionSort = {
  node?: InputMaybe<ExternalFileSort>;
};

export type ExternalSubmissionFilesConnectionWhere = {
  AND?: InputMaybe<Array<ExternalSubmissionFilesConnectionWhere>>;
  NOT?: InputMaybe<ExternalSubmissionFilesConnectionWhere>;
  OR?: InputMaybe<Array<ExternalSubmissionFilesConnectionWhere>>;
  node?: InputMaybe<ExternalFileWhere>;
};

export type ExternalSubmissionFilesCreateFieldInput = {
  node: ExternalFileCreateInput;
};

export type ExternalSubmissionFilesDeleteFieldInput = {
  delete?: InputMaybe<ExternalFileDeleteInput>;
  where?: InputMaybe<ExternalSubmissionFilesConnectionWhere>;
};

export type ExternalSubmissionFilesDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalFileDisconnectInput>;
  where?: InputMaybe<ExternalSubmissionFilesConnectionWhere>;
};

export type ExternalSubmissionFilesFieldInput = {
  connect?: InputMaybe<Array<ExternalSubmissionFilesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalSubmissionFilesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalSubmissionFilesCreateFieldInput>>;
};

export type ExternalSubmissionFilesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalSubmissionFilesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalSubmissionFilesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalSubmissionFilesNodeAggregationWhereInput>>;
  attachedToId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  attachedToId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  attachedToId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  attachedToId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  attachedToId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  attachedToId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  attachedToId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  downloadUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  downloadUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  downloadUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  downloadUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  downloadUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  downloadUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileSize_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileSize_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  fileSize_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileSize_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  fileSize_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileSize_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileSize_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileSize_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileSize_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  fileSize_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  mimeType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  mimeType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mimeType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modifiedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  modifiedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  previewUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  previewUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  previewUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  previewUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  previewUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  previewUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  previewUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerFileId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerFileId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerFileId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerFileId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerFileId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerFileId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedBy_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uploadedBy_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uploadedBy_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uploadedBy_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uploadedBy_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uploadedBy_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uploadedBy_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalSubmissionFilesRelationship = {
  __typename?: 'ExternalSubmissionFilesRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalFile;
};

export type ExternalSubmissionFilesUpdateConnectionInput = {
  node?: InputMaybe<ExternalFileUpdateInput>;
};

export type ExternalSubmissionFilesUpdateFieldInput = {
  connect?: InputMaybe<Array<ExternalSubmissionFilesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalSubmissionFilesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ExternalSubmissionFilesCreateFieldInput>>;
  delete?: InputMaybe<Array<ExternalSubmissionFilesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ExternalSubmissionFilesDisconnectFieldInput>>;
  update?: InputMaybe<ExternalSubmissionFilesUpdateConnectionInput>;
  where?: InputMaybe<ExternalSubmissionFilesConnectionWhere>;
};

export type ExternalSubmissionOnCreateInput = {
  gradeText?: InputMaybe<Scalars['String']['input']>;
  gradedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lmsSource: LmsSource;
  pointsPossible?: InputMaybe<Scalars['Float']['input']>;
  providerContentId: Scalars['String']['input'];
  providerContentType: ExternalSubmissionContentType;
  providerCourseId: Scalars['String']['input'];
  providerKey: Scalars['String']['input'];
  providerUserId: Scalars['String']['input'];
  score?: InputMaybe<Scalars['Float']['input']>;
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: ExternalSubmissionStatus;
  submittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt: Scalars['DateTime']['input'];
};

export type ExternalSubmissionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ExternalSubmissionSort objects to sort ExternalSubmissions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ExternalSubmissionSort>>;
};

export type ExternalSubmissionQuizAggregateInput = {
  AND?: InputMaybe<Array<ExternalSubmissionQuizAggregateInput>>;
  NOT?: InputMaybe<ExternalSubmissionQuizAggregateInput>;
  OR?: InputMaybe<Array<ExternalSubmissionQuizAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalSubmissionQuizNodeAggregationWhereInput>;
};

export type ExternalSubmissionQuizConnectFieldInput = {
  connect?: InputMaybe<ExternalQuizConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalQuizConnectWhere>;
};

export type ExternalSubmissionQuizConnectOrCreateFieldInput = {
  onCreate: ExternalSubmissionQuizConnectOrCreateFieldInputOnCreate;
  where: ExternalQuizConnectOrCreateWhere;
};

export type ExternalSubmissionQuizConnectOrCreateFieldInputOnCreate = {
  node: ExternalQuizOnCreateInput;
};

export type ExternalSubmissionQuizConnection = {
  __typename?: 'ExternalSubmissionQuizConnection';
  edges: Array<ExternalSubmissionQuizRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalSubmissionQuizConnectionSort = {
  node?: InputMaybe<ExternalQuizSort>;
};

export type ExternalSubmissionQuizConnectionWhere = {
  AND?: InputMaybe<Array<ExternalSubmissionQuizConnectionWhere>>;
  NOT?: InputMaybe<ExternalSubmissionQuizConnectionWhere>;
  OR?: InputMaybe<Array<ExternalSubmissionQuizConnectionWhere>>;
  node?: InputMaybe<ExternalQuizWhere>;
};

export type ExternalSubmissionQuizCreateFieldInput = {
  node: ExternalQuizCreateInput;
};

export type ExternalSubmissionQuizDeleteFieldInput = {
  delete?: InputMaybe<ExternalQuizDeleteInput>;
  where?: InputMaybe<ExternalSubmissionQuizConnectionWhere>;
};

export type ExternalSubmissionQuizDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalQuizDisconnectInput>;
  where?: InputMaybe<ExternalSubmissionQuizConnectionWhere>;
};

export type ExternalSubmissionQuizFieldInput = {
  connect?: InputMaybe<ExternalSubmissionQuizConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalSubmissionQuizConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalSubmissionQuizCreateFieldInput>;
};

export type ExternalSubmissionQuizNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalSubmissionQuizNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalSubmissionQuizNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalSubmissionQuizNodeAggregationWhereInput>>;
  attemptsAllowed_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  attemptsAllowed_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  attemptsAllowed_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  attemptsAllowed_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  attemptsAllowed_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  attemptsAllowed_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  availableFrom_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  descriptionHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pointsPossible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerQuizId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerQuizId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerQuizId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerQuizId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerQuizId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  timeLimitMinutes_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeLimitMinutes_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeLimitMinutes_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimitMinutes_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeLimitMinutes_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimitMinutes_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalSubmissionQuizRelationship = {
  __typename?: 'ExternalSubmissionQuizRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalQuiz;
};

export type ExternalSubmissionQuizUpdateConnectionInput = {
  node?: InputMaybe<ExternalQuizUpdateInput>;
};

export type ExternalSubmissionQuizUpdateFieldInput = {
  connect?: InputMaybe<ExternalSubmissionQuizConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalSubmissionQuizConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalSubmissionQuizCreateFieldInput>;
  delete?: InputMaybe<ExternalSubmissionQuizDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalSubmissionQuizDisconnectFieldInput>;
  update?: InputMaybe<ExternalSubmissionQuizUpdateConnectionInput>;
  where?: InputMaybe<ExternalSubmissionQuizConnectionWhere>;
};

/** Fields to sort ExternalSubmissions by. The order in which sorts are applied is not guaranteed when specifying many fields in one ExternalSubmissionSort object. */
export type ExternalSubmissionSort = {
  gradeText?: InputMaybe<SortDirection>;
  gradedAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lmsSource?: InputMaybe<SortDirection>;
  pointsPossible?: InputMaybe<SortDirection>;
  providerContentId?: InputMaybe<SortDirection>;
  providerContentType?: InputMaybe<SortDirection>;
  providerCourseId?: InputMaybe<SortDirection>;
  providerKey?: InputMaybe<SortDirection>;
  providerUserId?: InputMaybe<SortDirection>;
  score?: InputMaybe<SortDirection>;
  sourceMeta?: InputMaybe<SortDirection>;
  sourcePayload?: InputMaybe<SortDirection>;
  sourceUpdatedAt?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  submittedAt?: InputMaybe<SortDirection>;
  syncedAt?: InputMaybe<SortDirection>;
};

export enum ExternalSubmissionStatus {
  Excused = 'EXCUSED',
  Graded = 'GRADED',
  Late = 'LATE',
  Missing = 'MISSING',
  NotSubmitted = 'NOT_SUBMITTED',
  Returned = 'RETURNED',
  Submitted = 'SUBMITTED',
  Unknown = 'UNKNOWN'
}

export type ExternalSubmissionUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalSubmissionUpdateInput = {
  assignment?: InputMaybe<ExternalSubmissionAssignmentUpdateFieldInput>;
  discussion?: InputMaybe<ExternalSubmissionDiscussionUpdateFieldInput>;
  files?: InputMaybe<Array<ExternalSubmissionFilesUpdateFieldInput>>;
  gradeText?: InputMaybe<Scalars['String']['input']>;
  gradedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lmsSource?: InputMaybe<LmsSource>;
  pointsPossible?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_ADD?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  providerContentId?: InputMaybe<Scalars['String']['input']>;
  providerContentType?: InputMaybe<ExternalSubmissionContentType>;
  providerCourseId?: InputMaybe<Scalars['String']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
  providerUserId?: InputMaybe<Scalars['String']['input']>;
  quiz?: InputMaybe<ExternalSubmissionQuizUpdateFieldInput>;
  score?: InputMaybe<Scalars['Float']['input']>;
  score_ADD?: InputMaybe<Scalars['Float']['input']>;
  score_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  score_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  score_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ExternalSubmissionStatus>;
  submittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<ExternalSubmissionUserUpdateFieldInput>;
};

export type ExternalSubmissionUserAggregateInput = {
  AND?: InputMaybe<Array<ExternalSubmissionUserAggregateInput>>;
  NOT?: InputMaybe<ExternalSubmissionUserAggregateInput>;
  OR?: InputMaybe<Array<ExternalSubmissionUserAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ExternalSubmissionUserNodeAggregationWhereInput>;
};

export type ExternalSubmissionUserConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type ExternalSubmissionUserConnectOrCreateFieldInput = {
  onCreate: ExternalSubmissionUserConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type ExternalSubmissionUserConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type ExternalSubmissionUserConnection = {
  __typename?: 'ExternalSubmissionUserConnection';
  edges: Array<ExternalSubmissionUserRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalSubmissionUserConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type ExternalSubmissionUserConnectionWhere = {
  AND?: InputMaybe<Array<ExternalSubmissionUserConnectionWhere>>;
  NOT?: InputMaybe<ExternalSubmissionUserConnectionWhere>;
  OR?: InputMaybe<Array<ExternalSubmissionUserConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type ExternalSubmissionUserCreateFieldInput = {
  node: UserCreateInput;
};

export type ExternalSubmissionUserDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<ExternalSubmissionUserConnectionWhere>;
};

export type ExternalSubmissionUserDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<ExternalSubmissionUserConnectionWhere>;
};

export type ExternalSubmissionUserFieldInput = {
  connect?: InputMaybe<ExternalSubmissionUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalSubmissionUserConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalSubmissionUserCreateFieldInput>;
};

export type ExternalSubmissionUserNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ExternalSubmissionUserNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ExternalSubmissionUserNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ExternalSubmissionUserNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ExternalSubmissionUserRelationship = {
  __typename?: 'ExternalSubmissionUserRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type ExternalSubmissionUserUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type ExternalSubmissionUserUpdateFieldInput = {
  connect?: InputMaybe<ExternalSubmissionUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<ExternalSubmissionUserConnectOrCreateFieldInput>;
  create?: InputMaybe<ExternalSubmissionUserCreateFieldInput>;
  delete?: InputMaybe<ExternalSubmissionUserDeleteFieldInput>;
  disconnect?: InputMaybe<ExternalSubmissionUserDisconnectFieldInput>;
  update?: InputMaybe<ExternalSubmissionUserUpdateConnectionInput>;
  where?: InputMaybe<ExternalSubmissionUserConnectionWhere>;
};

export type ExternalSubmissionUserUserAggregationSelection = {
  __typename?: 'ExternalSubmissionUserUserAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ExternalSubmissionUserUserNodeAggregateSelection>;
};

export type ExternalSubmissionUserUserNodeAggregateSelection = {
  __typename?: 'ExternalSubmissionUserUserNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type ExternalSubmissionWhere = {
  AND?: InputMaybe<Array<ExternalSubmissionWhere>>;
  NOT?: InputMaybe<ExternalSubmissionWhere>;
  OR?: InputMaybe<Array<ExternalSubmissionWhere>>;
  assignment?: InputMaybe<ExternalAssignmentWhere>;
  assignmentAggregate?: InputMaybe<ExternalSubmissionAssignmentAggregateInput>;
  assignmentConnection?: InputMaybe<ExternalSubmissionAssignmentConnectionWhere>;
  assignmentConnection_NOT?: InputMaybe<ExternalSubmissionAssignmentConnectionWhere>;
  assignment_NOT?: InputMaybe<ExternalAssignmentWhere>;
  discussion?: InputMaybe<ExternalDiscussionBoardWhere>;
  discussionAggregate?: InputMaybe<ExternalSubmissionDiscussionAggregateInput>;
  discussionConnection?: InputMaybe<ExternalSubmissionDiscussionConnectionWhere>;
  discussionConnection_NOT?: InputMaybe<ExternalSubmissionDiscussionConnectionWhere>;
  discussion_NOT?: InputMaybe<ExternalDiscussionBoardWhere>;
  filesAggregate?: InputMaybe<ExternalSubmissionFilesAggregateInput>;
  /** Return ExternalSubmissions where all of the related ExternalSubmissionFilesConnections match this filter */
  filesConnection_ALL?: InputMaybe<ExternalSubmissionFilesConnectionWhere>;
  /** Return ExternalSubmissions where none of the related ExternalSubmissionFilesConnections match this filter */
  filesConnection_NONE?: InputMaybe<ExternalSubmissionFilesConnectionWhere>;
  /** Return ExternalSubmissions where one of the related ExternalSubmissionFilesConnections match this filter */
  filesConnection_SINGLE?: InputMaybe<ExternalSubmissionFilesConnectionWhere>;
  /** Return ExternalSubmissions where some of the related ExternalSubmissionFilesConnections match this filter */
  filesConnection_SOME?: InputMaybe<ExternalSubmissionFilesConnectionWhere>;
  /** Return ExternalSubmissions where all of the related ExternalFiles match this filter */
  files_ALL?: InputMaybe<ExternalFileWhere>;
  /** Return ExternalSubmissions where none of the related ExternalFiles match this filter */
  files_NONE?: InputMaybe<ExternalFileWhere>;
  /** Return ExternalSubmissions where one of the related ExternalFiles match this filter */
  files_SINGLE?: InputMaybe<ExternalFileWhere>;
  /** Return ExternalSubmissions where some of the related ExternalFiles match this filter */
  files_SOME?: InputMaybe<ExternalFileWhere>;
  gradeText?: InputMaybe<Scalars['String']['input']>;
  gradeText_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  gradeText_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  gradeText_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  gradeText_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  gradedAt?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  gradedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lmsSource?: InputMaybe<LmsSource>;
  lmsSource_IN?: InputMaybe<Array<LmsSource>>;
  pointsPossible?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  pointsPossible_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerContentId?: InputMaybe<Scalars['String']['input']>;
  providerContentId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerContentId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerContentId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerContentId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerContentType?: InputMaybe<ExternalSubmissionContentType>;
  providerContentType_IN?: InputMaybe<Array<ExternalSubmissionContentType>>;
  providerCourseId?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerCourseId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerCourseId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerKey?: InputMaybe<Scalars['String']['input']>;
  providerKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerKey_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerUserId?: InputMaybe<Scalars['String']['input']>;
  providerUserId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  providerUserId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  providerUserId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  providerUserId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  quiz?: InputMaybe<ExternalQuizWhere>;
  quizAggregate?: InputMaybe<ExternalSubmissionQuizAggregateInput>;
  quizConnection?: InputMaybe<ExternalSubmissionQuizConnectionWhere>;
  quizConnection_NOT?: InputMaybe<ExternalSubmissionQuizConnectionWhere>;
  quiz_NOT?: InputMaybe<ExternalQuizWhere>;
  score?: InputMaybe<Scalars['Float']['input']>;
  score_GT?: InputMaybe<Scalars['Float']['input']>;
  score_GTE?: InputMaybe<Scalars['Float']['input']>;
  score_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  score_LT?: InputMaybe<Scalars['Float']['input']>;
  score_LTE?: InputMaybe<Scalars['Float']['input']>;
  sourceMeta?: InputMaybe<Scalars['JSON']['input']>;
  sourceMeta_IN?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  sourcePayload?: InputMaybe<Scalars['JSON']['input']>;
  sourcePayload_IN?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  sourceUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  sourceUpdatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ExternalSubmissionStatus>;
  status_IN?: InputMaybe<Array<ExternalSubmissionStatus>>;
  submittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  submittedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submittedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  syncedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserWhere>;
  userAggregate?: InputMaybe<ExternalSubmissionUserAggregateInput>;
  userConnection?: InputMaybe<ExternalSubmissionUserConnectionWhere>;
  userConnection_NOT?: InputMaybe<ExternalSubmissionUserConnectionWhere>;
  user_NOT?: InputMaybe<UserWhere>;
};

export type FacultyDataCourse = {
  __typename?: 'FacultyDataCourse';
  course_code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type FacultyDataRole = {
  __typename?: 'FacultyDataRole';
  name?: Maybe<Scalars['String']['output']>;
};

export type FacultyDataSessionDeviceSession = {
  __typename?: 'FacultyDataSessionDeviceSession';
  id?: Maybe<Scalars['String']['output']>;
};

export type FacultyQueryResponse = {
  __typename?: 'FacultyQueryResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<FacultyQueryResponseWithCountData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type FacultyQueryResponseData = {
  __typename?: 'FacultyQueryResponseData';
  biography?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expiredInvitation?: Maybe<Scalars['Boolean']['output']>;
  hasRoleRoles: Array<FacultyDataRole>;
  hasSessionDeviceSessions: Array<FacultyDataSessionDeviceSession>;
  id?: Maybe<Scalars['String']['output']>;
  meetingLink?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pendingCourseEnrollmentInvite?: Maybe<Scalars['Boolean']['output']>;
  pendingFacultyInvite?: Maybe<Scalars['Boolean']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  teachingCourses: Array<FacultyDataCourse>;
  username?: Maybe<Scalars['String']['output']>;
};

export type FacultyQueryResponseWithCountData = {
  __typename?: 'FacultyQueryResponseWithCountData';
  faculties: Array<FacultyQueryResponseData>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Feedback = {
  __typename?: 'Feedback';
  context?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  sentiment?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type Field = {
  __typename?: 'Field';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isRelevant?: Maybe<Scalars['Boolean']['output']>;
  mastery?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
};

export type File = {
  __typename?: 'File';
  aiTutorActivity?: Maybe<AiTutor>;
  aiTutorActivityAggregate?: Maybe<FileAiTutorAiTutorActivityAggregationSelection>;
  aiTutorActivityConnection: FileAiTutorActivityConnection;
  assignmentActivity?: Maybe<Assignment>;
  assignmentActivityAggregate?: Maybe<FileAssignmentAssignmentActivityAggregationSelection>;
  assignmentActivityConnection: FileAssignmentActivityConnection;
  bucketName: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  documents: Array<Document>;
  documentsAggregate?: Maybe<FileDocumentDocumentsAggregationSelection>;
  documentsConnection: FileDocumentsConnection;
  fileBlock?: Maybe<FileBlock>;
  fileBlockAggregate?: Maybe<FileFileBlockFileBlockAggregationSelection>;
  fileBlockConnection: FileFileBlockConnection;
  fileName: Scalars['String']['output'];
  filePath: Scalars['String']['output'];
  fileURL: Scalars['String']['output'];
  hasRosterExport?: Maybe<User>;
  hasRosterExportAggregate?: Maybe<FileUserHasRosterExportAggregationSelection>;
  hasRosterExportConnection: FileHasRosterExportConnection;
  hasSubmissionExportUser?: Maybe<User>;
  hasSubmissionExportUserAggregate?: Maybe<FileUserHasSubmissionExportUserAggregationSelection>;
  hasSubmissionExportUserConnection: FileHasSubmissionExportUserConnection;
  id: Scalars['ID']['output'];
  message?: Maybe<Message>;
  messageAggregate?: Maybe<FileMessageMessageAggregationSelection>;
  messageConnection: FileMessageConnection;
  post?: Maybe<Post>;
  postAggregate?: Maybe<FilePostPostAggregationSelection>;
  postConnection: FilePostConnection;
  projectSubmission?: Maybe<ProjectSubmission>;
  projectSubmissionAggregate?: Maybe<FileProjectSubmissionProjectSubmissionAggregationSelection>;
  projectSubmissionConnection: FileProjectSubmissionConnection;
  resourceActivity?: Maybe<AxioResource>;
  resourceActivityAggregate?: Maybe<FileAxioResourceResourceActivityAggregationSelection>;
  resourceActivityConnection: FileResourceActivityConnection;
  status: FileStatus;
  submission?: Maybe<Submission>;
  submissionAggregate?: Maybe<FileSubmissionSubmissionAggregationSelection>;
  submissionConnection: FileSubmissionConnection;
  user?: Maybe<User>;
  userAggregate?: Maybe<FileUserUserAggregationSelection>;
  userConnection: FileUserConnection;
};


export type FileAiTutorActivityArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AiTutorOptions>;
  where?: InputMaybe<AiTutorWhere>;
};


export type FileAiTutorActivityAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AiTutorWhere>;
};


export type FileAiTutorActivityConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FileAiTutorActivityConnectionSort>>;
  where?: InputMaybe<FileAiTutorActivityConnectionWhere>;
};


export type FileAssignmentActivityArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AssignmentOptions>;
  where?: InputMaybe<AssignmentWhere>;
};


export type FileAssignmentActivityAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssignmentWhere>;
};


export type FileAssignmentActivityConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FileAssignmentActivityConnectionSort>>;
  where?: InputMaybe<FileAssignmentActivityConnectionWhere>;
};


export type FileDocumentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DocumentOptions>;
  where?: InputMaybe<DocumentWhere>;
};


export type FileDocumentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DocumentWhere>;
};


export type FileDocumentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FileDocumentsConnectionSort>>;
  where?: InputMaybe<FileDocumentsConnectionWhere>;
};


export type FileFileBlockArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FileBlockOptions>;
  where?: InputMaybe<FileBlockWhere>;
};


export type FileFileBlockAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FileBlockWhere>;
};


export type FileFileBlockConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FileFileBlockConnectionSort>>;
  where?: InputMaybe<FileFileBlockConnectionWhere>;
};


export type FileHasRosterExportArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type FileHasRosterExportAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type FileHasRosterExportConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FileHasRosterExportConnectionSort>>;
  where?: InputMaybe<FileHasRosterExportConnectionWhere>;
};


export type FileHasSubmissionExportUserArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type FileHasSubmissionExportUserAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type FileHasSubmissionExportUserConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FileHasSubmissionExportUserConnectionSort>>;
  where?: InputMaybe<FileHasSubmissionExportUserConnectionWhere>;
};


export type FileMessageArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<MessageOptions>;
  where?: InputMaybe<MessageWhere>;
};


export type FileMessageAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MessageWhere>;
};


export type FileMessageConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FileMessageConnectionSort>>;
  where?: InputMaybe<FileMessageConnectionWhere>;
};


export type FilePostArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PostOptions>;
  where?: InputMaybe<PostWhere>;
};


export type FilePostAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PostWhere>;
};


export type FilePostConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FilePostConnectionSort>>;
  where?: InputMaybe<FilePostConnectionWhere>;
};


export type FileProjectSubmissionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProjectSubmissionOptions>;
  where?: InputMaybe<ProjectSubmissionWhere>;
};


export type FileProjectSubmissionAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProjectSubmissionWhere>;
};


export type FileProjectSubmissionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FileProjectSubmissionConnectionSort>>;
  where?: InputMaybe<FileProjectSubmissionConnectionWhere>;
};


export type FileResourceActivityArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AxioResourceOptions>;
  where?: InputMaybe<AxioResourceWhere>;
};


export type FileResourceActivityAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AxioResourceWhere>;
};


export type FileResourceActivityConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FileResourceActivityConnectionSort>>;
  where?: InputMaybe<FileResourceActivityConnectionWhere>;
};


export type FileSubmissionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SubmissionOptions>;
  where?: InputMaybe<SubmissionWhere>;
};


export type FileSubmissionAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SubmissionWhere>;
};


export type FileSubmissionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FileSubmissionConnectionSort>>;
  where?: InputMaybe<FileSubmissionConnectionWhere>;
};


export type FileUserArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type FileUserAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type FileUserConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FileUserConnectionSort>>;
  where?: InputMaybe<FileUserConnectionWhere>;
};

export type FileAiTutorAiTutorActivityAggregationSelection = {
  __typename?: 'FileAITutorAiTutorActivityAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FileAiTutorAiTutorActivityNodeAggregateSelection>;
};

export type FileAiTutorAiTutorActivityNodeAggregateSelection = {
  __typename?: 'FileAITutorAiTutorActivityNodeAggregateSelection';
  context: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  targetAudience: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type FileAiTutorActivityAggregateInput = {
  AND?: InputMaybe<Array<FileAiTutorActivityAggregateInput>>;
  NOT?: InputMaybe<FileAiTutorActivityAggregateInput>;
  OR?: InputMaybe<Array<FileAiTutorActivityAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FileAiTutorActivityNodeAggregationWhereInput>;
};

export type FileAiTutorActivityConnectFieldInput = {
  connect?: InputMaybe<AiTutorConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AiTutorConnectWhere>;
};

export type FileAiTutorActivityConnectOrCreateFieldInput = {
  onCreate: FileAiTutorActivityConnectOrCreateFieldInputOnCreate;
  where: AiTutorConnectOrCreateWhere;
};

export type FileAiTutorActivityConnectOrCreateFieldInputOnCreate = {
  node: AiTutorOnCreateInput;
};

export type FileAiTutorActivityConnection = {
  __typename?: 'FileAiTutorActivityConnection';
  edges: Array<FileAiTutorActivityRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FileAiTutorActivityConnectionSort = {
  node?: InputMaybe<AiTutorSort>;
};

export type FileAiTutorActivityConnectionWhere = {
  AND?: InputMaybe<Array<FileAiTutorActivityConnectionWhere>>;
  NOT?: InputMaybe<FileAiTutorActivityConnectionWhere>;
  OR?: InputMaybe<Array<FileAiTutorActivityConnectionWhere>>;
  node?: InputMaybe<AiTutorWhere>;
};

export type FileAiTutorActivityCreateFieldInput = {
  node: AiTutorCreateInput;
};

export type FileAiTutorActivityDeleteFieldInput = {
  delete?: InputMaybe<AiTutorDeleteInput>;
  where?: InputMaybe<FileAiTutorActivityConnectionWhere>;
};

export type FileAiTutorActivityDisconnectFieldInput = {
  disconnect?: InputMaybe<AiTutorDisconnectInput>;
  where?: InputMaybe<FileAiTutorActivityConnectionWhere>;
};

export type FileAiTutorActivityFieldInput = {
  connect?: InputMaybe<FileAiTutorActivityConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileAiTutorActivityConnectOrCreateFieldInput>;
  create?: InputMaybe<FileAiTutorActivityCreateFieldInput>;
};

export type FileAiTutorActivityNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FileAiTutorActivityNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FileAiTutorActivityNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FileAiTutorActivityNodeAggregationWhereInput>>;
  context_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  context_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FileAiTutorActivityRelationship = {
  __typename?: 'FileAiTutorActivityRelationship';
  cursor: Scalars['String']['output'];
  node: AiTutor;
};

export type FileAiTutorActivityUpdateConnectionInput = {
  node?: InputMaybe<AiTutorUpdateInput>;
};

export type FileAiTutorActivityUpdateFieldInput = {
  connect?: InputMaybe<FileAiTutorActivityConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileAiTutorActivityConnectOrCreateFieldInput>;
  create?: InputMaybe<FileAiTutorActivityCreateFieldInput>;
  delete?: InputMaybe<FileAiTutorActivityDeleteFieldInput>;
  disconnect?: InputMaybe<FileAiTutorActivityDisconnectFieldInput>;
  update?: InputMaybe<FileAiTutorActivityUpdateConnectionInput>;
  where?: InputMaybe<FileAiTutorActivityConnectionWhere>;
};

export type FileAssignmentActivityAggregateInput = {
  AND?: InputMaybe<Array<FileAssignmentActivityAggregateInput>>;
  NOT?: InputMaybe<FileAssignmentActivityAggregateInput>;
  OR?: InputMaybe<Array<FileAssignmentActivityAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FileAssignmentActivityNodeAggregationWhereInput>;
};

export type FileAssignmentActivityConnectFieldInput = {
  connect?: InputMaybe<AssignmentConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AssignmentConnectWhere>;
};

export type FileAssignmentActivityConnectOrCreateFieldInput = {
  onCreate: FileAssignmentActivityConnectOrCreateFieldInputOnCreate;
  where: AssignmentConnectOrCreateWhere;
};

export type FileAssignmentActivityConnectOrCreateFieldInputOnCreate = {
  node: AssignmentOnCreateInput;
};

export type FileAssignmentActivityConnection = {
  __typename?: 'FileAssignmentActivityConnection';
  edges: Array<FileAssignmentActivityRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FileAssignmentActivityConnectionSort = {
  node?: InputMaybe<AssignmentSort>;
};

export type FileAssignmentActivityConnectionWhere = {
  AND?: InputMaybe<Array<FileAssignmentActivityConnectionWhere>>;
  NOT?: InputMaybe<FileAssignmentActivityConnectionWhere>;
  OR?: InputMaybe<Array<FileAssignmentActivityConnectionWhere>>;
  node?: InputMaybe<AssignmentWhere>;
};

export type FileAssignmentActivityCreateFieldInput = {
  node: AssignmentCreateInput;
};

export type FileAssignmentActivityDeleteFieldInput = {
  delete?: InputMaybe<AssignmentDeleteInput>;
  where?: InputMaybe<FileAssignmentActivityConnectionWhere>;
};

export type FileAssignmentActivityDisconnectFieldInput = {
  disconnect?: InputMaybe<AssignmentDisconnectInput>;
  where?: InputMaybe<FileAssignmentActivityConnectionWhere>;
};

export type FileAssignmentActivityFieldInput = {
  connect?: InputMaybe<FileAssignmentActivityConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileAssignmentActivityConnectOrCreateFieldInput>;
  create?: InputMaybe<FileAssignmentActivityCreateFieldInput>;
};

export type FileAssignmentActivityNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FileAssignmentActivityNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FileAssignmentActivityNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FileAssignmentActivityNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  allowed_attempts_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_group_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  body_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  category_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_assignment_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_unread_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  display_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  due_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_date_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_points_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  html_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lti_context_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  max_attempts_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  needs_grading_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  points_possible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  secure_params_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  secure_params_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  session_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FileAssignmentActivityRelationship = {
  __typename?: 'FileAssignmentActivityRelationship';
  cursor: Scalars['String']['output'];
  node: Assignment;
};

export type FileAssignmentActivityUpdateConnectionInput = {
  node?: InputMaybe<AssignmentUpdateInput>;
};

export type FileAssignmentActivityUpdateFieldInput = {
  connect?: InputMaybe<FileAssignmentActivityConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileAssignmentActivityConnectOrCreateFieldInput>;
  create?: InputMaybe<FileAssignmentActivityCreateFieldInput>;
  delete?: InputMaybe<FileAssignmentActivityDeleteFieldInput>;
  disconnect?: InputMaybe<FileAssignmentActivityDisconnectFieldInput>;
  update?: InputMaybe<FileAssignmentActivityUpdateConnectionInput>;
  where?: InputMaybe<FileAssignmentActivityConnectionWhere>;
};

export type FileAssignmentAssignmentActivityAggregationSelection = {
  __typename?: 'FileAssignmentAssignmentActivityAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FileAssignmentAssignmentActivityNodeAggregateSelection>;
};

export type FileAssignmentAssignmentActivityNodeAggregateSelection = {
  __typename?: 'FileAssignmentAssignmentActivityNodeAggregateSelection';
  _empty: StringAggregateSelection;
  allowed_attempts: FloatAggregateSelection;
  assignee_mode: StringAggregateSelection;
  assignment_group_id: FloatAggregateSelection;
  assignment_name: StringAggregateSelection;
  body: StringAggregateSelection;
  category_id: StringAggregateSelection;
  course_id: FloatAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  description: StringAggregateSelection;
  description_plaintext: StringAggregateSelection;
  discussion_topic_assignment_id: FloatAggregateSelection;
  discussion_topic_author_anonymous_id: StringAggregateSelection;
  discussion_topic_author_avatar_image_url: StringAggregateSelection;
  discussion_topic_author_display_name: StringAggregateSelection;
  discussion_topic_author_html_url: StringAggregateSelection;
  discussion_topic_author_id: FloatAggregateSelection;
  discussion_topic_created_at: StringAggregateSelection;
  discussion_topic_discussion_subentry_count: FloatAggregateSelection;
  discussion_topic_discussion_type: StringAggregateSelection;
  discussion_topic_html_url: StringAggregateSelection;
  discussion_topic_id: FloatAggregateSelection;
  discussion_topic_last_reply_at: StringAggregateSelection;
  discussion_topic_message: StringAggregateSelection;
  discussion_topic_posted_at: StringAggregateSelection;
  discussion_topic_read_state: StringAggregateSelection;
  discussion_topic_title: StringAggregateSelection;
  discussion_topic_unread_count: FloatAggregateSelection;
  discussion_topic_url: StringAggregateSelection;
  discussion_topic_user_name: StringAggregateSelection;
  display_date: StringAggregateSelection;
  due_at: StringAggregateSelection;
  due_date: DateTimeAggregateSelection;
  end_date: StringAggregateSelection;
  external_tool_tag_attributes_content_id: FloatAggregateSelection;
  external_tool_tag_attributes_content_type: StringAggregateSelection;
  external_tool_tag_attributes_external_data: StringAggregateSelection;
  external_tool_tag_attributes_resource_link_id: StringAggregateSelection;
  external_tool_tag_attributes_url: StringAggregateSelection;
  grade_points: FloatAggregateSelection;
  grader_count: FloatAggregateSelection;
  grading_type: StringAggregateSelection;
  html: StringAggregateSelection;
  html_url: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  lti_context_id: StringAggregateSelection;
  max_attempts: FloatAggregateSelection;
  max_name_length: FloatAggregateSelection;
  name: StringAggregateSelection;
  needs_grading_count: FloatAggregateSelection;
  objectives: StringAggregateSelection;
  points_possible: FloatAggregateSelection;
  position: FloatAggregateSelection;
  resource_metadata: StringAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  secure_params: StringAggregateSelection;
  session_id: StringAggregateSelection;
  start_date: StringAggregateSelection;
  state: StringAggregateSelection;
  submissions_download_url: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_at: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  url: StringAggregateSelection;
  videoUrl: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export type FileAxioResourceResourceActivityAggregationSelection = {
  __typename?: 'FileAxioResourceResourceActivityAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FileAxioResourceResourceActivityNodeAggregateSelection>;
};

export type FileAxioResourceResourceActivityNodeAggregateSelection = {
  __typename?: 'FileAxioResourceResourceActivityNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  moduleId: IdAggregateSelection;
  name: StringAggregateSelection;
  order: IntAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  videoUrl: StringAggregateSelection;
};

export type FileBlock = {
  __typename?: 'FileBlock';
  created: Scalars['DateTime']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  file?: Maybe<File>;
  fileAggregate?: Maybe<FileBlockFileFileAggregationSelection>;
  fileConnection: FileBlockFileConnection;
  id: Scalars['ID']['output'];
  message: Message;
  messageAggregate?: Maybe<FileBlockMessageMessageAggregationSelection>;
  messageConnection: FileBlockMessageConnection;
  purpose: FileBlockPurpose;
  type: BlockType;
};


export type FileBlockFileArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FileOptions>;
  where?: InputMaybe<FileWhere>;
};


export type FileBlockFileAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FileWhere>;
};


export type FileBlockFileConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FileBlockFileConnectionSort>>;
  where?: InputMaybe<FileBlockFileConnectionWhere>;
};


export type FileBlockMessageArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<MessageOptions>;
  where?: InputMaybe<MessageWhere>;
};


export type FileBlockMessageAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MessageWhere>;
};


export type FileBlockMessageConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FileBlockMessageConnectionSort>>;
  where?: InputMaybe<FileBlockMessageConnectionWhere>;
};

export type FileBlockConnectInput = {
  file?: InputMaybe<FileBlockFileConnectFieldInput>;
  message?: InputMaybe<FileBlockMessageConnectFieldInput>;
};

export type FileBlockConnectOrCreateWhere = {
  node: FileBlockUniqueWhere;
};

export type FileBlockConnectWhere = {
  node: FileBlockWhere;
};

export type FileBlockCreateInput = {
  created: Scalars['DateTime']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<FileBlockFileFieldInput>;
  message?: InputMaybe<FileBlockMessageFieldInput>;
  purpose: FileBlockPurpose;
  type: BlockType;
};

export type FileBlockDeleteInput = {
  file?: InputMaybe<FileBlockFileDeleteFieldInput>;
  message?: InputMaybe<FileBlockMessageDeleteFieldInput>;
};

export type FileBlockDisconnectInput = {
  file?: InputMaybe<FileBlockFileDisconnectFieldInput>;
  message?: InputMaybe<FileBlockMessageDisconnectFieldInput>;
};

export type FileBlockFileAggregateInput = {
  AND?: InputMaybe<Array<FileBlockFileAggregateInput>>;
  NOT?: InputMaybe<FileBlockFileAggregateInput>;
  OR?: InputMaybe<Array<FileBlockFileAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FileBlockFileNodeAggregationWhereInput>;
};

export type FileBlockFileConnectFieldInput = {
  connect?: InputMaybe<FileConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FileConnectWhere>;
};

export type FileBlockFileConnectOrCreateFieldInput = {
  onCreate: FileBlockFileConnectOrCreateFieldInputOnCreate;
  where: FileConnectOrCreateWhere;
};

export type FileBlockFileConnectOrCreateFieldInputOnCreate = {
  node: FileOnCreateInput;
};

export type FileBlockFileConnection = {
  __typename?: 'FileBlockFileConnection';
  edges: Array<FileBlockFileRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FileBlockFileConnectionSort = {
  node?: InputMaybe<FileSort>;
};

export type FileBlockFileConnectionWhere = {
  AND?: InputMaybe<Array<FileBlockFileConnectionWhere>>;
  NOT?: InputMaybe<FileBlockFileConnectionWhere>;
  OR?: InputMaybe<Array<FileBlockFileConnectionWhere>>;
  node?: InputMaybe<FileWhere>;
};

export type FileBlockFileCreateFieldInput = {
  node: FileCreateInput;
};

export type FileBlockFileDeleteFieldInput = {
  delete?: InputMaybe<FileDeleteInput>;
  where?: InputMaybe<FileBlockFileConnectionWhere>;
};

export type FileBlockFileDisconnectFieldInput = {
  disconnect?: InputMaybe<FileDisconnectInput>;
  where?: InputMaybe<FileBlockFileConnectionWhere>;
};

export type FileBlockFileFieldInput = {
  connect?: InputMaybe<FileBlockFileConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileBlockFileConnectOrCreateFieldInput>;
  create?: InputMaybe<FileBlockFileCreateFieldInput>;
};

export type FileBlockFileFileAggregationSelection = {
  __typename?: 'FileBlockFileFileAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FileBlockFileFileNodeAggregateSelection>;
};

export type FileBlockFileFileNodeAggregateSelection = {
  __typename?: 'FileBlockFileFileNodeAggregateSelection';
  bucketName: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  fileName: StringAggregateSelection;
  filePath: StringAggregateSelection;
  fileURL: StringAggregateSelection;
  id: IdAggregateSelection;
};

export type FileBlockFileNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FileBlockFileNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FileBlockFileNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FileBlockFileNodeAggregationWhereInput>>;
  bucketName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  bucketName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  fileName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileURL_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FileBlockFileRelationship = {
  __typename?: 'FileBlockFileRelationship';
  cursor: Scalars['String']['output'];
  node: File;
};

export type FileBlockFileUpdateConnectionInput = {
  node?: InputMaybe<FileUpdateInput>;
};

export type FileBlockFileUpdateFieldInput = {
  connect?: InputMaybe<FileBlockFileConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileBlockFileConnectOrCreateFieldInput>;
  create?: InputMaybe<FileBlockFileCreateFieldInput>;
  delete?: InputMaybe<FileBlockFileDeleteFieldInput>;
  disconnect?: InputMaybe<FileBlockFileDisconnectFieldInput>;
  update?: InputMaybe<FileBlockFileUpdateConnectionInput>;
  where?: InputMaybe<FileBlockFileConnectionWhere>;
};

export type FileBlockMessageAggregateInput = {
  AND?: InputMaybe<Array<FileBlockMessageAggregateInput>>;
  NOT?: InputMaybe<FileBlockMessageAggregateInput>;
  OR?: InputMaybe<Array<FileBlockMessageAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasBlockPropertiesAggregationWhereInput>;
  node?: InputMaybe<FileBlockMessageNodeAggregationWhereInput>;
};

export type FileBlockMessageConnectFieldInput = {
  connect?: InputMaybe<MessageConnectInput>;
  edge: HasBlockPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<MessageConnectWhere>;
};

export type FileBlockMessageConnectOrCreateFieldInput = {
  onCreate: FileBlockMessageConnectOrCreateFieldInputOnCreate;
  where: MessageConnectOrCreateWhere;
};

export type FileBlockMessageConnectOrCreateFieldInputOnCreate = {
  edge: HasBlockPropertiesCreateInput;
  node: MessageOnCreateInput;
};

export type FileBlockMessageConnection = {
  __typename?: 'FileBlockMessageConnection';
  edges: Array<FileBlockMessageRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FileBlockMessageConnectionSort = {
  edge?: InputMaybe<HasBlockPropertiesSort>;
  node?: InputMaybe<MessageSort>;
};

export type FileBlockMessageConnectionWhere = {
  AND?: InputMaybe<Array<FileBlockMessageConnectionWhere>>;
  NOT?: InputMaybe<FileBlockMessageConnectionWhere>;
  OR?: InputMaybe<Array<FileBlockMessageConnectionWhere>>;
  edge?: InputMaybe<HasBlockPropertiesWhere>;
  node?: InputMaybe<MessageWhere>;
};

export type FileBlockMessageCreateFieldInput = {
  edge: HasBlockPropertiesCreateInput;
  node: MessageCreateInput;
};

export type FileBlockMessageDeleteFieldInput = {
  delete?: InputMaybe<MessageDeleteInput>;
  where?: InputMaybe<FileBlockMessageConnectionWhere>;
};

export type FileBlockMessageDisconnectFieldInput = {
  disconnect?: InputMaybe<MessageDisconnectInput>;
  where?: InputMaybe<FileBlockMessageConnectionWhere>;
};

export type FileBlockMessageFieldInput = {
  connect?: InputMaybe<FileBlockMessageConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileBlockMessageConnectOrCreateFieldInput>;
  create?: InputMaybe<FileBlockMessageCreateFieldInput>;
};

export type FileBlockMessageMessageAggregationSelection = {
  __typename?: 'FileBlockMessageMessageAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<FileBlockMessageMessageEdgeAggregateSelection>;
  node?: Maybe<FileBlockMessageMessageNodeAggregateSelection>;
};

export type FileBlockMessageMessageEdgeAggregateSelection = {
  __typename?: 'FileBlockMessageMessageEdgeAggregateSelection';
  created: DateTimeAggregateSelection;
  index: IntAggregateSelection;
};

export type FileBlockMessageMessageNodeAggregateSelection = {
  __typename?: 'FileBlockMessageMessageNodeAggregateSelection';
  aspectDetails: StringAggregateSelection;
  content: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  emotion: StringAggregateSelection;
  id: IdAggregateSelection;
  index: IntAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  nodeId: StringAggregateSelection;
  parameters: StringAggregateSelection;
  sender: StringAggregateSelection;
  snackType: StringAggregateSelection;
  type: StringAggregateSelection;
};

export type FileBlockMessageNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FileBlockMessageNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FileBlockMessageNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FileBlockMessageNodeAggregationWhereInput>>;
  aspectDetails_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  content_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  content_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  emotion_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emotion_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emotion_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emotion_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emotion_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emotion_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emotion_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emotion_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emotion_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emotion_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  index_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  index_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  nodeId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nodeId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  nodeId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  nodeId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  nodeId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  nodeId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nodeId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nodeId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nodeId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nodeId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  parameters_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  parameters_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  parameters_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  parameters_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  parameters_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  parameters_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  parameters_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  parameters_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  parameters_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  parameters_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  snackType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  snackType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  snackType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  snackType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  snackType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  snackType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  snackType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  snackType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  snackType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  snackType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FileBlockMessageRelationship = {
  __typename?: 'FileBlockMessageRelationship';
  cursor: Scalars['String']['output'];
  node: Message;
  properties: HasBlockProperties;
};

export type FileBlockMessageUpdateConnectionInput = {
  edge?: InputMaybe<HasBlockPropertiesUpdateInput>;
  node?: InputMaybe<MessageUpdateInput>;
};

export type FileBlockMessageUpdateFieldInput = {
  connect?: InputMaybe<FileBlockMessageConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileBlockMessageConnectOrCreateFieldInput>;
  create?: InputMaybe<FileBlockMessageCreateFieldInput>;
  delete?: InputMaybe<FileBlockMessageDeleteFieldInput>;
  disconnect?: InputMaybe<FileBlockMessageDisconnectFieldInput>;
  update?: InputMaybe<FileBlockMessageUpdateConnectionInput>;
  where?: InputMaybe<FileBlockMessageConnectionWhere>;
};

export type FileBlockOnCreateInput = {
  created: Scalars['DateTime']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  purpose: FileBlockPurpose;
  type: BlockType;
};

export type FileBlockOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more FileBlockSort objects to sort FileBlocks by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FileBlockSort>>;
};

export enum FileBlockPurpose {
  Attachment = 'attachment',
  Input = 'input',
  Output = 'output'
}

/** Fields to sort FileBlocks by. The order in which sorts are applied is not guaranteed when specifying many fields in one FileBlockSort object. */
export type FileBlockSort = {
  created?: InputMaybe<SortDirection>;
  displayName?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  purpose?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export type FileBlockUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FileBlockUpdateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<FileBlockFileUpdateFieldInput>;
  message?: InputMaybe<FileBlockMessageUpdateFieldInput>;
  purpose?: InputMaybe<FileBlockPurpose>;
  type?: InputMaybe<BlockType>;
};

export type FileBlockWhere = {
  AND?: InputMaybe<Array<FileBlockWhere>>;
  NOT?: InputMaybe<FileBlockWhere>;
  OR?: InputMaybe<Array<FileBlockWhere>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  displayName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  displayName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<FileWhere>;
  fileAggregate?: InputMaybe<FileBlockFileAggregateInput>;
  fileConnection?: InputMaybe<FileBlockFileConnectionWhere>;
  fileConnection_NOT?: InputMaybe<FileBlockFileConnectionWhere>;
  file_NOT?: InputMaybe<FileWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  message?: InputMaybe<MessageWhere>;
  messageAggregate?: InputMaybe<FileBlockMessageAggregateInput>;
  messageConnection?: InputMaybe<FileBlockMessageConnectionWhere>;
  messageConnection_NOT?: InputMaybe<FileBlockMessageConnectionWhere>;
  message_NOT?: InputMaybe<MessageWhere>;
  purpose?: InputMaybe<FileBlockPurpose>;
  purpose_IN?: InputMaybe<Array<FileBlockPurpose>>;
  type?: InputMaybe<BlockType>;
  type_IN?: InputMaybe<Array<BlockType>>;
};

export type FileConnectInput = {
  aiTutorActivity?: InputMaybe<FileAiTutorActivityConnectFieldInput>;
  assignmentActivity?: InputMaybe<FileAssignmentActivityConnectFieldInput>;
  documents?: InputMaybe<Array<FileDocumentsConnectFieldInput>>;
  fileBlock?: InputMaybe<FileFileBlockConnectFieldInput>;
  hasRosterExport?: InputMaybe<FileHasRosterExportConnectFieldInput>;
  hasSubmissionExportUser?: InputMaybe<FileHasSubmissionExportUserConnectFieldInput>;
  message?: InputMaybe<FileMessageConnectFieldInput>;
  post?: InputMaybe<FilePostConnectFieldInput>;
  projectSubmission?: InputMaybe<FileProjectSubmissionConnectFieldInput>;
  resourceActivity?: InputMaybe<FileResourceActivityConnectFieldInput>;
  submission?: InputMaybe<FileSubmissionConnectFieldInput>;
  user?: InputMaybe<FileUserConnectFieldInput>;
};

export type FileConnectOrCreateWhere = {
  node: FileUniqueWhere;
};

export type FileConnectWhere = {
  node: FileWhere;
};

export type FileCreateInput = {
  aiTutorActivity?: InputMaybe<FileAiTutorActivityFieldInput>;
  assignmentActivity?: InputMaybe<FileAssignmentActivityFieldInput>;
  bucketName: Scalars['String']['input'];
  created: Scalars['DateTime']['input'];
  documents?: InputMaybe<FileDocumentsFieldInput>;
  fileBlock?: InputMaybe<FileFileBlockFieldInput>;
  fileName: Scalars['String']['input'];
  filePath: Scalars['String']['input'];
  fileURL: Scalars['String']['input'];
  hasRosterExport?: InputMaybe<FileHasRosterExportFieldInput>;
  hasSubmissionExportUser?: InputMaybe<FileHasSubmissionExportUserFieldInput>;
  id: Scalars['ID']['input'];
  message?: InputMaybe<FileMessageFieldInput>;
  post?: InputMaybe<FilePostFieldInput>;
  projectSubmission?: InputMaybe<FileProjectSubmissionFieldInput>;
  resourceActivity?: InputMaybe<FileResourceActivityFieldInput>;
  status: FileStatus;
  submission?: InputMaybe<FileSubmissionFieldInput>;
  user?: InputMaybe<FileUserFieldInput>;
};

export type FileDeleteInput = {
  aiTutorActivity?: InputMaybe<FileAiTutorActivityDeleteFieldInput>;
  assignmentActivity?: InputMaybe<FileAssignmentActivityDeleteFieldInput>;
  documents?: InputMaybe<Array<FileDocumentsDeleteFieldInput>>;
  fileBlock?: InputMaybe<FileFileBlockDeleteFieldInput>;
  hasRosterExport?: InputMaybe<FileHasRosterExportDeleteFieldInput>;
  hasSubmissionExportUser?: InputMaybe<FileHasSubmissionExportUserDeleteFieldInput>;
  message?: InputMaybe<FileMessageDeleteFieldInput>;
  post?: InputMaybe<FilePostDeleteFieldInput>;
  projectSubmission?: InputMaybe<FileProjectSubmissionDeleteFieldInput>;
  resourceActivity?: InputMaybe<FileResourceActivityDeleteFieldInput>;
  submission?: InputMaybe<FileSubmissionDeleteFieldInput>;
  user?: InputMaybe<FileUserDeleteFieldInput>;
};

export type FileDisconnectInput = {
  aiTutorActivity?: InputMaybe<FileAiTutorActivityDisconnectFieldInput>;
  assignmentActivity?: InputMaybe<FileAssignmentActivityDisconnectFieldInput>;
  documents?: InputMaybe<Array<FileDocumentsDisconnectFieldInput>>;
  fileBlock?: InputMaybe<FileFileBlockDisconnectFieldInput>;
  hasRosterExport?: InputMaybe<FileHasRosterExportDisconnectFieldInput>;
  hasSubmissionExportUser?: InputMaybe<FileHasSubmissionExportUserDisconnectFieldInput>;
  message?: InputMaybe<FileMessageDisconnectFieldInput>;
  post?: InputMaybe<FilePostDisconnectFieldInput>;
  projectSubmission?: InputMaybe<FileProjectSubmissionDisconnectFieldInput>;
  resourceActivity?: InputMaybe<FileResourceActivityDisconnectFieldInput>;
  submission?: InputMaybe<FileSubmissionDisconnectFieldInput>;
  user?: InputMaybe<FileUserDisconnectFieldInput>;
};

export type FileDocumentDocumentsAggregationSelection = {
  __typename?: 'FileDocumentDocumentsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FileDocumentDocumentsNodeAggregateSelection>;
};

export type FileDocumentDocumentsNodeAggregateSelection = {
  __typename?: 'FileDocumentDocumentsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  summary: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type FileDocumentsAggregateInput = {
  AND?: InputMaybe<Array<FileDocumentsAggregateInput>>;
  NOT?: InputMaybe<FileDocumentsAggregateInput>;
  OR?: InputMaybe<Array<FileDocumentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FileDocumentsNodeAggregationWhereInput>;
};

export type FileDocumentsConnectFieldInput = {
  connect?: InputMaybe<Array<DocumentConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DocumentConnectWhere>;
};

export type FileDocumentsConnection = {
  __typename?: 'FileDocumentsConnection';
  edges: Array<FileDocumentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FileDocumentsConnectionSort = {
  node?: InputMaybe<DocumentSort>;
};

export type FileDocumentsConnectionWhere = {
  AND?: InputMaybe<Array<FileDocumentsConnectionWhere>>;
  NOT?: InputMaybe<FileDocumentsConnectionWhere>;
  OR?: InputMaybe<Array<FileDocumentsConnectionWhere>>;
  node?: InputMaybe<DocumentWhere>;
};

export type FileDocumentsCreateFieldInput = {
  node: DocumentCreateInput;
};

export type FileDocumentsDeleteFieldInput = {
  delete?: InputMaybe<DocumentDeleteInput>;
  where?: InputMaybe<FileDocumentsConnectionWhere>;
};

export type FileDocumentsDisconnectFieldInput = {
  disconnect?: InputMaybe<DocumentDisconnectInput>;
  where?: InputMaybe<FileDocumentsConnectionWhere>;
};

export type FileDocumentsFieldInput = {
  connect?: InputMaybe<Array<FileDocumentsConnectFieldInput>>;
  create?: InputMaybe<Array<FileDocumentsCreateFieldInput>>;
};

export type FileDocumentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FileDocumentsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FileDocumentsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FileDocumentsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  summary_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  summary_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FileDocumentsRelationship = {
  __typename?: 'FileDocumentsRelationship';
  cursor: Scalars['String']['output'];
  node: Document;
};

export type FileDocumentsUpdateConnectionInput = {
  node?: InputMaybe<DocumentUpdateInput>;
};

export type FileDocumentsUpdateFieldInput = {
  connect?: InputMaybe<Array<FileDocumentsConnectFieldInput>>;
  create?: InputMaybe<Array<FileDocumentsCreateFieldInput>>;
  delete?: InputMaybe<Array<FileDocumentsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<FileDocumentsDisconnectFieldInput>>;
  update?: InputMaybe<FileDocumentsUpdateConnectionInput>;
  where?: InputMaybe<FileDocumentsConnectionWhere>;
};

export type FileFileBlockAggregateInput = {
  AND?: InputMaybe<Array<FileFileBlockAggregateInput>>;
  NOT?: InputMaybe<FileFileBlockAggregateInput>;
  OR?: InputMaybe<Array<FileFileBlockAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FileFileBlockNodeAggregationWhereInput>;
};

export type FileFileBlockConnectFieldInput = {
  connect?: InputMaybe<FileBlockConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FileBlockConnectWhere>;
};

export type FileFileBlockConnectOrCreateFieldInput = {
  onCreate: FileFileBlockConnectOrCreateFieldInputOnCreate;
  where: FileBlockConnectOrCreateWhere;
};

export type FileFileBlockConnectOrCreateFieldInputOnCreate = {
  node: FileBlockOnCreateInput;
};

export type FileFileBlockConnection = {
  __typename?: 'FileFileBlockConnection';
  edges: Array<FileFileBlockRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FileFileBlockConnectionSort = {
  node?: InputMaybe<FileBlockSort>;
};

export type FileFileBlockConnectionWhere = {
  AND?: InputMaybe<Array<FileFileBlockConnectionWhere>>;
  NOT?: InputMaybe<FileFileBlockConnectionWhere>;
  OR?: InputMaybe<Array<FileFileBlockConnectionWhere>>;
  node?: InputMaybe<FileBlockWhere>;
};

export type FileFileBlockCreateFieldInput = {
  node: FileBlockCreateInput;
};

export type FileFileBlockDeleteFieldInput = {
  delete?: InputMaybe<FileBlockDeleteInput>;
  where?: InputMaybe<FileFileBlockConnectionWhere>;
};

export type FileFileBlockDisconnectFieldInput = {
  disconnect?: InputMaybe<FileBlockDisconnectInput>;
  where?: InputMaybe<FileFileBlockConnectionWhere>;
};

export type FileFileBlockFieldInput = {
  connect?: InputMaybe<FileFileBlockConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileFileBlockConnectOrCreateFieldInput>;
  create?: InputMaybe<FileFileBlockCreateFieldInput>;
};

export type FileFileBlockFileBlockAggregationSelection = {
  __typename?: 'FileFileBlockFileBlockAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FileFileBlockFileBlockNodeAggregateSelection>;
};

export type FileFileBlockFileBlockNodeAggregateSelection = {
  __typename?: 'FileFileBlockFileBlockNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  displayName: StringAggregateSelection;
  id: IdAggregateSelection;
};

export type FileFileBlockNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FileFileBlockNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FileFileBlockNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FileFileBlockNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  displayName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FileFileBlockRelationship = {
  __typename?: 'FileFileBlockRelationship';
  cursor: Scalars['String']['output'];
  node: FileBlock;
};

export type FileFileBlockUpdateConnectionInput = {
  node?: InputMaybe<FileBlockUpdateInput>;
};

export type FileFileBlockUpdateFieldInput = {
  connect?: InputMaybe<FileFileBlockConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileFileBlockConnectOrCreateFieldInput>;
  create?: InputMaybe<FileFileBlockCreateFieldInput>;
  delete?: InputMaybe<FileFileBlockDeleteFieldInput>;
  disconnect?: InputMaybe<FileFileBlockDisconnectFieldInput>;
  update?: InputMaybe<FileFileBlockUpdateConnectionInput>;
  where?: InputMaybe<FileFileBlockConnectionWhere>;
};

export type FileHasRosterExportAggregateInput = {
  AND?: InputMaybe<Array<FileHasRosterExportAggregateInput>>;
  NOT?: InputMaybe<FileHasRosterExportAggregateInput>;
  OR?: InputMaybe<Array<FileHasRosterExportAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasExportPropsAggregationWhereInput>;
  node?: InputMaybe<FileHasRosterExportNodeAggregationWhereInput>;
};

export type FileHasRosterExportConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  edge?: InputMaybe<HasExportPropsCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type FileHasRosterExportConnectOrCreateFieldInput = {
  onCreate: FileHasRosterExportConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type FileHasRosterExportConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<HasExportPropsCreateInput>;
  node: UserOnCreateInput;
};

export type FileHasRosterExportConnection = {
  __typename?: 'FileHasRosterExportConnection';
  edges: Array<FileHasRosterExportRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FileHasRosterExportConnectionSort = {
  edge?: InputMaybe<HasExportPropsSort>;
  node?: InputMaybe<UserSort>;
};

export type FileHasRosterExportConnectionWhere = {
  AND?: InputMaybe<Array<FileHasRosterExportConnectionWhere>>;
  NOT?: InputMaybe<FileHasRosterExportConnectionWhere>;
  OR?: InputMaybe<Array<FileHasRosterExportConnectionWhere>>;
  edge?: InputMaybe<HasExportPropsWhere>;
  node?: InputMaybe<UserWhere>;
};

export type FileHasRosterExportCreateFieldInput = {
  edge?: InputMaybe<HasExportPropsCreateInput>;
  node: UserCreateInput;
};

export type FileHasRosterExportDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<FileHasRosterExportConnectionWhere>;
};

export type FileHasRosterExportDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<FileHasRosterExportConnectionWhere>;
};

export type FileHasRosterExportFieldInput = {
  connect?: InputMaybe<FileHasRosterExportConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileHasRosterExportConnectOrCreateFieldInput>;
  create?: InputMaybe<FileHasRosterExportCreateFieldInput>;
};

export type FileHasRosterExportNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FileHasRosterExportNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FileHasRosterExportNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FileHasRosterExportNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FileHasRosterExportRelationship = {
  __typename?: 'FileHasRosterExportRelationship';
  cursor: Scalars['String']['output'];
  node: User;
  properties: HasExportProps;
};

export type FileHasRosterExportUpdateConnectionInput = {
  edge?: InputMaybe<HasExportPropsUpdateInput>;
  node?: InputMaybe<UserUpdateInput>;
};

export type FileHasRosterExportUpdateFieldInput = {
  connect?: InputMaybe<FileHasRosterExportConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileHasRosterExportConnectOrCreateFieldInput>;
  create?: InputMaybe<FileHasRosterExportCreateFieldInput>;
  delete?: InputMaybe<FileHasRosterExportDeleteFieldInput>;
  disconnect?: InputMaybe<FileHasRosterExportDisconnectFieldInput>;
  update?: InputMaybe<FileHasRosterExportUpdateConnectionInput>;
  where?: InputMaybe<FileHasRosterExportConnectionWhere>;
};

export type FileHasSubmissionExportUserAggregateInput = {
  AND?: InputMaybe<Array<FileHasSubmissionExportUserAggregateInput>>;
  NOT?: InputMaybe<FileHasSubmissionExportUserAggregateInput>;
  OR?: InputMaybe<Array<FileHasSubmissionExportUserAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasExportPropsAggregationWhereInput>;
  node?: InputMaybe<FileHasSubmissionExportUserNodeAggregationWhereInput>;
};

export type FileHasSubmissionExportUserConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  edge?: InputMaybe<HasExportPropsCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type FileHasSubmissionExportUserConnectOrCreateFieldInput = {
  onCreate: FileHasSubmissionExportUserConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type FileHasSubmissionExportUserConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<HasExportPropsCreateInput>;
  node: UserOnCreateInput;
};

export type FileHasSubmissionExportUserConnection = {
  __typename?: 'FileHasSubmissionExportUserConnection';
  edges: Array<FileHasSubmissionExportUserRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FileHasSubmissionExportUserConnectionSort = {
  edge?: InputMaybe<HasExportPropsSort>;
  node?: InputMaybe<UserSort>;
};

export type FileHasSubmissionExportUserConnectionWhere = {
  AND?: InputMaybe<Array<FileHasSubmissionExportUserConnectionWhere>>;
  NOT?: InputMaybe<FileHasSubmissionExportUserConnectionWhere>;
  OR?: InputMaybe<Array<FileHasSubmissionExportUserConnectionWhere>>;
  edge?: InputMaybe<HasExportPropsWhere>;
  node?: InputMaybe<UserWhere>;
};

export type FileHasSubmissionExportUserCreateFieldInput = {
  edge?: InputMaybe<HasExportPropsCreateInput>;
  node: UserCreateInput;
};

export type FileHasSubmissionExportUserDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<FileHasSubmissionExportUserConnectionWhere>;
};

export type FileHasSubmissionExportUserDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<FileHasSubmissionExportUserConnectionWhere>;
};

export type FileHasSubmissionExportUserFieldInput = {
  connect?: InputMaybe<FileHasSubmissionExportUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileHasSubmissionExportUserConnectOrCreateFieldInput>;
  create?: InputMaybe<FileHasSubmissionExportUserCreateFieldInput>;
};

export type FileHasSubmissionExportUserNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FileHasSubmissionExportUserNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FileHasSubmissionExportUserNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FileHasSubmissionExportUserNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FileHasSubmissionExportUserRelationship = {
  __typename?: 'FileHasSubmissionExportUserRelationship';
  cursor: Scalars['String']['output'];
  node: User;
  properties: HasExportProps;
};

export type FileHasSubmissionExportUserUpdateConnectionInput = {
  edge?: InputMaybe<HasExportPropsUpdateInput>;
  node?: InputMaybe<UserUpdateInput>;
};

export type FileHasSubmissionExportUserUpdateFieldInput = {
  connect?: InputMaybe<FileHasSubmissionExportUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileHasSubmissionExportUserConnectOrCreateFieldInput>;
  create?: InputMaybe<FileHasSubmissionExportUserCreateFieldInput>;
  delete?: InputMaybe<FileHasSubmissionExportUserDeleteFieldInput>;
  disconnect?: InputMaybe<FileHasSubmissionExportUserDisconnectFieldInput>;
  update?: InputMaybe<FileHasSubmissionExportUserUpdateConnectionInput>;
  where?: InputMaybe<FileHasSubmissionExportUserConnectionWhere>;
};

export type FileInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  fileData?: InputMaybe<Scalars['String']['input']>;
  fileId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileURL?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type FileMessageAggregateInput = {
  AND?: InputMaybe<Array<FileMessageAggregateInput>>;
  NOT?: InputMaybe<FileMessageAggregateInput>;
  OR?: InputMaybe<Array<FileMessageAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FileMessageNodeAggregationWhereInput>;
};

export type FileMessageConnectFieldInput = {
  connect?: InputMaybe<MessageConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<MessageConnectWhere>;
};

export type FileMessageConnectOrCreateFieldInput = {
  onCreate: FileMessageConnectOrCreateFieldInputOnCreate;
  where: MessageConnectOrCreateWhere;
};

export type FileMessageConnectOrCreateFieldInputOnCreate = {
  node: MessageOnCreateInput;
};

export type FileMessageConnection = {
  __typename?: 'FileMessageConnection';
  edges: Array<FileMessageRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FileMessageConnectionSort = {
  node?: InputMaybe<MessageSort>;
};

export type FileMessageConnectionWhere = {
  AND?: InputMaybe<Array<FileMessageConnectionWhere>>;
  NOT?: InputMaybe<FileMessageConnectionWhere>;
  OR?: InputMaybe<Array<FileMessageConnectionWhere>>;
  node?: InputMaybe<MessageWhere>;
};

export type FileMessageCreateFieldInput = {
  node: MessageCreateInput;
};

export type FileMessageDeleteFieldInput = {
  delete?: InputMaybe<MessageDeleteInput>;
  where?: InputMaybe<FileMessageConnectionWhere>;
};

export type FileMessageDisconnectFieldInput = {
  disconnect?: InputMaybe<MessageDisconnectInput>;
  where?: InputMaybe<FileMessageConnectionWhere>;
};

export type FileMessageFieldInput = {
  connect?: InputMaybe<FileMessageConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileMessageConnectOrCreateFieldInput>;
  create?: InputMaybe<FileMessageCreateFieldInput>;
};

export type FileMessageMessageAggregationSelection = {
  __typename?: 'FileMessageMessageAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FileMessageMessageNodeAggregateSelection>;
};

export type FileMessageMessageNodeAggregateSelection = {
  __typename?: 'FileMessageMessageNodeAggregateSelection';
  aspectDetails: StringAggregateSelection;
  content: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  emotion: StringAggregateSelection;
  id: IdAggregateSelection;
  index: IntAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  nodeId: StringAggregateSelection;
  parameters: StringAggregateSelection;
  sender: StringAggregateSelection;
  snackType: StringAggregateSelection;
  type: StringAggregateSelection;
};

export type FileMessageNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FileMessageNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FileMessageNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FileMessageNodeAggregationWhereInput>>;
  aspectDetails_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  content_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  content_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  emotion_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emotion_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emotion_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emotion_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emotion_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emotion_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emotion_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emotion_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emotion_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emotion_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  index_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  index_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  nodeId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nodeId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  nodeId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  nodeId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  nodeId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  nodeId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nodeId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nodeId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nodeId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nodeId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  parameters_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  parameters_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  parameters_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  parameters_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  parameters_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  parameters_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  parameters_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  parameters_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  parameters_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  parameters_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  snackType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  snackType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  snackType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  snackType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  snackType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  snackType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  snackType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  snackType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  snackType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  snackType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FileMessageRelationship = {
  __typename?: 'FileMessageRelationship';
  cursor: Scalars['String']['output'];
  node: Message;
};

export type FileMessageUpdateConnectionInput = {
  node?: InputMaybe<MessageUpdateInput>;
};

export type FileMessageUpdateFieldInput = {
  connect?: InputMaybe<FileMessageConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileMessageConnectOrCreateFieldInput>;
  create?: InputMaybe<FileMessageCreateFieldInput>;
  delete?: InputMaybe<FileMessageDeleteFieldInput>;
  disconnect?: InputMaybe<FileMessageDisconnectFieldInput>;
  update?: InputMaybe<FileMessageUpdateConnectionInput>;
  where?: InputMaybe<FileMessageConnectionWhere>;
};

export type FileOnCreateInput = {
  bucketName: Scalars['String']['input'];
  created: Scalars['DateTime']['input'];
  fileName: Scalars['String']['input'];
  filePath: Scalars['String']['input'];
  fileURL: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  status: FileStatus;
};

export type FileOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more FileSort objects to sort Files by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FileSort>>;
};

export type FilePostAggregateInput = {
  AND?: InputMaybe<Array<FilePostAggregateInput>>;
  NOT?: InputMaybe<FilePostAggregateInput>;
  OR?: InputMaybe<Array<FilePostAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FilePostNodeAggregationWhereInput>;
};

export type FilePostConnectFieldInput = {
  connect?: InputMaybe<PostConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PostConnectWhere>;
};

export type FilePostConnectOrCreateFieldInput = {
  onCreate: FilePostConnectOrCreateFieldInputOnCreate;
  where: PostConnectOrCreateWhere;
};

export type FilePostConnectOrCreateFieldInputOnCreate = {
  node: PostOnCreateInput;
};

export type FilePostConnection = {
  __typename?: 'FilePostConnection';
  edges: Array<FilePostRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FilePostConnectionSort = {
  node?: InputMaybe<PostSort>;
};

export type FilePostConnectionWhere = {
  AND?: InputMaybe<Array<FilePostConnectionWhere>>;
  NOT?: InputMaybe<FilePostConnectionWhere>;
  OR?: InputMaybe<Array<FilePostConnectionWhere>>;
  node?: InputMaybe<PostWhere>;
};

export type FilePostCreateFieldInput = {
  node: PostCreateInput;
};

export type FilePostDeleteFieldInput = {
  delete?: InputMaybe<PostDeleteInput>;
  where?: InputMaybe<FilePostConnectionWhere>;
};

export type FilePostDisconnectFieldInput = {
  disconnect?: InputMaybe<PostDisconnectInput>;
  where?: InputMaybe<FilePostConnectionWhere>;
};

export type FilePostFieldInput = {
  connect?: InputMaybe<FilePostConnectFieldInput>;
  connectOrCreate?: InputMaybe<FilePostConnectOrCreateFieldInput>;
  create?: InputMaybe<FilePostCreateFieldInput>;
};

export type FilePostNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FilePostNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FilePostNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FilePostNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  depth_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  depth_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  depth_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  depth_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  depth_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  depth_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  depth_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  depth_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  depth_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  depth_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  depth_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  depth_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  depth_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  depth_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  depth_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  depth_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  depth_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  depth_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  depth_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  depth_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  message_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  message_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threadId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threadId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  threadId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  threadId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  threadId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  threadId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threadId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threadId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threadId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threadId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threadId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threadId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threadId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threadId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threadId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FilePostPostAggregationSelection = {
  __typename?: 'FilePostPostAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FilePostPostNodeAggregateSelection>;
};

export type FilePostPostNodeAggregateSelection = {
  __typename?: 'FilePostPostNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  depth: IntAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  message: StringAggregateSelection;
  threadId: StringAggregateSelection;
};

export type FilePostRelationship = {
  __typename?: 'FilePostRelationship';
  cursor: Scalars['String']['output'];
  node: Post;
};

export type FilePostUpdateConnectionInput = {
  node?: InputMaybe<PostUpdateInput>;
};

export type FilePostUpdateFieldInput = {
  connect?: InputMaybe<FilePostConnectFieldInput>;
  connectOrCreate?: InputMaybe<FilePostConnectOrCreateFieldInput>;
  create?: InputMaybe<FilePostCreateFieldInput>;
  delete?: InputMaybe<FilePostDeleteFieldInput>;
  disconnect?: InputMaybe<FilePostDisconnectFieldInput>;
  update?: InputMaybe<FilePostUpdateConnectionInput>;
  where?: InputMaybe<FilePostConnectionWhere>;
};

export type FileProjectSubmissionAggregateInput = {
  AND?: InputMaybe<Array<FileProjectSubmissionAggregateInput>>;
  NOT?: InputMaybe<FileProjectSubmissionAggregateInput>;
  OR?: InputMaybe<Array<FileProjectSubmissionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FileProjectSubmissionNodeAggregationWhereInput>;
};

export type FileProjectSubmissionConnectFieldInput = {
  connect?: InputMaybe<ProjectSubmissionConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ProjectSubmissionConnectWhere>;
};

export type FileProjectSubmissionConnectOrCreateFieldInput = {
  onCreate: FileProjectSubmissionConnectOrCreateFieldInputOnCreate;
  where: ProjectSubmissionConnectOrCreateWhere;
};

export type FileProjectSubmissionConnectOrCreateFieldInputOnCreate = {
  node: ProjectSubmissionOnCreateInput;
};

export type FileProjectSubmissionConnection = {
  __typename?: 'FileProjectSubmissionConnection';
  edges: Array<FileProjectSubmissionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FileProjectSubmissionConnectionSort = {
  node?: InputMaybe<ProjectSubmissionSort>;
};

export type FileProjectSubmissionConnectionWhere = {
  AND?: InputMaybe<Array<FileProjectSubmissionConnectionWhere>>;
  NOT?: InputMaybe<FileProjectSubmissionConnectionWhere>;
  OR?: InputMaybe<Array<FileProjectSubmissionConnectionWhere>>;
  node?: InputMaybe<ProjectSubmissionWhere>;
};

export type FileProjectSubmissionCreateFieldInput = {
  node: ProjectSubmissionCreateInput;
};

export type FileProjectSubmissionDeleteFieldInput = {
  delete?: InputMaybe<ProjectSubmissionDeleteInput>;
  where?: InputMaybe<FileProjectSubmissionConnectionWhere>;
};

export type FileProjectSubmissionDisconnectFieldInput = {
  disconnect?: InputMaybe<ProjectSubmissionDisconnectInput>;
  where?: InputMaybe<FileProjectSubmissionConnectionWhere>;
};

export type FileProjectSubmissionFieldInput = {
  connect?: InputMaybe<FileProjectSubmissionConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileProjectSubmissionConnectOrCreateFieldInput>;
  create?: InputMaybe<FileProjectSubmissionCreateFieldInput>;
};

export type FileProjectSubmissionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FileProjectSubmissionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FileProjectSubmissionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FileProjectSubmissionNodeAggregationWhereInput>>;
  aiAssessment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiAssessment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aiAssessment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiAssessment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aiAssessment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aiAssessment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  approachMethodology_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  approachMethodology_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  approachMethodology_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  approachMethodology_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  approachMethodology_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  completedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedTasks_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  completedTasks_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  completedTasks_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  completedTasks_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  completedTasks_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  completedTasks_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  complianceScore_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  feedback_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  feedback_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  gradedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  proposal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  proposal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  proposal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  proposal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  proposal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  proposal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  proposal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  proposal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  proposal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  proposal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  proposal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  proposal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  proposal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  proposal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  proposal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scopeJustification_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scopeJustification_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scopeJustification_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scopeJustification_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scopeJustification_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submissionLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submissionLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submissionLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submissionLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  submissionLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submissionNotes_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submissionNotes_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submissionNotes_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submissionNotes_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  submissionNotes_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalTasks_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalTasks_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalTasks_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalTasks_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalTasks_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FileProjectSubmissionProjectSubmissionAggregationSelection = {
  __typename?: 'FileProjectSubmissionProjectSubmissionAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FileProjectSubmissionProjectSubmissionNodeAggregateSelection>;
};

export type FileProjectSubmissionProjectSubmissionNodeAggregateSelection = {
  __typename?: 'FileProjectSubmissionProjectSubmissionNodeAggregateSelection';
  aiAssessment: StringAggregateSelection;
  approachMethodology: StringAggregateSelection;
  completedAt: DateTimeAggregateSelection;
  completedTasks: IntAggregateSelection;
  complianceScore: FloatAggregateSelection;
  created: DateTimeAggregateSelection;
  feedback: StringAggregateSelection;
  grade: FloatAggregateSelection;
  gradedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  proposal: StringAggregateSelection;
  scopeJustification: StringAggregateSelection;
  submissionLink: StringAggregateSelection;
  submissionNotes: StringAggregateSelection;
  totalTasks: IntAggregateSelection;
};

export type FileProjectSubmissionRelationship = {
  __typename?: 'FileProjectSubmissionRelationship';
  cursor: Scalars['String']['output'];
  node: ProjectSubmission;
};

export type FileProjectSubmissionUpdateConnectionInput = {
  node?: InputMaybe<ProjectSubmissionUpdateInput>;
};

export type FileProjectSubmissionUpdateFieldInput = {
  connect?: InputMaybe<FileProjectSubmissionConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileProjectSubmissionConnectOrCreateFieldInput>;
  create?: InputMaybe<FileProjectSubmissionCreateFieldInput>;
  delete?: InputMaybe<FileProjectSubmissionDeleteFieldInput>;
  disconnect?: InputMaybe<FileProjectSubmissionDisconnectFieldInput>;
  update?: InputMaybe<FileProjectSubmissionUpdateConnectionInput>;
  where?: InputMaybe<FileProjectSubmissionConnectionWhere>;
};

export type FileResourceActivityAggregateInput = {
  AND?: InputMaybe<Array<FileResourceActivityAggregateInput>>;
  NOT?: InputMaybe<FileResourceActivityAggregateInput>;
  OR?: InputMaybe<Array<FileResourceActivityAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FileResourceActivityNodeAggregationWhereInput>;
};

export type FileResourceActivityConnectFieldInput = {
  connect?: InputMaybe<AxioResourceConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AxioResourceConnectWhere>;
};

export type FileResourceActivityConnectOrCreateFieldInput = {
  onCreate: FileResourceActivityConnectOrCreateFieldInputOnCreate;
  where: AxioResourceConnectOrCreateWhere;
};

export type FileResourceActivityConnectOrCreateFieldInputOnCreate = {
  node: AxioResourceOnCreateInput;
};

export type FileResourceActivityConnection = {
  __typename?: 'FileResourceActivityConnection';
  edges: Array<FileResourceActivityRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FileResourceActivityConnectionSort = {
  node?: InputMaybe<AxioResourceSort>;
};

export type FileResourceActivityConnectionWhere = {
  AND?: InputMaybe<Array<FileResourceActivityConnectionWhere>>;
  NOT?: InputMaybe<FileResourceActivityConnectionWhere>;
  OR?: InputMaybe<Array<FileResourceActivityConnectionWhere>>;
  node?: InputMaybe<AxioResourceWhere>;
};

export type FileResourceActivityCreateFieldInput = {
  node: AxioResourceCreateInput;
};

export type FileResourceActivityDeleteFieldInput = {
  delete?: InputMaybe<AxioResourceDeleteInput>;
  where?: InputMaybe<FileResourceActivityConnectionWhere>;
};

export type FileResourceActivityDisconnectFieldInput = {
  disconnect?: InputMaybe<AxioResourceDisconnectInput>;
  where?: InputMaybe<FileResourceActivityConnectionWhere>;
};

export type FileResourceActivityFieldInput = {
  connect?: InputMaybe<FileResourceActivityConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileResourceActivityConnectOrCreateFieldInput>;
  create?: InputMaybe<FileResourceActivityCreateFieldInput>;
};

export type FileResourceActivityNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FileResourceActivityNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FileResourceActivityNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FileResourceActivityNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FileResourceActivityRelationship = {
  __typename?: 'FileResourceActivityRelationship';
  cursor: Scalars['String']['output'];
  node: AxioResource;
};

export type FileResourceActivityUpdateConnectionInput = {
  node?: InputMaybe<AxioResourceUpdateInput>;
};

export type FileResourceActivityUpdateFieldInput = {
  connect?: InputMaybe<FileResourceActivityConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileResourceActivityConnectOrCreateFieldInput>;
  create?: InputMaybe<FileResourceActivityCreateFieldInput>;
  delete?: InputMaybe<FileResourceActivityDeleteFieldInput>;
  disconnect?: InputMaybe<FileResourceActivityDisconnectFieldInput>;
  update?: InputMaybe<FileResourceActivityUpdateConnectionInput>;
  where?: InputMaybe<FileResourceActivityConnectionWhere>;
};

export type FileResponse = {
  __typename?: 'FileResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<File>>>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Fields to sort Files by. The order in which sorts are applied is not guaranteed when specifying many fields in one FileSort object. */
export type FileSort = {
  bucketName?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  fileName?: InputMaybe<SortDirection>;
  filePath?: InputMaybe<SortDirection>;
  fileURL?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
};

export enum FileStatus {
  Completed = 'completed',
  Pending = 'pending',
  Processing = 'processing',
  Rejected = 'rejected',
  Uploaded = 'uploaded'
}

export type FileSubmissionAggregateInput = {
  AND?: InputMaybe<Array<FileSubmissionAggregateInput>>;
  NOT?: InputMaybe<FileSubmissionAggregateInput>;
  OR?: InputMaybe<Array<FileSubmissionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FileSubmissionNodeAggregationWhereInput>;
};

export type FileSubmissionConnectFieldInput = {
  connect?: InputMaybe<SubmissionConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SubmissionConnectWhere>;
};

export type FileSubmissionConnectOrCreateFieldInput = {
  onCreate: FileSubmissionConnectOrCreateFieldInputOnCreate;
  where: SubmissionConnectOrCreateWhere;
};

export type FileSubmissionConnectOrCreateFieldInputOnCreate = {
  node: SubmissionOnCreateInput;
};

export type FileSubmissionConnection = {
  __typename?: 'FileSubmissionConnection';
  edges: Array<FileSubmissionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FileSubmissionConnectionSort = {
  node?: InputMaybe<SubmissionSort>;
};

export type FileSubmissionConnectionWhere = {
  AND?: InputMaybe<Array<FileSubmissionConnectionWhere>>;
  NOT?: InputMaybe<FileSubmissionConnectionWhere>;
  OR?: InputMaybe<Array<FileSubmissionConnectionWhere>>;
  node?: InputMaybe<SubmissionWhere>;
};

export type FileSubmissionCreateFieldInput = {
  node: SubmissionCreateInput;
};

export type FileSubmissionDeleteFieldInput = {
  delete?: InputMaybe<SubmissionDeleteInput>;
  where?: InputMaybe<FileSubmissionConnectionWhere>;
};

export type FileSubmissionDisconnectFieldInput = {
  disconnect?: InputMaybe<SubmissionDisconnectInput>;
  where?: InputMaybe<FileSubmissionConnectionWhere>;
};

export type FileSubmissionFieldInput = {
  connect?: InputMaybe<FileSubmissionConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileSubmissionConnectOrCreateFieldInput>;
  create?: InputMaybe<FileSubmissionCreateFieldInput>;
};

export type FileSubmissionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FileSubmissionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FileSubmissionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FileSubmissionNodeAggregationWhereInput>>;
  completedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  feedback_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  feedback_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FileSubmissionRelationship = {
  __typename?: 'FileSubmissionRelationship';
  cursor: Scalars['String']['output'];
  node: Submission;
};

export type FileSubmissionSubmissionAggregationSelection = {
  __typename?: 'FileSubmissionSubmissionAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FileSubmissionSubmissionNodeAggregateSelection>;
};

export type FileSubmissionSubmissionNodeAggregateSelection = {
  __typename?: 'FileSubmissionSubmissionNodeAggregateSelection';
  completedAt: DateTimeAggregateSelection;
  created: DateTimeAggregateSelection;
  feedback: StringAggregateSelection;
  grade: FloatAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
};

export type FileSubmissionUpdateConnectionInput = {
  node?: InputMaybe<SubmissionUpdateInput>;
};

export type FileSubmissionUpdateFieldInput = {
  connect?: InputMaybe<FileSubmissionConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileSubmissionConnectOrCreateFieldInput>;
  create?: InputMaybe<FileSubmissionCreateFieldInput>;
  delete?: InputMaybe<FileSubmissionDeleteFieldInput>;
  disconnect?: InputMaybe<FileSubmissionDisconnectFieldInput>;
  update?: InputMaybe<FileSubmissionUpdateConnectionInput>;
  where?: InputMaybe<FileSubmissionConnectionWhere>;
};

export type FileUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FileUpdateInput = {
  aiTutorActivity?: InputMaybe<FileAiTutorActivityUpdateFieldInput>;
  assignmentActivity?: InputMaybe<FileAssignmentActivityUpdateFieldInput>;
  bucketName?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  documents?: InputMaybe<Array<FileDocumentsUpdateFieldInput>>;
  fileBlock?: InputMaybe<FileFileBlockUpdateFieldInput>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  fileURL?: InputMaybe<Scalars['String']['input']>;
  hasRosterExport?: InputMaybe<FileHasRosterExportUpdateFieldInput>;
  hasSubmissionExportUser?: InputMaybe<FileHasSubmissionExportUserUpdateFieldInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  message?: InputMaybe<FileMessageUpdateFieldInput>;
  post?: InputMaybe<FilePostUpdateFieldInput>;
  projectSubmission?: InputMaybe<FileProjectSubmissionUpdateFieldInput>;
  resourceActivity?: InputMaybe<FileResourceActivityUpdateFieldInput>;
  status?: InputMaybe<FileStatus>;
  submission?: InputMaybe<FileSubmissionUpdateFieldInput>;
  user?: InputMaybe<FileUserUpdateFieldInput>;
};

export type FileUploadData = {
  __typename?: 'FileUploadData';
  file?: Maybe<File>;
  signedUrl?: Maybe<Scalars['String']['output']>;
  uniqueFileName?: Maybe<Scalars['String']['output']>;
  uploadedFileMimeType?: Maybe<Scalars['String']['output']>;
};

export type FileUploadResponse = {
  __typename?: 'FileUploadResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<FileUploadData>>>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type FileUserAggregateInput = {
  AND?: InputMaybe<Array<FileUserAggregateInput>>;
  NOT?: InputMaybe<FileUserAggregateInput>;
  OR?: InputMaybe<Array<FileUserAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FileUserNodeAggregationWhereInput>;
};

export type FileUserConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type FileUserConnectOrCreateFieldInput = {
  onCreate: FileUserConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type FileUserConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type FileUserConnection = {
  __typename?: 'FileUserConnection';
  edges: Array<FileUserRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FileUserConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type FileUserConnectionWhere = {
  AND?: InputMaybe<Array<FileUserConnectionWhere>>;
  NOT?: InputMaybe<FileUserConnectionWhere>;
  OR?: InputMaybe<Array<FileUserConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type FileUserCreateFieldInput = {
  node: UserCreateInput;
};

export type FileUserDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<FileUserConnectionWhere>;
};

export type FileUserDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<FileUserConnectionWhere>;
};

export type FileUserFieldInput = {
  connect?: InputMaybe<FileUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileUserConnectOrCreateFieldInput>;
  create?: InputMaybe<FileUserCreateFieldInput>;
};

export type FileUserHasRosterExportAggregationSelection = {
  __typename?: 'FileUserHasRosterExportAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<FileUserHasRosterExportEdgeAggregateSelection>;
  node?: Maybe<FileUserHasRosterExportNodeAggregateSelection>;
};

export type FileUserHasRosterExportEdgeAggregateSelection = {
  __typename?: 'FileUserHasRosterExportEdgeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  kind: StringAggregateSelection;
  rowCount: IntAggregateSelection;
};

export type FileUserHasRosterExportNodeAggregateSelection = {
  __typename?: 'FileUserHasRosterExportNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type FileUserHasSubmissionExportUserAggregationSelection = {
  __typename?: 'FileUserHasSubmissionExportUserAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<FileUserHasSubmissionExportUserEdgeAggregateSelection>;
  node?: Maybe<FileUserHasSubmissionExportUserNodeAggregateSelection>;
};

export type FileUserHasSubmissionExportUserEdgeAggregateSelection = {
  __typename?: 'FileUserHasSubmissionExportUserEdgeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  kind: StringAggregateSelection;
  rowCount: IntAggregateSelection;
};

export type FileUserHasSubmissionExportUserNodeAggregateSelection = {
  __typename?: 'FileUserHasSubmissionExportUserNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type FileUserNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FileUserNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FileUserNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FileUserNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FileUserRelationship = {
  __typename?: 'FileUserRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type FileUserUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type FileUserUpdateFieldInput = {
  connect?: InputMaybe<FileUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<FileUserConnectOrCreateFieldInput>;
  create?: InputMaybe<FileUserCreateFieldInput>;
  delete?: InputMaybe<FileUserDeleteFieldInput>;
  disconnect?: InputMaybe<FileUserDisconnectFieldInput>;
  update?: InputMaybe<FileUserUpdateConnectionInput>;
  where?: InputMaybe<FileUserConnectionWhere>;
};

export type FileUserUserAggregationSelection = {
  __typename?: 'FileUserUserAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<FileUserUserNodeAggregateSelection>;
};

export type FileUserUserNodeAggregateSelection = {
  __typename?: 'FileUserUserNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type FileWhere = {
  AND?: InputMaybe<Array<FileWhere>>;
  NOT?: InputMaybe<FileWhere>;
  OR?: InputMaybe<Array<FileWhere>>;
  aiTutorActivity?: InputMaybe<AiTutorWhere>;
  aiTutorActivityAggregate?: InputMaybe<FileAiTutorActivityAggregateInput>;
  aiTutorActivityConnection?: InputMaybe<FileAiTutorActivityConnectionWhere>;
  aiTutorActivityConnection_NOT?: InputMaybe<FileAiTutorActivityConnectionWhere>;
  aiTutorActivity_NOT?: InputMaybe<AiTutorWhere>;
  assignmentActivity?: InputMaybe<AssignmentWhere>;
  assignmentActivityAggregate?: InputMaybe<FileAssignmentActivityAggregateInput>;
  assignmentActivityConnection?: InputMaybe<FileAssignmentActivityConnectionWhere>;
  assignmentActivityConnection_NOT?: InputMaybe<FileAssignmentActivityConnectionWhere>;
  assignmentActivity_NOT?: InputMaybe<AssignmentWhere>;
  bucketName?: InputMaybe<Scalars['String']['input']>;
  bucketName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  bucketName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  bucketName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  bucketName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  documentsAggregate?: InputMaybe<FileDocumentsAggregateInput>;
  /** Return Files where all of the related FileDocumentsConnections match this filter */
  documentsConnection_ALL?: InputMaybe<FileDocumentsConnectionWhere>;
  /** Return Files where none of the related FileDocumentsConnections match this filter */
  documentsConnection_NONE?: InputMaybe<FileDocumentsConnectionWhere>;
  /** Return Files where one of the related FileDocumentsConnections match this filter */
  documentsConnection_SINGLE?: InputMaybe<FileDocumentsConnectionWhere>;
  /** Return Files where some of the related FileDocumentsConnections match this filter */
  documentsConnection_SOME?: InputMaybe<FileDocumentsConnectionWhere>;
  /** Return Files where all of the related Documents match this filter */
  documents_ALL?: InputMaybe<DocumentWhere>;
  /** Return Files where none of the related Documents match this filter */
  documents_NONE?: InputMaybe<DocumentWhere>;
  /** Return Files where one of the related Documents match this filter */
  documents_SINGLE?: InputMaybe<DocumentWhere>;
  /** Return Files where some of the related Documents match this filter */
  documents_SOME?: InputMaybe<DocumentWhere>;
  fileBlock?: InputMaybe<FileBlockWhere>;
  fileBlockAggregate?: InputMaybe<FileFileBlockAggregateInput>;
  fileBlockConnection?: InputMaybe<FileFileBlockConnectionWhere>;
  fileBlockConnection_NOT?: InputMaybe<FileFileBlockConnectionWhere>;
  fileBlock_NOT?: InputMaybe<FileBlockWhere>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  fileName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  fileName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  fileName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  filePath_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  filePath_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  filePath_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  filePath_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  fileURL?: InputMaybe<Scalars['String']['input']>;
  fileURL_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  fileURL_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  fileURL_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  fileURL_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  hasRosterExport?: InputMaybe<UserWhere>;
  hasRosterExportAggregate?: InputMaybe<FileHasRosterExportAggregateInput>;
  hasRosterExportConnection?: InputMaybe<FileHasRosterExportConnectionWhere>;
  hasRosterExportConnection_NOT?: InputMaybe<FileHasRosterExportConnectionWhere>;
  hasRosterExport_NOT?: InputMaybe<UserWhere>;
  hasSubmissionExportUser?: InputMaybe<UserWhere>;
  hasSubmissionExportUserAggregate?: InputMaybe<FileHasSubmissionExportUserAggregateInput>;
  hasSubmissionExportUserConnection?: InputMaybe<FileHasSubmissionExportUserConnectionWhere>;
  hasSubmissionExportUserConnection_NOT?: InputMaybe<FileHasSubmissionExportUserConnectionWhere>;
  hasSubmissionExportUser_NOT?: InputMaybe<UserWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  message?: InputMaybe<MessageWhere>;
  messageAggregate?: InputMaybe<FileMessageAggregateInput>;
  messageConnection?: InputMaybe<FileMessageConnectionWhere>;
  messageConnection_NOT?: InputMaybe<FileMessageConnectionWhere>;
  message_NOT?: InputMaybe<MessageWhere>;
  post?: InputMaybe<PostWhere>;
  postAggregate?: InputMaybe<FilePostAggregateInput>;
  postConnection?: InputMaybe<FilePostConnectionWhere>;
  postConnection_NOT?: InputMaybe<FilePostConnectionWhere>;
  post_NOT?: InputMaybe<PostWhere>;
  projectSubmission?: InputMaybe<ProjectSubmissionWhere>;
  projectSubmissionAggregate?: InputMaybe<FileProjectSubmissionAggregateInput>;
  projectSubmissionConnection?: InputMaybe<FileProjectSubmissionConnectionWhere>;
  projectSubmissionConnection_NOT?: InputMaybe<FileProjectSubmissionConnectionWhere>;
  projectSubmission_NOT?: InputMaybe<ProjectSubmissionWhere>;
  resourceActivity?: InputMaybe<AxioResourceWhere>;
  resourceActivityAggregate?: InputMaybe<FileResourceActivityAggregateInput>;
  resourceActivityConnection?: InputMaybe<FileResourceActivityConnectionWhere>;
  resourceActivityConnection_NOT?: InputMaybe<FileResourceActivityConnectionWhere>;
  resourceActivity_NOT?: InputMaybe<AxioResourceWhere>;
  status?: InputMaybe<FileStatus>;
  status_IN?: InputMaybe<Array<FileStatus>>;
  submission?: InputMaybe<SubmissionWhere>;
  submissionAggregate?: InputMaybe<FileSubmissionAggregateInput>;
  submissionConnection?: InputMaybe<FileSubmissionConnectionWhere>;
  submissionConnection_NOT?: InputMaybe<FileSubmissionConnectionWhere>;
  submission_NOT?: InputMaybe<SubmissionWhere>;
  user?: InputMaybe<UserWhere>;
  userAggregate?: InputMaybe<FileUserAggregateInput>;
  userConnection?: InputMaybe<FileUserConnectionWhere>;
  userConnection_NOT?: InputMaybe<FileUserConnectionWhere>;
  user_NOT?: InputMaybe<UserWhere>;
};

export type FinalizedMcqQuestionInput = {
  aiTutorId?: InputMaybe<Scalars['ID']['input']>;
  choices: Array<Scalars['String']['input']>;
  correctChoiceIndices: Array<Scalars['Int']['input']>;
  explanation?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  question: Scalars['String']['input'];
  totalScore?: InputMaybe<Scalars['Float']['input']>;
};

export type FinalizedSocraticQuestionInput = {
  aiTutorId: Scalars['ID']['input'];
  question: Scalars['String']['input'];
  rubrics?: InputMaybe<Array<SocraticQuestionRubricInput>>;
  totalScore?: InputMaybe<Scalars['Float']['input']>;
};

export type FloatAggregateSelection = {
  __typename?: 'FloatAggregateSelection';
  average?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  sum?: Maybe<Scalars['Float']['output']>;
};

export type Food = {
  __typename?: 'Food';
  calories?: Maybe<Scalars['Float']['output']>;
  carbohydrates_grams?: Maybe<Scalars['Float']['output']>;
  fat_grams?: Maybe<Scalars['Float']['output']>;
  fiber_grams?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  protein_grams?: Maybe<Scalars['Float']['output']>;
  serving_size?: Maybe<Scalars['String']['output']>;
  sodium_mg?: Maybe<Scalars['Float']['output']>;
  sugars_grams?: Maybe<Scalars['Float']['output']>;
};

export type FoodItem = {
  __typename?: 'FoodItem';
  calories?: Maybe<Scalars['Float']['output']>;
  created: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  last_modified: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  serving_size?: Maybe<Scalars['String']['output']>;
  sugar_grams?: Maybe<Scalars['Float']['output']>;
  usersHasFoodItem: Array<User>;
  usersHasFoodItemAggregate?: Maybe<FoodItemUserUsersHasFoodItemAggregationSelection>;
  usersHasFoodItemConnection: FoodItemUsersHasFoodItemConnection;
  usersundefined: Array<User>;
  usersundefinedAggregate?: Maybe<FoodItemUserUsersundefinedAggregationSelection>;
  usersundefinedConnection: FoodItemUsersundefinedConnection;
};


export type FoodItemUsersHasFoodItemArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type FoodItemUsersHasFoodItemAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type FoodItemUsersHasFoodItemConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FoodItemUsersHasFoodItemConnectionSort>>;
  where?: InputMaybe<FoodItemUsersHasFoodItemConnectionWhere>;
};


export type FoodItemUsersundefinedArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type FoodItemUsersundefinedAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type FoodItemUsersundefinedConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FoodItemUsersundefinedConnectionSort>>;
  where?: InputMaybe<FoodItemUsersundefinedConnectionWhere>;
};

export type FoodItemConnectInput = {
  usersHasFoodItem?: InputMaybe<Array<FoodItemUsersHasFoodItemConnectFieldInput>>;
  usersundefined?: InputMaybe<Array<FoodItemUsersundefinedConnectFieldInput>>;
};

export type FoodItemConnectWhere = {
  node: FoodItemWhere;
};

export type FoodItemCreateInput = {
  calories?: InputMaybe<Scalars['Float']['input']>;
  created: Scalars['DateTime']['input'];
  date?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  last_modified: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  serving_size?: InputMaybe<Scalars['String']['input']>;
  sugar_grams?: InputMaybe<Scalars['Float']['input']>;
  usersHasFoodItem?: InputMaybe<FoodItemUsersHasFoodItemFieldInput>;
  usersundefined?: InputMaybe<FoodItemUsersundefinedFieldInput>;
};

export type FoodItemDeleteInput = {
  usersHasFoodItem?: InputMaybe<Array<FoodItemUsersHasFoodItemDeleteFieldInput>>;
  usersundefined?: InputMaybe<Array<FoodItemUsersundefinedDeleteFieldInput>>;
};

export type FoodItemDisconnectInput = {
  usersHasFoodItem?: InputMaybe<Array<FoodItemUsersHasFoodItemDisconnectFieldInput>>;
  usersundefined?: InputMaybe<Array<FoodItemUsersundefinedDisconnectFieldInput>>;
};

export type FoodItemOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more FoodItemSort objects to sort FoodItems by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FoodItemSort>>;
};

/** Fields to sort FoodItems by. The order in which sorts are applied is not guaranteed when specifying many fields in one FoodItemSort object. */
export type FoodItemSort = {
  calories?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  date?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  last_modified?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  serving_size?: InputMaybe<SortDirection>;
  sugar_grams?: InputMaybe<SortDirection>;
};

export type FoodItemUpdateInput = {
  calories?: InputMaybe<Scalars['Float']['input']>;
  calories_ADD?: InputMaybe<Scalars['Float']['input']>;
  calories_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  calories_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  calories_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  serving_size?: InputMaybe<Scalars['String']['input']>;
  sugar_grams?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_ADD?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  usersHasFoodItem?: InputMaybe<Array<FoodItemUsersHasFoodItemUpdateFieldInput>>;
  usersundefined?: InputMaybe<Array<FoodItemUsersundefinedUpdateFieldInput>>;
};

export type FoodItemUserUsersHasFoodItemAggregationSelection = {
  __typename?: 'FoodItemUserUsersHasFoodItemAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<FoodItemUserUsersHasFoodItemEdgeAggregateSelection>;
  node?: Maybe<FoodItemUserUsersHasFoodItemNodeAggregateSelection>;
};

export type FoodItemUserUsersHasFoodItemEdgeAggregateSelection = {
  __typename?: 'FoodItemUserUsersHasFoodItemEdgeAggregateSelection';
  consumption_date: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  date: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  meal: StringAggregateSelection;
  meal_date: StringAggregateSelection;
  meal_time: StringAggregateSelection;
  meal_type: StringAggregateSelection;
  portion: FloatAggregateSelection;
  quality: BigIntAggregateSelection;
  quantity: FloatAggregateSelection;
  strength: BigIntAggregateSelection;
  time: StringAggregateSelection;
};

export type FoodItemUserUsersHasFoodItemNodeAggregateSelection = {
  __typename?: 'FoodItemUserUsersHasFoodItemNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type FoodItemUserUsersundefinedAggregationSelection = {
  __typename?: 'FoodItemUserUsersundefinedAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<FoodItemUserUsersundefinedEdgeAggregateSelection>;
  node?: Maybe<FoodItemUserUsersundefinedNodeAggregateSelection>;
};

export type FoodItemUserUsersundefinedEdgeAggregateSelection = {
  __typename?: 'FoodItemUserUsersundefinedEdgeAggregateSelection';
  created: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  quality: BigIntAggregateSelection;
  strength: BigIntAggregateSelection;
};

export type FoodItemUserUsersundefinedNodeAggregateSelection = {
  __typename?: 'FoodItemUserUsersundefinedNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type FoodItemUsersHasFoodItemAggregateInput = {
  AND?: InputMaybe<Array<FoodItemUsersHasFoodItemAggregateInput>>;
  NOT?: InputMaybe<FoodItemUsersHasFoodItemAggregateInput>;
  OR?: InputMaybe<Array<FoodItemUsersHasFoodItemAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasFoodItemPropertiesAggregationWhereInput>;
  node?: InputMaybe<FoodItemUsersHasFoodItemNodeAggregationWhereInput>;
};

export type FoodItemUsersHasFoodItemConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  edge: HasFoodItemPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type FoodItemUsersHasFoodItemConnectOrCreateFieldInput = {
  onCreate: FoodItemUsersHasFoodItemConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type FoodItemUsersHasFoodItemConnectOrCreateFieldInputOnCreate = {
  edge: HasFoodItemPropertiesCreateInput;
  node: UserOnCreateInput;
};

export type FoodItemUsersHasFoodItemConnection = {
  __typename?: 'FoodItemUsersHasFoodItemConnection';
  edges: Array<FoodItemUsersHasFoodItemRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FoodItemUsersHasFoodItemConnectionSort = {
  edge?: InputMaybe<HasFoodItemPropertiesSort>;
  node?: InputMaybe<UserSort>;
};

export type FoodItemUsersHasFoodItemConnectionWhere = {
  AND?: InputMaybe<Array<FoodItemUsersHasFoodItemConnectionWhere>>;
  NOT?: InputMaybe<FoodItemUsersHasFoodItemConnectionWhere>;
  OR?: InputMaybe<Array<FoodItemUsersHasFoodItemConnectionWhere>>;
  edge?: InputMaybe<HasFoodItemPropertiesWhere>;
  node?: InputMaybe<UserWhere>;
};

export type FoodItemUsersHasFoodItemCreateFieldInput = {
  edge: HasFoodItemPropertiesCreateInput;
  node: UserCreateInput;
};

export type FoodItemUsersHasFoodItemDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<FoodItemUsersHasFoodItemConnectionWhere>;
};

export type FoodItemUsersHasFoodItemDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<FoodItemUsersHasFoodItemConnectionWhere>;
};

export type FoodItemUsersHasFoodItemFieldInput = {
  connect?: InputMaybe<Array<FoodItemUsersHasFoodItemConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<FoodItemUsersHasFoodItemConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<FoodItemUsersHasFoodItemCreateFieldInput>>;
};

export type FoodItemUsersHasFoodItemNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FoodItemUsersHasFoodItemNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FoodItemUsersHasFoodItemNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FoodItemUsersHasFoodItemNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FoodItemUsersHasFoodItemRelationship = {
  __typename?: 'FoodItemUsersHasFoodItemRelationship';
  cursor: Scalars['String']['output'];
  node: User;
  properties: HasFoodItemProperties;
};

export type FoodItemUsersHasFoodItemUpdateConnectionInput = {
  edge?: InputMaybe<HasFoodItemPropertiesUpdateInput>;
  node?: InputMaybe<UserUpdateInput>;
};

export type FoodItemUsersHasFoodItemUpdateFieldInput = {
  connect?: InputMaybe<Array<FoodItemUsersHasFoodItemConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<FoodItemUsersHasFoodItemConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<FoodItemUsersHasFoodItemCreateFieldInput>>;
  delete?: InputMaybe<Array<FoodItemUsersHasFoodItemDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<FoodItemUsersHasFoodItemDisconnectFieldInput>>;
  update?: InputMaybe<FoodItemUsersHasFoodItemUpdateConnectionInput>;
  where?: InputMaybe<FoodItemUsersHasFoodItemConnectionWhere>;
};

export type FoodItemUsersundefinedAggregateInput = {
  AND?: InputMaybe<Array<FoodItemUsersundefinedAggregateInput>>;
  NOT?: InputMaybe<FoodItemUsersundefinedAggregateInput>;
  OR?: InputMaybe<Array<FoodItemUsersundefinedAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<UndefinedPropertiesAggregationWhereInput>;
  node?: InputMaybe<FoodItemUsersundefinedNodeAggregationWhereInput>;
};

export type FoodItemUsersundefinedConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  edge: UndefinedPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type FoodItemUsersundefinedConnectOrCreateFieldInput = {
  onCreate: FoodItemUsersundefinedConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type FoodItemUsersundefinedConnectOrCreateFieldInputOnCreate = {
  edge: UndefinedPropertiesCreateInput;
  node: UserOnCreateInput;
};

export type FoodItemUsersundefinedConnection = {
  __typename?: 'FoodItemUsersundefinedConnection';
  edges: Array<FoodItemUsersundefinedRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FoodItemUsersundefinedConnectionSort = {
  edge?: InputMaybe<UndefinedPropertiesSort>;
  node?: InputMaybe<UserSort>;
};

export type FoodItemUsersundefinedConnectionWhere = {
  AND?: InputMaybe<Array<FoodItemUsersundefinedConnectionWhere>>;
  NOT?: InputMaybe<FoodItemUsersundefinedConnectionWhere>;
  OR?: InputMaybe<Array<FoodItemUsersundefinedConnectionWhere>>;
  edge?: InputMaybe<UndefinedPropertiesWhere>;
  node?: InputMaybe<UserWhere>;
};

export type FoodItemUsersundefinedCreateFieldInput = {
  edge: UndefinedPropertiesCreateInput;
  node: UserCreateInput;
};

export type FoodItemUsersundefinedDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<FoodItemUsersundefinedConnectionWhere>;
};

export type FoodItemUsersundefinedDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<FoodItemUsersundefinedConnectionWhere>;
};

export type FoodItemUsersundefinedFieldInput = {
  connect?: InputMaybe<Array<FoodItemUsersundefinedConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<FoodItemUsersundefinedConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<FoodItemUsersundefinedCreateFieldInput>>;
};

export type FoodItemUsersundefinedNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FoodItemUsersundefinedNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FoodItemUsersundefinedNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FoodItemUsersundefinedNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FoodItemUsersundefinedRelationship = {
  __typename?: 'FoodItemUsersundefinedRelationship';
  cursor: Scalars['String']['output'];
  node: User;
  properties: UndefinedProperties;
};

export type FoodItemUsersundefinedUpdateConnectionInput = {
  edge?: InputMaybe<UndefinedPropertiesUpdateInput>;
  node?: InputMaybe<UserUpdateInput>;
};

export type FoodItemUsersundefinedUpdateFieldInput = {
  connect?: InputMaybe<Array<FoodItemUsersundefinedConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<FoodItemUsersundefinedConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<FoodItemUsersundefinedCreateFieldInput>>;
  delete?: InputMaybe<Array<FoodItemUsersundefinedDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<FoodItemUsersundefinedDisconnectFieldInput>>;
  update?: InputMaybe<FoodItemUsersundefinedUpdateConnectionInput>;
  where?: InputMaybe<FoodItemUsersundefinedConnectionWhere>;
};

export type FoodItemWhere = {
  AND?: InputMaybe<Array<FoodItemWhere>>;
  NOT?: InputMaybe<FoodItemWhere>;
  OR?: InputMaybe<Array<FoodItemWhere>>;
  calories?: InputMaybe<Scalars['Float']['input']>;
  calories_GT?: InputMaybe<Scalars['Float']['input']>;
  calories_GTE?: InputMaybe<Scalars['Float']['input']>;
  calories_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  calories_LT?: InputMaybe<Scalars['Float']['input']>;
  calories_LTE?: InputMaybe<Scalars['Float']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  date_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  id_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  last_modified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  serving_size?: InputMaybe<Scalars['String']['input']>;
  serving_size_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  serving_size_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  serving_size_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  serving_size_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sugar_grams?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_GT?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_GTE?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sugar_grams_LT?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_LTE?: InputMaybe<Scalars['Float']['input']>;
  usersHasFoodItemAggregate?: InputMaybe<FoodItemUsersHasFoodItemAggregateInput>;
  /** Return FoodItems where all of the related FoodItemUsersHasFoodItemConnections match this filter */
  usersHasFoodItemConnection_ALL?: InputMaybe<FoodItemUsersHasFoodItemConnectionWhere>;
  /** Return FoodItems where none of the related FoodItemUsersHasFoodItemConnections match this filter */
  usersHasFoodItemConnection_NONE?: InputMaybe<FoodItemUsersHasFoodItemConnectionWhere>;
  /** Return FoodItems where one of the related FoodItemUsersHasFoodItemConnections match this filter */
  usersHasFoodItemConnection_SINGLE?: InputMaybe<FoodItemUsersHasFoodItemConnectionWhere>;
  /** Return FoodItems where some of the related FoodItemUsersHasFoodItemConnections match this filter */
  usersHasFoodItemConnection_SOME?: InputMaybe<FoodItemUsersHasFoodItemConnectionWhere>;
  /** Return FoodItems where all of the related Users match this filter */
  usersHasFoodItem_ALL?: InputMaybe<UserWhere>;
  /** Return FoodItems where none of the related Users match this filter */
  usersHasFoodItem_NONE?: InputMaybe<UserWhere>;
  /** Return FoodItems where one of the related Users match this filter */
  usersHasFoodItem_SINGLE?: InputMaybe<UserWhere>;
  /** Return FoodItems where some of the related Users match this filter */
  usersHasFoodItem_SOME?: InputMaybe<UserWhere>;
  usersundefinedAggregate?: InputMaybe<FoodItemUsersundefinedAggregateInput>;
  /** Return FoodItems where all of the related FoodItemUsersundefinedConnections match this filter */
  usersundefinedConnection_ALL?: InputMaybe<FoodItemUsersundefinedConnectionWhere>;
  /** Return FoodItems where none of the related FoodItemUsersundefinedConnections match this filter */
  usersundefinedConnection_NONE?: InputMaybe<FoodItemUsersundefinedConnectionWhere>;
  /** Return FoodItems where one of the related FoodItemUsersundefinedConnections match this filter */
  usersundefinedConnection_SINGLE?: InputMaybe<FoodItemUsersundefinedConnectionWhere>;
  /** Return FoodItems where some of the related FoodItemUsersundefinedConnections match this filter */
  usersundefinedConnection_SOME?: InputMaybe<FoodItemUsersundefinedConnectionWhere>;
  /** Return FoodItems where all of the related Users match this filter */
  usersundefined_ALL?: InputMaybe<UserWhere>;
  /** Return FoodItems where none of the related Users match this filter */
  usersundefined_NONE?: InputMaybe<UserWhere>;
  /** Return FoodItems where one of the related Users match this filter */
  usersundefined_SINGLE?: InputMaybe<UserWhere>;
  /** Return FoodItems where some of the related Users match this filter */
  usersundefined_SOME?: InputMaybe<UserWhere>;
};

export type FormattedAiTutor = {
  __typename?: 'FormattedAITutor';
  activityState?: Maybe<ActivityState>;
  context?: Maybe<Scalars['String']['output']>;
  courseId?: Maybe<Scalars['ID']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  hasChatChats?: Maybe<Array<Maybe<FormattedChat>>>;
  id: Scalars['ID']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  objectives?: Maybe<Array<Maybe<FormattedObjective>>>;
  scheduledDate?: Maybe<Scalars['DateTime']['output']>;
  targetAudience?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  visualization?: Maybe<Visualization>;
};

export type FormattedChat = {
  __typename?: 'FormattedChat';
  id: Scalars['ID']['output'];
};

export type FormattedObjective = {
  __typename?: 'FormattedObjective';
  evalCriteria?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['ID']['output']>;
  objective: Scalars['String']['output'];
  pendingVideoProcessing?: Maybe<Scalars['Boolean']['output']>;
  sequence?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  videos?: Maybe<Array<Maybe<Video>>>;
};

export type FormattedVisualization = {
  __typename?: 'FormattedVisualization';
  code?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  status: VisualizationStatus;
  visualizationDescription?: Maybe<Scalars['String']['output']>;
  visualizationType?: Maybe<Scalars['String']['output']>;
};

export type Forum = {
  __typename?: 'Forum';
  course: Course;
  courseAggregate?: Maybe<ForumCourseCourseAggregationSelection>;
  courseConnection: ForumCourseConnection;
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastModified: Scalars['DateTime']['output'];
  threads: Array<Thread>;
  threadsAggregate?: Maybe<ForumThreadThreadsAggregationSelection>;
  threadsConnection: ForumThreadsConnection;
};


export type ForumCourseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CourseOptions>;
  where?: InputMaybe<CourseWhere>;
};


export type ForumCourseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CourseWhere>;
};


export type ForumCourseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ForumCourseConnectionSort>>;
  where?: InputMaybe<ForumCourseConnectionWhere>;
};


export type ForumThreadsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ThreadOptions>;
  where?: InputMaybe<ThreadWhere>;
};


export type ForumThreadsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ThreadWhere>;
};


export type ForumThreadsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ForumThreadsConnectionSort>>;
  where?: InputMaybe<ForumThreadsConnectionWhere>;
};

export type ForumConnectInput = {
  course?: InputMaybe<ForumCourseConnectFieldInput>;
  threads?: InputMaybe<Array<ForumThreadsConnectFieldInput>>;
};

export type ForumConnectOrCreateWhere = {
  node: ForumUniqueWhere;
};

export type ForumConnectWhere = {
  node: ForumWhere;
};

export type ForumCourseAggregateInput = {
  AND?: InputMaybe<Array<ForumCourseAggregateInput>>;
  NOT?: InputMaybe<ForumCourseAggregateInput>;
  OR?: InputMaybe<Array<ForumCourseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ForumCourseNodeAggregationWhereInput>;
};

export type ForumCourseConnectFieldInput = {
  connect?: InputMaybe<CourseConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CourseConnectWhere>;
};

export type ForumCourseConnectOrCreateFieldInput = {
  onCreate: ForumCourseConnectOrCreateFieldInputOnCreate;
  where: CourseConnectOrCreateWhere;
};

export type ForumCourseConnectOrCreateFieldInputOnCreate = {
  node: CourseOnCreateInput;
};

export type ForumCourseConnection = {
  __typename?: 'ForumCourseConnection';
  edges: Array<ForumCourseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ForumCourseConnectionSort = {
  node?: InputMaybe<CourseSort>;
};

export type ForumCourseConnectionWhere = {
  AND?: InputMaybe<Array<ForumCourseConnectionWhere>>;
  NOT?: InputMaybe<ForumCourseConnectionWhere>;
  OR?: InputMaybe<Array<ForumCourseConnectionWhere>>;
  node?: InputMaybe<CourseWhere>;
};

export type ForumCourseCourseAggregationSelection = {
  __typename?: 'ForumCourseCourseAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ForumCourseCourseNodeAggregateSelection>;
};

export type ForumCourseCourseNodeAggregateSelection = {
  __typename?: 'ForumCourseCourseNodeAggregateSelection';
  account_id: FloatAggregateSelection;
  calendar_ics: StringAggregateSelection;
  cost: FloatAggregateSelection;
  courseId: StringAggregateSelection;
  course_code: StringAggregateSelection;
  course_id: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  default_view: StringAggregateSelection;
  description: StringAggregateSelection;
  dueDateEndDate: DateTimeAggregateSelection;
  dueDateStartDate: DateTimeAggregateSelection;
  endDate: DateTimeAggregateSelection;
  end_at: StringAggregateSelection;
  enrollment_term_id: FloatAggregateSelection;
  grading_standard_id: FloatAggregateSelection;
  id: IdAggregateSelection;
  integration_id: StringAggregateSelection;
  label: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  learningStandards: StringAggregateSelection;
  lengthInWeeks: FloatAggregateSelection;
  license: StringAggregateSelection;
  lti_id: StringAggregateSelection;
  name: StringAggregateSelection;
  original_name: StringAggregateSelection;
  root_account_id: FloatAggregateSelection;
  sis_course_id: StringAggregateSelection;
  sis_import_id: FloatAggregateSelection;
  startDate: DateTimeAggregateSelection;
  start_at: StringAggregateSelection;
  state: StringAggregateSelection;
  storage_quota_mb: FloatAggregateSelection;
  stripePriceId: StringAggregateSelection;
  stripeProductId: StringAggregateSelection;
  targetAudience: StringAggregateSelection;
  thumbnail: StringAggregateSelection;
  time_zone: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  uuid: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export type ForumCourseCreateFieldInput = {
  node: CourseCreateInput;
};

export type ForumCourseDeleteFieldInput = {
  delete?: InputMaybe<CourseDeleteInput>;
  where?: InputMaybe<ForumCourseConnectionWhere>;
};

export type ForumCourseDisconnectFieldInput = {
  disconnect?: InputMaybe<CourseDisconnectInput>;
  where?: InputMaybe<ForumCourseConnectionWhere>;
};

export type ForumCourseFieldInput = {
  connect?: InputMaybe<ForumCourseConnectFieldInput>;
  connectOrCreate?: InputMaybe<ForumCourseConnectOrCreateFieldInput>;
  create?: InputMaybe<ForumCourseCreateFieldInput>;
};

export type ForumCourseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ForumCourseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ForumCourseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ForumCourseNodeAggregationWhereInput>>;
  account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  cost_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDateEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  enrollment_term_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  label_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningStandards_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthInWeeks_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  root_account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_import_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  startDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  storage_quota_mb_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ForumCourseRelationship = {
  __typename?: 'ForumCourseRelationship';
  cursor: Scalars['String']['output'];
  node: Course;
};

export type ForumCourseUpdateConnectionInput = {
  node?: InputMaybe<CourseUpdateInput>;
};

export type ForumCourseUpdateFieldInput = {
  connect?: InputMaybe<ForumCourseConnectFieldInput>;
  connectOrCreate?: InputMaybe<ForumCourseConnectOrCreateFieldInput>;
  create?: InputMaybe<ForumCourseCreateFieldInput>;
  delete?: InputMaybe<ForumCourseDeleteFieldInput>;
  disconnect?: InputMaybe<ForumCourseDisconnectFieldInput>;
  update?: InputMaybe<ForumCourseUpdateConnectionInput>;
  where?: InputMaybe<ForumCourseConnectionWhere>;
};

export type ForumCreateInput = {
  course?: InputMaybe<ForumCourseFieldInput>;
  created: Scalars['DateTime']['input'];
  lastModified: Scalars['DateTime']['input'];
  threads?: InputMaybe<ForumThreadsFieldInput>;
};

export type ForumDeleteInput = {
  course?: InputMaybe<ForumCourseDeleteFieldInput>;
  threads?: InputMaybe<Array<ForumThreadsDeleteFieldInput>>;
};

export type ForumDisconnectInput = {
  course?: InputMaybe<ForumCourseDisconnectFieldInput>;
  threads?: InputMaybe<Array<ForumThreadsDisconnectFieldInput>>;
};

export type ForumOnCreateInput = {
  created: Scalars['DateTime']['input'];
  lastModified: Scalars['DateTime']['input'];
};

export type ForumOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ForumSort objects to sort Forums by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ForumSort>>;
};

export type ForumResponse = {
  __typename?: 'ForumResponse';
  count: Scalars['Int']['output'];
  data?: Maybe<Forum>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Fields to sort Forums by. The order in which sorts are applied is not guaranteed when specifying many fields in one ForumSort object. */
export type ForumSort = {
  created?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastModified?: InputMaybe<SortDirection>;
};

export type ForumThreadThreadsAggregationSelection = {
  __typename?: 'ForumThreadThreadsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ForumThreadThreadsNodeAggregateSelection>;
};

export type ForumThreadThreadsNodeAggregateSelection = {
  __typename?: 'ForumThreadThreadsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  title: StringAggregateSelection;
};

export type ForumThreadsAggregateInput = {
  AND?: InputMaybe<Array<ForumThreadsAggregateInput>>;
  NOT?: InputMaybe<ForumThreadsAggregateInput>;
  OR?: InputMaybe<Array<ForumThreadsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ForumThreadsNodeAggregationWhereInput>;
};

export type ForumThreadsConnectFieldInput = {
  connect?: InputMaybe<Array<ThreadConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ThreadConnectWhere>;
};

export type ForumThreadsConnectOrCreateFieldInput = {
  onCreate: ForumThreadsConnectOrCreateFieldInputOnCreate;
  where: ThreadConnectOrCreateWhere;
};

export type ForumThreadsConnectOrCreateFieldInputOnCreate = {
  node: ThreadOnCreateInput;
};

export type ForumThreadsConnection = {
  __typename?: 'ForumThreadsConnection';
  edges: Array<ForumThreadsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ForumThreadsConnectionSort = {
  node?: InputMaybe<ThreadSort>;
};

export type ForumThreadsConnectionWhere = {
  AND?: InputMaybe<Array<ForumThreadsConnectionWhere>>;
  NOT?: InputMaybe<ForumThreadsConnectionWhere>;
  OR?: InputMaybe<Array<ForumThreadsConnectionWhere>>;
  node?: InputMaybe<ThreadWhere>;
};

export type ForumThreadsCreateFieldInput = {
  node: ThreadCreateInput;
};

export type ForumThreadsDeleteFieldInput = {
  delete?: InputMaybe<ThreadDeleteInput>;
  where?: InputMaybe<ForumThreadsConnectionWhere>;
};

export type ForumThreadsDisconnectFieldInput = {
  disconnect?: InputMaybe<ThreadDisconnectInput>;
  where?: InputMaybe<ForumThreadsConnectionWhere>;
};

export type ForumThreadsFieldInput = {
  connect?: InputMaybe<Array<ForumThreadsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ForumThreadsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ForumThreadsCreateFieldInput>>;
};

export type ForumThreadsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ForumThreadsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ForumThreadsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ForumThreadsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ForumThreadsRelationship = {
  __typename?: 'ForumThreadsRelationship';
  cursor: Scalars['String']['output'];
  node: Thread;
};

export type ForumThreadsUpdateConnectionInput = {
  node?: InputMaybe<ThreadUpdateInput>;
};

export type ForumThreadsUpdateFieldInput = {
  connect?: InputMaybe<Array<ForumThreadsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ForumThreadsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ForumThreadsCreateFieldInput>>;
  delete?: InputMaybe<Array<ForumThreadsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ForumThreadsDisconnectFieldInput>>;
  update?: InputMaybe<ForumThreadsUpdateConnectionInput>;
  where?: InputMaybe<ForumThreadsConnectionWhere>;
};

export type ForumUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ForumUpdateInput = {
  course?: InputMaybe<ForumCourseUpdateFieldInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  threads?: InputMaybe<Array<ForumThreadsUpdateFieldInput>>;
};

export type ForumWhere = {
  AND?: InputMaybe<Array<ForumWhere>>;
  NOT?: InputMaybe<ForumWhere>;
  OR?: InputMaybe<Array<ForumWhere>>;
  course?: InputMaybe<CourseWhere>;
  courseAggregate?: InputMaybe<ForumCourseAggregateInput>;
  courseConnection?: InputMaybe<ForumCourseConnectionWhere>;
  courseConnection_NOT?: InputMaybe<ForumCourseConnectionWhere>;
  course_NOT?: InputMaybe<CourseWhere>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lastModified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  threadsAggregate?: InputMaybe<ForumThreadsAggregateInput>;
  /** Return Forums where all of the related ForumThreadsConnections match this filter */
  threadsConnection_ALL?: InputMaybe<ForumThreadsConnectionWhere>;
  /** Return Forums where none of the related ForumThreadsConnections match this filter */
  threadsConnection_NONE?: InputMaybe<ForumThreadsConnectionWhere>;
  /** Return Forums where one of the related ForumThreadsConnections match this filter */
  threadsConnection_SINGLE?: InputMaybe<ForumThreadsConnectionWhere>;
  /** Return Forums where some of the related ForumThreadsConnections match this filter */
  threadsConnection_SOME?: InputMaybe<ForumThreadsConnectionWhere>;
  /** Return Forums where all of the related Threads match this filter */
  threads_ALL?: InputMaybe<ThreadWhere>;
  /** Return Forums where none of the related Threads match this filter */
  threads_NONE?: InputMaybe<ThreadWhere>;
  /** Return Forums where one of the related Threads match this filter */
  threads_SINGLE?: InputMaybe<ThreadWhere>;
  /** Return Forums where some of the related Threads match this filter */
  threads_SOME?: InputMaybe<ThreadWhere>;
};

export type GenerateAssessmentQuestionsPreviewInput = {
  aiTutorIds: Array<Scalars['ID']['input']>;
  assessmentLevel?: InputMaybe<Scalars['String']['input']>;
  assessmentType: AssessmentType;
  maxPointsPerQuestion?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions: Scalars['Int']['input'];
};

export type GenerateCourseContentData = {
  __typename?: 'GenerateCourseContentData';
  generationStatus?: Maybe<CourseGenerationStatus>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type GenerateCourseContentResponse = {
  __typename?: 'GenerateCourseContentResponse';
  count: Scalars['Int']['output'];
  data?: Maybe<GenerateCourseContentData>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type GenerateEvalCriteriaInput = {
  description: Scalars['String']['input'];
  objectives: Array<ObjectiveInput>;
  targetAudience?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type GenerateLessonPlanInput = {
  moduleId: Scalars['ID']['input'];
  selectedSections: Array<Scalars['String']['input']>;
};

export type GenerateLessonPlanResponse = {
  __typename?: 'GenerateLessonPlanResponse';
  data?: Maybe<Scalars['JSON']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GenerateSocraticRubricInput = {
  aiTutorId: Scalars['ID']['input'];
  question: Scalars['String']['input'];
  totalScore?: InputMaybe<Scalars['Float']['input']>;
};

export type Generated = {
  __typename?: 'Generated';
  data?: Maybe<Array<Maybe<Subfield>>>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GeneratedAiTutor = {
  __typename?: 'GeneratedAiTutor';
  description: Scalars['String']['output'];
  objectives?: Maybe<Array<GeneratedObjective>>;
};

export type GeneratedObjective = {
  __typename?: 'GeneratedObjective';
  objective: Scalars['String']['output'];
  sequence?: Maybe<Scalars['Float']['output']>;
};

export enum GeneratingNotificationStatus {
  Failure = 'FAILURE',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type GetAssignmentObjectiveResponse = {
  __typename?: 'GetAssignmentObjectiveResponse';
  id: Scalars['ID']['output'];
  objective?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type GetAssignmentResponse = {
  __typename?: 'GetAssignmentResponse';
  courseId?: Maybe<Scalars['ID']['output']>;
  createdDate?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  gradePoints?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  objectives?: Maybe<Array<Maybe<GetAssignmentObjectiveResponse>>>;
  pointsPossible?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
  updatedDate?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  worksheet?: Maybe<Worksheet>;
};

export type GetCompanionChatByIdResult = {
  __typename?: 'GetCompanionChatByIdResult';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<ChatResponse>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GetPageVisitsBySessionInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sessionId: Scalars['ID']['input'];
  sortBy?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type GetUnifiedSubmissionsByFacultyByUserInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  submissionType: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type GetUnifiedSubmissionsByFacultyData = {
  __typename?: 'GetUnifiedSubmissionsByFacultyData';
  submissions?: Maybe<Array<Maybe<UnifiedSubmission>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GetUnifiedSubmissionsByFacultyInput = {
  courseIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  facultyId: Scalars['ID']['input'];
  moduleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  showOnlyUngraded?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  submissionType?: InputMaybe<Scalars['String']['input']>;
};

export type GetUnifiedSubmissionsByFacultyResponse = {
  __typename?: 'GetUnifiedSubmissionsByFacultyResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<GetUnifiedSubmissionsByFacultyData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type GetVisitSessionsInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type Goal = {
  __typename?: 'Goal';
  category?: Maybe<Scalars['String']['output']>;
  completionStatus?: Maybe<Scalars['String']['output']>;
  deadline?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GoogleAuthTokens = {
  __typename?: 'GoogleAuthTokens';
  access_token?: Maybe<Scalars['String']['output']>;
  expiry_date?: Maybe<Scalars['Float']['output']>;
  refresh_token?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  token_type?: Maybe<Scalars['String']['output']>;
};

export type GradingCenterDashboardData = {
  __typename?: 'GradingCenterDashboardData';
  assignmentsAndAssessmentsToGrade?: Maybe<Scalars['Int']['output']>;
  newSubmissionsToday?: Maybe<Scalars['Int']['output']>;
};

export type GradingCenterDashboardResponse = {
  __typename?: 'GradingCenterDashboardResponse';
  data?: Maybe<GradingCenterDashboardData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * The edge properties for the following fields:
 * * Question.submissions
 * * AssessmentSubmission.questions
 */
export type HasAnswerProperties = {
  __typename?: 'HasAnswerProperties';
  aiTotalPoints?: Maybe<Scalars['Float']['output']>;
  answer?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  maximumPoints?: Maybe<Scalars['Float']['output']>;
  totalPoints?: Maybe<Scalars['Float']['output']>;
};

export type HasAnswerPropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<HasAnswerPropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<HasAnswerPropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<HasAnswerPropertiesAggregationWhereInput>>;
  aiTotalPoints_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  answer_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  answer_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  answer_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  answer_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  answer_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  answer_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  answer_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  answer_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  answer_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  answer_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  answer_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  answer_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  answer_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  answer_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  answer_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  maximumPoints_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type HasAnswerPropertiesCreateInput = {
  aiTotalPoints?: InputMaybe<Scalars['Float']['input']>;
  answer?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  maximumPoints?: InputMaybe<Scalars['Float']['input']>;
  totalPoints?: InputMaybe<Scalars['Float']['input']>;
};

export type HasAnswerPropertiesSort = {
  aiTotalPoints?: InputMaybe<SortDirection>;
  answer?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  maximumPoints?: InputMaybe<SortDirection>;
  totalPoints?: InputMaybe<SortDirection>;
};

export type HasAnswerPropertiesUpdateInput = {
  aiTotalPoints?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_ADD?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  answer?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  maximumPoints?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_ADD?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_ADD?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
};

export type HasAnswerPropertiesWhere = {
  AND?: InputMaybe<Array<HasAnswerPropertiesWhere>>;
  NOT?: InputMaybe<HasAnswerPropertiesWhere>;
  OR?: InputMaybe<Array<HasAnswerPropertiesWhere>>;
  aiTotalPoints?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_GT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  aiTotalPoints_LT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_LTE?: InputMaybe<Scalars['Float']['input']>;
  answer?: InputMaybe<Scalars['String']['input']>;
  answer_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  answer_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  answer_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  answer_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  maximumPoints?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_GT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_GTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  maximumPoints_LT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_GT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  totalPoints_LT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_LTE?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * The edge properties for the following fields:
 * * TextBlock.message
 * * FileBlock.message
 * * ArtifactBlock.message
 * * Message.textBlocks
 * * Message.fileBlocks
 * * Message.artifactBlocks
 */
export type HasBlockProperties = {
  __typename?: 'HasBlockProperties';
  created: Scalars['DateTime']['output'];
  index: Scalars['Int']['output'];
};

export type HasBlockPropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<HasBlockPropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<HasBlockPropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<HasBlockPropertiesAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  index_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  index_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type HasBlockPropertiesCreateInput = {
  created: Scalars['DateTime']['input'];
  index: Scalars['Int']['input'];
};

export type HasBlockPropertiesSort = {
  created?: InputMaybe<SortDirection>;
  index?: InputMaybe<SortDirection>;
};

export type HasBlockPropertiesUpdateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  index_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  index_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
};

export type HasBlockPropertiesWhere = {
  AND?: InputMaybe<Array<HasBlockPropertiesWhere>>;
  NOT?: InputMaybe<HasBlockPropertiesWhere>;
  OR?: InputMaybe<Array<HasBlockPropertiesWhere>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  index_GT?: InputMaybe<Scalars['Int']['input']>;
  index_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  index_LT?: InputMaybe<Scalars['Int']['input']>;
  index_LTE?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * The edge properties for the following fields:
 * * Topic.chapters
 * * Chapter.topicsHasChapter
 */
export type HasChapterProperties = {
  __typename?: 'HasChapterProperties';
  created: Scalars['DateTime']['output'];
  last_modified: Scalars['DateTime']['output'];
};

export type HasChapterPropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<HasChapterPropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<HasChapterPropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<HasChapterPropertiesAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HasChapterPropertiesCreateInput = {
  created: Scalars['DateTime']['input'];
  last_modified: Scalars['DateTime']['input'];
};

export type HasChapterPropertiesSort = {
  created?: InputMaybe<SortDirection>;
  last_modified?: InputMaybe<SortDirection>;
};

export type HasChapterPropertiesUpdateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HasChapterPropertiesWhere = {
  AND?: InputMaybe<Array<HasChapterPropertiesWhere>>;
  NOT?: InputMaybe<HasChapterPropertiesWhere>;
  OR?: InputMaybe<Array<HasChapterPropertiesWhere>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  last_modified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

/**
 * The edge properties for the following fields:
 * * User.hasChatChats
 * * Assignment.hasChatChats
 * * LearningObjective.hasChatChats
 * * AITutor.hasChatChats
 * * Chat.usersHasChat
 * * Chat.assignmentsHasChat
 * * Chat.aiTutorHasChat
 * * Chat.learningObjectivesHasChat
 */
export type HasChatProperties = {
  __typename?: 'HasChatProperties';
  ai_messages_count?: Maybe<Scalars['Int']['output']>;
  average_ai_response_time?: Maybe<Scalars['Float']['output']>;
  average_student_question_complexity?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  average_student_response_time?: Maybe<Scalars['Float']['output']>;
  confusion_points?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  created?: Maybe<Scalars['DateTime']['output']>;
  distractions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  further_recommendations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  last_modified?: Maybe<Scalars['DateTime']['output']>;
  level?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  num_messages?: Maybe<Scalars['Int']['output']>;
  originality_analysis?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  questions_asked?: Maybe<Scalars['Int']['output']>;
  sentiment_analysis?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  student_messages_count?: Maybe<Scalars['Int']['output']>;
  success_points?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  summary?: Maybe<Scalars['String']['output']>;
  total_time_taken?: Maybe<Scalars['Float']['output']>;
};

export type HasChatPropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<HasChatPropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<HasChatPropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<HasChatPropertiesAggregationWhereInput>>;
  ai_messages_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ai_messages_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  ai_messages_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  ai_messages_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  ai_messages_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  ai_messages_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  average_ai_response_time_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  num_messages_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  num_messages_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  num_messages_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  num_messages_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  num_messages_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  num_messages_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  num_messages_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  num_messages_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  num_messages_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  num_messages_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  num_messages_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  num_messages_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  num_messages_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  num_messages_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  num_messages_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  num_messages_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  num_messages_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  num_messages_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  num_messages_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  num_messages_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  questions_asked_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  questions_asked_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  questions_asked_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  questions_asked_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  questions_asked_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  student_messages_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  student_messages_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  student_messages_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  student_messages_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  student_messages_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  summary_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  summary_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  total_time_taken_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type HasChatPropertiesCreateInput = {
  ai_messages_count?: InputMaybe<Scalars['Int']['input']>;
  average_ai_response_time?: InputMaybe<Scalars['Float']['input']>;
  average_student_question_complexity?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  average_student_response_time?: InputMaybe<Scalars['Float']['input']>;
  confusion_points?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  distractions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  further_recommendations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  num_messages?: InputMaybe<Scalars['Int']['input']>;
  originality_analysis?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  questions_asked?: InputMaybe<Scalars['Int']['input']>;
  sentiment_analysis?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  student_messages_count?: InputMaybe<Scalars['Int']['input']>;
  success_points?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  summary?: InputMaybe<Scalars['String']['input']>;
  total_time_taken?: InputMaybe<Scalars['Float']['input']>;
};

export type HasChatPropertiesSort = {
  ai_messages_count?: InputMaybe<SortDirection>;
  average_ai_response_time?: InputMaybe<SortDirection>;
  average_student_question_complexity?: InputMaybe<SortDirection>;
  average_student_response_time?: InputMaybe<SortDirection>;
  confusion_points?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  distractions?: InputMaybe<SortDirection>;
  further_recommendations?: InputMaybe<SortDirection>;
  last_modified?: InputMaybe<SortDirection>;
  level?: InputMaybe<SortDirection>;
  num_messages?: InputMaybe<SortDirection>;
  originality_analysis?: InputMaybe<SortDirection>;
  questions_asked?: InputMaybe<SortDirection>;
  sentiment_analysis?: InputMaybe<SortDirection>;
  student_messages_count?: InputMaybe<SortDirection>;
  success_points?: InputMaybe<SortDirection>;
  summary?: InputMaybe<SortDirection>;
  total_time_taken?: InputMaybe<SortDirection>;
};

export type HasChatPropertiesUpdateInput = {
  ai_messages_count?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  average_ai_response_time?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_ADD?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  average_student_question_complexity?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  average_student_question_complexity_POP?: InputMaybe<Scalars['Int']['input']>;
  average_student_question_complexity_PUSH?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  average_student_response_time?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_ADD?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  confusion_points?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confusion_points_POP?: InputMaybe<Scalars['Int']['input']>;
  confusion_points_PUSH?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  distractions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  distractions_POP?: InputMaybe<Scalars['Int']['input']>;
  distractions_PUSH?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  further_recommendations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  further_recommendations_POP?: InputMaybe<Scalars['Int']['input']>;
  further_recommendations_PUSH?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  level_POP?: InputMaybe<Scalars['Int']['input']>;
  level_PUSH?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  num_messages?: InputMaybe<Scalars['Int']['input']>;
  num_messages_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  num_messages_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  originality_analysis?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  originality_analysis_POP?: InputMaybe<Scalars['Int']['input']>;
  originality_analysis_PUSH?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  questions_asked?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  sentiment_analysis?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sentiment_analysis_POP?: InputMaybe<Scalars['Int']['input']>;
  sentiment_analysis_PUSH?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  student_messages_count?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  success_points?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  success_points_POP?: InputMaybe<Scalars['Int']['input']>;
  success_points_PUSH?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  summary?: InputMaybe<Scalars['String']['input']>;
  total_time_taken?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_ADD?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
};

export type HasChatPropertiesWhere = {
  AND?: InputMaybe<Array<HasChatPropertiesWhere>>;
  NOT?: InputMaybe<HasChatPropertiesWhere>;
  OR?: InputMaybe<Array<HasChatPropertiesWhere>>;
  ai_messages_count?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_GT?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ai_messages_count_LT?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  average_ai_response_time?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_GT?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_GTE?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  average_ai_response_time_LT?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_LTE?: InputMaybe<Scalars['Float']['input']>;
  average_student_question_complexity?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  average_student_question_complexity_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  average_student_response_time?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_GT?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_GTE?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  average_student_response_time_LT?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_LTE?: InputMaybe<Scalars['Float']['input']>;
  confusion_points?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confusion_points_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  distractions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  distractions_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  further_recommendations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  further_recommendations_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  last_modified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  level_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  num_messages?: InputMaybe<Scalars['Int']['input']>;
  num_messages_GT?: InputMaybe<Scalars['Int']['input']>;
  num_messages_GTE?: InputMaybe<Scalars['Int']['input']>;
  num_messages_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  num_messages_LT?: InputMaybe<Scalars['Int']['input']>;
  num_messages_LTE?: InputMaybe<Scalars['Int']['input']>;
  originality_analysis?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  originality_analysis_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  questions_asked?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_GT?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_GTE?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  questions_asked_LT?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_LTE?: InputMaybe<Scalars['Int']['input']>;
  sentiment_analysis?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sentiment_analysis_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  student_messages_count?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_GT?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  student_messages_count_LT?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  success_points?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  success_points_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  summary_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  summary_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  summary_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  summary_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  total_time_taken?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_GT?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_GTE?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  total_time_taken_LT?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_LTE?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * The edge properties for the following fields:
 * * User.hasRosterExport
 * * User.hasSubmissionExport
 * * File.hasSubmissionExportUser
 * * File.hasRosterExport
 */
export type HasExportProps = {
  __typename?: 'HasExportProps';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  rowCount?: Maybe<Scalars['Int']['output']>;
};

export type HasExportPropsAggregationWhereInput = {
  AND?: InputMaybe<Array<HasExportPropsAggregationWhereInput>>;
  NOT?: InputMaybe<HasExportPropsAggregationWhereInput>;
  OR?: InputMaybe<Array<HasExportPropsAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  kind_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  kind_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  kind_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  kind_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  kind_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  kind_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  kind_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  kind_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  kind_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  kind_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  kind_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  kind_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  kind_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  kind_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  kind_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rowCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rowCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  rowCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  rowCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  rowCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  rowCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rowCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  rowCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  rowCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  rowCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  rowCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rowCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  rowCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  rowCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  rowCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  rowCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rowCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  rowCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  rowCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  rowCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type HasExportPropsCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  rowCount?: InputMaybe<Scalars['Int']['input']>;
};

export type HasExportPropsSort = {
  createdAt?: InputMaybe<SortDirection>;
  kind?: InputMaybe<SortDirection>;
  rowCount?: InputMaybe<SortDirection>;
};

export type HasExportPropsUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  rowCount?: InputMaybe<Scalars['Int']['input']>;
  rowCount_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  rowCount_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
};

export type HasExportPropsWhere = {
  AND?: InputMaybe<Array<HasExportPropsWhere>>;
  NOT?: InputMaybe<HasExportPropsWhere>;
  OR?: InputMaybe<Array<HasExportPropsWhere>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  kind_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  kind_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  kind_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  kind_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  rowCount?: InputMaybe<Scalars['Int']['input']>;
  rowCount_GT?: InputMaybe<Scalars['Int']['input']>;
  rowCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  rowCount_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  rowCount_LT?: InputMaybe<Scalars['Int']['input']>;
  rowCount_LTE?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * The edge properties for the following fields:
 * * User.hasFoodItemFoodItems
 * * FoodItem.usersHasFoodItem
 */
export type HasFoodItemProperties = {
  __typename?: 'HasFoodItemProperties';
  consumption_date?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['String']['output']>;
  isArchived: Scalars['Boolean']['output'];
  isHealthyOption?: Maybe<Scalars['Boolean']['output']>;
  isPositive?: Maybe<Scalars['Boolean']['output']>;
  last_modified: Scalars['DateTime']['output'];
  meal?: Maybe<Scalars['String']['output']>;
  meal_date?: Maybe<Scalars['String']['output']>;
  meal_time?: Maybe<Scalars['String']['output']>;
  meal_type?: Maybe<Scalars['String']['output']>;
  portion?: Maybe<Scalars['Float']['output']>;
  quality: Scalars['BigInt']['output'];
  quantity?: Maybe<Scalars['Float']['output']>;
  strength: Scalars['BigInt']['output'];
  time?: Maybe<Scalars['String']['output']>;
};

export type HasFoodItemPropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<HasFoodItemPropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<HasFoodItemPropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<HasFoodItemPropertiesAggregationWhereInput>>;
  consumption_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  consumption_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  consumption_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  consumption_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  consumption_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  consumption_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  consumption_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  consumption_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  consumption_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  consumption_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  consumption_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  consumption_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  consumption_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  consumption_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  consumption_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  meal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meal_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meal_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meal_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meal_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meal_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meal_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meal_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meal_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meal_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meal_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meal_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meal_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meal_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meal_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meal_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meal_time_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meal_time_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meal_time_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meal_time_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meal_time_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meal_time_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meal_time_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meal_time_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meal_time_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meal_time_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meal_time_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meal_time_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meal_time_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meal_time_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meal_time_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meal_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meal_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meal_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meal_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meal_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meal_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meal_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meal_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meal_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meal_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meal_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meal_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meal_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meal_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meal_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  portion_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  portion_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  portion_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  portion_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  portion_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  portion_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  portion_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  portion_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  portion_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  portion_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  portion_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  portion_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  portion_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  portion_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  portion_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  portion_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  portion_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  portion_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  portion_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  portion_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  quality_AVERAGE_EQUAL?: InputMaybe<Scalars['BigInt']['input']>;
  quality_AVERAGE_GT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_AVERAGE_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  quality_AVERAGE_LT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_AVERAGE_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MAX_EQUAL?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MAX_GT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MAX_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MAX_LT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MAX_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MIN_EQUAL?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MIN_GT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MIN_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MIN_LT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MIN_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  quality_SUM_EQUAL?: InputMaybe<Scalars['BigInt']['input']>;
  quality_SUM_GT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_SUM_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  quality_SUM_LT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_SUM_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  strength_AVERAGE_EQUAL?: InputMaybe<Scalars['BigInt']['input']>;
  strength_AVERAGE_GT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_AVERAGE_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_AVERAGE_LT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_AVERAGE_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MAX_EQUAL?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MAX_GT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MAX_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MAX_LT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MAX_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MIN_EQUAL?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MIN_GT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MIN_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MIN_LT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MIN_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_SUM_EQUAL?: InputMaybe<Scalars['BigInt']['input']>;
  strength_SUM_GT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_SUM_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_SUM_LT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_SUM_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  time_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  time_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  time_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  time_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  time_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  time_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type HasFoodItemPropertiesCreateInput = {
  consumption_date?: InputMaybe<Scalars['String']['input']>;
  created: Scalars['DateTime']['input'];
  date?: InputMaybe<Scalars['String']['input']>;
  isArchived: Scalars['Boolean']['input'];
  isHealthyOption?: InputMaybe<Scalars['Boolean']['input']>;
  isPositive?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified: Scalars['DateTime']['input'];
  meal?: InputMaybe<Scalars['String']['input']>;
  meal_date?: InputMaybe<Scalars['String']['input']>;
  meal_time?: InputMaybe<Scalars['String']['input']>;
  meal_type?: InputMaybe<Scalars['String']['input']>;
  portion?: InputMaybe<Scalars['Float']['input']>;
  quality: Scalars['BigInt']['input'];
  quantity?: InputMaybe<Scalars['Float']['input']>;
  strength: Scalars['BigInt']['input'];
  time?: InputMaybe<Scalars['String']['input']>;
};

export type HasFoodItemPropertiesSort = {
  consumption_date?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  date?: InputMaybe<SortDirection>;
  isArchived?: InputMaybe<SortDirection>;
  isHealthyOption?: InputMaybe<SortDirection>;
  isPositive?: InputMaybe<SortDirection>;
  last_modified?: InputMaybe<SortDirection>;
  meal?: InputMaybe<SortDirection>;
  meal_date?: InputMaybe<SortDirection>;
  meal_time?: InputMaybe<SortDirection>;
  meal_type?: InputMaybe<SortDirection>;
  portion?: InputMaybe<SortDirection>;
  quality?: InputMaybe<SortDirection>;
  quantity?: InputMaybe<SortDirection>;
  strength?: InputMaybe<SortDirection>;
  time?: InputMaybe<SortDirection>;
};

export type HasFoodItemPropertiesUpdateInput = {
  consumption_date?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isHealthyOption?: InputMaybe<Scalars['Boolean']['input']>;
  isPositive?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  meal?: InputMaybe<Scalars['String']['input']>;
  meal_date?: InputMaybe<Scalars['String']['input']>;
  meal_time?: InputMaybe<Scalars['String']['input']>;
  meal_type?: InputMaybe<Scalars['String']['input']>;
  portion?: InputMaybe<Scalars['Float']['input']>;
  portion_ADD?: InputMaybe<Scalars['Float']['input']>;
  portion_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  portion_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  portion_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  quality?: InputMaybe<Scalars['BigInt']['input']>;
  quality_DECREMENT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_INCREMENT?: InputMaybe<Scalars['BigInt']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  quantity_ADD?: InputMaybe<Scalars['Float']['input']>;
  quantity_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  strength?: InputMaybe<Scalars['BigInt']['input']>;
  strength_DECREMENT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_INCREMENT?: InputMaybe<Scalars['BigInt']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
};

export type HasFoodItemPropertiesWhere = {
  AND?: InputMaybe<Array<HasFoodItemPropertiesWhere>>;
  NOT?: InputMaybe<HasFoodItemPropertiesWhere>;
  OR?: InputMaybe<Array<HasFoodItemPropertiesWhere>>;
  consumption_date?: InputMaybe<Scalars['String']['input']>;
  consumption_date_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  consumption_date_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  consumption_date_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  consumption_date_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  date_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  date_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  date_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  date_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isHealthyOption?: InputMaybe<Scalars['Boolean']['input']>;
  isPositive?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  last_modified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  meal?: InputMaybe<Scalars['String']['input']>;
  meal_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  meal_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  meal_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  meal_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  meal_date?: InputMaybe<Scalars['String']['input']>;
  meal_date_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  meal_date_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  meal_date_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  meal_date_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  meal_time?: InputMaybe<Scalars['String']['input']>;
  meal_time_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  meal_time_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  meal_time_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  meal_time_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  meal_type?: InputMaybe<Scalars['String']['input']>;
  meal_type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  meal_type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  meal_type_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  meal_type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  portion?: InputMaybe<Scalars['Float']['input']>;
  portion_GT?: InputMaybe<Scalars['Float']['input']>;
  portion_GTE?: InputMaybe<Scalars['Float']['input']>;
  portion_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  portion_LT?: InputMaybe<Scalars['Float']['input']>;
  portion_LTE?: InputMaybe<Scalars['Float']['input']>;
  quality?: InputMaybe<Scalars['BigInt']['input']>;
  quality_GT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  quality_IN?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  quality_LT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  quantity_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  quantity_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_LTE?: InputMaybe<Scalars['Float']['input']>;
  strength?: InputMaybe<Scalars['BigInt']['input']>;
  strength_GT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_IN?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  strength_LT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  time_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  time_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  time_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  time_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The edge properties for the following fields:
 * * User.hasKnowledgeTopics
 * * User.hasKnowledgeChapters
 * * User.hasKnowledgeSubchapters
 * * Topic.usersHasKnowledge
 * * Chapter.usersHasKnowledge
 */
export type HasKnowledgeProperties = {
  __typename?: 'HasKnowledgeProperties';
  created: Scalars['DateTime']['output'];
  last_modified: Scalars['DateTime']['output'];
  total_mastery: Scalars['Float']['output'];
};

export type HasKnowledgePropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<HasKnowledgePropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<HasKnowledgePropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<HasKnowledgePropertiesAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  total_mastery_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  total_mastery_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  total_mastery_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  total_mastery_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  total_mastery_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  total_mastery_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  total_mastery_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  total_mastery_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  total_mastery_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  total_mastery_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  total_mastery_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  total_mastery_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  total_mastery_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  total_mastery_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  total_mastery_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  total_mastery_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  total_mastery_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  total_mastery_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  total_mastery_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  total_mastery_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type HasKnowledgePropertiesCreateInput = {
  created: Scalars['DateTime']['input'];
  last_modified: Scalars['DateTime']['input'];
  total_mastery: Scalars['Float']['input'];
};

export type HasKnowledgePropertiesSort = {
  created?: InputMaybe<SortDirection>;
  last_modified?: InputMaybe<SortDirection>;
  total_mastery?: InputMaybe<SortDirection>;
};

export type HasKnowledgePropertiesUpdateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  total_mastery?: InputMaybe<Scalars['Float']['input']>;
  total_mastery_ADD?: InputMaybe<Scalars['Float']['input']>;
  total_mastery_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  total_mastery_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  total_mastery_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
};

export type HasKnowledgePropertiesWhere = {
  AND?: InputMaybe<Array<HasKnowledgePropertiesWhere>>;
  NOT?: InputMaybe<HasKnowledgePropertiesWhere>;
  OR?: InputMaybe<Array<HasKnowledgePropertiesWhere>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  last_modified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  total_mastery?: InputMaybe<Scalars['Float']['input']>;
  total_mastery_GT?: InputMaybe<Scalars['Float']['input']>;
  total_mastery_GTE?: InputMaybe<Scalars['Float']['input']>;
  total_mastery_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  total_mastery_LT?: InputMaybe<Scalars['Float']['input']>;
  total_mastery_LTE?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * The edge properties for the following fields:
 * * AssessmentSubmission.mcqAnswers
 */
export type HasMcqAnswerProperties = {
  __typename?: 'HasMcqAnswerProperties';
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  isCorrect: Scalars['Boolean']['output'];
  pointsAwarded: Scalars['Float']['output'];
  selectedChoiceIndices?: Maybe<Array<Scalars['Int']['output']>>;
};

export type HasMcqAnswerPropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<HasMcqAnswerPropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<HasMcqAnswerPropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<HasMcqAnswerPropertiesAggregationWhereInput>>;
  answeredAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  answeredAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  answeredAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  answeredAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  answeredAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  answeredAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  answeredAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  answeredAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  answeredAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  answeredAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pointsAwarded_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type HasMcqAnswerPropertiesCreateInput = {
  answeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  isCorrect: Scalars['Boolean']['input'];
  pointsAwarded: Scalars['Float']['input'];
  selectedChoiceIndices?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type HasMcqAnswerPropertiesSort = {
  answeredAt?: InputMaybe<SortDirection>;
  isCorrect?: InputMaybe<SortDirection>;
  pointsAwarded?: InputMaybe<SortDirection>;
  selectedChoiceIndices?: InputMaybe<SortDirection>;
};

export type HasMcqAnswerPropertiesUpdateInput = {
  answeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  isCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  pointsAwarded?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_ADD?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  selectedChoiceIndices?: InputMaybe<Array<Scalars['Int']['input']>>;
  selectedChoiceIndices_POP?: InputMaybe<Scalars['Int']['input']>;
  selectedChoiceIndices_PUSH?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type HasMcqAnswerPropertiesWhere = {
  AND?: InputMaybe<Array<HasMcqAnswerPropertiesWhere>>;
  NOT?: InputMaybe<HasMcqAnswerPropertiesWhere>;
  OR?: InputMaybe<Array<HasMcqAnswerPropertiesWhere>>;
  answeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  answeredAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  answeredAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  answeredAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  answeredAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  answeredAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  isCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  pointsAwarded?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  pointsAwarded_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_LTE?: InputMaybe<Scalars['Float']['input']>;
  selectedChoiceIndices?: InputMaybe<Array<Scalars['Int']['input']>>;
  selectedChoiceIndices_INCLUDES?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * The edge properties for the following fields:
 * * Message.chatsHasMessage
 * * Chat.hasMessageMessages
 */
export type HasMessageProperties = {
  __typename?: 'HasMessageProperties';
  created: Scalars['DateTime']['output'];
};

export type HasMessagePropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<HasMessagePropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<HasMessagePropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<HasMessagePropertiesAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HasMessagePropertiesCreateInput = {
  created: Scalars['DateTime']['input'];
};

export type HasMessagePropertiesSort = {
  created?: InputMaybe<SortDirection>;
};

export type HasMessagePropertiesUpdateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HasMessagePropertiesWhere = {
  AND?: InputMaybe<Array<HasMessagePropertiesWhere>>;
  NOT?: InputMaybe<HasMessagePropertiesWhere>;
  OR?: InputMaybe<Array<HasMessagePropertiesWhere>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

/**
 * The edge properties for the following fields:
 * * User.hasPaymentPayments
 * * Payment.usersHasPayment
 */
export type HasPaymentProperties = {
  __typename?: 'HasPaymentProperties';
  integrationId?: Maybe<Scalars['String']['output']>;
  isPro: Scalars['Boolean']['output'];
  last_modified?: Maybe<Scalars['DateTime']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  trialEndDate?: Maybe<Scalars['DateTime']['output']>;
};

export type HasPaymentPropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<HasPaymentPropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<HasPaymentPropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<HasPaymentPropertiesAggregationWhereInput>>;
  integrationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  integrationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  integrationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  integrationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  integrationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  integrationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integrationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integrationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integrationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integrationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  integrationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integrationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integrationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integrationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integrationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HasPaymentPropertiesCreateInput = {
  integrationId?: InputMaybe<Scalars['String']['input']>;
  isPro: Scalars['Boolean']['input'];
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  trialEndDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HasPaymentPropertiesSort = {
  integrationId?: InputMaybe<SortDirection>;
  isPro?: InputMaybe<SortDirection>;
  last_modified?: InputMaybe<SortDirection>;
  stripeCustomerId?: InputMaybe<SortDirection>;
  stripeSubscriptionId?: InputMaybe<SortDirection>;
  trialEndDate?: InputMaybe<SortDirection>;
};

export type HasPaymentPropertiesUpdateInput = {
  integrationId?: InputMaybe<Scalars['String']['input']>;
  isPro?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  trialEndDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HasPaymentPropertiesWhere = {
  AND?: InputMaybe<Array<HasPaymentPropertiesWhere>>;
  NOT?: InputMaybe<HasPaymentPropertiesWhere>;
  OR?: InputMaybe<Array<HasPaymentPropertiesWhere>>;
  integrationId?: InputMaybe<Scalars['String']['input']>;
  integrationId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  integrationId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  integrationId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  integrationId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  isPro?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  last_modified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stripeCustomerId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stripeSubscriptionId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  trialEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  trialEndDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

/**
 * The edge properties for the following fields:
 * * Objective.userHasProgress
 */
export type HasProgressProperties = {
  __typename?: 'HasProgressProperties';
  ai_messages_count?: Maybe<Scalars['Int']['output']>;
  average_ai_response_time?: Maybe<Scalars['Float']['output']>;
  average_student_question_complexity?: Maybe<Scalars['String']['output']>;
  average_student_response_time?: Maybe<Scalars['Float']['output']>;
  confusion_points?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  created?: Maybe<Scalars['DateTime']['output']>;
  distractions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  further_recommendations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  last_modified?: Maybe<Scalars['DateTime']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  num_messages?: Maybe<Scalars['Int']['output']>;
  originality_analysis?: Maybe<Scalars['String']['output']>;
  questions_asked?: Maybe<Scalars['Int']['output']>;
  sentiment_analysis?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  student_messages_count?: Maybe<Scalars['Int']['output']>;
  success_points?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  summary?: Maybe<Scalars['String']['output']>;
  total_time_taken?: Maybe<Scalars['Float']['output']>;
};

export type HasProgressPropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<HasProgressPropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<HasProgressPropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<HasProgressPropertiesAggregationWhereInput>>;
  ai_messages_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ai_messages_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  ai_messages_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  ai_messages_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  ai_messages_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  ai_messages_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  average_ai_response_time_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  average_student_question_complexity_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  average_student_question_complexity_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  average_student_question_complexity_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  average_student_question_complexity_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  average_student_question_complexity_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  average_student_question_complexity_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  average_student_question_complexity_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  average_student_question_complexity_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  average_student_question_complexity_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  average_student_question_complexity_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  average_student_question_complexity_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  average_student_question_complexity_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  average_student_question_complexity_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  average_student_question_complexity_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  average_student_question_complexity_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  average_student_response_time_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  level_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  level_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  level_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  level_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  level_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  level_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  level_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  num_messages_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  num_messages_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  num_messages_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  num_messages_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  num_messages_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  num_messages_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  num_messages_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  num_messages_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  num_messages_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  num_messages_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  num_messages_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  num_messages_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  num_messages_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  num_messages_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  num_messages_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  num_messages_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  num_messages_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  num_messages_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  num_messages_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  num_messages_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  originality_analysis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  originality_analysis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  originality_analysis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  originality_analysis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  originality_analysis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  originality_analysis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  originality_analysis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  originality_analysis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  originality_analysis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  originality_analysis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  originality_analysis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  originality_analysis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  originality_analysis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  originality_analysis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  originality_analysis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  questions_asked_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  questions_asked_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  questions_asked_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  questions_asked_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  questions_asked_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  sentiment_analysis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sentiment_analysis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sentiment_analysis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sentiment_analysis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sentiment_analysis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sentiment_analysis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sentiment_analysis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sentiment_analysis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sentiment_analysis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sentiment_analysis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sentiment_analysis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sentiment_analysis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sentiment_analysis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sentiment_analysis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sentiment_analysis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  status_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  status_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  student_messages_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  student_messages_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  student_messages_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  student_messages_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  student_messages_count_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  summary_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  summary_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  total_time_taken_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type HasProgressPropertiesCreateInput = {
  ai_messages_count?: InputMaybe<Scalars['Int']['input']>;
  average_ai_response_time?: InputMaybe<Scalars['Float']['input']>;
  average_student_question_complexity?: InputMaybe<Scalars['String']['input']>;
  average_student_response_time?: InputMaybe<Scalars['Float']['input']>;
  confusion_points?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  distractions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  further_recommendations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  num_messages?: InputMaybe<Scalars['Int']['input']>;
  originality_analysis?: InputMaybe<Scalars['String']['input']>;
  questions_asked?: InputMaybe<Scalars['Int']['input']>;
  sentiment_analysis?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  student_messages_count?: InputMaybe<Scalars['Int']['input']>;
  success_points?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  summary?: InputMaybe<Scalars['String']['input']>;
  total_time_taken?: InputMaybe<Scalars['Float']['input']>;
};

export type HasProgressPropertiesSort = {
  ai_messages_count?: InputMaybe<SortDirection>;
  average_ai_response_time?: InputMaybe<SortDirection>;
  average_student_question_complexity?: InputMaybe<SortDirection>;
  average_student_response_time?: InputMaybe<SortDirection>;
  confusion_points?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  distractions?: InputMaybe<SortDirection>;
  further_recommendations?: InputMaybe<SortDirection>;
  last_modified?: InputMaybe<SortDirection>;
  level?: InputMaybe<SortDirection>;
  num_messages?: InputMaybe<SortDirection>;
  originality_analysis?: InputMaybe<SortDirection>;
  questions_asked?: InputMaybe<SortDirection>;
  sentiment_analysis?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  student_messages_count?: InputMaybe<SortDirection>;
  success_points?: InputMaybe<SortDirection>;
  summary?: InputMaybe<SortDirection>;
  total_time_taken?: InputMaybe<SortDirection>;
};

export type HasProgressPropertiesUpdateInput = {
  ai_messages_count?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  average_ai_response_time?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_ADD?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  average_student_question_complexity?: InputMaybe<Scalars['String']['input']>;
  average_student_response_time?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_ADD?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  confusion_points?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confusion_points_POP?: InputMaybe<Scalars['Int']['input']>;
  confusion_points_PUSH?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  distractions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  distractions_POP?: InputMaybe<Scalars['Int']['input']>;
  distractions_PUSH?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  further_recommendations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  further_recommendations_POP?: InputMaybe<Scalars['Int']['input']>;
  further_recommendations_PUSH?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  num_messages?: InputMaybe<Scalars['Int']['input']>;
  num_messages_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  num_messages_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  originality_analysis?: InputMaybe<Scalars['String']['input']>;
  questions_asked?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  sentiment_analysis?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  student_messages_count?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  success_points?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  success_points_POP?: InputMaybe<Scalars['Int']['input']>;
  success_points_PUSH?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  summary?: InputMaybe<Scalars['String']['input']>;
  total_time_taken?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_ADD?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
};

export type HasProgressPropertiesWhere = {
  AND?: InputMaybe<Array<HasProgressPropertiesWhere>>;
  NOT?: InputMaybe<HasProgressPropertiesWhere>;
  OR?: InputMaybe<Array<HasProgressPropertiesWhere>>;
  ai_messages_count?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_GT?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ai_messages_count_LT?: InputMaybe<Scalars['Int']['input']>;
  ai_messages_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  average_ai_response_time?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_GT?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_GTE?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  average_ai_response_time_LT?: InputMaybe<Scalars['Float']['input']>;
  average_ai_response_time_LTE?: InputMaybe<Scalars['Float']['input']>;
  average_student_question_complexity?: InputMaybe<Scalars['String']['input']>;
  average_student_question_complexity_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  average_student_question_complexity_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  average_student_question_complexity_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  average_student_question_complexity_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  average_student_response_time?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_GT?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_GTE?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  average_student_response_time_LT?: InputMaybe<Scalars['Float']['input']>;
  average_student_response_time_LTE?: InputMaybe<Scalars['Float']['input']>;
  confusion_points?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confusion_points_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  distractions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  distractions_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  further_recommendations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  further_recommendations_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  last_modified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  level_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  level_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  level_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  level_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  num_messages?: InputMaybe<Scalars['Int']['input']>;
  num_messages_GT?: InputMaybe<Scalars['Int']['input']>;
  num_messages_GTE?: InputMaybe<Scalars['Int']['input']>;
  num_messages_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  num_messages_LT?: InputMaybe<Scalars['Int']['input']>;
  num_messages_LTE?: InputMaybe<Scalars['Int']['input']>;
  originality_analysis?: InputMaybe<Scalars['String']['input']>;
  originality_analysis_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  originality_analysis_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  originality_analysis_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  originality_analysis_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  questions_asked?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_GT?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_GTE?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  questions_asked_LT?: InputMaybe<Scalars['Int']['input']>;
  questions_asked_LTE?: InputMaybe<Scalars['Int']['input']>;
  sentiment_analysis?: InputMaybe<Scalars['String']['input']>;
  sentiment_analysis_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  sentiment_analysis_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  sentiment_analysis_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sentiment_analysis_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  status_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  status_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  student_messages_count?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_GT?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_GTE?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  student_messages_count_LT?: InputMaybe<Scalars['Int']['input']>;
  student_messages_count_LTE?: InputMaybe<Scalars['Int']['input']>;
  success_points?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  success_points_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  summary_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  summary_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  summary_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  summary_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  total_time_taken?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_GT?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_GTE?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  total_time_taken_LT?: InputMaybe<Scalars['Float']['input']>;
  total_time_taken_LTE?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * The edge properties for the following fields:
 * * Rubric.question
 * * Rubric.submissions
 * * Question.rubrics
 * * AssessmentSubmission.rubrics
 */
export type HasRubricProperties = {
  __typename?: 'HasRubricProperties';
  aiPointsAwarded?: Maybe<Scalars['Float']['output']>;
  maxPoints?: Maybe<Scalars['Float']['output']>;
  pointsAwarded?: Maybe<Scalars['Float']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
};

export type HasRubricPropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<HasRubricPropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<HasRubricPropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<HasRubricPropertiesAggregationWhereInput>>;
  aiPointsAwarded_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiPointsAwarded_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aiPointsAwarded_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiPointsAwarded_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aiPointsAwarded_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aiPointsAwarded_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiPointsAwarded_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  aiPointsAwarded_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiPointsAwarded_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  aiPointsAwarded_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  aiPointsAwarded_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiPointsAwarded_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  aiPointsAwarded_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiPointsAwarded_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  aiPointsAwarded_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  aiPointsAwarded_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiPointsAwarded_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  aiPointsAwarded_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiPointsAwarded_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  aiPointsAwarded_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxPoints_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxPoints_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maxPoints_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxPoints_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maxPoints_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxPoints_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxPoints_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  maxPoints_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxPoints_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  maxPoints_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxPoints_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxPoints_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  maxPoints_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxPoints_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  maxPoints_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxPoints_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxPoints_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  maxPoints_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxPoints_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  maxPoints_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  remarks_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  remarks_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  remarks_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  remarks_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  remarks_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  remarks_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  remarks_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  remarks_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  remarks_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  remarks_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  remarks_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  remarks_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  remarks_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  remarks_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  remarks_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type HasRubricPropertiesCreateInput = {
  aiPointsAwarded?: InputMaybe<Scalars['Float']['input']>;
  maxPoints?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded?: InputMaybe<Scalars['Float']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
};

export type HasRubricPropertiesSort = {
  aiPointsAwarded?: InputMaybe<SortDirection>;
  maxPoints?: InputMaybe<SortDirection>;
  pointsAwarded?: InputMaybe<SortDirection>;
  remarks?: InputMaybe<SortDirection>;
};

export type HasRubricPropertiesUpdateInput = {
  aiPointsAwarded?: InputMaybe<Scalars['Float']['input']>;
  aiPointsAwarded_ADD?: InputMaybe<Scalars['Float']['input']>;
  aiPointsAwarded_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  aiPointsAwarded_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  aiPointsAwarded_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  maxPoints?: InputMaybe<Scalars['Float']['input']>;
  maxPoints_ADD?: InputMaybe<Scalars['Float']['input']>;
  maxPoints_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  maxPoints_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  maxPoints_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_ADD?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
};

export type HasRubricPropertiesWhere = {
  AND?: InputMaybe<Array<HasRubricPropertiesWhere>>;
  NOT?: InputMaybe<HasRubricPropertiesWhere>;
  OR?: InputMaybe<Array<HasRubricPropertiesWhere>>;
  aiPointsAwarded?: InputMaybe<Scalars['Float']['input']>;
  aiPointsAwarded_GT?: InputMaybe<Scalars['Float']['input']>;
  aiPointsAwarded_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiPointsAwarded_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  aiPointsAwarded_LT?: InputMaybe<Scalars['Float']['input']>;
  aiPointsAwarded_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxPoints?: InputMaybe<Scalars['Float']['input']>;
  maxPoints_GT?: InputMaybe<Scalars['Float']['input']>;
  maxPoints_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxPoints_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  maxPoints_LT?: InputMaybe<Scalars['Float']['input']>;
  maxPoints_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  pointsAwarded_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsAwarded_LTE?: InputMaybe<Scalars['Float']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  remarks_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  remarks_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  remarks_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  remarks_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The edge properties for the following fields:
 * * User.schoolAssignments
 * * Assignment.usersHasSchoolAssignment
 */
export type HasSchoolAssignmentProperties = {
  __typename?: 'HasSchoolAssignmentProperties';
  retakeAllowed?: Maybe<Scalars['Boolean']['output']>;
  retakeDeadline?: Maybe<Scalars['DateTime']['output']>;
};

export type HasSchoolAssignmentPropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<HasSchoolAssignmentPropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<HasSchoolAssignmentPropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<HasSchoolAssignmentPropertiesAggregationWhereInput>>;
  retakeDeadline_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  retakeDeadline_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  retakeDeadline_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  retakeDeadline_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  retakeDeadline_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  retakeDeadline_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  retakeDeadline_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  retakeDeadline_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  retakeDeadline_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  retakeDeadline_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HasSchoolAssignmentPropertiesCreateInput = {
  retakeAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  retakeDeadline?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HasSchoolAssignmentPropertiesSort = {
  retakeAllowed?: InputMaybe<SortDirection>;
  retakeDeadline?: InputMaybe<SortDirection>;
};

export type HasSchoolAssignmentPropertiesUpdateInput = {
  retakeAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  retakeDeadline?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HasSchoolAssignmentPropertiesWhere = {
  AND?: InputMaybe<Array<HasSchoolAssignmentPropertiesWhere>>;
  NOT?: InputMaybe<HasSchoolAssignmentPropertiesWhere>;
  OR?: InputMaybe<Array<HasSchoolAssignmentPropertiesWhere>>;
  retakeAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  retakeDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  retakeDeadline_GT?: InputMaybe<Scalars['DateTime']['input']>;
  retakeDeadline_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  retakeDeadline_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  retakeDeadline_LT?: InputMaybe<Scalars['DateTime']['input']>;
  retakeDeadline_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

/**
 * The edge properties for the following fields:
 * * User.schools
 * * School.users
 */
export type HasSchoolProperties = {
  __typename?: 'HasSchoolProperties';
  access_token?: Maybe<Scalars['String']['output']>;
  brightspace_user_id?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  expires_in?: Maybe<Scalars['Int']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['DateTime']['output']>;
  last_modified_token?: Maybe<Scalars['DateTime']['output']>;
  last_seen_at?: Maybe<Scalars['DateTime']['output']>;
  login_id?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  profile_id?: Maybe<Scalars['String']['output']>;
  refresh_token?: Maybe<Scalars['String']['output']>;
  school_id?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
};

export type HasSchoolPropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<HasSchoolPropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<HasSchoolPropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<HasSchoolPropertiesAggregationWhereInput>>;
  access_token_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  access_token_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  access_token_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  access_token_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  access_token_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  access_token_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  access_token_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  access_token_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  access_token_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  access_token_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  access_token_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  access_token_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  access_token_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  access_token_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  access_token_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_user_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  brightspace_user_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  brightspace_user_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  brightspace_user_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  brightspace_user_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  brightspace_user_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  brightspace_user_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_user_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_user_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_user_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_user_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  brightspace_user_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_user_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_user_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_user_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  domain_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domain_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  expires_in_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  expires_in_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  expires_in_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  expires_in_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  expires_in_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  expires_in_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  expires_in_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  expires_in_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  expires_in_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  expires_in_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  expires_in_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  expires_in_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  expires_in_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  expires_in_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  expires_in_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  expires_in_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  expires_in_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  expires_in_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  expires_in_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  expires_in_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_token_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_token_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_token_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_token_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_token_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_token_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_token_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_token_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_token_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_token_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_seen_at_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_seen_at_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_seen_at_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_seen_at_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_seen_at_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_seen_at_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_seen_at_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_seen_at_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_seen_at_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_seen_at_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  login_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  login_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  login_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  login_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  login_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  login_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  login_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  login_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  login_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  login_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  login_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  login_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  login_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  login_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  login_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  platform_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  platform_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  platform_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  platform_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  platform_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  platform_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  platform_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  platform_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  platform_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  platform_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  platform_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  platform_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  platform_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  platform_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  platform_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profile_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profile_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profile_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profile_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profile_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profile_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profile_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profile_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profile_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profile_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profile_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profile_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profile_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profile_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profile_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  refresh_token_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refresh_token_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  refresh_token_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  refresh_token_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  refresh_token_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  refresh_token_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refresh_token_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  refresh_token_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  refresh_token_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  refresh_token_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  refresh_token_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refresh_token_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  refresh_token_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  refresh_token_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  refresh_token_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  school_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  school_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  school_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  school_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  school_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  school_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  school_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  school_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  school_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  school_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  school_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  school_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  school_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  school_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  school_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  user_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  user_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  user_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  user_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  user_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  user_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  user_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  user_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  user_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  user_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  user_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  user_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  user_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  user_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  user_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  vendor_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  vendor_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  vendor_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  vendor_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  vendor_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  vendor_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vendor_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vendor_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vendor_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vendor_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  vendor_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  vendor_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  vendor_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  vendor_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  vendor_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type HasSchoolPropertiesCreateInput = {
  access_token?: InputMaybe<Scalars['String']['input']>;
  brightspace_user_id?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  expires_in?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_token?: InputMaybe<Scalars['DateTime']['input']>;
  last_seen_at?: InputMaybe<Scalars['DateTime']['input']>;
  login_id?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  profile_id?: InputMaybe<Scalars['String']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  school_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
};

export type HasSchoolPropertiesSort = {
  access_token?: InputMaybe<SortDirection>;
  brightspace_user_id?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  domain?: InputMaybe<SortDirection>;
  expires_in?: InputMaybe<SortDirection>;
  external_id?: InputMaybe<SortDirection>;
  last_modified?: InputMaybe<SortDirection>;
  last_modified_token?: InputMaybe<SortDirection>;
  last_seen_at?: InputMaybe<SortDirection>;
  login_id?: InputMaybe<SortDirection>;
  platform?: InputMaybe<SortDirection>;
  profile_id?: InputMaybe<SortDirection>;
  refresh_token?: InputMaybe<SortDirection>;
  school_id?: InputMaybe<SortDirection>;
  user_id?: InputMaybe<SortDirection>;
  vendor?: InputMaybe<SortDirection>;
};

export type HasSchoolPropertiesUpdateInput = {
  access_token?: InputMaybe<Scalars['String']['input']>;
  brightspace_user_id?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  expires_in?: InputMaybe<Scalars['Int']['input']>;
  expires_in_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  expires_in_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_token?: InputMaybe<Scalars['DateTime']['input']>;
  last_seen_at?: InputMaybe<Scalars['DateTime']['input']>;
  login_id?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  profile_id?: InputMaybe<Scalars['String']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  school_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
};

export type HasSchoolPropertiesWhere = {
  AND?: InputMaybe<Array<HasSchoolPropertiesWhere>>;
  NOT?: InputMaybe<HasSchoolPropertiesWhere>;
  OR?: InputMaybe<Array<HasSchoolPropertiesWhere>>;
  access_token?: InputMaybe<Scalars['String']['input']>;
  access_token_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  access_token_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  access_token_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  access_token_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  brightspace_user_id?: InputMaybe<Scalars['String']['input']>;
  brightspace_user_id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  brightspace_user_id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  brightspace_user_id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brightspace_user_id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  domain_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  domain_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  domain_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  domain_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  expires_in?: InputMaybe<Scalars['Int']['input']>;
  expires_in_GT?: InputMaybe<Scalars['Int']['input']>;
  expires_in_GTE?: InputMaybe<Scalars['Int']['input']>;
  expires_in_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  expires_in_LT?: InputMaybe<Scalars['Int']['input']>;
  expires_in_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  external_id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  external_id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  external_id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  last_modified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_token?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_token_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_token_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_token_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  last_modified_token_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_token_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_seen_at?: InputMaybe<Scalars['DateTime']['input']>;
  last_seen_at_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_seen_at_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_seen_at_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  last_seen_at_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_seen_at_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  login_id?: InputMaybe<Scalars['String']['input']>;
  login_id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  login_id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  login_id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  login_id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  platform_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  platform_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  platform_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  platform_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  profile_id?: InputMaybe<Scalars['String']['input']>;
  profile_id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  profile_id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  profile_id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  profile_id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  refresh_token_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  refresh_token_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  refresh_token_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refresh_token_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  school_id?: InputMaybe<Scalars['String']['input']>;
  school_id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  school_id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  school_id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  school_id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
  user_id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  user_id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  user_id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  user_id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
  vendor_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  vendor_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  vendor_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vendor_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The edge properties for the following fields:
 * * User.hasSessionDeviceSessions
 * * DeviceSession.usersHasSession
 */
export type HasSessionProperties = {
  __typename?: 'HasSessionProperties';
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  isActive: Scalars['Boolean']['output'];
};

export type HasSessionPropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<HasSessionPropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<HasSessionPropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<HasSessionPropertiesAggregationWhereInput>>;
  createdAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HasSessionPropertiesCreateInput = {
  createdAt: Scalars['DateTime']['input'];
  expiresAt: Scalars['DateTime']['input'];
  isActive: Scalars['Boolean']['input'];
};

export type HasSessionPropertiesSort = {
  createdAt?: InputMaybe<SortDirection>;
  expiresAt?: InputMaybe<SortDirection>;
  isActive?: InputMaybe<SortDirection>;
};

export type HasSessionPropertiesUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HasSessionPropertiesWhere = {
  AND?: InputMaybe<Array<HasSessionPropertiesWhere>>;
  NOT?: InputMaybe<HasSessionPropertiesWhere>;
  OR?: InputMaybe<Array<HasSessionPropertiesWhere>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  expiresAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * The edge properties for the following fields:
 * * User.todos
 * * Todo.usersHasTodo
 */
export type HasTodoProperties = {
  __typename?: 'HasTodoProperties';
  created?: Maybe<Scalars['DateTime']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isPositive?: Maybe<Scalars['Boolean']['output']>;
  isRelative?: Maybe<Scalars['Boolean']['output']>;
  last_modified?: Maybe<Scalars['DateTime']['output']>;
  quality?: Maybe<Scalars['BigInt']['output']>;
  strength?: Maybe<Scalars['BigInt']['output']>;
};

export type HasTodoPropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<HasTodoPropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<HasTodoPropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<HasTodoPropertiesAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  quality_AVERAGE_EQUAL?: InputMaybe<Scalars['BigInt']['input']>;
  quality_AVERAGE_GT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_AVERAGE_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  quality_AVERAGE_LT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_AVERAGE_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MAX_EQUAL?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MAX_GT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MAX_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MAX_LT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MAX_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MIN_EQUAL?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MIN_GT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MIN_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MIN_LT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MIN_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  quality_SUM_EQUAL?: InputMaybe<Scalars['BigInt']['input']>;
  quality_SUM_GT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_SUM_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  quality_SUM_LT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_SUM_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_AVERAGE_EQUAL?: InputMaybe<Scalars['BigInt']['input']>;
  strength_AVERAGE_GT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_AVERAGE_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_AVERAGE_LT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_AVERAGE_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MAX_EQUAL?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MAX_GT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MAX_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MAX_LT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MAX_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MIN_EQUAL?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MIN_GT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MIN_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MIN_LT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MIN_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_SUM_EQUAL?: InputMaybe<Scalars['BigInt']['input']>;
  strength_SUM_GT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_SUM_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_SUM_LT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_SUM_LTE?: InputMaybe<Scalars['BigInt']['input']>;
};

export type HasTodoPropertiesCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isPositive?: InputMaybe<Scalars['Boolean']['input']>;
  isRelative?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  quality?: InputMaybe<Scalars['BigInt']['input']>;
  strength?: InputMaybe<Scalars['BigInt']['input']>;
};

export type HasTodoPropertiesSort = {
  created?: InputMaybe<SortDirection>;
  isArchived?: InputMaybe<SortDirection>;
  isPositive?: InputMaybe<SortDirection>;
  isRelative?: InputMaybe<SortDirection>;
  last_modified?: InputMaybe<SortDirection>;
  quality?: InputMaybe<SortDirection>;
  strength?: InputMaybe<SortDirection>;
};

export type HasTodoPropertiesUpdateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isPositive?: InputMaybe<Scalars['Boolean']['input']>;
  isRelative?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  quality?: InputMaybe<Scalars['BigInt']['input']>;
  quality_DECREMENT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_INCREMENT?: InputMaybe<Scalars['BigInt']['input']>;
  strength?: InputMaybe<Scalars['BigInt']['input']>;
  strength_DECREMENT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_INCREMENT?: InputMaybe<Scalars['BigInt']['input']>;
};

export type HasTodoPropertiesWhere = {
  AND?: InputMaybe<Array<HasTodoPropertiesWhere>>;
  NOT?: InputMaybe<HasTodoPropertiesWhere>;
  OR?: InputMaybe<Array<HasTodoPropertiesWhere>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isPositive?: InputMaybe<Scalars['Boolean']['input']>;
  isRelative?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  last_modified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  quality?: InputMaybe<Scalars['BigInt']['input']>;
  quality_GT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  quality_IN?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
  quality_LT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength?: InputMaybe<Scalars['BigInt']['input']>;
  strength_GT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_IN?: InputMaybe<Array<InputMaybe<Scalars['BigInt']['input']>>>;
  strength_LT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_LTE?: InputMaybe<Scalars['BigInt']['input']>;
};

/**
 * The edge properties for the following fields:
 * * Objective.videos
 * * Video.objectiveHasVideos
 */
export type HasVideoProperties = {
  __typename?: 'HasVideoProperties';
  relevanceScore: Scalars['Float']['output'];
  timestamp: Scalars['Float']['output'];
};

export type HasVideoPropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<HasVideoPropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<HasVideoPropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<HasVideoPropertiesAggregationWhereInput>>;
  relevanceScore_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  relevanceScore_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  relevanceScore_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  relevanceScore_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  relevanceScore_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  relevanceScore_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  relevanceScore_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  relevanceScore_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  relevanceScore_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  relevanceScore_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  relevanceScore_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  relevanceScore_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  relevanceScore_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  relevanceScore_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  relevanceScore_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  relevanceScore_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  relevanceScore_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  relevanceScore_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  relevanceScore_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  relevanceScore_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  timestamp_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timestamp_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timestamp_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timestamp_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timestamp_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timestamp_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timestamp_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  timestamp_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  timestamp_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  timestamp_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  timestamp_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timestamp_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  timestamp_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  timestamp_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  timestamp_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  timestamp_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timestamp_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  timestamp_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  timestamp_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  timestamp_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type HasVideoPropertiesCreateInput = {
  relevanceScore: Scalars['Float']['input'];
  timestamp: Scalars['Float']['input'];
};

export type HasVideoPropertiesSort = {
  relevanceScore?: InputMaybe<SortDirection>;
  timestamp?: InputMaybe<SortDirection>;
};

export type HasVideoPropertiesUpdateInput = {
  relevanceScore?: InputMaybe<Scalars['Float']['input']>;
  relevanceScore_ADD?: InputMaybe<Scalars['Float']['input']>;
  relevanceScore_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  relevanceScore_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  relevanceScore_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  timestamp?: InputMaybe<Scalars['Float']['input']>;
  timestamp_ADD?: InputMaybe<Scalars['Float']['input']>;
  timestamp_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  timestamp_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  timestamp_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
};

export type HasVideoPropertiesWhere = {
  AND?: InputMaybe<Array<HasVideoPropertiesWhere>>;
  NOT?: InputMaybe<HasVideoPropertiesWhere>;
  OR?: InputMaybe<Array<HasVideoPropertiesWhere>>;
  relevanceScore?: InputMaybe<Scalars['Float']['input']>;
  relevanceScore_GT?: InputMaybe<Scalars['Float']['input']>;
  relevanceScore_GTE?: InputMaybe<Scalars['Float']['input']>;
  relevanceScore_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  relevanceScore_LT?: InputMaybe<Scalars['Float']['input']>;
  relevanceScore_LTE?: InputMaybe<Scalars['Float']['input']>;
  timestamp?: InputMaybe<Scalars['Float']['input']>;
  timestamp_GT?: InputMaybe<Scalars['Float']['input']>;
  timestamp_GTE?: InputMaybe<Scalars['Float']['input']>;
  timestamp_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  timestamp_LT?: InputMaybe<Scalars['Float']['input']>;
  timestamp_LTE?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * The edge properties for the following fields:
 * * User.hasWaterIntakeWaterIntakes
 * * WaterIntake.usersHasWaterIntake
 */
export type HasWaterIntakeProperties = {
  __typename?: 'HasWaterIntakeProperties';
  created: Scalars['DateTime']['output'];
  isArchived: Scalars['Boolean']['output'];
  isPositive?: Maybe<Scalars['Boolean']['output']>;
  last_modified: Scalars['DateTime']['output'];
  quality: Scalars['BigInt']['output'];
  strength: Scalars['BigInt']['output'];
};

export type HasWaterIntakePropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<HasWaterIntakePropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<HasWaterIntakePropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<HasWaterIntakePropertiesAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  quality_AVERAGE_EQUAL?: InputMaybe<Scalars['BigInt']['input']>;
  quality_AVERAGE_GT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_AVERAGE_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  quality_AVERAGE_LT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_AVERAGE_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MAX_EQUAL?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MAX_GT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MAX_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MAX_LT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MAX_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MIN_EQUAL?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MIN_GT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MIN_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MIN_LT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MIN_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  quality_SUM_EQUAL?: InputMaybe<Scalars['BigInt']['input']>;
  quality_SUM_GT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_SUM_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  quality_SUM_LT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_SUM_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_AVERAGE_EQUAL?: InputMaybe<Scalars['BigInt']['input']>;
  strength_AVERAGE_GT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_AVERAGE_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_AVERAGE_LT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_AVERAGE_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MAX_EQUAL?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MAX_GT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MAX_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MAX_LT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MAX_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MIN_EQUAL?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MIN_GT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MIN_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MIN_LT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MIN_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_SUM_EQUAL?: InputMaybe<Scalars['BigInt']['input']>;
  strength_SUM_GT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_SUM_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_SUM_LT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_SUM_LTE?: InputMaybe<Scalars['BigInt']['input']>;
};

export type HasWaterIntakePropertiesCreateInput = {
  created: Scalars['DateTime']['input'];
  isArchived: Scalars['Boolean']['input'];
  isPositive?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified: Scalars['DateTime']['input'];
  quality: Scalars['BigInt']['input'];
  strength: Scalars['BigInt']['input'];
};

export type HasWaterIntakePropertiesSort = {
  created?: InputMaybe<SortDirection>;
  isArchived?: InputMaybe<SortDirection>;
  isPositive?: InputMaybe<SortDirection>;
  last_modified?: InputMaybe<SortDirection>;
  quality?: InputMaybe<SortDirection>;
  strength?: InputMaybe<SortDirection>;
};

export type HasWaterIntakePropertiesUpdateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isPositive?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  quality?: InputMaybe<Scalars['BigInt']['input']>;
  quality_DECREMENT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_INCREMENT?: InputMaybe<Scalars['BigInt']['input']>;
  strength?: InputMaybe<Scalars['BigInt']['input']>;
  strength_DECREMENT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_INCREMENT?: InputMaybe<Scalars['BigInt']['input']>;
};

export type HasWaterIntakePropertiesWhere = {
  AND?: InputMaybe<Array<HasWaterIntakePropertiesWhere>>;
  NOT?: InputMaybe<HasWaterIntakePropertiesWhere>;
  OR?: InputMaybe<Array<HasWaterIntakePropertiesWhere>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isPositive?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  last_modified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  quality?: InputMaybe<Scalars['BigInt']['input']>;
  quality_GT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  quality_IN?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  quality_LT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength?: InputMaybe<Scalars['BigInt']['input']>;
  strength_GT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_IN?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  strength_LT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_LTE?: InputMaybe<Scalars['BigInt']['input']>;
};

export type Hierarchy = {
  __typename?: 'Hierarchy';
  completed?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  isRelevant: Scalars['Boolean']['output'];
  mastery: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  parentName: Scalars['String']['output'];
};

export type HierarchyActivity = {
  __typename?: 'HierarchyActivity';
  details?: Maybe<HierarchyActivityDetails>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  level: Scalars['String']['output'];
  parentCourse?: Maybe<ParentRef>;
  parentModule?: Maybe<ParentRef>;
};

export type HierarchyActivityDetails = {
  __typename?: 'HierarchyActivityDetails';
  objectives: Array<HierarchyObjective>;
};

export type HierarchyCourse = {
  __typename?: 'HierarchyCourse';
  details?: Maybe<HierarchyCourseDetails>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  level: Scalars['String']['output'];
};

export type HierarchyCourseDetails = {
  __typename?: 'HierarchyCourseDetails';
  modules: Array<HierarchyModule>;
};

export type HierarchyModule = {
  __typename?: 'HierarchyModule';
  details?: Maybe<HierarchyModuleDetails>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  level: Scalars['String']['output'];
  parentCourse?: Maybe<ParentRef>;
};

export type HierarchyModuleDetails = {
  __typename?: 'HierarchyModuleDetails';
  activities: Array<HierarchyActivity>;
};

export type HierarchyObjective = {
  __typename?: 'HierarchyObjective';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  level: Scalars['String']['output'];
  parentActivity?: Maybe<ParentRef>;
  parentCourse?: Maybe<ParentRef>;
  parentModule?: Maybe<ParentRef>;
};

export type Hobby = {
  __typename?: 'Hobby';
  category?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type IdAggregateSelection = {
  __typename?: 'IDAggregateSelection';
  longest?: Maybe<Scalars['ID']['output']>;
  shortest?: Maybe<Scalars['ID']['output']>;
};

export type IntAggregateSelection = {
  __typename?: 'IntAggregateSelection';
  average?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  sum?: Maybe<Scalars['Int']['output']>;
};

export type Interest = {
  __typename?: 'Interest';
  category?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type InviteCountResponse = {
  __typename?: 'InviteCountResponse';
  count: Scalars['Int']['output'];
};

export type InviteStudentUsers = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type InviteUserToSchoolInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

export type InviteUsersToEnrollInCourseInput = {
  courseId: Scalars['ID']['input'];
  users: Array<InviteStudentUsers>;
};

export type InviteUsersToEnrollInCourseResponse = {
  __typename?: 'InviteUsersToEnrollInCourseResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<InvitedUsers>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type InviteUsersToEnrollInDegreeInput = {
  degreeId: Scalars['ID']['input'];
  users: Array<InviteStudentUsers>;
};

export type InviteUsersToEnrollInDegreeResponse = {
  __typename?: 'InviteUsersToEnrollInDegreeResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<InvitedUsers>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type InvitedUsers = {
  __typename?: 'InvitedUsers';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type IsRoomDeletedResponse = {
  __typename?: 'IsRoomDeletedResponse';
  data?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type LlmStreamArtifactBlock = {
  __typename?: 'LLMStreamArtifactBlock';
  artifactId: Scalars['ID']['output'];
  artifactType: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type LlmStreamArtifactBlockWhere = {
  AND?: InputMaybe<Array<LlmStreamArtifactBlockWhere>>;
  NOT?: InputMaybe<LlmStreamArtifactBlockWhere>;
  OR?: InputMaybe<Array<LlmStreamArtifactBlockWhere>>;
  artifactId?: InputMaybe<Scalars['ID']['input']>;
  artifactId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  artifactId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  artifactId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  artifactId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  artifactType?: InputMaybe<Scalars['String']['input']>;
  artifactType_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  artifactType_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  artifactType_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  artifactType_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  type_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type LlmStreamArtifactCreatedEvent = {
  __typename?: 'LLMStreamArtifactCreatedEvent';
  artifact: Scalars['JSON']['output'];
  chatId: Scalars['ID']['output'];
  timestamp: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type LlmStreamArtifactCreatedEventWhere = {
  AND?: InputMaybe<Array<LlmStreamArtifactCreatedEventWhere>>;
  NOT?: InputMaybe<LlmStreamArtifactCreatedEventWhere>;
  OR?: InputMaybe<Array<LlmStreamArtifactCreatedEventWhere>>;
  artifact?: InputMaybe<Scalars['JSON']['input']>;
  artifact_IN?: InputMaybe<Array<Scalars['JSON']['input']>>;
  chatId?: InputMaybe<Scalars['ID']['input']>;
  chatId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  chatId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  chatId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  chatId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  timestamp?: InputMaybe<Scalars['String']['input']>;
  timestamp_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  timestamp_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  timestamp_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  timestamp_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  type_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type LlmStreamAudioSegmentEndEvent = {
  __typename?: 'LLMStreamAudioSegmentEndEvent';
  chatId: Scalars['ID']['output'];
  chunkIndex: Scalars['Int']['output'];
  messageId: Scalars['ID']['output'];
  timestamp: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type LlmStreamAudioSegmentEndEventWhere = {
  AND?: InputMaybe<Array<LlmStreamAudioSegmentEndEventWhere>>;
  NOT?: InputMaybe<LlmStreamAudioSegmentEndEventWhere>;
  OR?: InputMaybe<Array<LlmStreamAudioSegmentEndEventWhere>>;
  chatId?: InputMaybe<Scalars['ID']['input']>;
  chatId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  chatId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  chatId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  chatId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  chunkIndex?: InputMaybe<Scalars['Int']['input']>;
  chunkIndex_GT?: InputMaybe<Scalars['Int']['input']>;
  chunkIndex_GTE?: InputMaybe<Scalars['Int']['input']>;
  chunkIndex_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  chunkIndex_LT?: InputMaybe<Scalars['Int']['input']>;
  chunkIndex_LTE?: InputMaybe<Scalars['Int']['input']>;
  messageId?: InputMaybe<Scalars['ID']['input']>;
  messageId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  messageId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  messageId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  messageId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  timestamp?: InputMaybe<Scalars['String']['input']>;
  timestamp_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  timestamp_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  timestamp_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  timestamp_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  type_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type LlmStreamAudioSegmentStartEvent = {
  __typename?: 'LLMStreamAudioSegmentStartEvent';
  chatId: Scalars['ID']['output'];
  chunkIndex: Scalars['Int']['output'];
  messageId: Scalars['ID']['output'];
  timestamp: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type LlmStreamAudioSegmentStartEventWhere = {
  AND?: InputMaybe<Array<LlmStreamAudioSegmentStartEventWhere>>;
  NOT?: InputMaybe<LlmStreamAudioSegmentStartEventWhere>;
  OR?: InputMaybe<Array<LlmStreamAudioSegmentStartEventWhere>>;
  chatId?: InputMaybe<Scalars['ID']['input']>;
  chatId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  chatId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  chatId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  chatId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  chunkIndex?: InputMaybe<Scalars['Int']['input']>;
  chunkIndex_GT?: InputMaybe<Scalars['Int']['input']>;
  chunkIndex_GTE?: InputMaybe<Scalars['Int']['input']>;
  chunkIndex_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  chunkIndex_LT?: InputMaybe<Scalars['Int']['input']>;
  chunkIndex_LTE?: InputMaybe<Scalars['Int']['input']>;
  messageId?: InputMaybe<Scalars['ID']['input']>;
  messageId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  messageId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  messageId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  messageId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  timestamp?: InputMaybe<Scalars['String']['input']>;
  timestamp_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  timestamp_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  timestamp_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  timestamp_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  type_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type LlmStreamAudioSegmentTextEvent = {
  __typename?: 'LLMStreamAudioSegmentTextEvent';
  chatId: Scalars['ID']['output'];
  chunkIndex: Scalars['Int']['output'];
  messageId: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type LlmStreamAudioSegmentTextEventWhere = {
  AND?: InputMaybe<Array<LlmStreamAudioSegmentTextEventWhere>>;
  NOT?: InputMaybe<LlmStreamAudioSegmentTextEventWhere>;
  OR?: InputMaybe<Array<LlmStreamAudioSegmentTextEventWhere>>;
  chatId?: InputMaybe<Scalars['ID']['input']>;
  chatId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  chatId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  chatId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  chatId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  chunkIndex?: InputMaybe<Scalars['Int']['input']>;
  chunkIndex_GT?: InputMaybe<Scalars['Int']['input']>;
  chunkIndex_GTE?: InputMaybe<Scalars['Int']['input']>;
  chunkIndex_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  chunkIndex_LT?: InputMaybe<Scalars['Int']['input']>;
  chunkIndex_LTE?: InputMaybe<Scalars['Int']['input']>;
  messageId?: InputMaybe<Scalars['ID']['input']>;
  messageId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  messageId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  messageId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  messageId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  text_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  text_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  text_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['String']['input']>;
  timestamp_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  timestamp_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  timestamp_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  timestamp_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  type_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type LlmStreamChatRenamedEvent = {
  __typename?: 'LLMStreamChatRenamedEvent';
  chatId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type LlmStreamChatRenamedEventWhere = {
  AND?: InputMaybe<Array<LlmStreamChatRenamedEventWhere>>;
  NOT?: InputMaybe<LlmStreamChatRenamedEventWhere>;
  OR?: InputMaybe<Array<LlmStreamChatRenamedEventWhere>>;
  chatId?: InputMaybe<Scalars['ID']['input']>;
  chatId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  chatId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  chatId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  chatId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['String']['input']>;
  timestamp_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  timestamp_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  timestamp_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  timestamp_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  type_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type LlmStreamContentBlock = LlmStreamArtifactBlock | LlmStreamFileBlock | LlmStreamTextBlock;

export type LlmStreamContentBlockWhere = {
  LLMStreamArtifactBlock?: InputMaybe<LlmStreamArtifactBlockWhere>;
  LLMStreamFileBlock?: InputMaybe<LlmStreamFileBlockWhere>;
  LLMStreamTextBlock?: InputMaybe<LlmStreamTextBlockWhere>;
};

export type LlmStreamErrorEvent = {
  __typename?: 'LLMStreamErrorEvent';
  chatId: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  errorMessage: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type LlmStreamErrorEventWhere = {
  AND?: InputMaybe<Array<LlmStreamErrorEventWhere>>;
  NOT?: InputMaybe<LlmStreamErrorEventWhere>;
  OR?: InputMaybe<Array<LlmStreamErrorEventWhere>>;
  chatId?: InputMaybe<Scalars['ID']['input']>;
  chatId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  chatId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  chatId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  chatId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  code_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  code_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  code_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  code_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  errorMessage_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  errorMessage_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  errorMessage_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  errorMessage_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['String']['input']>;
  timestamp_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  timestamp_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  timestamp_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  timestamp_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  type_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type LlmStreamEvent = LlmStreamArtifactCreatedEvent | LlmStreamAudioSegmentEndEvent | LlmStreamAudioSegmentStartEvent | LlmStreamAudioSegmentTextEvent | LlmStreamChatRenamedEvent | LlmStreamErrorEvent | LlmStreamMessageCompletedEvent | LlmStreamMessageDeltaEvent;

export type LlmStreamEventWhere = {
  LLMStreamArtifactCreatedEvent?: InputMaybe<LlmStreamArtifactCreatedEventWhere>;
  LLMStreamAudioSegmentEndEvent?: InputMaybe<LlmStreamAudioSegmentEndEventWhere>;
  LLMStreamAudioSegmentStartEvent?: InputMaybe<LlmStreamAudioSegmentStartEventWhere>;
  LLMStreamAudioSegmentTextEvent?: InputMaybe<LlmStreamAudioSegmentTextEventWhere>;
  LLMStreamChatRenamedEvent?: InputMaybe<LlmStreamChatRenamedEventWhere>;
  LLMStreamErrorEvent?: InputMaybe<LlmStreamErrorEventWhere>;
  LLMStreamMessageCompletedEvent?: InputMaybe<LlmStreamMessageCompletedEventWhere>;
  LLMStreamMessageDeltaEvent?: InputMaybe<LlmStreamMessageDeltaEventWhere>;
};

export type LlmStreamFileBlock = {
  __typename?: 'LLMStreamFileBlock';
  displayName?: Maybe<Scalars['String']['output']>;
  fileId: Scalars['ID']['output'];
  purpose: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type LlmStreamFileBlockWhere = {
  AND?: InputMaybe<Array<LlmStreamFileBlockWhere>>;
  NOT?: InputMaybe<LlmStreamFileBlockWhere>;
  OR?: InputMaybe<Array<LlmStreamFileBlockWhere>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  displayName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  displayName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Scalars['ID']['input']>;
  fileId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  fileId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  fileId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  fileId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
  purpose_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  purpose_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  purpose_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  purpose_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  type_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type LlmStreamMessage = {
  __typename?: 'LLMStreamMessage';
  blocks: Array<LlmStreamContentBlock>;
  chatId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  parentId?: Maybe<Scalars['ID']['output']>;
  role: MessageRole;
};

export type LlmStreamMessageCompletedEvent = {
  __typename?: 'LLMStreamMessageCompletedEvent';
  chatId: Scalars['ID']['output'];
  message: LlmStreamMessage;
  timestamp: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type LlmStreamMessageCompletedEventWhere = {
  AND?: InputMaybe<Array<LlmStreamMessageCompletedEventWhere>>;
  NOT?: InputMaybe<LlmStreamMessageCompletedEventWhere>;
  OR?: InputMaybe<Array<LlmStreamMessageCompletedEventWhere>>;
  chatId?: InputMaybe<Scalars['ID']['input']>;
  chatId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  chatId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  chatId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  chatId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  timestamp?: InputMaybe<Scalars['String']['input']>;
  timestamp_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  timestamp_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  timestamp_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  timestamp_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  type_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type LlmStreamMessageDeltaEvent = {
  __typename?: 'LLMStreamMessageDeltaEvent';
  chatId: Scalars['ID']['output'];
  delta: LlmStreamContentBlock;
  isFinalChunk?: Maybe<Scalars['Boolean']['output']>;
  messageId: Scalars['ID']['output'];
  timestamp: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type LlmStreamMessageDeltaEventWhere = {
  AND?: InputMaybe<Array<LlmStreamMessageDeltaEventWhere>>;
  NOT?: InputMaybe<LlmStreamMessageDeltaEventWhere>;
  OR?: InputMaybe<Array<LlmStreamMessageDeltaEventWhere>>;
  chatId?: InputMaybe<Scalars['ID']['input']>;
  chatId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  chatId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  chatId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  chatId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isFinalChunk?: InputMaybe<Scalars['Boolean']['input']>;
  messageId?: InputMaybe<Scalars['ID']['input']>;
  messageId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  messageId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  messageId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  messageId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  timestamp?: InputMaybe<Scalars['String']['input']>;
  timestamp_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  timestamp_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  timestamp_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  timestamp_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  type_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type LlmStreamTextBlock = {
  __typename?: 'LLMStreamTextBlock';
  text: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type LlmStreamTextBlockWhere = {
  AND?: InputMaybe<Array<LlmStreamTextBlockWhere>>;
  NOT?: InputMaybe<LlmStreamTextBlockWhere>;
  OR?: InputMaybe<Array<LlmStreamTextBlockWhere>>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  text_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  text_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  text_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  type_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export enum LmsSource {
  Brightspace = 'BRIGHTSPACE',
  Canvas = 'CANVAS'
}

export type LastSeenPostData = {
  __typename?: 'LastSeenPostData';
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  lastSeenPostId?: Maybe<Scalars['String']['output']>;
  threadId: Scalars['String']['output'];
};

export type LastSeenPostResponse = {
  __typename?: 'LastSeenPostResponse';
  count: Scalars['Int']['output'];
  data?: Maybe<LastSeenPostData>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type LearningNode = {
  __typename?: 'LearningNode';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  mastery?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  unitsCount?: Maybe<Scalars['Int']['output']>;
};

export type LearningObjective = {
  __typename?: 'LearningObjective';
  completed?: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  hasChatChats: Array<Chat>;
  hasChatChatsAggregate?: Maybe<LearningObjectiveChatHasChatChatsAggregationSelection>;
  hasChatChatsConnection: LearningObjectiveHasChatChatsConnection;
  id: Scalars['ID']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  total_mastery?: Maybe<Scalars['Int']['output']>;
};


export type LearningObjectiveHasChatChatsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ChatOptions>;
  where?: InputMaybe<ChatWhere>;
};


export type LearningObjectiveHasChatChatsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ChatWhere>;
};


export type LearningObjectiveHasChatChatsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LearningObjectiveHasChatChatsConnectionSort>>;
  where?: InputMaybe<LearningObjectiveHasChatChatsConnectionWhere>;
};

export type LearningObjectiveChatHasChatChatsAggregationSelection = {
  __typename?: 'LearningObjectiveChatHasChatChatsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<LearningObjectiveChatHasChatChatsEdgeAggregateSelection>;
  node?: Maybe<LearningObjectiveChatHasChatChatsNodeAggregateSelection>;
};

export type LearningObjectiveChatHasChatChatsEdgeAggregateSelection = {
  __typename?: 'LearningObjectiveChatHasChatChatsEdgeAggregateSelection';
  ai_messages_count: IntAggregateSelection;
  average_ai_response_time: FloatAggregateSelection;
  average_student_response_time: FloatAggregateSelection;
  created: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  num_messages: IntAggregateSelection;
  questions_asked: IntAggregateSelection;
  student_messages_count: IntAggregateSelection;
  summary: StringAggregateSelection;
  total_time_taken: FloatAggregateSelection;
};

export type LearningObjectiveChatHasChatChatsNodeAggregateSelection = {
  __typename?: 'LearningObjectiveChatHasChatChatsNodeAggregateSelection';
  context: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  date: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  name: StringAggregateSelection;
  objectId: IdAggregateSelection;
  schemaVersion: IntAggregateSelection;
  timezone: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type LearningObjectiveConnectInput = {
  hasChatChats?: InputMaybe<Array<LearningObjectiveHasChatChatsConnectFieldInput>>;
};

export type LearningObjectiveConnectWhere = {
  node: LearningObjectiveWhere;
};

export type LearningObjectiveCreateInput = {
  completed?: InputMaybe<Scalars['Int']['input']>;
  description: Scalars['String']['input'];
  hasChatChats?: InputMaybe<LearningObjectiveHasChatChatsFieldInput>;
  id: Scalars['ID']['input'];
  index?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
  total_mastery?: InputMaybe<Scalars['Int']['input']>;
};

export type LearningObjectiveDeleteInput = {
  hasChatChats?: InputMaybe<Array<LearningObjectiveHasChatChatsDeleteFieldInput>>;
};

export type LearningObjectiveDisconnectInput = {
  hasChatChats?: InputMaybe<Array<LearningObjectiveHasChatChatsDisconnectFieldInput>>;
};

export type LearningObjectiveHasChatChatsAggregateInput = {
  AND?: InputMaybe<Array<LearningObjectiveHasChatChatsAggregateInput>>;
  NOT?: InputMaybe<LearningObjectiveHasChatChatsAggregateInput>;
  OR?: InputMaybe<Array<LearningObjectiveHasChatChatsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasChatPropertiesAggregationWhereInput>;
  node?: InputMaybe<LearningObjectiveHasChatChatsNodeAggregationWhereInput>;
};

export type LearningObjectiveHasChatChatsConnectFieldInput = {
  connect?: InputMaybe<Array<ChatConnectInput>>;
  edge?: InputMaybe<HasChatPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ChatConnectWhere>;
};

export type LearningObjectiveHasChatChatsConnectOrCreateFieldInput = {
  onCreate: LearningObjectiveHasChatChatsConnectOrCreateFieldInputOnCreate;
  where: ChatConnectOrCreateWhere;
};

export type LearningObjectiveHasChatChatsConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<HasChatPropertiesCreateInput>;
  node: ChatOnCreateInput;
};

export type LearningObjectiveHasChatChatsConnection = {
  __typename?: 'LearningObjectiveHasChatChatsConnection';
  edges: Array<LearningObjectiveHasChatChatsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LearningObjectiveHasChatChatsConnectionSort = {
  edge?: InputMaybe<HasChatPropertiesSort>;
  node?: InputMaybe<ChatSort>;
};

export type LearningObjectiveHasChatChatsConnectionWhere = {
  AND?: InputMaybe<Array<LearningObjectiveHasChatChatsConnectionWhere>>;
  NOT?: InputMaybe<LearningObjectiveHasChatChatsConnectionWhere>;
  OR?: InputMaybe<Array<LearningObjectiveHasChatChatsConnectionWhere>>;
  edge?: InputMaybe<HasChatPropertiesWhere>;
  node?: InputMaybe<ChatWhere>;
};

export type LearningObjectiveHasChatChatsCreateFieldInput = {
  edge?: InputMaybe<HasChatPropertiesCreateInput>;
  node: ChatCreateInput;
};

export type LearningObjectiveHasChatChatsDeleteFieldInput = {
  delete?: InputMaybe<ChatDeleteInput>;
  where?: InputMaybe<LearningObjectiveHasChatChatsConnectionWhere>;
};

export type LearningObjectiveHasChatChatsDisconnectFieldInput = {
  disconnect?: InputMaybe<ChatDisconnectInput>;
  where?: InputMaybe<LearningObjectiveHasChatChatsConnectionWhere>;
};

export type LearningObjectiveHasChatChatsFieldInput = {
  connect?: InputMaybe<Array<LearningObjectiveHasChatChatsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<LearningObjectiveHasChatChatsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<LearningObjectiveHasChatChatsCreateFieldInput>>;
};

export type LearningObjectiveHasChatChatsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LearningObjectiveHasChatChatsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LearningObjectiveHasChatChatsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LearningObjectiveHasChatChatsNodeAggregationWhereInput>>;
  context_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  context_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  schemaVersion_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  schemaVersion_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  schemaVersion_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  schemaVersion_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  schemaVersion_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type LearningObjectiveHasChatChatsRelationship = {
  __typename?: 'LearningObjectiveHasChatChatsRelationship';
  cursor: Scalars['String']['output'];
  node: Chat;
  properties: HasChatProperties;
};

export type LearningObjectiveHasChatChatsUpdateConnectionInput = {
  edge?: InputMaybe<HasChatPropertiesUpdateInput>;
  node?: InputMaybe<ChatUpdateInput>;
};

export type LearningObjectiveHasChatChatsUpdateFieldInput = {
  connect?: InputMaybe<Array<LearningObjectiveHasChatChatsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<LearningObjectiveHasChatChatsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<LearningObjectiveHasChatChatsCreateFieldInput>>;
  delete?: InputMaybe<Array<LearningObjectiveHasChatChatsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<LearningObjectiveHasChatChatsDisconnectFieldInput>>;
  update?: InputMaybe<LearningObjectiveHasChatChatsUpdateConnectionInput>;
  where?: InputMaybe<LearningObjectiveHasChatChatsConnectionWhere>;
};

export type LearningObjectiveOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more LearningObjectiveSort objects to sort LearningObjectives by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<LearningObjectiveSort>>;
};

export type LearningObjectiveResponse = {
  __typename?: 'LearningObjectiveResponse';
  completed?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

/** Fields to sort LearningObjectives by. The order in which sorts are applied is not guaranteed when specifying many fields in one LearningObjectiveSort object. */
export type LearningObjectiveSort = {
  completed?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  index?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  total_mastery?: InputMaybe<SortDirection>;
};

export type LearningObjectiveUpdateInput = {
  completed?: InputMaybe<Scalars['Int']['input']>;
  completed_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  completed_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hasChatChats?: InputMaybe<Array<LearningObjectiveHasChatChatsUpdateFieldInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  index_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  index_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  total_mastery?: InputMaybe<Scalars['Int']['input']>;
  total_mastery_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  total_mastery_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
};

export type LearningObjectiveWhere = {
  AND?: InputMaybe<Array<LearningObjectiveWhere>>;
  NOT?: InputMaybe<LearningObjectiveWhere>;
  OR?: InputMaybe<Array<LearningObjectiveWhere>>;
  completed?: InputMaybe<Scalars['Int']['input']>;
  completed_GT?: InputMaybe<Scalars['Int']['input']>;
  completed_GTE?: InputMaybe<Scalars['Int']['input']>;
  completed_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  completed_LT?: InputMaybe<Scalars['Int']['input']>;
  completed_LTE?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  hasChatChatsAggregate?: InputMaybe<LearningObjectiveHasChatChatsAggregateInput>;
  /** Return LearningObjectives where all of the related LearningObjectiveHasChatChatsConnections match this filter */
  hasChatChatsConnection_ALL?: InputMaybe<LearningObjectiveHasChatChatsConnectionWhere>;
  /** Return LearningObjectives where none of the related LearningObjectiveHasChatChatsConnections match this filter */
  hasChatChatsConnection_NONE?: InputMaybe<LearningObjectiveHasChatChatsConnectionWhere>;
  /** Return LearningObjectives where one of the related LearningObjectiveHasChatChatsConnections match this filter */
  hasChatChatsConnection_SINGLE?: InputMaybe<LearningObjectiveHasChatChatsConnectionWhere>;
  /** Return LearningObjectives where some of the related LearningObjectiveHasChatChatsConnections match this filter */
  hasChatChatsConnection_SOME?: InputMaybe<LearningObjectiveHasChatChatsConnectionWhere>;
  /** Return LearningObjectives where all of the related Chats match this filter */
  hasChatChats_ALL?: InputMaybe<ChatWhere>;
  /** Return LearningObjectives where none of the related Chats match this filter */
  hasChatChats_NONE?: InputMaybe<ChatWhere>;
  /** Return LearningObjectives where one of the related Chats match this filter */
  hasChatChats_SINGLE?: InputMaybe<ChatWhere>;
  /** Return LearningObjectives where some of the related Chats match this filter */
  hasChatChats_SOME?: InputMaybe<ChatWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  index_GT?: InputMaybe<Scalars['Int']['input']>;
  index_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  index_LT?: InputMaybe<Scalars['Int']['input']>;
  index_LTE?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  total_mastery?: InputMaybe<Scalars['Int']['input']>;
  total_mastery_GT?: InputMaybe<Scalars['Int']['input']>;
  total_mastery_GTE?: InputMaybe<Scalars['Int']['input']>;
  total_mastery_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  total_mastery_LT?: InputMaybe<Scalars['Int']['input']>;
  total_mastery_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type LearningPayment = {
  __typename?: 'LearningPayment';
  amount: Scalars['Float']['output'];
  course?: Maybe<Course>;
  courseAggregate?: Maybe<LearningPaymentCourseCourseAggregationSelection>;
  courseConnection: LearningPaymentCourseConnection;
  created: Scalars['DateTime']['output'];
  discountAmount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  promotionCode?: Maybe<Scalars['String']['output']>;
  users: Array<User>;
  usersAggregate?: Maybe<LearningPaymentUserUsersAggregationSelection>;
  usersConnection: LearningPaymentUsersConnection;
};


export type LearningPaymentCourseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CourseOptions>;
  where?: InputMaybe<CourseWhere>;
};


export type LearningPaymentCourseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CourseWhere>;
};


export type LearningPaymentCourseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LearningPaymentCourseConnectionSort>>;
  where?: InputMaybe<LearningPaymentCourseConnectionWhere>;
};


export type LearningPaymentUsersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type LearningPaymentUsersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type LearningPaymentUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LearningPaymentUsersConnectionSort>>;
  where?: InputMaybe<LearningPaymentUsersConnectionWhere>;
};

export type LearningPaymentConnectInput = {
  course?: InputMaybe<LearningPaymentCourseConnectFieldInput>;
  users?: InputMaybe<Array<LearningPaymentUsersConnectFieldInput>>;
};

export type LearningPaymentConnectOrCreateWhere = {
  node: LearningPaymentUniqueWhere;
};

export type LearningPaymentConnectWhere = {
  node: LearningPaymentWhere;
};

export type LearningPaymentCourseAggregateInput = {
  AND?: InputMaybe<Array<LearningPaymentCourseAggregateInput>>;
  NOT?: InputMaybe<LearningPaymentCourseAggregateInput>;
  OR?: InputMaybe<Array<LearningPaymentCourseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<LearningPaymentCourseNodeAggregationWhereInput>;
};

export type LearningPaymentCourseConnectFieldInput = {
  connect?: InputMaybe<CourseConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CourseConnectWhere>;
};

export type LearningPaymentCourseConnectOrCreateFieldInput = {
  onCreate: LearningPaymentCourseConnectOrCreateFieldInputOnCreate;
  where: CourseConnectOrCreateWhere;
};

export type LearningPaymentCourseConnectOrCreateFieldInputOnCreate = {
  node: CourseOnCreateInput;
};

export type LearningPaymentCourseConnection = {
  __typename?: 'LearningPaymentCourseConnection';
  edges: Array<LearningPaymentCourseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LearningPaymentCourseConnectionSort = {
  node?: InputMaybe<CourseSort>;
};

export type LearningPaymentCourseConnectionWhere = {
  AND?: InputMaybe<Array<LearningPaymentCourseConnectionWhere>>;
  NOT?: InputMaybe<LearningPaymentCourseConnectionWhere>;
  OR?: InputMaybe<Array<LearningPaymentCourseConnectionWhere>>;
  node?: InputMaybe<CourseWhere>;
};

export type LearningPaymentCourseCourseAggregationSelection = {
  __typename?: 'LearningPaymentCourseCourseAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<LearningPaymentCourseCourseNodeAggregateSelection>;
};

export type LearningPaymentCourseCourseNodeAggregateSelection = {
  __typename?: 'LearningPaymentCourseCourseNodeAggregateSelection';
  account_id: FloatAggregateSelection;
  calendar_ics: StringAggregateSelection;
  cost: FloatAggregateSelection;
  courseId: StringAggregateSelection;
  course_code: StringAggregateSelection;
  course_id: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  default_view: StringAggregateSelection;
  description: StringAggregateSelection;
  dueDateEndDate: DateTimeAggregateSelection;
  dueDateStartDate: DateTimeAggregateSelection;
  endDate: DateTimeAggregateSelection;
  end_at: StringAggregateSelection;
  enrollment_term_id: FloatAggregateSelection;
  grading_standard_id: FloatAggregateSelection;
  id: IdAggregateSelection;
  integration_id: StringAggregateSelection;
  label: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  learningStandards: StringAggregateSelection;
  lengthInWeeks: FloatAggregateSelection;
  license: StringAggregateSelection;
  lti_id: StringAggregateSelection;
  name: StringAggregateSelection;
  original_name: StringAggregateSelection;
  root_account_id: FloatAggregateSelection;
  sis_course_id: StringAggregateSelection;
  sis_import_id: FloatAggregateSelection;
  startDate: DateTimeAggregateSelection;
  start_at: StringAggregateSelection;
  state: StringAggregateSelection;
  storage_quota_mb: FloatAggregateSelection;
  stripePriceId: StringAggregateSelection;
  stripeProductId: StringAggregateSelection;
  targetAudience: StringAggregateSelection;
  thumbnail: StringAggregateSelection;
  time_zone: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  uuid: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export type LearningPaymentCourseCreateFieldInput = {
  node: CourseCreateInput;
};

export type LearningPaymentCourseDeleteFieldInput = {
  delete?: InputMaybe<CourseDeleteInput>;
  where?: InputMaybe<LearningPaymentCourseConnectionWhere>;
};

export type LearningPaymentCourseDisconnectFieldInput = {
  disconnect?: InputMaybe<CourseDisconnectInput>;
  where?: InputMaybe<LearningPaymentCourseConnectionWhere>;
};

export type LearningPaymentCourseFieldInput = {
  connect?: InputMaybe<LearningPaymentCourseConnectFieldInput>;
  connectOrCreate?: InputMaybe<LearningPaymentCourseConnectOrCreateFieldInput>;
  create?: InputMaybe<LearningPaymentCourseCreateFieldInput>;
};

export type LearningPaymentCourseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LearningPaymentCourseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LearningPaymentCourseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LearningPaymentCourseNodeAggregationWhereInput>>;
  account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  cost_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDateEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  enrollment_term_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  label_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningStandards_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthInWeeks_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  root_account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_import_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  startDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  storage_quota_mb_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type LearningPaymentCourseRelationship = {
  __typename?: 'LearningPaymentCourseRelationship';
  cursor: Scalars['String']['output'];
  node: Course;
};

export type LearningPaymentCourseUpdateConnectionInput = {
  node?: InputMaybe<CourseUpdateInput>;
};

export type LearningPaymentCourseUpdateFieldInput = {
  connect?: InputMaybe<LearningPaymentCourseConnectFieldInput>;
  connectOrCreate?: InputMaybe<LearningPaymentCourseConnectOrCreateFieldInput>;
  create?: InputMaybe<LearningPaymentCourseCreateFieldInput>;
  delete?: InputMaybe<LearningPaymentCourseDeleteFieldInput>;
  disconnect?: InputMaybe<LearningPaymentCourseDisconnectFieldInput>;
  update?: InputMaybe<LearningPaymentCourseUpdateConnectionInput>;
  where?: InputMaybe<LearningPaymentCourseConnectionWhere>;
};

export type LearningPaymentCreateInput = {
  amount: Scalars['Float']['input'];
  course?: InputMaybe<LearningPaymentCourseFieldInput>;
  created: Scalars['DateTime']['input'];
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  promotionCode?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<LearningPaymentUsersFieldInput>;
};

export type LearningPaymentDeleteInput = {
  course?: InputMaybe<LearningPaymentCourseDeleteFieldInput>;
  users?: InputMaybe<Array<LearningPaymentUsersDeleteFieldInput>>;
};

export type LearningPaymentDisconnectInput = {
  course?: InputMaybe<LearningPaymentCourseDisconnectFieldInput>;
  users?: InputMaybe<Array<LearningPaymentUsersDisconnectFieldInput>>;
};

export type LearningPaymentOnCreateInput = {
  amount: Scalars['Float']['input'];
  created: Scalars['DateTime']['input'];
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  promotionCode?: InputMaybe<Scalars['String']['input']>;
};

export type LearningPaymentOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more LearningPaymentSort objects to sort LearningPayments by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<LearningPaymentSort>>;
};

/** Fields to sort LearningPayments by. The order in which sorts are applied is not guaranteed when specifying many fields in one LearningPaymentSort object. */
export type LearningPaymentSort = {
  amount?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  discountAmount?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  promotionCode?: InputMaybe<SortDirection>;
};

export type LearningPaymentUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type LearningPaymentUpdateInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  amount_ADD?: InputMaybe<Scalars['Float']['input']>;
  amount_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  amount_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  amount_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  course?: InputMaybe<LearningPaymentCourseUpdateFieldInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_ADD?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  promotionCode?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<LearningPaymentUsersUpdateFieldInput>>;
};

export type LearningPaymentUserUsersAggregationSelection = {
  __typename?: 'LearningPaymentUserUsersAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<LearningPaymentUserUsersNodeAggregateSelection>;
};

export type LearningPaymentUserUsersNodeAggregateSelection = {
  __typename?: 'LearningPaymentUserUsersNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type LearningPaymentUsersAggregateInput = {
  AND?: InputMaybe<Array<LearningPaymentUsersAggregateInput>>;
  NOT?: InputMaybe<LearningPaymentUsersAggregateInput>;
  OR?: InputMaybe<Array<LearningPaymentUsersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<LearningPaymentUsersNodeAggregationWhereInput>;
};

export type LearningPaymentUsersConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type LearningPaymentUsersConnectOrCreateFieldInput = {
  onCreate: LearningPaymentUsersConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type LearningPaymentUsersConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type LearningPaymentUsersConnection = {
  __typename?: 'LearningPaymentUsersConnection';
  edges: Array<LearningPaymentUsersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LearningPaymentUsersConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type LearningPaymentUsersConnectionWhere = {
  AND?: InputMaybe<Array<LearningPaymentUsersConnectionWhere>>;
  NOT?: InputMaybe<LearningPaymentUsersConnectionWhere>;
  OR?: InputMaybe<Array<LearningPaymentUsersConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type LearningPaymentUsersCreateFieldInput = {
  node: UserCreateInput;
};

export type LearningPaymentUsersDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<LearningPaymentUsersConnectionWhere>;
};

export type LearningPaymentUsersDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<LearningPaymentUsersConnectionWhere>;
};

export type LearningPaymentUsersFieldInput = {
  connect?: InputMaybe<Array<LearningPaymentUsersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<LearningPaymentUsersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<LearningPaymentUsersCreateFieldInput>>;
};

export type LearningPaymentUsersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LearningPaymentUsersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<LearningPaymentUsersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LearningPaymentUsersNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type LearningPaymentUsersRelationship = {
  __typename?: 'LearningPaymentUsersRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type LearningPaymentUsersUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type LearningPaymentUsersUpdateFieldInput = {
  connect?: InputMaybe<Array<LearningPaymentUsersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<LearningPaymentUsersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<LearningPaymentUsersCreateFieldInput>>;
  delete?: InputMaybe<Array<LearningPaymentUsersDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<LearningPaymentUsersDisconnectFieldInput>>;
  update?: InputMaybe<LearningPaymentUsersUpdateConnectionInput>;
  where?: InputMaybe<LearningPaymentUsersConnectionWhere>;
};

export type LearningPaymentWhere = {
  AND?: InputMaybe<Array<LearningPaymentWhere>>;
  NOT?: InputMaybe<LearningPaymentWhere>;
  OR?: InputMaybe<Array<LearningPaymentWhere>>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  amount_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  amount_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_LTE?: InputMaybe<Scalars['Float']['input']>;
  course?: InputMaybe<CourseWhere>;
  courseAggregate?: InputMaybe<LearningPaymentCourseAggregateInput>;
  courseConnection?: InputMaybe<LearningPaymentCourseConnectionWhere>;
  courseConnection_NOT?: InputMaybe<LearningPaymentCourseConnectionWhere>;
  course_NOT?: InputMaybe<CourseWhere>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  discountAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  promotionCode?: InputMaybe<Scalars['String']['input']>;
  promotionCode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  promotionCode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  promotionCode_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promotionCode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  usersAggregate?: InputMaybe<LearningPaymentUsersAggregateInput>;
  /** Return LearningPayments where all of the related LearningPaymentUsersConnections match this filter */
  usersConnection_ALL?: InputMaybe<LearningPaymentUsersConnectionWhere>;
  /** Return LearningPayments where none of the related LearningPaymentUsersConnections match this filter */
  usersConnection_NONE?: InputMaybe<LearningPaymentUsersConnectionWhere>;
  /** Return LearningPayments where one of the related LearningPaymentUsersConnections match this filter */
  usersConnection_SINGLE?: InputMaybe<LearningPaymentUsersConnectionWhere>;
  /** Return LearningPayments where some of the related LearningPaymentUsersConnections match this filter */
  usersConnection_SOME?: InputMaybe<LearningPaymentUsersConnectionWhere>;
  /** Return LearningPayments where all of the related Users match this filter */
  users_ALL?: InputMaybe<UserWhere>;
  /** Return LearningPayments where none of the related Users match this filter */
  users_NONE?: InputMaybe<UserWhere>;
  /** Return LearningPayments where one of the related Users match this filter */
  users_SINGLE?: InputMaybe<UserWhere>;
  /** Return LearningPayments where some of the related Users match this filter */
  users_SOME?: InputMaybe<UserWhere>;
};

export type LearningTree = {
  __typename?: 'LearningTree';
  ChapterName?: Maybe<Scalars['String']['output']>;
  FieldName?: Maybe<Scalars['String']['output']>;
  SubchapterName?: Maybe<Scalars['String']['output']>;
  SubfieldName?: Maybe<Scalars['String']['output']>;
  TopicName?: Maybe<Scalars['String']['output']>;
};

export type LearningTtsTokenPayload = {
  __typename?: 'LearningTtsTokenPayload';
  token: Scalars['String']['output'];
};

export type Lesson = {
  __typename?: 'Lesson';
  category?: Maybe<Scalars['String']['output']>;
  completionStatus?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  difficultyLevel?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type LessonPlanStatus = {
  __typename?: 'LessonPlanStatus';
  hasLessonPlan: Scalars['Boolean']['output'];
  isGenerating: Scalars['Boolean']['output'];
  lessonPlanFile?: Maybe<File>;
  moduleId: Scalars['ID']['output'];
  moduleTitle: Scalars['String']['output'];
};

export type LessonPlanStatusResponse = {
  __typename?: 'LessonPlanStatusResponse';
  data?: Maybe<LessonPlanStatus>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type LevelDetails = {
  __typename?: 'LevelDetails';
  currentXP: Scalars['Int']['output'];
  level: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  progressPercentage: Scalars['Int']['output'];
  startingXPForCurrentLevel: Scalars['Int']['output'];
  xpToNextLevel: Scalars['Int']['output'];
};

export type LifeAspiration = {
  __typename?: 'LifeAspiration';
  category?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type LimitedVisitSession = {
  __typename?: 'LimitedVisitSession';
  ended: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastActiveTime: Scalars['DateTime']['output'];
  pageVisitsCount: Scalars['Int']['output'];
  startTime: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
  userName: Scalars['String']['output'];
};

export type MarkAnnouncementSeenResponse = {
  __typename?: 'MarkAnnouncementSeenResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type MasteryResult = {
  __typename?: 'MasteryResult';
  learningObjectiveId?: Maybe<Scalars['ID']['output']>;
  totalMastery?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type McqAnswerDetail = {
  __typename?: 'McqAnswerDetail';
  choices: Array<Scalars['String']['output']>;
  correctChoiceIndices: Array<Scalars['Int']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCorrect: Scalars['Boolean']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  pointsAwarded: Scalars['Float']['output'];
  question: Scalars['String']['output'];
  selectedChoiceIndices?: Maybe<Array<Scalars['Int']['output']>>;
  totalScore?: Maybe<Scalars['Float']['output']>;
};

export type McqQuestion = {
  __typename?: 'McqQuestion';
  aiTutor?: Maybe<AiTutor>;
  aiTutorAggregate?: Maybe<McqQuestionAiTutorAiTutorAggregationSelection>;
  aiTutorConnection: McqQuestionAiTutorConnection;
  assessments: Array<Assessment>;
  assessmentsAggregate?: Maybe<McqQuestionAssessmentAssessmentsAggregationSelection>;
  assessmentsConnection: McqQuestionAssessmentsConnection;
  choices: Array<Scalars['String']['output']>;
  correctChoiceIndices: Array<Scalars['Int']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  question: Scalars['String']['output'];
  replaces?: Maybe<McqQuestion>;
  replacesAggregate?: Maybe<McqQuestionMcqQuestionReplacesAggregationSelection>;
  replacesConnection: McqQuestionReplacesConnection;
  totalScore?: Maybe<Scalars['Float']['output']>;
};


export type McqQuestionAiTutorArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AiTutorOptions>;
  where?: InputMaybe<AiTutorWhere>;
};


export type McqQuestionAiTutorAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AiTutorWhere>;
};


export type McqQuestionAiTutorConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<McqQuestionAiTutorConnectionSort>>;
  where?: InputMaybe<McqQuestionAiTutorConnectionWhere>;
};


export type McqQuestionAssessmentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AssessmentOptions>;
  where?: InputMaybe<AssessmentWhere>;
};


export type McqQuestionAssessmentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssessmentWhere>;
};


export type McqQuestionAssessmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<McqQuestionAssessmentsConnectionSort>>;
  where?: InputMaybe<McqQuestionAssessmentsConnectionWhere>;
};


export type McqQuestionReplacesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<McqQuestionOptions>;
  where?: InputMaybe<McqQuestionWhere>;
};


export type McqQuestionReplacesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<McqQuestionWhere>;
};


export type McqQuestionReplacesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<McqQuestionReplacesConnectionSort>>;
  where?: InputMaybe<McqQuestionReplacesConnectionWhere>;
};

export type McqQuestionAiTutorAiTutorAggregationSelection = {
  __typename?: 'McqQuestionAITutorAiTutorAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<McqQuestionAiTutorAiTutorNodeAggregateSelection>;
};

export type McqQuestionAiTutorAiTutorNodeAggregateSelection = {
  __typename?: 'McqQuestionAITutorAiTutorNodeAggregateSelection';
  context: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  targetAudience: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type McqQuestionAiTutorAggregateInput = {
  AND?: InputMaybe<Array<McqQuestionAiTutorAggregateInput>>;
  NOT?: InputMaybe<McqQuestionAiTutorAggregateInput>;
  OR?: InputMaybe<Array<McqQuestionAiTutorAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<McqQuestionAiTutorNodeAggregationWhereInput>;
};

export type McqQuestionAiTutorConnectFieldInput = {
  connect?: InputMaybe<AiTutorConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AiTutorConnectWhere>;
};

export type McqQuestionAiTutorConnectOrCreateFieldInput = {
  onCreate: McqQuestionAiTutorConnectOrCreateFieldInputOnCreate;
  where: AiTutorConnectOrCreateWhere;
};

export type McqQuestionAiTutorConnectOrCreateFieldInputOnCreate = {
  node: AiTutorOnCreateInput;
};

export type McqQuestionAiTutorConnection = {
  __typename?: 'McqQuestionAiTutorConnection';
  edges: Array<McqQuestionAiTutorRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type McqQuestionAiTutorConnectionSort = {
  node?: InputMaybe<AiTutorSort>;
};

export type McqQuestionAiTutorConnectionWhere = {
  AND?: InputMaybe<Array<McqQuestionAiTutorConnectionWhere>>;
  NOT?: InputMaybe<McqQuestionAiTutorConnectionWhere>;
  OR?: InputMaybe<Array<McqQuestionAiTutorConnectionWhere>>;
  node?: InputMaybe<AiTutorWhere>;
};

export type McqQuestionAiTutorCreateFieldInput = {
  node: AiTutorCreateInput;
};

export type McqQuestionAiTutorDeleteFieldInput = {
  delete?: InputMaybe<AiTutorDeleteInput>;
  where?: InputMaybe<McqQuestionAiTutorConnectionWhere>;
};

export type McqQuestionAiTutorDisconnectFieldInput = {
  disconnect?: InputMaybe<AiTutorDisconnectInput>;
  where?: InputMaybe<McqQuestionAiTutorConnectionWhere>;
};

export type McqQuestionAiTutorFieldInput = {
  connect?: InputMaybe<McqQuestionAiTutorConnectFieldInput>;
  connectOrCreate?: InputMaybe<McqQuestionAiTutorConnectOrCreateFieldInput>;
  create?: InputMaybe<McqQuestionAiTutorCreateFieldInput>;
};

export type McqQuestionAiTutorNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<McqQuestionAiTutorNodeAggregationWhereInput>>;
  NOT?: InputMaybe<McqQuestionAiTutorNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<McqQuestionAiTutorNodeAggregationWhereInput>>;
  context_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  context_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type McqQuestionAiTutorRelationship = {
  __typename?: 'McqQuestionAiTutorRelationship';
  cursor: Scalars['String']['output'];
  node: AiTutor;
};

export type McqQuestionAiTutorUpdateConnectionInput = {
  node?: InputMaybe<AiTutorUpdateInput>;
};

export type McqQuestionAiTutorUpdateFieldInput = {
  connect?: InputMaybe<McqQuestionAiTutorConnectFieldInput>;
  connectOrCreate?: InputMaybe<McqQuestionAiTutorConnectOrCreateFieldInput>;
  create?: InputMaybe<McqQuestionAiTutorCreateFieldInput>;
  delete?: InputMaybe<McqQuestionAiTutorDeleteFieldInput>;
  disconnect?: InputMaybe<McqQuestionAiTutorDisconnectFieldInput>;
  update?: InputMaybe<McqQuestionAiTutorUpdateConnectionInput>;
  where?: InputMaybe<McqQuestionAiTutorConnectionWhere>;
};

export type McqQuestionAssessmentAssessmentsAggregationSelection = {
  __typename?: 'McqQuestionAssessmentAssessmentsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<McqQuestionAssessmentAssessmentsNodeAggregateSelection>;
};

export type McqQuestionAssessmentAssessmentsNodeAggregateSelection = {
  __typename?: 'McqQuestionAssessmentAssessmentsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  numberOfQuestions: IntAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  timeLimit: IntAggregateSelection;
};

export type McqQuestionAssessmentsAggregateInput = {
  AND?: InputMaybe<Array<McqQuestionAssessmentsAggregateInput>>;
  NOT?: InputMaybe<McqQuestionAssessmentsAggregateInput>;
  OR?: InputMaybe<Array<McqQuestionAssessmentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<McqQuestionAssessmentsNodeAggregationWhereInput>;
};

export type McqQuestionAssessmentsConnectFieldInput = {
  connect?: InputMaybe<Array<AssessmentConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AssessmentConnectWhere>;
};

export type McqQuestionAssessmentsConnectOrCreateFieldInput = {
  onCreate: McqQuestionAssessmentsConnectOrCreateFieldInputOnCreate;
  where: AssessmentConnectOrCreateWhere;
};

export type McqQuestionAssessmentsConnectOrCreateFieldInputOnCreate = {
  node: AssessmentOnCreateInput;
};

export type McqQuestionAssessmentsConnection = {
  __typename?: 'McqQuestionAssessmentsConnection';
  edges: Array<McqQuestionAssessmentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type McqQuestionAssessmentsConnectionSort = {
  node?: InputMaybe<AssessmentSort>;
};

export type McqQuestionAssessmentsConnectionWhere = {
  AND?: InputMaybe<Array<McqQuestionAssessmentsConnectionWhere>>;
  NOT?: InputMaybe<McqQuestionAssessmentsConnectionWhere>;
  OR?: InputMaybe<Array<McqQuestionAssessmentsConnectionWhere>>;
  node?: InputMaybe<AssessmentWhere>;
};

export type McqQuestionAssessmentsCreateFieldInput = {
  node: AssessmentCreateInput;
};

export type McqQuestionAssessmentsDeleteFieldInput = {
  delete?: InputMaybe<AssessmentDeleteInput>;
  where?: InputMaybe<McqQuestionAssessmentsConnectionWhere>;
};

export type McqQuestionAssessmentsDisconnectFieldInput = {
  disconnect?: InputMaybe<AssessmentDisconnectInput>;
  where?: InputMaybe<McqQuestionAssessmentsConnectionWhere>;
};

export type McqQuestionAssessmentsFieldInput = {
  connect?: InputMaybe<Array<McqQuestionAssessmentsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<McqQuestionAssessmentsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<McqQuestionAssessmentsCreateFieldInput>>;
};

export type McqQuestionAssessmentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<McqQuestionAssessmentsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<McqQuestionAssessmentsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<McqQuestionAssessmentsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfQuestions_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  timeLimit_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type McqQuestionAssessmentsRelationship = {
  __typename?: 'McqQuestionAssessmentsRelationship';
  cursor: Scalars['String']['output'];
  node: Assessment;
};

export type McqQuestionAssessmentsUpdateConnectionInput = {
  node?: InputMaybe<AssessmentUpdateInput>;
};

export type McqQuestionAssessmentsUpdateFieldInput = {
  connect?: InputMaybe<Array<McqQuestionAssessmentsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<McqQuestionAssessmentsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<McqQuestionAssessmentsCreateFieldInput>>;
  delete?: InputMaybe<Array<McqQuestionAssessmentsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<McqQuestionAssessmentsDisconnectFieldInput>>;
  update?: InputMaybe<McqQuestionAssessmentsUpdateConnectionInput>;
  where?: InputMaybe<McqQuestionAssessmentsConnectionWhere>;
};

export type McqQuestionConnectInput = {
  aiTutor?: InputMaybe<McqQuestionAiTutorConnectFieldInput>;
  assessments?: InputMaybe<Array<McqQuestionAssessmentsConnectFieldInput>>;
  replaces?: InputMaybe<McqQuestionReplacesConnectFieldInput>;
};

export type McqQuestionConnectOrCreateWhere = {
  node: McqQuestionUniqueWhere;
};

export type McqQuestionConnectWhere = {
  node: McqQuestionWhere;
};

export type McqQuestionCreateInput = {
  aiTutor?: InputMaybe<McqQuestionAiTutorFieldInput>;
  assessments?: InputMaybe<McqQuestionAssessmentsFieldInput>;
  choices: Array<Scalars['String']['input']>;
  correctChoiceIndices: Array<Scalars['Int']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  explanation?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  question: Scalars['String']['input'];
  replaces?: InputMaybe<McqQuestionReplacesFieldInput>;
  totalScore?: InputMaybe<Scalars['Float']['input']>;
};

export type McqQuestionDeleteInput = {
  aiTutor?: InputMaybe<McqQuestionAiTutorDeleteFieldInput>;
  assessments?: InputMaybe<Array<McqQuestionAssessmentsDeleteFieldInput>>;
  replaces?: InputMaybe<McqQuestionReplacesDeleteFieldInput>;
};

export type McqQuestionDisconnectInput = {
  aiTutor?: InputMaybe<McqQuestionAiTutorDisconnectFieldInput>;
  assessments?: InputMaybe<Array<McqQuestionAssessmentsDisconnectFieldInput>>;
  replaces?: InputMaybe<McqQuestionReplacesDisconnectFieldInput>;
};

export type McqQuestionListResponse = {
  __typename?: 'McqQuestionListResponse';
  count: Scalars['Int']['output'];
  data: Array<McqQuestion>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type McqQuestionMcqQuestionReplacesAggregationSelection = {
  __typename?: 'McqQuestionMcqQuestionReplacesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<McqQuestionMcqQuestionReplacesEdgeAggregateSelection>;
  node?: Maybe<McqQuestionMcqQuestionReplacesNodeAggregateSelection>;
};

export type McqQuestionMcqQuestionReplacesEdgeAggregateSelection = {
  __typename?: 'McqQuestionMcqQuestionReplacesEdgeAggregateSelection';
  assessmentId: IdAggregateSelection;
};

export type McqQuestionMcqQuestionReplacesNodeAggregateSelection = {
  __typename?: 'McqQuestionMcqQuestionReplacesNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  explanation: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  order: IntAggregateSelection;
  question: StringAggregateSelection;
  totalScore: FloatAggregateSelection;
};

export type McqQuestionOnCreateInput = {
  choices: Array<Scalars['String']['input']>;
  correctChoiceIndices: Array<Scalars['Int']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  explanation?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  question: Scalars['String']['input'];
  totalScore?: InputMaybe<Scalars['Float']['input']>;
};

export type McqQuestionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more McqQuestionSort objects to sort McqQuestions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<McqQuestionSort>>;
};

export type McqQuestionReplacesAggregateInput = {
  AND?: InputMaybe<Array<McqQuestionReplacesAggregateInput>>;
  NOT?: InputMaybe<McqQuestionReplacesAggregateInput>;
  OR?: InputMaybe<Array<McqQuestionReplacesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<ReplacesPropertiesAggregationWhereInput>;
  node?: InputMaybe<McqQuestionReplacesNodeAggregationWhereInput>;
};

export type McqQuestionReplacesConnectFieldInput = {
  connect?: InputMaybe<McqQuestionConnectInput>;
  edge?: InputMaybe<ReplacesPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<McqQuestionConnectWhere>;
};

export type McqQuestionReplacesConnectOrCreateFieldInput = {
  onCreate: McqQuestionReplacesConnectOrCreateFieldInputOnCreate;
  where: McqQuestionConnectOrCreateWhere;
};

export type McqQuestionReplacesConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<ReplacesPropertiesCreateInput>;
  node: McqQuestionOnCreateInput;
};

export type McqQuestionReplacesConnection = {
  __typename?: 'McqQuestionReplacesConnection';
  edges: Array<McqQuestionReplacesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type McqQuestionReplacesConnectionSort = {
  edge?: InputMaybe<ReplacesPropertiesSort>;
  node?: InputMaybe<McqQuestionSort>;
};

export type McqQuestionReplacesConnectionWhere = {
  AND?: InputMaybe<Array<McqQuestionReplacesConnectionWhere>>;
  NOT?: InputMaybe<McqQuestionReplacesConnectionWhere>;
  OR?: InputMaybe<Array<McqQuestionReplacesConnectionWhere>>;
  edge?: InputMaybe<ReplacesPropertiesWhere>;
  node?: InputMaybe<McqQuestionWhere>;
};

export type McqQuestionReplacesCreateFieldInput = {
  edge?: InputMaybe<ReplacesPropertiesCreateInput>;
  node: McqQuestionCreateInput;
};

export type McqQuestionReplacesDeleteFieldInput = {
  delete?: InputMaybe<McqQuestionDeleteInput>;
  where?: InputMaybe<McqQuestionReplacesConnectionWhere>;
};

export type McqQuestionReplacesDisconnectFieldInput = {
  disconnect?: InputMaybe<McqQuestionDisconnectInput>;
  where?: InputMaybe<McqQuestionReplacesConnectionWhere>;
};

export type McqQuestionReplacesFieldInput = {
  connect?: InputMaybe<McqQuestionReplacesConnectFieldInput>;
  connectOrCreate?: InputMaybe<McqQuestionReplacesConnectOrCreateFieldInput>;
  create?: InputMaybe<McqQuestionReplacesCreateFieldInput>;
};

export type McqQuestionReplacesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<McqQuestionReplacesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<McqQuestionReplacesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<McqQuestionReplacesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  explanation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  explanation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  explanation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  explanation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  explanation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  explanation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  explanation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  explanation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  explanation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  explanation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  explanation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  explanation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  explanation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  explanation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  explanation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  question_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  question_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalScore_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type McqQuestionReplacesRelationship = {
  __typename?: 'McqQuestionReplacesRelationship';
  cursor: Scalars['String']['output'];
  node: McqQuestion;
  properties: ReplacesProperties;
};

export type McqQuestionReplacesUpdateConnectionInput = {
  edge?: InputMaybe<ReplacesPropertiesUpdateInput>;
  node?: InputMaybe<McqQuestionUpdateInput>;
};

export type McqQuestionReplacesUpdateFieldInput = {
  connect?: InputMaybe<McqQuestionReplacesConnectFieldInput>;
  connectOrCreate?: InputMaybe<McqQuestionReplacesConnectOrCreateFieldInput>;
  create?: InputMaybe<McqQuestionReplacesCreateFieldInput>;
  delete?: InputMaybe<McqQuestionReplacesDeleteFieldInput>;
  disconnect?: InputMaybe<McqQuestionReplacesDisconnectFieldInput>;
  update?: InputMaybe<McqQuestionReplacesUpdateConnectionInput>;
  where?: InputMaybe<McqQuestionReplacesConnectionWhere>;
};

export type McqQuestionResponse = {
  __typename?: 'McqQuestionResponse';
  count: Scalars['Int']['output'];
  data?: Maybe<McqQuestion>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Fields to sort McqQuestions by. The order in which sorts are applied is not guaranteed when specifying many fields in one McqQuestionSort object. */
export type McqQuestionSort = {
  created?: InputMaybe<SortDirection>;
  explanation?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isDeleted?: InputMaybe<SortDirection>;
  lastModified?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
  question?: InputMaybe<SortDirection>;
  totalScore?: InputMaybe<SortDirection>;
};

export type McqQuestionUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type McqQuestionUpdateInput = {
  aiTutor?: InputMaybe<McqQuestionAiTutorUpdateFieldInput>;
  assessments?: InputMaybe<Array<McqQuestionAssessmentsUpdateFieldInput>>;
  choices?: InputMaybe<Array<Scalars['String']['input']>>;
  choices_POP?: InputMaybe<Scalars['Int']['input']>;
  choices_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  correctChoiceIndices?: InputMaybe<Array<Scalars['Int']['input']>>;
  correctChoiceIndices_POP?: InputMaybe<Scalars['Int']['input']>;
  correctChoiceIndices_PUSH?: InputMaybe<Array<Scalars['Int']['input']>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  explanation?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  order_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  replaces?: InputMaybe<McqQuestionReplacesUpdateFieldInput>;
  totalScore?: InputMaybe<Scalars['Float']['input']>;
  totalScore_ADD?: InputMaybe<Scalars['Float']['input']>;
  totalScore_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
};

export type McqQuestionWhere = {
  AND?: InputMaybe<Array<McqQuestionWhere>>;
  NOT?: InputMaybe<McqQuestionWhere>;
  OR?: InputMaybe<Array<McqQuestionWhere>>;
  aiTutor?: InputMaybe<AiTutorWhere>;
  aiTutorAggregate?: InputMaybe<McqQuestionAiTutorAggregateInput>;
  aiTutorConnection?: InputMaybe<McqQuestionAiTutorConnectionWhere>;
  aiTutorConnection_NOT?: InputMaybe<McqQuestionAiTutorConnectionWhere>;
  aiTutor_NOT?: InputMaybe<AiTutorWhere>;
  assessmentsAggregate?: InputMaybe<McqQuestionAssessmentsAggregateInput>;
  /** Return McqQuestions where all of the related McqQuestionAssessmentsConnections match this filter */
  assessmentsConnection_ALL?: InputMaybe<McqQuestionAssessmentsConnectionWhere>;
  /** Return McqQuestions where none of the related McqQuestionAssessmentsConnections match this filter */
  assessmentsConnection_NONE?: InputMaybe<McqQuestionAssessmentsConnectionWhere>;
  /** Return McqQuestions where one of the related McqQuestionAssessmentsConnections match this filter */
  assessmentsConnection_SINGLE?: InputMaybe<McqQuestionAssessmentsConnectionWhere>;
  /** Return McqQuestions where some of the related McqQuestionAssessmentsConnections match this filter */
  assessmentsConnection_SOME?: InputMaybe<McqQuestionAssessmentsConnectionWhere>;
  /** Return McqQuestions where all of the related Assessments match this filter */
  assessments_ALL?: InputMaybe<AssessmentWhere>;
  /** Return McqQuestions where none of the related Assessments match this filter */
  assessments_NONE?: InputMaybe<AssessmentWhere>;
  /** Return McqQuestions where one of the related Assessments match this filter */
  assessments_SINGLE?: InputMaybe<AssessmentWhere>;
  /** Return McqQuestions where some of the related Assessments match this filter */
  assessments_SOME?: InputMaybe<AssessmentWhere>;
  choices?: InputMaybe<Array<Scalars['String']['input']>>;
  choices_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  correctChoiceIndices?: InputMaybe<Array<Scalars['Int']['input']>>;
  correctChoiceIndices_INCLUDES?: InputMaybe<Scalars['Int']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  explanation?: InputMaybe<Scalars['String']['input']>;
  explanation_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  explanation_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  explanation_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  explanation_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastModified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  question_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  question_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  question_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  question_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  replaces?: InputMaybe<McqQuestionWhere>;
  replacesAggregate?: InputMaybe<McqQuestionReplacesAggregateInput>;
  replacesConnection?: InputMaybe<McqQuestionReplacesConnectionWhere>;
  replacesConnection_NOT?: InputMaybe<McqQuestionReplacesConnectionWhere>;
  replaces_NOT?: InputMaybe<McqQuestionWhere>;
  totalScore?: InputMaybe<Scalars['Float']['input']>;
  totalScore_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  totalScore_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type MeResponse = {
  __typename?: 'MeResponse';
  audioOn?: Maybe<Scalars['Boolean']['output']>;
  biography?: Maybe<Scalars['String']['output']>;
  companionOnboardingState?: Maybe<CompanionOnboardingState>;
  countryCode?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  currentWeightLbs?: Maybe<Scalars['Float']['output']>;
  dailyEmailOptIn?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enrolledDegrees: Array<Degree>;
  enrolledTracks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fullPhoneNumber?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  goalWeightLbs?: Maybe<Scalars['Float']['output']>;
  googleCalendarAuthToken?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCareerLoading?: Maybe<Scalars['Boolean']['output']>;
  isCourseLoading?: Maybe<Scalars['Boolean']['output']>;
  isEmailVerified?: Maybe<Scalars['Boolean']['output']>;
  isFaculty?: Maybe<Scalars['Boolean']['output']>;
  isOnboarded?: Maybe<Scalars['Boolean']['output']>;
  isPro?: Maybe<Scalars['Boolean']['output']>;
  meetingLink?: Maybe<Scalars['String']['output']>;
  modalOnboarding?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  otpPreference?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  showLearningActivityIntro?: Maybe<Scalars['Boolean']['output']>;
  skipAllNotificationEmail?: Maybe<Scalars['Boolean']['output']>;
  trialEndDate?: Maybe<Scalars['DateTime']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type Message = {
  __typename?: 'Message';
  artifactBlocks: Array<ArtifactBlock>;
  artifactBlocksAggregate?: Maybe<MessageArtifactBlockArtifactBlocksAggregationSelection>;
  artifactBlocksConnection: MessageArtifactBlocksConnection;
  aspectDetails?: Maybe<Scalars['String']['output']>;
  chatsHasMessage: Array<Chat>;
  chatsHasMessageAggregate?: Maybe<MessageChatChatsHasMessageAggregationSelection>;
  chatsHasMessageConnection: MessageChatsHasMessageConnection;
  content?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  documents: Array<Document>;
  documentsAggregate?: Maybe<MessageDocumentDocumentsAggregationSelection>;
  documentsConnection: MessageDocumentsConnection;
  emotion?: Maybe<Scalars['String']['output']>;
  file?: Maybe<File>;
  fileAggregate?: Maybe<MessageFileFileAggregationSelection>;
  fileBlocks: Array<FileBlock>;
  fileBlocksAggregate?: Maybe<MessageFileBlockFileBlocksAggregationSelection>;
  fileBlocksConnection: MessageFileBlocksConnection;
  fileConnection: MessageFileConnection;
  flagged?: Maybe<Scalars['Boolean']['output']>;
  harassment?: Maybe<Scalars['Boolean']['output']>;
  harassment_threatening?: Maybe<Scalars['Boolean']['output']>;
  hate?: Maybe<Scalars['Boolean']['output']>;
  hate_threatening?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  last_modified?: Maybe<Scalars['DateTime']['output']>;
  nodeId?: Maybe<Scalars['String']['output']>;
  parameters?: Maybe<Scalars['String']['output']>;
  self_harm?: Maybe<Scalars['Boolean']['output']>;
  self_harm_instructions?: Maybe<Scalars['Boolean']['output']>;
  self_harm_intent?: Maybe<Scalars['Boolean']['output']>;
  sender?: Maybe<Scalars['String']['output']>;
  sexual?: Maybe<Scalars['Boolean']['output']>;
  sexual_minors?: Maybe<Scalars['Boolean']['output']>;
  snackType?: Maybe<Scalars['String']['output']>;
  textBlocks: Array<TextBlock>;
  textBlocksAggregate?: Maybe<MessageTextBlockTextBlocksAggregationSelection>;
  textBlocksConnection: MessageTextBlocksConnection;
  type?: Maybe<Scalars['String']['output']>;
  video?: Maybe<Video>;
  videoAggregate?: Maybe<MessageVideoVideoAggregationSelection>;
  videoConnection: MessageVideoConnection;
  violence?: Maybe<Scalars['Boolean']['output']>;
  violence_graphic?: Maybe<Scalars['Boolean']['output']>;
  visualization?: Maybe<Visualization>;
  visualizationAggregate?: Maybe<MessageVisualizationVisualizationAggregationSelection>;
  visualizationConnection: MessageVisualizationConnection;
};


export type MessageArtifactBlocksArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ArtifactBlockOptions>;
  where?: InputMaybe<ArtifactBlockWhere>;
};


export type MessageArtifactBlocksAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ArtifactBlockWhere>;
};


export type MessageArtifactBlocksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<MessageArtifactBlocksConnectionSort>>;
  where?: InputMaybe<MessageArtifactBlocksConnectionWhere>;
};


export type MessageChatsHasMessageArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ChatOptions>;
  where?: InputMaybe<ChatWhere>;
};


export type MessageChatsHasMessageAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ChatWhere>;
};


export type MessageChatsHasMessageConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<MessageChatsHasMessageConnectionSort>>;
  where?: InputMaybe<MessageChatsHasMessageConnectionWhere>;
};


export type MessageDocumentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DocumentOptions>;
  where?: InputMaybe<DocumentWhere>;
};


export type MessageDocumentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DocumentWhere>;
};


export type MessageDocumentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<MessageDocumentsConnectionSort>>;
  where?: InputMaybe<MessageDocumentsConnectionWhere>;
};


export type MessageFileArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FileOptions>;
  where?: InputMaybe<FileWhere>;
};


export type MessageFileAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FileWhere>;
};


export type MessageFileBlocksArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FileBlockOptions>;
  where?: InputMaybe<FileBlockWhere>;
};


export type MessageFileBlocksAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FileBlockWhere>;
};


export type MessageFileBlocksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<MessageFileBlocksConnectionSort>>;
  where?: InputMaybe<MessageFileBlocksConnectionWhere>;
};


export type MessageFileConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<MessageFileConnectionSort>>;
  where?: InputMaybe<MessageFileConnectionWhere>;
};


export type MessageTextBlocksArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TextBlockOptions>;
  where?: InputMaybe<TextBlockWhere>;
};


export type MessageTextBlocksAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TextBlockWhere>;
};


export type MessageTextBlocksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<MessageTextBlocksConnectionSort>>;
  where?: InputMaybe<MessageTextBlocksConnectionWhere>;
};


export type MessageVideoArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<VideoOptions>;
  where?: InputMaybe<VideoWhere>;
};


export type MessageVideoAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VideoWhere>;
};


export type MessageVideoConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<MessageVideoConnectionSort>>;
  where?: InputMaybe<MessageVideoConnectionWhere>;
};


export type MessageVisualizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<VisualizationOptions>;
  where?: InputMaybe<VisualizationWhere>;
};


export type MessageVisualizationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VisualizationWhere>;
};


export type MessageVisualizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<MessageVisualizationConnectionSort>>;
  where?: InputMaybe<MessageVisualizationConnectionWhere>;
};

export type MessageArtifactBlockArtifactBlocksAggregationSelection = {
  __typename?: 'MessageArtifactBlockArtifactBlocksAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<MessageArtifactBlockArtifactBlocksEdgeAggregateSelection>;
  node?: Maybe<MessageArtifactBlockArtifactBlocksNodeAggregateSelection>;
};

export type MessageArtifactBlockArtifactBlocksEdgeAggregateSelection = {
  __typename?: 'MessageArtifactBlockArtifactBlocksEdgeAggregateSelection';
  created: DateTimeAggregateSelection;
  index: IntAggregateSelection;
};

export type MessageArtifactBlockArtifactBlocksNodeAggregateSelection = {
  __typename?: 'MessageArtifactBlockArtifactBlocksNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
};

export type MessageArtifactBlocksAggregateInput = {
  AND?: InputMaybe<Array<MessageArtifactBlocksAggregateInput>>;
  NOT?: InputMaybe<MessageArtifactBlocksAggregateInput>;
  OR?: InputMaybe<Array<MessageArtifactBlocksAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasBlockPropertiesAggregationWhereInput>;
  node?: InputMaybe<MessageArtifactBlocksNodeAggregationWhereInput>;
};

export type MessageArtifactBlocksConnectFieldInput = {
  connect?: InputMaybe<Array<ArtifactBlockConnectInput>>;
  edge: HasBlockPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ArtifactBlockConnectWhere>;
};

export type MessageArtifactBlocksConnectOrCreateFieldInput = {
  onCreate: MessageArtifactBlocksConnectOrCreateFieldInputOnCreate;
  where: ArtifactBlockConnectOrCreateWhere;
};

export type MessageArtifactBlocksConnectOrCreateFieldInputOnCreate = {
  edge: HasBlockPropertiesCreateInput;
  node: ArtifactBlockOnCreateInput;
};

export type MessageArtifactBlocksConnection = {
  __typename?: 'MessageArtifactBlocksConnection';
  edges: Array<MessageArtifactBlocksRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MessageArtifactBlocksConnectionSort = {
  edge?: InputMaybe<HasBlockPropertiesSort>;
  node?: InputMaybe<ArtifactBlockSort>;
};

export type MessageArtifactBlocksConnectionWhere = {
  AND?: InputMaybe<Array<MessageArtifactBlocksConnectionWhere>>;
  NOT?: InputMaybe<MessageArtifactBlocksConnectionWhere>;
  OR?: InputMaybe<Array<MessageArtifactBlocksConnectionWhere>>;
  edge?: InputMaybe<HasBlockPropertiesWhere>;
  node?: InputMaybe<ArtifactBlockWhere>;
};

export type MessageArtifactBlocksCreateFieldInput = {
  edge: HasBlockPropertiesCreateInput;
  node: ArtifactBlockCreateInput;
};

export type MessageArtifactBlocksDeleteFieldInput = {
  delete?: InputMaybe<ArtifactBlockDeleteInput>;
  where?: InputMaybe<MessageArtifactBlocksConnectionWhere>;
};

export type MessageArtifactBlocksDisconnectFieldInput = {
  disconnect?: InputMaybe<ArtifactBlockDisconnectInput>;
  where?: InputMaybe<MessageArtifactBlocksConnectionWhere>;
};

export type MessageArtifactBlocksFieldInput = {
  connect?: InputMaybe<Array<MessageArtifactBlocksConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<MessageArtifactBlocksConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<MessageArtifactBlocksCreateFieldInput>>;
};

export type MessageArtifactBlocksNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<MessageArtifactBlocksNodeAggregationWhereInput>>;
  NOT?: InputMaybe<MessageArtifactBlocksNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<MessageArtifactBlocksNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MessageArtifactBlocksRelationship = {
  __typename?: 'MessageArtifactBlocksRelationship';
  cursor: Scalars['String']['output'];
  node: ArtifactBlock;
  properties: HasBlockProperties;
};

export type MessageArtifactBlocksUpdateConnectionInput = {
  edge?: InputMaybe<HasBlockPropertiesUpdateInput>;
  node?: InputMaybe<ArtifactBlockUpdateInput>;
};

export type MessageArtifactBlocksUpdateFieldInput = {
  connect?: InputMaybe<Array<MessageArtifactBlocksConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<MessageArtifactBlocksConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<MessageArtifactBlocksCreateFieldInput>>;
  delete?: InputMaybe<Array<MessageArtifactBlocksDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<MessageArtifactBlocksDisconnectFieldInput>>;
  update?: InputMaybe<MessageArtifactBlocksUpdateConnectionInput>;
  where?: InputMaybe<MessageArtifactBlocksConnectionWhere>;
};

export type MessageChatChatsHasMessageAggregationSelection = {
  __typename?: 'MessageChatChatsHasMessageAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<MessageChatChatsHasMessageEdgeAggregateSelection>;
  node?: Maybe<MessageChatChatsHasMessageNodeAggregateSelection>;
};

export type MessageChatChatsHasMessageEdgeAggregateSelection = {
  __typename?: 'MessageChatChatsHasMessageEdgeAggregateSelection';
  created: DateTimeAggregateSelection;
};

export type MessageChatChatsHasMessageNodeAggregateSelection = {
  __typename?: 'MessageChatChatsHasMessageNodeAggregateSelection';
  context: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  date: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  name: StringAggregateSelection;
  objectId: IdAggregateSelection;
  schemaVersion: IntAggregateSelection;
  timezone: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type MessageChatsHasMessageAggregateInput = {
  AND?: InputMaybe<Array<MessageChatsHasMessageAggregateInput>>;
  NOT?: InputMaybe<MessageChatsHasMessageAggregateInput>;
  OR?: InputMaybe<Array<MessageChatsHasMessageAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasMessagePropertiesAggregationWhereInput>;
  node?: InputMaybe<MessageChatsHasMessageNodeAggregationWhereInput>;
};

export type MessageChatsHasMessageConnectFieldInput = {
  connect?: InputMaybe<Array<ChatConnectInput>>;
  edge: HasMessagePropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ChatConnectWhere>;
};

export type MessageChatsHasMessageConnectOrCreateFieldInput = {
  onCreate: MessageChatsHasMessageConnectOrCreateFieldInputOnCreate;
  where: ChatConnectOrCreateWhere;
};

export type MessageChatsHasMessageConnectOrCreateFieldInputOnCreate = {
  edge: HasMessagePropertiesCreateInput;
  node: ChatOnCreateInput;
};

export type MessageChatsHasMessageConnection = {
  __typename?: 'MessageChatsHasMessageConnection';
  edges: Array<MessageChatsHasMessageRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MessageChatsHasMessageConnectionSort = {
  edge?: InputMaybe<HasMessagePropertiesSort>;
  node?: InputMaybe<ChatSort>;
};

export type MessageChatsHasMessageConnectionWhere = {
  AND?: InputMaybe<Array<MessageChatsHasMessageConnectionWhere>>;
  NOT?: InputMaybe<MessageChatsHasMessageConnectionWhere>;
  OR?: InputMaybe<Array<MessageChatsHasMessageConnectionWhere>>;
  edge?: InputMaybe<HasMessagePropertiesWhere>;
  node?: InputMaybe<ChatWhere>;
};

export type MessageChatsHasMessageCreateFieldInput = {
  edge: HasMessagePropertiesCreateInput;
  node: ChatCreateInput;
};

export type MessageChatsHasMessageDeleteFieldInput = {
  delete?: InputMaybe<ChatDeleteInput>;
  where?: InputMaybe<MessageChatsHasMessageConnectionWhere>;
};

export type MessageChatsHasMessageDisconnectFieldInput = {
  disconnect?: InputMaybe<ChatDisconnectInput>;
  where?: InputMaybe<MessageChatsHasMessageConnectionWhere>;
};

export type MessageChatsHasMessageFieldInput = {
  connect?: InputMaybe<Array<MessageChatsHasMessageConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<MessageChatsHasMessageConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<MessageChatsHasMessageCreateFieldInput>>;
};

export type MessageChatsHasMessageNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<MessageChatsHasMessageNodeAggregationWhereInput>>;
  NOT?: InputMaybe<MessageChatsHasMessageNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<MessageChatsHasMessageNodeAggregationWhereInput>>;
  context_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  context_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  schemaVersion_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  schemaVersion_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  schemaVersion_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  schemaVersion_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  schemaVersion_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type MessageChatsHasMessageRelationship = {
  __typename?: 'MessageChatsHasMessageRelationship';
  cursor: Scalars['String']['output'];
  node: Chat;
  properties: HasMessageProperties;
};

export type MessageChatsHasMessageUpdateConnectionInput = {
  edge?: InputMaybe<HasMessagePropertiesUpdateInput>;
  node?: InputMaybe<ChatUpdateInput>;
};

export type MessageChatsHasMessageUpdateFieldInput = {
  connect?: InputMaybe<Array<MessageChatsHasMessageConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<MessageChatsHasMessageConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<MessageChatsHasMessageCreateFieldInput>>;
  delete?: InputMaybe<Array<MessageChatsHasMessageDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<MessageChatsHasMessageDisconnectFieldInput>>;
  update?: InputMaybe<MessageChatsHasMessageUpdateConnectionInput>;
  where?: InputMaybe<MessageChatsHasMessageConnectionWhere>;
};

export type MessageConnectInput = {
  artifactBlocks?: InputMaybe<Array<MessageArtifactBlocksConnectFieldInput>>;
  chatsHasMessage?: InputMaybe<Array<MessageChatsHasMessageConnectFieldInput>>;
  documents?: InputMaybe<Array<MessageDocumentsConnectFieldInput>>;
  file?: InputMaybe<MessageFileConnectFieldInput>;
  fileBlocks?: InputMaybe<Array<MessageFileBlocksConnectFieldInput>>;
  textBlocks?: InputMaybe<Array<MessageTextBlocksConnectFieldInput>>;
  video?: InputMaybe<MessageVideoConnectFieldInput>;
  visualization?: InputMaybe<MessageVisualizationConnectFieldInput>;
};

export type MessageConnectOrCreateWhere = {
  node: MessageUniqueWhere;
};

export type MessageConnectWhere = {
  node: MessageWhere;
};

export type MessageCreateInput = {
  artifactBlocks?: InputMaybe<MessageArtifactBlocksFieldInput>;
  aspectDetails?: InputMaybe<Scalars['String']['input']>;
  chatsHasMessage?: InputMaybe<MessageChatsHasMessageFieldInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  documents?: InputMaybe<MessageDocumentsFieldInput>;
  emotion?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<MessageFileFieldInput>;
  fileBlocks?: InputMaybe<MessageFileBlocksFieldInput>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  harassment?: InputMaybe<Scalars['Boolean']['input']>;
  harassment_threatening?: InputMaybe<Scalars['Boolean']['input']>;
  hate?: InputMaybe<Scalars['Boolean']['input']>;
  hate_threatening?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  index?: InputMaybe<Scalars['Int']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  nodeId?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['String']['input']>;
  self_harm?: InputMaybe<Scalars['Boolean']['input']>;
  self_harm_instructions?: InputMaybe<Scalars['Boolean']['input']>;
  self_harm_intent?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sexual?: InputMaybe<Scalars['Boolean']['input']>;
  sexual_minors?: InputMaybe<Scalars['Boolean']['input']>;
  snackType?: InputMaybe<Scalars['String']['input']>;
  textBlocks?: InputMaybe<MessageTextBlocksFieldInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<MessageVideoFieldInput>;
  violence?: InputMaybe<Scalars['Boolean']['input']>;
  violence_graphic?: InputMaybe<Scalars['Boolean']['input']>;
  visualization?: InputMaybe<MessageVisualizationFieldInput>;
};

export type MessageDeleteInput = {
  artifactBlocks?: InputMaybe<Array<MessageArtifactBlocksDeleteFieldInput>>;
  chatsHasMessage?: InputMaybe<Array<MessageChatsHasMessageDeleteFieldInput>>;
  documents?: InputMaybe<Array<MessageDocumentsDeleteFieldInput>>;
  file?: InputMaybe<MessageFileDeleteFieldInput>;
  fileBlocks?: InputMaybe<Array<MessageFileBlocksDeleteFieldInput>>;
  textBlocks?: InputMaybe<Array<MessageTextBlocksDeleteFieldInput>>;
  video?: InputMaybe<MessageVideoDeleteFieldInput>;
  visualization?: InputMaybe<MessageVisualizationDeleteFieldInput>;
};

export type MessageDisconnectInput = {
  artifactBlocks?: InputMaybe<Array<MessageArtifactBlocksDisconnectFieldInput>>;
  chatsHasMessage?: InputMaybe<Array<MessageChatsHasMessageDisconnectFieldInput>>;
  documents?: InputMaybe<Array<MessageDocumentsDisconnectFieldInput>>;
  file?: InputMaybe<MessageFileDisconnectFieldInput>;
  fileBlocks?: InputMaybe<Array<MessageFileBlocksDisconnectFieldInput>>;
  textBlocks?: InputMaybe<Array<MessageTextBlocksDisconnectFieldInput>>;
  video?: InputMaybe<MessageVideoDisconnectFieldInput>;
  visualization?: InputMaybe<MessageVisualizationDisconnectFieldInput>;
};

export type MessageDocumentDocumentsAggregationSelection = {
  __typename?: 'MessageDocumentDocumentsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<MessageDocumentDocumentsNodeAggregateSelection>;
};

export type MessageDocumentDocumentsNodeAggregateSelection = {
  __typename?: 'MessageDocumentDocumentsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  summary: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type MessageDocumentsAggregateInput = {
  AND?: InputMaybe<Array<MessageDocumentsAggregateInput>>;
  NOT?: InputMaybe<MessageDocumentsAggregateInput>;
  OR?: InputMaybe<Array<MessageDocumentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<MessageDocumentsNodeAggregationWhereInput>;
};

export type MessageDocumentsConnectFieldInput = {
  connect?: InputMaybe<Array<DocumentConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DocumentConnectWhere>;
};

export type MessageDocumentsConnection = {
  __typename?: 'MessageDocumentsConnection';
  edges: Array<MessageDocumentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MessageDocumentsConnectionSort = {
  node?: InputMaybe<DocumentSort>;
};

export type MessageDocumentsConnectionWhere = {
  AND?: InputMaybe<Array<MessageDocumentsConnectionWhere>>;
  NOT?: InputMaybe<MessageDocumentsConnectionWhere>;
  OR?: InputMaybe<Array<MessageDocumentsConnectionWhere>>;
  node?: InputMaybe<DocumentWhere>;
};

export type MessageDocumentsCreateFieldInput = {
  node: DocumentCreateInput;
};

export type MessageDocumentsDeleteFieldInput = {
  delete?: InputMaybe<DocumentDeleteInput>;
  where?: InputMaybe<MessageDocumentsConnectionWhere>;
};

export type MessageDocumentsDisconnectFieldInput = {
  disconnect?: InputMaybe<DocumentDisconnectInput>;
  where?: InputMaybe<MessageDocumentsConnectionWhere>;
};

export type MessageDocumentsFieldInput = {
  connect?: InputMaybe<Array<MessageDocumentsConnectFieldInput>>;
  create?: InputMaybe<Array<MessageDocumentsCreateFieldInput>>;
};

export type MessageDocumentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<MessageDocumentsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<MessageDocumentsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<MessageDocumentsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  summary_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  summary_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type MessageDocumentsRelationship = {
  __typename?: 'MessageDocumentsRelationship';
  cursor: Scalars['String']['output'];
  node: Document;
};

export type MessageDocumentsUpdateConnectionInput = {
  node?: InputMaybe<DocumentUpdateInput>;
};

export type MessageDocumentsUpdateFieldInput = {
  connect?: InputMaybe<Array<MessageDocumentsConnectFieldInput>>;
  create?: InputMaybe<Array<MessageDocumentsCreateFieldInput>>;
  delete?: InputMaybe<Array<MessageDocumentsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<MessageDocumentsDisconnectFieldInput>>;
  update?: InputMaybe<MessageDocumentsUpdateConnectionInput>;
  where?: InputMaybe<MessageDocumentsConnectionWhere>;
};

export type MessageFileAggregateInput = {
  AND?: InputMaybe<Array<MessageFileAggregateInput>>;
  NOT?: InputMaybe<MessageFileAggregateInput>;
  OR?: InputMaybe<Array<MessageFileAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<MessageFileNodeAggregationWhereInput>;
};

export type MessageFileBlockFileBlocksAggregationSelection = {
  __typename?: 'MessageFileBlockFileBlocksAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<MessageFileBlockFileBlocksEdgeAggregateSelection>;
  node?: Maybe<MessageFileBlockFileBlocksNodeAggregateSelection>;
};

export type MessageFileBlockFileBlocksEdgeAggregateSelection = {
  __typename?: 'MessageFileBlockFileBlocksEdgeAggregateSelection';
  created: DateTimeAggregateSelection;
  index: IntAggregateSelection;
};

export type MessageFileBlockFileBlocksNodeAggregateSelection = {
  __typename?: 'MessageFileBlockFileBlocksNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  displayName: StringAggregateSelection;
  id: IdAggregateSelection;
};

export type MessageFileBlocksAggregateInput = {
  AND?: InputMaybe<Array<MessageFileBlocksAggregateInput>>;
  NOT?: InputMaybe<MessageFileBlocksAggregateInput>;
  OR?: InputMaybe<Array<MessageFileBlocksAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasBlockPropertiesAggregationWhereInput>;
  node?: InputMaybe<MessageFileBlocksNodeAggregationWhereInput>;
};

export type MessageFileBlocksConnectFieldInput = {
  connect?: InputMaybe<Array<FileBlockConnectInput>>;
  edge: HasBlockPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FileBlockConnectWhere>;
};

export type MessageFileBlocksConnectOrCreateFieldInput = {
  onCreate: MessageFileBlocksConnectOrCreateFieldInputOnCreate;
  where: FileBlockConnectOrCreateWhere;
};

export type MessageFileBlocksConnectOrCreateFieldInputOnCreate = {
  edge: HasBlockPropertiesCreateInput;
  node: FileBlockOnCreateInput;
};

export type MessageFileBlocksConnection = {
  __typename?: 'MessageFileBlocksConnection';
  edges: Array<MessageFileBlocksRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MessageFileBlocksConnectionSort = {
  edge?: InputMaybe<HasBlockPropertiesSort>;
  node?: InputMaybe<FileBlockSort>;
};

export type MessageFileBlocksConnectionWhere = {
  AND?: InputMaybe<Array<MessageFileBlocksConnectionWhere>>;
  NOT?: InputMaybe<MessageFileBlocksConnectionWhere>;
  OR?: InputMaybe<Array<MessageFileBlocksConnectionWhere>>;
  edge?: InputMaybe<HasBlockPropertiesWhere>;
  node?: InputMaybe<FileBlockWhere>;
};

export type MessageFileBlocksCreateFieldInput = {
  edge: HasBlockPropertiesCreateInput;
  node: FileBlockCreateInput;
};

export type MessageFileBlocksDeleteFieldInput = {
  delete?: InputMaybe<FileBlockDeleteInput>;
  where?: InputMaybe<MessageFileBlocksConnectionWhere>;
};

export type MessageFileBlocksDisconnectFieldInput = {
  disconnect?: InputMaybe<FileBlockDisconnectInput>;
  where?: InputMaybe<MessageFileBlocksConnectionWhere>;
};

export type MessageFileBlocksFieldInput = {
  connect?: InputMaybe<Array<MessageFileBlocksConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<MessageFileBlocksConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<MessageFileBlocksCreateFieldInput>>;
};

export type MessageFileBlocksNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<MessageFileBlocksNodeAggregationWhereInput>>;
  NOT?: InputMaybe<MessageFileBlocksNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<MessageFileBlocksNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  displayName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  displayName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  displayName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  displayName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type MessageFileBlocksRelationship = {
  __typename?: 'MessageFileBlocksRelationship';
  cursor: Scalars['String']['output'];
  node: FileBlock;
  properties: HasBlockProperties;
};

export type MessageFileBlocksUpdateConnectionInput = {
  edge?: InputMaybe<HasBlockPropertiesUpdateInput>;
  node?: InputMaybe<FileBlockUpdateInput>;
};

export type MessageFileBlocksUpdateFieldInput = {
  connect?: InputMaybe<Array<MessageFileBlocksConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<MessageFileBlocksConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<MessageFileBlocksCreateFieldInput>>;
  delete?: InputMaybe<Array<MessageFileBlocksDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<MessageFileBlocksDisconnectFieldInput>>;
  update?: InputMaybe<MessageFileBlocksUpdateConnectionInput>;
  where?: InputMaybe<MessageFileBlocksConnectionWhere>;
};

export type MessageFileConnectFieldInput = {
  connect?: InputMaybe<FileConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FileConnectWhere>;
};

export type MessageFileConnectOrCreateFieldInput = {
  onCreate: MessageFileConnectOrCreateFieldInputOnCreate;
  where: FileConnectOrCreateWhere;
};

export type MessageFileConnectOrCreateFieldInputOnCreate = {
  node: FileOnCreateInput;
};

export type MessageFileConnection = {
  __typename?: 'MessageFileConnection';
  edges: Array<MessageFileRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MessageFileConnectionSort = {
  node?: InputMaybe<FileSort>;
};

export type MessageFileConnectionWhere = {
  AND?: InputMaybe<Array<MessageFileConnectionWhere>>;
  NOT?: InputMaybe<MessageFileConnectionWhere>;
  OR?: InputMaybe<Array<MessageFileConnectionWhere>>;
  node?: InputMaybe<FileWhere>;
};

export type MessageFileCreateFieldInput = {
  node: FileCreateInput;
};

export type MessageFileDeleteFieldInput = {
  delete?: InputMaybe<FileDeleteInput>;
  where?: InputMaybe<MessageFileConnectionWhere>;
};

export type MessageFileDisconnectFieldInput = {
  disconnect?: InputMaybe<FileDisconnectInput>;
  where?: InputMaybe<MessageFileConnectionWhere>;
};

export type MessageFileFieldInput = {
  connect?: InputMaybe<MessageFileConnectFieldInput>;
  connectOrCreate?: InputMaybe<MessageFileConnectOrCreateFieldInput>;
  create?: InputMaybe<MessageFileCreateFieldInput>;
};

export type MessageFileFileAggregationSelection = {
  __typename?: 'MessageFileFileAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<MessageFileFileNodeAggregateSelection>;
};

export type MessageFileFileNodeAggregateSelection = {
  __typename?: 'MessageFileFileNodeAggregateSelection';
  bucketName: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  fileName: StringAggregateSelection;
  filePath: StringAggregateSelection;
  fileURL: StringAggregateSelection;
  id: IdAggregateSelection;
};

export type MessageFileNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<MessageFileNodeAggregationWhereInput>>;
  NOT?: InputMaybe<MessageFileNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<MessageFileNodeAggregationWhereInput>>;
  bucketName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  bucketName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  fileName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileURL_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type MessageFileRelationship = {
  __typename?: 'MessageFileRelationship';
  cursor: Scalars['String']['output'];
  node: File;
};

export type MessageFileUpdateConnectionInput = {
  node?: InputMaybe<FileUpdateInput>;
};

export type MessageFileUpdateFieldInput = {
  connect?: InputMaybe<MessageFileConnectFieldInput>;
  connectOrCreate?: InputMaybe<MessageFileConnectOrCreateFieldInput>;
  create?: InputMaybe<MessageFileCreateFieldInput>;
  delete?: InputMaybe<MessageFileDeleteFieldInput>;
  disconnect?: InputMaybe<MessageFileDisconnectFieldInput>;
  update?: InputMaybe<MessageFileUpdateConnectionInput>;
  where?: InputMaybe<MessageFileConnectionWhere>;
};

export type MessageOnCreateInput = {
  aspectDetails?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  emotion?: InputMaybe<Scalars['String']['input']>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  harassment?: InputMaybe<Scalars['Boolean']['input']>;
  harassment_threatening?: InputMaybe<Scalars['Boolean']['input']>;
  hate?: InputMaybe<Scalars['Boolean']['input']>;
  hate_threatening?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  index?: InputMaybe<Scalars['Int']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  nodeId?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['String']['input']>;
  self_harm?: InputMaybe<Scalars['Boolean']['input']>;
  self_harm_instructions?: InputMaybe<Scalars['Boolean']['input']>;
  self_harm_intent?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sexual?: InputMaybe<Scalars['Boolean']['input']>;
  sexual_minors?: InputMaybe<Scalars['Boolean']['input']>;
  snackType?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  violence?: InputMaybe<Scalars['Boolean']['input']>;
  violence_graphic?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MessageOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more MessageSort objects to sort Messages by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<MessageSort>>;
};

export type MessageResponse = {
  __typename?: 'MessageResponse';
  aspectDetails?: Maybe<AspectDetailsType>;
  assignments: Array<Assignment>;
  chatsHasMessage: Array<Chat>;
  content?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  emotion?: Maybe<Scalars['String']['output']>;
  file?: Maybe<File>;
  files: Array<File>;
  flagged?: Maybe<Scalars['Boolean']['output']>;
  harassment?: Maybe<Scalars['Boolean']['output']>;
  harassment_threatening?: Maybe<Scalars['Boolean']['output']>;
  hate?: Maybe<Scalars['Boolean']['output']>;
  hate_threatening?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  last_modified?: Maybe<Scalars['DateTime']['output']>;
  nodeId?: Maybe<Scalars['String']['output']>;
  parameters?: Maybe<ParametersType>;
  self_harm?: Maybe<Scalars['Boolean']['output']>;
  self_harm_instructions?: Maybe<Scalars['Boolean']['output']>;
  self_harm_intent?: Maybe<Scalars['Boolean']['output']>;
  sender?: Maybe<Scalars['String']['output']>;
  sexual?: Maybe<Scalars['Boolean']['output']>;
  sexual_minors?: Maybe<Scalars['Boolean']['output']>;
  snackType?: Maybe<Scalars['String']['output']>;
  todos: Array<Todo>;
  type?: Maybe<Scalars['String']['output']>;
  violence?: Maybe<Scalars['Boolean']['output']>;
  violence_graphic?: Maybe<Scalars['Boolean']['output']>;
};

export enum MessageRole {
  Ai = 'ai',
  Human = 'human',
  System = 'system',
  Tool = 'tool'
}

/** Fields to sort Messages by. The order in which sorts are applied is not guaranteed when specifying many fields in one MessageSort object. */
export type MessageSort = {
  aspectDetails?: InputMaybe<SortDirection>;
  content?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  emotion?: InputMaybe<SortDirection>;
  flagged?: InputMaybe<SortDirection>;
  harassment?: InputMaybe<SortDirection>;
  harassment_threatening?: InputMaybe<SortDirection>;
  hate?: InputMaybe<SortDirection>;
  hate_threatening?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  index?: InputMaybe<SortDirection>;
  last_modified?: InputMaybe<SortDirection>;
  nodeId?: InputMaybe<SortDirection>;
  parameters?: InputMaybe<SortDirection>;
  self_harm?: InputMaybe<SortDirection>;
  self_harm_instructions?: InputMaybe<SortDirection>;
  self_harm_intent?: InputMaybe<SortDirection>;
  sender?: InputMaybe<SortDirection>;
  sexual?: InputMaybe<SortDirection>;
  sexual_minors?: InputMaybe<SortDirection>;
  snackType?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
  violence?: InputMaybe<SortDirection>;
  violence_graphic?: InputMaybe<SortDirection>;
};

export type MessageTextBlockTextBlocksAggregationSelection = {
  __typename?: 'MessageTextBlockTextBlocksAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<MessageTextBlockTextBlocksEdgeAggregateSelection>;
  node?: Maybe<MessageTextBlockTextBlocksNodeAggregateSelection>;
};

export type MessageTextBlockTextBlocksEdgeAggregateSelection = {
  __typename?: 'MessageTextBlockTextBlocksEdgeAggregateSelection';
  created: DateTimeAggregateSelection;
  index: IntAggregateSelection;
};

export type MessageTextBlockTextBlocksNodeAggregateSelection = {
  __typename?: 'MessageTextBlockTextBlocksNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  text: StringAggregateSelection;
};

export type MessageTextBlocksAggregateInput = {
  AND?: InputMaybe<Array<MessageTextBlocksAggregateInput>>;
  NOT?: InputMaybe<MessageTextBlocksAggregateInput>;
  OR?: InputMaybe<Array<MessageTextBlocksAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasBlockPropertiesAggregationWhereInput>;
  node?: InputMaybe<MessageTextBlocksNodeAggregationWhereInput>;
};

export type MessageTextBlocksConnectFieldInput = {
  connect?: InputMaybe<Array<TextBlockConnectInput>>;
  edge: HasBlockPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TextBlockConnectWhere>;
};

export type MessageTextBlocksConnectOrCreateFieldInput = {
  onCreate: MessageTextBlocksConnectOrCreateFieldInputOnCreate;
  where: TextBlockConnectOrCreateWhere;
};

export type MessageTextBlocksConnectOrCreateFieldInputOnCreate = {
  edge: HasBlockPropertiesCreateInput;
  node: TextBlockOnCreateInput;
};

export type MessageTextBlocksConnection = {
  __typename?: 'MessageTextBlocksConnection';
  edges: Array<MessageTextBlocksRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MessageTextBlocksConnectionSort = {
  edge?: InputMaybe<HasBlockPropertiesSort>;
  node?: InputMaybe<TextBlockSort>;
};

export type MessageTextBlocksConnectionWhere = {
  AND?: InputMaybe<Array<MessageTextBlocksConnectionWhere>>;
  NOT?: InputMaybe<MessageTextBlocksConnectionWhere>;
  OR?: InputMaybe<Array<MessageTextBlocksConnectionWhere>>;
  edge?: InputMaybe<HasBlockPropertiesWhere>;
  node?: InputMaybe<TextBlockWhere>;
};

export type MessageTextBlocksCreateFieldInput = {
  edge: HasBlockPropertiesCreateInput;
  node: TextBlockCreateInput;
};

export type MessageTextBlocksDeleteFieldInput = {
  delete?: InputMaybe<TextBlockDeleteInput>;
  where?: InputMaybe<MessageTextBlocksConnectionWhere>;
};

export type MessageTextBlocksDisconnectFieldInput = {
  disconnect?: InputMaybe<TextBlockDisconnectInput>;
  where?: InputMaybe<MessageTextBlocksConnectionWhere>;
};

export type MessageTextBlocksFieldInput = {
  connect?: InputMaybe<Array<MessageTextBlocksConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<MessageTextBlocksConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<MessageTextBlocksCreateFieldInput>>;
};

export type MessageTextBlocksNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<MessageTextBlocksNodeAggregationWhereInput>>;
  NOT?: InputMaybe<MessageTextBlocksNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<MessageTextBlocksNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  text_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  text_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type MessageTextBlocksRelationship = {
  __typename?: 'MessageTextBlocksRelationship';
  cursor: Scalars['String']['output'];
  node: TextBlock;
  properties: HasBlockProperties;
};

export type MessageTextBlocksUpdateConnectionInput = {
  edge?: InputMaybe<HasBlockPropertiesUpdateInput>;
  node?: InputMaybe<TextBlockUpdateInput>;
};

export type MessageTextBlocksUpdateFieldInput = {
  connect?: InputMaybe<Array<MessageTextBlocksConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<MessageTextBlocksConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<MessageTextBlocksCreateFieldInput>>;
  delete?: InputMaybe<Array<MessageTextBlocksDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<MessageTextBlocksDisconnectFieldInput>>;
  update?: InputMaybe<MessageTextBlocksUpdateConnectionInput>;
  where?: InputMaybe<MessageTextBlocksConnectionWhere>;
};

export type MessageUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type MessageUpdateInput = {
  artifactBlocks?: InputMaybe<Array<MessageArtifactBlocksUpdateFieldInput>>;
  aspectDetails?: InputMaybe<Scalars['String']['input']>;
  chatsHasMessage?: InputMaybe<Array<MessageChatsHasMessageUpdateFieldInput>>;
  content?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  documents?: InputMaybe<Array<MessageDocumentsUpdateFieldInput>>;
  emotion?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<MessageFileUpdateFieldInput>;
  fileBlocks?: InputMaybe<Array<MessageFileBlocksUpdateFieldInput>>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  harassment?: InputMaybe<Scalars['Boolean']['input']>;
  harassment_threatening?: InputMaybe<Scalars['Boolean']['input']>;
  hate?: InputMaybe<Scalars['Boolean']['input']>;
  hate_threatening?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  index_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  index_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  nodeId?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['String']['input']>;
  self_harm?: InputMaybe<Scalars['Boolean']['input']>;
  self_harm_instructions?: InputMaybe<Scalars['Boolean']['input']>;
  self_harm_intent?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sexual?: InputMaybe<Scalars['Boolean']['input']>;
  sexual_minors?: InputMaybe<Scalars['Boolean']['input']>;
  snackType?: InputMaybe<Scalars['String']['input']>;
  textBlocks?: InputMaybe<Array<MessageTextBlocksUpdateFieldInput>>;
  type?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<MessageVideoUpdateFieldInput>;
  violence?: InputMaybe<Scalars['Boolean']['input']>;
  violence_graphic?: InputMaybe<Scalars['Boolean']['input']>;
  visualization?: InputMaybe<MessageVisualizationUpdateFieldInput>;
};

export type MessageVideoAggregateInput = {
  AND?: InputMaybe<Array<MessageVideoAggregateInput>>;
  NOT?: InputMaybe<MessageVideoAggregateInput>;
  OR?: InputMaybe<Array<MessageVideoAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<MessageVideoNodeAggregationWhereInput>;
};

export type MessageVideoConnectFieldInput = {
  connect?: InputMaybe<VideoConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<VideoConnectWhere>;
};

export type MessageVideoConnectOrCreateFieldInput = {
  onCreate: MessageVideoConnectOrCreateFieldInputOnCreate;
  where: VideoConnectOrCreateWhere;
};

export type MessageVideoConnectOrCreateFieldInputOnCreate = {
  node: VideoOnCreateInput;
};

export type MessageVideoConnection = {
  __typename?: 'MessageVideoConnection';
  edges: Array<MessageVideoRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MessageVideoConnectionSort = {
  node?: InputMaybe<VideoSort>;
};

export type MessageVideoConnectionWhere = {
  AND?: InputMaybe<Array<MessageVideoConnectionWhere>>;
  NOT?: InputMaybe<MessageVideoConnectionWhere>;
  OR?: InputMaybe<Array<MessageVideoConnectionWhere>>;
  node?: InputMaybe<VideoWhere>;
};

export type MessageVideoCreateFieldInput = {
  node: VideoCreateInput;
};

export type MessageVideoDeleteFieldInput = {
  delete?: InputMaybe<VideoDeleteInput>;
  where?: InputMaybe<MessageVideoConnectionWhere>;
};

export type MessageVideoDisconnectFieldInput = {
  disconnect?: InputMaybe<VideoDisconnectInput>;
  where?: InputMaybe<MessageVideoConnectionWhere>;
};

export type MessageVideoFieldInput = {
  connect?: InputMaybe<MessageVideoConnectFieldInput>;
  connectOrCreate?: InputMaybe<MessageVideoConnectOrCreateFieldInput>;
  create?: InputMaybe<MessageVideoCreateFieldInput>;
};

export type MessageVideoNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<MessageVideoNodeAggregationWhereInput>>;
  NOT?: InputMaybe<MessageVideoNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<MessageVideoNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullTranscript_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTranscript_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTranscript_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTranscript_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTranscript_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullTranscript_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullTranscript_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullTranscript_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullTranscript_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullTranscript_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullTranscript_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullTranscript_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullTranscript_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullTranscript_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullTranscript_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  thumbnailUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thumbnailUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thumbnailUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnailUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thumbnailUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnailUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnailUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnailUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnailUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnailUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnailUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnailUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnailUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnailUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnailUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  videoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  videoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  videoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  videoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  videoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  videoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  videoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type MessageVideoRelationship = {
  __typename?: 'MessageVideoRelationship';
  cursor: Scalars['String']['output'];
  node: Video;
};

export type MessageVideoUpdateConnectionInput = {
  node?: InputMaybe<VideoUpdateInput>;
};

export type MessageVideoUpdateFieldInput = {
  connect?: InputMaybe<MessageVideoConnectFieldInput>;
  connectOrCreate?: InputMaybe<MessageVideoConnectOrCreateFieldInput>;
  create?: InputMaybe<MessageVideoCreateFieldInput>;
  delete?: InputMaybe<MessageVideoDeleteFieldInput>;
  disconnect?: InputMaybe<MessageVideoDisconnectFieldInput>;
  update?: InputMaybe<MessageVideoUpdateConnectionInput>;
  where?: InputMaybe<MessageVideoConnectionWhere>;
};

export type MessageVideoVideoAggregationSelection = {
  __typename?: 'MessageVideoVideoAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<MessageVideoVideoNodeAggregateSelection>;
};

export type MessageVideoVideoNodeAggregateSelection = {
  __typename?: 'MessageVideoVideoNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  fullTranscript: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  thumbnailUrl: StringAggregateSelection;
  title: StringAggregateSelection;
  url: StringAggregateSelection;
  videoId: StringAggregateSelection;
};

export type MessageVisualizationAggregateInput = {
  AND?: InputMaybe<Array<MessageVisualizationAggregateInput>>;
  NOT?: InputMaybe<MessageVisualizationAggregateInput>;
  OR?: InputMaybe<Array<MessageVisualizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<MessageVisualizationNodeAggregationWhereInput>;
};

export type MessageVisualizationConnectFieldInput = {
  connect?: InputMaybe<VisualizationConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<VisualizationConnectWhere>;
};

export type MessageVisualizationConnectOrCreateFieldInput = {
  onCreate: MessageVisualizationConnectOrCreateFieldInputOnCreate;
  where: VisualizationConnectOrCreateWhere;
};

export type MessageVisualizationConnectOrCreateFieldInputOnCreate = {
  node: VisualizationOnCreateInput;
};

export type MessageVisualizationConnection = {
  __typename?: 'MessageVisualizationConnection';
  edges: Array<MessageVisualizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MessageVisualizationConnectionSort = {
  node?: InputMaybe<VisualizationSort>;
};

export type MessageVisualizationConnectionWhere = {
  AND?: InputMaybe<Array<MessageVisualizationConnectionWhere>>;
  NOT?: InputMaybe<MessageVisualizationConnectionWhere>;
  OR?: InputMaybe<Array<MessageVisualizationConnectionWhere>>;
  node?: InputMaybe<VisualizationWhere>;
};

export type MessageVisualizationCreateFieldInput = {
  node: VisualizationCreateInput;
};

export type MessageVisualizationDeleteFieldInput = {
  delete?: InputMaybe<VisualizationDeleteInput>;
  where?: InputMaybe<MessageVisualizationConnectionWhere>;
};

export type MessageVisualizationDisconnectFieldInput = {
  disconnect?: InputMaybe<VisualizationDisconnectInput>;
  where?: InputMaybe<MessageVisualizationConnectionWhere>;
};

export type MessageVisualizationFieldInput = {
  connect?: InputMaybe<MessageVisualizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<MessageVisualizationConnectOrCreateFieldInput>;
  create?: InputMaybe<MessageVisualizationCreateFieldInput>;
};

export type MessageVisualizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<MessageVisualizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<MessageVisualizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<MessageVisualizationNodeAggregationWhereInput>>;
  code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  visualizationDescription_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  visualizationDescription_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  visualizationDescription_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  visualizationDescription_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  visualizationDescription_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  visualizationDescription_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  visualizationDescription_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  visualizationDescription_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  visualizationDescription_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  visualizationDescription_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  visualizationDescription_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  visualizationDescription_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  visualizationDescription_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  visualizationDescription_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  visualizationDescription_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  visualizationType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  visualizationType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  visualizationType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  visualizationType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  visualizationType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  visualizationType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  visualizationType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  visualizationType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  visualizationType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  visualizationType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  visualizationType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  visualizationType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  visualizationType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  visualizationType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  visualizationType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type MessageVisualizationRelationship = {
  __typename?: 'MessageVisualizationRelationship';
  cursor: Scalars['String']['output'];
  node: Visualization;
};

export type MessageVisualizationUpdateConnectionInput = {
  node?: InputMaybe<VisualizationUpdateInput>;
};

export type MessageVisualizationUpdateFieldInput = {
  connect?: InputMaybe<MessageVisualizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<MessageVisualizationConnectOrCreateFieldInput>;
  create?: InputMaybe<MessageVisualizationCreateFieldInput>;
  delete?: InputMaybe<MessageVisualizationDeleteFieldInput>;
  disconnect?: InputMaybe<MessageVisualizationDisconnectFieldInput>;
  update?: InputMaybe<MessageVisualizationUpdateConnectionInput>;
  where?: InputMaybe<MessageVisualizationConnectionWhere>;
};

export type MessageVisualizationVisualizationAggregationSelection = {
  __typename?: 'MessageVisualizationVisualizationAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<MessageVisualizationVisualizationNodeAggregateSelection>;
};

export type MessageVisualizationVisualizationNodeAggregateSelection = {
  __typename?: 'MessageVisualizationVisualizationNodeAggregateSelection';
  code: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  visualizationDescription: StringAggregateSelection;
  visualizationType: StringAggregateSelection;
};

export type MessageWhere = {
  AND?: InputMaybe<Array<MessageWhere>>;
  NOT?: InputMaybe<MessageWhere>;
  OR?: InputMaybe<Array<MessageWhere>>;
  artifactBlocksAggregate?: InputMaybe<MessageArtifactBlocksAggregateInput>;
  /** Return Messages where all of the related MessageArtifactBlocksConnections match this filter */
  artifactBlocksConnection_ALL?: InputMaybe<MessageArtifactBlocksConnectionWhere>;
  /** Return Messages where none of the related MessageArtifactBlocksConnections match this filter */
  artifactBlocksConnection_NONE?: InputMaybe<MessageArtifactBlocksConnectionWhere>;
  /** Return Messages where one of the related MessageArtifactBlocksConnections match this filter */
  artifactBlocksConnection_SINGLE?: InputMaybe<MessageArtifactBlocksConnectionWhere>;
  /** Return Messages where some of the related MessageArtifactBlocksConnections match this filter */
  artifactBlocksConnection_SOME?: InputMaybe<MessageArtifactBlocksConnectionWhere>;
  /** Return Messages where all of the related ArtifactBlocks match this filter */
  artifactBlocks_ALL?: InputMaybe<ArtifactBlockWhere>;
  /** Return Messages where none of the related ArtifactBlocks match this filter */
  artifactBlocks_NONE?: InputMaybe<ArtifactBlockWhere>;
  /** Return Messages where one of the related ArtifactBlocks match this filter */
  artifactBlocks_SINGLE?: InputMaybe<ArtifactBlockWhere>;
  /** Return Messages where some of the related ArtifactBlocks match this filter */
  artifactBlocks_SOME?: InputMaybe<ArtifactBlockWhere>;
  aspectDetails?: InputMaybe<Scalars['String']['input']>;
  aspectDetails_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  aspectDetails_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  aspectDetails_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aspectDetails_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  chatsHasMessageAggregate?: InputMaybe<MessageChatsHasMessageAggregateInput>;
  /** Return Messages where all of the related MessageChatsHasMessageConnections match this filter */
  chatsHasMessageConnection_ALL?: InputMaybe<MessageChatsHasMessageConnectionWhere>;
  /** Return Messages where none of the related MessageChatsHasMessageConnections match this filter */
  chatsHasMessageConnection_NONE?: InputMaybe<MessageChatsHasMessageConnectionWhere>;
  /** Return Messages where one of the related MessageChatsHasMessageConnections match this filter */
  chatsHasMessageConnection_SINGLE?: InputMaybe<MessageChatsHasMessageConnectionWhere>;
  /** Return Messages where some of the related MessageChatsHasMessageConnections match this filter */
  chatsHasMessageConnection_SOME?: InputMaybe<MessageChatsHasMessageConnectionWhere>;
  /** Return Messages where all of the related Chats match this filter */
  chatsHasMessage_ALL?: InputMaybe<ChatWhere>;
  /** Return Messages where none of the related Chats match this filter */
  chatsHasMessage_NONE?: InputMaybe<ChatWhere>;
  /** Return Messages where one of the related Chats match this filter */
  chatsHasMessage_SINGLE?: InputMaybe<ChatWhere>;
  /** Return Messages where some of the related Chats match this filter */
  chatsHasMessage_SOME?: InputMaybe<ChatWhere>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  content_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  content_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  documentsAggregate?: InputMaybe<MessageDocumentsAggregateInput>;
  /** Return Messages where all of the related MessageDocumentsConnections match this filter */
  documentsConnection_ALL?: InputMaybe<MessageDocumentsConnectionWhere>;
  /** Return Messages where none of the related MessageDocumentsConnections match this filter */
  documentsConnection_NONE?: InputMaybe<MessageDocumentsConnectionWhere>;
  /** Return Messages where one of the related MessageDocumentsConnections match this filter */
  documentsConnection_SINGLE?: InputMaybe<MessageDocumentsConnectionWhere>;
  /** Return Messages where some of the related MessageDocumentsConnections match this filter */
  documentsConnection_SOME?: InputMaybe<MessageDocumentsConnectionWhere>;
  /** Return Messages where all of the related Documents match this filter */
  documents_ALL?: InputMaybe<DocumentWhere>;
  /** Return Messages where none of the related Documents match this filter */
  documents_NONE?: InputMaybe<DocumentWhere>;
  /** Return Messages where one of the related Documents match this filter */
  documents_SINGLE?: InputMaybe<DocumentWhere>;
  /** Return Messages where some of the related Documents match this filter */
  documents_SOME?: InputMaybe<DocumentWhere>;
  emotion?: InputMaybe<Scalars['String']['input']>;
  emotion_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  emotion_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  emotion_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  emotion_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<FileWhere>;
  fileAggregate?: InputMaybe<MessageFileAggregateInput>;
  fileBlocksAggregate?: InputMaybe<MessageFileBlocksAggregateInput>;
  /** Return Messages where all of the related MessageFileBlocksConnections match this filter */
  fileBlocksConnection_ALL?: InputMaybe<MessageFileBlocksConnectionWhere>;
  /** Return Messages where none of the related MessageFileBlocksConnections match this filter */
  fileBlocksConnection_NONE?: InputMaybe<MessageFileBlocksConnectionWhere>;
  /** Return Messages where one of the related MessageFileBlocksConnections match this filter */
  fileBlocksConnection_SINGLE?: InputMaybe<MessageFileBlocksConnectionWhere>;
  /** Return Messages where some of the related MessageFileBlocksConnections match this filter */
  fileBlocksConnection_SOME?: InputMaybe<MessageFileBlocksConnectionWhere>;
  /** Return Messages where all of the related FileBlocks match this filter */
  fileBlocks_ALL?: InputMaybe<FileBlockWhere>;
  /** Return Messages where none of the related FileBlocks match this filter */
  fileBlocks_NONE?: InputMaybe<FileBlockWhere>;
  /** Return Messages where one of the related FileBlocks match this filter */
  fileBlocks_SINGLE?: InputMaybe<FileBlockWhere>;
  /** Return Messages where some of the related FileBlocks match this filter */
  fileBlocks_SOME?: InputMaybe<FileBlockWhere>;
  fileConnection?: InputMaybe<MessageFileConnectionWhere>;
  fileConnection_NOT?: InputMaybe<MessageFileConnectionWhere>;
  file_NOT?: InputMaybe<FileWhere>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  harassment?: InputMaybe<Scalars['Boolean']['input']>;
  harassment_threatening?: InputMaybe<Scalars['Boolean']['input']>;
  hate?: InputMaybe<Scalars['Boolean']['input']>;
  hate_threatening?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  index_GT?: InputMaybe<Scalars['Int']['input']>;
  index_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  index_LT?: InputMaybe<Scalars['Int']['input']>;
  index_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  last_modified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  nodeId?: InputMaybe<Scalars['String']['input']>;
  nodeId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  nodeId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  nodeId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nodeId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['String']['input']>;
  parameters_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  parameters_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  parameters_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parameters_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  self_harm?: InputMaybe<Scalars['Boolean']['input']>;
  self_harm_instructions?: InputMaybe<Scalars['Boolean']['input']>;
  self_harm_intent?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sender_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  sender_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  sender_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sender_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sexual?: InputMaybe<Scalars['Boolean']['input']>;
  sexual_minors?: InputMaybe<Scalars['Boolean']['input']>;
  snackType?: InputMaybe<Scalars['String']['input']>;
  snackType_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  snackType_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  snackType_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  snackType_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  textBlocksAggregate?: InputMaybe<MessageTextBlocksAggregateInput>;
  /** Return Messages where all of the related MessageTextBlocksConnections match this filter */
  textBlocksConnection_ALL?: InputMaybe<MessageTextBlocksConnectionWhere>;
  /** Return Messages where none of the related MessageTextBlocksConnections match this filter */
  textBlocksConnection_NONE?: InputMaybe<MessageTextBlocksConnectionWhere>;
  /** Return Messages where one of the related MessageTextBlocksConnections match this filter */
  textBlocksConnection_SINGLE?: InputMaybe<MessageTextBlocksConnectionWhere>;
  /** Return Messages where some of the related MessageTextBlocksConnections match this filter */
  textBlocksConnection_SOME?: InputMaybe<MessageTextBlocksConnectionWhere>;
  /** Return Messages where all of the related TextBlocks match this filter */
  textBlocks_ALL?: InputMaybe<TextBlockWhere>;
  /** Return Messages where none of the related TextBlocks match this filter */
  textBlocks_NONE?: InputMaybe<TextBlockWhere>;
  /** Return Messages where one of the related TextBlocks match this filter */
  textBlocks_SINGLE?: InputMaybe<TextBlockWhere>;
  /** Return Messages where some of the related TextBlocks match this filter */
  textBlocks_SOME?: InputMaybe<TextBlockWhere>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  type_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<VideoWhere>;
  videoAggregate?: InputMaybe<MessageVideoAggregateInput>;
  videoConnection?: InputMaybe<MessageVideoConnectionWhere>;
  videoConnection_NOT?: InputMaybe<MessageVideoConnectionWhere>;
  video_NOT?: InputMaybe<VideoWhere>;
  violence?: InputMaybe<Scalars['Boolean']['input']>;
  violence_graphic?: InputMaybe<Scalars['Boolean']['input']>;
  visualization?: InputMaybe<VisualizationWhere>;
  visualizationAggregate?: InputMaybe<MessageVisualizationAggregateInput>;
  visualizationConnection?: InputMaybe<MessageVisualizationConnectionWhere>;
  visualizationConnection_NOT?: InputMaybe<MessageVisualizationConnectionWhere>;
  visualization_NOT?: InputMaybe<VisualizationWhere>;
};

export enum ModerationCategory {
  Harassment = 'HARASSMENT',
  HarassmentThreatening = 'HARASSMENT_THREATENING',
  Hate = 'HATE',
  HateThreatening = 'HATE_THREATENING',
  SelfHarm = 'SELF_HARM',
  SelfHarmInstructions = 'SELF_HARM_INSTRUCTIONS',
  SelfHarmIntent = 'SELF_HARM_INTENT',
  Sexual = 'SEXUAL',
  SexualMinors = 'SEXUAL_MINORS',
  Violence = 'VIOLENCE',
  ViolenceGraphic = 'VIOLENCE_GRAPHIC'
}

export type Module = {
  __typename?: 'Module';
  aiTutors: Array<AiTutor>;
  aiTutorsAggregate?: Maybe<ModuleAiTutorAiTutorsAggregationSelection>;
  aiTutorsConnection: ModuleAiTutorsConnection;
  assessment?: Maybe<Assessment>;
  assessmentAggregate?: Maybe<ModuleAssessmentAssessmentAggregationSelection>;
  assessmentConnection: ModuleAssessmentConnection;
  assignments: Array<Assignment>;
  assignmentsAggregate?: Maybe<ModuleAssignmentAssignmentsAggregationSelection>;
  assignmentsConnection: ModuleAssignmentsConnection;
  axioResources: Array<AxioResource>;
  axioResourcesAggregate?: Maybe<ModuleAxioResourceAxioResourcesAggregationSelection>;
  axioResourcesConnection: ModuleAxioResourcesConnection;
  courseHasModules: Array<Course>;
  courseHasModulesAggregate?: Maybe<ModuleCourseCourseHasModulesAggregationSelection>;
  courseHasModulesConnection: ModuleCourseHasModulesConnection;
  created?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageGenerationStatus?: Maybe<ModuleImageGenerationStatus>;
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  lessonPlanFile?: Maybe<File>;
  lessonPlanFileAggregate?: Maybe<ModuleFileLessonPlanFileAggregationSelection>;
  lessonPlanFileConnection: ModuleLessonPlanFileConnection;
  lessonPlanGenerating?: Maybe<Scalars['Boolean']['output']>;
  module_name?: Maybe<Scalars['String']['output']>;
  nudgesAboutThis: Array<Nudge>;
  nudgesAboutThisAggregate?: Maybe<ModuleNudgeNudgesAboutThisAggregationSelection>;
  nudgesAboutThisConnection: ModuleNudgesAboutThisConnection;
  pages: Array<Page>;
  pagesAggregate?: Maybe<ModulePagePagesAggregationSelection>;
  pagesConnection: ModulePagesConnection;
  projects: Array<Project>;
  projectsAggregate?: Maybe<ModuleProjectProjectsAggregationSelection>;
  projectsConnection: ModuleProjectsConnection;
  resourceOrder?: Maybe<Array<Scalars['String']['output']>>;
  reviews: Array<Review>;
  reviewsAggregate?: Maybe<ModuleReviewReviewsAggregationSelection>;
  reviewsConnection: ModuleReviewsConnection;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ModuleAiTutorsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AiTutorOptions>;
  where?: InputMaybe<AiTutorWhere>;
};


export type ModuleAiTutorsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AiTutorWhere>;
};


export type ModuleAiTutorsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ModuleAiTutorsConnectionSort>>;
  where?: InputMaybe<ModuleAiTutorsConnectionWhere>;
};


export type ModuleAssessmentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AssessmentOptions>;
  where?: InputMaybe<AssessmentWhere>;
};


export type ModuleAssessmentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssessmentWhere>;
};


export type ModuleAssessmentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ModuleAssessmentConnectionSort>>;
  where?: InputMaybe<ModuleAssessmentConnectionWhere>;
};


export type ModuleAssignmentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AssignmentOptions>;
  where?: InputMaybe<AssignmentWhere>;
};


export type ModuleAssignmentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssignmentWhere>;
};


export type ModuleAssignmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ModuleAssignmentsConnectionSort>>;
  where?: InputMaybe<ModuleAssignmentsConnectionWhere>;
};


export type ModuleAxioResourcesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AxioResourceOptions>;
  where?: InputMaybe<AxioResourceWhere>;
};


export type ModuleAxioResourcesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AxioResourceWhere>;
};


export type ModuleAxioResourcesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ModuleAxioResourcesConnectionSort>>;
  where?: InputMaybe<ModuleAxioResourcesConnectionWhere>;
};


export type ModuleCourseHasModulesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CourseOptions>;
  where?: InputMaybe<CourseWhere>;
};


export type ModuleCourseHasModulesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CourseWhere>;
};


export type ModuleCourseHasModulesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ModuleCourseHasModulesConnectionSort>>;
  where?: InputMaybe<ModuleCourseHasModulesConnectionWhere>;
};


export type ModuleLessonPlanFileArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FileOptions>;
  where?: InputMaybe<FileWhere>;
};


export type ModuleLessonPlanFileAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FileWhere>;
};


export type ModuleLessonPlanFileConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ModuleLessonPlanFileConnectionSort>>;
  where?: InputMaybe<ModuleLessonPlanFileConnectionWhere>;
};


export type ModuleNudgesAboutThisArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<NudgeOptions>;
  where?: InputMaybe<NudgeWhere>;
};


export type ModuleNudgesAboutThisAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NudgeWhere>;
};


export type ModuleNudgesAboutThisConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ModuleNudgesAboutThisConnectionSort>>;
  where?: InputMaybe<ModuleNudgesAboutThisConnectionWhere>;
};


export type ModulePagesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PageOptions>;
  where?: InputMaybe<PageWhere>;
};


export type ModulePagesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PageWhere>;
};


export type ModulePagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ModulePagesConnectionSort>>;
  where?: InputMaybe<ModulePagesConnectionWhere>;
};


export type ModuleProjectsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProjectOptions>;
  where?: InputMaybe<ProjectWhere>;
};


export type ModuleProjectsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProjectWhere>;
};


export type ModuleProjectsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ModuleProjectsConnectionSort>>;
  where?: InputMaybe<ModuleProjectsConnectionWhere>;
};


export type ModuleReviewsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ReviewOptions>;
  where?: InputMaybe<ReviewWhere>;
};


export type ModuleReviewsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ReviewWhere>;
};


export type ModuleReviewsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ModuleReviewsConnectionSort>>;
  where?: InputMaybe<ModuleReviewsConnectionWhere>;
};

export type ModuleAiTutorAiTutorsAggregationSelection = {
  __typename?: 'ModuleAITutorAiTutorsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ModuleAiTutorAiTutorsNodeAggregateSelection>;
};

export type ModuleAiTutorAiTutorsNodeAggregateSelection = {
  __typename?: 'ModuleAITutorAiTutorsNodeAggregateSelection';
  context: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  targetAudience: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type ModuleAiTutors = {
  __typename?: 'ModuleAiTutors';
  aiTutors?: Maybe<Array<Maybe<AiTutor>>>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ModuleAiTutorsAggregateInput = {
  AND?: InputMaybe<Array<ModuleAiTutorsAggregateInput>>;
  NOT?: InputMaybe<ModuleAiTutorsAggregateInput>;
  OR?: InputMaybe<Array<ModuleAiTutorsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ModuleAiTutorsNodeAggregationWhereInput>;
};

export type ModuleAiTutorsConnectFieldInput = {
  connect?: InputMaybe<Array<AiTutorConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AiTutorConnectWhere>;
};

export type ModuleAiTutorsConnectOrCreateFieldInput = {
  onCreate: ModuleAiTutorsConnectOrCreateFieldInputOnCreate;
  where: AiTutorConnectOrCreateWhere;
};

export type ModuleAiTutorsConnectOrCreateFieldInputOnCreate = {
  node: AiTutorOnCreateInput;
};

export type ModuleAiTutorsConnection = {
  __typename?: 'ModuleAiTutorsConnection';
  edges: Array<ModuleAiTutorsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ModuleAiTutorsConnectionSort = {
  node?: InputMaybe<AiTutorSort>;
};

export type ModuleAiTutorsConnectionWhere = {
  AND?: InputMaybe<Array<ModuleAiTutorsConnectionWhere>>;
  NOT?: InputMaybe<ModuleAiTutorsConnectionWhere>;
  OR?: InputMaybe<Array<ModuleAiTutorsConnectionWhere>>;
  node?: InputMaybe<AiTutorWhere>;
};

export type ModuleAiTutorsCreateFieldInput = {
  node: AiTutorCreateInput;
};

export type ModuleAiTutorsDeleteFieldInput = {
  delete?: InputMaybe<AiTutorDeleteInput>;
  where?: InputMaybe<ModuleAiTutorsConnectionWhere>;
};

export type ModuleAiTutorsDisconnectFieldInput = {
  disconnect?: InputMaybe<AiTutorDisconnectInput>;
  where?: InputMaybe<ModuleAiTutorsConnectionWhere>;
};

export type ModuleAiTutorsFieldInput = {
  connect?: InputMaybe<Array<ModuleAiTutorsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ModuleAiTutorsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ModuleAiTutorsCreateFieldInput>>;
};

export type ModuleAiTutorsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ModuleAiTutorsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ModuleAiTutorsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ModuleAiTutorsNodeAggregationWhereInput>>;
  context_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  context_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ModuleAiTutorsRelationship = {
  __typename?: 'ModuleAiTutorsRelationship';
  cursor: Scalars['String']['output'];
  node: AiTutor;
};

export type ModuleAiTutorsUpdateConnectionInput = {
  node?: InputMaybe<AiTutorUpdateInput>;
};

export type ModuleAiTutorsUpdateFieldInput = {
  connect?: InputMaybe<Array<ModuleAiTutorsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ModuleAiTutorsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ModuleAiTutorsCreateFieldInput>>;
  delete?: InputMaybe<Array<ModuleAiTutorsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ModuleAiTutorsDisconnectFieldInput>>;
  update?: InputMaybe<ModuleAiTutorsUpdateConnectionInput>;
  where?: InputMaybe<ModuleAiTutorsConnectionWhere>;
};

export type ModuleAnalytics = {
  __typename?: 'ModuleAnalytics';
  active_interaction_count: Scalars['Int']['output'];
  average_time_taken?: Maybe<Scalars['Float']['output']>;
  confusion_points: Scalars['Int']['output'];
  details: ModuleAnalyticsDetails;
  distractions: Scalars['Int']['output'];
  enrollment: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  questions_asked: Scalars['Int']['output'];
  sentiment: Scalars['String']['output'];
  success_points: Scalars['Int']['output'];
};

export type ModuleAnalyticsDetails = {
  __typename?: 'ModuleAnalyticsDetails';
  activities: Array<ActivityAnalytics>;
};

export type ModuleAnalyticsResponse = {
  __typename?: 'ModuleAnalyticsResponse';
  count: Scalars['Int']['output'];
  data: Array<ModuleAnalytics>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ModuleAssessmentAggregateInput = {
  AND?: InputMaybe<Array<ModuleAssessmentAggregateInput>>;
  NOT?: InputMaybe<ModuleAssessmentAggregateInput>;
  OR?: InputMaybe<Array<ModuleAssessmentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ModuleAssessmentNodeAggregationWhereInput>;
};

export type ModuleAssessmentAssessmentAggregationSelection = {
  __typename?: 'ModuleAssessmentAssessmentAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ModuleAssessmentAssessmentNodeAggregateSelection>;
};

export type ModuleAssessmentAssessmentNodeAggregateSelection = {
  __typename?: 'ModuleAssessmentAssessmentNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  numberOfQuestions: IntAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  timeLimit: IntAggregateSelection;
};

export type ModuleAssessmentConnectFieldInput = {
  connect?: InputMaybe<AssessmentConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AssessmentConnectWhere>;
};

export type ModuleAssessmentConnectOrCreateFieldInput = {
  onCreate: ModuleAssessmentConnectOrCreateFieldInputOnCreate;
  where: AssessmentConnectOrCreateWhere;
};

export type ModuleAssessmentConnectOrCreateFieldInputOnCreate = {
  node: AssessmentOnCreateInput;
};

export type ModuleAssessmentConnection = {
  __typename?: 'ModuleAssessmentConnection';
  edges: Array<ModuleAssessmentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ModuleAssessmentConnectionSort = {
  node?: InputMaybe<AssessmentSort>;
};

export type ModuleAssessmentConnectionWhere = {
  AND?: InputMaybe<Array<ModuleAssessmentConnectionWhere>>;
  NOT?: InputMaybe<ModuleAssessmentConnectionWhere>;
  OR?: InputMaybe<Array<ModuleAssessmentConnectionWhere>>;
  node?: InputMaybe<AssessmentWhere>;
};

export type ModuleAssessmentCreateFieldInput = {
  node: AssessmentCreateInput;
};

export type ModuleAssessmentDeleteFieldInput = {
  delete?: InputMaybe<AssessmentDeleteInput>;
  where?: InputMaybe<ModuleAssessmentConnectionWhere>;
};

export type ModuleAssessmentDisconnectFieldInput = {
  disconnect?: InputMaybe<AssessmentDisconnectInput>;
  where?: InputMaybe<ModuleAssessmentConnectionWhere>;
};

export type ModuleAssessmentFieldInput = {
  connect?: InputMaybe<ModuleAssessmentConnectFieldInput>;
  connectOrCreate?: InputMaybe<ModuleAssessmentConnectOrCreateFieldInput>;
  create?: InputMaybe<ModuleAssessmentCreateFieldInput>;
};

export type ModuleAssessmentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ModuleAssessmentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ModuleAssessmentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ModuleAssessmentNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfQuestions_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  timeLimit_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ModuleAssessmentRelationship = {
  __typename?: 'ModuleAssessmentRelationship';
  cursor: Scalars['String']['output'];
  node: Assessment;
};

export type ModuleAssessmentUpdateConnectionInput = {
  node?: InputMaybe<AssessmentUpdateInput>;
};

export type ModuleAssessmentUpdateFieldInput = {
  connect?: InputMaybe<ModuleAssessmentConnectFieldInput>;
  connectOrCreate?: InputMaybe<ModuleAssessmentConnectOrCreateFieldInput>;
  create?: InputMaybe<ModuleAssessmentCreateFieldInput>;
  delete?: InputMaybe<ModuleAssessmentDeleteFieldInput>;
  disconnect?: InputMaybe<ModuleAssessmentDisconnectFieldInput>;
  update?: InputMaybe<ModuleAssessmentUpdateConnectionInput>;
  where?: InputMaybe<ModuleAssessmentConnectionWhere>;
};

export type ModuleAssignmentAssignmentsAggregationSelection = {
  __typename?: 'ModuleAssignmentAssignmentsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ModuleAssignmentAssignmentsNodeAggregateSelection>;
};

export type ModuleAssignmentAssignmentsNodeAggregateSelection = {
  __typename?: 'ModuleAssignmentAssignmentsNodeAggregateSelection';
  _empty: StringAggregateSelection;
  allowed_attempts: FloatAggregateSelection;
  assignee_mode: StringAggregateSelection;
  assignment_group_id: FloatAggregateSelection;
  assignment_name: StringAggregateSelection;
  body: StringAggregateSelection;
  category_id: StringAggregateSelection;
  course_id: FloatAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  description: StringAggregateSelection;
  description_plaintext: StringAggregateSelection;
  discussion_topic_assignment_id: FloatAggregateSelection;
  discussion_topic_author_anonymous_id: StringAggregateSelection;
  discussion_topic_author_avatar_image_url: StringAggregateSelection;
  discussion_topic_author_display_name: StringAggregateSelection;
  discussion_topic_author_html_url: StringAggregateSelection;
  discussion_topic_author_id: FloatAggregateSelection;
  discussion_topic_created_at: StringAggregateSelection;
  discussion_topic_discussion_subentry_count: FloatAggregateSelection;
  discussion_topic_discussion_type: StringAggregateSelection;
  discussion_topic_html_url: StringAggregateSelection;
  discussion_topic_id: FloatAggregateSelection;
  discussion_topic_last_reply_at: StringAggregateSelection;
  discussion_topic_message: StringAggregateSelection;
  discussion_topic_posted_at: StringAggregateSelection;
  discussion_topic_read_state: StringAggregateSelection;
  discussion_topic_title: StringAggregateSelection;
  discussion_topic_unread_count: FloatAggregateSelection;
  discussion_topic_url: StringAggregateSelection;
  discussion_topic_user_name: StringAggregateSelection;
  display_date: StringAggregateSelection;
  due_at: StringAggregateSelection;
  due_date: DateTimeAggregateSelection;
  end_date: StringAggregateSelection;
  external_tool_tag_attributes_content_id: FloatAggregateSelection;
  external_tool_tag_attributes_content_type: StringAggregateSelection;
  external_tool_tag_attributes_external_data: StringAggregateSelection;
  external_tool_tag_attributes_resource_link_id: StringAggregateSelection;
  external_tool_tag_attributes_url: StringAggregateSelection;
  grade_points: FloatAggregateSelection;
  grader_count: FloatAggregateSelection;
  grading_type: StringAggregateSelection;
  html: StringAggregateSelection;
  html_url: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  lti_context_id: StringAggregateSelection;
  max_attempts: FloatAggregateSelection;
  max_name_length: FloatAggregateSelection;
  name: StringAggregateSelection;
  needs_grading_count: FloatAggregateSelection;
  objectives: StringAggregateSelection;
  points_possible: FloatAggregateSelection;
  position: FloatAggregateSelection;
  resource_metadata: StringAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  secure_params: StringAggregateSelection;
  session_id: StringAggregateSelection;
  start_date: StringAggregateSelection;
  state: StringAggregateSelection;
  submissions_download_url: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_at: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  url: StringAggregateSelection;
  videoUrl: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export type ModuleAssignmentsAggregateInput = {
  AND?: InputMaybe<Array<ModuleAssignmentsAggregateInput>>;
  NOT?: InputMaybe<ModuleAssignmentsAggregateInput>;
  OR?: InputMaybe<Array<ModuleAssignmentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ModuleAssignmentsNodeAggregationWhereInput>;
};

export type ModuleAssignmentsConnectFieldInput = {
  connect?: InputMaybe<Array<AssignmentConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AssignmentConnectWhere>;
};

export type ModuleAssignmentsConnectOrCreateFieldInput = {
  onCreate: ModuleAssignmentsConnectOrCreateFieldInputOnCreate;
  where: AssignmentConnectOrCreateWhere;
};

export type ModuleAssignmentsConnectOrCreateFieldInputOnCreate = {
  node: AssignmentOnCreateInput;
};

export type ModuleAssignmentsConnection = {
  __typename?: 'ModuleAssignmentsConnection';
  edges: Array<ModuleAssignmentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ModuleAssignmentsConnectionSort = {
  node?: InputMaybe<AssignmentSort>;
};

export type ModuleAssignmentsConnectionWhere = {
  AND?: InputMaybe<Array<ModuleAssignmentsConnectionWhere>>;
  NOT?: InputMaybe<ModuleAssignmentsConnectionWhere>;
  OR?: InputMaybe<Array<ModuleAssignmentsConnectionWhere>>;
  node?: InputMaybe<AssignmentWhere>;
};

export type ModuleAssignmentsCreateFieldInput = {
  node: AssignmentCreateInput;
};

export type ModuleAssignmentsDeleteFieldInput = {
  delete?: InputMaybe<AssignmentDeleteInput>;
  where?: InputMaybe<ModuleAssignmentsConnectionWhere>;
};

export type ModuleAssignmentsDisconnectFieldInput = {
  disconnect?: InputMaybe<AssignmentDisconnectInput>;
  where?: InputMaybe<ModuleAssignmentsConnectionWhere>;
};

export type ModuleAssignmentsFieldInput = {
  connect?: InputMaybe<Array<ModuleAssignmentsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ModuleAssignmentsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ModuleAssignmentsCreateFieldInput>>;
};

export type ModuleAssignmentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ModuleAssignmentsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ModuleAssignmentsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ModuleAssignmentsNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  allowed_attempts_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_group_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  body_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  category_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_assignment_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_unread_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  display_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  due_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_date_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_points_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  html_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lti_context_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  max_attempts_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  needs_grading_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  points_possible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  secure_params_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  secure_params_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  session_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ModuleAssignmentsRelationship = {
  __typename?: 'ModuleAssignmentsRelationship';
  cursor: Scalars['String']['output'];
  node: Assignment;
};

export type ModuleAssignmentsUpdateConnectionInput = {
  node?: InputMaybe<AssignmentUpdateInput>;
};

export type ModuleAssignmentsUpdateFieldInput = {
  connect?: InputMaybe<Array<ModuleAssignmentsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ModuleAssignmentsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ModuleAssignmentsCreateFieldInput>>;
  delete?: InputMaybe<Array<ModuleAssignmentsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ModuleAssignmentsDisconnectFieldInput>>;
  update?: InputMaybe<ModuleAssignmentsUpdateConnectionInput>;
  where?: InputMaybe<ModuleAssignmentsConnectionWhere>;
};

export type ModuleAxioResourceAxioResourcesAggregationSelection = {
  __typename?: 'ModuleAxioResourceAxioResourcesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ModuleAxioResourceAxioResourcesNodeAggregateSelection>;
};

export type ModuleAxioResourceAxioResourcesNodeAggregateSelection = {
  __typename?: 'ModuleAxioResourceAxioResourcesNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  moduleId: IdAggregateSelection;
  name: StringAggregateSelection;
  order: IntAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  videoUrl: StringAggregateSelection;
};

export type ModuleAxioResourcesAggregateInput = {
  AND?: InputMaybe<Array<ModuleAxioResourcesAggregateInput>>;
  NOT?: InputMaybe<ModuleAxioResourcesAggregateInput>;
  OR?: InputMaybe<Array<ModuleAxioResourcesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ModuleAxioResourcesNodeAggregationWhereInput>;
};

export type ModuleAxioResourcesConnectFieldInput = {
  connect?: InputMaybe<Array<AxioResourceConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AxioResourceConnectWhere>;
};

export type ModuleAxioResourcesConnectOrCreateFieldInput = {
  onCreate: ModuleAxioResourcesConnectOrCreateFieldInputOnCreate;
  where: AxioResourceConnectOrCreateWhere;
};

export type ModuleAxioResourcesConnectOrCreateFieldInputOnCreate = {
  node: AxioResourceOnCreateInput;
};

export type ModuleAxioResourcesConnection = {
  __typename?: 'ModuleAxioResourcesConnection';
  edges: Array<ModuleAxioResourcesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ModuleAxioResourcesConnectionSort = {
  node?: InputMaybe<AxioResourceSort>;
};

export type ModuleAxioResourcesConnectionWhere = {
  AND?: InputMaybe<Array<ModuleAxioResourcesConnectionWhere>>;
  NOT?: InputMaybe<ModuleAxioResourcesConnectionWhere>;
  OR?: InputMaybe<Array<ModuleAxioResourcesConnectionWhere>>;
  node?: InputMaybe<AxioResourceWhere>;
};

export type ModuleAxioResourcesCreateFieldInput = {
  node: AxioResourceCreateInput;
};

export type ModuleAxioResourcesDeleteFieldInput = {
  delete?: InputMaybe<AxioResourceDeleteInput>;
  where?: InputMaybe<ModuleAxioResourcesConnectionWhere>;
};

export type ModuleAxioResourcesDisconnectFieldInput = {
  disconnect?: InputMaybe<AxioResourceDisconnectInput>;
  where?: InputMaybe<ModuleAxioResourcesConnectionWhere>;
};

export type ModuleAxioResourcesFieldInput = {
  connect?: InputMaybe<Array<ModuleAxioResourcesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ModuleAxioResourcesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ModuleAxioResourcesCreateFieldInput>>;
};

export type ModuleAxioResourcesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ModuleAxioResourcesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ModuleAxioResourcesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ModuleAxioResourcesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ModuleAxioResourcesRelationship = {
  __typename?: 'ModuleAxioResourcesRelationship';
  cursor: Scalars['String']['output'];
  node: AxioResource;
};

export type ModuleAxioResourcesUpdateConnectionInput = {
  node?: InputMaybe<AxioResourceUpdateInput>;
};

export type ModuleAxioResourcesUpdateFieldInput = {
  connect?: InputMaybe<Array<ModuleAxioResourcesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ModuleAxioResourcesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ModuleAxioResourcesCreateFieldInput>>;
  delete?: InputMaybe<Array<ModuleAxioResourcesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ModuleAxioResourcesDisconnectFieldInput>>;
  update?: InputMaybe<ModuleAxioResourcesUpdateConnectionInput>;
  where?: InputMaybe<ModuleAxioResourcesConnectionWhere>;
};

export type ModuleCompletionDetails = {
  __typename?: 'ModuleCompletionDetails';
  completionStats: CompletionStats;
  details: ModuleCompletionDetailsData;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type ModuleCompletionDetailsActivities = {
  __typename?: 'ModuleCompletionDetailsActivities';
  activities: Array<ActivityCompletionDetails>;
};

export type ModuleCompletionDetailsData = {
  __typename?: 'ModuleCompletionDetailsData';
  activities: Array<ActivityCompletionDetails>;
};

export type ModuleCompletionDetailsFull = {
  __typename?: 'ModuleCompletionDetailsFull';
  completionStats: CompletionStats;
  course_id: Scalars['ID']['output'];
  course_name: Scalars['String']['output'];
  details: ModuleCompletionDetailsActivities;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type ModuleCompletionDetailsResponse = {
  __typename?: 'ModuleCompletionDetailsResponse';
  count: Scalars['Int']['output'];
  data: Array<ModuleCompletionDetailsFull>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ModuleConnectInput = {
  aiTutors?: InputMaybe<Array<ModuleAiTutorsConnectFieldInput>>;
  assessment?: InputMaybe<ModuleAssessmentConnectFieldInput>;
  assignments?: InputMaybe<Array<ModuleAssignmentsConnectFieldInput>>;
  axioResources?: InputMaybe<Array<ModuleAxioResourcesConnectFieldInput>>;
  courseHasModules?: InputMaybe<Array<ModuleCourseHasModulesConnectFieldInput>>;
  lessonPlanFile?: InputMaybe<ModuleLessonPlanFileConnectFieldInput>;
  nudgesAboutThis?: InputMaybe<Array<ModuleNudgesAboutThisConnectFieldInput>>;
  pages?: InputMaybe<Array<ModulePagesConnectFieldInput>>;
  projects?: InputMaybe<Array<ModuleProjectsConnectFieldInput>>;
  reviews?: InputMaybe<Array<ModuleReviewsConnectFieldInput>>;
};

export type ModuleConnectOrCreateWhere = {
  node: ModuleUniqueWhere;
};

export type ModuleConnectWhere = {
  node: ModuleWhere;
};

export type ModuleCourseCourseHasModulesAggregationSelection = {
  __typename?: 'ModuleCourseCourseHasModulesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ModuleCourseCourseHasModulesNodeAggregateSelection>;
};

export type ModuleCourseCourseHasModulesNodeAggregateSelection = {
  __typename?: 'ModuleCourseCourseHasModulesNodeAggregateSelection';
  account_id: FloatAggregateSelection;
  calendar_ics: StringAggregateSelection;
  cost: FloatAggregateSelection;
  courseId: StringAggregateSelection;
  course_code: StringAggregateSelection;
  course_id: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  default_view: StringAggregateSelection;
  description: StringAggregateSelection;
  dueDateEndDate: DateTimeAggregateSelection;
  dueDateStartDate: DateTimeAggregateSelection;
  endDate: DateTimeAggregateSelection;
  end_at: StringAggregateSelection;
  enrollment_term_id: FloatAggregateSelection;
  grading_standard_id: FloatAggregateSelection;
  id: IdAggregateSelection;
  integration_id: StringAggregateSelection;
  label: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  learningStandards: StringAggregateSelection;
  lengthInWeeks: FloatAggregateSelection;
  license: StringAggregateSelection;
  lti_id: StringAggregateSelection;
  name: StringAggregateSelection;
  original_name: StringAggregateSelection;
  root_account_id: FloatAggregateSelection;
  sis_course_id: StringAggregateSelection;
  sis_import_id: FloatAggregateSelection;
  startDate: DateTimeAggregateSelection;
  start_at: StringAggregateSelection;
  state: StringAggregateSelection;
  storage_quota_mb: FloatAggregateSelection;
  stripePriceId: StringAggregateSelection;
  stripeProductId: StringAggregateSelection;
  targetAudience: StringAggregateSelection;
  thumbnail: StringAggregateSelection;
  time_zone: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  uuid: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export type ModuleCourseHasModulesAggregateInput = {
  AND?: InputMaybe<Array<ModuleCourseHasModulesAggregateInput>>;
  NOT?: InputMaybe<ModuleCourseHasModulesAggregateInput>;
  OR?: InputMaybe<Array<ModuleCourseHasModulesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ModuleCourseHasModulesNodeAggregationWhereInput>;
};

export type ModuleCourseHasModulesConnectFieldInput = {
  connect?: InputMaybe<Array<CourseConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CourseConnectWhere>;
};

export type ModuleCourseHasModulesConnectOrCreateFieldInput = {
  onCreate: ModuleCourseHasModulesConnectOrCreateFieldInputOnCreate;
  where: CourseConnectOrCreateWhere;
};

export type ModuleCourseHasModulesConnectOrCreateFieldInputOnCreate = {
  node: CourseOnCreateInput;
};

export type ModuleCourseHasModulesConnection = {
  __typename?: 'ModuleCourseHasModulesConnection';
  edges: Array<ModuleCourseHasModulesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ModuleCourseHasModulesConnectionSort = {
  node?: InputMaybe<CourseSort>;
};

export type ModuleCourseHasModulesConnectionWhere = {
  AND?: InputMaybe<Array<ModuleCourseHasModulesConnectionWhere>>;
  NOT?: InputMaybe<ModuleCourseHasModulesConnectionWhere>;
  OR?: InputMaybe<Array<ModuleCourseHasModulesConnectionWhere>>;
  node?: InputMaybe<CourseWhere>;
};

export type ModuleCourseHasModulesCreateFieldInput = {
  node: CourseCreateInput;
};

export type ModuleCourseHasModulesDeleteFieldInput = {
  delete?: InputMaybe<CourseDeleteInput>;
  where?: InputMaybe<ModuleCourseHasModulesConnectionWhere>;
};

export type ModuleCourseHasModulesDisconnectFieldInput = {
  disconnect?: InputMaybe<CourseDisconnectInput>;
  where?: InputMaybe<ModuleCourseHasModulesConnectionWhere>;
};

export type ModuleCourseHasModulesFieldInput = {
  connect?: InputMaybe<Array<ModuleCourseHasModulesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ModuleCourseHasModulesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ModuleCourseHasModulesCreateFieldInput>>;
};

export type ModuleCourseHasModulesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ModuleCourseHasModulesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ModuleCourseHasModulesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ModuleCourseHasModulesNodeAggregationWhereInput>>;
  account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  cost_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDateEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  enrollment_term_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  label_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningStandards_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthInWeeks_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  root_account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_import_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  startDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  storage_quota_mb_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ModuleCourseHasModulesRelationship = {
  __typename?: 'ModuleCourseHasModulesRelationship';
  cursor: Scalars['String']['output'];
  node: Course;
};

export type ModuleCourseHasModulesUpdateConnectionInput = {
  node?: InputMaybe<CourseUpdateInput>;
};

export type ModuleCourseHasModulesUpdateFieldInput = {
  connect?: InputMaybe<Array<ModuleCourseHasModulesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ModuleCourseHasModulesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ModuleCourseHasModulesCreateFieldInput>>;
  delete?: InputMaybe<Array<ModuleCourseHasModulesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ModuleCourseHasModulesDisconnectFieldInput>>;
  update?: InputMaybe<ModuleCourseHasModulesUpdateConnectionInput>;
  where?: InputMaybe<ModuleCourseHasModulesConnectionWhere>;
};

export type ModuleCreateInput = {
  aiTutors?: InputMaybe<ModuleAiTutorsFieldInput>;
  assessment?: InputMaybe<ModuleAssessmentFieldInput>;
  assignments?: InputMaybe<ModuleAssignmentsFieldInput>;
  axioResources?: InputMaybe<ModuleAxioResourcesFieldInput>;
  courseHasModules?: InputMaybe<ModuleCourseHasModulesFieldInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageGenerationStatus?: InputMaybe<ModuleImageGenerationStatus>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lessonPlanFile?: InputMaybe<ModuleLessonPlanFileFieldInput>;
  lessonPlanGenerating?: InputMaybe<Scalars['Boolean']['input']>;
  module_name?: InputMaybe<Scalars['String']['input']>;
  nudgesAboutThis?: InputMaybe<ModuleNudgesAboutThisFieldInput>;
  pages?: InputMaybe<ModulePagesFieldInput>;
  projects?: InputMaybe<ModuleProjectsFieldInput>;
  resourceOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  reviews?: InputMaybe<ModuleReviewsFieldInput>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ModuleDeleteInput = {
  aiTutors?: InputMaybe<Array<ModuleAiTutorsDeleteFieldInput>>;
  assessment?: InputMaybe<ModuleAssessmentDeleteFieldInput>;
  assignments?: InputMaybe<Array<ModuleAssignmentsDeleteFieldInput>>;
  axioResources?: InputMaybe<Array<ModuleAxioResourcesDeleteFieldInput>>;
  courseHasModules?: InputMaybe<Array<ModuleCourseHasModulesDeleteFieldInput>>;
  lessonPlanFile?: InputMaybe<ModuleLessonPlanFileDeleteFieldInput>;
  nudgesAboutThis?: InputMaybe<Array<ModuleNudgesAboutThisDeleteFieldInput>>;
  pages?: InputMaybe<Array<ModulePagesDeleteFieldInput>>;
  projects?: InputMaybe<Array<ModuleProjectsDeleteFieldInput>>;
  reviews?: InputMaybe<Array<ModuleReviewsDeleteFieldInput>>;
};

export type ModuleDisconnectInput = {
  aiTutors?: InputMaybe<Array<ModuleAiTutorsDisconnectFieldInput>>;
  assessment?: InputMaybe<ModuleAssessmentDisconnectFieldInput>;
  assignments?: InputMaybe<Array<ModuleAssignmentsDisconnectFieldInput>>;
  axioResources?: InputMaybe<Array<ModuleAxioResourcesDisconnectFieldInput>>;
  courseHasModules?: InputMaybe<Array<ModuleCourseHasModulesDisconnectFieldInput>>;
  lessonPlanFile?: InputMaybe<ModuleLessonPlanFileDisconnectFieldInput>;
  nudgesAboutThis?: InputMaybe<Array<ModuleNudgesAboutThisDisconnectFieldInput>>;
  pages?: InputMaybe<Array<ModulePagesDisconnectFieldInput>>;
  projects?: InputMaybe<Array<ModuleProjectsDisconnectFieldInput>>;
  reviews?: InputMaybe<Array<ModuleReviewsDisconnectFieldInput>>;
};

export type ModuleFileLessonPlanFileAggregationSelection = {
  __typename?: 'ModuleFileLessonPlanFileAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ModuleFileLessonPlanFileNodeAggregateSelection>;
};

export type ModuleFileLessonPlanFileNodeAggregateSelection = {
  __typename?: 'ModuleFileLessonPlanFileNodeAggregateSelection';
  bucketName: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  fileName: StringAggregateSelection;
  filePath: StringAggregateSelection;
  fileURL: StringAggregateSelection;
  id: IdAggregateSelection;
};

export enum ModuleImageGenerationStatus {
  Completed = 'completed',
  Failed = 'failed',
  Generating = 'generating',
  NotStarted = 'not_started'
}

export type ModuleLessonPlanFileAggregateInput = {
  AND?: InputMaybe<Array<ModuleLessonPlanFileAggregateInput>>;
  NOT?: InputMaybe<ModuleLessonPlanFileAggregateInput>;
  OR?: InputMaybe<Array<ModuleLessonPlanFileAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ModuleLessonPlanFileNodeAggregationWhereInput>;
};

export type ModuleLessonPlanFileConnectFieldInput = {
  connect?: InputMaybe<FileConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FileConnectWhere>;
};

export type ModuleLessonPlanFileConnectOrCreateFieldInput = {
  onCreate: ModuleLessonPlanFileConnectOrCreateFieldInputOnCreate;
  where: FileConnectOrCreateWhere;
};

export type ModuleLessonPlanFileConnectOrCreateFieldInputOnCreate = {
  node: FileOnCreateInput;
};

export type ModuleLessonPlanFileConnection = {
  __typename?: 'ModuleLessonPlanFileConnection';
  edges: Array<ModuleLessonPlanFileRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ModuleLessonPlanFileConnectionSort = {
  node?: InputMaybe<FileSort>;
};

export type ModuleLessonPlanFileConnectionWhere = {
  AND?: InputMaybe<Array<ModuleLessonPlanFileConnectionWhere>>;
  NOT?: InputMaybe<ModuleLessonPlanFileConnectionWhere>;
  OR?: InputMaybe<Array<ModuleLessonPlanFileConnectionWhere>>;
  node?: InputMaybe<FileWhere>;
};

export type ModuleLessonPlanFileCreateFieldInput = {
  node: FileCreateInput;
};

export type ModuleLessonPlanFileDeleteFieldInput = {
  delete?: InputMaybe<FileDeleteInput>;
  where?: InputMaybe<ModuleLessonPlanFileConnectionWhere>;
};

export type ModuleLessonPlanFileDisconnectFieldInput = {
  disconnect?: InputMaybe<FileDisconnectInput>;
  where?: InputMaybe<ModuleLessonPlanFileConnectionWhere>;
};

export type ModuleLessonPlanFileFieldInput = {
  connect?: InputMaybe<ModuleLessonPlanFileConnectFieldInput>;
  connectOrCreate?: InputMaybe<ModuleLessonPlanFileConnectOrCreateFieldInput>;
  create?: InputMaybe<ModuleLessonPlanFileCreateFieldInput>;
};

export type ModuleLessonPlanFileNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ModuleLessonPlanFileNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ModuleLessonPlanFileNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ModuleLessonPlanFileNodeAggregationWhereInput>>;
  bucketName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  bucketName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  fileName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileURL_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ModuleLessonPlanFileRelationship = {
  __typename?: 'ModuleLessonPlanFileRelationship';
  cursor: Scalars['String']['output'];
  node: File;
};

export type ModuleLessonPlanFileUpdateConnectionInput = {
  node?: InputMaybe<FileUpdateInput>;
};

export type ModuleLessonPlanFileUpdateFieldInput = {
  connect?: InputMaybe<ModuleLessonPlanFileConnectFieldInput>;
  connectOrCreate?: InputMaybe<ModuleLessonPlanFileConnectOrCreateFieldInput>;
  create?: InputMaybe<ModuleLessonPlanFileCreateFieldInput>;
  delete?: InputMaybe<ModuleLessonPlanFileDeleteFieldInput>;
  disconnect?: InputMaybe<ModuleLessonPlanFileDisconnectFieldInput>;
  update?: InputMaybe<ModuleLessonPlanFileUpdateConnectionInput>;
  where?: InputMaybe<ModuleLessonPlanFileConnectionWhere>;
};

export type ModuleNudgeNudgesAboutThisAggregationSelection = {
  __typename?: 'ModuleNudgeNudgesAboutThisAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ModuleNudgeNudgesAboutThisNodeAggregateSelection>;
};

export type ModuleNudgeNudgesAboutThisNodeAggregateSelection = {
  __typename?: 'ModuleNudgeNudgesAboutThisNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  idempotencyKey: StringAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  priorityScore: FloatAggregateSelection;
  scheduledFor: DateTimeAggregateSelection;
  snoozedUntil: DateTimeAggregateSelection;
  taskCompletedAt: DateTimeAggregateSelection;
};

export type ModuleNudgesAboutThisAggregateInput = {
  AND?: InputMaybe<Array<ModuleNudgesAboutThisAggregateInput>>;
  NOT?: InputMaybe<ModuleNudgesAboutThisAggregateInput>;
  OR?: InputMaybe<Array<ModuleNudgesAboutThisAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ModuleNudgesAboutThisNodeAggregationWhereInput>;
};

export type ModuleNudgesAboutThisConnectFieldInput = {
  connect?: InputMaybe<Array<NudgeConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<NudgeConnectWhere>;
};

export type ModuleNudgesAboutThisConnectOrCreateFieldInput = {
  onCreate: ModuleNudgesAboutThisConnectOrCreateFieldInputOnCreate;
  where: NudgeConnectOrCreateWhere;
};

export type ModuleNudgesAboutThisConnectOrCreateFieldInputOnCreate = {
  node: NudgeOnCreateInput;
};

export type ModuleNudgesAboutThisConnection = {
  __typename?: 'ModuleNudgesAboutThisConnection';
  edges: Array<ModuleNudgesAboutThisRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ModuleNudgesAboutThisConnectionSort = {
  node?: InputMaybe<NudgeSort>;
};

export type ModuleNudgesAboutThisConnectionWhere = {
  AND?: InputMaybe<Array<ModuleNudgesAboutThisConnectionWhere>>;
  NOT?: InputMaybe<ModuleNudgesAboutThisConnectionWhere>;
  OR?: InputMaybe<Array<ModuleNudgesAboutThisConnectionWhere>>;
  node?: InputMaybe<NudgeWhere>;
};

export type ModuleNudgesAboutThisCreateFieldInput = {
  node: NudgeCreateInput;
};

export type ModuleNudgesAboutThisDeleteFieldInput = {
  delete?: InputMaybe<NudgeDeleteInput>;
  where?: InputMaybe<ModuleNudgesAboutThisConnectionWhere>;
};

export type ModuleNudgesAboutThisDisconnectFieldInput = {
  disconnect?: InputMaybe<NudgeDisconnectInput>;
  where?: InputMaybe<ModuleNudgesAboutThisConnectionWhere>;
};

export type ModuleNudgesAboutThisFieldInput = {
  connect?: InputMaybe<Array<ModuleNudgesAboutThisConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ModuleNudgesAboutThisConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ModuleNudgesAboutThisCreateFieldInput>>;
};

export type ModuleNudgesAboutThisNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ModuleNudgesAboutThisNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ModuleNudgesAboutThisNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ModuleNudgesAboutThisNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  idempotencyKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  priorityScore_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  scheduledFor_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ModuleNudgesAboutThisRelationship = {
  __typename?: 'ModuleNudgesAboutThisRelationship';
  cursor: Scalars['String']['output'];
  node: Nudge;
};

export type ModuleNudgesAboutThisUpdateConnectionInput = {
  node?: InputMaybe<NudgeUpdateInput>;
};

export type ModuleNudgesAboutThisUpdateFieldInput = {
  connect?: InputMaybe<Array<ModuleNudgesAboutThisConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ModuleNudgesAboutThisConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ModuleNudgesAboutThisCreateFieldInput>>;
  delete?: InputMaybe<Array<ModuleNudgesAboutThisDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ModuleNudgesAboutThisDisconnectFieldInput>>;
  update?: InputMaybe<ModuleNudgesAboutThisUpdateConnectionInput>;
  where?: InputMaybe<ModuleNudgesAboutThisConnectionWhere>;
};

export type ModuleOnCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageGenerationStatus?: InputMaybe<ModuleImageGenerationStatus>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lessonPlanGenerating?: InputMaybe<Scalars['Boolean']['input']>;
  module_name?: InputMaybe<Scalars['String']['input']>;
  resourceOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ModuleOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ModuleSort objects to sort Modules by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ModuleSort>>;
};

export type ModulePagePagesAggregationSelection = {
  __typename?: 'ModulePagePagesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ModulePagePagesNodeAggregateSelection>;
};

export type ModulePagePagesNodeAggregateSelection = {
  __typename?: 'ModulePagePagesNodeAggregateSelection';
  _empty: StringAggregateSelection;
  assignee_mode: StringAggregateSelection;
  body: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  description: StringAggregateSelection;
  editing_roles: StringAggregateSelection;
  html_url: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  last_edited_by_anonymous_id: StringAggregateSelection;
  last_edited_by_avatar_image_url: StringAggregateSelection;
  last_edited_by_display_name: StringAggregateSelection;
  last_edited_by_html_url: StringAggregateSelection;
  last_edited_by_id: FloatAggregateSelection;
  page_id: FloatAggregateSelection;
  state: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_at: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type ModulePagesAggregateInput = {
  AND?: InputMaybe<Array<ModulePagesAggregateInput>>;
  NOT?: InputMaybe<ModulePagesAggregateInput>;
  OR?: InputMaybe<Array<ModulePagesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ModulePagesNodeAggregationWhereInput>;
};

export type ModulePagesConnectFieldInput = {
  connect?: InputMaybe<Array<PageConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PageConnectWhere>;
};

export type ModulePagesConnectOrCreateFieldInput = {
  onCreate: ModulePagesConnectOrCreateFieldInputOnCreate;
  where: PageConnectOrCreateWhere;
};

export type ModulePagesConnectOrCreateFieldInputOnCreate = {
  node: PageOnCreateInput;
};

export type ModulePagesConnection = {
  __typename?: 'ModulePagesConnection';
  edges: Array<ModulePagesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ModulePagesConnectionSort = {
  node?: InputMaybe<PageSort>;
};

export type ModulePagesConnectionWhere = {
  AND?: InputMaybe<Array<ModulePagesConnectionWhere>>;
  NOT?: InputMaybe<ModulePagesConnectionWhere>;
  OR?: InputMaybe<Array<ModulePagesConnectionWhere>>;
  node?: InputMaybe<PageWhere>;
};

export type ModulePagesCreateFieldInput = {
  node: PageCreateInput;
};

export type ModulePagesDeleteFieldInput = {
  delete?: InputMaybe<PageDeleteInput>;
  where?: InputMaybe<ModulePagesConnectionWhere>;
};

export type ModulePagesDisconnectFieldInput = {
  disconnect?: InputMaybe<PageDisconnectInput>;
  where?: InputMaybe<ModulePagesConnectionWhere>;
};

export type ModulePagesFieldInput = {
  connect?: InputMaybe<Array<ModulePagesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ModulePagesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ModulePagesCreateFieldInput>>;
};

export type ModulePagesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ModulePagesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ModulePagesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ModulePagesNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  body_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  editing_roles_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  editing_roles_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  editing_roles_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  editing_roles_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  editing_roles_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  editing_roles_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  editing_roles_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  editing_roles_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  editing_roles_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  editing_roles_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  editing_roles_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  editing_roles_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  editing_roles_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  editing_roles_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  editing_roles_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_edited_by_anonymous_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_anonymous_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_anonymous_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_anonymous_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_anonymous_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_anonymous_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_anonymous_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_anonymous_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_anonymous_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_anonymous_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_anonymous_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_anonymous_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_anonymous_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_anonymous_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_anonymous_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_avatar_image_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_avatar_image_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_avatar_image_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_avatar_image_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_avatar_image_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_avatar_image_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_avatar_image_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_avatar_image_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_avatar_image_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_avatar_image_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_avatar_image_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_avatar_image_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_avatar_image_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_avatar_image_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_avatar_image_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_display_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_display_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_display_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_display_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_display_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_display_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_display_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_display_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_display_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_display_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_display_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_display_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_display_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_display_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_display_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_edited_by_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  page_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  page_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  page_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  page_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  page_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  page_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  page_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  page_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  page_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  page_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  page_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  page_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  page_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  page_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  page_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  page_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  page_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  page_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  page_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  page_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ModulePagesRelationship = {
  __typename?: 'ModulePagesRelationship';
  cursor: Scalars['String']['output'];
  node: Page;
};

export type ModulePagesUpdateConnectionInput = {
  node?: InputMaybe<PageUpdateInput>;
};

export type ModulePagesUpdateFieldInput = {
  connect?: InputMaybe<Array<ModulePagesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ModulePagesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ModulePagesCreateFieldInput>>;
  delete?: InputMaybe<Array<ModulePagesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ModulePagesDisconnectFieldInput>>;
  update?: InputMaybe<ModulePagesUpdateConnectionInput>;
  where?: InputMaybe<ModulePagesConnectionWhere>;
};

export type ModuleProgressAnalytics = {
  __typename?: 'ModuleProgressAnalytics';
  active_interaction_count: Scalars['Int']['output'];
  completion_percentage?: Maybe<Scalars['Float']['output']>;
  confusion_points: Scalars['Int']['output'];
  details: ModuleProgressDetails;
  distractions: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  questions_asked: Scalars['Int']['output'];
  sentiment: Scalars['String']['output'];
  success_points: Scalars['Int']['output'];
  total_time_taken?: Maybe<Scalars['Float']['output']>;
};

export type ModuleProgressDetails = {
  __typename?: 'ModuleProgressDetails';
  activities: Array<ActivityProgressAnalytics>;
  aiTutors?: Maybe<Array<Maybe<AiTutorProgressAnalytics>>>;
};

export type ModuleProgressInformationData = {
  __typename?: 'ModuleProgressInformationData';
  completedActivities?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  progress?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  totalActivities?: Maybe<Scalars['Int']['output']>;
};

export type ModuleProjectProjectsAggregationSelection = {
  __typename?: 'ModuleProjectProjectsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ModuleProjectProjectsNodeAggregateSelection>;
};

export type ModuleProjectProjectsNodeAggregateSelection = {
  __typename?: 'ModuleProjectProjectsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  moduleId: IdAggregateSelection;
  name: StringAggregateSelection;
  order: IntAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  scopeDocument: StringAggregateSelection;
};

export type ModuleProjectsAggregateInput = {
  AND?: InputMaybe<Array<ModuleProjectsAggregateInput>>;
  NOT?: InputMaybe<ModuleProjectsAggregateInput>;
  OR?: InputMaybe<Array<ModuleProjectsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ModuleProjectsNodeAggregationWhereInput>;
};

export type ModuleProjectsConnectFieldInput = {
  connect?: InputMaybe<Array<ProjectConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ProjectConnectWhere>;
};

export type ModuleProjectsConnectOrCreateFieldInput = {
  onCreate: ModuleProjectsConnectOrCreateFieldInputOnCreate;
  where: ProjectConnectOrCreateWhere;
};

export type ModuleProjectsConnectOrCreateFieldInputOnCreate = {
  node: ProjectOnCreateInput;
};

export type ModuleProjectsConnection = {
  __typename?: 'ModuleProjectsConnection';
  edges: Array<ModuleProjectsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ModuleProjectsConnectionSort = {
  node?: InputMaybe<ProjectSort>;
};

export type ModuleProjectsConnectionWhere = {
  AND?: InputMaybe<Array<ModuleProjectsConnectionWhere>>;
  NOT?: InputMaybe<ModuleProjectsConnectionWhere>;
  OR?: InputMaybe<Array<ModuleProjectsConnectionWhere>>;
  node?: InputMaybe<ProjectWhere>;
};

export type ModuleProjectsCreateFieldInput = {
  node: ProjectCreateInput;
};

export type ModuleProjectsDeleteFieldInput = {
  delete?: InputMaybe<ProjectDeleteInput>;
  where?: InputMaybe<ModuleProjectsConnectionWhere>;
};

export type ModuleProjectsDisconnectFieldInput = {
  disconnect?: InputMaybe<ProjectDisconnectInput>;
  where?: InputMaybe<ModuleProjectsConnectionWhere>;
};

export type ModuleProjectsFieldInput = {
  connect?: InputMaybe<Array<ModuleProjectsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ModuleProjectsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ModuleProjectsCreateFieldInput>>;
};

export type ModuleProjectsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ModuleProjectsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ModuleProjectsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ModuleProjectsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scopeDocument_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scopeDocument_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scopeDocument_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scopeDocument_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scopeDocument_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scopeDocument_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeDocument_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeDocument_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeDocument_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeDocument_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopeDocument_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeDocument_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeDocument_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeDocument_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeDocument_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ModuleProjectsRelationship = {
  __typename?: 'ModuleProjectsRelationship';
  cursor: Scalars['String']['output'];
  node: Project;
};

export type ModuleProjectsUpdateConnectionInput = {
  node?: InputMaybe<ProjectUpdateInput>;
};

export type ModuleProjectsUpdateFieldInput = {
  connect?: InputMaybe<Array<ModuleProjectsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ModuleProjectsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ModuleProjectsCreateFieldInput>>;
  delete?: InputMaybe<Array<ModuleProjectsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ModuleProjectsDisconnectFieldInput>>;
  update?: InputMaybe<ModuleProjectsUpdateConnectionInput>;
  where?: InputMaybe<ModuleProjectsConnectionWhere>;
};

export type ModuleResponse = {
  __typename?: 'ModuleResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<Module>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ModuleReviewReviewsAggregationSelection = {
  __typename?: 'ModuleReviewReviewsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ModuleReviewReviewsNodeAggregateSelection>;
};

export type ModuleReviewReviewsNodeAggregateSelection = {
  __typename?: 'ModuleReviewReviewsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
};

export type ModuleReviewsAggregateInput = {
  AND?: InputMaybe<Array<ModuleReviewsAggregateInput>>;
  NOT?: InputMaybe<ModuleReviewsAggregateInput>;
  OR?: InputMaybe<Array<ModuleReviewsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ModuleReviewsNodeAggregationWhereInput>;
};

export type ModuleReviewsConnectFieldInput = {
  connect?: InputMaybe<Array<ReviewConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ReviewConnectWhere>;
};

export type ModuleReviewsConnectOrCreateFieldInput = {
  onCreate: ModuleReviewsConnectOrCreateFieldInputOnCreate;
  where: ReviewConnectOrCreateWhere;
};

export type ModuleReviewsConnectOrCreateFieldInputOnCreate = {
  node: ReviewOnCreateInput;
};

export type ModuleReviewsConnection = {
  __typename?: 'ModuleReviewsConnection';
  edges: Array<ModuleReviewsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ModuleReviewsConnectionSort = {
  node?: InputMaybe<ReviewSort>;
};

export type ModuleReviewsConnectionWhere = {
  AND?: InputMaybe<Array<ModuleReviewsConnectionWhere>>;
  NOT?: InputMaybe<ModuleReviewsConnectionWhere>;
  OR?: InputMaybe<Array<ModuleReviewsConnectionWhere>>;
  node?: InputMaybe<ReviewWhere>;
};

export type ModuleReviewsCreateFieldInput = {
  node: ReviewCreateInput;
};

export type ModuleReviewsDeleteFieldInput = {
  delete?: InputMaybe<ReviewDeleteInput>;
  where?: InputMaybe<ModuleReviewsConnectionWhere>;
};

export type ModuleReviewsDisconnectFieldInput = {
  disconnect?: InputMaybe<ReviewDisconnectInput>;
  where?: InputMaybe<ModuleReviewsConnectionWhere>;
};

export type ModuleReviewsFieldInput = {
  connect?: InputMaybe<Array<ModuleReviewsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ModuleReviewsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ModuleReviewsCreateFieldInput>>;
};

export type ModuleReviewsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ModuleReviewsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ModuleReviewsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ModuleReviewsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ModuleReviewsRelationship = {
  __typename?: 'ModuleReviewsRelationship';
  cursor: Scalars['String']['output'];
  node: Review;
};

export type ModuleReviewsUpdateConnectionInput = {
  node?: InputMaybe<ReviewUpdateInput>;
};

export type ModuleReviewsUpdateFieldInput = {
  connect?: InputMaybe<Array<ModuleReviewsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ModuleReviewsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ModuleReviewsCreateFieldInput>>;
  delete?: InputMaybe<Array<ModuleReviewsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ModuleReviewsDisconnectFieldInput>>;
  update?: InputMaybe<ModuleReviewsUpdateConnectionInput>;
  where?: InputMaybe<ModuleReviewsConnectionWhere>;
};

/** Fields to sort Modules by. The order in which sorts are applied is not guaranteed when specifying many fields in one ModuleSort object. */
export type ModuleSort = {
  created?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  imageGenerationStatus?: InputMaybe<SortDirection>;
  lastModified?: InputMaybe<SortDirection>;
  lessonPlanGenerating?: InputMaybe<SortDirection>;
  module_name?: InputMaybe<SortDirection>;
  thumbnail?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
};

export type ModuleUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ModuleUpdateInput = {
  aiTutors?: InputMaybe<Array<ModuleAiTutorsUpdateFieldInput>>;
  assessment?: InputMaybe<ModuleAssessmentUpdateFieldInput>;
  assignments?: InputMaybe<Array<ModuleAssignmentsUpdateFieldInput>>;
  axioResources?: InputMaybe<Array<ModuleAxioResourcesUpdateFieldInput>>;
  courseHasModules?: InputMaybe<Array<ModuleCourseHasModulesUpdateFieldInput>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageGenerationStatus?: InputMaybe<ModuleImageGenerationStatus>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lessonPlanFile?: InputMaybe<ModuleLessonPlanFileUpdateFieldInput>;
  lessonPlanGenerating?: InputMaybe<Scalars['Boolean']['input']>;
  module_name?: InputMaybe<Scalars['String']['input']>;
  nudgesAboutThis?: InputMaybe<Array<ModuleNudgesAboutThisUpdateFieldInput>>;
  pages?: InputMaybe<Array<ModulePagesUpdateFieldInput>>;
  projects?: InputMaybe<Array<ModuleProjectsUpdateFieldInput>>;
  resourceOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  resourceOrder_POP?: InputMaybe<Scalars['Int']['input']>;
  resourceOrder_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  reviews?: InputMaybe<Array<ModuleReviewsUpdateFieldInput>>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ModuleWhere = {
  AND?: InputMaybe<Array<ModuleWhere>>;
  NOT?: InputMaybe<ModuleWhere>;
  OR?: InputMaybe<Array<ModuleWhere>>;
  aiTutorsAggregate?: InputMaybe<ModuleAiTutorsAggregateInput>;
  /** Return Modules where all of the related ModuleAiTutorsConnections match this filter */
  aiTutorsConnection_ALL?: InputMaybe<ModuleAiTutorsConnectionWhere>;
  /** Return Modules where none of the related ModuleAiTutorsConnections match this filter */
  aiTutorsConnection_NONE?: InputMaybe<ModuleAiTutorsConnectionWhere>;
  /** Return Modules where one of the related ModuleAiTutorsConnections match this filter */
  aiTutorsConnection_SINGLE?: InputMaybe<ModuleAiTutorsConnectionWhere>;
  /** Return Modules where some of the related ModuleAiTutorsConnections match this filter */
  aiTutorsConnection_SOME?: InputMaybe<ModuleAiTutorsConnectionWhere>;
  /** Return Modules where all of the related AITutors match this filter */
  aiTutors_ALL?: InputMaybe<AiTutorWhere>;
  /** Return Modules where none of the related AITutors match this filter */
  aiTutors_NONE?: InputMaybe<AiTutorWhere>;
  /** Return Modules where one of the related AITutors match this filter */
  aiTutors_SINGLE?: InputMaybe<AiTutorWhere>;
  /** Return Modules where some of the related AITutors match this filter */
  aiTutors_SOME?: InputMaybe<AiTutorWhere>;
  assessment?: InputMaybe<AssessmentWhere>;
  assessmentAggregate?: InputMaybe<ModuleAssessmentAggregateInput>;
  assessmentConnection?: InputMaybe<ModuleAssessmentConnectionWhere>;
  assessmentConnection_NOT?: InputMaybe<ModuleAssessmentConnectionWhere>;
  assessment_NOT?: InputMaybe<AssessmentWhere>;
  assignmentsAggregate?: InputMaybe<ModuleAssignmentsAggregateInput>;
  /** Return Modules where all of the related ModuleAssignmentsConnections match this filter */
  assignmentsConnection_ALL?: InputMaybe<ModuleAssignmentsConnectionWhere>;
  /** Return Modules where none of the related ModuleAssignmentsConnections match this filter */
  assignmentsConnection_NONE?: InputMaybe<ModuleAssignmentsConnectionWhere>;
  /** Return Modules where one of the related ModuleAssignmentsConnections match this filter */
  assignmentsConnection_SINGLE?: InputMaybe<ModuleAssignmentsConnectionWhere>;
  /** Return Modules where some of the related ModuleAssignmentsConnections match this filter */
  assignmentsConnection_SOME?: InputMaybe<ModuleAssignmentsConnectionWhere>;
  /** Return Modules where all of the related Assignments match this filter */
  assignments_ALL?: InputMaybe<AssignmentWhere>;
  /** Return Modules where none of the related Assignments match this filter */
  assignments_NONE?: InputMaybe<AssignmentWhere>;
  /** Return Modules where one of the related Assignments match this filter */
  assignments_SINGLE?: InputMaybe<AssignmentWhere>;
  /** Return Modules where some of the related Assignments match this filter */
  assignments_SOME?: InputMaybe<AssignmentWhere>;
  axioResourcesAggregate?: InputMaybe<ModuleAxioResourcesAggregateInput>;
  /** Return Modules where all of the related ModuleAxioResourcesConnections match this filter */
  axioResourcesConnection_ALL?: InputMaybe<ModuleAxioResourcesConnectionWhere>;
  /** Return Modules where none of the related ModuleAxioResourcesConnections match this filter */
  axioResourcesConnection_NONE?: InputMaybe<ModuleAxioResourcesConnectionWhere>;
  /** Return Modules where one of the related ModuleAxioResourcesConnections match this filter */
  axioResourcesConnection_SINGLE?: InputMaybe<ModuleAxioResourcesConnectionWhere>;
  /** Return Modules where some of the related ModuleAxioResourcesConnections match this filter */
  axioResourcesConnection_SOME?: InputMaybe<ModuleAxioResourcesConnectionWhere>;
  /** Return Modules where all of the related AxioResources match this filter */
  axioResources_ALL?: InputMaybe<AxioResourceWhere>;
  /** Return Modules where none of the related AxioResources match this filter */
  axioResources_NONE?: InputMaybe<AxioResourceWhere>;
  /** Return Modules where one of the related AxioResources match this filter */
  axioResources_SINGLE?: InputMaybe<AxioResourceWhere>;
  /** Return Modules where some of the related AxioResources match this filter */
  axioResources_SOME?: InputMaybe<AxioResourceWhere>;
  courseHasModulesAggregate?: InputMaybe<ModuleCourseHasModulesAggregateInput>;
  /** Return Modules where all of the related ModuleCourseHasModulesConnections match this filter */
  courseHasModulesConnection_ALL?: InputMaybe<ModuleCourseHasModulesConnectionWhere>;
  /** Return Modules where none of the related ModuleCourseHasModulesConnections match this filter */
  courseHasModulesConnection_NONE?: InputMaybe<ModuleCourseHasModulesConnectionWhere>;
  /** Return Modules where one of the related ModuleCourseHasModulesConnections match this filter */
  courseHasModulesConnection_SINGLE?: InputMaybe<ModuleCourseHasModulesConnectionWhere>;
  /** Return Modules where some of the related ModuleCourseHasModulesConnections match this filter */
  courseHasModulesConnection_SOME?: InputMaybe<ModuleCourseHasModulesConnectionWhere>;
  /** Return Modules where all of the related Courses match this filter */
  courseHasModules_ALL?: InputMaybe<CourseWhere>;
  /** Return Modules where none of the related Courses match this filter */
  courseHasModules_NONE?: InputMaybe<CourseWhere>;
  /** Return Modules where one of the related Courses match this filter */
  courseHasModules_SINGLE?: InputMaybe<CourseWhere>;
  /** Return Modules where some of the related Courses match this filter */
  courseHasModules_SOME?: InputMaybe<CourseWhere>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  imageGenerationStatus?: InputMaybe<ModuleImageGenerationStatus>;
  imageGenerationStatus_IN?: InputMaybe<Array<InputMaybe<ModuleImageGenerationStatus>>>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastModified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lessonPlanFile?: InputMaybe<FileWhere>;
  lessonPlanFileAggregate?: InputMaybe<ModuleLessonPlanFileAggregateInput>;
  lessonPlanFileConnection?: InputMaybe<ModuleLessonPlanFileConnectionWhere>;
  lessonPlanFileConnection_NOT?: InputMaybe<ModuleLessonPlanFileConnectionWhere>;
  lessonPlanFile_NOT?: InputMaybe<FileWhere>;
  lessonPlanGenerating?: InputMaybe<Scalars['Boolean']['input']>;
  module_name?: InputMaybe<Scalars['String']['input']>;
  module_name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  module_name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  module_name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  module_name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  nudgesAboutThisAggregate?: InputMaybe<ModuleNudgesAboutThisAggregateInput>;
  /** Return Modules where all of the related ModuleNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_ALL?: InputMaybe<ModuleNudgesAboutThisConnectionWhere>;
  /** Return Modules where none of the related ModuleNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_NONE?: InputMaybe<ModuleNudgesAboutThisConnectionWhere>;
  /** Return Modules where one of the related ModuleNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_SINGLE?: InputMaybe<ModuleNudgesAboutThisConnectionWhere>;
  /** Return Modules where some of the related ModuleNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_SOME?: InputMaybe<ModuleNudgesAboutThisConnectionWhere>;
  /** Return Modules where all of the related Nudges match this filter */
  nudgesAboutThis_ALL?: InputMaybe<NudgeWhere>;
  /** Return Modules where none of the related Nudges match this filter */
  nudgesAboutThis_NONE?: InputMaybe<NudgeWhere>;
  /** Return Modules where one of the related Nudges match this filter */
  nudgesAboutThis_SINGLE?: InputMaybe<NudgeWhere>;
  /** Return Modules where some of the related Nudges match this filter */
  nudgesAboutThis_SOME?: InputMaybe<NudgeWhere>;
  pagesAggregate?: InputMaybe<ModulePagesAggregateInput>;
  /** Return Modules where all of the related ModulePagesConnections match this filter */
  pagesConnection_ALL?: InputMaybe<ModulePagesConnectionWhere>;
  /** Return Modules where none of the related ModulePagesConnections match this filter */
  pagesConnection_NONE?: InputMaybe<ModulePagesConnectionWhere>;
  /** Return Modules where one of the related ModulePagesConnections match this filter */
  pagesConnection_SINGLE?: InputMaybe<ModulePagesConnectionWhere>;
  /** Return Modules where some of the related ModulePagesConnections match this filter */
  pagesConnection_SOME?: InputMaybe<ModulePagesConnectionWhere>;
  /** Return Modules where all of the related Pages match this filter */
  pages_ALL?: InputMaybe<PageWhere>;
  /** Return Modules where none of the related Pages match this filter */
  pages_NONE?: InputMaybe<PageWhere>;
  /** Return Modules where one of the related Pages match this filter */
  pages_SINGLE?: InputMaybe<PageWhere>;
  /** Return Modules where some of the related Pages match this filter */
  pages_SOME?: InputMaybe<PageWhere>;
  projectsAggregate?: InputMaybe<ModuleProjectsAggregateInput>;
  /** Return Modules where all of the related ModuleProjectsConnections match this filter */
  projectsConnection_ALL?: InputMaybe<ModuleProjectsConnectionWhere>;
  /** Return Modules where none of the related ModuleProjectsConnections match this filter */
  projectsConnection_NONE?: InputMaybe<ModuleProjectsConnectionWhere>;
  /** Return Modules where one of the related ModuleProjectsConnections match this filter */
  projectsConnection_SINGLE?: InputMaybe<ModuleProjectsConnectionWhere>;
  /** Return Modules where some of the related ModuleProjectsConnections match this filter */
  projectsConnection_SOME?: InputMaybe<ModuleProjectsConnectionWhere>;
  /** Return Modules where all of the related Projects match this filter */
  projects_ALL?: InputMaybe<ProjectWhere>;
  /** Return Modules where none of the related Projects match this filter */
  projects_NONE?: InputMaybe<ProjectWhere>;
  /** Return Modules where one of the related Projects match this filter */
  projects_SINGLE?: InputMaybe<ProjectWhere>;
  /** Return Modules where some of the related Projects match this filter */
  projects_SOME?: InputMaybe<ProjectWhere>;
  resourceOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  resourceOrder_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  reviewsAggregate?: InputMaybe<ModuleReviewsAggregateInput>;
  /** Return Modules where all of the related ModuleReviewsConnections match this filter */
  reviewsConnection_ALL?: InputMaybe<ModuleReviewsConnectionWhere>;
  /** Return Modules where none of the related ModuleReviewsConnections match this filter */
  reviewsConnection_NONE?: InputMaybe<ModuleReviewsConnectionWhere>;
  /** Return Modules where one of the related ModuleReviewsConnections match this filter */
  reviewsConnection_SINGLE?: InputMaybe<ModuleReviewsConnectionWhere>;
  /** Return Modules where some of the related ModuleReviewsConnections match this filter */
  reviewsConnection_SOME?: InputMaybe<ModuleReviewsConnectionWhere>;
  /** Return Modules where all of the related Reviews match this filter */
  reviews_ALL?: InputMaybe<ReviewWhere>;
  /** Return Modules where none of the related Reviews match this filter */
  reviews_NONE?: InputMaybe<ReviewWhere>;
  /** Return Modules where one of the related Reviews match this filter */
  reviews_SINGLE?: InputMaybe<ReviewWhere>;
  /** Return Modules where some of the related Reviews match this filter */
  reviews_SOME?: InputMaybe<ReviewWhere>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  thumbnail_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  thumbnail_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  thumbnail_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thumbnail_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type MonthlySummary = {
  __typename?: 'MonthlySummary';
  created: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  isArchived: Scalars['Boolean']['output'];
  last_modified: Scalars['DateTime']['output'];
  summary: Scalars['String']['output'];
};

export type MonthlySummaryConnectWhere = {
  node: MonthlySummaryWhere;
};

export type MonthlySummaryCreateInput = {
  created: Scalars['DateTime']['input'];
  date: Scalars['DateTime']['input'];
  isArchived: Scalars['Boolean']['input'];
  last_modified: Scalars['DateTime']['input'];
  summary: Scalars['String']['input'];
};

export type MonthlySummaryOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more MonthlySummarySort objects to sort MonthlySummaries by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<MonthlySummarySort>>;
};

/** Fields to sort MonthlySummaries by. The order in which sorts are applied is not guaranteed when specifying many fields in one MonthlySummarySort object. */
export type MonthlySummarySort = {
  created?: InputMaybe<SortDirection>;
  date?: InputMaybe<SortDirection>;
  isArchived?: InputMaybe<SortDirection>;
  last_modified?: InputMaybe<SortDirection>;
  summary?: InputMaybe<SortDirection>;
};

export type MonthlySummaryUpdateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type MonthlySummaryWhere = {
  AND?: InputMaybe<Array<MonthlySummaryWhere>>;
  NOT?: InputMaybe<MonthlySummaryWhere>;
  OR?: InputMaybe<Array<MonthlySummaryWhere>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  date_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  date_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  last_modified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  summary_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  summary_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  summary_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  summary_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type MoveActivityInput = {
  activityId: Scalars['ID']['input'];
  activityType: Scalars['String']['input'];
  sourceModuleId: Scalars['ID']['input'];
  targetModuleId: Scalars['ID']['input'];
};

export type MultipleAssessmentResponse = {
  __typename?: 'MultipleAssessmentResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<Assessment>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']['output']>;
  addAssignment: AddAssignmentResponse;
  addContentModule: AddContentModuleResponse;
  addCoursesToDegree?: Maybe<DegreeResponse>;
  addPreRequisitesToCourse?: Maybe<CourseResponse>;
  addToWhitelist: WhitelistedEmail;
  addTodo: TodoResponse;
  approveProjectSubmission: SingleProjectSubmissionResponse;
  assignCourseToFaculty?: Maybe<ResponseType>;
  assignRoleToUserForTenant?: Maybe<ResponseType>;
  audioToggleUser?: Maybe<AudioToggleUserResponse>;
  bulkAssessmentCreate?: Maybe<BulkAssessmentCreateResponse>;
  careerIsLoading: UserCareerLoadingResponse;
  careerSubmitForm: Scalars['Boolean']['output'];
  careerTopicRelationship: CareerTopicResponse;
  cloneCourse?: Maybe<CourseResponse>;
  completeCourseInvitation?: Maybe<ResponseType>;
  completeDegreeInvitation?: Maybe<ResponseType>;
  completePendingInvite?: Maybe<ResponseType>;
  courseCreation?: Maybe<CourseCreationResponse>;
  courseIsLoading: UserCourseLoadingResponse;
  createAITutor?: Maybe<AiTutorResponse>;
  createAdminDocument?: Maybe<DocumentResponse>;
  createAnnouncement: AnnouncementResponse;
  createAssignment?: Maybe<AssignmentResponse>;
  createAxioResource: AxioResourceResponse;
  createCheckoutSession?: Maybe<ResponseType>;
  createCourse?: Maybe<CourseResponse>;
  createCoursePlaceholder?: Maybe<CourseResponse>;
  createDegree?: Maybe<DegreeResponse>;
  createEducationChildren: Generated;
  createEnrollmentLink?: Maybe<EnrollmentLinkMutationResult>;
  createFeedback?: Maybe<Feedback>;
  createGoal?: Maybe<Goal>;
  createInterest?: Maybe<Interest>;
  createLesson?: Maybe<Lesson>;
  createMcqQuestion: McqQuestionResponse;
  createModule?: Maybe<ModuleResponse>;
  createNote: NoteResponse;
  createOAuthClient?: Maybe<OAuthClientResponse>;
  createOrUpdateAssessment?: Maybe<AssessmentResponse>;
  createPage?: Maybe<PageResponse>;
  createPost: PostResponse;
  createPreference?: Maybe<Preferences>;
  createProgress?: Maybe<Progress>;
  createProject: SingleProjectResponse;
  createProjectRequirement: SingleProjectRequirementResponse;
  createProjectSubmission: SingleProjectSubmissionResponse;
  createReview?: Maybe<ReviewResponse>;
  createSamlConfig?: Maybe<SamlConfigResponse>;
  createSocraticQuestion?: Maybe<QuestionResponse>;
  createTenant?: Maybe<TenantResponse>;
  createThread: ThreadResponse;
  createVideoPool: VideoServiceResult;
  createVisualizationFromContent?: Maybe<VisualizationResponse>;
  createWorksheet?: Maybe<WorksheetResponse>;
  deleteAITutor?: Maybe<AiTutorResponse>;
  deleteAccount?: Maybe<ResponseType>;
  deleteAdminDocument?: Maybe<DocumentResponse>;
  deleteAnnouncement: AnnouncementResponse;
  deleteAspect: ResponseType;
  deleteAssessment?: Maybe<AssessmentResponse>;
  deleteAssignment?: Maybe<AssignmentResponse>;
  deleteAxioResource: AxioResourceResponse;
  deleteCompanionChat: ChatMutationResponse;
  deleteContentAssignment: DeleteContentAssignmentResponse;
  deleteContentModule: DeleteContentModuleResponse;
  deleteCourseCascade?: Maybe<CourseResponse>;
  deleteDegree?: Maybe<DegreeResponse>;
  deleteEnrollmentLink?: Maybe<EnrollmentLinkMutationResult>;
  deleteGoal?: Maybe<Scalars['Boolean']['output']>;
  deleteInterest?: Maybe<Scalars['Boolean']['output']>;
  deleteLesson?: Maybe<Scalars['Boolean']['output']>;
  deleteLoaderMessages: Scalars['Boolean']['output'];
  deleteMcqQuestion: McqQuestionResponse;
  deleteMessage?: Maybe<Message>;
  deleteModuleCascade?: Maybe<ModuleResponse>;
  deleteNote: NoteResponse;
  deleteOAuthClient?: Maybe<OAuthClientResponse>;
  deletePage?: Maybe<PageResponse>;
  deletePost: PostResponse;
  deletePreference?: Maybe<Scalars['Boolean']['output']>;
  deleteProgress?: Maybe<Scalars['Boolean']['output']>;
  deleteProject: SingleProjectResponse;
  deleteProjectRequirement: SingleProjectRequirementResponse;
  deleteProjectSubmission: SingleProjectSubmissionResponse;
  deleteReview?: Maybe<ReviewResponse>;
  deleteSamlConfig?: Maybe<SamlConfigResponse>;
  deleteSocraticQuestion?: Maybe<QuestionResponse>;
  deleteTenant?: Maybe<TenantResponse>;
  deleteThread: ThreadResponse;
  deleteTodo: ResponseType;
  deleteVisualization?: Maybe<VisualizationResponse>;
  dismissNudge: SingleNudgeResponse;
  downloadLessonPlan?: Maybe<DownloadLessonPlanResponse>;
  dropUserFromCourse?: Maybe<ResponseType>;
  editAssignment?: Maybe<AssignmentResponse>;
  editCourse?: Maybe<CourseResponse>;
  endVisitSession: VisitSession;
  enrollCourseWithToken?: Maybe<EnrollmentLinkMutationResultExtended>;
  enrollInDegree?: Maybe<DegreeResponse>;
  enrollUserInCourse?: Maybe<ResponseType>;
  enrollUserInTrack: ResponseType;
  evaluateCourse?: Maybe<CourseEvaluationResponse>;
  generateAiTutorFromTitle?: Maybe<AiTutorGeneratedResponse>;
  generateAssessmentQuestionsPreview?: Maybe<AssessmentQuestionsPreviewResponse>;
  generateCourseContent?: Maybe<GenerateCourseContentResponse>;
  generateCourseExport: RequestExportResponse;
  generateDueDatesForActivities?: Maybe<CourseResponse>;
  generateEvalCriteria?: Maybe<AiTutorEvalCriteriaResponse>;
  generateLessonPlan?: Maybe<GenerateLessonPlanResponse>;
  generateModuleThumbnails?: Maybe<ModuleResponse>;
  generateProjectRequirements: ProjectRequirementResponse;
  generateSocraticRubricForQuestion?: Maybe<SocraticRubricResponse>;
  generateSuggestedCareers?: Maybe<Career>;
  generateSuggestedDegrees: DegreeResponse;
  generateUploadUrl: FileUploadResponse;
  generateYoutubeKeywords?: Maybe<Scalars['String']['output']>;
  getLearningTtsToken: LearningTtsTokenPayload;
  gradeProjectSubmission: SingleProjectSubmissionResponse;
  hideLearningActivityIntro?: Maybe<ResponseType>;
  inviteUserToSchool?: Maybe<ResponseType>;
  inviteUsersToEnrollInCourse?: Maybe<InviteUsersToEnrollInCourseResponse>;
  inviteUsersToEnrollInDegree?: Maybe<InviteUsersToEnrollInDegreeResponse>;
  login?: Maybe<AuthPayloadResponse>;
  loginSuperAdmin?: Maybe<AuthPayloadResponse>;
  logout: ResponseType;
  makeFilePublic: FileResponse;
  markAnnouncementAsSeen: MarkAnnouncementSeenResponse;
  markNotificationAsRead: SingleNotificationResponse;
  markProjectRequirementComplete: SingleProjectRequirementResponse;
  moveActivity?: Maybe<ModuleResponse>;
  parseAndSaveSamlMetadata: SamlConfigResponse;
  processAttachment: ChatAttachmentResponse;
  processCompanionChatAttachment: ChatAttachmentProcessResult;
  processVideoPool: VideoServiceResult;
  reGenerateCourseImage?: Maybe<CourseResponse>;
  refreshToken?: Maybe<AuthPayloadResponse>;
  rejectProjectSubmission: SingleProjectSubmissionResponse;
  removeCourseAssignmentFromFaculty?: Maybe<ResponseType>;
  removeCoursesFromDegree?: Maybe<DegreeResponse>;
  removePreRequisitesFromCourse?: Maybe<CourseResponse>;
  removeRoleFromUserForTenant?: Maybe<ResponseType>;
  removeStudentsFromCourse?: Maybe<CourseRosterServiceResult>;
  removeStudentsFromDegree?: Maybe<DegreeResponse>;
  requestRosterExport: RequestExportResponse;
  requestSubmissionExport: RequestExportResponse;
  resetAITutor?: Maybe<AiTutorResponse>;
  resetAccount?: Maybe<ResponseType>;
  resetPassword?: Maybe<ResponseType>;
  resubmitProjectProposal: SingleProjectSubmissionResponse;
  revokeFaculty?: Maybe<ResponseType>;
  revokeRefreshToken?: Maybe<ResponseType>;
  setCareerPathActive: Scalars['Boolean']['output'];
  setKnowledgeRelevance: ResponseType;
  setOnboardingStatus: ResponseType;
  signup?: Maybe<AuthPayloadResponse>;
  snoozeNudge: SingleNudgeResponse;
  startVisitSession: VisitSession;
  submitFinalProject: SingleProjectSubmissionResponse;
  submitProjectForReview: SingleProjectSubmissionResponse;
  submitProjectSubmissionFiles: SingleProjectSubmissionResponse;
  submitStudentAssignment?: Maybe<SubmissionResponse>;
  trackPageVisit: PageVisit;
  unsnoozeNudge: SingleNudgeResponse;
  updateAITutor?: Maybe<AiTutorResponse>;
  updateAnnouncement: AnnouncementResponse;
  updateAssessmentSubmissionGrade?: Maybe<AssessmentSubmissionResponse>;
  updateAssignment: UpdateAssignmentResponse;
  updateAxioResource: AxioResourceResponse;
  updateCompanionChat: ChatMutationResponse;
  updateContentModuleName: UpdateContentModuleNameResponse;
  updateContentSafetySettings?: Maybe<ContentSafetySettingsResponse>;
  updateCourse?: Maybe<CourseResponse>;
  updateCourseDates?: Maybe<CourseResponse>;
  updateDegree?: Maybe<DegreeResponse>;
  updateEnrollmentLink?: Maybe<EnrollmentLinkMutationResult>;
  updateFacultyProfile?: Maybe<ResponseType>;
  updateFeedback?: Maybe<Feedback>;
  updateGoal?: Maybe<Goal>;
  updateInterest?: Maybe<Interest>;
  updateLastSeenPost: PostResponse;
  updateLearningObjectiveCompletion: ResponseType;
  updateLesson?: Maybe<Lesson>;
  updateMcqQuestion: McqQuestionResponse;
  updateModule?: Maybe<ModuleResponse>;
  updateNote: NoteResponse;
  updateNotificationsEmailSetting?: Maybe<ResponseType>;
  updateNotificationsSetting?: Maybe<ResponseType>;
  updateNudgePreferences: NudgePreferencesResponse;
  updateOAuthClient?: Maybe<OAuthClientResponse>;
  updatePage?: Maybe<PageResponse>;
  updatePost: PostResponse;
  updatePreference?: Maybe<Preferences>;
  updateProgress?: Maybe<Progress>;
  updateProject: SingleProjectResponse;
  updateProjectRequirement: SingleProjectRequirementResponse;
  updateProjectSubmission: SingleProjectSubmissionResponse;
  updateResourceOrder?: Maybe<ModuleResponse>;
  updateReview?: Maybe<ReviewResponse>;
  updateSamlConfig?: Maybe<SamlConfigResponse>;
  updateSocraticQuestion?: Maybe<QuestionResponse>;
  updateStudentAssignmentGrade?: Maybe<SubmissionResponse>;
  updateTenant?: Maybe<TenantResponse>;
  updateTenantSettings?: Maybe<TenantResponse>;
  updateThread: ThreadResponse;
  updateTodo: TodoResponse;
  updateTopic: ResponseType;
  updateUserLearningPreferences: UserLearningPreferences;
  updateUserModalOnboarding?: Maybe<UpdateUserModalOnboardingResponse>;
  updateVisitSession: VisitSession;
  updateVisualization?: Maybe<VisualizationResponse>;
  uploadFavicon?: Maybe<UploadFaviconResponse>;
  upsertCompanionOnboardingState: UpdateCompanionOnboardingResponse;
};


export type MutationAddAssignmentArgs = {
  courseId: Scalars['ID']['input'];
  moduleName: Scalars['String']['input'];
  newAssignmentName: Scalars['String']['input'];
  updatedHtml: Scalars['String']['input'];
};


export type MutationAddContentModuleArgs = {
  courseId: Scalars['ID']['input'];
  moduleName: Scalars['String']['input'];
};


export type MutationAddCoursesToDegreeArgs = {
  input: AddCoursesToDegreeInput;
};


export type MutationAddPreRequisitesToCourseArgs = {
  courseId: Scalars['ID']['input'];
  preRequisiteIds: Array<Scalars['ID']['input']>;
};


export type MutationAddToWhitelistArgs = {
  email: Scalars['String']['input'];
};


export type MutationAddTodoArgs = {
  todo: AddTodoInput;
};


export type MutationApproveProjectSubmissionArgs = {
  submissionId: Scalars['ID']['input'];
};


export type MutationAssignCourseToFacultyArgs = {
  courseId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};


export type MutationAssignRoleToUserForTenantArgs = {
  roleId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
};


export type MutationAudioToggleUserArgs = {
  audioOn?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationBulkAssessmentCreateArgs = {
  input: BulkAssessmentCreateInput;
};


export type MutationCareerIsLoadingArgs = {
  isLoading: Scalars['Boolean']['input'];
};


export type MutationCareerSubmitFormArgs = {
  careerGoal: Scalars['String']['input'];
  careerPathName: Scalars['String']['input'];
  currentOccupation: Scalars['String']['input'];
};


export type MutationCareerTopicRelationshipArgs = {
  careerName: Scalars['String']['input'];
  index: Scalars['Int']['input'];
  topicName: Scalars['String']['input'];
};


export type MutationCloneCourseArgs = {
  courseId: Scalars['ID']['input'];
};


export type MutationCompleteCourseInvitationArgs = {
  courseId: Scalars['ID']['input'];
};


export type MutationCompleteDegreeInvitationArgs = {
  degreeId: Scalars['ID']['input'];
};


export type MutationCompletePendingInviteArgs = {
  newPassword: Scalars['String']['input'];
  service: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationCourseCreationArgs = {
  objectives: Array<Scalars['String']['input']>;
  standard: Scalars['String']['input'];
  title: Scalars['String']['input'];
  urls: Array<Scalars['String']['input']>;
  weeks: Scalars['Int']['input'];
};


export type MutationCourseIsLoadingArgs = {
  isLoading: Scalars['Boolean']['input'];
};


export type MutationCreateAiTutorArgs = {
  aiTutor: CreateAiTutorInput;
};


export type MutationCreateAdminDocumentArgs = {
  fileId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationCreateAnnouncementArgs = {
  input: CreateAnnouncementInput;
};


export type MutationCreateAssignmentArgs = {
  assignment: CreateAssignmentInput;
};


export type MutationCreateAxioResourceArgs = {
  resource: CreateAxioResourceInput;
};


export type MutationCreateCheckoutSessionArgs = {
  courseId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCourseArgs = {
  course: CreateCourseInput;
};


export type MutationCreateCoursePlaceholderArgs = {
  course?: InputMaybe<CreateCoursePlaceholderInput>;
};


export type MutationCreateDegreeArgs = {
  degree: CreateDegreeInput;
};


export type MutationCreateEducationChildrenArgs = {
  label: NodeLabel;
  name: Scalars['String']['input'];
};


export type MutationCreateEnrollmentLinkArgs = {
  input: CreateEnrollmentLinkInput;
};


export type MutationCreateFeedbackArgs = {
  context: Scalars['String']['input'];
  date: Scalars['DateTime']['input'];
  sentiment: Scalars['String']['input'];
  text: Scalars['String']['input'];
  user: UserInput;
};


export type MutationCreateGoalArgs = {
  category: Scalars['String']['input'];
  completionStatus: Scalars['String']['input'];
  deadline: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  priority: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
  type: Scalars['String']['input'];
  user: UserInput;
};


export type MutationCreateInterestArgs = {
  category: Scalars['String']['input'];
  lastUpdated: Scalars['DateTime']['input'];
  level: Scalars['String']['input'];
  name: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
  user: UserInput;
};


export type MutationCreateLessonArgs = {
  category: Scalars['String']['input'];
  completionStatus: Scalars['String']['input'];
  difficultyLevel: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  format: Scalars['String']['input'];
  name: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
  user: UserInput;
};


export type MutationCreateMcqQuestionArgs = {
  input: CreateMcqQuestionInput;
};


export type MutationCreateModuleArgs = {
  module: CreateModuleInput;
};


export type MutationCreateNoteArgs = {
  input: CreateNoteInput;
};


export type MutationCreateOAuthClientArgs = {
  input: OAuthClientInput;
};


export type MutationCreateOrUpdateAssessmentArgs = {
  input: CreateOrUpdateAssessmentInput;
};


export type MutationCreatePageArgs = {
  page: CreatePageInput;
};


export type MutationCreatePostArgs = {
  input: CreatePostInput;
};


export type MutationCreatePreferenceArgs = {
  contentType: Scalars['String']['input'];
  language: Scalars['String']['input'];
  learningDuration: Scalars['Int']['input'];
  learningStyle: Scalars['String']['input'];
  notificationPreferences: Scalars['String']['input'];
  timeOfDay: Scalars['String']['input'];
  user: UserInput;
};


export type MutationCreateProgressArgs = {
  date: Scalars['DateTime']['input'];
  description: Scalars['String']['input'];
  level: Scalars['String']['input'];
  type: Scalars['String']['input'];
  user: UserInput;
};


export type MutationCreateProjectArgs = {
  project: CreateProjectInput;
};


export type MutationCreateProjectRequirementArgs = {
  requirement: CreateProjectRequirementInput;
};


export type MutationCreateProjectSubmissionArgs = {
  submission: CreateProjectSubmissionInput;
};


export type MutationCreateReviewArgs = {
  review: CreateReviewInput;
};


export type MutationCreateSamlConfigArgs = {
  input: SamlConfigCreateInput;
};


export type MutationCreateSocraticQuestionArgs = {
  input: CreateSocraticQuestionInput;
};


export type MutationCreateTenantArgs = {
  tenant: TenantInput;
};


export type MutationCreateThreadArgs = {
  input: CreateThreadInput;
};


export type MutationCreateVideoPoolArgs = {
  description: Scalars['String']['input'];
  objectives: Array<ObjectiveForVideoInput>;
  title: Scalars['String']['input'];
};


export type MutationCreateVisualizationFromContentArgs = {
  content: VisualizationContentInput;
};


export type MutationCreateWorksheetArgs = {
  existingWorksheetId?: InputMaybe<Scalars['ID']['input']>;
  worksheet: CreateWorksheetInput;
};


export type MutationDeleteAiTutorArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAdminDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAnnouncementArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAspectArgs = {
  nodeId: Scalars['ID']['input'];
};


export type MutationDeleteAssessmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAssignmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAxioResourceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCompanionChatArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteContentAssignmentArgs = {
  assignmentName: Scalars['String']['input'];
  courseId: Scalars['ID']['input'];
  moduleName: Scalars['String']['input'];
};


export type MutationDeleteContentModuleArgs = {
  courseId: Scalars['ID']['input'];
  moduleName: Scalars['String']['input'];
};


export type MutationDeleteCourseCascadeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDegreeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEnrollmentLinkArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGoalArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInterestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLessonArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMcqQuestionArgs = {
  assessmentId: Scalars['ID']['input'];
  mcqQuestionId: Scalars['ID']['input'];
};


export type MutationDeleteMessageArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteModuleCascadeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteNoteArgs = {
  noteId: Scalars['ID']['input'];
};


export type MutationDeleteOAuthClientArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePostArgs = {
  postId: Scalars['ID']['input'];
};


export type MutationDeletePreferenceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProgressArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectRequirementArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectSubmissionArgs = {
  submissionId: Scalars['ID']['input'];
};


export type MutationDeleteReviewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSamlConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSocraticQuestionArgs = {
  assessmentId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
};


export type MutationDeleteTenantArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteThreadArgs = {
  threadId: Scalars['ID']['input'];
};


export type MutationDeleteTodoArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteVisualizationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDismissNudgeArgs = {
  nudgeId: Scalars['ID']['input'];
};


export type MutationDownloadLessonPlanArgs = {
  moduleId: Scalars['ID']['input'];
};


export type MutationDropUserFromCourseArgs = {
  courseId: Scalars['ID']['input'];
};


export type MutationEditAssignmentArgs = {
  assignment: EditAssignmentInput;
  id: Scalars['ID']['input'];
};


export type MutationEditCourseArgs = {
  course: EditCourseInput;
  id: Scalars['ID']['input'];
};


export type MutationEndVisitSessionArgs = {
  sessionId: Scalars['ID']['input'];
};


export type MutationEnrollCourseWithTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationEnrollInDegreeArgs = {
  degreeId: Scalars['ID']['input'];
};


export type MutationEnrollUserInCourseArgs = {
  courseId: Scalars['ID']['input'];
};


export type MutationEnrollUserInTrackArgs = {
  topicName: Scalars['String']['input'];
};


export type MutationEvaluateCourseArgs = {
  courseId: Scalars['ID']['input'];
};


export type MutationGenerateAiTutorFromTitleArgs = {
  targetAudience?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};


export type MutationGenerateAssessmentQuestionsPreviewArgs = {
  input: GenerateAssessmentQuestionsPreviewInput;
};


export type MutationGenerateCourseContentArgs = {
  courseDescription?: InputMaybe<Scalars['String']['input']>;
  courseId: Scalars['ID']['input'];
  numberOfActivities: Scalars['Int']['input'];
  numberOfModules: Scalars['Int']['input'];
};


export type MutationGenerateCourseExportArgs = {
  courseId: Scalars['ID']['input'];
};


export type MutationGenerateDueDatesForActivitiesArgs = {
  courseId: Scalars['ID']['input'];
};


export type MutationGenerateEvalCriteriaArgs = {
  input: GenerateEvalCriteriaInput;
};


export type MutationGenerateLessonPlanArgs = {
  input: GenerateLessonPlanInput;
};


export type MutationGenerateModuleThumbnailsArgs = {
  courseId: Scalars['ID']['input'];
};


export type MutationGenerateProjectRequirementsArgs = {
  projectId: Scalars['ID']['input'];
  submissionId: Scalars['ID']['input'];
};


export type MutationGenerateSocraticRubricForQuestionArgs = {
  input: GenerateSocraticRubricInput;
};


export type MutationGenerateUploadUrlArgs = {
  fileName: Scalars['String']['input'];
  storagePath: StoragePathType;
};


export type MutationGenerateYoutubeKeywordsArgs = {
  description: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


export type MutationGradeProjectSubmissionArgs = {
  feedback?: InputMaybe<Scalars['String']['input']>;
  grade: Scalars['Float']['input'];
  submissionId: Scalars['ID']['input'];
};


export type MutationInviteUserToSchoolArgs = {
  input: InviteUserToSchoolInput;
};


export type MutationInviteUsersToEnrollInCourseArgs = {
  input: InviteUsersToEnrollInCourseInput;
};


export type MutationInviteUsersToEnrollInDegreeArgs = {
  input: InviteUsersToEnrollInDegreeInput;
};


export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationLoginSuperAdminArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationMakeFilePublicArgs = {
  fileId: Scalars['ID']['input'];
};


export type MutationMarkAnnouncementAsSeenArgs = {
  announcementId: Scalars['ID']['input'];
};


export type MutationMarkNotificationAsReadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkProjectRequirementCompleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMoveActivityArgs = {
  input: MoveActivityInput;
};


export type MutationParseAndSaveSamlMetadataArgs = {
  metadataUrl: Scalars['String']['input'];
};


export type MutationProcessAttachmentArgs = {
  fileId: Scalars['String']['input'];
};


export type MutationProcessCompanionChatAttachmentArgs = {
  fileId: Scalars['String']['input'];
};


export type MutationProcessVideoPoolArgs = {
  videoData: Array<VideoData>;
};


export type MutationReGenerateCourseImageArgs = {
  courseId: Scalars['ID']['input'];
};


export type MutationRefreshTokenArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationRejectProjectSubmissionArgs = {
  reason: Scalars['String']['input'];
  submissionId: Scalars['ID']['input'];
};


export type MutationRemoveCourseAssignmentFromFacultyArgs = {
  courseId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};


export type MutationRemoveCoursesFromDegreeArgs = {
  input: RemoveCoursesFromDegreeInput;
};


export type MutationRemovePreRequisitesFromCourseArgs = {
  courseId: Scalars['ID']['input'];
  preRequisiteIds: Array<Scalars['ID']['input']>;
};


export type MutationRemoveRoleFromUserForTenantArgs = {
  roleId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
};


export type MutationRemoveStudentsFromCourseArgs = {
  courseId: Scalars['ID']['input'];
  studentIds: Array<Scalars['ID']['input']>;
};


export type MutationRemoveStudentsFromDegreeArgs = {
  input: RemoveStudentsFromDegreeInput;
};


export type MutationRequestRosterExportArgs = {
  courseId: Scalars['ID']['input'];
};


export type MutationResetAiTutorArgs = {
  input: ResetAiTutorInput;
};


export type MutationResetPasswordArgs = {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationResubmitProjectProposalArgs = {
  submission: UpdateProjectSubmissionInput;
  submissionId: Scalars['ID']['input'];
};


export type MutationRevokeFacultyArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationRevokeRefreshTokenArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationSetCareerPathActiveArgs = {
  careerId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSetKnowledgeRelevanceArgs = {
  isRelevant: Scalars['Boolean']['input'];
  nodeLabel: Scalars['String']['input'];
  nodeName: Scalars['String']['input'];
};


export type MutationSetOnboardingStatusArgs = {
  isOnboarded: Scalars['Boolean']['input'];
};


export type MutationSignupArgs = {
  birthday: Scalars['String']['input'];
  dailyEmailOptIn: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};


export type MutationSnoozeNudgeArgs = {
  nudgeId: Scalars['ID']['input'];
  snoozedUntil: Scalars['DateTime']['input'];
};


export type MutationSubmitFinalProjectArgs = {
  submission: SubmitFinalProjectInput;
};


export type MutationSubmitProjectForReviewArgs = {
  submissionId: Scalars['ID']['input'];
};


export type MutationSubmitProjectSubmissionFilesArgs = {
  files?: InputMaybe<Array<FileInput>>;
  submissionId: Scalars['ID']['input'];
};


export type MutationSubmitStudentAssignmentArgs = {
  assignmentId: Scalars['ID']['input'];
  files?: InputMaybe<Array<FileInput>>;
};


export type MutationTrackPageVisitArgs = {
  path: Scalars['String']['input'];
  sessionId: Scalars['ID']['input'];
};


export type MutationUnsnoozeNudgeArgs = {
  nudgeId: Scalars['ID']['input'];
};


export type MutationUpdateAiTutorArgs = {
  aiTutor: UpdateAiTutorInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateAnnouncementArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAnnouncementInput;
};


export type MutationUpdateAssessmentSubmissionGradeArgs = {
  assessmentSubmissionId: Scalars['ID']['input'];
  reviewWithoutAdjustment?: InputMaybe<Scalars['Boolean']['input']>;
  updatedGradeEntry?: InputMaybe<UpdateAssessmentSubmissionUpdatedGrade>;
};


export type MutationUpdateAssignmentArgs = {
  courseId: Scalars['ID']['input'];
  currentAssignmentName: Scalars['String']['input'];
  moduleName: Scalars['String']['input'];
  newAssignmentName: Scalars['String']['input'];
  updatedHtml: Scalars['String']['input'];
};


export type MutationUpdateAxioResourceArgs = {
  id: Scalars['ID']['input'];
  resource: UpdateAxioResourceInput;
};


export type MutationUpdateCompanionChatArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateContentModuleNameArgs = {
  courseId: Scalars['ID']['input'];
  newModuleName: Scalars['String']['input'];
  oldModuleName: Scalars['String']['input'];
};


export type MutationUpdateContentSafetySettingsArgs = {
  settings: ContentSafetySettingsInput;
};


export type MutationUpdateCourseArgs = {
  course: UpdateCourseInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateCourseDatesArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCourseDatesInput;
};


export type MutationUpdateDegreeArgs = {
  degree: UpdateDegreeInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateEnrollmentLinkArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEnrollmentLinkInput;
};


export type MutationUpdateFacultyProfileArgs = {
  input: UpdateFacultyProfileInput;
};


export type MutationUpdateFeedbackArgs = {
  context?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  sentiment?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  user: UserInput;
};


export type MutationUpdateGoalArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  completionStatus?: InputMaybe<Scalars['String']['input']>;
  deadline?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user: UserInput;
};


export type MutationUpdateInterestArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastUpdated?: InputMaybe<Scalars['DateTime']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserInput;
};


export type MutationUpdateLastSeenPostArgs = {
  input: UpdateLastSeenPostInput;
};


export type MutationUpdateLearningObjectiveCompletionArgs = {
  completed: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateLessonArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  completionStatus?: InputMaybe<Scalars['String']['input']>;
  difficultyLevel?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  user: UserInput;
};


export type MutationUpdateMcqQuestionArgs = {
  assessmentId: Scalars['ID']['input'];
  input: UpdateMcqQuestionInput;
  mcqQuestionId: Scalars['ID']['input'];
};


export type MutationUpdateModuleArgs = {
  id: Scalars['ID']['input'];
  module: UpdateModuleInput;
};


export type MutationUpdateNoteArgs = {
  input: UpdateNoteInput;
  noteId: Scalars['ID']['input'];
};


export type MutationUpdateNotificationsEmailSettingArgs = {
  skipAllNotificationEmail: Scalars['Boolean']['input'];
};


export type MutationUpdateNotificationsSettingArgs = {
  dailyEmailOptIn: Scalars['Boolean']['input'];
};


export type MutationUpdateNudgePreferencesArgs = {
  input: UpdateNudgePreferencesInput;
};


export type MutationUpdateOAuthClientArgs = {
  id: Scalars['ID']['input'];
  input: OAuthClientInput;
};


export type MutationUpdatePageArgs = {
  id: Scalars['ID']['input'];
  page: UpdatePageInput;
};


export type MutationUpdatePostArgs = {
  input: UpdatePostInput;
  postId: Scalars['ID']['input'];
};


export type MutationUpdatePreferenceArgs = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  learningDuration?: InputMaybe<Scalars['Int']['input']>;
  learningStyle?: InputMaybe<Scalars['String']['input']>;
  notificationPreferences?: InputMaybe<Scalars['String']['input']>;
  timeOfDay?: InputMaybe<Scalars['String']['input']>;
  user: UserInput;
};


export type MutationUpdateProgressArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  level?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user: UserInput;
};


export type MutationUpdateProjectArgs = {
  id: Scalars['ID']['input'];
  project: UpdateProjectInput;
};


export type MutationUpdateProjectRequirementArgs = {
  id: Scalars['ID']['input'];
  requirement: UpdateProjectRequirementInput;
};


export type MutationUpdateProjectSubmissionArgs = {
  id: Scalars['ID']['input'];
  submission: UpdateProjectSubmissionInput;
};


export type MutationUpdateResourceOrderArgs = {
  input: UpdateResourceOrderInput;
};


export type MutationUpdateReviewArgs = {
  id: Scalars['ID']['input'];
  review: UpdateReviewInput;
};


export type MutationUpdateSamlConfigArgs = {
  id: Scalars['ID']['input'];
  input: SamlConfigUpdateInput;
};


export type MutationUpdateSocraticQuestionArgs = {
  assessmentId: Scalars['ID']['input'];
  input: UpdateSocraticQuestionInput;
  questionId: Scalars['ID']['input'];
};


export type MutationUpdateStudentAssignmentGradeArgs = {
  submissionId: Scalars['ID']['input'];
  updatePayload: UpdateStudentAssignmentGradeInput;
};


export type MutationUpdateTenantArgs = {
  id: Scalars['ID']['input'];
  tenant: TenantInput;
};


export type MutationUpdateTenantSettingsArgs = {
  settings: TenantSettingsInput;
};


export type MutationUpdateThreadArgs = {
  input: UpdateThreadInput;
  threadId: Scalars['ID']['input'];
};


export type MutationUpdateTodoArgs = {
  id: Scalars['String']['input'];
  todo: UpdateTodoInput;
};


export type MutationUpdateTopicArgs = {
  operationType: Scalars['String']['input'];
  topicName: Scalars['String']['input'];
};


export type MutationUpdateUserLearningPreferencesArgs = {
  input: UpdateUserLearningPreferencesInput;
};


export type MutationUpdateUserModalOnboardingArgs = {
  modalOnboarding?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateVisitSessionArgs = {
  sessionId: Scalars['ID']['input'];
};


export type MutationUpdateVisualizationArgs = {
  content: VisualizationContentInput;
  id: Scalars['ID']['input'];
};


export type MutationUploadFaviconArgs = {
  contentType: Scalars['String']['input'];
  favicon: Scalars['String']['input'];
  size: Scalars['Int']['input'];
};


export type MutationUpsertCompanionOnboardingStateArgs = {
  input: CompanionOnboardingStateInput;
};

export enum NodeLabel {
  Chapter = 'Chapter',
  Field = 'Field',
  Subchapter = 'Subchapter',
  Subfield = 'Subfield',
  Topic = 'Topic'
}

export type Note = {
  __typename?: 'Note';
  author: User;
  authorAggregate?: Maybe<NoteUserAuthorAggregationSelection>;
  authorConnection: NoteAuthorConnection;
  content: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastModified: Scalars['DateTime']['output'];
  subject: User;
  subjectAggregate?: Maybe<NoteUserSubjectAggregationSelection>;
  subjectConnection: NoteSubjectConnection;
};


export type NoteAuthorArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type NoteAuthorAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type NoteAuthorConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NoteAuthorConnectionSort>>;
  where?: InputMaybe<NoteAuthorConnectionWhere>;
};


export type NoteSubjectArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type NoteSubjectAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type NoteSubjectConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NoteSubjectConnectionSort>>;
  where?: InputMaybe<NoteSubjectConnectionWhere>;
};

export type NoteAuthorAggregateInput = {
  AND?: InputMaybe<Array<NoteAuthorAggregateInput>>;
  NOT?: InputMaybe<NoteAuthorAggregateInput>;
  OR?: InputMaybe<Array<NoteAuthorAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NoteAuthorNodeAggregationWhereInput>;
};

export type NoteAuthorConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type NoteAuthorConnectOrCreateFieldInput = {
  onCreate: NoteAuthorConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type NoteAuthorConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type NoteAuthorConnection = {
  __typename?: 'NoteAuthorConnection';
  edges: Array<NoteAuthorRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NoteAuthorConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type NoteAuthorConnectionWhere = {
  AND?: InputMaybe<Array<NoteAuthorConnectionWhere>>;
  NOT?: InputMaybe<NoteAuthorConnectionWhere>;
  OR?: InputMaybe<Array<NoteAuthorConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type NoteAuthorCreateFieldInput = {
  node: UserCreateInput;
};

export type NoteAuthorDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<NoteAuthorConnectionWhere>;
};

export type NoteAuthorDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<NoteAuthorConnectionWhere>;
};

export type NoteAuthorFieldInput = {
  connect?: InputMaybe<NoteAuthorConnectFieldInput>;
  connectOrCreate?: InputMaybe<NoteAuthorConnectOrCreateFieldInput>;
  create?: InputMaybe<NoteAuthorCreateFieldInput>;
};

export type NoteAuthorNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NoteAuthorNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NoteAuthorNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NoteAuthorNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteAuthorRelationship = {
  __typename?: 'NoteAuthorRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type NoteAuthorUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type NoteAuthorUpdateFieldInput = {
  connect?: InputMaybe<NoteAuthorConnectFieldInput>;
  connectOrCreate?: InputMaybe<NoteAuthorConnectOrCreateFieldInput>;
  create?: InputMaybe<NoteAuthorCreateFieldInput>;
  delete?: InputMaybe<NoteAuthorDeleteFieldInput>;
  disconnect?: InputMaybe<NoteAuthorDisconnectFieldInput>;
  update?: InputMaybe<NoteAuthorUpdateConnectionInput>;
  where?: InputMaybe<NoteAuthorConnectionWhere>;
};

export type NoteConnectInput = {
  author?: InputMaybe<NoteAuthorConnectFieldInput>;
  subject?: InputMaybe<NoteSubjectConnectFieldInput>;
};

export type NoteConnectOrCreateWhere = {
  node: NoteUniqueWhere;
};

export type NoteConnectWhere = {
  node: NoteWhere;
};

export type NoteCreateInput = {
  author?: InputMaybe<NoteAuthorFieldInput>;
  content: Scalars['String']['input'];
  created: Scalars['DateTime']['input'];
  lastModified: Scalars['DateTime']['input'];
  subject?: InputMaybe<NoteSubjectFieldInput>;
};

export type NoteDeleteInput = {
  author?: InputMaybe<NoteAuthorDeleteFieldInput>;
  subject?: InputMaybe<NoteSubjectDeleteFieldInput>;
};

export type NoteDisconnectInput = {
  author?: InputMaybe<NoteAuthorDisconnectFieldInput>;
  subject?: InputMaybe<NoteSubjectDisconnectFieldInput>;
};

export type NoteOnCreateInput = {
  content: Scalars['String']['input'];
  created: Scalars['DateTime']['input'];
  lastModified: Scalars['DateTime']['input'];
};

export type NoteOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more NoteSort objects to sort Notes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<NoteSort>>;
};

export type NoteResponse = {
  __typename?: 'NoteResponse';
  count: Scalars['Int']['output'];
  data?: Maybe<Note>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Fields to sort Notes by. The order in which sorts are applied is not guaranteed when specifying many fields in one NoteSort object. */
export type NoteSort = {
  content?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastModified?: InputMaybe<SortDirection>;
};

export type NoteSubjectAggregateInput = {
  AND?: InputMaybe<Array<NoteSubjectAggregateInput>>;
  NOT?: InputMaybe<NoteSubjectAggregateInput>;
  OR?: InputMaybe<Array<NoteSubjectAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NoteSubjectNodeAggregationWhereInput>;
};

export type NoteSubjectConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type NoteSubjectConnectOrCreateFieldInput = {
  onCreate: NoteSubjectConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type NoteSubjectConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type NoteSubjectConnection = {
  __typename?: 'NoteSubjectConnection';
  edges: Array<NoteSubjectRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NoteSubjectConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type NoteSubjectConnectionWhere = {
  AND?: InputMaybe<Array<NoteSubjectConnectionWhere>>;
  NOT?: InputMaybe<NoteSubjectConnectionWhere>;
  OR?: InputMaybe<Array<NoteSubjectConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type NoteSubjectCreateFieldInput = {
  node: UserCreateInput;
};

export type NoteSubjectDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<NoteSubjectConnectionWhere>;
};

export type NoteSubjectDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<NoteSubjectConnectionWhere>;
};

export type NoteSubjectFieldInput = {
  connect?: InputMaybe<NoteSubjectConnectFieldInput>;
  connectOrCreate?: InputMaybe<NoteSubjectConnectOrCreateFieldInput>;
  create?: InputMaybe<NoteSubjectCreateFieldInput>;
};

export type NoteSubjectNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NoteSubjectNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NoteSubjectNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NoteSubjectNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteSubjectRelationship = {
  __typename?: 'NoteSubjectRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type NoteSubjectUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type NoteSubjectUpdateFieldInput = {
  connect?: InputMaybe<NoteSubjectConnectFieldInput>;
  connectOrCreate?: InputMaybe<NoteSubjectConnectOrCreateFieldInput>;
  create?: InputMaybe<NoteSubjectCreateFieldInput>;
  delete?: InputMaybe<NoteSubjectDeleteFieldInput>;
  disconnect?: InputMaybe<NoteSubjectDisconnectFieldInput>;
  update?: InputMaybe<NoteSubjectUpdateConnectionInput>;
  where?: InputMaybe<NoteSubjectConnectionWhere>;
};

export type NoteUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type NoteUpdateInput = {
  author?: InputMaybe<NoteAuthorUpdateFieldInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  subject?: InputMaybe<NoteSubjectUpdateFieldInput>;
};

export type NoteUserAuthorAggregationSelection = {
  __typename?: 'NoteUserAuthorAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<NoteUserAuthorNodeAggregateSelection>;
};

export type NoteUserAuthorNodeAggregateSelection = {
  __typename?: 'NoteUserAuthorNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type NoteUserSubjectAggregationSelection = {
  __typename?: 'NoteUserSubjectAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<NoteUserSubjectNodeAggregateSelection>;
};

export type NoteUserSubjectNodeAggregateSelection = {
  __typename?: 'NoteUserSubjectNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type NoteWhere = {
  AND?: InputMaybe<Array<NoteWhere>>;
  NOT?: InputMaybe<NoteWhere>;
  OR?: InputMaybe<Array<NoteWhere>>;
  author?: InputMaybe<UserWhere>;
  authorAggregate?: InputMaybe<NoteAuthorAggregateInput>;
  authorConnection?: InputMaybe<NoteAuthorConnectionWhere>;
  authorConnection_NOT?: InputMaybe<NoteAuthorConnectionWhere>;
  author_NOT?: InputMaybe<UserWhere>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  content_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  content_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  content_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lastModified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  subject?: InputMaybe<UserWhere>;
  subjectAggregate?: InputMaybe<NoteSubjectAggregateInput>;
  subjectConnection?: InputMaybe<NoteSubjectConnectionWhere>;
  subjectConnection_NOT?: InputMaybe<NoteSubjectConnectionWhere>;
  subject_NOT?: InputMaybe<UserWhere>;
};

export type NotesListResponse = {
  __typename?: 'NotesListResponse';
  count: Scalars['Int']['output'];
  data: Array<Note>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Notification = {
  __typename?: 'Notification';
  actionUrl?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  event: NotificationEvent;
  eventAggregate?: Maybe<NotificationNotificationEventEventAggregationSelection>;
  eventConnection: NotificationEventConnection;
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  readAt?: Maybe<Scalars['DateTime']['output']>;
  schoolId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  type?: Maybe<NotificationType>;
  userId: Scalars['ID']['output'];
};


export type NotificationEventArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<NotificationEventOptions>;
  where?: InputMaybe<NotificationEventWhere>;
};


export type NotificationEventAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NotificationEventWhere>;
};


export type NotificationEventConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NotificationEventConnectionSort>>;
  where?: InputMaybe<NotificationEventConnectionWhere>;
};

export type NotificationConnectInput = {
  event?: InputMaybe<NotificationEventConnectFieldInput>;
};

export type NotificationConnectOrCreateWhere = {
  node: NotificationUniqueWhere;
};

export type NotificationConnectWhere = {
  node: NotificationWhere;
};

export type NotificationCreateInput = {
  actionUrl?: InputMaybe<Scalars['String']['input']>;
  created: Scalars['DateTime']['input'];
  event?: InputMaybe<NotificationEventFieldInput>;
  isRead?: Scalars['Boolean']['input'];
  message: Scalars['String']['input'];
  readAt?: InputMaybe<Scalars['DateTime']['input']>;
  schoolId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  type?: InputMaybe<NotificationType>;
  userId: Scalars['ID']['input'];
};

export type NotificationDeleteInput = {
  event?: InputMaybe<NotificationEventDeleteFieldInput>;
};

export type NotificationDisconnectInput = {
  event?: InputMaybe<NotificationEventDisconnectFieldInput>;
};

export type NotificationEvent = {
  __typename?: 'NotificationEvent';
  actorId?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  eventType?: Maybe<NotificationEventType>;
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  generatingNotiStatus?: Maybe<GeneratingNotificationStatus>;
  id: Scalars['ID']['output'];
  idempotencyKey: Scalars['String']['output'];
  lastModified: Scalars['DateTime']['output'];
  message?: Maybe<Scalars['String']['output']>;
  notifications: Array<Notification>;
  notificationsAggregate?: Maybe<NotificationEventNotificationNotificationsAggregationSelection>;
  notificationsConnection: NotificationEventNotificationsConnection;
  schoolId: Scalars['ID']['output'];
  sourceAnnouncement?: Maybe<Announcement>;
  sourceAnnouncementAggregate?: Maybe<NotificationEventAnnouncementSourceAnnouncementAggregationSelection>;
  sourceAnnouncementConnection: NotificationEventSourceAnnouncementConnection;
  sourceAssessmentSubmission?: Maybe<AssessmentSubmission>;
  sourceAssessmentSubmissionAggregate?: Maybe<NotificationEventAssessmentSubmissionSourceAssessmentSubmissionAggregationSelection>;
  sourceAssessmentSubmissionConnection: NotificationEventSourceAssessmentSubmissionConnection;
  sourceAssignmentSubmission?: Maybe<Submission>;
  sourceAssignmentSubmissionAggregate?: Maybe<NotificationEventSubmissionSourceAssignmentSubmissionAggregationSelection>;
  sourceAssignmentSubmissionConnection: NotificationEventSourceAssignmentSubmissionConnection;
  sourceProjectSubmission?: Maybe<ProjectSubmission>;
  sourceProjectSubmissionAggregate?: Maybe<NotificationEventProjectSubmissionSourceProjectSubmissionAggregationSelection>;
  sourceProjectSubmissionConnection: NotificationEventSourceProjectSubmissionConnection;
  title?: Maybe<Scalars['String']['output']>;
};


export type NotificationEventNotificationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<NotificationOptions>;
  where?: InputMaybe<NotificationWhere>;
};


export type NotificationEventNotificationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NotificationWhere>;
};


export type NotificationEventNotificationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NotificationEventNotificationsConnectionSort>>;
  where?: InputMaybe<NotificationEventNotificationsConnectionWhere>;
};


export type NotificationEventSourceAnnouncementArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AnnouncementOptions>;
  where?: InputMaybe<AnnouncementWhere>;
};


export type NotificationEventSourceAnnouncementAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnnouncementWhere>;
};


export type NotificationEventSourceAnnouncementConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NotificationEventSourceAnnouncementConnectionSort>>;
  where?: InputMaybe<NotificationEventSourceAnnouncementConnectionWhere>;
};


export type NotificationEventSourceAssessmentSubmissionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AssessmentSubmissionOptions>;
  where?: InputMaybe<AssessmentSubmissionWhere>;
};


export type NotificationEventSourceAssessmentSubmissionAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssessmentSubmissionWhere>;
};


export type NotificationEventSourceAssessmentSubmissionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NotificationEventSourceAssessmentSubmissionConnectionSort>>;
  where?: InputMaybe<NotificationEventSourceAssessmentSubmissionConnectionWhere>;
};


export type NotificationEventSourceAssignmentSubmissionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SubmissionOptions>;
  where?: InputMaybe<SubmissionWhere>;
};


export type NotificationEventSourceAssignmentSubmissionAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SubmissionWhere>;
};


export type NotificationEventSourceAssignmentSubmissionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NotificationEventSourceAssignmentSubmissionConnectionSort>>;
  where?: InputMaybe<NotificationEventSourceAssignmentSubmissionConnectionWhere>;
};


export type NotificationEventSourceProjectSubmissionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProjectSubmissionOptions>;
  where?: InputMaybe<ProjectSubmissionWhere>;
};


export type NotificationEventSourceProjectSubmissionAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProjectSubmissionWhere>;
};


export type NotificationEventSourceProjectSubmissionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NotificationEventSourceProjectSubmissionConnectionSort>>;
  where?: InputMaybe<NotificationEventSourceProjectSubmissionConnectionWhere>;
};

export type NotificationEventAggregateInput = {
  AND?: InputMaybe<Array<NotificationEventAggregateInput>>;
  NOT?: InputMaybe<NotificationEventAggregateInput>;
  OR?: InputMaybe<Array<NotificationEventAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NotificationEventNodeAggregationWhereInput>;
};

export type NotificationEventAnnouncementSourceAnnouncementAggregationSelection = {
  __typename?: 'NotificationEventAnnouncementSourceAnnouncementAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<NotificationEventAnnouncementSourceAnnouncementNodeAggregateSelection>;
};

export type NotificationEventAnnouncementSourceAnnouncementNodeAggregateSelection = {
  __typename?: 'NotificationEventAnnouncementSourceAnnouncementNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  expirationDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  message: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type NotificationEventAssessmentSubmissionSourceAssessmentSubmissionAggregationSelection = {
  __typename?: 'NotificationEventAssessmentSubmissionSourceAssessmentSubmissionAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<NotificationEventAssessmentSubmissionSourceAssessmentSubmissionNodeAggregateSelection>;
};

export type NotificationEventAssessmentSubmissionSourceAssessmentSubmissionNodeAggregateSelection = {
  __typename?: 'NotificationEventAssessmentSubmissionSourceAssessmentSubmissionNodeAggregateSelection';
  aiTotalPoints: FloatAggregateSelection;
  completedAt: DateTimeAggregateSelection;
  created: DateTimeAggregateSelection;
  feedback: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  maximumPoints: FloatAggregateSelection;
  startedAt: DateTimeAggregateSelection;
  timeLimit: IntAggregateSelection;
  totalPoints: FloatAggregateSelection;
};

export type NotificationEventConnectFieldInput = {
  connect?: InputMaybe<NotificationEventConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<NotificationEventConnectWhere>;
};

export type NotificationEventConnectInput = {
  notifications?: InputMaybe<Array<NotificationEventNotificationsConnectFieldInput>>;
  sourceAnnouncement?: InputMaybe<NotificationEventSourceAnnouncementConnectFieldInput>;
  sourceAssessmentSubmission?: InputMaybe<NotificationEventSourceAssessmentSubmissionConnectFieldInput>;
  sourceAssignmentSubmission?: InputMaybe<NotificationEventSourceAssignmentSubmissionConnectFieldInput>;
  sourceProjectSubmission?: InputMaybe<NotificationEventSourceProjectSubmissionConnectFieldInput>;
};

export type NotificationEventConnectOrCreateFieldInput = {
  onCreate: NotificationEventConnectOrCreateFieldInputOnCreate;
  where: NotificationEventConnectOrCreateWhere;
};

export type NotificationEventConnectOrCreateFieldInputOnCreate = {
  node: NotificationEventOnCreateInput;
};

export type NotificationEventConnectOrCreateWhere = {
  node: NotificationEventUniqueWhere;
};

export type NotificationEventConnectWhere = {
  node: NotificationEventWhere;
};

export type NotificationEventConnection = {
  __typename?: 'NotificationEventConnection';
  edges: Array<NotificationEventRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NotificationEventConnectionSort = {
  node?: InputMaybe<NotificationEventSort>;
};

export type NotificationEventConnectionWhere = {
  AND?: InputMaybe<Array<NotificationEventConnectionWhere>>;
  NOT?: InputMaybe<NotificationEventConnectionWhere>;
  OR?: InputMaybe<Array<NotificationEventConnectionWhere>>;
  node?: InputMaybe<NotificationEventWhere>;
};

export type NotificationEventCreateFieldInput = {
  node: NotificationEventCreateInput;
};

export type NotificationEventCreateInput = {
  actorId?: InputMaybe<Scalars['String']['input']>;
  created: Scalars['DateTime']['input'];
  eventType?: InputMaybe<NotificationEventType>;
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  generatingNotiStatus?: InputMaybe<GeneratingNotificationStatus>;
  idempotencyKey: Scalars['String']['input'];
  lastModified: Scalars['DateTime']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<NotificationEventNotificationsFieldInput>;
  schoolId: Scalars['ID']['input'];
  sourceAnnouncement?: InputMaybe<NotificationEventSourceAnnouncementFieldInput>;
  sourceAssessmentSubmission?: InputMaybe<NotificationEventSourceAssessmentSubmissionFieldInput>;
  sourceAssignmentSubmission?: InputMaybe<NotificationEventSourceAssignmentSubmissionFieldInput>;
  sourceProjectSubmission?: InputMaybe<NotificationEventSourceProjectSubmissionFieldInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationEventDeleteFieldInput = {
  delete?: InputMaybe<NotificationEventDeleteInput>;
  where?: InputMaybe<NotificationEventConnectionWhere>;
};

export type NotificationEventDeleteInput = {
  notifications?: InputMaybe<Array<NotificationEventNotificationsDeleteFieldInput>>;
  sourceAnnouncement?: InputMaybe<NotificationEventSourceAnnouncementDeleteFieldInput>;
  sourceAssessmentSubmission?: InputMaybe<NotificationEventSourceAssessmentSubmissionDeleteFieldInput>;
  sourceAssignmentSubmission?: InputMaybe<NotificationEventSourceAssignmentSubmissionDeleteFieldInput>;
  sourceProjectSubmission?: InputMaybe<NotificationEventSourceProjectSubmissionDeleteFieldInput>;
};

export type NotificationEventDisconnectFieldInput = {
  disconnect?: InputMaybe<NotificationEventDisconnectInput>;
  where?: InputMaybe<NotificationEventConnectionWhere>;
};

export type NotificationEventDisconnectInput = {
  notifications?: InputMaybe<Array<NotificationEventNotificationsDisconnectFieldInput>>;
  sourceAnnouncement?: InputMaybe<NotificationEventSourceAnnouncementDisconnectFieldInput>;
  sourceAssessmentSubmission?: InputMaybe<NotificationEventSourceAssessmentSubmissionDisconnectFieldInput>;
  sourceAssignmentSubmission?: InputMaybe<NotificationEventSourceAssignmentSubmissionDisconnectFieldInput>;
  sourceProjectSubmission?: InputMaybe<NotificationEventSourceProjectSubmissionDisconnectFieldInput>;
};

export type NotificationEventFieldInput = {
  connect?: InputMaybe<NotificationEventConnectFieldInput>;
  connectOrCreate?: InputMaybe<NotificationEventConnectOrCreateFieldInput>;
  create?: InputMaybe<NotificationEventCreateFieldInput>;
};

export type NotificationEventNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NotificationEventNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NotificationEventNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NotificationEventNodeAggregationWhereInput>>;
  actorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  actorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  actorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  actorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  actorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  actorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  actorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  idempotencyKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  message_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  message_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NotificationEventNotificationNotificationsAggregationSelection = {
  __typename?: 'NotificationEventNotificationNotificationsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<NotificationEventNotificationNotificationsNodeAggregateSelection>;
};

export type NotificationEventNotificationNotificationsNodeAggregateSelection = {
  __typename?: 'NotificationEventNotificationNotificationsNodeAggregateSelection';
  actionUrl: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  message: StringAggregateSelection;
  readAt: DateTimeAggregateSelection;
  schoolId: IdAggregateSelection;
  title: StringAggregateSelection;
  userId: IdAggregateSelection;
};

export type NotificationEventNotificationsAggregateInput = {
  AND?: InputMaybe<Array<NotificationEventNotificationsAggregateInput>>;
  NOT?: InputMaybe<NotificationEventNotificationsAggregateInput>;
  OR?: InputMaybe<Array<NotificationEventNotificationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NotificationEventNotificationsNodeAggregationWhereInput>;
};

export type NotificationEventNotificationsConnectFieldInput = {
  connect?: InputMaybe<Array<NotificationConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<NotificationConnectWhere>;
};

export type NotificationEventNotificationsConnectOrCreateFieldInput = {
  onCreate: NotificationEventNotificationsConnectOrCreateFieldInputOnCreate;
  where: NotificationConnectOrCreateWhere;
};

export type NotificationEventNotificationsConnectOrCreateFieldInputOnCreate = {
  node: NotificationOnCreateInput;
};

export type NotificationEventNotificationsConnection = {
  __typename?: 'NotificationEventNotificationsConnection';
  edges: Array<NotificationEventNotificationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NotificationEventNotificationsConnectionSort = {
  node?: InputMaybe<NotificationSort>;
};

export type NotificationEventNotificationsConnectionWhere = {
  AND?: InputMaybe<Array<NotificationEventNotificationsConnectionWhere>>;
  NOT?: InputMaybe<NotificationEventNotificationsConnectionWhere>;
  OR?: InputMaybe<Array<NotificationEventNotificationsConnectionWhere>>;
  node?: InputMaybe<NotificationWhere>;
};

export type NotificationEventNotificationsCreateFieldInput = {
  node: NotificationCreateInput;
};

export type NotificationEventNotificationsDeleteFieldInput = {
  delete?: InputMaybe<NotificationDeleteInput>;
  where?: InputMaybe<NotificationEventNotificationsConnectionWhere>;
};

export type NotificationEventNotificationsDisconnectFieldInput = {
  disconnect?: InputMaybe<NotificationDisconnectInput>;
  where?: InputMaybe<NotificationEventNotificationsConnectionWhere>;
};

export type NotificationEventNotificationsFieldInput = {
  connect?: InputMaybe<Array<NotificationEventNotificationsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationEventNotificationsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<NotificationEventNotificationsCreateFieldInput>>;
};

export type NotificationEventNotificationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NotificationEventNotificationsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NotificationEventNotificationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NotificationEventNotificationsNodeAggregationWhereInput>>;
  actionUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  actionUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  actionUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  actionUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  actionUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  actionUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actionUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actionUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actionUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actionUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  actionUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actionUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actionUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actionUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actionUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  message_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  message_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  readAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  readAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  readAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  readAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  readAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  readAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  readAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  readAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  readAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  readAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NotificationEventNotificationsRelationship = {
  __typename?: 'NotificationEventNotificationsRelationship';
  cursor: Scalars['String']['output'];
  node: Notification;
};

export type NotificationEventNotificationsUpdateConnectionInput = {
  node?: InputMaybe<NotificationUpdateInput>;
};

export type NotificationEventNotificationsUpdateFieldInput = {
  connect?: InputMaybe<Array<NotificationEventNotificationsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationEventNotificationsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<NotificationEventNotificationsCreateFieldInput>>;
  delete?: InputMaybe<Array<NotificationEventNotificationsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<NotificationEventNotificationsDisconnectFieldInput>>;
  update?: InputMaybe<NotificationEventNotificationsUpdateConnectionInput>;
  where?: InputMaybe<NotificationEventNotificationsConnectionWhere>;
};

export type NotificationEventOnCreateInput = {
  actorId?: InputMaybe<Scalars['String']['input']>;
  created: Scalars['DateTime']['input'];
  eventType?: InputMaybe<NotificationEventType>;
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  generatingNotiStatus?: InputMaybe<GeneratingNotificationStatus>;
  idempotencyKey: Scalars['String']['input'];
  lastModified: Scalars['DateTime']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  schoolId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationEventOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more NotificationEventSort objects to sort NotificationEvents by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<NotificationEventSort>>;
};

export type NotificationEventProjectSubmissionSourceProjectSubmissionAggregationSelection = {
  __typename?: 'NotificationEventProjectSubmissionSourceProjectSubmissionAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<NotificationEventProjectSubmissionSourceProjectSubmissionNodeAggregateSelection>;
};

export type NotificationEventProjectSubmissionSourceProjectSubmissionNodeAggregateSelection = {
  __typename?: 'NotificationEventProjectSubmissionSourceProjectSubmissionNodeAggregateSelection';
  aiAssessment: StringAggregateSelection;
  approachMethodology: StringAggregateSelection;
  completedAt: DateTimeAggregateSelection;
  completedTasks: IntAggregateSelection;
  complianceScore: FloatAggregateSelection;
  created: DateTimeAggregateSelection;
  feedback: StringAggregateSelection;
  grade: FloatAggregateSelection;
  gradedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  proposal: StringAggregateSelection;
  scopeJustification: StringAggregateSelection;
  submissionLink: StringAggregateSelection;
  submissionNotes: StringAggregateSelection;
  totalTasks: IntAggregateSelection;
};

export type NotificationEventRelationship = {
  __typename?: 'NotificationEventRelationship';
  cursor: Scalars['String']['output'];
  node: NotificationEvent;
};

/** Fields to sort NotificationEvents by. The order in which sorts are applied is not guaranteed when specifying many fields in one NotificationEventSort object. */
export type NotificationEventSort = {
  actorId?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  eventType?: InputMaybe<SortDirection>;
  expirationDate?: InputMaybe<SortDirection>;
  generatingNotiStatus?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  idempotencyKey?: InputMaybe<SortDirection>;
  lastModified?: InputMaybe<SortDirection>;
  message?: InputMaybe<SortDirection>;
  schoolId?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
};

export type NotificationEventSourceAnnouncementAggregateInput = {
  AND?: InputMaybe<Array<NotificationEventSourceAnnouncementAggregateInput>>;
  NOT?: InputMaybe<NotificationEventSourceAnnouncementAggregateInput>;
  OR?: InputMaybe<Array<NotificationEventSourceAnnouncementAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NotificationEventSourceAnnouncementNodeAggregationWhereInput>;
};

export type NotificationEventSourceAnnouncementConnectFieldInput = {
  connect?: InputMaybe<AnnouncementConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AnnouncementConnectWhere>;
};

export type NotificationEventSourceAnnouncementConnectOrCreateFieldInput = {
  onCreate: NotificationEventSourceAnnouncementConnectOrCreateFieldInputOnCreate;
  where: AnnouncementConnectOrCreateWhere;
};

export type NotificationEventSourceAnnouncementConnectOrCreateFieldInputOnCreate = {
  node: AnnouncementOnCreateInput;
};

export type NotificationEventSourceAnnouncementConnection = {
  __typename?: 'NotificationEventSourceAnnouncementConnection';
  edges: Array<NotificationEventSourceAnnouncementRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NotificationEventSourceAnnouncementConnectionSort = {
  node?: InputMaybe<AnnouncementSort>;
};

export type NotificationEventSourceAnnouncementConnectionWhere = {
  AND?: InputMaybe<Array<NotificationEventSourceAnnouncementConnectionWhere>>;
  NOT?: InputMaybe<NotificationEventSourceAnnouncementConnectionWhere>;
  OR?: InputMaybe<Array<NotificationEventSourceAnnouncementConnectionWhere>>;
  node?: InputMaybe<AnnouncementWhere>;
};

export type NotificationEventSourceAnnouncementCreateFieldInput = {
  node: AnnouncementCreateInput;
};

export type NotificationEventSourceAnnouncementDeleteFieldInput = {
  delete?: InputMaybe<AnnouncementDeleteInput>;
  where?: InputMaybe<NotificationEventSourceAnnouncementConnectionWhere>;
};

export type NotificationEventSourceAnnouncementDisconnectFieldInput = {
  disconnect?: InputMaybe<AnnouncementDisconnectInput>;
  where?: InputMaybe<NotificationEventSourceAnnouncementConnectionWhere>;
};

export type NotificationEventSourceAnnouncementFieldInput = {
  connect?: InputMaybe<NotificationEventSourceAnnouncementConnectFieldInput>;
  connectOrCreate?: InputMaybe<NotificationEventSourceAnnouncementConnectOrCreateFieldInput>;
  create?: InputMaybe<NotificationEventSourceAnnouncementCreateFieldInput>;
};

export type NotificationEventSourceAnnouncementNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NotificationEventSourceAnnouncementNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NotificationEventSourceAnnouncementNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NotificationEventSourceAnnouncementNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  message_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  message_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NotificationEventSourceAnnouncementRelationship = {
  __typename?: 'NotificationEventSourceAnnouncementRelationship';
  cursor: Scalars['String']['output'];
  node: Announcement;
};

export type NotificationEventSourceAnnouncementUpdateConnectionInput = {
  node?: InputMaybe<AnnouncementUpdateInput>;
};

export type NotificationEventSourceAnnouncementUpdateFieldInput = {
  connect?: InputMaybe<NotificationEventSourceAnnouncementConnectFieldInput>;
  connectOrCreate?: InputMaybe<NotificationEventSourceAnnouncementConnectOrCreateFieldInput>;
  create?: InputMaybe<NotificationEventSourceAnnouncementCreateFieldInput>;
  delete?: InputMaybe<NotificationEventSourceAnnouncementDeleteFieldInput>;
  disconnect?: InputMaybe<NotificationEventSourceAnnouncementDisconnectFieldInput>;
  update?: InputMaybe<NotificationEventSourceAnnouncementUpdateConnectionInput>;
  where?: InputMaybe<NotificationEventSourceAnnouncementConnectionWhere>;
};

export type NotificationEventSourceAssessmentSubmissionAggregateInput = {
  AND?: InputMaybe<Array<NotificationEventSourceAssessmentSubmissionAggregateInput>>;
  NOT?: InputMaybe<NotificationEventSourceAssessmentSubmissionAggregateInput>;
  OR?: InputMaybe<Array<NotificationEventSourceAssessmentSubmissionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NotificationEventSourceAssessmentSubmissionNodeAggregationWhereInput>;
};

export type NotificationEventSourceAssessmentSubmissionConnectFieldInput = {
  connect?: InputMaybe<AssessmentSubmissionConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AssessmentSubmissionConnectWhere>;
};

export type NotificationEventSourceAssessmentSubmissionConnectOrCreateFieldInput = {
  onCreate: NotificationEventSourceAssessmentSubmissionConnectOrCreateFieldInputOnCreate;
  where: AssessmentSubmissionConnectOrCreateWhere;
};

export type NotificationEventSourceAssessmentSubmissionConnectOrCreateFieldInputOnCreate = {
  node: AssessmentSubmissionOnCreateInput;
};

export type NotificationEventSourceAssessmentSubmissionConnection = {
  __typename?: 'NotificationEventSourceAssessmentSubmissionConnection';
  edges: Array<NotificationEventSourceAssessmentSubmissionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NotificationEventSourceAssessmentSubmissionConnectionSort = {
  node?: InputMaybe<AssessmentSubmissionSort>;
};

export type NotificationEventSourceAssessmentSubmissionConnectionWhere = {
  AND?: InputMaybe<Array<NotificationEventSourceAssessmentSubmissionConnectionWhere>>;
  NOT?: InputMaybe<NotificationEventSourceAssessmentSubmissionConnectionWhere>;
  OR?: InputMaybe<Array<NotificationEventSourceAssessmentSubmissionConnectionWhere>>;
  node?: InputMaybe<AssessmentSubmissionWhere>;
};

export type NotificationEventSourceAssessmentSubmissionCreateFieldInput = {
  node: AssessmentSubmissionCreateInput;
};

export type NotificationEventSourceAssessmentSubmissionDeleteFieldInput = {
  delete?: InputMaybe<AssessmentSubmissionDeleteInput>;
  where?: InputMaybe<NotificationEventSourceAssessmentSubmissionConnectionWhere>;
};

export type NotificationEventSourceAssessmentSubmissionDisconnectFieldInput = {
  disconnect?: InputMaybe<AssessmentSubmissionDisconnectInput>;
  where?: InputMaybe<NotificationEventSourceAssessmentSubmissionConnectionWhere>;
};

export type NotificationEventSourceAssessmentSubmissionFieldInput = {
  connect?: InputMaybe<NotificationEventSourceAssessmentSubmissionConnectFieldInput>;
  connectOrCreate?: InputMaybe<NotificationEventSourceAssessmentSubmissionConnectOrCreateFieldInput>;
  create?: InputMaybe<NotificationEventSourceAssessmentSubmissionCreateFieldInput>;
};

export type NotificationEventSourceAssessmentSubmissionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NotificationEventSourceAssessmentSubmissionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NotificationEventSourceAssessmentSubmissionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NotificationEventSourceAssessmentSubmissionNodeAggregationWhereInput>>;
  aiTotalPoints_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  completedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  feedback_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  feedback_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  maximumPoints_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  startedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  timeLimit_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalPoints_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type NotificationEventSourceAssessmentSubmissionRelationship = {
  __typename?: 'NotificationEventSourceAssessmentSubmissionRelationship';
  cursor: Scalars['String']['output'];
  node: AssessmentSubmission;
};

export type NotificationEventSourceAssessmentSubmissionUpdateConnectionInput = {
  node?: InputMaybe<AssessmentSubmissionUpdateInput>;
};

export type NotificationEventSourceAssessmentSubmissionUpdateFieldInput = {
  connect?: InputMaybe<NotificationEventSourceAssessmentSubmissionConnectFieldInput>;
  connectOrCreate?: InputMaybe<NotificationEventSourceAssessmentSubmissionConnectOrCreateFieldInput>;
  create?: InputMaybe<NotificationEventSourceAssessmentSubmissionCreateFieldInput>;
  delete?: InputMaybe<NotificationEventSourceAssessmentSubmissionDeleteFieldInput>;
  disconnect?: InputMaybe<NotificationEventSourceAssessmentSubmissionDisconnectFieldInput>;
  update?: InputMaybe<NotificationEventSourceAssessmentSubmissionUpdateConnectionInput>;
  where?: InputMaybe<NotificationEventSourceAssessmentSubmissionConnectionWhere>;
};

export type NotificationEventSourceAssignmentSubmissionAggregateInput = {
  AND?: InputMaybe<Array<NotificationEventSourceAssignmentSubmissionAggregateInput>>;
  NOT?: InputMaybe<NotificationEventSourceAssignmentSubmissionAggregateInput>;
  OR?: InputMaybe<Array<NotificationEventSourceAssignmentSubmissionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NotificationEventSourceAssignmentSubmissionNodeAggregationWhereInput>;
};

export type NotificationEventSourceAssignmentSubmissionConnectFieldInput = {
  connect?: InputMaybe<SubmissionConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SubmissionConnectWhere>;
};

export type NotificationEventSourceAssignmentSubmissionConnectOrCreateFieldInput = {
  onCreate: NotificationEventSourceAssignmentSubmissionConnectOrCreateFieldInputOnCreate;
  where: SubmissionConnectOrCreateWhere;
};

export type NotificationEventSourceAssignmentSubmissionConnectOrCreateFieldInputOnCreate = {
  node: SubmissionOnCreateInput;
};

export type NotificationEventSourceAssignmentSubmissionConnection = {
  __typename?: 'NotificationEventSourceAssignmentSubmissionConnection';
  edges: Array<NotificationEventSourceAssignmentSubmissionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NotificationEventSourceAssignmentSubmissionConnectionSort = {
  node?: InputMaybe<SubmissionSort>;
};

export type NotificationEventSourceAssignmentSubmissionConnectionWhere = {
  AND?: InputMaybe<Array<NotificationEventSourceAssignmentSubmissionConnectionWhere>>;
  NOT?: InputMaybe<NotificationEventSourceAssignmentSubmissionConnectionWhere>;
  OR?: InputMaybe<Array<NotificationEventSourceAssignmentSubmissionConnectionWhere>>;
  node?: InputMaybe<SubmissionWhere>;
};

export type NotificationEventSourceAssignmentSubmissionCreateFieldInput = {
  node: SubmissionCreateInput;
};

export type NotificationEventSourceAssignmentSubmissionDeleteFieldInput = {
  delete?: InputMaybe<SubmissionDeleteInput>;
  where?: InputMaybe<NotificationEventSourceAssignmentSubmissionConnectionWhere>;
};

export type NotificationEventSourceAssignmentSubmissionDisconnectFieldInput = {
  disconnect?: InputMaybe<SubmissionDisconnectInput>;
  where?: InputMaybe<NotificationEventSourceAssignmentSubmissionConnectionWhere>;
};

export type NotificationEventSourceAssignmentSubmissionFieldInput = {
  connect?: InputMaybe<NotificationEventSourceAssignmentSubmissionConnectFieldInput>;
  connectOrCreate?: InputMaybe<NotificationEventSourceAssignmentSubmissionConnectOrCreateFieldInput>;
  create?: InputMaybe<NotificationEventSourceAssignmentSubmissionCreateFieldInput>;
};

export type NotificationEventSourceAssignmentSubmissionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NotificationEventSourceAssignmentSubmissionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NotificationEventSourceAssignmentSubmissionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NotificationEventSourceAssignmentSubmissionNodeAggregationWhereInput>>;
  completedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  feedback_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  feedback_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationEventSourceAssignmentSubmissionRelationship = {
  __typename?: 'NotificationEventSourceAssignmentSubmissionRelationship';
  cursor: Scalars['String']['output'];
  node: Submission;
};

export type NotificationEventSourceAssignmentSubmissionUpdateConnectionInput = {
  node?: InputMaybe<SubmissionUpdateInput>;
};

export type NotificationEventSourceAssignmentSubmissionUpdateFieldInput = {
  connect?: InputMaybe<NotificationEventSourceAssignmentSubmissionConnectFieldInput>;
  connectOrCreate?: InputMaybe<NotificationEventSourceAssignmentSubmissionConnectOrCreateFieldInput>;
  create?: InputMaybe<NotificationEventSourceAssignmentSubmissionCreateFieldInput>;
  delete?: InputMaybe<NotificationEventSourceAssignmentSubmissionDeleteFieldInput>;
  disconnect?: InputMaybe<NotificationEventSourceAssignmentSubmissionDisconnectFieldInput>;
  update?: InputMaybe<NotificationEventSourceAssignmentSubmissionUpdateConnectionInput>;
  where?: InputMaybe<NotificationEventSourceAssignmentSubmissionConnectionWhere>;
};

export type NotificationEventSourceProjectSubmissionAggregateInput = {
  AND?: InputMaybe<Array<NotificationEventSourceProjectSubmissionAggregateInput>>;
  NOT?: InputMaybe<NotificationEventSourceProjectSubmissionAggregateInput>;
  OR?: InputMaybe<Array<NotificationEventSourceProjectSubmissionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NotificationEventSourceProjectSubmissionNodeAggregationWhereInput>;
};

export type NotificationEventSourceProjectSubmissionConnectFieldInput = {
  connect?: InputMaybe<ProjectSubmissionConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ProjectSubmissionConnectWhere>;
};

export type NotificationEventSourceProjectSubmissionConnectOrCreateFieldInput = {
  onCreate: NotificationEventSourceProjectSubmissionConnectOrCreateFieldInputOnCreate;
  where: ProjectSubmissionConnectOrCreateWhere;
};

export type NotificationEventSourceProjectSubmissionConnectOrCreateFieldInputOnCreate = {
  node: ProjectSubmissionOnCreateInput;
};

export type NotificationEventSourceProjectSubmissionConnection = {
  __typename?: 'NotificationEventSourceProjectSubmissionConnection';
  edges: Array<NotificationEventSourceProjectSubmissionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NotificationEventSourceProjectSubmissionConnectionSort = {
  node?: InputMaybe<ProjectSubmissionSort>;
};

export type NotificationEventSourceProjectSubmissionConnectionWhere = {
  AND?: InputMaybe<Array<NotificationEventSourceProjectSubmissionConnectionWhere>>;
  NOT?: InputMaybe<NotificationEventSourceProjectSubmissionConnectionWhere>;
  OR?: InputMaybe<Array<NotificationEventSourceProjectSubmissionConnectionWhere>>;
  node?: InputMaybe<ProjectSubmissionWhere>;
};

export type NotificationEventSourceProjectSubmissionCreateFieldInput = {
  node: ProjectSubmissionCreateInput;
};

export type NotificationEventSourceProjectSubmissionDeleteFieldInput = {
  delete?: InputMaybe<ProjectSubmissionDeleteInput>;
  where?: InputMaybe<NotificationEventSourceProjectSubmissionConnectionWhere>;
};

export type NotificationEventSourceProjectSubmissionDisconnectFieldInput = {
  disconnect?: InputMaybe<ProjectSubmissionDisconnectInput>;
  where?: InputMaybe<NotificationEventSourceProjectSubmissionConnectionWhere>;
};

export type NotificationEventSourceProjectSubmissionFieldInput = {
  connect?: InputMaybe<NotificationEventSourceProjectSubmissionConnectFieldInput>;
  connectOrCreate?: InputMaybe<NotificationEventSourceProjectSubmissionConnectOrCreateFieldInput>;
  create?: InputMaybe<NotificationEventSourceProjectSubmissionCreateFieldInput>;
};

export type NotificationEventSourceProjectSubmissionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NotificationEventSourceProjectSubmissionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NotificationEventSourceProjectSubmissionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NotificationEventSourceProjectSubmissionNodeAggregationWhereInput>>;
  aiAssessment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiAssessment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aiAssessment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiAssessment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aiAssessment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aiAssessment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  approachMethodology_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  approachMethodology_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  approachMethodology_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  approachMethodology_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  approachMethodology_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  completedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedTasks_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  completedTasks_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  completedTasks_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  completedTasks_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  completedTasks_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  completedTasks_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  complianceScore_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  feedback_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  feedback_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  gradedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  proposal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  proposal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  proposal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  proposal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  proposal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  proposal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  proposal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  proposal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  proposal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  proposal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  proposal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  proposal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  proposal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  proposal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  proposal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scopeJustification_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scopeJustification_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scopeJustification_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scopeJustification_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scopeJustification_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submissionLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submissionLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submissionLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submissionLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  submissionLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submissionNotes_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submissionNotes_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submissionNotes_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submissionNotes_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  submissionNotes_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalTasks_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalTasks_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalTasks_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalTasks_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalTasks_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NotificationEventSourceProjectSubmissionRelationship = {
  __typename?: 'NotificationEventSourceProjectSubmissionRelationship';
  cursor: Scalars['String']['output'];
  node: ProjectSubmission;
};

export type NotificationEventSourceProjectSubmissionUpdateConnectionInput = {
  node?: InputMaybe<ProjectSubmissionUpdateInput>;
};

export type NotificationEventSourceProjectSubmissionUpdateFieldInput = {
  connect?: InputMaybe<NotificationEventSourceProjectSubmissionConnectFieldInput>;
  connectOrCreate?: InputMaybe<NotificationEventSourceProjectSubmissionConnectOrCreateFieldInput>;
  create?: InputMaybe<NotificationEventSourceProjectSubmissionCreateFieldInput>;
  delete?: InputMaybe<NotificationEventSourceProjectSubmissionDeleteFieldInput>;
  disconnect?: InputMaybe<NotificationEventSourceProjectSubmissionDisconnectFieldInput>;
  update?: InputMaybe<NotificationEventSourceProjectSubmissionUpdateConnectionInput>;
  where?: InputMaybe<NotificationEventSourceProjectSubmissionConnectionWhere>;
};

export type NotificationEventSubmissionSourceAssignmentSubmissionAggregationSelection = {
  __typename?: 'NotificationEventSubmissionSourceAssignmentSubmissionAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<NotificationEventSubmissionSourceAssignmentSubmissionNodeAggregateSelection>;
};

export type NotificationEventSubmissionSourceAssignmentSubmissionNodeAggregateSelection = {
  __typename?: 'NotificationEventSubmissionSourceAssignmentSubmissionNodeAggregateSelection';
  completedAt: DateTimeAggregateSelection;
  created: DateTimeAggregateSelection;
  feedback: StringAggregateSelection;
  grade: FloatAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
};

export enum NotificationEventType {
  AnnouncementPosted = 'ANNOUNCEMENT_POSTED',
  AnnouncementUpdated = 'ANNOUNCEMENT_UPDATED',
  AssessmentSubmission = 'ASSESSMENT_SUBMISSION',
  AssignmentSubmission = 'ASSIGNMENT_SUBMISSION',
  DownloadUrl = 'DOWNLOAD_URL',
  ProjectSubmission = 'PROJECT_SUBMISSION'
}

export type NotificationEventUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type NotificationEventUpdateConnectionInput = {
  node?: InputMaybe<NotificationEventUpdateInput>;
};

export type NotificationEventUpdateFieldInput = {
  connect?: InputMaybe<NotificationEventConnectFieldInput>;
  connectOrCreate?: InputMaybe<NotificationEventConnectOrCreateFieldInput>;
  create?: InputMaybe<NotificationEventCreateFieldInput>;
  delete?: InputMaybe<NotificationEventDeleteFieldInput>;
  disconnect?: InputMaybe<NotificationEventDisconnectFieldInput>;
  update?: InputMaybe<NotificationEventUpdateConnectionInput>;
  where?: InputMaybe<NotificationEventConnectionWhere>;
};

export type NotificationEventUpdateInput = {
  actorId?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  eventType?: InputMaybe<NotificationEventType>;
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  generatingNotiStatus?: InputMaybe<GeneratingNotificationStatus>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<Array<NotificationEventNotificationsUpdateFieldInput>>;
  schoolId?: InputMaybe<Scalars['ID']['input']>;
  sourceAnnouncement?: InputMaybe<NotificationEventSourceAnnouncementUpdateFieldInput>;
  sourceAssessmentSubmission?: InputMaybe<NotificationEventSourceAssessmentSubmissionUpdateFieldInput>;
  sourceAssignmentSubmission?: InputMaybe<NotificationEventSourceAssignmentSubmissionUpdateFieldInput>;
  sourceProjectSubmission?: InputMaybe<NotificationEventSourceProjectSubmissionUpdateFieldInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationEventWhere = {
  AND?: InputMaybe<Array<NotificationEventWhere>>;
  NOT?: InputMaybe<NotificationEventWhere>;
  OR?: InputMaybe<Array<NotificationEventWhere>>;
  actorId?: InputMaybe<Scalars['String']['input']>;
  actorId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  actorId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  actorId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actorId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  eventType?: InputMaybe<NotificationEventType>;
  eventType_IN?: InputMaybe<Array<InputMaybe<NotificationEventType>>>;
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  expirationDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  generatingNotiStatus?: InputMaybe<GeneratingNotificationStatus>;
  generatingNotiStatus_IN?: InputMaybe<Array<InputMaybe<GeneratingNotificationStatus>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  idempotencyKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lastModified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  message_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  message_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  message_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  message_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  notificationsAggregate?: InputMaybe<NotificationEventNotificationsAggregateInput>;
  /** Return NotificationEvents where all of the related NotificationEventNotificationsConnections match this filter */
  notificationsConnection_ALL?: InputMaybe<NotificationEventNotificationsConnectionWhere>;
  /** Return NotificationEvents where none of the related NotificationEventNotificationsConnections match this filter */
  notificationsConnection_NONE?: InputMaybe<NotificationEventNotificationsConnectionWhere>;
  /** Return NotificationEvents where one of the related NotificationEventNotificationsConnections match this filter */
  notificationsConnection_SINGLE?: InputMaybe<NotificationEventNotificationsConnectionWhere>;
  /** Return NotificationEvents where some of the related NotificationEventNotificationsConnections match this filter */
  notificationsConnection_SOME?: InputMaybe<NotificationEventNotificationsConnectionWhere>;
  /** Return NotificationEvents where all of the related Notifications match this filter */
  notifications_ALL?: InputMaybe<NotificationWhere>;
  /** Return NotificationEvents where none of the related Notifications match this filter */
  notifications_NONE?: InputMaybe<NotificationWhere>;
  /** Return NotificationEvents where one of the related Notifications match this filter */
  notifications_SINGLE?: InputMaybe<NotificationWhere>;
  /** Return NotificationEvents where some of the related Notifications match this filter */
  notifications_SOME?: InputMaybe<NotificationWhere>;
  schoolId?: InputMaybe<Scalars['ID']['input']>;
  schoolId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  schoolId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  schoolId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  schoolId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  sourceAnnouncement?: InputMaybe<AnnouncementWhere>;
  sourceAnnouncementAggregate?: InputMaybe<NotificationEventSourceAnnouncementAggregateInput>;
  sourceAnnouncementConnection?: InputMaybe<NotificationEventSourceAnnouncementConnectionWhere>;
  sourceAnnouncementConnection_NOT?: InputMaybe<NotificationEventSourceAnnouncementConnectionWhere>;
  sourceAnnouncement_NOT?: InputMaybe<AnnouncementWhere>;
  sourceAssessmentSubmission?: InputMaybe<AssessmentSubmissionWhere>;
  sourceAssessmentSubmissionAggregate?: InputMaybe<NotificationEventSourceAssessmentSubmissionAggregateInput>;
  sourceAssessmentSubmissionConnection?: InputMaybe<NotificationEventSourceAssessmentSubmissionConnectionWhere>;
  sourceAssessmentSubmissionConnection_NOT?: InputMaybe<NotificationEventSourceAssessmentSubmissionConnectionWhere>;
  sourceAssessmentSubmission_NOT?: InputMaybe<AssessmentSubmissionWhere>;
  sourceAssignmentSubmission?: InputMaybe<SubmissionWhere>;
  sourceAssignmentSubmissionAggregate?: InputMaybe<NotificationEventSourceAssignmentSubmissionAggregateInput>;
  sourceAssignmentSubmissionConnection?: InputMaybe<NotificationEventSourceAssignmentSubmissionConnectionWhere>;
  sourceAssignmentSubmissionConnection_NOT?: InputMaybe<NotificationEventSourceAssignmentSubmissionConnectionWhere>;
  sourceAssignmentSubmission_NOT?: InputMaybe<SubmissionWhere>;
  sourceProjectSubmission?: InputMaybe<ProjectSubmissionWhere>;
  sourceProjectSubmissionAggregate?: InputMaybe<NotificationEventSourceProjectSubmissionAggregateInput>;
  sourceProjectSubmissionConnection?: InputMaybe<NotificationEventSourceProjectSubmissionConnectionWhere>;
  sourceProjectSubmissionConnection_NOT?: InputMaybe<NotificationEventSourceProjectSubmissionConnectionWhere>;
  sourceProjectSubmission_NOT?: InputMaybe<ProjectSubmissionWhere>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationLiveUpdate = {
  __typename?: 'NotificationLiveUpdate';
  actionUrl?: Maybe<Scalars['String']['output']>;
  created: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type?: Maybe<NotificationType>;
  userId: Scalars['ID']['output'];
};

export type NotificationNotificationEventEventAggregationSelection = {
  __typename?: 'NotificationNotificationEventEventAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<NotificationNotificationEventEventNodeAggregateSelection>;
};

export type NotificationNotificationEventEventNodeAggregateSelection = {
  __typename?: 'NotificationNotificationEventEventNodeAggregateSelection';
  actorId: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  expirationDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  idempotencyKey: StringAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  message: StringAggregateSelection;
  schoolId: IdAggregateSelection;
  title: StringAggregateSelection;
};

export type NotificationOnCreateInput = {
  actionUrl?: InputMaybe<Scalars['String']['input']>;
  created: Scalars['DateTime']['input'];
  isRead?: Scalars['Boolean']['input'];
  message: Scalars['String']['input'];
  readAt?: InputMaybe<Scalars['DateTime']['input']>;
  schoolId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  type?: InputMaybe<NotificationType>;
  userId: Scalars['ID']['input'];
};

export type NotificationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more NotificationSort objects to sort Notifications by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<NotificationSort>>;
};

export type NotificationResponse = {
  __typename?: 'NotificationResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<Notification>>>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Fields to sort Notifications by. The order in which sorts are applied is not guaranteed when specifying many fields in one NotificationSort object. */
export type NotificationSort = {
  actionUrl?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isRead?: InputMaybe<SortDirection>;
  message?: InputMaybe<SortDirection>;
  readAt?: InputMaybe<SortDirection>;
  schoolId?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
  userId?: InputMaybe<SortDirection>;
};

export enum NotificationType {
  DownloadFile = 'DOWNLOAD_FILE',
  Info = 'INFO'
}

export type NotificationUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type NotificationUpdateInput = {
  actionUrl?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  event?: InputMaybe<NotificationEventUpdateFieldInput>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  readAt?: InputMaybe<Scalars['DateTime']['input']>;
  schoolId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NotificationType>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type NotificationWhere = {
  AND?: InputMaybe<Array<NotificationWhere>>;
  NOT?: InputMaybe<NotificationWhere>;
  OR?: InputMaybe<Array<NotificationWhere>>;
  actionUrl?: InputMaybe<Scalars['String']['input']>;
  actionUrl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  actionUrl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  actionUrl_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionUrl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  event?: InputMaybe<NotificationEventWhere>;
  eventAggregate?: InputMaybe<NotificationEventAggregateInput>;
  eventConnection?: InputMaybe<NotificationEventConnectionWhere>;
  eventConnection_NOT?: InputMaybe<NotificationEventConnectionWhere>;
  event_NOT?: InputMaybe<NotificationEventWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  message_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  message_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  message_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  message_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  readAt?: InputMaybe<Scalars['DateTime']['input']>;
  readAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  readAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  readAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  readAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  readAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  schoolId?: InputMaybe<Scalars['ID']['input']>;
  schoolId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  schoolId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  schoolId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  schoolId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NotificationType>;
  type_IN?: InputMaybe<Array<InputMaybe<NotificationType>>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  userId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  userId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type Nudge = {
  __typename?: 'Nudge';
  aboutAiTutor?: Maybe<AiTutor>;
  aboutAiTutorAggregate?: Maybe<NudgeAiTutorAboutAiTutorAggregationSelection>;
  aboutAiTutorConnection: NudgeAboutAiTutorConnection;
  aboutAnnouncement?: Maybe<Announcement>;
  aboutAnnouncementAggregate?: Maybe<NudgeAnnouncementAboutAnnouncementAggregationSelection>;
  aboutAnnouncementConnection: NudgeAboutAnnouncementConnection;
  aboutAssessment?: Maybe<Assessment>;
  aboutAssessmentAggregate?: Maybe<NudgeAssessmentAboutAssessmentAggregationSelection>;
  aboutAssessmentConnection: NudgeAboutAssessmentConnection;
  aboutAssignment?: Maybe<Assignment>;
  aboutAssignmentAggregate?: Maybe<NudgeAssignmentAboutAssignmentAggregationSelection>;
  aboutAssignmentConnection: NudgeAboutAssignmentConnection;
  aboutCourse?: Maybe<Course>;
  aboutCourseAggregate?: Maybe<NudgeCourseAboutCourseAggregationSelection>;
  aboutCourseConnection: NudgeAboutCourseConnection;
  aboutExternalAnnouncement?: Maybe<ExternalAnnouncement>;
  aboutExternalAnnouncementAggregate?: Maybe<NudgeExternalAnnouncementAboutExternalAnnouncementAggregationSelection>;
  aboutExternalAnnouncementConnection: NudgeAboutExternalAnnouncementConnection;
  aboutExternalAssignment?: Maybe<ExternalAssignment>;
  aboutExternalAssignmentAggregate?: Maybe<NudgeExternalAssignmentAboutExternalAssignmentAggregationSelection>;
  aboutExternalAssignmentConnection: NudgeAboutExternalAssignmentConnection;
  aboutExternalDiscussionBoard?: Maybe<ExternalDiscussionBoard>;
  aboutExternalDiscussionBoardAggregate?: Maybe<NudgeExternalDiscussionBoardAboutExternalDiscussionBoardAggregationSelection>;
  aboutExternalDiscussionBoardConnection: NudgeAboutExternalDiscussionBoardConnection;
  aboutExternalQuiz?: Maybe<ExternalQuiz>;
  aboutExternalQuizAggregate?: Maybe<NudgeExternalQuizAboutExternalQuizAggregationSelection>;
  aboutExternalQuizConnection: NudgeAboutExternalQuizConnection;
  aboutModule?: Maybe<Module>;
  aboutModuleAggregate?: Maybe<NudgeModuleAboutModuleAggregationSelection>;
  aboutModuleConnection: NudgeAboutModuleConnection;
  aboutProject?: Maybe<Project>;
  aboutProjectAggregate?: Maybe<NudgeProjectAboutProjectAggregationSelection>;
  aboutProjectConnection: NudgeAboutProjectConnection;
  aboutProjectRequirement?: Maybe<ProjectRequirement>;
  aboutProjectRequirementAggregate?: Maybe<NudgeProjectRequirementAboutProjectRequirementAggregationSelection>;
  aboutProjectRequirementConnection: NudgeAboutProjectRequirementConnection;
  aboutUser?: Maybe<User>;
  aboutUserAggregate?: Maybe<NudgeUserAboutUserAggregationSelection>;
  aboutUserConnection: NudgeAboutUserConnection;
  created: Scalars['DateTime']['output'];
  events: Array<NudgeEvent>;
  eventsAggregate?: Maybe<NudgeNudgeEventEventsAggregationSelection>;
  eventsConnection: NudgeEventsConnection;
  id: Scalars['ID']['output'];
  idempotencyKey: Scalars['String']['output'];
  lastModified: Scalars['DateTime']['output'];
  nudgeType: NudgeType;
  parentType: NudgeParentType;
  priorityScore: Scalars['Float']['output'];
  scheduledFor?: Maybe<Scalars['DateTime']['output']>;
  snoozedUntil?: Maybe<Scalars['DateTime']['output']>;
  state: NudgeState;
  taskCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  triggerData: Scalars['JSON']['output'];
  triggerEventType?: Maybe<NudgeTriggerEventType>;
  user: User;
  userAggregate?: Maybe<NudgeUserUserAggregationSelection>;
  userConnection: NudgeUserConnection;
};


export type NudgeAboutAiTutorArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AiTutorOptions>;
  where?: InputMaybe<AiTutorWhere>;
};


export type NudgeAboutAiTutorAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AiTutorWhere>;
};


export type NudgeAboutAiTutorConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NudgeAboutAiTutorConnectionSort>>;
  where?: InputMaybe<NudgeAboutAiTutorConnectionWhere>;
};


export type NudgeAboutAnnouncementArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AnnouncementOptions>;
  where?: InputMaybe<AnnouncementWhere>;
};


export type NudgeAboutAnnouncementAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnnouncementWhere>;
};


export type NudgeAboutAnnouncementConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NudgeAboutAnnouncementConnectionSort>>;
  where?: InputMaybe<NudgeAboutAnnouncementConnectionWhere>;
};


export type NudgeAboutAssessmentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AssessmentOptions>;
  where?: InputMaybe<AssessmentWhere>;
};


export type NudgeAboutAssessmentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssessmentWhere>;
};


export type NudgeAboutAssessmentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NudgeAboutAssessmentConnectionSort>>;
  where?: InputMaybe<NudgeAboutAssessmentConnectionWhere>;
};


export type NudgeAboutAssignmentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AssignmentOptions>;
  where?: InputMaybe<AssignmentWhere>;
};


export type NudgeAboutAssignmentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssignmentWhere>;
};


export type NudgeAboutAssignmentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NudgeAboutAssignmentConnectionSort>>;
  where?: InputMaybe<NudgeAboutAssignmentConnectionWhere>;
};


export type NudgeAboutCourseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CourseOptions>;
  where?: InputMaybe<CourseWhere>;
};


export type NudgeAboutCourseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CourseWhere>;
};


export type NudgeAboutCourseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NudgeAboutCourseConnectionSort>>;
  where?: InputMaybe<NudgeAboutCourseConnectionWhere>;
};


export type NudgeAboutExternalAnnouncementArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalAnnouncementOptions>;
  where?: InputMaybe<ExternalAnnouncementWhere>;
};


export type NudgeAboutExternalAnnouncementAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalAnnouncementWhere>;
};


export type NudgeAboutExternalAnnouncementConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NudgeAboutExternalAnnouncementConnectionSort>>;
  where?: InputMaybe<NudgeAboutExternalAnnouncementConnectionWhere>;
};


export type NudgeAboutExternalAssignmentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalAssignmentOptions>;
  where?: InputMaybe<ExternalAssignmentWhere>;
};


export type NudgeAboutExternalAssignmentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalAssignmentWhere>;
};


export type NudgeAboutExternalAssignmentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NudgeAboutExternalAssignmentConnectionSort>>;
  where?: InputMaybe<NudgeAboutExternalAssignmentConnectionWhere>;
};


export type NudgeAboutExternalDiscussionBoardArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalDiscussionBoardOptions>;
  where?: InputMaybe<ExternalDiscussionBoardWhere>;
};


export type NudgeAboutExternalDiscussionBoardAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalDiscussionBoardWhere>;
};


export type NudgeAboutExternalDiscussionBoardConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NudgeAboutExternalDiscussionBoardConnectionSort>>;
  where?: InputMaybe<NudgeAboutExternalDiscussionBoardConnectionWhere>;
};


export type NudgeAboutExternalQuizArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalQuizOptions>;
  where?: InputMaybe<ExternalQuizWhere>;
};


export type NudgeAboutExternalQuizAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalQuizWhere>;
};


export type NudgeAboutExternalQuizConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NudgeAboutExternalQuizConnectionSort>>;
  where?: InputMaybe<NudgeAboutExternalQuizConnectionWhere>;
};


export type NudgeAboutModuleArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ModuleOptions>;
  where?: InputMaybe<ModuleWhere>;
};


export type NudgeAboutModuleAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ModuleWhere>;
};


export type NudgeAboutModuleConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NudgeAboutModuleConnectionSort>>;
  where?: InputMaybe<NudgeAboutModuleConnectionWhere>;
};


export type NudgeAboutProjectArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProjectOptions>;
  where?: InputMaybe<ProjectWhere>;
};


export type NudgeAboutProjectAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProjectWhere>;
};


export type NudgeAboutProjectConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NudgeAboutProjectConnectionSort>>;
  where?: InputMaybe<NudgeAboutProjectConnectionWhere>;
};


export type NudgeAboutProjectRequirementArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProjectRequirementOptions>;
  where?: InputMaybe<ProjectRequirementWhere>;
};


export type NudgeAboutProjectRequirementAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProjectRequirementWhere>;
};


export type NudgeAboutProjectRequirementConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NudgeAboutProjectRequirementConnectionSort>>;
  where?: InputMaybe<NudgeAboutProjectRequirementConnectionWhere>;
};


export type NudgeAboutUserArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type NudgeAboutUserAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type NudgeAboutUserConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NudgeAboutUserConnectionSort>>;
  where?: InputMaybe<NudgeAboutUserConnectionWhere>;
};


export type NudgeEventsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<NudgeEventOptions>;
  where?: InputMaybe<NudgeEventWhere>;
};


export type NudgeEventsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NudgeEventWhere>;
};


export type NudgeEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NudgeEventsConnectionSort>>;
  where?: InputMaybe<NudgeEventsConnectionWhere>;
};


export type NudgeUserArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type NudgeUserAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type NudgeUserConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NudgeUserConnectionSort>>;
  where?: InputMaybe<NudgeUserConnectionWhere>;
};

export type NudgeAiTutorAboutAiTutorAggregationSelection = {
  __typename?: 'NudgeAITutorAboutAiTutorAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<NudgeAiTutorAboutAiTutorNodeAggregateSelection>;
};

export type NudgeAiTutorAboutAiTutorNodeAggregateSelection = {
  __typename?: 'NudgeAITutorAboutAiTutorNodeAggregateSelection';
  context: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  targetAudience: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type NudgeAboutAiTutorAggregateInput = {
  AND?: InputMaybe<Array<NudgeAboutAiTutorAggregateInput>>;
  NOT?: InputMaybe<NudgeAboutAiTutorAggregateInput>;
  OR?: InputMaybe<Array<NudgeAboutAiTutorAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NudgeAboutAiTutorNodeAggregationWhereInput>;
};

export type NudgeAboutAiTutorConnectFieldInput = {
  connect?: InputMaybe<AiTutorConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AiTutorConnectWhere>;
};

export type NudgeAboutAiTutorConnectOrCreateFieldInput = {
  onCreate: NudgeAboutAiTutorConnectOrCreateFieldInputOnCreate;
  where: AiTutorConnectOrCreateWhere;
};

export type NudgeAboutAiTutorConnectOrCreateFieldInputOnCreate = {
  node: AiTutorOnCreateInput;
};

export type NudgeAboutAiTutorConnection = {
  __typename?: 'NudgeAboutAiTutorConnection';
  edges: Array<NudgeAboutAiTutorRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NudgeAboutAiTutorConnectionSort = {
  node?: InputMaybe<AiTutorSort>;
};

export type NudgeAboutAiTutorConnectionWhere = {
  AND?: InputMaybe<Array<NudgeAboutAiTutorConnectionWhere>>;
  NOT?: InputMaybe<NudgeAboutAiTutorConnectionWhere>;
  OR?: InputMaybe<Array<NudgeAboutAiTutorConnectionWhere>>;
  node?: InputMaybe<AiTutorWhere>;
};

export type NudgeAboutAiTutorCreateFieldInput = {
  node: AiTutorCreateInput;
};

export type NudgeAboutAiTutorDeleteFieldInput = {
  delete?: InputMaybe<AiTutorDeleteInput>;
  where?: InputMaybe<NudgeAboutAiTutorConnectionWhere>;
};

export type NudgeAboutAiTutorDisconnectFieldInput = {
  disconnect?: InputMaybe<AiTutorDisconnectInput>;
  where?: InputMaybe<NudgeAboutAiTutorConnectionWhere>;
};

export type NudgeAboutAiTutorFieldInput = {
  connect?: InputMaybe<NudgeAboutAiTutorConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgeAboutAiTutorConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgeAboutAiTutorCreateFieldInput>;
};

export type NudgeAboutAiTutorNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NudgeAboutAiTutorNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NudgeAboutAiTutorNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NudgeAboutAiTutorNodeAggregationWhereInput>>;
  context_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  context_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NudgeAboutAiTutorRelationship = {
  __typename?: 'NudgeAboutAiTutorRelationship';
  cursor: Scalars['String']['output'];
  node: AiTutor;
};

export type NudgeAboutAiTutorUpdateConnectionInput = {
  node?: InputMaybe<AiTutorUpdateInput>;
};

export type NudgeAboutAiTutorUpdateFieldInput = {
  connect?: InputMaybe<NudgeAboutAiTutorConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgeAboutAiTutorConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgeAboutAiTutorCreateFieldInput>;
  delete?: InputMaybe<NudgeAboutAiTutorDeleteFieldInput>;
  disconnect?: InputMaybe<NudgeAboutAiTutorDisconnectFieldInput>;
  update?: InputMaybe<NudgeAboutAiTutorUpdateConnectionInput>;
  where?: InputMaybe<NudgeAboutAiTutorConnectionWhere>;
};

export type NudgeAboutAnnouncementAggregateInput = {
  AND?: InputMaybe<Array<NudgeAboutAnnouncementAggregateInput>>;
  NOT?: InputMaybe<NudgeAboutAnnouncementAggregateInput>;
  OR?: InputMaybe<Array<NudgeAboutAnnouncementAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NudgeAboutAnnouncementNodeAggregationWhereInput>;
};

export type NudgeAboutAnnouncementConnectFieldInput = {
  connect?: InputMaybe<AnnouncementConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AnnouncementConnectWhere>;
};

export type NudgeAboutAnnouncementConnectOrCreateFieldInput = {
  onCreate: NudgeAboutAnnouncementConnectOrCreateFieldInputOnCreate;
  where: AnnouncementConnectOrCreateWhere;
};

export type NudgeAboutAnnouncementConnectOrCreateFieldInputOnCreate = {
  node: AnnouncementOnCreateInput;
};

export type NudgeAboutAnnouncementConnection = {
  __typename?: 'NudgeAboutAnnouncementConnection';
  edges: Array<NudgeAboutAnnouncementRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NudgeAboutAnnouncementConnectionSort = {
  node?: InputMaybe<AnnouncementSort>;
};

export type NudgeAboutAnnouncementConnectionWhere = {
  AND?: InputMaybe<Array<NudgeAboutAnnouncementConnectionWhere>>;
  NOT?: InputMaybe<NudgeAboutAnnouncementConnectionWhere>;
  OR?: InputMaybe<Array<NudgeAboutAnnouncementConnectionWhere>>;
  node?: InputMaybe<AnnouncementWhere>;
};

export type NudgeAboutAnnouncementCreateFieldInput = {
  node: AnnouncementCreateInput;
};

export type NudgeAboutAnnouncementDeleteFieldInput = {
  delete?: InputMaybe<AnnouncementDeleteInput>;
  where?: InputMaybe<NudgeAboutAnnouncementConnectionWhere>;
};

export type NudgeAboutAnnouncementDisconnectFieldInput = {
  disconnect?: InputMaybe<AnnouncementDisconnectInput>;
  where?: InputMaybe<NudgeAboutAnnouncementConnectionWhere>;
};

export type NudgeAboutAnnouncementFieldInput = {
  connect?: InputMaybe<NudgeAboutAnnouncementConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgeAboutAnnouncementConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgeAboutAnnouncementCreateFieldInput>;
};

export type NudgeAboutAnnouncementNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NudgeAboutAnnouncementNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NudgeAboutAnnouncementNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NudgeAboutAnnouncementNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  message_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  message_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NudgeAboutAnnouncementRelationship = {
  __typename?: 'NudgeAboutAnnouncementRelationship';
  cursor: Scalars['String']['output'];
  node: Announcement;
};

export type NudgeAboutAnnouncementUpdateConnectionInput = {
  node?: InputMaybe<AnnouncementUpdateInput>;
};

export type NudgeAboutAnnouncementUpdateFieldInput = {
  connect?: InputMaybe<NudgeAboutAnnouncementConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgeAboutAnnouncementConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgeAboutAnnouncementCreateFieldInput>;
  delete?: InputMaybe<NudgeAboutAnnouncementDeleteFieldInput>;
  disconnect?: InputMaybe<NudgeAboutAnnouncementDisconnectFieldInput>;
  update?: InputMaybe<NudgeAboutAnnouncementUpdateConnectionInput>;
  where?: InputMaybe<NudgeAboutAnnouncementConnectionWhere>;
};

export type NudgeAboutAssessmentAggregateInput = {
  AND?: InputMaybe<Array<NudgeAboutAssessmentAggregateInput>>;
  NOT?: InputMaybe<NudgeAboutAssessmentAggregateInput>;
  OR?: InputMaybe<Array<NudgeAboutAssessmentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NudgeAboutAssessmentNodeAggregationWhereInput>;
};

export type NudgeAboutAssessmentConnectFieldInput = {
  connect?: InputMaybe<AssessmentConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AssessmentConnectWhere>;
};

export type NudgeAboutAssessmentConnectOrCreateFieldInput = {
  onCreate: NudgeAboutAssessmentConnectOrCreateFieldInputOnCreate;
  where: AssessmentConnectOrCreateWhere;
};

export type NudgeAboutAssessmentConnectOrCreateFieldInputOnCreate = {
  node: AssessmentOnCreateInput;
};

export type NudgeAboutAssessmentConnection = {
  __typename?: 'NudgeAboutAssessmentConnection';
  edges: Array<NudgeAboutAssessmentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NudgeAboutAssessmentConnectionSort = {
  node?: InputMaybe<AssessmentSort>;
};

export type NudgeAboutAssessmentConnectionWhere = {
  AND?: InputMaybe<Array<NudgeAboutAssessmentConnectionWhere>>;
  NOT?: InputMaybe<NudgeAboutAssessmentConnectionWhere>;
  OR?: InputMaybe<Array<NudgeAboutAssessmentConnectionWhere>>;
  node?: InputMaybe<AssessmentWhere>;
};

export type NudgeAboutAssessmentCreateFieldInput = {
  node: AssessmentCreateInput;
};

export type NudgeAboutAssessmentDeleteFieldInput = {
  delete?: InputMaybe<AssessmentDeleteInput>;
  where?: InputMaybe<NudgeAboutAssessmentConnectionWhere>;
};

export type NudgeAboutAssessmentDisconnectFieldInput = {
  disconnect?: InputMaybe<AssessmentDisconnectInput>;
  where?: InputMaybe<NudgeAboutAssessmentConnectionWhere>;
};

export type NudgeAboutAssessmentFieldInput = {
  connect?: InputMaybe<NudgeAboutAssessmentConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgeAboutAssessmentConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgeAboutAssessmentCreateFieldInput>;
};

export type NudgeAboutAssessmentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NudgeAboutAssessmentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NudgeAboutAssessmentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NudgeAboutAssessmentNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfQuestions_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  timeLimit_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NudgeAboutAssessmentRelationship = {
  __typename?: 'NudgeAboutAssessmentRelationship';
  cursor: Scalars['String']['output'];
  node: Assessment;
};

export type NudgeAboutAssessmentUpdateConnectionInput = {
  node?: InputMaybe<AssessmentUpdateInput>;
};

export type NudgeAboutAssessmentUpdateFieldInput = {
  connect?: InputMaybe<NudgeAboutAssessmentConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgeAboutAssessmentConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgeAboutAssessmentCreateFieldInput>;
  delete?: InputMaybe<NudgeAboutAssessmentDeleteFieldInput>;
  disconnect?: InputMaybe<NudgeAboutAssessmentDisconnectFieldInput>;
  update?: InputMaybe<NudgeAboutAssessmentUpdateConnectionInput>;
  where?: InputMaybe<NudgeAboutAssessmentConnectionWhere>;
};

export type NudgeAboutAssignmentAggregateInput = {
  AND?: InputMaybe<Array<NudgeAboutAssignmentAggregateInput>>;
  NOT?: InputMaybe<NudgeAboutAssignmentAggregateInput>;
  OR?: InputMaybe<Array<NudgeAboutAssignmentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NudgeAboutAssignmentNodeAggregationWhereInput>;
};

export type NudgeAboutAssignmentConnectFieldInput = {
  connect?: InputMaybe<AssignmentConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AssignmentConnectWhere>;
};

export type NudgeAboutAssignmentConnectOrCreateFieldInput = {
  onCreate: NudgeAboutAssignmentConnectOrCreateFieldInputOnCreate;
  where: AssignmentConnectOrCreateWhere;
};

export type NudgeAboutAssignmentConnectOrCreateFieldInputOnCreate = {
  node: AssignmentOnCreateInput;
};

export type NudgeAboutAssignmentConnection = {
  __typename?: 'NudgeAboutAssignmentConnection';
  edges: Array<NudgeAboutAssignmentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NudgeAboutAssignmentConnectionSort = {
  node?: InputMaybe<AssignmentSort>;
};

export type NudgeAboutAssignmentConnectionWhere = {
  AND?: InputMaybe<Array<NudgeAboutAssignmentConnectionWhere>>;
  NOT?: InputMaybe<NudgeAboutAssignmentConnectionWhere>;
  OR?: InputMaybe<Array<NudgeAboutAssignmentConnectionWhere>>;
  node?: InputMaybe<AssignmentWhere>;
};

export type NudgeAboutAssignmentCreateFieldInput = {
  node: AssignmentCreateInput;
};

export type NudgeAboutAssignmentDeleteFieldInput = {
  delete?: InputMaybe<AssignmentDeleteInput>;
  where?: InputMaybe<NudgeAboutAssignmentConnectionWhere>;
};

export type NudgeAboutAssignmentDisconnectFieldInput = {
  disconnect?: InputMaybe<AssignmentDisconnectInput>;
  where?: InputMaybe<NudgeAboutAssignmentConnectionWhere>;
};

export type NudgeAboutAssignmentFieldInput = {
  connect?: InputMaybe<NudgeAboutAssignmentConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgeAboutAssignmentConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgeAboutAssignmentCreateFieldInput>;
};

export type NudgeAboutAssignmentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NudgeAboutAssignmentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NudgeAboutAssignmentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NudgeAboutAssignmentNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  allowed_attempts_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_group_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  body_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  category_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_assignment_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_unread_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  display_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  due_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_date_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_points_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  html_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lti_context_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  max_attempts_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  needs_grading_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  points_possible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  secure_params_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  secure_params_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  session_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NudgeAboutAssignmentRelationship = {
  __typename?: 'NudgeAboutAssignmentRelationship';
  cursor: Scalars['String']['output'];
  node: Assignment;
};

export type NudgeAboutAssignmentUpdateConnectionInput = {
  node?: InputMaybe<AssignmentUpdateInput>;
};

export type NudgeAboutAssignmentUpdateFieldInput = {
  connect?: InputMaybe<NudgeAboutAssignmentConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgeAboutAssignmentConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgeAboutAssignmentCreateFieldInput>;
  delete?: InputMaybe<NudgeAboutAssignmentDeleteFieldInput>;
  disconnect?: InputMaybe<NudgeAboutAssignmentDisconnectFieldInput>;
  update?: InputMaybe<NudgeAboutAssignmentUpdateConnectionInput>;
  where?: InputMaybe<NudgeAboutAssignmentConnectionWhere>;
};

export type NudgeAboutCourseAggregateInput = {
  AND?: InputMaybe<Array<NudgeAboutCourseAggregateInput>>;
  NOT?: InputMaybe<NudgeAboutCourseAggregateInput>;
  OR?: InputMaybe<Array<NudgeAboutCourseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NudgeAboutCourseNodeAggregationWhereInput>;
};

export type NudgeAboutCourseConnectFieldInput = {
  connect?: InputMaybe<CourseConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CourseConnectWhere>;
};

export type NudgeAboutCourseConnectOrCreateFieldInput = {
  onCreate: NudgeAboutCourseConnectOrCreateFieldInputOnCreate;
  where: CourseConnectOrCreateWhere;
};

export type NudgeAboutCourseConnectOrCreateFieldInputOnCreate = {
  node: CourseOnCreateInput;
};

export type NudgeAboutCourseConnection = {
  __typename?: 'NudgeAboutCourseConnection';
  edges: Array<NudgeAboutCourseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NudgeAboutCourseConnectionSort = {
  node?: InputMaybe<CourseSort>;
};

export type NudgeAboutCourseConnectionWhere = {
  AND?: InputMaybe<Array<NudgeAboutCourseConnectionWhere>>;
  NOT?: InputMaybe<NudgeAboutCourseConnectionWhere>;
  OR?: InputMaybe<Array<NudgeAboutCourseConnectionWhere>>;
  node?: InputMaybe<CourseWhere>;
};

export type NudgeAboutCourseCreateFieldInput = {
  node: CourseCreateInput;
};

export type NudgeAboutCourseDeleteFieldInput = {
  delete?: InputMaybe<CourseDeleteInput>;
  where?: InputMaybe<NudgeAboutCourseConnectionWhere>;
};

export type NudgeAboutCourseDisconnectFieldInput = {
  disconnect?: InputMaybe<CourseDisconnectInput>;
  where?: InputMaybe<NudgeAboutCourseConnectionWhere>;
};

export type NudgeAboutCourseFieldInput = {
  connect?: InputMaybe<NudgeAboutCourseConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgeAboutCourseConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgeAboutCourseCreateFieldInput>;
};

export type NudgeAboutCourseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NudgeAboutCourseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NudgeAboutCourseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NudgeAboutCourseNodeAggregationWhereInput>>;
  account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  cost_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDateEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  enrollment_term_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  label_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningStandards_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthInWeeks_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  root_account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_import_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  startDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  storage_quota_mb_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NudgeAboutCourseRelationship = {
  __typename?: 'NudgeAboutCourseRelationship';
  cursor: Scalars['String']['output'];
  node: Course;
};

export type NudgeAboutCourseUpdateConnectionInput = {
  node?: InputMaybe<CourseUpdateInput>;
};

export type NudgeAboutCourseUpdateFieldInput = {
  connect?: InputMaybe<NudgeAboutCourseConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgeAboutCourseConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgeAboutCourseCreateFieldInput>;
  delete?: InputMaybe<NudgeAboutCourseDeleteFieldInput>;
  disconnect?: InputMaybe<NudgeAboutCourseDisconnectFieldInput>;
  update?: InputMaybe<NudgeAboutCourseUpdateConnectionInput>;
  where?: InputMaybe<NudgeAboutCourseConnectionWhere>;
};

export type NudgeAboutExternalAnnouncementAggregateInput = {
  AND?: InputMaybe<Array<NudgeAboutExternalAnnouncementAggregateInput>>;
  NOT?: InputMaybe<NudgeAboutExternalAnnouncementAggregateInput>;
  OR?: InputMaybe<Array<NudgeAboutExternalAnnouncementAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NudgeAboutExternalAnnouncementNodeAggregationWhereInput>;
};

export type NudgeAboutExternalAnnouncementConnectFieldInput = {
  connect?: InputMaybe<ExternalAnnouncementConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalAnnouncementConnectWhere>;
};

export type NudgeAboutExternalAnnouncementConnectOrCreateFieldInput = {
  onCreate: NudgeAboutExternalAnnouncementConnectOrCreateFieldInputOnCreate;
  where: ExternalAnnouncementConnectOrCreateWhere;
};

export type NudgeAboutExternalAnnouncementConnectOrCreateFieldInputOnCreate = {
  node: ExternalAnnouncementOnCreateInput;
};

export type NudgeAboutExternalAnnouncementConnection = {
  __typename?: 'NudgeAboutExternalAnnouncementConnection';
  edges: Array<NudgeAboutExternalAnnouncementRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NudgeAboutExternalAnnouncementConnectionSort = {
  node?: InputMaybe<ExternalAnnouncementSort>;
};

export type NudgeAboutExternalAnnouncementConnectionWhere = {
  AND?: InputMaybe<Array<NudgeAboutExternalAnnouncementConnectionWhere>>;
  NOT?: InputMaybe<NudgeAboutExternalAnnouncementConnectionWhere>;
  OR?: InputMaybe<Array<NudgeAboutExternalAnnouncementConnectionWhere>>;
  node?: InputMaybe<ExternalAnnouncementWhere>;
};

export type NudgeAboutExternalAnnouncementCreateFieldInput = {
  node: ExternalAnnouncementCreateInput;
};

export type NudgeAboutExternalAnnouncementDeleteFieldInput = {
  delete?: InputMaybe<ExternalAnnouncementDeleteInput>;
  where?: InputMaybe<NudgeAboutExternalAnnouncementConnectionWhere>;
};

export type NudgeAboutExternalAnnouncementDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalAnnouncementDisconnectInput>;
  where?: InputMaybe<NudgeAboutExternalAnnouncementConnectionWhere>;
};

export type NudgeAboutExternalAnnouncementFieldInput = {
  connect?: InputMaybe<NudgeAboutExternalAnnouncementConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgeAboutExternalAnnouncementConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgeAboutExternalAnnouncementCreateFieldInput>;
};

export type NudgeAboutExternalAnnouncementNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NudgeAboutExternalAnnouncementNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NudgeAboutExternalAnnouncementNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NudgeAboutExternalAnnouncementNodeAggregationWhereInput>>;
  bodyHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  bodyHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bodyHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bodyText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  bodyText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  bodyText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  bodyText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  bodyText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  bodyText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bodyText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bodyText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bodyText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bodyText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bodyText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  postedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  postedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  providerAnnouncementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerAnnouncementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerAnnouncementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerAnnouncementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerAnnouncementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerAnnouncementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerAnnouncementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NudgeAboutExternalAnnouncementRelationship = {
  __typename?: 'NudgeAboutExternalAnnouncementRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalAnnouncement;
};

export type NudgeAboutExternalAnnouncementUpdateConnectionInput = {
  node?: InputMaybe<ExternalAnnouncementUpdateInput>;
};

export type NudgeAboutExternalAnnouncementUpdateFieldInput = {
  connect?: InputMaybe<NudgeAboutExternalAnnouncementConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgeAboutExternalAnnouncementConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgeAboutExternalAnnouncementCreateFieldInput>;
  delete?: InputMaybe<NudgeAboutExternalAnnouncementDeleteFieldInput>;
  disconnect?: InputMaybe<NudgeAboutExternalAnnouncementDisconnectFieldInput>;
  update?: InputMaybe<NudgeAboutExternalAnnouncementUpdateConnectionInput>;
  where?: InputMaybe<NudgeAboutExternalAnnouncementConnectionWhere>;
};

export type NudgeAboutExternalAssignmentAggregateInput = {
  AND?: InputMaybe<Array<NudgeAboutExternalAssignmentAggregateInput>>;
  NOT?: InputMaybe<NudgeAboutExternalAssignmentAggregateInput>;
  OR?: InputMaybe<Array<NudgeAboutExternalAssignmentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NudgeAboutExternalAssignmentNodeAggregationWhereInput>;
};

export type NudgeAboutExternalAssignmentConnectFieldInput = {
  connect?: InputMaybe<ExternalAssignmentConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalAssignmentConnectWhere>;
};

export type NudgeAboutExternalAssignmentConnectOrCreateFieldInput = {
  onCreate: NudgeAboutExternalAssignmentConnectOrCreateFieldInputOnCreate;
  where: ExternalAssignmentConnectOrCreateWhere;
};

export type NudgeAboutExternalAssignmentConnectOrCreateFieldInputOnCreate = {
  node: ExternalAssignmentOnCreateInput;
};

export type NudgeAboutExternalAssignmentConnection = {
  __typename?: 'NudgeAboutExternalAssignmentConnection';
  edges: Array<NudgeAboutExternalAssignmentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NudgeAboutExternalAssignmentConnectionSort = {
  node?: InputMaybe<ExternalAssignmentSort>;
};

export type NudgeAboutExternalAssignmentConnectionWhere = {
  AND?: InputMaybe<Array<NudgeAboutExternalAssignmentConnectionWhere>>;
  NOT?: InputMaybe<NudgeAboutExternalAssignmentConnectionWhere>;
  OR?: InputMaybe<Array<NudgeAboutExternalAssignmentConnectionWhere>>;
  node?: InputMaybe<ExternalAssignmentWhere>;
};

export type NudgeAboutExternalAssignmentCreateFieldInput = {
  node: ExternalAssignmentCreateInput;
};

export type NudgeAboutExternalAssignmentDeleteFieldInput = {
  delete?: InputMaybe<ExternalAssignmentDeleteInput>;
  where?: InputMaybe<NudgeAboutExternalAssignmentConnectionWhere>;
};

export type NudgeAboutExternalAssignmentDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalAssignmentDisconnectInput>;
  where?: InputMaybe<NudgeAboutExternalAssignmentConnectionWhere>;
};

export type NudgeAboutExternalAssignmentFieldInput = {
  connect?: InputMaybe<NudgeAboutExternalAssignmentConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgeAboutExternalAssignmentConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgeAboutExternalAssignmentCreateFieldInput>;
};

export type NudgeAboutExternalAssignmentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NudgeAboutExternalAssignmentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NudgeAboutExternalAssignmentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NudgeAboutExternalAssignmentNodeAggregationWhereInput>>;
  availableFrom_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  descriptionHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradingType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gradingType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gradingType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gradingType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gradingType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gradingType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gradingType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gradingType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gradingType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gradingType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gradingType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gradingType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gradingType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gradingType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gradingType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pointsPossible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerAssignmentId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerAssignmentId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerAssignmentId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerAssignmentId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerAssignmentId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerAssignmentId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NudgeAboutExternalAssignmentRelationship = {
  __typename?: 'NudgeAboutExternalAssignmentRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalAssignment;
};

export type NudgeAboutExternalAssignmentUpdateConnectionInput = {
  node?: InputMaybe<ExternalAssignmentUpdateInput>;
};

export type NudgeAboutExternalAssignmentUpdateFieldInput = {
  connect?: InputMaybe<NudgeAboutExternalAssignmentConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgeAboutExternalAssignmentConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgeAboutExternalAssignmentCreateFieldInput>;
  delete?: InputMaybe<NudgeAboutExternalAssignmentDeleteFieldInput>;
  disconnect?: InputMaybe<NudgeAboutExternalAssignmentDisconnectFieldInput>;
  update?: InputMaybe<NudgeAboutExternalAssignmentUpdateConnectionInput>;
  where?: InputMaybe<NudgeAboutExternalAssignmentConnectionWhere>;
};

export type NudgeAboutExternalDiscussionBoardAggregateInput = {
  AND?: InputMaybe<Array<NudgeAboutExternalDiscussionBoardAggregateInput>>;
  NOT?: InputMaybe<NudgeAboutExternalDiscussionBoardAggregateInput>;
  OR?: InputMaybe<Array<NudgeAboutExternalDiscussionBoardAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NudgeAboutExternalDiscussionBoardNodeAggregationWhereInput>;
};

export type NudgeAboutExternalDiscussionBoardConnectFieldInput = {
  connect?: InputMaybe<ExternalDiscussionBoardConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalDiscussionBoardConnectWhere>;
};

export type NudgeAboutExternalDiscussionBoardConnectOrCreateFieldInput = {
  onCreate: NudgeAboutExternalDiscussionBoardConnectOrCreateFieldInputOnCreate;
  where: ExternalDiscussionBoardConnectOrCreateWhere;
};

export type NudgeAboutExternalDiscussionBoardConnectOrCreateFieldInputOnCreate = {
  node: ExternalDiscussionBoardOnCreateInput;
};

export type NudgeAboutExternalDiscussionBoardConnection = {
  __typename?: 'NudgeAboutExternalDiscussionBoardConnection';
  edges: Array<NudgeAboutExternalDiscussionBoardRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NudgeAboutExternalDiscussionBoardConnectionSort = {
  node?: InputMaybe<ExternalDiscussionBoardSort>;
};

export type NudgeAboutExternalDiscussionBoardConnectionWhere = {
  AND?: InputMaybe<Array<NudgeAboutExternalDiscussionBoardConnectionWhere>>;
  NOT?: InputMaybe<NudgeAboutExternalDiscussionBoardConnectionWhere>;
  OR?: InputMaybe<Array<NudgeAboutExternalDiscussionBoardConnectionWhere>>;
  node?: InputMaybe<ExternalDiscussionBoardWhere>;
};

export type NudgeAboutExternalDiscussionBoardCreateFieldInput = {
  node: ExternalDiscussionBoardCreateInput;
};

export type NudgeAboutExternalDiscussionBoardDeleteFieldInput = {
  delete?: InputMaybe<ExternalDiscussionBoardDeleteInput>;
  where?: InputMaybe<NudgeAboutExternalDiscussionBoardConnectionWhere>;
};

export type NudgeAboutExternalDiscussionBoardDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalDiscussionBoardDisconnectInput>;
  where?: InputMaybe<NudgeAboutExternalDiscussionBoardConnectionWhere>;
};

export type NudgeAboutExternalDiscussionBoardFieldInput = {
  connect?: InputMaybe<NudgeAboutExternalDiscussionBoardConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgeAboutExternalDiscussionBoardConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgeAboutExternalDiscussionBoardCreateFieldInput>;
};

export type NudgeAboutExternalDiscussionBoardNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NudgeAboutExternalDiscussionBoardNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NudgeAboutExternalDiscussionBoardNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NudgeAboutExternalDiscussionBoardNodeAggregationWhereInput>>;
  availableFrom_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  messageHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  messageHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  messageHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  messageHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  messageHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  messageHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  messageHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  messageText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  messageText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  messageText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  messageText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  messageText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  messageText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  messageText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  messageText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  messageText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  messageText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  messageText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  messageText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  messageText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  messageText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  messageText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pointsPossible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerDiscussionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerDiscussionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerDiscussionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerDiscussionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerDiscussionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerDiscussionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NudgeAboutExternalDiscussionBoardRelationship = {
  __typename?: 'NudgeAboutExternalDiscussionBoardRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalDiscussionBoard;
};

export type NudgeAboutExternalDiscussionBoardUpdateConnectionInput = {
  node?: InputMaybe<ExternalDiscussionBoardUpdateInput>;
};

export type NudgeAboutExternalDiscussionBoardUpdateFieldInput = {
  connect?: InputMaybe<NudgeAboutExternalDiscussionBoardConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgeAboutExternalDiscussionBoardConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgeAboutExternalDiscussionBoardCreateFieldInput>;
  delete?: InputMaybe<NudgeAboutExternalDiscussionBoardDeleteFieldInput>;
  disconnect?: InputMaybe<NudgeAboutExternalDiscussionBoardDisconnectFieldInput>;
  update?: InputMaybe<NudgeAboutExternalDiscussionBoardUpdateConnectionInput>;
  where?: InputMaybe<NudgeAboutExternalDiscussionBoardConnectionWhere>;
};

export type NudgeAboutExternalQuizAggregateInput = {
  AND?: InputMaybe<Array<NudgeAboutExternalQuizAggregateInput>>;
  NOT?: InputMaybe<NudgeAboutExternalQuizAggregateInput>;
  OR?: InputMaybe<Array<NudgeAboutExternalQuizAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NudgeAboutExternalQuizNodeAggregationWhereInput>;
};

export type NudgeAboutExternalQuizConnectFieldInput = {
  connect?: InputMaybe<ExternalQuizConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalQuizConnectWhere>;
};

export type NudgeAboutExternalQuizConnectOrCreateFieldInput = {
  onCreate: NudgeAboutExternalQuizConnectOrCreateFieldInputOnCreate;
  where: ExternalQuizConnectOrCreateWhere;
};

export type NudgeAboutExternalQuizConnectOrCreateFieldInputOnCreate = {
  node: ExternalQuizOnCreateInput;
};

export type NudgeAboutExternalQuizConnection = {
  __typename?: 'NudgeAboutExternalQuizConnection';
  edges: Array<NudgeAboutExternalQuizRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NudgeAboutExternalQuizConnectionSort = {
  node?: InputMaybe<ExternalQuizSort>;
};

export type NudgeAboutExternalQuizConnectionWhere = {
  AND?: InputMaybe<Array<NudgeAboutExternalQuizConnectionWhere>>;
  NOT?: InputMaybe<NudgeAboutExternalQuizConnectionWhere>;
  OR?: InputMaybe<Array<NudgeAboutExternalQuizConnectionWhere>>;
  node?: InputMaybe<ExternalQuizWhere>;
};

export type NudgeAboutExternalQuizCreateFieldInput = {
  node: ExternalQuizCreateInput;
};

export type NudgeAboutExternalQuizDeleteFieldInput = {
  delete?: InputMaybe<ExternalQuizDeleteInput>;
  where?: InputMaybe<NudgeAboutExternalQuizConnectionWhere>;
};

export type NudgeAboutExternalQuizDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalQuizDisconnectInput>;
  where?: InputMaybe<NudgeAboutExternalQuizConnectionWhere>;
};

export type NudgeAboutExternalQuizFieldInput = {
  connect?: InputMaybe<NudgeAboutExternalQuizConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgeAboutExternalQuizConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgeAboutExternalQuizCreateFieldInput>;
};

export type NudgeAboutExternalQuizNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NudgeAboutExternalQuizNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NudgeAboutExternalQuizNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NudgeAboutExternalQuizNodeAggregationWhereInput>>;
  attemptsAllowed_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  attemptsAllowed_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  attemptsAllowed_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  attemptsAllowed_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  attemptsAllowed_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  attemptsAllowed_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  attemptsAllowed_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  availableFrom_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableFrom_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  availableUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  descriptionHtml_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionHtml_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionHtml_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  descriptionText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  descriptionText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pointsPossible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsPossible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerApiUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerApiUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerCourseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerCourseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  providerQuizId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  providerQuizId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  providerQuizId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  providerQuizId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  providerQuizId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  providerQuizId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceUpdatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sourceUpdatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  timeLimitMinutes_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeLimitMinutes_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeLimitMinutes_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimitMinutes_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeLimitMinutes_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimitMinutes_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimitMinutes_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NudgeAboutExternalQuizRelationship = {
  __typename?: 'NudgeAboutExternalQuizRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalQuiz;
};

export type NudgeAboutExternalQuizUpdateConnectionInput = {
  node?: InputMaybe<ExternalQuizUpdateInput>;
};

export type NudgeAboutExternalQuizUpdateFieldInput = {
  connect?: InputMaybe<NudgeAboutExternalQuizConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgeAboutExternalQuizConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgeAboutExternalQuizCreateFieldInput>;
  delete?: InputMaybe<NudgeAboutExternalQuizDeleteFieldInput>;
  disconnect?: InputMaybe<NudgeAboutExternalQuizDisconnectFieldInput>;
  update?: InputMaybe<NudgeAboutExternalQuizUpdateConnectionInput>;
  where?: InputMaybe<NudgeAboutExternalQuizConnectionWhere>;
};

export type NudgeAboutModuleAggregateInput = {
  AND?: InputMaybe<Array<NudgeAboutModuleAggregateInput>>;
  NOT?: InputMaybe<NudgeAboutModuleAggregateInput>;
  OR?: InputMaybe<Array<NudgeAboutModuleAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NudgeAboutModuleNodeAggregationWhereInput>;
};

export type NudgeAboutModuleConnectFieldInput = {
  connect?: InputMaybe<ModuleConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ModuleConnectWhere>;
};

export type NudgeAboutModuleConnectOrCreateFieldInput = {
  onCreate: NudgeAboutModuleConnectOrCreateFieldInputOnCreate;
  where: ModuleConnectOrCreateWhere;
};

export type NudgeAboutModuleConnectOrCreateFieldInputOnCreate = {
  node: ModuleOnCreateInput;
};

export type NudgeAboutModuleConnection = {
  __typename?: 'NudgeAboutModuleConnection';
  edges: Array<NudgeAboutModuleRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NudgeAboutModuleConnectionSort = {
  node?: InputMaybe<ModuleSort>;
};

export type NudgeAboutModuleConnectionWhere = {
  AND?: InputMaybe<Array<NudgeAboutModuleConnectionWhere>>;
  NOT?: InputMaybe<NudgeAboutModuleConnectionWhere>;
  OR?: InputMaybe<Array<NudgeAboutModuleConnectionWhere>>;
  node?: InputMaybe<ModuleWhere>;
};

export type NudgeAboutModuleCreateFieldInput = {
  node: ModuleCreateInput;
};

export type NudgeAboutModuleDeleteFieldInput = {
  delete?: InputMaybe<ModuleDeleteInput>;
  where?: InputMaybe<NudgeAboutModuleConnectionWhere>;
};

export type NudgeAboutModuleDisconnectFieldInput = {
  disconnect?: InputMaybe<ModuleDisconnectInput>;
  where?: InputMaybe<NudgeAboutModuleConnectionWhere>;
};

export type NudgeAboutModuleFieldInput = {
  connect?: InputMaybe<NudgeAboutModuleConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgeAboutModuleConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgeAboutModuleCreateFieldInput>;
};

export type NudgeAboutModuleNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NudgeAboutModuleNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NudgeAboutModuleNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NudgeAboutModuleNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  module_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  module_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NudgeAboutModuleRelationship = {
  __typename?: 'NudgeAboutModuleRelationship';
  cursor: Scalars['String']['output'];
  node: Module;
};

export type NudgeAboutModuleUpdateConnectionInput = {
  node?: InputMaybe<ModuleUpdateInput>;
};

export type NudgeAboutModuleUpdateFieldInput = {
  connect?: InputMaybe<NudgeAboutModuleConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgeAboutModuleConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgeAboutModuleCreateFieldInput>;
  delete?: InputMaybe<NudgeAboutModuleDeleteFieldInput>;
  disconnect?: InputMaybe<NudgeAboutModuleDisconnectFieldInput>;
  update?: InputMaybe<NudgeAboutModuleUpdateConnectionInput>;
  where?: InputMaybe<NudgeAboutModuleConnectionWhere>;
};

export type NudgeAboutProjectAggregateInput = {
  AND?: InputMaybe<Array<NudgeAboutProjectAggregateInput>>;
  NOT?: InputMaybe<NudgeAboutProjectAggregateInput>;
  OR?: InputMaybe<Array<NudgeAboutProjectAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NudgeAboutProjectNodeAggregationWhereInput>;
};

export type NudgeAboutProjectConnectFieldInput = {
  connect?: InputMaybe<ProjectConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ProjectConnectWhere>;
};

export type NudgeAboutProjectConnectOrCreateFieldInput = {
  onCreate: NudgeAboutProjectConnectOrCreateFieldInputOnCreate;
  where: ProjectConnectOrCreateWhere;
};

export type NudgeAboutProjectConnectOrCreateFieldInputOnCreate = {
  node: ProjectOnCreateInput;
};

export type NudgeAboutProjectConnection = {
  __typename?: 'NudgeAboutProjectConnection';
  edges: Array<NudgeAboutProjectRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NudgeAboutProjectConnectionSort = {
  node?: InputMaybe<ProjectSort>;
};

export type NudgeAboutProjectConnectionWhere = {
  AND?: InputMaybe<Array<NudgeAboutProjectConnectionWhere>>;
  NOT?: InputMaybe<NudgeAboutProjectConnectionWhere>;
  OR?: InputMaybe<Array<NudgeAboutProjectConnectionWhere>>;
  node?: InputMaybe<ProjectWhere>;
};

export type NudgeAboutProjectCreateFieldInput = {
  node: ProjectCreateInput;
};

export type NudgeAboutProjectDeleteFieldInput = {
  delete?: InputMaybe<ProjectDeleteInput>;
  where?: InputMaybe<NudgeAboutProjectConnectionWhere>;
};

export type NudgeAboutProjectDisconnectFieldInput = {
  disconnect?: InputMaybe<ProjectDisconnectInput>;
  where?: InputMaybe<NudgeAboutProjectConnectionWhere>;
};

export type NudgeAboutProjectFieldInput = {
  connect?: InputMaybe<NudgeAboutProjectConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgeAboutProjectConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgeAboutProjectCreateFieldInput>;
};

export type NudgeAboutProjectNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NudgeAboutProjectNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NudgeAboutProjectNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NudgeAboutProjectNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scopeDocument_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scopeDocument_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scopeDocument_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scopeDocument_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scopeDocument_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scopeDocument_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeDocument_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeDocument_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeDocument_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeDocument_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopeDocument_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeDocument_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeDocument_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeDocument_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeDocument_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NudgeAboutProjectRelationship = {
  __typename?: 'NudgeAboutProjectRelationship';
  cursor: Scalars['String']['output'];
  node: Project;
};

export type NudgeAboutProjectRequirementAggregateInput = {
  AND?: InputMaybe<Array<NudgeAboutProjectRequirementAggregateInput>>;
  NOT?: InputMaybe<NudgeAboutProjectRequirementAggregateInput>;
  OR?: InputMaybe<Array<NudgeAboutProjectRequirementAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NudgeAboutProjectRequirementNodeAggregationWhereInput>;
};

export type NudgeAboutProjectRequirementConnectFieldInput = {
  connect?: InputMaybe<ProjectRequirementConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ProjectRequirementConnectWhere>;
};

export type NudgeAboutProjectRequirementConnectOrCreateFieldInput = {
  onCreate: NudgeAboutProjectRequirementConnectOrCreateFieldInputOnCreate;
  where: ProjectRequirementConnectOrCreateWhere;
};

export type NudgeAboutProjectRequirementConnectOrCreateFieldInputOnCreate = {
  node: ProjectRequirementOnCreateInput;
};

export type NudgeAboutProjectRequirementConnection = {
  __typename?: 'NudgeAboutProjectRequirementConnection';
  edges: Array<NudgeAboutProjectRequirementRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NudgeAboutProjectRequirementConnectionSort = {
  node?: InputMaybe<ProjectRequirementSort>;
};

export type NudgeAboutProjectRequirementConnectionWhere = {
  AND?: InputMaybe<Array<NudgeAboutProjectRequirementConnectionWhere>>;
  NOT?: InputMaybe<NudgeAboutProjectRequirementConnectionWhere>;
  OR?: InputMaybe<Array<NudgeAboutProjectRequirementConnectionWhere>>;
  node?: InputMaybe<ProjectRequirementWhere>;
};

export type NudgeAboutProjectRequirementCreateFieldInput = {
  node: ProjectRequirementCreateInput;
};

export type NudgeAboutProjectRequirementDeleteFieldInput = {
  delete?: InputMaybe<ProjectRequirementDeleteInput>;
  where?: InputMaybe<NudgeAboutProjectRequirementConnectionWhere>;
};

export type NudgeAboutProjectRequirementDisconnectFieldInput = {
  disconnect?: InputMaybe<ProjectRequirementDisconnectInput>;
  where?: InputMaybe<NudgeAboutProjectRequirementConnectionWhere>;
};

export type NudgeAboutProjectRequirementFieldInput = {
  connect?: InputMaybe<NudgeAboutProjectRequirementConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgeAboutProjectRequirementConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgeAboutProjectRequirementCreateFieldInput>;
};

export type NudgeAboutProjectRequirementNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NudgeAboutProjectRequirementNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NudgeAboutProjectRequirementNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NudgeAboutProjectRequirementNodeAggregationWhereInput>>;
  aiRationale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiRationale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aiRationale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiRationale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aiRationale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aiRationale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aiRationale_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aiRationale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aiRationale_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aiRationale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aiRationale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aiRationale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aiRationale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aiRationale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aiRationale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  category_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  category_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  category_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  category_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  category_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  category_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  category_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  category_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  category_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  category_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  category_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  category_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  category_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  category_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  category_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  completedDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  estimatedHours_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  estimatedHours_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  estimatedHours_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  estimatedHours_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  estimatedHours_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  estimatedHours_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NudgeAboutProjectRequirementRelationship = {
  __typename?: 'NudgeAboutProjectRequirementRelationship';
  cursor: Scalars['String']['output'];
  node: ProjectRequirement;
};

export type NudgeAboutProjectRequirementUpdateConnectionInput = {
  node?: InputMaybe<ProjectRequirementUpdateInput>;
};

export type NudgeAboutProjectRequirementUpdateFieldInput = {
  connect?: InputMaybe<NudgeAboutProjectRequirementConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgeAboutProjectRequirementConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgeAboutProjectRequirementCreateFieldInput>;
  delete?: InputMaybe<NudgeAboutProjectRequirementDeleteFieldInput>;
  disconnect?: InputMaybe<NudgeAboutProjectRequirementDisconnectFieldInput>;
  update?: InputMaybe<NudgeAboutProjectRequirementUpdateConnectionInput>;
  where?: InputMaybe<NudgeAboutProjectRequirementConnectionWhere>;
};

export type NudgeAboutProjectUpdateConnectionInput = {
  node?: InputMaybe<ProjectUpdateInput>;
};

export type NudgeAboutProjectUpdateFieldInput = {
  connect?: InputMaybe<NudgeAboutProjectConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgeAboutProjectConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgeAboutProjectCreateFieldInput>;
  delete?: InputMaybe<NudgeAboutProjectDeleteFieldInput>;
  disconnect?: InputMaybe<NudgeAboutProjectDisconnectFieldInput>;
  update?: InputMaybe<NudgeAboutProjectUpdateConnectionInput>;
  where?: InputMaybe<NudgeAboutProjectConnectionWhere>;
};

export type NudgeAboutUserAggregateInput = {
  AND?: InputMaybe<Array<NudgeAboutUserAggregateInput>>;
  NOT?: InputMaybe<NudgeAboutUserAggregateInput>;
  OR?: InputMaybe<Array<NudgeAboutUserAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NudgeAboutUserNodeAggregationWhereInput>;
};

export type NudgeAboutUserConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type NudgeAboutUserConnectOrCreateFieldInput = {
  onCreate: NudgeAboutUserConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type NudgeAboutUserConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type NudgeAboutUserConnection = {
  __typename?: 'NudgeAboutUserConnection';
  edges: Array<NudgeAboutUserRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NudgeAboutUserConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type NudgeAboutUserConnectionWhere = {
  AND?: InputMaybe<Array<NudgeAboutUserConnectionWhere>>;
  NOT?: InputMaybe<NudgeAboutUserConnectionWhere>;
  OR?: InputMaybe<Array<NudgeAboutUserConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type NudgeAboutUserCreateFieldInput = {
  node: UserCreateInput;
};

export type NudgeAboutUserDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<NudgeAboutUserConnectionWhere>;
};

export type NudgeAboutUserDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<NudgeAboutUserConnectionWhere>;
};

export type NudgeAboutUserFieldInput = {
  connect?: InputMaybe<NudgeAboutUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgeAboutUserConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgeAboutUserCreateFieldInput>;
};

export type NudgeAboutUserNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NudgeAboutUserNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NudgeAboutUserNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NudgeAboutUserNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NudgeAboutUserRelationship = {
  __typename?: 'NudgeAboutUserRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type NudgeAboutUserUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type NudgeAboutUserUpdateFieldInput = {
  connect?: InputMaybe<NudgeAboutUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgeAboutUserConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgeAboutUserCreateFieldInput>;
  delete?: InputMaybe<NudgeAboutUserDeleteFieldInput>;
  disconnect?: InputMaybe<NudgeAboutUserDisconnectFieldInput>;
  update?: InputMaybe<NudgeAboutUserUpdateConnectionInput>;
  where?: InputMaybe<NudgeAboutUserConnectionWhere>;
};

export type NudgeAnnouncementAboutAnnouncementAggregationSelection = {
  __typename?: 'NudgeAnnouncementAboutAnnouncementAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<NudgeAnnouncementAboutAnnouncementNodeAggregateSelection>;
};

export type NudgeAnnouncementAboutAnnouncementNodeAggregateSelection = {
  __typename?: 'NudgeAnnouncementAboutAnnouncementNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  expirationDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  message: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type NudgeAssessmentAboutAssessmentAggregationSelection = {
  __typename?: 'NudgeAssessmentAboutAssessmentAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<NudgeAssessmentAboutAssessmentNodeAggregateSelection>;
};

export type NudgeAssessmentAboutAssessmentNodeAggregateSelection = {
  __typename?: 'NudgeAssessmentAboutAssessmentNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  numberOfQuestions: IntAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  timeLimit: IntAggregateSelection;
};

export type NudgeAssignmentAboutAssignmentAggregationSelection = {
  __typename?: 'NudgeAssignmentAboutAssignmentAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<NudgeAssignmentAboutAssignmentNodeAggregateSelection>;
};

export type NudgeAssignmentAboutAssignmentNodeAggregateSelection = {
  __typename?: 'NudgeAssignmentAboutAssignmentNodeAggregateSelection';
  _empty: StringAggregateSelection;
  allowed_attempts: FloatAggregateSelection;
  assignee_mode: StringAggregateSelection;
  assignment_group_id: FloatAggregateSelection;
  assignment_name: StringAggregateSelection;
  body: StringAggregateSelection;
  category_id: StringAggregateSelection;
  course_id: FloatAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  description: StringAggregateSelection;
  description_plaintext: StringAggregateSelection;
  discussion_topic_assignment_id: FloatAggregateSelection;
  discussion_topic_author_anonymous_id: StringAggregateSelection;
  discussion_topic_author_avatar_image_url: StringAggregateSelection;
  discussion_topic_author_display_name: StringAggregateSelection;
  discussion_topic_author_html_url: StringAggregateSelection;
  discussion_topic_author_id: FloatAggregateSelection;
  discussion_topic_created_at: StringAggregateSelection;
  discussion_topic_discussion_subentry_count: FloatAggregateSelection;
  discussion_topic_discussion_type: StringAggregateSelection;
  discussion_topic_html_url: StringAggregateSelection;
  discussion_topic_id: FloatAggregateSelection;
  discussion_topic_last_reply_at: StringAggregateSelection;
  discussion_topic_message: StringAggregateSelection;
  discussion_topic_posted_at: StringAggregateSelection;
  discussion_topic_read_state: StringAggregateSelection;
  discussion_topic_title: StringAggregateSelection;
  discussion_topic_unread_count: FloatAggregateSelection;
  discussion_topic_url: StringAggregateSelection;
  discussion_topic_user_name: StringAggregateSelection;
  display_date: StringAggregateSelection;
  due_at: StringAggregateSelection;
  due_date: DateTimeAggregateSelection;
  end_date: StringAggregateSelection;
  external_tool_tag_attributes_content_id: FloatAggregateSelection;
  external_tool_tag_attributes_content_type: StringAggregateSelection;
  external_tool_tag_attributes_external_data: StringAggregateSelection;
  external_tool_tag_attributes_resource_link_id: StringAggregateSelection;
  external_tool_tag_attributes_url: StringAggregateSelection;
  grade_points: FloatAggregateSelection;
  grader_count: FloatAggregateSelection;
  grading_type: StringAggregateSelection;
  html: StringAggregateSelection;
  html_url: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  lti_context_id: StringAggregateSelection;
  max_attempts: FloatAggregateSelection;
  max_name_length: FloatAggregateSelection;
  name: StringAggregateSelection;
  needs_grading_count: FloatAggregateSelection;
  objectives: StringAggregateSelection;
  points_possible: FloatAggregateSelection;
  position: FloatAggregateSelection;
  resource_metadata: StringAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  secure_params: StringAggregateSelection;
  session_id: StringAggregateSelection;
  start_date: StringAggregateSelection;
  state: StringAggregateSelection;
  submissions_download_url: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_at: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  url: StringAggregateSelection;
  videoUrl: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export enum NudgeChannel {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export enum NudgeConfigScope {
  Global = 'GLOBAL',
  Tenant = 'TENANT'
}

export type NudgeConnectInput = {
  aboutAiTutor?: InputMaybe<NudgeAboutAiTutorConnectFieldInput>;
  aboutAnnouncement?: InputMaybe<NudgeAboutAnnouncementConnectFieldInput>;
  aboutAssessment?: InputMaybe<NudgeAboutAssessmentConnectFieldInput>;
  aboutAssignment?: InputMaybe<NudgeAboutAssignmentConnectFieldInput>;
  aboutCourse?: InputMaybe<NudgeAboutCourseConnectFieldInput>;
  aboutExternalAnnouncement?: InputMaybe<NudgeAboutExternalAnnouncementConnectFieldInput>;
  aboutExternalAssignment?: InputMaybe<NudgeAboutExternalAssignmentConnectFieldInput>;
  aboutExternalDiscussionBoard?: InputMaybe<NudgeAboutExternalDiscussionBoardConnectFieldInput>;
  aboutExternalQuiz?: InputMaybe<NudgeAboutExternalQuizConnectFieldInput>;
  aboutModule?: InputMaybe<NudgeAboutModuleConnectFieldInput>;
  aboutProject?: InputMaybe<NudgeAboutProjectConnectFieldInput>;
  aboutProjectRequirement?: InputMaybe<NudgeAboutProjectRequirementConnectFieldInput>;
  aboutUser?: InputMaybe<NudgeAboutUserConnectFieldInput>;
  events?: InputMaybe<Array<NudgeEventsConnectFieldInput>>;
  user?: InputMaybe<NudgeUserConnectFieldInput>;
};

export type NudgeConnectOrCreateWhere = {
  node: NudgeUniqueWhere;
};

export type NudgeConnectWhere = {
  node: NudgeWhere;
};

export type NudgeCourseAboutCourseAggregationSelection = {
  __typename?: 'NudgeCourseAboutCourseAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<NudgeCourseAboutCourseNodeAggregateSelection>;
};

export type NudgeCourseAboutCourseNodeAggregateSelection = {
  __typename?: 'NudgeCourseAboutCourseNodeAggregateSelection';
  account_id: FloatAggregateSelection;
  calendar_ics: StringAggregateSelection;
  cost: FloatAggregateSelection;
  courseId: StringAggregateSelection;
  course_code: StringAggregateSelection;
  course_id: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  default_view: StringAggregateSelection;
  description: StringAggregateSelection;
  dueDateEndDate: DateTimeAggregateSelection;
  dueDateStartDate: DateTimeAggregateSelection;
  endDate: DateTimeAggregateSelection;
  end_at: StringAggregateSelection;
  enrollment_term_id: FloatAggregateSelection;
  grading_standard_id: FloatAggregateSelection;
  id: IdAggregateSelection;
  integration_id: StringAggregateSelection;
  label: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  learningStandards: StringAggregateSelection;
  lengthInWeeks: FloatAggregateSelection;
  license: StringAggregateSelection;
  lti_id: StringAggregateSelection;
  name: StringAggregateSelection;
  original_name: StringAggregateSelection;
  root_account_id: FloatAggregateSelection;
  sis_course_id: StringAggregateSelection;
  sis_import_id: FloatAggregateSelection;
  startDate: DateTimeAggregateSelection;
  start_at: StringAggregateSelection;
  state: StringAggregateSelection;
  storage_quota_mb: FloatAggregateSelection;
  stripePriceId: StringAggregateSelection;
  stripeProductId: StringAggregateSelection;
  targetAudience: StringAggregateSelection;
  thumbnail: StringAggregateSelection;
  time_zone: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  uuid: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export type NudgeCreateInput = {
  aboutAiTutor?: InputMaybe<NudgeAboutAiTutorFieldInput>;
  aboutAnnouncement?: InputMaybe<NudgeAboutAnnouncementFieldInput>;
  aboutAssessment?: InputMaybe<NudgeAboutAssessmentFieldInput>;
  aboutAssignment?: InputMaybe<NudgeAboutAssignmentFieldInput>;
  aboutCourse?: InputMaybe<NudgeAboutCourseFieldInput>;
  aboutExternalAnnouncement?: InputMaybe<NudgeAboutExternalAnnouncementFieldInput>;
  aboutExternalAssignment?: InputMaybe<NudgeAboutExternalAssignmentFieldInput>;
  aboutExternalDiscussionBoard?: InputMaybe<NudgeAboutExternalDiscussionBoardFieldInput>;
  aboutExternalQuiz?: InputMaybe<NudgeAboutExternalQuizFieldInput>;
  aboutModule?: InputMaybe<NudgeAboutModuleFieldInput>;
  aboutProject?: InputMaybe<NudgeAboutProjectFieldInput>;
  aboutProjectRequirement?: InputMaybe<NudgeAboutProjectRequirementFieldInput>;
  aboutUser?: InputMaybe<NudgeAboutUserFieldInput>;
  created: Scalars['DateTime']['input'];
  events?: InputMaybe<NudgeEventsFieldInput>;
  idempotencyKey: Scalars['String']['input'];
  lastModified: Scalars['DateTime']['input'];
  nudgeType: NudgeType;
  parentType: NudgeParentType;
  priorityScore: Scalars['Float']['input'];
  scheduledFor?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil?: InputMaybe<Scalars['DateTime']['input']>;
  state: NudgeState;
  taskCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  triggerData: Scalars['JSON']['input'];
  triggerEventType?: InputMaybe<NudgeTriggerEventType>;
  user?: InputMaybe<NudgeUserFieldInput>;
};

export type NudgeDeleteInput = {
  aboutAiTutor?: InputMaybe<NudgeAboutAiTutorDeleteFieldInput>;
  aboutAnnouncement?: InputMaybe<NudgeAboutAnnouncementDeleteFieldInput>;
  aboutAssessment?: InputMaybe<NudgeAboutAssessmentDeleteFieldInput>;
  aboutAssignment?: InputMaybe<NudgeAboutAssignmentDeleteFieldInput>;
  aboutCourse?: InputMaybe<NudgeAboutCourseDeleteFieldInput>;
  aboutExternalAnnouncement?: InputMaybe<NudgeAboutExternalAnnouncementDeleteFieldInput>;
  aboutExternalAssignment?: InputMaybe<NudgeAboutExternalAssignmentDeleteFieldInput>;
  aboutExternalDiscussionBoard?: InputMaybe<NudgeAboutExternalDiscussionBoardDeleteFieldInput>;
  aboutExternalQuiz?: InputMaybe<NudgeAboutExternalQuizDeleteFieldInput>;
  aboutModule?: InputMaybe<NudgeAboutModuleDeleteFieldInput>;
  aboutProject?: InputMaybe<NudgeAboutProjectDeleteFieldInput>;
  aboutProjectRequirement?: InputMaybe<NudgeAboutProjectRequirementDeleteFieldInput>;
  aboutUser?: InputMaybe<NudgeAboutUserDeleteFieldInput>;
  events?: InputMaybe<Array<NudgeEventsDeleteFieldInput>>;
  user?: InputMaybe<NudgeUserDeleteFieldInput>;
};

export type NudgeDisconnectInput = {
  aboutAiTutor?: InputMaybe<NudgeAboutAiTutorDisconnectFieldInput>;
  aboutAnnouncement?: InputMaybe<NudgeAboutAnnouncementDisconnectFieldInput>;
  aboutAssessment?: InputMaybe<NudgeAboutAssessmentDisconnectFieldInput>;
  aboutAssignment?: InputMaybe<NudgeAboutAssignmentDisconnectFieldInput>;
  aboutCourse?: InputMaybe<NudgeAboutCourseDisconnectFieldInput>;
  aboutExternalAnnouncement?: InputMaybe<NudgeAboutExternalAnnouncementDisconnectFieldInput>;
  aboutExternalAssignment?: InputMaybe<NudgeAboutExternalAssignmentDisconnectFieldInput>;
  aboutExternalDiscussionBoard?: InputMaybe<NudgeAboutExternalDiscussionBoardDisconnectFieldInput>;
  aboutExternalQuiz?: InputMaybe<NudgeAboutExternalQuizDisconnectFieldInput>;
  aboutModule?: InputMaybe<NudgeAboutModuleDisconnectFieldInput>;
  aboutProject?: InputMaybe<NudgeAboutProjectDisconnectFieldInput>;
  aboutProjectRequirement?: InputMaybe<NudgeAboutProjectRequirementDisconnectFieldInput>;
  aboutUser?: InputMaybe<NudgeAboutUserDisconnectFieldInput>;
  events?: InputMaybe<Array<NudgeEventsDisconnectFieldInput>>;
  user?: InputMaybe<NudgeUserDisconnectFieldInput>;
};

export type NudgeEvent = {
  __typename?: 'NudgeEvent';
  channel: NudgeChannel;
  clickedAt?: Maybe<Scalars['DateTime']['output']>;
  eventSequence: Scalars['Int']['output'];
  firstMessageAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  messageSnapshot: Scalars['JSON']['output'];
  nudge: Nudge;
  nudgeAggregate?: Maybe<NudgeEventNudgeNudgeAggregationSelection>;
  nudgeConnection: NudgeEventNudgeConnection;
  sentAt: Scalars['DateTime']['output'];
};


export type NudgeEventNudgeArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<NudgeOptions>;
  where?: InputMaybe<NudgeWhere>;
};


export type NudgeEventNudgeAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NudgeWhere>;
};


export type NudgeEventNudgeConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NudgeEventNudgeConnectionSort>>;
  where?: InputMaybe<NudgeEventNudgeConnectionWhere>;
};

export type NudgeEventConnectInput = {
  nudge?: InputMaybe<NudgeEventNudgeConnectFieldInput>;
};

export type NudgeEventConnectOrCreateWhere = {
  node: NudgeEventUniqueWhere;
};

export type NudgeEventConnectWhere = {
  node: NudgeEventWhere;
};

export type NudgeEventCreateInput = {
  channel: NudgeChannel;
  clickedAt?: InputMaybe<Scalars['DateTime']['input']>;
  eventSequence: Scalars['Int']['input'];
  firstMessageAt?: InputMaybe<Scalars['DateTime']['input']>;
  messageSnapshot: Scalars['JSON']['input'];
  nudge?: InputMaybe<NudgeEventNudgeFieldInput>;
  sentAt: Scalars['DateTime']['input'];
};

export type NudgeEventDeleteInput = {
  nudge?: InputMaybe<NudgeEventNudgeDeleteFieldInput>;
};

export type NudgeEventDisconnectInput = {
  nudge?: InputMaybe<NudgeEventNudgeDisconnectFieldInput>;
};

export type NudgeEventNudgeAggregateInput = {
  AND?: InputMaybe<Array<NudgeEventNudgeAggregateInput>>;
  NOT?: InputMaybe<NudgeEventNudgeAggregateInput>;
  OR?: InputMaybe<Array<NudgeEventNudgeAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NudgeEventNudgeNodeAggregationWhereInput>;
};

export type NudgeEventNudgeConnectFieldInput = {
  connect?: InputMaybe<NudgeConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<NudgeConnectWhere>;
};

export type NudgeEventNudgeConnectOrCreateFieldInput = {
  onCreate: NudgeEventNudgeConnectOrCreateFieldInputOnCreate;
  where: NudgeConnectOrCreateWhere;
};

export type NudgeEventNudgeConnectOrCreateFieldInputOnCreate = {
  node: NudgeOnCreateInput;
};

export type NudgeEventNudgeConnection = {
  __typename?: 'NudgeEventNudgeConnection';
  edges: Array<NudgeEventNudgeRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NudgeEventNudgeConnectionSort = {
  node?: InputMaybe<NudgeSort>;
};

export type NudgeEventNudgeConnectionWhere = {
  AND?: InputMaybe<Array<NudgeEventNudgeConnectionWhere>>;
  NOT?: InputMaybe<NudgeEventNudgeConnectionWhere>;
  OR?: InputMaybe<Array<NudgeEventNudgeConnectionWhere>>;
  node?: InputMaybe<NudgeWhere>;
};

export type NudgeEventNudgeCreateFieldInput = {
  node: NudgeCreateInput;
};

export type NudgeEventNudgeDeleteFieldInput = {
  delete?: InputMaybe<NudgeDeleteInput>;
  where?: InputMaybe<NudgeEventNudgeConnectionWhere>;
};

export type NudgeEventNudgeDisconnectFieldInput = {
  disconnect?: InputMaybe<NudgeDisconnectInput>;
  where?: InputMaybe<NudgeEventNudgeConnectionWhere>;
};

export type NudgeEventNudgeFieldInput = {
  connect?: InputMaybe<NudgeEventNudgeConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgeEventNudgeConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgeEventNudgeCreateFieldInput>;
};

export type NudgeEventNudgeNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NudgeEventNudgeNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NudgeEventNudgeNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NudgeEventNudgeNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  idempotencyKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  priorityScore_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  scheduledFor_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NudgeEventNudgeNudgeAggregationSelection = {
  __typename?: 'NudgeEventNudgeNudgeAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<NudgeEventNudgeNudgeNodeAggregateSelection>;
};

export type NudgeEventNudgeNudgeNodeAggregateSelection = {
  __typename?: 'NudgeEventNudgeNudgeNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  idempotencyKey: StringAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  priorityScore: FloatAggregateSelection;
  scheduledFor: DateTimeAggregateSelection;
  snoozedUntil: DateTimeAggregateSelection;
  taskCompletedAt: DateTimeAggregateSelection;
};

export type NudgeEventNudgeRelationship = {
  __typename?: 'NudgeEventNudgeRelationship';
  cursor: Scalars['String']['output'];
  node: Nudge;
};

export type NudgeEventNudgeUpdateConnectionInput = {
  node?: InputMaybe<NudgeUpdateInput>;
};

export type NudgeEventNudgeUpdateFieldInput = {
  connect?: InputMaybe<NudgeEventNudgeConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgeEventNudgeConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgeEventNudgeCreateFieldInput>;
  delete?: InputMaybe<NudgeEventNudgeDeleteFieldInput>;
  disconnect?: InputMaybe<NudgeEventNudgeDisconnectFieldInput>;
  update?: InputMaybe<NudgeEventNudgeUpdateConnectionInput>;
  where?: InputMaybe<NudgeEventNudgeConnectionWhere>;
};

export type NudgeEventOnCreateInput = {
  channel: NudgeChannel;
  clickedAt?: InputMaybe<Scalars['DateTime']['input']>;
  eventSequence: Scalars['Int']['input'];
  firstMessageAt?: InputMaybe<Scalars['DateTime']['input']>;
  messageSnapshot: Scalars['JSON']['input'];
  sentAt: Scalars['DateTime']['input'];
};

export type NudgeEventOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more NudgeEventSort objects to sort NudgeEvents by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<NudgeEventSort>>;
};

/** Fields to sort NudgeEvents by. The order in which sorts are applied is not guaranteed when specifying many fields in one NudgeEventSort object. */
export type NudgeEventSort = {
  channel?: InputMaybe<SortDirection>;
  clickedAt?: InputMaybe<SortDirection>;
  eventSequence?: InputMaybe<SortDirection>;
  firstMessageAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  messageSnapshot?: InputMaybe<SortDirection>;
  sentAt?: InputMaybe<SortDirection>;
};

export type NudgeEventUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type NudgeEventUpdateInput = {
  channel?: InputMaybe<NudgeChannel>;
  clickedAt?: InputMaybe<Scalars['DateTime']['input']>;
  eventSequence?: InputMaybe<Scalars['Int']['input']>;
  eventSequence_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  eventSequence_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  firstMessageAt?: InputMaybe<Scalars['DateTime']['input']>;
  messageSnapshot?: InputMaybe<Scalars['JSON']['input']>;
  nudge?: InputMaybe<NudgeEventNudgeUpdateFieldInput>;
  sentAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NudgeEventWhere = {
  AND?: InputMaybe<Array<NudgeEventWhere>>;
  NOT?: InputMaybe<NudgeEventWhere>;
  OR?: InputMaybe<Array<NudgeEventWhere>>;
  channel?: InputMaybe<NudgeChannel>;
  channel_IN?: InputMaybe<Array<NudgeChannel>>;
  clickedAt?: InputMaybe<Scalars['DateTime']['input']>;
  clickedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  clickedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  clickedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  clickedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  clickedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  eventSequence?: InputMaybe<Scalars['Int']['input']>;
  eventSequence_GT?: InputMaybe<Scalars['Int']['input']>;
  eventSequence_GTE?: InputMaybe<Scalars['Int']['input']>;
  eventSequence_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  eventSequence_LT?: InputMaybe<Scalars['Int']['input']>;
  eventSequence_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstMessageAt?: InputMaybe<Scalars['DateTime']['input']>;
  firstMessageAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstMessageAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstMessageAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  firstMessageAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstMessageAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  messageSnapshot?: InputMaybe<Scalars['JSON']['input']>;
  messageSnapshot_IN?: InputMaybe<Array<Scalars['JSON']['input']>>;
  nudge?: InputMaybe<NudgeWhere>;
  nudgeAggregate?: InputMaybe<NudgeEventNudgeAggregateInput>;
  nudgeConnection?: InputMaybe<NudgeEventNudgeConnectionWhere>;
  nudgeConnection_NOT?: InputMaybe<NudgeEventNudgeConnectionWhere>;
  nudge_NOT?: InputMaybe<NudgeWhere>;
  sentAt?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  sentAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NudgeEventsAggregateInput = {
  AND?: InputMaybe<Array<NudgeEventsAggregateInput>>;
  NOT?: InputMaybe<NudgeEventsAggregateInput>;
  OR?: InputMaybe<Array<NudgeEventsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NudgeEventsNodeAggregationWhereInput>;
};

export type NudgeEventsConnectFieldInput = {
  connect?: InputMaybe<Array<NudgeEventConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<NudgeEventConnectWhere>;
};

export type NudgeEventsConnectOrCreateFieldInput = {
  onCreate: NudgeEventsConnectOrCreateFieldInputOnCreate;
  where: NudgeEventConnectOrCreateWhere;
};

export type NudgeEventsConnectOrCreateFieldInputOnCreate = {
  node: NudgeEventOnCreateInput;
};

export type NudgeEventsConnection = {
  __typename?: 'NudgeEventsConnection';
  edges: Array<NudgeEventsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NudgeEventsConnectionSort = {
  node?: InputMaybe<NudgeEventSort>;
};

export type NudgeEventsConnectionWhere = {
  AND?: InputMaybe<Array<NudgeEventsConnectionWhere>>;
  NOT?: InputMaybe<NudgeEventsConnectionWhere>;
  OR?: InputMaybe<Array<NudgeEventsConnectionWhere>>;
  node?: InputMaybe<NudgeEventWhere>;
};

export type NudgeEventsCreateFieldInput = {
  node: NudgeEventCreateInput;
};

export type NudgeEventsDeleteFieldInput = {
  delete?: InputMaybe<NudgeEventDeleteInput>;
  where?: InputMaybe<NudgeEventsConnectionWhere>;
};

export type NudgeEventsDisconnectFieldInput = {
  disconnect?: InputMaybe<NudgeEventDisconnectInput>;
  where?: InputMaybe<NudgeEventsConnectionWhere>;
};

export type NudgeEventsFieldInput = {
  connect?: InputMaybe<Array<NudgeEventsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<NudgeEventsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<NudgeEventsCreateFieldInput>>;
};

export type NudgeEventsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NudgeEventsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NudgeEventsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NudgeEventsNodeAggregationWhereInput>>;
  clickedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  clickedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  clickedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  clickedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  clickedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  clickedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  clickedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  clickedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  clickedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  clickedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  eventSequence_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  eventSequence_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  eventSequence_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  eventSequence_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  eventSequence_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  eventSequence_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eventSequence_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  eventSequence_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  eventSequence_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  eventSequence_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  eventSequence_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eventSequence_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  eventSequence_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  eventSequence_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  eventSequence_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  eventSequence_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eventSequence_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  eventSequence_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  eventSequence_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  eventSequence_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstMessageAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstMessageAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstMessageAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstMessageAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstMessageAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstMessageAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstMessageAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstMessageAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstMessageAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstMessageAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NudgeEventsRelationship = {
  __typename?: 'NudgeEventsRelationship';
  cursor: Scalars['String']['output'];
  node: NudgeEvent;
};

export type NudgeEventsUpdateConnectionInput = {
  node?: InputMaybe<NudgeEventUpdateInput>;
};

export type NudgeEventsUpdateFieldInput = {
  connect?: InputMaybe<Array<NudgeEventsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<NudgeEventsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<NudgeEventsCreateFieldInput>>;
  delete?: InputMaybe<Array<NudgeEventsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<NudgeEventsDisconnectFieldInput>>;
  update?: InputMaybe<NudgeEventsUpdateConnectionInput>;
  where?: InputMaybe<NudgeEventsConnectionWhere>;
};

export type NudgeExternalAnnouncementAboutExternalAnnouncementAggregationSelection = {
  __typename?: 'NudgeExternalAnnouncementAboutExternalAnnouncementAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<NudgeExternalAnnouncementAboutExternalAnnouncementNodeAggregateSelection>;
};

export type NudgeExternalAnnouncementAboutExternalAnnouncementNodeAggregateSelection = {
  __typename?: 'NudgeExternalAnnouncementAboutExternalAnnouncementNodeAggregateSelection';
  bodyHtml: StringAggregateSelection;
  bodyText: StringAggregateSelection;
  id: IdAggregateSelection;
  postedAt: DateTimeAggregateSelection;
  providerAnnouncementId: StringAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  title: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type NudgeExternalAssignmentAboutExternalAssignmentAggregationSelection = {
  __typename?: 'NudgeExternalAssignmentAboutExternalAssignmentAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<NudgeExternalAssignmentAboutExternalAssignmentNodeAggregateSelection>;
};

export type NudgeExternalAssignmentAboutExternalAssignmentNodeAggregateSelection = {
  __typename?: 'NudgeExternalAssignmentAboutExternalAssignmentNodeAggregateSelection';
  availableFrom: DateTimeAggregateSelection;
  availableUntil: DateTimeAggregateSelection;
  descriptionHtml: StringAggregateSelection;
  descriptionText: StringAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  gradingType: StringAggregateSelection;
  id: IdAggregateSelection;
  pointsPossible: FloatAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerAssignmentId: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  title: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type NudgeExternalDiscussionBoardAboutExternalDiscussionBoardAggregationSelection = {
  __typename?: 'NudgeExternalDiscussionBoardAboutExternalDiscussionBoardAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<NudgeExternalDiscussionBoardAboutExternalDiscussionBoardNodeAggregateSelection>;
};

export type NudgeExternalDiscussionBoardAboutExternalDiscussionBoardNodeAggregateSelection = {
  __typename?: 'NudgeExternalDiscussionBoardAboutExternalDiscussionBoardNodeAggregateSelection';
  availableFrom: DateTimeAggregateSelection;
  availableUntil: DateTimeAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  messageHtml: StringAggregateSelection;
  messageText: StringAggregateSelection;
  pointsPossible: FloatAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerDiscussionId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  title: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type NudgeExternalQuizAboutExternalQuizAggregationSelection = {
  __typename?: 'NudgeExternalQuizAboutExternalQuizAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<NudgeExternalQuizAboutExternalQuizNodeAggregateSelection>;
};

export type NudgeExternalQuizAboutExternalQuizNodeAggregateSelection = {
  __typename?: 'NudgeExternalQuizAboutExternalQuizNodeAggregateSelection';
  attemptsAllowed: IntAggregateSelection;
  availableFrom: DateTimeAggregateSelection;
  availableUntil: DateTimeAggregateSelection;
  descriptionHtml: StringAggregateSelection;
  descriptionText: StringAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  pointsPossible: FloatAggregateSelection;
  providerApiUrl: StringAggregateSelection;
  providerCourseId: StringAggregateSelection;
  providerKey: StringAggregateSelection;
  providerQuizId: StringAggregateSelection;
  sourceUpdatedAt: DateTimeAggregateSelection;
  syncedAt: DateTimeAggregateSelection;
  timeLimitMinutes: IntAggregateSelection;
  title: StringAggregateSelection;
  url: StringAggregateSelection;
};

export enum NudgeFrequency {
  Daily = 'DAILY',
  EveryOtherDay = 'EVERY_OTHER_DAY',
  Never = 'NEVER',
  Weekly = 'WEEKLY'
}

export type NudgeModuleAboutModuleAggregationSelection = {
  __typename?: 'NudgeModuleAboutModuleAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<NudgeModuleAboutModuleNodeAggregateSelection>;
};

export type NudgeModuleAboutModuleNodeAggregateSelection = {
  __typename?: 'NudgeModuleAboutModuleNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  module_name: StringAggregateSelection;
  thumbnail: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type NudgeNudgeEventEventsAggregationSelection = {
  __typename?: 'NudgeNudgeEventEventsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<NudgeNudgeEventEventsNodeAggregateSelection>;
};

export type NudgeNudgeEventEventsNodeAggregateSelection = {
  __typename?: 'NudgeNudgeEventEventsNodeAggregateSelection';
  clickedAt: DateTimeAggregateSelection;
  eventSequence: IntAggregateSelection;
  firstMessageAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  sentAt: DateTimeAggregateSelection;
};

export type NudgeOnCreateInput = {
  created: Scalars['DateTime']['input'];
  idempotencyKey: Scalars['String']['input'];
  lastModified: Scalars['DateTime']['input'];
  nudgeType: NudgeType;
  parentType: NudgeParentType;
  priorityScore: Scalars['Float']['input'];
  scheduledFor?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil?: InputMaybe<Scalars['DateTime']['input']>;
  state: NudgeState;
  taskCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  triggerData: Scalars['JSON']['input'];
  triggerEventType?: InputMaybe<NudgeTriggerEventType>;
};

export type NudgeOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more NudgeSort objects to sort Nudges by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<NudgeSort>>;
};

export enum NudgeParentType {
  AiTutor = 'ai_tutor',
  Announcement = 'announcement',
  Assessment = 'assessment',
  Assignment = 'assignment',
  Course = 'course',
  ExternalAnnouncement = 'external_announcement',
  ExternalAssignment = 'external_assignment',
  ExternalDiscussion = 'external_discussion',
  Module = 'module',
  Project = 'project',
  ProjectRequirement = 'project_requirement',
  Quiz = 'quiz',
  User = 'user'
}

export type NudgePreferences = {
  __typename?: 'NudgePreferences';
  created: Scalars['DateTime']['output'];
  emailEnabled: Scalars['Boolean']['output'];
  frequency: NudgeFrequency;
  id: Scalars['ID']['output'];
  lastModified: Scalars['DateTime']['output'];
  maxEmailPerDay: Scalars['Int']['output'];
  maxSmsPerDay: Scalars['Int']['output'];
  preferredSendTime: Scalars['String']['output'];
  smsEnabled: Scalars['Boolean']['output'];
  snoozeAllUntil?: Maybe<Scalars['DateTime']['output']>;
  timezone: Scalars['String']['output'];
  user: User;
  userAggregate?: Maybe<NudgePreferencesUserUserAggregationSelection>;
  userConnection: NudgePreferencesUserConnection;
  userId: Scalars['ID']['output'];
};


export type NudgePreferencesUserArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type NudgePreferencesUserAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type NudgePreferencesUserConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NudgePreferencesUserConnectionSort>>;
  where?: InputMaybe<NudgePreferencesUserConnectionWhere>;
};

export type NudgePreferencesConnectInput = {
  user?: InputMaybe<NudgePreferencesUserConnectFieldInput>;
};

export type NudgePreferencesConnectOrCreateWhere = {
  node: NudgePreferencesUniqueWhere;
};

export type NudgePreferencesConnectWhere = {
  node: NudgePreferencesWhere;
};

export type NudgePreferencesCreateInput = {
  created: Scalars['DateTime']['input'];
  emailEnabled?: Scalars['Boolean']['input'];
  frequency?: NudgeFrequency;
  lastModified: Scalars['DateTime']['input'];
  maxEmailPerDay?: Scalars['Int']['input'];
  maxSmsPerDay?: Scalars['Int']['input'];
  preferredSendTime?: Scalars['String']['input'];
  smsEnabled?: Scalars['Boolean']['input'];
  snoozeAllUntil?: InputMaybe<Scalars['DateTime']['input']>;
  timezone?: Scalars['String']['input'];
  user?: InputMaybe<NudgePreferencesUserFieldInput>;
  userId: Scalars['ID']['input'];
};

export type NudgePreferencesDeleteInput = {
  user?: InputMaybe<NudgePreferencesUserDeleteFieldInput>;
};

export type NudgePreferencesDisconnectInput = {
  user?: InputMaybe<NudgePreferencesUserDisconnectFieldInput>;
};

export type NudgePreferencesOnCreateInput = {
  created: Scalars['DateTime']['input'];
  emailEnabled?: Scalars['Boolean']['input'];
  frequency?: NudgeFrequency;
  lastModified: Scalars['DateTime']['input'];
  maxEmailPerDay?: Scalars['Int']['input'];
  maxSmsPerDay?: Scalars['Int']['input'];
  preferredSendTime?: Scalars['String']['input'];
  smsEnabled?: Scalars['Boolean']['input'];
  snoozeAllUntil?: InputMaybe<Scalars['DateTime']['input']>;
  timezone?: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type NudgePreferencesOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more NudgePreferencesSort objects to sort NudgePreferences by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<NudgePreferencesSort>>;
};

export type NudgePreferencesResponse = {
  __typename?: 'NudgePreferencesResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<NudgePreferences>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Fields to sort NudgePreferences by. The order in which sorts are applied is not guaranteed when specifying many fields in one NudgePreferencesSort object. */
export type NudgePreferencesSort = {
  created?: InputMaybe<SortDirection>;
  emailEnabled?: InputMaybe<SortDirection>;
  frequency?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastModified?: InputMaybe<SortDirection>;
  maxEmailPerDay?: InputMaybe<SortDirection>;
  maxSmsPerDay?: InputMaybe<SortDirection>;
  preferredSendTime?: InputMaybe<SortDirection>;
  smsEnabled?: InputMaybe<SortDirection>;
  snoozeAllUntil?: InputMaybe<SortDirection>;
  timezone?: InputMaybe<SortDirection>;
  userId?: InputMaybe<SortDirection>;
};

export type NudgePreferencesUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type NudgePreferencesUpdateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  emailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  frequency?: InputMaybe<NudgeFrequency>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  maxEmailPerDay?: InputMaybe<Scalars['Int']['input']>;
  maxEmailPerDay_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  maxEmailPerDay_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  maxSmsPerDay?: InputMaybe<Scalars['Int']['input']>;
  maxSmsPerDay_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  maxSmsPerDay_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  preferredSendTime?: InputMaybe<Scalars['String']['input']>;
  smsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  snoozeAllUntil?: InputMaybe<Scalars['DateTime']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<NudgePreferencesUserUpdateFieldInput>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type NudgePreferencesUserAggregateInput = {
  AND?: InputMaybe<Array<NudgePreferencesUserAggregateInput>>;
  NOT?: InputMaybe<NudgePreferencesUserAggregateInput>;
  OR?: InputMaybe<Array<NudgePreferencesUserAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NudgePreferencesUserNodeAggregationWhereInput>;
};

export type NudgePreferencesUserConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type NudgePreferencesUserConnectOrCreateFieldInput = {
  onCreate: NudgePreferencesUserConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type NudgePreferencesUserConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type NudgePreferencesUserConnection = {
  __typename?: 'NudgePreferencesUserConnection';
  edges: Array<NudgePreferencesUserRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NudgePreferencesUserConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type NudgePreferencesUserConnectionWhere = {
  AND?: InputMaybe<Array<NudgePreferencesUserConnectionWhere>>;
  NOT?: InputMaybe<NudgePreferencesUserConnectionWhere>;
  OR?: InputMaybe<Array<NudgePreferencesUserConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type NudgePreferencesUserCreateFieldInput = {
  node: UserCreateInput;
};

export type NudgePreferencesUserDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<NudgePreferencesUserConnectionWhere>;
};

export type NudgePreferencesUserDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<NudgePreferencesUserConnectionWhere>;
};

export type NudgePreferencesUserFieldInput = {
  connect?: InputMaybe<NudgePreferencesUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgePreferencesUserConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgePreferencesUserCreateFieldInput>;
};

export type NudgePreferencesUserNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NudgePreferencesUserNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NudgePreferencesUserNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NudgePreferencesUserNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NudgePreferencesUserRelationship = {
  __typename?: 'NudgePreferencesUserRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type NudgePreferencesUserUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type NudgePreferencesUserUpdateFieldInput = {
  connect?: InputMaybe<NudgePreferencesUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgePreferencesUserConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgePreferencesUserCreateFieldInput>;
  delete?: InputMaybe<NudgePreferencesUserDeleteFieldInput>;
  disconnect?: InputMaybe<NudgePreferencesUserDisconnectFieldInput>;
  update?: InputMaybe<NudgePreferencesUserUpdateConnectionInput>;
  where?: InputMaybe<NudgePreferencesUserConnectionWhere>;
};

export type NudgePreferencesUserUserAggregationSelection = {
  __typename?: 'NudgePreferencesUserUserAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<NudgePreferencesUserUserNodeAggregateSelection>;
};

export type NudgePreferencesUserUserNodeAggregateSelection = {
  __typename?: 'NudgePreferencesUserUserNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type NudgePreferencesWhere = {
  AND?: InputMaybe<Array<NudgePreferencesWhere>>;
  NOT?: InputMaybe<NudgePreferencesWhere>;
  OR?: InputMaybe<Array<NudgePreferencesWhere>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  emailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  frequency?: InputMaybe<NudgeFrequency>;
  frequency_IN?: InputMaybe<Array<NudgeFrequency>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lastModified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  maxEmailPerDay?: InputMaybe<Scalars['Int']['input']>;
  maxEmailPerDay_GT?: InputMaybe<Scalars['Int']['input']>;
  maxEmailPerDay_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxEmailPerDay_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxEmailPerDay_LT?: InputMaybe<Scalars['Int']['input']>;
  maxEmailPerDay_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxSmsPerDay?: InputMaybe<Scalars['Int']['input']>;
  maxSmsPerDay_GT?: InputMaybe<Scalars['Int']['input']>;
  maxSmsPerDay_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxSmsPerDay_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxSmsPerDay_LT?: InputMaybe<Scalars['Int']['input']>;
  maxSmsPerDay_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredSendTime?: InputMaybe<Scalars['String']['input']>;
  preferredSendTime_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  preferredSendTime_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  preferredSendTime_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredSendTime_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  smsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  snoozeAllUntil?: InputMaybe<Scalars['DateTime']['input']>;
  snoozeAllUntil_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozeAllUntil_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozeAllUntil_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  snoozeAllUntil_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozeAllUntil_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  timezone_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  timezone_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  timezone_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  timezone_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserWhere>;
  userAggregate?: InputMaybe<NudgePreferencesUserAggregateInput>;
  userConnection?: InputMaybe<NudgePreferencesUserConnectionWhere>;
  userConnection_NOT?: InputMaybe<NudgePreferencesUserConnectionWhere>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  userId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  userId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  user_NOT?: InputMaybe<UserWhere>;
};

export type NudgeProjectAboutProjectAggregationSelection = {
  __typename?: 'NudgeProjectAboutProjectAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<NudgeProjectAboutProjectNodeAggregateSelection>;
};

export type NudgeProjectAboutProjectNodeAggregateSelection = {
  __typename?: 'NudgeProjectAboutProjectNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  moduleId: IdAggregateSelection;
  name: StringAggregateSelection;
  order: IntAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  scopeDocument: StringAggregateSelection;
};

export type NudgeProjectRequirementAboutProjectRequirementAggregationSelection = {
  __typename?: 'NudgeProjectRequirementAboutProjectRequirementAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<NudgeProjectRequirementAboutProjectRequirementNodeAggregateSelection>;
};

export type NudgeProjectRequirementAboutProjectRequirementNodeAggregateSelection = {
  __typename?: 'NudgeProjectRequirementAboutProjectRequirementNodeAggregateSelection';
  aiRationale: StringAggregateSelection;
  category: StringAggregateSelection;
  completedDate: DateTimeAggregateSelection;
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  estimatedHours: IntAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  order: IntAggregateSelection;
  title: StringAggregateSelection;
};

/** Fields to sort Nudges by. The order in which sorts are applied is not guaranteed when specifying many fields in one NudgeSort object. */
export type NudgeSort = {
  created?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  idempotencyKey?: InputMaybe<SortDirection>;
  lastModified?: InputMaybe<SortDirection>;
  nudgeType?: InputMaybe<SortDirection>;
  parentType?: InputMaybe<SortDirection>;
  priorityScore?: InputMaybe<SortDirection>;
  scheduledFor?: InputMaybe<SortDirection>;
  snoozedUntil?: InputMaybe<SortDirection>;
  state?: InputMaybe<SortDirection>;
  taskCompletedAt?: InputMaybe<SortDirection>;
  triggerData?: InputMaybe<SortDirection>;
  triggerEventType?: InputMaybe<SortDirection>;
};

export enum NudgeState {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Dismissed = 'DISMISSED',
  Potential = 'POTENTIAL',
  Ready = 'READY',
  Scheduled = 'SCHEDULED',
  Snoozed = 'SNOOZED'
}

export enum NudgeTriggerEventType {
  NudgeActivityAvailabilityChanged = 'NudgeActivityAvailabilityChanged',
  NudgeActivityCompleted = 'NudgeActivityCompleted',
  NudgeActivityDueDateChanged = 'NudgeActivityDueDateChanged',
  NudgeGradePosted = 'NudgeGradePosted'
}

export enum NudgeType {
  AssignmentDueSoon = 'ASSIGNMENT_DUE_SOON',
  AssignmentOverdue = 'ASSIGNMENT_OVERDUE',
  CourseNotAccessed = 'COURSE_NOT_ACCESSED',
  InactiveUser = 'INACTIVE_USER',
  NewAnnouncement = 'NEW_ANNOUNCEMENT',
  NoMastery = 'NO_MASTERY',
  QuizOpen = 'QUIZ_OPEN',
  ScoreDropped = 'SCORE_DROPPED',
  SubmissionFeedbackReady = 'SUBMISSION_FEEDBACK_READY'
}

export type NudgeTypeConfig = {
  __typename?: 'NudgeTypeConfig';
  cooldownEmailHours: Scalars['Int']['output'];
  cooldownSmsHours: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  lastModified: Scalars['DateTime']['output'];
  maxInactiveDays: Scalars['Int']['output'];
  maxSendsEmail: Scalars['Int']['output'];
  maxSendsSms: Scalars['Int']['output'];
  maxWindowDays: Scalars['Int']['output'];
  nudgeType: NudgeType;
  readinessThreshold: Scalars['Float']['output'];
  scope: NudgeConfigScope;
  smsThreshold: Scalars['Float']['output'];
  supersedesToType?: Maybe<NudgeType>;
  tenant?: Maybe<Tenant>;
  tenantAggregate?: Maybe<NudgeTypeConfigTenantTenantAggregationSelection>;
  tenantConnection: NudgeTypeConfigTenantConnection;
  weightAcademicImpact: Scalars['Float']['output'];
  weightEventSequenceDecay: Scalars['Float']['output'];
  weightPriorResponse: Scalars['Float']['output'];
  weightTimeUrgency: Scalars['Float']['output'];
  weightUserEngagement: Scalars['Float']['output'];
};


export type NudgeTypeConfigTenantArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TenantOptions>;
  where?: InputMaybe<TenantWhere>;
};


export type NudgeTypeConfigTenantAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TenantWhere>;
};


export type NudgeTypeConfigTenantConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NudgeTypeConfigTenantConnectionSort>>;
  where?: InputMaybe<NudgeTypeConfigTenantConnectionWhere>;
};

export type NudgeTypeConfigConnectInput = {
  tenant?: InputMaybe<NudgeTypeConfigTenantConnectFieldInput>;
};

export type NudgeTypeConfigConnectOrCreateWhere = {
  node: NudgeTypeConfigUniqueWhere;
};

export type NudgeTypeConfigConnectWhere = {
  node: NudgeTypeConfigWhere;
};

export type NudgeTypeConfigCreateInput = {
  cooldownEmailHours: Scalars['Int']['input'];
  cooldownSmsHours: Scalars['Int']['input'];
  created: Scalars['DateTime']['input'];
  enabled: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
  lastModified: Scalars['DateTime']['input'];
  maxInactiveDays: Scalars['Int']['input'];
  maxSendsEmail: Scalars['Int']['input'];
  maxSendsSms: Scalars['Int']['input'];
  maxWindowDays: Scalars['Int']['input'];
  nudgeType: NudgeType;
  readinessThreshold: Scalars['Float']['input'];
  scope: NudgeConfigScope;
  smsThreshold: Scalars['Float']['input'];
  supersedesToType?: InputMaybe<NudgeType>;
  tenant?: InputMaybe<NudgeTypeConfigTenantFieldInput>;
  weightAcademicImpact: Scalars['Float']['input'];
  weightEventSequenceDecay: Scalars['Float']['input'];
  weightPriorResponse: Scalars['Float']['input'];
  weightTimeUrgency: Scalars['Float']['input'];
  weightUserEngagement: Scalars['Float']['input'];
};

export type NudgeTypeConfigDeleteInput = {
  tenant?: InputMaybe<NudgeTypeConfigTenantDeleteFieldInput>;
};

export type NudgeTypeConfigDisconnectInput = {
  tenant?: InputMaybe<NudgeTypeConfigTenantDisconnectFieldInput>;
};

export type NudgeTypeConfigOnCreateInput = {
  cooldownEmailHours: Scalars['Int']['input'];
  cooldownSmsHours: Scalars['Int']['input'];
  created: Scalars['DateTime']['input'];
  enabled: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
  lastModified: Scalars['DateTime']['input'];
  maxInactiveDays: Scalars['Int']['input'];
  maxSendsEmail: Scalars['Int']['input'];
  maxSendsSms: Scalars['Int']['input'];
  maxWindowDays: Scalars['Int']['input'];
  nudgeType: NudgeType;
  readinessThreshold: Scalars['Float']['input'];
  scope: NudgeConfigScope;
  smsThreshold: Scalars['Float']['input'];
  supersedesToType?: InputMaybe<NudgeType>;
  weightAcademicImpact: Scalars['Float']['input'];
  weightEventSequenceDecay: Scalars['Float']['input'];
  weightPriorResponse: Scalars['Float']['input'];
  weightTimeUrgency: Scalars['Float']['input'];
  weightUserEngagement: Scalars['Float']['input'];
};

export type NudgeTypeConfigOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more NudgeTypeConfigSort objects to sort NudgeTypeConfigs by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<NudgeTypeConfigSort>>;
};

/** Fields to sort NudgeTypeConfigs by. The order in which sorts are applied is not guaranteed when specifying many fields in one NudgeTypeConfigSort object. */
export type NudgeTypeConfigSort = {
  cooldownEmailHours?: InputMaybe<SortDirection>;
  cooldownSmsHours?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  enabled?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  key?: InputMaybe<SortDirection>;
  lastModified?: InputMaybe<SortDirection>;
  maxInactiveDays?: InputMaybe<SortDirection>;
  maxSendsEmail?: InputMaybe<SortDirection>;
  maxSendsSms?: InputMaybe<SortDirection>;
  maxWindowDays?: InputMaybe<SortDirection>;
  nudgeType?: InputMaybe<SortDirection>;
  readinessThreshold?: InputMaybe<SortDirection>;
  scope?: InputMaybe<SortDirection>;
  smsThreshold?: InputMaybe<SortDirection>;
  supersedesToType?: InputMaybe<SortDirection>;
  weightAcademicImpact?: InputMaybe<SortDirection>;
  weightEventSequenceDecay?: InputMaybe<SortDirection>;
  weightPriorResponse?: InputMaybe<SortDirection>;
  weightTimeUrgency?: InputMaybe<SortDirection>;
  weightUserEngagement?: InputMaybe<SortDirection>;
};

export type NudgeTypeConfigTenantAggregateInput = {
  AND?: InputMaybe<Array<NudgeTypeConfigTenantAggregateInput>>;
  NOT?: InputMaybe<NudgeTypeConfigTenantAggregateInput>;
  OR?: InputMaybe<Array<NudgeTypeConfigTenantAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NudgeTypeConfigTenantNodeAggregationWhereInput>;
};

export type NudgeTypeConfigTenantConnectFieldInput = {
  connect?: InputMaybe<TenantConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TenantConnectWhere>;
};

export type NudgeTypeConfigTenantConnectOrCreateFieldInput = {
  onCreate: NudgeTypeConfigTenantConnectOrCreateFieldInputOnCreate;
  where: TenantConnectOrCreateWhere;
};

export type NudgeTypeConfigTenantConnectOrCreateFieldInputOnCreate = {
  node: TenantOnCreateInput;
};

export type NudgeTypeConfigTenantConnection = {
  __typename?: 'NudgeTypeConfigTenantConnection';
  edges: Array<NudgeTypeConfigTenantRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NudgeTypeConfigTenantConnectionSort = {
  node?: InputMaybe<TenantSort>;
};

export type NudgeTypeConfigTenantConnectionWhere = {
  AND?: InputMaybe<Array<NudgeTypeConfigTenantConnectionWhere>>;
  NOT?: InputMaybe<NudgeTypeConfigTenantConnectionWhere>;
  OR?: InputMaybe<Array<NudgeTypeConfigTenantConnectionWhere>>;
  node?: InputMaybe<TenantWhere>;
};

export type NudgeTypeConfigTenantCreateFieldInput = {
  node: TenantCreateInput;
};

export type NudgeTypeConfigTenantDeleteFieldInput = {
  delete?: InputMaybe<TenantDeleteInput>;
  where?: InputMaybe<NudgeTypeConfigTenantConnectionWhere>;
};

export type NudgeTypeConfigTenantDisconnectFieldInput = {
  disconnect?: InputMaybe<TenantDisconnectInput>;
  where?: InputMaybe<NudgeTypeConfigTenantConnectionWhere>;
};

export type NudgeTypeConfigTenantFieldInput = {
  connect?: InputMaybe<NudgeTypeConfigTenantConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgeTypeConfigTenantConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgeTypeConfigTenantCreateFieldInput>;
};

export type NudgeTypeConfigTenantNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NudgeTypeConfigTenantNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NudgeTypeConfigTenantNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NudgeTypeConfigTenantNodeAggregationWhereInput>>;
  companionName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  companionName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  key_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  key_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogImage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  proLogo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NudgeTypeConfigTenantRelationship = {
  __typename?: 'NudgeTypeConfigTenantRelationship';
  cursor: Scalars['String']['output'];
  node: Tenant;
};

export type NudgeTypeConfigTenantTenantAggregationSelection = {
  __typename?: 'NudgeTypeConfigTenantTenantAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<NudgeTypeConfigTenantTenantNodeAggregateSelection>;
};

export type NudgeTypeConfigTenantTenantNodeAggregateSelection = {
  __typename?: 'NudgeTypeConfigTenantTenantNodeAggregateSelection';
  companionName: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  emailBackgroundColor: StringAggregateSelection;
  emailFooterColor: StringAggregateSelection;
  emulationStatement: StringAggregateSelection;
  externalSendGridDailyEmailTemplateId: StringAggregateSelection;
  externalSendGridFromEmail: StringAggregateSelection;
  externalSendGridFromName: StringAggregateSelection;
  externalSendGridTwilioServiceSID: StringAggregateSelection;
  favicon16Url: StringAggregateSelection;
  favicon32Url: StringAggregateSelection;
  favicon48Url: StringAggregateSelection;
  favicon180Url: StringAggregateSelection;
  favicon192Url: StringAggregateSelection;
  favicon512Url: StringAggregateSelection;
  faviconIcoUrl: StringAggregateSelection;
  financialInformationUrl: StringAggregateSelection;
  gameMenuBg: StringAggregateSelection;
  gameMenuCardBg: StringAggregateSelection;
  gameMenuProgress: StringAggregateSelection;
  gameMenuTrack: StringAggregateSelection;
  generalPrompt: StringAggregateSelection;
  helpCenterUrl: StringAggregateSelection;
  id: IdAggregateSelection;
  key: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  learningEmulationStatement: StringAggregateSelection;
  logo: StringAggregateSelection;
  ltiLaunchUrl: StringAggregateSelection;
  miniLogo: StringAggregateSelection;
  newsSearchTerms: StringAggregateSelection;
  officialTranscriptsUrl: StringAggregateSelection;
  ogDescription: StringAggregateSelection;
  ogImage: StringAggregateSelection;
  ogImageHeight: StringAggregateSelection;
  ogImageWidth: StringAggregateSelection;
  ogSiteName: StringAggregateSelection;
  ogTitle: StringAggregateSelection;
  ogType: StringAggregateSelection;
  onboardingPrompt: StringAggregateSelection;
  primaryColor: StringAggregateSelection;
  proLogo: StringAggregateSelection;
  reportProblemUrl: StringAggregateSelection;
  scheduleAdvisorCallUrl: StringAggregateSelection;
  schoolResourcesUrl: StringAggregateSelection;
  stripeSecretKey: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  stripeTrialDays: IntAggregateSelection;
  submitHelpTicketLink: StringAggregateSelection;
  tenantDomain: StringAggregateSelection;
  tenantName: StringAggregateSelection;
  termsOfServiceLink: StringAggregateSelection;
  upgradeModalBody: StringAggregateSelection;
};

export type NudgeTypeConfigTenantUpdateConnectionInput = {
  node?: InputMaybe<TenantUpdateInput>;
};

export type NudgeTypeConfigTenantUpdateFieldInput = {
  connect?: InputMaybe<NudgeTypeConfigTenantConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgeTypeConfigTenantConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgeTypeConfigTenantCreateFieldInput>;
  delete?: InputMaybe<NudgeTypeConfigTenantDeleteFieldInput>;
  disconnect?: InputMaybe<NudgeTypeConfigTenantDisconnectFieldInput>;
  update?: InputMaybe<NudgeTypeConfigTenantUpdateConnectionInput>;
  where?: InputMaybe<NudgeTypeConfigTenantConnectionWhere>;
};

export type NudgeTypeConfigUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};

export type NudgeTypeConfigUpdateInput = {
  cooldownEmailHours?: InputMaybe<Scalars['Int']['input']>;
  cooldownEmailHours_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  cooldownEmailHours_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  cooldownSmsHours?: InputMaybe<Scalars['Int']['input']>;
  cooldownSmsHours_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  cooldownSmsHours_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  maxInactiveDays?: InputMaybe<Scalars['Int']['input']>;
  maxInactiveDays_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  maxInactiveDays_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  maxSendsEmail?: InputMaybe<Scalars['Int']['input']>;
  maxSendsEmail_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  maxSendsEmail_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  maxSendsSms?: InputMaybe<Scalars['Int']['input']>;
  maxSendsSms_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  maxSendsSms_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  maxWindowDays?: InputMaybe<Scalars['Int']['input']>;
  maxWindowDays_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  maxWindowDays_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  nudgeType?: InputMaybe<NudgeType>;
  readinessThreshold?: InputMaybe<Scalars['Float']['input']>;
  readinessThreshold_ADD?: InputMaybe<Scalars['Float']['input']>;
  readinessThreshold_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  readinessThreshold_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  readinessThreshold_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  scope?: InputMaybe<NudgeConfigScope>;
  smsThreshold?: InputMaybe<Scalars['Float']['input']>;
  smsThreshold_ADD?: InputMaybe<Scalars['Float']['input']>;
  smsThreshold_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  smsThreshold_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  smsThreshold_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  supersedesToType?: InputMaybe<NudgeType>;
  tenant?: InputMaybe<NudgeTypeConfigTenantUpdateFieldInput>;
  weightAcademicImpact?: InputMaybe<Scalars['Float']['input']>;
  weightAcademicImpact_ADD?: InputMaybe<Scalars['Float']['input']>;
  weightAcademicImpact_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  weightAcademicImpact_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  weightAcademicImpact_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  weightEventSequenceDecay?: InputMaybe<Scalars['Float']['input']>;
  weightEventSequenceDecay_ADD?: InputMaybe<Scalars['Float']['input']>;
  weightEventSequenceDecay_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  weightEventSequenceDecay_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  weightEventSequenceDecay_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  weightPriorResponse?: InputMaybe<Scalars['Float']['input']>;
  weightPriorResponse_ADD?: InputMaybe<Scalars['Float']['input']>;
  weightPriorResponse_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  weightPriorResponse_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  weightPriorResponse_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  weightTimeUrgency?: InputMaybe<Scalars['Float']['input']>;
  weightTimeUrgency_ADD?: InputMaybe<Scalars['Float']['input']>;
  weightTimeUrgency_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  weightTimeUrgency_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  weightTimeUrgency_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  weightUserEngagement?: InputMaybe<Scalars['Float']['input']>;
  weightUserEngagement_ADD?: InputMaybe<Scalars['Float']['input']>;
  weightUserEngagement_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  weightUserEngagement_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  weightUserEngagement_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
};

export type NudgeTypeConfigWhere = {
  AND?: InputMaybe<Array<NudgeTypeConfigWhere>>;
  NOT?: InputMaybe<NudgeTypeConfigWhere>;
  OR?: InputMaybe<Array<NudgeTypeConfigWhere>>;
  cooldownEmailHours?: InputMaybe<Scalars['Int']['input']>;
  cooldownEmailHours_GT?: InputMaybe<Scalars['Int']['input']>;
  cooldownEmailHours_GTE?: InputMaybe<Scalars['Int']['input']>;
  cooldownEmailHours_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  cooldownEmailHours_LT?: InputMaybe<Scalars['Int']['input']>;
  cooldownEmailHours_LTE?: InputMaybe<Scalars['Int']['input']>;
  cooldownSmsHours?: InputMaybe<Scalars['Int']['input']>;
  cooldownSmsHours_GT?: InputMaybe<Scalars['Int']['input']>;
  cooldownSmsHours_GTE?: InputMaybe<Scalars['Int']['input']>;
  cooldownSmsHours_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  cooldownSmsHours_LT?: InputMaybe<Scalars['Int']['input']>;
  cooldownSmsHours_LTE?: InputMaybe<Scalars['Int']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  key_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  key_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  key_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  key_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lastModified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  maxInactiveDays?: InputMaybe<Scalars['Int']['input']>;
  maxInactiveDays_GT?: InputMaybe<Scalars['Int']['input']>;
  maxInactiveDays_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxInactiveDays_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxInactiveDays_LT?: InputMaybe<Scalars['Int']['input']>;
  maxInactiveDays_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxSendsEmail?: InputMaybe<Scalars['Int']['input']>;
  maxSendsEmail_GT?: InputMaybe<Scalars['Int']['input']>;
  maxSendsEmail_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxSendsEmail_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxSendsEmail_LT?: InputMaybe<Scalars['Int']['input']>;
  maxSendsEmail_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxSendsSms?: InputMaybe<Scalars['Int']['input']>;
  maxSendsSms_GT?: InputMaybe<Scalars['Int']['input']>;
  maxSendsSms_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxSendsSms_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxSendsSms_LT?: InputMaybe<Scalars['Int']['input']>;
  maxSendsSms_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxWindowDays?: InputMaybe<Scalars['Int']['input']>;
  maxWindowDays_GT?: InputMaybe<Scalars['Int']['input']>;
  maxWindowDays_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxWindowDays_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxWindowDays_LT?: InputMaybe<Scalars['Int']['input']>;
  maxWindowDays_LTE?: InputMaybe<Scalars['Int']['input']>;
  nudgeType?: InputMaybe<NudgeType>;
  nudgeType_IN?: InputMaybe<Array<NudgeType>>;
  readinessThreshold?: InputMaybe<Scalars['Float']['input']>;
  readinessThreshold_GT?: InputMaybe<Scalars['Float']['input']>;
  readinessThreshold_GTE?: InputMaybe<Scalars['Float']['input']>;
  readinessThreshold_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  readinessThreshold_LT?: InputMaybe<Scalars['Float']['input']>;
  readinessThreshold_LTE?: InputMaybe<Scalars['Float']['input']>;
  scope?: InputMaybe<NudgeConfigScope>;
  scope_IN?: InputMaybe<Array<NudgeConfigScope>>;
  smsThreshold?: InputMaybe<Scalars['Float']['input']>;
  smsThreshold_GT?: InputMaybe<Scalars['Float']['input']>;
  smsThreshold_GTE?: InputMaybe<Scalars['Float']['input']>;
  smsThreshold_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  smsThreshold_LT?: InputMaybe<Scalars['Float']['input']>;
  smsThreshold_LTE?: InputMaybe<Scalars['Float']['input']>;
  supersedesToType?: InputMaybe<NudgeType>;
  supersedesToType_IN?: InputMaybe<Array<InputMaybe<NudgeType>>>;
  tenant?: InputMaybe<TenantWhere>;
  tenantAggregate?: InputMaybe<NudgeTypeConfigTenantAggregateInput>;
  tenantConnection?: InputMaybe<NudgeTypeConfigTenantConnectionWhere>;
  tenantConnection_NOT?: InputMaybe<NudgeTypeConfigTenantConnectionWhere>;
  tenant_NOT?: InputMaybe<TenantWhere>;
  weightAcademicImpact?: InputMaybe<Scalars['Float']['input']>;
  weightAcademicImpact_GT?: InputMaybe<Scalars['Float']['input']>;
  weightAcademicImpact_GTE?: InputMaybe<Scalars['Float']['input']>;
  weightAcademicImpact_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  weightAcademicImpact_LT?: InputMaybe<Scalars['Float']['input']>;
  weightAcademicImpact_LTE?: InputMaybe<Scalars['Float']['input']>;
  weightEventSequenceDecay?: InputMaybe<Scalars['Float']['input']>;
  weightEventSequenceDecay_GT?: InputMaybe<Scalars['Float']['input']>;
  weightEventSequenceDecay_GTE?: InputMaybe<Scalars['Float']['input']>;
  weightEventSequenceDecay_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  weightEventSequenceDecay_LT?: InputMaybe<Scalars['Float']['input']>;
  weightEventSequenceDecay_LTE?: InputMaybe<Scalars['Float']['input']>;
  weightPriorResponse?: InputMaybe<Scalars['Float']['input']>;
  weightPriorResponse_GT?: InputMaybe<Scalars['Float']['input']>;
  weightPriorResponse_GTE?: InputMaybe<Scalars['Float']['input']>;
  weightPriorResponse_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  weightPriorResponse_LT?: InputMaybe<Scalars['Float']['input']>;
  weightPriorResponse_LTE?: InputMaybe<Scalars['Float']['input']>;
  weightTimeUrgency?: InputMaybe<Scalars['Float']['input']>;
  weightTimeUrgency_GT?: InputMaybe<Scalars['Float']['input']>;
  weightTimeUrgency_GTE?: InputMaybe<Scalars['Float']['input']>;
  weightTimeUrgency_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  weightTimeUrgency_LT?: InputMaybe<Scalars['Float']['input']>;
  weightTimeUrgency_LTE?: InputMaybe<Scalars['Float']['input']>;
  weightUserEngagement?: InputMaybe<Scalars['Float']['input']>;
  weightUserEngagement_GT?: InputMaybe<Scalars['Float']['input']>;
  weightUserEngagement_GTE?: InputMaybe<Scalars['Float']['input']>;
  weightUserEngagement_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  weightUserEngagement_LT?: InputMaybe<Scalars['Float']['input']>;
  weightUserEngagement_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type NudgeUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
};

export type NudgeUpdateInput = {
  aboutAiTutor?: InputMaybe<NudgeAboutAiTutorUpdateFieldInput>;
  aboutAnnouncement?: InputMaybe<NudgeAboutAnnouncementUpdateFieldInput>;
  aboutAssessment?: InputMaybe<NudgeAboutAssessmentUpdateFieldInput>;
  aboutAssignment?: InputMaybe<NudgeAboutAssignmentUpdateFieldInput>;
  aboutCourse?: InputMaybe<NudgeAboutCourseUpdateFieldInput>;
  aboutExternalAnnouncement?: InputMaybe<NudgeAboutExternalAnnouncementUpdateFieldInput>;
  aboutExternalAssignment?: InputMaybe<NudgeAboutExternalAssignmentUpdateFieldInput>;
  aboutExternalDiscussionBoard?: InputMaybe<NudgeAboutExternalDiscussionBoardUpdateFieldInput>;
  aboutExternalQuiz?: InputMaybe<NudgeAboutExternalQuizUpdateFieldInput>;
  aboutModule?: InputMaybe<NudgeAboutModuleUpdateFieldInput>;
  aboutProject?: InputMaybe<NudgeAboutProjectUpdateFieldInput>;
  aboutProjectRequirement?: InputMaybe<NudgeAboutProjectRequirementUpdateFieldInput>;
  aboutUser?: InputMaybe<NudgeAboutUserUpdateFieldInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  events?: InputMaybe<Array<NudgeEventsUpdateFieldInput>>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  nudgeType?: InputMaybe<NudgeType>;
  parentType?: InputMaybe<NudgeParentType>;
  priorityScore?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_ADD?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  scheduledFor?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<NudgeState>;
  taskCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  triggerData?: InputMaybe<Scalars['JSON']['input']>;
  triggerEventType?: InputMaybe<NudgeTriggerEventType>;
  user?: InputMaybe<NudgeUserUpdateFieldInput>;
};

export type NudgeUserAboutUserAggregationSelection = {
  __typename?: 'NudgeUserAboutUserAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<NudgeUserAboutUserNodeAggregateSelection>;
};

export type NudgeUserAboutUserNodeAggregateSelection = {
  __typename?: 'NudgeUserAboutUserNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type NudgeUserAggregateInput = {
  AND?: InputMaybe<Array<NudgeUserAggregateInput>>;
  NOT?: InputMaybe<NudgeUserAggregateInput>;
  OR?: InputMaybe<Array<NudgeUserAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NudgeUserNodeAggregationWhereInput>;
};

export type NudgeUserConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type NudgeUserConnectOrCreateFieldInput = {
  onCreate: NudgeUserConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type NudgeUserConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type NudgeUserConnection = {
  __typename?: 'NudgeUserConnection';
  edges: Array<NudgeUserRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NudgeUserConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type NudgeUserConnectionWhere = {
  AND?: InputMaybe<Array<NudgeUserConnectionWhere>>;
  NOT?: InputMaybe<NudgeUserConnectionWhere>;
  OR?: InputMaybe<Array<NudgeUserConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type NudgeUserCreateFieldInput = {
  node: UserCreateInput;
};

export type NudgeUserDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<NudgeUserConnectionWhere>;
};

export type NudgeUserDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<NudgeUserConnectionWhere>;
};

export type NudgeUserFieldInput = {
  connect?: InputMaybe<NudgeUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgeUserConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgeUserCreateFieldInput>;
};

export type NudgeUserNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NudgeUserNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NudgeUserNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NudgeUserNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NudgeUserRelationship = {
  __typename?: 'NudgeUserRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type NudgeUserUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type NudgeUserUpdateFieldInput = {
  connect?: InputMaybe<NudgeUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<NudgeUserConnectOrCreateFieldInput>;
  create?: InputMaybe<NudgeUserCreateFieldInput>;
  delete?: InputMaybe<NudgeUserDeleteFieldInput>;
  disconnect?: InputMaybe<NudgeUserDisconnectFieldInput>;
  update?: InputMaybe<NudgeUserUpdateConnectionInput>;
  where?: InputMaybe<NudgeUserConnectionWhere>;
};

export type NudgeUserUserAggregationSelection = {
  __typename?: 'NudgeUserUserAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<NudgeUserUserNodeAggregateSelection>;
};

export type NudgeUserUserNodeAggregateSelection = {
  __typename?: 'NudgeUserUserNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type NudgeWhere = {
  AND?: InputMaybe<Array<NudgeWhere>>;
  NOT?: InputMaybe<NudgeWhere>;
  OR?: InputMaybe<Array<NudgeWhere>>;
  aboutAiTutor?: InputMaybe<AiTutorWhere>;
  aboutAiTutorAggregate?: InputMaybe<NudgeAboutAiTutorAggregateInput>;
  aboutAiTutorConnection?: InputMaybe<NudgeAboutAiTutorConnectionWhere>;
  aboutAiTutorConnection_NOT?: InputMaybe<NudgeAboutAiTutorConnectionWhere>;
  aboutAiTutor_NOT?: InputMaybe<AiTutorWhere>;
  aboutAnnouncement?: InputMaybe<AnnouncementWhere>;
  aboutAnnouncementAggregate?: InputMaybe<NudgeAboutAnnouncementAggregateInput>;
  aboutAnnouncementConnection?: InputMaybe<NudgeAboutAnnouncementConnectionWhere>;
  aboutAnnouncementConnection_NOT?: InputMaybe<NudgeAboutAnnouncementConnectionWhere>;
  aboutAnnouncement_NOT?: InputMaybe<AnnouncementWhere>;
  aboutAssessment?: InputMaybe<AssessmentWhere>;
  aboutAssessmentAggregate?: InputMaybe<NudgeAboutAssessmentAggregateInput>;
  aboutAssessmentConnection?: InputMaybe<NudgeAboutAssessmentConnectionWhere>;
  aboutAssessmentConnection_NOT?: InputMaybe<NudgeAboutAssessmentConnectionWhere>;
  aboutAssessment_NOT?: InputMaybe<AssessmentWhere>;
  aboutAssignment?: InputMaybe<AssignmentWhere>;
  aboutAssignmentAggregate?: InputMaybe<NudgeAboutAssignmentAggregateInput>;
  aboutAssignmentConnection?: InputMaybe<NudgeAboutAssignmentConnectionWhere>;
  aboutAssignmentConnection_NOT?: InputMaybe<NudgeAboutAssignmentConnectionWhere>;
  aboutAssignment_NOT?: InputMaybe<AssignmentWhere>;
  aboutCourse?: InputMaybe<CourseWhere>;
  aboutCourseAggregate?: InputMaybe<NudgeAboutCourseAggregateInput>;
  aboutCourseConnection?: InputMaybe<NudgeAboutCourseConnectionWhere>;
  aboutCourseConnection_NOT?: InputMaybe<NudgeAboutCourseConnectionWhere>;
  aboutCourse_NOT?: InputMaybe<CourseWhere>;
  aboutExternalAnnouncement?: InputMaybe<ExternalAnnouncementWhere>;
  aboutExternalAnnouncementAggregate?: InputMaybe<NudgeAboutExternalAnnouncementAggregateInput>;
  aboutExternalAnnouncementConnection?: InputMaybe<NudgeAboutExternalAnnouncementConnectionWhere>;
  aboutExternalAnnouncementConnection_NOT?: InputMaybe<NudgeAboutExternalAnnouncementConnectionWhere>;
  aboutExternalAnnouncement_NOT?: InputMaybe<ExternalAnnouncementWhere>;
  aboutExternalAssignment?: InputMaybe<ExternalAssignmentWhere>;
  aboutExternalAssignmentAggregate?: InputMaybe<NudgeAboutExternalAssignmentAggregateInput>;
  aboutExternalAssignmentConnection?: InputMaybe<NudgeAboutExternalAssignmentConnectionWhere>;
  aboutExternalAssignmentConnection_NOT?: InputMaybe<NudgeAboutExternalAssignmentConnectionWhere>;
  aboutExternalAssignment_NOT?: InputMaybe<ExternalAssignmentWhere>;
  aboutExternalDiscussionBoard?: InputMaybe<ExternalDiscussionBoardWhere>;
  aboutExternalDiscussionBoardAggregate?: InputMaybe<NudgeAboutExternalDiscussionBoardAggregateInput>;
  aboutExternalDiscussionBoardConnection?: InputMaybe<NudgeAboutExternalDiscussionBoardConnectionWhere>;
  aboutExternalDiscussionBoardConnection_NOT?: InputMaybe<NudgeAboutExternalDiscussionBoardConnectionWhere>;
  aboutExternalDiscussionBoard_NOT?: InputMaybe<ExternalDiscussionBoardWhere>;
  aboutExternalQuiz?: InputMaybe<ExternalQuizWhere>;
  aboutExternalQuizAggregate?: InputMaybe<NudgeAboutExternalQuizAggregateInput>;
  aboutExternalQuizConnection?: InputMaybe<NudgeAboutExternalQuizConnectionWhere>;
  aboutExternalQuizConnection_NOT?: InputMaybe<NudgeAboutExternalQuizConnectionWhere>;
  aboutExternalQuiz_NOT?: InputMaybe<ExternalQuizWhere>;
  aboutModule?: InputMaybe<ModuleWhere>;
  aboutModuleAggregate?: InputMaybe<NudgeAboutModuleAggregateInput>;
  aboutModuleConnection?: InputMaybe<NudgeAboutModuleConnectionWhere>;
  aboutModuleConnection_NOT?: InputMaybe<NudgeAboutModuleConnectionWhere>;
  aboutModule_NOT?: InputMaybe<ModuleWhere>;
  aboutProject?: InputMaybe<ProjectWhere>;
  aboutProjectAggregate?: InputMaybe<NudgeAboutProjectAggregateInput>;
  aboutProjectConnection?: InputMaybe<NudgeAboutProjectConnectionWhere>;
  aboutProjectConnection_NOT?: InputMaybe<NudgeAboutProjectConnectionWhere>;
  aboutProjectRequirement?: InputMaybe<ProjectRequirementWhere>;
  aboutProjectRequirementAggregate?: InputMaybe<NudgeAboutProjectRequirementAggregateInput>;
  aboutProjectRequirementConnection?: InputMaybe<NudgeAboutProjectRequirementConnectionWhere>;
  aboutProjectRequirementConnection_NOT?: InputMaybe<NudgeAboutProjectRequirementConnectionWhere>;
  aboutProjectRequirement_NOT?: InputMaybe<ProjectRequirementWhere>;
  aboutProject_NOT?: InputMaybe<ProjectWhere>;
  aboutUser?: InputMaybe<UserWhere>;
  aboutUserAggregate?: InputMaybe<NudgeAboutUserAggregateInput>;
  aboutUserConnection?: InputMaybe<NudgeAboutUserConnectionWhere>;
  aboutUserConnection_NOT?: InputMaybe<NudgeAboutUserConnectionWhere>;
  aboutUser_NOT?: InputMaybe<UserWhere>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  eventsAggregate?: InputMaybe<NudgeEventsAggregateInput>;
  /** Return Nudges where all of the related NudgeEventsConnections match this filter */
  eventsConnection_ALL?: InputMaybe<NudgeEventsConnectionWhere>;
  /** Return Nudges where none of the related NudgeEventsConnections match this filter */
  eventsConnection_NONE?: InputMaybe<NudgeEventsConnectionWhere>;
  /** Return Nudges where one of the related NudgeEventsConnections match this filter */
  eventsConnection_SINGLE?: InputMaybe<NudgeEventsConnectionWhere>;
  /** Return Nudges where some of the related NudgeEventsConnections match this filter */
  eventsConnection_SOME?: InputMaybe<NudgeEventsConnectionWhere>;
  /** Return Nudges where all of the related NudgeEvents match this filter */
  events_ALL?: InputMaybe<NudgeEventWhere>;
  /** Return Nudges where none of the related NudgeEvents match this filter */
  events_NONE?: InputMaybe<NudgeEventWhere>;
  /** Return Nudges where one of the related NudgeEvents match this filter */
  events_SINGLE?: InputMaybe<NudgeEventWhere>;
  /** Return Nudges where some of the related NudgeEvents match this filter */
  events_SOME?: InputMaybe<NudgeEventWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  idempotencyKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lastModified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  nudgeType?: InputMaybe<NudgeType>;
  nudgeType_IN?: InputMaybe<Array<NudgeType>>;
  parentType?: InputMaybe<NudgeParentType>;
  parentType_IN?: InputMaybe<Array<NudgeParentType>>;
  priorityScore?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  priorityScore_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_LTE?: InputMaybe<Scalars['Float']['input']>;
  scheduledFor?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  scheduledFor_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  snoozedUntil_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<NudgeState>;
  state_IN?: InputMaybe<Array<NudgeState>>;
  taskCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  taskCompletedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  triggerData?: InputMaybe<Scalars['JSON']['input']>;
  triggerData_IN?: InputMaybe<Array<Scalars['JSON']['input']>>;
  triggerEventType?: InputMaybe<NudgeTriggerEventType>;
  triggerEventType_IN?: InputMaybe<Array<InputMaybe<NudgeTriggerEventType>>>;
  user?: InputMaybe<UserWhere>;
  userAggregate?: InputMaybe<NudgeUserAggregateInput>;
  userConnection?: InputMaybe<NudgeUserConnectionWhere>;
  userConnection_NOT?: InputMaybe<NudgeUserConnectionWhere>;
  user_NOT?: InputMaybe<UserWhere>;
};

export type OAuthAccessToken = {
  __typename?: 'OAuthAccessToken';
  accessToken: Scalars['String']['output'];
  client: OAuthClient;
  clientAggregate?: Maybe<OAuthAccessTokenOAuthClientClientAggregationSelection>;
  clientConnection: OAuthAccessTokenClientConnection;
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  refreshToken?: Maybe<Scalars['String']['output']>;
  refreshTokenExpiresAt?: Maybe<Scalars['DateTime']['output']>;
};


export type OAuthAccessTokenClientArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OAuthClientOptions>;
  where?: InputMaybe<OAuthClientWhere>;
};


export type OAuthAccessTokenClientAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OAuthClientWhere>;
};


export type OAuthAccessTokenClientConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OAuthAccessTokenClientConnectionSort>>;
  where?: InputMaybe<OAuthAccessTokenClientConnectionWhere>;
};

export type OAuthAccessTokenClientAggregateInput = {
  AND?: InputMaybe<Array<OAuthAccessTokenClientAggregateInput>>;
  NOT?: InputMaybe<OAuthAccessTokenClientAggregateInput>;
  OR?: InputMaybe<Array<OAuthAccessTokenClientAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<OAuthAccessTokenClientNodeAggregationWhereInput>;
};

export type OAuthAccessTokenClientConnectFieldInput = {
  connect?: InputMaybe<OAuthClientConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OAuthClientConnectWhere>;
};

export type OAuthAccessTokenClientConnectOrCreateFieldInput = {
  onCreate: OAuthAccessTokenClientConnectOrCreateFieldInputOnCreate;
  where: OAuthClientConnectOrCreateWhere;
};

export type OAuthAccessTokenClientConnectOrCreateFieldInputOnCreate = {
  node: OAuthClientOnCreateInput;
};

export type OAuthAccessTokenClientConnection = {
  __typename?: 'OAuthAccessTokenClientConnection';
  edges: Array<OAuthAccessTokenClientRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OAuthAccessTokenClientConnectionSort = {
  node?: InputMaybe<OAuthClientSort>;
};

export type OAuthAccessTokenClientConnectionWhere = {
  AND?: InputMaybe<Array<OAuthAccessTokenClientConnectionWhere>>;
  NOT?: InputMaybe<OAuthAccessTokenClientConnectionWhere>;
  OR?: InputMaybe<Array<OAuthAccessTokenClientConnectionWhere>>;
  node?: InputMaybe<OAuthClientWhere>;
};

export type OAuthAccessTokenClientCreateFieldInput = {
  node: OAuthClientCreateInput;
};

export type OAuthAccessTokenClientDeleteFieldInput = {
  delete?: InputMaybe<OAuthClientDeleteInput>;
  where?: InputMaybe<OAuthAccessTokenClientConnectionWhere>;
};

export type OAuthAccessTokenClientDisconnectFieldInput = {
  disconnect?: InputMaybe<OAuthClientDisconnectInput>;
  where?: InputMaybe<OAuthAccessTokenClientConnectionWhere>;
};

export type OAuthAccessTokenClientFieldInput = {
  connect?: InputMaybe<OAuthAccessTokenClientConnectFieldInput>;
  connectOrCreate?: InputMaybe<OAuthAccessTokenClientConnectOrCreateFieldInput>;
  create?: InputMaybe<OAuthAccessTokenClientCreateFieldInput>;
};

export type OAuthAccessTokenClientNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OAuthAccessTokenClientNodeAggregationWhereInput>>;
  NOT?: InputMaybe<OAuthAccessTokenClientNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<OAuthAccessTokenClientNodeAggregationWhereInput>>;
  clientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  clientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  clientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  clientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  clientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  clientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  clientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  clientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  clientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  clientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  clientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  clientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  clientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  clientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  clientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  clientSecret_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  clientSecret_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  clientSecret_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  clientSecret_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  clientSecret_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  clientSecret_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  clientSecret_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  clientSecret_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  clientSecret_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  clientSecret_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  clientSecret_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  clientSecret_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  clientSecret_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  clientSecret_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  clientSecret_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OAuthAccessTokenClientRelationship = {
  __typename?: 'OAuthAccessTokenClientRelationship';
  cursor: Scalars['String']['output'];
  node: OAuthClient;
};

export type OAuthAccessTokenClientUpdateConnectionInput = {
  node?: InputMaybe<OAuthClientUpdateInput>;
};

export type OAuthAccessTokenClientUpdateFieldInput = {
  connect?: InputMaybe<OAuthAccessTokenClientConnectFieldInput>;
  connectOrCreate?: InputMaybe<OAuthAccessTokenClientConnectOrCreateFieldInput>;
  create?: InputMaybe<OAuthAccessTokenClientCreateFieldInput>;
  delete?: InputMaybe<OAuthAccessTokenClientDeleteFieldInput>;
  disconnect?: InputMaybe<OAuthAccessTokenClientDisconnectFieldInput>;
  update?: InputMaybe<OAuthAccessTokenClientUpdateConnectionInput>;
  where?: InputMaybe<OAuthAccessTokenClientConnectionWhere>;
};

export type OAuthAccessTokenConnectInput = {
  client?: InputMaybe<OAuthAccessTokenClientConnectFieldInput>;
};

export type OAuthAccessTokenConnectOrCreateWhere = {
  node: OAuthAccessTokenUniqueWhere;
};

export type OAuthAccessTokenConnectWhere = {
  node: OAuthAccessTokenWhere;
};

export type OAuthAccessTokenCreateInput = {
  accessToken: Scalars['String']['input'];
  client?: InputMaybe<OAuthAccessTokenClientFieldInput>;
  expiresAt: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  refreshTokenExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OAuthAccessTokenDeleteInput = {
  client?: InputMaybe<OAuthAccessTokenClientDeleteFieldInput>;
};

export type OAuthAccessTokenDisconnectInput = {
  client?: InputMaybe<OAuthAccessTokenClientDisconnectFieldInput>;
};

export type OAuthAccessTokenOAuthClientClientAggregationSelection = {
  __typename?: 'OAuthAccessTokenOAuthClientClientAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<OAuthAccessTokenOAuthClientClientNodeAggregateSelection>;
};

export type OAuthAccessTokenOAuthClientClientNodeAggregateSelection = {
  __typename?: 'OAuthAccessTokenOAuthClientClientNodeAggregateSelection';
  clientId: StringAggregateSelection;
  clientSecret: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
};

export type OAuthAccessTokenOnCreateInput = {
  accessToken: Scalars['String']['input'];
  expiresAt: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  refreshTokenExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OAuthAccessTokenOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more OAuthAccessTokenSort objects to sort OAuthAccessTokens by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<OAuthAccessTokenSort>>;
};

/** Fields to sort OAuthAccessTokens by. The order in which sorts are applied is not guaranteed when specifying many fields in one OAuthAccessTokenSort object. */
export type OAuthAccessTokenSort = {
  accessToken?: InputMaybe<SortDirection>;
  expiresAt?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  refreshToken?: InputMaybe<SortDirection>;
  refreshTokenExpiresAt?: InputMaybe<SortDirection>;
};

export type OAuthAccessTokenUniqueWhere = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type OAuthAccessTokenUpdateInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<OAuthAccessTokenClientUpdateFieldInput>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  refreshTokenExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OAuthAccessTokenWhere = {
  AND?: InputMaybe<Array<OAuthAccessTokenWhere>>;
  NOT?: InputMaybe<OAuthAccessTokenWhere>;
  OR?: InputMaybe<Array<OAuthAccessTokenWhere>>;
  accessToken?: InputMaybe<Scalars['String']['input']>;
  accessToken_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  accessToken_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  accessToken_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  accessToken_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<OAuthClientWhere>;
  clientAggregate?: InputMaybe<OAuthAccessTokenClientAggregateInput>;
  clientConnection?: InputMaybe<OAuthAccessTokenClientConnectionWhere>;
  clientConnection_NOT?: InputMaybe<OAuthAccessTokenClientConnectionWhere>;
  client_NOT?: InputMaybe<OAuthClientWhere>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  expiresAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  refreshTokenExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  refreshTokenExpiresAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  refreshTokenExpiresAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  refreshTokenExpiresAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  refreshTokenExpiresAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  refreshTokenExpiresAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  refreshToken_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  refreshToken_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  refreshToken_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refreshToken_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type OAuthClient = {
  __typename?: 'OAuthClient';
  accessTokens: Array<OAuthAccessToken>;
  accessTokensAggregate?: Maybe<OAuthClientOAuthAccessTokenAccessTokensAggregationSelection>;
  accessTokensConnection: OAuthClientAccessTokensConnection;
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  tenant: Tenant;
  tenantAggregate?: Maybe<OAuthClientTenantTenantAggregationSelection>;
  tenantConnection: OAuthClientTenantConnection;
};


export type OAuthClientAccessTokensArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OAuthAccessTokenOptions>;
  where?: InputMaybe<OAuthAccessTokenWhere>;
};


export type OAuthClientAccessTokensAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OAuthAccessTokenWhere>;
};


export type OAuthClientAccessTokensConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OAuthClientAccessTokensConnectionSort>>;
  where?: InputMaybe<OAuthClientAccessTokensConnectionWhere>;
};


export type OAuthClientTenantArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TenantOptions>;
  where?: InputMaybe<TenantWhere>;
};


export type OAuthClientTenantAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TenantWhere>;
};


export type OAuthClientTenantConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OAuthClientTenantConnectionSort>>;
  where?: InputMaybe<OAuthClientTenantConnectionWhere>;
};

export type OAuthClientAccessTokensAggregateInput = {
  AND?: InputMaybe<Array<OAuthClientAccessTokensAggregateInput>>;
  NOT?: InputMaybe<OAuthClientAccessTokensAggregateInput>;
  OR?: InputMaybe<Array<OAuthClientAccessTokensAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<OAuthClientAccessTokensNodeAggregationWhereInput>;
};

export type OAuthClientAccessTokensConnectFieldInput = {
  connect?: InputMaybe<Array<OAuthAccessTokenConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OAuthAccessTokenConnectWhere>;
};

export type OAuthClientAccessTokensConnectOrCreateFieldInput = {
  onCreate: OAuthClientAccessTokensConnectOrCreateFieldInputOnCreate;
  where: OAuthAccessTokenConnectOrCreateWhere;
};

export type OAuthClientAccessTokensConnectOrCreateFieldInputOnCreate = {
  node: OAuthAccessTokenOnCreateInput;
};

export type OAuthClientAccessTokensConnection = {
  __typename?: 'OAuthClientAccessTokensConnection';
  edges: Array<OAuthClientAccessTokensRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OAuthClientAccessTokensConnectionSort = {
  node?: InputMaybe<OAuthAccessTokenSort>;
};

export type OAuthClientAccessTokensConnectionWhere = {
  AND?: InputMaybe<Array<OAuthClientAccessTokensConnectionWhere>>;
  NOT?: InputMaybe<OAuthClientAccessTokensConnectionWhere>;
  OR?: InputMaybe<Array<OAuthClientAccessTokensConnectionWhere>>;
  node?: InputMaybe<OAuthAccessTokenWhere>;
};

export type OAuthClientAccessTokensCreateFieldInput = {
  node: OAuthAccessTokenCreateInput;
};

export type OAuthClientAccessTokensDeleteFieldInput = {
  delete?: InputMaybe<OAuthAccessTokenDeleteInput>;
  where?: InputMaybe<OAuthClientAccessTokensConnectionWhere>;
};

export type OAuthClientAccessTokensDisconnectFieldInput = {
  disconnect?: InputMaybe<OAuthAccessTokenDisconnectInput>;
  where?: InputMaybe<OAuthClientAccessTokensConnectionWhere>;
};

export type OAuthClientAccessTokensFieldInput = {
  connect?: InputMaybe<Array<OAuthClientAccessTokensConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<OAuthClientAccessTokensConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<OAuthClientAccessTokensCreateFieldInput>>;
};

export type OAuthClientAccessTokensNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OAuthClientAccessTokensNodeAggregationWhereInput>>;
  NOT?: InputMaybe<OAuthClientAccessTokensNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<OAuthClientAccessTokensNodeAggregationWhereInput>>;
  accessToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accessToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accessToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accessToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accessToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accessToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accessToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accessToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accessToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accessToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accessToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accessToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accessToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accessToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accessToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  expiresAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  refreshTokenExpiresAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  refreshTokenExpiresAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  refreshTokenExpiresAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  refreshTokenExpiresAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  refreshTokenExpiresAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  refreshTokenExpiresAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  refreshTokenExpiresAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  refreshTokenExpiresAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  refreshTokenExpiresAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  refreshTokenExpiresAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  refreshToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refreshToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  refreshToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  refreshToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  refreshToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  refreshToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refreshToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  refreshToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  refreshToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  refreshToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  refreshToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refreshToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  refreshToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  refreshToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  refreshToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type OAuthClientAccessTokensRelationship = {
  __typename?: 'OAuthClientAccessTokensRelationship';
  cursor: Scalars['String']['output'];
  node: OAuthAccessToken;
};

export type OAuthClientAccessTokensUpdateConnectionInput = {
  node?: InputMaybe<OAuthAccessTokenUpdateInput>;
};

export type OAuthClientAccessTokensUpdateFieldInput = {
  connect?: InputMaybe<Array<OAuthClientAccessTokensConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<OAuthClientAccessTokensConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<OAuthClientAccessTokensCreateFieldInput>>;
  delete?: InputMaybe<Array<OAuthClientAccessTokensDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<OAuthClientAccessTokensDisconnectFieldInput>>;
  update?: InputMaybe<OAuthClientAccessTokensUpdateConnectionInput>;
  where?: InputMaybe<OAuthClientAccessTokensConnectionWhere>;
};

export type OAuthClientConnectInput = {
  accessTokens?: InputMaybe<Array<OAuthClientAccessTokensConnectFieldInput>>;
  tenant?: InputMaybe<OAuthClientTenantConnectFieldInput>;
};

export type OAuthClientConnectOrCreateWhere = {
  node: OAuthClientUniqueWhere;
};

export type OAuthClientConnectWhere = {
  node: OAuthClientWhere;
};

export type OAuthClientCreateInput = {
  accessTokens?: InputMaybe<OAuthClientAccessTokensFieldInput>;
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  created: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
  tenant?: InputMaybe<OAuthClientTenantFieldInput>;
};

export type OAuthClientDeleteInput = {
  accessTokens?: InputMaybe<Array<OAuthClientAccessTokensDeleteFieldInput>>;
  tenant?: InputMaybe<OAuthClientTenantDeleteFieldInput>;
};

export type OAuthClientDisconnectInput = {
  accessTokens?: InputMaybe<Array<OAuthClientAccessTokensDisconnectFieldInput>>;
  tenant?: InputMaybe<OAuthClientTenantDisconnectFieldInput>;
};

export type OAuthClientInput = {
  tenantId: Scalars['ID']['input'];
};

export type OAuthClientOAuthAccessTokenAccessTokensAggregationSelection = {
  __typename?: 'OAuthClientOAuthAccessTokenAccessTokensAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<OAuthClientOAuthAccessTokenAccessTokensNodeAggregateSelection>;
};

export type OAuthClientOAuthAccessTokenAccessTokensNodeAggregateSelection = {
  __typename?: 'OAuthClientOAuthAccessTokenAccessTokensNodeAggregateSelection';
  accessToken: StringAggregateSelection;
  expiresAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  refreshToken: StringAggregateSelection;
  refreshTokenExpiresAt: DateTimeAggregateSelection;
};

export type OAuthClientOnCreateInput = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  created: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
};

export type OAuthClientOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more OAuthClientSort objects to sort OAuthClients by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<OAuthClientSort>>;
};

export type OAuthClientResponse = {
  __typename?: 'OAuthClientResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<OAuthClient>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Fields to sort OAuthClients by. The order in which sorts are applied is not guaranteed when specifying many fields in one OAuthClientSort object. */
export type OAuthClientSort = {
  clientId?: InputMaybe<SortDirection>;
  clientSecret?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
};

export type OAuthClientTenantAggregateInput = {
  AND?: InputMaybe<Array<OAuthClientTenantAggregateInput>>;
  NOT?: InputMaybe<OAuthClientTenantAggregateInput>;
  OR?: InputMaybe<Array<OAuthClientTenantAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<OAuthClientTenantNodeAggregationWhereInput>;
};

export type OAuthClientTenantConnectFieldInput = {
  connect?: InputMaybe<TenantConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TenantConnectWhere>;
};

export type OAuthClientTenantConnectOrCreateFieldInput = {
  onCreate: OAuthClientTenantConnectOrCreateFieldInputOnCreate;
  where: TenantConnectOrCreateWhere;
};

export type OAuthClientTenantConnectOrCreateFieldInputOnCreate = {
  node: TenantOnCreateInput;
};

export type OAuthClientTenantConnection = {
  __typename?: 'OAuthClientTenantConnection';
  edges: Array<OAuthClientTenantRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OAuthClientTenantConnectionSort = {
  node?: InputMaybe<TenantSort>;
};

export type OAuthClientTenantConnectionWhere = {
  AND?: InputMaybe<Array<OAuthClientTenantConnectionWhere>>;
  NOT?: InputMaybe<OAuthClientTenantConnectionWhere>;
  OR?: InputMaybe<Array<OAuthClientTenantConnectionWhere>>;
  node?: InputMaybe<TenantWhere>;
};

export type OAuthClientTenantCreateFieldInput = {
  node: TenantCreateInput;
};

export type OAuthClientTenantDeleteFieldInput = {
  delete?: InputMaybe<TenantDeleteInput>;
  where?: InputMaybe<OAuthClientTenantConnectionWhere>;
};

export type OAuthClientTenantDisconnectFieldInput = {
  disconnect?: InputMaybe<TenantDisconnectInput>;
  where?: InputMaybe<OAuthClientTenantConnectionWhere>;
};

export type OAuthClientTenantFieldInput = {
  connect?: InputMaybe<OAuthClientTenantConnectFieldInput>;
  connectOrCreate?: InputMaybe<OAuthClientTenantConnectOrCreateFieldInput>;
  create?: InputMaybe<OAuthClientTenantCreateFieldInput>;
};

export type OAuthClientTenantNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OAuthClientTenantNodeAggregationWhereInput>>;
  NOT?: InputMaybe<OAuthClientTenantNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<OAuthClientTenantNodeAggregationWhereInput>>;
  companionName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  companionName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  key_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  key_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogImage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  proLogo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type OAuthClientTenantRelationship = {
  __typename?: 'OAuthClientTenantRelationship';
  cursor: Scalars['String']['output'];
  node: Tenant;
};

export type OAuthClientTenantTenantAggregationSelection = {
  __typename?: 'OAuthClientTenantTenantAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<OAuthClientTenantTenantNodeAggregateSelection>;
};

export type OAuthClientTenantTenantNodeAggregateSelection = {
  __typename?: 'OAuthClientTenantTenantNodeAggregateSelection';
  companionName: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  emailBackgroundColor: StringAggregateSelection;
  emailFooterColor: StringAggregateSelection;
  emulationStatement: StringAggregateSelection;
  externalSendGridDailyEmailTemplateId: StringAggregateSelection;
  externalSendGridFromEmail: StringAggregateSelection;
  externalSendGridFromName: StringAggregateSelection;
  externalSendGridTwilioServiceSID: StringAggregateSelection;
  favicon16Url: StringAggregateSelection;
  favicon32Url: StringAggregateSelection;
  favicon48Url: StringAggregateSelection;
  favicon180Url: StringAggregateSelection;
  favicon192Url: StringAggregateSelection;
  favicon512Url: StringAggregateSelection;
  faviconIcoUrl: StringAggregateSelection;
  financialInformationUrl: StringAggregateSelection;
  gameMenuBg: StringAggregateSelection;
  gameMenuCardBg: StringAggregateSelection;
  gameMenuProgress: StringAggregateSelection;
  gameMenuTrack: StringAggregateSelection;
  generalPrompt: StringAggregateSelection;
  helpCenterUrl: StringAggregateSelection;
  id: IdAggregateSelection;
  key: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  learningEmulationStatement: StringAggregateSelection;
  logo: StringAggregateSelection;
  ltiLaunchUrl: StringAggregateSelection;
  miniLogo: StringAggregateSelection;
  newsSearchTerms: StringAggregateSelection;
  officialTranscriptsUrl: StringAggregateSelection;
  ogDescription: StringAggregateSelection;
  ogImage: StringAggregateSelection;
  ogImageHeight: StringAggregateSelection;
  ogImageWidth: StringAggregateSelection;
  ogSiteName: StringAggregateSelection;
  ogTitle: StringAggregateSelection;
  ogType: StringAggregateSelection;
  onboardingPrompt: StringAggregateSelection;
  primaryColor: StringAggregateSelection;
  proLogo: StringAggregateSelection;
  reportProblemUrl: StringAggregateSelection;
  scheduleAdvisorCallUrl: StringAggregateSelection;
  schoolResourcesUrl: StringAggregateSelection;
  stripeSecretKey: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  stripeTrialDays: IntAggregateSelection;
  submitHelpTicketLink: StringAggregateSelection;
  tenantDomain: StringAggregateSelection;
  tenantName: StringAggregateSelection;
  termsOfServiceLink: StringAggregateSelection;
  upgradeModalBody: StringAggregateSelection;
};

export type OAuthClientTenantUpdateConnectionInput = {
  node?: InputMaybe<TenantUpdateInput>;
};

export type OAuthClientTenantUpdateFieldInput = {
  connect?: InputMaybe<OAuthClientTenantConnectFieldInput>;
  connectOrCreate?: InputMaybe<OAuthClientTenantConnectOrCreateFieldInput>;
  create?: InputMaybe<OAuthClientTenantCreateFieldInput>;
  delete?: InputMaybe<OAuthClientTenantDeleteFieldInput>;
  disconnect?: InputMaybe<OAuthClientTenantDisconnectFieldInput>;
  update?: InputMaybe<OAuthClientTenantUpdateConnectionInput>;
  where?: InputMaybe<OAuthClientTenantConnectionWhere>;
};

export type OAuthClientUniqueWhere = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type OAuthClientUpdateInput = {
  accessTokens?: InputMaybe<Array<OAuthClientAccessTokensUpdateFieldInput>>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  tenant?: InputMaybe<OAuthClientTenantUpdateFieldInput>;
};

export type OAuthClientWhere = {
  AND?: InputMaybe<Array<OAuthClientWhere>>;
  NOT?: InputMaybe<OAuthClientWhere>;
  OR?: InputMaybe<Array<OAuthClientWhere>>;
  accessTokensAggregate?: InputMaybe<OAuthClientAccessTokensAggregateInput>;
  /** Return OAuthClients where all of the related OAuthClientAccessTokensConnections match this filter */
  accessTokensConnection_ALL?: InputMaybe<OAuthClientAccessTokensConnectionWhere>;
  /** Return OAuthClients where none of the related OAuthClientAccessTokensConnections match this filter */
  accessTokensConnection_NONE?: InputMaybe<OAuthClientAccessTokensConnectionWhere>;
  /** Return OAuthClients where one of the related OAuthClientAccessTokensConnections match this filter */
  accessTokensConnection_SINGLE?: InputMaybe<OAuthClientAccessTokensConnectionWhere>;
  /** Return OAuthClients where some of the related OAuthClientAccessTokensConnections match this filter */
  accessTokensConnection_SOME?: InputMaybe<OAuthClientAccessTokensConnectionWhere>;
  /** Return OAuthClients where all of the related OAuthAccessTokens match this filter */
  accessTokens_ALL?: InputMaybe<OAuthAccessTokenWhere>;
  /** Return OAuthClients where none of the related OAuthAccessTokens match this filter */
  accessTokens_NONE?: InputMaybe<OAuthAccessTokenWhere>;
  /** Return OAuthClients where one of the related OAuthAccessTokens match this filter */
  accessTokens_SINGLE?: InputMaybe<OAuthAccessTokenWhere>;
  /** Return OAuthClients where some of the related OAuthAccessTokens match this filter */
  accessTokens_SOME?: InputMaybe<OAuthAccessTokenWhere>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  clientId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  clientId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  clientId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  clientSecret_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  clientSecret_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  clientSecret_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  clientSecret_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  tenant?: InputMaybe<TenantWhere>;
  tenantAggregate?: InputMaybe<OAuthClientTenantAggregateInput>;
  tenantConnection?: InputMaybe<OAuthClientTenantConnectionWhere>;
  tenantConnection_NOT?: InputMaybe<OAuthClientTenantConnectionWhere>;
  tenant_NOT?: InputMaybe<TenantWhere>;
};

export type Objective = {
  __typename?: 'Objective';
  aiTutors: Array<AiTutor>;
  aiTutorsAggregate?: Maybe<ObjectiveAiTutorAiTutorsAggregationSelection>;
  aiTutorsConnection: ObjectiveAiTutorsConnection;
  assignments: Array<Assignment>;
  assignmentsAggregate?: Maybe<ObjectiveAssignmentAssignmentsAggregationSelection>;
  assignmentsConnection: ObjectiveAssignmentsConnection;
  evalCriteria?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  objective?: Maybe<Scalars['String']['output']>;
  pendingVideoProcessing?: Maybe<Scalars['Boolean']['output']>;
  sequence?: Maybe<Scalars['Float']['output']>;
  teachingPlan?: Maybe<Scalars['String']['output']>;
  userHasProgress: Array<User>;
  userHasProgressAggregate?: Maybe<ObjectiveUserUserHasProgressAggregationSelection>;
  userHasProgressConnection: ObjectiveUserHasProgressConnection;
  videos: Array<Video>;
  videosAggregate?: Maybe<ObjectiveVideoVideosAggregationSelection>;
  videosConnection: ObjectiveVideosConnection;
};


export type ObjectiveAiTutorsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AiTutorOptions>;
  where?: InputMaybe<AiTutorWhere>;
};


export type ObjectiveAiTutorsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AiTutorWhere>;
};


export type ObjectiveAiTutorsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ObjectiveAiTutorsConnectionSort>>;
  where?: InputMaybe<ObjectiveAiTutorsConnectionWhere>;
};


export type ObjectiveAssignmentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AssignmentOptions>;
  where?: InputMaybe<AssignmentWhere>;
};


export type ObjectiveAssignmentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssignmentWhere>;
};


export type ObjectiveAssignmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ObjectiveAssignmentsConnectionSort>>;
  where?: InputMaybe<ObjectiveAssignmentsConnectionWhere>;
};


export type ObjectiveUserHasProgressArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type ObjectiveUserHasProgressAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type ObjectiveUserHasProgressConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ObjectiveUserHasProgressConnectionSort>>;
  where?: InputMaybe<ObjectiveUserHasProgressConnectionWhere>;
};


export type ObjectiveVideosArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<VideoOptions>;
  where?: InputMaybe<VideoWhere>;
};


export type ObjectiveVideosAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VideoWhere>;
};


export type ObjectiveVideosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ObjectiveVideosConnectionSort>>;
  where?: InputMaybe<ObjectiveVideosConnectionWhere>;
};

export type ObjectiveAiTutorAiTutorsAggregationSelection = {
  __typename?: 'ObjectiveAITutorAiTutorsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ObjectiveAiTutorAiTutorsNodeAggregateSelection>;
};

export type ObjectiveAiTutorAiTutorsNodeAggregateSelection = {
  __typename?: 'ObjectiveAITutorAiTutorsNodeAggregateSelection';
  context: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  targetAudience: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type ObjectiveAiTutorsAggregateInput = {
  AND?: InputMaybe<Array<ObjectiveAiTutorsAggregateInput>>;
  NOT?: InputMaybe<ObjectiveAiTutorsAggregateInput>;
  OR?: InputMaybe<Array<ObjectiveAiTutorsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ObjectiveAiTutorsNodeAggregationWhereInput>;
};

export type ObjectiveAiTutorsConnectFieldInput = {
  connect?: InputMaybe<Array<AiTutorConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AiTutorConnectWhere>;
};

export type ObjectiveAiTutorsConnectOrCreateFieldInput = {
  onCreate: ObjectiveAiTutorsConnectOrCreateFieldInputOnCreate;
  where: AiTutorConnectOrCreateWhere;
};

export type ObjectiveAiTutorsConnectOrCreateFieldInputOnCreate = {
  node: AiTutorOnCreateInput;
};

export type ObjectiveAiTutorsConnection = {
  __typename?: 'ObjectiveAiTutorsConnection';
  edges: Array<ObjectiveAiTutorsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ObjectiveAiTutorsConnectionSort = {
  node?: InputMaybe<AiTutorSort>;
};

export type ObjectiveAiTutorsConnectionWhere = {
  AND?: InputMaybe<Array<ObjectiveAiTutorsConnectionWhere>>;
  NOT?: InputMaybe<ObjectiveAiTutorsConnectionWhere>;
  OR?: InputMaybe<Array<ObjectiveAiTutorsConnectionWhere>>;
  node?: InputMaybe<AiTutorWhere>;
};

export type ObjectiveAiTutorsCreateFieldInput = {
  node: AiTutorCreateInput;
};

export type ObjectiveAiTutorsDeleteFieldInput = {
  delete?: InputMaybe<AiTutorDeleteInput>;
  where?: InputMaybe<ObjectiveAiTutorsConnectionWhere>;
};

export type ObjectiveAiTutorsDisconnectFieldInput = {
  disconnect?: InputMaybe<AiTutorDisconnectInput>;
  where?: InputMaybe<ObjectiveAiTutorsConnectionWhere>;
};

export type ObjectiveAiTutorsFieldInput = {
  connect?: InputMaybe<Array<ObjectiveAiTutorsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ObjectiveAiTutorsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ObjectiveAiTutorsCreateFieldInput>>;
};

export type ObjectiveAiTutorsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ObjectiveAiTutorsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ObjectiveAiTutorsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ObjectiveAiTutorsNodeAggregationWhereInput>>;
  context_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  context_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ObjectiveAiTutorsRelationship = {
  __typename?: 'ObjectiveAiTutorsRelationship';
  cursor: Scalars['String']['output'];
  node: AiTutor;
};

export type ObjectiveAiTutorsUpdateConnectionInput = {
  node?: InputMaybe<AiTutorUpdateInput>;
};

export type ObjectiveAiTutorsUpdateFieldInput = {
  connect?: InputMaybe<Array<ObjectiveAiTutorsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ObjectiveAiTutorsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ObjectiveAiTutorsCreateFieldInput>>;
  delete?: InputMaybe<Array<ObjectiveAiTutorsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ObjectiveAiTutorsDisconnectFieldInput>>;
  update?: InputMaybe<ObjectiveAiTutorsUpdateConnectionInput>;
  where?: InputMaybe<ObjectiveAiTutorsConnectionWhere>;
};

export type ObjectiveAnalytics = {
  __typename?: 'ObjectiveAnalytics';
  average_time_taken?: Maybe<Scalars['Float']['output']>;
  confusion_points: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  progress_details?: Maybe<ProgressDetails>;
  success_points: Scalars['Int']['output'];
};

export type ObjectiveAnalyticsResponse = {
  __typename?: 'ObjectiveAnalyticsResponse';
  count: Scalars['Int']['output'];
  data: Array<ObjectiveAnalytics>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ObjectiveAssignmentAssignmentsAggregationSelection = {
  __typename?: 'ObjectiveAssignmentAssignmentsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ObjectiveAssignmentAssignmentsNodeAggregateSelection>;
};

export type ObjectiveAssignmentAssignmentsNodeAggregateSelection = {
  __typename?: 'ObjectiveAssignmentAssignmentsNodeAggregateSelection';
  _empty: StringAggregateSelection;
  allowed_attempts: FloatAggregateSelection;
  assignee_mode: StringAggregateSelection;
  assignment_group_id: FloatAggregateSelection;
  assignment_name: StringAggregateSelection;
  body: StringAggregateSelection;
  category_id: StringAggregateSelection;
  course_id: FloatAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  description: StringAggregateSelection;
  description_plaintext: StringAggregateSelection;
  discussion_topic_assignment_id: FloatAggregateSelection;
  discussion_topic_author_anonymous_id: StringAggregateSelection;
  discussion_topic_author_avatar_image_url: StringAggregateSelection;
  discussion_topic_author_display_name: StringAggregateSelection;
  discussion_topic_author_html_url: StringAggregateSelection;
  discussion_topic_author_id: FloatAggregateSelection;
  discussion_topic_created_at: StringAggregateSelection;
  discussion_topic_discussion_subentry_count: FloatAggregateSelection;
  discussion_topic_discussion_type: StringAggregateSelection;
  discussion_topic_html_url: StringAggregateSelection;
  discussion_topic_id: FloatAggregateSelection;
  discussion_topic_last_reply_at: StringAggregateSelection;
  discussion_topic_message: StringAggregateSelection;
  discussion_topic_posted_at: StringAggregateSelection;
  discussion_topic_read_state: StringAggregateSelection;
  discussion_topic_title: StringAggregateSelection;
  discussion_topic_unread_count: FloatAggregateSelection;
  discussion_topic_url: StringAggregateSelection;
  discussion_topic_user_name: StringAggregateSelection;
  display_date: StringAggregateSelection;
  due_at: StringAggregateSelection;
  due_date: DateTimeAggregateSelection;
  end_date: StringAggregateSelection;
  external_tool_tag_attributes_content_id: FloatAggregateSelection;
  external_tool_tag_attributes_content_type: StringAggregateSelection;
  external_tool_tag_attributes_external_data: StringAggregateSelection;
  external_tool_tag_attributes_resource_link_id: StringAggregateSelection;
  external_tool_tag_attributes_url: StringAggregateSelection;
  grade_points: FloatAggregateSelection;
  grader_count: FloatAggregateSelection;
  grading_type: StringAggregateSelection;
  html: StringAggregateSelection;
  html_url: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  lti_context_id: StringAggregateSelection;
  max_attempts: FloatAggregateSelection;
  max_name_length: FloatAggregateSelection;
  name: StringAggregateSelection;
  needs_grading_count: FloatAggregateSelection;
  objectives: StringAggregateSelection;
  points_possible: FloatAggregateSelection;
  position: FloatAggregateSelection;
  resource_metadata: StringAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  secure_params: StringAggregateSelection;
  session_id: StringAggregateSelection;
  start_date: StringAggregateSelection;
  state: StringAggregateSelection;
  submissions_download_url: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_at: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  url: StringAggregateSelection;
  videoUrl: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export type ObjectiveAssignmentsAggregateInput = {
  AND?: InputMaybe<Array<ObjectiveAssignmentsAggregateInput>>;
  NOT?: InputMaybe<ObjectiveAssignmentsAggregateInput>;
  OR?: InputMaybe<Array<ObjectiveAssignmentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ObjectiveAssignmentsNodeAggregationWhereInput>;
};

export type ObjectiveAssignmentsConnectFieldInput = {
  connect?: InputMaybe<Array<AssignmentConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AssignmentConnectWhere>;
};

export type ObjectiveAssignmentsConnectOrCreateFieldInput = {
  onCreate: ObjectiveAssignmentsConnectOrCreateFieldInputOnCreate;
  where: AssignmentConnectOrCreateWhere;
};

export type ObjectiveAssignmentsConnectOrCreateFieldInputOnCreate = {
  node: AssignmentOnCreateInput;
};

export type ObjectiveAssignmentsConnection = {
  __typename?: 'ObjectiveAssignmentsConnection';
  edges: Array<ObjectiveAssignmentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ObjectiveAssignmentsConnectionSort = {
  node?: InputMaybe<AssignmentSort>;
};

export type ObjectiveAssignmentsConnectionWhere = {
  AND?: InputMaybe<Array<ObjectiveAssignmentsConnectionWhere>>;
  NOT?: InputMaybe<ObjectiveAssignmentsConnectionWhere>;
  OR?: InputMaybe<Array<ObjectiveAssignmentsConnectionWhere>>;
  node?: InputMaybe<AssignmentWhere>;
};

export type ObjectiveAssignmentsCreateFieldInput = {
  node: AssignmentCreateInput;
};

export type ObjectiveAssignmentsDeleteFieldInput = {
  delete?: InputMaybe<AssignmentDeleteInput>;
  where?: InputMaybe<ObjectiveAssignmentsConnectionWhere>;
};

export type ObjectiveAssignmentsDisconnectFieldInput = {
  disconnect?: InputMaybe<AssignmentDisconnectInput>;
  where?: InputMaybe<ObjectiveAssignmentsConnectionWhere>;
};

export type ObjectiveAssignmentsFieldInput = {
  connect?: InputMaybe<Array<ObjectiveAssignmentsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ObjectiveAssignmentsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ObjectiveAssignmentsCreateFieldInput>>;
};

export type ObjectiveAssignmentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ObjectiveAssignmentsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ObjectiveAssignmentsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ObjectiveAssignmentsNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  allowed_attempts_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_group_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  body_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  category_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_assignment_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_unread_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  display_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  due_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_date_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_points_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  html_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lti_context_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  max_attempts_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  needs_grading_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  points_possible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  secure_params_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  secure_params_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  session_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ObjectiveAssignmentsRelationship = {
  __typename?: 'ObjectiveAssignmentsRelationship';
  cursor: Scalars['String']['output'];
  node: Assignment;
};

export type ObjectiveAssignmentsUpdateConnectionInput = {
  node?: InputMaybe<AssignmentUpdateInput>;
};

export type ObjectiveAssignmentsUpdateFieldInput = {
  connect?: InputMaybe<Array<ObjectiveAssignmentsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ObjectiveAssignmentsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ObjectiveAssignmentsCreateFieldInput>>;
  delete?: InputMaybe<Array<ObjectiveAssignmentsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ObjectiveAssignmentsDisconnectFieldInput>>;
  update?: InputMaybe<ObjectiveAssignmentsUpdateConnectionInput>;
  where?: InputMaybe<ObjectiveAssignmentsConnectionWhere>;
};

export type ObjectiveCompletionDetails = {
  __typename?: 'ObjectiveCompletionDetails';
  completionStats: CompletionStats;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type ObjectiveCompletionDetailsFull = {
  __typename?: 'ObjectiveCompletionDetailsFull';
  aiTutor_id?: Maybe<Scalars['ID']['output']>;
  aiTutor_name?: Maybe<Scalars['String']['output']>;
  completionStats: CompletionStats;
  course_id?: Maybe<Scalars['ID']['output']>;
  course_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  module_id?: Maybe<Scalars['ID']['output']>;
  module_name?: Maybe<Scalars['String']['output']>;
};

export type ObjectiveCompletionDetailsResponse = {
  __typename?: 'ObjectiveCompletionDetailsResponse';
  count: Scalars['Int']['output'];
  data: Array<ObjectiveCompletionDetailsFull>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ObjectiveConnectInput = {
  aiTutors?: InputMaybe<Array<ObjectiveAiTutorsConnectFieldInput>>;
  assignments?: InputMaybe<Array<ObjectiveAssignmentsConnectFieldInput>>;
  userHasProgress?: InputMaybe<Array<ObjectiveUserHasProgressConnectFieldInput>>;
  videos?: InputMaybe<Array<ObjectiveVideosConnectFieldInput>>;
};

export type ObjectiveConnectOrCreateWhere = {
  node: ObjectiveUniqueWhere;
};

export type ObjectiveConnectWhere = {
  node: ObjectiveWhere;
};

export type ObjectiveCreateInput = {
  aiTutors?: InputMaybe<ObjectiveAiTutorsFieldInput>;
  assignments?: InputMaybe<ObjectiveAssignmentsFieldInput>;
  evalCriteria?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  objective?: InputMaybe<Scalars['String']['input']>;
  pendingVideoProcessing?: InputMaybe<Scalars['Boolean']['input']>;
  sequence?: InputMaybe<Scalars['Float']['input']>;
  teachingPlan?: InputMaybe<Scalars['String']['input']>;
  userHasProgress?: InputMaybe<ObjectiveUserHasProgressFieldInput>;
  videos?: InputMaybe<ObjectiveVideosFieldInput>;
};

export type ObjectiveDeleteInput = {
  aiTutors?: InputMaybe<Array<ObjectiveAiTutorsDeleteFieldInput>>;
  assignments?: InputMaybe<Array<ObjectiveAssignmentsDeleteFieldInput>>;
  userHasProgress?: InputMaybe<Array<ObjectiveUserHasProgressDeleteFieldInput>>;
  videos?: InputMaybe<Array<ObjectiveVideosDeleteFieldInput>>;
};

export type ObjectiveDisconnectInput = {
  aiTutors?: InputMaybe<Array<ObjectiveAiTutorsDisconnectFieldInput>>;
  assignments?: InputMaybe<Array<ObjectiveAssignmentsDisconnectFieldInput>>;
  userHasProgress?: InputMaybe<Array<ObjectiveUserHasProgressDisconnectFieldInput>>;
  videos?: InputMaybe<Array<ObjectiveVideosDisconnectFieldInput>>;
};

export type ObjectiveForVideoInput = {
  objective: Scalars['String']['input'];
  sequence?: InputMaybe<Scalars['Float']['input']>;
};

export type ObjectiveInput = {
  evalCriteria?: InputMaybe<Array<Scalars['String']['input']>>;
  objective: Scalars['String']['input'];
  sequence?: InputMaybe<Scalars['Float']['input']>;
};

export type ObjectiveOnCreateInput = {
  evalCriteria?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  objective?: InputMaybe<Scalars['String']['input']>;
  pendingVideoProcessing?: InputMaybe<Scalars['Boolean']['input']>;
  sequence?: InputMaybe<Scalars['Float']['input']>;
  teachingPlan?: InputMaybe<Scalars['String']['input']>;
};

export type ObjectiveOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ObjectiveSort objects to sort Objectives by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ObjectiveSort>>;
};

export type ObjectiveProgressAnalytics = {
  __typename?: 'ObjectiveProgressAnalytics';
  active_interaction_count: Scalars['Int']['output'];
  confusion_points: Scalars['Int']['output'];
  distractions: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  progress_details?: Maybe<ProgressDetails>;
  questions_asked: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
  success_points: Scalars['Int']['output'];
};

/** Fields to sort Objectives by. The order in which sorts are applied is not guaranteed when specifying many fields in one ObjectiveSort object. */
export type ObjectiveSort = {
  id?: InputMaybe<SortDirection>;
  objective?: InputMaybe<SortDirection>;
  pendingVideoProcessing?: InputMaybe<SortDirection>;
  sequence?: InputMaybe<SortDirection>;
  teachingPlan?: InputMaybe<SortDirection>;
};

export type ObjectiveUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ObjectiveUpdateInput = {
  aiTutors?: InputMaybe<Array<ObjectiveAiTutorsUpdateFieldInput>>;
  assignments?: InputMaybe<Array<ObjectiveAssignmentsUpdateFieldInput>>;
  evalCriteria?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  evalCriteria_POP?: InputMaybe<Scalars['Int']['input']>;
  evalCriteria_PUSH?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  objective?: InputMaybe<Scalars['String']['input']>;
  pendingVideoProcessing?: InputMaybe<Scalars['Boolean']['input']>;
  sequence?: InputMaybe<Scalars['Float']['input']>;
  sequence_ADD?: InputMaybe<Scalars['Float']['input']>;
  sequence_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  sequence_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  sequence_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  teachingPlan?: InputMaybe<Scalars['String']['input']>;
  userHasProgress?: InputMaybe<Array<ObjectiveUserHasProgressUpdateFieldInput>>;
  videos?: InputMaybe<Array<ObjectiveVideosUpdateFieldInput>>;
};

export type ObjectiveUserHasProgressAggregateInput = {
  AND?: InputMaybe<Array<ObjectiveUserHasProgressAggregateInput>>;
  NOT?: InputMaybe<ObjectiveUserHasProgressAggregateInput>;
  OR?: InputMaybe<Array<ObjectiveUserHasProgressAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasProgressPropertiesAggregationWhereInput>;
  node?: InputMaybe<ObjectiveUserHasProgressNodeAggregationWhereInput>;
};

export type ObjectiveUserHasProgressConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  edge?: InputMaybe<HasProgressPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type ObjectiveUserHasProgressConnectOrCreateFieldInput = {
  onCreate: ObjectiveUserHasProgressConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type ObjectiveUserHasProgressConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<HasProgressPropertiesCreateInput>;
  node: UserOnCreateInput;
};

export type ObjectiveUserHasProgressConnection = {
  __typename?: 'ObjectiveUserHasProgressConnection';
  edges: Array<ObjectiveUserHasProgressRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ObjectiveUserHasProgressConnectionSort = {
  edge?: InputMaybe<HasProgressPropertiesSort>;
  node?: InputMaybe<UserSort>;
};

export type ObjectiveUserHasProgressConnectionWhere = {
  AND?: InputMaybe<Array<ObjectiveUserHasProgressConnectionWhere>>;
  NOT?: InputMaybe<ObjectiveUserHasProgressConnectionWhere>;
  OR?: InputMaybe<Array<ObjectiveUserHasProgressConnectionWhere>>;
  edge?: InputMaybe<HasProgressPropertiesWhere>;
  node?: InputMaybe<UserWhere>;
};

export type ObjectiveUserHasProgressCreateFieldInput = {
  edge?: InputMaybe<HasProgressPropertiesCreateInput>;
  node: UserCreateInput;
};

export type ObjectiveUserHasProgressDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<ObjectiveUserHasProgressConnectionWhere>;
};

export type ObjectiveUserHasProgressDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<ObjectiveUserHasProgressConnectionWhere>;
};

export type ObjectiveUserHasProgressFieldInput = {
  connect?: InputMaybe<Array<ObjectiveUserHasProgressConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ObjectiveUserHasProgressConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ObjectiveUserHasProgressCreateFieldInput>>;
};

export type ObjectiveUserHasProgressNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ObjectiveUserHasProgressNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ObjectiveUserHasProgressNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ObjectiveUserHasProgressNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ObjectiveUserHasProgressRelationship = {
  __typename?: 'ObjectiveUserHasProgressRelationship';
  cursor: Scalars['String']['output'];
  node: User;
  properties: HasProgressProperties;
};

export type ObjectiveUserHasProgressUpdateConnectionInput = {
  edge?: InputMaybe<HasProgressPropertiesUpdateInput>;
  node?: InputMaybe<UserUpdateInput>;
};

export type ObjectiveUserHasProgressUpdateFieldInput = {
  connect?: InputMaybe<Array<ObjectiveUserHasProgressConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ObjectiveUserHasProgressConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ObjectiveUserHasProgressCreateFieldInput>>;
  delete?: InputMaybe<Array<ObjectiveUserHasProgressDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ObjectiveUserHasProgressDisconnectFieldInput>>;
  update?: InputMaybe<ObjectiveUserHasProgressUpdateConnectionInput>;
  where?: InputMaybe<ObjectiveUserHasProgressConnectionWhere>;
};

export type ObjectiveUserUserHasProgressAggregationSelection = {
  __typename?: 'ObjectiveUserUserHasProgressAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<ObjectiveUserUserHasProgressEdgeAggregateSelection>;
  node?: Maybe<ObjectiveUserUserHasProgressNodeAggregateSelection>;
};

export type ObjectiveUserUserHasProgressEdgeAggregateSelection = {
  __typename?: 'ObjectiveUserUserHasProgressEdgeAggregateSelection';
  ai_messages_count: IntAggregateSelection;
  average_ai_response_time: FloatAggregateSelection;
  average_student_question_complexity: StringAggregateSelection;
  average_student_response_time: FloatAggregateSelection;
  created: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  level: StringAggregateSelection;
  num_messages: IntAggregateSelection;
  originality_analysis: StringAggregateSelection;
  questions_asked: IntAggregateSelection;
  sentiment_analysis: StringAggregateSelection;
  status: StringAggregateSelection;
  student_messages_count: IntAggregateSelection;
  summary: StringAggregateSelection;
  total_time_taken: FloatAggregateSelection;
};

export type ObjectiveUserUserHasProgressNodeAggregateSelection = {
  __typename?: 'ObjectiveUserUserHasProgressNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type ObjectiveVideoVideosAggregationSelection = {
  __typename?: 'ObjectiveVideoVideosAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<ObjectiveVideoVideosEdgeAggregateSelection>;
  node?: Maybe<ObjectiveVideoVideosNodeAggregateSelection>;
};

export type ObjectiveVideoVideosEdgeAggregateSelection = {
  __typename?: 'ObjectiveVideoVideosEdgeAggregateSelection';
  relevanceScore: FloatAggregateSelection;
  timestamp: FloatAggregateSelection;
};

export type ObjectiveVideoVideosNodeAggregateSelection = {
  __typename?: 'ObjectiveVideoVideosNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  fullTranscript: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  thumbnailUrl: StringAggregateSelection;
  title: StringAggregateSelection;
  url: StringAggregateSelection;
  videoId: StringAggregateSelection;
};

export type ObjectiveVideosAggregateInput = {
  AND?: InputMaybe<Array<ObjectiveVideosAggregateInput>>;
  NOT?: InputMaybe<ObjectiveVideosAggregateInput>;
  OR?: InputMaybe<Array<ObjectiveVideosAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasVideoPropertiesAggregationWhereInput>;
  node?: InputMaybe<ObjectiveVideosNodeAggregationWhereInput>;
};

export type ObjectiveVideosConnectFieldInput = {
  connect?: InputMaybe<Array<VideoConnectInput>>;
  edge: HasVideoPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<VideoConnectWhere>;
};

export type ObjectiveVideosConnectOrCreateFieldInput = {
  onCreate: ObjectiveVideosConnectOrCreateFieldInputOnCreate;
  where: VideoConnectOrCreateWhere;
};

export type ObjectiveVideosConnectOrCreateFieldInputOnCreate = {
  edge: HasVideoPropertiesCreateInput;
  node: VideoOnCreateInput;
};

export type ObjectiveVideosConnection = {
  __typename?: 'ObjectiveVideosConnection';
  edges: Array<ObjectiveVideosRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ObjectiveVideosConnectionSort = {
  edge?: InputMaybe<HasVideoPropertiesSort>;
  node?: InputMaybe<VideoSort>;
};

export type ObjectiveVideosConnectionWhere = {
  AND?: InputMaybe<Array<ObjectiveVideosConnectionWhere>>;
  NOT?: InputMaybe<ObjectiveVideosConnectionWhere>;
  OR?: InputMaybe<Array<ObjectiveVideosConnectionWhere>>;
  edge?: InputMaybe<HasVideoPropertiesWhere>;
  node?: InputMaybe<VideoWhere>;
};

export type ObjectiveVideosCreateFieldInput = {
  edge: HasVideoPropertiesCreateInput;
  node: VideoCreateInput;
};

export type ObjectiveVideosDeleteFieldInput = {
  delete?: InputMaybe<VideoDeleteInput>;
  where?: InputMaybe<ObjectiveVideosConnectionWhere>;
};

export type ObjectiveVideosDisconnectFieldInput = {
  disconnect?: InputMaybe<VideoDisconnectInput>;
  where?: InputMaybe<ObjectiveVideosConnectionWhere>;
};

export type ObjectiveVideosFieldInput = {
  connect?: InputMaybe<Array<ObjectiveVideosConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ObjectiveVideosConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ObjectiveVideosCreateFieldInput>>;
};

export type ObjectiveVideosNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ObjectiveVideosNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ObjectiveVideosNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ObjectiveVideosNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullTranscript_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullTranscript_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullTranscript_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullTranscript_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullTranscript_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullTranscript_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullTranscript_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullTranscript_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullTranscript_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullTranscript_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullTranscript_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullTranscript_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullTranscript_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullTranscript_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullTranscript_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  thumbnailUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thumbnailUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thumbnailUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnailUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thumbnailUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnailUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnailUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnailUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnailUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnailUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnailUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnailUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnailUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnailUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnailUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  videoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  videoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  videoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  videoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  videoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  videoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  videoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ObjectiveVideosRelationship = {
  __typename?: 'ObjectiveVideosRelationship';
  cursor: Scalars['String']['output'];
  node: Video;
  properties: HasVideoProperties;
};

export type ObjectiveVideosUpdateConnectionInput = {
  edge?: InputMaybe<HasVideoPropertiesUpdateInput>;
  node?: InputMaybe<VideoUpdateInput>;
};

export type ObjectiveVideosUpdateFieldInput = {
  connect?: InputMaybe<Array<ObjectiveVideosConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ObjectiveVideosConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ObjectiveVideosCreateFieldInput>>;
  delete?: InputMaybe<Array<ObjectiveVideosDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ObjectiveVideosDisconnectFieldInput>>;
  update?: InputMaybe<ObjectiveVideosUpdateConnectionInput>;
  where?: InputMaybe<ObjectiveVideosConnectionWhere>;
};

export type ObjectiveWhere = {
  AND?: InputMaybe<Array<ObjectiveWhere>>;
  NOT?: InputMaybe<ObjectiveWhere>;
  OR?: InputMaybe<Array<ObjectiveWhere>>;
  aiTutorsAggregate?: InputMaybe<ObjectiveAiTutorsAggregateInput>;
  /** Return Objectives where all of the related ObjectiveAiTutorsConnections match this filter */
  aiTutorsConnection_ALL?: InputMaybe<ObjectiveAiTutorsConnectionWhere>;
  /** Return Objectives where none of the related ObjectiveAiTutorsConnections match this filter */
  aiTutorsConnection_NONE?: InputMaybe<ObjectiveAiTutorsConnectionWhere>;
  /** Return Objectives where one of the related ObjectiveAiTutorsConnections match this filter */
  aiTutorsConnection_SINGLE?: InputMaybe<ObjectiveAiTutorsConnectionWhere>;
  /** Return Objectives where some of the related ObjectiveAiTutorsConnections match this filter */
  aiTutorsConnection_SOME?: InputMaybe<ObjectiveAiTutorsConnectionWhere>;
  /** Return Objectives where all of the related AITutors match this filter */
  aiTutors_ALL?: InputMaybe<AiTutorWhere>;
  /** Return Objectives where none of the related AITutors match this filter */
  aiTutors_NONE?: InputMaybe<AiTutorWhere>;
  /** Return Objectives where one of the related AITutors match this filter */
  aiTutors_SINGLE?: InputMaybe<AiTutorWhere>;
  /** Return Objectives where some of the related AITutors match this filter */
  aiTutors_SOME?: InputMaybe<AiTutorWhere>;
  assignmentsAggregate?: InputMaybe<ObjectiveAssignmentsAggregateInput>;
  /** Return Objectives where all of the related ObjectiveAssignmentsConnections match this filter */
  assignmentsConnection_ALL?: InputMaybe<ObjectiveAssignmentsConnectionWhere>;
  /** Return Objectives where none of the related ObjectiveAssignmentsConnections match this filter */
  assignmentsConnection_NONE?: InputMaybe<ObjectiveAssignmentsConnectionWhere>;
  /** Return Objectives where one of the related ObjectiveAssignmentsConnections match this filter */
  assignmentsConnection_SINGLE?: InputMaybe<ObjectiveAssignmentsConnectionWhere>;
  /** Return Objectives where some of the related ObjectiveAssignmentsConnections match this filter */
  assignmentsConnection_SOME?: InputMaybe<ObjectiveAssignmentsConnectionWhere>;
  /** Return Objectives where all of the related Assignments match this filter */
  assignments_ALL?: InputMaybe<AssignmentWhere>;
  /** Return Objectives where none of the related Assignments match this filter */
  assignments_NONE?: InputMaybe<AssignmentWhere>;
  /** Return Objectives where one of the related Assignments match this filter */
  assignments_SINGLE?: InputMaybe<AssignmentWhere>;
  /** Return Objectives where some of the related Assignments match this filter */
  assignments_SOME?: InputMaybe<AssignmentWhere>;
  evalCriteria?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  evalCriteria_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  objective?: InputMaybe<Scalars['String']['input']>;
  objective_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  objective_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  objective_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  objective_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  pendingVideoProcessing?: InputMaybe<Scalars['Boolean']['input']>;
  sequence?: InputMaybe<Scalars['Float']['input']>;
  sequence_GT?: InputMaybe<Scalars['Float']['input']>;
  sequence_GTE?: InputMaybe<Scalars['Float']['input']>;
  sequence_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  sequence_LT?: InputMaybe<Scalars['Float']['input']>;
  sequence_LTE?: InputMaybe<Scalars['Float']['input']>;
  teachingPlan?: InputMaybe<Scalars['String']['input']>;
  teachingPlan_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  teachingPlan_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  teachingPlan_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  teachingPlan_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  userHasProgressAggregate?: InputMaybe<ObjectiveUserHasProgressAggregateInput>;
  /** Return Objectives where all of the related ObjectiveUserHasProgressConnections match this filter */
  userHasProgressConnection_ALL?: InputMaybe<ObjectiveUserHasProgressConnectionWhere>;
  /** Return Objectives where none of the related ObjectiveUserHasProgressConnections match this filter */
  userHasProgressConnection_NONE?: InputMaybe<ObjectiveUserHasProgressConnectionWhere>;
  /** Return Objectives where one of the related ObjectiveUserHasProgressConnections match this filter */
  userHasProgressConnection_SINGLE?: InputMaybe<ObjectiveUserHasProgressConnectionWhere>;
  /** Return Objectives where some of the related ObjectiveUserHasProgressConnections match this filter */
  userHasProgressConnection_SOME?: InputMaybe<ObjectiveUserHasProgressConnectionWhere>;
  /** Return Objectives where all of the related Users match this filter */
  userHasProgress_ALL?: InputMaybe<UserWhere>;
  /** Return Objectives where none of the related Users match this filter */
  userHasProgress_NONE?: InputMaybe<UserWhere>;
  /** Return Objectives where one of the related Users match this filter */
  userHasProgress_SINGLE?: InputMaybe<UserWhere>;
  /** Return Objectives where some of the related Users match this filter */
  userHasProgress_SOME?: InputMaybe<UserWhere>;
  videosAggregate?: InputMaybe<ObjectiveVideosAggregateInput>;
  /** Return Objectives where all of the related ObjectiveVideosConnections match this filter */
  videosConnection_ALL?: InputMaybe<ObjectiveVideosConnectionWhere>;
  /** Return Objectives where none of the related ObjectiveVideosConnections match this filter */
  videosConnection_NONE?: InputMaybe<ObjectiveVideosConnectionWhere>;
  /** Return Objectives where one of the related ObjectiveVideosConnections match this filter */
  videosConnection_SINGLE?: InputMaybe<ObjectiveVideosConnectionWhere>;
  /** Return Objectives where some of the related ObjectiveVideosConnections match this filter */
  videosConnection_SOME?: InputMaybe<ObjectiveVideosConnectionWhere>;
  /** Return Objectives where all of the related Videos match this filter */
  videos_ALL?: InputMaybe<VideoWhere>;
  /** Return Objectives where none of the related Videos match this filter */
  videos_NONE?: InputMaybe<VideoWhere>;
  /** Return Objectives where one of the related Videos match this filter */
  videos_SINGLE?: InputMaybe<VideoWhere>;
  /** Return Objectives where some of the related Videos match this filter */
  videos_SOME?: InputMaybe<VideoWhere>;
};

export type Page = {
  __typename?: 'Page';
  _empty?: Maybe<Scalars['String']['output']>;
  assignee_mode?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  coursesHasPage: Array<Course>;
  coursesHasPageAggregate?: Maybe<PageCourseCoursesHasPageAggregationSelection>;
  coursesHasPageConnection: PageCoursesHasPageConnection;
  created?: Maybe<Scalars['DateTime']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  created_date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  editing_roles?: Maybe<Scalars['String']['output']>;
  front_page?: Maybe<Scalars['Boolean']['output']>;
  hide_from_students?: Maybe<Scalars['Boolean']['output']>;
  html_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  last_edited_by_anonymous_id?: Maybe<Scalars['String']['output']>;
  last_edited_by_avatar_image_url?: Maybe<Scalars['String']['output']>;
  last_edited_by_display_name?: Maybe<Scalars['String']['output']>;
  last_edited_by_html_url?: Maybe<Scalars['String']['output']>;
  last_edited_by_id?: Maybe<Scalars['Float']['output']>;
  locked_for_user?: Maybe<Scalars['Boolean']['output']>;
  moduleHasPages: Array<Module>;
  moduleHasPagesAggregate?: Maybe<PageModuleModuleHasPagesAggregationSelection>;
  moduleHasPagesConnection: PageModuleHasPagesConnection;
  page_id?: Maybe<Scalars['Float']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['String']['output']>;
  updated_date?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usersHasSchoolPage: Array<User>;
  usersHasSchoolPageAggregate?: Maybe<PageUserUsersHasSchoolPageAggregationSelection>;
  usersHasSchoolPageConnection: PageUsersHasSchoolPageConnection;
};


export type PageCoursesHasPageArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CourseOptions>;
  where?: InputMaybe<CourseWhere>;
};


export type PageCoursesHasPageAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CourseWhere>;
};


export type PageCoursesHasPageConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PageCoursesHasPageConnectionSort>>;
  where?: InputMaybe<PageCoursesHasPageConnectionWhere>;
};


export type PageModuleHasPagesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ModuleOptions>;
  where?: InputMaybe<ModuleWhere>;
};


export type PageModuleHasPagesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ModuleWhere>;
};


export type PageModuleHasPagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PageModuleHasPagesConnectionSort>>;
  where?: InputMaybe<PageModuleHasPagesConnectionWhere>;
};


export type PageUsersHasSchoolPageArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type PageUsersHasSchoolPageAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type PageUsersHasSchoolPageConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PageUsersHasSchoolPageConnectionSort>>;
  where?: InputMaybe<PageUsersHasSchoolPageConnectionWhere>;
};

export type PageConnectInput = {
  coursesHasPage?: InputMaybe<Array<PageCoursesHasPageConnectFieldInput>>;
  moduleHasPages?: InputMaybe<Array<PageModuleHasPagesConnectFieldInput>>;
  usersHasSchoolPage?: InputMaybe<Array<PageUsersHasSchoolPageConnectFieldInput>>;
};

export type PageConnectOrCreateWhere = {
  node: PageUniqueWhere;
};

export type PageConnectWhere = {
  node: PageWhere;
};

export type PageCourseCoursesHasPageAggregationSelection = {
  __typename?: 'PageCourseCoursesHasPageAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PageCourseCoursesHasPageNodeAggregateSelection>;
};

export type PageCourseCoursesHasPageNodeAggregateSelection = {
  __typename?: 'PageCourseCoursesHasPageNodeAggregateSelection';
  account_id: FloatAggregateSelection;
  calendar_ics: StringAggregateSelection;
  cost: FloatAggregateSelection;
  courseId: StringAggregateSelection;
  course_code: StringAggregateSelection;
  course_id: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  default_view: StringAggregateSelection;
  description: StringAggregateSelection;
  dueDateEndDate: DateTimeAggregateSelection;
  dueDateStartDate: DateTimeAggregateSelection;
  endDate: DateTimeAggregateSelection;
  end_at: StringAggregateSelection;
  enrollment_term_id: FloatAggregateSelection;
  grading_standard_id: FloatAggregateSelection;
  id: IdAggregateSelection;
  integration_id: StringAggregateSelection;
  label: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  learningStandards: StringAggregateSelection;
  lengthInWeeks: FloatAggregateSelection;
  license: StringAggregateSelection;
  lti_id: StringAggregateSelection;
  name: StringAggregateSelection;
  original_name: StringAggregateSelection;
  root_account_id: FloatAggregateSelection;
  sis_course_id: StringAggregateSelection;
  sis_import_id: FloatAggregateSelection;
  startDate: DateTimeAggregateSelection;
  start_at: StringAggregateSelection;
  state: StringAggregateSelection;
  storage_quota_mb: FloatAggregateSelection;
  stripePriceId: StringAggregateSelection;
  stripeProductId: StringAggregateSelection;
  targetAudience: StringAggregateSelection;
  thumbnail: StringAggregateSelection;
  time_zone: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  uuid: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export type PageCoursesHasPageAggregateInput = {
  AND?: InputMaybe<Array<PageCoursesHasPageAggregateInput>>;
  NOT?: InputMaybe<PageCoursesHasPageAggregateInput>;
  OR?: InputMaybe<Array<PageCoursesHasPageAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PageCoursesHasPageNodeAggregationWhereInput>;
};

export type PageCoursesHasPageConnectFieldInput = {
  connect?: InputMaybe<Array<CourseConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CourseConnectWhere>;
};

export type PageCoursesHasPageConnectOrCreateFieldInput = {
  onCreate: PageCoursesHasPageConnectOrCreateFieldInputOnCreate;
  where: CourseConnectOrCreateWhere;
};

export type PageCoursesHasPageConnectOrCreateFieldInputOnCreate = {
  node: CourseOnCreateInput;
};

export type PageCoursesHasPageConnection = {
  __typename?: 'PageCoursesHasPageConnection';
  edges: Array<PageCoursesHasPageRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PageCoursesHasPageConnectionSort = {
  node?: InputMaybe<CourseSort>;
};

export type PageCoursesHasPageConnectionWhere = {
  AND?: InputMaybe<Array<PageCoursesHasPageConnectionWhere>>;
  NOT?: InputMaybe<PageCoursesHasPageConnectionWhere>;
  OR?: InputMaybe<Array<PageCoursesHasPageConnectionWhere>>;
  node?: InputMaybe<CourseWhere>;
};

export type PageCoursesHasPageCreateFieldInput = {
  node: CourseCreateInput;
};

export type PageCoursesHasPageDeleteFieldInput = {
  delete?: InputMaybe<CourseDeleteInput>;
  where?: InputMaybe<PageCoursesHasPageConnectionWhere>;
};

export type PageCoursesHasPageDisconnectFieldInput = {
  disconnect?: InputMaybe<CourseDisconnectInput>;
  where?: InputMaybe<PageCoursesHasPageConnectionWhere>;
};

export type PageCoursesHasPageFieldInput = {
  connect?: InputMaybe<Array<PageCoursesHasPageConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<PageCoursesHasPageConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<PageCoursesHasPageCreateFieldInput>>;
};

export type PageCoursesHasPageNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PageCoursesHasPageNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PageCoursesHasPageNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PageCoursesHasPageNodeAggregationWhereInput>>;
  account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  cost_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDateEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  enrollment_term_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  label_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningStandards_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthInWeeks_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  root_account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_import_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  startDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  storage_quota_mb_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PageCoursesHasPageRelationship = {
  __typename?: 'PageCoursesHasPageRelationship';
  cursor: Scalars['String']['output'];
  node: Course;
};

export type PageCoursesHasPageUpdateConnectionInput = {
  node?: InputMaybe<CourseUpdateInput>;
};

export type PageCoursesHasPageUpdateFieldInput = {
  connect?: InputMaybe<Array<PageCoursesHasPageConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<PageCoursesHasPageConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<PageCoursesHasPageCreateFieldInput>>;
  delete?: InputMaybe<Array<PageCoursesHasPageDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<PageCoursesHasPageDisconnectFieldInput>>;
  update?: InputMaybe<PageCoursesHasPageUpdateConnectionInput>;
  where?: InputMaybe<PageCoursesHasPageConnectionWhere>;
};

export type PageCreateInput = {
  _empty?: InputMaybe<Scalars['String']['input']>;
  assignee_mode?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  coursesHasPage?: InputMaybe<PageCoursesHasPageFieldInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_at?: InputMaybe<Scalars['String']['input']>;
  created_date?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  editing_roles?: InputMaybe<Scalars['String']['input']>;
  front_page?: InputMaybe<Scalars['Boolean']['input']>;
  hide_from_students?: InputMaybe<Scalars['Boolean']['input']>;
  html_url?: InputMaybe<Scalars['String']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  last_edited_by_anonymous_id?: InputMaybe<Scalars['String']['input']>;
  last_edited_by_avatar_image_url?: InputMaybe<Scalars['String']['input']>;
  last_edited_by_display_name?: InputMaybe<Scalars['String']['input']>;
  last_edited_by_html_url?: InputMaybe<Scalars['String']['input']>;
  last_edited_by_id?: InputMaybe<Scalars['Float']['input']>;
  locked_for_user?: InputMaybe<Scalars['Boolean']['input']>;
  moduleHasPages?: InputMaybe<PageModuleHasPagesFieldInput>;
  page_id?: InputMaybe<Scalars['Float']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  updated_at?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  usersHasSchoolPage?: InputMaybe<PageUsersHasSchoolPageFieldInput>;
};

export type PageDeleteInput = {
  coursesHasPage?: InputMaybe<Array<PageCoursesHasPageDeleteFieldInput>>;
  moduleHasPages?: InputMaybe<Array<PageModuleHasPagesDeleteFieldInput>>;
  usersHasSchoolPage?: InputMaybe<Array<PageUsersHasSchoolPageDeleteFieldInput>>;
};

export type PageDisconnectInput = {
  coursesHasPage?: InputMaybe<Array<PageCoursesHasPageDisconnectFieldInput>>;
  moduleHasPages?: InputMaybe<Array<PageModuleHasPagesDisconnectFieldInput>>;
  usersHasSchoolPage?: InputMaybe<Array<PageUsersHasSchoolPageDisconnectFieldInput>>;
};

/** Pagination information (Relay) */
export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PageModuleHasPagesAggregateInput = {
  AND?: InputMaybe<Array<PageModuleHasPagesAggregateInput>>;
  NOT?: InputMaybe<PageModuleHasPagesAggregateInput>;
  OR?: InputMaybe<Array<PageModuleHasPagesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PageModuleHasPagesNodeAggregationWhereInput>;
};

export type PageModuleHasPagesConnectFieldInput = {
  connect?: InputMaybe<Array<ModuleConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ModuleConnectWhere>;
};

export type PageModuleHasPagesConnectOrCreateFieldInput = {
  onCreate: PageModuleHasPagesConnectOrCreateFieldInputOnCreate;
  where: ModuleConnectOrCreateWhere;
};

export type PageModuleHasPagesConnectOrCreateFieldInputOnCreate = {
  node: ModuleOnCreateInput;
};

export type PageModuleHasPagesConnection = {
  __typename?: 'PageModuleHasPagesConnection';
  edges: Array<PageModuleHasPagesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PageModuleHasPagesConnectionSort = {
  node?: InputMaybe<ModuleSort>;
};

export type PageModuleHasPagesConnectionWhere = {
  AND?: InputMaybe<Array<PageModuleHasPagesConnectionWhere>>;
  NOT?: InputMaybe<PageModuleHasPagesConnectionWhere>;
  OR?: InputMaybe<Array<PageModuleHasPagesConnectionWhere>>;
  node?: InputMaybe<ModuleWhere>;
};

export type PageModuleHasPagesCreateFieldInput = {
  node: ModuleCreateInput;
};

export type PageModuleHasPagesDeleteFieldInput = {
  delete?: InputMaybe<ModuleDeleteInput>;
  where?: InputMaybe<PageModuleHasPagesConnectionWhere>;
};

export type PageModuleHasPagesDisconnectFieldInput = {
  disconnect?: InputMaybe<ModuleDisconnectInput>;
  where?: InputMaybe<PageModuleHasPagesConnectionWhere>;
};

export type PageModuleHasPagesFieldInput = {
  connect?: InputMaybe<Array<PageModuleHasPagesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<PageModuleHasPagesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<PageModuleHasPagesCreateFieldInput>>;
};

export type PageModuleHasPagesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PageModuleHasPagesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PageModuleHasPagesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PageModuleHasPagesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  module_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  module_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PageModuleHasPagesRelationship = {
  __typename?: 'PageModuleHasPagesRelationship';
  cursor: Scalars['String']['output'];
  node: Module;
};

export type PageModuleHasPagesUpdateConnectionInput = {
  node?: InputMaybe<ModuleUpdateInput>;
};

export type PageModuleHasPagesUpdateFieldInput = {
  connect?: InputMaybe<Array<PageModuleHasPagesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<PageModuleHasPagesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<PageModuleHasPagesCreateFieldInput>>;
  delete?: InputMaybe<Array<PageModuleHasPagesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<PageModuleHasPagesDisconnectFieldInput>>;
  update?: InputMaybe<PageModuleHasPagesUpdateConnectionInput>;
  where?: InputMaybe<PageModuleHasPagesConnectionWhere>;
};

export type PageModuleModuleHasPagesAggregationSelection = {
  __typename?: 'PageModuleModuleHasPagesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PageModuleModuleHasPagesNodeAggregateSelection>;
};

export type PageModuleModuleHasPagesNodeAggregateSelection = {
  __typename?: 'PageModuleModuleHasPagesNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  module_name: StringAggregateSelection;
  thumbnail: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type PageOnCreateInput = {
  _empty?: InputMaybe<Scalars['String']['input']>;
  assignee_mode?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_at?: InputMaybe<Scalars['String']['input']>;
  created_date?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  editing_roles?: InputMaybe<Scalars['String']['input']>;
  front_page?: InputMaybe<Scalars['Boolean']['input']>;
  hide_from_students?: InputMaybe<Scalars['Boolean']['input']>;
  html_url?: InputMaybe<Scalars['String']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  last_edited_by_anonymous_id?: InputMaybe<Scalars['String']['input']>;
  last_edited_by_avatar_image_url?: InputMaybe<Scalars['String']['input']>;
  last_edited_by_display_name?: InputMaybe<Scalars['String']['input']>;
  last_edited_by_html_url?: InputMaybe<Scalars['String']['input']>;
  last_edited_by_id?: InputMaybe<Scalars['Float']['input']>;
  locked_for_user?: InputMaybe<Scalars['Boolean']['input']>;
  page_id?: InputMaybe<Scalars['Float']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  updated_at?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type PageOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PageSort objects to sort Pages by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PageSort>>;
};

export type PageResponse = {
  __typename?: 'PageResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<Page>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Fields to sort Pages by. The order in which sorts are applied is not guaranteed when specifying many fields in one PageSort object. */
export type PageSort = {
  _empty?: InputMaybe<SortDirection>;
  assignee_mode?: InputMaybe<SortDirection>;
  body?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  created_at?: InputMaybe<SortDirection>;
  created_date?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  editing_roles?: InputMaybe<SortDirection>;
  front_page?: InputMaybe<SortDirection>;
  hide_from_students?: InputMaybe<SortDirection>;
  html_url?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastModified?: InputMaybe<SortDirection>;
  last_edited_by_anonymous_id?: InputMaybe<SortDirection>;
  last_edited_by_avatar_image_url?: InputMaybe<SortDirection>;
  last_edited_by_display_name?: InputMaybe<SortDirection>;
  last_edited_by_html_url?: InputMaybe<SortDirection>;
  last_edited_by_id?: InputMaybe<SortDirection>;
  locked_for_user?: InputMaybe<SortDirection>;
  page_id?: InputMaybe<SortDirection>;
  published?: InputMaybe<SortDirection>;
  state?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  updated_at?: InputMaybe<SortDirection>;
  updated_date?: InputMaybe<SortDirection>;
  url?: InputMaybe<SortDirection>;
};

export type PageUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PageUpdateInput = {
  _empty?: InputMaybe<Scalars['String']['input']>;
  assignee_mode?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  coursesHasPage?: InputMaybe<Array<PageCoursesHasPageUpdateFieldInput>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_at?: InputMaybe<Scalars['String']['input']>;
  created_date?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  editing_roles?: InputMaybe<Scalars['String']['input']>;
  front_page?: InputMaybe<Scalars['Boolean']['input']>;
  hide_from_students?: InputMaybe<Scalars['Boolean']['input']>;
  html_url?: InputMaybe<Scalars['String']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  last_edited_by_anonymous_id?: InputMaybe<Scalars['String']['input']>;
  last_edited_by_avatar_image_url?: InputMaybe<Scalars['String']['input']>;
  last_edited_by_display_name?: InputMaybe<Scalars['String']['input']>;
  last_edited_by_html_url?: InputMaybe<Scalars['String']['input']>;
  last_edited_by_id?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_ADD?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  locked_for_user?: InputMaybe<Scalars['Boolean']['input']>;
  moduleHasPages?: InputMaybe<Array<PageModuleHasPagesUpdateFieldInput>>;
  page_id?: InputMaybe<Scalars['Float']['input']>;
  page_id_ADD?: InputMaybe<Scalars['Float']['input']>;
  page_id_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  page_id_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  page_id_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  usersHasSchoolPage?: InputMaybe<Array<PageUsersHasSchoolPageUpdateFieldInput>>;
};

export type PageUserUsersHasSchoolPageAggregationSelection = {
  __typename?: 'PageUserUsersHasSchoolPageAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PageUserUsersHasSchoolPageNodeAggregateSelection>;
};

export type PageUserUsersHasSchoolPageNodeAggregateSelection = {
  __typename?: 'PageUserUsersHasSchoolPageNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type PageUsersHasSchoolPageAggregateInput = {
  AND?: InputMaybe<Array<PageUsersHasSchoolPageAggregateInput>>;
  NOT?: InputMaybe<PageUsersHasSchoolPageAggregateInput>;
  OR?: InputMaybe<Array<PageUsersHasSchoolPageAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PageUsersHasSchoolPageNodeAggregationWhereInput>;
};

export type PageUsersHasSchoolPageConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type PageUsersHasSchoolPageConnectOrCreateFieldInput = {
  onCreate: PageUsersHasSchoolPageConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type PageUsersHasSchoolPageConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type PageUsersHasSchoolPageConnection = {
  __typename?: 'PageUsersHasSchoolPageConnection';
  edges: Array<PageUsersHasSchoolPageRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PageUsersHasSchoolPageConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type PageUsersHasSchoolPageConnectionWhere = {
  AND?: InputMaybe<Array<PageUsersHasSchoolPageConnectionWhere>>;
  NOT?: InputMaybe<PageUsersHasSchoolPageConnectionWhere>;
  OR?: InputMaybe<Array<PageUsersHasSchoolPageConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type PageUsersHasSchoolPageCreateFieldInput = {
  node: UserCreateInput;
};

export type PageUsersHasSchoolPageDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<PageUsersHasSchoolPageConnectionWhere>;
};

export type PageUsersHasSchoolPageDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<PageUsersHasSchoolPageConnectionWhere>;
};

export type PageUsersHasSchoolPageFieldInput = {
  connect?: InputMaybe<Array<PageUsersHasSchoolPageConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<PageUsersHasSchoolPageConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<PageUsersHasSchoolPageCreateFieldInput>>;
};

export type PageUsersHasSchoolPageNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PageUsersHasSchoolPageNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PageUsersHasSchoolPageNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PageUsersHasSchoolPageNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PageUsersHasSchoolPageRelationship = {
  __typename?: 'PageUsersHasSchoolPageRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type PageUsersHasSchoolPageUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type PageUsersHasSchoolPageUpdateFieldInput = {
  connect?: InputMaybe<Array<PageUsersHasSchoolPageConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<PageUsersHasSchoolPageConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<PageUsersHasSchoolPageCreateFieldInput>>;
  delete?: InputMaybe<Array<PageUsersHasSchoolPageDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<PageUsersHasSchoolPageDisconnectFieldInput>>;
  update?: InputMaybe<PageUsersHasSchoolPageUpdateConnectionInput>;
  where?: InputMaybe<PageUsersHasSchoolPageConnectionWhere>;
};

export type PageVisit = {
  __typename?: 'PageVisit';
  endTimestamp?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  lastActiveTime?: Maybe<Scalars['DateTime']['output']>;
  path: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  visitSession: VisitSession;
  visitSessionAggregate?: Maybe<PageVisitVisitSessionVisitSessionAggregationSelection>;
  visitSessionConnection: PageVisitVisitSessionConnection;
};


export type PageVisitVisitSessionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<VisitSessionOptions>;
  where?: InputMaybe<VisitSessionWhere>;
};


export type PageVisitVisitSessionAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VisitSessionWhere>;
};


export type PageVisitVisitSessionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PageVisitVisitSessionConnectionSort>>;
  where?: InputMaybe<PageVisitVisitSessionConnectionWhere>;
};

export type PageVisitConnectInput = {
  visitSession?: InputMaybe<PageVisitVisitSessionConnectFieldInput>;
};

export type PageVisitConnectOrCreateWhere = {
  node: PageVisitUniqueWhere;
};

export type PageVisitConnectWhere = {
  node: PageVisitWhere;
};

export type PageVisitCreateInput = {
  endTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime?: InputMaybe<Scalars['DateTime']['input']>;
  path: Scalars['String']['input'];
  timestamp: Scalars['DateTime']['input'];
  visitSession?: InputMaybe<PageVisitVisitSessionFieldInput>;
};

export type PageVisitData = {
  __typename?: 'PageVisitData';
  pageVisits?: Maybe<Array<Maybe<PageVisitItem>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PageVisitDeleteInput = {
  visitSession?: InputMaybe<PageVisitVisitSessionDeleteFieldInput>;
};

export type PageVisitDisconnectInput = {
  visitSession?: InputMaybe<PageVisitVisitSessionDisconnectFieldInput>;
};

export type PageVisitItem = {
  __typename?: 'PageVisitItem';
  endTimestamp?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  lastActiveTime?: Maybe<Scalars['DateTime']['output']>;
  path: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  visitSessionId: Scalars['ID']['output'];
};

export type PageVisitListResponse = {
  __typename?: 'PageVisitListResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<PageVisitData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PageVisitOnCreateInput = {
  endTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime?: InputMaybe<Scalars['DateTime']['input']>;
  path: Scalars['String']['input'];
  timestamp: Scalars['DateTime']['input'];
};

export type PageVisitOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PageVisitSort objects to sort PageVisits by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PageVisitSort>>;
};

/** Fields to sort PageVisits by. The order in which sorts are applied is not guaranteed when specifying many fields in one PageVisitSort object. */
export type PageVisitSort = {
  endTimestamp?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastActiveTime?: InputMaybe<SortDirection>;
  path?: InputMaybe<SortDirection>;
  timestamp?: InputMaybe<SortDirection>;
};

export type PageVisitUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PageVisitUpdateInput = {
  endTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime?: InputMaybe<Scalars['DateTime']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  visitSession?: InputMaybe<PageVisitVisitSessionUpdateFieldInput>;
};

export type PageVisitVisitSessionAggregateInput = {
  AND?: InputMaybe<Array<PageVisitVisitSessionAggregateInput>>;
  NOT?: InputMaybe<PageVisitVisitSessionAggregateInput>;
  OR?: InputMaybe<Array<PageVisitVisitSessionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PageVisitVisitSessionNodeAggregationWhereInput>;
};

export type PageVisitVisitSessionConnectFieldInput = {
  connect?: InputMaybe<VisitSessionConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<VisitSessionConnectWhere>;
};

export type PageVisitVisitSessionConnectOrCreateFieldInput = {
  onCreate: PageVisitVisitSessionConnectOrCreateFieldInputOnCreate;
  where: VisitSessionConnectOrCreateWhere;
};

export type PageVisitVisitSessionConnectOrCreateFieldInputOnCreate = {
  node: VisitSessionOnCreateInput;
};

export type PageVisitVisitSessionConnection = {
  __typename?: 'PageVisitVisitSessionConnection';
  edges: Array<PageVisitVisitSessionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PageVisitVisitSessionConnectionSort = {
  node?: InputMaybe<VisitSessionSort>;
};

export type PageVisitVisitSessionConnectionWhere = {
  AND?: InputMaybe<Array<PageVisitVisitSessionConnectionWhere>>;
  NOT?: InputMaybe<PageVisitVisitSessionConnectionWhere>;
  OR?: InputMaybe<Array<PageVisitVisitSessionConnectionWhere>>;
  node?: InputMaybe<VisitSessionWhere>;
};

export type PageVisitVisitSessionCreateFieldInput = {
  node: VisitSessionCreateInput;
};

export type PageVisitVisitSessionDeleteFieldInput = {
  delete?: InputMaybe<VisitSessionDeleteInput>;
  where?: InputMaybe<PageVisitVisitSessionConnectionWhere>;
};

export type PageVisitVisitSessionDisconnectFieldInput = {
  disconnect?: InputMaybe<VisitSessionDisconnectInput>;
  where?: InputMaybe<PageVisitVisitSessionConnectionWhere>;
};

export type PageVisitVisitSessionFieldInput = {
  connect?: InputMaybe<PageVisitVisitSessionConnectFieldInput>;
  connectOrCreate?: InputMaybe<PageVisitVisitSessionConnectOrCreateFieldInput>;
  create?: InputMaybe<PageVisitVisitSessionCreateFieldInput>;
};

export type PageVisitVisitSessionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PageVisitVisitSessionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PageVisitVisitSessionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PageVisitVisitSessionNodeAggregationWhereInput>>;
  ipAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ipAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ipAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ipAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ipAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ipAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ipAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ipAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ipAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ipAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ipAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ipAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ipAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ipAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ipAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastActiveTime_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startTime_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startTime_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startTime_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startTime_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startTime_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startTime_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startTime_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startTime_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startTime_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startTime_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  userAgent_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  userAgent_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  userAgent_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  userAgent_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  userAgent_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  userAgent_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userAgent_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userAgent_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userAgent_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userAgent_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  userAgent_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userAgent_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userAgent_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userAgent_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userAgent_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PageVisitVisitSessionRelationship = {
  __typename?: 'PageVisitVisitSessionRelationship';
  cursor: Scalars['String']['output'];
  node: VisitSession;
};

export type PageVisitVisitSessionUpdateConnectionInput = {
  node?: InputMaybe<VisitSessionUpdateInput>;
};

export type PageVisitVisitSessionUpdateFieldInput = {
  connect?: InputMaybe<PageVisitVisitSessionConnectFieldInput>;
  connectOrCreate?: InputMaybe<PageVisitVisitSessionConnectOrCreateFieldInput>;
  create?: InputMaybe<PageVisitVisitSessionCreateFieldInput>;
  delete?: InputMaybe<PageVisitVisitSessionDeleteFieldInput>;
  disconnect?: InputMaybe<PageVisitVisitSessionDisconnectFieldInput>;
  update?: InputMaybe<PageVisitVisitSessionUpdateConnectionInput>;
  where?: InputMaybe<PageVisitVisitSessionConnectionWhere>;
};

export type PageVisitVisitSessionVisitSessionAggregationSelection = {
  __typename?: 'PageVisitVisitSessionVisitSessionAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PageVisitVisitSessionVisitSessionNodeAggregateSelection>;
};

export type PageVisitVisitSessionVisitSessionNodeAggregateSelection = {
  __typename?: 'PageVisitVisitSessionVisitSessionNodeAggregateSelection';
  id: IdAggregateSelection;
  ipAddress: StringAggregateSelection;
  lastActiveTime: DateTimeAggregateSelection;
  startTime: DateTimeAggregateSelection;
  userAgent: StringAggregateSelection;
};

export type PageVisitWhere = {
  AND?: InputMaybe<Array<PageVisitWhere>>;
  NOT?: InputMaybe<PageVisitWhere>;
  OR?: InputMaybe<Array<PageVisitWhere>>;
  endTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  endTimestamp_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endTimestamp_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endTimestamp_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  endTimestamp_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endTimestamp_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lastActiveTime?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastActiveTime_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  path_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  path_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  path_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  path_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_GT?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  timestamp_LT?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  visitSession?: InputMaybe<VisitSessionWhere>;
  visitSessionAggregate?: InputMaybe<PageVisitVisitSessionAggregateInput>;
  visitSessionConnection?: InputMaybe<PageVisitVisitSessionConnectionWhere>;
  visitSessionConnection_NOT?: InputMaybe<PageVisitVisitSessionConnectionWhere>;
  visitSession_NOT?: InputMaybe<VisitSessionWhere>;
};

export type PageWhere = {
  AND?: InputMaybe<Array<PageWhere>>;
  NOT?: InputMaybe<PageWhere>;
  OR?: InputMaybe<Array<PageWhere>>;
  _empty?: InputMaybe<Scalars['String']['input']>;
  _empty_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  _empty_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  _empty_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  _empty_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  assignee_mode?: InputMaybe<Scalars['String']['input']>;
  assignee_mode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  assignee_mode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  assignee_mode_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assignee_mode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  body_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  body_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  body_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  coursesHasPageAggregate?: InputMaybe<PageCoursesHasPageAggregateInput>;
  /** Return Pages where all of the related PageCoursesHasPageConnections match this filter */
  coursesHasPageConnection_ALL?: InputMaybe<PageCoursesHasPageConnectionWhere>;
  /** Return Pages where none of the related PageCoursesHasPageConnections match this filter */
  coursesHasPageConnection_NONE?: InputMaybe<PageCoursesHasPageConnectionWhere>;
  /** Return Pages where one of the related PageCoursesHasPageConnections match this filter */
  coursesHasPageConnection_SINGLE?: InputMaybe<PageCoursesHasPageConnectionWhere>;
  /** Return Pages where some of the related PageCoursesHasPageConnections match this filter */
  coursesHasPageConnection_SOME?: InputMaybe<PageCoursesHasPageConnectionWhere>;
  /** Return Pages where all of the related Courses match this filter */
  coursesHasPage_ALL?: InputMaybe<CourseWhere>;
  /** Return Pages where none of the related Courses match this filter */
  coursesHasPage_NONE?: InputMaybe<CourseWhere>;
  /** Return Pages where one of the related Courses match this filter */
  coursesHasPage_SINGLE?: InputMaybe<CourseWhere>;
  /** Return Pages where some of the related Courses match this filter */
  coursesHasPage_SOME?: InputMaybe<CourseWhere>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at?: InputMaybe<Scalars['String']['input']>;
  created_at_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  created_at_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  created_at_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  created_at_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  created_date?: InputMaybe<Scalars['String']['input']>;
  created_date_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  created_date_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  created_date_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  created_date_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  editing_roles?: InputMaybe<Scalars['String']['input']>;
  editing_roles_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  editing_roles_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  editing_roles_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  editing_roles_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  front_page?: InputMaybe<Scalars['Boolean']['input']>;
  hide_from_students?: InputMaybe<Scalars['Boolean']['input']>;
  html_url?: InputMaybe<Scalars['String']['input']>;
  html_url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  html_url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  html_url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  html_url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastModified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_edited_by_anonymous_id?: InputMaybe<Scalars['String']['input']>;
  last_edited_by_anonymous_id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  last_edited_by_anonymous_id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  last_edited_by_anonymous_id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  last_edited_by_anonymous_id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  last_edited_by_avatar_image_url?: InputMaybe<Scalars['String']['input']>;
  last_edited_by_avatar_image_url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  last_edited_by_avatar_image_url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  last_edited_by_avatar_image_url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  last_edited_by_avatar_image_url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  last_edited_by_display_name?: InputMaybe<Scalars['String']['input']>;
  last_edited_by_display_name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  last_edited_by_display_name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  last_edited_by_display_name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  last_edited_by_display_name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  last_edited_by_html_url?: InputMaybe<Scalars['String']['input']>;
  last_edited_by_html_url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  last_edited_by_html_url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  last_edited_by_html_url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  last_edited_by_html_url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  last_edited_by_id?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_GT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_GTE?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  last_edited_by_id_LT?: InputMaybe<Scalars['Float']['input']>;
  last_edited_by_id_LTE?: InputMaybe<Scalars['Float']['input']>;
  locked_for_user?: InputMaybe<Scalars['Boolean']['input']>;
  moduleHasPagesAggregate?: InputMaybe<PageModuleHasPagesAggregateInput>;
  /** Return Pages where all of the related PageModuleHasPagesConnections match this filter */
  moduleHasPagesConnection_ALL?: InputMaybe<PageModuleHasPagesConnectionWhere>;
  /** Return Pages where none of the related PageModuleHasPagesConnections match this filter */
  moduleHasPagesConnection_NONE?: InputMaybe<PageModuleHasPagesConnectionWhere>;
  /** Return Pages where one of the related PageModuleHasPagesConnections match this filter */
  moduleHasPagesConnection_SINGLE?: InputMaybe<PageModuleHasPagesConnectionWhere>;
  /** Return Pages where some of the related PageModuleHasPagesConnections match this filter */
  moduleHasPagesConnection_SOME?: InputMaybe<PageModuleHasPagesConnectionWhere>;
  /** Return Pages where all of the related Modules match this filter */
  moduleHasPages_ALL?: InputMaybe<ModuleWhere>;
  /** Return Pages where none of the related Modules match this filter */
  moduleHasPages_NONE?: InputMaybe<ModuleWhere>;
  /** Return Pages where one of the related Modules match this filter */
  moduleHasPages_SINGLE?: InputMaybe<ModuleWhere>;
  /** Return Pages where some of the related Modules match this filter */
  moduleHasPages_SOME?: InputMaybe<ModuleWhere>;
  page_id?: InputMaybe<Scalars['Float']['input']>;
  page_id_GT?: InputMaybe<Scalars['Float']['input']>;
  page_id_GTE?: InputMaybe<Scalars['Float']['input']>;
  page_id_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  page_id_LT?: InputMaybe<Scalars['Float']['input']>;
  page_id_LTE?: InputMaybe<Scalars['Float']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  state_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  state_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  state_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['String']['input']>;
  updated_at_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  updated_at_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  updated_at_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updated_at_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  updated_date?: InputMaybe<Scalars['String']['input']>;
  updated_date_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  updated_date_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  updated_date_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updated_date_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  usersHasSchoolPageAggregate?: InputMaybe<PageUsersHasSchoolPageAggregateInput>;
  /** Return Pages where all of the related PageUsersHasSchoolPageConnections match this filter */
  usersHasSchoolPageConnection_ALL?: InputMaybe<PageUsersHasSchoolPageConnectionWhere>;
  /** Return Pages where none of the related PageUsersHasSchoolPageConnections match this filter */
  usersHasSchoolPageConnection_NONE?: InputMaybe<PageUsersHasSchoolPageConnectionWhere>;
  /** Return Pages where one of the related PageUsersHasSchoolPageConnections match this filter */
  usersHasSchoolPageConnection_SINGLE?: InputMaybe<PageUsersHasSchoolPageConnectionWhere>;
  /** Return Pages where some of the related PageUsersHasSchoolPageConnections match this filter */
  usersHasSchoolPageConnection_SOME?: InputMaybe<PageUsersHasSchoolPageConnectionWhere>;
  /** Return Pages where all of the related Users match this filter */
  usersHasSchoolPage_ALL?: InputMaybe<UserWhere>;
  /** Return Pages where none of the related Users match this filter */
  usersHasSchoolPage_NONE?: InputMaybe<UserWhere>;
  /** Return Pages where one of the related Users match this filter */
  usersHasSchoolPage_SINGLE?: InputMaybe<UserWhere>;
  /** Return Pages where some of the related Users match this filter */
  usersHasSchoolPage_SOME?: InputMaybe<UserWhere>;
};

export type ParametersType = {
  __typename?: 'ParametersType';
  lastGeneratedLabel?: Maybe<Scalars['String']['output']>;
  lastGeneratedTopic?: Maybe<Scalars['String']['output']>;
  questContext?: Maybe<Scalars['String']['output']>;
  userResponse?: Maybe<Scalars['String']['output']>;
};

export type ParentRef = {
  __typename?: 'ParentRef';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type Payment = {
  __typename?: 'Payment';
  domain: Scalars['String']['output'];
  usersHasPayment: Array<User>;
  usersHasPaymentAggregate?: Maybe<PaymentUserUsersHasPaymentAggregationSelection>;
  usersHasPaymentConnection: PaymentUsersHasPaymentConnection;
};


export type PaymentUsersHasPaymentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type PaymentUsersHasPaymentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type PaymentUsersHasPaymentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PaymentUsersHasPaymentConnectionSort>>;
  where?: InputMaybe<PaymentUsersHasPaymentConnectionWhere>;
};

export type PaymentConnectInput = {
  usersHasPayment?: InputMaybe<Array<PaymentUsersHasPaymentConnectFieldInput>>;
};

export type PaymentConnectWhere = {
  node: PaymentWhere;
};

export type PaymentCreateInput = {
  domain: Scalars['String']['input'];
  usersHasPayment?: InputMaybe<PaymentUsersHasPaymentFieldInput>;
};

export type PaymentDeleteInput = {
  usersHasPayment?: InputMaybe<Array<PaymentUsersHasPaymentDeleteFieldInput>>;
};

export type PaymentDisconnectInput = {
  usersHasPayment?: InputMaybe<Array<PaymentUsersHasPaymentDisconnectFieldInput>>;
};

export type PaymentOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PaymentSort objects to sort Payments by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PaymentSort>>;
};

/** Fields to sort Payments by. The order in which sorts are applied is not guaranteed when specifying many fields in one PaymentSort object. */
export type PaymentSort = {
  domain?: InputMaybe<SortDirection>;
};

export type PaymentUpdateInput = {
  domain?: InputMaybe<Scalars['String']['input']>;
  usersHasPayment?: InputMaybe<Array<PaymentUsersHasPaymentUpdateFieldInput>>;
};

export type PaymentUserUsersHasPaymentAggregationSelection = {
  __typename?: 'PaymentUserUsersHasPaymentAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<PaymentUserUsersHasPaymentEdgeAggregateSelection>;
  node?: Maybe<PaymentUserUsersHasPaymentNodeAggregateSelection>;
};

export type PaymentUserUsersHasPaymentEdgeAggregateSelection = {
  __typename?: 'PaymentUserUsersHasPaymentEdgeAggregateSelection';
  integrationId: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
};

export type PaymentUserUsersHasPaymentNodeAggregateSelection = {
  __typename?: 'PaymentUserUsersHasPaymentNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type PaymentUsersHasPaymentAggregateInput = {
  AND?: InputMaybe<Array<PaymentUsersHasPaymentAggregateInput>>;
  NOT?: InputMaybe<PaymentUsersHasPaymentAggregateInput>;
  OR?: InputMaybe<Array<PaymentUsersHasPaymentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasPaymentPropertiesAggregationWhereInput>;
  node?: InputMaybe<PaymentUsersHasPaymentNodeAggregationWhereInput>;
};

export type PaymentUsersHasPaymentConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  edge: HasPaymentPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type PaymentUsersHasPaymentConnectOrCreateFieldInput = {
  onCreate: PaymentUsersHasPaymentConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type PaymentUsersHasPaymentConnectOrCreateFieldInputOnCreate = {
  edge: HasPaymentPropertiesCreateInput;
  node: UserOnCreateInput;
};

export type PaymentUsersHasPaymentConnection = {
  __typename?: 'PaymentUsersHasPaymentConnection';
  edges: Array<PaymentUsersHasPaymentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaymentUsersHasPaymentConnectionSort = {
  edge?: InputMaybe<HasPaymentPropertiesSort>;
  node?: InputMaybe<UserSort>;
};

export type PaymentUsersHasPaymentConnectionWhere = {
  AND?: InputMaybe<Array<PaymentUsersHasPaymentConnectionWhere>>;
  NOT?: InputMaybe<PaymentUsersHasPaymentConnectionWhere>;
  OR?: InputMaybe<Array<PaymentUsersHasPaymentConnectionWhere>>;
  edge?: InputMaybe<HasPaymentPropertiesWhere>;
  node?: InputMaybe<UserWhere>;
};

export type PaymentUsersHasPaymentCreateFieldInput = {
  edge: HasPaymentPropertiesCreateInput;
  node: UserCreateInput;
};

export type PaymentUsersHasPaymentDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<PaymentUsersHasPaymentConnectionWhere>;
};

export type PaymentUsersHasPaymentDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<PaymentUsersHasPaymentConnectionWhere>;
};

export type PaymentUsersHasPaymentFieldInput = {
  connect?: InputMaybe<Array<PaymentUsersHasPaymentConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentUsersHasPaymentConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<PaymentUsersHasPaymentCreateFieldInput>>;
};

export type PaymentUsersHasPaymentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PaymentUsersHasPaymentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PaymentUsersHasPaymentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PaymentUsersHasPaymentNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PaymentUsersHasPaymentRelationship = {
  __typename?: 'PaymentUsersHasPaymentRelationship';
  cursor: Scalars['String']['output'];
  node: User;
  properties: HasPaymentProperties;
};

export type PaymentUsersHasPaymentUpdateConnectionInput = {
  edge?: InputMaybe<HasPaymentPropertiesUpdateInput>;
  node?: InputMaybe<UserUpdateInput>;
};

export type PaymentUsersHasPaymentUpdateFieldInput = {
  connect?: InputMaybe<Array<PaymentUsersHasPaymentConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentUsersHasPaymentConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<PaymentUsersHasPaymentCreateFieldInput>>;
  delete?: InputMaybe<Array<PaymentUsersHasPaymentDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<PaymentUsersHasPaymentDisconnectFieldInput>>;
  update?: InputMaybe<PaymentUsersHasPaymentUpdateConnectionInput>;
  where?: InputMaybe<PaymentUsersHasPaymentConnectionWhere>;
};

export type PaymentWhere = {
  AND?: InputMaybe<Array<PaymentWhere>>;
  NOT?: InputMaybe<PaymentWhere>;
  OR?: InputMaybe<Array<PaymentWhere>>;
  domain?: InputMaybe<Scalars['String']['input']>;
  domain_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  domain_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  domain_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  domain_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  usersHasPaymentAggregate?: InputMaybe<PaymentUsersHasPaymentAggregateInput>;
  /** Return Payments where all of the related PaymentUsersHasPaymentConnections match this filter */
  usersHasPaymentConnection_ALL?: InputMaybe<PaymentUsersHasPaymentConnectionWhere>;
  /** Return Payments where none of the related PaymentUsersHasPaymentConnections match this filter */
  usersHasPaymentConnection_NONE?: InputMaybe<PaymentUsersHasPaymentConnectionWhere>;
  /** Return Payments where one of the related PaymentUsersHasPaymentConnections match this filter */
  usersHasPaymentConnection_SINGLE?: InputMaybe<PaymentUsersHasPaymentConnectionWhere>;
  /** Return Payments where some of the related PaymentUsersHasPaymentConnections match this filter */
  usersHasPaymentConnection_SOME?: InputMaybe<PaymentUsersHasPaymentConnectionWhere>;
  /** Return Payments where all of the related Users match this filter */
  usersHasPayment_ALL?: InputMaybe<UserWhere>;
  /** Return Payments where none of the related Users match this filter */
  usersHasPayment_NONE?: InputMaybe<UserWhere>;
  /** Return Payments where one of the related Users match this filter */
  usersHasPayment_SINGLE?: InputMaybe<UserWhere>;
  /** Return Payments where some of the related Users match this filter */
  usersHasPayment_SOME?: InputMaybe<UserWhere>;
};

export type Permission = {
  __typename?: 'Permission';
  name: Scalars['String']['output'];
  rolesHasPermission: Array<Role>;
  rolesHasPermissionAggregate?: Maybe<PermissionRoleRolesHasPermissionAggregationSelection>;
  rolesHasPermissionConnection: PermissionRolesHasPermissionConnection;
};


export type PermissionRolesHasPermissionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RoleOptions>;
  where?: InputMaybe<RoleWhere>;
};


export type PermissionRolesHasPermissionAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RoleWhere>;
};


export type PermissionRolesHasPermissionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PermissionRolesHasPermissionConnectionSort>>;
  where?: InputMaybe<PermissionRolesHasPermissionConnectionWhere>;
};

export type PermissionConnectInput = {
  rolesHasPermission?: InputMaybe<Array<PermissionRolesHasPermissionConnectFieldInput>>;
};

export type PermissionConnectWhere = {
  node: PermissionWhere;
};

export type PermissionCreateInput = {
  name: Scalars['String']['input'];
  rolesHasPermission?: InputMaybe<PermissionRolesHasPermissionFieldInput>;
};

export type PermissionDeleteInput = {
  rolesHasPermission?: InputMaybe<Array<PermissionRolesHasPermissionDeleteFieldInput>>;
};

export type PermissionDisconnectInput = {
  rolesHasPermission?: InputMaybe<Array<PermissionRolesHasPermissionDisconnectFieldInput>>;
};

export type PermissionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PermissionSort objects to sort Permissions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PermissionSort>>;
};

export type PermissionRoleRolesHasPermissionAggregationSelection = {
  __typename?: 'PermissionRoleRolesHasPermissionAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PermissionRoleRolesHasPermissionNodeAggregateSelection>;
};

export type PermissionRoleRolesHasPermissionNodeAggregateSelection = {
  __typename?: 'PermissionRoleRolesHasPermissionNodeAggregateSelection';
  name: StringAggregateSelection;
};

export type PermissionRolesHasPermissionAggregateInput = {
  AND?: InputMaybe<Array<PermissionRolesHasPermissionAggregateInput>>;
  NOT?: InputMaybe<PermissionRolesHasPermissionAggregateInput>;
  OR?: InputMaybe<Array<PermissionRolesHasPermissionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PermissionRolesHasPermissionNodeAggregationWhereInput>;
};

export type PermissionRolesHasPermissionConnectFieldInput = {
  connect?: InputMaybe<Array<RoleConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<RoleConnectWhere>;
};

export type PermissionRolesHasPermissionConnection = {
  __typename?: 'PermissionRolesHasPermissionConnection';
  edges: Array<PermissionRolesHasPermissionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PermissionRolesHasPermissionConnectionSort = {
  node?: InputMaybe<RoleSort>;
};

export type PermissionRolesHasPermissionConnectionWhere = {
  AND?: InputMaybe<Array<PermissionRolesHasPermissionConnectionWhere>>;
  NOT?: InputMaybe<PermissionRolesHasPermissionConnectionWhere>;
  OR?: InputMaybe<Array<PermissionRolesHasPermissionConnectionWhere>>;
  node?: InputMaybe<RoleWhere>;
};

export type PermissionRolesHasPermissionCreateFieldInput = {
  node: RoleCreateInput;
};

export type PermissionRolesHasPermissionDeleteFieldInput = {
  delete?: InputMaybe<RoleDeleteInput>;
  where?: InputMaybe<PermissionRolesHasPermissionConnectionWhere>;
};

export type PermissionRolesHasPermissionDisconnectFieldInput = {
  disconnect?: InputMaybe<RoleDisconnectInput>;
  where?: InputMaybe<PermissionRolesHasPermissionConnectionWhere>;
};

export type PermissionRolesHasPermissionFieldInput = {
  connect?: InputMaybe<Array<PermissionRolesHasPermissionConnectFieldInput>>;
  create?: InputMaybe<Array<PermissionRolesHasPermissionCreateFieldInput>>;
};

export type PermissionRolesHasPermissionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PermissionRolesHasPermissionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PermissionRolesHasPermissionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PermissionRolesHasPermissionNodeAggregationWhereInput>>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PermissionRolesHasPermissionRelationship = {
  __typename?: 'PermissionRolesHasPermissionRelationship';
  cursor: Scalars['String']['output'];
  node: Role;
};

export type PermissionRolesHasPermissionUpdateConnectionInput = {
  node?: InputMaybe<RoleUpdateInput>;
};

export type PermissionRolesHasPermissionUpdateFieldInput = {
  connect?: InputMaybe<Array<PermissionRolesHasPermissionConnectFieldInput>>;
  create?: InputMaybe<Array<PermissionRolesHasPermissionCreateFieldInput>>;
  delete?: InputMaybe<Array<PermissionRolesHasPermissionDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<PermissionRolesHasPermissionDisconnectFieldInput>>;
  update?: InputMaybe<PermissionRolesHasPermissionUpdateConnectionInput>;
  where?: InputMaybe<PermissionRolesHasPermissionConnectionWhere>;
};

/** Fields to sort Permissions by. The order in which sorts are applied is not guaranteed when specifying many fields in one PermissionSort object. */
export type PermissionSort = {
  name?: InputMaybe<SortDirection>;
};

export type PermissionUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  rolesHasPermission?: InputMaybe<Array<PermissionRolesHasPermissionUpdateFieldInput>>;
};

export type PermissionWhere = {
  AND?: InputMaybe<Array<PermissionWhere>>;
  NOT?: InputMaybe<PermissionWhere>;
  OR?: InputMaybe<Array<PermissionWhere>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  rolesHasPermissionAggregate?: InputMaybe<PermissionRolesHasPermissionAggregateInput>;
  /** Return Permissions where all of the related PermissionRolesHasPermissionConnections match this filter */
  rolesHasPermissionConnection_ALL?: InputMaybe<PermissionRolesHasPermissionConnectionWhere>;
  /** Return Permissions where none of the related PermissionRolesHasPermissionConnections match this filter */
  rolesHasPermissionConnection_NONE?: InputMaybe<PermissionRolesHasPermissionConnectionWhere>;
  /** Return Permissions where one of the related PermissionRolesHasPermissionConnections match this filter */
  rolesHasPermissionConnection_SINGLE?: InputMaybe<PermissionRolesHasPermissionConnectionWhere>;
  /** Return Permissions where some of the related PermissionRolesHasPermissionConnections match this filter */
  rolesHasPermissionConnection_SOME?: InputMaybe<PermissionRolesHasPermissionConnectionWhere>;
  /** Return Permissions where all of the related Roles match this filter */
  rolesHasPermission_ALL?: InputMaybe<RoleWhere>;
  /** Return Permissions where none of the related Roles match this filter */
  rolesHasPermission_NONE?: InputMaybe<RoleWhere>;
  /** Return Permissions where one of the related Roles match this filter */
  rolesHasPermission_SINGLE?: InputMaybe<RoleWhere>;
  /** Return Permissions where some of the related Roles match this filter */
  rolesHasPermission_SOME?: InputMaybe<RoleWhere>;
};

export type PersonalityTrait = {
  __typename?: 'PersonalityTrait';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type Post = {
  __typename?: 'Post';
  author: User;
  authorAggregate?: Maybe<PostUserAuthorAggregationSelection>;
  authorConnection: PostAuthorConnection;
  created: Scalars['DateTime']['output'];
  depth: Scalars['Int']['output'];
  files: Array<File>;
  filesAggregate?: Maybe<PostFileFilesAggregationSelection>;
  filesConnection: PostFilesConnection;
  id: Scalars['ID']['output'];
  lastModified: Scalars['DateTime']['output'];
  message: Scalars['String']['output'];
  replies: Array<Post>;
  repliesAggregate?: Maybe<PostPostRepliesAggregationSelection>;
  repliesConnection: PostRepliesConnection;
  replyTo?: Maybe<Post>;
  replyToAggregate?: Maybe<PostPostReplyToAggregationSelection>;
  replyToConnection: PostReplyToConnection;
  thread: Thread;
  threadAggregate?: Maybe<PostThreadThreadAggregationSelection>;
  threadConnection: PostThreadConnection;
  threadId: Scalars['String']['output'];
};


export type PostAuthorArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type PostAuthorAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type PostAuthorConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PostAuthorConnectionSort>>;
  where?: InputMaybe<PostAuthorConnectionWhere>;
};


export type PostFilesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FileOptions>;
  where?: InputMaybe<FileWhere>;
};


export type PostFilesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FileWhere>;
};


export type PostFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PostFilesConnectionSort>>;
  where?: InputMaybe<PostFilesConnectionWhere>;
};


export type PostRepliesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PostOptions>;
  where?: InputMaybe<PostWhere>;
};


export type PostRepliesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PostWhere>;
};


export type PostRepliesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PostRepliesConnectionSort>>;
  where?: InputMaybe<PostRepliesConnectionWhere>;
};


export type PostReplyToArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PostOptions>;
  where?: InputMaybe<PostWhere>;
};


export type PostReplyToAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PostWhere>;
};


export type PostReplyToConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PostReplyToConnectionSort>>;
  where?: InputMaybe<PostReplyToConnectionWhere>;
};


export type PostThreadArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ThreadOptions>;
  where?: InputMaybe<ThreadWhere>;
};


export type PostThreadAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ThreadWhere>;
};


export type PostThreadConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PostThreadConnectionSort>>;
  where?: InputMaybe<PostThreadConnectionWhere>;
};

export type PostAuthorAggregateInput = {
  AND?: InputMaybe<Array<PostAuthorAggregateInput>>;
  NOT?: InputMaybe<PostAuthorAggregateInput>;
  OR?: InputMaybe<Array<PostAuthorAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PostAuthorNodeAggregationWhereInput>;
};

export type PostAuthorConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type PostAuthorConnectOrCreateFieldInput = {
  onCreate: PostAuthorConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type PostAuthorConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type PostAuthorConnection = {
  __typename?: 'PostAuthorConnection';
  edges: Array<PostAuthorRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PostAuthorConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type PostAuthorConnectionWhere = {
  AND?: InputMaybe<Array<PostAuthorConnectionWhere>>;
  NOT?: InputMaybe<PostAuthorConnectionWhere>;
  OR?: InputMaybe<Array<PostAuthorConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type PostAuthorCreateFieldInput = {
  node: UserCreateInput;
};

export type PostAuthorDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<PostAuthorConnectionWhere>;
};

export type PostAuthorDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<PostAuthorConnectionWhere>;
};

export type PostAuthorFieldInput = {
  connect?: InputMaybe<PostAuthorConnectFieldInput>;
  connectOrCreate?: InputMaybe<PostAuthorConnectOrCreateFieldInput>;
  create?: InputMaybe<PostAuthorCreateFieldInput>;
};

export type PostAuthorNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PostAuthorNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PostAuthorNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PostAuthorNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PostAuthorRelationship = {
  __typename?: 'PostAuthorRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type PostAuthorUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type PostAuthorUpdateFieldInput = {
  connect?: InputMaybe<PostAuthorConnectFieldInput>;
  connectOrCreate?: InputMaybe<PostAuthorConnectOrCreateFieldInput>;
  create?: InputMaybe<PostAuthorCreateFieldInput>;
  delete?: InputMaybe<PostAuthorDeleteFieldInput>;
  disconnect?: InputMaybe<PostAuthorDisconnectFieldInput>;
  update?: InputMaybe<PostAuthorUpdateConnectionInput>;
  where?: InputMaybe<PostAuthorConnectionWhere>;
};

export type PostConnectInput = {
  author?: InputMaybe<PostAuthorConnectFieldInput>;
  files?: InputMaybe<Array<PostFilesConnectFieldInput>>;
  replies?: InputMaybe<Array<PostRepliesConnectFieldInput>>;
  replyTo?: InputMaybe<PostReplyToConnectFieldInput>;
  thread?: InputMaybe<PostThreadConnectFieldInput>;
};

export type PostConnectOrCreateWhere = {
  node: PostUniqueWhere;
};

export type PostConnectWhere = {
  node: PostWhere;
};

export type PostCreateInput = {
  author?: InputMaybe<PostAuthorFieldInput>;
  created: Scalars['DateTime']['input'];
  depth: Scalars['Int']['input'];
  files?: InputMaybe<PostFilesFieldInput>;
  lastModified: Scalars['DateTime']['input'];
  message: Scalars['String']['input'];
  replies?: InputMaybe<PostRepliesFieldInput>;
  replyTo?: InputMaybe<PostReplyToFieldInput>;
  thread?: InputMaybe<PostThreadFieldInput>;
  threadId: Scalars['String']['input'];
};

export type PostDeleteInput = {
  author?: InputMaybe<PostAuthorDeleteFieldInput>;
  files?: InputMaybe<Array<PostFilesDeleteFieldInput>>;
  replies?: InputMaybe<Array<PostRepliesDeleteFieldInput>>;
  replyTo?: InputMaybe<PostReplyToDeleteFieldInput>;
  thread?: InputMaybe<PostThreadDeleteFieldInput>;
};

export type PostDisconnectInput = {
  author?: InputMaybe<PostAuthorDisconnectFieldInput>;
  files?: InputMaybe<Array<PostFilesDisconnectFieldInput>>;
  replies?: InputMaybe<Array<PostRepliesDisconnectFieldInput>>;
  replyTo?: InputMaybe<PostReplyToDisconnectFieldInput>;
  thread?: InputMaybe<PostThreadDisconnectFieldInput>;
};

export type PostFileFilesAggregationSelection = {
  __typename?: 'PostFileFilesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PostFileFilesNodeAggregateSelection>;
};

export type PostFileFilesNodeAggregateSelection = {
  __typename?: 'PostFileFilesNodeAggregateSelection';
  bucketName: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  fileName: StringAggregateSelection;
  filePath: StringAggregateSelection;
  fileURL: StringAggregateSelection;
  id: IdAggregateSelection;
};

export type PostFilesAggregateInput = {
  AND?: InputMaybe<Array<PostFilesAggregateInput>>;
  NOT?: InputMaybe<PostFilesAggregateInput>;
  OR?: InputMaybe<Array<PostFilesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PostFilesNodeAggregationWhereInput>;
};

export type PostFilesConnectFieldInput = {
  connect?: InputMaybe<Array<FileConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FileConnectWhere>;
};

export type PostFilesConnectOrCreateFieldInput = {
  onCreate: PostFilesConnectOrCreateFieldInputOnCreate;
  where: FileConnectOrCreateWhere;
};

export type PostFilesConnectOrCreateFieldInputOnCreate = {
  node: FileOnCreateInput;
};

export type PostFilesConnection = {
  __typename?: 'PostFilesConnection';
  edges: Array<PostFilesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PostFilesConnectionSort = {
  node?: InputMaybe<FileSort>;
};

export type PostFilesConnectionWhere = {
  AND?: InputMaybe<Array<PostFilesConnectionWhere>>;
  NOT?: InputMaybe<PostFilesConnectionWhere>;
  OR?: InputMaybe<Array<PostFilesConnectionWhere>>;
  node?: InputMaybe<FileWhere>;
};

export type PostFilesCreateFieldInput = {
  node: FileCreateInput;
};

export type PostFilesDeleteFieldInput = {
  delete?: InputMaybe<FileDeleteInput>;
  where?: InputMaybe<PostFilesConnectionWhere>;
};

export type PostFilesDisconnectFieldInput = {
  disconnect?: InputMaybe<FileDisconnectInput>;
  where?: InputMaybe<PostFilesConnectionWhere>;
};

export type PostFilesFieldInput = {
  connect?: InputMaybe<Array<PostFilesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<PostFilesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<PostFilesCreateFieldInput>>;
};

export type PostFilesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PostFilesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PostFilesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PostFilesNodeAggregationWhereInput>>;
  bucketName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  bucketName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  fileName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileURL_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PostFilesRelationship = {
  __typename?: 'PostFilesRelationship';
  cursor: Scalars['String']['output'];
  node: File;
};

export type PostFilesUpdateConnectionInput = {
  node?: InputMaybe<FileUpdateInput>;
};

export type PostFilesUpdateFieldInput = {
  connect?: InputMaybe<Array<PostFilesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<PostFilesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<PostFilesCreateFieldInput>>;
  delete?: InputMaybe<Array<PostFilesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<PostFilesDisconnectFieldInput>>;
  update?: InputMaybe<PostFilesUpdateConnectionInput>;
  where?: InputMaybe<PostFilesConnectionWhere>;
};

export type PostListResponse = {
  __typename?: 'PostListResponse';
  count: Scalars['Int']['output'];
  data: Array<Post>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type PostOnCreateInput = {
  created: Scalars['DateTime']['input'];
  depth: Scalars['Int']['input'];
  lastModified: Scalars['DateTime']['input'];
  message: Scalars['String']['input'];
  threadId: Scalars['String']['input'];
};

export type PostOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PostSort objects to sort Posts by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PostSort>>;
};

export type PostPostRepliesAggregationSelection = {
  __typename?: 'PostPostRepliesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PostPostRepliesNodeAggregateSelection>;
};

export type PostPostRepliesNodeAggregateSelection = {
  __typename?: 'PostPostRepliesNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  depth: IntAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  message: StringAggregateSelection;
  threadId: StringAggregateSelection;
};

export type PostPostReplyToAggregationSelection = {
  __typename?: 'PostPostReplyToAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PostPostReplyToNodeAggregateSelection>;
};

export type PostPostReplyToNodeAggregateSelection = {
  __typename?: 'PostPostReplyToNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  depth: IntAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  message: StringAggregateSelection;
  threadId: StringAggregateSelection;
};

export type PostRepliesAggregateInput = {
  AND?: InputMaybe<Array<PostRepliesAggregateInput>>;
  NOT?: InputMaybe<PostRepliesAggregateInput>;
  OR?: InputMaybe<Array<PostRepliesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PostRepliesNodeAggregationWhereInput>;
};

export type PostRepliesConnectFieldInput = {
  connect?: InputMaybe<Array<PostConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PostConnectWhere>;
};

export type PostRepliesConnectOrCreateFieldInput = {
  onCreate: PostRepliesConnectOrCreateFieldInputOnCreate;
  where: PostConnectOrCreateWhere;
};

export type PostRepliesConnectOrCreateFieldInputOnCreate = {
  node: PostOnCreateInput;
};

export type PostRepliesConnection = {
  __typename?: 'PostRepliesConnection';
  edges: Array<PostRepliesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PostRepliesConnectionSort = {
  node?: InputMaybe<PostSort>;
};

export type PostRepliesConnectionWhere = {
  AND?: InputMaybe<Array<PostRepliesConnectionWhere>>;
  NOT?: InputMaybe<PostRepliesConnectionWhere>;
  OR?: InputMaybe<Array<PostRepliesConnectionWhere>>;
  node?: InputMaybe<PostWhere>;
};

export type PostRepliesCreateFieldInput = {
  node: PostCreateInput;
};

export type PostRepliesDeleteFieldInput = {
  delete?: InputMaybe<PostDeleteInput>;
  where?: InputMaybe<PostRepliesConnectionWhere>;
};

export type PostRepliesDisconnectFieldInput = {
  disconnect?: InputMaybe<PostDisconnectInput>;
  where?: InputMaybe<PostRepliesConnectionWhere>;
};

export type PostRepliesFieldInput = {
  connect?: InputMaybe<Array<PostRepliesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<PostRepliesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<PostRepliesCreateFieldInput>>;
};

export type PostRepliesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PostRepliesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PostRepliesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PostRepliesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  depth_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  depth_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  depth_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  depth_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  depth_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  depth_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  depth_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  depth_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  depth_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  depth_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  depth_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  depth_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  depth_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  depth_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  depth_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  depth_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  depth_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  depth_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  depth_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  depth_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  message_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  message_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threadId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threadId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  threadId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  threadId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  threadId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  threadId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threadId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threadId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threadId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threadId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threadId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threadId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threadId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threadId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threadId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PostRepliesRelationship = {
  __typename?: 'PostRepliesRelationship';
  cursor: Scalars['String']['output'];
  node: Post;
};

export type PostRepliesUpdateConnectionInput = {
  node?: InputMaybe<PostUpdateInput>;
};

export type PostRepliesUpdateFieldInput = {
  connect?: InputMaybe<Array<PostRepliesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<PostRepliesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<PostRepliesCreateFieldInput>>;
  delete?: InputMaybe<Array<PostRepliesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<PostRepliesDisconnectFieldInput>>;
  update?: InputMaybe<PostRepliesUpdateConnectionInput>;
  where?: InputMaybe<PostRepliesConnectionWhere>;
};

export type PostReplyToAggregateInput = {
  AND?: InputMaybe<Array<PostReplyToAggregateInput>>;
  NOT?: InputMaybe<PostReplyToAggregateInput>;
  OR?: InputMaybe<Array<PostReplyToAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PostReplyToNodeAggregationWhereInput>;
};

export type PostReplyToConnectFieldInput = {
  connect?: InputMaybe<PostConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PostConnectWhere>;
};

export type PostReplyToConnectOrCreateFieldInput = {
  onCreate: PostReplyToConnectOrCreateFieldInputOnCreate;
  where: PostConnectOrCreateWhere;
};

export type PostReplyToConnectOrCreateFieldInputOnCreate = {
  node: PostOnCreateInput;
};

export type PostReplyToConnection = {
  __typename?: 'PostReplyToConnection';
  edges: Array<PostReplyToRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PostReplyToConnectionSort = {
  node?: InputMaybe<PostSort>;
};

export type PostReplyToConnectionWhere = {
  AND?: InputMaybe<Array<PostReplyToConnectionWhere>>;
  NOT?: InputMaybe<PostReplyToConnectionWhere>;
  OR?: InputMaybe<Array<PostReplyToConnectionWhere>>;
  node?: InputMaybe<PostWhere>;
};

export type PostReplyToCreateFieldInput = {
  node: PostCreateInput;
};

export type PostReplyToDeleteFieldInput = {
  delete?: InputMaybe<PostDeleteInput>;
  where?: InputMaybe<PostReplyToConnectionWhere>;
};

export type PostReplyToDisconnectFieldInput = {
  disconnect?: InputMaybe<PostDisconnectInput>;
  where?: InputMaybe<PostReplyToConnectionWhere>;
};

export type PostReplyToFieldInput = {
  connect?: InputMaybe<PostReplyToConnectFieldInput>;
  connectOrCreate?: InputMaybe<PostReplyToConnectOrCreateFieldInput>;
  create?: InputMaybe<PostReplyToCreateFieldInput>;
};

export type PostReplyToNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PostReplyToNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PostReplyToNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PostReplyToNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  depth_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  depth_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  depth_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  depth_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  depth_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  depth_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  depth_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  depth_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  depth_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  depth_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  depth_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  depth_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  depth_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  depth_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  depth_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  depth_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  depth_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  depth_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  depth_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  depth_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  message_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  message_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threadId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threadId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  threadId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  threadId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  threadId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  threadId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threadId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threadId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threadId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threadId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threadId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threadId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threadId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threadId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threadId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PostReplyToRelationship = {
  __typename?: 'PostReplyToRelationship';
  cursor: Scalars['String']['output'];
  node: Post;
};

export type PostReplyToUpdateConnectionInput = {
  node?: InputMaybe<PostUpdateInput>;
};

export type PostReplyToUpdateFieldInput = {
  connect?: InputMaybe<PostReplyToConnectFieldInput>;
  connectOrCreate?: InputMaybe<PostReplyToConnectOrCreateFieldInput>;
  create?: InputMaybe<PostReplyToCreateFieldInput>;
  delete?: InputMaybe<PostReplyToDeleteFieldInput>;
  disconnect?: InputMaybe<PostReplyToDisconnectFieldInput>;
  update?: InputMaybe<PostReplyToUpdateConnectionInput>;
  where?: InputMaybe<PostReplyToConnectionWhere>;
};

export type PostResponse = {
  __typename?: 'PostResponse';
  count: Scalars['Int']['output'];
  data?: Maybe<Post>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Fields to sort Posts by. The order in which sorts are applied is not guaranteed when specifying many fields in one PostSort object. */
export type PostSort = {
  created?: InputMaybe<SortDirection>;
  depth?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastModified?: InputMaybe<SortDirection>;
  message?: InputMaybe<SortDirection>;
  threadId?: InputMaybe<SortDirection>;
};

export type PostThreadAggregateInput = {
  AND?: InputMaybe<Array<PostThreadAggregateInput>>;
  NOT?: InputMaybe<PostThreadAggregateInput>;
  OR?: InputMaybe<Array<PostThreadAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PostThreadNodeAggregationWhereInput>;
};

export type PostThreadConnectFieldInput = {
  connect?: InputMaybe<ThreadConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ThreadConnectWhere>;
};

export type PostThreadConnectOrCreateFieldInput = {
  onCreate: PostThreadConnectOrCreateFieldInputOnCreate;
  where: ThreadConnectOrCreateWhere;
};

export type PostThreadConnectOrCreateFieldInputOnCreate = {
  node: ThreadOnCreateInput;
};

export type PostThreadConnection = {
  __typename?: 'PostThreadConnection';
  edges: Array<PostThreadRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PostThreadConnectionSort = {
  node?: InputMaybe<ThreadSort>;
};

export type PostThreadConnectionWhere = {
  AND?: InputMaybe<Array<PostThreadConnectionWhere>>;
  NOT?: InputMaybe<PostThreadConnectionWhere>;
  OR?: InputMaybe<Array<PostThreadConnectionWhere>>;
  node?: InputMaybe<ThreadWhere>;
};

export type PostThreadCreateFieldInput = {
  node: ThreadCreateInput;
};

export type PostThreadDeleteFieldInput = {
  delete?: InputMaybe<ThreadDeleteInput>;
  where?: InputMaybe<PostThreadConnectionWhere>;
};

export type PostThreadDisconnectFieldInput = {
  disconnect?: InputMaybe<ThreadDisconnectInput>;
  where?: InputMaybe<PostThreadConnectionWhere>;
};

export type PostThreadFieldInput = {
  connect?: InputMaybe<PostThreadConnectFieldInput>;
  connectOrCreate?: InputMaybe<PostThreadConnectOrCreateFieldInput>;
  create?: InputMaybe<PostThreadCreateFieldInput>;
};

export type PostThreadNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PostThreadNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PostThreadNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PostThreadNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PostThreadRelationship = {
  __typename?: 'PostThreadRelationship';
  cursor: Scalars['String']['output'];
  node: Thread;
};

export type PostThreadThreadAggregationSelection = {
  __typename?: 'PostThreadThreadAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PostThreadThreadNodeAggregateSelection>;
};

export type PostThreadThreadNodeAggregateSelection = {
  __typename?: 'PostThreadThreadNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  title: StringAggregateSelection;
};

export type PostThreadUpdateConnectionInput = {
  node?: InputMaybe<ThreadUpdateInput>;
};

export type PostThreadUpdateFieldInput = {
  connect?: InputMaybe<PostThreadConnectFieldInput>;
  connectOrCreate?: InputMaybe<PostThreadConnectOrCreateFieldInput>;
  create?: InputMaybe<PostThreadCreateFieldInput>;
  delete?: InputMaybe<PostThreadDeleteFieldInput>;
  disconnect?: InputMaybe<PostThreadDisconnectFieldInput>;
  update?: InputMaybe<PostThreadUpdateConnectionInput>;
  where?: InputMaybe<PostThreadConnectionWhere>;
};

export type PostUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PostUpdateInput = {
  author?: InputMaybe<PostAuthorUpdateFieldInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  depth?: InputMaybe<Scalars['Int']['input']>;
  depth_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  depth_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  files?: InputMaybe<Array<PostFilesUpdateFieldInput>>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  replies?: InputMaybe<Array<PostRepliesUpdateFieldInput>>;
  replyTo?: InputMaybe<PostReplyToUpdateFieldInput>;
  thread?: InputMaybe<PostThreadUpdateFieldInput>;
  threadId?: InputMaybe<Scalars['String']['input']>;
};

export type PostUserAuthorAggregationSelection = {
  __typename?: 'PostUserAuthorAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PostUserAuthorNodeAggregateSelection>;
};

export type PostUserAuthorNodeAggregateSelection = {
  __typename?: 'PostUserAuthorNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type PostWhere = {
  AND?: InputMaybe<Array<PostWhere>>;
  NOT?: InputMaybe<PostWhere>;
  OR?: InputMaybe<Array<PostWhere>>;
  author?: InputMaybe<UserWhere>;
  authorAggregate?: InputMaybe<PostAuthorAggregateInput>;
  authorConnection?: InputMaybe<PostAuthorConnectionWhere>;
  authorConnection_NOT?: InputMaybe<PostAuthorConnectionWhere>;
  author_NOT?: InputMaybe<UserWhere>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  depth?: InputMaybe<Scalars['Int']['input']>;
  depth_GT?: InputMaybe<Scalars['Int']['input']>;
  depth_GTE?: InputMaybe<Scalars['Int']['input']>;
  depth_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  depth_LT?: InputMaybe<Scalars['Int']['input']>;
  depth_LTE?: InputMaybe<Scalars['Int']['input']>;
  filesAggregate?: InputMaybe<PostFilesAggregateInput>;
  /** Return Posts where all of the related PostFilesConnections match this filter */
  filesConnection_ALL?: InputMaybe<PostFilesConnectionWhere>;
  /** Return Posts where none of the related PostFilesConnections match this filter */
  filesConnection_NONE?: InputMaybe<PostFilesConnectionWhere>;
  /** Return Posts where one of the related PostFilesConnections match this filter */
  filesConnection_SINGLE?: InputMaybe<PostFilesConnectionWhere>;
  /** Return Posts where some of the related PostFilesConnections match this filter */
  filesConnection_SOME?: InputMaybe<PostFilesConnectionWhere>;
  /** Return Posts where all of the related Files match this filter */
  files_ALL?: InputMaybe<FileWhere>;
  /** Return Posts where none of the related Files match this filter */
  files_NONE?: InputMaybe<FileWhere>;
  /** Return Posts where one of the related Files match this filter */
  files_SINGLE?: InputMaybe<FileWhere>;
  /** Return Posts where some of the related Files match this filter */
  files_SOME?: InputMaybe<FileWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lastModified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  message_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  message_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  message_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  message_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  repliesAggregate?: InputMaybe<PostRepliesAggregateInput>;
  /** Return Posts where all of the related PostRepliesConnections match this filter */
  repliesConnection_ALL?: InputMaybe<PostRepliesConnectionWhere>;
  /** Return Posts where none of the related PostRepliesConnections match this filter */
  repliesConnection_NONE?: InputMaybe<PostRepliesConnectionWhere>;
  /** Return Posts where one of the related PostRepliesConnections match this filter */
  repliesConnection_SINGLE?: InputMaybe<PostRepliesConnectionWhere>;
  /** Return Posts where some of the related PostRepliesConnections match this filter */
  repliesConnection_SOME?: InputMaybe<PostRepliesConnectionWhere>;
  /** Return Posts where all of the related Posts match this filter */
  replies_ALL?: InputMaybe<PostWhere>;
  /** Return Posts where none of the related Posts match this filter */
  replies_NONE?: InputMaybe<PostWhere>;
  /** Return Posts where one of the related Posts match this filter */
  replies_SINGLE?: InputMaybe<PostWhere>;
  /** Return Posts where some of the related Posts match this filter */
  replies_SOME?: InputMaybe<PostWhere>;
  replyTo?: InputMaybe<PostWhere>;
  replyToAggregate?: InputMaybe<PostReplyToAggregateInput>;
  replyToConnection?: InputMaybe<PostReplyToConnectionWhere>;
  replyToConnection_NOT?: InputMaybe<PostReplyToConnectionWhere>;
  replyTo_NOT?: InputMaybe<PostWhere>;
  thread?: InputMaybe<ThreadWhere>;
  threadAggregate?: InputMaybe<PostThreadAggregateInput>;
  threadConnection?: InputMaybe<PostThreadConnectionWhere>;
  threadConnection_NOT?: InputMaybe<PostThreadConnectionWhere>;
  threadId?: InputMaybe<Scalars['String']['input']>;
  threadId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  threadId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  threadId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  threadId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  thread_NOT?: InputMaybe<ThreadWhere>;
};

export type Preferences = {
  __typename?: 'Preferences';
  contentType?: Maybe<Scalars['String']['output']>;
  language: Scalars['String']['output'];
  learningDuration?: Maybe<Scalars['Int']['output']>;
  learningStyle?: Maybe<Scalars['String']['output']>;
  notificationPreferences?: Maybe<Scalars['String']['output']>;
  timeOfDay?: Maybe<Scalars['String']['output']>;
  usersHasPreferences: Array<User>;
  usersHasPreferencesAggregate?: Maybe<PreferencesUserUsersHasPreferencesAggregationSelection>;
  usersHasPreferencesConnection: PreferencesUsersHasPreferencesConnection;
};


export type PreferencesUsersHasPreferencesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type PreferencesUsersHasPreferencesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type PreferencesUsersHasPreferencesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PreferencesUsersHasPreferencesConnectionSort>>;
  where?: InputMaybe<PreferencesUsersHasPreferencesConnectionWhere>;
};

export type PreferencesConnectInput = {
  usersHasPreferences?: InputMaybe<Array<PreferencesUsersHasPreferencesConnectFieldInput>>;
};

export type PreferencesConnectWhere = {
  node: PreferencesWhere;
};

export type PreferencesCreateInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  learningDuration?: InputMaybe<Scalars['Int']['input']>;
  learningStyle?: InputMaybe<Scalars['String']['input']>;
  notificationPreferences?: InputMaybe<Scalars['String']['input']>;
  timeOfDay?: InputMaybe<Scalars['String']['input']>;
  usersHasPreferences?: InputMaybe<PreferencesUsersHasPreferencesFieldInput>;
};

export type PreferencesDeleteInput = {
  usersHasPreferences?: InputMaybe<Array<PreferencesUsersHasPreferencesDeleteFieldInput>>;
};

export type PreferencesDisconnectInput = {
  usersHasPreferences?: InputMaybe<Array<PreferencesUsersHasPreferencesDisconnectFieldInput>>;
};

export type PreferencesOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PreferencesSort objects to sort Preferences by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PreferencesSort>>;
};

/** Fields to sort Preferences by. The order in which sorts are applied is not guaranteed when specifying many fields in one PreferencesSort object. */
export type PreferencesSort = {
  contentType?: InputMaybe<SortDirection>;
  language?: InputMaybe<SortDirection>;
  learningDuration?: InputMaybe<SortDirection>;
  learningStyle?: InputMaybe<SortDirection>;
  notificationPreferences?: InputMaybe<SortDirection>;
  timeOfDay?: InputMaybe<SortDirection>;
};

export type PreferencesUpdateInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  learningDuration?: InputMaybe<Scalars['Int']['input']>;
  learningDuration_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  learningDuration_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  learningStyle?: InputMaybe<Scalars['String']['input']>;
  notificationPreferences?: InputMaybe<Scalars['String']['input']>;
  timeOfDay?: InputMaybe<Scalars['String']['input']>;
  usersHasPreferences?: InputMaybe<Array<PreferencesUsersHasPreferencesUpdateFieldInput>>;
};

export type PreferencesUserUsersHasPreferencesAggregationSelection = {
  __typename?: 'PreferencesUserUsersHasPreferencesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<PreferencesUserUsersHasPreferencesNodeAggregateSelection>;
};

export type PreferencesUserUsersHasPreferencesNodeAggregateSelection = {
  __typename?: 'PreferencesUserUsersHasPreferencesNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type PreferencesUsersHasPreferencesAggregateInput = {
  AND?: InputMaybe<Array<PreferencesUsersHasPreferencesAggregateInput>>;
  NOT?: InputMaybe<PreferencesUsersHasPreferencesAggregateInput>;
  OR?: InputMaybe<Array<PreferencesUsersHasPreferencesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PreferencesUsersHasPreferencesNodeAggregationWhereInput>;
};

export type PreferencesUsersHasPreferencesConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type PreferencesUsersHasPreferencesConnectOrCreateFieldInput = {
  onCreate: PreferencesUsersHasPreferencesConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type PreferencesUsersHasPreferencesConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type PreferencesUsersHasPreferencesConnection = {
  __typename?: 'PreferencesUsersHasPreferencesConnection';
  edges: Array<PreferencesUsersHasPreferencesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PreferencesUsersHasPreferencesConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type PreferencesUsersHasPreferencesConnectionWhere = {
  AND?: InputMaybe<Array<PreferencesUsersHasPreferencesConnectionWhere>>;
  NOT?: InputMaybe<PreferencesUsersHasPreferencesConnectionWhere>;
  OR?: InputMaybe<Array<PreferencesUsersHasPreferencesConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type PreferencesUsersHasPreferencesCreateFieldInput = {
  node: UserCreateInput;
};

export type PreferencesUsersHasPreferencesDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<PreferencesUsersHasPreferencesConnectionWhere>;
};

export type PreferencesUsersHasPreferencesDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<PreferencesUsersHasPreferencesConnectionWhere>;
};

export type PreferencesUsersHasPreferencesFieldInput = {
  connect?: InputMaybe<Array<PreferencesUsersHasPreferencesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<PreferencesUsersHasPreferencesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<PreferencesUsersHasPreferencesCreateFieldInput>>;
};

export type PreferencesUsersHasPreferencesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PreferencesUsersHasPreferencesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PreferencesUsersHasPreferencesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PreferencesUsersHasPreferencesNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PreferencesUsersHasPreferencesRelationship = {
  __typename?: 'PreferencesUsersHasPreferencesRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type PreferencesUsersHasPreferencesUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type PreferencesUsersHasPreferencesUpdateFieldInput = {
  connect?: InputMaybe<Array<PreferencesUsersHasPreferencesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<PreferencesUsersHasPreferencesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<PreferencesUsersHasPreferencesCreateFieldInput>>;
  delete?: InputMaybe<Array<PreferencesUsersHasPreferencesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<PreferencesUsersHasPreferencesDisconnectFieldInput>>;
  update?: InputMaybe<PreferencesUsersHasPreferencesUpdateConnectionInput>;
  where?: InputMaybe<PreferencesUsersHasPreferencesConnectionWhere>;
};

export type PreferencesWhere = {
  AND?: InputMaybe<Array<PreferencesWhere>>;
  NOT?: InputMaybe<PreferencesWhere>;
  OR?: InputMaybe<Array<PreferencesWhere>>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  contentType_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  contentType_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  contentType_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentType_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  language_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  language_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  language_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  language_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  learningDuration?: InputMaybe<Scalars['Int']['input']>;
  learningDuration_GT?: InputMaybe<Scalars['Int']['input']>;
  learningDuration_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningDuration_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  learningDuration_LT?: InputMaybe<Scalars['Int']['input']>;
  learningDuration_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningStyle?: InputMaybe<Scalars['String']['input']>;
  learningStyle_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  learningStyle_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  learningStyle_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  learningStyle_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  notificationPreferences?: InputMaybe<Scalars['String']['input']>;
  notificationPreferences_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  notificationPreferences_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  notificationPreferences_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notificationPreferences_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  timeOfDay?: InputMaybe<Scalars['String']['input']>;
  timeOfDay_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  timeOfDay_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  timeOfDay_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeOfDay_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  usersHasPreferencesAggregate?: InputMaybe<PreferencesUsersHasPreferencesAggregateInput>;
  /** Return Preferences where all of the related PreferencesUsersHasPreferencesConnections match this filter */
  usersHasPreferencesConnection_ALL?: InputMaybe<PreferencesUsersHasPreferencesConnectionWhere>;
  /** Return Preferences where none of the related PreferencesUsersHasPreferencesConnections match this filter */
  usersHasPreferencesConnection_NONE?: InputMaybe<PreferencesUsersHasPreferencesConnectionWhere>;
  /** Return Preferences where one of the related PreferencesUsersHasPreferencesConnections match this filter */
  usersHasPreferencesConnection_SINGLE?: InputMaybe<PreferencesUsersHasPreferencesConnectionWhere>;
  /** Return Preferences where some of the related PreferencesUsersHasPreferencesConnections match this filter */
  usersHasPreferencesConnection_SOME?: InputMaybe<PreferencesUsersHasPreferencesConnectionWhere>;
  /** Return Preferences where all of the related Users match this filter */
  usersHasPreferences_ALL?: InputMaybe<UserWhere>;
  /** Return Preferences where none of the related Users match this filter */
  usersHasPreferences_NONE?: InputMaybe<UserWhere>;
  /** Return Preferences where one of the related Users match this filter */
  usersHasPreferences_SINGLE?: InputMaybe<UserWhere>;
  /** Return Preferences where some of the related Users match this filter */
  usersHasPreferences_SOME?: InputMaybe<UserWhere>;
};

export type Prerequisite = {
  __typename?: 'Prerequisite';
  field?: Maybe<Scalars['String']['output']>;
  mastery?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subfield?: Maybe<Scalars['String']['output']>;
};

export type PreviewMcqQuestion = {
  __typename?: 'PreviewMcqQuestion';
  aiTutorId?: Maybe<Scalars['ID']['output']>;
  choices: Array<Scalars['String']['output']>;
  correctChoiceIndices: Array<Scalars['Int']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  question: Scalars['String']['output'];
  totalScore?: Maybe<Scalars['Float']['output']>;
};

export type PreviewSocraticQuestion = {
  __typename?: 'PreviewSocraticQuestion';
  aiTutorId: Scalars['ID']['output'];
  question: Scalars['String']['output'];
  rubrics: Array<SocraticQuestionRubric>;
  totalScore?: Maybe<Scalars['Float']['output']>;
};

export enum Priority {
  Critical = 'CRITICAL',
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type Progress = {
  __typename?: 'Progress';
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ProgressConnectWhere = {
  node: ProgressWhere;
};

export type ProgressCreateInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ProgressDetails = {
  __typename?: 'ProgressDetails';
  ai_messages_count?: Maybe<Scalars['Int']['output']>;
  average_ai_response_time?: Maybe<Scalars['Float']['output']>;
  average_student_question_complexity?: Maybe<Scalars['String']['output']>;
  average_student_response_time?: Maybe<Scalars['Float']['output']>;
  confusion_points?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  distractions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  further_recommendations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  level?: Maybe<Scalars['String']['output']>;
  num_messages?: Maybe<Scalars['Int']['output']>;
  originality_analysis?: Maybe<Scalars['String']['output']>;
  questions_asked?: Maybe<Scalars['Int']['output']>;
  sentiment_analysis?: Maybe<Scalars['String']['output']>;
  student_messages_count?: Maybe<Scalars['Int']['output']>;
  success_points?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  summary?: Maybe<Scalars['String']['output']>;
  total_time_taken?: Maybe<Scalars['Float']['output']>;
};

export enum ProgressEventType {
  ActivityCompleted = 'ActivityCompleted',
  CourseCompleted = 'CourseCompleted',
  ModuleCompleted = 'ModuleCompleted',
  ObjectiveCompleted = 'ObjectiveCompleted'
}

export type ProgressOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ProgressSort objects to sort Progresses by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ProgressSort>>;
};

/** Fields to sort Progresses by. The order in which sorts are applied is not guaranteed when specifying many fields in one ProgressSort object. */
export type ProgressSort = {
  date?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  level?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export type ProgressUpdateInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  id_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ProgressWhere = {
  AND?: InputMaybe<Array<ProgressWhere>>;
  NOT?: InputMaybe<ProgressWhere>;
  OR?: InputMaybe<Array<ProgressWhere>>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  date_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_GT?: InputMaybe<Scalars['Int']['input']>;
  id_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LTE?: InputMaybe<Scalars['Int']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  level_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  level_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  level_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  level_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  type_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type Project = {
  __typename?: 'Project';
  activityState?: Maybe<ActivityState>;
  assessmentCriteria?: Maybe<Array<Scalars['String']['output']>>;
  created?: Maybe<Scalars['DateTime']['output']>;
  deliverableTypes?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  expectedOutcomes?: Maybe<Array<Scalars['String']['output']>>;
  files: Array<File>;
  filesAggregate?: Maybe<ProjectFileFilesAggregationSelection>;
  filesConnection: ProjectFilesConnection;
  id: Scalars['ID']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  module: Module;
  moduleAggregate?: Maybe<ProjectModuleModuleAggregationSelection>;
  moduleConnection: ProjectModuleConnection;
  moduleId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nudgesAboutThis: Array<Nudge>;
  nudgesAboutThisAggregate?: Maybe<ProjectNudgeNudgesAboutThisAggregationSelection>;
  nudgesAboutThisConnection: ProjectNudgesAboutThisConnection;
  order: Scalars['Int']['output'];
  scheduledDate?: Maybe<Scalars['DateTime']['output']>;
  scopeDocument?: Maybe<Scalars['String']['output']>;
  status: ProjectStatus;
  submissions: Array<ProjectSubmission>;
  submissionsAggregate?: Maybe<ProjectProjectSubmissionSubmissionsAggregationSelection>;
  submissionsConnection: ProjectSubmissionsConnection;
};


export type ProjectFilesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FileOptions>;
  where?: InputMaybe<FileWhere>;
};


export type ProjectFilesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FileWhere>;
};


export type ProjectFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProjectFilesConnectionSort>>;
  where?: InputMaybe<ProjectFilesConnectionWhere>;
};


export type ProjectModuleArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ModuleOptions>;
  where?: InputMaybe<ModuleWhere>;
};


export type ProjectModuleAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ModuleWhere>;
};


export type ProjectModuleConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProjectModuleConnectionSort>>;
  where?: InputMaybe<ProjectModuleConnectionWhere>;
};


export type ProjectNudgesAboutThisArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<NudgeOptions>;
  where?: InputMaybe<NudgeWhere>;
};


export type ProjectNudgesAboutThisAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NudgeWhere>;
};


export type ProjectNudgesAboutThisConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProjectNudgesAboutThisConnectionSort>>;
  where?: InputMaybe<ProjectNudgesAboutThisConnectionWhere>;
};


export type ProjectSubmissionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProjectSubmissionOptions>;
  where?: InputMaybe<ProjectSubmissionWhere>;
};


export type ProjectSubmissionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProjectSubmissionWhere>;
};


export type ProjectSubmissionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProjectSubmissionsConnectionSort>>;
  where?: InputMaybe<ProjectSubmissionsConnectionWhere>;
};

export type ProjectConnectInput = {
  files?: InputMaybe<Array<ProjectFilesConnectFieldInput>>;
  module?: InputMaybe<ProjectModuleConnectFieldInput>;
  nudgesAboutThis?: InputMaybe<Array<ProjectNudgesAboutThisConnectFieldInput>>;
  submissions?: InputMaybe<Array<ProjectSubmissionsConnectFieldInput>>;
};

export type ProjectConnectOrCreateWhere = {
  node: ProjectUniqueWhere;
};

export type ProjectConnectWhere = {
  node: ProjectWhere;
};

export type ProjectCreateInput = {
  activityState?: InputMaybe<ActivityState>;
  assessmentCriteria?: InputMaybe<Array<Scalars['String']['input']>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  deliverableTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  expectedOutcomes?: InputMaybe<Array<Scalars['String']['input']>>;
  files?: InputMaybe<ProjectFilesFieldInput>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  module?: InputMaybe<ProjectModuleFieldInput>;
  moduleId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  nudgesAboutThis?: InputMaybe<ProjectNudgesAboutThisFieldInput>;
  order: Scalars['Int']['input'];
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  scopeDocument?: InputMaybe<Scalars['String']['input']>;
  status?: ProjectStatus;
  submissions?: InputMaybe<ProjectSubmissionsFieldInput>;
};

export type ProjectDeleteInput = {
  files?: InputMaybe<Array<ProjectFilesDeleteFieldInput>>;
  module?: InputMaybe<ProjectModuleDeleteFieldInput>;
  nudgesAboutThis?: InputMaybe<Array<ProjectNudgesAboutThisDeleteFieldInput>>;
  submissions?: InputMaybe<Array<ProjectSubmissionsDeleteFieldInput>>;
};

export type ProjectDisconnectInput = {
  files?: InputMaybe<Array<ProjectFilesDisconnectFieldInput>>;
  module?: InputMaybe<ProjectModuleDisconnectFieldInput>;
  nudgesAboutThis?: InputMaybe<Array<ProjectNudgesAboutThisDisconnectFieldInput>>;
  submissions?: InputMaybe<Array<ProjectSubmissionsDisconnectFieldInput>>;
};

export type ProjectFileFilesAggregationSelection = {
  __typename?: 'ProjectFileFilesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ProjectFileFilesNodeAggregateSelection>;
};

export type ProjectFileFilesNodeAggregateSelection = {
  __typename?: 'ProjectFileFilesNodeAggregateSelection';
  bucketName: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  fileName: StringAggregateSelection;
  filePath: StringAggregateSelection;
  fileURL: StringAggregateSelection;
  id: IdAggregateSelection;
};

export type ProjectFilesAggregateInput = {
  AND?: InputMaybe<Array<ProjectFilesAggregateInput>>;
  NOT?: InputMaybe<ProjectFilesAggregateInput>;
  OR?: InputMaybe<Array<ProjectFilesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ProjectFilesNodeAggregationWhereInput>;
};

export type ProjectFilesConnectFieldInput = {
  connect?: InputMaybe<Array<FileConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FileConnectWhere>;
};

export type ProjectFilesConnectOrCreateFieldInput = {
  onCreate: ProjectFilesConnectOrCreateFieldInputOnCreate;
  where: FileConnectOrCreateWhere;
};

export type ProjectFilesConnectOrCreateFieldInputOnCreate = {
  node: FileOnCreateInput;
};

export type ProjectFilesConnection = {
  __typename?: 'ProjectFilesConnection';
  edges: Array<ProjectFilesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProjectFilesConnectionSort = {
  node?: InputMaybe<FileSort>;
};

export type ProjectFilesConnectionWhere = {
  AND?: InputMaybe<Array<ProjectFilesConnectionWhere>>;
  NOT?: InputMaybe<ProjectFilesConnectionWhere>;
  OR?: InputMaybe<Array<ProjectFilesConnectionWhere>>;
  node?: InputMaybe<FileWhere>;
};

export type ProjectFilesCreateFieldInput = {
  node: FileCreateInput;
};

export type ProjectFilesDeleteFieldInput = {
  delete?: InputMaybe<FileDeleteInput>;
  where?: InputMaybe<ProjectFilesConnectionWhere>;
};

export type ProjectFilesDisconnectFieldInput = {
  disconnect?: InputMaybe<FileDisconnectInput>;
  where?: InputMaybe<ProjectFilesConnectionWhere>;
};

export type ProjectFilesFieldInput = {
  connect?: InputMaybe<Array<ProjectFilesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectFilesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ProjectFilesCreateFieldInput>>;
};

export type ProjectFilesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProjectFilesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProjectFilesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProjectFilesNodeAggregationWhereInput>>;
  bucketName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  bucketName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  fileName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileURL_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectFilesRelationship = {
  __typename?: 'ProjectFilesRelationship';
  cursor: Scalars['String']['output'];
  node: File;
};

export type ProjectFilesUpdateConnectionInput = {
  node?: InputMaybe<FileUpdateInput>;
};

export type ProjectFilesUpdateFieldInput = {
  connect?: InputMaybe<Array<ProjectFilesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectFilesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ProjectFilesCreateFieldInput>>;
  delete?: InputMaybe<Array<ProjectFilesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProjectFilesDisconnectFieldInput>>;
  update?: InputMaybe<ProjectFilesUpdateConnectionInput>;
  where?: InputMaybe<ProjectFilesConnectionWhere>;
};

export type ProjectModuleAggregateInput = {
  AND?: InputMaybe<Array<ProjectModuleAggregateInput>>;
  NOT?: InputMaybe<ProjectModuleAggregateInput>;
  OR?: InputMaybe<Array<ProjectModuleAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ProjectModuleNodeAggregationWhereInput>;
};

export type ProjectModuleConnectFieldInput = {
  connect?: InputMaybe<ModuleConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ModuleConnectWhere>;
};

export type ProjectModuleConnectOrCreateFieldInput = {
  onCreate: ProjectModuleConnectOrCreateFieldInputOnCreate;
  where: ModuleConnectOrCreateWhere;
};

export type ProjectModuleConnectOrCreateFieldInputOnCreate = {
  node: ModuleOnCreateInput;
};

export type ProjectModuleConnection = {
  __typename?: 'ProjectModuleConnection';
  edges: Array<ProjectModuleRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProjectModuleConnectionSort = {
  node?: InputMaybe<ModuleSort>;
};

export type ProjectModuleConnectionWhere = {
  AND?: InputMaybe<Array<ProjectModuleConnectionWhere>>;
  NOT?: InputMaybe<ProjectModuleConnectionWhere>;
  OR?: InputMaybe<Array<ProjectModuleConnectionWhere>>;
  node?: InputMaybe<ModuleWhere>;
};

export type ProjectModuleCreateFieldInput = {
  node: ModuleCreateInput;
};

export type ProjectModuleDeleteFieldInput = {
  delete?: InputMaybe<ModuleDeleteInput>;
  where?: InputMaybe<ProjectModuleConnectionWhere>;
};

export type ProjectModuleDisconnectFieldInput = {
  disconnect?: InputMaybe<ModuleDisconnectInput>;
  where?: InputMaybe<ProjectModuleConnectionWhere>;
};

export type ProjectModuleFieldInput = {
  connect?: InputMaybe<ProjectModuleConnectFieldInput>;
  connectOrCreate?: InputMaybe<ProjectModuleConnectOrCreateFieldInput>;
  create?: InputMaybe<ProjectModuleCreateFieldInput>;
};

export type ProjectModuleModuleAggregationSelection = {
  __typename?: 'ProjectModuleModuleAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ProjectModuleModuleNodeAggregateSelection>;
};

export type ProjectModuleModuleNodeAggregateSelection = {
  __typename?: 'ProjectModuleModuleNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  module_name: StringAggregateSelection;
  thumbnail: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type ProjectModuleNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProjectModuleNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProjectModuleNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProjectModuleNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  module_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  module_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectModuleRelationship = {
  __typename?: 'ProjectModuleRelationship';
  cursor: Scalars['String']['output'];
  node: Module;
};

export type ProjectModuleUpdateConnectionInput = {
  node?: InputMaybe<ModuleUpdateInput>;
};

export type ProjectModuleUpdateFieldInput = {
  connect?: InputMaybe<ProjectModuleConnectFieldInput>;
  connectOrCreate?: InputMaybe<ProjectModuleConnectOrCreateFieldInput>;
  create?: InputMaybe<ProjectModuleCreateFieldInput>;
  delete?: InputMaybe<ProjectModuleDeleteFieldInput>;
  disconnect?: InputMaybe<ProjectModuleDisconnectFieldInput>;
  update?: InputMaybe<ProjectModuleUpdateConnectionInput>;
  where?: InputMaybe<ProjectModuleConnectionWhere>;
};

export type ProjectNudgeNudgesAboutThisAggregationSelection = {
  __typename?: 'ProjectNudgeNudgesAboutThisAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ProjectNudgeNudgesAboutThisNodeAggregateSelection>;
};

export type ProjectNudgeNudgesAboutThisNodeAggregateSelection = {
  __typename?: 'ProjectNudgeNudgesAboutThisNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  idempotencyKey: StringAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  priorityScore: FloatAggregateSelection;
  scheduledFor: DateTimeAggregateSelection;
  snoozedUntil: DateTimeAggregateSelection;
  taskCompletedAt: DateTimeAggregateSelection;
};

export type ProjectNudgesAboutThisAggregateInput = {
  AND?: InputMaybe<Array<ProjectNudgesAboutThisAggregateInput>>;
  NOT?: InputMaybe<ProjectNudgesAboutThisAggregateInput>;
  OR?: InputMaybe<Array<ProjectNudgesAboutThisAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ProjectNudgesAboutThisNodeAggregationWhereInput>;
};

export type ProjectNudgesAboutThisConnectFieldInput = {
  connect?: InputMaybe<Array<NudgeConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<NudgeConnectWhere>;
};

export type ProjectNudgesAboutThisConnectOrCreateFieldInput = {
  onCreate: ProjectNudgesAboutThisConnectOrCreateFieldInputOnCreate;
  where: NudgeConnectOrCreateWhere;
};

export type ProjectNudgesAboutThisConnectOrCreateFieldInputOnCreate = {
  node: NudgeOnCreateInput;
};

export type ProjectNudgesAboutThisConnection = {
  __typename?: 'ProjectNudgesAboutThisConnection';
  edges: Array<ProjectNudgesAboutThisRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProjectNudgesAboutThisConnectionSort = {
  node?: InputMaybe<NudgeSort>;
};

export type ProjectNudgesAboutThisConnectionWhere = {
  AND?: InputMaybe<Array<ProjectNudgesAboutThisConnectionWhere>>;
  NOT?: InputMaybe<ProjectNudgesAboutThisConnectionWhere>;
  OR?: InputMaybe<Array<ProjectNudgesAboutThisConnectionWhere>>;
  node?: InputMaybe<NudgeWhere>;
};

export type ProjectNudgesAboutThisCreateFieldInput = {
  node: NudgeCreateInput;
};

export type ProjectNudgesAboutThisDeleteFieldInput = {
  delete?: InputMaybe<NudgeDeleteInput>;
  where?: InputMaybe<ProjectNudgesAboutThisConnectionWhere>;
};

export type ProjectNudgesAboutThisDisconnectFieldInput = {
  disconnect?: InputMaybe<NudgeDisconnectInput>;
  where?: InputMaybe<ProjectNudgesAboutThisConnectionWhere>;
};

export type ProjectNudgesAboutThisFieldInput = {
  connect?: InputMaybe<Array<ProjectNudgesAboutThisConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectNudgesAboutThisConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ProjectNudgesAboutThisCreateFieldInput>>;
};

export type ProjectNudgesAboutThisNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProjectNudgesAboutThisNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProjectNudgesAboutThisNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProjectNudgesAboutThisNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  idempotencyKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  priorityScore_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  scheduledFor_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProjectNudgesAboutThisRelationship = {
  __typename?: 'ProjectNudgesAboutThisRelationship';
  cursor: Scalars['String']['output'];
  node: Nudge;
};

export type ProjectNudgesAboutThisUpdateConnectionInput = {
  node?: InputMaybe<NudgeUpdateInput>;
};

export type ProjectNudgesAboutThisUpdateFieldInput = {
  connect?: InputMaybe<Array<ProjectNudgesAboutThisConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectNudgesAboutThisConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ProjectNudgesAboutThisCreateFieldInput>>;
  delete?: InputMaybe<Array<ProjectNudgesAboutThisDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProjectNudgesAboutThisDisconnectFieldInput>>;
  update?: InputMaybe<ProjectNudgesAboutThisUpdateConnectionInput>;
  where?: InputMaybe<ProjectNudgesAboutThisConnectionWhere>;
};

export type ProjectOnCreateInput = {
  activityState?: InputMaybe<ActivityState>;
  assessmentCriteria?: InputMaybe<Array<Scalars['String']['input']>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  deliverableTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  expectedOutcomes?: InputMaybe<Array<Scalars['String']['input']>>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  moduleId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  scopeDocument?: InputMaybe<Scalars['String']['input']>;
  status?: ProjectStatus;
};

export type ProjectOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ProjectSort objects to sort Projects by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ProjectSort>>;
};

export type ProjectProjectSubmissionSubmissionsAggregationSelection = {
  __typename?: 'ProjectProjectSubmissionSubmissionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ProjectProjectSubmissionSubmissionsNodeAggregateSelection>;
};

export type ProjectProjectSubmissionSubmissionsNodeAggregateSelection = {
  __typename?: 'ProjectProjectSubmissionSubmissionsNodeAggregateSelection';
  aiAssessment: StringAggregateSelection;
  approachMethodology: StringAggregateSelection;
  completedAt: DateTimeAggregateSelection;
  completedTasks: IntAggregateSelection;
  complianceScore: FloatAggregateSelection;
  created: DateTimeAggregateSelection;
  feedback: StringAggregateSelection;
  grade: FloatAggregateSelection;
  gradedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  proposal: StringAggregateSelection;
  scopeJustification: StringAggregateSelection;
  submissionLink: StringAggregateSelection;
  submissionNotes: StringAggregateSelection;
  totalTasks: IntAggregateSelection;
};

export type ProjectRequirement = {
  __typename?: 'ProjectRequirement';
  aiRationale?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  completed: Scalars['Boolean']['output'];
  completedDate?: Maybe<Scalars['DateTime']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  dependencies?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  estimatedHours?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isGenerated: Scalars['Boolean']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  nudgesAboutThis: Array<Nudge>;
  nudgesAboutThisAggregate?: Maybe<ProjectRequirementNudgeNudgesAboutThisAggregationSelection>;
  nudgesAboutThisConnection: ProjectRequirementNudgesAboutThisConnection;
  order: Scalars['Int']['output'];
  priority: Priority;
  submission: ProjectSubmission;
  submissionAggregate?: Maybe<ProjectRequirementProjectSubmissionSubmissionAggregationSelection>;
  submissionConnection: ProjectRequirementSubmissionConnection;
  title: Scalars['String']['output'];
  type: RequirementType;
};


export type ProjectRequirementNudgesAboutThisArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<NudgeOptions>;
  where?: InputMaybe<NudgeWhere>;
};


export type ProjectRequirementNudgesAboutThisAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NudgeWhere>;
};


export type ProjectRequirementNudgesAboutThisConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProjectRequirementNudgesAboutThisConnectionSort>>;
  where?: InputMaybe<ProjectRequirementNudgesAboutThisConnectionWhere>;
};


export type ProjectRequirementSubmissionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProjectSubmissionOptions>;
  where?: InputMaybe<ProjectSubmissionWhere>;
};


export type ProjectRequirementSubmissionAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProjectSubmissionWhere>;
};


export type ProjectRequirementSubmissionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProjectRequirementSubmissionConnectionSort>>;
  where?: InputMaybe<ProjectRequirementSubmissionConnectionWhere>;
};

export type ProjectRequirementConnectInput = {
  nudgesAboutThis?: InputMaybe<Array<ProjectRequirementNudgesAboutThisConnectFieldInput>>;
  submission?: InputMaybe<ProjectRequirementSubmissionConnectFieldInput>;
};

export type ProjectRequirementConnectOrCreateWhere = {
  node: ProjectRequirementUniqueWhere;
};

export type ProjectRequirementConnectWhere = {
  node: ProjectRequirementWhere;
};

export type ProjectRequirementCreateInput = {
  aiRationale?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  completed?: Scalars['Boolean']['input'];
  completedDate?: InputMaybe<Scalars['DateTime']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  dependencies?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  estimatedHours?: InputMaybe<Scalars['Int']['input']>;
  isGenerated?: Scalars['Boolean']['input'];
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  nudgesAboutThis?: InputMaybe<ProjectRequirementNudgesAboutThisFieldInput>;
  order: Scalars['Int']['input'];
  priority?: Priority;
  submission?: InputMaybe<ProjectRequirementSubmissionFieldInput>;
  title: Scalars['String']['input'];
  type?: RequirementType;
};

export type ProjectRequirementDeleteInput = {
  nudgesAboutThis?: InputMaybe<Array<ProjectRequirementNudgesAboutThisDeleteFieldInput>>;
  submission?: InputMaybe<ProjectRequirementSubmissionDeleteFieldInput>;
};

export type ProjectRequirementDisconnectInput = {
  nudgesAboutThis?: InputMaybe<Array<ProjectRequirementNudgesAboutThisDisconnectFieldInput>>;
  submission?: InputMaybe<ProjectRequirementSubmissionDisconnectFieldInput>;
};

export type ProjectRequirementNudgeNudgesAboutThisAggregationSelection = {
  __typename?: 'ProjectRequirementNudgeNudgesAboutThisAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ProjectRequirementNudgeNudgesAboutThisNodeAggregateSelection>;
};

export type ProjectRequirementNudgeNudgesAboutThisNodeAggregateSelection = {
  __typename?: 'ProjectRequirementNudgeNudgesAboutThisNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  idempotencyKey: StringAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  priorityScore: FloatAggregateSelection;
  scheduledFor: DateTimeAggregateSelection;
  snoozedUntil: DateTimeAggregateSelection;
  taskCompletedAt: DateTimeAggregateSelection;
};

export type ProjectRequirementNudgesAboutThisAggregateInput = {
  AND?: InputMaybe<Array<ProjectRequirementNudgesAboutThisAggregateInput>>;
  NOT?: InputMaybe<ProjectRequirementNudgesAboutThisAggregateInput>;
  OR?: InputMaybe<Array<ProjectRequirementNudgesAboutThisAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ProjectRequirementNudgesAboutThisNodeAggregationWhereInput>;
};

export type ProjectRequirementNudgesAboutThisConnectFieldInput = {
  connect?: InputMaybe<Array<NudgeConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<NudgeConnectWhere>;
};

export type ProjectRequirementNudgesAboutThisConnectOrCreateFieldInput = {
  onCreate: ProjectRequirementNudgesAboutThisConnectOrCreateFieldInputOnCreate;
  where: NudgeConnectOrCreateWhere;
};

export type ProjectRequirementNudgesAboutThisConnectOrCreateFieldInputOnCreate = {
  node: NudgeOnCreateInput;
};

export type ProjectRequirementNudgesAboutThisConnection = {
  __typename?: 'ProjectRequirementNudgesAboutThisConnection';
  edges: Array<ProjectRequirementNudgesAboutThisRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProjectRequirementNudgesAboutThisConnectionSort = {
  node?: InputMaybe<NudgeSort>;
};

export type ProjectRequirementNudgesAboutThisConnectionWhere = {
  AND?: InputMaybe<Array<ProjectRequirementNudgesAboutThisConnectionWhere>>;
  NOT?: InputMaybe<ProjectRequirementNudgesAboutThisConnectionWhere>;
  OR?: InputMaybe<Array<ProjectRequirementNudgesAboutThisConnectionWhere>>;
  node?: InputMaybe<NudgeWhere>;
};

export type ProjectRequirementNudgesAboutThisCreateFieldInput = {
  node: NudgeCreateInput;
};

export type ProjectRequirementNudgesAboutThisDeleteFieldInput = {
  delete?: InputMaybe<NudgeDeleteInput>;
  where?: InputMaybe<ProjectRequirementNudgesAboutThisConnectionWhere>;
};

export type ProjectRequirementNudgesAboutThisDisconnectFieldInput = {
  disconnect?: InputMaybe<NudgeDisconnectInput>;
  where?: InputMaybe<ProjectRequirementNudgesAboutThisConnectionWhere>;
};

export type ProjectRequirementNudgesAboutThisFieldInput = {
  connect?: InputMaybe<Array<ProjectRequirementNudgesAboutThisConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectRequirementNudgesAboutThisConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ProjectRequirementNudgesAboutThisCreateFieldInput>>;
};

export type ProjectRequirementNudgesAboutThisNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProjectRequirementNudgesAboutThisNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProjectRequirementNudgesAboutThisNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProjectRequirementNudgesAboutThisNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  idempotencyKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  priorityScore_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  scheduledFor_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProjectRequirementNudgesAboutThisRelationship = {
  __typename?: 'ProjectRequirementNudgesAboutThisRelationship';
  cursor: Scalars['String']['output'];
  node: Nudge;
};

export type ProjectRequirementNudgesAboutThisUpdateConnectionInput = {
  node?: InputMaybe<NudgeUpdateInput>;
};

export type ProjectRequirementNudgesAboutThisUpdateFieldInput = {
  connect?: InputMaybe<Array<ProjectRequirementNudgesAboutThisConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectRequirementNudgesAboutThisConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ProjectRequirementNudgesAboutThisCreateFieldInput>>;
  delete?: InputMaybe<Array<ProjectRequirementNudgesAboutThisDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProjectRequirementNudgesAboutThisDisconnectFieldInput>>;
  update?: InputMaybe<ProjectRequirementNudgesAboutThisUpdateConnectionInput>;
  where?: InputMaybe<ProjectRequirementNudgesAboutThisConnectionWhere>;
};

export type ProjectRequirementOnCreateInput = {
  aiRationale?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  completed?: Scalars['Boolean']['input'];
  completedDate?: InputMaybe<Scalars['DateTime']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  dependencies?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  estimatedHours?: InputMaybe<Scalars['Int']['input']>;
  isGenerated?: Scalars['Boolean']['input'];
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  order: Scalars['Int']['input'];
  priority?: Priority;
  title: Scalars['String']['input'];
  type?: RequirementType;
};

export type ProjectRequirementOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ProjectRequirementSort objects to sort ProjectRequirements by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ProjectRequirementSort>>;
};

export type ProjectRequirementProjectSubmissionSubmissionAggregationSelection = {
  __typename?: 'ProjectRequirementProjectSubmissionSubmissionAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ProjectRequirementProjectSubmissionSubmissionNodeAggregateSelection>;
};

export type ProjectRequirementProjectSubmissionSubmissionNodeAggregateSelection = {
  __typename?: 'ProjectRequirementProjectSubmissionSubmissionNodeAggregateSelection';
  aiAssessment: StringAggregateSelection;
  approachMethodology: StringAggregateSelection;
  completedAt: DateTimeAggregateSelection;
  completedTasks: IntAggregateSelection;
  complianceScore: FloatAggregateSelection;
  created: DateTimeAggregateSelection;
  feedback: StringAggregateSelection;
  grade: FloatAggregateSelection;
  gradedAt: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  proposal: StringAggregateSelection;
  scopeJustification: StringAggregateSelection;
  submissionLink: StringAggregateSelection;
  submissionNotes: StringAggregateSelection;
  totalTasks: IntAggregateSelection;
};

export type ProjectRequirementResponse = {
  __typename?: 'ProjectRequirementResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<ProjectRequirement>>>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Fields to sort ProjectRequirements by. The order in which sorts are applied is not guaranteed when specifying many fields in one ProjectRequirementSort object. */
export type ProjectRequirementSort = {
  aiRationale?: InputMaybe<SortDirection>;
  category?: InputMaybe<SortDirection>;
  completed?: InputMaybe<SortDirection>;
  completedDate?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  dueDate?: InputMaybe<SortDirection>;
  estimatedHours?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isGenerated?: InputMaybe<SortDirection>;
  lastModified?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
  priority?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export type ProjectRequirementSubmissionAggregateInput = {
  AND?: InputMaybe<Array<ProjectRequirementSubmissionAggregateInput>>;
  NOT?: InputMaybe<ProjectRequirementSubmissionAggregateInput>;
  OR?: InputMaybe<Array<ProjectRequirementSubmissionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ProjectRequirementSubmissionNodeAggregationWhereInput>;
};

export type ProjectRequirementSubmissionConnectFieldInput = {
  connect?: InputMaybe<ProjectSubmissionConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ProjectSubmissionConnectWhere>;
};

export type ProjectRequirementSubmissionConnectOrCreateFieldInput = {
  onCreate: ProjectRequirementSubmissionConnectOrCreateFieldInputOnCreate;
  where: ProjectSubmissionConnectOrCreateWhere;
};

export type ProjectRequirementSubmissionConnectOrCreateFieldInputOnCreate = {
  node: ProjectSubmissionOnCreateInput;
};

export type ProjectRequirementSubmissionConnection = {
  __typename?: 'ProjectRequirementSubmissionConnection';
  edges: Array<ProjectRequirementSubmissionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProjectRequirementSubmissionConnectionSort = {
  node?: InputMaybe<ProjectSubmissionSort>;
};

export type ProjectRequirementSubmissionConnectionWhere = {
  AND?: InputMaybe<Array<ProjectRequirementSubmissionConnectionWhere>>;
  NOT?: InputMaybe<ProjectRequirementSubmissionConnectionWhere>;
  OR?: InputMaybe<Array<ProjectRequirementSubmissionConnectionWhere>>;
  node?: InputMaybe<ProjectSubmissionWhere>;
};

export type ProjectRequirementSubmissionCreateFieldInput = {
  node: ProjectSubmissionCreateInput;
};

export type ProjectRequirementSubmissionDeleteFieldInput = {
  delete?: InputMaybe<ProjectSubmissionDeleteInput>;
  where?: InputMaybe<ProjectRequirementSubmissionConnectionWhere>;
};

export type ProjectRequirementSubmissionDisconnectFieldInput = {
  disconnect?: InputMaybe<ProjectSubmissionDisconnectInput>;
  where?: InputMaybe<ProjectRequirementSubmissionConnectionWhere>;
};

export type ProjectRequirementSubmissionFieldInput = {
  connect?: InputMaybe<ProjectRequirementSubmissionConnectFieldInput>;
  connectOrCreate?: InputMaybe<ProjectRequirementSubmissionConnectOrCreateFieldInput>;
  create?: InputMaybe<ProjectRequirementSubmissionCreateFieldInput>;
};

export type ProjectRequirementSubmissionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProjectRequirementSubmissionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProjectRequirementSubmissionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProjectRequirementSubmissionNodeAggregationWhereInput>>;
  aiAssessment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiAssessment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aiAssessment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiAssessment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aiAssessment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aiAssessment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  approachMethodology_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  approachMethodology_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  approachMethodology_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  approachMethodology_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  approachMethodology_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  completedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedTasks_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  completedTasks_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  completedTasks_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  completedTasks_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  completedTasks_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  completedTasks_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  complianceScore_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  feedback_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  feedback_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  gradedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  proposal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  proposal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  proposal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  proposal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  proposal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  proposal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  proposal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  proposal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  proposal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  proposal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  proposal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  proposal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  proposal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  proposal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  proposal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scopeJustification_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scopeJustification_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scopeJustification_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scopeJustification_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scopeJustification_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submissionLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submissionLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submissionLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submissionLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  submissionLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submissionNotes_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submissionNotes_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submissionNotes_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submissionNotes_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  submissionNotes_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalTasks_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalTasks_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalTasks_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalTasks_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalTasks_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectRequirementSubmissionRelationship = {
  __typename?: 'ProjectRequirementSubmissionRelationship';
  cursor: Scalars['String']['output'];
  node: ProjectSubmission;
};

export type ProjectRequirementSubmissionUpdateConnectionInput = {
  node?: InputMaybe<ProjectSubmissionUpdateInput>;
};

export type ProjectRequirementSubmissionUpdateFieldInput = {
  connect?: InputMaybe<ProjectRequirementSubmissionConnectFieldInput>;
  connectOrCreate?: InputMaybe<ProjectRequirementSubmissionConnectOrCreateFieldInput>;
  create?: InputMaybe<ProjectRequirementSubmissionCreateFieldInput>;
  delete?: InputMaybe<ProjectRequirementSubmissionDeleteFieldInput>;
  disconnect?: InputMaybe<ProjectRequirementSubmissionDisconnectFieldInput>;
  update?: InputMaybe<ProjectRequirementSubmissionUpdateConnectionInput>;
  where?: InputMaybe<ProjectRequirementSubmissionConnectionWhere>;
};

export type ProjectRequirementUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ProjectRequirementUpdateInput = {
  aiRationale?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completedDate?: InputMaybe<Scalars['DateTime']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  dependencies?: InputMaybe<Array<Scalars['String']['input']>>;
  dependencies_POP?: InputMaybe<Scalars['Int']['input']>;
  dependencies_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  estimatedHours?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  isGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  nudgesAboutThis?: InputMaybe<Array<ProjectRequirementNudgesAboutThisUpdateFieldInput>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  order_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Priority>;
  submission?: InputMaybe<ProjectRequirementSubmissionUpdateFieldInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<RequirementType>;
};

export type ProjectRequirementWhere = {
  AND?: InputMaybe<Array<ProjectRequirementWhere>>;
  NOT?: InputMaybe<ProjectRequirementWhere>;
  OR?: InputMaybe<Array<ProjectRequirementWhere>>;
  aiRationale?: InputMaybe<Scalars['String']['input']>;
  aiRationale_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  aiRationale_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  aiRationale_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aiRationale_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  category_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  category_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  category_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completedDate?: InputMaybe<Scalars['DateTime']['input']>;
  completedDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  completedDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dependencies?: InputMaybe<Array<Scalars['String']['input']>>;
  dependencies_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  dueDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  estimatedHours?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_GT?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_GTE?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  estimatedHours_LT?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_LTE?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastModified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  nudgesAboutThisAggregate?: InputMaybe<ProjectRequirementNudgesAboutThisAggregateInput>;
  /** Return ProjectRequirements where all of the related ProjectRequirementNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_ALL?: InputMaybe<ProjectRequirementNudgesAboutThisConnectionWhere>;
  /** Return ProjectRequirements where none of the related ProjectRequirementNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_NONE?: InputMaybe<ProjectRequirementNudgesAboutThisConnectionWhere>;
  /** Return ProjectRequirements where one of the related ProjectRequirementNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_SINGLE?: InputMaybe<ProjectRequirementNudgesAboutThisConnectionWhere>;
  /** Return ProjectRequirements where some of the related ProjectRequirementNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_SOME?: InputMaybe<ProjectRequirementNudgesAboutThisConnectionWhere>;
  /** Return ProjectRequirements where all of the related Nudges match this filter */
  nudgesAboutThis_ALL?: InputMaybe<NudgeWhere>;
  /** Return ProjectRequirements where none of the related Nudges match this filter */
  nudgesAboutThis_NONE?: InputMaybe<NudgeWhere>;
  /** Return ProjectRequirements where one of the related Nudges match this filter */
  nudgesAboutThis_SINGLE?: InputMaybe<NudgeWhere>;
  /** Return ProjectRequirements where some of the related Nudges match this filter */
  nudgesAboutThis_SOME?: InputMaybe<NudgeWhere>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Priority>;
  priority_IN?: InputMaybe<Array<Priority>>;
  submission?: InputMaybe<ProjectSubmissionWhere>;
  submissionAggregate?: InputMaybe<ProjectRequirementSubmissionAggregateInput>;
  submissionConnection?: InputMaybe<ProjectRequirementSubmissionConnectionWhere>;
  submissionConnection_NOT?: InputMaybe<ProjectRequirementSubmissionConnectionWhere>;
  submission_NOT?: InputMaybe<ProjectSubmissionWhere>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<RequirementType>;
  type_IN?: InputMaybe<Array<RequirementType>>;
};

export type ProjectResponse = {
  __typename?: 'ProjectResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<Project>>>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Fields to sort Projects by. The order in which sorts are applied is not guaranteed when specifying many fields in one ProjectSort object. */
export type ProjectSort = {
  activityState?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  dueDate?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastModified?: InputMaybe<SortDirection>;
  moduleId?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
  scheduledDate?: InputMaybe<SortDirection>;
  scopeDocument?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
};

export enum ProjectStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type ProjectSubmission = {
  __typename?: 'ProjectSubmission';
  aiAssessment?: Maybe<Scalars['String']['output']>;
  approachMethodology?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedTasks?: Maybe<Scalars['Int']['output']>;
  complianceScore?: Maybe<Scalars['Float']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  expectedOutcomes?: Maybe<Array<Scalars['String']['output']>>;
  feedback?: Maybe<Scalars['String']['output']>;
  files: Array<File>;
  filesAggregate?: Maybe<ProjectSubmissionFileFilesAggregationSelection>;
  filesConnection: ProjectSubmissionFilesConnection;
  grade?: Maybe<Scalars['Float']['output']>;
  gradedAt?: Maybe<Scalars['DateTime']['output']>;
  hasTeacherGraded?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isCompleted?: Maybe<Scalars['Boolean']['output']>;
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  project: Project;
  projectAggregate?: Maybe<ProjectSubmissionProjectProjectAggregationSelection>;
  projectConnection: ProjectSubmissionProjectConnection;
  proposal: Scalars['String']['output'];
  requirements: Array<ProjectRequirement>;
  requirementsAggregate?: Maybe<ProjectSubmissionProjectRequirementRequirementsAggregationSelection>;
  requirementsConnection: ProjectSubmissionRequirementsConnection;
  scopeJustification?: Maybe<Scalars['String']['output']>;
  status: ProjectSubmissionStatus;
  submissionLink?: Maybe<Scalars['String']['output']>;
  submissionNotes?: Maybe<Scalars['String']['output']>;
  suggestedImprovements?: Maybe<Array<Scalars['String']['output']>>;
  totalTasks?: Maybe<Scalars['Int']['output']>;
  user: User;
  userAggregate?: Maybe<ProjectSubmissionUserUserAggregationSelection>;
  userConnection: ProjectSubmissionUserConnection;
  vettingStatus?: Maybe<ProjectVettingStatus>;
};


export type ProjectSubmissionFilesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FileOptions>;
  where?: InputMaybe<FileWhere>;
};


export type ProjectSubmissionFilesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FileWhere>;
};


export type ProjectSubmissionFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProjectSubmissionFilesConnectionSort>>;
  where?: InputMaybe<ProjectSubmissionFilesConnectionWhere>;
};


export type ProjectSubmissionProjectArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProjectOptions>;
  where?: InputMaybe<ProjectWhere>;
};


export type ProjectSubmissionProjectAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProjectWhere>;
};


export type ProjectSubmissionProjectConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProjectSubmissionProjectConnectionSort>>;
  where?: InputMaybe<ProjectSubmissionProjectConnectionWhere>;
};


export type ProjectSubmissionRequirementsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProjectRequirementOptions>;
  where?: InputMaybe<ProjectRequirementWhere>;
};


export type ProjectSubmissionRequirementsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProjectRequirementWhere>;
};


export type ProjectSubmissionRequirementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProjectSubmissionRequirementsConnectionSort>>;
  where?: InputMaybe<ProjectSubmissionRequirementsConnectionWhere>;
};


export type ProjectSubmissionUserArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type ProjectSubmissionUserAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type ProjectSubmissionUserConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProjectSubmissionUserConnectionSort>>;
  where?: InputMaybe<ProjectSubmissionUserConnectionWhere>;
};

export type ProjectSubmissionConnectInput = {
  files?: InputMaybe<Array<ProjectSubmissionFilesConnectFieldInput>>;
  project?: InputMaybe<ProjectSubmissionProjectConnectFieldInput>;
  requirements?: InputMaybe<Array<ProjectSubmissionRequirementsConnectFieldInput>>;
  user?: InputMaybe<ProjectSubmissionUserConnectFieldInput>;
};

export type ProjectSubmissionConnectOrCreateWhere = {
  node: ProjectSubmissionUniqueWhere;
};

export type ProjectSubmissionConnectWhere = {
  node: ProjectSubmissionWhere;
};

export type ProjectSubmissionCreateInput = {
  aiAssessment?: InputMaybe<Scalars['String']['input']>;
  approachMethodology?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedTasks?: InputMaybe<Scalars['Int']['input']>;
  complianceScore?: InputMaybe<Scalars['Float']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  expectedOutcomes?: InputMaybe<Array<Scalars['String']['input']>>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<ProjectSubmissionFilesFieldInput>;
  grade?: InputMaybe<Scalars['Float']['input']>;
  gradedAt?: InputMaybe<Scalars['DateTime']['input']>;
  hasTeacherGraded?: InputMaybe<Scalars['Boolean']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  project?: InputMaybe<ProjectSubmissionProjectFieldInput>;
  proposal: Scalars['String']['input'];
  requirements?: InputMaybe<ProjectSubmissionRequirementsFieldInput>;
  scopeJustification?: InputMaybe<Scalars['String']['input']>;
  status: ProjectSubmissionStatus;
  submissionLink?: InputMaybe<Scalars['String']['input']>;
  submissionNotes?: InputMaybe<Scalars['String']['input']>;
  suggestedImprovements?: InputMaybe<Array<Scalars['String']['input']>>;
  totalTasks?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<ProjectSubmissionUserFieldInput>;
  vettingStatus?: InputMaybe<ProjectVettingStatus>;
};

export type ProjectSubmissionDeleteInput = {
  files?: InputMaybe<Array<ProjectSubmissionFilesDeleteFieldInput>>;
  project?: InputMaybe<ProjectSubmissionProjectDeleteFieldInput>;
  requirements?: InputMaybe<Array<ProjectSubmissionRequirementsDeleteFieldInput>>;
  user?: InputMaybe<ProjectSubmissionUserDeleteFieldInput>;
};

export type ProjectSubmissionDisconnectInput = {
  files?: InputMaybe<Array<ProjectSubmissionFilesDisconnectFieldInput>>;
  project?: InputMaybe<ProjectSubmissionProjectDisconnectFieldInput>;
  requirements?: InputMaybe<Array<ProjectSubmissionRequirementsDisconnectFieldInput>>;
  user?: InputMaybe<ProjectSubmissionUserDisconnectFieldInput>;
};

export type ProjectSubmissionFileFilesAggregationSelection = {
  __typename?: 'ProjectSubmissionFileFilesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ProjectSubmissionFileFilesNodeAggregateSelection>;
};

export type ProjectSubmissionFileFilesNodeAggregateSelection = {
  __typename?: 'ProjectSubmissionFileFilesNodeAggregateSelection';
  bucketName: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  fileName: StringAggregateSelection;
  filePath: StringAggregateSelection;
  fileURL: StringAggregateSelection;
  id: IdAggregateSelection;
};

export type ProjectSubmissionFilesAggregateInput = {
  AND?: InputMaybe<Array<ProjectSubmissionFilesAggregateInput>>;
  NOT?: InputMaybe<ProjectSubmissionFilesAggregateInput>;
  OR?: InputMaybe<Array<ProjectSubmissionFilesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ProjectSubmissionFilesNodeAggregationWhereInput>;
};

export type ProjectSubmissionFilesConnectFieldInput = {
  connect?: InputMaybe<Array<FileConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FileConnectWhere>;
};

export type ProjectSubmissionFilesConnectOrCreateFieldInput = {
  onCreate: ProjectSubmissionFilesConnectOrCreateFieldInputOnCreate;
  where: FileConnectOrCreateWhere;
};

export type ProjectSubmissionFilesConnectOrCreateFieldInputOnCreate = {
  node: FileOnCreateInput;
};

export type ProjectSubmissionFilesConnection = {
  __typename?: 'ProjectSubmissionFilesConnection';
  edges: Array<ProjectSubmissionFilesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProjectSubmissionFilesConnectionSort = {
  node?: InputMaybe<FileSort>;
};

export type ProjectSubmissionFilesConnectionWhere = {
  AND?: InputMaybe<Array<ProjectSubmissionFilesConnectionWhere>>;
  NOT?: InputMaybe<ProjectSubmissionFilesConnectionWhere>;
  OR?: InputMaybe<Array<ProjectSubmissionFilesConnectionWhere>>;
  node?: InputMaybe<FileWhere>;
};

export type ProjectSubmissionFilesCreateFieldInput = {
  node: FileCreateInput;
};

export type ProjectSubmissionFilesDeleteFieldInput = {
  delete?: InputMaybe<FileDeleteInput>;
  where?: InputMaybe<ProjectSubmissionFilesConnectionWhere>;
};

export type ProjectSubmissionFilesDisconnectFieldInput = {
  disconnect?: InputMaybe<FileDisconnectInput>;
  where?: InputMaybe<ProjectSubmissionFilesConnectionWhere>;
};

export type ProjectSubmissionFilesFieldInput = {
  connect?: InputMaybe<Array<ProjectSubmissionFilesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectSubmissionFilesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ProjectSubmissionFilesCreateFieldInput>>;
};

export type ProjectSubmissionFilesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProjectSubmissionFilesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProjectSubmissionFilesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProjectSubmissionFilesNodeAggregationWhereInput>>;
  bucketName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  bucketName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  fileName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileURL_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectSubmissionFilesRelationship = {
  __typename?: 'ProjectSubmissionFilesRelationship';
  cursor: Scalars['String']['output'];
  node: File;
};

export type ProjectSubmissionFilesUpdateConnectionInput = {
  node?: InputMaybe<FileUpdateInput>;
};

export type ProjectSubmissionFilesUpdateFieldInput = {
  connect?: InputMaybe<Array<ProjectSubmissionFilesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectSubmissionFilesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ProjectSubmissionFilesCreateFieldInput>>;
  delete?: InputMaybe<Array<ProjectSubmissionFilesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProjectSubmissionFilesDisconnectFieldInput>>;
  update?: InputMaybe<ProjectSubmissionFilesUpdateConnectionInput>;
  where?: InputMaybe<ProjectSubmissionFilesConnectionWhere>;
};

export type ProjectSubmissionOnCreateInput = {
  aiAssessment?: InputMaybe<Scalars['String']['input']>;
  approachMethodology?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedTasks?: InputMaybe<Scalars['Int']['input']>;
  complianceScore?: InputMaybe<Scalars['Float']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  expectedOutcomes?: InputMaybe<Array<Scalars['String']['input']>>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Scalars['Float']['input']>;
  gradedAt?: InputMaybe<Scalars['DateTime']['input']>;
  hasTeacherGraded?: InputMaybe<Scalars['Boolean']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  proposal: Scalars['String']['input'];
  scopeJustification?: InputMaybe<Scalars['String']['input']>;
  status: ProjectSubmissionStatus;
  submissionLink?: InputMaybe<Scalars['String']['input']>;
  submissionNotes?: InputMaybe<Scalars['String']['input']>;
  suggestedImprovements?: InputMaybe<Array<Scalars['String']['input']>>;
  totalTasks?: InputMaybe<Scalars['Int']['input']>;
  vettingStatus?: InputMaybe<ProjectVettingStatus>;
};

export type ProjectSubmissionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ProjectSubmissionSort objects to sort ProjectSubmissions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ProjectSubmissionSort>>;
};

export type ProjectSubmissionProjectAggregateInput = {
  AND?: InputMaybe<Array<ProjectSubmissionProjectAggregateInput>>;
  NOT?: InputMaybe<ProjectSubmissionProjectAggregateInput>;
  OR?: InputMaybe<Array<ProjectSubmissionProjectAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ProjectSubmissionProjectNodeAggregationWhereInput>;
};

export type ProjectSubmissionProjectConnectFieldInput = {
  connect?: InputMaybe<ProjectConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ProjectConnectWhere>;
};

export type ProjectSubmissionProjectConnectOrCreateFieldInput = {
  onCreate: ProjectSubmissionProjectConnectOrCreateFieldInputOnCreate;
  where: ProjectConnectOrCreateWhere;
};

export type ProjectSubmissionProjectConnectOrCreateFieldInputOnCreate = {
  node: ProjectOnCreateInput;
};

export type ProjectSubmissionProjectConnection = {
  __typename?: 'ProjectSubmissionProjectConnection';
  edges: Array<ProjectSubmissionProjectRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProjectSubmissionProjectConnectionSort = {
  node?: InputMaybe<ProjectSort>;
};

export type ProjectSubmissionProjectConnectionWhere = {
  AND?: InputMaybe<Array<ProjectSubmissionProjectConnectionWhere>>;
  NOT?: InputMaybe<ProjectSubmissionProjectConnectionWhere>;
  OR?: InputMaybe<Array<ProjectSubmissionProjectConnectionWhere>>;
  node?: InputMaybe<ProjectWhere>;
};

export type ProjectSubmissionProjectCreateFieldInput = {
  node: ProjectCreateInput;
};

export type ProjectSubmissionProjectDeleteFieldInput = {
  delete?: InputMaybe<ProjectDeleteInput>;
  where?: InputMaybe<ProjectSubmissionProjectConnectionWhere>;
};

export type ProjectSubmissionProjectDisconnectFieldInput = {
  disconnect?: InputMaybe<ProjectDisconnectInput>;
  where?: InputMaybe<ProjectSubmissionProjectConnectionWhere>;
};

export type ProjectSubmissionProjectFieldInput = {
  connect?: InputMaybe<ProjectSubmissionProjectConnectFieldInput>;
  connectOrCreate?: InputMaybe<ProjectSubmissionProjectConnectOrCreateFieldInput>;
  create?: InputMaybe<ProjectSubmissionProjectCreateFieldInput>;
};

export type ProjectSubmissionProjectNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProjectSubmissionProjectNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProjectSubmissionProjectNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProjectSubmissionProjectNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scopeDocument_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scopeDocument_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scopeDocument_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scopeDocument_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scopeDocument_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scopeDocument_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeDocument_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeDocument_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeDocument_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeDocument_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopeDocument_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeDocument_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeDocument_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeDocument_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeDocument_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectSubmissionProjectProjectAggregationSelection = {
  __typename?: 'ProjectSubmissionProjectProjectAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ProjectSubmissionProjectProjectNodeAggregateSelection>;
};

export type ProjectSubmissionProjectProjectNodeAggregateSelection = {
  __typename?: 'ProjectSubmissionProjectProjectNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  moduleId: IdAggregateSelection;
  name: StringAggregateSelection;
  order: IntAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  scopeDocument: StringAggregateSelection;
};

export type ProjectSubmissionProjectRelationship = {
  __typename?: 'ProjectSubmissionProjectRelationship';
  cursor: Scalars['String']['output'];
  node: Project;
};

export type ProjectSubmissionProjectRequirementRequirementsAggregationSelection = {
  __typename?: 'ProjectSubmissionProjectRequirementRequirementsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ProjectSubmissionProjectRequirementRequirementsNodeAggregateSelection>;
};

export type ProjectSubmissionProjectRequirementRequirementsNodeAggregateSelection = {
  __typename?: 'ProjectSubmissionProjectRequirementRequirementsNodeAggregateSelection';
  aiRationale: StringAggregateSelection;
  category: StringAggregateSelection;
  completedDate: DateTimeAggregateSelection;
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  estimatedHours: IntAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  order: IntAggregateSelection;
  title: StringAggregateSelection;
};

export type ProjectSubmissionProjectUpdateConnectionInput = {
  node?: InputMaybe<ProjectUpdateInput>;
};

export type ProjectSubmissionProjectUpdateFieldInput = {
  connect?: InputMaybe<ProjectSubmissionProjectConnectFieldInput>;
  connectOrCreate?: InputMaybe<ProjectSubmissionProjectConnectOrCreateFieldInput>;
  create?: InputMaybe<ProjectSubmissionProjectCreateFieldInput>;
  delete?: InputMaybe<ProjectSubmissionProjectDeleteFieldInput>;
  disconnect?: InputMaybe<ProjectSubmissionProjectDisconnectFieldInput>;
  update?: InputMaybe<ProjectSubmissionProjectUpdateConnectionInput>;
  where?: InputMaybe<ProjectSubmissionProjectConnectionWhere>;
};

export type ProjectSubmissionRequirementsAggregateInput = {
  AND?: InputMaybe<Array<ProjectSubmissionRequirementsAggregateInput>>;
  NOT?: InputMaybe<ProjectSubmissionRequirementsAggregateInput>;
  OR?: InputMaybe<Array<ProjectSubmissionRequirementsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ProjectSubmissionRequirementsNodeAggregationWhereInput>;
};

export type ProjectSubmissionRequirementsConnectFieldInput = {
  connect?: InputMaybe<Array<ProjectRequirementConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ProjectRequirementConnectWhere>;
};

export type ProjectSubmissionRequirementsConnectOrCreateFieldInput = {
  onCreate: ProjectSubmissionRequirementsConnectOrCreateFieldInputOnCreate;
  where: ProjectRequirementConnectOrCreateWhere;
};

export type ProjectSubmissionRequirementsConnectOrCreateFieldInputOnCreate = {
  node: ProjectRequirementOnCreateInput;
};

export type ProjectSubmissionRequirementsConnection = {
  __typename?: 'ProjectSubmissionRequirementsConnection';
  edges: Array<ProjectSubmissionRequirementsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProjectSubmissionRequirementsConnectionSort = {
  node?: InputMaybe<ProjectRequirementSort>;
};

export type ProjectSubmissionRequirementsConnectionWhere = {
  AND?: InputMaybe<Array<ProjectSubmissionRequirementsConnectionWhere>>;
  NOT?: InputMaybe<ProjectSubmissionRequirementsConnectionWhere>;
  OR?: InputMaybe<Array<ProjectSubmissionRequirementsConnectionWhere>>;
  node?: InputMaybe<ProjectRequirementWhere>;
};

export type ProjectSubmissionRequirementsCreateFieldInput = {
  node: ProjectRequirementCreateInput;
};

export type ProjectSubmissionRequirementsDeleteFieldInput = {
  delete?: InputMaybe<ProjectRequirementDeleteInput>;
  where?: InputMaybe<ProjectSubmissionRequirementsConnectionWhere>;
};

export type ProjectSubmissionRequirementsDisconnectFieldInput = {
  disconnect?: InputMaybe<ProjectRequirementDisconnectInput>;
  where?: InputMaybe<ProjectSubmissionRequirementsConnectionWhere>;
};

export type ProjectSubmissionRequirementsFieldInput = {
  connect?: InputMaybe<Array<ProjectSubmissionRequirementsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectSubmissionRequirementsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ProjectSubmissionRequirementsCreateFieldInput>>;
};

export type ProjectSubmissionRequirementsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProjectSubmissionRequirementsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProjectSubmissionRequirementsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProjectSubmissionRequirementsNodeAggregationWhereInput>>;
  aiRationale_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiRationale_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aiRationale_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiRationale_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aiRationale_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aiRationale_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aiRationale_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aiRationale_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aiRationale_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aiRationale_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aiRationale_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aiRationale_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aiRationale_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aiRationale_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aiRationale_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  category_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  category_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  category_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  category_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  category_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  category_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  category_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  category_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  category_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  category_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  category_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  category_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  category_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  category_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  category_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  completedDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  estimatedHours_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  estimatedHours_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  estimatedHours_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  estimatedHours_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  estimatedHours_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  estimatedHours_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectSubmissionRequirementsRelationship = {
  __typename?: 'ProjectSubmissionRequirementsRelationship';
  cursor: Scalars['String']['output'];
  node: ProjectRequirement;
};

export type ProjectSubmissionRequirementsUpdateConnectionInput = {
  node?: InputMaybe<ProjectRequirementUpdateInput>;
};

export type ProjectSubmissionRequirementsUpdateFieldInput = {
  connect?: InputMaybe<Array<ProjectSubmissionRequirementsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectSubmissionRequirementsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ProjectSubmissionRequirementsCreateFieldInput>>;
  delete?: InputMaybe<Array<ProjectSubmissionRequirementsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProjectSubmissionRequirementsDisconnectFieldInput>>;
  update?: InputMaybe<ProjectSubmissionRequirementsUpdateConnectionInput>;
  where?: InputMaybe<ProjectSubmissionRequirementsConnectionWhere>;
};

export type ProjectSubmissionResponse = {
  __typename?: 'ProjectSubmissionResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<ProjectSubmission>>>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Fields to sort ProjectSubmissions by. The order in which sorts are applied is not guaranteed when specifying many fields in one ProjectSubmissionSort object. */
export type ProjectSubmissionSort = {
  aiAssessment?: InputMaybe<SortDirection>;
  approachMethodology?: InputMaybe<SortDirection>;
  completedAt?: InputMaybe<SortDirection>;
  completedTasks?: InputMaybe<SortDirection>;
  complianceScore?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  feedback?: InputMaybe<SortDirection>;
  grade?: InputMaybe<SortDirection>;
  gradedAt?: InputMaybe<SortDirection>;
  hasTeacherGraded?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isCompleted?: InputMaybe<SortDirection>;
  lastModified?: InputMaybe<SortDirection>;
  proposal?: InputMaybe<SortDirection>;
  scopeJustification?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  submissionLink?: InputMaybe<SortDirection>;
  submissionNotes?: InputMaybe<SortDirection>;
  totalTasks?: InputMaybe<SortDirection>;
  vettingStatus?: InputMaybe<SortDirection>;
};

export enum ProjectSubmissionStatus {
  Approved = 'APPROVED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  NeedsRevision = 'NEEDS_REVISION',
  Rejected = 'REJECTED',
  Submitted = 'SUBMITTED',
  UnderReview = 'UNDER_REVIEW'
}

export type ProjectSubmissionUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ProjectSubmissionUpdateInput = {
  aiAssessment?: InputMaybe<Scalars['String']['input']>;
  approachMethodology?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedTasks?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  complianceScore?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_ADD?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  expectedOutcomes?: InputMaybe<Array<Scalars['String']['input']>>;
  expectedOutcomes_POP?: InputMaybe<Scalars['Int']['input']>;
  expectedOutcomes_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<ProjectSubmissionFilesUpdateFieldInput>>;
  grade?: InputMaybe<Scalars['Float']['input']>;
  grade_ADD?: InputMaybe<Scalars['Float']['input']>;
  grade_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  grade_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  grade_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  gradedAt?: InputMaybe<Scalars['DateTime']['input']>;
  hasTeacherGraded?: InputMaybe<Scalars['Boolean']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  project?: InputMaybe<ProjectSubmissionProjectUpdateFieldInput>;
  proposal?: InputMaybe<Scalars['String']['input']>;
  requirements?: InputMaybe<Array<ProjectSubmissionRequirementsUpdateFieldInput>>;
  scopeJustification?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProjectSubmissionStatus>;
  submissionLink?: InputMaybe<Scalars['String']['input']>;
  submissionNotes?: InputMaybe<Scalars['String']['input']>;
  suggestedImprovements?: InputMaybe<Array<Scalars['String']['input']>>;
  suggestedImprovements_POP?: InputMaybe<Scalars['Int']['input']>;
  suggestedImprovements_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  totalTasks?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<ProjectSubmissionUserUpdateFieldInput>;
  vettingStatus?: InputMaybe<ProjectVettingStatus>;
};

export type ProjectSubmissionUserAggregateInput = {
  AND?: InputMaybe<Array<ProjectSubmissionUserAggregateInput>>;
  NOT?: InputMaybe<ProjectSubmissionUserAggregateInput>;
  OR?: InputMaybe<Array<ProjectSubmissionUserAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ProjectSubmissionUserNodeAggregationWhereInput>;
};

export type ProjectSubmissionUserConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type ProjectSubmissionUserConnectOrCreateFieldInput = {
  onCreate: ProjectSubmissionUserConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type ProjectSubmissionUserConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type ProjectSubmissionUserConnection = {
  __typename?: 'ProjectSubmissionUserConnection';
  edges: Array<ProjectSubmissionUserRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProjectSubmissionUserConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type ProjectSubmissionUserConnectionWhere = {
  AND?: InputMaybe<Array<ProjectSubmissionUserConnectionWhere>>;
  NOT?: InputMaybe<ProjectSubmissionUserConnectionWhere>;
  OR?: InputMaybe<Array<ProjectSubmissionUserConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type ProjectSubmissionUserCreateFieldInput = {
  node: UserCreateInput;
};

export type ProjectSubmissionUserDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<ProjectSubmissionUserConnectionWhere>;
};

export type ProjectSubmissionUserDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<ProjectSubmissionUserConnectionWhere>;
};

export type ProjectSubmissionUserFieldInput = {
  connect?: InputMaybe<ProjectSubmissionUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<ProjectSubmissionUserConnectOrCreateFieldInput>;
  create?: InputMaybe<ProjectSubmissionUserCreateFieldInput>;
};

export type ProjectSubmissionUserNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProjectSubmissionUserNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProjectSubmissionUserNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProjectSubmissionUserNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectSubmissionUserRelationship = {
  __typename?: 'ProjectSubmissionUserRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type ProjectSubmissionUserUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type ProjectSubmissionUserUpdateFieldInput = {
  connect?: InputMaybe<ProjectSubmissionUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<ProjectSubmissionUserConnectOrCreateFieldInput>;
  create?: InputMaybe<ProjectSubmissionUserCreateFieldInput>;
  delete?: InputMaybe<ProjectSubmissionUserDeleteFieldInput>;
  disconnect?: InputMaybe<ProjectSubmissionUserDisconnectFieldInput>;
  update?: InputMaybe<ProjectSubmissionUserUpdateConnectionInput>;
  where?: InputMaybe<ProjectSubmissionUserConnectionWhere>;
};

export type ProjectSubmissionUserUserAggregationSelection = {
  __typename?: 'ProjectSubmissionUserUserAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ProjectSubmissionUserUserNodeAggregateSelection>;
};

export type ProjectSubmissionUserUserNodeAggregateSelection = {
  __typename?: 'ProjectSubmissionUserUserNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type ProjectSubmissionWhere = {
  AND?: InputMaybe<Array<ProjectSubmissionWhere>>;
  NOT?: InputMaybe<ProjectSubmissionWhere>;
  OR?: InputMaybe<Array<ProjectSubmissionWhere>>;
  aiAssessment?: InputMaybe<Scalars['String']['input']>;
  aiAssessment_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  aiAssessment_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  aiAssessment_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aiAssessment_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  approachMethodology?: InputMaybe<Scalars['String']['input']>;
  approachMethodology_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  approachMethodology_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  approachMethodology_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  approachMethodology_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  completedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedTasks?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_GT?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_GTE?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  completedTasks_LT?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_LTE?: InputMaybe<Scalars['Int']['input']>;
  complianceScore?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_GT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_GTE?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  complianceScore_LT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_LTE?: InputMaybe<Scalars['Float']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  expectedOutcomes?: InputMaybe<Array<Scalars['String']['input']>>;
  expectedOutcomes_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  feedback_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  feedback_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  feedback_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  feedback_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  filesAggregate?: InputMaybe<ProjectSubmissionFilesAggregateInput>;
  /** Return ProjectSubmissions where all of the related ProjectSubmissionFilesConnections match this filter */
  filesConnection_ALL?: InputMaybe<ProjectSubmissionFilesConnectionWhere>;
  /** Return ProjectSubmissions where none of the related ProjectSubmissionFilesConnections match this filter */
  filesConnection_NONE?: InputMaybe<ProjectSubmissionFilesConnectionWhere>;
  /** Return ProjectSubmissions where one of the related ProjectSubmissionFilesConnections match this filter */
  filesConnection_SINGLE?: InputMaybe<ProjectSubmissionFilesConnectionWhere>;
  /** Return ProjectSubmissions where some of the related ProjectSubmissionFilesConnections match this filter */
  filesConnection_SOME?: InputMaybe<ProjectSubmissionFilesConnectionWhere>;
  /** Return ProjectSubmissions where all of the related Files match this filter */
  files_ALL?: InputMaybe<FileWhere>;
  /** Return ProjectSubmissions where none of the related Files match this filter */
  files_NONE?: InputMaybe<FileWhere>;
  /** Return ProjectSubmissions where one of the related Files match this filter */
  files_SINGLE?: InputMaybe<FileWhere>;
  /** Return ProjectSubmissions where some of the related Files match this filter */
  files_SOME?: InputMaybe<FileWhere>;
  grade?: InputMaybe<Scalars['Float']['input']>;
  grade_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  grade_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_LTE?: InputMaybe<Scalars['Float']['input']>;
  gradedAt?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  gradedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  hasTeacherGraded?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastModified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  project?: InputMaybe<ProjectWhere>;
  projectAggregate?: InputMaybe<ProjectSubmissionProjectAggregateInput>;
  projectConnection?: InputMaybe<ProjectSubmissionProjectConnectionWhere>;
  projectConnection_NOT?: InputMaybe<ProjectSubmissionProjectConnectionWhere>;
  project_NOT?: InputMaybe<ProjectWhere>;
  proposal?: InputMaybe<Scalars['String']['input']>;
  proposal_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  proposal_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  proposal_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  proposal_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  requirementsAggregate?: InputMaybe<ProjectSubmissionRequirementsAggregateInput>;
  /** Return ProjectSubmissions where all of the related ProjectSubmissionRequirementsConnections match this filter */
  requirementsConnection_ALL?: InputMaybe<ProjectSubmissionRequirementsConnectionWhere>;
  /** Return ProjectSubmissions where none of the related ProjectSubmissionRequirementsConnections match this filter */
  requirementsConnection_NONE?: InputMaybe<ProjectSubmissionRequirementsConnectionWhere>;
  /** Return ProjectSubmissions where one of the related ProjectSubmissionRequirementsConnections match this filter */
  requirementsConnection_SINGLE?: InputMaybe<ProjectSubmissionRequirementsConnectionWhere>;
  /** Return ProjectSubmissions where some of the related ProjectSubmissionRequirementsConnections match this filter */
  requirementsConnection_SOME?: InputMaybe<ProjectSubmissionRequirementsConnectionWhere>;
  /** Return ProjectSubmissions where all of the related ProjectRequirements match this filter */
  requirements_ALL?: InputMaybe<ProjectRequirementWhere>;
  /** Return ProjectSubmissions where none of the related ProjectRequirements match this filter */
  requirements_NONE?: InputMaybe<ProjectRequirementWhere>;
  /** Return ProjectSubmissions where one of the related ProjectRequirements match this filter */
  requirements_SINGLE?: InputMaybe<ProjectRequirementWhere>;
  /** Return ProjectSubmissions where some of the related ProjectRequirements match this filter */
  requirements_SOME?: InputMaybe<ProjectRequirementWhere>;
  scopeJustification?: InputMaybe<Scalars['String']['input']>;
  scopeJustification_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  scopeJustification_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  scopeJustification_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scopeJustification_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProjectSubmissionStatus>;
  status_IN?: InputMaybe<Array<ProjectSubmissionStatus>>;
  submissionLink?: InputMaybe<Scalars['String']['input']>;
  submissionLink_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  submissionLink_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  submissionLink_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submissionLink_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  submissionNotes?: InputMaybe<Scalars['String']['input']>;
  submissionNotes_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  submissionNotes_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  submissionNotes_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submissionNotes_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  suggestedImprovements?: InputMaybe<Array<Scalars['String']['input']>>;
  suggestedImprovements_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  totalTasks?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_GT?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_GTE?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  totalTasks_LT?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_LTE?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<UserWhere>;
  userAggregate?: InputMaybe<ProjectSubmissionUserAggregateInput>;
  userConnection?: InputMaybe<ProjectSubmissionUserConnectionWhere>;
  userConnection_NOT?: InputMaybe<ProjectSubmissionUserConnectionWhere>;
  user_NOT?: InputMaybe<UserWhere>;
  vettingStatus?: InputMaybe<ProjectVettingStatus>;
  vettingStatus_IN?: InputMaybe<Array<InputMaybe<ProjectVettingStatus>>>;
};

export type ProjectSubmissionsAggregateInput = {
  AND?: InputMaybe<Array<ProjectSubmissionsAggregateInput>>;
  NOT?: InputMaybe<ProjectSubmissionsAggregateInput>;
  OR?: InputMaybe<Array<ProjectSubmissionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ProjectSubmissionsNodeAggregationWhereInput>;
};

export type ProjectSubmissionsConnectFieldInput = {
  connect?: InputMaybe<Array<ProjectSubmissionConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ProjectSubmissionConnectWhere>;
};

export type ProjectSubmissionsConnectOrCreateFieldInput = {
  onCreate: ProjectSubmissionsConnectOrCreateFieldInputOnCreate;
  where: ProjectSubmissionConnectOrCreateWhere;
};

export type ProjectSubmissionsConnectOrCreateFieldInputOnCreate = {
  node: ProjectSubmissionOnCreateInput;
};

export type ProjectSubmissionsConnection = {
  __typename?: 'ProjectSubmissionsConnection';
  edges: Array<ProjectSubmissionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProjectSubmissionsConnectionSort = {
  node?: InputMaybe<ProjectSubmissionSort>;
};

export type ProjectSubmissionsConnectionWhere = {
  AND?: InputMaybe<Array<ProjectSubmissionsConnectionWhere>>;
  NOT?: InputMaybe<ProjectSubmissionsConnectionWhere>;
  OR?: InputMaybe<Array<ProjectSubmissionsConnectionWhere>>;
  node?: InputMaybe<ProjectSubmissionWhere>;
};

export type ProjectSubmissionsCreateFieldInput = {
  node: ProjectSubmissionCreateInput;
};

export type ProjectSubmissionsDeleteFieldInput = {
  delete?: InputMaybe<ProjectSubmissionDeleteInput>;
  where?: InputMaybe<ProjectSubmissionsConnectionWhere>;
};

export type ProjectSubmissionsDisconnectFieldInput = {
  disconnect?: InputMaybe<ProjectSubmissionDisconnectInput>;
  where?: InputMaybe<ProjectSubmissionsConnectionWhere>;
};

export type ProjectSubmissionsFieldInput = {
  connect?: InputMaybe<Array<ProjectSubmissionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectSubmissionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ProjectSubmissionsCreateFieldInput>>;
};

export type ProjectSubmissionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProjectSubmissionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProjectSubmissionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProjectSubmissionsNodeAggregationWhereInput>>;
  aiAssessment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiAssessment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aiAssessment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiAssessment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aiAssessment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aiAssessment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aiAssessment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  approachMethodology_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  approachMethodology_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  approachMethodology_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  approachMethodology_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  approachMethodology_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  approachMethodology_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  completedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedTasks_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  completedTasks_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  completedTasks_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  completedTasks_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  completedTasks_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  completedTasks_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  completedTasks_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  complianceScore_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  complianceScore_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  feedback_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  feedback_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  gradedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  gradedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  proposal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  proposal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  proposal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  proposal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  proposal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  proposal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  proposal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  proposal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  proposal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  proposal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  proposal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  proposal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  proposal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  proposal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  proposal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scopeJustification_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scopeJustification_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scopeJustification_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scopeJustification_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scopeJustification_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeJustification_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submissionLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submissionLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submissionLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submissionLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  submissionLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissionLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submissionNotes_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submissionNotes_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submissionNotes_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submissionNotes_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  submissionNotes_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissionNotes_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalTasks_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalTasks_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalTasks_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalTasks_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalTasks_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  totalTasks_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectSubmissionsRelationship = {
  __typename?: 'ProjectSubmissionsRelationship';
  cursor: Scalars['String']['output'];
  node: ProjectSubmission;
};

export type ProjectSubmissionsUpdateConnectionInput = {
  node?: InputMaybe<ProjectSubmissionUpdateInput>;
};

export type ProjectSubmissionsUpdateFieldInput = {
  connect?: InputMaybe<Array<ProjectSubmissionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectSubmissionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ProjectSubmissionsCreateFieldInput>>;
  delete?: InputMaybe<Array<ProjectSubmissionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProjectSubmissionsDisconnectFieldInput>>;
  update?: InputMaybe<ProjectSubmissionsUpdateConnectionInput>;
  where?: InputMaybe<ProjectSubmissionsConnectionWhere>;
};

export type ProjectUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ProjectUpdateInput = {
  activityState?: InputMaybe<ActivityState>;
  assessmentCriteria?: InputMaybe<Array<Scalars['String']['input']>>;
  assessmentCriteria_POP?: InputMaybe<Scalars['Int']['input']>;
  assessmentCriteria_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  deliverableTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  deliverableTypes_POP?: InputMaybe<Scalars['Int']['input']>;
  deliverableTypes_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  expectedOutcomes?: InputMaybe<Array<Scalars['String']['input']>>;
  expectedOutcomes_POP?: InputMaybe<Scalars['Int']['input']>;
  expectedOutcomes_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  files?: InputMaybe<Array<ProjectFilesUpdateFieldInput>>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  module?: InputMaybe<ProjectModuleUpdateFieldInput>;
  moduleId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nudgesAboutThis?: InputMaybe<Array<ProjectNudgesAboutThisUpdateFieldInput>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  order_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  scopeDocument?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProjectStatus>;
  submissions?: InputMaybe<Array<ProjectSubmissionsUpdateFieldInput>>;
};

export enum ProjectVettingStatus {
  Approved = 'APPROVED',
  InProgress = 'IN_PROGRESS',
  NeedsRevision = 'NEEDS_REVISION',
  NotStarted = 'NOT_STARTED',
  Rejected = 'REJECTED'
}

export type ProjectWhere = {
  AND?: InputMaybe<Array<ProjectWhere>>;
  NOT?: InputMaybe<ProjectWhere>;
  OR?: InputMaybe<Array<ProjectWhere>>;
  activityState?: InputMaybe<ActivityState>;
  activityState_IN?: InputMaybe<Array<InputMaybe<ActivityState>>>;
  assessmentCriteria?: InputMaybe<Array<Scalars['String']['input']>>;
  assessmentCriteria_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deliverableTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  deliverableTypes_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  dueDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  expectedOutcomes?: InputMaybe<Array<Scalars['String']['input']>>;
  expectedOutcomes_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  filesAggregate?: InputMaybe<ProjectFilesAggregateInput>;
  /** Return Projects where all of the related ProjectFilesConnections match this filter */
  filesConnection_ALL?: InputMaybe<ProjectFilesConnectionWhere>;
  /** Return Projects where none of the related ProjectFilesConnections match this filter */
  filesConnection_NONE?: InputMaybe<ProjectFilesConnectionWhere>;
  /** Return Projects where one of the related ProjectFilesConnections match this filter */
  filesConnection_SINGLE?: InputMaybe<ProjectFilesConnectionWhere>;
  /** Return Projects where some of the related ProjectFilesConnections match this filter */
  filesConnection_SOME?: InputMaybe<ProjectFilesConnectionWhere>;
  /** Return Projects where all of the related Files match this filter */
  files_ALL?: InputMaybe<FileWhere>;
  /** Return Projects where none of the related Files match this filter */
  files_NONE?: InputMaybe<FileWhere>;
  /** Return Projects where one of the related Files match this filter */
  files_SINGLE?: InputMaybe<FileWhere>;
  /** Return Projects where some of the related Files match this filter */
  files_SOME?: InputMaybe<FileWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastModified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  module?: InputMaybe<ModuleWhere>;
  moduleAggregate?: InputMaybe<ProjectModuleAggregateInput>;
  moduleConnection?: InputMaybe<ProjectModuleConnectionWhere>;
  moduleConnection_NOT?: InputMaybe<ProjectModuleConnectionWhere>;
  moduleId?: InputMaybe<Scalars['ID']['input']>;
  moduleId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  moduleId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  moduleId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  moduleId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  module_NOT?: InputMaybe<ModuleWhere>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  nudgesAboutThisAggregate?: InputMaybe<ProjectNudgesAboutThisAggregateInput>;
  /** Return Projects where all of the related ProjectNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_ALL?: InputMaybe<ProjectNudgesAboutThisConnectionWhere>;
  /** Return Projects where none of the related ProjectNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_NONE?: InputMaybe<ProjectNudgesAboutThisConnectionWhere>;
  /** Return Projects where one of the related ProjectNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_SINGLE?: InputMaybe<ProjectNudgesAboutThisConnectionWhere>;
  /** Return Projects where some of the related ProjectNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_SOME?: InputMaybe<ProjectNudgesAboutThisConnectionWhere>;
  /** Return Projects where all of the related Nudges match this filter */
  nudgesAboutThis_ALL?: InputMaybe<NudgeWhere>;
  /** Return Projects where none of the related Nudges match this filter */
  nudgesAboutThis_NONE?: InputMaybe<NudgeWhere>;
  /** Return Projects where one of the related Nudges match this filter */
  nudgesAboutThis_SINGLE?: InputMaybe<NudgeWhere>;
  /** Return Projects where some of the related Nudges match this filter */
  nudgesAboutThis_SOME?: InputMaybe<NudgeWhere>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  scheduledDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scopeDocument?: InputMaybe<Scalars['String']['input']>;
  scopeDocument_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  scopeDocument_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  scopeDocument_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scopeDocument_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProjectStatus>;
  status_IN?: InputMaybe<Array<ProjectStatus>>;
  submissionsAggregate?: InputMaybe<ProjectSubmissionsAggregateInput>;
  /** Return Projects where all of the related ProjectSubmissionsConnections match this filter */
  submissionsConnection_ALL?: InputMaybe<ProjectSubmissionsConnectionWhere>;
  /** Return Projects where none of the related ProjectSubmissionsConnections match this filter */
  submissionsConnection_NONE?: InputMaybe<ProjectSubmissionsConnectionWhere>;
  /** Return Projects where one of the related ProjectSubmissionsConnections match this filter */
  submissionsConnection_SINGLE?: InputMaybe<ProjectSubmissionsConnectionWhere>;
  /** Return Projects where some of the related ProjectSubmissionsConnections match this filter */
  submissionsConnection_SOME?: InputMaybe<ProjectSubmissionsConnectionWhere>;
  /** Return Projects where all of the related ProjectSubmissions match this filter */
  submissions_ALL?: InputMaybe<ProjectSubmissionWhere>;
  /** Return Projects where none of the related ProjectSubmissions match this filter */
  submissions_NONE?: InputMaybe<ProjectSubmissionWhere>;
  /** Return Projects where one of the related ProjectSubmissions match this filter */
  submissions_SINGLE?: InputMaybe<ProjectSubmissionWhere>;
  /** Return Projects where some of the related ProjectSubmissions match this filter */
  submissions_SOME?: InputMaybe<ProjectSubmissionWhere>;
};

export type QuarterlySummary = {
  __typename?: 'QuarterlySummary';
  created: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  isArchived: Scalars['Boolean']['output'];
  last_modified: Scalars['DateTime']['output'];
  summary: Scalars['String']['output'];
};

export type QuarterlySummaryConnectWhere = {
  node: QuarterlySummaryWhere;
};

export type QuarterlySummaryCreateInput = {
  created: Scalars['DateTime']['input'];
  date: Scalars['DateTime']['input'];
  isArchived: Scalars['Boolean']['input'];
  last_modified: Scalars['DateTime']['input'];
  summary: Scalars['String']['input'];
};

export type QuarterlySummaryOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more QuarterlySummarySort objects to sort QuarterlySummaries by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<QuarterlySummarySort>>;
};

/** Fields to sort QuarterlySummaries by. The order in which sorts are applied is not guaranteed when specifying many fields in one QuarterlySummarySort object. */
export type QuarterlySummarySort = {
  created?: InputMaybe<SortDirection>;
  date?: InputMaybe<SortDirection>;
  isArchived?: InputMaybe<SortDirection>;
  last_modified?: InputMaybe<SortDirection>;
  summary?: InputMaybe<SortDirection>;
};

export type QuarterlySummaryUpdateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type QuarterlySummaryWhere = {
  AND?: InputMaybe<Array<QuarterlySummaryWhere>>;
  NOT?: InputMaybe<QuarterlySummaryWhere>;
  OR?: InputMaybe<Array<QuarterlySummaryWhere>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  date_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  date_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  last_modified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  summary_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  summary_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  summary_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  summary_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']['output']>;
  baseProgressEvents: Array<BaseProgressEvent>;
  baseProgressEventsAggregate: BaseProgressEventAggregateSelection;
  baseProgressEventsConnection: BaseProgressEventsConnection;
  exportCsv: ExportCsvResponse;
  getAITutor?: Maybe<AiTutorResponse>;
  getAITutorAnalytics?: Maybe<AiTutorAnalyticsResponse>;
  getAITutorVideos?: Maybe<AiTutorVideosResponse>;
  getActiveTracks?: Maybe<Array<Maybe<ActiveTrack>>>;
  getActivityAnalyticsByModule?: Maybe<ActivityAnalyticsResponse>;
  getActivityCompletionDetails: ActivityCompletionDetailsResponse;
  getActivityInsightsData: ActivityInsightsResponse;
  getAdminDashboardMetrics: AdminDashboardResponse;
  getAdminDocumentAnalytics: AdminDocumentAnalyticsResponse;
  getAdminDocumentsForTenant: AdminDocumentsResponse;
  getAllAITutorsByCourse?: Maybe<AiTutorResponse>;
  getAllAssessmentsByCourse?: Maybe<MultipleAssessmentResponse>;
  getAllAxioResourcesByCourse: AxioResourceResponse;
  getAllCompanionChatsForUser: CompanionChatsForUserResult;
  getAllCoursesBySchool?: Maybe<CoursesByQueryResponse>;
  getAllModulesByCourse?: Maybe<ModuleResponse>;
  getAllReviewsByCourse?: Maybe<ReviewResponse>;
  getAllTenants?: Maybe<TenantResponse>;
  getAllowedUploadSpecifications: AllowedUploadSpecificationsResponse;
  getAnnouncementById: AnnouncementResponse;
  getAnnouncementsByCourse: AnnouncementListResponse;
  getAnnouncementsBySchool: AnnouncementListResponse;
  getAnnouncementsForStudent: AnnouncementListResponse;
  getAnnouncementsForUser: AnnouncementListResponse;
  getAssessment?: Maybe<AssessmentResponse>;
  getAssessmentAiTutors?: Maybe<AssessmentAiTutorsResponse>;
  getAssessmentQuestionBank?: Maybe<AssessmentResponse>;
  getAssessmentSubmissionDetails?: Maybe<AssessmentSubmissionDetailsResponse>;
  getAssignment?: Maybe<AssignmentResponse>;
  getAssignmentAndSubmissionBySubmissionId?: Maybe<AssignmentAndSubmissionResponse>;
  getAssignmentSubmissionAttemptHistory?: Maybe<AssignmentSubmissionListResponse>;
  getAssignments?: Maybe<Array<Maybe<GetAssignmentResponse>>>;
  getAssignmentsWithCourse: AssignmentsWithCourseResponse;
  getAttemptHistory?: Maybe<AssessmentSubmissionListResponse>;
  getAvailableCoursesForStudent?: Maybe<CoursesByQueryResponseWithMetadata>;
  getAxioResource: AxioResourceResponse;
  getCareerById?: Maybe<Career>;
  getCareerHeader: CareerHeader;
  getCareerTopics?: Maybe<Array<Maybe<Topic>>>;
  getCareers?: Maybe<Array<Maybe<Career>>>;
  getChapters?: Maybe<Array<Maybe<Subfield>>>;
  getChatByContextAndParams?: Maybe<ChatResponse>;
  getChatById?: Maybe<ChatResponse>;
  getChatByObjectId?: Maybe<ChatResponse>;
  getChatForDate?: Maybe<ChatResponse>;
  getChats?: Maybe<Array<Maybe<Chat>>>;
  getCompanionChatByAiTutorId: GetCompanionChatByIdResult;
  getCompanionChatById: GetCompanionChatByIdResult;
  getCompanionChatsForUserPreview: CompanionChatsForUserResult;
  getCompanionWorkspaceChats: CompanionWorkspaceChatsResponse;
  getCompletionAnalyticsBySchool: CompletionAnalyticsResponse;
  getContentById?: Maybe<Curriculum>;
  getContentSafetySettings?: Maybe<ContentSafetySettingsResponse>;
  getCourseActivitiesProgress?: Maybe<CourseResponse>;
  getCourseAdminStats?: Maybe<CourseResponse>;
  getCourseAnalyticsById?: Maybe<CourseDetailedResponse>;
  getCourseByIdWithEnrolledUserInfo?: Maybe<CourseResponse>;
  getCourseByName?: Maybe<CourseResponse>;
  getCourseChatResources?: Maybe<CourseResponse>;
  getCourseCompletionDetails: CourseCompletionDetailsResponse;
  getCourseCompletionSummaryBySchool?: Maybe<CourseCompletionSummaryResponse>;
  getCourseCore?: Maybe<CourseResponse>;
  getCourseHierarchy?: Maybe<CourseHierarchyResponse>;
  getCourseModulesActivitiesLite?: Maybe<CourseResponse>;
  getCourseModulesLite?: Maybe<CourseResponse>;
  getCourseProgressInformation?: Maybe<CourseProgressInformationResponse>;
  getCourseSessionAnalytics?: Maybe<CourseSessionAnalyticsResponse>;
  getCoursesAnalyticsBySchool?: Maybe<CourseAnalyticsResponse>;
  getCoursesAndAssignments: CoursesAndAssignmentsResponse;
  getCoursesByDegreeByQuery?: Maybe<CoursesByQueryResponse>;
  getCoursesByFaculty?: Maybe<CourseResponse>;
  getCoursesBySchoolByQuery?: Maybe<CoursesByQueryResponse>;
  getCoursesForTranscriptGeneration?: Maybe<CourseResponse>;
  getCoursesSummaryBySchool?: Maybe<CourseDetailedResponse>;
  getDailyLimit?: Maybe<RateLimitResult>;
  getDegree?: Maybe<DegreeResponse>;
  getDegreeByName?: Maybe<DegreeResponse>;
  getDegreeBySchool?: Maybe<DegreeResponse>;
  getDegreeForUser?: Maybe<DegreeResponse>;
  getDegreeForUserWithEnrolledUserInfo?: Maybe<DegreeResponse>;
  getDegreesBySchoolByQuery?: Maybe<DegreesBySchoolByQueryResponse>;
  getDocument?: Maybe<DocumentResponse>;
  getDocumentReferenceAnalytics: DocumentReferenceAnalyticsResponse;
  getDueSoonActivitiesBySchoolAndUser?: Maybe<CourseResponse>;
  getEnrolledCoursesForStudent?: Maybe<CoursesByQueryResponseWithMetadata>;
  getEnrolledStudentCoursesByAdmin?: Maybe<CoursesByQueryResponseWithMetadata>;
  getEnrollmentLink?: Maybe<EnrollmentLinkServiceResult>;
  getFacultyByCourseId?: Maybe<FacultyQueryResponse>;
  getFacultyByNameOrEmail?: Maybe<FacultyQueryResponse>;
  getFacultyForSchool?: Maybe<FacultyQueryResponse>;
  getFields: Array<Maybe<Field>>;
  getFile: FileResponse;
  getFirstSubchapterByTopicName: SubchapterDetails;
  getFlaggedMessages: SafetyCaseResponse;
  getFoodsByDate?: Maybe<Array<Maybe<Food>>>;
  getForumByCourse: ForumResponse;
  getGcpSignedUrlForRead: FileUploadResponse;
  getGeneralCompanionChatsForUser: CompanionWorkspaceChatsResponse;
  getGeneratedContent?: Maybe<Array<Maybe<Curriculum>>>;
  getGradingCenterDashboardData?: Maybe<GradingCenterDashboardResponse>;
  getIsInvitationTokenValid?: Maybe<ValidityResponse>;
  getIsRoomDeleted?: Maybe<IsRoomDeletedResponse>;
  getLastSeenPost: LastSeenPostResponse;
  getLatestCourseEvaluation?: Maybe<CourseEvaluation>;
  getLearningObjectiveById: LearningObjectiveResponse;
  getLearningObjectivesBySubchapter?: Maybe<Array<Maybe<LearningObjective>>>;
  getLearningTree?: Maybe<LearningTree>;
  getLessonPlanStatus?: Maybe<LessonPlanStatusResponse>;
  getLevelDetails?: Maybe<LevelDetails>;
  getMcqQuestion: McqQuestionResponse;
  getMcqQuestionsByAssessment: McqQuestionListResponse;
  getModule?: Maybe<ModuleResponse>;
  getModuleAnalyticsByCourse?: Maybe<ModuleAnalyticsResponse>;
  getModuleCompletionDetails: ModuleCompletionDetailsResponse;
  getMostRelevantVideo: VideoServiceResult;
  getNode?: Maybe<LearningNode>;
  getNodeChildren: Array<Maybe<LearningNode>>;
  getNodeParents: Array<Maybe<LearningNode>>;
  getNote: NoteResponse;
  getNotesForStudent: NotesListResponse;
  getOAuthClient?: Maybe<OAuthClientResponse>;
  getOAuthClients?: Maybe<OAuthClientResponse>;
  getObjectiveAnalyticsByActivity?: Maybe<ObjectiveAnalyticsResponse>;
  getObjectiveCompletionDetails: ObjectiveCompletionDetailsResponse;
  getPage?: Maybe<PageResponse>;
  getPageVisitsBySession: PageVisitListResponse;
  getPostById: PostResponse;
  getPostsByThread: PostListResponse;
  getProject: SingleProjectResponse;
  getProjectSubmission: SingleProjectSubmissionResponse;
  getProjectSubmissionsByProject: ProjectSubmissionResponse;
  getProjectSubmissionsByStudent: ProjectSubmissionResponse;
  getProjectsByStudent: ProjectResponse;
  getRecentActivity: AuditEventServiceResult;
  getRecentTodosForUser: TodoResponse;
  getRecentTracks?: Maybe<Array<Maybe<RecentTrack>>>;
  getReview?: Maybe<ReviewResponse>;
  getRosterExportFile: ExportDownloadResponse;
  getRunningAssessmentSubmissionByUser?: Maybe<AssessmentSubmissionResponse>;
  getSamlConfigByTenant?: Maybe<SamlConfigResponse>;
  getSchools?: Maybe<Array<Maybe<School>>>;
  getSessionAnalyticsCsv: ExportCsvResponse;
  getSessionAnalyticsCsvStatus: ExportCsvResponse;
  getStudentActivityProgress?: Maybe<StudentActivityProgressResponse>;
  getStudentAnalyticsBySchool: StudentAnalyticsResponse;
  getStudentAnalyticsForStudent: StudentAnalyticsResponse;
  getStudentChatAnalytics: StudentChatAnalyticsResponse;
  getStudentCourseProgress?: Maybe<StudentCourseProgressResponse>;
  getStudentDetailedAnalytics?: Maybe<StudentDetailedAnalyticsResponse>;
  getStudentLearningInsights: StudentLearningInsightsResponse;
  getStudentModuleProgress?: Maybe<StudentModuleProgressResponse>;
  getStudentsByCourseId?: Maybe<CourseRosterServiceResult>;
  getStudentsByDegreeId?: Maybe<DegreeRosterServiceResult>;
  getStudentsSummaryBySchool?: Maybe<StudentAnalyticsSummaryResponse>;
  getSubchapterById?: Maybe<SubchapterDetails>;
  getSubmissionExportFile: ExportDownloadResponse;
  getSubmissionRequirements: ProjectRequirementResponse;
  getSuggestions?: Maybe<Array<Maybe<Suggestion>>>;
  getTableOfContents?: Maybe<Array<Maybe<Hierarchy>>>;
  getTenant?: Maybe<TenantResponse>;
  getTenantByDomain?: Maybe<TenantResponse>;
  getTenantDefaults?: Maybe<TenantResponse>;
  getTenantForSchoolAdmin?: Maybe<TenantResponse>;
  getTenantSchema?: Maybe<TenantSchemaResponse>;
  getTenantSubmitHelpTicketLink?: Maybe<TenantSubmitHelpTicketLinkResponse>;
  getThreadsByCourse: ThreadListResponse;
  getTodayChat?: Maybe<ChatResponse>;
  getTodosForUser: TodoResponse;
  getTrackOverview?: Maybe<TrackOverview>;
  getUnifiedSubmissionsByFaculty?: Maybe<GetUnifiedSubmissionsByFacultyResponse>;
  getUnifiedSubmissionsByFacultyByUser?: Maybe<GetUnifiedSubmissionsByFacultyResponse>;
  getUserAnnouncements: AnnouncementListResponse;
  getUserChatMessageAnalytics?: Maybe<UserChatMessageAnalyticsResponse>;
  getUserLearningObjectiveMastery?: Maybe<MasteryResult>;
  getUserLearningPreferences?: Maybe<UserLearningPreferences>;
  getUserNotifications: NotificationResponse;
  getUserPermissions: Array<Scalars['String']['output']>;
  getUserProgress: Array<UserProgress>;
  getUserSessionAnalytics?: Maybe<UserSessionAnalyticsResponse>;
  getUserSessionAnalyticsDailyBreakdown?: Maybe<UserSessionAnalyticsDailyBreakdownResponse>;
  getUserSubmissions?: Maybe<SubmissionResponse>;
  getUserWorkspaces: Array<UserWorkspace>;
  getUsersForSchool?: Maybe<FacultyQueryResponse>;
  getUsersWithElevatedRoles?: Maybe<FacultyQueryResponse>;
  getVisitSessions: VisitSessionListResponse;
  getVisualization?: Maybe<VisualizationResponse>;
  getVisualizationsForTutor?: Maybe<VisualizationResponse>;
  getWorksheet?: Maybe<WorksheetResponse>;
  llmStreamContentBlocks: Array<LlmStreamContentBlock>;
  llmStreamEvents: Array<LlmStreamEvent>;
  me?: Maybe<MeResponse>;
  searchTodosForUser: TodoResponse;
  userInviteCount?: Maybe<InviteCountResponse>;
  validateSession: SessionResponse;
};


export type QueryBaseProgressEventsArgs = {
  options?: InputMaybe<BaseProgressEventOptions>;
  where?: InputMaybe<BaseProgressEventWhere>;
};


export type QueryBaseProgressEventsAggregateArgs = {
  where?: InputMaybe<BaseProgressEventWhere>;
};


export type QueryBaseProgressEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<BaseProgressEventSort>>>;
  where?: InputMaybe<BaseProgressEventWhere>;
};


export type QueryGetAiTutorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAiTutorAnalyticsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAiTutorVideosArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetActivityAnalyticsByModuleArgs = {
  moduleId: Scalars['ID']['input'];
};


export type QueryGetActivityCompletionDetailsArgs = {
  aiTutorId: Scalars['ID']['input'];
};


export type QueryGetActivityInsightsDataArgs = {
  aiTutorId: Scalars['ID']['input'];
};


export type QueryGetAdminDashboardMetricsArgs = {
  schoolId: Scalars['ID']['input'];
};


export type QueryGetAdminDocumentAnalyticsArgs = {
  input?: InputMaybe<DocumentReferenceAnalyticsInput>;
};


export type QueryGetAllAiTutorsByCourseArgs = {
  courseIds: Array<Scalars['ID']['input']>;
};


export type QueryGetAllAssessmentsByCourseArgs = {
  courseId: Scalars['ID']['input'];
};


export type QueryGetAllAxioResourcesByCourseArgs = {
  courseId: Scalars['ID']['input'];
};


export type QueryGetAllCoursesBySchoolArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  schoolId: Scalars['ID']['input'];
};


export type QueryGetAllModulesByCourseArgs = {
  courseId: Scalars['ID']['input'];
};


export type QueryGetAllReviewsByCourseArgs = {
  courseId: Scalars['ID']['input'];
};


export type QueryGetAllowedUploadSpecificationsArgs = {
  storagePath: StoragePathType;
};


export type QueryGetAnnouncementByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAnnouncementsByCourseArgs = {
  courseId: Scalars['ID']['input'];
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetAnnouncementsBySchoolArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  schoolId: Scalars['ID']['input'];
};


export type QueryGetAnnouncementsForStudentArgs = {
  courseId: Scalars['ID']['input'];
};


export type QueryGetAnnouncementsForUserArgs = {
  audienceType?: InputMaybe<AudienceType>;
  schoolId: Scalars['ID']['input'];
};


export type QueryGetAssessmentArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type QueryGetAssessmentAiTutorsArgs = {
  courseId: Scalars['ID']['input'];
  moduleId: Scalars['ID']['input'];
};


export type QueryGetAssessmentQuestionBankArgs = {
  assessmentId: Scalars['ID']['input'];
  pagination?: InputMaybe<AssessmentQuestionBankPaginationInput>;
};


export type QueryGetAssessmentSubmissionDetailsArgs = {
  assessmentSubmissionId: Scalars['ID']['input'];
  studentId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetAssignmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAssignmentAndSubmissionBySubmissionIdArgs = {
  submissionId: Scalars['ID']['input'];
};


export type QueryGetAssignmentSubmissionAttemptHistoryArgs = {
  assignmentId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryGetAssignmentsWithCourseArgs = {
  courseId?: InputMaybe<Scalars['ID']['input']>;
  schoolId: Scalars['ID']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAttemptHistoryArgs = {
  assessmentId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryGetAvailableCoursesForStudentArgs = {
  degreeId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  schoolId: Scalars['ID']['input'];
};


export type QueryGetAxioResourceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCareerByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCareerTopicsArgs = {
  careerId: Scalars['ID']['input'];
};


export type QueryGetChaptersArgs = {
  topicName: Scalars['String']['input'];
};


export type QueryGetChatByContextAndParamsArgs = {
  context: Scalars['String']['input'];
  params?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetChatByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetChatByObjectIdArgs = {
  context: Scalars['String']['input'];
  objectId: Scalars['ID']['input'];
};


export type QueryGetChatForDateArgs = {
  date: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};


export type QueryGetCompanionChatByAiTutorIdArgs = {
  aiTutorId: Scalars['ID']['input'];
};


export type QueryGetCompanionChatByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCompanionChatsForUserPreviewArgs = {
  limit: Scalars['Int']['input'];
};


export type QueryGetCompanionWorkspaceChatsArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type QueryGetCompletionAnalyticsBySchoolArgs = {
  schoolId: Scalars['ID']['input'];
};


export type QueryGetContentByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCourseActivitiesProgressArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCourseAdminStatsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCourseAnalyticsByIdArgs = {
  courseId: Scalars['ID']['input'];
};


export type QueryGetCourseByIdWithEnrolledUserInfoArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCourseByNameArgs = {
  name: Scalars['String']['input'];
};


export type QueryGetCourseChatResourcesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCourseCompletionDetailsArgs = {
  courseId: Scalars['ID']['input'];
};


export type QueryGetCourseCompletionSummaryBySchoolArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  schoolId: Scalars['ID']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCourseCoreArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCourseHierarchyArgs = {
  schoolId: Scalars['ID']['input'];
};


export type QueryGetCourseModulesActivitiesLiteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCourseModulesLiteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCourseProgressInformationArgs = {
  courseId: Scalars['ID']['input'];
};


export type QueryGetCourseSessionAnalyticsArgs = {
  input?: InputMaybe<CourseSessionAnalyticsInput>;
};


export type QueryGetCoursesAnalyticsBySchoolArgs = {
  schoolId: Scalars['ID']['input'];
};


export type QueryGetCoursesAndAssignmentsArgs = {
  schoolId: Scalars['ID']['input'];
};


export type QueryGetCoursesByDegreeByQueryArgs = {
  degreeId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCoursesByFacultyArgs = {
  schoolId: Scalars['ID']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryGetCoursesBySchoolByQueryArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  schoolId: Scalars['ID']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCoursesForTranscriptGenerationArgs = {
  schoolId: Scalars['ID']['input'];
};


export type QueryGetCoursesSummaryBySchoolArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  schoolId: Scalars['ID']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDegreeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetDegreeByNameArgs = {
  name: Scalars['String']['input'];
};


export type QueryGetDegreeBySchoolArgs = {
  schoolId: Scalars['ID']['input'];
};


export type QueryGetDegreesBySchoolByQueryArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  schoolId: Scalars['ID']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetDocumentReferenceAnalyticsArgs = {
  input?: InputMaybe<DocumentReferenceAnalyticsInput>;
};


export type QueryGetDueSoonActivitiesBySchoolAndUserArgs = {
  schoolId: Scalars['ID']['input'];
};


export type QueryGetEnrolledCoursesForStudentArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  schoolId: Scalars['ID']['input'];
  studentId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetEnrolledStudentCoursesByAdminArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  schoolId: Scalars['ID']['input'];
  sortBy?: InputMaybe<Scalars['String']['input']>;
  studentId: Scalars['ID']['input'];
};


export type QueryGetEnrollmentLinkArgs = {
  courseId: Scalars['ID']['input'];
};


export type QueryGetFacultyByCourseIdArgs = {
  courseId: Scalars['ID']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFacultyByNameOrEmailArgs = {
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  schoolId: Scalars['ID']['input'];
  searchQuery: Scalars['String']['input'];
};


export type QueryGetFacultyForSchoolArgs = {
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  schoolId: Scalars['ID']['input'];
};


export type QueryGetFileArgs = {
  fileId: Scalars['ID']['input'];
};


export type QueryGetFirstSubchapterByTopicNameArgs = {
  topicName: Scalars['String']['input'];
};


export type QueryGetFlaggedMessagesArgs = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryGetFoodsByDateArgs = {
  date: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};


export type QueryGetForumByCourseArgs = {
  courseId: Scalars['ID']['input'];
};


export type QueryGetGcpSignedUrlForReadArgs = {
  fileId: Scalars['ID']['input'];
  responseDisposition?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetGeneralCompanionChatsForUserArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryGetGradingCenterDashboardDataArgs = {
  facultyId: Scalars['ID']['input'];
};


export type QueryGetIsInvitationTokenValidArgs = {
  service: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type QueryGetLastSeenPostArgs = {
  threadId: Scalars['ID']['input'];
};


export type QueryGetLatestCourseEvaluationArgs = {
  courseId: Scalars['ID']['input'];
};


export type QueryGetLearningObjectiveByIdArgs = {
  loId: Scalars['ID']['input'];
};


export type QueryGetLearningObjectivesBySubchapterArgs = {
  learningObjectiveId: Scalars['ID']['input'];
};


export type QueryGetLearningTreeArgs = {
  level: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type QueryGetLessonPlanStatusArgs = {
  moduleId: Scalars['ID']['input'];
};


export type QueryGetMcqQuestionArgs = {
  mcqQuestionId: Scalars['ID']['input'];
};


export type QueryGetMcqQuestionsByAssessmentArgs = {
  assessmentId: Scalars['ID']['input'];
};


export type QueryGetModuleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetModuleAnalyticsByCourseArgs = {
  courseId: Scalars['ID']['input'];
};


export type QueryGetModuleCompletionDetailsArgs = {
  moduleId: Scalars['ID']['input'];
};


export type QueryGetMostRelevantVideoArgs = {
  conversationContext: Scalars['String']['input'];
  domain: Scalars['String']['input'];
  objectiveId: Scalars['ID']['input'];
};


export type QueryGetNodeArgs = {
  label: NodeLabel;
  name: Scalars['String']['input'];
};


export type QueryGetNodeChildrenArgs = {
  label: NodeLabel;
  name: Scalars['String']['input'];
};


export type QueryGetNodeParentsArgs = {
  label: NodeLabel;
  name: Scalars['String']['input'];
};


export type QueryGetNoteArgs = {
  noteId: Scalars['ID']['input'];
};


export type QueryGetNotesForStudentArgs = {
  studentId: Scalars['ID']['input'];
};


export type QueryGetOAuthClientArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetObjectiveAnalyticsByActivityArgs = {
  aiTutorId: Scalars['ID']['input'];
};


export type QueryGetObjectiveCompletionDetailsArgs = {
  objectiveId: Scalars['ID']['input'];
};


export type QueryGetPageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetPageVisitsBySessionArgs = {
  input: GetPageVisitsBySessionInput;
};


export type QueryGetPostByIdArgs = {
  postId: Scalars['ID']['input'];
};


export type QueryGetPostsByThreadArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  threadId: Scalars['ID']['input'];
};


export type QueryGetProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetProjectSubmissionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetProjectSubmissionsByProjectArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryGetProjectSubmissionsByStudentArgs = {
  studentId: Scalars['ID']['input'];
};


export type QueryGetProjectsByStudentArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetRecentTracksArgs = {
  filterByCategory?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetReviewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetRosterExportFileArgs = {
  courseId: Scalars['ID']['input'];
};


export type QueryGetSamlConfigByTenantArgs = {
  tenantId: Scalars['ID']['input'];
};


export type QueryGetSessionAnalyticsCsvStatusArgs = {
  jobId: Scalars['String']['input'];
};


export type QueryGetStudentActivityProgressArgs = {
  aiTutorId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};


export type QueryGetStudentAnalyticsBySchoolArgs = {
  schoolId: Scalars['ID']['input'];
};


export type QueryGetStudentAnalyticsForStudentArgs = {
  schoolId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};


export type QueryGetStudentChatAnalyticsArgs = {
  schoolId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};


export type QueryGetStudentCourseProgressArgs = {
  courseId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};


export type QueryGetStudentDetailedAnalyticsArgs = {
  schoolId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};


export type QueryGetStudentLearningInsightsArgs = {
  schoolId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};


export type QueryGetStudentModuleProgressArgs = {
  moduleId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
};


export type QueryGetStudentsByCourseIdArgs = {
  courseId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetStudentsByDegreeIdArgs = {
  degreeId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetStudentsSummaryBySchoolArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  schoolId: Scalars['ID']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSubchapterByIdArgs = {
  name: Scalars['String']['input'];
};


export type QueryGetSubmissionRequirementsArgs = {
  submissionId: Scalars['ID']['input'];
};


export type QueryGetTableOfContentsArgs = {
  hierarchyLabel: Scalars['String']['input'];
  learningNodeNames: Array<InputMaybe<Scalars['String']['input']>>;
};


export type QueryGetTenantByDomainArgs = {
  domain: Scalars['String']['input'];
};


export type QueryGetThreadsByCourseArgs = {
  courseId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetTodayChatArgs = {
  timezone: Scalars['String']['input'];
};


export type QueryGetTrackOverviewArgs = {
  topicName: Scalars['String']['input'];
};


export type QueryGetUnifiedSubmissionsByFacultyArgs = {
  input: GetUnifiedSubmissionsByFacultyInput;
};


export type QueryGetUnifiedSubmissionsByFacultyByUserArgs = {
  input: GetUnifiedSubmissionsByFacultyByUserInput;
};


export type QueryGetUserAnnouncementsArgs = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryGetUserChatMessageAnalyticsArgs = {
  input?: InputMaybe<UserChatMessageAnalyticsInput>;
};


export type QueryGetUserLearningObjectiveMasteryArgs = {
  learningObjectiveId: Scalars['ID']['input'];
};


export type QueryGetUserProgressArgs = {
  nodeLabel: NodeLabel;
  nodeName: Scalars['String']['input'];
};


export type QueryGetUserSessionAnalyticsArgs = {
  input?: InputMaybe<UserSessionAnalyticsInput>;
};


export type QueryGetUserSessionAnalyticsDailyBreakdownArgs = {
  input: UserSessionAnalyticsDailyBreakdownInput;
};


export type QueryGetUserSubmissionsArgs = {
  assignmentId: Scalars['ID']['input'];
};


export type QueryGetUsersForSchoolArgs = {
  fetchStudentsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  schoolId: Scalars['ID']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUsersWithElevatedRolesArgs = {
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  schoolId: Scalars['ID']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetVisitSessionsArgs = {
  input: GetVisitSessionsInput;
};


export type QueryGetVisualizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetVisualizationsForTutorArgs = {
  tutorId: Scalars['ID']['input'];
};


export type QueryGetWorksheetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLlmStreamContentBlocksArgs = {
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<LlmStreamContentBlockWhere>;
};


export type QueryLlmStreamEventsArgs = {
  options?: InputMaybe<QueryOptions>;
  where?: InputMaybe<LlmStreamEventWhere>;
};


export type QuerySearchTodosForUserArgs = {
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for options that can be specified on a query operation. */
export type QueryOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type Question = {
  __typename?: 'Question';
  aiTutor: AiTutor;
  aiTutorAggregate?: Maybe<QuestionAiTutorAiTutorAggregationSelection>;
  aiTutorConnection: QuestionAiTutorConnection;
  assessments: Array<Assessment>;
  assessmentsAggregate?: Maybe<QuestionAssessmentAssessmentsAggregationSelection>;
  assessmentsConnection: QuestionAssessmentsConnection;
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  replaces?: Maybe<Question>;
  replacesAggregate?: Maybe<QuestionQuestionReplacesAggregationSelection>;
  replacesConnection: QuestionReplacesConnection;
  rubrics: Array<Rubric>;
  rubricsAggregate?: Maybe<QuestionRubricRubricsAggregationSelection>;
  rubricsConnection: QuestionRubricsConnection;
  submissions: Array<AssessmentSubmission>;
  submissionsAggregate?: Maybe<QuestionAssessmentSubmissionSubmissionsAggregationSelection>;
  submissionsConnection: QuestionSubmissionsConnection;
  totalScore?: Maybe<Scalars['Float']['output']>;
};


export type QuestionAiTutorArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AiTutorOptions>;
  where?: InputMaybe<AiTutorWhere>;
};


export type QuestionAiTutorAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AiTutorWhere>;
};


export type QuestionAiTutorConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<QuestionAiTutorConnectionSort>>;
  where?: InputMaybe<QuestionAiTutorConnectionWhere>;
};


export type QuestionAssessmentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AssessmentOptions>;
  where?: InputMaybe<AssessmentWhere>;
};


export type QuestionAssessmentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssessmentWhere>;
};


export type QuestionAssessmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<QuestionAssessmentsConnectionSort>>;
  where?: InputMaybe<QuestionAssessmentsConnectionWhere>;
};


export type QuestionReplacesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QuestionOptions>;
  where?: InputMaybe<QuestionWhere>;
};


export type QuestionReplacesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QuestionWhere>;
};


export type QuestionReplacesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<QuestionReplacesConnectionSort>>;
  where?: InputMaybe<QuestionReplacesConnectionWhere>;
};


export type QuestionRubricsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RubricOptions>;
  where?: InputMaybe<RubricWhere>;
};


export type QuestionRubricsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RubricWhere>;
};


export type QuestionRubricsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<QuestionRubricsConnectionSort>>;
  where?: InputMaybe<QuestionRubricsConnectionWhere>;
};


export type QuestionSubmissionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AssessmentSubmissionOptions>;
  where?: InputMaybe<AssessmentSubmissionWhere>;
};


export type QuestionSubmissionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssessmentSubmissionWhere>;
};


export type QuestionSubmissionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<QuestionSubmissionsConnectionSort>>;
  where?: InputMaybe<QuestionSubmissionsConnectionWhere>;
};

export type QuestionAiTutorAiTutorAggregationSelection = {
  __typename?: 'QuestionAITutorAiTutorAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<QuestionAiTutorAiTutorNodeAggregateSelection>;
};

export type QuestionAiTutorAiTutorNodeAggregateSelection = {
  __typename?: 'QuestionAITutorAiTutorNodeAggregateSelection';
  context: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  targetAudience: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type QuestionAiTutorAggregateInput = {
  AND?: InputMaybe<Array<QuestionAiTutorAggregateInput>>;
  NOT?: InputMaybe<QuestionAiTutorAggregateInput>;
  OR?: InputMaybe<Array<QuestionAiTutorAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<QuestionAiTutorNodeAggregationWhereInput>;
};

export type QuestionAiTutorConnectFieldInput = {
  connect?: InputMaybe<AiTutorConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AiTutorConnectWhere>;
};

export type QuestionAiTutorConnectOrCreateFieldInput = {
  onCreate: QuestionAiTutorConnectOrCreateFieldInputOnCreate;
  where: AiTutorConnectOrCreateWhere;
};

export type QuestionAiTutorConnectOrCreateFieldInputOnCreate = {
  node: AiTutorOnCreateInput;
};

export type QuestionAiTutorConnection = {
  __typename?: 'QuestionAiTutorConnection';
  edges: Array<QuestionAiTutorRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestionAiTutorConnectionSort = {
  node?: InputMaybe<AiTutorSort>;
};

export type QuestionAiTutorConnectionWhere = {
  AND?: InputMaybe<Array<QuestionAiTutorConnectionWhere>>;
  NOT?: InputMaybe<QuestionAiTutorConnectionWhere>;
  OR?: InputMaybe<Array<QuestionAiTutorConnectionWhere>>;
  node?: InputMaybe<AiTutorWhere>;
};

export type QuestionAiTutorCreateFieldInput = {
  node: AiTutorCreateInput;
};

export type QuestionAiTutorDeleteFieldInput = {
  delete?: InputMaybe<AiTutorDeleteInput>;
  where?: InputMaybe<QuestionAiTutorConnectionWhere>;
};

export type QuestionAiTutorDisconnectFieldInput = {
  disconnect?: InputMaybe<AiTutorDisconnectInput>;
  where?: InputMaybe<QuestionAiTutorConnectionWhere>;
};

export type QuestionAiTutorFieldInput = {
  connect?: InputMaybe<QuestionAiTutorConnectFieldInput>;
  connectOrCreate?: InputMaybe<QuestionAiTutorConnectOrCreateFieldInput>;
  create?: InputMaybe<QuestionAiTutorCreateFieldInput>;
};

export type QuestionAiTutorNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<QuestionAiTutorNodeAggregationWhereInput>>;
  NOT?: InputMaybe<QuestionAiTutorNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<QuestionAiTutorNodeAggregationWhereInput>>;
  context_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  context_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionAiTutorRelationship = {
  __typename?: 'QuestionAiTutorRelationship';
  cursor: Scalars['String']['output'];
  node: AiTutor;
};

export type QuestionAiTutorUpdateConnectionInput = {
  node?: InputMaybe<AiTutorUpdateInput>;
};

export type QuestionAiTutorUpdateFieldInput = {
  connect?: InputMaybe<QuestionAiTutorConnectFieldInput>;
  connectOrCreate?: InputMaybe<QuestionAiTutorConnectOrCreateFieldInput>;
  create?: InputMaybe<QuestionAiTutorCreateFieldInput>;
  delete?: InputMaybe<QuestionAiTutorDeleteFieldInput>;
  disconnect?: InputMaybe<QuestionAiTutorDisconnectFieldInput>;
  update?: InputMaybe<QuestionAiTutorUpdateConnectionInput>;
  where?: InputMaybe<QuestionAiTutorConnectionWhere>;
};

export type QuestionAssessmentAssessmentsAggregationSelection = {
  __typename?: 'QuestionAssessmentAssessmentsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<QuestionAssessmentAssessmentsNodeAggregateSelection>;
};

export type QuestionAssessmentAssessmentsNodeAggregateSelection = {
  __typename?: 'QuestionAssessmentAssessmentsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  numberOfQuestions: IntAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  timeLimit: IntAggregateSelection;
};

export type QuestionAssessmentSubmissionSubmissionsAggregationSelection = {
  __typename?: 'QuestionAssessmentSubmissionSubmissionsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<QuestionAssessmentSubmissionSubmissionsEdgeAggregateSelection>;
  node?: Maybe<QuestionAssessmentSubmissionSubmissionsNodeAggregateSelection>;
};

export type QuestionAssessmentSubmissionSubmissionsEdgeAggregateSelection = {
  __typename?: 'QuestionAssessmentSubmissionSubmissionsEdgeAggregateSelection';
  aiTotalPoints: FloatAggregateSelection;
  answer: StringAggregateSelection;
  createdAt: DateTimeAggregateSelection;
  maximumPoints: FloatAggregateSelection;
  totalPoints: FloatAggregateSelection;
};

export type QuestionAssessmentSubmissionSubmissionsNodeAggregateSelection = {
  __typename?: 'QuestionAssessmentSubmissionSubmissionsNodeAggregateSelection';
  aiTotalPoints: FloatAggregateSelection;
  completedAt: DateTimeAggregateSelection;
  created: DateTimeAggregateSelection;
  feedback: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  maximumPoints: FloatAggregateSelection;
  startedAt: DateTimeAggregateSelection;
  timeLimit: IntAggregateSelection;
  totalPoints: FloatAggregateSelection;
};

export type QuestionAssessmentsAggregateInput = {
  AND?: InputMaybe<Array<QuestionAssessmentsAggregateInput>>;
  NOT?: InputMaybe<QuestionAssessmentsAggregateInput>;
  OR?: InputMaybe<Array<QuestionAssessmentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<QuestionAssessmentsNodeAggregationWhereInput>;
};

export type QuestionAssessmentsConnectFieldInput = {
  connect?: InputMaybe<Array<AssessmentConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AssessmentConnectWhere>;
};

export type QuestionAssessmentsConnectOrCreateFieldInput = {
  onCreate: QuestionAssessmentsConnectOrCreateFieldInputOnCreate;
  where: AssessmentConnectOrCreateWhere;
};

export type QuestionAssessmentsConnectOrCreateFieldInputOnCreate = {
  node: AssessmentOnCreateInput;
};

export type QuestionAssessmentsConnection = {
  __typename?: 'QuestionAssessmentsConnection';
  edges: Array<QuestionAssessmentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestionAssessmentsConnectionSort = {
  node?: InputMaybe<AssessmentSort>;
};

export type QuestionAssessmentsConnectionWhere = {
  AND?: InputMaybe<Array<QuestionAssessmentsConnectionWhere>>;
  NOT?: InputMaybe<QuestionAssessmentsConnectionWhere>;
  OR?: InputMaybe<Array<QuestionAssessmentsConnectionWhere>>;
  node?: InputMaybe<AssessmentWhere>;
};

export type QuestionAssessmentsCreateFieldInput = {
  node: AssessmentCreateInput;
};

export type QuestionAssessmentsDeleteFieldInput = {
  delete?: InputMaybe<AssessmentDeleteInput>;
  where?: InputMaybe<QuestionAssessmentsConnectionWhere>;
};

export type QuestionAssessmentsDisconnectFieldInput = {
  disconnect?: InputMaybe<AssessmentDisconnectInput>;
  where?: InputMaybe<QuestionAssessmentsConnectionWhere>;
};

export type QuestionAssessmentsFieldInput = {
  connect?: InputMaybe<Array<QuestionAssessmentsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<QuestionAssessmentsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<QuestionAssessmentsCreateFieldInput>>;
};

export type QuestionAssessmentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<QuestionAssessmentsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<QuestionAssessmentsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<QuestionAssessmentsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfQuestions_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  timeLimit_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionAssessmentsRelationship = {
  __typename?: 'QuestionAssessmentsRelationship';
  cursor: Scalars['String']['output'];
  node: Assessment;
};

export type QuestionAssessmentsUpdateConnectionInput = {
  node?: InputMaybe<AssessmentUpdateInput>;
};

export type QuestionAssessmentsUpdateFieldInput = {
  connect?: InputMaybe<Array<QuestionAssessmentsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<QuestionAssessmentsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<QuestionAssessmentsCreateFieldInput>>;
  delete?: InputMaybe<Array<QuestionAssessmentsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<QuestionAssessmentsDisconnectFieldInput>>;
  update?: InputMaybe<QuestionAssessmentsUpdateConnectionInput>;
  where?: InputMaybe<QuestionAssessmentsConnectionWhere>;
};

export type QuestionConnectInput = {
  aiTutor?: InputMaybe<QuestionAiTutorConnectFieldInput>;
  assessments?: InputMaybe<Array<QuestionAssessmentsConnectFieldInput>>;
  replaces?: InputMaybe<QuestionReplacesConnectFieldInput>;
  rubrics?: InputMaybe<Array<QuestionRubricsConnectFieldInput>>;
  submissions?: InputMaybe<Array<QuestionSubmissionsConnectFieldInput>>;
};

export type QuestionConnectOrCreateWhere = {
  node: QuestionUniqueWhere;
};

export type QuestionConnectWhere = {
  node: QuestionWhere;
};

export type QuestionCreateInput = {
  aiTutor?: InputMaybe<QuestionAiTutorFieldInput>;
  assessments?: InputMaybe<QuestionAssessmentsFieldInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  replaces?: InputMaybe<QuestionReplacesFieldInput>;
  rubrics?: InputMaybe<QuestionRubricsFieldInput>;
  submissions?: InputMaybe<QuestionSubmissionsFieldInput>;
  totalScore?: InputMaybe<Scalars['Float']['input']>;
};

export type QuestionDeleteInput = {
  aiTutor?: InputMaybe<QuestionAiTutorDeleteFieldInput>;
  assessments?: InputMaybe<Array<QuestionAssessmentsDeleteFieldInput>>;
  replaces?: InputMaybe<QuestionReplacesDeleteFieldInput>;
  rubrics?: InputMaybe<Array<QuestionRubricsDeleteFieldInput>>;
  submissions?: InputMaybe<Array<QuestionSubmissionsDeleteFieldInput>>;
};

export type QuestionDisconnectInput = {
  aiTutor?: InputMaybe<QuestionAiTutorDisconnectFieldInput>;
  assessments?: InputMaybe<Array<QuestionAssessmentsDisconnectFieldInput>>;
  replaces?: InputMaybe<QuestionReplacesDisconnectFieldInput>;
  rubrics?: InputMaybe<Array<QuestionRubricsDisconnectFieldInput>>;
  submissions?: InputMaybe<Array<QuestionSubmissionsDisconnectFieldInput>>;
};

export enum QuestionGenerationStatus {
  Completed = 'completed',
  Failed = 'failed',
  Processing = 'processing'
}

export type QuestionOnCreateInput = {
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  totalScore?: InputMaybe<Scalars['Float']['input']>;
};

export type QuestionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more QuestionSort objects to sort Questions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<QuestionSort>>;
};

export type QuestionQuestionReplacesAggregationSelection = {
  __typename?: 'QuestionQuestionReplacesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<QuestionQuestionReplacesEdgeAggregateSelection>;
  node?: Maybe<QuestionQuestionReplacesNodeAggregateSelection>;
};

export type QuestionQuestionReplacesEdgeAggregateSelection = {
  __typename?: 'QuestionQuestionReplacesEdgeAggregateSelection';
  assessmentId: IdAggregateSelection;
};

export type QuestionQuestionReplacesNodeAggregateSelection = {
  __typename?: 'QuestionQuestionReplacesNodeAggregateSelection';
  id: IdAggregateSelection;
  question: StringAggregateSelection;
  totalScore: FloatAggregateSelection;
};

export type QuestionReplacesAggregateInput = {
  AND?: InputMaybe<Array<QuestionReplacesAggregateInput>>;
  NOT?: InputMaybe<QuestionReplacesAggregateInput>;
  OR?: InputMaybe<Array<QuestionReplacesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<ReplacesPropertiesAggregationWhereInput>;
  node?: InputMaybe<QuestionReplacesNodeAggregationWhereInput>;
};

export type QuestionReplacesConnectFieldInput = {
  connect?: InputMaybe<QuestionConnectInput>;
  edge?: InputMaybe<ReplacesPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<QuestionConnectWhere>;
};

export type QuestionReplacesConnectOrCreateFieldInput = {
  onCreate: QuestionReplacesConnectOrCreateFieldInputOnCreate;
  where: QuestionConnectOrCreateWhere;
};

export type QuestionReplacesConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<ReplacesPropertiesCreateInput>;
  node: QuestionOnCreateInput;
};

export type QuestionReplacesConnection = {
  __typename?: 'QuestionReplacesConnection';
  edges: Array<QuestionReplacesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestionReplacesConnectionSort = {
  edge?: InputMaybe<ReplacesPropertiesSort>;
  node?: InputMaybe<QuestionSort>;
};

export type QuestionReplacesConnectionWhere = {
  AND?: InputMaybe<Array<QuestionReplacesConnectionWhere>>;
  NOT?: InputMaybe<QuestionReplacesConnectionWhere>;
  OR?: InputMaybe<Array<QuestionReplacesConnectionWhere>>;
  edge?: InputMaybe<ReplacesPropertiesWhere>;
  node?: InputMaybe<QuestionWhere>;
};

export type QuestionReplacesCreateFieldInput = {
  edge?: InputMaybe<ReplacesPropertiesCreateInput>;
  node: QuestionCreateInput;
};

export type QuestionReplacesDeleteFieldInput = {
  delete?: InputMaybe<QuestionDeleteInput>;
  where?: InputMaybe<QuestionReplacesConnectionWhere>;
};

export type QuestionReplacesDisconnectFieldInput = {
  disconnect?: InputMaybe<QuestionDisconnectInput>;
  where?: InputMaybe<QuestionReplacesConnectionWhere>;
};

export type QuestionReplacesFieldInput = {
  connect?: InputMaybe<QuestionReplacesConnectFieldInput>;
  connectOrCreate?: InputMaybe<QuestionReplacesConnectOrCreateFieldInput>;
  create?: InputMaybe<QuestionReplacesCreateFieldInput>;
};

export type QuestionReplacesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<QuestionReplacesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<QuestionReplacesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<QuestionReplacesNodeAggregationWhereInput>>;
  question_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  question_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalScore_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type QuestionReplacesRelationship = {
  __typename?: 'QuestionReplacesRelationship';
  cursor: Scalars['String']['output'];
  node: Question;
  properties: ReplacesProperties;
};

export type QuestionReplacesUpdateConnectionInput = {
  edge?: InputMaybe<ReplacesPropertiesUpdateInput>;
  node?: InputMaybe<QuestionUpdateInput>;
};

export type QuestionReplacesUpdateFieldInput = {
  connect?: InputMaybe<QuestionReplacesConnectFieldInput>;
  connectOrCreate?: InputMaybe<QuestionReplacesConnectOrCreateFieldInput>;
  create?: InputMaybe<QuestionReplacesCreateFieldInput>;
  delete?: InputMaybe<QuestionReplacesDeleteFieldInput>;
  disconnect?: InputMaybe<QuestionReplacesDisconnectFieldInput>;
  update?: InputMaybe<QuestionReplacesUpdateConnectionInput>;
  where?: InputMaybe<QuestionReplacesConnectionWhere>;
};

export type QuestionResponse = {
  __typename?: 'QuestionResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Question>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type QuestionRubricRubricsAggregationSelection = {
  __typename?: 'QuestionRubricRubricsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<QuestionRubricRubricsEdgeAggregateSelection>;
  node?: Maybe<QuestionRubricRubricsNodeAggregateSelection>;
};

export type QuestionRubricRubricsEdgeAggregateSelection = {
  __typename?: 'QuestionRubricRubricsEdgeAggregateSelection';
  aiPointsAwarded: FloatAggregateSelection;
  maxPoints: FloatAggregateSelection;
  pointsAwarded: FloatAggregateSelection;
  remarks: StringAggregateSelection;
};

export type QuestionRubricRubricsNodeAggregateSelection = {
  __typename?: 'QuestionRubricRubricsNodeAggregateSelection';
  component: StringAggregateSelection;
  id: IdAggregateSelection;
  points: FloatAggregateSelection;
};

export type QuestionRubricsAggregateInput = {
  AND?: InputMaybe<Array<QuestionRubricsAggregateInput>>;
  NOT?: InputMaybe<QuestionRubricsAggregateInput>;
  OR?: InputMaybe<Array<QuestionRubricsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasRubricPropertiesAggregationWhereInput>;
  node?: InputMaybe<QuestionRubricsNodeAggregationWhereInput>;
};

export type QuestionRubricsConnectFieldInput = {
  connect?: InputMaybe<Array<RubricConnectInput>>;
  edge?: InputMaybe<HasRubricPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<RubricConnectWhere>;
};

export type QuestionRubricsConnectOrCreateFieldInput = {
  onCreate: QuestionRubricsConnectOrCreateFieldInputOnCreate;
  where: RubricConnectOrCreateWhere;
};

export type QuestionRubricsConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<HasRubricPropertiesCreateInput>;
  node: RubricOnCreateInput;
};

export type QuestionRubricsConnection = {
  __typename?: 'QuestionRubricsConnection';
  edges: Array<QuestionRubricsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestionRubricsConnectionSort = {
  edge?: InputMaybe<HasRubricPropertiesSort>;
  node?: InputMaybe<RubricSort>;
};

export type QuestionRubricsConnectionWhere = {
  AND?: InputMaybe<Array<QuestionRubricsConnectionWhere>>;
  NOT?: InputMaybe<QuestionRubricsConnectionWhere>;
  OR?: InputMaybe<Array<QuestionRubricsConnectionWhere>>;
  edge?: InputMaybe<HasRubricPropertiesWhere>;
  node?: InputMaybe<RubricWhere>;
};

export type QuestionRubricsCreateFieldInput = {
  edge?: InputMaybe<HasRubricPropertiesCreateInput>;
  node: RubricCreateInput;
};

export type QuestionRubricsDeleteFieldInput = {
  delete?: InputMaybe<RubricDeleteInput>;
  where?: InputMaybe<QuestionRubricsConnectionWhere>;
};

export type QuestionRubricsDisconnectFieldInput = {
  disconnect?: InputMaybe<RubricDisconnectInput>;
  where?: InputMaybe<QuestionRubricsConnectionWhere>;
};

export type QuestionRubricsFieldInput = {
  connect?: InputMaybe<Array<QuestionRubricsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<QuestionRubricsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<QuestionRubricsCreateFieldInput>>;
};

export type QuestionRubricsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<QuestionRubricsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<QuestionRubricsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<QuestionRubricsNodeAggregationWhereInput>>;
  component_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  component_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  component_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  component_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  component_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  component_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  component_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  component_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  component_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  component_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  component_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  component_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  component_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  component_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  component_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  points_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  points_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  points_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  points_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  points_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  points_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  points_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  points_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  points_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type QuestionRubricsRelationship = {
  __typename?: 'QuestionRubricsRelationship';
  cursor: Scalars['String']['output'];
  node: Rubric;
  properties: HasRubricProperties;
};

export type QuestionRubricsUpdateConnectionInput = {
  edge?: InputMaybe<HasRubricPropertiesUpdateInput>;
  node?: InputMaybe<RubricUpdateInput>;
};

export type QuestionRubricsUpdateFieldInput = {
  connect?: InputMaybe<Array<QuestionRubricsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<QuestionRubricsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<QuestionRubricsCreateFieldInput>>;
  delete?: InputMaybe<Array<QuestionRubricsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<QuestionRubricsDisconnectFieldInput>>;
  update?: InputMaybe<QuestionRubricsUpdateConnectionInput>;
  where?: InputMaybe<QuestionRubricsConnectionWhere>;
};

/** Fields to sort Questions by. The order in which sorts are applied is not guaranteed when specifying many fields in one QuestionSort object. */
export type QuestionSort = {
  id?: InputMaybe<SortDirection>;
  isDeleted?: InputMaybe<SortDirection>;
  question?: InputMaybe<SortDirection>;
  totalScore?: InputMaybe<SortDirection>;
};

export type QuestionSubmissionsAggregateInput = {
  AND?: InputMaybe<Array<QuestionSubmissionsAggregateInput>>;
  NOT?: InputMaybe<QuestionSubmissionsAggregateInput>;
  OR?: InputMaybe<Array<QuestionSubmissionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasAnswerPropertiesAggregationWhereInput>;
  node?: InputMaybe<QuestionSubmissionsNodeAggregationWhereInput>;
};

export type QuestionSubmissionsConnectFieldInput = {
  connect?: InputMaybe<Array<AssessmentSubmissionConnectInput>>;
  edge?: InputMaybe<HasAnswerPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AssessmentSubmissionConnectWhere>;
};

export type QuestionSubmissionsConnectOrCreateFieldInput = {
  onCreate: QuestionSubmissionsConnectOrCreateFieldInputOnCreate;
  where: AssessmentSubmissionConnectOrCreateWhere;
};

export type QuestionSubmissionsConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<HasAnswerPropertiesCreateInput>;
  node: AssessmentSubmissionOnCreateInput;
};

export type QuestionSubmissionsConnection = {
  __typename?: 'QuestionSubmissionsConnection';
  edges: Array<QuestionSubmissionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestionSubmissionsConnectionSort = {
  edge?: InputMaybe<HasAnswerPropertiesSort>;
  node?: InputMaybe<AssessmentSubmissionSort>;
};

export type QuestionSubmissionsConnectionWhere = {
  AND?: InputMaybe<Array<QuestionSubmissionsConnectionWhere>>;
  NOT?: InputMaybe<QuestionSubmissionsConnectionWhere>;
  OR?: InputMaybe<Array<QuestionSubmissionsConnectionWhere>>;
  edge?: InputMaybe<HasAnswerPropertiesWhere>;
  node?: InputMaybe<AssessmentSubmissionWhere>;
};

export type QuestionSubmissionsCreateFieldInput = {
  edge?: InputMaybe<HasAnswerPropertiesCreateInput>;
  node: AssessmentSubmissionCreateInput;
};

export type QuestionSubmissionsDeleteFieldInput = {
  delete?: InputMaybe<AssessmentSubmissionDeleteInput>;
  where?: InputMaybe<QuestionSubmissionsConnectionWhere>;
};

export type QuestionSubmissionsDisconnectFieldInput = {
  disconnect?: InputMaybe<AssessmentSubmissionDisconnectInput>;
  where?: InputMaybe<QuestionSubmissionsConnectionWhere>;
};

export type QuestionSubmissionsFieldInput = {
  connect?: InputMaybe<Array<QuestionSubmissionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<QuestionSubmissionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<QuestionSubmissionsCreateFieldInput>>;
};

export type QuestionSubmissionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<QuestionSubmissionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<QuestionSubmissionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<QuestionSubmissionsNodeAggregationWhereInput>>;
  aiTotalPoints_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  completedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  feedback_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  feedback_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  maximumPoints_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  startedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  timeLimit_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalPoints_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type QuestionSubmissionsRelationship = {
  __typename?: 'QuestionSubmissionsRelationship';
  cursor: Scalars['String']['output'];
  node: AssessmentSubmission;
  properties: HasAnswerProperties;
};

export type QuestionSubmissionsUpdateConnectionInput = {
  edge?: InputMaybe<HasAnswerPropertiesUpdateInput>;
  node?: InputMaybe<AssessmentSubmissionUpdateInput>;
};

export type QuestionSubmissionsUpdateFieldInput = {
  connect?: InputMaybe<Array<QuestionSubmissionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<QuestionSubmissionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<QuestionSubmissionsCreateFieldInput>>;
  delete?: InputMaybe<Array<QuestionSubmissionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<QuestionSubmissionsDisconnectFieldInput>>;
  update?: InputMaybe<QuestionSubmissionsUpdateConnectionInput>;
  where?: InputMaybe<QuestionSubmissionsConnectionWhere>;
};

export type QuestionUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QuestionUpdateInput = {
  aiTutor?: InputMaybe<QuestionAiTutorUpdateFieldInput>;
  assessments?: InputMaybe<Array<QuestionAssessmentsUpdateFieldInput>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  replaces?: InputMaybe<QuestionReplacesUpdateFieldInput>;
  rubrics?: InputMaybe<Array<QuestionRubricsUpdateFieldInput>>;
  submissions?: InputMaybe<Array<QuestionSubmissionsUpdateFieldInput>>;
  totalScore?: InputMaybe<Scalars['Float']['input']>;
  totalScore_ADD?: InputMaybe<Scalars['Float']['input']>;
  totalScore_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
};

export type QuestionWhere = {
  AND?: InputMaybe<Array<QuestionWhere>>;
  NOT?: InputMaybe<QuestionWhere>;
  OR?: InputMaybe<Array<QuestionWhere>>;
  aiTutor?: InputMaybe<AiTutorWhere>;
  aiTutorAggregate?: InputMaybe<QuestionAiTutorAggregateInput>;
  aiTutorConnection?: InputMaybe<QuestionAiTutorConnectionWhere>;
  aiTutorConnection_NOT?: InputMaybe<QuestionAiTutorConnectionWhere>;
  aiTutor_NOT?: InputMaybe<AiTutorWhere>;
  assessmentsAggregate?: InputMaybe<QuestionAssessmentsAggregateInput>;
  /** Return Questions where all of the related QuestionAssessmentsConnections match this filter */
  assessmentsConnection_ALL?: InputMaybe<QuestionAssessmentsConnectionWhere>;
  /** Return Questions where none of the related QuestionAssessmentsConnections match this filter */
  assessmentsConnection_NONE?: InputMaybe<QuestionAssessmentsConnectionWhere>;
  /** Return Questions where one of the related QuestionAssessmentsConnections match this filter */
  assessmentsConnection_SINGLE?: InputMaybe<QuestionAssessmentsConnectionWhere>;
  /** Return Questions where some of the related QuestionAssessmentsConnections match this filter */
  assessmentsConnection_SOME?: InputMaybe<QuestionAssessmentsConnectionWhere>;
  /** Return Questions where all of the related Assessments match this filter */
  assessments_ALL?: InputMaybe<AssessmentWhere>;
  /** Return Questions where none of the related Assessments match this filter */
  assessments_NONE?: InputMaybe<AssessmentWhere>;
  /** Return Questions where one of the related Assessments match this filter */
  assessments_SINGLE?: InputMaybe<AssessmentWhere>;
  /** Return Questions where some of the related Assessments match this filter */
  assessments_SOME?: InputMaybe<AssessmentWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  question_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  question_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  question_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  question_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  replaces?: InputMaybe<QuestionWhere>;
  replacesAggregate?: InputMaybe<QuestionReplacesAggregateInput>;
  replacesConnection?: InputMaybe<QuestionReplacesConnectionWhere>;
  replacesConnection_NOT?: InputMaybe<QuestionReplacesConnectionWhere>;
  replaces_NOT?: InputMaybe<QuestionWhere>;
  rubricsAggregate?: InputMaybe<QuestionRubricsAggregateInput>;
  /** Return Questions where all of the related QuestionRubricsConnections match this filter */
  rubricsConnection_ALL?: InputMaybe<QuestionRubricsConnectionWhere>;
  /** Return Questions where none of the related QuestionRubricsConnections match this filter */
  rubricsConnection_NONE?: InputMaybe<QuestionRubricsConnectionWhere>;
  /** Return Questions where one of the related QuestionRubricsConnections match this filter */
  rubricsConnection_SINGLE?: InputMaybe<QuestionRubricsConnectionWhere>;
  /** Return Questions where some of the related QuestionRubricsConnections match this filter */
  rubricsConnection_SOME?: InputMaybe<QuestionRubricsConnectionWhere>;
  /** Return Questions where all of the related Rubrics match this filter */
  rubrics_ALL?: InputMaybe<RubricWhere>;
  /** Return Questions where none of the related Rubrics match this filter */
  rubrics_NONE?: InputMaybe<RubricWhere>;
  /** Return Questions where one of the related Rubrics match this filter */
  rubrics_SINGLE?: InputMaybe<RubricWhere>;
  /** Return Questions where some of the related Rubrics match this filter */
  rubrics_SOME?: InputMaybe<RubricWhere>;
  submissionsAggregate?: InputMaybe<QuestionSubmissionsAggregateInput>;
  /** Return Questions where all of the related QuestionSubmissionsConnections match this filter */
  submissionsConnection_ALL?: InputMaybe<QuestionSubmissionsConnectionWhere>;
  /** Return Questions where none of the related QuestionSubmissionsConnections match this filter */
  submissionsConnection_NONE?: InputMaybe<QuestionSubmissionsConnectionWhere>;
  /** Return Questions where one of the related QuestionSubmissionsConnections match this filter */
  submissionsConnection_SINGLE?: InputMaybe<QuestionSubmissionsConnectionWhere>;
  /** Return Questions where some of the related QuestionSubmissionsConnections match this filter */
  submissionsConnection_SOME?: InputMaybe<QuestionSubmissionsConnectionWhere>;
  /** Return Questions where all of the related AssessmentSubmissions match this filter */
  submissions_ALL?: InputMaybe<AssessmentSubmissionWhere>;
  /** Return Questions where none of the related AssessmentSubmissions match this filter */
  submissions_NONE?: InputMaybe<AssessmentSubmissionWhere>;
  /** Return Questions where one of the related AssessmentSubmissions match this filter */
  submissions_SINGLE?: InputMaybe<AssessmentSubmissionWhere>;
  /** Return Questions where some of the related AssessmentSubmissions match this filter */
  submissions_SOME?: InputMaybe<AssessmentSubmissionWhere>;
  totalScore?: InputMaybe<Scalars['Float']['input']>;
  totalScore_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  totalScore_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type RateLimitResult = {
  __typename?: 'RateLimitResult';
  dailyRequests?: Maybe<Scalars['Int']['output']>;
  result?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * The edge properties for the following fields:
 * * User.threadReadStates
 * * Thread.readStates
 */
export type ReadStateProperties = {
  __typename?: 'ReadStateProperties';
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  lastSeenPostId?: Maybe<Scalars['String']['output']>;
};

export type ReadStatePropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<ReadStatePropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<ReadStatePropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<ReadStatePropertiesAggregationWhereInput>>;
  lastSeenAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastSeenAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSeenAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSeenAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSeenAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSeenAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastSeenAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSeenAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSeenAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSeenAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSeenPostId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastSeenPostId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastSeenPostId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastSeenPostId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastSeenPostId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastSeenPostId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastSeenPostId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastSeenPostId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastSeenPostId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastSeenPostId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastSeenPostId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastSeenPostId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastSeenPostId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastSeenPostId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastSeenPostId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ReadStatePropertiesCreateInput = {
  lastSeenAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastSeenPostId?: InputMaybe<Scalars['String']['input']>;
};

export type ReadStatePropertiesSort = {
  lastSeenAt?: InputMaybe<SortDirection>;
  lastSeenPostId?: InputMaybe<SortDirection>;
};

export type ReadStatePropertiesUpdateInput = {
  lastSeenAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastSeenPostId?: InputMaybe<Scalars['String']['input']>;
};

export type ReadStatePropertiesWhere = {
  AND?: InputMaybe<Array<ReadStatePropertiesWhere>>;
  NOT?: InputMaybe<ReadStatePropertiesWhere>;
  OR?: InputMaybe<Array<ReadStatePropertiesWhere>>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastSeenAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSeenAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSeenAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastSeenAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSeenAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSeenPostId?: InputMaybe<Scalars['String']['input']>;
  lastSeenPostId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lastSeenPostId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastSeenPostId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastSeenPostId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type RecentTrack = {
  __typename?: 'RecentTrack';
  completedUnits?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  mastery?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  parentFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  parentSubfield?: Maybe<Scalars['String']['output']>;
  totalUnits?: Maybe<Scalars['Int']['output']>;
};

export type Reflection = {
  __typename?: 'Reflection';
  context?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  sentiment?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type RemoveCoursesFromDegreeInput = {
  courseIds: Array<Scalars['ID']['input']>;
  degreeId: Scalars['ID']['input'];
};

export type RemoveStudentsFromDegreeInput = {
  degreeId: Scalars['ID']['input'];
  studentIds: Array<Scalars['ID']['input']>;
};

/**
 * The edge properties for the following fields:
 * * Question.replaces
 * * McqQuestion.replaces
 */
export type ReplacesProperties = {
  __typename?: 'ReplacesProperties';
  assessmentId?: Maybe<Scalars['ID']['output']>;
};

export type ReplacesPropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<ReplacesPropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<ReplacesPropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<ReplacesPropertiesAggregationWhereInput>>;
};

export type ReplacesPropertiesCreateInput = {
  assessmentId?: InputMaybe<Scalars['ID']['input']>;
};

export type ReplacesPropertiesSort = {
  assessmentId?: InputMaybe<SortDirection>;
};

export type ReplacesPropertiesUpdateInput = {
  assessmentId?: InputMaybe<Scalars['ID']['input']>;
};

export type ReplacesPropertiesWhere = {
  AND?: InputMaybe<Array<ReplacesPropertiesWhere>>;
  NOT?: InputMaybe<ReplacesPropertiesWhere>;
  OR?: InputMaybe<Array<ReplacesPropertiesWhere>>;
  assessmentId?: InputMaybe<Scalars['ID']['input']>;
  assessmentId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  assessmentId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  assessmentId_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  assessmentId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type RequestExportData = {
  __typename?: 'RequestExportData';
  jobId?: Maybe<Scalars['ID']['output']>;
};

export type RequestExportResponse = {
  __typename?: 'RequestExportResponse';
  data?: Maybe<RequestExportData>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum RequirementType {
  Deliverable = 'DELIVERABLE',
  Documentation = 'DOCUMENTATION',
  Milestone = 'MILESTONE',
  Presentation = 'PRESENTATION',
  Research = 'RESEARCH',
  Testing = 'TESTING'
}

export type ResetAiTutorInput = {
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type ResponseType = {
  __typename?: 'ResponseType';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type Review = {
  __typename?: 'Review';
  activityState?: Maybe<ActivityState>;
  created?: Maybe<Scalars['DateTime']['output']>;
  generatingReviewAITutorFor: Array<User>;
  generatingReviewAITutorForAggregate?: Maybe<ReviewUserGeneratingReviewAiTutorForAggregationSelection>;
  generatingReviewAITutorForConnection: ReviewGeneratingReviewAiTutorForConnection;
  hasAITutors: Array<AiTutor>;
  hasAITutorsAggregate?: Maybe<ReviewAiTutorHasAiTutorsAggregationSelection>;
  hasAITutorsConnection: ReviewHasAiTutorsConnection;
  hasReviewFor: Assessment;
  hasReviewForAggregate?: Maybe<ReviewAssessmentHasReviewForAggregationSelection>;
  hasReviewForConnection: ReviewHasReviewForConnection;
  id: Scalars['ID']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  moduleHasReviews: Array<Module>;
  moduleHasReviewsAggregate?: Maybe<ReviewModuleModuleHasReviewsAggregationSelection>;
  moduleHasReviewsConnection: ReviewModuleHasReviewsConnection;
  scheduledDate?: Maybe<Scalars['DateTime']['output']>;
};


export type ReviewGeneratingReviewAiTutorForArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type ReviewGeneratingReviewAiTutorForAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type ReviewGeneratingReviewAiTutorForConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ReviewGeneratingReviewAiTutorForConnectionSort>>;
  where?: InputMaybe<ReviewGeneratingReviewAiTutorForConnectionWhere>;
};


export type ReviewHasAiTutorsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AiTutorOptions>;
  where?: InputMaybe<AiTutorWhere>;
};


export type ReviewHasAiTutorsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AiTutorWhere>;
};


export type ReviewHasAiTutorsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ReviewHasAiTutorsConnectionSort>>;
  where?: InputMaybe<ReviewHasAiTutorsConnectionWhere>;
};


export type ReviewHasReviewForArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AssessmentOptions>;
  where?: InputMaybe<AssessmentWhere>;
};


export type ReviewHasReviewForAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssessmentWhere>;
};


export type ReviewHasReviewForConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ReviewHasReviewForConnectionSort>>;
  where?: InputMaybe<ReviewHasReviewForConnectionWhere>;
};


export type ReviewModuleHasReviewsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ModuleOptions>;
  where?: InputMaybe<ModuleWhere>;
};


export type ReviewModuleHasReviewsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ModuleWhere>;
};


export type ReviewModuleHasReviewsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ReviewModuleHasReviewsConnectionSort>>;
  where?: InputMaybe<ReviewModuleHasReviewsConnectionWhere>;
};

export type ReviewAiTutorHasAiTutorsAggregationSelection = {
  __typename?: 'ReviewAITutorHasAITutorsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ReviewAiTutorHasAiTutorsNodeAggregateSelection>;
};

export type ReviewAiTutorHasAiTutorsNodeAggregateSelection = {
  __typename?: 'ReviewAITutorHasAITutorsNodeAggregateSelection';
  context: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  targetAudience: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type ReviewAssessmentHasReviewForAggregationSelection = {
  __typename?: 'ReviewAssessmentHasReviewForAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ReviewAssessmentHasReviewForNodeAggregateSelection>;
};

export type ReviewAssessmentHasReviewForNodeAggregateSelection = {
  __typename?: 'ReviewAssessmentHasReviewForNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  numberOfQuestions: IntAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  timeLimit: IntAggregateSelection;
};

export type ReviewConnectInput = {
  generatingReviewAITutorFor?: InputMaybe<Array<ReviewGeneratingReviewAiTutorForConnectFieldInput>>;
  hasAITutors?: InputMaybe<Array<ReviewHasAiTutorsConnectFieldInput>>;
  hasReviewFor?: InputMaybe<ReviewHasReviewForConnectFieldInput>;
  moduleHasReviews?: InputMaybe<Array<ReviewModuleHasReviewsConnectFieldInput>>;
};

export type ReviewConnectOrCreateWhere = {
  node: ReviewUniqueWhere;
};

export type ReviewConnectWhere = {
  node: ReviewWhere;
};

export type ReviewCreateInput = {
  activityState?: InputMaybe<ActivityState>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  generatingReviewAITutorFor?: InputMaybe<ReviewGeneratingReviewAiTutorForFieldInput>;
  hasAITutors?: InputMaybe<ReviewHasAiTutorsFieldInput>;
  hasReviewFor?: InputMaybe<ReviewHasReviewForFieldInput>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  moduleHasReviews?: InputMaybe<ReviewModuleHasReviewsFieldInput>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ReviewDeleteInput = {
  generatingReviewAITutorFor?: InputMaybe<Array<ReviewGeneratingReviewAiTutorForDeleteFieldInput>>;
  hasAITutors?: InputMaybe<Array<ReviewHasAiTutorsDeleteFieldInput>>;
  hasReviewFor?: InputMaybe<ReviewHasReviewForDeleteFieldInput>;
  moduleHasReviews?: InputMaybe<Array<ReviewModuleHasReviewsDeleteFieldInput>>;
};

export type ReviewDisconnectInput = {
  generatingReviewAITutorFor?: InputMaybe<Array<ReviewGeneratingReviewAiTutorForDisconnectFieldInput>>;
  hasAITutors?: InputMaybe<Array<ReviewHasAiTutorsDisconnectFieldInput>>;
  hasReviewFor?: InputMaybe<ReviewHasReviewForDisconnectFieldInput>;
  moduleHasReviews?: InputMaybe<Array<ReviewModuleHasReviewsDisconnectFieldInput>>;
};

/**
 * The edge properties for the following fields:
 * * User.reviewAITutorBeingGeneratedFor
 * * Review.generatingReviewAITutorFor
 */
export type ReviewGeneratingForProperties = {
  __typename?: 'ReviewGeneratingForProperties';
  isGenerating?: Maybe<Scalars['Boolean']['output']>;
};

export type ReviewGeneratingForPropertiesCreateInput = {
  isGenerating?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReviewGeneratingForPropertiesSort = {
  isGenerating?: InputMaybe<SortDirection>;
};

export type ReviewGeneratingForPropertiesUpdateInput = {
  isGenerating?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReviewGeneratingForPropertiesWhere = {
  AND?: InputMaybe<Array<ReviewGeneratingForPropertiesWhere>>;
  NOT?: InputMaybe<ReviewGeneratingForPropertiesWhere>;
  OR?: InputMaybe<Array<ReviewGeneratingForPropertiesWhere>>;
  isGenerating?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReviewGeneratingReviewAiTutorForAggregateInput = {
  AND?: InputMaybe<Array<ReviewGeneratingReviewAiTutorForAggregateInput>>;
  NOT?: InputMaybe<ReviewGeneratingReviewAiTutorForAggregateInput>;
  OR?: InputMaybe<Array<ReviewGeneratingReviewAiTutorForAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ReviewGeneratingReviewAiTutorForNodeAggregationWhereInput>;
};

export type ReviewGeneratingReviewAiTutorForConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  edge?: InputMaybe<ReviewGeneratingForPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type ReviewGeneratingReviewAiTutorForConnectOrCreateFieldInput = {
  onCreate: ReviewGeneratingReviewAiTutorForConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type ReviewGeneratingReviewAiTutorForConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<ReviewGeneratingForPropertiesCreateInput>;
  node: UserOnCreateInput;
};

export type ReviewGeneratingReviewAiTutorForConnection = {
  __typename?: 'ReviewGeneratingReviewAITutorForConnection';
  edges: Array<ReviewGeneratingReviewAiTutorForRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ReviewGeneratingReviewAiTutorForConnectionSort = {
  edge?: InputMaybe<ReviewGeneratingForPropertiesSort>;
  node?: InputMaybe<UserSort>;
};

export type ReviewGeneratingReviewAiTutorForConnectionWhere = {
  AND?: InputMaybe<Array<ReviewGeneratingReviewAiTutorForConnectionWhere>>;
  NOT?: InputMaybe<ReviewGeneratingReviewAiTutorForConnectionWhere>;
  OR?: InputMaybe<Array<ReviewGeneratingReviewAiTutorForConnectionWhere>>;
  edge?: InputMaybe<ReviewGeneratingForPropertiesWhere>;
  node?: InputMaybe<UserWhere>;
};

export type ReviewGeneratingReviewAiTutorForCreateFieldInput = {
  edge?: InputMaybe<ReviewGeneratingForPropertiesCreateInput>;
  node: UserCreateInput;
};

export type ReviewGeneratingReviewAiTutorForDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<ReviewGeneratingReviewAiTutorForConnectionWhere>;
};

export type ReviewGeneratingReviewAiTutorForDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<ReviewGeneratingReviewAiTutorForConnectionWhere>;
};

export type ReviewGeneratingReviewAiTutorForFieldInput = {
  connect?: InputMaybe<Array<ReviewGeneratingReviewAiTutorForConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ReviewGeneratingReviewAiTutorForConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ReviewGeneratingReviewAiTutorForCreateFieldInput>>;
};

export type ReviewGeneratingReviewAiTutorForNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ReviewGeneratingReviewAiTutorForNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ReviewGeneratingReviewAiTutorForNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ReviewGeneratingReviewAiTutorForNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ReviewGeneratingReviewAiTutorForRelationship = {
  __typename?: 'ReviewGeneratingReviewAITutorForRelationship';
  cursor: Scalars['String']['output'];
  node: User;
  properties: ReviewGeneratingForProperties;
};

export type ReviewGeneratingReviewAiTutorForUpdateConnectionInput = {
  edge?: InputMaybe<ReviewGeneratingForPropertiesUpdateInput>;
  node?: InputMaybe<UserUpdateInput>;
};

export type ReviewGeneratingReviewAiTutorForUpdateFieldInput = {
  connect?: InputMaybe<Array<ReviewGeneratingReviewAiTutorForConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ReviewGeneratingReviewAiTutorForConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ReviewGeneratingReviewAiTutorForCreateFieldInput>>;
  delete?: InputMaybe<Array<ReviewGeneratingReviewAiTutorForDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ReviewGeneratingReviewAiTutorForDisconnectFieldInput>>;
  update?: InputMaybe<ReviewGeneratingReviewAiTutorForUpdateConnectionInput>;
  where?: InputMaybe<ReviewGeneratingReviewAiTutorForConnectionWhere>;
};

export type ReviewHasAiTutorsAggregateInput = {
  AND?: InputMaybe<Array<ReviewHasAiTutorsAggregateInput>>;
  NOT?: InputMaybe<ReviewHasAiTutorsAggregateInput>;
  OR?: InputMaybe<Array<ReviewHasAiTutorsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ReviewHasAiTutorsNodeAggregationWhereInput>;
};

export type ReviewHasAiTutorsConnectFieldInput = {
  connect?: InputMaybe<Array<AiTutorConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AiTutorConnectWhere>;
};

export type ReviewHasAiTutorsConnectOrCreateFieldInput = {
  onCreate: ReviewHasAiTutorsConnectOrCreateFieldInputOnCreate;
  where: AiTutorConnectOrCreateWhere;
};

export type ReviewHasAiTutorsConnectOrCreateFieldInputOnCreate = {
  node: AiTutorOnCreateInput;
};

export type ReviewHasAiTutorsConnection = {
  __typename?: 'ReviewHasAITutorsConnection';
  edges: Array<ReviewHasAiTutorsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ReviewHasAiTutorsConnectionSort = {
  node?: InputMaybe<AiTutorSort>;
};

export type ReviewHasAiTutorsConnectionWhere = {
  AND?: InputMaybe<Array<ReviewHasAiTutorsConnectionWhere>>;
  NOT?: InputMaybe<ReviewHasAiTutorsConnectionWhere>;
  OR?: InputMaybe<Array<ReviewHasAiTutorsConnectionWhere>>;
  node?: InputMaybe<AiTutorWhere>;
};

export type ReviewHasAiTutorsCreateFieldInput = {
  node: AiTutorCreateInput;
};

export type ReviewHasAiTutorsDeleteFieldInput = {
  delete?: InputMaybe<AiTutorDeleteInput>;
  where?: InputMaybe<ReviewHasAiTutorsConnectionWhere>;
};

export type ReviewHasAiTutorsDisconnectFieldInput = {
  disconnect?: InputMaybe<AiTutorDisconnectInput>;
  where?: InputMaybe<ReviewHasAiTutorsConnectionWhere>;
};

export type ReviewHasAiTutorsFieldInput = {
  connect?: InputMaybe<Array<ReviewHasAiTutorsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ReviewHasAiTutorsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ReviewHasAiTutorsCreateFieldInput>>;
};

export type ReviewHasAiTutorsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ReviewHasAiTutorsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ReviewHasAiTutorsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ReviewHasAiTutorsNodeAggregationWhereInput>>;
  context_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  context_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ReviewHasAiTutorsRelationship = {
  __typename?: 'ReviewHasAITutorsRelationship';
  cursor: Scalars['String']['output'];
  node: AiTutor;
};

export type ReviewHasAiTutorsUpdateConnectionInput = {
  node?: InputMaybe<AiTutorUpdateInput>;
};

export type ReviewHasAiTutorsUpdateFieldInput = {
  connect?: InputMaybe<Array<ReviewHasAiTutorsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ReviewHasAiTutorsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ReviewHasAiTutorsCreateFieldInput>>;
  delete?: InputMaybe<Array<ReviewHasAiTutorsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ReviewHasAiTutorsDisconnectFieldInput>>;
  update?: InputMaybe<ReviewHasAiTutorsUpdateConnectionInput>;
  where?: InputMaybe<ReviewHasAiTutorsConnectionWhere>;
};

export type ReviewHasReviewForAggregateInput = {
  AND?: InputMaybe<Array<ReviewHasReviewForAggregateInput>>;
  NOT?: InputMaybe<ReviewHasReviewForAggregateInput>;
  OR?: InputMaybe<Array<ReviewHasReviewForAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ReviewHasReviewForNodeAggregationWhereInput>;
};

export type ReviewHasReviewForConnectFieldInput = {
  connect?: InputMaybe<AssessmentConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AssessmentConnectWhere>;
};

export type ReviewHasReviewForConnectOrCreateFieldInput = {
  onCreate: ReviewHasReviewForConnectOrCreateFieldInputOnCreate;
  where: AssessmentConnectOrCreateWhere;
};

export type ReviewHasReviewForConnectOrCreateFieldInputOnCreate = {
  node: AssessmentOnCreateInput;
};

export type ReviewHasReviewForConnection = {
  __typename?: 'ReviewHasReviewForConnection';
  edges: Array<ReviewHasReviewForRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ReviewHasReviewForConnectionSort = {
  node?: InputMaybe<AssessmentSort>;
};

export type ReviewHasReviewForConnectionWhere = {
  AND?: InputMaybe<Array<ReviewHasReviewForConnectionWhere>>;
  NOT?: InputMaybe<ReviewHasReviewForConnectionWhere>;
  OR?: InputMaybe<Array<ReviewHasReviewForConnectionWhere>>;
  node?: InputMaybe<AssessmentWhere>;
};

export type ReviewHasReviewForCreateFieldInput = {
  node: AssessmentCreateInput;
};

export type ReviewHasReviewForDeleteFieldInput = {
  delete?: InputMaybe<AssessmentDeleteInput>;
  where?: InputMaybe<ReviewHasReviewForConnectionWhere>;
};

export type ReviewHasReviewForDisconnectFieldInput = {
  disconnect?: InputMaybe<AssessmentDisconnectInput>;
  where?: InputMaybe<ReviewHasReviewForConnectionWhere>;
};

export type ReviewHasReviewForFieldInput = {
  connect?: InputMaybe<ReviewHasReviewForConnectFieldInput>;
  connectOrCreate?: InputMaybe<ReviewHasReviewForConnectOrCreateFieldInput>;
  create?: InputMaybe<ReviewHasReviewForCreateFieldInput>;
};

export type ReviewHasReviewForNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ReviewHasReviewForNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ReviewHasReviewForNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ReviewHasReviewForNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  numberOfQuestions_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  numberOfQuestions_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfQuestions_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  timeLimit_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ReviewHasReviewForRelationship = {
  __typename?: 'ReviewHasReviewForRelationship';
  cursor: Scalars['String']['output'];
  node: Assessment;
};

export type ReviewHasReviewForUpdateConnectionInput = {
  node?: InputMaybe<AssessmentUpdateInput>;
};

export type ReviewHasReviewForUpdateFieldInput = {
  connect?: InputMaybe<ReviewHasReviewForConnectFieldInput>;
  connectOrCreate?: InputMaybe<ReviewHasReviewForConnectOrCreateFieldInput>;
  create?: InputMaybe<ReviewHasReviewForCreateFieldInput>;
  delete?: InputMaybe<ReviewHasReviewForDeleteFieldInput>;
  disconnect?: InputMaybe<ReviewHasReviewForDisconnectFieldInput>;
  update?: InputMaybe<ReviewHasReviewForUpdateConnectionInput>;
  where?: InputMaybe<ReviewHasReviewForConnectionWhere>;
};

export type ReviewModuleHasReviewsAggregateInput = {
  AND?: InputMaybe<Array<ReviewModuleHasReviewsAggregateInput>>;
  NOT?: InputMaybe<ReviewModuleHasReviewsAggregateInput>;
  OR?: InputMaybe<Array<ReviewModuleHasReviewsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ReviewModuleHasReviewsNodeAggregationWhereInput>;
};

export type ReviewModuleHasReviewsConnectFieldInput = {
  connect?: InputMaybe<Array<ModuleConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ModuleConnectWhere>;
};

export type ReviewModuleHasReviewsConnectOrCreateFieldInput = {
  onCreate: ReviewModuleHasReviewsConnectOrCreateFieldInputOnCreate;
  where: ModuleConnectOrCreateWhere;
};

export type ReviewModuleHasReviewsConnectOrCreateFieldInputOnCreate = {
  node: ModuleOnCreateInput;
};

export type ReviewModuleHasReviewsConnection = {
  __typename?: 'ReviewModuleHasReviewsConnection';
  edges: Array<ReviewModuleHasReviewsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ReviewModuleHasReviewsConnectionSort = {
  node?: InputMaybe<ModuleSort>;
};

export type ReviewModuleHasReviewsConnectionWhere = {
  AND?: InputMaybe<Array<ReviewModuleHasReviewsConnectionWhere>>;
  NOT?: InputMaybe<ReviewModuleHasReviewsConnectionWhere>;
  OR?: InputMaybe<Array<ReviewModuleHasReviewsConnectionWhere>>;
  node?: InputMaybe<ModuleWhere>;
};

export type ReviewModuleHasReviewsCreateFieldInput = {
  node: ModuleCreateInput;
};

export type ReviewModuleHasReviewsDeleteFieldInput = {
  delete?: InputMaybe<ModuleDeleteInput>;
  where?: InputMaybe<ReviewModuleHasReviewsConnectionWhere>;
};

export type ReviewModuleHasReviewsDisconnectFieldInput = {
  disconnect?: InputMaybe<ModuleDisconnectInput>;
  where?: InputMaybe<ReviewModuleHasReviewsConnectionWhere>;
};

export type ReviewModuleHasReviewsFieldInput = {
  connect?: InputMaybe<Array<ReviewModuleHasReviewsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ReviewModuleHasReviewsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ReviewModuleHasReviewsCreateFieldInput>>;
};

export type ReviewModuleHasReviewsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ReviewModuleHasReviewsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ReviewModuleHasReviewsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ReviewModuleHasReviewsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  module_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  module_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  module_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  module_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  module_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ReviewModuleHasReviewsRelationship = {
  __typename?: 'ReviewModuleHasReviewsRelationship';
  cursor: Scalars['String']['output'];
  node: Module;
};

export type ReviewModuleHasReviewsUpdateConnectionInput = {
  node?: InputMaybe<ModuleUpdateInput>;
};

export type ReviewModuleHasReviewsUpdateFieldInput = {
  connect?: InputMaybe<Array<ReviewModuleHasReviewsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ReviewModuleHasReviewsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ReviewModuleHasReviewsCreateFieldInput>>;
  delete?: InputMaybe<Array<ReviewModuleHasReviewsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ReviewModuleHasReviewsDisconnectFieldInput>>;
  update?: InputMaybe<ReviewModuleHasReviewsUpdateConnectionInput>;
  where?: InputMaybe<ReviewModuleHasReviewsConnectionWhere>;
};

export type ReviewModuleModuleHasReviewsAggregationSelection = {
  __typename?: 'ReviewModuleModuleHasReviewsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ReviewModuleModuleHasReviewsNodeAggregateSelection>;
};

export type ReviewModuleModuleHasReviewsNodeAggregateSelection = {
  __typename?: 'ReviewModuleModuleHasReviewsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  module_name: StringAggregateSelection;
  thumbnail: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type ReviewOnCreateInput = {
  activityState?: InputMaybe<ActivityState>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ReviewOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ReviewSort objects to sort Reviews by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ReviewSort>>;
};

export type ReviewResponse = {
  __typename?: 'ReviewResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<Review>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Fields to sort Reviews by. The order in which sorts are applied is not guaranteed when specifying many fields in one ReviewSort object. */
export type ReviewSort = {
  activityState?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastModified?: InputMaybe<SortDirection>;
  scheduledDate?: InputMaybe<SortDirection>;
};

export type ReviewUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ReviewUpdateInput = {
  activityState?: InputMaybe<ActivityState>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  generatingReviewAITutorFor?: InputMaybe<Array<ReviewGeneratingReviewAiTutorForUpdateFieldInput>>;
  hasAITutors?: InputMaybe<Array<ReviewHasAiTutorsUpdateFieldInput>>;
  hasReviewFor?: InputMaybe<ReviewHasReviewForUpdateFieldInput>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  moduleHasReviews?: InputMaybe<Array<ReviewModuleHasReviewsUpdateFieldInput>>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ReviewUserGeneratingReviewAiTutorForAggregationSelection = {
  __typename?: 'ReviewUserGeneratingReviewAITutorForAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ReviewUserGeneratingReviewAiTutorForNodeAggregateSelection>;
};

export type ReviewUserGeneratingReviewAiTutorForNodeAggregateSelection = {
  __typename?: 'ReviewUserGeneratingReviewAITutorForNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type ReviewWhere = {
  AND?: InputMaybe<Array<ReviewWhere>>;
  NOT?: InputMaybe<ReviewWhere>;
  OR?: InputMaybe<Array<ReviewWhere>>;
  activityState?: InputMaybe<ActivityState>;
  activityState_IN?: InputMaybe<Array<InputMaybe<ActivityState>>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  generatingReviewAITutorForAggregate?: InputMaybe<ReviewGeneratingReviewAiTutorForAggregateInput>;
  /** Return Reviews where all of the related ReviewGeneratingReviewAITutorForConnections match this filter */
  generatingReviewAITutorForConnection_ALL?: InputMaybe<ReviewGeneratingReviewAiTutorForConnectionWhere>;
  /** Return Reviews where none of the related ReviewGeneratingReviewAITutorForConnections match this filter */
  generatingReviewAITutorForConnection_NONE?: InputMaybe<ReviewGeneratingReviewAiTutorForConnectionWhere>;
  /** Return Reviews where one of the related ReviewGeneratingReviewAITutorForConnections match this filter */
  generatingReviewAITutorForConnection_SINGLE?: InputMaybe<ReviewGeneratingReviewAiTutorForConnectionWhere>;
  /** Return Reviews where some of the related ReviewGeneratingReviewAITutorForConnections match this filter */
  generatingReviewAITutorForConnection_SOME?: InputMaybe<ReviewGeneratingReviewAiTutorForConnectionWhere>;
  /** Return Reviews where all of the related Users match this filter */
  generatingReviewAITutorFor_ALL?: InputMaybe<UserWhere>;
  /** Return Reviews where none of the related Users match this filter */
  generatingReviewAITutorFor_NONE?: InputMaybe<UserWhere>;
  /** Return Reviews where one of the related Users match this filter */
  generatingReviewAITutorFor_SINGLE?: InputMaybe<UserWhere>;
  /** Return Reviews where some of the related Users match this filter */
  generatingReviewAITutorFor_SOME?: InputMaybe<UserWhere>;
  hasAITutorsAggregate?: InputMaybe<ReviewHasAiTutorsAggregateInput>;
  /** Return Reviews where all of the related ReviewHasAITutorsConnections match this filter */
  hasAITutorsConnection_ALL?: InputMaybe<ReviewHasAiTutorsConnectionWhere>;
  /** Return Reviews where none of the related ReviewHasAITutorsConnections match this filter */
  hasAITutorsConnection_NONE?: InputMaybe<ReviewHasAiTutorsConnectionWhere>;
  /** Return Reviews where one of the related ReviewHasAITutorsConnections match this filter */
  hasAITutorsConnection_SINGLE?: InputMaybe<ReviewHasAiTutorsConnectionWhere>;
  /** Return Reviews where some of the related ReviewHasAITutorsConnections match this filter */
  hasAITutorsConnection_SOME?: InputMaybe<ReviewHasAiTutorsConnectionWhere>;
  /** Return Reviews where all of the related AITutors match this filter */
  hasAITutors_ALL?: InputMaybe<AiTutorWhere>;
  /** Return Reviews where none of the related AITutors match this filter */
  hasAITutors_NONE?: InputMaybe<AiTutorWhere>;
  /** Return Reviews where one of the related AITutors match this filter */
  hasAITutors_SINGLE?: InputMaybe<AiTutorWhere>;
  /** Return Reviews where some of the related AITutors match this filter */
  hasAITutors_SOME?: InputMaybe<AiTutorWhere>;
  hasReviewFor?: InputMaybe<AssessmentWhere>;
  hasReviewForAggregate?: InputMaybe<ReviewHasReviewForAggregateInput>;
  hasReviewForConnection?: InputMaybe<ReviewHasReviewForConnectionWhere>;
  hasReviewForConnection_NOT?: InputMaybe<ReviewHasReviewForConnectionWhere>;
  hasReviewFor_NOT?: InputMaybe<AssessmentWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastModified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  moduleHasReviewsAggregate?: InputMaybe<ReviewModuleHasReviewsAggregateInput>;
  /** Return Reviews where all of the related ReviewModuleHasReviewsConnections match this filter */
  moduleHasReviewsConnection_ALL?: InputMaybe<ReviewModuleHasReviewsConnectionWhere>;
  /** Return Reviews where none of the related ReviewModuleHasReviewsConnections match this filter */
  moduleHasReviewsConnection_NONE?: InputMaybe<ReviewModuleHasReviewsConnectionWhere>;
  /** Return Reviews where one of the related ReviewModuleHasReviewsConnections match this filter */
  moduleHasReviewsConnection_SINGLE?: InputMaybe<ReviewModuleHasReviewsConnectionWhere>;
  /** Return Reviews where some of the related ReviewModuleHasReviewsConnections match this filter */
  moduleHasReviewsConnection_SOME?: InputMaybe<ReviewModuleHasReviewsConnectionWhere>;
  /** Return Reviews where all of the related Modules match this filter */
  moduleHasReviews_ALL?: InputMaybe<ModuleWhere>;
  /** Return Reviews where none of the related Modules match this filter */
  moduleHasReviews_NONE?: InputMaybe<ModuleWhere>;
  /** Return Reviews where one of the related Modules match this filter */
  moduleHasReviews_SINGLE?: InputMaybe<ModuleWhere>;
  /** Return Reviews where some of the related Modules match this filter */
  moduleHasReviews_SOME?: InputMaybe<ModuleWhere>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  scheduledDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Role = {
  __typename?: 'Role';
  inheritsFromRole: Array<Role>;
  inheritsFromRoleAggregate?: Maybe<RoleRoleInheritsFromRoleAggregationSelection>;
  inheritsFromRoleConnection: RoleInheritsFromRoleConnection;
  name: Scalars['String']['output'];
  permissions: Array<Permission>;
  permissionsAggregate?: Maybe<RolePermissionPermissionsAggregationSelection>;
  permissionsConnection: RolePermissionsConnection;
  usersHasRole: Array<User>;
  usersHasRoleAggregate?: Maybe<RoleUserUsersHasRoleAggregationSelection>;
  usersHasRoleConnection: RoleUsersHasRoleConnection;
};


export type RoleInheritsFromRoleArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RoleOptions>;
  where?: InputMaybe<RoleWhere>;
};


export type RoleInheritsFromRoleAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RoleWhere>;
};


export type RoleInheritsFromRoleConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RoleInheritsFromRoleConnectionSort>>;
  where?: InputMaybe<RoleInheritsFromRoleConnectionWhere>;
};


export type RolePermissionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PermissionOptions>;
  where?: InputMaybe<PermissionWhere>;
};


export type RolePermissionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PermissionWhere>;
};


export type RolePermissionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RolePermissionsConnectionSort>>;
  where?: InputMaybe<RolePermissionsConnectionWhere>;
};


export type RoleUsersHasRoleArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type RoleUsersHasRoleAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type RoleUsersHasRoleConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RoleUsersHasRoleConnectionSort>>;
  where?: InputMaybe<RoleUsersHasRoleConnectionWhere>;
};

export type RoleConnectInput = {
  inheritsFromRole?: InputMaybe<Array<RoleInheritsFromRoleConnectFieldInput>>;
  permissions?: InputMaybe<Array<RolePermissionsConnectFieldInput>>;
  usersHasRole?: InputMaybe<Array<RoleUsersHasRoleConnectFieldInput>>;
};

export type RoleConnectWhere = {
  node: RoleWhere;
};

export type RoleCreateInput = {
  inheritsFromRole?: InputMaybe<RoleInheritsFromRoleFieldInput>;
  name: Scalars['String']['input'];
  permissions?: InputMaybe<RolePermissionsFieldInput>;
  usersHasRole?: InputMaybe<RoleUsersHasRoleFieldInput>;
};

export type RoleDeleteInput = {
  inheritsFromRole?: InputMaybe<Array<RoleInheritsFromRoleDeleteFieldInput>>;
  permissions?: InputMaybe<Array<RolePermissionsDeleteFieldInput>>;
  usersHasRole?: InputMaybe<Array<RoleUsersHasRoleDeleteFieldInput>>;
};

export type RoleDisconnectInput = {
  inheritsFromRole?: InputMaybe<Array<RoleInheritsFromRoleDisconnectFieldInput>>;
  permissions?: InputMaybe<Array<RolePermissionsDisconnectFieldInput>>;
  usersHasRole?: InputMaybe<Array<RoleUsersHasRoleDisconnectFieldInput>>;
};

export type RoleInheritsFromRoleAggregateInput = {
  AND?: InputMaybe<Array<RoleInheritsFromRoleAggregateInput>>;
  NOT?: InputMaybe<RoleInheritsFromRoleAggregateInput>;
  OR?: InputMaybe<Array<RoleInheritsFromRoleAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RoleInheritsFromRoleNodeAggregationWhereInput>;
};

export type RoleInheritsFromRoleConnectFieldInput = {
  connect?: InputMaybe<Array<RoleConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<RoleConnectWhere>;
};

export type RoleInheritsFromRoleConnection = {
  __typename?: 'RoleInheritsFromRoleConnection';
  edges: Array<RoleInheritsFromRoleRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RoleInheritsFromRoleConnectionSort = {
  node?: InputMaybe<RoleSort>;
};

export type RoleInheritsFromRoleConnectionWhere = {
  AND?: InputMaybe<Array<RoleInheritsFromRoleConnectionWhere>>;
  NOT?: InputMaybe<RoleInheritsFromRoleConnectionWhere>;
  OR?: InputMaybe<Array<RoleInheritsFromRoleConnectionWhere>>;
  node?: InputMaybe<RoleWhere>;
};

export type RoleInheritsFromRoleCreateFieldInput = {
  node: RoleCreateInput;
};

export type RoleInheritsFromRoleDeleteFieldInput = {
  delete?: InputMaybe<RoleDeleteInput>;
  where?: InputMaybe<RoleInheritsFromRoleConnectionWhere>;
};

export type RoleInheritsFromRoleDisconnectFieldInput = {
  disconnect?: InputMaybe<RoleDisconnectInput>;
  where?: InputMaybe<RoleInheritsFromRoleConnectionWhere>;
};

export type RoleInheritsFromRoleFieldInput = {
  connect?: InputMaybe<Array<RoleInheritsFromRoleConnectFieldInput>>;
  create?: InputMaybe<Array<RoleInheritsFromRoleCreateFieldInput>>;
};

export type RoleInheritsFromRoleNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RoleInheritsFromRoleNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RoleInheritsFromRoleNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RoleInheritsFromRoleNodeAggregationWhereInput>>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type RoleInheritsFromRoleRelationship = {
  __typename?: 'RoleInheritsFromRoleRelationship';
  cursor: Scalars['String']['output'];
  node: Role;
};

export type RoleInheritsFromRoleUpdateConnectionInput = {
  node?: InputMaybe<RoleUpdateInput>;
};

export type RoleInheritsFromRoleUpdateFieldInput = {
  connect?: InputMaybe<Array<RoleInheritsFromRoleConnectFieldInput>>;
  create?: InputMaybe<Array<RoleInheritsFromRoleCreateFieldInput>>;
  delete?: InputMaybe<Array<RoleInheritsFromRoleDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<RoleInheritsFromRoleDisconnectFieldInput>>;
  update?: InputMaybe<RoleInheritsFromRoleUpdateConnectionInput>;
  where?: InputMaybe<RoleInheritsFromRoleConnectionWhere>;
};

export type RoleOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more RoleSort objects to sort Roles by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<RoleSort>>;
};

export type RolePermissionPermissionsAggregationSelection = {
  __typename?: 'RolePermissionPermissionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<RolePermissionPermissionsNodeAggregateSelection>;
};

export type RolePermissionPermissionsNodeAggregateSelection = {
  __typename?: 'RolePermissionPermissionsNodeAggregateSelection';
  name: StringAggregateSelection;
};

export type RolePermissionsAggregateInput = {
  AND?: InputMaybe<Array<RolePermissionsAggregateInput>>;
  NOT?: InputMaybe<RolePermissionsAggregateInput>;
  OR?: InputMaybe<Array<RolePermissionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RolePermissionsNodeAggregationWhereInput>;
};

export type RolePermissionsConnectFieldInput = {
  connect?: InputMaybe<Array<PermissionConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PermissionConnectWhere>;
};

export type RolePermissionsConnection = {
  __typename?: 'RolePermissionsConnection';
  edges: Array<RolePermissionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RolePermissionsConnectionSort = {
  node?: InputMaybe<PermissionSort>;
};

export type RolePermissionsConnectionWhere = {
  AND?: InputMaybe<Array<RolePermissionsConnectionWhere>>;
  NOT?: InputMaybe<RolePermissionsConnectionWhere>;
  OR?: InputMaybe<Array<RolePermissionsConnectionWhere>>;
  node?: InputMaybe<PermissionWhere>;
};

export type RolePermissionsCreateFieldInput = {
  node: PermissionCreateInput;
};

export type RolePermissionsDeleteFieldInput = {
  delete?: InputMaybe<PermissionDeleteInput>;
  where?: InputMaybe<RolePermissionsConnectionWhere>;
};

export type RolePermissionsDisconnectFieldInput = {
  disconnect?: InputMaybe<PermissionDisconnectInput>;
  where?: InputMaybe<RolePermissionsConnectionWhere>;
};

export type RolePermissionsFieldInput = {
  connect?: InputMaybe<Array<RolePermissionsConnectFieldInput>>;
  create?: InputMaybe<Array<RolePermissionsCreateFieldInput>>;
};

export type RolePermissionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RolePermissionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RolePermissionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RolePermissionsNodeAggregationWhereInput>>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type RolePermissionsRelationship = {
  __typename?: 'RolePermissionsRelationship';
  cursor: Scalars['String']['output'];
  node: Permission;
};

export type RolePermissionsUpdateConnectionInput = {
  node?: InputMaybe<PermissionUpdateInput>;
};

export type RolePermissionsUpdateFieldInput = {
  connect?: InputMaybe<Array<RolePermissionsConnectFieldInput>>;
  create?: InputMaybe<Array<RolePermissionsCreateFieldInput>>;
  delete?: InputMaybe<Array<RolePermissionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<RolePermissionsDisconnectFieldInput>>;
  update?: InputMaybe<RolePermissionsUpdateConnectionInput>;
  where?: InputMaybe<RolePermissionsConnectionWhere>;
};

export type RoleRoleInheritsFromRoleAggregationSelection = {
  __typename?: 'RoleRoleInheritsFromRoleAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<RoleRoleInheritsFromRoleNodeAggregateSelection>;
};

export type RoleRoleInheritsFromRoleNodeAggregateSelection = {
  __typename?: 'RoleRoleInheritsFromRoleNodeAggregateSelection';
  name: StringAggregateSelection;
};

/** Fields to sort Roles by. The order in which sorts are applied is not guaranteed when specifying many fields in one RoleSort object. */
export type RoleSort = {
  name?: InputMaybe<SortDirection>;
};

export type RoleUpdateInput = {
  inheritsFromRole?: InputMaybe<Array<RoleInheritsFromRoleUpdateFieldInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<RolePermissionsUpdateFieldInput>>;
  usersHasRole?: InputMaybe<Array<RoleUsersHasRoleUpdateFieldInput>>;
};

export type RoleUserUsersHasRoleAggregationSelection = {
  __typename?: 'RoleUserUsersHasRoleAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<RoleUserUsersHasRoleEdgeAggregateSelection>;
  node?: Maybe<RoleUserUsersHasRoleNodeAggregateSelection>;
};

export type RoleUserUsersHasRoleEdgeAggregateSelection = {
  __typename?: 'RoleUserUsersHasRoleEdgeAggregateSelection';
  tenantId: IdAggregateSelection;
};

export type RoleUserUsersHasRoleNodeAggregateSelection = {
  __typename?: 'RoleUserUsersHasRoleNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type RoleUsersHasRoleAggregateInput = {
  AND?: InputMaybe<Array<RoleUsersHasRoleAggregateInput>>;
  NOT?: InputMaybe<RoleUsersHasRoleAggregateInput>;
  OR?: InputMaybe<Array<RoleUsersHasRoleAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<UserRolePropertiesAggregationWhereInput>;
  node?: InputMaybe<RoleUsersHasRoleNodeAggregationWhereInput>;
};

export type RoleUsersHasRoleConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  edge: UserRolePropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type RoleUsersHasRoleConnectOrCreateFieldInput = {
  onCreate: RoleUsersHasRoleConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type RoleUsersHasRoleConnectOrCreateFieldInputOnCreate = {
  edge: UserRolePropertiesCreateInput;
  node: UserOnCreateInput;
};

export type RoleUsersHasRoleConnection = {
  __typename?: 'RoleUsersHasRoleConnection';
  edges: Array<RoleUsersHasRoleRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RoleUsersHasRoleConnectionSort = {
  edge?: InputMaybe<UserRolePropertiesSort>;
  node?: InputMaybe<UserSort>;
};

export type RoleUsersHasRoleConnectionWhere = {
  AND?: InputMaybe<Array<RoleUsersHasRoleConnectionWhere>>;
  NOT?: InputMaybe<RoleUsersHasRoleConnectionWhere>;
  OR?: InputMaybe<Array<RoleUsersHasRoleConnectionWhere>>;
  edge?: InputMaybe<UserRolePropertiesWhere>;
  node?: InputMaybe<UserWhere>;
};

export type RoleUsersHasRoleCreateFieldInput = {
  edge: UserRolePropertiesCreateInput;
  node: UserCreateInput;
};

export type RoleUsersHasRoleDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<RoleUsersHasRoleConnectionWhere>;
};

export type RoleUsersHasRoleDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<RoleUsersHasRoleConnectionWhere>;
};

export type RoleUsersHasRoleFieldInput = {
  connect?: InputMaybe<Array<RoleUsersHasRoleConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<RoleUsersHasRoleConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<RoleUsersHasRoleCreateFieldInput>>;
};

export type RoleUsersHasRoleNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RoleUsersHasRoleNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RoleUsersHasRoleNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RoleUsersHasRoleNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type RoleUsersHasRoleRelationship = {
  __typename?: 'RoleUsersHasRoleRelationship';
  cursor: Scalars['String']['output'];
  node: User;
  properties: UserRoleProperties;
};

export type RoleUsersHasRoleUpdateConnectionInput = {
  edge?: InputMaybe<UserRolePropertiesUpdateInput>;
  node?: InputMaybe<UserUpdateInput>;
};

export type RoleUsersHasRoleUpdateFieldInput = {
  connect?: InputMaybe<Array<RoleUsersHasRoleConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<RoleUsersHasRoleConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<RoleUsersHasRoleCreateFieldInput>>;
  delete?: InputMaybe<Array<RoleUsersHasRoleDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<RoleUsersHasRoleDisconnectFieldInput>>;
  update?: InputMaybe<RoleUsersHasRoleUpdateConnectionInput>;
  where?: InputMaybe<RoleUsersHasRoleConnectionWhere>;
};

export type RoleWhere = {
  AND?: InputMaybe<Array<RoleWhere>>;
  NOT?: InputMaybe<RoleWhere>;
  OR?: InputMaybe<Array<RoleWhere>>;
  inheritsFromRoleAggregate?: InputMaybe<RoleInheritsFromRoleAggregateInput>;
  /** Return Roles where all of the related RoleInheritsFromRoleConnections match this filter */
  inheritsFromRoleConnection_ALL?: InputMaybe<RoleInheritsFromRoleConnectionWhere>;
  /** Return Roles where none of the related RoleInheritsFromRoleConnections match this filter */
  inheritsFromRoleConnection_NONE?: InputMaybe<RoleInheritsFromRoleConnectionWhere>;
  /** Return Roles where one of the related RoleInheritsFromRoleConnections match this filter */
  inheritsFromRoleConnection_SINGLE?: InputMaybe<RoleInheritsFromRoleConnectionWhere>;
  /** Return Roles where some of the related RoleInheritsFromRoleConnections match this filter */
  inheritsFromRoleConnection_SOME?: InputMaybe<RoleInheritsFromRoleConnectionWhere>;
  /** Return Roles where all of the related Roles match this filter */
  inheritsFromRole_ALL?: InputMaybe<RoleWhere>;
  /** Return Roles where none of the related Roles match this filter */
  inheritsFromRole_NONE?: InputMaybe<RoleWhere>;
  /** Return Roles where one of the related Roles match this filter */
  inheritsFromRole_SINGLE?: InputMaybe<RoleWhere>;
  /** Return Roles where some of the related Roles match this filter */
  inheritsFromRole_SOME?: InputMaybe<RoleWhere>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  permissionsAggregate?: InputMaybe<RolePermissionsAggregateInput>;
  /** Return Roles where all of the related RolePermissionsConnections match this filter */
  permissionsConnection_ALL?: InputMaybe<RolePermissionsConnectionWhere>;
  /** Return Roles where none of the related RolePermissionsConnections match this filter */
  permissionsConnection_NONE?: InputMaybe<RolePermissionsConnectionWhere>;
  /** Return Roles where one of the related RolePermissionsConnections match this filter */
  permissionsConnection_SINGLE?: InputMaybe<RolePermissionsConnectionWhere>;
  /** Return Roles where some of the related RolePermissionsConnections match this filter */
  permissionsConnection_SOME?: InputMaybe<RolePermissionsConnectionWhere>;
  /** Return Roles where all of the related Permissions match this filter */
  permissions_ALL?: InputMaybe<PermissionWhere>;
  /** Return Roles where none of the related Permissions match this filter */
  permissions_NONE?: InputMaybe<PermissionWhere>;
  /** Return Roles where one of the related Permissions match this filter */
  permissions_SINGLE?: InputMaybe<PermissionWhere>;
  /** Return Roles where some of the related Permissions match this filter */
  permissions_SOME?: InputMaybe<PermissionWhere>;
  usersHasRoleAggregate?: InputMaybe<RoleUsersHasRoleAggregateInput>;
  /** Return Roles where all of the related RoleUsersHasRoleConnections match this filter */
  usersHasRoleConnection_ALL?: InputMaybe<RoleUsersHasRoleConnectionWhere>;
  /** Return Roles where none of the related RoleUsersHasRoleConnections match this filter */
  usersHasRoleConnection_NONE?: InputMaybe<RoleUsersHasRoleConnectionWhere>;
  /** Return Roles where one of the related RoleUsersHasRoleConnections match this filter */
  usersHasRoleConnection_SINGLE?: InputMaybe<RoleUsersHasRoleConnectionWhere>;
  /** Return Roles where some of the related RoleUsersHasRoleConnections match this filter */
  usersHasRoleConnection_SOME?: InputMaybe<RoleUsersHasRoleConnectionWhere>;
  /** Return Roles where all of the related Users match this filter */
  usersHasRole_ALL?: InputMaybe<UserWhere>;
  /** Return Roles where none of the related Users match this filter */
  usersHasRole_NONE?: InputMaybe<UserWhere>;
  /** Return Roles where one of the related Users match this filter */
  usersHasRole_SINGLE?: InputMaybe<UserWhere>;
  /** Return Roles where some of the related Users match this filter */
  usersHasRole_SOME?: InputMaybe<UserWhere>;
};

export type Rubric = {
  __typename?: 'Rubric';
  component?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  points?: Maybe<Scalars['Float']['output']>;
  question: Question;
  questionAggregate?: Maybe<RubricQuestionQuestionAggregationSelection>;
  questionConnection: RubricQuestionConnection;
  submissions: Array<AssessmentSubmission>;
  submissionsAggregate?: Maybe<RubricAssessmentSubmissionSubmissionsAggregationSelection>;
  submissionsConnection: RubricSubmissionsConnection;
};


export type RubricQuestionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QuestionOptions>;
  where?: InputMaybe<QuestionWhere>;
};


export type RubricQuestionAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QuestionWhere>;
};


export type RubricQuestionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RubricQuestionConnectionSort>>;
  where?: InputMaybe<RubricQuestionConnectionWhere>;
};


export type RubricSubmissionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AssessmentSubmissionOptions>;
  where?: InputMaybe<AssessmentSubmissionWhere>;
};


export type RubricSubmissionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssessmentSubmissionWhere>;
};


export type RubricSubmissionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RubricSubmissionsConnectionSort>>;
  where?: InputMaybe<RubricSubmissionsConnectionWhere>;
};

export type RubricAssessmentSubmissionSubmissionsAggregationSelection = {
  __typename?: 'RubricAssessmentSubmissionSubmissionsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<RubricAssessmentSubmissionSubmissionsEdgeAggregateSelection>;
  node?: Maybe<RubricAssessmentSubmissionSubmissionsNodeAggregateSelection>;
};

export type RubricAssessmentSubmissionSubmissionsEdgeAggregateSelection = {
  __typename?: 'RubricAssessmentSubmissionSubmissionsEdgeAggregateSelection';
  aiPointsAwarded: FloatAggregateSelection;
  maxPoints: FloatAggregateSelection;
  pointsAwarded: FloatAggregateSelection;
  remarks: StringAggregateSelection;
};

export type RubricAssessmentSubmissionSubmissionsNodeAggregateSelection = {
  __typename?: 'RubricAssessmentSubmissionSubmissionsNodeAggregateSelection';
  aiTotalPoints: FloatAggregateSelection;
  completedAt: DateTimeAggregateSelection;
  created: DateTimeAggregateSelection;
  feedback: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  maximumPoints: FloatAggregateSelection;
  startedAt: DateTimeAggregateSelection;
  timeLimit: IntAggregateSelection;
  totalPoints: FloatAggregateSelection;
};

export type RubricConnectInput = {
  question?: InputMaybe<RubricQuestionConnectFieldInput>;
  submissions?: InputMaybe<Array<RubricSubmissionsConnectFieldInput>>;
};

export type RubricConnectOrCreateWhere = {
  node: RubricUniqueWhere;
};

export type RubricConnectWhere = {
  node: RubricWhere;
};

export type RubricCreateInput = {
  component?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Float']['input']>;
  question?: InputMaybe<RubricQuestionFieldInput>;
  submissions?: InputMaybe<RubricSubmissionsFieldInput>;
};

export type RubricDeleteInput = {
  question?: InputMaybe<RubricQuestionDeleteFieldInput>;
  submissions?: InputMaybe<Array<RubricSubmissionsDeleteFieldInput>>;
};

export type RubricDisconnectInput = {
  question?: InputMaybe<RubricQuestionDisconnectFieldInput>;
  submissions?: InputMaybe<Array<RubricSubmissionsDisconnectFieldInput>>;
};

export type RubricOnCreateInput = {
  component?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Float']['input']>;
};

export type RubricOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more RubricSort objects to sort Rubrics by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<RubricSort>>;
};

export type RubricQuestionAggregateInput = {
  AND?: InputMaybe<Array<RubricQuestionAggregateInput>>;
  NOT?: InputMaybe<RubricQuestionAggregateInput>;
  OR?: InputMaybe<Array<RubricQuestionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasRubricPropertiesAggregationWhereInput>;
  node?: InputMaybe<RubricQuestionNodeAggregationWhereInput>;
};

export type RubricQuestionConnectFieldInput = {
  connect?: InputMaybe<QuestionConnectInput>;
  edge?: InputMaybe<HasRubricPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<QuestionConnectWhere>;
};

export type RubricQuestionConnectOrCreateFieldInput = {
  onCreate: RubricQuestionConnectOrCreateFieldInputOnCreate;
  where: QuestionConnectOrCreateWhere;
};

export type RubricQuestionConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<HasRubricPropertiesCreateInput>;
  node: QuestionOnCreateInput;
};

export type RubricQuestionConnection = {
  __typename?: 'RubricQuestionConnection';
  edges: Array<RubricQuestionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RubricQuestionConnectionSort = {
  edge?: InputMaybe<HasRubricPropertiesSort>;
  node?: InputMaybe<QuestionSort>;
};

export type RubricQuestionConnectionWhere = {
  AND?: InputMaybe<Array<RubricQuestionConnectionWhere>>;
  NOT?: InputMaybe<RubricQuestionConnectionWhere>;
  OR?: InputMaybe<Array<RubricQuestionConnectionWhere>>;
  edge?: InputMaybe<HasRubricPropertiesWhere>;
  node?: InputMaybe<QuestionWhere>;
};

export type RubricQuestionCreateFieldInput = {
  edge?: InputMaybe<HasRubricPropertiesCreateInput>;
  node: QuestionCreateInput;
};

export type RubricQuestionDeleteFieldInput = {
  delete?: InputMaybe<QuestionDeleteInput>;
  where?: InputMaybe<RubricQuestionConnectionWhere>;
};

export type RubricQuestionDisconnectFieldInput = {
  disconnect?: InputMaybe<QuestionDisconnectInput>;
  where?: InputMaybe<RubricQuestionConnectionWhere>;
};

export type RubricQuestionFieldInput = {
  connect?: InputMaybe<RubricQuestionConnectFieldInput>;
  connectOrCreate?: InputMaybe<RubricQuestionConnectOrCreateFieldInput>;
  create?: InputMaybe<RubricQuestionCreateFieldInput>;
};

export type RubricQuestionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RubricQuestionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RubricQuestionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RubricQuestionNodeAggregationWhereInput>>;
  question_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  question_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalScore_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type RubricQuestionQuestionAggregationSelection = {
  __typename?: 'RubricQuestionQuestionAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<RubricQuestionQuestionEdgeAggregateSelection>;
  node?: Maybe<RubricQuestionQuestionNodeAggregateSelection>;
};

export type RubricQuestionQuestionEdgeAggregateSelection = {
  __typename?: 'RubricQuestionQuestionEdgeAggregateSelection';
  aiPointsAwarded: FloatAggregateSelection;
  maxPoints: FloatAggregateSelection;
  pointsAwarded: FloatAggregateSelection;
  remarks: StringAggregateSelection;
};

export type RubricQuestionQuestionNodeAggregateSelection = {
  __typename?: 'RubricQuestionQuestionNodeAggregateSelection';
  id: IdAggregateSelection;
  question: StringAggregateSelection;
  totalScore: FloatAggregateSelection;
};

export type RubricQuestionRelationship = {
  __typename?: 'RubricQuestionRelationship';
  cursor: Scalars['String']['output'];
  node: Question;
  properties: HasRubricProperties;
};

export type RubricQuestionUpdateConnectionInput = {
  edge?: InputMaybe<HasRubricPropertiesUpdateInput>;
  node?: InputMaybe<QuestionUpdateInput>;
};

export type RubricQuestionUpdateFieldInput = {
  connect?: InputMaybe<RubricQuestionConnectFieldInput>;
  connectOrCreate?: InputMaybe<RubricQuestionConnectOrCreateFieldInput>;
  create?: InputMaybe<RubricQuestionCreateFieldInput>;
  delete?: InputMaybe<RubricQuestionDeleteFieldInput>;
  disconnect?: InputMaybe<RubricQuestionDisconnectFieldInput>;
  update?: InputMaybe<RubricQuestionUpdateConnectionInput>;
  where?: InputMaybe<RubricQuestionConnectionWhere>;
};

/** Fields to sort Rubrics by. The order in which sorts are applied is not guaranteed when specifying many fields in one RubricSort object. */
export type RubricSort = {
  component?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  points?: InputMaybe<SortDirection>;
};

export type RubricSubmissionsAggregateInput = {
  AND?: InputMaybe<Array<RubricSubmissionsAggregateInput>>;
  NOT?: InputMaybe<RubricSubmissionsAggregateInput>;
  OR?: InputMaybe<Array<RubricSubmissionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasRubricPropertiesAggregationWhereInput>;
  node?: InputMaybe<RubricSubmissionsNodeAggregationWhereInput>;
};

export type RubricSubmissionsConnectFieldInput = {
  connect?: InputMaybe<Array<AssessmentSubmissionConnectInput>>;
  edge?: InputMaybe<HasRubricPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AssessmentSubmissionConnectWhere>;
};

export type RubricSubmissionsConnectOrCreateFieldInput = {
  onCreate: RubricSubmissionsConnectOrCreateFieldInputOnCreate;
  where: AssessmentSubmissionConnectOrCreateWhere;
};

export type RubricSubmissionsConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<HasRubricPropertiesCreateInput>;
  node: AssessmentSubmissionOnCreateInput;
};

export type RubricSubmissionsConnection = {
  __typename?: 'RubricSubmissionsConnection';
  edges: Array<RubricSubmissionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RubricSubmissionsConnectionSort = {
  edge?: InputMaybe<HasRubricPropertiesSort>;
  node?: InputMaybe<AssessmentSubmissionSort>;
};

export type RubricSubmissionsConnectionWhere = {
  AND?: InputMaybe<Array<RubricSubmissionsConnectionWhere>>;
  NOT?: InputMaybe<RubricSubmissionsConnectionWhere>;
  OR?: InputMaybe<Array<RubricSubmissionsConnectionWhere>>;
  edge?: InputMaybe<HasRubricPropertiesWhere>;
  node?: InputMaybe<AssessmentSubmissionWhere>;
};

export type RubricSubmissionsCreateFieldInput = {
  edge?: InputMaybe<HasRubricPropertiesCreateInput>;
  node: AssessmentSubmissionCreateInput;
};

export type RubricSubmissionsDeleteFieldInput = {
  delete?: InputMaybe<AssessmentSubmissionDeleteInput>;
  where?: InputMaybe<RubricSubmissionsConnectionWhere>;
};

export type RubricSubmissionsDisconnectFieldInput = {
  disconnect?: InputMaybe<AssessmentSubmissionDisconnectInput>;
  where?: InputMaybe<RubricSubmissionsConnectionWhere>;
};

export type RubricSubmissionsFieldInput = {
  connect?: InputMaybe<Array<RubricSubmissionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<RubricSubmissionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<RubricSubmissionsCreateFieldInput>>;
};

export type RubricSubmissionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RubricSubmissionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RubricSubmissionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RubricSubmissionsNodeAggregationWhereInput>>;
  aiTotalPoints_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  completedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  feedback_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  feedback_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  maximumPoints_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  startedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  timeLimit_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalPoints_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type RubricSubmissionsRelationship = {
  __typename?: 'RubricSubmissionsRelationship';
  cursor: Scalars['String']['output'];
  node: AssessmentSubmission;
  properties: HasRubricProperties;
};

export type RubricSubmissionsUpdateConnectionInput = {
  edge?: InputMaybe<HasRubricPropertiesUpdateInput>;
  node?: InputMaybe<AssessmentSubmissionUpdateInput>;
};

export type RubricSubmissionsUpdateFieldInput = {
  connect?: InputMaybe<Array<RubricSubmissionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<RubricSubmissionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<RubricSubmissionsCreateFieldInput>>;
  delete?: InputMaybe<Array<RubricSubmissionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<RubricSubmissionsDisconnectFieldInput>>;
  update?: InputMaybe<RubricSubmissionsUpdateConnectionInput>;
  where?: InputMaybe<RubricSubmissionsConnectionWhere>;
};

export type RubricUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type RubricUpdateInput = {
  component?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Float']['input']>;
  points_ADD?: InputMaybe<Scalars['Float']['input']>;
  points_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  points_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  points_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  question?: InputMaybe<RubricQuestionUpdateFieldInput>;
  submissions?: InputMaybe<Array<RubricSubmissionsUpdateFieldInput>>;
};

export type RubricWhere = {
  AND?: InputMaybe<Array<RubricWhere>>;
  NOT?: InputMaybe<RubricWhere>;
  OR?: InputMaybe<Array<RubricWhere>>;
  component?: InputMaybe<Scalars['String']['input']>;
  component_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  component_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  component_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  component_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  points?: InputMaybe<Scalars['Float']['input']>;
  points_GT?: InputMaybe<Scalars['Float']['input']>;
  points_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  points_LT?: InputMaybe<Scalars['Float']['input']>;
  points_LTE?: InputMaybe<Scalars['Float']['input']>;
  question?: InputMaybe<QuestionWhere>;
  questionAggregate?: InputMaybe<RubricQuestionAggregateInput>;
  questionConnection?: InputMaybe<RubricQuestionConnectionWhere>;
  questionConnection_NOT?: InputMaybe<RubricQuestionConnectionWhere>;
  question_NOT?: InputMaybe<QuestionWhere>;
  submissionsAggregate?: InputMaybe<RubricSubmissionsAggregateInput>;
  /** Return Rubrics where all of the related RubricSubmissionsConnections match this filter */
  submissionsConnection_ALL?: InputMaybe<RubricSubmissionsConnectionWhere>;
  /** Return Rubrics where none of the related RubricSubmissionsConnections match this filter */
  submissionsConnection_NONE?: InputMaybe<RubricSubmissionsConnectionWhere>;
  /** Return Rubrics where one of the related RubricSubmissionsConnections match this filter */
  submissionsConnection_SINGLE?: InputMaybe<RubricSubmissionsConnectionWhere>;
  /** Return Rubrics where some of the related RubricSubmissionsConnections match this filter */
  submissionsConnection_SOME?: InputMaybe<RubricSubmissionsConnectionWhere>;
  /** Return Rubrics where all of the related AssessmentSubmissions match this filter */
  submissions_ALL?: InputMaybe<AssessmentSubmissionWhere>;
  /** Return Rubrics where none of the related AssessmentSubmissions match this filter */
  submissions_NONE?: InputMaybe<AssessmentSubmissionWhere>;
  /** Return Rubrics where one of the related AssessmentSubmissions match this filter */
  submissions_SINGLE?: InputMaybe<AssessmentSubmissionWhere>;
  /** Return Rubrics where some of the related AssessmentSubmissions match this filter */
  submissions_SOME?: InputMaybe<AssessmentSubmissionWhere>;
};

export type SafetyCase = {
  __typename?: 'SafetyCase';
  caseDetails?: Maybe<Scalars['String']['output']>;
  categories: Array<ModerationCategory>;
  messageId: Scalars['ID']['output'];
  severity: Severity;
  studentEmail: Scalars['String']['output'];
  studentName: Scalars['String']['output'];
  time: Scalars['DateTime']['output'];
};

export type SafetyCaseResponse = {
  __typename?: 'SafetyCaseResponse';
  count: Scalars['Int']['output'];
  data?: Maybe<Array<SafetyCase>>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SamlConfig = {
  __typename?: 'SamlConfig';
  authnRequestBinding?: Maybe<Scalars['String']['output']>;
  callbackUrl: Scalars['String']['output'];
  cert: Scalars['String']['output'];
  created?: Maybe<Scalars['DateTime']['output']>;
  emailAttribute?: Maybe<Scalars['String']['output']>;
  entryPoint: Scalars['String']['output'];
  expiry?: Maybe<Scalars['String']['output']>;
  firstNameAttribute?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issuer: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  lastNameAttribute?: Maybe<Scalars['String']['output']>;
  signRequest?: Maybe<Scalars['Boolean']['output']>;
  signatureAlgorithm?: Maybe<Scalars['String']['output']>;
  tenant: Tenant;
  tenantAggregate?: Maybe<SamlConfigTenantTenantAggregationSelection>;
  tenantConnection: SamlConfigTenantConnection;
};


export type SamlConfigTenantArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TenantOptions>;
  where?: InputMaybe<TenantWhere>;
};


export type SamlConfigTenantAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TenantWhere>;
};


export type SamlConfigTenantConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SamlConfigTenantConnectionSort>>;
  where?: InputMaybe<SamlConfigTenantConnectionWhere>;
};

export type SamlConfigConnectInput = {
  tenant?: InputMaybe<SamlConfigTenantConnectFieldInput>;
};

export type SamlConfigConnectOrCreateWhere = {
  node: SamlConfigUniqueWhere;
};

export type SamlConfigConnectWhere = {
  node: SamlConfigWhere;
};

export type SamlConfigCreateInput = {
  authnRequestBinding?: InputMaybe<Scalars['String']['input']>;
  callbackUrl: Scalars['String']['input'];
  cert: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  emailAttribute?: InputMaybe<Scalars['String']['input']>;
  entryPoint: Scalars['String']['input'];
  expiry?: InputMaybe<Scalars['String']['input']>;
  firstNameAttribute?: InputMaybe<Scalars['String']['input']>;
  issuer: Scalars['String']['input'];
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lastNameAttribute?: InputMaybe<Scalars['String']['input']>;
  signRequest?: InputMaybe<Scalars['Boolean']['input']>;
  signatureAlgorithm?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<SamlConfigTenantFieldInput>;
};

export type SamlConfigDeleteInput = {
  tenant?: InputMaybe<SamlConfigTenantDeleteFieldInput>;
};

export type SamlConfigDisconnectInput = {
  tenant?: InputMaybe<SamlConfigTenantDisconnectFieldInput>;
};

export type SamlConfigOnCreateInput = {
  authnRequestBinding?: InputMaybe<Scalars['String']['input']>;
  callbackUrl: Scalars['String']['input'];
  cert: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  emailAttribute?: InputMaybe<Scalars['String']['input']>;
  entryPoint: Scalars['String']['input'];
  expiry?: InputMaybe<Scalars['String']['input']>;
  firstNameAttribute?: InputMaybe<Scalars['String']['input']>;
  issuer: Scalars['String']['input'];
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lastNameAttribute?: InputMaybe<Scalars['String']['input']>;
  signRequest?: InputMaybe<Scalars['Boolean']['input']>;
  signatureAlgorithm?: InputMaybe<Scalars['String']['input']>;
};

export type SamlConfigOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SamlConfigSort objects to sort SamlConfigs by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SamlConfigSort>>;
};

export type SamlConfigResponse = {
  __typename?: 'SamlConfigResponse';
  data?: Maybe<SamlConfig>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Fields to sort SamlConfigs by. The order in which sorts are applied is not guaranteed when specifying many fields in one SamlConfigSort object. */
export type SamlConfigSort = {
  authnRequestBinding?: InputMaybe<SortDirection>;
  callbackUrl?: InputMaybe<SortDirection>;
  cert?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  emailAttribute?: InputMaybe<SortDirection>;
  entryPoint?: InputMaybe<SortDirection>;
  expiry?: InputMaybe<SortDirection>;
  firstNameAttribute?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  issuer?: InputMaybe<SortDirection>;
  lastModified?: InputMaybe<SortDirection>;
  lastNameAttribute?: InputMaybe<SortDirection>;
  signRequest?: InputMaybe<SortDirection>;
  signatureAlgorithm?: InputMaybe<SortDirection>;
};

export type SamlConfigTenantAggregateInput = {
  AND?: InputMaybe<Array<SamlConfigTenantAggregateInput>>;
  NOT?: InputMaybe<SamlConfigTenantAggregateInput>;
  OR?: InputMaybe<Array<SamlConfigTenantAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SamlConfigTenantNodeAggregationWhereInput>;
};

export type SamlConfigTenantConnectFieldInput = {
  connect?: InputMaybe<TenantConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TenantConnectWhere>;
};

export type SamlConfigTenantConnectOrCreateFieldInput = {
  onCreate: SamlConfigTenantConnectOrCreateFieldInputOnCreate;
  where: TenantConnectOrCreateWhere;
};

export type SamlConfigTenantConnectOrCreateFieldInputOnCreate = {
  node: TenantOnCreateInput;
};

export type SamlConfigTenantConnection = {
  __typename?: 'SamlConfigTenantConnection';
  edges: Array<SamlConfigTenantRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SamlConfigTenantConnectionSort = {
  node?: InputMaybe<TenantSort>;
};

export type SamlConfigTenantConnectionWhere = {
  AND?: InputMaybe<Array<SamlConfigTenantConnectionWhere>>;
  NOT?: InputMaybe<SamlConfigTenantConnectionWhere>;
  OR?: InputMaybe<Array<SamlConfigTenantConnectionWhere>>;
  node?: InputMaybe<TenantWhere>;
};

export type SamlConfigTenantCreateFieldInput = {
  node: TenantCreateInput;
};

export type SamlConfigTenantDeleteFieldInput = {
  delete?: InputMaybe<TenantDeleteInput>;
  where?: InputMaybe<SamlConfigTenantConnectionWhere>;
};

export type SamlConfigTenantDisconnectFieldInput = {
  disconnect?: InputMaybe<TenantDisconnectInput>;
  where?: InputMaybe<SamlConfigTenantConnectionWhere>;
};

export type SamlConfigTenantFieldInput = {
  connect?: InputMaybe<SamlConfigTenantConnectFieldInput>;
  connectOrCreate?: InputMaybe<SamlConfigTenantConnectOrCreateFieldInput>;
  create?: InputMaybe<SamlConfigTenantCreateFieldInput>;
};

export type SamlConfigTenantNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SamlConfigTenantNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SamlConfigTenantNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SamlConfigTenantNodeAggregationWhereInput>>;
  companionName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  companionName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  key_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  key_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogImage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  proLogo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SamlConfigTenantRelationship = {
  __typename?: 'SamlConfigTenantRelationship';
  cursor: Scalars['String']['output'];
  node: Tenant;
};

export type SamlConfigTenantTenantAggregationSelection = {
  __typename?: 'SamlConfigTenantTenantAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<SamlConfigTenantTenantNodeAggregateSelection>;
};

export type SamlConfigTenantTenantNodeAggregateSelection = {
  __typename?: 'SamlConfigTenantTenantNodeAggregateSelection';
  companionName: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  emailBackgroundColor: StringAggregateSelection;
  emailFooterColor: StringAggregateSelection;
  emulationStatement: StringAggregateSelection;
  externalSendGridDailyEmailTemplateId: StringAggregateSelection;
  externalSendGridFromEmail: StringAggregateSelection;
  externalSendGridFromName: StringAggregateSelection;
  externalSendGridTwilioServiceSID: StringAggregateSelection;
  favicon16Url: StringAggregateSelection;
  favicon32Url: StringAggregateSelection;
  favicon48Url: StringAggregateSelection;
  favicon180Url: StringAggregateSelection;
  favicon192Url: StringAggregateSelection;
  favicon512Url: StringAggregateSelection;
  faviconIcoUrl: StringAggregateSelection;
  financialInformationUrl: StringAggregateSelection;
  gameMenuBg: StringAggregateSelection;
  gameMenuCardBg: StringAggregateSelection;
  gameMenuProgress: StringAggregateSelection;
  gameMenuTrack: StringAggregateSelection;
  generalPrompt: StringAggregateSelection;
  helpCenterUrl: StringAggregateSelection;
  id: IdAggregateSelection;
  key: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  learningEmulationStatement: StringAggregateSelection;
  logo: StringAggregateSelection;
  ltiLaunchUrl: StringAggregateSelection;
  miniLogo: StringAggregateSelection;
  newsSearchTerms: StringAggregateSelection;
  officialTranscriptsUrl: StringAggregateSelection;
  ogDescription: StringAggregateSelection;
  ogImage: StringAggregateSelection;
  ogImageHeight: StringAggregateSelection;
  ogImageWidth: StringAggregateSelection;
  ogSiteName: StringAggregateSelection;
  ogTitle: StringAggregateSelection;
  ogType: StringAggregateSelection;
  onboardingPrompt: StringAggregateSelection;
  primaryColor: StringAggregateSelection;
  proLogo: StringAggregateSelection;
  reportProblemUrl: StringAggregateSelection;
  scheduleAdvisorCallUrl: StringAggregateSelection;
  schoolResourcesUrl: StringAggregateSelection;
  stripeSecretKey: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  stripeTrialDays: IntAggregateSelection;
  submitHelpTicketLink: StringAggregateSelection;
  tenantDomain: StringAggregateSelection;
  tenantName: StringAggregateSelection;
  termsOfServiceLink: StringAggregateSelection;
  upgradeModalBody: StringAggregateSelection;
};

export type SamlConfigTenantUpdateConnectionInput = {
  node?: InputMaybe<TenantUpdateInput>;
};

export type SamlConfigTenantUpdateFieldInput = {
  connect?: InputMaybe<SamlConfigTenantConnectFieldInput>;
  connectOrCreate?: InputMaybe<SamlConfigTenantConnectOrCreateFieldInput>;
  create?: InputMaybe<SamlConfigTenantCreateFieldInput>;
  delete?: InputMaybe<SamlConfigTenantDeleteFieldInput>;
  disconnect?: InputMaybe<SamlConfigTenantDisconnectFieldInput>;
  update?: InputMaybe<SamlConfigTenantUpdateConnectionInput>;
  where?: InputMaybe<SamlConfigTenantConnectionWhere>;
};

export type SamlConfigUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SamlConfigUpdateInput = {
  authnRequestBinding?: InputMaybe<Scalars['String']['input']>;
  callbackUrl?: InputMaybe<Scalars['String']['input']>;
  cert?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  emailAttribute?: InputMaybe<Scalars['String']['input']>;
  entryPoint?: InputMaybe<Scalars['String']['input']>;
  expiry?: InputMaybe<Scalars['String']['input']>;
  firstNameAttribute?: InputMaybe<Scalars['String']['input']>;
  issuer?: InputMaybe<Scalars['String']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lastNameAttribute?: InputMaybe<Scalars['String']['input']>;
  signRequest?: InputMaybe<Scalars['Boolean']['input']>;
  signatureAlgorithm?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<SamlConfigTenantUpdateFieldInput>;
};

export type SamlConfigWhere = {
  AND?: InputMaybe<Array<SamlConfigWhere>>;
  NOT?: InputMaybe<SamlConfigWhere>;
  OR?: InputMaybe<Array<SamlConfigWhere>>;
  authnRequestBinding?: InputMaybe<Scalars['String']['input']>;
  authnRequestBinding_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  authnRequestBinding_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  authnRequestBinding_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authnRequestBinding_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  callbackUrl?: InputMaybe<Scalars['String']['input']>;
  callbackUrl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  callbackUrl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  callbackUrl_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  callbackUrl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  cert?: InputMaybe<Scalars['String']['input']>;
  cert_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  cert_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  cert_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  cert_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  emailAttribute?: InputMaybe<Scalars['String']['input']>;
  emailAttribute_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  emailAttribute_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  emailAttribute_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  emailAttribute_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  entryPoint?: InputMaybe<Scalars['String']['input']>;
  entryPoint_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  entryPoint_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  entryPoint_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  entryPoint_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  expiry?: InputMaybe<Scalars['String']['input']>;
  expiry_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  expiry_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  expiry_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  expiry_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstNameAttribute?: InputMaybe<Scalars['String']['input']>;
  firstNameAttribute_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  firstNameAttribute_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstNameAttribute_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstNameAttribute_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  issuer?: InputMaybe<Scalars['String']['input']>;
  issuer_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  issuer_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  issuer_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  issuer_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastModified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastNameAttribute?: InputMaybe<Scalars['String']['input']>;
  lastNameAttribute_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lastNameAttribute_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastNameAttribute_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastNameAttribute_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  signRequest?: InputMaybe<Scalars['Boolean']['input']>;
  signatureAlgorithm?: InputMaybe<Scalars['String']['input']>;
  signatureAlgorithm_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  signatureAlgorithm_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  signatureAlgorithm_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  signatureAlgorithm_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<TenantWhere>;
  tenantAggregate?: InputMaybe<SamlConfigTenantAggregateInput>;
  tenantConnection?: InputMaybe<SamlConfigTenantConnectionWhere>;
  tenantConnection_NOT?: InputMaybe<SamlConfigTenantConnectionWhere>;
  tenant_NOT?: InputMaybe<TenantWhere>;
};

export type School = {
  __typename?: 'School';
  announcements: Array<Announcement>;
  announcementsAggregate?: Maybe<SchoolAnnouncementAnnouncementsAggregationSelection>;
  announcementsConnection: SchoolAnnouncementsConnection;
  brightspace_api_client_id?: Maybe<Scalars['String']['output']>;
  brightspace_api_client_secret?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  domain?: Maybe<Scalars['String']['output']>;
  hasCanvasEnv: Array<CanvasEnv>;
  hasCanvasEnvAggregate?: Maybe<SchoolCanvasEnvHasCanvasEnvAggregationSelection>;
  hasCanvasEnvConnection: SchoolHasCanvasEnvConnection;
  hasCourses: Array<Course>;
  hasCoursesAggregate?: Maybe<SchoolCourseHasCoursesAggregationSelection>;
  hasCoursesConnection: SchoolHasCoursesConnection;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  provider_icon_url?: Maybe<Scalars['String']['output']>;
  provider_name?: Maybe<Scalars['String']['output']>;
  team_name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  users: Array<User>;
  usersAggregate?: Maybe<SchoolUserUsersAggregationSelection>;
  usersConnection: SchoolUsersConnection;
  workspaces: Array<Workspace>;
  workspacesAggregate?: Maybe<SchoolWorkspaceWorkspacesAggregationSelection>;
  workspacesConnection: SchoolWorkspacesConnection;
};


export type SchoolAnnouncementsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AnnouncementOptions>;
  where?: InputMaybe<AnnouncementWhere>;
};


export type SchoolAnnouncementsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnnouncementWhere>;
};


export type SchoolAnnouncementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SchoolAnnouncementsConnectionSort>>;
  where?: InputMaybe<SchoolAnnouncementsConnectionWhere>;
};


export type SchoolHasCanvasEnvArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CanvasEnvOptions>;
  where?: InputMaybe<CanvasEnvWhere>;
};


export type SchoolHasCanvasEnvAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CanvasEnvWhere>;
};


export type SchoolHasCanvasEnvConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SchoolHasCanvasEnvConnectionSort>>;
  where?: InputMaybe<SchoolHasCanvasEnvConnectionWhere>;
};


export type SchoolHasCoursesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CourseOptions>;
  where?: InputMaybe<CourseWhere>;
};


export type SchoolHasCoursesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CourseWhere>;
};


export type SchoolHasCoursesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SchoolHasCoursesConnectionSort>>;
  where?: InputMaybe<SchoolHasCoursesConnectionWhere>;
};


export type SchoolUsersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type SchoolUsersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type SchoolUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SchoolUsersConnectionSort>>;
  where?: InputMaybe<SchoolUsersConnectionWhere>;
};


export type SchoolWorkspacesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<WorkspaceOptions>;
  where?: InputMaybe<WorkspaceWhere>;
};


export type SchoolWorkspacesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WorkspaceWhere>;
};


export type SchoolWorkspacesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SchoolWorkspacesConnectionSort>>;
  where?: InputMaybe<SchoolWorkspacesConnectionWhere>;
};

export type SchoolAnnouncementAnnouncementsAggregationSelection = {
  __typename?: 'SchoolAnnouncementAnnouncementsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<SchoolAnnouncementAnnouncementsNodeAggregateSelection>;
};

export type SchoolAnnouncementAnnouncementsNodeAggregateSelection = {
  __typename?: 'SchoolAnnouncementAnnouncementsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  expirationDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  message: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type SchoolAnnouncementsAggregateInput = {
  AND?: InputMaybe<Array<SchoolAnnouncementsAggregateInput>>;
  NOT?: InputMaybe<SchoolAnnouncementsAggregateInput>;
  OR?: InputMaybe<Array<SchoolAnnouncementsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SchoolAnnouncementsNodeAggregationWhereInput>;
};

export type SchoolAnnouncementsConnectFieldInput = {
  connect?: InputMaybe<Array<AnnouncementConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AnnouncementConnectWhere>;
};

export type SchoolAnnouncementsConnectOrCreateFieldInput = {
  onCreate: SchoolAnnouncementsConnectOrCreateFieldInputOnCreate;
  where: AnnouncementConnectOrCreateWhere;
};

export type SchoolAnnouncementsConnectOrCreateFieldInputOnCreate = {
  node: AnnouncementOnCreateInput;
};

export type SchoolAnnouncementsConnection = {
  __typename?: 'SchoolAnnouncementsConnection';
  edges: Array<SchoolAnnouncementsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SchoolAnnouncementsConnectionSort = {
  node?: InputMaybe<AnnouncementSort>;
};

export type SchoolAnnouncementsConnectionWhere = {
  AND?: InputMaybe<Array<SchoolAnnouncementsConnectionWhere>>;
  NOT?: InputMaybe<SchoolAnnouncementsConnectionWhere>;
  OR?: InputMaybe<Array<SchoolAnnouncementsConnectionWhere>>;
  node?: InputMaybe<AnnouncementWhere>;
};

export type SchoolAnnouncementsCreateFieldInput = {
  node: AnnouncementCreateInput;
};

export type SchoolAnnouncementsDeleteFieldInput = {
  delete?: InputMaybe<AnnouncementDeleteInput>;
  where?: InputMaybe<SchoolAnnouncementsConnectionWhere>;
};

export type SchoolAnnouncementsDisconnectFieldInput = {
  disconnect?: InputMaybe<AnnouncementDisconnectInput>;
  where?: InputMaybe<SchoolAnnouncementsConnectionWhere>;
};

export type SchoolAnnouncementsFieldInput = {
  connect?: InputMaybe<Array<SchoolAnnouncementsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SchoolAnnouncementsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SchoolAnnouncementsCreateFieldInput>>;
};

export type SchoolAnnouncementsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SchoolAnnouncementsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SchoolAnnouncementsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SchoolAnnouncementsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  message_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  message_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SchoolAnnouncementsRelationship = {
  __typename?: 'SchoolAnnouncementsRelationship';
  cursor: Scalars['String']['output'];
  node: Announcement;
};

export type SchoolAnnouncementsUpdateConnectionInput = {
  node?: InputMaybe<AnnouncementUpdateInput>;
};

export type SchoolAnnouncementsUpdateFieldInput = {
  connect?: InputMaybe<Array<SchoolAnnouncementsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SchoolAnnouncementsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SchoolAnnouncementsCreateFieldInput>>;
  delete?: InputMaybe<Array<SchoolAnnouncementsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<SchoolAnnouncementsDisconnectFieldInput>>;
  update?: InputMaybe<SchoolAnnouncementsUpdateConnectionInput>;
  where?: InputMaybe<SchoolAnnouncementsConnectionWhere>;
};

export type SchoolCanvasEnvHasCanvasEnvAggregationSelection = {
  __typename?: 'SchoolCanvasEnvHasCanvasEnvAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<SchoolCanvasEnvHasCanvasEnvNodeAggregateSelection>;
};

export type SchoolCanvasEnvHasCanvasEnvNodeAggregateSelection = {
  __typename?: 'SchoolCanvasEnvHasCanvasEnvNodeAggregateSelection';
  api_client_id: StringAggregateSelection;
  api_client_secret: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  deployment_id: StringAggregateSelection;
  domain: StringAggregateSelection;
  id: IdAggregateSelection;
  mobile_api_client_id: StringAggregateSelection;
  mobile_api_client_secret: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
};

export type SchoolConnectInput = {
  announcements?: InputMaybe<Array<SchoolAnnouncementsConnectFieldInput>>;
  hasCanvasEnv?: InputMaybe<Array<SchoolHasCanvasEnvConnectFieldInput>>;
  hasCourses?: InputMaybe<Array<SchoolHasCoursesConnectFieldInput>>;
  users?: InputMaybe<Array<SchoolUsersConnectFieldInput>>;
  workspaces?: InputMaybe<Array<SchoolWorkspacesConnectFieldInput>>;
};

export type SchoolConnectOrCreateWhere = {
  node: SchoolUniqueWhere;
};

export type SchoolConnectWhere = {
  node: SchoolWhere;
};

export type SchoolCourseHasCoursesAggregationSelection = {
  __typename?: 'SchoolCourseHasCoursesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<SchoolCourseHasCoursesNodeAggregateSelection>;
};

export type SchoolCourseHasCoursesNodeAggregateSelection = {
  __typename?: 'SchoolCourseHasCoursesNodeAggregateSelection';
  account_id: FloatAggregateSelection;
  calendar_ics: StringAggregateSelection;
  cost: FloatAggregateSelection;
  courseId: StringAggregateSelection;
  course_code: StringAggregateSelection;
  course_id: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  default_view: StringAggregateSelection;
  description: StringAggregateSelection;
  dueDateEndDate: DateTimeAggregateSelection;
  dueDateStartDate: DateTimeAggregateSelection;
  endDate: DateTimeAggregateSelection;
  end_at: StringAggregateSelection;
  enrollment_term_id: FloatAggregateSelection;
  grading_standard_id: FloatAggregateSelection;
  id: IdAggregateSelection;
  integration_id: StringAggregateSelection;
  label: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  learningStandards: StringAggregateSelection;
  lengthInWeeks: FloatAggregateSelection;
  license: StringAggregateSelection;
  lti_id: StringAggregateSelection;
  name: StringAggregateSelection;
  original_name: StringAggregateSelection;
  root_account_id: FloatAggregateSelection;
  sis_course_id: StringAggregateSelection;
  sis_import_id: FloatAggregateSelection;
  startDate: DateTimeAggregateSelection;
  start_at: StringAggregateSelection;
  state: StringAggregateSelection;
  storage_quota_mb: FloatAggregateSelection;
  stripePriceId: StringAggregateSelection;
  stripeProductId: StringAggregateSelection;
  targetAudience: StringAggregateSelection;
  thumbnail: StringAggregateSelection;
  time_zone: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  uuid: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export type SchoolCreateInput = {
  announcements?: InputMaybe<SchoolAnnouncementsFieldInput>;
  brightspace_api_client_id?: InputMaybe<Scalars['String']['input']>;
  brightspace_api_client_secret?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  hasCanvasEnv?: InputMaybe<SchoolHasCanvasEnvFieldInput>;
  hasCourses?: InputMaybe<SchoolHasCoursesFieldInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  provider_icon_url?: InputMaybe<Scalars['String']['input']>;
  provider_name?: InputMaybe<Scalars['String']['input']>;
  team_name?: InputMaybe<Scalars['String']['input']>;
  updatedAt: Scalars['DateTime']['input'];
  users?: InputMaybe<SchoolUsersFieldInput>;
  workspaces?: InputMaybe<SchoolWorkspacesFieldInput>;
};

export type SchoolDeleteInput = {
  announcements?: InputMaybe<Array<SchoolAnnouncementsDeleteFieldInput>>;
  hasCanvasEnv?: InputMaybe<Array<SchoolHasCanvasEnvDeleteFieldInput>>;
  hasCourses?: InputMaybe<Array<SchoolHasCoursesDeleteFieldInput>>;
  users?: InputMaybe<Array<SchoolUsersDeleteFieldInput>>;
  workspaces?: InputMaybe<Array<SchoolWorkspacesDeleteFieldInput>>;
};

export type SchoolDisconnectInput = {
  announcements?: InputMaybe<Array<SchoolAnnouncementsDisconnectFieldInput>>;
  hasCanvasEnv?: InputMaybe<Array<SchoolHasCanvasEnvDisconnectFieldInput>>;
  hasCourses?: InputMaybe<Array<SchoolHasCoursesDisconnectFieldInput>>;
  users?: InputMaybe<Array<SchoolUsersDisconnectFieldInput>>;
  workspaces?: InputMaybe<Array<SchoolWorkspacesDisconnectFieldInput>>;
};

export type SchoolHasCanvasEnvAggregateInput = {
  AND?: InputMaybe<Array<SchoolHasCanvasEnvAggregateInput>>;
  NOT?: InputMaybe<SchoolHasCanvasEnvAggregateInput>;
  OR?: InputMaybe<Array<SchoolHasCanvasEnvAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SchoolHasCanvasEnvNodeAggregationWhereInput>;
};

export type SchoolHasCanvasEnvConnectFieldInput = {
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CanvasEnvConnectWhere>;
};

export type SchoolHasCanvasEnvConnectOrCreateFieldInput = {
  onCreate: SchoolHasCanvasEnvConnectOrCreateFieldInputOnCreate;
  where: CanvasEnvConnectOrCreateWhere;
};

export type SchoolHasCanvasEnvConnectOrCreateFieldInputOnCreate = {
  node: CanvasEnvOnCreateInput;
};

export type SchoolHasCanvasEnvConnection = {
  __typename?: 'SchoolHasCanvasEnvConnection';
  edges: Array<SchoolHasCanvasEnvRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SchoolHasCanvasEnvConnectionSort = {
  node?: InputMaybe<CanvasEnvSort>;
};

export type SchoolHasCanvasEnvConnectionWhere = {
  AND?: InputMaybe<Array<SchoolHasCanvasEnvConnectionWhere>>;
  NOT?: InputMaybe<SchoolHasCanvasEnvConnectionWhere>;
  OR?: InputMaybe<Array<SchoolHasCanvasEnvConnectionWhere>>;
  node?: InputMaybe<CanvasEnvWhere>;
};

export type SchoolHasCanvasEnvCreateFieldInput = {
  node: CanvasEnvCreateInput;
};

export type SchoolHasCanvasEnvDeleteFieldInput = {
  where?: InputMaybe<SchoolHasCanvasEnvConnectionWhere>;
};

export type SchoolHasCanvasEnvDisconnectFieldInput = {
  where?: InputMaybe<SchoolHasCanvasEnvConnectionWhere>;
};

export type SchoolHasCanvasEnvFieldInput = {
  connect?: InputMaybe<Array<SchoolHasCanvasEnvConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SchoolHasCanvasEnvConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SchoolHasCanvasEnvCreateFieldInput>>;
};

export type SchoolHasCanvasEnvNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SchoolHasCanvasEnvNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SchoolHasCanvasEnvNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SchoolHasCanvasEnvNodeAggregationWhereInput>>;
  api_client_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  api_client_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  api_client_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  api_client_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  api_client_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  api_client_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  api_client_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  api_client_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  api_client_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  api_client_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  api_client_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  api_client_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  api_client_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  api_client_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  api_client_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  api_client_secret_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  api_client_secret_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  api_client_secret_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  api_client_secret_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  api_client_secret_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  api_client_secret_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  api_client_secret_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  api_client_secret_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  api_client_secret_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  api_client_secret_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  api_client_secret_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  api_client_secret_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  api_client_secret_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  api_client_secret_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  api_client_secret_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deployment_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deployment_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deployment_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deployment_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deployment_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deployment_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deployment_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deployment_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deployment_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deployment_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deployment_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deployment_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deployment_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deployment_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deployment_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domain_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domain_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mobile_api_client_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mobile_api_client_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  mobile_api_client_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  mobile_api_client_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  mobile_api_client_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  mobile_api_client_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mobile_api_client_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mobile_api_client_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mobile_api_client_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mobile_api_client_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mobile_api_client_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mobile_api_client_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mobile_api_client_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mobile_api_client_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mobile_api_client_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mobile_api_client_secret_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mobile_api_client_secret_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  mobile_api_client_secret_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  mobile_api_client_secret_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  mobile_api_client_secret_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  mobile_api_client_secret_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mobile_api_client_secret_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mobile_api_client_secret_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mobile_api_client_secret_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mobile_api_client_secret_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mobile_api_client_secret_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mobile_api_client_secret_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mobile_api_client_secret_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mobile_api_client_secret_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mobile_api_client_secret_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SchoolHasCanvasEnvRelationship = {
  __typename?: 'SchoolHasCanvasEnvRelationship';
  cursor: Scalars['String']['output'];
  node: CanvasEnv;
};

export type SchoolHasCanvasEnvUpdateConnectionInput = {
  node?: InputMaybe<CanvasEnvUpdateInput>;
};

export type SchoolHasCanvasEnvUpdateFieldInput = {
  connect?: InputMaybe<Array<SchoolHasCanvasEnvConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SchoolHasCanvasEnvConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SchoolHasCanvasEnvCreateFieldInput>>;
  delete?: InputMaybe<Array<SchoolHasCanvasEnvDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<SchoolHasCanvasEnvDisconnectFieldInput>>;
  update?: InputMaybe<SchoolHasCanvasEnvUpdateConnectionInput>;
  where?: InputMaybe<SchoolHasCanvasEnvConnectionWhere>;
};

export type SchoolHasCoursesAggregateInput = {
  AND?: InputMaybe<Array<SchoolHasCoursesAggregateInput>>;
  NOT?: InputMaybe<SchoolHasCoursesAggregateInput>;
  OR?: InputMaybe<Array<SchoolHasCoursesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SchoolHasCoursesNodeAggregationWhereInput>;
};

export type SchoolHasCoursesConnectFieldInput = {
  connect?: InputMaybe<Array<CourseConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CourseConnectWhere>;
};

export type SchoolHasCoursesConnectOrCreateFieldInput = {
  onCreate: SchoolHasCoursesConnectOrCreateFieldInputOnCreate;
  where: CourseConnectOrCreateWhere;
};

export type SchoolHasCoursesConnectOrCreateFieldInputOnCreate = {
  node: CourseOnCreateInput;
};

export type SchoolHasCoursesConnection = {
  __typename?: 'SchoolHasCoursesConnection';
  edges: Array<SchoolHasCoursesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SchoolHasCoursesConnectionSort = {
  node?: InputMaybe<CourseSort>;
};

export type SchoolHasCoursesConnectionWhere = {
  AND?: InputMaybe<Array<SchoolHasCoursesConnectionWhere>>;
  NOT?: InputMaybe<SchoolHasCoursesConnectionWhere>;
  OR?: InputMaybe<Array<SchoolHasCoursesConnectionWhere>>;
  node?: InputMaybe<CourseWhere>;
};

export type SchoolHasCoursesCreateFieldInput = {
  node: CourseCreateInput;
};

export type SchoolHasCoursesDeleteFieldInput = {
  delete?: InputMaybe<CourseDeleteInput>;
  where?: InputMaybe<SchoolHasCoursesConnectionWhere>;
};

export type SchoolHasCoursesDisconnectFieldInput = {
  disconnect?: InputMaybe<CourseDisconnectInput>;
  where?: InputMaybe<SchoolHasCoursesConnectionWhere>;
};

export type SchoolHasCoursesFieldInput = {
  connect?: InputMaybe<Array<SchoolHasCoursesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SchoolHasCoursesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SchoolHasCoursesCreateFieldInput>>;
};

export type SchoolHasCoursesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SchoolHasCoursesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SchoolHasCoursesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SchoolHasCoursesNodeAggregationWhereInput>>;
  account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  cost_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDateEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  enrollment_term_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  label_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningStandards_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthInWeeks_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  root_account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_import_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  startDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  storage_quota_mb_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SchoolHasCoursesRelationship = {
  __typename?: 'SchoolHasCoursesRelationship';
  cursor: Scalars['String']['output'];
  node: Course;
};

export type SchoolHasCoursesUpdateConnectionInput = {
  node?: InputMaybe<CourseUpdateInput>;
};

export type SchoolHasCoursesUpdateFieldInput = {
  connect?: InputMaybe<Array<SchoolHasCoursesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SchoolHasCoursesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SchoolHasCoursesCreateFieldInput>>;
  delete?: InputMaybe<Array<SchoolHasCoursesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<SchoolHasCoursesDisconnectFieldInput>>;
  update?: InputMaybe<SchoolHasCoursesUpdateConnectionInput>;
  where?: InputMaybe<SchoolHasCoursesConnectionWhere>;
};

export type SchoolOnCreateInput = {
  brightspace_api_client_id?: InputMaybe<Scalars['String']['input']>;
  brightspace_api_client_secret?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  provider_icon_url?: InputMaybe<Scalars['String']['input']>;
  provider_name?: InputMaybe<Scalars['String']['input']>;
  team_name?: InputMaybe<Scalars['String']['input']>;
  updatedAt: Scalars['DateTime']['input'];
};

export type SchoolOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SchoolSort objects to sort Schools by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SchoolSort>>;
};

/** Fields to sort Schools by. The order in which sorts are applied is not guaranteed when specifying many fields in one SchoolSort object. */
export type SchoolSort = {
  brightspace_api_client_id?: InputMaybe<SortDirection>;
  brightspace_api_client_secret?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  domain?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isActive?: InputMaybe<SortDirection>;
  provider_icon_url?: InputMaybe<SortDirection>;
  provider_name?: InputMaybe<SortDirection>;
  team_name?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type SchoolUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SchoolUpdateInput = {
  announcements?: InputMaybe<Array<SchoolAnnouncementsUpdateFieldInput>>;
  brightspace_api_client_id?: InputMaybe<Scalars['String']['input']>;
  brightspace_api_client_secret?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  hasCanvasEnv?: InputMaybe<Array<SchoolHasCanvasEnvUpdateFieldInput>>;
  hasCourses?: InputMaybe<Array<SchoolHasCoursesUpdateFieldInput>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  provider_icon_url?: InputMaybe<Scalars['String']['input']>;
  provider_name?: InputMaybe<Scalars['String']['input']>;
  team_name?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<SchoolUsersUpdateFieldInput>>;
  workspaces?: InputMaybe<Array<SchoolWorkspacesUpdateFieldInput>>;
};

export type SchoolUserUsersAggregationSelection = {
  __typename?: 'SchoolUserUsersAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<SchoolUserUsersEdgeAggregateSelection>;
  node?: Maybe<SchoolUserUsersNodeAggregateSelection>;
};

export type SchoolUserUsersEdgeAggregateSelection = {
  __typename?: 'SchoolUserUsersEdgeAggregateSelection';
  access_token: StringAggregateSelection;
  brightspace_user_id: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  domain: StringAggregateSelection;
  expires_in: IntAggregateSelection;
  external_id: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  last_modified_token: DateTimeAggregateSelection;
  last_seen_at: DateTimeAggregateSelection;
  login_id: StringAggregateSelection;
  platform: StringAggregateSelection;
  profile_id: StringAggregateSelection;
  refresh_token: StringAggregateSelection;
  school_id: StringAggregateSelection;
  user_id: StringAggregateSelection;
  vendor: StringAggregateSelection;
};

export type SchoolUserUsersNodeAggregateSelection = {
  __typename?: 'SchoolUserUsersNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type SchoolUsersAggregateInput = {
  AND?: InputMaybe<Array<SchoolUsersAggregateInput>>;
  NOT?: InputMaybe<SchoolUsersAggregateInput>;
  OR?: InputMaybe<Array<SchoolUsersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasSchoolPropertiesAggregationWhereInput>;
  node?: InputMaybe<SchoolUsersNodeAggregationWhereInput>;
};

export type SchoolUsersConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  edge?: InputMaybe<HasSchoolPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type SchoolUsersConnectOrCreateFieldInput = {
  onCreate: SchoolUsersConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type SchoolUsersConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<HasSchoolPropertiesCreateInput>;
  node: UserOnCreateInput;
};

export type SchoolUsersConnection = {
  __typename?: 'SchoolUsersConnection';
  edges: Array<SchoolUsersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SchoolUsersConnectionSort = {
  edge?: InputMaybe<HasSchoolPropertiesSort>;
  node?: InputMaybe<UserSort>;
};

export type SchoolUsersConnectionWhere = {
  AND?: InputMaybe<Array<SchoolUsersConnectionWhere>>;
  NOT?: InputMaybe<SchoolUsersConnectionWhere>;
  OR?: InputMaybe<Array<SchoolUsersConnectionWhere>>;
  edge?: InputMaybe<HasSchoolPropertiesWhere>;
  node?: InputMaybe<UserWhere>;
};

export type SchoolUsersCreateFieldInput = {
  edge?: InputMaybe<HasSchoolPropertiesCreateInput>;
  node: UserCreateInput;
};

export type SchoolUsersDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<SchoolUsersConnectionWhere>;
};

export type SchoolUsersDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<SchoolUsersConnectionWhere>;
};

export type SchoolUsersFieldInput = {
  connect?: InputMaybe<Array<SchoolUsersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SchoolUsersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SchoolUsersCreateFieldInput>>;
};

export type SchoolUsersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SchoolUsersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SchoolUsersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SchoolUsersNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SchoolUsersRelationship = {
  __typename?: 'SchoolUsersRelationship';
  cursor: Scalars['String']['output'];
  node: User;
  properties: HasSchoolProperties;
};

export type SchoolUsersUpdateConnectionInput = {
  edge?: InputMaybe<HasSchoolPropertiesUpdateInput>;
  node?: InputMaybe<UserUpdateInput>;
};

export type SchoolUsersUpdateFieldInput = {
  connect?: InputMaybe<Array<SchoolUsersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SchoolUsersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SchoolUsersCreateFieldInput>>;
  delete?: InputMaybe<Array<SchoolUsersDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<SchoolUsersDisconnectFieldInput>>;
  update?: InputMaybe<SchoolUsersUpdateConnectionInput>;
  where?: InputMaybe<SchoolUsersConnectionWhere>;
};

export type SchoolWhere = {
  AND?: InputMaybe<Array<SchoolWhere>>;
  NOT?: InputMaybe<SchoolWhere>;
  OR?: InputMaybe<Array<SchoolWhere>>;
  announcementsAggregate?: InputMaybe<SchoolAnnouncementsAggregateInput>;
  /** Return Schools where all of the related SchoolAnnouncementsConnections match this filter */
  announcementsConnection_ALL?: InputMaybe<SchoolAnnouncementsConnectionWhere>;
  /** Return Schools where none of the related SchoolAnnouncementsConnections match this filter */
  announcementsConnection_NONE?: InputMaybe<SchoolAnnouncementsConnectionWhere>;
  /** Return Schools where one of the related SchoolAnnouncementsConnections match this filter */
  announcementsConnection_SINGLE?: InputMaybe<SchoolAnnouncementsConnectionWhere>;
  /** Return Schools where some of the related SchoolAnnouncementsConnections match this filter */
  announcementsConnection_SOME?: InputMaybe<SchoolAnnouncementsConnectionWhere>;
  /** Return Schools where all of the related Announcements match this filter */
  announcements_ALL?: InputMaybe<AnnouncementWhere>;
  /** Return Schools where none of the related Announcements match this filter */
  announcements_NONE?: InputMaybe<AnnouncementWhere>;
  /** Return Schools where one of the related Announcements match this filter */
  announcements_SINGLE?: InputMaybe<AnnouncementWhere>;
  /** Return Schools where some of the related Announcements match this filter */
  announcements_SOME?: InputMaybe<AnnouncementWhere>;
  brightspace_api_client_id?: InputMaybe<Scalars['String']['input']>;
  brightspace_api_client_id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  brightspace_api_client_id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  brightspace_api_client_id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brightspace_api_client_id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  brightspace_api_client_secret?: InputMaybe<Scalars['String']['input']>;
  brightspace_api_client_secret_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  brightspace_api_client_secret_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  brightspace_api_client_secret_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brightspace_api_client_secret_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  domain_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  domain_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  domain_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  domain_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  hasCanvasEnvAggregate?: InputMaybe<SchoolHasCanvasEnvAggregateInput>;
  /** Return Schools where all of the related SchoolHasCanvasEnvConnections match this filter */
  hasCanvasEnvConnection_ALL?: InputMaybe<SchoolHasCanvasEnvConnectionWhere>;
  /** Return Schools where none of the related SchoolHasCanvasEnvConnections match this filter */
  hasCanvasEnvConnection_NONE?: InputMaybe<SchoolHasCanvasEnvConnectionWhere>;
  /** Return Schools where one of the related SchoolHasCanvasEnvConnections match this filter */
  hasCanvasEnvConnection_SINGLE?: InputMaybe<SchoolHasCanvasEnvConnectionWhere>;
  /** Return Schools where some of the related SchoolHasCanvasEnvConnections match this filter */
  hasCanvasEnvConnection_SOME?: InputMaybe<SchoolHasCanvasEnvConnectionWhere>;
  /** Return Schools where all of the related CanvasEnvs match this filter */
  hasCanvasEnv_ALL?: InputMaybe<CanvasEnvWhere>;
  /** Return Schools where none of the related CanvasEnvs match this filter */
  hasCanvasEnv_NONE?: InputMaybe<CanvasEnvWhere>;
  /** Return Schools where one of the related CanvasEnvs match this filter */
  hasCanvasEnv_SINGLE?: InputMaybe<CanvasEnvWhere>;
  /** Return Schools where some of the related CanvasEnvs match this filter */
  hasCanvasEnv_SOME?: InputMaybe<CanvasEnvWhere>;
  hasCoursesAggregate?: InputMaybe<SchoolHasCoursesAggregateInput>;
  /** Return Schools where all of the related SchoolHasCoursesConnections match this filter */
  hasCoursesConnection_ALL?: InputMaybe<SchoolHasCoursesConnectionWhere>;
  /** Return Schools where none of the related SchoolHasCoursesConnections match this filter */
  hasCoursesConnection_NONE?: InputMaybe<SchoolHasCoursesConnectionWhere>;
  /** Return Schools where one of the related SchoolHasCoursesConnections match this filter */
  hasCoursesConnection_SINGLE?: InputMaybe<SchoolHasCoursesConnectionWhere>;
  /** Return Schools where some of the related SchoolHasCoursesConnections match this filter */
  hasCoursesConnection_SOME?: InputMaybe<SchoolHasCoursesConnectionWhere>;
  /** Return Schools where all of the related Courses match this filter */
  hasCourses_ALL?: InputMaybe<CourseWhere>;
  /** Return Schools where none of the related Courses match this filter */
  hasCourses_NONE?: InputMaybe<CourseWhere>;
  /** Return Schools where one of the related Courses match this filter */
  hasCourses_SINGLE?: InputMaybe<CourseWhere>;
  /** Return Schools where some of the related Courses match this filter */
  hasCourses_SOME?: InputMaybe<CourseWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  provider_icon_url?: InputMaybe<Scalars['String']['input']>;
  provider_icon_url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  provider_icon_url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  provider_icon_url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider_icon_url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  provider_name?: InputMaybe<Scalars['String']['input']>;
  provider_name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  provider_name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  provider_name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  provider_name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  team_name?: InputMaybe<Scalars['String']['input']>;
  team_name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  team_name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  team_name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  team_name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  usersAggregate?: InputMaybe<SchoolUsersAggregateInput>;
  /** Return Schools where all of the related SchoolUsersConnections match this filter */
  usersConnection_ALL?: InputMaybe<SchoolUsersConnectionWhere>;
  /** Return Schools where none of the related SchoolUsersConnections match this filter */
  usersConnection_NONE?: InputMaybe<SchoolUsersConnectionWhere>;
  /** Return Schools where one of the related SchoolUsersConnections match this filter */
  usersConnection_SINGLE?: InputMaybe<SchoolUsersConnectionWhere>;
  /** Return Schools where some of the related SchoolUsersConnections match this filter */
  usersConnection_SOME?: InputMaybe<SchoolUsersConnectionWhere>;
  /** Return Schools where all of the related Users match this filter */
  users_ALL?: InputMaybe<UserWhere>;
  /** Return Schools where none of the related Users match this filter */
  users_NONE?: InputMaybe<UserWhere>;
  /** Return Schools where one of the related Users match this filter */
  users_SINGLE?: InputMaybe<UserWhere>;
  /** Return Schools where some of the related Users match this filter */
  users_SOME?: InputMaybe<UserWhere>;
  workspacesAggregate?: InputMaybe<SchoolWorkspacesAggregateInput>;
  /** Return Schools where all of the related SchoolWorkspacesConnections match this filter */
  workspacesConnection_ALL?: InputMaybe<SchoolWorkspacesConnectionWhere>;
  /** Return Schools where none of the related SchoolWorkspacesConnections match this filter */
  workspacesConnection_NONE?: InputMaybe<SchoolWorkspacesConnectionWhere>;
  /** Return Schools where one of the related SchoolWorkspacesConnections match this filter */
  workspacesConnection_SINGLE?: InputMaybe<SchoolWorkspacesConnectionWhere>;
  /** Return Schools where some of the related SchoolWorkspacesConnections match this filter */
  workspacesConnection_SOME?: InputMaybe<SchoolWorkspacesConnectionWhere>;
  /** Return Schools where all of the related Workspaces match this filter */
  workspaces_ALL?: InputMaybe<WorkspaceWhere>;
  /** Return Schools where none of the related Workspaces match this filter */
  workspaces_NONE?: InputMaybe<WorkspaceWhere>;
  /** Return Schools where one of the related Workspaces match this filter */
  workspaces_SINGLE?: InputMaybe<WorkspaceWhere>;
  /** Return Schools where some of the related Workspaces match this filter */
  workspaces_SOME?: InputMaybe<WorkspaceWhere>;
};

export type SchoolWorkspaceWorkspacesAggregationSelection = {
  __typename?: 'SchoolWorkspaceWorkspacesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<SchoolWorkspaceWorkspacesNodeAggregateSelection>;
};

export type SchoolWorkspaceWorkspacesNodeAggregateSelection = {
  __typename?: 'SchoolWorkspaceWorkspacesNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  key: StringAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  name: StringAggregateSelection;
};

export type SchoolWorkspacesAggregateInput = {
  AND?: InputMaybe<Array<SchoolWorkspacesAggregateInput>>;
  NOT?: InputMaybe<SchoolWorkspacesAggregateInput>;
  OR?: InputMaybe<Array<SchoolWorkspacesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SchoolWorkspacesNodeAggregationWhereInput>;
};

export type SchoolWorkspacesConnectFieldInput = {
  connect?: InputMaybe<Array<WorkspaceConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<WorkspaceConnectWhere>;
};

export type SchoolWorkspacesConnectOrCreateFieldInput = {
  onCreate: SchoolWorkspacesConnectOrCreateFieldInputOnCreate;
  where: WorkspaceConnectOrCreateWhere;
};

export type SchoolWorkspacesConnectOrCreateFieldInputOnCreate = {
  node: WorkspaceOnCreateInput;
};

export type SchoolWorkspacesConnection = {
  __typename?: 'SchoolWorkspacesConnection';
  edges: Array<SchoolWorkspacesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SchoolWorkspacesConnectionSort = {
  node?: InputMaybe<WorkspaceSort>;
};

export type SchoolWorkspacesConnectionWhere = {
  AND?: InputMaybe<Array<SchoolWorkspacesConnectionWhere>>;
  NOT?: InputMaybe<SchoolWorkspacesConnectionWhere>;
  OR?: InputMaybe<Array<SchoolWorkspacesConnectionWhere>>;
  node?: InputMaybe<WorkspaceWhere>;
};

export type SchoolWorkspacesCreateFieldInput = {
  node: WorkspaceCreateInput;
};

export type SchoolWorkspacesDeleteFieldInput = {
  delete?: InputMaybe<WorkspaceDeleteInput>;
  where?: InputMaybe<SchoolWorkspacesConnectionWhere>;
};

export type SchoolWorkspacesDisconnectFieldInput = {
  disconnect?: InputMaybe<WorkspaceDisconnectInput>;
  where?: InputMaybe<SchoolWorkspacesConnectionWhere>;
};

export type SchoolWorkspacesFieldInput = {
  connect?: InputMaybe<Array<SchoolWorkspacesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SchoolWorkspacesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SchoolWorkspacesCreateFieldInput>>;
};

export type SchoolWorkspacesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SchoolWorkspacesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SchoolWorkspacesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SchoolWorkspacesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  key_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  key_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SchoolWorkspacesRelationship = {
  __typename?: 'SchoolWorkspacesRelationship';
  cursor: Scalars['String']['output'];
  node: Workspace;
};

export type SchoolWorkspacesUpdateConnectionInput = {
  node?: InputMaybe<WorkspaceUpdateInput>;
};

export type SchoolWorkspacesUpdateFieldInput = {
  connect?: InputMaybe<Array<SchoolWorkspacesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SchoolWorkspacesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SchoolWorkspacesCreateFieldInput>>;
  delete?: InputMaybe<Array<SchoolWorkspacesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<SchoolWorkspacesDisconnectFieldInput>>;
  update?: InputMaybe<SchoolWorkspacesUpdateConnectionInput>;
  where?: InputMaybe<SchoolWorkspacesConnectionWhere>;
};

export type SessionResponse = {
  __typename?: 'SessionResponse';
  isValid: Scalars['Boolean']['output'];
};

export enum Severity {
  Critical = 'CRITICAL',
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type SingleNotificationResponse = {
  __typename?: 'SingleNotificationResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Notification>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SingleNudgeResponse = {
  __typename?: 'SingleNudgeResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Nudge>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SingleProjectRequirementResponse = {
  __typename?: 'SingleProjectRequirementResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<ProjectRequirement>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SingleProjectResponse = {
  __typename?: 'SingleProjectResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Project>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SingleProjectSubmissionResponse = {
  __typename?: 'SingleProjectSubmissionResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<ProjectSubmission>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SocraticQuestionRubric = {
  __typename?: 'SocraticQuestionRubric';
  component: Scalars['String']['output'];
  points: Scalars['Float']['output'];
};

export type SocraticQuestionRubricInput = {
  component: Scalars['String']['input'];
  points: Scalars['Float']['input'];
};

export type SocraticRubricResponse = {
  __typename?: 'SocraticRubricResponse';
  count?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  rubrics: Array<SocraticQuestionRubric>;
  success?: Maybe<Scalars['Boolean']['output']>;
  totalScore?: Maybe<Scalars['Float']['output']>;
};

/** An enum for sorting in either ascending or descending order. */
export enum SortDirection {
  /** Sort by field values in ascending order. */
  Asc = 'ASC',
  /** Sort by field values in descending order. */
  Desc = 'DESC'
}

export enum StoragePathType {
  AdminDocuments = 'admin_documents',
  AssignmentsWorksheets = 'assignments_worksheets',
  ChatAttachments = 'chat_attachments',
  ExportCourse = 'export_course',
  ExportGradeSubmissions = 'export_grade_submissions',
  ExportsCsv = 'exports_csv',
  ExportsRoster = 'exports_roster',
  LessonPlans = 'lesson__plans',
  ProjectStarterResources = 'project_starterResources',
  ProjectSubmissions = 'project_submissions',
  Resources = 'resources',
  RichTextEditorImages = 'rich_text_editor_images',
  TenantFavicon = 'tenant_favicon',
  TenantLogo = 'tenant_logo',
  Thumbnails = 'thumbnails',
  UsersProfileImages = 'users_profile__images'
}

export type StringAggregateSelection = {
  __typename?: 'StringAggregateSelection';
  longest?: Maybe<Scalars['String']['output']>;
  shortest?: Maybe<Scalars['String']['output']>;
};

export type StudentActivityProgressData = {
  __typename?: 'StudentActivityProgressData';
  active_interaction_count: Scalars['Int']['output'];
  chatAnalytics?: Maybe<Array<Maybe<ChatAnalytics>>>;
  completion_percentage?: Maybe<Scalars['Float']['output']>;
  confusion_points: Scalars['Int']['output'];
  course_id?: Maybe<Scalars['ID']['output']>;
  course_name?: Maybe<Scalars['String']['output']>;
  details: ActivityProgressDetails;
  distractions: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  module_id?: Maybe<Scalars['ID']['output']>;
  module_name?: Maybe<Scalars['String']['output']>;
  questions_asked: Scalars['Int']['output'];
  sentiment: Scalars['String']['output'];
  student_id: Scalars['ID']['output'];
  student_name: Scalars['String']['output'];
  success_points: Scalars['Int']['output'];
  total_time_taken?: Maybe<Scalars['Float']['output']>;
};

export type StudentActivityProgressResponse = {
  __typename?: 'StudentActivityProgressResponse';
  count: Scalars['Int']['output'];
  data: Array<StudentActivityProgressData>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type StudentAnalytics = {
  __typename?: 'StudentAnalytics';
  active_interaction_count: Scalars['Int']['output'];
  completion_percentage?: Maybe<Scalars['Float']['output']>;
  confusion_points: Scalars['Int']['output'];
  details: StudentAnalyticsDetails;
  distractions: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  questions_asked: Scalars['Int']['output'];
  sentiment: Scalars['String']['output'];
  success_points: Scalars['Int']['output'];
  total_time_taken?: Maybe<Scalars['Float']['output']>;
};

export type StudentAnalyticsDetails = {
  __typename?: 'StudentAnalyticsDetails';
  courses: Array<CourseProgressAnalytics>;
};

export type StudentAnalyticsResponse = {
  __typename?: 'StudentAnalyticsResponse';
  count: Scalars['Int']['output'];
  data: Array<StudentAnalytics>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type StudentAnalyticsSummaryResponse = {
  __typename?: 'StudentAnalyticsSummaryResponse';
  count: Scalars['Int']['output'];
  data: Array<StudentSummary>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type StudentChatAnalytics = {
  __typename?: 'StudentChatAnalytics';
  activityId: Scalars['ID']['output'];
  activityName: Scalars['String']['output'];
  ai_messages_count: Scalars['Int']['output'];
  average_ai_response_time: Scalars['Float']['output'];
  average_student_response_time: Scalars['Float']['output'];
  courseId: Scalars['ID']['output'];
  courseName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  moduleId: Scalars['ID']['output'];
  moduleName: Scalars['String']['output'];
  num_messages: Scalars['Int']['output'];
  originality_analysis?: Maybe<Scalars['String']['output']>;
  sentiment_analysis?: Maybe<Scalars['String']['output']>;
  student_messages_count: Scalars['Int']['output'];
  total_time_taken: Scalars['Float']['output'];
};

export type StudentChatAnalyticsResponse = {
  __typename?: 'StudentChatAnalyticsResponse';
  count: Scalars['Int']['output'];
  data: Array<StudentChatAnalytics>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type StudentCourseProgressResponse = {
  __typename?: 'StudentCourseProgressResponse';
  count: Scalars['Int']['output'];
  data: Array<CourseProgressAnalytics>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type StudentDetailedAnalytics = {
  __typename?: 'StudentDetailedAnalytics';
  active_interaction_count: Scalars['Int']['output'];
  completion_percentage?: Maybe<Scalars['Float']['output']>;
  confusion_points: Scalars['Int']['output'];
  details: StudentAnalyticsDetails;
  distractions: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  questions_asked: Scalars['Int']['output'];
  sentiment: Scalars['String']['output'];
  status: Scalars['String']['output'];
  success_points: Scalars['Int']['output'];
  total_time_taken?: Maybe<Scalars['Float']['output']>;
};

export type StudentDetailedAnalyticsResponse = {
  __typename?: 'StudentDetailedAnalyticsResponse';
  count: Scalars['Int']['output'];
  data: Array<StudentDetailedAnalytics>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type StudentLearningInsights = {
  __typename?: 'StudentLearningInsights';
  active_interaction_count: Scalars['Int']['output'];
  confusion_points_details: Array<Scalars['String']['output']>;
  further_recommendations: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  questions_asked: Scalars['Int']['output'];
  success_points_details: Array<Scalars['String']['output']>;
  total_sessions: Scalars['Int']['output'];
  total_time_taken: Scalars['Float']['output'];
};

export type StudentLearningInsightsResponse = {
  __typename?: 'StudentLearningInsightsResponse';
  count: Scalars['Int']['output'];
  data: Array<StudentLearningInsights>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type StudentModuleProgressData = {
  __typename?: 'StudentModuleProgressData';
  active_interaction_count: Scalars['Int']['output'];
  completion_percentage?: Maybe<Scalars['Float']['output']>;
  confusion_points: Scalars['Int']['output'];
  course_id?: Maybe<Scalars['ID']['output']>;
  course_name?: Maybe<Scalars['String']['output']>;
  details: ModuleProgressDetails;
  distractions: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  questions_asked: Scalars['Int']['output'];
  sentiment: Scalars['String']['output'];
  student_id: Scalars['ID']['output'];
  student_name: Scalars['String']['output'];
  success_points: Scalars['Int']['output'];
  total_time_taken?: Maybe<Scalars['Float']['output']>;
};

export type StudentModuleProgressResponse = {
  __typename?: 'StudentModuleProgressResponse';
  count: Scalars['Int']['output'];
  data: Array<StudentModuleProgressData>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type StudentProperties = {
  __typename?: 'StudentProperties';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  initials: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type StudentSummary = {
  __typename?: 'StudentSummary';
  active_interaction_count: Scalars['Int']['output'];
  confusion_points: Scalars['Int']['output'];
  distractions: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  questions_asked: Scalars['Int']['output'];
  schoolEnrollmentDate?: Maybe<Scalars['DateTime']['output']>;
  sentiment: Scalars['String']['output'];
  success_points: Scalars['Int']['output'];
  total_time_taken?: Maybe<Scalars['Float']['output']>;
};

export enum StudyTime {
  Afternoon = 'AFTERNOON',
  Evening = 'EVENING',
  Morning = 'MORNING'
}

export type Subchapter = {
  __typename?: 'Subchapter';
  isRelevant?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type SubchapterConnectWhere = {
  node: SubchapterWhere;
};

export type SubchapterCreateInput = {
  isRelevant?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type SubchapterDetails = {
  __typename?: 'SubchapterDetails';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  objectives?: Maybe<Array<Maybe<LearningObjective>>>;
  success: Scalars['Boolean']['output'];
  totalMastery?: Maybe<Scalars['Float']['output']>;
};

export type SubchapterOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SubchapterSort objects to sort Subchapters by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SubchapterSort>>;
};

/** Fields to sort Subchapters by. The order in which sorts are applied is not guaranteed when specifying many fields in one SubchapterSort object. */
export type SubchapterSort = {
  isRelevant?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type SubchapterUpdateInput = {
  isRelevant?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SubchapterWhere = {
  AND?: InputMaybe<Array<SubchapterWhere>>;
  NOT?: InputMaybe<SubchapterWhere>;
  OR?: InputMaybe<Array<SubchapterWhere>>;
  isRelevant?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type Subfield = {
  __typename?: 'Subfield';
  description?: Maybe<Scalars['String']['output']>;
  isRelevant?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type Submission = {
  __typename?: 'Submission';
  assignment: Assignment;
  assignmentAggregate?: Maybe<SubmissionAssignmentAssignmentAggregationSelection>;
  assignmentConnection: SubmissionAssignmentConnection;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  files: Array<File>;
  filesAggregate?: Maybe<SubmissionFileFilesAggregationSelection>;
  filesConnection: SubmissionFilesConnection;
  grade?: Maybe<Scalars['Float']['output']>;
  hasTeacherGraded?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isCompleted?: Maybe<Scalars['Boolean']['output']>;
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  user: User;
  userAggregate?: Maybe<SubmissionUserUserAggregationSelection>;
  userConnection: SubmissionUserConnection;
};


export type SubmissionAssignmentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AssignmentOptions>;
  where?: InputMaybe<AssignmentWhere>;
};


export type SubmissionAssignmentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssignmentWhere>;
};


export type SubmissionAssignmentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubmissionAssignmentConnectionSort>>;
  where?: InputMaybe<SubmissionAssignmentConnectionWhere>;
};


export type SubmissionFilesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FileOptions>;
  where?: InputMaybe<FileWhere>;
};


export type SubmissionFilesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FileWhere>;
};


export type SubmissionFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubmissionFilesConnectionSort>>;
  where?: InputMaybe<SubmissionFilesConnectionWhere>;
};


export type SubmissionUserArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type SubmissionUserAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type SubmissionUserConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SubmissionUserConnectionSort>>;
  where?: InputMaybe<SubmissionUserConnectionWhere>;
};

export type SubmissionAssignmentAggregateInput = {
  AND?: InputMaybe<Array<SubmissionAssignmentAggregateInput>>;
  NOT?: InputMaybe<SubmissionAssignmentAggregateInput>;
  OR?: InputMaybe<Array<SubmissionAssignmentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SubmissionAssignmentNodeAggregationWhereInput>;
};

export type SubmissionAssignmentAssignmentAggregationSelection = {
  __typename?: 'SubmissionAssignmentAssignmentAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<SubmissionAssignmentAssignmentNodeAggregateSelection>;
};

export type SubmissionAssignmentAssignmentNodeAggregateSelection = {
  __typename?: 'SubmissionAssignmentAssignmentNodeAggregateSelection';
  _empty: StringAggregateSelection;
  allowed_attempts: FloatAggregateSelection;
  assignee_mode: StringAggregateSelection;
  assignment_group_id: FloatAggregateSelection;
  assignment_name: StringAggregateSelection;
  body: StringAggregateSelection;
  category_id: StringAggregateSelection;
  course_id: FloatAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  description: StringAggregateSelection;
  description_plaintext: StringAggregateSelection;
  discussion_topic_assignment_id: FloatAggregateSelection;
  discussion_topic_author_anonymous_id: StringAggregateSelection;
  discussion_topic_author_avatar_image_url: StringAggregateSelection;
  discussion_topic_author_display_name: StringAggregateSelection;
  discussion_topic_author_html_url: StringAggregateSelection;
  discussion_topic_author_id: FloatAggregateSelection;
  discussion_topic_created_at: StringAggregateSelection;
  discussion_topic_discussion_subentry_count: FloatAggregateSelection;
  discussion_topic_discussion_type: StringAggregateSelection;
  discussion_topic_html_url: StringAggregateSelection;
  discussion_topic_id: FloatAggregateSelection;
  discussion_topic_last_reply_at: StringAggregateSelection;
  discussion_topic_message: StringAggregateSelection;
  discussion_topic_posted_at: StringAggregateSelection;
  discussion_topic_read_state: StringAggregateSelection;
  discussion_topic_title: StringAggregateSelection;
  discussion_topic_unread_count: FloatAggregateSelection;
  discussion_topic_url: StringAggregateSelection;
  discussion_topic_user_name: StringAggregateSelection;
  display_date: StringAggregateSelection;
  due_at: StringAggregateSelection;
  due_date: DateTimeAggregateSelection;
  end_date: StringAggregateSelection;
  external_tool_tag_attributes_content_id: FloatAggregateSelection;
  external_tool_tag_attributes_content_type: StringAggregateSelection;
  external_tool_tag_attributes_external_data: StringAggregateSelection;
  external_tool_tag_attributes_resource_link_id: StringAggregateSelection;
  external_tool_tag_attributes_url: StringAggregateSelection;
  grade_points: FloatAggregateSelection;
  grader_count: FloatAggregateSelection;
  grading_type: StringAggregateSelection;
  html: StringAggregateSelection;
  html_url: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  lti_context_id: StringAggregateSelection;
  max_attempts: FloatAggregateSelection;
  max_name_length: FloatAggregateSelection;
  name: StringAggregateSelection;
  needs_grading_count: FloatAggregateSelection;
  objectives: StringAggregateSelection;
  points_possible: FloatAggregateSelection;
  position: FloatAggregateSelection;
  resource_metadata: StringAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  secure_params: StringAggregateSelection;
  session_id: StringAggregateSelection;
  start_date: StringAggregateSelection;
  state: StringAggregateSelection;
  submissions_download_url: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_at: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  url: StringAggregateSelection;
  videoUrl: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export type SubmissionAssignmentConnectFieldInput = {
  connect?: InputMaybe<AssignmentConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AssignmentConnectWhere>;
};

export type SubmissionAssignmentConnectOrCreateFieldInput = {
  onCreate: SubmissionAssignmentConnectOrCreateFieldInputOnCreate;
  where: AssignmentConnectOrCreateWhere;
};

export type SubmissionAssignmentConnectOrCreateFieldInputOnCreate = {
  node: AssignmentOnCreateInput;
};

export type SubmissionAssignmentConnection = {
  __typename?: 'SubmissionAssignmentConnection';
  edges: Array<SubmissionAssignmentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubmissionAssignmentConnectionSort = {
  node?: InputMaybe<AssignmentSort>;
};

export type SubmissionAssignmentConnectionWhere = {
  AND?: InputMaybe<Array<SubmissionAssignmentConnectionWhere>>;
  NOT?: InputMaybe<SubmissionAssignmentConnectionWhere>;
  OR?: InputMaybe<Array<SubmissionAssignmentConnectionWhere>>;
  node?: InputMaybe<AssignmentWhere>;
};

export type SubmissionAssignmentCreateFieldInput = {
  node: AssignmentCreateInput;
};

export type SubmissionAssignmentDeleteFieldInput = {
  delete?: InputMaybe<AssignmentDeleteInput>;
  where?: InputMaybe<SubmissionAssignmentConnectionWhere>;
};

export type SubmissionAssignmentDisconnectFieldInput = {
  disconnect?: InputMaybe<AssignmentDisconnectInput>;
  where?: InputMaybe<SubmissionAssignmentConnectionWhere>;
};

export type SubmissionAssignmentFieldInput = {
  connect?: InputMaybe<SubmissionAssignmentConnectFieldInput>;
  connectOrCreate?: InputMaybe<SubmissionAssignmentConnectOrCreateFieldInput>;
  create?: InputMaybe<SubmissionAssignmentCreateFieldInput>;
};

export type SubmissionAssignmentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SubmissionAssignmentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SubmissionAssignmentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SubmissionAssignmentNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  allowed_attempts_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_group_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  body_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  category_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_assignment_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_unread_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  display_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  due_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_date_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_points_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  html_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lti_context_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  max_attempts_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  needs_grading_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  points_possible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  secure_params_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  secure_params_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  session_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SubmissionAssignmentRelationship = {
  __typename?: 'SubmissionAssignmentRelationship';
  cursor: Scalars['String']['output'];
  node: Assignment;
};

export type SubmissionAssignmentUpdateConnectionInput = {
  node?: InputMaybe<AssignmentUpdateInput>;
};

export type SubmissionAssignmentUpdateFieldInput = {
  connect?: InputMaybe<SubmissionAssignmentConnectFieldInput>;
  connectOrCreate?: InputMaybe<SubmissionAssignmentConnectOrCreateFieldInput>;
  create?: InputMaybe<SubmissionAssignmentCreateFieldInput>;
  delete?: InputMaybe<SubmissionAssignmentDeleteFieldInput>;
  disconnect?: InputMaybe<SubmissionAssignmentDisconnectFieldInput>;
  update?: InputMaybe<SubmissionAssignmentUpdateConnectionInput>;
  where?: InputMaybe<SubmissionAssignmentConnectionWhere>;
};

export type SubmissionConnectInput = {
  assignment?: InputMaybe<SubmissionAssignmentConnectFieldInput>;
  files?: InputMaybe<Array<SubmissionFilesConnectFieldInput>>;
  user?: InputMaybe<SubmissionUserConnectFieldInput>;
};

export type SubmissionConnectOrCreateWhere = {
  node: SubmissionUniqueWhere;
};

export type SubmissionConnectWhere = {
  node: SubmissionWhere;
};

export type SubmissionCreateInput = {
  assignment?: InputMaybe<SubmissionAssignmentFieldInput>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<SubmissionFilesFieldInput>;
  grade?: InputMaybe<Scalars['Float']['input']>;
  hasTeacherGraded?: InputMaybe<Scalars['Boolean']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<SubmissionUserFieldInput>;
};

export type SubmissionDeleteInput = {
  assignment?: InputMaybe<SubmissionAssignmentDeleteFieldInput>;
  files?: InputMaybe<Array<SubmissionFilesDeleteFieldInput>>;
  user?: InputMaybe<SubmissionUserDeleteFieldInput>;
};

export type SubmissionDisconnectInput = {
  assignment?: InputMaybe<SubmissionAssignmentDisconnectFieldInput>;
  files?: InputMaybe<Array<SubmissionFilesDisconnectFieldInput>>;
  user?: InputMaybe<SubmissionUserDisconnectFieldInput>;
};

export type SubmissionFileFilesAggregationSelection = {
  __typename?: 'SubmissionFileFilesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<SubmissionFileFilesNodeAggregateSelection>;
};

export type SubmissionFileFilesNodeAggregateSelection = {
  __typename?: 'SubmissionFileFilesNodeAggregateSelection';
  bucketName: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  fileName: StringAggregateSelection;
  filePath: StringAggregateSelection;
  fileURL: StringAggregateSelection;
  id: IdAggregateSelection;
};

export type SubmissionFilesAggregateInput = {
  AND?: InputMaybe<Array<SubmissionFilesAggregateInput>>;
  NOT?: InputMaybe<SubmissionFilesAggregateInput>;
  OR?: InputMaybe<Array<SubmissionFilesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SubmissionFilesNodeAggregationWhereInput>;
};

export type SubmissionFilesConnectFieldInput = {
  connect?: InputMaybe<Array<FileConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FileConnectWhere>;
};

export type SubmissionFilesConnectOrCreateFieldInput = {
  onCreate: SubmissionFilesConnectOrCreateFieldInputOnCreate;
  where: FileConnectOrCreateWhere;
};

export type SubmissionFilesConnectOrCreateFieldInputOnCreate = {
  node: FileOnCreateInput;
};

export type SubmissionFilesConnection = {
  __typename?: 'SubmissionFilesConnection';
  edges: Array<SubmissionFilesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubmissionFilesConnectionSort = {
  node?: InputMaybe<FileSort>;
};

export type SubmissionFilesConnectionWhere = {
  AND?: InputMaybe<Array<SubmissionFilesConnectionWhere>>;
  NOT?: InputMaybe<SubmissionFilesConnectionWhere>;
  OR?: InputMaybe<Array<SubmissionFilesConnectionWhere>>;
  node?: InputMaybe<FileWhere>;
};

export type SubmissionFilesCreateFieldInput = {
  node: FileCreateInput;
};

export type SubmissionFilesDeleteFieldInput = {
  delete?: InputMaybe<FileDeleteInput>;
  where?: InputMaybe<SubmissionFilesConnectionWhere>;
};

export type SubmissionFilesDisconnectFieldInput = {
  disconnect?: InputMaybe<FileDisconnectInput>;
  where?: InputMaybe<SubmissionFilesConnectionWhere>;
};

export type SubmissionFilesFieldInput = {
  connect?: InputMaybe<Array<SubmissionFilesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SubmissionFilesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SubmissionFilesCreateFieldInput>>;
};

export type SubmissionFilesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SubmissionFilesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SubmissionFilesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SubmissionFilesNodeAggregationWhereInput>>;
  bucketName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  bucketName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  fileName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileURL_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SubmissionFilesRelationship = {
  __typename?: 'SubmissionFilesRelationship';
  cursor: Scalars['String']['output'];
  node: File;
};

export type SubmissionFilesUpdateConnectionInput = {
  node?: InputMaybe<FileUpdateInput>;
};

export type SubmissionFilesUpdateFieldInput = {
  connect?: InputMaybe<Array<SubmissionFilesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SubmissionFilesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SubmissionFilesCreateFieldInput>>;
  delete?: InputMaybe<Array<SubmissionFilesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<SubmissionFilesDisconnectFieldInput>>;
  update?: InputMaybe<SubmissionFilesUpdateConnectionInput>;
  where?: InputMaybe<SubmissionFilesConnectionWhere>;
};

export type SubmissionOnCreateInput = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Scalars['Float']['input']>;
  hasTeacherGraded?: InputMaybe<Scalars['Boolean']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubmissionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SubmissionSort objects to sort Submissions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SubmissionSort>>;
};

export type SubmissionResponse = {
  __typename?: 'SubmissionResponse';
  data?: Maybe<Array<Maybe<Submission>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Fields to sort Submissions by. The order in which sorts are applied is not guaranteed when specifying many fields in one SubmissionSort object. */
export type SubmissionSort = {
  completedAt?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  feedback?: InputMaybe<SortDirection>;
  grade?: InputMaybe<SortDirection>;
  hasTeacherGraded?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isCompleted?: InputMaybe<SortDirection>;
  lastModified?: InputMaybe<SortDirection>;
};

export type SubmissionUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SubmissionUpdateInput = {
  assignment?: InputMaybe<SubmissionAssignmentUpdateFieldInput>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<SubmissionFilesUpdateFieldInput>>;
  grade?: InputMaybe<Scalars['Float']['input']>;
  grade_ADD?: InputMaybe<Scalars['Float']['input']>;
  grade_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  grade_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  grade_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  hasTeacherGraded?: InputMaybe<Scalars['Boolean']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<SubmissionUserUpdateFieldInput>;
};

export type SubmissionUserAggregateInput = {
  AND?: InputMaybe<Array<SubmissionUserAggregateInput>>;
  NOT?: InputMaybe<SubmissionUserAggregateInput>;
  OR?: InputMaybe<Array<SubmissionUserAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SubmissionUserNodeAggregationWhereInput>;
};

export type SubmissionUserConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type SubmissionUserConnectOrCreateFieldInput = {
  onCreate: SubmissionUserConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type SubmissionUserConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type SubmissionUserConnection = {
  __typename?: 'SubmissionUserConnection';
  edges: Array<SubmissionUserRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubmissionUserConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type SubmissionUserConnectionWhere = {
  AND?: InputMaybe<Array<SubmissionUserConnectionWhere>>;
  NOT?: InputMaybe<SubmissionUserConnectionWhere>;
  OR?: InputMaybe<Array<SubmissionUserConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type SubmissionUserCreateFieldInput = {
  node: UserCreateInput;
};

export type SubmissionUserDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<SubmissionUserConnectionWhere>;
};

export type SubmissionUserDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<SubmissionUserConnectionWhere>;
};

export type SubmissionUserFieldInput = {
  connect?: InputMaybe<SubmissionUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<SubmissionUserConnectOrCreateFieldInput>;
  create?: InputMaybe<SubmissionUserCreateFieldInput>;
};

export type SubmissionUserNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SubmissionUserNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SubmissionUserNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SubmissionUserNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SubmissionUserRelationship = {
  __typename?: 'SubmissionUserRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type SubmissionUserUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type SubmissionUserUpdateFieldInput = {
  connect?: InputMaybe<SubmissionUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<SubmissionUserConnectOrCreateFieldInput>;
  create?: InputMaybe<SubmissionUserCreateFieldInput>;
  delete?: InputMaybe<SubmissionUserDeleteFieldInput>;
  disconnect?: InputMaybe<SubmissionUserDisconnectFieldInput>;
  update?: InputMaybe<SubmissionUserUpdateConnectionInput>;
  where?: InputMaybe<SubmissionUserConnectionWhere>;
};

export type SubmissionUserUserAggregationSelection = {
  __typename?: 'SubmissionUserUserAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<SubmissionUserUserNodeAggregateSelection>;
};

export type SubmissionUserUserNodeAggregateSelection = {
  __typename?: 'SubmissionUserUserNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type SubmissionWhere = {
  AND?: InputMaybe<Array<SubmissionWhere>>;
  NOT?: InputMaybe<SubmissionWhere>;
  OR?: InputMaybe<Array<SubmissionWhere>>;
  assignment?: InputMaybe<AssignmentWhere>;
  assignmentAggregate?: InputMaybe<SubmissionAssignmentAggregateInput>;
  assignmentConnection?: InputMaybe<SubmissionAssignmentConnectionWhere>;
  assignmentConnection_NOT?: InputMaybe<SubmissionAssignmentConnectionWhere>;
  assignment_NOT?: InputMaybe<AssignmentWhere>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  completedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  feedback_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  feedback_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  feedback_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  feedback_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  filesAggregate?: InputMaybe<SubmissionFilesAggregateInput>;
  /** Return Submissions where all of the related SubmissionFilesConnections match this filter */
  filesConnection_ALL?: InputMaybe<SubmissionFilesConnectionWhere>;
  /** Return Submissions where none of the related SubmissionFilesConnections match this filter */
  filesConnection_NONE?: InputMaybe<SubmissionFilesConnectionWhere>;
  /** Return Submissions where one of the related SubmissionFilesConnections match this filter */
  filesConnection_SINGLE?: InputMaybe<SubmissionFilesConnectionWhere>;
  /** Return Submissions where some of the related SubmissionFilesConnections match this filter */
  filesConnection_SOME?: InputMaybe<SubmissionFilesConnectionWhere>;
  /** Return Submissions where all of the related Files match this filter */
  files_ALL?: InputMaybe<FileWhere>;
  /** Return Submissions where none of the related Files match this filter */
  files_NONE?: InputMaybe<FileWhere>;
  /** Return Submissions where one of the related Files match this filter */
  files_SINGLE?: InputMaybe<FileWhere>;
  /** Return Submissions where some of the related Files match this filter */
  files_SOME?: InputMaybe<FileWhere>;
  grade?: InputMaybe<Scalars['Float']['input']>;
  grade_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  grade_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_LTE?: InputMaybe<Scalars['Float']['input']>;
  hasTeacherGraded?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastModified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserWhere>;
  userAggregate?: InputMaybe<SubmissionUserAggregateInput>;
  userConnection?: InputMaybe<SubmissionUserConnectionWhere>;
  userConnection_NOT?: InputMaybe<SubmissionUserConnectionWhere>;
  user_NOT?: InputMaybe<UserWhere>;
};

export type SubmitFinalProjectInput = {
  projectId: Scalars['ID']['input'];
  submissionFiles: Array<FileInput>;
  submissionLink?: InputMaybe<Scalars['String']['input']>;
  submissionNotes?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  _empty?: Maybe<Scalars['String']['output']>;
  companionLlmStream: LlmStreamEvent;
  learningLlmStream: LlmStreamEvent;
  onActivityCompleted: BaseProgressEvent;
  onCourseCompleted: BaseProgressEvent;
  onModuleCompleted: BaseProgressEvent;
  onNotificationCreated?: Maybe<NotificationLiveUpdate>;
  onObjectiveCompleted: BaseProgressEvent;
};


export type SubscriptionCompanionLlmStreamArgs = {
  attachment?: InputMaybe<AttachmentInput>;
  chatId?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionLearningLlmStreamArgs = {
  attachment?: InputMaybe<AttachmentInput>;
  chatId?: InputMaybe<Scalars['String']['input']>;
  contentNodeId?: InputMaybe<Scalars['String']['input']>;
  enableTts?: InputMaybe<Scalars['Boolean']['input']>;
  question: Scalars['String']['input'];
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnActivityCompletedArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionOnCourseCompletedArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionOnModuleCompletedArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionOnNotificationCreatedArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionOnObjectiveCompletedArgs = {
  userId: Scalars['ID']['input'];
};

export type Suggestion = {
  __typename?: 'Suggestion';
  assignmentId?: Maybe<Scalars['String']['output']>;
  classId?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  integrationId?: Maybe<Scalars['String']['output']>;
  trackName?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  usersHasSuggestion: Array<User>;
  usersHasSuggestionAggregate?: Maybe<SuggestionUserUsersHasSuggestionAggregationSelection>;
  usersHasSuggestionConnection: SuggestionUsersHasSuggestionConnection;
};


export type SuggestionUsersHasSuggestionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type SuggestionUsersHasSuggestionAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type SuggestionUsersHasSuggestionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SuggestionUsersHasSuggestionConnectionSort>>;
  where?: InputMaybe<SuggestionUsersHasSuggestionConnectionWhere>;
};

export type SuggestionConnectInput = {
  usersHasSuggestion?: InputMaybe<Array<SuggestionUsersHasSuggestionConnectFieldInput>>;
};

export type SuggestionConnectWhere = {
  node: SuggestionWhere;
};

export type SuggestionCreateInput = {
  assignmentId?: InputMaybe<Scalars['String']['input']>;
  classId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  created: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  integrationId?: InputMaybe<Scalars['String']['input']>;
  trackName?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  usersHasSuggestion?: InputMaybe<SuggestionUsersHasSuggestionFieldInput>;
};

export type SuggestionDeleteInput = {
  usersHasSuggestion?: InputMaybe<Array<SuggestionUsersHasSuggestionDeleteFieldInput>>;
};

export type SuggestionDisconnectInput = {
  usersHasSuggestion?: InputMaybe<Array<SuggestionUsersHasSuggestionDisconnectFieldInput>>;
};

export type SuggestionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SuggestionSort objects to sort Suggestions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SuggestionSort>>;
};

/** Fields to sort Suggestions by. The order in which sorts are applied is not guaranteed when specifying many fields in one SuggestionSort object. */
export type SuggestionSort = {
  assignmentId?: InputMaybe<SortDirection>;
  classId?: InputMaybe<SortDirection>;
  content?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  integrationId?: InputMaybe<SortDirection>;
  trackName?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export type SuggestionUpdateInput = {
  assignmentId?: InputMaybe<Scalars['String']['input']>;
  classId?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  integrationId?: InputMaybe<Scalars['String']['input']>;
  trackName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  usersHasSuggestion?: InputMaybe<Array<SuggestionUsersHasSuggestionUpdateFieldInput>>;
};

export type SuggestionUserUsersHasSuggestionAggregationSelection = {
  __typename?: 'SuggestionUserUsersHasSuggestionAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<SuggestionUserUsersHasSuggestionNodeAggregateSelection>;
};

export type SuggestionUserUsersHasSuggestionNodeAggregateSelection = {
  __typename?: 'SuggestionUserUsersHasSuggestionNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type SuggestionUsersHasSuggestionAggregateInput = {
  AND?: InputMaybe<Array<SuggestionUsersHasSuggestionAggregateInput>>;
  NOT?: InputMaybe<SuggestionUsersHasSuggestionAggregateInput>;
  OR?: InputMaybe<Array<SuggestionUsersHasSuggestionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SuggestionUsersHasSuggestionNodeAggregationWhereInput>;
};

export type SuggestionUsersHasSuggestionConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type SuggestionUsersHasSuggestionConnectOrCreateFieldInput = {
  onCreate: SuggestionUsersHasSuggestionConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type SuggestionUsersHasSuggestionConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type SuggestionUsersHasSuggestionConnection = {
  __typename?: 'SuggestionUsersHasSuggestionConnection';
  edges: Array<SuggestionUsersHasSuggestionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SuggestionUsersHasSuggestionConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type SuggestionUsersHasSuggestionConnectionWhere = {
  AND?: InputMaybe<Array<SuggestionUsersHasSuggestionConnectionWhere>>;
  NOT?: InputMaybe<SuggestionUsersHasSuggestionConnectionWhere>;
  OR?: InputMaybe<Array<SuggestionUsersHasSuggestionConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type SuggestionUsersHasSuggestionCreateFieldInput = {
  node: UserCreateInput;
};

export type SuggestionUsersHasSuggestionDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<SuggestionUsersHasSuggestionConnectionWhere>;
};

export type SuggestionUsersHasSuggestionDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<SuggestionUsersHasSuggestionConnectionWhere>;
};

export type SuggestionUsersHasSuggestionFieldInput = {
  connect?: InputMaybe<Array<SuggestionUsersHasSuggestionConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SuggestionUsersHasSuggestionConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SuggestionUsersHasSuggestionCreateFieldInput>>;
};

export type SuggestionUsersHasSuggestionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SuggestionUsersHasSuggestionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SuggestionUsersHasSuggestionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SuggestionUsersHasSuggestionNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SuggestionUsersHasSuggestionRelationship = {
  __typename?: 'SuggestionUsersHasSuggestionRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type SuggestionUsersHasSuggestionUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type SuggestionUsersHasSuggestionUpdateFieldInput = {
  connect?: InputMaybe<Array<SuggestionUsersHasSuggestionConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<SuggestionUsersHasSuggestionConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<SuggestionUsersHasSuggestionCreateFieldInput>>;
  delete?: InputMaybe<Array<SuggestionUsersHasSuggestionDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<SuggestionUsersHasSuggestionDisconnectFieldInput>>;
  update?: InputMaybe<SuggestionUsersHasSuggestionUpdateConnectionInput>;
  where?: InputMaybe<SuggestionUsersHasSuggestionConnectionWhere>;
};

export type SuggestionWhere = {
  AND?: InputMaybe<Array<SuggestionWhere>>;
  NOT?: InputMaybe<SuggestionWhere>;
  OR?: InputMaybe<Array<SuggestionWhere>>;
  assignmentId?: InputMaybe<Scalars['String']['input']>;
  assignmentId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  assignmentId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  assignmentId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assignmentId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  classId?: InputMaybe<Scalars['String']['input']>;
  classId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  classId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  classId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  classId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  content_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  content_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  content_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  integrationId?: InputMaybe<Scalars['String']['input']>;
  integrationId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  integrationId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  integrationId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  integrationId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  trackName?: InputMaybe<Scalars['String']['input']>;
  trackName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  trackName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  trackName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  trackName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  type_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  usersHasSuggestionAggregate?: InputMaybe<SuggestionUsersHasSuggestionAggregateInput>;
  /** Return Suggestions where all of the related SuggestionUsersHasSuggestionConnections match this filter */
  usersHasSuggestionConnection_ALL?: InputMaybe<SuggestionUsersHasSuggestionConnectionWhere>;
  /** Return Suggestions where none of the related SuggestionUsersHasSuggestionConnections match this filter */
  usersHasSuggestionConnection_NONE?: InputMaybe<SuggestionUsersHasSuggestionConnectionWhere>;
  /** Return Suggestions where one of the related SuggestionUsersHasSuggestionConnections match this filter */
  usersHasSuggestionConnection_SINGLE?: InputMaybe<SuggestionUsersHasSuggestionConnectionWhere>;
  /** Return Suggestions where some of the related SuggestionUsersHasSuggestionConnections match this filter */
  usersHasSuggestionConnection_SOME?: InputMaybe<SuggestionUsersHasSuggestionConnectionWhere>;
  /** Return Suggestions where all of the related Users match this filter */
  usersHasSuggestion_ALL?: InputMaybe<UserWhere>;
  /** Return Suggestions where none of the related Users match this filter */
  usersHasSuggestion_NONE?: InputMaybe<UserWhere>;
  /** Return Suggestions where one of the related Users match this filter */
  usersHasSuggestion_SINGLE?: InputMaybe<UserWhere>;
  /** Return Suggestions where some of the related Users match this filter */
  usersHasSuggestion_SOME?: InputMaybe<UserWhere>;
};

export type Tenant = {
  __typename?: 'Tenant';
  additionalScope?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  allowFormSignup?: Maybe<Scalars['Boolean']['output']>;
  allowStripeDiscountCodes?: Maybe<Scalars['Boolean']['output']>;
  allowThirdPartyCredentials?: Maybe<Scalars['Boolean']['output']>;
  auditEvents: Array<AuditEvent>;
  auditEventsAggregate?: Maybe<TenantAuditEventAuditEventsAggregationSelection>;
  auditEventsConnection: TenantAuditEventsConnection;
  autoEnrollCourses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  axioSchools?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  bugReportEmails?: Maybe<Array<Scalars['String']['output']>>;
  companionName?: Maybe<Scalars['String']['output']>;
  companionWebSearchDomains?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  created?: Maybe<Scalars['DateTime']['output']>;
  customNews?: Maybe<Scalars['Boolean']['output']>;
  doRAG?: Maybe<Scalars['Boolean']['output']>;
  documentReferences: Array<DocumentReference>;
  documentReferencesAggregate?: Maybe<TenantDocumentReferenceDocumentReferencesAggregationSelection>;
  documentReferencesConnection: TenantDocumentReferencesConnection;
  documents: Array<Document>;
  documentsAggregate?: Maybe<TenantDocumentDocumentsAggregationSelection>;
  documentsConnection: TenantDocumentsConnection;
  emailBackgroundColor?: Maybe<Scalars['String']['output']>;
  emailFooterColor?: Maybe<Scalars['String']['output']>;
  emulationStatement?: Maybe<Scalars['String']['output']>;
  externalIntegrations: Array<ExternalIntegration>;
  externalIntegrationsAggregate?: Maybe<TenantExternalIntegrationExternalIntegrationsAggregationSelection>;
  externalIntegrationsConnection: TenantExternalIntegrationsConnection;
  externalSendGridDailyEmailTemplateId?: Maybe<Scalars['String']['output']>;
  externalSendGridFromEmail?: Maybe<Scalars['String']['output']>;
  externalSendGridFromName?: Maybe<Scalars['String']['output']>;
  externalSendGridTwilioServiceSID?: Maybe<Scalars['String']['output']>;
  favicon16Url?: Maybe<Scalars['String']['output']>;
  favicon32Url?: Maybe<Scalars['String']['output']>;
  favicon48Url?: Maybe<Scalars['String']['output']>;
  favicon180Url?: Maybe<Scalars['String']['output']>;
  favicon192Url?: Maybe<Scalars['String']['output']>;
  favicon512Url?: Maybe<Scalars['String']['output']>;
  faviconIcoUrl?: Maybe<Scalars['String']['output']>;
  financialInformationUrl?: Maybe<Scalars['String']['output']>;
  gameMenuBg?: Maybe<Scalars['String']['output']>;
  gameMenuCardBg?: Maybe<Scalars['String']['output']>;
  gameMenuProgress?: Maybe<Scalars['String']['output']>;
  gameMenuTrack?: Maybe<Scalars['String']['output']>;
  generalPrompt?: Maybe<Scalars['String']['output']>;
  hasCourseEnrollment?: Maybe<Scalars['Boolean']['output']>;
  hasDegrees?: Maybe<Scalars['Boolean']['output']>;
  hasEmailVerification?: Maybe<Scalars['Boolean']['output']>;
  hasLearningTopicsInChat?: Maybe<Scalars['Boolean']['output']>;
  hasProFlow?: Maybe<Scalars['Boolean']['output']>;
  hasTrial?: Maybe<Scalars['Boolean']['output']>;
  hasTurnBasedAssessments?: Maybe<Scalars['Boolean']['output']>;
  helpCenterUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isAxioOffering?: Maybe<Scalars['Boolean']['output']>;
  isCompanionMode?: Maybe<Scalars['Boolean']['output']>;
  isDailyEventEnabled?: Maybe<Scalars['Boolean']['output']>;
  isFreemium?: Maybe<Scalars['Boolean']['output']>;
  isLMS?: Maybe<Scalars['Boolean']['output']>;
  isLTI?: Maybe<Scalars['Boolean']['output']>;
  isSuggestedInsights?: Maybe<Scalars['Boolean']['output']>;
  isTeacherNotifiedOnEnrollment?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  last_modified?: Maybe<Scalars['DateTime']['output']>;
  learningEmulationStatement?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  ltiLaunchUrl?: Maybe<Scalars['String']['output']>;
  miniLogo?: Maybe<Scalars['String']['output']>;
  moderationHarassment?: Maybe<Scalars['Boolean']['output']>;
  moderationHarassmentThreatening?: Maybe<Scalars['Boolean']['output']>;
  moderationHate?: Maybe<Scalars['Boolean']['output']>;
  moderationHateThreatening?: Maybe<Scalars['Boolean']['output']>;
  moderationSelfHarm?: Maybe<Scalars['Boolean']['output']>;
  moderationSelfHarmInstructions?: Maybe<Scalars['Boolean']['output']>;
  moderationSelfHarmIntent?: Maybe<Scalars['Boolean']['output']>;
  moderationSexual?: Maybe<Scalars['Boolean']['output']>;
  moderationSexualMinors?: Maybe<Scalars['Boolean']['output']>;
  moderationViolence?: Maybe<Scalars['Boolean']['output']>;
  moderationViolenceGraphic?: Maybe<Scalars['Boolean']['output']>;
  newsSearchTerms?: Maybe<Scalars['String']['output']>;
  nudgeTypeConfigs: Array<NudgeTypeConfig>;
  nudgeTypeConfigsAggregate?: Maybe<TenantNudgeTypeConfigNudgeTypeConfigsAggregationSelection>;
  nudgeTypeConfigsConnection: TenantNudgeTypeConfigsConnection;
  oauthClients: Array<OAuthClient>;
  oauthClientsAggregate?: Maybe<TenantOAuthClientOauthClientsAggregationSelection>;
  oauthClientsConnection: TenantOauthClientsConnection;
  officialTranscriptsUrl?: Maybe<Scalars['String']['output']>;
  ogDescription?: Maybe<Scalars['String']['output']>;
  ogImage?: Maybe<Scalars['String']['output']>;
  ogImageHeight?: Maybe<Scalars['String']['output']>;
  ogImageWidth?: Maybe<Scalars['String']['output']>;
  ogSiteName?: Maybe<Scalars['String']['output']>;
  ogTitle?: Maybe<Scalars['String']['output']>;
  ogType?: Maybe<Scalars['String']['output']>;
  onboardingPrompt?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  proLogo?: Maybe<Scalars['String']['output']>;
  reportProblemUrl?: Maybe<Scalars['String']['output']>;
  requireSSO?: Maybe<Scalars['Boolean']['output']>;
  samlConfig?: Maybe<SamlConfig>;
  samlConfigAggregate?: Maybe<TenantSamlConfigSamlConfigAggregationSelection>;
  samlConfigConnection: TenantSamlConfigConnection;
  scheduleAdvisorCallUrl?: Maybe<Scalars['String']['output']>;
  schoolResourcesUrl?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  showFeedback?: Maybe<Scalars['Boolean']['output']>;
  showMiniLogo?: Maybe<Scalars['Boolean']['output']>;
  stripeSecretKey?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  stripeTrialDays?: Maybe<Scalars['Int']['output']>;
  submitHelpTicketLink?: Maybe<Scalars['String']['output']>;
  tenantDomain: Scalars['String']['output'];
  tenantName: Scalars['String']['output'];
  termsOfServiceLink?: Maybe<Scalars['String']['output']>;
  upgradeModalBody?: Maybe<Scalars['String']['output']>;
  users: Array<User>;
  usersAggregate?: Maybe<TenantUserUsersAggregationSelection>;
  usersConnection: TenantUsersConnection;
  webhook?: Maybe<Webhook>;
  webhookAggregate?: Maybe<TenantWebhookWebhookAggregationSelection>;
  webhookConnection: TenantWebhookConnection;
};


export type TenantAuditEventsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AuditEventOptions>;
  where?: InputMaybe<AuditEventWhere>;
};


export type TenantAuditEventsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AuditEventWhere>;
};


export type TenantAuditEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TenantAuditEventsConnectionSort>>;
  where?: InputMaybe<TenantAuditEventsConnectionWhere>;
};


export type TenantDocumentReferencesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DocumentReferenceOptions>;
  where?: InputMaybe<DocumentReferenceWhere>;
};


export type TenantDocumentReferencesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DocumentReferenceWhere>;
};


export type TenantDocumentReferencesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TenantDocumentReferencesConnectionSort>>;
  where?: InputMaybe<TenantDocumentReferencesConnectionWhere>;
};


export type TenantDocumentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DocumentOptions>;
  where?: InputMaybe<DocumentWhere>;
};


export type TenantDocumentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DocumentWhere>;
};


export type TenantDocumentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TenantDocumentsConnectionSort>>;
  where?: InputMaybe<TenantDocumentsConnectionWhere>;
};


export type TenantExternalIntegrationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ExternalIntegrationOptions>;
  where?: InputMaybe<ExternalIntegrationWhere>;
};


export type TenantExternalIntegrationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExternalIntegrationWhere>;
};


export type TenantExternalIntegrationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TenantExternalIntegrationsConnectionSort>>;
  where?: InputMaybe<TenantExternalIntegrationsConnectionWhere>;
};


export type TenantNudgeTypeConfigsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<NudgeTypeConfigOptions>;
  where?: InputMaybe<NudgeTypeConfigWhere>;
};


export type TenantNudgeTypeConfigsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NudgeTypeConfigWhere>;
};


export type TenantNudgeTypeConfigsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TenantNudgeTypeConfigsConnectionSort>>;
  where?: InputMaybe<TenantNudgeTypeConfigsConnectionWhere>;
};


export type TenantOauthClientsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OAuthClientOptions>;
  where?: InputMaybe<OAuthClientWhere>;
};


export type TenantOauthClientsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OAuthClientWhere>;
};


export type TenantOauthClientsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TenantOauthClientsConnectionSort>>;
  where?: InputMaybe<TenantOauthClientsConnectionWhere>;
};


export type TenantSamlConfigArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SamlConfigOptions>;
  where?: InputMaybe<SamlConfigWhere>;
};


export type TenantSamlConfigAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SamlConfigWhere>;
};


export type TenantSamlConfigConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TenantSamlConfigConnectionSort>>;
  where?: InputMaybe<TenantSamlConfigConnectionWhere>;
};


export type TenantUsersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type TenantUsersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type TenantUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TenantUsersConnectionSort>>;
  where?: InputMaybe<TenantUsersConnectionWhere>;
};


export type TenantWebhookArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<WebhookOptions>;
  where?: InputMaybe<WebhookWhere>;
};


export type TenantWebhookAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WebhookWhere>;
};


export type TenantWebhookConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TenantWebhookConnectionSort>>;
  where?: InputMaybe<TenantWebhookConnectionWhere>;
};

export type TenantAuditEventAuditEventsAggregationSelection = {
  __typename?: 'TenantAuditEventAuditEventsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TenantAuditEventAuditEventsNodeAggregateSelection>;
};

export type TenantAuditEventAuditEventsNodeAggregateSelection = {
  __typename?: 'TenantAuditEventAuditEventsNodeAggregateSelection';
  actorId: IdAggregateSelection;
  id: IdAggregateSelection;
  occurredAt: DateTimeAggregateSelection;
  relatedUserId: IdAggregateSelection;
  subjectId: IdAggregateSelection;
  subjectType: StringAggregateSelection;
  tenantId: IdAggregateSelection;
};

export type TenantAuditEventsAggregateInput = {
  AND?: InputMaybe<Array<TenantAuditEventsAggregateInput>>;
  NOT?: InputMaybe<TenantAuditEventsAggregateInput>;
  OR?: InputMaybe<Array<TenantAuditEventsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TenantAuditEventsNodeAggregationWhereInput>;
};

export type TenantAuditEventsConnectFieldInput = {
  connect?: InputMaybe<Array<AuditEventConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AuditEventConnectWhere>;
};

export type TenantAuditEventsConnectOrCreateFieldInput = {
  onCreate: TenantAuditEventsConnectOrCreateFieldInputOnCreate;
  where: AuditEventConnectOrCreateWhere;
};

export type TenantAuditEventsConnectOrCreateFieldInputOnCreate = {
  node: AuditEventOnCreateInput;
};

export type TenantAuditEventsConnection = {
  __typename?: 'TenantAuditEventsConnection';
  edges: Array<TenantAuditEventsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TenantAuditEventsConnectionSort = {
  node?: InputMaybe<AuditEventSort>;
};

export type TenantAuditEventsConnectionWhere = {
  AND?: InputMaybe<Array<TenantAuditEventsConnectionWhere>>;
  NOT?: InputMaybe<TenantAuditEventsConnectionWhere>;
  OR?: InputMaybe<Array<TenantAuditEventsConnectionWhere>>;
  node?: InputMaybe<AuditEventWhere>;
};

export type TenantAuditEventsCreateFieldInput = {
  node: AuditEventCreateInput;
};

export type TenantAuditEventsDeleteFieldInput = {
  delete?: InputMaybe<AuditEventDeleteInput>;
  where?: InputMaybe<TenantAuditEventsConnectionWhere>;
};

export type TenantAuditEventsDisconnectFieldInput = {
  disconnect?: InputMaybe<AuditEventDisconnectInput>;
  where?: InputMaybe<TenantAuditEventsConnectionWhere>;
};

export type TenantAuditEventsFieldInput = {
  connect?: InputMaybe<Array<TenantAuditEventsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TenantAuditEventsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TenantAuditEventsCreateFieldInput>>;
};

export type TenantAuditEventsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TenantAuditEventsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TenantAuditEventsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TenantAuditEventsNodeAggregationWhereInput>>;
  occurredAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  subjectType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subjectType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  subjectType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  subjectType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  subjectType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  subjectType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subjectType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subjectType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subjectType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subjectType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subjectType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subjectType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subjectType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subjectType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subjectType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TenantAuditEventsRelationship = {
  __typename?: 'TenantAuditEventsRelationship';
  cursor: Scalars['String']['output'];
  node: AuditEvent;
};

export type TenantAuditEventsUpdateConnectionInput = {
  node?: InputMaybe<AuditEventUpdateInput>;
};

export type TenantAuditEventsUpdateFieldInput = {
  connect?: InputMaybe<Array<TenantAuditEventsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TenantAuditEventsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TenantAuditEventsCreateFieldInput>>;
  delete?: InputMaybe<Array<TenantAuditEventsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TenantAuditEventsDisconnectFieldInput>>;
  update?: InputMaybe<TenantAuditEventsUpdateConnectionInput>;
  where?: InputMaybe<TenantAuditEventsConnectionWhere>;
};

export type TenantConnectInput = {
  auditEvents?: InputMaybe<Array<TenantAuditEventsConnectFieldInput>>;
  documentReferences?: InputMaybe<Array<TenantDocumentReferencesConnectFieldInput>>;
  documents?: InputMaybe<Array<TenantDocumentsConnectFieldInput>>;
  externalIntegrations?: InputMaybe<Array<TenantExternalIntegrationsConnectFieldInput>>;
  nudgeTypeConfigs?: InputMaybe<Array<TenantNudgeTypeConfigsConnectFieldInput>>;
  oauthClients?: InputMaybe<Array<TenantOauthClientsConnectFieldInput>>;
  samlConfig?: InputMaybe<TenantSamlConfigConnectFieldInput>;
  users?: InputMaybe<Array<TenantUsersConnectFieldInput>>;
  webhook?: InputMaybe<TenantWebhookConnectFieldInput>;
};

export type TenantConnectOrCreateWhere = {
  node: TenantUniqueWhere;
};

export type TenantConnectWhere = {
  node: TenantWhere;
};

export type TenantCreateInput = {
  additionalScope?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowFormSignup?: InputMaybe<Scalars['Boolean']['input']>;
  allowStripeDiscountCodes?: InputMaybe<Scalars['Boolean']['input']>;
  allowThirdPartyCredentials?: InputMaybe<Scalars['Boolean']['input']>;
  auditEvents?: InputMaybe<TenantAuditEventsFieldInput>;
  autoEnrollCourses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  axioSchools?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bugReportEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  companionName?: InputMaybe<Scalars['String']['input']>;
  companionWebSearchDomains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  customNews?: InputMaybe<Scalars['Boolean']['input']>;
  doRAG?: InputMaybe<Scalars['Boolean']['input']>;
  documentReferences?: InputMaybe<TenantDocumentReferencesFieldInput>;
  documents?: InputMaybe<TenantDocumentsFieldInput>;
  emailBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  emailFooterColor?: InputMaybe<Scalars['String']['input']>;
  emulationStatement?: InputMaybe<Scalars['String']['input']>;
  externalIntegrations?: InputMaybe<TenantExternalIntegrationsFieldInput>;
  externalSendGridDailyEmailTemplateId?: InputMaybe<Scalars['String']['input']>;
  externalSendGridFromEmail?: InputMaybe<Scalars['String']['input']>;
  externalSendGridFromName?: InputMaybe<Scalars['String']['input']>;
  externalSendGridTwilioServiceSID?: InputMaybe<Scalars['String']['input']>;
  favicon16Url?: InputMaybe<Scalars['String']['input']>;
  favicon32Url?: InputMaybe<Scalars['String']['input']>;
  favicon48Url?: InputMaybe<Scalars['String']['input']>;
  favicon180Url?: InputMaybe<Scalars['String']['input']>;
  favicon192Url?: InputMaybe<Scalars['String']['input']>;
  favicon512Url?: InputMaybe<Scalars['String']['input']>;
  faviconIcoUrl?: InputMaybe<Scalars['String']['input']>;
  financialInformationUrl?: InputMaybe<Scalars['String']['input']>;
  gameMenuBg?: InputMaybe<Scalars['String']['input']>;
  gameMenuCardBg?: InputMaybe<Scalars['String']['input']>;
  gameMenuProgress?: InputMaybe<Scalars['String']['input']>;
  gameMenuTrack?: InputMaybe<Scalars['String']['input']>;
  generalPrompt?: InputMaybe<Scalars['String']['input']>;
  hasCourseEnrollment?: InputMaybe<Scalars['Boolean']['input']>;
  hasDegrees?: InputMaybe<Scalars['Boolean']['input']>;
  hasEmailVerification?: InputMaybe<Scalars['Boolean']['input']>;
  hasLearningTopicsInChat?: InputMaybe<Scalars['Boolean']['input']>;
  hasProFlow?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrial?: InputMaybe<Scalars['Boolean']['input']>;
  hasTurnBasedAssessments?: InputMaybe<Scalars['Boolean']['input']>;
  helpCenterUrl?: InputMaybe<Scalars['String']['input']>;
  isAxioOffering?: InputMaybe<Scalars['Boolean']['input']>;
  isCompanionMode?: InputMaybe<Scalars['Boolean']['input']>;
  isDailyEventEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isFreemium?: InputMaybe<Scalars['Boolean']['input']>;
  isLMS?: InputMaybe<Scalars['Boolean']['input']>;
  isLTI?: InputMaybe<Scalars['Boolean']['input']>;
  isSuggestedInsights?: InputMaybe<Scalars['Boolean']['input']>;
  isTeacherNotifiedOnEnrollment?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  learningEmulationStatement?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  ltiLaunchUrl?: InputMaybe<Scalars['String']['input']>;
  miniLogo?: InputMaybe<Scalars['String']['input']>;
  moderationHarassment?: InputMaybe<Scalars['Boolean']['input']>;
  moderationHarassmentThreatening?: InputMaybe<Scalars['Boolean']['input']>;
  moderationHate?: InputMaybe<Scalars['Boolean']['input']>;
  moderationHateThreatening?: InputMaybe<Scalars['Boolean']['input']>;
  moderationSelfHarm?: InputMaybe<Scalars['Boolean']['input']>;
  moderationSelfHarmInstructions?: InputMaybe<Scalars['Boolean']['input']>;
  moderationSelfHarmIntent?: InputMaybe<Scalars['Boolean']['input']>;
  moderationSexual?: InputMaybe<Scalars['Boolean']['input']>;
  moderationSexualMinors?: InputMaybe<Scalars['Boolean']['input']>;
  moderationViolence?: InputMaybe<Scalars['Boolean']['input']>;
  moderationViolenceGraphic?: InputMaybe<Scalars['Boolean']['input']>;
  newsSearchTerms?: InputMaybe<Scalars['String']['input']>;
  nudgeTypeConfigs?: InputMaybe<TenantNudgeTypeConfigsFieldInput>;
  oauthClients?: InputMaybe<TenantOauthClientsFieldInput>;
  officialTranscriptsUrl?: InputMaybe<Scalars['String']['input']>;
  ogDescription?: InputMaybe<Scalars['String']['input']>;
  ogImage?: InputMaybe<Scalars['String']['input']>;
  ogImageHeight?: InputMaybe<Scalars['String']['input']>;
  ogImageWidth?: InputMaybe<Scalars['String']['input']>;
  ogSiteName?: InputMaybe<Scalars['String']['input']>;
  ogTitle?: InputMaybe<Scalars['String']['input']>;
  ogType?: InputMaybe<Scalars['String']['input']>;
  onboardingPrompt?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  proLogo?: InputMaybe<Scalars['String']['input']>;
  reportProblemUrl?: InputMaybe<Scalars['String']['input']>;
  requireSSO?: InputMaybe<Scalars['Boolean']['input']>;
  samlConfig?: InputMaybe<TenantSamlConfigFieldInput>;
  scheduleAdvisorCallUrl?: InputMaybe<Scalars['String']['input']>;
  schoolResourcesUrl?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  showMiniLogo?: InputMaybe<Scalars['Boolean']['input']>;
  stripeSecretKey?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  stripeTrialDays?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink?: InputMaybe<Scalars['String']['input']>;
  tenantDomain: Scalars['String']['input'];
  tenantName: Scalars['String']['input'];
  termsOfServiceLink?: InputMaybe<Scalars['String']['input']>;
  upgradeModalBody?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<TenantUsersFieldInput>;
  webhook?: InputMaybe<TenantWebhookFieldInput>;
};

export type TenantDeleteInput = {
  auditEvents?: InputMaybe<Array<TenantAuditEventsDeleteFieldInput>>;
  documentReferences?: InputMaybe<Array<TenantDocumentReferencesDeleteFieldInput>>;
  documents?: InputMaybe<Array<TenantDocumentsDeleteFieldInput>>;
  externalIntegrations?: InputMaybe<Array<TenantExternalIntegrationsDeleteFieldInput>>;
  nudgeTypeConfigs?: InputMaybe<Array<TenantNudgeTypeConfigsDeleteFieldInput>>;
  oauthClients?: InputMaybe<Array<TenantOauthClientsDeleteFieldInput>>;
  samlConfig?: InputMaybe<TenantSamlConfigDeleteFieldInput>;
  users?: InputMaybe<Array<TenantUsersDeleteFieldInput>>;
  webhook?: InputMaybe<TenantWebhookDeleteFieldInput>;
};

export type TenantDisconnectInput = {
  auditEvents?: InputMaybe<Array<TenantAuditEventsDisconnectFieldInput>>;
  documentReferences?: InputMaybe<Array<TenantDocumentReferencesDisconnectFieldInput>>;
  documents?: InputMaybe<Array<TenantDocumentsDisconnectFieldInput>>;
  externalIntegrations?: InputMaybe<Array<TenantExternalIntegrationsDisconnectFieldInput>>;
  nudgeTypeConfigs?: InputMaybe<Array<TenantNudgeTypeConfigsDisconnectFieldInput>>;
  oauthClients?: InputMaybe<Array<TenantOauthClientsDisconnectFieldInput>>;
  samlConfig?: InputMaybe<TenantSamlConfigDisconnectFieldInput>;
  users?: InputMaybe<Array<TenantUsersDisconnectFieldInput>>;
  webhook?: InputMaybe<TenantWebhookDisconnectFieldInput>;
};

export type TenantDocumentDocumentsAggregationSelection = {
  __typename?: 'TenantDocumentDocumentsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TenantDocumentDocumentsNodeAggregateSelection>;
};

export type TenantDocumentDocumentsNodeAggregateSelection = {
  __typename?: 'TenantDocumentDocumentsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  summary: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type TenantDocumentReferenceDocumentReferencesAggregationSelection = {
  __typename?: 'TenantDocumentReferenceDocumentReferencesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TenantDocumentReferenceDocumentReferencesNodeAggregateSelection>;
};

export type TenantDocumentReferenceDocumentReferencesNodeAggregateSelection = {
  __typename?: 'TenantDocumentReferenceDocumentReferencesNodeAggregateSelection';
  chatId: IdAggregateSelection;
  documentId: IdAggregateSelection;
  id: IdAggregateSelection;
  messageId: IdAggregateSelection;
  referencedAt: DateTimeAggregateSelection;
  tenantId: IdAggregateSelection;
};

export type TenantDocumentReferencesAggregateInput = {
  AND?: InputMaybe<Array<TenantDocumentReferencesAggregateInput>>;
  NOT?: InputMaybe<TenantDocumentReferencesAggregateInput>;
  OR?: InputMaybe<Array<TenantDocumentReferencesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TenantDocumentReferencesNodeAggregationWhereInput>;
};

export type TenantDocumentReferencesConnectFieldInput = {
  connect?: InputMaybe<Array<DocumentReferenceConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DocumentReferenceConnectWhere>;
};

export type TenantDocumentReferencesConnectOrCreateFieldInput = {
  onCreate: TenantDocumentReferencesConnectOrCreateFieldInputOnCreate;
  where: DocumentReferenceConnectOrCreateWhere;
};

export type TenantDocumentReferencesConnectOrCreateFieldInputOnCreate = {
  node: DocumentReferenceOnCreateInput;
};

export type TenantDocumentReferencesConnection = {
  __typename?: 'TenantDocumentReferencesConnection';
  edges: Array<TenantDocumentReferencesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TenantDocumentReferencesConnectionSort = {
  node?: InputMaybe<DocumentReferenceSort>;
};

export type TenantDocumentReferencesConnectionWhere = {
  AND?: InputMaybe<Array<TenantDocumentReferencesConnectionWhere>>;
  NOT?: InputMaybe<TenantDocumentReferencesConnectionWhere>;
  OR?: InputMaybe<Array<TenantDocumentReferencesConnectionWhere>>;
  node?: InputMaybe<DocumentReferenceWhere>;
};

export type TenantDocumentReferencesCreateFieldInput = {
  node: DocumentReferenceCreateInput;
};

export type TenantDocumentReferencesDeleteFieldInput = {
  delete?: InputMaybe<DocumentReferenceDeleteInput>;
  where?: InputMaybe<TenantDocumentReferencesConnectionWhere>;
};

export type TenantDocumentReferencesDisconnectFieldInput = {
  disconnect?: InputMaybe<DocumentReferenceDisconnectInput>;
  where?: InputMaybe<TenantDocumentReferencesConnectionWhere>;
};

export type TenantDocumentReferencesFieldInput = {
  connect?: InputMaybe<Array<TenantDocumentReferencesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TenantDocumentReferencesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TenantDocumentReferencesCreateFieldInput>>;
};

export type TenantDocumentReferencesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TenantDocumentReferencesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TenantDocumentReferencesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TenantDocumentReferencesNodeAggregationWhereInput>>;
  referencedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  referencedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  referencedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  referencedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  referencedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  referencedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  referencedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  referencedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  referencedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  referencedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TenantDocumentReferencesRelationship = {
  __typename?: 'TenantDocumentReferencesRelationship';
  cursor: Scalars['String']['output'];
  node: DocumentReference;
};

export type TenantDocumentReferencesUpdateConnectionInput = {
  node?: InputMaybe<DocumentReferenceUpdateInput>;
};

export type TenantDocumentReferencesUpdateFieldInput = {
  connect?: InputMaybe<Array<TenantDocumentReferencesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TenantDocumentReferencesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TenantDocumentReferencesCreateFieldInput>>;
  delete?: InputMaybe<Array<TenantDocumentReferencesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TenantDocumentReferencesDisconnectFieldInput>>;
  update?: InputMaybe<TenantDocumentReferencesUpdateConnectionInput>;
  where?: InputMaybe<TenantDocumentReferencesConnectionWhere>;
};

export type TenantDocumentsAggregateInput = {
  AND?: InputMaybe<Array<TenantDocumentsAggregateInput>>;
  NOT?: InputMaybe<TenantDocumentsAggregateInput>;
  OR?: InputMaybe<Array<TenantDocumentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TenantDocumentsNodeAggregationWhereInput>;
};

export type TenantDocumentsConnectFieldInput = {
  connect?: InputMaybe<Array<DocumentConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DocumentConnectWhere>;
};

export type TenantDocumentsConnection = {
  __typename?: 'TenantDocumentsConnection';
  edges: Array<TenantDocumentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TenantDocumentsConnectionSort = {
  node?: InputMaybe<DocumentSort>;
};

export type TenantDocumentsConnectionWhere = {
  AND?: InputMaybe<Array<TenantDocumentsConnectionWhere>>;
  NOT?: InputMaybe<TenantDocumentsConnectionWhere>;
  OR?: InputMaybe<Array<TenantDocumentsConnectionWhere>>;
  node?: InputMaybe<DocumentWhere>;
};

export type TenantDocumentsCreateFieldInput = {
  node: DocumentCreateInput;
};

export type TenantDocumentsDeleteFieldInput = {
  delete?: InputMaybe<DocumentDeleteInput>;
  where?: InputMaybe<TenantDocumentsConnectionWhere>;
};

export type TenantDocumentsDisconnectFieldInput = {
  disconnect?: InputMaybe<DocumentDisconnectInput>;
  where?: InputMaybe<TenantDocumentsConnectionWhere>;
};

export type TenantDocumentsFieldInput = {
  connect?: InputMaybe<Array<TenantDocumentsConnectFieldInput>>;
  create?: InputMaybe<Array<TenantDocumentsCreateFieldInput>>;
};

export type TenantDocumentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TenantDocumentsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TenantDocumentsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TenantDocumentsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  summary_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  summary_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TenantDocumentsRelationship = {
  __typename?: 'TenantDocumentsRelationship';
  cursor: Scalars['String']['output'];
  node: Document;
};

export type TenantDocumentsUpdateConnectionInput = {
  node?: InputMaybe<DocumentUpdateInput>;
};

export type TenantDocumentsUpdateFieldInput = {
  connect?: InputMaybe<Array<TenantDocumentsConnectFieldInput>>;
  create?: InputMaybe<Array<TenantDocumentsCreateFieldInput>>;
  delete?: InputMaybe<Array<TenantDocumentsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TenantDocumentsDisconnectFieldInput>>;
  update?: InputMaybe<TenantDocumentsUpdateConnectionInput>;
  where?: InputMaybe<TenantDocumentsConnectionWhere>;
};

export type TenantExternalIntegrationExternalIntegrationsAggregationSelection = {
  __typename?: 'TenantExternalIntegrationExternalIntegrationsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TenantExternalIntegrationExternalIntegrationsNodeAggregateSelection>;
};

export type TenantExternalIntegrationExternalIntegrationsNodeAggregateSelection = {
  __typename?: 'TenantExternalIntegrationExternalIntegrationsNodeAggregateSelection';
  apiBaseUrl: StringAggregateSelection;
  apiKey: StringAggregateSelection;
  config: StringAggregateSelection;
  id: IdAggregateSelection;
  type: StringAggregateSelection;
};

export type TenantExternalIntegrationsAggregateInput = {
  AND?: InputMaybe<Array<TenantExternalIntegrationsAggregateInput>>;
  NOT?: InputMaybe<TenantExternalIntegrationsAggregateInput>;
  OR?: InputMaybe<Array<TenantExternalIntegrationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TenantExternalIntegrationsNodeAggregationWhereInput>;
};

export type TenantExternalIntegrationsConnectFieldInput = {
  connect?: InputMaybe<Array<ExternalIntegrationConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ExternalIntegrationConnectWhere>;
};

export type TenantExternalIntegrationsConnectOrCreateFieldInput = {
  onCreate: TenantExternalIntegrationsConnectOrCreateFieldInputOnCreate;
  where: ExternalIntegrationConnectOrCreateWhere;
};

export type TenantExternalIntegrationsConnectOrCreateFieldInputOnCreate = {
  node: ExternalIntegrationOnCreateInput;
};

export type TenantExternalIntegrationsConnection = {
  __typename?: 'TenantExternalIntegrationsConnection';
  edges: Array<TenantExternalIntegrationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TenantExternalIntegrationsConnectionSort = {
  node?: InputMaybe<ExternalIntegrationSort>;
};

export type TenantExternalIntegrationsConnectionWhere = {
  AND?: InputMaybe<Array<TenantExternalIntegrationsConnectionWhere>>;
  NOT?: InputMaybe<TenantExternalIntegrationsConnectionWhere>;
  OR?: InputMaybe<Array<TenantExternalIntegrationsConnectionWhere>>;
  node?: InputMaybe<ExternalIntegrationWhere>;
};

export type TenantExternalIntegrationsCreateFieldInput = {
  node: ExternalIntegrationCreateInput;
};

export type TenantExternalIntegrationsDeleteFieldInput = {
  delete?: InputMaybe<ExternalIntegrationDeleteInput>;
  where?: InputMaybe<TenantExternalIntegrationsConnectionWhere>;
};

export type TenantExternalIntegrationsDisconnectFieldInput = {
  disconnect?: InputMaybe<ExternalIntegrationDisconnectInput>;
  where?: InputMaybe<TenantExternalIntegrationsConnectionWhere>;
};

export type TenantExternalIntegrationsFieldInput = {
  connect?: InputMaybe<Array<TenantExternalIntegrationsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TenantExternalIntegrationsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TenantExternalIntegrationsCreateFieldInput>>;
};

export type TenantExternalIntegrationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TenantExternalIntegrationsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TenantExternalIntegrationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TenantExternalIntegrationsNodeAggregationWhereInput>>;
  apiBaseUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  apiBaseUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  apiBaseUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  apiBaseUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  apiBaseUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  apiBaseUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  apiBaseUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  apiBaseUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  apiBaseUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  apiBaseUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  apiBaseUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  apiBaseUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  apiBaseUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  apiBaseUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  apiBaseUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  apiKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  apiKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  apiKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  apiKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  apiKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  apiKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  apiKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  apiKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  apiKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  apiKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  apiKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  apiKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  apiKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  apiKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  apiKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  config_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  config_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  config_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  config_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  config_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  config_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  config_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  config_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  config_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  config_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  config_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  config_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  config_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  config_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  config_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TenantExternalIntegrationsRelationship = {
  __typename?: 'TenantExternalIntegrationsRelationship';
  cursor: Scalars['String']['output'];
  node: ExternalIntegration;
};

export type TenantExternalIntegrationsUpdateConnectionInput = {
  node?: InputMaybe<ExternalIntegrationUpdateInput>;
};

export type TenantExternalIntegrationsUpdateFieldInput = {
  connect?: InputMaybe<Array<TenantExternalIntegrationsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TenantExternalIntegrationsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TenantExternalIntegrationsCreateFieldInput>>;
  delete?: InputMaybe<Array<TenantExternalIntegrationsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TenantExternalIntegrationsDisconnectFieldInput>>;
  update?: InputMaybe<TenantExternalIntegrationsUpdateConnectionInput>;
  where?: InputMaybe<TenantExternalIntegrationsConnectionWhere>;
};

export type TenantInput = {
  additionalScope?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowFormSignup?: InputMaybe<Scalars['Boolean']['input']>;
  allowStripeDiscountCodes?: InputMaybe<Scalars['Boolean']['input']>;
  allowThirdPartyCredentials?: InputMaybe<Scalars['Boolean']['input']>;
  autoEnrollCourses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bugReportEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  companionName?: InputMaybe<Scalars['String']['input']>;
  companionWebSearchDomains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customNews?: InputMaybe<Scalars['Boolean']['input']>;
  doRAG?: InputMaybe<Scalars['Boolean']['input']>;
  emailBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  emailFooterColor?: InputMaybe<Scalars['String']['input']>;
  emulationStatement?: InputMaybe<Scalars['String']['input']>;
  externalSendGridDailyEmailTemplateId?: InputMaybe<Scalars['String']['input']>;
  externalSendGridFromEmail?: InputMaybe<Scalars['String']['input']>;
  externalSendGridFromName?: InputMaybe<Scalars['String']['input']>;
  externalSendGridTwilioServiceSID?: InputMaybe<Scalars['String']['input']>;
  favicon16Url?: InputMaybe<Scalars['String']['input']>;
  favicon32Url?: InputMaybe<Scalars['String']['input']>;
  favicon48Url?: InputMaybe<Scalars['String']['input']>;
  favicon180Url?: InputMaybe<Scalars['String']['input']>;
  favicon192Url?: InputMaybe<Scalars['String']['input']>;
  favicon512Url?: InputMaybe<Scalars['String']['input']>;
  faviconIcoUrl?: InputMaybe<Scalars['String']['input']>;
  financialInformationUrl?: InputMaybe<Scalars['String']['input']>;
  gameMenuBg?: InputMaybe<Scalars['String']['input']>;
  gameMenuCardBg?: InputMaybe<Scalars['String']['input']>;
  gameMenuProgress?: InputMaybe<Scalars['String']['input']>;
  gameMenuTrack?: InputMaybe<Scalars['String']['input']>;
  generalPrompt?: InputMaybe<Scalars['String']['input']>;
  hasCourseEnrollment?: InputMaybe<Scalars['Boolean']['input']>;
  hasDegrees?: InputMaybe<Scalars['Boolean']['input']>;
  hasEmailVerification?: InputMaybe<Scalars['Boolean']['input']>;
  hasLearningTopicsInChat?: InputMaybe<Scalars['Boolean']['input']>;
  hasProFlow?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrial?: InputMaybe<Scalars['Boolean']['input']>;
  hasTurnBasedAssessments?: InputMaybe<Scalars['Boolean']['input']>;
  helpCenterUrl?: InputMaybe<Scalars['String']['input']>;
  isAxioOffering?: InputMaybe<Scalars['Boolean']['input']>;
  isCompanionMode?: InputMaybe<Scalars['Boolean']['input']>;
  isDailyEventEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isFreemium?: InputMaybe<Scalars['Boolean']['input']>;
  isLMS?: InputMaybe<Scalars['Boolean']['input']>;
  isLTI?: InputMaybe<Scalars['Boolean']['input']>;
  isSuggestedInsights?: InputMaybe<Scalars['Boolean']['input']>;
  isTeacherNotifiedOnEnrollment?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  learningEmulationStatement?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  ltiLaunchUrl?: InputMaybe<Scalars['String']['input']>;
  miniLogo?: InputMaybe<Scalars['String']['input']>;
  moderationHarassment?: InputMaybe<Scalars['Boolean']['input']>;
  moderationHarassmentThreatening?: InputMaybe<Scalars['Boolean']['input']>;
  moderationHate?: InputMaybe<Scalars['Boolean']['input']>;
  moderationHateThreatening?: InputMaybe<Scalars['Boolean']['input']>;
  moderationSelfHarm?: InputMaybe<Scalars['Boolean']['input']>;
  moderationSelfHarmInstructions?: InputMaybe<Scalars['Boolean']['input']>;
  moderationSelfHarmIntent?: InputMaybe<Scalars['Boolean']['input']>;
  moderationSexual?: InputMaybe<Scalars['Boolean']['input']>;
  moderationSexualMinors?: InputMaybe<Scalars['Boolean']['input']>;
  moderationViolence?: InputMaybe<Scalars['Boolean']['input']>;
  moderationViolenceGraphic?: InputMaybe<Scalars['Boolean']['input']>;
  newsSearchTerms?: InputMaybe<Scalars['String']['input']>;
  officialTranscriptsUrl?: InputMaybe<Scalars['String']['input']>;
  ogDescription?: InputMaybe<Scalars['String']['input']>;
  ogImage?: InputMaybe<Scalars['String']['input']>;
  ogImageHeight?: InputMaybe<Scalars['String']['input']>;
  ogImageWidth?: InputMaybe<Scalars['String']['input']>;
  ogSiteName?: InputMaybe<Scalars['String']['input']>;
  ogTitle?: InputMaybe<Scalars['String']['input']>;
  ogType?: InputMaybe<Scalars['String']['input']>;
  onboardingPrompt?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  proLogo?: InputMaybe<Scalars['String']['input']>;
  reportProblemUrl?: InputMaybe<Scalars['String']['input']>;
  requireSSO?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleAdvisorCallUrl?: InputMaybe<Scalars['String']['input']>;
  schoolResourcesUrl?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  showMiniLogo?: InputMaybe<Scalars['Boolean']['input']>;
  stripeSecretKey?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  stripeTrialDays?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink?: InputMaybe<Scalars['String']['input']>;
  tenantDomain: Scalars['String']['input'];
  tenantName: Scalars['String']['input'];
  termsOfServiceLink?: InputMaybe<Scalars['String']['input']>;
  upgradeModalBody?: InputMaybe<Scalars['String']['input']>;
};

export type TenantNudgeTypeConfigNudgeTypeConfigsAggregationSelection = {
  __typename?: 'TenantNudgeTypeConfigNudgeTypeConfigsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TenantNudgeTypeConfigNudgeTypeConfigsNodeAggregateSelection>;
};

export type TenantNudgeTypeConfigNudgeTypeConfigsNodeAggregateSelection = {
  __typename?: 'TenantNudgeTypeConfigNudgeTypeConfigsNodeAggregateSelection';
  cooldownEmailHours: IntAggregateSelection;
  cooldownSmsHours: IntAggregateSelection;
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  key: StringAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  maxInactiveDays: IntAggregateSelection;
  maxSendsEmail: IntAggregateSelection;
  maxSendsSms: IntAggregateSelection;
  maxWindowDays: IntAggregateSelection;
  readinessThreshold: FloatAggregateSelection;
  smsThreshold: FloatAggregateSelection;
  weightAcademicImpact: FloatAggregateSelection;
  weightEventSequenceDecay: FloatAggregateSelection;
  weightPriorResponse: FloatAggregateSelection;
  weightTimeUrgency: FloatAggregateSelection;
  weightUserEngagement: FloatAggregateSelection;
};

export type TenantNudgeTypeConfigsAggregateInput = {
  AND?: InputMaybe<Array<TenantNudgeTypeConfigsAggregateInput>>;
  NOT?: InputMaybe<TenantNudgeTypeConfigsAggregateInput>;
  OR?: InputMaybe<Array<TenantNudgeTypeConfigsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TenantNudgeTypeConfigsNodeAggregationWhereInput>;
};

export type TenantNudgeTypeConfigsConnectFieldInput = {
  connect?: InputMaybe<Array<NudgeTypeConfigConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<NudgeTypeConfigConnectWhere>;
};

export type TenantNudgeTypeConfigsConnectOrCreateFieldInput = {
  onCreate: TenantNudgeTypeConfigsConnectOrCreateFieldInputOnCreate;
  where: NudgeTypeConfigConnectOrCreateWhere;
};

export type TenantNudgeTypeConfigsConnectOrCreateFieldInputOnCreate = {
  node: NudgeTypeConfigOnCreateInput;
};

export type TenantNudgeTypeConfigsConnection = {
  __typename?: 'TenantNudgeTypeConfigsConnection';
  edges: Array<TenantNudgeTypeConfigsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TenantNudgeTypeConfigsConnectionSort = {
  node?: InputMaybe<NudgeTypeConfigSort>;
};

export type TenantNudgeTypeConfigsConnectionWhere = {
  AND?: InputMaybe<Array<TenantNudgeTypeConfigsConnectionWhere>>;
  NOT?: InputMaybe<TenantNudgeTypeConfigsConnectionWhere>;
  OR?: InputMaybe<Array<TenantNudgeTypeConfigsConnectionWhere>>;
  node?: InputMaybe<NudgeTypeConfigWhere>;
};

export type TenantNudgeTypeConfigsCreateFieldInput = {
  node: NudgeTypeConfigCreateInput;
};

export type TenantNudgeTypeConfigsDeleteFieldInput = {
  delete?: InputMaybe<NudgeTypeConfigDeleteInput>;
  where?: InputMaybe<TenantNudgeTypeConfigsConnectionWhere>;
};

export type TenantNudgeTypeConfigsDisconnectFieldInput = {
  disconnect?: InputMaybe<NudgeTypeConfigDisconnectInput>;
  where?: InputMaybe<TenantNudgeTypeConfigsConnectionWhere>;
};

export type TenantNudgeTypeConfigsFieldInput = {
  connect?: InputMaybe<Array<TenantNudgeTypeConfigsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TenantNudgeTypeConfigsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TenantNudgeTypeConfigsCreateFieldInput>>;
};

export type TenantNudgeTypeConfigsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TenantNudgeTypeConfigsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TenantNudgeTypeConfigsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TenantNudgeTypeConfigsNodeAggregationWhereInput>>;
  cooldownEmailHours_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cooldownEmailHours_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  cooldownEmailHours_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cooldownEmailHours_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  cooldownEmailHours_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  cooldownEmailHours_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cooldownEmailHours_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  cooldownEmailHours_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  cooldownEmailHours_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  cooldownEmailHours_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  cooldownEmailHours_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cooldownEmailHours_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  cooldownEmailHours_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  cooldownEmailHours_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  cooldownEmailHours_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  cooldownEmailHours_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cooldownEmailHours_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  cooldownEmailHours_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  cooldownEmailHours_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  cooldownEmailHours_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  cooldownSmsHours_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cooldownSmsHours_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  cooldownSmsHours_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cooldownSmsHours_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  cooldownSmsHours_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  cooldownSmsHours_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cooldownSmsHours_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  cooldownSmsHours_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  cooldownSmsHours_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  cooldownSmsHours_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  cooldownSmsHours_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cooldownSmsHours_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  cooldownSmsHours_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  cooldownSmsHours_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  cooldownSmsHours_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  cooldownSmsHours_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cooldownSmsHours_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  cooldownSmsHours_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  cooldownSmsHours_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  cooldownSmsHours_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  key_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  key_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  maxInactiveDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxInactiveDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maxInactiveDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxInactiveDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maxInactiveDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxInactiveDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxInactiveDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  maxInactiveDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxInactiveDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  maxInactiveDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxInactiveDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxInactiveDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  maxInactiveDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxInactiveDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  maxInactiveDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxInactiveDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxInactiveDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  maxInactiveDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxInactiveDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  maxInactiveDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxSendsEmail_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxSendsEmail_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maxSendsEmail_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxSendsEmail_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maxSendsEmail_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxSendsEmail_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxSendsEmail_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  maxSendsEmail_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxSendsEmail_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  maxSendsEmail_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxSendsEmail_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxSendsEmail_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  maxSendsEmail_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxSendsEmail_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  maxSendsEmail_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxSendsEmail_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxSendsEmail_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  maxSendsEmail_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxSendsEmail_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  maxSendsEmail_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxSendsSms_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxSendsSms_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maxSendsSms_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxSendsSms_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maxSendsSms_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxSendsSms_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxSendsSms_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  maxSendsSms_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxSendsSms_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  maxSendsSms_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxSendsSms_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxSendsSms_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  maxSendsSms_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxSendsSms_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  maxSendsSms_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxSendsSms_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxSendsSms_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  maxSendsSms_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxSendsSms_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  maxSendsSms_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxWindowDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxWindowDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maxWindowDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxWindowDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maxWindowDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxWindowDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxWindowDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  maxWindowDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxWindowDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  maxWindowDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxWindowDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxWindowDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  maxWindowDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxWindowDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  maxWindowDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxWindowDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxWindowDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  maxWindowDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxWindowDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  maxWindowDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  readinessThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  readinessThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  readinessThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  readinessThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  readinessThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  readinessThreshold_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  readinessThreshold_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  readinessThreshold_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  readinessThreshold_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  readinessThreshold_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  readinessThreshold_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  readinessThreshold_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  readinessThreshold_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  readinessThreshold_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  readinessThreshold_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  readinessThreshold_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  readinessThreshold_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  readinessThreshold_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  readinessThreshold_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  readinessThreshold_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  smsThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  smsThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  smsThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  smsThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  smsThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  smsThreshold_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  smsThreshold_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  smsThreshold_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  smsThreshold_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  smsThreshold_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  smsThreshold_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  smsThreshold_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  smsThreshold_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  smsThreshold_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  smsThreshold_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  smsThreshold_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  smsThreshold_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  smsThreshold_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  smsThreshold_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  smsThreshold_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  weightAcademicImpact_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  weightAcademicImpact_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  weightAcademicImpact_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  weightAcademicImpact_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  weightAcademicImpact_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  weightAcademicImpact_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  weightAcademicImpact_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  weightAcademicImpact_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  weightAcademicImpact_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  weightAcademicImpact_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  weightAcademicImpact_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  weightAcademicImpact_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  weightAcademicImpact_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  weightAcademicImpact_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  weightAcademicImpact_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  weightAcademicImpact_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  weightAcademicImpact_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  weightAcademicImpact_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  weightAcademicImpact_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  weightAcademicImpact_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  weightEventSequenceDecay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  weightEventSequenceDecay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  weightEventSequenceDecay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  weightEventSequenceDecay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  weightEventSequenceDecay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  weightEventSequenceDecay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  weightEventSequenceDecay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  weightEventSequenceDecay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  weightEventSequenceDecay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  weightEventSequenceDecay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  weightEventSequenceDecay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  weightEventSequenceDecay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  weightEventSequenceDecay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  weightEventSequenceDecay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  weightEventSequenceDecay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  weightEventSequenceDecay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  weightEventSequenceDecay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  weightEventSequenceDecay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  weightEventSequenceDecay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  weightEventSequenceDecay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  weightPriorResponse_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  weightPriorResponse_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  weightPriorResponse_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  weightPriorResponse_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  weightPriorResponse_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  weightPriorResponse_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  weightPriorResponse_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  weightPriorResponse_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  weightPriorResponse_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  weightPriorResponse_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  weightPriorResponse_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  weightPriorResponse_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  weightPriorResponse_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  weightPriorResponse_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  weightPriorResponse_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  weightPriorResponse_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  weightPriorResponse_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  weightPriorResponse_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  weightPriorResponse_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  weightPriorResponse_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  weightTimeUrgency_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  weightTimeUrgency_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  weightTimeUrgency_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  weightTimeUrgency_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  weightTimeUrgency_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  weightTimeUrgency_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  weightTimeUrgency_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  weightTimeUrgency_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  weightTimeUrgency_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  weightTimeUrgency_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  weightTimeUrgency_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  weightTimeUrgency_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  weightTimeUrgency_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  weightTimeUrgency_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  weightTimeUrgency_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  weightTimeUrgency_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  weightTimeUrgency_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  weightTimeUrgency_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  weightTimeUrgency_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  weightTimeUrgency_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  weightUserEngagement_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  weightUserEngagement_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  weightUserEngagement_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  weightUserEngagement_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  weightUserEngagement_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  weightUserEngagement_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  weightUserEngagement_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  weightUserEngagement_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  weightUserEngagement_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  weightUserEngagement_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  weightUserEngagement_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  weightUserEngagement_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  weightUserEngagement_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  weightUserEngagement_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  weightUserEngagement_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  weightUserEngagement_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  weightUserEngagement_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  weightUserEngagement_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  weightUserEngagement_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  weightUserEngagement_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type TenantNudgeTypeConfigsRelationship = {
  __typename?: 'TenantNudgeTypeConfigsRelationship';
  cursor: Scalars['String']['output'];
  node: NudgeTypeConfig;
};

export type TenantNudgeTypeConfigsUpdateConnectionInput = {
  node?: InputMaybe<NudgeTypeConfigUpdateInput>;
};

export type TenantNudgeTypeConfigsUpdateFieldInput = {
  connect?: InputMaybe<Array<TenantNudgeTypeConfigsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TenantNudgeTypeConfigsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TenantNudgeTypeConfigsCreateFieldInput>>;
  delete?: InputMaybe<Array<TenantNudgeTypeConfigsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TenantNudgeTypeConfigsDisconnectFieldInput>>;
  update?: InputMaybe<TenantNudgeTypeConfigsUpdateConnectionInput>;
  where?: InputMaybe<TenantNudgeTypeConfigsConnectionWhere>;
};

export type TenantOAuthClientOauthClientsAggregationSelection = {
  __typename?: 'TenantOAuthClientOauthClientsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TenantOAuthClientOauthClientsNodeAggregateSelection>;
};

export type TenantOAuthClientOauthClientsNodeAggregateSelection = {
  __typename?: 'TenantOAuthClientOauthClientsNodeAggregateSelection';
  clientId: StringAggregateSelection;
  clientSecret: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
};

export type TenantOauthClientsAggregateInput = {
  AND?: InputMaybe<Array<TenantOauthClientsAggregateInput>>;
  NOT?: InputMaybe<TenantOauthClientsAggregateInput>;
  OR?: InputMaybe<Array<TenantOauthClientsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TenantOauthClientsNodeAggregationWhereInput>;
};

export type TenantOauthClientsConnectFieldInput = {
  connect?: InputMaybe<Array<OAuthClientConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<OAuthClientConnectWhere>;
};

export type TenantOauthClientsConnectOrCreateFieldInput = {
  onCreate: TenantOauthClientsConnectOrCreateFieldInputOnCreate;
  where: OAuthClientConnectOrCreateWhere;
};

export type TenantOauthClientsConnectOrCreateFieldInputOnCreate = {
  node: OAuthClientOnCreateInput;
};

export type TenantOauthClientsConnection = {
  __typename?: 'TenantOauthClientsConnection';
  edges: Array<TenantOauthClientsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TenantOauthClientsConnectionSort = {
  node?: InputMaybe<OAuthClientSort>;
};

export type TenantOauthClientsConnectionWhere = {
  AND?: InputMaybe<Array<TenantOauthClientsConnectionWhere>>;
  NOT?: InputMaybe<TenantOauthClientsConnectionWhere>;
  OR?: InputMaybe<Array<TenantOauthClientsConnectionWhere>>;
  node?: InputMaybe<OAuthClientWhere>;
};

export type TenantOauthClientsCreateFieldInput = {
  node: OAuthClientCreateInput;
};

export type TenantOauthClientsDeleteFieldInput = {
  delete?: InputMaybe<OAuthClientDeleteInput>;
  where?: InputMaybe<TenantOauthClientsConnectionWhere>;
};

export type TenantOauthClientsDisconnectFieldInput = {
  disconnect?: InputMaybe<OAuthClientDisconnectInput>;
  where?: InputMaybe<TenantOauthClientsConnectionWhere>;
};

export type TenantOauthClientsFieldInput = {
  connect?: InputMaybe<Array<TenantOauthClientsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TenantOauthClientsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TenantOauthClientsCreateFieldInput>>;
};

export type TenantOauthClientsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TenantOauthClientsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TenantOauthClientsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TenantOauthClientsNodeAggregationWhereInput>>;
  clientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  clientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  clientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  clientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  clientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  clientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  clientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  clientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  clientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  clientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  clientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  clientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  clientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  clientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  clientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  clientSecret_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  clientSecret_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  clientSecret_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  clientSecret_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  clientSecret_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  clientSecret_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  clientSecret_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  clientSecret_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  clientSecret_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  clientSecret_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  clientSecret_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  clientSecret_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  clientSecret_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  clientSecret_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  clientSecret_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TenantOauthClientsRelationship = {
  __typename?: 'TenantOauthClientsRelationship';
  cursor: Scalars['String']['output'];
  node: OAuthClient;
};

export type TenantOauthClientsUpdateConnectionInput = {
  node?: InputMaybe<OAuthClientUpdateInput>;
};

export type TenantOauthClientsUpdateFieldInput = {
  connect?: InputMaybe<Array<TenantOauthClientsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TenantOauthClientsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TenantOauthClientsCreateFieldInput>>;
  delete?: InputMaybe<Array<TenantOauthClientsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TenantOauthClientsDisconnectFieldInput>>;
  update?: InputMaybe<TenantOauthClientsUpdateConnectionInput>;
  where?: InputMaybe<TenantOauthClientsConnectionWhere>;
};

export type TenantOnCreateInput = {
  additionalScope?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowFormSignup?: InputMaybe<Scalars['Boolean']['input']>;
  allowStripeDiscountCodes?: InputMaybe<Scalars['Boolean']['input']>;
  allowThirdPartyCredentials?: InputMaybe<Scalars['Boolean']['input']>;
  autoEnrollCourses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  axioSchools?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bugReportEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  companionName?: InputMaybe<Scalars['String']['input']>;
  companionWebSearchDomains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  customNews?: InputMaybe<Scalars['Boolean']['input']>;
  doRAG?: InputMaybe<Scalars['Boolean']['input']>;
  emailBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  emailFooterColor?: InputMaybe<Scalars['String']['input']>;
  emulationStatement?: InputMaybe<Scalars['String']['input']>;
  externalSendGridDailyEmailTemplateId?: InputMaybe<Scalars['String']['input']>;
  externalSendGridFromEmail?: InputMaybe<Scalars['String']['input']>;
  externalSendGridFromName?: InputMaybe<Scalars['String']['input']>;
  externalSendGridTwilioServiceSID?: InputMaybe<Scalars['String']['input']>;
  favicon16Url?: InputMaybe<Scalars['String']['input']>;
  favicon32Url?: InputMaybe<Scalars['String']['input']>;
  favicon48Url?: InputMaybe<Scalars['String']['input']>;
  favicon180Url?: InputMaybe<Scalars['String']['input']>;
  favicon192Url?: InputMaybe<Scalars['String']['input']>;
  favicon512Url?: InputMaybe<Scalars['String']['input']>;
  faviconIcoUrl?: InputMaybe<Scalars['String']['input']>;
  financialInformationUrl?: InputMaybe<Scalars['String']['input']>;
  gameMenuBg?: InputMaybe<Scalars['String']['input']>;
  gameMenuCardBg?: InputMaybe<Scalars['String']['input']>;
  gameMenuProgress?: InputMaybe<Scalars['String']['input']>;
  gameMenuTrack?: InputMaybe<Scalars['String']['input']>;
  generalPrompt?: InputMaybe<Scalars['String']['input']>;
  hasCourseEnrollment?: InputMaybe<Scalars['Boolean']['input']>;
  hasDegrees?: InputMaybe<Scalars['Boolean']['input']>;
  hasEmailVerification?: InputMaybe<Scalars['Boolean']['input']>;
  hasLearningTopicsInChat?: InputMaybe<Scalars['Boolean']['input']>;
  hasProFlow?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrial?: InputMaybe<Scalars['Boolean']['input']>;
  hasTurnBasedAssessments?: InputMaybe<Scalars['Boolean']['input']>;
  helpCenterUrl?: InputMaybe<Scalars['String']['input']>;
  isAxioOffering?: InputMaybe<Scalars['Boolean']['input']>;
  isCompanionMode?: InputMaybe<Scalars['Boolean']['input']>;
  isDailyEventEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isFreemium?: InputMaybe<Scalars['Boolean']['input']>;
  isLMS?: InputMaybe<Scalars['Boolean']['input']>;
  isLTI?: InputMaybe<Scalars['Boolean']['input']>;
  isSuggestedInsights?: InputMaybe<Scalars['Boolean']['input']>;
  isTeacherNotifiedOnEnrollment?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  learningEmulationStatement?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  ltiLaunchUrl?: InputMaybe<Scalars['String']['input']>;
  miniLogo?: InputMaybe<Scalars['String']['input']>;
  moderationHarassment?: InputMaybe<Scalars['Boolean']['input']>;
  moderationHarassmentThreatening?: InputMaybe<Scalars['Boolean']['input']>;
  moderationHate?: InputMaybe<Scalars['Boolean']['input']>;
  moderationHateThreatening?: InputMaybe<Scalars['Boolean']['input']>;
  moderationSelfHarm?: InputMaybe<Scalars['Boolean']['input']>;
  moderationSelfHarmInstructions?: InputMaybe<Scalars['Boolean']['input']>;
  moderationSelfHarmIntent?: InputMaybe<Scalars['Boolean']['input']>;
  moderationSexual?: InputMaybe<Scalars['Boolean']['input']>;
  moderationSexualMinors?: InputMaybe<Scalars['Boolean']['input']>;
  moderationViolence?: InputMaybe<Scalars['Boolean']['input']>;
  moderationViolenceGraphic?: InputMaybe<Scalars['Boolean']['input']>;
  newsSearchTerms?: InputMaybe<Scalars['String']['input']>;
  officialTranscriptsUrl?: InputMaybe<Scalars['String']['input']>;
  ogDescription?: InputMaybe<Scalars['String']['input']>;
  ogImage?: InputMaybe<Scalars['String']['input']>;
  ogImageHeight?: InputMaybe<Scalars['String']['input']>;
  ogImageWidth?: InputMaybe<Scalars['String']['input']>;
  ogSiteName?: InputMaybe<Scalars['String']['input']>;
  ogTitle?: InputMaybe<Scalars['String']['input']>;
  ogType?: InputMaybe<Scalars['String']['input']>;
  onboardingPrompt?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  proLogo?: InputMaybe<Scalars['String']['input']>;
  reportProblemUrl?: InputMaybe<Scalars['String']['input']>;
  requireSSO?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleAdvisorCallUrl?: InputMaybe<Scalars['String']['input']>;
  schoolResourcesUrl?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  showMiniLogo?: InputMaybe<Scalars['Boolean']['input']>;
  stripeSecretKey?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  stripeTrialDays?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink?: InputMaybe<Scalars['String']['input']>;
  tenantDomain: Scalars['String']['input'];
  tenantName: Scalars['String']['input'];
  termsOfServiceLink?: InputMaybe<Scalars['String']['input']>;
  upgradeModalBody?: InputMaybe<Scalars['String']['input']>;
};

export type TenantOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TenantSort objects to sort Tenants by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TenantSort>>;
};

export type TenantResponse = {
  __typename?: 'TenantResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<Tenant>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TenantSamlConfigAggregateInput = {
  AND?: InputMaybe<Array<TenantSamlConfigAggregateInput>>;
  NOT?: InputMaybe<TenantSamlConfigAggregateInput>;
  OR?: InputMaybe<Array<TenantSamlConfigAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TenantSamlConfigNodeAggregationWhereInput>;
};

export type TenantSamlConfigConnectFieldInput = {
  connect?: InputMaybe<SamlConfigConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SamlConfigConnectWhere>;
};

export type TenantSamlConfigConnectOrCreateFieldInput = {
  onCreate: TenantSamlConfigConnectOrCreateFieldInputOnCreate;
  where: SamlConfigConnectOrCreateWhere;
};

export type TenantSamlConfigConnectOrCreateFieldInputOnCreate = {
  node: SamlConfigOnCreateInput;
};

export type TenantSamlConfigConnection = {
  __typename?: 'TenantSamlConfigConnection';
  edges: Array<TenantSamlConfigRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TenantSamlConfigConnectionSort = {
  node?: InputMaybe<SamlConfigSort>;
};

export type TenantSamlConfigConnectionWhere = {
  AND?: InputMaybe<Array<TenantSamlConfigConnectionWhere>>;
  NOT?: InputMaybe<TenantSamlConfigConnectionWhere>;
  OR?: InputMaybe<Array<TenantSamlConfigConnectionWhere>>;
  node?: InputMaybe<SamlConfigWhere>;
};

export type TenantSamlConfigCreateFieldInput = {
  node: SamlConfigCreateInput;
};

export type TenantSamlConfigDeleteFieldInput = {
  delete?: InputMaybe<SamlConfigDeleteInput>;
  where?: InputMaybe<TenantSamlConfigConnectionWhere>;
};

export type TenantSamlConfigDisconnectFieldInput = {
  disconnect?: InputMaybe<SamlConfigDisconnectInput>;
  where?: InputMaybe<TenantSamlConfigConnectionWhere>;
};

export type TenantSamlConfigFieldInput = {
  connect?: InputMaybe<TenantSamlConfigConnectFieldInput>;
  connectOrCreate?: InputMaybe<TenantSamlConfigConnectOrCreateFieldInput>;
  create?: InputMaybe<TenantSamlConfigCreateFieldInput>;
};

export type TenantSamlConfigNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TenantSamlConfigNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TenantSamlConfigNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TenantSamlConfigNodeAggregationWhereInput>>;
  authnRequestBinding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  authnRequestBinding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  authnRequestBinding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  authnRequestBinding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  authnRequestBinding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  authnRequestBinding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  authnRequestBinding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  authnRequestBinding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  authnRequestBinding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  authnRequestBinding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  authnRequestBinding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  authnRequestBinding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  authnRequestBinding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  authnRequestBinding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  authnRequestBinding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  callbackUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  callbackUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  callbackUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  callbackUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  callbackUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  callbackUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callbackUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callbackUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callbackUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callbackUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  callbackUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  callbackUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  callbackUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  callbackUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  callbackUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  cert_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cert_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  cert_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  cert_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  cert_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  cert_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cert_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  cert_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  cert_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  cert_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  cert_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cert_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  cert_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  cert_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  cert_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  emailAttribute_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emailAttribute_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emailAttribute_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emailAttribute_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emailAttribute_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emailAttribute_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailAttribute_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailAttribute_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailAttribute_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailAttribute_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emailAttribute_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailAttribute_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailAttribute_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailAttribute_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailAttribute_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  entryPoint_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  entryPoint_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  entryPoint_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  entryPoint_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  entryPoint_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  entryPoint_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  entryPoint_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  entryPoint_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  entryPoint_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  entryPoint_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  entryPoint_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  entryPoint_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  entryPoint_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  entryPoint_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  entryPoint_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  expiry_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  expiry_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  expiry_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  expiry_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  expiry_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  expiry_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  expiry_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  expiry_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  expiry_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  expiry_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  expiry_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  expiry_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  expiry_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  expiry_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  expiry_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNameAttribute_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstNameAttribute_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstNameAttribute_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstNameAttribute_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstNameAttribute_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstNameAttribute_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNameAttribute_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNameAttribute_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNameAttribute_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNameAttribute_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstNameAttribute_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstNameAttribute_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstNameAttribute_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstNameAttribute_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstNameAttribute_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  issuer_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  issuer_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  issuer_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  issuer_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  issuer_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  issuer_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  issuer_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  issuer_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  issuer_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  issuer_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  issuer_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  issuer_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  issuer_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  issuer_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  issuer_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastNameAttribute_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastNameAttribute_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastNameAttribute_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastNameAttribute_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastNameAttribute_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastNameAttribute_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastNameAttribute_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastNameAttribute_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastNameAttribute_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastNameAttribute_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastNameAttribute_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastNameAttribute_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastNameAttribute_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastNameAttribute_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastNameAttribute_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signatureAlgorithm_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signatureAlgorithm_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signatureAlgorithm_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signatureAlgorithm_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signatureAlgorithm_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signatureAlgorithm_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signatureAlgorithm_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signatureAlgorithm_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signatureAlgorithm_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signatureAlgorithm_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signatureAlgorithm_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signatureAlgorithm_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signatureAlgorithm_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signatureAlgorithm_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signatureAlgorithm_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TenantSamlConfigRelationship = {
  __typename?: 'TenantSamlConfigRelationship';
  cursor: Scalars['String']['output'];
  node: SamlConfig;
};

export type TenantSamlConfigSamlConfigAggregationSelection = {
  __typename?: 'TenantSamlConfigSamlConfigAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TenantSamlConfigSamlConfigNodeAggregateSelection>;
};

export type TenantSamlConfigSamlConfigNodeAggregateSelection = {
  __typename?: 'TenantSamlConfigSamlConfigNodeAggregateSelection';
  authnRequestBinding: StringAggregateSelection;
  callbackUrl: StringAggregateSelection;
  cert: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  emailAttribute: StringAggregateSelection;
  entryPoint: StringAggregateSelection;
  expiry: StringAggregateSelection;
  firstNameAttribute: StringAggregateSelection;
  id: IdAggregateSelection;
  issuer: StringAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  lastNameAttribute: StringAggregateSelection;
  signatureAlgorithm: StringAggregateSelection;
};

export type TenantSamlConfigUpdateConnectionInput = {
  node?: InputMaybe<SamlConfigUpdateInput>;
};

export type TenantSamlConfigUpdateFieldInput = {
  connect?: InputMaybe<TenantSamlConfigConnectFieldInput>;
  connectOrCreate?: InputMaybe<TenantSamlConfigConnectOrCreateFieldInput>;
  create?: InputMaybe<TenantSamlConfigCreateFieldInput>;
  delete?: InputMaybe<TenantSamlConfigDeleteFieldInput>;
  disconnect?: InputMaybe<TenantSamlConfigDisconnectFieldInput>;
  update?: InputMaybe<TenantSamlConfigUpdateConnectionInput>;
  where?: InputMaybe<TenantSamlConfigConnectionWhere>;
};

export type TenantSchemaResponse = {
  __typename?: 'TenantSchemaResponse';
  data?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TenantSettingsInput = {
  financialInformationUrl?: InputMaybe<Scalars['String']['input']>;
  helpCenterUrl?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  officialTranscriptsUrl?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  schoolResourcesUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Fields to sort Tenants by. The order in which sorts are applied is not guaranteed when specifying many fields in one TenantSort object. */
export type TenantSort = {
  allowFormSignup?: InputMaybe<SortDirection>;
  allowStripeDiscountCodes?: InputMaybe<SortDirection>;
  allowThirdPartyCredentials?: InputMaybe<SortDirection>;
  companionName?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  customNews?: InputMaybe<SortDirection>;
  doRAG?: InputMaybe<SortDirection>;
  emailBackgroundColor?: InputMaybe<SortDirection>;
  emailFooterColor?: InputMaybe<SortDirection>;
  emulationStatement?: InputMaybe<SortDirection>;
  externalSendGridDailyEmailTemplateId?: InputMaybe<SortDirection>;
  externalSendGridFromEmail?: InputMaybe<SortDirection>;
  externalSendGridFromName?: InputMaybe<SortDirection>;
  externalSendGridTwilioServiceSID?: InputMaybe<SortDirection>;
  favicon16Url?: InputMaybe<SortDirection>;
  favicon32Url?: InputMaybe<SortDirection>;
  favicon48Url?: InputMaybe<SortDirection>;
  favicon180Url?: InputMaybe<SortDirection>;
  favicon192Url?: InputMaybe<SortDirection>;
  favicon512Url?: InputMaybe<SortDirection>;
  faviconIcoUrl?: InputMaybe<SortDirection>;
  financialInformationUrl?: InputMaybe<SortDirection>;
  gameMenuBg?: InputMaybe<SortDirection>;
  gameMenuCardBg?: InputMaybe<SortDirection>;
  gameMenuProgress?: InputMaybe<SortDirection>;
  gameMenuTrack?: InputMaybe<SortDirection>;
  generalPrompt?: InputMaybe<SortDirection>;
  hasCourseEnrollment?: InputMaybe<SortDirection>;
  hasDegrees?: InputMaybe<SortDirection>;
  hasEmailVerification?: InputMaybe<SortDirection>;
  hasLearningTopicsInChat?: InputMaybe<SortDirection>;
  hasProFlow?: InputMaybe<SortDirection>;
  hasTrial?: InputMaybe<SortDirection>;
  hasTurnBasedAssessments?: InputMaybe<SortDirection>;
  helpCenterUrl?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isAxioOffering?: InputMaybe<SortDirection>;
  isCompanionMode?: InputMaybe<SortDirection>;
  isDailyEventEnabled?: InputMaybe<SortDirection>;
  isFreemium?: InputMaybe<SortDirection>;
  isLMS?: InputMaybe<SortDirection>;
  isLTI?: InputMaybe<SortDirection>;
  isSuggestedInsights?: InputMaybe<SortDirection>;
  isTeacherNotifiedOnEnrollment?: InputMaybe<SortDirection>;
  key?: InputMaybe<SortDirection>;
  last_modified?: InputMaybe<SortDirection>;
  learningEmulationStatement?: InputMaybe<SortDirection>;
  logo?: InputMaybe<SortDirection>;
  ltiLaunchUrl?: InputMaybe<SortDirection>;
  miniLogo?: InputMaybe<SortDirection>;
  moderationHarassment?: InputMaybe<SortDirection>;
  moderationHarassmentThreatening?: InputMaybe<SortDirection>;
  moderationHate?: InputMaybe<SortDirection>;
  moderationHateThreatening?: InputMaybe<SortDirection>;
  moderationSelfHarm?: InputMaybe<SortDirection>;
  moderationSelfHarmInstructions?: InputMaybe<SortDirection>;
  moderationSelfHarmIntent?: InputMaybe<SortDirection>;
  moderationSexual?: InputMaybe<SortDirection>;
  moderationSexualMinors?: InputMaybe<SortDirection>;
  moderationViolence?: InputMaybe<SortDirection>;
  moderationViolenceGraphic?: InputMaybe<SortDirection>;
  newsSearchTerms?: InputMaybe<SortDirection>;
  officialTranscriptsUrl?: InputMaybe<SortDirection>;
  ogDescription?: InputMaybe<SortDirection>;
  ogImage?: InputMaybe<SortDirection>;
  ogImageHeight?: InputMaybe<SortDirection>;
  ogImageWidth?: InputMaybe<SortDirection>;
  ogSiteName?: InputMaybe<SortDirection>;
  ogTitle?: InputMaybe<SortDirection>;
  ogType?: InputMaybe<SortDirection>;
  onboardingPrompt?: InputMaybe<SortDirection>;
  primaryColor?: InputMaybe<SortDirection>;
  proLogo?: InputMaybe<SortDirection>;
  reportProblemUrl?: InputMaybe<SortDirection>;
  requireSSO?: InputMaybe<SortDirection>;
  scheduleAdvisorCallUrl?: InputMaybe<SortDirection>;
  schoolResourcesUrl?: InputMaybe<SortDirection>;
  showFeedback?: InputMaybe<SortDirection>;
  showMiniLogo?: InputMaybe<SortDirection>;
  stripeSecretKey?: InputMaybe<SortDirection>;
  stripeSubscriptionId?: InputMaybe<SortDirection>;
  stripeTrialDays?: InputMaybe<SortDirection>;
  submitHelpTicketLink?: InputMaybe<SortDirection>;
  tenantDomain?: InputMaybe<SortDirection>;
  tenantName?: InputMaybe<SortDirection>;
  termsOfServiceLink?: InputMaybe<SortDirection>;
  upgradeModalBody?: InputMaybe<SortDirection>;
};

export type TenantSubmitHelpTicketLinkResponse = {
  __typename?: 'TenantSubmitHelpTicketLinkResponse';
  data?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TenantUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
  tenantDomain?: InputMaybe<Scalars['String']['input']>;
  tenantName?: InputMaybe<Scalars['String']['input']>;
};

export type TenantUpdateInput = {
  additionalScope?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  additionalScope_POP?: InputMaybe<Scalars['Int']['input']>;
  additionalScope_PUSH?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  allowFormSignup?: InputMaybe<Scalars['Boolean']['input']>;
  allowStripeDiscountCodes?: InputMaybe<Scalars['Boolean']['input']>;
  allowThirdPartyCredentials?: InputMaybe<Scalars['Boolean']['input']>;
  auditEvents?: InputMaybe<Array<TenantAuditEventsUpdateFieldInput>>;
  autoEnrollCourses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  autoEnrollCourses_POP?: InputMaybe<Scalars['Int']['input']>;
  autoEnrollCourses_PUSH?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  axioSchools?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  axioSchools_POP?: InputMaybe<Scalars['Int']['input']>;
  axioSchools_PUSH?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bugReportEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  bugReportEmails_POP?: InputMaybe<Scalars['Int']['input']>;
  bugReportEmails_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  companionName?: InputMaybe<Scalars['String']['input']>;
  companionWebSearchDomains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companionWebSearchDomains_POP?: InputMaybe<Scalars['Int']['input']>;
  companionWebSearchDomains_PUSH?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  customNews?: InputMaybe<Scalars['Boolean']['input']>;
  doRAG?: InputMaybe<Scalars['Boolean']['input']>;
  documentReferences?: InputMaybe<Array<TenantDocumentReferencesUpdateFieldInput>>;
  documents?: InputMaybe<Array<TenantDocumentsUpdateFieldInput>>;
  emailBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  emailFooterColor?: InputMaybe<Scalars['String']['input']>;
  emulationStatement?: InputMaybe<Scalars['String']['input']>;
  externalIntegrations?: InputMaybe<Array<TenantExternalIntegrationsUpdateFieldInput>>;
  externalSendGridDailyEmailTemplateId?: InputMaybe<Scalars['String']['input']>;
  externalSendGridFromEmail?: InputMaybe<Scalars['String']['input']>;
  externalSendGridFromName?: InputMaybe<Scalars['String']['input']>;
  externalSendGridTwilioServiceSID?: InputMaybe<Scalars['String']['input']>;
  favicon16Url?: InputMaybe<Scalars['String']['input']>;
  favicon32Url?: InputMaybe<Scalars['String']['input']>;
  favicon48Url?: InputMaybe<Scalars['String']['input']>;
  favicon180Url?: InputMaybe<Scalars['String']['input']>;
  favicon192Url?: InputMaybe<Scalars['String']['input']>;
  favicon512Url?: InputMaybe<Scalars['String']['input']>;
  faviconIcoUrl?: InputMaybe<Scalars['String']['input']>;
  financialInformationUrl?: InputMaybe<Scalars['String']['input']>;
  gameMenuBg?: InputMaybe<Scalars['String']['input']>;
  gameMenuCardBg?: InputMaybe<Scalars['String']['input']>;
  gameMenuProgress?: InputMaybe<Scalars['String']['input']>;
  gameMenuTrack?: InputMaybe<Scalars['String']['input']>;
  generalPrompt?: InputMaybe<Scalars['String']['input']>;
  hasCourseEnrollment?: InputMaybe<Scalars['Boolean']['input']>;
  hasDegrees?: InputMaybe<Scalars['Boolean']['input']>;
  hasEmailVerification?: InputMaybe<Scalars['Boolean']['input']>;
  hasLearningTopicsInChat?: InputMaybe<Scalars['Boolean']['input']>;
  hasProFlow?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrial?: InputMaybe<Scalars['Boolean']['input']>;
  hasTurnBasedAssessments?: InputMaybe<Scalars['Boolean']['input']>;
  helpCenterUrl?: InputMaybe<Scalars['String']['input']>;
  isAxioOffering?: InputMaybe<Scalars['Boolean']['input']>;
  isCompanionMode?: InputMaybe<Scalars['Boolean']['input']>;
  isDailyEventEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isFreemium?: InputMaybe<Scalars['Boolean']['input']>;
  isLMS?: InputMaybe<Scalars['Boolean']['input']>;
  isLTI?: InputMaybe<Scalars['Boolean']['input']>;
  isSuggestedInsights?: InputMaybe<Scalars['Boolean']['input']>;
  isTeacherNotifiedOnEnrollment?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  learningEmulationStatement?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  ltiLaunchUrl?: InputMaybe<Scalars['String']['input']>;
  miniLogo?: InputMaybe<Scalars['String']['input']>;
  moderationHarassment?: InputMaybe<Scalars['Boolean']['input']>;
  moderationHarassmentThreatening?: InputMaybe<Scalars['Boolean']['input']>;
  moderationHate?: InputMaybe<Scalars['Boolean']['input']>;
  moderationHateThreatening?: InputMaybe<Scalars['Boolean']['input']>;
  moderationSelfHarm?: InputMaybe<Scalars['Boolean']['input']>;
  moderationSelfHarmInstructions?: InputMaybe<Scalars['Boolean']['input']>;
  moderationSelfHarmIntent?: InputMaybe<Scalars['Boolean']['input']>;
  moderationSexual?: InputMaybe<Scalars['Boolean']['input']>;
  moderationSexualMinors?: InputMaybe<Scalars['Boolean']['input']>;
  moderationViolence?: InputMaybe<Scalars['Boolean']['input']>;
  moderationViolenceGraphic?: InputMaybe<Scalars['Boolean']['input']>;
  newsSearchTerms?: InputMaybe<Scalars['String']['input']>;
  nudgeTypeConfigs?: InputMaybe<Array<TenantNudgeTypeConfigsUpdateFieldInput>>;
  oauthClients?: InputMaybe<Array<TenantOauthClientsUpdateFieldInput>>;
  officialTranscriptsUrl?: InputMaybe<Scalars['String']['input']>;
  ogDescription?: InputMaybe<Scalars['String']['input']>;
  ogImage?: InputMaybe<Scalars['String']['input']>;
  ogImageHeight?: InputMaybe<Scalars['String']['input']>;
  ogImageWidth?: InputMaybe<Scalars['String']['input']>;
  ogSiteName?: InputMaybe<Scalars['String']['input']>;
  ogTitle?: InputMaybe<Scalars['String']['input']>;
  ogType?: InputMaybe<Scalars['String']['input']>;
  onboardingPrompt?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  proLogo?: InputMaybe<Scalars['String']['input']>;
  reportProblemUrl?: InputMaybe<Scalars['String']['input']>;
  requireSSO?: InputMaybe<Scalars['Boolean']['input']>;
  samlConfig?: InputMaybe<TenantSamlConfigUpdateFieldInput>;
  scheduleAdvisorCallUrl?: InputMaybe<Scalars['String']['input']>;
  schoolResourcesUrl?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scope_POP?: InputMaybe<Scalars['Int']['input']>;
  scope_PUSH?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  showMiniLogo?: InputMaybe<Scalars['Boolean']['input']>;
  stripeSecretKey?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  stripeTrialDays?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink?: InputMaybe<Scalars['String']['input']>;
  tenantDomain?: InputMaybe<Scalars['String']['input']>;
  tenantName?: InputMaybe<Scalars['String']['input']>;
  termsOfServiceLink?: InputMaybe<Scalars['String']['input']>;
  upgradeModalBody?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<TenantUsersUpdateFieldInput>>;
  webhook?: InputMaybe<TenantWebhookUpdateFieldInput>;
};

export type TenantUserUsersAggregationSelection = {
  __typename?: 'TenantUserUsersAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TenantUserUsersNodeAggregateSelection>;
};

export type TenantUserUsersNodeAggregateSelection = {
  __typename?: 'TenantUserUsersNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type TenantUsersAggregateInput = {
  AND?: InputMaybe<Array<TenantUsersAggregateInput>>;
  NOT?: InputMaybe<TenantUsersAggregateInput>;
  OR?: InputMaybe<Array<TenantUsersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TenantUsersNodeAggregationWhereInput>;
};

export type TenantUsersConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type TenantUsersConnectOrCreateFieldInput = {
  onCreate: TenantUsersConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type TenantUsersConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type TenantUsersConnection = {
  __typename?: 'TenantUsersConnection';
  edges: Array<TenantUsersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TenantUsersConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type TenantUsersConnectionWhere = {
  AND?: InputMaybe<Array<TenantUsersConnectionWhere>>;
  NOT?: InputMaybe<TenantUsersConnectionWhere>;
  OR?: InputMaybe<Array<TenantUsersConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type TenantUsersCreateFieldInput = {
  node: UserCreateInput;
};

export type TenantUsersDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<TenantUsersConnectionWhere>;
};

export type TenantUsersDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<TenantUsersConnectionWhere>;
};

export type TenantUsersFieldInput = {
  connect?: InputMaybe<Array<TenantUsersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TenantUsersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TenantUsersCreateFieldInput>>;
};

export type TenantUsersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TenantUsersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TenantUsersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TenantUsersNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TenantUsersRelationship = {
  __typename?: 'TenantUsersRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type TenantUsersUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type TenantUsersUpdateFieldInput = {
  connect?: InputMaybe<Array<TenantUsersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TenantUsersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TenantUsersCreateFieldInput>>;
  delete?: InputMaybe<Array<TenantUsersDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TenantUsersDisconnectFieldInput>>;
  update?: InputMaybe<TenantUsersUpdateConnectionInput>;
  where?: InputMaybe<TenantUsersConnectionWhere>;
};

export type TenantWebhookAggregateInput = {
  AND?: InputMaybe<Array<TenantWebhookAggregateInput>>;
  NOT?: InputMaybe<TenantWebhookAggregateInput>;
  OR?: InputMaybe<Array<TenantWebhookAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TenantWebhookNodeAggregationWhereInput>;
};

export type TenantWebhookConnectFieldInput = {
  connect?: InputMaybe<WebhookConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<WebhookConnectWhere>;
};

export type TenantWebhookConnectOrCreateFieldInput = {
  onCreate: TenantWebhookConnectOrCreateFieldInputOnCreate;
  where: WebhookConnectOrCreateWhere;
};

export type TenantWebhookConnectOrCreateFieldInputOnCreate = {
  node: WebhookOnCreateInput;
};

export type TenantWebhookConnection = {
  __typename?: 'TenantWebhookConnection';
  edges: Array<TenantWebhookRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TenantWebhookConnectionSort = {
  node?: InputMaybe<WebhookSort>;
};

export type TenantWebhookConnectionWhere = {
  AND?: InputMaybe<Array<TenantWebhookConnectionWhere>>;
  NOT?: InputMaybe<TenantWebhookConnectionWhere>;
  OR?: InputMaybe<Array<TenantWebhookConnectionWhere>>;
  node?: InputMaybe<WebhookWhere>;
};

export type TenantWebhookCreateFieldInput = {
  node: WebhookCreateInput;
};

export type TenantWebhookDeleteFieldInput = {
  delete?: InputMaybe<WebhookDeleteInput>;
  where?: InputMaybe<TenantWebhookConnectionWhere>;
};

export type TenantWebhookDisconnectFieldInput = {
  disconnect?: InputMaybe<WebhookDisconnectInput>;
  where?: InputMaybe<TenantWebhookConnectionWhere>;
};

export type TenantWebhookFieldInput = {
  connect?: InputMaybe<TenantWebhookConnectFieldInput>;
  connectOrCreate?: InputMaybe<TenantWebhookConnectOrCreateFieldInput>;
  create?: InputMaybe<TenantWebhookCreateFieldInput>;
};

export type TenantWebhookNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TenantWebhookNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TenantWebhookNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TenantWebhookNodeAggregationWhereInput>>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TenantWebhookRelationship = {
  __typename?: 'TenantWebhookRelationship';
  cursor: Scalars['String']['output'];
  node: Webhook;
};

export type TenantWebhookUpdateConnectionInput = {
  node?: InputMaybe<WebhookUpdateInput>;
};

export type TenantWebhookUpdateFieldInput = {
  connect?: InputMaybe<TenantWebhookConnectFieldInput>;
  connectOrCreate?: InputMaybe<TenantWebhookConnectOrCreateFieldInput>;
  create?: InputMaybe<TenantWebhookCreateFieldInput>;
  delete?: InputMaybe<TenantWebhookDeleteFieldInput>;
  disconnect?: InputMaybe<TenantWebhookDisconnectFieldInput>;
  update?: InputMaybe<TenantWebhookUpdateConnectionInput>;
  where?: InputMaybe<TenantWebhookConnectionWhere>;
};

export type TenantWebhookWebhookAggregationSelection = {
  __typename?: 'TenantWebhookWebhookAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TenantWebhookWebhookNodeAggregateSelection>;
};

export type TenantWebhookWebhookNodeAggregateSelection = {
  __typename?: 'TenantWebhookWebhookNodeAggregateSelection';
  id: IdAggregateSelection;
  url: StringAggregateSelection;
};

export type TenantWhere = {
  AND?: InputMaybe<Array<TenantWhere>>;
  NOT?: InputMaybe<TenantWhere>;
  OR?: InputMaybe<Array<TenantWhere>>;
  additionalScope?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  additionalScope_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  allowFormSignup?: InputMaybe<Scalars['Boolean']['input']>;
  allowStripeDiscountCodes?: InputMaybe<Scalars['Boolean']['input']>;
  allowThirdPartyCredentials?: InputMaybe<Scalars['Boolean']['input']>;
  auditEventsAggregate?: InputMaybe<TenantAuditEventsAggregateInput>;
  /** Return Tenants where all of the related TenantAuditEventsConnections match this filter */
  auditEventsConnection_ALL?: InputMaybe<TenantAuditEventsConnectionWhere>;
  /** Return Tenants where none of the related TenantAuditEventsConnections match this filter */
  auditEventsConnection_NONE?: InputMaybe<TenantAuditEventsConnectionWhere>;
  /** Return Tenants where one of the related TenantAuditEventsConnections match this filter */
  auditEventsConnection_SINGLE?: InputMaybe<TenantAuditEventsConnectionWhere>;
  /** Return Tenants where some of the related TenantAuditEventsConnections match this filter */
  auditEventsConnection_SOME?: InputMaybe<TenantAuditEventsConnectionWhere>;
  /** Return Tenants where all of the related AuditEvents match this filter */
  auditEvents_ALL?: InputMaybe<AuditEventWhere>;
  /** Return Tenants where none of the related AuditEvents match this filter */
  auditEvents_NONE?: InputMaybe<AuditEventWhere>;
  /** Return Tenants where one of the related AuditEvents match this filter */
  auditEvents_SINGLE?: InputMaybe<AuditEventWhere>;
  /** Return Tenants where some of the related AuditEvents match this filter */
  auditEvents_SOME?: InputMaybe<AuditEventWhere>;
  autoEnrollCourses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  autoEnrollCourses_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  axioSchools?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  axioSchools_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  bugReportEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  bugReportEmails_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  companionName?: InputMaybe<Scalars['String']['input']>;
  companionName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  companionName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  companionName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companionName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  companionWebSearchDomains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companionWebSearchDomains_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  customNews?: InputMaybe<Scalars['Boolean']['input']>;
  doRAG?: InputMaybe<Scalars['Boolean']['input']>;
  documentReferencesAggregate?: InputMaybe<TenantDocumentReferencesAggregateInput>;
  /** Return Tenants where all of the related TenantDocumentReferencesConnections match this filter */
  documentReferencesConnection_ALL?: InputMaybe<TenantDocumentReferencesConnectionWhere>;
  /** Return Tenants where none of the related TenantDocumentReferencesConnections match this filter */
  documentReferencesConnection_NONE?: InputMaybe<TenantDocumentReferencesConnectionWhere>;
  /** Return Tenants where one of the related TenantDocumentReferencesConnections match this filter */
  documentReferencesConnection_SINGLE?: InputMaybe<TenantDocumentReferencesConnectionWhere>;
  /** Return Tenants where some of the related TenantDocumentReferencesConnections match this filter */
  documentReferencesConnection_SOME?: InputMaybe<TenantDocumentReferencesConnectionWhere>;
  /** Return Tenants where all of the related DocumentReferences match this filter */
  documentReferences_ALL?: InputMaybe<DocumentReferenceWhere>;
  /** Return Tenants where none of the related DocumentReferences match this filter */
  documentReferences_NONE?: InputMaybe<DocumentReferenceWhere>;
  /** Return Tenants where one of the related DocumentReferences match this filter */
  documentReferences_SINGLE?: InputMaybe<DocumentReferenceWhere>;
  /** Return Tenants where some of the related DocumentReferences match this filter */
  documentReferences_SOME?: InputMaybe<DocumentReferenceWhere>;
  documentsAggregate?: InputMaybe<TenantDocumentsAggregateInput>;
  /** Return Tenants where all of the related TenantDocumentsConnections match this filter */
  documentsConnection_ALL?: InputMaybe<TenantDocumentsConnectionWhere>;
  /** Return Tenants where none of the related TenantDocumentsConnections match this filter */
  documentsConnection_NONE?: InputMaybe<TenantDocumentsConnectionWhere>;
  /** Return Tenants where one of the related TenantDocumentsConnections match this filter */
  documentsConnection_SINGLE?: InputMaybe<TenantDocumentsConnectionWhere>;
  /** Return Tenants where some of the related TenantDocumentsConnections match this filter */
  documentsConnection_SOME?: InputMaybe<TenantDocumentsConnectionWhere>;
  /** Return Tenants where all of the related Documents match this filter */
  documents_ALL?: InputMaybe<DocumentWhere>;
  /** Return Tenants where none of the related Documents match this filter */
  documents_NONE?: InputMaybe<DocumentWhere>;
  /** Return Tenants where one of the related Documents match this filter */
  documents_SINGLE?: InputMaybe<DocumentWhere>;
  /** Return Tenants where some of the related Documents match this filter */
  documents_SOME?: InputMaybe<DocumentWhere>;
  emailBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  emailBackgroundColor_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  emailBackgroundColor_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  emailBackgroundColor_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  emailBackgroundColor_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  emailFooterColor?: InputMaybe<Scalars['String']['input']>;
  emailFooterColor_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  emailFooterColor_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  emailFooterColor_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  emailFooterColor_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  emulationStatement?: InputMaybe<Scalars['String']['input']>;
  emulationStatement_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  emulationStatement_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  emulationStatement_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  emulationStatement_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  externalIntegrationsAggregate?: InputMaybe<TenantExternalIntegrationsAggregateInput>;
  /** Return Tenants where all of the related TenantExternalIntegrationsConnections match this filter */
  externalIntegrationsConnection_ALL?: InputMaybe<TenantExternalIntegrationsConnectionWhere>;
  /** Return Tenants where none of the related TenantExternalIntegrationsConnections match this filter */
  externalIntegrationsConnection_NONE?: InputMaybe<TenantExternalIntegrationsConnectionWhere>;
  /** Return Tenants where one of the related TenantExternalIntegrationsConnections match this filter */
  externalIntegrationsConnection_SINGLE?: InputMaybe<TenantExternalIntegrationsConnectionWhere>;
  /** Return Tenants where some of the related TenantExternalIntegrationsConnections match this filter */
  externalIntegrationsConnection_SOME?: InputMaybe<TenantExternalIntegrationsConnectionWhere>;
  /** Return Tenants where all of the related ExternalIntegrations match this filter */
  externalIntegrations_ALL?: InputMaybe<ExternalIntegrationWhere>;
  /** Return Tenants where none of the related ExternalIntegrations match this filter */
  externalIntegrations_NONE?: InputMaybe<ExternalIntegrationWhere>;
  /** Return Tenants where one of the related ExternalIntegrations match this filter */
  externalIntegrations_SINGLE?: InputMaybe<ExternalIntegrationWhere>;
  /** Return Tenants where some of the related ExternalIntegrations match this filter */
  externalIntegrations_SOME?: InputMaybe<ExternalIntegrationWhere>;
  externalSendGridDailyEmailTemplateId?: InputMaybe<Scalars['String']['input']>;
  externalSendGridDailyEmailTemplateId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  externalSendGridDailyEmailTemplateId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  externalSendGridDailyEmailTemplateId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalSendGridDailyEmailTemplateId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  externalSendGridFromEmail?: InputMaybe<Scalars['String']['input']>;
  externalSendGridFromEmail_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  externalSendGridFromEmail_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  externalSendGridFromEmail_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalSendGridFromEmail_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  externalSendGridFromName?: InputMaybe<Scalars['String']['input']>;
  externalSendGridFromName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  externalSendGridFromName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  externalSendGridFromName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalSendGridFromName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  externalSendGridTwilioServiceSID?: InputMaybe<Scalars['String']['input']>;
  externalSendGridTwilioServiceSID_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  externalSendGridTwilioServiceSID_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  externalSendGridTwilioServiceSID_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalSendGridTwilioServiceSID_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  favicon16Url?: InputMaybe<Scalars['String']['input']>;
  favicon16Url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  favicon16Url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  favicon16Url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  favicon16Url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  favicon32Url?: InputMaybe<Scalars['String']['input']>;
  favicon32Url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  favicon32Url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  favicon32Url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  favicon32Url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  favicon48Url?: InputMaybe<Scalars['String']['input']>;
  favicon48Url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  favicon48Url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  favicon48Url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  favicon48Url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  favicon180Url?: InputMaybe<Scalars['String']['input']>;
  favicon180Url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  favicon180Url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  favicon180Url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  favicon180Url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  favicon192Url?: InputMaybe<Scalars['String']['input']>;
  favicon192Url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  favicon192Url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  favicon192Url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  favicon192Url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  favicon512Url?: InputMaybe<Scalars['String']['input']>;
  favicon512Url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  favicon512Url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  favicon512Url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  favicon512Url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  faviconIcoUrl?: InputMaybe<Scalars['String']['input']>;
  faviconIcoUrl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  faviconIcoUrl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  faviconIcoUrl_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faviconIcoUrl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  financialInformationUrl?: InputMaybe<Scalars['String']['input']>;
  financialInformationUrl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  financialInformationUrl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  financialInformationUrl_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  financialInformationUrl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  gameMenuBg?: InputMaybe<Scalars['String']['input']>;
  gameMenuBg_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  gameMenuBg_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  gameMenuBg_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  gameMenuBg_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  gameMenuCardBg?: InputMaybe<Scalars['String']['input']>;
  gameMenuCardBg_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  gameMenuCardBg_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  gameMenuCardBg_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  gameMenuCardBg_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  gameMenuProgress?: InputMaybe<Scalars['String']['input']>;
  gameMenuProgress_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  gameMenuProgress_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  gameMenuProgress_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  gameMenuProgress_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  gameMenuTrack?: InputMaybe<Scalars['String']['input']>;
  gameMenuTrack_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  gameMenuTrack_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  gameMenuTrack_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  gameMenuTrack_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  generalPrompt?: InputMaybe<Scalars['String']['input']>;
  generalPrompt_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  generalPrompt_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  generalPrompt_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  generalPrompt_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  hasCourseEnrollment?: InputMaybe<Scalars['Boolean']['input']>;
  hasDegrees?: InputMaybe<Scalars['Boolean']['input']>;
  hasEmailVerification?: InputMaybe<Scalars['Boolean']['input']>;
  hasLearningTopicsInChat?: InputMaybe<Scalars['Boolean']['input']>;
  hasProFlow?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrial?: InputMaybe<Scalars['Boolean']['input']>;
  hasTurnBasedAssessments?: InputMaybe<Scalars['Boolean']['input']>;
  helpCenterUrl?: InputMaybe<Scalars['String']['input']>;
  helpCenterUrl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  helpCenterUrl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  helpCenterUrl_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  helpCenterUrl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isAxioOffering?: InputMaybe<Scalars['Boolean']['input']>;
  isCompanionMode?: InputMaybe<Scalars['Boolean']['input']>;
  isDailyEventEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isFreemium?: InputMaybe<Scalars['Boolean']['input']>;
  isLMS?: InputMaybe<Scalars['Boolean']['input']>;
  isLTI?: InputMaybe<Scalars['Boolean']['input']>;
  isSuggestedInsights?: InputMaybe<Scalars['Boolean']['input']>;
  isTeacherNotifiedOnEnrollment?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  key_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  key_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  key_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  key_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  last_modified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningEmulationStatement?: InputMaybe<Scalars['String']['input']>;
  learningEmulationStatement_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  learningEmulationStatement_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  learningEmulationStatement_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  learningEmulationStatement_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  logo_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  logo_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  logo_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logo_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ltiLaunchUrl?: InputMaybe<Scalars['String']['input']>;
  ltiLaunchUrl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  ltiLaunchUrl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  ltiLaunchUrl_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ltiLaunchUrl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  miniLogo?: InputMaybe<Scalars['String']['input']>;
  miniLogo_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  miniLogo_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  miniLogo_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  miniLogo_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  moderationHarassment?: InputMaybe<Scalars['Boolean']['input']>;
  moderationHarassmentThreatening?: InputMaybe<Scalars['Boolean']['input']>;
  moderationHate?: InputMaybe<Scalars['Boolean']['input']>;
  moderationHateThreatening?: InputMaybe<Scalars['Boolean']['input']>;
  moderationSelfHarm?: InputMaybe<Scalars['Boolean']['input']>;
  moderationSelfHarmInstructions?: InputMaybe<Scalars['Boolean']['input']>;
  moderationSelfHarmIntent?: InputMaybe<Scalars['Boolean']['input']>;
  moderationSexual?: InputMaybe<Scalars['Boolean']['input']>;
  moderationSexualMinors?: InputMaybe<Scalars['Boolean']['input']>;
  moderationViolence?: InputMaybe<Scalars['Boolean']['input']>;
  moderationViolenceGraphic?: InputMaybe<Scalars['Boolean']['input']>;
  newsSearchTerms?: InputMaybe<Scalars['String']['input']>;
  newsSearchTerms_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  newsSearchTerms_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  newsSearchTerms_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  newsSearchTerms_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  nudgeTypeConfigsAggregate?: InputMaybe<TenantNudgeTypeConfigsAggregateInput>;
  /** Return Tenants where all of the related TenantNudgeTypeConfigsConnections match this filter */
  nudgeTypeConfigsConnection_ALL?: InputMaybe<TenantNudgeTypeConfigsConnectionWhere>;
  /** Return Tenants where none of the related TenantNudgeTypeConfigsConnections match this filter */
  nudgeTypeConfigsConnection_NONE?: InputMaybe<TenantNudgeTypeConfigsConnectionWhere>;
  /** Return Tenants where one of the related TenantNudgeTypeConfigsConnections match this filter */
  nudgeTypeConfigsConnection_SINGLE?: InputMaybe<TenantNudgeTypeConfigsConnectionWhere>;
  /** Return Tenants where some of the related TenantNudgeTypeConfigsConnections match this filter */
  nudgeTypeConfigsConnection_SOME?: InputMaybe<TenantNudgeTypeConfigsConnectionWhere>;
  /** Return Tenants where all of the related NudgeTypeConfigs match this filter */
  nudgeTypeConfigs_ALL?: InputMaybe<NudgeTypeConfigWhere>;
  /** Return Tenants where none of the related NudgeTypeConfigs match this filter */
  nudgeTypeConfigs_NONE?: InputMaybe<NudgeTypeConfigWhere>;
  /** Return Tenants where one of the related NudgeTypeConfigs match this filter */
  nudgeTypeConfigs_SINGLE?: InputMaybe<NudgeTypeConfigWhere>;
  /** Return Tenants where some of the related NudgeTypeConfigs match this filter */
  nudgeTypeConfigs_SOME?: InputMaybe<NudgeTypeConfigWhere>;
  oauthClientsAggregate?: InputMaybe<TenantOauthClientsAggregateInput>;
  /** Return Tenants where all of the related TenantOauthClientsConnections match this filter */
  oauthClientsConnection_ALL?: InputMaybe<TenantOauthClientsConnectionWhere>;
  /** Return Tenants where none of the related TenantOauthClientsConnections match this filter */
  oauthClientsConnection_NONE?: InputMaybe<TenantOauthClientsConnectionWhere>;
  /** Return Tenants where one of the related TenantOauthClientsConnections match this filter */
  oauthClientsConnection_SINGLE?: InputMaybe<TenantOauthClientsConnectionWhere>;
  /** Return Tenants where some of the related TenantOauthClientsConnections match this filter */
  oauthClientsConnection_SOME?: InputMaybe<TenantOauthClientsConnectionWhere>;
  /** Return Tenants where all of the related OAuthClients match this filter */
  oauthClients_ALL?: InputMaybe<OAuthClientWhere>;
  /** Return Tenants where none of the related OAuthClients match this filter */
  oauthClients_NONE?: InputMaybe<OAuthClientWhere>;
  /** Return Tenants where one of the related OAuthClients match this filter */
  oauthClients_SINGLE?: InputMaybe<OAuthClientWhere>;
  /** Return Tenants where some of the related OAuthClients match this filter */
  oauthClients_SOME?: InputMaybe<OAuthClientWhere>;
  officialTranscriptsUrl?: InputMaybe<Scalars['String']['input']>;
  officialTranscriptsUrl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  officialTranscriptsUrl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  officialTranscriptsUrl_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  officialTranscriptsUrl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ogDescription?: InputMaybe<Scalars['String']['input']>;
  ogDescription_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  ogDescription_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  ogDescription_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogDescription_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ogImage?: InputMaybe<Scalars['String']['input']>;
  ogImageHeight?: InputMaybe<Scalars['String']['input']>;
  ogImageHeight_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  ogImageHeight_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  ogImageHeight_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogImageHeight_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ogImageWidth?: InputMaybe<Scalars['String']['input']>;
  ogImageWidth_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  ogImageWidth_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  ogImageWidth_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogImageWidth_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ogImage_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  ogImage_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  ogImage_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogImage_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ogSiteName?: InputMaybe<Scalars['String']['input']>;
  ogSiteName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  ogSiteName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  ogSiteName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogSiteName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ogTitle?: InputMaybe<Scalars['String']['input']>;
  ogTitle_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  ogTitle_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  ogTitle_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogTitle_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ogType?: InputMaybe<Scalars['String']['input']>;
  ogType_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  ogType_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  ogType_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ogType_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  onboardingPrompt?: InputMaybe<Scalars['String']['input']>;
  onboardingPrompt_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  onboardingPrompt_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  onboardingPrompt_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onboardingPrompt_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  primaryColor_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  primaryColor_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  primaryColor_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  primaryColor_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  proLogo?: InputMaybe<Scalars['String']['input']>;
  proLogo_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  proLogo_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  proLogo_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  proLogo_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  reportProblemUrl?: InputMaybe<Scalars['String']['input']>;
  reportProblemUrl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  reportProblemUrl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  reportProblemUrl_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reportProblemUrl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  requireSSO?: InputMaybe<Scalars['Boolean']['input']>;
  samlConfig?: InputMaybe<SamlConfigWhere>;
  samlConfigAggregate?: InputMaybe<TenantSamlConfigAggregateInput>;
  samlConfigConnection?: InputMaybe<TenantSamlConfigConnectionWhere>;
  samlConfigConnection_NOT?: InputMaybe<TenantSamlConfigConnectionWhere>;
  samlConfig_NOT?: InputMaybe<SamlConfigWhere>;
  scheduleAdvisorCallUrl?: InputMaybe<Scalars['String']['input']>;
  scheduleAdvisorCallUrl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  scheduleAdvisorCallUrl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  scheduleAdvisorCallUrl_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scheduleAdvisorCallUrl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  schoolResourcesUrl?: InputMaybe<Scalars['String']['input']>;
  schoolResourcesUrl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  schoolResourcesUrl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  schoolResourcesUrl_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schoolResourcesUrl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scope_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  showFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  showMiniLogo?: InputMaybe<Scalars['Boolean']['input']>;
  stripeSecretKey?: InputMaybe<Scalars['String']['input']>;
  stripeSecretKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  stripeSecretKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  stripeSecretKey_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stripeSecretKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stripeSubscriptionId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  stripeTrialDays?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  stripeTrialDays_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_LTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink?: InputMaybe<Scalars['String']['input']>;
  submitHelpTicketLink_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  submitHelpTicketLink_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  submitHelpTicketLink_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submitHelpTicketLink_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantDomain?: InputMaybe<Scalars['String']['input']>;
  tenantDomain_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tenantDomain_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantDomain_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantDomain_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantName?: InputMaybe<Scalars['String']['input']>;
  tenantName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tenantName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  termsOfServiceLink?: InputMaybe<Scalars['String']['input']>;
  termsOfServiceLink_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  termsOfServiceLink_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  termsOfServiceLink_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  termsOfServiceLink_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  upgradeModalBody?: InputMaybe<Scalars['String']['input']>;
  upgradeModalBody_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  upgradeModalBody_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  upgradeModalBody_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  upgradeModalBody_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  usersAggregate?: InputMaybe<TenantUsersAggregateInput>;
  /** Return Tenants where all of the related TenantUsersConnections match this filter */
  usersConnection_ALL?: InputMaybe<TenantUsersConnectionWhere>;
  /** Return Tenants where none of the related TenantUsersConnections match this filter */
  usersConnection_NONE?: InputMaybe<TenantUsersConnectionWhere>;
  /** Return Tenants where one of the related TenantUsersConnections match this filter */
  usersConnection_SINGLE?: InputMaybe<TenantUsersConnectionWhere>;
  /** Return Tenants where some of the related TenantUsersConnections match this filter */
  usersConnection_SOME?: InputMaybe<TenantUsersConnectionWhere>;
  /** Return Tenants where all of the related Users match this filter */
  users_ALL?: InputMaybe<UserWhere>;
  /** Return Tenants where none of the related Users match this filter */
  users_NONE?: InputMaybe<UserWhere>;
  /** Return Tenants where one of the related Users match this filter */
  users_SINGLE?: InputMaybe<UserWhere>;
  /** Return Tenants where some of the related Users match this filter */
  users_SOME?: InputMaybe<UserWhere>;
  webhook?: InputMaybe<WebhookWhere>;
  webhookAggregate?: InputMaybe<TenantWebhookAggregateInput>;
  webhookConnection?: InputMaybe<TenantWebhookConnectionWhere>;
  webhookConnection_NOT?: InputMaybe<TenantWebhookConnectionWhere>;
  webhook_NOT?: InputMaybe<WebhookWhere>;
};

export type TextBlock = {
  __typename?: 'TextBlock';
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  message: Message;
  messageAggregate?: Maybe<TextBlockMessageMessageAggregationSelection>;
  messageConnection: TextBlockMessageConnection;
  text: Scalars['String']['output'];
  type: BlockType;
};


export type TextBlockMessageArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<MessageOptions>;
  where?: InputMaybe<MessageWhere>;
};


export type TextBlockMessageAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MessageWhere>;
};


export type TextBlockMessageConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TextBlockMessageConnectionSort>>;
  where?: InputMaybe<TextBlockMessageConnectionWhere>;
};

export type TextBlockConnectInput = {
  message?: InputMaybe<TextBlockMessageConnectFieldInput>;
};

export type TextBlockConnectOrCreateWhere = {
  node: TextBlockUniqueWhere;
};

export type TextBlockConnectWhere = {
  node: TextBlockWhere;
};

export type TextBlockCreateInput = {
  created: Scalars['DateTime']['input'];
  message?: InputMaybe<TextBlockMessageFieldInput>;
  text: Scalars['String']['input'];
  type: BlockType;
};

export type TextBlockDeleteInput = {
  message?: InputMaybe<TextBlockMessageDeleteFieldInput>;
};

export type TextBlockDisconnectInput = {
  message?: InputMaybe<TextBlockMessageDisconnectFieldInput>;
};

export type TextBlockMessageAggregateInput = {
  AND?: InputMaybe<Array<TextBlockMessageAggregateInput>>;
  NOT?: InputMaybe<TextBlockMessageAggregateInput>;
  OR?: InputMaybe<Array<TextBlockMessageAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasBlockPropertiesAggregationWhereInput>;
  node?: InputMaybe<TextBlockMessageNodeAggregationWhereInput>;
};

export type TextBlockMessageConnectFieldInput = {
  connect?: InputMaybe<MessageConnectInput>;
  edge: HasBlockPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<MessageConnectWhere>;
};

export type TextBlockMessageConnectOrCreateFieldInput = {
  onCreate: TextBlockMessageConnectOrCreateFieldInputOnCreate;
  where: MessageConnectOrCreateWhere;
};

export type TextBlockMessageConnectOrCreateFieldInputOnCreate = {
  edge: HasBlockPropertiesCreateInput;
  node: MessageOnCreateInput;
};

export type TextBlockMessageConnection = {
  __typename?: 'TextBlockMessageConnection';
  edges: Array<TextBlockMessageRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TextBlockMessageConnectionSort = {
  edge?: InputMaybe<HasBlockPropertiesSort>;
  node?: InputMaybe<MessageSort>;
};

export type TextBlockMessageConnectionWhere = {
  AND?: InputMaybe<Array<TextBlockMessageConnectionWhere>>;
  NOT?: InputMaybe<TextBlockMessageConnectionWhere>;
  OR?: InputMaybe<Array<TextBlockMessageConnectionWhere>>;
  edge?: InputMaybe<HasBlockPropertiesWhere>;
  node?: InputMaybe<MessageWhere>;
};

export type TextBlockMessageCreateFieldInput = {
  edge: HasBlockPropertiesCreateInput;
  node: MessageCreateInput;
};

export type TextBlockMessageDeleteFieldInput = {
  delete?: InputMaybe<MessageDeleteInput>;
  where?: InputMaybe<TextBlockMessageConnectionWhere>;
};

export type TextBlockMessageDisconnectFieldInput = {
  disconnect?: InputMaybe<MessageDisconnectInput>;
  where?: InputMaybe<TextBlockMessageConnectionWhere>;
};

export type TextBlockMessageFieldInput = {
  connect?: InputMaybe<TextBlockMessageConnectFieldInput>;
  connectOrCreate?: InputMaybe<TextBlockMessageConnectOrCreateFieldInput>;
  create?: InputMaybe<TextBlockMessageCreateFieldInput>;
};

export type TextBlockMessageMessageAggregationSelection = {
  __typename?: 'TextBlockMessageMessageAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<TextBlockMessageMessageEdgeAggregateSelection>;
  node?: Maybe<TextBlockMessageMessageNodeAggregateSelection>;
};

export type TextBlockMessageMessageEdgeAggregateSelection = {
  __typename?: 'TextBlockMessageMessageEdgeAggregateSelection';
  created: DateTimeAggregateSelection;
  index: IntAggregateSelection;
};

export type TextBlockMessageMessageNodeAggregateSelection = {
  __typename?: 'TextBlockMessageMessageNodeAggregateSelection';
  aspectDetails: StringAggregateSelection;
  content: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  emotion: StringAggregateSelection;
  id: IdAggregateSelection;
  index: IntAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  nodeId: StringAggregateSelection;
  parameters: StringAggregateSelection;
  sender: StringAggregateSelection;
  snackType: StringAggregateSelection;
  type: StringAggregateSelection;
};

export type TextBlockMessageNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TextBlockMessageNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TextBlockMessageNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TextBlockMessageNodeAggregationWhereInput>>;
  aspectDetails_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  content_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  content_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  emotion_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emotion_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emotion_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emotion_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emotion_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emotion_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emotion_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emotion_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emotion_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emotion_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  index_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  index_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  nodeId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nodeId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  nodeId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  nodeId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  nodeId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  nodeId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nodeId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nodeId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nodeId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nodeId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  parameters_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  parameters_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  parameters_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  parameters_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  parameters_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  parameters_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  parameters_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  parameters_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  parameters_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  parameters_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  snackType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  snackType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  snackType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  snackType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  snackType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  snackType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  snackType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  snackType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  snackType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  snackType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TextBlockMessageRelationship = {
  __typename?: 'TextBlockMessageRelationship';
  cursor: Scalars['String']['output'];
  node: Message;
  properties: HasBlockProperties;
};

export type TextBlockMessageUpdateConnectionInput = {
  edge?: InputMaybe<HasBlockPropertiesUpdateInput>;
  node?: InputMaybe<MessageUpdateInput>;
};

export type TextBlockMessageUpdateFieldInput = {
  connect?: InputMaybe<TextBlockMessageConnectFieldInput>;
  connectOrCreate?: InputMaybe<TextBlockMessageConnectOrCreateFieldInput>;
  create?: InputMaybe<TextBlockMessageCreateFieldInput>;
  delete?: InputMaybe<TextBlockMessageDeleteFieldInput>;
  disconnect?: InputMaybe<TextBlockMessageDisconnectFieldInput>;
  update?: InputMaybe<TextBlockMessageUpdateConnectionInput>;
  where?: InputMaybe<TextBlockMessageConnectionWhere>;
};

export type TextBlockOnCreateInput = {
  created: Scalars['DateTime']['input'];
  text: Scalars['String']['input'];
  type: BlockType;
};

export type TextBlockOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TextBlockSort objects to sort TextBlocks by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TextBlockSort>>;
};

/** Fields to sort TextBlocks by. The order in which sorts are applied is not guaranteed when specifying many fields in one TextBlockSort object. */
export type TextBlockSort = {
  created?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  text?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export type TextBlockUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type TextBlockUpdateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  message?: InputMaybe<TextBlockMessageUpdateFieldInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BlockType>;
};

export type TextBlockWhere = {
  AND?: InputMaybe<Array<TextBlockWhere>>;
  NOT?: InputMaybe<TextBlockWhere>;
  OR?: InputMaybe<Array<TextBlockWhere>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  message?: InputMaybe<MessageWhere>;
  messageAggregate?: InputMaybe<TextBlockMessageAggregateInput>;
  messageConnection?: InputMaybe<TextBlockMessageConnectionWhere>;
  messageConnection_NOT?: InputMaybe<TextBlockMessageConnectionWhere>;
  message_NOT?: InputMaybe<MessageWhere>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  text_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  text_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  text_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BlockType>;
  type_IN?: InputMaybe<Array<BlockType>>;
};

export type Thread = {
  __typename?: 'Thread';
  created: Scalars['DateTime']['output'];
  forum: Forum;
  forumAggregate?: Maybe<ThreadForumForumAggregationSelection>;
  forumConnection: ThreadForumConnection;
  id: Scalars['ID']['output'];
  lastModified: Scalars['DateTime']['output'];
  posts: Array<Post>;
  postsAggregate?: Maybe<ThreadPostPostsAggregationSelection>;
  postsConnection: ThreadPostsConnection;
  readStates: Array<User>;
  readStatesAggregate?: Maybe<ThreadUserReadStatesAggregationSelection>;
  readStatesConnection: ThreadReadStatesConnection;
  subscribers: Array<User>;
  subscribersAggregate?: Maybe<ThreadUserSubscribersAggregationSelection>;
  subscribersConnection: ThreadSubscribersConnection;
  title: Scalars['String']['output'];
};


export type ThreadForumArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ForumOptions>;
  where?: InputMaybe<ForumWhere>;
};


export type ThreadForumAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ForumWhere>;
};


export type ThreadForumConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ThreadForumConnectionSort>>;
  where?: InputMaybe<ThreadForumConnectionWhere>;
};


export type ThreadPostsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PostOptions>;
  where?: InputMaybe<PostWhere>;
};


export type ThreadPostsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PostWhere>;
};


export type ThreadPostsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ThreadPostsConnectionSort>>;
  where?: InputMaybe<ThreadPostsConnectionWhere>;
};


export type ThreadReadStatesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type ThreadReadStatesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type ThreadReadStatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ThreadReadStatesConnectionSort>>;
  where?: InputMaybe<ThreadReadStatesConnectionWhere>;
};


export type ThreadSubscribersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type ThreadSubscribersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type ThreadSubscribersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ThreadSubscribersConnectionSort>>;
  where?: InputMaybe<ThreadSubscribersConnectionWhere>;
};

export type ThreadConnectInput = {
  forum?: InputMaybe<ThreadForumConnectFieldInput>;
  posts?: InputMaybe<Array<ThreadPostsConnectFieldInput>>;
  readStates?: InputMaybe<Array<ThreadReadStatesConnectFieldInput>>;
  subscribers?: InputMaybe<Array<ThreadSubscribersConnectFieldInput>>;
};

export type ThreadConnectOrCreateWhere = {
  node: ThreadUniqueWhere;
};

export type ThreadConnectWhere = {
  node: ThreadWhere;
};

export type ThreadCreateInput = {
  created: Scalars['DateTime']['input'];
  forum?: InputMaybe<ThreadForumFieldInput>;
  lastModified: Scalars['DateTime']['input'];
  posts?: InputMaybe<ThreadPostsFieldInput>;
  readStates?: InputMaybe<ThreadReadStatesFieldInput>;
  subscribers?: InputMaybe<ThreadSubscribersFieldInput>;
  title: Scalars['String']['input'];
};

export type ThreadDeleteInput = {
  forum?: InputMaybe<ThreadForumDeleteFieldInput>;
  posts?: InputMaybe<Array<ThreadPostsDeleteFieldInput>>;
  readStates?: InputMaybe<Array<ThreadReadStatesDeleteFieldInput>>;
  subscribers?: InputMaybe<Array<ThreadSubscribersDeleteFieldInput>>;
};

export type ThreadDisconnectInput = {
  forum?: InputMaybe<ThreadForumDisconnectFieldInput>;
  posts?: InputMaybe<Array<ThreadPostsDisconnectFieldInput>>;
  readStates?: InputMaybe<Array<ThreadReadStatesDisconnectFieldInput>>;
  subscribers?: InputMaybe<Array<ThreadSubscribersDisconnectFieldInput>>;
};

export type ThreadForumAggregateInput = {
  AND?: InputMaybe<Array<ThreadForumAggregateInput>>;
  NOT?: InputMaybe<ThreadForumAggregateInput>;
  OR?: InputMaybe<Array<ThreadForumAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ThreadForumNodeAggregationWhereInput>;
};

export type ThreadForumConnectFieldInput = {
  connect?: InputMaybe<ForumConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ForumConnectWhere>;
};

export type ThreadForumConnectOrCreateFieldInput = {
  onCreate: ThreadForumConnectOrCreateFieldInputOnCreate;
  where: ForumConnectOrCreateWhere;
};

export type ThreadForumConnectOrCreateFieldInputOnCreate = {
  node: ForumOnCreateInput;
};

export type ThreadForumConnection = {
  __typename?: 'ThreadForumConnection';
  edges: Array<ThreadForumRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ThreadForumConnectionSort = {
  node?: InputMaybe<ForumSort>;
};

export type ThreadForumConnectionWhere = {
  AND?: InputMaybe<Array<ThreadForumConnectionWhere>>;
  NOT?: InputMaybe<ThreadForumConnectionWhere>;
  OR?: InputMaybe<Array<ThreadForumConnectionWhere>>;
  node?: InputMaybe<ForumWhere>;
};

export type ThreadForumCreateFieldInput = {
  node: ForumCreateInput;
};

export type ThreadForumDeleteFieldInput = {
  delete?: InputMaybe<ForumDeleteInput>;
  where?: InputMaybe<ThreadForumConnectionWhere>;
};

export type ThreadForumDisconnectFieldInput = {
  disconnect?: InputMaybe<ForumDisconnectInput>;
  where?: InputMaybe<ThreadForumConnectionWhere>;
};

export type ThreadForumFieldInput = {
  connect?: InputMaybe<ThreadForumConnectFieldInput>;
  connectOrCreate?: InputMaybe<ThreadForumConnectOrCreateFieldInput>;
  create?: InputMaybe<ThreadForumCreateFieldInput>;
};

export type ThreadForumForumAggregationSelection = {
  __typename?: 'ThreadForumForumAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ThreadForumForumNodeAggregateSelection>;
};

export type ThreadForumForumNodeAggregateSelection = {
  __typename?: 'ThreadForumForumNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
};

export type ThreadForumNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ThreadForumNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ThreadForumNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ThreadForumNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ThreadForumRelationship = {
  __typename?: 'ThreadForumRelationship';
  cursor: Scalars['String']['output'];
  node: Forum;
};

export type ThreadForumUpdateConnectionInput = {
  node?: InputMaybe<ForumUpdateInput>;
};

export type ThreadForumUpdateFieldInput = {
  connect?: InputMaybe<ThreadForumConnectFieldInput>;
  connectOrCreate?: InputMaybe<ThreadForumConnectOrCreateFieldInput>;
  create?: InputMaybe<ThreadForumCreateFieldInput>;
  delete?: InputMaybe<ThreadForumDeleteFieldInput>;
  disconnect?: InputMaybe<ThreadForumDisconnectFieldInput>;
  update?: InputMaybe<ThreadForumUpdateConnectionInput>;
  where?: InputMaybe<ThreadForumConnectionWhere>;
};

export type ThreadListResponse = {
  __typename?: 'ThreadListResponse';
  count: Scalars['Int']['output'];
  data: Array<Thread>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ThreadOnCreateInput = {
  created: Scalars['DateTime']['input'];
  lastModified: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
};

export type ThreadOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ThreadSort objects to sort Threads by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ThreadSort>>;
};

export type ThreadPostPostsAggregationSelection = {
  __typename?: 'ThreadPostPostsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ThreadPostPostsNodeAggregateSelection>;
};

export type ThreadPostPostsNodeAggregateSelection = {
  __typename?: 'ThreadPostPostsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  depth: IntAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  message: StringAggregateSelection;
  threadId: StringAggregateSelection;
};

export type ThreadPostsAggregateInput = {
  AND?: InputMaybe<Array<ThreadPostsAggregateInput>>;
  NOT?: InputMaybe<ThreadPostsAggregateInput>;
  OR?: InputMaybe<Array<ThreadPostsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ThreadPostsNodeAggregationWhereInput>;
};

export type ThreadPostsConnectFieldInput = {
  connect?: InputMaybe<Array<PostConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PostConnectWhere>;
};

export type ThreadPostsConnectOrCreateFieldInput = {
  onCreate: ThreadPostsConnectOrCreateFieldInputOnCreate;
  where: PostConnectOrCreateWhere;
};

export type ThreadPostsConnectOrCreateFieldInputOnCreate = {
  node: PostOnCreateInput;
};

export type ThreadPostsConnection = {
  __typename?: 'ThreadPostsConnection';
  edges: Array<ThreadPostsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ThreadPostsConnectionSort = {
  node?: InputMaybe<PostSort>;
};

export type ThreadPostsConnectionWhere = {
  AND?: InputMaybe<Array<ThreadPostsConnectionWhere>>;
  NOT?: InputMaybe<ThreadPostsConnectionWhere>;
  OR?: InputMaybe<Array<ThreadPostsConnectionWhere>>;
  node?: InputMaybe<PostWhere>;
};

export type ThreadPostsCreateFieldInput = {
  node: PostCreateInput;
};

export type ThreadPostsDeleteFieldInput = {
  delete?: InputMaybe<PostDeleteInput>;
  where?: InputMaybe<ThreadPostsConnectionWhere>;
};

export type ThreadPostsDisconnectFieldInput = {
  disconnect?: InputMaybe<PostDisconnectInput>;
  where?: InputMaybe<ThreadPostsConnectionWhere>;
};

export type ThreadPostsFieldInput = {
  connect?: InputMaybe<Array<ThreadPostsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ThreadPostsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ThreadPostsCreateFieldInput>>;
};

export type ThreadPostsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ThreadPostsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ThreadPostsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ThreadPostsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  depth_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  depth_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  depth_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  depth_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  depth_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  depth_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  depth_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  depth_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  depth_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  depth_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  depth_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  depth_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  depth_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  depth_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  depth_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  depth_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  depth_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  depth_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  depth_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  depth_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  message_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  message_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threadId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threadId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  threadId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  threadId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  threadId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  threadId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threadId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threadId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threadId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threadId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threadId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threadId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threadId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threadId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threadId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ThreadPostsRelationship = {
  __typename?: 'ThreadPostsRelationship';
  cursor: Scalars['String']['output'];
  node: Post;
};

export type ThreadPostsUpdateConnectionInput = {
  node?: InputMaybe<PostUpdateInput>;
};

export type ThreadPostsUpdateFieldInput = {
  connect?: InputMaybe<Array<ThreadPostsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ThreadPostsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ThreadPostsCreateFieldInput>>;
  delete?: InputMaybe<Array<ThreadPostsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ThreadPostsDisconnectFieldInput>>;
  update?: InputMaybe<ThreadPostsUpdateConnectionInput>;
  where?: InputMaybe<ThreadPostsConnectionWhere>;
};

export type ThreadReadStatesAggregateInput = {
  AND?: InputMaybe<Array<ThreadReadStatesAggregateInput>>;
  NOT?: InputMaybe<ThreadReadStatesAggregateInput>;
  OR?: InputMaybe<Array<ThreadReadStatesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<ReadStatePropertiesAggregationWhereInput>;
  node?: InputMaybe<ThreadReadStatesNodeAggregationWhereInput>;
};

export type ThreadReadStatesConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  edge?: InputMaybe<ReadStatePropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type ThreadReadStatesConnectOrCreateFieldInput = {
  onCreate: ThreadReadStatesConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type ThreadReadStatesConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<ReadStatePropertiesCreateInput>;
  node: UserOnCreateInput;
};

export type ThreadReadStatesConnection = {
  __typename?: 'ThreadReadStatesConnection';
  edges: Array<ThreadReadStatesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ThreadReadStatesConnectionSort = {
  edge?: InputMaybe<ReadStatePropertiesSort>;
  node?: InputMaybe<UserSort>;
};

export type ThreadReadStatesConnectionWhere = {
  AND?: InputMaybe<Array<ThreadReadStatesConnectionWhere>>;
  NOT?: InputMaybe<ThreadReadStatesConnectionWhere>;
  OR?: InputMaybe<Array<ThreadReadStatesConnectionWhere>>;
  edge?: InputMaybe<ReadStatePropertiesWhere>;
  node?: InputMaybe<UserWhere>;
};

export type ThreadReadStatesCreateFieldInput = {
  edge?: InputMaybe<ReadStatePropertiesCreateInput>;
  node: UserCreateInput;
};

export type ThreadReadStatesDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<ThreadReadStatesConnectionWhere>;
};

export type ThreadReadStatesDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<ThreadReadStatesConnectionWhere>;
};

export type ThreadReadStatesFieldInput = {
  connect?: InputMaybe<Array<ThreadReadStatesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ThreadReadStatesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ThreadReadStatesCreateFieldInput>>;
};

export type ThreadReadStatesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ThreadReadStatesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ThreadReadStatesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ThreadReadStatesNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ThreadReadStatesRelationship = {
  __typename?: 'ThreadReadStatesRelationship';
  cursor: Scalars['String']['output'];
  node: User;
  properties: ReadStateProperties;
};

export type ThreadReadStatesUpdateConnectionInput = {
  edge?: InputMaybe<ReadStatePropertiesUpdateInput>;
  node?: InputMaybe<UserUpdateInput>;
};

export type ThreadReadStatesUpdateFieldInput = {
  connect?: InputMaybe<Array<ThreadReadStatesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ThreadReadStatesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ThreadReadStatesCreateFieldInput>>;
  delete?: InputMaybe<Array<ThreadReadStatesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ThreadReadStatesDisconnectFieldInput>>;
  update?: InputMaybe<ThreadReadStatesUpdateConnectionInput>;
  where?: InputMaybe<ThreadReadStatesConnectionWhere>;
};

export type ThreadResponse = {
  __typename?: 'ThreadResponse';
  count: Scalars['Int']['output'];
  data?: Maybe<Thread>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Fields to sort Threads by. The order in which sorts are applied is not guaranteed when specifying many fields in one ThreadSort object. */
export type ThreadSort = {
  created?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastModified?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
};

export type ThreadSubscribersAggregateInput = {
  AND?: InputMaybe<Array<ThreadSubscribersAggregateInput>>;
  NOT?: InputMaybe<ThreadSubscribersAggregateInput>;
  OR?: InputMaybe<Array<ThreadSubscribersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ThreadSubscribersNodeAggregationWhereInput>;
};

export type ThreadSubscribersConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type ThreadSubscribersConnectOrCreateFieldInput = {
  onCreate: ThreadSubscribersConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type ThreadSubscribersConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type ThreadSubscribersConnection = {
  __typename?: 'ThreadSubscribersConnection';
  edges: Array<ThreadSubscribersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ThreadSubscribersConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type ThreadSubscribersConnectionWhere = {
  AND?: InputMaybe<Array<ThreadSubscribersConnectionWhere>>;
  NOT?: InputMaybe<ThreadSubscribersConnectionWhere>;
  OR?: InputMaybe<Array<ThreadSubscribersConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type ThreadSubscribersCreateFieldInput = {
  node: UserCreateInput;
};

export type ThreadSubscribersDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<ThreadSubscribersConnectionWhere>;
};

export type ThreadSubscribersDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<ThreadSubscribersConnectionWhere>;
};

export type ThreadSubscribersFieldInput = {
  connect?: InputMaybe<Array<ThreadSubscribersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ThreadSubscribersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ThreadSubscribersCreateFieldInput>>;
};

export type ThreadSubscribersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ThreadSubscribersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ThreadSubscribersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ThreadSubscribersNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ThreadSubscribersRelationship = {
  __typename?: 'ThreadSubscribersRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type ThreadSubscribersUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type ThreadSubscribersUpdateFieldInput = {
  connect?: InputMaybe<Array<ThreadSubscribersConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<ThreadSubscribersConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<ThreadSubscribersCreateFieldInput>>;
  delete?: InputMaybe<Array<ThreadSubscribersDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ThreadSubscribersDisconnectFieldInput>>;
  update?: InputMaybe<ThreadSubscribersUpdateConnectionInput>;
  where?: InputMaybe<ThreadSubscribersConnectionWhere>;
};

export type ThreadUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ThreadUpdateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  forum?: InputMaybe<ThreadForumUpdateFieldInput>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  posts?: InputMaybe<Array<ThreadPostsUpdateFieldInput>>;
  readStates?: InputMaybe<Array<ThreadReadStatesUpdateFieldInput>>;
  subscribers?: InputMaybe<Array<ThreadSubscribersUpdateFieldInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ThreadUserReadStatesAggregationSelection = {
  __typename?: 'ThreadUserReadStatesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<ThreadUserReadStatesEdgeAggregateSelection>;
  node?: Maybe<ThreadUserReadStatesNodeAggregateSelection>;
};

export type ThreadUserReadStatesEdgeAggregateSelection = {
  __typename?: 'ThreadUserReadStatesEdgeAggregateSelection';
  lastSeenAt: DateTimeAggregateSelection;
  lastSeenPostId: StringAggregateSelection;
};

export type ThreadUserReadStatesNodeAggregateSelection = {
  __typename?: 'ThreadUserReadStatesNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type ThreadUserSubscribersAggregationSelection = {
  __typename?: 'ThreadUserSubscribersAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<ThreadUserSubscribersNodeAggregateSelection>;
};

export type ThreadUserSubscribersNodeAggregateSelection = {
  __typename?: 'ThreadUserSubscribersNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type ThreadWhere = {
  AND?: InputMaybe<Array<ThreadWhere>>;
  NOT?: InputMaybe<ThreadWhere>;
  OR?: InputMaybe<Array<ThreadWhere>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  forum?: InputMaybe<ForumWhere>;
  forumAggregate?: InputMaybe<ThreadForumAggregateInput>;
  forumConnection?: InputMaybe<ThreadForumConnectionWhere>;
  forumConnection_NOT?: InputMaybe<ThreadForumConnectionWhere>;
  forum_NOT?: InputMaybe<ForumWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lastModified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  postsAggregate?: InputMaybe<ThreadPostsAggregateInput>;
  /** Return Threads where all of the related ThreadPostsConnections match this filter */
  postsConnection_ALL?: InputMaybe<ThreadPostsConnectionWhere>;
  /** Return Threads where none of the related ThreadPostsConnections match this filter */
  postsConnection_NONE?: InputMaybe<ThreadPostsConnectionWhere>;
  /** Return Threads where one of the related ThreadPostsConnections match this filter */
  postsConnection_SINGLE?: InputMaybe<ThreadPostsConnectionWhere>;
  /** Return Threads where some of the related ThreadPostsConnections match this filter */
  postsConnection_SOME?: InputMaybe<ThreadPostsConnectionWhere>;
  /** Return Threads where all of the related Posts match this filter */
  posts_ALL?: InputMaybe<PostWhere>;
  /** Return Threads where none of the related Posts match this filter */
  posts_NONE?: InputMaybe<PostWhere>;
  /** Return Threads where one of the related Posts match this filter */
  posts_SINGLE?: InputMaybe<PostWhere>;
  /** Return Threads where some of the related Posts match this filter */
  posts_SOME?: InputMaybe<PostWhere>;
  readStatesAggregate?: InputMaybe<ThreadReadStatesAggregateInput>;
  /** Return Threads where all of the related ThreadReadStatesConnections match this filter */
  readStatesConnection_ALL?: InputMaybe<ThreadReadStatesConnectionWhere>;
  /** Return Threads where none of the related ThreadReadStatesConnections match this filter */
  readStatesConnection_NONE?: InputMaybe<ThreadReadStatesConnectionWhere>;
  /** Return Threads where one of the related ThreadReadStatesConnections match this filter */
  readStatesConnection_SINGLE?: InputMaybe<ThreadReadStatesConnectionWhere>;
  /** Return Threads where some of the related ThreadReadStatesConnections match this filter */
  readStatesConnection_SOME?: InputMaybe<ThreadReadStatesConnectionWhere>;
  /** Return Threads where all of the related Users match this filter */
  readStates_ALL?: InputMaybe<UserWhere>;
  /** Return Threads where none of the related Users match this filter */
  readStates_NONE?: InputMaybe<UserWhere>;
  /** Return Threads where one of the related Users match this filter */
  readStates_SINGLE?: InputMaybe<UserWhere>;
  /** Return Threads where some of the related Users match this filter */
  readStates_SOME?: InputMaybe<UserWhere>;
  subscribersAggregate?: InputMaybe<ThreadSubscribersAggregateInput>;
  /** Return Threads where all of the related ThreadSubscribersConnections match this filter */
  subscribersConnection_ALL?: InputMaybe<ThreadSubscribersConnectionWhere>;
  /** Return Threads where none of the related ThreadSubscribersConnections match this filter */
  subscribersConnection_NONE?: InputMaybe<ThreadSubscribersConnectionWhere>;
  /** Return Threads where one of the related ThreadSubscribersConnections match this filter */
  subscribersConnection_SINGLE?: InputMaybe<ThreadSubscribersConnectionWhere>;
  /** Return Threads where some of the related ThreadSubscribersConnections match this filter */
  subscribersConnection_SOME?: InputMaybe<ThreadSubscribersConnectionWhere>;
  /** Return Threads where all of the related Users match this filter */
  subscribers_ALL?: InputMaybe<UserWhere>;
  /** Return Threads where none of the related Users match this filter */
  subscribers_NONE?: InputMaybe<UserWhere>;
  /** Return Threads where one of the related Users match this filter */
  subscribers_SINGLE?: InputMaybe<UserWhere>;
  /** Return Threads where some of the related Users match this filter */
  subscribers_SOME?: InputMaybe<UserWhere>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type Todo = {
  __typename?: 'Todo';
  achievements?: Maybe<Array<Maybe<Achievements>>>;
  aiSummary?: Maybe<Scalars['String']['output']>;
  challenges?: Maybe<Array<Maybe<Challenge>>>;
  completed: Scalars['Boolean']['output'];
  completed_date?: Maybe<Scalars['DateTime']['output']>;
  coreValues?: Maybe<Array<Maybe<CoreValue>>>;
  created?: Maybe<Scalars['DateTime']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  emotionalStates?: Maybe<Array<Maybe<EmotionalState>>>;
  feedback?: Maybe<Feedback>;
  goals?: Maybe<Array<Maybe<Goal>>>;
  hobbies?: Maybe<Array<Maybe<Hobby>>>;
  id: Scalars['ID']['output'];
  interests?: Maybe<Array<Maybe<Interest>>>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isRecurring?: Maybe<Scalars['Boolean']['output']>;
  last_modified?: Maybe<Scalars['DateTime']['output']>;
  lessons?: Maybe<Array<Maybe<Lesson>>>;
  lifeAspirations?: Maybe<Array<Maybe<LifeAspiration>>>;
  name: Scalars['String']['output'];
  personalityTraits?: Maybe<Array<Maybe<PersonalityTrait>>>;
  pointsReceived?: Maybe<Scalars['Int']['output']>;
  preferences?: Maybe<Preferences>;
  priority?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Progress>;
  recurringDaily?: Maybe<Scalars['Boolean']['output']>;
  recurringDayOfMonth?: Maybe<Scalars['Int']['output']>;
  recurringDayOfWeek?: Maybe<Scalars['String']['output']>;
  recurringFrequency?: Maybe<Scalars['String']['output']>;
  recurringTime?: Maybe<Scalars['String']['output']>;
  reflections?: Maybe<Array<Maybe<Reflection>>>;
  timeOfDay?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  todos: Array<Todo>;
  user: User;
  usersHasTodo: Array<User>;
  usersHasTodoAggregate?: Maybe<TodoUserUsersHasTodoAggregationSelection>;
  usersHasTodoConnection: TodoUsersHasTodoConnection;
  workspacesHasTodo: Array<Workspace>;
  workspacesHasTodoAggregate?: Maybe<TodoWorkspaceWorkspacesHasTodoAggregationSelection>;
  workspacesHasTodoConnection: TodoWorkspacesHasTodoConnection;
};


export type TodoUsersHasTodoArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type TodoUsersHasTodoAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type TodoUsersHasTodoConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TodoUsersHasTodoConnectionSort>>;
  where?: InputMaybe<TodoUsersHasTodoConnectionWhere>;
};


export type TodoWorkspacesHasTodoArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<WorkspaceOptions>;
  where?: InputMaybe<WorkspaceWhere>;
};


export type TodoWorkspacesHasTodoAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WorkspaceWhere>;
};


export type TodoWorkspacesHasTodoConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TodoWorkspacesHasTodoConnectionSort>>;
  where?: InputMaybe<TodoWorkspacesHasTodoConnectionWhere>;
};

export type TodoConnectInput = {
  usersHasTodo?: InputMaybe<Array<TodoUsersHasTodoConnectFieldInput>>;
  workspacesHasTodo?: InputMaybe<Array<TodoWorkspacesHasTodoConnectFieldInput>>;
};

export type TodoConnectOrCreateWhere = {
  node: TodoUniqueWhere;
};

export type TodoConnectWhere = {
  node: TodoWhere;
};

export type TodoCreateInput = {
  aiSummary?: InputMaybe<Scalars['String']['input']>;
  completed: Scalars['Boolean']['input'];
  completed_date?: InputMaybe<Scalars['DateTime']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  pointsReceived?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  recurringDaily?: InputMaybe<Scalars['Boolean']['input']>;
  recurringDayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek?: InputMaybe<Scalars['String']['input']>;
  recurringFrequency?: InputMaybe<Scalars['String']['input']>;
  recurringTime?: InputMaybe<Scalars['String']['input']>;
  timeOfDay?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  usersHasTodo?: InputMaybe<TodoUsersHasTodoFieldInput>;
  workspacesHasTodo?: InputMaybe<TodoWorkspacesHasTodoFieldInput>;
};

export type TodoDeleteInput = {
  usersHasTodo?: InputMaybe<Array<TodoUsersHasTodoDeleteFieldInput>>;
  workspacesHasTodo?: InputMaybe<Array<TodoWorkspacesHasTodoDeleteFieldInput>>;
};

export type TodoDisconnectInput = {
  usersHasTodo?: InputMaybe<Array<TodoUsersHasTodoDisconnectFieldInput>>;
  workspacesHasTodo?: InputMaybe<Array<TodoWorkspacesHasTodoDisconnectFieldInput>>;
};

export type TodoOnCreateInput = {
  aiSummary?: InputMaybe<Scalars['String']['input']>;
  completed: Scalars['Boolean']['input'];
  completed_date?: InputMaybe<Scalars['DateTime']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  pointsReceived?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  recurringDaily?: InputMaybe<Scalars['Boolean']['input']>;
  recurringDayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek?: InputMaybe<Scalars['String']['input']>;
  recurringFrequency?: InputMaybe<Scalars['String']['input']>;
  recurringTime?: InputMaybe<Scalars['String']['input']>;
  timeOfDay?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type TodoOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TodoSort objects to sort Todos by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TodoSort>>;
};

export type TodoResponse = {
  __typename?: 'TodoResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<Todo>>>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Fields to sort Todos by. The order in which sorts are applied is not guaranteed when specifying many fields in one TodoSort object. */
export type TodoSort = {
  aiSummary?: InputMaybe<SortDirection>;
  completed?: InputMaybe<SortDirection>;
  completed_date?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  date?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isArchived?: InputMaybe<SortDirection>;
  isRecurring?: InputMaybe<SortDirection>;
  last_modified?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  pointsReceived?: InputMaybe<SortDirection>;
  priority?: InputMaybe<SortDirection>;
  recurringDaily?: InputMaybe<SortDirection>;
  recurringDayOfMonth?: InputMaybe<SortDirection>;
  recurringDayOfWeek?: InputMaybe<SortDirection>;
  recurringFrequency?: InputMaybe<SortDirection>;
  recurringTime?: InputMaybe<SortDirection>;
  timeOfDay?: InputMaybe<SortDirection>;
  timezone?: InputMaybe<SortDirection>;
};

export type TodoUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type TodoUpdateInput = {
  aiSummary?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completed_date?: InputMaybe<Scalars['DateTime']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pointsReceived?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  recurringDaily?: InputMaybe<Scalars['Boolean']['input']>;
  recurringDayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek?: InputMaybe<Scalars['String']['input']>;
  recurringFrequency?: InputMaybe<Scalars['String']['input']>;
  recurringTime?: InputMaybe<Scalars['String']['input']>;
  timeOfDay?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  usersHasTodo?: InputMaybe<Array<TodoUsersHasTodoUpdateFieldInput>>;
  workspacesHasTodo?: InputMaybe<Array<TodoWorkspacesHasTodoUpdateFieldInput>>;
};

export type TodoUserUsersHasTodoAggregationSelection = {
  __typename?: 'TodoUserUsersHasTodoAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<TodoUserUsersHasTodoEdgeAggregateSelection>;
  node?: Maybe<TodoUserUsersHasTodoNodeAggregateSelection>;
};

export type TodoUserUsersHasTodoEdgeAggregateSelection = {
  __typename?: 'TodoUserUsersHasTodoEdgeAggregateSelection';
  created: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  quality: BigIntAggregateSelection;
  strength: BigIntAggregateSelection;
};

export type TodoUserUsersHasTodoNodeAggregateSelection = {
  __typename?: 'TodoUserUsersHasTodoNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type TodoUsersHasTodoAggregateInput = {
  AND?: InputMaybe<Array<TodoUsersHasTodoAggregateInput>>;
  NOT?: InputMaybe<TodoUsersHasTodoAggregateInput>;
  OR?: InputMaybe<Array<TodoUsersHasTodoAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasTodoPropertiesAggregationWhereInput>;
  node?: InputMaybe<TodoUsersHasTodoNodeAggregationWhereInput>;
};

export type TodoUsersHasTodoConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  edge?: InputMaybe<HasTodoPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type TodoUsersHasTodoConnectOrCreateFieldInput = {
  onCreate: TodoUsersHasTodoConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type TodoUsersHasTodoConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<HasTodoPropertiesCreateInput>;
  node: UserOnCreateInput;
};

export type TodoUsersHasTodoConnection = {
  __typename?: 'TodoUsersHasTodoConnection';
  edges: Array<TodoUsersHasTodoRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TodoUsersHasTodoConnectionSort = {
  edge?: InputMaybe<HasTodoPropertiesSort>;
  node?: InputMaybe<UserSort>;
};

export type TodoUsersHasTodoConnectionWhere = {
  AND?: InputMaybe<Array<TodoUsersHasTodoConnectionWhere>>;
  NOT?: InputMaybe<TodoUsersHasTodoConnectionWhere>;
  OR?: InputMaybe<Array<TodoUsersHasTodoConnectionWhere>>;
  edge?: InputMaybe<HasTodoPropertiesWhere>;
  node?: InputMaybe<UserWhere>;
};

export type TodoUsersHasTodoCreateFieldInput = {
  edge?: InputMaybe<HasTodoPropertiesCreateInput>;
  node: UserCreateInput;
};

export type TodoUsersHasTodoDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<TodoUsersHasTodoConnectionWhere>;
};

export type TodoUsersHasTodoDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<TodoUsersHasTodoConnectionWhere>;
};

export type TodoUsersHasTodoFieldInput = {
  connect?: InputMaybe<Array<TodoUsersHasTodoConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TodoUsersHasTodoConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TodoUsersHasTodoCreateFieldInput>>;
};

export type TodoUsersHasTodoNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TodoUsersHasTodoNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TodoUsersHasTodoNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TodoUsersHasTodoNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TodoUsersHasTodoRelationship = {
  __typename?: 'TodoUsersHasTodoRelationship';
  cursor: Scalars['String']['output'];
  node: User;
  properties: HasTodoProperties;
};

export type TodoUsersHasTodoUpdateConnectionInput = {
  edge?: InputMaybe<HasTodoPropertiesUpdateInput>;
  node?: InputMaybe<UserUpdateInput>;
};

export type TodoUsersHasTodoUpdateFieldInput = {
  connect?: InputMaybe<Array<TodoUsersHasTodoConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TodoUsersHasTodoConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TodoUsersHasTodoCreateFieldInput>>;
  delete?: InputMaybe<Array<TodoUsersHasTodoDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TodoUsersHasTodoDisconnectFieldInput>>;
  update?: InputMaybe<TodoUsersHasTodoUpdateConnectionInput>;
  where?: InputMaybe<TodoUsersHasTodoConnectionWhere>;
};

export type TodoWhere = {
  AND?: InputMaybe<Array<TodoWhere>>;
  NOT?: InputMaybe<TodoWhere>;
  OR?: InputMaybe<Array<TodoWhere>>;
  aiSummary?: InputMaybe<Scalars['String']['input']>;
  aiSummary_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  aiSummary_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  aiSummary_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aiSummary_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completed_date?: InputMaybe<Scalars['DateTime']['input']>;
  completed_date_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completed_date_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completed_date_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  completed_date_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completed_date_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  date_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  last_modified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  pointsReceived?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_GT?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_GTE?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  pointsReceived_LT?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_LTE?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  priority_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  priority_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  priority_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  priority_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  recurringDaily?: InputMaybe<Scalars['Boolean']['input']>;
  recurringDayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_GT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_GTE?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  recurringDayOfMonth_LT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_LTE?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek?: InputMaybe<Scalars['String']['input']>;
  recurringDayOfWeek_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  recurringDayOfWeek_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  recurringDayOfWeek_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recurringDayOfWeek_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  recurringFrequency?: InputMaybe<Scalars['String']['input']>;
  recurringFrequency_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  recurringFrequency_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  recurringFrequency_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recurringFrequency_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  recurringTime?: InputMaybe<Scalars['String']['input']>;
  recurringTime_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  recurringTime_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  recurringTime_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recurringTime_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  timeOfDay?: InputMaybe<Scalars['String']['input']>;
  timeOfDay_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  timeOfDay_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  timeOfDay_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeOfDay_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  timezone_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  timezone_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  timezone_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timezone_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  usersHasTodoAggregate?: InputMaybe<TodoUsersHasTodoAggregateInput>;
  /** Return Todos where all of the related TodoUsersHasTodoConnections match this filter */
  usersHasTodoConnection_ALL?: InputMaybe<TodoUsersHasTodoConnectionWhere>;
  /** Return Todos where none of the related TodoUsersHasTodoConnections match this filter */
  usersHasTodoConnection_NONE?: InputMaybe<TodoUsersHasTodoConnectionWhere>;
  /** Return Todos where one of the related TodoUsersHasTodoConnections match this filter */
  usersHasTodoConnection_SINGLE?: InputMaybe<TodoUsersHasTodoConnectionWhere>;
  /** Return Todos where some of the related TodoUsersHasTodoConnections match this filter */
  usersHasTodoConnection_SOME?: InputMaybe<TodoUsersHasTodoConnectionWhere>;
  /** Return Todos where all of the related Users match this filter */
  usersHasTodo_ALL?: InputMaybe<UserWhere>;
  /** Return Todos where none of the related Users match this filter */
  usersHasTodo_NONE?: InputMaybe<UserWhere>;
  /** Return Todos where one of the related Users match this filter */
  usersHasTodo_SINGLE?: InputMaybe<UserWhere>;
  /** Return Todos where some of the related Users match this filter */
  usersHasTodo_SOME?: InputMaybe<UserWhere>;
  workspacesHasTodoAggregate?: InputMaybe<TodoWorkspacesHasTodoAggregateInput>;
  /** Return Todos where all of the related TodoWorkspacesHasTodoConnections match this filter */
  workspacesHasTodoConnection_ALL?: InputMaybe<TodoWorkspacesHasTodoConnectionWhere>;
  /** Return Todos where none of the related TodoWorkspacesHasTodoConnections match this filter */
  workspacesHasTodoConnection_NONE?: InputMaybe<TodoWorkspacesHasTodoConnectionWhere>;
  /** Return Todos where one of the related TodoWorkspacesHasTodoConnections match this filter */
  workspacesHasTodoConnection_SINGLE?: InputMaybe<TodoWorkspacesHasTodoConnectionWhere>;
  /** Return Todos where some of the related TodoWorkspacesHasTodoConnections match this filter */
  workspacesHasTodoConnection_SOME?: InputMaybe<TodoWorkspacesHasTodoConnectionWhere>;
  /** Return Todos where all of the related Workspaces match this filter */
  workspacesHasTodo_ALL?: InputMaybe<WorkspaceWhere>;
  /** Return Todos where none of the related Workspaces match this filter */
  workspacesHasTodo_NONE?: InputMaybe<WorkspaceWhere>;
  /** Return Todos where one of the related Workspaces match this filter */
  workspacesHasTodo_SINGLE?: InputMaybe<WorkspaceWhere>;
  /** Return Todos where some of the related Workspaces match this filter */
  workspacesHasTodo_SOME?: InputMaybe<WorkspaceWhere>;
};

export type TodoWorkspaceWorkspacesHasTodoAggregationSelection = {
  __typename?: 'TodoWorkspaceWorkspacesHasTodoAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<TodoWorkspaceWorkspacesHasTodoNodeAggregateSelection>;
};

export type TodoWorkspaceWorkspacesHasTodoNodeAggregateSelection = {
  __typename?: 'TodoWorkspaceWorkspacesHasTodoNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  key: StringAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  name: StringAggregateSelection;
};

export type TodoWorkspacesHasTodoAggregateInput = {
  AND?: InputMaybe<Array<TodoWorkspacesHasTodoAggregateInput>>;
  NOT?: InputMaybe<TodoWorkspacesHasTodoAggregateInput>;
  OR?: InputMaybe<Array<TodoWorkspacesHasTodoAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TodoWorkspacesHasTodoNodeAggregationWhereInput>;
};

export type TodoWorkspacesHasTodoConnectFieldInput = {
  connect?: InputMaybe<Array<WorkspaceConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<WorkspaceConnectWhere>;
};

export type TodoWorkspacesHasTodoConnectOrCreateFieldInput = {
  onCreate: TodoWorkspacesHasTodoConnectOrCreateFieldInputOnCreate;
  where: WorkspaceConnectOrCreateWhere;
};

export type TodoWorkspacesHasTodoConnectOrCreateFieldInputOnCreate = {
  node: WorkspaceOnCreateInput;
};

export type TodoWorkspacesHasTodoConnection = {
  __typename?: 'TodoWorkspacesHasTodoConnection';
  edges: Array<TodoWorkspacesHasTodoRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TodoWorkspacesHasTodoConnectionSort = {
  node?: InputMaybe<WorkspaceSort>;
};

export type TodoWorkspacesHasTodoConnectionWhere = {
  AND?: InputMaybe<Array<TodoWorkspacesHasTodoConnectionWhere>>;
  NOT?: InputMaybe<TodoWorkspacesHasTodoConnectionWhere>;
  OR?: InputMaybe<Array<TodoWorkspacesHasTodoConnectionWhere>>;
  node?: InputMaybe<WorkspaceWhere>;
};

export type TodoWorkspacesHasTodoCreateFieldInput = {
  node: WorkspaceCreateInput;
};

export type TodoWorkspacesHasTodoDeleteFieldInput = {
  delete?: InputMaybe<WorkspaceDeleteInput>;
  where?: InputMaybe<TodoWorkspacesHasTodoConnectionWhere>;
};

export type TodoWorkspacesHasTodoDisconnectFieldInput = {
  disconnect?: InputMaybe<WorkspaceDisconnectInput>;
  where?: InputMaybe<TodoWorkspacesHasTodoConnectionWhere>;
};

export type TodoWorkspacesHasTodoFieldInput = {
  connect?: InputMaybe<Array<TodoWorkspacesHasTodoConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TodoWorkspacesHasTodoConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TodoWorkspacesHasTodoCreateFieldInput>>;
};

export type TodoWorkspacesHasTodoNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TodoWorkspacesHasTodoNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TodoWorkspacesHasTodoNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TodoWorkspacesHasTodoNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  key_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  key_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TodoWorkspacesHasTodoRelationship = {
  __typename?: 'TodoWorkspacesHasTodoRelationship';
  cursor: Scalars['String']['output'];
  node: Workspace;
};

export type TodoWorkspacesHasTodoUpdateConnectionInput = {
  node?: InputMaybe<WorkspaceUpdateInput>;
};

export type TodoWorkspacesHasTodoUpdateFieldInput = {
  connect?: InputMaybe<Array<TodoWorkspacesHasTodoConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TodoWorkspacesHasTodoConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TodoWorkspacesHasTodoCreateFieldInput>>;
  delete?: InputMaybe<Array<TodoWorkspacesHasTodoDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TodoWorkspacesHasTodoDisconnectFieldInput>>;
  update?: InputMaybe<TodoWorkspacesHasTodoUpdateConnectionInput>;
  where?: InputMaybe<TodoWorkspacesHasTodoConnectionWhere>;
};

export type TopActiveUser = {
  __typename?: 'TopActiveUser';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  totalSessions: Scalars['Int']['output'];
};

export type Topic = {
  __typename?: 'Topic';
  chapters: Array<Chapter>;
  chaptersAggregate?: Maybe<TopicChapterChaptersAggregationSelection>;
  chaptersConnection: TopicChaptersConnection;
  description?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isRelevant?: Maybe<Scalars['Boolean']['output']>;
  mastery?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  usersEnrolledIn: Array<User>;
  usersEnrolledInAggregate?: Maybe<TopicUserUsersEnrolledInAggregationSelection>;
  usersEnrolledInConnection: TopicUsersEnrolledInConnection;
  usersHasKnowledge: Array<User>;
  usersHasKnowledgeAggregate?: Maybe<TopicUserUsersHasKnowledgeAggregationSelection>;
  usersHasKnowledgeConnection: TopicUsersHasKnowledgeConnection;
};


export type TopicChaptersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ChapterOptions>;
  where?: InputMaybe<ChapterWhere>;
};


export type TopicChaptersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ChapterWhere>;
};


export type TopicChaptersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TopicChaptersConnectionSort>>;
  where?: InputMaybe<TopicChaptersConnectionWhere>;
};


export type TopicUsersEnrolledInArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type TopicUsersEnrolledInAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type TopicUsersEnrolledInConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TopicUsersEnrolledInConnectionSort>>;
  where?: InputMaybe<TopicUsersEnrolledInConnectionWhere>;
};


export type TopicUsersHasKnowledgeArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type TopicUsersHasKnowledgeAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type TopicUsersHasKnowledgeConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TopicUsersHasKnowledgeConnectionSort>>;
  where?: InputMaybe<TopicUsersHasKnowledgeConnectionWhere>;
};

export type TopicChapterChaptersAggregationSelection = {
  __typename?: 'TopicChapterChaptersAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<TopicChapterChaptersEdgeAggregateSelection>;
  node?: Maybe<TopicChapterChaptersNodeAggregateSelection>;
};

export type TopicChapterChaptersEdgeAggregateSelection = {
  __typename?: 'TopicChapterChaptersEdgeAggregateSelection';
  created: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
};

export type TopicChapterChaptersNodeAggregateSelection = {
  __typename?: 'TopicChapterChaptersNodeAggregateSelection';
  name: StringAggregateSelection;
};

export type TopicChaptersAggregateInput = {
  AND?: InputMaybe<Array<TopicChaptersAggregateInput>>;
  NOT?: InputMaybe<TopicChaptersAggregateInput>;
  OR?: InputMaybe<Array<TopicChaptersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasChapterPropertiesAggregationWhereInput>;
  node?: InputMaybe<TopicChaptersNodeAggregationWhereInput>;
};

export type TopicChaptersConnectFieldInput = {
  connect?: InputMaybe<Array<ChapterConnectInput>>;
  edge: HasChapterPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ChapterConnectWhere>;
};

export type TopicChaptersConnection = {
  __typename?: 'TopicChaptersConnection';
  edges: Array<TopicChaptersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TopicChaptersConnectionSort = {
  edge?: InputMaybe<HasChapterPropertiesSort>;
  node?: InputMaybe<ChapterSort>;
};

export type TopicChaptersConnectionWhere = {
  AND?: InputMaybe<Array<TopicChaptersConnectionWhere>>;
  NOT?: InputMaybe<TopicChaptersConnectionWhere>;
  OR?: InputMaybe<Array<TopicChaptersConnectionWhere>>;
  edge?: InputMaybe<HasChapterPropertiesWhere>;
  node?: InputMaybe<ChapterWhere>;
};

export type TopicChaptersCreateFieldInput = {
  edge: HasChapterPropertiesCreateInput;
  node: ChapterCreateInput;
};

export type TopicChaptersDeleteFieldInput = {
  delete?: InputMaybe<ChapterDeleteInput>;
  where?: InputMaybe<TopicChaptersConnectionWhere>;
};

export type TopicChaptersDisconnectFieldInput = {
  disconnect?: InputMaybe<ChapterDisconnectInput>;
  where?: InputMaybe<TopicChaptersConnectionWhere>;
};

export type TopicChaptersFieldInput = {
  connect?: InputMaybe<Array<TopicChaptersConnectFieldInput>>;
  create?: InputMaybe<Array<TopicChaptersCreateFieldInput>>;
};

export type TopicChaptersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TopicChaptersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TopicChaptersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TopicChaptersNodeAggregationWhereInput>>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TopicChaptersRelationship = {
  __typename?: 'TopicChaptersRelationship';
  cursor: Scalars['String']['output'];
  node: Chapter;
  properties: HasChapterProperties;
};

export type TopicChaptersUpdateConnectionInput = {
  edge?: InputMaybe<HasChapterPropertiesUpdateInput>;
  node?: InputMaybe<ChapterUpdateInput>;
};

export type TopicChaptersUpdateFieldInput = {
  connect?: InputMaybe<Array<TopicChaptersConnectFieldInput>>;
  create?: InputMaybe<Array<TopicChaptersCreateFieldInput>>;
  delete?: InputMaybe<Array<TopicChaptersDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TopicChaptersDisconnectFieldInput>>;
  update?: InputMaybe<TopicChaptersUpdateConnectionInput>;
  where?: InputMaybe<TopicChaptersConnectionWhere>;
};

export type TopicConnectInput = {
  chapters?: InputMaybe<Array<TopicChaptersConnectFieldInput>>;
  usersEnrolledIn?: InputMaybe<Array<TopicUsersEnrolledInConnectFieldInput>>;
  usersHasKnowledge?: InputMaybe<Array<TopicUsersHasKnowledgeConnectFieldInput>>;
};

export type TopicConnectWhere = {
  node: TopicWhere;
};

export type TopicCreateInput = {
  chapters?: InputMaybe<TopicChaptersFieldInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isRelevant?: InputMaybe<Scalars['Boolean']['input']>;
  mastery?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  usersEnrolledIn?: InputMaybe<TopicUsersEnrolledInFieldInput>;
  usersHasKnowledge?: InputMaybe<TopicUsersHasKnowledgeFieldInput>;
};

export type TopicDeleteInput = {
  chapters?: InputMaybe<Array<TopicChaptersDeleteFieldInput>>;
  usersEnrolledIn?: InputMaybe<Array<TopicUsersEnrolledInDeleteFieldInput>>;
  usersHasKnowledge?: InputMaybe<Array<TopicUsersHasKnowledgeDeleteFieldInput>>;
};

export type TopicDisconnectInput = {
  chapters?: InputMaybe<Array<TopicChaptersDisconnectFieldInput>>;
  usersEnrolledIn?: InputMaybe<Array<TopicUsersEnrolledInDisconnectFieldInput>>;
  usersHasKnowledge?: InputMaybe<Array<TopicUsersHasKnowledgeDisconnectFieldInput>>;
};

export type TopicOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TopicSort objects to sort Topics by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TopicSort>>;
};

/** Fields to sort Topics by. The order in which sorts are applied is not guaranteed when specifying many fields in one TopicSort object. */
export type TopicSort = {
  description?: InputMaybe<SortDirection>;
  imageUrl?: InputMaybe<SortDirection>;
  isRelevant?: InputMaybe<SortDirection>;
  mastery?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type TopicUpdateInput = {
  chapters?: InputMaybe<Array<TopicChaptersUpdateFieldInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isRelevant?: InputMaybe<Scalars['Boolean']['input']>;
  mastery?: InputMaybe<Scalars['Float']['input']>;
  mastery_ADD?: InputMaybe<Scalars['Float']['input']>;
  mastery_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  mastery_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  mastery_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  usersEnrolledIn?: InputMaybe<Array<TopicUsersEnrolledInUpdateFieldInput>>;
  usersHasKnowledge?: InputMaybe<Array<TopicUsersHasKnowledgeUpdateFieldInput>>;
};

export type TopicUserUsersEnrolledInAggregationSelection = {
  __typename?: 'TopicUserUsersEnrolledInAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<TopicUserUsersEnrolledInEdgeAggregateSelection>;
  node?: Maybe<TopicUserUsersEnrolledInNodeAggregateSelection>;
};

export type TopicUserUsersEnrolledInEdgeAggregateSelection = {
  __typename?: 'TopicUserUsersEnrolledInEdgeAggregateSelection';
  created: DateTimeAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
};

export type TopicUserUsersEnrolledInNodeAggregateSelection = {
  __typename?: 'TopicUserUsersEnrolledInNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type TopicUserUsersHasKnowledgeAggregationSelection = {
  __typename?: 'TopicUserUsersHasKnowledgeAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<TopicUserUsersHasKnowledgeEdgeAggregateSelection>;
  node?: Maybe<TopicUserUsersHasKnowledgeNodeAggregateSelection>;
};

export type TopicUserUsersHasKnowledgeEdgeAggregateSelection = {
  __typename?: 'TopicUserUsersHasKnowledgeEdgeAggregateSelection';
  created: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  total_mastery: FloatAggregateSelection;
};

export type TopicUserUsersHasKnowledgeNodeAggregateSelection = {
  __typename?: 'TopicUserUsersHasKnowledgeNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type TopicUsersEnrolledInAggregateInput = {
  AND?: InputMaybe<Array<TopicUsersEnrolledInAggregateInput>>;
  NOT?: InputMaybe<TopicUsersEnrolledInAggregateInput>;
  OR?: InputMaybe<Array<TopicUsersEnrolledInAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<EnrolledInPropertiesAggregationWhereInput>;
  node?: InputMaybe<TopicUsersEnrolledInNodeAggregationWhereInput>;
};

export type TopicUsersEnrolledInConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  edge: EnrolledInPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type TopicUsersEnrolledInConnectOrCreateFieldInput = {
  onCreate: TopicUsersEnrolledInConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type TopicUsersEnrolledInConnectOrCreateFieldInputOnCreate = {
  edge: EnrolledInPropertiesCreateInput;
  node: UserOnCreateInput;
};

export type TopicUsersEnrolledInConnection = {
  __typename?: 'TopicUsersEnrolledInConnection';
  edges: Array<TopicUsersEnrolledInRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TopicUsersEnrolledInConnectionSort = {
  edge?: InputMaybe<EnrolledInPropertiesSort>;
  node?: InputMaybe<UserSort>;
};

export type TopicUsersEnrolledInConnectionWhere = {
  AND?: InputMaybe<Array<TopicUsersEnrolledInConnectionWhere>>;
  NOT?: InputMaybe<TopicUsersEnrolledInConnectionWhere>;
  OR?: InputMaybe<Array<TopicUsersEnrolledInConnectionWhere>>;
  edge?: InputMaybe<EnrolledInPropertiesWhere>;
  node?: InputMaybe<UserWhere>;
};

export type TopicUsersEnrolledInCreateFieldInput = {
  edge: EnrolledInPropertiesCreateInput;
  node: UserCreateInput;
};

export type TopicUsersEnrolledInDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<TopicUsersEnrolledInConnectionWhere>;
};

export type TopicUsersEnrolledInDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<TopicUsersEnrolledInConnectionWhere>;
};

export type TopicUsersEnrolledInFieldInput = {
  connect?: InputMaybe<Array<TopicUsersEnrolledInConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TopicUsersEnrolledInConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TopicUsersEnrolledInCreateFieldInput>>;
};

export type TopicUsersEnrolledInNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TopicUsersEnrolledInNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TopicUsersEnrolledInNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TopicUsersEnrolledInNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TopicUsersEnrolledInRelationship = {
  __typename?: 'TopicUsersEnrolledInRelationship';
  cursor: Scalars['String']['output'];
  node: User;
  properties: EnrolledInProperties;
};

export type TopicUsersEnrolledInUpdateConnectionInput = {
  edge?: InputMaybe<EnrolledInPropertiesUpdateInput>;
  node?: InputMaybe<UserUpdateInput>;
};

export type TopicUsersEnrolledInUpdateFieldInput = {
  connect?: InputMaybe<Array<TopicUsersEnrolledInConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TopicUsersEnrolledInConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TopicUsersEnrolledInCreateFieldInput>>;
  delete?: InputMaybe<Array<TopicUsersEnrolledInDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TopicUsersEnrolledInDisconnectFieldInput>>;
  update?: InputMaybe<TopicUsersEnrolledInUpdateConnectionInput>;
  where?: InputMaybe<TopicUsersEnrolledInConnectionWhere>;
};

export type TopicUsersHasKnowledgeAggregateInput = {
  AND?: InputMaybe<Array<TopicUsersHasKnowledgeAggregateInput>>;
  NOT?: InputMaybe<TopicUsersHasKnowledgeAggregateInput>;
  OR?: InputMaybe<Array<TopicUsersHasKnowledgeAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasKnowledgePropertiesAggregationWhereInput>;
  node?: InputMaybe<TopicUsersHasKnowledgeNodeAggregationWhereInput>;
};

export type TopicUsersHasKnowledgeConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  edge: HasKnowledgePropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type TopicUsersHasKnowledgeConnectOrCreateFieldInput = {
  onCreate: TopicUsersHasKnowledgeConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type TopicUsersHasKnowledgeConnectOrCreateFieldInputOnCreate = {
  edge: HasKnowledgePropertiesCreateInput;
  node: UserOnCreateInput;
};

export type TopicUsersHasKnowledgeConnection = {
  __typename?: 'TopicUsersHasKnowledgeConnection';
  edges: Array<TopicUsersHasKnowledgeRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TopicUsersHasKnowledgeConnectionSort = {
  edge?: InputMaybe<HasKnowledgePropertiesSort>;
  node?: InputMaybe<UserSort>;
};

export type TopicUsersHasKnowledgeConnectionWhere = {
  AND?: InputMaybe<Array<TopicUsersHasKnowledgeConnectionWhere>>;
  NOT?: InputMaybe<TopicUsersHasKnowledgeConnectionWhere>;
  OR?: InputMaybe<Array<TopicUsersHasKnowledgeConnectionWhere>>;
  edge?: InputMaybe<HasKnowledgePropertiesWhere>;
  node?: InputMaybe<UserWhere>;
};

export type TopicUsersHasKnowledgeCreateFieldInput = {
  edge: HasKnowledgePropertiesCreateInput;
  node: UserCreateInput;
};

export type TopicUsersHasKnowledgeDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<TopicUsersHasKnowledgeConnectionWhere>;
};

export type TopicUsersHasKnowledgeDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<TopicUsersHasKnowledgeConnectionWhere>;
};

export type TopicUsersHasKnowledgeFieldInput = {
  connect?: InputMaybe<Array<TopicUsersHasKnowledgeConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TopicUsersHasKnowledgeConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TopicUsersHasKnowledgeCreateFieldInput>>;
};

export type TopicUsersHasKnowledgeNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TopicUsersHasKnowledgeNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TopicUsersHasKnowledgeNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TopicUsersHasKnowledgeNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TopicUsersHasKnowledgeRelationship = {
  __typename?: 'TopicUsersHasKnowledgeRelationship';
  cursor: Scalars['String']['output'];
  node: User;
  properties: HasKnowledgeProperties;
};

export type TopicUsersHasKnowledgeUpdateConnectionInput = {
  edge?: InputMaybe<HasKnowledgePropertiesUpdateInput>;
  node?: InputMaybe<UserUpdateInput>;
};

export type TopicUsersHasKnowledgeUpdateFieldInput = {
  connect?: InputMaybe<Array<TopicUsersHasKnowledgeConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<TopicUsersHasKnowledgeConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<TopicUsersHasKnowledgeCreateFieldInput>>;
  delete?: InputMaybe<Array<TopicUsersHasKnowledgeDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<TopicUsersHasKnowledgeDisconnectFieldInput>>;
  update?: InputMaybe<TopicUsersHasKnowledgeUpdateConnectionInput>;
  where?: InputMaybe<TopicUsersHasKnowledgeConnectionWhere>;
};

export type TopicWhere = {
  AND?: InputMaybe<Array<TopicWhere>>;
  NOT?: InputMaybe<TopicWhere>;
  OR?: InputMaybe<Array<TopicWhere>>;
  chaptersAggregate?: InputMaybe<TopicChaptersAggregateInput>;
  /** Return Topics where all of the related TopicChaptersConnections match this filter */
  chaptersConnection_ALL?: InputMaybe<TopicChaptersConnectionWhere>;
  /** Return Topics where none of the related TopicChaptersConnections match this filter */
  chaptersConnection_NONE?: InputMaybe<TopicChaptersConnectionWhere>;
  /** Return Topics where one of the related TopicChaptersConnections match this filter */
  chaptersConnection_SINGLE?: InputMaybe<TopicChaptersConnectionWhere>;
  /** Return Topics where some of the related TopicChaptersConnections match this filter */
  chaptersConnection_SOME?: InputMaybe<TopicChaptersConnectionWhere>;
  /** Return Topics where all of the related Chapters match this filter */
  chapters_ALL?: InputMaybe<ChapterWhere>;
  /** Return Topics where none of the related Chapters match this filter */
  chapters_NONE?: InputMaybe<ChapterWhere>;
  /** Return Topics where one of the related Chapters match this filter */
  chapters_SINGLE?: InputMaybe<ChapterWhere>;
  /** Return Topics where some of the related Chapters match this filter */
  chapters_SOME?: InputMaybe<ChapterWhere>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  imageUrl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  imageUrl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  imageUrl_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageUrl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  isRelevant?: InputMaybe<Scalars['Boolean']['input']>;
  mastery?: InputMaybe<Scalars['Float']['input']>;
  mastery_GT?: InputMaybe<Scalars['Float']['input']>;
  mastery_GTE?: InputMaybe<Scalars['Float']['input']>;
  mastery_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  mastery_LT?: InputMaybe<Scalars['Float']['input']>;
  mastery_LTE?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  usersEnrolledInAggregate?: InputMaybe<TopicUsersEnrolledInAggregateInput>;
  /** Return Topics where all of the related TopicUsersEnrolledInConnections match this filter */
  usersEnrolledInConnection_ALL?: InputMaybe<TopicUsersEnrolledInConnectionWhere>;
  /** Return Topics where none of the related TopicUsersEnrolledInConnections match this filter */
  usersEnrolledInConnection_NONE?: InputMaybe<TopicUsersEnrolledInConnectionWhere>;
  /** Return Topics where one of the related TopicUsersEnrolledInConnections match this filter */
  usersEnrolledInConnection_SINGLE?: InputMaybe<TopicUsersEnrolledInConnectionWhere>;
  /** Return Topics where some of the related TopicUsersEnrolledInConnections match this filter */
  usersEnrolledInConnection_SOME?: InputMaybe<TopicUsersEnrolledInConnectionWhere>;
  /** Return Topics where all of the related Users match this filter */
  usersEnrolledIn_ALL?: InputMaybe<UserWhere>;
  /** Return Topics where none of the related Users match this filter */
  usersEnrolledIn_NONE?: InputMaybe<UserWhere>;
  /** Return Topics where one of the related Users match this filter */
  usersEnrolledIn_SINGLE?: InputMaybe<UserWhere>;
  /** Return Topics where some of the related Users match this filter */
  usersEnrolledIn_SOME?: InputMaybe<UserWhere>;
  usersHasKnowledgeAggregate?: InputMaybe<TopicUsersHasKnowledgeAggregateInput>;
  /** Return Topics where all of the related TopicUsersHasKnowledgeConnections match this filter */
  usersHasKnowledgeConnection_ALL?: InputMaybe<TopicUsersHasKnowledgeConnectionWhere>;
  /** Return Topics where none of the related TopicUsersHasKnowledgeConnections match this filter */
  usersHasKnowledgeConnection_NONE?: InputMaybe<TopicUsersHasKnowledgeConnectionWhere>;
  /** Return Topics where one of the related TopicUsersHasKnowledgeConnections match this filter */
  usersHasKnowledgeConnection_SINGLE?: InputMaybe<TopicUsersHasKnowledgeConnectionWhere>;
  /** Return Topics where some of the related TopicUsersHasKnowledgeConnections match this filter */
  usersHasKnowledgeConnection_SOME?: InputMaybe<TopicUsersHasKnowledgeConnectionWhere>;
  /** Return Topics where all of the related Users match this filter */
  usersHasKnowledge_ALL?: InputMaybe<UserWhere>;
  /** Return Topics where none of the related Users match this filter */
  usersHasKnowledge_NONE?: InputMaybe<UserWhere>;
  /** Return Topics where one of the related Users match this filter */
  usersHasKnowledge_SINGLE?: InputMaybe<UserWhere>;
  /** Return Topics where some of the related Users match this filter */
  usersHasKnowledge_SOME?: InputMaybe<UserWhere>;
};

export type TrackOverview = {
  __typename?: 'TrackOverview';
  description?: Maybe<Scalars['String']['output']>;
  lessons?: Maybe<Array<Maybe<Lesson>>>;
  name?: Maybe<Scalars['String']['output']>;
  objectives?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  otherRequirements?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  otherRequirementsTitle?: Maybe<Scalars['String']['output']>;
  prerequisites?: Maybe<Array<Maybe<Prerequisite>>>;
  skillRequirements?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/**
 * The edge properties for the following fields:
 * * User.undefinedFoodItems
 * * User.undefinedWaterIntakes
 * * FoodItem.usersundefined
 * * WaterIntake.usersundefined
 */
export type UndefinedProperties = {
  __typename?: 'UndefinedProperties';
  created: Scalars['DateTime']['output'];
  isArchived: Scalars['Boolean']['output'];
  isPositive?: Maybe<Scalars['Boolean']['output']>;
  last_modified: Scalars['DateTime']['output'];
  quality: Scalars['BigInt']['output'];
  strength: Scalars['BigInt']['output'];
};

export type UndefinedPropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<UndefinedPropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<UndefinedPropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<UndefinedPropertiesAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  quality_AVERAGE_EQUAL?: InputMaybe<Scalars['BigInt']['input']>;
  quality_AVERAGE_GT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_AVERAGE_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  quality_AVERAGE_LT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_AVERAGE_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MAX_EQUAL?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MAX_GT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MAX_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MAX_LT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MAX_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MIN_EQUAL?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MIN_GT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MIN_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MIN_LT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_MIN_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  quality_SUM_EQUAL?: InputMaybe<Scalars['BigInt']['input']>;
  quality_SUM_GT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_SUM_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  quality_SUM_LT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_SUM_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_AVERAGE_EQUAL?: InputMaybe<Scalars['BigInt']['input']>;
  strength_AVERAGE_GT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_AVERAGE_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_AVERAGE_LT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_AVERAGE_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MAX_EQUAL?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MAX_GT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MAX_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MAX_LT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MAX_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MIN_EQUAL?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MIN_GT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MIN_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MIN_LT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_MIN_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_SUM_EQUAL?: InputMaybe<Scalars['BigInt']['input']>;
  strength_SUM_GT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_SUM_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_SUM_LT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_SUM_LTE?: InputMaybe<Scalars['BigInt']['input']>;
};

export type UndefinedPropertiesCreateInput = {
  created: Scalars['DateTime']['input'];
  isArchived: Scalars['Boolean']['input'];
  isPositive?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified: Scalars['DateTime']['input'];
  quality: Scalars['BigInt']['input'];
  strength: Scalars['BigInt']['input'];
};

export type UndefinedPropertiesSort = {
  created?: InputMaybe<SortDirection>;
  isArchived?: InputMaybe<SortDirection>;
  isPositive?: InputMaybe<SortDirection>;
  last_modified?: InputMaybe<SortDirection>;
  quality?: InputMaybe<SortDirection>;
  strength?: InputMaybe<SortDirection>;
};

export type UndefinedPropertiesUpdateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isPositive?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  quality?: InputMaybe<Scalars['BigInt']['input']>;
  quality_DECREMENT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_INCREMENT?: InputMaybe<Scalars['BigInt']['input']>;
  strength?: InputMaybe<Scalars['BigInt']['input']>;
  strength_DECREMENT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_INCREMENT?: InputMaybe<Scalars['BigInt']['input']>;
};

export type UndefinedPropertiesWhere = {
  AND?: InputMaybe<Array<UndefinedPropertiesWhere>>;
  NOT?: InputMaybe<UndefinedPropertiesWhere>;
  OR?: InputMaybe<Array<UndefinedPropertiesWhere>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isPositive?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  last_modified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  quality?: InputMaybe<Scalars['BigInt']['input']>;
  quality_GT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  quality_IN?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  quality_LT?: InputMaybe<Scalars['BigInt']['input']>;
  quality_LTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength?: InputMaybe<Scalars['BigInt']['input']>;
  strength_GT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_GTE?: InputMaybe<Scalars['BigInt']['input']>;
  strength_IN?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  strength_LT?: InputMaybe<Scalars['BigInt']['input']>;
  strength_LTE?: InputMaybe<Scalars['BigInt']['input']>;
};

export type UnifiedSubmission = {
  __typename?: 'UnifiedSubmission';
  courseCode?: Maybe<Scalars['String']['output']>;
  courseId: Scalars['ID']['output'];
  courseName: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  grade?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  maximumPoints?: Maybe<Scalars['Float']['output']>;
  moduleName: Scalars['String']['output'];
  retakeDeadline?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  student: StudentProperties;
  submissionTitle: Scalars['String']['output'];
  submissionType: Scalars['String']['output'];
  submittedOn?: Maybe<Scalars['DateTime']['output']>;
  submittedTime?: Maybe<Scalars['DateTime']['output']>;
};

export type UpdateAiTutorInput = {
  activityState?: InputMaybe<ActivityState>;
  context?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  objectives?: InputMaybe<Array<InputMaybe<ObjectiveInput>>>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  targetAudience?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  videoPool?: InputMaybe<Array<InputMaybe<VideoDataInput>>>;
  visualizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateAnnouncementInput = {
  audienceType: AudienceType;
  courseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  degreeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  schoolId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAssessmentSubmissionUpdatedGrade = {
  updatedEntityId: Scalars['ID']['input'];
  updatedEntityType: UpdatedEntityType;
  updatedFeedback?: InputMaybe<Scalars['String']['input']>;
  updatedGrade: Scalars['String']['input'];
};

export type UpdateAssignmentResponse = {
  __typename?: 'UpdateAssignmentResponse';
  data?: Maybe<Assignment>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateAxioResourceInput = {
  activityState?: InputMaybe<ActivityState>;
  description?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<FileInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompanionOnboardingResponse = {
  __typename?: 'UpdateCompanionOnboardingResponse';
  message?: Maybe<Scalars['String']['output']>;
  state?: Maybe<CompanionOnboardingState>;
  success: Scalars['Boolean']['output'];
};

export type UpdateContentModuleNameResponse = {
  __typename?: 'UpdateContentModuleNameResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateCourseDatesInput = {
  dueDateEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateCourseInput = {
  courseCode?: InputMaybe<Scalars['String']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isEnrollmentAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  moduleOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDegreeInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEnrollmentLinkInput = {
  expiresInDays: Scalars['Int']['input'];
  maxEnrollments: Scalars['Int']['input'];
};

export type UpdateFacultyProfileInput = {
  biography?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  meetingLink?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLastSeenPostInput = {
  postId: Scalars['ID']['input'];
  threadId: Scalars['ID']['input'];
};

export type UpdateMcqQuestionInput = {
  choices?: InputMaybe<Array<Scalars['String']['input']>>;
  correctChoiceIndices: Array<Scalars['Int']['input']>;
  explanation?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  totalScore?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateModuleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNoteInput = {
  content: Scalars['String']['input'];
};

export type UpdateNudgePreferencesInput = {
  emailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  frequency?: InputMaybe<NudgeFrequency>;
  maxEmailPerDay?: InputMaybe<Scalars['Int']['input']>;
  maxSmsPerDay?: InputMaybe<Scalars['Int']['input']>;
  preferredSendTime?: InputMaybe<Scalars['String']['input']>;
  smsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  snoozeAllUntil?: InputMaybe<Scalars['DateTime']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePageInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePostInput = {
  fileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProjectInput = {
  activityState?: InputMaybe<ActivityState>;
  assessmentCriteria?: InputMaybe<Array<Scalars['String']['input']>>;
  deliverableTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  expectedOutcomes?: InputMaybe<Array<Scalars['String']['input']>>;
  files?: InputMaybe<Array<FileInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  scopeDocument?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProjectRequirementInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  dependencies?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  estimatedHours?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Priority>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<RequirementType>;
};

export type UpdateProjectSubmissionInput = {
  approachMethodology?: InputMaybe<Scalars['String']['input']>;
  expectedOutcomes?: InputMaybe<Array<Scalars['String']['input']>>;
  proposal?: InputMaybe<Scalars['String']['input']>;
  scopeJustification?: InputMaybe<Scalars['String']['input']>;
  totalTasks?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateResourceOrderInput = {
  moduleId: Scalars['ID']['input'];
  resourceOrder: Array<Scalars['String']['input']>;
};

export type UpdateReviewInput = {
  activityState?: InputMaybe<ActivityState>;
  assessmentId?: InputMaybe<Scalars['ID']['input']>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateSocraticQuestionInput = {
  question?: InputMaybe<Scalars['String']['input']>;
  rubrics?: InputMaybe<Array<SocraticQuestionRubricInput>>;
  totalScore?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateStudentAssignmentGradeInput = {
  feedback?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Scalars['Float']['input']>;
  retakeAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  retakeDeadline?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateThreadInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTodoInput = {
  aiSummary?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completed_date?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  pointsReceived?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  recurringDaily?: InputMaybe<Scalars['Boolean']['input']>;
  recurringDayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek?: InputMaybe<Scalars['String']['input']>;
  recurringFrequency?: InputMaybe<Scalars['String']['input']>;
  recurringTime?: InputMaybe<Scalars['String']['input']>;
  timeOfDay?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateUserLearningPreferencesInput = {
  assignmentReminders?: InputMaybe<Scalars['Boolean']['input']>;
  careerInterests?: InputMaybe<Array<Scalars['String']['input']>>;
  checkInFrequency?: InputMaybe<CheckInFrequency>;
  consentToSms?: InputMaybe<Scalars['Boolean']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  learningStyles?: InputMaybe<Array<Scalars['String']['input']>>;
  motivations?: InputMaybe<Array<Scalars['String']['input']>>;
  semesterGoal?: InputMaybe<Scalars['String']['input']>;
  skillsToImprove?: InputMaybe<Array<Scalars['String']['input']>>;
  studyTimePreference?: InputMaybe<StudyTime>;
  textReminders?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateUserModalOnboardingResponse = {
  __typename?: 'UpdateUserModalOnboardingResponse';
  modalOnboarding?: Maybe<Scalars['String']['output']>;
};

export enum UpdatedEntityType {
  Question = 'QUESTION',
  Rubric = 'RUBRIC',
  Submission = 'SUBMISSION'
}

export type UploadFaviconResponse = {
  __typename?: 'UploadFaviconResponse';
  data?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type User = {
  __typename?: 'User';
  _empty?: Maybe<Scalars['String']['output']>;
  achievements: Array<Achievements>;
  achievementsAggregate?: Maybe<UserAchievementsAchievementsAggregationSelection>;
  achievementsConnection: UserAchievementsConnection;
  assessmentSubmissions: Array<AssessmentSubmission>;
  assessmentSubmissionsAggregate?: Maybe<UserAssessmentSubmissionAssessmentSubmissionsAggregationSelection>;
  assessmentSubmissionsConnection: UserAssessmentSubmissionsConnection;
  attributes: Array<Attribute>;
  attributesAggregate?: Maybe<UserAttributeAttributesAggregationSelection>;
  attributesConnection: UserAttributesConnection;
  audioOn?: Maybe<Scalars['Boolean']['output']>;
  auditEvents: Array<AuditEvent>;
  auditEventsAggregate?: Maybe<UserAuditEventAuditEventsAggregationSelection>;
  auditEventsConnection: UserAuditEventsConnection;
  authoredNotes: Array<Note>;
  authoredNotesAggregate?: Maybe<UserNoteAuthoredNotesAggregationSelection>;
  authoredNotesConnection: UserAuthoredNotesConnection;
  authoredPosts: Array<Post>;
  authoredPostsAggregate?: Maybe<UserPostAuthoredPostsAggregationSelection>;
  authoredPostsConnection: UserAuthoredPostsConnection;
  biography?: Maybe<Scalars['String']['output']>;
  birthday?: Maybe<Scalars['DateTime']['output']>;
  challenges?: Maybe<Array<Maybe<Challenge>>>;
  consentToSms?: Maybe<Scalars['Boolean']['output']>;
  coreValues?: Maybe<Array<Maybe<CoreValue>>>;
  countryCode?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  createdAnnouncements: Array<Announcement>;
  createdAnnouncementsAggregate?: Maybe<UserAnnouncementCreatedAnnouncementsAggregationSelection>;
  createdAnnouncementsConnection: UserCreatedAnnouncementsConnection;
  crmUserId?: Maybe<Scalars['String']['output']>;
  currentWeightLbs?: Maybe<Scalars['Float']['output']>;
  dailyEmailOptIn?: Maybe<Scalars['Boolean']['output']>;
  email: Scalars['String']['output'];
  emotionalStates?: Maybe<Array<Maybe<EmotionalState>>>;
  enrolledCourses: Array<Course>;
  enrolledCoursesAggregate?: Maybe<UserCourseEnrolledCoursesAggregationSelection>;
  enrolledCoursesConnection: UserEnrolledCoursesConnection;
  enrolledDegrees: Array<Degree>;
  enrolledDegreesAggregate?: Maybe<UserDegreeEnrolledDegreesAggregationSelection>;
  enrolledDegreesConnection: UserEnrolledDegreesConnection;
  enrolledInTopics: Array<Topic>;
  enrolledInTopicsAggregate?: Maybe<UserTopicEnrolledInTopicsAggregationSelection>;
  enrolledInTopicsConnection: UserEnrolledInTopicsConnection;
  enrolledTracks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  feedback?: Maybe<Feedback>;
  fullPhoneNumber?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  goalWeightLbs?: Maybe<Scalars['Float']['output']>;
  goals?: Maybe<Array<Maybe<Goal>>>;
  googleAuthTokens?: Maybe<Scalars['String']['output']>;
  googleCalendarAuthToken?: Maybe<Scalars['String']['output']>;
  hasChatChats: Array<Chat>;
  hasChatChatsAggregate?: Maybe<UserChatHasChatChatsAggregationSelection>;
  hasChatChatsConnection: UserHasChatChatsConnection;
  hasFile: Array<File>;
  hasFileAggregate?: Maybe<UserFileHasFileAggregationSelection>;
  hasFileConnection: UserHasFileConnection;
  hasFoodItemFoodItems: Array<FoodItem>;
  hasFoodItemFoodItemsAggregate?: Maybe<UserFoodItemHasFoodItemFoodItemsAggregationSelection>;
  hasFoodItemFoodItemsConnection: UserHasFoodItemFoodItemsConnection;
  hasKnowledgeChapters: Array<Chapter>;
  hasKnowledgeChaptersAggregate?: Maybe<UserChapterHasKnowledgeChaptersAggregationSelection>;
  hasKnowledgeChaptersConnection: UserHasKnowledgeChaptersConnection;
  hasKnowledgeSubchapters: Array<Subchapter>;
  hasKnowledgeSubchaptersAggregate?: Maybe<UserSubchapterHasKnowledgeSubchaptersAggregationSelection>;
  hasKnowledgeSubchaptersConnection: UserHasKnowledgeSubchaptersConnection;
  hasKnowledgeTopics: Array<Topic>;
  hasKnowledgeTopicsAggregate?: Maybe<UserTopicHasKnowledgeTopicsAggregationSelection>;
  hasKnowledgeTopicsConnection: UserHasKnowledgeTopicsConnection;
  hasLearningPreferences?: Maybe<UserLearningPreferences>;
  hasLearningPreferencesAggregate?: Maybe<UserUserLearningPreferencesHasLearningPreferencesAggregationSelection>;
  hasLearningPreferencesConnection: UserHasLearningPreferencesConnection;
  hasPaymentPayments: Array<Payment>;
  hasPaymentPaymentsAggregate?: Maybe<UserPaymentHasPaymentPaymentsAggregationSelection>;
  hasPaymentPaymentsConnection: UserHasPaymentPaymentsConnection;
  hasPreferencesPreferences: Array<Preferences>;
  hasPreferencesPreferencesAggregate?: Maybe<UserPreferencesHasPreferencesPreferencesAggregationSelection>;
  hasPreferencesPreferencesConnection: UserHasPreferencesPreferencesConnection;
  hasProgress: Array<Progress>;
  hasProgressAggregate?: Maybe<UserProgressHasProgressAggregationSelection>;
  hasProgressConnection: UserHasProgressConnection;
  hasReviews: Array<AiTutor>;
  hasReviewsAggregate?: Maybe<UserAiTutorHasReviewsAggregationSelection>;
  hasReviewsConnection: UserHasReviewsConnection;
  hasRoleRoles: Array<Role>;
  hasRoleRolesAggregate?: Maybe<UserRoleHasRoleRolesAggregationSelection>;
  hasRoleRolesConnection: UserHasRoleRolesConnection;
  hasRosterExport: Array<File>;
  hasRosterExportAggregate?: Maybe<UserFileHasRosterExportAggregationSelection>;
  hasRosterExportConnection: UserHasRosterExportConnection;
  hasSessionDeviceSessions: Array<DeviceSession>;
  hasSessionDeviceSessionsAggregate?: Maybe<UserDeviceSessionHasSessionDeviceSessionsAggregationSelection>;
  hasSessionDeviceSessionsConnection: UserHasSessionDeviceSessionsConnection;
  hasSubmissionExport: Array<File>;
  hasSubmissionExportAggregate?: Maybe<UserFileHasSubmissionExportAggregationSelection>;
  hasSubmissionExportConnection: UserHasSubmissionExportConnection;
  hasSubmitted: Array<Submission>;
  hasSubmittedAggregate?: Maybe<UserSubmissionHasSubmittedAggregationSelection>;
  hasSubmittedConnection: UserHasSubmittedConnection;
  hasSuggestionSuggestions: Array<Suggestion>;
  hasSuggestionSuggestionsAggregate?: Maybe<UserSuggestionHasSuggestionSuggestionsAggregationSelection>;
  hasSuggestionSuggestionsConnection: UserHasSuggestionSuggestionsConnection;
  hasSummaryDailySummaries: Array<DailySummary>;
  hasSummaryDailySummariesAggregate?: Maybe<UserDailySummaryHasSummaryDailySummariesAggregationSelection>;
  hasSummaryDailySummariesConnection: UserHasSummaryDailySummariesConnection;
  hasSummaryMonthlySummaries: Array<MonthlySummary>;
  hasSummaryMonthlySummariesAggregate?: Maybe<UserMonthlySummaryHasSummaryMonthlySummariesAggregationSelection>;
  hasSummaryMonthlySummariesConnection: UserHasSummaryMonthlySummariesConnection;
  hasSummaryQuarterlySummaries: Array<QuarterlySummary>;
  hasSummaryQuarterlySummariesAggregate?: Maybe<UserQuarterlySummaryHasSummaryQuarterlySummariesAggregationSelection>;
  hasSummaryQuarterlySummariesConnection: UserHasSummaryQuarterlySummariesConnection;
  hasSummaryWeeklySummaries: Array<WeeklySummary>;
  hasSummaryWeeklySummariesAggregate?: Maybe<UserWeeklySummaryHasSummaryWeeklySummariesAggregationSelection>;
  hasSummaryWeeklySummariesConnection: UserHasSummaryWeeklySummariesConnection;
  hasSummaryYearlySummaries: Array<YearlySummary>;
  hasSummaryYearlySummariesAggregate?: Maybe<UserYearlySummaryHasSummaryYearlySummariesAggregationSelection>;
  hasSummaryYearlySummariesConnection: UserHasSummaryYearlySummariesConnection;
  hasVisitSessions: Array<VisitSession>;
  hasVisitSessionsAggregate?: Maybe<UserVisitSessionHasVisitSessionsAggregationSelection>;
  hasVisitSessionsConnection: UserHasVisitSessionsConnection;
  hasWaterIntakeWaterIntakes: Array<WaterIntake>;
  hasWaterIntakeWaterIntakesAggregate?: Maybe<UserWaterIntakeHasWaterIntakeWaterIntakesAggregationSelection>;
  hasWaterIntakeWaterIntakesConnection: UserHasWaterIntakeWaterIntakesConnection;
  hasWhitelistedEmails: Array<WhitelistedEmail>;
  hasWhitelistedEmailsAggregate?: Maybe<UserWhitelistedEmailHasWhitelistedEmailsAggregationSelection>;
  hasWhitelistedEmailsConnection: UserHasWhitelistedEmailsConnection;
  hasWorkspaces: Array<Workspace>;
  hasWorkspacesAggregate?: Maybe<UserWorkspaceHasWorkspacesAggregationSelection>;
  hasWorkspacesConnection: UserHasWorkspacesConnection;
  hobbies?: Maybe<Array<Maybe<Hobby>>>;
  id: Scalars['ID']['output'];
  interests?: Maybe<Array<Maybe<Interest>>>;
  invitationToken?: Maybe<Scalars['String']['output']>;
  invitationTokenExpiry?: Maybe<Scalars['DateTime']['output']>;
  inviteCount?: Maybe<Scalars['Int']['output']>;
  isCareerLoading?: Maybe<Scalars['Boolean']['output']>;
  isCourseLoading?: Maybe<Scalars['Boolean']['output']>;
  isEmailVerified?: Maybe<Scalars['Boolean']['output']>;
  isOnboarded?: Maybe<Scalars['Boolean']['output']>;
  isPhoneVerified?: Maybe<Scalars['Boolean']['output']>;
  isPro?: Maybe<Scalars['Boolean']['output']>;
  learningPayments: Array<LearningPayment>;
  learningPaymentsAggregate?: Maybe<UserLearningPaymentLearningPaymentsAggregationSelection>;
  learningPaymentsConnection: UserLearningPaymentsConnection;
  lessons?: Maybe<Array<Maybe<Lesson>>>;
  lifeAspirations?: Maybe<Array<Maybe<LifeAspiration>>>;
  meetingLink?: Maybe<Scalars['String']['output']>;
  modalOnboarding?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  needsResolution?: Maybe<Scalars['Boolean']['output']>;
  notes: Array<Note>;
  notesAggregate?: Maybe<UserNoteNotesAggregationSelection>;
  notesConnection: UserNotesConnection;
  nudgePreferences?: Maybe<NudgePreferences>;
  nudgePreferencesAggregate?: Maybe<UserNudgePreferencesNudgePreferencesAggregationSelection>;
  nudgePreferencesConnection: UserNudgePreferencesConnection;
  nudges: Array<Nudge>;
  nudgesAboutThis: Array<Nudge>;
  nudgesAboutThisAggregate?: Maybe<UserNudgeNudgesAboutThisAggregationSelection>;
  nudgesAboutThisConnection: UserNudgesAboutThisConnection;
  nudgesAggregate?: Maybe<UserNudgeNudgesAggregationSelection>;
  nudgesConnection: UserNudgesConnection;
  otpPreference?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  passwordResetToken?: Maybe<Scalars['String']['output']>;
  passwordResetTokenExpiry?: Maybe<Scalars['DateTime']['output']>;
  pendingCourseEnrollmentInvite?: Maybe<Scalars['Boolean']['output']>;
  pendingEmail?: Maybe<Scalars['String']['output']>;
  pendingFacultyInvite?: Maybe<Scalars['Boolean']['output']>;
  personalityTraits?: Maybe<Array<Maybe<PersonalityTrait>>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<Preferences>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Progress>;
  reflections?: Maybe<Array<Maybe<Reflection>>>;
  reviewAITutorBeingGeneratedFor: Array<Review>;
  reviewAITutorBeingGeneratedForAggregate?: Maybe<UserReviewReviewAiTutorBeingGeneratedForAggregationSelection>;
  reviewAITutorBeingGeneratedForConnection: UserReviewAiTutorBeingGeneratedForConnection;
  schoolAssignments: Array<Assignment>;
  schoolAssignmentsAggregate?: Maybe<UserAssignmentSchoolAssignmentsAggregationSelection>;
  schoolAssignmentsConnection: UserSchoolAssignmentsConnection;
  schools: Array<School>;
  schoolsAggregate?: Maybe<UserSchoolSchoolsAggregationSelection>;
  schoolsConnection: UserSchoolsConnection;
  seenAnnouncements: Array<Announcement>;
  seenAnnouncementsAggregate?: Maybe<UserAnnouncementSeenAnnouncementsAggregationSelection>;
  seenAnnouncementsConnection: UserSeenAnnouncementsConnection;
  showLearningActivityIntro?: Maybe<Scalars['Boolean']['output']>;
  skipAllNotificationEmail?: Maybe<Scalars['Boolean']['output']>;
  ssoId?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripeCustomerIdLearningPayments?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subjectUser?: Maybe<User>;
  subjectUserAggregate?: Maybe<UserUserSubjectUserAggregationSelection>;
  subjectUserConnection: UserSubjectUserConnection;
  subscribedThreads: Array<Thread>;
  subscribedThreadsAggregate?: Maybe<UserThreadSubscribedThreadsAggregationSelection>;
  subscribedThreadsConnection: UserSubscribedThreadsConnection;
  teachingCourses: Array<Course>;
  teachingCoursesAggregate?: Maybe<UserCourseTeachingCoursesAggregationSelection>;
  teachingCoursesConnection: UserTeachingCoursesConnection;
  tenants: Array<Tenant>;
  tenantsAggregate?: Maybe<UserTenantTenantsAggregationSelection>;
  tenantsConnection: UserTenantsConnection;
  threadReadStates: Array<Thread>;
  threadReadStatesAggregate?: Maybe<UserThreadThreadReadStatesAggregationSelection>;
  threadReadStatesConnection: UserThreadReadStatesConnection;
  todos: Array<Todo>;
  todosAggregate?: Maybe<UserTodoTodosAggregationSelection>;
  todosConnection: UserTodosConnection;
  trialEndDate?: Maybe<Scalars['DateTime']['output']>;
  undefinedFoodItems: Array<FoodItem>;
  undefinedFoodItemsAggregate?: Maybe<UserFoodItemUndefinedFoodItemsAggregationSelection>;
  undefinedFoodItemsConnection: UserUndefinedFoodItemsConnection;
  undefinedWaterIntakes: Array<WaterIntake>;
  undefinedWaterIntakesAggregate?: Maybe<UserWaterIntakeUndefinedWaterIntakesAggregationSelection>;
  undefinedWaterIntakesConnection: UserUndefinedWaterIntakesConnection;
  username?: Maybe<Scalars['String']['output']>;
  watchedIntroVideo?: Maybe<Scalars['Boolean']['output']>;
};


export type UserAchievementsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AchievementsOptions>;
  where?: InputMaybe<AchievementsWhere>;
};


export type UserAchievementsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AchievementsWhere>;
};


export type UserAchievementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserAchievementsConnectionSort>>;
  where?: InputMaybe<UserAchievementsConnectionWhere>;
};


export type UserAssessmentSubmissionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AssessmentSubmissionOptions>;
  where?: InputMaybe<AssessmentSubmissionWhere>;
};


export type UserAssessmentSubmissionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssessmentSubmissionWhere>;
};


export type UserAssessmentSubmissionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserAssessmentSubmissionsConnectionSort>>;
  where?: InputMaybe<UserAssessmentSubmissionsConnectionWhere>;
};


export type UserAttributesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AttributeOptions>;
  where?: InputMaybe<AttributeWhere>;
};


export type UserAttributesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AttributeWhere>;
};


export type UserAttributesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserAttributesConnectionSort>>;
  where?: InputMaybe<UserAttributesConnectionWhere>;
};


export type UserAuditEventsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AuditEventOptions>;
  where?: InputMaybe<AuditEventWhere>;
};


export type UserAuditEventsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AuditEventWhere>;
};


export type UserAuditEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserAuditEventsConnectionSort>>;
  where?: InputMaybe<UserAuditEventsConnectionWhere>;
};


export type UserAuthoredNotesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<NoteOptions>;
  where?: InputMaybe<NoteWhere>;
};


export type UserAuthoredNotesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NoteWhere>;
};


export type UserAuthoredNotesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserAuthoredNotesConnectionSort>>;
  where?: InputMaybe<UserAuthoredNotesConnectionWhere>;
};


export type UserAuthoredPostsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PostOptions>;
  where?: InputMaybe<PostWhere>;
};


export type UserAuthoredPostsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PostWhere>;
};


export type UserAuthoredPostsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserAuthoredPostsConnectionSort>>;
  where?: InputMaybe<UserAuthoredPostsConnectionWhere>;
};


export type UserCreatedAnnouncementsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AnnouncementOptions>;
  where?: InputMaybe<AnnouncementWhere>;
};


export type UserCreatedAnnouncementsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnnouncementWhere>;
};


export type UserCreatedAnnouncementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserCreatedAnnouncementsConnectionSort>>;
  where?: InputMaybe<UserCreatedAnnouncementsConnectionWhere>;
};


export type UserEnrolledCoursesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CourseOptions>;
  where?: InputMaybe<CourseWhere>;
};


export type UserEnrolledCoursesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CourseWhere>;
};


export type UserEnrolledCoursesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserEnrolledCoursesConnectionSort>>;
  where?: InputMaybe<UserEnrolledCoursesConnectionWhere>;
};


export type UserEnrolledDegreesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DegreeOptions>;
  where?: InputMaybe<DegreeWhere>;
};


export type UserEnrolledDegreesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DegreeWhere>;
};


export type UserEnrolledDegreesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserEnrolledDegreesConnectionSort>>;
  where?: InputMaybe<UserEnrolledDegreesConnectionWhere>;
};


export type UserEnrolledInTopicsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TopicOptions>;
  where?: InputMaybe<TopicWhere>;
};


export type UserEnrolledInTopicsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TopicWhere>;
};


export type UserEnrolledInTopicsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserEnrolledInTopicsConnectionSort>>;
  where?: InputMaybe<UserEnrolledInTopicsConnectionWhere>;
};


export type UserHasChatChatsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ChatOptions>;
  where?: InputMaybe<ChatWhere>;
};


export type UserHasChatChatsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ChatWhere>;
};


export type UserHasChatChatsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserHasChatChatsConnectionSort>>;
  where?: InputMaybe<UserHasChatChatsConnectionWhere>;
};


export type UserHasFileArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FileOptions>;
  where?: InputMaybe<FileWhere>;
};


export type UserHasFileAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FileWhere>;
};


export type UserHasFileConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserHasFileConnectionSort>>;
  where?: InputMaybe<UserHasFileConnectionWhere>;
};


export type UserHasFoodItemFoodItemsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FoodItemOptions>;
  where?: InputMaybe<FoodItemWhere>;
};


export type UserHasFoodItemFoodItemsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FoodItemWhere>;
};


export type UserHasFoodItemFoodItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserHasFoodItemFoodItemsConnectionSort>>;
  where?: InputMaybe<UserHasFoodItemFoodItemsConnectionWhere>;
};


export type UserHasKnowledgeChaptersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ChapterOptions>;
  where?: InputMaybe<ChapterWhere>;
};


export type UserHasKnowledgeChaptersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ChapterWhere>;
};


export type UserHasKnowledgeChaptersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserHasKnowledgeChaptersConnectionSort>>;
  where?: InputMaybe<UserHasKnowledgeChaptersConnectionWhere>;
};


export type UserHasKnowledgeSubchaptersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SubchapterOptions>;
  where?: InputMaybe<SubchapterWhere>;
};


export type UserHasKnowledgeSubchaptersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SubchapterWhere>;
};


export type UserHasKnowledgeSubchaptersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserHasKnowledgeSubchaptersConnectionSort>>;
  where?: InputMaybe<UserHasKnowledgeSubchaptersConnectionWhere>;
};


export type UserHasKnowledgeTopicsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TopicOptions>;
  where?: InputMaybe<TopicWhere>;
};


export type UserHasKnowledgeTopicsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TopicWhere>;
};


export type UserHasKnowledgeTopicsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserHasKnowledgeTopicsConnectionSort>>;
  where?: InputMaybe<UserHasKnowledgeTopicsConnectionWhere>;
};


export type UserHasLearningPreferencesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserLearningPreferencesOptions>;
  where?: InputMaybe<UserLearningPreferencesWhere>;
};


export type UserHasLearningPreferencesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserLearningPreferencesWhere>;
};


export type UserHasLearningPreferencesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserHasLearningPreferencesConnectionSort>>;
  where?: InputMaybe<UserHasLearningPreferencesConnectionWhere>;
};


export type UserHasPaymentPaymentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PaymentOptions>;
  where?: InputMaybe<PaymentWhere>;
};


export type UserHasPaymentPaymentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PaymentWhere>;
};


export type UserHasPaymentPaymentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserHasPaymentPaymentsConnectionSort>>;
  where?: InputMaybe<UserHasPaymentPaymentsConnectionWhere>;
};


export type UserHasPreferencesPreferencesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PreferencesOptions>;
  where?: InputMaybe<PreferencesWhere>;
};


export type UserHasPreferencesPreferencesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PreferencesWhere>;
};


export type UserHasPreferencesPreferencesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserHasPreferencesPreferencesConnectionSort>>;
  where?: InputMaybe<UserHasPreferencesPreferencesConnectionWhere>;
};


export type UserHasProgressArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProgressOptions>;
  where?: InputMaybe<ProgressWhere>;
};


export type UserHasProgressAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProgressWhere>;
};


export type UserHasProgressConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserHasProgressConnectionSort>>;
  where?: InputMaybe<UserHasProgressConnectionWhere>;
};


export type UserHasReviewsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AiTutorOptions>;
  where?: InputMaybe<AiTutorWhere>;
};


export type UserHasReviewsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AiTutorWhere>;
};


export type UserHasReviewsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserHasReviewsConnectionSort>>;
  where?: InputMaybe<UserHasReviewsConnectionWhere>;
};


export type UserHasRoleRolesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RoleOptions>;
  where?: InputMaybe<RoleWhere>;
};


export type UserHasRoleRolesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RoleWhere>;
};


export type UserHasRoleRolesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserHasRoleRolesConnectionSort>>;
  where?: InputMaybe<UserHasRoleRolesConnectionWhere>;
};


export type UserHasRosterExportArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FileOptions>;
  where?: InputMaybe<FileWhere>;
};


export type UserHasRosterExportAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FileWhere>;
};


export type UserHasRosterExportConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserHasRosterExportConnectionSort>>;
  where?: InputMaybe<UserHasRosterExportConnectionWhere>;
};


export type UserHasSessionDeviceSessionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DeviceSessionOptions>;
  where?: InputMaybe<DeviceSessionWhere>;
};


export type UserHasSessionDeviceSessionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DeviceSessionWhere>;
};


export type UserHasSessionDeviceSessionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserHasSessionDeviceSessionsConnectionSort>>;
  where?: InputMaybe<UserHasSessionDeviceSessionsConnectionWhere>;
};


export type UserHasSubmissionExportArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FileOptions>;
  where?: InputMaybe<FileWhere>;
};


export type UserHasSubmissionExportAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FileWhere>;
};


export type UserHasSubmissionExportConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserHasSubmissionExportConnectionSort>>;
  where?: InputMaybe<UserHasSubmissionExportConnectionWhere>;
};


export type UserHasSubmittedArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SubmissionOptions>;
  where?: InputMaybe<SubmissionWhere>;
};


export type UserHasSubmittedAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SubmissionWhere>;
};


export type UserHasSubmittedConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserHasSubmittedConnectionSort>>;
  where?: InputMaybe<UserHasSubmittedConnectionWhere>;
};


export type UserHasSuggestionSuggestionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SuggestionOptions>;
  where?: InputMaybe<SuggestionWhere>;
};


export type UserHasSuggestionSuggestionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SuggestionWhere>;
};


export type UserHasSuggestionSuggestionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserHasSuggestionSuggestionsConnectionSort>>;
  where?: InputMaybe<UserHasSuggestionSuggestionsConnectionWhere>;
};


export type UserHasSummaryDailySummariesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DailySummaryOptions>;
  where?: InputMaybe<DailySummaryWhere>;
};


export type UserHasSummaryDailySummariesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DailySummaryWhere>;
};


export type UserHasSummaryDailySummariesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserHasSummaryDailySummariesConnectionSort>>;
  where?: InputMaybe<UserHasSummaryDailySummariesConnectionWhere>;
};


export type UserHasSummaryMonthlySummariesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<MonthlySummaryOptions>;
  where?: InputMaybe<MonthlySummaryWhere>;
};


export type UserHasSummaryMonthlySummariesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MonthlySummaryWhere>;
};


export type UserHasSummaryMonthlySummariesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserHasSummaryMonthlySummariesConnectionSort>>;
  where?: InputMaybe<UserHasSummaryMonthlySummariesConnectionWhere>;
};


export type UserHasSummaryQuarterlySummariesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QuarterlySummaryOptions>;
  where?: InputMaybe<QuarterlySummaryWhere>;
};


export type UserHasSummaryQuarterlySummariesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QuarterlySummaryWhere>;
};


export type UserHasSummaryQuarterlySummariesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserHasSummaryQuarterlySummariesConnectionSort>>;
  where?: InputMaybe<UserHasSummaryQuarterlySummariesConnectionWhere>;
};


export type UserHasSummaryWeeklySummariesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<WeeklySummaryOptions>;
  where?: InputMaybe<WeeklySummaryWhere>;
};


export type UserHasSummaryWeeklySummariesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WeeklySummaryWhere>;
};


export type UserHasSummaryWeeklySummariesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserHasSummaryWeeklySummariesConnectionSort>>;
  where?: InputMaybe<UserHasSummaryWeeklySummariesConnectionWhere>;
};


export type UserHasSummaryYearlySummariesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<YearlySummaryOptions>;
  where?: InputMaybe<YearlySummaryWhere>;
};


export type UserHasSummaryYearlySummariesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<YearlySummaryWhere>;
};


export type UserHasSummaryYearlySummariesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserHasSummaryYearlySummariesConnectionSort>>;
  where?: InputMaybe<UserHasSummaryYearlySummariesConnectionWhere>;
};


export type UserHasVisitSessionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<VisitSessionOptions>;
  where?: InputMaybe<VisitSessionWhere>;
};


export type UserHasVisitSessionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<VisitSessionWhere>;
};


export type UserHasVisitSessionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserHasVisitSessionsConnectionSort>>;
  where?: InputMaybe<UserHasVisitSessionsConnectionWhere>;
};


export type UserHasWaterIntakeWaterIntakesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<WaterIntakeOptions>;
  where?: InputMaybe<WaterIntakeWhere>;
};


export type UserHasWaterIntakeWaterIntakesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WaterIntakeWhere>;
};


export type UserHasWaterIntakeWaterIntakesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserHasWaterIntakeWaterIntakesConnectionSort>>;
  where?: InputMaybe<UserHasWaterIntakeWaterIntakesConnectionWhere>;
};


export type UserHasWhitelistedEmailsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<WhitelistedEmailOptions>;
  where?: InputMaybe<WhitelistedEmailWhere>;
};


export type UserHasWhitelistedEmailsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WhitelistedEmailWhere>;
};


export type UserHasWhitelistedEmailsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserHasWhitelistedEmailsConnectionSort>>;
  where?: InputMaybe<UserHasWhitelistedEmailsConnectionWhere>;
};


export type UserHasWorkspacesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<WorkspaceOptions>;
  where?: InputMaybe<WorkspaceWhere>;
};


export type UserHasWorkspacesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WorkspaceWhere>;
};


export type UserHasWorkspacesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserHasWorkspacesConnectionSort>>;
  where?: InputMaybe<UserHasWorkspacesConnectionWhere>;
};


export type UserLearningPaymentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LearningPaymentOptions>;
  where?: InputMaybe<LearningPaymentWhere>;
};


export type UserLearningPaymentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LearningPaymentWhere>;
};


export type UserLearningPaymentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserLearningPaymentsConnectionSort>>;
  where?: InputMaybe<UserLearningPaymentsConnectionWhere>;
};


export type UserNotesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<NoteOptions>;
  where?: InputMaybe<NoteWhere>;
};


export type UserNotesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NoteWhere>;
};


export type UserNotesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserNotesConnectionSort>>;
  where?: InputMaybe<UserNotesConnectionWhere>;
};


export type UserNudgePreferencesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<NudgePreferencesOptions>;
  where?: InputMaybe<NudgePreferencesWhere>;
};


export type UserNudgePreferencesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NudgePreferencesWhere>;
};


export type UserNudgePreferencesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserNudgePreferencesConnectionSort>>;
  where?: InputMaybe<UserNudgePreferencesConnectionWhere>;
};


export type UserNudgesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<NudgeOptions>;
  where?: InputMaybe<NudgeWhere>;
};


export type UserNudgesAboutThisArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<NudgeOptions>;
  where?: InputMaybe<NudgeWhere>;
};


export type UserNudgesAboutThisAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NudgeWhere>;
};


export type UserNudgesAboutThisConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserNudgesAboutThisConnectionSort>>;
  where?: InputMaybe<UserNudgesAboutThisConnectionWhere>;
};


export type UserNudgesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NudgeWhere>;
};


export type UserNudgesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserNudgesConnectionSort>>;
  where?: InputMaybe<UserNudgesConnectionWhere>;
};


export type UserReviewAiTutorBeingGeneratedForArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ReviewOptions>;
  where?: InputMaybe<ReviewWhere>;
};


export type UserReviewAiTutorBeingGeneratedForAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ReviewWhere>;
};


export type UserReviewAiTutorBeingGeneratedForConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserReviewAiTutorBeingGeneratedForConnectionSort>>;
  where?: InputMaybe<UserReviewAiTutorBeingGeneratedForConnectionWhere>;
};


export type UserSchoolAssignmentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AssignmentOptions>;
  where?: InputMaybe<AssignmentWhere>;
};


export type UserSchoolAssignmentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssignmentWhere>;
};


export type UserSchoolAssignmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserSchoolAssignmentsConnectionSort>>;
  where?: InputMaybe<UserSchoolAssignmentsConnectionWhere>;
};


export type UserSchoolsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SchoolOptions>;
  where?: InputMaybe<SchoolWhere>;
};


export type UserSchoolsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SchoolWhere>;
};


export type UserSchoolsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserSchoolsConnectionSort>>;
  where?: InputMaybe<UserSchoolsConnectionWhere>;
};


export type UserSeenAnnouncementsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AnnouncementOptions>;
  where?: InputMaybe<AnnouncementWhere>;
};


export type UserSeenAnnouncementsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnnouncementWhere>;
};


export type UserSeenAnnouncementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserSeenAnnouncementsConnectionSort>>;
  where?: InputMaybe<UserSeenAnnouncementsConnectionWhere>;
};


export type UserSubjectUserArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type UserSubjectUserAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type UserSubjectUserConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserSubjectUserConnectionSort>>;
  where?: InputMaybe<UserSubjectUserConnectionWhere>;
};


export type UserSubscribedThreadsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ThreadOptions>;
  where?: InputMaybe<ThreadWhere>;
};


export type UserSubscribedThreadsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ThreadWhere>;
};


export type UserSubscribedThreadsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserSubscribedThreadsConnectionSort>>;
  where?: InputMaybe<UserSubscribedThreadsConnectionWhere>;
};


export type UserTeachingCoursesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CourseOptions>;
  where?: InputMaybe<CourseWhere>;
};


export type UserTeachingCoursesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CourseWhere>;
};


export type UserTeachingCoursesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserTeachingCoursesConnectionSort>>;
  where?: InputMaybe<UserTeachingCoursesConnectionWhere>;
};


export type UserTenantsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TenantOptions>;
  where?: InputMaybe<TenantWhere>;
};


export type UserTenantsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TenantWhere>;
};


export type UserTenantsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserTenantsConnectionSort>>;
  where?: InputMaybe<UserTenantsConnectionWhere>;
};


export type UserThreadReadStatesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ThreadOptions>;
  where?: InputMaybe<ThreadWhere>;
};


export type UserThreadReadStatesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ThreadWhere>;
};


export type UserThreadReadStatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserThreadReadStatesConnectionSort>>;
  where?: InputMaybe<UserThreadReadStatesConnectionWhere>;
};


export type UserTodosArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TodoOptions>;
  where?: InputMaybe<TodoWhere>;
};


export type UserTodosAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TodoWhere>;
};


export type UserTodosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserTodosConnectionSort>>;
  where?: InputMaybe<UserTodosConnectionWhere>;
};


export type UserUndefinedFoodItemsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FoodItemOptions>;
  where?: InputMaybe<FoodItemWhere>;
};


export type UserUndefinedFoodItemsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FoodItemWhere>;
};


export type UserUndefinedFoodItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserUndefinedFoodItemsConnectionSort>>;
  where?: InputMaybe<UserUndefinedFoodItemsConnectionWhere>;
};


export type UserUndefinedWaterIntakesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<WaterIntakeOptions>;
  where?: InputMaybe<WaterIntakeWhere>;
};


export type UserUndefinedWaterIntakesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WaterIntakeWhere>;
};


export type UserUndefinedWaterIntakesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserUndefinedWaterIntakesConnectionSort>>;
  where?: InputMaybe<UserUndefinedWaterIntakesConnectionWhere>;
};

export type UserAiTutorHasReviewsAggregationSelection = {
  __typename?: 'UserAITutorHasReviewsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserAiTutorHasReviewsNodeAggregateSelection>;
};

export type UserAiTutorHasReviewsNodeAggregateSelection = {
  __typename?: 'UserAITutorHasReviewsNodeAggregateSelection';
  context: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  targetAudience: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type UserAchievementsAchievementsAggregationSelection = {
  __typename?: 'UserAchievementsAchievementsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserAchievementsAchievementsNodeAggregateSelection>;
};

export type UserAchievementsAchievementsNodeAggregateSelection = {
  __typename?: 'UserAchievementsAchievementsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  name: StringAggregateSelection;
};

export type UserAchievementsAggregateInput = {
  AND?: InputMaybe<Array<UserAchievementsAggregateInput>>;
  NOT?: InputMaybe<UserAchievementsAggregateInput>;
  OR?: InputMaybe<Array<UserAchievementsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserAchievementsNodeAggregationWhereInput>;
};

export type UserAchievementsConnectFieldInput = {
  connect?: InputMaybe<Array<AchievementsConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AchievementsConnectWhere>;
};

export type UserAchievementsConnection = {
  __typename?: 'UserAchievementsConnection';
  edges: Array<UserAchievementsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserAchievementsConnectionSort = {
  node?: InputMaybe<AchievementsSort>;
};

export type UserAchievementsConnectionWhere = {
  AND?: InputMaybe<Array<UserAchievementsConnectionWhere>>;
  NOT?: InputMaybe<UserAchievementsConnectionWhere>;
  OR?: InputMaybe<Array<UserAchievementsConnectionWhere>>;
  node?: InputMaybe<AchievementsWhere>;
};

export type UserAchievementsCreateFieldInput = {
  node: AchievementsCreateInput;
};

export type UserAchievementsDeleteFieldInput = {
  delete?: InputMaybe<AchievementsDeleteInput>;
  where?: InputMaybe<UserAchievementsConnectionWhere>;
};

export type UserAchievementsDisconnectFieldInput = {
  disconnect?: InputMaybe<AchievementsDisconnectInput>;
  where?: InputMaybe<UserAchievementsConnectionWhere>;
};

export type UserAchievementsFieldInput = {
  connect?: InputMaybe<Array<UserAchievementsConnectFieldInput>>;
  create?: InputMaybe<Array<UserAchievementsCreateFieldInput>>;
};

export type UserAchievementsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserAchievementsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserAchievementsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserAchievementsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserAchievementsRelationship = {
  __typename?: 'UserAchievementsRelationship';
  cursor: Scalars['String']['output'];
  node: Achievements;
};

export type UserAchievementsUpdateConnectionInput = {
  node?: InputMaybe<AchievementsUpdateInput>;
};

export type UserAchievementsUpdateFieldInput = {
  connect?: InputMaybe<Array<UserAchievementsConnectFieldInput>>;
  create?: InputMaybe<Array<UserAchievementsCreateFieldInput>>;
  delete?: InputMaybe<Array<UserAchievementsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserAchievementsDisconnectFieldInput>>;
  update?: InputMaybe<UserAchievementsUpdateConnectionInput>;
  where?: InputMaybe<UserAchievementsConnectionWhere>;
};

export type UserAnnouncementCreatedAnnouncementsAggregationSelection = {
  __typename?: 'UserAnnouncementCreatedAnnouncementsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserAnnouncementCreatedAnnouncementsNodeAggregateSelection>;
};

export type UserAnnouncementCreatedAnnouncementsNodeAggregateSelection = {
  __typename?: 'UserAnnouncementCreatedAnnouncementsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  expirationDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  message: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type UserAnnouncementSeenAnnouncementsAggregationSelection = {
  __typename?: 'UserAnnouncementSeenAnnouncementsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserAnnouncementSeenAnnouncementsNodeAggregateSelection>;
};

export type UserAnnouncementSeenAnnouncementsNodeAggregateSelection = {
  __typename?: 'UserAnnouncementSeenAnnouncementsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  expirationDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  message: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type UserAssessmentSubmissionAssessmentSubmissionsAggregationSelection = {
  __typename?: 'UserAssessmentSubmissionAssessmentSubmissionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserAssessmentSubmissionAssessmentSubmissionsNodeAggregateSelection>;
};

export type UserAssessmentSubmissionAssessmentSubmissionsNodeAggregateSelection = {
  __typename?: 'UserAssessmentSubmissionAssessmentSubmissionsNodeAggregateSelection';
  aiTotalPoints: FloatAggregateSelection;
  completedAt: DateTimeAggregateSelection;
  created: DateTimeAggregateSelection;
  feedback: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  maximumPoints: FloatAggregateSelection;
  startedAt: DateTimeAggregateSelection;
  timeLimit: IntAggregateSelection;
  totalPoints: FloatAggregateSelection;
};

export type UserAssessmentSubmissionsAggregateInput = {
  AND?: InputMaybe<Array<UserAssessmentSubmissionsAggregateInput>>;
  NOT?: InputMaybe<UserAssessmentSubmissionsAggregateInput>;
  OR?: InputMaybe<Array<UserAssessmentSubmissionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserAssessmentSubmissionsNodeAggregationWhereInput>;
};

export type UserAssessmentSubmissionsConnectFieldInput = {
  connect?: InputMaybe<Array<AssessmentSubmissionConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AssessmentSubmissionConnectWhere>;
};

export type UserAssessmentSubmissionsConnectOrCreateFieldInput = {
  onCreate: UserAssessmentSubmissionsConnectOrCreateFieldInputOnCreate;
  where: AssessmentSubmissionConnectOrCreateWhere;
};

export type UserAssessmentSubmissionsConnectOrCreateFieldInputOnCreate = {
  node: AssessmentSubmissionOnCreateInput;
};

export type UserAssessmentSubmissionsConnection = {
  __typename?: 'UserAssessmentSubmissionsConnection';
  edges: Array<UserAssessmentSubmissionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserAssessmentSubmissionsConnectionSort = {
  node?: InputMaybe<AssessmentSubmissionSort>;
};

export type UserAssessmentSubmissionsConnectionWhere = {
  AND?: InputMaybe<Array<UserAssessmentSubmissionsConnectionWhere>>;
  NOT?: InputMaybe<UserAssessmentSubmissionsConnectionWhere>;
  OR?: InputMaybe<Array<UserAssessmentSubmissionsConnectionWhere>>;
  node?: InputMaybe<AssessmentSubmissionWhere>;
};

export type UserAssessmentSubmissionsCreateFieldInput = {
  node: AssessmentSubmissionCreateInput;
};

export type UserAssessmentSubmissionsDeleteFieldInput = {
  delete?: InputMaybe<AssessmentSubmissionDeleteInput>;
  where?: InputMaybe<UserAssessmentSubmissionsConnectionWhere>;
};

export type UserAssessmentSubmissionsDisconnectFieldInput = {
  disconnect?: InputMaybe<AssessmentSubmissionDisconnectInput>;
  where?: InputMaybe<UserAssessmentSubmissionsConnectionWhere>;
};

export type UserAssessmentSubmissionsFieldInput = {
  connect?: InputMaybe<Array<UserAssessmentSubmissionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserAssessmentSubmissionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserAssessmentSubmissionsCreateFieldInput>>;
};

export type UserAssessmentSubmissionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserAssessmentSubmissionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserAssessmentSubmissionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserAssessmentSubmissionsNodeAggregationWhereInput>>;
  aiTotalPoints_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  aiTotalPoints_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  completedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  feedback_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  feedback_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  maximumPoints_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  maximumPoints_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  startedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  timeLimit_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeLimit_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeLimit_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalPoints_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalPoints_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type UserAssessmentSubmissionsRelationship = {
  __typename?: 'UserAssessmentSubmissionsRelationship';
  cursor: Scalars['String']['output'];
  node: AssessmentSubmission;
};

export type UserAssessmentSubmissionsUpdateConnectionInput = {
  node?: InputMaybe<AssessmentSubmissionUpdateInput>;
};

export type UserAssessmentSubmissionsUpdateFieldInput = {
  connect?: InputMaybe<Array<UserAssessmentSubmissionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserAssessmentSubmissionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserAssessmentSubmissionsCreateFieldInput>>;
  delete?: InputMaybe<Array<UserAssessmentSubmissionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserAssessmentSubmissionsDisconnectFieldInput>>;
  update?: InputMaybe<UserAssessmentSubmissionsUpdateConnectionInput>;
  where?: InputMaybe<UserAssessmentSubmissionsConnectionWhere>;
};

export type UserAssignmentSchoolAssignmentsAggregationSelection = {
  __typename?: 'UserAssignmentSchoolAssignmentsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<UserAssignmentSchoolAssignmentsEdgeAggregateSelection>;
  node?: Maybe<UserAssignmentSchoolAssignmentsNodeAggregateSelection>;
};

export type UserAssignmentSchoolAssignmentsEdgeAggregateSelection = {
  __typename?: 'UserAssignmentSchoolAssignmentsEdgeAggregateSelection';
  retakeDeadline: DateTimeAggregateSelection;
};

export type UserAssignmentSchoolAssignmentsNodeAggregateSelection = {
  __typename?: 'UserAssignmentSchoolAssignmentsNodeAggregateSelection';
  _empty: StringAggregateSelection;
  allowed_attempts: FloatAggregateSelection;
  assignee_mode: StringAggregateSelection;
  assignment_group_id: FloatAggregateSelection;
  assignment_name: StringAggregateSelection;
  body: StringAggregateSelection;
  category_id: StringAggregateSelection;
  course_id: FloatAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  description: StringAggregateSelection;
  description_plaintext: StringAggregateSelection;
  discussion_topic_assignment_id: FloatAggregateSelection;
  discussion_topic_author_anonymous_id: StringAggregateSelection;
  discussion_topic_author_avatar_image_url: StringAggregateSelection;
  discussion_topic_author_display_name: StringAggregateSelection;
  discussion_topic_author_html_url: StringAggregateSelection;
  discussion_topic_author_id: FloatAggregateSelection;
  discussion_topic_created_at: StringAggregateSelection;
  discussion_topic_discussion_subentry_count: FloatAggregateSelection;
  discussion_topic_discussion_type: StringAggregateSelection;
  discussion_topic_html_url: StringAggregateSelection;
  discussion_topic_id: FloatAggregateSelection;
  discussion_topic_last_reply_at: StringAggregateSelection;
  discussion_topic_message: StringAggregateSelection;
  discussion_topic_posted_at: StringAggregateSelection;
  discussion_topic_read_state: StringAggregateSelection;
  discussion_topic_title: StringAggregateSelection;
  discussion_topic_unread_count: FloatAggregateSelection;
  discussion_topic_url: StringAggregateSelection;
  discussion_topic_user_name: StringAggregateSelection;
  display_date: StringAggregateSelection;
  due_at: StringAggregateSelection;
  due_date: DateTimeAggregateSelection;
  end_date: StringAggregateSelection;
  external_tool_tag_attributes_content_id: FloatAggregateSelection;
  external_tool_tag_attributes_content_type: StringAggregateSelection;
  external_tool_tag_attributes_external_data: StringAggregateSelection;
  external_tool_tag_attributes_resource_link_id: StringAggregateSelection;
  external_tool_tag_attributes_url: StringAggregateSelection;
  grade_points: FloatAggregateSelection;
  grader_count: FloatAggregateSelection;
  grading_type: StringAggregateSelection;
  html: StringAggregateSelection;
  html_url: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  lti_context_id: StringAggregateSelection;
  max_attempts: FloatAggregateSelection;
  max_name_length: FloatAggregateSelection;
  name: StringAggregateSelection;
  needs_grading_count: FloatAggregateSelection;
  objectives: StringAggregateSelection;
  points_possible: FloatAggregateSelection;
  position: FloatAggregateSelection;
  resource_metadata: StringAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  secure_params: StringAggregateSelection;
  session_id: StringAggregateSelection;
  start_date: StringAggregateSelection;
  state: StringAggregateSelection;
  submissions_download_url: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_at: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  url: StringAggregateSelection;
  videoUrl: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export type UserAttributeAttributesAggregationSelection = {
  __typename?: 'UserAttributeAttributesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserAttributeAttributesNodeAggregateSelection>;
};

export type UserAttributeAttributesNodeAggregateSelection = {
  __typename?: 'UserAttributeAttributesNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: StringAggregateSelection;
  text: StringAggregateSelection;
};

export type UserAttributesAggregateInput = {
  AND?: InputMaybe<Array<UserAttributesAggregateInput>>;
  NOT?: InputMaybe<UserAttributesAggregateInput>;
  OR?: InputMaybe<Array<UserAttributesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserAttributesNodeAggregationWhereInput>;
};

export type UserAttributesConnectFieldInput = {
  connect?: InputMaybe<Array<AttributeConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AttributeConnectWhere>;
};

export type UserAttributesConnection = {
  __typename?: 'UserAttributesConnection';
  edges: Array<UserAttributesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserAttributesConnectionSort = {
  node?: InputMaybe<AttributeSort>;
};

export type UserAttributesConnectionWhere = {
  AND?: InputMaybe<Array<UserAttributesConnectionWhere>>;
  NOT?: InputMaybe<UserAttributesConnectionWhere>;
  OR?: InputMaybe<Array<UserAttributesConnectionWhere>>;
  node?: InputMaybe<AttributeWhere>;
};

export type UserAttributesCreateFieldInput = {
  node: AttributeCreateInput;
};

export type UserAttributesDeleteFieldInput = {
  delete?: InputMaybe<AttributeDeleteInput>;
  where?: InputMaybe<UserAttributesConnectionWhere>;
};

export type UserAttributesDisconnectFieldInput = {
  disconnect?: InputMaybe<AttributeDisconnectInput>;
  where?: InputMaybe<UserAttributesConnectionWhere>;
};

export type UserAttributesFieldInput = {
  connect?: InputMaybe<Array<UserAttributesConnectFieldInput>>;
  create?: InputMaybe<Array<UserAttributesCreateFieldInput>>;
};

export type UserAttributesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserAttributesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserAttributesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserAttributesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  text_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  text_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  text_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  text_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  text_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserAttributesRelationship = {
  __typename?: 'UserAttributesRelationship';
  cursor: Scalars['String']['output'];
  node: Attribute;
};

export type UserAttributesUpdateConnectionInput = {
  node?: InputMaybe<AttributeUpdateInput>;
};

export type UserAttributesUpdateFieldInput = {
  connect?: InputMaybe<Array<UserAttributesConnectFieldInput>>;
  create?: InputMaybe<Array<UserAttributesCreateFieldInput>>;
  delete?: InputMaybe<Array<UserAttributesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserAttributesDisconnectFieldInput>>;
  update?: InputMaybe<UserAttributesUpdateConnectionInput>;
  where?: InputMaybe<UserAttributesConnectionWhere>;
};

export type UserAuditEventAuditEventsAggregationSelection = {
  __typename?: 'UserAuditEventAuditEventsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserAuditEventAuditEventsNodeAggregateSelection>;
};

export type UserAuditEventAuditEventsNodeAggregateSelection = {
  __typename?: 'UserAuditEventAuditEventsNodeAggregateSelection';
  actorId: IdAggregateSelection;
  id: IdAggregateSelection;
  occurredAt: DateTimeAggregateSelection;
  relatedUserId: IdAggregateSelection;
  subjectId: IdAggregateSelection;
  subjectType: StringAggregateSelection;
  tenantId: IdAggregateSelection;
};

export type UserAuditEventsAggregateInput = {
  AND?: InputMaybe<Array<UserAuditEventsAggregateInput>>;
  NOT?: InputMaybe<UserAuditEventsAggregateInput>;
  OR?: InputMaybe<Array<UserAuditEventsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserAuditEventsNodeAggregationWhereInput>;
};

export type UserAuditEventsConnectFieldInput = {
  connect?: InputMaybe<Array<AuditEventConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AuditEventConnectWhere>;
};

export type UserAuditEventsConnectOrCreateFieldInput = {
  onCreate: UserAuditEventsConnectOrCreateFieldInputOnCreate;
  where: AuditEventConnectOrCreateWhere;
};

export type UserAuditEventsConnectOrCreateFieldInputOnCreate = {
  node: AuditEventOnCreateInput;
};

export type UserAuditEventsConnection = {
  __typename?: 'UserAuditEventsConnection';
  edges: Array<UserAuditEventsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserAuditEventsConnectionSort = {
  node?: InputMaybe<AuditEventSort>;
};

export type UserAuditEventsConnectionWhere = {
  AND?: InputMaybe<Array<UserAuditEventsConnectionWhere>>;
  NOT?: InputMaybe<UserAuditEventsConnectionWhere>;
  OR?: InputMaybe<Array<UserAuditEventsConnectionWhere>>;
  node?: InputMaybe<AuditEventWhere>;
};

export type UserAuditEventsCreateFieldInput = {
  node: AuditEventCreateInput;
};

export type UserAuditEventsDeleteFieldInput = {
  delete?: InputMaybe<AuditEventDeleteInput>;
  where?: InputMaybe<UserAuditEventsConnectionWhere>;
};

export type UserAuditEventsDisconnectFieldInput = {
  disconnect?: InputMaybe<AuditEventDisconnectInput>;
  where?: InputMaybe<UserAuditEventsConnectionWhere>;
};

export type UserAuditEventsFieldInput = {
  connect?: InputMaybe<Array<UserAuditEventsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserAuditEventsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserAuditEventsCreateFieldInput>>;
};

export type UserAuditEventsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserAuditEventsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserAuditEventsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserAuditEventsNodeAggregationWhereInput>>;
  occurredAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  occurredAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  subjectType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subjectType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  subjectType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  subjectType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  subjectType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  subjectType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subjectType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subjectType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subjectType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subjectType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subjectType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subjectType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subjectType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subjectType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subjectType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserAuditEventsRelationship = {
  __typename?: 'UserAuditEventsRelationship';
  cursor: Scalars['String']['output'];
  node: AuditEvent;
};

export type UserAuditEventsUpdateConnectionInput = {
  node?: InputMaybe<AuditEventUpdateInput>;
};

export type UserAuditEventsUpdateFieldInput = {
  connect?: InputMaybe<Array<UserAuditEventsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserAuditEventsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserAuditEventsCreateFieldInput>>;
  delete?: InputMaybe<Array<UserAuditEventsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserAuditEventsDisconnectFieldInput>>;
  update?: InputMaybe<UserAuditEventsUpdateConnectionInput>;
  where?: InputMaybe<UserAuditEventsConnectionWhere>;
};

export type UserAuthoredNotesAggregateInput = {
  AND?: InputMaybe<Array<UserAuthoredNotesAggregateInput>>;
  NOT?: InputMaybe<UserAuthoredNotesAggregateInput>;
  OR?: InputMaybe<Array<UserAuthoredNotesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserAuthoredNotesNodeAggregationWhereInput>;
};

export type UserAuthoredNotesConnectFieldInput = {
  connect?: InputMaybe<Array<NoteConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<NoteConnectWhere>;
};

export type UserAuthoredNotesConnectOrCreateFieldInput = {
  onCreate: UserAuthoredNotesConnectOrCreateFieldInputOnCreate;
  where: NoteConnectOrCreateWhere;
};

export type UserAuthoredNotesConnectOrCreateFieldInputOnCreate = {
  node: NoteOnCreateInput;
};

export type UserAuthoredNotesConnection = {
  __typename?: 'UserAuthoredNotesConnection';
  edges: Array<UserAuthoredNotesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserAuthoredNotesConnectionSort = {
  node?: InputMaybe<NoteSort>;
};

export type UserAuthoredNotesConnectionWhere = {
  AND?: InputMaybe<Array<UserAuthoredNotesConnectionWhere>>;
  NOT?: InputMaybe<UserAuthoredNotesConnectionWhere>;
  OR?: InputMaybe<Array<UserAuthoredNotesConnectionWhere>>;
  node?: InputMaybe<NoteWhere>;
};

export type UserAuthoredNotesCreateFieldInput = {
  node: NoteCreateInput;
};

export type UserAuthoredNotesDeleteFieldInput = {
  delete?: InputMaybe<NoteDeleteInput>;
  where?: InputMaybe<UserAuthoredNotesConnectionWhere>;
};

export type UserAuthoredNotesDisconnectFieldInput = {
  disconnect?: InputMaybe<NoteDisconnectInput>;
  where?: InputMaybe<UserAuthoredNotesConnectionWhere>;
};

export type UserAuthoredNotesFieldInput = {
  connect?: InputMaybe<Array<UserAuthoredNotesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserAuthoredNotesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserAuthoredNotesCreateFieldInput>>;
};

export type UserAuthoredNotesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserAuthoredNotesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserAuthoredNotesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserAuthoredNotesNodeAggregationWhereInput>>;
  content_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  content_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserAuthoredNotesRelationship = {
  __typename?: 'UserAuthoredNotesRelationship';
  cursor: Scalars['String']['output'];
  node: Note;
};

export type UserAuthoredNotesUpdateConnectionInput = {
  node?: InputMaybe<NoteUpdateInput>;
};

export type UserAuthoredNotesUpdateFieldInput = {
  connect?: InputMaybe<Array<UserAuthoredNotesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserAuthoredNotesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserAuthoredNotesCreateFieldInput>>;
  delete?: InputMaybe<Array<UserAuthoredNotesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserAuthoredNotesDisconnectFieldInput>>;
  update?: InputMaybe<UserAuthoredNotesUpdateConnectionInput>;
  where?: InputMaybe<UserAuthoredNotesConnectionWhere>;
};

export type UserAuthoredPostsAggregateInput = {
  AND?: InputMaybe<Array<UserAuthoredPostsAggregateInput>>;
  NOT?: InputMaybe<UserAuthoredPostsAggregateInput>;
  OR?: InputMaybe<Array<UserAuthoredPostsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserAuthoredPostsNodeAggregationWhereInput>;
};

export type UserAuthoredPostsConnectFieldInput = {
  connect?: InputMaybe<Array<PostConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PostConnectWhere>;
};

export type UserAuthoredPostsConnectOrCreateFieldInput = {
  onCreate: UserAuthoredPostsConnectOrCreateFieldInputOnCreate;
  where: PostConnectOrCreateWhere;
};

export type UserAuthoredPostsConnectOrCreateFieldInputOnCreate = {
  node: PostOnCreateInput;
};

export type UserAuthoredPostsConnection = {
  __typename?: 'UserAuthoredPostsConnection';
  edges: Array<UserAuthoredPostsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserAuthoredPostsConnectionSort = {
  node?: InputMaybe<PostSort>;
};

export type UserAuthoredPostsConnectionWhere = {
  AND?: InputMaybe<Array<UserAuthoredPostsConnectionWhere>>;
  NOT?: InputMaybe<UserAuthoredPostsConnectionWhere>;
  OR?: InputMaybe<Array<UserAuthoredPostsConnectionWhere>>;
  node?: InputMaybe<PostWhere>;
};

export type UserAuthoredPostsCreateFieldInput = {
  node: PostCreateInput;
};

export type UserAuthoredPostsDeleteFieldInput = {
  delete?: InputMaybe<PostDeleteInput>;
  where?: InputMaybe<UserAuthoredPostsConnectionWhere>;
};

export type UserAuthoredPostsDisconnectFieldInput = {
  disconnect?: InputMaybe<PostDisconnectInput>;
  where?: InputMaybe<UserAuthoredPostsConnectionWhere>;
};

export type UserAuthoredPostsFieldInput = {
  connect?: InputMaybe<Array<UserAuthoredPostsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserAuthoredPostsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserAuthoredPostsCreateFieldInput>>;
};

export type UserAuthoredPostsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserAuthoredPostsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserAuthoredPostsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserAuthoredPostsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  depth_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  depth_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  depth_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  depth_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  depth_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  depth_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  depth_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  depth_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  depth_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  depth_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  depth_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  depth_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  depth_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  depth_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  depth_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  depth_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  depth_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  depth_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  depth_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  depth_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  message_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  message_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threadId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threadId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  threadId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  threadId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  threadId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  threadId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threadId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threadId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threadId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threadId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threadId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threadId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  threadId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  threadId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  threadId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserAuthoredPostsRelationship = {
  __typename?: 'UserAuthoredPostsRelationship';
  cursor: Scalars['String']['output'];
  node: Post;
};

export type UserAuthoredPostsUpdateConnectionInput = {
  node?: InputMaybe<PostUpdateInput>;
};

export type UserAuthoredPostsUpdateFieldInput = {
  connect?: InputMaybe<Array<UserAuthoredPostsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserAuthoredPostsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserAuthoredPostsCreateFieldInput>>;
  delete?: InputMaybe<Array<UserAuthoredPostsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserAuthoredPostsDisconnectFieldInput>>;
  update?: InputMaybe<UserAuthoredPostsUpdateConnectionInput>;
  where?: InputMaybe<UserAuthoredPostsConnectionWhere>;
};

export type UserCareerLoadingResponse = {
  __typename?: 'UserCareerLoadingResponse';
  isCareerLoading: Scalars['Boolean']['output'];
};

export type UserChapterHasKnowledgeChaptersAggregationSelection = {
  __typename?: 'UserChapterHasKnowledgeChaptersAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<UserChapterHasKnowledgeChaptersEdgeAggregateSelection>;
  node?: Maybe<UserChapterHasKnowledgeChaptersNodeAggregateSelection>;
};

export type UserChapterHasKnowledgeChaptersEdgeAggregateSelection = {
  __typename?: 'UserChapterHasKnowledgeChaptersEdgeAggregateSelection';
  created: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  total_mastery: FloatAggregateSelection;
};

export type UserChapterHasKnowledgeChaptersNodeAggregateSelection = {
  __typename?: 'UserChapterHasKnowledgeChaptersNodeAggregateSelection';
  name: StringAggregateSelection;
};

export type UserChatHasChatChatsAggregationSelection = {
  __typename?: 'UserChatHasChatChatsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<UserChatHasChatChatsEdgeAggregateSelection>;
  node?: Maybe<UserChatHasChatChatsNodeAggregateSelection>;
};

export type UserChatHasChatChatsEdgeAggregateSelection = {
  __typename?: 'UserChatHasChatChatsEdgeAggregateSelection';
  ai_messages_count: IntAggregateSelection;
  average_ai_response_time: FloatAggregateSelection;
  average_student_response_time: FloatAggregateSelection;
  created: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  num_messages: IntAggregateSelection;
  questions_asked: IntAggregateSelection;
  student_messages_count: IntAggregateSelection;
  summary: StringAggregateSelection;
  total_time_taken: FloatAggregateSelection;
};

export type UserChatHasChatChatsNodeAggregateSelection = {
  __typename?: 'UserChatHasChatChatsNodeAggregateSelection';
  context: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  date: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  name: StringAggregateSelection;
  objectId: IdAggregateSelection;
  schemaVersion: IntAggregateSelection;
  timezone: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type UserChatMessageAnalyticsData = {
  __typename?: 'UserChatMessageAnalyticsData';
  aiMessagesCount?: Maybe<Scalars['Int']['output']>;
  courses?: Maybe<Array<Maybe<CourseInfo>>>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  studentMessagesCount?: Maybe<Scalars['Int']['output']>;
  totalMessages?: Maybe<Scalars['Int']['output']>;
};

export type UserChatMessageAnalyticsInput = {
  courseFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  coursesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

export type UserChatMessageAnalyticsResponse = {
  __typename?: 'UserChatMessageAnalyticsResponse';
  availableCourses?: Maybe<Array<Maybe<Course>>>;
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<UserChatMessageAnalyticsData>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type UserChatsResponse = {
  __typename?: 'UserChatsResponse';
  created?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  last_modified?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
};

export type UserConnectInput = {
  achievements?: InputMaybe<Array<UserAchievementsConnectFieldInput>>;
  assessmentSubmissions?: InputMaybe<Array<UserAssessmentSubmissionsConnectFieldInput>>;
  attributes?: InputMaybe<Array<UserAttributesConnectFieldInput>>;
  auditEvents?: InputMaybe<Array<UserAuditEventsConnectFieldInput>>;
  authoredNotes?: InputMaybe<Array<UserAuthoredNotesConnectFieldInput>>;
  authoredPosts?: InputMaybe<Array<UserAuthoredPostsConnectFieldInput>>;
  createdAnnouncements?: InputMaybe<Array<UserCreatedAnnouncementsConnectFieldInput>>;
  enrolledCourses?: InputMaybe<Array<UserEnrolledCoursesConnectFieldInput>>;
  enrolledDegrees?: InputMaybe<Array<UserEnrolledDegreesConnectFieldInput>>;
  enrolledInTopics?: InputMaybe<Array<UserEnrolledInTopicsConnectFieldInput>>;
  hasChatChats?: InputMaybe<Array<UserHasChatChatsConnectFieldInput>>;
  hasFile?: InputMaybe<Array<UserHasFileConnectFieldInput>>;
  hasFoodItemFoodItems?: InputMaybe<Array<UserHasFoodItemFoodItemsConnectFieldInput>>;
  hasKnowledgeChapters?: InputMaybe<Array<UserHasKnowledgeChaptersConnectFieldInput>>;
  hasKnowledgeSubchapters?: InputMaybe<Array<UserHasKnowledgeSubchaptersConnectFieldInput>>;
  hasKnowledgeTopics?: InputMaybe<Array<UserHasKnowledgeTopicsConnectFieldInput>>;
  hasLearningPreferences?: InputMaybe<UserHasLearningPreferencesConnectFieldInput>;
  hasPaymentPayments?: InputMaybe<Array<UserHasPaymentPaymentsConnectFieldInput>>;
  hasPreferencesPreferences?: InputMaybe<Array<UserHasPreferencesPreferencesConnectFieldInput>>;
  hasProgress?: InputMaybe<Array<UserHasProgressConnectFieldInput>>;
  hasReviews?: InputMaybe<Array<UserHasReviewsConnectFieldInput>>;
  hasRoleRoles?: InputMaybe<Array<UserHasRoleRolesConnectFieldInput>>;
  hasRosterExport?: InputMaybe<Array<UserHasRosterExportConnectFieldInput>>;
  hasSessionDeviceSessions?: InputMaybe<Array<UserHasSessionDeviceSessionsConnectFieldInput>>;
  hasSubmissionExport?: InputMaybe<Array<UserHasSubmissionExportConnectFieldInput>>;
  hasSubmitted?: InputMaybe<Array<UserHasSubmittedConnectFieldInput>>;
  hasSuggestionSuggestions?: InputMaybe<Array<UserHasSuggestionSuggestionsConnectFieldInput>>;
  hasSummaryDailySummaries?: InputMaybe<Array<UserHasSummaryDailySummariesConnectFieldInput>>;
  hasSummaryMonthlySummaries?: InputMaybe<Array<UserHasSummaryMonthlySummariesConnectFieldInput>>;
  hasSummaryQuarterlySummaries?: InputMaybe<Array<UserHasSummaryQuarterlySummariesConnectFieldInput>>;
  hasSummaryWeeklySummaries?: InputMaybe<Array<UserHasSummaryWeeklySummariesConnectFieldInput>>;
  hasSummaryYearlySummaries?: InputMaybe<Array<UserHasSummaryYearlySummariesConnectFieldInput>>;
  hasVisitSessions?: InputMaybe<Array<UserHasVisitSessionsConnectFieldInput>>;
  hasWaterIntakeWaterIntakes?: InputMaybe<Array<UserHasWaterIntakeWaterIntakesConnectFieldInput>>;
  hasWhitelistedEmails?: InputMaybe<Array<UserHasWhitelistedEmailsConnectFieldInput>>;
  hasWorkspaces?: InputMaybe<Array<UserHasWorkspacesConnectFieldInput>>;
  learningPayments?: InputMaybe<Array<UserLearningPaymentsConnectFieldInput>>;
  notes?: InputMaybe<Array<UserNotesConnectFieldInput>>;
  nudgePreferences?: InputMaybe<UserNudgePreferencesConnectFieldInput>;
  nudges?: InputMaybe<Array<UserNudgesConnectFieldInput>>;
  nudgesAboutThis?: InputMaybe<Array<UserNudgesAboutThisConnectFieldInput>>;
  reviewAITutorBeingGeneratedFor?: InputMaybe<Array<UserReviewAiTutorBeingGeneratedForConnectFieldInput>>;
  schoolAssignments?: InputMaybe<Array<UserSchoolAssignmentsConnectFieldInput>>;
  schools?: InputMaybe<Array<UserSchoolsConnectFieldInput>>;
  seenAnnouncements?: InputMaybe<Array<UserSeenAnnouncementsConnectFieldInput>>;
  subjectUser?: InputMaybe<UserSubjectUserConnectFieldInput>;
  subscribedThreads?: InputMaybe<Array<UserSubscribedThreadsConnectFieldInput>>;
  teachingCourses?: InputMaybe<Array<UserTeachingCoursesConnectFieldInput>>;
  tenants?: InputMaybe<Array<UserTenantsConnectFieldInput>>;
  threadReadStates?: InputMaybe<Array<UserThreadReadStatesConnectFieldInput>>;
  todos?: InputMaybe<Array<UserTodosConnectFieldInput>>;
  undefinedFoodItems?: InputMaybe<Array<UserUndefinedFoodItemsConnectFieldInput>>;
  undefinedWaterIntakes?: InputMaybe<Array<UserUndefinedWaterIntakesConnectFieldInput>>;
};

export type UserConnectOrCreateWhere = {
  node: UserUniqueWhere;
};

export type UserConnectWhere = {
  node: UserWhere;
};

export type UserCourseEnrolledCoursesAggregationSelection = {
  __typename?: 'UserCourseEnrolledCoursesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<UserCourseEnrolledCoursesEdgeAggregateSelection>;
  node?: Maybe<UserCourseEnrolledCoursesNodeAggregateSelection>;
};

export type UserCourseEnrolledCoursesEdgeAggregateSelection = {
  __typename?: 'UserCourseEnrolledCoursesEdgeAggregateSelection';
  created: DateTimeAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
};

export type UserCourseEnrolledCoursesNodeAggregateSelection = {
  __typename?: 'UserCourseEnrolledCoursesNodeAggregateSelection';
  account_id: FloatAggregateSelection;
  calendar_ics: StringAggregateSelection;
  cost: FloatAggregateSelection;
  courseId: StringAggregateSelection;
  course_code: StringAggregateSelection;
  course_id: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  default_view: StringAggregateSelection;
  description: StringAggregateSelection;
  dueDateEndDate: DateTimeAggregateSelection;
  dueDateStartDate: DateTimeAggregateSelection;
  endDate: DateTimeAggregateSelection;
  end_at: StringAggregateSelection;
  enrollment_term_id: FloatAggregateSelection;
  grading_standard_id: FloatAggregateSelection;
  id: IdAggregateSelection;
  integration_id: StringAggregateSelection;
  label: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  learningStandards: StringAggregateSelection;
  lengthInWeeks: FloatAggregateSelection;
  license: StringAggregateSelection;
  lti_id: StringAggregateSelection;
  name: StringAggregateSelection;
  original_name: StringAggregateSelection;
  root_account_id: FloatAggregateSelection;
  sis_course_id: StringAggregateSelection;
  sis_import_id: FloatAggregateSelection;
  startDate: DateTimeAggregateSelection;
  start_at: StringAggregateSelection;
  state: StringAggregateSelection;
  storage_quota_mb: FloatAggregateSelection;
  stripePriceId: StringAggregateSelection;
  stripeProductId: StringAggregateSelection;
  targetAudience: StringAggregateSelection;
  thumbnail: StringAggregateSelection;
  time_zone: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  uuid: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export type UserCourseLoadingResponse = {
  __typename?: 'UserCourseLoadingResponse';
  isCourseLoading: Scalars['Boolean']['output'];
};

export type UserCourseTeachingCoursesAggregationSelection = {
  __typename?: 'UserCourseTeachingCoursesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserCourseTeachingCoursesNodeAggregateSelection>;
};

export type UserCourseTeachingCoursesNodeAggregateSelection = {
  __typename?: 'UserCourseTeachingCoursesNodeAggregateSelection';
  account_id: FloatAggregateSelection;
  calendar_ics: StringAggregateSelection;
  cost: FloatAggregateSelection;
  courseId: StringAggregateSelection;
  course_code: StringAggregateSelection;
  course_id: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  default_view: StringAggregateSelection;
  description: StringAggregateSelection;
  dueDateEndDate: DateTimeAggregateSelection;
  dueDateStartDate: DateTimeAggregateSelection;
  endDate: DateTimeAggregateSelection;
  end_at: StringAggregateSelection;
  enrollment_term_id: FloatAggregateSelection;
  grading_standard_id: FloatAggregateSelection;
  id: IdAggregateSelection;
  integration_id: StringAggregateSelection;
  label: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  learningStandards: StringAggregateSelection;
  lengthInWeeks: FloatAggregateSelection;
  license: StringAggregateSelection;
  lti_id: StringAggregateSelection;
  name: StringAggregateSelection;
  original_name: StringAggregateSelection;
  root_account_id: FloatAggregateSelection;
  sis_course_id: StringAggregateSelection;
  sis_import_id: FloatAggregateSelection;
  startDate: DateTimeAggregateSelection;
  start_at: StringAggregateSelection;
  state: StringAggregateSelection;
  storage_quota_mb: FloatAggregateSelection;
  stripePriceId: StringAggregateSelection;
  stripeProductId: StringAggregateSelection;
  targetAudience: StringAggregateSelection;
  thumbnail: StringAggregateSelection;
  time_zone: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  uuid: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export type UserCreateInput = {
  _empty?: InputMaybe<Scalars['String']['input']>;
  achievements?: InputMaybe<UserAchievementsFieldInput>;
  assessmentSubmissions?: InputMaybe<UserAssessmentSubmissionsFieldInput>;
  attributes?: InputMaybe<UserAttributesFieldInput>;
  audioOn?: InputMaybe<Scalars['Boolean']['input']>;
  auditEvents?: InputMaybe<UserAuditEventsFieldInput>;
  authoredNotes?: InputMaybe<UserAuthoredNotesFieldInput>;
  authoredPosts?: InputMaybe<UserAuthoredPostsFieldInput>;
  biography?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  consentToSms?: InputMaybe<Scalars['Boolean']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  created: Scalars['DateTime']['input'];
  createdAnnouncements?: InputMaybe<UserCreatedAnnouncementsFieldInput>;
  crmUserId?: InputMaybe<Scalars['String']['input']>;
  currentWeightLbs?: InputMaybe<Scalars['Float']['input']>;
  dailyEmailOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  enrolledCourses?: InputMaybe<UserEnrolledCoursesFieldInput>;
  enrolledDegrees?: InputMaybe<UserEnrolledDegreesFieldInput>;
  enrolledInTopics?: InputMaybe<UserEnrolledInTopicsFieldInput>;
  enrolledTracks?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fullPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  goalWeightLbs?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens?: InputMaybe<Scalars['String']['input']>;
  googleCalendarAuthToken?: InputMaybe<Scalars['String']['input']>;
  hasChatChats?: InputMaybe<UserHasChatChatsFieldInput>;
  hasFile?: InputMaybe<UserHasFileFieldInput>;
  hasFoodItemFoodItems?: InputMaybe<UserHasFoodItemFoodItemsFieldInput>;
  hasKnowledgeChapters?: InputMaybe<UserHasKnowledgeChaptersFieldInput>;
  hasKnowledgeSubchapters?: InputMaybe<UserHasKnowledgeSubchaptersFieldInput>;
  hasKnowledgeTopics?: InputMaybe<UserHasKnowledgeTopicsFieldInput>;
  hasLearningPreferences?: InputMaybe<UserHasLearningPreferencesFieldInput>;
  hasPaymentPayments?: InputMaybe<UserHasPaymentPaymentsFieldInput>;
  hasPreferencesPreferences?: InputMaybe<UserHasPreferencesPreferencesFieldInput>;
  hasProgress?: InputMaybe<UserHasProgressFieldInput>;
  hasReviews?: InputMaybe<UserHasReviewsFieldInput>;
  hasRoleRoles?: InputMaybe<UserHasRoleRolesFieldInput>;
  hasRosterExport?: InputMaybe<UserHasRosterExportFieldInput>;
  hasSessionDeviceSessions?: InputMaybe<UserHasSessionDeviceSessionsFieldInput>;
  hasSubmissionExport?: InputMaybe<UserHasSubmissionExportFieldInput>;
  hasSubmitted?: InputMaybe<UserHasSubmittedFieldInput>;
  hasSuggestionSuggestions?: InputMaybe<UserHasSuggestionSuggestionsFieldInput>;
  hasSummaryDailySummaries?: InputMaybe<UserHasSummaryDailySummariesFieldInput>;
  hasSummaryMonthlySummaries?: InputMaybe<UserHasSummaryMonthlySummariesFieldInput>;
  hasSummaryQuarterlySummaries?: InputMaybe<UserHasSummaryQuarterlySummariesFieldInput>;
  hasSummaryWeeklySummaries?: InputMaybe<UserHasSummaryWeeklySummariesFieldInput>;
  hasSummaryYearlySummaries?: InputMaybe<UserHasSummaryYearlySummariesFieldInput>;
  hasVisitSessions?: InputMaybe<UserHasVisitSessionsFieldInput>;
  hasWaterIntakeWaterIntakes?: InputMaybe<UserHasWaterIntakeWaterIntakesFieldInput>;
  hasWhitelistedEmails?: InputMaybe<UserHasWhitelistedEmailsFieldInput>;
  hasWorkspaces?: InputMaybe<UserHasWorkspacesFieldInput>;
  id: Scalars['ID']['input'];
  invitationToken?: InputMaybe<Scalars['String']['input']>;
  invitationTokenExpiry?: InputMaybe<Scalars['DateTime']['input']>;
  inviteCount?: InputMaybe<Scalars['Int']['input']>;
  isCareerLoading?: InputMaybe<Scalars['Boolean']['input']>;
  isCourseLoading?: InputMaybe<Scalars['Boolean']['input']>;
  isEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  isOnboarded?: InputMaybe<Scalars['Boolean']['input']>;
  isPhoneVerified?: InputMaybe<Scalars['Boolean']['input']>;
  isPro?: InputMaybe<Scalars['Boolean']['input']>;
  learningPayments?: InputMaybe<UserLearningPaymentsFieldInput>;
  meetingLink?: InputMaybe<Scalars['String']['input']>;
  modalOnboarding?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  needsResolution?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<UserNotesFieldInput>;
  nudgePreferences?: InputMaybe<UserNudgePreferencesFieldInput>;
  nudges?: InputMaybe<UserNudgesFieldInput>;
  nudgesAboutThis?: InputMaybe<UserNudgesAboutThisFieldInput>;
  otpPreference?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  passwordResetToken?: InputMaybe<Scalars['String']['input']>;
  passwordResetTokenExpiry?: InputMaybe<Scalars['DateTime']['input']>;
  pendingCourseEnrollmentInvite?: InputMaybe<Scalars['Boolean']['input']>;
  pendingEmail?: InputMaybe<Scalars['String']['input']>;
  pendingFacultyInvite?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Scalars['String']['input']>;
  reviewAITutorBeingGeneratedFor?: InputMaybe<UserReviewAiTutorBeingGeneratedForFieldInput>;
  schoolAssignments?: InputMaybe<UserSchoolAssignmentsFieldInput>;
  schools?: InputMaybe<UserSchoolsFieldInput>;
  seenAnnouncements?: InputMaybe<UserSeenAnnouncementsFieldInput>;
  showLearningActivityIntro?: InputMaybe<Scalars['Boolean']['input']>;
  skipAllNotificationEmail?: InputMaybe<Scalars['Boolean']['input']>;
  ssoId?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerIdLearningPayments?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  subjectUser?: InputMaybe<UserSubjectUserFieldInput>;
  subscribedThreads?: InputMaybe<UserSubscribedThreadsFieldInput>;
  teachingCourses?: InputMaybe<UserTeachingCoursesFieldInput>;
  tenants?: InputMaybe<UserTenantsFieldInput>;
  threadReadStates?: InputMaybe<UserThreadReadStatesFieldInput>;
  todos?: InputMaybe<UserTodosFieldInput>;
  trialEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  undefinedFoodItems?: InputMaybe<UserUndefinedFoodItemsFieldInput>;
  undefinedWaterIntakes?: InputMaybe<UserUndefinedWaterIntakesFieldInput>;
  username?: InputMaybe<Scalars['String']['input']>;
  watchedIntroVideo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserCreatedAnnouncementsAggregateInput = {
  AND?: InputMaybe<Array<UserCreatedAnnouncementsAggregateInput>>;
  NOT?: InputMaybe<UserCreatedAnnouncementsAggregateInput>;
  OR?: InputMaybe<Array<UserCreatedAnnouncementsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserCreatedAnnouncementsNodeAggregationWhereInput>;
};

export type UserCreatedAnnouncementsConnectFieldInput = {
  connect?: InputMaybe<Array<AnnouncementConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AnnouncementConnectWhere>;
};

export type UserCreatedAnnouncementsConnectOrCreateFieldInput = {
  onCreate: UserCreatedAnnouncementsConnectOrCreateFieldInputOnCreate;
  where: AnnouncementConnectOrCreateWhere;
};

export type UserCreatedAnnouncementsConnectOrCreateFieldInputOnCreate = {
  node: AnnouncementOnCreateInput;
};

export type UserCreatedAnnouncementsConnection = {
  __typename?: 'UserCreatedAnnouncementsConnection';
  edges: Array<UserCreatedAnnouncementsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserCreatedAnnouncementsConnectionSort = {
  node?: InputMaybe<AnnouncementSort>;
};

export type UserCreatedAnnouncementsConnectionWhere = {
  AND?: InputMaybe<Array<UserCreatedAnnouncementsConnectionWhere>>;
  NOT?: InputMaybe<UserCreatedAnnouncementsConnectionWhere>;
  OR?: InputMaybe<Array<UserCreatedAnnouncementsConnectionWhere>>;
  node?: InputMaybe<AnnouncementWhere>;
};

export type UserCreatedAnnouncementsCreateFieldInput = {
  node: AnnouncementCreateInput;
};

export type UserCreatedAnnouncementsDeleteFieldInput = {
  delete?: InputMaybe<AnnouncementDeleteInput>;
  where?: InputMaybe<UserCreatedAnnouncementsConnectionWhere>;
};

export type UserCreatedAnnouncementsDisconnectFieldInput = {
  disconnect?: InputMaybe<AnnouncementDisconnectInput>;
  where?: InputMaybe<UserCreatedAnnouncementsConnectionWhere>;
};

export type UserCreatedAnnouncementsFieldInput = {
  connect?: InputMaybe<Array<UserCreatedAnnouncementsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreatedAnnouncementsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserCreatedAnnouncementsCreateFieldInput>>;
};

export type UserCreatedAnnouncementsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserCreatedAnnouncementsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserCreatedAnnouncementsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserCreatedAnnouncementsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  message_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  message_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCreatedAnnouncementsRelationship = {
  __typename?: 'UserCreatedAnnouncementsRelationship';
  cursor: Scalars['String']['output'];
  node: Announcement;
};

export type UserCreatedAnnouncementsUpdateConnectionInput = {
  node?: InputMaybe<AnnouncementUpdateInput>;
};

export type UserCreatedAnnouncementsUpdateFieldInput = {
  connect?: InputMaybe<Array<UserCreatedAnnouncementsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreatedAnnouncementsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserCreatedAnnouncementsCreateFieldInput>>;
  delete?: InputMaybe<Array<UserCreatedAnnouncementsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserCreatedAnnouncementsDisconnectFieldInput>>;
  update?: InputMaybe<UserCreatedAnnouncementsUpdateConnectionInput>;
  where?: InputMaybe<UserCreatedAnnouncementsConnectionWhere>;
};

export type UserDailySummaryHasSummaryDailySummariesAggregationSelection = {
  __typename?: 'UserDailySummaryHasSummaryDailySummariesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserDailySummaryHasSummaryDailySummariesNodeAggregateSelection>;
};

export type UserDailySummaryHasSummaryDailySummariesNodeAggregateSelection = {
  __typename?: 'UserDailySummaryHasSummaryDailySummariesNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  date: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  summary: StringAggregateSelection;
};

export type UserDegreeEnrolledDegreesAggregationSelection = {
  __typename?: 'UserDegreeEnrolledDegreesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<UserDegreeEnrolledDegreesEdgeAggregateSelection>;
  node?: Maybe<UserDegreeEnrolledDegreesNodeAggregateSelection>;
};

export type UserDegreeEnrolledDegreesEdgeAggregateSelection = {
  __typename?: 'UserDegreeEnrolledDegreesEdgeAggregateSelection';
  created: DateTimeAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
};

export type UserDegreeEnrolledDegreesNodeAggregateSelection = {
  __typename?: 'UserDegreeEnrolledDegreesNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  id: IdAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  name: StringAggregateSelection;
};

export type UserDeleteInput = {
  achievements?: InputMaybe<Array<UserAchievementsDeleteFieldInput>>;
  assessmentSubmissions?: InputMaybe<Array<UserAssessmentSubmissionsDeleteFieldInput>>;
  attributes?: InputMaybe<Array<UserAttributesDeleteFieldInput>>;
  auditEvents?: InputMaybe<Array<UserAuditEventsDeleteFieldInput>>;
  authoredNotes?: InputMaybe<Array<UserAuthoredNotesDeleteFieldInput>>;
  authoredPosts?: InputMaybe<Array<UserAuthoredPostsDeleteFieldInput>>;
  createdAnnouncements?: InputMaybe<Array<UserCreatedAnnouncementsDeleteFieldInput>>;
  enrolledCourses?: InputMaybe<Array<UserEnrolledCoursesDeleteFieldInput>>;
  enrolledDegrees?: InputMaybe<Array<UserEnrolledDegreesDeleteFieldInput>>;
  enrolledInTopics?: InputMaybe<Array<UserEnrolledInTopicsDeleteFieldInput>>;
  hasChatChats?: InputMaybe<Array<UserHasChatChatsDeleteFieldInput>>;
  hasFile?: InputMaybe<Array<UserHasFileDeleteFieldInput>>;
  hasFoodItemFoodItems?: InputMaybe<Array<UserHasFoodItemFoodItemsDeleteFieldInput>>;
  hasKnowledgeChapters?: InputMaybe<Array<UserHasKnowledgeChaptersDeleteFieldInput>>;
  hasKnowledgeSubchapters?: InputMaybe<Array<UserHasKnowledgeSubchaptersDeleteFieldInput>>;
  hasKnowledgeTopics?: InputMaybe<Array<UserHasKnowledgeTopicsDeleteFieldInput>>;
  hasLearningPreferences?: InputMaybe<UserHasLearningPreferencesDeleteFieldInput>;
  hasPaymentPayments?: InputMaybe<Array<UserHasPaymentPaymentsDeleteFieldInput>>;
  hasPreferencesPreferences?: InputMaybe<Array<UserHasPreferencesPreferencesDeleteFieldInput>>;
  hasProgress?: InputMaybe<Array<UserHasProgressDeleteFieldInput>>;
  hasReviews?: InputMaybe<Array<UserHasReviewsDeleteFieldInput>>;
  hasRoleRoles?: InputMaybe<Array<UserHasRoleRolesDeleteFieldInput>>;
  hasRosterExport?: InputMaybe<Array<UserHasRosterExportDeleteFieldInput>>;
  hasSessionDeviceSessions?: InputMaybe<Array<UserHasSessionDeviceSessionsDeleteFieldInput>>;
  hasSubmissionExport?: InputMaybe<Array<UserHasSubmissionExportDeleteFieldInput>>;
  hasSubmitted?: InputMaybe<Array<UserHasSubmittedDeleteFieldInput>>;
  hasSuggestionSuggestions?: InputMaybe<Array<UserHasSuggestionSuggestionsDeleteFieldInput>>;
  hasSummaryDailySummaries?: InputMaybe<Array<UserHasSummaryDailySummariesDeleteFieldInput>>;
  hasSummaryMonthlySummaries?: InputMaybe<Array<UserHasSummaryMonthlySummariesDeleteFieldInput>>;
  hasSummaryQuarterlySummaries?: InputMaybe<Array<UserHasSummaryQuarterlySummariesDeleteFieldInput>>;
  hasSummaryWeeklySummaries?: InputMaybe<Array<UserHasSummaryWeeklySummariesDeleteFieldInput>>;
  hasSummaryYearlySummaries?: InputMaybe<Array<UserHasSummaryYearlySummariesDeleteFieldInput>>;
  hasVisitSessions?: InputMaybe<Array<UserHasVisitSessionsDeleteFieldInput>>;
  hasWaterIntakeWaterIntakes?: InputMaybe<Array<UserHasWaterIntakeWaterIntakesDeleteFieldInput>>;
  hasWhitelistedEmails?: InputMaybe<Array<UserHasWhitelistedEmailsDeleteFieldInput>>;
  hasWorkspaces?: InputMaybe<Array<UserHasWorkspacesDeleteFieldInput>>;
  learningPayments?: InputMaybe<Array<UserLearningPaymentsDeleteFieldInput>>;
  notes?: InputMaybe<Array<UserNotesDeleteFieldInput>>;
  nudgePreferences?: InputMaybe<UserNudgePreferencesDeleteFieldInput>;
  nudges?: InputMaybe<Array<UserNudgesDeleteFieldInput>>;
  nudgesAboutThis?: InputMaybe<Array<UserNudgesAboutThisDeleteFieldInput>>;
  reviewAITutorBeingGeneratedFor?: InputMaybe<Array<UserReviewAiTutorBeingGeneratedForDeleteFieldInput>>;
  schoolAssignments?: InputMaybe<Array<UserSchoolAssignmentsDeleteFieldInput>>;
  schools?: InputMaybe<Array<UserSchoolsDeleteFieldInput>>;
  seenAnnouncements?: InputMaybe<Array<UserSeenAnnouncementsDeleteFieldInput>>;
  subjectUser?: InputMaybe<UserSubjectUserDeleteFieldInput>;
  subscribedThreads?: InputMaybe<Array<UserSubscribedThreadsDeleteFieldInput>>;
  teachingCourses?: InputMaybe<Array<UserTeachingCoursesDeleteFieldInput>>;
  tenants?: InputMaybe<Array<UserTenantsDeleteFieldInput>>;
  threadReadStates?: InputMaybe<Array<UserThreadReadStatesDeleteFieldInput>>;
  todos?: InputMaybe<Array<UserTodosDeleteFieldInput>>;
  undefinedFoodItems?: InputMaybe<Array<UserUndefinedFoodItemsDeleteFieldInput>>;
  undefinedWaterIntakes?: InputMaybe<Array<UserUndefinedWaterIntakesDeleteFieldInput>>;
};

export type UserDeviceSessionHasSessionDeviceSessionsAggregationSelection = {
  __typename?: 'UserDeviceSessionHasSessionDeviceSessionsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<UserDeviceSessionHasSessionDeviceSessionsEdgeAggregateSelection>;
  node?: Maybe<UserDeviceSessionHasSessionDeviceSessionsNodeAggregateSelection>;
};

export type UserDeviceSessionHasSessionDeviceSessionsEdgeAggregateSelection = {
  __typename?: 'UserDeviceSessionHasSessionDeviceSessionsEdgeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  expiresAt: DateTimeAggregateSelection;
};

export type UserDeviceSessionHasSessionDeviceSessionsNodeAggregateSelection = {
  __typename?: 'UserDeviceSessionHasSessionDeviceSessionsNodeAggregateSelection';
  id: IdAggregateSelection;
};

export type UserDisconnectInput = {
  achievements?: InputMaybe<Array<UserAchievementsDisconnectFieldInput>>;
  assessmentSubmissions?: InputMaybe<Array<UserAssessmentSubmissionsDisconnectFieldInput>>;
  attributes?: InputMaybe<Array<UserAttributesDisconnectFieldInput>>;
  auditEvents?: InputMaybe<Array<UserAuditEventsDisconnectFieldInput>>;
  authoredNotes?: InputMaybe<Array<UserAuthoredNotesDisconnectFieldInput>>;
  authoredPosts?: InputMaybe<Array<UserAuthoredPostsDisconnectFieldInput>>;
  createdAnnouncements?: InputMaybe<Array<UserCreatedAnnouncementsDisconnectFieldInput>>;
  enrolledCourses?: InputMaybe<Array<UserEnrolledCoursesDisconnectFieldInput>>;
  enrolledDegrees?: InputMaybe<Array<UserEnrolledDegreesDisconnectFieldInput>>;
  enrolledInTopics?: InputMaybe<Array<UserEnrolledInTopicsDisconnectFieldInput>>;
  hasChatChats?: InputMaybe<Array<UserHasChatChatsDisconnectFieldInput>>;
  hasFile?: InputMaybe<Array<UserHasFileDisconnectFieldInput>>;
  hasFoodItemFoodItems?: InputMaybe<Array<UserHasFoodItemFoodItemsDisconnectFieldInput>>;
  hasKnowledgeChapters?: InputMaybe<Array<UserHasKnowledgeChaptersDisconnectFieldInput>>;
  hasKnowledgeSubchapters?: InputMaybe<Array<UserHasKnowledgeSubchaptersDisconnectFieldInput>>;
  hasKnowledgeTopics?: InputMaybe<Array<UserHasKnowledgeTopicsDisconnectFieldInput>>;
  hasLearningPreferences?: InputMaybe<UserHasLearningPreferencesDisconnectFieldInput>;
  hasPaymentPayments?: InputMaybe<Array<UserHasPaymentPaymentsDisconnectFieldInput>>;
  hasPreferencesPreferences?: InputMaybe<Array<UserHasPreferencesPreferencesDisconnectFieldInput>>;
  hasProgress?: InputMaybe<Array<UserHasProgressDisconnectFieldInput>>;
  hasReviews?: InputMaybe<Array<UserHasReviewsDisconnectFieldInput>>;
  hasRoleRoles?: InputMaybe<Array<UserHasRoleRolesDisconnectFieldInput>>;
  hasRosterExport?: InputMaybe<Array<UserHasRosterExportDisconnectFieldInput>>;
  hasSessionDeviceSessions?: InputMaybe<Array<UserHasSessionDeviceSessionsDisconnectFieldInput>>;
  hasSubmissionExport?: InputMaybe<Array<UserHasSubmissionExportDisconnectFieldInput>>;
  hasSubmitted?: InputMaybe<Array<UserHasSubmittedDisconnectFieldInput>>;
  hasSuggestionSuggestions?: InputMaybe<Array<UserHasSuggestionSuggestionsDisconnectFieldInput>>;
  hasSummaryDailySummaries?: InputMaybe<Array<UserHasSummaryDailySummariesDisconnectFieldInput>>;
  hasSummaryMonthlySummaries?: InputMaybe<Array<UserHasSummaryMonthlySummariesDisconnectFieldInput>>;
  hasSummaryQuarterlySummaries?: InputMaybe<Array<UserHasSummaryQuarterlySummariesDisconnectFieldInput>>;
  hasSummaryWeeklySummaries?: InputMaybe<Array<UserHasSummaryWeeklySummariesDisconnectFieldInput>>;
  hasSummaryYearlySummaries?: InputMaybe<Array<UserHasSummaryYearlySummariesDisconnectFieldInput>>;
  hasVisitSessions?: InputMaybe<Array<UserHasVisitSessionsDisconnectFieldInput>>;
  hasWaterIntakeWaterIntakes?: InputMaybe<Array<UserHasWaterIntakeWaterIntakesDisconnectFieldInput>>;
  hasWhitelistedEmails?: InputMaybe<Array<UserHasWhitelistedEmailsDisconnectFieldInput>>;
  hasWorkspaces?: InputMaybe<Array<UserHasWorkspacesDisconnectFieldInput>>;
  learningPayments?: InputMaybe<Array<UserLearningPaymentsDisconnectFieldInput>>;
  notes?: InputMaybe<Array<UserNotesDisconnectFieldInput>>;
  nudgePreferences?: InputMaybe<UserNudgePreferencesDisconnectFieldInput>;
  nudges?: InputMaybe<Array<UserNudgesDisconnectFieldInput>>;
  nudgesAboutThis?: InputMaybe<Array<UserNudgesAboutThisDisconnectFieldInput>>;
  reviewAITutorBeingGeneratedFor?: InputMaybe<Array<UserReviewAiTutorBeingGeneratedForDisconnectFieldInput>>;
  schoolAssignments?: InputMaybe<Array<UserSchoolAssignmentsDisconnectFieldInput>>;
  schools?: InputMaybe<Array<UserSchoolsDisconnectFieldInput>>;
  seenAnnouncements?: InputMaybe<Array<UserSeenAnnouncementsDisconnectFieldInput>>;
  subjectUser?: InputMaybe<UserSubjectUserDisconnectFieldInput>;
  subscribedThreads?: InputMaybe<Array<UserSubscribedThreadsDisconnectFieldInput>>;
  teachingCourses?: InputMaybe<Array<UserTeachingCoursesDisconnectFieldInput>>;
  tenants?: InputMaybe<Array<UserTenantsDisconnectFieldInput>>;
  threadReadStates?: InputMaybe<Array<UserThreadReadStatesDisconnectFieldInput>>;
  todos?: InputMaybe<Array<UserTodosDisconnectFieldInput>>;
  undefinedFoodItems?: InputMaybe<Array<UserUndefinedFoodItemsDisconnectFieldInput>>;
  undefinedWaterIntakes?: InputMaybe<Array<UserUndefinedWaterIntakesDisconnectFieldInput>>;
};

export type UserEnrolledCoursesAggregateInput = {
  AND?: InputMaybe<Array<UserEnrolledCoursesAggregateInput>>;
  NOT?: InputMaybe<UserEnrolledCoursesAggregateInput>;
  OR?: InputMaybe<Array<UserEnrolledCoursesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<EnrolledInPropertiesAggregationWhereInput>;
  node?: InputMaybe<UserEnrolledCoursesNodeAggregationWhereInput>;
};

export type UserEnrolledCoursesConnectFieldInput = {
  connect?: InputMaybe<Array<CourseConnectInput>>;
  edge: EnrolledInPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CourseConnectWhere>;
};

export type UserEnrolledCoursesConnectOrCreateFieldInput = {
  onCreate: UserEnrolledCoursesConnectOrCreateFieldInputOnCreate;
  where: CourseConnectOrCreateWhere;
};

export type UserEnrolledCoursesConnectOrCreateFieldInputOnCreate = {
  edge: EnrolledInPropertiesCreateInput;
  node: CourseOnCreateInput;
};

export type UserEnrolledCoursesConnection = {
  __typename?: 'UserEnrolledCoursesConnection';
  edges: Array<UserEnrolledCoursesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserEnrolledCoursesConnectionSort = {
  edge?: InputMaybe<EnrolledInPropertiesSort>;
  node?: InputMaybe<CourseSort>;
};

export type UserEnrolledCoursesConnectionWhere = {
  AND?: InputMaybe<Array<UserEnrolledCoursesConnectionWhere>>;
  NOT?: InputMaybe<UserEnrolledCoursesConnectionWhere>;
  OR?: InputMaybe<Array<UserEnrolledCoursesConnectionWhere>>;
  edge?: InputMaybe<EnrolledInPropertiesWhere>;
  node?: InputMaybe<CourseWhere>;
};

export type UserEnrolledCoursesCreateFieldInput = {
  edge: EnrolledInPropertiesCreateInput;
  node: CourseCreateInput;
};

export type UserEnrolledCoursesDeleteFieldInput = {
  delete?: InputMaybe<CourseDeleteInput>;
  where?: InputMaybe<UserEnrolledCoursesConnectionWhere>;
};

export type UserEnrolledCoursesDisconnectFieldInput = {
  disconnect?: InputMaybe<CourseDisconnectInput>;
  where?: InputMaybe<UserEnrolledCoursesConnectionWhere>;
};

export type UserEnrolledCoursesFieldInput = {
  connect?: InputMaybe<Array<UserEnrolledCoursesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserEnrolledCoursesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserEnrolledCoursesCreateFieldInput>>;
};

export type UserEnrolledCoursesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserEnrolledCoursesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserEnrolledCoursesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserEnrolledCoursesNodeAggregationWhereInput>>;
  account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  cost_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDateEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  enrollment_term_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  label_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningStandards_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthInWeeks_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  root_account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_import_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  startDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  storage_quota_mb_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserEnrolledCoursesRelationship = {
  __typename?: 'UserEnrolledCoursesRelationship';
  cursor: Scalars['String']['output'];
  node: Course;
  properties: EnrolledInProperties;
};

export type UserEnrolledCoursesUpdateConnectionInput = {
  edge?: InputMaybe<EnrolledInPropertiesUpdateInput>;
  node?: InputMaybe<CourseUpdateInput>;
};

export type UserEnrolledCoursesUpdateFieldInput = {
  connect?: InputMaybe<Array<UserEnrolledCoursesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserEnrolledCoursesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserEnrolledCoursesCreateFieldInput>>;
  delete?: InputMaybe<Array<UserEnrolledCoursesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserEnrolledCoursesDisconnectFieldInput>>;
  update?: InputMaybe<UserEnrolledCoursesUpdateConnectionInput>;
  where?: InputMaybe<UserEnrolledCoursesConnectionWhere>;
};

export type UserEnrolledDegreesAggregateInput = {
  AND?: InputMaybe<Array<UserEnrolledDegreesAggregateInput>>;
  NOT?: InputMaybe<UserEnrolledDegreesAggregateInput>;
  OR?: InputMaybe<Array<UserEnrolledDegreesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<EnrolledInDegreePropertiesAggregationWhereInput>;
  node?: InputMaybe<UserEnrolledDegreesNodeAggregationWhereInput>;
};

export type UserEnrolledDegreesConnectFieldInput = {
  connect?: InputMaybe<Array<DegreeConnectInput>>;
  edge: EnrolledInDegreePropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DegreeConnectWhere>;
};

export type UserEnrolledDegreesConnectOrCreateFieldInput = {
  onCreate: UserEnrolledDegreesConnectOrCreateFieldInputOnCreate;
  where: DegreeConnectOrCreateWhere;
};

export type UserEnrolledDegreesConnectOrCreateFieldInputOnCreate = {
  edge: EnrolledInDegreePropertiesCreateInput;
  node: DegreeOnCreateInput;
};

export type UserEnrolledDegreesConnection = {
  __typename?: 'UserEnrolledDegreesConnection';
  edges: Array<UserEnrolledDegreesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserEnrolledDegreesConnectionSort = {
  edge?: InputMaybe<EnrolledInDegreePropertiesSort>;
  node?: InputMaybe<DegreeSort>;
};

export type UserEnrolledDegreesConnectionWhere = {
  AND?: InputMaybe<Array<UserEnrolledDegreesConnectionWhere>>;
  NOT?: InputMaybe<UserEnrolledDegreesConnectionWhere>;
  OR?: InputMaybe<Array<UserEnrolledDegreesConnectionWhere>>;
  edge?: InputMaybe<EnrolledInDegreePropertiesWhere>;
  node?: InputMaybe<DegreeWhere>;
};

export type UserEnrolledDegreesCreateFieldInput = {
  edge: EnrolledInDegreePropertiesCreateInput;
  node: DegreeCreateInput;
};

export type UserEnrolledDegreesDeleteFieldInput = {
  delete?: InputMaybe<DegreeDeleteInput>;
  where?: InputMaybe<UserEnrolledDegreesConnectionWhere>;
};

export type UserEnrolledDegreesDisconnectFieldInput = {
  disconnect?: InputMaybe<DegreeDisconnectInput>;
  where?: InputMaybe<UserEnrolledDegreesConnectionWhere>;
};

export type UserEnrolledDegreesFieldInput = {
  connect?: InputMaybe<Array<UserEnrolledDegreesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserEnrolledDegreesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserEnrolledDegreesCreateFieldInput>>;
};

export type UserEnrolledDegreesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserEnrolledDegreesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserEnrolledDegreesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserEnrolledDegreesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserEnrolledDegreesRelationship = {
  __typename?: 'UserEnrolledDegreesRelationship';
  cursor: Scalars['String']['output'];
  node: Degree;
  properties: EnrolledInDegreeProperties;
};

export type UserEnrolledDegreesUpdateConnectionInput = {
  edge?: InputMaybe<EnrolledInDegreePropertiesUpdateInput>;
  node?: InputMaybe<DegreeUpdateInput>;
};

export type UserEnrolledDegreesUpdateFieldInput = {
  connect?: InputMaybe<Array<UserEnrolledDegreesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserEnrolledDegreesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserEnrolledDegreesCreateFieldInput>>;
  delete?: InputMaybe<Array<UserEnrolledDegreesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserEnrolledDegreesDisconnectFieldInput>>;
  update?: InputMaybe<UserEnrolledDegreesUpdateConnectionInput>;
  where?: InputMaybe<UserEnrolledDegreesConnectionWhere>;
};

export type UserEnrolledInTopicsAggregateInput = {
  AND?: InputMaybe<Array<UserEnrolledInTopicsAggregateInput>>;
  NOT?: InputMaybe<UserEnrolledInTopicsAggregateInput>;
  OR?: InputMaybe<Array<UserEnrolledInTopicsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<EnrolledInPropertiesAggregationWhereInput>;
  node?: InputMaybe<UserEnrolledInTopicsNodeAggregationWhereInput>;
};

export type UserEnrolledInTopicsConnectFieldInput = {
  connect?: InputMaybe<Array<TopicConnectInput>>;
  edge: EnrolledInPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TopicConnectWhere>;
};

export type UserEnrolledInTopicsConnection = {
  __typename?: 'UserEnrolledInTopicsConnection';
  edges: Array<UserEnrolledInTopicsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserEnrolledInTopicsConnectionSort = {
  edge?: InputMaybe<EnrolledInPropertiesSort>;
  node?: InputMaybe<TopicSort>;
};

export type UserEnrolledInTopicsConnectionWhere = {
  AND?: InputMaybe<Array<UserEnrolledInTopicsConnectionWhere>>;
  NOT?: InputMaybe<UserEnrolledInTopicsConnectionWhere>;
  OR?: InputMaybe<Array<UserEnrolledInTopicsConnectionWhere>>;
  edge?: InputMaybe<EnrolledInPropertiesWhere>;
  node?: InputMaybe<TopicWhere>;
};

export type UserEnrolledInTopicsCreateFieldInput = {
  edge: EnrolledInPropertiesCreateInput;
  node: TopicCreateInput;
};

export type UserEnrolledInTopicsDeleteFieldInput = {
  delete?: InputMaybe<TopicDeleteInput>;
  where?: InputMaybe<UserEnrolledInTopicsConnectionWhere>;
};

export type UserEnrolledInTopicsDisconnectFieldInput = {
  disconnect?: InputMaybe<TopicDisconnectInput>;
  where?: InputMaybe<UserEnrolledInTopicsConnectionWhere>;
};

export type UserEnrolledInTopicsFieldInput = {
  connect?: InputMaybe<Array<UserEnrolledInTopicsConnectFieldInput>>;
  create?: InputMaybe<Array<UserEnrolledInTopicsCreateFieldInput>>;
};

export type UserEnrolledInTopicsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserEnrolledInTopicsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserEnrolledInTopicsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserEnrolledInTopicsNodeAggregationWhereInput>>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  imageUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  imageUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  imageUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  imageUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  imageUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  imageUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  imageUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  imageUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  imageUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  imageUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  imageUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  imageUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  imageUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  imageUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  imageUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mastery_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mastery_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  mastery_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  mastery_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  mastery_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  mastery_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mastery_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  mastery_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  mastery_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  mastery_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  mastery_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mastery_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  mastery_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  mastery_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  mastery_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  mastery_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mastery_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  mastery_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  mastery_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  mastery_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserEnrolledInTopicsRelationship = {
  __typename?: 'UserEnrolledInTopicsRelationship';
  cursor: Scalars['String']['output'];
  node: Topic;
  properties: EnrolledInProperties;
};

export type UserEnrolledInTopicsUpdateConnectionInput = {
  edge?: InputMaybe<EnrolledInPropertiesUpdateInput>;
  node?: InputMaybe<TopicUpdateInput>;
};

export type UserEnrolledInTopicsUpdateFieldInput = {
  connect?: InputMaybe<Array<UserEnrolledInTopicsConnectFieldInput>>;
  create?: InputMaybe<Array<UserEnrolledInTopicsCreateFieldInput>>;
  delete?: InputMaybe<Array<UserEnrolledInTopicsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserEnrolledInTopicsDisconnectFieldInput>>;
  update?: InputMaybe<UserEnrolledInTopicsUpdateConnectionInput>;
  where?: InputMaybe<UserEnrolledInTopicsConnectionWhere>;
};

export type UserFileHasFileAggregationSelection = {
  __typename?: 'UserFileHasFileAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserFileHasFileNodeAggregateSelection>;
};

export type UserFileHasFileNodeAggregateSelection = {
  __typename?: 'UserFileHasFileNodeAggregateSelection';
  bucketName: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  fileName: StringAggregateSelection;
  filePath: StringAggregateSelection;
  fileURL: StringAggregateSelection;
  id: IdAggregateSelection;
};

export type UserFileHasRosterExportAggregationSelection = {
  __typename?: 'UserFileHasRosterExportAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<UserFileHasRosterExportEdgeAggregateSelection>;
  node?: Maybe<UserFileHasRosterExportNodeAggregateSelection>;
};

export type UserFileHasRosterExportEdgeAggregateSelection = {
  __typename?: 'UserFileHasRosterExportEdgeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  kind: StringAggregateSelection;
  rowCount: IntAggregateSelection;
};

export type UserFileHasRosterExportNodeAggregateSelection = {
  __typename?: 'UserFileHasRosterExportNodeAggregateSelection';
  bucketName: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  fileName: StringAggregateSelection;
  filePath: StringAggregateSelection;
  fileURL: StringAggregateSelection;
  id: IdAggregateSelection;
};

export type UserFileHasSubmissionExportAggregationSelection = {
  __typename?: 'UserFileHasSubmissionExportAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<UserFileHasSubmissionExportEdgeAggregateSelection>;
  node?: Maybe<UserFileHasSubmissionExportNodeAggregateSelection>;
};

export type UserFileHasSubmissionExportEdgeAggregateSelection = {
  __typename?: 'UserFileHasSubmissionExportEdgeAggregateSelection';
  createdAt: DateTimeAggregateSelection;
  kind: StringAggregateSelection;
  rowCount: IntAggregateSelection;
};

export type UserFileHasSubmissionExportNodeAggregateSelection = {
  __typename?: 'UserFileHasSubmissionExportNodeAggregateSelection';
  bucketName: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  fileName: StringAggregateSelection;
  filePath: StringAggregateSelection;
  fileURL: StringAggregateSelection;
  id: IdAggregateSelection;
};

export type UserFoodItemHasFoodItemFoodItemsAggregationSelection = {
  __typename?: 'UserFoodItemHasFoodItemFoodItemsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<UserFoodItemHasFoodItemFoodItemsEdgeAggregateSelection>;
  node?: Maybe<UserFoodItemHasFoodItemFoodItemsNodeAggregateSelection>;
};

export type UserFoodItemHasFoodItemFoodItemsEdgeAggregateSelection = {
  __typename?: 'UserFoodItemHasFoodItemFoodItemsEdgeAggregateSelection';
  consumption_date: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  date: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  meal: StringAggregateSelection;
  meal_date: StringAggregateSelection;
  meal_time: StringAggregateSelection;
  meal_type: StringAggregateSelection;
  portion: FloatAggregateSelection;
  quality: BigIntAggregateSelection;
  quantity: FloatAggregateSelection;
  strength: BigIntAggregateSelection;
  time: StringAggregateSelection;
};

export type UserFoodItemHasFoodItemFoodItemsNodeAggregateSelection = {
  __typename?: 'UserFoodItemHasFoodItemFoodItemsNodeAggregateSelection';
  calories: FloatAggregateSelection;
  created: DateTimeAggregateSelection;
  date: DateTimeAggregateSelection;
  id: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  name: StringAggregateSelection;
  serving_size: StringAggregateSelection;
  sugar_grams: FloatAggregateSelection;
};

export type UserFoodItemUndefinedFoodItemsAggregationSelection = {
  __typename?: 'UserFoodItemUndefinedFoodItemsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<UserFoodItemUndefinedFoodItemsEdgeAggregateSelection>;
  node?: Maybe<UserFoodItemUndefinedFoodItemsNodeAggregateSelection>;
};

export type UserFoodItemUndefinedFoodItemsEdgeAggregateSelection = {
  __typename?: 'UserFoodItemUndefinedFoodItemsEdgeAggregateSelection';
  created: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  quality: BigIntAggregateSelection;
  strength: BigIntAggregateSelection;
};

export type UserFoodItemUndefinedFoodItemsNodeAggregateSelection = {
  __typename?: 'UserFoodItemUndefinedFoodItemsNodeAggregateSelection';
  calories: FloatAggregateSelection;
  created: DateTimeAggregateSelection;
  date: DateTimeAggregateSelection;
  id: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  name: StringAggregateSelection;
  serving_size: StringAggregateSelection;
  sugar_grams: FloatAggregateSelection;
};

export type UserHasChatChatsAggregateInput = {
  AND?: InputMaybe<Array<UserHasChatChatsAggregateInput>>;
  NOT?: InputMaybe<UserHasChatChatsAggregateInput>;
  OR?: InputMaybe<Array<UserHasChatChatsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasChatPropertiesAggregationWhereInput>;
  node?: InputMaybe<UserHasChatChatsNodeAggregationWhereInput>;
};

export type UserHasChatChatsConnectFieldInput = {
  connect?: InputMaybe<Array<ChatConnectInput>>;
  edge?: InputMaybe<HasChatPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ChatConnectWhere>;
};

export type UserHasChatChatsConnectOrCreateFieldInput = {
  onCreate: UserHasChatChatsConnectOrCreateFieldInputOnCreate;
  where: ChatConnectOrCreateWhere;
};

export type UserHasChatChatsConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<HasChatPropertiesCreateInput>;
  node: ChatOnCreateInput;
};

export type UserHasChatChatsConnection = {
  __typename?: 'UserHasChatChatsConnection';
  edges: Array<UserHasChatChatsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserHasChatChatsConnectionSort = {
  edge?: InputMaybe<HasChatPropertiesSort>;
  node?: InputMaybe<ChatSort>;
};

export type UserHasChatChatsConnectionWhere = {
  AND?: InputMaybe<Array<UserHasChatChatsConnectionWhere>>;
  NOT?: InputMaybe<UserHasChatChatsConnectionWhere>;
  OR?: InputMaybe<Array<UserHasChatChatsConnectionWhere>>;
  edge?: InputMaybe<HasChatPropertiesWhere>;
  node?: InputMaybe<ChatWhere>;
};

export type UserHasChatChatsCreateFieldInput = {
  edge?: InputMaybe<HasChatPropertiesCreateInput>;
  node: ChatCreateInput;
};

export type UserHasChatChatsDeleteFieldInput = {
  delete?: InputMaybe<ChatDeleteInput>;
  where?: InputMaybe<UserHasChatChatsConnectionWhere>;
};

export type UserHasChatChatsDisconnectFieldInput = {
  disconnect?: InputMaybe<ChatDisconnectInput>;
  where?: InputMaybe<UserHasChatChatsConnectionWhere>;
};

export type UserHasChatChatsFieldInput = {
  connect?: InputMaybe<Array<UserHasChatChatsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserHasChatChatsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserHasChatChatsCreateFieldInput>>;
};

export type UserHasChatChatsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserHasChatChatsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserHasChatChatsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserHasChatChatsNodeAggregationWhereInput>>;
  context_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  context_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  schemaVersion_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  schemaVersion_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  schemaVersion_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  schemaVersion_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  schemaVersion_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserHasChatChatsRelationship = {
  __typename?: 'UserHasChatChatsRelationship';
  cursor: Scalars['String']['output'];
  node: Chat;
  properties: HasChatProperties;
};

export type UserHasChatChatsUpdateConnectionInput = {
  edge?: InputMaybe<HasChatPropertiesUpdateInput>;
  node?: InputMaybe<ChatUpdateInput>;
};

export type UserHasChatChatsUpdateFieldInput = {
  connect?: InputMaybe<Array<UserHasChatChatsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserHasChatChatsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserHasChatChatsCreateFieldInput>>;
  delete?: InputMaybe<Array<UserHasChatChatsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserHasChatChatsDisconnectFieldInput>>;
  update?: InputMaybe<UserHasChatChatsUpdateConnectionInput>;
  where?: InputMaybe<UserHasChatChatsConnectionWhere>;
};

export type UserHasFileAggregateInput = {
  AND?: InputMaybe<Array<UserHasFileAggregateInput>>;
  NOT?: InputMaybe<UserHasFileAggregateInput>;
  OR?: InputMaybe<Array<UserHasFileAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserHasFileNodeAggregationWhereInput>;
};

export type UserHasFileConnectFieldInput = {
  connect?: InputMaybe<Array<FileConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FileConnectWhere>;
};

export type UserHasFileConnectOrCreateFieldInput = {
  onCreate: UserHasFileConnectOrCreateFieldInputOnCreate;
  where: FileConnectOrCreateWhere;
};

export type UserHasFileConnectOrCreateFieldInputOnCreate = {
  node: FileOnCreateInput;
};

export type UserHasFileConnection = {
  __typename?: 'UserHasFileConnection';
  edges: Array<UserHasFileRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserHasFileConnectionSort = {
  node?: InputMaybe<FileSort>;
};

export type UserHasFileConnectionWhere = {
  AND?: InputMaybe<Array<UserHasFileConnectionWhere>>;
  NOT?: InputMaybe<UserHasFileConnectionWhere>;
  OR?: InputMaybe<Array<UserHasFileConnectionWhere>>;
  node?: InputMaybe<FileWhere>;
};

export type UserHasFileCreateFieldInput = {
  node: FileCreateInput;
};

export type UserHasFileDeleteFieldInput = {
  delete?: InputMaybe<FileDeleteInput>;
  where?: InputMaybe<UserHasFileConnectionWhere>;
};

export type UserHasFileDisconnectFieldInput = {
  disconnect?: InputMaybe<FileDisconnectInput>;
  where?: InputMaybe<UserHasFileConnectionWhere>;
};

export type UserHasFileFieldInput = {
  connect?: InputMaybe<Array<UserHasFileConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserHasFileConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserHasFileCreateFieldInput>>;
};

export type UserHasFileNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserHasFileNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserHasFileNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserHasFileNodeAggregationWhereInput>>;
  bucketName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  bucketName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  fileName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileURL_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserHasFileRelationship = {
  __typename?: 'UserHasFileRelationship';
  cursor: Scalars['String']['output'];
  node: File;
};

export type UserHasFileUpdateConnectionInput = {
  node?: InputMaybe<FileUpdateInput>;
};

export type UserHasFileUpdateFieldInput = {
  connect?: InputMaybe<Array<UserHasFileConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserHasFileConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserHasFileCreateFieldInput>>;
  delete?: InputMaybe<Array<UserHasFileDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserHasFileDisconnectFieldInput>>;
  update?: InputMaybe<UserHasFileUpdateConnectionInput>;
  where?: InputMaybe<UserHasFileConnectionWhere>;
};

export type UserHasFoodItemFoodItemsAggregateInput = {
  AND?: InputMaybe<Array<UserHasFoodItemFoodItemsAggregateInput>>;
  NOT?: InputMaybe<UserHasFoodItemFoodItemsAggregateInput>;
  OR?: InputMaybe<Array<UserHasFoodItemFoodItemsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasFoodItemPropertiesAggregationWhereInput>;
  node?: InputMaybe<UserHasFoodItemFoodItemsNodeAggregationWhereInput>;
};

export type UserHasFoodItemFoodItemsConnectFieldInput = {
  connect?: InputMaybe<Array<FoodItemConnectInput>>;
  edge: HasFoodItemPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FoodItemConnectWhere>;
};

export type UserHasFoodItemFoodItemsConnection = {
  __typename?: 'UserHasFoodItemFoodItemsConnection';
  edges: Array<UserHasFoodItemFoodItemsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserHasFoodItemFoodItemsConnectionSort = {
  edge?: InputMaybe<HasFoodItemPropertiesSort>;
  node?: InputMaybe<FoodItemSort>;
};

export type UserHasFoodItemFoodItemsConnectionWhere = {
  AND?: InputMaybe<Array<UserHasFoodItemFoodItemsConnectionWhere>>;
  NOT?: InputMaybe<UserHasFoodItemFoodItemsConnectionWhere>;
  OR?: InputMaybe<Array<UserHasFoodItemFoodItemsConnectionWhere>>;
  edge?: InputMaybe<HasFoodItemPropertiesWhere>;
  node?: InputMaybe<FoodItemWhere>;
};

export type UserHasFoodItemFoodItemsCreateFieldInput = {
  edge: HasFoodItemPropertiesCreateInput;
  node: FoodItemCreateInput;
};

export type UserHasFoodItemFoodItemsDeleteFieldInput = {
  delete?: InputMaybe<FoodItemDeleteInput>;
  where?: InputMaybe<UserHasFoodItemFoodItemsConnectionWhere>;
};

export type UserHasFoodItemFoodItemsDisconnectFieldInput = {
  disconnect?: InputMaybe<FoodItemDisconnectInput>;
  where?: InputMaybe<UserHasFoodItemFoodItemsConnectionWhere>;
};

export type UserHasFoodItemFoodItemsFieldInput = {
  connect?: InputMaybe<Array<UserHasFoodItemFoodItemsConnectFieldInput>>;
  create?: InputMaybe<Array<UserHasFoodItemFoodItemsCreateFieldInput>>;
};

export type UserHasFoodItemFoodItemsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserHasFoodItemFoodItemsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserHasFoodItemFoodItemsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserHasFoodItemFoodItemsNodeAggregationWhereInput>>;
  calories_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  calories_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  calories_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  calories_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  calories_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  calories_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  calories_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  calories_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  calories_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  calories_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  calories_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  calories_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  calories_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  calories_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  calories_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  calories_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  calories_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  calories_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  calories_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  calories_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  serving_size_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  serving_size_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  serving_size_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  serving_size_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  serving_size_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  serving_size_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  serving_size_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  serving_size_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  serving_size_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  serving_size_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  serving_size_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  serving_size_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  serving_size_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  serving_size_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  serving_size_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sugar_grams_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type UserHasFoodItemFoodItemsRelationship = {
  __typename?: 'UserHasFoodItemFoodItemsRelationship';
  cursor: Scalars['String']['output'];
  node: FoodItem;
  properties: HasFoodItemProperties;
};

export type UserHasFoodItemFoodItemsUpdateConnectionInput = {
  edge?: InputMaybe<HasFoodItemPropertiesUpdateInput>;
  node?: InputMaybe<FoodItemUpdateInput>;
};

export type UserHasFoodItemFoodItemsUpdateFieldInput = {
  connect?: InputMaybe<Array<UserHasFoodItemFoodItemsConnectFieldInput>>;
  create?: InputMaybe<Array<UserHasFoodItemFoodItemsCreateFieldInput>>;
  delete?: InputMaybe<Array<UserHasFoodItemFoodItemsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserHasFoodItemFoodItemsDisconnectFieldInput>>;
  update?: InputMaybe<UserHasFoodItemFoodItemsUpdateConnectionInput>;
  where?: InputMaybe<UserHasFoodItemFoodItemsConnectionWhere>;
};

export type UserHasKnowledgeChaptersAggregateInput = {
  AND?: InputMaybe<Array<UserHasKnowledgeChaptersAggregateInput>>;
  NOT?: InputMaybe<UserHasKnowledgeChaptersAggregateInput>;
  OR?: InputMaybe<Array<UserHasKnowledgeChaptersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasKnowledgePropertiesAggregationWhereInput>;
  node?: InputMaybe<UserHasKnowledgeChaptersNodeAggregationWhereInput>;
};

export type UserHasKnowledgeChaptersConnectFieldInput = {
  connect?: InputMaybe<Array<ChapterConnectInput>>;
  edge: HasKnowledgePropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ChapterConnectWhere>;
};

export type UserHasKnowledgeChaptersConnection = {
  __typename?: 'UserHasKnowledgeChaptersConnection';
  edges: Array<UserHasKnowledgeChaptersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserHasKnowledgeChaptersConnectionSort = {
  edge?: InputMaybe<HasKnowledgePropertiesSort>;
  node?: InputMaybe<ChapterSort>;
};

export type UserHasKnowledgeChaptersConnectionWhere = {
  AND?: InputMaybe<Array<UserHasKnowledgeChaptersConnectionWhere>>;
  NOT?: InputMaybe<UserHasKnowledgeChaptersConnectionWhere>;
  OR?: InputMaybe<Array<UserHasKnowledgeChaptersConnectionWhere>>;
  edge?: InputMaybe<HasKnowledgePropertiesWhere>;
  node?: InputMaybe<ChapterWhere>;
};

export type UserHasKnowledgeChaptersCreateFieldInput = {
  edge: HasKnowledgePropertiesCreateInput;
  node: ChapterCreateInput;
};

export type UserHasKnowledgeChaptersDeleteFieldInput = {
  delete?: InputMaybe<ChapterDeleteInput>;
  where?: InputMaybe<UserHasKnowledgeChaptersConnectionWhere>;
};

export type UserHasKnowledgeChaptersDisconnectFieldInput = {
  disconnect?: InputMaybe<ChapterDisconnectInput>;
  where?: InputMaybe<UserHasKnowledgeChaptersConnectionWhere>;
};

export type UserHasKnowledgeChaptersFieldInput = {
  connect?: InputMaybe<Array<UserHasKnowledgeChaptersConnectFieldInput>>;
  create?: InputMaybe<Array<UserHasKnowledgeChaptersCreateFieldInput>>;
};

export type UserHasKnowledgeChaptersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserHasKnowledgeChaptersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserHasKnowledgeChaptersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserHasKnowledgeChaptersNodeAggregationWhereInput>>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserHasKnowledgeChaptersRelationship = {
  __typename?: 'UserHasKnowledgeChaptersRelationship';
  cursor: Scalars['String']['output'];
  node: Chapter;
  properties: HasKnowledgeProperties;
};

export type UserHasKnowledgeChaptersUpdateConnectionInput = {
  edge?: InputMaybe<HasKnowledgePropertiesUpdateInput>;
  node?: InputMaybe<ChapterUpdateInput>;
};

export type UserHasKnowledgeChaptersUpdateFieldInput = {
  connect?: InputMaybe<Array<UserHasKnowledgeChaptersConnectFieldInput>>;
  create?: InputMaybe<Array<UserHasKnowledgeChaptersCreateFieldInput>>;
  delete?: InputMaybe<Array<UserHasKnowledgeChaptersDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserHasKnowledgeChaptersDisconnectFieldInput>>;
  update?: InputMaybe<UserHasKnowledgeChaptersUpdateConnectionInput>;
  where?: InputMaybe<UserHasKnowledgeChaptersConnectionWhere>;
};

export type UserHasKnowledgeSubchaptersAggregateInput = {
  AND?: InputMaybe<Array<UserHasKnowledgeSubchaptersAggregateInput>>;
  NOT?: InputMaybe<UserHasKnowledgeSubchaptersAggregateInput>;
  OR?: InputMaybe<Array<UserHasKnowledgeSubchaptersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasKnowledgePropertiesAggregationWhereInput>;
  node?: InputMaybe<UserHasKnowledgeSubchaptersNodeAggregationWhereInput>;
};

export type UserHasKnowledgeSubchaptersConnectFieldInput = {
  edge: HasKnowledgePropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SubchapterConnectWhere>;
};

export type UserHasKnowledgeSubchaptersConnection = {
  __typename?: 'UserHasKnowledgeSubchaptersConnection';
  edges: Array<UserHasKnowledgeSubchaptersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserHasKnowledgeSubchaptersConnectionSort = {
  edge?: InputMaybe<HasKnowledgePropertiesSort>;
  node?: InputMaybe<SubchapterSort>;
};

export type UserHasKnowledgeSubchaptersConnectionWhere = {
  AND?: InputMaybe<Array<UserHasKnowledgeSubchaptersConnectionWhere>>;
  NOT?: InputMaybe<UserHasKnowledgeSubchaptersConnectionWhere>;
  OR?: InputMaybe<Array<UserHasKnowledgeSubchaptersConnectionWhere>>;
  edge?: InputMaybe<HasKnowledgePropertiesWhere>;
  node?: InputMaybe<SubchapterWhere>;
};

export type UserHasKnowledgeSubchaptersCreateFieldInput = {
  edge: HasKnowledgePropertiesCreateInput;
  node: SubchapterCreateInput;
};

export type UserHasKnowledgeSubchaptersDeleteFieldInput = {
  where?: InputMaybe<UserHasKnowledgeSubchaptersConnectionWhere>;
};

export type UserHasKnowledgeSubchaptersDisconnectFieldInput = {
  where?: InputMaybe<UserHasKnowledgeSubchaptersConnectionWhere>;
};

export type UserHasKnowledgeSubchaptersFieldInput = {
  connect?: InputMaybe<Array<UserHasKnowledgeSubchaptersConnectFieldInput>>;
  create?: InputMaybe<Array<UserHasKnowledgeSubchaptersCreateFieldInput>>;
};

export type UserHasKnowledgeSubchaptersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserHasKnowledgeSubchaptersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserHasKnowledgeSubchaptersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserHasKnowledgeSubchaptersNodeAggregationWhereInput>>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserHasKnowledgeSubchaptersRelationship = {
  __typename?: 'UserHasKnowledgeSubchaptersRelationship';
  cursor: Scalars['String']['output'];
  node: Subchapter;
  properties: HasKnowledgeProperties;
};

export type UserHasKnowledgeSubchaptersUpdateConnectionInput = {
  edge?: InputMaybe<HasKnowledgePropertiesUpdateInput>;
  node?: InputMaybe<SubchapterUpdateInput>;
};

export type UserHasKnowledgeSubchaptersUpdateFieldInput = {
  connect?: InputMaybe<Array<UserHasKnowledgeSubchaptersConnectFieldInput>>;
  create?: InputMaybe<Array<UserHasKnowledgeSubchaptersCreateFieldInput>>;
  delete?: InputMaybe<Array<UserHasKnowledgeSubchaptersDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserHasKnowledgeSubchaptersDisconnectFieldInput>>;
  update?: InputMaybe<UserHasKnowledgeSubchaptersUpdateConnectionInput>;
  where?: InputMaybe<UserHasKnowledgeSubchaptersConnectionWhere>;
};

export type UserHasKnowledgeTopicsAggregateInput = {
  AND?: InputMaybe<Array<UserHasKnowledgeTopicsAggregateInput>>;
  NOT?: InputMaybe<UserHasKnowledgeTopicsAggregateInput>;
  OR?: InputMaybe<Array<UserHasKnowledgeTopicsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasKnowledgePropertiesAggregationWhereInput>;
  node?: InputMaybe<UserHasKnowledgeTopicsNodeAggregationWhereInput>;
};

export type UserHasKnowledgeTopicsConnectFieldInput = {
  connect?: InputMaybe<Array<TopicConnectInput>>;
  edge: HasKnowledgePropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TopicConnectWhere>;
};

export type UserHasKnowledgeTopicsConnection = {
  __typename?: 'UserHasKnowledgeTopicsConnection';
  edges: Array<UserHasKnowledgeTopicsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserHasKnowledgeTopicsConnectionSort = {
  edge?: InputMaybe<HasKnowledgePropertiesSort>;
  node?: InputMaybe<TopicSort>;
};

export type UserHasKnowledgeTopicsConnectionWhere = {
  AND?: InputMaybe<Array<UserHasKnowledgeTopicsConnectionWhere>>;
  NOT?: InputMaybe<UserHasKnowledgeTopicsConnectionWhere>;
  OR?: InputMaybe<Array<UserHasKnowledgeTopicsConnectionWhere>>;
  edge?: InputMaybe<HasKnowledgePropertiesWhere>;
  node?: InputMaybe<TopicWhere>;
};

export type UserHasKnowledgeTopicsCreateFieldInput = {
  edge: HasKnowledgePropertiesCreateInput;
  node: TopicCreateInput;
};

export type UserHasKnowledgeTopicsDeleteFieldInput = {
  delete?: InputMaybe<TopicDeleteInput>;
  where?: InputMaybe<UserHasKnowledgeTopicsConnectionWhere>;
};

export type UserHasKnowledgeTopicsDisconnectFieldInput = {
  disconnect?: InputMaybe<TopicDisconnectInput>;
  where?: InputMaybe<UserHasKnowledgeTopicsConnectionWhere>;
};

export type UserHasKnowledgeTopicsFieldInput = {
  connect?: InputMaybe<Array<UserHasKnowledgeTopicsConnectFieldInput>>;
  create?: InputMaybe<Array<UserHasKnowledgeTopicsCreateFieldInput>>;
};

export type UserHasKnowledgeTopicsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserHasKnowledgeTopicsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserHasKnowledgeTopicsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserHasKnowledgeTopicsNodeAggregationWhereInput>>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  imageUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  imageUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  imageUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  imageUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  imageUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  imageUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  imageUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  imageUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  imageUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  imageUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  imageUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  imageUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  imageUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  imageUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  imageUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mastery_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mastery_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  mastery_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  mastery_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  mastery_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  mastery_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mastery_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  mastery_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  mastery_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  mastery_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  mastery_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mastery_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  mastery_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  mastery_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  mastery_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  mastery_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mastery_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  mastery_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  mastery_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  mastery_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserHasKnowledgeTopicsRelationship = {
  __typename?: 'UserHasKnowledgeTopicsRelationship';
  cursor: Scalars['String']['output'];
  node: Topic;
  properties: HasKnowledgeProperties;
};

export type UserHasKnowledgeTopicsUpdateConnectionInput = {
  edge?: InputMaybe<HasKnowledgePropertiesUpdateInput>;
  node?: InputMaybe<TopicUpdateInput>;
};

export type UserHasKnowledgeTopicsUpdateFieldInput = {
  connect?: InputMaybe<Array<UserHasKnowledgeTopicsConnectFieldInput>>;
  create?: InputMaybe<Array<UserHasKnowledgeTopicsCreateFieldInput>>;
  delete?: InputMaybe<Array<UserHasKnowledgeTopicsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserHasKnowledgeTopicsDisconnectFieldInput>>;
  update?: InputMaybe<UserHasKnowledgeTopicsUpdateConnectionInput>;
  where?: InputMaybe<UserHasKnowledgeTopicsConnectionWhere>;
};

export type UserHasLearningPreferencesAggregateInput = {
  AND?: InputMaybe<Array<UserHasLearningPreferencesAggregateInput>>;
  NOT?: InputMaybe<UserHasLearningPreferencesAggregateInput>;
  OR?: InputMaybe<Array<UserHasLearningPreferencesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserHasLearningPreferencesNodeAggregationWhereInput>;
};

export type UserHasLearningPreferencesConnectFieldInput = {
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserLearningPreferencesConnectWhere>;
};

export type UserHasLearningPreferencesConnectOrCreateFieldInput = {
  onCreate: UserHasLearningPreferencesConnectOrCreateFieldInputOnCreate;
  where: UserLearningPreferencesConnectOrCreateWhere;
};

export type UserHasLearningPreferencesConnectOrCreateFieldInputOnCreate = {
  node: UserLearningPreferencesOnCreateInput;
};

export type UserHasLearningPreferencesConnection = {
  __typename?: 'UserHasLearningPreferencesConnection';
  edges: Array<UserHasLearningPreferencesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserHasLearningPreferencesConnectionSort = {
  node?: InputMaybe<UserLearningPreferencesSort>;
};

export type UserHasLearningPreferencesConnectionWhere = {
  AND?: InputMaybe<Array<UserHasLearningPreferencesConnectionWhere>>;
  NOT?: InputMaybe<UserHasLearningPreferencesConnectionWhere>;
  OR?: InputMaybe<Array<UserHasLearningPreferencesConnectionWhere>>;
  node?: InputMaybe<UserLearningPreferencesWhere>;
};

export type UserHasLearningPreferencesCreateFieldInput = {
  node: UserLearningPreferencesCreateInput;
};

export type UserHasLearningPreferencesDeleteFieldInput = {
  where?: InputMaybe<UserHasLearningPreferencesConnectionWhere>;
};

export type UserHasLearningPreferencesDisconnectFieldInput = {
  where?: InputMaybe<UserHasLearningPreferencesConnectionWhere>;
};

export type UserHasLearningPreferencesFieldInput = {
  connect?: InputMaybe<UserHasLearningPreferencesConnectFieldInput>;
  connectOrCreate?: InputMaybe<UserHasLearningPreferencesConnectOrCreateFieldInput>;
  create?: InputMaybe<UserHasLearningPreferencesCreateFieldInput>;
};

export type UserHasLearningPreferencesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserHasLearningPreferencesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserHasLearningPreferencesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserHasLearningPreferencesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  semesterGoal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  semesterGoal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  semesterGoal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  semesterGoal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  semesterGoal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  semesterGoal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  semesterGoal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  semesterGoal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  semesterGoal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  semesterGoal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  semesterGoal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  semesterGoal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  semesterGoal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  semesterGoal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  semesterGoal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserHasLearningPreferencesRelationship = {
  __typename?: 'UserHasLearningPreferencesRelationship';
  cursor: Scalars['String']['output'];
  node: UserLearningPreferences;
};

export type UserHasLearningPreferencesUpdateConnectionInput = {
  node?: InputMaybe<UserLearningPreferencesUpdateInput>;
};

export type UserHasLearningPreferencesUpdateFieldInput = {
  connect?: InputMaybe<UserHasLearningPreferencesConnectFieldInput>;
  connectOrCreate?: InputMaybe<UserHasLearningPreferencesConnectOrCreateFieldInput>;
  create?: InputMaybe<UserHasLearningPreferencesCreateFieldInput>;
  delete?: InputMaybe<UserHasLearningPreferencesDeleteFieldInput>;
  disconnect?: InputMaybe<UserHasLearningPreferencesDisconnectFieldInput>;
  update?: InputMaybe<UserHasLearningPreferencesUpdateConnectionInput>;
  where?: InputMaybe<UserHasLearningPreferencesConnectionWhere>;
};

export type UserHasPaymentPaymentsAggregateInput = {
  AND?: InputMaybe<Array<UserHasPaymentPaymentsAggregateInput>>;
  NOT?: InputMaybe<UserHasPaymentPaymentsAggregateInput>;
  OR?: InputMaybe<Array<UserHasPaymentPaymentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasPaymentPropertiesAggregationWhereInput>;
  node?: InputMaybe<UserHasPaymentPaymentsNodeAggregationWhereInput>;
};

export type UserHasPaymentPaymentsConnectFieldInput = {
  connect?: InputMaybe<Array<PaymentConnectInput>>;
  edge: HasPaymentPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PaymentConnectWhere>;
};

export type UserHasPaymentPaymentsConnection = {
  __typename?: 'UserHasPaymentPaymentsConnection';
  edges: Array<UserHasPaymentPaymentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserHasPaymentPaymentsConnectionSort = {
  edge?: InputMaybe<HasPaymentPropertiesSort>;
  node?: InputMaybe<PaymentSort>;
};

export type UserHasPaymentPaymentsConnectionWhere = {
  AND?: InputMaybe<Array<UserHasPaymentPaymentsConnectionWhere>>;
  NOT?: InputMaybe<UserHasPaymentPaymentsConnectionWhere>;
  OR?: InputMaybe<Array<UserHasPaymentPaymentsConnectionWhere>>;
  edge?: InputMaybe<HasPaymentPropertiesWhere>;
  node?: InputMaybe<PaymentWhere>;
};

export type UserHasPaymentPaymentsCreateFieldInput = {
  edge: HasPaymentPropertiesCreateInput;
  node: PaymentCreateInput;
};

export type UserHasPaymentPaymentsDeleteFieldInput = {
  delete?: InputMaybe<PaymentDeleteInput>;
  where?: InputMaybe<UserHasPaymentPaymentsConnectionWhere>;
};

export type UserHasPaymentPaymentsDisconnectFieldInput = {
  disconnect?: InputMaybe<PaymentDisconnectInput>;
  where?: InputMaybe<UserHasPaymentPaymentsConnectionWhere>;
};

export type UserHasPaymentPaymentsFieldInput = {
  connect?: InputMaybe<Array<UserHasPaymentPaymentsConnectFieldInput>>;
  create?: InputMaybe<Array<UserHasPaymentPaymentsCreateFieldInput>>;
};

export type UserHasPaymentPaymentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserHasPaymentPaymentsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserHasPaymentPaymentsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserHasPaymentPaymentsNodeAggregationWhereInput>>;
  domain_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domain_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserHasPaymentPaymentsRelationship = {
  __typename?: 'UserHasPaymentPaymentsRelationship';
  cursor: Scalars['String']['output'];
  node: Payment;
  properties: HasPaymentProperties;
};

export type UserHasPaymentPaymentsUpdateConnectionInput = {
  edge?: InputMaybe<HasPaymentPropertiesUpdateInput>;
  node?: InputMaybe<PaymentUpdateInput>;
};

export type UserHasPaymentPaymentsUpdateFieldInput = {
  connect?: InputMaybe<Array<UserHasPaymentPaymentsConnectFieldInput>>;
  create?: InputMaybe<Array<UserHasPaymentPaymentsCreateFieldInput>>;
  delete?: InputMaybe<Array<UserHasPaymentPaymentsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserHasPaymentPaymentsDisconnectFieldInput>>;
  update?: InputMaybe<UserHasPaymentPaymentsUpdateConnectionInput>;
  where?: InputMaybe<UserHasPaymentPaymentsConnectionWhere>;
};

export type UserHasPreferencesPreferencesAggregateInput = {
  AND?: InputMaybe<Array<UserHasPreferencesPreferencesAggregateInput>>;
  NOT?: InputMaybe<UserHasPreferencesPreferencesAggregateInput>;
  OR?: InputMaybe<Array<UserHasPreferencesPreferencesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserHasPreferencesPreferencesNodeAggregationWhereInput>;
};

export type UserHasPreferencesPreferencesConnectFieldInput = {
  connect?: InputMaybe<Array<PreferencesConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PreferencesConnectWhere>;
};

export type UserHasPreferencesPreferencesConnection = {
  __typename?: 'UserHasPreferencesPreferencesConnection';
  edges: Array<UserHasPreferencesPreferencesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserHasPreferencesPreferencesConnectionSort = {
  node?: InputMaybe<PreferencesSort>;
};

export type UserHasPreferencesPreferencesConnectionWhere = {
  AND?: InputMaybe<Array<UserHasPreferencesPreferencesConnectionWhere>>;
  NOT?: InputMaybe<UserHasPreferencesPreferencesConnectionWhere>;
  OR?: InputMaybe<Array<UserHasPreferencesPreferencesConnectionWhere>>;
  node?: InputMaybe<PreferencesWhere>;
};

export type UserHasPreferencesPreferencesCreateFieldInput = {
  node: PreferencesCreateInput;
};

export type UserHasPreferencesPreferencesDeleteFieldInput = {
  delete?: InputMaybe<PreferencesDeleteInput>;
  where?: InputMaybe<UserHasPreferencesPreferencesConnectionWhere>;
};

export type UserHasPreferencesPreferencesDisconnectFieldInput = {
  disconnect?: InputMaybe<PreferencesDisconnectInput>;
  where?: InputMaybe<UserHasPreferencesPreferencesConnectionWhere>;
};

export type UserHasPreferencesPreferencesFieldInput = {
  connect?: InputMaybe<Array<UserHasPreferencesPreferencesConnectFieldInput>>;
  create?: InputMaybe<Array<UserHasPreferencesPreferencesCreateFieldInput>>;
};

export type UserHasPreferencesPreferencesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserHasPreferencesPreferencesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserHasPreferencesPreferencesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserHasPreferencesPreferencesNodeAggregationWhereInput>>;
  contentType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contentType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contentType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contentType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contentType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contentType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contentType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contentType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contentType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contentType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contentType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contentType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contentType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contentType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contentType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  language_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  language_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  language_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  language_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  language_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  language_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  language_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  language_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  language_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  language_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  language_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  language_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  language_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  language_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  language_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningDuration_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  learningDuration_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  learningDuration_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  learningDuration_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  learningDuration_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  learningDuration_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningDuration_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  learningDuration_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningDuration_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  learningDuration_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningDuration_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningDuration_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  learningDuration_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningDuration_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  learningDuration_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningDuration_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningDuration_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  learningDuration_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningDuration_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  learningDuration_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningStyle_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  learningStyle_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  learningStyle_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  learningStyle_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  learningStyle_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  learningStyle_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStyle_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStyle_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStyle_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStyle_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningStyle_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStyle_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStyle_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStyle_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStyle_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  notificationPreferences_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  notificationPreferences_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  notificationPreferences_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  notificationPreferences_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  notificationPreferences_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  notificationPreferences_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  notificationPreferences_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  notificationPreferences_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  notificationPreferences_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  notificationPreferences_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  notificationPreferences_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  notificationPreferences_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  notificationPreferences_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  notificationPreferences_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  notificationPreferences_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeOfDay_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timeOfDay_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeOfDay_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timeOfDay_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeOfDay_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserHasPreferencesPreferencesRelationship = {
  __typename?: 'UserHasPreferencesPreferencesRelationship';
  cursor: Scalars['String']['output'];
  node: Preferences;
};

export type UserHasPreferencesPreferencesUpdateConnectionInput = {
  node?: InputMaybe<PreferencesUpdateInput>;
};

export type UserHasPreferencesPreferencesUpdateFieldInput = {
  connect?: InputMaybe<Array<UserHasPreferencesPreferencesConnectFieldInput>>;
  create?: InputMaybe<Array<UserHasPreferencesPreferencesCreateFieldInput>>;
  delete?: InputMaybe<Array<UserHasPreferencesPreferencesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserHasPreferencesPreferencesDisconnectFieldInput>>;
  update?: InputMaybe<UserHasPreferencesPreferencesUpdateConnectionInput>;
  where?: InputMaybe<UserHasPreferencesPreferencesConnectionWhere>;
};

export type UserHasProgressAggregateInput = {
  AND?: InputMaybe<Array<UserHasProgressAggregateInput>>;
  NOT?: InputMaybe<UserHasProgressAggregateInput>;
  OR?: InputMaybe<Array<UserHasProgressAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserHasProgressNodeAggregationWhereInput>;
};

export type UserHasProgressConnectFieldInput = {
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ProgressConnectWhere>;
};

export type UserHasProgressConnection = {
  __typename?: 'UserHasProgressConnection';
  edges: Array<UserHasProgressRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserHasProgressConnectionSort = {
  node?: InputMaybe<ProgressSort>;
};

export type UserHasProgressConnectionWhere = {
  AND?: InputMaybe<Array<UserHasProgressConnectionWhere>>;
  NOT?: InputMaybe<UserHasProgressConnectionWhere>;
  OR?: InputMaybe<Array<UserHasProgressConnectionWhere>>;
  node?: InputMaybe<ProgressWhere>;
};

export type UserHasProgressCreateFieldInput = {
  node: ProgressCreateInput;
};

export type UserHasProgressDeleteFieldInput = {
  where?: InputMaybe<UserHasProgressConnectionWhere>;
};

export type UserHasProgressDisconnectFieldInput = {
  where?: InputMaybe<UserHasProgressConnectionWhere>;
};

export type UserHasProgressFieldInput = {
  connect?: InputMaybe<Array<UserHasProgressConnectFieldInput>>;
  create?: InputMaybe<Array<UserHasProgressCreateFieldInput>>;
};

export type UserHasProgressNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserHasProgressNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserHasProgressNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserHasProgressNodeAggregationWhereInput>>;
  date_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  level_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  level_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  level_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  level_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  level_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  level_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  level_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserHasProgressRelationship = {
  __typename?: 'UserHasProgressRelationship';
  cursor: Scalars['String']['output'];
  node: Progress;
};

export type UserHasProgressUpdateConnectionInput = {
  node?: InputMaybe<ProgressUpdateInput>;
};

export type UserHasProgressUpdateFieldInput = {
  connect?: InputMaybe<Array<UserHasProgressConnectFieldInput>>;
  create?: InputMaybe<Array<UserHasProgressCreateFieldInput>>;
  delete?: InputMaybe<Array<UserHasProgressDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserHasProgressDisconnectFieldInput>>;
  update?: InputMaybe<UserHasProgressUpdateConnectionInput>;
  where?: InputMaybe<UserHasProgressConnectionWhere>;
};

export type UserHasReviewsAggregateInput = {
  AND?: InputMaybe<Array<UserHasReviewsAggregateInput>>;
  NOT?: InputMaybe<UserHasReviewsAggregateInput>;
  OR?: InputMaybe<Array<UserHasReviewsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserHasReviewsNodeAggregationWhereInput>;
};

export type UserHasReviewsConnectFieldInput = {
  connect?: InputMaybe<Array<AiTutorConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AiTutorConnectWhere>;
};

export type UserHasReviewsConnectOrCreateFieldInput = {
  onCreate: UserHasReviewsConnectOrCreateFieldInputOnCreate;
  where: AiTutorConnectOrCreateWhere;
};

export type UserHasReviewsConnectOrCreateFieldInputOnCreate = {
  node: AiTutorOnCreateInput;
};

export type UserHasReviewsConnection = {
  __typename?: 'UserHasReviewsConnection';
  edges: Array<UserHasReviewsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserHasReviewsConnectionSort = {
  node?: InputMaybe<AiTutorSort>;
};

export type UserHasReviewsConnectionWhere = {
  AND?: InputMaybe<Array<UserHasReviewsConnectionWhere>>;
  NOT?: InputMaybe<UserHasReviewsConnectionWhere>;
  OR?: InputMaybe<Array<UserHasReviewsConnectionWhere>>;
  node?: InputMaybe<AiTutorWhere>;
};

export type UserHasReviewsCreateFieldInput = {
  node: AiTutorCreateInput;
};

export type UserHasReviewsDeleteFieldInput = {
  delete?: InputMaybe<AiTutorDeleteInput>;
  where?: InputMaybe<UserHasReviewsConnectionWhere>;
};

export type UserHasReviewsDisconnectFieldInput = {
  disconnect?: InputMaybe<AiTutorDisconnectInput>;
  where?: InputMaybe<UserHasReviewsConnectionWhere>;
};

export type UserHasReviewsFieldInput = {
  connect?: InputMaybe<Array<UserHasReviewsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserHasReviewsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserHasReviewsCreateFieldInput>>;
};

export type UserHasReviewsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserHasReviewsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserHasReviewsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserHasReviewsNodeAggregationWhereInput>>;
  context_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  context_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserHasReviewsRelationship = {
  __typename?: 'UserHasReviewsRelationship';
  cursor: Scalars['String']['output'];
  node: AiTutor;
};

export type UserHasReviewsUpdateConnectionInput = {
  node?: InputMaybe<AiTutorUpdateInput>;
};

export type UserHasReviewsUpdateFieldInput = {
  connect?: InputMaybe<Array<UserHasReviewsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserHasReviewsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserHasReviewsCreateFieldInput>>;
  delete?: InputMaybe<Array<UserHasReviewsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserHasReviewsDisconnectFieldInput>>;
  update?: InputMaybe<UserHasReviewsUpdateConnectionInput>;
  where?: InputMaybe<UserHasReviewsConnectionWhere>;
};

export type UserHasRoleRolesAggregateInput = {
  AND?: InputMaybe<Array<UserHasRoleRolesAggregateInput>>;
  NOT?: InputMaybe<UserHasRoleRolesAggregateInput>;
  OR?: InputMaybe<Array<UserHasRoleRolesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<UserRolePropertiesAggregationWhereInput>;
  node?: InputMaybe<UserHasRoleRolesNodeAggregationWhereInput>;
};

export type UserHasRoleRolesConnectFieldInput = {
  connect?: InputMaybe<Array<RoleConnectInput>>;
  edge: UserRolePropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<RoleConnectWhere>;
};

export type UserHasRoleRolesConnection = {
  __typename?: 'UserHasRoleRolesConnection';
  edges: Array<UserHasRoleRolesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserHasRoleRolesConnectionSort = {
  edge?: InputMaybe<UserRolePropertiesSort>;
  node?: InputMaybe<RoleSort>;
};

export type UserHasRoleRolesConnectionWhere = {
  AND?: InputMaybe<Array<UserHasRoleRolesConnectionWhere>>;
  NOT?: InputMaybe<UserHasRoleRolesConnectionWhere>;
  OR?: InputMaybe<Array<UserHasRoleRolesConnectionWhere>>;
  edge?: InputMaybe<UserRolePropertiesWhere>;
  node?: InputMaybe<RoleWhere>;
};

export type UserHasRoleRolesCreateFieldInput = {
  edge: UserRolePropertiesCreateInput;
  node: RoleCreateInput;
};

export type UserHasRoleRolesDeleteFieldInput = {
  delete?: InputMaybe<RoleDeleteInput>;
  where?: InputMaybe<UserHasRoleRolesConnectionWhere>;
};

export type UserHasRoleRolesDisconnectFieldInput = {
  disconnect?: InputMaybe<RoleDisconnectInput>;
  where?: InputMaybe<UserHasRoleRolesConnectionWhere>;
};

export type UserHasRoleRolesFieldInput = {
  connect?: InputMaybe<Array<UserHasRoleRolesConnectFieldInput>>;
  create?: InputMaybe<Array<UserHasRoleRolesCreateFieldInput>>;
};

export type UserHasRoleRolesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserHasRoleRolesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserHasRoleRolesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserHasRoleRolesNodeAggregationWhereInput>>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserHasRoleRolesRelationship = {
  __typename?: 'UserHasRoleRolesRelationship';
  cursor: Scalars['String']['output'];
  node: Role;
  properties: UserRoleProperties;
};

export type UserHasRoleRolesUpdateConnectionInput = {
  edge?: InputMaybe<UserRolePropertiesUpdateInput>;
  node?: InputMaybe<RoleUpdateInput>;
};

export type UserHasRoleRolesUpdateFieldInput = {
  connect?: InputMaybe<Array<UserHasRoleRolesConnectFieldInput>>;
  create?: InputMaybe<Array<UserHasRoleRolesCreateFieldInput>>;
  delete?: InputMaybe<Array<UserHasRoleRolesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserHasRoleRolesDisconnectFieldInput>>;
  update?: InputMaybe<UserHasRoleRolesUpdateConnectionInput>;
  where?: InputMaybe<UserHasRoleRolesConnectionWhere>;
};

export type UserHasRosterExportAggregateInput = {
  AND?: InputMaybe<Array<UserHasRosterExportAggregateInput>>;
  NOT?: InputMaybe<UserHasRosterExportAggregateInput>;
  OR?: InputMaybe<Array<UserHasRosterExportAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasExportPropsAggregationWhereInput>;
  node?: InputMaybe<UserHasRosterExportNodeAggregationWhereInput>;
};

export type UserHasRosterExportConnectFieldInput = {
  connect?: InputMaybe<Array<FileConnectInput>>;
  edge?: InputMaybe<HasExportPropsCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FileConnectWhere>;
};

export type UserHasRosterExportConnectOrCreateFieldInput = {
  onCreate: UserHasRosterExportConnectOrCreateFieldInputOnCreate;
  where: FileConnectOrCreateWhere;
};

export type UserHasRosterExportConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<HasExportPropsCreateInput>;
  node: FileOnCreateInput;
};

export type UserHasRosterExportConnection = {
  __typename?: 'UserHasRosterExportConnection';
  edges: Array<UserHasRosterExportRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserHasRosterExportConnectionSort = {
  edge?: InputMaybe<HasExportPropsSort>;
  node?: InputMaybe<FileSort>;
};

export type UserHasRosterExportConnectionWhere = {
  AND?: InputMaybe<Array<UserHasRosterExportConnectionWhere>>;
  NOT?: InputMaybe<UserHasRosterExportConnectionWhere>;
  OR?: InputMaybe<Array<UserHasRosterExportConnectionWhere>>;
  edge?: InputMaybe<HasExportPropsWhere>;
  node?: InputMaybe<FileWhere>;
};

export type UserHasRosterExportCreateFieldInput = {
  edge?: InputMaybe<HasExportPropsCreateInput>;
  node: FileCreateInput;
};

export type UserHasRosterExportDeleteFieldInput = {
  delete?: InputMaybe<FileDeleteInput>;
  where?: InputMaybe<UserHasRosterExportConnectionWhere>;
};

export type UserHasRosterExportDisconnectFieldInput = {
  disconnect?: InputMaybe<FileDisconnectInput>;
  where?: InputMaybe<UserHasRosterExportConnectionWhere>;
};

export type UserHasRosterExportFieldInput = {
  connect?: InputMaybe<Array<UserHasRosterExportConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserHasRosterExportConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserHasRosterExportCreateFieldInput>>;
};

export type UserHasRosterExportNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserHasRosterExportNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserHasRosterExportNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserHasRosterExportNodeAggregationWhereInput>>;
  bucketName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  bucketName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  fileName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileURL_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserHasRosterExportRelationship = {
  __typename?: 'UserHasRosterExportRelationship';
  cursor: Scalars['String']['output'];
  node: File;
  properties: HasExportProps;
};

export type UserHasRosterExportUpdateConnectionInput = {
  edge?: InputMaybe<HasExportPropsUpdateInput>;
  node?: InputMaybe<FileUpdateInput>;
};

export type UserHasRosterExportUpdateFieldInput = {
  connect?: InputMaybe<Array<UserHasRosterExportConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserHasRosterExportConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserHasRosterExportCreateFieldInput>>;
  delete?: InputMaybe<Array<UserHasRosterExportDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserHasRosterExportDisconnectFieldInput>>;
  update?: InputMaybe<UserHasRosterExportUpdateConnectionInput>;
  where?: InputMaybe<UserHasRosterExportConnectionWhere>;
};

export type UserHasSessionDeviceSessionsAggregateInput = {
  AND?: InputMaybe<Array<UserHasSessionDeviceSessionsAggregateInput>>;
  NOT?: InputMaybe<UserHasSessionDeviceSessionsAggregateInput>;
  OR?: InputMaybe<Array<UserHasSessionDeviceSessionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasSessionPropertiesAggregationWhereInput>;
  node?: InputMaybe<UserHasSessionDeviceSessionsNodeAggregationWhereInput>;
};

export type UserHasSessionDeviceSessionsConnectFieldInput = {
  connect?: InputMaybe<Array<DeviceSessionConnectInput>>;
  edge: HasSessionPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DeviceSessionConnectWhere>;
};

export type UserHasSessionDeviceSessionsConnectOrCreateFieldInput = {
  onCreate: UserHasSessionDeviceSessionsConnectOrCreateFieldInputOnCreate;
  where: DeviceSessionConnectOrCreateWhere;
};

export type UserHasSessionDeviceSessionsConnectOrCreateFieldInputOnCreate = {
  edge: HasSessionPropertiesCreateInput;
  node: DeviceSessionOnCreateInput;
};

export type UserHasSessionDeviceSessionsConnection = {
  __typename?: 'UserHasSessionDeviceSessionsConnection';
  edges: Array<UserHasSessionDeviceSessionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserHasSessionDeviceSessionsConnectionSort = {
  edge?: InputMaybe<HasSessionPropertiesSort>;
  node?: InputMaybe<DeviceSessionSort>;
};

export type UserHasSessionDeviceSessionsConnectionWhere = {
  AND?: InputMaybe<Array<UserHasSessionDeviceSessionsConnectionWhere>>;
  NOT?: InputMaybe<UserHasSessionDeviceSessionsConnectionWhere>;
  OR?: InputMaybe<Array<UserHasSessionDeviceSessionsConnectionWhere>>;
  edge?: InputMaybe<HasSessionPropertiesWhere>;
  node?: InputMaybe<DeviceSessionWhere>;
};

export type UserHasSessionDeviceSessionsCreateFieldInput = {
  edge: HasSessionPropertiesCreateInput;
  node: DeviceSessionCreateInput;
};

export type UserHasSessionDeviceSessionsDeleteFieldInput = {
  delete?: InputMaybe<DeviceSessionDeleteInput>;
  where?: InputMaybe<UserHasSessionDeviceSessionsConnectionWhere>;
};

export type UserHasSessionDeviceSessionsDisconnectFieldInput = {
  disconnect?: InputMaybe<DeviceSessionDisconnectInput>;
  where?: InputMaybe<UserHasSessionDeviceSessionsConnectionWhere>;
};

export type UserHasSessionDeviceSessionsFieldInput = {
  connect?: InputMaybe<Array<UserHasSessionDeviceSessionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserHasSessionDeviceSessionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserHasSessionDeviceSessionsCreateFieldInput>>;
};

export type UserHasSessionDeviceSessionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserHasSessionDeviceSessionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserHasSessionDeviceSessionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserHasSessionDeviceSessionsNodeAggregationWhereInput>>;
};

export type UserHasSessionDeviceSessionsRelationship = {
  __typename?: 'UserHasSessionDeviceSessionsRelationship';
  cursor: Scalars['String']['output'];
  node: DeviceSession;
  properties: HasSessionProperties;
};

export type UserHasSessionDeviceSessionsUpdateConnectionInput = {
  edge?: InputMaybe<HasSessionPropertiesUpdateInput>;
  node?: InputMaybe<DeviceSessionUpdateInput>;
};

export type UserHasSessionDeviceSessionsUpdateFieldInput = {
  connect?: InputMaybe<Array<UserHasSessionDeviceSessionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserHasSessionDeviceSessionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserHasSessionDeviceSessionsCreateFieldInput>>;
  delete?: InputMaybe<Array<UserHasSessionDeviceSessionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserHasSessionDeviceSessionsDisconnectFieldInput>>;
  update?: InputMaybe<UserHasSessionDeviceSessionsUpdateConnectionInput>;
  where?: InputMaybe<UserHasSessionDeviceSessionsConnectionWhere>;
};

export type UserHasSubmissionExportAggregateInput = {
  AND?: InputMaybe<Array<UserHasSubmissionExportAggregateInput>>;
  NOT?: InputMaybe<UserHasSubmissionExportAggregateInput>;
  OR?: InputMaybe<Array<UserHasSubmissionExportAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasExportPropsAggregationWhereInput>;
  node?: InputMaybe<UserHasSubmissionExportNodeAggregationWhereInput>;
};

export type UserHasSubmissionExportConnectFieldInput = {
  connect?: InputMaybe<Array<FileConnectInput>>;
  edge?: InputMaybe<HasExportPropsCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FileConnectWhere>;
};

export type UserHasSubmissionExportConnectOrCreateFieldInput = {
  onCreate: UserHasSubmissionExportConnectOrCreateFieldInputOnCreate;
  where: FileConnectOrCreateWhere;
};

export type UserHasSubmissionExportConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<HasExportPropsCreateInput>;
  node: FileOnCreateInput;
};

export type UserHasSubmissionExportConnection = {
  __typename?: 'UserHasSubmissionExportConnection';
  edges: Array<UserHasSubmissionExportRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserHasSubmissionExportConnectionSort = {
  edge?: InputMaybe<HasExportPropsSort>;
  node?: InputMaybe<FileSort>;
};

export type UserHasSubmissionExportConnectionWhere = {
  AND?: InputMaybe<Array<UserHasSubmissionExportConnectionWhere>>;
  NOT?: InputMaybe<UserHasSubmissionExportConnectionWhere>;
  OR?: InputMaybe<Array<UserHasSubmissionExportConnectionWhere>>;
  edge?: InputMaybe<HasExportPropsWhere>;
  node?: InputMaybe<FileWhere>;
};

export type UserHasSubmissionExportCreateFieldInput = {
  edge?: InputMaybe<HasExportPropsCreateInput>;
  node: FileCreateInput;
};

export type UserHasSubmissionExportDeleteFieldInput = {
  delete?: InputMaybe<FileDeleteInput>;
  where?: InputMaybe<UserHasSubmissionExportConnectionWhere>;
};

export type UserHasSubmissionExportDisconnectFieldInput = {
  disconnect?: InputMaybe<FileDisconnectInput>;
  where?: InputMaybe<UserHasSubmissionExportConnectionWhere>;
};

export type UserHasSubmissionExportFieldInput = {
  connect?: InputMaybe<Array<UserHasSubmissionExportConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserHasSubmissionExportConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserHasSubmissionExportCreateFieldInput>>;
};

export type UserHasSubmissionExportNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserHasSubmissionExportNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserHasSubmissionExportNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserHasSubmissionExportNodeAggregationWhereInput>>;
  bucketName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  bucketName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  fileName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileURL_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserHasSubmissionExportRelationship = {
  __typename?: 'UserHasSubmissionExportRelationship';
  cursor: Scalars['String']['output'];
  node: File;
  properties: HasExportProps;
};

export type UserHasSubmissionExportUpdateConnectionInput = {
  edge?: InputMaybe<HasExportPropsUpdateInput>;
  node?: InputMaybe<FileUpdateInput>;
};

export type UserHasSubmissionExportUpdateFieldInput = {
  connect?: InputMaybe<Array<UserHasSubmissionExportConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserHasSubmissionExportConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserHasSubmissionExportCreateFieldInput>>;
  delete?: InputMaybe<Array<UserHasSubmissionExportDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserHasSubmissionExportDisconnectFieldInput>>;
  update?: InputMaybe<UserHasSubmissionExportUpdateConnectionInput>;
  where?: InputMaybe<UserHasSubmissionExportConnectionWhere>;
};

export type UserHasSubmittedAggregateInput = {
  AND?: InputMaybe<Array<UserHasSubmittedAggregateInput>>;
  NOT?: InputMaybe<UserHasSubmittedAggregateInput>;
  OR?: InputMaybe<Array<UserHasSubmittedAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserHasSubmittedNodeAggregationWhereInput>;
};

export type UserHasSubmittedConnectFieldInput = {
  connect?: InputMaybe<Array<SubmissionConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SubmissionConnectWhere>;
};

export type UserHasSubmittedConnectOrCreateFieldInput = {
  onCreate: UserHasSubmittedConnectOrCreateFieldInputOnCreate;
  where: SubmissionConnectOrCreateWhere;
};

export type UserHasSubmittedConnectOrCreateFieldInputOnCreate = {
  node: SubmissionOnCreateInput;
};

export type UserHasSubmittedConnection = {
  __typename?: 'UserHasSubmittedConnection';
  edges: Array<UserHasSubmittedRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserHasSubmittedConnectionSort = {
  node?: InputMaybe<SubmissionSort>;
};

export type UserHasSubmittedConnectionWhere = {
  AND?: InputMaybe<Array<UserHasSubmittedConnectionWhere>>;
  NOT?: InputMaybe<UserHasSubmittedConnectionWhere>;
  OR?: InputMaybe<Array<UserHasSubmittedConnectionWhere>>;
  node?: InputMaybe<SubmissionWhere>;
};

export type UserHasSubmittedCreateFieldInput = {
  node: SubmissionCreateInput;
};

export type UserHasSubmittedDeleteFieldInput = {
  delete?: InputMaybe<SubmissionDeleteInput>;
  where?: InputMaybe<UserHasSubmittedConnectionWhere>;
};

export type UserHasSubmittedDisconnectFieldInput = {
  disconnect?: InputMaybe<SubmissionDisconnectInput>;
  where?: InputMaybe<UserHasSubmittedConnectionWhere>;
};

export type UserHasSubmittedFieldInput = {
  connect?: InputMaybe<Array<UserHasSubmittedConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserHasSubmittedConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserHasSubmittedCreateFieldInput>>;
};

export type UserHasSubmittedNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserHasSubmittedNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserHasSubmittedNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserHasSubmittedNodeAggregationWhereInput>>;
  completedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  feedback_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  feedback_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  feedback_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  feedback_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  feedback_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserHasSubmittedRelationship = {
  __typename?: 'UserHasSubmittedRelationship';
  cursor: Scalars['String']['output'];
  node: Submission;
};

export type UserHasSubmittedUpdateConnectionInput = {
  node?: InputMaybe<SubmissionUpdateInput>;
};

export type UserHasSubmittedUpdateFieldInput = {
  connect?: InputMaybe<Array<UserHasSubmittedConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserHasSubmittedConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserHasSubmittedCreateFieldInput>>;
  delete?: InputMaybe<Array<UserHasSubmittedDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserHasSubmittedDisconnectFieldInput>>;
  update?: InputMaybe<UserHasSubmittedUpdateConnectionInput>;
  where?: InputMaybe<UserHasSubmittedConnectionWhere>;
};

export type UserHasSuggestionSuggestionsAggregateInput = {
  AND?: InputMaybe<Array<UserHasSuggestionSuggestionsAggregateInput>>;
  NOT?: InputMaybe<UserHasSuggestionSuggestionsAggregateInput>;
  OR?: InputMaybe<Array<UserHasSuggestionSuggestionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserHasSuggestionSuggestionsNodeAggregationWhereInput>;
};

export type UserHasSuggestionSuggestionsConnectFieldInput = {
  connect?: InputMaybe<Array<SuggestionConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SuggestionConnectWhere>;
};

export type UserHasSuggestionSuggestionsConnection = {
  __typename?: 'UserHasSuggestionSuggestionsConnection';
  edges: Array<UserHasSuggestionSuggestionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserHasSuggestionSuggestionsConnectionSort = {
  node?: InputMaybe<SuggestionSort>;
};

export type UserHasSuggestionSuggestionsConnectionWhere = {
  AND?: InputMaybe<Array<UserHasSuggestionSuggestionsConnectionWhere>>;
  NOT?: InputMaybe<UserHasSuggestionSuggestionsConnectionWhere>;
  OR?: InputMaybe<Array<UserHasSuggestionSuggestionsConnectionWhere>>;
  node?: InputMaybe<SuggestionWhere>;
};

export type UserHasSuggestionSuggestionsCreateFieldInput = {
  node: SuggestionCreateInput;
};

export type UserHasSuggestionSuggestionsDeleteFieldInput = {
  delete?: InputMaybe<SuggestionDeleteInput>;
  where?: InputMaybe<UserHasSuggestionSuggestionsConnectionWhere>;
};

export type UserHasSuggestionSuggestionsDisconnectFieldInput = {
  disconnect?: InputMaybe<SuggestionDisconnectInput>;
  where?: InputMaybe<UserHasSuggestionSuggestionsConnectionWhere>;
};

export type UserHasSuggestionSuggestionsFieldInput = {
  connect?: InputMaybe<Array<UserHasSuggestionSuggestionsConnectFieldInput>>;
  create?: InputMaybe<Array<UserHasSuggestionSuggestionsCreateFieldInput>>;
};

export type UserHasSuggestionSuggestionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserHasSuggestionSuggestionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserHasSuggestionSuggestionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserHasSuggestionSuggestionsNodeAggregationWhereInput>>;
  assignmentId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignmentId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  assignmentId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignmentId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  assignmentId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignmentId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignmentId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignmentId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignmentId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignmentId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignmentId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignmentId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignmentId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignmentId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignmentId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  content_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  content_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  integrationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  integrationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  integrationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  integrationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  integrationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  integrationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integrationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integrationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integrationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integrationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  integrationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integrationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integrationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integrationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integrationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trackName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  trackName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  trackName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  trackName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  trackName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  trackName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  trackName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  trackName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  trackName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  trackName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trackName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  trackName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  trackName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  trackName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  trackName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserHasSuggestionSuggestionsRelationship = {
  __typename?: 'UserHasSuggestionSuggestionsRelationship';
  cursor: Scalars['String']['output'];
  node: Suggestion;
};

export type UserHasSuggestionSuggestionsUpdateConnectionInput = {
  node?: InputMaybe<SuggestionUpdateInput>;
};

export type UserHasSuggestionSuggestionsUpdateFieldInput = {
  connect?: InputMaybe<Array<UserHasSuggestionSuggestionsConnectFieldInput>>;
  create?: InputMaybe<Array<UserHasSuggestionSuggestionsCreateFieldInput>>;
  delete?: InputMaybe<Array<UserHasSuggestionSuggestionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserHasSuggestionSuggestionsDisconnectFieldInput>>;
  update?: InputMaybe<UserHasSuggestionSuggestionsUpdateConnectionInput>;
  where?: InputMaybe<UserHasSuggestionSuggestionsConnectionWhere>;
};

export type UserHasSummaryDailySummariesAggregateInput = {
  AND?: InputMaybe<Array<UserHasSummaryDailySummariesAggregateInput>>;
  NOT?: InputMaybe<UserHasSummaryDailySummariesAggregateInput>;
  OR?: InputMaybe<Array<UserHasSummaryDailySummariesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserHasSummaryDailySummariesNodeAggregationWhereInput>;
};

export type UserHasSummaryDailySummariesConnectFieldInput = {
  connect?: InputMaybe<Array<DailySummaryConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<DailySummaryConnectWhere>;
};

export type UserHasSummaryDailySummariesConnection = {
  __typename?: 'UserHasSummaryDailySummariesConnection';
  edges: Array<UserHasSummaryDailySummariesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserHasSummaryDailySummariesConnectionSort = {
  node?: InputMaybe<DailySummarySort>;
};

export type UserHasSummaryDailySummariesConnectionWhere = {
  AND?: InputMaybe<Array<UserHasSummaryDailySummariesConnectionWhere>>;
  NOT?: InputMaybe<UserHasSummaryDailySummariesConnectionWhere>;
  OR?: InputMaybe<Array<UserHasSummaryDailySummariesConnectionWhere>>;
  node?: InputMaybe<DailySummaryWhere>;
};

export type UserHasSummaryDailySummariesCreateFieldInput = {
  node: DailySummaryCreateInput;
};

export type UserHasSummaryDailySummariesDeleteFieldInput = {
  delete?: InputMaybe<DailySummaryDeleteInput>;
  where?: InputMaybe<UserHasSummaryDailySummariesConnectionWhere>;
};

export type UserHasSummaryDailySummariesDisconnectFieldInput = {
  disconnect?: InputMaybe<DailySummaryDisconnectInput>;
  where?: InputMaybe<UserHasSummaryDailySummariesConnectionWhere>;
};

export type UserHasSummaryDailySummariesFieldInput = {
  connect?: InputMaybe<Array<UserHasSummaryDailySummariesConnectFieldInput>>;
  create?: InputMaybe<Array<UserHasSummaryDailySummariesCreateFieldInput>>;
};

export type UserHasSummaryDailySummariesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserHasSummaryDailySummariesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserHasSummaryDailySummariesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserHasSummaryDailySummariesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  summary_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  summary_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserHasSummaryDailySummariesRelationship = {
  __typename?: 'UserHasSummaryDailySummariesRelationship';
  cursor: Scalars['String']['output'];
  node: DailySummary;
};

export type UserHasSummaryDailySummariesUpdateConnectionInput = {
  node?: InputMaybe<DailySummaryUpdateInput>;
};

export type UserHasSummaryDailySummariesUpdateFieldInput = {
  connect?: InputMaybe<Array<UserHasSummaryDailySummariesConnectFieldInput>>;
  create?: InputMaybe<Array<UserHasSummaryDailySummariesCreateFieldInput>>;
  delete?: InputMaybe<Array<UserHasSummaryDailySummariesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserHasSummaryDailySummariesDisconnectFieldInput>>;
  update?: InputMaybe<UserHasSummaryDailySummariesUpdateConnectionInput>;
  where?: InputMaybe<UserHasSummaryDailySummariesConnectionWhere>;
};

export type UserHasSummaryMonthlySummariesAggregateInput = {
  AND?: InputMaybe<Array<UserHasSummaryMonthlySummariesAggregateInput>>;
  NOT?: InputMaybe<UserHasSummaryMonthlySummariesAggregateInput>;
  OR?: InputMaybe<Array<UserHasSummaryMonthlySummariesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserHasSummaryMonthlySummariesNodeAggregationWhereInput>;
};

export type UserHasSummaryMonthlySummariesConnectFieldInput = {
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<MonthlySummaryConnectWhere>;
};

export type UserHasSummaryMonthlySummariesConnection = {
  __typename?: 'UserHasSummaryMonthlySummariesConnection';
  edges: Array<UserHasSummaryMonthlySummariesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserHasSummaryMonthlySummariesConnectionSort = {
  node?: InputMaybe<MonthlySummarySort>;
};

export type UserHasSummaryMonthlySummariesConnectionWhere = {
  AND?: InputMaybe<Array<UserHasSummaryMonthlySummariesConnectionWhere>>;
  NOT?: InputMaybe<UserHasSummaryMonthlySummariesConnectionWhere>;
  OR?: InputMaybe<Array<UserHasSummaryMonthlySummariesConnectionWhere>>;
  node?: InputMaybe<MonthlySummaryWhere>;
};

export type UserHasSummaryMonthlySummariesCreateFieldInput = {
  node: MonthlySummaryCreateInput;
};

export type UserHasSummaryMonthlySummariesDeleteFieldInput = {
  where?: InputMaybe<UserHasSummaryMonthlySummariesConnectionWhere>;
};

export type UserHasSummaryMonthlySummariesDisconnectFieldInput = {
  where?: InputMaybe<UserHasSummaryMonthlySummariesConnectionWhere>;
};

export type UserHasSummaryMonthlySummariesFieldInput = {
  connect?: InputMaybe<Array<UserHasSummaryMonthlySummariesConnectFieldInput>>;
  create?: InputMaybe<Array<UserHasSummaryMonthlySummariesCreateFieldInput>>;
};

export type UserHasSummaryMonthlySummariesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserHasSummaryMonthlySummariesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserHasSummaryMonthlySummariesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserHasSummaryMonthlySummariesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  summary_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  summary_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserHasSummaryMonthlySummariesRelationship = {
  __typename?: 'UserHasSummaryMonthlySummariesRelationship';
  cursor: Scalars['String']['output'];
  node: MonthlySummary;
};

export type UserHasSummaryMonthlySummariesUpdateConnectionInput = {
  node?: InputMaybe<MonthlySummaryUpdateInput>;
};

export type UserHasSummaryMonthlySummariesUpdateFieldInput = {
  connect?: InputMaybe<Array<UserHasSummaryMonthlySummariesConnectFieldInput>>;
  create?: InputMaybe<Array<UserHasSummaryMonthlySummariesCreateFieldInput>>;
  delete?: InputMaybe<Array<UserHasSummaryMonthlySummariesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserHasSummaryMonthlySummariesDisconnectFieldInput>>;
  update?: InputMaybe<UserHasSummaryMonthlySummariesUpdateConnectionInput>;
  where?: InputMaybe<UserHasSummaryMonthlySummariesConnectionWhere>;
};

export type UserHasSummaryQuarterlySummariesAggregateInput = {
  AND?: InputMaybe<Array<UserHasSummaryQuarterlySummariesAggregateInput>>;
  NOT?: InputMaybe<UserHasSummaryQuarterlySummariesAggregateInput>;
  OR?: InputMaybe<Array<UserHasSummaryQuarterlySummariesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserHasSummaryQuarterlySummariesNodeAggregationWhereInput>;
};

export type UserHasSummaryQuarterlySummariesConnectFieldInput = {
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<QuarterlySummaryConnectWhere>;
};

export type UserHasSummaryQuarterlySummariesConnection = {
  __typename?: 'UserHasSummaryQuarterlySummariesConnection';
  edges: Array<UserHasSummaryQuarterlySummariesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserHasSummaryQuarterlySummariesConnectionSort = {
  node?: InputMaybe<QuarterlySummarySort>;
};

export type UserHasSummaryQuarterlySummariesConnectionWhere = {
  AND?: InputMaybe<Array<UserHasSummaryQuarterlySummariesConnectionWhere>>;
  NOT?: InputMaybe<UserHasSummaryQuarterlySummariesConnectionWhere>;
  OR?: InputMaybe<Array<UserHasSummaryQuarterlySummariesConnectionWhere>>;
  node?: InputMaybe<QuarterlySummaryWhere>;
};

export type UserHasSummaryQuarterlySummariesCreateFieldInput = {
  node: QuarterlySummaryCreateInput;
};

export type UserHasSummaryQuarterlySummariesDeleteFieldInput = {
  where?: InputMaybe<UserHasSummaryQuarterlySummariesConnectionWhere>;
};

export type UserHasSummaryQuarterlySummariesDisconnectFieldInput = {
  where?: InputMaybe<UserHasSummaryQuarterlySummariesConnectionWhere>;
};

export type UserHasSummaryQuarterlySummariesFieldInput = {
  connect?: InputMaybe<Array<UserHasSummaryQuarterlySummariesConnectFieldInput>>;
  create?: InputMaybe<Array<UserHasSummaryQuarterlySummariesCreateFieldInput>>;
};

export type UserHasSummaryQuarterlySummariesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserHasSummaryQuarterlySummariesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserHasSummaryQuarterlySummariesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserHasSummaryQuarterlySummariesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  summary_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  summary_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserHasSummaryQuarterlySummariesRelationship = {
  __typename?: 'UserHasSummaryQuarterlySummariesRelationship';
  cursor: Scalars['String']['output'];
  node: QuarterlySummary;
};

export type UserHasSummaryQuarterlySummariesUpdateConnectionInput = {
  node?: InputMaybe<QuarterlySummaryUpdateInput>;
};

export type UserHasSummaryQuarterlySummariesUpdateFieldInput = {
  connect?: InputMaybe<Array<UserHasSummaryQuarterlySummariesConnectFieldInput>>;
  create?: InputMaybe<Array<UserHasSummaryQuarterlySummariesCreateFieldInput>>;
  delete?: InputMaybe<Array<UserHasSummaryQuarterlySummariesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserHasSummaryQuarterlySummariesDisconnectFieldInput>>;
  update?: InputMaybe<UserHasSummaryQuarterlySummariesUpdateConnectionInput>;
  where?: InputMaybe<UserHasSummaryQuarterlySummariesConnectionWhere>;
};

export type UserHasSummaryWeeklySummariesAggregateInput = {
  AND?: InputMaybe<Array<UserHasSummaryWeeklySummariesAggregateInput>>;
  NOT?: InputMaybe<UserHasSummaryWeeklySummariesAggregateInput>;
  OR?: InputMaybe<Array<UserHasSummaryWeeklySummariesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserHasSummaryWeeklySummariesNodeAggregationWhereInput>;
};

export type UserHasSummaryWeeklySummariesConnectFieldInput = {
  connect?: InputMaybe<Array<WeeklySummaryConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<WeeklySummaryConnectWhere>;
};

export type UserHasSummaryWeeklySummariesConnection = {
  __typename?: 'UserHasSummaryWeeklySummariesConnection';
  edges: Array<UserHasSummaryWeeklySummariesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserHasSummaryWeeklySummariesConnectionSort = {
  node?: InputMaybe<WeeklySummarySort>;
};

export type UserHasSummaryWeeklySummariesConnectionWhere = {
  AND?: InputMaybe<Array<UserHasSummaryWeeklySummariesConnectionWhere>>;
  NOT?: InputMaybe<UserHasSummaryWeeklySummariesConnectionWhere>;
  OR?: InputMaybe<Array<UserHasSummaryWeeklySummariesConnectionWhere>>;
  node?: InputMaybe<WeeklySummaryWhere>;
};

export type UserHasSummaryWeeklySummariesCreateFieldInput = {
  node: WeeklySummaryCreateInput;
};

export type UserHasSummaryWeeklySummariesDeleteFieldInput = {
  delete?: InputMaybe<WeeklySummaryDeleteInput>;
  where?: InputMaybe<UserHasSummaryWeeklySummariesConnectionWhere>;
};

export type UserHasSummaryWeeklySummariesDisconnectFieldInput = {
  disconnect?: InputMaybe<WeeklySummaryDisconnectInput>;
  where?: InputMaybe<UserHasSummaryWeeklySummariesConnectionWhere>;
};

export type UserHasSummaryWeeklySummariesFieldInput = {
  connect?: InputMaybe<Array<UserHasSummaryWeeklySummariesConnectFieldInput>>;
  create?: InputMaybe<Array<UserHasSummaryWeeklySummariesCreateFieldInput>>;
};

export type UserHasSummaryWeeklySummariesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserHasSummaryWeeklySummariesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserHasSummaryWeeklySummariesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserHasSummaryWeeklySummariesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  summary_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  summary_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserHasSummaryWeeklySummariesRelationship = {
  __typename?: 'UserHasSummaryWeeklySummariesRelationship';
  cursor: Scalars['String']['output'];
  node: WeeklySummary;
};

export type UserHasSummaryWeeklySummariesUpdateConnectionInput = {
  node?: InputMaybe<WeeklySummaryUpdateInput>;
};

export type UserHasSummaryWeeklySummariesUpdateFieldInput = {
  connect?: InputMaybe<Array<UserHasSummaryWeeklySummariesConnectFieldInput>>;
  create?: InputMaybe<Array<UserHasSummaryWeeklySummariesCreateFieldInput>>;
  delete?: InputMaybe<Array<UserHasSummaryWeeklySummariesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserHasSummaryWeeklySummariesDisconnectFieldInput>>;
  update?: InputMaybe<UserHasSummaryWeeklySummariesUpdateConnectionInput>;
  where?: InputMaybe<UserHasSummaryWeeklySummariesConnectionWhere>;
};

export type UserHasSummaryYearlySummariesAggregateInput = {
  AND?: InputMaybe<Array<UserHasSummaryYearlySummariesAggregateInput>>;
  NOT?: InputMaybe<UserHasSummaryYearlySummariesAggregateInput>;
  OR?: InputMaybe<Array<UserHasSummaryYearlySummariesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserHasSummaryYearlySummariesNodeAggregationWhereInput>;
};

export type UserHasSummaryYearlySummariesConnectFieldInput = {
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<YearlySummaryConnectWhere>;
};

export type UserHasSummaryYearlySummariesConnection = {
  __typename?: 'UserHasSummaryYearlySummariesConnection';
  edges: Array<UserHasSummaryYearlySummariesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserHasSummaryYearlySummariesConnectionSort = {
  node?: InputMaybe<YearlySummarySort>;
};

export type UserHasSummaryYearlySummariesConnectionWhere = {
  AND?: InputMaybe<Array<UserHasSummaryYearlySummariesConnectionWhere>>;
  NOT?: InputMaybe<UserHasSummaryYearlySummariesConnectionWhere>;
  OR?: InputMaybe<Array<UserHasSummaryYearlySummariesConnectionWhere>>;
  node?: InputMaybe<YearlySummaryWhere>;
};

export type UserHasSummaryYearlySummariesCreateFieldInput = {
  node: YearlySummaryCreateInput;
};

export type UserHasSummaryYearlySummariesDeleteFieldInput = {
  where?: InputMaybe<UserHasSummaryYearlySummariesConnectionWhere>;
};

export type UserHasSummaryYearlySummariesDisconnectFieldInput = {
  where?: InputMaybe<UserHasSummaryYearlySummariesConnectionWhere>;
};

export type UserHasSummaryYearlySummariesFieldInput = {
  connect?: InputMaybe<Array<UserHasSummaryYearlySummariesConnectFieldInput>>;
  create?: InputMaybe<Array<UserHasSummaryYearlySummariesCreateFieldInput>>;
};

export type UserHasSummaryYearlySummariesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserHasSummaryYearlySummariesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserHasSummaryYearlySummariesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserHasSummaryYearlySummariesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  summary_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  summary_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserHasSummaryYearlySummariesRelationship = {
  __typename?: 'UserHasSummaryYearlySummariesRelationship';
  cursor: Scalars['String']['output'];
  node: YearlySummary;
};

export type UserHasSummaryYearlySummariesUpdateConnectionInput = {
  node?: InputMaybe<YearlySummaryUpdateInput>;
};

export type UserHasSummaryYearlySummariesUpdateFieldInput = {
  connect?: InputMaybe<Array<UserHasSummaryYearlySummariesConnectFieldInput>>;
  create?: InputMaybe<Array<UserHasSummaryYearlySummariesCreateFieldInput>>;
  delete?: InputMaybe<Array<UserHasSummaryYearlySummariesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserHasSummaryYearlySummariesDisconnectFieldInput>>;
  update?: InputMaybe<UserHasSummaryYearlySummariesUpdateConnectionInput>;
  where?: InputMaybe<UserHasSummaryYearlySummariesConnectionWhere>;
};

export type UserHasVisitSessionsAggregateInput = {
  AND?: InputMaybe<Array<UserHasVisitSessionsAggregateInput>>;
  NOT?: InputMaybe<UserHasVisitSessionsAggregateInput>;
  OR?: InputMaybe<Array<UserHasVisitSessionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserHasVisitSessionsNodeAggregationWhereInput>;
};

export type UserHasVisitSessionsConnectFieldInput = {
  connect?: InputMaybe<Array<VisitSessionConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<VisitSessionConnectWhere>;
};

export type UserHasVisitSessionsConnectOrCreateFieldInput = {
  onCreate: UserHasVisitSessionsConnectOrCreateFieldInputOnCreate;
  where: VisitSessionConnectOrCreateWhere;
};

export type UserHasVisitSessionsConnectOrCreateFieldInputOnCreate = {
  node: VisitSessionOnCreateInput;
};

export type UserHasVisitSessionsConnection = {
  __typename?: 'UserHasVisitSessionsConnection';
  edges: Array<UserHasVisitSessionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserHasVisitSessionsConnectionSort = {
  node?: InputMaybe<VisitSessionSort>;
};

export type UserHasVisitSessionsConnectionWhere = {
  AND?: InputMaybe<Array<UserHasVisitSessionsConnectionWhere>>;
  NOT?: InputMaybe<UserHasVisitSessionsConnectionWhere>;
  OR?: InputMaybe<Array<UserHasVisitSessionsConnectionWhere>>;
  node?: InputMaybe<VisitSessionWhere>;
};

export type UserHasVisitSessionsCreateFieldInput = {
  node: VisitSessionCreateInput;
};

export type UserHasVisitSessionsDeleteFieldInput = {
  delete?: InputMaybe<VisitSessionDeleteInput>;
  where?: InputMaybe<UserHasVisitSessionsConnectionWhere>;
};

export type UserHasVisitSessionsDisconnectFieldInput = {
  disconnect?: InputMaybe<VisitSessionDisconnectInput>;
  where?: InputMaybe<UserHasVisitSessionsConnectionWhere>;
};

export type UserHasVisitSessionsFieldInput = {
  connect?: InputMaybe<Array<UserHasVisitSessionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserHasVisitSessionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserHasVisitSessionsCreateFieldInput>>;
};

export type UserHasVisitSessionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserHasVisitSessionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserHasVisitSessionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserHasVisitSessionsNodeAggregationWhereInput>>;
  ipAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ipAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ipAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ipAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ipAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ipAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ipAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ipAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ipAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ipAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ipAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ipAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ipAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ipAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ipAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastActiveTime_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startTime_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startTime_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startTime_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startTime_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startTime_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startTime_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startTime_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startTime_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startTime_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startTime_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  userAgent_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  userAgent_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  userAgent_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  userAgent_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  userAgent_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  userAgent_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userAgent_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userAgent_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userAgent_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userAgent_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  userAgent_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  userAgent_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  userAgent_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  userAgent_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  userAgent_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserHasVisitSessionsRelationship = {
  __typename?: 'UserHasVisitSessionsRelationship';
  cursor: Scalars['String']['output'];
  node: VisitSession;
};

export type UserHasVisitSessionsUpdateConnectionInput = {
  node?: InputMaybe<VisitSessionUpdateInput>;
};

export type UserHasVisitSessionsUpdateFieldInput = {
  connect?: InputMaybe<Array<UserHasVisitSessionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserHasVisitSessionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserHasVisitSessionsCreateFieldInput>>;
  delete?: InputMaybe<Array<UserHasVisitSessionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserHasVisitSessionsDisconnectFieldInput>>;
  update?: InputMaybe<UserHasVisitSessionsUpdateConnectionInput>;
  where?: InputMaybe<UserHasVisitSessionsConnectionWhere>;
};

export type UserHasWaterIntakeWaterIntakesAggregateInput = {
  AND?: InputMaybe<Array<UserHasWaterIntakeWaterIntakesAggregateInput>>;
  NOT?: InputMaybe<UserHasWaterIntakeWaterIntakesAggregateInput>;
  OR?: InputMaybe<Array<UserHasWaterIntakeWaterIntakesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasWaterIntakePropertiesAggregationWhereInput>;
  node?: InputMaybe<UserHasWaterIntakeWaterIntakesNodeAggregationWhereInput>;
};

export type UserHasWaterIntakeWaterIntakesConnectFieldInput = {
  connect?: InputMaybe<Array<WaterIntakeConnectInput>>;
  edge: HasWaterIntakePropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<WaterIntakeConnectWhere>;
};

export type UserHasWaterIntakeWaterIntakesConnection = {
  __typename?: 'UserHasWaterIntakeWaterIntakesConnection';
  edges: Array<UserHasWaterIntakeWaterIntakesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserHasWaterIntakeWaterIntakesConnectionSort = {
  edge?: InputMaybe<HasWaterIntakePropertiesSort>;
  node?: InputMaybe<WaterIntakeSort>;
};

export type UserHasWaterIntakeWaterIntakesConnectionWhere = {
  AND?: InputMaybe<Array<UserHasWaterIntakeWaterIntakesConnectionWhere>>;
  NOT?: InputMaybe<UserHasWaterIntakeWaterIntakesConnectionWhere>;
  OR?: InputMaybe<Array<UserHasWaterIntakeWaterIntakesConnectionWhere>>;
  edge?: InputMaybe<HasWaterIntakePropertiesWhere>;
  node?: InputMaybe<WaterIntakeWhere>;
};

export type UserHasWaterIntakeWaterIntakesCreateFieldInput = {
  edge: HasWaterIntakePropertiesCreateInput;
  node: WaterIntakeCreateInput;
};

export type UserHasWaterIntakeWaterIntakesDeleteFieldInput = {
  delete?: InputMaybe<WaterIntakeDeleteInput>;
  where?: InputMaybe<UserHasWaterIntakeWaterIntakesConnectionWhere>;
};

export type UserHasWaterIntakeWaterIntakesDisconnectFieldInput = {
  disconnect?: InputMaybe<WaterIntakeDisconnectInput>;
  where?: InputMaybe<UserHasWaterIntakeWaterIntakesConnectionWhere>;
};

export type UserHasWaterIntakeWaterIntakesFieldInput = {
  connect?: InputMaybe<Array<UserHasWaterIntakeWaterIntakesConnectFieldInput>>;
  create?: InputMaybe<Array<UserHasWaterIntakeWaterIntakesCreateFieldInput>>;
};

export type UserHasWaterIntakeWaterIntakesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserHasWaterIntakeWaterIntakesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserHasWaterIntakeWaterIntakesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserHasWaterIntakeWaterIntakesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  water_intake_oz_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type UserHasWaterIntakeWaterIntakesRelationship = {
  __typename?: 'UserHasWaterIntakeWaterIntakesRelationship';
  cursor: Scalars['String']['output'];
  node: WaterIntake;
  properties: HasWaterIntakeProperties;
};

export type UserHasWaterIntakeWaterIntakesUpdateConnectionInput = {
  edge?: InputMaybe<HasWaterIntakePropertiesUpdateInput>;
  node?: InputMaybe<WaterIntakeUpdateInput>;
};

export type UserHasWaterIntakeWaterIntakesUpdateFieldInput = {
  connect?: InputMaybe<Array<UserHasWaterIntakeWaterIntakesConnectFieldInput>>;
  create?: InputMaybe<Array<UserHasWaterIntakeWaterIntakesCreateFieldInput>>;
  delete?: InputMaybe<Array<UserHasWaterIntakeWaterIntakesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserHasWaterIntakeWaterIntakesDisconnectFieldInput>>;
  update?: InputMaybe<UserHasWaterIntakeWaterIntakesUpdateConnectionInput>;
  where?: InputMaybe<UserHasWaterIntakeWaterIntakesConnectionWhere>;
};

export type UserHasWhitelistedEmailsAggregateInput = {
  AND?: InputMaybe<Array<UserHasWhitelistedEmailsAggregateInput>>;
  NOT?: InputMaybe<UserHasWhitelistedEmailsAggregateInput>;
  OR?: InputMaybe<Array<UserHasWhitelistedEmailsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserHasWhitelistedEmailsNodeAggregationWhereInput>;
};

export type UserHasWhitelistedEmailsConnectFieldInput = {
  connect?: InputMaybe<Array<WhitelistedEmailConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<WhitelistedEmailConnectWhere>;
};

export type UserHasWhitelistedEmailsConnection = {
  __typename?: 'UserHasWhitelistedEmailsConnection';
  edges: Array<UserHasWhitelistedEmailsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserHasWhitelistedEmailsConnectionSort = {
  node?: InputMaybe<WhitelistedEmailSort>;
};

export type UserHasWhitelistedEmailsConnectionWhere = {
  AND?: InputMaybe<Array<UserHasWhitelistedEmailsConnectionWhere>>;
  NOT?: InputMaybe<UserHasWhitelistedEmailsConnectionWhere>;
  OR?: InputMaybe<Array<UserHasWhitelistedEmailsConnectionWhere>>;
  node?: InputMaybe<WhitelistedEmailWhere>;
};

export type UserHasWhitelistedEmailsCreateFieldInput = {
  node: WhitelistedEmailCreateInput;
};

export type UserHasWhitelistedEmailsDeleteFieldInput = {
  delete?: InputMaybe<WhitelistedEmailDeleteInput>;
  where?: InputMaybe<UserHasWhitelistedEmailsConnectionWhere>;
};

export type UserHasWhitelistedEmailsDisconnectFieldInput = {
  disconnect?: InputMaybe<WhitelistedEmailDisconnectInput>;
  where?: InputMaybe<UserHasWhitelistedEmailsConnectionWhere>;
};

export type UserHasWhitelistedEmailsFieldInput = {
  connect?: InputMaybe<Array<UserHasWhitelistedEmailsConnectFieldInput>>;
  create?: InputMaybe<Array<UserHasWhitelistedEmailsCreateFieldInput>>;
};

export type UserHasWhitelistedEmailsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserHasWhitelistedEmailsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserHasWhitelistedEmailsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserHasWhitelistedEmailsNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserHasWhitelistedEmailsRelationship = {
  __typename?: 'UserHasWhitelistedEmailsRelationship';
  cursor: Scalars['String']['output'];
  node: WhitelistedEmail;
};

export type UserHasWhitelistedEmailsUpdateConnectionInput = {
  node?: InputMaybe<WhitelistedEmailUpdateInput>;
};

export type UserHasWhitelistedEmailsUpdateFieldInput = {
  connect?: InputMaybe<Array<UserHasWhitelistedEmailsConnectFieldInput>>;
  create?: InputMaybe<Array<UserHasWhitelistedEmailsCreateFieldInput>>;
  delete?: InputMaybe<Array<UserHasWhitelistedEmailsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserHasWhitelistedEmailsDisconnectFieldInput>>;
  update?: InputMaybe<UserHasWhitelistedEmailsUpdateConnectionInput>;
  where?: InputMaybe<UserHasWhitelistedEmailsConnectionWhere>;
};

export type UserHasWorkspacesAggregateInput = {
  AND?: InputMaybe<Array<UserHasWorkspacesAggregateInput>>;
  NOT?: InputMaybe<UserHasWorkspacesAggregateInput>;
  OR?: InputMaybe<Array<UserHasWorkspacesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserHasWorkspacesNodeAggregationWhereInput>;
};

export type UserHasWorkspacesConnectFieldInput = {
  connect?: InputMaybe<Array<WorkspaceConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<WorkspaceConnectWhere>;
};

export type UserHasWorkspacesConnectOrCreateFieldInput = {
  onCreate: UserHasWorkspacesConnectOrCreateFieldInputOnCreate;
  where: WorkspaceConnectOrCreateWhere;
};

export type UserHasWorkspacesConnectOrCreateFieldInputOnCreate = {
  node: WorkspaceOnCreateInput;
};

export type UserHasWorkspacesConnection = {
  __typename?: 'UserHasWorkspacesConnection';
  edges: Array<UserHasWorkspacesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserHasWorkspacesConnectionSort = {
  node?: InputMaybe<WorkspaceSort>;
};

export type UserHasWorkspacesConnectionWhere = {
  AND?: InputMaybe<Array<UserHasWorkspacesConnectionWhere>>;
  NOT?: InputMaybe<UserHasWorkspacesConnectionWhere>;
  OR?: InputMaybe<Array<UserHasWorkspacesConnectionWhere>>;
  node?: InputMaybe<WorkspaceWhere>;
};

export type UserHasWorkspacesCreateFieldInput = {
  node: WorkspaceCreateInput;
};

export type UserHasWorkspacesDeleteFieldInput = {
  delete?: InputMaybe<WorkspaceDeleteInput>;
  where?: InputMaybe<UserHasWorkspacesConnectionWhere>;
};

export type UserHasWorkspacesDisconnectFieldInput = {
  disconnect?: InputMaybe<WorkspaceDisconnectInput>;
  where?: InputMaybe<UserHasWorkspacesConnectionWhere>;
};

export type UserHasWorkspacesFieldInput = {
  connect?: InputMaybe<Array<UserHasWorkspacesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserHasWorkspacesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserHasWorkspacesCreateFieldInput>>;
};

export type UserHasWorkspacesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserHasWorkspacesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserHasWorkspacesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserHasWorkspacesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  key_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  key_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserHasWorkspacesRelationship = {
  __typename?: 'UserHasWorkspacesRelationship';
  cursor: Scalars['String']['output'];
  node: Workspace;
};

export type UserHasWorkspacesUpdateConnectionInput = {
  node?: InputMaybe<WorkspaceUpdateInput>;
};

export type UserHasWorkspacesUpdateFieldInput = {
  connect?: InputMaybe<Array<UserHasWorkspacesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserHasWorkspacesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserHasWorkspacesCreateFieldInput>>;
  delete?: InputMaybe<Array<UserHasWorkspacesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserHasWorkspacesDisconnectFieldInput>>;
  update?: InputMaybe<UserHasWorkspacesUpdateConnectionInput>;
  where?: InputMaybe<UserHasWorkspacesConnectionWhere>;
};

export type UserInput = {
  id: Scalars['ID']['input'];
};

/**
 * The edge properties for the following fields:
 * * ExternalCourse.users
 * * ExternalAssignment.assignees
 * * ExternalPage.users
 * * ExternalQuiz.assignees
 */
export type UserLmsContentProperties = {
  __typename?: 'UserLMSContentProperties';
  syncedAt: Scalars['DateTime']['output'];
};

export type UserLmsContentPropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<UserLmsContentPropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<UserLmsContentPropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<UserLmsContentPropertiesAggregationWhereInput>>;
  syncedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserLmsContentPropertiesCreateInput = {
  syncedAt: Scalars['DateTime']['input'];
};

export type UserLmsContentPropertiesSort = {
  syncedAt?: InputMaybe<SortDirection>;
};

export type UserLmsContentPropertiesUpdateInput = {
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserLmsContentPropertiesWhere = {
  AND?: InputMaybe<Array<UserLmsContentPropertiesWhere>>;
  NOT?: InputMaybe<UserLmsContentPropertiesWhere>;
  OR?: InputMaybe<Array<UserLmsContentPropertiesWhere>>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  syncedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserLearningPaymentLearningPaymentsAggregationSelection = {
  __typename?: 'UserLearningPaymentLearningPaymentsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserLearningPaymentLearningPaymentsNodeAggregateSelection>;
};

export type UserLearningPaymentLearningPaymentsNodeAggregateSelection = {
  __typename?: 'UserLearningPaymentLearningPaymentsNodeAggregateSelection';
  amount: FloatAggregateSelection;
  created: DateTimeAggregateSelection;
  discountAmount: FloatAggregateSelection;
  id: IdAggregateSelection;
  promotionCode: StringAggregateSelection;
};

export type UserLearningPaymentsAggregateInput = {
  AND?: InputMaybe<Array<UserLearningPaymentsAggregateInput>>;
  NOT?: InputMaybe<UserLearningPaymentsAggregateInput>;
  OR?: InputMaybe<Array<UserLearningPaymentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserLearningPaymentsNodeAggregationWhereInput>;
};

export type UserLearningPaymentsConnectFieldInput = {
  connect?: InputMaybe<Array<LearningPaymentConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<LearningPaymentConnectWhere>;
};

export type UserLearningPaymentsConnectOrCreateFieldInput = {
  onCreate: UserLearningPaymentsConnectOrCreateFieldInputOnCreate;
  where: LearningPaymentConnectOrCreateWhere;
};

export type UserLearningPaymentsConnectOrCreateFieldInputOnCreate = {
  node: LearningPaymentOnCreateInput;
};

export type UserLearningPaymentsConnection = {
  __typename?: 'UserLearningPaymentsConnection';
  edges: Array<UserLearningPaymentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserLearningPaymentsConnectionSort = {
  node?: InputMaybe<LearningPaymentSort>;
};

export type UserLearningPaymentsConnectionWhere = {
  AND?: InputMaybe<Array<UserLearningPaymentsConnectionWhere>>;
  NOT?: InputMaybe<UserLearningPaymentsConnectionWhere>;
  OR?: InputMaybe<Array<UserLearningPaymentsConnectionWhere>>;
  node?: InputMaybe<LearningPaymentWhere>;
};

export type UserLearningPaymentsCreateFieldInput = {
  node: LearningPaymentCreateInput;
};

export type UserLearningPaymentsDeleteFieldInput = {
  delete?: InputMaybe<LearningPaymentDeleteInput>;
  where?: InputMaybe<UserLearningPaymentsConnectionWhere>;
};

export type UserLearningPaymentsDisconnectFieldInput = {
  disconnect?: InputMaybe<LearningPaymentDisconnectInput>;
  where?: InputMaybe<UserLearningPaymentsConnectionWhere>;
};

export type UserLearningPaymentsFieldInput = {
  connect?: InputMaybe<Array<UserLearningPaymentsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserLearningPaymentsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserLearningPaymentsCreateFieldInput>>;
};

export type UserLearningPaymentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserLearningPaymentsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserLearningPaymentsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserLearningPaymentsNodeAggregationWhereInput>>;
  amount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  discountAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  promotionCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  promotionCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  promotionCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  promotionCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  promotionCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  promotionCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  promotionCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  promotionCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  promotionCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  promotionCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  promotionCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  promotionCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  promotionCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  promotionCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  promotionCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserLearningPaymentsRelationship = {
  __typename?: 'UserLearningPaymentsRelationship';
  cursor: Scalars['String']['output'];
  node: LearningPayment;
};

export type UserLearningPaymentsUpdateConnectionInput = {
  node?: InputMaybe<LearningPaymentUpdateInput>;
};

export type UserLearningPaymentsUpdateFieldInput = {
  connect?: InputMaybe<Array<UserLearningPaymentsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserLearningPaymentsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserLearningPaymentsCreateFieldInput>>;
  delete?: InputMaybe<Array<UserLearningPaymentsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserLearningPaymentsDisconnectFieldInput>>;
  update?: InputMaybe<UserLearningPaymentsUpdateConnectionInput>;
  where?: InputMaybe<UserLearningPaymentsConnectionWhere>;
};

export type UserLearningPreferences = {
  __typename?: 'UserLearningPreferences';
  assignmentReminders?: Maybe<Scalars['Boolean']['output']>;
  careerInterests?: Maybe<Array<Scalars['String']['output']>>;
  checkInFrequency?: Maybe<CheckInFrequency>;
  created?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  interests?: Maybe<Array<Scalars['String']['output']>>;
  last_modified?: Maybe<Scalars['DateTime']['output']>;
  learningStyles?: Maybe<Array<Scalars['String']['output']>>;
  motivations?: Maybe<Array<Scalars['String']['output']>>;
  semesterGoal?: Maybe<Scalars['String']['output']>;
  skillsToImprove?: Maybe<Array<Scalars['String']['output']>>;
  studyTimePreference?: Maybe<StudyTime>;
  textReminders?: Maybe<Scalars['Boolean']['output']>;
};

export type UserLearningPreferencesConnectOrCreateWhere = {
  node: UserLearningPreferencesUniqueWhere;
};

export type UserLearningPreferencesConnectWhere = {
  node: UserLearningPreferencesWhere;
};

export type UserLearningPreferencesCreateInput = {
  assignmentReminders?: InputMaybe<Scalars['Boolean']['input']>;
  careerInterests?: InputMaybe<Array<Scalars['String']['input']>>;
  checkInFrequency?: InputMaybe<CheckInFrequency>;
  id: Scalars['ID']['input'];
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  learningStyles?: InputMaybe<Array<Scalars['String']['input']>>;
  motivations?: InputMaybe<Array<Scalars['String']['input']>>;
  semesterGoal?: InputMaybe<Scalars['String']['input']>;
  skillsToImprove?: InputMaybe<Array<Scalars['String']['input']>>;
  studyTimePreference?: InputMaybe<StudyTime>;
  textReminders?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserLearningPreferencesOnCreateInput = {
  assignmentReminders?: InputMaybe<Scalars['Boolean']['input']>;
  careerInterests?: InputMaybe<Array<Scalars['String']['input']>>;
  checkInFrequency?: InputMaybe<CheckInFrequency>;
  id: Scalars['ID']['input'];
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  learningStyles?: InputMaybe<Array<Scalars['String']['input']>>;
  motivations?: InputMaybe<Array<Scalars['String']['input']>>;
  semesterGoal?: InputMaybe<Scalars['String']['input']>;
  skillsToImprove?: InputMaybe<Array<Scalars['String']['input']>>;
  studyTimePreference?: InputMaybe<StudyTime>;
  textReminders?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserLearningPreferencesOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more UserLearningPreferencesSort objects to sort UserLearningPreferences by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<UserLearningPreferencesSort>>;
};

/** Fields to sort UserLearningPreferences by. The order in which sorts are applied is not guaranteed when specifying many fields in one UserLearningPreferencesSort object. */
export type UserLearningPreferencesSort = {
  assignmentReminders?: InputMaybe<SortDirection>;
  checkInFrequency?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  last_modified?: InputMaybe<SortDirection>;
  semesterGoal?: InputMaybe<SortDirection>;
  studyTimePreference?: InputMaybe<SortDirection>;
  textReminders?: InputMaybe<SortDirection>;
};

export type UserLearningPreferencesUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UserLearningPreferencesUpdateInput = {
  assignmentReminders?: InputMaybe<Scalars['Boolean']['input']>;
  careerInterests?: InputMaybe<Array<Scalars['String']['input']>>;
  careerInterests_POP?: InputMaybe<Scalars['Int']['input']>;
  careerInterests_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  checkInFrequency?: InputMaybe<CheckInFrequency>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  interests_POP?: InputMaybe<Scalars['Int']['input']>;
  interests_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  learningStyles?: InputMaybe<Array<Scalars['String']['input']>>;
  learningStyles_POP?: InputMaybe<Scalars['Int']['input']>;
  learningStyles_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  motivations?: InputMaybe<Array<Scalars['String']['input']>>;
  motivations_POP?: InputMaybe<Scalars['Int']['input']>;
  motivations_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  semesterGoal?: InputMaybe<Scalars['String']['input']>;
  skillsToImprove?: InputMaybe<Array<Scalars['String']['input']>>;
  skillsToImprove_POP?: InputMaybe<Scalars['Int']['input']>;
  skillsToImprove_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  studyTimePreference?: InputMaybe<StudyTime>;
  textReminders?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserLearningPreferencesWhere = {
  AND?: InputMaybe<Array<UserLearningPreferencesWhere>>;
  NOT?: InputMaybe<UserLearningPreferencesWhere>;
  OR?: InputMaybe<Array<UserLearningPreferencesWhere>>;
  assignmentReminders?: InputMaybe<Scalars['Boolean']['input']>;
  careerInterests?: InputMaybe<Array<Scalars['String']['input']>>;
  careerInterests_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  checkInFrequency?: InputMaybe<CheckInFrequency>;
  checkInFrequency_IN?: InputMaybe<Array<InputMaybe<CheckInFrequency>>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  interests_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  last_modified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningStyles?: InputMaybe<Array<Scalars['String']['input']>>;
  learningStyles_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  motivations?: InputMaybe<Array<Scalars['String']['input']>>;
  motivations_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  semesterGoal?: InputMaybe<Scalars['String']['input']>;
  semesterGoal_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  semesterGoal_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  semesterGoal_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  semesterGoal_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  skillsToImprove?: InputMaybe<Array<Scalars['String']['input']>>;
  skillsToImprove_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  studyTimePreference?: InputMaybe<StudyTime>;
  studyTimePreference_IN?: InputMaybe<Array<InputMaybe<StudyTime>>>;
  textReminders?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserMonthlySummaryHasSummaryMonthlySummariesAggregationSelection = {
  __typename?: 'UserMonthlySummaryHasSummaryMonthlySummariesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserMonthlySummaryHasSummaryMonthlySummariesNodeAggregateSelection>;
};

export type UserMonthlySummaryHasSummaryMonthlySummariesNodeAggregateSelection = {
  __typename?: 'UserMonthlySummaryHasSummaryMonthlySummariesNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  date: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  summary: StringAggregateSelection;
};

export type UserNoteAuthoredNotesAggregationSelection = {
  __typename?: 'UserNoteAuthoredNotesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserNoteAuthoredNotesNodeAggregateSelection>;
};

export type UserNoteAuthoredNotesNodeAggregateSelection = {
  __typename?: 'UserNoteAuthoredNotesNodeAggregateSelection';
  content: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
};

export type UserNoteNotesAggregationSelection = {
  __typename?: 'UserNoteNotesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserNoteNotesNodeAggregateSelection>;
};

export type UserNoteNotesNodeAggregateSelection = {
  __typename?: 'UserNoteNotesNodeAggregateSelection';
  content: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
};

export type UserNotesAggregateInput = {
  AND?: InputMaybe<Array<UserNotesAggregateInput>>;
  NOT?: InputMaybe<UserNotesAggregateInput>;
  OR?: InputMaybe<Array<UserNotesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserNotesNodeAggregationWhereInput>;
};

export type UserNotesConnectFieldInput = {
  connect?: InputMaybe<Array<NoteConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<NoteConnectWhere>;
};

export type UserNotesConnectOrCreateFieldInput = {
  onCreate: UserNotesConnectOrCreateFieldInputOnCreate;
  where: NoteConnectOrCreateWhere;
};

export type UserNotesConnectOrCreateFieldInputOnCreate = {
  node: NoteOnCreateInput;
};

export type UserNotesConnection = {
  __typename?: 'UserNotesConnection';
  edges: Array<UserNotesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserNotesConnectionSort = {
  node?: InputMaybe<NoteSort>;
};

export type UserNotesConnectionWhere = {
  AND?: InputMaybe<Array<UserNotesConnectionWhere>>;
  NOT?: InputMaybe<UserNotesConnectionWhere>;
  OR?: InputMaybe<Array<UserNotesConnectionWhere>>;
  node?: InputMaybe<NoteWhere>;
};

export type UserNotesCreateFieldInput = {
  node: NoteCreateInput;
};

export type UserNotesDeleteFieldInput = {
  delete?: InputMaybe<NoteDeleteInput>;
  where?: InputMaybe<UserNotesConnectionWhere>;
};

export type UserNotesDisconnectFieldInput = {
  disconnect?: InputMaybe<NoteDisconnectInput>;
  where?: InputMaybe<UserNotesConnectionWhere>;
};

export type UserNotesFieldInput = {
  connect?: InputMaybe<Array<UserNotesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserNotesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserNotesCreateFieldInput>>;
};

export type UserNotesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserNotesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserNotesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserNotesNodeAggregationWhereInput>>;
  content_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  content_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserNotesRelationship = {
  __typename?: 'UserNotesRelationship';
  cursor: Scalars['String']['output'];
  node: Note;
};

export type UserNotesUpdateConnectionInput = {
  node?: InputMaybe<NoteUpdateInput>;
};

export type UserNotesUpdateFieldInput = {
  connect?: InputMaybe<Array<UserNotesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserNotesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserNotesCreateFieldInput>>;
  delete?: InputMaybe<Array<UserNotesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserNotesDisconnectFieldInput>>;
  update?: InputMaybe<UserNotesUpdateConnectionInput>;
  where?: InputMaybe<UserNotesConnectionWhere>;
};

export type UserNudgeNudgesAboutThisAggregationSelection = {
  __typename?: 'UserNudgeNudgesAboutThisAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserNudgeNudgesAboutThisNodeAggregateSelection>;
};

export type UserNudgeNudgesAboutThisNodeAggregateSelection = {
  __typename?: 'UserNudgeNudgesAboutThisNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  idempotencyKey: StringAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  priorityScore: FloatAggregateSelection;
  scheduledFor: DateTimeAggregateSelection;
  snoozedUntil: DateTimeAggregateSelection;
  taskCompletedAt: DateTimeAggregateSelection;
};

export type UserNudgeNudgesAggregationSelection = {
  __typename?: 'UserNudgeNudgesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserNudgeNudgesNodeAggregateSelection>;
};

export type UserNudgeNudgesNodeAggregateSelection = {
  __typename?: 'UserNudgeNudgesNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  idempotencyKey: StringAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  priorityScore: FloatAggregateSelection;
  scheduledFor: DateTimeAggregateSelection;
  snoozedUntil: DateTimeAggregateSelection;
  taskCompletedAt: DateTimeAggregateSelection;
};

export type UserNudgePreferencesAggregateInput = {
  AND?: InputMaybe<Array<UserNudgePreferencesAggregateInput>>;
  NOT?: InputMaybe<UserNudgePreferencesAggregateInput>;
  OR?: InputMaybe<Array<UserNudgePreferencesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserNudgePreferencesNodeAggregationWhereInput>;
};

export type UserNudgePreferencesConnectFieldInput = {
  connect?: InputMaybe<NudgePreferencesConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<NudgePreferencesConnectWhere>;
};

export type UserNudgePreferencesConnectOrCreateFieldInput = {
  onCreate: UserNudgePreferencesConnectOrCreateFieldInputOnCreate;
  where: NudgePreferencesConnectOrCreateWhere;
};

export type UserNudgePreferencesConnectOrCreateFieldInputOnCreate = {
  node: NudgePreferencesOnCreateInput;
};

export type UserNudgePreferencesConnection = {
  __typename?: 'UserNudgePreferencesConnection';
  edges: Array<UserNudgePreferencesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserNudgePreferencesConnectionSort = {
  node?: InputMaybe<NudgePreferencesSort>;
};

export type UserNudgePreferencesConnectionWhere = {
  AND?: InputMaybe<Array<UserNudgePreferencesConnectionWhere>>;
  NOT?: InputMaybe<UserNudgePreferencesConnectionWhere>;
  OR?: InputMaybe<Array<UserNudgePreferencesConnectionWhere>>;
  node?: InputMaybe<NudgePreferencesWhere>;
};

export type UserNudgePreferencesCreateFieldInput = {
  node: NudgePreferencesCreateInput;
};

export type UserNudgePreferencesDeleteFieldInput = {
  delete?: InputMaybe<NudgePreferencesDeleteInput>;
  where?: InputMaybe<UserNudgePreferencesConnectionWhere>;
};

export type UserNudgePreferencesDisconnectFieldInput = {
  disconnect?: InputMaybe<NudgePreferencesDisconnectInput>;
  where?: InputMaybe<UserNudgePreferencesConnectionWhere>;
};

export type UserNudgePreferencesFieldInput = {
  connect?: InputMaybe<UserNudgePreferencesConnectFieldInput>;
  connectOrCreate?: InputMaybe<UserNudgePreferencesConnectOrCreateFieldInput>;
  create?: InputMaybe<UserNudgePreferencesCreateFieldInput>;
};

export type UserNudgePreferencesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserNudgePreferencesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserNudgePreferencesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserNudgePreferencesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  maxEmailPerDay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxEmailPerDay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maxEmailPerDay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxEmailPerDay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maxEmailPerDay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxEmailPerDay_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxEmailPerDay_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  maxEmailPerDay_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxEmailPerDay_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  maxEmailPerDay_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxEmailPerDay_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxEmailPerDay_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  maxEmailPerDay_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxEmailPerDay_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  maxEmailPerDay_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxEmailPerDay_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxEmailPerDay_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  maxEmailPerDay_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxEmailPerDay_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  maxEmailPerDay_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxSmsPerDay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxSmsPerDay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maxSmsPerDay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxSmsPerDay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maxSmsPerDay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxSmsPerDay_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxSmsPerDay_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  maxSmsPerDay_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxSmsPerDay_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  maxSmsPerDay_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxSmsPerDay_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxSmsPerDay_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  maxSmsPerDay_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxSmsPerDay_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  maxSmsPerDay_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxSmsPerDay_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxSmsPerDay_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  maxSmsPerDay_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxSmsPerDay_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  maxSmsPerDay_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredSendTime_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredSendTime_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredSendTime_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredSendTime_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredSendTime_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredSendTime_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredSendTime_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredSendTime_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredSendTime_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredSendTime_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredSendTime_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredSendTime_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredSendTime_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredSendTime_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredSendTime_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  snoozeAllUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  snoozeAllUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozeAllUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozeAllUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozeAllUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozeAllUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  snoozeAllUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozeAllUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozeAllUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozeAllUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserNudgePreferencesNudgePreferencesAggregationSelection = {
  __typename?: 'UserNudgePreferencesNudgePreferencesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserNudgePreferencesNudgePreferencesNodeAggregateSelection>;
};

export type UserNudgePreferencesNudgePreferencesNodeAggregateSelection = {
  __typename?: 'UserNudgePreferencesNudgePreferencesNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  maxEmailPerDay: IntAggregateSelection;
  maxSmsPerDay: IntAggregateSelection;
  preferredSendTime: StringAggregateSelection;
  snoozeAllUntil: DateTimeAggregateSelection;
  timezone: StringAggregateSelection;
  userId: IdAggregateSelection;
};

export type UserNudgePreferencesRelationship = {
  __typename?: 'UserNudgePreferencesRelationship';
  cursor: Scalars['String']['output'];
  node: NudgePreferences;
};

export type UserNudgePreferencesUpdateConnectionInput = {
  node?: InputMaybe<NudgePreferencesUpdateInput>;
};

export type UserNudgePreferencesUpdateFieldInput = {
  connect?: InputMaybe<UserNudgePreferencesConnectFieldInput>;
  connectOrCreate?: InputMaybe<UserNudgePreferencesConnectOrCreateFieldInput>;
  create?: InputMaybe<UserNudgePreferencesCreateFieldInput>;
  delete?: InputMaybe<UserNudgePreferencesDeleteFieldInput>;
  disconnect?: InputMaybe<UserNudgePreferencesDisconnectFieldInput>;
  update?: InputMaybe<UserNudgePreferencesUpdateConnectionInput>;
  where?: InputMaybe<UserNudgePreferencesConnectionWhere>;
};

export type UserNudgesAboutThisAggregateInput = {
  AND?: InputMaybe<Array<UserNudgesAboutThisAggregateInput>>;
  NOT?: InputMaybe<UserNudgesAboutThisAggregateInput>;
  OR?: InputMaybe<Array<UserNudgesAboutThisAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserNudgesAboutThisNodeAggregationWhereInput>;
};

export type UserNudgesAboutThisConnectFieldInput = {
  connect?: InputMaybe<Array<NudgeConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<NudgeConnectWhere>;
};

export type UserNudgesAboutThisConnectOrCreateFieldInput = {
  onCreate: UserNudgesAboutThisConnectOrCreateFieldInputOnCreate;
  where: NudgeConnectOrCreateWhere;
};

export type UserNudgesAboutThisConnectOrCreateFieldInputOnCreate = {
  node: NudgeOnCreateInput;
};

export type UserNudgesAboutThisConnection = {
  __typename?: 'UserNudgesAboutThisConnection';
  edges: Array<UserNudgesAboutThisRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserNudgesAboutThisConnectionSort = {
  node?: InputMaybe<NudgeSort>;
};

export type UserNudgesAboutThisConnectionWhere = {
  AND?: InputMaybe<Array<UserNudgesAboutThisConnectionWhere>>;
  NOT?: InputMaybe<UserNudgesAboutThisConnectionWhere>;
  OR?: InputMaybe<Array<UserNudgesAboutThisConnectionWhere>>;
  node?: InputMaybe<NudgeWhere>;
};

export type UserNudgesAboutThisCreateFieldInput = {
  node: NudgeCreateInput;
};

export type UserNudgesAboutThisDeleteFieldInput = {
  delete?: InputMaybe<NudgeDeleteInput>;
  where?: InputMaybe<UserNudgesAboutThisConnectionWhere>;
};

export type UserNudgesAboutThisDisconnectFieldInput = {
  disconnect?: InputMaybe<NudgeDisconnectInput>;
  where?: InputMaybe<UserNudgesAboutThisConnectionWhere>;
};

export type UserNudgesAboutThisFieldInput = {
  connect?: InputMaybe<Array<UserNudgesAboutThisConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserNudgesAboutThisConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserNudgesAboutThisCreateFieldInput>>;
};

export type UserNudgesAboutThisNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserNudgesAboutThisNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserNudgesAboutThisNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserNudgesAboutThisNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  idempotencyKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  priorityScore_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  scheduledFor_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserNudgesAboutThisRelationship = {
  __typename?: 'UserNudgesAboutThisRelationship';
  cursor: Scalars['String']['output'];
  node: Nudge;
};

export type UserNudgesAboutThisUpdateConnectionInput = {
  node?: InputMaybe<NudgeUpdateInput>;
};

export type UserNudgesAboutThisUpdateFieldInput = {
  connect?: InputMaybe<Array<UserNudgesAboutThisConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserNudgesAboutThisConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserNudgesAboutThisCreateFieldInput>>;
  delete?: InputMaybe<Array<UserNudgesAboutThisDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserNudgesAboutThisDisconnectFieldInput>>;
  update?: InputMaybe<UserNudgesAboutThisUpdateConnectionInput>;
  where?: InputMaybe<UserNudgesAboutThisConnectionWhere>;
};

export type UserNudgesAggregateInput = {
  AND?: InputMaybe<Array<UserNudgesAggregateInput>>;
  NOT?: InputMaybe<UserNudgesAggregateInput>;
  OR?: InputMaybe<Array<UserNudgesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserNudgesNodeAggregationWhereInput>;
};

export type UserNudgesConnectFieldInput = {
  connect?: InputMaybe<Array<NudgeConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<NudgeConnectWhere>;
};

export type UserNudgesConnectOrCreateFieldInput = {
  onCreate: UserNudgesConnectOrCreateFieldInputOnCreate;
  where: NudgeConnectOrCreateWhere;
};

export type UserNudgesConnectOrCreateFieldInputOnCreate = {
  node: NudgeOnCreateInput;
};

export type UserNudgesConnection = {
  __typename?: 'UserNudgesConnection';
  edges: Array<UserNudgesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserNudgesConnectionSort = {
  node?: InputMaybe<NudgeSort>;
};

export type UserNudgesConnectionWhere = {
  AND?: InputMaybe<Array<UserNudgesConnectionWhere>>;
  NOT?: InputMaybe<UserNudgesConnectionWhere>;
  OR?: InputMaybe<Array<UserNudgesConnectionWhere>>;
  node?: InputMaybe<NudgeWhere>;
};

export type UserNudgesCreateFieldInput = {
  node: NudgeCreateInput;
};

export type UserNudgesDeleteFieldInput = {
  delete?: InputMaybe<NudgeDeleteInput>;
  where?: InputMaybe<UserNudgesConnectionWhere>;
};

export type UserNudgesDisconnectFieldInput = {
  disconnect?: InputMaybe<NudgeDisconnectInput>;
  where?: InputMaybe<UserNudgesConnectionWhere>;
};

export type UserNudgesFieldInput = {
  connect?: InputMaybe<Array<UserNudgesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserNudgesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserNudgesCreateFieldInput>>;
};

export type UserNudgesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserNudgesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserNudgesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserNudgesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  idempotencyKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  idempotencyKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idempotencyKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  priorityScore_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  priorityScore_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  scheduledFor_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledFor_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  snoozedUntil_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  taskCompletedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserNudgesRelationship = {
  __typename?: 'UserNudgesRelationship';
  cursor: Scalars['String']['output'];
  node: Nudge;
};

export type UserNudgesUpdateConnectionInput = {
  node?: InputMaybe<NudgeUpdateInput>;
};

export type UserNudgesUpdateFieldInput = {
  connect?: InputMaybe<Array<UserNudgesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserNudgesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserNudgesCreateFieldInput>>;
  delete?: InputMaybe<Array<UserNudgesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserNudgesDisconnectFieldInput>>;
  update?: InputMaybe<UserNudgesUpdateConnectionInput>;
  where?: InputMaybe<UserNudgesConnectionWhere>;
};

export type UserOnCreateInput = {
  _empty?: InputMaybe<Scalars['String']['input']>;
  audioOn?: InputMaybe<Scalars['Boolean']['input']>;
  biography?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  consentToSms?: InputMaybe<Scalars['Boolean']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  created: Scalars['DateTime']['input'];
  crmUserId?: InputMaybe<Scalars['String']['input']>;
  currentWeightLbs?: InputMaybe<Scalars['Float']['input']>;
  dailyEmailOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  enrolledTracks?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fullPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  goalWeightLbs?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens?: InputMaybe<Scalars['String']['input']>;
  googleCalendarAuthToken?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  invitationToken?: InputMaybe<Scalars['String']['input']>;
  invitationTokenExpiry?: InputMaybe<Scalars['DateTime']['input']>;
  inviteCount?: InputMaybe<Scalars['Int']['input']>;
  isCareerLoading?: InputMaybe<Scalars['Boolean']['input']>;
  isCourseLoading?: InputMaybe<Scalars['Boolean']['input']>;
  isEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  isOnboarded?: InputMaybe<Scalars['Boolean']['input']>;
  isPhoneVerified?: InputMaybe<Scalars['Boolean']['input']>;
  isPro?: InputMaybe<Scalars['Boolean']['input']>;
  meetingLink?: InputMaybe<Scalars['String']['input']>;
  modalOnboarding?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  needsResolution?: InputMaybe<Scalars['Boolean']['input']>;
  otpPreference?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  passwordResetToken?: InputMaybe<Scalars['String']['input']>;
  passwordResetTokenExpiry?: InputMaybe<Scalars['DateTime']['input']>;
  pendingCourseEnrollmentInvite?: InputMaybe<Scalars['Boolean']['input']>;
  pendingEmail?: InputMaybe<Scalars['String']['input']>;
  pendingFacultyInvite?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Scalars['String']['input']>;
  showLearningActivityIntro?: InputMaybe<Scalars['Boolean']['input']>;
  skipAllNotificationEmail?: InputMaybe<Scalars['Boolean']['input']>;
  ssoId?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerIdLearningPayments?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  trialEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  watchedIntroVideo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more UserSort objects to sort Users by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<UserSort>>;
};

export type UserPaymentHasPaymentPaymentsAggregationSelection = {
  __typename?: 'UserPaymentHasPaymentPaymentsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<UserPaymentHasPaymentPaymentsEdgeAggregateSelection>;
  node?: Maybe<UserPaymentHasPaymentPaymentsNodeAggregateSelection>;
};

export type UserPaymentHasPaymentPaymentsEdgeAggregateSelection = {
  __typename?: 'UserPaymentHasPaymentPaymentsEdgeAggregateSelection';
  integrationId: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
};

export type UserPaymentHasPaymentPaymentsNodeAggregateSelection = {
  __typename?: 'UserPaymentHasPaymentPaymentsNodeAggregateSelection';
  domain: StringAggregateSelection;
};

export type UserPostAuthoredPostsAggregationSelection = {
  __typename?: 'UserPostAuthoredPostsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserPostAuthoredPostsNodeAggregateSelection>;
};

export type UserPostAuthoredPostsNodeAggregateSelection = {
  __typename?: 'UserPostAuthoredPostsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  depth: IntAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  message: StringAggregateSelection;
  threadId: StringAggregateSelection;
};

export type UserPreferencesHasPreferencesPreferencesAggregationSelection = {
  __typename?: 'UserPreferencesHasPreferencesPreferencesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserPreferencesHasPreferencesPreferencesNodeAggregateSelection>;
};

export type UserPreferencesHasPreferencesPreferencesNodeAggregateSelection = {
  __typename?: 'UserPreferencesHasPreferencesPreferencesNodeAggregateSelection';
  contentType: StringAggregateSelection;
  language: StringAggregateSelection;
  learningDuration: IntAggregateSelection;
  learningStyle: StringAggregateSelection;
  notificationPreferences: StringAggregateSelection;
  timeOfDay: StringAggregateSelection;
};

export type UserProgress = {
  __typename?: 'UserProgress';
  child: ChildInfo;
  lastModified: Scalars['String']['output'];
  parent?: Maybe<ChildInfo>;
  totalMastery?: Maybe<Scalars['Float']['output']>;
};

export type UserProgressHasProgressAggregationSelection = {
  __typename?: 'UserProgressHasProgressAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserProgressHasProgressNodeAggregateSelection>;
};

export type UserProgressHasProgressNodeAggregateSelection = {
  __typename?: 'UserProgressHasProgressNodeAggregateSelection';
  date: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  id: IntAggregateSelection;
  level: StringAggregateSelection;
  type: StringAggregateSelection;
};

export type UserQuarterlySummaryHasSummaryQuarterlySummariesAggregationSelection = {
  __typename?: 'UserQuarterlySummaryHasSummaryQuarterlySummariesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserQuarterlySummaryHasSummaryQuarterlySummariesNodeAggregateSelection>;
};

export type UserQuarterlySummaryHasSummaryQuarterlySummariesNodeAggregateSelection = {
  __typename?: 'UserQuarterlySummaryHasSummaryQuarterlySummariesNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  date: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  summary: StringAggregateSelection;
};

export type UserReviewAiTutorBeingGeneratedForAggregateInput = {
  AND?: InputMaybe<Array<UserReviewAiTutorBeingGeneratedForAggregateInput>>;
  NOT?: InputMaybe<UserReviewAiTutorBeingGeneratedForAggregateInput>;
  OR?: InputMaybe<Array<UserReviewAiTutorBeingGeneratedForAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserReviewAiTutorBeingGeneratedForNodeAggregationWhereInput>;
};

export type UserReviewAiTutorBeingGeneratedForConnectFieldInput = {
  connect?: InputMaybe<Array<ReviewConnectInput>>;
  edge?: InputMaybe<ReviewGeneratingForPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ReviewConnectWhere>;
};

export type UserReviewAiTutorBeingGeneratedForConnectOrCreateFieldInput = {
  onCreate: UserReviewAiTutorBeingGeneratedForConnectOrCreateFieldInputOnCreate;
  where: ReviewConnectOrCreateWhere;
};

export type UserReviewAiTutorBeingGeneratedForConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<ReviewGeneratingForPropertiesCreateInput>;
  node: ReviewOnCreateInput;
};

export type UserReviewAiTutorBeingGeneratedForConnection = {
  __typename?: 'UserReviewAITutorBeingGeneratedForConnection';
  edges: Array<UserReviewAiTutorBeingGeneratedForRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserReviewAiTutorBeingGeneratedForConnectionSort = {
  edge?: InputMaybe<ReviewGeneratingForPropertiesSort>;
  node?: InputMaybe<ReviewSort>;
};

export type UserReviewAiTutorBeingGeneratedForConnectionWhere = {
  AND?: InputMaybe<Array<UserReviewAiTutorBeingGeneratedForConnectionWhere>>;
  NOT?: InputMaybe<UserReviewAiTutorBeingGeneratedForConnectionWhere>;
  OR?: InputMaybe<Array<UserReviewAiTutorBeingGeneratedForConnectionWhere>>;
  edge?: InputMaybe<ReviewGeneratingForPropertiesWhere>;
  node?: InputMaybe<ReviewWhere>;
};

export type UserReviewAiTutorBeingGeneratedForCreateFieldInput = {
  edge?: InputMaybe<ReviewGeneratingForPropertiesCreateInput>;
  node: ReviewCreateInput;
};

export type UserReviewAiTutorBeingGeneratedForDeleteFieldInput = {
  delete?: InputMaybe<ReviewDeleteInput>;
  where?: InputMaybe<UserReviewAiTutorBeingGeneratedForConnectionWhere>;
};

export type UserReviewAiTutorBeingGeneratedForDisconnectFieldInput = {
  disconnect?: InputMaybe<ReviewDisconnectInput>;
  where?: InputMaybe<UserReviewAiTutorBeingGeneratedForConnectionWhere>;
};

export type UserReviewAiTutorBeingGeneratedForFieldInput = {
  connect?: InputMaybe<Array<UserReviewAiTutorBeingGeneratedForConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserReviewAiTutorBeingGeneratedForConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserReviewAiTutorBeingGeneratedForCreateFieldInput>>;
};

export type UserReviewAiTutorBeingGeneratedForNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserReviewAiTutorBeingGeneratedForNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserReviewAiTutorBeingGeneratedForNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserReviewAiTutorBeingGeneratedForNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserReviewAiTutorBeingGeneratedForRelationship = {
  __typename?: 'UserReviewAITutorBeingGeneratedForRelationship';
  cursor: Scalars['String']['output'];
  node: Review;
  properties: ReviewGeneratingForProperties;
};

export type UserReviewAiTutorBeingGeneratedForUpdateConnectionInput = {
  edge?: InputMaybe<ReviewGeneratingForPropertiesUpdateInput>;
  node?: InputMaybe<ReviewUpdateInput>;
};

export type UserReviewAiTutorBeingGeneratedForUpdateFieldInput = {
  connect?: InputMaybe<Array<UserReviewAiTutorBeingGeneratedForConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserReviewAiTutorBeingGeneratedForConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserReviewAiTutorBeingGeneratedForCreateFieldInput>>;
  delete?: InputMaybe<Array<UserReviewAiTutorBeingGeneratedForDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserReviewAiTutorBeingGeneratedForDisconnectFieldInput>>;
  update?: InputMaybe<UserReviewAiTutorBeingGeneratedForUpdateConnectionInput>;
  where?: InputMaybe<UserReviewAiTutorBeingGeneratedForConnectionWhere>;
};

export type UserReviewReviewAiTutorBeingGeneratedForAggregationSelection = {
  __typename?: 'UserReviewReviewAITutorBeingGeneratedForAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserReviewReviewAiTutorBeingGeneratedForNodeAggregateSelection>;
};

export type UserReviewReviewAiTutorBeingGeneratedForNodeAggregateSelection = {
  __typename?: 'UserReviewReviewAITutorBeingGeneratedForNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
};

export type UserRoleHasRoleRolesAggregationSelection = {
  __typename?: 'UserRoleHasRoleRolesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<UserRoleHasRoleRolesEdgeAggregateSelection>;
  node?: Maybe<UserRoleHasRoleRolesNodeAggregateSelection>;
};

export type UserRoleHasRoleRolesEdgeAggregateSelection = {
  __typename?: 'UserRoleHasRoleRolesEdgeAggregateSelection';
  tenantId: IdAggregateSelection;
};

export type UserRoleHasRoleRolesNodeAggregateSelection = {
  __typename?: 'UserRoleHasRoleRolesNodeAggregateSelection';
  name: StringAggregateSelection;
};

/**
 * The edge properties for the following fields:
 * * User.hasRoleRoles
 * * Role.usersHasRole
 */
export type UserRoleProperties = {
  __typename?: 'UserRoleProperties';
  tenantId: Scalars['ID']['output'];
};

export type UserRolePropertiesAggregationWhereInput = {
  AND?: InputMaybe<Array<UserRolePropertiesAggregationWhereInput>>;
  NOT?: InputMaybe<UserRolePropertiesAggregationWhereInput>;
  OR?: InputMaybe<Array<UserRolePropertiesAggregationWhereInput>>;
};

export type UserRolePropertiesCreateInput = {
  tenantId: Scalars['ID']['input'];
};

export type UserRolePropertiesSort = {
  tenantId?: InputMaybe<SortDirection>;
};

export type UserRolePropertiesUpdateInput = {
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};

export type UserRolePropertiesWhere = {
  AND?: InputMaybe<Array<UserRolePropertiesWhere>>;
  NOT?: InputMaybe<UserRolePropertiesWhere>;
  OR?: InputMaybe<Array<UserRolePropertiesWhere>>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  tenantId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  tenantId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  tenantId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type UserRosterAnalytics = {
  __typename?: 'UserRosterAnalytics';
  active_interaction_count: Scalars['Int']['output'];
  completion_percentage?: Maybe<Scalars['Float']['output']>;
  confusion_points: Scalars['Int']['output'];
  distractions: Scalars['Int']['output'];
  questions_asked: Scalars['Int']['output'];
  sentiment: Scalars['String']['output'];
  success_points: Scalars['Int']['output'];
  total_time_taken?: Maybe<Scalars['Float']['output']>;
};

export type UserSchoolAssignmentsAggregateInput = {
  AND?: InputMaybe<Array<UserSchoolAssignmentsAggregateInput>>;
  NOT?: InputMaybe<UserSchoolAssignmentsAggregateInput>;
  OR?: InputMaybe<Array<UserSchoolAssignmentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasSchoolAssignmentPropertiesAggregationWhereInput>;
  node?: InputMaybe<UserSchoolAssignmentsNodeAggregationWhereInput>;
};

export type UserSchoolAssignmentsConnectFieldInput = {
  connect?: InputMaybe<Array<AssignmentConnectInput>>;
  edge?: InputMaybe<HasSchoolAssignmentPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AssignmentConnectWhere>;
};

export type UserSchoolAssignmentsConnectOrCreateFieldInput = {
  onCreate: UserSchoolAssignmentsConnectOrCreateFieldInputOnCreate;
  where: AssignmentConnectOrCreateWhere;
};

export type UserSchoolAssignmentsConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<HasSchoolAssignmentPropertiesCreateInput>;
  node: AssignmentOnCreateInput;
};

export type UserSchoolAssignmentsConnection = {
  __typename?: 'UserSchoolAssignmentsConnection';
  edges: Array<UserSchoolAssignmentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserSchoolAssignmentsConnectionSort = {
  edge?: InputMaybe<HasSchoolAssignmentPropertiesSort>;
  node?: InputMaybe<AssignmentSort>;
};

export type UserSchoolAssignmentsConnectionWhere = {
  AND?: InputMaybe<Array<UserSchoolAssignmentsConnectionWhere>>;
  NOT?: InputMaybe<UserSchoolAssignmentsConnectionWhere>;
  OR?: InputMaybe<Array<UserSchoolAssignmentsConnectionWhere>>;
  edge?: InputMaybe<HasSchoolAssignmentPropertiesWhere>;
  node?: InputMaybe<AssignmentWhere>;
};

export type UserSchoolAssignmentsCreateFieldInput = {
  edge?: InputMaybe<HasSchoolAssignmentPropertiesCreateInput>;
  node: AssignmentCreateInput;
};

export type UserSchoolAssignmentsDeleteFieldInput = {
  delete?: InputMaybe<AssignmentDeleteInput>;
  where?: InputMaybe<UserSchoolAssignmentsConnectionWhere>;
};

export type UserSchoolAssignmentsDisconnectFieldInput = {
  disconnect?: InputMaybe<AssignmentDisconnectInput>;
  where?: InputMaybe<UserSchoolAssignmentsConnectionWhere>;
};

export type UserSchoolAssignmentsFieldInput = {
  connect?: InputMaybe<Array<UserSchoolAssignmentsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserSchoolAssignmentsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserSchoolAssignmentsCreateFieldInput>>;
};

export type UserSchoolAssignmentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserSchoolAssignmentsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserSchoolAssignmentsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserSchoolAssignmentsNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  allowed_attempts_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_group_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  body_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  category_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_assignment_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_unread_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  display_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  due_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_date_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_points_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  html_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lti_context_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  max_attempts_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  needs_grading_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  points_possible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  secure_params_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  secure_params_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  session_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserSchoolAssignmentsRelationship = {
  __typename?: 'UserSchoolAssignmentsRelationship';
  cursor: Scalars['String']['output'];
  node: Assignment;
  properties: HasSchoolAssignmentProperties;
};

export type UserSchoolAssignmentsUpdateConnectionInput = {
  edge?: InputMaybe<HasSchoolAssignmentPropertiesUpdateInput>;
  node?: InputMaybe<AssignmentUpdateInput>;
};

export type UserSchoolAssignmentsUpdateFieldInput = {
  connect?: InputMaybe<Array<UserSchoolAssignmentsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserSchoolAssignmentsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserSchoolAssignmentsCreateFieldInput>>;
  delete?: InputMaybe<Array<UserSchoolAssignmentsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserSchoolAssignmentsDisconnectFieldInput>>;
  update?: InputMaybe<UserSchoolAssignmentsUpdateConnectionInput>;
  where?: InputMaybe<UserSchoolAssignmentsConnectionWhere>;
};

export type UserSchoolSchoolsAggregationSelection = {
  __typename?: 'UserSchoolSchoolsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<UserSchoolSchoolsEdgeAggregateSelection>;
  node?: Maybe<UserSchoolSchoolsNodeAggregateSelection>;
};

export type UserSchoolSchoolsEdgeAggregateSelection = {
  __typename?: 'UserSchoolSchoolsEdgeAggregateSelection';
  access_token: StringAggregateSelection;
  brightspace_user_id: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  domain: StringAggregateSelection;
  expires_in: IntAggregateSelection;
  external_id: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  last_modified_token: DateTimeAggregateSelection;
  last_seen_at: DateTimeAggregateSelection;
  login_id: StringAggregateSelection;
  platform: StringAggregateSelection;
  profile_id: StringAggregateSelection;
  refresh_token: StringAggregateSelection;
  school_id: StringAggregateSelection;
  user_id: StringAggregateSelection;
  vendor: StringAggregateSelection;
};

export type UserSchoolSchoolsNodeAggregateSelection = {
  __typename?: 'UserSchoolSchoolsNodeAggregateSelection';
  brightspace_api_client_id: StringAggregateSelection;
  brightspace_api_client_secret: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  domain: StringAggregateSelection;
  id: IdAggregateSelection;
  provider_icon_url: StringAggregateSelection;
  provider_name: StringAggregateSelection;
  team_name: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
};

export type UserSchoolsAggregateInput = {
  AND?: InputMaybe<Array<UserSchoolsAggregateInput>>;
  NOT?: InputMaybe<UserSchoolsAggregateInput>;
  OR?: InputMaybe<Array<UserSchoolsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasSchoolPropertiesAggregationWhereInput>;
  node?: InputMaybe<UserSchoolsNodeAggregationWhereInput>;
};

export type UserSchoolsConnectFieldInput = {
  connect?: InputMaybe<Array<SchoolConnectInput>>;
  edge?: InputMaybe<HasSchoolPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SchoolConnectWhere>;
};

export type UserSchoolsConnectOrCreateFieldInput = {
  onCreate: UserSchoolsConnectOrCreateFieldInputOnCreate;
  where: SchoolConnectOrCreateWhere;
};

export type UserSchoolsConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<HasSchoolPropertiesCreateInput>;
  node: SchoolOnCreateInput;
};

export type UserSchoolsConnection = {
  __typename?: 'UserSchoolsConnection';
  edges: Array<UserSchoolsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserSchoolsConnectionSort = {
  edge?: InputMaybe<HasSchoolPropertiesSort>;
  node?: InputMaybe<SchoolSort>;
};

export type UserSchoolsConnectionWhere = {
  AND?: InputMaybe<Array<UserSchoolsConnectionWhere>>;
  NOT?: InputMaybe<UserSchoolsConnectionWhere>;
  OR?: InputMaybe<Array<UserSchoolsConnectionWhere>>;
  edge?: InputMaybe<HasSchoolPropertiesWhere>;
  node?: InputMaybe<SchoolWhere>;
};

export type UserSchoolsCreateFieldInput = {
  edge?: InputMaybe<HasSchoolPropertiesCreateInput>;
  node: SchoolCreateInput;
};

export type UserSchoolsDeleteFieldInput = {
  delete?: InputMaybe<SchoolDeleteInput>;
  where?: InputMaybe<UserSchoolsConnectionWhere>;
};

export type UserSchoolsDisconnectFieldInput = {
  disconnect?: InputMaybe<SchoolDisconnectInput>;
  where?: InputMaybe<UserSchoolsConnectionWhere>;
};

export type UserSchoolsFieldInput = {
  connect?: InputMaybe<Array<UserSchoolsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserSchoolsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserSchoolsCreateFieldInput>>;
};

export type UserSchoolsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserSchoolsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserSchoolsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserSchoolsNodeAggregationWhereInput>>;
  brightspace_api_client_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_secret_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_secret_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_secret_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_secret_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_secret_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  domain_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domain_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  provider_icon_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  provider_icon_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  provider_icon_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  provider_icon_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  provider_icon_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  provider_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  provider_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  provider_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  provider_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  provider_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  provider_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  provider_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  provider_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  provider_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  provider_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  provider_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  provider_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  provider_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  provider_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  provider_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  team_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  team_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  team_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  team_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  team_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  team_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  team_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  team_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  team_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  team_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  team_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  team_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  team_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  team_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  team_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserSchoolsRelationship = {
  __typename?: 'UserSchoolsRelationship';
  cursor: Scalars['String']['output'];
  node: School;
  properties: HasSchoolProperties;
};

export type UserSchoolsUpdateConnectionInput = {
  edge?: InputMaybe<HasSchoolPropertiesUpdateInput>;
  node?: InputMaybe<SchoolUpdateInput>;
};

export type UserSchoolsUpdateFieldInput = {
  connect?: InputMaybe<Array<UserSchoolsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserSchoolsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserSchoolsCreateFieldInput>>;
  delete?: InputMaybe<Array<UserSchoolsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserSchoolsDisconnectFieldInput>>;
  update?: InputMaybe<UserSchoolsUpdateConnectionInput>;
  where?: InputMaybe<UserSchoolsConnectionWhere>;
};

export type UserSeenAnnouncementsAggregateInput = {
  AND?: InputMaybe<Array<UserSeenAnnouncementsAggregateInput>>;
  NOT?: InputMaybe<UserSeenAnnouncementsAggregateInput>;
  OR?: InputMaybe<Array<UserSeenAnnouncementsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserSeenAnnouncementsNodeAggregationWhereInput>;
};

export type UserSeenAnnouncementsConnectFieldInput = {
  connect?: InputMaybe<Array<AnnouncementConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AnnouncementConnectWhere>;
};

export type UserSeenAnnouncementsConnectOrCreateFieldInput = {
  onCreate: UserSeenAnnouncementsConnectOrCreateFieldInputOnCreate;
  where: AnnouncementConnectOrCreateWhere;
};

export type UserSeenAnnouncementsConnectOrCreateFieldInputOnCreate = {
  node: AnnouncementOnCreateInput;
};

export type UserSeenAnnouncementsConnection = {
  __typename?: 'UserSeenAnnouncementsConnection';
  edges: Array<UserSeenAnnouncementsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserSeenAnnouncementsConnectionSort = {
  node?: InputMaybe<AnnouncementSort>;
};

export type UserSeenAnnouncementsConnectionWhere = {
  AND?: InputMaybe<Array<UserSeenAnnouncementsConnectionWhere>>;
  NOT?: InputMaybe<UserSeenAnnouncementsConnectionWhere>;
  OR?: InputMaybe<Array<UserSeenAnnouncementsConnectionWhere>>;
  node?: InputMaybe<AnnouncementWhere>;
};

export type UserSeenAnnouncementsCreateFieldInput = {
  node: AnnouncementCreateInput;
};

export type UserSeenAnnouncementsDeleteFieldInput = {
  delete?: InputMaybe<AnnouncementDeleteInput>;
  where?: InputMaybe<UserSeenAnnouncementsConnectionWhere>;
};

export type UserSeenAnnouncementsDisconnectFieldInput = {
  disconnect?: InputMaybe<AnnouncementDisconnectInput>;
  where?: InputMaybe<UserSeenAnnouncementsConnectionWhere>;
};

export type UserSeenAnnouncementsFieldInput = {
  connect?: InputMaybe<Array<UserSeenAnnouncementsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserSeenAnnouncementsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserSeenAnnouncementsCreateFieldInput>>;
};

export type UserSeenAnnouncementsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserSeenAnnouncementsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserSeenAnnouncementsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserSeenAnnouncementsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  message_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  message_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  message_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  message_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserSeenAnnouncementsRelationship = {
  __typename?: 'UserSeenAnnouncementsRelationship';
  cursor: Scalars['String']['output'];
  node: Announcement;
};

export type UserSeenAnnouncementsUpdateConnectionInput = {
  node?: InputMaybe<AnnouncementUpdateInput>;
};

export type UserSeenAnnouncementsUpdateFieldInput = {
  connect?: InputMaybe<Array<UserSeenAnnouncementsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserSeenAnnouncementsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserSeenAnnouncementsCreateFieldInput>>;
  delete?: InputMaybe<Array<UserSeenAnnouncementsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserSeenAnnouncementsDisconnectFieldInput>>;
  update?: InputMaybe<UserSeenAnnouncementsUpdateConnectionInput>;
  where?: InputMaybe<UserSeenAnnouncementsConnectionWhere>;
};

export type UserSessionAnalyticsDailyBreakdownInput = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type UserSessionAnalyticsDailyBreakdownResponse = {
  __typename?: 'UserSessionAnalyticsDailyBreakdownResponse';
  data?: Maybe<Array<Maybe<DailyBreakdownData>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UserSessionAnalyticsData = {
  __typename?: 'UserSessionAnalyticsData';
  averageDuration?: Maybe<Scalars['Int']['output']>;
  courses?: Maybe<Array<Maybe<AnalyticsCourse>>>;
  email?: Maybe<Scalars['String']['output']>;
  firstActiveDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastActiveDate?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  totalDuration?: Maybe<Scalars['Int']['output']>;
  totalSessions?: Maybe<Scalars['Int']['output']>;
};

export type UserSessionAnalyticsInput = {
  courseFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  coursesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type UserSessionAnalyticsResponse = {
  __typename?: 'UserSessionAnalyticsResponse';
  avgSessionLength?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<UserSessionAnalyticsData>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  totalSessions?: Maybe<Scalars['Int']['output']>;
  totalUsers?: Maybe<Scalars['Int']['output']>;
};

/** Fields to sort Users by. The order in which sorts are applied is not guaranteed when specifying many fields in one UserSort object. */
export type UserSort = {
  _empty?: InputMaybe<SortDirection>;
  audioOn?: InputMaybe<SortDirection>;
  biography?: InputMaybe<SortDirection>;
  birthday?: InputMaybe<SortDirection>;
  consentToSms?: InputMaybe<SortDirection>;
  countryCode?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  crmUserId?: InputMaybe<SortDirection>;
  currentWeightLbs?: InputMaybe<SortDirection>;
  dailyEmailOptIn?: InputMaybe<SortDirection>;
  email?: InputMaybe<SortDirection>;
  fullPhoneNumber?: InputMaybe<SortDirection>;
  gender?: InputMaybe<SortDirection>;
  goalWeightLbs?: InputMaybe<SortDirection>;
  googleAuthTokens?: InputMaybe<SortDirection>;
  googleCalendarAuthToken?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  invitationToken?: InputMaybe<SortDirection>;
  invitationTokenExpiry?: InputMaybe<SortDirection>;
  inviteCount?: InputMaybe<SortDirection>;
  isCareerLoading?: InputMaybe<SortDirection>;
  isCourseLoading?: InputMaybe<SortDirection>;
  isEmailVerified?: InputMaybe<SortDirection>;
  isOnboarded?: InputMaybe<SortDirection>;
  isPhoneVerified?: InputMaybe<SortDirection>;
  isPro?: InputMaybe<SortDirection>;
  meetingLink?: InputMaybe<SortDirection>;
  modalOnboarding?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  needsResolution?: InputMaybe<SortDirection>;
  otpPreference?: InputMaybe<SortDirection>;
  password?: InputMaybe<SortDirection>;
  passwordResetToken?: InputMaybe<SortDirection>;
  passwordResetTokenExpiry?: InputMaybe<SortDirection>;
  pendingCourseEnrollmentInvite?: InputMaybe<SortDirection>;
  pendingEmail?: InputMaybe<SortDirection>;
  pendingFacultyInvite?: InputMaybe<SortDirection>;
  phoneNumber?: InputMaybe<SortDirection>;
  profilePicture?: InputMaybe<SortDirection>;
  showLearningActivityIntro?: InputMaybe<SortDirection>;
  skipAllNotificationEmail?: InputMaybe<SortDirection>;
  ssoId?: InputMaybe<SortDirection>;
  stripeCustomerId?: InputMaybe<SortDirection>;
  stripeCustomerIdLearningPayments?: InputMaybe<SortDirection>;
  stripeSubscriptionId?: InputMaybe<SortDirection>;
  trialEndDate?: InputMaybe<SortDirection>;
  username?: InputMaybe<SortDirection>;
  watchedIntroVideo?: InputMaybe<SortDirection>;
};

export type UserSubchapterHasKnowledgeSubchaptersAggregationSelection = {
  __typename?: 'UserSubchapterHasKnowledgeSubchaptersAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<UserSubchapterHasKnowledgeSubchaptersEdgeAggregateSelection>;
  node?: Maybe<UserSubchapterHasKnowledgeSubchaptersNodeAggregateSelection>;
};

export type UserSubchapterHasKnowledgeSubchaptersEdgeAggregateSelection = {
  __typename?: 'UserSubchapterHasKnowledgeSubchaptersEdgeAggregateSelection';
  created: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  total_mastery: FloatAggregateSelection;
};

export type UserSubchapterHasKnowledgeSubchaptersNodeAggregateSelection = {
  __typename?: 'UserSubchapterHasKnowledgeSubchaptersNodeAggregateSelection';
  name: StringAggregateSelection;
};

export type UserSubjectUserAggregateInput = {
  AND?: InputMaybe<Array<UserSubjectUserAggregateInput>>;
  NOT?: InputMaybe<UserSubjectUserAggregateInput>;
  OR?: InputMaybe<Array<UserSubjectUserAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserSubjectUserNodeAggregationWhereInput>;
};

export type UserSubjectUserConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type UserSubjectUserConnectOrCreateFieldInput = {
  onCreate: UserSubjectUserConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type UserSubjectUserConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type UserSubjectUserConnection = {
  __typename?: 'UserSubjectUserConnection';
  edges: Array<UserSubjectUserRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserSubjectUserConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type UserSubjectUserConnectionWhere = {
  AND?: InputMaybe<Array<UserSubjectUserConnectionWhere>>;
  NOT?: InputMaybe<UserSubjectUserConnectionWhere>;
  OR?: InputMaybe<Array<UserSubjectUserConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type UserSubjectUserCreateFieldInput = {
  node: UserCreateInput;
};

export type UserSubjectUserDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<UserSubjectUserConnectionWhere>;
};

export type UserSubjectUserDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<UserSubjectUserConnectionWhere>;
};

export type UserSubjectUserFieldInput = {
  connect?: InputMaybe<UserSubjectUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<UserSubjectUserConnectOrCreateFieldInput>;
  create?: InputMaybe<UserSubjectUserCreateFieldInput>;
};

export type UserSubjectUserNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserSubjectUserNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserSubjectUserNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserSubjectUserNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserSubjectUserRelationship = {
  __typename?: 'UserSubjectUserRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type UserSubjectUserUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type UserSubjectUserUpdateFieldInput = {
  connect?: InputMaybe<UserSubjectUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<UserSubjectUserConnectOrCreateFieldInput>;
  create?: InputMaybe<UserSubjectUserCreateFieldInput>;
  delete?: InputMaybe<UserSubjectUserDeleteFieldInput>;
  disconnect?: InputMaybe<UserSubjectUserDisconnectFieldInput>;
  update?: InputMaybe<UserSubjectUserUpdateConnectionInput>;
  where?: InputMaybe<UserSubjectUserConnectionWhere>;
};

export type UserSubmissionHasSubmittedAggregationSelection = {
  __typename?: 'UserSubmissionHasSubmittedAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserSubmissionHasSubmittedNodeAggregateSelection>;
};

export type UserSubmissionHasSubmittedNodeAggregateSelection = {
  __typename?: 'UserSubmissionHasSubmittedNodeAggregateSelection';
  completedAt: DateTimeAggregateSelection;
  created: DateTimeAggregateSelection;
  feedback: StringAggregateSelection;
  grade: FloatAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
};

export type UserSubscribedThreadsAggregateInput = {
  AND?: InputMaybe<Array<UserSubscribedThreadsAggregateInput>>;
  NOT?: InputMaybe<UserSubscribedThreadsAggregateInput>;
  OR?: InputMaybe<Array<UserSubscribedThreadsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserSubscribedThreadsNodeAggregationWhereInput>;
};

export type UserSubscribedThreadsConnectFieldInput = {
  connect?: InputMaybe<Array<ThreadConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ThreadConnectWhere>;
};

export type UserSubscribedThreadsConnectOrCreateFieldInput = {
  onCreate: UserSubscribedThreadsConnectOrCreateFieldInputOnCreate;
  where: ThreadConnectOrCreateWhere;
};

export type UserSubscribedThreadsConnectOrCreateFieldInputOnCreate = {
  node: ThreadOnCreateInput;
};

export type UserSubscribedThreadsConnection = {
  __typename?: 'UserSubscribedThreadsConnection';
  edges: Array<UserSubscribedThreadsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserSubscribedThreadsConnectionSort = {
  node?: InputMaybe<ThreadSort>;
};

export type UserSubscribedThreadsConnectionWhere = {
  AND?: InputMaybe<Array<UserSubscribedThreadsConnectionWhere>>;
  NOT?: InputMaybe<UserSubscribedThreadsConnectionWhere>;
  OR?: InputMaybe<Array<UserSubscribedThreadsConnectionWhere>>;
  node?: InputMaybe<ThreadWhere>;
};

export type UserSubscribedThreadsCreateFieldInput = {
  node: ThreadCreateInput;
};

export type UserSubscribedThreadsDeleteFieldInput = {
  delete?: InputMaybe<ThreadDeleteInput>;
  where?: InputMaybe<UserSubscribedThreadsConnectionWhere>;
};

export type UserSubscribedThreadsDisconnectFieldInput = {
  disconnect?: InputMaybe<ThreadDisconnectInput>;
  where?: InputMaybe<UserSubscribedThreadsConnectionWhere>;
};

export type UserSubscribedThreadsFieldInput = {
  connect?: InputMaybe<Array<UserSubscribedThreadsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserSubscribedThreadsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserSubscribedThreadsCreateFieldInput>>;
};

export type UserSubscribedThreadsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserSubscribedThreadsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserSubscribedThreadsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserSubscribedThreadsNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserSubscribedThreadsRelationship = {
  __typename?: 'UserSubscribedThreadsRelationship';
  cursor: Scalars['String']['output'];
  node: Thread;
};

export type UserSubscribedThreadsUpdateConnectionInput = {
  node?: InputMaybe<ThreadUpdateInput>;
};

export type UserSubscribedThreadsUpdateFieldInput = {
  connect?: InputMaybe<Array<UserSubscribedThreadsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserSubscribedThreadsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserSubscribedThreadsCreateFieldInput>>;
  delete?: InputMaybe<Array<UserSubscribedThreadsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserSubscribedThreadsDisconnectFieldInput>>;
  update?: InputMaybe<UserSubscribedThreadsUpdateConnectionInput>;
  where?: InputMaybe<UserSubscribedThreadsConnectionWhere>;
};

export type UserSuggestionHasSuggestionSuggestionsAggregationSelection = {
  __typename?: 'UserSuggestionHasSuggestionSuggestionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserSuggestionHasSuggestionSuggestionsNodeAggregateSelection>;
};

export type UserSuggestionHasSuggestionSuggestionsNodeAggregateSelection = {
  __typename?: 'UserSuggestionHasSuggestionSuggestionsNodeAggregateSelection';
  assignmentId: StringAggregateSelection;
  classId: StringAggregateSelection;
  content: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  integrationId: StringAggregateSelection;
  trackName: StringAggregateSelection;
  type: StringAggregateSelection;
};

export type UserTeachingCoursesAggregateInput = {
  AND?: InputMaybe<Array<UserTeachingCoursesAggregateInput>>;
  NOT?: InputMaybe<UserTeachingCoursesAggregateInput>;
  OR?: InputMaybe<Array<UserTeachingCoursesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserTeachingCoursesNodeAggregationWhereInput>;
};

export type UserTeachingCoursesConnectFieldInput = {
  connect?: InputMaybe<Array<CourseConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CourseConnectWhere>;
};

export type UserTeachingCoursesConnectOrCreateFieldInput = {
  onCreate: UserTeachingCoursesConnectOrCreateFieldInputOnCreate;
  where: CourseConnectOrCreateWhere;
};

export type UserTeachingCoursesConnectOrCreateFieldInputOnCreate = {
  node: CourseOnCreateInput;
};

export type UserTeachingCoursesConnection = {
  __typename?: 'UserTeachingCoursesConnection';
  edges: Array<UserTeachingCoursesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserTeachingCoursesConnectionSort = {
  node?: InputMaybe<CourseSort>;
};

export type UserTeachingCoursesConnectionWhere = {
  AND?: InputMaybe<Array<UserTeachingCoursesConnectionWhere>>;
  NOT?: InputMaybe<UserTeachingCoursesConnectionWhere>;
  OR?: InputMaybe<Array<UserTeachingCoursesConnectionWhere>>;
  node?: InputMaybe<CourseWhere>;
};

export type UserTeachingCoursesCreateFieldInput = {
  node: CourseCreateInput;
};

export type UserTeachingCoursesDeleteFieldInput = {
  delete?: InputMaybe<CourseDeleteInput>;
  where?: InputMaybe<UserTeachingCoursesConnectionWhere>;
};

export type UserTeachingCoursesDisconnectFieldInput = {
  disconnect?: InputMaybe<CourseDisconnectInput>;
  where?: InputMaybe<UserTeachingCoursesConnectionWhere>;
};

export type UserTeachingCoursesFieldInput = {
  connect?: InputMaybe<Array<UserTeachingCoursesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserTeachingCoursesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserTeachingCoursesCreateFieldInput>>;
};

export type UserTeachingCoursesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserTeachingCoursesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserTeachingCoursesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserTeachingCoursesNodeAggregationWhereInput>>;
  account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  cost_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDateEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  enrollment_term_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  label_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningStandards_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthInWeeks_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  root_account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_import_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  startDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  storage_quota_mb_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserTeachingCoursesRelationship = {
  __typename?: 'UserTeachingCoursesRelationship';
  cursor: Scalars['String']['output'];
  node: Course;
};

export type UserTeachingCoursesUpdateConnectionInput = {
  node?: InputMaybe<CourseUpdateInput>;
};

export type UserTeachingCoursesUpdateFieldInput = {
  connect?: InputMaybe<Array<UserTeachingCoursesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserTeachingCoursesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserTeachingCoursesCreateFieldInput>>;
  delete?: InputMaybe<Array<UserTeachingCoursesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserTeachingCoursesDisconnectFieldInput>>;
  update?: InputMaybe<UserTeachingCoursesUpdateConnectionInput>;
  where?: InputMaybe<UserTeachingCoursesConnectionWhere>;
};

export type UserTenantTenantsAggregationSelection = {
  __typename?: 'UserTenantTenantsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserTenantTenantsNodeAggregateSelection>;
};

export type UserTenantTenantsNodeAggregateSelection = {
  __typename?: 'UserTenantTenantsNodeAggregateSelection';
  companionName: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  emailBackgroundColor: StringAggregateSelection;
  emailFooterColor: StringAggregateSelection;
  emulationStatement: StringAggregateSelection;
  externalSendGridDailyEmailTemplateId: StringAggregateSelection;
  externalSendGridFromEmail: StringAggregateSelection;
  externalSendGridFromName: StringAggregateSelection;
  externalSendGridTwilioServiceSID: StringAggregateSelection;
  favicon16Url: StringAggregateSelection;
  favicon32Url: StringAggregateSelection;
  favicon48Url: StringAggregateSelection;
  favicon180Url: StringAggregateSelection;
  favicon192Url: StringAggregateSelection;
  favicon512Url: StringAggregateSelection;
  faviconIcoUrl: StringAggregateSelection;
  financialInformationUrl: StringAggregateSelection;
  gameMenuBg: StringAggregateSelection;
  gameMenuCardBg: StringAggregateSelection;
  gameMenuProgress: StringAggregateSelection;
  gameMenuTrack: StringAggregateSelection;
  generalPrompt: StringAggregateSelection;
  helpCenterUrl: StringAggregateSelection;
  id: IdAggregateSelection;
  key: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  learningEmulationStatement: StringAggregateSelection;
  logo: StringAggregateSelection;
  ltiLaunchUrl: StringAggregateSelection;
  miniLogo: StringAggregateSelection;
  newsSearchTerms: StringAggregateSelection;
  officialTranscriptsUrl: StringAggregateSelection;
  ogDescription: StringAggregateSelection;
  ogImage: StringAggregateSelection;
  ogImageHeight: StringAggregateSelection;
  ogImageWidth: StringAggregateSelection;
  ogSiteName: StringAggregateSelection;
  ogTitle: StringAggregateSelection;
  ogType: StringAggregateSelection;
  onboardingPrompt: StringAggregateSelection;
  primaryColor: StringAggregateSelection;
  proLogo: StringAggregateSelection;
  reportProblemUrl: StringAggregateSelection;
  scheduleAdvisorCallUrl: StringAggregateSelection;
  schoolResourcesUrl: StringAggregateSelection;
  stripeSecretKey: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  stripeTrialDays: IntAggregateSelection;
  submitHelpTicketLink: StringAggregateSelection;
  tenantDomain: StringAggregateSelection;
  tenantName: StringAggregateSelection;
  termsOfServiceLink: StringAggregateSelection;
  upgradeModalBody: StringAggregateSelection;
};

export type UserTenantsAggregateInput = {
  AND?: InputMaybe<Array<UserTenantsAggregateInput>>;
  NOT?: InputMaybe<UserTenantsAggregateInput>;
  OR?: InputMaybe<Array<UserTenantsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserTenantsNodeAggregationWhereInput>;
};

export type UserTenantsConnectFieldInput = {
  connect?: InputMaybe<Array<TenantConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TenantConnectWhere>;
};

export type UserTenantsConnectOrCreateFieldInput = {
  onCreate: UserTenantsConnectOrCreateFieldInputOnCreate;
  where: TenantConnectOrCreateWhere;
};

export type UserTenantsConnectOrCreateFieldInputOnCreate = {
  node: TenantOnCreateInput;
};

export type UserTenantsConnection = {
  __typename?: 'UserTenantsConnection';
  edges: Array<UserTenantsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserTenantsConnectionSort = {
  node?: InputMaybe<TenantSort>;
};

export type UserTenantsConnectionWhere = {
  AND?: InputMaybe<Array<UserTenantsConnectionWhere>>;
  NOT?: InputMaybe<UserTenantsConnectionWhere>;
  OR?: InputMaybe<Array<UserTenantsConnectionWhere>>;
  node?: InputMaybe<TenantWhere>;
};

export type UserTenantsCreateFieldInput = {
  node: TenantCreateInput;
};

export type UserTenantsDeleteFieldInput = {
  delete?: InputMaybe<TenantDeleteInput>;
  where?: InputMaybe<UserTenantsConnectionWhere>;
};

export type UserTenantsDisconnectFieldInput = {
  disconnect?: InputMaybe<TenantDisconnectInput>;
  where?: InputMaybe<UserTenantsConnectionWhere>;
};

export type UserTenantsFieldInput = {
  connect?: InputMaybe<Array<UserTenantsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserTenantsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserTenantsCreateFieldInput>>;
};

export type UserTenantsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserTenantsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserTenantsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserTenantsNodeAggregationWhereInput>>;
  companionName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  companionName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  key_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  key_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogImage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  proLogo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserTenantsRelationship = {
  __typename?: 'UserTenantsRelationship';
  cursor: Scalars['String']['output'];
  node: Tenant;
};

export type UserTenantsUpdateConnectionInput = {
  node?: InputMaybe<TenantUpdateInput>;
};

export type UserTenantsUpdateFieldInput = {
  connect?: InputMaybe<Array<UserTenantsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserTenantsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserTenantsCreateFieldInput>>;
  delete?: InputMaybe<Array<UserTenantsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserTenantsDisconnectFieldInput>>;
  update?: InputMaybe<UserTenantsUpdateConnectionInput>;
  where?: InputMaybe<UserTenantsConnectionWhere>;
};

export type UserThreadReadStatesAggregateInput = {
  AND?: InputMaybe<Array<UserThreadReadStatesAggregateInput>>;
  NOT?: InputMaybe<UserThreadReadStatesAggregateInput>;
  OR?: InputMaybe<Array<UserThreadReadStatesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<ReadStatePropertiesAggregationWhereInput>;
  node?: InputMaybe<UserThreadReadStatesNodeAggregationWhereInput>;
};

export type UserThreadReadStatesConnectFieldInput = {
  connect?: InputMaybe<Array<ThreadConnectInput>>;
  edge?: InputMaybe<ReadStatePropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ThreadConnectWhere>;
};

export type UserThreadReadStatesConnectOrCreateFieldInput = {
  onCreate: UserThreadReadStatesConnectOrCreateFieldInputOnCreate;
  where: ThreadConnectOrCreateWhere;
};

export type UserThreadReadStatesConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<ReadStatePropertiesCreateInput>;
  node: ThreadOnCreateInput;
};

export type UserThreadReadStatesConnection = {
  __typename?: 'UserThreadReadStatesConnection';
  edges: Array<UserThreadReadStatesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserThreadReadStatesConnectionSort = {
  edge?: InputMaybe<ReadStatePropertiesSort>;
  node?: InputMaybe<ThreadSort>;
};

export type UserThreadReadStatesConnectionWhere = {
  AND?: InputMaybe<Array<UserThreadReadStatesConnectionWhere>>;
  NOT?: InputMaybe<UserThreadReadStatesConnectionWhere>;
  OR?: InputMaybe<Array<UserThreadReadStatesConnectionWhere>>;
  edge?: InputMaybe<ReadStatePropertiesWhere>;
  node?: InputMaybe<ThreadWhere>;
};

export type UserThreadReadStatesCreateFieldInput = {
  edge?: InputMaybe<ReadStatePropertiesCreateInput>;
  node: ThreadCreateInput;
};

export type UserThreadReadStatesDeleteFieldInput = {
  delete?: InputMaybe<ThreadDeleteInput>;
  where?: InputMaybe<UserThreadReadStatesConnectionWhere>;
};

export type UserThreadReadStatesDisconnectFieldInput = {
  disconnect?: InputMaybe<ThreadDisconnectInput>;
  where?: InputMaybe<UserThreadReadStatesConnectionWhere>;
};

export type UserThreadReadStatesFieldInput = {
  connect?: InputMaybe<Array<UserThreadReadStatesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserThreadReadStatesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserThreadReadStatesCreateFieldInput>>;
};

export type UserThreadReadStatesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserThreadReadStatesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserThreadReadStatesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserThreadReadStatesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserThreadReadStatesRelationship = {
  __typename?: 'UserThreadReadStatesRelationship';
  cursor: Scalars['String']['output'];
  node: Thread;
  properties: ReadStateProperties;
};

export type UserThreadReadStatesUpdateConnectionInput = {
  edge?: InputMaybe<ReadStatePropertiesUpdateInput>;
  node?: InputMaybe<ThreadUpdateInput>;
};

export type UserThreadReadStatesUpdateFieldInput = {
  connect?: InputMaybe<Array<UserThreadReadStatesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserThreadReadStatesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserThreadReadStatesCreateFieldInput>>;
  delete?: InputMaybe<Array<UserThreadReadStatesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserThreadReadStatesDisconnectFieldInput>>;
  update?: InputMaybe<UserThreadReadStatesUpdateConnectionInput>;
  where?: InputMaybe<UserThreadReadStatesConnectionWhere>;
};

export type UserThreadSubscribedThreadsAggregationSelection = {
  __typename?: 'UserThreadSubscribedThreadsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserThreadSubscribedThreadsNodeAggregateSelection>;
};

export type UserThreadSubscribedThreadsNodeAggregateSelection = {
  __typename?: 'UserThreadSubscribedThreadsNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  title: StringAggregateSelection;
};

export type UserThreadThreadReadStatesAggregationSelection = {
  __typename?: 'UserThreadThreadReadStatesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<UserThreadThreadReadStatesEdgeAggregateSelection>;
  node?: Maybe<UserThreadThreadReadStatesNodeAggregateSelection>;
};

export type UserThreadThreadReadStatesEdgeAggregateSelection = {
  __typename?: 'UserThreadThreadReadStatesEdgeAggregateSelection';
  lastSeenAt: DateTimeAggregateSelection;
  lastSeenPostId: StringAggregateSelection;
};

export type UserThreadThreadReadStatesNodeAggregateSelection = {
  __typename?: 'UserThreadThreadReadStatesNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  title: StringAggregateSelection;
};

export type UserTodoTodosAggregationSelection = {
  __typename?: 'UserTodoTodosAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<UserTodoTodosEdgeAggregateSelection>;
  node?: Maybe<UserTodoTodosNodeAggregateSelection>;
};

export type UserTodoTodosEdgeAggregateSelection = {
  __typename?: 'UserTodoTodosEdgeAggregateSelection';
  created: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  quality: BigIntAggregateSelection;
  strength: BigIntAggregateSelection;
};

export type UserTodoTodosNodeAggregateSelection = {
  __typename?: 'UserTodoTodosNodeAggregateSelection';
  aiSummary: StringAggregateSelection;
  completed_date: DateTimeAggregateSelection;
  created: DateTimeAggregateSelection;
  date: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  id: IdAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  name: StringAggregateSelection;
  pointsReceived: IntAggregateSelection;
  priority: StringAggregateSelection;
  recurringDayOfMonth: IntAggregateSelection;
  recurringDayOfWeek: StringAggregateSelection;
  recurringFrequency: StringAggregateSelection;
  recurringTime: StringAggregateSelection;
  timeOfDay: StringAggregateSelection;
  timezone: StringAggregateSelection;
};

export type UserTodosAggregateInput = {
  AND?: InputMaybe<Array<UserTodosAggregateInput>>;
  NOT?: InputMaybe<UserTodosAggregateInput>;
  OR?: InputMaybe<Array<UserTodosAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasTodoPropertiesAggregationWhereInput>;
  node?: InputMaybe<UserTodosNodeAggregationWhereInput>;
};

export type UserTodosConnectFieldInput = {
  connect?: InputMaybe<Array<TodoConnectInput>>;
  edge?: InputMaybe<HasTodoPropertiesCreateInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TodoConnectWhere>;
};

export type UserTodosConnectOrCreateFieldInput = {
  onCreate: UserTodosConnectOrCreateFieldInputOnCreate;
  where: TodoConnectOrCreateWhere;
};

export type UserTodosConnectOrCreateFieldInputOnCreate = {
  edge?: InputMaybe<HasTodoPropertiesCreateInput>;
  node: TodoOnCreateInput;
};

export type UserTodosConnection = {
  __typename?: 'UserTodosConnection';
  edges: Array<UserTodosRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserTodosConnectionSort = {
  edge?: InputMaybe<HasTodoPropertiesSort>;
  node?: InputMaybe<TodoSort>;
};

export type UserTodosConnectionWhere = {
  AND?: InputMaybe<Array<UserTodosConnectionWhere>>;
  NOT?: InputMaybe<UserTodosConnectionWhere>;
  OR?: InputMaybe<Array<UserTodosConnectionWhere>>;
  edge?: InputMaybe<HasTodoPropertiesWhere>;
  node?: InputMaybe<TodoWhere>;
};

export type UserTodosCreateFieldInput = {
  edge?: InputMaybe<HasTodoPropertiesCreateInput>;
  node: TodoCreateInput;
};

export type UserTodosDeleteFieldInput = {
  delete?: InputMaybe<TodoDeleteInput>;
  where?: InputMaybe<UserTodosConnectionWhere>;
};

export type UserTodosDisconnectFieldInput = {
  disconnect?: InputMaybe<TodoDisconnectInput>;
  where?: InputMaybe<UserTodosConnectionWhere>;
};

export type UserTodosFieldInput = {
  connect?: InputMaybe<Array<UserTodosConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserTodosConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserTodosCreateFieldInput>>;
};

export type UserTodosNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserTodosNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserTodosNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserTodosNodeAggregationWhereInput>>;
  aiSummary_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiSummary_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aiSummary_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiSummary_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aiSummary_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aiSummary_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aiSummary_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aiSummary_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aiSummary_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aiSummary_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aiSummary_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aiSummary_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aiSummary_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aiSummary_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aiSummary_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  completed_date_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completed_date_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completed_date_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completed_date_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completed_date_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  completed_date_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completed_date_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completed_date_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completed_date_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completed_date_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsReceived_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsReceived_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsReceived_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsReceived_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsReceived_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  priority_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priority_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  priority_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  priority_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  priority_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  priority_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  priority_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  priority_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  priority_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  priority_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  priority_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  priority_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  priority_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  priority_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  priority_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  recurringDayOfMonth_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  recurringDayOfMonth_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  recurringDayOfMonth_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  recurringDayOfMonth_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  recurringDayOfMonth_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  recurringDayOfWeek_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  recurringDayOfWeek_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  recurringDayOfWeek_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  recurringDayOfWeek_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  recurringDayOfWeek_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  recurringFrequency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  recurringFrequency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  recurringFrequency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  recurringFrequency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  recurringFrequency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  recurringFrequency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recurringFrequency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  recurringFrequency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  recurringFrequency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  recurringFrequency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  recurringFrequency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recurringFrequency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  recurringFrequency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  recurringFrequency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  recurringFrequency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  recurringTime_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  recurringTime_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  recurringTime_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  recurringTime_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  recurringTime_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  recurringTime_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recurringTime_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  recurringTime_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  recurringTime_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  recurringTime_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  recurringTime_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recurringTime_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  recurringTime_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  recurringTime_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  recurringTime_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeOfDay_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timeOfDay_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeOfDay_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timeOfDay_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeOfDay_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserTodosRelationship = {
  __typename?: 'UserTodosRelationship';
  cursor: Scalars['String']['output'];
  node: Todo;
  properties: HasTodoProperties;
};

export type UserTodosUpdateConnectionInput = {
  edge?: InputMaybe<HasTodoPropertiesUpdateInput>;
  node?: InputMaybe<TodoUpdateInput>;
};

export type UserTodosUpdateFieldInput = {
  connect?: InputMaybe<Array<UserTodosConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<UserTodosConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<UserTodosCreateFieldInput>>;
  delete?: InputMaybe<Array<UserTodosDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserTodosDisconnectFieldInput>>;
  update?: InputMaybe<UserTodosUpdateConnectionInput>;
  where?: InputMaybe<UserTodosConnectionWhere>;
};

export type UserTopicEnrolledInTopicsAggregationSelection = {
  __typename?: 'UserTopicEnrolledInTopicsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<UserTopicEnrolledInTopicsEdgeAggregateSelection>;
  node?: Maybe<UserTopicEnrolledInTopicsNodeAggregateSelection>;
};

export type UserTopicEnrolledInTopicsEdgeAggregateSelection = {
  __typename?: 'UserTopicEnrolledInTopicsEdgeAggregateSelection';
  created: DateTimeAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
};

export type UserTopicEnrolledInTopicsNodeAggregateSelection = {
  __typename?: 'UserTopicEnrolledInTopicsNodeAggregateSelection';
  description: StringAggregateSelection;
  imageUrl: StringAggregateSelection;
  mastery: FloatAggregateSelection;
  name: StringAggregateSelection;
};

export type UserTopicHasKnowledgeTopicsAggregationSelection = {
  __typename?: 'UserTopicHasKnowledgeTopicsAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<UserTopicHasKnowledgeTopicsEdgeAggregateSelection>;
  node?: Maybe<UserTopicHasKnowledgeTopicsNodeAggregateSelection>;
};

export type UserTopicHasKnowledgeTopicsEdgeAggregateSelection = {
  __typename?: 'UserTopicHasKnowledgeTopicsEdgeAggregateSelection';
  created: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  total_mastery: FloatAggregateSelection;
};

export type UserTopicHasKnowledgeTopicsNodeAggregateSelection = {
  __typename?: 'UserTopicHasKnowledgeTopicsNodeAggregateSelection';
  description: StringAggregateSelection;
  imageUrl: StringAggregateSelection;
  mastery: FloatAggregateSelection;
  name: StringAggregateSelection;
};

export type UserUndefinedFoodItemsAggregateInput = {
  AND?: InputMaybe<Array<UserUndefinedFoodItemsAggregateInput>>;
  NOT?: InputMaybe<UserUndefinedFoodItemsAggregateInput>;
  OR?: InputMaybe<Array<UserUndefinedFoodItemsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<UndefinedPropertiesAggregationWhereInput>;
  node?: InputMaybe<UserUndefinedFoodItemsNodeAggregationWhereInput>;
};

export type UserUndefinedFoodItemsConnectFieldInput = {
  connect?: InputMaybe<Array<FoodItemConnectInput>>;
  edge: UndefinedPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FoodItemConnectWhere>;
};

export type UserUndefinedFoodItemsConnection = {
  __typename?: 'UserUndefinedFoodItemsConnection';
  edges: Array<UserUndefinedFoodItemsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserUndefinedFoodItemsConnectionSort = {
  edge?: InputMaybe<UndefinedPropertiesSort>;
  node?: InputMaybe<FoodItemSort>;
};

export type UserUndefinedFoodItemsConnectionWhere = {
  AND?: InputMaybe<Array<UserUndefinedFoodItemsConnectionWhere>>;
  NOT?: InputMaybe<UserUndefinedFoodItemsConnectionWhere>;
  OR?: InputMaybe<Array<UserUndefinedFoodItemsConnectionWhere>>;
  edge?: InputMaybe<UndefinedPropertiesWhere>;
  node?: InputMaybe<FoodItemWhere>;
};

export type UserUndefinedFoodItemsCreateFieldInput = {
  edge: UndefinedPropertiesCreateInput;
  node: FoodItemCreateInput;
};

export type UserUndefinedFoodItemsDeleteFieldInput = {
  delete?: InputMaybe<FoodItemDeleteInput>;
  where?: InputMaybe<UserUndefinedFoodItemsConnectionWhere>;
};

export type UserUndefinedFoodItemsDisconnectFieldInput = {
  disconnect?: InputMaybe<FoodItemDisconnectInput>;
  where?: InputMaybe<UserUndefinedFoodItemsConnectionWhere>;
};

export type UserUndefinedFoodItemsFieldInput = {
  connect?: InputMaybe<Array<UserUndefinedFoodItemsConnectFieldInput>>;
  create?: InputMaybe<Array<UserUndefinedFoodItemsCreateFieldInput>>;
};

export type UserUndefinedFoodItemsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserUndefinedFoodItemsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserUndefinedFoodItemsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserUndefinedFoodItemsNodeAggregationWhereInput>>;
  calories_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  calories_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  calories_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  calories_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  calories_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  calories_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  calories_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  calories_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  calories_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  calories_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  calories_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  calories_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  calories_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  calories_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  calories_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  calories_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  calories_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  calories_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  calories_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  calories_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  serving_size_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  serving_size_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  serving_size_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  serving_size_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  serving_size_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  serving_size_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  serving_size_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  serving_size_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  serving_size_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  serving_size_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  serving_size_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  serving_size_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  serving_size_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  serving_size_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  serving_size_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sugar_grams_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sugar_grams_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type UserUndefinedFoodItemsRelationship = {
  __typename?: 'UserUndefinedFoodItemsRelationship';
  cursor: Scalars['String']['output'];
  node: FoodItem;
  properties: UndefinedProperties;
};

export type UserUndefinedFoodItemsUpdateConnectionInput = {
  edge?: InputMaybe<UndefinedPropertiesUpdateInput>;
  node?: InputMaybe<FoodItemUpdateInput>;
};

export type UserUndefinedFoodItemsUpdateFieldInput = {
  connect?: InputMaybe<Array<UserUndefinedFoodItemsConnectFieldInput>>;
  create?: InputMaybe<Array<UserUndefinedFoodItemsCreateFieldInput>>;
  delete?: InputMaybe<Array<UserUndefinedFoodItemsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserUndefinedFoodItemsDisconnectFieldInput>>;
  update?: InputMaybe<UserUndefinedFoodItemsUpdateConnectionInput>;
  where?: InputMaybe<UserUndefinedFoodItemsConnectionWhere>;
};

export type UserUndefinedWaterIntakesAggregateInput = {
  AND?: InputMaybe<Array<UserUndefinedWaterIntakesAggregateInput>>;
  NOT?: InputMaybe<UserUndefinedWaterIntakesAggregateInput>;
  OR?: InputMaybe<Array<UserUndefinedWaterIntakesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<UndefinedPropertiesAggregationWhereInput>;
  node?: InputMaybe<UserUndefinedWaterIntakesNodeAggregationWhereInput>;
};

export type UserUndefinedWaterIntakesConnectFieldInput = {
  connect?: InputMaybe<Array<WaterIntakeConnectInput>>;
  edge: UndefinedPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<WaterIntakeConnectWhere>;
};

export type UserUndefinedWaterIntakesConnection = {
  __typename?: 'UserUndefinedWaterIntakesConnection';
  edges: Array<UserUndefinedWaterIntakesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserUndefinedWaterIntakesConnectionSort = {
  edge?: InputMaybe<UndefinedPropertiesSort>;
  node?: InputMaybe<WaterIntakeSort>;
};

export type UserUndefinedWaterIntakesConnectionWhere = {
  AND?: InputMaybe<Array<UserUndefinedWaterIntakesConnectionWhere>>;
  NOT?: InputMaybe<UserUndefinedWaterIntakesConnectionWhere>;
  OR?: InputMaybe<Array<UserUndefinedWaterIntakesConnectionWhere>>;
  edge?: InputMaybe<UndefinedPropertiesWhere>;
  node?: InputMaybe<WaterIntakeWhere>;
};

export type UserUndefinedWaterIntakesCreateFieldInput = {
  edge: UndefinedPropertiesCreateInput;
  node: WaterIntakeCreateInput;
};

export type UserUndefinedWaterIntakesDeleteFieldInput = {
  delete?: InputMaybe<WaterIntakeDeleteInput>;
  where?: InputMaybe<UserUndefinedWaterIntakesConnectionWhere>;
};

export type UserUndefinedWaterIntakesDisconnectFieldInput = {
  disconnect?: InputMaybe<WaterIntakeDisconnectInput>;
  where?: InputMaybe<UserUndefinedWaterIntakesConnectionWhere>;
};

export type UserUndefinedWaterIntakesFieldInput = {
  connect?: InputMaybe<Array<UserUndefinedWaterIntakesConnectFieldInput>>;
  create?: InputMaybe<Array<UserUndefinedWaterIntakesCreateFieldInput>>;
};

export type UserUndefinedWaterIntakesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserUndefinedWaterIntakesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserUndefinedWaterIntakesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserUndefinedWaterIntakesNodeAggregationWhereInput>>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  water_intake_oz_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type UserUndefinedWaterIntakesRelationship = {
  __typename?: 'UserUndefinedWaterIntakesRelationship';
  cursor: Scalars['String']['output'];
  node: WaterIntake;
  properties: UndefinedProperties;
};

export type UserUndefinedWaterIntakesUpdateConnectionInput = {
  edge?: InputMaybe<UndefinedPropertiesUpdateInput>;
  node?: InputMaybe<WaterIntakeUpdateInput>;
};

export type UserUndefinedWaterIntakesUpdateFieldInput = {
  connect?: InputMaybe<Array<UserUndefinedWaterIntakesConnectFieldInput>>;
  create?: InputMaybe<Array<UserUndefinedWaterIntakesCreateFieldInput>>;
  delete?: InputMaybe<Array<UserUndefinedWaterIntakesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UserUndefinedWaterIntakesDisconnectFieldInput>>;
  update?: InputMaybe<UserUndefinedWaterIntakesUpdateConnectionInput>;
  where?: InputMaybe<UserUndefinedWaterIntakesConnectionWhere>;
};

export type UserUniqueWhere = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  invitationToken?: InputMaybe<Scalars['String']['input']>;
};

export type UserUpdateInput = {
  _empty?: InputMaybe<Scalars['String']['input']>;
  achievements?: InputMaybe<Array<UserAchievementsUpdateFieldInput>>;
  assessmentSubmissions?: InputMaybe<Array<UserAssessmentSubmissionsUpdateFieldInput>>;
  attributes?: InputMaybe<Array<UserAttributesUpdateFieldInput>>;
  audioOn?: InputMaybe<Scalars['Boolean']['input']>;
  auditEvents?: InputMaybe<Array<UserAuditEventsUpdateFieldInput>>;
  authoredNotes?: InputMaybe<Array<UserAuthoredNotesUpdateFieldInput>>;
  authoredPosts?: InputMaybe<Array<UserAuthoredPostsUpdateFieldInput>>;
  biography?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  consentToSms?: InputMaybe<Scalars['Boolean']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  createdAnnouncements?: InputMaybe<Array<UserCreatedAnnouncementsUpdateFieldInput>>;
  crmUserId?: InputMaybe<Scalars['String']['input']>;
  currentWeightLbs?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_ADD?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  dailyEmailOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enrolledCourses?: InputMaybe<Array<UserEnrolledCoursesUpdateFieldInput>>;
  enrolledDegrees?: InputMaybe<Array<UserEnrolledDegreesUpdateFieldInput>>;
  enrolledInTopics?: InputMaybe<Array<UserEnrolledInTopicsUpdateFieldInput>>;
  enrolledTracks?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enrolledTracks_POP?: InputMaybe<Scalars['Int']['input']>;
  enrolledTracks_PUSH?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fullPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  goalWeightLbs?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_ADD?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens?: InputMaybe<Scalars['String']['input']>;
  googleCalendarAuthToken?: InputMaybe<Scalars['String']['input']>;
  hasChatChats?: InputMaybe<Array<UserHasChatChatsUpdateFieldInput>>;
  hasFile?: InputMaybe<Array<UserHasFileUpdateFieldInput>>;
  hasFoodItemFoodItems?: InputMaybe<Array<UserHasFoodItemFoodItemsUpdateFieldInput>>;
  hasKnowledgeChapters?: InputMaybe<Array<UserHasKnowledgeChaptersUpdateFieldInput>>;
  hasKnowledgeSubchapters?: InputMaybe<Array<UserHasKnowledgeSubchaptersUpdateFieldInput>>;
  hasKnowledgeTopics?: InputMaybe<Array<UserHasKnowledgeTopicsUpdateFieldInput>>;
  hasLearningPreferences?: InputMaybe<UserHasLearningPreferencesUpdateFieldInput>;
  hasPaymentPayments?: InputMaybe<Array<UserHasPaymentPaymentsUpdateFieldInput>>;
  hasPreferencesPreferences?: InputMaybe<Array<UserHasPreferencesPreferencesUpdateFieldInput>>;
  hasProgress?: InputMaybe<Array<UserHasProgressUpdateFieldInput>>;
  hasReviews?: InputMaybe<Array<UserHasReviewsUpdateFieldInput>>;
  hasRoleRoles?: InputMaybe<Array<UserHasRoleRolesUpdateFieldInput>>;
  hasRosterExport?: InputMaybe<Array<UserHasRosterExportUpdateFieldInput>>;
  hasSessionDeviceSessions?: InputMaybe<Array<UserHasSessionDeviceSessionsUpdateFieldInput>>;
  hasSubmissionExport?: InputMaybe<Array<UserHasSubmissionExportUpdateFieldInput>>;
  hasSubmitted?: InputMaybe<Array<UserHasSubmittedUpdateFieldInput>>;
  hasSuggestionSuggestions?: InputMaybe<Array<UserHasSuggestionSuggestionsUpdateFieldInput>>;
  hasSummaryDailySummaries?: InputMaybe<Array<UserHasSummaryDailySummariesUpdateFieldInput>>;
  hasSummaryMonthlySummaries?: InputMaybe<Array<UserHasSummaryMonthlySummariesUpdateFieldInput>>;
  hasSummaryQuarterlySummaries?: InputMaybe<Array<UserHasSummaryQuarterlySummariesUpdateFieldInput>>;
  hasSummaryWeeklySummaries?: InputMaybe<Array<UserHasSummaryWeeklySummariesUpdateFieldInput>>;
  hasSummaryYearlySummaries?: InputMaybe<Array<UserHasSummaryYearlySummariesUpdateFieldInput>>;
  hasVisitSessions?: InputMaybe<Array<UserHasVisitSessionsUpdateFieldInput>>;
  hasWaterIntakeWaterIntakes?: InputMaybe<Array<UserHasWaterIntakeWaterIntakesUpdateFieldInput>>;
  hasWhitelistedEmails?: InputMaybe<Array<UserHasWhitelistedEmailsUpdateFieldInput>>;
  hasWorkspaces?: InputMaybe<Array<UserHasWorkspacesUpdateFieldInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  invitationToken?: InputMaybe<Scalars['String']['input']>;
  invitationTokenExpiry?: InputMaybe<Scalars['DateTime']['input']>;
  inviteCount?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  isCareerLoading?: InputMaybe<Scalars['Boolean']['input']>;
  isCourseLoading?: InputMaybe<Scalars['Boolean']['input']>;
  isEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  isOnboarded?: InputMaybe<Scalars['Boolean']['input']>;
  isPhoneVerified?: InputMaybe<Scalars['Boolean']['input']>;
  isPro?: InputMaybe<Scalars['Boolean']['input']>;
  learningPayments?: InputMaybe<Array<UserLearningPaymentsUpdateFieldInput>>;
  meetingLink?: InputMaybe<Scalars['String']['input']>;
  modalOnboarding?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  needsResolution?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Array<UserNotesUpdateFieldInput>>;
  nudgePreferences?: InputMaybe<UserNudgePreferencesUpdateFieldInput>;
  nudges?: InputMaybe<Array<UserNudgesUpdateFieldInput>>;
  nudgesAboutThis?: InputMaybe<Array<UserNudgesAboutThisUpdateFieldInput>>;
  otpPreference?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  passwordResetToken?: InputMaybe<Scalars['String']['input']>;
  passwordResetTokenExpiry?: InputMaybe<Scalars['DateTime']['input']>;
  pendingCourseEnrollmentInvite?: InputMaybe<Scalars['Boolean']['input']>;
  pendingEmail?: InputMaybe<Scalars['String']['input']>;
  pendingFacultyInvite?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Scalars['String']['input']>;
  reviewAITutorBeingGeneratedFor?: InputMaybe<Array<UserReviewAiTutorBeingGeneratedForUpdateFieldInput>>;
  schoolAssignments?: InputMaybe<Array<UserSchoolAssignmentsUpdateFieldInput>>;
  schools?: InputMaybe<Array<UserSchoolsUpdateFieldInput>>;
  seenAnnouncements?: InputMaybe<Array<UserSeenAnnouncementsUpdateFieldInput>>;
  showLearningActivityIntro?: InputMaybe<Scalars['Boolean']['input']>;
  skipAllNotificationEmail?: InputMaybe<Scalars['Boolean']['input']>;
  ssoId?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerIdLearningPayments?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  subjectUser?: InputMaybe<UserSubjectUserUpdateFieldInput>;
  subscribedThreads?: InputMaybe<Array<UserSubscribedThreadsUpdateFieldInput>>;
  teachingCourses?: InputMaybe<Array<UserTeachingCoursesUpdateFieldInput>>;
  tenants?: InputMaybe<Array<UserTenantsUpdateFieldInput>>;
  threadReadStates?: InputMaybe<Array<UserThreadReadStatesUpdateFieldInput>>;
  todos?: InputMaybe<Array<UserTodosUpdateFieldInput>>;
  trialEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  undefinedFoodItems?: InputMaybe<Array<UserUndefinedFoodItemsUpdateFieldInput>>;
  undefinedWaterIntakes?: InputMaybe<Array<UserUndefinedWaterIntakesUpdateFieldInput>>;
  username?: InputMaybe<Scalars['String']['input']>;
  watchedIntroVideo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserUserLearningPreferencesHasLearningPreferencesAggregationSelection = {
  __typename?: 'UserUserLearningPreferencesHasLearningPreferencesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserUserLearningPreferencesHasLearningPreferencesNodeAggregateSelection>;
};

export type UserUserLearningPreferencesHasLearningPreferencesNodeAggregateSelection = {
  __typename?: 'UserUserLearningPreferencesHasLearningPreferencesNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  semesterGoal: StringAggregateSelection;
};

export type UserUserSubjectUserAggregationSelection = {
  __typename?: 'UserUserSubjectUserAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserUserSubjectUserNodeAggregateSelection>;
};

export type UserUserSubjectUserNodeAggregateSelection = {
  __typename?: 'UserUserSubjectUserNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type UserVisitSessionHasVisitSessionsAggregationSelection = {
  __typename?: 'UserVisitSessionHasVisitSessionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserVisitSessionHasVisitSessionsNodeAggregateSelection>;
};

export type UserVisitSessionHasVisitSessionsNodeAggregateSelection = {
  __typename?: 'UserVisitSessionHasVisitSessionsNodeAggregateSelection';
  id: IdAggregateSelection;
  ipAddress: StringAggregateSelection;
  lastActiveTime: DateTimeAggregateSelection;
  startTime: DateTimeAggregateSelection;
  userAgent: StringAggregateSelection;
};

export type UserWaterIntakeHasWaterIntakeWaterIntakesAggregationSelection = {
  __typename?: 'UserWaterIntakeHasWaterIntakeWaterIntakesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<UserWaterIntakeHasWaterIntakeWaterIntakesEdgeAggregateSelection>;
  node?: Maybe<UserWaterIntakeHasWaterIntakeWaterIntakesNodeAggregateSelection>;
};

export type UserWaterIntakeHasWaterIntakeWaterIntakesEdgeAggregateSelection = {
  __typename?: 'UserWaterIntakeHasWaterIntakeWaterIntakesEdgeAggregateSelection';
  created: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  quality: BigIntAggregateSelection;
  strength: BigIntAggregateSelection;
};

export type UserWaterIntakeHasWaterIntakeWaterIntakesNodeAggregateSelection = {
  __typename?: 'UserWaterIntakeHasWaterIntakeWaterIntakesNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  name: StringAggregateSelection;
  water_intake_oz: FloatAggregateSelection;
};

export type UserWaterIntakeUndefinedWaterIntakesAggregationSelection = {
  __typename?: 'UserWaterIntakeUndefinedWaterIntakesAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<UserWaterIntakeUndefinedWaterIntakesEdgeAggregateSelection>;
  node?: Maybe<UserWaterIntakeUndefinedWaterIntakesNodeAggregateSelection>;
};

export type UserWaterIntakeUndefinedWaterIntakesEdgeAggregateSelection = {
  __typename?: 'UserWaterIntakeUndefinedWaterIntakesEdgeAggregateSelection';
  created: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  quality: BigIntAggregateSelection;
  strength: BigIntAggregateSelection;
};

export type UserWaterIntakeUndefinedWaterIntakesNodeAggregateSelection = {
  __typename?: 'UserWaterIntakeUndefinedWaterIntakesNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  name: StringAggregateSelection;
  water_intake_oz: FloatAggregateSelection;
};

export type UserWeeklySummaryHasSummaryWeeklySummariesAggregationSelection = {
  __typename?: 'UserWeeklySummaryHasSummaryWeeklySummariesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserWeeklySummaryHasSummaryWeeklySummariesNodeAggregateSelection>;
};

export type UserWeeklySummaryHasSummaryWeeklySummariesNodeAggregateSelection = {
  __typename?: 'UserWeeklySummaryHasSummaryWeeklySummariesNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  date: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  summary: StringAggregateSelection;
};

export type UserWhere = {
  AND?: InputMaybe<Array<UserWhere>>;
  NOT?: InputMaybe<UserWhere>;
  OR?: InputMaybe<Array<UserWhere>>;
  _empty?: InputMaybe<Scalars['String']['input']>;
  _empty_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  _empty_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  _empty_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  _empty_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  achievementsAggregate?: InputMaybe<UserAchievementsAggregateInput>;
  /** Return Users where all of the related UserAchievementsConnections match this filter */
  achievementsConnection_ALL?: InputMaybe<UserAchievementsConnectionWhere>;
  /** Return Users where none of the related UserAchievementsConnections match this filter */
  achievementsConnection_NONE?: InputMaybe<UserAchievementsConnectionWhere>;
  /** Return Users where one of the related UserAchievementsConnections match this filter */
  achievementsConnection_SINGLE?: InputMaybe<UserAchievementsConnectionWhere>;
  /** Return Users where some of the related UserAchievementsConnections match this filter */
  achievementsConnection_SOME?: InputMaybe<UserAchievementsConnectionWhere>;
  /** Return Users where all of the related Achievements match this filter */
  achievements_ALL?: InputMaybe<AchievementsWhere>;
  /** Return Users where none of the related Achievements match this filter */
  achievements_NONE?: InputMaybe<AchievementsWhere>;
  /** Return Users where one of the related Achievements match this filter */
  achievements_SINGLE?: InputMaybe<AchievementsWhere>;
  /** Return Users where some of the related Achievements match this filter */
  achievements_SOME?: InputMaybe<AchievementsWhere>;
  assessmentSubmissionsAggregate?: InputMaybe<UserAssessmentSubmissionsAggregateInput>;
  /** Return Users where all of the related UserAssessmentSubmissionsConnections match this filter */
  assessmentSubmissionsConnection_ALL?: InputMaybe<UserAssessmentSubmissionsConnectionWhere>;
  /** Return Users where none of the related UserAssessmentSubmissionsConnections match this filter */
  assessmentSubmissionsConnection_NONE?: InputMaybe<UserAssessmentSubmissionsConnectionWhere>;
  /** Return Users where one of the related UserAssessmentSubmissionsConnections match this filter */
  assessmentSubmissionsConnection_SINGLE?: InputMaybe<UserAssessmentSubmissionsConnectionWhere>;
  /** Return Users where some of the related UserAssessmentSubmissionsConnections match this filter */
  assessmentSubmissionsConnection_SOME?: InputMaybe<UserAssessmentSubmissionsConnectionWhere>;
  /** Return Users where all of the related AssessmentSubmissions match this filter */
  assessmentSubmissions_ALL?: InputMaybe<AssessmentSubmissionWhere>;
  /** Return Users where none of the related AssessmentSubmissions match this filter */
  assessmentSubmissions_NONE?: InputMaybe<AssessmentSubmissionWhere>;
  /** Return Users where one of the related AssessmentSubmissions match this filter */
  assessmentSubmissions_SINGLE?: InputMaybe<AssessmentSubmissionWhere>;
  /** Return Users where some of the related AssessmentSubmissions match this filter */
  assessmentSubmissions_SOME?: InputMaybe<AssessmentSubmissionWhere>;
  attributesAggregate?: InputMaybe<UserAttributesAggregateInput>;
  /** Return Users where all of the related UserAttributesConnections match this filter */
  attributesConnection_ALL?: InputMaybe<UserAttributesConnectionWhere>;
  /** Return Users where none of the related UserAttributesConnections match this filter */
  attributesConnection_NONE?: InputMaybe<UserAttributesConnectionWhere>;
  /** Return Users where one of the related UserAttributesConnections match this filter */
  attributesConnection_SINGLE?: InputMaybe<UserAttributesConnectionWhere>;
  /** Return Users where some of the related UserAttributesConnections match this filter */
  attributesConnection_SOME?: InputMaybe<UserAttributesConnectionWhere>;
  /** Return Users where all of the related Attributes match this filter */
  attributes_ALL?: InputMaybe<AttributeWhere>;
  /** Return Users where none of the related Attributes match this filter */
  attributes_NONE?: InputMaybe<AttributeWhere>;
  /** Return Users where one of the related Attributes match this filter */
  attributes_SINGLE?: InputMaybe<AttributeWhere>;
  /** Return Users where some of the related Attributes match this filter */
  attributes_SOME?: InputMaybe<AttributeWhere>;
  audioOn?: InputMaybe<Scalars['Boolean']['input']>;
  auditEventsAggregate?: InputMaybe<UserAuditEventsAggregateInput>;
  /** Return Users where all of the related UserAuditEventsConnections match this filter */
  auditEventsConnection_ALL?: InputMaybe<UserAuditEventsConnectionWhere>;
  /** Return Users where none of the related UserAuditEventsConnections match this filter */
  auditEventsConnection_NONE?: InputMaybe<UserAuditEventsConnectionWhere>;
  /** Return Users where one of the related UserAuditEventsConnections match this filter */
  auditEventsConnection_SINGLE?: InputMaybe<UserAuditEventsConnectionWhere>;
  /** Return Users where some of the related UserAuditEventsConnections match this filter */
  auditEventsConnection_SOME?: InputMaybe<UserAuditEventsConnectionWhere>;
  /** Return Users where all of the related AuditEvents match this filter */
  auditEvents_ALL?: InputMaybe<AuditEventWhere>;
  /** Return Users where none of the related AuditEvents match this filter */
  auditEvents_NONE?: InputMaybe<AuditEventWhere>;
  /** Return Users where one of the related AuditEvents match this filter */
  auditEvents_SINGLE?: InputMaybe<AuditEventWhere>;
  /** Return Users where some of the related AuditEvents match this filter */
  auditEvents_SOME?: InputMaybe<AuditEventWhere>;
  authoredNotesAggregate?: InputMaybe<UserAuthoredNotesAggregateInput>;
  /** Return Users where all of the related UserAuthoredNotesConnections match this filter */
  authoredNotesConnection_ALL?: InputMaybe<UserAuthoredNotesConnectionWhere>;
  /** Return Users where none of the related UserAuthoredNotesConnections match this filter */
  authoredNotesConnection_NONE?: InputMaybe<UserAuthoredNotesConnectionWhere>;
  /** Return Users where one of the related UserAuthoredNotesConnections match this filter */
  authoredNotesConnection_SINGLE?: InputMaybe<UserAuthoredNotesConnectionWhere>;
  /** Return Users where some of the related UserAuthoredNotesConnections match this filter */
  authoredNotesConnection_SOME?: InputMaybe<UserAuthoredNotesConnectionWhere>;
  /** Return Users where all of the related Notes match this filter */
  authoredNotes_ALL?: InputMaybe<NoteWhere>;
  /** Return Users where none of the related Notes match this filter */
  authoredNotes_NONE?: InputMaybe<NoteWhere>;
  /** Return Users where one of the related Notes match this filter */
  authoredNotes_SINGLE?: InputMaybe<NoteWhere>;
  /** Return Users where some of the related Notes match this filter */
  authoredNotes_SOME?: InputMaybe<NoteWhere>;
  authoredPostsAggregate?: InputMaybe<UserAuthoredPostsAggregateInput>;
  /** Return Users where all of the related UserAuthoredPostsConnections match this filter */
  authoredPostsConnection_ALL?: InputMaybe<UserAuthoredPostsConnectionWhere>;
  /** Return Users where none of the related UserAuthoredPostsConnections match this filter */
  authoredPostsConnection_NONE?: InputMaybe<UserAuthoredPostsConnectionWhere>;
  /** Return Users where one of the related UserAuthoredPostsConnections match this filter */
  authoredPostsConnection_SINGLE?: InputMaybe<UserAuthoredPostsConnectionWhere>;
  /** Return Users where some of the related UserAuthoredPostsConnections match this filter */
  authoredPostsConnection_SOME?: InputMaybe<UserAuthoredPostsConnectionWhere>;
  /** Return Users where all of the related Posts match this filter */
  authoredPosts_ALL?: InputMaybe<PostWhere>;
  /** Return Users where none of the related Posts match this filter */
  authoredPosts_NONE?: InputMaybe<PostWhere>;
  /** Return Users where one of the related Posts match this filter */
  authoredPosts_SINGLE?: InputMaybe<PostWhere>;
  /** Return Users where some of the related Posts match this filter */
  authoredPosts_SOME?: InputMaybe<PostWhere>;
  biography?: InputMaybe<Scalars['String']['input']>;
  biography_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  biography_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  biography_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  biography_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  birthday_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  consentToSms?: InputMaybe<Scalars['Boolean']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryCode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  countryCode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  countryCode_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  countryCode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  createdAnnouncementsAggregate?: InputMaybe<UserCreatedAnnouncementsAggregateInput>;
  /** Return Users where all of the related UserCreatedAnnouncementsConnections match this filter */
  createdAnnouncementsConnection_ALL?: InputMaybe<UserCreatedAnnouncementsConnectionWhere>;
  /** Return Users where none of the related UserCreatedAnnouncementsConnections match this filter */
  createdAnnouncementsConnection_NONE?: InputMaybe<UserCreatedAnnouncementsConnectionWhere>;
  /** Return Users where one of the related UserCreatedAnnouncementsConnections match this filter */
  createdAnnouncementsConnection_SINGLE?: InputMaybe<UserCreatedAnnouncementsConnectionWhere>;
  /** Return Users where some of the related UserCreatedAnnouncementsConnections match this filter */
  createdAnnouncementsConnection_SOME?: InputMaybe<UserCreatedAnnouncementsConnectionWhere>;
  /** Return Users where all of the related Announcements match this filter */
  createdAnnouncements_ALL?: InputMaybe<AnnouncementWhere>;
  /** Return Users where none of the related Announcements match this filter */
  createdAnnouncements_NONE?: InputMaybe<AnnouncementWhere>;
  /** Return Users where one of the related Announcements match this filter */
  createdAnnouncements_SINGLE?: InputMaybe<AnnouncementWhere>;
  /** Return Users where some of the related Announcements match this filter */
  createdAnnouncements_SOME?: InputMaybe<AnnouncementWhere>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId?: InputMaybe<Scalars['String']['input']>;
  crmUserId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  crmUserId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  crmUserId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  crmUserId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  currentWeightLbs?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  currentWeightLbs_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_LTE?: InputMaybe<Scalars['Float']['input']>;
  dailyEmailOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  email_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  email_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  email_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  enrolledCoursesAggregate?: InputMaybe<UserEnrolledCoursesAggregateInput>;
  /** Return Users where all of the related UserEnrolledCoursesConnections match this filter */
  enrolledCoursesConnection_ALL?: InputMaybe<UserEnrolledCoursesConnectionWhere>;
  /** Return Users where none of the related UserEnrolledCoursesConnections match this filter */
  enrolledCoursesConnection_NONE?: InputMaybe<UserEnrolledCoursesConnectionWhere>;
  /** Return Users where one of the related UserEnrolledCoursesConnections match this filter */
  enrolledCoursesConnection_SINGLE?: InputMaybe<UserEnrolledCoursesConnectionWhere>;
  /** Return Users where some of the related UserEnrolledCoursesConnections match this filter */
  enrolledCoursesConnection_SOME?: InputMaybe<UserEnrolledCoursesConnectionWhere>;
  /** Return Users where all of the related Courses match this filter */
  enrolledCourses_ALL?: InputMaybe<CourseWhere>;
  /** Return Users where none of the related Courses match this filter */
  enrolledCourses_NONE?: InputMaybe<CourseWhere>;
  /** Return Users where one of the related Courses match this filter */
  enrolledCourses_SINGLE?: InputMaybe<CourseWhere>;
  /** Return Users where some of the related Courses match this filter */
  enrolledCourses_SOME?: InputMaybe<CourseWhere>;
  enrolledDegreesAggregate?: InputMaybe<UserEnrolledDegreesAggregateInput>;
  /** Return Users where all of the related UserEnrolledDegreesConnections match this filter */
  enrolledDegreesConnection_ALL?: InputMaybe<UserEnrolledDegreesConnectionWhere>;
  /** Return Users where none of the related UserEnrolledDegreesConnections match this filter */
  enrolledDegreesConnection_NONE?: InputMaybe<UserEnrolledDegreesConnectionWhere>;
  /** Return Users where one of the related UserEnrolledDegreesConnections match this filter */
  enrolledDegreesConnection_SINGLE?: InputMaybe<UserEnrolledDegreesConnectionWhere>;
  /** Return Users where some of the related UserEnrolledDegreesConnections match this filter */
  enrolledDegreesConnection_SOME?: InputMaybe<UserEnrolledDegreesConnectionWhere>;
  /** Return Users where all of the related Degrees match this filter */
  enrolledDegrees_ALL?: InputMaybe<DegreeWhere>;
  /** Return Users where none of the related Degrees match this filter */
  enrolledDegrees_NONE?: InputMaybe<DegreeWhere>;
  /** Return Users where one of the related Degrees match this filter */
  enrolledDegrees_SINGLE?: InputMaybe<DegreeWhere>;
  /** Return Users where some of the related Degrees match this filter */
  enrolledDegrees_SOME?: InputMaybe<DegreeWhere>;
  enrolledInTopicsAggregate?: InputMaybe<UserEnrolledInTopicsAggregateInput>;
  /** Return Users where all of the related UserEnrolledInTopicsConnections match this filter */
  enrolledInTopicsConnection_ALL?: InputMaybe<UserEnrolledInTopicsConnectionWhere>;
  /** Return Users where none of the related UserEnrolledInTopicsConnections match this filter */
  enrolledInTopicsConnection_NONE?: InputMaybe<UserEnrolledInTopicsConnectionWhere>;
  /** Return Users where one of the related UserEnrolledInTopicsConnections match this filter */
  enrolledInTopicsConnection_SINGLE?: InputMaybe<UserEnrolledInTopicsConnectionWhere>;
  /** Return Users where some of the related UserEnrolledInTopicsConnections match this filter */
  enrolledInTopicsConnection_SOME?: InputMaybe<UserEnrolledInTopicsConnectionWhere>;
  /** Return Users where all of the related Topics match this filter */
  enrolledInTopics_ALL?: InputMaybe<TopicWhere>;
  /** Return Users where none of the related Topics match this filter */
  enrolledInTopics_NONE?: InputMaybe<TopicWhere>;
  /** Return Users where one of the related Topics match this filter */
  enrolledInTopics_SINGLE?: InputMaybe<TopicWhere>;
  /** Return Users where some of the related Topics match this filter */
  enrolledInTopics_SOME?: InputMaybe<TopicWhere>;
  enrolledTracks?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enrolledTracks_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  fullPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  fullPhoneNumber_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  fullPhoneNumber_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  fullPhoneNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fullPhoneNumber_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  gender_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  gender_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  gender_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  gender_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  goalWeightLbs?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  goalWeightLbs_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens?: InputMaybe<Scalars['String']['input']>;
  googleAuthTokens_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  googleAuthTokens_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  googleAuthTokens_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  googleAuthTokens_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  googleCalendarAuthToken?: InputMaybe<Scalars['String']['input']>;
  googleCalendarAuthToken_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  googleCalendarAuthToken_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  googleCalendarAuthToken_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  googleCalendarAuthToken_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  hasChatChatsAggregate?: InputMaybe<UserHasChatChatsAggregateInput>;
  /** Return Users where all of the related UserHasChatChatsConnections match this filter */
  hasChatChatsConnection_ALL?: InputMaybe<UserHasChatChatsConnectionWhere>;
  /** Return Users where none of the related UserHasChatChatsConnections match this filter */
  hasChatChatsConnection_NONE?: InputMaybe<UserHasChatChatsConnectionWhere>;
  /** Return Users where one of the related UserHasChatChatsConnections match this filter */
  hasChatChatsConnection_SINGLE?: InputMaybe<UserHasChatChatsConnectionWhere>;
  /** Return Users where some of the related UserHasChatChatsConnections match this filter */
  hasChatChatsConnection_SOME?: InputMaybe<UserHasChatChatsConnectionWhere>;
  /** Return Users where all of the related Chats match this filter */
  hasChatChats_ALL?: InputMaybe<ChatWhere>;
  /** Return Users where none of the related Chats match this filter */
  hasChatChats_NONE?: InputMaybe<ChatWhere>;
  /** Return Users where one of the related Chats match this filter */
  hasChatChats_SINGLE?: InputMaybe<ChatWhere>;
  /** Return Users where some of the related Chats match this filter */
  hasChatChats_SOME?: InputMaybe<ChatWhere>;
  hasFileAggregate?: InputMaybe<UserHasFileAggregateInput>;
  /** Return Users where all of the related UserHasFileConnections match this filter */
  hasFileConnection_ALL?: InputMaybe<UserHasFileConnectionWhere>;
  /** Return Users where none of the related UserHasFileConnections match this filter */
  hasFileConnection_NONE?: InputMaybe<UserHasFileConnectionWhere>;
  /** Return Users where one of the related UserHasFileConnections match this filter */
  hasFileConnection_SINGLE?: InputMaybe<UserHasFileConnectionWhere>;
  /** Return Users where some of the related UserHasFileConnections match this filter */
  hasFileConnection_SOME?: InputMaybe<UserHasFileConnectionWhere>;
  /** Return Users where all of the related Files match this filter */
  hasFile_ALL?: InputMaybe<FileWhere>;
  /** Return Users where none of the related Files match this filter */
  hasFile_NONE?: InputMaybe<FileWhere>;
  /** Return Users where one of the related Files match this filter */
  hasFile_SINGLE?: InputMaybe<FileWhere>;
  /** Return Users where some of the related Files match this filter */
  hasFile_SOME?: InputMaybe<FileWhere>;
  hasFoodItemFoodItemsAggregate?: InputMaybe<UserHasFoodItemFoodItemsAggregateInput>;
  /** Return Users where all of the related UserHasFoodItemFoodItemsConnections match this filter */
  hasFoodItemFoodItemsConnection_ALL?: InputMaybe<UserHasFoodItemFoodItemsConnectionWhere>;
  /** Return Users where none of the related UserHasFoodItemFoodItemsConnections match this filter */
  hasFoodItemFoodItemsConnection_NONE?: InputMaybe<UserHasFoodItemFoodItemsConnectionWhere>;
  /** Return Users where one of the related UserHasFoodItemFoodItemsConnections match this filter */
  hasFoodItemFoodItemsConnection_SINGLE?: InputMaybe<UserHasFoodItemFoodItemsConnectionWhere>;
  /** Return Users where some of the related UserHasFoodItemFoodItemsConnections match this filter */
  hasFoodItemFoodItemsConnection_SOME?: InputMaybe<UserHasFoodItemFoodItemsConnectionWhere>;
  /** Return Users where all of the related FoodItems match this filter */
  hasFoodItemFoodItems_ALL?: InputMaybe<FoodItemWhere>;
  /** Return Users where none of the related FoodItems match this filter */
  hasFoodItemFoodItems_NONE?: InputMaybe<FoodItemWhere>;
  /** Return Users where one of the related FoodItems match this filter */
  hasFoodItemFoodItems_SINGLE?: InputMaybe<FoodItemWhere>;
  /** Return Users where some of the related FoodItems match this filter */
  hasFoodItemFoodItems_SOME?: InputMaybe<FoodItemWhere>;
  hasKnowledgeChaptersAggregate?: InputMaybe<UserHasKnowledgeChaptersAggregateInput>;
  /** Return Users where all of the related UserHasKnowledgeChaptersConnections match this filter */
  hasKnowledgeChaptersConnection_ALL?: InputMaybe<UserHasKnowledgeChaptersConnectionWhere>;
  /** Return Users where none of the related UserHasKnowledgeChaptersConnections match this filter */
  hasKnowledgeChaptersConnection_NONE?: InputMaybe<UserHasKnowledgeChaptersConnectionWhere>;
  /** Return Users where one of the related UserHasKnowledgeChaptersConnections match this filter */
  hasKnowledgeChaptersConnection_SINGLE?: InputMaybe<UserHasKnowledgeChaptersConnectionWhere>;
  /** Return Users where some of the related UserHasKnowledgeChaptersConnections match this filter */
  hasKnowledgeChaptersConnection_SOME?: InputMaybe<UserHasKnowledgeChaptersConnectionWhere>;
  /** Return Users where all of the related Chapters match this filter */
  hasKnowledgeChapters_ALL?: InputMaybe<ChapterWhere>;
  /** Return Users where none of the related Chapters match this filter */
  hasKnowledgeChapters_NONE?: InputMaybe<ChapterWhere>;
  /** Return Users where one of the related Chapters match this filter */
  hasKnowledgeChapters_SINGLE?: InputMaybe<ChapterWhere>;
  /** Return Users where some of the related Chapters match this filter */
  hasKnowledgeChapters_SOME?: InputMaybe<ChapterWhere>;
  hasKnowledgeSubchaptersAggregate?: InputMaybe<UserHasKnowledgeSubchaptersAggregateInput>;
  /** Return Users where all of the related UserHasKnowledgeSubchaptersConnections match this filter */
  hasKnowledgeSubchaptersConnection_ALL?: InputMaybe<UserHasKnowledgeSubchaptersConnectionWhere>;
  /** Return Users where none of the related UserHasKnowledgeSubchaptersConnections match this filter */
  hasKnowledgeSubchaptersConnection_NONE?: InputMaybe<UserHasKnowledgeSubchaptersConnectionWhere>;
  /** Return Users where one of the related UserHasKnowledgeSubchaptersConnections match this filter */
  hasKnowledgeSubchaptersConnection_SINGLE?: InputMaybe<UserHasKnowledgeSubchaptersConnectionWhere>;
  /** Return Users where some of the related UserHasKnowledgeSubchaptersConnections match this filter */
  hasKnowledgeSubchaptersConnection_SOME?: InputMaybe<UserHasKnowledgeSubchaptersConnectionWhere>;
  /** Return Users where all of the related Subchapters match this filter */
  hasKnowledgeSubchapters_ALL?: InputMaybe<SubchapterWhere>;
  /** Return Users where none of the related Subchapters match this filter */
  hasKnowledgeSubchapters_NONE?: InputMaybe<SubchapterWhere>;
  /** Return Users where one of the related Subchapters match this filter */
  hasKnowledgeSubchapters_SINGLE?: InputMaybe<SubchapterWhere>;
  /** Return Users where some of the related Subchapters match this filter */
  hasKnowledgeSubchapters_SOME?: InputMaybe<SubchapterWhere>;
  hasKnowledgeTopicsAggregate?: InputMaybe<UserHasKnowledgeTopicsAggregateInput>;
  /** Return Users where all of the related UserHasKnowledgeTopicsConnections match this filter */
  hasKnowledgeTopicsConnection_ALL?: InputMaybe<UserHasKnowledgeTopicsConnectionWhere>;
  /** Return Users where none of the related UserHasKnowledgeTopicsConnections match this filter */
  hasKnowledgeTopicsConnection_NONE?: InputMaybe<UserHasKnowledgeTopicsConnectionWhere>;
  /** Return Users where one of the related UserHasKnowledgeTopicsConnections match this filter */
  hasKnowledgeTopicsConnection_SINGLE?: InputMaybe<UserHasKnowledgeTopicsConnectionWhere>;
  /** Return Users where some of the related UserHasKnowledgeTopicsConnections match this filter */
  hasKnowledgeTopicsConnection_SOME?: InputMaybe<UserHasKnowledgeTopicsConnectionWhere>;
  /** Return Users where all of the related Topics match this filter */
  hasKnowledgeTopics_ALL?: InputMaybe<TopicWhere>;
  /** Return Users where none of the related Topics match this filter */
  hasKnowledgeTopics_NONE?: InputMaybe<TopicWhere>;
  /** Return Users where one of the related Topics match this filter */
  hasKnowledgeTopics_SINGLE?: InputMaybe<TopicWhere>;
  /** Return Users where some of the related Topics match this filter */
  hasKnowledgeTopics_SOME?: InputMaybe<TopicWhere>;
  hasLearningPreferences?: InputMaybe<UserLearningPreferencesWhere>;
  hasLearningPreferencesAggregate?: InputMaybe<UserHasLearningPreferencesAggregateInput>;
  hasLearningPreferencesConnection?: InputMaybe<UserHasLearningPreferencesConnectionWhere>;
  hasLearningPreferencesConnection_NOT?: InputMaybe<UserHasLearningPreferencesConnectionWhere>;
  hasLearningPreferences_NOT?: InputMaybe<UserLearningPreferencesWhere>;
  hasPaymentPaymentsAggregate?: InputMaybe<UserHasPaymentPaymentsAggregateInput>;
  /** Return Users where all of the related UserHasPaymentPaymentsConnections match this filter */
  hasPaymentPaymentsConnection_ALL?: InputMaybe<UserHasPaymentPaymentsConnectionWhere>;
  /** Return Users where none of the related UserHasPaymentPaymentsConnections match this filter */
  hasPaymentPaymentsConnection_NONE?: InputMaybe<UserHasPaymentPaymentsConnectionWhere>;
  /** Return Users where one of the related UserHasPaymentPaymentsConnections match this filter */
  hasPaymentPaymentsConnection_SINGLE?: InputMaybe<UserHasPaymentPaymentsConnectionWhere>;
  /** Return Users where some of the related UserHasPaymentPaymentsConnections match this filter */
  hasPaymentPaymentsConnection_SOME?: InputMaybe<UserHasPaymentPaymentsConnectionWhere>;
  /** Return Users where all of the related Payments match this filter */
  hasPaymentPayments_ALL?: InputMaybe<PaymentWhere>;
  /** Return Users where none of the related Payments match this filter */
  hasPaymentPayments_NONE?: InputMaybe<PaymentWhere>;
  /** Return Users where one of the related Payments match this filter */
  hasPaymentPayments_SINGLE?: InputMaybe<PaymentWhere>;
  /** Return Users where some of the related Payments match this filter */
  hasPaymentPayments_SOME?: InputMaybe<PaymentWhere>;
  hasPreferencesPreferencesAggregate?: InputMaybe<UserHasPreferencesPreferencesAggregateInput>;
  /** Return Users where all of the related UserHasPreferencesPreferencesConnections match this filter */
  hasPreferencesPreferencesConnection_ALL?: InputMaybe<UserHasPreferencesPreferencesConnectionWhere>;
  /** Return Users where none of the related UserHasPreferencesPreferencesConnections match this filter */
  hasPreferencesPreferencesConnection_NONE?: InputMaybe<UserHasPreferencesPreferencesConnectionWhere>;
  /** Return Users where one of the related UserHasPreferencesPreferencesConnections match this filter */
  hasPreferencesPreferencesConnection_SINGLE?: InputMaybe<UserHasPreferencesPreferencesConnectionWhere>;
  /** Return Users where some of the related UserHasPreferencesPreferencesConnections match this filter */
  hasPreferencesPreferencesConnection_SOME?: InputMaybe<UserHasPreferencesPreferencesConnectionWhere>;
  /** Return Users where all of the related Preferences match this filter */
  hasPreferencesPreferences_ALL?: InputMaybe<PreferencesWhere>;
  /** Return Users where none of the related Preferences match this filter */
  hasPreferencesPreferences_NONE?: InputMaybe<PreferencesWhere>;
  /** Return Users where one of the related Preferences match this filter */
  hasPreferencesPreferences_SINGLE?: InputMaybe<PreferencesWhere>;
  /** Return Users where some of the related Preferences match this filter */
  hasPreferencesPreferences_SOME?: InputMaybe<PreferencesWhere>;
  hasProgressAggregate?: InputMaybe<UserHasProgressAggregateInput>;
  /** Return Users where all of the related UserHasProgressConnections match this filter */
  hasProgressConnection_ALL?: InputMaybe<UserHasProgressConnectionWhere>;
  /** Return Users where none of the related UserHasProgressConnections match this filter */
  hasProgressConnection_NONE?: InputMaybe<UserHasProgressConnectionWhere>;
  /** Return Users where one of the related UserHasProgressConnections match this filter */
  hasProgressConnection_SINGLE?: InputMaybe<UserHasProgressConnectionWhere>;
  /** Return Users where some of the related UserHasProgressConnections match this filter */
  hasProgressConnection_SOME?: InputMaybe<UserHasProgressConnectionWhere>;
  /** Return Users where all of the related Progresses match this filter */
  hasProgress_ALL?: InputMaybe<ProgressWhere>;
  /** Return Users where none of the related Progresses match this filter */
  hasProgress_NONE?: InputMaybe<ProgressWhere>;
  /** Return Users where one of the related Progresses match this filter */
  hasProgress_SINGLE?: InputMaybe<ProgressWhere>;
  /** Return Users where some of the related Progresses match this filter */
  hasProgress_SOME?: InputMaybe<ProgressWhere>;
  hasReviewsAggregate?: InputMaybe<UserHasReviewsAggregateInput>;
  /** Return Users where all of the related UserHasReviewsConnections match this filter */
  hasReviewsConnection_ALL?: InputMaybe<UserHasReviewsConnectionWhere>;
  /** Return Users where none of the related UserHasReviewsConnections match this filter */
  hasReviewsConnection_NONE?: InputMaybe<UserHasReviewsConnectionWhere>;
  /** Return Users where one of the related UserHasReviewsConnections match this filter */
  hasReviewsConnection_SINGLE?: InputMaybe<UserHasReviewsConnectionWhere>;
  /** Return Users where some of the related UserHasReviewsConnections match this filter */
  hasReviewsConnection_SOME?: InputMaybe<UserHasReviewsConnectionWhere>;
  /** Return Users where all of the related AITutors match this filter */
  hasReviews_ALL?: InputMaybe<AiTutorWhere>;
  /** Return Users where none of the related AITutors match this filter */
  hasReviews_NONE?: InputMaybe<AiTutorWhere>;
  /** Return Users where one of the related AITutors match this filter */
  hasReviews_SINGLE?: InputMaybe<AiTutorWhere>;
  /** Return Users where some of the related AITutors match this filter */
  hasReviews_SOME?: InputMaybe<AiTutorWhere>;
  hasRoleRolesAggregate?: InputMaybe<UserHasRoleRolesAggregateInput>;
  /** Return Users where all of the related UserHasRoleRolesConnections match this filter */
  hasRoleRolesConnection_ALL?: InputMaybe<UserHasRoleRolesConnectionWhere>;
  /** Return Users where none of the related UserHasRoleRolesConnections match this filter */
  hasRoleRolesConnection_NONE?: InputMaybe<UserHasRoleRolesConnectionWhere>;
  /** Return Users where one of the related UserHasRoleRolesConnections match this filter */
  hasRoleRolesConnection_SINGLE?: InputMaybe<UserHasRoleRolesConnectionWhere>;
  /** Return Users where some of the related UserHasRoleRolesConnections match this filter */
  hasRoleRolesConnection_SOME?: InputMaybe<UserHasRoleRolesConnectionWhere>;
  /** Return Users where all of the related Roles match this filter */
  hasRoleRoles_ALL?: InputMaybe<RoleWhere>;
  /** Return Users where none of the related Roles match this filter */
  hasRoleRoles_NONE?: InputMaybe<RoleWhere>;
  /** Return Users where one of the related Roles match this filter */
  hasRoleRoles_SINGLE?: InputMaybe<RoleWhere>;
  /** Return Users where some of the related Roles match this filter */
  hasRoleRoles_SOME?: InputMaybe<RoleWhere>;
  hasRosterExportAggregate?: InputMaybe<UserHasRosterExportAggregateInput>;
  /** Return Users where all of the related UserHasRosterExportConnections match this filter */
  hasRosterExportConnection_ALL?: InputMaybe<UserHasRosterExportConnectionWhere>;
  /** Return Users where none of the related UserHasRosterExportConnections match this filter */
  hasRosterExportConnection_NONE?: InputMaybe<UserHasRosterExportConnectionWhere>;
  /** Return Users where one of the related UserHasRosterExportConnections match this filter */
  hasRosterExportConnection_SINGLE?: InputMaybe<UserHasRosterExportConnectionWhere>;
  /** Return Users where some of the related UserHasRosterExportConnections match this filter */
  hasRosterExportConnection_SOME?: InputMaybe<UserHasRosterExportConnectionWhere>;
  /** Return Users where all of the related Files match this filter */
  hasRosterExport_ALL?: InputMaybe<FileWhere>;
  /** Return Users where none of the related Files match this filter */
  hasRosterExport_NONE?: InputMaybe<FileWhere>;
  /** Return Users where one of the related Files match this filter */
  hasRosterExport_SINGLE?: InputMaybe<FileWhere>;
  /** Return Users where some of the related Files match this filter */
  hasRosterExport_SOME?: InputMaybe<FileWhere>;
  hasSessionDeviceSessionsAggregate?: InputMaybe<UserHasSessionDeviceSessionsAggregateInput>;
  /** Return Users where all of the related UserHasSessionDeviceSessionsConnections match this filter */
  hasSessionDeviceSessionsConnection_ALL?: InputMaybe<UserHasSessionDeviceSessionsConnectionWhere>;
  /** Return Users where none of the related UserHasSessionDeviceSessionsConnections match this filter */
  hasSessionDeviceSessionsConnection_NONE?: InputMaybe<UserHasSessionDeviceSessionsConnectionWhere>;
  /** Return Users where one of the related UserHasSessionDeviceSessionsConnections match this filter */
  hasSessionDeviceSessionsConnection_SINGLE?: InputMaybe<UserHasSessionDeviceSessionsConnectionWhere>;
  /** Return Users where some of the related UserHasSessionDeviceSessionsConnections match this filter */
  hasSessionDeviceSessionsConnection_SOME?: InputMaybe<UserHasSessionDeviceSessionsConnectionWhere>;
  /** Return Users where all of the related DeviceSessions match this filter */
  hasSessionDeviceSessions_ALL?: InputMaybe<DeviceSessionWhere>;
  /** Return Users where none of the related DeviceSessions match this filter */
  hasSessionDeviceSessions_NONE?: InputMaybe<DeviceSessionWhere>;
  /** Return Users where one of the related DeviceSessions match this filter */
  hasSessionDeviceSessions_SINGLE?: InputMaybe<DeviceSessionWhere>;
  /** Return Users where some of the related DeviceSessions match this filter */
  hasSessionDeviceSessions_SOME?: InputMaybe<DeviceSessionWhere>;
  hasSubmissionExportAggregate?: InputMaybe<UserHasSubmissionExportAggregateInput>;
  /** Return Users where all of the related UserHasSubmissionExportConnections match this filter */
  hasSubmissionExportConnection_ALL?: InputMaybe<UserHasSubmissionExportConnectionWhere>;
  /** Return Users where none of the related UserHasSubmissionExportConnections match this filter */
  hasSubmissionExportConnection_NONE?: InputMaybe<UserHasSubmissionExportConnectionWhere>;
  /** Return Users where one of the related UserHasSubmissionExportConnections match this filter */
  hasSubmissionExportConnection_SINGLE?: InputMaybe<UserHasSubmissionExportConnectionWhere>;
  /** Return Users where some of the related UserHasSubmissionExportConnections match this filter */
  hasSubmissionExportConnection_SOME?: InputMaybe<UserHasSubmissionExportConnectionWhere>;
  /** Return Users where all of the related Files match this filter */
  hasSubmissionExport_ALL?: InputMaybe<FileWhere>;
  /** Return Users where none of the related Files match this filter */
  hasSubmissionExport_NONE?: InputMaybe<FileWhere>;
  /** Return Users where one of the related Files match this filter */
  hasSubmissionExport_SINGLE?: InputMaybe<FileWhere>;
  /** Return Users where some of the related Files match this filter */
  hasSubmissionExport_SOME?: InputMaybe<FileWhere>;
  hasSubmittedAggregate?: InputMaybe<UserHasSubmittedAggregateInput>;
  /** Return Users where all of the related UserHasSubmittedConnections match this filter */
  hasSubmittedConnection_ALL?: InputMaybe<UserHasSubmittedConnectionWhere>;
  /** Return Users where none of the related UserHasSubmittedConnections match this filter */
  hasSubmittedConnection_NONE?: InputMaybe<UserHasSubmittedConnectionWhere>;
  /** Return Users where one of the related UserHasSubmittedConnections match this filter */
  hasSubmittedConnection_SINGLE?: InputMaybe<UserHasSubmittedConnectionWhere>;
  /** Return Users where some of the related UserHasSubmittedConnections match this filter */
  hasSubmittedConnection_SOME?: InputMaybe<UserHasSubmittedConnectionWhere>;
  /** Return Users where all of the related Submissions match this filter */
  hasSubmitted_ALL?: InputMaybe<SubmissionWhere>;
  /** Return Users where none of the related Submissions match this filter */
  hasSubmitted_NONE?: InputMaybe<SubmissionWhere>;
  /** Return Users where one of the related Submissions match this filter */
  hasSubmitted_SINGLE?: InputMaybe<SubmissionWhere>;
  /** Return Users where some of the related Submissions match this filter */
  hasSubmitted_SOME?: InputMaybe<SubmissionWhere>;
  hasSuggestionSuggestionsAggregate?: InputMaybe<UserHasSuggestionSuggestionsAggregateInput>;
  /** Return Users where all of the related UserHasSuggestionSuggestionsConnections match this filter */
  hasSuggestionSuggestionsConnection_ALL?: InputMaybe<UserHasSuggestionSuggestionsConnectionWhere>;
  /** Return Users where none of the related UserHasSuggestionSuggestionsConnections match this filter */
  hasSuggestionSuggestionsConnection_NONE?: InputMaybe<UserHasSuggestionSuggestionsConnectionWhere>;
  /** Return Users where one of the related UserHasSuggestionSuggestionsConnections match this filter */
  hasSuggestionSuggestionsConnection_SINGLE?: InputMaybe<UserHasSuggestionSuggestionsConnectionWhere>;
  /** Return Users where some of the related UserHasSuggestionSuggestionsConnections match this filter */
  hasSuggestionSuggestionsConnection_SOME?: InputMaybe<UserHasSuggestionSuggestionsConnectionWhere>;
  /** Return Users where all of the related Suggestions match this filter */
  hasSuggestionSuggestions_ALL?: InputMaybe<SuggestionWhere>;
  /** Return Users where none of the related Suggestions match this filter */
  hasSuggestionSuggestions_NONE?: InputMaybe<SuggestionWhere>;
  /** Return Users where one of the related Suggestions match this filter */
  hasSuggestionSuggestions_SINGLE?: InputMaybe<SuggestionWhere>;
  /** Return Users where some of the related Suggestions match this filter */
  hasSuggestionSuggestions_SOME?: InputMaybe<SuggestionWhere>;
  hasSummaryDailySummariesAggregate?: InputMaybe<UserHasSummaryDailySummariesAggregateInput>;
  /** Return Users where all of the related UserHasSummaryDailySummariesConnections match this filter */
  hasSummaryDailySummariesConnection_ALL?: InputMaybe<UserHasSummaryDailySummariesConnectionWhere>;
  /** Return Users where none of the related UserHasSummaryDailySummariesConnections match this filter */
  hasSummaryDailySummariesConnection_NONE?: InputMaybe<UserHasSummaryDailySummariesConnectionWhere>;
  /** Return Users where one of the related UserHasSummaryDailySummariesConnections match this filter */
  hasSummaryDailySummariesConnection_SINGLE?: InputMaybe<UserHasSummaryDailySummariesConnectionWhere>;
  /** Return Users where some of the related UserHasSummaryDailySummariesConnections match this filter */
  hasSummaryDailySummariesConnection_SOME?: InputMaybe<UserHasSummaryDailySummariesConnectionWhere>;
  /** Return Users where all of the related DailySummaries match this filter */
  hasSummaryDailySummaries_ALL?: InputMaybe<DailySummaryWhere>;
  /** Return Users where none of the related DailySummaries match this filter */
  hasSummaryDailySummaries_NONE?: InputMaybe<DailySummaryWhere>;
  /** Return Users where one of the related DailySummaries match this filter */
  hasSummaryDailySummaries_SINGLE?: InputMaybe<DailySummaryWhere>;
  /** Return Users where some of the related DailySummaries match this filter */
  hasSummaryDailySummaries_SOME?: InputMaybe<DailySummaryWhere>;
  hasSummaryMonthlySummariesAggregate?: InputMaybe<UserHasSummaryMonthlySummariesAggregateInput>;
  /** Return Users where all of the related UserHasSummaryMonthlySummariesConnections match this filter */
  hasSummaryMonthlySummariesConnection_ALL?: InputMaybe<UserHasSummaryMonthlySummariesConnectionWhere>;
  /** Return Users where none of the related UserHasSummaryMonthlySummariesConnections match this filter */
  hasSummaryMonthlySummariesConnection_NONE?: InputMaybe<UserHasSummaryMonthlySummariesConnectionWhere>;
  /** Return Users where one of the related UserHasSummaryMonthlySummariesConnections match this filter */
  hasSummaryMonthlySummariesConnection_SINGLE?: InputMaybe<UserHasSummaryMonthlySummariesConnectionWhere>;
  /** Return Users where some of the related UserHasSummaryMonthlySummariesConnections match this filter */
  hasSummaryMonthlySummariesConnection_SOME?: InputMaybe<UserHasSummaryMonthlySummariesConnectionWhere>;
  /** Return Users where all of the related MonthlySummaries match this filter */
  hasSummaryMonthlySummaries_ALL?: InputMaybe<MonthlySummaryWhere>;
  /** Return Users where none of the related MonthlySummaries match this filter */
  hasSummaryMonthlySummaries_NONE?: InputMaybe<MonthlySummaryWhere>;
  /** Return Users where one of the related MonthlySummaries match this filter */
  hasSummaryMonthlySummaries_SINGLE?: InputMaybe<MonthlySummaryWhere>;
  /** Return Users where some of the related MonthlySummaries match this filter */
  hasSummaryMonthlySummaries_SOME?: InputMaybe<MonthlySummaryWhere>;
  hasSummaryQuarterlySummariesAggregate?: InputMaybe<UserHasSummaryQuarterlySummariesAggregateInput>;
  /** Return Users where all of the related UserHasSummaryQuarterlySummariesConnections match this filter */
  hasSummaryQuarterlySummariesConnection_ALL?: InputMaybe<UserHasSummaryQuarterlySummariesConnectionWhere>;
  /** Return Users where none of the related UserHasSummaryQuarterlySummariesConnections match this filter */
  hasSummaryQuarterlySummariesConnection_NONE?: InputMaybe<UserHasSummaryQuarterlySummariesConnectionWhere>;
  /** Return Users where one of the related UserHasSummaryQuarterlySummariesConnections match this filter */
  hasSummaryQuarterlySummariesConnection_SINGLE?: InputMaybe<UserHasSummaryQuarterlySummariesConnectionWhere>;
  /** Return Users where some of the related UserHasSummaryQuarterlySummariesConnections match this filter */
  hasSummaryQuarterlySummariesConnection_SOME?: InputMaybe<UserHasSummaryQuarterlySummariesConnectionWhere>;
  /** Return Users where all of the related QuarterlySummaries match this filter */
  hasSummaryQuarterlySummaries_ALL?: InputMaybe<QuarterlySummaryWhere>;
  /** Return Users where none of the related QuarterlySummaries match this filter */
  hasSummaryQuarterlySummaries_NONE?: InputMaybe<QuarterlySummaryWhere>;
  /** Return Users where one of the related QuarterlySummaries match this filter */
  hasSummaryQuarterlySummaries_SINGLE?: InputMaybe<QuarterlySummaryWhere>;
  /** Return Users where some of the related QuarterlySummaries match this filter */
  hasSummaryQuarterlySummaries_SOME?: InputMaybe<QuarterlySummaryWhere>;
  hasSummaryWeeklySummariesAggregate?: InputMaybe<UserHasSummaryWeeklySummariesAggregateInput>;
  /** Return Users where all of the related UserHasSummaryWeeklySummariesConnections match this filter */
  hasSummaryWeeklySummariesConnection_ALL?: InputMaybe<UserHasSummaryWeeklySummariesConnectionWhere>;
  /** Return Users where none of the related UserHasSummaryWeeklySummariesConnections match this filter */
  hasSummaryWeeklySummariesConnection_NONE?: InputMaybe<UserHasSummaryWeeklySummariesConnectionWhere>;
  /** Return Users where one of the related UserHasSummaryWeeklySummariesConnections match this filter */
  hasSummaryWeeklySummariesConnection_SINGLE?: InputMaybe<UserHasSummaryWeeklySummariesConnectionWhere>;
  /** Return Users where some of the related UserHasSummaryWeeklySummariesConnections match this filter */
  hasSummaryWeeklySummariesConnection_SOME?: InputMaybe<UserHasSummaryWeeklySummariesConnectionWhere>;
  /** Return Users where all of the related WeeklySummaries match this filter */
  hasSummaryWeeklySummaries_ALL?: InputMaybe<WeeklySummaryWhere>;
  /** Return Users where none of the related WeeklySummaries match this filter */
  hasSummaryWeeklySummaries_NONE?: InputMaybe<WeeklySummaryWhere>;
  /** Return Users where one of the related WeeklySummaries match this filter */
  hasSummaryWeeklySummaries_SINGLE?: InputMaybe<WeeklySummaryWhere>;
  /** Return Users where some of the related WeeklySummaries match this filter */
  hasSummaryWeeklySummaries_SOME?: InputMaybe<WeeklySummaryWhere>;
  hasSummaryYearlySummariesAggregate?: InputMaybe<UserHasSummaryYearlySummariesAggregateInput>;
  /** Return Users where all of the related UserHasSummaryYearlySummariesConnections match this filter */
  hasSummaryYearlySummariesConnection_ALL?: InputMaybe<UserHasSummaryYearlySummariesConnectionWhere>;
  /** Return Users where none of the related UserHasSummaryYearlySummariesConnections match this filter */
  hasSummaryYearlySummariesConnection_NONE?: InputMaybe<UserHasSummaryYearlySummariesConnectionWhere>;
  /** Return Users where one of the related UserHasSummaryYearlySummariesConnections match this filter */
  hasSummaryYearlySummariesConnection_SINGLE?: InputMaybe<UserHasSummaryYearlySummariesConnectionWhere>;
  /** Return Users where some of the related UserHasSummaryYearlySummariesConnections match this filter */
  hasSummaryYearlySummariesConnection_SOME?: InputMaybe<UserHasSummaryYearlySummariesConnectionWhere>;
  /** Return Users where all of the related YearlySummaries match this filter */
  hasSummaryYearlySummaries_ALL?: InputMaybe<YearlySummaryWhere>;
  /** Return Users where none of the related YearlySummaries match this filter */
  hasSummaryYearlySummaries_NONE?: InputMaybe<YearlySummaryWhere>;
  /** Return Users where one of the related YearlySummaries match this filter */
  hasSummaryYearlySummaries_SINGLE?: InputMaybe<YearlySummaryWhere>;
  /** Return Users where some of the related YearlySummaries match this filter */
  hasSummaryYearlySummaries_SOME?: InputMaybe<YearlySummaryWhere>;
  hasVisitSessionsAggregate?: InputMaybe<UserHasVisitSessionsAggregateInput>;
  /** Return Users where all of the related UserHasVisitSessionsConnections match this filter */
  hasVisitSessionsConnection_ALL?: InputMaybe<UserHasVisitSessionsConnectionWhere>;
  /** Return Users where none of the related UserHasVisitSessionsConnections match this filter */
  hasVisitSessionsConnection_NONE?: InputMaybe<UserHasVisitSessionsConnectionWhere>;
  /** Return Users where one of the related UserHasVisitSessionsConnections match this filter */
  hasVisitSessionsConnection_SINGLE?: InputMaybe<UserHasVisitSessionsConnectionWhere>;
  /** Return Users where some of the related UserHasVisitSessionsConnections match this filter */
  hasVisitSessionsConnection_SOME?: InputMaybe<UserHasVisitSessionsConnectionWhere>;
  /** Return Users where all of the related VisitSessions match this filter */
  hasVisitSessions_ALL?: InputMaybe<VisitSessionWhere>;
  /** Return Users where none of the related VisitSessions match this filter */
  hasVisitSessions_NONE?: InputMaybe<VisitSessionWhere>;
  /** Return Users where one of the related VisitSessions match this filter */
  hasVisitSessions_SINGLE?: InputMaybe<VisitSessionWhere>;
  /** Return Users where some of the related VisitSessions match this filter */
  hasVisitSessions_SOME?: InputMaybe<VisitSessionWhere>;
  hasWaterIntakeWaterIntakesAggregate?: InputMaybe<UserHasWaterIntakeWaterIntakesAggregateInput>;
  /** Return Users where all of the related UserHasWaterIntakeWaterIntakesConnections match this filter */
  hasWaterIntakeWaterIntakesConnection_ALL?: InputMaybe<UserHasWaterIntakeWaterIntakesConnectionWhere>;
  /** Return Users where none of the related UserHasWaterIntakeWaterIntakesConnections match this filter */
  hasWaterIntakeWaterIntakesConnection_NONE?: InputMaybe<UserHasWaterIntakeWaterIntakesConnectionWhere>;
  /** Return Users where one of the related UserHasWaterIntakeWaterIntakesConnections match this filter */
  hasWaterIntakeWaterIntakesConnection_SINGLE?: InputMaybe<UserHasWaterIntakeWaterIntakesConnectionWhere>;
  /** Return Users where some of the related UserHasWaterIntakeWaterIntakesConnections match this filter */
  hasWaterIntakeWaterIntakesConnection_SOME?: InputMaybe<UserHasWaterIntakeWaterIntakesConnectionWhere>;
  /** Return Users where all of the related WaterIntakes match this filter */
  hasWaterIntakeWaterIntakes_ALL?: InputMaybe<WaterIntakeWhere>;
  /** Return Users where none of the related WaterIntakes match this filter */
  hasWaterIntakeWaterIntakes_NONE?: InputMaybe<WaterIntakeWhere>;
  /** Return Users where one of the related WaterIntakes match this filter */
  hasWaterIntakeWaterIntakes_SINGLE?: InputMaybe<WaterIntakeWhere>;
  /** Return Users where some of the related WaterIntakes match this filter */
  hasWaterIntakeWaterIntakes_SOME?: InputMaybe<WaterIntakeWhere>;
  hasWhitelistedEmailsAggregate?: InputMaybe<UserHasWhitelistedEmailsAggregateInput>;
  /** Return Users where all of the related UserHasWhitelistedEmailsConnections match this filter */
  hasWhitelistedEmailsConnection_ALL?: InputMaybe<UserHasWhitelistedEmailsConnectionWhere>;
  /** Return Users where none of the related UserHasWhitelistedEmailsConnections match this filter */
  hasWhitelistedEmailsConnection_NONE?: InputMaybe<UserHasWhitelistedEmailsConnectionWhere>;
  /** Return Users where one of the related UserHasWhitelistedEmailsConnections match this filter */
  hasWhitelistedEmailsConnection_SINGLE?: InputMaybe<UserHasWhitelistedEmailsConnectionWhere>;
  /** Return Users where some of the related UserHasWhitelistedEmailsConnections match this filter */
  hasWhitelistedEmailsConnection_SOME?: InputMaybe<UserHasWhitelistedEmailsConnectionWhere>;
  /** Return Users where all of the related WhitelistedEmails match this filter */
  hasWhitelistedEmails_ALL?: InputMaybe<WhitelistedEmailWhere>;
  /** Return Users where none of the related WhitelistedEmails match this filter */
  hasWhitelistedEmails_NONE?: InputMaybe<WhitelistedEmailWhere>;
  /** Return Users where one of the related WhitelistedEmails match this filter */
  hasWhitelistedEmails_SINGLE?: InputMaybe<WhitelistedEmailWhere>;
  /** Return Users where some of the related WhitelistedEmails match this filter */
  hasWhitelistedEmails_SOME?: InputMaybe<WhitelistedEmailWhere>;
  hasWorkspacesAggregate?: InputMaybe<UserHasWorkspacesAggregateInput>;
  /** Return Users where all of the related UserHasWorkspacesConnections match this filter */
  hasWorkspacesConnection_ALL?: InputMaybe<UserHasWorkspacesConnectionWhere>;
  /** Return Users where none of the related UserHasWorkspacesConnections match this filter */
  hasWorkspacesConnection_NONE?: InputMaybe<UserHasWorkspacesConnectionWhere>;
  /** Return Users where one of the related UserHasWorkspacesConnections match this filter */
  hasWorkspacesConnection_SINGLE?: InputMaybe<UserHasWorkspacesConnectionWhere>;
  /** Return Users where some of the related UserHasWorkspacesConnections match this filter */
  hasWorkspacesConnection_SOME?: InputMaybe<UserHasWorkspacesConnectionWhere>;
  /** Return Users where all of the related Workspaces match this filter */
  hasWorkspaces_ALL?: InputMaybe<WorkspaceWhere>;
  /** Return Users where none of the related Workspaces match this filter */
  hasWorkspaces_NONE?: InputMaybe<WorkspaceWhere>;
  /** Return Users where one of the related Workspaces match this filter */
  hasWorkspaces_SINGLE?: InputMaybe<WorkspaceWhere>;
  /** Return Users where some of the related Workspaces match this filter */
  hasWorkspaces_SOME?: InputMaybe<WorkspaceWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  invitationToken?: InputMaybe<Scalars['String']['input']>;
  invitationTokenExpiry?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  invitationTokenExpiry_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  invitationToken_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  invitationToken_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  invitationToken_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  inviteCount?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  inviteCount_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_LTE?: InputMaybe<Scalars['Int']['input']>;
  isCareerLoading?: InputMaybe<Scalars['Boolean']['input']>;
  isCourseLoading?: InputMaybe<Scalars['Boolean']['input']>;
  isEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  isOnboarded?: InputMaybe<Scalars['Boolean']['input']>;
  isPhoneVerified?: InputMaybe<Scalars['Boolean']['input']>;
  isPro?: InputMaybe<Scalars['Boolean']['input']>;
  learningPaymentsAggregate?: InputMaybe<UserLearningPaymentsAggregateInput>;
  /** Return Users where all of the related UserLearningPaymentsConnections match this filter */
  learningPaymentsConnection_ALL?: InputMaybe<UserLearningPaymentsConnectionWhere>;
  /** Return Users where none of the related UserLearningPaymentsConnections match this filter */
  learningPaymentsConnection_NONE?: InputMaybe<UserLearningPaymentsConnectionWhere>;
  /** Return Users where one of the related UserLearningPaymentsConnections match this filter */
  learningPaymentsConnection_SINGLE?: InputMaybe<UserLearningPaymentsConnectionWhere>;
  /** Return Users where some of the related UserLearningPaymentsConnections match this filter */
  learningPaymentsConnection_SOME?: InputMaybe<UserLearningPaymentsConnectionWhere>;
  /** Return Users where all of the related LearningPayments match this filter */
  learningPayments_ALL?: InputMaybe<LearningPaymentWhere>;
  /** Return Users where none of the related LearningPayments match this filter */
  learningPayments_NONE?: InputMaybe<LearningPaymentWhere>;
  /** Return Users where one of the related LearningPayments match this filter */
  learningPayments_SINGLE?: InputMaybe<LearningPaymentWhere>;
  /** Return Users where some of the related LearningPayments match this filter */
  learningPayments_SOME?: InputMaybe<LearningPaymentWhere>;
  meetingLink?: InputMaybe<Scalars['String']['input']>;
  meetingLink_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  meetingLink_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  meetingLink_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  meetingLink_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  modalOnboarding?: InputMaybe<Scalars['String']['input']>;
  modalOnboarding_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  modalOnboarding_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  modalOnboarding_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modalOnboarding_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  needsResolution?: InputMaybe<Scalars['Boolean']['input']>;
  notesAggregate?: InputMaybe<UserNotesAggregateInput>;
  /** Return Users where all of the related UserNotesConnections match this filter */
  notesConnection_ALL?: InputMaybe<UserNotesConnectionWhere>;
  /** Return Users where none of the related UserNotesConnections match this filter */
  notesConnection_NONE?: InputMaybe<UserNotesConnectionWhere>;
  /** Return Users where one of the related UserNotesConnections match this filter */
  notesConnection_SINGLE?: InputMaybe<UserNotesConnectionWhere>;
  /** Return Users where some of the related UserNotesConnections match this filter */
  notesConnection_SOME?: InputMaybe<UserNotesConnectionWhere>;
  /** Return Users where all of the related Notes match this filter */
  notes_ALL?: InputMaybe<NoteWhere>;
  /** Return Users where none of the related Notes match this filter */
  notes_NONE?: InputMaybe<NoteWhere>;
  /** Return Users where one of the related Notes match this filter */
  notes_SINGLE?: InputMaybe<NoteWhere>;
  /** Return Users where some of the related Notes match this filter */
  notes_SOME?: InputMaybe<NoteWhere>;
  nudgePreferences?: InputMaybe<NudgePreferencesWhere>;
  nudgePreferencesAggregate?: InputMaybe<UserNudgePreferencesAggregateInput>;
  nudgePreferencesConnection?: InputMaybe<UserNudgePreferencesConnectionWhere>;
  nudgePreferencesConnection_NOT?: InputMaybe<UserNudgePreferencesConnectionWhere>;
  nudgePreferences_NOT?: InputMaybe<NudgePreferencesWhere>;
  nudgesAboutThisAggregate?: InputMaybe<UserNudgesAboutThisAggregateInput>;
  /** Return Users where all of the related UserNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_ALL?: InputMaybe<UserNudgesAboutThisConnectionWhere>;
  /** Return Users where none of the related UserNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_NONE?: InputMaybe<UserNudgesAboutThisConnectionWhere>;
  /** Return Users where one of the related UserNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_SINGLE?: InputMaybe<UserNudgesAboutThisConnectionWhere>;
  /** Return Users where some of the related UserNudgesAboutThisConnections match this filter */
  nudgesAboutThisConnection_SOME?: InputMaybe<UserNudgesAboutThisConnectionWhere>;
  /** Return Users where all of the related Nudges match this filter */
  nudgesAboutThis_ALL?: InputMaybe<NudgeWhere>;
  /** Return Users where none of the related Nudges match this filter */
  nudgesAboutThis_NONE?: InputMaybe<NudgeWhere>;
  /** Return Users where one of the related Nudges match this filter */
  nudgesAboutThis_SINGLE?: InputMaybe<NudgeWhere>;
  /** Return Users where some of the related Nudges match this filter */
  nudgesAboutThis_SOME?: InputMaybe<NudgeWhere>;
  nudgesAggregate?: InputMaybe<UserNudgesAggregateInput>;
  /** Return Users where all of the related UserNudgesConnections match this filter */
  nudgesConnection_ALL?: InputMaybe<UserNudgesConnectionWhere>;
  /** Return Users where none of the related UserNudgesConnections match this filter */
  nudgesConnection_NONE?: InputMaybe<UserNudgesConnectionWhere>;
  /** Return Users where one of the related UserNudgesConnections match this filter */
  nudgesConnection_SINGLE?: InputMaybe<UserNudgesConnectionWhere>;
  /** Return Users where some of the related UserNudgesConnections match this filter */
  nudgesConnection_SOME?: InputMaybe<UserNudgesConnectionWhere>;
  /** Return Users where all of the related Nudges match this filter */
  nudges_ALL?: InputMaybe<NudgeWhere>;
  /** Return Users where none of the related Nudges match this filter */
  nudges_NONE?: InputMaybe<NudgeWhere>;
  /** Return Users where one of the related Nudges match this filter */
  nudges_SINGLE?: InputMaybe<NudgeWhere>;
  /** Return Users where some of the related Nudges match this filter */
  nudges_SOME?: InputMaybe<NudgeWhere>;
  otpPreference?: InputMaybe<Scalars['String']['input']>;
  otpPreference_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  otpPreference_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  otpPreference_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  otpPreference_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  passwordResetToken?: InputMaybe<Scalars['String']['input']>;
  passwordResetTokenExpiry?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  passwordResetTokenExpiry_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  passwordResetToken_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  passwordResetToken_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  passwordResetToken_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  password_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  password_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  password_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  password_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  pendingCourseEnrollmentInvite?: InputMaybe<Scalars['Boolean']['input']>;
  pendingEmail?: InputMaybe<Scalars['String']['input']>;
  pendingEmail_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  pendingEmail_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  pendingEmail_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pendingEmail_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  pendingFacultyInvite?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  phoneNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phoneNumber_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Scalars['String']['input']>;
  profilePicture_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  profilePicture_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  profilePicture_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  profilePicture_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  reviewAITutorBeingGeneratedForAggregate?: InputMaybe<UserReviewAiTutorBeingGeneratedForAggregateInput>;
  /** Return Users where all of the related UserReviewAITutorBeingGeneratedForConnections match this filter */
  reviewAITutorBeingGeneratedForConnection_ALL?: InputMaybe<UserReviewAiTutorBeingGeneratedForConnectionWhere>;
  /** Return Users where none of the related UserReviewAITutorBeingGeneratedForConnections match this filter */
  reviewAITutorBeingGeneratedForConnection_NONE?: InputMaybe<UserReviewAiTutorBeingGeneratedForConnectionWhere>;
  /** Return Users where one of the related UserReviewAITutorBeingGeneratedForConnections match this filter */
  reviewAITutorBeingGeneratedForConnection_SINGLE?: InputMaybe<UserReviewAiTutorBeingGeneratedForConnectionWhere>;
  /** Return Users where some of the related UserReviewAITutorBeingGeneratedForConnections match this filter */
  reviewAITutorBeingGeneratedForConnection_SOME?: InputMaybe<UserReviewAiTutorBeingGeneratedForConnectionWhere>;
  /** Return Users where all of the related Reviews match this filter */
  reviewAITutorBeingGeneratedFor_ALL?: InputMaybe<ReviewWhere>;
  /** Return Users where none of the related Reviews match this filter */
  reviewAITutorBeingGeneratedFor_NONE?: InputMaybe<ReviewWhere>;
  /** Return Users where one of the related Reviews match this filter */
  reviewAITutorBeingGeneratedFor_SINGLE?: InputMaybe<ReviewWhere>;
  /** Return Users where some of the related Reviews match this filter */
  reviewAITutorBeingGeneratedFor_SOME?: InputMaybe<ReviewWhere>;
  schoolAssignmentsAggregate?: InputMaybe<UserSchoolAssignmentsAggregateInput>;
  /** Return Users where all of the related UserSchoolAssignmentsConnections match this filter */
  schoolAssignmentsConnection_ALL?: InputMaybe<UserSchoolAssignmentsConnectionWhere>;
  /** Return Users where none of the related UserSchoolAssignmentsConnections match this filter */
  schoolAssignmentsConnection_NONE?: InputMaybe<UserSchoolAssignmentsConnectionWhere>;
  /** Return Users where one of the related UserSchoolAssignmentsConnections match this filter */
  schoolAssignmentsConnection_SINGLE?: InputMaybe<UserSchoolAssignmentsConnectionWhere>;
  /** Return Users where some of the related UserSchoolAssignmentsConnections match this filter */
  schoolAssignmentsConnection_SOME?: InputMaybe<UserSchoolAssignmentsConnectionWhere>;
  /** Return Users where all of the related Assignments match this filter */
  schoolAssignments_ALL?: InputMaybe<AssignmentWhere>;
  /** Return Users where none of the related Assignments match this filter */
  schoolAssignments_NONE?: InputMaybe<AssignmentWhere>;
  /** Return Users where one of the related Assignments match this filter */
  schoolAssignments_SINGLE?: InputMaybe<AssignmentWhere>;
  /** Return Users where some of the related Assignments match this filter */
  schoolAssignments_SOME?: InputMaybe<AssignmentWhere>;
  schoolsAggregate?: InputMaybe<UserSchoolsAggregateInput>;
  /** Return Users where all of the related UserSchoolsConnections match this filter */
  schoolsConnection_ALL?: InputMaybe<UserSchoolsConnectionWhere>;
  /** Return Users where none of the related UserSchoolsConnections match this filter */
  schoolsConnection_NONE?: InputMaybe<UserSchoolsConnectionWhere>;
  /** Return Users where one of the related UserSchoolsConnections match this filter */
  schoolsConnection_SINGLE?: InputMaybe<UserSchoolsConnectionWhere>;
  /** Return Users where some of the related UserSchoolsConnections match this filter */
  schoolsConnection_SOME?: InputMaybe<UserSchoolsConnectionWhere>;
  /** Return Users where all of the related Schools match this filter */
  schools_ALL?: InputMaybe<SchoolWhere>;
  /** Return Users where none of the related Schools match this filter */
  schools_NONE?: InputMaybe<SchoolWhere>;
  /** Return Users where one of the related Schools match this filter */
  schools_SINGLE?: InputMaybe<SchoolWhere>;
  /** Return Users where some of the related Schools match this filter */
  schools_SOME?: InputMaybe<SchoolWhere>;
  seenAnnouncementsAggregate?: InputMaybe<UserSeenAnnouncementsAggregateInput>;
  /** Return Users where all of the related UserSeenAnnouncementsConnections match this filter */
  seenAnnouncementsConnection_ALL?: InputMaybe<UserSeenAnnouncementsConnectionWhere>;
  /** Return Users where none of the related UserSeenAnnouncementsConnections match this filter */
  seenAnnouncementsConnection_NONE?: InputMaybe<UserSeenAnnouncementsConnectionWhere>;
  /** Return Users where one of the related UserSeenAnnouncementsConnections match this filter */
  seenAnnouncementsConnection_SINGLE?: InputMaybe<UserSeenAnnouncementsConnectionWhere>;
  /** Return Users where some of the related UserSeenAnnouncementsConnections match this filter */
  seenAnnouncementsConnection_SOME?: InputMaybe<UserSeenAnnouncementsConnectionWhere>;
  /** Return Users where all of the related Announcements match this filter */
  seenAnnouncements_ALL?: InputMaybe<AnnouncementWhere>;
  /** Return Users where none of the related Announcements match this filter */
  seenAnnouncements_NONE?: InputMaybe<AnnouncementWhere>;
  /** Return Users where one of the related Announcements match this filter */
  seenAnnouncements_SINGLE?: InputMaybe<AnnouncementWhere>;
  /** Return Users where some of the related Announcements match this filter */
  seenAnnouncements_SOME?: InputMaybe<AnnouncementWhere>;
  showLearningActivityIntro?: InputMaybe<Scalars['Boolean']['input']>;
  skipAllNotificationEmail?: InputMaybe<Scalars['Boolean']['input']>;
  ssoId?: InputMaybe<Scalars['String']['input']>;
  ssoId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  ssoId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  ssoId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ssoId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerIdLearningPayments?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerIdLearningPayments_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerIdLearningPayments_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerIdLearningPayments_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stripeCustomerIdLearningPayments_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stripeCustomerId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stripeSubscriptionId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  subjectUser?: InputMaybe<UserWhere>;
  subjectUserAggregate?: InputMaybe<UserSubjectUserAggregateInput>;
  subjectUserConnection?: InputMaybe<UserSubjectUserConnectionWhere>;
  subjectUserConnection_NOT?: InputMaybe<UserSubjectUserConnectionWhere>;
  subjectUser_NOT?: InputMaybe<UserWhere>;
  subscribedThreadsAggregate?: InputMaybe<UserSubscribedThreadsAggregateInput>;
  /** Return Users where all of the related UserSubscribedThreadsConnections match this filter */
  subscribedThreadsConnection_ALL?: InputMaybe<UserSubscribedThreadsConnectionWhere>;
  /** Return Users where none of the related UserSubscribedThreadsConnections match this filter */
  subscribedThreadsConnection_NONE?: InputMaybe<UserSubscribedThreadsConnectionWhere>;
  /** Return Users where one of the related UserSubscribedThreadsConnections match this filter */
  subscribedThreadsConnection_SINGLE?: InputMaybe<UserSubscribedThreadsConnectionWhere>;
  /** Return Users where some of the related UserSubscribedThreadsConnections match this filter */
  subscribedThreadsConnection_SOME?: InputMaybe<UserSubscribedThreadsConnectionWhere>;
  /** Return Users where all of the related Threads match this filter */
  subscribedThreads_ALL?: InputMaybe<ThreadWhere>;
  /** Return Users where none of the related Threads match this filter */
  subscribedThreads_NONE?: InputMaybe<ThreadWhere>;
  /** Return Users where one of the related Threads match this filter */
  subscribedThreads_SINGLE?: InputMaybe<ThreadWhere>;
  /** Return Users where some of the related Threads match this filter */
  subscribedThreads_SOME?: InputMaybe<ThreadWhere>;
  teachingCoursesAggregate?: InputMaybe<UserTeachingCoursesAggregateInput>;
  /** Return Users where all of the related UserTeachingCoursesConnections match this filter */
  teachingCoursesConnection_ALL?: InputMaybe<UserTeachingCoursesConnectionWhere>;
  /** Return Users where none of the related UserTeachingCoursesConnections match this filter */
  teachingCoursesConnection_NONE?: InputMaybe<UserTeachingCoursesConnectionWhere>;
  /** Return Users where one of the related UserTeachingCoursesConnections match this filter */
  teachingCoursesConnection_SINGLE?: InputMaybe<UserTeachingCoursesConnectionWhere>;
  /** Return Users where some of the related UserTeachingCoursesConnections match this filter */
  teachingCoursesConnection_SOME?: InputMaybe<UserTeachingCoursesConnectionWhere>;
  /** Return Users where all of the related Courses match this filter */
  teachingCourses_ALL?: InputMaybe<CourseWhere>;
  /** Return Users where none of the related Courses match this filter */
  teachingCourses_NONE?: InputMaybe<CourseWhere>;
  /** Return Users where one of the related Courses match this filter */
  teachingCourses_SINGLE?: InputMaybe<CourseWhere>;
  /** Return Users where some of the related Courses match this filter */
  teachingCourses_SOME?: InputMaybe<CourseWhere>;
  tenantsAggregate?: InputMaybe<UserTenantsAggregateInput>;
  /** Return Users where all of the related UserTenantsConnections match this filter */
  tenantsConnection_ALL?: InputMaybe<UserTenantsConnectionWhere>;
  /** Return Users where none of the related UserTenantsConnections match this filter */
  tenantsConnection_NONE?: InputMaybe<UserTenantsConnectionWhere>;
  /** Return Users where one of the related UserTenantsConnections match this filter */
  tenantsConnection_SINGLE?: InputMaybe<UserTenantsConnectionWhere>;
  /** Return Users where some of the related UserTenantsConnections match this filter */
  tenantsConnection_SOME?: InputMaybe<UserTenantsConnectionWhere>;
  /** Return Users where all of the related Tenants match this filter */
  tenants_ALL?: InputMaybe<TenantWhere>;
  /** Return Users where none of the related Tenants match this filter */
  tenants_NONE?: InputMaybe<TenantWhere>;
  /** Return Users where one of the related Tenants match this filter */
  tenants_SINGLE?: InputMaybe<TenantWhere>;
  /** Return Users where some of the related Tenants match this filter */
  tenants_SOME?: InputMaybe<TenantWhere>;
  threadReadStatesAggregate?: InputMaybe<UserThreadReadStatesAggregateInput>;
  /** Return Users where all of the related UserThreadReadStatesConnections match this filter */
  threadReadStatesConnection_ALL?: InputMaybe<UserThreadReadStatesConnectionWhere>;
  /** Return Users where none of the related UserThreadReadStatesConnections match this filter */
  threadReadStatesConnection_NONE?: InputMaybe<UserThreadReadStatesConnectionWhere>;
  /** Return Users where one of the related UserThreadReadStatesConnections match this filter */
  threadReadStatesConnection_SINGLE?: InputMaybe<UserThreadReadStatesConnectionWhere>;
  /** Return Users where some of the related UserThreadReadStatesConnections match this filter */
  threadReadStatesConnection_SOME?: InputMaybe<UserThreadReadStatesConnectionWhere>;
  /** Return Users where all of the related Threads match this filter */
  threadReadStates_ALL?: InputMaybe<ThreadWhere>;
  /** Return Users where none of the related Threads match this filter */
  threadReadStates_NONE?: InputMaybe<ThreadWhere>;
  /** Return Users where one of the related Threads match this filter */
  threadReadStates_SINGLE?: InputMaybe<ThreadWhere>;
  /** Return Users where some of the related Threads match this filter */
  threadReadStates_SOME?: InputMaybe<ThreadWhere>;
  todosAggregate?: InputMaybe<UserTodosAggregateInput>;
  /** Return Users where all of the related UserTodosConnections match this filter */
  todosConnection_ALL?: InputMaybe<UserTodosConnectionWhere>;
  /** Return Users where none of the related UserTodosConnections match this filter */
  todosConnection_NONE?: InputMaybe<UserTodosConnectionWhere>;
  /** Return Users where one of the related UserTodosConnections match this filter */
  todosConnection_SINGLE?: InputMaybe<UserTodosConnectionWhere>;
  /** Return Users where some of the related UserTodosConnections match this filter */
  todosConnection_SOME?: InputMaybe<UserTodosConnectionWhere>;
  /** Return Users where all of the related Todos match this filter */
  todos_ALL?: InputMaybe<TodoWhere>;
  /** Return Users where none of the related Todos match this filter */
  todos_NONE?: InputMaybe<TodoWhere>;
  /** Return Users where one of the related Todos match this filter */
  todos_SINGLE?: InputMaybe<TodoWhere>;
  /** Return Users where some of the related Todos match this filter */
  todos_SOME?: InputMaybe<TodoWhere>;
  trialEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  trialEndDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  undefinedFoodItemsAggregate?: InputMaybe<UserUndefinedFoodItemsAggregateInput>;
  /** Return Users where all of the related UserUndefinedFoodItemsConnections match this filter */
  undefinedFoodItemsConnection_ALL?: InputMaybe<UserUndefinedFoodItemsConnectionWhere>;
  /** Return Users where none of the related UserUndefinedFoodItemsConnections match this filter */
  undefinedFoodItemsConnection_NONE?: InputMaybe<UserUndefinedFoodItemsConnectionWhere>;
  /** Return Users where one of the related UserUndefinedFoodItemsConnections match this filter */
  undefinedFoodItemsConnection_SINGLE?: InputMaybe<UserUndefinedFoodItemsConnectionWhere>;
  /** Return Users where some of the related UserUndefinedFoodItemsConnections match this filter */
  undefinedFoodItemsConnection_SOME?: InputMaybe<UserUndefinedFoodItemsConnectionWhere>;
  /** Return Users where all of the related FoodItems match this filter */
  undefinedFoodItems_ALL?: InputMaybe<FoodItemWhere>;
  /** Return Users where none of the related FoodItems match this filter */
  undefinedFoodItems_NONE?: InputMaybe<FoodItemWhere>;
  /** Return Users where one of the related FoodItems match this filter */
  undefinedFoodItems_SINGLE?: InputMaybe<FoodItemWhere>;
  /** Return Users where some of the related FoodItems match this filter */
  undefinedFoodItems_SOME?: InputMaybe<FoodItemWhere>;
  undefinedWaterIntakesAggregate?: InputMaybe<UserUndefinedWaterIntakesAggregateInput>;
  /** Return Users where all of the related UserUndefinedWaterIntakesConnections match this filter */
  undefinedWaterIntakesConnection_ALL?: InputMaybe<UserUndefinedWaterIntakesConnectionWhere>;
  /** Return Users where none of the related UserUndefinedWaterIntakesConnections match this filter */
  undefinedWaterIntakesConnection_NONE?: InputMaybe<UserUndefinedWaterIntakesConnectionWhere>;
  /** Return Users where one of the related UserUndefinedWaterIntakesConnections match this filter */
  undefinedWaterIntakesConnection_SINGLE?: InputMaybe<UserUndefinedWaterIntakesConnectionWhere>;
  /** Return Users where some of the related UserUndefinedWaterIntakesConnections match this filter */
  undefinedWaterIntakesConnection_SOME?: InputMaybe<UserUndefinedWaterIntakesConnectionWhere>;
  /** Return Users where all of the related WaterIntakes match this filter */
  undefinedWaterIntakes_ALL?: InputMaybe<WaterIntakeWhere>;
  /** Return Users where none of the related WaterIntakes match this filter */
  undefinedWaterIntakes_NONE?: InputMaybe<WaterIntakeWhere>;
  /** Return Users where one of the related WaterIntakes match this filter */
  undefinedWaterIntakes_SINGLE?: InputMaybe<WaterIntakeWhere>;
  /** Return Users where some of the related WaterIntakes match this filter */
  undefinedWaterIntakes_SOME?: InputMaybe<WaterIntakeWhere>;
  username?: InputMaybe<Scalars['String']['input']>;
  username_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  username_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  username_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  username_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  watchedIntroVideo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserWhitelistedEmailHasWhitelistedEmailsAggregationSelection = {
  __typename?: 'UserWhitelistedEmailHasWhitelistedEmailsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserWhitelistedEmailHasWhitelistedEmailsNodeAggregateSelection>;
};

export type UserWhitelistedEmailHasWhitelistedEmailsNodeAggregateSelection = {
  __typename?: 'UserWhitelistedEmailHasWhitelistedEmailsNodeAggregateSelection';
  email: StringAggregateSelection;
};

export type UserWorkspace = {
  __typename?: 'UserWorkspace';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type UserWorkspaceHasWorkspacesAggregationSelection = {
  __typename?: 'UserWorkspaceHasWorkspacesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserWorkspaceHasWorkspacesNodeAggregateSelection>;
};

export type UserWorkspaceHasWorkspacesNodeAggregateSelection = {
  __typename?: 'UserWorkspaceHasWorkspacesNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  key: StringAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  name: StringAggregateSelection;
};

export type UserYearlySummaryHasSummaryYearlySummariesAggregationSelection = {
  __typename?: 'UserYearlySummaryHasSummaryYearlySummariesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<UserYearlySummaryHasSummaryYearlySummariesNodeAggregateSelection>;
};

export type UserYearlySummaryHasSummaryYearlySummariesNodeAggregateSelection = {
  __typename?: 'UserYearlySummaryHasSummaryYearlySummariesNodeAggregateSelection';
  created: DateTimeAggregateSelection;
  date: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  summary: StringAggregateSelection;
};

export type ValidityResponse = {
  __typename?: 'ValidityResponse';
  isValid?: Maybe<Scalars['Boolean']['output']>;
};

export type Video = {
  __typename?: 'Video';
  created?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fullTranscript: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isTeacherAdded: Scalars['Boolean']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  messageHasVideo?: Maybe<Message>;
  messageHasVideoAggregate?: Maybe<VideoMessageMessageHasVideoAggregationSelection>;
  messageHasVideoConnection: VideoMessageHasVideoConnection;
  objectiveHasVideos: Objective;
  objectiveHasVideosAggregate?: Maybe<VideoObjectiveObjectiveHasVideosAggregationSelection>;
  objectiveHasVideosConnection: VideoObjectiveHasVideosConnection;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
  videoId: Scalars['String']['output'];
};


export type VideoMessageHasVideoArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<MessageOptions>;
  where?: InputMaybe<MessageWhere>;
};


export type VideoMessageHasVideoAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MessageWhere>;
};


export type VideoMessageHasVideoConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<VideoMessageHasVideoConnectionSort>>;
  where?: InputMaybe<VideoMessageHasVideoConnectionWhere>;
};


export type VideoObjectiveHasVideosArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ObjectiveOptions>;
  where?: InputMaybe<ObjectiveWhere>;
};


export type VideoObjectiveHasVideosAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ObjectiveWhere>;
};


export type VideoObjectiveHasVideosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<VideoObjectiveHasVideosConnectionSort>>;
  where?: InputMaybe<VideoObjectiveHasVideosConnectionWhere>;
};

export type VideoConnectInput = {
  messageHasVideo?: InputMaybe<VideoMessageHasVideoConnectFieldInput>;
  objectiveHasVideos?: InputMaybe<VideoObjectiveHasVideosConnectFieldInput>;
};

export type VideoConnectOrCreateWhere = {
  node: VideoUniqueWhere;
};

export type VideoConnectWhere = {
  node: VideoWhere;
};

export type VideoCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fullTranscript: Scalars['String']['input'];
  isTeacherAdded: Scalars['Boolean']['input'];
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  messageHasVideo?: InputMaybe<VideoMessageHasVideoFieldInput>;
  objectiveHasVideos?: InputMaybe<VideoObjectiveHasVideosFieldInput>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
  videoId: Scalars['String']['input'];
};

export type VideoData = {
  isTeacherAdded: Scalars['Boolean']['input'];
  objectiveId: Scalars['String']['input'];
  videoId: Scalars['String']['input'];
};

export type VideoDataInput = {
  isTeacherAdded?: InputMaybe<Scalars['Boolean']['input']>;
  objectiveSequence?: InputMaybe<Scalars['Float']['input']>;
  objectiveText: Scalars['String']['input'];
  videoId: Scalars['String']['input'];
};

export type VideoDeleteInput = {
  messageHasVideo?: InputMaybe<VideoMessageHasVideoDeleteFieldInput>;
  objectiveHasVideos?: InputMaybe<VideoObjectiveHasVideosDeleteFieldInput>;
};

export type VideoDisconnectInput = {
  messageHasVideo?: InputMaybe<VideoMessageHasVideoDisconnectFieldInput>;
  objectiveHasVideos?: InputMaybe<VideoObjectiveHasVideosDisconnectFieldInput>;
};

export type VideoMessageHasVideoAggregateInput = {
  AND?: InputMaybe<Array<VideoMessageHasVideoAggregateInput>>;
  NOT?: InputMaybe<VideoMessageHasVideoAggregateInput>;
  OR?: InputMaybe<Array<VideoMessageHasVideoAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<VideoMessageHasVideoNodeAggregationWhereInput>;
};

export type VideoMessageHasVideoConnectFieldInput = {
  connect?: InputMaybe<MessageConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<MessageConnectWhere>;
};

export type VideoMessageHasVideoConnectOrCreateFieldInput = {
  onCreate: VideoMessageHasVideoConnectOrCreateFieldInputOnCreate;
  where: MessageConnectOrCreateWhere;
};

export type VideoMessageHasVideoConnectOrCreateFieldInputOnCreate = {
  node: MessageOnCreateInput;
};

export type VideoMessageHasVideoConnection = {
  __typename?: 'VideoMessageHasVideoConnection';
  edges: Array<VideoMessageHasVideoRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type VideoMessageHasVideoConnectionSort = {
  node?: InputMaybe<MessageSort>;
};

export type VideoMessageHasVideoConnectionWhere = {
  AND?: InputMaybe<Array<VideoMessageHasVideoConnectionWhere>>;
  NOT?: InputMaybe<VideoMessageHasVideoConnectionWhere>;
  OR?: InputMaybe<Array<VideoMessageHasVideoConnectionWhere>>;
  node?: InputMaybe<MessageWhere>;
};

export type VideoMessageHasVideoCreateFieldInput = {
  node: MessageCreateInput;
};

export type VideoMessageHasVideoDeleteFieldInput = {
  delete?: InputMaybe<MessageDeleteInput>;
  where?: InputMaybe<VideoMessageHasVideoConnectionWhere>;
};

export type VideoMessageHasVideoDisconnectFieldInput = {
  disconnect?: InputMaybe<MessageDisconnectInput>;
  where?: InputMaybe<VideoMessageHasVideoConnectionWhere>;
};

export type VideoMessageHasVideoFieldInput = {
  connect?: InputMaybe<VideoMessageHasVideoConnectFieldInput>;
  connectOrCreate?: InputMaybe<VideoMessageHasVideoConnectOrCreateFieldInput>;
  create?: InputMaybe<VideoMessageHasVideoCreateFieldInput>;
};

export type VideoMessageHasVideoNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<VideoMessageHasVideoNodeAggregationWhereInput>>;
  NOT?: InputMaybe<VideoMessageHasVideoNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<VideoMessageHasVideoNodeAggregationWhereInput>>;
  aspectDetails_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  content_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  content_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  emotion_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emotion_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emotion_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emotion_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emotion_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emotion_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emotion_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emotion_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emotion_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emotion_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  index_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  index_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  nodeId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nodeId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  nodeId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  nodeId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  nodeId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  nodeId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nodeId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nodeId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nodeId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nodeId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  parameters_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  parameters_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  parameters_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  parameters_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  parameters_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  parameters_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  parameters_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  parameters_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  parameters_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  parameters_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  snackType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  snackType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  snackType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  snackType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  snackType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  snackType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  snackType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  snackType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  snackType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  snackType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type VideoMessageHasVideoRelationship = {
  __typename?: 'VideoMessageHasVideoRelationship';
  cursor: Scalars['String']['output'];
  node: Message;
};

export type VideoMessageHasVideoUpdateConnectionInput = {
  node?: InputMaybe<MessageUpdateInput>;
};

export type VideoMessageHasVideoUpdateFieldInput = {
  connect?: InputMaybe<VideoMessageHasVideoConnectFieldInput>;
  connectOrCreate?: InputMaybe<VideoMessageHasVideoConnectOrCreateFieldInput>;
  create?: InputMaybe<VideoMessageHasVideoCreateFieldInput>;
  delete?: InputMaybe<VideoMessageHasVideoDeleteFieldInput>;
  disconnect?: InputMaybe<VideoMessageHasVideoDisconnectFieldInput>;
  update?: InputMaybe<VideoMessageHasVideoUpdateConnectionInput>;
  where?: InputMaybe<VideoMessageHasVideoConnectionWhere>;
};

export type VideoMessageMessageHasVideoAggregationSelection = {
  __typename?: 'VideoMessageMessageHasVideoAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<VideoMessageMessageHasVideoNodeAggregateSelection>;
};

export type VideoMessageMessageHasVideoNodeAggregateSelection = {
  __typename?: 'VideoMessageMessageHasVideoNodeAggregateSelection';
  aspectDetails: StringAggregateSelection;
  content: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  emotion: StringAggregateSelection;
  id: IdAggregateSelection;
  index: IntAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  nodeId: StringAggregateSelection;
  parameters: StringAggregateSelection;
  sender: StringAggregateSelection;
  snackType: StringAggregateSelection;
  type: StringAggregateSelection;
};

export type VideoObjectiveHasVideosAggregateInput = {
  AND?: InputMaybe<Array<VideoObjectiveHasVideosAggregateInput>>;
  NOT?: InputMaybe<VideoObjectiveHasVideosAggregateInput>;
  OR?: InputMaybe<Array<VideoObjectiveHasVideosAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasVideoPropertiesAggregationWhereInput>;
  node?: InputMaybe<VideoObjectiveHasVideosNodeAggregationWhereInput>;
};

export type VideoObjectiveHasVideosConnectFieldInput = {
  connect?: InputMaybe<ObjectiveConnectInput>;
  edge: HasVideoPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ObjectiveConnectWhere>;
};

export type VideoObjectiveHasVideosConnectOrCreateFieldInput = {
  onCreate: VideoObjectiveHasVideosConnectOrCreateFieldInputOnCreate;
  where: ObjectiveConnectOrCreateWhere;
};

export type VideoObjectiveHasVideosConnectOrCreateFieldInputOnCreate = {
  edge: HasVideoPropertiesCreateInput;
  node: ObjectiveOnCreateInput;
};

export type VideoObjectiveHasVideosConnection = {
  __typename?: 'VideoObjectiveHasVideosConnection';
  edges: Array<VideoObjectiveHasVideosRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type VideoObjectiveHasVideosConnectionSort = {
  edge?: InputMaybe<HasVideoPropertiesSort>;
  node?: InputMaybe<ObjectiveSort>;
};

export type VideoObjectiveHasVideosConnectionWhere = {
  AND?: InputMaybe<Array<VideoObjectiveHasVideosConnectionWhere>>;
  NOT?: InputMaybe<VideoObjectiveHasVideosConnectionWhere>;
  OR?: InputMaybe<Array<VideoObjectiveHasVideosConnectionWhere>>;
  edge?: InputMaybe<HasVideoPropertiesWhere>;
  node?: InputMaybe<ObjectiveWhere>;
};

export type VideoObjectiveHasVideosCreateFieldInput = {
  edge: HasVideoPropertiesCreateInput;
  node: ObjectiveCreateInput;
};

export type VideoObjectiveHasVideosDeleteFieldInput = {
  delete?: InputMaybe<ObjectiveDeleteInput>;
  where?: InputMaybe<VideoObjectiveHasVideosConnectionWhere>;
};

export type VideoObjectiveHasVideosDisconnectFieldInput = {
  disconnect?: InputMaybe<ObjectiveDisconnectInput>;
  where?: InputMaybe<VideoObjectiveHasVideosConnectionWhere>;
};

export type VideoObjectiveHasVideosFieldInput = {
  connect?: InputMaybe<VideoObjectiveHasVideosConnectFieldInput>;
  connectOrCreate?: InputMaybe<VideoObjectiveHasVideosConnectOrCreateFieldInput>;
  create?: InputMaybe<VideoObjectiveHasVideosCreateFieldInput>;
};

export type VideoObjectiveHasVideosNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<VideoObjectiveHasVideosNodeAggregationWhereInput>>;
  NOT?: InputMaybe<VideoObjectiveHasVideosNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<VideoObjectiveHasVideosNodeAggregationWhereInput>>;
  objective_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  objective_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  objective_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  objective_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  objective_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  objective_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  objective_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  objective_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  objective_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  objective_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  objective_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  objective_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  objective_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  objective_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  objective_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sequence_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sequence_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sequence_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sequence_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sequence_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sequence_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sequence_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sequence_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sequence_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sequence_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sequence_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sequence_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sequence_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sequence_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sequence_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sequence_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sequence_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sequence_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sequence_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sequence_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  teachingPlan_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  teachingPlan_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  teachingPlan_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  teachingPlan_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  teachingPlan_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  teachingPlan_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  teachingPlan_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  teachingPlan_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  teachingPlan_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  teachingPlan_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  teachingPlan_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  teachingPlan_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  teachingPlan_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  teachingPlan_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  teachingPlan_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type VideoObjectiveHasVideosRelationship = {
  __typename?: 'VideoObjectiveHasVideosRelationship';
  cursor: Scalars['String']['output'];
  node: Objective;
  properties: HasVideoProperties;
};

export type VideoObjectiveHasVideosUpdateConnectionInput = {
  edge?: InputMaybe<HasVideoPropertiesUpdateInput>;
  node?: InputMaybe<ObjectiveUpdateInput>;
};

export type VideoObjectiveHasVideosUpdateFieldInput = {
  connect?: InputMaybe<VideoObjectiveHasVideosConnectFieldInput>;
  connectOrCreate?: InputMaybe<VideoObjectiveHasVideosConnectOrCreateFieldInput>;
  create?: InputMaybe<VideoObjectiveHasVideosCreateFieldInput>;
  delete?: InputMaybe<VideoObjectiveHasVideosDeleteFieldInput>;
  disconnect?: InputMaybe<VideoObjectiveHasVideosDisconnectFieldInput>;
  update?: InputMaybe<VideoObjectiveHasVideosUpdateConnectionInput>;
  where?: InputMaybe<VideoObjectiveHasVideosConnectionWhere>;
};

export type VideoObjectiveObjectiveHasVideosAggregationSelection = {
  __typename?: 'VideoObjectiveObjectiveHasVideosAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<VideoObjectiveObjectiveHasVideosEdgeAggregateSelection>;
  node?: Maybe<VideoObjectiveObjectiveHasVideosNodeAggregateSelection>;
};

export type VideoObjectiveObjectiveHasVideosEdgeAggregateSelection = {
  __typename?: 'VideoObjectiveObjectiveHasVideosEdgeAggregateSelection';
  relevanceScore: FloatAggregateSelection;
  timestamp: FloatAggregateSelection;
};

export type VideoObjectiveObjectiveHasVideosNodeAggregateSelection = {
  __typename?: 'VideoObjectiveObjectiveHasVideosNodeAggregateSelection';
  id: IdAggregateSelection;
  objective: StringAggregateSelection;
  sequence: FloatAggregateSelection;
  teachingPlan: StringAggregateSelection;
};

export type VideoOnCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fullTranscript: Scalars['String']['input'];
  isTeacherAdded: Scalars['Boolean']['input'];
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
  videoId: Scalars['String']['input'];
};

export type VideoOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more VideoSort objects to sort Videos by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<VideoSort>>;
};

export type VideoPoolItem = {
  __typename?: 'VideoPoolItem';
  description?: Maybe<Scalars['String']['output']>;
  objectiveSequence?: Maybe<Scalars['Float']['output']>;
  objectiveText?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
  videoId: Scalars['String']['output'];
};

export type VideoServiceResult = {
  __typename?: 'VideoServiceResult';
  count: Scalars['Int']['output'];
  data?: Maybe<Array<VideoPoolItem>>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Fields to sort Videos by. The order in which sorts are applied is not guaranteed when specifying many fields in one VideoSort object. */
export type VideoSort = {
  created?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  fullTranscript?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isTeacherAdded?: InputMaybe<SortDirection>;
  lastModified?: InputMaybe<SortDirection>;
  thumbnailUrl?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  url?: InputMaybe<SortDirection>;
  videoId?: InputMaybe<SortDirection>;
};

export type VideoUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type VideoUpdateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fullTranscript?: InputMaybe<Scalars['String']['input']>;
  isTeacherAdded?: InputMaybe<Scalars['Boolean']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  messageHasVideo?: InputMaybe<VideoMessageHasVideoUpdateFieldInput>;
  objectiveHasVideos?: InputMaybe<VideoObjectiveHasVideosUpdateFieldInput>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
};

export type VideoWhere = {
  AND?: InputMaybe<Array<VideoWhere>>;
  NOT?: InputMaybe<VideoWhere>;
  OR?: InputMaybe<Array<VideoWhere>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  fullTranscript?: InputMaybe<Scalars['String']['input']>;
  fullTranscript_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  fullTranscript_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  fullTranscript_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  fullTranscript_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isTeacherAdded?: InputMaybe<Scalars['Boolean']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastModified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  messageHasVideo?: InputMaybe<MessageWhere>;
  messageHasVideoAggregate?: InputMaybe<VideoMessageHasVideoAggregateInput>;
  messageHasVideoConnection?: InputMaybe<VideoMessageHasVideoConnectionWhere>;
  messageHasVideoConnection_NOT?: InputMaybe<VideoMessageHasVideoConnectionWhere>;
  messageHasVideo_NOT?: InputMaybe<MessageWhere>;
  objectiveHasVideos?: InputMaybe<ObjectiveWhere>;
  objectiveHasVideosAggregate?: InputMaybe<VideoObjectiveHasVideosAggregateInput>;
  objectiveHasVideosConnection?: InputMaybe<VideoObjectiveHasVideosConnectionWhere>;
  objectiveHasVideosConnection_NOT?: InputMaybe<VideoObjectiveHasVideosConnectionWhere>;
  objectiveHasVideos_NOT?: InputMaybe<ObjectiveWhere>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thumbnailUrl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  url_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
  videoId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  videoId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  videoId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  videoId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type VisitSession = {
  __typename?: 'VisitSession';
  ended: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  ipAddress: Scalars['String']['output'];
  lastActiveTime: Scalars['DateTime']['output'];
  pageVisits: Array<PageVisit>;
  pageVisitsAggregate?: Maybe<VisitSessionPageVisitPageVisitsAggregationSelection>;
  pageVisitsConnection: VisitSessionPageVisitsConnection;
  startTime: Scalars['DateTime']['output'];
  user: User;
  userAgent: Scalars['String']['output'];
  userAggregate?: Maybe<VisitSessionUserUserAggregationSelection>;
  userConnection: VisitSessionUserConnection;
};


export type VisitSessionPageVisitsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PageVisitOptions>;
  where?: InputMaybe<PageVisitWhere>;
};


export type VisitSessionPageVisitsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PageVisitWhere>;
};


export type VisitSessionPageVisitsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<VisitSessionPageVisitsConnectionSort>>;
  where?: InputMaybe<VisitSessionPageVisitsConnectionWhere>;
};


export type VisitSessionUserArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type VisitSessionUserAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type VisitSessionUserConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<VisitSessionUserConnectionSort>>;
  where?: InputMaybe<VisitSessionUserConnectionWhere>;
};

export type VisitSessionConnectInput = {
  pageVisits?: InputMaybe<Array<VisitSessionPageVisitsConnectFieldInput>>;
  user?: InputMaybe<VisitSessionUserConnectFieldInput>;
};

export type VisitSessionConnectOrCreateWhere = {
  node: VisitSessionUniqueWhere;
};

export type VisitSessionConnectWhere = {
  node: VisitSessionWhere;
};

export type VisitSessionCreateInput = {
  ended: Scalars['Boolean']['input'];
  ipAddress: Scalars['String']['input'];
  lastActiveTime: Scalars['DateTime']['input'];
  pageVisits?: InputMaybe<VisitSessionPageVisitsFieldInput>;
  startTime: Scalars['DateTime']['input'];
  user?: InputMaybe<VisitSessionUserFieldInput>;
  userAgent: Scalars['String']['input'];
};

export type VisitSessionData = {
  __typename?: 'VisitSessionData';
  totalCount?: Maybe<Scalars['Int']['output']>;
  visitSessions?: Maybe<Array<Maybe<LimitedVisitSession>>>;
};

export type VisitSessionDeleteInput = {
  pageVisits?: InputMaybe<Array<VisitSessionPageVisitsDeleteFieldInput>>;
  user?: InputMaybe<VisitSessionUserDeleteFieldInput>;
};

export type VisitSessionDisconnectInput = {
  pageVisits?: InputMaybe<Array<VisitSessionPageVisitsDisconnectFieldInput>>;
  user?: InputMaybe<VisitSessionUserDisconnectFieldInput>;
};

export type VisitSessionListResponse = {
  __typename?: 'VisitSessionListResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<VisitSessionData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type VisitSessionOnCreateInput = {
  ended: Scalars['Boolean']['input'];
  ipAddress: Scalars['String']['input'];
  lastActiveTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
  userAgent: Scalars['String']['input'];
};

export type VisitSessionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more VisitSessionSort objects to sort VisitSessions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<VisitSessionSort>>;
};

export type VisitSessionPageVisitPageVisitsAggregationSelection = {
  __typename?: 'VisitSessionPageVisitPageVisitsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<VisitSessionPageVisitPageVisitsNodeAggregateSelection>;
};

export type VisitSessionPageVisitPageVisitsNodeAggregateSelection = {
  __typename?: 'VisitSessionPageVisitPageVisitsNodeAggregateSelection';
  endTimestamp: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastActiveTime: DateTimeAggregateSelection;
  path: StringAggregateSelection;
  timestamp: DateTimeAggregateSelection;
};

export type VisitSessionPageVisitsAggregateInput = {
  AND?: InputMaybe<Array<VisitSessionPageVisitsAggregateInput>>;
  NOT?: InputMaybe<VisitSessionPageVisitsAggregateInput>;
  OR?: InputMaybe<Array<VisitSessionPageVisitsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<VisitSessionPageVisitsNodeAggregationWhereInput>;
};

export type VisitSessionPageVisitsConnectFieldInput = {
  connect?: InputMaybe<Array<PageVisitConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<PageVisitConnectWhere>;
};

export type VisitSessionPageVisitsConnectOrCreateFieldInput = {
  onCreate: VisitSessionPageVisitsConnectOrCreateFieldInputOnCreate;
  where: PageVisitConnectOrCreateWhere;
};

export type VisitSessionPageVisitsConnectOrCreateFieldInputOnCreate = {
  node: PageVisitOnCreateInput;
};

export type VisitSessionPageVisitsConnection = {
  __typename?: 'VisitSessionPageVisitsConnection';
  edges: Array<VisitSessionPageVisitsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type VisitSessionPageVisitsConnectionSort = {
  node?: InputMaybe<PageVisitSort>;
};

export type VisitSessionPageVisitsConnectionWhere = {
  AND?: InputMaybe<Array<VisitSessionPageVisitsConnectionWhere>>;
  NOT?: InputMaybe<VisitSessionPageVisitsConnectionWhere>;
  OR?: InputMaybe<Array<VisitSessionPageVisitsConnectionWhere>>;
  node?: InputMaybe<PageVisitWhere>;
};

export type VisitSessionPageVisitsCreateFieldInput = {
  node: PageVisitCreateInput;
};

export type VisitSessionPageVisitsDeleteFieldInput = {
  delete?: InputMaybe<PageVisitDeleteInput>;
  where?: InputMaybe<VisitSessionPageVisitsConnectionWhere>;
};

export type VisitSessionPageVisitsDisconnectFieldInput = {
  disconnect?: InputMaybe<PageVisitDisconnectInput>;
  where?: InputMaybe<VisitSessionPageVisitsConnectionWhere>;
};

export type VisitSessionPageVisitsFieldInput = {
  connect?: InputMaybe<Array<VisitSessionPageVisitsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<VisitSessionPageVisitsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<VisitSessionPageVisitsCreateFieldInput>>;
};

export type VisitSessionPageVisitsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<VisitSessionPageVisitsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<VisitSessionPageVisitsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<VisitSessionPageVisitsNodeAggregationWhereInput>>;
  endTimestamp_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endTimestamp_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endTimestamp_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endTimestamp_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endTimestamp_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endTimestamp_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endTimestamp_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endTimestamp_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endTimestamp_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endTimestamp_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  path_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  path_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  path_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  path_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  path_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  path_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  path_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  path_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  path_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  path_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  path_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  path_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  path_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  path_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  path_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timestamp_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type VisitSessionPageVisitsRelationship = {
  __typename?: 'VisitSessionPageVisitsRelationship';
  cursor: Scalars['String']['output'];
  node: PageVisit;
};

export type VisitSessionPageVisitsUpdateConnectionInput = {
  node?: InputMaybe<PageVisitUpdateInput>;
};

export type VisitSessionPageVisitsUpdateFieldInput = {
  connect?: InputMaybe<Array<VisitSessionPageVisitsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<VisitSessionPageVisitsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<VisitSessionPageVisitsCreateFieldInput>>;
  delete?: InputMaybe<Array<VisitSessionPageVisitsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<VisitSessionPageVisitsDisconnectFieldInput>>;
  update?: InputMaybe<VisitSessionPageVisitsUpdateConnectionInput>;
  where?: InputMaybe<VisitSessionPageVisitsConnectionWhere>;
};

/** Fields to sort VisitSessions by. The order in which sorts are applied is not guaranteed when specifying many fields in one VisitSessionSort object. */
export type VisitSessionSort = {
  ended?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  ipAddress?: InputMaybe<SortDirection>;
  lastActiveTime?: InputMaybe<SortDirection>;
  startTime?: InputMaybe<SortDirection>;
  userAgent?: InputMaybe<SortDirection>;
};

export type VisitSessionUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type VisitSessionUpdateInput = {
  ended?: InputMaybe<Scalars['Boolean']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  lastActiveTime?: InputMaybe<Scalars['DateTime']['input']>;
  pageVisits?: InputMaybe<Array<VisitSessionPageVisitsUpdateFieldInput>>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<VisitSessionUserUpdateFieldInput>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

export type VisitSessionUserAggregateInput = {
  AND?: InputMaybe<Array<VisitSessionUserAggregateInput>>;
  NOT?: InputMaybe<VisitSessionUserAggregateInput>;
  OR?: InputMaybe<Array<VisitSessionUserAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<VisitSessionUserNodeAggregationWhereInput>;
};

export type VisitSessionUserConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type VisitSessionUserConnectOrCreateFieldInput = {
  onCreate: VisitSessionUserConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type VisitSessionUserConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type VisitSessionUserConnection = {
  __typename?: 'VisitSessionUserConnection';
  edges: Array<VisitSessionUserRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type VisitSessionUserConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type VisitSessionUserConnectionWhere = {
  AND?: InputMaybe<Array<VisitSessionUserConnectionWhere>>;
  NOT?: InputMaybe<VisitSessionUserConnectionWhere>;
  OR?: InputMaybe<Array<VisitSessionUserConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type VisitSessionUserCreateFieldInput = {
  node: UserCreateInput;
};

export type VisitSessionUserDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<VisitSessionUserConnectionWhere>;
};

export type VisitSessionUserDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<VisitSessionUserConnectionWhere>;
};

export type VisitSessionUserFieldInput = {
  connect?: InputMaybe<VisitSessionUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<VisitSessionUserConnectOrCreateFieldInput>;
  create?: InputMaybe<VisitSessionUserCreateFieldInput>;
};

export type VisitSessionUserNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<VisitSessionUserNodeAggregationWhereInput>>;
  NOT?: InputMaybe<VisitSessionUserNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<VisitSessionUserNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type VisitSessionUserRelationship = {
  __typename?: 'VisitSessionUserRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type VisitSessionUserUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type VisitSessionUserUpdateFieldInput = {
  connect?: InputMaybe<VisitSessionUserConnectFieldInput>;
  connectOrCreate?: InputMaybe<VisitSessionUserConnectOrCreateFieldInput>;
  create?: InputMaybe<VisitSessionUserCreateFieldInput>;
  delete?: InputMaybe<VisitSessionUserDeleteFieldInput>;
  disconnect?: InputMaybe<VisitSessionUserDisconnectFieldInput>;
  update?: InputMaybe<VisitSessionUserUpdateConnectionInput>;
  where?: InputMaybe<VisitSessionUserConnectionWhere>;
};

export type VisitSessionUserUserAggregationSelection = {
  __typename?: 'VisitSessionUserUserAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<VisitSessionUserUserNodeAggregateSelection>;
};

export type VisitSessionUserUserNodeAggregateSelection = {
  __typename?: 'VisitSessionUserUserNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type VisitSessionWhere = {
  AND?: InputMaybe<Array<VisitSessionWhere>>;
  NOT?: InputMaybe<VisitSessionWhere>;
  OR?: InputMaybe<Array<VisitSessionWhere>>;
  ended?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  ipAddress_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  ipAddress_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  ipAddress_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  ipAddress_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastActiveTime?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lastActiveTime_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastActiveTime_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pageVisitsAggregate?: InputMaybe<VisitSessionPageVisitsAggregateInput>;
  /** Return VisitSessions where all of the related VisitSessionPageVisitsConnections match this filter */
  pageVisitsConnection_ALL?: InputMaybe<VisitSessionPageVisitsConnectionWhere>;
  /** Return VisitSessions where none of the related VisitSessionPageVisitsConnections match this filter */
  pageVisitsConnection_NONE?: InputMaybe<VisitSessionPageVisitsConnectionWhere>;
  /** Return VisitSessions where one of the related VisitSessionPageVisitsConnections match this filter */
  pageVisitsConnection_SINGLE?: InputMaybe<VisitSessionPageVisitsConnectionWhere>;
  /** Return VisitSessions where some of the related VisitSessionPageVisitsConnections match this filter */
  pageVisitsConnection_SOME?: InputMaybe<VisitSessionPageVisitsConnectionWhere>;
  /** Return VisitSessions where all of the related PageVisits match this filter */
  pageVisits_ALL?: InputMaybe<PageVisitWhere>;
  /** Return VisitSessions where none of the related PageVisits match this filter */
  pageVisits_NONE?: InputMaybe<PageVisitWhere>;
  /** Return VisitSessions where one of the related PageVisits match this filter */
  pageVisits_SINGLE?: InputMaybe<PageVisitWhere>;
  /** Return VisitSessions where some of the related PageVisits match this filter */
  pageVisits_SOME?: InputMaybe<PageVisitWhere>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  startTime_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startTime_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startTime_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  startTime_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startTime_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  user?: InputMaybe<UserWhere>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
  userAgent_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  userAgent_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  userAgent_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  userAgent_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  userAggregate?: InputMaybe<VisitSessionUserAggregateInput>;
  userConnection?: InputMaybe<VisitSessionUserConnectionWhere>;
  userConnection_NOT?: InputMaybe<VisitSessionUserConnectionWhere>;
  user_NOT?: InputMaybe<UserWhere>;
};

export type Visualization = {
  __typename?: 'Visualization';
  aiTutorHasVisualization?: Maybe<AiTutor>;
  aiTutorHasVisualizationAggregate?: Maybe<VisualizationAiTutorAiTutorHasVisualizationAggregationSelection>;
  aiTutorHasVisualizationConnection: VisualizationAiTutorHasVisualizationConnection;
  code?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastModified: Scalars['DateTime']['output'];
  messageHasVisualization?: Maybe<Message>;
  messageHasVisualizationAggregate?: Maybe<VisualizationMessageMessageHasVisualizationAggregationSelection>;
  messageHasVisualizationConnection: VisualizationMessageHasVisualizationConnection;
  status: VisualizationStatus;
  visualizationDescription?: Maybe<Scalars['String']['output']>;
  visualizationType?: Maybe<Scalars['String']['output']>;
};


export type VisualizationAiTutorHasVisualizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AiTutorOptions>;
  where?: InputMaybe<AiTutorWhere>;
};


export type VisualizationAiTutorHasVisualizationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AiTutorWhere>;
};


export type VisualizationAiTutorHasVisualizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<VisualizationAiTutorHasVisualizationConnectionSort>>;
  where?: InputMaybe<VisualizationAiTutorHasVisualizationConnectionWhere>;
};


export type VisualizationMessageHasVisualizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<MessageOptions>;
  where?: InputMaybe<MessageWhere>;
};


export type VisualizationMessageHasVisualizationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MessageWhere>;
};


export type VisualizationMessageHasVisualizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<VisualizationMessageHasVisualizationConnectionSort>>;
  where?: InputMaybe<VisualizationMessageHasVisualizationConnectionWhere>;
};

export type VisualizationAiTutorAiTutorHasVisualizationAggregationSelection = {
  __typename?: 'VisualizationAITutorAiTutorHasVisualizationAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<VisualizationAiTutorAiTutorHasVisualizationNodeAggregateSelection>;
};

export type VisualizationAiTutorAiTutorHasVisualizationNodeAggregateSelection = {
  __typename?: 'VisualizationAITutorAiTutorHasVisualizationNodeAggregateSelection';
  context: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  dueDate: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  targetAudience: StringAggregateSelection;
  title: StringAggregateSelection;
};

export type VisualizationAiTutorHasVisualizationAggregateInput = {
  AND?: InputMaybe<Array<VisualizationAiTutorHasVisualizationAggregateInput>>;
  NOT?: InputMaybe<VisualizationAiTutorHasVisualizationAggregateInput>;
  OR?: InputMaybe<Array<VisualizationAiTutorHasVisualizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<VisualizationAiTutorHasVisualizationNodeAggregationWhereInput>;
};

export type VisualizationAiTutorHasVisualizationConnectFieldInput = {
  connect?: InputMaybe<AiTutorConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AiTutorConnectWhere>;
};

export type VisualizationAiTutorHasVisualizationConnectOrCreateFieldInput = {
  onCreate: VisualizationAiTutorHasVisualizationConnectOrCreateFieldInputOnCreate;
  where: AiTutorConnectOrCreateWhere;
};

export type VisualizationAiTutorHasVisualizationConnectOrCreateFieldInputOnCreate = {
  node: AiTutorOnCreateInput;
};

export type VisualizationAiTutorHasVisualizationConnection = {
  __typename?: 'VisualizationAiTutorHasVisualizationConnection';
  edges: Array<VisualizationAiTutorHasVisualizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type VisualizationAiTutorHasVisualizationConnectionSort = {
  node?: InputMaybe<AiTutorSort>;
};

export type VisualizationAiTutorHasVisualizationConnectionWhere = {
  AND?: InputMaybe<Array<VisualizationAiTutorHasVisualizationConnectionWhere>>;
  NOT?: InputMaybe<VisualizationAiTutorHasVisualizationConnectionWhere>;
  OR?: InputMaybe<Array<VisualizationAiTutorHasVisualizationConnectionWhere>>;
  node?: InputMaybe<AiTutorWhere>;
};

export type VisualizationAiTutorHasVisualizationCreateFieldInput = {
  node: AiTutorCreateInput;
};

export type VisualizationAiTutorHasVisualizationDeleteFieldInput = {
  delete?: InputMaybe<AiTutorDeleteInput>;
  where?: InputMaybe<VisualizationAiTutorHasVisualizationConnectionWhere>;
};

export type VisualizationAiTutorHasVisualizationDisconnectFieldInput = {
  disconnect?: InputMaybe<AiTutorDisconnectInput>;
  where?: InputMaybe<VisualizationAiTutorHasVisualizationConnectionWhere>;
};

export type VisualizationAiTutorHasVisualizationFieldInput = {
  connect?: InputMaybe<VisualizationAiTutorHasVisualizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<VisualizationAiTutorHasVisualizationConnectOrCreateFieldInput>;
  create?: InputMaybe<VisualizationAiTutorHasVisualizationCreateFieldInput>;
};

export type VisualizationAiTutorHasVisualizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<VisualizationAiTutorHasVisualizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<VisualizationAiTutorHasVisualizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<VisualizationAiTutorHasVisualizationNodeAggregationWhereInput>>;
  context_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  context_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type VisualizationAiTutorHasVisualizationRelationship = {
  __typename?: 'VisualizationAiTutorHasVisualizationRelationship';
  cursor: Scalars['String']['output'];
  node: AiTutor;
};

export type VisualizationAiTutorHasVisualizationUpdateConnectionInput = {
  node?: InputMaybe<AiTutorUpdateInput>;
};

export type VisualizationAiTutorHasVisualizationUpdateFieldInput = {
  connect?: InputMaybe<VisualizationAiTutorHasVisualizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<VisualizationAiTutorHasVisualizationConnectOrCreateFieldInput>;
  create?: InputMaybe<VisualizationAiTutorHasVisualizationCreateFieldInput>;
  delete?: InputMaybe<VisualizationAiTutorHasVisualizationDeleteFieldInput>;
  disconnect?: InputMaybe<VisualizationAiTutorHasVisualizationDisconnectFieldInput>;
  update?: InputMaybe<VisualizationAiTutorHasVisualizationUpdateConnectionInput>;
  where?: InputMaybe<VisualizationAiTutorHasVisualizationConnectionWhere>;
};

export type VisualizationConnectInput = {
  aiTutorHasVisualization?: InputMaybe<VisualizationAiTutorHasVisualizationConnectFieldInput>;
  messageHasVisualization?: InputMaybe<VisualizationMessageHasVisualizationConnectFieldInput>;
};

export type VisualizationConnectOrCreateWhere = {
  node: VisualizationUniqueWhere;
};

export type VisualizationConnectWhere = {
  node: VisualizationWhere;
};

export type VisualizationContentInput = {
  description: Scalars['String']['input'];
  objectives: Array<ObjectiveInput>;
  title: Scalars['String']['input'];
};

export type VisualizationCreateInput = {
  aiTutorHasVisualization?: InputMaybe<VisualizationAiTutorHasVisualizationFieldInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  created: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
  lastModified: Scalars['DateTime']['input'];
  messageHasVisualization?: InputMaybe<VisualizationMessageHasVisualizationFieldInput>;
  status: VisualizationStatus;
  visualizationDescription?: InputMaybe<Scalars['String']['input']>;
  visualizationType?: InputMaybe<Scalars['String']['input']>;
};

export type VisualizationDeleteInput = {
  aiTutorHasVisualization?: InputMaybe<VisualizationAiTutorHasVisualizationDeleteFieldInput>;
  messageHasVisualization?: InputMaybe<VisualizationMessageHasVisualizationDeleteFieldInput>;
};

export type VisualizationDisconnectInput = {
  aiTutorHasVisualization?: InputMaybe<VisualizationAiTutorHasVisualizationDisconnectFieldInput>;
  messageHasVisualization?: InputMaybe<VisualizationMessageHasVisualizationDisconnectFieldInput>;
};

export type VisualizationMessageHasVisualizationAggregateInput = {
  AND?: InputMaybe<Array<VisualizationMessageHasVisualizationAggregateInput>>;
  NOT?: InputMaybe<VisualizationMessageHasVisualizationAggregateInput>;
  OR?: InputMaybe<Array<VisualizationMessageHasVisualizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<VisualizationMessageHasVisualizationNodeAggregationWhereInput>;
};

export type VisualizationMessageHasVisualizationConnectFieldInput = {
  connect?: InputMaybe<MessageConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<MessageConnectWhere>;
};

export type VisualizationMessageHasVisualizationConnectOrCreateFieldInput = {
  onCreate: VisualizationMessageHasVisualizationConnectOrCreateFieldInputOnCreate;
  where: MessageConnectOrCreateWhere;
};

export type VisualizationMessageHasVisualizationConnectOrCreateFieldInputOnCreate = {
  node: MessageOnCreateInput;
};

export type VisualizationMessageHasVisualizationConnection = {
  __typename?: 'VisualizationMessageHasVisualizationConnection';
  edges: Array<VisualizationMessageHasVisualizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type VisualizationMessageHasVisualizationConnectionSort = {
  node?: InputMaybe<MessageSort>;
};

export type VisualizationMessageHasVisualizationConnectionWhere = {
  AND?: InputMaybe<Array<VisualizationMessageHasVisualizationConnectionWhere>>;
  NOT?: InputMaybe<VisualizationMessageHasVisualizationConnectionWhere>;
  OR?: InputMaybe<Array<VisualizationMessageHasVisualizationConnectionWhere>>;
  node?: InputMaybe<MessageWhere>;
};

export type VisualizationMessageHasVisualizationCreateFieldInput = {
  node: MessageCreateInput;
};

export type VisualizationMessageHasVisualizationDeleteFieldInput = {
  delete?: InputMaybe<MessageDeleteInput>;
  where?: InputMaybe<VisualizationMessageHasVisualizationConnectionWhere>;
};

export type VisualizationMessageHasVisualizationDisconnectFieldInput = {
  disconnect?: InputMaybe<MessageDisconnectInput>;
  where?: InputMaybe<VisualizationMessageHasVisualizationConnectionWhere>;
};

export type VisualizationMessageHasVisualizationFieldInput = {
  connect?: InputMaybe<VisualizationMessageHasVisualizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<VisualizationMessageHasVisualizationConnectOrCreateFieldInput>;
  create?: InputMaybe<VisualizationMessageHasVisualizationCreateFieldInput>;
};

export type VisualizationMessageHasVisualizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<VisualizationMessageHasVisualizationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<VisualizationMessageHasVisualizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<VisualizationMessageHasVisualizationNodeAggregationWhereInput>>;
  aspectDetails_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aspectDetails_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aspectDetails_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  content_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  content_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  emotion_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emotion_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emotion_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emotion_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emotion_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emotion_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emotion_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emotion_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emotion_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emotion_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emotion_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  index_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  index_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  index_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  index_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  index_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  index_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  nodeId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nodeId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  nodeId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  nodeId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  nodeId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  nodeId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nodeId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nodeId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nodeId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nodeId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nodeId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  parameters_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  parameters_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  parameters_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  parameters_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  parameters_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  parameters_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  parameters_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  parameters_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  parameters_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  parameters_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  parameters_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  snackType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  snackType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  snackType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  snackType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  snackType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  snackType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  snackType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  snackType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  snackType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  snackType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  snackType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type VisualizationMessageHasVisualizationRelationship = {
  __typename?: 'VisualizationMessageHasVisualizationRelationship';
  cursor: Scalars['String']['output'];
  node: Message;
};

export type VisualizationMessageHasVisualizationUpdateConnectionInput = {
  node?: InputMaybe<MessageUpdateInput>;
};

export type VisualizationMessageHasVisualizationUpdateFieldInput = {
  connect?: InputMaybe<VisualizationMessageHasVisualizationConnectFieldInput>;
  connectOrCreate?: InputMaybe<VisualizationMessageHasVisualizationConnectOrCreateFieldInput>;
  create?: InputMaybe<VisualizationMessageHasVisualizationCreateFieldInput>;
  delete?: InputMaybe<VisualizationMessageHasVisualizationDeleteFieldInput>;
  disconnect?: InputMaybe<VisualizationMessageHasVisualizationDisconnectFieldInput>;
  update?: InputMaybe<VisualizationMessageHasVisualizationUpdateConnectionInput>;
  where?: InputMaybe<VisualizationMessageHasVisualizationConnectionWhere>;
};

export type VisualizationMessageMessageHasVisualizationAggregationSelection = {
  __typename?: 'VisualizationMessageMessageHasVisualizationAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<VisualizationMessageMessageHasVisualizationNodeAggregateSelection>;
};

export type VisualizationMessageMessageHasVisualizationNodeAggregateSelection = {
  __typename?: 'VisualizationMessageMessageHasVisualizationNodeAggregateSelection';
  aspectDetails: StringAggregateSelection;
  content: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  emotion: StringAggregateSelection;
  id: IdAggregateSelection;
  index: IntAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  nodeId: StringAggregateSelection;
  parameters: StringAggregateSelection;
  sender: StringAggregateSelection;
  snackType: StringAggregateSelection;
  type: StringAggregateSelection;
};

export type VisualizationOnCreateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  created: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
  lastModified: Scalars['DateTime']['input'];
  status: VisualizationStatus;
  visualizationDescription?: InputMaybe<Scalars['String']['input']>;
  visualizationType?: InputMaybe<Scalars['String']['input']>;
};

export type VisualizationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more VisualizationSort objects to sort Visualizations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<VisualizationSort>>;
};

export type VisualizationResponse = {
  __typename?: 'VisualizationResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<FormattedVisualization>>>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Fields to sort Visualizations by. The order in which sorts are applied is not guaranteed when specifying many fields in one VisualizationSort object. */
export type VisualizationSort = {
  code?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastModified?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  visualizationDescription?: InputMaybe<SortDirection>;
  visualizationType?: InputMaybe<SortDirection>;
};

export enum VisualizationStatus {
  Completed = 'completed',
  Failed = 'failed',
  Processing = 'processing'
}

export type VisualizationUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type VisualizationUpdateInput = {
  aiTutorHasVisualization?: InputMaybe<VisualizationAiTutorHasVisualizationUpdateFieldInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  messageHasVisualization?: InputMaybe<VisualizationMessageHasVisualizationUpdateFieldInput>;
  status?: InputMaybe<VisualizationStatus>;
  visualizationDescription?: InputMaybe<Scalars['String']['input']>;
  visualizationType?: InputMaybe<Scalars['String']['input']>;
};

export type VisualizationWhere = {
  AND?: InputMaybe<Array<VisualizationWhere>>;
  NOT?: InputMaybe<VisualizationWhere>;
  OR?: InputMaybe<Array<VisualizationWhere>>;
  aiTutorHasVisualization?: InputMaybe<AiTutorWhere>;
  aiTutorHasVisualizationAggregate?: InputMaybe<VisualizationAiTutorHasVisualizationAggregateInput>;
  aiTutorHasVisualizationConnection?: InputMaybe<VisualizationAiTutorHasVisualizationConnectionWhere>;
  aiTutorHasVisualizationConnection_NOT?: InputMaybe<VisualizationAiTutorHasVisualizationConnectionWhere>;
  aiTutorHasVisualization_NOT?: InputMaybe<AiTutorWhere>;
  code?: InputMaybe<Scalars['String']['input']>;
  code_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  code_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  code_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lastModified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  messageHasVisualization?: InputMaybe<MessageWhere>;
  messageHasVisualizationAggregate?: InputMaybe<VisualizationMessageHasVisualizationAggregateInput>;
  messageHasVisualizationConnection?: InputMaybe<VisualizationMessageHasVisualizationConnectionWhere>;
  messageHasVisualizationConnection_NOT?: InputMaybe<VisualizationMessageHasVisualizationConnectionWhere>;
  messageHasVisualization_NOT?: InputMaybe<MessageWhere>;
  status?: InputMaybe<VisualizationStatus>;
  status_IN?: InputMaybe<Array<VisualizationStatus>>;
  visualizationDescription?: InputMaybe<Scalars['String']['input']>;
  visualizationDescription_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  visualizationDescription_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  visualizationDescription_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  visualizationDescription_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  visualizationType?: InputMaybe<Scalars['String']['input']>;
  visualizationType_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  visualizationType_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  visualizationType_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  visualizationType_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type WaterIntake = {
  __typename?: 'WaterIntake';
  created: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  last_modified: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  usersHasWaterIntake: Array<User>;
  usersHasWaterIntakeAggregate?: Maybe<WaterIntakeUserUsersHasWaterIntakeAggregationSelection>;
  usersHasWaterIntakeConnection: WaterIntakeUsersHasWaterIntakeConnection;
  usersundefined: Array<User>;
  usersundefinedAggregate?: Maybe<WaterIntakeUserUsersundefinedAggregationSelection>;
  usersundefinedConnection: WaterIntakeUsersundefinedConnection;
  water_intake_oz?: Maybe<Scalars['Float']['output']>;
};


export type WaterIntakeUsersHasWaterIntakeArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type WaterIntakeUsersHasWaterIntakeAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type WaterIntakeUsersHasWaterIntakeConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<WaterIntakeUsersHasWaterIntakeConnectionSort>>;
  where?: InputMaybe<WaterIntakeUsersHasWaterIntakeConnectionWhere>;
};


export type WaterIntakeUsersundefinedArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type WaterIntakeUsersundefinedAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type WaterIntakeUsersundefinedConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<WaterIntakeUsersundefinedConnectionSort>>;
  where?: InputMaybe<WaterIntakeUsersundefinedConnectionWhere>;
};

export type WaterIntakeConnectInput = {
  usersHasWaterIntake?: InputMaybe<Array<WaterIntakeUsersHasWaterIntakeConnectFieldInput>>;
  usersundefined?: InputMaybe<Array<WaterIntakeUsersundefinedConnectFieldInput>>;
};

export type WaterIntakeConnectWhere = {
  node: WaterIntakeWhere;
};

export type WaterIntakeCreateInput = {
  created: Scalars['DateTime']['input'];
  id: Scalars['String']['input'];
  last_modified: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  usersHasWaterIntake?: InputMaybe<WaterIntakeUsersHasWaterIntakeFieldInput>;
  usersundefined?: InputMaybe<WaterIntakeUsersundefinedFieldInput>;
  water_intake_oz?: InputMaybe<Scalars['Float']['input']>;
};

export type WaterIntakeDeleteInput = {
  usersHasWaterIntake?: InputMaybe<Array<WaterIntakeUsersHasWaterIntakeDeleteFieldInput>>;
  usersundefined?: InputMaybe<Array<WaterIntakeUsersundefinedDeleteFieldInput>>;
};

export type WaterIntakeDisconnectInput = {
  usersHasWaterIntake?: InputMaybe<Array<WaterIntakeUsersHasWaterIntakeDisconnectFieldInput>>;
  usersundefined?: InputMaybe<Array<WaterIntakeUsersundefinedDisconnectFieldInput>>;
};

export type WaterIntakeOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more WaterIntakeSort objects to sort WaterIntakes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<WaterIntakeSort>>;
};

/** Fields to sort WaterIntakes by. The order in which sorts are applied is not guaranteed when specifying many fields in one WaterIntakeSort object. */
export type WaterIntakeSort = {
  created?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  last_modified?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  water_intake_oz?: InputMaybe<SortDirection>;
};

export type WaterIntakeUpdateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  usersHasWaterIntake?: InputMaybe<Array<WaterIntakeUsersHasWaterIntakeUpdateFieldInput>>;
  usersundefined?: InputMaybe<Array<WaterIntakeUsersundefinedUpdateFieldInput>>;
  water_intake_oz?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_ADD?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_DIVIDE?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_MULTIPLY?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_SUBTRACT?: InputMaybe<Scalars['Float']['input']>;
};

export type WaterIntakeUserUsersHasWaterIntakeAggregationSelection = {
  __typename?: 'WaterIntakeUserUsersHasWaterIntakeAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<WaterIntakeUserUsersHasWaterIntakeEdgeAggregateSelection>;
  node?: Maybe<WaterIntakeUserUsersHasWaterIntakeNodeAggregateSelection>;
};

export type WaterIntakeUserUsersHasWaterIntakeEdgeAggregateSelection = {
  __typename?: 'WaterIntakeUserUsersHasWaterIntakeEdgeAggregateSelection';
  created: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  quality: BigIntAggregateSelection;
  strength: BigIntAggregateSelection;
};

export type WaterIntakeUserUsersHasWaterIntakeNodeAggregateSelection = {
  __typename?: 'WaterIntakeUserUsersHasWaterIntakeNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type WaterIntakeUserUsersundefinedAggregationSelection = {
  __typename?: 'WaterIntakeUserUsersundefinedAggregationSelection';
  count: Scalars['Int']['output'];
  edge?: Maybe<WaterIntakeUserUsersundefinedEdgeAggregateSelection>;
  node?: Maybe<WaterIntakeUserUsersundefinedNodeAggregateSelection>;
};

export type WaterIntakeUserUsersundefinedEdgeAggregateSelection = {
  __typename?: 'WaterIntakeUserUsersundefinedEdgeAggregateSelection';
  created: DateTimeAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  quality: BigIntAggregateSelection;
  strength: BigIntAggregateSelection;
};

export type WaterIntakeUserUsersundefinedNodeAggregateSelection = {
  __typename?: 'WaterIntakeUserUsersundefinedNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type WaterIntakeUsersHasWaterIntakeAggregateInput = {
  AND?: InputMaybe<Array<WaterIntakeUsersHasWaterIntakeAggregateInput>>;
  NOT?: InputMaybe<WaterIntakeUsersHasWaterIntakeAggregateInput>;
  OR?: InputMaybe<Array<WaterIntakeUsersHasWaterIntakeAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<HasWaterIntakePropertiesAggregationWhereInput>;
  node?: InputMaybe<WaterIntakeUsersHasWaterIntakeNodeAggregationWhereInput>;
};

export type WaterIntakeUsersHasWaterIntakeConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  edge: HasWaterIntakePropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type WaterIntakeUsersHasWaterIntakeConnectOrCreateFieldInput = {
  onCreate: WaterIntakeUsersHasWaterIntakeConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type WaterIntakeUsersHasWaterIntakeConnectOrCreateFieldInputOnCreate = {
  edge: HasWaterIntakePropertiesCreateInput;
  node: UserOnCreateInput;
};

export type WaterIntakeUsersHasWaterIntakeConnection = {
  __typename?: 'WaterIntakeUsersHasWaterIntakeConnection';
  edges: Array<WaterIntakeUsersHasWaterIntakeRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WaterIntakeUsersHasWaterIntakeConnectionSort = {
  edge?: InputMaybe<HasWaterIntakePropertiesSort>;
  node?: InputMaybe<UserSort>;
};

export type WaterIntakeUsersHasWaterIntakeConnectionWhere = {
  AND?: InputMaybe<Array<WaterIntakeUsersHasWaterIntakeConnectionWhere>>;
  NOT?: InputMaybe<WaterIntakeUsersHasWaterIntakeConnectionWhere>;
  OR?: InputMaybe<Array<WaterIntakeUsersHasWaterIntakeConnectionWhere>>;
  edge?: InputMaybe<HasWaterIntakePropertiesWhere>;
  node?: InputMaybe<UserWhere>;
};

export type WaterIntakeUsersHasWaterIntakeCreateFieldInput = {
  edge: HasWaterIntakePropertiesCreateInput;
  node: UserCreateInput;
};

export type WaterIntakeUsersHasWaterIntakeDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<WaterIntakeUsersHasWaterIntakeConnectionWhere>;
};

export type WaterIntakeUsersHasWaterIntakeDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<WaterIntakeUsersHasWaterIntakeConnectionWhere>;
};

export type WaterIntakeUsersHasWaterIntakeFieldInput = {
  connect?: InputMaybe<Array<WaterIntakeUsersHasWaterIntakeConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<WaterIntakeUsersHasWaterIntakeConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<WaterIntakeUsersHasWaterIntakeCreateFieldInput>>;
};

export type WaterIntakeUsersHasWaterIntakeNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<WaterIntakeUsersHasWaterIntakeNodeAggregationWhereInput>>;
  NOT?: InputMaybe<WaterIntakeUsersHasWaterIntakeNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<WaterIntakeUsersHasWaterIntakeNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type WaterIntakeUsersHasWaterIntakeRelationship = {
  __typename?: 'WaterIntakeUsersHasWaterIntakeRelationship';
  cursor: Scalars['String']['output'];
  node: User;
  properties: HasWaterIntakeProperties;
};

export type WaterIntakeUsersHasWaterIntakeUpdateConnectionInput = {
  edge?: InputMaybe<HasWaterIntakePropertiesUpdateInput>;
  node?: InputMaybe<UserUpdateInput>;
};

export type WaterIntakeUsersHasWaterIntakeUpdateFieldInput = {
  connect?: InputMaybe<Array<WaterIntakeUsersHasWaterIntakeConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<WaterIntakeUsersHasWaterIntakeConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<WaterIntakeUsersHasWaterIntakeCreateFieldInput>>;
  delete?: InputMaybe<Array<WaterIntakeUsersHasWaterIntakeDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<WaterIntakeUsersHasWaterIntakeDisconnectFieldInput>>;
  update?: InputMaybe<WaterIntakeUsersHasWaterIntakeUpdateConnectionInput>;
  where?: InputMaybe<WaterIntakeUsersHasWaterIntakeConnectionWhere>;
};

export type WaterIntakeUsersundefinedAggregateInput = {
  AND?: InputMaybe<Array<WaterIntakeUsersundefinedAggregateInput>>;
  NOT?: InputMaybe<WaterIntakeUsersundefinedAggregateInput>;
  OR?: InputMaybe<Array<WaterIntakeUsersundefinedAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<UndefinedPropertiesAggregationWhereInput>;
  node?: InputMaybe<WaterIntakeUsersundefinedNodeAggregationWhereInput>;
};

export type WaterIntakeUsersundefinedConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  edge: UndefinedPropertiesCreateInput;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type WaterIntakeUsersundefinedConnectOrCreateFieldInput = {
  onCreate: WaterIntakeUsersundefinedConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type WaterIntakeUsersundefinedConnectOrCreateFieldInputOnCreate = {
  edge: UndefinedPropertiesCreateInput;
  node: UserOnCreateInput;
};

export type WaterIntakeUsersundefinedConnection = {
  __typename?: 'WaterIntakeUsersundefinedConnection';
  edges: Array<WaterIntakeUsersundefinedRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WaterIntakeUsersundefinedConnectionSort = {
  edge?: InputMaybe<UndefinedPropertiesSort>;
  node?: InputMaybe<UserSort>;
};

export type WaterIntakeUsersundefinedConnectionWhere = {
  AND?: InputMaybe<Array<WaterIntakeUsersundefinedConnectionWhere>>;
  NOT?: InputMaybe<WaterIntakeUsersundefinedConnectionWhere>;
  OR?: InputMaybe<Array<WaterIntakeUsersundefinedConnectionWhere>>;
  edge?: InputMaybe<UndefinedPropertiesWhere>;
  node?: InputMaybe<UserWhere>;
};

export type WaterIntakeUsersundefinedCreateFieldInput = {
  edge: UndefinedPropertiesCreateInput;
  node: UserCreateInput;
};

export type WaterIntakeUsersundefinedDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<WaterIntakeUsersundefinedConnectionWhere>;
};

export type WaterIntakeUsersundefinedDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<WaterIntakeUsersundefinedConnectionWhere>;
};

export type WaterIntakeUsersundefinedFieldInput = {
  connect?: InputMaybe<Array<WaterIntakeUsersundefinedConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<WaterIntakeUsersundefinedConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<WaterIntakeUsersundefinedCreateFieldInput>>;
};

export type WaterIntakeUsersundefinedNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<WaterIntakeUsersundefinedNodeAggregationWhereInput>>;
  NOT?: InputMaybe<WaterIntakeUsersundefinedNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<WaterIntakeUsersundefinedNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type WaterIntakeUsersundefinedRelationship = {
  __typename?: 'WaterIntakeUsersundefinedRelationship';
  cursor: Scalars['String']['output'];
  node: User;
  properties: UndefinedProperties;
};

export type WaterIntakeUsersundefinedUpdateConnectionInput = {
  edge?: InputMaybe<UndefinedPropertiesUpdateInput>;
  node?: InputMaybe<UserUpdateInput>;
};

export type WaterIntakeUsersundefinedUpdateFieldInput = {
  connect?: InputMaybe<Array<WaterIntakeUsersundefinedConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<WaterIntakeUsersundefinedConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<WaterIntakeUsersundefinedCreateFieldInput>>;
  delete?: InputMaybe<Array<WaterIntakeUsersundefinedDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<WaterIntakeUsersundefinedDisconnectFieldInput>>;
  update?: InputMaybe<WaterIntakeUsersundefinedUpdateConnectionInput>;
  where?: InputMaybe<WaterIntakeUsersundefinedConnectionWhere>;
};

export type WaterIntakeWhere = {
  AND?: InputMaybe<Array<WaterIntakeWhere>>;
  NOT?: InputMaybe<WaterIntakeWhere>;
  OR?: InputMaybe<Array<WaterIntakeWhere>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  id_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  last_modified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  usersHasWaterIntakeAggregate?: InputMaybe<WaterIntakeUsersHasWaterIntakeAggregateInput>;
  /** Return WaterIntakes where all of the related WaterIntakeUsersHasWaterIntakeConnections match this filter */
  usersHasWaterIntakeConnection_ALL?: InputMaybe<WaterIntakeUsersHasWaterIntakeConnectionWhere>;
  /** Return WaterIntakes where none of the related WaterIntakeUsersHasWaterIntakeConnections match this filter */
  usersHasWaterIntakeConnection_NONE?: InputMaybe<WaterIntakeUsersHasWaterIntakeConnectionWhere>;
  /** Return WaterIntakes where one of the related WaterIntakeUsersHasWaterIntakeConnections match this filter */
  usersHasWaterIntakeConnection_SINGLE?: InputMaybe<WaterIntakeUsersHasWaterIntakeConnectionWhere>;
  /** Return WaterIntakes where some of the related WaterIntakeUsersHasWaterIntakeConnections match this filter */
  usersHasWaterIntakeConnection_SOME?: InputMaybe<WaterIntakeUsersHasWaterIntakeConnectionWhere>;
  /** Return WaterIntakes where all of the related Users match this filter */
  usersHasWaterIntake_ALL?: InputMaybe<UserWhere>;
  /** Return WaterIntakes where none of the related Users match this filter */
  usersHasWaterIntake_NONE?: InputMaybe<UserWhere>;
  /** Return WaterIntakes where one of the related Users match this filter */
  usersHasWaterIntake_SINGLE?: InputMaybe<UserWhere>;
  /** Return WaterIntakes where some of the related Users match this filter */
  usersHasWaterIntake_SOME?: InputMaybe<UserWhere>;
  usersundefinedAggregate?: InputMaybe<WaterIntakeUsersundefinedAggregateInput>;
  /** Return WaterIntakes where all of the related WaterIntakeUsersundefinedConnections match this filter */
  usersundefinedConnection_ALL?: InputMaybe<WaterIntakeUsersundefinedConnectionWhere>;
  /** Return WaterIntakes where none of the related WaterIntakeUsersundefinedConnections match this filter */
  usersundefinedConnection_NONE?: InputMaybe<WaterIntakeUsersundefinedConnectionWhere>;
  /** Return WaterIntakes where one of the related WaterIntakeUsersundefinedConnections match this filter */
  usersundefinedConnection_SINGLE?: InputMaybe<WaterIntakeUsersundefinedConnectionWhere>;
  /** Return WaterIntakes where some of the related WaterIntakeUsersundefinedConnections match this filter */
  usersundefinedConnection_SOME?: InputMaybe<WaterIntakeUsersundefinedConnectionWhere>;
  /** Return WaterIntakes where all of the related Users match this filter */
  usersundefined_ALL?: InputMaybe<UserWhere>;
  /** Return WaterIntakes where none of the related Users match this filter */
  usersundefined_NONE?: InputMaybe<UserWhere>;
  /** Return WaterIntakes where one of the related Users match this filter */
  usersundefined_SINGLE?: InputMaybe<UserWhere>;
  /** Return WaterIntakes where some of the related Users match this filter */
  usersundefined_SOME?: InputMaybe<UserWhere>;
  water_intake_oz?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_GT?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_GTE?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  water_intake_oz_LT?: InputMaybe<Scalars['Float']['input']>;
  water_intake_oz_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type Webhook = {
  __typename?: 'Webhook';
  events?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  tenant: Tenant;
  tenantAggregate?: Maybe<WebhookTenantTenantAggregationSelection>;
  tenantConnection: WebhookTenantConnection;
  url?: Maybe<Scalars['String']['output']>;
};


export type WebhookTenantArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TenantOptions>;
  where?: InputMaybe<TenantWhere>;
};


export type WebhookTenantAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TenantWhere>;
};


export type WebhookTenantConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<WebhookTenantConnectionSort>>;
  where?: InputMaybe<WebhookTenantConnectionWhere>;
};

export type WebhookConnectInput = {
  tenant?: InputMaybe<WebhookTenantConnectFieldInput>;
};

export type WebhookConnectOrCreateWhere = {
  node: WebhookUniqueWhere;
};

export type WebhookConnectWhere = {
  node: WebhookWhere;
};

export type WebhookCreateInput = {
  events?: InputMaybe<Array<Scalars['String']['input']>>;
  tenant?: InputMaybe<WebhookTenantFieldInput>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type WebhookDeleteInput = {
  tenant?: InputMaybe<WebhookTenantDeleteFieldInput>;
};

export type WebhookDisconnectInput = {
  tenant?: InputMaybe<WebhookTenantDisconnectFieldInput>;
};

export type WebhookOnCreateInput = {
  events?: InputMaybe<Array<Scalars['String']['input']>>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type WebhookOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more WebhookSort objects to sort Webhooks by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<WebhookSort>>;
};

/** Fields to sort Webhooks by. The order in which sorts are applied is not guaranteed when specifying many fields in one WebhookSort object. */
export type WebhookSort = {
  id?: InputMaybe<SortDirection>;
  url?: InputMaybe<SortDirection>;
};

export type WebhookTenantAggregateInput = {
  AND?: InputMaybe<Array<WebhookTenantAggregateInput>>;
  NOT?: InputMaybe<WebhookTenantAggregateInput>;
  OR?: InputMaybe<Array<WebhookTenantAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<WebhookTenantNodeAggregationWhereInput>;
};

export type WebhookTenantConnectFieldInput = {
  connect?: InputMaybe<TenantConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TenantConnectWhere>;
};

export type WebhookTenantConnectOrCreateFieldInput = {
  onCreate: WebhookTenantConnectOrCreateFieldInputOnCreate;
  where: TenantConnectOrCreateWhere;
};

export type WebhookTenantConnectOrCreateFieldInputOnCreate = {
  node: TenantOnCreateInput;
};

export type WebhookTenantConnection = {
  __typename?: 'WebhookTenantConnection';
  edges: Array<WebhookTenantRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WebhookTenantConnectionSort = {
  node?: InputMaybe<TenantSort>;
};

export type WebhookTenantConnectionWhere = {
  AND?: InputMaybe<Array<WebhookTenantConnectionWhere>>;
  NOT?: InputMaybe<WebhookTenantConnectionWhere>;
  OR?: InputMaybe<Array<WebhookTenantConnectionWhere>>;
  node?: InputMaybe<TenantWhere>;
};

export type WebhookTenantCreateFieldInput = {
  node: TenantCreateInput;
};

export type WebhookTenantDeleteFieldInput = {
  delete?: InputMaybe<TenantDeleteInput>;
  where?: InputMaybe<WebhookTenantConnectionWhere>;
};

export type WebhookTenantDisconnectFieldInput = {
  disconnect?: InputMaybe<TenantDisconnectInput>;
  where?: InputMaybe<WebhookTenantConnectionWhere>;
};

export type WebhookTenantFieldInput = {
  connect?: InputMaybe<WebhookTenantConnectFieldInput>;
  connectOrCreate?: InputMaybe<WebhookTenantConnectOrCreateFieldInput>;
  create?: InputMaybe<WebhookTenantCreateFieldInput>;
};

export type WebhookTenantNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<WebhookTenantNodeAggregationWhereInput>>;
  NOT?: InputMaybe<WebhookTenantNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<WebhookTenantNodeAggregationWhereInput>>;
  companionName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  companionName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  companionName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  companionName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  companionName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailBackgroundColor_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emailFooterColor_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emailFooterColor_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  emulationStatement_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  emulationStatement_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridDailyEmailTemplateId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridFromName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalSendGridTwilioServiceSID_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon16Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon16Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon32Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon32Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon48Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon48Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon180Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon180Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon192Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon192Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  favicon512Url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  favicon512Url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  faviconIcoUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  financialInformationUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  financialInformationUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuBg_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuBg_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuCardBg_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuProgress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuProgress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gameMenuTrack_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gameMenuTrack_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  generalPrompt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  generalPrompt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  helpCenterUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  helpCenterUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  key_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  key_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningEmulationStatement_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ltiLaunchUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  miniLogo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  miniLogo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newsSearchTerms_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newsSearchTerms_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  officialTranscriptsUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogDescription_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogDescription_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageHeight_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageHeight_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogImageWidth_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImageWidth_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogImage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogImage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogImage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogSiteName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogSiteName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogTitle_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogTitle_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ogType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ogType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ogType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  onboardingPrompt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  onboardingPrompt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  primaryColor_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  primaryColor_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  proLogo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  proLogo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  proLogo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  reportProblemUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportProblemUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scheduleAdvisorCallUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  schoolResourcesUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSecretKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSecretKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeTrialDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeTrialDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submitHelpTicketLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantDomain_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantDomain_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  termsOfServiceLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  upgradeModalBody_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  upgradeModalBody_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type WebhookTenantRelationship = {
  __typename?: 'WebhookTenantRelationship';
  cursor: Scalars['String']['output'];
  node: Tenant;
};

export type WebhookTenantTenantAggregationSelection = {
  __typename?: 'WebhookTenantTenantAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<WebhookTenantTenantNodeAggregateSelection>;
};

export type WebhookTenantTenantNodeAggregateSelection = {
  __typename?: 'WebhookTenantTenantNodeAggregateSelection';
  companionName: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  emailBackgroundColor: StringAggregateSelection;
  emailFooterColor: StringAggregateSelection;
  emulationStatement: StringAggregateSelection;
  externalSendGridDailyEmailTemplateId: StringAggregateSelection;
  externalSendGridFromEmail: StringAggregateSelection;
  externalSendGridFromName: StringAggregateSelection;
  externalSendGridTwilioServiceSID: StringAggregateSelection;
  favicon16Url: StringAggregateSelection;
  favicon32Url: StringAggregateSelection;
  favicon48Url: StringAggregateSelection;
  favicon180Url: StringAggregateSelection;
  favicon192Url: StringAggregateSelection;
  favicon512Url: StringAggregateSelection;
  faviconIcoUrl: StringAggregateSelection;
  financialInformationUrl: StringAggregateSelection;
  gameMenuBg: StringAggregateSelection;
  gameMenuCardBg: StringAggregateSelection;
  gameMenuProgress: StringAggregateSelection;
  gameMenuTrack: StringAggregateSelection;
  generalPrompt: StringAggregateSelection;
  helpCenterUrl: StringAggregateSelection;
  id: IdAggregateSelection;
  key: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  learningEmulationStatement: StringAggregateSelection;
  logo: StringAggregateSelection;
  ltiLaunchUrl: StringAggregateSelection;
  miniLogo: StringAggregateSelection;
  newsSearchTerms: StringAggregateSelection;
  officialTranscriptsUrl: StringAggregateSelection;
  ogDescription: StringAggregateSelection;
  ogImage: StringAggregateSelection;
  ogImageHeight: StringAggregateSelection;
  ogImageWidth: StringAggregateSelection;
  ogSiteName: StringAggregateSelection;
  ogTitle: StringAggregateSelection;
  ogType: StringAggregateSelection;
  onboardingPrompt: StringAggregateSelection;
  primaryColor: StringAggregateSelection;
  proLogo: StringAggregateSelection;
  reportProblemUrl: StringAggregateSelection;
  scheduleAdvisorCallUrl: StringAggregateSelection;
  schoolResourcesUrl: StringAggregateSelection;
  stripeSecretKey: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  stripeTrialDays: IntAggregateSelection;
  submitHelpTicketLink: StringAggregateSelection;
  tenantDomain: StringAggregateSelection;
  tenantName: StringAggregateSelection;
  termsOfServiceLink: StringAggregateSelection;
  upgradeModalBody: StringAggregateSelection;
};

export type WebhookTenantUpdateConnectionInput = {
  node?: InputMaybe<TenantUpdateInput>;
};

export type WebhookTenantUpdateFieldInput = {
  connect?: InputMaybe<WebhookTenantConnectFieldInput>;
  connectOrCreate?: InputMaybe<WebhookTenantConnectOrCreateFieldInput>;
  create?: InputMaybe<WebhookTenantCreateFieldInput>;
  delete?: InputMaybe<WebhookTenantDeleteFieldInput>;
  disconnect?: InputMaybe<WebhookTenantDisconnectFieldInput>;
  update?: InputMaybe<WebhookTenantUpdateConnectionInput>;
  where?: InputMaybe<WebhookTenantConnectionWhere>;
};

export type WebhookUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type WebhookUpdateInput = {
  events?: InputMaybe<Array<Scalars['String']['input']>>;
  events_POP?: InputMaybe<Scalars['Int']['input']>;
  events_PUSH?: InputMaybe<Array<Scalars['String']['input']>>;
  tenant?: InputMaybe<WebhookTenantUpdateFieldInput>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type WebhookWhere = {
  AND?: InputMaybe<Array<WebhookWhere>>;
  NOT?: InputMaybe<WebhookWhere>;
  OR?: InputMaybe<Array<WebhookWhere>>;
  events?: InputMaybe<Array<Scalars['String']['input']>>;
  events_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  tenant?: InputMaybe<TenantWhere>;
  tenantAggregate?: InputMaybe<WebhookTenantAggregateInput>;
  tenantConnection?: InputMaybe<WebhookTenantConnectionWhere>;
  tenantConnection_NOT?: InputMaybe<WebhookTenantConnectionWhere>;
  tenant_NOT?: InputMaybe<TenantWhere>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type WeeklySummary = {
  __typename?: 'WeeklySummary';
  created: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  isArchived: Scalars['Boolean']['output'];
  last_modified: Scalars['DateTime']['output'];
  summary: Scalars['String']['output'];
  usersHasSummary: Array<User>;
  usersHasSummaryAggregate?: Maybe<WeeklySummaryUserUsersHasSummaryAggregationSelection>;
  usersHasSummaryConnection: WeeklySummaryUsersHasSummaryConnection;
};


export type WeeklySummaryUsersHasSummaryArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type WeeklySummaryUsersHasSummaryAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type WeeklySummaryUsersHasSummaryConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<WeeklySummaryUsersHasSummaryConnectionSort>>;
  where?: InputMaybe<WeeklySummaryUsersHasSummaryConnectionWhere>;
};

export type WeeklySummaryConnectInput = {
  usersHasSummary?: InputMaybe<Array<WeeklySummaryUsersHasSummaryConnectFieldInput>>;
};

export type WeeklySummaryConnectWhere = {
  node: WeeklySummaryWhere;
};

export type WeeklySummaryCreateInput = {
  created: Scalars['DateTime']['input'];
  date: Scalars['DateTime']['input'];
  isArchived: Scalars['Boolean']['input'];
  last_modified: Scalars['DateTime']['input'];
  summary: Scalars['String']['input'];
  usersHasSummary?: InputMaybe<WeeklySummaryUsersHasSummaryFieldInput>;
};

export type WeeklySummaryDeleteInput = {
  usersHasSummary?: InputMaybe<Array<WeeklySummaryUsersHasSummaryDeleteFieldInput>>;
};

export type WeeklySummaryDisconnectInput = {
  usersHasSummary?: InputMaybe<Array<WeeklySummaryUsersHasSummaryDisconnectFieldInput>>;
};

export type WeeklySummaryOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more WeeklySummarySort objects to sort WeeklySummaries by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<WeeklySummarySort>>;
};

/** Fields to sort WeeklySummaries by. The order in which sorts are applied is not guaranteed when specifying many fields in one WeeklySummarySort object. */
export type WeeklySummarySort = {
  created?: InputMaybe<SortDirection>;
  date?: InputMaybe<SortDirection>;
  isArchived?: InputMaybe<SortDirection>;
  last_modified?: InputMaybe<SortDirection>;
  summary?: InputMaybe<SortDirection>;
};

export type WeeklySummaryUpdateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  usersHasSummary?: InputMaybe<Array<WeeklySummaryUsersHasSummaryUpdateFieldInput>>;
};

export type WeeklySummaryUserUsersHasSummaryAggregationSelection = {
  __typename?: 'WeeklySummaryUserUsersHasSummaryAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<WeeklySummaryUserUsersHasSummaryNodeAggregateSelection>;
};

export type WeeklySummaryUserUsersHasSummaryNodeAggregateSelection = {
  __typename?: 'WeeklySummaryUserUsersHasSummaryNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type WeeklySummaryUsersHasSummaryAggregateInput = {
  AND?: InputMaybe<Array<WeeklySummaryUsersHasSummaryAggregateInput>>;
  NOT?: InputMaybe<WeeklySummaryUsersHasSummaryAggregateInput>;
  OR?: InputMaybe<Array<WeeklySummaryUsersHasSummaryAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<WeeklySummaryUsersHasSummaryNodeAggregationWhereInput>;
};

export type WeeklySummaryUsersHasSummaryConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type WeeklySummaryUsersHasSummaryConnectOrCreateFieldInput = {
  onCreate: WeeklySummaryUsersHasSummaryConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type WeeklySummaryUsersHasSummaryConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type WeeklySummaryUsersHasSummaryConnection = {
  __typename?: 'WeeklySummaryUsersHasSummaryConnection';
  edges: Array<WeeklySummaryUsersHasSummaryRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WeeklySummaryUsersHasSummaryConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type WeeklySummaryUsersHasSummaryConnectionWhere = {
  AND?: InputMaybe<Array<WeeklySummaryUsersHasSummaryConnectionWhere>>;
  NOT?: InputMaybe<WeeklySummaryUsersHasSummaryConnectionWhere>;
  OR?: InputMaybe<Array<WeeklySummaryUsersHasSummaryConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type WeeklySummaryUsersHasSummaryCreateFieldInput = {
  node: UserCreateInput;
};

export type WeeklySummaryUsersHasSummaryDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<WeeklySummaryUsersHasSummaryConnectionWhere>;
};

export type WeeklySummaryUsersHasSummaryDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<WeeklySummaryUsersHasSummaryConnectionWhere>;
};

export type WeeklySummaryUsersHasSummaryFieldInput = {
  connect?: InputMaybe<Array<WeeklySummaryUsersHasSummaryConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<WeeklySummaryUsersHasSummaryConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<WeeklySummaryUsersHasSummaryCreateFieldInput>>;
};

export type WeeklySummaryUsersHasSummaryNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<WeeklySummaryUsersHasSummaryNodeAggregationWhereInput>>;
  NOT?: InputMaybe<WeeklySummaryUsersHasSummaryNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<WeeklySummaryUsersHasSummaryNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type WeeklySummaryUsersHasSummaryRelationship = {
  __typename?: 'WeeklySummaryUsersHasSummaryRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type WeeklySummaryUsersHasSummaryUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type WeeklySummaryUsersHasSummaryUpdateFieldInput = {
  connect?: InputMaybe<Array<WeeklySummaryUsersHasSummaryConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<WeeklySummaryUsersHasSummaryConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<WeeklySummaryUsersHasSummaryCreateFieldInput>>;
  delete?: InputMaybe<Array<WeeklySummaryUsersHasSummaryDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<WeeklySummaryUsersHasSummaryDisconnectFieldInput>>;
  update?: InputMaybe<WeeklySummaryUsersHasSummaryUpdateConnectionInput>;
  where?: InputMaybe<WeeklySummaryUsersHasSummaryConnectionWhere>;
};

export type WeeklySummaryWhere = {
  AND?: InputMaybe<Array<WeeklySummaryWhere>>;
  NOT?: InputMaybe<WeeklySummaryWhere>;
  OR?: InputMaybe<Array<WeeklySummaryWhere>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  date_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  date_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  last_modified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  summary_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  summary_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  summary_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  summary_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  usersHasSummaryAggregate?: InputMaybe<WeeklySummaryUsersHasSummaryAggregateInput>;
  /** Return WeeklySummaries where all of the related WeeklySummaryUsersHasSummaryConnections match this filter */
  usersHasSummaryConnection_ALL?: InputMaybe<WeeklySummaryUsersHasSummaryConnectionWhere>;
  /** Return WeeklySummaries where none of the related WeeklySummaryUsersHasSummaryConnections match this filter */
  usersHasSummaryConnection_NONE?: InputMaybe<WeeklySummaryUsersHasSummaryConnectionWhere>;
  /** Return WeeklySummaries where one of the related WeeklySummaryUsersHasSummaryConnections match this filter */
  usersHasSummaryConnection_SINGLE?: InputMaybe<WeeklySummaryUsersHasSummaryConnectionWhere>;
  /** Return WeeklySummaries where some of the related WeeklySummaryUsersHasSummaryConnections match this filter */
  usersHasSummaryConnection_SOME?: InputMaybe<WeeklySummaryUsersHasSummaryConnectionWhere>;
  /** Return WeeklySummaries where all of the related Users match this filter */
  usersHasSummary_ALL?: InputMaybe<UserWhere>;
  /** Return WeeklySummaries where none of the related Users match this filter */
  usersHasSummary_NONE?: InputMaybe<UserWhere>;
  /** Return WeeklySummaries where one of the related Users match this filter */
  usersHasSummary_SINGLE?: InputMaybe<UserWhere>;
  /** Return WeeklySummaries where some of the related Users match this filter */
  usersHasSummary_SOME?: InputMaybe<UserWhere>;
};

export type WhitelistedEmail = {
  __typename?: 'WhitelistedEmail';
  email: Scalars['String']['output'];
  invitee: User;
  inviteeAggregate?: Maybe<WhitelistedEmailUserInviteeAggregationSelection>;
  inviteeConnection: WhitelistedEmailInviteeConnection;
};


export type WhitelistedEmailInviteeArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type WhitelistedEmailInviteeAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type WhitelistedEmailInviteeConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<WhitelistedEmailInviteeConnectionSort>>;
  where?: InputMaybe<WhitelistedEmailInviteeConnectionWhere>;
};

export type WhitelistedEmailConnectInput = {
  invitee?: InputMaybe<WhitelistedEmailInviteeConnectFieldInput>;
};

export type WhitelistedEmailConnectWhere = {
  node: WhitelistedEmailWhere;
};

export type WhitelistedEmailCreateInput = {
  email: Scalars['String']['input'];
  invitee?: InputMaybe<WhitelistedEmailInviteeFieldInput>;
};

export type WhitelistedEmailDeleteInput = {
  invitee?: InputMaybe<WhitelistedEmailInviteeDeleteFieldInput>;
};

export type WhitelistedEmailDisconnectInput = {
  invitee?: InputMaybe<WhitelistedEmailInviteeDisconnectFieldInput>;
};

export type WhitelistedEmailInviteeAggregateInput = {
  AND?: InputMaybe<Array<WhitelistedEmailInviteeAggregateInput>>;
  NOT?: InputMaybe<WhitelistedEmailInviteeAggregateInput>;
  OR?: InputMaybe<Array<WhitelistedEmailInviteeAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<WhitelistedEmailInviteeNodeAggregationWhereInput>;
};

export type WhitelistedEmailInviteeConnectFieldInput = {
  connect?: InputMaybe<UserConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type WhitelistedEmailInviteeConnectOrCreateFieldInput = {
  onCreate: WhitelistedEmailInviteeConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type WhitelistedEmailInviteeConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type WhitelistedEmailInviteeConnection = {
  __typename?: 'WhitelistedEmailInviteeConnection';
  edges: Array<WhitelistedEmailInviteeRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WhitelistedEmailInviteeConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type WhitelistedEmailInviteeConnectionWhere = {
  AND?: InputMaybe<Array<WhitelistedEmailInviteeConnectionWhere>>;
  NOT?: InputMaybe<WhitelistedEmailInviteeConnectionWhere>;
  OR?: InputMaybe<Array<WhitelistedEmailInviteeConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type WhitelistedEmailInviteeCreateFieldInput = {
  node: UserCreateInput;
};

export type WhitelistedEmailInviteeDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<WhitelistedEmailInviteeConnectionWhere>;
};

export type WhitelistedEmailInviteeDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<WhitelistedEmailInviteeConnectionWhere>;
};

export type WhitelistedEmailInviteeFieldInput = {
  connect?: InputMaybe<WhitelistedEmailInviteeConnectFieldInput>;
  connectOrCreate?: InputMaybe<WhitelistedEmailInviteeConnectOrCreateFieldInput>;
  create?: InputMaybe<WhitelistedEmailInviteeCreateFieldInput>;
};

export type WhitelistedEmailInviteeNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<WhitelistedEmailInviteeNodeAggregationWhereInput>>;
  NOT?: InputMaybe<WhitelistedEmailInviteeNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<WhitelistedEmailInviteeNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type WhitelistedEmailInviteeRelationship = {
  __typename?: 'WhitelistedEmailInviteeRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type WhitelistedEmailInviteeUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type WhitelistedEmailInviteeUpdateFieldInput = {
  connect?: InputMaybe<WhitelistedEmailInviteeConnectFieldInput>;
  connectOrCreate?: InputMaybe<WhitelistedEmailInviteeConnectOrCreateFieldInput>;
  create?: InputMaybe<WhitelistedEmailInviteeCreateFieldInput>;
  delete?: InputMaybe<WhitelistedEmailInviteeDeleteFieldInput>;
  disconnect?: InputMaybe<WhitelistedEmailInviteeDisconnectFieldInput>;
  update?: InputMaybe<WhitelistedEmailInviteeUpdateConnectionInput>;
  where?: InputMaybe<WhitelistedEmailInviteeConnectionWhere>;
};

export type WhitelistedEmailOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more WhitelistedEmailSort objects to sort WhitelistedEmails by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<WhitelistedEmailSort>>;
};

/** Fields to sort WhitelistedEmails by. The order in which sorts are applied is not guaranteed when specifying many fields in one WhitelistedEmailSort object. */
export type WhitelistedEmailSort = {
  email?: InputMaybe<SortDirection>;
};

export type WhitelistedEmailUpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  invitee?: InputMaybe<WhitelistedEmailInviteeUpdateFieldInput>;
};

export type WhitelistedEmailUserInviteeAggregationSelection = {
  __typename?: 'WhitelistedEmailUserInviteeAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<WhitelistedEmailUserInviteeNodeAggregateSelection>;
};

export type WhitelistedEmailUserInviteeNodeAggregateSelection = {
  __typename?: 'WhitelistedEmailUserInviteeNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type WhitelistedEmailWhere = {
  AND?: InputMaybe<Array<WhitelistedEmailWhere>>;
  NOT?: InputMaybe<WhitelistedEmailWhere>;
  OR?: InputMaybe<Array<WhitelistedEmailWhere>>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  email_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  email_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  email_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  invitee?: InputMaybe<UserWhere>;
  inviteeAggregate?: InputMaybe<WhitelistedEmailInviteeAggregateInput>;
  inviteeConnection?: InputMaybe<WhitelistedEmailInviteeConnectionWhere>;
  inviteeConnection_NOT?: InputMaybe<WhitelistedEmailInviteeConnectionWhere>;
  invitee_NOT?: InputMaybe<UserWhere>;
};

export type Worksheet = {
  __typename?: 'Worksheet';
  assignment?: Maybe<Assignment>;
  assignmentAggregate?: Maybe<WorksheetAssignmentAssignmentAggregationSelection>;
  assignmentConnection: WorksheetAssignmentConnection;
  coverage: Scalars['String']['output'];
  created?: Maybe<Scalars['DateTime']['output']>;
  files: Array<File>;
  filesAggregate?: Maybe<WorksheetFileFilesAggregationSelection>;
  filesConnection: WorksheetFilesConnection;
  generationStatus?: Maybe<WorksheetGenerationStatus>;
  id: Scalars['ID']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  numQuestions: Scalars['Int']['output'];
  questions: Array<Question>;
  questionsAggregate?: Maybe<WorksheetQuestionQuestionsAggregationSelection>;
  questionsConnection: WorksheetQuestionsConnection;
  title: Scalars['String']['output'];
};


export type WorksheetAssignmentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AssignmentOptions>;
  where?: InputMaybe<AssignmentWhere>;
};


export type WorksheetAssignmentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssignmentWhere>;
};


export type WorksheetAssignmentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<WorksheetAssignmentConnectionSort>>;
  where?: InputMaybe<WorksheetAssignmentConnectionWhere>;
};


export type WorksheetFilesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FileOptions>;
  where?: InputMaybe<FileWhere>;
};


export type WorksheetFilesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FileWhere>;
};


export type WorksheetFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<WorksheetFilesConnectionSort>>;
  where?: InputMaybe<WorksheetFilesConnectionWhere>;
};


export type WorksheetQuestionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QuestionOptions>;
  where?: InputMaybe<QuestionWhere>;
};


export type WorksheetQuestionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QuestionWhere>;
};


export type WorksheetQuestionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<WorksheetQuestionsConnectionSort>>;
  where?: InputMaybe<WorksheetQuestionsConnectionWhere>;
};

export type WorksheetAssignmentAggregateInput = {
  AND?: InputMaybe<Array<WorksheetAssignmentAggregateInput>>;
  NOT?: InputMaybe<WorksheetAssignmentAggregateInput>;
  OR?: InputMaybe<Array<WorksheetAssignmentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<WorksheetAssignmentNodeAggregationWhereInput>;
};

export type WorksheetAssignmentAssignmentAggregationSelection = {
  __typename?: 'WorksheetAssignmentAssignmentAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<WorksheetAssignmentAssignmentNodeAggregateSelection>;
};

export type WorksheetAssignmentAssignmentNodeAggregateSelection = {
  __typename?: 'WorksheetAssignmentAssignmentNodeAggregateSelection';
  _empty: StringAggregateSelection;
  allowed_attempts: FloatAggregateSelection;
  assignee_mode: StringAggregateSelection;
  assignment_group_id: FloatAggregateSelection;
  assignment_name: StringAggregateSelection;
  body: StringAggregateSelection;
  category_id: StringAggregateSelection;
  course_id: FloatAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  description: StringAggregateSelection;
  description_plaintext: StringAggregateSelection;
  discussion_topic_assignment_id: FloatAggregateSelection;
  discussion_topic_author_anonymous_id: StringAggregateSelection;
  discussion_topic_author_avatar_image_url: StringAggregateSelection;
  discussion_topic_author_display_name: StringAggregateSelection;
  discussion_topic_author_html_url: StringAggregateSelection;
  discussion_topic_author_id: FloatAggregateSelection;
  discussion_topic_created_at: StringAggregateSelection;
  discussion_topic_discussion_subentry_count: FloatAggregateSelection;
  discussion_topic_discussion_type: StringAggregateSelection;
  discussion_topic_html_url: StringAggregateSelection;
  discussion_topic_id: FloatAggregateSelection;
  discussion_topic_last_reply_at: StringAggregateSelection;
  discussion_topic_message: StringAggregateSelection;
  discussion_topic_posted_at: StringAggregateSelection;
  discussion_topic_read_state: StringAggregateSelection;
  discussion_topic_title: StringAggregateSelection;
  discussion_topic_unread_count: FloatAggregateSelection;
  discussion_topic_url: StringAggregateSelection;
  discussion_topic_user_name: StringAggregateSelection;
  display_date: StringAggregateSelection;
  due_at: StringAggregateSelection;
  due_date: DateTimeAggregateSelection;
  end_date: StringAggregateSelection;
  external_tool_tag_attributes_content_id: FloatAggregateSelection;
  external_tool_tag_attributes_content_type: StringAggregateSelection;
  external_tool_tag_attributes_external_data: StringAggregateSelection;
  external_tool_tag_attributes_resource_link_id: StringAggregateSelection;
  external_tool_tag_attributes_url: StringAggregateSelection;
  grade_points: FloatAggregateSelection;
  grader_count: FloatAggregateSelection;
  grading_type: StringAggregateSelection;
  html: StringAggregateSelection;
  html_url: StringAggregateSelection;
  id: IdAggregateSelection;
  lastModified: DateTimeAggregateSelection;
  lti_context_id: StringAggregateSelection;
  max_attempts: FloatAggregateSelection;
  max_name_length: FloatAggregateSelection;
  name: StringAggregateSelection;
  needs_grading_count: FloatAggregateSelection;
  objectives: StringAggregateSelection;
  points_possible: FloatAggregateSelection;
  position: FloatAggregateSelection;
  resource_metadata: StringAggregateSelection;
  scheduledDate: DateTimeAggregateSelection;
  secure_params: StringAggregateSelection;
  session_id: StringAggregateSelection;
  start_date: StringAggregateSelection;
  state: StringAggregateSelection;
  submissions_download_url: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_at: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  url: StringAggregateSelection;
  videoUrl: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export type WorksheetAssignmentConnectFieldInput = {
  connect?: InputMaybe<AssignmentConnectInput>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<AssignmentConnectWhere>;
};

export type WorksheetAssignmentConnectOrCreateFieldInput = {
  onCreate: WorksheetAssignmentConnectOrCreateFieldInputOnCreate;
  where: AssignmentConnectOrCreateWhere;
};

export type WorksheetAssignmentConnectOrCreateFieldInputOnCreate = {
  node: AssignmentOnCreateInput;
};

export type WorksheetAssignmentConnection = {
  __typename?: 'WorksheetAssignmentConnection';
  edges: Array<WorksheetAssignmentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WorksheetAssignmentConnectionSort = {
  node?: InputMaybe<AssignmentSort>;
};

export type WorksheetAssignmentConnectionWhere = {
  AND?: InputMaybe<Array<WorksheetAssignmentConnectionWhere>>;
  NOT?: InputMaybe<WorksheetAssignmentConnectionWhere>;
  OR?: InputMaybe<Array<WorksheetAssignmentConnectionWhere>>;
  node?: InputMaybe<AssignmentWhere>;
};

export type WorksheetAssignmentCreateFieldInput = {
  node: AssignmentCreateInput;
};

export type WorksheetAssignmentDeleteFieldInput = {
  delete?: InputMaybe<AssignmentDeleteInput>;
  where?: InputMaybe<WorksheetAssignmentConnectionWhere>;
};

export type WorksheetAssignmentDisconnectFieldInput = {
  disconnect?: InputMaybe<AssignmentDisconnectInput>;
  where?: InputMaybe<WorksheetAssignmentConnectionWhere>;
};

export type WorksheetAssignmentFieldInput = {
  connect?: InputMaybe<WorksheetAssignmentConnectFieldInput>;
  connectOrCreate?: InputMaybe<WorksheetAssignmentConnectOrCreateFieldInput>;
  create?: InputMaybe<WorksheetAssignmentCreateFieldInput>;
};

export type WorksheetAssignmentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<WorksheetAssignmentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<WorksheetAssignmentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<WorksheetAssignmentNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  allowed_attempts_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  allowed_attempts_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignee_mode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignee_mode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_group_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_group_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  assignment_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  assignment_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  body_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  body_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  body_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  category_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  category_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  category_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  category_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_plaintext_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_plaintext_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_assignment_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_assignment_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_anonymous_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_avatar_image_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_display_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_author_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_author_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_subentry_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_discussion_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_last_reply_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_message_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_message_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_posted_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_read_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_unread_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_unread_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  discussion_topic_user_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  display_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  display_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  display_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  display_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  due_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  due_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  due_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  due_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  due_date_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  due_date_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_content_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_external_data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_resource_link_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  external_tool_tag_attributes_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grade_points_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grade_points_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grader_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  grading_type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  html_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  html_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  html_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  html_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  html_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastModified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lti_context_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_context_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_context_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  max_attempts_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  max_attempts_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  max_name_length_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  needs_grading_count_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  needs_grading_count_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  objectives_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  objectives_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  objectives_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  objectives_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  points_possible_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  points_possible_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  position_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  position_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  resource_metadata_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  resource_metadata_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scheduledDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  secure_params_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  secure_params_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  secure_params_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  secure_params_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  session_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  session_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  session_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  session_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  submissions_download_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  submissions_download_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  videoUrl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  videoUrl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetAssignmentRelationship = {
  __typename?: 'WorksheetAssignmentRelationship';
  cursor: Scalars['String']['output'];
  node: Assignment;
};

export type WorksheetAssignmentUpdateConnectionInput = {
  node?: InputMaybe<AssignmentUpdateInput>;
};

export type WorksheetAssignmentUpdateFieldInput = {
  connect?: InputMaybe<WorksheetAssignmentConnectFieldInput>;
  connectOrCreate?: InputMaybe<WorksheetAssignmentConnectOrCreateFieldInput>;
  create?: InputMaybe<WorksheetAssignmentCreateFieldInput>;
  delete?: InputMaybe<WorksheetAssignmentDeleteFieldInput>;
  disconnect?: InputMaybe<WorksheetAssignmentDisconnectFieldInput>;
  update?: InputMaybe<WorksheetAssignmentUpdateConnectionInput>;
  where?: InputMaybe<WorksheetAssignmentConnectionWhere>;
};

export type WorksheetConnectInput = {
  assignment?: InputMaybe<WorksheetAssignmentConnectFieldInput>;
  files?: InputMaybe<Array<WorksheetFilesConnectFieldInput>>;
  questions?: InputMaybe<Array<WorksheetQuestionsConnectFieldInput>>;
};

export type WorksheetConnectOrCreateWhere = {
  node: WorksheetUniqueWhere;
};

export type WorksheetConnectWhere = {
  node: WorksheetWhere;
};

export type WorksheetCreateInput = {
  assignment?: InputMaybe<WorksheetAssignmentFieldInput>;
  coverage: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  files?: InputMaybe<WorksheetFilesFieldInput>;
  generationStatus?: InputMaybe<WorksheetGenerationStatus>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  numQuestions: Scalars['Int']['input'];
  questions?: InputMaybe<WorksheetQuestionsFieldInput>;
  title: Scalars['String']['input'];
};

export type WorksheetDeleteInput = {
  assignment?: InputMaybe<WorksheetAssignmentDeleteFieldInput>;
  files?: InputMaybe<Array<WorksheetFilesDeleteFieldInput>>;
  questions?: InputMaybe<Array<WorksheetQuestionsDeleteFieldInput>>;
};

export type WorksheetDisconnectInput = {
  assignment?: InputMaybe<WorksheetAssignmentDisconnectFieldInput>;
  files?: InputMaybe<Array<WorksheetFilesDisconnectFieldInput>>;
  questions?: InputMaybe<Array<WorksheetQuestionsDisconnectFieldInput>>;
};

export type WorksheetFileFilesAggregationSelection = {
  __typename?: 'WorksheetFileFilesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<WorksheetFileFilesNodeAggregateSelection>;
};

export type WorksheetFileFilesNodeAggregateSelection = {
  __typename?: 'WorksheetFileFilesNodeAggregateSelection';
  bucketName: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  fileName: StringAggregateSelection;
  filePath: StringAggregateSelection;
  fileURL: StringAggregateSelection;
  id: IdAggregateSelection;
};

export type WorksheetFilesAggregateInput = {
  AND?: InputMaybe<Array<WorksheetFilesAggregateInput>>;
  NOT?: InputMaybe<WorksheetFilesAggregateInput>;
  OR?: InputMaybe<Array<WorksheetFilesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<WorksheetFilesNodeAggregationWhereInput>;
};

export type WorksheetFilesConnectFieldInput = {
  connect?: InputMaybe<Array<FileConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<FileConnectWhere>;
};

export type WorksheetFilesConnectOrCreateFieldInput = {
  onCreate: WorksheetFilesConnectOrCreateFieldInputOnCreate;
  where: FileConnectOrCreateWhere;
};

export type WorksheetFilesConnectOrCreateFieldInputOnCreate = {
  node: FileOnCreateInput;
};

export type WorksheetFilesConnection = {
  __typename?: 'WorksheetFilesConnection';
  edges: Array<WorksheetFilesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WorksheetFilesConnectionSort = {
  node?: InputMaybe<FileSort>;
};

export type WorksheetFilesConnectionWhere = {
  AND?: InputMaybe<Array<WorksheetFilesConnectionWhere>>;
  NOT?: InputMaybe<WorksheetFilesConnectionWhere>;
  OR?: InputMaybe<Array<WorksheetFilesConnectionWhere>>;
  node?: InputMaybe<FileWhere>;
};

export type WorksheetFilesCreateFieldInput = {
  node: FileCreateInput;
};

export type WorksheetFilesDeleteFieldInput = {
  delete?: InputMaybe<FileDeleteInput>;
  where?: InputMaybe<WorksheetFilesConnectionWhere>;
};

export type WorksheetFilesDisconnectFieldInput = {
  disconnect?: InputMaybe<FileDisconnectInput>;
  where?: InputMaybe<WorksheetFilesConnectionWhere>;
};

export type WorksheetFilesFieldInput = {
  connect?: InputMaybe<Array<WorksheetFilesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<WorksheetFilesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<WorksheetFilesCreateFieldInput>>;
};

export type WorksheetFilesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<WorksheetFilesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<WorksheetFilesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<WorksheetFilesNodeAggregationWhereInput>>;
  bucketName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  bucketName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  bucketName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  bucketName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  fileName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fileURL_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fileURL_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fileURL_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type WorksheetFilesRelationship = {
  __typename?: 'WorksheetFilesRelationship';
  cursor: Scalars['String']['output'];
  node: File;
};

export type WorksheetFilesUpdateConnectionInput = {
  node?: InputMaybe<FileUpdateInput>;
};

export type WorksheetFilesUpdateFieldInput = {
  connect?: InputMaybe<Array<WorksheetFilesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<WorksheetFilesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<WorksheetFilesCreateFieldInput>>;
  delete?: InputMaybe<Array<WorksheetFilesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<WorksheetFilesDisconnectFieldInput>>;
  update?: InputMaybe<WorksheetFilesUpdateConnectionInput>;
  where?: InputMaybe<WorksheetFilesConnectionWhere>;
};

export enum WorksheetGenerationStatus {
  Completed = 'completed',
  Failed = 'failed',
  Processing = 'processing'
}

export type WorksheetOnCreateInput = {
  coverage: Scalars['String']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  generationStatus?: InputMaybe<WorksheetGenerationStatus>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  numQuestions: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type WorksheetOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more WorksheetSort objects to sort Worksheets by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<WorksheetSort>>;
};

export type WorksheetQuestionQuestionsAggregationSelection = {
  __typename?: 'WorksheetQuestionQuestionsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<WorksheetQuestionQuestionsNodeAggregateSelection>;
};

export type WorksheetQuestionQuestionsNodeAggregateSelection = {
  __typename?: 'WorksheetQuestionQuestionsNodeAggregateSelection';
  id: IdAggregateSelection;
  question: StringAggregateSelection;
  totalScore: FloatAggregateSelection;
};

export type WorksheetQuestionsAggregateInput = {
  AND?: InputMaybe<Array<WorksheetQuestionsAggregateInput>>;
  NOT?: InputMaybe<WorksheetQuestionsAggregateInput>;
  OR?: InputMaybe<Array<WorksheetQuestionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<WorksheetQuestionsNodeAggregationWhereInput>;
};

export type WorksheetQuestionsConnectFieldInput = {
  connect?: InputMaybe<Array<QuestionConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<QuestionConnectWhere>;
};

export type WorksheetQuestionsConnectOrCreateFieldInput = {
  onCreate: WorksheetQuestionsConnectOrCreateFieldInputOnCreate;
  where: QuestionConnectOrCreateWhere;
};

export type WorksheetQuestionsConnectOrCreateFieldInputOnCreate = {
  node: QuestionOnCreateInput;
};

export type WorksheetQuestionsConnection = {
  __typename?: 'WorksheetQuestionsConnection';
  edges: Array<WorksheetQuestionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WorksheetQuestionsConnectionSort = {
  node?: InputMaybe<QuestionSort>;
};

export type WorksheetQuestionsConnectionWhere = {
  AND?: InputMaybe<Array<WorksheetQuestionsConnectionWhere>>;
  NOT?: InputMaybe<WorksheetQuestionsConnectionWhere>;
  OR?: InputMaybe<Array<WorksheetQuestionsConnectionWhere>>;
  node?: InputMaybe<QuestionWhere>;
};

export type WorksheetQuestionsCreateFieldInput = {
  node: QuestionCreateInput;
};

export type WorksheetQuestionsDeleteFieldInput = {
  delete?: InputMaybe<QuestionDeleteInput>;
  where?: InputMaybe<WorksheetQuestionsConnectionWhere>;
};

export type WorksheetQuestionsDisconnectFieldInput = {
  disconnect?: InputMaybe<QuestionDisconnectInput>;
  where?: InputMaybe<WorksheetQuestionsConnectionWhere>;
};

export type WorksheetQuestionsFieldInput = {
  connect?: InputMaybe<Array<WorksheetQuestionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<WorksheetQuestionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<WorksheetQuestionsCreateFieldInput>>;
};

export type WorksheetQuestionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<WorksheetQuestionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<WorksheetQuestionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<WorksheetQuestionsNodeAggregationWhereInput>>;
  question_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  question_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  question_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  question_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  question_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalScore_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalScore_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type WorksheetQuestionsRelationship = {
  __typename?: 'WorksheetQuestionsRelationship';
  cursor: Scalars['String']['output'];
  node: Question;
};

export type WorksheetQuestionsUpdateConnectionInput = {
  node?: InputMaybe<QuestionUpdateInput>;
};

export type WorksheetQuestionsUpdateFieldInput = {
  connect?: InputMaybe<Array<WorksheetQuestionsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<WorksheetQuestionsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<WorksheetQuestionsCreateFieldInput>>;
  delete?: InputMaybe<Array<WorksheetQuestionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<WorksheetQuestionsDisconnectFieldInput>>;
  update?: InputMaybe<WorksheetQuestionsUpdateConnectionInput>;
  where?: InputMaybe<WorksheetQuestionsConnectionWhere>;
};

export type WorksheetResponse = {
  __typename?: 'WorksheetResponse';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<WorksheetResponseData>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type WorksheetResponseData = {
  __typename?: 'WorksheetResponseData';
  generationStatus?: Maybe<WorksheetGenerationStatus>;
  pdfUrl: Scalars['String']['output'];
  worksheetId: Scalars['ID']['output'];
};

/** Fields to sort Worksheets by. The order in which sorts are applied is not guaranteed when specifying many fields in one WorksheetSort object. */
export type WorksheetSort = {
  coverage?: InputMaybe<SortDirection>;
  created?: InputMaybe<SortDirection>;
  generationStatus?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  instructions?: InputMaybe<SortDirection>;
  lastModified?: InputMaybe<SortDirection>;
  numQuestions?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
};

export type WorksheetUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type WorksheetUpdateInput = {
  assignment?: InputMaybe<WorksheetAssignmentUpdateFieldInput>;
  coverage?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  files?: InputMaybe<Array<WorksheetFilesUpdateFieldInput>>;
  generationStatus?: InputMaybe<WorksheetGenerationStatus>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  numQuestions?: InputMaybe<Scalars['Int']['input']>;
  numQuestions_DECREMENT?: InputMaybe<Scalars['Int']['input']>;
  numQuestions_INCREMENT?: InputMaybe<Scalars['Int']['input']>;
  questions?: InputMaybe<Array<WorksheetQuestionsUpdateFieldInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type WorksheetWhere = {
  AND?: InputMaybe<Array<WorksheetWhere>>;
  NOT?: InputMaybe<WorksheetWhere>;
  OR?: InputMaybe<Array<WorksheetWhere>>;
  assignment?: InputMaybe<AssignmentWhere>;
  assignmentAggregate?: InputMaybe<WorksheetAssignmentAggregateInput>;
  assignmentConnection?: InputMaybe<WorksheetAssignmentConnectionWhere>;
  assignmentConnection_NOT?: InputMaybe<WorksheetAssignmentConnectionWhere>;
  assignment_NOT?: InputMaybe<AssignmentWhere>;
  coverage?: InputMaybe<Scalars['String']['input']>;
  coverage_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  coverage_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  coverage_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  coverage_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  filesAggregate?: InputMaybe<WorksheetFilesAggregateInput>;
  /** Return Worksheets where all of the related WorksheetFilesConnections match this filter */
  filesConnection_ALL?: InputMaybe<WorksheetFilesConnectionWhere>;
  /** Return Worksheets where none of the related WorksheetFilesConnections match this filter */
  filesConnection_NONE?: InputMaybe<WorksheetFilesConnectionWhere>;
  /** Return Worksheets where one of the related WorksheetFilesConnections match this filter */
  filesConnection_SINGLE?: InputMaybe<WorksheetFilesConnectionWhere>;
  /** Return Worksheets where some of the related WorksheetFilesConnections match this filter */
  filesConnection_SOME?: InputMaybe<WorksheetFilesConnectionWhere>;
  /** Return Worksheets where all of the related Files match this filter */
  files_ALL?: InputMaybe<FileWhere>;
  /** Return Worksheets where none of the related Files match this filter */
  files_NONE?: InputMaybe<FileWhere>;
  /** Return Worksheets where one of the related Files match this filter */
  files_SINGLE?: InputMaybe<FileWhere>;
  /** Return Worksheets where some of the related Files match this filter */
  files_SOME?: InputMaybe<FileWhere>;
  generationStatus?: InputMaybe<WorksheetGenerationStatus>;
  generationStatus_IN?: InputMaybe<Array<InputMaybe<WorksheetGenerationStatus>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  instructions_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  instructions_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  instructions_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  instructions_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastModified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  numQuestions?: InputMaybe<Scalars['Int']['input']>;
  numQuestions_GT?: InputMaybe<Scalars['Int']['input']>;
  numQuestions_GTE?: InputMaybe<Scalars['Int']['input']>;
  numQuestions_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  numQuestions_LT?: InputMaybe<Scalars['Int']['input']>;
  numQuestions_LTE?: InputMaybe<Scalars['Int']['input']>;
  questionsAggregate?: InputMaybe<WorksheetQuestionsAggregateInput>;
  /** Return Worksheets where all of the related WorksheetQuestionsConnections match this filter */
  questionsConnection_ALL?: InputMaybe<WorksheetQuestionsConnectionWhere>;
  /** Return Worksheets where none of the related WorksheetQuestionsConnections match this filter */
  questionsConnection_NONE?: InputMaybe<WorksheetQuestionsConnectionWhere>;
  /** Return Worksheets where one of the related WorksheetQuestionsConnections match this filter */
  questionsConnection_SINGLE?: InputMaybe<WorksheetQuestionsConnectionWhere>;
  /** Return Worksheets where some of the related WorksheetQuestionsConnections match this filter */
  questionsConnection_SOME?: InputMaybe<WorksheetQuestionsConnectionWhere>;
  /** Return Worksheets where all of the related Questions match this filter */
  questions_ALL?: InputMaybe<QuestionWhere>;
  /** Return Worksheets where none of the related Questions match this filter */
  questions_NONE?: InputMaybe<QuestionWhere>;
  /** Return Worksheets where one of the related Questions match this filter */
  questions_SINGLE?: InputMaybe<QuestionWhere>;
  /** Return Worksheets where some of the related Questions match this filter */
  questions_SOME?: InputMaybe<QuestionWhere>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type Workspace = {
  __typename?: 'Workspace';
  chats: Array<Chat>;
  chatsAggregate?: Maybe<WorkspaceChatChatsAggregationSelection>;
  chatsConnection: WorkspaceChatsConnection;
  courses: Array<Course>;
  coursesAggregate?: Maybe<WorkspaceCourseCoursesAggregationSelection>;
  coursesConnection: WorkspaceCoursesConnection;
  created?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  schools: Array<School>;
  schoolsAggregate?: Maybe<WorkspaceSchoolSchoolsAggregationSelection>;
  schoolsConnection: WorkspaceSchoolsConnection;
  todos: Array<Todo>;
  todosAggregate?: Maybe<WorkspaceTodoTodosAggregationSelection>;
  todosConnection: WorkspaceTodosConnection;
  type?: Maybe<WorkspaceType>;
  usersHasWorkspace: Array<User>;
  usersHasWorkspaceAggregate?: Maybe<WorkspaceUserUsersHasWorkspaceAggregationSelection>;
  usersHasWorkspaceConnection: WorkspaceUsersHasWorkspaceConnection;
};


export type WorkspaceChatsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ChatOptions>;
  where?: InputMaybe<ChatWhere>;
};


export type WorkspaceChatsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ChatWhere>;
};


export type WorkspaceChatsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<WorkspaceChatsConnectionSort>>;
  where?: InputMaybe<WorkspaceChatsConnectionWhere>;
};


export type WorkspaceCoursesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CourseOptions>;
  where?: InputMaybe<CourseWhere>;
};


export type WorkspaceCoursesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CourseWhere>;
};


export type WorkspaceCoursesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<WorkspaceCoursesConnectionSort>>;
  where?: InputMaybe<WorkspaceCoursesConnectionWhere>;
};


export type WorkspaceSchoolsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SchoolOptions>;
  where?: InputMaybe<SchoolWhere>;
};


export type WorkspaceSchoolsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SchoolWhere>;
};


export type WorkspaceSchoolsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<WorkspaceSchoolsConnectionSort>>;
  where?: InputMaybe<WorkspaceSchoolsConnectionWhere>;
};


export type WorkspaceTodosArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TodoOptions>;
  where?: InputMaybe<TodoWhere>;
};


export type WorkspaceTodosAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TodoWhere>;
};


export type WorkspaceTodosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<WorkspaceTodosConnectionSort>>;
  where?: InputMaybe<WorkspaceTodosConnectionWhere>;
};


export type WorkspaceUsersHasWorkspaceArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type WorkspaceUsersHasWorkspaceAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type WorkspaceUsersHasWorkspaceConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<WorkspaceUsersHasWorkspaceConnectionSort>>;
  where?: InputMaybe<WorkspaceUsersHasWorkspaceConnectionWhere>;
};

export type WorkspaceChatChatsAggregationSelection = {
  __typename?: 'WorkspaceChatChatsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<WorkspaceChatChatsNodeAggregateSelection>;
};

export type WorkspaceChatChatsNodeAggregateSelection = {
  __typename?: 'WorkspaceChatChatsNodeAggregateSelection';
  context: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  date: DateTimeAggregateSelection;
  id: IdAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  name: StringAggregateSelection;
  objectId: IdAggregateSelection;
  schemaVersion: IntAggregateSelection;
  timezone: StringAggregateSelection;
  url: StringAggregateSelection;
};

export type WorkspaceChatsAggregateInput = {
  AND?: InputMaybe<Array<WorkspaceChatsAggregateInput>>;
  NOT?: InputMaybe<WorkspaceChatsAggregateInput>;
  OR?: InputMaybe<Array<WorkspaceChatsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<WorkspaceChatsNodeAggregationWhereInput>;
};

export type WorkspaceChatsConnectFieldInput = {
  connect?: InputMaybe<Array<ChatConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<ChatConnectWhere>;
};

export type WorkspaceChatsConnectOrCreateFieldInput = {
  onCreate: WorkspaceChatsConnectOrCreateFieldInputOnCreate;
  where: ChatConnectOrCreateWhere;
};

export type WorkspaceChatsConnectOrCreateFieldInputOnCreate = {
  node: ChatOnCreateInput;
};

export type WorkspaceChatsConnection = {
  __typename?: 'WorkspaceChatsConnection';
  edges: Array<WorkspaceChatsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WorkspaceChatsConnectionSort = {
  node?: InputMaybe<ChatSort>;
};

export type WorkspaceChatsConnectionWhere = {
  AND?: InputMaybe<Array<WorkspaceChatsConnectionWhere>>;
  NOT?: InputMaybe<WorkspaceChatsConnectionWhere>;
  OR?: InputMaybe<Array<WorkspaceChatsConnectionWhere>>;
  node?: InputMaybe<ChatWhere>;
};

export type WorkspaceChatsCreateFieldInput = {
  node: ChatCreateInput;
};

export type WorkspaceChatsDeleteFieldInput = {
  delete?: InputMaybe<ChatDeleteInput>;
  where?: InputMaybe<WorkspaceChatsConnectionWhere>;
};

export type WorkspaceChatsDisconnectFieldInput = {
  disconnect?: InputMaybe<ChatDisconnectInput>;
  where?: InputMaybe<WorkspaceChatsConnectionWhere>;
};

export type WorkspaceChatsFieldInput = {
  connect?: InputMaybe<Array<WorkspaceChatsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<WorkspaceChatsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<WorkspaceChatsCreateFieldInput>>;
};

export type WorkspaceChatsGroup = {
  __typename?: 'WorkspaceChatsGroup';
  chats: Array<UserChatsResponse>;
  created?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

export type WorkspaceChatsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<WorkspaceChatsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<WorkspaceChatsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<WorkspaceChatsNodeAggregationWhereInput>>;
  context_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  context_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  context_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  context_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  schemaVersion_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  schemaVersion_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  schemaVersion_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  schemaVersion_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  schemaVersion_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  schemaVersion_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkspaceChatsRelationship = {
  __typename?: 'WorkspaceChatsRelationship';
  cursor: Scalars['String']['output'];
  node: Chat;
};

export type WorkspaceChatsUpdateConnectionInput = {
  node?: InputMaybe<ChatUpdateInput>;
};

export type WorkspaceChatsUpdateFieldInput = {
  connect?: InputMaybe<Array<WorkspaceChatsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<WorkspaceChatsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<WorkspaceChatsCreateFieldInput>>;
  delete?: InputMaybe<Array<WorkspaceChatsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<WorkspaceChatsDisconnectFieldInput>>;
  update?: InputMaybe<WorkspaceChatsUpdateConnectionInput>;
  where?: InputMaybe<WorkspaceChatsConnectionWhere>;
};

export type WorkspaceConnectInput = {
  chats?: InputMaybe<Array<WorkspaceChatsConnectFieldInput>>;
  courses?: InputMaybe<Array<WorkspaceCoursesConnectFieldInput>>;
  schools?: InputMaybe<Array<WorkspaceSchoolsConnectFieldInput>>;
  todos?: InputMaybe<Array<WorkspaceTodosConnectFieldInput>>;
  usersHasWorkspace?: InputMaybe<Array<WorkspaceUsersHasWorkspaceConnectFieldInput>>;
};

export type WorkspaceConnectOrCreateWhere = {
  node: WorkspaceUniqueWhere;
};

export type WorkspaceConnectWhere = {
  node: WorkspaceWhere;
};

export type WorkspaceCourseCoursesAggregationSelection = {
  __typename?: 'WorkspaceCourseCoursesAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<WorkspaceCourseCoursesNodeAggregateSelection>;
};

export type WorkspaceCourseCoursesNodeAggregateSelection = {
  __typename?: 'WorkspaceCourseCoursesNodeAggregateSelection';
  account_id: FloatAggregateSelection;
  calendar_ics: StringAggregateSelection;
  cost: FloatAggregateSelection;
  courseId: StringAggregateSelection;
  course_code: StringAggregateSelection;
  course_id: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  created_at: StringAggregateSelection;
  created_date: StringAggregateSelection;
  default_view: StringAggregateSelection;
  description: StringAggregateSelection;
  dueDateEndDate: DateTimeAggregateSelection;
  dueDateStartDate: DateTimeAggregateSelection;
  endDate: DateTimeAggregateSelection;
  end_at: StringAggregateSelection;
  enrollment_term_id: FloatAggregateSelection;
  grading_standard_id: FloatAggregateSelection;
  id: IdAggregateSelection;
  integration_id: StringAggregateSelection;
  label: StringAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  learningStandards: StringAggregateSelection;
  lengthInWeeks: FloatAggregateSelection;
  license: StringAggregateSelection;
  lti_id: StringAggregateSelection;
  name: StringAggregateSelection;
  original_name: StringAggregateSelection;
  root_account_id: FloatAggregateSelection;
  sis_course_id: StringAggregateSelection;
  sis_import_id: FloatAggregateSelection;
  startDate: DateTimeAggregateSelection;
  start_at: StringAggregateSelection;
  state: StringAggregateSelection;
  storage_quota_mb: FloatAggregateSelection;
  stripePriceId: StringAggregateSelection;
  stripeProductId: StringAggregateSelection;
  targetAudience: StringAggregateSelection;
  thumbnail: StringAggregateSelection;
  time_zone: StringAggregateSelection;
  title: StringAggregateSelection;
  updated_date: StringAggregateSelection;
  uuid: StringAggregateSelection;
  workflow_state: StringAggregateSelection;
};

export type WorkspaceCoursesAggregateInput = {
  AND?: InputMaybe<Array<WorkspaceCoursesAggregateInput>>;
  NOT?: InputMaybe<WorkspaceCoursesAggregateInput>;
  OR?: InputMaybe<Array<WorkspaceCoursesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<WorkspaceCoursesNodeAggregationWhereInput>;
};

export type WorkspaceCoursesConnectFieldInput = {
  connect?: InputMaybe<Array<CourseConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<CourseConnectWhere>;
};

export type WorkspaceCoursesConnectOrCreateFieldInput = {
  onCreate: WorkspaceCoursesConnectOrCreateFieldInputOnCreate;
  where: CourseConnectOrCreateWhere;
};

export type WorkspaceCoursesConnectOrCreateFieldInputOnCreate = {
  node: CourseOnCreateInput;
};

export type WorkspaceCoursesConnection = {
  __typename?: 'WorkspaceCoursesConnection';
  edges: Array<WorkspaceCoursesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WorkspaceCoursesConnectionSort = {
  node?: InputMaybe<CourseSort>;
};

export type WorkspaceCoursesConnectionWhere = {
  AND?: InputMaybe<Array<WorkspaceCoursesConnectionWhere>>;
  NOT?: InputMaybe<WorkspaceCoursesConnectionWhere>;
  OR?: InputMaybe<Array<WorkspaceCoursesConnectionWhere>>;
  node?: InputMaybe<CourseWhere>;
};

export type WorkspaceCoursesCreateFieldInput = {
  node: CourseCreateInput;
};

export type WorkspaceCoursesDeleteFieldInput = {
  delete?: InputMaybe<CourseDeleteInput>;
  where?: InputMaybe<WorkspaceCoursesConnectionWhere>;
};

export type WorkspaceCoursesDisconnectFieldInput = {
  disconnect?: InputMaybe<CourseDisconnectInput>;
  where?: InputMaybe<WorkspaceCoursesConnectionWhere>;
};

export type WorkspaceCoursesFieldInput = {
  connect?: InputMaybe<Array<WorkspaceCoursesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<WorkspaceCoursesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<WorkspaceCoursesCreateFieldInput>>;
};

export type WorkspaceCoursesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<WorkspaceCoursesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<WorkspaceCoursesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<WorkspaceCoursesNodeAggregationWhereInput>>;
  account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  calendar_ics_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  calendar_ics_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  cost_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  cost_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  courseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  courseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  courseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  created_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  created_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  created_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  default_view_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  default_view_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  default_view_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dueDateEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  dueDateStartDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  endDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  end_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  end_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  end_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  end_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  enrollment_term_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  enrollment_term_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  grading_standard_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  integration_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  integration_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  integration_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  label_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  label_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  label_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  learningStandards_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  learningStandards_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  learningStandards_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthInWeeks_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthInWeeks_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  license_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  license_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  license_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lti_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lti_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lti_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  original_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  original_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  original_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  root_account_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  root_account_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_course_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sis_course_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sis_import_id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  sis_import_id_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  startDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  start_at_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  start_at_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  start_at_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  start_at_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  storage_quota_mb_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  storage_quota_mb_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripePriceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeProductId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeProductId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  targetAudience_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  targetAudience_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  thumbnail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  thumbnail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  time_zone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  time_zone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  time_zone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  updated_date_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  updated_date_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  updated_date_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  workflow_state_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  workflow_state_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkspaceCoursesRelationship = {
  __typename?: 'WorkspaceCoursesRelationship';
  cursor: Scalars['String']['output'];
  node: Course;
};

export type WorkspaceCoursesUpdateConnectionInput = {
  node?: InputMaybe<CourseUpdateInput>;
};

export type WorkspaceCoursesUpdateFieldInput = {
  connect?: InputMaybe<Array<WorkspaceCoursesConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<WorkspaceCoursesConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<WorkspaceCoursesCreateFieldInput>>;
  delete?: InputMaybe<Array<WorkspaceCoursesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<WorkspaceCoursesDisconnectFieldInput>>;
  update?: InputMaybe<WorkspaceCoursesUpdateConnectionInput>;
  where?: InputMaybe<WorkspaceCoursesConnectionWhere>;
};

export type WorkspaceCreateInput = {
  chats?: InputMaybe<WorkspaceChatsFieldInput>;
  courses?: InputMaybe<WorkspaceCoursesFieldInput>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  key: Scalars['String']['input'];
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  schools?: InputMaybe<WorkspaceSchoolsFieldInput>;
  todos?: InputMaybe<WorkspaceTodosFieldInput>;
  type?: InputMaybe<WorkspaceType>;
  usersHasWorkspace?: InputMaybe<WorkspaceUsersHasWorkspaceFieldInput>;
};

export type WorkspaceDeleteInput = {
  chats?: InputMaybe<Array<WorkspaceChatsDeleteFieldInput>>;
  courses?: InputMaybe<Array<WorkspaceCoursesDeleteFieldInput>>;
  schools?: InputMaybe<Array<WorkspaceSchoolsDeleteFieldInput>>;
  todos?: InputMaybe<Array<WorkspaceTodosDeleteFieldInput>>;
  usersHasWorkspace?: InputMaybe<Array<WorkspaceUsersHasWorkspaceDeleteFieldInput>>;
};

export type WorkspaceDisconnectInput = {
  chats?: InputMaybe<Array<WorkspaceChatsDisconnectFieldInput>>;
  courses?: InputMaybe<Array<WorkspaceCoursesDisconnectFieldInput>>;
  schools?: InputMaybe<Array<WorkspaceSchoolsDisconnectFieldInput>>;
  todos?: InputMaybe<Array<WorkspaceTodosDisconnectFieldInput>>;
  usersHasWorkspace?: InputMaybe<Array<WorkspaceUsersHasWorkspaceDisconnectFieldInput>>;
};

export type WorkspaceOnCreateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  key: Scalars['String']['input'];
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  type?: InputMaybe<WorkspaceType>;
};

export type WorkspaceOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more WorkspaceSort objects to sort Workspaces by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<WorkspaceSort>>;
};

export type WorkspaceSchoolSchoolsAggregationSelection = {
  __typename?: 'WorkspaceSchoolSchoolsAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<WorkspaceSchoolSchoolsNodeAggregateSelection>;
};

export type WorkspaceSchoolSchoolsNodeAggregateSelection = {
  __typename?: 'WorkspaceSchoolSchoolsNodeAggregateSelection';
  brightspace_api_client_id: StringAggregateSelection;
  brightspace_api_client_secret: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  domain: StringAggregateSelection;
  id: IdAggregateSelection;
  provider_icon_url: StringAggregateSelection;
  provider_name: StringAggregateSelection;
  team_name: StringAggregateSelection;
  updatedAt: DateTimeAggregateSelection;
};

export type WorkspaceSchoolsAggregateInput = {
  AND?: InputMaybe<Array<WorkspaceSchoolsAggregateInput>>;
  NOT?: InputMaybe<WorkspaceSchoolsAggregateInput>;
  OR?: InputMaybe<Array<WorkspaceSchoolsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<WorkspaceSchoolsNodeAggregationWhereInput>;
};

export type WorkspaceSchoolsConnectFieldInput = {
  connect?: InputMaybe<Array<SchoolConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<SchoolConnectWhere>;
};

export type WorkspaceSchoolsConnectOrCreateFieldInput = {
  onCreate: WorkspaceSchoolsConnectOrCreateFieldInputOnCreate;
  where: SchoolConnectOrCreateWhere;
};

export type WorkspaceSchoolsConnectOrCreateFieldInputOnCreate = {
  node: SchoolOnCreateInput;
};

export type WorkspaceSchoolsConnection = {
  __typename?: 'WorkspaceSchoolsConnection';
  edges: Array<WorkspaceSchoolsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WorkspaceSchoolsConnectionSort = {
  node?: InputMaybe<SchoolSort>;
};

export type WorkspaceSchoolsConnectionWhere = {
  AND?: InputMaybe<Array<WorkspaceSchoolsConnectionWhere>>;
  NOT?: InputMaybe<WorkspaceSchoolsConnectionWhere>;
  OR?: InputMaybe<Array<WorkspaceSchoolsConnectionWhere>>;
  node?: InputMaybe<SchoolWhere>;
};

export type WorkspaceSchoolsCreateFieldInput = {
  node: SchoolCreateInput;
};

export type WorkspaceSchoolsDeleteFieldInput = {
  delete?: InputMaybe<SchoolDeleteInput>;
  where?: InputMaybe<WorkspaceSchoolsConnectionWhere>;
};

export type WorkspaceSchoolsDisconnectFieldInput = {
  disconnect?: InputMaybe<SchoolDisconnectInput>;
  where?: InputMaybe<WorkspaceSchoolsConnectionWhere>;
};

export type WorkspaceSchoolsFieldInput = {
  connect?: InputMaybe<Array<WorkspaceSchoolsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<WorkspaceSchoolsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<WorkspaceSchoolsCreateFieldInput>>;
};

export type WorkspaceSchoolsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<WorkspaceSchoolsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<WorkspaceSchoolsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<WorkspaceSchoolsNodeAggregationWhereInput>>;
  brightspace_api_client_id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_secret_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_secret_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_secret_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_secret_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  brightspace_api_client_secret_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  brightspace_api_client_secret_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  domain_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domain_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domain_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domain_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domain_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  provider_icon_url_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  provider_icon_url_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  provider_icon_url_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  provider_icon_url_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  provider_icon_url_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  provider_icon_url_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  provider_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  provider_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  provider_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  provider_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  provider_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  provider_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  provider_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  provider_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  provider_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  provider_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  provider_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  provider_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  provider_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  provider_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  provider_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  team_name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  team_name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  team_name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  team_name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  team_name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  team_name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  team_name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  team_name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  team_name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  team_name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  team_name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  team_name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  team_name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  team_name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  team_name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type WorkspaceSchoolsRelationship = {
  __typename?: 'WorkspaceSchoolsRelationship';
  cursor: Scalars['String']['output'];
  node: School;
};

export type WorkspaceSchoolsUpdateConnectionInput = {
  node?: InputMaybe<SchoolUpdateInput>;
};

export type WorkspaceSchoolsUpdateFieldInput = {
  connect?: InputMaybe<Array<WorkspaceSchoolsConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<WorkspaceSchoolsConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<WorkspaceSchoolsCreateFieldInput>>;
  delete?: InputMaybe<Array<WorkspaceSchoolsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<WorkspaceSchoolsDisconnectFieldInput>>;
  update?: InputMaybe<WorkspaceSchoolsUpdateConnectionInput>;
  where?: InputMaybe<WorkspaceSchoolsConnectionWhere>;
};

/** Fields to sort Workspaces by. The order in which sorts are applied is not guaranteed when specifying many fields in one WorkspaceSort object. */
export type WorkspaceSort = {
  created?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  key?: InputMaybe<SortDirection>;
  lastModified?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export type WorkspaceTodoTodosAggregationSelection = {
  __typename?: 'WorkspaceTodoTodosAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<WorkspaceTodoTodosNodeAggregateSelection>;
};

export type WorkspaceTodoTodosNodeAggregateSelection = {
  __typename?: 'WorkspaceTodoTodosNodeAggregateSelection';
  aiSummary: StringAggregateSelection;
  completed_date: DateTimeAggregateSelection;
  created: DateTimeAggregateSelection;
  date: DateTimeAggregateSelection;
  description: StringAggregateSelection;
  id: IdAggregateSelection;
  last_modified: DateTimeAggregateSelection;
  name: StringAggregateSelection;
  pointsReceived: IntAggregateSelection;
  priority: StringAggregateSelection;
  recurringDayOfMonth: IntAggregateSelection;
  recurringDayOfWeek: StringAggregateSelection;
  recurringFrequency: StringAggregateSelection;
  recurringTime: StringAggregateSelection;
  timeOfDay: StringAggregateSelection;
  timezone: StringAggregateSelection;
};

export type WorkspaceTodosAggregateInput = {
  AND?: InputMaybe<Array<WorkspaceTodosAggregateInput>>;
  NOT?: InputMaybe<WorkspaceTodosAggregateInput>;
  OR?: InputMaybe<Array<WorkspaceTodosAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<WorkspaceTodosNodeAggregationWhereInput>;
};

export type WorkspaceTodosConnectFieldInput = {
  connect?: InputMaybe<Array<TodoConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<TodoConnectWhere>;
};

export type WorkspaceTodosConnectOrCreateFieldInput = {
  onCreate: WorkspaceTodosConnectOrCreateFieldInputOnCreate;
  where: TodoConnectOrCreateWhere;
};

export type WorkspaceTodosConnectOrCreateFieldInputOnCreate = {
  node: TodoOnCreateInput;
};

export type WorkspaceTodosConnection = {
  __typename?: 'WorkspaceTodosConnection';
  edges: Array<WorkspaceTodosRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WorkspaceTodosConnectionSort = {
  node?: InputMaybe<TodoSort>;
};

export type WorkspaceTodosConnectionWhere = {
  AND?: InputMaybe<Array<WorkspaceTodosConnectionWhere>>;
  NOT?: InputMaybe<WorkspaceTodosConnectionWhere>;
  OR?: InputMaybe<Array<WorkspaceTodosConnectionWhere>>;
  node?: InputMaybe<TodoWhere>;
};

export type WorkspaceTodosCreateFieldInput = {
  node: TodoCreateInput;
};

export type WorkspaceTodosDeleteFieldInput = {
  delete?: InputMaybe<TodoDeleteInput>;
  where?: InputMaybe<WorkspaceTodosConnectionWhere>;
};

export type WorkspaceTodosDisconnectFieldInput = {
  disconnect?: InputMaybe<TodoDisconnectInput>;
  where?: InputMaybe<WorkspaceTodosConnectionWhere>;
};

export type WorkspaceTodosFieldInput = {
  connect?: InputMaybe<Array<WorkspaceTodosConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<WorkspaceTodosConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<WorkspaceTodosCreateFieldInput>>;
};

export type WorkspaceTodosNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<WorkspaceTodosNodeAggregationWhereInput>>;
  NOT?: InputMaybe<WorkspaceTodosNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<WorkspaceTodosNodeAggregationWhereInput>>;
  aiSummary_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aiSummary_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  aiSummary_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  aiSummary_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  aiSummary_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  aiSummary_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aiSummary_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aiSummary_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aiSummary_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aiSummary_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aiSummary_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aiSummary_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  aiSummary_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  aiSummary_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  aiSummary_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  completed_date_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completed_date_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completed_date_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completed_date_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completed_date_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  completed_date_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completed_date_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completed_date_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completed_date_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completed_date_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  last_modified_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pointsReceived_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  pointsReceived_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  pointsReceived_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  pointsReceived_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  pointsReceived_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  pointsReceived_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  priority_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  priority_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  priority_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  priority_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  priority_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  priority_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  priority_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  priority_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  priority_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  priority_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  priority_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  priority_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  priority_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  priority_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  priority_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  recurringDayOfMonth_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  recurringDayOfMonth_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  recurringDayOfMonth_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  recurringDayOfMonth_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  recurringDayOfMonth_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfMonth_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  recurringDayOfWeek_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  recurringDayOfWeek_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  recurringDayOfWeek_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  recurringDayOfWeek_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  recurringDayOfWeek_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  recurringDayOfWeek_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  recurringFrequency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  recurringFrequency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  recurringFrequency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  recurringFrequency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  recurringFrequency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  recurringFrequency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recurringFrequency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  recurringFrequency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  recurringFrequency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  recurringFrequency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  recurringFrequency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recurringFrequency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  recurringFrequency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  recurringFrequency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  recurringFrequency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  recurringTime_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  recurringTime_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  recurringTime_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  recurringTime_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  recurringTime_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  recurringTime_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recurringTime_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  recurringTime_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  recurringTime_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  recurringTime_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  recurringTime_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recurringTime_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  recurringTime_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  recurringTime_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  recurringTime_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeOfDay_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timeOfDay_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeOfDay_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timeOfDay_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeOfDay_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timeOfDay_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timezone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timezone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timezone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkspaceTodosRelationship = {
  __typename?: 'WorkspaceTodosRelationship';
  cursor: Scalars['String']['output'];
  node: Todo;
};

export type WorkspaceTodosUpdateConnectionInput = {
  node?: InputMaybe<TodoUpdateInput>;
};

export type WorkspaceTodosUpdateFieldInput = {
  connect?: InputMaybe<Array<WorkspaceTodosConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<WorkspaceTodosConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<WorkspaceTodosCreateFieldInput>>;
  delete?: InputMaybe<Array<WorkspaceTodosDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<WorkspaceTodosDisconnectFieldInput>>;
  update?: InputMaybe<WorkspaceTodosUpdateConnectionInput>;
  where?: InputMaybe<WorkspaceTodosConnectionWhere>;
};

export enum WorkspaceType {
  Course = 'course',
  Support = 'support'
}

export type WorkspaceUniqueWhere = {
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};

export type WorkspaceUpdateInput = {
  chats?: InputMaybe<Array<WorkspaceChatsUpdateFieldInput>>;
  courses?: InputMaybe<Array<WorkspaceCoursesUpdateFieldInput>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  schools?: InputMaybe<Array<WorkspaceSchoolsUpdateFieldInput>>;
  todos?: InputMaybe<Array<WorkspaceTodosUpdateFieldInput>>;
  type?: InputMaybe<WorkspaceType>;
  usersHasWorkspace?: InputMaybe<Array<WorkspaceUsersHasWorkspaceUpdateFieldInput>>;
};

export type WorkspaceUserUsersHasWorkspaceAggregationSelection = {
  __typename?: 'WorkspaceUserUsersHasWorkspaceAggregationSelection';
  count: Scalars['Int']['output'];
  node?: Maybe<WorkspaceUserUsersHasWorkspaceNodeAggregateSelection>;
};

export type WorkspaceUserUsersHasWorkspaceNodeAggregateSelection = {
  __typename?: 'WorkspaceUserUsersHasWorkspaceNodeAggregateSelection';
  _empty: StringAggregateSelection;
  biography: StringAggregateSelection;
  birthday: DateTimeAggregateSelection;
  countryCode: StringAggregateSelection;
  created: DateTimeAggregateSelection;
  crmUserId: StringAggregateSelection;
  currentWeightLbs: FloatAggregateSelection;
  email: StringAggregateSelection;
  fullPhoneNumber: StringAggregateSelection;
  gender: StringAggregateSelection;
  goalWeightLbs: FloatAggregateSelection;
  googleAuthTokens: StringAggregateSelection;
  googleCalendarAuthToken: StringAggregateSelection;
  id: IdAggregateSelection;
  invitationToken: StringAggregateSelection;
  invitationTokenExpiry: DateTimeAggregateSelection;
  inviteCount: IntAggregateSelection;
  meetingLink: StringAggregateSelection;
  modalOnboarding: StringAggregateSelection;
  name: StringAggregateSelection;
  otpPreference: StringAggregateSelection;
  password: StringAggregateSelection;
  passwordResetToken: StringAggregateSelection;
  passwordResetTokenExpiry: DateTimeAggregateSelection;
  pendingEmail: StringAggregateSelection;
  phoneNumber: StringAggregateSelection;
  profilePicture: StringAggregateSelection;
  ssoId: StringAggregateSelection;
  stripeCustomerId: StringAggregateSelection;
  stripeCustomerIdLearningPayments: StringAggregateSelection;
  stripeSubscriptionId: StringAggregateSelection;
  trialEndDate: DateTimeAggregateSelection;
  username: StringAggregateSelection;
};

export type WorkspaceUsersHasWorkspaceAggregateInput = {
  AND?: InputMaybe<Array<WorkspaceUsersHasWorkspaceAggregateInput>>;
  NOT?: InputMaybe<WorkspaceUsersHasWorkspaceAggregateInput>;
  OR?: InputMaybe<Array<WorkspaceUsersHasWorkspaceAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<WorkspaceUsersHasWorkspaceNodeAggregationWhereInput>;
};

export type WorkspaceUsersHasWorkspaceConnectFieldInput = {
  connect?: InputMaybe<Array<UserConnectInput>>;
  /** Whether or not to overwrite any matching relationship with the new properties. */
  overwrite?: Scalars['Boolean']['input'];
  where?: InputMaybe<UserConnectWhere>;
};

export type WorkspaceUsersHasWorkspaceConnectOrCreateFieldInput = {
  onCreate: WorkspaceUsersHasWorkspaceConnectOrCreateFieldInputOnCreate;
  where: UserConnectOrCreateWhere;
};

export type WorkspaceUsersHasWorkspaceConnectOrCreateFieldInputOnCreate = {
  node: UserOnCreateInput;
};

export type WorkspaceUsersHasWorkspaceConnection = {
  __typename?: 'WorkspaceUsersHasWorkspaceConnection';
  edges: Array<WorkspaceUsersHasWorkspaceRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WorkspaceUsersHasWorkspaceConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type WorkspaceUsersHasWorkspaceConnectionWhere = {
  AND?: InputMaybe<Array<WorkspaceUsersHasWorkspaceConnectionWhere>>;
  NOT?: InputMaybe<WorkspaceUsersHasWorkspaceConnectionWhere>;
  OR?: InputMaybe<Array<WorkspaceUsersHasWorkspaceConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type WorkspaceUsersHasWorkspaceCreateFieldInput = {
  node: UserCreateInput;
};

export type WorkspaceUsersHasWorkspaceDeleteFieldInput = {
  delete?: InputMaybe<UserDeleteInput>;
  where?: InputMaybe<WorkspaceUsersHasWorkspaceConnectionWhere>;
};

export type WorkspaceUsersHasWorkspaceDisconnectFieldInput = {
  disconnect?: InputMaybe<UserDisconnectInput>;
  where?: InputMaybe<WorkspaceUsersHasWorkspaceConnectionWhere>;
};

export type WorkspaceUsersHasWorkspaceFieldInput = {
  connect?: InputMaybe<Array<WorkspaceUsersHasWorkspaceConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<WorkspaceUsersHasWorkspaceConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<WorkspaceUsersHasWorkspaceCreateFieldInput>>;
};

export type WorkspaceUsersHasWorkspaceNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<WorkspaceUsersHasWorkspaceNodeAggregationWhereInput>>;
  NOT?: InputMaybe<WorkspaceUsersHasWorkspaceNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<WorkspaceUsersHasWorkspaceNodeAggregationWhereInput>>;
  _empty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  _empty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  _empty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  _empty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  biography_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  biography_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  biography_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  birthday_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  countryCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  created_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  crmUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  crmUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  crmUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  currentWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fullPhoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  gender_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  gender_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  gender_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  goalWeightLbs_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  goalWeightLbs_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleAuthTokens_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleAuthTokens_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  googleCalendarAuthToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  invitationTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  invitationToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invitationToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invitationToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  inviteCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  inviteCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  meetingLink_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  meetingLink_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  modalOnboarding_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  modalOnboarding_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  otpPreference_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  otpPreference_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetTokenExpiry_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetTokenExpiry_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  passwordResetToken_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  passwordResetToken_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  passwordResetToken_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  password_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  password_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  password_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pendingEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pendingEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  profilePicture_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  profilePicture_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ssoId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ssoId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ssoId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerIdLearningPayments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeCustomerId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeCustomerId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  stripeSubscriptionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  trialEndDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  trialEndDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  username_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  username_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  username_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  username_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkspaceUsersHasWorkspaceRelationship = {
  __typename?: 'WorkspaceUsersHasWorkspaceRelationship';
  cursor: Scalars['String']['output'];
  node: User;
};

export type WorkspaceUsersHasWorkspaceUpdateConnectionInput = {
  node?: InputMaybe<UserUpdateInput>;
};

export type WorkspaceUsersHasWorkspaceUpdateFieldInput = {
  connect?: InputMaybe<Array<WorkspaceUsersHasWorkspaceConnectFieldInput>>;
  connectOrCreate?: InputMaybe<Array<WorkspaceUsersHasWorkspaceConnectOrCreateFieldInput>>;
  create?: InputMaybe<Array<WorkspaceUsersHasWorkspaceCreateFieldInput>>;
  delete?: InputMaybe<Array<WorkspaceUsersHasWorkspaceDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<WorkspaceUsersHasWorkspaceDisconnectFieldInput>>;
  update?: InputMaybe<WorkspaceUsersHasWorkspaceUpdateConnectionInput>;
  where?: InputMaybe<WorkspaceUsersHasWorkspaceConnectionWhere>;
};

export type WorkspaceWhere = {
  AND?: InputMaybe<Array<WorkspaceWhere>>;
  NOT?: InputMaybe<WorkspaceWhere>;
  OR?: InputMaybe<Array<WorkspaceWhere>>;
  chatsAggregate?: InputMaybe<WorkspaceChatsAggregateInput>;
  /** Return Workspaces where all of the related WorkspaceChatsConnections match this filter */
  chatsConnection_ALL?: InputMaybe<WorkspaceChatsConnectionWhere>;
  /** Return Workspaces where none of the related WorkspaceChatsConnections match this filter */
  chatsConnection_NONE?: InputMaybe<WorkspaceChatsConnectionWhere>;
  /** Return Workspaces where one of the related WorkspaceChatsConnections match this filter */
  chatsConnection_SINGLE?: InputMaybe<WorkspaceChatsConnectionWhere>;
  /** Return Workspaces where some of the related WorkspaceChatsConnections match this filter */
  chatsConnection_SOME?: InputMaybe<WorkspaceChatsConnectionWhere>;
  /** Return Workspaces where all of the related Chats match this filter */
  chats_ALL?: InputMaybe<ChatWhere>;
  /** Return Workspaces where none of the related Chats match this filter */
  chats_NONE?: InputMaybe<ChatWhere>;
  /** Return Workspaces where one of the related Chats match this filter */
  chats_SINGLE?: InputMaybe<ChatWhere>;
  /** Return Workspaces where some of the related Chats match this filter */
  chats_SOME?: InputMaybe<ChatWhere>;
  coursesAggregate?: InputMaybe<WorkspaceCoursesAggregateInput>;
  /** Return Workspaces where all of the related WorkspaceCoursesConnections match this filter */
  coursesConnection_ALL?: InputMaybe<WorkspaceCoursesConnectionWhere>;
  /** Return Workspaces where none of the related WorkspaceCoursesConnections match this filter */
  coursesConnection_NONE?: InputMaybe<WorkspaceCoursesConnectionWhere>;
  /** Return Workspaces where one of the related WorkspaceCoursesConnections match this filter */
  coursesConnection_SINGLE?: InputMaybe<WorkspaceCoursesConnectionWhere>;
  /** Return Workspaces where some of the related WorkspaceCoursesConnections match this filter */
  coursesConnection_SOME?: InputMaybe<WorkspaceCoursesConnectionWhere>;
  /** Return Workspaces where all of the related Courses match this filter */
  courses_ALL?: InputMaybe<CourseWhere>;
  /** Return Workspaces where none of the related Courses match this filter */
  courses_NONE?: InputMaybe<CourseWhere>;
  /** Return Workspaces where one of the related Courses match this filter */
  courses_SINGLE?: InputMaybe<CourseWhere>;
  /** Return Workspaces where some of the related Courses match this filter */
  courses_SOME?: InputMaybe<CourseWhere>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  key_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  key_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  key_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  key_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastModified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastModified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  schoolsAggregate?: InputMaybe<WorkspaceSchoolsAggregateInput>;
  /** Return Workspaces where all of the related WorkspaceSchoolsConnections match this filter */
  schoolsConnection_ALL?: InputMaybe<WorkspaceSchoolsConnectionWhere>;
  /** Return Workspaces where none of the related WorkspaceSchoolsConnections match this filter */
  schoolsConnection_NONE?: InputMaybe<WorkspaceSchoolsConnectionWhere>;
  /** Return Workspaces where one of the related WorkspaceSchoolsConnections match this filter */
  schoolsConnection_SINGLE?: InputMaybe<WorkspaceSchoolsConnectionWhere>;
  /** Return Workspaces where some of the related WorkspaceSchoolsConnections match this filter */
  schoolsConnection_SOME?: InputMaybe<WorkspaceSchoolsConnectionWhere>;
  /** Return Workspaces where all of the related Schools match this filter */
  schools_ALL?: InputMaybe<SchoolWhere>;
  /** Return Workspaces where none of the related Schools match this filter */
  schools_NONE?: InputMaybe<SchoolWhere>;
  /** Return Workspaces where one of the related Schools match this filter */
  schools_SINGLE?: InputMaybe<SchoolWhere>;
  /** Return Workspaces where some of the related Schools match this filter */
  schools_SOME?: InputMaybe<SchoolWhere>;
  todosAggregate?: InputMaybe<WorkspaceTodosAggregateInput>;
  /** Return Workspaces where all of the related WorkspaceTodosConnections match this filter */
  todosConnection_ALL?: InputMaybe<WorkspaceTodosConnectionWhere>;
  /** Return Workspaces where none of the related WorkspaceTodosConnections match this filter */
  todosConnection_NONE?: InputMaybe<WorkspaceTodosConnectionWhere>;
  /** Return Workspaces where one of the related WorkspaceTodosConnections match this filter */
  todosConnection_SINGLE?: InputMaybe<WorkspaceTodosConnectionWhere>;
  /** Return Workspaces where some of the related WorkspaceTodosConnections match this filter */
  todosConnection_SOME?: InputMaybe<WorkspaceTodosConnectionWhere>;
  /** Return Workspaces where all of the related Todos match this filter */
  todos_ALL?: InputMaybe<TodoWhere>;
  /** Return Workspaces where none of the related Todos match this filter */
  todos_NONE?: InputMaybe<TodoWhere>;
  /** Return Workspaces where one of the related Todos match this filter */
  todos_SINGLE?: InputMaybe<TodoWhere>;
  /** Return Workspaces where some of the related Todos match this filter */
  todos_SOME?: InputMaybe<TodoWhere>;
  type?: InputMaybe<WorkspaceType>;
  type_IN?: InputMaybe<Array<InputMaybe<WorkspaceType>>>;
  usersHasWorkspaceAggregate?: InputMaybe<WorkspaceUsersHasWorkspaceAggregateInput>;
  /** Return Workspaces where all of the related WorkspaceUsersHasWorkspaceConnections match this filter */
  usersHasWorkspaceConnection_ALL?: InputMaybe<WorkspaceUsersHasWorkspaceConnectionWhere>;
  /** Return Workspaces where none of the related WorkspaceUsersHasWorkspaceConnections match this filter */
  usersHasWorkspaceConnection_NONE?: InputMaybe<WorkspaceUsersHasWorkspaceConnectionWhere>;
  /** Return Workspaces where one of the related WorkspaceUsersHasWorkspaceConnections match this filter */
  usersHasWorkspaceConnection_SINGLE?: InputMaybe<WorkspaceUsersHasWorkspaceConnectionWhere>;
  /** Return Workspaces where some of the related WorkspaceUsersHasWorkspaceConnections match this filter */
  usersHasWorkspaceConnection_SOME?: InputMaybe<WorkspaceUsersHasWorkspaceConnectionWhere>;
  /** Return Workspaces where all of the related Users match this filter */
  usersHasWorkspace_ALL?: InputMaybe<UserWhere>;
  /** Return Workspaces where none of the related Users match this filter */
  usersHasWorkspace_NONE?: InputMaybe<UserWhere>;
  /** Return Workspaces where one of the related Users match this filter */
  usersHasWorkspace_SINGLE?: InputMaybe<UserWhere>;
  /** Return Workspaces where some of the related Users match this filter */
  usersHasWorkspace_SOME?: InputMaybe<UserWhere>;
};

export type YearlySummary = {
  __typename?: 'YearlySummary';
  created: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  isArchived: Scalars['Boolean']['output'];
  last_modified: Scalars['DateTime']['output'];
  summary: Scalars['String']['output'];
};

export type YearlySummaryConnectWhere = {
  node: YearlySummaryWhere;
};

export type YearlySummaryCreateInput = {
  created: Scalars['DateTime']['input'];
  date: Scalars['DateTime']['input'];
  isArchived: Scalars['Boolean']['input'];
  last_modified: Scalars['DateTime']['input'];
  summary: Scalars['String']['input'];
};

export type YearlySummaryOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more YearlySummarySort objects to sort YearlySummaries by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<YearlySummarySort>>;
};

/** Fields to sort YearlySummaries by. The order in which sorts are applied is not guaranteed when specifying many fields in one YearlySummarySort object. */
export type YearlySummarySort = {
  created?: InputMaybe<SortDirection>;
  date?: InputMaybe<SortDirection>;
  isArchived?: InputMaybe<SortDirection>;
  last_modified?: InputMaybe<SortDirection>;
  summary?: InputMaybe<SortDirection>;
};

export type YearlySummaryUpdateInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type YearlySummaryWhere = {
  AND?: InputMaybe<Array<YearlySummaryWhere>>;
  NOT?: InputMaybe<YearlySummaryWhere>;
  OR?: InputMaybe<Array<YearlySummaryWhere>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  created_GT?: InputMaybe<Scalars['DateTime']['input']>;
  created_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  created_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  created_LT?: InputMaybe<Scalars['DateTime']['input']>;
  created_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  date_GT?: InputMaybe<Scalars['DateTime']['input']>;
  date_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  date_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  date_LT?: InputMaybe<Scalars['DateTime']['input']>;
  date_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last_modified?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  last_modified_LT?: InputMaybe<Scalars['DateTime']['input']>;
  last_modified_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  summary_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  summary_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  summary_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  summary_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login?: { __typename?: 'AuthPayloadResponse', accessToken: string, refreshToken: string, user?: { __typename?: 'AuthPayloadUser', id?: string | null, email?: string | null, isOnboarded?: boolean | null, isPro?: boolean | null, name?: string | null, isEmailVerified?: boolean | null, otpPreference?: string | null, countryCode?: string | null, phoneNumber?: string | null, fullPhoneNumber?: string | null, googleAuthTokens?: { __typename?: 'GoogleAuthTokens', access_token?: string | null, refresh_token?: string | null, scope?: string | null, token_type?: string | null, expiry_date?: number | null } | null } | null } | null };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: { __typename?: 'ResponseType', message?: string | null, success: boolean } };

export type RefreshTokenMutationVariables = Exact<{
  refreshToken: Scalars['String']['input'];
}>;


export type RefreshTokenMutation = { __typename?: 'Mutation', refreshToken?: { __typename?: 'AuthPayloadResponse', accessToken: string, refreshToken: string } | null };

export type ResetPasswordMutationVariables = Exact<{
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: { __typename?: 'ResponseType', message?: string | null, success: boolean } | null };

export type SignupMutationVariables = Exact<{
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  birthday: Scalars['String']['input'];
  dailyEmailOptIn: Scalars['Boolean']['input'];
  language: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
}>;


export type SignupMutation = { __typename?: 'Mutation', signup?: { __typename?: 'AuthPayloadResponse', accessToken: string, refreshToken: string, user?: { __typename?: 'AuthPayloadUser', id?: string | null, email?: string | null, name?: string | null, isPro?: boolean | null, isOnboarded?: boolean | null, otpPreference?: string | null, isEmailVerified?: boolean | null, fullPhoneNumber?: string | null, preferences?: { __typename?: 'AuthPayloadUserPreferences', language?: string | null } | null } | null } | null };

export type LoginSuperAdminMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginSuperAdminMutation = { __typename?: 'Mutation', loginSuperAdmin?: { __typename?: 'AuthPayloadResponse', accessToken: string, refreshToken: string, user?: { __typename?: 'AuthPayloadUser', id?: string | null, email?: string | null, isOnboarded?: boolean | null, isPro?: boolean | null, name?: string | null, isEmailVerified?: boolean | null, otpPreference?: string | null, countryCode?: string | null, phoneNumber?: string | null, fullPhoneNumber?: string | null, googleAuthTokens?: { __typename?: 'GoogleAuthTokens', access_token?: string | null, refresh_token?: string | null, scope?: string | null, token_type?: string | null, expiry_date?: number | null } | null } | null } | null };

export type CareerIsLoadingMutationVariables = Exact<{
  isLoading: Scalars['Boolean']['input'];
}>;


export type CareerIsLoadingMutation = { __typename?: 'Mutation', careerIsLoading: { __typename?: 'UserCareerLoadingResponse', isCareerLoading: boolean } };

export type CareerSubmitFormMutationVariables = Exact<{
  currentOccupation: Scalars['String']['input'];
  careerPathName: Scalars['String']['input'];
  careerGoal: Scalars['String']['input'];
}>;


export type CareerSubmitFormMutation = { __typename?: 'Mutation', careerSubmitForm: boolean };

export type GenerateSuggestedCareersMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateSuggestedCareersMutation = { __typename?: 'Mutation', generateSuggestedCareers?: { __typename?: 'Career', name: string, id: string } | null };

export type SetCareerPathActiveMutationVariables = Exact<{
  careerId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SetCareerPathActiveMutation = { __typename?: 'Mutation', setCareerPathActive: boolean };

export type DeleteAspectMutationVariables = Exact<{
  nodeId: Scalars['ID']['input'];
}>;


export type DeleteAspectMutation = { __typename?: 'Mutation', deleteAspect: { __typename?: 'ResponseType', message?: string | null, success: boolean } };

export type DeleteCompanionChatMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCompanionChatMutation = { __typename?: 'Mutation', deleteCompanionChat: { __typename?: 'ChatMutationResponse', success: boolean, message?: string | null } };

export type DeleteMessageMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteMessageMutation = { __typename?: 'Mutation', deleteMessage?: { __typename?: 'Message', id: string } | null };

export type ProcessAttachmentMutationVariables = Exact<{
  fileId: Scalars['String']['input'];
}>;


export type ProcessAttachmentMutation = { __typename?: 'Mutation', processAttachment: { __typename?: 'ChatAttachmentResponse', message?: string | null, count?: number | null, success: boolean } };

export type ProcessCompanionChatAttachmentMutationVariables = Exact<{
  fileId: Scalars['String']['input'];
}>;


export type ProcessCompanionChatAttachmentMutation = { __typename?: 'Mutation', processCompanionChatAttachment: { __typename?: 'ChatAttachmentProcessResult', success: boolean, message?: string | null, data?: { __typename?: 'AttachmentProcessData', fileId: string, fileName: string, documentId: string } | null } };

export type UpdateCompanionChatMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateCompanionChatMutation = { __typename?: 'Mutation', updateCompanionChat: { __typename?: 'ChatMutationResponse', success: boolean, message?: string | null } };

export type AddAssignmentMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
  moduleName: Scalars['String']['input'];
  newAssignmentName: Scalars['String']['input'];
  updatedHtml: Scalars['String']['input'];
}>;


export type AddAssignmentMutation = { __typename?: 'Mutation', addAssignment: { __typename?: 'AddAssignmentResponse', success: boolean, message?: string | null } };

export type AddContentModuleMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
  moduleName: Scalars['String']['input'];
}>;


export type AddContentModuleMutation = { __typename?: 'Mutation', addContentModule: { __typename?: 'AddContentModuleResponse', success: boolean, message?: string | null } };

export type CourseCreationMutationVariables = Exact<{
  title: Scalars['String']['input'];
  standard: Scalars['String']['input'];
  weeks: Scalars['Int']['input'];
  objectives: Array<Scalars['String']['input']> | Scalars['String']['input'];
  urls: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CourseCreationMutation = { __typename?: 'Mutation', courseCreation?: { __typename?: 'CourseCreationResponse', success: boolean, message?: string | null, data?: { __typename?: 'Curriculum', name: string, standard: string, weeks: number, objectives: Array<string>, created?: any | null, last_modified?: any | null, modules: Array<{ __typename?: 'Module', module_name?: string | null, assignments: Array<{ __typename?: 'Assignment', assignment_name?: string | null, html?: string | null }> }> } | null } | null };

export type CourseIsLoadingMutationVariables = Exact<{
  isLoading: Scalars['Boolean']['input'];
}>;


export type CourseIsLoadingMutation = { __typename?: 'Mutation', courseIsLoading: { __typename?: 'UserCourseLoadingResponse', isCourseLoading: boolean } };

export type DeleteContentAssignmentMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
  moduleName: Scalars['String']['input'];
  assignmentName: Scalars['String']['input'];
}>;


export type DeleteContentAssignmentMutation = { __typename?: 'Mutation', deleteContentAssignment: { __typename?: 'DeleteContentAssignmentResponse', success: boolean, message?: string | null } };

export type DeleteContentModuleMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
  moduleName: Scalars['String']['input'];
}>;


export type DeleteContentModuleMutation = { __typename?: 'Mutation', deleteContentModule: { __typename?: 'DeleteContentModuleResponse', success: boolean, message?: string | null } };

export type UpdateAssignmentMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
  moduleName: Scalars['String']['input'];
  currentAssignmentName: Scalars['String']['input'];
  newAssignmentName: Scalars['String']['input'];
  updatedHtml: Scalars['String']['input'];
}>;


export type UpdateAssignmentMutation = { __typename?: 'Mutation', updateAssignment: { __typename?: 'UpdateAssignmentResponse', success: boolean, message?: string | null, data?: { __typename?: 'Assignment', assignment_name?: string | null, html?: string | null } | null } };

export type UpdateContentModuleNameMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
  oldModuleName: Scalars['String']['input'];
  newModuleName: Scalars['String']['input'];
}>;


export type UpdateContentModuleNameMutation = { __typename?: 'Mutation', updateContentModuleName: { __typename?: 'UpdateContentModuleNameResponse', success: boolean, message?: string | null } };

export type EvaluateCourseMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type EvaluateCourseMutation = { __typename?: 'Mutation', evaluateCourse?: { __typename?: 'CourseEvaluationResponse', success: boolean, message?: string | null, jobId?: string | null } | null };

export type MakeCoursePaymentMutationVariables = Exact<{
  courseId: Scalars['String']['input'];
}>;


export type MakeCoursePaymentMutation = { __typename?: 'Mutation', createCheckoutSession?: { __typename?: 'ResponseType', success: boolean, message?: string | null, url?: string | null } | null };

export type CreateAiTutorMutationVariables = Exact<{
  title: Scalars['String']['input'];
  description: Scalars['String']['input'];
  parentModuleId: Scalars['ID']['input'];
  objectives: Array<ObjectiveInput> | ObjectiveInput;
  context?: InputMaybe<Scalars['String']['input']>;
  visualizationId?: InputMaybe<Scalars['ID']['input']>;
  videoPool?: InputMaybe<Array<InputMaybe<VideoDataInput>> | InputMaybe<VideoDataInput>>;
  targetAudience?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  activityState?: InputMaybe<ActivityState>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type CreateAiTutorMutation = { __typename?: 'Mutation', createAITutor?: { __typename?: 'AITutorResponse', success?: boolean | null, message?: string | null, data?: Array<{ __typename?: 'FormattedAITutor', title: string, description?: string | null, targetAudience?: string | null, dueDate?: any | null, activityState?: ActivityState | null, scheduledDate?: any | null, objectives?: Array<{ __typename?: 'FormattedObjective', objective: string, sequence?: number | null } | null> | null } | null> | null } | null };

export type DeleteAiTutorMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAiTutorMutation = { __typename?: 'Mutation', deleteAITutor?: { __typename?: 'AITutorResponse', success?: boolean | null, message?: string | null } | null };

export type BulkAssessmentCreateMutationVariables = Exact<{
  input: BulkAssessmentCreateInput;
}>;


export type BulkAssessmentCreateMutation = { __typename?: 'Mutation', bulkAssessmentCreate?: { __typename?: 'BulkAssessmentCreateResponse', success?: boolean | null, message?: string | null, jobId?: string | null } | null };

export type CreateAnnouncementMutationVariables = Exact<{
  input: CreateAnnouncementInput;
}>;


export type CreateAnnouncementMutation = { __typename?: 'Mutation', createAnnouncement: { __typename?: 'AnnouncementResponse', success: boolean, message?: string | null, count: number, data?: { __typename?: 'Announcement', id: string, title: string, message: string, expirationDate?: any | null, created: any, lastModified: any, scope: AnnouncementScope, audienceType: AudienceType, author: { __typename?: 'User', id: string, name: string, email: string }, courses: Array<{ __typename?: 'Course', id: string, name?: string | null }>, degrees: Array<{ __typename?: 'Degree', id: string, name: string }>, school?: { __typename?: 'School', id: string, team_name?: string | null } | null } | null } };

export type CreateAxioResourceMutationVariables = Exact<{
  resource: CreateAxioResourceInput;
}>;


export type CreateAxioResourceMutation = { __typename?: 'Mutation', createAxioResource: { __typename?: 'AxioResourceResponse', success: boolean, message?: string | null, count?: number | null, data?: Array<{ __typename?: 'AxioResource', id: string, name: string, description?: string | null, videoUrl?: string | null, order: number, created?: any | null, lastModified?: any | null } | null> | null } };

export type CreateCoursePlaceholderMutationVariables = Exact<{
  name: Scalars['String']['input'];
  courseCode?: InputMaybe<Scalars['String']['input']>;
  schoolId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  objectives?: InputMaybe<Scalars['String']['input']>;
  targetAudience?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<Scalars['Float']['input']>;
  degreeIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type CreateCoursePlaceholderMutation = { __typename?: 'Mutation', createCoursePlaceholder?: { __typename?: 'CourseResponse', success?: boolean | null, count?: number | null, data?: Array<{ __typename?: 'Course', id: string, name?: string | null, course_code?: string | null, description?: string | null, objectives?: Array<string> | null, targetAudience?: string | null, cost?: number | null, degreesHasCourse: Array<{ __typename?: 'Degree', id: string, name: string }> } | null> | null } | null };

export type CreateNoteMutationVariables = Exact<{
  input: CreateNoteInput;
}>;


export type CreateNoteMutation = { __typename?: 'Mutation', createNote: { __typename?: 'NoteResponse', success: boolean, message?: string | null, count: number, data?: { __typename?: 'Note', id: string, content: string, created: any, lastModified: any, author: { __typename?: 'User', id: string, name: string, profilePicture?: string | null }, subject: { __typename?: 'User', id: string, name: string } } | null } };

export type CreatePostMutationVariables = Exact<{
  input: CreatePostInput;
}>;


export type CreatePostMutation = { __typename?: 'Mutation', createPost: { __typename?: 'PostResponse', success: boolean, message?: string | null, count: number, data?: { __typename?: 'Post', id: string, message: string, depth: number, threadId: string, created: any, lastModified: any, thread: { __typename?: 'Thread', id: string, title: string, forum: { __typename?: 'Forum', course: { __typename?: 'Course', id: string, name?: string | null } } }, author: { __typename?: 'User', id: string, name: string }, files: Array<{ __typename?: 'File', id: string, fileName: string, fileURL: string }>, replies: Array<{ __typename?: 'Post', id: string, message: string, depth: number, created: any, lastModified: any, author: { __typename?: 'User', id: string, name: string }, files: Array<{ __typename?: 'File', id: string, fileName: string, fileURL: string }> }>, replyTo?: { __typename?: 'Post', id: string, message: string, author: { __typename?: 'User', id: string, name: string } } | null } | null } };

export type CreateReviewMutationVariables = Exact<{
  review: CreateReviewInput;
}>;


export type CreateReviewMutation = { __typename?: 'Mutation', createReview?: { __typename?: 'ReviewResponse', success?: boolean | null, message?: string | null, count?: number | null, data?: Array<{ __typename?: 'Review', id: string, created?: any | null, lastModified?: any | null } | null> | null } | null };

export type CreateThreadMutationVariables = Exact<{
  input: CreateThreadInput;
}>;


export type CreateThreadMutation = { __typename?: 'Mutation', createThread: { __typename?: 'ThreadResponse', success: boolean, message?: string | null, count: number, data?: { __typename?: 'Thread', id: string, title: string, created: any, lastModified: any, forum: { __typename?: 'Forum', id: string, course: { __typename?: 'Course', id: string, name?: string | null } }, posts: Array<{ __typename?: 'Post', id: string, message: string, depth: number, threadId: string, created: any, lastModified: any, author: { __typename?: 'User', id: string, name: string }, files: Array<{ __typename?: 'File', id: string, fileName: string, fileURL: string }> }>, subscribers: Array<{ __typename?: 'User', id: string }> } | null } };

export type DeleteAnnouncementMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAnnouncementMutation = { __typename?: 'Mutation', deleteAnnouncement: { __typename?: 'AnnouncementResponse', success: boolean, message?: string | null, count: number } };

export type DeleteAxioResourceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAxioResourceMutation = { __typename?: 'Mutation', deleteAxioResource: { __typename?: 'AxioResourceResponse', success: boolean, message?: string | null } };

export type DeleteNoteMutationVariables = Exact<{
  noteId: Scalars['ID']['input'];
}>;


export type DeleteNoteMutation = { __typename?: 'Mutation', deleteNote: { __typename?: 'NoteResponse', success: boolean, message?: string | null, count: number } };

export type DeletePostMutationVariables = Exact<{
  postId: Scalars['ID']['input'];
}>;


export type DeletePostMutation = { __typename?: 'Mutation', deletePost: { __typename?: 'PostResponse', success: boolean, message?: string | null, count: number, data?: { __typename?: 'Post', id: string, message: string, author: { __typename?: 'User', id: string, name: string }, thread: { __typename?: 'Thread', id: string, title: string } } | null } };

export type DeleteReviewMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteReviewMutation = { __typename?: 'Mutation', deleteReview?: { __typename?: 'ReviewResponse', success?: boolean | null, message?: string | null, count?: number | null } | null };

export type DeleteThreadMutationVariables = Exact<{
  threadId: Scalars['ID']['input'];
}>;


export type DeleteThreadMutation = { __typename?: 'Mutation', deleteThread: { __typename?: 'ThreadResponse', success: boolean, message?: string | null, count: number, data?: { __typename?: 'Thread', id: string, title: string, created: any, lastModified: any, posts: Array<{ __typename?: 'Post', id: string, message: string, author: { __typename?: 'User', id: string, name: string } }> } | null } };

export type DownloadLessonPlanMutationVariables = Exact<{
  moduleId: Scalars['ID']['input'];
}>;


export type DownloadLessonPlanMutation = { __typename?: 'Mutation', downloadLessonPlan?: { __typename?: 'DownloadLessonPlanResponse', success: boolean, message?: string | null, data?: any | null } | null };

export type GenerateAiTutorFromTitleMutationVariables = Exact<{
  title: Scalars['String']['input'];
  targetAudience?: InputMaybe<Scalars['String']['input']>;
}>;


export type GenerateAiTutorFromTitleMutation = { __typename?: 'Mutation', generateAiTutorFromTitle?: { __typename?: 'AITutorGeneratedResponse', message?: string | null, success?: boolean | null, data?: { __typename?: 'GeneratedAiTutor', description: string, objectives?: Array<{ __typename?: 'GeneratedObjective', objective: string, sequence?: number | null }> | null } | null } | null };

export type GenerateCourseContentMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
  numberOfModules: Scalars['Int']['input'];
  numberOfActivities: Scalars['Int']['input'];
  courseDescription?: InputMaybe<Scalars['String']['input']>;
}>;


export type GenerateCourseContentMutation = { __typename?: 'Mutation', generateCourseContent?: { __typename?: 'GenerateCourseContentResponse', count: number, message: string, success: boolean, data?: { __typename?: 'GenerateCourseContentData', id: string } | null } | null };

export type GenerateEvalCriteriaMutationVariables = Exact<{
  input: GenerateEvalCriteriaInput;
}>;


export type GenerateEvalCriteriaMutation = { __typename?: 'Mutation', generateEvalCriteria?: { __typename?: 'AITutorEvalCriteriaResponse', message?: string | null, success?: boolean | null, data?: Array<{ __typename?: 'FormattedObjective', objective: string, evalCriteria?: Array<string | null> | null } | null> | null } | null };

export type GenerateLessonPlanMutationVariables = Exact<{
  input: GenerateLessonPlanInput;
}>;


export type GenerateLessonPlanMutation = { __typename?: 'Mutation', generateLessonPlan?: { __typename?: 'GenerateLessonPlanResponse', success: boolean, message?: string | null, data?: any | null } | null };

export type GetRosterExportFileQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type GetRosterExportFileQuery = { __typename?: 'Query', getRosterExportFile: { __typename?: 'ExportDownloadResponse', success: boolean, message?: string | null, count: number, data?: { __typename?: 'File', id: string, fileName: string, fileURL: string } | null } };

export type GetSubmissionExportFileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubmissionExportFileQuery = { __typename?: 'Query', getSubmissionExportFile: { __typename?: 'ExportDownloadResponse', success: boolean, message?: string | null, count: number, data?: { __typename?: 'File', id: string, fileName: string, fileURL: string } | null } };

export type MarkAnnouncementAsSeenMutationVariables = Exact<{
  announcementId: Scalars['ID']['input'];
}>;


export type MarkAnnouncementAsSeenMutation = { __typename?: 'Mutation', markAnnouncementAsSeen: { __typename?: 'MarkAnnouncementSeenResponse', success: boolean, message?: string | null } };

export type UpdateAnnouncementMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateAnnouncementInput;
}>;


export type UpdateAnnouncementMutation = { __typename?: 'Mutation', updateAnnouncement: { __typename?: 'AnnouncementResponse', success: boolean, message?: string | null, count: number, data?: { __typename?: 'Announcement', id: string, title: string, message: string, expirationDate?: any | null, created: any, lastModified: any, scope: AnnouncementScope, audienceType: AudienceType, author: { __typename?: 'User', id: string, name: string, email: string }, courses: Array<{ __typename?: 'Course', id: string, name?: string | null }>, degrees: Array<{ __typename?: 'Degree', id: string, name: string }>, school?: { __typename?: 'School', id: string, team_name?: string | null } | null } | null } };

export type UpdateAxioResourceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  resource: UpdateAxioResourceInput;
}>;


export type UpdateAxioResourceMutation = { __typename?: 'Mutation', updateAxioResource: { __typename?: 'AxioResourceResponse', success: boolean, message?: string | null, data?: Array<{ __typename?: 'AxioResource', id: string, name: string, description?: string | null, videoUrl?: string | null, order: number } | null> | null } };

export type UpdateLastSeenPostMutationVariables = Exact<{
  input: UpdateLastSeenPostInput;
}>;


export type UpdateLastSeenPostMutation = { __typename?: 'Mutation', updateLastSeenPost: { __typename?: 'PostResponse', success: boolean, message?: string | null, count: number, data?: { __typename?: 'Post', id: string, message: string, threadId: string, created: any } | null } };

export type UpdateNoteMutationVariables = Exact<{
  noteId: Scalars['ID']['input'];
  input: UpdateNoteInput;
}>;


export type UpdateNoteMutation = { __typename?: 'Mutation', updateNote: { __typename?: 'NoteResponse', success: boolean, message?: string | null, count: number, data?: { __typename?: 'Note', id: string, content: string, created: any, lastModified: any, author: { __typename?: 'User', id: string, name: string, profilePicture?: string | null }, subject: { __typename?: 'User', id: string, name: string } } | null } };

export type UpdatePostMutationVariables = Exact<{
  postId: Scalars['ID']['input'];
  input: UpdatePostInput;
}>;


export type UpdatePostMutation = { __typename?: 'Mutation', updatePost: { __typename?: 'PostResponse', success: boolean, message?: string | null, count: number, data?: { __typename?: 'Post', id: string, message: string, depth: number, threadId: string, created: any, lastModified: any, thread: { __typename?: 'Thread', id: string, title: string }, author: { __typename?: 'User', id: string, name: string }, files: Array<{ __typename?: 'File', id: string, fileName: string, fileURL: string }>, replies: Array<{ __typename?: 'Post', id: string, message: string, depth: number, created: any, lastModified: any, author: { __typename?: 'User', id: string, name: string }, files: Array<{ __typename?: 'File', id: string, fileName: string, fileURL: string }> }>, replyTo?: { __typename?: 'Post', id: string, message: string, author: { __typename?: 'User', id: string, name: string } } | null } | null } };

export type UpdateReviewMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  review: UpdateReviewInput;
}>;


export type UpdateReviewMutation = { __typename?: 'Mutation', updateReview?: { __typename?: 'ReviewResponse', success?: boolean | null, message?: string | null, count?: number | null, data?: Array<{ __typename?: 'Review', id: string, activityState?: ActivityState | null, scheduledDate?: any | null, lastModified?: any | null } | null> | null } | null };

export type UpdateThreadMutationVariables = Exact<{
  threadId: Scalars['ID']['input'];
  input: UpdateThreadInput;
}>;


export type UpdateThreadMutation = { __typename?: 'Mutation', updateThread: { __typename?: 'ThreadResponse', success: boolean, message?: string | null, count: number, data?: { __typename?: 'Thread', id: string, title: string, created: any, lastModified: any, forum: { __typename?: 'Forum', id: string, course: { __typename?: 'Course', id: string, name?: string | null } }, posts: Array<{ __typename?: 'Post', id: string, message: string, depth: number, threadId: string, created: any, lastModified: any, author: { __typename?: 'User', id: string, name: string }, files: Array<{ __typename?: 'File', id: string, fileName: string, fileURL: string }> }>, subscribers: Array<{ __typename?: 'User', id: string }> } | null } };

export type CreateVideoPoolMutationVariables = Exact<{
  title: Scalars['String']['input'];
  description: Scalars['String']['input'];
  objectives: Array<ObjectiveForVideoInput> | ObjectiveForVideoInput;
}>;


export type CreateVideoPoolMutation = { __typename?: 'Mutation', createVideoPool: { __typename?: 'VideoServiceResult', success: boolean, message?: string | null, count: number, data?: Array<{ __typename?: 'VideoPoolItem', videoId: string, url: string, title: string, description?: string | null, thumbnailUrl?: string | null, objectiveText?: string | null, objectiveSequence?: number | null }> | null } };

export type AddPreRequisitesToCourseMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
  preRequisiteIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AddPreRequisitesToCourseMutation = { __typename?: 'Mutation', addPreRequisitesToCourse?: { __typename?: 'CourseResponse', success?: boolean | null, count?: number | null, data?: Array<{ __typename?: 'Course', id: string } | null> | null } | null };

export type CloneCourseMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type CloneCourseMutation = { __typename?: 'Mutation', cloneCourse?: { __typename?: 'CourseResponse', success?: boolean | null, count?: number | null, data?: Array<{ __typename?: 'Course', id: string, name?: string | null } | null> | null } | null };

export type CreateAssignmentMutationVariables = Exact<{
  assignment: CreateAssignmentInput;
}>;


export type CreateAssignmentMutation = { __typename?: 'Mutation', createAssignment?: { __typename?: 'AssignmentResponse', success?: boolean | null, message?: string | null } | null };

export type CreateOrUpdateAssessmentMutationVariables = Exact<{
  input: CreateOrUpdateAssessmentInput;
}>;


export type CreateOrUpdateAssessmentMutation = { __typename?: 'Mutation', createOrUpdateAssessment?: { __typename?: 'AssessmentResponse', success?: boolean | null, message?: string | null, data?: { __typename?: 'Assessment', id: string } | null } | null };

export type CreateWorksheetMutationVariables = Exact<{
  worksheet: CreateWorksheetInput;
  existingWorksheetId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateWorksheetMutation = { __typename?: 'Mutation', createWorksheet?: { __typename?: 'WorksheetResponse', success?: boolean | null, message?: string | null, data?: { __typename?: 'WorksheetResponseData', worksheetId: string, pdfUrl: string, generationStatus?: WorksheetGenerationStatus | null } | null } | null };

export type DeleteCourseCascadeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCourseCascadeMutation = { __typename?: 'Mutation', deleteCourseCascade?: { __typename?: 'CourseResponse', success?: boolean | null, message?: string | null } | null };

export type CreateCourseMutationVariables = Exact<{
  name: Scalars['String']['input'];
  learningStandards?: InputMaybe<Scalars['String']['input']>;
  lengthInWeeks?: InputMaybe<Scalars['Float']['input']>;
  objectives?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  parentSchoolId: Scalars['String']['input'];
  cost?: InputMaybe<Scalars['Float']['input']>;
}>;


export type CreateCourseMutation = { __typename?: 'Mutation', createCourse?: { __typename?: 'CourseResponse', success?: boolean | null, message?: string | null, data?: Array<{ __typename?: 'Course', name?: string | null, learningStandards?: string | null, lengthInWeeks?: number | null, objectives?: Array<string> | null, cost?: number | null } | null> | null } | null };

export type UpdateCourseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  course: UpdateCourseInput;
}>;


export type UpdateCourseMutation = { __typename?: 'Mutation', updateCourse?: { __typename?: 'CourseResponse', success?: boolean | null, message?: string | null, data?: Array<{ __typename?: 'Course', name?: string | null, course_code?: string | null, isDraft?: boolean | null, isEnrollmentAvailable?: boolean | null } | null> | null } | null };

export type DeleteModuleCascadeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteModuleCascadeMutation = { __typename?: 'Mutation', deleteModuleCascade?: { __typename?: 'ModuleResponse', success?: boolean | null, message?: string | null } | null };

export type CreateModuleMutationVariables = Exact<{
  title: Scalars['String']['input'];
  parentCourseId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateModuleMutation = { __typename?: 'Mutation', createModule?: { __typename?: 'ModuleResponse', success?: boolean | null, message?: string | null, data?: Array<{ __typename?: 'Module', title?: string | null, description?: string | null, thumbnail?: string | null } | null> | null } | null };

export type UpdateModuleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateModuleMutation = { __typename?: 'Mutation', updateModule?: { __typename?: 'ModuleResponse', success?: boolean | null, message?: string | null, data?: Array<{ __typename?: 'Module', title?: string | null, description?: string | null, thumbnail?: string | null } | null> | null } | null };

export type CreatePageMutationVariables = Exact<{
  title: Scalars['String']['input'];
  body?: InputMaybe<Scalars['String']['input']>;
  parentModuleId: Scalars['ID']['input'];
}>;


export type CreatePageMutation = { __typename?: 'Mutation', createPage?: { __typename?: 'PageResponse', success?: boolean | null, message?: string | null, data?: Array<{ __typename?: 'Page', title: string, body?: string | null } | null> | null } | null };

export type DeletePageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletePageMutation = { __typename?: 'Mutation', deletePage?: { __typename?: 'PageResponse', success?: boolean | null, message?: string | null } | null };

export type UpdatePageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdatePageMutation = { __typename?: 'Mutation', updatePage?: { __typename?: 'PageResponse', success?: boolean | null, message?: string | null, data?: Array<{ __typename?: 'Page', title: string, body?: string | null } | null> | null } | null };

export type DeleteAssessmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAssessmentMutation = { __typename?: 'Mutation', deleteAssessment?: { __typename?: 'AssessmentResponse', success?: boolean | null, message?: string | null, data?: { __typename?: 'Assessment', id: string } | null } | null };

export type DeleteAssignmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAssignmentMutation = { __typename?: 'Mutation', deleteAssignment?: { __typename?: 'AssignmentResponse', success?: boolean | null, count?: number | null, data?: Array<{ __typename?: 'Assignment', id: string } | null> | null } | null };

export type EditAssignmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  assignment: EditAssignmentInput;
}>;


export type EditAssignmentMutation = { __typename?: 'Mutation', editAssignment?: { __typename?: 'AssignmentResponse', success?: boolean | null, message?: string | null, data?: Array<{ __typename?: 'Assignment', id: string, name?: string | null, due_date?: any | null, description?: string | null, videoUrl?: string | null, enableStudentFileUpload?: boolean | null, files: Array<{ __typename?: 'File', id: string, fileName: string, fileURL: string, created: any, status: FileStatus }> } | null> | null } | null };

export type EditCourseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  course: EditCourseInput;
}>;


export type EditCourseMutation = { __typename?: 'Mutation', editCourse?: { __typename?: 'CourseResponse', success?: boolean | null, message?: string | null, data?: Array<{ __typename?: 'Course', id: string, name?: string | null, course_code?: string | null, learningStandards?: string | null, lengthInWeeks?: number | null, objectives?: Array<string> | null, is_elective?: boolean | null, cost?: number | null, isDraft?: boolean | null, description?: string | null, targetAudience?: string | null, thumbnail?: string | null } | null> | null } | null };

export type GenerateAssessmentQuestionsPreviewMutationVariables = Exact<{
  input: GenerateAssessmentQuestionsPreviewInput;
}>;


export type GenerateAssessmentQuestionsPreviewMutation = { __typename?: 'Mutation', generateAssessmentQuestionsPreview?: { __typename?: 'AssessmentQuestionsPreviewResponse', success?: boolean | null, message?: string | null, count?: number | null, mcqQuestions: Array<{ __typename?: 'PreviewMcqQuestion', question: string, choices: Array<string>, correctChoiceIndices: Array<number>, explanation?: string | null, totalScore?: number | null, order?: number | null }>, socraticQuestions: Array<{ __typename?: 'PreviewSocraticQuestion', aiTutorId: string, question: string, totalScore?: number | null, rubrics: Array<{ __typename?: 'SocraticQuestionRubric', component: string, points: number }> }> } | null };

export type GenerateCourseExportMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type GenerateCourseExportMutation = { __typename?: 'Mutation', generateCourseExport: { __typename?: 'RequestExportResponse', success: boolean, message?: string | null, data?: { __typename?: 'RequestExportData', jobId?: string | null } | null } };

export type GenerateDueDatesForActivitiesMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type GenerateDueDatesForActivitiesMutation = { __typename?: 'Mutation', generateDueDatesForActivities?: { __typename?: 'CourseResponse', success?: boolean | null, data?: Array<{ __typename?: 'Course', id: string } | null> | null } | null };

export type GenerateModuleThumbnailsMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type GenerateModuleThumbnailsMutation = { __typename?: 'Mutation', generateModuleThumbnails?: { __typename?: 'ModuleResponse', success?: boolean | null, message?: string | null, count?: number | null, data?: Array<{ __typename?: 'Module', id: string, title?: string | null, thumbnail?: string | null } | null> | null } | null };

export type InviteUsersToEnrollInCourseMutationVariables = Exact<{
  input: InviteUsersToEnrollInCourseInput;
}>;


export type InviteUsersToEnrollInCourseMutation = { __typename?: 'Mutation', inviteUsersToEnrollInCourse?: { __typename?: 'InviteUsersToEnrollInCourseResponse', success?: boolean | null, count?: number | null, data?: Array<{ __typename?: 'InvitedUsers', email: string, id: string } | null> | null } | null };

export type CreateMcqQuestionMutationVariables = Exact<{
  input: CreateMcqQuestionInput;
}>;


export type CreateMcqQuestionMutation = { __typename?: 'Mutation', createMcqQuestion: { __typename?: 'McqQuestionResponse', success: boolean, message?: string | null, data?: { __typename?: 'McqQuestion', id: string, question: string, choices: Array<string>, correctChoiceIndices: Array<number>, explanation?: string | null, totalScore?: number | null, order?: number | null } | null } };

export type UpdateMcqQuestionMutationVariables = Exact<{
  mcqQuestionId: Scalars['ID']['input'];
  assessmentId: Scalars['ID']['input'];
  input: UpdateMcqQuestionInput;
}>;


export type UpdateMcqQuestionMutation = { __typename?: 'Mutation', updateMcqQuestion: { __typename?: 'McqQuestionResponse', success: boolean, message?: string | null, data?: { __typename?: 'McqQuestion', id: string, question: string, choices: Array<string>, correctChoiceIndices: Array<number>, explanation?: string | null, totalScore?: number | null, order?: number | null } | null } };

export type DeleteMcqQuestionMutationVariables = Exact<{
  mcqQuestionId: Scalars['ID']['input'];
  assessmentId: Scalars['ID']['input'];
}>;


export type DeleteMcqQuestionMutation = { __typename?: 'Mutation', deleteMcqQuestion: { __typename?: 'McqQuestionResponse', success: boolean, message?: string | null, data?: { __typename?: 'McqQuestion', id: string } | null } };

export type MoveActivityMutationVariables = Exact<{
  activityId: Scalars['ID']['input'];
  sourceModuleId: Scalars['ID']['input'];
  targetModuleId: Scalars['ID']['input'];
  activityType: Scalars['String']['input'];
}>;


export type MoveActivityMutation = { __typename?: 'Mutation', moveActivity?: { __typename?: 'ModuleResponse', success?: boolean | null, message?: string | null, count?: number | null, data?: Array<{ __typename?: 'Module', id: string, title?: string | null, resourceOrder?: Array<string> | null } | null> | null } | null };

export type ReGenerateCourseImageMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type ReGenerateCourseImageMutation = { __typename?: 'Mutation', reGenerateCourseImage?: { __typename?: 'CourseResponse', success?: boolean | null, data?: Array<{ __typename?: 'Course', id: string } | null> | null } | null };

export type RemovePreRequisitesFromCourseMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
  preRequisiteIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RemovePreRequisitesFromCourseMutation = { __typename?: 'Mutation', removePreRequisitesFromCourse?: { __typename?: 'CourseResponse', success?: boolean | null, count?: number | null, data?: Array<{ __typename?: 'Course', id: string } | null> | null } | null };

export type RemoveStudentsFromCourseMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
  studentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RemoveStudentsFromCourseMutation = { __typename?: 'Mutation', removeStudentsFromCourse?: { __typename?: 'CourseRosterServiceResult', success?: boolean | null, count?: number | null, data?: Array<{ __typename?: 'CourseRosterData', id: string, name: string } | null> | null } | null };

export type RequestRosterExportMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type RequestRosterExportMutation = { __typename?: 'Mutation', requestRosterExport: { __typename?: 'RequestExportResponse', success: boolean, message?: string | null, data?: { __typename?: 'RequestExportData', jobId?: string | null } | null } };

export type RequestSubmissionExportMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestSubmissionExportMutation = { __typename?: 'Mutation', requestSubmissionExport: { __typename?: 'RequestExportResponse', success: boolean, message?: string | null, data?: { __typename?: 'RequestExportData', jobId?: string | null } | null } };

export type ResetAiTutorMutationVariables = Exact<{
  input: ResetAiTutorInput;
}>;


export type ResetAiTutorMutation = { __typename?: 'Mutation', resetAITutor?: { __typename?: 'AITutorResponse', success?: boolean | null, message?: string | null } | null };

export type CreateSocraticQuestionMutationVariables = Exact<{
  input: CreateSocraticQuestionInput;
}>;


export type CreateSocraticQuestionMutation = { __typename?: 'Mutation', createSocraticQuestion?: { __typename?: 'QuestionResponse', success?: boolean | null, message?: string | null, data?: { __typename?: 'Question', id: string, question?: string | null, totalScore?: number | null, rubrics: Array<{ __typename?: 'Rubric', id: string, component?: string | null, points?: number | null }> } | null } | null };

export type UpdateSocraticQuestionMutationVariables = Exact<{
  questionId: Scalars['ID']['input'];
  assessmentId: Scalars['ID']['input'];
  input: UpdateSocraticQuestionInput;
}>;


export type UpdateSocraticQuestionMutation = { __typename?: 'Mutation', updateSocraticQuestion?: { __typename?: 'QuestionResponse', success?: boolean | null, message?: string | null, data?: { __typename?: 'Question', id: string, question?: string | null, totalScore?: number | null, rubrics: Array<{ __typename?: 'Rubric', id: string, component?: string | null, points?: number | null }> } | null } | null };

export type DeleteSocraticQuestionMutationVariables = Exact<{
  questionId: Scalars['ID']['input'];
  assessmentId: Scalars['ID']['input'];
}>;


export type DeleteSocraticQuestionMutation = { __typename?: 'Mutation', deleteSocraticQuestion?: { __typename?: 'QuestionResponse', success?: boolean | null, message?: string | null, data?: { __typename?: 'Question', id: string } | null } | null };

export type GenerateSocraticRubricForQuestionMutationVariables = Exact<{
  input: GenerateSocraticRubricInput;
}>;


export type GenerateSocraticRubricForQuestionMutation = { __typename?: 'Mutation', generateSocraticRubricForQuestion?: { __typename?: 'SocraticRubricResponse', success?: boolean | null, message?: string | null, totalScore?: number | null, rubrics: Array<{ __typename?: 'SocraticQuestionRubric', component: string, points: number }> } | null };

export type SubmitStudentAssignmentMutationVariables = Exact<{
  assignmentId: Scalars['ID']['input'];
  files: Array<FileInput> | FileInput;
}>;


export type SubmitStudentAssignmentMutation = { __typename?: 'Mutation', submitStudentAssignment?: { __typename?: 'SubmissionResponse', success?: boolean | null, message?: string | null, data?: Array<{ __typename?: 'Submission', id: string } | null> | null } | null };

export type UpdateAiTutorMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  aiTutor: UpdateAiTutorInput;
}>;


export type UpdateAiTutorMutation = { __typename?: 'Mutation', updateAITutor?: { __typename?: 'AITutorResponse', success?: boolean | null, message?: string | null, data?: Array<{ __typename?: 'FormattedAITutor', id: string, title: string, description?: string | null, targetAudience?: string | null, dueDate?: any | null, objectives?: Array<{ __typename?: 'FormattedObjective', objective: string, sequence?: number | null, id?: string | null } | null> | null } | null> | null } | null };

export type UpdateAssessmentSubmissionGradeMutationVariables = Exact<{
  assessmentSubmissionId: Scalars['ID']['input'];
  updatedGradeEntry: UpdateAssessmentSubmissionUpdatedGrade;
  reviewWithoutAdjustment?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateAssessmentSubmissionGradeMutation = { __typename?: 'Mutation', updateAssessmentSubmissionGrade?: { __typename?: 'AssessmentSubmissionResponse', success?: boolean | null, message?: string | null, data?: { __typename?: 'AssessmentSubmission', id: string } | null } | null };

export type UpdateCourseDatesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateCourseDatesInput;
}>;


export type UpdateCourseDatesMutation = { __typename?: 'Mutation', updateCourseDates?: { __typename?: 'CourseResponse', success?: boolean | null, data?: Array<{ __typename?: 'Course', id: string } | null> | null } | null };

export type UpdateResourceOrderMutationVariables = Exact<{
  input: UpdateResourceOrderInput;
}>;


export type UpdateResourceOrderMutation = { __typename?: 'Mutation', updateResourceOrder?: { __typename?: 'ModuleResponse', success?: boolean | null, message?: string | null, data?: Array<{ __typename?: 'Module', id: string, resourceOrder?: Array<string> | null } | null> | null } | null };

export type UpdateStudentAssignmentGradeMutationVariables = Exact<{
  submissionId: Scalars['ID']['input'];
  updatePayload: UpdateStudentAssignmentGradeInput;
}>;


export type UpdateStudentAssignmentGradeMutation = { __typename?: 'Mutation', updateStudentAssignmentGrade?: { __typename?: 'SubmissionResponse', success?: boolean | null, message?: string | null, data?: Array<{ __typename?: 'Submission', id: string } | null> | null } | null };

export type AddCoursesToDegreeMutationVariables = Exact<{
  input: AddCoursesToDegreeInput;
}>;


export type AddCoursesToDegreeMutation = { __typename?: 'Mutation', addCoursesToDegree?: { __typename?: 'DegreeResponse', success?: boolean | null, message?: string | null } | null };

export type CreateDegreeMutationVariables = Exact<{
  name: Scalars['String']['input'];
  schoolId: Scalars['ID']['input'];
}>;


export type CreateDegreeMutation = { __typename?: 'Mutation', createDegree?: { __typename?: 'DegreeResponse', success?: boolean | null, message?: string | null, data?: Array<{ __typename?: 'Degree', id: string, name: string } | null> | null } | null };

export type DeleteDegreeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteDegreeMutation = { __typename?: 'Mutation', deleteDegree?: { __typename?: 'DegreeResponse', success?: boolean | null, message?: string | null } | null };

export type EnrollUserInDegreeMutationVariables = Exact<{
  degreeId: Scalars['ID']['input'];
}>;


export type EnrollUserInDegreeMutation = { __typename?: 'Mutation', enrollInDegree?: { __typename?: 'DegreeResponse', success?: boolean | null, data?: Array<{ __typename?: 'Degree', id: string, name: string, usersEnrolledIn: Array<{ __typename?: 'User', id: string }> } | null> | null } | null };

export type GenerateSuggestedDegreesMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateSuggestedDegreesMutation = { __typename?: 'Mutation', generateSuggestedDegrees: { __typename?: 'DegreeResponse', success?: boolean | null, message?: string | null, data?: Array<{ __typename?: 'Degree', id: string, name: string, created?: any | null, last_modified?: any | null } | null> | null } };

export type InviteUsersToEnrollInDegreeMutationVariables = Exact<{
  input: InviteUsersToEnrollInDegreeInput;
}>;


export type InviteUsersToEnrollInDegreeMutation = { __typename?: 'Mutation', inviteUsersToEnrollInDegree?: { __typename?: 'InviteUsersToEnrollInDegreeResponse', success?: boolean | null, count?: number | null, data?: Array<{ __typename?: 'InvitedUsers', email: string, id: string } | null> | null } | null };

export type RemoveCoursesFromDegreeMutationVariables = Exact<{
  input: RemoveCoursesFromDegreeInput;
}>;


export type RemoveCoursesFromDegreeMutation = { __typename?: 'Mutation', removeCoursesFromDegree?: { __typename?: 'DegreeResponse', success?: boolean | null, message?: string | null } | null };

export type RemoveStudentsFromDegreeMutationVariables = Exact<{
  input: RemoveStudentsFromDegreeInput;
}>;


export type RemoveStudentsFromDegreeMutation = { __typename?: 'Mutation', removeStudentsFromDegree?: { __typename?: 'DegreeResponse', success?: boolean | null, count?: number | null, data?: Array<{ __typename?: 'Degree', id: string, name: string } | null> | null } | null };

export type UpdateDegreeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  degree: UpdateDegreeInput;
}>;


export type UpdateDegreeMutation = { __typename?: 'Mutation', updateDegree?: { __typename?: 'DegreeResponse', success?: boolean | null, message?: string | null, data?: Array<{ __typename?: 'Degree', id: string, name: string, description?: string | null, usersEnrolledIn: Array<{ __typename?: 'User', id: string, name: string }>, coursesHasCourse: Array<{ __typename?: 'Course', id: string, name?: string | null }> } | null> | null } | null };

export type CreateAdminDocumentMutationVariables = Exact<{
  fileId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
}>;


export type CreateAdminDocumentMutation = { __typename?: 'Mutation', createAdminDocument?: { __typename?: 'DocumentResponse', success: boolean, message?: string | null, count?: number | null, data?: { __typename?: 'Document', id: string, title: string, status: DocumentStatus, created: any, last_modified: any, files: Array<{ __typename?: 'File', id: string, fileName: string, fileURL: string, status: FileStatus }> } | null } | null };

export type DeleteAdminDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAdminDocumentMutation = { __typename?: 'Mutation', deleteAdminDocument?: { __typename?: 'DocumentResponse', success: boolean, message?: string | null, count?: number | null, data?: { __typename?: 'Document', id: string } | null } | null };

export type GenerateKeywordsMutationVariables = Exact<{
  title: Scalars['String']['input'];
  description: Scalars['String']['input'];
}>;


export type GenerateKeywordsMutation = { __typename?: 'Mutation', generateYoutubeKeywords?: string | null };

export type CreateEnrollmentLinkMutationVariables = Exact<{
  input: CreateEnrollmentLinkInput;
}>;


export type CreateEnrollmentLinkMutation = { __typename?: 'Mutation', createEnrollmentLink?: { __typename?: 'EnrollmentLinkMutationResult', success: boolean, message?: string | null, count: number, data?: { __typename?: 'EnrollmentLinkMutationDataResult', id: string, lastModified: any } | null } | null };

export type DeleteEnrollmentLinkMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteEnrollmentLinkMutation = { __typename?: 'Mutation', deleteEnrollmentLink?: { __typename?: 'EnrollmentLinkMutationResult', success: boolean, message?: string | null, count: number } | null };

export type EnrollCourseWithTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type EnrollCourseWithTokenMutation = { __typename?: 'Mutation', enrollCourseWithToken?: { __typename?: 'EnrollmentLinkMutationResultExtended', success: boolean, message?: string | null, count: number, data?: { __typename?: 'EnrollmentLinkMutationDataExtendedResult', id: string, lastModified: any, courseId: string, courseName: string } | null } | null };

export type UpdateEnrollmentLinkMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateEnrollmentLinkInput;
}>;


export type UpdateEnrollmentLinkMutation = { __typename?: 'Mutation', updateEnrollmentLink?: { __typename?: 'EnrollmentLinkMutationResult', success: boolean, message?: string | null, count: number, data?: { __typename?: 'EnrollmentLinkMutationDataResult', id: string, lastModified: any } | null } | null };

export type GenerateUploadUrlMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
  storagePath: StoragePathType;
}>;


export type GenerateUploadUrlMutation = { __typename?: 'Mutation', generateUploadUrl: { __typename?: 'FileUploadResponse', message?: string | null, success: boolean, data?: Array<{ __typename?: 'FileUploadData', signedUrl?: string | null, uniqueFileName?: string | null, uploadedFileMimeType?: string | null, file?: { __typename?: 'File', id: string, fileName: string, fileURL: string, filePath: string, bucketName: string, created: any, status: FileStatus } | null } | null> | null } };

export type GetGcpSignedUrlForReadQueryVariables = Exact<{
  fileId: Scalars['ID']['input'];
  responseDisposition?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetGcpSignedUrlForReadQuery = { __typename?: 'Query', getGcpSignedUrlForRead: { __typename?: 'FileUploadResponse', message?: string | null, success: boolean, data?: Array<{ __typename?: 'FileUploadData', signedUrl?: string | null } | null> | null } };

export type MakeFilePublicMutationVariables = Exact<{
  fileId: Scalars['ID']['input'];
}>;


export type MakeFilePublicMutation = { __typename?: 'Mutation', makeFilePublic: { __typename?: 'FileResponse', success: boolean, message?: string | null, data?: Array<{ __typename?: 'File', id: string, fileName: string, fileURL: string, filePath: string, bucketName: string, created: any, status: FileStatus } | null> | null } };

export type AudioToggleUserMutationVariables = Exact<{
  audioOn: Scalars['Boolean']['input'];
}>;


export type AudioToggleUserMutation = { __typename?: 'Mutation', audioToggleUser?: { __typename?: 'AudioToggleUserResponse', audioOn?: boolean | null } | null };

export type HideLearningActivityIntroMutationVariables = Exact<{ [key: string]: never; }>;


export type HideLearningActivityIntroMutation = { __typename?: 'Mutation', hideLearningActivityIntro?: { __typename?: 'ResponseType', success: boolean, message?: string | null } | null };

export type UpdateNotificationsSettingMutationVariables = Exact<{
  dailyEmailOptIn: Scalars['Boolean']['input'];
}>;


export type UpdateNotificationsSettingMutation = { __typename?: 'Mutation', updateNotificationsSetting?: { __typename?: 'ResponseType', success: boolean, message?: string | null } | null };

export type UpdateNotificationsEmailSettingMutationVariables = Exact<{
  skipAllNotificationEmail: Scalars['Boolean']['input'];
}>;


export type UpdateNotificationsEmailSettingMutation = { __typename?: 'Mutation', updateNotificationsEmailSetting?: { __typename?: 'ResponseType', success: boolean, message?: string | null } | null };

export type AddToWhitelistMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type AddToWhitelistMutation = { __typename?: 'Mutation', addToWhitelist: { __typename?: 'WhitelistedEmail', email: string } };

export type CompleteCourseInvitationMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type CompleteCourseInvitationMutation = { __typename?: 'Mutation', completeCourseInvitation?: { __typename?: 'ResponseType', message?: string | null, success: boolean } | null };

export type CompleteDegreeInvitationMutationVariables = Exact<{
  degreeId: Scalars['ID']['input'];
}>;


export type CompleteDegreeInvitationMutation = { __typename?: 'Mutation', completeDegreeInvitation?: { __typename?: 'ResponseType', message?: string | null, success: boolean } | null };

export type CompletePendingInviteMutationVariables = Exact<{
  token: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  service: Scalars['String']['input'];
}>;


export type CompletePendingInviteMutation = { __typename?: 'Mutation', completePendingInvite?: { __typename?: 'ResponseType', message?: string | null, success: boolean } | null };

export type CreateEducationChildrenMutationVariables = Exact<{
  label: NodeLabel;
  name: Scalars['String']['input'];
}>;


export type CreateEducationChildrenMutation = { __typename?: 'Mutation', createEducationChildren: { __typename?: 'Generated', success: boolean, message?: string | null, data?: Array<{ __typename?: 'Subfield', name: string } | null> | null } };

export type DropUserFromCourseMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type DropUserFromCourseMutation = { __typename?: 'Mutation', dropUserFromCourse?: { __typename?: 'ResponseType', success: boolean, message?: string | null } | null };

export type EnrollUserInCourseMutationVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type EnrollUserInCourseMutation = { __typename?: 'Mutation', enrollUserInCourse?: { __typename?: 'ResponseType', success: boolean, message?: string | null } | null };

export type EnrollUserInTrackMutationVariables = Exact<{
  topicName: Scalars['String']['input'];
}>;


export type EnrollUserInTrackMutation = { __typename?: 'Mutation', enrollUserInTrack: { __typename?: 'ResponseType', success: boolean, message?: string | null } };

export type GetLearningTtsTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type GetLearningTtsTokenMutation = { __typename?: 'Mutation', getLearningTtsToken: { __typename?: 'LearningTtsTokenPayload', token: string } };

export type SetKnowledgeRelevanceMutationVariables = Exact<{
  nodeName: Scalars['String']['input'];
  nodeLabel: Scalars['String']['input'];
  isRelevant: Scalars['Boolean']['input'];
}>;


export type SetKnowledgeRelevanceMutation = { __typename?: 'Mutation', setKnowledgeRelevance: { __typename?: 'ResponseType', success: boolean, message?: string | null } };

export type UpdateTopicMutationVariables = Exact<{
  operationType: Scalars['String']['input'];
  topicName: Scalars['String']['input'];
}>;


export type UpdateTopicMutation = { __typename?: 'Mutation', updateTopic: { __typename?: 'ResponseType', success: boolean, message?: string | null } };

export type UpdateLearningObjectiveCompletionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  completed: Scalars['Boolean']['input'];
}>;


export type UpdateLearningObjectiveCompletionMutation = { __typename?: 'Mutation', updateLearningObjectiveCompletion: { __typename?: 'ResponseType', success: boolean, message?: string | null } };

export type MarkNotificationAsReadMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MarkNotificationAsReadMutation = { __typename?: 'Mutation', markNotificationAsRead: { __typename?: 'SingleNotificationResponse', success: boolean, count?: number | null, data?: { __typename?: 'Notification', id: string, title: string, message: string, created: any, isRead: boolean, readAt?: any | null, actionUrl?: string | null } | null } };

export type CreateOAuthClientMutationVariables = Exact<{
  input: OAuthClientInput;
}>;


export type CreateOAuthClientMutation = { __typename?: 'Mutation', createOAuthClient?: { __typename?: 'OAuthClientResponse', success?: boolean | null, message?: string | null, count?: number | null, data?: Array<{ __typename?: 'OAuthClient', id: string, clientId: string, clientSecret: string, created: any, tenant: { __typename?: 'Tenant', id?: string | null, tenantDomain: string } } | null> | null } | null };

export type DeleteOAuthClientMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteOAuthClientMutation = { __typename?: 'Mutation', deleteOAuthClient?: { __typename?: 'OAuthClientResponse', success?: boolean | null, message?: string | null, count?: number | null } | null };

export type UpdateOAuthClientMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: OAuthClientInput;
}>;


export type UpdateOAuthClientMutation = { __typename?: 'Mutation', updateOAuthClient?: { __typename?: 'OAuthClientResponse', success?: boolean | null, message?: string | null, count?: number | null, data?: Array<{ __typename?: 'OAuthClient', id: string, clientId: string, clientSecret: string, created: any, tenant: { __typename?: 'Tenant', id?: string | null, tenantDomain: string } } | null> | null } | null };

export type SetOnboardingStatusMutationVariables = Exact<{
  isOnboarded: Scalars['Boolean']['input'];
}>;


export type SetOnboardingStatusMutation = { __typename?: 'Mutation', setOnboardingStatus: { __typename?: 'ResponseType', message?: string | null, success: boolean } };

export type UpdateUserModalOnboardingMutationVariables = Exact<{
  modalOnboarding: Scalars['String']['input'];
}>;


export type UpdateUserModalOnboardingMutation = { __typename?: 'Mutation', updateUserModalOnboarding?: { __typename?: 'UpdateUserModalOnboardingResponse', modalOnboarding?: string | null } | null };

export type DeleteAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteAccountMutation = { __typename?: 'Mutation', deleteAccount?: { __typename?: 'ResponseType', success: boolean, message?: string | null } | null };

export type ResetAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type ResetAccountMutation = { __typename?: 'Mutation', resetAccount?: { __typename?: 'ResponseType', success: boolean, message?: string | null } | null };

export type AddTodoMutationVariables = Exact<{
  todo: AddTodoInput;
}>;


export type AddTodoMutation = { __typename?: 'Mutation', addTodo: { __typename?: 'TodoResponse', success: boolean, message?: string | null, count?: number | null, data?: Array<{ __typename?: 'Todo', id: string, name: string, description?: string | null, date?: any | null, completed_date?: any | null } | null> | null } };

export type UpdateTodoMutationVariables = Exact<{
  id: Scalars['String']['input'];
  todo: UpdateTodoInput;
}>;


export type UpdateTodoMutation = { __typename?: 'Mutation', updateTodo: { __typename?: 'TodoResponse', success: boolean, message?: string | null, count?: number | null, data?: Array<{ __typename?: 'Todo', id: string, name: string, description?: string | null, date?: any | null, completed_date?: any | null, completed: boolean } | null> | null } };

export type CreateSamlConfigMutationVariables = Exact<{
  input: SamlConfigCreateInput;
}>;


export type CreateSamlConfigMutation = { __typename?: 'Mutation', createSamlConfig?: { __typename?: 'SamlConfigResponse', success?: boolean | null, message?: string | null, data?: { __typename?: 'SamlConfig', id: string } | null } | null };

export type CreateTenantMutationVariables = Exact<{
  tenant: TenantInput;
}>;


export type CreateTenantMutation = { __typename?: 'Mutation', createTenant?: { __typename?: 'TenantResponse', success?: boolean | null, message?: string | null, count?: number | null, data?: Array<{ __typename?: 'Tenant', id?: string | null, tenantName: string, tenantDomain: string, ogDescription?: string | null, ogImage?: string | null, ogImageHeight?: string | null, ogImageWidth?: string | null, ogSiteName?: string | null, ogTitle?: string | null, ogType?: string | null, stripeSubscriptionId?: string | null, hasTrial?: boolean | null, stripeTrialDays?: number | null, externalSendGridDailyEmailTemplateId?: string | null, externalSendGridFromEmail?: string | null, externalSendGridFromName?: string | null, externalSendGridTwilioServiceSID?: string | null, moderationSexual?: boolean | null, moderationHate?: boolean | null, moderationHarassment?: boolean | null, moderationSelfHarm?: boolean | null, moderationSexualMinors?: boolean | null, moderationHateThreatening?: boolean | null, moderationViolenceGraphic?: boolean | null, moderationSelfHarmIntent?: boolean | null, moderationSelfHarmInstructions?: boolean | null, moderationHarassmentThreatening?: boolean | null, moderationViolence?: boolean | null, companionName?: string | null, isCompanionMode?: boolean | null, key?: string | null, isLMS?: boolean | null, isLTI?: boolean | null, isAxioOffering?: boolean | null, isSuggestedInsights?: boolean | null, hasCourseEnrollment?: boolean | null, doRAG?: boolean | null, primaryColor?: string | null, gameMenuBg?: string | null, gameMenuTrack?: string | null, gameMenuProgress?: string | null, gameMenuCardBg?: string | null, emulationStatement?: string | null, learningEmulationStatement?: string | null, logo?: string | null, miniLogo?: string | null, proLogo?: string | null, showMiniLogo?: boolean | null, scope?: Array<string | null> | null, additionalScope?: Array<string | null> | null, termsOfServiceLink?: string | null, generalPrompt?: string | null, onboardingPrompt?: string | null, customNews?: boolean | null, newsSearchTerms?: string | null, showFeedback?: boolean | null, bugReportEmails?: Array<string> | null, upgradeModalBody?: string | null, isFreemium?: boolean | null, hasEmailVerification?: boolean | null, hasDegrees?: boolean | null, created?: any | null, last_modified?: any | null, isDailyEventEnabled?: boolean | null, emailFooterColor?: string | null, emailBackgroundColor?: string | null, hasProFlow?: boolean | null, stripeSecretKey?: string | null, allowFormSignup?: boolean | null, autoEnrollCourses?: Array<string | null> | null, hasLearningTopicsInChat?: boolean | null, favicon16Url?: string | null, favicon32Url?: string | null, favicon48Url?: string | null, favicon180Url?: string | null, favicon192Url?: string | null, favicon512Url?: string | null, faviconIcoUrl?: string | null, isTeacherNotifiedOnEnrollment?: boolean | null, allowStripeDiscountCodes?: boolean | null, officialTranscriptsUrl?: string | null, financialInformationUrl?: string | null, helpCenterUrl?: string | null, schoolResourcesUrl?: string | null, reportProblemUrl?: string | null, scheduleAdvisorCallUrl?: string | null, hasTurnBasedAssessments?: boolean | null, requireSSO?: boolean | null, allowThirdPartyCredentials?: boolean | null } | null> | null } | null };

export type DeleteSamlConfigMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSamlConfigMutation = { __typename?: 'Mutation', deleteSamlConfig?: { __typename?: 'SamlConfigResponse', success?: boolean | null, message?: string | null, data?: { __typename?: 'SamlConfig', id: string } | null } | null };

export type ParseAndSaveSamlMetadataMutationVariables = Exact<{
  metadataUrl: Scalars['String']['input'];
}>;


export type ParseAndSaveSamlMetadataMutation = { __typename?: 'Mutation', parseAndSaveSamlMetadata: { __typename?: 'SamlConfigResponse', success?: boolean | null, message?: string | null, data?: { __typename?: 'SamlConfig', id: string, entryPoint: string, issuer: string, cert: string, callbackUrl: string, emailAttribute?: string | null, firstNameAttribute?: string | null, lastNameAttribute?: string | null, signRequest?: boolean | null, signatureAlgorithm?: string | null, expiry?: string | null, tenant: { __typename?: 'Tenant', id?: string | null, tenantDomain: string } } | null } };

export type UpdateSamlConfigMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: SamlConfigUpdateInput;
}>;


export type UpdateSamlConfigMutation = { __typename?: 'Mutation', updateSamlConfig?: { __typename?: 'SamlConfigResponse', success?: boolean | null, message?: string | null, data?: { __typename?: 'SamlConfig', id: string } | null } | null };

export type UpdateTenantMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  tenant: TenantInput;
}>;


export type UpdateTenantMutation = { __typename?: 'Mutation', updateTenant?: { __typename?: 'TenantResponse', count?: number | null, success?: boolean | null, message?: string | null, data?: Array<{ __typename?: 'Tenant', id?: string | null, tenantDomain: string, ogDescription?: string | null, ogImage?: string | null, ogImageHeight?: string | null, ogImageWidth?: string | null, ogSiteName?: string | null, ogTitle?: string | null, ogType?: string | null, stripeSubscriptionId?: string | null, hasTrial?: boolean | null, stripeTrialDays?: number | null, externalSendGridDailyEmailTemplateId?: string | null, externalSendGridFromEmail?: string | null, externalSendGridFromName?: string | null, externalSendGridTwilioServiceSID?: string | null, moderationSexual?: boolean | null, moderationHate?: boolean | null, moderationHarassment?: boolean | null, moderationSelfHarm?: boolean | null, moderationSexualMinors?: boolean | null, moderationHateThreatening?: boolean | null, moderationViolenceGraphic?: boolean | null, moderationSelfHarmIntent?: boolean | null, moderationSelfHarmInstructions?: boolean | null, moderationHarassmentThreatening?: boolean | null, moderationViolence?: boolean | null, companionName?: string | null, isCompanionMode?: boolean | null, key?: string | null, isLMS?: boolean | null, isLTI?: boolean | null, isAxioOffering?: boolean | null, isSuggestedInsights?: boolean | null, axioSchools?: Array<string | null> | null, primaryColor?: string | null, gameMenuBg?: string | null, gameMenuTrack?: string | null, gameMenuProgress?: string | null, gameMenuCardBg?: string | null, emulationStatement?: string | null, learningEmulationStatement?: string | null, logo?: string | null, miniLogo?: string | null, proLogo?: string | null, showMiniLogo?: boolean | null, scope?: Array<string | null> | null, additionalScope?: Array<string | null> | null, termsOfServiceLink?: string | null, generalPrompt?: string | null, onboardingPrompt?: string | null, customNews?: boolean | null, newsSearchTerms?: string | null, showFeedback?: boolean | null, bugReportEmails?: Array<string> | null, upgradeModalBody?: string | null, isFreemium?: boolean | null, hasEmailVerification?: boolean | null, created?: any | null, last_modified?: any | null, hasProFlow?: boolean | null, stripeSecretKey?: string | null, hasDegrees?: boolean | null, hasLearningTopicsInChat?: boolean | null, hasTurnBasedAssessments?: boolean | null, allowThirdPartyCredentials?: boolean | null } | null> | null } | null };

export type UpdateTenantSettingsMutationVariables = Exact<{
  settings: TenantSettingsInput;
}>;


export type UpdateTenantSettingsMutation = { __typename?: 'Mutation', updateTenantSettings?: { __typename?: 'TenantResponse', count?: number | null, success?: boolean | null, message?: string | null, data?: Array<{ __typename?: 'Tenant', id?: string | null, primaryColor?: string | null, financialInformationUrl?: string | null, helpCenterUrl?: string | null, schoolResourcesUrl?: string | null, officialTranscriptsUrl?: string | null, logo?: string | null } | null> | null } | null };

export type UploadFaviconMutationVariables = Exact<{
  favicon: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  size: Scalars['Int']['input'];
}>;


export type UploadFaviconMutation = { __typename?: 'Mutation', uploadFavicon?: { __typename?: 'UploadFaviconResponse', success?: boolean | null, message?: string | null, data?: string | null } | null };

export type UpdateContentSafetySettingsMutationVariables = Exact<{
  settings: ContentSafetySettingsInput;
}>;


export type UpdateContentSafetySettingsMutation = { __typename?: 'Mutation', updateContentSafetySettings?: { __typename?: 'ContentSafetySettingsResponse', count: number, success: boolean, message?: string | null, data?: Array<{ __typename?: 'ContentSafetySettings', sexual: boolean, hate: boolean, harassment: boolean, selfHarm: boolean, violence: boolean } | null> | null } | null };

export type AssignCourseToFacultyMutationVariables = Exact<{
  userIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
}>;


export type AssignCourseToFacultyMutation = { __typename?: 'Mutation', assignCourseToFaculty?: { __typename?: 'ResponseType', success: boolean, message?: string | null } | null };

export type InviteUserToSchoolMutationVariables = Exact<{
  input: InviteUserToSchoolInput;
}>;


export type InviteUserToSchoolMutation = { __typename?: 'Mutation', inviteUserToSchool?: { __typename?: 'ResponseType', success: boolean, message?: string | null } | null };

export type RemoveCourseAssignmentFromFacultyMutationVariables = Exact<{
  userIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
}>;


export type RemoveCourseAssignmentFromFacultyMutation = { __typename?: 'Mutation', removeCourseAssignmentFromFaculty?: { __typename?: 'ResponseType', success: boolean, message?: string | null } | null };

export type RevokeFacultyMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type RevokeFacultyMutation = { __typename?: 'Mutation', revokeFaculty?: { __typename?: 'ResponseType', success: boolean, message?: string | null } | null };

export type UpdateFacultyProfileMutationVariables = Exact<{
  input: UpdateFacultyProfileInput;
}>;


export type UpdateFacultyProfileMutation = { __typename?: 'Mutation', updateFacultyProfile?: { __typename?: 'ResponseType', success: boolean, message?: string | null } | null };

export type UpdateUserLearningPreferencesMutationVariables = Exact<{
  input: UpdateUserLearningPreferencesInput;
}>;


export type UpdateUserLearningPreferencesMutation = { __typename?: 'Mutation', updateUserLearningPreferences: { __typename?: 'UserLearningPreferences', id: string, interests?: Array<string> | null, careerInterests?: Array<string> | null, skillsToImprove?: Array<string> | null, learningStyles?: Array<string> | null, motivations?: Array<string> | null, semesterGoal?: string | null, studyTimePreference?: StudyTime | null, checkInFrequency?: CheckInFrequency | null, assignmentReminders?: boolean | null, textReminders?: boolean | null } };

export type UpsertCompanionOnboardingStateMutationVariables = Exact<{
  input: CompanionOnboardingStateInput;
}>;


export type UpsertCompanionOnboardingStateMutation = { __typename?: 'Mutation', upsertCompanionOnboardingState: { __typename?: 'UpdateCompanionOnboardingResponse', success: boolean, message?: string | null, state?: { __typename?: 'CompanionOnboardingState', status: CompanionOnboardingStatus, step?: number | null, deferredUntil?: any | null, last_modified?: any | null, payload?: { __typename?: 'UserLearningPreferences', interests?: Array<string> | null, careerInterests?: Array<string> | null, skillsToImprove?: Array<string> | null, learningStyles?: Array<string> | null, motivations?: Array<string> | null, semesterGoal?: string | null, studyTimePreference?: StudyTime | null, checkInFrequency?: CheckInFrequency | null, assignmentReminders?: boolean | null, textReminders?: boolean | null } | null } | null } };

export type EndVisitSessionMutationVariables = Exact<{
  sessionId: Scalars['ID']['input'];
}>;


export type EndVisitSessionMutation = { __typename?: 'Mutation', endVisitSession: { __typename?: 'VisitSession', id: string, startTime: any, lastActiveTime: any, ended: boolean } };

export type StartVisitSessionMutationVariables = Exact<{ [key: string]: never; }>;


export type StartVisitSessionMutation = { __typename?: 'Mutation', startVisitSession: { __typename?: 'VisitSession', id: string, startTime: any, lastActiveTime: any } };

export type TrackPageVisitMutationVariables = Exact<{
  sessionId: Scalars['ID']['input'];
  path: Scalars['String']['input'];
}>;


export type TrackPageVisitMutation = { __typename?: 'Mutation', trackPageVisit: { __typename?: 'PageVisit', id: string, path: string, timestamp: any } };

export type UpdateVisitSessionMutationVariables = Exact<{
  sessionId: Scalars['ID']['input'];
}>;


export type UpdateVisitSessionMutation = { __typename?: 'Mutation', updateVisitSession: { __typename?: 'VisitSession', id: string, lastActiveTime: any } };

export type CreateVisualizationFromContentMutationVariables = Exact<{
  title: Scalars['String']['input'];
  description: Scalars['String']['input'];
  objectives: Array<ObjectiveInput> | ObjectiveInput;
}>;


export type CreateVisualizationFromContentMutation = { __typename?: 'Mutation', createVisualizationFromContent?: { __typename?: 'VisualizationResponse', success?: boolean | null, message?: string | null, count?: number | null, data?: Array<{ __typename?: 'FormattedVisualization', id: string, code?: string | null, visualizationType?: string | null, created?: any | null, lastModified?: any | null } | null> | null } | null };

export type DeleteVisualizationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteVisualizationMutation = { __typename?: 'Mutation', deleteVisualization?: { __typename?: 'VisualizationResponse', count?: number | null, message?: string | null, success?: boolean | null } | null };

export type UpdateVisualizationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  description: Scalars['String']['input'];
  objectives: Array<ObjectiveInput> | ObjectiveInput;
}>;


export type UpdateVisualizationMutation = { __typename?: 'Mutation', updateVisualization?: { __typename?: 'VisualizationResponse', success?: boolean | null, message?: string | null, count?: number | null, data?: Array<{ __typename?: 'FormattedVisualization', id: string, code?: string | null, visualizationType?: string | null, created?: any | null, lastModified?: any | null } | null> | null } | null };

export type GetUserChatMessageAnalyticsQueryVariables = Exact<{
  input: UserChatMessageAnalyticsInput;
}>;


export type GetUserChatMessageAnalyticsQuery = { __typename?: 'Query', getUserChatMessageAnalytics?: { __typename?: 'UserChatMessageAnalyticsResponse', success?: boolean | null, message?: string | null, count?: number | null, totalCount?: number | null, data?: Array<{ __typename?: 'UserChatMessageAnalyticsData', id?: string | null, name?: string | null, email?: string | null, studentMessagesCount?: number | null, aiMessagesCount?: number | null, totalMessages?: number | null } | null> | null, availableCourses?: Array<{ __typename?: 'Course', id: string, name?: string | null } | null> | null } | null };

export type GetAdminDashboardMetricsQueryVariables = Exact<{
  schoolId: Scalars['ID']['input'];
}>;


export type GetAdminDashboardMetricsQuery = { __typename?: 'Query', getAdminDashboardMetrics: { __typename?: 'AdminDashboardResponse', success: boolean, message?: string | null, data: { __typename?: 'AdminDashboardMetrics', totalStudents: number, activeCourses: number } } };

export type GetActivityCompletionDetailsQueryVariables = Exact<{
  aiTutorId: Scalars['ID']['input'];
}>;


export type GetActivityCompletionDetailsQuery = { __typename?: 'Query', getActivityCompletionDetails: { __typename?: 'ActivityCompletionDetailsResponse', success: boolean, message?: string | null, count: number, data: Array<{ __typename?: 'ActivityCompletionDetailsFull', id: string, label: string, module_id?: string | null, module_name?: string | null, course_id?: string | null, course_name?: string | null, completionStats: { __typename?: 'CompletionStats', completed: number, inProgress: number, notStarted: number }, details: { __typename?: 'ActivityCompletionDetailsObjectives', objectives: Array<{ __typename?: 'ObjectiveCompletionDetails', id: string, label: string, completionStats: { __typename?: 'CompletionStats', completed: number, inProgress: number, notStarted: number } }> } }> } };

export type GetCourseCompletionDetailsQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type GetCourseCompletionDetailsQuery = { __typename?: 'Query', getCourseCompletionDetails: { __typename?: 'CourseCompletionDetailsResponse', success: boolean, message?: string | null, count: number, data: Array<{ __typename?: 'CourseCompletionDetails', id: string, label: string, completionStats: { __typename?: 'CompletionStats', completed: number, inProgress: number, notStarted: number }, details: { __typename?: 'CourseCompletionDetailsData', modules: Array<{ __typename?: 'ModuleCompletionDetails', id: string, label: string, completionStats: { __typename?: 'CompletionStats', completed: number, inProgress: number, notStarted: number }, details: { __typename?: 'ModuleCompletionDetailsData', activities: Array<{ __typename?: 'ActivityCompletionDetails', id: string, label: string, completionStats: { __typename?: 'CompletionStats', completed: number, inProgress: number, notStarted: number }, details: { __typename?: 'ActivityCompletionDetailsData', objectives: Array<{ __typename?: 'ObjectiveCompletionDetails', id: string, label: string, completionStats: { __typename?: 'CompletionStats', completed: number, inProgress: number, notStarted: number } }> } }> } }> } }> } };

export type GetCourseCompletionSummaryBySchoolQueryVariables = Exact<{
  schoolId: Scalars['ID']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCourseCompletionSummaryBySchoolQuery = { __typename?: 'Query', getCourseCompletionSummaryBySchool?: { __typename?: 'CourseCompletionSummaryResponse', success: boolean, message?: string | null, count: number, data: Array<{ __typename?: 'CourseCompletionSummary', id: string, label: string, completionStats: { __typename?: 'CompletionStats', completed: number, inProgress: number, notStarted: number } }> } | null };

export type GetModuleCompletionDetailsQueryVariables = Exact<{
  moduleId: Scalars['ID']['input'];
}>;


export type GetModuleCompletionDetailsQuery = { __typename?: 'Query', getModuleCompletionDetails: { __typename?: 'ModuleCompletionDetailsResponse', success: boolean, message?: string | null, count: number, data: Array<{ __typename?: 'ModuleCompletionDetailsFull', id: string, label: string, course_id: string, course_name: string, completionStats: { __typename?: 'CompletionStats', completed: number, inProgress: number, notStarted: number }, details: { __typename?: 'ModuleCompletionDetailsActivities', activities: Array<{ __typename?: 'ActivityCompletionDetails', id: string, label: string, completionStats: { __typename?: 'CompletionStats', completed: number, inProgress: number, notStarted: number }, details: { __typename?: 'ActivityCompletionDetailsData', objectives: Array<{ __typename?: 'ObjectiveCompletionDetails', id: string, label: string, completionStats: { __typename?: 'CompletionStats', completed: number, inProgress: number, notStarted: number } }> } }> } }> } };

export type GetObjectiveCompletionDetailsQueryVariables = Exact<{
  objectiveId: Scalars['ID']['input'];
}>;


export type GetObjectiveCompletionDetailsQuery = { __typename?: 'Query', getObjectiveCompletionDetails: { __typename?: 'ObjectiveCompletionDetailsResponse', success: boolean, message?: string | null, count: number, data: Array<{ __typename?: 'ObjectiveCompletionDetailsFull', id: string, label: string, aiTutor_id?: string | null, aiTutor_name?: string | null, module_id?: string | null, module_name?: string | null, course_id?: string | null, course_name?: string | null, completionStats: { __typename?: 'CompletionStats', completed: number, inProgress: number, notStarted: number } }> } };

export type GetActivityAnalyticsByModuleQueryVariables = Exact<{
  moduleId: Scalars['ID']['input'];
}>;


export type GetActivityAnalyticsByModuleQuery = { __typename?: 'Query', getActivityAnalyticsByModule?: { __typename?: 'ActivityAnalyticsResponse', success: boolean, message?: string | null, count: number, data: Array<{ __typename?: 'ActivityAnalytics', id: string, label: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, sentiment: string, enrollment: number, average_time_taken?: number | null, summaries?: Array<string | null> | null, success_points_details?: Array<string | null> | null, confusion_points_details?: Array<string | null> | null, further_recommendations?: Array<string | null> | null, details: { __typename?: 'ActivityAnalyticsDetails', objectives: Array<{ __typename?: 'ObjectiveAnalytics', id: string, label: string, success_points: number, confusion_points: number, average_time_taken?: number | null }> } }> } | null };

export type GetCourseAnalyticsByIdQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type GetCourseAnalyticsByIdQuery = { __typename?: 'Query', getCourseAnalyticsById?: { __typename?: 'CourseDetailedResponse', success: boolean, message?: string | null, count: number, data: Array<{ __typename?: 'CourseDetailedAnalytics', id: string, label: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, sentiment: string, enrollment: number, average_time_taken?: number | null, details: { __typename?: 'CourseAnalyticsDetails', modules: Array<{ __typename?: 'ModuleAnalytics', id: string, label: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, sentiment: string, enrollment: number, average_time_taken?: number | null, details: { __typename?: 'ModuleAnalyticsDetails', activities: Array<{ __typename?: 'ActivityAnalytics', id: string, label: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, sentiment: string, enrollment: number, average_time_taken?: number | null, summaries?: Array<string | null> | null, success_points_details?: Array<string | null> | null, confusion_points_details?: Array<string | null> | null, further_recommendations?: Array<string | null> | null, details: { __typename?: 'ActivityAnalyticsDetails', objectives: Array<{ __typename?: 'ObjectiveAnalytics', id: string, label: string, success_points: number, confusion_points: number, average_time_taken?: number | null, progress_details?: { __typename?: 'ProgressDetails', level?: string | null, confusion_points?: Array<string | null> | null, success_points?: Array<string | null> | null, average_student_question_complexity?: string | null, further_recommendations?: Array<string | null> | null, questions_asked?: number | null, distractions?: Array<string | null> | null, sentiment_analysis?: string | null, originality_analysis?: string | null, summary?: string | null, num_messages?: number | null, student_messages_count?: number | null, ai_messages_count?: number | null, average_student_response_time?: number | null, average_ai_response_time?: number | null, total_time_taken?: number | null } | null }> } }> } }> } }> } | null };

export type GetCourseHierarchyQueryVariables = Exact<{
  schoolId: Scalars['ID']['input'];
}>;


export type GetCourseHierarchyQuery = { __typename?: 'Query', getCourseHierarchy?: { __typename?: 'CourseHierarchyResponse', success: boolean, message?: string | null, count: number, data: Array<{ __typename?: 'HierarchyCourse', id: string, label: string, level: string, details?: { __typename?: 'HierarchyCourseDetails', modules: Array<{ __typename?: 'HierarchyModule', id: string, label: string, level: string, parentCourse?: { __typename?: 'ParentRef', id: string, label: string } | null, details?: { __typename?: 'HierarchyModuleDetails', activities: Array<{ __typename?: 'HierarchyActivity', id: string, label: string, level: string, parentModule?: { __typename?: 'ParentRef', id: string, label: string } | null, parentCourse?: { __typename?: 'ParentRef', id: string, label: string } | null, details?: { __typename?: 'HierarchyActivityDetails', objectives: Array<{ __typename?: 'HierarchyObjective', id: string, label: string, level: string, parentActivity?: { __typename?: 'ParentRef', id: string, label: string } | null, parentModule?: { __typename?: 'ParentRef', id: string, label: string } | null, parentCourse?: { __typename?: 'ParentRef', id: string, label: string } | null }> } | null }> } | null }> } | null }> } | null };

export type GetCoursesSummaryBySchoolQueryVariables = Exact<{
  schoolId: Scalars['ID']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCoursesSummaryBySchoolQuery = { __typename?: 'Query', getCoursesSummaryBySchool?: { __typename?: 'CourseDetailedResponse', success: boolean, message?: string | null, count: number, data: Array<{ __typename?: 'CourseDetailedAnalytics', id: string, label: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, sentiment: string, enrollment: number, average_time_taken?: number | null, details: { __typename?: 'CourseAnalyticsDetails', modules: Array<{ __typename?: 'ModuleAnalytics', id: string, label: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, sentiment: string, enrollment: number, average_time_taken?: number | null, details: { __typename?: 'ModuleAnalyticsDetails', activities: Array<{ __typename?: 'ActivityAnalytics', id: string, label: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, sentiment: string, enrollment: number, average_time_taken?: number | null, summaries?: Array<string | null> | null, success_points_details?: Array<string | null> | null, confusion_points_details?: Array<string | null> | null, further_recommendations?: Array<string | null> | null, details: { __typename?: 'ActivityAnalyticsDetails', objectives: Array<{ __typename?: 'ObjectiveAnalytics', id: string, label: string, success_points: number, confusion_points: number, average_time_taken?: number | null, progress_details?: { __typename?: 'ProgressDetails', level?: string | null, confusion_points?: Array<string | null> | null, success_points?: Array<string | null> | null, average_student_question_complexity?: string | null, further_recommendations?: Array<string | null> | null, questions_asked?: number | null, distractions?: Array<string | null> | null, sentiment_analysis?: string | null, originality_analysis?: string | null, summary?: string | null, num_messages?: number | null, student_messages_count?: number | null, ai_messages_count?: number | null, average_student_response_time?: number | null, average_ai_response_time?: number | null, total_time_taken?: number | null } | null }> } }> } }> } }> } | null };

export type GetModuleAnalyticsByCourseQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type GetModuleAnalyticsByCourseQuery = { __typename?: 'Query', getModuleAnalyticsByCourse?: { __typename?: 'ModuleAnalyticsResponse', success: boolean, message?: string | null, count: number, data: Array<{ __typename?: 'ModuleAnalytics', id: string, label: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, sentiment: string, enrollment: number, average_time_taken?: number | null, details: { __typename?: 'ModuleAnalyticsDetails', activities: Array<{ __typename?: 'ActivityAnalytics', id: string, label: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, sentiment: string, enrollment: number, average_time_taken?: number | null }> } }> } | null };

export type GetObjectiveAnalyticsByActivityQueryVariables = Exact<{
  aiTutorId: Scalars['ID']['input'];
}>;


export type GetObjectiveAnalyticsByActivityQuery = { __typename?: 'Query', getObjectiveAnalyticsByActivity?: { __typename?: 'ObjectiveAnalyticsResponse', success: boolean, message?: string | null, count: number, data: Array<{ __typename?: 'ObjectiveAnalytics', id: string, label: string, success_points: number, confusion_points: number, average_time_taken?: number | null }> } | null };

export type GetActivityInsightsDataQueryVariables = Exact<{
  aiTutorId: Scalars['ID']['input'];
}>;


export type GetActivityInsightsDataQuery = { __typename?: 'Query', getActivityInsightsData: { __typename?: 'ActivityInsightsResponse', success: boolean, message?: string | null, count: number, data: Array<{ __typename?: 'ActivityInsights', id: string, label: string, success_points_details: Array<string>, confusion_points_details: Array<string>, further_recommendations: Array<string>, average_time_taken: number, completion_rate: number, student_engagement: string, overall_sentiment: string }> } };

export type GetStudentChatAnalyticsQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  schoolId: Scalars['ID']['input'];
}>;


export type GetStudentChatAnalyticsQuery = { __typename?: 'Query', getStudentChatAnalytics: { __typename?: 'StudentChatAnalyticsResponse', success: boolean, message?: string | null, count: number, data: Array<{ __typename?: 'StudentChatAnalytics', id: string, courseId: string, courseName: string, moduleId: string, moduleName: string, activityId: string, activityName: string, sentiment_analysis?: string | null, originality_analysis?: string | null, num_messages: number, student_messages_count: number, ai_messages_count: number, average_student_response_time: number, average_ai_response_time: number, total_time_taken: number }> } };

export type GetStudentLearningInsightsQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  schoolId: Scalars['ID']['input'];
}>;


export type GetStudentLearningInsightsQuery = { __typename?: 'Query', getStudentLearningInsights: { __typename?: 'StudentLearningInsightsResponse', success: boolean, message?: string | null, count: number, data: Array<{ __typename?: 'StudentLearningInsights', id: string, label: string, success_points_details: Array<string>, confusion_points_details: Array<string>, further_recommendations: Array<string>, total_time_taken: number, active_interaction_count: number, total_sessions: number, questions_asked: number }> } };

export type GetStudentActivityProgressQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  aiTutorId: Scalars['ID']['input'];
}>;


export type GetStudentActivityProgressQuery = { __typename?: 'Query', getStudentActivityProgress?: { __typename?: 'StudentActivityProgressResponse', success: boolean, message?: string | null, count: number, data: Array<{ __typename?: 'StudentActivityProgressData', id: string, label: string, module_id?: string | null, module_name?: string | null, course_id?: string | null, course_name?: string | null, student_id: string, student_name: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, sentiment: string, completion_percentage?: number | null, total_time_taken?: number | null, chatAnalytics?: Array<{ __typename?: 'ChatAnalytics', id: string, level?: string | null, confusion_points?: Array<string | null> | null, success_points?: Array<string | null> | null, average_student_question_complexity?: number | null, further_recommendations: Array<string>, questions_asked: number, distractions: number, sentiment_analysis?: string | null, originality_analysis?: string | null, summary: string, num_messages: number, student_messages_count: number, ai_messages_count: number, average_student_response_time: number, average_ai_response_time: number, total_time_taken: number } | null> | null, details: { __typename?: 'ActivityProgressDetails', objectives: Array<{ __typename?: 'ObjectiveProgressAnalytics', id: string, label: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, status?: string | null, progress_details?: { __typename?: 'ProgressDetails', level?: string | null, confusion_points?: Array<string | null> | null, success_points?: Array<string | null> | null, average_student_question_complexity?: string | null, further_recommendations?: Array<string | null> | null, questions_asked?: number | null, distractions?: Array<string | null> | null, sentiment_analysis?: string | null, originality_analysis?: string | null, summary?: string | null, num_messages?: number | null, student_messages_count?: number | null, ai_messages_count?: number | null, average_student_response_time?: number | null, average_ai_response_time?: number | null, total_time_taken?: number | null } | null }> } }> } | null };

export type GetStudentCourseProgressQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
}>;


export type GetStudentCourseProgressQuery = { __typename?: 'Query', getStudentCourseProgress?: { __typename?: 'StudentCourseProgressResponse', success: boolean, message?: string | null, count: number, data: Array<{ __typename?: 'CourseProgressAnalytics', id: string, label: string, student_id?: string | null, student_name?: string | null, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, sentiment: string, completion_percentage?: number | null, total_time_taken?: number | null, details: { __typename?: 'CourseProgressDetails', modules: Array<{ __typename?: 'ModuleProgressAnalytics', id: string, label: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, sentiment: string, completion_percentage?: number | null, total_time_taken?: number | null, details: { __typename?: 'ModuleProgressDetails', activities: Array<{ __typename?: 'ActivityProgressAnalytics', id: string, label: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, sentiment: string, completion_percentage?: number | null, total_time_taken?: number | null, details: { __typename?: 'ActivityProgressDetails', objectives: Array<{ __typename?: 'ObjectiveProgressAnalytics', id: string, label: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, status?: string | null }> } }> } }> } }> } | null };

export type GetStudentDetailedAnalyticsQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  schoolId: Scalars['ID']['input'];
}>;


export type GetStudentDetailedAnalyticsQuery = { __typename?: 'Query', getStudentDetailedAnalytics?: { __typename?: 'StudentDetailedAnalyticsResponse', success: boolean, message?: string | null, count: number, data: Array<{ __typename?: 'StudentDetailedAnalytics', id: string, label: string, status: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, sentiment: string, completion_percentage?: number | null, total_time_taken?: number | null, details: { __typename?: 'StudentAnalyticsDetails', courses: Array<{ __typename?: 'CourseProgressAnalytics', id: string, label: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, sentiment: string, completion_percentage?: number | null, total_time_taken?: number | null, details: { __typename?: 'CourseProgressDetails', modules: Array<{ __typename?: 'ModuleProgressAnalytics', id: string, label: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, sentiment: string, completion_percentage?: number | null, total_time_taken?: number | null, details: { __typename?: 'ModuleProgressDetails', activities: Array<{ __typename?: 'ActivityProgressAnalytics', id: string, label: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, sentiment: string, completion_percentage?: number | null, total_time_taken?: number | null, chatAnalytics?: Array<{ __typename?: 'ChatAnalytics', id: string, level?: string | null, confusion_points?: Array<string | null> | null, success_points?: Array<string | null> | null, average_student_question_complexity?: number | null, further_recommendations: Array<string>, questions_asked: number, distractions: number, sentiment_analysis?: string | null, originality_analysis?: string | null, summary: string, num_messages: number, student_messages_count: number, ai_messages_count: number, average_student_response_time: number, average_ai_response_time: number, total_time_taken: number } | null> | null, details: { __typename?: 'ActivityProgressDetails', objectives: Array<{ __typename?: 'ObjectiveProgressAnalytics', id: string, label: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, status?: string | null, progress_details?: { __typename?: 'ProgressDetails', level?: string | null, confusion_points?: Array<string | null> | null, success_points?: Array<string | null> | null, average_student_question_complexity?: string | null, further_recommendations?: Array<string | null> | null, questions_asked?: number | null, distractions?: Array<string | null> | null, sentiment_analysis?: string | null, originality_analysis?: string | null, summary?: string | null, num_messages?: number | null, student_messages_count?: number | null, ai_messages_count?: number | null, average_student_response_time?: number | null, average_ai_response_time?: number | null, total_time_taken?: number | null } | null }> } }> } }> } }> } }> } | null };

export type GetStudentModuleProgressQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
  moduleId: Scalars['ID']['input'];
}>;


export type GetStudentModuleProgressQuery = { __typename?: 'Query', getStudentModuleProgress?: { __typename?: 'StudentModuleProgressResponse', success: boolean, message?: string | null, count: number, data: Array<{ __typename?: 'StudentModuleProgressData', id: string, label: string, course_id?: string | null, course_name?: string | null, student_id: string, student_name: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, sentiment: string, completion_percentage?: number | null, total_time_taken?: number | null, details: { __typename?: 'ModuleProgressDetails', activities: Array<{ __typename?: 'ActivityProgressAnalytics', id: string, label: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, sentiment: string, completion_percentage?: number | null, total_time_taken?: number | null, details: { __typename?: 'ActivityProgressDetails', objectives: Array<{ __typename?: 'ObjectiveProgressAnalytics', id: string, label: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, status?: string | null }> } }> } }> } | null };

export type GetStudentsSummaryBySchoolQueryVariables = Exact<{
  schoolId: Scalars['ID']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetStudentsSummaryBySchoolQuery = { __typename?: 'Query', getStudentsSummaryBySchool?: { __typename?: 'StudentAnalyticsSummaryResponse', success: boolean, message?: string | null, count: number, data: Array<{ __typename?: 'StudentSummary', id: string, label: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, sentiment: string, total_time_taken?: number | null, schoolEnrollmentDate?: any | null }> } | null };

export type GetRecentActivityQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRecentActivityQuery = { __typename?: 'Query', getRecentActivity: { __typename?: 'AuditEventServiceResult', success: boolean, message: string, count: number, data: Array<{ __typename?: 'AuditEvent', id: string, type: AuditEventType, occurredAt: any, tenantId: string, actorId: string, subjectType: string, subjectId: string, relatedUserId?: string | null, diffKeys: Array<string>, diffBefore: Array<string>, diffAfter: Array<string>, actor?: { __typename?: 'User', id: string, name: string, email: string } | null, subjectCourse?: { __typename?: 'Course', id: string, name?: string | null } | null, subjectDegree?: { __typename?: 'Degree', id: string, name: string } | null, subjectUser?: { __typename?: 'User', id: string, name: string, email: string } | null }> } };

export type GetUserPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserPermissionsQuery = { __typename?: 'Query', getUserPermissions: Array<string> };

export type ValidateSessionQueryVariables = Exact<{ [key: string]: never; }>;


export type ValidateSessionQuery = { __typename?: 'Query', validateSession: { __typename?: 'SessionResponse', isValid: boolean } };

export type CareerByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CareerByIdQuery = { __typename?: 'Query', getCareerById?: { __typename?: 'Career', id: string, name: string, brief_description?: string | null, description?: string | null, created?: any | null, last_modified?: any | null, path?: any | null, trends?: any | null, pros?: string | null, cons?: string | null, skills?: string | null, core_skills?: string | null, growth?: string | null, salary?: string | null, url?: string | null } | null };

export type GetCareerHeaderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCareerHeaderQuery = { __typename?: 'Query', getCareerHeader: { __typename?: 'CareerHeader', jobTitle?: string | null, careerGoal?: string | null, careerName?: string | null, careerId?: string | null } };

export type GetCareerTopicsQueryVariables = Exact<{
  careerId: Scalars['ID']['input'];
}>;


export type GetCareerTopicsQuery = { __typename?: 'Query', getCareerTopics?: Array<{ __typename?: 'Topic', name: string, description?: string | null, mastery?: number | null } | null> | null };

export type GetCareersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCareersQuery = { __typename?: 'Query', getCareers?: Array<{ __typename?: 'Career', id: string, name: string, brief_description?: string | null, description?: string | null, created?: any | null, last_modified?: any | null, path?: any | null, trends?: any | null, pros?: string | null, cons?: string | null, skills?: string | null, core_skills?: string | null, growth?: string | null, salary?: string | null, url?: string | null } | null> | null };

export type DailyLimitQueryVariables = Exact<{ [key: string]: never; }>;


export type DailyLimitQuery = { __typename?: 'Query', getDailyLimit?: { __typename?: 'RateLimitResult', dailyRequests?: number | null, result?: boolean | null } | null };

export type GetChatByContextAndParamsQueryVariables = Exact<{
  context: Scalars['String']['input'];
  params?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetChatByContextAndParamsQuery = { __typename?: 'Query', getChatByContextAndParams?: { __typename?: 'ChatResponse', id: string, date?: string | null, name: string, objectId?: string | null, context?: string | null, params?: any | null, conversation: Array<{ __typename?: 'MessageResponse', id: string, sender?: string | null, content?: string | null, type?: string | null, nodeId?: string | null, snackType?: string | null, file?: { __typename?: 'File', fileName: string, id: string } | null, parameters?: { __typename?: 'ParametersType', lastGeneratedTopic?: string | null, lastGeneratedLabel?: string | null, questContext?: string | null, userResponse?: string | null } | null, aspectDetails?: { __typename?: 'AspectDetailsType', name?: string | null, category?: string | null, id?: number | null, friendId?: number | null, relationshipType?: string | null, connectionStrength?: number | null, frequencyOfInteraction?: string | null, lastInteractionDate?: any | null, sharedInterests?: Array<string | null> | null, sharedGoals?: Array<string | null> | null, sharedEventsAttended?: Array<string | null> | null, friendPersonalityTraits?: Array<string | null> | null, communicationChannel?: string | null, level?: string | null, startDate?: any | null, lastUpdated?: any | null, learningStyle?: string | null, language?: string | null, timeOfDay?: string | null, learningDuration?: number | null, contentType?: string | null, notificationPreferences?: string | null, type?: string | null, completionStatus?: string | null, deadline?: any | null, priority?: string | null, value?: number | null, description?: string | null, date?: any | null, importance?: number | null, status?: string | null, endDate?: any | null, text?: string | null, sentiment?: string | null, context?: string | null, intensity?: number | null, timestamp?: any | null, trigger?: string | null, calories?: number | null, carbohydrates_grams?: number | null, fat_grams?: number | null, fiber_grams?: number | null, protein_grams?: number | null, serving_size?: string | null, sodium_mg?: number | null, sugars_grams?: number | null, totalCalories?: number | null, totalCarbs?: number | null, totalFats?: number | null, totalProteins?: number | null, totalCaloriesBurned?: number | null, totalDurationMinutes?: number | null, totalWorkouts?: number | null, water_intake_oz?: number | null } | null }> } | null };

export type GetChatByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetChatByIdQuery = { __typename?: 'Query', getChatById?: { __typename?: 'ChatResponse', id: string, date?: string | null, name: string, objectId?: string | null, context?: string | null, params?: any | null, conversation: Array<{ __typename?: 'MessageResponse', id: string, sender?: string | null, content?: string | null, type?: string | null, nodeId?: string | null, snackType?: string | null, file?: { __typename?: 'File', fileName: string, id: string } | null, parameters?: { __typename?: 'ParametersType', lastGeneratedTopic?: string | null, lastGeneratedLabel?: string | null, questContext?: string | null, userResponse?: string | null } | null, aspectDetails?: { __typename?: 'AspectDetailsType', name?: string | null, category?: string | null, id?: number | null, friendId?: number | null, relationshipType?: string | null, connectionStrength?: number | null, frequencyOfInteraction?: string | null, lastInteractionDate?: any | null, sharedInterests?: Array<string | null> | null, sharedGoals?: Array<string | null> | null, sharedEventsAttended?: Array<string | null> | null, friendPersonalityTraits?: Array<string | null> | null, communicationChannel?: string | null, level?: string | null, startDate?: any | null, lastUpdated?: any | null, learningStyle?: string | null, language?: string | null, timeOfDay?: string | null, learningDuration?: number | null, contentType?: string | null, notificationPreferences?: string | null, type?: string | null, completionStatus?: string | null, deadline?: any | null, priority?: string | null, value?: number | null, description?: string | null, date?: any | null, importance?: number | null, status?: string | null, endDate?: any | null, text?: string | null, sentiment?: string | null, context?: string | null, intensity?: number | null, timestamp?: any | null, trigger?: string | null, calories?: number | null, carbohydrates_grams?: number | null, fat_grams?: number | null, fiber_grams?: number | null, protein_grams?: number | null, serving_size?: string | null, sodium_mg?: number | null, sugars_grams?: number | null, totalCalories?: number | null, totalCarbs?: number | null, totalFats?: number | null, totalProteins?: number | null, totalCaloriesBurned?: number | null, totalDurationMinutes?: number | null, totalWorkouts?: number | null, water_intake_oz?: number | null } | null }> } | null };

export type GetChatByObjectIdQueryVariables = Exact<{
  objectId: Scalars['ID']['input'];
  context: Scalars['String']['input'];
}>;


export type GetChatByObjectIdQuery = { __typename?: 'Query', getChatByObjectId?: { __typename?: 'ChatResponse', id: string, date?: string | null, name: string, objectId?: string | null, context?: string | null, params?: any | null, conversation: Array<{ __typename?: 'MessageResponse', id: string, sender?: string | null, content?: string | null, type?: string | null, nodeId?: string | null, snackType?: string | null, file?: { __typename?: 'File', fileName: string, id: string } | null, parameters?: { __typename?: 'ParametersType', lastGeneratedTopic?: string | null, lastGeneratedLabel?: string | null, questContext?: string | null, userResponse?: string | null } | null, aspectDetails?: { __typename?: 'AspectDetailsType', name?: string | null, category?: string | null, id?: number | null, friendId?: number | null, relationshipType?: string | null, connectionStrength?: number | null, frequencyOfInteraction?: string | null, lastInteractionDate?: any | null, sharedInterests?: Array<string | null> | null, sharedGoals?: Array<string | null> | null, sharedEventsAttended?: Array<string | null> | null, friendPersonalityTraits?: Array<string | null> | null, communicationChannel?: string | null, level?: string | null, startDate?: any | null, lastUpdated?: any | null, learningStyle?: string | null, language?: string | null, timeOfDay?: string | null, learningDuration?: number | null, contentType?: string | null, notificationPreferences?: string | null, type?: string | null, completionStatus?: string | null, deadline?: any | null, priority?: string | null, value?: number | null, description?: string | null, date?: any | null, importance?: number | null, status?: string | null, endDate?: any | null, text?: string | null, sentiment?: string | null, context?: string | null, intensity?: number | null, timestamp?: any | null, trigger?: string | null, calories?: number | null, carbohydrates_grams?: number | null, fat_grams?: number | null, fiber_grams?: number | null, protein_grams?: number | null, serving_size?: string | null, sodium_mg?: number | null, sugars_grams?: number | null, totalCalories?: number | null, totalCarbs?: number | null, totalFats?: number | null, totalProteins?: number | null, totalCaloriesBurned?: number | null, totalDurationMinutes?: number | null, totalWorkouts?: number | null, water_intake_oz?: number | null } | null }> } | null };

export type GetChatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetChatsQuery = { __typename?: 'Query', getChats?: Array<{ __typename?: 'Chat', id: string, date?: any | null, name: string, objectId?: string | null, context?: string | null, params?: any | null, url?: string | null } | null> | null };

export type GetCompanionChatByAiTutorIdQueryVariables = Exact<{
  aiTutorId: Scalars['ID']['input'];
}>;


export type GetCompanionChatByAiTutorIdQuery = { __typename?: 'Query', getCompanionChatByAiTutorId: { __typename?: 'GetCompanionChatByIdResult', success: boolean, message?: string | null, data?: { __typename?: 'ChatResponse', id: string, date?: string | null, name: string, objectId?: string | null, params?: any | null, url?: string | null, last_modified?: any | null, created?: any | null, workspacesHasChat: Array<{ __typename?: 'Workspace', id: string, name: string, created?: any | null, lastModified?: any | null, type?: WorkspaceType | null }>, conversation: Array<{ __typename?: 'MessageResponse', id: string, sender?: string | null, content?: string | null, created?: any | null, todos: Array<{ __typename?: 'Todo', id: string, name: string, priority?: string | null, completed: boolean, date?: any | null }>, assignments: Array<{ __typename?: 'Assignment', id: string, name?: string | null, course_id?: number | null, due_date?: any | null }>, files: Array<{ __typename?: 'File', id: string, fileName: string }> }> } | null } };

export type GetCompanionChatByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCompanionChatByIdQuery = { __typename?: 'Query', getCompanionChatById: { __typename?: 'GetCompanionChatByIdResult', success: boolean, message?: string | null, data?: { __typename?: 'ChatResponse', id: string, date?: string | null, name: string, objectId?: string | null, params?: any | null, url?: string | null, last_modified?: any | null, created?: any | null, workspacesHasChat: Array<{ __typename?: 'Workspace', id: string, name: string, created?: any | null, lastModified?: any | null, type?: WorkspaceType | null }>, conversation: Array<{ __typename?: 'MessageResponse', id: string, sender?: string | null, content?: string | null, created?: any | null, todos: Array<{ __typename?: 'Todo', id: string, name: string, priority?: string | null, completed: boolean, date?: any | null }>, assignments: Array<{ __typename?: 'Assignment', id: string, name?: string | null, course_id?: number | null, due_date?: any | null }>, files: Array<{ __typename?: 'File', id: string, fileName: string }> }> } | null } };

export type GetFlaggedMessagesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type GetFlaggedMessagesQuery = { __typename?: 'Query', getFlaggedMessages: { __typename?: 'SafetyCaseResponse', success: boolean, message?: string | null, count: number, data?: Array<{ __typename?: 'SafetyCase', messageId: string, studentName: string, studentEmail: string, categories: Array<ModerationCategory>, severity: Severity, time: any, caseDetails?: string | null }> | null } };

export type TodayChatQueryVariables = Exact<{
  timezone: Scalars['String']['input'];
}>;


export type TodayChatQuery = { __typename?: 'Query', getTodayChat?: { __typename?: 'ChatResponse', id: string, date?: string | null, name: string, timezone?: string | null, objectId?: string | null, context?: string | null, params?: any | null, conversation: Array<{ __typename?: 'MessageResponse', id: string, sender?: string | null, content?: string | null, type?: string | null, nodeId?: string | null, snackType?: string | null, file?: { __typename?: 'File', fileName: string, id: string } | null, parameters?: { __typename?: 'ParametersType', lastGeneratedTopic?: string | null, lastGeneratedLabel?: string | null, questContext?: string | null, userResponse?: string | null } | null, aspectDetails?: { __typename?: 'AspectDetailsType', name?: string | null, category?: string | null, id?: number | null, friendId?: number | null, relationshipType?: string | null, connectionStrength?: number | null, frequencyOfInteraction?: string | null, lastInteractionDate?: any | null, sharedInterests?: Array<string | null> | null, sharedGoals?: Array<string | null> | null, sharedEventsAttended?: Array<string | null> | null, friendPersonalityTraits?: Array<string | null> | null, communicationChannel?: string | null, level?: string | null, startDate?: any | null, lastUpdated?: any | null, learningStyle?: string | null, language?: string | null, timeOfDay?: string | null, learningDuration?: number | null, contentType?: string | null, notificationPreferences?: string | null, type?: string | null, completionStatus?: string | null, deadline?: any | null, priority?: string | null, value?: number | null, description?: string | null, date?: any | null, importance?: number | null, status?: string | null, endDate?: any | null, text?: string | null, sentiment?: string | null, context?: string | null, intensity?: number | null, timestamp?: any | null, trigger?: string | null, calories?: number | null, carbohydrates_grams?: number | null, fat_grams?: number | null, fiber_grams?: number | null, protein_grams?: number | null, serving_size?: string | null, sodium_mg?: number | null, sugars_grams?: number | null, totalCalories?: number | null, totalCarbs?: number | null, totalFats?: number | null, totalProteins?: number | null, totalCaloriesBurned?: number | null, totalDurationMinutes?: number | null, totalWorkouts?: number | null, water_intake_oz?: number | null } | null }> } | null };

export type GetAllCompanionChatsForUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCompanionChatsForUserQuery = { __typename?: 'Query', getAllCompanionChatsForUser: { __typename?: 'CompanionChatsForUserResult', success: boolean, message?: string | null, data: { __typename?: 'CompanionChatsForUserResponse', generalChatsCount: number, generalChats: Array<{ __typename?: 'UserChatsResponse', id: string, name: string, last_modified?: any | null, created?: any | null }>, courseWorkspaces: Array<{ __typename?: 'WorkspaceChatsGroup', id: string, name: string, created?: any | null, lastModified?: any | null, key: string, chats: Array<{ __typename?: 'UserChatsResponse', id: string, name: string, last_modified?: any | null, created?: any | null }> }> } } };

export type GetCompanionChatsForUserPreviewQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
}>;


export type GetCompanionChatsForUserPreviewQuery = { __typename?: 'Query', getCompanionChatsForUserPreview: { __typename?: 'CompanionChatsForUserResult', success: boolean, message?: string | null, data: { __typename?: 'CompanionChatsForUserResponse', generalChatsCount: number, generalChats: Array<{ __typename?: 'UserChatsResponse', id: string, name: string, last_modified?: any | null, created?: any | null }>, courseWorkspaces: Array<{ __typename?: 'WorkspaceChatsGroup', id: string, name: string, created?: any | null, lastModified?: any | null, key: string, totalCount: number, chats: Array<{ __typename?: 'UserChatsResponse', id: string, name: string, last_modified?: any | null, created?: any | null }> }> } } };

export type GetCompanionWorkspaceChatsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetCompanionWorkspaceChatsQuery = { __typename?: 'Query', getCompanionWorkspaceChats: { __typename?: 'CompanionWorkspaceChatsResponse', totalCount: number, chats: Array<{ __typename?: 'UserChatsResponse', id: string, name: string, last_modified?: any | null, created?: any | null }> } };

export type GetGeneralCompanionChatsForUserQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetGeneralCompanionChatsForUserQuery = { __typename?: 'Query', getGeneralCompanionChatsForUser: { __typename?: 'CompanionWorkspaceChatsResponse', totalCount: number, chats: Array<{ __typename?: 'UserChatsResponse', id: string, name: string, last_modified?: any | null, created?: any | null }> } };

export type GetContentByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetContentByIdQuery = { __typename?: 'Query', getContentById?: { __typename?: 'Curriculum', id: string, name: string, standard: string, weeks: number, objectives: Array<string>, created?: any | null, last_modified?: any | null, modules: Array<{ __typename?: 'Module', module_name?: string | null, assignments: Array<{ __typename?: 'Assignment', assignment_name?: string | null, html?: string | null }> }> } | null };

export type GetGeneratedContentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGeneratedContentQuery = { __typename?: 'Query', getGeneratedContent?: Array<{ __typename?: 'Curriculum', id: string, name: string, standard: string, weeks: number, objectives: Array<string>, created?: any | null, last_modified?: any | null, modules: Array<{ __typename?: 'Module', module_name?: string | null, assignments: Array<{ __typename?: 'Assignment', assignment_name?: string | null, html?: string | null }> }> } | null> | null };

export type GetAllAxioResourcesByCourseQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type GetAllAxioResourcesByCourseQuery = { __typename?: 'Query', getAllAxioResourcesByCourse: { __typename?: 'AxioResourceResponse', success: boolean, message?: string | null, data?: Array<{ __typename?: 'AxioResource', id: string, moduleId: string, order: number, name: string, description?: string | null, videoUrl?: string | null, created?: any | null, lastModified?: any | null, files: Array<{ __typename?: 'File', id: string, fileName: string, fileURL: string, created: any, status: FileStatus }> } | null> | null } };

export type GetAllCoursesBySchoolQueryVariables = Exact<{
  schoolId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllCoursesBySchoolQuery = { __typename?: 'Query', getAllCoursesBySchool?: { __typename?: 'CoursesByQueryResponse', success?: boolean | null, count?: number | null, data?: { __typename?: 'CoursesByQueryData', totalCount?: number | null, courses?: Array<{ __typename?: 'Course', id: string, name?: string | null, isDraft?: boolean | null, learningStandards?: string | null, lengthInWeeks?: number | null, objectives?: Array<string> | null, last_modified?: any | null, thumbnail?: string | null, cost?: number | null, startDate?: any | null, description?: string | null, targetAudience?: string | null, course_code?: string | null, enrolledStudents: Array<{ __typename?: 'User', id: string }>, hasAssignmentAssignments: Array<{ __typename?: 'Assignment', id: string, title?: string | null, description?: string | null }>, evaluations: Array<{ __typename?: 'CourseEvaluation', id: string, status: string, createdAt: any }> } | null> | null } | null } | null };

export type GetAllReviewsByCourseQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type GetAllReviewsByCourseQuery = { __typename?: 'Query', getAllReviewsByCourse?: { __typename?: 'ReviewResponse', success?: boolean | null, message?: string | null, count?: number | null, data?: Array<{ __typename?: 'Review', id: string, created?: any | null, lastModified?: any | null, hasReviewFor: { __typename?: 'Assessment', id: string }, hasAITutors: Array<{ __typename?: 'AITutor', id: string, title: string }>, moduleHasReviews: Array<{ __typename?: 'Module', id: string }> } | null> | null } | null };

export type GetAnnouncementsByCourseQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAnnouncementsByCourseQuery = { __typename?: 'Query', getAnnouncementsByCourse: { __typename?: 'AnnouncementListResponse', success: boolean, message?: string | null, count: number, data: Array<{ __typename?: 'AnnouncementWithStatus', id: string, title: string, message: string, expirationDate?: any | null, created: any, lastModified: any, isActive: boolean, audienceType: AudienceType, author: { __typename?: 'User', id: string, name: string, email: string }, courses: Array<{ __typename?: 'Course', id: string, name?: string | null }>, degrees: Array<{ __typename?: 'Degree', id: string, name: string }>, school?: { __typename?: 'School', id: string, team_name?: string | null } | null }> } };

export type GetAnnouncementsBySchoolQueryVariables = Exact<{
  schoolId: Scalars['ID']['input'];
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAnnouncementsBySchoolQuery = { __typename?: 'Query', getAnnouncementsBySchool: { __typename?: 'AnnouncementListResponse', success: boolean, message?: string | null, count: number, data: Array<{ __typename?: 'AnnouncementWithStatus', id: string, title: string, message: string, expirationDate?: any | null, created: any, lastModified: any, isActive: boolean, audienceType: AudienceType, author: { __typename?: 'User', id: string, name: string, email: string }, school?: { __typename?: 'School', id: string, provider_name?: string | null } | null, courses: Array<{ __typename?: 'Course', id: string, name?: string | null }>, degrees: Array<{ __typename?: 'Degree', id: string, name: string }> }> } };

export type GetAnnouncementsForStudentQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type GetAnnouncementsForStudentQuery = { __typename?: 'Query', getAnnouncementsForStudent: { __typename?: 'AnnouncementListResponse', success: boolean, message?: string | null, count: number, data: Array<{ __typename?: 'AnnouncementWithStatus', id: string, title: string, message: string, expirationDate?: any | null, created: any, lastModified: any, isActive: boolean, isNew?: boolean | null, audienceType: AudienceType, author: { __typename?: 'User', id: string, name: string, email: string }, courses: Array<{ __typename?: 'Course', id: string, name?: string | null }>, degrees: Array<{ __typename?: 'Degree', id: string, name: string }>, school?: { __typename?: 'School', id: string, team_name?: string | null } | null }> } };

export type GetAnnouncementsForUserQueryVariables = Exact<{
  schoolId: Scalars['ID']['input'];
  audienceType?: InputMaybe<AudienceType>;
}>;


export type GetAnnouncementsForUserQuery = { __typename?: 'Query', getAnnouncementsForUser: { __typename?: 'AnnouncementListResponse', success: boolean, message?: string | null, count: number, data: Array<{ __typename?: 'AnnouncementWithStatus', id: string, title: string, message: string, expirationDate?: any | null, created: any, lastModified: any, isActive: boolean, isNew?: boolean | null, audienceType: AudienceType, author: { __typename?: 'User', id: string, name: string, email: string }, courses: Array<{ __typename?: 'Course', id: string, name?: string | null }>, degrees: Array<{ __typename?: 'Degree', id: string, name: string }>, school?: { __typename?: 'School', id: string, team_name?: string | null } | null }> } };

export type GetAssignmentsWithCourseQueryVariables = Exact<{
  schoolId: Scalars['ID']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  courseId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetAssignmentsWithCourseQuery = { __typename?: 'Query', getAssignmentsWithCourse: { __typename?: 'AssignmentsWithCourseResponse', success: boolean, message?: string | null, count: number, data: Array<{ __typename?: 'AssignmentWithCourse', id: string, title?: string | null, due_date?: any | null, points_possible?: number | null, courseName?: string | null, courseCode?: string | null, courseId?: string | null }> } };

export type GetAvailableCoursesForStudentQueryVariables = Exact<{
  schoolId: Scalars['ID']['input'];
  degreeId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAvailableCoursesForStudentQuery = { __typename?: 'Query', getAvailableCoursesForStudent?: { __typename?: 'CoursesByQueryResponseWithMetadata', count?: number | null, data?: { __typename?: 'CoursesByQueryDataWithMetadata', totalCount?: number | null, courses?: Array<{ __typename?: 'CourseWithMetadata', progress?: number | null, preRequisitesCompleted?: boolean | null, course?: { __typename?: 'Course', id: string, name?: string | null, course_code?: string | null, isDraft?: boolean | null, learningStandards?: string | null, lengthInWeeks?: number | null, objectives?: Array<string> | null, last_modified?: any | null, thumbnail?: string | null, cost?: number | null, startDate?: any | null, description?: string | null, targetAudience?: string | null, generationStatus?: CourseGenerationStatus | null, preRequisites: Array<{ __typename?: 'Course', id: string, name?: string | null, cost?: number | null, description?: string | null, enrolledStudents: Array<{ __typename?: 'User', id: string, name: string }> }>, preRequisiteFor: Array<{ __typename?: 'Course', id: string, name?: string | null, cost?: number | null, description?: string | null, enrolledStudents: Array<{ __typename?: 'User', id: string, name: string }> }>, modules: Array<{ __typename?: 'Module', id: string, title?: string | null, assignments: Array<{ __typename?: 'Assignment', id: string, name?: string | null }>, aiTutors: Array<{ __typename?: 'AITutor', id: string, title: string }>, axioResources: Array<{ __typename?: 'AxioResource', id: string, name: string }> }>, enrolledStudents: Array<{ __typename?: 'User', id: string, name: string }>, degreesHasCourse: Array<{ __typename?: 'Degree', id: string, name: string, usersEnrolledIn: Array<{ __typename?: 'User', id: string, name: string }> }> } | null } | null> | null } | null } | null };

export type GetAxioResourceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAxioResourceQuery = { __typename?: 'Query', getAxioResource: { __typename?: 'AxioResourceResponse', success: boolean, message?: string | null, data?: Array<{ __typename?: 'AxioResource', id: string, moduleId: string, order: number, name: string, description?: string | null, videoUrl?: string | null, created?: any | null, lastModified?: any | null, files: Array<{ __typename?: 'File', id: string, fileName: string, fileURL: string, created: any, status: FileStatus }> } | null> | null } };

export type GetCompletionAnalyticsBySchoolQueryVariables = Exact<{
  schoolId: Scalars['ID']['input'];
}>;


export type GetCompletionAnalyticsBySchoolQuery = { __typename?: 'Query', getCompletionAnalyticsBySchool: { __typename?: 'CompletionAnalyticsResponse', success: boolean, message?: string | null, count: number, data: Array<{ __typename?: 'CompletionAnalytics', label: string, completionStats: { __typename?: 'CompletionStats', completed: number, inProgress: number, notStarted: number }, details: { __typename?: 'CompletionCourseDetails', modules: Array<{ __typename?: 'CompletionModuleAnalytics', label: string, completionStats: { __typename?: 'CompletionStats', completed: number, inProgress: number, notStarted: number }, details: { __typename?: 'CompletionModuleDetails', activities: Array<{ __typename?: 'CompletionActivityAnalytics', label: string, completionStats: { __typename?: 'CompletionStats', completed: number, inProgress: number, notStarted: number }, details: { __typename?: 'CompletionActivityDetails', objectives: Array<{ __typename?: 'CompletionObjectiveAnalytics', label: string, completionStats: { __typename?: 'CompletionStats', completed: number, inProgress: number, notStarted: number } }> } }> } }> } }> } };

export type GetCoursesAnalyticsBySchoolQueryVariables = Exact<{
  schoolId: Scalars['ID']['input'];
}>;


export type GetCoursesAnalyticsBySchoolQuery = { __typename?: 'Query', getCoursesAnalyticsBySchool?: { __typename?: 'CourseAnalyticsResponse', count?: number | null, data?: Array<{ __typename?: 'CourseAnalytics', label: string, id: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, sentiment: string, enrollment: number, average_time_taken?: number | null, details: { __typename?: 'CourseAnalyticsDetails', modules: Array<{ __typename?: 'ModuleAnalytics', label: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, sentiment: string, enrollment: number, average_time_taken?: number | null, details: { __typename?: 'ModuleAnalyticsDetails', activities: Array<{ __typename?: 'ActivityAnalytics', label: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, sentiment: string, enrollment: number, average_time_taken?: number | null, summaries?: Array<string | null> | null, success_points_details?: Array<string | null> | null, confusion_points_details?: Array<string | null> | null, further_recommendations?: Array<string | null> | null, distractions_details?: Array<string | null> | null, details: { __typename?: 'ActivityAnalyticsDetails', objectives: Array<{ __typename?: 'ObjectiveAnalytics', label: string, success_points: number, confusion_points: number, average_time_taken?: number | null }> } }> } }> } } | null> | null } | null };

export type GetCoursesByDegreeByQueryQueryVariables = Exact<{
  degreeId: Scalars['ID']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCoursesByDegreeByQueryQuery = { __typename?: 'Query', getCoursesByDegreeByQuery?: { __typename?: 'CoursesByQueryResponse', success?: boolean | null, message?: string | null, count?: number | null, data?: { __typename?: 'CoursesByQueryData', totalCount?: number | null, courses?: Array<{ __typename?: 'Course', id: string, name?: string | null, course_code?: string | null, learningStandards?: string | null, lengthInWeeks?: number | null, objectives?: Array<string> | null, thumbnail?: string | null, last_modified?: any | null, generationStatus?: CourseGenerationStatus | null, teachingFaculty: Array<{ __typename?: 'User', id: string, name: string }>, enrolledStudents: Array<{ __typename?: 'User', id: string, name: string }> } | null> | null } | null } | null };

export type GetCoursesByFacultyQueryVariables = Exact<{
  schoolId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCoursesByFacultyQuery = { __typename?: 'Query', getCoursesByFaculty?: { __typename?: 'CourseResponse', count?: number | null, data?: Array<{ __typename?: 'Course', id: string, name?: string | null, course_code?: string | null, isDraft?: boolean | null, learningStandards?: string | null, lengthInWeeks?: number | null, objectives?: Array<string> | null, last_modified?: any | null, thumbnail?: string | null, cost?: number | null, startDate?: any | null, description?: string | null, targetAudience?: string | null, generationStatus?: CourseGenerationStatus | null, enrolledStudents: Array<{ __typename?: 'User', id: string, name: string }>, teachingFaculty: Array<{ __typename?: 'User', id: string, name: string }>, degreesHasCourse: Array<{ __typename?: 'Degree', id: string, name: string }>, modules: Array<{ __typename?: 'Module', id: string, title?: string | null, aiTutors: Array<{ __typename?: 'AITutor', id: string, title: string }>, assignments: Array<{ __typename?: 'Assignment', id: string, name?: string | null }>, axioResources: Array<{ __typename?: 'AxioResource', id: string, name: string }>, reviews: Array<{ __typename?: 'Review', id: string }> }> } | null> | null } | null };

export type GetCoursesBySchoolByQueryQueryVariables = Exact<{
  schoolId: Scalars['ID']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCoursesBySchoolByQueryQuery = { __typename?: 'Query', getCoursesBySchoolByQuery?: { __typename?: 'CoursesByQueryResponse', success?: boolean | null, message?: string | null, count?: number | null, data?: { __typename?: 'CoursesByQueryData', totalCount?: number | null, courses?: Array<{ __typename?: 'Course', id: string, name?: string | null, course_code?: string | null, description?: string | null, cost?: number | null, startDate?: any | null, targetAudience?: string | null, learningStandards?: string | null, lengthInWeeks?: number | null, objectives?: Array<string> | null, thumbnail?: string | null, last_modified?: any | null, generationStatus?: CourseGenerationStatus | null, isDraft?: boolean | null, isEnrollmentAvailable?: boolean | null, teachingFaculty: Array<{ __typename?: 'User', id: string, name: string }>, enrolledStudents: Array<{ __typename?: 'User', id: string, name: string }>, degreesHasCourse: Array<{ __typename?: 'Degree', id: string, name: string }> } | null> | null } | null } | null };

export type GetEnrolledStudentCoursesByAdminQueryVariables = Exact<{
  schoolId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetEnrolledStudentCoursesByAdminQuery = { __typename?: 'Query', getEnrolledStudentCoursesByAdmin?: { __typename?: 'CoursesByQueryResponseWithMetadata', success?: boolean | null, message?: string | null, count?: number | null, data?: { __typename?: 'CoursesByQueryDataWithMetadata', totalCount?: number | null, courses?: Array<{ __typename?: 'CourseWithMetadata', progress?: number | null, preRequisitesCompleted?: boolean | null, course?: { __typename?: 'Course', id: string, name?: string | null, course_code?: string | null, isDraft?: boolean | null, learningStandards?: string | null, lengthInWeeks?: number | null, objectives?: Array<string> | null, last_modified?: any | null, thumbnail?: string | null, cost?: number | null, startDate?: any | null, description?: string | null, targetAudience?: string | null, generationStatus?: CourseGenerationStatus | null, preRequisites: Array<{ __typename?: 'Course', id: string, name?: string | null, cost?: number | null, description?: string | null, enrolledStudents: Array<{ __typename?: 'User', id: string, name: string }> }>, preRequisiteFor: Array<{ __typename?: 'Course', id: string, name?: string | null, cost?: number | null, description?: string | null, enrolledStudents: Array<{ __typename?: 'User', id: string, name: string }> }>, modules: Array<{ __typename?: 'Module', id: string, title?: string | null, assignments: Array<{ __typename?: 'Assignment', id: string, name?: string | null }>, aiTutors: Array<{ __typename?: 'AITutor', id: string, title: string }>, axioResources: Array<{ __typename?: 'AxioResource', id: string, name: string }> }>, enrolledStudents: Array<{ __typename?: 'User', id: string, name: string }>, degreesHasCourse: Array<{ __typename?: 'Degree', id: string, name: string, usersEnrolledIn: Array<{ __typename?: 'User', id: string, name: string }> }> } | null } | null> | null } | null } | null };

export type GetFacultyByCourseIdQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFacultyByCourseIdQuery = { __typename?: 'Query', getFacultyByCourseId?: { __typename?: 'FacultyQueryResponse', data?: { __typename?: 'FacultyQueryResponseWithCountData', totalCount?: number | null, faculties: Array<{ __typename?: 'FacultyQueryResponseData', id?: string | null, name?: string | null, profilePicture?: string | null, email?: string | null, meetingLink?: string | null, biography?: string | null }> } | null } | null };

export type GetForumByCourseQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type GetForumByCourseQuery = { __typename?: 'Query', getForumByCourse: { __typename?: 'ForumResponse', success: boolean, message?: string | null, count: number, data?: { __typename?: 'Forum', id: string, created: any, lastModified: any, course: { __typename?: 'Course', id: string, name?: string | null } } | null } };

export type GetLastSeenPostQueryVariables = Exact<{
  threadId: Scalars['ID']['input'];
}>;


export type GetLastSeenPostQuery = { __typename?: 'Query', getLastSeenPost: { __typename?: 'LastSeenPostResponse', success: boolean, message?: string | null, data?: { __typename?: 'LastSeenPostData', threadId: string, lastSeenPostId?: string | null, lastSeenAt?: any | null } | null } };

export type GetLessonPlanStatusQueryVariables = Exact<{
  moduleId: Scalars['ID']['input'];
}>;


export type GetLessonPlanStatusQuery = { __typename?: 'Query', getLessonPlanStatus?: { __typename?: 'LessonPlanStatusResponse', success: boolean, message?: string | null, data?: { __typename?: 'LessonPlanStatus', moduleId: string, moduleTitle: string, isGenerating: boolean, hasLessonPlan: boolean, lessonPlanFile?: { __typename?: 'File', id: string, fileName: string, fileURL: string } | null } | null } | null };

export type GetNotesForStudentQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GetNotesForStudentQuery = { __typename?: 'Query', getNotesForStudent: { __typename?: 'NotesListResponse', success: boolean, message?: string | null, count: number, data: Array<{ __typename?: 'Note', id: string, content: string, created: any, lastModified: any, author: { __typename?: 'User', id: string, name: string, profilePicture?: string | null }, subject: { __typename?: 'User', id: string, name: string } }> } };

export type GetPostByIdQueryVariables = Exact<{
  postId: Scalars['ID']['input'];
}>;


export type GetPostByIdQuery = { __typename?: 'Query', getPostById: { __typename?: 'PostResponse', success: boolean, message?: string | null, count: number, data?: { __typename?: 'Post', id: string, message: string, depth: number, threadId: string, created: any, lastModified: any, thread: { __typename?: 'Thread', id: string, title: string, forum: { __typename?: 'Forum', course: { __typename?: 'Course', id: string, name?: string | null } } }, author: { __typename?: 'User', id: string, name: string }, files: Array<{ __typename?: 'File', id: string, fileName: string, fileURL: string }>, replies: Array<{ __typename?: 'Post', id: string, message: string, depth: number, created: any, lastModified: any, author: { __typename?: 'User', id: string, name: string }, files: Array<{ __typename?: 'File', id: string, fileName: string, fileURL: string }> }>, replyTo?: { __typename?: 'Post', id: string, message: string, author: { __typename?: 'User', id: string, name: string } } | null } | null } };

export type GetPostsByThreadQueryVariables = Exact<{
  threadId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPostsByThreadQuery = { __typename?: 'Query', getPostsByThread: { __typename?: 'PostListResponse', success: boolean, message?: string | null, count: number, data: Array<{ __typename?: 'Post', id: string, message: string, depth: number, threadId: string, created: any, lastModified: any, author: { __typename?: 'User', id: string, name: string }, files: Array<{ __typename?: 'File', id: string, fileName: string, fileURL: string }>, replies: Array<{ __typename?: 'Post', id: string, message: string, depth: number, created: any, author: { __typename?: 'User', id: string, name: string } }>, replyTo?: { __typename?: 'Post', id: string, message: string, author: { __typename?: 'User', id: string, name: string } } | null }> } };

export type GetReviewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetReviewQuery = { __typename?: 'Query', getReview?: { __typename?: 'ReviewResponse', success?: boolean | null, message?: string | null, count?: number | null, data?: Array<{ __typename?: 'Review', id: string, created?: any | null, lastModified?: any | null, hasReviewFor: { __typename?: 'Assessment', id: string, moduleHasAssessment: { __typename?: 'Module', id: string, title?: string | null } }, hasAITutors: Array<{ __typename?: 'AITutor', id: string, title: string, objectives: Array<{ __typename?: 'Objective', id: string, objective?: string | null, sequence?: number | null }> }> } | null> | null } | null };

export type GetStudentAnalyticsBySchoolQueryVariables = Exact<{
  schoolId: Scalars['ID']['input'];
}>;


export type GetStudentAnalyticsBySchoolQuery = { __typename?: 'Query', getStudentAnalyticsBySchool: { __typename?: 'StudentAnalyticsResponse', success: boolean, message?: string | null, count: number, data: Array<{ __typename?: 'StudentAnalytics', id: string, label: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, sentiment: string, details: { __typename?: 'StudentAnalyticsDetails', courses: Array<{ __typename?: 'CourseProgressAnalytics', label: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, sentiment: string, details: { __typename?: 'CourseProgressDetails', modules: Array<{ __typename?: 'ModuleProgressAnalytics', label: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, sentiment: string, details: { __typename?: 'ModuleProgressDetails', aiTutors?: Array<{ __typename?: 'AITutorProgressAnalytics', label: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, sentiment: string, details: { __typename?: 'AITutorProgressDetails', objectives: Array<{ __typename?: 'ObjectiveProgressAnalytics', label: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number }> } } | null> | null } }> } }> } }> } };

export type GetStudentAnalyticsForStudentQueryVariables = Exact<{
  schoolId: Scalars['ID']['input'];
  studentId: Scalars['ID']['input'];
}>;


export type GetStudentAnalyticsForStudentQuery = { __typename?: 'Query', getStudentAnalyticsForStudent: { __typename?: 'StudentAnalyticsResponse', success: boolean, message?: string | null, data: Array<{ __typename?: 'StudentAnalytics', id: string, label: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, sentiment: string, completion_percentage?: number | null, total_time_taken?: number | null, details: { __typename?: 'StudentAnalyticsDetails', courses: Array<{ __typename?: 'CourseProgressAnalytics', id: string, label: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, sentiment: string, completion_percentage?: number | null, total_time_taken?: number | null, details: { __typename?: 'CourseProgressDetails', modules: Array<{ __typename?: 'ModuleProgressAnalytics', id: string, label: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, sentiment: string, completion_percentage?: number | null, total_time_taken?: number | null, details: { __typename?: 'ModuleProgressDetails', aiTutors?: Array<{ __typename?: 'AITutorProgressAnalytics', id: string, label: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, sentiment: string, completion_percentage?: number | null, total_time_taken?: number | null, details: { __typename?: 'AITutorProgressDetails', objectives: Array<{ __typename?: 'ObjectiveProgressAnalytics', id: string, label: string, success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, status?: string | null, progress_details?: { __typename?: 'ProgressDetails', level?: string | null, confusion_points?: Array<string | null> | null, success_points?: Array<string | null> | null, average_student_question_complexity?: string | null, further_recommendations?: Array<string | null> | null, questions_asked?: number | null, distractions?: Array<string | null> | null, sentiment_analysis?: string | null, originality_analysis?: string | null, summary?: string | null, num_messages?: number | null, student_messages_count?: number | null, ai_messages_count?: number | null, average_student_response_time?: number | null, average_ai_response_time?: number | null, total_time_taken?: number | null } | null }> }, chatAnalytics?: Array<{ __typename?: 'ChatAnalytics', id: string, level?: string | null, confusion_points?: Array<string | null> | null, success_points?: Array<string | null> | null, average_student_question_complexity?: number | null, further_recommendations: Array<string>, questions_asked: number, distractions: number, sentiment_analysis?: string | null, originality_analysis?: string | null, summary: string, num_messages: number, student_messages_count: number, ai_messages_count: number, average_student_response_time: number, average_ai_response_time: number, total_time_taken: number } | null> | null } | null> | null } }> } }> } }> } };

export type GetStudentsByCourseIdQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetStudentsByCourseIdQuery = { __typename?: 'Query', getStudentsByCourseId?: { __typename?: 'CourseRosterServiceResult', success?: boolean | null, count?: number | null, data?: Array<{ __typename?: 'CourseRosterData', id: string, name: string, email: string, pendingCourseEnrollmentInvite?: boolean | null, expiredInvitation?: boolean | null, enrollmentDate: any, roles: Array<string>, analytics?: { __typename?: 'UserRosterAnalytics', success_points: number, confusion_points: number, questions_asked: number, active_interaction_count: number, distractions: number, sentiment: string, completion_percentage?: number | null, total_time_taken?: number | null } | null } | null> | null } | null };

export type GetThreadsByCourseQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetThreadsByCourseQuery = { __typename?: 'Query', getThreadsByCourse: { __typename?: 'ThreadListResponse', success: boolean, message?: string | null, count: number, data: Array<{ __typename?: 'Thread', id: string, title: string, created: any, lastModified: any, forum: { __typename?: 'Forum', id: string, course: { __typename?: 'Course', id: string, name?: string | null } }, posts: Array<{ __typename?: 'Post', id: string, message: string, depth: number, created: any, author: { __typename?: 'User', id: string, name: string } }>, subscribers: Array<{ __typename?: 'User', id: string }> }> } };

export type GetUnifiedSubmissionsByFacultyQueryVariables = Exact<{
  input: GetUnifiedSubmissionsByFacultyInput;
}>;


export type GetUnifiedSubmissionsByFacultyQuery = { __typename?: 'Query', getUnifiedSubmissionsByFaculty?: { __typename?: 'GetUnifiedSubmissionsByFacultyResponse', success?: boolean | null, count?: number | null, data?: { __typename?: 'GetUnifiedSubmissionsByFacultyData', totalCount?: number | null, submissions?: Array<{ __typename?: 'UnifiedSubmission', id: string, created: any, submissionType: string, moduleName: string, submissionTitle: string, courseName: string, submittedOn?: any | null, submittedTime?: any | null, status?: string | null, grade?: number | null, maximumPoints?: number | null, courseCode?: string | null, courseId: string, dueDate?: any | null, retakeDeadline?: any | null, student: { __typename?: 'StudentProperties', id: string, name: string, email: string, initials: string } } | null> | null } | null } | null };

export type GetUnifiedSubmissionsByFacultyByUserQueryVariables = Exact<{
  input: GetUnifiedSubmissionsByFacultyByUserInput;
}>;


export type GetUnifiedSubmissionsByFacultyByUserQuery = { __typename?: 'Query', getUnifiedSubmissionsByFacultyByUser?: { __typename?: 'GetUnifiedSubmissionsByFacultyResponse', success?: boolean | null, count?: number | null, data?: { __typename?: 'GetUnifiedSubmissionsByFacultyData', totalCount?: number | null, submissions?: Array<{ __typename?: 'UnifiedSubmission', id: string, created: any, submissionType: string, moduleName: string, submissionTitle: string, courseName: string, submittedOn?: any | null, submittedTime?: any | null, status?: string | null, grade?: number | null, maximumPoints?: number | null, courseCode?: string | null, courseId: string, dueDate?: any | null, retakeDeadline?: any | null, student: { __typename?: 'StudentProperties', id: string, name: string, email: string, initials: string } } | null> | null } | null } | null };

export type GetAiTutorQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAiTutorQuery = { __typename?: 'Query', getAITutor?: { __typename?: 'AITutorResponse', data?: Array<{ __typename?: 'FormattedAITutor', id: string, title: string, description?: string | null, created?: any | null, lastModified?: any | null, dueDate?: any | null, context?: string | null, targetAudience?: string | null, activityState?: ActivityState | null, scheduledDate?: any | null, visualization?: { __typename?: 'Visualization', id: string, code?: string | null, visualizationType?: string | null } | null, hasChatChats?: Array<{ __typename?: 'FormattedChat', id: string } | null> | null, objectives?: Array<{ __typename?: 'FormattedObjective', id?: string | null, objective: string, sequence?: number | null, evalCriteria?: Array<string | null> | null, pendingVideoProcessing?: boolean | null, status?: string | null, videos?: Array<{ __typename?: 'Video', id: string, videoId: string, title: string, url: string, thumbnailUrl?: string | null, isTeacherAdded: boolean } | null> | null } | null> | null } | null> | null } | null };

export type GetAiTutorVideosQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAiTutorVideosQuery = { __typename?: 'Query', getAITutorVideos?: { __typename?: 'AITutorVideosResponse', success?: boolean | null, message?: string | null, count?: number | null, data?: Array<{ __typename?: 'Video', id: string, videoId: string, url: string, title: string, description?: string | null, thumbnailUrl?: string | null, isTeacherAdded: boolean } | null> | null } | null };

export type GetAllAiTutorsByCourseQueryVariables = Exact<{
  courseIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetAllAiTutorsByCourseQuery = { __typename?: 'Query', getAllAITutorsByCourse?: { __typename?: 'AITutorResponse', data?: Array<{ __typename?: 'FormattedAITutor', id: string, title: string, dueDate?: any | null, context?: string | null, courseId?: string | null, visualization?: { __typename?: 'Visualization', id: string, code?: string | null, visualizationType?: string | null } | null, objectives?: Array<{ __typename?: 'FormattedObjective', id?: string | null, objective: string, status?: string | null, evalCriteria?: Array<string | null> | null } | null> | null } | null> | null } | null };

export type GetAllAssessmentsByCourseQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type GetAllAssessmentsByCourseQuery = { __typename?: 'Query', getAllAssessmentsByCourse?: { __typename?: 'MultipleAssessmentResponse', success?: boolean | null, message?: string | null, count?: number | null, data?: Array<{ __typename?: 'Assessment', id: string, created?: any | null, lastModified?: any | null, activityState?: ActivityState | null, scheduledDate?: any | null, aiTutors: Array<{ __typename?: 'AITutor', id: string, title: string }>, moduleHasAssessment: { __typename?: 'Module', id: string, title?: string | null, courseHasModules: Array<{ __typename?: 'Course', id: string, name?: string | null }> } } | null> | null } | null };

export type GetAllModulesByCourseQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type GetAllModulesByCourseQuery = { __typename?: 'Query', getAllModulesByCourse?: { __typename?: 'ModuleResponse', success?: boolean | null, message?: string | null, count?: number | null, data?: Array<{ __typename?: 'Module', id: string, title?: string | null, thumbnail?: string | null, description?: string | null, resourceOrder?: Array<string> | null, aiTutors: Array<{ __typename?: 'AITutor', id: string, title: string, description?: string | null }>, assignments: Array<{ __typename?: 'Assignment', id: string, name?: string | null, description?: string | null, due_date?: any | null }>, axioResources: Array<{ __typename?: 'AxioResource', id: string, name: string, description?: string | null }> } | null> | null } | null };

export type GetAnnouncementByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAnnouncementByIdQuery = { __typename?: 'Query', getAnnouncementById: { __typename?: 'AnnouncementResponse', success: boolean, message?: string | null, count: number, data?: { __typename?: 'Announcement', id: string, title: string, message: string, expirationDate?: any | null, created: any, lastModified: any, audienceType: AudienceType, scope: AnnouncementScope } | null } };

export type GetAssessmentQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
}>;


export type GetAssessmentQuery = { __typename?: 'Query', getAssessment?: { __typename?: 'AssessmentResponse', data?: { __typename?: 'Assessment', id: string, created?: any | null, lastModified?: any | null, assessmentType?: AssessmentType | null, numberOfQuestions?: number | null, timeLimit?: number | null, dueDate?: any | null, activityState?: ActivityState | null, scheduledDate?: any | null, moduleHasAssessment: { __typename?: 'Module', title?: string | null }, aiTutors: Array<{ __typename?: 'AITutor', id: string, title: string }> } | null } | null };

export type GetAssessmentQuestionBankQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  pagination?: InputMaybe<AssessmentQuestionBankPaginationInput>;
}>;


export type GetAssessmentQuestionBankQuery = { __typename?: 'Query', getAssessmentQuestionBank?: { __typename?: 'AssessmentResponse', count?: number | null, socraticTotalCount?: number | null, mcqTotalCount?: number | null, data?: { __typename?: 'Assessment', id: string, assessmentType?: AssessmentType | null, aiTutors: Array<{ __typename?: 'AITutor', id: string, title: string, questionGenerationStatus?: QuestionGenerationStatus | null, questions: Array<{ __typename?: 'Question', id: string, question?: string | null, totalScore?: number | null, rubrics: Array<{ __typename?: 'Rubric', id: string, component?: string | null, points?: number | null }> }> }>, mcqQuestions: Array<{ __typename?: 'McqQuestion', id: string, created?: any | null, lastModified?: any | null, question: string, choices: Array<string>, correctChoiceIndices: Array<number>, explanation?: string | null, totalScore?: number | null, order?: number | null }> } | null } | null };

export type GetAssessmentSubmissionAttemptHistoryQueryVariables = Exact<{
  assessmentId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type GetAssessmentSubmissionAttemptHistoryQuery = { __typename?: 'Query', getAttemptHistory?: { __typename?: 'AssessmentSubmissionListResponse', count?: number | null, data?: { __typename?: 'AssessmentSubmissionData', totalCount?: number | null, assessmentSubmissions?: Array<{ __typename?: 'AssessmentSubmission', id: string, created?: any | null, lastModified?: any | null, startedAt?: any | null, completedAt?: any | null, totalPoints?: number | null, maximumPoints?: number | null, hasTeacherGraded?: boolean | null, hasTeacherAdjustedGrade?: boolean | null, status?: AssessmentSubmissionStatus | null, timeLimit?: number | null, isEvaluationPending?: boolean | null, mcqAnswersConnection: { __typename?: 'AssessmentSubmissionMcqAnswersConnection', edges: Array<{ __typename?: 'AssessmentSubmissionMcqAnswersRelationship', properties: { __typename?: 'HasMcqAnswerProperties', selectedChoiceIndices?: Array<number> | null }, node: { __typename?: 'McqQuestion', id: string, question: string, choices: Array<string>, order?: number | null } }> }, questionsConnection: { __typename?: 'AssessmentSubmissionQuestionsConnection', edges: Array<{ __typename?: 'AssessmentSubmissionQuestionsRelationship', node: { __typename?: 'Question', id: string, question?: string | null }, properties: { __typename?: 'HasAnswerProperties', answer?: string | null, createdAt?: any | null, totalPoints?: number | null, maximumPoints?: number | null } }> } } | null> | null } | null } | null };

export type GetRunningAssessmentSubmissionByUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRunningAssessmentSubmissionByUserQuery = { __typename?: 'Query', getRunningAssessmentSubmissionByUser?: { __typename?: 'AssessmentSubmissionResponse', data?: { __typename?: 'AssessmentSubmission', id: string, status?: AssessmentSubmissionStatus | null, assessment: { __typename?: 'Assessment', id: string } } | null } | null };

export type GetAssessmentSubmissionsDetailsQueryVariables = Exact<{
  assessmentSubmissionId: Scalars['ID']['input'];
  studentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetAssessmentSubmissionsDetailsQuery = { __typename?: 'Query', getAssessmentSubmissionDetails?: { __typename?: 'AssessmentSubmissionDetailsResponse', success?: boolean | null, data?: { __typename?: 'AssessmentSubmissionDetails', id: string, userName?: string | null, userId?: string | null, userEmail?: string | null, status?: AssessmentSubmissionStatus | null, completedAt?: any | null, startedAt?: any | null, totalPoints?: number | null, aiTotalPoints?: number | null, maximumPoints?: number | null, hasTeacherGraded?: boolean | null, hasTeacherAdjustedGrade?: boolean | null, assessmentId?: string | null, assessmentType?: AssessmentType | null, created?: any | null, lastModified?: any | null, timeLimit?: number | null, moduleName?: string | null, courseName?: string | null, feedback?: string | null, questions?: Array<{ __typename?: 'AssessmentSubmissionQuestion', id: string, question?: string | null, totalScore?: number | null, rubrics?: Array<{ __typename?: 'AssessmentSubmissionRubric', id: string, component?: string | null, points?: number | null, pointsAwarded?: number | null, aiPointsAwarded?: number | null, maxPoints?: number | null, remarks?: string | null } | null> | null, userAnswer?: { __typename?: 'AssessmentSubmissionUserAnswer', answer?: string | null, createdAt?: any | null, totalPoints?: number | null, aiTotalPoints?: number | null, maximumPoints?: number | null } | null } | null> | null, mcqAnswers?: Array<{ __typename?: 'McqAnswerDetail', id: string, question: string, choices: Array<string>, correctChoiceIndices: Array<number>, explanation?: string | null, totalScore?: number | null, order?: number | null, selectedChoiceIndices?: Array<number> | null, isCorrect: boolean, pointsAwarded: number } | null> | null } | null } | null };

export type GetAssessmentAiTutorsQueryVariables = Exact<{
  moduleId: Scalars['ID']['input'];
  courseId: Scalars['ID']['input'];
}>;


export type GetAssessmentAiTutorsQuery = { __typename?: 'Query', getAssessmentAiTutors?: { __typename?: 'AssessmentAiTutorsResponse', data?: { __typename?: 'AssessmentAiTutors', currentModuleAiTutors?: { __typename?: 'ModuleAiTutors', title?: string | null, aiTutors?: Array<{ __typename?: 'AITutor', id: string, title: string } | null> | null } | null, pastModulesAiTutors?: Array<{ __typename?: 'ModuleAiTutors', id: string, title?: string | null, aiTutors?: Array<{ __typename?: 'AITutor', id: string, title: string } | null> | null } | null> | null, futureModulesAiTutors?: Array<{ __typename?: 'ModuleAiTutors', id: string, title?: string | null, aiTutors?: Array<{ __typename?: 'AITutor', id: string, title: string } | null> | null } | null> | null } | null } | null };

export type GetAssignmentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAssignmentQuery = { __typename?: 'Query', getAssignment?: { __typename?: 'AssignmentResponse', success?: boolean | null, message?: string | null, data?: Array<{ __typename?: 'Assignment', id: string, name?: string | null, description?: string | null, due_date?: any | null, enableStudentFileUpload?: boolean | null, videoUrl?: string | null, created?: any | null, lastModified?: any | null, files: Array<{ __typename?: 'File', id: string, fileName: string, fileURL: string, created: any, status: FileStatus }>, usersHasSchoolAssignmentConnection: { __typename?: 'AssignmentUsersHasSchoolAssignmentConnection', edges: Array<{ __typename?: 'AssignmentUsersHasSchoolAssignmentRelationship', node: { __typename?: 'User', id: string }, properties: { __typename?: 'HasSchoolAssignmentProperties', retakeAllowed?: boolean | null, retakeDeadline?: any | null } }> }, worksheet?: { __typename?: 'Worksheet', id: string, title: string, coverage: string, instructions?: string | null, numQuestions: number, files: Array<{ __typename?: 'File', id: string, fileName: string, fileURL: string, created: any, status: FileStatus }> } | null } | null> | null } | null };

export type GetAssignmentAndSubmissionBySubmissionIdQueryVariables = Exact<{
  submissionId: Scalars['ID']['input'];
}>;


export type GetAssignmentAndSubmissionBySubmissionIdQuery = { __typename?: 'Query', getAssignmentAndSubmissionBySubmissionId?: { __typename?: 'AssignmentAndSubmissionResponse', success?: boolean | null, data?: Array<{ __typename?: 'AssignmentAndSubmission', assignment?: { __typename?: 'Assignment', id: string, name?: string | null, description?: string | null, due_date?: any | null, usersHasSchoolAssignmentConnection: { __typename?: 'AssignmentUsersHasSchoolAssignmentConnection', edges: Array<{ __typename?: 'AssignmentUsersHasSchoolAssignmentRelationship', properties: { __typename?: 'HasSchoolAssignmentProperties', retakeAllowed?: boolean | null, retakeDeadline?: any | null } }> } } | null, submission?: { __typename?: 'Submission', id: string, created?: any | null, lastModified?: any | null, grade?: number | null, isCompleted?: boolean | null, completedAt?: any | null, feedback?: string | null, hasTeacherGraded?: boolean | null, files: Array<{ __typename?: 'File', id: string, fileName: string, fileURL: string, created: any, status: FileStatus }> } | null } | null> | null } | null };

export type GetAssignmentSubmissionAttemptHistoryQueryVariables = Exact<{
  assignmentId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type GetAssignmentSubmissionAttemptHistoryQuery = { __typename?: 'Query', getAssignmentSubmissionAttemptHistory?: { __typename?: 'AssignmentSubmissionListResponse', count?: number | null, data?: { __typename?: 'AssignmentSubmissionData', totalCount?: number | null, submissions?: Array<{ __typename?: 'Submission', id: string, created?: any | null, lastModified?: any | null, grade?: number | null, isCompleted?: boolean | null, completedAt?: any | null, hasTeacherGraded?: boolean | null, feedback?: string | null } | null> | null } | null } | null };

export type GetCourseActivitiesProgressQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCourseActivitiesProgressQuery = { __typename?: 'Query', getCourseActivitiesProgress?: { __typename?: 'CourseResponse', data?: Array<{ __typename?: 'Course', id: string, name?: string | null, modules: Array<{ __typename?: 'Module', id: string, title?: string | null, resourceOrder?: Array<string> | null, aiTutors: Array<{ __typename?: 'AITutor', id: string, title: string, lastModified?: any | null, dueDate?: any | null, activityState?: ActivityState | null, scheduledDate?: any | null, objectives: Array<{ __typename?: 'Objective', id: string, userHasProgressConnection: { __typename?: 'ObjectiveUserHasProgressConnection', edges: Array<{ __typename?: 'ObjectiveUserHasProgressRelationship', properties: { __typename?: 'HasProgressProperties', status?: string | null } }> } }> }>, axioResources: Array<{ __typename?: 'AxioResource', id: string, name: string, description?: string | null, videoUrl?: string | null, lastModified?: any | null, activityState?: ActivityState | null, scheduledDate?: any | null, files: Array<{ __typename?: 'File', id: string, fileName: string, fileURL: string }> }>, assignments: Array<{ __typename?: 'Assignment', id: string, name?: string | null, description?: string | null, due_date?: any | null, videoUrl?: string | null, lastModified?: any | null, activityState?: ActivityState | null, scheduledDate?: any | null, submissions: Array<{ __typename?: 'Submission', id: string, created?: any | null, grade?: number | null, hasTeacherGraded?: boolean | null }>, files: Array<{ __typename?: 'File', id: string }> }>, assessment?: { __typename?: 'Assessment', id: string, lastModified?: any | null, dueDate?: any | null, activityState?: ActivityState | null, scheduledDate?: any | null, aiTutors: Array<{ __typename?: 'AITutor', id: string }>, submissions: Array<{ __typename?: 'AssessmentSubmission', id: string, created?: any | null, status?: AssessmentSubmissionStatus | null, isEvaluationPending?: boolean | null, totalPoints?: number | null, maximumPoints?: number | null }> } | null, projects: Array<{ __typename?: 'Project', id: string, name: string, description?: string | null, status: ProjectStatus, lastModified?: any | null, dueDate?: any | null, expectedOutcomes?: Array<string> | null, scopeDocument?: string | null, deliverableTypes?: Array<string> | null, assessmentCriteria?: Array<string> | null, activityState?: ActivityState | null, scheduledDate?: any | null }>, reviews: Array<{ __typename?: 'Review', id: string, lastModified?: any | null, activityState?: ActivityState | null, scheduledDate?: any | null, hasReviewFor: { __typename?: 'Assessment', id: string, moduleHasAssessment: { __typename?: 'Module', id: string, title?: string | null } }, generatingReviewAITutorForConnection: { __typename?: 'ReviewGeneratingReviewAITutorForConnection', edges: Array<{ __typename?: 'ReviewGeneratingReviewAITutorForRelationship', node: { __typename?: 'User', id: string }, properties: { __typename?: 'ReviewGeneratingForProperties', isGenerating?: boolean | null } }> }, hasAITutors: Array<{ __typename?: 'AITutor', id: string, created?: any | null, reviewForUser?: { __typename?: 'User', id: string } | null, objectives: Array<{ __typename?: 'Objective', id: string, userHasProgressConnection: { __typename?: 'ObjectiveUserHasProgressConnection', edges: Array<{ __typename?: 'ObjectiveUserHasProgressRelationship', properties: { __typename?: 'HasProgressProperties', status?: string | null } }> } }> }> }> }> } | null> | null } | null };

export type GetCourseAdminStatsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCourseAdminStatsQuery = { __typename?: 'Query', getCourseAdminStats?: { __typename?: 'CourseResponse', data?: Array<{ __typename?: 'Course', id: string, name?: string | null, isDraft?: boolean | null, enrolledStudents: Array<{ __typename?: 'User', id: string }>, modules: Array<{ __typename?: 'Module', id: string, assignments: Array<{ __typename?: 'Assignment', id: string }> }> } | null> | null } | null };

export type GetCourseByIdWithEnrolledUserInfoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCourseByIdWithEnrolledUserInfoQuery = { __typename?: 'Query', getCourseByIdWithEnrolledUserInfo?: { __typename?: 'CourseResponse', data?: Array<{ __typename?: 'Course', id: string, name?: string | null, course_code?: string | null, description?: string | null, cost?: number | null, startDate?: any | null, endDate?: any | null, dueDateStartDate?: any | null, dueDateEndDate?: any | null, isDraft?: boolean | null, isEnrollmentAvailable?: boolean | null, learningStandards?: string | null, lengthInWeeks?: number | null, generationStatus?: CourseGenerationStatus | null, targetAudience?: string | null, objectives?: Array<string> | null, thumbnail?: string | null, last_modified?: any | null, stripeProductId?: string | null, enrolledStudentsConnection: { __typename?: 'CourseEnrolledStudentsConnection', edges: Array<{ __typename?: 'CourseEnrolledStudentsRelationship', node: { __typename?: 'User', id: string }, properties: { __typename?: 'EnrolledInProperties', pendingCourseEnrollmentInvite?: boolean | null } }> } } | null> | null } | null };

export type GetCourseChatResourcesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCourseChatResourcesQuery = { __typename?: 'Query', getCourseChatResources?: { __typename?: 'CourseResponse', data?: Array<{ __typename?: 'Course', id: string, modules: Array<{ __typename?: 'Module', id: string, resourceOrder?: Array<string> | null, aiTutors: Array<{ __typename?: 'AITutor', id: string, title: string, lastModified?: any | null }>, axioResources: Array<{ __typename?: 'AxioResource', id: string, name: string, lastModified?: any | null }>, assignments: Array<{ __typename?: 'Assignment', id: string, name?: string | null, lastModified?: any | null }>, assessment?: { __typename?: 'Assessment', id: string, lastModified?: any | null } | null, projects: Array<{ __typename?: 'Project', id: string, name: string, lastModified?: any | null }> }> } | null> | null } | null };

export type GetCourseCoreQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCourseCoreQuery = { __typename?: 'Query', getCourseCore?: { __typename?: 'CourseResponse', data?: Array<{ __typename?: 'Course', id: string, name?: string | null, course_code?: string | null, description?: string | null, moduleOrder?: Array<string> | null, cost?: number | null, startDate?: any | null, endDate?: any | null, dueDateStartDate?: any | null, dueDateEndDate?: any | null, isDraft?: boolean | null, isEnrollmentAvailable?: boolean | null, generationStatus?: CourseGenerationStatus | null, targetAudience?: string | null, objectives?: Array<string> | null, thumbnail?: string | null, stripeProductId?: string | null, preRequisites: Array<{ __typename?: 'Course', id: string, name?: string | null }> } | null> | null } | null };

export type GetCourseModulesActivitiesLiteQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCourseModulesActivitiesLiteQuery = { __typename?: 'Query', getCourseModulesActivitiesLite?: { __typename?: 'CourseResponse', data?: Array<{ __typename?: 'Course', id: string, name?: string | null, isDraft?: boolean | null, generationStatus?: CourseGenerationStatus | null, moduleOrder?: Array<string> | null, modules: Array<{ __typename?: 'Module', id: string, title?: string | null, description?: string | null, thumbnail?: string | null, imageGenerationStatus?: ModuleImageGenerationStatus | null, resourceOrder?: Array<string> | null, aiTutors: Array<{ __typename?: 'AITutor', id: string, title: string, lastModified?: any | null, dueDate?: any | null, activityState?: ActivityState | null, scheduledDate?: any | null, objectives: Array<{ __typename?: 'Objective', id: string, pendingVideoProcessing?: boolean | null }> }>, pages: Array<{ __typename?: 'Page', id: string, title: string, lastModified?: any | null }>, assessment?: { __typename?: 'Assessment', id: string, assessmentType?: AssessmentType | null, lastModified?: any | null, dueDate?: any | null, activityState?: ActivityState | null, scheduledDate?: any | null, aiTutors: Array<{ __typename?: 'AITutor', id: string }>, moduleHasAssessment: { __typename?: 'Module', id: string, title?: string | null } } | null, axioResources: Array<{ __typename?: 'AxioResource', id: string, name: string, lastModified?: any | null, activityState?: ActivityState | null, scheduledDate?: any | null }>, assignments: Array<{ __typename?: 'Assignment', id: string, name?: string | null, lastModified?: any | null, due_date?: any | null, activityState?: ActivityState | null, scheduledDate?: any | null }>, projects: Array<{ __typename?: 'Project', id: string, name: string, lastModified?: any | null, activityState?: ActivityState | null, scheduledDate?: any | null }>, reviews: Array<{ __typename?: 'Review', id: string, lastModified?: any | null, activityState?: ActivityState | null, scheduledDate?: any | null, hasReviewFor: { __typename?: 'Assessment', id: string, moduleHasAssessment: { __typename?: 'Module', id: string, title?: string | null } } }> }> } | null> | null } | null };

export type GetCourseModulesLiteQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCourseModulesLiteQuery = { __typename?: 'Query', getCourseModulesLite?: { __typename?: 'CourseResponse', data?: Array<{ __typename?: 'Course', id: string, name?: string | null, course_code?: string | null, description?: string | null, moduleOrder?: Array<string> | null, thumbnail?: string | null, isDraft?: boolean | null, isEnrollmentAvailable?: boolean | null, preRequisites: Array<{ __typename?: 'Course', id: string, name?: string | null }>, modules: Array<{ __typename?: 'Module', id: string, title?: string | null, description?: string | null, thumbnail?: string | null, imageGenerationStatus?: ModuleImageGenerationStatus | null, resourceOrder?: Array<string> | null }> } | null> | null } | null };

export type GetCourseProgressInformationQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type GetCourseProgressInformationQuery = { __typename?: 'Query', getCourseProgressInformation?: { __typename?: 'CourseProgressInformationResponse', success: boolean, message?: string | null, count: number, data?: { __typename?: 'CourseProgressInformationData', courseId: string, progress?: number | null, totalModules?: number | null, completedModules?: number | null, modules: Array<{ __typename?: 'ModuleProgressInformationData', id: string, title: string, progress?: number | null, totalActivities?: number | null, completedActivities?: number | null }> } | null } | null };

export type CoursesAndAssignmentsQueryVariables = Exact<{
  schoolId: Scalars['ID']['input'];
}>;


export type CoursesAndAssignmentsQuery = { __typename?: 'Query', getCoursesAndAssignments: { __typename?: 'CoursesAndAssignmentsResponse', success: boolean, message?: string | null, count: number, data?: { __typename?: 'CoursesAndAssignmentsData', courses: Array<{ __typename?: 'CourseWithAssignments', id: string, name?: string | null, course_code?: string | null, assignments: Array<{ __typename?: 'Assignment', id: string, name?: string | null, description?: string | null, due_date?: any | null, points_possible?: number | null, created?: any | null }> }> } | null } };

export type GetCoursesForTranscriptGenerationQueryVariables = Exact<{
  schoolId: Scalars['ID']['input'];
}>;


export type GetCoursesForTranscriptGenerationQuery = { __typename?: 'Query', getCoursesForTranscriptGeneration?: { __typename?: 'CourseResponse', success?: boolean | null, message?: string | null, count?: number | null, data?: Array<{ __typename?: 'Course', id: string, name?: string | null, modules: Array<{ __typename?: 'Module', title?: string | null, aiTutors: Array<{ __typename?: 'AITutor', title: string, id: string, hasChatChats: Array<{ __typename?: 'Chat', id: string, date?: any | null, name: string, context?: string | null, params?: any | null, hasMessageMessages: Array<{ __typename?: 'Message', id: string, content?: string | null, index?: number | null, parameters?: string | null, aspectDetails?: string | null, sender?: string | null, created?: any | null, snackType?: string | null, type?: string | null }> }> }> }> } | null> | null } | null };

export type GetDueSoonActivitiesBySchoolAndUserQueryVariables = Exact<{
  schoolId: Scalars['ID']['input'];
}>;


export type GetDueSoonActivitiesBySchoolAndUserQuery = { __typename?: 'Query', getDueSoonActivitiesBySchoolAndUser?: { __typename?: 'CourseResponse', success?: boolean | null, count?: number | null, data?: Array<{ __typename?: 'Course', id: string, name?: string | null, modules: Array<{ __typename?: 'Module', id: string, title?: string | null, assignments: Array<{ __typename?: 'Assignment', id: string, name?: string | null, description?: string | null, due_date?: any | null, submissions: Array<{ __typename?: 'Submission', id: string, isCompleted?: boolean | null, completedAt?: any | null }> }>, aiTutors: Array<{ __typename?: 'AITutor', id: string, title: string, description?: string | null, dueDate?: any | null, objectives: Array<{ __typename?: 'Objective', id: string, objective?: string | null, sequence?: number | null, userHasProgressConnection: { __typename?: 'ObjectiveUserHasProgressConnection', edges: Array<{ __typename?: 'ObjectiveUserHasProgressRelationship', properties: { __typename?: 'HasProgressProperties', status?: string | null } }> } }> }> }> } | null> | null } | null };

export type GetEnrolledCoursesForStudentQueryVariables = Exact<{
  schoolId: Scalars['ID']['input'];
  studentId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetEnrolledCoursesForStudentQuery = { __typename?: 'Query', getEnrolledCoursesForStudent?: { __typename?: 'CoursesByQueryResponseWithMetadata', count?: number | null, data?: { __typename?: 'CoursesByQueryDataWithMetadata', totalCount?: number | null, courses?: Array<{ __typename?: 'CourseWithMetadata', progress?: number | null, preRequisitesCompleted?: boolean | null, course?: { __typename?: 'Course', id: string, name?: string | null, course_code?: string | null, isDraft?: boolean | null, learningStandards?: string | null, lengthInWeeks?: number | null, objectives?: Array<string> | null, last_modified?: any | null, thumbnail?: string | null, cost?: number | null, startDate?: any | null, description?: string | null, targetAudience?: string | null, generationStatus?: CourseGenerationStatus | null, preRequisites: Array<{ __typename?: 'Course', id: string, name?: string | null, cost?: number | null, description?: string | null, enrolledStudents: Array<{ __typename?: 'User', id: string, name: string }> }>, preRequisiteFor: Array<{ __typename?: 'Course', id: string, name?: string | null, cost?: number | null, description?: string | null, enrolledStudents: Array<{ __typename?: 'User', id: string, name: string }> }>, modules: Array<{ __typename?: 'Module', id: string, title?: string | null, assignments: Array<{ __typename?: 'Assignment', id: string, name?: string | null }>, aiTutors: Array<{ __typename?: 'AITutor', id: string, title: string }>, axioResources: Array<{ __typename?: 'AxioResource', id: string, name: string }> }>, enrolledStudents: Array<{ __typename?: 'User', id: string, name: string }>, degreesHasCourse: Array<{ __typename?: 'Degree', id: string, name: string, usersEnrolledIn: Array<{ __typename?: 'User', id: string, name: string }> }> } | null } | null> | null } | null } | null };

export type GetGradingCenterDashboardDataQueryVariables = Exact<{
  facultyId: Scalars['ID']['input'];
}>;


export type GetGradingCenterDashboardDataQuery = { __typename?: 'Query', getGradingCenterDashboardData?: { __typename?: 'GradingCenterDashboardResponse', success?: boolean | null, message?: string | null, data?: { __typename?: 'GradingCenterDashboardData', assignmentsAndAssessmentsToGrade?: number | null, newSubmissionsToday?: number | null } | null } | null };

export type GetIsRoomDeletedQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIsRoomDeletedQuery = { __typename?: 'Query', getIsRoomDeleted?: { __typename?: 'IsRoomDeletedResponse', success?: boolean | null, data?: boolean | null } | null };

export type GetLatestCourseEvaluationQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type GetLatestCourseEvaluationQuery = { __typename?: 'Query', getLatestCourseEvaluation?: { __typename?: 'CourseEvaluation', id: string, courseId: string, jobId: string, status: string, createdAt: any, overallSummary?: string | null, teacherRecommendations?: Array<string> | null, curriculumEvaluationJson?: string | null, assignmentEvaluationJson?: string | null, courseHasEvaluation?: { __typename?: 'Course', id: string, name?: string | null, course_code?: string | null, startDate?: any | null } | null } | null };

export type GetUserAnnouncementsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type GetUserAnnouncementsQuery = { __typename?: 'Query', getUserAnnouncements: { __typename?: 'AnnouncementListResponse', success: boolean, message?: string | null, count: number, data: Array<{ __typename?: 'AnnouncementWithStatus', id: string, title: string, message: string, expirationDate?: any | null, created: any, lastModified: any, isActive: boolean, isNew?: boolean | null, audienceType: AudienceType, author: { __typename?: 'User', id: string, name: string }, courses: Array<{ __typename?: 'Course', id: string, name?: string | null }>, degrees: Array<{ __typename?: 'Degree', id: string, name: string }>, school?: { __typename?: 'School', id: string, provider_name?: string | null } | null }> } };

export type GetUserSubmissionsQueryVariables = Exact<{
  assignmentId: Scalars['ID']['input'];
}>;


export type GetUserSubmissionsQuery = { __typename?: 'Query', getUserSubmissions?: { __typename?: 'SubmissionResponse', success?: boolean | null, message?: string | null, data?: Array<{ __typename?: 'Submission', id: string, isCompleted?: boolean | null, completedAt?: any | null, hasTeacherGraded?: boolean | null, grade?: number | null, feedback?: string | null, created?: any | null, files: Array<{ __typename?: 'File', id: string, fileName: string, fileURL: string, created: any, status: FileStatus }> } | null> | null } | null };

export type GetWorksheetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetWorksheetQuery = { __typename?: 'Query', getWorksheet?: { __typename?: 'WorksheetResponse', success?: boolean | null, message?: string | null, data?: { __typename?: 'WorksheetResponseData', worksheetId: string, pdfUrl: string, generationStatus?: WorksheetGenerationStatus | null } | null } | null };

export type GetProjectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProjectQuery = { __typename?: 'Query', getProject: { __typename?: 'SingleProjectResponse', success: boolean, message?: string | null, data?: { __typename?: 'Project', id: string, moduleId: string, order: number, name: string, description?: string | null, scopeDocument?: string | null, deliverableTypes?: Array<string> | null, assessmentCriteria?: Array<string> | null, expectedOutcomes?: Array<string> | null, status: ProjectStatus, dueDate?: any | null, created?: any | null, lastModified?: any | null, files: Array<{ __typename?: 'File', id: string, fileName: string, fileURL: string, created: any, status: FileStatus }> } | null } };

export type GetProjectFrameworkQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProjectFrameworkQuery = { __typename?: 'Query', getProject: { __typename?: 'SingleProjectResponse', success: boolean, message?: string | null, data?: { __typename?: 'Project', id: string, moduleId: string, order: number, name: string, description?: string | null, scopeDocument?: string | null, deliverableTypes?: Array<string> | null, assessmentCriteria?: Array<string> | null, expectedOutcomes?: Array<string> | null, status: ProjectStatus, dueDate?: any | null, created?: any | null, lastModified?: any | null, files: Array<{ __typename?: 'File', id: string, fileName: string, fileURL: string, created: any, status: FileStatus }> } | null } };

export type GetProjectsByStudentQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProjectsByStudentQuery = { __typename?: 'Query', getProjectsByStudent: { __typename?: 'ProjectResponse', success: boolean, message?: string | null, data?: Array<{ __typename?: 'Project', id: string, moduleId: string, order: number, name: string, description?: string | null, scopeDocument?: string | null, deliverableTypes?: Array<string> | null, assessmentCriteria?: Array<string> | null, expectedOutcomes?: Array<string> | null, status: ProjectStatus, dueDate?: any | null, created?: any | null, lastModified?: any | null, files: Array<{ __typename?: 'File', id: string, fileName: string, fileURL: string, created: any, status: FileStatus }> } | null> | null } };

export type GetProjectSubmissionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProjectSubmissionQuery = { __typename?: 'Query', getProjectSubmission: { __typename?: 'SingleProjectSubmissionResponse', success: boolean, message?: string | null, data?: { __typename?: 'ProjectSubmission', id: string, proposal: string, approachMethodology?: string | null, scopeJustification?: string | null, expectedOutcomes?: Array<string> | null, status: ProjectSubmissionStatus, vettingStatus?: ProjectVettingStatus | null, complianceScore?: number | null, aiAssessment?: string | null, suggestedImprovements?: Array<string> | null, grade?: number | null, hasTeacherGraded?: boolean | null, isCompleted?: boolean | null, completedAt?: any | null, gradedAt?: any | null, feedback?: string | null, created?: any | null, lastModified?: any | null, totalTasks?: number | null, completedTasks?: number | null, submissionLink?: string | null, submissionNotes?: string | null, files: Array<{ __typename?: 'File', id: string, fileName: string, fileURL: string, created: any, status: FileStatus }>, requirements: Array<{ __typename?: 'ProjectRequirement', id: string, title: string, description?: string | null, type: RequirementType, priority: Priority, completed: boolean }>, project: { __typename?: 'Project', id: string, moduleId: string, order: number, name: string, description?: string | null, scopeDocument?: string | null, deliverableTypes?: Array<string> | null, assessmentCriteria?: Array<string> | null, expectedOutcomes?: Array<string> | null, status: ProjectStatus, dueDate?: any | null, created?: any | null, lastModified?: any | null }, user: { __typename?: 'User', id: string } } | null } };

export type GetProjectSubmissionsByProjectQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetProjectSubmissionsByProjectQuery = { __typename?: 'Query', getProjectSubmissionsByProject: { __typename?: 'ProjectSubmissionResponse', success: boolean, message?: string | null, data?: Array<{ __typename?: 'ProjectSubmission', id: string, proposal: string, approachMethodology?: string | null, scopeJustification?: string | null, expectedOutcomes?: Array<string> | null, status: ProjectSubmissionStatus, vettingStatus?: ProjectVettingStatus | null, complianceScore?: number | null, aiAssessment?: string | null, suggestedImprovements?: Array<string> | null, grade?: number | null, hasTeacherGraded?: boolean | null, isCompleted?: boolean | null, completedAt?: any | null, gradedAt?: any | null, feedback?: string | null, created?: any | null, lastModified?: any | null, totalTasks?: number | null, completedTasks?: number | null, submissionLink?: string | null, submissionNotes?: string | null, files: Array<{ __typename?: 'File', id: string, fileName: string, fileURL: string, created: any, status: FileStatus }>, requirements: Array<{ __typename?: 'ProjectRequirement', id: string, title: string, description?: string | null, type: RequirementType, priority: Priority, category?: string | null, estimatedHours?: number | null, completed: boolean }>, project: { __typename?: 'Project', id: string, moduleId: string, order: number, name: string, description?: string | null, scopeDocument?: string | null, deliverableTypes?: Array<string> | null, assessmentCriteria?: Array<string> | null, expectedOutcomes?: Array<string> | null, status: ProjectStatus, dueDate?: any | null, created?: any | null, lastModified?: any | null, files: Array<{ __typename?: 'File', id: string, fileName: string, fileURL: string, created: any, status: FileStatus }> }, user: { __typename?: 'User', id: string } } | null> | null } };

export type GetProjectSubmissionsByStudentQueryVariables = Exact<{
  studentId: Scalars['ID']['input'];
}>;


export type GetProjectSubmissionsByStudentQuery = { __typename?: 'Query', getProjectSubmissionsByStudent: { __typename?: 'ProjectSubmissionResponse', success: boolean, message?: string | null, data?: Array<{ __typename?: 'ProjectSubmission', id: string, proposal: string, approachMethodology?: string | null, scopeJustification?: string | null, expectedOutcomes?: Array<string> | null, status: ProjectSubmissionStatus, vettingStatus?: ProjectVettingStatus | null, complianceScore?: number | null, aiAssessment?: string | null, suggestedImprovements?: Array<string> | null, grade?: number | null, hasTeacherGraded?: boolean | null, isCompleted?: boolean | null, completedAt?: any | null, created?: any | null, lastModified?: any | null, totalTasks?: number | null, completedTasks?: number | null, requirements: Array<{ __typename?: 'ProjectRequirement', id: string, title: string, description?: string | null, type: RequirementType, priority: Priority, completed: boolean }>, project: { __typename?: 'Project', id: string, moduleId: string, order: number, name: string, description?: string | null, scopeDocument?: string | null, deliverableTypes?: Array<string> | null, assessmentCriteria?: Array<string> | null, expectedOutcomes?: Array<string> | null, status: ProjectStatus, dueDate?: any | null, created?: any | null, lastModified?: any | null, files: Array<{ __typename?: 'File', id: string, fileName: string, fileURL: string, created: any, status: FileStatus }> }, user: { __typename?: 'User', id: string } } | null> | null } };

export type CreateProjectMutationVariables = Exact<{
  project: CreateProjectInput;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject: { __typename?: 'SingleProjectResponse', success: boolean, message?: string | null, data?: { __typename?: 'Project', id: string, moduleId: string, order: number, name: string, description?: string | null, scopeDocument?: string | null, deliverableTypes?: Array<string> | null, assessmentCriteria?: Array<string> | null, expectedOutcomes?: Array<string> | null, status: ProjectStatus, dueDate?: any | null, created?: any | null, lastModified?: any | null } | null } };

export type UpdateProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  project: UpdateProjectInput;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject: { __typename?: 'SingleProjectResponse', success: boolean, message?: string | null, data?: { __typename?: 'Project', id: string, moduleId: string, order: number, name: string, description?: string | null, scopeDocument?: string | null, deliverableTypes?: Array<string> | null, assessmentCriteria?: Array<string> | null, expectedOutcomes?: Array<string> | null, status: ProjectStatus, dueDate?: any | null, lastModified?: any | null } | null } };

export type DeleteProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProjectMutation = { __typename?: 'Mutation', deleteProject: { __typename?: 'SingleProjectResponse', success: boolean, message?: string | null, data?: { __typename?: 'Project', id: string } | null } };

export type CreateProjectSubmissionMutationVariables = Exact<{
  submission: CreateProjectSubmissionInput;
}>;


export type CreateProjectSubmissionMutation = { __typename?: 'Mutation', createProjectSubmission: { __typename?: 'SingleProjectSubmissionResponse', success: boolean, message?: string | null, data?: { __typename?: 'ProjectSubmission', id: string, proposal: string, approachMethodology?: string | null, scopeJustification?: string | null, expectedOutcomes?: Array<string> | null, status: ProjectSubmissionStatus, vettingStatus?: ProjectVettingStatus | null, created?: any | null, lastModified?: any | null } | null } };

export type UpdateProjectSubmissionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  submission: UpdateProjectSubmissionInput;
}>;


export type UpdateProjectSubmissionMutation = { __typename?: 'Mutation', updateProjectSubmission: { __typename?: 'SingleProjectSubmissionResponse', success: boolean, message?: string | null, data?: { __typename?: 'ProjectSubmission', id: string, proposal: string, approachMethodology?: string | null, scopeJustification?: string | null, expectedOutcomes?: Array<string> | null, status: ProjectSubmissionStatus, vettingStatus?: ProjectVettingStatus | null, lastModified?: any | null } | null } };

export type SubmitProjectForReviewMutationVariables = Exact<{
  submissionId: Scalars['ID']['input'];
}>;


export type SubmitProjectForReviewMutation = { __typename?: 'Mutation', submitProjectForReview: { __typename?: 'SingleProjectSubmissionResponse', success: boolean, message?: string | null, data?: { __typename?: 'ProjectSubmission', id: string, status: ProjectSubmissionStatus, vettingStatus?: ProjectVettingStatus | null, complianceScore?: number | null, aiAssessment?: string | null, suggestedImprovements?: Array<string> | null, lastModified?: any | null } | null } };

export type ApproveProjectSubmissionMutationVariables = Exact<{
  submissionId: Scalars['ID']['input'];
}>;


export type ApproveProjectSubmissionMutation = { __typename?: 'Mutation', approveProjectSubmission: { __typename?: 'SingleProjectSubmissionResponse', success: boolean, message?: string | null, data?: { __typename?: 'ProjectSubmission', id: string, status: ProjectSubmissionStatus, lastModified?: any | null } | null } };

export type RejectProjectSubmissionMutationVariables = Exact<{
  submissionId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
}>;


export type RejectProjectSubmissionMutation = { __typename?: 'Mutation', rejectProjectSubmission: { __typename?: 'SingleProjectSubmissionResponse', success: boolean, message?: string | null, data?: { __typename?: 'ProjectSubmission', id: string, status: ProjectSubmissionStatus, lastModified?: any | null } | null } };

export type GradeProjectSubmissionMutationVariables = Exact<{
  submissionId: Scalars['ID']['input'];
  grade: Scalars['Float']['input'];
  feedback?: InputMaybe<Scalars['String']['input']>;
}>;


export type GradeProjectSubmissionMutation = { __typename?: 'Mutation', gradeProjectSubmission: { __typename?: 'SingleProjectSubmissionResponse', success: boolean, message?: string | null, data?: { __typename?: 'ProjectSubmission', id: string, grade?: number | null, hasTeacherGraded?: boolean | null, isCompleted?: boolean | null, completedAt?: any | null, lastModified?: any | null } | null } };

export type ResubmitProjectProposalMutationVariables = Exact<{
  submissionId: Scalars['ID']['input'];
  submission: UpdateProjectSubmissionInput;
}>;


export type ResubmitProjectProposalMutation = { __typename?: 'Mutation', resubmitProjectProposal: { __typename?: 'SingleProjectSubmissionResponse', success: boolean, message?: string | null, data?: { __typename?: 'ProjectSubmission', id: string, proposal: string, approachMethodology?: string | null, scopeJustification?: string | null, expectedOutcomes?: Array<string> | null, status: ProjectSubmissionStatus, vettingStatus?: ProjectVettingStatus | null, lastModified?: any | null } | null } };

export type GetActiveProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveProjectsQuery = { __typename?: 'Query', getProjectsByStudent: { __typename?: 'ProjectResponse', success: boolean, message?: string | null, data?: Array<{ __typename?: 'Project', id: string, moduleId: string, order: number, name: string, description?: string | null, scopeDocument?: string | null, status: ProjectStatus, dueDate?: any | null, created?: any | null, lastModified?: any | null, submissions: Array<{ __typename?: 'ProjectSubmission', id: string, status: ProjectSubmissionStatus, vettingStatus?: ProjectVettingStatus | null, complianceScore?: number | null, completedTasks?: number | null, totalTasks?: number | null, requirements: Array<{ __typename?: 'ProjectRequirement', id: string, title: string, description?: string | null, type: RequirementType, priority: Priority, completed: boolean }> }> } | null> | null } };

export type GetSubmissionRequirementsQueryVariables = Exact<{
  submissionId: Scalars['ID']['input'];
}>;


export type GetSubmissionRequirementsQuery = { __typename?: 'Query', getSubmissionRequirements: { __typename?: 'ProjectRequirementResponse', success: boolean, message?: string | null, data?: Array<{ __typename?: 'ProjectRequirement', id: string, title: string, description?: string | null, type: RequirementType, priority: Priority, estimatedHours?: number | null, dueDate?: any | null, dependencies?: Array<string> | null, order: number, completed: boolean, completedDate?: any | null, isGenerated: boolean, aiRationale?: string | null, created?: any | null, lastModified?: any | null } | null> | null } };

export type CreateProjectRequirementMutationVariables = Exact<{
  requirement: CreateProjectRequirementInput;
}>;


export type CreateProjectRequirementMutation = { __typename?: 'Mutation', createProjectRequirement: { __typename?: 'SingleProjectRequirementResponse', success: boolean, message?: string | null, data?: { __typename?: 'ProjectRequirement', id: string, title: string, description?: string | null, type: RequirementType, priority: Priority, estimatedHours?: number | null, dueDate?: any | null, dependencies?: Array<string> | null, completed: boolean, isGenerated: boolean, aiRationale?: string | null, created?: any | null, lastModified?: any | null } | null } };

export type UpdateProjectRequirementMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  requirement: UpdateProjectRequirementInput;
}>;


export type UpdateProjectRequirementMutation = { __typename?: 'Mutation', updateProjectRequirement: { __typename?: 'SingleProjectRequirementResponse', success: boolean, message?: string | null, data?: { __typename?: 'ProjectRequirement', id: string, title: string, description?: string | null, type: RequirementType, priority: Priority, estimatedHours?: number | null, dueDate?: any | null, dependencies?: Array<string> | null, completed: boolean, completedDate?: any | null, lastModified?: any | null } | null } };

export type MarkProjectRequirementCompleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MarkProjectRequirementCompleteMutation = { __typename?: 'Mutation', markProjectRequirementComplete: { __typename?: 'SingleProjectRequirementResponse', success: boolean, message?: string | null, data?: { __typename?: 'ProjectRequirement', id: string, completed: boolean, completedDate?: any | null, lastModified?: any | null } | null } };

export type DeleteProjectRequirementMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProjectRequirementMutation = { __typename?: 'Mutation', deleteProjectRequirement: { __typename?: 'SingleProjectRequirementResponse', success: boolean, message?: string | null, data?: { __typename?: 'ProjectRequirement', id: string } | null } };

export type GenerateProjectRequirementsMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  submissionId: Scalars['ID']['input'];
}>;


export type GenerateProjectRequirementsMutation = { __typename?: 'Mutation', generateProjectRequirements: { __typename?: 'ProjectRequirementResponse', success: boolean, message?: string | null, data?: Array<{ __typename?: 'ProjectRequirement', id: string, title: string, description?: string | null, type: RequirementType, priority: Priority, estimatedHours?: number | null, dueDate?: any | null, dependencies?: Array<string> | null, completed: boolean, isGenerated: boolean, aiRationale?: string | null, created?: any | null, lastModified?: any | null } | null> | null } };

export type SubmitFinalProjectMutationVariables = Exact<{
  submission: SubmitFinalProjectInput;
}>;


export type SubmitFinalProjectMutation = { __typename?: 'Mutation', submitFinalProject: { __typename?: 'SingleProjectSubmissionResponse', success: boolean, message?: string | null, data?: { __typename?: 'ProjectSubmission', id: string, proposal: string, approachMethodology?: string | null, scopeJustification?: string | null, expectedOutcomes?: Array<string> | null, grade?: number | null, isCompleted?: boolean | null, completedAt?: any | null, hasTeacherGraded?: boolean | null, status: ProjectSubmissionStatus, vettingStatus?: ProjectVettingStatus | null, complianceScore?: number | null, aiAssessment?: string | null, suggestedImprovements?: Array<string> | null, created?: any | null, lastModified?: any | null } | null } };

export type SubmitProjectSubmissionFilesMutationVariables = Exact<{
  submissionId: Scalars['ID']['input'];
  files: Array<FileInput> | FileInput;
}>;


export type SubmitProjectSubmissionFilesMutation = { __typename?: 'Mutation', submitProjectSubmissionFiles: { __typename?: 'SingleProjectSubmissionResponse', success: boolean, message?: string | null, data?: { __typename?: 'ProjectSubmission', id: string } | null } };

export type DeleteProjectSubmissionMutationVariables = Exact<{
  submissionId: Scalars['ID']['input'];
}>;


export type DeleteProjectSubmissionMutation = { __typename?: 'Mutation', deleteProjectSubmission: { __typename?: 'SingleProjectSubmissionResponse', success: boolean, message?: string | null, data?: { __typename?: 'ProjectSubmission', id: string } | null } };

export type SuggestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type SuggestionsQuery = { __typename?: 'Query', getSuggestions?: Array<{ __typename?: 'Suggestion', type: string, content: string, integrationId?: string | null, classId?: string | null, assignmentId?: string | null, trackName?: string | null } | null> | null };

export type GetDegreesByDegreeIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDegreesByDegreeIdQuery = { __typename?: 'Query', getDegree?: { __typename?: 'DegreeResponse', success?: boolean | null, message?: string | null, count?: number | null, data?: Array<{ __typename?: 'Degree', id: string, name: string, description?: string | null, usersEnrolledIn: Array<{ __typename?: 'User', id: string, name: string }>, coursesHasCourse: Array<{ __typename?: 'Course', id: string, name?: string | null, isDraft?: boolean | null, course_code?: string | null }> } | null> | null } | null };

export type GetDegreeBySchoolQueryVariables = Exact<{
  schoolId: Scalars['ID']['input'];
}>;


export type GetDegreeBySchoolQuery = { __typename?: 'Query', getDegreeBySchool?: { __typename?: 'DegreeResponse', success?: boolean | null, message?: string | null, count?: number | null, data?: Array<{ __typename?: 'Degree', id: string, name: string, created?: any | null, last_modified?: any | null, description?: string | null } | null> | null } | null };

export type GetDegreesBySchoolByQueryQueryVariables = Exact<{
  schoolId: Scalars['ID']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDegreesBySchoolByQueryQuery = { __typename?: 'Query', getDegreesBySchoolByQuery?: { __typename?: 'DegreesBySchoolByQueryResponse', success?: boolean | null, message?: string | null, count?: number | null, data?: { __typename?: 'DegreesBySchoolByQueryData', totalCount?: number | null, degrees?: Array<{ __typename?: 'Degree', id: string, name: string, description?: string | null, usersEnrolledIn: Array<{ __typename?: 'User', id: string, name: string }>, coursesHasCourse: Array<{ __typename?: 'Course', id: string, name?: string | null, course_code?: string | null }> } | null> | null } | null } | null };

export type GetDegreeForUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDegreeForUserQuery = { __typename?: 'Query', getDegreeForUser?: { __typename?: 'DegreeResponse', count?: number | null, message?: string | null, success?: boolean | null, data?: Array<{ __typename?: 'Degree', description?: string | null, name: string, id: string } | null> | null } | null };

export type GetDegreeForUserWithEnrolledUserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDegreeForUserWithEnrolledUserInfoQuery = { __typename?: 'Query', getDegreeForUserWithEnrolledUserInfo?: { __typename?: 'DegreeResponse', count?: number | null, message?: string | null, success?: boolean | null, data?: Array<{ __typename?: 'Degree', description?: string | null, name: string, id: string, usersEnrolledInConnection: { __typename?: 'DegreeUsersEnrolledInConnection', edges: Array<{ __typename?: 'DegreeUsersEnrolledInRelationship', node: { __typename?: 'User', id: string }, properties: { __typename?: 'EnrolledInDegreeProperties', pendingDegreeEnrollmentInvite?: boolean | null } }> } } | null> | null } | null };

export type GetStudentsByDegreeIdQueryVariables = Exact<{
  degreeId: Scalars['ID']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetStudentsByDegreeIdQuery = { __typename?: 'Query', getStudentsByDegreeId?: { __typename?: 'DegreeRosterServiceResult', success?: boolean | null, message?: string | null, count?: number | null, data?: Array<{ __typename?: 'DegreeRosterData', id: string, name: string, email: string, pendingDegreeEnrollmentInvite?: boolean | null, enrollmentDate: any } | null> | null } | null };

export type GetAdminDocumentsForTenantQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminDocumentsForTenantQuery = { __typename?: 'Query', getAdminDocumentsForTenant: { __typename?: 'AdminDocumentsResponse', success: boolean, message?: string | null, count: number, data: Array<{ __typename?: 'Document', id: string, title: string, status: DocumentStatus, adminDoc?: boolean | null, created: any, last_modified: any, files: Array<{ __typename?: 'File', id: string, fileName: string, fileURL: string, status: FileStatus }> }> } };

export type GetAdminDocumentAnalyticsQueryVariables = Exact<{
  input?: InputMaybe<DocumentReferenceAnalyticsInput>;
}>;


export type GetAdminDocumentAnalyticsQuery = { __typename?: 'Query', getAdminDocumentAnalytics: { __typename?: 'AdminDocumentAnalyticsResponse', success: boolean, message?: string | null, count: number, data: Array<{ __typename?: 'AdminDocumentAnalytics', referenceCount: number, document: { __typename?: 'Document', id: string, title: string } }> } };

export type GetDocumentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDocumentQuery = { __typename?: 'Query', getDocument?: { __typename?: 'DocumentResponse', success: boolean, message?: string | null, count?: number | null, data?: { __typename?: 'Document', id: string, title: string, summary?: string | null, status: DocumentStatus, sourceType?: DocumentSourceType | null, created: any, last_modified: any, files: Array<{ __typename?: 'File', id: string, fileName: string, fileURL: string, status: FileStatus }> } | null } | null };

export type GetEnrollmentLinkQueryVariables = Exact<{
  courseId: Scalars['ID']['input'];
}>;


export type GetEnrollmentLinkQuery = { __typename?: 'Query', getEnrollmentLink?: { __typename?: 'EnrollmentLinkServiceResult', success: boolean, message?: string | null, count: number, data?: { __typename?: 'EnrollmentLinkData', id: string, enrollmentLink: string, maxEnrollments: number, currentEnrollments: number, expiresAt: any, createdAt: any, lastModified: any } | null } | null };

export type GetAllowedUploadSpecificationsQueryVariables = Exact<{
  storagePath: StoragePathType;
}>;


export type GetAllowedUploadSpecificationsQuery = { __typename?: 'Query', getAllowedUploadSpecifications: { __typename?: 'AllowedUploadSpecificationsResponse', count?: number | null, message?: string | null, success: boolean, data?: { __typename?: 'AllowedUploadSpecifications', allowedMimeTypes: Array<string>, maxFileSize: number } | null } };

export type GetFileQueryVariables = Exact<{
  fileId: Scalars['ID']['input'];
}>;


export type GetFileQuery = { __typename?: 'Query', getFile: { __typename?: 'FileResponse', count?: number | null, message?: string | null, success: boolean, data?: Array<{ __typename?: 'File', fileName: string, id: string, status: FileStatus } | null> | null } };

export type FoodByDateQueryVariables = Exact<{
  date: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
}>;


export type FoodByDateQuery = { __typename?: 'Query', getFoodsByDate?: Array<{ __typename?: 'Food', name: string, calories?: number | null, carbohydrates_grams?: number | null, fat_grams?: number | null, fiber_grams?: number | null, protein_grams?: number | null, serving_size?: string | null, sodium_mg?: number | null, sugars_grams?: number | null } | null> | null };

export type InviteCountQueryVariables = Exact<{ [key: string]: never; }>;


export type InviteCountQuery = { __typename?: 'Query', userInviteCount?: { __typename?: 'InviteCountResponse', count: number } | null, me?: { __typename?: 'MeResponse', name?: string | null, username?: string | null, gender?: string | null, isOnboarded?: boolean | null, isPro?: boolean | null, phoneNumber?: string | null, isEmailVerified?: boolean | null } | null };

export type DateForChatQueryVariables = Exact<{
  date: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
}>;


export type DateForChatQuery = { __typename?: 'Query', getChatForDate?: { __typename?: 'ChatResponse', id: string, date?: string | null, timezone?: string | null, conversation: Array<{ __typename?: 'MessageResponse', id: string, sender?: string | null, content?: string | null, type?: string | null, nodeId?: string | null, snackType?: string | null, file?: { __typename?: 'File', fileName: string, id: string } | null, parameters?: { __typename?: 'ParametersType', lastGeneratedTopic?: string | null, lastGeneratedLabel?: string | null, questContext?: string | null, userResponse?: string | null } | null, aspectDetails?: { __typename?: 'AspectDetailsType', name?: string | null, category?: string | null, id?: number | null, friendId?: number | null, relationshipType?: string | null, connectionStrength?: number | null, frequencyOfInteraction?: string | null, lastInteractionDate?: any | null, sharedInterests?: Array<string | null> | null, sharedGoals?: Array<string | null> | null, sharedEventsAttended?: Array<string | null> | null, friendPersonalityTraits?: Array<string | null> | null, communicationChannel?: string | null, level?: string | null, startDate?: any | null, lastUpdated?: any | null, learningStyle?: string | null, language?: string | null, timeOfDay?: string | null, learningDuration?: number | null, contentType?: string | null, notificationPreferences?: string | null, type?: string | null, completionStatus?: string | null, deadline?: any | null, priority?: string | null, value?: number | null, description?: string | null, date?: any | null, importance?: number | null, status?: string | null, endDate?: any | null, text?: string | null, sentiment?: string | null, context?: string | null, intensity?: number | null, timestamp?: any | null, trigger?: string | null, calories?: number | null, carbohydrates_grams?: number | null, fat_grams?: number | null, fiber_grams?: number | null, protein_grams?: number | null, serving_size?: string | null, sodium_mg?: number | null, sugars_grams?: number | null, totalCalories?: number | null, totalCarbs?: number | null, totalFats?: number | null, totalProteins?: number | null, totalCaloriesBurned?: number | null, totalDurationMinutes?: number | null, totalWorkouts?: number | null, water_intake_oz?: number | null } | null }> } | null };

export type FieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type FieldsQuery = { __typename?: 'Query', getFields: Array<{ __typename?: 'Field', name: string, id: string, mastery?: number | null, isRelevant?: boolean | null, imageUrl?: string | null } | null> };

export type GetLearningTreeQueryVariables = Exact<{
  level: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type GetLearningTreeQuery = { __typename?: 'Query', getLearningTree?: { __typename?: 'LearningTree', FieldName?: string | null, SubfieldName?: string | null, TopicName?: string | null, ChapterName?: string | null, SubchapterName?: string | null } | null };

export type NodeGraphQueryVariables = Exact<{
  nodeName: Scalars['String']['input'];
  nodeLabel: NodeLabel;
}>;


export type NodeGraphQuery = { __typename?: 'Query', getNodeChildren: Array<{ __typename?: 'LearningNode', name: string, description?: string | null, id: string, mastery?: number | null, label?: string | null, unitsCount?: number | null, imageUrl?: string | null } | null>, getNode?: { __typename?: 'LearningNode', name: string, description?: string | null, id: string, mastery?: number | null, label?: string | null, imageUrl?: string | null } | null, getNodeParents: Array<{ __typename?: 'LearningNode', name: string, id: string, mastery?: number | null, label?: string | null } | null> };

export type RecentTracksQueryVariables = Exact<{
  filterByCategory?: InputMaybe<Scalars['String']['input']>;
}>;


export type RecentTracksQuery = { __typename?: 'Query', getRecentTracks?: Array<{ __typename?: 'RecentTrack', name: string, description?: string | null, totalUnits?: number | null, completedUnits?: number | null, parentFields?: Array<string | null> | null, parentSubfield?: string | null, mastery?: number | null, imageUrl?: string | null } | null> | null };

export type TableOfContentsQueryVariables = Exact<{
  learningNodeNames: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  hierarchyLabel: Scalars['String']['input'];
}>;


export type TableOfContentsQuery = { __typename?: 'Query', getTableOfContents?: Array<{ __typename?: 'Hierarchy', name: string, mastery: number, id?: string | null, isRelevant: boolean, parentName: string, description?: string | null, completed?: number | null, index?: number | null } | null> | null };

export type TrackOverviewQueryVariables = Exact<{
  topicName: Scalars['String']['input'];
}>;


export type TrackOverviewQuery = { __typename?: 'Query', getTrackOverview?: { __typename?: 'TrackOverview', name?: string | null, description?: string | null, objectives?: Array<string | null> | null, skillRequirements?: Array<string | null> | null, otherRequirements?: Array<string | null> | null, otherRequirementsTitle?: string | null, lessons?: Array<{ __typename?: 'Lesson', name?: string | null, description?: string | null } | null> | null, prerequisites?: Array<{ __typename?: 'Prerequisite', name?: string | null, subfield?: string | null, field?: string | null, mastery?: number | null } | null> | null } | null };

export type UserProgressQueryVariables = Exact<{
  nodeName: Scalars['String']['input'];
  nodeLabel: NodeLabel;
}>;


export type UserProgressQuery = { __typename?: 'Query', getUserProgress: Array<{ __typename?: 'UserProgress', totalMastery?: number | null, lastModified: string, child: { __typename?: 'ChildInfo', name: string, label: string, totalTracks?: number | null, completedTracks?: number | null } }> };

export type GetFirstSubchapterByTopicNameQueryVariables = Exact<{
  topicName: Scalars['String']['input'];
}>;


export type GetFirstSubchapterByTopicNameQuery = { __typename?: 'Query', getFirstSubchapterByTopicName: { __typename?: 'SubchapterDetails', success: boolean, message?: string | null, id?: string | null, name?: string | null, description?: string | null, objectives?: Array<{ __typename?: 'LearningObjective', id: string, title: string, description: string, completed?: number | null } | null> | null } };

export type GetLearningObjectiveByIdQueryVariables = Exact<{
  loId: Scalars['ID']['input'];
}>;


export type GetLearningObjectiveByIdQuery = { __typename?: 'Query', getLearningObjectiveById: { __typename?: 'LearningObjectiveResponse', success: boolean, message?: string | null, id?: string | null, title?: string | null, description?: string | null, completed?: number | null } };

export type GetLearningObjectivesBySubchapterQueryVariables = Exact<{
  learningObjectiveId: Scalars['ID']['input'];
}>;


export type GetLearningObjectivesBySubchapterQuery = { __typename?: 'Query', getLearningObjectivesBySubchapter?: Array<{ __typename?: 'LearningObjective', id: string, title: string, description: string, index?: number | null, completed?: number | null } | null> | null };

export type SubchapterByIdQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type SubchapterByIdQuery = { __typename?: 'Query', getSubchapterById?: { __typename?: 'SubchapterDetails', id?: string | null, name?: string | null, description?: string | null, totalMastery?: number | null, objectives?: Array<{ __typename?: 'LearningObjective', id: string, title: string, description: string, completed?: number | null } | null> | null } | null };

export type GetMasteryQueryVariables = Exact<{
  learningObjectiveId: Scalars['ID']['input'];
}>;


export type GetMasteryQuery = { __typename?: 'Query', getUserLearningObjectiveMastery?: { __typename?: 'MasteryResult', learningObjectiveId?: string | null, userId?: string | null, totalMastery?: number | null } | null };

export type GetUserNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserNotificationsQuery = { __typename?: 'Query', getUserNotifications: { __typename?: 'NotificationResponse', success: boolean, message?: string | null, count?: number | null, data?: Array<{ __typename?: 'Notification', id: string, title: string, message: string, created: any, type?: NotificationType | null, isRead: boolean, actionUrl?: string | null, event: { __typename?: 'NotificationEvent', id: string, eventType?: NotificationEventType | null } } | null> | null } };

export type GetOAuthClientQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOAuthClientQuery = { __typename?: 'Query', getOAuthClient?: { __typename?: 'OAuthClientResponse', success?: boolean | null, message?: string | null, count?: number | null, data?: Array<{ __typename?: 'OAuthClient', id: string, clientId: string, clientSecret: string, created: any, tenant: { __typename?: 'Tenant', id?: string | null, tenantDomain: string } } | null> | null } | null };

export type GetOAuthClientsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOAuthClientsQuery = { __typename?: 'Query', getOAuthClients?: { __typename?: 'OAuthClientResponse', success?: boolean | null, message?: string | null, count?: number | null, data?: Array<{ __typename?: 'OAuthClient', id: string, clientId: string, clientSecret: string, created: any, tenant: { __typename?: 'Tenant', id?: string | null, tenantDomain: string } } | null> | null } | null };

export type ExportCsvQueryVariables = Exact<{ [key: string]: never; }>;


export type ExportCsvQuery = { __typename?: 'Query', exportCsv: { __typename?: 'ExportCsvResponse', success: boolean, csvData?: string | null, message?: string | null } };

export type AssignmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type AssignmentsQuery = { __typename?: 'Query', getAssignments?: Array<{ __typename?: 'GetAssignmentResponse', id: string, title: string, description?: string | null, gradePoints?: number | null, createdDate?: string | null, pointsPossible?: number | null, dueDate?: string | null, url?: string | null, objectives?: Array<{ __typename?: 'GetAssignmentObjectiveResponse', id: string, objective?: string | null, status?: string | null } | null> | null } | null> | null };

export type SchoolsQueryVariables = Exact<{ [key: string]: never; }>;


export type SchoolsQuery = { __typename?: 'Query', getSchools?: Array<{ __typename?: 'School', id: string, provider_name?: string | null, team_name?: string | null, provider_icon_url?: string | null } | null> | null };

export type DeleteTodoMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteTodoMutation = { __typename?: 'Mutation', deleteTodo: { __typename?: 'ResponseType', success: boolean, message?: string | null } };

export type RecentTodosQueryVariables = Exact<{ [key: string]: never; }>;


export type RecentTodosQuery = { __typename?: 'Query', getRecentTodosForUser: { __typename?: 'TodoResponse', success: boolean, message?: string | null, count?: number | null, data?: Array<{ __typename?: 'Todo', id: string, name: string, description?: string | null, priority?: string | null, date?: any | null, completed: boolean, completed_date?: any | null, isRecurring?: boolean | null, recurringFrequency?: string | null, recurringDaily?: boolean | null, recurringDayOfWeek?: string | null, recurringDayOfMonth?: number | null, recurringTime?: string | null, timeOfDay?: string | null, timezone?: string | null, aiSummary?: string | null, workspacesHasTodo: Array<{ __typename?: 'Workspace', id: string, name: string }> } | null> | null } };

export type SearchTodosQueryVariables = Exact<{
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchTodosQuery = { __typename?: 'Query', searchTodosForUser: { __typename?: 'TodoResponse', success: boolean, message?: string | null, count?: number | null, data?: Array<{ __typename?: 'Todo', id: string, name: string, description?: string | null, priority?: string | null, date?: any | null, completed: boolean, completed_date?: any | null, isRecurring?: boolean | null, recurringFrequency?: string | null, recurringDaily?: boolean | null, recurringDayOfWeek?: string | null, recurringDayOfMonth?: number | null, recurringTime?: string | null, timeOfDay?: string | null, timezone?: string | null, aiSummary?: string | null, workspacesHasTodo: Array<{ __typename?: 'Workspace', id: string, name: string }> } | null> | null } };

export type TodosQueryVariables = Exact<{ [key: string]: never; }>;


export type TodosQuery = { __typename?: 'Query', getTodosForUser: { __typename?: 'TodoResponse', success: boolean, message?: string | null, count?: number | null, data?: Array<{ __typename?: 'Todo', id: string, name: string, description?: string | null, priority?: string | null, date?: any | null, completed: boolean, completed_date?: any | null, isRecurring?: boolean | null, recurringFrequency?: string | null, recurringDaily?: boolean | null, recurringDayOfWeek?: string | null, recurringDayOfMonth?: number | null, recurringTime?: string | null, timeOfDay?: string | null, timezone?: string | null, aiSummary?: string | null, workspacesHasTodo: Array<{ __typename?: 'Workspace', id: string, name: string }> } | null> | null } };

export type GetAllTenantsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllTenantsQuery = { __typename?: 'Query', getAllTenants?: { __typename?: 'TenantResponse', success?: boolean | null, message?: string | null, count?: number | null, data?: Array<{ __typename?: 'Tenant', id?: string | null, tenantDomain: string, ogDescription?: string | null, ogImage?: string | null, ogImageHeight?: string | null, ogImageWidth?: string | null, ogSiteName?: string | null, ogTitle?: string | null, ogType?: string | null, stripeSubscriptionId?: string | null, hasTrial?: boolean | null, stripeTrialDays?: number | null, externalSendGridDailyEmailTemplateId?: string | null, externalSendGridFromEmail?: string | null, externalSendGridFromName?: string | null, externalSendGridTwilioServiceSID?: string | null, moderationSexual?: boolean | null, moderationHate?: boolean | null, moderationHarassment?: boolean | null, moderationSelfHarm?: boolean | null, moderationSexualMinors?: boolean | null, moderationHateThreatening?: boolean | null, moderationViolenceGraphic?: boolean | null, moderationSelfHarmIntent?: boolean | null, moderationSelfHarmInstructions?: boolean | null, moderationHarassmentThreatening?: boolean | null, moderationViolence?: boolean | null, companionName?: string | null, key?: string | null, isLMS?: boolean | null, isLTI?: boolean | null, isAxioOffering?: boolean | null, isSuggestedInsights?: boolean | null, axioSchools?: Array<string | null> | null, primaryColor?: string | null, gameMenuBg?: string | null, gameMenuTrack?: string | null, gameMenuProgress?: string | null, gameMenuCardBg?: string | null, emulationStatement?: string | null, learningEmulationStatement?: string | null, logo?: string | null, miniLogo?: string | null, proLogo?: string | null, showMiniLogo?: boolean | null, scope?: Array<string | null> | null, additionalScope?: Array<string | null> | null, termsOfServiceLink?: string | null, generalPrompt?: string | null, onboardingPrompt?: string | null, customNews?: boolean | null, newsSearchTerms?: string | null, showFeedback?: boolean | null, bugReportEmails?: Array<string> | null, upgradeModalBody?: string | null, isFreemium?: boolean | null, hasEmailVerification?: boolean | null, created?: any | null, last_modified?: any | null, hasProFlow?: boolean | null, stripeSecretKey?: string | null, hasDegrees?: boolean | null, hasLearningTopicsInChat?: boolean | null, officialTranscriptsUrl?: string | null, financialInformationUrl?: string | null, helpCenterUrl?: string | null, schoolResourcesUrl?: string | null, reportProblemUrl?: string | null, scheduleAdvisorCallUrl?: string | null, hasTurnBasedAssessments?: boolean | null } | null> | null } | null };

export type GetContentSafetySettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContentSafetySettingsQuery = { __typename?: 'Query', getContentSafetySettings?: { __typename?: 'ContentSafetySettingsResponse', count: number, success: boolean, message?: string | null, data?: Array<{ __typename?: 'ContentSafetySettings', sexual: boolean, hate: boolean, harassment: boolean, selfHarm: boolean, violence: boolean } | null> | null } | null };

export type GetSamlConfigByTenantQueryVariables = Exact<{
  tenantId: Scalars['ID']['input'];
}>;


export type GetSamlConfigByTenantQuery = { __typename?: 'Query', getSamlConfigByTenant?: { __typename?: 'SamlConfigResponse', success?: boolean | null, message?: string | null, data?: { __typename?: 'SamlConfig', id: string, entryPoint: string, issuer: string, cert: string, callbackUrl: string, emailAttribute?: string | null, firstNameAttribute?: string | null, lastNameAttribute?: string | null, signRequest?: boolean | null, signatureAlgorithm?: string | null, tenant: { __typename?: 'Tenant', id?: string | null, tenantDomain: string } } | null } | null };

export type GetTenantQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantQuery = { __typename?: 'Query', getTenant?: { __typename?: 'TenantResponse', success?: boolean | null, message?: string | null, count?: number | null, data?: Array<{ __typename?: 'Tenant', id?: string | null, tenantName: string, tenantDomain: string, ogDescription?: string | null, ogImage?: string | null, ogImageHeight?: string | null, ogImageWidth?: string | null, ogSiteName?: string | null, ogTitle?: string | null, ogType?: string | null, stripeSubscriptionId?: string | null, hasTrial?: boolean | null, stripeTrialDays?: number | null, externalSendGridDailyEmailTemplateId?: string | null, externalSendGridFromEmail?: string | null, externalSendGridFromName?: string | null, externalSendGridTwilioServiceSID?: string | null, moderationSexual?: boolean | null, moderationHate?: boolean | null, moderationHarassment?: boolean | null, moderationSelfHarm?: boolean | null, moderationSexualMinors?: boolean | null, moderationHateThreatening?: boolean | null, moderationViolenceGraphic?: boolean | null, moderationSelfHarmIntent?: boolean | null, moderationSelfHarmInstructions?: boolean | null, moderationHarassmentThreatening?: boolean | null, moderationViolence?: boolean | null, companionName?: string | null, isCompanionMode?: boolean | null, key?: string | null, isLMS?: boolean | null, isLTI?: boolean | null, ltiLaunchUrl?: string | null, isAxioOffering?: boolean | null, isSuggestedInsights?: boolean | null, axioSchools?: Array<string | null> | null, hasCourseEnrollment?: boolean | null, primaryColor?: string | null, gameMenuBg?: string | null, gameMenuTrack?: string | null, gameMenuProgress?: string | null, gameMenuCardBg?: string | null, emulationStatement?: string | null, learningEmulationStatement?: string | null, logo?: string | null, miniLogo?: string | null, proLogo?: string | null, showMiniLogo?: boolean | null, scope?: Array<string | null> | null, additionalScope?: Array<string | null> | null, termsOfServiceLink?: string | null, generalPrompt?: string | null, onboardingPrompt?: string | null, customNews?: boolean | null, newsSearchTerms?: string | null, showFeedback?: boolean | null, bugReportEmails?: Array<string> | null, upgradeModalBody?: string | null, isFreemium?: boolean | null, hasEmailVerification?: boolean | null, hasDegrees?: boolean | null, created?: any | null, last_modified?: any | null, isDailyEventEnabled?: boolean | null, emailFooterColor?: string | null, emailBackgroundColor?: string | null, hasProFlow?: boolean | null, stripeSecretKey?: string | null, allowFormSignup?: boolean | null, autoEnrollCourses?: Array<string | null> | null, hasLearningTopicsInChat?: boolean | null, favicon16Url?: string | null, favicon32Url?: string | null, favicon48Url?: string | null, favicon180Url?: string | null, favicon192Url?: string | null, favicon512Url?: string | null, faviconIcoUrl?: string | null, isTeacherNotifiedOnEnrollment?: boolean | null, officialTranscriptsUrl?: string | null, financialInformationUrl?: string | null, helpCenterUrl?: string | null, schoolResourcesUrl?: string | null, reportProblemUrl?: string | null, scheduleAdvisorCallUrl?: string | null, hasTurnBasedAssessments?: boolean | null, requireSSO?: boolean | null } | null> | null } | null };

export type GetTenantByDomainQueryVariables = Exact<{
  domain: Scalars['String']['input'];
}>;


export type GetTenantByDomainQuery = { __typename?: 'Query', getTenantByDomain?: { __typename?: 'TenantResponse', success?: boolean | null, message?: string | null, count?: number | null, data?: Array<{ __typename?: 'Tenant', id?: string | null, tenantName: string, tenantDomain: string, ogDescription?: string | null, ogImage?: string | null, ogImageHeight?: string | null, ogImageWidth?: string | null, ogSiteName?: string | null, ogTitle?: string | null, ogType?: string | null, stripeSubscriptionId?: string | null, hasTrial?: boolean | null, stripeTrialDays?: number | null, externalSendGridDailyEmailTemplateId?: string | null, externalSendGridFromEmail?: string | null, externalSendGridFromName?: string | null, externalSendGridTwilioServiceSID?: string | null, moderationSexual?: boolean | null, moderationHate?: boolean | null, moderationHarassment?: boolean | null, moderationSelfHarm?: boolean | null, moderationSexualMinors?: boolean | null, moderationHateThreatening?: boolean | null, moderationViolenceGraphic?: boolean | null, moderationSelfHarmIntent?: boolean | null, moderationSelfHarmInstructions?: boolean | null, moderationHarassmentThreatening?: boolean | null, moderationViolence?: boolean | null, companionName?: string | null, key?: string | null, isLMS?: boolean | null, isLTI?: boolean | null, ltiLaunchUrl?: string | null, isAxioOffering?: boolean | null, isSuggestedInsights?: boolean | null, axioSchools?: Array<string | null> | null, hasCourseEnrollment?: boolean | null, primaryColor?: string | null, gameMenuBg?: string | null, gameMenuTrack?: string | null, gameMenuProgress?: string | null, gameMenuCardBg?: string | null, emulationStatement?: string | null, learningEmulationStatement?: string | null, logo?: string | null, miniLogo?: string | null, proLogo?: string | null, showMiniLogo?: boolean | null, scope?: Array<string | null> | null, additionalScope?: Array<string | null> | null, termsOfServiceLink?: string | null, generalPrompt?: string | null, onboardingPrompt?: string | null, customNews?: boolean | null, newsSearchTerms?: string | null, showFeedback?: boolean | null, bugReportEmails?: Array<string> | null, upgradeModalBody?: string | null, isFreemium?: boolean | null, hasEmailVerification?: boolean | null, hasDegrees?: boolean | null, created?: any | null, last_modified?: any | null, isDailyEventEnabled?: boolean | null, emailFooterColor?: string | null, emailBackgroundColor?: string | null, hasProFlow?: boolean | null, stripeSecretKey?: string | null, allowFormSignup?: boolean | null, autoEnrollCourses?: Array<string | null> | null, hasLearningTopicsInChat?: boolean | null, favicon16Url?: string | null, favicon32Url?: string | null, favicon48Url?: string | null, favicon180Url?: string | null, favicon192Url?: string | null, favicon512Url?: string | null, faviconIcoUrl?: string | null, isTeacherNotifiedOnEnrollment?: boolean | null, officialTranscriptsUrl?: string | null, financialInformationUrl?: string | null, helpCenterUrl?: string | null, schoolResourcesUrl?: string | null, reportProblemUrl?: string | null, scheduleAdvisorCallUrl?: string | null, hasTurnBasedAssessments?: boolean | null } | null> | null } | null };

export type GetTenantDefaultsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantDefaultsQuery = { __typename?: 'Query', getTenantDefaults?: { __typename?: 'TenantResponse', success?: boolean | null, message?: string | null, count?: number | null, data?: Array<{ __typename?: 'Tenant', tenantName: string, tenantDomain: string, ogDescription?: string | null, ogImage?: string | null, ogImageHeight?: string | null, ogImageWidth?: string | null, ogSiteName?: string | null, ogTitle?: string | null, ogType?: string | null, stripeSubscriptionId?: string | null, hasTrial?: boolean | null, stripeTrialDays?: number | null, externalSendGridDailyEmailTemplateId?: string | null, externalSendGridFromEmail?: string | null, externalSendGridFromName?: string | null, externalSendGridTwilioServiceSID?: string | null, moderationSexual?: boolean | null, moderationHate?: boolean | null, moderationHarassment?: boolean | null, moderationSelfHarm?: boolean | null, moderationSexualMinors?: boolean | null, moderationHateThreatening?: boolean | null, moderationViolenceGraphic?: boolean | null, moderationSelfHarmIntent?: boolean | null, moderationSelfHarmInstructions?: boolean | null, moderationHarassmentThreatening?: boolean | null, moderationViolence?: boolean | null, companionName?: string | null, isCompanionMode?: boolean | null, key?: string | null, isLMS?: boolean | null, isLTI?: boolean | null, ltiLaunchUrl?: string | null, isAxioOffering?: boolean | null, isSuggestedInsights?: boolean | null, hasCourseEnrollment?: boolean | null, primaryColor?: string | null, gameMenuBg?: string | null, gameMenuTrack?: string | null, gameMenuProgress?: string | null, gameMenuCardBg?: string | null, emulationStatement?: string | null, learningEmulationStatement?: string | null, logo?: string | null, miniLogo?: string | null, proLogo?: string | null, showMiniLogo?: boolean | null, scope?: Array<string | null> | null, additionalScope?: Array<string | null> | null, termsOfServiceLink?: string | null, generalPrompt?: string | null, onboardingPrompt?: string | null, customNews?: boolean | null, newsSearchTerms?: string | null, showFeedback?: boolean | null, bugReportEmails?: Array<string> | null, upgradeModalBody?: string | null, isFreemium?: boolean | null, hasEmailVerification?: boolean | null, hasDegrees?: boolean | null, isDailyEventEnabled?: boolean | null, emailFooterColor?: string | null, emailBackgroundColor?: string | null, hasProFlow?: boolean | null, stripeSecretKey?: string | null, allowFormSignup?: boolean | null, autoEnrollCourses?: Array<string | null> | null, hasLearningTopicsInChat?: boolean | null, favicon16Url?: string | null, favicon32Url?: string | null, favicon48Url?: string | null, favicon180Url?: string | null, favicon192Url?: string | null, favicon512Url?: string | null, faviconIcoUrl?: string | null, isTeacherNotifiedOnEnrollment?: boolean | null, allowStripeDiscountCodes?: boolean | null, doRAG?: boolean | null, officialTranscriptsUrl?: string | null, financialInformationUrl?: string | null, helpCenterUrl?: string | null, schoolResourcesUrl?: string | null, reportProblemUrl?: string | null, scheduleAdvisorCallUrl?: string | null, hasTurnBasedAssessments?: boolean | null } | null> | null } | null };

export type GetTenantForSchoolAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantForSchoolAdminQuery = { __typename?: 'Query', getTenantForSchoolAdmin?: { __typename?: 'TenantResponse', success?: boolean | null, message?: string | null, count?: number | null, data?: Array<{ __typename?: 'Tenant', id?: string | null, tenantName: string, tenantDomain: string, logo?: string | null, primaryColor?: string | null, favicon16Url?: string | null, favicon180Url?: string | null, officialTranscriptsUrl?: string | null, financialInformationUrl?: string | null, helpCenterUrl?: string | null, schoolResourcesUrl?: string | null } | null> | null } | null };

export type GetTenantSchemaQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantSchemaQuery = { __typename?: 'Query', getTenantSchema?: { __typename?: 'TenantSchemaResponse', success?: boolean | null, message?: string | null, data?: string | null } | null };

export type GetTenantSubmitHelpTicketLinkQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantSubmitHelpTicketLinkQuery = { __typename?: 'Query', getTenantSubmitHelpTicketLink?: { __typename?: 'TenantSubmitHelpTicketLinkResponse', success?: boolean | null, message?: string | null, data?: string | null } | null };

export type GetActiveTracksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveTracksQuery = { __typename?: 'Query', getActiveTracks?: Array<{ __typename?: 'ActiveTrack', name?: string | null, description?: string | null, last_modified?: any | null, totalUnits?: number | null, completedUnits?: number | null, parentSubfield?: string | null, parentFields?: Array<string | null> | null, mastery?: number | null, imageUrl?: string | null } | null> | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'MeResponse', audioOn?: boolean | null, countryCode?: string | null, currentWeightLbs?: number | null, dailyEmailOptIn?: boolean | null, enrolledTracks?: Array<string | null> | null, email?: string | null, fullPhoneNumber?: string | null, gender?: string | null, goalWeightLbs?: number | null, googleCalendarAuthToken?: string | null, id: string, isCareerLoading?: boolean | null, isCourseLoading?: boolean | null, isEmailVerified?: boolean | null, isPro?: boolean | null, isOnboarded?: boolean | null, modalOnboarding?: string | null, name?: string | null, otpPreference?: string | null, phoneNumber?: string | null, trialEndDate?: any | null, username?: string | null, meetingLink?: string | null, profilePicture?: string | null, biography?: string | null, isFaculty?: boolean | null, created?: any | null, skipAllNotificationEmail?: boolean | null, showLearningActivityIntro?: boolean | null, enrolledDegrees: Array<{ __typename?: 'Degree', id: string, name: string }> } | null };

export type GetCourseSessionAnalyticsQueryVariables = Exact<{
  input?: InputMaybe<CourseSessionAnalyticsInput>;
}>;


export type GetCourseSessionAnalyticsQuery = { __typename?: 'Query', getCourseSessionAnalytics?: { __typename?: 'CourseSessionAnalyticsResponse', success?: boolean | null, message?: string | null, totalCount?: number | null, data?: Array<{ __typename?: 'CourseSessionAnalyticsData', id?: string | null, name?: string | null, course_code?: string | null, students?: number | null, instructor?: string | null, totalSessions?: number | null, totalDuration?: number | null, averageDuration?: number | null, lastActiveDate?: any | null, firstActiveDate?: any | null } | null> | null, topActiveUsers?: Array<{ __typename?: 'TopActiveUser', id: string, name: string, totalSessions: number }> | null } | null };

export type GetFacultyByNameOrEmailQueryVariables = Exact<{
  searchQuery: Scalars['String']['input'];
  schoolId: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetFacultyByNameOrEmailQuery = { __typename?: 'Query', getFacultyByNameOrEmail?: { __typename?: 'FacultyQueryResponse', success?: boolean | null, message?: string | null, count?: number | null, data?: { __typename?: 'FacultyQueryResponseWithCountData', totalCount?: number | null, faculties: Array<{ __typename?: 'FacultyQueryResponseData', id?: string | null, name?: string | null, email?: string | null, pendingFacultyInvite?: boolean | null, hasRoleRoles: Array<{ __typename?: 'FacultyDataRole', name?: string | null }>, teachingCourses: Array<{ __typename?: 'FacultyDataCourse', id?: string | null, name?: string | null }>, hasSessionDeviceSessions: Array<{ __typename?: 'FacultyDataSessionDeviceSession', id?: string | null }> }> } | null } | null };

export type GetIsInvitationTokenValidQueryVariables = Exact<{
  token: Scalars['String']['input'];
  service: Scalars['String']['input'];
}>;


export type GetIsInvitationTokenValidQuery = { __typename?: 'Query', getIsInvitationTokenValid?: { __typename?: 'ValidityResponse', isValid?: boolean | null } | null };

export type GetUserLearningPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserLearningPreferencesQuery = { __typename?: 'Query', getUserLearningPreferences?: { __typename?: 'UserLearningPreferences', id: string, interests?: Array<string> | null, careerInterests?: Array<string> | null, skillsToImprove?: Array<string> | null, learningStyles?: Array<string> | null, motivations?: Array<string> | null, semesterGoal?: string | null, studyTimePreference?: StudyTime | null, checkInFrequency?: CheckInFrequency | null, assignmentReminders?: boolean | null, textReminders?: boolean | null } | null };

export type GetUserSessionAnalyticsQueryVariables = Exact<{
  input: UserSessionAnalyticsInput;
}>;


export type GetUserSessionAnalyticsQuery = { __typename?: 'Query', getUserSessionAnalytics?: { __typename?: 'UserSessionAnalyticsResponse', success?: boolean | null, message?: string | null, count?: number | null, totalCount?: number | null, totalUsers?: number | null, totalSessions?: number | null, avgSessionLength?: number | null, data?: Array<{ __typename?: 'UserSessionAnalyticsData', id?: string | null, name?: string | null, email?: string | null, totalSessions?: number | null, totalDuration?: number | null, averageDuration?: number | null, lastActiveDate?: any | null, firstActiveDate?: any | null, courses?: Array<{ __typename?: 'AnalyticsCourse', id: string, name: string } | null> | null } | null> | null } | null };

export type GetUserSessionAnalyticsDailyBreakdownQueryVariables = Exact<{
  input: UserSessionAnalyticsDailyBreakdownInput;
}>;


export type GetUserSessionAnalyticsDailyBreakdownQuery = { __typename?: 'Query', getUserSessionAnalyticsDailyBreakdown?: { __typename?: 'UserSessionAnalyticsDailyBreakdownResponse', success?: boolean | null, message?: string | null, data?: Array<{ __typename?: 'DailyBreakdownData', day?: string | null, date?: string | null, sessions?: number | null, hourly?: Array<number | null> | null } | null> | null } | null };

export type GetUsersForSchoolQueryVariables = Exact<{
  searchQuery: Scalars['String']['input'];
  schoolId: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  fetchStudentsOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetUsersForSchoolQuery = { __typename?: 'Query', getUsersForSchool?: { __typename?: 'FacultyQueryResponse', success?: boolean | null, message?: string | null, count?: number | null, data?: { __typename?: 'FacultyQueryResponseWithCountData', totalCount?: number | null, faculties: Array<{ __typename?: 'FacultyQueryResponseData', id?: string | null, name?: string | null, email?: string | null, pendingFacultyInvite?: boolean | null, pendingCourseEnrollmentInvite?: boolean | null, created?: string | null, expiredInvitation?: boolean | null, hasRoleRoles: Array<{ __typename?: 'FacultyDataRole', name?: string | null }>, teachingCourses: Array<{ __typename?: 'FacultyDataCourse', id?: string | null, name?: string | null, course_code?: string | null }>, hasSessionDeviceSessions: Array<{ __typename?: 'FacultyDataSessionDeviceSession', id?: string | null }> }> } | null } | null };

export type GetUsersWithElevatedRolesQueryVariables = Exact<{
  schoolId: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUsersWithElevatedRolesQuery = { __typename?: 'Query', getUsersWithElevatedRoles?: { __typename?: 'FacultyQueryResponse', success?: boolean | null, message?: string | null, count?: number | null, data?: { __typename?: 'FacultyQueryResponseWithCountData', totalCount?: number | null, faculties: Array<{ __typename?: 'FacultyQueryResponseData', id?: string | null, name?: string | null, email?: string | null, pendingFacultyInvite?: boolean | null, expiredInvitation?: boolean | null, hasRoleRoles: Array<{ __typename?: 'FacultyDataRole', name?: string | null }>, teachingCourses: Array<{ __typename?: 'FacultyDataCourse', id?: string | null, name?: string | null, course_code?: string | null }>, hasSessionDeviceSessions: Array<{ __typename?: 'FacultyDataSessionDeviceSession', id?: string | null }> }> } | null } | null };

export type GetPageVisitsBySessionQueryVariables = Exact<{
  sessionId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPageVisitsBySessionQuery = { __typename?: 'Query', getPageVisitsBySession: { __typename?: 'PageVisitListResponse', success?: boolean | null, message?: string | null, count?: number | null, data?: { __typename?: 'PageVisitData', totalCount?: number | null, pageVisits?: Array<{ __typename?: 'PageVisitItem', id: string, path: string, timestamp: any, endTimestamp?: any | null, lastActiveTime?: any | null, visitSessionId: string } | null> | null } | null } };

export type GetVisitSessionsQueryVariables = Exact<{
  input: GetVisitSessionsInput;
}>;


export type GetVisitSessionsQuery = { __typename?: 'Query', getVisitSessions: { __typename?: 'VisitSessionListResponse', success?: boolean | null, message?: string | null, count?: number | null, data?: { __typename?: 'VisitSessionData', totalCount?: number | null, visitSessions?: Array<{ __typename?: 'LimitedVisitSession', id: string, startTime: any, lastActiveTime: any, ended: boolean, userName: string, userId: string, pageVisitsCount: number } | null> | null } | null } };

export type GetSessionAnalyticsCsvQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSessionAnalyticsCsvQuery = { __typename?: 'Query', getSessionAnalyticsCsv: { __typename?: 'ExportCsvResponse', success: boolean, jobId?: string | null, message?: string | null } };

export type GetSessionAnalyticsCsvStatusQueryVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type GetSessionAnalyticsCsvStatusQuery = { __typename?: 'Query', getSessionAnalyticsCsvStatus: { __typename?: 'ExportCsvResponse', success: boolean, downloadUrl?: string | null, message?: string | null, jobId?: string | null } };

export type GetVisualizationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetVisualizationQuery = { __typename?: 'Query', getVisualization?: { __typename?: 'VisualizationResponse', count?: number | null, message?: string | null, success?: boolean | null, data?: Array<{ __typename?: 'FormattedVisualization', code?: string | null, created?: any | null, id: string, lastModified?: any | null, visualizationType?: string | null, visualizationDescription?: string | null, status: VisualizationStatus } | null> | null } | null };

export type GetUserWorkspacesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserWorkspacesQuery = { __typename?: 'Query', getUserWorkspaces: Array<{ __typename?: 'UserWorkspace', id: string, name: string }> };

export type CompanionLlmStreamSubscriptionVariables = Exact<{
  question: Scalars['String']['input'];
  chatId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  attachment?: InputMaybe<AttachmentInput>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['String']['input']>;
}>;


export type CompanionLlmStreamSubscription = { __typename?: 'Subscription', companionLlmStream: { __typename: 'LLMStreamArtifactCreatedEvent', type: string, chatId: string, timestamp: string, artifact: any } | { __typename: 'LLMStreamAudioSegmentEndEvent' } | { __typename: 'LLMStreamAudioSegmentStartEvent' } | { __typename: 'LLMStreamAudioSegmentTextEvent' } | { __typename: 'LLMStreamChatRenamedEvent', type: string, chatId: string, timestamp: string, name: string } | { __typename: 'LLMStreamErrorEvent', type: string, chatId: string, timestamp: string, code: string, errorMessage: string } | { __typename: 'LLMStreamMessageCompletedEvent', type: string, chatId: string, timestamp: string, message: { __typename?: 'LLMStreamMessage', id: string, chatId: string, role: MessageRole, createdAt: string, metadata?: any | null, blocks: Array<{ __typename: 'LLMStreamArtifactBlock', artifactId: string, artifactType: string } | { __typename: 'LLMStreamFileBlock', fileId: string, purpose: string, displayName?: string | null } | { __typename: 'LLMStreamTextBlock', text: string }> } } | { __typename: 'LLMStreamMessageDeltaEvent', type: string, chatId: string, timestamp: string, messageId: string, isFinalChunk?: boolean | null, delta: { __typename: 'LLMStreamArtifactBlock', artifactId: string, artifactType: string } | { __typename: 'LLMStreamFileBlock', fileId: string, purpose: string, displayName?: string | null } | { __typename: 'LLMStreamTextBlock', text: string } } };

export type LearningLlmStreamSubscriptionVariables = Exact<{
  question: Scalars['String']['input'];
  chatId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  attachment?: InputMaybe<AttachmentInput>;
  contentNodeId?: InputMaybe<Scalars['String']['input']>;
  enableTts?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type LearningLlmStreamSubscription = { __typename?: 'Subscription', learningLlmStream: { __typename: 'LLMStreamArtifactCreatedEvent', type: string, chatId: string, timestamp: string, artifact: any } | { __typename: 'LLMStreamAudioSegmentEndEvent', type: string, chatId: string, timestamp: string, messageId: string, chunkIndex: number } | { __typename: 'LLMStreamAudioSegmentStartEvent', type: string, chatId: string, timestamp: string, messageId: string, chunkIndex: number } | { __typename: 'LLMStreamAudioSegmentTextEvent', type: string, chatId: string, timestamp: string, messageId: string, chunkIndex: number, text: string } | { __typename: 'LLMStreamChatRenamedEvent', type: string, chatId: string, timestamp: string, name: string } | { __typename: 'LLMStreamErrorEvent', type: string, chatId: string, timestamp: string, code: string, errorMessage: string } | { __typename: 'LLMStreamMessageCompletedEvent', type: string, chatId: string, timestamp: string, message: { __typename?: 'LLMStreamMessage', id: string, chatId: string, role: MessageRole, createdAt: string, metadata?: any | null, blocks: Array<{ __typename: 'LLMStreamArtifactBlock', artifactId: string, artifactType: string } | { __typename: 'LLMStreamFileBlock', fileId: string, purpose: string, displayName?: string | null } | { __typename: 'LLMStreamTextBlock', text: string }> } } | { __typename: 'LLMStreamMessageDeltaEvent', type: string, chatId: string, timestamp: string, messageId: string, isFinalChunk?: boolean | null, delta: { __typename: 'LLMStreamArtifactBlock', artifactId: string, artifactType: string } | { __typename: 'LLMStreamFileBlock', fileId: string, purpose: string, displayName?: string | null } | { __typename: 'LLMStreamTextBlock', text: string } } };

export type OnNotificationCreatedSubscriptionVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type OnNotificationCreatedSubscription = { __typename?: 'Subscription', onNotificationCreated?: { __typename?: 'NotificationLiveUpdate', id: string, userId: string, title: string, message: string, created: string, isRead: boolean, actionUrl?: string | null, type?: NotificationType | null } | null };


export const LoginDocument = gql`
    mutation Login($email: String!, $password: String!) {
  login(email: $email, password: $password) {
    accessToken
    refreshToken
    user {
      id
      email
      isOnboarded
      isPro
      name
      googleAuthTokens {
        access_token
        refresh_token
        scope
        token_type
        expiry_date
      }
      isEmailVerified
      otpPreference
      countryCode
      phoneNumber
      fullPhoneNumber
    }
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout {
    message
    success
  }
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const RefreshTokenDocument = gql`
    mutation RefreshToken($refreshToken: String!) {
  refreshToken(refreshToken: $refreshToken) {
    accessToken
    refreshToken
  }
}
    `;
export type RefreshTokenMutationFn = Apollo.MutationFunction<RefreshTokenMutation, RefreshTokenMutationVariables>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument, options);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($newPassword: String!, $token: String!) {
  resetPassword(newPassword: $newPassword, token: $token) {
    message
    success
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const SignupDocument = gql`
    mutation Signup($email: String!, $name: String!, $password: String!, $gender: String, $birthday: String!, $dailyEmailOptIn: Boolean!, $language: String!, $timezone: String!) {
  signup(
    email: $email
    name: $name
    password: $password
    gender: $gender
    birthday: $birthday
    dailyEmailOptIn: $dailyEmailOptIn
    language: $language
    timezone: $timezone
  ) {
    accessToken
    refreshToken
    user {
      id
      email
      name
      isPro
      isOnboarded
      otpPreference
      isEmailVerified
      fullPhoneNumber
      preferences {
        language
      }
    }
  }
}
    `;
export type SignupMutationFn = Apollo.MutationFunction<SignupMutation, SignupMutationVariables>;

/**
 * __useSignupMutation__
 *
 * To run a mutation, you first call `useSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupMutation, { data, loading, error }] = useSignupMutation({
 *   variables: {
 *      email: // value for 'email'
 *      name: // value for 'name'
 *      password: // value for 'password'
 *      gender: // value for 'gender'
 *      birthday: // value for 'birthday'
 *      dailyEmailOptIn: // value for 'dailyEmailOptIn'
 *      language: // value for 'language'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useSignupMutation(baseOptions?: Apollo.MutationHookOptions<SignupMutation, SignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignupMutation, SignupMutationVariables>(SignupDocument, options);
      }
export type SignupMutationHookResult = ReturnType<typeof useSignupMutation>;
export type SignupMutationResult = Apollo.MutationResult<SignupMutation>;
export type SignupMutationOptions = Apollo.BaseMutationOptions<SignupMutation, SignupMutationVariables>;
export const LoginSuperAdminDocument = gql`
    mutation LoginSuperAdmin($email: String!, $password: String!) {
  loginSuperAdmin(email: $email, password: $password) {
    accessToken
    refreshToken
    user {
      id
      email
      isOnboarded
      isPro
      name
      googleAuthTokens {
        access_token
        refresh_token
        scope
        token_type
        expiry_date
      }
      isEmailVerified
      otpPreference
      countryCode
      phoneNumber
      fullPhoneNumber
    }
  }
}
    `;
export type LoginSuperAdminMutationFn = Apollo.MutationFunction<LoginSuperAdminMutation, LoginSuperAdminMutationVariables>;

/**
 * __useLoginSuperAdminMutation__
 *
 * To run a mutation, you first call `useLoginSuperAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginSuperAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginSuperAdminMutation, { data, loading, error }] = useLoginSuperAdminMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginSuperAdminMutation(baseOptions?: Apollo.MutationHookOptions<LoginSuperAdminMutation, LoginSuperAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginSuperAdminMutation, LoginSuperAdminMutationVariables>(LoginSuperAdminDocument, options);
      }
export type LoginSuperAdminMutationHookResult = ReturnType<typeof useLoginSuperAdminMutation>;
export type LoginSuperAdminMutationResult = Apollo.MutationResult<LoginSuperAdminMutation>;
export type LoginSuperAdminMutationOptions = Apollo.BaseMutationOptions<LoginSuperAdminMutation, LoginSuperAdminMutationVariables>;
export const CareerIsLoadingDocument = gql`
    mutation careerIsLoading($isLoading: Boolean!) {
  careerIsLoading(isLoading: $isLoading) {
    isCareerLoading
  }
}
    `;
export type CareerIsLoadingMutationFn = Apollo.MutationFunction<CareerIsLoadingMutation, CareerIsLoadingMutationVariables>;

/**
 * __useCareerIsLoadingMutation__
 *
 * To run a mutation, you first call `useCareerIsLoadingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCareerIsLoadingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [careerIsLoadingMutation, { data, loading, error }] = useCareerIsLoadingMutation({
 *   variables: {
 *      isLoading: // value for 'isLoading'
 *   },
 * });
 */
export function useCareerIsLoadingMutation(baseOptions?: Apollo.MutationHookOptions<CareerIsLoadingMutation, CareerIsLoadingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CareerIsLoadingMutation, CareerIsLoadingMutationVariables>(CareerIsLoadingDocument, options);
      }
export type CareerIsLoadingMutationHookResult = ReturnType<typeof useCareerIsLoadingMutation>;
export type CareerIsLoadingMutationResult = Apollo.MutationResult<CareerIsLoadingMutation>;
export type CareerIsLoadingMutationOptions = Apollo.BaseMutationOptions<CareerIsLoadingMutation, CareerIsLoadingMutationVariables>;
export const CareerSubmitFormDocument = gql`
    mutation CareerSubmitForm($currentOccupation: String!, $careerPathName: String!, $careerGoal: String!) {
  careerSubmitForm(
    currentOccupation: $currentOccupation
    careerPathName: $careerPathName
    careerGoal: $careerGoal
  )
}
    `;
export type CareerSubmitFormMutationFn = Apollo.MutationFunction<CareerSubmitFormMutation, CareerSubmitFormMutationVariables>;

/**
 * __useCareerSubmitFormMutation__
 *
 * To run a mutation, you first call `useCareerSubmitFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCareerSubmitFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [careerSubmitFormMutation, { data, loading, error }] = useCareerSubmitFormMutation({
 *   variables: {
 *      currentOccupation: // value for 'currentOccupation'
 *      careerPathName: // value for 'careerPathName'
 *      careerGoal: // value for 'careerGoal'
 *   },
 * });
 */
export function useCareerSubmitFormMutation(baseOptions?: Apollo.MutationHookOptions<CareerSubmitFormMutation, CareerSubmitFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CareerSubmitFormMutation, CareerSubmitFormMutationVariables>(CareerSubmitFormDocument, options);
      }
export type CareerSubmitFormMutationHookResult = ReturnType<typeof useCareerSubmitFormMutation>;
export type CareerSubmitFormMutationResult = Apollo.MutationResult<CareerSubmitFormMutation>;
export type CareerSubmitFormMutationOptions = Apollo.BaseMutationOptions<CareerSubmitFormMutation, CareerSubmitFormMutationVariables>;
export const GenerateSuggestedCareersDocument = gql`
    mutation generateSuggestedCareers {
  generateSuggestedCareers {
    name
    id
  }
}
    `;
export type GenerateSuggestedCareersMutationFn = Apollo.MutationFunction<GenerateSuggestedCareersMutation, GenerateSuggestedCareersMutationVariables>;

/**
 * __useGenerateSuggestedCareersMutation__
 *
 * To run a mutation, you first call `useGenerateSuggestedCareersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSuggestedCareersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSuggestedCareersMutation, { data, loading, error }] = useGenerateSuggestedCareersMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerateSuggestedCareersMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSuggestedCareersMutation, GenerateSuggestedCareersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSuggestedCareersMutation, GenerateSuggestedCareersMutationVariables>(GenerateSuggestedCareersDocument, options);
      }
export type GenerateSuggestedCareersMutationHookResult = ReturnType<typeof useGenerateSuggestedCareersMutation>;
export type GenerateSuggestedCareersMutationResult = Apollo.MutationResult<GenerateSuggestedCareersMutation>;
export type GenerateSuggestedCareersMutationOptions = Apollo.BaseMutationOptions<GenerateSuggestedCareersMutation, GenerateSuggestedCareersMutationVariables>;
export const SetCareerPathActiveDocument = gql`
    mutation SetCareerPathActive($careerId: ID) {
  setCareerPathActive(careerId: $careerId)
}
    `;
export type SetCareerPathActiveMutationFn = Apollo.MutationFunction<SetCareerPathActiveMutation, SetCareerPathActiveMutationVariables>;

/**
 * __useSetCareerPathActiveMutation__
 *
 * To run a mutation, you first call `useSetCareerPathActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCareerPathActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCareerPathActiveMutation, { data, loading, error }] = useSetCareerPathActiveMutation({
 *   variables: {
 *      careerId: // value for 'careerId'
 *   },
 * });
 */
export function useSetCareerPathActiveMutation(baseOptions?: Apollo.MutationHookOptions<SetCareerPathActiveMutation, SetCareerPathActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCareerPathActiveMutation, SetCareerPathActiveMutationVariables>(SetCareerPathActiveDocument, options);
      }
export type SetCareerPathActiveMutationHookResult = ReturnType<typeof useSetCareerPathActiveMutation>;
export type SetCareerPathActiveMutationResult = Apollo.MutationResult<SetCareerPathActiveMutation>;
export type SetCareerPathActiveMutationOptions = Apollo.BaseMutationOptions<SetCareerPathActiveMutation, SetCareerPathActiveMutationVariables>;
export const DeleteAspectDocument = gql`
    mutation DeleteAspect($nodeId: ID!) {
  deleteAspect(nodeId: $nodeId) {
    message
    success
  }
}
    `;
export type DeleteAspectMutationFn = Apollo.MutationFunction<DeleteAspectMutation, DeleteAspectMutationVariables>;

/**
 * __useDeleteAspectMutation__
 *
 * To run a mutation, you first call `useDeleteAspectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAspectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAspectMutation, { data, loading, error }] = useDeleteAspectMutation({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useDeleteAspectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAspectMutation, DeleteAspectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAspectMutation, DeleteAspectMutationVariables>(DeleteAspectDocument, options);
      }
export type DeleteAspectMutationHookResult = ReturnType<typeof useDeleteAspectMutation>;
export type DeleteAspectMutationResult = Apollo.MutationResult<DeleteAspectMutation>;
export type DeleteAspectMutationOptions = Apollo.BaseMutationOptions<DeleteAspectMutation, DeleteAspectMutationVariables>;
export const DeleteCompanionChatDocument = gql`
    mutation DeleteCompanionChat($id: ID!) {
  deleteCompanionChat(id: $id) {
    success
    message
  }
}
    `;
export type DeleteCompanionChatMutationFn = Apollo.MutationFunction<DeleteCompanionChatMutation, DeleteCompanionChatMutationVariables>;

/**
 * __useDeleteCompanionChatMutation__
 *
 * To run a mutation, you first call `useDeleteCompanionChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanionChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanionChatMutation, { data, loading, error }] = useDeleteCompanionChatMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCompanionChatMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanionChatMutation, DeleteCompanionChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanionChatMutation, DeleteCompanionChatMutationVariables>(DeleteCompanionChatDocument, options);
      }
export type DeleteCompanionChatMutationHookResult = ReturnType<typeof useDeleteCompanionChatMutation>;
export type DeleteCompanionChatMutationResult = Apollo.MutationResult<DeleteCompanionChatMutation>;
export type DeleteCompanionChatMutationOptions = Apollo.BaseMutationOptions<DeleteCompanionChatMutation, DeleteCompanionChatMutationVariables>;
export const DeleteMessageDocument = gql`
    mutation DeleteMessage($id: String!) {
  deleteMessage(id: $id) {
    id
  }
}
    `;
export type DeleteMessageMutationFn = Apollo.MutationFunction<DeleteMessageMutation, DeleteMessageMutationVariables>;

/**
 * __useDeleteMessageMutation__
 *
 * To run a mutation, you first call `useDeleteMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMessageMutation, { data, loading, error }] = useDeleteMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMessageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMessageMutation, DeleteMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMessageMutation, DeleteMessageMutationVariables>(DeleteMessageDocument, options);
      }
export type DeleteMessageMutationHookResult = ReturnType<typeof useDeleteMessageMutation>;
export type DeleteMessageMutationResult = Apollo.MutationResult<DeleteMessageMutation>;
export type DeleteMessageMutationOptions = Apollo.BaseMutationOptions<DeleteMessageMutation, DeleteMessageMutationVariables>;
export const ProcessAttachmentDocument = gql`
    mutation ProcessAttachment($fileId: String!) {
  processAttachment(fileId: $fileId) {
    message
    count
    success
  }
}
    `;
export type ProcessAttachmentMutationFn = Apollo.MutationFunction<ProcessAttachmentMutation, ProcessAttachmentMutationVariables>;

/**
 * __useProcessAttachmentMutation__
 *
 * To run a mutation, you first call `useProcessAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processAttachmentMutation, { data, loading, error }] = useProcessAttachmentMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useProcessAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<ProcessAttachmentMutation, ProcessAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessAttachmentMutation, ProcessAttachmentMutationVariables>(ProcessAttachmentDocument, options);
      }
export type ProcessAttachmentMutationHookResult = ReturnType<typeof useProcessAttachmentMutation>;
export type ProcessAttachmentMutationResult = Apollo.MutationResult<ProcessAttachmentMutation>;
export type ProcessAttachmentMutationOptions = Apollo.BaseMutationOptions<ProcessAttachmentMutation, ProcessAttachmentMutationVariables>;
export const ProcessCompanionChatAttachmentDocument = gql`
    mutation ProcessCompanionChatAttachment($fileId: String!) {
  processCompanionChatAttachment(fileId: $fileId) {
    success
    message
    data {
      fileId
      fileName
      documentId
    }
  }
}
    `;
export type ProcessCompanionChatAttachmentMutationFn = Apollo.MutationFunction<ProcessCompanionChatAttachmentMutation, ProcessCompanionChatAttachmentMutationVariables>;

/**
 * __useProcessCompanionChatAttachmentMutation__
 *
 * To run a mutation, you first call `useProcessCompanionChatAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessCompanionChatAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processCompanionChatAttachmentMutation, { data, loading, error }] = useProcessCompanionChatAttachmentMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useProcessCompanionChatAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<ProcessCompanionChatAttachmentMutation, ProcessCompanionChatAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessCompanionChatAttachmentMutation, ProcessCompanionChatAttachmentMutationVariables>(ProcessCompanionChatAttachmentDocument, options);
      }
export type ProcessCompanionChatAttachmentMutationHookResult = ReturnType<typeof useProcessCompanionChatAttachmentMutation>;
export type ProcessCompanionChatAttachmentMutationResult = Apollo.MutationResult<ProcessCompanionChatAttachmentMutation>;
export type ProcessCompanionChatAttachmentMutationOptions = Apollo.BaseMutationOptions<ProcessCompanionChatAttachmentMutation, ProcessCompanionChatAttachmentMutationVariables>;
export const UpdateCompanionChatDocument = gql`
    mutation UpdateCompanionChat($id: ID!, $name: String!) {
  updateCompanionChat(id: $id, name: $name) {
    success
    message
  }
}
    `;
export type UpdateCompanionChatMutationFn = Apollo.MutationFunction<UpdateCompanionChatMutation, UpdateCompanionChatMutationVariables>;

/**
 * __useUpdateCompanionChatMutation__
 *
 * To run a mutation, you first call `useUpdateCompanionChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanionChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanionChatMutation, { data, loading, error }] = useUpdateCompanionChatMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateCompanionChatMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanionChatMutation, UpdateCompanionChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanionChatMutation, UpdateCompanionChatMutationVariables>(UpdateCompanionChatDocument, options);
      }
export type UpdateCompanionChatMutationHookResult = ReturnType<typeof useUpdateCompanionChatMutation>;
export type UpdateCompanionChatMutationResult = Apollo.MutationResult<UpdateCompanionChatMutation>;
export type UpdateCompanionChatMutationOptions = Apollo.BaseMutationOptions<UpdateCompanionChatMutation, UpdateCompanionChatMutationVariables>;
export const AddAssignmentDocument = gql`
    mutation AddAssignment($courseId: ID!, $moduleName: String!, $newAssignmentName: String!, $updatedHtml: String!) {
  addAssignment(
    courseId: $courseId
    moduleName: $moduleName
    newAssignmentName: $newAssignmentName
    updatedHtml: $updatedHtml
  ) {
    success
    message
  }
}
    `;
export type AddAssignmentMutationFn = Apollo.MutationFunction<AddAssignmentMutation, AddAssignmentMutationVariables>;

/**
 * __useAddAssignmentMutation__
 *
 * To run a mutation, you first call `useAddAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAssignmentMutation, { data, loading, error }] = useAddAssignmentMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      moduleName: // value for 'moduleName'
 *      newAssignmentName: // value for 'newAssignmentName'
 *      updatedHtml: // value for 'updatedHtml'
 *   },
 * });
 */
export function useAddAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<AddAssignmentMutation, AddAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAssignmentMutation, AddAssignmentMutationVariables>(AddAssignmentDocument, options);
      }
export type AddAssignmentMutationHookResult = ReturnType<typeof useAddAssignmentMutation>;
export type AddAssignmentMutationResult = Apollo.MutationResult<AddAssignmentMutation>;
export type AddAssignmentMutationOptions = Apollo.BaseMutationOptions<AddAssignmentMutation, AddAssignmentMutationVariables>;
export const AddContentModuleDocument = gql`
    mutation AddContentModule($courseId: ID!, $moduleName: String!) {
  addContentModule(courseId: $courseId, moduleName: $moduleName) {
    success
    message
  }
}
    `;
export type AddContentModuleMutationFn = Apollo.MutationFunction<AddContentModuleMutation, AddContentModuleMutationVariables>;

/**
 * __useAddContentModuleMutation__
 *
 * To run a mutation, you first call `useAddContentModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContentModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContentModuleMutation, { data, loading, error }] = useAddContentModuleMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      moduleName: // value for 'moduleName'
 *   },
 * });
 */
export function useAddContentModuleMutation(baseOptions?: Apollo.MutationHookOptions<AddContentModuleMutation, AddContentModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddContentModuleMutation, AddContentModuleMutationVariables>(AddContentModuleDocument, options);
      }
export type AddContentModuleMutationHookResult = ReturnType<typeof useAddContentModuleMutation>;
export type AddContentModuleMutationResult = Apollo.MutationResult<AddContentModuleMutation>;
export type AddContentModuleMutationOptions = Apollo.BaseMutationOptions<AddContentModuleMutation, AddContentModuleMutationVariables>;
export const CourseCreationDocument = gql`
    mutation CourseCreation($title: String!, $standard: String!, $weeks: Int!, $objectives: [String!]!, $urls: [String!]!) {
  courseCreation(
    title: $title
    standard: $standard
    weeks: $weeks
    objectives: $objectives
    urls: $urls
  ) {
    success
    message
    data {
      name
      standard
      weeks
      objectives
      modules {
        module_name
        assignments {
          assignment_name
          html
        }
      }
      created
      last_modified
    }
  }
}
    `;
export type CourseCreationMutationFn = Apollo.MutationFunction<CourseCreationMutation, CourseCreationMutationVariables>;

/**
 * __useCourseCreationMutation__
 *
 * To run a mutation, you first call `useCourseCreationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseCreationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseCreationMutation, { data, loading, error }] = useCourseCreationMutation({
 *   variables: {
 *      title: // value for 'title'
 *      standard: // value for 'standard'
 *      weeks: // value for 'weeks'
 *      objectives: // value for 'objectives'
 *      urls: // value for 'urls'
 *   },
 * });
 */
export function useCourseCreationMutation(baseOptions?: Apollo.MutationHookOptions<CourseCreationMutation, CourseCreationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseCreationMutation, CourseCreationMutationVariables>(CourseCreationDocument, options);
      }
export type CourseCreationMutationHookResult = ReturnType<typeof useCourseCreationMutation>;
export type CourseCreationMutationResult = Apollo.MutationResult<CourseCreationMutation>;
export type CourseCreationMutationOptions = Apollo.BaseMutationOptions<CourseCreationMutation, CourseCreationMutationVariables>;
export const CourseIsLoadingDocument = gql`
    mutation courseIsLoading($isLoading: Boolean!) {
  courseIsLoading(isLoading: $isLoading) {
    isCourseLoading
  }
}
    `;
export type CourseIsLoadingMutationFn = Apollo.MutationFunction<CourseIsLoadingMutation, CourseIsLoadingMutationVariables>;

/**
 * __useCourseIsLoadingMutation__
 *
 * To run a mutation, you first call `useCourseIsLoadingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseIsLoadingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseIsLoadingMutation, { data, loading, error }] = useCourseIsLoadingMutation({
 *   variables: {
 *      isLoading: // value for 'isLoading'
 *   },
 * });
 */
export function useCourseIsLoadingMutation(baseOptions?: Apollo.MutationHookOptions<CourseIsLoadingMutation, CourseIsLoadingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CourseIsLoadingMutation, CourseIsLoadingMutationVariables>(CourseIsLoadingDocument, options);
      }
export type CourseIsLoadingMutationHookResult = ReturnType<typeof useCourseIsLoadingMutation>;
export type CourseIsLoadingMutationResult = Apollo.MutationResult<CourseIsLoadingMutation>;
export type CourseIsLoadingMutationOptions = Apollo.BaseMutationOptions<CourseIsLoadingMutation, CourseIsLoadingMutationVariables>;
export const DeleteContentAssignmentDocument = gql`
    mutation DeleteContentAssignment($courseId: ID!, $moduleName: String!, $assignmentName: String!) {
  deleteContentAssignment(
    courseId: $courseId
    moduleName: $moduleName
    assignmentName: $assignmentName
  ) {
    success
    message
  }
}
    `;
export type DeleteContentAssignmentMutationFn = Apollo.MutationFunction<DeleteContentAssignmentMutation, DeleteContentAssignmentMutationVariables>;

/**
 * __useDeleteContentAssignmentMutation__
 *
 * To run a mutation, you first call `useDeleteContentAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentAssignmentMutation, { data, loading, error }] = useDeleteContentAssignmentMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      moduleName: // value for 'moduleName'
 *      assignmentName: // value for 'assignmentName'
 *   },
 * });
 */
export function useDeleteContentAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContentAssignmentMutation, DeleteContentAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContentAssignmentMutation, DeleteContentAssignmentMutationVariables>(DeleteContentAssignmentDocument, options);
      }
export type DeleteContentAssignmentMutationHookResult = ReturnType<typeof useDeleteContentAssignmentMutation>;
export type DeleteContentAssignmentMutationResult = Apollo.MutationResult<DeleteContentAssignmentMutation>;
export type DeleteContentAssignmentMutationOptions = Apollo.BaseMutationOptions<DeleteContentAssignmentMutation, DeleteContentAssignmentMutationVariables>;
export const DeleteContentModuleDocument = gql`
    mutation DeleteContentModule($courseId: ID!, $moduleName: String!) {
  deleteContentModule(courseId: $courseId, moduleName: $moduleName) {
    success
    message
  }
}
    `;
export type DeleteContentModuleMutationFn = Apollo.MutationFunction<DeleteContentModuleMutation, DeleteContentModuleMutationVariables>;

/**
 * __useDeleteContentModuleMutation__
 *
 * To run a mutation, you first call `useDeleteContentModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentModuleMutation, { data, loading, error }] = useDeleteContentModuleMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      moduleName: // value for 'moduleName'
 *   },
 * });
 */
export function useDeleteContentModuleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContentModuleMutation, DeleteContentModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContentModuleMutation, DeleteContentModuleMutationVariables>(DeleteContentModuleDocument, options);
      }
export type DeleteContentModuleMutationHookResult = ReturnType<typeof useDeleteContentModuleMutation>;
export type DeleteContentModuleMutationResult = Apollo.MutationResult<DeleteContentModuleMutation>;
export type DeleteContentModuleMutationOptions = Apollo.BaseMutationOptions<DeleteContentModuleMutation, DeleteContentModuleMutationVariables>;
export const UpdateAssignmentDocument = gql`
    mutation UpdateAssignment($courseId: ID!, $moduleName: String!, $currentAssignmentName: String!, $newAssignmentName: String!, $updatedHtml: String!) {
  updateAssignment(
    courseId: $courseId
    moduleName: $moduleName
    currentAssignmentName: $currentAssignmentName
    newAssignmentName: $newAssignmentName
    updatedHtml: $updatedHtml
  ) {
    success
    message
    data {
      assignment_name
      html
    }
  }
}
    `;
export type UpdateAssignmentMutationFn = Apollo.MutationFunction<UpdateAssignmentMutation, UpdateAssignmentMutationVariables>;

/**
 * __useUpdateAssignmentMutation__
 *
 * To run a mutation, you first call `useUpdateAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssignmentMutation, { data, loading, error }] = useUpdateAssignmentMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      moduleName: // value for 'moduleName'
 *      currentAssignmentName: // value for 'currentAssignmentName'
 *      newAssignmentName: // value for 'newAssignmentName'
 *      updatedHtml: // value for 'updatedHtml'
 *   },
 * });
 */
export function useUpdateAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssignmentMutation, UpdateAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssignmentMutation, UpdateAssignmentMutationVariables>(UpdateAssignmentDocument, options);
      }
export type UpdateAssignmentMutationHookResult = ReturnType<typeof useUpdateAssignmentMutation>;
export type UpdateAssignmentMutationResult = Apollo.MutationResult<UpdateAssignmentMutation>;
export type UpdateAssignmentMutationOptions = Apollo.BaseMutationOptions<UpdateAssignmentMutation, UpdateAssignmentMutationVariables>;
export const UpdateContentModuleNameDocument = gql`
    mutation UpdateContentModuleName($courseId: ID!, $oldModuleName: String!, $newModuleName: String!) {
  updateContentModuleName(
    courseId: $courseId
    oldModuleName: $oldModuleName
    newModuleName: $newModuleName
  ) {
    success
    message
  }
}
    `;
export type UpdateContentModuleNameMutationFn = Apollo.MutationFunction<UpdateContentModuleNameMutation, UpdateContentModuleNameMutationVariables>;

/**
 * __useUpdateContentModuleNameMutation__
 *
 * To run a mutation, you first call `useUpdateContentModuleNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentModuleNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentModuleNameMutation, { data, loading, error }] = useUpdateContentModuleNameMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      oldModuleName: // value for 'oldModuleName'
 *      newModuleName: // value for 'newModuleName'
 *   },
 * });
 */
export function useUpdateContentModuleNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentModuleNameMutation, UpdateContentModuleNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentModuleNameMutation, UpdateContentModuleNameMutationVariables>(UpdateContentModuleNameDocument, options);
      }
export type UpdateContentModuleNameMutationHookResult = ReturnType<typeof useUpdateContentModuleNameMutation>;
export type UpdateContentModuleNameMutationResult = Apollo.MutationResult<UpdateContentModuleNameMutation>;
export type UpdateContentModuleNameMutationOptions = Apollo.BaseMutationOptions<UpdateContentModuleNameMutation, UpdateContentModuleNameMutationVariables>;
export const EvaluateCourseDocument = gql`
    mutation EvaluateCourse($courseId: ID!) {
  evaluateCourse(courseId: $courseId) {
    success
    message
    jobId
  }
}
    `;
export type EvaluateCourseMutationFn = Apollo.MutationFunction<EvaluateCourseMutation, EvaluateCourseMutationVariables>;

/**
 * __useEvaluateCourseMutation__
 *
 * To run a mutation, you first call `useEvaluateCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEvaluateCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [evaluateCourseMutation, { data, loading, error }] = useEvaluateCourseMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useEvaluateCourseMutation(baseOptions?: Apollo.MutationHookOptions<EvaluateCourseMutation, EvaluateCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EvaluateCourseMutation, EvaluateCourseMutationVariables>(EvaluateCourseDocument, options);
      }
export type EvaluateCourseMutationHookResult = ReturnType<typeof useEvaluateCourseMutation>;
export type EvaluateCourseMutationResult = Apollo.MutationResult<EvaluateCourseMutation>;
export type EvaluateCourseMutationOptions = Apollo.BaseMutationOptions<EvaluateCourseMutation, EvaluateCourseMutationVariables>;
export const MakeCoursePaymentDocument = gql`
    mutation MakeCoursePayment($courseId: String!) {
  createCheckoutSession(courseId: $courseId) {
    success
    message
    url
  }
}
    `;
export type MakeCoursePaymentMutationFn = Apollo.MutationFunction<MakeCoursePaymentMutation, MakeCoursePaymentMutationVariables>;

/**
 * __useMakeCoursePaymentMutation__
 *
 * To run a mutation, you first call `useMakeCoursePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeCoursePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeCoursePaymentMutation, { data, loading, error }] = useMakeCoursePaymentMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useMakeCoursePaymentMutation(baseOptions?: Apollo.MutationHookOptions<MakeCoursePaymentMutation, MakeCoursePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeCoursePaymentMutation, MakeCoursePaymentMutationVariables>(MakeCoursePaymentDocument, options);
      }
export type MakeCoursePaymentMutationHookResult = ReturnType<typeof useMakeCoursePaymentMutation>;
export type MakeCoursePaymentMutationResult = Apollo.MutationResult<MakeCoursePaymentMutation>;
export type MakeCoursePaymentMutationOptions = Apollo.BaseMutationOptions<MakeCoursePaymentMutation, MakeCoursePaymentMutationVariables>;
export const CreateAiTutorDocument = gql`
    mutation CreateAITutor($title: String!, $description: String!, $parentModuleId: ID!, $objectives: [ObjectiveInput!]!, $context: String, $visualizationId: ID, $videoPool: [VideoDataInput], $targetAudience: String, $dueDate: DateTime, $activityState: ActivityState, $scheduledDate: DateTime) {
  createAITutor(
    aiTutor: {title: $title, description: $description, parentModuleId: $parentModuleId, objectives: $objectives, context: $context, visualizationId: $visualizationId, videoPool: $videoPool, targetAudience: $targetAudience, dueDate: $dueDate, activityState: $activityState, scheduledDate: $scheduledDate}
  ) {
    success
    message
    data {
      title
      description
      targetAudience
      dueDate
      objectives {
        objective
        sequence
      }
      activityState
      scheduledDate
    }
  }
}
    `;
export type CreateAiTutorMutationFn = Apollo.MutationFunction<CreateAiTutorMutation, CreateAiTutorMutationVariables>;

/**
 * __useCreateAiTutorMutation__
 *
 * To run a mutation, you first call `useCreateAiTutorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAiTutorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAiTutorMutation, { data, loading, error }] = useCreateAiTutorMutation({
 *   variables: {
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      parentModuleId: // value for 'parentModuleId'
 *      objectives: // value for 'objectives'
 *      context: // value for 'context'
 *      visualizationId: // value for 'visualizationId'
 *      videoPool: // value for 'videoPool'
 *      targetAudience: // value for 'targetAudience'
 *      dueDate: // value for 'dueDate'
 *      activityState: // value for 'activityState'
 *      scheduledDate: // value for 'scheduledDate'
 *   },
 * });
 */
export function useCreateAiTutorMutation(baseOptions?: Apollo.MutationHookOptions<CreateAiTutorMutation, CreateAiTutorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAiTutorMutation, CreateAiTutorMutationVariables>(CreateAiTutorDocument, options);
      }
export type CreateAiTutorMutationHookResult = ReturnType<typeof useCreateAiTutorMutation>;
export type CreateAiTutorMutationResult = Apollo.MutationResult<CreateAiTutorMutation>;
export type CreateAiTutorMutationOptions = Apollo.BaseMutationOptions<CreateAiTutorMutation, CreateAiTutorMutationVariables>;
export const DeleteAiTutorDocument = gql`
    mutation DeleteAITutor($id: ID!) {
  deleteAITutor(id: $id) {
    success
    message
  }
}
    `;
export type DeleteAiTutorMutationFn = Apollo.MutationFunction<DeleteAiTutorMutation, DeleteAiTutorMutationVariables>;

/**
 * __useDeleteAiTutorMutation__
 *
 * To run a mutation, you first call `useDeleteAiTutorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAiTutorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAiTutorMutation, { data, loading, error }] = useDeleteAiTutorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAiTutorMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAiTutorMutation, DeleteAiTutorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAiTutorMutation, DeleteAiTutorMutationVariables>(DeleteAiTutorDocument, options);
      }
export type DeleteAiTutorMutationHookResult = ReturnType<typeof useDeleteAiTutorMutation>;
export type DeleteAiTutorMutationResult = Apollo.MutationResult<DeleteAiTutorMutation>;
export type DeleteAiTutorMutationOptions = Apollo.BaseMutationOptions<DeleteAiTutorMutation, DeleteAiTutorMutationVariables>;
export const BulkAssessmentCreateDocument = gql`
    mutation BulkAssessmentCreate($input: BulkAssessmentCreateInput!) {
  bulkAssessmentCreate(input: $input) {
    success
    message
    jobId
  }
}
    `;
export type BulkAssessmentCreateMutationFn = Apollo.MutationFunction<BulkAssessmentCreateMutation, BulkAssessmentCreateMutationVariables>;

/**
 * __useBulkAssessmentCreateMutation__
 *
 * To run a mutation, you first call `useBulkAssessmentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkAssessmentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkAssessmentCreateMutation, { data, loading, error }] = useBulkAssessmentCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkAssessmentCreateMutation(baseOptions?: Apollo.MutationHookOptions<BulkAssessmentCreateMutation, BulkAssessmentCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkAssessmentCreateMutation, BulkAssessmentCreateMutationVariables>(BulkAssessmentCreateDocument, options);
      }
export type BulkAssessmentCreateMutationHookResult = ReturnType<typeof useBulkAssessmentCreateMutation>;
export type BulkAssessmentCreateMutationResult = Apollo.MutationResult<BulkAssessmentCreateMutation>;
export type BulkAssessmentCreateMutationOptions = Apollo.BaseMutationOptions<BulkAssessmentCreateMutation, BulkAssessmentCreateMutationVariables>;
export const CreateAnnouncementDocument = gql`
    mutation CreateAnnouncement($input: CreateAnnouncementInput!) {
  createAnnouncement(input: $input) {
    success
    message
    data {
      id
      title
      message
      expirationDate
      created
      lastModified
      scope
      audienceType
      author {
        id
        name
        email
      }
      courses {
        id
        name
      }
      degrees {
        id
        name
      }
      school {
        id
        team_name
      }
    }
    count
  }
}
    `;
export type CreateAnnouncementMutationFn = Apollo.MutationFunction<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>;

/**
 * __useCreateAnnouncementMutation__
 *
 * To run a mutation, you first call `useCreateAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnnouncementMutation, { data, loading, error }] = useCreateAnnouncementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAnnouncementMutation(baseOptions?: Apollo.MutationHookOptions<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>(CreateAnnouncementDocument, options);
      }
export type CreateAnnouncementMutationHookResult = ReturnType<typeof useCreateAnnouncementMutation>;
export type CreateAnnouncementMutationResult = Apollo.MutationResult<CreateAnnouncementMutation>;
export type CreateAnnouncementMutationOptions = Apollo.BaseMutationOptions<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>;
export const CreateAxioResourceDocument = gql`
    mutation CreateAxioResource($resource: CreateAxioResourceInput!) {
  createAxioResource(resource: $resource) {
    success
    message
    data {
      id
      name
      description
      videoUrl
      order
      created
      lastModified
    }
    count
  }
}
    `;
export type CreateAxioResourceMutationFn = Apollo.MutationFunction<CreateAxioResourceMutation, CreateAxioResourceMutationVariables>;

/**
 * __useCreateAxioResourceMutation__
 *
 * To run a mutation, you first call `useCreateAxioResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAxioResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAxioResourceMutation, { data, loading, error }] = useCreateAxioResourceMutation({
 *   variables: {
 *      resource: // value for 'resource'
 *   },
 * });
 */
export function useCreateAxioResourceMutation(baseOptions?: Apollo.MutationHookOptions<CreateAxioResourceMutation, CreateAxioResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAxioResourceMutation, CreateAxioResourceMutationVariables>(CreateAxioResourceDocument, options);
      }
export type CreateAxioResourceMutationHookResult = ReturnType<typeof useCreateAxioResourceMutation>;
export type CreateAxioResourceMutationResult = Apollo.MutationResult<CreateAxioResourceMutation>;
export type CreateAxioResourceMutationOptions = Apollo.BaseMutationOptions<CreateAxioResourceMutation, CreateAxioResourceMutationVariables>;
export const CreateCoursePlaceholderDocument = gql`
    mutation CreateCoursePlaceholder($name: String!, $courseCode: String, $schoolId: ID!, $description: String, $objectives: String, $targetAudience: String, $cost: Float, $degreeIds: [ID!]) {
  createCoursePlaceholder(
    course: {name: $name, course_code: $courseCode, schoolId: $schoolId, description: $description, objectives: $objectives, targetAudience: $targetAudience, cost: $cost, degreeIds: $degreeIds}
  ) {
    success
    data {
      id
      name
      course_code
      description
      objectives
      targetAudience
      cost
      degreesHasCourse {
        id
        name
      }
    }
    count
  }
}
    `;
export type CreateCoursePlaceholderMutationFn = Apollo.MutationFunction<CreateCoursePlaceholderMutation, CreateCoursePlaceholderMutationVariables>;

/**
 * __useCreateCoursePlaceholderMutation__
 *
 * To run a mutation, you first call `useCreateCoursePlaceholderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoursePlaceholderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoursePlaceholderMutation, { data, loading, error }] = useCreateCoursePlaceholderMutation({
 *   variables: {
 *      name: // value for 'name'
 *      courseCode: // value for 'courseCode'
 *      schoolId: // value for 'schoolId'
 *      description: // value for 'description'
 *      objectives: // value for 'objectives'
 *      targetAudience: // value for 'targetAudience'
 *      cost: // value for 'cost'
 *      degreeIds: // value for 'degreeIds'
 *   },
 * });
 */
export function useCreateCoursePlaceholderMutation(baseOptions?: Apollo.MutationHookOptions<CreateCoursePlaceholderMutation, CreateCoursePlaceholderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCoursePlaceholderMutation, CreateCoursePlaceholderMutationVariables>(CreateCoursePlaceholderDocument, options);
      }
export type CreateCoursePlaceholderMutationHookResult = ReturnType<typeof useCreateCoursePlaceholderMutation>;
export type CreateCoursePlaceholderMutationResult = Apollo.MutationResult<CreateCoursePlaceholderMutation>;
export type CreateCoursePlaceholderMutationOptions = Apollo.BaseMutationOptions<CreateCoursePlaceholderMutation, CreateCoursePlaceholderMutationVariables>;
export const CreateNoteDocument = gql`
    mutation CreateNote($input: CreateNoteInput!) {
  createNote(input: $input) {
    success
    message
    data {
      id
      content
      created
      lastModified
      author {
        id
        name
        profilePicture
      }
      subject {
        id
        name
      }
    }
    count
  }
}
    `;
export type CreateNoteMutationFn = Apollo.MutationFunction<CreateNoteMutation, CreateNoteMutationVariables>;

/**
 * __useCreateNoteMutation__
 *
 * To run a mutation, you first call `useCreateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteMutation, { data, loading, error }] = useCreateNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateNoteMutation, CreateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNoteMutation, CreateNoteMutationVariables>(CreateNoteDocument, options);
      }
export type CreateNoteMutationHookResult = ReturnType<typeof useCreateNoteMutation>;
export type CreateNoteMutationResult = Apollo.MutationResult<CreateNoteMutation>;
export type CreateNoteMutationOptions = Apollo.BaseMutationOptions<CreateNoteMutation, CreateNoteMutationVariables>;
export const CreatePostDocument = gql`
    mutation CreatePost($input: CreatePostInput!) {
  createPost(input: $input) {
    success
    message
    data {
      id
      message
      depth
      threadId
      created
      lastModified
      thread {
        id
        title
        forum {
          course {
            id
            name
          }
        }
      }
      author {
        id
        name
      }
      files {
        id
        fileName
        fileURL
      }
      replies {
        id
        message
        depth
        created
        lastModified
        author {
          id
          name
        }
        files {
          id
          fileName
          fileURL
        }
      }
      replyTo {
        id
        message
        author {
          id
          name
        }
      }
    }
    count
  }
}
    `;
export type CreatePostMutationFn = Apollo.MutationFunction<CreatePostMutation, CreatePostMutationVariables>;

/**
 * __useCreatePostMutation__
 *
 * To run a mutation, you first call `useCreatePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostMutation, { data, loading, error }] = useCreatePostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePostMutation(baseOptions?: Apollo.MutationHookOptions<CreatePostMutation, CreatePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePostMutation, CreatePostMutationVariables>(CreatePostDocument, options);
      }
export type CreatePostMutationHookResult = ReturnType<typeof useCreatePostMutation>;
export type CreatePostMutationResult = Apollo.MutationResult<CreatePostMutation>;
export type CreatePostMutationOptions = Apollo.BaseMutationOptions<CreatePostMutation, CreatePostMutationVariables>;
export const CreateReviewDocument = gql`
    mutation CreateReview($review: CreateReviewInput!) {
  createReview(review: $review) {
    success
    message
    data {
      id
      created
      lastModified
    }
    count
  }
}
    `;
export type CreateReviewMutationFn = Apollo.MutationFunction<CreateReviewMutation, CreateReviewMutationVariables>;

/**
 * __useCreateReviewMutation__
 *
 * To run a mutation, you first call `useCreateReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReviewMutation, { data, loading, error }] = useCreateReviewMutation({
 *   variables: {
 *      review: // value for 'review'
 *   },
 * });
 */
export function useCreateReviewMutation(baseOptions?: Apollo.MutationHookOptions<CreateReviewMutation, CreateReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReviewMutation, CreateReviewMutationVariables>(CreateReviewDocument, options);
      }
export type CreateReviewMutationHookResult = ReturnType<typeof useCreateReviewMutation>;
export type CreateReviewMutationResult = Apollo.MutationResult<CreateReviewMutation>;
export type CreateReviewMutationOptions = Apollo.BaseMutationOptions<CreateReviewMutation, CreateReviewMutationVariables>;
export const CreateThreadDocument = gql`
    mutation CreateThread($input: CreateThreadInput!) {
  createThread(input: $input) {
    success
    message
    data {
      id
      title
      created
      lastModified
      forum {
        id
        course {
          id
          name
        }
      }
      posts {
        id
        message
        depth
        threadId
        created
        lastModified
        author {
          id
          name
        }
        files {
          id
          fileName
          fileURL
        }
      }
      subscribers {
        id
      }
    }
    count
  }
}
    `;
export type CreateThreadMutationFn = Apollo.MutationFunction<CreateThreadMutation, CreateThreadMutationVariables>;

/**
 * __useCreateThreadMutation__
 *
 * To run a mutation, you first call `useCreateThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createThreadMutation, { data, loading, error }] = useCreateThreadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateThreadMutation(baseOptions?: Apollo.MutationHookOptions<CreateThreadMutation, CreateThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateThreadMutation, CreateThreadMutationVariables>(CreateThreadDocument, options);
      }
export type CreateThreadMutationHookResult = ReturnType<typeof useCreateThreadMutation>;
export type CreateThreadMutationResult = Apollo.MutationResult<CreateThreadMutation>;
export type CreateThreadMutationOptions = Apollo.BaseMutationOptions<CreateThreadMutation, CreateThreadMutationVariables>;
export const DeleteAnnouncementDocument = gql`
    mutation DeleteAnnouncement($id: ID!) {
  deleteAnnouncement(id: $id) {
    success
    message
    count
  }
}
    `;
export type DeleteAnnouncementMutationFn = Apollo.MutationFunction<DeleteAnnouncementMutation, DeleteAnnouncementMutationVariables>;

/**
 * __useDeleteAnnouncementMutation__
 *
 * To run a mutation, you first call `useDeleteAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnnouncementMutation, { data, loading, error }] = useDeleteAnnouncementMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAnnouncementMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAnnouncementMutation, DeleteAnnouncementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAnnouncementMutation, DeleteAnnouncementMutationVariables>(DeleteAnnouncementDocument, options);
      }
export type DeleteAnnouncementMutationHookResult = ReturnType<typeof useDeleteAnnouncementMutation>;
export type DeleteAnnouncementMutationResult = Apollo.MutationResult<DeleteAnnouncementMutation>;
export type DeleteAnnouncementMutationOptions = Apollo.BaseMutationOptions<DeleteAnnouncementMutation, DeleteAnnouncementMutationVariables>;
export const DeleteAxioResourceDocument = gql`
    mutation DeleteAxioResource($id: ID!) {
  deleteAxioResource(id: $id) {
    success
    message
  }
}
    `;
export type DeleteAxioResourceMutationFn = Apollo.MutationFunction<DeleteAxioResourceMutation, DeleteAxioResourceMutationVariables>;

/**
 * __useDeleteAxioResourceMutation__
 *
 * To run a mutation, you first call `useDeleteAxioResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAxioResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAxioResourceMutation, { data, loading, error }] = useDeleteAxioResourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAxioResourceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAxioResourceMutation, DeleteAxioResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAxioResourceMutation, DeleteAxioResourceMutationVariables>(DeleteAxioResourceDocument, options);
      }
export type DeleteAxioResourceMutationHookResult = ReturnType<typeof useDeleteAxioResourceMutation>;
export type DeleteAxioResourceMutationResult = Apollo.MutationResult<DeleteAxioResourceMutation>;
export type DeleteAxioResourceMutationOptions = Apollo.BaseMutationOptions<DeleteAxioResourceMutation, DeleteAxioResourceMutationVariables>;
export const DeleteNoteDocument = gql`
    mutation DeleteNote($noteId: ID!) {
  deleteNote(noteId: $noteId) {
    success
    message
    count
  }
}
    `;
export type DeleteNoteMutationFn = Apollo.MutationFunction<DeleteNoteMutation, DeleteNoteMutationVariables>;

/**
 * __useDeleteNoteMutation__
 *
 * To run a mutation, you first call `useDeleteNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNoteMutation, { data, loading, error }] = useDeleteNoteMutation({
 *   variables: {
 *      noteId: // value for 'noteId'
 *   },
 * });
 */
export function useDeleteNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNoteMutation, DeleteNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNoteMutation, DeleteNoteMutationVariables>(DeleteNoteDocument, options);
      }
export type DeleteNoteMutationHookResult = ReturnType<typeof useDeleteNoteMutation>;
export type DeleteNoteMutationResult = Apollo.MutationResult<DeleteNoteMutation>;
export type DeleteNoteMutationOptions = Apollo.BaseMutationOptions<DeleteNoteMutation, DeleteNoteMutationVariables>;
export const DeletePostDocument = gql`
    mutation DeletePost($postId: ID!) {
  deletePost(postId: $postId) {
    success
    message
    data {
      id
      message
      author {
        id
        name
      }
      thread {
        id
        title
      }
    }
    count
  }
}
    `;
export type DeletePostMutationFn = Apollo.MutationFunction<DeletePostMutation, DeletePostMutationVariables>;

/**
 * __useDeletePostMutation__
 *
 * To run a mutation, you first call `useDeletePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostMutation, { data, loading, error }] = useDeletePostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useDeletePostMutation(baseOptions?: Apollo.MutationHookOptions<DeletePostMutation, DeletePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePostMutation, DeletePostMutationVariables>(DeletePostDocument, options);
      }
export type DeletePostMutationHookResult = ReturnType<typeof useDeletePostMutation>;
export type DeletePostMutationResult = Apollo.MutationResult<DeletePostMutation>;
export type DeletePostMutationOptions = Apollo.BaseMutationOptions<DeletePostMutation, DeletePostMutationVariables>;
export const DeleteReviewDocument = gql`
    mutation DeleteReview($id: ID!) {
  deleteReview(id: $id) {
    success
    message
    count
  }
}
    `;
export type DeleteReviewMutationFn = Apollo.MutationFunction<DeleteReviewMutation, DeleteReviewMutationVariables>;

/**
 * __useDeleteReviewMutation__
 *
 * To run a mutation, you first call `useDeleteReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReviewMutation, { data, loading, error }] = useDeleteReviewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReviewMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReviewMutation, DeleteReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReviewMutation, DeleteReviewMutationVariables>(DeleteReviewDocument, options);
      }
export type DeleteReviewMutationHookResult = ReturnType<typeof useDeleteReviewMutation>;
export type DeleteReviewMutationResult = Apollo.MutationResult<DeleteReviewMutation>;
export type DeleteReviewMutationOptions = Apollo.BaseMutationOptions<DeleteReviewMutation, DeleteReviewMutationVariables>;
export const DeleteThreadDocument = gql`
    mutation DeleteThread($threadId: ID!) {
  deleteThread(threadId: $threadId) {
    success
    message
    data {
      id
      title
      created
      lastModified
      posts {
        id
        message
        author {
          id
          name
        }
      }
    }
    count
  }
}
    `;
export type DeleteThreadMutationFn = Apollo.MutationFunction<DeleteThreadMutation, DeleteThreadMutationVariables>;

/**
 * __useDeleteThreadMutation__
 *
 * To run a mutation, you first call `useDeleteThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteThreadMutation, { data, loading, error }] = useDeleteThreadMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useDeleteThreadMutation(baseOptions?: Apollo.MutationHookOptions<DeleteThreadMutation, DeleteThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteThreadMutation, DeleteThreadMutationVariables>(DeleteThreadDocument, options);
      }
export type DeleteThreadMutationHookResult = ReturnType<typeof useDeleteThreadMutation>;
export type DeleteThreadMutationResult = Apollo.MutationResult<DeleteThreadMutation>;
export type DeleteThreadMutationOptions = Apollo.BaseMutationOptions<DeleteThreadMutation, DeleteThreadMutationVariables>;
export const DownloadLessonPlanDocument = gql`
    mutation DownloadLessonPlan($moduleId: ID!) {
  downloadLessonPlan(moduleId: $moduleId) {
    success
    message
    data
  }
}
    `;
export type DownloadLessonPlanMutationFn = Apollo.MutationFunction<DownloadLessonPlanMutation, DownloadLessonPlanMutationVariables>;

/**
 * __useDownloadLessonPlanMutation__
 *
 * To run a mutation, you first call `useDownloadLessonPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadLessonPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadLessonPlanMutation, { data, loading, error }] = useDownloadLessonPlanMutation({
 *   variables: {
 *      moduleId: // value for 'moduleId'
 *   },
 * });
 */
export function useDownloadLessonPlanMutation(baseOptions?: Apollo.MutationHookOptions<DownloadLessonPlanMutation, DownloadLessonPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadLessonPlanMutation, DownloadLessonPlanMutationVariables>(DownloadLessonPlanDocument, options);
      }
export type DownloadLessonPlanMutationHookResult = ReturnType<typeof useDownloadLessonPlanMutation>;
export type DownloadLessonPlanMutationResult = Apollo.MutationResult<DownloadLessonPlanMutation>;
export type DownloadLessonPlanMutationOptions = Apollo.BaseMutationOptions<DownloadLessonPlanMutation, DownloadLessonPlanMutationVariables>;
export const GenerateAiTutorFromTitleDocument = gql`
    mutation GenerateAiTutorFromTitle($title: String!, $targetAudience: String) {
  generateAiTutorFromTitle(title: $title, targetAudience: $targetAudience) {
    message
    success
    data {
      description
      objectives {
        objective
        sequence
      }
    }
  }
}
    `;
export type GenerateAiTutorFromTitleMutationFn = Apollo.MutationFunction<GenerateAiTutorFromTitleMutation, GenerateAiTutorFromTitleMutationVariables>;

/**
 * __useGenerateAiTutorFromTitleMutation__
 *
 * To run a mutation, you first call `useGenerateAiTutorFromTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAiTutorFromTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAiTutorFromTitleMutation, { data, loading, error }] = useGenerateAiTutorFromTitleMutation({
 *   variables: {
 *      title: // value for 'title'
 *      targetAudience: // value for 'targetAudience'
 *   },
 * });
 */
export function useGenerateAiTutorFromTitleMutation(baseOptions?: Apollo.MutationHookOptions<GenerateAiTutorFromTitleMutation, GenerateAiTutorFromTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateAiTutorFromTitleMutation, GenerateAiTutorFromTitleMutationVariables>(GenerateAiTutorFromTitleDocument, options);
      }
export type GenerateAiTutorFromTitleMutationHookResult = ReturnType<typeof useGenerateAiTutorFromTitleMutation>;
export type GenerateAiTutorFromTitleMutationResult = Apollo.MutationResult<GenerateAiTutorFromTitleMutation>;
export type GenerateAiTutorFromTitleMutationOptions = Apollo.BaseMutationOptions<GenerateAiTutorFromTitleMutation, GenerateAiTutorFromTitleMutationVariables>;
export const GenerateCourseContentDocument = gql`
    mutation GenerateCourseContent($courseId: ID!, $numberOfModules: Int!, $numberOfActivities: Int!, $courseDescription: String) {
  generateCourseContent(
    courseId: $courseId
    numberOfModules: $numberOfModules
    numberOfActivities: $numberOfActivities
    courseDescription: $courseDescription
  ) {
    count
    data {
      id
    }
    message
    success
  }
}
    `;
export type GenerateCourseContentMutationFn = Apollo.MutationFunction<GenerateCourseContentMutation, GenerateCourseContentMutationVariables>;

/**
 * __useGenerateCourseContentMutation__
 *
 * To run a mutation, you first call `useGenerateCourseContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCourseContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCourseContentMutation, { data, loading, error }] = useGenerateCourseContentMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      numberOfModules: // value for 'numberOfModules'
 *      numberOfActivities: // value for 'numberOfActivities'
 *      courseDescription: // value for 'courseDescription'
 *   },
 * });
 */
export function useGenerateCourseContentMutation(baseOptions?: Apollo.MutationHookOptions<GenerateCourseContentMutation, GenerateCourseContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateCourseContentMutation, GenerateCourseContentMutationVariables>(GenerateCourseContentDocument, options);
      }
export type GenerateCourseContentMutationHookResult = ReturnType<typeof useGenerateCourseContentMutation>;
export type GenerateCourseContentMutationResult = Apollo.MutationResult<GenerateCourseContentMutation>;
export type GenerateCourseContentMutationOptions = Apollo.BaseMutationOptions<GenerateCourseContentMutation, GenerateCourseContentMutationVariables>;
export const GenerateEvalCriteriaDocument = gql`
    mutation GenerateEvalCriteria($input: GenerateEvalCriteriaInput!) {
  generateEvalCriteria(input: $input) {
    message
    success
    data {
      objective
      evalCriteria
    }
  }
}
    `;
export type GenerateEvalCriteriaMutationFn = Apollo.MutationFunction<GenerateEvalCriteriaMutation, GenerateEvalCriteriaMutationVariables>;

/**
 * __useGenerateEvalCriteriaMutation__
 *
 * To run a mutation, you first call `useGenerateEvalCriteriaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateEvalCriteriaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateEvalCriteriaMutation, { data, loading, error }] = useGenerateEvalCriteriaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateEvalCriteriaMutation(baseOptions?: Apollo.MutationHookOptions<GenerateEvalCriteriaMutation, GenerateEvalCriteriaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateEvalCriteriaMutation, GenerateEvalCriteriaMutationVariables>(GenerateEvalCriteriaDocument, options);
      }
export type GenerateEvalCriteriaMutationHookResult = ReturnType<typeof useGenerateEvalCriteriaMutation>;
export type GenerateEvalCriteriaMutationResult = Apollo.MutationResult<GenerateEvalCriteriaMutation>;
export type GenerateEvalCriteriaMutationOptions = Apollo.BaseMutationOptions<GenerateEvalCriteriaMutation, GenerateEvalCriteriaMutationVariables>;
export const GenerateLessonPlanDocument = gql`
    mutation GenerateLessonPlan($input: GenerateLessonPlanInput!) {
  generateLessonPlan(input: $input) {
    success
    message
    data
  }
}
    `;
export type GenerateLessonPlanMutationFn = Apollo.MutationFunction<GenerateLessonPlanMutation, GenerateLessonPlanMutationVariables>;

/**
 * __useGenerateLessonPlanMutation__
 *
 * To run a mutation, you first call `useGenerateLessonPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateLessonPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateLessonPlanMutation, { data, loading, error }] = useGenerateLessonPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateLessonPlanMutation(baseOptions?: Apollo.MutationHookOptions<GenerateLessonPlanMutation, GenerateLessonPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateLessonPlanMutation, GenerateLessonPlanMutationVariables>(GenerateLessonPlanDocument, options);
      }
export type GenerateLessonPlanMutationHookResult = ReturnType<typeof useGenerateLessonPlanMutation>;
export type GenerateLessonPlanMutationResult = Apollo.MutationResult<GenerateLessonPlanMutation>;
export type GenerateLessonPlanMutationOptions = Apollo.BaseMutationOptions<GenerateLessonPlanMutation, GenerateLessonPlanMutationVariables>;
export const GetRosterExportFileDocument = gql`
    query GetRosterExportFile($courseId: ID!) {
  getRosterExportFile(courseId: $courseId) {
    success
    message
    count
    data {
      id
      fileName
      fileURL
    }
  }
}
    `;

/**
 * __useGetRosterExportFileQuery__
 *
 * To run a query within a React component, call `useGetRosterExportFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRosterExportFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRosterExportFileQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetRosterExportFileQuery(baseOptions: Apollo.QueryHookOptions<GetRosterExportFileQuery, GetRosterExportFileQueryVariables> & ({ variables: GetRosterExportFileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRosterExportFileQuery, GetRosterExportFileQueryVariables>(GetRosterExportFileDocument, options);
      }
export function useGetRosterExportFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRosterExportFileQuery, GetRosterExportFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRosterExportFileQuery, GetRosterExportFileQueryVariables>(GetRosterExportFileDocument, options);
        }
// @ts-ignore
export function useGetRosterExportFileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRosterExportFileQuery, GetRosterExportFileQueryVariables>): Apollo.UseSuspenseQueryResult<GetRosterExportFileQuery, GetRosterExportFileQueryVariables>;
export function useGetRosterExportFileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRosterExportFileQuery, GetRosterExportFileQueryVariables>): Apollo.UseSuspenseQueryResult<GetRosterExportFileQuery | undefined, GetRosterExportFileQueryVariables>;
export function useGetRosterExportFileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRosterExportFileQuery, GetRosterExportFileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRosterExportFileQuery, GetRosterExportFileQueryVariables>(GetRosterExportFileDocument, options);
        }
export type GetRosterExportFileQueryHookResult = ReturnType<typeof useGetRosterExportFileQuery>;
export type GetRosterExportFileLazyQueryHookResult = ReturnType<typeof useGetRosterExportFileLazyQuery>;
export type GetRosterExportFileSuspenseQueryHookResult = ReturnType<typeof useGetRosterExportFileSuspenseQuery>;
export type GetRosterExportFileQueryResult = Apollo.QueryResult<GetRosterExportFileQuery, GetRosterExportFileQueryVariables>;
export const GetSubmissionExportFileDocument = gql`
    query GetSubmissionExportFile {
  getSubmissionExportFile {
    success
    message
    count
    data {
      id
      fileName
      fileURL
    }
  }
}
    `;

/**
 * __useGetSubmissionExportFileQuery__
 *
 * To run a query within a React component, call `useGetSubmissionExportFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubmissionExportFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubmissionExportFileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubmissionExportFileQuery(baseOptions?: Apollo.QueryHookOptions<GetSubmissionExportFileQuery, GetSubmissionExportFileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubmissionExportFileQuery, GetSubmissionExportFileQueryVariables>(GetSubmissionExportFileDocument, options);
      }
export function useGetSubmissionExportFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubmissionExportFileQuery, GetSubmissionExportFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubmissionExportFileQuery, GetSubmissionExportFileQueryVariables>(GetSubmissionExportFileDocument, options);
        }
// @ts-ignore
export function useGetSubmissionExportFileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSubmissionExportFileQuery, GetSubmissionExportFileQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubmissionExportFileQuery, GetSubmissionExportFileQueryVariables>;
export function useGetSubmissionExportFileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubmissionExportFileQuery, GetSubmissionExportFileQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubmissionExportFileQuery | undefined, GetSubmissionExportFileQueryVariables>;
export function useGetSubmissionExportFileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubmissionExportFileQuery, GetSubmissionExportFileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubmissionExportFileQuery, GetSubmissionExportFileQueryVariables>(GetSubmissionExportFileDocument, options);
        }
export type GetSubmissionExportFileQueryHookResult = ReturnType<typeof useGetSubmissionExportFileQuery>;
export type GetSubmissionExportFileLazyQueryHookResult = ReturnType<typeof useGetSubmissionExportFileLazyQuery>;
export type GetSubmissionExportFileSuspenseQueryHookResult = ReturnType<typeof useGetSubmissionExportFileSuspenseQuery>;
export type GetSubmissionExportFileQueryResult = Apollo.QueryResult<GetSubmissionExportFileQuery, GetSubmissionExportFileQueryVariables>;
export const MarkAnnouncementAsSeenDocument = gql`
    mutation MarkAnnouncementAsSeen($announcementId: ID!) {
  markAnnouncementAsSeen(announcementId: $announcementId) {
    success
    message
  }
}
    `;
export type MarkAnnouncementAsSeenMutationFn = Apollo.MutationFunction<MarkAnnouncementAsSeenMutation, MarkAnnouncementAsSeenMutationVariables>;

/**
 * __useMarkAnnouncementAsSeenMutation__
 *
 * To run a mutation, you first call `useMarkAnnouncementAsSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAnnouncementAsSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAnnouncementAsSeenMutation, { data, loading, error }] = useMarkAnnouncementAsSeenMutation({
 *   variables: {
 *      announcementId: // value for 'announcementId'
 *   },
 * });
 */
export function useMarkAnnouncementAsSeenMutation(baseOptions?: Apollo.MutationHookOptions<MarkAnnouncementAsSeenMutation, MarkAnnouncementAsSeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAnnouncementAsSeenMutation, MarkAnnouncementAsSeenMutationVariables>(MarkAnnouncementAsSeenDocument, options);
      }
export type MarkAnnouncementAsSeenMutationHookResult = ReturnType<typeof useMarkAnnouncementAsSeenMutation>;
export type MarkAnnouncementAsSeenMutationResult = Apollo.MutationResult<MarkAnnouncementAsSeenMutation>;
export type MarkAnnouncementAsSeenMutationOptions = Apollo.BaseMutationOptions<MarkAnnouncementAsSeenMutation, MarkAnnouncementAsSeenMutationVariables>;
export const UpdateAnnouncementDocument = gql`
    mutation UpdateAnnouncement($id: ID!, $input: UpdateAnnouncementInput!) {
  updateAnnouncement(id: $id, input: $input) {
    success
    message
    data {
      id
      title
      message
      expirationDate
      created
      lastModified
      scope
      audienceType
      author {
        id
        name
        email
      }
      courses {
        id
        name
      }
      degrees {
        id
        name
      }
      school {
        id
        team_name
      }
    }
    count
  }
}
    `;
export type UpdateAnnouncementMutationFn = Apollo.MutationFunction<UpdateAnnouncementMutation, UpdateAnnouncementMutationVariables>;

/**
 * __useUpdateAnnouncementMutation__
 *
 * To run a mutation, you first call `useUpdateAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnnouncementMutation, { data, loading, error }] = useUpdateAnnouncementMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAnnouncementMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAnnouncementMutation, UpdateAnnouncementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAnnouncementMutation, UpdateAnnouncementMutationVariables>(UpdateAnnouncementDocument, options);
      }
export type UpdateAnnouncementMutationHookResult = ReturnType<typeof useUpdateAnnouncementMutation>;
export type UpdateAnnouncementMutationResult = Apollo.MutationResult<UpdateAnnouncementMutation>;
export type UpdateAnnouncementMutationOptions = Apollo.BaseMutationOptions<UpdateAnnouncementMutation, UpdateAnnouncementMutationVariables>;
export const UpdateAxioResourceDocument = gql`
    mutation UpdateAxioResource($id: ID!, $resource: UpdateAxioResourceInput!) {
  updateAxioResource(id: $id, resource: $resource) {
    success
    message
    data {
      id
      name
      description
      videoUrl
      order
    }
  }
}
    `;
export type UpdateAxioResourceMutationFn = Apollo.MutationFunction<UpdateAxioResourceMutation, UpdateAxioResourceMutationVariables>;

/**
 * __useUpdateAxioResourceMutation__
 *
 * To run a mutation, you first call `useUpdateAxioResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAxioResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAxioResourceMutation, { data, loading, error }] = useUpdateAxioResourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      resource: // value for 'resource'
 *   },
 * });
 */
export function useUpdateAxioResourceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAxioResourceMutation, UpdateAxioResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAxioResourceMutation, UpdateAxioResourceMutationVariables>(UpdateAxioResourceDocument, options);
      }
export type UpdateAxioResourceMutationHookResult = ReturnType<typeof useUpdateAxioResourceMutation>;
export type UpdateAxioResourceMutationResult = Apollo.MutationResult<UpdateAxioResourceMutation>;
export type UpdateAxioResourceMutationOptions = Apollo.BaseMutationOptions<UpdateAxioResourceMutation, UpdateAxioResourceMutationVariables>;
export const UpdateLastSeenPostDocument = gql`
    mutation UpdateLastSeenPost($input: UpdateLastSeenPostInput!) {
  updateLastSeenPost(input: $input) {
    success
    message
    data {
      id
      message
      threadId
      created
    }
    count
  }
}
    `;
export type UpdateLastSeenPostMutationFn = Apollo.MutationFunction<UpdateLastSeenPostMutation, UpdateLastSeenPostMutationVariables>;

/**
 * __useUpdateLastSeenPostMutation__
 *
 * To run a mutation, you first call `useUpdateLastSeenPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLastSeenPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLastSeenPostMutation, { data, loading, error }] = useUpdateLastSeenPostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLastSeenPostMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLastSeenPostMutation, UpdateLastSeenPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLastSeenPostMutation, UpdateLastSeenPostMutationVariables>(UpdateLastSeenPostDocument, options);
      }
export type UpdateLastSeenPostMutationHookResult = ReturnType<typeof useUpdateLastSeenPostMutation>;
export type UpdateLastSeenPostMutationResult = Apollo.MutationResult<UpdateLastSeenPostMutation>;
export type UpdateLastSeenPostMutationOptions = Apollo.BaseMutationOptions<UpdateLastSeenPostMutation, UpdateLastSeenPostMutationVariables>;
export const UpdateNoteDocument = gql`
    mutation UpdateNote($noteId: ID!, $input: UpdateNoteInput!) {
  updateNote(noteId: $noteId, input: $input) {
    success
    message
    data {
      id
      content
      created
      lastModified
      author {
        id
        name
        profilePicture
      }
      subject {
        id
        name
      }
    }
    count
  }
}
    `;
export type UpdateNoteMutationFn = Apollo.MutationFunction<UpdateNoteMutation, UpdateNoteMutationVariables>;

/**
 * __useUpdateNoteMutation__
 *
 * To run a mutation, you first call `useUpdateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteMutation, { data, loading, error }] = useUpdateNoteMutation({
 *   variables: {
 *      noteId: // value for 'noteId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNoteMutation, UpdateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNoteMutation, UpdateNoteMutationVariables>(UpdateNoteDocument, options);
      }
export type UpdateNoteMutationHookResult = ReturnType<typeof useUpdateNoteMutation>;
export type UpdateNoteMutationResult = Apollo.MutationResult<UpdateNoteMutation>;
export type UpdateNoteMutationOptions = Apollo.BaseMutationOptions<UpdateNoteMutation, UpdateNoteMutationVariables>;
export const UpdatePostDocument = gql`
    mutation UpdatePost($postId: ID!, $input: UpdatePostInput!) {
  updatePost(postId: $postId, input: $input) {
    success
    message
    data {
      id
      message
      depth
      threadId
      created
      lastModified
      thread {
        id
        title
      }
      author {
        id
        name
      }
      files {
        id
        fileName
        fileURL
      }
      replies {
        id
        message
        depth
        created
        lastModified
        author {
          id
          name
        }
        files {
          id
          fileName
          fileURL
        }
      }
      replyTo {
        id
        message
        author {
          id
          name
        }
      }
    }
    count
  }
}
    `;
export type UpdatePostMutationFn = Apollo.MutationFunction<UpdatePostMutation, UpdatePostMutationVariables>;

/**
 * __useUpdatePostMutation__
 *
 * To run a mutation, you first call `useUpdatePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostMutation, { data, loading, error }] = useUpdatePostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePostMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePostMutation, UpdatePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePostMutation, UpdatePostMutationVariables>(UpdatePostDocument, options);
      }
export type UpdatePostMutationHookResult = ReturnType<typeof useUpdatePostMutation>;
export type UpdatePostMutationResult = Apollo.MutationResult<UpdatePostMutation>;
export type UpdatePostMutationOptions = Apollo.BaseMutationOptions<UpdatePostMutation, UpdatePostMutationVariables>;
export const UpdateReviewDocument = gql`
    mutation UpdateReview($id: ID!, $review: UpdateReviewInput!) {
  updateReview(id: $id, review: $review) {
    success
    message
    data {
      id
      activityState
      scheduledDate
      lastModified
    }
    count
  }
}
    `;
export type UpdateReviewMutationFn = Apollo.MutationFunction<UpdateReviewMutation, UpdateReviewMutationVariables>;

/**
 * __useUpdateReviewMutation__
 *
 * To run a mutation, you first call `useUpdateReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReviewMutation, { data, loading, error }] = useUpdateReviewMutation({
 *   variables: {
 *      id: // value for 'id'
 *      review: // value for 'review'
 *   },
 * });
 */
export function useUpdateReviewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReviewMutation, UpdateReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReviewMutation, UpdateReviewMutationVariables>(UpdateReviewDocument, options);
      }
export type UpdateReviewMutationHookResult = ReturnType<typeof useUpdateReviewMutation>;
export type UpdateReviewMutationResult = Apollo.MutationResult<UpdateReviewMutation>;
export type UpdateReviewMutationOptions = Apollo.BaseMutationOptions<UpdateReviewMutation, UpdateReviewMutationVariables>;
export const UpdateThreadDocument = gql`
    mutation UpdateThread($threadId: ID!, $input: UpdateThreadInput!) {
  updateThread(threadId: $threadId, input: $input) {
    success
    message
    data {
      id
      title
      created
      lastModified
      forum {
        id
        course {
          id
          name
        }
      }
      posts {
        id
        message
        depth
        threadId
        created
        lastModified
        author {
          id
          name
        }
        files {
          id
          fileName
          fileURL
        }
      }
      subscribers {
        id
      }
    }
    count
  }
}
    `;
export type UpdateThreadMutationFn = Apollo.MutationFunction<UpdateThreadMutation, UpdateThreadMutationVariables>;

/**
 * __useUpdateThreadMutation__
 *
 * To run a mutation, you first call `useUpdateThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateThreadMutation, { data, loading, error }] = useUpdateThreadMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateThreadMutation(baseOptions?: Apollo.MutationHookOptions<UpdateThreadMutation, UpdateThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateThreadMutation, UpdateThreadMutationVariables>(UpdateThreadDocument, options);
      }
export type UpdateThreadMutationHookResult = ReturnType<typeof useUpdateThreadMutation>;
export type UpdateThreadMutationResult = Apollo.MutationResult<UpdateThreadMutation>;
export type UpdateThreadMutationOptions = Apollo.BaseMutationOptions<UpdateThreadMutation, UpdateThreadMutationVariables>;
export const CreateVideoPoolDocument = gql`
    mutation CreateVideoPool($title: String!, $description: String!, $objectives: [ObjectiveForVideoInput!]!) {
  createVideoPool(
    title: $title
    description: $description
    objectives: $objectives
  ) {
    success
    message
    data {
      videoId
      url
      title
      description
      thumbnailUrl
      objectiveText
      objectiveSequence
    }
    count
  }
}
    `;
export type CreateVideoPoolMutationFn = Apollo.MutationFunction<CreateVideoPoolMutation, CreateVideoPoolMutationVariables>;

/**
 * __useCreateVideoPoolMutation__
 *
 * To run a mutation, you first call `useCreateVideoPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVideoPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVideoPoolMutation, { data, loading, error }] = useCreateVideoPoolMutation({
 *   variables: {
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      objectives: // value for 'objectives'
 *   },
 * });
 */
export function useCreateVideoPoolMutation(baseOptions?: Apollo.MutationHookOptions<CreateVideoPoolMutation, CreateVideoPoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVideoPoolMutation, CreateVideoPoolMutationVariables>(CreateVideoPoolDocument, options);
      }
export type CreateVideoPoolMutationHookResult = ReturnType<typeof useCreateVideoPoolMutation>;
export type CreateVideoPoolMutationResult = Apollo.MutationResult<CreateVideoPoolMutation>;
export type CreateVideoPoolMutationOptions = Apollo.BaseMutationOptions<CreateVideoPoolMutation, CreateVideoPoolMutationVariables>;
export const AddPreRequisitesToCourseDocument = gql`
    mutation AddPreRequisitesToCourse($courseId: ID!, $preRequisiteIds: [ID!]!) {
  addPreRequisitesToCourse(courseId: $courseId, preRequisiteIds: $preRequisiteIds) {
    success
    data {
      id
    }
    count
  }
}
    `;
export type AddPreRequisitesToCourseMutationFn = Apollo.MutationFunction<AddPreRequisitesToCourseMutation, AddPreRequisitesToCourseMutationVariables>;

/**
 * __useAddPreRequisitesToCourseMutation__
 *
 * To run a mutation, you first call `useAddPreRequisitesToCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPreRequisitesToCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPreRequisitesToCourseMutation, { data, loading, error }] = useAddPreRequisitesToCourseMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      preRequisiteIds: // value for 'preRequisiteIds'
 *   },
 * });
 */
export function useAddPreRequisitesToCourseMutation(baseOptions?: Apollo.MutationHookOptions<AddPreRequisitesToCourseMutation, AddPreRequisitesToCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPreRequisitesToCourseMutation, AddPreRequisitesToCourseMutationVariables>(AddPreRequisitesToCourseDocument, options);
      }
export type AddPreRequisitesToCourseMutationHookResult = ReturnType<typeof useAddPreRequisitesToCourseMutation>;
export type AddPreRequisitesToCourseMutationResult = Apollo.MutationResult<AddPreRequisitesToCourseMutation>;
export type AddPreRequisitesToCourseMutationOptions = Apollo.BaseMutationOptions<AddPreRequisitesToCourseMutation, AddPreRequisitesToCourseMutationVariables>;
export const CloneCourseDocument = gql`
    mutation CloneCourse($courseId: ID!) {
  cloneCourse(courseId: $courseId) {
    success
    data {
      id
      name
    }
    count
  }
}
    `;
export type CloneCourseMutationFn = Apollo.MutationFunction<CloneCourseMutation, CloneCourseMutationVariables>;

/**
 * __useCloneCourseMutation__
 *
 * To run a mutation, you first call `useCloneCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneCourseMutation, { data, loading, error }] = useCloneCourseMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useCloneCourseMutation(baseOptions?: Apollo.MutationHookOptions<CloneCourseMutation, CloneCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneCourseMutation, CloneCourseMutationVariables>(CloneCourseDocument, options);
      }
export type CloneCourseMutationHookResult = ReturnType<typeof useCloneCourseMutation>;
export type CloneCourseMutationResult = Apollo.MutationResult<CloneCourseMutation>;
export type CloneCourseMutationOptions = Apollo.BaseMutationOptions<CloneCourseMutation, CloneCourseMutationVariables>;
export const CreateAssignmentDocument = gql`
    mutation CreateAssignment($assignment: CreateAssignmentInput!) {
  createAssignment(assignment: $assignment) {
    success
    message
  }
}
    `;
export type CreateAssignmentMutationFn = Apollo.MutationFunction<CreateAssignmentMutation, CreateAssignmentMutationVariables>;

/**
 * __useCreateAssignmentMutation__
 *
 * To run a mutation, you first call `useCreateAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssignmentMutation, { data, loading, error }] = useCreateAssignmentMutation({
 *   variables: {
 *      assignment: // value for 'assignment'
 *   },
 * });
 */
export function useCreateAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAssignmentMutation, CreateAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssignmentMutation, CreateAssignmentMutationVariables>(CreateAssignmentDocument, options);
      }
export type CreateAssignmentMutationHookResult = ReturnType<typeof useCreateAssignmentMutation>;
export type CreateAssignmentMutationResult = Apollo.MutationResult<CreateAssignmentMutation>;
export type CreateAssignmentMutationOptions = Apollo.BaseMutationOptions<CreateAssignmentMutation, CreateAssignmentMutationVariables>;
export const CreateOrUpdateAssessmentDocument = gql`
    mutation CreateOrUpdateAssessment($input: CreateOrUpdateAssessmentInput!) {
  createOrUpdateAssessment(input: $input) {
    success
    message
    data {
      id
    }
  }
}
    `;
export type CreateOrUpdateAssessmentMutationFn = Apollo.MutationFunction<CreateOrUpdateAssessmentMutation, CreateOrUpdateAssessmentMutationVariables>;

/**
 * __useCreateOrUpdateAssessmentMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateAssessmentMutation, { data, loading, error }] = useCreateOrUpdateAssessmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateAssessmentMutation, CreateOrUpdateAssessmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateAssessmentMutation, CreateOrUpdateAssessmentMutationVariables>(CreateOrUpdateAssessmentDocument, options);
      }
export type CreateOrUpdateAssessmentMutationHookResult = ReturnType<typeof useCreateOrUpdateAssessmentMutation>;
export type CreateOrUpdateAssessmentMutationResult = Apollo.MutationResult<CreateOrUpdateAssessmentMutation>;
export type CreateOrUpdateAssessmentMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateAssessmentMutation, CreateOrUpdateAssessmentMutationVariables>;
export const CreateWorksheetDocument = gql`
    mutation CreateWorksheet($worksheet: CreateWorksheetInput!, $existingWorksheetId: ID) {
  createWorksheet(
    worksheet: $worksheet
    existingWorksheetId: $existingWorksheetId
  ) {
    success
    message
    data {
      worksheetId
      pdfUrl
      generationStatus
    }
  }
}
    `;
export type CreateWorksheetMutationFn = Apollo.MutationFunction<CreateWorksheetMutation, CreateWorksheetMutationVariables>;

/**
 * __useCreateWorksheetMutation__
 *
 * To run a mutation, you first call `useCreateWorksheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorksheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorksheetMutation, { data, loading, error }] = useCreateWorksheetMutation({
 *   variables: {
 *      worksheet: // value for 'worksheet'
 *      existingWorksheetId: // value for 'existingWorksheetId'
 *   },
 * });
 */
export function useCreateWorksheetMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorksheetMutation, CreateWorksheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorksheetMutation, CreateWorksheetMutationVariables>(CreateWorksheetDocument, options);
      }
export type CreateWorksheetMutationHookResult = ReturnType<typeof useCreateWorksheetMutation>;
export type CreateWorksheetMutationResult = Apollo.MutationResult<CreateWorksheetMutation>;
export type CreateWorksheetMutationOptions = Apollo.BaseMutationOptions<CreateWorksheetMutation, CreateWorksheetMutationVariables>;
export const DeleteCourseCascadeDocument = gql`
    mutation DeleteCourseCascade($id: ID!) {
  deleteCourseCascade(id: $id) {
    success
    message
  }
}
    `;
export type DeleteCourseCascadeMutationFn = Apollo.MutationFunction<DeleteCourseCascadeMutation, DeleteCourseCascadeMutationVariables>;

/**
 * __useDeleteCourseCascadeMutation__
 *
 * To run a mutation, you first call `useDeleteCourseCascadeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCourseCascadeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCourseCascadeMutation, { data, loading, error }] = useDeleteCourseCascadeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCourseCascadeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCourseCascadeMutation, DeleteCourseCascadeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCourseCascadeMutation, DeleteCourseCascadeMutationVariables>(DeleteCourseCascadeDocument, options);
      }
export type DeleteCourseCascadeMutationHookResult = ReturnType<typeof useDeleteCourseCascadeMutation>;
export type DeleteCourseCascadeMutationResult = Apollo.MutationResult<DeleteCourseCascadeMutation>;
export type DeleteCourseCascadeMutationOptions = Apollo.BaseMutationOptions<DeleteCourseCascadeMutation, DeleteCourseCascadeMutationVariables>;
export const CreateCourseDocument = gql`
    mutation CreateCourse($name: String!, $learningStandards: String, $lengthInWeeks: Float, $objectives: [String!], $parentSchoolId: String!, $cost: Float) {
  createCourse(
    course: {name: $name, learningStandards: $learningStandards, lengthInWeeks: $lengthInWeeks, objectives: $objectives, parentSchoolId: $parentSchoolId, cost: $cost}
  ) {
    success
    message
    data {
      name
      learningStandards
      lengthInWeeks
      objectives
      cost
    }
  }
}
    `;
export type CreateCourseMutationFn = Apollo.MutationFunction<CreateCourseMutation, CreateCourseMutationVariables>;

/**
 * __useCreateCourseMutation__
 *
 * To run a mutation, you first call `useCreateCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCourseMutation, { data, loading, error }] = useCreateCourseMutation({
 *   variables: {
 *      name: // value for 'name'
 *      learningStandards: // value for 'learningStandards'
 *      lengthInWeeks: // value for 'lengthInWeeks'
 *      objectives: // value for 'objectives'
 *      parentSchoolId: // value for 'parentSchoolId'
 *      cost: // value for 'cost'
 *   },
 * });
 */
export function useCreateCourseMutation(baseOptions?: Apollo.MutationHookOptions<CreateCourseMutation, CreateCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCourseMutation, CreateCourseMutationVariables>(CreateCourseDocument, options);
      }
export type CreateCourseMutationHookResult = ReturnType<typeof useCreateCourseMutation>;
export type CreateCourseMutationResult = Apollo.MutationResult<CreateCourseMutation>;
export type CreateCourseMutationOptions = Apollo.BaseMutationOptions<CreateCourseMutation, CreateCourseMutationVariables>;
export const UpdateCourseDocument = gql`
    mutation UpdateCourse($id: ID!, $course: UpdateCourseInput!) {
  updateCourse(id: $id, course: $course) {
    success
    message
    data {
      name
      course_code
      isDraft
      isEnrollmentAvailable
    }
  }
}
    `;
export type UpdateCourseMutationFn = Apollo.MutationFunction<UpdateCourseMutation, UpdateCourseMutationVariables>;

/**
 * __useUpdateCourseMutation__
 *
 * To run a mutation, you first call `useUpdateCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCourseMutation, { data, loading, error }] = useUpdateCourseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      course: // value for 'course'
 *   },
 * });
 */
export function useUpdateCourseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCourseMutation, UpdateCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCourseMutation, UpdateCourseMutationVariables>(UpdateCourseDocument, options);
      }
export type UpdateCourseMutationHookResult = ReturnType<typeof useUpdateCourseMutation>;
export type UpdateCourseMutationResult = Apollo.MutationResult<UpdateCourseMutation>;
export type UpdateCourseMutationOptions = Apollo.BaseMutationOptions<UpdateCourseMutation, UpdateCourseMutationVariables>;
export const DeleteModuleCascadeDocument = gql`
    mutation DeleteModuleCascade($id: ID!) {
  deleteModuleCascade(id: $id) {
    success
    message
  }
}
    `;
export type DeleteModuleCascadeMutationFn = Apollo.MutationFunction<DeleteModuleCascadeMutation, DeleteModuleCascadeMutationVariables>;

/**
 * __useDeleteModuleCascadeMutation__
 *
 * To run a mutation, you first call `useDeleteModuleCascadeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteModuleCascadeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteModuleCascadeMutation, { data, loading, error }] = useDeleteModuleCascadeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteModuleCascadeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteModuleCascadeMutation, DeleteModuleCascadeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteModuleCascadeMutation, DeleteModuleCascadeMutationVariables>(DeleteModuleCascadeDocument, options);
      }
export type DeleteModuleCascadeMutationHookResult = ReturnType<typeof useDeleteModuleCascadeMutation>;
export type DeleteModuleCascadeMutationResult = Apollo.MutationResult<DeleteModuleCascadeMutation>;
export type DeleteModuleCascadeMutationOptions = Apollo.BaseMutationOptions<DeleteModuleCascadeMutation, DeleteModuleCascadeMutationVariables>;
export const CreateModuleDocument = gql`
    mutation CreateModule($title: String!, $parentCourseId: ID!, $description: String, $thumbnail: String) {
  createModule(
    module: {title: $title, parentCourseId: $parentCourseId, description: $description, thumbnail: $thumbnail}
  ) {
    success
    message
    data {
      title
      description
      thumbnail
    }
  }
}
    `;
export type CreateModuleMutationFn = Apollo.MutationFunction<CreateModuleMutation, CreateModuleMutationVariables>;

/**
 * __useCreateModuleMutation__
 *
 * To run a mutation, you first call `useCreateModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createModuleMutation, { data, loading, error }] = useCreateModuleMutation({
 *   variables: {
 *      title: // value for 'title'
 *      parentCourseId: // value for 'parentCourseId'
 *      description: // value for 'description'
 *      thumbnail: // value for 'thumbnail'
 *   },
 * });
 */
export function useCreateModuleMutation(baseOptions?: Apollo.MutationHookOptions<CreateModuleMutation, CreateModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateModuleMutation, CreateModuleMutationVariables>(CreateModuleDocument, options);
      }
export type CreateModuleMutationHookResult = ReturnType<typeof useCreateModuleMutation>;
export type CreateModuleMutationResult = Apollo.MutationResult<CreateModuleMutation>;
export type CreateModuleMutationOptions = Apollo.BaseMutationOptions<CreateModuleMutation, CreateModuleMutationVariables>;
export const UpdateModuleDocument = gql`
    mutation UpdateModule($id: ID!, $title: String, $description: String, $thumbnail: String) {
  updateModule(
    id: $id
    module: {title: $title, description: $description, thumbnail: $thumbnail}
  ) {
    success
    message
    data {
      title
      description
      thumbnail
    }
  }
}
    `;
export type UpdateModuleMutationFn = Apollo.MutationFunction<UpdateModuleMutation, UpdateModuleMutationVariables>;

/**
 * __useUpdateModuleMutation__
 *
 * To run a mutation, you first call `useUpdateModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModuleMutation, { data, loading, error }] = useUpdateModuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      thumbnail: // value for 'thumbnail'
 *   },
 * });
 */
export function useUpdateModuleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateModuleMutation, UpdateModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateModuleMutation, UpdateModuleMutationVariables>(UpdateModuleDocument, options);
      }
export type UpdateModuleMutationHookResult = ReturnType<typeof useUpdateModuleMutation>;
export type UpdateModuleMutationResult = Apollo.MutationResult<UpdateModuleMutation>;
export type UpdateModuleMutationOptions = Apollo.BaseMutationOptions<UpdateModuleMutation, UpdateModuleMutationVariables>;
export const CreatePageDocument = gql`
    mutation CreatePage($title: String!, $body: String, $parentModuleId: ID!) {
  createPage(page: {title: $title, body: $body, parentModuleId: $parentModuleId}) {
    success
    message
    data {
      title
      body
    }
  }
}
    `;
export type CreatePageMutationFn = Apollo.MutationFunction<CreatePageMutation, CreatePageMutationVariables>;

/**
 * __useCreatePageMutation__
 *
 * To run a mutation, you first call `useCreatePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPageMutation, { data, loading, error }] = useCreatePageMutation({
 *   variables: {
 *      title: // value for 'title'
 *      body: // value for 'body'
 *      parentModuleId: // value for 'parentModuleId'
 *   },
 * });
 */
export function useCreatePageMutation(baseOptions?: Apollo.MutationHookOptions<CreatePageMutation, CreatePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePageMutation, CreatePageMutationVariables>(CreatePageDocument, options);
      }
export type CreatePageMutationHookResult = ReturnType<typeof useCreatePageMutation>;
export type CreatePageMutationResult = Apollo.MutationResult<CreatePageMutation>;
export type CreatePageMutationOptions = Apollo.BaseMutationOptions<CreatePageMutation, CreatePageMutationVariables>;
export const DeletePageDocument = gql`
    mutation DeletePage($id: ID!) {
  deletePage(id: $id) {
    success
    message
  }
}
    `;
export type DeletePageMutationFn = Apollo.MutationFunction<DeletePageMutation, DeletePageMutationVariables>;

/**
 * __useDeletePageMutation__
 *
 * To run a mutation, you first call `useDeletePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePageMutation, { data, loading, error }] = useDeletePageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePageMutation(baseOptions?: Apollo.MutationHookOptions<DeletePageMutation, DeletePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePageMutation, DeletePageMutationVariables>(DeletePageDocument, options);
      }
export type DeletePageMutationHookResult = ReturnType<typeof useDeletePageMutation>;
export type DeletePageMutationResult = Apollo.MutationResult<DeletePageMutation>;
export type DeletePageMutationOptions = Apollo.BaseMutationOptions<DeletePageMutation, DeletePageMutationVariables>;
export const UpdatePageDocument = gql`
    mutation UpdatePage($id: ID!, $title: String, $body: String) {
  updatePage(id: $id, page: {title: $title, body: $body}) {
    success
    message
    data {
      title
      body
    }
  }
}
    `;
export type UpdatePageMutationFn = Apollo.MutationFunction<UpdatePageMutation, UpdatePageMutationVariables>;

/**
 * __useUpdatePageMutation__
 *
 * To run a mutation, you first call `useUpdatePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageMutation, { data, loading, error }] = useUpdatePageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdatePageMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageMutation, UpdatePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageMutation, UpdatePageMutationVariables>(UpdatePageDocument, options);
      }
export type UpdatePageMutationHookResult = ReturnType<typeof useUpdatePageMutation>;
export type UpdatePageMutationResult = Apollo.MutationResult<UpdatePageMutation>;
export type UpdatePageMutationOptions = Apollo.BaseMutationOptions<UpdatePageMutation, UpdatePageMutationVariables>;
export const DeleteAssessmentDocument = gql`
    mutation DeleteAssessment($id: ID!) {
  deleteAssessment(id: $id) {
    success
    message
    data {
      id
    }
  }
}
    `;
export type DeleteAssessmentMutationFn = Apollo.MutationFunction<DeleteAssessmentMutation, DeleteAssessmentMutationVariables>;

/**
 * __useDeleteAssessmentMutation__
 *
 * To run a mutation, you first call `useDeleteAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssessmentMutation, { data, loading, error }] = useDeleteAssessmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAssessmentMutation, DeleteAssessmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAssessmentMutation, DeleteAssessmentMutationVariables>(DeleteAssessmentDocument, options);
      }
export type DeleteAssessmentMutationHookResult = ReturnType<typeof useDeleteAssessmentMutation>;
export type DeleteAssessmentMutationResult = Apollo.MutationResult<DeleteAssessmentMutation>;
export type DeleteAssessmentMutationOptions = Apollo.BaseMutationOptions<DeleteAssessmentMutation, DeleteAssessmentMutationVariables>;
export const DeleteAssignmentDocument = gql`
    mutation DeleteAssignment($id: ID!) {
  deleteAssignment(id: $id) {
    success
    data {
      id
    }
    count
  }
}
    `;
export type DeleteAssignmentMutationFn = Apollo.MutationFunction<DeleteAssignmentMutation, DeleteAssignmentMutationVariables>;

/**
 * __useDeleteAssignmentMutation__
 *
 * To run a mutation, you first call `useDeleteAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssignmentMutation, { data, loading, error }] = useDeleteAssignmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAssignmentMutation, DeleteAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAssignmentMutation, DeleteAssignmentMutationVariables>(DeleteAssignmentDocument, options);
      }
export type DeleteAssignmentMutationHookResult = ReturnType<typeof useDeleteAssignmentMutation>;
export type DeleteAssignmentMutationResult = Apollo.MutationResult<DeleteAssignmentMutation>;
export type DeleteAssignmentMutationOptions = Apollo.BaseMutationOptions<DeleteAssignmentMutation, DeleteAssignmentMutationVariables>;
export const EditAssignmentDocument = gql`
    mutation EditAssignment($id: ID!, $assignment: EditAssignmentInput!) {
  editAssignment(id: $id, assignment: $assignment) {
    success
    data {
      id
      name
      due_date
      description
      files {
        id
        fileName
        fileURL
        created
        status
      }
      videoUrl
      enableStudentFileUpload
    }
    message
  }
}
    `;
export type EditAssignmentMutationFn = Apollo.MutationFunction<EditAssignmentMutation, EditAssignmentMutationVariables>;

/**
 * __useEditAssignmentMutation__
 *
 * To run a mutation, you first call `useEditAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAssignmentMutation, { data, loading, error }] = useEditAssignmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      assignment: // value for 'assignment'
 *   },
 * });
 */
export function useEditAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<EditAssignmentMutation, EditAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditAssignmentMutation, EditAssignmentMutationVariables>(EditAssignmentDocument, options);
      }
export type EditAssignmentMutationHookResult = ReturnType<typeof useEditAssignmentMutation>;
export type EditAssignmentMutationResult = Apollo.MutationResult<EditAssignmentMutation>;
export type EditAssignmentMutationOptions = Apollo.BaseMutationOptions<EditAssignmentMutation, EditAssignmentMutationVariables>;
export const EditCourseDocument = gql`
    mutation EditCourse($id: ID!, $course: EditCourseInput!) {
  editCourse(id: $id, course: $course) {
    success
    message
    data {
      id
      name
      course_code
      learningStandards
      lengthInWeeks
      objectives
      is_elective
      cost
      isDraft
      description
      targetAudience
      thumbnail
    }
  }
}
    `;
export type EditCourseMutationFn = Apollo.MutationFunction<EditCourseMutation, EditCourseMutationVariables>;

/**
 * __useEditCourseMutation__
 *
 * To run a mutation, you first call `useEditCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCourseMutation, { data, loading, error }] = useEditCourseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      course: // value for 'course'
 *   },
 * });
 */
export function useEditCourseMutation(baseOptions?: Apollo.MutationHookOptions<EditCourseMutation, EditCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCourseMutation, EditCourseMutationVariables>(EditCourseDocument, options);
      }
export type EditCourseMutationHookResult = ReturnType<typeof useEditCourseMutation>;
export type EditCourseMutationResult = Apollo.MutationResult<EditCourseMutation>;
export type EditCourseMutationOptions = Apollo.BaseMutationOptions<EditCourseMutation, EditCourseMutationVariables>;
export const GenerateAssessmentQuestionsPreviewDocument = gql`
    mutation GenerateAssessmentQuestionsPreview($input: GenerateAssessmentQuestionsPreviewInput!) {
  generateAssessmentQuestionsPreview(input: $input) {
    success
    message
    count
    mcqQuestions {
      question
      choices
      correctChoiceIndices
      explanation
      totalScore
      order
    }
    socraticQuestions {
      aiTutorId
      question
      totalScore
      rubrics {
        component
        points
      }
    }
  }
}
    `;
export type GenerateAssessmentQuestionsPreviewMutationFn = Apollo.MutationFunction<GenerateAssessmentQuestionsPreviewMutation, GenerateAssessmentQuestionsPreviewMutationVariables>;

/**
 * __useGenerateAssessmentQuestionsPreviewMutation__
 *
 * To run a mutation, you first call `useGenerateAssessmentQuestionsPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAssessmentQuestionsPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAssessmentQuestionsPreviewMutation, { data, loading, error }] = useGenerateAssessmentQuestionsPreviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateAssessmentQuestionsPreviewMutation(baseOptions?: Apollo.MutationHookOptions<GenerateAssessmentQuestionsPreviewMutation, GenerateAssessmentQuestionsPreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateAssessmentQuestionsPreviewMutation, GenerateAssessmentQuestionsPreviewMutationVariables>(GenerateAssessmentQuestionsPreviewDocument, options);
      }
export type GenerateAssessmentQuestionsPreviewMutationHookResult = ReturnType<typeof useGenerateAssessmentQuestionsPreviewMutation>;
export type GenerateAssessmentQuestionsPreviewMutationResult = Apollo.MutationResult<GenerateAssessmentQuestionsPreviewMutation>;
export type GenerateAssessmentQuestionsPreviewMutationOptions = Apollo.BaseMutationOptions<GenerateAssessmentQuestionsPreviewMutation, GenerateAssessmentQuestionsPreviewMutationVariables>;
export const GenerateCourseExportDocument = gql`
    mutation GenerateCourseExport($courseId: ID!) {
  generateCourseExport(courseId: $courseId) {
    success
    message
    data {
      jobId
    }
  }
}
    `;
export type GenerateCourseExportMutationFn = Apollo.MutationFunction<GenerateCourseExportMutation, GenerateCourseExportMutationVariables>;

/**
 * __useGenerateCourseExportMutation__
 *
 * To run a mutation, you first call `useGenerateCourseExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCourseExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCourseExportMutation, { data, loading, error }] = useGenerateCourseExportMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGenerateCourseExportMutation(baseOptions?: Apollo.MutationHookOptions<GenerateCourseExportMutation, GenerateCourseExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateCourseExportMutation, GenerateCourseExportMutationVariables>(GenerateCourseExportDocument, options);
      }
export type GenerateCourseExportMutationHookResult = ReturnType<typeof useGenerateCourseExportMutation>;
export type GenerateCourseExportMutationResult = Apollo.MutationResult<GenerateCourseExportMutation>;
export type GenerateCourseExportMutationOptions = Apollo.BaseMutationOptions<GenerateCourseExportMutation, GenerateCourseExportMutationVariables>;
export const GenerateDueDatesForActivitiesDocument = gql`
    mutation GenerateDueDatesForActivities($courseId: ID!) {
  generateDueDatesForActivities(courseId: $courseId) {
    success
    data {
      id
    }
  }
}
    `;
export type GenerateDueDatesForActivitiesMutationFn = Apollo.MutationFunction<GenerateDueDatesForActivitiesMutation, GenerateDueDatesForActivitiesMutationVariables>;

/**
 * __useGenerateDueDatesForActivitiesMutation__
 *
 * To run a mutation, you first call `useGenerateDueDatesForActivitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateDueDatesForActivitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateDueDatesForActivitiesMutation, { data, loading, error }] = useGenerateDueDatesForActivitiesMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGenerateDueDatesForActivitiesMutation(baseOptions?: Apollo.MutationHookOptions<GenerateDueDatesForActivitiesMutation, GenerateDueDatesForActivitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateDueDatesForActivitiesMutation, GenerateDueDatesForActivitiesMutationVariables>(GenerateDueDatesForActivitiesDocument, options);
      }
export type GenerateDueDatesForActivitiesMutationHookResult = ReturnType<typeof useGenerateDueDatesForActivitiesMutation>;
export type GenerateDueDatesForActivitiesMutationResult = Apollo.MutationResult<GenerateDueDatesForActivitiesMutation>;
export type GenerateDueDatesForActivitiesMutationOptions = Apollo.BaseMutationOptions<GenerateDueDatesForActivitiesMutation, GenerateDueDatesForActivitiesMutationVariables>;
export const GenerateModuleThumbnailsDocument = gql`
    mutation GenerateModuleThumbnails($courseId: ID!) {
  generateModuleThumbnails(courseId: $courseId) {
    success
    message
    data {
      id
      title
      thumbnail
    }
    count
  }
}
    `;
export type GenerateModuleThumbnailsMutationFn = Apollo.MutationFunction<GenerateModuleThumbnailsMutation, GenerateModuleThumbnailsMutationVariables>;

/**
 * __useGenerateModuleThumbnailsMutation__
 *
 * To run a mutation, you first call `useGenerateModuleThumbnailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateModuleThumbnailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateModuleThumbnailsMutation, { data, loading, error }] = useGenerateModuleThumbnailsMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGenerateModuleThumbnailsMutation(baseOptions?: Apollo.MutationHookOptions<GenerateModuleThumbnailsMutation, GenerateModuleThumbnailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateModuleThumbnailsMutation, GenerateModuleThumbnailsMutationVariables>(GenerateModuleThumbnailsDocument, options);
      }
export type GenerateModuleThumbnailsMutationHookResult = ReturnType<typeof useGenerateModuleThumbnailsMutation>;
export type GenerateModuleThumbnailsMutationResult = Apollo.MutationResult<GenerateModuleThumbnailsMutation>;
export type GenerateModuleThumbnailsMutationOptions = Apollo.BaseMutationOptions<GenerateModuleThumbnailsMutation, GenerateModuleThumbnailsMutationVariables>;
export const InviteUsersToEnrollInCourseDocument = gql`
    mutation InviteUsersToEnrollInCourse($input: InviteUsersToEnrollInCourseInput!) {
  inviteUsersToEnrollInCourse(input: $input) {
    success
    data {
      email
      id
    }
    count
  }
}
    `;
export type InviteUsersToEnrollInCourseMutationFn = Apollo.MutationFunction<InviteUsersToEnrollInCourseMutation, InviteUsersToEnrollInCourseMutationVariables>;

/**
 * __useInviteUsersToEnrollInCourseMutation__
 *
 * To run a mutation, you first call `useInviteUsersToEnrollInCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUsersToEnrollInCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUsersToEnrollInCourseMutation, { data, loading, error }] = useInviteUsersToEnrollInCourseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteUsersToEnrollInCourseMutation(baseOptions?: Apollo.MutationHookOptions<InviteUsersToEnrollInCourseMutation, InviteUsersToEnrollInCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUsersToEnrollInCourseMutation, InviteUsersToEnrollInCourseMutationVariables>(InviteUsersToEnrollInCourseDocument, options);
      }
export type InviteUsersToEnrollInCourseMutationHookResult = ReturnType<typeof useInviteUsersToEnrollInCourseMutation>;
export type InviteUsersToEnrollInCourseMutationResult = Apollo.MutationResult<InviteUsersToEnrollInCourseMutation>;
export type InviteUsersToEnrollInCourseMutationOptions = Apollo.BaseMutationOptions<InviteUsersToEnrollInCourseMutation, InviteUsersToEnrollInCourseMutationVariables>;
export const CreateMcqQuestionDocument = gql`
    mutation CreateMcqQuestion($input: CreateMcqQuestionInput!) {
  createMcqQuestion(input: $input) {
    success
    message
    data {
      id
      question
      choices
      correctChoiceIndices
      explanation
      totalScore
      order
    }
  }
}
    `;
export type CreateMcqQuestionMutationFn = Apollo.MutationFunction<CreateMcqQuestionMutation, CreateMcqQuestionMutationVariables>;

/**
 * __useCreateMcqQuestionMutation__
 *
 * To run a mutation, you first call `useCreateMcqQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMcqQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMcqQuestionMutation, { data, loading, error }] = useCreateMcqQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMcqQuestionMutation(baseOptions?: Apollo.MutationHookOptions<CreateMcqQuestionMutation, CreateMcqQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMcqQuestionMutation, CreateMcqQuestionMutationVariables>(CreateMcqQuestionDocument, options);
      }
export type CreateMcqQuestionMutationHookResult = ReturnType<typeof useCreateMcqQuestionMutation>;
export type CreateMcqQuestionMutationResult = Apollo.MutationResult<CreateMcqQuestionMutation>;
export type CreateMcqQuestionMutationOptions = Apollo.BaseMutationOptions<CreateMcqQuestionMutation, CreateMcqQuestionMutationVariables>;
export const UpdateMcqQuestionDocument = gql`
    mutation UpdateMcqQuestion($mcqQuestionId: ID!, $assessmentId: ID!, $input: UpdateMcqQuestionInput!) {
  updateMcqQuestion(
    mcqQuestionId: $mcqQuestionId
    assessmentId: $assessmentId
    input: $input
  ) {
    success
    message
    data {
      id
      question
      choices
      correctChoiceIndices
      explanation
      totalScore
      order
    }
  }
}
    `;
export type UpdateMcqQuestionMutationFn = Apollo.MutationFunction<UpdateMcqQuestionMutation, UpdateMcqQuestionMutationVariables>;

/**
 * __useUpdateMcqQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateMcqQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMcqQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMcqQuestionMutation, { data, loading, error }] = useUpdateMcqQuestionMutation({
 *   variables: {
 *      mcqQuestionId: // value for 'mcqQuestionId'
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMcqQuestionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMcqQuestionMutation, UpdateMcqQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMcqQuestionMutation, UpdateMcqQuestionMutationVariables>(UpdateMcqQuestionDocument, options);
      }
export type UpdateMcqQuestionMutationHookResult = ReturnType<typeof useUpdateMcqQuestionMutation>;
export type UpdateMcqQuestionMutationResult = Apollo.MutationResult<UpdateMcqQuestionMutation>;
export type UpdateMcqQuestionMutationOptions = Apollo.BaseMutationOptions<UpdateMcqQuestionMutation, UpdateMcqQuestionMutationVariables>;
export const DeleteMcqQuestionDocument = gql`
    mutation DeleteMcqQuestion($mcqQuestionId: ID!, $assessmentId: ID!) {
  deleteMcqQuestion(mcqQuestionId: $mcqQuestionId, assessmentId: $assessmentId) {
    success
    message
    data {
      id
    }
  }
}
    `;
export type DeleteMcqQuestionMutationFn = Apollo.MutationFunction<DeleteMcqQuestionMutation, DeleteMcqQuestionMutationVariables>;

/**
 * __useDeleteMcqQuestionMutation__
 *
 * To run a mutation, you first call `useDeleteMcqQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMcqQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMcqQuestionMutation, { data, loading, error }] = useDeleteMcqQuestionMutation({
 *   variables: {
 *      mcqQuestionId: // value for 'mcqQuestionId'
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useDeleteMcqQuestionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMcqQuestionMutation, DeleteMcqQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMcqQuestionMutation, DeleteMcqQuestionMutationVariables>(DeleteMcqQuestionDocument, options);
      }
export type DeleteMcqQuestionMutationHookResult = ReturnType<typeof useDeleteMcqQuestionMutation>;
export type DeleteMcqQuestionMutationResult = Apollo.MutationResult<DeleteMcqQuestionMutation>;
export type DeleteMcqQuestionMutationOptions = Apollo.BaseMutationOptions<DeleteMcqQuestionMutation, DeleteMcqQuestionMutationVariables>;
export const MoveActivityDocument = gql`
    mutation MoveActivity($activityId: ID!, $sourceModuleId: ID!, $targetModuleId: ID!, $activityType: String!) {
  moveActivity(
    input: {activityId: $activityId, sourceModuleId: $sourceModuleId, targetModuleId: $targetModuleId, activityType: $activityType}
  ) {
    success
    message
    data {
      id
      title
      resourceOrder
    }
    count
  }
}
    `;
export type MoveActivityMutationFn = Apollo.MutationFunction<MoveActivityMutation, MoveActivityMutationVariables>;

/**
 * __useMoveActivityMutation__
 *
 * To run a mutation, you first call `useMoveActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveActivityMutation, { data, loading, error }] = useMoveActivityMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      sourceModuleId: // value for 'sourceModuleId'
 *      targetModuleId: // value for 'targetModuleId'
 *      activityType: // value for 'activityType'
 *   },
 * });
 */
export function useMoveActivityMutation(baseOptions?: Apollo.MutationHookOptions<MoveActivityMutation, MoveActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveActivityMutation, MoveActivityMutationVariables>(MoveActivityDocument, options);
      }
export type MoveActivityMutationHookResult = ReturnType<typeof useMoveActivityMutation>;
export type MoveActivityMutationResult = Apollo.MutationResult<MoveActivityMutation>;
export type MoveActivityMutationOptions = Apollo.BaseMutationOptions<MoveActivityMutation, MoveActivityMutationVariables>;
export const ReGenerateCourseImageDocument = gql`
    mutation ReGenerateCourseImage($courseId: ID!) {
  reGenerateCourseImage(courseId: $courseId) {
    success
    data {
      id
    }
  }
}
    `;
export type ReGenerateCourseImageMutationFn = Apollo.MutationFunction<ReGenerateCourseImageMutation, ReGenerateCourseImageMutationVariables>;

/**
 * __useReGenerateCourseImageMutation__
 *
 * To run a mutation, you first call `useReGenerateCourseImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReGenerateCourseImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reGenerateCourseImageMutation, { data, loading, error }] = useReGenerateCourseImageMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useReGenerateCourseImageMutation(baseOptions?: Apollo.MutationHookOptions<ReGenerateCourseImageMutation, ReGenerateCourseImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReGenerateCourseImageMutation, ReGenerateCourseImageMutationVariables>(ReGenerateCourseImageDocument, options);
      }
export type ReGenerateCourseImageMutationHookResult = ReturnType<typeof useReGenerateCourseImageMutation>;
export type ReGenerateCourseImageMutationResult = Apollo.MutationResult<ReGenerateCourseImageMutation>;
export type ReGenerateCourseImageMutationOptions = Apollo.BaseMutationOptions<ReGenerateCourseImageMutation, ReGenerateCourseImageMutationVariables>;
export const RemovePreRequisitesFromCourseDocument = gql`
    mutation RemovePreRequisitesFromCourse($courseId: ID!, $preRequisiteIds: [ID!]!) {
  removePreRequisitesFromCourse(
    courseId: $courseId
    preRequisiteIds: $preRequisiteIds
  ) {
    success
    data {
      id
    }
    count
  }
}
    `;
export type RemovePreRequisitesFromCourseMutationFn = Apollo.MutationFunction<RemovePreRequisitesFromCourseMutation, RemovePreRequisitesFromCourseMutationVariables>;

/**
 * __useRemovePreRequisitesFromCourseMutation__
 *
 * To run a mutation, you first call `useRemovePreRequisitesFromCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePreRequisitesFromCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePreRequisitesFromCourseMutation, { data, loading, error }] = useRemovePreRequisitesFromCourseMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      preRequisiteIds: // value for 'preRequisiteIds'
 *   },
 * });
 */
export function useRemovePreRequisitesFromCourseMutation(baseOptions?: Apollo.MutationHookOptions<RemovePreRequisitesFromCourseMutation, RemovePreRequisitesFromCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePreRequisitesFromCourseMutation, RemovePreRequisitesFromCourseMutationVariables>(RemovePreRequisitesFromCourseDocument, options);
      }
export type RemovePreRequisitesFromCourseMutationHookResult = ReturnType<typeof useRemovePreRequisitesFromCourseMutation>;
export type RemovePreRequisitesFromCourseMutationResult = Apollo.MutationResult<RemovePreRequisitesFromCourseMutation>;
export type RemovePreRequisitesFromCourseMutationOptions = Apollo.BaseMutationOptions<RemovePreRequisitesFromCourseMutation, RemovePreRequisitesFromCourseMutationVariables>;
export const RemoveStudentsFromCourseDocument = gql`
    mutation RemoveStudentsFromCourse($courseId: ID!, $studentIds: [ID!]!) {
  removeStudentsFromCourse(courseId: $courseId, studentIds: $studentIds) {
    success
    data {
      id
      name
    }
    count
  }
}
    `;
export type RemoveStudentsFromCourseMutationFn = Apollo.MutationFunction<RemoveStudentsFromCourseMutation, RemoveStudentsFromCourseMutationVariables>;

/**
 * __useRemoveStudentsFromCourseMutation__
 *
 * To run a mutation, you first call `useRemoveStudentsFromCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveStudentsFromCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeStudentsFromCourseMutation, { data, loading, error }] = useRemoveStudentsFromCourseMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      studentIds: // value for 'studentIds'
 *   },
 * });
 */
export function useRemoveStudentsFromCourseMutation(baseOptions?: Apollo.MutationHookOptions<RemoveStudentsFromCourseMutation, RemoveStudentsFromCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveStudentsFromCourseMutation, RemoveStudentsFromCourseMutationVariables>(RemoveStudentsFromCourseDocument, options);
      }
export type RemoveStudentsFromCourseMutationHookResult = ReturnType<typeof useRemoveStudentsFromCourseMutation>;
export type RemoveStudentsFromCourseMutationResult = Apollo.MutationResult<RemoveStudentsFromCourseMutation>;
export type RemoveStudentsFromCourseMutationOptions = Apollo.BaseMutationOptions<RemoveStudentsFromCourseMutation, RemoveStudentsFromCourseMutationVariables>;
export const RequestRosterExportDocument = gql`
    mutation RequestRosterExport($courseId: ID!) {
  requestRosterExport(courseId: $courseId) {
    success
    message
    data {
      jobId
    }
  }
}
    `;
export type RequestRosterExportMutationFn = Apollo.MutationFunction<RequestRosterExportMutation, RequestRosterExportMutationVariables>;

/**
 * __useRequestRosterExportMutation__
 *
 * To run a mutation, you first call `useRequestRosterExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestRosterExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestRosterExportMutation, { data, loading, error }] = useRequestRosterExportMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useRequestRosterExportMutation(baseOptions?: Apollo.MutationHookOptions<RequestRosterExportMutation, RequestRosterExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestRosterExportMutation, RequestRosterExportMutationVariables>(RequestRosterExportDocument, options);
      }
export type RequestRosterExportMutationHookResult = ReturnType<typeof useRequestRosterExportMutation>;
export type RequestRosterExportMutationResult = Apollo.MutationResult<RequestRosterExportMutation>;
export type RequestRosterExportMutationOptions = Apollo.BaseMutationOptions<RequestRosterExportMutation, RequestRosterExportMutationVariables>;
export const RequestSubmissionExportDocument = gql`
    mutation RequestSubmissionExport {
  requestSubmissionExport {
    success
    message
    data {
      jobId
    }
  }
}
    `;
export type RequestSubmissionExportMutationFn = Apollo.MutationFunction<RequestSubmissionExportMutation, RequestSubmissionExportMutationVariables>;

/**
 * __useRequestSubmissionExportMutation__
 *
 * To run a mutation, you first call `useRequestSubmissionExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestSubmissionExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestSubmissionExportMutation, { data, loading, error }] = useRequestSubmissionExportMutation({
 *   variables: {
 *   },
 * });
 */
export function useRequestSubmissionExportMutation(baseOptions?: Apollo.MutationHookOptions<RequestSubmissionExportMutation, RequestSubmissionExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestSubmissionExportMutation, RequestSubmissionExportMutationVariables>(RequestSubmissionExportDocument, options);
      }
export type RequestSubmissionExportMutationHookResult = ReturnType<typeof useRequestSubmissionExportMutation>;
export type RequestSubmissionExportMutationResult = Apollo.MutationResult<RequestSubmissionExportMutation>;
export type RequestSubmissionExportMutationOptions = Apollo.BaseMutationOptions<RequestSubmissionExportMutation, RequestSubmissionExportMutationVariables>;
export const ResetAiTutorDocument = gql`
    mutation ResetAITutor($input: ResetAiTutorInput!) {
  resetAITutor(input: $input) {
    success
    message
  }
}
    `;
export type ResetAiTutorMutationFn = Apollo.MutationFunction<ResetAiTutorMutation, ResetAiTutorMutationVariables>;

/**
 * __useResetAiTutorMutation__
 *
 * To run a mutation, you first call `useResetAiTutorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetAiTutorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetAiTutorMutation, { data, loading, error }] = useResetAiTutorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetAiTutorMutation(baseOptions?: Apollo.MutationHookOptions<ResetAiTutorMutation, ResetAiTutorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetAiTutorMutation, ResetAiTutorMutationVariables>(ResetAiTutorDocument, options);
      }
export type ResetAiTutorMutationHookResult = ReturnType<typeof useResetAiTutorMutation>;
export type ResetAiTutorMutationResult = Apollo.MutationResult<ResetAiTutorMutation>;
export type ResetAiTutorMutationOptions = Apollo.BaseMutationOptions<ResetAiTutorMutation, ResetAiTutorMutationVariables>;
export const CreateSocraticQuestionDocument = gql`
    mutation CreateSocraticQuestion($input: CreateSocraticQuestionInput!) {
  createSocraticQuestion(input: $input) {
    success
    message
    data {
      id
      question
      totalScore
      rubrics {
        id
        component
        points
      }
    }
  }
}
    `;
export type CreateSocraticQuestionMutationFn = Apollo.MutationFunction<CreateSocraticQuestionMutation, CreateSocraticQuestionMutationVariables>;

/**
 * __useCreateSocraticQuestionMutation__
 *
 * To run a mutation, you first call `useCreateSocraticQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSocraticQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSocraticQuestionMutation, { data, loading, error }] = useCreateSocraticQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSocraticQuestionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSocraticQuestionMutation, CreateSocraticQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSocraticQuestionMutation, CreateSocraticQuestionMutationVariables>(CreateSocraticQuestionDocument, options);
      }
export type CreateSocraticQuestionMutationHookResult = ReturnType<typeof useCreateSocraticQuestionMutation>;
export type CreateSocraticQuestionMutationResult = Apollo.MutationResult<CreateSocraticQuestionMutation>;
export type CreateSocraticQuestionMutationOptions = Apollo.BaseMutationOptions<CreateSocraticQuestionMutation, CreateSocraticQuestionMutationVariables>;
export const UpdateSocraticQuestionDocument = gql`
    mutation UpdateSocraticQuestion($questionId: ID!, $assessmentId: ID!, $input: UpdateSocraticQuestionInput!) {
  updateSocraticQuestion(
    questionId: $questionId
    assessmentId: $assessmentId
    input: $input
  ) {
    success
    message
    data {
      id
      question
      totalScore
      rubrics {
        id
        component
        points
      }
    }
  }
}
    `;
export type UpdateSocraticQuestionMutationFn = Apollo.MutationFunction<UpdateSocraticQuestionMutation, UpdateSocraticQuestionMutationVariables>;

/**
 * __useUpdateSocraticQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateSocraticQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSocraticQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSocraticQuestionMutation, { data, loading, error }] = useUpdateSocraticQuestionMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSocraticQuestionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSocraticQuestionMutation, UpdateSocraticQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSocraticQuestionMutation, UpdateSocraticQuestionMutationVariables>(UpdateSocraticQuestionDocument, options);
      }
export type UpdateSocraticQuestionMutationHookResult = ReturnType<typeof useUpdateSocraticQuestionMutation>;
export type UpdateSocraticQuestionMutationResult = Apollo.MutationResult<UpdateSocraticQuestionMutation>;
export type UpdateSocraticQuestionMutationOptions = Apollo.BaseMutationOptions<UpdateSocraticQuestionMutation, UpdateSocraticQuestionMutationVariables>;
export const DeleteSocraticQuestionDocument = gql`
    mutation DeleteSocraticQuestion($questionId: ID!, $assessmentId: ID!) {
  deleteSocraticQuestion(questionId: $questionId, assessmentId: $assessmentId) {
    success
    message
    data {
      id
    }
  }
}
    `;
export type DeleteSocraticQuestionMutationFn = Apollo.MutationFunction<DeleteSocraticQuestionMutation, DeleteSocraticQuestionMutationVariables>;

/**
 * __useDeleteSocraticQuestionMutation__
 *
 * To run a mutation, you first call `useDeleteSocraticQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSocraticQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSocraticQuestionMutation, { data, loading, error }] = useDeleteSocraticQuestionMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useDeleteSocraticQuestionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSocraticQuestionMutation, DeleteSocraticQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSocraticQuestionMutation, DeleteSocraticQuestionMutationVariables>(DeleteSocraticQuestionDocument, options);
      }
export type DeleteSocraticQuestionMutationHookResult = ReturnType<typeof useDeleteSocraticQuestionMutation>;
export type DeleteSocraticQuestionMutationResult = Apollo.MutationResult<DeleteSocraticQuestionMutation>;
export type DeleteSocraticQuestionMutationOptions = Apollo.BaseMutationOptions<DeleteSocraticQuestionMutation, DeleteSocraticQuestionMutationVariables>;
export const GenerateSocraticRubricForQuestionDocument = gql`
    mutation GenerateSocraticRubricForQuestion($input: GenerateSocraticRubricInput!) {
  generateSocraticRubricForQuestion(input: $input) {
    success
    message
    totalScore
    rubrics {
      component
      points
    }
  }
}
    `;
export type GenerateSocraticRubricForQuestionMutationFn = Apollo.MutationFunction<GenerateSocraticRubricForQuestionMutation, GenerateSocraticRubricForQuestionMutationVariables>;

/**
 * __useGenerateSocraticRubricForQuestionMutation__
 *
 * To run a mutation, you first call `useGenerateSocraticRubricForQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSocraticRubricForQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSocraticRubricForQuestionMutation, { data, loading, error }] = useGenerateSocraticRubricForQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateSocraticRubricForQuestionMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSocraticRubricForQuestionMutation, GenerateSocraticRubricForQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSocraticRubricForQuestionMutation, GenerateSocraticRubricForQuestionMutationVariables>(GenerateSocraticRubricForQuestionDocument, options);
      }
export type GenerateSocraticRubricForQuestionMutationHookResult = ReturnType<typeof useGenerateSocraticRubricForQuestionMutation>;
export type GenerateSocraticRubricForQuestionMutationResult = Apollo.MutationResult<GenerateSocraticRubricForQuestionMutation>;
export type GenerateSocraticRubricForQuestionMutationOptions = Apollo.BaseMutationOptions<GenerateSocraticRubricForQuestionMutation, GenerateSocraticRubricForQuestionMutationVariables>;
export const SubmitStudentAssignmentDocument = gql`
    mutation submitStudentAssignment($assignmentId: ID!, $files: [FileInput!]!) {
  submitStudentAssignment(assignmentId: $assignmentId, files: $files) {
    success
    message
    data {
      id
    }
  }
}
    `;
export type SubmitStudentAssignmentMutationFn = Apollo.MutationFunction<SubmitStudentAssignmentMutation, SubmitStudentAssignmentMutationVariables>;

/**
 * __useSubmitStudentAssignmentMutation__
 *
 * To run a mutation, you first call `useSubmitStudentAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitStudentAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitStudentAssignmentMutation, { data, loading, error }] = useSubmitStudentAssignmentMutation({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useSubmitStudentAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<SubmitStudentAssignmentMutation, SubmitStudentAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitStudentAssignmentMutation, SubmitStudentAssignmentMutationVariables>(SubmitStudentAssignmentDocument, options);
      }
export type SubmitStudentAssignmentMutationHookResult = ReturnType<typeof useSubmitStudentAssignmentMutation>;
export type SubmitStudentAssignmentMutationResult = Apollo.MutationResult<SubmitStudentAssignmentMutation>;
export type SubmitStudentAssignmentMutationOptions = Apollo.BaseMutationOptions<SubmitStudentAssignmentMutation, SubmitStudentAssignmentMutationVariables>;
export const UpdateAiTutorDocument = gql`
    mutation UpdateAITutor($id: ID!, $aiTutor: UpdateAITutorInput!) {
  updateAITutor(id: $id, aiTutor: $aiTutor) {
    success
    message
    data {
      id
      title
      description
      targetAudience
      dueDate
      objectives {
        objective
        sequence
        id
      }
    }
  }
}
    `;
export type UpdateAiTutorMutationFn = Apollo.MutationFunction<UpdateAiTutorMutation, UpdateAiTutorMutationVariables>;

/**
 * __useUpdateAiTutorMutation__
 *
 * To run a mutation, you first call `useUpdateAiTutorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAiTutorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAiTutorMutation, { data, loading, error }] = useUpdateAiTutorMutation({
 *   variables: {
 *      id: // value for 'id'
 *      aiTutor: // value for 'aiTutor'
 *   },
 * });
 */
export function useUpdateAiTutorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAiTutorMutation, UpdateAiTutorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAiTutorMutation, UpdateAiTutorMutationVariables>(UpdateAiTutorDocument, options);
      }
export type UpdateAiTutorMutationHookResult = ReturnType<typeof useUpdateAiTutorMutation>;
export type UpdateAiTutorMutationResult = Apollo.MutationResult<UpdateAiTutorMutation>;
export type UpdateAiTutorMutationOptions = Apollo.BaseMutationOptions<UpdateAiTutorMutation, UpdateAiTutorMutationVariables>;
export const UpdateAssessmentSubmissionGradeDocument = gql`
    mutation updateAssessmentSubmissionGrade($assessmentSubmissionId: ID!, $updatedGradeEntry: UpdateAssessmentSubmissionUpdatedGrade!, $reviewWithoutAdjustment: Boolean) {
  updateAssessmentSubmissionGrade(
    assessmentSubmissionId: $assessmentSubmissionId
    updatedGradeEntry: $updatedGradeEntry
    reviewWithoutAdjustment: $reviewWithoutAdjustment
  ) {
    success
    message
    data {
      id
    }
  }
}
    `;
export type UpdateAssessmentSubmissionGradeMutationFn = Apollo.MutationFunction<UpdateAssessmentSubmissionGradeMutation, UpdateAssessmentSubmissionGradeMutationVariables>;

/**
 * __useUpdateAssessmentSubmissionGradeMutation__
 *
 * To run a mutation, you first call `useUpdateAssessmentSubmissionGradeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssessmentSubmissionGradeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssessmentSubmissionGradeMutation, { data, loading, error }] = useUpdateAssessmentSubmissionGradeMutation({
 *   variables: {
 *      assessmentSubmissionId: // value for 'assessmentSubmissionId'
 *      updatedGradeEntry: // value for 'updatedGradeEntry'
 *      reviewWithoutAdjustment: // value for 'reviewWithoutAdjustment'
 *   },
 * });
 */
export function useUpdateAssessmentSubmissionGradeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssessmentSubmissionGradeMutation, UpdateAssessmentSubmissionGradeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssessmentSubmissionGradeMutation, UpdateAssessmentSubmissionGradeMutationVariables>(UpdateAssessmentSubmissionGradeDocument, options);
      }
export type UpdateAssessmentSubmissionGradeMutationHookResult = ReturnType<typeof useUpdateAssessmentSubmissionGradeMutation>;
export type UpdateAssessmentSubmissionGradeMutationResult = Apollo.MutationResult<UpdateAssessmentSubmissionGradeMutation>;
export type UpdateAssessmentSubmissionGradeMutationOptions = Apollo.BaseMutationOptions<UpdateAssessmentSubmissionGradeMutation, UpdateAssessmentSubmissionGradeMutationVariables>;
export const UpdateCourseDatesDocument = gql`
    mutation UpdateCourseDates($id: ID!, $input: UpdateCourseDatesInput!) {
  updateCourseDates(id: $id, input: $input) {
    success
    data {
      id
    }
  }
}
    `;
export type UpdateCourseDatesMutationFn = Apollo.MutationFunction<UpdateCourseDatesMutation, UpdateCourseDatesMutationVariables>;

/**
 * __useUpdateCourseDatesMutation__
 *
 * To run a mutation, you first call `useUpdateCourseDatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourseDatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCourseDatesMutation, { data, loading, error }] = useUpdateCourseDatesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCourseDatesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCourseDatesMutation, UpdateCourseDatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCourseDatesMutation, UpdateCourseDatesMutationVariables>(UpdateCourseDatesDocument, options);
      }
export type UpdateCourseDatesMutationHookResult = ReturnType<typeof useUpdateCourseDatesMutation>;
export type UpdateCourseDatesMutationResult = Apollo.MutationResult<UpdateCourseDatesMutation>;
export type UpdateCourseDatesMutationOptions = Apollo.BaseMutationOptions<UpdateCourseDatesMutation, UpdateCourseDatesMutationVariables>;
export const UpdateResourceOrderDocument = gql`
    mutation UpdateResourceOrder($input: UpdateResourceOrderInput!) {
  updateResourceOrder(input: $input) {
    success
    message
    data {
      id
      resourceOrder
    }
  }
}
    `;
export type UpdateResourceOrderMutationFn = Apollo.MutationFunction<UpdateResourceOrderMutation, UpdateResourceOrderMutationVariables>;

/**
 * __useUpdateResourceOrderMutation__
 *
 * To run a mutation, you first call `useUpdateResourceOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourceOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourceOrderMutation, { data, loading, error }] = useUpdateResourceOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateResourceOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResourceOrderMutation, UpdateResourceOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResourceOrderMutation, UpdateResourceOrderMutationVariables>(UpdateResourceOrderDocument, options);
      }
export type UpdateResourceOrderMutationHookResult = ReturnType<typeof useUpdateResourceOrderMutation>;
export type UpdateResourceOrderMutationResult = Apollo.MutationResult<UpdateResourceOrderMutation>;
export type UpdateResourceOrderMutationOptions = Apollo.BaseMutationOptions<UpdateResourceOrderMutation, UpdateResourceOrderMutationVariables>;
export const UpdateStudentAssignmentGradeDocument = gql`
    mutation updateStudentAssignmentGrade($submissionId: ID!, $updatePayload: UpdateStudentAssignmentGradeInput!) {
  updateStudentAssignmentGrade(
    submissionId: $submissionId
    updatePayload: $updatePayload
  ) {
    success
    message
    data {
      id
    }
  }
}
    `;
export type UpdateStudentAssignmentGradeMutationFn = Apollo.MutationFunction<UpdateStudentAssignmentGradeMutation, UpdateStudentAssignmentGradeMutationVariables>;

/**
 * __useUpdateStudentAssignmentGradeMutation__
 *
 * To run a mutation, you first call `useUpdateStudentAssignmentGradeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentAssignmentGradeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentAssignmentGradeMutation, { data, loading, error }] = useUpdateStudentAssignmentGradeMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *      updatePayload: // value for 'updatePayload'
 *   },
 * });
 */
export function useUpdateStudentAssignmentGradeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStudentAssignmentGradeMutation, UpdateStudentAssignmentGradeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStudentAssignmentGradeMutation, UpdateStudentAssignmentGradeMutationVariables>(UpdateStudentAssignmentGradeDocument, options);
      }
export type UpdateStudentAssignmentGradeMutationHookResult = ReturnType<typeof useUpdateStudentAssignmentGradeMutation>;
export type UpdateStudentAssignmentGradeMutationResult = Apollo.MutationResult<UpdateStudentAssignmentGradeMutation>;
export type UpdateStudentAssignmentGradeMutationOptions = Apollo.BaseMutationOptions<UpdateStudentAssignmentGradeMutation, UpdateStudentAssignmentGradeMutationVariables>;
export const AddCoursesToDegreeDocument = gql`
    mutation AddCoursesToDegree($input: AddCoursesToDegreeInput!) {
  addCoursesToDegree(input: $input) {
    success
    message
  }
}
    `;
export type AddCoursesToDegreeMutationFn = Apollo.MutationFunction<AddCoursesToDegreeMutation, AddCoursesToDegreeMutationVariables>;

/**
 * __useAddCoursesToDegreeMutation__
 *
 * To run a mutation, you first call `useAddCoursesToDegreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCoursesToDegreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCoursesToDegreeMutation, { data, loading, error }] = useAddCoursesToDegreeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCoursesToDegreeMutation(baseOptions?: Apollo.MutationHookOptions<AddCoursesToDegreeMutation, AddCoursesToDegreeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCoursesToDegreeMutation, AddCoursesToDegreeMutationVariables>(AddCoursesToDegreeDocument, options);
      }
export type AddCoursesToDegreeMutationHookResult = ReturnType<typeof useAddCoursesToDegreeMutation>;
export type AddCoursesToDegreeMutationResult = Apollo.MutationResult<AddCoursesToDegreeMutation>;
export type AddCoursesToDegreeMutationOptions = Apollo.BaseMutationOptions<AddCoursesToDegreeMutation, AddCoursesToDegreeMutationVariables>;
export const CreateDegreeDocument = gql`
    mutation CreateDegree($name: String!, $schoolId: ID!) {
  createDegree(degree: {name: $name, schoolId: $schoolId}) {
    success
    message
    data {
      id
      name
    }
  }
}
    `;
export type CreateDegreeMutationFn = Apollo.MutationFunction<CreateDegreeMutation, CreateDegreeMutationVariables>;

/**
 * __useCreateDegreeMutation__
 *
 * To run a mutation, you first call `useCreateDegreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDegreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDegreeMutation, { data, loading, error }] = useCreateDegreeMutation({
 *   variables: {
 *      name: // value for 'name'
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useCreateDegreeMutation(baseOptions?: Apollo.MutationHookOptions<CreateDegreeMutation, CreateDegreeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDegreeMutation, CreateDegreeMutationVariables>(CreateDegreeDocument, options);
      }
export type CreateDegreeMutationHookResult = ReturnType<typeof useCreateDegreeMutation>;
export type CreateDegreeMutationResult = Apollo.MutationResult<CreateDegreeMutation>;
export type CreateDegreeMutationOptions = Apollo.BaseMutationOptions<CreateDegreeMutation, CreateDegreeMutationVariables>;
export const DeleteDegreeDocument = gql`
    mutation DeleteDegree($id: ID!) {
  deleteDegree(id: $id) {
    success
    message
  }
}
    `;
export type DeleteDegreeMutationFn = Apollo.MutationFunction<DeleteDegreeMutation, DeleteDegreeMutationVariables>;

/**
 * __useDeleteDegreeMutation__
 *
 * To run a mutation, you first call `useDeleteDegreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDegreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDegreeMutation, { data, loading, error }] = useDeleteDegreeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDegreeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDegreeMutation, DeleteDegreeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDegreeMutation, DeleteDegreeMutationVariables>(DeleteDegreeDocument, options);
      }
export type DeleteDegreeMutationHookResult = ReturnType<typeof useDeleteDegreeMutation>;
export type DeleteDegreeMutationResult = Apollo.MutationResult<DeleteDegreeMutation>;
export type DeleteDegreeMutationOptions = Apollo.BaseMutationOptions<DeleteDegreeMutation, DeleteDegreeMutationVariables>;
export const EnrollUserInDegreeDocument = gql`
    mutation EnrollUserInDegree($degreeId: ID!) {
  enrollInDegree(degreeId: $degreeId) {
    success
    data {
      id
      name
      usersEnrolledIn {
        id
      }
    }
  }
}
    `;
export type EnrollUserInDegreeMutationFn = Apollo.MutationFunction<EnrollUserInDegreeMutation, EnrollUserInDegreeMutationVariables>;

/**
 * __useEnrollUserInDegreeMutation__
 *
 * To run a mutation, you first call `useEnrollUserInDegreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollUserInDegreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollUserInDegreeMutation, { data, loading, error }] = useEnrollUserInDegreeMutation({
 *   variables: {
 *      degreeId: // value for 'degreeId'
 *   },
 * });
 */
export function useEnrollUserInDegreeMutation(baseOptions?: Apollo.MutationHookOptions<EnrollUserInDegreeMutation, EnrollUserInDegreeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnrollUserInDegreeMutation, EnrollUserInDegreeMutationVariables>(EnrollUserInDegreeDocument, options);
      }
export type EnrollUserInDegreeMutationHookResult = ReturnType<typeof useEnrollUserInDegreeMutation>;
export type EnrollUserInDegreeMutationResult = Apollo.MutationResult<EnrollUserInDegreeMutation>;
export type EnrollUserInDegreeMutationOptions = Apollo.BaseMutationOptions<EnrollUserInDegreeMutation, EnrollUserInDegreeMutationVariables>;
export const GenerateSuggestedDegreesDocument = gql`
    mutation generateSuggestedDegrees {
  generateSuggestedDegrees {
    success
    message
    data {
      id
      name
      created
      last_modified
    }
  }
}
    `;
export type GenerateSuggestedDegreesMutationFn = Apollo.MutationFunction<GenerateSuggestedDegreesMutation, GenerateSuggestedDegreesMutationVariables>;

/**
 * __useGenerateSuggestedDegreesMutation__
 *
 * To run a mutation, you first call `useGenerateSuggestedDegreesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSuggestedDegreesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSuggestedDegreesMutation, { data, loading, error }] = useGenerateSuggestedDegreesMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerateSuggestedDegreesMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSuggestedDegreesMutation, GenerateSuggestedDegreesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSuggestedDegreesMutation, GenerateSuggestedDegreesMutationVariables>(GenerateSuggestedDegreesDocument, options);
      }
export type GenerateSuggestedDegreesMutationHookResult = ReturnType<typeof useGenerateSuggestedDegreesMutation>;
export type GenerateSuggestedDegreesMutationResult = Apollo.MutationResult<GenerateSuggestedDegreesMutation>;
export type GenerateSuggestedDegreesMutationOptions = Apollo.BaseMutationOptions<GenerateSuggestedDegreesMutation, GenerateSuggestedDegreesMutationVariables>;
export const InviteUsersToEnrollInDegreeDocument = gql`
    mutation InviteUsersToEnrollInDegree($input: InviteUsersToEnrollInDegreeInput!) {
  inviteUsersToEnrollInDegree(input: $input) {
    success
    data {
      email
      id
    }
    count
  }
}
    `;
export type InviteUsersToEnrollInDegreeMutationFn = Apollo.MutationFunction<InviteUsersToEnrollInDegreeMutation, InviteUsersToEnrollInDegreeMutationVariables>;

/**
 * __useInviteUsersToEnrollInDegreeMutation__
 *
 * To run a mutation, you first call `useInviteUsersToEnrollInDegreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUsersToEnrollInDegreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUsersToEnrollInDegreeMutation, { data, loading, error }] = useInviteUsersToEnrollInDegreeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteUsersToEnrollInDegreeMutation(baseOptions?: Apollo.MutationHookOptions<InviteUsersToEnrollInDegreeMutation, InviteUsersToEnrollInDegreeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUsersToEnrollInDegreeMutation, InviteUsersToEnrollInDegreeMutationVariables>(InviteUsersToEnrollInDegreeDocument, options);
      }
export type InviteUsersToEnrollInDegreeMutationHookResult = ReturnType<typeof useInviteUsersToEnrollInDegreeMutation>;
export type InviteUsersToEnrollInDegreeMutationResult = Apollo.MutationResult<InviteUsersToEnrollInDegreeMutation>;
export type InviteUsersToEnrollInDegreeMutationOptions = Apollo.BaseMutationOptions<InviteUsersToEnrollInDegreeMutation, InviteUsersToEnrollInDegreeMutationVariables>;
export const RemoveCoursesFromDegreeDocument = gql`
    mutation RemoveCoursesFromDegree($input: RemoveCoursesFromDegreeInput!) {
  removeCoursesFromDegree(input: $input) {
    success
    message
  }
}
    `;
export type RemoveCoursesFromDegreeMutationFn = Apollo.MutationFunction<RemoveCoursesFromDegreeMutation, RemoveCoursesFromDegreeMutationVariables>;

/**
 * __useRemoveCoursesFromDegreeMutation__
 *
 * To run a mutation, you first call `useRemoveCoursesFromDegreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCoursesFromDegreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCoursesFromDegreeMutation, { data, loading, error }] = useRemoveCoursesFromDegreeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveCoursesFromDegreeMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCoursesFromDegreeMutation, RemoveCoursesFromDegreeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCoursesFromDegreeMutation, RemoveCoursesFromDegreeMutationVariables>(RemoveCoursesFromDegreeDocument, options);
      }
export type RemoveCoursesFromDegreeMutationHookResult = ReturnType<typeof useRemoveCoursesFromDegreeMutation>;
export type RemoveCoursesFromDegreeMutationResult = Apollo.MutationResult<RemoveCoursesFromDegreeMutation>;
export type RemoveCoursesFromDegreeMutationOptions = Apollo.BaseMutationOptions<RemoveCoursesFromDegreeMutation, RemoveCoursesFromDegreeMutationVariables>;
export const RemoveStudentsFromDegreeDocument = gql`
    mutation RemoveStudentsFromDegree($input: RemoveStudentsFromDegreeInput!) {
  removeStudentsFromDegree(input: $input) {
    success
    data {
      id
      name
    }
    count
  }
}
    `;
export type RemoveStudentsFromDegreeMutationFn = Apollo.MutationFunction<RemoveStudentsFromDegreeMutation, RemoveStudentsFromDegreeMutationVariables>;

/**
 * __useRemoveStudentsFromDegreeMutation__
 *
 * To run a mutation, you first call `useRemoveStudentsFromDegreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveStudentsFromDegreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeStudentsFromDegreeMutation, { data, loading, error }] = useRemoveStudentsFromDegreeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveStudentsFromDegreeMutation(baseOptions?: Apollo.MutationHookOptions<RemoveStudentsFromDegreeMutation, RemoveStudentsFromDegreeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveStudentsFromDegreeMutation, RemoveStudentsFromDegreeMutationVariables>(RemoveStudentsFromDegreeDocument, options);
      }
export type RemoveStudentsFromDegreeMutationHookResult = ReturnType<typeof useRemoveStudentsFromDegreeMutation>;
export type RemoveStudentsFromDegreeMutationResult = Apollo.MutationResult<RemoveStudentsFromDegreeMutation>;
export type RemoveStudentsFromDegreeMutationOptions = Apollo.BaseMutationOptions<RemoveStudentsFromDegreeMutation, RemoveStudentsFromDegreeMutationVariables>;
export const UpdateDegreeDocument = gql`
    mutation UpdateDegree($id: ID!, $degree: UpdateDegreeInput!) {
  updateDegree(id: $id, degree: $degree) {
    success
    message
    data {
      id
      name
      description
      usersEnrolledIn {
        id
        name
      }
      coursesHasCourse {
        id
        name
      }
    }
  }
}
    `;
export type UpdateDegreeMutationFn = Apollo.MutationFunction<UpdateDegreeMutation, UpdateDegreeMutationVariables>;

/**
 * __useUpdateDegreeMutation__
 *
 * To run a mutation, you first call `useUpdateDegreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDegreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDegreeMutation, { data, loading, error }] = useUpdateDegreeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      degree: // value for 'degree'
 *   },
 * });
 */
export function useUpdateDegreeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDegreeMutation, UpdateDegreeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDegreeMutation, UpdateDegreeMutationVariables>(UpdateDegreeDocument, options);
      }
export type UpdateDegreeMutationHookResult = ReturnType<typeof useUpdateDegreeMutation>;
export type UpdateDegreeMutationResult = Apollo.MutationResult<UpdateDegreeMutation>;
export type UpdateDegreeMutationOptions = Apollo.BaseMutationOptions<UpdateDegreeMutation, UpdateDegreeMutationVariables>;
export const CreateAdminDocumentDocument = gql`
    mutation CreateAdminDocument($fileId: ID!, $title: String!) {
  createAdminDocument(fileId: $fileId, title: $title) {
    success
    message
    data {
      id
      title
      status
      created
      last_modified
      files {
        id
        fileName
        fileURL
        status
      }
    }
    count
  }
}
    `;
export type CreateAdminDocumentMutationFn = Apollo.MutationFunction<CreateAdminDocumentMutation, CreateAdminDocumentMutationVariables>;

/**
 * __useCreateAdminDocumentMutation__
 *
 * To run a mutation, you first call `useCreateAdminDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminDocumentMutation, { data, loading, error }] = useCreateAdminDocumentMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateAdminDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdminDocumentMutation, CreateAdminDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdminDocumentMutation, CreateAdminDocumentMutationVariables>(CreateAdminDocumentDocument, options);
      }
export type CreateAdminDocumentMutationHookResult = ReturnType<typeof useCreateAdminDocumentMutation>;
export type CreateAdminDocumentMutationResult = Apollo.MutationResult<CreateAdminDocumentMutation>;
export type CreateAdminDocumentMutationOptions = Apollo.BaseMutationOptions<CreateAdminDocumentMutation, CreateAdminDocumentMutationVariables>;
export const DeleteAdminDocumentDocument = gql`
    mutation DeleteAdminDocument($id: ID!) {
  deleteAdminDocument(id: $id) {
    success
    message
    data {
      id
    }
    count
  }
}
    `;
export type DeleteAdminDocumentMutationFn = Apollo.MutationFunction<DeleteAdminDocumentMutation, DeleteAdminDocumentMutationVariables>;

/**
 * __useDeleteAdminDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteAdminDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdminDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdminDocumentMutation, { data, loading, error }] = useDeleteAdminDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAdminDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAdminDocumentMutation, DeleteAdminDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAdminDocumentMutation, DeleteAdminDocumentMutationVariables>(DeleteAdminDocumentDocument, options);
      }
export type DeleteAdminDocumentMutationHookResult = ReturnType<typeof useDeleteAdminDocumentMutation>;
export type DeleteAdminDocumentMutationResult = Apollo.MutationResult<DeleteAdminDocumentMutation>;
export type DeleteAdminDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteAdminDocumentMutation, DeleteAdminDocumentMutationVariables>;
export const GenerateKeywordsDocument = gql`
    mutation GenerateKeywords($title: String!, $description: String!) {
  generateYoutubeKeywords(title: $title, description: $description)
}
    `;
export type GenerateKeywordsMutationFn = Apollo.MutationFunction<GenerateKeywordsMutation, GenerateKeywordsMutationVariables>;

/**
 * __useGenerateKeywordsMutation__
 *
 * To run a mutation, you first call `useGenerateKeywordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateKeywordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateKeywordsMutation, { data, loading, error }] = useGenerateKeywordsMutation({
 *   variables: {
 *      title: // value for 'title'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useGenerateKeywordsMutation(baseOptions?: Apollo.MutationHookOptions<GenerateKeywordsMutation, GenerateKeywordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateKeywordsMutation, GenerateKeywordsMutationVariables>(GenerateKeywordsDocument, options);
      }
export type GenerateKeywordsMutationHookResult = ReturnType<typeof useGenerateKeywordsMutation>;
export type GenerateKeywordsMutationResult = Apollo.MutationResult<GenerateKeywordsMutation>;
export type GenerateKeywordsMutationOptions = Apollo.BaseMutationOptions<GenerateKeywordsMutation, GenerateKeywordsMutationVariables>;
export const CreateEnrollmentLinkDocument = gql`
    mutation CreateEnrollmentLink($input: CreateEnrollmentLinkInput!) {
  createEnrollmentLink(input: $input) {
    success
    message
    data {
      id
      lastModified
    }
    count
  }
}
    `;
export type CreateEnrollmentLinkMutationFn = Apollo.MutationFunction<CreateEnrollmentLinkMutation, CreateEnrollmentLinkMutationVariables>;

/**
 * __useCreateEnrollmentLinkMutation__
 *
 * To run a mutation, you first call `useCreateEnrollmentLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEnrollmentLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEnrollmentLinkMutation, { data, loading, error }] = useCreateEnrollmentLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEnrollmentLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateEnrollmentLinkMutation, CreateEnrollmentLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEnrollmentLinkMutation, CreateEnrollmentLinkMutationVariables>(CreateEnrollmentLinkDocument, options);
      }
export type CreateEnrollmentLinkMutationHookResult = ReturnType<typeof useCreateEnrollmentLinkMutation>;
export type CreateEnrollmentLinkMutationResult = Apollo.MutationResult<CreateEnrollmentLinkMutation>;
export type CreateEnrollmentLinkMutationOptions = Apollo.BaseMutationOptions<CreateEnrollmentLinkMutation, CreateEnrollmentLinkMutationVariables>;
export const DeleteEnrollmentLinkDocument = gql`
    mutation DeleteEnrollmentLink($id: ID!) {
  deleteEnrollmentLink(id: $id) {
    success
    message
    count
  }
}
    `;
export type DeleteEnrollmentLinkMutationFn = Apollo.MutationFunction<DeleteEnrollmentLinkMutation, DeleteEnrollmentLinkMutationVariables>;

/**
 * __useDeleteEnrollmentLinkMutation__
 *
 * To run a mutation, you first call `useDeleteEnrollmentLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEnrollmentLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEnrollmentLinkMutation, { data, loading, error }] = useDeleteEnrollmentLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEnrollmentLinkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEnrollmentLinkMutation, DeleteEnrollmentLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEnrollmentLinkMutation, DeleteEnrollmentLinkMutationVariables>(DeleteEnrollmentLinkDocument, options);
      }
export type DeleteEnrollmentLinkMutationHookResult = ReturnType<typeof useDeleteEnrollmentLinkMutation>;
export type DeleteEnrollmentLinkMutationResult = Apollo.MutationResult<DeleteEnrollmentLinkMutation>;
export type DeleteEnrollmentLinkMutationOptions = Apollo.BaseMutationOptions<DeleteEnrollmentLinkMutation, DeleteEnrollmentLinkMutationVariables>;
export const EnrollCourseWithTokenDocument = gql`
    mutation EnrollCourseWithToken($token: String!) {
  enrollCourseWithToken(token: $token) {
    success
    message
    data {
      id
      lastModified
      courseId
      courseName
    }
    count
  }
}
    `;
export type EnrollCourseWithTokenMutationFn = Apollo.MutationFunction<EnrollCourseWithTokenMutation, EnrollCourseWithTokenMutationVariables>;

/**
 * __useEnrollCourseWithTokenMutation__
 *
 * To run a mutation, you first call `useEnrollCourseWithTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollCourseWithTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollCourseWithTokenMutation, { data, loading, error }] = useEnrollCourseWithTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useEnrollCourseWithTokenMutation(baseOptions?: Apollo.MutationHookOptions<EnrollCourseWithTokenMutation, EnrollCourseWithTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnrollCourseWithTokenMutation, EnrollCourseWithTokenMutationVariables>(EnrollCourseWithTokenDocument, options);
      }
export type EnrollCourseWithTokenMutationHookResult = ReturnType<typeof useEnrollCourseWithTokenMutation>;
export type EnrollCourseWithTokenMutationResult = Apollo.MutationResult<EnrollCourseWithTokenMutation>;
export type EnrollCourseWithTokenMutationOptions = Apollo.BaseMutationOptions<EnrollCourseWithTokenMutation, EnrollCourseWithTokenMutationVariables>;
export const UpdateEnrollmentLinkDocument = gql`
    mutation UpdateEnrollmentLink($id: ID!, $input: UpdateEnrollmentLinkInput!) {
  updateEnrollmentLink(id: $id, input: $input) {
    success
    message
    data {
      id
      lastModified
    }
    count
  }
}
    `;
export type UpdateEnrollmentLinkMutationFn = Apollo.MutationFunction<UpdateEnrollmentLinkMutation, UpdateEnrollmentLinkMutationVariables>;

/**
 * __useUpdateEnrollmentLinkMutation__
 *
 * To run a mutation, you first call `useUpdateEnrollmentLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnrollmentLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnrollmentLinkMutation, { data, loading, error }] = useUpdateEnrollmentLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEnrollmentLinkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEnrollmentLinkMutation, UpdateEnrollmentLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEnrollmentLinkMutation, UpdateEnrollmentLinkMutationVariables>(UpdateEnrollmentLinkDocument, options);
      }
export type UpdateEnrollmentLinkMutationHookResult = ReturnType<typeof useUpdateEnrollmentLinkMutation>;
export type UpdateEnrollmentLinkMutationResult = Apollo.MutationResult<UpdateEnrollmentLinkMutation>;
export type UpdateEnrollmentLinkMutationOptions = Apollo.BaseMutationOptions<UpdateEnrollmentLinkMutation, UpdateEnrollmentLinkMutationVariables>;
export const GenerateUploadUrlDocument = gql`
    mutation GenerateUploadUrl($fileName: String!, $storagePath: StoragePathType!) {
  generateUploadUrl(fileName: $fileName, storagePath: $storagePath) {
    data {
      file {
        id
        fileName
        fileURL
        filePath
        bucketName
        created
        status
      }
      signedUrl
      uniqueFileName
      uploadedFileMimeType
    }
    message
    success
  }
}
    `;
export type GenerateUploadUrlMutationFn = Apollo.MutationFunction<GenerateUploadUrlMutation, GenerateUploadUrlMutationVariables>;

/**
 * __useGenerateUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUploadUrlMutation, { data, loading, error }] = useGenerateUploadUrlMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      storagePath: // value for 'storagePath'
 *   },
 * });
 */
export function useGenerateUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateUploadUrlMutation, GenerateUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateUploadUrlMutation, GenerateUploadUrlMutationVariables>(GenerateUploadUrlDocument, options);
      }
export type GenerateUploadUrlMutationHookResult = ReturnType<typeof useGenerateUploadUrlMutation>;
export type GenerateUploadUrlMutationResult = Apollo.MutationResult<GenerateUploadUrlMutation>;
export type GenerateUploadUrlMutationOptions = Apollo.BaseMutationOptions<GenerateUploadUrlMutation, GenerateUploadUrlMutationVariables>;
export const GetGcpSignedUrlForReadDocument = gql`
    query GetGcpSignedUrlForRead($fileId: ID!, $responseDisposition: String) {
  getGcpSignedUrlForRead(
    fileId: $fileId
    responseDisposition: $responseDisposition
  ) {
    data {
      signedUrl
    }
    message
    success
  }
}
    `;

/**
 * __useGetGcpSignedUrlForReadQuery__
 *
 * To run a query within a React component, call `useGetGcpSignedUrlForReadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGcpSignedUrlForReadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGcpSignedUrlForReadQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      responseDisposition: // value for 'responseDisposition'
 *   },
 * });
 */
export function useGetGcpSignedUrlForReadQuery(baseOptions: Apollo.QueryHookOptions<GetGcpSignedUrlForReadQuery, GetGcpSignedUrlForReadQueryVariables> & ({ variables: GetGcpSignedUrlForReadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGcpSignedUrlForReadQuery, GetGcpSignedUrlForReadQueryVariables>(GetGcpSignedUrlForReadDocument, options);
      }
export function useGetGcpSignedUrlForReadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGcpSignedUrlForReadQuery, GetGcpSignedUrlForReadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGcpSignedUrlForReadQuery, GetGcpSignedUrlForReadQueryVariables>(GetGcpSignedUrlForReadDocument, options);
        }
// @ts-ignore
export function useGetGcpSignedUrlForReadSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGcpSignedUrlForReadQuery, GetGcpSignedUrlForReadQueryVariables>): Apollo.UseSuspenseQueryResult<GetGcpSignedUrlForReadQuery, GetGcpSignedUrlForReadQueryVariables>;
export function useGetGcpSignedUrlForReadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGcpSignedUrlForReadQuery, GetGcpSignedUrlForReadQueryVariables>): Apollo.UseSuspenseQueryResult<GetGcpSignedUrlForReadQuery | undefined, GetGcpSignedUrlForReadQueryVariables>;
export function useGetGcpSignedUrlForReadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGcpSignedUrlForReadQuery, GetGcpSignedUrlForReadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGcpSignedUrlForReadQuery, GetGcpSignedUrlForReadQueryVariables>(GetGcpSignedUrlForReadDocument, options);
        }
export type GetGcpSignedUrlForReadQueryHookResult = ReturnType<typeof useGetGcpSignedUrlForReadQuery>;
export type GetGcpSignedUrlForReadLazyQueryHookResult = ReturnType<typeof useGetGcpSignedUrlForReadLazyQuery>;
export type GetGcpSignedUrlForReadSuspenseQueryHookResult = ReturnType<typeof useGetGcpSignedUrlForReadSuspenseQuery>;
export type GetGcpSignedUrlForReadQueryResult = Apollo.QueryResult<GetGcpSignedUrlForReadQuery, GetGcpSignedUrlForReadQueryVariables>;
export const MakeFilePublicDocument = gql`
    mutation MakeFilePublic($fileId: ID!) {
  makeFilePublic(fileId: $fileId) {
    success
    message
    data {
      id
      fileName
      fileURL
      filePath
      bucketName
      created
      status
    }
  }
}
    `;
export type MakeFilePublicMutationFn = Apollo.MutationFunction<MakeFilePublicMutation, MakeFilePublicMutationVariables>;

/**
 * __useMakeFilePublicMutation__
 *
 * To run a mutation, you first call `useMakeFilePublicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeFilePublicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeFilePublicMutation, { data, loading, error }] = useMakeFilePublicMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useMakeFilePublicMutation(baseOptions?: Apollo.MutationHookOptions<MakeFilePublicMutation, MakeFilePublicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeFilePublicMutation, MakeFilePublicMutationVariables>(MakeFilePublicDocument, options);
      }
export type MakeFilePublicMutationHookResult = ReturnType<typeof useMakeFilePublicMutation>;
export type MakeFilePublicMutationResult = Apollo.MutationResult<MakeFilePublicMutation>;
export type MakeFilePublicMutationOptions = Apollo.BaseMutationOptions<MakeFilePublicMutation, MakeFilePublicMutationVariables>;
export const AudioToggleUserDocument = gql`
    mutation AudioToggleUser($audioOn: Boolean!) {
  audioToggleUser(audioOn: $audioOn) {
    audioOn
  }
}
    `;
export type AudioToggleUserMutationFn = Apollo.MutationFunction<AudioToggleUserMutation, AudioToggleUserMutationVariables>;

/**
 * __useAudioToggleUserMutation__
 *
 * To run a mutation, you first call `useAudioToggleUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAudioToggleUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [audioToggleUserMutation, { data, loading, error }] = useAudioToggleUserMutation({
 *   variables: {
 *      audioOn: // value for 'audioOn'
 *   },
 * });
 */
export function useAudioToggleUserMutation(baseOptions?: Apollo.MutationHookOptions<AudioToggleUserMutation, AudioToggleUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AudioToggleUserMutation, AudioToggleUserMutationVariables>(AudioToggleUserDocument, options);
      }
export type AudioToggleUserMutationHookResult = ReturnType<typeof useAudioToggleUserMutation>;
export type AudioToggleUserMutationResult = Apollo.MutationResult<AudioToggleUserMutation>;
export type AudioToggleUserMutationOptions = Apollo.BaseMutationOptions<AudioToggleUserMutation, AudioToggleUserMutationVariables>;
export const HideLearningActivityIntroDocument = gql`
    mutation HideLearningActivityIntro {
  hideLearningActivityIntro {
    success
    message
  }
}
    `;
export type HideLearningActivityIntroMutationFn = Apollo.MutationFunction<HideLearningActivityIntroMutation, HideLearningActivityIntroMutationVariables>;

/**
 * __useHideLearningActivityIntroMutation__
 *
 * To run a mutation, you first call `useHideLearningActivityIntroMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHideLearningActivityIntroMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hideLearningActivityIntroMutation, { data, loading, error }] = useHideLearningActivityIntroMutation({
 *   variables: {
 *   },
 * });
 */
export function useHideLearningActivityIntroMutation(baseOptions?: Apollo.MutationHookOptions<HideLearningActivityIntroMutation, HideLearningActivityIntroMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HideLearningActivityIntroMutation, HideLearningActivityIntroMutationVariables>(HideLearningActivityIntroDocument, options);
      }
export type HideLearningActivityIntroMutationHookResult = ReturnType<typeof useHideLearningActivityIntroMutation>;
export type HideLearningActivityIntroMutationResult = Apollo.MutationResult<HideLearningActivityIntroMutation>;
export type HideLearningActivityIntroMutationOptions = Apollo.BaseMutationOptions<HideLearningActivityIntroMutation, HideLearningActivityIntroMutationVariables>;
export const UpdateNotificationsSettingDocument = gql`
    mutation UpdateNotificationsSetting($dailyEmailOptIn: Boolean!) {
  updateNotificationsSetting(dailyEmailOptIn: $dailyEmailOptIn) {
    success
    message
  }
}
    `;
export type UpdateNotificationsSettingMutationFn = Apollo.MutationFunction<UpdateNotificationsSettingMutation, UpdateNotificationsSettingMutationVariables>;

/**
 * __useUpdateNotificationsSettingMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationsSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationsSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationsSettingMutation, { data, loading, error }] = useUpdateNotificationsSettingMutation({
 *   variables: {
 *      dailyEmailOptIn: // value for 'dailyEmailOptIn'
 *   },
 * });
 */
export function useUpdateNotificationsSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationsSettingMutation, UpdateNotificationsSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationsSettingMutation, UpdateNotificationsSettingMutationVariables>(UpdateNotificationsSettingDocument, options);
      }
export type UpdateNotificationsSettingMutationHookResult = ReturnType<typeof useUpdateNotificationsSettingMutation>;
export type UpdateNotificationsSettingMutationResult = Apollo.MutationResult<UpdateNotificationsSettingMutation>;
export type UpdateNotificationsSettingMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationsSettingMutation, UpdateNotificationsSettingMutationVariables>;
export const UpdateNotificationsEmailSettingDocument = gql`
    mutation UpdateNotificationsEmailSetting($skipAllNotificationEmail: Boolean!) {
  updateNotificationsEmailSetting(
    skipAllNotificationEmail: $skipAllNotificationEmail
  ) {
    success
    message
  }
}
    `;
export type UpdateNotificationsEmailSettingMutationFn = Apollo.MutationFunction<UpdateNotificationsEmailSettingMutation, UpdateNotificationsEmailSettingMutationVariables>;

/**
 * __useUpdateNotificationsEmailSettingMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationsEmailSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationsEmailSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationsEmailSettingMutation, { data, loading, error }] = useUpdateNotificationsEmailSettingMutation({
 *   variables: {
 *      skipAllNotificationEmail: // value for 'skipAllNotificationEmail'
 *   },
 * });
 */
export function useUpdateNotificationsEmailSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationsEmailSettingMutation, UpdateNotificationsEmailSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationsEmailSettingMutation, UpdateNotificationsEmailSettingMutationVariables>(UpdateNotificationsEmailSettingDocument, options);
      }
export type UpdateNotificationsEmailSettingMutationHookResult = ReturnType<typeof useUpdateNotificationsEmailSettingMutation>;
export type UpdateNotificationsEmailSettingMutationResult = Apollo.MutationResult<UpdateNotificationsEmailSettingMutation>;
export type UpdateNotificationsEmailSettingMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationsEmailSettingMutation, UpdateNotificationsEmailSettingMutationVariables>;
export const AddToWhitelistDocument = gql`
    mutation AddToWhitelist($email: String!) {
  addToWhitelist(email: $email) {
    email
  }
}
    `;
export type AddToWhitelistMutationFn = Apollo.MutationFunction<AddToWhitelistMutation, AddToWhitelistMutationVariables>;

/**
 * __useAddToWhitelistMutation__
 *
 * To run a mutation, you first call `useAddToWhitelistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToWhitelistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToWhitelistMutation, { data, loading, error }] = useAddToWhitelistMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useAddToWhitelistMutation(baseOptions?: Apollo.MutationHookOptions<AddToWhitelistMutation, AddToWhitelistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddToWhitelistMutation, AddToWhitelistMutationVariables>(AddToWhitelistDocument, options);
      }
export type AddToWhitelistMutationHookResult = ReturnType<typeof useAddToWhitelistMutation>;
export type AddToWhitelistMutationResult = Apollo.MutationResult<AddToWhitelistMutation>;
export type AddToWhitelistMutationOptions = Apollo.BaseMutationOptions<AddToWhitelistMutation, AddToWhitelistMutationVariables>;
export const CompleteCourseInvitationDocument = gql`
    mutation CompleteCourseInvitation($courseId: ID!) {
  completeCourseInvitation(courseId: $courseId) {
    message
    success
  }
}
    `;
export type CompleteCourseInvitationMutationFn = Apollo.MutationFunction<CompleteCourseInvitationMutation, CompleteCourseInvitationMutationVariables>;

/**
 * __useCompleteCourseInvitationMutation__
 *
 * To run a mutation, you first call `useCompleteCourseInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteCourseInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeCourseInvitationMutation, { data, loading, error }] = useCompleteCourseInvitationMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useCompleteCourseInvitationMutation(baseOptions?: Apollo.MutationHookOptions<CompleteCourseInvitationMutation, CompleteCourseInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteCourseInvitationMutation, CompleteCourseInvitationMutationVariables>(CompleteCourseInvitationDocument, options);
      }
export type CompleteCourseInvitationMutationHookResult = ReturnType<typeof useCompleteCourseInvitationMutation>;
export type CompleteCourseInvitationMutationResult = Apollo.MutationResult<CompleteCourseInvitationMutation>;
export type CompleteCourseInvitationMutationOptions = Apollo.BaseMutationOptions<CompleteCourseInvitationMutation, CompleteCourseInvitationMutationVariables>;
export const CompleteDegreeInvitationDocument = gql`
    mutation CompleteDegreeInvitation($degreeId: ID!) {
  completeDegreeInvitation(degreeId: $degreeId) {
    message
    success
  }
}
    `;
export type CompleteDegreeInvitationMutationFn = Apollo.MutationFunction<CompleteDegreeInvitationMutation, CompleteDegreeInvitationMutationVariables>;

/**
 * __useCompleteDegreeInvitationMutation__
 *
 * To run a mutation, you first call `useCompleteDegreeInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteDegreeInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeDegreeInvitationMutation, { data, loading, error }] = useCompleteDegreeInvitationMutation({
 *   variables: {
 *      degreeId: // value for 'degreeId'
 *   },
 * });
 */
export function useCompleteDegreeInvitationMutation(baseOptions?: Apollo.MutationHookOptions<CompleteDegreeInvitationMutation, CompleteDegreeInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteDegreeInvitationMutation, CompleteDegreeInvitationMutationVariables>(CompleteDegreeInvitationDocument, options);
      }
export type CompleteDegreeInvitationMutationHookResult = ReturnType<typeof useCompleteDegreeInvitationMutation>;
export type CompleteDegreeInvitationMutationResult = Apollo.MutationResult<CompleteDegreeInvitationMutation>;
export type CompleteDegreeInvitationMutationOptions = Apollo.BaseMutationOptions<CompleteDegreeInvitationMutation, CompleteDegreeInvitationMutationVariables>;
export const CompletePendingInviteDocument = gql`
    mutation CompletePendingInvite($token: String!, $newPassword: String!, $service: String!) {
  completePendingInvite(
    token: $token
    newPassword: $newPassword
    service: $service
  ) {
    message
    success
  }
}
    `;
export type CompletePendingInviteMutationFn = Apollo.MutationFunction<CompletePendingInviteMutation, CompletePendingInviteMutationVariables>;

/**
 * __useCompletePendingInviteMutation__
 *
 * To run a mutation, you first call `useCompletePendingInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompletePendingInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completePendingInviteMutation, { data, loading, error }] = useCompletePendingInviteMutation({
 *   variables: {
 *      token: // value for 'token'
 *      newPassword: // value for 'newPassword'
 *      service: // value for 'service'
 *   },
 * });
 */
export function useCompletePendingInviteMutation(baseOptions?: Apollo.MutationHookOptions<CompletePendingInviteMutation, CompletePendingInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompletePendingInviteMutation, CompletePendingInviteMutationVariables>(CompletePendingInviteDocument, options);
      }
export type CompletePendingInviteMutationHookResult = ReturnType<typeof useCompletePendingInviteMutation>;
export type CompletePendingInviteMutationResult = Apollo.MutationResult<CompletePendingInviteMutation>;
export type CompletePendingInviteMutationOptions = Apollo.BaseMutationOptions<CompletePendingInviteMutation, CompletePendingInviteMutationVariables>;
export const CreateEducationChildrenDocument = gql`
    mutation CreateEducationChildren($label: NodeLabel!, $name: String!) {
  createEducationChildren(label: $label, name: $name) {
    success
    message
    data {
      name
    }
  }
}
    `;
export type CreateEducationChildrenMutationFn = Apollo.MutationFunction<CreateEducationChildrenMutation, CreateEducationChildrenMutationVariables>;

/**
 * __useCreateEducationChildrenMutation__
 *
 * To run a mutation, you first call `useCreateEducationChildrenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEducationChildrenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEducationChildrenMutation, { data, loading, error }] = useCreateEducationChildrenMutation({
 *   variables: {
 *      label: // value for 'label'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateEducationChildrenMutation(baseOptions?: Apollo.MutationHookOptions<CreateEducationChildrenMutation, CreateEducationChildrenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEducationChildrenMutation, CreateEducationChildrenMutationVariables>(CreateEducationChildrenDocument, options);
      }
export type CreateEducationChildrenMutationHookResult = ReturnType<typeof useCreateEducationChildrenMutation>;
export type CreateEducationChildrenMutationResult = Apollo.MutationResult<CreateEducationChildrenMutation>;
export type CreateEducationChildrenMutationOptions = Apollo.BaseMutationOptions<CreateEducationChildrenMutation, CreateEducationChildrenMutationVariables>;
export const DropUserFromCourseDocument = gql`
    mutation DropUserFromCourse($courseId: ID!) {
  dropUserFromCourse(courseId: $courseId) {
    success
    message
  }
}
    `;
export type DropUserFromCourseMutationFn = Apollo.MutationFunction<DropUserFromCourseMutation, DropUserFromCourseMutationVariables>;

/**
 * __useDropUserFromCourseMutation__
 *
 * To run a mutation, you first call `useDropUserFromCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDropUserFromCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dropUserFromCourseMutation, { data, loading, error }] = useDropUserFromCourseMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useDropUserFromCourseMutation(baseOptions?: Apollo.MutationHookOptions<DropUserFromCourseMutation, DropUserFromCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DropUserFromCourseMutation, DropUserFromCourseMutationVariables>(DropUserFromCourseDocument, options);
      }
export type DropUserFromCourseMutationHookResult = ReturnType<typeof useDropUserFromCourseMutation>;
export type DropUserFromCourseMutationResult = Apollo.MutationResult<DropUserFromCourseMutation>;
export type DropUserFromCourseMutationOptions = Apollo.BaseMutationOptions<DropUserFromCourseMutation, DropUserFromCourseMutationVariables>;
export const EnrollUserInCourseDocument = gql`
    mutation EnrollUserInCourse($courseId: ID!) {
  enrollUserInCourse(courseId: $courseId) {
    success
    message
  }
}
    `;
export type EnrollUserInCourseMutationFn = Apollo.MutationFunction<EnrollUserInCourseMutation, EnrollUserInCourseMutationVariables>;

/**
 * __useEnrollUserInCourseMutation__
 *
 * To run a mutation, you first call `useEnrollUserInCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollUserInCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollUserInCourseMutation, { data, loading, error }] = useEnrollUserInCourseMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useEnrollUserInCourseMutation(baseOptions?: Apollo.MutationHookOptions<EnrollUserInCourseMutation, EnrollUserInCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnrollUserInCourseMutation, EnrollUserInCourseMutationVariables>(EnrollUserInCourseDocument, options);
      }
export type EnrollUserInCourseMutationHookResult = ReturnType<typeof useEnrollUserInCourseMutation>;
export type EnrollUserInCourseMutationResult = Apollo.MutationResult<EnrollUserInCourseMutation>;
export type EnrollUserInCourseMutationOptions = Apollo.BaseMutationOptions<EnrollUserInCourseMutation, EnrollUserInCourseMutationVariables>;
export const EnrollUserInTrackDocument = gql`
    mutation EnrollUserInTrack($topicName: String!) {
  enrollUserInTrack(topicName: $topicName) {
    success
    message
  }
}
    `;
export type EnrollUserInTrackMutationFn = Apollo.MutationFunction<EnrollUserInTrackMutation, EnrollUserInTrackMutationVariables>;

/**
 * __useEnrollUserInTrackMutation__
 *
 * To run a mutation, you first call `useEnrollUserInTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollUserInTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollUserInTrackMutation, { data, loading, error }] = useEnrollUserInTrackMutation({
 *   variables: {
 *      topicName: // value for 'topicName'
 *   },
 * });
 */
export function useEnrollUserInTrackMutation(baseOptions?: Apollo.MutationHookOptions<EnrollUserInTrackMutation, EnrollUserInTrackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnrollUserInTrackMutation, EnrollUserInTrackMutationVariables>(EnrollUserInTrackDocument, options);
      }
export type EnrollUserInTrackMutationHookResult = ReturnType<typeof useEnrollUserInTrackMutation>;
export type EnrollUserInTrackMutationResult = Apollo.MutationResult<EnrollUserInTrackMutation>;
export type EnrollUserInTrackMutationOptions = Apollo.BaseMutationOptions<EnrollUserInTrackMutation, EnrollUserInTrackMutationVariables>;
export const GetLearningTtsTokenDocument = gql`
    mutation GetLearningTtsToken {
  getLearningTtsToken {
    token
  }
}
    `;
export type GetLearningTtsTokenMutationFn = Apollo.MutationFunction<GetLearningTtsTokenMutation, GetLearningTtsTokenMutationVariables>;

/**
 * __useGetLearningTtsTokenMutation__
 *
 * To run a mutation, you first call `useGetLearningTtsTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetLearningTtsTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getLearningTtsTokenMutation, { data, loading, error }] = useGetLearningTtsTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetLearningTtsTokenMutation(baseOptions?: Apollo.MutationHookOptions<GetLearningTtsTokenMutation, GetLearningTtsTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetLearningTtsTokenMutation, GetLearningTtsTokenMutationVariables>(GetLearningTtsTokenDocument, options);
      }
export type GetLearningTtsTokenMutationHookResult = ReturnType<typeof useGetLearningTtsTokenMutation>;
export type GetLearningTtsTokenMutationResult = Apollo.MutationResult<GetLearningTtsTokenMutation>;
export type GetLearningTtsTokenMutationOptions = Apollo.BaseMutationOptions<GetLearningTtsTokenMutation, GetLearningTtsTokenMutationVariables>;
export const SetKnowledgeRelevanceDocument = gql`
    mutation SetKnowledgeRelevance($nodeName: String!, $nodeLabel: String!, $isRelevant: Boolean!) {
  setKnowledgeRelevance(
    nodeName: $nodeName
    nodeLabel: $nodeLabel
    isRelevant: $isRelevant
  ) {
    success
    message
  }
}
    `;
export type SetKnowledgeRelevanceMutationFn = Apollo.MutationFunction<SetKnowledgeRelevanceMutation, SetKnowledgeRelevanceMutationVariables>;

/**
 * __useSetKnowledgeRelevanceMutation__
 *
 * To run a mutation, you first call `useSetKnowledgeRelevanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetKnowledgeRelevanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setKnowledgeRelevanceMutation, { data, loading, error }] = useSetKnowledgeRelevanceMutation({
 *   variables: {
 *      nodeName: // value for 'nodeName'
 *      nodeLabel: // value for 'nodeLabel'
 *      isRelevant: // value for 'isRelevant'
 *   },
 * });
 */
export function useSetKnowledgeRelevanceMutation(baseOptions?: Apollo.MutationHookOptions<SetKnowledgeRelevanceMutation, SetKnowledgeRelevanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetKnowledgeRelevanceMutation, SetKnowledgeRelevanceMutationVariables>(SetKnowledgeRelevanceDocument, options);
      }
export type SetKnowledgeRelevanceMutationHookResult = ReturnType<typeof useSetKnowledgeRelevanceMutation>;
export type SetKnowledgeRelevanceMutationResult = Apollo.MutationResult<SetKnowledgeRelevanceMutation>;
export type SetKnowledgeRelevanceMutationOptions = Apollo.BaseMutationOptions<SetKnowledgeRelevanceMutation, SetKnowledgeRelevanceMutationVariables>;
export const UpdateTopicDocument = gql`
    mutation UpdateTopic($operationType: String!, $topicName: String!) {
  updateTopic(operationType: $operationType, topicName: $topicName) {
    success
    message
  }
}
    `;
export type UpdateTopicMutationFn = Apollo.MutationFunction<UpdateTopicMutation, UpdateTopicMutationVariables>;

/**
 * __useUpdateTopicMutation__
 *
 * To run a mutation, you first call `useUpdateTopicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTopicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTopicMutation, { data, loading, error }] = useUpdateTopicMutation({
 *   variables: {
 *      operationType: // value for 'operationType'
 *      topicName: // value for 'topicName'
 *   },
 * });
 */
export function useUpdateTopicMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTopicMutation, UpdateTopicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTopicMutation, UpdateTopicMutationVariables>(UpdateTopicDocument, options);
      }
export type UpdateTopicMutationHookResult = ReturnType<typeof useUpdateTopicMutation>;
export type UpdateTopicMutationResult = Apollo.MutationResult<UpdateTopicMutation>;
export type UpdateTopicMutationOptions = Apollo.BaseMutationOptions<UpdateTopicMutation, UpdateTopicMutationVariables>;
export const UpdateLearningObjectiveCompletionDocument = gql`
    mutation UpdateLearningObjectiveCompletion($id: ID!, $completed: Boolean!) {
  updateLearningObjectiveCompletion(id: $id, completed: $completed) {
    success
    message
  }
}
    `;
export type UpdateLearningObjectiveCompletionMutationFn = Apollo.MutationFunction<UpdateLearningObjectiveCompletionMutation, UpdateLearningObjectiveCompletionMutationVariables>;

/**
 * __useUpdateLearningObjectiveCompletionMutation__
 *
 * To run a mutation, you first call `useUpdateLearningObjectiveCompletionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLearningObjectiveCompletionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLearningObjectiveCompletionMutation, { data, loading, error }] = useUpdateLearningObjectiveCompletionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      completed: // value for 'completed'
 *   },
 * });
 */
export function useUpdateLearningObjectiveCompletionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLearningObjectiveCompletionMutation, UpdateLearningObjectiveCompletionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLearningObjectiveCompletionMutation, UpdateLearningObjectiveCompletionMutationVariables>(UpdateLearningObjectiveCompletionDocument, options);
      }
export type UpdateLearningObjectiveCompletionMutationHookResult = ReturnType<typeof useUpdateLearningObjectiveCompletionMutation>;
export type UpdateLearningObjectiveCompletionMutationResult = Apollo.MutationResult<UpdateLearningObjectiveCompletionMutation>;
export type UpdateLearningObjectiveCompletionMutationOptions = Apollo.BaseMutationOptions<UpdateLearningObjectiveCompletionMutation, UpdateLearningObjectiveCompletionMutationVariables>;
export const MarkNotificationAsReadDocument = gql`
    mutation MarkNotificationAsRead($id: ID!) {
  markNotificationAsRead(id: $id) {
    success
    data {
      id
      title
      message
      created
      isRead
      readAt
      actionUrl
    }
    count
  }
}
    `;
export type MarkNotificationAsReadMutationFn = Apollo.MutationFunction<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;

/**
 * __useMarkNotificationAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationAsReadMutation, { data, loading, error }] = useMarkNotificationAsReadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkNotificationAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>(MarkNotificationAsReadDocument, options);
      }
export type MarkNotificationAsReadMutationHookResult = ReturnType<typeof useMarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationResult = Apollo.MutationResult<MarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;
export const CreateOAuthClientDocument = gql`
    mutation CreateOAuthClient($input: OAuthClientInput!) {
  createOAuthClient(input: $input) {
    success
    message
    data {
      id
      clientId
      clientSecret
      tenant {
        id
        tenantDomain
      }
      created
    }
    count
  }
}
    `;
export type CreateOAuthClientMutationFn = Apollo.MutationFunction<CreateOAuthClientMutation, CreateOAuthClientMutationVariables>;

/**
 * __useCreateOAuthClientMutation__
 *
 * To run a mutation, you first call `useCreateOAuthClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOAuthClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOAuthClientMutation, { data, loading, error }] = useCreateOAuthClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOAuthClientMutation(baseOptions?: Apollo.MutationHookOptions<CreateOAuthClientMutation, CreateOAuthClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOAuthClientMutation, CreateOAuthClientMutationVariables>(CreateOAuthClientDocument, options);
      }
export type CreateOAuthClientMutationHookResult = ReturnType<typeof useCreateOAuthClientMutation>;
export type CreateOAuthClientMutationResult = Apollo.MutationResult<CreateOAuthClientMutation>;
export type CreateOAuthClientMutationOptions = Apollo.BaseMutationOptions<CreateOAuthClientMutation, CreateOAuthClientMutationVariables>;
export const DeleteOAuthClientDocument = gql`
    mutation DeleteOAuthClient($id: ID!) {
  deleteOAuthClient(id: $id) {
    success
    message
    count
  }
}
    `;
export type DeleteOAuthClientMutationFn = Apollo.MutationFunction<DeleteOAuthClientMutation, DeleteOAuthClientMutationVariables>;

/**
 * __useDeleteOAuthClientMutation__
 *
 * To run a mutation, you first call `useDeleteOAuthClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOAuthClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOAuthClientMutation, { data, loading, error }] = useDeleteOAuthClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOAuthClientMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOAuthClientMutation, DeleteOAuthClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOAuthClientMutation, DeleteOAuthClientMutationVariables>(DeleteOAuthClientDocument, options);
      }
export type DeleteOAuthClientMutationHookResult = ReturnType<typeof useDeleteOAuthClientMutation>;
export type DeleteOAuthClientMutationResult = Apollo.MutationResult<DeleteOAuthClientMutation>;
export type DeleteOAuthClientMutationOptions = Apollo.BaseMutationOptions<DeleteOAuthClientMutation, DeleteOAuthClientMutationVariables>;
export const UpdateOAuthClientDocument = gql`
    mutation UpdateOAuthClient($id: ID!, $input: OAuthClientInput!) {
  updateOAuthClient(id: $id, input: $input) {
    success
    message
    data {
      id
      clientId
      clientSecret
      created
      tenant {
        id
        tenantDomain
      }
    }
    count
  }
}
    `;
export type UpdateOAuthClientMutationFn = Apollo.MutationFunction<UpdateOAuthClientMutation, UpdateOAuthClientMutationVariables>;

/**
 * __useUpdateOAuthClientMutation__
 *
 * To run a mutation, you first call `useUpdateOAuthClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOAuthClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOAuthClientMutation, { data, loading, error }] = useUpdateOAuthClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOAuthClientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOAuthClientMutation, UpdateOAuthClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOAuthClientMutation, UpdateOAuthClientMutationVariables>(UpdateOAuthClientDocument, options);
      }
export type UpdateOAuthClientMutationHookResult = ReturnType<typeof useUpdateOAuthClientMutation>;
export type UpdateOAuthClientMutationResult = Apollo.MutationResult<UpdateOAuthClientMutation>;
export type UpdateOAuthClientMutationOptions = Apollo.BaseMutationOptions<UpdateOAuthClientMutation, UpdateOAuthClientMutationVariables>;
export const SetOnboardingStatusDocument = gql`
    mutation SetOnboardingStatus($isOnboarded: Boolean!) {
  setOnboardingStatus(isOnboarded: $isOnboarded) {
    message
    success
  }
}
    `;
export type SetOnboardingStatusMutationFn = Apollo.MutationFunction<SetOnboardingStatusMutation, SetOnboardingStatusMutationVariables>;

/**
 * __useSetOnboardingStatusMutation__
 *
 * To run a mutation, you first call `useSetOnboardingStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOnboardingStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOnboardingStatusMutation, { data, loading, error }] = useSetOnboardingStatusMutation({
 *   variables: {
 *      isOnboarded: // value for 'isOnboarded'
 *   },
 * });
 */
export function useSetOnboardingStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetOnboardingStatusMutation, SetOnboardingStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetOnboardingStatusMutation, SetOnboardingStatusMutationVariables>(SetOnboardingStatusDocument, options);
      }
export type SetOnboardingStatusMutationHookResult = ReturnType<typeof useSetOnboardingStatusMutation>;
export type SetOnboardingStatusMutationResult = Apollo.MutationResult<SetOnboardingStatusMutation>;
export type SetOnboardingStatusMutationOptions = Apollo.BaseMutationOptions<SetOnboardingStatusMutation, SetOnboardingStatusMutationVariables>;
export const UpdateUserModalOnboardingDocument = gql`
    mutation UpdateUserModalOnboarding($modalOnboarding: String!) {
  updateUserModalOnboarding(modalOnboarding: $modalOnboarding) {
    modalOnboarding
  }
}
    `;
export type UpdateUserModalOnboardingMutationFn = Apollo.MutationFunction<UpdateUserModalOnboardingMutation, UpdateUserModalOnboardingMutationVariables>;

/**
 * __useUpdateUserModalOnboardingMutation__
 *
 * To run a mutation, you first call `useUpdateUserModalOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserModalOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserModalOnboardingMutation, { data, loading, error }] = useUpdateUserModalOnboardingMutation({
 *   variables: {
 *      modalOnboarding: // value for 'modalOnboarding'
 *   },
 * });
 */
export function useUpdateUserModalOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserModalOnboardingMutation, UpdateUserModalOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserModalOnboardingMutation, UpdateUserModalOnboardingMutationVariables>(UpdateUserModalOnboardingDocument, options);
      }
export type UpdateUserModalOnboardingMutationHookResult = ReturnType<typeof useUpdateUserModalOnboardingMutation>;
export type UpdateUserModalOnboardingMutationResult = Apollo.MutationResult<UpdateUserModalOnboardingMutation>;
export type UpdateUserModalOnboardingMutationOptions = Apollo.BaseMutationOptions<UpdateUserModalOnboardingMutation, UpdateUserModalOnboardingMutationVariables>;
export const DeleteAccountDocument = gql`
    mutation deleteAccount {
  deleteAccount {
    success
    message
  }
}
    `;
export type DeleteAccountMutationFn = Apollo.MutationFunction<DeleteAccountMutation, DeleteAccountMutationVariables>;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountMutation, DeleteAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(DeleteAccountDocument, options);
      }
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>;
export type DeleteAccountMutationResult = Apollo.MutationResult<DeleteAccountMutation>;
export type DeleteAccountMutationOptions = Apollo.BaseMutationOptions<DeleteAccountMutation, DeleteAccountMutationVariables>;
export const ResetAccountDocument = gql`
    mutation resetAccount {
  resetAccount {
    success
    message
  }
}
    `;
export type ResetAccountMutationFn = Apollo.MutationFunction<ResetAccountMutation, ResetAccountMutationVariables>;

/**
 * __useResetAccountMutation__
 *
 * To run a mutation, you first call `useResetAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetAccountMutation, { data, loading, error }] = useResetAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useResetAccountMutation(baseOptions?: Apollo.MutationHookOptions<ResetAccountMutation, ResetAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetAccountMutation, ResetAccountMutationVariables>(ResetAccountDocument, options);
      }
export type ResetAccountMutationHookResult = ReturnType<typeof useResetAccountMutation>;
export type ResetAccountMutationResult = Apollo.MutationResult<ResetAccountMutation>;
export type ResetAccountMutationOptions = Apollo.BaseMutationOptions<ResetAccountMutation, ResetAccountMutationVariables>;
export const AddTodoDocument = gql`
    mutation AddTodo($todo: AddTodoInput!) {
  addTodo(todo: $todo) {
    success
    message
    data {
      id
      name
      description
      date
      completed_date
    }
    count
  }
}
    `;
export type AddTodoMutationFn = Apollo.MutationFunction<AddTodoMutation, AddTodoMutationVariables>;

/**
 * __useAddTodoMutation__
 *
 * To run a mutation, you first call `useAddTodoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTodoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTodoMutation, { data, loading, error }] = useAddTodoMutation({
 *   variables: {
 *      todo: // value for 'todo'
 *   },
 * });
 */
export function useAddTodoMutation(baseOptions?: Apollo.MutationHookOptions<AddTodoMutation, AddTodoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTodoMutation, AddTodoMutationVariables>(AddTodoDocument, options);
      }
export type AddTodoMutationHookResult = ReturnType<typeof useAddTodoMutation>;
export type AddTodoMutationResult = Apollo.MutationResult<AddTodoMutation>;
export type AddTodoMutationOptions = Apollo.BaseMutationOptions<AddTodoMutation, AddTodoMutationVariables>;
export const UpdateTodoDocument = gql`
    mutation UpdateTodo($id: String!, $todo: UpdateTodoInput!) {
  updateTodo(id: $id, todo: $todo) {
    success
    message
    data {
      id
      name
      description
      date
      completed_date
      completed
    }
    count
  }
}
    `;
export type UpdateTodoMutationFn = Apollo.MutationFunction<UpdateTodoMutation, UpdateTodoMutationVariables>;

/**
 * __useUpdateTodoMutation__
 *
 * To run a mutation, you first call `useUpdateTodoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTodoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTodoMutation, { data, loading, error }] = useUpdateTodoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      todo: // value for 'todo'
 *   },
 * });
 */
export function useUpdateTodoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTodoMutation, UpdateTodoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTodoMutation, UpdateTodoMutationVariables>(UpdateTodoDocument, options);
      }
export type UpdateTodoMutationHookResult = ReturnType<typeof useUpdateTodoMutation>;
export type UpdateTodoMutationResult = Apollo.MutationResult<UpdateTodoMutation>;
export type UpdateTodoMutationOptions = Apollo.BaseMutationOptions<UpdateTodoMutation, UpdateTodoMutationVariables>;
export const CreateSamlConfigDocument = gql`
    mutation CreateSamlConfig($input: SamlConfigCreateInput!) {
  createSamlConfig(input: $input) {
    success
    message
    data {
      id
    }
  }
}
    `;
export type CreateSamlConfigMutationFn = Apollo.MutationFunction<CreateSamlConfigMutation, CreateSamlConfigMutationVariables>;

/**
 * __useCreateSamlConfigMutation__
 *
 * To run a mutation, you first call `useCreateSamlConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSamlConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSamlConfigMutation, { data, loading, error }] = useCreateSamlConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSamlConfigMutation(baseOptions?: Apollo.MutationHookOptions<CreateSamlConfigMutation, CreateSamlConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSamlConfigMutation, CreateSamlConfigMutationVariables>(CreateSamlConfigDocument, options);
      }
export type CreateSamlConfigMutationHookResult = ReturnType<typeof useCreateSamlConfigMutation>;
export type CreateSamlConfigMutationResult = Apollo.MutationResult<CreateSamlConfigMutation>;
export type CreateSamlConfigMutationOptions = Apollo.BaseMutationOptions<CreateSamlConfigMutation, CreateSamlConfigMutationVariables>;
export const CreateTenantDocument = gql`
    mutation CreateTenant($tenant: TenantInput!) {
  createTenant(tenant: $tenant) {
    success
    message
    count
    data {
      id
      tenantName
      tenantDomain
      ogDescription
      ogImage
      ogImageHeight
      ogImageWidth
      ogSiteName
      ogTitle
      ogType
      stripeSubscriptionId
      hasTrial
      stripeTrialDays
      externalSendGridDailyEmailTemplateId
      externalSendGridFromEmail
      externalSendGridFromName
      externalSendGridTwilioServiceSID
      moderationSexual
      moderationHate
      moderationHarassment
      moderationSelfHarm
      moderationSexualMinors
      moderationHateThreatening
      moderationViolenceGraphic
      moderationSelfHarmIntent
      moderationSelfHarmInstructions
      moderationHarassmentThreatening
      moderationViolence
      companionName
      isCompanionMode
      key
      isLMS
      isLTI
      isAxioOffering
      isSuggestedInsights
      hasCourseEnrollment
      doRAG
      primaryColor
      gameMenuBg
      gameMenuTrack
      gameMenuProgress
      gameMenuCardBg
      emulationStatement
      learningEmulationStatement
      logo
      miniLogo
      proLogo
      showMiniLogo
      scope
      additionalScope
      termsOfServiceLink
      generalPrompt
      onboardingPrompt
      customNews
      newsSearchTerms
      showFeedback
      bugReportEmails
      upgradeModalBody
      isFreemium
      hasEmailVerification
      hasDegrees
      created
      last_modified
      isDailyEventEnabled
      emailFooterColor
      emailBackgroundColor
      hasProFlow
      stripeSecretKey
      allowFormSignup
      autoEnrollCourses
      hasLearningTopicsInChat
      favicon16Url
      favicon32Url
      favicon48Url
      favicon180Url
      favicon192Url
      favicon512Url
      faviconIcoUrl
      isTeacherNotifiedOnEnrollment
      allowStripeDiscountCodes
      officialTranscriptsUrl
      financialInformationUrl
      helpCenterUrl
      schoolResourcesUrl
      reportProblemUrl
      scheduleAdvisorCallUrl
      hasTurnBasedAssessments
      requireSSO
      allowThirdPartyCredentials
    }
  }
}
    `;
export type CreateTenantMutationFn = Apollo.MutationFunction<CreateTenantMutation, CreateTenantMutationVariables>;

/**
 * __useCreateTenantMutation__
 *
 * To run a mutation, you first call `useCreateTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTenantMutation, { data, loading, error }] = useCreateTenantMutation({
 *   variables: {
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useCreateTenantMutation(baseOptions?: Apollo.MutationHookOptions<CreateTenantMutation, CreateTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTenantMutation, CreateTenantMutationVariables>(CreateTenantDocument, options);
      }
export type CreateTenantMutationHookResult = ReturnType<typeof useCreateTenantMutation>;
export type CreateTenantMutationResult = Apollo.MutationResult<CreateTenantMutation>;
export type CreateTenantMutationOptions = Apollo.BaseMutationOptions<CreateTenantMutation, CreateTenantMutationVariables>;
export const DeleteSamlConfigDocument = gql`
    mutation DeleteSamlConfig($id: ID!) {
  deleteSamlConfig(id: $id) {
    success
    message
    data {
      id
    }
  }
}
    `;
export type DeleteSamlConfigMutationFn = Apollo.MutationFunction<DeleteSamlConfigMutation, DeleteSamlConfigMutationVariables>;

/**
 * __useDeleteSamlConfigMutation__
 *
 * To run a mutation, you first call `useDeleteSamlConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSamlConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSamlConfigMutation, { data, loading, error }] = useDeleteSamlConfigMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSamlConfigMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSamlConfigMutation, DeleteSamlConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSamlConfigMutation, DeleteSamlConfigMutationVariables>(DeleteSamlConfigDocument, options);
      }
export type DeleteSamlConfigMutationHookResult = ReturnType<typeof useDeleteSamlConfigMutation>;
export type DeleteSamlConfigMutationResult = Apollo.MutationResult<DeleteSamlConfigMutation>;
export type DeleteSamlConfigMutationOptions = Apollo.BaseMutationOptions<DeleteSamlConfigMutation, DeleteSamlConfigMutationVariables>;
export const ParseAndSaveSamlMetadataDocument = gql`
    mutation ParseAndSaveSamlMetadata($metadataUrl: String!) {
  parseAndSaveSamlMetadata(metadataUrl: $metadataUrl) {
    success
    message
    data {
      id
      entryPoint
      issuer
      cert
      callbackUrl
      emailAttribute
      firstNameAttribute
      lastNameAttribute
      signRequest
      signatureAlgorithm
      expiry
      tenant {
        id
        tenantDomain
      }
    }
  }
}
    `;
export type ParseAndSaveSamlMetadataMutationFn = Apollo.MutationFunction<ParseAndSaveSamlMetadataMutation, ParseAndSaveSamlMetadataMutationVariables>;

/**
 * __useParseAndSaveSamlMetadataMutation__
 *
 * To run a mutation, you first call `useParseAndSaveSamlMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useParseAndSaveSamlMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [parseAndSaveSamlMetadataMutation, { data, loading, error }] = useParseAndSaveSamlMetadataMutation({
 *   variables: {
 *      metadataUrl: // value for 'metadataUrl'
 *   },
 * });
 */
export function useParseAndSaveSamlMetadataMutation(baseOptions?: Apollo.MutationHookOptions<ParseAndSaveSamlMetadataMutation, ParseAndSaveSamlMetadataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ParseAndSaveSamlMetadataMutation, ParseAndSaveSamlMetadataMutationVariables>(ParseAndSaveSamlMetadataDocument, options);
      }
export type ParseAndSaveSamlMetadataMutationHookResult = ReturnType<typeof useParseAndSaveSamlMetadataMutation>;
export type ParseAndSaveSamlMetadataMutationResult = Apollo.MutationResult<ParseAndSaveSamlMetadataMutation>;
export type ParseAndSaveSamlMetadataMutationOptions = Apollo.BaseMutationOptions<ParseAndSaveSamlMetadataMutation, ParseAndSaveSamlMetadataMutationVariables>;
export const UpdateSamlConfigDocument = gql`
    mutation UpdateSamlConfig($id: ID!, $input: SamlConfigUpdateInput!) {
  updateSamlConfig(id: $id, input: $input) {
    success
    message
    data {
      id
    }
  }
}
    `;
export type UpdateSamlConfigMutationFn = Apollo.MutationFunction<UpdateSamlConfigMutation, UpdateSamlConfigMutationVariables>;

/**
 * __useUpdateSamlConfigMutation__
 *
 * To run a mutation, you first call `useUpdateSamlConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSamlConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSamlConfigMutation, { data, loading, error }] = useUpdateSamlConfigMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSamlConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSamlConfigMutation, UpdateSamlConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSamlConfigMutation, UpdateSamlConfigMutationVariables>(UpdateSamlConfigDocument, options);
      }
export type UpdateSamlConfigMutationHookResult = ReturnType<typeof useUpdateSamlConfigMutation>;
export type UpdateSamlConfigMutationResult = Apollo.MutationResult<UpdateSamlConfigMutation>;
export type UpdateSamlConfigMutationOptions = Apollo.BaseMutationOptions<UpdateSamlConfigMutation, UpdateSamlConfigMutationVariables>;
export const UpdateTenantDocument = gql`
    mutation UpdateTenant($id: ID!, $tenant: TenantInput!) {
  updateTenant(id: $id, tenant: $tenant) {
    count
    success
    message
    data {
      id
      tenantDomain
      ogDescription
      ogImage
      ogImageHeight
      ogImageWidth
      ogSiteName
      ogTitle
      ogType
      stripeSubscriptionId
      hasTrial
      stripeTrialDays
      externalSendGridDailyEmailTemplateId
      externalSendGridFromEmail
      externalSendGridFromName
      externalSendGridTwilioServiceSID
      moderationSexual
      moderationHate
      moderationHarassment
      moderationSelfHarm
      moderationSexualMinors
      moderationHateThreatening
      moderationViolenceGraphic
      moderationSelfHarmIntent
      moderationSelfHarmInstructions
      moderationHarassmentThreatening
      moderationViolence
      companionName
      isCompanionMode
      key
      isLMS
      isLTI
      isAxioOffering
      isSuggestedInsights
      axioSchools
      primaryColor
      gameMenuBg
      gameMenuTrack
      gameMenuProgress
      gameMenuCardBg
      emulationStatement
      learningEmulationStatement
      logo
      miniLogo
      proLogo
      showMiniLogo
      scope
      additionalScope
      termsOfServiceLink
      generalPrompt
      onboardingPrompt
      customNews
      newsSearchTerms
      showFeedback
      bugReportEmails
      upgradeModalBody
      isFreemium
      hasEmailVerification
      created
      last_modified
      hasProFlow
      stripeSecretKey
      hasDegrees
      hasLearningTopicsInChat
      hasTurnBasedAssessments
      allowThirdPartyCredentials
    }
  }
}
    `;
export type UpdateTenantMutationFn = Apollo.MutationFunction<UpdateTenantMutation, UpdateTenantMutationVariables>;

/**
 * __useUpdateTenantMutation__
 *
 * To run a mutation, you first call `useUpdateTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenantMutation, { data, loading, error }] = useUpdateTenantMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useUpdateTenantMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTenantMutation, UpdateTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTenantMutation, UpdateTenantMutationVariables>(UpdateTenantDocument, options);
      }
export type UpdateTenantMutationHookResult = ReturnType<typeof useUpdateTenantMutation>;
export type UpdateTenantMutationResult = Apollo.MutationResult<UpdateTenantMutation>;
export type UpdateTenantMutationOptions = Apollo.BaseMutationOptions<UpdateTenantMutation, UpdateTenantMutationVariables>;
export const UpdateTenantSettingsDocument = gql`
    mutation UpdateTenantSettings($settings: TenantSettingsInput!) {
  updateTenantSettings(settings: $settings) {
    count
    success
    message
    data {
      id
      primaryColor
      financialInformationUrl
      helpCenterUrl
      schoolResourcesUrl
      officialTranscriptsUrl
      logo
    }
  }
}
    `;
export type UpdateTenantSettingsMutationFn = Apollo.MutationFunction<UpdateTenantSettingsMutation, UpdateTenantSettingsMutationVariables>;

/**
 * __useUpdateTenantSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateTenantSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenantSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenantSettingsMutation, { data, loading, error }] = useUpdateTenantSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateTenantSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTenantSettingsMutation, UpdateTenantSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTenantSettingsMutation, UpdateTenantSettingsMutationVariables>(UpdateTenantSettingsDocument, options);
      }
export type UpdateTenantSettingsMutationHookResult = ReturnType<typeof useUpdateTenantSettingsMutation>;
export type UpdateTenantSettingsMutationResult = Apollo.MutationResult<UpdateTenantSettingsMutation>;
export type UpdateTenantSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateTenantSettingsMutation, UpdateTenantSettingsMutationVariables>;
export const UploadFaviconDocument = gql`
    mutation UploadFavicon($favicon: String!, $contentType: String!, $size: Int!) {
  uploadFavicon(favicon: $favicon, contentType: $contentType, size: $size) {
    success
    message
    data
  }
}
    `;
export type UploadFaviconMutationFn = Apollo.MutationFunction<UploadFaviconMutation, UploadFaviconMutationVariables>;

/**
 * __useUploadFaviconMutation__
 *
 * To run a mutation, you first call `useUploadFaviconMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFaviconMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFaviconMutation, { data, loading, error }] = useUploadFaviconMutation({
 *   variables: {
 *      favicon: // value for 'favicon'
 *      contentType: // value for 'contentType'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useUploadFaviconMutation(baseOptions?: Apollo.MutationHookOptions<UploadFaviconMutation, UploadFaviconMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadFaviconMutation, UploadFaviconMutationVariables>(UploadFaviconDocument, options);
      }
export type UploadFaviconMutationHookResult = ReturnType<typeof useUploadFaviconMutation>;
export type UploadFaviconMutationResult = Apollo.MutationResult<UploadFaviconMutation>;
export type UploadFaviconMutationOptions = Apollo.BaseMutationOptions<UploadFaviconMutation, UploadFaviconMutationVariables>;
export const UpdateContentSafetySettingsDocument = gql`
    mutation UpdateContentSafetySettings($settings: ContentSafetySettingsInput!) {
  updateContentSafetySettings(settings: $settings) {
    count
    success
    message
    data {
      sexual
      hate
      harassment
      selfHarm
      violence
    }
  }
}
    `;
export type UpdateContentSafetySettingsMutationFn = Apollo.MutationFunction<UpdateContentSafetySettingsMutation, UpdateContentSafetySettingsMutationVariables>;

/**
 * __useUpdateContentSafetySettingsMutation__
 *
 * To run a mutation, you first call `useUpdateContentSafetySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentSafetySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentSafetySettingsMutation, { data, loading, error }] = useUpdateContentSafetySettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateContentSafetySettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentSafetySettingsMutation, UpdateContentSafetySettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentSafetySettingsMutation, UpdateContentSafetySettingsMutationVariables>(UpdateContentSafetySettingsDocument, options);
      }
export type UpdateContentSafetySettingsMutationHookResult = ReturnType<typeof useUpdateContentSafetySettingsMutation>;
export type UpdateContentSafetySettingsMutationResult = Apollo.MutationResult<UpdateContentSafetySettingsMutation>;
export type UpdateContentSafetySettingsMutationOptions = Apollo.BaseMutationOptions<UpdateContentSafetySettingsMutation, UpdateContentSafetySettingsMutationVariables>;
export const AssignCourseToFacultyDocument = gql`
    mutation AssignCourseToFaculty($userIds: [ID!]!, $courseId: ID!) {
  assignCourseToFaculty(userIds: $userIds, courseId: $courseId) {
    success
    message
  }
}
    `;
export type AssignCourseToFacultyMutationFn = Apollo.MutationFunction<AssignCourseToFacultyMutation, AssignCourseToFacultyMutationVariables>;

/**
 * __useAssignCourseToFacultyMutation__
 *
 * To run a mutation, you first call `useAssignCourseToFacultyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignCourseToFacultyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignCourseToFacultyMutation, { data, loading, error }] = useAssignCourseToFacultyMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useAssignCourseToFacultyMutation(baseOptions?: Apollo.MutationHookOptions<AssignCourseToFacultyMutation, AssignCourseToFacultyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignCourseToFacultyMutation, AssignCourseToFacultyMutationVariables>(AssignCourseToFacultyDocument, options);
      }
export type AssignCourseToFacultyMutationHookResult = ReturnType<typeof useAssignCourseToFacultyMutation>;
export type AssignCourseToFacultyMutationResult = Apollo.MutationResult<AssignCourseToFacultyMutation>;
export type AssignCourseToFacultyMutationOptions = Apollo.BaseMutationOptions<AssignCourseToFacultyMutation, AssignCourseToFacultyMutationVariables>;
export const InviteUserToSchoolDocument = gql`
    mutation InviteUserToSchool($input: InviteUserToSchoolInput!) {
  inviteUserToSchool(input: $input) {
    success
    message
  }
}
    `;
export type InviteUserToSchoolMutationFn = Apollo.MutationFunction<InviteUserToSchoolMutation, InviteUserToSchoolMutationVariables>;

/**
 * __useInviteUserToSchoolMutation__
 *
 * To run a mutation, you first call `useInviteUserToSchoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserToSchoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserToSchoolMutation, { data, loading, error }] = useInviteUserToSchoolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteUserToSchoolMutation(baseOptions?: Apollo.MutationHookOptions<InviteUserToSchoolMutation, InviteUserToSchoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUserToSchoolMutation, InviteUserToSchoolMutationVariables>(InviteUserToSchoolDocument, options);
      }
export type InviteUserToSchoolMutationHookResult = ReturnType<typeof useInviteUserToSchoolMutation>;
export type InviteUserToSchoolMutationResult = Apollo.MutationResult<InviteUserToSchoolMutation>;
export type InviteUserToSchoolMutationOptions = Apollo.BaseMutationOptions<InviteUserToSchoolMutation, InviteUserToSchoolMutationVariables>;
export const RemoveCourseAssignmentFromFacultyDocument = gql`
    mutation RemoveCourseAssignmentFromFaculty($userIds: [ID!]!, $courseId: ID!) {
  removeCourseAssignmentFromFaculty(userIds: $userIds, courseId: $courseId) {
    success
    message
  }
}
    `;
export type RemoveCourseAssignmentFromFacultyMutationFn = Apollo.MutationFunction<RemoveCourseAssignmentFromFacultyMutation, RemoveCourseAssignmentFromFacultyMutationVariables>;

/**
 * __useRemoveCourseAssignmentFromFacultyMutation__
 *
 * To run a mutation, you first call `useRemoveCourseAssignmentFromFacultyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCourseAssignmentFromFacultyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCourseAssignmentFromFacultyMutation, { data, loading, error }] = useRemoveCourseAssignmentFromFacultyMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useRemoveCourseAssignmentFromFacultyMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCourseAssignmentFromFacultyMutation, RemoveCourseAssignmentFromFacultyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCourseAssignmentFromFacultyMutation, RemoveCourseAssignmentFromFacultyMutationVariables>(RemoveCourseAssignmentFromFacultyDocument, options);
      }
export type RemoveCourseAssignmentFromFacultyMutationHookResult = ReturnType<typeof useRemoveCourseAssignmentFromFacultyMutation>;
export type RemoveCourseAssignmentFromFacultyMutationResult = Apollo.MutationResult<RemoveCourseAssignmentFromFacultyMutation>;
export type RemoveCourseAssignmentFromFacultyMutationOptions = Apollo.BaseMutationOptions<RemoveCourseAssignmentFromFacultyMutation, RemoveCourseAssignmentFromFacultyMutationVariables>;
export const RevokeFacultyDocument = gql`
    mutation RevokeFaculty($userId: ID!) {
  revokeFaculty(userId: $userId) {
    success
    message
  }
}
    `;
export type RevokeFacultyMutationFn = Apollo.MutationFunction<RevokeFacultyMutation, RevokeFacultyMutationVariables>;

/**
 * __useRevokeFacultyMutation__
 *
 * To run a mutation, you first call `useRevokeFacultyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeFacultyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeFacultyMutation, { data, loading, error }] = useRevokeFacultyMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRevokeFacultyMutation(baseOptions?: Apollo.MutationHookOptions<RevokeFacultyMutation, RevokeFacultyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeFacultyMutation, RevokeFacultyMutationVariables>(RevokeFacultyDocument, options);
      }
export type RevokeFacultyMutationHookResult = ReturnType<typeof useRevokeFacultyMutation>;
export type RevokeFacultyMutationResult = Apollo.MutationResult<RevokeFacultyMutation>;
export type RevokeFacultyMutationOptions = Apollo.BaseMutationOptions<RevokeFacultyMutation, RevokeFacultyMutationVariables>;
export const UpdateFacultyProfileDocument = gql`
    mutation UpdateFacultyProfile($input: UpdateFacultyProfileInput!) {
  updateFacultyProfile(input: $input) {
    success
    message
  }
}
    `;
export type UpdateFacultyProfileMutationFn = Apollo.MutationFunction<UpdateFacultyProfileMutation, UpdateFacultyProfileMutationVariables>;

/**
 * __useUpdateFacultyProfileMutation__
 *
 * To run a mutation, you first call `useUpdateFacultyProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFacultyProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFacultyProfileMutation, { data, loading, error }] = useUpdateFacultyProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFacultyProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFacultyProfileMutation, UpdateFacultyProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFacultyProfileMutation, UpdateFacultyProfileMutationVariables>(UpdateFacultyProfileDocument, options);
      }
export type UpdateFacultyProfileMutationHookResult = ReturnType<typeof useUpdateFacultyProfileMutation>;
export type UpdateFacultyProfileMutationResult = Apollo.MutationResult<UpdateFacultyProfileMutation>;
export type UpdateFacultyProfileMutationOptions = Apollo.BaseMutationOptions<UpdateFacultyProfileMutation, UpdateFacultyProfileMutationVariables>;
export const UpdateUserLearningPreferencesDocument = gql`
    mutation UpdateUserLearningPreferences($input: UpdateUserLearningPreferencesInput!) {
  updateUserLearningPreferences(input: $input) {
    id
    interests
    careerInterests
    skillsToImprove
    learningStyles
    motivations
    semesterGoal
    studyTimePreference
    checkInFrequency
    assignmentReminders
    textReminders
  }
}
    `;
export type UpdateUserLearningPreferencesMutationFn = Apollo.MutationFunction<UpdateUserLearningPreferencesMutation, UpdateUserLearningPreferencesMutationVariables>;

/**
 * __useUpdateUserLearningPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateUserLearningPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserLearningPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserLearningPreferencesMutation, { data, loading, error }] = useUpdateUserLearningPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserLearningPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserLearningPreferencesMutation, UpdateUserLearningPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserLearningPreferencesMutation, UpdateUserLearningPreferencesMutationVariables>(UpdateUserLearningPreferencesDocument, options);
      }
export type UpdateUserLearningPreferencesMutationHookResult = ReturnType<typeof useUpdateUserLearningPreferencesMutation>;
export type UpdateUserLearningPreferencesMutationResult = Apollo.MutationResult<UpdateUserLearningPreferencesMutation>;
export type UpdateUserLearningPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateUserLearningPreferencesMutation, UpdateUserLearningPreferencesMutationVariables>;
export const UpsertCompanionOnboardingStateDocument = gql`
    mutation UpsertCompanionOnboardingState($input: CompanionOnboardingStateInput!) {
  upsertCompanionOnboardingState(input: $input) {
    success
    message
    state {
      status
      step
      deferredUntil
      last_modified
      payload {
        interests
        careerInterests
        skillsToImprove
        learningStyles
        motivations
        semesterGoal
        studyTimePreference
        checkInFrequency
        assignmentReminders
        textReminders
      }
    }
  }
}
    `;
export type UpsertCompanionOnboardingStateMutationFn = Apollo.MutationFunction<UpsertCompanionOnboardingStateMutation, UpsertCompanionOnboardingStateMutationVariables>;

/**
 * __useUpsertCompanionOnboardingStateMutation__
 *
 * To run a mutation, you first call `useUpsertCompanionOnboardingStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCompanionOnboardingStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCompanionOnboardingStateMutation, { data, loading, error }] = useUpsertCompanionOnboardingStateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertCompanionOnboardingStateMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCompanionOnboardingStateMutation, UpsertCompanionOnboardingStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCompanionOnboardingStateMutation, UpsertCompanionOnboardingStateMutationVariables>(UpsertCompanionOnboardingStateDocument, options);
      }
export type UpsertCompanionOnboardingStateMutationHookResult = ReturnType<typeof useUpsertCompanionOnboardingStateMutation>;
export type UpsertCompanionOnboardingStateMutationResult = Apollo.MutationResult<UpsertCompanionOnboardingStateMutation>;
export type UpsertCompanionOnboardingStateMutationOptions = Apollo.BaseMutationOptions<UpsertCompanionOnboardingStateMutation, UpsertCompanionOnboardingStateMutationVariables>;
export const EndVisitSessionDocument = gql`
    mutation EndVisitSession($sessionId: ID!) {
  endVisitSession(sessionId: $sessionId) {
    id
    startTime
    lastActiveTime
    ended
  }
}
    `;
export type EndVisitSessionMutationFn = Apollo.MutationFunction<EndVisitSessionMutation, EndVisitSessionMutationVariables>;

/**
 * __useEndVisitSessionMutation__
 *
 * To run a mutation, you first call `useEndVisitSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndVisitSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endVisitSessionMutation, { data, loading, error }] = useEndVisitSessionMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useEndVisitSessionMutation(baseOptions?: Apollo.MutationHookOptions<EndVisitSessionMutation, EndVisitSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EndVisitSessionMutation, EndVisitSessionMutationVariables>(EndVisitSessionDocument, options);
      }
export type EndVisitSessionMutationHookResult = ReturnType<typeof useEndVisitSessionMutation>;
export type EndVisitSessionMutationResult = Apollo.MutationResult<EndVisitSessionMutation>;
export type EndVisitSessionMutationOptions = Apollo.BaseMutationOptions<EndVisitSessionMutation, EndVisitSessionMutationVariables>;
export const StartVisitSessionDocument = gql`
    mutation StartVisitSession {
  startVisitSession {
    id
    startTime
    lastActiveTime
  }
}
    `;
export type StartVisitSessionMutationFn = Apollo.MutationFunction<StartVisitSessionMutation, StartVisitSessionMutationVariables>;

/**
 * __useStartVisitSessionMutation__
 *
 * To run a mutation, you first call `useStartVisitSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartVisitSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startVisitSessionMutation, { data, loading, error }] = useStartVisitSessionMutation({
 *   variables: {
 *   },
 * });
 */
export function useStartVisitSessionMutation(baseOptions?: Apollo.MutationHookOptions<StartVisitSessionMutation, StartVisitSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartVisitSessionMutation, StartVisitSessionMutationVariables>(StartVisitSessionDocument, options);
      }
export type StartVisitSessionMutationHookResult = ReturnType<typeof useStartVisitSessionMutation>;
export type StartVisitSessionMutationResult = Apollo.MutationResult<StartVisitSessionMutation>;
export type StartVisitSessionMutationOptions = Apollo.BaseMutationOptions<StartVisitSessionMutation, StartVisitSessionMutationVariables>;
export const TrackPageVisitDocument = gql`
    mutation TrackPageVisit($sessionId: ID!, $path: String!) {
  trackPageVisit(sessionId: $sessionId, path: $path) {
    id
    path
    timestamp
  }
}
    `;
export type TrackPageVisitMutationFn = Apollo.MutationFunction<TrackPageVisitMutation, TrackPageVisitMutationVariables>;

/**
 * __useTrackPageVisitMutation__
 *
 * To run a mutation, you first call `useTrackPageVisitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackPageVisitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackPageVisitMutation, { data, loading, error }] = useTrackPageVisitMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      path: // value for 'path'
 *   },
 * });
 */
export function useTrackPageVisitMutation(baseOptions?: Apollo.MutationHookOptions<TrackPageVisitMutation, TrackPageVisitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackPageVisitMutation, TrackPageVisitMutationVariables>(TrackPageVisitDocument, options);
      }
export type TrackPageVisitMutationHookResult = ReturnType<typeof useTrackPageVisitMutation>;
export type TrackPageVisitMutationResult = Apollo.MutationResult<TrackPageVisitMutation>;
export type TrackPageVisitMutationOptions = Apollo.BaseMutationOptions<TrackPageVisitMutation, TrackPageVisitMutationVariables>;
export const UpdateVisitSessionDocument = gql`
    mutation UpdateVisitSession($sessionId: ID!) {
  updateVisitSession(sessionId: $sessionId) {
    id
    lastActiveTime
  }
}
    `;
export type UpdateVisitSessionMutationFn = Apollo.MutationFunction<UpdateVisitSessionMutation, UpdateVisitSessionMutationVariables>;

/**
 * __useUpdateVisitSessionMutation__
 *
 * To run a mutation, you first call `useUpdateVisitSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVisitSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVisitSessionMutation, { data, loading, error }] = useUpdateVisitSessionMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useUpdateVisitSessionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVisitSessionMutation, UpdateVisitSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVisitSessionMutation, UpdateVisitSessionMutationVariables>(UpdateVisitSessionDocument, options);
      }
export type UpdateVisitSessionMutationHookResult = ReturnType<typeof useUpdateVisitSessionMutation>;
export type UpdateVisitSessionMutationResult = Apollo.MutationResult<UpdateVisitSessionMutation>;
export type UpdateVisitSessionMutationOptions = Apollo.BaseMutationOptions<UpdateVisitSessionMutation, UpdateVisitSessionMutationVariables>;
export const CreateVisualizationFromContentDocument = gql`
    mutation CreateVisualizationFromContent($title: String!, $description: String!, $objectives: [ObjectiveInput!]!) {
  createVisualizationFromContent(
    content: {title: $title, description: $description, objectives: $objectives}
  ) {
    success
    message
    data {
      id
      code
      visualizationType
      created
      lastModified
    }
    count
  }
}
    `;
export type CreateVisualizationFromContentMutationFn = Apollo.MutationFunction<CreateVisualizationFromContentMutation, CreateVisualizationFromContentMutationVariables>;

/**
 * __useCreateVisualizationFromContentMutation__
 *
 * To run a mutation, you first call `useCreateVisualizationFromContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVisualizationFromContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVisualizationFromContentMutation, { data, loading, error }] = useCreateVisualizationFromContentMutation({
 *   variables: {
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      objectives: // value for 'objectives'
 *   },
 * });
 */
export function useCreateVisualizationFromContentMutation(baseOptions?: Apollo.MutationHookOptions<CreateVisualizationFromContentMutation, CreateVisualizationFromContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVisualizationFromContentMutation, CreateVisualizationFromContentMutationVariables>(CreateVisualizationFromContentDocument, options);
      }
export type CreateVisualizationFromContentMutationHookResult = ReturnType<typeof useCreateVisualizationFromContentMutation>;
export type CreateVisualizationFromContentMutationResult = Apollo.MutationResult<CreateVisualizationFromContentMutation>;
export type CreateVisualizationFromContentMutationOptions = Apollo.BaseMutationOptions<CreateVisualizationFromContentMutation, CreateVisualizationFromContentMutationVariables>;
export const DeleteVisualizationDocument = gql`
    mutation DeleteVisualization($id: ID!) {
  deleteVisualization(id: $id) {
    count
    message
    success
  }
}
    `;
export type DeleteVisualizationMutationFn = Apollo.MutationFunction<DeleteVisualizationMutation, DeleteVisualizationMutationVariables>;

/**
 * __useDeleteVisualizationMutation__
 *
 * To run a mutation, you first call `useDeleteVisualizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVisualizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVisualizationMutation, { data, loading, error }] = useDeleteVisualizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVisualizationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVisualizationMutation, DeleteVisualizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVisualizationMutation, DeleteVisualizationMutationVariables>(DeleteVisualizationDocument, options);
      }
export type DeleteVisualizationMutationHookResult = ReturnType<typeof useDeleteVisualizationMutation>;
export type DeleteVisualizationMutationResult = Apollo.MutationResult<DeleteVisualizationMutation>;
export type DeleteVisualizationMutationOptions = Apollo.BaseMutationOptions<DeleteVisualizationMutation, DeleteVisualizationMutationVariables>;
export const UpdateVisualizationDocument = gql`
    mutation UpdateVisualization($id: ID!, $title: String!, $description: String!, $objectives: [ObjectiveInput!]!) {
  updateVisualization(
    id: $id
    content: {title: $title, description: $description, objectives: $objectives}
  ) {
    success
    message
    data {
      id
      code
      visualizationType
      created
      lastModified
    }
    count
  }
}
    `;
export type UpdateVisualizationMutationFn = Apollo.MutationFunction<UpdateVisualizationMutation, UpdateVisualizationMutationVariables>;

/**
 * __useUpdateVisualizationMutation__
 *
 * To run a mutation, you first call `useUpdateVisualizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVisualizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVisualizationMutation, { data, loading, error }] = useUpdateVisualizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      objectives: // value for 'objectives'
 *   },
 * });
 */
export function useUpdateVisualizationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVisualizationMutation, UpdateVisualizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVisualizationMutation, UpdateVisualizationMutationVariables>(UpdateVisualizationDocument, options);
      }
export type UpdateVisualizationMutationHookResult = ReturnType<typeof useUpdateVisualizationMutation>;
export type UpdateVisualizationMutationResult = Apollo.MutationResult<UpdateVisualizationMutation>;
export type UpdateVisualizationMutationOptions = Apollo.BaseMutationOptions<UpdateVisualizationMutation, UpdateVisualizationMutationVariables>;
export const GetUserChatMessageAnalyticsDocument = gql`
    query GetUserChatMessageAnalytics($input: UserChatMessageAnalyticsInput!) {
  getUserChatMessageAnalytics(input: $input) {
    success
    message
    data {
      id
      name
      email
      studentMessagesCount
      aiMessagesCount
      totalMessages
    }
    count
    totalCount
    availableCourses {
      id
      name
    }
  }
}
    `;

/**
 * __useGetUserChatMessageAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetUserChatMessageAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserChatMessageAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserChatMessageAnalyticsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUserChatMessageAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetUserChatMessageAnalyticsQuery, GetUserChatMessageAnalyticsQueryVariables> & ({ variables: GetUserChatMessageAnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserChatMessageAnalyticsQuery, GetUserChatMessageAnalyticsQueryVariables>(GetUserChatMessageAnalyticsDocument, options);
      }
export function useGetUserChatMessageAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserChatMessageAnalyticsQuery, GetUserChatMessageAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserChatMessageAnalyticsQuery, GetUserChatMessageAnalyticsQueryVariables>(GetUserChatMessageAnalyticsDocument, options);
        }
// @ts-ignore
export function useGetUserChatMessageAnalyticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserChatMessageAnalyticsQuery, GetUserChatMessageAnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserChatMessageAnalyticsQuery, GetUserChatMessageAnalyticsQueryVariables>;
export function useGetUserChatMessageAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserChatMessageAnalyticsQuery, GetUserChatMessageAnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserChatMessageAnalyticsQuery | undefined, GetUserChatMessageAnalyticsQueryVariables>;
export function useGetUserChatMessageAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserChatMessageAnalyticsQuery, GetUserChatMessageAnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserChatMessageAnalyticsQuery, GetUserChatMessageAnalyticsQueryVariables>(GetUserChatMessageAnalyticsDocument, options);
        }
export type GetUserChatMessageAnalyticsQueryHookResult = ReturnType<typeof useGetUserChatMessageAnalyticsQuery>;
export type GetUserChatMessageAnalyticsLazyQueryHookResult = ReturnType<typeof useGetUserChatMessageAnalyticsLazyQuery>;
export type GetUserChatMessageAnalyticsSuspenseQueryHookResult = ReturnType<typeof useGetUserChatMessageAnalyticsSuspenseQuery>;
export type GetUserChatMessageAnalyticsQueryResult = Apollo.QueryResult<GetUserChatMessageAnalyticsQuery, GetUserChatMessageAnalyticsQueryVariables>;
export const GetAdminDashboardMetricsDocument = gql`
    query GetAdminDashboardMetrics($schoolId: ID!) {
  getAdminDashboardMetrics(schoolId: $schoolId) {
    success
    message
    data {
      totalStudents
      activeCourses
    }
  }
}
    `;

/**
 * __useGetAdminDashboardMetricsQuery__
 *
 * To run a query within a React component, call `useGetAdminDashboardMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminDashboardMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminDashboardMetricsQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetAdminDashboardMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetAdminDashboardMetricsQuery, GetAdminDashboardMetricsQueryVariables> & ({ variables: GetAdminDashboardMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminDashboardMetricsQuery, GetAdminDashboardMetricsQueryVariables>(GetAdminDashboardMetricsDocument, options);
      }
export function useGetAdminDashboardMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminDashboardMetricsQuery, GetAdminDashboardMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminDashboardMetricsQuery, GetAdminDashboardMetricsQueryVariables>(GetAdminDashboardMetricsDocument, options);
        }
// @ts-ignore
export function useGetAdminDashboardMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminDashboardMetricsQuery, GetAdminDashboardMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAdminDashboardMetricsQuery, GetAdminDashboardMetricsQueryVariables>;
export function useGetAdminDashboardMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminDashboardMetricsQuery, GetAdminDashboardMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAdminDashboardMetricsQuery | undefined, GetAdminDashboardMetricsQueryVariables>;
export function useGetAdminDashboardMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminDashboardMetricsQuery, GetAdminDashboardMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminDashboardMetricsQuery, GetAdminDashboardMetricsQueryVariables>(GetAdminDashboardMetricsDocument, options);
        }
export type GetAdminDashboardMetricsQueryHookResult = ReturnType<typeof useGetAdminDashboardMetricsQuery>;
export type GetAdminDashboardMetricsLazyQueryHookResult = ReturnType<typeof useGetAdminDashboardMetricsLazyQuery>;
export type GetAdminDashboardMetricsSuspenseQueryHookResult = ReturnType<typeof useGetAdminDashboardMetricsSuspenseQuery>;
export type GetAdminDashboardMetricsQueryResult = Apollo.QueryResult<GetAdminDashboardMetricsQuery, GetAdminDashboardMetricsQueryVariables>;
export const GetActivityCompletionDetailsDocument = gql`
    query GetActivityCompletionDetails($aiTutorId: ID!) {
  getActivityCompletionDetails(aiTutorId: $aiTutorId) {
    success
    message
    count
    data {
      id
      label
      module_id
      module_name
      course_id
      course_name
      completionStats {
        completed
        inProgress
        notStarted
      }
      details {
        objectives {
          id
          label
          completionStats {
            completed
            inProgress
            notStarted
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetActivityCompletionDetailsQuery__
 *
 * To run a query within a React component, call `useGetActivityCompletionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityCompletionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityCompletionDetailsQuery({
 *   variables: {
 *      aiTutorId: // value for 'aiTutorId'
 *   },
 * });
 */
export function useGetActivityCompletionDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetActivityCompletionDetailsQuery, GetActivityCompletionDetailsQueryVariables> & ({ variables: GetActivityCompletionDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityCompletionDetailsQuery, GetActivityCompletionDetailsQueryVariables>(GetActivityCompletionDetailsDocument, options);
      }
export function useGetActivityCompletionDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityCompletionDetailsQuery, GetActivityCompletionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityCompletionDetailsQuery, GetActivityCompletionDetailsQueryVariables>(GetActivityCompletionDetailsDocument, options);
        }
// @ts-ignore
export function useGetActivityCompletionDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActivityCompletionDetailsQuery, GetActivityCompletionDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetActivityCompletionDetailsQuery, GetActivityCompletionDetailsQueryVariables>;
export function useGetActivityCompletionDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActivityCompletionDetailsQuery, GetActivityCompletionDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetActivityCompletionDetailsQuery | undefined, GetActivityCompletionDetailsQueryVariables>;
export function useGetActivityCompletionDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActivityCompletionDetailsQuery, GetActivityCompletionDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActivityCompletionDetailsQuery, GetActivityCompletionDetailsQueryVariables>(GetActivityCompletionDetailsDocument, options);
        }
export type GetActivityCompletionDetailsQueryHookResult = ReturnType<typeof useGetActivityCompletionDetailsQuery>;
export type GetActivityCompletionDetailsLazyQueryHookResult = ReturnType<typeof useGetActivityCompletionDetailsLazyQuery>;
export type GetActivityCompletionDetailsSuspenseQueryHookResult = ReturnType<typeof useGetActivityCompletionDetailsSuspenseQuery>;
export type GetActivityCompletionDetailsQueryResult = Apollo.QueryResult<GetActivityCompletionDetailsQuery, GetActivityCompletionDetailsQueryVariables>;
export const GetCourseCompletionDetailsDocument = gql`
    query GetCourseCompletionDetails($courseId: ID!) {
  getCourseCompletionDetails(courseId: $courseId) {
    success
    message
    count
    data {
      id
      label
      completionStats {
        completed
        inProgress
        notStarted
      }
      details {
        modules {
          id
          label
          completionStats {
            completed
            inProgress
            notStarted
          }
          details {
            activities {
              id
              label
              completionStats {
                completed
                inProgress
                notStarted
              }
              details {
                objectives {
                  id
                  label
                  completionStats {
                    completed
                    inProgress
                    notStarted
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCourseCompletionDetailsQuery__
 *
 * To run a query within a React component, call `useGetCourseCompletionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseCompletionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseCompletionDetailsQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetCourseCompletionDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetCourseCompletionDetailsQuery, GetCourseCompletionDetailsQueryVariables> & ({ variables: GetCourseCompletionDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseCompletionDetailsQuery, GetCourseCompletionDetailsQueryVariables>(GetCourseCompletionDetailsDocument, options);
      }
export function useGetCourseCompletionDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseCompletionDetailsQuery, GetCourseCompletionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseCompletionDetailsQuery, GetCourseCompletionDetailsQueryVariables>(GetCourseCompletionDetailsDocument, options);
        }
// @ts-ignore
export function useGetCourseCompletionDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCourseCompletionDetailsQuery, GetCourseCompletionDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseCompletionDetailsQuery, GetCourseCompletionDetailsQueryVariables>;
export function useGetCourseCompletionDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseCompletionDetailsQuery, GetCourseCompletionDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseCompletionDetailsQuery | undefined, GetCourseCompletionDetailsQueryVariables>;
export function useGetCourseCompletionDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseCompletionDetailsQuery, GetCourseCompletionDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseCompletionDetailsQuery, GetCourseCompletionDetailsQueryVariables>(GetCourseCompletionDetailsDocument, options);
        }
export type GetCourseCompletionDetailsQueryHookResult = ReturnType<typeof useGetCourseCompletionDetailsQuery>;
export type GetCourseCompletionDetailsLazyQueryHookResult = ReturnType<typeof useGetCourseCompletionDetailsLazyQuery>;
export type GetCourseCompletionDetailsSuspenseQueryHookResult = ReturnType<typeof useGetCourseCompletionDetailsSuspenseQuery>;
export type GetCourseCompletionDetailsQueryResult = Apollo.QueryResult<GetCourseCompletionDetailsQuery, GetCourseCompletionDetailsQueryVariables>;
export const GetCourseCompletionSummaryBySchoolDocument = gql`
    query GetCourseCompletionSummaryBySchool($schoolId: ID!, $searchQuery: String, $page: Int, $pageSize: Int, $sortBy: String) {
  getCourseCompletionSummaryBySchool(
    schoolId: $schoolId
    searchQuery: $searchQuery
    page: $page
    pageSize: $pageSize
    sortBy: $sortBy
  ) {
    success
    message
    count
    data {
      id
      label
      completionStats {
        completed
        inProgress
        notStarted
      }
    }
  }
}
    `;

/**
 * __useGetCourseCompletionSummaryBySchoolQuery__
 *
 * To run a query within a React component, call `useGetCourseCompletionSummaryBySchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseCompletionSummaryBySchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseCompletionSummaryBySchoolQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      searchQuery: // value for 'searchQuery'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetCourseCompletionSummaryBySchoolQuery(baseOptions: Apollo.QueryHookOptions<GetCourseCompletionSummaryBySchoolQuery, GetCourseCompletionSummaryBySchoolQueryVariables> & ({ variables: GetCourseCompletionSummaryBySchoolQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseCompletionSummaryBySchoolQuery, GetCourseCompletionSummaryBySchoolQueryVariables>(GetCourseCompletionSummaryBySchoolDocument, options);
      }
export function useGetCourseCompletionSummaryBySchoolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseCompletionSummaryBySchoolQuery, GetCourseCompletionSummaryBySchoolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseCompletionSummaryBySchoolQuery, GetCourseCompletionSummaryBySchoolQueryVariables>(GetCourseCompletionSummaryBySchoolDocument, options);
        }
// @ts-ignore
export function useGetCourseCompletionSummaryBySchoolSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCourseCompletionSummaryBySchoolQuery, GetCourseCompletionSummaryBySchoolQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseCompletionSummaryBySchoolQuery, GetCourseCompletionSummaryBySchoolQueryVariables>;
export function useGetCourseCompletionSummaryBySchoolSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseCompletionSummaryBySchoolQuery, GetCourseCompletionSummaryBySchoolQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseCompletionSummaryBySchoolQuery | undefined, GetCourseCompletionSummaryBySchoolQueryVariables>;
export function useGetCourseCompletionSummaryBySchoolSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseCompletionSummaryBySchoolQuery, GetCourseCompletionSummaryBySchoolQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseCompletionSummaryBySchoolQuery, GetCourseCompletionSummaryBySchoolQueryVariables>(GetCourseCompletionSummaryBySchoolDocument, options);
        }
export type GetCourseCompletionSummaryBySchoolQueryHookResult = ReturnType<typeof useGetCourseCompletionSummaryBySchoolQuery>;
export type GetCourseCompletionSummaryBySchoolLazyQueryHookResult = ReturnType<typeof useGetCourseCompletionSummaryBySchoolLazyQuery>;
export type GetCourseCompletionSummaryBySchoolSuspenseQueryHookResult = ReturnType<typeof useGetCourseCompletionSummaryBySchoolSuspenseQuery>;
export type GetCourseCompletionSummaryBySchoolQueryResult = Apollo.QueryResult<GetCourseCompletionSummaryBySchoolQuery, GetCourseCompletionSummaryBySchoolQueryVariables>;
export const GetModuleCompletionDetailsDocument = gql`
    query GetModuleCompletionDetails($moduleId: ID!) {
  getModuleCompletionDetails(moduleId: $moduleId) {
    success
    message
    count
    data {
      id
      label
      course_id
      course_name
      completionStats {
        completed
        inProgress
        notStarted
      }
      details {
        activities {
          id
          label
          completionStats {
            completed
            inProgress
            notStarted
          }
          details {
            objectives {
              id
              label
              completionStats {
                completed
                inProgress
                notStarted
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetModuleCompletionDetailsQuery__
 *
 * To run a query within a React component, call `useGetModuleCompletionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModuleCompletionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModuleCompletionDetailsQuery({
 *   variables: {
 *      moduleId: // value for 'moduleId'
 *   },
 * });
 */
export function useGetModuleCompletionDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetModuleCompletionDetailsQuery, GetModuleCompletionDetailsQueryVariables> & ({ variables: GetModuleCompletionDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetModuleCompletionDetailsQuery, GetModuleCompletionDetailsQueryVariables>(GetModuleCompletionDetailsDocument, options);
      }
export function useGetModuleCompletionDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModuleCompletionDetailsQuery, GetModuleCompletionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetModuleCompletionDetailsQuery, GetModuleCompletionDetailsQueryVariables>(GetModuleCompletionDetailsDocument, options);
        }
// @ts-ignore
export function useGetModuleCompletionDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetModuleCompletionDetailsQuery, GetModuleCompletionDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetModuleCompletionDetailsQuery, GetModuleCompletionDetailsQueryVariables>;
export function useGetModuleCompletionDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetModuleCompletionDetailsQuery, GetModuleCompletionDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetModuleCompletionDetailsQuery | undefined, GetModuleCompletionDetailsQueryVariables>;
export function useGetModuleCompletionDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetModuleCompletionDetailsQuery, GetModuleCompletionDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetModuleCompletionDetailsQuery, GetModuleCompletionDetailsQueryVariables>(GetModuleCompletionDetailsDocument, options);
        }
export type GetModuleCompletionDetailsQueryHookResult = ReturnType<typeof useGetModuleCompletionDetailsQuery>;
export type GetModuleCompletionDetailsLazyQueryHookResult = ReturnType<typeof useGetModuleCompletionDetailsLazyQuery>;
export type GetModuleCompletionDetailsSuspenseQueryHookResult = ReturnType<typeof useGetModuleCompletionDetailsSuspenseQuery>;
export type GetModuleCompletionDetailsQueryResult = Apollo.QueryResult<GetModuleCompletionDetailsQuery, GetModuleCompletionDetailsQueryVariables>;
export const GetObjectiveCompletionDetailsDocument = gql`
    query GetObjectiveCompletionDetails($objectiveId: ID!) {
  getObjectiveCompletionDetails(objectiveId: $objectiveId) {
    success
    message
    data {
      id
      label
      aiTutor_id
      aiTutor_name
      module_id
      module_name
      course_id
      course_name
      completionStats {
        completed
        inProgress
        notStarted
      }
    }
    count
  }
}
    `;

/**
 * __useGetObjectiveCompletionDetailsQuery__
 *
 * To run a query within a React component, call `useGetObjectiveCompletionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetObjectiveCompletionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetObjectiveCompletionDetailsQuery({
 *   variables: {
 *      objectiveId: // value for 'objectiveId'
 *   },
 * });
 */
export function useGetObjectiveCompletionDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetObjectiveCompletionDetailsQuery, GetObjectiveCompletionDetailsQueryVariables> & ({ variables: GetObjectiveCompletionDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetObjectiveCompletionDetailsQuery, GetObjectiveCompletionDetailsQueryVariables>(GetObjectiveCompletionDetailsDocument, options);
      }
export function useGetObjectiveCompletionDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetObjectiveCompletionDetailsQuery, GetObjectiveCompletionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetObjectiveCompletionDetailsQuery, GetObjectiveCompletionDetailsQueryVariables>(GetObjectiveCompletionDetailsDocument, options);
        }
// @ts-ignore
export function useGetObjectiveCompletionDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetObjectiveCompletionDetailsQuery, GetObjectiveCompletionDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetObjectiveCompletionDetailsQuery, GetObjectiveCompletionDetailsQueryVariables>;
export function useGetObjectiveCompletionDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetObjectiveCompletionDetailsQuery, GetObjectiveCompletionDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetObjectiveCompletionDetailsQuery | undefined, GetObjectiveCompletionDetailsQueryVariables>;
export function useGetObjectiveCompletionDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetObjectiveCompletionDetailsQuery, GetObjectiveCompletionDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetObjectiveCompletionDetailsQuery, GetObjectiveCompletionDetailsQueryVariables>(GetObjectiveCompletionDetailsDocument, options);
        }
export type GetObjectiveCompletionDetailsQueryHookResult = ReturnType<typeof useGetObjectiveCompletionDetailsQuery>;
export type GetObjectiveCompletionDetailsLazyQueryHookResult = ReturnType<typeof useGetObjectiveCompletionDetailsLazyQuery>;
export type GetObjectiveCompletionDetailsSuspenseQueryHookResult = ReturnType<typeof useGetObjectiveCompletionDetailsSuspenseQuery>;
export type GetObjectiveCompletionDetailsQueryResult = Apollo.QueryResult<GetObjectiveCompletionDetailsQuery, GetObjectiveCompletionDetailsQueryVariables>;
export const GetActivityAnalyticsByModuleDocument = gql`
    query GetActivityAnalyticsByModule($moduleId: ID!) {
  getActivityAnalyticsByModule(moduleId: $moduleId) {
    success
    message
    count
    data {
      id
      label
      success_points
      confusion_points
      questions_asked
      active_interaction_count
      distractions
      sentiment
      enrollment
      average_time_taken
      summaries
      success_points_details
      confusion_points_details
      further_recommendations
      details {
        objectives {
          id
          label
          success_points
          confusion_points
          average_time_taken
        }
      }
    }
  }
}
    `;

/**
 * __useGetActivityAnalyticsByModuleQuery__
 *
 * To run a query within a React component, call `useGetActivityAnalyticsByModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityAnalyticsByModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityAnalyticsByModuleQuery({
 *   variables: {
 *      moduleId: // value for 'moduleId'
 *   },
 * });
 */
export function useGetActivityAnalyticsByModuleQuery(baseOptions: Apollo.QueryHookOptions<GetActivityAnalyticsByModuleQuery, GetActivityAnalyticsByModuleQueryVariables> & ({ variables: GetActivityAnalyticsByModuleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityAnalyticsByModuleQuery, GetActivityAnalyticsByModuleQueryVariables>(GetActivityAnalyticsByModuleDocument, options);
      }
export function useGetActivityAnalyticsByModuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityAnalyticsByModuleQuery, GetActivityAnalyticsByModuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityAnalyticsByModuleQuery, GetActivityAnalyticsByModuleQueryVariables>(GetActivityAnalyticsByModuleDocument, options);
        }
// @ts-ignore
export function useGetActivityAnalyticsByModuleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActivityAnalyticsByModuleQuery, GetActivityAnalyticsByModuleQueryVariables>): Apollo.UseSuspenseQueryResult<GetActivityAnalyticsByModuleQuery, GetActivityAnalyticsByModuleQueryVariables>;
export function useGetActivityAnalyticsByModuleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActivityAnalyticsByModuleQuery, GetActivityAnalyticsByModuleQueryVariables>): Apollo.UseSuspenseQueryResult<GetActivityAnalyticsByModuleQuery | undefined, GetActivityAnalyticsByModuleQueryVariables>;
export function useGetActivityAnalyticsByModuleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActivityAnalyticsByModuleQuery, GetActivityAnalyticsByModuleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActivityAnalyticsByModuleQuery, GetActivityAnalyticsByModuleQueryVariables>(GetActivityAnalyticsByModuleDocument, options);
        }
export type GetActivityAnalyticsByModuleQueryHookResult = ReturnType<typeof useGetActivityAnalyticsByModuleQuery>;
export type GetActivityAnalyticsByModuleLazyQueryHookResult = ReturnType<typeof useGetActivityAnalyticsByModuleLazyQuery>;
export type GetActivityAnalyticsByModuleSuspenseQueryHookResult = ReturnType<typeof useGetActivityAnalyticsByModuleSuspenseQuery>;
export type GetActivityAnalyticsByModuleQueryResult = Apollo.QueryResult<GetActivityAnalyticsByModuleQuery, GetActivityAnalyticsByModuleQueryVariables>;
export const GetCourseAnalyticsByIdDocument = gql`
    query GetCourseAnalyticsById($courseId: ID!) {
  getCourseAnalyticsById(courseId: $courseId) {
    success
    message
    count
    data {
      id
      label
      success_points
      confusion_points
      questions_asked
      active_interaction_count
      distractions
      sentiment
      enrollment
      average_time_taken
      details {
        modules {
          id
          label
          success_points
          confusion_points
          questions_asked
          active_interaction_count
          distractions
          sentiment
          enrollment
          average_time_taken
          details {
            activities {
              id
              label
              success_points
              confusion_points
              questions_asked
              active_interaction_count
              distractions
              sentiment
              enrollment
              average_time_taken
              details {
                objectives {
                  id
                  label
                  success_points
                  confusion_points
                  average_time_taken
                  progress_details {
                    level
                    confusion_points
                    success_points
                    average_student_question_complexity
                    further_recommendations
                    questions_asked
                    distractions
                    sentiment_analysis
                    originality_analysis
                    summary
                    num_messages
                    student_messages_count
                    ai_messages_count
                    average_student_response_time
                    average_ai_response_time
                    total_time_taken
                  }
                }
              }
              summaries
              success_points_details
              confusion_points_details
              further_recommendations
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCourseAnalyticsByIdQuery__
 *
 * To run a query within a React component, call `useGetCourseAnalyticsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseAnalyticsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseAnalyticsByIdQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetCourseAnalyticsByIdQuery(baseOptions: Apollo.QueryHookOptions<GetCourseAnalyticsByIdQuery, GetCourseAnalyticsByIdQueryVariables> & ({ variables: GetCourseAnalyticsByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseAnalyticsByIdQuery, GetCourseAnalyticsByIdQueryVariables>(GetCourseAnalyticsByIdDocument, options);
      }
export function useGetCourseAnalyticsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseAnalyticsByIdQuery, GetCourseAnalyticsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseAnalyticsByIdQuery, GetCourseAnalyticsByIdQueryVariables>(GetCourseAnalyticsByIdDocument, options);
        }
// @ts-ignore
export function useGetCourseAnalyticsByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCourseAnalyticsByIdQuery, GetCourseAnalyticsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseAnalyticsByIdQuery, GetCourseAnalyticsByIdQueryVariables>;
export function useGetCourseAnalyticsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseAnalyticsByIdQuery, GetCourseAnalyticsByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseAnalyticsByIdQuery | undefined, GetCourseAnalyticsByIdQueryVariables>;
export function useGetCourseAnalyticsByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseAnalyticsByIdQuery, GetCourseAnalyticsByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseAnalyticsByIdQuery, GetCourseAnalyticsByIdQueryVariables>(GetCourseAnalyticsByIdDocument, options);
        }
export type GetCourseAnalyticsByIdQueryHookResult = ReturnType<typeof useGetCourseAnalyticsByIdQuery>;
export type GetCourseAnalyticsByIdLazyQueryHookResult = ReturnType<typeof useGetCourseAnalyticsByIdLazyQuery>;
export type GetCourseAnalyticsByIdSuspenseQueryHookResult = ReturnType<typeof useGetCourseAnalyticsByIdSuspenseQuery>;
export type GetCourseAnalyticsByIdQueryResult = Apollo.QueryResult<GetCourseAnalyticsByIdQuery, GetCourseAnalyticsByIdQueryVariables>;
export const GetCourseHierarchyDocument = gql`
    query GetCourseHierarchy($schoolId: ID!) {
  getCourseHierarchy(schoolId: $schoolId) {
    success
    message
    count
    data {
      id
      label
      level
      details {
        modules {
          id
          label
          level
          parentCourse {
            id
            label
          }
          details {
            activities {
              id
              label
              level
              parentModule {
                id
                label
              }
              parentCourse {
                id
                label
              }
              details {
                objectives {
                  id
                  label
                  level
                  parentActivity {
                    id
                    label
                  }
                  parentModule {
                    id
                    label
                  }
                  parentCourse {
                    id
                    label
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCourseHierarchyQuery__
 *
 * To run a query within a React component, call `useGetCourseHierarchyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseHierarchyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseHierarchyQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetCourseHierarchyQuery(baseOptions: Apollo.QueryHookOptions<GetCourseHierarchyQuery, GetCourseHierarchyQueryVariables> & ({ variables: GetCourseHierarchyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseHierarchyQuery, GetCourseHierarchyQueryVariables>(GetCourseHierarchyDocument, options);
      }
export function useGetCourseHierarchyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseHierarchyQuery, GetCourseHierarchyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseHierarchyQuery, GetCourseHierarchyQueryVariables>(GetCourseHierarchyDocument, options);
        }
// @ts-ignore
export function useGetCourseHierarchySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCourseHierarchyQuery, GetCourseHierarchyQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseHierarchyQuery, GetCourseHierarchyQueryVariables>;
export function useGetCourseHierarchySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseHierarchyQuery, GetCourseHierarchyQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseHierarchyQuery | undefined, GetCourseHierarchyQueryVariables>;
export function useGetCourseHierarchySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseHierarchyQuery, GetCourseHierarchyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseHierarchyQuery, GetCourseHierarchyQueryVariables>(GetCourseHierarchyDocument, options);
        }
export type GetCourseHierarchyQueryHookResult = ReturnType<typeof useGetCourseHierarchyQuery>;
export type GetCourseHierarchyLazyQueryHookResult = ReturnType<typeof useGetCourseHierarchyLazyQuery>;
export type GetCourseHierarchySuspenseQueryHookResult = ReturnType<typeof useGetCourseHierarchySuspenseQuery>;
export type GetCourseHierarchyQueryResult = Apollo.QueryResult<GetCourseHierarchyQuery, GetCourseHierarchyQueryVariables>;
export const GetCoursesSummaryBySchoolDocument = gql`
    query GetCoursesSummaryBySchool($schoolId: ID!, $searchQuery: String, $page: Int, $pageSize: Int, $sortBy: String) {
  getCoursesSummaryBySchool(
    schoolId: $schoolId
    searchQuery: $searchQuery
    page: $page
    pageSize: $pageSize
    sortBy: $sortBy
  ) {
    success
    message
    count
    data {
      id
      label
      success_points
      confusion_points
      questions_asked
      active_interaction_count
      distractions
      sentiment
      enrollment
      average_time_taken
      details {
        modules {
          id
          label
          success_points
          confusion_points
          questions_asked
          active_interaction_count
          distractions
          sentiment
          enrollment
          average_time_taken
          details {
            activities {
              id
              label
              success_points
              confusion_points
              questions_asked
              active_interaction_count
              distractions
              sentiment
              enrollment
              average_time_taken
              details {
                objectives {
                  id
                  label
                  success_points
                  confusion_points
                  average_time_taken
                  progress_details {
                    level
                    confusion_points
                    success_points
                    average_student_question_complexity
                    further_recommendations
                    questions_asked
                    distractions
                    sentiment_analysis
                    originality_analysis
                    summary
                    num_messages
                    student_messages_count
                    ai_messages_count
                    average_student_response_time
                    average_ai_response_time
                    total_time_taken
                  }
                }
              }
              summaries
              success_points_details
              confusion_points_details
              further_recommendations
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCoursesSummaryBySchoolQuery__
 *
 * To run a query within a React component, call `useGetCoursesSummaryBySchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesSummaryBySchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesSummaryBySchoolQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      searchQuery: // value for 'searchQuery'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetCoursesSummaryBySchoolQuery(baseOptions: Apollo.QueryHookOptions<GetCoursesSummaryBySchoolQuery, GetCoursesSummaryBySchoolQueryVariables> & ({ variables: GetCoursesSummaryBySchoolQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoursesSummaryBySchoolQuery, GetCoursesSummaryBySchoolQueryVariables>(GetCoursesSummaryBySchoolDocument, options);
      }
export function useGetCoursesSummaryBySchoolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoursesSummaryBySchoolQuery, GetCoursesSummaryBySchoolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoursesSummaryBySchoolQuery, GetCoursesSummaryBySchoolQueryVariables>(GetCoursesSummaryBySchoolDocument, options);
        }
// @ts-ignore
export function useGetCoursesSummaryBySchoolSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCoursesSummaryBySchoolQuery, GetCoursesSummaryBySchoolQueryVariables>): Apollo.UseSuspenseQueryResult<GetCoursesSummaryBySchoolQuery, GetCoursesSummaryBySchoolQueryVariables>;
export function useGetCoursesSummaryBySchoolSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoursesSummaryBySchoolQuery, GetCoursesSummaryBySchoolQueryVariables>): Apollo.UseSuspenseQueryResult<GetCoursesSummaryBySchoolQuery | undefined, GetCoursesSummaryBySchoolQueryVariables>;
export function useGetCoursesSummaryBySchoolSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoursesSummaryBySchoolQuery, GetCoursesSummaryBySchoolQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCoursesSummaryBySchoolQuery, GetCoursesSummaryBySchoolQueryVariables>(GetCoursesSummaryBySchoolDocument, options);
        }
export type GetCoursesSummaryBySchoolQueryHookResult = ReturnType<typeof useGetCoursesSummaryBySchoolQuery>;
export type GetCoursesSummaryBySchoolLazyQueryHookResult = ReturnType<typeof useGetCoursesSummaryBySchoolLazyQuery>;
export type GetCoursesSummaryBySchoolSuspenseQueryHookResult = ReturnType<typeof useGetCoursesSummaryBySchoolSuspenseQuery>;
export type GetCoursesSummaryBySchoolQueryResult = Apollo.QueryResult<GetCoursesSummaryBySchoolQuery, GetCoursesSummaryBySchoolQueryVariables>;
export const GetModuleAnalyticsByCourseDocument = gql`
    query GetModuleAnalyticsByCourse($courseId: ID!) {
  getModuleAnalyticsByCourse(courseId: $courseId) {
    success
    message
    count
    data {
      id
      label
      success_points
      confusion_points
      questions_asked
      active_interaction_count
      distractions
      sentiment
      enrollment
      average_time_taken
      details {
        activities {
          id
          label
          success_points
          confusion_points
          questions_asked
          active_interaction_count
          distractions
          sentiment
          enrollment
          average_time_taken
        }
      }
    }
  }
}
    `;

/**
 * __useGetModuleAnalyticsByCourseQuery__
 *
 * To run a query within a React component, call `useGetModuleAnalyticsByCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModuleAnalyticsByCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModuleAnalyticsByCourseQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetModuleAnalyticsByCourseQuery(baseOptions: Apollo.QueryHookOptions<GetModuleAnalyticsByCourseQuery, GetModuleAnalyticsByCourseQueryVariables> & ({ variables: GetModuleAnalyticsByCourseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetModuleAnalyticsByCourseQuery, GetModuleAnalyticsByCourseQueryVariables>(GetModuleAnalyticsByCourseDocument, options);
      }
export function useGetModuleAnalyticsByCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModuleAnalyticsByCourseQuery, GetModuleAnalyticsByCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetModuleAnalyticsByCourseQuery, GetModuleAnalyticsByCourseQueryVariables>(GetModuleAnalyticsByCourseDocument, options);
        }
// @ts-ignore
export function useGetModuleAnalyticsByCourseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetModuleAnalyticsByCourseQuery, GetModuleAnalyticsByCourseQueryVariables>): Apollo.UseSuspenseQueryResult<GetModuleAnalyticsByCourseQuery, GetModuleAnalyticsByCourseQueryVariables>;
export function useGetModuleAnalyticsByCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetModuleAnalyticsByCourseQuery, GetModuleAnalyticsByCourseQueryVariables>): Apollo.UseSuspenseQueryResult<GetModuleAnalyticsByCourseQuery | undefined, GetModuleAnalyticsByCourseQueryVariables>;
export function useGetModuleAnalyticsByCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetModuleAnalyticsByCourseQuery, GetModuleAnalyticsByCourseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetModuleAnalyticsByCourseQuery, GetModuleAnalyticsByCourseQueryVariables>(GetModuleAnalyticsByCourseDocument, options);
        }
export type GetModuleAnalyticsByCourseQueryHookResult = ReturnType<typeof useGetModuleAnalyticsByCourseQuery>;
export type GetModuleAnalyticsByCourseLazyQueryHookResult = ReturnType<typeof useGetModuleAnalyticsByCourseLazyQuery>;
export type GetModuleAnalyticsByCourseSuspenseQueryHookResult = ReturnType<typeof useGetModuleAnalyticsByCourseSuspenseQuery>;
export type GetModuleAnalyticsByCourseQueryResult = Apollo.QueryResult<GetModuleAnalyticsByCourseQuery, GetModuleAnalyticsByCourseQueryVariables>;
export const GetObjectiveAnalyticsByActivityDocument = gql`
    query GetObjectiveAnalyticsByActivity($aiTutorId: ID!) {
  getObjectiveAnalyticsByActivity(aiTutorId: $aiTutorId) {
    success
    message
    count
    data {
      id
      label
      success_points
      confusion_points
      average_time_taken
    }
  }
}
    `;

/**
 * __useGetObjectiveAnalyticsByActivityQuery__
 *
 * To run a query within a React component, call `useGetObjectiveAnalyticsByActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetObjectiveAnalyticsByActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetObjectiveAnalyticsByActivityQuery({
 *   variables: {
 *      aiTutorId: // value for 'aiTutorId'
 *   },
 * });
 */
export function useGetObjectiveAnalyticsByActivityQuery(baseOptions: Apollo.QueryHookOptions<GetObjectiveAnalyticsByActivityQuery, GetObjectiveAnalyticsByActivityQueryVariables> & ({ variables: GetObjectiveAnalyticsByActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetObjectiveAnalyticsByActivityQuery, GetObjectiveAnalyticsByActivityQueryVariables>(GetObjectiveAnalyticsByActivityDocument, options);
      }
export function useGetObjectiveAnalyticsByActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetObjectiveAnalyticsByActivityQuery, GetObjectiveAnalyticsByActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetObjectiveAnalyticsByActivityQuery, GetObjectiveAnalyticsByActivityQueryVariables>(GetObjectiveAnalyticsByActivityDocument, options);
        }
// @ts-ignore
export function useGetObjectiveAnalyticsByActivitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetObjectiveAnalyticsByActivityQuery, GetObjectiveAnalyticsByActivityQueryVariables>): Apollo.UseSuspenseQueryResult<GetObjectiveAnalyticsByActivityQuery, GetObjectiveAnalyticsByActivityQueryVariables>;
export function useGetObjectiveAnalyticsByActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetObjectiveAnalyticsByActivityQuery, GetObjectiveAnalyticsByActivityQueryVariables>): Apollo.UseSuspenseQueryResult<GetObjectiveAnalyticsByActivityQuery | undefined, GetObjectiveAnalyticsByActivityQueryVariables>;
export function useGetObjectiveAnalyticsByActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetObjectiveAnalyticsByActivityQuery, GetObjectiveAnalyticsByActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetObjectiveAnalyticsByActivityQuery, GetObjectiveAnalyticsByActivityQueryVariables>(GetObjectiveAnalyticsByActivityDocument, options);
        }
export type GetObjectiveAnalyticsByActivityQueryHookResult = ReturnType<typeof useGetObjectiveAnalyticsByActivityQuery>;
export type GetObjectiveAnalyticsByActivityLazyQueryHookResult = ReturnType<typeof useGetObjectiveAnalyticsByActivityLazyQuery>;
export type GetObjectiveAnalyticsByActivitySuspenseQueryHookResult = ReturnType<typeof useGetObjectiveAnalyticsByActivitySuspenseQuery>;
export type GetObjectiveAnalyticsByActivityQueryResult = Apollo.QueryResult<GetObjectiveAnalyticsByActivityQuery, GetObjectiveAnalyticsByActivityQueryVariables>;
export const GetActivityInsightsDataDocument = gql`
    query GetActivityInsightsData($aiTutorId: ID!) {
  getActivityInsightsData(aiTutorId: $aiTutorId) {
    success
    message
    count
    data {
      id
      label
      success_points_details
      confusion_points_details
      further_recommendations
      average_time_taken
      completion_rate
      student_engagement
      overall_sentiment
    }
  }
}
    `;

/**
 * __useGetActivityInsightsDataQuery__
 *
 * To run a query within a React component, call `useGetActivityInsightsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityInsightsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityInsightsDataQuery({
 *   variables: {
 *      aiTutorId: // value for 'aiTutorId'
 *   },
 * });
 */
export function useGetActivityInsightsDataQuery(baseOptions: Apollo.QueryHookOptions<GetActivityInsightsDataQuery, GetActivityInsightsDataQueryVariables> & ({ variables: GetActivityInsightsDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityInsightsDataQuery, GetActivityInsightsDataQueryVariables>(GetActivityInsightsDataDocument, options);
      }
export function useGetActivityInsightsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityInsightsDataQuery, GetActivityInsightsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityInsightsDataQuery, GetActivityInsightsDataQueryVariables>(GetActivityInsightsDataDocument, options);
        }
// @ts-ignore
export function useGetActivityInsightsDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActivityInsightsDataQuery, GetActivityInsightsDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetActivityInsightsDataQuery, GetActivityInsightsDataQueryVariables>;
export function useGetActivityInsightsDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActivityInsightsDataQuery, GetActivityInsightsDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetActivityInsightsDataQuery | undefined, GetActivityInsightsDataQueryVariables>;
export function useGetActivityInsightsDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActivityInsightsDataQuery, GetActivityInsightsDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActivityInsightsDataQuery, GetActivityInsightsDataQueryVariables>(GetActivityInsightsDataDocument, options);
        }
export type GetActivityInsightsDataQueryHookResult = ReturnType<typeof useGetActivityInsightsDataQuery>;
export type GetActivityInsightsDataLazyQueryHookResult = ReturnType<typeof useGetActivityInsightsDataLazyQuery>;
export type GetActivityInsightsDataSuspenseQueryHookResult = ReturnType<typeof useGetActivityInsightsDataSuspenseQuery>;
export type GetActivityInsightsDataQueryResult = Apollo.QueryResult<GetActivityInsightsDataQuery, GetActivityInsightsDataQueryVariables>;
export const GetStudentChatAnalyticsDocument = gql`
    query GetStudentChatAnalytics($studentId: ID!, $schoolId: ID!) {
  getStudentChatAnalytics(studentId: $studentId, schoolId: $schoolId) {
    success
    message
    count
    data {
      id
      courseId
      courseName
      moduleId
      moduleName
      activityId
      activityName
      sentiment_analysis
      originality_analysis
      num_messages
      student_messages_count
      ai_messages_count
      average_student_response_time
      average_ai_response_time
      total_time_taken
    }
  }
}
    `;

/**
 * __useGetStudentChatAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetStudentChatAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentChatAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentChatAnalyticsQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetStudentChatAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetStudentChatAnalyticsQuery, GetStudentChatAnalyticsQueryVariables> & ({ variables: GetStudentChatAnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentChatAnalyticsQuery, GetStudentChatAnalyticsQueryVariables>(GetStudentChatAnalyticsDocument, options);
      }
export function useGetStudentChatAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentChatAnalyticsQuery, GetStudentChatAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentChatAnalyticsQuery, GetStudentChatAnalyticsQueryVariables>(GetStudentChatAnalyticsDocument, options);
        }
// @ts-ignore
export function useGetStudentChatAnalyticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentChatAnalyticsQuery, GetStudentChatAnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentChatAnalyticsQuery, GetStudentChatAnalyticsQueryVariables>;
export function useGetStudentChatAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentChatAnalyticsQuery, GetStudentChatAnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentChatAnalyticsQuery | undefined, GetStudentChatAnalyticsQueryVariables>;
export function useGetStudentChatAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentChatAnalyticsQuery, GetStudentChatAnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentChatAnalyticsQuery, GetStudentChatAnalyticsQueryVariables>(GetStudentChatAnalyticsDocument, options);
        }
export type GetStudentChatAnalyticsQueryHookResult = ReturnType<typeof useGetStudentChatAnalyticsQuery>;
export type GetStudentChatAnalyticsLazyQueryHookResult = ReturnType<typeof useGetStudentChatAnalyticsLazyQuery>;
export type GetStudentChatAnalyticsSuspenseQueryHookResult = ReturnType<typeof useGetStudentChatAnalyticsSuspenseQuery>;
export type GetStudentChatAnalyticsQueryResult = Apollo.QueryResult<GetStudentChatAnalyticsQuery, GetStudentChatAnalyticsQueryVariables>;
export const GetStudentLearningInsightsDocument = gql`
    query GetStudentLearningInsights($studentId: ID!, $schoolId: ID!) {
  getStudentLearningInsights(studentId: $studentId, schoolId: $schoolId) {
    success
    message
    count
    data {
      id
      label
      success_points_details
      confusion_points_details
      further_recommendations
      total_time_taken
      active_interaction_count
      total_sessions
      questions_asked
    }
  }
}
    `;

/**
 * __useGetStudentLearningInsightsQuery__
 *
 * To run a query within a React component, call `useGetStudentLearningInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentLearningInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentLearningInsightsQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetStudentLearningInsightsQuery(baseOptions: Apollo.QueryHookOptions<GetStudentLearningInsightsQuery, GetStudentLearningInsightsQueryVariables> & ({ variables: GetStudentLearningInsightsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentLearningInsightsQuery, GetStudentLearningInsightsQueryVariables>(GetStudentLearningInsightsDocument, options);
      }
export function useGetStudentLearningInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentLearningInsightsQuery, GetStudentLearningInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentLearningInsightsQuery, GetStudentLearningInsightsQueryVariables>(GetStudentLearningInsightsDocument, options);
        }
// @ts-ignore
export function useGetStudentLearningInsightsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentLearningInsightsQuery, GetStudentLearningInsightsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentLearningInsightsQuery, GetStudentLearningInsightsQueryVariables>;
export function useGetStudentLearningInsightsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentLearningInsightsQuery, GetStudentLearningInsightsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentLearningInsightsQuery | undefined, GetStudentLearningInsightsQueryVariables>;
export function useGetStudentLearningInsightsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentLearningInsightsQuery, GetStudentLearningInsightsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentLearningInsightsQuery, GetStudentLearningInsightsQueryVariables>(GetStudentLearningInsightsDocument, options);
        }
export type GetStudentLearningInsightsQueryHookResult = ReturnType<typeof useGetStudentLearningInsightsQuery>;
export type GetStudentLearningInsightsLazyQueryHookResult = ReturnType<typeof useGetStudentLearningInsightsLazyQuery>;
export type GetStudentLearningInsightsSuspenseQueryHookResult = ReturnType<typeof useGetStudentLearningInsightsSuspenseQuery>;
export type GetStudentLearningInsightsQueryResult = Apollo.QueryResult<GetStudentLearningInsightsQuery, GetStudentLearningInsightsQueryVariables>;
export const GetStudentActivityProgressDocument = gql`
    query GetStudentActivityProgress($studentId: ID!, $aiTutorId: ID!) {
  getStudentActivityProgress(studentId: $studentId, aiTutorId: $aiTutorId) {
    success
    message
    count
    data {
      id
      label
      module_id
      module_name
      course_id
      course_name
      student_id
      student_name
      success_points
      confusion_points
      questions_asked
      active_interaction_count
      distractions
      sentiment
      completion_percentage
      total_time_taken
      chatAnalytics {
        id
        level
        confusion_points
        success_points
        average_student_question_complexity
        further_recommendations
        questions_asked
        distractions
        sentiment_analysis
        originality_analysis
        summary
        num_messages
        student_messages_count
        ai_messages_count
        average_student_response_time
        average_ai_response_time
        total_time_taken
      }
      details {
        objectives {
          id
          label
          success_points
          confusion_points
          questions_asked
          active_interaction_count
          distractions
          status
          progress_details {
            level
            confusion_points
            success_points
            average_student_question_complexity
            further_recommendations
            questions_asked
            distractions
            sentiment_analysis
            originality_analysis
            summary
            num_messages
            student_messages_count
            ai_messages_count
            average_student_response_time
            average_ai_response_time
            total_time_taken
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetStudentActivityProgressQuery__
 *
 * To run a query within a React component, call `useGetStudentActivityProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentActivityProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentActivityProgressQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      aiTutorId: // value for 'aiTutorId'
 *   },
 * });
 */
export function useGetStudentActivityProgressQuery(baseOptions: Apollo.QueryHookOptions<GetStudentActivityProgressQuery, GetStudentActivityProgressQueryVariables> & ({ variables: GetStudentActivityProgressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentActivityProgressQuery, GetStudentActivityProgressQueryVariables>(GetStudentActivityProgressDocument, options);
      }
export function useGetStudentActivityProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentActivityProgressQuery, GetStudentActivityProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentActivityProgressQuery, GetStudentActivityProgressQueryVariables>(GetStudentActivityProgressDocument, options);
        }
// @ts-ignore
export function useGetStudentActivityProgressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentActivityProgressQuery, GetStudentActivityProgressQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentActivityProgressQuery, GetStudentActivityProgressQueryVariables>;
export function useGetStudentActivityProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentActivityProgressQuery, GetStudentActivityProgressQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentActivityProgressQuery | undefined, GetStudentActivityProgressQueryVariables>;
export function useGetStudentActivityProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentActivityProgressQuery, GetStudentActivityProgressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentActivityProgressQuery, GetStudentActivityProgressQueryVariables>(GetStudentActivityProgressDocument, options);
        }
export type GetStudentActivityProgressQueryHookResult = ReturnType<typeof useGetStudentActivityProgressQuery>;
export type GetStudentActivityProgressLazyQueryHookResult = ReturnType<typeof useGetStudentActivityProgressLazyQuery>;
export type GetStudentActivityProgressSuspenseQueryHookResult = ReturnType<typeof useGetStudentActivityProgressSuspenseQuery>;
export type GetStudentActivityProgressQueryResult = Apollo.QueryResult<GetStudentActivityProgressQuery, GetStudentActivityProgressQueryVariables>;
export const GetStudentCourseProgressDocument = gql`
    query GetStudentCourseProgress($studentId: ID!, $courseId: ID!) {
  getStudentCourseProgress(studentId: $studentId, courseId: $courseId) {
    success
    message
    count
    data {
      id
      label
      student_id
      student_name
      success_points
      confusion_points
      questions_asked
      active_interaction_count
      distractions
      sentiment
      completion_percentage
      total_time_taken
      details {
        modules {
          id
          label
          success_points
          confusion_points
          questions_asked
          active_interaction_count
          distractions
          sentiment
          completion_percentage
          total_time_taken
          details {
            activities {
              id
              label
              success_points
              confusion_points
              questions_asked
              active_interaction_count
              distractions
              sentiment
              completion_percentage
              total_time_taken
              details {
                objectives {
                  id
                  label
                  success_points
                  confusion_points
                  questions_asked
                  active_interaction_count
                  distractions
                  status
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetStudentCourseProgressQuery__
 *
 * To run a query within a React component, call `useGetStudentCourseProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentCourseProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentCourseProgressQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetStudentCourseProgressQuery(baseOptions: Apollo.QueryHookOptions<GetStudentCourseProgressQuery, GetStudentCourseProgressQueryVariables> & ({ variables: GetStudentCourseProgressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentCourseProgressQuery, GetStudentCourseProgressQueryVariables>(GetStudentCourseProgressDocument, options);
      }
export function useGetStudentCourseProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentCourseProgressQuery, GetStudentCourseProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentCourseProgressQuery, GetStudentCourseProgressQueryVariables>(GetStudentCourseProgressDocument, options);
        }
// @ts-ignore
export function useGetStudentCourseProgressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentCourseProgressQuery, GetStudentCourseProgressQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentCourseProgressQuery, GetStudentCourseProgressQueryVariables>;
export function useGetStudentCourseProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentCourseProgressQuery, GetStudentCourseProgressQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentCourseProgressQuery | undefined, GetStudentCourseProgressQueryVariables>;
export function useGetStudentCourseProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentCourseProgressQuery, GetStudentCourseProgressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentCourseProgressQuery, GetStudentCourseProgressQueryVariables>(GetStudentCourseProgressDocument, options);
        }
export type GetStudentCourseProgressQueryHookResult = ReturnType<typeof useGetStudentCourseProgressQuery>;
export type GetStudentCourseProgressLazyQueryHookResult = ReturnType<typeof useGetStudentCourseProgressLazyQuery>;
export type GetStudentCourseProgressSuspenseQueryHookResult = ReturnType<typeof useGetStudentCourseProgressSuspenseQuery>;
export type GetStudentCourseProgressQueryResult = Apollo.QueryResult<GetStudentCourseProgressQuery, GetStudentCourseProgressQueryVariables>;
export const GetStudentDetailedAnalyticsDocument = gql`
    query GetStudentDetailedAnalytics($studentId: ID!, $schoolId: ID!) {
  getStudentDetailedAnalytics(studentId: $studentId, schoolId: $schoolId) {
    success
    message
    count
    data {
      id
      label
      status
      success_points
      confusion_points
      questions_asked
      active_interaction_count
      distractions
      sentiment
      completion_percentage
      total_time_taken
      details {
        courses {
          id
          label
          success_points
          confusion_points
          questions_asked
          active_interaction_count
          distractions
          sentiment
          completion_percentage
          total_time_taken
          details {
            modules {
              id
              label
              success_points
              confusion_points
              questions_asked
              active_interaction_count
              distractions
              sentiment
              completion_percentage
              total_time_taken
              details {
                activities {
                  id
                  label
                  success_points
                  confusion_points
                  questions_asked
                  active_interaction_count
                  distractions
                  sentiment
                  completion_percentage
                  total_time_taken
                  chatAnalytics {
                    id
                    level
                    confusion_points
                    success_points
                    average_student_question_complexity
                    further_recommendations
                    questions_asked
                    distractions
                    sentiment_analysis
                    originality_analysis
                    summary
                    num_messages
                    student_messages_count
                    ai_messages_count
                    average_student_response_time
                    average_ai_response_time
                    total_time_taken
                  }
                  details {
                    objectives {
                      id
                      label
                      success_points
                      confusion_points
                      questions_asked
                      active_interaction_count
                      distractions
                      status
                      progress_details {
                        level
                        confusion_points
                        success_points
                        average_student_question_complexity
                        further_recommendations
                        questions_asked
                        distractions
                        sentiment_analysis
                        originality_analysis
                        summary
                        num_messages
                        student_messages_count
                        ai_messages_count
                        average_student_response_time
                        average_ai_response_time
                        total_time_taken
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetStudentDetailedAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetStudentDetailedAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentDetailedAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentDetailedAnalyticsQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetStudentDetailedAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetStudentDetailedAnalyticsQuery, GetStudentDetailedAnalyticsQueryVariables> & ({ variables: GetStudentDetailedAnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentDetailedAnalyticsQuery, GetStudentDetailedAnalyticsQueryVariables>(GetStudentDetailedAnalyticsDocument, options);
      }
export function useGetStudentDetailedAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentDetailedAnalyticsQuery, GetStudentDetailedAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentDetailedAnalyticsQuery, GetStudentDetailedAnalyticsQueryVariables>(GetStudentDetailedAnalyticsDocument, options);
        }
// @ts-ignore
export function useGetStudentDetailedAnalyticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentDetailedAnalyticsQuery, GetStudentDetailedAnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentDetailedAnalyticsQuery, GetStudentDetailedAnalyticsQueryVariables>;
export function useGetStudentDetailedAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentDetailedAnalyticsQuery, GetStudentDetailedAnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentDetailedAnalyticsQuery | undefined, GetStudentDetailedAnalyticsQueryVariables>;
export function useGetStudentDetailedAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentDetailedAnalyticsQuery, GetStudentDetailedAnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentDetailedAnalyticsQuery, GetStudentDetailedAnalyticsQueryVariables>(GetStudentDetailedAnalyticsDocument, options);
        }
export type GetStudentDetailedAnalyticsQueryHookResult = ReturnType<typeof useGetStudentDetailedAnalyticsQuery>;
export type GetStudentDetailedAnalyticsLazyQueryHookResult = ReturnType<typeof useGetStudentDetailedAnalyticsLazyQuery>;
export type GetStudentDetailedAnalyticsSuspenseQueryHookResult = ReturnType<typeof useGetStudentDetailedAnalyticsSuspenseQuery>;
export type GetStudentDetailedAnalyticsQueryResult = Apollo.QueryResult<GetStudentDetailedAnalyticsQuery, GetStudentDetailedAnalyticsQueryVariables>;
export const GetStudentModuleProgressDocument = gql`
    query GetStudentModuleProgress($studentId: ID!, $moduleId: ID!) {
  getStudentModuleProgress(studentId: $studentId, moduleId: $moduleId) {
    success
    message
    count
    data {
      id
      label
      course_id
      course_name
      student_id
      student_name
      success_points
      confusion_points
      questions_asked
      active_interaction_count
      distractions
      sentiment
      completion_percentage
      total_time_taken
      details {
        activities {
          id
          label
          success_points
          confusion_points
          questions_asked
          active_interaction_count
          distractions
          sentiment
          completion_percentage
          total_time_taken
          details {
            objectives {
              id
              label
              success_points
              confusion_points
              questions_asked
              active_interaction_count
              distractions
              status
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetStudentModuleProgressQuery__
 *
 * To run a query within a React component, call `useGetStudentModuleProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentModuleProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentModuleProgressQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      moduleId: // value for 'moduleId'
 *   },
 * });
 */
export function useGetStudentModuleProgressQuery(baseOptions: Apollo.QueryHookOptions<GetStudentModuleProgressQuery, GetStudentModuleProgressQueryVariables> & ({ variables: GetStudentModuleProgressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentModuleProgressQuery, GetStudentModuleProgressQueryVariables>(GetStudentModuleProgressDocument, options);
      }
export function useGetStudentModuleProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentModuleProgressQuery, GetStudentModuleProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentModuleProgressQuery, GetStudentModuleProgressQueryVariables>(GetStudentModuleProgressDocument, options);
        }
// @ts-ignore
export function useGetStudentModuleProgressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentModuleProgressQuery, GetStudentModuleProgressQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentModuleProgressQuery, GetStudentModuleProgressQueryVariables>;
export function useGetStudentModuleProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentModuleProgressQuery, GetStudentModuleProgressQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentModuleProgressQuery | undefined, GetStudentModuleProgressQueryVariables>;
export function useGetStudentModuleProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentModuleProgressQuery, GetStudentModuleProgressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentModuleProgressQuery, GetStudentModuleProgressQueryVariables>(GetStudentModuleProgressDocument, options);
        }
export type GetStudentModuleProgressQueryHookResult = ReturnType<typeof useGetStudentModuleProgressQuery>;
export type GetStudentModuleProgressLazyQueryHookResult = ReturnType<typeof useGetStudentModuleProgressLazyQuery>;
export type GetStudentModuleProgressSuspenseQueryHookResult = ReturnType<typeof useGetStudentModuleProgressSuspenseQuery>;
export type GetStudentModuleProgressQueryResult = Apollo.QueryResult<GetStudentModuleProgressQuery, GetStudentModuleProgressQueryVariables>;
export const GetStudentsSummaryBySchoolDocument = gql`
    query GetStudentsSummaryBySchool($schoolId: ID!, $searchQuery: String, $page: Int, $pageSize: Int, $sortBy: String) {
  getStudentsSummaryBySchool(
    schoolId: $schoolId
    searchQuery: $searchQuery
    page: $page
    pageSize: $pageSize
    sortBy: $sortBy
  ) {
    success
    message
    count
    data {
      id
      label
      success_points
      confusion_points
      questions_asked
      active_interaction_count
      distractions
      sentiment
      total_time_taken
      schoolEnrollmentDate
    }
  }
}
    `;

/**
 * __useGetStudentsSummaryBySchoolQuery__
 *
 * To run a query within a React component, call `useGetStudentsSummaryBySchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentsSummaryBySchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentsSummaryBySchoolQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      searchQuery: // value for 'searchQuery'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetStudentsSummaryBySchoolQuery(baseOptions: Apollo.QueryHookOptions<GetStudentsSummaryBySchoolQuery, GetStudentsSummaryBySchoolQueryVariables> & ({ variables: GetStudentsSummaryBySchoolQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentsSummaryBySchoolQuery, GetStudentsSummaryBySchoolQueryVariables>(GetStudentsSummaryBySchoolDocument, options);
      }
export function useGetStudentsSummaryBySchoolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentsSummaryBySchoolQuery, GetStudentsSummaryBySchoolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentsSummaryBySchoolQuery, GetStudentsSummaryBySchoolQueryVariables>(GetStudentsSummaryBySchoolDocument, options);
        }
// @ts-ignore
export function useGetStudentsSummaryBySchoolSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentsSummaryBySchoolQuery, GetStudentsSummaryBySchoolQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentsSummaryBySchoolQuery, GetStudentsSummaryBySchoolQueryVariables>;
export function useGetStudentsSummaryBySchoolSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentsSummaryBySchoolQuery, GetStudentsSummaryBySchoolQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentsSummaryBySchoolQuery | undefined, GetStudentsSummaryBySchoolQueryVariables>;
export function useGetStudentsSummaryBySchoolSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentsSummaryBySchoolQuery, GetStudentsSummaryBySchoolQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentsSummaryBySchoolQuery, GetStudentsSummaryBySchoolQueryVariables>(GetStudentsSummaryBySchoolDocument, options);
        }
export type GetStudentsSummaryBySchoolQueryHookResult = ReturnType<typeof useGetStudentsSummaryBySchoolQuery>;
export type GetStudentsSummaryBySchoolLazyQueryHookResult = ReturnType<typeof useGetStudentsSummaryBySchoolLazyQuery>;
export type GetStudentsSummaryBySchoolSuspenseQueryHookResult = ReturnType<typeof useGetStudentsSummaryBySchoolSuspenseQuery>;
export type GetStudentsSummaryBySchoolQueryResult = Apollo.QueryResult<GetStudentsSummaryBySchoolQuery, GetStudentsSummaryBySchoolQueryVariables>;
export const GetRecentActivityDocument = gql`
    query GetRecentActivity {
  getRecentActivity {
    success
    message
    data {
      id
      type
      occurredAt
      tenantId
      actorId
      subjectType
      subjectId
      relatedUserId
      diffKeys
      diffBefore
      diffAfter
      actor {
        id
        name
        email
      }
      subjectCourse {
        id
        name
      }
      subjectDegree {
        id
        name
      }
      subjectUser {
        id
        name
        email
      }
    }
    count
  }
}
    `;

/**
 * __useGetRecentActivityQuery__
 *
 * To run a query within a React component, call `useGetRecentActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentActivityQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRecentActivityQuery(baseOptions?: Apollo.QueryHookOptions<GetRecentActivityQuery, GetRecentActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentActivityQuery, GetRecentActivityQueryVariables>(GetRecentActivityDocument, options);
      }
export function useGetRecentActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentActivityQuery, GetRecentActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentActivityQuery, GetRecentActivityQueryVariables>(GetRecentActivityDocument, options);
        }
// @ts-ignore
export function useGetRecentActivitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRecentActivityQuery, GetRecentActivityQueryVariables>): Apollo.UseSuspenseQueryResult<GetRecentActivityQuery, GetRecentActivityQueryVariables>;
export function useGetRecentActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecentActivityQuery, GetRecentActivityQueryVariables>): Apollo.UseSuspenseQueryResult<GetRecentActivityQuery | undefined, GetRecentActivityQueryVariables>;
export function useGetRecentActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecentActivityQuery, GetRecentActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecentActivityQuery, GetRecentActivityQueryVariables>(GetRecentActivityDocument, options);
        }
export type GetRecentActivityQueryHookResult = ReturnType<typeof useGetRecentActivityQuery>;
export type GetRecentActivityLazyQueryHookResult = ReturnType<typeof useGetRecentActivityLazyQuery>;
export type GetRecentActivitySuspenseQueryHookResult = ReturnType<typeof useGetRecentActivitySuspenseQuery>;
export type GetRecentActivityQueryResult = Apollo.QueryResult<GetRecentActivityQuery, GetRecentActivityQueryVariables>;
export const GetUserPermissionsDocument = gql`
    query GetUserPermissions {
  getUserPermissions
}
    `;

/**
 * __useGetUserPermissionsQuery__
 *
 * To run a query within a React component, call `useGetUserPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>(GetUserPermissionsDocument, options);
      }
export function useGetUserPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>(GetUserPermissionsDocument, options);
        }
// @ts-ignore
export function useGetUserPermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>;
export function useGetUserPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserPermissionsQuery | undefined, GetUserPermissionsQueryVariables>;
export function useGetUserPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>(GetUserPermissionsDocument, options);
        }
export type GetUserPermissionsQueryHookResult = ReturnType<typeof useGetUserPermissionsQuery>;
export type GetUserPermissionsLazyQueryHookResult = ReturnType<typeof useGetUserPermissionsLazyQuery>;
export type GetUserPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetUserPermissionsSuspenseQuery>;
export type GetUserPermissionsQueryResult = Apollo.QueryResult<GetUserPermissionsQuery, GetUserPermissionsQueryVariables>;
export const ValidateSessionDocument = gql`
    query ValidateSession {
  validateSession {
    isValid
  }
}
    `;

/**
 * __useValidateSessionQuery__
 *
 * To run a query within a React component, call `useValidateSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateSessionQuery({
 *   variables: {
 *   },
 * });
 */
export function useValidateSessionQuery(baseOptions?: Apollo.QueryHookOptions<ValidateSessionQuery, ValidateSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateSessionQuery, ValidateSessionQueryVariables>(ValidateSessionDocument, options);
      }
export function useValidateSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateSessionQuery, ValidateSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateSessionQuery, ValidateSessionQueryVariables>(ValidateSessionDocument, options);
        }
// @ts-ignore
export function useValidateSessionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ValidateSessionQuery, ValidateSessionQueryVariables>): Apollo.UseSuspenseQueryResult<ValidateSessionQuery, ValidateSessionQueryVariables>;
export function useValidateSessionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateSessionQuery, ValidateSessionQueryVariables>): Apollo.UseSuspenseQueryResult<ValidateSessionQuery | undefined, ValidateSessionQueryVariables>;
export function useValidateSessionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateSessionQuery, ValidateSessionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateSessionQuery, ValidateSessionQueryVariables>(ValidateSessionDocument, options);
        }
export type ValidateSessionQueryHookResult = ReturnType<typeof useValidateSessionQuery>;
export type ValidateSessionLazyQueryHookResult = ReturnType<typeof useValidateSessionLazyQuery>;
export type ValidateSessionSuspenseQueryHookResult = ReturnType<typeof useValidateSessionSuspenseQuery>;
export type ValidateSessionQueryResult = Apollo.QueryResult<ValidateSessionQuery, ValidateSessionQueryVariables>;
export const CareerByIdDocument = gql`
    query CareerById($id: ID!) {
  getCareerById(id: $id) {
    id
    name
    brief_description
    description
    created
    last_modified
    path
    trends
    pros
    cons
    skills
    core_skills
    growth
    salary
    url
  }
}
    `;

/**
 * __useCareerByIdQuery__
 *
 * To run a query within a React component, call `useCareerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCareerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCareerByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCareerByIdQuery(baseOptions: Apollo.QueryHookOptions<CareerByIdQuery, CareerByIdQueryVariables> & ({ variables: CareerByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CareerByIdQuery, CareerByIdQueryVariables>(CareerByIdDocument, options);
      }
export function useCareerByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CareerByIdQuery, CareerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CareerByIdQuery, CareerByIdQueryVariables>(CareerByIdDocument, options);
        }
// @ts-ignore
export function useCareerByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CareerByIdQuery, CareerByIdQueryVariables>): Apollo.UseSuspenseQueryResult<CareerByIdQuery, CareerByIdQueryVariables>;
export function useCareerByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CareerByIdQuery, CareerByIdQueryVariables>): Apollo.UseSuspenseQueryResult<CareerByIdQuery | undefined, CareerByIdQueryVariables>;
export function useCareerByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CareerByIdQuery, CareerByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CareerByIdQuery, CareerByIdQueryVariables>(CareerByIdDocument, options);
        }
export type CareerByIdQueryHookResult = ReturnType<typeof useCareerByIdQuery>;
export type CareerByIdLazyQueryHookResult = ReturnType<typeof useCareerByIdLazyQuery>;
export type CareerByIdSuspenseQueryHookResult = ReturnType<typeof useCareerByIdSuspenseQuery>;
export type CareerByIdQueryResult = Apollo.QueryResult<CareerByIdQuery, CareerByIdQueryVariables>;
export const GetCareerHeaderDocument = gql`
    query GetCareerHeader {
  getCareerHeader {
    jobTitle
    careerGoal
    careerName
    careerId
  }
}
    `;

/**
 * __useGetCareerHeaderQuery__
 *
 * To run a query within a React component, call `useGetCareerHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCareerHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCareerHeaderQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCareerHeaderQuery(baseOptions?: Apollo.QueryHookOptions<GetCareerHeaderQuery, GetCareerHeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCareerHeaderQuery, GetCareerHeaderQueryVariables>(GetCareerHeaderDocument, options);
      }
export function useGetCareerHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCareerHeaderQuery, GetCareerHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCareerHeaderQuery, GetCareerHeaderQueryVariables>(GetCareerHeaderDocument, options);
        }
// @ts-ignore
export function useGetCareerHeaderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCareerHeaderQuery, GetCareerHeaderQueryVariables>): Apollo.UseSuspenseQueryResult<GetCareerHeaderQuery, GetCareerHeaderQueryVariables>;
export function useGetCareerHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCareerHeaderQuery, GetCareerHeaderQueryVariables>): Apollo.UseSuspenseQueryResult<GetCareerHeaderQuery | undefined, GetCareerHeaderQueryVariables>;
export function useGetCareerHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCareerHeaderQuery, GetCareerHeaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCareerHeaderQuery, GetCareerHeaderQueryVariables>(GetCareerHeaderDocument, options);
        }
export type GetCareerHeaderQueryHookResult = ReturnType<typeof useGetCareerHeaderQuery>;
export type GetCareerHeaderLazyQueryHookResult = ReturnType<typeof useGetCareerHeaderLazyQuery>;
export type GetCareerHeaderSuspenseQueryHookResult = ReturnType<typeof useGetCareerHeaderSuspenseQuery>;
export type GetCareerHeaderQueryResult = Apollo.QueryResult<GetCareerHeaderQuery, GetCareerHeaderQueryVariables>;
export const GetCareerTopicsDocument = gql`
    query getCareerTopics($careerId: ID!) {
  getCareerTopics(careerId: $careerId) {
    name
    description
    mastery
  }
}
    `;

/**
 * __useGetCareerTopicsQuery__
 *
 * To run a query within a React component, call `useGetCareerTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCareerTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCareerTopicsQuery({
 *   variables: {
 *      careerId: // value for 'careerId'
 *   },
 * });
 */
export function useGetCareerTopicsQuery(baseOptions: Apollo.QueryHookOptions<GetCareerTopicsQuery, GetCareerTopicsQueryVariables> & ({ variables: GetCareerTopicsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCareerTopicsQuery, GetCareerTopicsQueryVariables>(GetCareerTopicsDocument, options);
      }
export function useGetCareerTopicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCareerTopicsQuery, GetCareerTopicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCareerTopicsQuery, GetCareerTopicsQueryVariables>(GetCareerTopicsDocument, options);
        }
// @ts-ignore
export function useGetCareerTopicsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCareerTopicsQuery, GetCareerTopicsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCareerTopicsQuery, GetCareerTopicsQueryVariables>;
export function useGetCareerTopicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCareerTopicsQuery, GetCareerTopicsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCareerTopicsQuery | undefined, GetCareerTopicsQueryVariables>;
export function useGetCareerTopicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCareerTopicsQuery, GetCareerTopicsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCareerTopicsQuery, GetCareerTopicsQueryVariables>(GetCareerTopicsDocument, options);
        }
export type GetCareerTopicsQueryHookResult = ReturnType<typeof useGetCareerTopicsQuery>;
export type GetCareerTopicsLazyQueryHookResult = ReturnType<typeof useGetCareerTopicsLazyQuery>;
export type GetCareerTopicsSuspenseQueryHookResult = ReturnType<typeof useGetCareerTopicsSuspenseQuery>;
export type GetCareerTopicsQueryResult = Apollo.QueryResult<GetCareerTopicsQuery, GetCareerTopicsQueryVariables>;
export const GetCareersDocument = gql`
    query GetCareers {
  getCareers {
    id
    name
    brief_description
    description
    created
    last_modified
    path
    trends
    pros
    cons
    skills
    core_skills
    growth
    salary
    url
  }
}
    `;

/**
 * __useGetCareersQuery__
 *
 * To run a query within a React component, call `useGetCareersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCareersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCareersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCareersQuery(baseOptions?: Apollo.QueryHookOptions<GetCareersQuery, GetCareersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCareersQuery, GetCareersQueryVariables>(GetCareersDocument, options);
      }
export function useGetCareersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCareersQuery, GetCareersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCareersQuery, GetCareersQueryVariables>(GetCareersDocument, options);
        }
// @ts-ignore
export function useGetCareersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCareersQuery, GetCareersQueryVariables>): Apollo.UseSuspenseQueryResult<GetCareersQuery, GetCareersQueryVariables>;
export function useGetCareersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCareersQuery, GetCareersQueryVariables>): Apollo.UseSuspenseQueryResult<GetCareersQuery | undefined, GetCareersQueryVariables>;
export function useGetCareersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCareersQuery, GetCareersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCareersQuery, GetCareersQueryVariables>(GetCareersDocument, options);
        }
export type GetCareersQueryHookResult = ReturnType<typeof useGetCareersQuery>;
export type GetCareersLazyQueryHookResult = ReturnType<typeof useGetCareersLazyQuery>;
export type GetCareersSuspenseQueryHookResult = ReturnType<typeof useGetCareersSuspenseQuery>;
export type GetCareersQueryResult = Apollo.QueryResult<GetCareersQuery, GetCareersQueryVariables>;
export const DailyLimitDocument = gql`
    query DailyLimit {
  getDailyLimit {
    dailyRequests
    result
  }
}
    `;

/**
 * __useDailyLimitQuery__
 *
 * To run a query within a React component, call `useDailyLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyLimitQuery({
 *   variables: {
 *   },
 * });
 */
export function useDailyLimitQuery(baseOptions?: Apollo.QueryHookOptions<DailyLimitQuery, DailyLimitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DailyLimitQuery, DailyLimitQueryVariables>(DailyLimitDocument, options);
      }
export function useDailyLimitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DailyLimitQuery, DailyLimitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DailyLimitQuery, DailyLimitQueryVariables>(DailyLimitDocument, options);
        }
// @ts-ignore
export function useDailyLimitSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DailyLimitQuery, DailyLimitQueryVariables>): Apollo.UseSuspenseQueryResult<DailyLimitQuery, DailyLimitQueryVariables>;
export function useDailyLimitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DailyLimitQuery, DailyLimitQueryVariables>): Apollo.UseSuspenseQueryResult<DailyLimitQuery | undefined, DailyLimitQueryVariables>;
export function useDailyLimitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DailyLimitQuery, DailyLimitQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DailyLimitQuery, DailyLimitQueryVariables>(DailyLimitDocument, options);
        }
export type DailyLimitQueryHookResult = ReturnType<typeof useDailyLimitQuery>;
export type DailyLimitLazyQueryHookResult = ReturnType<typeof useDailyLimitLazyQuery>;
export type DailyLimitSuspenseQueryHookResult = ReturnType<typeof useDailyLimitSuspenseQuery>;
export type DailyLimitQueryResult = Apollo.QueryResult<DailyLimitQuery, DailyLimitQueryVariables>;
export const GetChatByContextAndParamsDocument = gql`
    query GetChatByContextAndParams($context: String!, $params: JSON) {
  getChatByContextAndParams(context: $context, params: $params) {
    id
    date
    name
    objectId
    context
    params
    conversation {
      id
      sender
      content
      type
      nodeId
      snackType
      file {
        fileName
        id
      }
      parameters {
        lastGeneratedTopic
        lastGeneratedLabel
        questContext
        userResponse
      }
      aspectDetails {
        name
        category
        id
        friendId
        relationshipType
        connectionStrength
        frequencyOfInteraction
        lastInteractionDate
        sharedInterests
        sharedGoals
        sharedEventsAttended
        friendPersonalityTraits
        communicationChannel
        level
        startDate
        lastUpdated
        learningStyle
        language
        timeOfDay
        learningDuration
        contentType
        notificationPreferences
        type
        completionStatus
        deadline
        priority
        value
        description
        date
        importance
        status
        endDate
        text
        sentiment
        context
        intensity
        timestamp
        trigger
        calories
        carbohydrates_grams
        fat_grams
        fiber_grams
        protein_grams
        serving_size
        sodium_mg
        sugars_grams
        totalCalories
        totalCarbs
        totalFats
        totalProteins
        totalCaloriesBurned
        totalDurationMinutes
        totalWorkouts
        water_intake_oz
      }
    }
  }
}
    `;

/**
 * __useGetChatByContextAndParamsQuery__
 *
 * To run a query within a React component, call `useGetChatByContextAndParamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatByContextAndParamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatByContextAndParamsQuery({
 *   variables: {
 *      context: // value for 'context'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetChatByContextAndParamsQuery(baseOptions: Apollo.QueryHookOptions<GetChatByContextAndParamsQuery, GetChatByContextAndParamsQueryVariables> & ({ variables: GetChatByContextAndParamsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatByContextAndParamsQuery, GetChatByContextAndParamsQueryVariables>(GetChatByContextAndParamsDocument, options);
      }
export function useGetChatByContextAndParamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatByContextAndParamsQuery, GetChatByContextAndParamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatByContextAndParamsQuery, GetChatByContextAndParamsQueryVariables>(GetChatByContextAndParamsDocument, options);
        }
// @ts-ignore
export function useGetChatByContextAndParamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetChatByContextAndParamsQuery, GetChatByContextAndParamsQueryVariables>): Apollo.UseSuspenseQueryResult<GetChatByContextAndParamsQuery, GetChatByContextAndParamsQueryVariables>;
export function useGetChatByContextAndParamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChatByContextAndParamsQuery, GetChatByContextAndParamsQueryVariables>): Apollo.UseSuspenseQueryResult<GetChatByContextAndParamsQuery | undefined, GetChatByContextAndParamsQueryVariables>;
export function useGetChatByContextAndParamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChatByContextAndParamsQuery, GetChatByContextAndParamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChatByContextAndParamsQuery, GetChatByContextAndParamsQueryVariables>(GetChatByContextAndParamsDocument, options);
        }
export type GetChatByContextAndParamsQueryHookResult = ReturnType<typeof useGetChatByContextAndParamsQuery>;
export type GetChatByContextAndParamsLazyQueryHookResult = ReturnType<typeof useGetChatByContextAndParamsLazyQuery>;
export type GetChatByContextAndParamsSuspenseQueryHookResult = ReturnType<typeof useGetChatByContextAndParamsSuspenseQuery>;
export type GetChatByContextAndParamsQueryResult = Apollo.QueryResult<GetChatByContextAndParamsQuery, GetChatByContextAndParamsQueryVariables>;
export const GetChatByIdDocument = gql`
    query GetChatById($id: ID!) {
  getChatById(id: $id) {
    id
    date
    name
    objectId
    context
    params
    conversation {
      id
      sender
      content
      type
      nodeId
      snackType
      file {
        fileName
        id
      }
      parameters {
        lastGeneratedTopic
        lastGeneratedLabel
        questContext
        userResponse
      }
      aspectDetails {
        name
        category
        id
        friendId
        relationshipType
        connectionStrength
        frequencyOfInteraction
        lastInteractionDate
        sharedInterests
        sharedGoals
        sharedEventsAttended
        friendPersonalityTraits
        communicationChannel
        level
        startDate
        lastUpdated
        learningStyle
        language
        timeOfDay
        learningDuration
        contentType
        notificationPreferences
        type
        completionStatus
        deadline
        priority
        value
        description
        date
        importance
        status
        endDate
        text
        sentiment
        context
        intensity
        timestamp
        trigger
        calories
        carbohydrates_grams
        fat_grams
        fiber_grams
        protein_grams
        serving_size
        sodium_mg
        sugars_grams
        totalCalories
        totalCarbs
        totalFats
        totalProteins
        totalCaloriesBurned
        totalDurationMinutes
        totalWorkouts
        water_intake_oz
      }
    }
  }
}
    `;

/**
 * __useGetChatByIdQuery__
 *
 * To run a query within a React component, call `useGetChatByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetChatByIdQuery(baseOptions: Apollo.QueryHookOptions<GetChatByIdQuery, GetChatByIdQueryVariables> & ({ variables: GetChatByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatByIdQuery, GetChatByIdQueryVariables>(GetChatByIdDocument, options);
      }
export function useGetChatByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatByIdQuery, GetChatByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatByIdQuery, GetChatByIdQueryVariables>(GetChatByIdDocument, options);
        }
// @ts-ignore
export function useGetChatByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetChatByIdQuery, GetChatByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetChatByIdQuery, GetChatByIdQueryVariables>;
export function useGetChatByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChatByIdQuery, GetChatByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetChatByIdQuery | undefined, GetChatByIdQueryVariables>;
export function useGetChatByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChatByIdQuery, GetChatByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChatByIdQuery, GetChatByIdQueryVariables>(GetChatByIdDocument, options);
        }
export type GetChatByIdQueryHookResult = ReturnType<typeof useGetChatByIdQuery>;
export type GetChatByIdLazyQueryHookResult = ReturnType<typeof useGetChatByIdLazyQuery>;
export type GetChatByIdSuspenseQueryHookResult = ReturnType<typeof useGetChatByIdSuspenseQuery>;
export type GetChatByIdQueryResult = Apollo.QueryResult<GetChatByIdQuery, GetChatByIdQueryVariables>;
export const GetChatByObjectIdDocument = gql`
    query GetChatByObjectId($objectId: ID!, $context: String!) {
  getChatByObjectId(objectId: $objectId, context: $context) {
    id
    date
    name
    objectId
    context
    params
    conversation {
      id
      sender
      content
      type
      nodeId
      snackType
      file {
        fileName
        id
      }
      parameters {
        lastGeneratedTopic
        lastGeneratedLabel
        questContext
        userResponse
      }
      aspectDetails {
        name
        category
        id
        friendId
        relationshipType
        connectionStrength
        frequencyOfInteraction
        lastInteractionDate
        sharedInterests
        sharedGoals
        sharedEventsAttended
        friendPersonalityTraits
        communicationChannel
        level
        startDate
        lastUpdated
        learningStyle
        language
        timeOfDay
        learningDuration
        contentType
        notificationPreferences
        type
        completionStatus
        deadline
        priority
        value
        description
        date
        importance
        status
        endDate
        text
        sentiment
        context
        intensity
        timestamp
        trigger
        calories
        carbohydrates_grams
        fat_grams
        fiber_grams
        protein_grams
        serving_size
        sodium_mg
        sugars_grams
        totalCalories
        totalCarbs
        totalFats
        totalProteins
        totalCaloriesBurned
        totalDurationMinutes
        totalWorkouts
        water_intake_oz
      }
    }
  }
}
    `;

/**
 * __useGetChatByObjectIdQuery__
 *
 * To run a query within a React component, call `useGetChatByObjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatByObjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatByObjectIdQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useGetChatByObjectIdQuery(baseOptions: Apollo.QueryHookOptions<GetChatByObjectIdQuery, GetChatByObjectIdQueryVariables> & ({ variables: GetChatByObjectIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatByObjectIdQuery, GetChatByObjectIdQueryVariables>(GetChatByObjectIdDocument, options);
      }
export function useGetChatByObjectIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatByObjectIdQuery, GetChatByObjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatByObjectIdQuery, GetChatByObjectIdQueryVariables>(GetChatByObjectIdDocument, options);
        }
// @ts-ignore
export function useGetChatByObjectIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetChatByObjectIdQuery, GetChatByObjectIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetChatByObjectIdQuery, GetChatByObjectIdQueryVariables>;
export function useGetChatByObjectIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChatByObjectIdQuery, GetChatByObjectIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetChatByObjectIdQuery | undefined, GetChatByObjectIdQueryVariables>;
export function useGetChatByObjectIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChatByObjectIdQuery, GetChatByObjectIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChatByObjectIdQuery, GetChatByObjectIdQueryVariables>(GetChatByObjectIdDocument, options);
        }
export type GetChatByObjectIdQueryHookResult = ReturnType<typeof useGetChatByObjectIdQuery>;
export type GetChatByObjectIdLazyQueryHookResult = ReturnType<typeof useGetChatByObjectIdLazyQuery>;
export type GetChatByObjectIdSuspenseQueryHookResult = ReturnType<typeof useGetChatByObjectIdSuspenseQuery>;
export type GetChatByObjectIdQueryResult = Apollo.QueryResult<GetChatByObjectIdQuery, GetChatByObjectIdQueryVariables>;
export const GetChatsDocument = gql`
    query GetChats {
  getChats {
    id
    date
    name
    objectId
    context
    params
    url
  }
}
    `;

/**
 * __useGetChatsQuery__
 *
 * To run a query within a React component, call `useGetChatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetChatsQuery(baseOptions?: Apollo.QueryHookOptions<GetChatsQuery, GetChatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatsQuery, GetChatsQueryVariables>(GetChatsDocument, options);
      }
export function useGetChatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatsQuery, GetChatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatsQuery, GetChatsQueryVariables>(GetChatsDocument, options);
        }
// @ts-ignore
export function useGetChatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetChatsQuery, GetChatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetChatsQuery, GetChatsQueryVariables>;
export function useGetChatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChatsQuery, GetChatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetChatsQuery | undefined, GetChatsQueryVariables>;
export function useGetChatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChatsQuery, GetChatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChatsQuery, GetChatsQueryVariables>(GetChatsDocument, options);
        }
export type GetChatsQueryHookResult = ReturnType<typeof useGetChatsQuery>;
export type GetChatsLazyQueryHookResult = ReturnType<typeof useGetChatsLazyQuery>;
export type GetChatsSuspenseQueryHookResult = ReturnType<typeof useGetChatsSuspenseQuery>;
export type GetChatsQueryResult = Apollo.QueryResult<GetChatsQuery, GetChatsQueryVariables>;
export const GetCompanionChatByAiTutorIdDocument = gql`
    query GetCompanionChatByAiTutorId($aiTutorId: ID!) {
  getCompanionChatByAiTutorId(aiTutorId: $aiTutorId) {
    success
    message
    data {
      id
      date
      name
      objectId
      params
      url
      last_modified
      created
      workspacesHasChat {
        id
        name
        created
        lastModified
        type
      }
      conversation {
        id
        sender
        content
        created
        todos {
          id
          name
          priority
          completed
          date
        }
        assignments {
          id
          name
          course_id
          due_date
        }
        files {
          id
          fileName
        }
      }
    }
  }
}
    `;

/**
 * __useGetCompanionChatByAiTutorIdQuery__
 *
 * To run a query within a React component, call `useGetCompanionChatByAiTutorIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanionChatByAiTutorIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanionChatByAiTutorIdQuery({
 *   variables: {
 *      aiTutorId: // value for 'aiTutorId'
 *   },
 * });
 */
export function useGetCompanionChatByAiTutorIdQuery(baseOptions: Apollo.QueryHookOptions<GetCompanionChatByAiTutorIdQuery, GetCompanionChatByAiTutorIdQueryVariables> & ({ variables: GetCompanionChatByAiTutorIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanionChatByAiTutorIdQuery, GetCompanionChatByAiTutorIdQueryVariables>(GetCompanionChatByAiTutorIdDocument, options);
      }
export function useGetCompanionChatByAiTutorIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanionChatByAiTutorIdQuery, GetCompanionChatByAiTutorIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanionChatByAiTutorIdQuery, GetCompanionChatByAiTutorIdQueryVariables>(GetCompanionChatByAiTutorIdDocument, options);
        }
// @ts-ignore
export function useGetCompanionChatByAiTutorIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanionChatByAiTutorIdQuery, GetCompanionChatByAiTutorIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanionChatByAiTutorIdQuery, GetCompanionChatByAiTutorIdQueryVariables>;
export function useGetCompanionChatByAiTutorIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanionChatByAiTutorIdQuery, GetCompanionChatByAiTutorIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanionChatByAiTutorIdQuery | undefined, GetCompanionChatByAiTutorIdQueryVariables>;
export function useGetCompanionChatByAiTutorIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanionChatByAiTutorIdQuery, GetCompanionChatByAiTutorIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanionChatByAiTutorIdQuery, GetCompanionChatByAiTutorIdQueryVariables>(GetCompanionChatByAiTutorIdDocument, options);
        }
export type GetCompanionChatByAiTutorIdQueryHookResult = ReturnType<typeof useGetCompanionChatByAiTutorIdQuery>;
export type GetCompanionChatByAiTutorIdLazyQueryHookResult = ReturnType<typeof useGetCompanionChatByAiTutorIdLazyQuery>;
export type GetCompanionChatByAiTutorIdSuspenseQueryHookResult = ReturnType<typeof useGetCompanionChatByAiTutorIdSuspenseQuery>;
export type GetCompanionChatByAiTutorIdQueryResult = Apollo.QueryResult<GetCompanionChatByAiTutorIdQuery, GetCompanionChatByAiTutorIdQueryVariables>;
export const GetCompanionChatByIdDocument = gql`
    query GetCompanionChatById($id: ID!) {
  getCompanionChatById(id: $id) {
    success
    message
    data {
      id
      date
      name
      objectId
      params
      url
      last_modified
      created
      workspacesHasChat {
        id
        name
        created
        lastModified
        type
      }
      conversation {
        id
        sender
        content
        created
        todos {
          id
          name
          priority
          completed
          date
        }
        assignments {
          id
          name
          course_id
          due_date
        }
        files {
          id
          fileName
        }
      }
    }
  }
}
    `;

/**
 * __useGetCompanionChatByIdQuery__
 *
 * To run a query within a React component, call `useGetCompanionChatByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanionChatByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanionChatByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanionChatByIdQuery(baseOptions: Apollo.QueryHookOptions<GetCompanionChatByIdQuery, GetCompanionChatByIdQueryVariables> & ({ variables: GetCompanionChatByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanionChatByIdQuery, GetCompanionChatByIdQueryVariables>(GetCompanionChatByIdDocument, options);
      }
export function useGetCompanionChatByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanionChatByIdQuery, GetCompanionChatByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanionChatByIdQuery, GetCompanionChatByIdQueryVariables>(GetCompanionChatByIdDocument, options);
        }
// @ts-ignore
export function useGetCompanionChatByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanionChatByIdQuery, GetCompanionChatByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanionChatByIdQuery, GetCompanionChatByIdQueryVariables>;
export function useGetCompanionChatByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanionChatByIdQuery, GetCompanionChatByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanionChatByIdQuery | undefined, GetCompanionChatByIdQueryVariables>;
export function useGetCompanionChatByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanionChatByIdQuery, GetCompanionChatByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanionChatByIdQuery, GetCompanionChatByIdQueryVariables>(GetCompanionChatByIdDocument, options);
        }
export type GetCompanionChatByIdQueryHookResult = ReturnType<typeof useGetCompanionChatByIdQuery>;
export type GetCompanionChatByIdLazyQueryHookResult = ReturnType<typeof useGetCompanionChatByIdLazyQuery>;
export type GetCompanionChatByIdSuspenseQueryHookResult = ReturnType<typeof useGetCompanionChatByIdSuspenseQuery>;
export type GetCompanionChatByIdQueryResult = Apollo.QueryResult<GetCompanionChatByIdQuery, GetCompanionChatByIdQueryVariables>;
export const GetFlaggedMessagesDocument = gql`
    query GetFlaggedMessages($page: Int!, $pageSize: Int!) {
  getFlaggedMessages(page: $page, pageSize: $pageSize) {
    success
    message
    count
    data {
      messageId
      studentName
      studentEmail
      categories
      severity
      time
      caseDetails
    }
  }
}
    `;

/**
 * __useGetFlaggedMessagesQuery__
 *
 * To run a query within a React component, call `useGetFlaggedMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFlaggedMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFlaggedMessagesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetFlaggedMessagesQuery(baseOptions: Apollo.QueryHookOptions<GetFlaggedMessagesQuery, GetFlaggedMessagesQueryVariables> & ({ variables: GetFlaggedMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFlaggedMessagesQuery, GetFlaggedMessagesQueryVariables>(GetFlaggedMessagesDocument, options);
      }
export function useGetFlaggedMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFlaggedMessagesQuery, GetFlaggedMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFlaggedMessagesQuery, GetFlaggedMessagesQueryVariables>(GetFlaggedMessagesDocument, options);
        }
// @ts-ignore
export function useGetFlaggedMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFlaggedMessagesQuery, GetFlaggedMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetFlaggedMessagesQuery, GetFlaggedMessagesQueryVariables>;
export function useGetFlaggedMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFlaggedMessagesQuery, GetFlaggedMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetFlaggedMessagesQuery | undefined, GetFlaggedMessagesQueryVariables>;
export function useGetFlaggedMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFlaggedMessagesQuery, GetFlaggedMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFlaggedMessagesQuery, GetFlaggedMessagesQueryVariables>(GetFlaggedMessagesDocument, options);
        }
export type GetFlaggedMessagesQueryHookResult = ReturnType<typeof useGetFlaggedMessagesQuery>;
export type GetFlaggedMessagesLazyQueryHookResult = ReturnType<typeof useGetFlaggedMessagesLazyQuery>;
export type GetFlaggedMessagesSuspenseQueryHookResult = ReturnType<typeof useGetFlaggedMessagesSuspenseQuery>;
export type GetFlaggedMessagesQueryResult = Apollo.QueryResult<GetFlaggedMessagesQuery, GetFlaggedMessagesQueryVariables>;
export const TodayChatDocument = gql`
    query TodayChat($timezone: String!) {
  getTodayChat(timezone: $timezone) {
    id
    date
    name
    timezone
    objectId
    context
    params
    conversation {
      id
      sender
      content
      type
      nodeId
      snackType
      file {
        fileName
        id
      }
      parameters {
        lastGeneratedTopic
        lastGeneratedLabel
        questContext
        userResponse
      }
      aspectDetails {
        name
        category
        id
        friendId
        relationshipType
        connectionStrength
        frequencyOfInteraction
        lastInteractionDate
        sharedInterests
        sharedGoals
        sharedEventsAttended
        friendPersonalityTraits
        communicationChannel
        level
        startDate
        lastUpdated
        learningStyle
        language
        timeOfDay
        learningDuration
        contentType
        notificationPreferences
        type
        completionStatus
        deadline
        priority
        value
        description
        date
        importance
        status
        endDate
        text
        sentiment
        context
        intensity
        timestamp
        trigger
        calories
        carbohydrates_grams
        fat_grams
        fiber_grams
        protein_grams
        serving_size
        sodium_mg
        sugars_grams
        totalCalories
        totalCarbs
        totalFats
        totalProteins
        totalCaloriesBurned
        totalDurationMinutes
        totalWorkouts
        water_intake_oz
      }
    }
  }
}
    `;

/**
 * __useTodayChatQuery__
 *
 * To run a query within a React component, call `useTodayChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useTodayChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTodayChatQuery({
 *   variables: {
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useTodayChatQuery(baseOptions: Apollo.QueryHookOptions<TodayChatQuery, TodayChatQueryVariables> & ({ variables: TodayChatQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TodayChatQuery, TodayChatQueryVariables>(TodayChatDocument, options);
      }
export function useTodayChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TodayChatQuery, TodayChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TodayChatQuery, TodayChatQueryVariables>(TodayChatDocument, options);
        }
// @ts-ignore
export function useTodayChatSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TodayChatQuery, TodayChatQueryVariables>): Apollo.UseSuspenseQueryResult<TodayChatQuery, TodayChatQueryVariables>;
export function useTodayChatSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TodayChatQuery, TodayChatQueryVariables>): Apollo.UseSuspenseQueryResult<TodayChatQuery | undefined, TodayChatQueryVariables>;
export function useTodayChatSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TodayChatQuery, TodayChatQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TodayChatQuery, TodayChatQueryVariables>(TodayChatDocument, options);
        }
export type TodayChatQueryHookResult = ReturnType<typeof useTodayChatQuery>;
export type TodayChatLazyQueryHookResult = ReturnType<typeof useTodayChatLazyQuery>;
export type TodayChatSuspenseQueryHookResult = ReturnType<typeof useTodayChatSuspenseQuery>;
export type TodayChatQueryResult = Apollo.QueryResult<TodayChatQuery, TodayChatQueryVariables>;
export const GetAllCompanionChatsForUserDocument = gql`
    query getAllCompanionChatsForUser {
  getAllCompanionChatsForUser {
    success
    message
    data {
      generalChats {
        id
        name
        last_modified
        created
      }
      generalChatsCount
      courseWorkspaces {
        id
        name
        created
        lastModified
        key
        chats {
          id
          name
          last_modified
          created
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllCompanionChatsForUserQuery__
 *
 * To run a query within a React component, call `useGetAllCompanionChatsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCompanionChatsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCompanionChatsForUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCompanionChatsForUserQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCompanionChatsForUserQuery, GetAllCompanionChatsForUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCompanionChatsForUserQuery, GetAllCompanionChatsForUserQueryVariables>(GetAllCompanionChatsForUserDocument, options);
      }
export function useGetAllCompanionChatsForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCompanionChatsForUserQuery, GetAllCompanionChatsForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCompanionChatsForUserQuery, GetAllCompanionChatsForUserQueryVariables>(GetAllCompanionChatsForUserDocument, options);
        }
// @ts-ignore
export function useGetAllCompanionChatsForUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllCompanionChatsForUserQuery, GetAllCompanionChatsForUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllCompanionChatsForUserQuery, GetAllCompanionChatsForUserQueryVariables>;
export function useGetAllCompanionChatsForUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCompanionChatsForUserQuery, GetAllCompanionChatsForUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllCompanionChatsForUserQuery | undefined, GetAllCompanionChatsForUserQueryVariables>;
export function useGetAllCompanionChatsForUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCompanionChatsForUserQuery, GetAllCompanionChatsForUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCompanionChatsForUserQuery, GetAllCompanionChatsForUserQueryVariables>(GetAllCompanionChatsForUserDocument, options);
        }
export type GetAllCompanionChatsForUserQueryHookResult = ReturnType<typeof useGetAllCompanionChatsForUserQuery>;
export type GetAllCompanionChatsForUserLazyQueryHookResult = ReturnType<typeof useGetAllCompanionChatsForUserLazyQuery>;
export type GetAllCompanionChatsForUserSuspenseQueryHookResult = ReturnType<typeof useGetAllCompanionChatsForUserSuspenseQuery>;
export type GetAllCompanionChatsForUserQueryResult = Apollo.QueryResult<GetAllCompanionChatsForUserQuery, GetAllCompanionChatsForUserQueryVariables>;
export const GetCompanionChatsForUserPreviewDocument = gql`
    query getCompanionChatsForUserPreview($limit: Int!) {
  getCompanionChatsForUserPreview(limit: $limit) {
    success
    message
    data {
      generalChats {
        id
        name
        last_modified
        created
      }
      generalChatsCount
      courseWorkspaces {
        id
        name
        created
        lastModified
        key
        totalCount
        chats {
          id
          name
          last_modified
          created
        }
      }
    }
  }
}
    `;

/**
 * __useGetCompanionChatsForUserPreviewQuery__
 *
 * To run a query within a React component, call `useGetCompanionChatsForUserPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanionChatsForUserPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanionChatsForUserPreviewQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetCompanionChatsForUserPreviewQuery(baseOptions: Apollo.QueryHookOptions<GetCompanionChatsForUserPreviewQuery, GetCompanionChatsForUserPreviewQueryVariables> & ({ variables: GetCompanionChatsForUserPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanionChatsForUserPreviewQuery, GetCompanionChatsForUserPreviewQueryVariables>(GetCompanionChatsForUserPreviewDocument, options);
      }
export function useGetCompanionChatsForUserPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanionChatsForUserPreviewQuery, GetCompanionChatsForUserPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanionChatsForUserPreviewQuery, GetCompanionChatsForUserPreviewQueryVariables>(GetCompanionChatsForUserPreviewDocument, options);
        }
// @ts-ignore
export function useGetCompanionChatsForUserPreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanionChatsForUserPreviewQuery, GetCompanionChatsForUserPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanionChatsForUserPreviewQuery, GetCompanionChatsForUserPreviewQueryVariables>;
export function useGetCompanionChatsForUserPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanionChatsForUserPreviewQuery, GetCompanionChatsForUserPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanionChatsForUserPreviewQuery | undefined, GetCompanionChatsForUserPreviewQueryVariables>;
export function useGetCompanionChatsForUserPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanionChatsForUserPreviewQuery, GetCompanionChatsForUserPreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanionChatsForUserPreviewQuery, GetCompanionChatsForUserPreviewQueryVariables>(GetCompanionChatsForUserPreviewDocument, options);
        }
export type GetCompanionChatsForUserPreviewQueryHookResult = ReturnType<typeof useGetCompanionChatsForUserPreviewQuery>;
export type GetCompanionChatsForUserPreviewLazyQueryHookResult = ReturnType<typeof useGetCompanionChatsForUserPreviewLazyQuery>;
export type GetCompanionChatsForUserPreviewSuspenseQueryHookResult = ReturnType<typeof useGetCompanionChatsForUserPreviewSuspenseQuery>;
export type GetCompanionChatsForUserPreviewQueryResult = Apollo.QueryResult<GetCompanionChatsForUserPreviewQuery, GetCompanionChatsForUserPreviewQueryVariables>;
export const GetCompanionWorkspaceChatsDocument = gql`
    query getCompanionWorkspaceChats($workspaceId: ID!, $offset: Int!, $limit: Int!) {
  getCompanionWorkspaceChats(
    workspaceId: $workspaceId
    offset: $offset
    limit: $limit
  ) {
    totalCount
    chats {
      id
      name
      last_modified
      created
    }
  }
}
    `;

/**
 * __useGetCompanionWorkspaceChatsQuery__
 *
 * To run a query within a React component, call `useGetCompanionWorkspaceChatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanionWorkspaceChatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanionWorkspaceChatsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetCompanionWorkspaceChatsQuery(baseOptions: Apollo.QueryHookOptions<GetCompanionWorkspaceChatsQuery, GetCompanionWorkspaceChatsQueryVariables> & ({ variables: GetCompanionWorkspaceChatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanionWorkspaceChatsQuery, GetCompanionWorkspaceChatsQueryVariables>(GetCompanionWorkspaceChatsDocument, options);
      }
export function useGetCompanionWorkspaceChatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanionWorkspaceChatsQuery, GetCompanionWorkspaceChatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanionWorkspaceChatsQuery, GetCompanionWorkspaceChatsQueryVariables>(GetCompanionWorkspaceChatsDocument, options);
        }
// @ts-ignore
export function useGetCompanionWorkspaceChatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanionWorkspaceChatsQuery, GetCompanionWorkspaceChatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanionWorkspaceChatsQuery, GetCompanionWorkspaceChatsQueryVariables>;
export function useGetCompanionWorkspaceChatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanionWorkspaceChatsQuery, GetCompanionWorkspaceChatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanionWorkspaceChatsQuery | undefined, GetCompanionWorkspaceChatsQueryVariables>;
export function useGetCompanionWorkspaceChatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanionWorkspaceChatsQuery, GetCompanionWorkspaceChatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanionWorkspaceChatsQuery, GetCompanionWorkspaceChatsQueryVariables>(GetCompanionWorkspaceChatsDocument, options);
        }
export type GetCompanionWorkspaceChatsQueryHookResult = ReturnType<typeof useGetCompanionWorkspaceChatsQuery>;
export type GetCompanionWorkspaceChatsLazyQueryHookResult = ReturnType<typeof useGetCompanionWorkspaceChatsLazyQuery>;
export type GetCompanionWorkspaceChatsSuspenseQueryHookResult = ReturnType<typeof useGetCompanionWorkspaceChatsSuspenseQuery>;
export type GetCompanionWorkspaceChatsQueryResult = Apollo.QueryResult<GetCompanionWorkspaceChatsQuery, GetCompanionWorkspaceChatsQueryVariables>;
export const GetGeneralCompanionChatsForUserDocument = gql`
    query getGeneralCompanionChatsForUser($offset: Int!, $limit: Int!) {
  getGeneralCompanionChatsForUser(offset: $offset, limit: $limit) {
    totalCount
    chats {
      id
      name
      last_modified
      created
    }
  }
}
    `;

/**
 * __useGetGeneralCompanionChatsForUserQuery__
 *
 * To run a query within a React component, call `useGetGeneralCompanionChatsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeneralCompanionChatsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeneralCompanionChatsForUserQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetGeneralCompanionChatsForUserQuery(baseOptions: Apollo.QueryHookOptions<GetGeneralCompanionChatsForUserQuery, GetGeneralCompanionChatsForUserQueryVariables> & ({ variables: GetGeneralCompanionChatsForUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGeneralCompanionChatsForUserQuery, GetGeneralCompanionChatsForUserQueryVariables>(GetGeneralCompanionChatsForUserDocument, options);
      }
export function useGetGeneralCompanionChatsForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGeneralCompanionChatsForUserQuery, GetGeneralCompanionChatsForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGeneralCompanionChatsForUserQuery, GetGeneralCompanionChatsForUserQueryVariables>(GetGeneralCompanionChatsForUserDocument, options);
        }
// @ts-ignore
export function useGetGeneralCompanionChatsForUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGeneralCompanionChatsForUserQuery, GetGeneralCompanionChatsForUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetGeneralCompanionChatsForUserQuery, GetGeneralCompanionChatsForUserQueryVariables>;
export function useGetGeneralCompanionChatsForUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGeneralCompanionChatsForUserQuery, GetGeneralCompanionChatsForUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetGeneralCompanionChatsForUserQuery | undefined, GetGeneralCompanionChatsForUserQueryVariables>;
export function useGetGeneralCompanionChatsForUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGeneralCompanionChatsForUserQuery, GetGeneralCompanionChatsForUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGeneralCompanionChatsForUserQuery, GetGeneralCompanionChatsForUserQueryVariables>(GetGeneralCompanionChatsForUserDocument, options);
        }
export type GetGeneralCompanionChatsForUserQueryHookResult = ReturnType<typeof useGetGeneralCompanionChatsForUserQuery>;
export type GetGeneralCompanionChatsForUserLazyQueryHookResult = ReturnType<typeof useGetGeneralCompanionChatsForUserLazyQuery>;
export type GetGeneralCompanionChatsForUserSuspenseQueryHookResult = ReturnType<typeof useGetGeneralCompanionChatsForUserSuspenseQuery>;
export type GetGeneralCompanionChatsForUserQueryResult = Apollo.QueryResult<GetGeneralCompanionChatsForUserQuery, GetGeneralCompanionChatsForUserQueryVariables>;
export const GetContentByIdDocument = gql`
    query GetContentById($id: ID!) {
  getContentById(id: $id) {
    id
    name
    standard
    weeks
    objectives
    modules {
      module_name
      assignments {
        assignment_name
        html
      }
    }
    created
    last_modified
  }
}
    `;

/**
 * __useGetContentByIdQuery__
 *
 * To run a query within a React component, call `useGetContentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContentByIdQuery(baseOptions: Apollo.QueryHookOptions<GetContentByIdQuery, GetContentByIdQueryVariables> & ({ variables: GetContentByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentByIdQuery, GetContentByIdQueryVariables>(GetContentByIdDocument, options);
      }
export function useGetContentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentByIdQuery, GetContentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentByIdQuery, GetContentByIdQueryVariables>(GetContentByIdDocument, options);
        }
// @ts-ignore
export function useGetContentByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContentByIdQuery, GetContentByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetContentByIdQuery, GetContentByIdQueryVariables>;
export function useGetContentByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentByIdQuery, GetContentByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetContentByIdQuery | undefined, GetContentByIdQueryVariables>;
export function useGetContentByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentByIdQuery, GetContentByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContentByIdQuery, GetContentByIdQueryVariables>(GetContentByIdDocument, options);
        }
export type GetContentByIdQueryHookResult = ReturnType<typeof useGetContentByIdQuery>;
export type GetContentByIdLazyQueryHookResult = ReturnType<typeof useGetContentByIdLazyQuery>;
export type GetContentByIdSuspenseQueryHookResult = ReturnType<typeof useGetContentByIdSuspenseQuery>;
export type GetContentByIdQueryResult = Apollo.QueryResult<GetContentByIdQuery, GetContentByIdQueryVariables>;
export const GetGeneratedContentDocument = gql`
    query GetGeneratedContent {
  getGeneratedContent {
    id
    name
    standard
    weeks
    objectives
    modules {
      module_name
      assignments {
        assignment_name
        html
      }
    }
    created
    last_modified
  }
}
    `;

/**
 * __useGetGeneratedContentQuery__
 *
 * To run a query within a React component, call `useGetGeneratedContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeneratedContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeneratedContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGeneratedContentQuery(baseOptions?: Apollo.QueryHookOptions<GetGeneratedContentQuery, GetGeneratedContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGeneratedContentQuery, GetGeneratedContentQueryVariables>(GetGeneratedContentDocument, options);
      }
export function useGetGeneratedContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGeneratedContentQuery, GetGeneratedContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGeneratedContentQuery, GetGeneratedContentQueryVariables>(GetGeneratedContentDocument, options);
        }
// @ts-ignore
export function useGetGeneratedContentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGeneratedContentQuery, GetGeneratedContentQueryVariables>): Apollo.UseSuspenseQueryResult<GetGeneratedContentQuery, GetGeneratedContentQueryVariables>;
export function useGetGeneratedContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGeneratedContentQuery, GetGeneratedContentQueryVariables>): Apollo.UseSuspenseQueryResult<GetGeneratedContentQuery | undefined, GetGeneratedContentQueryVariables>;
export function useGetGeneratedContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGeneratedContentQuery, GetGeneratedContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGeneratedContentQuery, GetGeneratedContentQueryVariables>(GetGeneratedContentDocument, options);
        }
export type GetGeneratedContentQueryHookResult = ReturnType<typeof useGetGeneratedContentQuery>;
export type GetGeneratedContentLazyQueryHookResult = ReturnType<typeof useGetGeneratedContentLazyQuery>;
export type GetGeneratedContentSuspenseQueryHookResult = ReturnType<typeof useGetGeneratedContentSuspenseQuery>;
export type GetGeneratedContentQueryResult = Apollo.QueryResult<GetGeneratedContentQuery, GetGeneratedContentQueryVariables>;
export const GetAllAxioResourcesByCourseDocument = gql`
    query GetAllAxioResourcesByCourse($courseId: ID!) {
  getAllAxioResourcesByCourse(courseId: $courseId) {
    success
    message
    data {
      id
      moduleId
      order
      name
      description
      files {
        id
        fileName
        fileURL
        created
        status
      }
      videoUrl
      created
      lastModified
    }
  }
}
    `;

/**
 * __useGetAllAxioResourcesByCourseQuery__
 *
 * To run a query within a React component, call `useGetAllAxioResourcesByCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAxioResourcesByCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAxioResourcesByCourseQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetAllAxioResourcesByCourseQuery(baseOptions: Apollo.QueryHookOptions<GetAllAxioResourcesByCourseQuery, GetAllAxioResourcesByCourseQueryVariables> & ({ variables: GetAllAxioResourcesByCourseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAxioResourcesByCourseQuery, GetAllAxioResourcesByCourseQueryVariables>(GetAllAxioResourcesByCourseDocument, options);
      }
export function useGetAllAxioResourcesByCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAxioResourcesByCourseQuery, GetAllAxioResourcesByCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAxioResourcesByCourseQuery, GetAllAxioResourcesByCourseQueryVariables>(GetAllAxioResourcesByCourseDocument, options);
        }
// @ts-ignore
export function useGetAllAxioResourcesByCourseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllAxioResourcesByCourseQuery, GetAllAxioResourcesByCourseQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllAxioResourcesByCourseQuery, GetAllAxioResourcesByCourseQueryVariables>;
export function useGetAllAxioResourcesByCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAxioResourcesByCourseQuery, GetAllAxioResourcesByCourseQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllAxioResourcesByCourseQuery | undefined, GetAllAxioResourcesByCourseQueryVariables>;
export function useGetAllAxioResourcesByCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAxioResourcesByCourseQuery, GetAllAxioResourcesByCourseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllAxioResourcesByCourseQuery, GetAllAxioResourcesByCourseQueryVariables>(GetAllAxioResourcesByCourseDocument, options);
        }
export type GetAllAxioResourcesByCourseQueryHookResult = ReturnType<typeof useGetAllAxioResourcesByCourseQuery>;
export type GetAllAxioResourcesByCourseLazyQueryHookResult = ReturnType<typeof useGetAllAxioResourcesByCourseLazyQuery>;
export type GetAllAxioResourcesByCourseSuspenseQueryHookResult = ReturnType<typeof useGetAllAxioResourcesByCourseSuspenseQuery>;
export type GetAllAxioResourcesByCourseQueryResult = Apollo.QueryResult<GetAllAxioResourcesByCourseQuery, GetAllAxioResourcesByCourseQueryVariables>;
export const GetAllCoursesBySchoolDocument = gql`
    query GetAllCoursesBySchool($schoolId: ID!, $page: Int, $pageSize: Int) {
  getAllCoursesBySchool(schoolId: $schoolId, page: $page, pageSize: $pageSize) {
    success
    data {
      courses {
        id
        name
        isDraft
        learningStandards
        lengthInWeeks
        objectives
        last_modified
        thumbnail
        cost
        startDate
        description
        targetAudience
        course_code
        enrolledStudents {
          id
        }
        hasAssignmentAssignments {
          id
          title
          description
        }
        evaluations {
          id
          status
          createdAt
        }
      }
      totalCount
    }
    count
  }
}
    `;

/**
 * __useGetAllCoursesBySchoolQuery__
 *
 * To run a query within a React component, call `useGetAllCoursesBySchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCoursesBySchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCoursesBySchoolQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetAllCoursesBySchoolQuery(baseOptions: Apollo.QueryHookOptions<GetAllCoursesBySchoolQuery, GetAllCoursesBySchoolQueryVariables> & ({ variables: GetAllCoursesBySchoolQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCoursesBySchoolQuery, GetAllCoursesBySchoolQueryVariables>(GetAllCoursesBySchoolDocument, options);
      }
export function useGetAllCoursesBySchoolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCoursesBySchoolQuery, GetAllCoursesBySchoolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCoursesBySchoolQuery, GetAllCoursesBySchoolQueryVariables>(GetAllCoursesBySchoolDocument, options);
        }
// @ts-ignore
export function useGetAllCoursesBySchoolSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllCoursesBySchoolQuery, GetAllCoursesBySchoolQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllCoursesBySchoolQuery, GetAllCoursesBySchoolQueryVariables>;
export function useGetAllCoursesBySchoolSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCoursesBySchoolQuery, GetAllCoursesBySchoolQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllCoursesBySchoolQuery | undefined, GetAllCoursesBySchoolQueryVariables>;
export function useGetAllCoursesBySchoolSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCoursesBySchoolQuery, GetAllCoursesBySchoolQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCoursesBySchoolQuery, GetAllCoursesBySchoolQueryVariables>(GetAllCoursesBySchoolDocument, options);
        }
export type GetAllCoursesBySchoolQueryHookResult = ReturnType<typeof useGetAllCoursesBySchoolQuery>;
export type GetAllCoursesBySchoolLazyQueryHookResult = ReturnType<typeof useGetAllCoursesBySchoolLazyQuery>;
export type GetAllCoursesBySchoolSuspenseQueryHookResult = ReturnType<typeof useGetAllCoursesBySchoolSuspenseQuery>;
export type GetAllCoursesBySchoolQueryResult = Apollo.QueryResult<GetAllCoursesBySchoolQuery, GetAllCoursesBySchoolQueryVariables>;
export const GetAllReviewsByCourseDocument = gql`
    query GetAllReviewsByCourse($courseId: ID!) {
  getAllReviewsByCourse(courseId: $courseId) {
    success
    message
    data {
      id
      created
      lastModified
      hasReviewFor {
        id
      }
      hasAITutors {
        id
        title
      }
      moduleHasReviews {
        id
      }
    }
    count
  }
}
    `;

/**
 * __useGetAllReviewsByCourseQuery__
 *
 * To run a query within a React component, call `useGetAllReviewsByCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllReviewsByCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllReviewsByCourseQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetAllReviewsByCourseQuery(baseOptions: Apollo.QueryHookOptions<GetAllReviewsByCourseQuery, GetAllReviewsByCourseQueryVariables> & ({ variables: GetAllReviewsByCourseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllReviewsByCourseQuery, GetAllReviewsByCourseQueryVariables>(GetAllReviewsByCourseDocument, options);
      }
export function useGetAllReviewsByCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllReviewsByCourseQuery, GetAllReviewsByCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllReviewsByCourseQuery, GetAllReviewsByCourseQueryVariables>(GetAllReviewsByCourseDocument, options);
        }
// @ts-ignore
export function useGetAllReviewsByCourseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllReviewsByCourseQuery, GetAllReviewsByCourseQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllReviewsByCourseQuery, GetAllReviewsByCourseQueryVariables>;
export function useGetAllReviewsByCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllReviewsByCourseQuery, GetAllReviewsByCourseQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllReviewsByCourseQuery | undefined, GetAllReviewsByCourseQueryVariables>;
export function useGetAllReviewsByCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllReviewsByCourseQuery, GetAllReviewsByCourseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllReviewsByCourseQuery, GetAllReviewsByCourseQueryVariables>(GetAllReviewsByCourseDocument, options);
        }
export type GetAllReviewsByCourseQueryHookResult = ReturnType<typeof useGetAllReviewsByCourseQuery>;
export type GetAllReviewsByCourseLazyQueryHookResult = ReturnType<typeof useGetAllReviewsByCourseLazyQuery>;
export type GetAllReviewsByCourseSuspenseQueryHookResult = ReturnType<typeof useGetAllReviewsByCourseSuspenseQuery>;
export type GetAllReviewsByCourseQueryResult = Apollo.QueryResult<GetAllReviewsByCourseQuery, GetAllReviewsByCourseQueryVariables>;
export const GetAnnouncementsByCourseDocument = gql`
    query GetAnnouncementsByCourse($courseId: ID!, $includeInactive: Boolean) {
  getAnnouncementsByCourse(courseId: $courseId, includeInactive: $includeInactive) {
    success
    message
    data {
      id
      title
      message
      expirationDate
      created
      lastModified
      isActive
      audienceType
      author {
        id
        name
        email
      }
      courses {
        id
        name
      }
      degrees {
        id
        name
      }
      school {
        id
        team_name
      }
    }
    count
  }
}
    `;

/**
 * __useGetAnnouncementsByCourseQuery__
 *
 * To run a query within a React component, call `useGetAnnouncementsByCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnouncementsByCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnouncementsByCourseQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useGetAnnouncementsByCourseQuery(baseOptions: Apollo.QueryHookOptions<GetAnnouncementsByCourseQuery, GetAnnouncementsByCourseQueryVariables> & ({ variables: GetAnnouncementsByCourseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnnouncementsByCourseQuery, GetAnnouncementsByCourseQueryVariables>(GetAnnouncementsByCourseDocument, options);
      }
export function useGetAnnouncementsByCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnnouncementsByCourseQuery, GetAnnouncementsByCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnnouncementsByCourseQuery, GetAnnouncementsByCourseQueryVariables>(GetAnnouncementsByCourseDocument, options);
        }
// @ts-ignore
export function useGetAnnouncementsByCourseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAnnouncementsByCourseQuery, GetAnnouncementsByCourseQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnnouncementsByCourseQuery, GetAnnouncementsByCourseQueryVariables>;
export function useGetAnnouncementsByCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnnouncementsByCourseQuery, GetAnnouncementsByCourseQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnnouncementsByCourseQuery | undefined, GetAnnouncementsByCourseQueryVariables>;
export function useGetAnnouncementsByCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnnouncementsByCourseQuery, GetAnnouncementsByCourseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnnouncementsByCourseQuery, GetAnnouncementsByCourseQueryVariables>(GetAnnouncementsByCourseDocument, options);
        }
export type GetAnnouncementsByCourseQueryHookResult = ReturnType<typeof useGetAnnouncementsByCourseQuery>;
export type GetAnnouncementsByCourseLazyQueryHookResult = ReturnType<typeof useGetAnnouncementsByCourseLazyQuery>;
export type GetAnnouncementsByCourseSuspenseQueryHookResult = ReturnType<typeof useGetAnnouncementsByCourseSuspenseQuery>;
export type GetAnnouncementsByCourseQueryResult = Apollo.QueryResult<GetAnnouncementsByCourseQuery, GetAnnouncementsByCourseQueryVariables>;
export const GetAnnouncementsBySchoolDocument = gql`
    query GetAnnouncementsBySchool($schoolId: ID!, $includeInactive: Boolean) {
  getAnnouncementsBySchool(schoolId: $schoolId, includeInactive: $includeInactive) {
    success
    message
    data {
      id
      title
      message
      expirationDate
      created
      lastModified
      isActive
      audienceType
      author {
        id
        name
        email
      }
      school {
        id
        provider_name
      }
      courses {
        id
        name
      }
      degrees {
        id
        name
      }
    }
    count
  }
}
    `;

/**
 * __useGetAnnouncementsBySchoolQuery__
 *
 * To run a query within a React component, call `useGetAnnouncementsBySchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnouncementsBySchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnouncementsBySchoolQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useGetAnnouncementsBySchoolQuery(baseOptions: Apollo.QueryHookOptions<GetAnnouncementsBySchoolQuery, GetAnnouncementsBySchoolQueryVariables> & ({ variables: GetAnnouncementsBySchoolQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnnouncementsBySchoolQuery, GetAnnouncementsBySchoolQueryVariables>(GetAnnouncementsBySchoolDocument, options);
      }
export function useGetAnnouncementsBySchoolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnnouncementsBySchoolQuery, GetAnnouncementsBySchoolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnnouncementsBySchoolQuery, GetAnnouncementsBySchoolQueryVariables>(GetAnnouncementsBySchoolDocument, options);
        }
// @ts-ignore
export function useGetAnnouncementsBySchoolSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAnnouncementsBySchoolQuery, GetAnnouncementsBySchoolQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnnouncementsBySchoolQuery, GetAnnouncementsBySchoolQueryVariables>;
export function useGetAnnouncementsBySchoolSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnnouncementsBySchoolQuery, GetAnnouncementsBySchoolQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnnouncementsBySchoolQuery | undefined, GetAnnouncementsBySchoolQueryVariables>;
export function useGetAnnouncementsBySchoolSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnnouncementsBySchoolQuery, GetAnnouncementsBySchoolQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnnouncementsBySchoolQuery, GetAnnouncementsBySchoolQueryVariables>(GetAnnouncementsBySchoolDocument, options);
        }
export type GetAnnouncementsBySchoolQueryHookResult = ReturnType<typeof useGetAnnouncementsBySchoolQuery>;
export type GetAnnouncementsBySchoolLazyQueryHookResult = ReturnType<typeof useGetAnnouncementsBySchoolLazyQuery>;
export type GetAnnouncementsBySchoolSuspenseQueryHookResult = ReturnType<typeof useGetAnnouncementsBySchoolSuspenseQuery>;
export type GetAnnouncementsBySchoolQueryResult = Apollo.QueryResult<GetAnnouncementsBySchoolQuery, GetAnnouncementsBySchoolQueryVariables>;
export const GetAnnouncementsForStudentDocument = gql`
    query GetAnnouncementsForStudent($courseId: ID!) {
  getAnnouncementsForStudent(courseId: $courseId) {
    success
    message
    data {
      id
      title
      message
      expirationDate
      created
      lastModified
      isActive
      isNew
      audienceType
      author {
        id
        name
        email
      }
      courses {
        id
        name
      }
      degrees {
        id
        name
      }
      school {
        id
        team_name
      }
    }
    count
  }
}
    `;

/**
 * __useGetAnnouncementsForStudentQuery__
 *
 * To run a query within a React component, call `useGetAnnouncementsForStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnouncementsForStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnouncementsForStudentQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetAnnouncementsForStudentQuery(baseOptions: Apollo.QueryHookOptions<GetAnnouncementsForStudentQuery, GetAnnouncementsForStudentQueryVariables> & ({ variables: GetAnnouncementsForStudentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnnouncementsForStudentQuery, GetAnnouncementsForStudentQueryVariables>(GetAnnouncementsForStudentDocument, options);
      }
export function useGetAnnouncementsForStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnnouncementsForStudentQuery, GetAnnouncementsForStudentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnnouncementsForStudentQuery, GetAnnouncementsForStudentQueryVariables>(GetAnnouncementsForStudentDocument, options);
        }
// @ts-ignore
export function useGetAnnouncementsForStudentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAnnouncementsForStudentQuery, GetAnnouncementsForStudentQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnnouncementsForStudentQuery, GetAnnouncementsForStudentQueryVariables>;
export function useGetAnnouncementsForStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnnouncementsForStudentQuery, GetAnnouncementsForStudentQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnnouncementsForStudentQuery | undefined, GetAnnouncementsForStudentQueryVariables>;
export function useGetAnnouncementsForStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnnouncementsForStudentQuery, GetAnnouncementsForStudentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnnouncementsForStudentQuery, GetAnnouncementsForStudentQueryVariables>(GetAnnouncementsForStudentDocument, options);
        }
export type GetAnnouncementsForStudentQueryHookResult = ReturnType<typeof useGetAnnouncementsForStudentQuery>;
export type GetAnnouncementsForStudentLazyQueryHookResult = ReturnType<typeof useGetAnnouncementsForStudentLazyQuery>;
export type GetAnnouncementsForStudentSuspenseQueryHookResult = ReturnType<typeof useGetAnnouncementsForStudentSuspenseQuery>;
export type GetAnnouncementsForStudentQueryResult = Apollo.QueryResult<GetAnnouncementsForStudentQuery, GetAnnouncementsForStudentQueryVariables>;
export const GetAnnouncementsForUserDocument = gql`
    query GetAnnouncementsForUser($schoolId: ID!, $audienceType: AudienceType) {
  getAnnouncementsForUser(schoolId: $schoolId, audienceType: $audienceType) {
    success
    message
    data {
      id
      title
      message
      expirationDate
      created
      lastModified
      isActive
      isNew
      audienceType
      author {
        id
        name
        email
      }
      courses {
        id
        name
      }
      degrees {
        id
        name
      }
      school {
        id
        team_name
      }
    }
    count
  }
}
    `;

/**
 * __useGetAnnouncementsForUserQuery__
 *
 * To run a query within a React component, call `useGetAnnouncementsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnouncementsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnouncementsForUserQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      audienceType: // value for 'audienceType'
 *   },
 * });
 */
export function useGetAnnouncementsForUserQuery(baseOptions: Apollo.QueryHookOptions<GetAnnouncementsForUserQuery, GetAnnouncementsForUserQueryVariables> & ({ variables: GetAnnouncementsForUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnnouncementsForUserQuery, GetAnnouncementsForUserQueryVariables>(GetAnnouncementsForUserDocument, options);
      }
export function useGetAnnouncementsForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnnouncementsForUserQuery, GetAnnouncementsForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnnouncementsForUserQuery, GetAnnouncementsForUserQueryVariables>(GetAnnouncementsForUserDocument, options);
        }
// @ts-ignore
export function useGetAnnouncementsForUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAnnouncementsForUserQuery, GetAnnouncementsForUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnnouncementsForUserQuery, GetAnnouncementsForUserQueryVariables>;
export function useGetAnnouncementsForUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnnouncementsForUserQuery, GetAnnouncementsForUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnnouncementsForUserQuery | undefined, GetAnnouncementsForUserQueryVariables>;
export function useGetAnnouncementsForUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnnouncementsForUserQuery, GetAnnouncementsForUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnnouncementsForUserQuery, GetAnnouncementsForUserQueryVariables>(GetAnnouncementsForUserDocument, options);
        }
export type GetAnnouncementsForUserQueryHookResult = ReturnType<typeof useGetAnnouncementsForUserQuery>;
export type GetAnnouncementsForUserLazyQueryHookResult = ReturnType<typeof useGetAnnouncementsForUserLazyQuery>;
export type GetAnnouncementsForUserSuspenseQueryHookResult = ReturnType<typeof useGetAnnouncementsForUserSuspenseQuery>;
export type GetAnnouncementsForUserQueryResult = Apollo.QueryResult<GetAnnouncementsForUserQuery, GetAnnouncementsForUserQueryVariables>;
export const GetAssignmentsWithCourseDocument = gql`
    query GetAssignmentsWithCourse($schoolId: ID!, $searchQuery: String, $courseId: ID) {
  getAssignmentsWithCourse(
    schoolId: $schoolId
    searchQuery: $searchQuery
    courseId: $courseId
  ) {
    success
    message
    data {
      id
      title
      due_date
      points_possible
      courseName
      courseCode
      courseId
    }
    count
  }
}
    `;

/**
 * __useGetAssignmentsWithCourseQuery__
 *
 * To run a query within a React component, call `useGetAssignmentsWithCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentsWithCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentsWithCourseQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      searchQuery: // value for 'searchQuery'
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetAssignmentsWithCourseQuery(baseOptions: Apollo.QueryHookOptions<GetAssignmentsWithCourseQuery, GetAssignmentsWithCourseQueryVariables> & ({ variables: GetAssignmentsWithCourseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignmentsWithCourseQuery, GetAssignmentsWithCourseQueryVariables>(GetAssignmentsWithCourseDocument, options);
      }
export function useGetAssignmentsWithCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignmentsWithCourseQuery, GetAssignmentsWithCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignmentsWithCourseQuery, GetAssignmentsWithCourseQueryVariables>(GetAssignmentsWithCourseDocument, options);
        }
// @ts-ignore
export function useGetAssignmentsWithCourseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssignmentsWithCourseQuery, GetAssignmentsWithCourseQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssignmentsWithCourseQuery, GetAssignmentsWithCourseQueryVariables>;
export function useGetAssignmentsWithCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssignmentsWithCourseQuery, GetAssignmentsWithCourseQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssignmentsWithCourseQuery | undefined, GetAssignmentsWithCourseQueryVariables>;
export function useGetAssignmentsWithCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssignmentsWithCourseQuery, GetAssignmentsWithCourseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssignmentsWithCourseQuery, GetAssignmentsWithCourseQueryVariables>(GetAssignmentsWithCourseDocument, options);
        }
export type GetAssignmentsWithCourseQueryHookResult = ReturnType<typeof useGetAssignmentsWithCourseQuery>;
export type GetAssignmentsWithCourseLazyQueryHookResult = ReturnType<typeof useGetAssignmentsWithCourseLazyQuery>;
export type GetAssignmentsWithCourseSuspenseQueryHookResult = ReturnType<typeof useGetAssignmentsWithCourseSuspenseQuery>;
export type GetAssignmentsWithCourseQueryResult = Apollo.QueryResult<GetAssignmentsWithCourseQuery, GetAssignmentsWithCourseQueryVariables>;
export const GetAvailableCoursesForStudentDocument = gql`
    query GetAvailableCoursesForStudent($schoolId: ID!, $degreeId: ID, $page: Int, $pageSize: Int) {
  getAvailableCoursesForStudent(
    schoolId: $schoolId
    degreeId: $degreeId
    page: $page
    pageSize: $pageSize
  ) {
    data {
      courses {
        course {
          id
          name
          course_code
          isDraft
          learningStandards
          lengthInWeeks
          objectives
          last_modified
          thumbnail
          cost
          startDate
          description
          targetAudience
          generationStatus
          preRequisites {
            id
            name
            cost
            description
            enrolledStudents {
              id
              name
            }
          }
          preRequisiteFor {
            id
            name
            cost
            description
            enrolledStudents {
              id
              name
            }
          }
          modules {
            id
            title
            assignments {
              id
              name
            }
            aiTutors {
              id
              title
            }
            axioResources {
              id
              name
            }
          }
          enrolledStudents {
            id
            name
          }
          degreesHasCourse {
            id
            name
            usersEnrolledIn {
              id
              name
            }
          }
        }
        progress
        preRequisitesCompleted
      }
      totalCount
    }
    count
  }
}
    `;

/**
 * __useGetAvailableCoursesForStudentQuery__
 *
 * To run a query within a React component, call `useGetAvailableCoursesForStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableCoursesForStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableCoursesForStudentQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      degreeId: // value for 'degreeId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetAvailableCoursesForStudentQuery(baseOptions: Apollo.QueryHookOptions<GetAvailableCoursesForStudentQuery, GetAvailableCoursesForStudentQueryVariables> & ({ variables: GetAvailableCoursesForStudentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableCoursesForStudentQuery, GetAvailableCoursesForStudentQueryVariables>(GetAvailableCoursesForStudentDocument, options);
      }
export function useGetAvailableCoursesForStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableCoursesForStudentQuery, GetAvailableCoursesForStudentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableCoursesForStudentQuery, GetAvailableCoursesForStudentQueryVariables>(GetAvailableCoursesForStudentDocument, options);
        }
// @ts-ignore
export function useGetAvailableCoursesForStudentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAvailableCoursesForStudentQuery, GetAvailableCoursesForStudentQueryVariables>): Apollo.UseSuspenseQueryResult<GetAvailableCoursesForStudentQuery, GetAvailableCoursesForStudentQueryVariables>;
export function useGetAvailableCoursesForStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableCoursesForStudentQuery, GetAvailableCoursesForStudentQueryVariables>): Apollo.UseSuspenseQueryResult<GetAvailableCoursesForStudentQuery | undefined, GetAvailableCoursesForStudentQueryVariables>;
export function useGetAvailableCoursesForStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableCoursesForStudentQuery, GetAvailableCoursesForStudentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableCoursesForStudentQuery, GetAvailableCoursesForStudentQueryVariables>(GetAvailableCoursesForStudentDocument, options);
        }
export type GetAvailableCoursesForStudentQueryHookResult = ReturnType<typeof useGetAvailableCoursesForStudentQuery>;
export type GetAvailableCoursesForStudentLazyQueryHookResult = ReturnType<typeof useGetAvailableCoursesForStudentLazyQuery>;
export type GetAvailableCoursesForStudentSuspenseQueryHookResult = ReturnType<typeof useGetAvailableCoursesForStudentSuspenseQuery>;
export type GetAvailableCoursesForStudentQueryResult = Apollo.QueryResult<GetAvailableCoursesForStudentQuery, GetAvailableCoursesForStudentQueryVariables>;
export const GetAxioResourceDocument = gql`
    query GetAxioResource($id: ID!) {
  getAxioResource(id: $id) {
    success
    message
    data {
      id
      moduleId
      order
      name
      description
      files {
        id
        fileName
        fileURL
        created
        status
      }
      videoUrl
      created
      lastModified
    }
  }
}
    `;

/**
 * __useGetAxioResourceQuery__
 *
 * To run a query within a React component, call `useGetAxioResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAxioResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAxioResourceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAxioResourceQuery(baseOptions: Apollo.QueryHookOptions<GetAxioResourceQuery, GetAxioResourceQueryVariables> & ({ variables: GetAxioResourceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAxioResourceQuery, GetAxioResourceQueryVariables>(GetAxioResourceDocument, options);
      }
export function useGetAxioResourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAxioResourceQuery, GetAxioResourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAxioResourceQuery, GetAxioResourceQueryVariables>(GetAxioResourceDocument, options);
        }
// @ts-ignore
export function useGetAxioResourceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAxioResourceQuery, GetAxioResourceQueryVariables>): Apollo.UseSuspenseQueryResult<GetAxioResourceQuery, GetAxioResourceQueryVariables>;
export function useGetAxioResourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAxioResourceQuery, GetAxioResourceQueryVariables>): Apollo.UseSuspenseQueryResult<GetAxioResourceQuery | undefined, GetAxioResourceQueryVariables>;
export function useGetAxioResourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAxioResourceQuery, GetAxioResourceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAxioResourceQuery, GetAxioResourceQueryVariables>(GetAxioResourceDocument, options);
        }
export type GetAxioResourceQueryHookResult = ReturnType<typeof useGetAxioResourceQuery>;
export type GetAxioResourceLazyQueryHookResult = ReturnType<typeof useGetAxioResourceLazyQuery>;
export type GetAxioResourceSuspenseQueryHookResult = ReturnType<typeof useGetAxioResourceSuspenseQuery>;
export type GetAxioResourceQueryResult = Apollo.QueryResult<GetAxioResourceQuery, GetAxioResourceQueryVariables>;
export const GetCompletionAnalyticsBySchoolDocument = gql`
    query GetCompletionAnalyticsBySchool($schoolId: ID!) {
  getCompletionAnalyticsBySchool(schoolId: $schoolId) {
    success
    message
    count
    data {
      label
      completionStats {
        completed
        inProgress
        notStarted
      }
      details {
        modules {
          label
          completionStats {
            completed
            inProgress
            notStarted
          }
          details {
            activities {
              label
              completionStats {
                completed
                inProgress
                notStarted
              }
              details {
                objectives {
                  label
                  completionStats {
                    completed
                    inProgress
                    notStarted
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCompletionAnalyticsBySchoolQuery__
 *
 * To run a query within a React component, call `useGetCompletionAnalyticsBySchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompletionAnalyticsBySchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompletionAnalyticsBySchoolQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetCompletionAnalyticsBySchoolQuery(baseOptions: Apollo.QueryHookOptions<GetCompletionAnalyticsBySchoolQuery, GetCompletionAnalyticsBySchoolQueryVariables> & ({ variables: GetCompletionAnalyticsBySchoolQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompletionAnalyticsBySchoolQuery, GetCompletionAnalyticsBySchoolQueryVariables>(GetCompletionAnalyticsBySchoolDocument, options);
      }
export function useGetCompletionAnalyticsBySchoolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompletionAnalyticsBySchoolQuery, GetCompletionAnalyticsBySchoolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompletionAnalyticsBySchoolQuery, GetCompletionAnalyticsBySchoolQueryVariables>(GetCompletionAnalyticsBySchoolDocument, options);
        }
// @ts-ignore
export function useGetCompletionAnalyticsBySchoolSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompletionAnalyticsBySchoolQuery, GetCompletionAnalyticsBySchoolQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompletionAnalyticsBySchoolQuery, GetCompletionAnalyticsBySchoolQueryVariables>;
export function useGetCompletionAnalyticsBySchoolSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompletionAnalyticsBySchoolQuery, GetCompletionAnalyticsBySchoolQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompletionAnalyticsBySchoolQuery | undefined, GetCompletionAnalyticsBySchoolQueryVariables>;
export function useGetCompletionAnalyticsBySchoolSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompletionAnalyticsBySchoolQuery, GetCompletionAnalyticsBySchoolQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompletionAnalyticsBySchoolQuery, GetCompletionAnalyticsBySchoolQueryVariables>(GetCompletionAnalyticsBySchoolDocument, options);
        }
export type GetCompletionAnalyticsBySchoolQueryHookResult = ReturnType<typeof useGetCompletionAnalyticsBySchoolQuery>;
export type GetCompletionAnalyticsBySchoolLazyQueryHookResult = ReturnType<typeof useGetCompletionAnalyticsBySchoolLazyQuery>;
export type GetCompletionAnalyticsBySchoolSuspenseQueryHookResult = ReturnType<typeof useGetCompletionAnalyticsBySchoolSuspenseQuery>;
export type GetCompletionAnalyticsBySchoolQueryResult = Apollo.QueryResult<GetCompletionAnalyticsBySchoolQuery, GetCompletionAnalyticsBySchoolQueryVariables>;
export const GetCoursesAnalyticsBySchoolDocument = gql`
    query GetCoursesAnalyticsBySchool($schoolId: ID!) {
  getCoursesAnalyticsBySchool(schoolId: $schoolId) {
    count
    data {
      label
      id
      success_points
      confusion_points
      questions_asked
      active_interaction_count
      distractions
      sentiment
      enrollment
      average_time_taken
      details {
        modules {
          label
          success_points
          confusion_points
          questions_asked
          active_interaction_count
          distractions
          sentiment
          enrollment
          average_time_taken
          details {
            activities {
              label
              success_points
              confusion_points
              questions_asked
              active_interaction_count
              distractions
              sentiment
              enrollment
              average_time_taken
              summaries
              success_points_details
              confusion_points_details
              further_recommendations
              distractions_details
              details {
                objectives {
                  label
                  success_points
                  confusion_points
                  average_time_taken
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCoursesAnalyticsBySchoolQuery__
 *
 * To run a query within a React component, call `useGetCoursesAnalyticsBySchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesAnalyticsBySchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesAnalyticsBySchoolQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetCoursesAnalyticsBySchoolQuery(baseOptions: Apollo.QueryHookOptions<GetCoursesAnalyticsBySchoolQuery, GetCoursesAnalyticsBySchoolQueryVariables> & ({ variables: GetCoursesAnalyticsBySchoolQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoursesAnalyticsBySchoolQuery, GetCoursesAnalyticsBySchoolQueryVariables>(GetCoursesAnalyticsBySchoolDocument, options);
      }
export function useGetCoursesAnalyticsBySchoolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoursesAnalyticsBySchoolQuery, GetCoursesAnalyticsBySchoolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoursesAnalyticsBySchoolQuery, GetCoursesAnalyticsBySchoolQueryVariables>(GetCoursesAnalyticsBySchoolDocument, options);
        }
// @ts-ignore
export function useGetCoursesAnalyticsBySchoolSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCoursesAnalyticsBySchoolQuery, GetCoursesAnalyticsBySchoolQueryVariables>): Apollo.UseSuspenseQueryResult<GetCoursesAnalyticsBySchoolQuery, GetCoursesAnalyticsBySchoolQueryVariables>;
export function useGetCoursesAnalyticsBySchoolSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoursesAnalyticsBySchoolQuery, GetCoursesAnalyticsBySchoolQueryVariables>): Apollo.UseSuspenseQueryResult<GetCoursesAnalyticsBySchoolQuery | undefined, GetCoursesAnalyticsBySchoolQueryVariables>;
export function useGetCoursesAnalyticsBySchoolSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoursesAnalyticsBySchoolQuery, GetCoursesAnalyticsBySchoolQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCoursesAnalyticsBySchoolQuery, GetCoursesAnalyticsBySchoolQueryVariables>(GetCoursesAnalyticsBySchoolDocument, options);
        }
export type GetCoursesAnalyticsBySchoolQueryHookResult = ReturnType<typeof useGetCoursesAnalyticsBySchoolQuery>;
export type GetCoursesAnalyticsBySchoolLazyQueryHookResult = ReturnType<typeof useGetCoursesAnalyticsBySchoolLazyQuery>;
export type GetCoursesAnalyticsBySchoolSuspenseQueryHookResult = ReturnType<typeof useGetCoursesAnalyticsBySchoolSuspenseQuery>;
export type GetCoursesAnalyticsBySchoolQueryResult = Apollo.QueryResult<GetCoursesAnalyticsBySchoolQuery, GetCoursesAnalyticsBySchoolQueryVariables>;
export const GetCoursesByDegreeByQueryDocument = gql`
    query GetCoursesByDegreeByQuery($degreeId: ID!, $searchQuery: String, $page: Int, $pageSize: Int, $sortBy: String) {
  getCoursesByDegreeByQuery(
    degreeId: $degreeId
    searchQuery: $searchQuery
    page: $page
    pageSize: $pageSize
    sortBy: $sortBy
  ) {
    success
    message
    data {
      courses {
        id
        name
        course_code
        learningStandards
        lengthInWeeks
        objectives
        thumbnail
        last_modified
        generationStatus
        teachingFaculty {
          id
          name
        }
        enrolledStudents {
          id
          name
        }
      }
      totalCount
    }
    count
  }
}
    `;

/**
 * __useGetCoursesByDegreeByQueryQuery__
 *
 * To run a query within a React component, call `useGetCoursesByDegreeByQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesByDegreeByQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesByDegreeByQueryQuery({
 *   variables: {
 *      degreeId: // value for 'degreeId'
 *      searchQuery: // value for 'searchQuery'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetCoursesByDegreeByQueryQuery(baseOptions: Apollo.QueryHookOptions<GetCoursesByDegreeByQueryQuery, GetCoursesByDegreeByQueryQueryVariables> & ({ variables: GetCoursesByDegreeByQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoursesByDegreeByQueryQuery, GetCoursesByDegreeByQueryQueryVariables>(GetCoursesByDegreeByQueryDocument, options);
      }
export function useGetCoursesByDegreeByQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoursesByDegreeByQueryQuery, GetCoursesByDegreeByQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoursesByDegreeByQueryQuery, GetCoursesByDegreeByQueryQueryVariables>(GetCoursesByDegreeByQueryDocument, options);
        }
// @ts-ignore
export function useGetCoursesByDegreeByQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCoursesByDegreeByQueryQuery, GetCoursesByDegreeByQueryQueryVariables>): Apollo.UseSuspenseQueryResult<GetCoursesByDegreeByQueryQuery, GetCoursesByDegreeByQueryQueryVariables>;
export function useGetCoursesByDegreeByQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoursesByDegreeByQueryQuery, GetCoursesByDegreeByQueryQueryVariables>): Apollo.UseSuspenseQueryResult<GetCoursesByDegreeByQueryQuery | undefined, GetCoursesByDegreeByQueryQueryVariables>;
export function useGetCoursesByDegreeByQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoursesByDegreeByQueryQuery, GetCoursesByDegreeByQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCoursesByDegreeByQueryQuery, GetCoursesByDegreeByQueryQueryVariables>(GetCoursesByDegreeByQueryDocument, options);
        }
export type GetCoursesByDegreeByQueryQueryHookResult = ReturnType<typeof useGetCoursesByDegreeByQueryQuery>;
export type GetCoursesByDegreeByQueryLazyQueryHookResult = ReturnType<typeof useGetCoursesByDegreeByQueryLazyQuery>;
export type GetCoursesByDegreeByQuerySuspenseQueryHookResult = ReturnType<typeof useGetCoursesByDegreeByQuerySuspenseQuery>;
export type GetCoursesByDegreeByQueryQueryResult = Apollo.QueryResult<GetCoursesByDegreeByQueryQuery, GetCoursesByDegreeByQueryQueryVariables>;
export const GetCoursesByFacultyDocument = gql`
    query GetCoursesByFaculty($schoolId: ID!, $userId: ID!, $searchQuery: String) {
  getCoursesByFaculty(
    schoolId: $schoolId
    userId: $userId
    searchQuery: $searchQuery
  ) {
    data {
      id
      name
      course_code
      isDraft
      learningStandards
      lengthInWeeks
      objectives
      last_modified
      thumbnail
      cost
      startDate
      description
      targetAudience
      generationStatus
      enrolledStudents {
        id
        name
      }
      teachingFaculty {
        id
        name
      }
      degreesHasCourse {
        id
        name
      }
      modules {
        id
        title
        aiTutors {
          id
          title
        }
        assignments {
          id
          name
        }
        axioResources {
          id
          name
        }
        reviews {
          id
        }
      }
    }
    count
  }
}
    `;

/**
 * __useGetCoursesByFacultyQuery__
 *
 * To run a query within a React component, call `useGetCoursesByFacultyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesByFacultyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesByFacultyQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      userId: // value for 'userId'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useGetCoursesByFacultyQuery(baseOptions: Apollo.QueryHookOptions<GetCoursesByFacultyQuery, GetCoursesByFacultyQueryVariables> & ({ variables: GetCoursesByFacultyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoursesByFacultyQuery, GetCoursesByFacultyQueryVariables>(GetCoursesByFacultyDocument, options);
      }
export function useGetCoursesByFacultyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoursesByFacultyQuery, GetCoursesByFacultyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoursesByFacultyQuery, GetCoursesByFacultyQueryVariables>(GetCoursesByFacultyDocument, options);
        }
// @ts-ignore
export function useGetCoursesByFacultySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCoursesByFacultyQuery, GetCoursesByFacultyQueryVariables>): Apollo.UseSuspenseQueryResult<GetCoursesByFacultyQuery, GetCoursesByFacultyQueryVariables>;
export function useGetCoursesByFacultySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoursesByFacultyQuery, GetCoursesByFacultyQueryVariables>): Apollo.UseSuspenseQueryResult<GetCoursesByFacultyQuery | undefined, GetCoursesByFacultyQueryVariables>;
export function useGetCoursesByFacultySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoursesByFacultyQuery, GetCoursesByFacultyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCoursesByFacultyQuery, GetCoursesByFacultyQueryVariables>(GetCoursesByFacultyDocument, options);
        }
export type GetCoursesByFacultyQueryHookResult = ReturnType<typeof useGetCoursesByFacultyQuery>;
export type GetCoursesByFacultyLazyQueryHookResult = ReturnType<typeof useGetCoursesByFacultyLazyQuery>;
export type GetCoursesByFacultySuspenseQueryHookResult = ReturnType<typeof useGetCoursesByFacultySuspenseQuery>;
export type GetCoursesByFacultyQueryResult = Apollo.QueryResult<GetCoursesByFacultyQuery, GetCoursesByFacultyQueryVariables>;
export const GetCoursesBySchoolByQueryDocument = gql`
    query GetCoursesBySchoolByQuery($schoolId: ID!, $searchQuery: String, $page: Int, $pageSize: Int, $sortBy: String) {
  getCoursesBySchoolByQuery(
    schoolId: $schoolId
    searchQuery: $searchQuery
    page: $page
    pageSize: $pageSize
    sortBy: $sortBy
  ) {
    success
    message
    data {
      courses {
        id
        name
        course_code
        description
        cost
        startDate
        targetAudience
        learningStandards
        lengthInWeeks
        objectives
        thumbnail
        last_modified
        generationStatus
        isDraft
        isEnrollmentAvailable
        teachingFaculty {
          id
          name
        }
        enrolledStudents {
          id
          name
        }
        degreesHasCourse {
          id
          name
        }
      }
      totalCount
    }
    count
  }
}
    `;

/**
 * __useGetCoursesBySchoolByQueryQuery__
 *
 * To run a query within a React component, call `useGetCoursesBySchoolByQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesBySchoolByQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesBySchoolByQueryQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      searchQuery: // value for 'searchQuery'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetCoursesBySchoolByQueryQuery(baseOptions: Apollo.QueryHookOptions<GetCoursesBySchoolByQueryQuery, GetCoursesBySchoolByQueryQueryVariables> & ({ variables: GetCoursesBySchoolByQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoursesBySchoolByQueryQuery, GetCoursesBySchoolByQueryQueryVariables>(GetCoursesBySchoolByQueryDocument, options);
      }
export function useGetCoursesBySchoolByQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoursesBySchoolByQueryQuery, GetCoursesBySchoolByQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoursesBySchoolByQueryQuery, GetCoursesBySchoolByQueryQueryVariables>(GetCoursesBySchoolByQueryDocument, options);
        }
// @ts-ignore
export function useGetCoursesBySchoolByQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCoursesBySchoolByQueryQuery, GetCoursesBySchoolByQueryQueryVariables>): Apollo.UseSuspenseQueryResult<GetCoursesBySchoolByQueryQuery, GetCoursesBySchoolByQueryQueryVariables>;
export function useGetCoursesBySchoolByQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoursesBySchoolByQueryQuery, GetCoursesBySchoolByQueryQueryVariables>): Apollo.UseSuspenseQueryResult<GetCoursesBySchoolByQueryQuery | undefined, GetCoursesBySchoolByQueryQueryVariables>;
export function useGetCoursesBySchoolByQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoursesBySchoolByQueryQuery, GetCoursesBySchoolByQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCoursesBySchoolByQueryQuery, GetCoursesBySchoolByQueryQueryVariables>(GetCoursesBySchoolByQueryDocument, options);
        }
export type GetCoursesBySchoolByQueryQueryHookResult = ReturnType<typeof useGetCoursesBySchoolByQueryQuery>;
export type GetCoursesBySchoolByQueryLazyQueryHookResult = ReturnType<typeof useGetCoursesBySchoolByQueryLazyQuery>;
export type GetCoursesBySchoolByQuerySuspenseQueryHookResult = ReturnType<typeof useGetCoursesBySchoolByQuerySuspenseQuery>;
export type GetCoursesBySchoolByQueryQueryResult = Apollo.QueryResult<GetCoursesBySchoolByQueryQuery, GetCoursesBySchoolByQueryQueryVariables>;
export const GetEnrolledStudentCoursesByAdminDocument = gql`
    query GetEnrolledStudentCoursesByAdmin($schoolId: ID!, $studentId: ID!, $query: String, $page: Int, $pageSize: Int, $sortBy: String) {
  getEnrolledStudentCoursesByAdmin(
    schoolId: $schoolId
    studentId: $studentId
    query: $query
    page: $page
    pageSize: $pageSize
    sortBy: $sortBy
  ) {
    success
    message
    data {
      courses {
        course {
          id
          name
          course_code
          isDraft
          learningStandards
          lengthInWeeks
          objectives
          last_modified
          thumbnail
          cost
          startDate
          description
          targetAudience
          generationStatus
          preRequisites {
            id
            name
            cost
            description
            enrolledStudents {
              id
              name
            }
          }
          preRequisiteFor {
            id
            name
            cost
            description
            enrolledStudents {
              id
              name
            }
          }
          modules {
            id
            title
            assignments {
              id
              name
            }
            aiTutors {
              id
              title
            }
            axioResources {
              id
              name
            }
          }
          enrolledStudents {
            id
            name
          }
          degreesHasCourse {
            id
            name
            usersEnrolledIn {
              id
              name
            }
          }
        }
        progress
        preRequisitesCompleted
      }
      totalCount
    }
    count
  }
}
    `;

/**
 * __useGetEnrolledStudentCoursesByAdminQuery__
 *
 * To run a query within a React component, call `useGetEnrolledStudentCoursesByAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnrolledStudentCoursesByAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnrolledStudentCoursesByAdminQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      studentId: // value for 'studentId'
 *      query: // value for 'query'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetEnrolledStudentCoursesByAdminQuery(baseOptions: Apollo.QueryHookOptions<GetEnrolledStudentCoursesByAdminQuery, GetEnrolledStudentCoursesByAdminQueryVariables> & ({ variables: GetEnrolledStudentCoursesByAdminQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnrolledStudentCoursesByAdminQuery, GetEnrolledStudentCoursesByAdminQueryVariables>(GetEnrolledStudentCoursesByAdminDocument, options);
      }
export function useGetEnrolledStudentCoursesByAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnrolledStudentCoursesByAdminQuery, GetEnrolledStudentCoursesByAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnrolledStudentCoursesByAdminQuery, GetEnrolledStudentCoursesByAdminQueryVariables>(GetEnrolledStudentCoursesByAdminDocument, options);
        }
// @ts-ignore
export function useGetEnrolledStudentCoursesByAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEnrolledStudentCoursesByAdminQuery, GetEnrolledStudentCoursesByAdminQueryVariables>): Apollo.UseSuspenseQueryResult<GetEnrolledStudentCoursesByAdminQuery, GetEnrolledStudentCoursesByAdminQueryVariables>;
export function useGetEnrolledStudentCoursesByAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEnrolledStudentCoursesByAdminQuery, GetEnrolledStudentCoursesByAdminQueryVariables>): Apollo.UseSuspenseQueryResult<GetEnrolledStudentCoursesByAdminQuery | undefined, GetEnrolledStudentCoursesByAdminQueryVariables>;
export function useGetEnrolledStudentCoursesByAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEnrolledStudentCoursesByAdminQuery, GetEnrolledStudentCoursesByAdminQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEnrolledStudentCoursesByAdminQuery, GetEnrolledStudentCoursesByAdminQueryVariables>(GetEnrolledStudentCoursesByAdminDocument, options);
        }
export type GetEnrolledStudentCoursesByAdminQueryHookResult = ReturnType<typeof useGetEnrolledStudentCoursesByAdminQuery>;
export type GetEnrolledStudentCoursesByAdminLazyQueryHookResult = ReturnType<typeof useGetEnrolledStudentCoursesByAdminLazyQuery>;
export type GetEnrolledStudentCoursesByAdminSuspenseQueryHookResult = ReturnType<typeof useGetEnrolledStudentCoursesByAdminSuspenseQuery>;
export type GetEnrolledStudentCoursesByAdminQueryResult = Apollo.QueryResult<GetEnrolledStudentCoursesByAdminQuery, GetEnrolledStudentCoursesByAdminQueryVariables>;
export const GetFacultyByCourseIdDocument = gql`
    query GetFacultyByCourseId($courseId: ID!, $searchQuery: String) {
  getFacultyByCourseId(courseId: $courseId, searchQuery: $searchQuery) {
    data {
      faculties {
        id
        name
        profilePicture
        email
        meetingLink
        biography
      }
      totalCount
    }
  }
}
    `;

/**
 * __useGetFacultyByCourseIdQuery__
 *
 * To run a query within a React component, call `useGetFacultyByCourseIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFacultyByCourseIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFacultyByCourseIdQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useGetFacultyByCourseIdQuery(baseOptions: Apollo.QueryHookOptions<GetFacultyByCourseIdQuery, GetFacultyByCourseIdQueryVariables> & ({ variables: GetFacultyByCourseIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFacultyByCourseIdQuery, GetFacultyByCourseIdQueryVariables>(GetFacultyByCourseIdDocument, options);
      }
export function useGetFacultyByCourseIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFacultyByCourseIdQuery, GetFacultyByCourseIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFacultyByCourseIdQuery, GetFacultyByCourseIdQueryVariables>(GetFacultyByCourseIdDocument, options);
        }
// @ts-ignore
export function useGetFacultyByCourseIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFacultyByCourseIdQuery, GetFacultyByCourseIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetFacultyByCourseIdQuery, GetFacultyByCourseIdQueryVariables>;
export function useGetFacultyByCourseIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFacultyByCourseIdQuery, GetFacultyByCourseIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetFacultyByCourseIdQuery | undefined, GetFacultyByCourseIdQueryVariables>;
export function useGetFacultyByCourseIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFacultyByCourseIdQuery, GetFacultyByCourseIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFacultyByCourseIdQuery, GetFacultyByCourseIdQueryVariables>(GetFacultyByCourseIdDocument, options);
        }
export type GetFacultyByCourseIdQueryHookResult = ReturnType<typeof useGetFacultyByCourseIdQuery>;
export type GetFacultyByCourseIdLazyQueryHookResult = ReturnType<typeof useGetFacultyByCourseIdLazyQuery>;
export type GetFacultyByCourseIdSuspenseQueryHookResult = ReturnType<typeof useGetFacultyByCourseIdSuspenseQuery>;
export type GetFacultyByCourseIdQueryResult = Apollo.QueryResult<GetFacultyByCourseIdQuery, GetFacultyByCourseIdQueryVariables>;
export const GetForumByCourseDocument = gql`
    query GetForumByCourse($courseId: ID!) {
  getForumByCourse(courseId: $courseId) {
    success
    message
    data {
      id
      created
      lastModified
      course {
        id
        name
      }
    }
    count
  }
}
    `;

/**
 * __useGetForumByCourseQuery__
 *
 * To run a query within a React component, call `useGetForumByCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetForumByCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetForumByCourseQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetForumByCourseQuery(baseOptions: Apollo.QueryHookOptions<GetForumByCourseQuery, GetForumByCourseQueryVariables> & ({ variables: GetForumByCourseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetForumByCourseQuery, GetForumByCourseQueryVariables>(GetForumByCourseDocument, options);
      }
export function useGetForumByCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetForumByCourseQuery, GetForumByCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetForumByCourseQuery, GetForumByCourseQueryVariables>(GetForumByCourseDocument, options);
        }
// @ts-ignore
export function useGetForumByCourseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetForumByCourseQuery, GetForumByCourseQueryVariables>): Apollo.UseSuspenseQueryResult<GetForumByCourseQuery, GetForumByCourseQueryVariables>;
export function useGetForumByCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetForumByCourseQuery, GetForumByCourseQueryVariables>): Apollo.UseSuspenseQueryResult<GetForumByCourseQuery | undefined, GetForumByCourseQueryVariables>;
export function useGetForumByCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetForumByCourseQuery, GetForumByCourseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetForumByCourseQuery, GetForumByCourseQueryVariables>(GetForumByCourseDocument, options);
        }
export type GetForumByCourseQueryHookResult = ReturnType<typeof useGetForumByCourseQuery>;
export type GetForumByCourseLazyQueryHookResult = ReturnType<typeof useGetForumByCourseLazyQuery>;
export type GetForumByCourseSuspenseQueryHookResult = ReturnType<typeof useGetForumByCourseSuspenseQuery>;
export type GetForumByCourseQueryResult = Apollo.QueryResult<GetForumByCourseQuery, GetForumByCourseQueryVariables>;
export const GetLastSeenPostDocument = gql`
    query GetLastSeenPost($threadId: ID!) {
  getLastSeenPost(threadId: $threadId) {
    success
    message
    data {
      threadId
      lastSeenPostId
      lastSeenAt
    }
  }
}
    `;

/**
 * __useGetLastSeenPostQuery__
 *
 * To run a query within a React component, call `useGetLastSeenPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastSeenPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastSeenPostQuery({
 *   variables: {
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useGetLastSeenPostQuery(baseOptions: Apollo.QueryHookOptions<GetLastSeenPostQuery, GetLastSeenPostQueryVariables> & ({ variables: GetLastSeenPostQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLastSeenPostQuery, GetLastSeenPostQueryVariables>(GetLastSeenPostDocument, options);
      }
export function useGetLastSeenPostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLastSeenPostQuery, GetLastSeenPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLastSeenPostQuery, GetLastSeenPostQueryVariables>(GetLastSeenPostDocument, options);
        }
// @ts-ignore
export function useGetLastSeenPostSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLastSeenPostQuery, GetLastSeenPostQueryVariables>): Apollo.UseSuspenseQueryResult<GetLastSeenPostQuery, GetLastSeenPostQueryVariables>;
export function useGetLastSeenPostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLastSeenPostQuery, GetLastSeenPostQueryVariables>): Apollo.UseSuspenseQueryResult<GetLastSeenPostQuery | undefined, GetLastSeenPostQueryVariables>;
export function useGetLastSeenPostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLastSeenPostQuery, GetLastSeenPostQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLastSeenPostQuery, GetLastSeenPostQueryVariables>(GetLastSeenPostDocument, options);
        }
export type GetLastSeenPostQueryHookResult = ReturnType<typeof useGetLastSeenPostQuery>;
export type GetLastSeenPostLazyQueryHookResult = ReturnType<typeof useGetLastSeenPostLazyQuery>;
export type GetLastSeenPostSuspenseQueryHookResult = ReturnType<typeof useGetLastSeenPostSuspenseQuery>;
export type GetLastSeenPostQueryResult = Apollo.QueryResult<GetLastSeenPostQuery, GetLastSeenPostQueryVariables>;
export const GetLessonPlanStatusDocument = gql`
    query GetLessonPlanStatus($moduleId: ID!) {
  getLessonPlanStatus(moduleId: $moduleId) {
    success
    message
    data {
      moduleId
      moduleTitle
      isGenerating
      hasLessonPlan
      lessonPlanFile {
        id
        fileName
        fileURL
      }
    }
  }
}
    `;

/**
 * __useGetLessonPlanStatusQuery__
 *
 * To run a query within a React component, call `useGetLessonPlanStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLessonPlanStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLessonPlanStatusQuery({
 *   variables: {
 *      moduleId: // value for 'moduleId'
 *   },
 * });
 */
export function useGetLessonPlanStatusQuery(baseOptions: Apollo.QueryHookOptions<GetLessonPlanStatusQuery, GetLessonPlanStatusQueryVariables> & ({ variables: GetLessonPlanStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLessonPlanStatusQuery, GetLessonPlanStatusQueryVariables>(GetLessonPlanStatusDocument, options);
      }
export function useGetLessonPlanStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLessonPlanStatusQuery, GetLessonPlanStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLessonPlanStatusQuery, GetLessonPlanStatusQueryVariables>(GetLessonPlanStatusDocument, options);
        }
// @ts-ignore
export function useGetLessonPlanStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLessonPlanStatusQuery, GetLessonPlanStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetLessonPlanStatusQuery, GetLessonPlanStatusQueryVariables>;
export function useGetLessonPlanStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLessonPlanStatusQuery, GetLessonPlanStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetLessonPlanStatusQuery | undefined, GetLessonPlanStatusQueryVariables>;
export function useGetLessonPlanStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLessonPlanStatusQuery, GetLessonPlanStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLessonPlanStatusQuery, GetLessonPlanStatusQueryVariables>(GetLessonPlanStatusDocument, options);
        }
export type GetLessonPlanStatusQueryHookResult = ReturnType<typeof useGetLessonPlanStatusQuery>;
export type GetLessonPlanStatusLazyQueryHookResult = ReturnType<typeof useGetLessonPlanStatusLazyQuery>;
export type GetLessonPlanStatusSuspenseQueryHookResult = ReturnType<typeof useGetLessonPlanStatusSuspenseQuery>;
export type GetLessonPlanStatusQueryResult = Apollo.QueryResult<GetLessonPlanStatusQuery, GetLessonPlanStatusQueryVariables>;
export const GetNotesForStudentDocument = gql`
    query GetNotesForStudent($studentId: ID!) {
  getNotesForStudent(studentId: $studentId) {
    success
    message
    data {
      id
      content
      created
      lastModified
      author {
        id
        name
        profilePicture
      }
      subject {
        id
        name
      }
    }
    count
  }
}
    `;

/**
 * __useGetNotesForStudentQuery__
 *
 * To run a query within a React component, call `useGetNotesForStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotesForStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotesForStudentQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useGetNotesForStudentQuery(baseOptions: Apollo.QueryHookOptions<GetNotesForStudentQuery, GetNotesForStudentQueryVariables> & ({ variables: GetNotesForStudentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotesForStudentQuery, GetNotesForStudentQueryVariables>(GetNotesForStudentDocument, options);
      }
export function useGetNotesForStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotesForStudentQuery, GetNotesForStudentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotesForStudentQuery, GetNotesForStudentQueryVariables>(GetNotesForStudentDocument, options);
        }
// @ts-ignore
export function useGetNotesForStudentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNotesForStudentQuery, GetNotesForStudentQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotesForStudentQuery, GetNotesForStudentQueryVariables>;
export function useGetNotesForStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotesForStudentQuery, GetNotesForStudentQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotesForStudentQuery | undefined, GetNotesForStudentQueryVariables>;
export function useGetNotesForStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotesForStudentQuery, GetNotesForStudentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotesForStudentQuery, GetNotesForStudentQueryVariables>(GetNotesForStudentDocument, options);
        }
export type GetNotesForStudentQueryHookResult = ReturnType<typeof useGetNotesForStudentQuery>;
export type GetNotesForStudentLazyQueryHookResult = ReturnType<typeof useGetNotesForStudentLazyQuery>;
export type GetNotesForStudentSuspenseQueryHookResult = ReturnType<typeof useGetNotesForStudentSuspenseQuery>;
export type GetNotesForStudentQueryResult = Apollo.QueryResult<GetNotesForStudentQuery, GetNotesForStudentQueryVariables>;
export const GetPostByIdDocument = gql`
    query GetPostById($postId: ID!) {
  getPostById(postId: $postId) {
    success
    message
    data {
      id
      message
      depth
      threadId
      created
      lastModified
      thread {
        id
        title
        forum {
          course {
            id
            name
          }
        }
      }
      author {
        id
        name
      }
      files {
        id
        fileName
        fileURL
      }
      replies {
        id
        message
        depth
        created
        lastModified
        author {
          id
          name
        }
        files {
          id
          fileName
          fileURL
        }
      }
      replyTo {
        id
        message
        author {
          id
          name
        }
      }
    }
    count
  }
}
    `;

/**
 * __useGetPostByIdQuery__
 *
 * To run a query within a React component, call `useGetPostByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostByIdQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetPostByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPostByIdQuery, GetPostByIdQueryVariables> & ({ variables: GetPostByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostByIdQuery, GetPostByIdQueryVariables>(GetPostByIdDocument, options);
      }
export function useGetPostByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostByIdQuery, GetPostByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostByIdQuery, GetPostByIdQueryVariables>(GetPostByIdDocument, options);
        }
// @ts-ignore
export function useGetPostByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPostByIdQuery, GetPostByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetPostByIdQuery, GetPostByIdQueryVariables>;
export function useGetPostByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPostByIdQuery, GetPostByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetPostByIdQuery | undefined, GetPostByIdQueryVariables>;
export function useGetPostByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPostByIdQuery, GetPostByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPostByIdQuery, GetPostByIdQueryVariables>(GetPostByIdDocument, options);
        }
export type GetPostByIdQueryHookResult = ReturnType<typeof useGetPostByIdQuery>;
export type GetPostByIdLazyQueryHookResult = ReturnType<typeof useGetPostByIdLazyQuery>;
export type GetPostByIdSuspenseQueryHookResult = ReturnType<typeof useGetPostByIdSuspenseQuery>;
export type GetPostByIdQueryResult = Apollo.QueryResult<GetPostByIdQuery, GetPostByIdQueryVariables>;
export const GetPostsByThreadDocument = gql`
    query GetPostsByThread($threadId: ID!, $page: Int, $pageSize: Int) {
  getPostsByThread(threadId: $threadId, page: $page, pageSize: $pageSize) {
    success
    message
    data {
      id
      message
      depth
      threadId
      created
      lastModified
      author {
        id
        name
      }
      files {
        id
        fileName
        fileURL
      }
      replies {
        id
        message
        depth
        created
        author {
          id
          name
        }
      }
      replyTo {
        id
        message
        author {
          id
          name
        }
      }
    }
    count
  }
}
    `;

/**
 * __useGetPostsByThreadQuery__
 *
 * To run a query within a React component, call `useGetPostsByThreadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsByThreadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsByThreadQuery({
 *   variables: {
 *      threadId: // value for 'threadId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetPostsByThreadQuery(baseOptions: Apollo.QueryHookOptions<GetPostsByThreadQuery, GetPostsByThreadQueryVariables> & ({ variables: GetPostsByThreadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostsByThreadQuery, GetPostsByThreadQueryVariables>(GetPostsByThreadDocument, options);
      }
export function useGetPostsByThreadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostsByThreadQuery, GetPostsByThreadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostsByThreadQuery, GetPostsByThreadQueryVariables>(GetPostsByThreadDocument, options);
        }
// @ts-ignore
export function useGetPostsByThreadSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPostsByThreadQuery, GetPostsByThreadQueryVariables>): Apollo.UseSuspenseQueryResult<GetPostsByThreadQuery, GetPostsByThreadQueryVariables>;
export function useGetPostsByThreadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPostsByThreadQuery, GetPostsByThreadQueryVariables>): Apollo.UseSuspenseQueryResult<GetPostsByThreadQuery | undefined, GetPostsByThreadQueryVariables>;
export function useGetPostsByThreadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPostsByThreadQuery, GetPostsByThreadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPostsByThreadQuery, GetPostsByThreadQueryVariables>(GetPostsByThreadDocument, options);
        }
export type GetPostsByThreadQueryHookResult = ReturnType<typeof useGetPostsByThreadQuery>;
export type GetPostsByThreadLazyQueryHookResult = ReturnType<typeof useGetPostsByThreadLazyQuery>;
export type GetPostsByThreadSuspenseQueryHookResult = ReturnType<typeof useGetPostsByThreadSuspenseQuery>;
export type GetPostsByThreadQueryResult = Apollo.QueryResult<GetPostsByThreadQuery, GetPostsByThreadQueryVariables>;
export const GetReviewDocument = gql`
    query GetReview($id: ID!) {
  getReview(id: $id) {
    success
    message
    data {
      id
      created
      lastModified
      hasReviewFor {
        id
        moduleHasAssessment {
          id
          title
        }
      }
      hasAITutors {
        id
        title
        objectives {
          id
          objective
          sequence
        }
      }
    }
    count
  }
}
    `;

/**
 * __useGetReviewQuery__
 *
 * To run a query within a React component, call `useGetReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReviewQuery(baseOptions: Apollo.QueryHookOptions<GetReviewQuery, GetReviewQueryVariables> & ({ variables: GetReviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReviewQuery, GetReviewQueryVariables>(GetReviewDocument, options);
      }
export function useGetReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReviewQuery, GetReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReviewQuery, GetReviewQueryVariables>(GetReviewDocument, options);
        }
// @ts-ignore
export function useGetReviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReviewQuery, GetReviewQueryVariables>): Apollo.UseSuspenseQueryResult<GetReviewQuery, GetReviewQueryVariables>;
export function useGetReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReviewQuery, GetReviewQueryVariables>): Apollo.UseSuspenseQueryResult<GetReviewQuery | undefined, GetReviewQueryVariables>;
export function useGetReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReviewQuery, GetReviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReviewQuery, GetReviewQueryVariables>(GetReviewDocument, options);
        }
export type GetReviewQueryHookResult = ReturnType<typeof useGetReviewQuery>;
export type GetReviewLazyQueryHookResult = ReturnType<typeof useGetReviewLazyQuery>;
export type GetReviewSuspenseQueryHookResult = ReturnType<typeof useGetReviewSuspenseQuery>;
export type GetReviewQueryResult = Apollo.QueryResult<GetReviewQuery, GetReviewQueryVariables>;
export const GetStudentAnalyticsBySchoolDocument = gql`
    query GetStudentAnalyticsBySchool($schoolId: ID!) {
  getStudentAnalyticsBySchool(schoolId: $schoolId) {
    success
    message
    count
    data {
      id
      label
      success_points
      confusion_points
      questions_asked
      active_interaction_count
      distractions
      sentiment
      details {
        courses {
          label
          success_points
          confusion_points
          questions_asked
          active_interaction_count
          distractions
          sentiment
          details {
            modules {
              label
              success_points
              confusion_points
              questions_asked
              active_interaction_count
              distractions
              sentiment
              details {
                aiTutors {
                  label
                  success_points
                  confusion_points
                  questions_asked
                  active_interaction_count
                  distractions
                  sentiment
                  details {
                    objectives {
                      label
                      success_points
                      confusion_points
                      questions_asked
                      active_interaction_count
                      distractions
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetStudentAnalyticsBySchoolQuery__
 *
 * To run a query within a React component, call `useGetStudentAnalyticsBySchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentAnalyticsBySchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentAnalyticsBySchoolQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetStudentAnalyticsBySchoolQuery(baseOptions: Apollo.QueryHookOptions<GetStudentAnalyticsBySchoolQuery, GetStudentAnalyticsBySchoolQueryVariables> & ({ variables: GetStudentAnalyticsBySchoolQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentAnalyticsBySchoolQuery, GetStudentAnalyticsBySchoolQueryVariables>(GetStudentAnalyticsBySchoolDocument, options);
      }
export function useGetStudentAnalyticsBySchoolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentAnalyticsBySchoolQuery, GetStudentAnalyticsBySchoolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentAnalyticsBySchoolQuery, GetStudentAnalyticsBySchoolQueryVariables>(GetStudentAnalyticsBySchoolDocument, options);
        }
// @ts-ignore
export function useGetStudentAnalyticsBySchoolSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentAnalyticsBySchoolQuery, GetStudentAnalyticsBySchoolQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentAnalyticsBySchoolQuery, GetStudentAnalyticsBySchoolQueryVariables>;
export function useGetStudentAnalyticsBySchoolSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentAnalyticsBySchoolQuery, GetStudentAnalyticsBySchoolQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentAnalyticsBySchoolQuery | undefined, GetStudentAnalyticsBySchoolQueryVariables>;
export function useGetStudentAnalyticsBySchoolSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentAnalyticsBySchoolQuery, GetStudentAnalyticsBySchoolQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentAnalyticsBySchoolQuery, GetStudentAnalyticsBySchoolQueryVariables>(GetStudentAnalyticsBySchoolDocument, options);
        }
export type GetStudentAnalyticsBySchoolQueryHookResult = ReturnType<typeof useGetStudentAnalyticsBySchoolQuery>;
export type GetStudentAnalyticsBySchoolLazyQueryHookResult = ReturnType<typeof useGetStudentAnalyticsBySchoolLazyQuery>;
export type GetStudentAnalyticsBySchoolSuspenseQueryHookResult = ReturnType<typeof useGetStudentAnalyticsBySchoolSuspenseQuery>;
export type GetStudentAnalyticsBySchoolQueryResult = Apollo.QueryResult<GetStudentAnalyticsBySchoolQuery, GetStudentAnalyticsBySchoolQueryVariables>;
export const GetStudentAnalyticsForStudentDocument = gql`
    query GetStudentAnalyticsForStudent($schoolId: ID!, $studentId: ID!) {
  getStudentAnalyticsForStudent(schoolId: $schoolId, studentId: $studentId) {
    success
    message
    data {
      id
      label
      success_points
      confusion_points
      questions_asked
      active_interaction_count
      distractions
      sentiment
      completion_percentage
      total_time_taken
      details {
        courses {
          id
          label
          success_points
          confusion_points
          questions_asked
          active_interaction_count
          distractions
          sentiment
          completion_percentage
          total_time_taken
          details {
            modules {
              id
              label
              success_points
              confusion_points
              questions_asked
              active_interaction_count
              distractions
              sentiment
              completion_percentage
              total_time_taken
              details {
                aiTutors {
                  id
                  label
                  success_points
                  confusion_points
                  questions_asked
                  active_interaction_count
                  distractions
                  sentiment
                  completion_percentage
                  total_time_taken
                  details {
                    objectives {
                      id
                      label
                      success_points
                      confusion_points
                      questions_asked
                      active_interaction_count
                      distractions
                      status
                      progress_details {
                        level
                        confusion_points
                        success_points
                        average_student_question_complexity
                        further_recommendations
                        questions_asked
                        distractions
                        sentiment_analysis
                        originality_analysis
                        summary
                        num_messages
                        student_messages_count
                        ai_messages_count
                        average_student_response_time
                        average_ai_response_time
                        total_time_taken
                      }
                    }
                  }
                  chatAnalytics {
                    id
                    level
                    confusion_points
                    success_points
                    average_student_question_complexity
                    further_recommendations
                    questions_asked
                    distractions
                    sentiment_analysis
                    originality_analysis
                    summary
                    num_messages
                    student_messages_count
                    ai_messages_count
                    average_student_response_time
                    average_ai_response_time
                    total_time_taken
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetStudentAnalyticsForStudentQuery__
 *
 * To run a query within a React component, call `useGetStudentAnalyticsForStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentAnalyticsForStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentAnalyticsForStudentQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useGetStudentAnalyticsForStudentQuery(baseOptions: Apollo.QueryHookOptions<GetStudentAnalyticsForStudentQuery, GetStudentAnalyticsForStudentQueryVariables> & ({ variables: GetStudentAnalyticsForStudentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentAnalyticsForStudentQuery, GetStudentAnalyticsForStudentQueryVariables>(GetStudentAnalyticsForStudentDocument, options);
      }
export function useGetStudentAnalyticsForStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentAnalyticsForStudentQuery, GetStudentAnalyticsForStudentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentAnalyticsForStudentQuery, GetStudentAnalyticsForStudentQueryVariables>(GetStudentAnalyticsForStudentDocument, options);
        }
// @ts-ignore
export function useGetStudentAnalyticsForStudentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentAnalyticsForStudentQuery, GetStudentAnalyticsForStudentQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentAnalyticsForStudentQuery, GetStudentAnalyticsForStudentQueryVariables>;
export function useGetStudentAnalyticsForStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentAnalyticsForStudentQuery, GetStudentAnalyticsForStudentQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentAnalyticsForStudentQuery | undefined, GetStudentAnalyticsForStudentQueryVariables>;
export function useGetStudentAnalyticsForStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentAnalyticsForStudentQuery, GetStudentAnalyticsForStudentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentAnalyticsForStudentQuery, GetStudentAnalyticsForStudentQueryVariables>(GetStudentAnalyticsForStudentDocument, options);
        }
export type GetStudentAnalyticsForStudentQueryHookResult = ReturnType<typeof useGetStudentAnalyticsForStudentQuery>;
export type GetStudentAnalyticsForStudentLazyQueryHookResult = ReturnType<typeof useGetStudentAnalyticsForStudentLazyQuery>;
export type GetStudentAnalyticsForStudentSuspenseQueryHookResult = ReturnType<typeof useGetStudentAnalyticsForStudentSuspenseQuery>;
export type GetStudentAnalyticsForStudentQueryResult = Apollo.QueryResult<GetStudentAnalyticsForStudentQuery, GetStudentAnalyticsForStudentQueryVariables>;
export const GetStudentsByCourseIdDocument = gql`
    query GetStudentsByCourseId($courseId: ID!, $searchQuery: String, $page: Int, $pageSize: Int, $sortBy: String) {
  getStudentsByCourseId(
    courseId: $courseId
    searchQuery: $searchQuery
    page: $page
    pageSize: $pageSize
    sortBy: $sortBy
  ) {
    success
    data {
      id
      name
      email
      pendingCourseEnrollmentInvite
      expiredInvitation
      enrollmentDate
      roles
      analytics {
        success_points
        confusion_points
        questions_asked
        active_interaction_count
        distractions
        sentiment
        completion_percentage
        total_time_taken
      }
    }
    count
  }
}
    `;

/**
 * __useGetStudentsByCourseIdQuery__
 *
 * To run a query within a React component, call `useGetStudentsByCourseIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentsByCourseIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentsByCourseIdQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      searchQuery: // value for 'searchQuery'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetStudentsByCourseIdQuery(baseOptions: Apollo.QueryHookOptions<GetStudentsByCourseIdQuery, GetStudentsByCourseIdQueryVariables> & ({ variables: GetStudentsByCourseIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentsByCourseIdQuery, GetStudentsByCourseIdQueryVariables>(GetStudentsByCourseIdDocument, options);
      }
export function useGetStudentsByCourseIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentsByCourseIdQuery, GetStudentsByCourseIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentsByCourseIdQuery, GetStudentsByCourseIdQueryVariables>(GetStudentsByCourseIdDocument, options);
        }
// @ts-ignore
export function useGetStudentsByCourseIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentsByCourseIdQuery, GetStudentsByCourseIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentsByCourseIdQuery, GetStudentsByCourseIdQueryVariables>;
export function useGetStudentsByCourseIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentsByCourseIdQuery, GetStudentsByCourseIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentsByCourseIdQuery | undefined, GetStudentsByCourseIdQueryVariables>;
export function useGetStudentsByCourseIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentsByCourseIdQuery, GetStudentsByCourseIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentsByCourseIdQuery, GetStudentsByCourseIdQueryVariables>(GetStudentsByCourseIdDocument, options);
        }
export type GetStudentsByCourseIdQueryHookResult = ReturnType<typeof useGetStudentsByCourseIdQuery>;
export type GetStudentsByCourseIdLazyQueryHookResult = ReturnType<typeof useGetStudentsByCourseIdLazyQuery>;
export type GetStudentsByCourseIdSuspenseQueryHookResult = ReturnType<typeof useGetStudentsByCourseIdSuspenseQuery>;
export type GetStudentsByCourseIdQueryResult = Apollo.QueryResult<GetStudentsByCourseIdQuery, GetStudentsByCourseIdQueryVariables>;
export const GetThreadsByCourseDocument = gql`
    query GetThreadsByCourse($courseId: ID!, $page: Int, $pageSize: Int) {
  getThreadsByCourse(courseId: $courseId, page: $page, pageSize: $pageSize) {
    success
    message
    data {
      id
      title
      created
      lastModified
      forum {
        id
        course {
          id
          name
        }
      }
      posts {
        id
        message
        depth
        created
        author {
          id
          name
        }
      }
      subscribers {
        id
      }
    }
    count
  }
}
    `;

/**
 * __useGetThreadsByCourseQuery__
 *
 * To run a query within a React component, call `useGetThreadsByCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThreadsByCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThreadsByCourseQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetThreadsByCourseQuery(baseOptions: Apollo.QueryHookOptions<GetThreadsByCourseQuery, GetThreadsByCourseQueryVariables> & ({ variables: GetThreadsByCourseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetThreadsByCourseQuery, GetThreadsByCourseQueryVariables>(GetThreadsByCourseDocument, options);
      }
export function useGetThreadsByCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetThreadsByCourseQuery, GetThreadsByCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetThreadsByCourseQuery, GetThreadsByCourseQueryVariables>(GetThreadsByCourseDocument, options);
        }
// @ts-ignore
export function useGetThreadsByCourseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetThreadsByCourseQuery, GetThreadsByCourseQueryVariables>): Apollo.UseSuspenseQueryResult<GetThreadsByCourseQuery, GetThreadsByCourseQueryVariables>;
export function useGetThreadsByCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetThreadsByCourseQuery, GetThreadsByCourseQueryVariables>): Apollo.UseSuspenseQueryResult<GetThreadsByCourseQuery | undefined, GetThreadsByCourseQueryVariables>;
export function useGetThreadsByCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetThreadsByCourseQuery, GetThreadsByCourseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetThreadsByCourseQuery, GetThreadsByCourseQueryVariables>(GetThreadsByCourseDocument, options);
        }
export type GetThreadsByCourseQueryHookResult = ReturnType<typeof useGetThreadsByCourseQuery>;
export type GetThreadsByCourseLazyQueryHookResult = ReturnType<typeof useGetThreadsByCourseLazyQuery>;
export type GetThreadsByCourseSuspenseQueryHookResult = ReturnType<typeof useGetThreadsByCourseSuspenseQuery>;
export type GetThreadsByCourseQueryResult = Apollo.QueryResult<GetThreadsByCourseQuery, GetThreadsByCourseQueryVariables>;
export const GetUnifiedSubmissionsByFacultyDocument = gql`
    query GetUnifiedSubmissionsByFaculty($input: GetUnifiedSubmissionsByFacultyInput!) {
  getUnifiedSubmissionsByFaculty(input: $input) {
    success
    data {
      submissions {
        id
        created
        submissionType
        moduleName
        submissionTitle
        courseName
        student {
          id
          name
          email
          initials
        }
        submittedOn
        submittedTime
        status
        grade
        maximumPoints
        courseCode
        courseId
        dueDate
        retakeDeadline
      }
      totalCount
    }
    count
  }
}
    `;

/**
 * __useGetUnifiedSubmissionsByFacultyQuery__
 *
 * To run a query within a React component, call `useGetUnifiedSubmissionsByFacultyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnifiedSubmissionsByFacultyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnifiedSubmissionsByFacultyQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUnifiedSubmissionsByFacultyQuery(baseOptions: Apollo.QueryHookOptions<GetUnifiedSubmissionsByFacultyQuery, GetUnifiedSubmissionsByFacultyQueryVariables> & ({ variables: GetUnifiedSubmissionsByFacultyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnifiedSubmissionsByFacultyQuery, GetUnifiedSubmissionsByFacultyQueryVariables>(GetUnifiedSubmissionsByFacultyDocument, options);
      }
export function useGetUnifiedSubmissionsByFacultyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnifiedSubmissionsByFacultyQuery, GetUnifiedSubmissionsByFacultyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnifiedSubmissionsByFacultyQuery, GetUnifiedSubmissionsByFacultyQueryVariables>(GetUnifiedSubmissionsByFacultyDocument, options);
        }
// @ts-ignore
export function useGetUnifiedSubmissionsByFacultySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUnifiedSubmissionsByFacultyQuery, GetUnifiedSubmissionsByFacultyQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnifiedSubmissionsByFacultyQuery, GetUnifiedSubmissionsByFacultyQueryVariables>;
export function useGetUnifiedSubmissionsByFacultySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnifiedSubmissionsByFacultyQuery, GetUnifiedSubmissionsByFacultyQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnifiedSubmissionsByFacultyQuery | undefined, GetUnifiedSubmissionsByFacultyQueryVariables>;
export function useGetUnifiedSubmissionsByFacultySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnifiedSubmissionsByFacultyQuery, GetUnifiedSubmissionsByFacultyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnifiedSubmissionsByFacultyQuery, GetUnifiedSubmissionsByFacultyQueryVariables>(GetUnifiedSubmissionsByFacultyDocument, options);
        }
export type GetUnifiedSubmissionsByFacultyQueryHookResult = ReturnType<typeof useGetUnifiedSubmissionsByFacultyQuery>;
export type GetUnifiedSubmissionsByFacultyLazyQueryHookResult = ReturnType<typeof useGetUnifiedSubmissionsByFacultyLazyQuery>;
export type GetUnifiedSubmissionsByFacultySuspenseQueryHookResult = ReturnType<typeof useGetUnifiedSubmissionsByFacultySuspenseQuery>;
export type GetUnifiedSubmissionsByFacultyQueryResult = Apollo.QueryResult<GetUnifiedSubmissionsByFacultyQuery, GetUnifiedSubmissionsByFacultyQueryVariables>;
export const GetUnifiedSubmissionsByFacultyByUserDocument = gql`
    query GetUnifiedSubmissionsByFacultyByUser($input: GetUnifiedSubmissionsByFacultyByUserInput!) {
  getUnifiedSubmissionsByFacultyByUser(input: $input) {
    success
    data {
      submissions {
        id
        created
        submissionType
        moduleName
        submissionTitle
        courseName
        student {
          id
          name
          email
          initials
        }
        submittedOn
        submittedTime
        status
        grade
        maximumPoints
        courseCode
        courseId
        dueDate
        retakeDeadline
      }
      totalCount
    }
    count
  }
}
    `;

/**
 * __useGetUnifiedSubmissionsByFacultyByUserQuery__
 *
 * To run a query within a React component, call `useGetUnifiedSubmissionsByFacultyByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnifiedSubmissionsByFacultyByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnifiedSubmissionsByFacultyByUserQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUnifiedSubmissionsByFacultyByUserQuery(baseOptions: Apollo.QueryHookOptions<GetUnifiedSubmissionsByFacultyByUserQuery, GetUnifiedSubmissionsByFacultyByUserQueryVariables> & ({ variables: GetUnifiedSubmissionsByFacultyByUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnifiedSubmissionsByFacultyByUserQuery, GetUnifiedSubmissionsByFacultyByUserQueryVariables>(GetUnifiedSubmissionsByFacultyByUserDocument, options);
      }
export function useGetUnifiedSubmissionsByFacultyByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnifiedSubmissionsByFacultyByUserQuery, GetUnifiedSubmissionsByFacultyByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnifiedSubmissionsByFacultyByUserQuery, GetUnifiedSubmissionsByFacultyByUserQueryVariables>(GetUnifiedSubmissionsByFacultyByUserDocument, options);
        }
// @ts-ignore
export function useGetUnifiedSubmissionsByFacultyByUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUnifiedSubmissionsByFacultyByUserQuery, GetUnifiedSubmissionsByFacultyByUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnifiedSubmissionsByFacultyByUserQuery, GetUnifiedSubmissionsByFacultyByUserQueryVariables>;
export function useGetUnifiedSubmissionsByFacultyByUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnifiedSubmissionsByFacultyByUserQuery, GetUnifiedSubmissionsByFacultyByUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnifiedSubmissionsByFacultyByUserQuery | undefined, GetUnifiedSubmissionsByFacultyByUserQueryVariables>;
export function useGetUnifiedSubmissionsByFacultyByUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnifiedSubmissionsByFacultyByUserQuery, GetUnifiedSubmissionsByFacultyByUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnifiedSubmissionsByFacultyByUserQuery, GetUnifiedSubmissionsByFacultyByUserQueryVariables>(GetUnifiedSubmissionsByFacultyByUserDocument, options);
        }
export type GetUnifiedSubmissionsByFacultyByUserQueryHookResult = ReturnType<typeof useGetUnifiedSubmissionsByFacultyByUserQuery>;
export type GetUnifiedSubmissionsByFacultyByUserLazyQueryHookResult = ReturnType<typeof useGetUnifiedSubmissionsByFacultyByUserLazyQuery>;
export type GetUnifiedSubmissionsByFacultyByUserSuspenseQueryHookResult = ReturnType<typeof useGetUnifiedSubmissionsByFacultyByUserSuspenseQuery>;
export type GetUnifiedSubmissionsByFacultyByUserQueryResult = Apollo.QueryResult<GetUnifiedSubmissionsByFacultyByUserQuery, GetUnifiedSubmissionsByFacultyByUserQueryVariables>;
export const GetAiTutorDocument = gql`
    query getAITutor($id: ID!) {
  getAITutor(id: $id) {
    data {
      id
      title
      description
      created
      lastModified
      dueDate
      context
      targetAudience
      activityState
      scheduledDate
      visualization {
        id
        code
        visualizationType
      }
      hasChatChats {
        id
      }
      objectives {
        id
        objective
        sequence
        evalCriteria
        pendingVideoProcessing
        videos {
          id
          videoId
          title
          url
          thumbnailUrl
          isTeacherAdded
        }
        status
      }
    }
  }
}
    `;

/**
 * __useGetAiTutorQuery__
 *
 * To run a query within a React component, call `useGetAiTutorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiTutorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiTutorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAiTutorQuery(baseOptions: Apollo.QueryHookOptions<GetAiTutorQuery, GetAiTutorQueryVariables> & ({ variables: GetAiTutorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiTutorQuery, GetAiTutorQueryVariables>(GetAiTutorDocument, options);
      }
export function useGetAiTutorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiTutorQuery, GetAiTutorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiTutorQuery, GetAiTutorQueryVariables>(GetAiTutorDocument, options);
        }
// @ts-ignore
export function useGetAiTutorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAiTutorQuery, GetAiTutorQueryVariables>): Apollo.UseSuspenseQueryResult<GetAiTutorQuery, GetAiTutorQueryVariables>;
export function useGetAiTutorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAiTutorQuery, GetAiTutorQueryVariables>): Apollo.UseSuspenseQueryResult<GetAiTutorQuery | undefined, GetAiTutorQueryVariables>;
export function useGetAiTutorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAiTutorQuery, GetAiTutorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAiTutorQuery, GetAiTutorQueryVariables>(GetAiTutorDocument, options);
        }
export type GetAiTutorQueryHookResult = ReturnType<typeof useGetAiTutorQuery>;
export type GetAiTutorLazyQueryHookResult = ReturnType<typeof useGetAiTutorLazyQuery>;
export type GetAiTutorSuspenseQueryHookResult = ReturnType<typeof useGetAiTutorSuspenseQuery>;
export type GetAiTutorQueryResult = Apollo.QueryResult<GetAiTutorQuery, GetAiTutorQueryVariables>;
export const GetAiTutorVideosDocument = gql`
    query GetAiTutorVideos($id: ID!) {
  getAITutorVideos(id: $id) {
    success
    message
    count
    data {
      id
      videoId
      url
      title
      description
      thumbnailUrl
      isTeacherAdded
    }
  }
}
    `;

/**
 * __useGetAiTutorVideosQuery__
 *
 * To run a query within a React component, call `useGetAiTutorVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiTutorVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiTutorVideosQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAiTutorVideosQuery(baseOptions: Apollo.QueryHookOptions<GetAiTutorVideosQuery, GetAiTutorVideosQueryVariables> & ({ variables: GetAiTutorVideosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiTutorVideosQuery, GetAiTutorVideosQueryVariables>(GetAiTutorVideosDocument, options);
      }
export function useGetAiTutorVideosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiTutorVideosQuery, GetAiTutorVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiTutorVideosQuery, GetAiTutorVideosQueryVariables>(GetAiTutorVideosDocument, options);
        }
// @ts-ignore
export function useGetAiTutorVideosSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAiTutorVideosQuery, GetAiTutorVideosQueryVariables>): Apollo.UseSuspenseQueryResult<GetAiTutorVideosQuery, GetAiTutorVideosQueryVariables>;
export function useGetAiTutorVideosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAiTutorVideosQuery, GetAiTutorVideosQueryVariables>): Apollo.UseSuspenseQueryResult<GetAiTutorVideosQuery | undefined, GetAiTutorVideosQueryVariables>;
export function useGetAiTutorVideosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAiTutorVideosQuery, GetAiTutorVideosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAiTutorVideosQuery, GetAiTutorVideosQueryVariables>(GetAiTutorVideosDocument, options);
        }
export type GetAiTutorVideosQueryHookResult = ReturnType<typeof useGetAiTutorVideosQuery>;
export type GetAiTutorVideosLazyQueryHookResult = ReturnType<typeof useGetAiTutorVideosLazyQuery>;
export type GetAiTutorVideosSuspenseQueryHookResult = ReturnType<typeof useGetAiTutorVideosSuspenseQuery>;
export type GetAiTutorVideosQueryResult = Apollo.QueryResult<GetAiTutorVideosQuery, GetAiTutorVideosQueryVariables>;
export const GetAllAiTutorsByCourseDocument = gql`
    query GetAllAiTutorsByCourse($courseIds: [ID!]!) {
  getAllAITutorsByCourse(courseIds: $courseIds) {
    data {
      id
      title
      dueDate
      context
      visualization {
        id
        code
        visualizationType
      }
      objectives {
        id
        objective
        status
        evalCriteria
      }
      courseId
    }
  }
}
    `;

/**
 * __useGetAllAiTutorsByCourseQuery__
 *
 * To run a query within a React component, call `useGetAllAiTutorsByCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAiTutorsByCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAiTutorsByCourseQuery({
 *   variables: {
 *      courseIds: // value for 'courseIds'
 *   },
 * });
 */
export function useGetAllAiTutorsByCourseQuery(baseOptions: Apollo.QueryHookOptions<GetAllAiTutorsByCourseQuery, GetAllAiTutorsByCourseQueryVariables> & ({ variables: GetAllAiTutorsByCourseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAiTutorsByCourseQuery, GetAllAiTutorsByCourseQueryVariables>(GetAllAiTutorsByCourseDocument, options);
      }
export function useGetAllAiTutorsByCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAiTutorsByCourseQuery, GetAllAiTutorsByCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAiTutorsByCourseQuery, GetAllAiTutorsByCourseQueryVariables>(GetAllAiTutorsByCourseDocument, options);
        }
// @ts-ignore
export function useGetAllAiTutorsByCourseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllAiTutorsByCourseQuery, GetAllAiTutorsByCourseQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllAiTutorsByCourseQuery, GetAllAiTutorsByCourseQueryVariables>;
export function useGetAllAiTutorsByCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAiTutorsByCourseQuery, GetAllAiTutorsByCourseQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllAiTutorsByCourseQuery | undefined, GetAllAiTutorsByCourseQueryVariables>;
export function useGetAllAiTutorsByCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAiTutorsByCourseQuery, GetAllAiTutorsByCourseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllAiTutorsByCourseQuery, GetAllAiTutorsByCourseQueryVariables>(GetAllAiTutorsByCourseDocument, options);
        }
export type GetAllAiTutorsByCourseQueryHookResult = ReturnType<typeof useGetAllAiTutorsByCourseQuery>;
export type GetAllAiTutorsByCourseLazyQueryHookResult = ReturnType<typeof useGetAllAiTutorsByCourseLazyQuery>;
export type GetAllAiTutorsByCourseSuspenseQueryHookResult = ReturnType<typeof useGetAllAiTutorsByCourseSuspenseQuery>;
export type GetAllAiTutorsByCourseQueryResult = Apollo.QueryResult<GetAllAiTutorsByCourseQuery, GetAllAiTutorsByCourseQueryVariables>;
export const GetAllAssessmentsByCourseDocument = gql`
    query GetAllAssessmentsByCourse($courseId: ID!) {
  getAllAssessmentsByCourse(courseId: $courseId) {
    success
    message
    data {
      id
      created
      lastModified
      aiTutors {
        id
        title
      }
      moduleHasAssessment {
        id
        title
        courseHasModules {
          id
          name
        }
      }
      activityState
      scheduledDate
    }
    count
  }
}
    `;

/**
 * __useGetAllAssessmentsByCourseQuery__
 *
 * To run a query within a React component, call `useGetAllAssessmentsByCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAssessmentsByCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAssessmentsByCourseQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetAllAssessmentsByCourseQuery(baseOptions: Apollo.QueryHookOptions<GetAllAssessmentsByCourseQuery, GetAllAssessmentsByCourseQueryVariables> & ({ variables: GetAllAssessmentsByCourseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAssessmentsByCourseQuery, GetAllAssessmentsByCourseQueryVariables>(GetAllAssessmentsByCourseDocument, options);
      }
export function useGetAllAssessmentsByCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAssessmentsByCourseQuery, GetAllAssessmentsByCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAssessmentsByCourseQuery, GetAllAssessmentsByCourseQueryVariables>(GetAllAssessmentsByCourseDocument, options);
        }
// @ts-ignore
export function useGetAllAssessmentsByCourseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllAssessmentsByCourseQuery, GetAllAssessmentsByCourseQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllAssessmentsByCourseQuery, GetAllAssessmentsByCourseQueryVariables>;
export function useGetAllAssessmentsByCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAssessmentsByCourseQuery, GetAllAssessmentsByCourseQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllAssessmentsByCourseQuery | undefined, GetAllAssessmentsByCourseQueryVariables>;
export function useGetAllAssessmentsByCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAssessmentsByCourseQuery, GetAllAssessmentsByCourseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllAssessmentsByCourseQuery, GetAllAssessmentsByCourseQueryVariables>(GetAllAssessmentsByCourseDocument, options);
        }
export type GetAllAssessmentsByCourseQueryHookResult = ReturnType<typeof useGetAllAssessmentsByCourseQuery>;
export type GetAllAssessmentsByCourseLazyQueryHookResult = ReturnType<typeof useGetAllAssessmentsByCourseLazyQuery>;
export type GetAllAssessmentsByCourseSuspenseQueryHookResult = ReturnType<typeof useGetAllAssessmentsByCourseSuspenseQuery>;
export type GetAllAssessmentsByCourseQueryResult = Apollo.QueryResult<GetAllAssessmentsByCourseQuery, GetAllAssessmentsByCourseQueryVariables>;
export const GetAllModulesByCourseDocument = gql`
    query GetAllModulesByCourse($courseId: ID!) {
  getAllModulesByCourse(courseId: $courseId) {
    success
    message
    data {
      id
      title
      thumbnail
      description
      resourceOrder
      aiTutors {
        id
        title
        description
      }
      assignments {
        id
        name
        description
        due_date
      }
      axioResources {
        id
        name
        description
      }
    }
    count
  }
}
    `;

/**
 * __useGetAllModulesByCourseQuery__
 *
 * To run a query within a React component, call `useGetAllModulesByCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllModulesByCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllModulesByCourseQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetAllModulesByCourseQuery(baseOptions: Apollo.QueryHookOptions<GetAllModulesByCourseQuery, GetAllModulesByCourseQueryVariables> & ({ variables: GetAllModulesByCourseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllModulesByCourseQuery, GetAllModulesByCourseQueryVariables>(GetAllModulesByCourseDocument, options);
      }
export function useGetAllModulesByCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllModulesByCourseQuery, GetAllModulesByCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllModulesByCourseQuery, GetAllModulesByCourseQueryVariables>(GetAllModulesByCourseDocument, options);
        }
// @ts-ignore
export function useGetAllModulesByCourseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllModulesByCourseQuery, GetAllModulesByCourseQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllModulesByCourseQuery, GetAllModulesByCourseQueryVariables>;
export function useGetAllModulesByCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllModulesByCourseQuery, GetAllModulesByCourseQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllModulesByCourseQuery | undefined, GetAllModulesByCourseQueryVariables>;
export function useGetAllModulesByCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllModulesByCourseQuery, GetAllModulesByCourseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllModulesByCourseQuery, GetAllModulesByCourseQueryVariables>(GetAllModulesByCourseDocument, options);
        }
export type GetAllModulesByCourseQueryHookResult = ReturnType<typeof useGetAllModulesByCourseQuery>;
export type GetAllModulesByCourseLazyQueryHookResult = ReturnType<typeof useGetAllModulesByCourseLazyQuery>;
export type GetAllModulesByCourseSuspenseQueryHookResult = ReturnType<typeof useGetAllModulesByCourseSuspenseQuery>;
export type GetAllModulesByCourseQueryResult = Apollo.QueryResult<GetAllModulesByCourseQuery, GetAllModulesByCourseQueryVariables>;
export const GetAnnouncementByIdDocument = gql`
    query GetAnnouncementById($id: ID!) {
  getAnnouncementById(id: $id) {
    success
    message
    data {
      id
      title
      message
      expirationDate
      created
      lastModified
      audienceType
      scope
    }
    count
  }
}
    `;

/**
 * __useGetAnnouncementByIdQuery__
 *
 * To run a query within a React component, call `useGetAnnouncementByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnouncementByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnouncementByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAnnouncementByIdQuery(baseOptions: Apollo.QueryHookOptions<GetAnnouncementByIdQuery, GetAnnouncementByIdQueryVariables> & ({ variables: GetAnnouncementByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnnouncementByIdQuery, GetAnnouncementByIdQueryVariables>(GetAnnouncementByIdDocument, options);
      }
export function useGetAnnouncementByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnnouncementByIdQuery, GetAnnouncementByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnnouncementByIdQuery, GetAnnouncementByIdQueryVariables>(GetAnnouncementByIdDocument, options);
        }
// @ts-ignore
export function useGetAnnouncementByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAnnouncementByIdQuery, GetAnnouncementByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnnouncementByIdQuery, GetAnnouncementByIdQueryVariables>;
export function useGetAnnouncementByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnnouncementByIdQuery, GetAnnouncementByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnnouncementByIdQuery | undefined, GetAnnouncementByIdQueryVariables>;
export function useGetAnnouncementByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnnouncementByIdQuery, GetAnnouncementByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnnouncementByIdQuery, GetAnnouncementByIdQueryVariables>(GetAnnouncementByIdDocument, options);
        }
export type GetAnnouncementByIdQueryHookResult = ReturnType<typeof useGetAnnouncementByIdQuery>;
export type GetAnnouncementByIdLazyQueryHookResult = ReturnType<typeof useGetAnnouncementByIdLazyQuery>;
export type GetAnnouncementByIdSuspenseQueryHookResult = ReturnType<typeof useGetAnnouncementByIdSuspenseQuery>;
export type GetAnnouncementByIdQueryResult = Apollo.QueryResult<GetAnnouncementByIdQuery, GetAnnouncementByIdQueryVariables>;
export const GetAssessmentDocument = gql`
    query getAssessment($assessmentId: ID!) {
  getAssessment(assessmentId: $assessmentId) {
    data {
      id
      created
      lastModified
      assessmentType
      numberOfQuestions
      timeLimit
      dueDate
      activityState
      scheduledDate
      moduleHasAssessment {
        title
      }
      aiTutors {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useGetAssessmentQuery__
 *
 * To run a query within a React component, call `useGetAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGetAssessmentQuery(baseOptions: Apollo.QueryHookOptions<GetAssessmentQuery, GetAssessmentQueryVariables> & ({ variables: GetAssessmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssessmentQuery, GetAssessmentQueryVariables>(GetAssessmentDocument, options);
      }
export function useGetAssessmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssessmentQuery, GetAssessmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssessmentQuery, GetAssessmentQueryVariables>(GetAssessmentDocument, options);
        }
// @ts-ignore
export function useGetAssessmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssessmentQuery, GetAssessmentQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssessmentQuery, GetAssessmentQueryVariables>;
export function useGetAssessmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssessmentQuery, GetAssessmentQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssessmentQuery | undefined, GetAssessmentQueryVariables>;
export function useGetAssessmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssessmentQuery, GetAssessmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssessmentQuery, GetAssessmentQueryVariables>(GetAssessmentDocument, options);
        }
export type GetAssessmentQueryHookResult = ReturnType<typeof useGetAssessmentQuery>;
export type GetAssessmentLazyQueryHookResult = ReturnType<typeof useGetAssessmentLazyQuery>;
export type GetAssessmentSuspenseQueryHookResult = ReturnType<typeof useGetAssessmentSuspenseQuery>;
export type GetAssessmentQueryResult = Apollo.QueryResult<GetAssessmentQuery, GetAssessmentQueryVariables>;
export const GetAssessmentQuestionBankDocument = gql`
    query getAssessmentQuestionBank($assessmentId: ID!, $pagination: AssessmentQuestionBankPaginationInput) {
  getAssessmentQuestionBank(assessmentId: $assessmentId, pagination: $pagination) {
    count
    socraticTotalCount
    mcqTotalCount
    data {
      id
      assessmentType
      aiTutors {
        id
        title
        questionGenerationStatus
        questions {
          id
          question
          totalScore
          rubrics {
            id
            component
            points
          }
        }
      }
      mcqQuestions {
        id
        created
        lastModified
        question
        choices
        correctChoiceIndices
        explanation
        totalScore
        order
      }
    }
  }
}
    `;

/**
 * __useGetAssessmentQuestionBankQuery__
 *
 * To run a query within a React component, call `useGetAssessmentQuestionBankQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentQuestionBankQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentQuestionBankQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetAssessmentQuestionBankQuery(baseOptions: Apollo.QueryHookOptions<GetAssessmentQuestionBankQuery, GetAssessmentQuestionBankQueryVariables> & ({ variables: GetAssessmentQuestionBankQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssessmentQuestionBankQuery, GetAssessmentQuestionBankQueryVariables>(GetAssessmentQuestionBankDocument, options);
      }
export function useGetAssessmentQuestionBankLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssessmentQuestionBankQuery, GetAssessmentQuestionBankQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssessmentQuestionBankQuery, GetAssessmentQuestionBankQueryVariables>(GetAssessmentQuestionBankDocument, options);
        }
// @ts-ignore
export function useGetAssessmentQuestionBankSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssessmentQuestionBankQuery, GetAssessmentQuestionBankQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssessmentQuestionBankQuery, GetAssessmentQuestionBankQueryVariables>;
export function useGetAssessmentQuestionBankSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssessmentQuestionBankQuery, GetAssessmentQuestionBankQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssessmentQuestionBankQuery | undefined, GetAssessmentQuestionBankQueryVariables>;
export function useGetAssessmentQuestionBankSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssessmentQuestionBankQuery, GetAssessmentQuestionBankQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssessmentQuestionBankQuery, GetAssessmentQuestionBankQueryVariables>(GetAssessmentQuestionBankDocument, options);
        }
export type GetAssessmentQuestionBankQueryHookResult = ReturnType<typeof useGetAssessmentQuestionBankQuery>;
export type GetAssessmentQuestionBankLazyQueryHookResult = ReturnType<typeof useGetAssessmentQuestionBankLazyQuery>;
export type GetAssessmentQuestionBankSuspenseQueryHookResult = ReturnType<typeof useGetAssessmentQuestionBankSuspenseQuery>;
export type GetAssessmentQuestionBankQueryResult = Apollo.QueryResult<GetAssessmentQuestionBankQuery, GetAssessmentQuestionBankQueryVariables>;
export const GetAssessmentSubmissionAttemptHistoryDocument = gql`
    query getAssessmentSubmissionAttemptHistory($assessmentId: ID!, $userId: ID!) {
  getAttemptHistory(assessmentId: $assessmentId, userId: $userId) {
    data {
      assessmentSubmissions {
        id
        created
        lastModified
        startedAt
        completedAt
        totalPoints
        maximumPoints
        hasTeacherGraded
        hasTeacherAdjustedGrade
        status
        timeLimit
        isEvaluationPending
        mcqAnswersConnection {
          edges {
            properties {
              selectedChoiceIndices
            }
            node {
              id
              question
              choices
              order
            }
          }
        }
        questionsConnection {
          edges {
            node {
              id
              question
            }
            properties {
              answer
              createdAt
              totalPoints
              maximumPoints
            }
          }
        }
      }
      totalCount
    }
    count
  }
}
    `;

/**
 * __useGetAssessmentSubmissionAttemptHistoryQuery__
 *
 * To run a query within a React component, call `useGetAssessmentSubmissionAttemptHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentSubmissionAttemptHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentSubmissionAttemptHistoryQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetAssessmentSubmissionAttemptHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetAssessmentSubmissionAttemptHistoryQuery, GetAssessmentSubmissionAttemptHistoryQueryVariables> & ({ variables: GetAssessmentSubmissionAttemptHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssessmentSubmissionAttemptHistoryQuery, GetAssessmentSubmissionAttemptHistoryQueryVariables>(GetAssessmentSubmissionAttemptHistoryDocument, options);
      }
export function useGetAssessmentSubmissionAttemptHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssessmentSubmissionAttemptHistoryQuery, GetAssessmentSubmissionAttemptHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssessmentSubmissionAttemptHistoryQuery, GetAssessmentSubmissionAttemptHistoryQueryVariables>(GetAssessmentSubmissionAttemptHistoryDocument, options);
        }
// @ts-ignore
export function useGetAssessmentSubmissionAttemptHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssessmentSubmissionAttemptHistoryQuery, GetAssessmentSubmissionAttemptHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssessmentSubmissionAttemptHistoryQuery, GetAssessmentSubmissionAttemptHistoryQueryVariables>;
export function useGetAssessmentSubmissionAttemptHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssessmentSubmissionAttemptHistoryQuery, GetAssessmentSubmissionAttemptHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssessmentSubmissionAttemptHistoryQuery | undefined, GetAssessmentSubmissionAttemptHistoryQueryVariables>;
export function useGetAssessmentSubmissionAttemptHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssessmentSubmissionAttemptHistoryQuery, GetAssessmentSubmissionAttemptHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssessmentSubmissionAttemptHistoryQuery, GetAssessmentSubmissionAttemptHistoryQueryVariables>(GetAssessmentSubmissionAttemptHistoryDocument, options);
        }
export type GetAssessmentSubmissionAttemptHistoryQueryHookResult = ReturnType<typeof useGetAssessmentSubmissionAttemptHistoryQuery>;
export type GetAssessmentSubmissionAttemptHistoryLazyQueryHookResult = ReturnType<typeof useGetAssessmentSubmissionAttemptHistoryLazyQuery>;
export type GetAssessmentSubmissionAttemptHistorySuspenseQueryHookResult = ReturnType<typeof useGetAssessmentSubmissionAttemptHistorySuspenseQuery>;
export type GetAssessmentSubmissionAttemptHistoryQueryResult = Apollo.QueryResult<GetAssessmentSubmissionAttemptHistoryQuery, GetAssessmentSubmissionAttemptHistoryQueryVariables>;
export const GetRunningAssessmentSubmissionByUserDocument = gql`
    query getRunningAssessmentSubmissionByUser {
  getRunningAssessmentSubmissionByUser {
    data {
      id
      status
      assessment {
        id
      }
    }
  }
}
    `;

/**
 * __useGetRunningAssessmentSubmissionByUserQuery__
 *
 * To run a query within a React component, call `useGetRunningAssessmentSubmissionByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRunningAssessmentSubmissionByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRunningAssessmentSubmissionByUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRunningAssessmentSubmissionByUserQuery(baseOptions?: Apollo.QueryHookOptions<GetRunningAssessmentSubmissionByUserQuery, GetRunningAssessmentSubmissionByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRunningAssessmentSubmissionByUserQuery, GetRunningAssessmentSubmissionByUserQueryVariables>(GetRunningAssessmentSubmissionByUserDocument, options);
      }
export function useGetRunningAssessmentSubmissionByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRunningAssessmentSubmissionByUserQuery, GetRunningAssessmentSubmissionByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRunningAssessmentSubmissionByUserQuery, GetRunningAssessmentSubmissionByUserQueryVariables>(GetRunningAssessmentSubmissionByUserDocument, options);
        }
// @ts-ignore
export function useGetRunningAssessmentSubmissionByUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRunningAssessmentSubmissionByUserQuery, GetRunningAssessmentSubmissionByUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetRunningAssessmentSubmissionByUserQuery, GetRunningAssessmentSubmissionByUserQueryVariables>;
export function useGetRunningAssessmentSubmissionByUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRunningAssessmentSubmissionByUserQuery, GetRunningAssessmentSubmissionByUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetRunningAssessmentSubmissionByUserQuery | undefined, GetRunningAssessmentSubmissionByUserQueryVariables>;
export function useGetRunningAssessmentSubmissionByUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRunningAssessmentSubmissionByUserQuery, GetRunningAssessmentSubmissionByUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRunningAssessmentSubmissionByUserQuery, GetRunningAssessmentSubmissionByUserQueryVariables>(GetRunningAssessmentSubmissionByUserDocument, options);
        }
export type GetRunningAssessmentSubmissionByUserQueryHookResult = ReturnType<typeof useGetRunningAssessmentSubmissionByUserQuery>;
export type GetRunningAssessmentSubmissionByUserLazyQueryHookResult = ReturnType<typeof useGetRunningAssessmentSubmissionByUserLazyQuery>;
export type GetRunningAssessmentSubmissionByUserSuspenseQueryHookResult = ReturnType<typeof useGetRunningAssessmentSubmissionByUserSuspenseQuery>;
export type GetRunningAssessmentSubmissionByUserQueryResult = Apollo.QueryResult<GetRunningAssessmentSubmissionByUserQuery, GetRunningAssessmentSubmissionByUserQueryVariables>;
export const GetAssessmentSubmissionsDetailsDocument = gql`
    query GetAssessmentSubmissionsDetails($assessmentSubmissionId: ID!, $studentId: ID) {
  getAssessmentSubmissionDetails(
    assessmentSubmissionId: $assessmentSubmissionId
    studentId: $studentId
  ) {
    success
    data {
      id
      userName
      userId
      userEmail
      status
      completedAt
      startedAt
      totalPoints
      aiTotalPoints
      maximumPoints
      hasTeacherGraded
      hasTeacherAdjustedGrade
      assessmentId
      assessmentType
      created
      lastModified
      timeLimit
      moduleName
      courseName
      feedback
      questions {
        id
        question
        totalScore
        rubrics {
          id
          component
          points
          pointsAwarded
          aiPointsAwarded
          maxPoints
          remarks
        }
        userAnswer {
          answer
          createdAt
          totalPoints
          aiTotalPoints
          maximumPoints
        }
      }
      mcqAnswers {
        id
        question
        choices
        correctChoiceIndices
        explanation
        totalScore
        order
        selectedChoiceIndices
        isCorrect
        pointsAwarded
      }
    }
  }
}
    `;

/**
 * __useGetAssessmentSubmissionsDetailsQuery__
 *
 * To run a query within a React component, call `useGetAssessmentSubmissionsDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentSubmissionsDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentSubmissionsDetailsQuery({
 *   variables: {
 *      assessmentSubmissionId: // value for 'assessmentSubmissionId'
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useGetAssessmentSubmissionsDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetAssessmentSubmissionsDetailsQuery, GetAssessmentSubmissionsDetailsQueryVariables> & ({ variables: GetAssessmentSubmissionsDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssessmentSubmissionsDetailsQuery, GetAssessmentSubmissionsDetailsQueryVariables>(GetAssessmentSubmissionsDetailsDocument, options);
      }
export function useGetAssessmentSubmissionsDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssessmentSubmissionsDetailsQuery, GetAssessmentSubmissionsDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssessmentSubmissionsDetailsQuery, GetAssessmentSubmissionsDetailsQueryVariables>(GetAssessmentSubmissionsDetailsDocument, options);
        }
// @ts-ignore
export function useGetAssessmentSubmissionsDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssessmentSubmissionsDetailsQuery, GetAssessmentSubmissionsDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssessmentSubmissionsDetailsQuery, GetAssessmentSubmissionsDetailsQueryVariables>;
export function useGetAssessmentSubmissionsDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssessmentSubmissionsDetailsQuery, GetAssessmentSubmissionsDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssessmentSubmissionsDetailsQuery | undefined, GetAssessmentSubmissionsDetailsQueryVariables>;
export function useGetAssessmentSubmissionsDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssessmentSubmissionsDetailsQuery, GetAssessmentSubmissionsDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssessmentSubmissionsDetailsQuery, GetAssessmentSubmissionsDetailsQueryVariables>(GetAssessmentSubmissionsDetailsDocument, options);
        }
export type GetAssessmentSubmissionsDetailsQueryHookResult = ReturnType<typeof useGetAssessmentSubmissionsDetailsQuery>;
export type GetAssessmentSubmissionsDetailsLazyQueryHookResult = ReturnType<typeof useGetAssessmentSubmissionsDetailsLazyQuery>;
export type GetAssessmentSubmissionsDetailsSuspenseQueryHookResult = ReturnType<typeof useGetAssessmentSubmissionsDetailsSuspenseQuery>;
export type GetAssessmentSubmissionsDetailsQueryResult = Apollo.QueryResult<GetAssessmentSubmissionsDetailsQuery, GetAssessmentSubmissionsDetailsQueryVariables>;
export const GetAssessmentAiTutorsDocument = gql`
    query getAssessmentAiTutors($moduleId: ID!, $courseId: ID!) {
  getAssessmentAiTutors(moduleId: $moduleId, courseId: $courseId) {
    data {
      currentModuleAiTutors {
        title
        aiTutors {
          id
          title
        }
      }
      pastModulesAiTutors {
        id
        title
        aiTutors {
          id
          title
        }
      }
      futureModulesAiTutors {
        id
        title
        aiTutors {
          id
          title
        }
      }
    }
  }
}
    `;

/**
 * __useGetAssessmentAiTutorsQuery__
 *
 * To run a query within a React component, call `useGetAssessmentAiTutorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentAiTutorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentAiTutorsQuery({
 *   variables: {
 *      moduleId: // value for 'moduleId'
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetAssessmentAiTutorsQuery(baseOptions: Apollo.QueryHookOptions<GetAssessmentAiTutorsQuery, GetAssessmentAiTutorsQueryVariables> & ({ variables: GetAssessmentAiTutorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssessmentAiTutorsQuery, GetAssessmentAiTutorsQueryVariables>(GetAssessmentAiTutorsDocument, options);
      }
export function useGetAssessmentAiTutorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssessmentAiTutorsQuery, GetAssessmentAiTutorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssessmentAiTutorsQuery, GetAssessmentAiTutorsQueryVariables>(GetAssessmentAiTutorsDocument, options);
        }
// @ts-ignore
export function useGetAssessmentAiTutorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssessmentAiTutorsQuery, GetAssessmentAiTutorsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssessmentAiTutorsQuery, GetAssessmentAiTutorsQueryVariables>;
export function useGetAssessmentAiTutorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssessmentAiTutorsQuery, GetAssessmentAiTutorsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssessmentAiTutorsQuery | undefined, GetAssessmentAiTutorsQueryVariables>;
export function useGetAssessmentAiTutorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssessmentAiTutorsQuery, GetAssessmentAiTutorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssessmentAiTutorsQuery, GetAssessmentAiTutorsQueryVariables>(GetAssessmentAiTutorsDocument, options);
        }
export type GetAssessmentAiTutorsQueryHookResult = ReturnType<typeof useGetAssessmentAiTutorsQuery>;
export type GetAssessmentAiTutorsLazyQueryHookResult = ReturnType<typeof useGetAssessmentAiTutorsLazyQuery>;
export type GetAssessmentAiTutorsSuspenseQueryHookResult = ReturnType<typeof useGetAssessmentAiTutorsSuspenseQuery>;
export type GetAssessmentAiTutorsQueryResult = Apollo.QueryResult<GetAssessmentAiTutorsQuery, GetAssessmentAiTutorsQueryVariables>;
export const GetAssignmentDocument = gql`
    query getAssignment($id: ID!) {
  getAssignment(id: $id) {
    success
    message
    data {
      id
      name
      description
      due_date
      enableStudentFileUpload
      files {
        id
        fileName
        fileURL
        created
        status
      }
      videoUrl
      created
      lastModified
      usersHasSchoolAssignmentConnection {
        edges {
          node {
            id
          }
          properties {
            retakeAllowed
            retakeDeadline
          }
        }
      }
      worksheet {
        id
        title
        coverage
        instructions
        numQuestions
        files {
          id
          fileName
          fileURL
          created
          status
        }
      }
    }
  }
}
    `;

/**
 * __useGetAssignmentQuery__
 *
 * To run a query within a React component, call `useGetAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAssignmentQuery(baseOptions: Apollo.QueryHookOptions<GetAssignmentQuery, GetAssignmentQueryVariables> & ({ variables: GetAssignmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignmentQuery, GetAssignmentQueryVariables>(GetAssignmentDocument, options);
      }
export function useGetAssignmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignmentQuery, GetAssignmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignmentQuery, GetAssignmentQueryVariables>(GetAssignmentDocument, options);
        }
// @ts-ignore
export function useGetAssignmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssignmentQuery, GetAssignmentQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssignmentQuery, GetAssignmentQueryVariables>;
export function useGetAssignmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssignmentQuery, GetAssignmentQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssignmentQuery | undefined, GetAssignmentQueryVariables>;
export function useGetAssignmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssignmentQuery, GetAssignmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssignmentQuery, GetAssignmentQueryVariables>(GetAssignmentDocument, options);
        }
export type GetAssignmentQueryHookResult = ReturnType<typeof useGetAssignmentQuery>;
export type GetAssignmentLazyQueryHookResult = ReturnType<typeof useGetAssignmentLazyQuery>;
export type GetAssignmentSuspenseQueryHookResult = ReturnType<typeof useGetAssignmentSuspenseQuery>;
export type GetAssignmentQueryResult = Apollo.QueryResult<GetAssignmentQuery, GetAssignmentQueryVariables>;
export const GetAssignmentAndSubmissionBySubmissionIdDocument = gql`
    query getAssignmentAndSubmissionBySubmissionId($submissionId: ID!) {
  getAssignmentAndSubmissionBySubmissionId(submissionId: $submissionId) {
    success
    data {
      assignment {
        id
        name
        description
        due_date
        usersHasSchoolAssignmentConnection {
          edges {
            properties {
              retakeAllowed
              retakeDeadline
            }
          }
        }
      }
      submission {
        id
        created
        lastModified
        grade
        isCompleted
        completedAt
        feedback
        hasTeacherGraded
        files {
          id
          fileName
          fileURL
          created
          status
        }
      }
    }
  }
}
    `;

/**
 * __useGetAssignmentAndSubmissionBySubmissionIdQuery__
 *
 * To run a query within a React component, call `useGetAssignmentAndSubmissionBySubmissionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentAndSubmissionBySubmissionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentAndSubmissionBySubmissionIdQuery({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useGetAssignmentAndSubmissionBySubmissionIdQuery(baseOptions: Apollo.QueryHookOptions<GetAssignmentAndSubmissionBySubmissionIdQuery, GetAssignmentAndSubmissionBySubmissionIdQueryVariables> & ({ variables: GetAssignmentAndSubmissionBySubmissionIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignmentAndSubmissionBySubmissionIdQuery, GetAssignmentAndSubmissionBySubmissionIdQueryVariables>(GetAssignmentAndSubmissionBySubmissionIdDocument, options);
      }
export function useGetAssignmentAndSubmissionBySubmissionIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignmentAndSubmissionBySubmissionIdQuery, GetAssignmentAndSubmissionBySubmissionIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignmentAndSubmissionBySubmissionIdQuery, GetAssignmentAndSubmissionBySubmissionIdQueryVariables>(GetAssignmentAndSubmissionBySubmissionIdDocument, options);
        }
// @ts-ignore
export function useGetAssignmentAndSubmissionBySubmissionIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssignmentAndSubmissionBySubmissionIdQuery, GetAssignmentAndSubmissionBySubmissionIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssignmentAndSubmissionBySubmissionIdQuery, GetAssignmentAndSubmissionBySubmissionIdQueryVariables>;
export function useGetAssignmentAndSubmissionBySubmissionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssignmentAndSubmissionBySubmissionIdQuery, GetAssignmentAndSubmissionBySubmissionIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssignmentAndSubmissionBySubmissionIdQuery | undefined, GetAssignmentAndSubmissionBySubmissionIdQueryVariables>;
export function useGetAssignmentAndSubmissionBySubmissionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssignmentAndSubmissionBySubmissionIdQuery, GetAssignmentAndSubmissionBySubmissionIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssignmentAndSubmissionBySubmissionIdQuery, GetAssignmentAndSubmissionBySubmissionIdQueryVariables>(GetAssignmentAndSubmissionBySubmissionIdDocument, options);
        }
export type GetAssignmentAndSubmissionBySubmissionIdQueryHookResult = ReturnType<typeof useGetAssignmentAndSubmissionBySubmissionIdQuery>;
export type GetAssignmentAndSubmissionBySubmissionIdLazyQueryHookResult = ReturnType<typeof useGetAssignmentAndSubmissionBySubmissionIdLazyQuery>;
export type GetAssignmentAndSubmissionBySubmissionIdSuspenseQueryHookResult = ReturnType<typeof useGetAssignmentAndSubmissionBySubmissionIdSuspenseQuery>;
export type GetAssignmentAndSubmissionBySubmissionIdQueryResult = Apollo.QueryResult<GetAssignmentAndSubmissionBySubmissionIdQuery, GetAssignmentAndSubmissionBySubmissionIdQueryVariables>;
export const GetAssignmentSubmissionAttemptHistoryDocument = gql`
    query getAssignmentSubmissionAttemptHistory($assignmentId: ID!, $userId: ID!) {
  getAssignmentSubmissionAttemptHistory(
    assignmentId: $assignmentId
    userId: $userId
  ) {
    data {
      submissions {
        id
        created
        lastModified
        grade
        isCompleted
        completedAt
        hasTeacherGraded
        feedback
      }
      totalCount
    }
    count
  }
}
    `;

/**
 * __useGetAssignmentSubmissionAttemptHistoryQuery__
 *
 * To run a query within a React component, call `useGetAssignmentSubmissionAttemptHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentSubmissionAttemptHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentSubmissionAttemptHistoryQuery({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetAssignmentSubmissionAttemptHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetAssignmentSubmissionAttemptHistoryQuery, GetAssignmentSubmissionAttemptHistoryQueryVariables> & ({ variables: GetAssignmentSubmissionAttemptHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignmentSubmissionAttemptHistoryQuery, GetAssignmentSubmissionAttemptHistoryQueryVariables>(GetAssignmentSubmissionAttemptHistoryDocument, options);
      }
export function useGetAssignmentSubmissionAttemptHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignmentSubmissionAttemptHistoryQuery, GetAssignmentSubmissionAttemptHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignmentSubmissionAttemptHistoryQuery, GetAssignmentSubmissionAttemptHistoryQueryVariables>(GetAssignmentSubmissionAttemptHistoryDocument, options);
        }
// @ts-ignore
export function useGetAssignmentSubmissionAttemptHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssignmentSubmissionAttemptHistoryQuery, GetAssignmentSubmissionAttemptHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssignmentSubmissionAttemptHistoryQuery, GetAssignmentSubmissionAttemptHistoryQueryVariables>;
export function useGetAssignmentSubmissionAttemptHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssignmentSubmissionAttemptHistoryQuery, GetAssignmentSubmissionAttemptHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssignmentSubmissionAttemptHistoryQuery | undefined, GetAssignmentSubmissionAttemptHistoryQueryVariables>;
export function useGetAssignmentSubmissionAttemptHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssignmentSubmissionAttemptHistoryQuery, GetAssignmentSubmissionAttemptHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssignmentSubmissionAttemptHistoryQuery, GetAssignmentSubmissionAttemptHistoryQueryVariables>(GetAssignmentSubmissionAttemptHistoryDocument, options);
        }
export type GetAssignmentSubmissionAttemptHistoryQueryHookResult = ReturnType<typeof useGetAssignmentSubmissionAttemptHistoryQuery>;
export type GetAssignmentSubmissionAttemptHistoryLazyQueryHookResult = ReturnType<typeof useGetAssignmentSubmissionAttemptHistoryLazyQuery>;
export type GetAssignmentSubmissionAttemptHistorySuspenseQueryHookResult = ReturnType<typeof useGetAssignmentSubmissionAttemptHistorySuspenseQuery>;
export type GetAssignmentSubmissionAttemptHistoryQueryResult = Apollo.QueryResult<GetAssignmentSubmissionAttemptHistoryQuery, GetAssignmentSubmissionAttemptHistoryQueryVariables>;
export const GetCourseActivitiesProgressDocument = gql`
    query GetCourseActivitiesProgress($id: ID!) {
  getCourseActivitiesProgress(id: $id) {
    data {
      id
      name
      modules {
        id
        title
        resourceOrder
        aiTutors {
          id
          title
          lastModified
          dueDate
          activityState
          scheduledDate
          objectives {
            id
            userHasProgressConnection {
              edges {
                properties {
                  status
                }
              }
            }
          }
        }
        axioResources {
          id
          name
          description
          videoUrl
          lastModified
          activityState
          scheduledDate
          files {
            id
            fileName
            fileURL
          }
        }
        assignments {
          id
          name
          description
          due_date
          videoUrl
          lastModified
          activityState
          scheduledDate
          submissions {
            id
            created
            grade
            hasTeacherGraded
          }
          files {
            id
          }
        }
        assessment {
          id
          lastModified
          dueDate
          activityState
          scheduledDate
          aiTutors {
            id
          }
          submissions {
            id
            created
            status
            isEvaluationPending
            totalPoints
            maximumPoints
          }
        }
        projects {
          id
          name
          description
          status
          lastModified
          dueDate
          expectedOutcomes
          scopeDocument
          deliverableTypes
          assessmentCriteria
          activityState
          scheduledDate
        }
        reviews {
          id
          lastModified
          activityState
          scheduledDate
          hasReviewFor {
            id
            moduleHasAssessment {
              id
              title
            }
          }
          generatingReviewAITutorForConnection {
            edges {
              node {
                id
              }
              properties {
                isGenerating
              }
            }
          }
          hasAITutors {
            id
            created
            reviewForUser {
              id
            }
            objectives {
              id
              userHasProgressConnection {
                edges {
                  properties {
                    status
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCourseActivitiesProgressQuery__
 *
 * To run a query within a React component, call `useGetCourseActivitiesProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseActivitiesProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseActivitiesProgressQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCourseActivitiesProgressQuery(baseOptions: Apollo.QueryHookOptions<GetCourseActivitiesProgressQuery, GetCourseActivitiesProgressQueryVariables> & ({ variables: GetCourseActivitiesProgressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseActivitiesProgressQuery, GetCourseActivitiesProgressQueryVariables>(GetCourseActivitiesProgressDocument, options);
      }
export function useGetCourseActivitiesProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseActivitiesProgressQuery, GetCourseActivitiesProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseActivitiesProgressQuery, GetCourseActivitiesProgressQueryVariables>(GetCourseActivitiesProgressDocument, options);
        }
// @ts-ignore
export function useGetCourseActivitiesProgressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCourseActivitiesProgressQuery, GetCourseActivitiesProgressQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseActivitiesProgressQuery, GetCourseActivitiesProgressQueryVariables>;
export function useGetCourseActivitiesProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseActivitiesProgressQuery, GetCourseActivitiesProgressQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseActivitiesProgressQuery | undefined, GetCourseActivitiesProgressQueryVariables>;
export function useGetCourseActivitiesProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseActivitiesProgressQuery, GetCourseActivitiesProgressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseActivitiesProgressQuery, GetCourseActivitiesProgressQueryVariables>(GetCourseActivitiesProgressDocument, options);
        }
export type GetCourseActivitiesProgressQueryHookResult = ReturnType<typeof useGetCourseActivitiesProgressQuery>;
export type GetCourseActivitiesProgressLazyQueryHookResult = ReturnType<typeof useGetCourseActivitiesProgressLazyQuery>;
export type GetCourseActivitiesProgressSuspenseQueryHookResult = ReturnType<typeof useGetCourseActivitiesProgressSuspenseQuery>;
export type GetCourseActivitiesProgressQueryResult = Apollo.QueryResult<GetCourseActivitiesProgressQuery, GetCourseActivitiesProgressQueryVariables>;
export const GetCourseAdminStatsDocument = gql`
    query GetCourseAdminStats($id: ID!) {
  getCourseAdminStats(id: $id) {
    data {
      id
      name
      isDraft
      enrolledStudents {
        id
      }
      modules {
        id
        assignments {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetCourseAdminStatsQuery__
 *
 * To run a query within a React component, call `useGetCourseAdminStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseAdminStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseAdminStatsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCourseAdminStatsQuery(baseOptions: Apollo.QueryHookOptions<GetCourseAdminStatsQuery, GetCourseAdminStatsQueryVariables> & ({ variables: GetCourseAdminStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseAdminStatsQuery, GetCourseAdminStatsQueryVariables>(GetCourseAdminStatsDocument, options);
      }
export function useGetCourseAdminStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseAdminStatsQuery, GetCourseAdminStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseAdminStatsQuery, GetCourseAdminStatsQueryVariables>(GetCourseAdminStatsDocument, options);
        }
// @ts-ignore
export function useGetCourseAdminStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCourseAdminStatsQuery, GetCourseAdminStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseAdminStatsQuery, GetCourseAdminStatsQueryVariables>;
export function useGetCourseAdminStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseAdminStatsQuery, GetCourseAdminStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseAdminStatsQuery | undefined, GetCourseAdminStatsQueryVariables>;
export function useGetCourseAdminStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseAdminStatsQuery, GetCourseAdminStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseAdminStatsQuery, GetCourseAdminStatsQueryVariables>(GetCourseAdminStatsDocument, options);
        }
export type GetCourseAdminStatsQueryHookResult = ReturnType<typeof useGetCourseAdminStatsQuery>;
export type GetCourseAdminStatsLazyQueryHookResult = ReturnType<typeof useGetCourseAdminStatsLazyQuery>;
export type GetCourseAdminStatsSuspenseQueryHookResult = ReturnType<typeof useGetCourseAdminStatsSuspenseQuery>;
export type GetCourseAdminStatsQueryResult = Apollo.QueryResult<GetCourseAdminStatsQuery, GetCourseAdminStatsQueryVariables>;
export const GetCourseByIdWithEnrolledUserInfoDocument = gql`
    query GetCourseByIdWithEnrolledUserInfo($id: ID!) {
  getCourseByIdWithEnrolledUserInfo(id: $id) {
    data {
      id
      name
      course_code
      description
      cost
      startDate
      endDate
      dueDateStartDate
      dueDateEndDate
      isDraft
      isEnrollmentAvailable
      learningStandards
      lengthInWeeks
      generationStatus
      targetAudience
      objectives
      thumbnail
      last_modified
      stripeProductId
      enrolledStudentsConnection {
        edges {
          node {
            id
          }
          properties {
            pendingCourseEnrollmentInvite
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCourseByIdWithEnrolledUserInfoQuery__
 *
 * To run a query within a React component, call `useGetCourseByIdWithEnrolledUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseByIdWithEnrolledUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseByIdWithEnrolledUserInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCourseByIdWithEnrolledUserInfoQuery(baseOptions: Apollo.QueryHookOptions<GetCourseByIdWithEnrolledUserInfoQuery, GetCourseByIdWithEnrolledUserInfoQueryVariables> & ({ variables: GetCourseByIdWithEnrolledUserInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseByIdWithEnrolledUserInfoQuery, GetCourseByIdWithEnrolledUserInfoQueryVariables>(GetCourseByIdWithEnrolledUserInfoDocument, options);
      }
export function useGetCourseByIdWithEnrolledUserInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseByIdWithEnrolledUserInfoQuery, GetCourseByIdWithEnrolledUserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseByIdWithEnrolledUserInfoQuery, GetCourseByIdWithEnrolledUserInfoQueryVariables>(GetCourseByIdWithEnrolledUserInfoDocument, options);
        }
// @ts-ignore
export function useGetCourseByIdWithEnrolledUserInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCourseByIdWithEnrolledUserInfoQuery, GetCourseByIdWithEnrolledUserInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseByIdWithEnrolledUserInfoQuery, GetCourseByIdWithEnrolledUserInfoQueryVariables>;
export function useGetCourseByIdWithEnrolledUserInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseByIdWithEnrolledUserInfoQuery, GetCourseByIdWithEnrolledUserInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseByIdWithEnrolledUserInfoQuery | undefined, GetCourseByIdWithEnrolledUserInfoQueryVariables>;
export function useGetCourseByIdWithEnrolledUserInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseByIdWithEnrolledUserInfoQuery, GetCourseByIdWithEnrolledUserInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseByIdWithEnrolledUserInfoQuery, GetCourseByIdWithEnrolledUserInfoQueryVariables>(GetCourseByIdWithEnrolledUserInfoDocument, options);
        }
export type GetCourseByIdWithEnrolledUserInfoQueryHookResult = ReturnType<typeof useGetCourseByIdWithEnrolledUserInfoQuery>;
export type GetCourseByIdWithEnrolledUserInfoLazyQueryHookResult = ReturnType<typeof useGetCourseByIdWithEnrolledUserInfoLazyQuery>;
export type GetCourseByIdWithEnrolledUserInfoSuspenseQueryHookResult = ReturnType<typeof useGetCourseByIdWithEnrolledUserInfoSuspenseQuery>;
export type GetCourseByIdWithEnrolledUserInfoQueryResult = Apollo.QueryResult<GetCourseByIdWithEnrolledUserInfoQuery, GetCourseByIdWithEnrolledUserInfoQueryVariables>;
export const GetCourseChatResourcesDocument = gql`
    query GetCourseChatResources($id: ID!) {
  getCourseChatResources(id: $id) {
    data {
      id
      modules {
        id
        resourceOrder
        aiTutors {
          id
          title
          lastModified
        }
        axioResources {
          id
          name
          lastModified
        }
        assignments {
          id
          name
          lastModified
        }
        assessment {
          id
          lastModified
        }
        projects {
          id
          name
          lastModified
        }
      }
    }
  }
}
    `;

/**
 * __useGetCourseChatResourcesQuery__
 *
 * To run a query within a React component, call `useGetCourseChatResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseChatResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseChatResourcesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCourseChatResourcesQuery(baseOptions: Apollo.QueryHookOptions<GetCourseChatResourcesQuery, GetCourseChatResourcesQueryVariables> & ({ variables: GetCourseChatResourcesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseChatResourcesQuery, GetCourseChatResourcesQueryVariables>(GetCourseChatResourcesDocument, options);
      }
export function useGetCourseChatResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseChatResourcesQuery, GetCourseChatResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseChatResourcesQuery, GetCourseChatResourcesQueryVariables>(GetCourseChatResourcesDocument, options);
        }
// @ts-ignore
export function useGetCourseChatResourcesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCourseChatResourcesQuery, GetCourseChatResourcesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseChatResourcesQuery, GetCourseChatResourcesQueryVariables>;
export function useGetCourseChatResourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseChatResourcesQuery, GetCourseChatResourcesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseChatResourcesQuery | undefined, GetCourseChatResourcesQueryVariables>;
export function useGetCourseChatResourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseChatResourcesQuery, GetCourseChatResourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseChatResourcesQuery, GetCourseChatResourcesQueryVariables>(GetCourseChatResourcesDocument, options);
        }
export type GetCourseChatResourcesQueryHookResult = ReturnType<typeof useGetCourseChatResourcesQuery>;
export type GetCourseChatResourcesLazyQueryHookResult = ReturnType<typeof useGetCourseChatResourcesLazyQuery>;
export type GetCourseChatResourcesSuspenseQueryHookResult = ReturnType<typeof useGetCourseChatResourcesSuspenseQuery>;
export type GetCourseChatResourcesQueryResult = Apollo.QueryResult<GetCourseChatResourcesQuery, GetCourseChatResourcesQueryVariables>;
export const GetCourseCoreDocument = gql`
    query GetCourseCore($id: ID!) {
  getCourseCore(id: $id) {
    data {
      id
      name
      course_code
      description
      moduleOrder
      cost
      startDate
      endDate
      dueDateStartDate
      dueDateEndDate
      isDraft
      isEnrollmentAvailable
      generationStatus
      targetAudience
      objectives
      thumbnail
      stripeProductId
      preRequisites {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetCourseCoreQuery__
 *
 * To run a query within a React component, call `useGetCourseCoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseCoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseCoreQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCourseCoreQuery(baseOptions: Apollo.QueryHookOptions<GetCourseCoreQuery, GetCourseCoreQueryVariables> & ({ variables: GetCourseCoreQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseCoreQuery, GetCourseCoreQueryVariables>(GetCourseCoreDocument, options);
      }
export function useGetCourseCoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseCoreQuery, GetCourseCoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseCoreQuery, GetCourseCoreQueryVariables>(GetCourseCoreDocument, options);
        }
// @ts-ignore
export function useGetCourseCoreSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCourseCoreQuery, GetCourseCoreQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseCoreQuery, GetCourseCoreQueryVariables>;
export function useGetCourseCoreSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseCoreQuery, GetCourseCoreQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseCoreQuery | undefined, GetCourseCoreQueryVariables>;
export function useGetCourseCoreSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseCoreQuery, GetCourseCoreQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseCoreQuery, GetCourseCoreQueryVariables>(GetCourseCoreDocument, options);
        }
export type GetCourseCoreQueryHookResult = ReturnType<typeof useGetCourseCoreQuery>;
export type GetCourseCoreLazyQueryHookResult = ReturnType<typeof useGetCourseCoreLazyQuery>;
export type GetCourseCoreSuspenseQueryHookResult = ReturnType<typeof useGetCourseCoreSuspenseQuery>;
export type GetCourseCoreQueryResult = Apollo.QueryResult<GetCourseCoreQuery, GetCourseCoreQueryVariables>;
export const GetCourseModulesActivitiesLiteDocument = gql`
    query GetCourseModulesActivitiesLite($id: ID!) {
  getCourseModulesActivitiesLite(id: $id) {
    data {
      id
      name
      isDraft
      generationStatus
      moduleOrder
      modules {
        id
        title
        description
        thumbnail
        imageGenerationStatus
        resourceOrder
        aiTutors {
          id
          title
          lastModified
          dueDate
          activityState
          scheduledDate
          objectives {
            id
            pendingVideoProcessing
          }
        }
        pages {
          id
          title
          lastModified
        }
        assessment {
          id
          assessmentType
          lastModified
          dueDate
          activityState
          scheduledDate
          aiTutors {
            id
          }
          moduleHasAssessment {
            id
            title
          }
        }
        axioResources {
          id
          name
          lastModified
          activityState
          scheduledDate
        }
        assignments {
          id
          name
          lastModified
          due_date
          activityState
          scheduledDate
        }
        projects {
          id
          name
          lastModified
          activityState
          scheduledDate
        }
        reviews {
          id
          lastModified
          activityState
          scheduledDate
          hasReviewFor {
            id
            moduleHasAssessment {
              id
              title
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCourseModulesActivitiesLiteQuery__
 *
 * To run a query within a React component, call `useGetCourseModulesActivitiesLiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseModulesActivitiesLiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseModulesActivitiesLiteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCourseModulesActivitiesLiteQuery(baseOptions: Apollo.QueryHookOptions<GetCourseModulesActivitiesLiteQuery, GetCourseModulesActivitiesLiteQueryVariables> & ({ variables: GetCourseModulesActivitiesLiteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseModulesActivitiesLiteQuery, GetCourseModulesActivitiesLiteQueryVariables>(GetCourseModulesActivitiesLiteDocument, options);
      }
export function useGetCourseModulesActivitiesLiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseModulesActivitiesLiteQuery, GetCourseModulesActivitiesLiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseModulesActivitiesLiteQuery, GetCourseModulesActivitiesLiteQueryVariables>(GetCourseModulesActivitiesLiteDocument, options);
        }
// @ts-ignore
export function useGetCourseModulesActivitiesLiteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCourseModulesActivitiesLiteQuery, GetCourseModulesActivitiesLiteQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseModulesActivitiesLiteQuery, GetCourseModulesActivitiesLiteQueryVariables>;
export function useGetCourseModulesActivitiesLiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseModulesActivitiesLiteQuery, GetCourseModulesActivitiesLiteQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseModulesActivitiesLiteQuery | undefined, GetCourseModulesActivitiesLiteQueryVariables>;
export function useGetCourseModulesActivitiesLiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseModulesActivitiesLiteQuery, GetCourseModulesActivitiesLiteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseModulesActivitiesLiteQuery, GetCourseModulesActivitiesLiteQueryVariables>(GetCourseModulesActivitiesLiteDocument, options);
        }
export type GetCourseModulesActivitiesLiteQueryHookResult = ReturnType<typeof useGetCourseModulesActivitiesLiteQuery>;
export type GetCourseModulesActivitiesLiteLazyQueryHookResult = ReturnType<typeof useGetCourseModulesActivitiesLiteLazyQuery>;
export type GetCourseModulesActivitiesLiteSuspenseQueryHookResult = ReturnType<typeof useGetCourseModulesActivitiesLiteSuspenseQuery>;
export type GetCourseModulesActivitiesLiteQueryResult = Apollo.QueryResult<GetCourseModulesActivitiesLiteQuery, GetCourseModulesActivitiesLiteQueryVariables>;
export const GetCourseModulesLiteDocument = gql`
    query GetCourseModulesLite($id: ID!) {
  getCourseModulesLite(id: $id) {
    data {
      id
      name
      course_code
      description
      moduleOrder
      thumbnail
      isDraft
      isEnrollmentAvailable
      preRequisites {
        id
        name
      }
      modules {
        id
        title
        description
        thumbnail
        imageGenerationStatus
        resourceOrder
      }
    }
  }
}
    `;

/**
 * __useGetCourseModulesLiteQuery__
 *
 * To run a query within a React component, call `useGetCourseModulesLiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseModulesLiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseModulesLiteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCourseModulesLiteQuery(baseOptions: Apollo.QueryHookOptions<GetCourseModulesLiteQuery, GetCourseModulesLiteQueryVariables> & ({ variables: GetCourseModulesLiteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseModulesLiteQuery, GetCourseModulesLiteQueryVariables>(GetCourseModulesLiteDocument, options);
      }
export function useGetCourseModulesLiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseModulesLiteQuery, GetCourseModulesLiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseModulesLiteQuery, GetCourseModulesLiteQueryVariables>(GetCourseModulesLiteDocument, options);
        }
// @ts-ignore
export function useGetCourseModulesLiteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCourseModulesLiteQuery, GetCourseModulesLiteQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseModulesLiteQuery, GetCourseModulesLiteQueryVariables>;
export function useGetCourseModulesLiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseModulesLiteQuery, GetCourseModulesLiteQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseModulesLiteQuery | undefined, GetCourseModulesLiteQueryVariables>;
export function useGetCourseModulesLiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseModulesLiteQuery, GetCourseModulesLiteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseModulesLiteQuery, GetCourseModulesLiteQueryVariables>(GetCourseModulesLiteDocument, options);
        }
export type GetCourseModulesLiteQueryHookResult = ReturnType<typeof useGetCourseModulesLiteQuery>;
export type GetCourseModulesLiteLazyQueryHookResult = ReturnType<typeof useGetCourseModulesLiteLazyQuery>;
export type GetCourseModulesLiteSuspenseQueryHookResult = ReturnType<typeof useGetCourseModulesLiteSuspenseQuery>;
export type GetCourseModulesLiteQueryResult = Apollo.QueryResult<GetCourseModulesLiteQuery, GetCourseModulesLiteQueryVariables>;
export const GetCourseProgressInformationDocument = gql`
    query GetCourseProgressInformation($courseId: ID!) {
  getCourseProgressInformation(courseId: $courseId) {
    success
    message
    count
    data {
      courseId
      progress
      totalModules
      completedModules
      modules {
        id
        title
        progress
        totalActivities
        completedActivities
      }
    }
  }
}
    `;

/**
 * __useGetCourseProgressInformationQuery__
 *
 * To run a query within a React component, call `useGetCourseProgressInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseProgressInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseProgressInformationQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetCourseProgressInformationQuery(baseOptions: Apollo.QueryHookOptions<GetCourseProgressInformationQuery, GetCourseProgressInformationQueryVariables> & ({ variables: GetCourseProgressInformationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseProgressInformationQuery, GetCourseProgressInformationQueryVariables>(GetCourseProgressInformationDocument, options);
      }
export function useGetCourseProgressInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseProgressInformationQuery, GetCourseProgressInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseProgressInformationQuery, GetCourseProgressInformationQueryVariables>(GetCourseProgressInformationDocument, options);
        }
// @ts-ignore
export function useGetCourseProgressInformationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCourseProgressInformationQuery, GetCourseProgressInformationQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseProgressInformationQuery, GetCourseProgressInformationQueryVariables>;
export function useGetCourseProgressInformationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseProgressInformationQuery, GetCourseProgressInformationQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseProgressInformationQuery | undefined, GetCourseProgressInformationQueryVariables>;
export function useGetCourseProgressInformationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseProgressInformationQuery, GetCourseProgressInformationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseProgressInformationQuery, GetCourseProgressInformationQueryVariables>(GetCourseProgressInformationDocument, options);
        }
export type GetCourseProgressInformationQueryHookResult = ReturnType<typeof useGetCourseProgressInformationQuery>;
export type GetCourseProgressInformationLazyQueryHookResult = ReturnType<typeof useGetCourseProgressInformationLazyQuery>;
export type GetCourseProgressInformationSuspenseQueryHookResult = ReturnType<typeof useGetCourseProgressInformationSuspenseQuery>;
export type GetCourseProgressInformationQueryResult = Apollo.QueryResult<GetCourseProgressInformationQuery, GetCourseProgressInformationQueryVariables>;
export const CoursesAndAssignmentsDocument = gql`
    query CoursesAndAssignments($schoolId: ID!) {
  getCoursesAndAssignments(schoolId: $schoolId) {
    success
    message
    data {
      courses {
        id
        name
        course_code
        assignments {
          id
          name
          description
          due_date
          points_possible
          created
        }
      }
    }
    count
  }
}
    `;

/**
 * __useCoursesAndAssignmentsQuery__
 *
 * To run a query within a React component, call `useCoursesAndAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoursesAndAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoursesAndAssignmentsQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useCoursesAndAssignmentsQuery(baseOptions: Apollo.QueryHookOptions<CoursesAndAssignmentsQuery, CoursesAndAssignmentsQueryVariables> & ({ variables: CoursesAndAssignmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoursesAndAssignmentsQuery, CoursesAndAssignmentsQueryVariables>(CoursesAndAssignmentsDocument, options);
      }
export function useCoursesAndAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoursesAndAssignmentsQuery, CoursesAndAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoursesAndAssignmentsQuery, CoursesAndAssignmentsQueryVariables>(CoursesAndAssignmentsDocument, options);
        }
// @ts-ignore
export function useCoursesAndAssignmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CoursesAndAssignmentsQuery, CoursesAndAssignmentsQueryVariables>): Apollo.UseSuspenseQueryResult<CoursesAndAssignmentsQuery, CoursesAndAssignmentsQueryVariables>;
export function useCoursesAndAssignmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CoursesAndAssignmentsQuery, CoursesAndAssignmentsQueryVariables>): Apollo.UseSuspenseQueryResult<CoursesAndAssignmentsQuery | undefined, CoursesAndAssignmentsQueryVariables>;
export function useCoursesAndAssignmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CoursesAndAssignmentsQuery, CoursesAndAssignmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CoursesAndAssignmentsQuery, CoursesAndAssignmentsQueryVariables>(CoursesAndAssignmentsDocument, options);
        }
export type CoursesAndAssignmentsQueryHookResult = ReturnType<typeof useCoursesAndAssignmentsQuery>;
export type CoursesAndAssignmentsLazyQueryHookResult = ReturnType<typeof useCoursesAndAssignmentsLazyQuery>;
export type CoursesAndAssignmentsSuspenseQueryHookResult = ReturnType<typeof useCoursesAndAssignmentsSuspenseQuery>;
export type CoursesAndAssignmentsQueryResult = Apollo.QueryResult<CoursesAndAssignmentsQuery, CoursesAndAssignmentsQueryVariables>;
export const GetCoursesForTranscriptGenerationDocument = gql`
    query GetCoursesForTranscriptGeneration($schoolId: ID!) {
  getCoursesForTranscriptGeneration(schoolId: $schoolId) {
    success
    message
    data {
      id
      name
      modules {
        title
        aiTutors {
          title
          id
          hasChatChats {
            id
            date
            name
            context
            params
            hasMessageMessages {
              id
              content
              index
              parameters
              aspectDetails
              sender
              created
              snackType
              type
            }
          }
        }
      }
    }
    count
  }
}
    `;

/**
 * __useGetCoursesForTranscriptGenerationQuery__
 *
 * To run a query within a React component, call `useGetCoursesForTranscriptGenerationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesForTranscriptGenerationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesForTranscriptGenerationQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetCoursesForTranscriptGenerationQuery(baseOptions: Apollo.QueryHookOptions<GetCoursesForTranscriptGenerationQuery, GetCoursesForTranscriptGenerationQueryVariables> & ({ variables: GetCoursesForTranscriptGenerationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoursesForTranscriptGenerationQuery, GetCoursesForTranscriptGenerationQueryVariables>(GetCoursesForTranscriptGenerationDocument, options);
      }
export function useGetCoursesForTranscriptGenerationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoursesForTranscriptGenerationQuery, GetCoursesForTranscriptGenerationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoursesForTranscriptGenerationQuery, GetCoursesForTranscriptGenerationQueryVariables>(GetCoursesForTranscriptGenerationDocument, options);
        }
// @ts-ignore
export function useGetCoursesForTranscriptGenerationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCoursesForTranscriptGenerationQuery, GetCoursesForTranscriptGenerationQueryVariables>): Apollo.UseSuspenseQueryResult<GetCoursesForTranscriptGenerationQuery, GetCoursesForTranscriptGenerationQueryVariables>;
export function useGetCoursesForTranscriptGenerationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoursesForTranscriptGenerationQuery, GetCoursesForTranscriptGenerationQueryVariables>): Apollo.UseSuspenseQueryResult<GetCoursesForTranscriptGenerationQuery | undefined, GetCoursesForTranscriptGenerationQueryVariables>;
export function useGetCoursesForTranscriptGenerationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoursesForTranscriptGenerationQuery, GetCoursesForTranscriptGenerationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCoursesForTranscriptGenerationQuery, GetCoursesForTranscriptGenerationQueryVariables>(GetCoursesForTranscriptGenerationDocument, options);
        }
export type GetCoursesForTranscriptGenerationQueryHookResult = ReturnType<typeof useGetCoursesForTranscriptGenerationQuery>;
export type GetCoursesForTranscriptGenerationLazyQueryHookResult = ReturnType<typeof useGetCoursesForTranscriptGenerationLazyQuery>;
export type GetCoursesForTranscriptGenerationSuspenseQueryHookResult = ReturnType<typeof useGetCoursesForTranscriptGenerationSuspenseQuery>;
export type GetCoursesForTranscriptGenerationQueryResult = Apollo.QueryResult<GetCoursesForTranscriptGenerationQuery, GetCoursesForTranscriptGenerationQueryVariables>;
export const GetDueSoonActivitiesBySchoolAndUserDocument = gql`
    query GetDueSoonActivitiesBySchoolAndUser($schoolId: ID!) {
  getDueSoonActivitiesBySchoolAndUser(schoolId: $schoolId) {
    success
    data {
      id
      name
      modules {
        id
        title
        assignments {
          id
          name
          description
          due_date
          submissions {
            id
            isCompleted
            completedAt
          }
        }
        aiTutors {
          id
          title
          description
          dueDate
          objectives {
            id
            objective
            sequence
            userHasProgressConnection {
              edges {
                properties {
                  status
                }
              }
            }
          }
        }
      }
    }
    count
  }
}
    `;

/**
 * __useGetDueSoonActivitiesBySchoolAndUserQuery__
 *
 * To run a query within a React component, call `useGetDueSoonActivitiesBySchoolAndUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDueSoonActivitiesBySchoolAndUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDueSoonActivitiesBySchoolAndUserQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetDueSoonActivitiesBySchoolAndUserQuery(baseOptions: Apollo.QueryHookOptions<GetDueSoonActivitiesBySchoolAndUserQuery, GetDueSoonActivitiesBySchoolAndUserQueryVariables> & ({ variables: GetDueSoonActivitiesBySchoolAndUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDueSoonActivitiesBySchoolAndUserQuery, GetDueSoonActivitiesBySchoolAndUserQueryVariables>(GetDueSoonActivitiesBySchoolAndUserDocument, options);
      }
export function useGetDueSoonActivitiesBySchoolAndUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDueSoonActivitiesBySchoolAndUserQuery, GetDueSoonActivitiesBySchoolAndUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDueSoonActivitiesBySchoolAndUserQuery, GetDueSoonActivitiesBySchoolAndUserQueryVariables>(GetDueSoonActivitiesBySchoolAndUserDocument, options);
        }
// @ts-ignore
export function useGetDueSoonActivitiesBySchoolAndUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDueSoonActivitiesBySchoolAndUserQuery, GetDueSoonActivitiesBySchoolAndUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetDueSoonActivitiesBySchoolAndUserQuery, GetDueSoonActivitiesBySchoolAndUserQueryVariables>;
export function useGetDueSoonActivitiesBySchoolAndUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDueSoonActivitiesBySchoolAndUserQuery, GetDueSoonActivitiesBySchoolAndUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetDueSoonActivitiesBySchoolAndUserQuery | undefined, GetDueSoonActivitiesBySchoolAndUserQueryVariables>;
export function useGetDueSoonActivitiesBySchoolAndUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDueSoonActivitiesBySchoolAndUserQuery, GetDueSoonActivitiesBySchoolAndUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDueSoonActivitiesBySchoolAndUserQuery, GetDueSoonActivitiesBySchoolAndUserQueryVariables>(GetDueSoonActivitiesBySchoolAndUserDocument, options);
        }
export type GetDueSoonActivitiesBySchoolAndUserQueryHookResult = ReturnType<typeof useGetDueSoonActivitiesBySchoolAndUserQuery>;
export type GetDueSoonActivitiesBySchoolAndUserLazyQueryHookResult = ReturnType<typeof useGetDueSoonActivitiesBySchoolAndUserLazyQuery>;
export type GetDueSoonActivitiesBySchoolAndUserSuspenseQueryHookResult = ReturnType<typeof useGetDueSoonActivitiesBySchoolAndUserSuspenseQuery>;
export type GetDueSoonActivitiesBySchoolAndUserQueryResult = Apollo.QueryResult<GetDueSoonActivitiesBySchoolAndUserQuery, GetDueSoonActivitiesBySchoolAndUserQueryVariables>;
export const GetEnrolledCoursesForStudentDocument = gql`
    query GetEnrolledCoursesForStudent($schoolId: ID!, $studentId: ID, $page: Int, $pageSize: Int) {
  getEnrolledCoursesForStudent(
    schoolId: $schoolId
    studentId: $studentId
    page: $page
    pageSize: $pageSize
  ) {
    data {
      courses {
        course {
          id
          name
          course_code
          isDraft
          learningStandards
          lengthInWeeks
          objectives
          last_modified
          thumbnail
          cost
          startDate
          description
          targetAudience
          generationStatus
          preRequisites {
            id
            name
            cost
            description
            enrolledStudents {
              id
              name
            }
          }
          preRequisiteFor {
            id
            name
            cost
            description
            enrolledStudents {
              id
              name
            }
          }
          modules {
            id
            title
            assignments {
              id
              name
            }
            aiTutors {
              id
              title
            }
            axioResources {
              id
              name
            }
          }
          enrolledStudents {
            id
            name
          }
          degreesHasCourse {
            id
            name
            usersEnrolledIn {
              id
              name
            }
          }
        }
        progress
        preRequisitesCompleted
      }
      totalCount
    }
    count
  }
}
    `;

/**
 * __useGetEnrolledCoursesForStudentQuery__
 *
 * To run a query within a React component, call `useGetEnrolledCoursesForStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnrolledCoursesForStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnrolledCoursesForStudentQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      studentId: // value for 'studentId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetEnrolledCoursesForStudentQuery(baseOptions: Apollo.QueryHookOptions<GetEnrolledCoursesForStudentQuery, GetEnrolledCoursesForStudentQueryVariables> & ({ variables: GetEnrolledCoursesForStudentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnrolledCoursesForStudentQuery, GetEnrolledCoursesForStudentQueryVariables>(GetEnrolledCoursesForStudentDocument, options);
      }
export function useGetEnrolledCoursesForStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnrolledCoursesForStudentQuery, GetEnrolledCoursesForStudentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnrolledCoursesForStudentQuery, GetEnrolledCoursesForStudentQueryVariables>(GetEnrolledCoursesForStudentDocument, options);
        }
// @ts-ignore
export function useGetEnrolledCoursesForStudentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEnrolledCoursesForStudentQuery, GetEnrolledCoursesForStudentQueryVariables>): Apollo.UseSuspenseQueryResult<GetEnrolledCoursesForStudentQuery, GetEnrolledCoursesForStudentQueryVariables>;
export function useGetEnrolledCoursesForStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEnrolledCoursesForStudentQuery, GetEnrolledCoursesForStudentQueryVariables>): Apollo.UseSuspenseQueryResult<GetEnrolledCoursesForStudentQuery | undefined, GetEnrolledCoursesForStudentQueryVariables>;
export function useGetEnrolledCoursesForStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEnrolledCoursesForStudentQuery, GetEnrolledCoursesForStudentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEnrolledCoursesForStudentQuery, GetEnrolledCoursesForStudentQueryVariables>(GetEnrolledCoursesForStudentDocument, options);
        }
export type GetEnrolledCoursesForStudentQueryHookResult = ReturnType<typeof useGetEnrolledCoursesForStudentQuery>;
export type GetEnrolledCoursesForStudentLazyQueryHookResult = ReturnType<typeof useGetEnrolledCoursesForStudentLazyQuery>;
export type GetEnrolledCoursesForStudentSuspenseQueryHookResult = ReturnType<typeof useGetEnrolledCoursesForStudentSuspenseQuery>;
export type GetEnrolledCoursesForStudentQueryResult = Apollo.QueryResult<GetEnrolledCoursesForStudentQuery, GetEnrolledCoursesForStudentQueryVariables>;
export const GetGradingCenterDashboardDataDocument = gql`
    query getGradingCenterDashboardData($facultyId: ID!) {
  getGradingCenterDashboardData(facultyId: $facultyId) {
    success
    message
    data {
      assignmentsAndAssessmentsToGrade
      newSubmissionsToday
    }
  }
}
    `;

/**
 * __useGetGradingCenterDashboardDataQuery__
 *
 * To run a query within a React component, call `useGetGradingCenterDashboardDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGradingCenterDashboardDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGradingCenterDashboardDataQuery({
 *   variables: {
 *      facultyId: // value for 'facultyId'
 *   },
 * });
 */
export function useGetGradingCenterDashboardDataQuery(baseOptions: Apollo.QueryHookOptions<GetGradingCenterDashboardDataQuery, GetGradingCenterDashboardDataQueryVariables> & ({ variables: GetGradingCenterDashboardDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGradingCenterDashboardDataQuery, GetGradingCenterDashboardDataQueryVariables>(GetGradingCenterDashboardDataDocument, options);
      }
export function useGetGradingCenterDashboardDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGradingCenterDashboardDataQuery, GetGradingCenterDashboardDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGradingCenterDashboardDataQuery, GetGradingCenterDashboardDataQueryVariables>(GetGradingCenterDashboardDataDocument, options);
        }
// @ts-ignore
export function useGetGradingCenterDashboardDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGradingCenterDashboardDataQuery, GetGradingCenterDashboardDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetGradingCenterDashboardDataQuery, GetGradingCenterDashboardDataQueryVariables>;
export function useGetGradingCenterDashboardDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGradingCenterDashboardDataQuery, GetGradingCenterDashboardDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetGradingCenterDashboardDataQuery | undefined, GetGradingCenterDashboardDataQueryVariables>;
export function useGetGradingCenterDashboardDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGradingCenterDashboardDataQuery, GetGradingCenterDashboardDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGradingCenterDashboardDataQuery, GetGradingCenterDashboardDataQueryVariables>(GetGradingCenterDashboardDataDocument, options);
        }
export type GetGradingCenterDashboardDataQueryHookResult = ReturnType<typeof useGetGradingCenterDashboardDataQuery>;
export type GetGradingCenterDashboardDataLazyQueryHookResult = ReturnType<typeof useGetGradingCenterDashboardDataLazyQuery>;
export type GetGradingCenterDashboardDataSuspenseQueryHookResult = ReturnType<typeof useGetGradingCenterDashboardDataSuspenseQuery>;
export type GetGradingCenterDashboardDataQueryResult = Apollo.QueryResult<GetGradingCenterDashboardDataQuery, GetGradingCenterDashboardDataQueryVariables>;
export const GetIsRoomDeletedDocument = gql`
    query getIsRoomDeleted {
  getIsRoomDeleted {
    success
    data
  }
}
    `;

/**
 * __useGetIsRoomDeletedQuery__
 *
 * To run a query within a React component, call `useGetIsRoomDeletedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsRoomDeletedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsRoomDeletedQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIsRoomDeletedQuery(baseOptions?: Apollo.QueryHookOptions<GetIsRoomDeletedQuery, GetIsRoomDeletedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIsRoomDeletedQuery, GetIsRoomDeletedQueryVariables>(GetIsRoomDeletedDocument, options);
      }
export function useGetIsRoomDeletedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIsRoomDeletedQuery, GetIsRoomDeletedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIsRoomDeletedQuery, GetIsRoomDeletedQueryVariables>(GetIsRoomDeletedDocument, options);
        }
// @ts-ignore
export function useGetIsRoomDeletedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIsRoomDeletedQuery, GetIsRoomDeletedQueryVariables>): Apollo.UseSuspenseQueryResult<GetIsRoomDeletedQuery, GetIsRoomDeletedQueryVariables>;
export function useGetIsRoomDeletedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIsRoomDeletedQuery, GetIsRoomDeletedQueryVariables>): Apollo.UseSuspenseQueryResult<GetIsRoomDeletedQuery | undefined, GetIsRoomDeletedQueryVariables>;
export function useGetIsRoomDeletedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIsRoomDeletedQuery, GetIsRoomDeletedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIsRoomDeletedQuery, GetIsRoomDeletedQueryVariables>(GetIsRoomDeletedDocument, options);
        }
export type GetIsRoomDeletedQueryHookResult = ReturnType<typeof useGetIsRoomDeletedQuery>;
export type GetIsRoomDeletedLazyQueryHookResult = ReturnType<typeof useGetIsRoomDeletedLazyQuery>;
export type GetIsRoomDeletedSuspenseQueryHookResult = ReturnType<typeof useGetIsRoomDeletedSuspenseQuery>;
export type GetIsRoomDeletedQueryResult = Apollo.QueryResult<GetIsRoomDeletedQuery, GetIsRoomDeletedQueryVariables>;
export const GetLatestCourseEvaluationDocument = gql`
    query GetLatestCourseEvaluation($courseId: ID!) {
  getLatestCourseEvaluation(courseId: $courseId) {
    id
    courseId
    jobId
    status
    createdAt
    overallSummary
    teacherRecommendations
    curriculumEvaluationJson
    assignmentEvaluationJson
    courseHasEvaluation {
      id
      name
      course_code
      startDate
    }
  }
}
    `;

/**
 * __useGetLatestCourseEvaluationQuery__
 *
 * To run a query within a React component, call `useGetLatestCourseEvaluationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestCourseEvaluationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestCourseEvaluationQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetLatestCourseEvaluationQuery(baseOptions: Apollo.QueryHookOptions<GetLatestCourseEvaluationQuery, GetLatestCourseEvaluationQueryVariables> & ({ variables: GetLatestCourseEvaluationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestCourseEvaluationQuery, GetLatestCourseEvaluationQueryVariables>(GetLatestCourseEvaluationDocument, options);
      }
export function useGetLatestCourseEvaluationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestCourseEvaluationQuery, GetLatestCourseEvaluationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestCourseEvaluationQuery, GetLatestCourseEvaluationQueryVariables>(GetLatestCourseEvaluationDocument, options);
        }
// @ts-ignore
export function useGetLatestCourseEvaluationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLatestCourseEvaluationQuery, GetLatestCourseEvaluationQueryVariables>): Apollo.UseSuspenseQueryResult<GetLatestCourseEvaluationQuery, GetLatestCourseEvaluationQueryVariables>;
export function useGetLatestCourseEvaluationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLatestCourseEvaluationQuery, GetLatestCourseEvaluationQueryVariables>): Apollo.UseSuspenseQueryResult<GetLatestCourseEvaluationQuery | undefined, GetLatestCourseEvaluationQueryVariables>;
export function useGetLatestCourseEvaluationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLatestCourseEvaluationQuery, GetLatestCourseEvaluationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLatestCourseEvaluationQuery, GetLatestCourseEvaluationQueryVariables>(GetLatestCourseEvaluationDocument, options);
        }
export type GetLatestCourseEvaluationQueryHookResult = ReturnType<typeof useGetLatestCourseEvaluationQuery>;
export type GetLatestCourseEvaluationLazyQueryHookResult = ReturnType<typeof useGetLatestCourseEvaluationLazyQuery>;
export type GetLatestCourseEvaluationSuspenseQueryHookResult = ReturnType<typeof useGetLatestCourseEvaluationSuspenseQuery>;
export type GetLatestCourseEvaluationQueryResult = Apollo.QueryResult<GetLatestCourseEvaluationQuery, GetLatestCourseEvaluationQueryVariables>;
export const GetUserAnnouncementsDocument = gql`
    query getUserAnnouncements($page: Int!, $pageSize: Int!) {
  getUserAnnouncements(page: $page, pageSize: $pageSize) {
    success
    message
    count
    data {
      id
      title
      message
      expirationDate
      created
      lastModified
      isActive
      isNew
      audienceType
      author {
        id
        name
      }
      courses {
        id
        name
      }
      degrees {
        id
        name
      }
      school {
        id
        provider_name
      }
    }
  }
}
    `;

/**
 * __useGetUserAnnouncementsQuery__
 *
 * To run a query within a React component, call `useGetUserAnnouncementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAnnouncementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAnnouncementsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetUserAnnouncementsQuery(baseOptions: Apollo.QueryHookOptions<GetUserAnnouncementsQuery, GetUserAnnouncementsQueryVariables> & ({ variables: GetUserAnnouncementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAnnouncementsQuery, GetUserAnnouncementsQueryVariables>(GetUserAnnouncementsDocument, options);
      }
export function useGetUserAnnouncementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAnnouncementsQuery, GetUserAnnouncementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAnnouncementsQuery, GetUserAnnouncementsQueryVariables>(GetUserAnnouncementsDocument, options);
        }
// @ts-ignore
export function useGetUserAnnouncementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserAnnouncementsQuery, GetUserAnnouncementsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserAnnouncementsQuery, GetUserAnnouncementsQueryVariables>;
export function useGetUserAnnouncementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserAnnouncementsQuery, GetUserAnnouncementsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserAnnouncementsQuery | undefined, GetUserAnnouncementsQueryVariables>;
export function useGetUserAnnouncementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserAnnouncementsQuery, GetUserAnnouncementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserAnnouncementsQuery, GetUserAnnouncementsQueryVariables>(GetUserAnnouncementsDocument, options);
        }
export type GetUserAnnouncementsQueryHookResult = ReturnType<typeof useGetUserAnnouncementsQuery>;
export type GetUserAnnouncementsLazyQueryHookResult = ReturnType<typeof useGetUserAnnouncementsLazyQuery>;
export type GetUserAnnouncementsSuspenseQueryHookResult = ReturnType<typeof useGetUserAnnouncementsSuspenseQuery>;
export type GetUserAnnouncementsQueryResult = Apollo.QueryResult<GetUserAnnouncementsQuery, GetUserAnnouncementsQueryVariables>;
export const GetUserSubmissionsDocument = gql`
    query getUserSubmissions($assignmentId: ID!) {
  getUserSubmissions(assignmentId: $assignmentId) {
    success
    message
    data {
      id
      isCompleted
      completedAt
      hasTeacherGraded
      grade
      feedback
      created
      files {
        id
        fileName
        fileURL
        created
        status
      }
    }
  }
}
    `;

/**
 * __useGetUserSubmissionsQuery__
 *
 * To run a query within a React component, call `useGetUserSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSubmissionsQuery({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function useGetUserSubmissionsQuery(baseOptions: Apollo.QueryHookOptions<GetUserSubmissionsQuery, GetUserSubmissionsQueryVariables> & ({ variables: GetUserSubmissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserSubmissionsQuery, GetUserSubmissionsQueryVariables>(GetUserSubmissionsDocument, options);
      }
export function useGetUserSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserSubmissionsQuery, GetUserSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserSubmissionsQuery, GetUserSubmissionsQueryVariables>(GetUserSubmissionsDocument, options);
        }
// @ts-ignore
export function useGetUserSubmissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserSubmissionsQuery, GetUserSubmissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserSubmissionsQuery, GetUserSubmissionsQueryVariables>;
export function useGetUserSubmissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserSubmissionsQuery, GetUserSubmissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserSubmissionsQuery | undefined, GetUserSubmissionsQueryVariables>;
export function useGetUserSubmissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserSubmissionsQuery, GetUserSubmissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserSubmissionsQuery, GetUserSubmissionsQueryVariables>(GetUserSubmissionsDocument, options);
        }
export type GetUserSubmissionsQueryHookResult = ReturnType<typeof useGetUserSubmissionsQuery>;
export type GetUserSubmissionsLazyQueryHookResult = ReturnType<typeof useGetUserSubmissionsLazyQuery>;
export type GetUserSubmissionsSuspenseQueryHookResult = ReturnType<typeof useGetUserSubmissionsSuspenseQuery>;
export type GetUserSubmissionsQueryResult = Apollo.QueryResult<GetUserSubmissionsQuery, GetUserSubmissionsQueryVariables>;
export const GetWorksheetDocument = gql`
    query getWorksheet($id: ID!) {
  getWorksheet(id: $id) {
    success
    message
    data {
      worksheetId
      pdfUrl
      generationStatus
    }
  }
}
    `;

/**
 * __useGetWorksheetQuery__
 *
 * To run a query within a React component, call `useGetWorksheetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorksheetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorksheetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWorksheetQuery(baseOptions: Apollo.QueryHookOptions<GetWorksheetQuery, GetWorksheetQueryVariables> & ({ variables: GetWorksheetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorksheetQuery, GetWorksheetQueryVariables>(GetWorksheetDocument, options);
      }
export function useGetWorksheetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorksheetQuery, GetWorksheetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorksheetQuery, GetWorksheetQueryVariables>(GetWorksheetDocument, options);
        }
// @ts-ignore
export function useGetWorksheetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorksheetQuery, GetWorksheetQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorksheetQuery, GetWorksheetQueryVariables>;
export function useGetWorksheetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorksheetQuery, GetWorksheetQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorksheetQuery | undefined, GetWorksheetQueryVariables>;
export function useGetWorksheetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorksheetQuery, GetWorksheetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorksheetQuery, GetWorksheetQueryVariables>(GetWorksheetDocument, options);
        }
export type GetWorksheetQueryHookResult = ReturnType<typeof useGetWorksheetQuery>;
export type GetWorksheetLazyQueryHookResult = ReturnType<typeof useGetWorksheetLazyQuery>;
export type GetWorksheetSuspenseQueryHookResult = ReturnType<typeof useGetWorksheetSuspenseQuery>;
export type GetWorksheetQueryResult = Apollo.QueryResult<GetWorksheetQuery, GetWorksheetQueryVariables>;
export const GetProjectDocument = gql`
    query GetProject($id: ID!) {
  getProject(id: $id) {
    success
    message
    data {
      id
      moduleId
      order
      name
      description
      scopeDocument
      deliverableTypes
      assessmentCriteria
      expectedOutcomes
      status
      dueDate
      created
      lastModified
      files {
        id
        fileName
        fileURL
        created
        status
      }
    }
  }
}
    `;

/**
 * __useGetProjectQuery__
 *
 * To run a query within a React component, call `useGetProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectQuery(baseOptions: Apollo.QueryHookOptions<GetProjectQuery, GetProjectQueryVariables> & ({ variables: GetProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
      }
export function useGetProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
        }
// @ts-ignore
export function useGetProjectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectQuery, GetProjectQueryVariables>;
export function useGetProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectQuery | undefined, GetProjectQueryVariables>;
export function useGetProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
        }
export type GetProjectQueryHookResult = ReturnType<typeof useGetProjectQuery>;
export type GetProjectLazyQueryHookResult = ReturnType<typeof useGetProjectLazyQuery>;
export type GetProjectSuspenseQueryHookResult = ReturnType<typeof useGetProjectSuspenseQuery>;
export type GetProjectQueryResult = Apollo.QueryResult<GetProjectQuery, GetProjectQueryVariables>;
export const GetProjectFrameworkDocument = gql`
    query GetProjectFramework($id: ID!) {
  getProject(id: $id) {
    success
    message
    data {
      id
      moduleId
      order
      name
      description
      scopeDocument
      deliverableTypes
      assessmentCriteria
      expectedOutcomes
      status
      dueDate
      created
      lastModified
      files {
        id
        fileName
        fileURL
        created
        status
      }
    }
  }
}
    `;

/**
 * __useGetProjectFrameworkQuery__
 *
 * To run a query within a React component, call `useGetProjectFrameworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectFrameworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectFrameworkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectFrameworkQuery(baseOptions: Apollo.QueryHookOptions<GetProjectFrameworkQuery, GetProjectFrameworkQueryVariables> & ({ variables: GetProjectFrameworkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectFrameworkQuery, GetProjectFrameworkQueryVariables>(GetProjectFrameworkDocument, options);
      }
export function useGetProjectFrameworkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectFrameworkQuery, GetProjectFrameworkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectFrameworkQuery, GetProjectFrameworkQueryVariables>(GetProjectFrameworkDocument, options);
        }
// @ts-ignore
export function useGetProjectFrameworkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectFrameworkQuery, GetProjectFrameworkQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectFrameworkQuery, GetProjectFrameworkQueryVariables>;
export function useGetProjectFrameworkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectFrameworkQuery, GetProjectFrameworkQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectFrameworkQuery | undefined, GetProjectFrameworkQueryVariables>;
export function useGetProjectFrameworkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectFrameworkQuery, GetProjectFrameworkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectFrameworkQuery, GetProjectFrameworkQueryVariables>(GetProjectFrameworkDocument, options);
        }
export type GetProjectFrameworkQueryHookResult = ReturnType<typeof useGetProjectFrameworkQuery>;
export type GetProjectFrameworkLazyQueryHookResult = ReturnType<typeof useGetProjectFrameworkLazyQuery>;
export type GetProjectFrameworkSuspenseQueryHookResult = ReturnType<typeof useGetProjectFrameworkSuspenseQuery>;
export type GetProjectFrameworkQueryResult = Apollo.QueryResult<GetProjectFrameworkQuery, GetProjectFrameworkQueryVariables>;
export const GetProjectsByStudentDocument = gql`
    query GetProjectsByStudent($page: Int, $pageSize: Int) {
  getProjectsByStudent(page: $page, pageSize: $pageSize) {
    success
    message
    data {
      id
      moduleId
      order
      name
      description
      scopeDocument
      deliverableTypes
      assessmentCriteria
      expectedOutcomes
      status
      dueDate
      created
      lastModified
      files {
        id
        fileName
        fileURL
        created
        status
      }
    }
  }
}
    `;

/**
 * __useGetProjectsByStudentQuery__
 *
 * To run a query within a React component, call `useGetProjectsByStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectsByStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectsByStudentQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetProjectsByStudentQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectsByStudentQuery, GetProjectsByStudentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectsByStudentQuery, GetProjectsByStudentQueryVariables>(GetProjectsByStudentDocument, options);
      }
export function useGetProjectsByStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectsByStudentQuery, GetProjectsByStudentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectsByStudentQuery, GetProjectsByStudentQueryVariables>(GetProjectsByStudentDocument, options);
        }
// @ts-ignore
export function useGetProjectsByStudentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectsByStudentQuery, GetProjectsByStudentQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectsByStudentQuery, GetProjectsByStudentQueryVariables>;
export function useGetProjectsByStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectsByStudentQuery, GetProjectsByStudentQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectsByStudentQuery | undefined, GetProjectsByStudentQueryVariables>;
export function useGetProjectsByStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectsByStudentQuery, GetProjectsByStudentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectsByStudentQuery, GetProjectsByStudentQueryVariables>(GetProjectsByStudentDocument, options);
        }
export type GetProjectsByStudentQueryHookResult = ReturnType<typeof useGetProjectsByStudentQuery>;
export type GetProjectsByStudentLazyQueryHookResult = ReturnType<typeof useGetProjectsByStudentLazyQuery>;
export type GetProjectsByStudentSuspenseQueryHookResult = ReturnType<typeof useGetProjectsByStudentSuspenseQuery>;
export type GetProjectsByStudentQueryResult = Apollo.QueryResult<GetProjectsByStudentQuery, GetProjectsByStudentQueryVariables>;
export const GetProjectSubmissionDocument = gql`
    query GetProjectSubmission($id: ID!) {
  getProjectSubmission(id: $id) {
    success
    message
    data {
      id
      proposal
      approachMethodology
      scopeJustification
      expectedOutcomes
      status
      vettingStatus
      complianceScore
      aiAssessment
      suggestedImprovements
      grade
      hasTeacherGraded
      isCompleted
      completedAt
      gradedAt
      feedback
      created
      lastModified
      totalTasks
      completedTasks
      submissionLink
      submissionNotes
      files {
        id
        fileName
        fileURL
        created
        status
      }
      requirements {
        id
        title
        description
        type
        priority
        completed
      }
      project {
        id
        moduleId
        order
        name
        description
        scopeDocument
        deliverableTypes
        assessmentCriteria
        expectedOutcomes
        status
        dueDate
        created
        lastModified
      }
      user {
        id
      }
    }
  }
}
    `;

/**
 * __useGetProjectSubmissionQuery__
 *
 * To run a query within a React component, call `useGetProjectSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectSubmissionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectSubmissionQuery(baseOptions: Apollo.QueryHookOptions<GetProjectSubmissionQuery, GetProjectSubmissionQueryVariables> & ({ variables: GetProjectSubmissionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectSubmissionQuery, GetProjectSubmissionQueryVariables>(GetProjectSubmissionDocument, options);
      }
export function useGetProjectSubmissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectSubmissionQuery, GetProjectSubmissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectSubmissionQuery, GetProjectSubmissionQueryVariables>(GetProjectSubmissionDocument, options);
        }
// @ts-ignore
export function useGetProjectSubmissionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectSubmissionQuery, GetProjectSubmissionQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectSubmissionQuery, GetProjectSubmissionQueryVariables>;
export function useGetProjectSubmissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectSubmissionQuery, GetProjectSubmissionQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectSubmissionQuery | undefined, GetProjectSubmissionQueryVariables>;
export function useGetProjectSubmissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectSubmissionQuery, GetProjectSubmissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectSubmissionQuery, GetProjectSubmissionQueryVariables>(GetProjectSubmissionDocument, options);
        }
export type GetProjectSubmissionQueryHookResult = ReturnType<typeof useGetProjectSubmissionQuery>;
export type GetProjectSubmissionLazyQueryHookResult = ReturnType<typeof useGetProjectSubmissionLazyQuery>;
export type GetProjectSubmissionSuspenseQueryHookResult = ReturnType<typeof useGetProjectSubmissionSuspenseQuery>;
export type GetProjectSubmissionQueryResult = Apollo.QueryResult<GetProjectSubmissionQuery, GetProjectSubmissionQueryVariables>;
export const GetProjectSubmissionsByProjectDocument = gql`
    query GetProjectSubmissionsByProject($projectId: ID!) {
  getProjectSubmissionsByProject(projectId: $projectId) {
    success
    message
    data {
      id
      proposal
      approachMethodology
      scopeJustification
      expectedOutcomes
      status
      vettingStatus
      complianceScore
      aiAssessment
      suggestedImprovements
      grade
      hasTeacherGraded
      isCompleted
      completedAt
      gradedAt
      feedback
      created
      lastModified
      totalTasks
      completedTasks
      submissionLink
      submissionNotes
      files {
        id
        fileName
        fileURL
        created
        status
      }
      requirements {
        id
        title
        description
        type
        priority
        category
        estimatedHours
        completed
      }
      project {
        id
        moduleId
        order
        name
        description
        scopeDocument
        deliverableTypes
        assessmentCriteria
        expectedOutcomes
        status
        dueDate
        created
        lastModified
        files {
          id
          fileName
          fileURL
          created
          status
        }
      }
      user {
        id
      }
    }
  }
}
    `;

/**
 * __useGetProjectSubmissionsByProjectQuery__
 *
 * To run a query within a React component, call `useGetProjectSubmissionsByProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectSubmissionsByProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectSubmissionsByProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectSubmissionsByProjectQuery(baseOptions: Apollo.QueryHookOptions<GetProjectSubmissionsByProjectQuery, GetProjectSubmissionsByProjectQueryVariables> & ({ variables: GetProjectSubmissionsByProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectSubmissionsByProjectQuery, GetProjectSubmissionsByProjectQueryVariables>(GetProjectSubmissionsByProjectDocument, options);
      }
export function useGetProjectSubmissionsByProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectSubmissionsByProjectQuery, GetProjectSubmissionsByProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectSubmissionsByProjectQuery, GetProjectSubmissionsByProjectQueryVariables>(GetProjectSubmissionsByProjectDocument, options);
        }
// @ts-ignore
export function useGetProjectSubmissionsByProjectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectSubmissionsByProjectQuery, GetProjectSubmissionsByProjectQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectSubmissionsByProjectQuery, GetProjectSubmissionsByProjectQueryVariables>;
export function useGetProjectSubmissionsByProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectSubmissionsByProjectQuery, GetProjectSubmissionsByProjectQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectSubmissionsByProjectQuery | undefined, GetProjectSubmissionsByProjectQueryVariables>;
export function useGetProjectSubmissionsByProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectSubmissionsByProjectQuery, GetProjectSubmissionsByProjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectSubmissionsByProjectQuery, GetProjectSubmissionsByProjectQueryVariables>(GetProjectSubmissionsByProjectDocument, options);
        }
export type GetProjectSubmissionsByProjectQueryHookResult = ReturnType<typeof useGetProjectSubmissionsByProjectQuery>;
export type GetProjectSubmissionsByProjectLazyQueryHookResult = ReturnType<typeof useGetProjectSubmissionsByProjectLazyQuery>;
export type GetProjectSubmissionsByProjectSuspenseQueryHookResult = ReturnType<typeof useGetProjectSubmissionsByProjectSuspenseQuery>;
export type GetProjectSubmissionsByProjectQueryResult = Apollo.QueryResult<GetProjectSubmissionsByProjectQuery, GetProjectSubmissionsByProjectQueryVariables>;
export const GetProjectSubmissionsByStudentDocument = gql`
    query GetProjectSubmissionsByStudent($studentId: ID!) {
  getProjectSubmissionsByStudent(studentId: $studentId) {
    success
    message
    data {
      id
      proposal
      approachMethodology
      scopeJustification
      expectedOutcomes
      status
      vettingStatus
      complianceScore
      aiAssessment
      suggestedImprovements
      grade
      hasTeacherGraded
      isCompleted
      completedAt
      created
      lastModified
      totalTasks
      completedTasks
      requirements {
        id
        title
        description
        type
        priority
        completed
      }
      project {
        id
        moduleId
        order
        name
        description
        scopeDocument
        deliverableTypes
        assessmentCriteria
        expectedOutcomes
        status
        dueDate
        created
        lastModified
        files {
          id
          fileName
          fileURL
          created
          status
        }
      }
      user {
        id
      }
    }
  }
}
    `;

/**
 * __useGetProjectSubmissionsByStudentQuery__
 *
 * To run a query within a React component, call `useGetProjectSubmissionsByStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectSubmissionsByStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectSubmissionsByStudentQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useGetProjectSubmissionsByStudentQuery(baseOptions: Apollo.QueryHookOptions<GetProjectSubmissionsByStudentQuery, GetProjectSubmissionsByStudentQueryVariables> & ({ variables: GetProjectSubmissionsByStudentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectSubmissionsByStudentQuery, GetProjectSubmissionsByStudentQueryVariables>(GetProjectSubmissionsByStudentDocument, options);
      }
export function useGetProjectSubmissionsByStudentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectSubmissionsByStudentQuery, GetProjectSubmissionsByStudentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectSubmissionsByStudentQuery, GetProjectSubmissionsByStudentQueryVariables>(GetProjectSubmissionsByStudentDocument, options);
        }
// @ts-ignore
export function useGetProjectSubmissionsByStudentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectSubmissionsByStudentQuery, GetProjectSubmissionsByStudentQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectSubmissionsByStudentQuery, GetProjectSubmissionsByStudentQueryVariables>;
export function useGetProjectSubmissionsByStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectSubmissionsByStudentQuery, GetProjectSubmissionsByStudentQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectSubmissionsByStudentQuery | undefined, GetProjectSubmissionsByStudentQueryVariables>;
export function useGetProjectSubmissionsByStudentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectSubmissionsByStudentQuery, GetProjectSubmissionsByStudentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectSubmissionsByStudentQuery, GetProjectSubmissionsByStudentQueryVariables>(GetProjectSubmissionsByStudentDocument, options);
        }
export type GetProjectSubmissionsByStudentQueryHookResult = ReturnType<typeof useGetProjectSubmissionsByStudentQuery>;
export type GetProjectSubmissionsByStudentLazyQueryHookResult = ReturnType<typeof useGetProjectSubmissionsByStudentLazyQuery>;
export type GetProjectSubmissionsByStudentSuspenseQueryHookResult = ReturnType<typeof useGetProjectSubmissionsByStudentSuspenseQuery>;
export type GetProjectSubmissionsByStudentQueryResult = Apollo.QueryResult<GetProjectSubmissionsByStudentQuery, GetProjectSubmissionsByStudentQueryVariables>;
export const CreateProjectDocument = gql`
    mutation CreateProject($project: CreateProjectInput!) {
  createProject(project: $project) {
    success
    message
    data {
      id
      moduleId
      order
      name
      description
      scopeDocument
      deliverableTypes
      assessmentCriteria
      expectedOutcomes
      status
      dueDate
      created
      lastModified
    }
  }
}
    `;
export type CreateProjectMutationFn = Apollo.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      project: // value for 'project'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, options);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const UpdateProjectDocument = gql`
    mutation UpdateProject($id: ID!, $project: UpdateProjectInput!) {
  updateProject(id: $id, project: $project) {
    success
    message
    data {
      id
      moduleId
      order
      name
      description
      scopeDocument
      deliverableTypes
      assessmentCriteria
      expectedOutcomes
      status
      dueDate
      lastModified
    }
  }
}
    `;
export type UpdateProjectMutationFn = Apollo.MutationFunction<UpdateProjectMutation, UpdateProjectMutationVariables>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      project: // value for 'project'
 *   },
 * });
 */
export function useUpdateProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, options);
      }
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>;
export type UpdateProjectMutationResult = Apollo.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const DeleteProjectDocument = gql`
    mutation DeleteProject($id: ID!) {
  deleteProject(id: $id) {
    success
    message
    data {
      id
    }
  }
}
    `;
export type DeleteProjectMutationFn = Apollo.MutationFunction<DeleteProjectMutation, DeleteProjectMutationVariables>;

/**
 * __useDeleteProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMutation, { data, loading, error }] = useDeleteProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectMutation, DeleteProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectMutation, DeleteProjectMutationVariables>(DeleteProjectDocument, options);
      }
export type DeleteProjectMutationHookResult = ReturnType<typeof useDeleteProjectMutation>;
export type DeleteProjectMutationResult = Apollo.MutationResult<DeleteProjectMutation>;
export type DeleteProjectMutationOptions = Apollo.BaseMutationOptions<DeleteProjectMutation, DeleteProjectMutationVariables>;
export const CreateProjectSubmissionDocument = gql`
    mutation CreateProjectSubmission($submission: CreateProjectSubmissionInput!) {
  createProjectSubmission(submission: $submission) {
    success
    message
    data {
      id
      proposal
      approachMethodology
      scopeJustification
      expectedOutcomes
      status
      vettingStatus
      created
      lastModified
    }
  }
}
    `;
export type CreateProjectSubmissionMutationFn = Apollo.MutationFunction<CreateProjectSubmissionMutation, CreateProjectSubmissionMutationVariables>;

/**
 * __useCreateProjectSubmissionMutation__
 *
 * To run a mutation, you first call `useCreateProjectSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectSubmissionMutation, { data, loading, error }] = useCreateProjectSubmissionMutation({
 *   variables: {
 *      submission: // value for 'submission'
 *   },
 * });
 */
export function useCreateProjectSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectSubmissionMutation, CreateProjectSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectSubmissionMutation, CreateProjectSubmissionMutationVariables>(CreateProjectSubmissionDocument, options);
      }
export type CreateProjectSubmissionMutationHookResult = ReturnType<typeof useCreateProjectSubmissionMutation>;
export type CreateProjectSubmissionMutationResult = Apollo.MutationResult<CreateProjectSubmissionMutation>;
export type CreateProjectSubmissionMutationOptions = Apollo.BaseMutationOptions<CreateProjectSubmissionMutation, CreateProjectSubmissionMutationVariables>;
export const UpdateProjectSubmissionDocument = gql`
    mutation UpdateProjectSubmission($id: ID!, $submission: UpdateProjectSubmissionInput!) {
  updateProjectSubmission(id: $id, submission: $submission) {
    success
    message
    data {
      id
      proposal
      approachMethodology
      scopeJustification
      expectedOutcomes
      status
      vettingStatus
      lastModified
    }
  }
}
    `;
export type UpdateProjectSubmissionMutationFn = Apollo.MutationFunction<UpdateProjectSubmissionMutation, UpdateProjectSubmissionMutationVariables>;

/**
 * __useUpdateProjectSubmissionMutation__
 *
 * To run a mutation, you first call `useUpdateProjectSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectSubmissionMutation, { data, loading, error }] = useUpdateProjectSubmissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      submission: // value for 'submission'
 *   },
 * });
 */
export function useUpdateProjectSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectSubmissionMutation, UpdateProjectSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectSubmissionMutation, UpdateProjectSubmissionMutationVariables>(UpdateProjectSubmissionDocument, options);
      }
export type UpdateProjectSubmissionMutationHookResult = ReturnType<typeof useUpdateProjectSubmissionMutation>;
export type UpdateProjectSubmissionMutationResult = Apollo.MutationResult<UpdateProjectSubmissionMutation>;
export type UpdateProjectSubmissionMutationOptions = Apollo.BaseMutationOptions<UpdateProjectSubmissionMutation, UpdateProjectSubmissionMutationVariables>;
export const SubmitProjectForReviewDocument = gql`
    mutation SubmitProjectForReview($submissionId: ID!) {
  submitProjectForReview(submissionId: $submissionId) {
    success
    message
    data {
      id
      status
      vettingStatus
      complianceScore
      aiAssessment
      suggestedImprovements
      lastModified
    }
  }
}
    `;
export type SubmitProjectForReviewMutationFn = Apollo.MutationFunction<SubmitProjectForReviewMutation, SubmitProjectForReviewMutationVariables>;

/**
 * __useSubmitProjectForReviewMutation__
 *
 * To run a mutation, you first call `useSubmitProjectForReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitProjectForReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitProjectForReviewMutation, { data, loading, error }] = useSubmitProjectForReviewMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useSubmitProjectForReviewMutation(baseOptions?: Apollo.MutationHookOptions<SubmitProjectForReviewMutation, SubmitProjectForReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitProjectForReviewMutation, SubmitProjectForReviewMutationVariables>(SubmitProjectForReviewDocument, options);
      }
export type SubmitProjectForReviewMutationHookResult = ReturnType<typeof useSubmitProjectForReviewMutation>;
export type SubmitProjectForReviewMutationResult = Apollo.MutationResult<SubmitProjectForReviewMutation>;
export type SubmitProjectForReviewMutationOptions = Apollo.BaseMutationOptions<SubmitProjectForReviewMutation, SubmitProjectForReviewMutationVariables>;
export const ApproveProjectSubmissionDocument = gql`
    mutation ApproveProjectSubmission($submissionId: ID!) {
  approveProjectSubmission(submissionId: $submissionId) {
    success
    message
    data {
      id
      status
      lastModified
    }
  }
}
    `;
export type ApproveProjectSubmissionMutationFn = Apollo.MutationFunction<ApproveProjectSubmissionMutation, ApproveProjectSubmissionMutationVariables>;

/**
 * __useApproveProjectSubmissionMutation__
 *
 * To run a mutation, you first call `useApproveProjectSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveProjectSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveProjectSubmissionMutation, { data, loading, error }] = useApproveProjectSubmissionMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useApproveProjectSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<ApproveProjectSubmissionMutation, ApproveProjectSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveProjectSubmissionMutation, ApproveProjectSubmissionMutationVariables>(ApproveProjectSubmissionDocument, options);
      }
export type ApproveProjectSubmissionMutationHookResult = ReturnType<typeof useApproveProjectSubmissionMutation>;
export type ApproveProjectSubmissionMutationResult = Apollo.MutationResult<ApproveProjectSubmissionMutation>;
export type ApproveProjectSubmissionMutationOptions = Apollo.BaseMutationOptions<ApproveProjectSubmissionMutation, ApproveProjectSubmissionMutationVariables>;
export const RejectProjectSubmissionDocument = gql`
    mutation RejectProjectSubmission($submissionId: ID!, $reason: String!) {
  rejectProjectSubmission(submissionId: $submissionId, reason: $reason) {
    success
    message
    data {
      id
      status
      lastModified
    }
  }
}
    `;
export type RejectProjectSubmissionMutationFn = Apollo.MutationFunction<RejectProjectSubmissionMutation, RejectProjectSubmissionMutationVariables>;

/**
 * __useRejectProjectSubmissionMutation__
 *
 * To run a mutation, you first call `useRejectProjectSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectProjectSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectProjectSubmissionMutation, { data, loading, error }] = useRejectProjectSubmissionMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useRejectProjectSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<RejectProjectSubmissionMutation, RejectProjectSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectProjectSubmissionMutation, RejectProjectSubmissionMutationVariables>(RejectProjectSubmissionDocument, options);
      }
export type RejectProjectSubmissionMutationHookResult = ReturnType<typeof useRejectProjectSubmissionMutation>;
export type RejectProjectSubmissionMutationResult = Apollo.MutationResult<RejectProjectSubmissionMutation>;
export type RejectProjectSubmissionMutationOptions = Apollo.BaseMutationOptions<RejectProjectSubmissionMutation, RejectProjectSubmissionMutationVariables>;
export const GradeProjectSubmissionDocument = gql`
    mutation GradeProjectSubmission($submissionId: ID!, $grade: Float!, $feedback: String) {
  gradeProjectSubmission(
    submissionId: $submissionId
    grade: $grade
    feedback: $feedback
  ) {
    success
    message
    data {
      id
      grade
      hasTeacherGraded
      isCompleted
      completedAt
      lastModified
    }
  }
}
    `;
export type GradeProjectSubmissionMutationFn = Apollo.MutationFunction<GradeProjectSubmissionMutation, GradeProjectSubmissionMutationVariables>;

/**
 * __useGradeProjectSubmissionMutation__
 *
 * To run a mutation, you first call `useGradeProjectSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGradeProjectSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gradeProjectSubmissionMutation, { data, loading, error }] = useGradeProjectSubmissionMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *      grade: // value for 'grade'
 *      feedback: // value for 'feedback'
 *   },
 * });
 */
export function useGradeProjectSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<GradeProjectSubmissionMutation, GradeProjectSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GradeProjectSubmissionMutation, GradeProjectSubmissionMutationVariables>(GradeProjectSubmissionDocument, options);
      }
export type GradeProjectSubmissionMutationHookResult = ReturnType<typeof useGradeProjectSubmissionMutation>;
export type GradeProjectSubmissionMutationResult = Apollo.MutationResult<GradeProjectSubmissionMutation>;
export type GradeProjectSubmissionMutationOptions = Apollo.BaseMutationOptions<GradeProjectSubmissionMutation, GradeProjectSubmissionMutationVariables>;
export const ResubmitProjectProposalDocument = gql`
    mutation ResubmitProjectProposal($submissionId: ID!, $submission: UpdateProjectSubmissionInput!) {
  resubmitProjectProposal(submissionId: $submissionId, submission: $submission) {
    success
    message
    data {
      id
      proposal
      approachMethodology
      scopeJustification
      expectedOutcomes
      status
      vettingStatus
      lastModified
    }
  }
}
    `;
export type ResubmitProjectProposalMutationFn = Apollo.MutationFunction<ResubmitProjectProposalMutation, ResubmitProjectProposalMutationVariables>;

/**
 * __useResubmitProjectProposalMutation__
 *
 * To run a mutation, you first call `useResubmitProjectProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResubmitProjectProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resubmitProjectProposalMutation, { data, loading, error }] = useResubmitProjectProposalMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *      submission: // value for 'submission'
 *   },
 * });
 */
export function useResubmitProjectProposalMutation(baseOptions?: Apollo.MutationHookOptions<ResubmitProjectProposalMutation, ResubmitProjectProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResubmitProjectProposalMutation, ResubmitProjectProposalMutationVariables>(ResubmitProjectProposalDocument, options);
      }
export type ResubmitProjectProposalMutationHookResult = ReturnType<typeof useResubmitProjectProposalMutation>;
export type ResubmitProjectProposalMutationResult = Apollo.MutationResult<ResubmitProjectProposalMutation>;
export type ResubmitProjectProposalMutationOptions = Apollo.BaseMutationOptions<ResubmitProjectProposalMutation, ResubmitProjectProposalMutationVariables>;
export const GetActiveProjectsDocument = gql`
    query GetActiveProjects {
  getProjectsByStudent {
    success
    message
    data {
      id
      moduleId
      order
      name
      description
      scopeDocument
      status
      dueDate
      created
      lastModified
      submissions {
        id
        status
        vettingStatus
        complianceScore
        requirements {
          id
          title
          description
          type
          priority
          completed
        }
        completedTasks
        totalTasks
      }
    }
  }
}
    `;

/**
 * __useGetActiveProjectsQuery__
 *
 * To run a query within a React component, call `useGetActiveProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveProjectsQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveProjectsQuery, GetActiveProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveProjectsQuery, GetActiveProjectsQueryVariables>(GetActiveProjectsDocument, options);
      }
export function useGetActiveProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveProjectsQuery, GetActiveProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveProjectsQuery, GetActiveProjectsQueryVariables>(GetActiveProjectsDocument, options);
        }
// @ts-ignore
export function useGetActiveProjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActiveProjectsQuery, GetActiveProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<GetActiveProjectsQuery, GetActiveProjectsQueryVariables>;
export function useGetActiveProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveProjectsQuery, GetActiveProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<GetActiveProjectsQuery | undefined, GetActiveProjectsQueryVariables>;
export function useGetActiveProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveProjectsQuery, GetActiveProjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveProjectsQuery, GetActiveProjectsQueryVariables>(GetActiveProjectsDocument, options);
        }
export type GetActiveProjectsQueryHookResult = ReturnType<typeof useGetActiveProjectsQuery>;
export type GetActiveProjectsLazyQueryHookResult = ReturnType<typeof useGetActiveProjectsLazyQuery>;
export type GetActiveProjectsSuspenseQueryHookResult = ReturnType<typeof useGetActiveProjectsSuspenseQuery>;
export type GetActiveProjectsQueryResult = Apollo.QueryResult<GetActiveProjectsQuery, GetActiveProjectsQueryVariables>;
export const GetSubmissionRequirementsDocument = gql`
    query GetSubmissionRequirements($submissionId: ID!) {
  getSubmissionRequirements(submissionId: $submissionId) {
    success
    message
    data {
      id
      title
      description
      type
      priority
      estimatedHours
      dueDate
      dependencies
      order
      completed
      completedDate
      isGenerated
      aiRationale
      created
      lastModified
    }
  }
}
    `;

/**
 * __useGetSubmissionRequirementsQuery__
 *
 * To run a query within a React component, call `useGetSubmissionRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubmissionRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubmissionRequirementsQuery({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useGetSubmissionRequirementsQuery(baseOptions: Apollo.QueryHookOptions<GetSubmissionRequirementsQuery, GetSubmissionRequirementsQueryVariables> & ({ variables: GetSubmissionRequirementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubmissionRequirementsQuery, GetSubmissionRequirementsQueryVariables>(GetSubmissionRequirementsDocument, options);
      }
export function useGetSubmissionRequirementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubmissionRequirementsQuery, GetSubmissionRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubmissionRequirementsQuery, GetSubmissionRequirementsQueryVariables>(GetSubmissionRequirementsDocument, options);
        }
// @ts-ignore
export function useGetSubmissionRequirementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSubmissionRequirementsQuery, GetSubmissionRequirementsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubmissionRequirementsQuery, GetSubmissionRequirementsQueryVariables>;
export function useGetSubmissionRequirementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubmissionRequirementsQuery, GetSubmissionRequirementsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubmissionRequirementsQuery | undefined, GetSubmissionRequirementsQueryVariables>;
export function useGetSubmissionRequirementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubmissionRequirementsQuery, GetSubmissionRequirementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubmissionRequirementsQuery, GetSubmissionRequirementsQueryVariables>(GetSubmissionRequirementsDocument, options);
        }
export type GetSubmissionRequirementsQueryHookResult = ReturnType<typeof useGetSubmissionRequirementsQuery>;
export type GetSubmissionRequirementsLazyQueryHookResult = ReturnType<typeof useGetSubmissionRequirementsLazyQuery>;
export type GetSubmissionRequirementsSuspenseQueryHookResult = ReturnType<typeof useGetSubmissionRequirementsSuspenseQuery>;
export type GetSubmissionRequirementsQueryResult = Apollo.QueryResult<GetSubmissionRequirementsQuery, GetSubmissionRequirementsQueryVariables>;
export const CreateProjectRequirementDocument = gql`
    mutation CreateProjectRequirement($requirement: CreateProjectRequirementInput!) {
  createProjectRequirement(requirement: $requirement) {
    success
    message
    data {
      id
      title
      description
      type
      priority
      estimatedHours
      dueDate
      dependencies
      completed
      isGenerated
      aiRationale
      created
      lastModified
    }
  }
}
    `;
export type CreateProjectRequirementMutationFn = Apollo.MutationFunction<CreateProjectRequirementMutation, CreateProjectRequirementMutationVariables>;

/**
 * __useCreateProjectRequirementMutation__
 *
 * To run a mutation, you first call `useCreateProjectRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectRequirementMutation, { data, loading, error }] = useCreateProjectRequirementMutation({
 *   variables: {
 *      requirement: // value for 'requirement'
 *   },
 * });
 */
export function useCreateProjectRequirementMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectRequirementMutation, CreateProjectRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectRequirementMutation, CreateProjectRequirementMutationVariables>(CreateProjectRequirementDocument, options);
      }
export type CreateProjectRequirementMutationHookResult = ReturnType<typeof useCreateProjectRequirementMutation>;
export type CreateProjectRequirementMutationResult = Apollo.MutationResult<CreateProjectRequirementMutation>;
export type CreateProjectRequirementMutationOptions = Apollo.BaseMutationOptions<CreateProjectRequirementMutation, CreateProjectRequirementMutationVariables>;
export const UpdateProjectRequirementDocument = gql`
    mutation UpdateProjectRequirement($id: ID!, $requirement: UpdateProjectRequirementInput!) {
  updateProjectRequirement(id: $id, requirement: $requirement) {
    success
    message
    data {
      id
      title
      description
      type
      priority
      estimatedHours
      dueDate
      dependencies
      completed
      completedDate
      lastModified
    }
  }
}
    `;
export type UpdateProjectRequirementMutationFn = Apollo.MutationFunction<UpdateProjectRequirementMutation, UpdateProjectRequirementMutationVariables>;

/**
 * __useUpdateProjectRequirementMutation__
 *
 * To run a mutation, you first call `useUpdateProjectRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectRequirementMutation, { data, loading, error }] = useUpdateProjectRequirementMutation({
 *   variables: {
 *      id: // value for 'id'
 *      requirement: // value for 'requirement'
 *   },
 * });
 */
export function useUpdateProjectRequirementMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectRequirementMutation, UpdateProjectRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectRequirementMutation, UpdateProjectRequirementMutationVariables>(UpdateProjectRequirementDocument, options);
      }
export type UpdateProjectRequirementMutationHookResult = ReturnType<typeof useUpdateProjectRequirementMutation>;
export type UpdateProjectRequirementMutationResult = Apollo.MutationResult<UpdateProjectRequirementMutation>;
export type UpdateProjectRequirementMutationOptions = Apollo.BaseMutationOptions<UpdateProjectRequirementMutation, UpdateProjectRequirementMutationVariables>;
export const MarkProjectRequirementCompleteDocument = gql`
    mutation MarkProjectRequirementComplete($id: ID!) {
  markProjectRequirementComplete(id: $id) {
    success
    message
    data {
      id
      completed
      completedDate
      lastModified
    }
  }
}
    `;
export type MarkProjectRequirementCompleteMutationFn = Apollo.MutationFunction<MarkProjectRequirementCompleteMutation, MarkProjectRequirementCompleteMutationVariables>;

/**
 * __useMarkProjectRequirementCompleteMutation__
 *
 * To run a mutation, you first call `useMarkProjectRequirementCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkProjectRequirementCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markProjectRequirementCompleteMutation, { data, loading, error }] = useMarkProjectRequirementCompleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkProjectRequirementCompleteMutation(baseOptions?: Apollo.MutationHookOptions<MarkProjectRequirementCompleteMutation, MarkProjectRequirementCompleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkProjectRequirementCompleteMutation, MarkProjectRequirementCompleteMutationVariables>(MarkProjectRequirementCompleteDocument, options);
      }
export type MarkProjectRequirementCompleteMutationHookResult = ReturnType<typeof useMarkProjectRequirementCompleteMutation>;
export type MarkProjectRequirementCompleteMutationResult = Apollo.MutationResult<MarkProjectRequirementCompleteMutation>;
export type MarkProjectRequirementCompleteMutationOptions = Apollo.BaseMutationOptions<MarkProjectRequirementCompleteMutation, MarkProjectRequirementCompleteMutationVariables>;
export const DeleteProjectRequirementDocument = gql`
    mutation DeleteProjectRequirement($id: ID!) {
  deleteProjectRequirement(id: $id) {
    success
    message
    data {
      id
    }
  }
}
    `;
export type DeleteProjectRequirementMutationFn = Apollo.MutationFunction<DeleteProjectRequirementMutation, DeleteProjectRequirementMutationVariables>;

/**
 * __useDeleteProjectRequirementMutation__
 *
 * To run a mutation, you first call `useDeleteProjectRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectRequirementMutation, { data, loading, error }] = useDeleteProjectRequirementMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectRequirementMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectRequirementMutation, DeleteProjectRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectRequirementMutation, DeleteProjectRequirementMutationVariables>(DeleteProjectRequirementDocument, options);
      }
export type DeleteProjectRequirementMutationHookResult = ReturnType<typeof useDeleteProjectRequirementMutation>;
export type DeleteProjectRequirementMutationResult = Apollo.MutationResult<DeleteProjectRequirementMutation>;
export type DeleteProjectRequirementMutationOptions = Apollo.BaseMutationOptions<DeleteProjectRequirementMutation, DeleteProjectRequirementMutationVariables>;
export const GenerateProjectRequirementsDocument = gql`
    mutation GenerateProjectRequirements($projectId: ID!, $submissionId: ID!) {
  generateProjectRequirements(projectId: $projectId, submissionId: $submissionId) {
    success
    message
    data {
      id
      title
      description
      type
      priority
      estimatedHours
      dueDate
      dependencies
      completed
      isGenerated
      aiRationale
      created
      lastModified
    }
  }
}
    `;
export type GenerateProjectRequirementsMutationFn = Apollo.MutationFunction<GenerateProjectRequirementsMutation, GenerateProjectRequirementsMutationVariables>;

/**
 * __useGenerateProjectRequirementsMutation__
 *
 * To run a mutation, you first call `useGenerateProjectRequirementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateProjectRequirementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateProjectRequirementsMutation, { data, loading, error }] = useGenerateProjectRequirementsMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useGenerateProjectRequirementsMutation(baseOptions?: Apollo.MutationHookOptions<GenerateProjectRequirementsMutation, GenerateProjectRequirementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateProjectRequirementsMutation, GenerateProjectRequirementsMutationVariables>(GenerateProjectRequirementsDocument, options);
      }
export type GenerateProjectRequirementsMutationHookResult = ReturnType<typeof useGenerateProjectRequirementsMutation>;
export type GenerateProjectRequirementsMutationResult = Apollo.MutationResult<GenerateProjectRequirementsMutation>;
export type GenerateProjectRequirementsMutationOptions = Apollo.BaseMutationOptions<GenerateProjectRequirementsMutation, GenerateProjectRequirementsMutationVariables>;
export const SubmitFinalProjectDocument = gql`
    mutation SubmitFinalProject($submission: SubmitFinalProjectInput!) {
  submitFinalProject(submission: $submission) {
    success
    message
    data {
      id
      proposal
      approachMethodology
      scopeJustification
      expectedOutcomes
      grade
      isCompleted
      completedAt
      hasTeacherGraded
      status
      vettingStatus
      complianceScore
      aiAssessment
      suggestedImprovements
      created
      lastModified
    }
  }
}
    `;
export type SubmitFinalProjectMutationFn = Apollo.MutationFunction<SubmitFinalProjectMutation, SubmitFinalProjectMutationVariables>;

/**
 * __useSubmitFinalProjectMutation__
 *
 * To run a mutation, you first call `useSubmitFinalProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFinalProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFinalProjectMutation, { data, loading, error }] = useSubmitFinalProjectMutation({
 *   variables: {
 *      submission: // value for 'submission'
 *   },
 * });
 */
export function useSubmitFinalProjectMutation(baseOptions?: Apollo.MutationHookOptions<SubmitFinalProjectMutation, SubmitFinalProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitFinalProjectMutation, SubmitFinalProjectMutationVariables>(SubmitFinalProjectDocument, options);
      }
export type SubmitFinalProjectMutationHookResult = ReturnType<typeof useSubmitFinalProjectMutation>;
export type SubmitFinalProjectMutationResult = Apollo.MutationResult<SubmitFinalProjectMutation>;
export type SubmitFinalProjectMutationOptions = Apollo.BaseMutationOptions<SubmitFinalProjectMutation, SubmitFinalProjectMutationVariables>;
export const SubmitProjectSubmissionFilesDocument = gql`
    mutation SubmitProjectSubmissionFiles($submissionId: ID!, $files: [FileInput!]!) {
  submitProjectSubmissionFiles(submissionId: $submissionId, files: $files) {
    success
    message
    data {
      id
    }
  }
}
    `;
export type SubmitProjectSubmissionFilesMutationFn = Apollo.MutationFunction<SubmitProjectSubmissionFilesMutation, SubmitProjectSubmissionFilesMutationVariables>;

/**
 * __useSubmitProjectSubmissionFilesMutation__
 *
 * To run a mutation, you first call `useSubmitProjectSubmissionFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitProjectSubmissionFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitProjectSubmissionFilesMutation, { data, loading, error }] = useSubmitProjectSubmissionFilesMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useSubmitProjectSubmissionFilesMutation(baseOptions?: Apollo.MutationHookOptions<SubmitProjectSubmissionFilesMutation, SubmitProjectSubmissionFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitProjectSubmissionFilesMutation, SubmitProjectSubmissionFilesMutationVariables>(SubmitProjectSubmissionFilesDocument, options);
      }
export type SubmitProjectSubmissionFilesMutationHookResult = ReturnType<typeof useSubmitProjectSubmissionFilesMutation>;
export type SubmitProjectSubmissionFilesMutationResult = Apollo.MutationResult<SubmitProjectSubmissionFilesMutation>;
export type SubmitProjectSubmissionFilesMutationOptions = Apollo.BaseMutationOptions<SubmitProjectSubmissionFilesMutation, SubmitProjectSubmissionFilesMutationVariables>;
export const DeleteProjectSubmissionDocument = gql`
    mutation DeleteProjectSubmission($submissionId: ID!) {
  deleteProjectSubmission(submissionId: $submissionId) {
    success
    message
    data {
      id
    }
  }
}
    `;
export type DeleteProjectSubmissionMutationFn = Apollo.MutationFunction<DeleteProjectSubmissionMutation, DeleteProjectSubmissionMutationVariables>;

/**
 * __useDeleteProjectSubmissionMutation__
 *
 * To run a mutation, you first call `useDeleteProjectSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectSubmissionMutation, { data, loading, error }] = useDeleteProjectSubmissionMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useDeleteProjectSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectSubmissionMutation, DeleteProjectSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectSubmissionMutation, DeleteProjectSubmissionMutationVariables>(DeleteProjectSubmissionDocument, options);
      }
export type DeleteProjectSubmissionMutationHookResult = ReturnType<typeof useDeleteProjectSubmissionMutation>;
export type DeleteProjectSubmissionMutationResult = Apollo.MutationResult<DeleteProjectSubmissionMutation>;
export type DeleteProjectSubmissionMutationOptions = Apollo.BaseMutationOptions<DeleteProjectSubmissionMutation, DeleteProjectSubmissionMutationVariables>;
export const SuggestionsDocument = gql`
    query Suggestions {
  getSuggestions {
    type
    content
    integrationId
    classId
    assignmentId
    trackName
  }
}
    `;

/**
 * __useSuggestionsQuery__
 *
 * To run a query within a React component, call `useSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSuggestionsQuery(baseOptions?: Apollo.QueryHookOptions<SuggestionsQuery, SuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuggestionsQuery, SuggestionsQueryVariables>(SuggestionsDocument, options);
      }
export function useSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuggestionsQuery, SuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuggestionsQuery, SuggestionsQueryVariables>(SuggestionsDocument, options);
        }
// @ts-ignore
export function useSuggestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SuggestionsQuery, SuggestionsQueryVariables>): Apollo.UseSuspenseQueryResult<SuggestionsQuery, SuggestionsQueryVariables>;
export function useSuggestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuggestionsQuery, SuggestionsQueryVariables>): Apollo.UseSuspenseQueryResult<SuggestionsQuery | undefined, SuggestionsQueryVariables>;
export function useSuggestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuggestionsQuery, SuggestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuggestionsQuery, SuggestionsQueryVariables>(SuggestionsDocument, options);
        }
export type SuggestionsQueryHookResult = ReturnType<typeof useSuggestionsQuery>;
export type SuggestionsLazyQueryHookResult = ReturnType<typeof useSuggestionsLazyQuery>;
export type SuggestionsSuspenseQueryHookResult = ReturnType<typeof useSuggestionsSuspenseQuery>;
export type SuggestionsQueryResult = Apollo.QueryResult<SuggestionsQuery, SuggestionsQueryVariables>;
export const GetDegreesByDegreeIdDocument = gql`
    query GetDegreesByDegreeId($id: ID!) {
  getDegree(id: $id) {
    success
    message
    data {
      id
      name
      description
      usersEnrolledIn {
        id
        name
      }
      coursesHasCourse {
        id
        name
        isDraft
        course_code
      }
    }
    count
  }
}
    `;

/**
 * __useGetDegreesByDegreeIdQuery__
 *
 * To run a query within a React component, call `useGetDegreesByDegreeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDegreesByDegreeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDegreesByDegreeIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDegreesByDegreeIdQuery(baseOptions: Apollo.QueryHookOptions<GetDegreesByDegreeIdQuery, GetDegreesByDegreeIdQueryVariables> & ({ variables: GetDegreesByDegreeIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDegreesByDegreeIdQuery, GetDegreesByDegreeIdQueryVariables>(GetDegreesByDegreeIdDocument, options);
      }
export function useGetDegreesByDegreeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDegreesByDegreeIdQuery, GetDegreesByDegreeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDegreesByDegreeIdQuery, GetDegreesByDegreeIdQueryVariables>(GetDegreesByDegreeIdDocument, options);
        }
// @ts-ignore
export function useGetDegreesByDegreeIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDegreesByDegreeIdQuery, GetDegreesByDegreeIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetDegreesByDegreeIdQuery, GetDegreesByDegreeIdQueryVariables>;
export function useGetDegreesByDegreeIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDegreesByDegreeIdQuery, GetDegreesByDegreeIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetDegreesByDegreeIdQuery | undefined, GetDegreesByDegreeIdQueryVariables>;
export function useGetDegreesByDegreeIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDegreesByDegreeIdQuery, GetDegreesByDegreeIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDegreesByDegreeIdQuery, GetDegreesByDegreeIdQueryVariables>(GetDegreesByDegreeIdDocument, options);
        }
export type GetDegreesByDegreeIdQueryHookResult = ReturnType<typeof useGetDegreesByDegreeIdQuery>;
export type GetDegreesByDegreeIdLazyQueryHookResult = ReturnType<typeof useGetDegreesByDegreeIdLazyQuery>;
export type GetDegreesByDegreeIdSuspenseQueryHookResult = ReturnType<typeof useGetDegreesByDegreeIdSuspenseQuery>;
export type GetDegreesByDegreeIdQueryResult = Apollo.QueryResult<GetDegreesByDegreeIdQuery, GetDegreesByDegreeIdQueryVariables>;
export const GetDegreeBySchoolDocument = gql`
    query GetDegreeBySchool($schoolId: ID!) {
  getDegreeBySchool(schoolId: $schoolId) {
    success
    message
    data {
      id
      name
      created
      last_modified
      description
    }
    count
  }
}
    `;

/**
 * __useGetDegreeBySchoolQuery__
 *
 * To run a query within a React component, call `useGetDegreeBySchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDegreeBySchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDegreeBySchoolQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetDegreeBySchoolQuery(baseOptions: Apollo.QueryHookOptions<GetDegreeBySchoolQuery, GetDegreeBySchoolQueryVariables> & ({ variables: GetDegreeBySchoolQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDegreeBySchoolQuery, GetDegreeBySchoolQueryVariables>(GetDegreeBySchoolDocument, options);
      }
export function useGetDegreeBySchoolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDegreeBySchoolQuery, GetDegreeBySchoolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDegreeBySchoolQuery, GetDegreeBySchoolQueryVariables>(GetDegreeBySchoolDocument, options);
        }
// @ts-ignore
export function useGetDegreeBySchoolSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDegreeBySchoolQuery, GetDegreeBySchoolQueryVariables>): Apollo.UseSuspenseQueryResult<GetDegreeBySchoolQuery, GetDegreeBySchoolQueryVariables>;
export function useGetDegreeBySchoolSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDegreeBySchoolQuery, GetDegreeBySchoolQueryVariables>): Apollo.UseSuspenseQueryResult<GetDegreeBySchoolQuery | undefined, GetDegreeBySchoolQueryVariables>;
export function useGetDegreeBySchoolSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDegreeBySchoolQuery, GetDegreeBySchoolQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDegreeBySchoolQuery, GetDegreeBySchoolQueryVariables>(GetDegreeBySchoolDocument, options);
        }
export type GetDegreeBySchoolQueryHookResult = ReturnType<typeof useGetDegreeBySchoolQuery>;
export type GetDegreeBySchoolLazyQueryHookResult = ReturnType<typeof useGetDegreeBySchoolLazyQuery>;
export type GetDegreeBySchoolSuspenseQueryHookResult = ReturnType<typeof useGetDegreeBySchoolSuspenseQuery>;
export type GetDegreeBySchoolQueryResult = Apollo.QueryResult<GetDegreeBySchoolQuery, GetDegreeBySchoolQueryVariables>;
export const GetDegreesBySchoolByQueryDocument = gql`
    query GetDegreesBySchoolByQuery($schoolId: ID!, $searchQuery: String, $page: Int, $pageSize: Int, $sortBy: String) {
  getDegreesBySchoolByQuery(
    schoolId: $schoolId
    searchQuery: $searchQuery
    page: $page
    pageSize: $pageSize
    sortBy: $sortBy
  ) {
    success
    message
    data {
      degrees {
        id
        name
        description
        usersEnrolledIn {
          id
          name
        }
        coursesHasCourse {
          id
          name
          course_code
        }
      }
      totalCount
    }
    count
  }
}
    `;

/**
 * __useGetDegreesBySchoolByQueryQuery__
 *
 * To run a query within a React component, call `useGetDegreesBySchoolByQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDegreesBySchoolByQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDegreesBySchoolByQueryQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      searchQuery: // value for 'searchQuery'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetDegreesBySchoolByQueryQuery(baseOptions: Apollo.QueryHookOptions<GetDegreesBySchoolByQueryQuery, GetDegreesBySchoolByQueryQueryVariables> & ({ variables: GetDegreesBySchoolByQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDegreesBySchoolByQueryQuery, GetDegreesBySchoolByQueryQueryVariables>(GetDegreesBySchoolByQueryDocument, options);
      }
export function useGetDegreesBySchoolByQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDegreesBySchoolByQueryQuery, GetDegreesBySchoolByQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDegreesBySchoolByQueryQuery, GetDegreesBySchoolByQueryQueryVariables>(GetDegreesBySchoolByQueryDocument, options);
        }
// @ts-ignore
export function useGetDegreesBySchoolByQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDegreesBySchoolByQueryQuery, GetDegreesBySchoolByQueryQueryVariables>): Apollo.UseSuspenseQueryResult<GetDegreesBySchoolByQueryQuery, GetDegreesBySchoolByQueryQueryVariables>;
export function useGetDegreesBySchoolByQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDegreesBySchoolByQueryQuery, GetDegreesBySchoolByQueryQueryVariables>): Apollo.UseSuspenseQueryResult<GetDegreesBySchoolByQueryQuery | undefined, GetDegreesBySchoolByQueryQueryVariables>;
export function useGetDegreesBySchoolByQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDegreesBySchoolByQueryQuery, GetDegreesBySchoolByQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDegreesBySchoolByQueryQuery, GetDegreesBySchoolByQueryQueryVariables>(GetDegreesBySchoolByQueryDocument, options);
        }
export type GetDegreesBySchoolByQueryQueryHookResult = ReturnType<typeof useGetDegreesBySchoolByQueryQuery>;
export type GetDegreesBySchoolByQueryLazyQueryHookResult = ReturnType<typeof useGetDegreesBySchoolByQueryLazyQuery>;
export type GetDegreesBySchoolByQuerySuspenseQueryHookResult = ReturnType<typeof useGetDegreesBySchoolByQuerySuspenseQuery>;
export type GetDegreesBySchoolByQueryQueryResult = Apollo.QueryResult<GetDegreesBySchoolByQueryQuery, GetDegreesBySchoolByQueryQueryVariables>;
export const GetDegreeForUserDocument = gql`
    query GetDegreeForUser {
  getDegreeForUser {
    count
    message
    success
    data {
      description
      name
      id
    }
  }
}
    `;

/**
 * __useGetDegreeForUserQuery__
 *
 * To run a query within a React component, call `useGetDegreeForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDegreeForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDegreeForUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDegreeForUserQuery(baseOptions?: Apollo.QueryHookOptions<GetDegreeForUserQuery, GetDegreeForUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDegreeForUserQuery, GetDegreeForUserQueryVariables>(GetDegreeForUserDocument, options);
      }
export function useGetDegreeForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDegreeForUserQuery, GetDegreeForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDegreeForUserQuery, GetDegreeForUserQueryVariables>(GetDegreeForUserDocument, options);
        }
// @ts-ignore
export function useGetDegreeForUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDegreeForUserQuery, GetDegreeForUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetDegreeForUserQuery, GetDegreeForUserQueryVariables>;
export function useGetDegreeForUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDegreeForUserQuery, GetDegreeForUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetDegreeForUserQuery | undefined, GetDegreeForUserQueryVariables>;
export function useGetDegreeForUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDegreeForUserQuery, GetDegreeForUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDegreeForUserQuery, GetDegreeForUserQueryVariables>(GetDegreeForUserDocument, options);
        }
export type GetDegreeForUserQueryHookResult = ReturnType<typeof useGetDegreeForUserQuery>;
export type GetDegreeForUserLazyQueryHookResult = ReturnType<typeof useGetDegreeForUserLazyQuery>;
export type GetDegreeForUserSuspenseQueryHookResult = ReturnType<typeof useGetDegreeForUserSuspenseQuery>;
export type GetDegreeForUserQueryResult = Apollo.QueryResult<GetDegreeForUserQuery, GetDegreeForUserQueryVariables>;
export const GetDegreeForUserWithEnrolledUserInfoDocument = gql`
    query GetDegreeForUserWithEnrolledUserInfo {
  getDegreeForUserWithEnrolledUserInfo {
    count
    message
    success
    data {
      description
      name
      id
      usersEnrolledInConnection {
        edges {
          node {
            id
          }
          properties {
            pendingDegreeEnrollmentInvite
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetDegreeForUserWithEnrolledUserInfoQuery__
 *
 * To run a query within a React component, call `useGetDegreeForUserWithEnrolledUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDegreeForUserWithEnrolledUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDegreeForUserWithEnrolledUserInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDegreeForUserWithEnrolledUserInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetDegreeForUserWithEnrolledUserInfoQuery, GetDegreeForUserWithEnrolledUserInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDegreeForUserWithEnrolledUserInfoQuery, GetDegreeForUserWithEnrolledUserInfoQueryVariables>(GetDegreeForUserWithEnrolledUserInfoDocument, options);
      }
export function useGetDegreeForUserWithEnrolledUserInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDegreeForUserWithEnrolledUserInfoQuery, GetDegreeForUserWithEnrolledUserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDegreeForUserWithEnrolledUserInfoQuery, GetDegreeForUserWithEnrolledUserInfoQueryVariables>(GetDegreeForUserWithEnrolledUserInfoDocument, options);
        }
// @ts-ignore
export function useGetDegreeForUserWithEnrolledUserInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDegreeForUserWithEnrolledUserInfoQuery, GetDegreeForUserWithEnrolledUserInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetDegreeForUserWithEnrolledUserInfoQuery, GetDegreeForUserWithEnrolledUserInfoQueryVariables>;
export function useGetDegreeForUserWithEnrolledUserInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDegreeForUserWithEnrolledUserInfoQuery, GetDegreeForUserWithEnrolledUserInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetDegreeForUserWithEnrolledUserInfoQuery | undefined, GetDegreeForUserWithEnrolledUserInfoQueryVariables>;
export function useGetDegreeForUserWithEnrolledUserInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDegreeForUserWithEnrolledUserInfoQuery, GetDegreeForUserWithEnrolledUserInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDegreeForUserWithEnrolledUserInfoQuery, GetDegreeForUserWithEnrolledUserInfoQueryVariables>(GetDegreeForUserWithEnrolledUserInfoDocument, options);
        }
export type GetDegreeForUserWithEnrolledUserInfoQueryHookResult = ReturnType<typeof useGetDegreeForUserWithEnrolledUserInfoQuery>;
export type GetDegreeForUserWithEnrolledUserInfoLazyQueryHookResult = ReturnType<typeof useGetDegreeForUserWithEnrolledUserInfoLazyQuery>;
export type GetDegreeForUserWithEnrolledUserInfoSuspenseQueryHookResult = ReturnType<typeof useGetDegreeForUserWithEnrolledUserInfoSuspenseQuery>;
export type GetDegreeForUserWithEnrolledUserInfoQueryResult = Apollo.QueryResult<GetDegreeForUserWithEnrolledUserInfoQuery, GetDegreeForUserWithEnrolledUserInfoQueryVariables>;
export const GetStudentsByDegreeIdDocument = gql`
    query GetStudentsByDegreeId($degreeId: ID!, $searchQuery: String, $page: Int, $pageSize: Int, $sortBy: String) {
  getStudentsByDegreeId(
    degreeId: $degreeId
    searchQuery: $searchQuery
    page: $page
    pageSize: $pageSize
    sortBy: $sortBy
  ) {
    success
    message
    data {
      id
      name
      email
      pendingDegreeEnrollmentInvite
      enrollmentDate
    }
    count
  }
}
    `;

/**
 * __useGetStudentsByDegreeIdQuery__
 *
 * To run a query within a React component, call `useGetStudentsByDegreeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentsByDegreeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentsByDegreeIdQuery({
 *   variables: {
 *      degreeId: // value for 'degreeId'
 *      searchQuery: // value for 'searchQuery'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetStudentsByDegreeIdQuery(baseOptions: Apollo.QueryHookOptions<GetStudentsByDegreeIdQuery, GetStudentsByDegreeIdQueryVariables> & ({ variables: GetStudentsByDegreeIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentsByDegreeIdQuery, GetStudentsByDegreeIdQueryVariables>(GetStudentsByDegreeIdDocument, options);
      }
export function useGetStudentsByDegreeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentsByDegreeIdQuery, GetStudentsByDegreeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentsByDegreeIdQuery, GetStudentsByDegreeIdQueryVariables>(GetStudentsByDegreeIdDocument, options);
        }
// @ts-ignore
export function useGetStudentsByDegreeIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStudentsByDegreeIdQuery, GetStudentsByDegreeIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentsByDegreeIdQuery, GetStudentsByDegreeIdQueryVariables>;
export function useGetStudentsByDegreeIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentsByDegreeIdQuery, GetStudentsByDegreeIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetStudentsByDegreeIdQuery | undefined, GetStudentsByDegreeIdQueryVariables>;
export function useGetStudentsByDegreeIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStudentsByDegreeIdQuery, GetStudentsByDegreeIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStudentsByDegreeIdQuery, GetStudentsByDegreeIdQueryVariables>(GetStudentsByDegreeIdDocument, options);
        }
export type GetStudentsByDegreeIdQueryHookResult = ReturnType<typeof useGetStudentsByDegreeIdQuery>;
export type GetStudentsByDegreeIdLazyQueryHookResult = ReturnType<typeof useGetStudentsByDegreeIdLazyQuery>;
export type GetStudentsByDegreeIdSuspenseQueryHookResult = ReturnType<typeof useGetStudentsByDegreeIdSuspenseQuery>;
export type GetStudentsByDegreeIdQueryResult = Apollo.QueryResult<GetStudentsByDegreeIdQuery, GetStudentsByDegreeIdQueryVariables>;
export const GetAdminDocumentsForTenantDocument = gql`
    query GetAdminDocumentsForTenant {
  getAdminDocumentsForTenant {
    success
    message
    data {
      id
      title
      status
      adminDoc
      created
      last_modified
      files {
        id
        fileName
        fileURL
        status
      }
    }
    count
  }
}
    `;

/**
 * __useGetAdminDocumentsForTenantQuery__
 *
 * To run a query within a React component, call `useGetAdminDocumentsForTenantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminDocumentsForTenantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminDocumentsForTenantQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminDocumentsForTenantQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminDocumentsForTenantQuery, GetAdminDocumentsForTenantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminDocumentsForTenantQuery, GetAdminDocumentsForTenantQueryVariables>(GetAdminDocumentsForTenantDocument, options);
      }
export function useGetAdminDocumentsForTenantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminDocumentsForTenantQuery, GetAdminDocumentsForTenantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminDocumentsForTenantQuery, GetAdminDocumentsForTenantQueryVariables>(GetAdminDocumentsForTenantDocument, options);
        }
// @ts-ignore
export function useGetAdminDocumentsForTenantSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminDocumentsForTenantQuery, GetAdminDocumentsForTenantQueryVariables>): Apollo.UseSuspenseQueryResult<GetAdminDocumentsForTenantQuery, GetAdminDocumentsForTenantQueryVariables>;
export function useGetAdminDocumentsForTenantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminDocumentsForTenantQuery, GetAdminDocumentsForTenantQueryVariables>): Apollo.UseSuspenseQueryResult<GetAdminDocumentsForTenantQuery | undefined, GetAdminDocumentsForTenantQueryVariables>;
export function useGetAdminDocumentsForTenantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminDocumentsForTenantQuery, GetAdminDocumentsForTenantQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminDocumentsForTenantQuery, GetAdminDocumentsForTenantQueryVariables>(GetAdminDocumentsForTenantDocument, options);
        }
export type GetAdminDocumentsForTenantQueryHookResult = ReturnType<typeof useGetAdminDocumentsForTenantQuery>;
export type GetAdminDocumentsForTenantLazyQueryHookResult = ReturnType<typeof useGetAdminDocumentsForTenantLazyQuery>;
export type GetAdminDocumentsForTenantSuspenseQueryHookResult = ReturnType<typeof useGetAdminDocumentsForTenantSuspenseQuery>;
export type GetAdminDocumentsForTenantQueryResult = Apollo.QueryResult<GetAdminDocumentsForTenantQuery, GetAdminDocumentsForTenantQueryVariables>;
export const GetAdminDocumentAnalyticsDocument = gql`
    query GetAdminDocumentAnalytics($input: DocumentReferenceAnalyticsInput) {
  getAdminDocumentAnalytics(input: $input) {
    success
    message
    data {
      document {
        id
        title
      }
      referenceCount
    }
    count
  }
}
    `;

/**
 * __useGetAdminDocumentAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetAdminDocumentAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminDocumentAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminDocumentAnalyticsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAdminDocumentAnalyticsQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminDocumentAnalyticsQuery, GetAdminDocumentAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminDocumentAnalyticsQuery, GetAdminDocumentAnalyticsQueryVariables>(GetAdminDocumentAnalyticsDocument, options);
      }
export function useGetAdminDocumentAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminDocumentAnalyticsQuery, GetAdminDocumentAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminDocumentAnalyticsQuery, GetAdminDocumentAnalyticsQueryVariables>(GetAdminDocumentAnalyticsDocument, options);
        }
// @ts-ignore
export function useGetAdminDocumentAnalyticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminDocumentAnalyticsQuery, GetAdminDocumentAnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAdminDocumentAnalyticsQuery, GetAdminDocumentAnalyticsQueryVariables>;
export function useGetAdminDocumentAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminDocumentAnalyticsQuery, GetAdminDocumentAnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAdminDocumentAnalyticsQuery | undefined, GetAdminDocumentAnalyticsQueryVariables>;
export function useGetAdminDocumentAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminDocumentAnalyticsQuery, GetAdminDocumentAnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminDocumentAnalyticsQuery, GetAdminDocumentAnalyticsQueryVariables>(GetAdminDocumentAnalyticsDocument, options);
        }
export type GetAdminDocumentAnalyticsQueryHookResult = ReturnType<typeof useGetAdminDocumentAnalyticsQuery>;
export type GetAdminDocumentAnalyticsLazyQueryHookResult = ReturnType<typeof useGetAdminDocumentAnalyticsLazyQuery>;
export type GetAdminDocumentAnalyticsSuspenseQueryHookResult = ReturnType<typeof useGetAdminDocumentAnalyticsSuspenseQuery>;
export type GetAdminDocumentAnalyticsQueryResult = Apollo.QueryResult<GetAdminDocumentAnalyticsQuery, GetAdminDocumentAnalyticsQueryVariables>;
export const GetDocumentDocument = gql`
    query getDocument($id: ID!) {
  getDocument(id: $id) {
    success
    message
    data {
      id
      title
      summary
      status
      sourceType
      created
      last_modified
      files {
        id
        fileName
        fileURL
        status
      }
    }
    count
  }
}
    `;

/**
 * __useGetDocumentQuery__
 *
 * To run a query within a React component, call `useGetDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDocumentQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentQuery, GetDocumentQueryVariables> & ({ variables: GetDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentQuery, GetDocumentQueryVariables>(GetDocumentDocument, options);
      }
export function useGetDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentQuery, GetDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentQuery, GetDocumentQueryVariables>(GetDocumentDocument, options);
        }
// @ts-ignore
export function useGetDocumentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDocumentQuery, GetDocumentQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentQuery, GetDocumentQueryVariables>;
export function useGetDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentQuery, GetDocumentQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentQuery | undefined, GetDocumentQueryVariables>;
export function useGetDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentQuery, GetDocumentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDocumentQuery, GetDocumentQueryVariables>(GetDocumentDocument, options);
        }
export type GetDocumentQueryHookResult = ReturnType<typeof useGetDocumentQuery>;
export type GetDocumentLazyQueryHookResult = ReturnType<typeof useGetDocumentLazyQuery>;
export type GetDocumentSuspenseQueryHookResult = ReturnType<typeof useGetDocumentSuspenseQuery>;
export type GetDocumentQueryResult = Apollo.QueryResult<GetDocumentQuery, GetDocumentQueryVariables>;
export const GetEnrollmentLinkDocument = gql`
    query GetEnrollmentLink($courseId: ID!) {
  getEnrollmentLink(courseId: $courseId) {
    success
    message
    data {
      id
      enrollmentLink
      maxEnrollments
      currentEnrollments
      expiresAt
      createdAt
      lastModified
    }
    count
  }
}
    `;

/**
 * __useGetEnrollmentLinkQuery__
 *
 * To run a query within a React component, call `useGetEnrollmentLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnrollmentLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnrollmentLinkQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetEnrollmentLinkQuery(baseOptions: Apollo.QueryHookOptions<GetEnrollmentLinkQuery, GetEnrollmentLinkQueryVariables> & ({ variables: GetEnrollmentLinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnrollmentLinkQuery, GetEnrollmentLinkQueryVariables>(GetEnrollmentLinkDocument, options);
      }
export function useGetEnrollmentLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnrollmentLinkQuery, GetEnrollmentLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnrollmentLinkQuery, GetEnrollmentLinkQueryVariables>(GetEnrollmentLinkDocument, options);
        }
// @ts-ignore
export function useGetEnrollmentLinkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEnrollmentLinkQuery, GetEnrollmentLinkQueryVariables>): Apollo.UseSuspenseQueryResult<GetEnrollmentLinkQuery, GetEnrollmentLinkQueryVariables>;
export function useGetEnrollmentLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEnrollmentLinkQuery, GetEnrollmentLinkQueryVariables>): Apollo.UseSuspenseQueryResult<GetEnrollmentLinkQuery | undefined, GetEnrollmentLinkQueryVariables>;
export function useGetEnrollmentLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEnrollmentLinkQuery, GetEnrollmentLinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEnrollmentLinkQuery, GetEnrollmentLinkQueryVariables>(GetEnrollmentLinkDocument, options);
        }
export type GetEnrollmentLinkQueryHookResult = ReturnType<typeof useGetEnrollmentLinkQuery>;
export type GetEnrollmentLinkLazyQueryHookResult = ReturnType<typeof useGetEnrollmentLinkLazyQuery>;
export type GetEnrollmentLinkSuspenseQueryHookResult = ReturnType<typeof useGetEnrollmentLinkSuspenseQuery>;
export type GetEnrollmentLinkQueryResult = Apollo.QueryResult<GetEnrollmentLinkQuery, GetEnrollmentLinkQueryVariables>;
export const GetAllowedUploadSpecificationsDocument = gql`
    query GetAllowedUploadSpecifications($storagePath: StoragePathType!) {
  getAllowedUploadSpecifications(storagePath: $storagePath) {
    count
    data {
      allowedMimeTypes
      maxFileSize
    }
    message
    success
  }
}
    `;

/**
 * __useGetAllowedUploadSpecificationsQuery__
 *
 * To run a query within a React component, call `useGetAllowedUploadSpecificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllowedUploadSpecificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllowedUploadSpecificationsQuery({
 *   variables: {
 *      storagePath: // value for 'storagePath'
 *   },
 * });
 */
export function useGetAllowedUploadSpecificationsQuery(baseOptions: Apollo.QueryHookOptions<GetAllowedUploadSpecificationsQuery, GetAllowedUploadSpecificationsQueryVariables> & ({ variables: GetAllowedUploadSpecificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllowedUploadSpecificationsQuery, GetAllowedUploadSpecificationsQueryVariables>(GetAllowedUploadSpecificationsDocument, options);
      }
export function useGetAllowedUploadSpecificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllowedUploadSpecificationsQuery, GetAllowedUploadSpecificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllowedUploadSpecificationsQuery, GetAllowedUploadSpecificationsQueryVariables>(GetAllowedUploadSpecificationsDocument, options);
        }
// @ts-ignore
export function useGetAllowedUploadSpecificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllowedUploadSpecificationsQuery, GetAllowedUploadSpecificationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllowedUploadSpecificationsQuery, GetAllowedUploadSpecificationsQueryVariables>;
export function useGetAllowedUploadSpecificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllowedUploadSpecificationsQuery, GetAllowedUploadSpecificationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllowedUploadSpecificationsQuery | undefined, GetAllowedUploadSpecificationsQueryVariables>;
export function useGetAllowedUploadSpecificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllowedUploadSpecificationsQuery, GetAllowedUploadSpecificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllowedUploadSpecificationsQuery, GetAllowedUploadSpecificationsQueryVariables>(GetAllowedUploadSpecificationsDocument, options);
        }
export type GetAllowedUploadSpecificationsQueryHookResult = ReturnType<typeof useGetAllowedUploadSpecificationsQuery>;
export type GetAllowedUploadSpecificationsLazyQueryHookResult = ReturnType<typeof useGetAllowedUploadSpecificationsLazyQuery>;
export type GetAllowedUploadSpecificationsSuspenseQueryHookResult = ReturnType<typeof useGetAllowedUploadSpecificationsSuspenseQuery>;
export type GetAllowedUploadSpecificationsQueryResult = Apollo.QueryResult<GetAllowedUploadSpecificationsQuery, GetAllowedUploadSpecificationsQueryVariables>;
export const GetFileDocument = gql`
    query GetFile($fileId: ID!) {
  getFile(fileId: $fileId) {
    count
    data {
      fileName
      id
      status
    }
    message
    success
  }
}
    `;

/**
 * __useGetFileQuery__
 *
 * To run a query within a React component, call `useGetFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useGetFileQuery(baseOptions: Apollo.QueryHookOptions<GetFileQuery, GetFileQueryVariables> & ({ variables: GetFileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFileQuery, GetFileQueryVariables>(GetFileDocument, options);
      }
export function useGetFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFileQuery, GetFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFileQuery, GetFileQueryVariables>(GetFileDocument, options);
        }
// @ts-ignore
export function useGetFileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFileQuery, GetFileQueryVariables>): Apollo.UseSuspenseQueryResult<GetFileQuery, GetFileQueryVariables>;
export function useGetFileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFileQuery, GetFileQueryVariables>): Apollo.UseSuspenseQueryResult<GetFileQuery | undefined, GetFileQueryVariables>;
export function useGetFileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFileQuery, GetFileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFileQuery, GetFileQueryVariables>(GetFileDocument, options);
        }
export type GetFileQueryHookResult = ReturnType<typeof useGetFileQuery>;
export type GetFileLazyQueryHookResult = ReturnType<typeof useGetFileLazyQuery>;
export type GetFileSuspenseQueryHookResult = ReturnType<typeof useGetFileSuspenseQuery>;
export type GetFileQueryResult = Apollo.QueryResult<GetFileQuery, GetFileQueryVariables>;
export const FoodByDateDocument = gql`
    query FoodByDate($date: String!, $timezone: String!) {
  getFoodsByDate(date: $date, timezone: $timezone) {
    name
    calories
    carbohydrates_grams
    fat_grams
    fiber_grams
    protein_grams
    serving_size
    sodium_mg
    sugars_grams
  }
}
    `;

/**
 * __useFoodByDateQuery__
 *
 * To run a query within a React component, call `useFoodByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoodByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoodByDateQuery({
 *   variables: {
 *      date: // value for 'date'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useFoodByDateQuery(baseOptions: Apollo.QueryHookOptions<FoodByDateQuery, FoodByDateQueryVariables> & ({ variables: FoodByDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FoodByDateQuery, FoodByDateQueryVariables>(FoodByDateDocument, options);
      }
export function useFoodByDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FoodByDateQuery, FoodByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FoodByDateQuery, FoodByDateQueryVariables>(FoodByDateDocument, options);
        }
// @ts-ignore
export function useFoodByDateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FoodByDateQuery, FoodByDateQueryVariables>): Apollo.UseSuspenseQueryResult<FoodByDateQuery, FoodByDateQueryVariables>;
export function useFoodByDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FoodByDateQuery, FoodByDateQueryVariables>): Apollo.UseSuspenseQueryResult<FoodByDateQuery | undefined, FoodByDateQueryVariables>;
export function useFoodByDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FoodByDateQuery, FoodByDateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FoodByDateQuery, FoodByDateQueryVariables>(FoodByDateDocument, options);
        }
export type FoodByDateQueryHookResult = ReturnType<typeof useFoodByDateQuery>;
export type FoodByDateLazyQueryHookResult = ReturnType<typeof useFoodByDateLazyQuery>;
export type FoodByDateSuspenseQueryHookResult = ReturnType<typeof useFoodByDateSuspenseQuery>;
export type FoodByDateQueryResult = Apollo.QueryResult<FoodByDateQuery, FoodByDateQueryVariables>;
export const InviteCountDocument = gql`
    query InviteCount {
  userInviteCount {
    count
  }
  me {
    name
    username
    gender
    isOnboarded
    isPro
    phoneNumber
    isEmailVerified
  }
}
    `;

/**
 * __useInviteCountQuery__
 *
 * To run a query within a React component, call `useInviteCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useInviteCountQuery(baseOptions?: Apollo.QueryHookOptions<InviteCountQuery, InviteCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InviteCountQuery, InviteCountQueryVariables>(InviteCountDocument, options);
      }
export function useInviteCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InviteCountQuery, InviteCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InviteCountQuery, InviteCountQueryVariables>(InviteCountDocument, options);
        }
// @ts-ignore
export function useInviteCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InviteCountQuery, InviteCountQueryVariables>): Apollo.UseSuspenseQueryResult<InviteCountQuery, InviteCountQueryVariables>;
export function useInviteCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InviteCountQuery, InviteCountQueryVariables>): Apollo.UseSuspenseQueryResult<InviteCountQuery | undefined, InviteCountQueryVariables>;
export function useInviteCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InviteCountQuery, InviteCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InviteCountQuery, InviteCountQueryVariables>(InviteCountDocument, options);
        }
export type InviteCountQueryHookResult = ReturnType<typeof useInviteCountQuery>;
export type InviteCountLazyQueryHookResult = ReturnType<typeof useInviteCountLazyQuery>;
export type InviteCountSuspenseQueryHookResult = ReturnType<typeof useInviteCountSuspenseQuery>;
export type InviteCountQueryResult = Apollo.QueryResult<InviteCountQuery, InviteCountQueryVariables>;
export const DateForChatDocument = gql`
    query DateForChat($date: String!, $timezone: String!) {
  getChatForDate(date: $date, timezone: $timezone) {
    id
    date
    timezone
    conversation {
      id
      sender
      content
      type
      nodeId
      snackType
      file {
        fileName
        id
      }
      parameters {
        lastGeneratedTopic
        lastGeneratedLabel
        questContext
        userResponse
      }
      aspectDetails {
        name
        category
        id
        friendId
        relationshipType
        connectionStrength
        frequencyOfInteraction
        lastInteractionDate
        sharedInterests
        sharedGoals
        sharedEventsAttended
        friendPersonalityTraits
        communicationChannel
        level
        startDate
        lastUpdated
        learningStyle
        language
        timeOfDay
        learningDuration
        contentType
        notificationPreferences
        type
        completionStatus
        deadline
        priority
        value
        description
        date
        importance
        status
        endDate
        text
        sentiment
        context
        intensity
        timestamp
        trigger
        calories
        carbohydrates_grams
        fat_grams
        fiber_grams
        protein_grams
        serving_size
        sodium_mg
        sugars_grams
        totalCalories
        totalCarbs
        totalFats
        totalProteins
        totalCaloriesBurned
        totalDurationMinutes
        totalWorkouts
        water_intake_oz
      }
    }
  }
}
    `;

/**
 * __useDateForChatQuery__
 *
 * To run a query within a React component, call `useDateForChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useDateForChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDateForChatQuery({
 *   variables: {
 *      date: // value for 'date'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useDateForChatQuery(baseOptions: Apollo.QueryHookOptions<DateForChatQuery, DateForChatQueryVariables> & ({ variables: DateForChatQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DateForChatQuery, DateForChatQueryVariables>(DateForChatDocument, options);
      }
export function useDateForChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DateForChatQuery, DateForChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DateForChatQuery, DateForChatQueryVariables>(DateForChatDocument, options);
        }
// @ts-ignore
export function useDateForChatSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DateForChatQuery, DateForChatQueryVariables>): Apollo.UseSuspenseQueryResult<DateForChatQuery, DateForChatQueryVariables>;
export function useDateForChatSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DateForChatQuery, DateForChatQueryVariables>): Apollo.UseSuspenseQueryResult<DateForChatQuery | undefined, DateForChatQueryVariables>;
export function useDateForChatSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DateForChatQuery, DateForChatQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DateForChatQuery, DateForChatQueryVariables>(DateForChatDocument, options);
        }
export type DateForChatQueryHookResult = ReturnType<typeof useDateForChatQuery>;
export type DateForChatLazyQueryHookResult = ReturnType<typeof useDateForChatLazyQuery>;
export type DateForChatSuspenseQueryHookResult = ReturnType<typeof useDateForChatSuspenseQuery>;
export type DateForChatQueryResult = Apollo.QueryResult<DateForChatQuery, DateForChatQueryVariables>;
export const FieldsDocument = gql`
    query Fields {
  getFields {
    name
    id
    mastery
    isRelevant
    imageUrl
  }
}
    `;

/**
 * __useFieldsQuery__
 *
 * To run a query within a React component, call `useFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFieldsQuery(baseOptions?: Apollo.QueryHookOptions<FieldsQuery, FieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FieldsQuery, FieldsQueryVariables>(FieldsDocument, options);
      }
export function useFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FieldsQuery, FieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FieldsQuery, FieldsQueryVariables>(FieldsDocument, options);
        }
// @ts-ignore
export function useFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FieldsQuery, FieldsQueryVariables>): Apollo.UseSuspenseQueryResult<FieldsQuery, FieldsQueryVariables>;
export function useFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FieldsQuery, FieldsQueryVariables>): Apollo.UseSuspenseQueryResult<FieldsQuery | undefined, FieldsQueryVariables>;
export function useFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FieldsQuery, FieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FieldsQuery, FieldsQueryVariables>(FieldsDocument, options);
        }
export type FieldsQueryHookResult = ReturnType<typeof useFieldsQuery>;
export type FieldsLazyQueryHookResult = ReturnType<typeof useFieldsLazyQuery>;
export type FieldsSuspenseQueryHookResult = ReturnType<typeof useFieldsSuspenseQuery>;
export type FieldsQueryResult = Apollo.QueryResult<FieldsQuery, FieldsQueryVariables>;
export const GetLearningTreeDocument = gql`
    query GetLearningTree($level: String!, $name: String!) {
  getLearningTree(level: $level, name: $name) {
    FieldName
    SubfieldName
    TopicName
    ChapterName
    SubchapterName
  }
}
    `;

/**
 * __useGetLearningTreeQuery__
 *
 * To run a query within a React component, call `useGetLearningTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearningTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearningTreeQuery({
 *   variables: {
 *      level: // value for 'level'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetLearningTreeQuery(baseOptions: Apollo.QueryHookOptions<GetLearningTreeQuery, GetLearningTreeQueryVariables> & ({ variables: GetLearningTreeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLearningTreeQuery, GetLearningTreeQueryVariables>(GetLearningTreeDocument, options);
      }
export function useGetLearningTreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLearningTreeQuery, GetLearningTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLearningTreeQuery, GetLearningTreeQueryVariables>(GetLearningTreeDocument, options);
        }
// @ts-ignore
export function useGetLearningTreeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLearningTreeQuery, GetLearningTreeQueryVariables>): Apollo.UseSuspenseQueryResult<GetLearningTreeQuery, GetLearningTreeQueryVariables>;
export function useGetLearningTreeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLearningTreeQuery, GetLearningTreeQueryVariables>): Apollo.UseSuspenseQueryResult<GetLearningTreeQuery | undefined, GetLearningTreeQueryVariables>;
export function useGetLearningTreeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLearningTreeQuery, GetLearningTreeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLearningTreeQuery, GetLearningTreeQueryVariables>(GetLearningTreeDocument, options);
        }
export type GetLearningTreeQueryHookResult = ReturnType<typeof useGetLearningTreeQuery>;
export type GetLearningTreeLazyQueryHookResult = ReturnType<typeof useGetLearningTreeLazyQuery>;
export type GetLearningTreeSuspenseQueryHookResult = ReturnType<typeof useGetLearningTreeSuspenseQuery>;
export type GetLearningTreeQueryResult = Apollo.QueryResult<GetLearningTreeQuery, GetLearningTreeQueryVariables>;
export const NodeGraphDocument = gql`
    query NodeGraph($nodeName: String!, $nodeLabel: NodeLabel!) {
  getNodeChildren(label: $nodeLabel, name: $nodeName) {
    name
    description
    id
    mastery
    label
    unitsCount
    imageUrl
  }
  getNode(label: $nodeLabel, name: $nodeName) {
    name
    description
    id
    mastery
    label
    imageUrl
  }
  getNodeParents(label: $nodeLabel, name: $nodeName) {
    name
    id
    mastery
    label
  }
}
    `;

/**
 * __useNodeGraphQuery__
 *
 * To run a query within a React component, call `useNodeGraphQuery` and pass it any options that fit your needs.
 * When your component renders, `useNodeGraphQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNodeGraphQuery({
 *   variables: {
 *      nodeName: // value for 'nodeName'
 *      nodeLabel: // value for 'nodeLabel'
 *   },
 * });
 */
export function useNodeGraphQuery(baseOptions: Apollo.QueryHookOptions<NodeGraphQuery, NodeGraphQueryVariables> & ({ variables: NodeGraphQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NodeGraphQuery, NodeGraphQueryVariables>(NodeGraphDocument, options);
      }
export function useNodeGraphLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NodeGraphQuery, NodeGraphQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NodeGraphQuery, NodeGraphQueryVariables>(NodeGraphDocument, options);
        }
// @ts-ignore
export function useNodeGraphSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NodeGraphQuery, NodeGraphQueryVariables>): Apollo.UseSuspenseQueryResult<NodeGraphQuery, NodeGraphQueryVariables>;
export function useNodeGraphSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NodeGraphQuery, NodeGraphQueryVariables>): Apollo.UseSuspenseQueryResult<NodeGraphQuery | undefined, NodeGraphQueryVariables>;
export function useNodeGraphSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NodeGraphQuery, NodeGraphQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NodeGraphQuery, NodeGraphQueryVariables>(NodeGraphDocument, options);
        }
export type NodeGraphQueryHookResult = ReturnType<typeof useNodeGraphQuery>;
export type NodeGraphLazyQueryHookResult = ReturnType<typeof useNodeGraphLazyQuery>;
export type NodeGraphSuspenseQueryHookResult = ReturnType<typeof useNodeGraphSuspenseQuery>;
export type NodeGraphQueryResult = Apollo.QueryResult<NodeGraphQuery, NodeGraphQueryVariables>;
export const RecentTracksDocument = gql`
    query RecentTracks($filterByCategory: String) {
  getRecentTracks(filterByCategory: $filterByCategory) {
    name
    description
    totalUnits
    completedUnits
    parentFields
    parentSubfield
    mastery
    imageUrl
  }
}
    `;

/**
 * __useRecentTracksQuery__
 *
 * To run a query within a React component, call `useRecentTracksQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentTracksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentTracksQuery({
 *   variables: {
 *      filterByCategory: // value for 'filterByCategory'
 *   },
 * });
 */
export function useRecentTracksQuery(baseOptions?: Apollo.QueryHookOptions<RecentTracksQuery, RecentTracksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentTracksQuery, RecentTracksQueryVariables>(RecentTracksDocument, options);
      }
export function useRecentTracksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentTracksQuery, RecentTracksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentTracksQuery, RecentTracksQueryVariables>(RecentTracksDocument, options);
        }
// @ts-ignore
export function useRecentTracksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RecentTracksQuery, RecentTracksQueryVariables>): Apollo.UseSuspenseQueryResult<RecentTracksQuery, RecentTracksQueryVariables>;
export function useRecentTracksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecentTracksQuery, RecentTracksQueryVariables>): Apollo.UseSuspenseQueryResult<RecentTracksQuery | undefined, RecentTracksQueryVariables>;
export function useRecentTracksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecentTracksQuery, RecentTracksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecentTracksQuery, RecentTracksQueryVariables>(RecentTracksDocument, options);
        }
export type RecentTracksQueryHookResult = ReturnType<typeof useRecentTracksQuery>;
export type RecentTracksLazyQueryHookResult = ReturnType<typeof useRecentTracksLazyQuery>;
export type RecentTracksSuspenseQueryHookResult = ReturnType<typeof useRecentTracksSuspenseQuery>;
export type RecentTracksQueryResult = Apollo.QueryResult<RecentTracksQuery, RecentTracksQueryVariables>;
export const TableOfContentsDocument = gql`
    query TableOfContents($learningNodeNames: [String]!, $hierarchyLabel: String!) {
  getTableOfContents(
    learningNodeNames: $learningNodeNames
    hierarchyLabel: $hierarchyLabel
  ) {
    name
    mastery
    id
    isRelevant
    parentName
    description
    completed
    index
  }
}
    `;

/**
 * __useTableOfContentsQuery__
 *
 * To run a query within a React component, call `useTableOfContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTableOfContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTableOfContentsQuery({
 *   variables: {
 *      learningNodeNames: // value for 'learningNodeNames'
 *      hierarchyLabel: // value for 'hierarchyLabel'
 *   },
 * });
 */
export function useTableOfContentsQuery(baseOptions: Apollo.QueryHookOptions<TableOfContentsQuery, TableOfContentsQueryVariables> & ({ variables: TableOfContentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TableOfContentsQuery, TableOfContentsQueryVariables>(TableOfContentsDocument, options);
      }
export function useTableOfContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TableOfContentsQuery, TableOfContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TableOfContentsQuery, TableOfContentsQueryVariables>(TableOfContentsDocument, options);
        }
// @ts-ignore
export function useTableOfContentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TableOfContentsQuery, TableOfContentsQueryVariables>): Apollo.UseSuspenseQueryResult<TableOfContentsQuery, TableOfContentsQueryVariables>;
export function useTableOfContentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TableOfContentsQuery, TableOfContentsQueryVariables>): Apollo.UseSuspenseQueryResult<TableOfContentsQuery | undefined, TableOfContentsQueryVariables>;
export function useTableOfContentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TableOfContentsQuery, TableOfContentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TableOfContentsQuery, TableOfContentsQueryVariables>(TableOfContentsDocument, options);
        }
export type TableOfContentsQueryHookResult = ReturnType<typeof useTableOfContentsQuery>;
export type TableOfContentsLazyQueryHookResult = ReturnType<typeof useTableOfContentsLazyQuery>;
export type TableOfContentsSuspenseQueryHookResult = ReturnType<typeof useTableOfContentsSuspenseQuery>;
export type TableOfContentsQueryResult = Apollo.QueryResult<TableOfContentsQuery, TableOfContentsQueryVariables>;
export const TrackOverviewDocument = gql`
    query TrackOverview($topicName: String!) {
  getTrackOverview(topicName: $topicName) {
    name
    description
    objectives
    lessons {
      name
      description
    }
    skillRequirements
    otherRequirements
    otherRequirementsTitle
    prerequisites {
      name
      subfield
      field
      mastery
    }
  }
}
    `;

/**
 * __useTrackOverviewQuery__
 *
 * To run a query within a React component, call `useTrackOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackOverviewQuery({
 *   variables: {
 *      topicName: // value for 'topicName'
 *   },
 * });
 */
export function useTrackOverviewQuery(baseOptions: Apollo.QueryHookOptions<TrackOverviewQuery, TrackOverviewQueryVariables> & ({ variables: TrackOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackOverviewQuery, TrackOverviewQueryVariables>(TrackOverviewDocument, options);
      }
export function useTrackOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackOverviewQuery, TrackOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackOverviewQuery, TrackOverviewQueryVariables>(TrackOverviewDocument, options);
        }
// @ts-ignore
export function useTrackOverviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrackOverviewQuery, TrackOverviewQueryVariables>): Apollo.UseSuspenseQueryResult<TrackOverviewQuery, TrackOverviewQueryVariables>;
export function useTrackOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrackOverviewQuery, TrackOverviewQueryVariables>): Apollo.UseSuspenseQueryResult<TrackOverviewQuery | undefined, TrackOverviewQueryVariables>;
export function useTrackOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrackOverviewQuery, TrackOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrackOverviewQuery, TrackOverviewQueryVariables>(TrackOverviewDocument, options);
        }
export type TrackOverviewQueryHookResult = ReturnType<typeof useTrackOverviewQuery>;
export type TrackOverviewLazyQueryHookResult = ReturnType<typeof useTrackOverviewLazyQuery>;
export type TrackOverviewSuspenseQueryHookResult = ReturnType<typeof useTrackOverviewSuspenseQuery>;
export type TrackOverviewQueryResult = Apollo.QueryResult<TrackOverviewQuery, TrackOverviewQueryVariables>;
export const UserProgressDocument = gql`
    query UserProgress($nodeName: String!, $nodeLabel: NodeLabel!) {
  getUserProgress(nodeName: $nodeName, nodeLabel: $nodeLabel) {
    child {
      name
      label
      totalTracks
      completedTracks
    }
    totalMastery
    lastModified
  }
}
    `;

/**
 * __useUserProgressQuery__
 *
 * To run a query within a React component, call `useUserProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProgressQuery({
 *   variables: {
 *      nodeName: // value for 'nodeName'
 *      nodeLabel: // value for 'nodeLabel'
 *   },
 * });
 */
export function useUserProgressQuery(baseOptions: Apollo.QueryHookOptions<UserProgressQuery, UserProgressQueryVariables> & ({ variables: UserProgressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProgressQuery, UserProgressQueryVariables>(UserProgressDocument, options);
      }
export function useUserProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProgressQuery, UserProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProgressQuery, UserProgressQueryVariables>(UserProgressDocument, options);
        }
// @ts-ignore
export function useUserProgressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserProgressQuery, UserProgressQueryVariables>): Apollo.UseSuspenseQueryResult<UserProgressQuery, UserProgressQueryVariables>;
export function useUserProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserProgressQuery, UserProgressQueryVariables>): Apollo.UseSuspenseQueryResult<UserProgressQuery | undefined, UserProgressQueryVariables>;
export function useUserProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserProgressQuery, UserProgressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserProgressQuery, UserProgressQueryVariables>(UserProgressDocument, options);
        }
export type UserProgressQueryHookResult = ReturnType<typeof useUserProgressQuery>;
export type UserProgressLazyQueryHookResult = ReturnType<typeof useUserProgressLazyQuery>;
export type UserProgressSuspenseQueryHookResult = ReturnType<typeof useUserProgressSuspenseQuery>;
export type UserProgressQueryResult = Apollo.QueryResult<UserProgressQuery, UserProgressQueryVariables>;
export const GetFirstSubchapterByTopicNameDocument = gql`
    query GetFirstSubchapterByTopicName($topicName: String!) {
  getFirstSubchapterByTopicName(topicName: $topicName) {
    success
    message
    id
    name
    description
    objectives {
      id
      title
      description
      completed
    }
  }
}
    `;

/**
 * __useGetFirstSubchapterByTopicNameQuery__
 *
 * To run a query within a React component, call `useGetFirstSubchapterByTopicNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFirstSubchapterByTopicNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFirstSubchapterByTopicNameQuery({
 *   variables: {
 *      topicName: // value for 'topicName'
 *   },
 * });
 */
export function useGetFirstSubchapterByTopicNameQuery(baseOptions: Apollo.QueryHookOptions<GetFirstSubchapterByTopicNameQuery, GetFirstSubchapterByTopicNameQueryVariables> & ({ variables: GetFirstSubchapterByTopicNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFirstSubchapterByTopicNameQuery, GetFirstSubchapterByTopicNameQueryVariables>(GetFirstSubchapterByTopicNameDocument, options);
      }
export function useGetFirstSubchapterByTopicNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFirstSubchapterByTopicNameQuery, GetFirstSubchapterByTopicNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFirstSubchapterByTopicNameQuery, GetFirstSubchapterByTopicNameQueryVariables>(GetFirstSubchapterByTopicNameDocument, options);
        }
// @ts-ignore
export function useGetFirstSubchapterByTopicNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFirstSubchapterByTopicNameQuery, GetFirstSubchapterByTopicNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetFirstSubchapterByTopicNameQuery, GetFirstSubchapterByTopicNameQueryVariables>;
export function useGetFirstSubchapterByTopicNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFirstSubchapterByTopicNameQuery, GetFirstSubchapterByTopicNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetFirstSubchapterByTopicNameQuery | undefined, GetFirstSubchapterByTopicNameQueryVariables>;
export function useGetFirstSubchapterByTopicNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFirstSubchapterByTopicNameQuery, GetFirstSubchapterByTopicNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFirstSubchapterByTopicNameQuery, GetFirstSubchapterByTopicNameQueryVariables>(GetFirstSubchapterByTopicNameDocument, options);
        }
export type GetFirstSubchapterByTopicNameQueryHookResult = ReturnType<typeof useGetFirstSubchapterByTopicNameQuery>;
export type GetFirstSubchapterByTopicNameLazyQueryHookResult = ReturnType<typeof useGetFirstSubchapterByTopicNameLazyQuery>;
export type GetFirstSubchapterByTopicNameSuspenseQueryHookResult = ReturnType<typeof useGetFirstSubchapterByTopicNameSuspenseQuery>;
export type GetFirstSubchapterByTopicNameQueryResult = Apollo.QueryResult<GetFirstSubchapterByTopicNameQuery, GetFirstSubchapterByTopicNameQueryVariables>;
export const GetLearningObjectiveByIdDocument = gql`
    query GetLearningObjectiveById($loId: ID!) {
  getLearningObjectiveById(loId: $loId) {
    success
    message
    id
    title
    description
    completed
  }
}
    `;

/**
 * __useGetLearningObjectiveByIdQuery__
 *
 * To run a query within a React component, call `useGetLearningObjectiveByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearningObjectiveByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearningObjectiveByIdQuery({
 *   variables: {
 *      loId: // value for 'loId'
 *   },
 * });
 */
export function useGetLearningObjectiveByIdQuery(baseOptions: Apollo.QueryHookOptions<GetLearningObjectiveByIdQuery, GetLearningObjectiveByIdQueryVariables> & ({ variables: GetLearningObjectiveByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLearningObjectiveByIdQuery, GetLearningObjectiveByIdQueryVariables>(GetLearningObjectiveByIdDocument, options);
      }
export function useGetLearningObjectiveByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLearningObjectiveByIdQuery, GetLearningObjectiveByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLearningObjectiveByIdQuery, GetLearningObjectiveByIdQueryVariables>(GetLearningObjectiveByIdDocument, options);
        }
// @ts-ignore
export function useGetLearningObjectiveByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLearningObjectiveByIdQuery, GetLearningObjectiveByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetLearningObjectiveByIdQuery, GetLearningObjectiveByIdQueryVariables>;
export function useGetLearningObjectiveByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLearningObjectiveByIdQuery, GetLearningObjectiveByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetLearningObjectiveByIdQuery | undefined, GetLearningObjectiveByIdQueryVariables>;
export function useGetLearningObjectiveByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLearningObjectiveByIdQuery, GetLearningObjectiveByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLearningObjectiveByIdQuery, GetLearningObjectiveByIdQueryVariables>(GetLearningObjectiveByIdDocument, options);
        }
export type GetLearningObjectiveByIdQueryHookResult = ReturnType<typeof useGetLearningObjectiveByIdQuery>;
export type GetLearningObjectiveByIdLazyQueryHookResult = ReturnType<typeof useGetLearningObjectiveByIdLazyQuery>;
export type GetLearningObjectiveByIdSuspenseQueryHookResult = ReturnType<typeof useGetLearningObjectiveByIdSuspenseQuery>;
export type GetLearningObjectiveByIdQueryResult = Apollo.QueryResult<GetLearningObjectiveByIdQuery, GetLearningObjectiveByIdQueryVariables>;
export const GetLearningObjectivesBySubchapterDocument = gql`
    query GetLearningObjectivesBySubchapter($learningObjectiveId: ID!) {
  getLearningObjectivesBySubchapter(learningObjectiveId: $learningObjectiveId) {
    id
    title
    description
    index
    completed
  }
}
    `;

/**
 * __useGetLearningObjectivesBySubchapterQuery__
 *
 * To run a query within a React component, call `useGetLearningObjectivesBySubchapterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearningObjectivesBySubchapterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearningObjectivesBySubchapterQuery({
 *   variables: {
 *      learningObjectiveId: // value for 'learningObjectiveId'
 *   },
 * });
 */
export function useGetLearningObjectivesBySubchapterQuery(baseOptions: Apollo.QueryHookOptions<GetLearningObjectivesBySubchapterQuery, GetLearningObjectivesBySubchapterQueryVariables> & ({ variables: GetLearningObjectivesBySubchapterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLearningObjectivesBySubchapterQuery, GetLearningObjectivesBySubchapterQueryVariables>(GetLearningObjectivesBySubchapterDocument, options);
      }
export function useGetLearningObjectivesBySubchapterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLearningObjectivesBySubchapterQuery, GetLearningObjectivesBySubchapterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLearningObjectivesBySubchapterQuery, GetLearningObjectivesBySubchapterQueryVariables>(GetLearningObjectivesBySubchapterDocument, options);
        }
// @ts-ignore
export function useGetLearningObjectivesBySubchapterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLearningObjectivesBySubchapterQuery, GetLearningObjectivesBySubchapterQueryVariables>): Apollo.UseSuspenseQueryResult<GetLearningObjectivesBySubchapterQuery, GetLearningObjectivesBySubchapterQueryVariables>;
export function useGetLearningObjectivesBySubchapterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLearningObjectivesBySubchapterQuery, GetLearningObjectivesBySubchapterQueryVariables>): Apollo.UseSuspenseQueryResult<GetLearningObjectivesBySubchapterQuery | undefined, GetLearningObjectivesBySubchapterQueryVariables>;
export function useGetLearningObjectivesBySubchapterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLearningObjectivesBySubchapterQuery, GetLearningObjectivesBySubchapterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLearningObjectivesBySubchapterQuery, GetLearningObjectivesBySubchapterQueryVariables>(GetLearningObjectivesBySubchapterDocument, options);
        }
export type GetLearningObjectivesBySubchapterQueryHookResult = ReturnType<typeof useGetLearningObjectivesBySubchapterQuery>;
export type GetLearningObjectivesBySubchapterLazyQueryHookResult = ReturnType<typeof useGetLearningObjectivesBySubchapterLazyQuery>;
export type GetLearningObjectivesBySubchapterSuspenseQueryHookResult = ReturnType<typeof useGetLearningObjectivesBySubchapterSuspenseQuery>;
export type GetLearningObjectivesBySubchapterQueryResult = Apollo.QueryResult<GetLearningObjectivesBySubchapterQuery, GetLearningObjectivesBySubchapterQueryVariables>;
export const SubchapterByIdDocument = gql`
    query SubchapterById($name: String!) {
  getSubchapterById(name: $name) {
    id
    name
    description
    objectives {
      id
      title
      description
      completed
    }
    totalMastery
  }
}
    `;

/**
 * __useSubchapterByIdQuery__
 *
 * To run a query within a React component, call `useSubchapterByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubchapterByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubchapterByIdQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSubchapterByIdQuery(baseOptions: Apollo.QueryHookOptions<SubchapterByIdQuery, SubchapterByIdQueryVariables> & ({ variables: SubchapterByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubchapterByIdQuery, SubchapterByIdQueryVariables>(SubchapterByIdDocument, options);
      }
export function useSubchapterByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubchapterByIdQuery, SubchapterByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubchapterByIdQuery, SubchapterByIdQueryVariables>(SubchapterByIdDocument, options);
        }
// @ts-ignore
export function useSubchapterByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubchapterByIdQuery, SubchapterByIdQueryVariables>): Apollo.UseSuspenseQueryResult<SubchapterByIdQuery, SubchapterByIdQueryVariables>;
export function useSubchapterByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubchapterByIdQuery, SubchapterByIdQueryVariables>): Apollo.UseSuspenseQueryResult<SubchapterByIdQuery | undefined, SubchapterByIdQueryVariables>;
export function useSubchapterByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubchapterByIdQuery, SubchapterByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubchapterByIdQuery, SubchapterByIdQueryVariables>(SubchapterByIdDocument, options);
        }
export type SubchapterByIdQueryHookResult = ReturnType<typeof useSubchapterByIdQuery>;
export type SubchapterByIdLazyQueryHookResult = ReturnType<typeof useSubchapterByIdLazyQuery>;
export type SubchapterByIdSuspenseQueryHookResult = ReturnType<typeof useSubchapterByIdSuspenseQuery>;
export type SubchapterByIdQueryResult = Apollo.QueryResult<SubchapterByIdQuery, SubchapterByIdQueryVariables>;
export const GetMasteryDocument = gql`
    query GetMastery($learningObjectiveId: ID!) {
  getUserLearningObjectiveMastery(learningObjectiveId: $learningObjectiveId) {
    learningObjectiveId
    userId
    totalMastery
  }
}
    `;

/**
 * __useGetMasteryQuery__
 *
 * To run a query within a React component, call `useGetMasteryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMasteryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMasteryQuery({
 *   variables: {
 *      learningObjectiveId: // value for 'learningObjectiveId'
 *   },
 * });
 */
export function useGetMasteryQuery(baseOptions: Apollo.QueryHookOptions<GetMasteryQuery, GetMasteryQueryVariables> & ({ variables: GetMasteryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMasteryQuery, GetMasteryQueryVariables>(GetMasteryDocument, options);
      }
export function useGetMasteryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMasteryQuery, GetMasteryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMasteryQuery, GetMasteryQueryVariables>(GetMasteryDocument, options);
        }
// @ts-ignore
export function useGetMasterySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMasteryQuery, GetMasteryQueryVariables>): Apollo.UseSuspenseQueryResult<GetMasteryQuery, GetMasteryQueryVariables>;
export function useGetMasterySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMasteryQuery, GetMasteryQueryVariables>): Apollo.UseSuspenseQueryResult<GetMasteryQuery | undefined, GetMasteryQueryVariables>;
export function useGetMasterySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMasteryQuery, GetMasteryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMasteryQuery, GetMasteryQueryVariables>(GetMasteryDocument, options);
        }
export type GetMasteryQueryHookResult = ReturnType<typeof useGetMasteryQuery>;
export type GetMasteryLazyQueryHookResult = ReturnType<typeof useGetMasteryLazyQuery>;
export type GetMasterySuspenseQueryHookResult = ReturnType<typeof useGetMasterySuspenseQuery>;
export type GetMasteryQueryResult = Apollo.QueryResult<GetMasteryQuery, GetMasteryQueryVariables>;
export const GetUserNotificationsDocument = gql`
    query GetUserNotifications {
  getUserNotifications {
    success
    message
    data {
      id
      title
      message
      created
      type
      isRead
      actionUrl
      event {
        id
        eventType
      }
    }
    count
  }
}
    `;

/**
 * __useGetUserNotificationsQuery__
 *
 * To run a query within a React component, call `useGetUserNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>(GetUserNotificationsDocument, options);
      }
export function useGetUserNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>(GetUserNotificationsDocument, options);
        }
// @ts-ignore
export function useGetUserNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>;
export function useGetUserNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserNotificationsQuery | undefined, GetUserNotificationsQueryVariables>;
export function useGetUserNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>(GetUserNotificationsDocument, options);
        }
export type GetUserNotificationsQueryHookResult = ReturnType<typeof useGetUserNotificationsQuery>;
export type GetUserNotificationsLazyQueryHookResult = ReturnType<typeof useGetUserNotificationsLazyQuery>;
export type GetUserNotificationsSuspenseQueryHookResult = ReturnType<typeof useGetUserNotificationsSuspenseQuery>;
export type GetUserNotificationsQueryResult = Apollo.QueryResult<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>;
export const GetOAuthClientDocument = gql`
    query GetOAuthClient($id: ID!) {
  getOAuthClient(id: $id) {
    success
    message
    data {
      id
      clientId
      clientSecret
      created
      tenant {
        id
        tenantDomain
      }
    }
    count
  }
}
    `;

/**
 * __useGetOAuthClientQuery__
 *
 * To run a query within a React component, call `useGetOAuthClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOAuthClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOAuthClientQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOAuthClientQuery(baseOptions: Apollo.QueryHookOptions<GetOAuthClientQuery, GetOAuthClientQueryVariables> & ({ variables: GetOAuthClientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOAuthClientQuery, GetOAuthClientQueryVariables>(GetOAuthClientDocument, options);
      }
export function useGetOAuthClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOAuthClientQuery, GetOAuthClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOAuthClientQuery, GetOAuthClientQueryVariables>(GetOAuthClientDocument, options);
        }
// @ts-ignore
export function useGetOAuthClientSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOAuthClientQuery, GetOAuthClientQueryVariables>): Apollo.UseSuspenseQueryResult<GetOAuthClientQuery, GetOAuthClientQueryVariables>;
export function useGetOAuthClientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOAuthClientQuery, GetOAuthClientQueryVariables>): Apollo.UseSuspenseQueryResult<GetOAuthClientQuery | undefined, GetOAuthClientQueryVariables>;
export function useGetOAuthClientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOAuthClientQuery, GetOAuthClientQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOAuthClientQuery, GetOAuthClientQueryVariables>(GetOAuthClientDocument, options);
        }
export type GetOAuthClientQueryHookResult = ReturnType<typeof useGetOAuthClientQuery>;
export type GetOAuthClientLazyQueryHookResult = ReturnType<typeof useGetOAuthClientLazyQuery>;
export type GetOAuthClientSuspenseQueryHookResult = ReturnType<typeof useGetOAuthClientSuspenseQuery>;
export type GetOAuthClientQueryResult = Apollo.QueryResult<GetOAuthClientQuery, GetOAuthClientQueryVariables>;
export const GetOAuthClientsDocument = gql`
    query GetOAuthClients {
  getOAuthClients {
    success
    message
    data {
      id
      clientId
      clientSecret
      created
      tenant {
        id
        tenantDomain
      }
    }
    count
  }
}
    `;

/**
 * __useGetOAuthClientsQuery__
 *
 * To run a query within a React component, call `useGetOAuthClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOAuthClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOAuthClientsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOAuthClientsQuery(baseOptions?: Apollo.QueryHookOptions<GetOAuthClientsQuery, GetOAuthClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOAuthClientsQuery, GetOAuthClientsQueryVariables>(GetOAuthClientsDocument, options);
      }
export function useGetOAuthClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOAuthClientsQuery, GetOAuthClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOAuthClientsQuery, GetOAuthClientsQueryVariables>(GetOAuthClientsDocument, options);
        }
// @ts-ignore
export function useGetOAuthClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOAuthClientsQuery, GetOAuthClientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOAuthClientsQuery, GetOAuthClientsQueryVariables>;
export function useGetOAuthClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOAuthClientsQuery, GetOAuthClientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOAuthClientsQuery | undefined, GetOAuthClientsQueryVariables>;
export function useGetOAuthClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOAuthClientsQuery, GetOAuthClientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOAuthClientsQuery, GetOAuthClientsQueryVariables>(GetOAuthClientsDocument, options);
        }
export type GetOAuthClientsQueryHookResult = ReturnType<typeof useGetOAuthClientsQuery>;
export type GetOAuthClientsLazyQueryHookResult = ReturnType<typeof useGetOAuthClientsLazyQuery>;
export type GetOAuthClientsSuspenseQueryHookResult = ReturnType<typeof useGetOAuthClientsSuspenseQuery>;
export type GetOAuthClientsQueryResult = Apollo.QueryResult<GetOAuthClientsQuery, GetOAuthClientsQueryVariables>;
export const ExportCsvDocument = gql`
    query ExportCsv {
  exportCsv {
    success
    csvData
    message
  }
}
    `;

/**
 * __useExportCsvQuery__
 *
 * To run a query within a React component, call `useExportCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportCsvQuery({
 *   variables: {
 *   },
 * });
 */
export function useExportCsvQuery(baseOptions?: Apollo.QueryHookOptions<ExportCsvQuery, ExportCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportCsvQuery, ExportCsvQueryVariables>(ExportCsvDocument, options);
      }
export function useExportCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportCsvQuery, ExportCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportCsvQuery, ExportCsvQueryVariables>(ExportCsvDocument, options);
        }
// @ts-ignore
export function useExportCsvSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportCsvQuery, ExportCsvQueryVariables>): Apollo.UseSuspenseQueryResult<ExportCsvQuery, ExportCsvQueryVariables>;
export function useExportCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportCsvQuery, ExportCsvQueryVariables>): Apollo.UseSuspenseQueryResult<ExportCsvQuery | undefined, ExportCsvQueryVariables>;
export function useExportCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportCsvQuery, ExportCsvQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportCsvQuery, ExportCsvQueryVariables>(ExportCsvDocument, options);
        }
export type ExportCsvQueryHookResult = ReturnType<typeof useExportCsvQuery>;
export type ExportCsvLazyQueryHookResult = ReturnType<typeof useExportCsvLazyQuery>;
export type ExportCsvSuspenseQueryHookResult = ReturnType<typeof useExportCsvSuspenseQuery>;
export type ExportCsvQueryResult = Apollo.QueryResult<ExportCsvQuery, ExportCsvQueryVariables>;
export const AssignmentsDocument = gql`
    query Assignments {
  getAssignments {
    id
    title
    description
    gradePoints
    createdDate
    pointsPossible
    dueDate
    url
    objectives {
      id
      objective
      status
    }
  }
}
    `;

/**
 * __useAssignmentsQuery__
 *
 * To run a query within a React component, call `useAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAssignmentsQuery(baseOptions?: Apollo.QueryHookOptions<AssignmentsQuery, AssignmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssignmentsQuery, AssignmentsQueryVariables>(AssignmentsDocument, options);
      }
export function useAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssignmentsQuery, AssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssignmentsQuery, AssignmentsQueryVariables>(AssignmentsDocument, options);
        }
// @ts-ignore
export function useAssignmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AssignmentsQuery, AssignmentsQueryVariables>): Apollo.UseSuspenseQueryResult<AssignmentsQuery, AssignmentsQueryVariables>;
export function useAssignmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssignmentsQuery, AssignmentsQueryVariables>): Apollo.UseSuspenseQueryResult<AssignmentsQuery | undefined, AssignmentsQueryVariables>;
export function useAssignmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssignmentsQuery, AssignmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssignmentsQuery, AssignmentsQueryVariables>(AssignmentsDocument, options);
        }
export type AssignmentsQueryHookResult = ReturnType<typeof useAssignmentsQuery>;
export type AssignmentsLazyQueryHookResult = ReturnType<typeof useAssignmentsLazyQuery>;
export type AssignmentsSuspenseQueryHookResult = ReturnType<typeof useAssignmentsSuspenseQuery>;
export type AssignmentsQueryResult = Apollo.QueryResult<AssignmentsQuery, AssignmentsQueryVariables>;
export const SchoolsDocument = gql`
    query Schools {
  getSchools {
    id
    provider_name
    team_name
    provider_icon_url
  }
}
    `;

/**
 * __useSchoolsQuery__
 *
 * To run a query within a React component, call `useSchoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSchoolsQuery(baseOptions?: Apollo.QueryHookOptions<SchoolsQuery, SchoolsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchoolsQuery, SchoolsQueryVariables>(SchoolsDocument, options);
      }
export function useSchoolsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchoolsQuery, SchoolsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchoolsQuery, SchoolsQueryVariables>(SchoolsDocument, options);
        }
// @ts-ignore
export function useSchoolsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SchoolsQuery, SchoolsQueryVariables>): Apollo.UseSuspenseQueryResult<SchoolsQuery, SchoolsQueryVariables>;
export function useSchoolsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SchoolsQuery, SchoolsQueryVariables>): Apollo.UseSuspenseQueryResult<SchoolsQuery | undefined, SchoolsQueryVariables>;
export function useSchoolsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SchoolsQuery, SchoolsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchoolsQuery, SchoolsQueryVariables>(SchoolsDocument, options);
        }
export type SchoolsQueryHookResult = ReturnType<typeof useSchoolsQuery>;
export type SchoolsLazyQueryHookResult = ReturnType<typeof useSchoolsLazyQuery>;
export type SchoolsSuspenseQueryHookResult = ReturnType<typeof useSchoolsSuspenseQuery>;
export type SchoolsQueryResult = Apollo.QueryResult<SchoolsQuery, SchoolsQueryVariables>;
export const DeleteTodoDocument = gql`
    mutation DeleteTodo($id: String!) {
  deleteTodo(id: $id) {
    success
    message
  }
}
    `;
export type DeleteTodoMutationFn = Apollo.MutationFunction<DeleteTodoMutation, DeleteTodoMutationVariables>;

/**
 * __useDeleteTodoMutation__
 *
 * To run a mutation, you first call `useDeleteTodoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTodoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTodoMutation, { data, loading, error }] = useDeleteTodoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTodoMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTodoMutation, DeleteTodoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTodoMutation, DeleteTodoMutationVariables>(DeleteTodoDocument, options);
      }
export type DeleteTodoMutationHookResult = ReturnType<typeof useDeleteTodoMutation>;
export type DeleteTodoMutationResult = Apollo.MutationResult<DeleteTodoMutation>;
export type DeleteTodoMutationOptions = Apollo.BaseMutationOptions<DeleteTodoMutation, DeleteTodoMutationVariables>;
export const RecentTodosDocument = gql`
    query RecentTodos {
  getRecentTodosForUser {
    success
    message
    count
    data {
      id
      name
      description
      priority
      date
      completed
      completed_date
      isRecurring
      recurringFrequency
      recurringDaily
      recurringDayOfWeek
      recurringDayOfMonth
      recurringTime
      timeOfDay
      timezone
      aiSummary
      workspacesHasTodo {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useRecentTodosQuery__
 *
 * To run a query within a React component, call `useRecentTodosQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentTodosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentTodosQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecentTodosQuery(baseOptions?: Apollo.QueryHookOptions<RecentTodosQuery, RecentTodosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentTodosQuery, RecentTodosQueryVariables>(RecentTodosDocument, options);
      }
export function useRecentTodosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentTodosQuery, RecentTodosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentTodosQuery, RecentTodosQueryVariables>(RecentTodosDocument, options);
        }
// @ts-ignore
export function useRecentTodosSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RecentTodosQuery, RecentTodosQueryVariables>): Apollo.UseSuspenseQueryResult<RecentTodosQuery, RecentTodosQueryVariables>;
export function useRecentTodosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecentTodosQuery, RecentTodosQueryVariables>): Apollo.UseSuspenseQueryResult<RecentTodosQuery | undefined, RecentTodosQueryVariables>;
export function useRecentTodosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecentTodosQuery, RecentTodosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecentTodosQuery, RecentTodosQueryVariables>(RecentTodosDocument, options);
        }
export type RecentTodosQueryHookResult = ReturnType<typeof useRecentTodosQuery>;
export type RecentTodosLazyQueryHookResult = ReturnType<typeof useRecentTodosLazyQuery>;
export type RecentTodosSuspenseQueryHookResult = ReturnType<typeof useRecentTodosSuspenseQuery>;
export type RecentTodosQueryResult = Apollo.QueryResult<RecentTodosQuery, RecentTodosQueryVariables>;
export const SearchTodosDocument = gql`
    query SearchTodos($searchQuery: String) {
  searchTodosForUser(searchQuery: $searchQuery) {
    success
    message
    count
    data {
      id
      name
      description
      priority
      date
      completed
      completed_date
      isRecurring
      recurringFrequency
      recurringDaily
      recurringDayOfWeek
      recurringDayOfMonth
      recurringTime
      timeOfDay
      timezone
      aiSummary
      workspacesHasTodo {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useSearchTodosQuery__
 *
 * To run a query within a React component, call `useSearchTodosQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTodosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTodosQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useSearchTodosQuery(baseOptions?: Apollo.QueryHookOptions<SearchTodosQuery, SearchTodosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchTodosQuery, SearchTodosQueryVariables>(SearchTodosDocument, options);
      }
export function useSearchTodosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchTodosQuery, SearchTodosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchTodosQuery, SearchTodosQueryVariables>(SearchTodosDocument, options);
        }
// @ts-ignore
export function useSearchTodosSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchTodosQuery, SearchTodosQueryVariables>): Apollo.UseSuspenseQueryResult<SearchTodosQuery, SearchTodosQueryVariables>;
export function useSearchTodosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchTodosQuery, SearchTodosQueryVariables>): Apollo.UseSuspenseQueryResult<SearchTodosQuery | undefined, SearchTodosQueryVariables>;
export function useSearchTodosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchTodosQuery, SearchTodosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchTodosQuery, SearchTodosQueryVariables>(SearchTodosDocument, options);
        }
export type SearchTodosQueryHookResult = ReturnType<typeof useSearchTodosQuery>;
export type SearchTodosLazyQueryHookResult = ReturnType<typeof useSearchTodosLazyQuery>;
export type SearchTodosSuspenseQueryHookResult = ReturnType<typeof useSearchTodosSuspenseQuery>;
export type SearchTodosQueryResult = Apollo.QueryResult<SearchTodosQuery, SearchTodosQueryVariables>;
export const TodosDocument = gql`
    query Todos {
  getTodosForUser {
    success
    message
    count
    data {
      id
      name
      description
      priority
      date
      completed
      completed_date
      isRecurring
      recurringFrequency
      recurringDaily
      recurringDayOfWeek
      recurringDayOfMonth
      recurringTime
      timeOfDay
      timezone
      aiSummary
      workspacesHasTodo {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useTodosQuery__
 *
 * To run a query within a React component, call `useTodosQuery` and pass it any options that fit your needs.
 * When your component renders, `useTodosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTodosQuery({
 *   variables: {
 *   },
 * });
 */
export function useTodosQuery(baseOptions?: Apollo.QueryHookOptions<TodosQuery, TodosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TodosQuery, TodosQueryVariables>(TodosDocument, options);
      }
export function useTodosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TodosQuery, TodosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TodosQuery, TodosQueryVariables>(TodosDocument, options);
        }
// @ts-ignore
export function useTodosSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TodosQuery, TodosQueryVariables>): Apollo.UseSuspenseQueryResult<TodosQuery, TodosQueryVariables>;
export function useTodosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TodosQuery, TodosQueryVariables>): Apollo.UseSuspenseQueryResult<TodosQuery | undefined, TodosQueryVariables>;
export function useTodosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TodosQuery, TodosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TodosQuery, TodosQueryVariables>(TodosDocument, options);
        }
export type TodosQueryHookResult = ReturnType<typeof useTodosQuery>;
export type TodosLazyQueryHookResult = ReturnType<typeof useTodosLazyQuery>;
export type TodosSuspenseQueryHookResult = ReturnType<typeof useTodosSuspenseQuery>;
export type TodosQueryResult = Apollo.QueryResult<TodosQuery, TodosQueryVariables>;
export const GetAllTenantsDocument = gql`
    query GetAllTenants {
  getAllTenants {
    success
    message
    data {
      id
      tenantDomain
      ogDescription
      ogImage
      ogImageHeight
      ogImageWidth
      ogSiteName
      ogTitle
      ogType
      stripeSubscriptionId
      hasTrial
      stripeTrialDays
      externalSendGridDailyEmailTemplateId
      externalSendGridFromEmail
      externalSendGridFromName
      externalSendGridTwilioServiceSID
      moderationSexual
      moderationHate
      moderationHarassment
      moderationSelfHarm
      moderationSexualMinors
      moderationHateThreatening
      moderationViolenceGraphic
      moderationSelfHarmIntent
      moderationSelfHarmInstructions
      moderationHarassmentThreatening
      moderationViolence
      companionName
      key
      isLMS
      isLTI
      isAxioOffering
      isSuggestedInsights
      axioSchools
      primaryColor
      gameMenuBg
      gameMenuTrack
      gameMenuProgress
      gameMenuCardBg
      emulationStatement
      learningEmulationStatement
      logo
      miniLogo
      proLogo
      showMiniLogo
      scope
      additionalScope
      termsOfServiceLink
      generalPrompt
      onboardingPrompt
      customNews
      newsSearchTerms
      showFeedback
      bugReportEmails
      upgradeModalBody
      isFreemium
      hasEmailVerification
      created
      last_modified
      hasProFlow
      stripeSecretKey
      hasDegrees
      hasLearningTopicsInChat
      officialTranscriptsUrl
      financialInformationUrl
      helpCenterUrl
      schoolResourcesUrl
      reportProblemUrl
      scheduleAdvisorCallUrl
      hasTurnBasedAssessments
    }
    count
  }
}
    `;

/**
 * __useGetAllTenantsQuery__
 *
 * To run a query within a React component, call `useGetAllTenantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTenantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTenantsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllTenantsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllTenantsQuery, GetAllTenantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTenantsQuery, GetAllTenantsQueryVariables>(GetAllTenantsDocument, options);
      }
export function useGetAllTenantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTenantsQuery, GetAllTenantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTenantsQuery, GetAllTenantsQueryVariables>(GetAllTenantsDocument, options);
        }
// @ts-ignore
export function useGetAllTenantsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllTenantsQuery, GetAllTenantsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllTenantsQuery, GetAllTenantsQueryVariables>;
export function useGetAllTenantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllTenantsQuery, GetAllTenantsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllTenantsQuery | undefined, GetAllTenantsQueryVariables>;
export function useGetAllTenantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllTenantsQuery, GetAllTenantsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllTenantsQuery, GetAllTenantsQueryVariables>(GetAllTenantsDocument, options);
        }
export type GetAllTenantsQueryHookResult = ReturnType<typeof useGetAllTenantsQuery>;
export type GetAllTenantsLazyQueryHookResult = ReturnType<typeof useGetAllTenantsLazyQuery>;
export type GetAllTenantsSuspenseQueryHookResult = ReturnType<typeof useGetAllTenantsSuspenseQuery>;
export type GetAllTenantsQueryResult = Apollo.QueryResult<GetAllTenantsQuery, GetAllTenantsQueryVariables>;
export const GetContentSafetySettingsDocument = gql`
    query GetContentSafetySettings {
  getContentSafetySettings {
    count
    success
    message
    data {
      sexual
      hate
      harassment
      selfHarm
      violence
    }
  }
}
    `;

/**
 * __useGetContentSafetySettingsQuery__
 *
 * To run a query within a React component, call `useGetContentSafetySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentSafetySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentSafetySettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContentSafetySettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetContentSafetySettingsQuery, GetContentSafetySettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentSafetySettingsQuery, GetContentSafetySettingsQueryVariables>(GetContentSafetySettingsDocument, options);
      }
export function useGetContentSafetySettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentSafetySettingsQuery, GetContentSafetySettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentSafetySettingsQuery, GetContentSafetySettingsQueryVariables>(GetContentSafetySettingsDocument, options);
        }
// @ts-ignore
export function useGetContentSafetySettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContentSafetySettingsQuery, GetContentSafetySettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GetContentSafetySettingsQuery, GetContentSafetySettingsQueryVariables>;
export function useGetContentSafetySettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentSafetySettingsQuery, GetContentSafetySettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GetContentSafetySettingsQuery | undefined, GetContentSafetySettingsQueryVariables>;
export function useGetContentSafetySettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentSafetySettingsQuery, GetContentSafetySettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContentSafetySettingsQuery, GetContentSafetySettingsQueryVariables>(GetContentSafetySettingsDocument, options);
        }
export type GetContentSafetySettingsQueryHookResult = ReturnType<typeof useGetContentSafetySettingsQuery>;
export type GetContentSafetySettingsLazyQueryHookResult = ReturnType<typeof useGetContentSafetySettingsLazyQuery>;
export type GetContentSafetySettingsSuspenseQueryHookResult = ReturnType<typeof useGetContentSafetySettingsSuspenseQuery>;
export type GetContentSafetySettingsQueryResult = Apollo.QueryResult<GetContentSafetySettingsQuery, GetContentSafetySettingsQueryVariables>;
export const GetSamlConfigByTenantDocument = gql`
    query GetSamlConfigByTenant($tenantId: ID!) {
  getSamlConfigByTenant(tenantId: $tenantId) {
    success
    message
    data {
      id
      entryPoint
      issuer
      cert
      callbackUrl
      emailAttribute
      firstNameAttribute
      lastNameAttribute
      signRequest
      signatureAlgorithm
      tenant {
        id
        tenantDomain
      }
    }
  }
}
    `;

/**
 * __useGetSamlConfigByTenantQuery__
 *
 * To run a query within a React component, call `useGetSamlConfigByTenantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSamlConfigByTenantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSamlConfigByTenantQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetSamlConfigByTenantQuery(baseOptions: Apollo.QueryHookOptions<GetSamlConfigByTenantQuery, GetSamlConfigByTenantQueryVariables> & ({ variables: GetSamlConfigByTenantQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSamlConfigByTenantQuery, GetSamlConfigByTenantQueryVariables>(GetSamlConfigByTenantDocument, options);
      }
export function useGetSamlConfigByTenantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSamlConfigByTenantQuery, GetSamlConfigByTenantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSamlConfigByTenantQuery, GetSamlConfigByTenantQueryVariables>(GetSamlConfigByTenantDocument, options);
        }
// @ts-ignore
export function useGetSamlConfigByTenantSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSamlConfigByTenantQuery, GetSamlConfigByTenantQueryVariables>): Apollo.UseSuspenseQueryResult<GetSamlConfigByTenantQuery, GetSamlConfigByTenantQueryVariables>;
export function useGetSamlConfigByTenantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSamlConfigByTenantQuery, GetSamlConfigByTenantQueryVariables>): Apollo.UseSuspenseQueryResult<GetSamlConfigByTenantQuery | undefined, GetSamlConfigByTenantQueryVariables>;
export function useGetSamlConfigByTenantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSamlConfigByTenantQuery, GetSamlConfigByTenantQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSamlConfigByTenantQuery, GetSamlConfigByTenantQueryVariables>(GetSamlConfigByTenantDocument, options);
        }
export type GetSamlConfigByTenantQueryHookResult = ReturnType<typeof useGetSamlConfigByTenantQuery>;
export type GetSamlConfigByTenantLazyQueryHookResult = ReturnType<typeof useGetSamlConfigByTenantLazyQuery>;
export type GetSamlConfigByTenantSuspenseQueryHookResult = ReturnType<typeof useGetSamlConfigByTenantSuspenseQuery>;
export type GetSamlConfigByTenantQueryResult = Apollo.QueryResult<GetSamlConfigByTenantQuery, GetSamlConfigByTenantQueryVariables>;
export const GetTenantDocument = gql`
    query GetTenant {
  getTenant {
    success
    message
    data {
      id
      tenantName
      tenantDomain
      ogDescription
      ogImage
      ogImageHeight
      ogImageWidth
      ogSiteName
      ogTitle
      ogType
      stripeSubscriptionId
      hasTrial
      stripeTrialDays
      externalSendGridDailyEmailTemplateId
      externalSendGridFromEmail
      externalSendGridFromName
      externalSendGridTwilioServiceSID
      moderationSexual
      moderationHate
      moderationHarassment
      moderationSelfHarm
      moderationSexualMinors
      moderationHateThreatening
      moderationViolenceGraphic
      moderationSelfHarmIntent
      moderationSelfHarmInstructions
      moderationHarassmentThreatening
      moderationViolence
      companionName
      isCompanionMode
      key
      isLMS
      isLTI
      ltiLaunchUrl
      isAxioOffering
      isSuggestedInsights
      axioSchools
      hasCourseEnrollment
      primaryColor
      gameMenuBg
      gameMenuTrack
      gameMenuProgress
      gameMenuCardBg
      emulationStatement
      learningEmulationStatement
      logo
      miniLogo
      proLogo
      showMiniLogo
      scope
      additionalScope
      termsOfServiceLink
      generalPrompt
      onboardingPrompt
      customNews
      newsSearchTerms
      showFeedback
      bugReportEmails
      upgradeModalBody
      isFreemium
      hasEmailVerification
      hasDegrees
      created
      last_modified
      isDailyEventEnabled
      emailFooterColor
      emailBackgroundColor
      hasProFlow
      stripeSecretKey
      allowFormSignup
      autoEnrollCourses
      hasLearningTopicsInChat
      favicon16Url
      favicon32Url
      favicon48Url
      favicon180Url
      favicon192Url
      favicon512Url
      faviconIcoUrl
      isTeacherNotifiedOnEnrollment
      officialTranscriptsUrl
      financialInformationUrl
      helpCenterUrl
      schoolResourcesUrl
      reportProblemUrl
      scheduleAdvisorCallUrl
      hasTurnBasedAssessments
      requireSSO
    }
    count
  }
}
    `;

/**
 * __useGetTenantQuery__
 *
 * To run a query within a React component, call `useGetTenantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTenantQuery(baseOptions?: Apollo.QueryHookOptions<GetTenantQuery, GetTenantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantQuery, GetTenantQueryVariables>(GetTenantDocument, options);
      }
export function useGetTenantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantQuery, GetTenantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantQuery, GetTenantQueryVariables>(GetTenantDocument, options);
        }
// @ts-ignore
export function useGetTenantSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTenantQuery, GetTenantQueryVariables>): Apollo.UseSuspenseQueryResult<GetTenantQuery, GetTenantQueryVariables>;
export function useGetTenantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTenantQuery, GetTenantQueryVariables>): Apollo.UseSuspenseQueryResult<GetTenantQuery | undefined, GetTenantQueryVariables>;
export function useGetTenantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTenantQuery, GetTenantQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTenantQuery, GetTenantQueryVariables>(GetTenantDocument, options);
        }
export type GetTenantQueryHookResult = ReturnType<typeof useGetTenantQuery>;
export type GetTenantLazyQueryHookResult = ReturnType<typeof useGetTenantLazyQuery>;
export type GetTenantSuspenseQueryHookResult = ReturnType<typeof useGetTenantSuspenseQuery>;
export type GetTenantQueryResult = Apollo.QueryResult<GetTenantQuery, GetTenantQueryVariables>;
export const GetTenantByDomainDocument = gql`
    query GetTenantByDomain($domain: String!) {
  getTenantByDomain(domain: $domain) {
    success
    message
    data {
      id
      tenantName
      tenantDomain
      ogDescription
      ogImage
      ogImageHeight
      ogImageWidth
      ogSiteName
      ogTitle
      ogType
      stripeSubscriptionId
      hasTrial
      stripeTrialDays
      externalSendGridDailyEmailTemplateId
      externalSendGridFromEmail
      externalSendGridFromName
      externalSendGridTwilioServiceSID
      moderationSexual
      moderationHate
      moderationHarassment
      moderationSelfHarm
      moderationSexualMinors
      moderationHateThreatening
      moderationViolenceGraphic
      moderationSelfHarmIntent
      moderationSelfHarmInstructions
      moderationHarassmentThreatening
      moderationViolence
      companionName
      key
      isLMS
      isLTI
      ltiLaunchUrl
      isAxioOffering
      isSuggestedInsights
      axioSchools
      hasCourseEnrollment
      primaryColor
      gameMenuBg
      gameMenuTrack
      gameMenuProgress
      gameMenuCardBg
      emulationStatement
      learningEmulationStatement
      logo
      miniLogo
      proLogo
      showMiniLogo
      scope
      additionalScope
      termsOfServiceLink
      generalPrompt
      onboardingPrompt
      customNews
      newsSearchTerms
      showFeedback
      bugReportEmails
      upgradeModalBody
      isFreemium
      hasEmailVerification
      hasDegrees
      created
      last_modified
      isDailyEventEnabled
      emailFooterColor
      emailBackgroundColor
      hasProFlow
      stripeSecretKey
      allowFormSignup
      autoEnrollCourses
      hasLearningTopicsInChat
      favicon16Url
      favicon32Url
      favicon48Url
      favicon180Url
      favicon192Url
      favicon512Url
      faviconIcoUrl
      isTeacherNotifiedOnEnrollment
      officialTranscriptsUrl
      financialInformationUrl
      helpCenterUrl
      schoolResourcesUrl
      reportProblemUrl
      scheduleAdvisorCallUrl
      hasTurnBasedAssessments
    }
    count
  }
}
    `;

/**
 * __useGetTenantByDomainQuery__
 *
 * To run a query within a React component, call `useGetTenantByDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantByDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantByDomainQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useGetTenantByDomainQuery(baseOptions: Apollo.QueryHookOptions<GetTenantByDomainQuery, GetTenantByDomainQueryVariables> & ({ variables: GetTenantByDomainQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantByDomainQuery, GetTenantByDomainQueryVariables>(GetTenantByDomainDocument, options);
      }
export function useGetTenantByDomainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantByDomainQuery, GetTenantByDomainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantByDomainQuery, GetTenantByDomainQueryVariables>(GetTenantByDomainDocument, options);
        }
// @ts-ignore
export function useGetTenantByDomainSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTenantByDomainQuery, GetTenantByDomainQueryVariables>): Apollo.UseSuspenseQueryResult<GetTenantByDomainQuery, GetTenantByDomainQueryVariables>;
export function useGetTenantByDomainSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTenantByDomainQuery, GetTenantByDomainQueryVariables>): Apollo.UseSuspenseQueryResult<GetTenantByDomainQuery | undefined, GetTenantByDomainQueryVariables>;
export function useGetTenantByDomainSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTenantByDomainQuery, GetTenantByDomainQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTenantByDomainQuery, GetTenantByDomainQueryVariables>(GetTenantByDomainDocument, options);
        }
export type GetTenantByDomainQueryHookResult = ReturnType<typeof useGetTenantByDomainQuery>;
export type GetTenantByDomainLazyQueryHookResult = ReturnType<typeof useGetTenantByDomainLazyQuery>;
export type GetTenantByDomainSuspenseQueryHookResult = ReturnType<typeof useGetTenantByDomainSuspenseQuery>;
export type GetTenantByDomainQueryResult = Apollo.QueryResult<GetTenantByDomainQuery, GetTenantByDomainQueryVariables>;
export const GetTenantDefaultsDocument = gql`
    query GetTenantDefaults {
  getTenantDefaults {
    success
    message
    data {
      tenantName
      tenantDomain
      ogDescription
      ogImage
      ogImageHeight
      ogImageWidth
      ogSiteName
      ogTitle
      ogType
      stripeSubscriptionId
      hasTrial
      stripeTrialDays
      externalSendGridDailyEmailTemplateId
      externalSendGridFromEmail
      externalSendGridFromName
      externalSendGridTwilioServiceSID
      moderationSexual
      moderationHate
      moderationHarassment
      moderationSelfHarm
      moderationSexualMinors
      moderationHateThreatening
      moderationViolenceGraphic
      moderationSelfHarmIntent
      moderationSelfHarmInstructions
      moderationHarassmentThreatening
      moderationViolence
      companionName
      isCompanionMode
      key
      isLMS
      isLTI
      ltiLaunchUrl
      isAxioOffering
      isSuggestedInsights
      hasCourseEnrollment
      primaryColor
      gameMenuBg
      gameMenuTrack
      gameMenuProgress
      gameMenuCardBg
      emulationStatement
      learningEmulationStatement
      logo
      miniLogo
      proLogo
      showMiniLogo
      scope
      additionalScope
      termsOfServiceLink
      generalPrompt
      onboardingPrompt
      customNews
      newsSearchTerms
      showFeedback
      bugReportEmails
      upgradeModalBody
      isFreemium
      hasEmailVerification
      hasDegrees
      isDailyEventEnabled
      emailFooterColor
      emailBackgroundColor
      hasProFlow
      stripeSecretKey
      allowFormSignup
      autoEnrollCourses
      hasLearningTopicsInChat
      favicon16Url
      favicon32Url
      favicon48Url
      favicon180Url
      favicon192Url
      favicon512Url
      faviconIcoUrl
      isTeacherNotifiedOnEnrollment
      allowStripeDiscountCodes
      doRAG
      officialTranscriptsUrl
      financialInformationUrl
      helpCenterUrl
      schoolResourcesUrl
      reportProblemUrl
      scheduleAdvisorCallUrl
      hasTurnBasedAssessments
    }
    count
  }
}
    `;

/**
 * __useGetTenantDefaultsQuery__
 *
 * To run a query within a React component, call `useGetTenantDefaultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantDefaultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantDefaultsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTenantDefaultsQuery(baseOptions?: Apollo.QueryHookOptions<GetTenantDefaultsQuery, GetTenantDefaultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantDefaultsQuery, GetTenantDefaultsQueryVariables>(GetTenantDefaultsDocument, options);
      }
export function useGetTenantDefaultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantDefaultsQuery, GetTenantDefaultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantDefaultsQuery, GetTenantDefaultsQueryVariables>(GetTenantDefaultsDocument, options);
        }
// @ts-ignore
export function useGetTenantDefaultsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTenantDefaultsQuery, GetTenantDefaultsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTenantDefaultsQuery, GetTenantDefaultsQueryVariables>;
export function useGetTenantDefaultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTenantDefaultsQuery, GetTenantDefaultsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTenantDefaultsQuery | undefined, GetTenantDefaultsQueryVariables>;
export function useGetTenantDefaultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTenantDefaultsQuery, GetTenantDefaultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTenantDefaultsQuery, GetTenantDefaultsQueryVariables>(GetTenantDefaultsDocument, options);
        }
export type GetTenantDefaultsQueryHookResult = ReturnType<typeof useGetTenantDefaultsQuery>;
export type GetTenantDefaultsLazyQueryHookResult = ReturnType<typeof useGetTenantDefaultsLazyQuery>;
export type GetTenantDefaultsSuspenseQueryHookResult = ReturnType<typeof useGetTenantDefaultsSuspenseQuery>;
export type GetTenantDefaultsQueryResult = Apollo.QueryResult<GetTenantDefaultsQuery, GetTenantDefaultsQueryVariables>;
export const GetTenantForSchoolAdminDocument = gql`
    query GetTenantForSchoolAdmin {
  getTenantForSchoolAdmin {
    success
    message
    data {
      id
      tenantName
      tenantDomain
      logo
      primaryColor
      favicon16Url
      favicon180Url
      officialTranscriptsUrl
      financialInformationUrl
      helpCenterUrl
      schoolResourcesUrl
    }
    count
  }
}
    `;

/**
 * __useGetTenantForSchoolAdminQuery__
 *
 * To run a query within a React component, call `useGetTenantForSchoolAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantForSchoolAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantForSchoolAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTenantForSchoolAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetTenantForSchoolAdminQuery, GetTenantForSchoolAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantForSchoolAdminQuery, GetTenantForSchoolAdminQueryVariables>(GetTenantForSchoolAdminDocument, options);
      }
export function useGetTenantForSchoolAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantForSchoolAdminQuery, GetTenantForSchoolAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantForSchoolAdminQuery, GetTenantForSchoolAdminQueryVariables>(GetTenantForSchoolAdminDocument, options);
        }
// @ts-ignore
export function useGetTenantForSchoolAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTenantForSchoolAdminQuery, GetTenantForSchoolAdminQueryVariables>): Apollo.UseSuspenseQueryResult<GetTenantForSchoolAdminQuery, GetTenantForSchoolAdminQueryVariables>;
export function useGetTenantForSchoolAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTenantForSchoolAdminQuery, GetTenantForSchoolAdminQueryVariables>): Apollo.UseSuspenseQueryResult<GetTenantForSchoolAdminQuery | undefined, GetTenantForSchoolAdminQueryVariables>;
export function useGetTenantForSchoolAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTenantForSchoolAdminQuery, GetTenantForSchoolAdminQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTenantForSchoolAdminQuery, GetTenantForSchoolAdminQueryVariables>(GetTenantForSchoolAdminDocument, options);
        }
export type GetTenantForSchoolAdminQueryHookResult = ReturnType<typeof useGetTenantForSchoolAdminQuery>;
export type GetTenantForSchoolAdminLazyQueryHookResult = ReturnType<typeof useGetTenantForSchoolAdminLazyQuery>;
export type GetTenantForSchoolAdminSuspenseQueryHookResult = ReturnType<typeof useGetTenantForSchoolAdminSuspenseQuery>;
export type GetTenantForSchoolAdminQueryResult = Apollo.QueryResult<GetTenantForSchoolAdminQuery, GetTenantForSchoolAdminQueryVariables>;
export const GetTenantSchemaDocument = gql`
    query GetTenantSchema {
  getTenantSchema {
    success
    message
    data
  }
}
    `;

/**
 * __useGetTenantSchemaQuery__
 *
 * To run a query within a React component, call `useGetTenantSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantSchemaQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTenantSchemaQuery(baseOptions?: Apollo.QueryHookOptions<GetTenantSchemaQuery, GetTenantSchemaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantSchemaQuery, GetTenantSchemaQueryVariables>(GetTenantSchemaDocument, options);
      }
export function useGetTenantSchemaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantSchemaQuery, GetTenantSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantSchemaQuery, GetTenantSchemaQueryVariables>(GetTenantSchemaDocument, options);
        }
// @ts-ignore
export function useGetTenantSchemaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTenantSchemaQuery, GetTenantSchemaQueryVariables>): Apollo.UseSuspenseQueryResult<GetTenantSchemaQuery, GetTenantSchemaQueryVariables>;
export function useGetTenantSchemaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTenantSchemaQuery, GetTenantSchemaQueryVariables>): Apollo.UseSuspenseQueryResult<GetTenantSchemaQuery | undefined, GetTenantSchemaQueryVariables>;
export function useGetTenantSchemaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTenantSchemaQuery, GetTenantSchemaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTenantSchemaQuery, GetTenantSchemaQueryVariables>(GetTenantSchemaDocument, options);
        }
export type GetTenantSchemaQueryHookResult = ReturnType<typeof useGetTenantSchemaQuery>;
export type GetTenantSchemaLazyQueryHookResult = ReturnType<typeof useGetTenantSchemaLazyQuery>;
export type GetTenantSchemaSuspenseQueryHookResult = ReturnType<typeof useGetTenantSchemaSuspenseQuery>;
export type GetTenantSchemaQueryResult = Apollo.QueryResult<GetTenantSchemaQuery, GetTenantSchemaQueryVariables>;
export const GetTenantSubmitHelpTicketLinkDocument = gql`
    query GetTenantSubmitHelpTicketLink {
  getTenantSubmitHelpTicketLink {
    success
    message
    data
  }
}
    `;

/**
 * __useGetTenantSubmitHelpTicketLinkQuery__
 *
 * To run a query within a React component, call `useGetTenantSubmitHelpTicketLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantSubmitHelpTicketLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantSubmitHelpTicketLinkQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTenantSubmitHelpTicketLinkQuery(baseOptions?: Apollo.QueryHookOptions<GetTenantSubmitHelpTicketLinkQuery, GetTenantSubmitHelpTicketLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantSubmitHelpTicketLinkQuery, GetTenantSubmitHelpTicketLinkQueryVariables>(GetTenantSubmitHelpTicketLinkDocument, options);
      }
export function useGetTenantSubmitHelpTicketLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantSubmitHelpTicketLinkQuery, GetTenantSubmitHelpTicketLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantSubmitHelpTicketLinkQuery, GetTenantSubmitHelpTicketLinkQueryVariables>(GetTenantSubmitHelpTicketLinkDocument, options);
        }
// @ts-ignore
export function useGetTenantSubmitHelpTicketLinkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTenantSubmitHelpTicketLinkQuery, GetTenantSubmitHelpTicketLinkQueryVariables>): Apollo.UseSuspenseQueryResult<GetTenantSubmitHelpTicketLinkQuery, GetTenantSubmitHelpTicketLinkQueryVariables>;
export function useGetTenantSubmitHelpTicketLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTenantSubmitHelpTicketLinkQuery, GetTenantSubmitHelpTicketLinkQueryVariables>): Apollo.UseSuspenseQueryResult<GetTenantSubmitHelpTicketLinkQuery | undefined, GetTenantSubmitHelpTicketLinkQueryVariables>;
export function useGetTenantSubmitHelpTicketLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTenantSubmitHelpTicketLinkQuery, GetTenantSubmitHelpTicketLinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTenantSubmitHelpTicketLinkQuery, GetTenantSubmitHelpTicketLinkQueryVariables>(GetTenantSubmitHelpTicketLinkDocument, options);
        }
export type GetTenantSubmitHelpTicketLinkQueryHookResult = ReturnType<typeof useGetTenantSubmitHelpTicketLinkQuery>;
export type GetTenantSubmitHelpTicketLinkLazyQueryHookResult = ReturnType<typeof useGetTenantSubmitHelpTicketLinkLazyQuery>;
export type GetTenantSubmitHelpTicketLinkSuspenseQueryHookResult = ReturnType<typeof useGetTenantSubmitHelpTicketLinkSuspenseQuery>;
export type GetTenantSubmitHelpTicketLinkQueryResult = Apollo.QueryResult<GetTenantSubmitHelpTicketLinkQuery, GetTenantSubmitHelpTicketLinkQueryVariables>;
export const GetActiveTracksDocument = gql`
    query GetActiveTracks {
  getActiveTracks {
    name
    description
    last_modified
    totalUnits
    completedUnits
    parentSubfield
    parentFields
    mastery
    imageUrl
  }
}
    `;

/**
 * __useGetActiveTracksQuery__
 *
 * To run a query within a React component, call `useGetActiveTracksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveTracksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveTracksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveTracksQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveTracksQuery, GetActiveTracksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveTracksQuery, GetActiveTracksQueryVariables>(GetActiveTracksDocument, options);
      }
export function useGetActiveTracksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveTracksQuery, GetActiveTracksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveTracksQuery, GetActiveTracksQueryVariables>(GetActiveTracksDocument, options);
        }
// @ts-ignore
export function useGetActiveTracksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActiveTracksQuery, GetActiveTracksQueryVariables>): Apollo.UseSuspenseQueryResult<GetActiveTracksQuery, GetActiveTracksQueryVariables>;
export function useGetActiveTracksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveTracksQuery, GetActiveTracksQueryVariables>): Apollo.UseSuspenseQueryResult<GetActiveTracksQuery | undefined, GetActiveTracksQueryVariables>;
export function useGetActiveTracksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveTracksQuery, GetActiveTracksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveTracksQuery, GetActiveTracksQueryVariables>(GetActiveTracksDocument, options);
        }
export type GetActiveTracksQueryHookResult = ReturnType<typeof useGetActiveTracksQuery>;
export type GetActiveTracksLazyQueryHookResult = ReturnType<typeof useGetActiveTracksLazyQuery>;
export type GetActiveTracksSuspenseQueryHookResult = ReturnType<typeof useGetActiveTracksSuspenseQuery>;
export type GetActiveTracksQueryResult = Apollo.QueryResult<GetActiveTracksQuery, GetActiveTracksQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    audioOn
    countryCode
    currentWeightLbs
    dailyEmailOptIn
    enrolledTracks
    email
    fullPhoneNumber
    gender
    goalWeightLbs
    googleCalendarAuthToken
    id
    isCareerLoading
    isCourseLoading
    isEmailVerified
    isPro
    isOnboarded
    modalOnboarding
    name
    otpPreference
    phoneNumber
    trialEndDate
    username
    meetingLink
    profilePicture
    biography
    enrolledDegrees {
      id
      name
    }
    isFaculty
    created
    skipAllNotificationEmail
    showLearningActivityIntro
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
// @ts-ignore
export function useMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>): Apollo.UseSuspenseQueryResult<MeQuery, MeQueryVariables>;
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>): Apollo.UseSuspenseQueryResult<MeQuery | undefined, MeQueryVariables>;
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const GetCourseSessionAnalyticsDocument = gql`
    query GetCourseSessionAnalytics($input: CourseSessionAnalyticsInput) {
  getCourseSessionAnalytics(input: $input) {
    success
    message
    data {
      id
      name
      course_code
      students
      instructor
      totalSessions
      totalDuration
      averageDuration
      lastActiveDate
      firstActiveDate
    }
    totalCount
    topActiveUsers {
      id
      name
      totalSessions
    }
  }
}
    `;

/**
 * __useGetCourseSessionAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetCourseSessionAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseSessionAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseSessionAnalyticsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCourseSessionAnalyticsQuery(baseOptions?: Apollo.QueryHookOptions<GetCourseSessionAnalyticsQuery, GetCourseSessionAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseSessionAnalyticsQuery, GetCourseSessionAnalyticsQueryVariables>(GetCourseSessionAnalyticsDocument, options);
      }
export function useGetCourseSessionAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseSessionAnalyticsQuery, GetCourseSessionAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseSessionAnalyticsQuery, GetCourseSessionAnalyticsQueryVariables>(GetCourseSessionAnalyticsDocument, options);
        }
// @ts-ignore
export function useGetCourseSessionAnalyticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCourseSessionAnalyticsQuery, GetCourseSessionAnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseSessionAnalyticsQuery, GetCourseSessionAnalyticsQueryVariables>;
export function useGetCourseSessionAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseSessionAnalyticsQuery, GetCourseSessionAnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCourseSessionAnalyticsQuery | undefined, GetCourseSessionAnalyticsQueryVariables>;
export function useGetCourseSessionAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCourseSessionAnalyticsQuery, GetCourseSessionAnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCourseSessionAnalyticsQuery, GetCourseSessionAnalyticsQueryVariables>(GetCourseSessionAnalyticsDocument, options);
        }
export type GetCourseSessionAnalyticsQueryHookResult = ReturnType<typeof useGetCourseSessionAnalyticsQuery>;
export type GetCourseSessionAnalyticsLazyQueryHookResult = ReturnType<typeof useGetCourseSessionAnalyticsLazyQuery>;
export type GetCourseSessionAnalyticsSuspenseQueryHookResult = ReturnType<typeof useGetCourseSessionAnalyticsSuspenseQuery>;
export type GetCourseSessionAnalyticsQueryResult = Apollo.QueryResult<GetCourseSessionAnalyticsQuery, GetCourseSessionAnalyticsQueryVariables>;
export const GetFacultyByNameOrEmailDocument = gql`
    query GetFacultyByNameOrEmail($searchQuery: String!, $schoolId: ID!, $page: Int!, $pageSize: Int) {
  getFacultyByNameOrEmail(
    searchQuery: $searchQuery
    schoolId: $schoolId
    page: $page
    pageSize: $pageSize
  ) {
    success
    message
    data {
      faculties {
        id
        name
        email
        pendingFacultyInvite
        hasRoleRoles {
          name
        }
        teachingCourses {
          id
          name
        }
        hasSessionDeviceSessions {
          id
        }
      }
      totalCount
    }
    count
  }
}
    `;

/**
 * __useGetFacultyByNameOrEmailQuery__
 *
 * To run a query within a React component, call `useGetFacultyByNameOrEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFacultyByNameOrEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFacultyByNameOrEmailQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *      schoolId: // value for 'schoolId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetFacultyByNameOrEmailQuery(baseOptions: Apollo.QueryHookOptions<GetFacultyByNameOrEmailQuery, GetFacultyByNameOrEmailQueryVariables> & ({ variables: GetFacultyByNameOrEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFacultyByNameOrEmailQuery, GetFacultyByNameOrEmailQueryVariables>(GetFacultyByNameOrEmailDocument, options);
      }
export function useGetFacultyByNameOrEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFacultyByNameOrEmailQuery, GetFacultyByNameOrEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFacultyByNameOrEmailQuery, GetFacultyByNameOrEmailQueryVariables>(GetFacultyByNameOrEmailDocument, options);
        }
// @ts-ignore
export function useGetFacultyByNameOrEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFacultyByNameOrEmailQuery, GetFacultyByNameOrEmailQueryVariables>): Apollo.UseSuspenseQueryResult<GetFacultyByNameOrEmailQuery, GetFacultyByNameOrEmailQueryVariables>;
export function useGetFacultyByNameOrEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFacultyByNameOrEmailQuery, GetFacultyByNameOrEmailQueryVariables>): Apollo.UseSuspenseQueryResult<GetFacultyByNameOrEmailQuery | undefined, GetFacultyByNameOrEmailQueryVariables>;
export function useGetFacultyByNameOrEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFacultyByNameOrEmailQuery, GetFacultyByNameOrEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFacultyByNameOrEmailQuery, GetFacultyByNameOrEmailQueryVariables>(GetFacultyByNameOrEmailDocument, options);
        }
export type GetFacultyByNameOrEmailQueryHookResult = ReturnType<typeof useGetFacultyByNameOrEmailQuery>;
export type GetFacultyByNameOrEmailLazyQueryHookResult = ReturnType<typeof useGetFacultyByNameOrEmailLazyQuery>;
export type GetFacultyByNameOrEmailSuspenseQueryHookResult = ReturnType<typeof useGetFacultyByNameOrEmailSuspenseQuery>;
export type GetFacultyByNameOrEmailQueryResult = Apollo.QueryResult<GetFacultyByNameOrEmailQuery, GetFacultyByNameOrEmailQueryVariables>;
export const GetIsInvitationTokenValidDocument = gql`
    query GetIsInvitationTokenValid($token: String!, $service: String!) {
  getIsInvitationTokenValid(token: $token, service: $service) {
    isValid
  }
}
    `;

/**
 * __useGetIsInvitationTokenValidQuery__
 *
 * To run a query within a React component, call `useGetIsInvitationTokenValidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsInvitationTokenValidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsInvitationTokenValidQuery({
 *   variables: {
 *      token: // value for 'token'
 *      service: // value for 'service'
 *   },
 * });
 */
export function useGetIsInvitationTokenValidQuery(baseOptions: Apollo.QueryHookOptions<GetIsInvitationTokenValidQuery, GetIsInvitationTokenValidQueryVariables> & ({ variables: GetIsInvitationTokenValidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIsInvitationTokenValidQuery, GetIsInvitationTokenValidQueryVariables>(GetIsInvitationTokenValidDocument, options);
      }
export function useGetIsInvitationTokenValidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIsInvitationTokenValidQuery, GetIsInvitationTokenValidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIsInvitationTokenValidQuery, GetIsInvitationTokenValidQueryVariables>(GetIsInvitationTokenValidDocument, options);
        }
// @ts-ignore
export function useGetIsInvitationTokenValidSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIsInvitationTokenValidQuery, GetIsInvitationTokenValidQueryVariables>): Apollo.UseSuspenseQueryResult<GetIsInvitationTokenValidQuery, GetIsInvitationTokenValidQueryVariables>;
export function useGetIsInvitationTokenValidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIsInvitationTokenValidQuery, GetIsInvitationTokenValidQueryVariables>): Apollo.UseSuspenseQueryResult<GetIsInvitationTokenValidQuery | undefined, GetIsInvitationTokenValidQueryVariables>;
export function useGetIsInvitationTokenValidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIsInvitationTokenValidQuery, GetIsInvitationTokenValidQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIsInvitationTokenValidQuery, GetIsInvitationTokenValidQueryVariables>(GetIsInvitationTokenValidDocument, options);
        }
export type GetIsInvitationTokenValidQueryHookResult = ReturnType<typeof useGetIsInvitationTokenValidQuery>;
export type GetIsInvitationTokenValidLazyQueryHookResult = ReturnType<typeof useGetIsInvitationTokenValidLazyQuery>;
export type GetIsInvitationTokenValidSuspenseQueryHookResult = ReturnType<typeof useGetIsInvitationTokenValidSuspenseQuery>;
export type GetIsInvitationTokenValidQueryResult = Apollo.QueryResult<GetIsInvitationTokenValidQuery, GetIsInvitationTokenValidQueryVariables>;
export const GetUserLearningPreferencesDocument = gql`
    query GetUserLearningPreferences {
  getUserLearningPreferences {
    id
    interests
    careerInterests
    skillsToImprove
    learningStyles
    motivations
    semesterGoal
    studyTimePreference
    checkInFrequency
    assignmentReminders
    textReminders
  }
}
    `;

/**
 * __useGetUserLearningPreferencesQuery__
 *
 * To run a query within a React component, call `useGetUserLearningPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserLearningPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserLearningPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserLearningPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserLearningPreferencesQuery, GetUserLearningPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserLearningPreferencesQuery, GetUserLearningPreferencesQueryVariables>(GetUserLearningPreferencesDocument, options);
      }
export function useGetUserLearningPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserLearningPreferencesQuery, GetUserLearningPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserLearningPreferencesQuery, GetUserLearningPreferencesQueryVariables>(GetUserLearningPreferencesDocument, options);
        }
// @ts-ignore
export function useGetUserLearningPreferencesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserLearningPreferencesQuery, GetUserLearningPreferencesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserLearningPreferencesQuery, GetUserLearningPreferencesQueryVariables>;
export function useGetUserLearningPreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserLearningPreferencesQuery, GetUserLearningPreferencesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserLearningPreferencesQuery | undefined, GetUserLearningPreferencesQueryVariables>;
export function useGetUserLearningPreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserLearningPreferencesQuery, GetUserLearningPreferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserLearningPreferencesQuery, GetUserLearningPreferencesQueryVariables>(GetUserLearningPreferencesDocument, options);
        }
export type GetUserLearningPreferencesQueryHookResult = ReturnType<typeof useGetUserLearningPreferencesQuery>;
export type GetUserLearningPreferencesLazyQueryHookResult = ReturnType<typeof useGetUserLearningPreferencesLazyQuery>;
export type GetUserLearningPreferencesSuspenseQueryHookResult = ReturnType<typeof useGetUserLearningPreferencesSuspenseQuery>;
export type GetUserLearningPreferencesQueryResult = Apollo.QueryResult<GetUserLearningPreferencesQuery, GetUserLearningPreferencesQueryVariables>;
export const GetUserSessionAnalyticsDocument = gql`
    query GetUserSessionAnalytics($input: UserSessionAnalyticsInput!) {
  getUserSessionAnalytics(input: $input) {
    success
    message
    data {
      id
      name
      email
      totalSessions
      totalDuration
      averageDuration
      lastActiveDate
      firstActiveDate
      courses {
        id
        name
      }
    }
    count
    totalCount
    totalUsers
    totalSessions
    avgSessionLength
  }
}
    `;

/**
 * __useGetUserSessionAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetUserSessionAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSessionAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSessionAnalyticsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUserSessionAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetUserSessionAnalyticsQuery, GetUserSessionAnalyticsQueryVariables> & ({ variables: GetUserSessionAnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserSessionAnalyticsQuery, GetUserSessionAnalyticsQueryVariables>(GetUserSessionAnalyticsDocument, options);
      }
export function useGetUserSessionAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserSessionAnalyticsQuery, GetUserSessionAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserSessionAnalyticsQuery, GetUserSessionAnalyticsQueryVariables>(GetUserSessionAnalyticsDocument, options);
        }
// @ts-ignore
export function useGetUserSessionAnalyticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserSessionAnalyticsQuery, GetUserSessionAnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserSessionAnalyticsQuery, GetUserSessionAnalyticsQueryVariables>;
export function useGetUserSessionAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserSessionAnalyticsQuery, GetUserSessionAnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserSessionAnalyticsQuery | undefined, GetUserSessionAnalyticsQueryVariables>;
export function useGetUserSessionAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserSessionAnalyticsQuery, GetUserSessionAnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserSessionAnalyticsQuery, GetUserSessionAnalyticsQueryVariables>(GetUserSessionAnalyticsDocument, options);
        }
export type GetUserSessionAnalyticsQueryHookResult = ReturnType<typeof useGetUserSessionAnalyticsQuery>;
export type GetUserSessionAnalyticsLazyQueryHookResult = ReturnType<typeof useGetUserSessionAnalyticsLazyQuery>;
export type GetUserSessionAnalyticsSuspenseQueryHookResult = ReturnType<typeof useGetUserSessionAnalyticsSuspenseQuery>;
export type GetUserSessionAnalyticsQueryResult = Apollo.QueryResult<GetUserSessionAnalyticsQuery, GetUserSessionAnalyticsQueryVariables>;
export const GetUserSessionAnalyticsDailyBreakdownDocument = gql`
    query GetUserSessionAnalyticsDailyBreakdown($input: UserSessionAnalyticsDailyBreakdownInput!) {
  getUserSessionAnalyticsDailyBreakdown(input: $input) {
    success
    message
    data {
      day
      date
      sessions
      hourly
    }
  }
}
    `;

/**
 * __useGetUserSessionAnalyticsDailyBreakdownQuery__
 *
 * To run a query within a React component, call `useGetUserSessionAnalyticsDailyBreakdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSessionAnalyticsDailyBreakdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSessionAnalyticsDailyBreakdownQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUserSessionAnalyticsDailyBreakdownQuery(baseOptions: Apollo.QueryHookOptions<GetUserSessionAnalyticsDailyBreakdownQuery, GetUserSessionAnalyticsDailyBreakdownQueryVariables> & ({ variables: GetUserSessionAnalyticsDailyBreakdownQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserSessionAnalyticsDailyBreakdownQuery, GetUserSessionAnalyticsDailyBreakdownQueryVariables>(GetUserSessionAnalyticsDailyBreakdownDocument, options);
      }
export function useGetUserSessionAnalyticsDailyBreakdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserSessionAnalyticsDailyBreakdownQuery, GetUserSessionAnalyticsDailyBreakdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserSessionAnalyticsDailyBreakdownQuery, GetUserSessionAnalyticsDailyBreakdownQueryVariables>(GetUserSessionAnalyticsDailyBreakdownDocument, options);
        }
// @ts-ignore
export function useGetUserSessionAnalyticsDailyBreakdownSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserSessionAnalyticsDailyBreakdownQuery, GetUserSessionAnalyticsDailyBreakdownQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserSessionAnalyticsDailyBreakdownQuery, GetUserSessionAnalyticsDailyBreakdownQueryVariables>;
export function useGetUserSessionAnalyticsDailyBreakdownSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserSessionAnalyticsDailyBreakdownQuery, GetUserSessionAnalyticsDailyBreakdownQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserSessionAnalyticsDailyBreakdownQuery | undefined, GetUserSessionAnalyticsDailyBreakdownQueryVariables>;
export function useGetUserSessionAnalyticsDailyBreakdownSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserSessionAnalyticsDailyBreakdownQuery, GetUserSessionAnalyticsDailyBreakdownQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserSessionAnalyticsDailyBreakdownQuery, GetUserSessionAnalyticsDailyBreakdownQueryVariables>(GetUserSessionAnalyticsDailyBreakdownDocument, options);
        }
export type GetUserSessionAnalyticsDailyBreakdownQueryHookResult = ReturnType<typeof useGetUserSessionAnalyticsDailyBreakdownQuery>;
export type GetUserSessionAnalyticsDailyBreakdownLazyQueryHookResult = ReturnType<typeof useGetUserSessionAnalyticsDailyBreakdownLazyQuery>;
export type GetUserSessionAnalyticsDailyBreakdownSuspenseQueryHookResult = ReturnType<typeof useGetUserSessionAnalyticsDailyBreakdownSuspenseQuery>;
export type GetUserSessionAnalyticsDailyBreakdownQueryResult = Apollo.QueryResult<GetUserSessionAnalyticsDailyBreakdownQuery, GetUserSessionAnalyticsDailyBreakdownQueryVariables>;
export const GetUsersForSchoolDocument = gql`
    query GetUsersForSchool($searchQuery: String!, $schoolId: ID!, $page: Int!, $pageSize: Int, $sortBy: String, $fetchStudentsOnly: Boolean) {
  getUsersForSchool(
    searchQuery: $searchQuery
    schoolId: $schoolId
    page: $page
    pageSize: $pageSize
    sortBy: $sortBy
    fetchStudentsOnly: $fetchStudentsOnly
  ) {
    success
    message
    data {
      faculties {
        id
        name
        email
        pendingFacultyInvite
        pendingCourseEnrollmentInvite
        created
        expiredInvitation
        hasRoleRoles {
          name
        }
        teachingCourses {
          id
          name
          course_code
        }
        hasSessionDeviceSessions {
          id
        }
      }
      totalCount
    }
    count
  }
}
    `;

/**
 * __useGetUsersForSchoolQuery__
 *
 * To run a query within a React component, call `useGetUsersForSchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersForSchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersForSchoolQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *      schoolId: // value for 'schoolId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      sortBy: // value for 'sortBy'
 *      fetchStudentsOnly: // value for 'fetchStudentsOnly'
 *   },
 * });
 */
export function useGetUsersForSchoolQuery(baseOptions: Apollo.QueryHookOptions<GetUsersForSchoolQuery, GetUsersForSchoolQueryVariables> & ({ variables: GetUsersForSchoolQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersForSchoolQuery, GetUsersForSchoolQueryVariables>(GetUsersForSchoolDocument, options);
      }
export function useGetUsersForSchoolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersForSchoolQuery, GetUsersForSchoolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersForSchoolQuery, GetUsersForSchoolQueryVariables>(GetUsersForSchoolDocument, options);
        }
// @ts-ignore
export function useGetUsersForSchoolSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsersForSchoolQuery, GetUsersForSchoolQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersForSchoolQuery, GetUsersForSchoolQueryVariables>;
export function useGetUsersForSchoolSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersForSchoolQuery, GetUsersForSchoolQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersForSchoolQuery | undefined, GetUsersForSchoolQueryVariables>;
export function useGetUsersForSchoolSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersForSchoolQuery, GetUsersForSchoolQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersForSchoolQuery, GetUsersForSchoolQueryVariables>(GetUsersForSchoolDocument, options);
        }
export type GetUsersForSchoolQueryHookResult = ReturnType<typeof useGetUsersForSchoolQuery>;
export type GetUsersForSchoolLazyQueryHookResult = ReturnType<typeof useGetUsersForSchoolLazyQuery>;
export type GetUsersForSchoolSuspenseQueryHookResult = ReturnType<typeof useGetUsersForSchoolSuspenseQuery>;
export type GetUsersForSchoolQueryResult = Apollo.QueryResult<GetUsersForSchoolQuery, GetUsersForSchoolQueryVariables>;
export const GetUsersWithElevatedRolesDocument = gql`
    query GetUsersWithElevatedRoles($schoolId: ID!, $page: Int!, $pageSize: Int, $searchQuery: String, $sortBy: String) {
  getUsersWithElevatedRoles(
    schoolId: $schoolId
    page: $page
    pageSize: $pageSize
    searchQuery: $searchQuery
    sortBy: $sortBy
  ) {
    success
    message
    data {
      faculties {
        id
        name
        email
        pendingFacultyInvite
        expiredInvitation
        hasRoleRoles {
          name
        }
        teachingCourses {
          id
          name
          course_code
        }
        hasSessionDeviceSessions {
          id
        }
      }
      totalCount
    }
    count
  }
}
    `;

/**
 * __useGetUsersWithElevatedRolesQuery__
 *
 * To run a query within a React component, call `useGetUsersWithElevatedRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersWithElevatedRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersWithElevatedRolesQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      searchQuery: // value for 'searchQuery'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetUsersWithElevatedRolesQuery(baseOptions: Apollo.QueryHookOptions<GetUsersWithElevatedRolesQuery, GetUsersWithElevatedRolesQueryVariables> & ({ variables: GetUsersWithElevatedRolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersWithElevatedRolesQuery, GetUsersWithElevatedRolesQueryVariables>(GetUsersWithElevatedRolesDocument, options);
      }
export function useGetUsersWithElevatedRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersWithElevatedRolesQuery, GetUsersWithElevatedRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersWithElevatedRolesQuery, GetUsersWithElevatedRolesQueryVariables>(GetUsersWithElevatedRolesDocument, options);
        }
// @ts-ignore
export function useGetUsersWithElevatedRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsersWithElevatedRolesQuery, GetUsersWithElevatedRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersWithElevatedRolesQuery, GetUsersWithElevatedRolesQueryVariables>;
export function useGetUsersWithElevatedRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersWithElevatedRolesQuery, GetUsersWithElevatedRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersWithElevatedRolesQuery | undefined, GetUsersWithElevatedRolesQueryVariables>;
export function useGetUsersWithElevatedRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersWithElevatedRolesQuery, GetUsersWithElevatedRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersWithElevatedRolesQuery, GetUsersWithElevatedRolesQueryVariables>(GetUsersWithElevatedRolesDocument, options);
        }
export type GetUsersWithElevatedRolesQueryHookResult = ReturnType<typeof useGetUsersWithElevatedRolesQuery>;
export type GetUsersWithElevatedRolesLazyQueryHookResult = ReturnType<typeof useGetUsersWithElevatedRolesLazyQuery>;
export type GetUsersWithElevatedRolesSuspenseQueryHookResult = ReturnType<typeof useGetUsersWithElevatedRolesSuspenseQuery>;
export type GetUsersWithElevatedRolesQueryResult = Apollo.QueryResult<GetUsersWithElevatedRolesQuery, GetUsersWithElevatedRolesQueryVariables>;
export const GetPageVisitsBySessionDocument = gql`
    query GetPageVisitsBySession($sessionId: ID!, $startDate: String, $endDate: String, $page: Int, $pageSize: Int, $sortBy: String) {
  getPageVisitsBySession(
    input: {sessionId: $sessionId, startDate: $startDate, endDate: $endDate, page: $page, pageSize: $pageSize, sortBy: $sortBy}
  ) {
    success
    message
    data {
      pageVisits {
        id
        path
        timestamp
        endTimestamp
        lastActiveTime
        visitSessionId
      }
      totalCount
    }
    count
  }
}
    `;

/**
 * __useGetPageVisitsBySessionQuery__
 *
 * To run a query within a React component, call `useGetPageVisitsBySessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageVisitsBySessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageVisitsBySessionQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetPageVisitsBySessionQuery(baseOptions: Apollo.QueryHookOptions<GetPageVisitsBySessionQuery, GetPageVisitsBySessionQueryVariables> & ({ variables: GetPageVisitsBySessionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPageVisitsBySessionQuery, GetPageVisitsBySessionQueryVariables>(GetPageVisitsBySessionDocument, options);
      }
export function useGetPageVisitsBySessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageVisitsBySessionQuery, GetPageVisitsBySessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPageVisitsBySessionQuery, GetPageVisitsBySessionQueryVariables>(GetPageVisitsBySessionDocument, options);
        }
// @ts-ignore
export function useGetPageVisitsBySessionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPageVisitsBySessionQuery, GetPageVisitsBySessionQueryVariables>): Apollo.UseSuspenseQueryResult<GetPageVisitsBySessionQuery, GetPageVisitsBySessionQueryVariables>;
export function useGetPageVisitsBySessionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPageVisitsBySessionQuery, GetPageVisitsBySessionQueryVariables>): Apollo.UseSuspenseQueryResult<GetPageVisitsBySessionQuery | undefined, GetPageVisitsBySessionQueryVariables>;
export function useGetPageVisitsBySessionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPageVisitsBySessionQuery, GetPageVisitsBySessionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPageVisitsBySessionQuery, GetPageVisitsBySessionQueryVariables>(GetPageVisitsBySessionDocument, options);
        }
export type GetPageVisitsBySessionQueryHookResult = ReturnType<typeof useGetPageVisitsBySessionQuery>;
export type GetPageVisitsBySessionLazyQueryHookResult = ReturnType<typeof useGetPageVisitsBySessionLazyQuery>;
export type GetPageVisitsBySessionSuspenseQueryHookResult = ReturnType<typeof useGetPageVisitsBySessionSuspenseQuery>;
export type GetPageVisitsBySessionQueryResult = Apollo.QueryResult<GetPageVisitsBySessionQuery, GetPageVisitsBySessionQueryVariables>;
export const GetVisitSessionsDocument = gql`
    query GetVisitSessions($input: GetVisitSessionsInput!) {
  getVisitSessions(input: $input) {
    success
    message
    data {
      visitSessions {
        id
        startTime
        lastActiveTime
        ended
        userName
        userId
        pageVisitsCount
      }
      totalCount
    }
    count
  }
}
    `;

/**
 * __useGetVisitSessionsQuery__
 *
 * To run a query within a React component, call `useGetVisitSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisitSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisitSessionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetVisitSessionsQuery(baseOptions: Apollo.QueryHookOptions<GetVisitSessionsQuery, GetVisitSessionsQueryVariables> & ({ variables: GetVisitSessionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVisitSessionsQuery, GetVisitSessionsQueryVariables>(GetVisitSessionsDocument, options);
      }
export function useGetVisitSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVisitSessionsQuery, GetVisitSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVisitSessionsQuery, GetVisitSessionsQueryVariables>(GetVisitSessionsDocument, options);
        }
// @ts-ignore
export function useGetVisitSessionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVisitSessionsQuery, GetVisitSessionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetVisitSessionsQuery, GetVisitSessionsQueryVariables>;
export function useGetVisitSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVisitSessionsQuery, GetVisitSessionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetVisitSessionsQuery | undefined, GetVisitSessionsQueryVariables>;
export function useGetVisitSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVisitSessionsQuery, GetVisitSessionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVisitSessionsQuery, GetVisitSessionsQueryVariables>(GetVisitSessionsDocument, options);
        }
export type GetVisitSessionsQueryHookResult = ReturnType<typeof useGetVisitSessionsQuery>;
export type GetVisitSessionsLazyQueryHookResult = ReturnType<typeof useGetVisitSessionsLazyQuery>;
export type GetVisitSessionsSuspenseQueryHookResult = ReturnType<typeof useGetVisitSessionsSuspenseQuery>;
export type GetVisitSessionsQueryResult = Apollo.QueryResult<GetVisitSessionsQuery, GetVisitSessionsQueryVariables>;
export const GetSessionAnalyticsCsvDocument = gql`
    query GetSessionAnalyticsCsv {
  getSessionAnalyticsCsv {
    success
    jobId
    message
  }
}
    `;

/**
 * __useGetSessionAnalyticsCsvQuery__
 *
 * To run a query within a React component, call `useGetSessionAnalyticsCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionAnalyticsCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionAnalyticsCsvQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSessionAnalyticsCsvQuery(baseOptions?: Apollo.QueryHookOptions<GetSessionAnalyticsCsvQuery, GetSessionAnalyticsCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSessionAnalyticsCsvQuery, GetSessionAnalyticsCsvQueryVariables>(GetSessionAnalyticsCsvDocument, options);
      }
export function useGetSessionAnalyticsCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSessionAnalyticsCsvQuery, GetSessionAnalyticsCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSessionAnalyticsCsvQuery, GetSessionAnalyticsCsvQueryVariables>(GetSessionAnalyticsCsvDocument, options);
        }
// @ts-ignore
export function useGetSessionAnalyticsCsvSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSessionAnalyticsCsvQuery, GetSessionAnalyticsCsvQueryVariables>): Apollo.UseSuspenseQueryResult<GetSessionAnalyticsCsvQuery, GetSessionAnalyticsCsvQueryVariables>;
export function useGetSessionAnalyticsCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSessionAnalyticsCsvQuery, GetSessionAnalyticsCsvQueryVariables>): Apollo.UseSuspenseQueryResult<GetSessionAnalyticsCsvQuery | undefined, GetSessionAnalyticsCsvQueryVariables>;
export function useGetSessionAnalyticsCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSessionAnalyticsCsvQuery, GetSessionAnalyticsCsvQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSessionAnalyticsCsvQuery, GetSessionAnalyticsCsvQueryVariables>(GetSessionAnalyticsCsvDocument, options);
        }
export type GetSessionAnalyticsCsvQueryHookResult = ReturnType<typeof useGetSessionAnalyticsCsvQuery>;
export type GetSessionAnalyticsCsvLazyQueryHookResult = ReturnType<typeof useGetSessionAnalyticsCsvLazyQuery>;
export type GetSessionAnalyticsCsvSuspenseQueryHookResult = ReturnType<typeof useGetSessionAnalyticsCsvSuspenseQuery>;
export type GetSessionAnalyticsCsvQueryResult = Apollo.QueryResult<GetSessionAnalyticsCsvQuery, GetSessionAnalyticsCsvQueryVariables>;
export const GetSessionAnalyticsCsvStatusDocument = gql`
    query GetSessionAnalyticsCsvStatus($jobId: String!) {
  getSessionAnalyticsCsvStatus(jobId: $jobId) {
    success
    downloadUrl
    message
    jobId
  }
}
    `;

/**
 * __useGetSessionAnalyticsCsvStatusQuery__
 *
 * To run a query within a React component, call `useGetSessionAnalyticsCsvStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionAnalyticsCsvStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionAnalyticsCsvStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetSessionAnalyticsCsvStatusQuery(baseOptions: Apollo.QueryHookOptions<GetSessionAnalyticsCsvStatusQuery, GetSessionAnalyticsCsvStatusQueryVariables> & ({ variables: GetSessionAnalyticsCsvStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSessionAnalyticsCsvStatusQuery, GetSessionAnalyticsCsvStatusQueryVariables>(GetSessionAnalyticsCsvStatusDocument, options);
      }
export function useGetSessionAnalyticsCsvStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSessionAnalyticsCsvStatusQuery, GetSessionAnalyticsCsvStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSessionAnalyticsCsvStatusQuery, GetSessionAnalyticsCsvStatusQueryVariables>(GetSessionAnalyticsCsvStatusDocument, options);
        }
// @ts-ignore
export function useGetSessionAnalyticsCsvStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSessionAnalyticsCsvStatusQuery, GetSessionAnalyticsCsvStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetSessionAnalyticsCsvStatusQuery, GetSessionAnalyticsCsvStatusQueryVariables>;
export function useGetSessionAnalyticsCsvStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSessionAnalyticsCsvStatusQuery, GetSessionAnalyticsCsvStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetSessionAnalyticsCsvStatusQuery | undefined, GetSessionAnalyticsCsvStatusQueryVariables>;
export function useGetSessionAnalyticsCsvStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSessionAnalyticsCsvStatusQuery, GetSessionAnalyticsCsvStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSessionAnalyticsCsvStatusQuery, GetSessionAnalyticsCsvStatusQueryVariables>(GetSessionAnalyticsCsvStatusDocument, options);
        }
export type GetSessionAnalyticsCsvStatusQueryHookResult = ReturnType<typeof useGetSessionAnalyticsCsvStatusQuery>;
export type GetSessionAnalyticsCsvStatusLazyQueryHookResult = ReturnType<typeof useGetSessionAnalyticsCsvStatusLazyQuery>;
export type GetSessionAnalyticsCsvStatusSuspenseQueryHookResult = ReturnType<typeof useGetSessionAnalyticsCsvStatusSuspenseQuery>;
export type GetSessionAnalyticsCsvStatusQueryResult = Apollo.QueryResult<GetSessionAnalyticsCsvStatusQuery, GetSessionAnalyticsCsvStatusQueryVariables>;
export const GetVisualizationDocument = gql`
    query GetVisualization($id: ID!) {
  getVisualization(id: $id) {
    count
    data {
      code
      created
      id
      lastModified
      visualizationType
      visualizationDescription
      status
    }
    message
    success
  }
}
    `;

/**
 * __useGetVisualizationQuery__
 *
 * To run a query within a React component, call `useGetVisualizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisualizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisualizationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVisualizationQuery(baseOptions: Apollo.QueryHookOptions<GetVisualizationQuery, GetVisualizationQueryVariables> & ({ variables: GetVisualizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVisualizationQuery, GetVisualizationQueryVariables>(GetVisualizationDocument, options);
      }
export function useGetVisualizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVisualizationQuery, GetVisualizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVisualizationQuery, GetVisualizationQueryVariables>(GetVisualizationDocument, options);
        }
// @ts-ignore
export function useGetVisualizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVisualizationQuery, GetVisualizationQueryVariables>): Apollo.UseSuspenseQueryResult<GetVisualizationQuery, GetVisualizationQueryVariables>;
export function useGetVisualizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVisualizationQuery, GetVisualizationQueryVariables>): Apollo.UseSuspenseQueryResult<GetVisualizationQuery | undefined, GetVisualizationQueryVariables>;
export function useGetVisualizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVisualizationQuery, GetVisualizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVisualizationQuery, GetVisualizationQueryVariables>(GetVisualizationDocument, options);
        }
export type GetVisualizationQueryHookResult = ReturnType<typeof useGetVisualizationQuery>;
export type GetVisualizationLazyQueryHookResult = ReturnType<typeof useGetVisualizationLazyQuery>;
export type GetVisualizationSuspenseQueryHookResult = ReturnType<typeof useGetVisualizationSuspenseQuery>;
export type GetVisualizationQueryResult = Apollo.QueryResult<GetVisualizationQuery, GetVisualizationQueryVariables>;
export const GetUserWorkspacesDocument = gql`
    query GetUserWorkspaces {
  getUserWorkspaces {
    id
    name
  }
}
    `;

/**
 * __useGetUserWorkspacesQuery__
 *
 * To run a query within a React component, call `useGetUserWorkspacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserWorkspacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserWorkspacesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserWorkspacesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserWorkspacesQuery, GetUserWorkspacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserWorkspacesQuery, GetUserWorkspacesQueryVariables>(GetUserWorkspacesDocument, options);
      }
export function useGetUserWorkspacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserWorkspacesQuery, GetUserWorkspacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserWorkspacesQuery, GetUserWorkspacesQueryVariables>(GetUserWorkspacesDocument, options);
        }
// @ts-ignore
export function useGetUserWorkspacesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserWorkspacesQuery, GetUserWorkspacesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserWorkspacesQuery, GetUserWorkspacesQueryVariables>;
export function useGetUserWorkspacesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserWorkspacesQuery, GetUserWorkspacesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserWorkspacesQuery | undefined, GetUserWorkspacesQueryVariables>;
export function useGetUserWorkspacesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserWorkspacesQuery, GetUserWorkspacesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserWorkspacesQuery, GetUserWorkspacesQueryVariables>(GetUserWorkspacesDocument, options);
        }
export type GetUserWorkspacesQueryHookResult = ReturnType<typeof useGetUserWorkspacesQuery>;
export type GetUserWorkspacesLazyQueryHookResult = ReturnType<typeof useGetUserWorkspacesLazyQuery>;
export type GetUserWorkspacesSuspenseQueryHookResult = ReturnType<typeof useGetUserWorkspacesSuspenseQuery>;
export type GetUserWorkspacesQueryResult = Apollo.QueryResult<GetUserWorkspacesQuery, GetUserWorkspacesQueryVariables>;
export const CompanionLlmStreamDocument = gql`
    subscription CompanionLlmStream($question: String!, $chatId: String, $workspaceId: String, $attachment: AttachmentInput, $timeZone: String, $timestamp: String) {
  companionLlmStream(
    question: $question
    chatId: $chatId
    workspaceId: $workspaceId
    attachment: $attachment
    timeZone: $timeZone
    timestamp: $timestamp
  ) {
    __typename
    ... on LLMStreamMessageDeltaEvent {
      type
      chatId
      timestamp
      messageId
      isFinalChunk
      delta {
        __typename
        ... on LLMStreamTextBlock {
          text
        }
        ... on LLMStreamFileBlock {
          fileId
          purpose
          displayName
        }
        ... on LLMStreamArtifactBlock {
          artifactId
          artifactType
        }
      }
    }
    ... on LLMStreamMessageCompletedEvent {
      type
      chatId
      timestamp
      message {
        id
        chatId
        role
        createdAt
        metadata
        blocks {
          __typename
          ... on LLMStreamTextBlock {
            text
          }
          ... on LLMStreamFileBlock {
            fileId
            purpose
            displayName
          }
          ... on LLMStreamArtifactBlock {
            artifactId
            artifactType
          }
        }
      }
    }
    ... on LLMStreamArtifactCreatedEvent {
      type
      chatId
      timestamp
      artifact
    }
    ... on LLMStreamChatRenamedEvent {
      type
      chatId
      timestamp
      name
    }
    ... on LLMStreamErrorEvent {
      type
      chatId
      timestamp
      code
      errorMessage
    }
  }
}
    `;

/**
 * __useCompanionLlmStreamSubscription__
 *
 * To run a query within a React component, call `useCompanionLlmStreamSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCompanionLlmStreamSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanionLlmStreamSubscription({
 *   variables: {
 *      question: // value for 'question'
 *      chatId: // value for 'chatId'
 *      workspaceId: // value for 'workspaceId'
 *      attachment: // value for 'attachment'
 *      timeZone: // value for 'timeZone'
 *      timestamp: // value for 'timestamp'
 *   },
 * });
 */
export function useCompanionLlmStreamSubscription(baseOptions: Apollo.SubscriptionHookOptions<CompanionLlmStreamSubscription, CompanionLlmStreamSubscriptionVariables> & ({ variables: CompanionLlmStreamSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CompanionLlmStreamSubscription, CompanionLlmStreamSubscriptionVariables>(CompanionLlmStreamDocument, options);
      }
export type CompanionLlmStreamSubscriptionHookResult = ReturnType<typeof useCompanionLlmStreamSubscription>;
export type CompanionLlmStreamSubscriptionResult = Apollo.SubscriptionResult<CompanionLlmStreamSubscription>;
export const LearningLlmStreamDocument = gql`
    subscription LearningLlmStream($question: String!, $chatId: String, $workspaceId: String, $attachment: AttachmentInput, $contentNodeId: String, $enableTts: Boolean) {
  learningLlmStream(
    question: $question
    chatId: $chatId
    workspaceId: $workspaceId
    attachment: $attachment
    contentNodeId: $contentNodeId
    enableTts: $enableTts
  ) {
    __typename
    ... on LLMStreamMessageDeltaEvent {
      type
      chatId
      timestamp
      messageId
      isFinalChunk
      delta {
        __typename
        ... on LLMStreamTextBlock {
          text
        }
        ... on LLMStreamFileBlock {
          fileId
          purpose
          displayName
        }
        ... on LLMStreamArtifactBlock {
          artifactId
          artifactType
        }
      }
    }
    ... on LLMStreamAudioSegmentStartEvent {
      type
      chatId
      timestamp
      messageId
      chunkIndex
    }
    ... on LLMStreamAudioSegmentTextEvent {
      type
      chatId
      timestamp
      messageId
      chunkIndex
      text
    }
    ... on LLMStreamAudioSegmentEndEvent {
      type
      chatId
      timestamp
      messageId
      chunkIndex
    }
    ... on LLMStreamMessageCompletedEvent {
      type
      chatId
      timestamp
      message {
        id
        chatId
        role
        createdAt
        metadata
        blocks {
          __typename
          ... on LLMStreamTextBlock {
            text
          }
          ... on LLMStreamFileBlock {
            fileId
            purpose
            displayName
          }
          ... on LLMStreamArtifactBlock {
            artifactId
            artifactType
          }
        }
      }
    }
    ... on LLMStreamArtifactCreatedEvent {
      type
      chatId
      timestamp
      artifact
    }
    ... on LLMStreamChatRenamedEvent {
      type
      chatId
      timestamp
      name
    }
    ... on LLMStreamErrorEvent {
      type
      chatId
      timestamp
      code
      errorMessage
    }
  }
}
    `;

/**
 * __useLearningLlmStreamSubscription__
 *
 * To run a query within a React component, call `useLearningLlmStreamSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLearningLlmStreamSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningLlmStreamSubscription({
 *   variables: {
 *      question: // value for 'question'
 *      chatId: // value for 'chatId'
 *      workspaceId: // value for 'workspaceId'
 *      attachment: // value for 'attachment'
 *      contentNodeId: // value for 'contentNodeId'
 *      enableTts: // value for 'enableTts'
 *   },
 * });
 */
export function useLearningLlmStreamSubscription(baseOptions: Apollo.SubscriptionHookOptions<LearningLlmStreamSubscription, LearningLlmStreamSubscriptionVariables> & ({ variables: LearningLlmStreamSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LearningLlmStreamSubscription, LearningLlmStreamSubscriptionVariables>(LearningLlmStreamDocument, options);
      }
export type LearningLlmStreamSubscriptionHookResult = ReturnType<typeof useLearningLlmStreamSubscription>;
export type LearningLlmStreamSubscriptionResult = Apollo.SubscriptionResult<LearningLlmStreamSubscription>;
export const OnNotificationCreatedDocument = gql`
    subscription OnNotificationCreated($userId: ID!) {
  onNotificationCreated(userId: $userId) {
    id
    userId
    title
    message
    created
    isRead
    actionUrl
    type
  }
}
    `;

/**
 * __useOnNotificationCreatedSubscription__
 *
 * To run a query within a React component, call `useOnNotificationCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnNotificationCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnNotificationCreatedSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useOnNotificationCreatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnNotificationCreatedSubscription, OnNotificationCreatedSubscriptionVariables> & ({ variables: OnNotificationCreatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnNotificationCreatedSubscription, OnNotificationCreatedSubscriptionVariables>(OnNotificationCreatedDocument, options);
      }
export type OnNotificationCreatedSubscriptionHookResult = ReturnType<typeof useOnNotificationCreatedSubscription>;
export type OnNotificationCreatedSubscriptionResult = Apollo.SubscriptionResult<OnNotificationCreatedSubscription>;